
(() => {
    try {
        if(!self.__SRX_MODULES__) {
            const store = new class extends Array {
                dump() { console.table(this) };
            };
            Object.defineProperty(self, "__SRX_MODULES__", {
                get() { return store; },
                set() {},
            });
            self.__SRX_DUMP__ = () => self.__SRX_MODULES__.dump();
        };
        self.__SRX_MODULES__.push({"name":"@sarex-frontend","version":"5.3.0","buildAt":"2026-11-05T16:38:57.474Z","tag":"--","hash":"953e39ce","branch":"stage","chunk":"-"});
    } catch(e) { console.warn("Build info inject error", e); };
})();
;
(self["webpackChunk"] = self["webpackChunk"] || []).push([[276],{

/***/ 97904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}



/***/ }),

/***/ 47924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}



/***/ }),

/***/ 60326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}



/***/ }),

/***/ 82548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



/***/ }),

/***/ 64970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26575);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: false
  }), e;
}



/***/ }),

/***/ 75054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26575);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}



/***/ }),

/***/ 89435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}



/***/ }),

/***/ 27983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}



/***/ }),

/***/ 51836:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50267);

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: true,
      configurable: true
    }
  }), Object.defineProperty(t, "prototype", {
    writable: false
  }), e && (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t, e);
}



/***/ }),

/***/ 34280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _inheritsLoose; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50267);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(t, o);
}



/***/ }),

/***/ 79290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



/***/ }),

/***/ 46529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



/***/ }),

/***/ 89782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _objectWithoutProperties; }
/* harmony export */ });
/* harmony import */ var _objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90018);

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = (0,_objectWithoutPropertiesLoose_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}



/***/ }),

/***/ 90018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}



/***/ }),

/***/ 9329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47421);
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60326);


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(t);
}



/***/ }),

/***/ 50267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}



/***/ }),

/***/ 72943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ _slicedToArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(47924);
;// ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = false;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true) ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}


// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(14477);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(46529);
;// ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(r, e) {
  return (0,arrayWithHoles/* default */.A)(r) || _iterableToArrayLimit(r, e) || (0,unsupportedIterableToArray/* default */.A)(r, e) || (0,nonIterableRest/* default */.A)();
}



/***/ }),

/***/ 6849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(97904);
;// ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return (0,arrayLikeToArray/* default */.A)(r);
}


// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(79290);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(14477);
;// ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


;// ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || (0,iterableToArray/* default */.A)(r) || (0,unsupportedIterableToArray/* default */.A)(r) || _nonIterableSpread();
}



/***/ }),

/***/ 26575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ toPropertyKey; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(47421);
;// ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.A)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.A)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}


;// ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.A)(i) ? i : i + "";
}



/***/ }),

/***/ 47421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}



/***/ }),

/***/ 14477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97904);

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(r, a) : void 0;
  }
}



/***/ }),

/***/ 6036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27503);
/* harmony import */ var _Fade__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28276);







var styles = {
  /* Styles applied to the root element. */
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: "fixed",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    WebkitTapHighlightColor: "transparent"
  },
  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: "transparent"
  }
};
var Backdrop = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function Backdrop2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, transitionDuration = props.transitionDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? _Fade__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A : _props$TransitionComp, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    in: open,
    timeout: transitionDuration
  }, other), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, invisible && classes.invisible),
    "aria-hidden": true,
    ref
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(styles, {
  name: "MuiBackdrop"
})(Backdrop));


/***/ }),

/***/ 65838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Box_Box; },
  E: function() { return /* binding */ styleFunction; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(6849);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/merge.js
var merge = __webpack_require__(81979);
;// ./node_modules/@material-ui/system/esm/styleFunctionSx.js





function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function(prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}
var warnedOnce = false;
function styleFunctionSx(styleFunction) {
  var newStyleFunction = function newStyleFunction2(props) {
    var output = styleFunction(props);
    if (props.css) {
      return (0,esm_extends/* default */.A)({}, (0,merge/* default */.A)(output, styleFunction((0,esm_extends/* default */.A)({
        theme: props.theme
      }, props.css))), omit(props.css, [styleFunction.filterProps]));
    }
    if (props.sx) {
      return (0,esm_extends/* default */.A)({}, (0,merge/* default */.A)(output, styleFunction((0,esm_extends/* default */.A)({
        theme: props.theme
      }, props.sx))), omit(props.sx, [styleFunction.filterProps]));
    }
    return output;
  };
  newStyleFunction.propTypes =  false ? 0 : {};
  newStyleFunction.filterProps = ["css", "sx"].concat((0,toConsumableArray/* default */.A)(styleFunction.filterProps));
  return newStyleFunction;
}
function css(styleFunction) {
  if (false) // removed by dead control flow
{}
  return styleFunctionSx(styleFunction);
}
/* harmony default export */ var esm_styleFunctionSx = (styleFunctionSx);

;// ./node_modules/@material-ui/system/esm/compose.js


function compose() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }
  var fn = function fn2(props) {
    return styles.reduce(function(acc, style) {
      var output = style(props);
      if (output) {
        return (0,merge/* default */.A)(acc, output);
      }
      return acc;
    }, {});
  };
  fn.propTypes =  false ? 0 : {};
  fn.filterProps = styles.reduce(function(acc, style) {
    return acc.concat(style.filterProps);
  }, []);
  return fn;
}
/* harmony default export */ var esm_compose = (compose);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(75054);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(299);
;// ./node_modules/@material-ui/system/esm/style.js



function getPath(obj, path) {
  if (!path || typeof path !== "string") {
    return null;
  }
  return path.split(".").reduce(function(acc, item) {
    return acc && acc[item] ? acc[item] : null;
  }, obj);
}
function style(options) {
  var prop = options.prop, _options$cssProperty = options.cssProperty, cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty, themeKey = options.themeKey, transform = options.transform;
  var fn = function fn2(props) {
    if (props[prop] == null) {
      return null;
    }
    var propValue = props[prop];
    var theme = props.theme;
    var themeMapping = getPath(theme, themeKey) || {};
    var styleFromPropValue = function styleFromPropValue2(propValueFinal) {
      var value;
      if (typeof themeMapping === "function") {
        value = themeMapping(propValueFinal);
      } else if (Array.isArray(themeMapping)) {
        value = themeMapping[propValueFinal] || propValueFinal;
      } else {
        value = getPath(themeMapping, propValueFinal) || propValueFinal;
        if (transform) {
          value = transform(value);
        }
      }
      if (cssProperty === false) {
        return value;
      }
      return (0,defineProperty/* default */.A)({}, cssProperty, value);
    };
    return (0,breakpoints/* handleBreakpoints */.N)(props, propValue, styleFromPropValue);
  };
  fn.propTypes =  false ? 0 : {};
  fn.filterProps = [prop];
  return fn;
}
/* harmony default export */ var esm_style = (style);

;// ./node_modules/@material-ui/system/esm/borders.js


function getBorder(value) {
  if (typeof value !== "number") {
    return value;
  }
  return "".concat(value, "px solid");
}
var border = esm_style({
  prop: "border",
  themeKey: "borders",
  transform: getBorder
});
var borderTop = esm_style({
  prop: "borderTop",
  themeKey: "borders",
  transform: getBorder
});
var borderRight = esm_style({
  prop: "borderRight",
  themeKey: "borders",
  transform: getBorder
});
var borderBottom = esm_style({
  prop: "borderBottom",
  themeKey: "borders",
  transform: getBorder
});
var borderLeft = esm_style({
  prop: "borderLeft",
  themeKey: "borders",
  transform: getBorder
});
var borderColor = esm_style({
  prop: "borderColor",
  themeKey: "palette"
});
var borderRadius = esm_style({
  prop: "borderRadius",
  themeKey: "shape"
});
var borders = esm_compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
/* harmony default export */ var esm_borders = (borders);

;// ./node_modules/@material-ui/system/esm/display.js


var displayPrint = esm_style({
  prop: "displayPrint",
  cssProperty: false,
  transform: function transform(value) {
    return {
      "@media print": {
        display: value
      }
    };
  }
});
var displayRaw = esm_style({
  prop: "display"
});
var overflow = esm_style({
  prop: "overflow"
});
var textOverflow = esm_style({
  prop: "textOverflow"
});
var visibility = esm_style({
  prop: "visibility"
});
var whiteSpace = esm_style({
  prop: "whiteSpace"
});
/* harmony default export */ var display = (esm_compose(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace));

;// ./node_modules/@material-ui/system/esm/flexbox.js


var flexBasis = esm_style({
  prop: "flexBasis"
});
var flexDirection = esm_style({
  prop: "flexDirection"
});
var flexWrap = esm_style({
  prop: "flexWrap"
});
var justifyContent = esm_style({
  prop: "justifyContent"
});
var alignItems = esm_style({
  prop: "alignItems"
});
var alignContent = esm_style({
  prop: "alignContent"
});
var order = esm_style({
  prop: "order"
});
var flex = esm_style({
  prop: "flex"
});
var flexGrow = esm_style({
  prop: "flexGrow"
});
var flexShrink = esm_style({
  prop: "flexShrink"
});
var alignSelf = esm_style({
  prop: "alignSelf"
});
var justifyItems = esm_style({
  prop: "justifyItems"
});
var justifySelf = esm_style({
  prop: "justifySelf"
});
var flexbox = esm_compose(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
/* harmony default export */ var esm_flexbox = (flexbox);

;// ./node_modules/@material-ui/system/esm/grid.js


var gridGap = esm_style({
  prop: "gridGap"
});
var gridColumnGap = esm_style({
  prop: "gridColumnGap"
});
var gridRowGap = esm_style({
  prop: "gridRowGap"
});
var gridColumn = esm_style({
  prop: "gridColumn"
});
var gridRow = esm_style({
  prop: "gridRow"
});
var gridAutoFlow = esm_style({
  prop: "gridAutoFlow"
});
var gridAutoColumns = esm_style({
  prop: "gridAutoColumns"
});
var gridAutoRows = esm_style({
  prop: "gridAutoRows"
});
var gridTemplateColumns = esm_style({
  prop: "gridTemplateColumns"
});
var gridTemplateRows = esm_style({
  prop: "gridTemplateRows"
});
var gridTemplateAreas = esm_style({
  prop: "gridTemplateAreas"
});
var gridArea = esm_style({
  prop: "gridArea"
});
var grid = esm_compose(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
/* harmony default export */ var esm_grid = (grid);

;// ./node_modules/@material-ui/system/esm/positions.js


var position = esm_style({
  prop: "position"
});
var zIndex = esm_style({
  prop: "zIndex",
  themeKey: "zIndex"
});
var positions_top = esm_style({
  prop: "top"
});
var right = esm_style({
  prop: "right"
});
var bottom = esm_style({
  prop: "bottom"
});
var left = esm_style({
  prop: "left"
});
/* harmony default export */ var positions = (esm_compose(position, zIndex, positions_top, right, bottom, left));

;// ./node_modules/@material-ui/system/esm/palette.js


var color = esm_style({
  prop: "color",
  themeKey: "palette"
});
var bgcolor = esm_style({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette"
});
var palette = esm_compose(color, bgcolor);
/* harmony default export */ var esm_palette = (palette);

;// ./node_modules/@material-ui/system/esm/shadows.js

var boxShadow = esm_style({
  prop: "boxShadow",
  themeKey: "shadows"
});
/* harmony default export */ var shadows = (boxShadow);

;// ./node_modules/@material-ui/system/esm/sizing.js


function transform(value) {
  return value <= 1 ? "".concat(value * 100, "%") : value;
}
var width = esm_style({
  prop: "width",
  transform
});
var maxWidth = esm_style({
  prop: "maxWidth",
  transform
});
var minWidth = esm_style({
  prop: "minWidth",
  transform
});
var height = esm_style({
  prop: "height",
  transform
});
var maxHeight = esm_style({
  prop: "maxHeight",
  transform
});
var minHeight = esm_style({
  prop: "minHeight",
  transform
});
var sizeWidth = esm_style({
  prop: "size",
  cssProperty: "width",
  transform
});
var sizeHeight = esm_style({
  prop: "size",
  cssProperty: "height",
  transform
});
var boxSizing = esm_style({
  prop: "boxSizing"
});
var sizing = esm_compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
/* harmony default export */ var esm_sizing = (sizing);

// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/spacing.js + 1 modules
var spacing = __webpack_require__(59259);
;// ./node_modules/@material-ui/system/esm/typography.js


var fontFamily = esm_style({
  prop: "fontFamily",
  themeKey: "typography"
});
var fontSize = esm_style({
  prop: "fontSize",
  themeKey: "typography"
});
var fontStyle = esm_style({
  prop: "fontStyle",
  themeKey: "typography"
});
var fontWeight = esm_style({
  prop: "fontWeight",
  themeKey: "typography"
});
var letterSpacing = esm_style({
  prop: "letterSpacing"
});
var lineHeight = esm_style({
  prop: "lineHeight"
});
var textAlign = esm_style({
  prop: "textAlign"
});
var typography = esm_compose(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
/* harmony default export */ var esm_typography = (typography);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/styled.js + 1 modules
var styled = __webpack_require__(50501);
;// ./node_modules/@material-ui/core/esm/Box/Box.js


var styleFunction = esm_styleFunctionSx(esm_compose(esm_borders, display, esm_flexbox, esm_grid, positions, esm_palette, shadows, esm_sizing, spacing/* default */.A, esm_typography));
var Box = (0,styled/* default */.A)("div")(styleFunction, {
  name: "MuiBox"
});
/* harmony default export */ var Box_Box = (Box);


/***/ }),

/***/ 57772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89782);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89435);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27503);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19603);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44963);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39021);









var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({}, theme.typography.button, {
      boxSizing: "border-box",
      minWidth: 64,
      padding: "6px 16px",
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(["background-color", "box-shadow", "border"], {
        duration: theme.transitions.duration.short
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .X4)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        },
        "&$disabled": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        color: theme.palette.action.disabled
      }
    }),
    /* Styles applied to the span element that wraps the children. */
    label: {
      width: "100%",
      // Ensure the correct width for iOS Safari
      display: "inherit",
      alignItems: "inherit",
      justifyContent: "inherit"
    },
    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: "6px 8px"
    },
    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .X4)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      "&:hover": {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .X4)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: "5px 15px",
      border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
      "&$disabled": {
        border: "1px solid ".concat(theme.palette.action.disabledBackground)
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat((0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .X4)(theme.palette.primary.main, 0.5)),
      "&:hover": {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .X4)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat((0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .X4)(theme.palette.secondary.main, 0.5)),
      "&:hover": {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .X4)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },
    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      "&:hover": {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        },
        "&$disabled": {
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      "&$focusVisible": {
        boxShadow: theme.shadows[6]
      },
      "&:active": {
        boxShadow: theme.shadows[8]
      },
      "&$disabled": {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    },
    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: theme.palette.primary.main
        }
      }
    },
    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      "&:hover": {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },
    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none"
      },
      "&$focusVisible": {
        boxShadow: "none"
      },
      "&:active": {
        boxShadow: "none"
      },
      "&$disabled": {
        boxShadow: "none"
      }
    },
    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit",
      borderColor: "currentColor"
    },
    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: "4px 5px",
      fontSize: theme.typography.pxToRem(13)
    },
    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: "8px 11px",
      fontSize: theme.typography.pxToRem(15)
    },
    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: "3px 9px",
      fontSize: theme.typography.pxToRem(13)
    },
    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: "7px 21px",
      fontSize: theme.typography.pxToRem(15)
    },
    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: "4px 10px",
      fontSize: theme.typography.pxToRem(13)
    },
    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: "8px 22px",
      fontSize: theme.typography.pxToRem(15)
    },
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},
    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: "100%"
    },
    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: "inherit",
      marginRight: 8,
      marginLeft: -4,
      "&$iconSizeSmall": {
        marginLeft: -2
      }
    },
    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: "inherit",
      marginRight: -4,
      marginLeft: 8,
      "&$iconSizeSmall": {
        marginRight: -2
      }
    },
    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      "& > *:first-child": {
        fontSize: 18
      }
    },
    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      "& > *:first-child": {
        fontSize: 20
      }
    },
    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      "& > *:first-child": {
        fontSize: 22
      }
    }
  };
};
var Button = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function Button2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, endIconProp = props.endIcon, focusVisibleClassName = props.focusVisibleClassName, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, startIconProp = props.startIcon, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, _props$variant = props.variant, variant = _props$variant === void 0 ? "text" : _props$variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);
  var startIcon = startIconProp && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.startIcon, classes["iconSize".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(size))])
  }, startIconProp);
  var endIcon = endIconProp && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.endIcon, classes["iconSize".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(size))])
  }, endIconProp);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, classes[variant], className, color === "inherit" ? classes.colorInherit : color !== "default" && classes["".concat(variant).concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(color))], size !== "medium" && [classes["".concat(variant, "Size").concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(size))], classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
    component,
    disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.focusVisible, focusVisibleClassName),
    ref,
    type
  }, other), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    className: classes.label
  }, startIcon, children, endIcon));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(styles, {
  name: "MuiButton"
})(Button));


/***/ }),

/***/ 44963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ ButtonBase_ButtonBase; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(89782);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: consume shared module (default) react-dom@=17.0.2 (singleton) (fallback: ./node_modules/react-dom/index.js) (eager)
var react_dom_index_js_eager_ = __webpack_require__(51971);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(31719);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(1863);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(38957);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(27503);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(6606);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(6849);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 1 modules
var TransitionGroup = __webpack_require__(23180);
;// ./node_modules/@material-ui/core/esm/ButtonBase/Ripple.js




var useEnhancedEffect = typeof window === "undefined" ? index_js_eager_.useEffect : index_js_eager_.useLayoutEffect;
function Ripple(props) {
  var classes = props.classes, _props$pulsate = props.pulsate, pulsate = _props$pulsate === void 0 ? false : _props$pulsate, rippleX = props.rippleX, rippleY = props.rippleY, rippleSize = props.rippleSize, inProp = props.in, _props$onExited = props.onExited, onExited = _props$onExited === void 0 ? function() {
  } : _props$onExited, timeout = props.timeout;
  var _React$useState = index_js_eager_.useState(false), leaving = _React$useState[0], setLeaving = _React$useState[1];
  var rippleClassName = (0,clsx_m["default"])(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = (0,clsx_m["default"])(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = (0,useEventCallback/* default */.A)(onExited);
  useEnhancedEffect(function() {
    if (!inProp) {
      setLeaving(true);
      var timeoutId = setTimeout(handleExited, timeout);
      return function() {
        clearTimeout(timeoutId);
      };
    }
    return void 0;
  }, [handleExited, inProp, timeout]);
  return /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: rippleClassName,
    style: rippleStyles
  }, /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: childClassName
  }));
}
 false ? 0 : void 0;
/* harmony default export */ var ButtonBase_Ripple = (Ripple);

;// ./node_modules/@material-ui/core/esm/ButtonBase/TouchRipple.js









var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: "hidden",
      pointerEvents: "none",
      position: "absolute",
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: "inherit"
    },
    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: "absolute"
    },
    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: "scale(1)",
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },
    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },
    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: "block",
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      backgroundColor: "currentColor"
    },
    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },
    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: "absolute",
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    "@keyframes enter": {
      "0%": {
        transform: "scale(0)",
        opacity: 0.1
      },
      "100%": {
        transform: "scale(1)",
        opacity: 0.3
      }
    },
    "@keyframes exit": {
      "0%": {
        opacity: 1
      },
      "100%": {
        opacity: 0
      }
    },
    "@keyframes pulsate": {
      "0%": {
        transform: "scale(1)"
      },
      "50%": {
        transform: "scale(0.92)"
      },
      "100%": {
        transform: "scale(1)"
      }
    }
  };
};
var TouchRipple = /* @__PURE__ */ index_js_eager_.forwardRef(function TouchRipple2(props, ref) {
  var _props$center = props.center, centerProp = _props$center === void 0 ? false : _props$center, classes = props.classes, className = props.className, other = (0,objectWithoutProperties/* default */.A)(props, ["center", "classes", "className"]);
  var _React$useState = index_js_eager_.useState([]), ripples = _React$useState[0], setRipples = _React$useState[1];
  var nextKey = index_js_eager_.useRef(0);
  var rippleCallback = index_js_eager_.useRef(null);
  index_js_eager_.useEffect(function() {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]);
  var ignoringMouseDown = index_js_eager_.useRef(false);
  var startTimer = index_js_eager_.useRef(null);
  var startTimerCommit = index_js_eager_.useRef(null);
  var container = index_js_eager_.useRef(null);
  index_js_eager_.useEffect(function() {
    return function() {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = index_js_eager_.useCallback(function(params) {
    var pulsate2 = params.pulsate, rippleX = params.rippleX, rippleY = params.rippleY, rippleSize = params.rippleSize, cb = params.cb;
    setRipples(function(oldRipples) {
      return [].concat((0,toConsumableArray/* default */.A)(oldRipples), [/* @__PURE__ */ index_js_eager_.createElement(ButtonBase_Ripple, {
        key: nextKey.current,
        classes,
        timeout: DURATION,
        pulsate: pulsate2,
        rippleX,
        rippleY,
        rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = index_js_eager_.useCallback(function() {
    var event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : void 0;
    var _options$pulsate = options.pulsate, pulsate2 = _options$pulsate === void 0 ? false : _options$pulsate, _options$center = options.center, center = _options$center === void 0 ? centerProp || options.pulsate : _options$center, _options$fakeElement = options.fakeElement, fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
    if (event.type === "mousedown" && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }
    if (event.type === "touchstart") {
      ignoringMouseDown.current = true;
    }
    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    var rippleX;
    var rippleY;
    var rippleSize;
    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event, clientX = _ref.clientX, clientY = _ref.clientY;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }
    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3);
      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    }
    if (event.touches) {
      if (startTimerCommit.current === null) {
        startTimerCommit.current = function() {
          startCommit({
            pulsate: pulsate2,
            rippleX,
            rippleY,
            rippleSize,
            cb
          });
        };
        startTimer.current = setTimeout(function() {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE);
      }
    } else {
      startCommit({
        pulsate: pulsate2,
        rippleX,
        rippleY,
        rippleSize,
        cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = index_js_eager_.useCallback(function() {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = index_js_eager_.useCallback(function(event, cb) {
    clearTimeout(startTimer.current);
    if (event.type === "touchend" && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function() {
        stop(event, cb);
      });
      return;
    }
    startTimerCommit.current = null;
    setRipples(function(oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }
      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  index_js_eager_.useImperativeHandle(ref, function() {
    return {
      pulsate,
      start,
      stop
    };
  }, [pulsate, start, stop]);
  return /* @__PURE__ */ index_js_eager_.createElement("span", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref: container
  }, other), /* @__PURE__ */ index_js_eager_.createElement(TransitionGroup/* default */.A, {
    component: null,
    exit: true
  }, ripples));
});
 false ? 0 : void 0;
/* harmony default export */ var ButtonBase_TouchRipple = ((0,withStyles/* default */.A)(styles, {
  flip: false,
  name: "MuiTouchRipple"
})(/* @__PURE__ */ index_js_eager_.memo(TouchRipple)));

;// ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js













var ButtonBase_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    "-moz-appearance": "none",
    // Reset
    "-webkit-appearance": "none",
    // Reset
    textDecoration: "none",
    // So we take precedent over the style of a native <a /> element.
    color: "inherit",
    "&::-moz-focus-inner": {
      borderStyle: "none"
      // Remove Firefox dotted outline.
    },
    "&$disabled": {
      pointerEvents: "none",
      // Disable link interactions
      cursor: "default"
    },
    "@media print": {
      colorAdjust: "exact"
    }
  },
  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},
  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
var ButtonBase = /* @__PURE__ */ index_js_eager_.forwardRef(function ButtonBase2(props, ref) {
  var action = props.action, buttonRefProp = props.buttonRef, _props$centerRipple = props.centerRipple, centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple, children = props.children, classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$disableTouchRi = props.disableTouchRipple, disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi, _props$focusRipple = props.focusRipple, focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple, focusVisibleClassName = props.focusVisibleClassName, onBlur = props.onBlur, onClick = props.onClick, onFocus = props.onFocus, onFocusVisible = props.onFocusVisible, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, onMouseDown = props.onMouseDown, onMouseLeave = props.onMouseLeave, onMouseUp = props.onMouseUp, onTouchEnd = props.onTouchEnd, onTouchMove = props.onTouchMove, onTouchStart = props.onTouchStart, onDragLeave = props.onDragLeave, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, TouchRippleProps = props.TouchRippleProps, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, other = (0,objectWithoutProperties/* default */.A)(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);
  var buttonRef = index_js_eager_.useRef(null);
  function getButtonNode() {
    return react_dom_index_js_eager_.findDOMNode(buttonRef.current);
  }
  var rippleRef = index_js_eager_.useRef(null);
  var _React$useState = index_js_eager_.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
  if (disabled && focusVisible) {
    setFocusVisible(false);
  }
  var _useIsFocusVisible = (0,useIsFocusVisible/* default */.A)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
  index_js_eager_.useImperativeHandle(action, function() {
    return {
      focusVisible: function focusVisible2() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  index_js_eager_.useEffect(function() {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);
  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : disableTouchRipple;
    return (0,useEventCallback/* default */.A)(function(event) {
      if (eventCallback) {
        eventCallback(event);
      }
      var ignore = skipRippleAction;
      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }
      return true;
    });
  }
  var handleMouseDown = useRippleHandler("start", onMouseDown);
  var handleDragLeave = useRippleHandler("stop", onDragLeave);
  var handleMouseUp = useRippleHandler("stop", onMouseUp);
  var handleMouseLeave = useRippleHandler("stop", function(event) {
    if (focusVisible) {
      event.preventDefault();
    }
    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler("start", onTouchStart);
  var handleTouchEnd = useRippleHandler("stop", onTouchEnd);
  var handleTouchMove = useRippleHandler("stop", onTouchMove);
  var handleBlur = useRippleHandler("stop", function(event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = (0,useEventCallback/* default */.A)(function(event) {
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }
    if (isFocusVisible(event)) {
      setFocusVisible(true);
      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }
    if (onFocus) {
      onFocus(event);
    }
  });
  var isNonNativeButton = function isNonNativeButton2() {
    var button = getButtonNode();
    return component && component !== "button" && !(button.tagName === "A" && button.href);
  };
  var keydownRef = index_js_eager_.useRef(false);
  var handleKeyDown = (0,useEventCallback/* default */.A)(function(event) {
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === " ") {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function() {
        rippleRef.current.start(event);
      });
    }
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === " ") {
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
    if (event.target === event.currentTarget && isNonNativeButton() && event.key === "Enter" && !disabled) {
      event.preventDefault();
      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = (0,useEventCallback/* default */.A)(function(event) {
    if (focusRipple && event.key === " " && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function() {
        rippleRef.current.pulsate(event);
      });
    }
    if (onKeyUp) {
      onKeyUp(event);
    }
    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === " " && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;
  if (ComponentProp === "button" && other.href) {
    ComponentProp = "a";
  }
  var buttonProps = {};
  if (ComponentProp === "button") {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== "a" || !other.href) {
      buttonProps.role = "button";
    }
    buttonProps["aria-disabled"] = disabled;
  }
  var handleUserRef = (0,useForkRef/* default */.A)(buttonRefProp, ref);
  var handleOwnRef = (0,useForkRef/* default */.A)(focusVisibleRef, buttonRef);
  var handleRef = (0,useForkRef/* default */.A)(handleUserRef, handleOwnRef);
  var _React$useState2 = index_js_eager_.useState(false), mountedState = _React$useState2[0], setMountedState = _React$useState2[1];
  index_js_eager_.useEffect(function() {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;
  if (false) // removed by dead control flow
{}
  return /* @__PURE__ */ index_js_eager_.createElement(ComponentProp, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ? (
    /* TouchRipple is only needed client-side, x2 boost on the server. */
    /* @__PURE__ */ index_js_eager_.createElement(ButtonBase_TouchRipple, (0,esm_extends/* default */.A)({
      ref: rippleRef,
      center: centerRipple
    }, TouchRippleProps))
  ) : null);
});
 false ? 0 : void 0;
/* harmony default export */ var ButtonBase_ButtonBase = ((0,withStyles/* default */.A)(ButtonBase_styles, {
  name: "MuiButtonBase"
})(ButtonBase));


/***/ }),

/***/ 52776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27503);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39021);








var SIZE = 44;
var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "inline-block"
    },
    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create("transform")
    },
    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: "$circular-rotate 1.4s linear infinite"
    },
    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: theme.transitions.create("transform")
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    /* Styles applied to the `svg` element. */
    svg: {
      display: "block"
      // Keeps the progress centered
    },
    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: "currentColor"
      // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',
    },
    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create("stroke-dashoffset")
    },
    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: "$circular-dash 1.4s ease-in-out infinite",
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: "80px, 200px",
      strokeDashoffset: "0px"
      // Add the unit to fix a Edge 16 and below bug.
    },
    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: theme.transitions.create("stroke-dashoffset")
    },
    "@keyframes circular-rotate": {
      "0%": {
        // Fix IE 11 wobbly
        transformOrigin: "50% 50%"
      },
      "100%": {
        transform: "rotate(360deg)"
      }
    },
    "@keyframes circular-dash": {
      "0%": {
        strokeDasharray: "1px, 200px",
        strokeDashoffset: "0px"
      },
      "50%": {
        strokeDasharray: "100px, 200px",
        strokeDashoffset: "-15px"
      },
      "100%": {
        strokeDasharray: "100px, 200px",
        strokeDashoffset: "-125px"
      }
    },
    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: "none"
    }
  };
};
var CircularProgress = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function CircularProgress2(props, ref) {
  var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$disableShrink = props.disableShrink, disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink, _props$size = props.size, size = _props$size === void 0 ? 40 : _props$size, style = props.style, _props$thickness = props.thickness, thickness = _props$thickness === void 0 ? 3.6 : _props$thickness, _props$value = props.value, value = _props$value === void 0 ? 0 : _props$value, _props$variant = props.variant, variant = _props$variant === void 0 ? "indeterminate" : _props$variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);
  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};
  if (variant === "determinate" || variant === "static") {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps["aria-valuenow"] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = "rotate(-90deg)";
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, color !== "inherit" && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(color))], {
      "determinate": classes.determinate,
      "indeterminate": classes.indeterminate,
      "static": classes.static
    }[variant]),
    style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
      width: size,
      height: size
    }, rootStyle, style),
    ref,
    role: "progressbar"
  }, rootProps, other), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("circle", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.circle, disableShrink && classes.circleDisableShrink, {
      "determinate": classes.circleDeterminate,
      "indeterminate": classes.circleIndeterminate,
      "static": classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(styles, {
  name: "MuiCircularProgress",
  flip: false
})(CircularProgress));


/***/ }),

/***/ 42920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75054);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27503);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39021);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37790);
/* harmony import */ var _Backdrop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6036);
/* harmony import */ var _Fade__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28276);
/* harmony import */ var _styles_transitions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58268);
/* harmony import */ var _Paper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(1526);














var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      "@media print": {
        // Use !important to override the Modal inline-style.
        position: "absolute !important"
      }
    },
    /* Styles applied to the container element if `scroll="paper"`. */
    scrollPaper: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    },
    /* Styles applied to the container element if `scroll="body"`. */
    scrollBody: {
      overflowY: "auto",
      overflowX: "hidden",
      textAlign: "center",
      "&:after": {
        content: '""',
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0"
      }
    },
    /* Styles applied to the container element. */
    container: {
      height: "100%",
      "@media print": {
        height: "auto"
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    },
    /* Styles applied to the `Paper` component. */
    paper: {
      margin: 32,
      position: "relative",
      overflowY: "auto",
      // Fix IE 11 issue, to remove at some point.
      "@media print": {
        overflowY: "visible",
        boxShadow: "none"
      }
    },
    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      display: "flex",
      flexDirection: "column",
      maxHeight: "calc(100% - 64px)"
    },
    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      display: "inline-block",
      verticalAlign: "middle",
      textAlign: "left"
      // 'initial' doesn't work on IE 11
    },
    /* Styles applied to the `Paper` component if `maxWidth=false`. */
    paperWidthFalse: {
      maxWidth: "calc(100% - 64px)"
    },
    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
      "&$paperScrollBody": (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      "&$paperScrollBody": (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      "&$paperScrollBody": (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      "&$paperScrollBody": (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: theme.breakpoints.values.xl,
      "&$paperScrollBody": (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
        maxWidth: "calc(100% - 64px)"
      })
    },
    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: "calc(100% - 64px)"
    },
    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
      borderRadius: 0,
      "&$paperScrollBody": {
        margin: 0,
        maxWidth: "100%"
      }
    }
  };
};
var defaultTransitionDuration = {
  enter: _styles_transitions__WEBPACK_IMPORTED_MODULE_10__/* .duration */ .p0.enteringScreen,
  exit: _styles_transitions__WEBPACK_IMPORTED_MODULE_10__/* .duration */ .p0.leavingScreen
};
var Dialog = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.forwardRef(function Dialog2(props, ref) {
  var BackdropProps = props.BackdropProps, children = props.children, classes = props.classes, className = props.className, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$fullScreen = props.fullScreen, fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? "sm" : _props$maxWidth, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onEscapeKeyDown = props.onEscapeKeyDown, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperComponent = props.PaperComponent, PaperComponent = _props$PaperComponent === void 0 ? _Paper__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .A : _props$PaperComponent, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$scroll = props.scroll, scroll = _props$scroll === void 0 ? "paper" : _props$scroll, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? _Fade__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura, TransitionProps = props.TransitionProps, ariaDescribedby = props["aria-describedby"], ariaLabelledby = props["aria-labelledby"], other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);
  var mouseDownTarget = react__WEBPACK_IMPORTED_MODULE_3__.useRef();
  var handleMouseDown = function handleMouseDown2(event) {
    mouseDownTarget.current = event.target;
  };
  var handleBackdropClick = function handleBackdropClick2(event) {
    if (event.target !== event.currentTarget) {
      return;
    }
    if (event.target !== mouseDownTarget.current) {
      return;
    }
    mouseDownTarget.current = null;
    if (onBackdropClick) {
      onBackdropClick(event);
    }
    if (!disableBackdropClick && onClose) {
      onClose(event, "backdropClick");
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.createElement(_Modal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__["default"])(classes.root, className),
    BackdropComponent: _Backdrop__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A,
    BackdropProps: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
      transitionDuration
    }, BackdropProps),
    closeAfterTransition: true
  }, disableBackdropClick ? {
    disableBackdropClick
  } : {}, {
    disableEscapeKeyDown,
    onEscapeKeyDown,
    onClose,
    open,
    ref
  }, other), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter,
    onEntering,
    onEntered,
    onExit,
    onExiting,
    onExited,
    role: "none presentation"
  }, TransitionProps), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__["default"])(classes.container, classes["scroll".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(scroll))]),
    onMouseUp: handleBackdropClick,
    onMouseDown: handleMouseDown
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.createElement(PaperComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    elevation: 24,
    role: "dialog",
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby
  }, PaperProps, {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__["default"])(classes.paper, classes["paperScroll".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(scroll))], classes["paperWidth".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
  }), children))));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(styles, {
  name: "MuiDialog"
})(Dialog));


/***/ }),

/***/ 34130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27503);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    alignItems: "center",
    padding: 8,
    justifyContent: "flex-end",
    flex: "0 0 auto"
  },
  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    "& > :not(:first-child)": {
      marginLeft: 8
    }
  }
};
var DialogActions = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function DialogActions2(props, ref) {
  var _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, classes = props.classes, className = props.className, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["disableSpacing", "classes", "className"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, !disableSpacing && classes.spacing),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(styles, {
  name: "MuiDialogActions"
})(DialogActions));


/***/ }),

/***/ 69346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27503);






var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: "1 1 auto",
      WebkitOverflowScrolling: "touch",
      // Add iOS momentum scrolling.
      overflowY: "auto",
      padding: "8px 24px",
      "&:first-child": {
        // dialog without title
        paddingTop: 20
      }
    },
    /* Styles applied to the root element if `dividers={true}`. */
    dividers: {
      padding: "16px 24px",
      borderTop: "1px solid ".concat(theme.palette.divider),
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }
  };
};
var DialogContent = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function DialogContent2(props, ref) {
  var classes = props.classes, className = props.className, _props$dividers = props.dividers, dividers = _props$dividers === void 0 ? false : _props$dividers, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["classes", "className", "dividers"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, dividers && classes.dividers),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(styles, {
  name: "MuiDialogContent"
})(DialogContent));


/***/ }),

/***/ 28276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72943);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12549);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51052);
/* harmony import */ var _styles_transitions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58268);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9022);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56571);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1863);










var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
var defaultTimeout = {
  enter: _styles_transitions__WEBPACK_IMPORTED_MODULE_5__/* .duration */ .p0.enteringScreen,
  exit: _styles_transitions__WEBPACK_IMPORTED_MODULE_5__/* .duration */ .p0.leavingScreen
};
var Fade = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.forwardRef(function Fade2(props, ref) {
  var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? react_transition_group__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Ay : _props$TransitionComp, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);
  var theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = react__WEBPACK_IMPORTED_MODULE_3__.useRef(null);
  var foreignRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(children.ref, ref);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(enableStrictModeCompat ? nodeRef : void 0, foreignRef);
  var normalizedTransitionCallback = function normalizedTransitionCallback2(callback) {
    return function(nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing], _ref2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1];
        if (isAppearing === void 0) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };
  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .reflow */ .q)(node);
    var transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .c)({
      style,
      timeout
    }, {
      mode: "enter"
    });
    node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
    node.style.transition = theme.transitions.create("opacity", transitionProps);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function(node) {
    var transitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_7__/* .getTransitionProps */ .c)({
      style,
      timeout
    }, {
      mode: "exit"
    });
    node.style.webkitTransition = theme.transitions.create("opacity", transitionProps);
    node.style.transition = theme.transitions.create("opacity", transitionProps);
    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : void 0,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout
  }, other), function(state, childProps) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
        opacity: 0,
        visibility: state === "exited" && !inProp ? "hidden" : void 0
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = (Fade);


/***/ }),

/***/ 29118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _InputBase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1766);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27503);








var styles = function styles2(theme) {
  var light = theme.palette.type === "light";
  var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  var backgroundColor = light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)";
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create("background-color", {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      "&:hover": {
        backgroundColor: light ? "rgba(0, 0, 0, 0.13)" : "rgba(255, 255, 255, 0.13)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor
        }
      },
      "&$focused": {
        backgroundColor: light ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.09)"
      },
      "&$disabled": {
        backgroundColor: light ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)"
      }
    },
    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      "&$underline:after": {
        borderBottomColor: theme.palette.secondary.main
      }
    },
    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      "&:after": {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: "absolute",
        right: 0,
        transform: "scaleX(0)",
        transition: theme.transitions.create("transform", {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: "none"
        // Transparent to the hover style.
      },
      "&$focused:after": {
        transform: "scaleX(1)"
      },
      "&$error:after": {
        borderBottomColor: theme.palette.error.main,
        transform: "scaleX(1)"
        // error is always underlined in red
      },
      "&:before": {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: "absolute",
        right: 0,
        transition: theme.transitions.create("border-bottom-color", {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: "none"
        // Transparent to the hover style.
      },
      "&:hover:before": {
        borderBottom: "1px solid ".concat(theme.palette.text.primary)
      },
      "&$disabled:before": {
        borderBottomStyle: "dotted"
      }
    },
    /* Pseudo-class applied to the root element if the component is focused. */
    focused: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },
    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "27px 12px 10px",
      "&$marginDense": {
        paddingTop: 23,
        paddingBottom: 6
      }
    },
    /* Styles applied to the `input` element. */
    input: {
      padding: "27px 12px 10px",
      "&:-webkit-autofill": {
        WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
        WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
        caretColor: theme.palette.type === "light" ? null : "#fff",
        borderTopLeftRadius: "inherit",
        borderTopRightRadius: "inherit"
      }
    },
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 23,
      paddingBottom: 6
    },
    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
    inputHiddenLabel: {
      paddingTop: 18,
      paddingBottom: 19,
      "&$inputMarginDense": {
        paddingTop: 10,
        paddingBottom: 11
      }
    },
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },
    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },
    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var FilledInput = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function FilledInput2(props, ref) {
  var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_InputBase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    classes: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, classes, {
      root: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth,
    inputComponent,
    multiline,
    ref,
    type
  }, other));
});
 false ? 0 : void 0;
FilledInput.muiName = "Input";
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(styles, {
  name: "MuiFilledInput"
})(FilledInput));


/***/ }),

/***/ 1586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _InputBase_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5850);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27503);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39021);
/* harmony import */ var _utils_isMuiElement__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75900);
/* harmony import */ var _FormControlContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50287);










var styles = {
  /* Styles applied to the root element. */
  root: {
    display: "inline-flex",
    flexDirection: "column",
    position: "relative",
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: "top"
    // Fix alignment issue on Safari.
  },
  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },
  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },
  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: "100%"
  }
};
var FormControl = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function FormControl2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, visuallyFocused = props.focused, _props$hiddenLabel = props.hiddenLabel, hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel, _props$margin = props.margin, margin = _props$margin === void 0 ? "none" : _props$margin, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, size = props.size, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_2__.useState(function() {
    var initialAdornedStart = false;
    if (children) {
      react__WEBPACK_IMPORTED_MODULE_2__.Children.forEach(children, function(child) {
        if (!(0,_utils_isMuiElement__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(child, ["Input", "Select"])) {
          return;
        }
        var input = (0,_utils_isMuiElement__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(child, ["Select"]) ? child.props.input : child;
        if (input && (0,_InputBase_utils__WEBPACK_IMPORTED_MODULE_4__/* .isAdornedStart */ .gr)(input.props)) {
          initialAdornedStart = true;
        }
      });
    }
    return initialAdornedStart;
  }), adornedStart = _React$useState[0], setAdornedStart = _React$useState[1];
  var _React$useState2 = react__WEBPACK_IMPORTED_MODULE_2__.useState(function() {
    var initialFilled = false;
    if (children) {
      react__WEBPACK_IMPORTED_MODULE_2__.Children.forEach(children, function(child) {
        if (!(0,_utils_isMuiElement__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(child, ["Input", "Select"])) {
          return;
        }
        if ((0,_InputBase_utils__WEBPACK_IMPORTED_MODULE_4__/* .isFilled */ .lq)(child.props, true)) {
          initialFilled = true;
        }
      });
    }
    return initialFilled;
  }), filled = _React$useState2[0], setFilled = _React$useState2[1];
  var _React$useState3 = react__WEBPACK_IMPORTED_MODULE_2__.useState(false), _focused = _React$useState3[0], setFocused = _React$useState3[1];
  var focused = visuallyFocused !== void 0 ? visuallyFocused : _focused;
  if (disabled && focused) {
    setFocused(false);
  }
  var registerEffect;
  if (false) // removed by dead control flow
{ var registeredInput; }
  var onFilled = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function() {
    setFilled(true);
  }, []);
  var onEmpty = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function() {
    setFilled(false);
  }, []);
  var childContext = {
    adornedStart,
    setAdornedStart,
    color,
    disabled,
    error,
    filled,
    focused,
    fullWidth,
    hiddenLabel,
    margin: (size === "small" ? "dense" : void 0) || margin,
    onBlur: function onBlur() {
      setFocused(false);
    },
    onEmpty,
    onFilled,
    onFocus: function onFocus() {
      setFocused(true);
    },
    registerEffect,
    required,
    variant
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_FormControlContext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A.Provider, {
    value: childContext
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, margin !== "none" && classes["margin".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(margin))], fullWidth && classes.fullWidth),
    ref
  }, other), children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(styles, {
  name: "MuiFormControl"
})(FormControl));


/***/ }),

/***/ 50287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   t: function() { return /* binding */ useFormControl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);

var FormControlContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext();
if (false) // removed by dead control flow
{}
function useFormControl() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(FormControlContext);
}
/* harmony default export */ __webpack_exports__.A = (FormControlContext);


/***/ }),

/***/ 26221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ formControlState; }
/* harmony export */ });
function formControlState(_ref) {
  var props = _ref.props, states = _ref.states, muiFormControl = _ref.muiFormControl;
  return states.reduce(function(acc, state) {
    acc[state] = props[state];
    if (muiFormControl) {
      if (typeof props[state] === "undefined") {
        acc[state] = muiFormControl[state];
      }
    }
    return acc;
  }, {});
}


/***/ }),

/***/ 72463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ useFormControl; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);
/* harmony import */ var _FormControlContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50287);


function useFormControl() {
  return react__WEBPACK_IMPORTED_MODULE_0__.useContext(_FormControlContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A);
}


/***/ }),

/***/ 95262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89782);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89435);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _FormControl_formControlState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26221);
/* harmony import */ var _FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72463);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27503);








var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
      color: theme.palette.text.secondary
    }, theme.typography.caption, {
      textAlign: "left",
      marginTop: 3,
      margin: 0,
      "&$disabled": {
        color: theme.palette.text.disabled
      },
      "&$error": {
        color: theme.palette.error.main
      }
    }),
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },
    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      marginLeft: 14,
      marginRight: 14
    },
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},
    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {}
  };
};
var FormHelperText = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function FormHelperText2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "p" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, margin = props.margin, required = props.required, variant = props.variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);
  var muiFormControl = (0,_FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)();
  var fcs = (0,_FormControl_formControlState__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)({
    props,
    muiFormControl,
    states: ["variant", "margin", "disabled", "error", "filled", "focused", "required"]
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, (fcs.variant === "filled" || fcs.variant === "outlined") && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === "dense" && classes.marginDense),
    ref
  }, other), children === " " ? (
    // eslint-disable-next-line react/no-danger
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: "&#8203;"
      }
    })
  ) : children);
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(styles, {
  name: "MuiFormHelperText"
})(FormHelperText));


/***/ }),

/***/ 95142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89782);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89435);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _FormControl_formControlState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26221);
/* harmony import */ var _FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72463);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39021);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27503);









var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
      color: theme.palette.text.secondary
    }, theme.typography.body1, {
      lineHeight: 1,
      padding: 0,
      "&$focused": {
        color: theme.palette.primary.main
      },
      "&$disabled": {
        color: theme.palette.text.disabled
      },
      "&$error": {
        color: theme.palette.error.main
      }
    }),
    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      "&$focused": {
        color: theme.palette.secondary.main
      }
    },
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},
    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},
    /* Styles applied to the asterisk element. */
    asterisk: {
      "&$error": {
        color: theme.palette.error.main
      }
    }
  };
};
var FormLabel = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function FormLabel2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, color = props.color, _props$component = props.component, Component = _props$component === void 0 ? "label" : _props$component, disabled = props.disabled, error = props.error, filled = props.filled, focused = props.focused, required = props.required, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);
  var muiFormControl = (0,_FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)();
  var fcs = (0,_FormControl_formControlState__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)({
    props,
    muiFormControl,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
    ref
  }, other), children, fcs.required && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    "aria-hidden": true,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.asterisk, fcs.error && classes.error)
  }, "\u2009", "*"));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(styles, {
  name: "MuiFormLabel"
})(FormLabel));


/***/ }),

/***/ 75282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72943);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12549);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51052);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9022);
/* harmony import */ var _transitions_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(56571);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1863);









function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
};
var Grow = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.forwardRef(function Grow2(props, ref) {
  var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? "auto" : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? react_transition_group__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Ay : _props$TransitionComp, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
  var timer = react__WEBPACK_IMPORTED_MODULE_3__.useRef();
  var autoTimeout = react__WEBPACK_IMPORTED_MODULE_3__.useRef();
  var theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = react__WEBPACK_IMPORTED_MODULE_3__.useRef(null);
  var foreignRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(children.ref, ref);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(enableStrictModeCompat ? nodeRef : void 0, foreignRef);
  var normalizedTransitionCallback = function normalizedTransitionCallback2(callback) {
    return function(nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing], _ref2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1];
        if (isAppearing === void 0) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };
  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
    (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .reflow */ .q)(node);
    var _getTransitionProps = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .c)({
      style,
      timeout
    }, {
      mode: "enter"
    }), transitionDuration = _getTransitionProps.duration, delay = _getTransitionProps.delay;
    var duration;
    if (timeout === "auto") {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }
    node.style.transition = [theme.transitions.create("opacity", {
      duration,
      delay
    }), theme.transitions.create("transform", {
      duration: duration * 0.666,
      delay
    })].join(",");
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function(node) {
    var _getTransitionProps2 = (0,_transitions_utils__WEBPACK_IMPORTED_MODULE_6__/* .getTransitionProps */ .c)({
      style,
      timeout
    }, {
      mode: "exit"
    }), transitionDuration = _getTransitionProps2.duration, delay = _getTransitionProps2.delay;
    var duration;
    if (timeout === "auto") {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }
    node.style.transition = [theme.transitions.create("opacity", {
      duration,
      delay
    }), theme.transitions.create("transform", {
      duration: duration * 0.666,
      delay: delay || duration * 0.333
    })].join(",");
    node.style.opacity = "0";
    node.style.transform = getScale(0.75);
    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  var addEndListener = function addEndListener2(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
    if (timeout === "auto") {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  };
  react__WEBPACK_IMPORTED_MODULE_3__.useEffect(function() {
    return function() {
      clearTimeout(timer.current);
    };
  }, []);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : void 0,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener,
    timeout: timeout === "auto" ? null : timeout
  }, other), function(state, childProps) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.cloneElement(children, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
      style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
        opacity: 0,
        transform: getScale(0.75),
        visibility: state === "exited" && !inProp ? "hidden" : void 0
      }, styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? 0 : void 0;
Grow.muiSupportAuto = true;
/* harmony default export */ __webpack_exports__.A = (Grow);


/***/ }),

/***/ 24022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27503);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19603);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44963);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39021);










var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: "center",
      flex: "0 0 auto",
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: "50%",
      overflow: "visible",
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create("background-color", {
        duration: theme.transitions.duration.shortest
      }),
      "&:hover": {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .X4)(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      },
      "&$disabled": {
        backgroundColor: "transparent",
        color: theme.palette.action.disabled
      }
    },
    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      "$sizeSmall&": {
        marginLeft: -3
      }
    },
    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      "$sizeSmall&": {
        marginRight: -3
      }
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .X4)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      "&:hover": {
        backgroundColor: (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .X4)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },
    /* Styles applied to the children container element. */
    label: {
      width: "100%",
      display: "flex",
      alignItems: "inherit",
      justifyContent: "inherit"
    }
  };
};
var IconButton = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function IconButton2(props, ref) {
  var _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ButtonBase__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, color !== "default" && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(size))], {
      "start": classes.edgeStart,
      "end": classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled,
    ref
  }, other), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("span", {
    className: classes.label
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(styles, {
  name: "MuiIconButton"
})(IconButton));


/***/ }),

/***/ 99266:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _InputBase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1766);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27503);








var styles = function styles2(theme) {
  var light = theme.palette.type === "light";
  var bottomLineColor = light ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative"
    },
    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      "label + &": {
        marginTop: 16
      }
    },
    /* Styles applied to the root element if the component is focused. */
    focused: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      "&$underline:after": {
        borderBottomColor: theme.palette.secondary.main
      }
    },
    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      "&:after": {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: "absolute",
        right: 0,
        transform: "scaleX(0)",
        transition: theme.transitions.create("transform", {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: "none"
        // Transparent to the hover style.
      },
      "&$focused:after": {
        transform: "scaleX(1)"
      },
      "&$error:after": {
        borderBottomColor: theme.palette.error.main,
        transform: "scaleX(1)"
        // error is always underlined in red
      },
      "&:before": {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: "absolute",
        right: 0,
        transition: theme.transitions.create("border-bottom-color", {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: "none"
        // Transparent to the hover style.
      },
      "&:hover:not($disabled):before": {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      "&$disabled:before": {
        borderBottomStyle: "dotted"
      }
    },
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},
    /* Styles applied to the `input` element. */
    input: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},
    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
};
var Input = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function Input2(props, ref) {
  var disableUnderline = props.disableUnderline, classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_InputBase__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    classes: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, classes, {
      root: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth,
    inputComponent,
    multiline,
    ref,
    type
  }, other));
});
 false ? 0 : void 0;
Input.muiName = "Input";
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(styles, {
  name: "MuiInput"
})(Input));


/***/ }),

/***/ 73968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54346);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27503);
/* harmony import */ var _FormControl_FormControlContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50287);








var styles = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    height: "0.01em",
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: "2em",
    alignItems: "center",
    whiteSpace: "nowrap"
  },
  /* Styles applied to the root element if `variant="filled"`. */
  filled: {
    "&$positionStart:not($hiddenLabel)": {
      marginTop: 16
    }
  },
  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },
  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  },
  /* Styles applied to the root element if `disablePointerEvents=true`. */
  disablePointerEvents: {
    pointerEvents: "none"
  },
  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
  hiddenLabel: {},
  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
  marginDense: {}
};
var InputAdornment = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function InputAdornment2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disablePointer = props.disablePointerEvents, disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, position = props.position, variantProp = props.variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);
  var muiFormControl = (0,_FormControl_FormControlContext__WEBPACK_IMPORTED_MODULE_6__/* .useFormControl */ .t)() || {};
  var variant = variantProp;
  if (variantProp && muiFormControl.variant) {
    if (false) // removed by dead control flow
{}
  }
  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_FormControl_FormControlContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A.Provider, {
    value: null
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, position === "end" ? classes.positionEnd : classes.positionStart, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === "filled" && classes.filled, muiFormControl.margin === "dense" && classes.marginDense),
    ref
  }, other), typeof children === "string" && !disableTypography ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Typography__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A, {
    color: "textSecondary"
  }, children) : children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(styles, {
  name: "MuiInputAdornment"
})(InputAdornment));


/***/ }),

/***/ 37072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _InputAdornment__WEBPACK_IMPORTED_MODULE_0__.A; }
/* harmony export */ });
/* harmony import */ var _InputAdornment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73968);



/***/ }),

/***/ 1766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89782);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89435);
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44998);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31719);
/* harmony import */ var _FormControl_formControlState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26221);
/* harmony import */ var _FormControl_FormControlContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50287);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(27503);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39021);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1863);
/* harmony import */ var _TextareaAutosize__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(64916);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5850);














var styles = function styles2(theme) {
  var light = theme.palette.type === "light";
  var placeholder = {
    color: "currentColor",
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create("opacity", {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: "0 !important"
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    "@global": {
      "@keyframes mui-auto-fill": {},
      "@keyframes mui-auto-fill-cancel": {}
    },
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({}, theme.typography.body1, {
      color: theme.palette.text.primary,
      lineHeight: "1.1876em",
      // Reset (19px), match the native input line-height
      boxSizing: "border-box",
      // Prevent padding issue with fullWidth.
      position: "relative",
      cursor: "text",
      display: "inline-flex",
      alignItems: "center",
      "&$disabled": {
        color: theme.palette.text.disabled,
        cursor: "default"
      }
    }),
    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},
    /* Styles applied to the root element if the component is focused. */
    focused: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},
    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      "&$marginDense": {
        paddingTop: 4 - 1
      }
    },
    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {},
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: "100%"
    },
    /* Styles applied to the `input` element. */
    input: {
      font: "inherit",
      letterSpacing: "inherit",
      color: "currentColor",
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: "content-box",
      background: "none",
      height: "1.1876em",
      // Reset (19px), match the native input line-height
      margin: 0,
      // Reset for Safari
      WebkitTapHighlightColor: "transparent",
      display: "block",
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: "100%",
      // Fix IE 11 width issue
      animationName: "mui-auto-fill-cancel",
      animationDuration: "10ms",
      "&::-webkit-input-placeholder": placeholder,
      "&::-moz-placeholder": placeholder,
      // Firefox 19+
      "&:-ms-input-placeholder": placeholder,
      // IE 11
      "&::-ms-input-placeholder": placeholder,
      // Edge
      "&:focus": {
        outline: 0
      },
      // Reset Firefox invalid required input style
      "&:invalid": {
        boxShadow: "none"
      },
      "&::-webkit-search-decoration": {
        // Remove the padding when type=search.
        "-webkit-appearance": "none"
      },
      // Show and hide the placeholder logic
      "label[data-shrink=false] + $formControl &": {
        "&::-webkit-input-placeholder": placeholderHidden,
        "&::-moz-placeholder": placeholderHidden,
        // Firefox 19+
        "&:-ms-input-placeholder": placeholderHidden,
        // IE 11
        "&::-ms-input-placeholder": placeholderHidden,
        // Edge
        "&:focus::-webkit-input-placeholder": placeholderVisible,
        "&:focus::-moz-placeholder": placeholderVisible,
        // Firefox 19+
        "&:focus:-ms-input-placeholder": placeholderVisible,
        // IE 11
        "&:focus::-ms-input-placeholder": placeholderVisible
        // Edge
      },
      "&$disabled": {
        opacity: 1
        // Reset iOS opacity
      },
      "&:-webkit-autofill": {
        animationDuration: "5000s",
        animationName: "mui-auto-fill"
      }
    },
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      height: "auto",
      resize: "none",
      padding: 0
    },
    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      "-moz-appearance": "textfield",
      "-webkit-appearance": "textfield"
    },
    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},
    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {},
    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
    inputHiddenLabel: {}
  };
};
var useEnhancedEffect = typeof window === "undefined" ? react__WEBPACK_IMPORTED_MODULE_3__.useEffect : react__WEBPACK_IMPORTED_MODULE_3__.useLayoutEffect;
var InputBase = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.forwardRef(function InputBase2(props, ref) {
  var ariaDescribedby = props["aria-describedby"], autoComplete = props.autoComplete, autoFocus = props.autoFocus, classes = props.classes, className = props.className, color = props.color, defaultValue = props.defaultValue, disabled = props.disabled, endAdornment = props.endAdornment, error = props.error, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, id = props.id, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, _props$inputProps = props.inputProps, inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps, inputRefProp = props.inputRef, margin = props.margin, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, placeholder = props.placeholder, readOnly = props.readOnly, renderSuffix = props.renderSuffix, rows = props.rows, rowsMax = props.rowsMax, rowsMin = props.rowsMin, maxRows = props.maxRows, minRows = props.minRows, startAdornment = props.startAdornment, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, valueProp = props.value, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "startAdornment", "type", "value"]);
  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
  var _React$useRef = react__WEBPACK_IMPORTED_MODULE_3__.useRef(value != null), isControlled = _React$useRef.current;
  var inputRef = react__WEBPACK_IMPORTED_MODULE_3__.useRef();
  var handleInputRefWarning = react__WEBPACK_IMPORTED_MODULE_3__.useCallback(function(instance) {
    if (false) // removed by dead control flow
{}
  }, []);
  var handleInputPropsRefProp = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(inputPropsProp.ref, handleInputRefWarning);
  var handleInputRefProp = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(inputRefProp, handleInputPropsRefProp);
  var handleInputRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(inputRef, handleInputRefProp);
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_3__.useState(false), focused = _React$useState[0], setFocused = _React$useState[1];
  var muiFormControl = (0,_FormControl_FormControlContext__WEBPACK_IMPORTED_MODULE_6__/* .useFormControl */ .t)();
  if (false) // removed by dead control flow
{}
  var fcs = (0,_FormControl_formControlState__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)({
    props,
    muiFormControl,
    states: ["color", "disabled", "error", "hiddenLabel", "margin", "required", "filled"]
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused;
  react__WEBPACK_IMPORTED_MODULE_3__.useEffect(function() {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);
      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  var onFilled = muiFormControl && muiFormControl.onFilled;
  var onEmpty = muiFormControl && muiFormControl.onEmpty;
  var checkDirty = react__WEBPACK_IMPORTED_MODULE_3__.useCallback(function(obj) {
    if ((0,_utils__WEBPACK_IMPORTED_MODULE_11__/* .isFilled */ .lq)(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect(function() {
    if (isControlled) {
      checkDirty({
        value
      });
    }
  }, [value, checkDirty, isControlled]);
  var handleFocus = function handleFocus2(event) {
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }
    if (onFocus) {
      onFocus(event);
    }
    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }
    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };
  var handleBlur = function handleBlur2(event) {
    if (onBlur) {
      onBlur(event);
    }
    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }
    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };
  var handleChange = function handleChange2(event) {
    if (!isControlled) {
      var element = event.target || inputRef.current;
      if (element == null) {
        throw new Error( false ? 0 : (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(1));
      }
      checkDirty({
        value: element.value
      });
    }
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (inputPropsProp.onChange) {
      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
    }
    if (onChange) {
      onChange.apply(void 0, [event].concat(args));
    }
  };
  react__WEBPACK_IMPORTED_MODULE_3__.useEffect(function() {
    checkDirty(inputRef.current);
  }, []);
  var handleClick = function handleClick2(event) {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }
    if (onClick) {
      onClick(event);
    }
  };
  var InputComponent = inputComponent;
  var inputProps = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({}, inputPropsProp, {
    ref: handleInputRef
  });
  if (typeof InputComponent !== "string") {
    inputProps = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
      // Rename ref to inputRef as we don't know the
      // provided `inputComponent` structure.
      inputRef: handleInputRef,
      type
    }, inputProps, {
      ref: null
    });
  } else if (multiline) {
    if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) {
      InputComponent = "textarea";
    } else {
      inputProps = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
        minRows: rows || minRows,
        rowsMax,
        maxRows
      }, inputProps);
      InputComponent = _TextareaAutosize__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .A;
    }
  } else {
    inputProps = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
      type
    }, inputProps);
  }
  var handleAutoFill = function handleAutoFill2(event) {
    checkDirty(event.animationName === "mui-auto-fill-cancel" ? inputRef.current : {
      value: "x"
    });
  };
  react__WEBPACK_IMPORTED_MODULE_3__.useEffect(function() {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__["default"])(classes.root, classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(fcs.color || "primary"))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === "dense" && classes.marginDense),
    onClick: handleClick,
    ref
  }, other), startAdornment, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.createElement(_FormControl_FormControlContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A.Provider, {
    value: null
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.createElement(InputComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
    "aria-invalid": fcs.error,
    "aria-describedby": ariaDescribedby,
    autoComplete,
    autoFocus,
    defaultValue,
    disabled: fcs.disabled,
    id,
    onAnimationStart: handleAutoFill,
    name,
    placeholder,
    readOnly,
    required: fcs.required,
    rows,
    value,
    onKeyDown,
    onKeyUp
  }, inputProps, {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__["default"])(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === "search" && classes.inputTypeSearch, fcs.margin === "dense" && classes.inputMarginDense),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus
  }))), endAdornment, renderSuffix ? renderSuffix((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({}, fcs, {
    startAdornment
  })) : null);
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(styles, {
  name: "MuiInputBase"
})(InputBase));


/***/ }),

/***/ 5850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   gr: function() { return /* binding */ isAdornedStart; },
/* harmony export */   lq: function() { return /* binding */ isFilled; }
/* harmony export */ });
/* unused harmony export hasValue */
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
}
function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== "" || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== "");
}
function isAdornedStart(obj) {
  return obj.startAdornment;
}


/***/ }),

/***/ 96900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _FormControl_formControlState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26221);
/* harmony import */ var _FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72463);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27503);
/* harmony import */ var _FormLabel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95142);









var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "block",
      transformOrigin: "top left"
    },
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},
    /* Pseudo-class applied to the asterisk element. */
    asterisk: {},
    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: "absolute",
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: "translate(0, 24px) scale(1)"
    },
    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: "translate(0, 21px) scale(1)"
    },
    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: "translate(0, 1.5px) scale(0.75)",
      transformOrigin: "top left"
    },
    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create(["color", "transform"], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },
    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(12px, 20px) scale(1)",
      "&$marginDense": {
        transform: "translate(12px, 17px) scale(1)"
      },
      "&$shrink": {
        transform: "translate(12px, 10px) scale(0.75)",
        "&$marginDense": {
          transform: "translate(12px, 7px) scale(0.75)"
        }
      }
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: "none",
      transform: "translate(14px, 20px) scale(1)",
      "&$marginDense": {
        transform: "translate(14px, 12px) scale(1)"
      },
      "&$shrink": {
        transform: "translate(14px, -6px) scale(0.75)"
      }
    }
  };
};
var InputLabel = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function InputLabel2(props, ref) {
  var classes = props.classes, className = props.className, _props$disableAnimati = props.disableAnimation, disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati, margin = props.margin, shrinkProp = props.shrink, variant = props.variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);
  var muiFormControl = (0,_FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)();
  var shrink = shrinkProp;
  if (typeof shrink === "undefined" && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }
  var fcs = (0,_FormControl_formControlState__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)({
    props,
    muiFormControl,
    states: ["margin", "variant"]
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_FormLabel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    "data-shrink": shrink,
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === "dense" && classes.marginDense, {
      "filled": classes.filled,
      "outlined": classes.outlined
    }[fcs.variant]),
    classes: {
      focused: classes.focused,
      disabled: classes.disabled,
      error: classes.error,
      required: classes.required,
      asterisk: classes.asterisk
    },
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(styles, {
  name: "MuiInputLabel"
})(InputLabel));


/***/ }),

/***/ 96724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39021);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27503);
/* harmony import */ var _styles_colorManipulator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19603);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9022);









var TRANSITION_DURATION = 4;
var styles = function styles2(theme) {
  var getColor = function getColor2(color) {
    return theme.palette.type === "light" ? (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_6__/* .lighten */ .a)(color, 0.62) : (0,_styles_colorManipulator__WEBPACK_IMPORTED_MODULE_6__/* .darken */ .e$)(color, 0.5);
  };
  var backgroundPrimary = getColor(theme.palette.primary.main);
  var backgroundSecondary = getColor(theme.palette.secondary.main);
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      overflow: "hidden",
      height: 4,
      "@media print": {
        colorAdjust: "exact"
      }
    },
    /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */
    colorPrimary: {
      backgroundColor: backgroundPrimary
    },
    /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
    colorSecondary: {
      backgroundColor: backgroundSecondary
    },
    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {},
    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {},
    /* Styles applied to the root element if `variant="buffer"`. */
    buffer: {
      backgroundColor: "transparent"
    },
    /* Styles applied to the root element if `variant="query"`. */
    query: {
      transform: "rotate(180deg)"
    },
    /* Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {
      position: "absolute",
      marginTop: 0,
      height: "100%",
      width: "100%",
      animation: "$buffer 3s infinite linear"
    },
    /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
      backgroundSize: "10px 10px",
      backgroundPosition: "0 -23px"
    },
    /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
      backgroundSize: "10px 10px",
      backgroundPosition: "0 -23px"
    },
    /* Styles applied to the layered bar1 and bar2 elements. */
    bar: {
      width: "100%",
      position: "absolute",
      left: 0,
      bottom: 0,
      top: 0,
      transition: "transform 0.2s linear",
      transformOrigin: "left"
    },
    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },
    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {
      width: "auto",
      animation: "$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite"
    },
    /* Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    /* Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {
      width: "auto",
      animation: "$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite"
    },
    /* Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    "@keyframes indeterminate1": {
      //  |-----|---x-||-----||-----|
      "0%": {
        left: "-35%",
        right: "100%"
      },
      //  |-----|-----||-----||xxxx-|
      "60%": {
        left: "100%",
        right: "-90%"
      },
      "100%": {
        left: "100%",
        right: "-90%"
      }
    },
    "@keyframes indeterminate2": {
      //  |xxxxx|xxxxx||-----||-----|
      "0%": {
        left: "-200%",
        right: "100%"
      },
      //  |-----|-----||-----||-x----|
      "60%": {
        left: "107%",
        right: "-8%"
      },
      "100%": {
        left: "107%",
        right: "-8%"
      }
    },
    "@keyframes buffer": {
      "0%": {
        opacity: 1,
        backgroundPosition: "0 -23px"
      },
      "50%": {
        opacity: 0,
        backgroundPosition: "0 -23px"
      },
      "100%": {
        opacity: 1,
        backgroundPosition: "-200px -23px"
      }
    }
  };
};
var LinearProgress = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function LinearProgress2(props, ref) {
  var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, value = props.value, valueBuffer = props.valueBuffer, _props$variant = props.variant, variant = _props$variant === void 0 ? "indeterminate" : _props$variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
  var theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)();
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };
  if (variant === "determinate" || variant === "buffer") {
    if (value !== void 0) {
      rootProps["aria-valuenow"] = Math.round(value);
      rootProps["aria-valuemin"] = 0;
      rootProps["aria-valuemax"] = 100;
      var transform = value - 100;
      if (theme.direction === "rtl") {
        transform = -transform;
      }
      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
    } else if (false) // removed by dead control flow
{}
  }
  if (variant === "buffer") {
    if (valueBuffer !== void 0) {
      var _transform = (valueBuffer || 0) - 100;
      if (theme.direction === "rtl") {
        _transform = -_transform;
      }
      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
    } else if (false) // removed by dead control flow
{}
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(color))], className, {
      "determinate": classes.determinate,
      "indeterminate": classes.indeterminate,
      "buffer": classes.buffer,
      "query": classes.query
    }[variant]),
    role: "progressbar"
  }, rootProps, {
    ref
  }, other), variant === "buffer" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.dashed, classes["dashedColor".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(color))])
  }) : null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.bar, classes["barColor".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(color))], (variant === "indeterminate" || variant === "query") && classes.bar1Indeterminate, {
      "determinate": classes.bar1Determinate,
      "buffer": classes.bar1Buffer
    }[variant]),
    style: inlineStyles.bar1
  }), variant === "determinate" ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.bar, (variant === "indeterminate" || variant === "query") && classes.bar2Indeterminate, variant === "buffer" ? [classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(color))], classes.bar2Buffer] : classes["barColor".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(color))]),
    style: inlineStyles.bar2
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(styles, {
  name: "MuiLinearProgress"
})(LinearProgress));


/***/ }),

/***/ 2544:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27503);
/* harmony import */ var _ListContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36421);







var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: "none",
    margin: 0,
    padding: 0,
    position: "relative"
  },
  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },
  /* Styles applied to the root element if dense. */
  dense: {},
  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function List2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "ul" : _props$component, _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disablePadding = props.disablePadding, disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding, subheader = props.subheader, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
  var context = react__WEBPACK_IMPORTED_MODULE_2__.useMemo(function() {
    return {
      dense
    };
  }, [dense]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_ListContext__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A.Provider, {
    value: context
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref
  }, other), subheader, children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(styles, {
  name: "MuiList"
})(List));


/***/ }),

/***/ 36421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);

var ListContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
if (false) // removed by dead control flow
{}
/* harmony default export */ __webpack_exports__.A = (ListContext);


/***/ }),

/***/ 2002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27503);
/* harmony import */ var _ButtonBase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44963);
/* harmony import */ var _utils_isMuiElement__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75900);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1863);
/* harmony import */ var _List_ListContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36421);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51971);












var styles = function styles2(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      position: "relative",
      textDecoration: "none",
      width: "100%",
      boxSizing: "border-box",
      textAlign: "left",
      paddingTop: 8,
      paddingBottom: 8,
      "&$focusVisible": {
        backgroundColor: theme.palette.action.selected
      },
      "&$selected, &$selected:hover": {
        backgroundColor: theme.palette.action.selected
      },
      "&$disabled": {
        opacity: 0.5
      }
    },
    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: "relative"
    },
    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},
    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },
    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: "flex-start"
    },
    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: "padding-box"
    },
    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },
    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create("background-color", {
        duration: theme.transitions.duration.shortest
      }),
      "&:hover": {
        textDecoration: "none",
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    },
    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },
    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect = typeof window === "undefined" ? react__WEBPACK_IMPORTED_MODULE_2__.useEffect : react__WEBPACK_IMPORTED_MODULE_2__.useLayoutEffect;
var ListItem = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function ListItem2(props, ref) {
  var _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "center" : _props$alignItems, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$button = props.button, button = _props$button === void 0 ? false : _props$button, childrenProp = props.children, classes = props.classes, className = props.className, componentProp = props.component, _props$ContainerCompo = props.ContainerComponent, ContainerComponent = _props$ContainerCompo === void 0 ? "li" : _props$ContainerCompo, _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
  var ContainerClassName = _props$ContainerProps.className, ContainerProps = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(_props$ContainerProps, ["className"]), _props$dense = props.dense, dense = _props$dense === void 0 ? false : _props$dense, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$divider = props.divider, divider = _props$divider === void 0 ? false : _props$divider, focusVisibleClassName = props.focusVisibleClassName, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);
  var context = react__WEBPACK_IMPORTED_MODULE_2__.useContext(_List_ListContext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems
  };
  var listItemRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
  useEnhancedEffect(function() {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) // removed by dead control flow
{}
    }
  }, [autoFocus]);
  var children = react__WEBPACK_IMPORTED_MODULE_2__.Children.toArray(childrenProp);
  var hasSecondaryAction = children.length && (0,_utils_isMuiElement__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(children[children.length - 1], ["ListItemSecondaryAction"]);
  var handleOwnRef = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function(instance) {
    listItemRef.current = react_dom__WEBPACK_IMPORTED_MODULE_9__.findDOMNode(instance);
  }, []);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(handleOwnRef, ref);
  var componentProps = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled
  }, other);
  var Component = componentProp || "li";
  if (button) {
    componentProps.component = componentProp || "div";
    componentProps.focusVisibleClassName = (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.focusVisible, focusVisibleClassName);
    Component = _ButtonBase__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A;
  }
  if (hasSecondaryAction) {
    Component = !componentProps.component && !componentProp ? "div" : Component;
    if (ContainerComponent === "li") {
      if (Component === "li") {
        Component = "div";
      } else if (componentProps.component === "li") {
        componentProps.component = "div";
      }
    }
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_List_ListContext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A.Provider, {
      value: childContext
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(ContainerComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
      className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, componentProps, children), children.pop()));
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_List_ListContext__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A.Provider, {
    value: childContext
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    ref: handleRef
  }, componentProps), children));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(styles, {
  name: "MuiListItem"
})(ListItem));


/***/ }),

/***/ 12330:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94249);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27503);
/* harmony import */ var _Popover__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(898);
/* harmony import */ var _MenuList__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2434);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51971);
/* harmony import */ var _utils_setRef__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58094);
/* harmony import */ var _styles_useTheme__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9022);














var RTL_ORIGIN = {
  vertical: "top",
  horizontal: "right"
};
var LTR_ORIGIN = {
  vertical: "top",
  horizontal: "left"
};
var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: "calc(100% - 96px)",
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: "touch"
  },
  /* Styles applied to the `List` component via `MenuList`. */
  list: {
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Menu = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function Menu2(props, ref) {
  var _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus, children = props.children, classes = props.classes, _props$disableAutoFoc = props.disableAutoFocusItem, disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$MenuListProps = props.MenuListProps, MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps, onClose = props.onClose, onEnteringProp = props.onEntering, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, PopoverClasses = props.PopoverClasses, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps;
  _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;
  var onEntering = _props$TransitionProp.onEntering, TransitionProps = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(_props$TransitionProp, ["onEntering"]), _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"]);
  var theme = (0,_styles_useTheme__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .A)();
  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  var menuListActionsRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
  var contentAnchorRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
  var getContentAnchorEl = function getContentAnchorEl2() {
    return contentAnchorRef.current;
  };
  var handleEntering = function handleEntering2(element, isAppearing) {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }
    if (onEnteringProp) {
      onEnteringProp(element, isAppearing);
    }
    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };
  var handleListKeyDown = function handleListKeyDown2(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      if (onClose) {
        onClose(event, "tabKeyDown");
      }
    }
  };
  var activeItemIndex = -1;
  react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child, index) {
    if (!/* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.isValidElement(child)) {
      return;
    }
    if (false) // removed by dead control flow
{}
    if (!child.props.disabled) {
      if (variant !== "menu" && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child, index) {
    if (index === activeItemIndex) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.cloneElement(child, {
        ref: function ref2(instance) {
          contentAnchorRef.current = react_dom__WEBPACK_IMPORTED_MODULE_8__.findDOMNode(instance);
          (0,_utils_setRef__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(child.ref, instance);
        }
      });
    }
    return child;
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Popover__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Ay, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    getContentAnchorEl,
    classes: PopoverClasses,
    onClose,
    TransitionProps: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
      onEntering: handleEntering
    }, TransitionProps),
    anchorOrigin: theme.direction === "rtl" ? RTL_ORIGIN : LTR_ORIGIN,
    transformOrigin: theme.direction === "rtl" ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, PaperProps, {
      classes: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    open,
    ref,
    transitionDuration
  }, other), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_MenuList__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    onKeyDown: handleListKeyDown,
    actions: menuListActionsRef,
    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
    autoFocusItem,
    variant
  }, MenuListProps, {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__["default"])(classes.list, MenuListProps.className)
  }), items));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(styles, {
  name: "MuiMenu"
})(Menu));


/***/ }),

/***/ 91336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89782);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75054);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89435);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27503);
/* harmony import */ var _ListItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2002);








var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)({}, theme.typography.body1, (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: "border-box",
      width: "auto",
      overflow: "hidden",
      whiteSpace: "nowrap"
    }, theme.breakpoints.up("sm"), {
      minHeight: "auto"
    })),
    // TODO v5: remove
    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},
    /* Styles applied to the root element if `selected={true}`. */
    selected: {},
    /* Styles applied to the root element if dense. */
    dense: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)({}, theme.typography.body2, {
      minHeight: "auto"
    })
  };
};
var MenuItem = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.forwardRef(function MenuItem2(props, ref) {
  var classes = props.classes, className = props.className, _props$component = props.component, component = _props$component === void 0 ? "li" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, ListItemClasses = props.ListItemClasses, _props$role = props.role, role = _props$role === void 0 ? "menuitem" : _props$role, selected = props.selected, tabIndexProp = props.tabIndex, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);
  var tabIndex;
  if (!props.disabled) {
    tabIndex = tabIndexProp !== void 0 ? tabIndexProp : -1;
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.createElement(_ListItem__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)({
    button: true,
    role,
    tabIndex,
    component,
    selected,
    disableGutters,
    classes: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)({
      dense: classes.dense
    }, ListItemClasses),
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__["default"])(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(styles, {
  name: "MuiMenuItem"
})(MenuItem));


/***/ }),

/***/ 2434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var react_is__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94249);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51971);
/* harmony import */ var _utils_ownerDocument__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33189);
/* harmony import */ var _List__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2544);
/* harmony import */ var _utils_getScrollbarSize__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57040);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1863);










function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }
  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }
  return disableListWrap ? null : list.firstChild;
}
function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }
  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }
  return disableListWrap ? null : list.lastChild;
}
function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === void 0) {
    return true;
  }
  var text = nextFocus.innerText;
  if (text === void 0) {
    text = nextFocus.textContent;
  }
  text = text.trim().toLowerCase();
  if (text.length === 0) {
    return false;
  }
  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }
  return text.indexOf(textCriteria.keys.join("")) === 0;
}
function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  var wrappedOnce = false;
  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
  while (nextFocus) {
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return;
      }
      wrappedOnce = true;
    }
    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute("aria-disabled") === "true";
    if (!nextFocus.hasAttribute("tabindex") || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return;
    }
  }
}
var useEnhancedEffect = typeof window === "undefined" ? react__WEBPACK_IMPORTED_MODULE_2__.useEffect : react__WEBPACK_IMPORTED_MODULE_2__.useLayoutEffect;
var MenuList = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function MenuList2(props, ref) {
  var actions = props.actions, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, _props$autoFocusItem = props.autoFocusItem, autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem, children = props.children, className = props.className, _props$disabledItemsF = props.disabledItemsFocusable, disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF, _props$disableListWra = props.disableListWrap, disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra, onKeyDown = props.onKeyDown, _props$variant = props.variant, variant = _props$variant === void 0 ? "selectedMenu" : _props$variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);
  var listRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
  var textCriteriaRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect(function() {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle(actions, function() {
    return {
      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
        var noExplicitWidth = !listRef.current.style.width;
        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
          var scrollbarSize = "".concat((0,_utils_getScrollbarSize__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(true), "px");
          listRef.current.style[theme.direction === "rtl" ? "paddingLeft" : "paddingRight"] = scrollbarSize;
          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
        }
        return listRef.current;
      }
    };
  }, []);
  var handleKeyDown = function handleKeyDown2(event) {
    var list = listRef.current;
    var key = event.key;
    var currentFocus = (0,_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(list).activeElement;
    if (key === "ArrowDown") {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === "ArrowUp") {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === "Home") {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === "End") {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      var criteria = textCriteriaRef.current;
      var lowerKey = key.toLowerCase();
      var currTime = performance.now();
      if (criteria.keys.length > 0) {
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }
      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  var handleOwnRef = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function(instance) {
    listRef.current = react_dom__WEBPACK_IMPORTED_MODULE_4__.findDOMNode(instance);
  }, []);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(handleOwnRef, ref);
  var activeItemIndex = -1;
  react__WEBPACK_IMPORTED_MODULE_2__.Children.forEach(children, function(child, index) {
    if (!/* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.isValidElement(child)) {
      return;
    }
    if (false) // removed by dead control flow
{}
    if (!child.props.disabled) {
      if (variant === "selectedMenu" && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = react__WEBPACK_IMPORTED_MODULE_2__.Children.map(children, function(child, index) {
    if (index === activeItemIndex) {
      var newChildProps = {};
      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }
      if (child.props.tabIndex === void 0 && variant === "selectedMenu") {
        newChildProps.tabIndex = 0;
      }
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.cloneElement(child, newChildProps);
    }
    return child;
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_List__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    role: "menu",
    ref: handleRef,
    className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other), items);
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = (MenuList);


/***/ }),

/***/ 37790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Modal_Modal; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(89782);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: consume shared module (default) react-dom@=17.0.2 (singleton) (fallback: ./node_modules/react-dom/index.js) (eager)
var react_dom_index_js_eager_ = __webpack_require__(51971);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(9341);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/getThemeProps/getThemeProps.js
var getThemeProps = __webpack_require__(29663);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(33189);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Portal/Portal.js
var Portal = __webpack_require__(4163);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(33771);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(1863);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(38957);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/zIndex.js
var zIndex = __webpack_require__(31372);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/ModalManager.js
var ModalManager = __webpack_require__(2563);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Unstable_TrapFocus/Unstable_TrapFocus.js
var Unstable_TrapFocus = __webpack_require__(1568);
;// ./node_modules/@material-ui/core/esm/Modal/SimpleBackdrop.js




var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: "fixed",
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    WebkitTapHighlightColor: "transparent"
  },
  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: "transparent"
  }
};
var SimpleBackdrop = /* @__PURE__ */ index_js_eager_.forwardRef(function SimpleBackdrop2(props, ref) {
  var _props$invisible = props.invisible, invisible = _props$invisible === void 0 ? false : _props$invisible, open = props.open, other = (0,objectWithoutProperties/* default */.A)(props, ["invisible", "open"]);
  return open ? /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    "aria-hidden": true,
    ref
  }, other, {
    style: (0,esm_extends/* default */.A)({}, styles.root, invisible ? styles.invisible : {}, other.style)
  })) : null;
});
 false ? 0 : void 0;
/* harmony default export */ var Modal_SimpleBackdrop = (SimpleBackdrop);

;// ./node_modules/@material-ui/core/esm/Modal/Modal.js

















function getContainer(container) {
  container = typeof container === "function" ? container() : container;
  return react_dom_index_js_eager_.findDOMNode(container);
}
function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty("in") : false;
}
var defaultManager = new ModalManager/* default */.A();
var Modal_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "fixed",
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },
    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: "hidden"
    }
  };
};
var Modal = /* @__PURE__ */ index_js_eager_.forwardRef(function Modal2(inProps, ref) {
  var theme = (0,useTheme/* default */.A)();
  var props = (0,getThemeProps/* default */.A)({
    name: "MuiModal",
    props: (0,esm_extends/* default */.A)({}, inProps),
    theme
  });
  var _props$BackdropCompon = props.BackdropComponent, BackdropComponent = _props$BackdropCompon === void 0 ? Modal_SimpleBackdrop : _props$BackdropCompon, BackdropProps = props.BackdropProps, children = props.children, _props$closeAfterTran = props.closeAfterTransition, closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran, container = props.container, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableBackdro = props.disableBackdropClick, disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableEscapeK = props.disableEscapeKeyDown, disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, _props$disableScrollL = props.disableScrollLock, disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL, _props$hideBackdrop = props.hideBackdrop, hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, _props$manager = props.manager, manager = _props$manager === void 0 ? defaultManager : _props$manager, onBackdropClick = props.onBackdropClick, onClose = props.onClose, onEscapeKeyDown = props.onEscapeKeyDown, onRendered = props.onRendered, open = props.open, other = (0,objectWithoutProperties/* default */.A)(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
  var _React$useState = index_js_eager_.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
  var modal = index_js_eager_.useRef({});
  var mountNodeRef = index_js_eager_.useRef(null);
  var modalRef = index_js_eager_.useRef(null);
  var handleRef = (0,useForkRef/* default */.A)(modalRef, ref);
  var hasTransition = getHasTransition(props);
  var getDoc = function getDoc2() {
    return (0,ownerDocument/* default */.A)(mountNodeRef.current);
  };
  var getModal = function getModal2() {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };
  var handleMounted = function handleMounted2() {
    manager.mount(getModal(), {
      disableScrollLock
    });
    modalRef.current.scrollTop = 0;
  };
  var handleOpen = (0,useEventCallback/* default */.A)(function() {
    var resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer);
    if (modalRef.current) {
      handleMounted();
    }
  });
  var isTopModal = index_js_eager_.useCallback(function() {
    return manager.isTopModal(getModal());
  }, [manager]);
  var handlePortalRef = (0,useEventCallback/* default */.A)(function(node) {
    mountNodeRef.current = node;
    if (!node) {
      return;
    }
    if (onRendered) {
      onRendered();
    }
    if (open && isTopModal()) {
      handleMounted();
    } else {
      (0,ModalManager/* ariaHidden */.M)(modalRef.current, true);
    }
  });
  var handleClose = index_js_eager_.useCallback(function() {
    manager.remove(getModal());
  }, [manager]);
  index_js_eager_.useEffect(function() {
    return function() {
      handleClose();
    };
  }, [handleClose]);
  index_js_eager_.useEffect(function() {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }
  var handleEnter = function handleEnter2() {
    setExited(false);
  };
  var handleExited = function handleExited2() {
    setExited(true);
    if (closeAfterTransition) {
      handleClose();
    }
  };
  var handleBackdropClick = function handleBackdropClick2(event) {
    if (event.target !== event.currentTarget) {
      return;
    }
    if (onBackdropClick) {
      onBackdropClick(event);
    }
    if (!disableBackdropClick && onClose) {
      onClose(event, "backdropClick");
    }
  };
  var handleKeyDown = function handleKeyDown2(event) {
    if (event.key !== "Escape" || !isTopModal()) {
      return;
    }
    if (onEscapeKeyDown) {
      onEscapeKeyDown(event);
    }
    if (!disableEscapeKeyDown) {
      event.stopPropagation();
      if (onClose) {
        onClose(event, "escapeKeyDown");
      }
    }
  };
  var inlineStyle = Modal_styles(theme || {
    zIndex: zIndex/* default */.A
  });
  var childProps = {};
  if (children.props.tabIndex === void 0) {
    childProps.tabIndex = children.props.tabIndex || "-1";
  }
  if (hasTransition) {
    childProps.onEnter = (0,createChainedFunction/* default */.A)(handleEnter, children.props.onEnter);
    childProps.onExited = (0,createChainedFunction/* default */.A)(handleExited, children.props.onExited);
  }
  return /* @__PURE__ */ index_js_eager_.createElement(Portal/* default */.A, {
    ref: handlePortalRef,
    container,
    disablePortal
  }, /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    ref: handleRef,
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, other, {
    style: (0,esm_extends/* default */.A)({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
  }), hideBackdrop ? null : /* @__PURE__ */ index_js_eager_.createElement(BackdropComponent, (0,esm_extends/* default */.A)({
    open,
    onClick: handleBackdropClick
  }, BackdropProps)), /* @__PURE__ */ index_js_eager_.createElement(Unstable_TrapFocus/* default */.A, {
    disableEnforceFocus,
    disableAutoFocus,
    disableRestoreFocus,
    getDoc,
    isEnabled: isTopModal,
    open
  }, /* @__PURE__ */ index_js_eager_.cloneElement(children, childProps))));
});
 false ? 0 : void 0;
/* harmony default export */ var Modal_Modal = (Modal);


/***/ }),

/***/ 2563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ ModalManager; },
/* harmony export */   M: function() { return /* binding */ ariaHidden; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82548);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64970);
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6849);
/* harmony import */ var _utils_getScrollbarSize__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57040);
/* harmony import */ var _utils_ownerDocument__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33189);
/* harmony import */ var _utils_ownerWindow__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(37940);






function isOverflowing(container) {
  var doc = (0,_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(container);
  if (doc.body === container) {
    return (0,_utils_ownerWindow__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(doc).innerWidth > doc.documentElement.clientWidth;
  }
  return container.scrollHeight > container.clientHeight;
}
function ariaHidden(node, show) {
  if (show) {
    node.setAttribute("aria-hidden", "true");
  } else {
    node.removeAttribute("aria-hidden");
  }
}
function getPaddingRight(node) {
  return parseInt(window.getComputedStyle(node)["padding-right"], 10) || 0;
}
function ariaHiddenSiblings(container, mountNode, currentNode) {
  var nodesToExclude = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
  var show = arguments.length > 4 ? arguments[4] : void 0;
  var blacklist = [mountNode, currentNode].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(nodesToExclude));
  var blacklistTagNames = ["TEMPLATE", "SCRIPT", "STYLE"];
  [].forEach.call(container.children, function(node) {
    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
      ariaHidden(node, show);
    }
  });
}
function findIndexOf(containerInfo, callback) {
  var idx = -1;
  containerInfo.some(function(item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }
    return false;
  });
  return idx;
}
function handleContainer(containerInfo, props) {
  var restoreStyle = [];
  var restorePaddings = [];
  var container = containerInfo.container;
  var fixedNodes;
  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      var scrollbarSize = (0,_utils_getScrollbarSize__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)();
      restoreStyle.push({
        value: container.style.paddingRight,
        key: "padding-right",
        el: container
      });
      container.style["padding-right"] = "".concat(getPaddingRight(container) + scrollbarSize, "px");
      fixedNodes = (0,_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(container).querySelectorAll(".mui-fixed");
      [].forEach.call(fixedNodes, function(node) {
        restorePaddings.push(node.style.paddingRight);
        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
      });
    }
    var parent = container.parentElement;
    var scrollContainer = parent.nodeName === "HTML" && window.getComputedStyle(parent)["overflow-y"] === "scroll" ? parent : container;
    restoreStyle.push({
      value: scrollContainer.style.overflow,
      key: "overflow",
      el: scrollContainer
    });
    scrollContainer.style.overflow = "hidden";
  }
  var restore = function restore2() {
    if (fixedNodes) {
      [].forEach.call(fixedNodes, function(node, i) {
        if (restorePaddings[i]) {
          node.style.paddingRight = restorePaddings[i];
        } else {
          node.style.removeProperty("padding-right");
        }
      });
    }
    restoreStyle.forEach(function(_ref) {
      var value = _ref.value, el = _ref.el, key = _ref.key;
      if (value) {
        el.style.setProperty(key, value);
      } else {
        el.style.removeProperty(key);
      }
    });
  };
  return restore;
}
function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function(node) {
    if (node.getAttribute && node.getAttribute("aria-hidden") === "true") {
      hiddenSiblings.push(node);
    }
  });
  return hiddenSiblings;
}
var ModalManager = /* @__PURE__ */ (function() {
  function ModalManager2() {
    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(this, ModalManager2);
    this.modals = [];
    this.containers = [];
  }
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(ModalManager2, [{
    key: "add",
    value: function add(modal, container) {
      var modalIndex = this.modals.indexOf(modal);
      if (modalIndex !== -1) {
        return modalIndex;
      }
      modalIndex = this.modals.length;
      this.modals.push(modal);
      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }
      var hiddenSiblingNodes = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
      var containerIndex = findIndexOf(this.containers, function(item) {
        return item.container === container;
      });
      if (containerIndex !== -1) {
        this.containers[containerIndex].modals.push(modal);
        return modalIndex;
      }
      this.containers.push({
        modals: [modal],
        container,
        restore: null,
        hiddenSiblingNodes
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal, props) {
      var containerIndex = findIndexOf(this.containers, function(item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      if (!containerInfo.restore) {
        containerInfo.restore = handleContainer(containerInfo, props);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIndex = this.modals.indexOf(modal);
      if (modalIndex === -1) {
        return modalIndex;
      }
      var containerIndex = findIndexOf(this.containers, function(item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
      this.modals.splice(modalIndex, 1);
      if (containerInfo.modals.length === 0) {
        if (containerInfo.restore) {
          containerInfo.restore();
        }
        if (modal.modalRef) {
          ariaHidden(modal.modalRef, true);
        }
        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
        this.containers.splice(containerIndex, 1);
      } else {
        var nextTop = containerInfo.modals[containerInfo.modals.length - 1];
        if (nextTop.modalRef) {
          ariaHidden(nextTop.modalRef, false);
        }
      }
      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);
  return ModalManager2;
})();



/***/ }),

/***/ 10922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: function() { return /* binding */ styles; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var _NativeSelectInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99108);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27503);
/* harmony import */ var _FormControl_formControlState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26221);
/* harmony import */ var _FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72463);
/* harmony import */ var _internal_svg_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(91893);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99266);










var styles = function styles2(theme) {
  return {
    /* Styles applied to the select component `root` class. */
    root: {},
    /* Styles applied to the select component `select` class. */
    select: {
      "-moz-appearance": "none",
      // Reset
      "-webkit-appearance": "none",
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: "none",
      borderRadius: 0,
      // Reset
      minWidth: 16,
      // So it doesn't collapse.
      cursor: "pointer",
      "&:focus": {
        // Show that it's not an text input
        backgroundColor: theme.palette.type === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)",
        borderRadius: 0
        // Reset Chrome style
      },
      // Remove IE 11 arrow
      "&::-ms-expand": {
        display: "none"
      },
      "&$disabled": {
        cursor: "default"
      },
      "&[multiple]": {
        height: "auto"
      },
      "&:not([multiple]) option, &:not([multiple]) optgroup": {
        backgroundColor: theme.palette.background.paper
      },
      "&&": {
        paddingRight: 24
      }
    },
    /* Styles applied to the select component if `variant="filled"`. */
    filled: {
      "&&": {
        paddingRight: 32
      }
    },
    /* Styles applied to the select component if `variant="outlined"`. */
    outlined: {
      borderRadius: theme.shape.borderRadius,
      "&&": {
        paddingRight: 32
      }
    },
    /* Styles applied to the select component `selectMenu` class. */
    selectMenu: {
      height: "auto",
      // Resets for multpile select with chips
      minHeight: "1.1876em",
      // Required for select\text-field height consistency
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    /* Pseudo-class applied to the select component `disabled` class. */
    disabled: {},
    /* Styles applied to the icon component. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input and to support wrapping tags..
      position: "absolute",
      right: 0,
      top: "calc(50% - 12px)",
      // Center vertically
      pointerEvents: "none",
      // Don't block pointer events on the select under the icon.
      color: theme.palette.action.active,
      "&$disabled": {
        color: theme.palette.action.disabled
      }
    },
    /* Styles applied to the icon component if the popup is open. */
    iconOpen: {
      transform: "rotate(180deg)"
    },
    /* Styles applied to the icon component if `variant="filled"`. */
    iconFilled: {
      right: 7
    },
    /* Styles applied to the icon component if `variant="outlined"`. */
    iconOutlined: {
      right: 7
    },
    /* Styles applied to the underlying native input component. */
    nativeInput: {
      bottom: 0,
      left: 0,
      position: "absolute",
      opacity: 0,
      pointerEvents: "none",
      width: "100%"
    }
  };
};
var defaultInput = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Input__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A, null);
var NativeSelect = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function NativeSelect2(props, ref) {
  var children = props.children, classes = props.classes, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? _internal_svg_icons_ArrowDropDown__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A : _props$IconComponent, _props$input = props.input, input = _props$input === void 0 ? defaultInput : _props$input, inputProps = props.inputProps, variant = props.variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);
  var muiFormControl = (0,_FormControl_useFormControl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)();
  var fcs = (0,_FormControl_formControlState__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)({
    props,
    muiFormControl,
    states: ["variant"]
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.cloneElement(input, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: _NativeSelectInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A,
    inputProps: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
      children,
      classes,
      IconComponent,
      variant: fcs.variant,
      type: void 0
    }, inputProps, input ? input.props.inputProps : {}),
    ref
  }, other));
});
 false ? 0 : void 0;
NativeSelect.muiName = "Select";
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(styles, {
  name: "MuiNativeSelect"
})(NativeSelect));


/***/ }),

/***/ 99108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39021);







var NativeSelectInput = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function NativeSelectInput2(props, ref) {
  var classes = props.classes, className = props.className, disabled = props.disabled, IconComponent = props.IconComponent, inputRef = props.inputRef, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("select", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(
      classes.root,
      // TODO v5: merge root and select
      classes.select,
      classes[variant],
      className,
      disabled && classes.disabled
    ),
    disabled,
    ref: inputRef || ref
  }, other)), props.multiple ? null : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(IconComponent, {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.icon, classes["icon".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(variant))], disabled && classes.disabled)
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = (NativeSelectInput);


/***/ }),

/***/ 28662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ OutlinedInput_OutlinedInput; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(89782);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(31719);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputBase/InputBase.js
var InputBase = __webpack_require__(1766);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(75054);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(27503);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(9022);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(39021);
;// ./node_modules/@material-ui/core/esm/OutlinedInput/NotchedOutline.js









var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "absolute",
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: "0 8px",
      pointerEvents: "none",
      borderRadius: "inherit",
      borderStyle: "solid",
      borderWidth: 1,
      overflow: "hidden"
    },
    /* Styles applied to the legend element when `labelWidth` is provided. */
    legend: {
      textAlign: "left",
      padding: 0,
      lineHeight: "11px",
      // sync with `height` in `legend` styles
      transition: theme.transitions.create("width", {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    },
    /* Styles applied to the legend element. */
    legendLabelled: {
      display: "block",
      width: "auto",
      textAlign: "left",
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: "0.75em",
      visibility: "hidden",
      maxWidth: 0.01,
      transition: theme.transitions.create("max-width", {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      "& > span": {
        paddingLeft: 5,
        paddingRight: 5,
        display: "inline-block"
      }
    },
    /* Styles applied to the legend element is notched. */
    legendNotched: {
      maxWidth: 1e3,
      transition: theme.transitions.create("max-width", {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }
  };
};
var NotchedOutline = /* @__PURE__ */ index_js_eager_.forwardRef(function NotchedOutline2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, label = props.label, labelWidthProp = props.labelWidth, notched = props.notched, style = props.style, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);
  var theme = (0,useTheme/* default */.A)();
  var align = theme.direction === "rtl" ? "right" : "left";
  if (label !== void 0) {
    return /* @__PURE__ */ index_js_eager_.createElement("fieldset", (0,esm_extends/* default */.A)({
      "aria-hidden": true,
      className: (0,clsx_m["default"])(classes.root, className),
      ref,
      style
    }, other), /* @__PURE__ */ index_js_eager_.createElement("legend", {
      className: (0,clsx_m["default"])(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /* @__PURE__ */ index_js_eager_.createElement("span", null, label) : /* @__PURE__ */ index_js_eager_.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: "&#8203;"
      }
    })));
  }
  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
  return /* @__PURE__ */ index_js_eager_.createElement("fieldset", (0,esm_extends/* default */.A)({
    "aria-hidden": true,
    style: (0,esm_extends/* default */.A)((0,defineProperty/* default */.A)({}, "padding".concat((0,capitalize/* default */.A)(align)), 8), style),
    className: (0,clsx_m["default"])(classes.root, className),
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement("legend", {
    className: classes.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: notched ? labelWidth : 0.01
    }
  }, /* @__PURE__ */ index_js_eager_.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: "&#8203;"
    }
  })));
});
 false ? 0 : void 0;
/* harmony default export */ var OutlinedInput_NotchedOutline = ((0,withStyles/* default */.A)(styles, {
  name: "PrivateNotchedOutline"
})(NotchedOutline));

;// ./node_modules/@material-ui/core/esm/OutlinedInput/OutlinedInput.js









var OutlinedInput_styles = function styles2(theme) {
  var borderColor = theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      borderRadius: theme.shape.borderRadius,
      "&:hover $notchedOutline": {
        borderColor: theme.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        "&:hover $notchedOutline": {
          borderColor
        }
      },
      "&$focused $notchedOutline": {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      "&$error $notchedOutline": {
        borderColor: theme.palette.error.main
      },
      "&$disabled $notchedOutline": {
        borderColor: theme.palette.action.disabled
      }
    },
    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      "&$focused $notchedOutline": {
        borderColor: theme.palette.secondary.main
      }
    },
    /* Styles applied to the root element if the component is focused. */
    focused: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },
    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},
    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "18.5px 14px",
      "&$marginDense": {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },
    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
      borderColor
    },
    /* Styles applied to the `input` element. */
    input: {
      padding: "18.5px 14px",
      "&:-webkit-autofill": {
        WebkitBoxShadow: theme.palette.type === "light" ? null : "0 0 0 100px #266798 inset",
        WebkitTextFillColor: theme.palette.type === "light" ? null : "#fff",
        caretColor: theme.palette.type === "light" ? null : "#fff",
        borderRadius: "inherit"
      }
    },
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },
    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },
    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var OutlinedInput = /* @__PURE__ */ index_js_eager_.forwardRef(function OutlinedInput2(props, ref) {
  var classes = props.classes, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$inputComponent = props.inputComponent, inputComponent = _props$inputComponent === void 0 ? "input" : _props$inputComponent, label = props.label, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, notched = props.notched, _props$type = props.type, type = _props$type === void 0 ? "text" : _props$type, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);
  return /* @__PURE__ */ index_js_eager_.createElement(InputBase/* default */.A, (0,esm_extends/* default */.A)({
    renderSuffix: function renderSuffix(state) {
      return /* @__PURE__ */ index_js_eager_.createElement(OutlinedInput_NotchedOutline, {
        className: classes.notchedOutline,
        label,
        labelWidth,
        notched: typeof notched !== "undefined" ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: (0,esm_extends/* default */.A)({}, classes, {
      root: (0,clsx_m["default"])(classes.root, classes.underline),
      notchedOutline: null
    }),
    fullWidth,
    inputComponent,
    multiline,
    ref,
    type
  }, other));
});
 false ? 0 : void 0;
OutlinedInput.muiName = "Input";
/* harmony default export */ var OutlinedInput_OutlinedInput = ((0,withStyles/* default */.A)(OutlinedInput_styles, {
  name: "MuiOutlinedInput"
})(OutlinedInput));


/***/ }),

/***/ 1526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89782);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89435);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27503);







var styles = function styles2(theme) {
  var elevations = {};
  theme.shadows.forEach(function(shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create("box-shadow")
    },
    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function Paper2(props, ref) {
  var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 1 : _props$elevation, _props$variant = props.variant, variant = _props$variant === void 0 ? "elevation" : _props$variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(props, ["classes", "className", "component", "square", "elevation", "variant"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, variant === "outlined" ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(styles, {
  name: "MuiPaper"
})(Paper));


/***/ }),

/***/ 898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports getOffsetTop, getOffsetLeft, styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51971);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35864);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31719);
/* harmony import */ var _utils_ownerDocument__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33189);
/* harmony import */ var _utils_ownerWindow__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(37940);
/* harmony import */ var _utils_createChainedFunction__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(33771);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27503);
/* harmony import */ var _Modal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(37790);
/* harmony import */ var _Grow__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(75282);
/* harmony import */ var _Paper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1526);
















function getOffsetTop(rect, vertical) {
  var offset = 0;
  if (typeof vertical === "number") {
    offset = vertical;
  } else if (vertical === "center") {
    offset = rect.height / 2;
  } else if (vertical === "bottom") {
    offset = rect.height;
  }
  return offset;
}
function getOffsetLeft(rect, horizontal) {
  var offset = 0;
  if (typeof horizontal === "number") {
    offset = horizontal;
  } else if (horizontal === "center") {
    offset = rect.width / 2;
  } else if (horizontal === "right") {
    offset = rect.width;
  }
  return offset;
}
function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function(n) {
    return typeof n === "number" ? "".concat(n, "px") : n;
  }).join(" ");
}
function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;
  while (element && element !== parent) {
    element = element.parentElement;
    scrollTop += element.scrollTop;
  }
  return scrollTop;
}
function getAnchorEl(anchorEl) {
  return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
var styles = {
  /* Styles applied to the root element. */
  root: {},
  /* Styles applied to the `Paper` component. */
  paper: {
    position: "absolute",
    overflowY: "auto",
    overflowX: "hidden",
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: "calc(100% - 32px)",
    maxHeight: "calc(100% - 32px)",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Popover = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function Popover2(props, ref) {
  var action = props.action, anchorEl = props.anchorEl, _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: "top",
    horizontal: "left"
  } : _props$anchorOrigin, anchorPosition = props.anchorPosition, _props$anchorReferenc = props.anchorReference, anchorReference = _props$anchorReferenc === void 0 ? "anchorEl" : _props$anchorReferenc, children = props.children, classes = props.classes, className = props.className, containerProp = props.container, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 8 : _props$elevation, getContentAnchorEl = props.getContentAnchorEl, _props$marginThreshol = props.marginThreshold, marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, _props$transformOrigi = props.transformOrigin, transformOrigin = _props$transformOrigi === void 0 ? {
    vertical: "top",
    horizontal: "left"
  } : _props$transformOrigi, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? _Grow__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .A : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, _props$TransitionProp = props.TransitionProps, TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
  var paperRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef();
  var getAnchorOffset = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function(contentAnchorOffset) {
    if (anchorReference === "anchorPosition") {
      if (false) // removed by dead control flow
{}
      return anchorPosition;
    }
    var resolvedAnchorEl = getAnchorEl(anchorEl);
    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0,_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(paperRef.current).body;
    var anchorRect = anchorElement.getBoundingClientRect();
    if (false) // removed by dead control flow
{ var box; }
    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : "center";
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]);
  var getContentAnchorOffset = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function(element) {
    var contentAnchorOffset = 0;
    if (getContentAnchorEl && anchorReference === "anchorEl") {
      var contentAnchorEl = getContentAnchorEl(element);
      if (contentAnchorEl && element.contains(contentAnchorEl)) {
        var scrollTop = getScrollParent(element, contentAnchorEl);
        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
      }
      if (false) // removed by dead control flow
{}
    }
    return contentAnchorOffset;
  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]);
  var getTransformOrigin = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function(elemRect) {
    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  var getPositioningStyle = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function(element) {
    var contentAnchorOffset = getContentAnchorOffset(element);
    var elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    };
    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
    if (anchorReference === "none") {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    }
    var anchorOffset = getAnchorOffset(contentAnchorOffset);
    var top = anchorOffset.top - elemTransformOrigin.vertical;
    var left = anchorOffset.left - elemTransformOrigin.horizontal;
    var bottom = top + elemRect.height;
    var right = left + elemRect.width;
    var containerWindow = (0,_utils_ownerWindow__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A)(getAnchorEl(anchorEl));
    var heightThreshold = containerWindow.innerHeight - marginThreshold;
    var widthThreshold = containerWindow.innerWidth - marginThreshold;
    if (top < marginThreshold) {
      var diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      var _diff = bottom - heightThreshold;
      top -= _diff;
      elemTransformOrigin.vertical += _diff;
    }
    if (false) // removed by dead control flow
{}
    if (left < marginThreshold) {
      var _diff2 = left - marginThreshold;
      left -= _diff2;
      elemTransformOrigin.horizontal += _diff2;
    } else if (right > widthThreshold) {
      var _diff3 = right - widthThreshold;
      left -= _diff3;
      elemTransformOrigin.horizontal += _diff3;
    }
    return {
      top: "".concat(Math.round(top), "px"),
      left: "".concat(Math.round(left), "px"),
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
  var setPositioningStyles = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function() {
    var element = paperRef.current;
    if (!element) {
      return;
    }
    var positioning = getPositioningStyle(element);
    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }
    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }
    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);
  var handleEntering = function handleEntering2(element, isAppearing) {
    if (onEntering) {
      onEntering(element, isAppearing);
    }
    setPositioningStyles();
  };
  var handlePaperRef = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function(instance) {
    paperRef.current = react_dom__WEBPACK_IMPORTED_MODULE_3__.findDOMNode(instance);
  }, []);
  react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
    if (open) {
      setPositioningStyles();
    }
  });
  react__WEBPACK_IMPORTED_MODULE_2__.useImperativeHandle(action, function() {
    return open ? {
      updatePosition: function updatePosition() {
        setPositioningStyles();
      }
    } : null;
  }, [open, setPositioningStyles]);
  react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
    if (!open) {
      return void 0;
    }
    var handleResize = (0,_utils_debounce__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(function() {
      setPositioningStyles();
    });
    window.addEventListener("resize", handleResize);
    return function() {
      handleResize.clear();
      window.removeEventListener("resize", handleResize);
    };
  }, [open, setPositioningStyles]);
  var transitionDuration = transitionDurationProp;
  if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) {
    transitionDuration = void 0;
  }
  var container = containerProp || (anchorEl ? (0,_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A)(getAnchorEl(anchorEl)).body : void 0);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Modal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    container,
    open,
    ref,
    BackdropProps: {
      invisible: true
    },
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__["default"])(classes.root, className)
  }, other), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(TransitionComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    appear: true,
    in: open,
    onEnter,
    onEntered,
    onExit,
    onExited,
    onExiting,
    timeout: transitionDuration
  }, TransitionProps, {
    onEntering: (0,_utils_createChainedFunction__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A)(handleEntering, TransitionProps.onEntering)
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Paper__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    elevation,
    ref: handlePaperRef
  }, PaperProps, {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__["default"])(classes.paper, PaperProps.className)
  }), children)));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.Ay = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A)(styles, {
  name: "MuiPopover"
})(Popover));


/***/ }),

/***/ 4163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51971);
/* harmony import */ var _utils_setRef__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58094);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1863);







function getContainer(container) {
  container = typeof container === "function" ? container() : container;
  return react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(container);
}
var useEnhancedEffect = typeof window !== "undefined" ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
var Portal = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Portal2(props, ref) {
  var children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, onRendered = props.onRendered;
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(null), mountNode = _React$useState[0], setMountNode = _React$useState[1];
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(/* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children) ? children.ref : null, ref);
  useEnhancedEffect(function() {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(function() {
    if (mountNode && !disablePortal) {
      (0,_utils_setRef__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(ref, mountNode);
      return function() {
        (0,_utils_setRef__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(ref, null);
      };
    }
    return void 0;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect(function() {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);
  if (disablePortal) {
    if (/* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(children)) {
      return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
        ref: handleRef
      });
    }
    return children;
  }
  return mountNode ? /* @__PURE__ */ react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal(children, mountNode) : mountNode;
});
 false ? 0 : void 0;
if (false) // removed by dead control flow
{}
/* harmony default export */ __webpack_exports__.A = (Portal);


/***/ }),

/***/ 73815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Select_Select; }
});

// UNUSED EXPORTS: styles

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(89782);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/mergeClasses/mergeClasses.js
var mergeClasses = __webpack_require__(31185);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(72943);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(47421);
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(44998);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(94249);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(31719);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(33189);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(39021);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Menu/Menu.js
var Menu = __webpack_require__(12330);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputBase/utils.js
var utils = __webpack_require__(5850);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(1863);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(50842);
;// ./node_modules/@material-ui/core/esm/Select/SelectInput.js
















function areEqualValues(a, b) {
  if ((0,esm_typeof/* default */.A)(b) === "object" && b !== null) {
    return a === b;
  }
  return String(a) === String(b);
}
function isEmpty(display) {
  return display == null || typeof display === "string" && !display.trim();
}
var SelectInput = /* @__PURE__ */ index_js_eager_.forwardRef(function SelectInput2(props, ref) {
  var ariaLabel = props["aria-label"], autoFocus = props.autoFocus, autoWidth = props.autoWidth, children = props.children, classes = props.classes, className = props.className, defaultValue = props.defaultValue, disabled = props.disabled, displayEmpty = props.displayEmpty, IconComponent = props.IconComponent, inputRefProp = props.inputRef, labelId = props.labelId, _props$MenuProps = props.MenuProps, MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps, multiple = props.multiple, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onClose = props.onClose, onFocus = props.onFocus, onOpen = props.onOpen, openProp = props.open, readOnly = props.readOnly, renderValue = props.renderValue, _props$SelectDisplayP = props.SelectDisplayProps, SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP, tabIndexProp = props.tabIndex, type = props.type, valueProp = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);
  var _useControlled = (0,useControlled/* default */.A)({
    controlled: valueProp,
    default: defaultValue,
    name: "Select"
  }), _useControlled2 = (0,slicedToArray/* default */.A)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
  var inputRef = index_js_eager_.useRef(null);
  var _React$useState = index_js_eager_.useState(null), displayNode = _React$useState[0], setDisplayNode = _React$useState[1];
  var _React$useRef = index_js_eager_.useRef(openProp != null), isOpenControlled = _React$useRef.current;
  var _React$useState2 = index_js_eager_.useState(), menuMinWidthState = _React$useState2[0], setMenuMinWidthState = _React$useState2[1];
  var _React$useState3 = index_js_eager_.useState(false), openState = _React$useState3[0], setOpenState = _React$useState3[1];
  var handleRef = (0,useForkRef/* default */.A)(ref, inputRefProp);
  index_js_eager_.useImperativeHandle(handleRef, function() {
    return {
      focus: function focus() {
        displayNode.focus();
      },
      node: inputRef.current,
      value
    };
  }, [displayNode, value]);
  index_js_eager_.useEffect(function() {
    if (autoFocus && displayNode) {
      displayNode.focus();
    }
  }, [autoFocus, displayNode]);
  index_js_eager_.useEffect(function() {
    if (displayNode) {
      var label = (0,ownerDocument/* default */.A)(displayNode).getElementById(labelId);
      if (label) {
        var handler = function handler2() {
          if (getSelection().isCollapsed) {
            displayNode.focus();
          }
        };
        label.addEventListener("click", handler);
        return function() {
          label.removeEventListener("click", handler);
        };
      }
    }
    return void 0;
  }, [labelId, displayNode]);
  var update = function update2(open2, event) {
    if (open2) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }
    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open2);
    }
  };
  var handleMouseDown = function handleMouseDown2(event) {
    if (event.button !== 0) {
      return;
    }
    event.preventDefault();
    displayNode.focus();
    update(true, event);
  };
  var handleClose = function handleClose2(event) {
    update(false, event);
  };
  var childrenArray = index_js_eager_.Children.toArray(children);
  var handleChange = function handleChange2(event) {
    var index = childrenArray.map(function(child2) {
      return child2.props.value;
    }).indexOf(event.target.value);
    if (index === -1) {
      return;
    }
    var child = childrenArray[index];
    setValue(child.props.value);
    if (onChange) {
      onChange(event, child);
    }
  };
  var handleItemClick = function handleItemClick2(child) {
    return function(event) {
      if (!multiple) {
        update(false, event);
      }
      var newValue;
      if (multiple) {
        newValue = Array.isArray(value) ? value.slice() : [];
        var itemIndex = value.indexOf(child.props.value);
        if (itemIndex === -1) {
          newValue.push(child.props.value);
        } else {
          newValue.splice(itemIndex, 1);
        }
      } else {
        newValue = child.props.value;
      }
      if (child.props.onClick) {
        child.props.onClick(event);
      }
      if (value === newValue) {
        return;
      }
      setValue(newValue);
      if (onChange) {
        event.persist();
        Object.defineProperty(event, "target", {
          writable: true,
          value: {
            value: newValue,
            name
          }
        });
        onChange(event, child);
      }
    };
  };
  var handleKeyDown = function handleKeyDown2(event) {
    if (!readOnly) {
      var validKeys = [
        " ",
        "ArrowUp",
        "ArrowDown",
        // The native select doesn't respond to enter on MacOS, but it's recommended by
        // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
        "Enter"
      ];
      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };
  var open = displayNode !== null && (isOpenControlled ? openProp : openState);
  var handleBlur = function handleBlur2(event) {
    if (!open && onBlur) {
      event.persist();
      Object.defineProperty(event, "target", {
        writable: true,
        value: {
          value,
          name
        }
      });
      onBlur(event);
    }
  };
  delete other["aria-invalid"];
  var display;
  var displaySingle;
  var displayMultiple = [];
  var computeDisplay = false;
  var foundMatch = false;
  if ((0,utils/* isFilled */.lq)({
    value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }
  var items = childrenArray.map(function(child) {
    if (!/* @__PURE__ */ index_js_eager_.isValidElement(child)) {
      return null;
    }
    if (false) // removed by dead control flow
{}
    var selected;
    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.A)(2));
      }
      selected = value.some(function(v) {
        return areEqualValues(v, child.props.value);
      });
      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);
      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }
    if (selected) {
      foundMatch = true;
    }
    return /* @__PURE__ */ index_js_eager_.cloneElement(child, {
      "aria-selected": selected ? "true" : void 0,
      onClick: handleItemClick(child),
      onKeyUp: function onKeyUp(event) {
        if (event.key === " ") {
          event.preventDefault();
        }
        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: "option",
      selected,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": child.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  if (false) // removed by dead control flow
{}
  if (computeDisplay) {
    display = multiple ? displayMultiple.join(", ") : displaySingle;
  }
  var menuMinWidth = menuMinWidthState;
  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }
  var tabIndex;
  if (typeof tabIndexProp !== "undefined") {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }
  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : void 0);
  return /* @__PURE__ */ index_js_eager_.createElement(index_js_eager_.Fragment, null, /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(
      classes.root,
      // TODO v5: merge root and select
      classes.select,
      classes.selectMenu,
      classes[variant],
      className,
      disabled && classes.disabled
    ),
    ref: setDisplayNode,
    tabIndex,
    role: "button",
    "aria-disabled": disabled ? "true" : void 0,
    "aria-expanded": open ? "true" : void 0,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(" ") || void 0,
    onKeyDown: handleKeyDown,
    onMouseDown: disabled || readOnly ? null : handleMouseDown,
    onBlur: handleBlur,
    onFocus
  }, SelectDisplayProps, {
    // The id is required for proper a11y
    id: buttonId
  }), isEmpty(display) ? (
    // eslint-disable-next-line react/no-danger
    /* @__PURE__ */ index_js_eager_.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: "&#8203;"
      }
    })
  ) : display), /* @__PURE__ */ index_js_eager_.createElement("input", (0,esm_extends/* default */.A)({
    value: Array.isArray(value) ? value.join(",") : value,
    name,
    ref: inputRef,
    "aria-hidden": true,
    onChange: handleChange,
    tabIndex: -1,
    className: classes.nativeInput,
    autoFocus
  }, other)), /* @__PURE__ */ index_js_eager_.createElement(IconComponent, {
    className: (0,clsx_m["default"])(classes.icon, classes["icon".concat((0,capitalize/* default */.A)(variant))], open && classes.iconOpen, disabled && classes.disabled)
  }), /* @__PURE__ */ index_js_eager_.createElement(Menu/* default */.A, (0,esm_extends/* default */.A)({
    id: "menu-".concat(name || ""),
    anchorEl: displayNode,
    open,
    onClose: handleClose
  }, MenuProps, {
    MenuListProps: (0,esm_extends/* default */.A)({
      "aria-labelledby": labelId,
      role: "listbox",
      disableListWrap: true
    }, MenuProps.MenuListProps),
    PaperProps: (0,esm_extends/* default */.A)({}, MenuProps.PaperProps, {
      style: (0,esm_extends/* default */.A)({
        minWidth: menuMinWidth
      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
    })
  }), items));
});
 false ? 0 : void 0;
/* harmony default export */ var Select_SelectInput = (SelectInput);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/formControlState.js
var formControlState = __webpack_require__(26221);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/useFormControl.js
var useFormControl = __webpack_require__(72463);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(27503);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/internal/svg-icons/ArrowDropDown.js
var ArrowDropDown = __webpack_require__(91893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Input/Input.js
var Input = __webpack_require__(99266);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/NativeSelect/NativeSelect.js
var NativeSelect = __webpack_require__(10922);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/NativeSelect/NativeSelectInput.js
var NativeSelectInput = __webpack_require__(99108);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FilledInput/FilledInput.js
var FilledInput = __webpack_require__(29118);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/OutlinedInput/OutlinedInput.js + 1 modules
var OutlinedInput = __webpack_require__(28662);
;// ./node_modules/@material-ui/core/esm/Select/Select.js















var styles = NativeSelect/* styles */.R;
var _ref = /* @__PURE__ */ index_js_eager_.createElement(Input/* default */.A, null);
var _ref2 = /* @__PURE__ */ index_js_eager_.createElement(FilledInput/* default */.A, null);
var Select = /* @__PURE__ */ index_js_eager_.forwardRef(function Select2(props, ref) {
  var _props$autoWidth = props.autoWidth, autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth, children = props.children, classes = props.classes, _props$displayEmpty = props.displayEmpty, displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? ArrowDropDown/* default */.A : _props$IconComponent, id = props.id, input = props.input, inputProps = props.inputProps, label = props.label, labelId = props.labelId, _props$labelWidth = props.labelWidth, labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth, MenuProps = props.MenuProps, _props$multiple = props.multiple, multiple = _props$multiple === void 0 ? false : _props$multiple, _props$native = props.native, native = _props$native === void 0 ? false : _props$native, onClose = props.onClose, onOpen = props.onOpen, open = props.open, renderValue = props.renderValue, SelectDisplayProps = props.SelectDisplayProps, _props$variant = props.variant, variantProps = _props$variant === void 0 ? "standard" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);
  var inputComponent = native ? NativeSelectInput/* default */.A : Select_SelectInput;
  var muiFormControl = (0,useFormControl/* default */.A)();
  var fcs = (0,formControlState/* default */.A)({
    props,
    muiFormControl,
    states: ["variant"]
  });
  var variant = fcs.variant || variantProps;
  var InputComponent = input || {
    standard: _ref,
    outlined: /* @__PURE__ */ index_js_eager_.createElement(OutlinedInput/* default */.A, {
      label,
      labelWidth
    }),
    filled: _ref2
  }[variant];
  return /* @__PURE__ */ index_js_eager_.cloneElement(InputComponent, (0,esm_extends/* default */.A)({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent,
    inputProps: (0,esm_extends/* default */.A)({
      children,
      IconComponent,
      variant,
      type: void 0,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple
    }, native ? {
      id
    } : {
      autoWidth,
      displayEmpty,
      labelId,
      MenuProps,
      onClose,
      onOpen,
      open,
      renderValue,
      SelectDisplayProps: (0,esm_extends/* default */.A)({
        id
      }, SelectDisplayProps)
    }, inputProps, {
      classes: inputProps ? (0,mergeClasses/* default */.A)({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select2
      }) : classes
    }, input ? input.props.inputProps : {}),
    ref
  }, other));
});
 false ? 0 : void 0;
Select.muiName = "Select";
/* harmony default export */ var Select_Select = ((0,withStyles/* default */.A)(styles, {
  name: "MuiSelect"
})(Select));


/***/ }),

/***/ 97186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27503);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39021);








var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: "none",
      width: "1em",
      height: "1em",
      display: "inline-block",
      fill: "currentColor",
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create("fill", {
        duration: theme.transitions.duration.shorter
      })
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },
    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: "inherit"
    },
    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },
    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function SvgIcon2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "inherit" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "svg" : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? "medium" : _props$fontSize, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _props$viewBox = props.viewBox, viewBox = _props$viewBox === void 0 ? "0 0 24 24" : _props$viewBox, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, color !== "inherit" && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(color))], fontSize !== "default" && fontSize !== "medium" && classes["fontSize".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(fontSize))]),
    focusable: "false",
    viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? void 0 : true,
    role: titleAccess ? "img" : void 0,
    ref
  }, other), children, titleAccess ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("title", null, titleAccess) : null);
});
 false ? 0 : void 0;
SvgIcon.muiName = "SvgIcon";
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(styles, {
  name: "MuiSvgIcon"
})(SvgIcon));


/***/ }),

/***/ 62894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99266);
/* harmony import */ var _FilledInput__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29118);
/* harmony import */ var _OutlinedInput__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28662);
/* harmony import */ var _InputLabel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96900);
/* harmony import */ var _FormControl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1586);
/* harmony import */ var _FormHelperText__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95262);
/* harmony import */ var _Select__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(73815);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27503);















var variantComponent = {
  standard: _Input__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A,
  filled: _FilledInput__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A,
  outlined: _OutlinedInput__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .A
};
var styles = {
  /* Styles applied to the root element. */
  root: {}
};
var TextField = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function TextField2(props, ref) {
  var autoComplete = props.autoComplete, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, FormHelperTextProps = props.FormHelperTextProps, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, helperText = props.helperText, hiddenLabel = props.hiddenLabel, id = props.id, InputLabelProps = props.InputLabelProps, inputProps = props.inputProps, InputProps = props.InputProps, inputRef = props.inputRef, label = props.label, _props$multiline = props.multiline, multiline = _props$multiline === void 0 ? false : _props$multiline, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, placeholder = props.placeholder, _props$required = props.required, required = _props$required === void 0 ? false : _props$required, rows = props.rows, rowsMax = props.rowsMax, maxRows = props.maxRows, minRows = props.minRows, _props$select = props.select, select = _props$select === void 0 ? false : _props$select, SelectProps = props.SelectProps, type = props.type, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "maxRows", "minRows", "select", "SelectProps", "type", "value", "variant"]);
  if (false) // removed by dead control flow
{}
  var InputMore = {};
  if (variant === "outlined") {
    if (InputLabelProps && typeof InputLabelProps.shrink !== "undefined") {
      InputMore.notched = InputLabelProps.shrink;
    }
    if (label) {
      var _InputLabelProps$requ;
      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
      InputMore.label = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, label, displayRequired && "\xA0*");
    }
  }
  if (select) {
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = void 0;
    }
    InputMore["aria-describedby"] = void 0;
  }
  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : void 0;
  var inputLabelId = label && id ? "".concat(id, "-label") : void 0;
  var InputComponent = variantComponent[variant];
  var InputElement = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(InputComponent, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    "aria-describedby": helperTextId,
    autoComplete,
    autoFocus,
    defaultValue,
    fullWidth,
    multiline,
    name,
    rows,
    rowsMax,
    maxRows,
    minRows,
    type,
    value,
    id,
    inputRef,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    inputProps
  }, InputMore, InputProps));
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_FormControl__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className),
    disabled,
    error,
    fullWidth,
    hiddenLabel,
    ref,
    required,
    color,
    variant
  }, other), label && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_InputLabel__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    htmlFor: id,
    id: inputLabelId
  }, InputLabelProps), label), select ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_Select__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    "aria-describedby": helperTextId,
    id,
    labelId: inputLabelId,
    value,
    input: InputElement
  }, SelectProps), children) : InputElement, helperText && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(_FormHelperText__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    id: helperTextId
  }, FormHelperTextProps), helperText));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .A)(styles, {
  name: "MuiTextField"
})(TextField));


/***/ }),

/***/ 64916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35864);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1863);







function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}
var useEnhancedEffect = typeof window !== "undefined" ? react__WEBPACK_IMPORTED_MODULE_2__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_2__.useEffect;
var styles = {
  /* Styles applied to the shadow textarea element. */
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
var TextareaAutosize = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function TextareaAutosize2(props, ref) {
  var onChange = props.onChange, rows = props.rows, rowsMax = props.rowsMax, rowsMinProp = props.rowsMin, maxRowsProp = props.maxRows, _props$minRows = props.minRows, minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows, style = props.style, value = props.value, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["onChange", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "style", "value"]);
  var maxRows = maxRowsProp || rowsMax;
  var minRows = rows || rowsMinProp || minRowsProp;
  var _React$useRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(value != null), isControlled = _React$useRef.current;
  var inputRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(ref, inputRef);
  var shadowRef = react__WEBPACK_IMPORTED_MODULE_2__.useRef(null);
  var renders = react__WEBPACK_IMPORTED_MODULE_2__.useRef(0);
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_2__.useState({}), state = _React$useState[0], setState = _React$useState[1];
  var syncHeight = react__WEBPACK_IMPORTED_MODULE_2__.useCallback(function() {
    var input = inputRef.current;
    var computedStyle = window.getComputedStyle(input);
    var inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || "x";
    if (inputShallow.value.slice(-1) === "\n") {
      inputShallow.value += " ";
    }
    var boxSizing = computedStyle["box-sizing"];
    var padding = getStyleValue(computedStyle, "padding-bottom") + getStyleValue(computedStyle, "padding-top");
    var border = getStyleValue(computedStyle, "border-bottom-width") + getStyleValue(computedStyle, "border-top-width");
    var innerHeight = inputShallow.scrollHeight - padding;
    inputShallow.value = "x";
    var singleRowHeight = inputShallow.scrollHeight - padding;
    var outerHeight = innerHeight;
    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }
    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }
    outerHeight = Math.max(outerHeight, singleRowHeight);
    var outerHeightStyle = outerHeight + (boxSizing === "border-box" ? padding + border : 0);
    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(function(prevState) {
      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
        renders.current += 1;
        return {
          overflow,
          outerHeightStyle
        };
      }
      if (false) // removed by dead control flow
{}
      return prevState;
    });
  }, [maxRows, minRows, props.placeholder]);
  react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
    var handleResize = (0,_utils_debounce__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(function() {
      renders.current = 0;
      syncHeight();
    });
    window.addEventListener("resize", handleResize);
    return function() {
      handleResize.clear();
      window.removeEventListener("resize", handleResize);
    };
  }, [syncHeight]);
  useEnhancedEffect(function() {
    syncHeight();
  });
  react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
    renders.current = 0;
  }, [value]);
  var handleChange = function handleChange2(event) {
    renders.current = 0;
    if (!isControlled) {
      syncHeight();
    }
    if (onChange) {
      onChange(event);
    }
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("textarea", (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    value,
    onChange: handleChange,
    ref: handleRef,
    rows: minRows,
    style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
      height: state.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: state.overflow ? "hidden" : null
    }, style)
  }, other)), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement("textarea", {
    "aria-hidden": true,
    className: props.className,
    readOnly: true,
    ref: shadowRef,
    tabIndex: -1,
    style: (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, styles.shadow, style)
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = (TextareaAutosize);


/***/ }),

/***/ 30178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75054);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27503);







var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      display: "flex",
      alignItems: "center"
    },
    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: (0,_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.up("sm"), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),
    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,
    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};
var Toolbar = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.forwardRef(function Toolbar2(props, ref) {
  var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$variant = props.variant, variant = _props$variant === void 0 ? "regular" : _props$variant, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["classes", "className", "component", "disableGutters", "variant"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_3__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_4__["default"])(classes.root, classes[variant], className, !disableGutters && classes.gutters),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(styles, {
  name: "MuiToolbar"
})(Toolbar));


/***/ }),

/***/ 54346:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31719);
/* harmony import */ var _styles_withStyles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27503);
/* harmony import */ var _utils_capitalize__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39021);







var styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },
    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,
    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,
    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,
    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,
    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,
    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,
    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,
    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,
    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,
    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,
    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,
    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,
    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,
    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: "absolute",
      height: 1,
      width: 1,
      overflow: "hidden"
    },
    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: "left"
    },
    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: "center"
    },
    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: "right"
    },
    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: "justify"
    },
    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: "0.35em"
    },
    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },
    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },
    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: "inline"
    },
    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: "block"
    }
  };
};
var defaultVariantMapping = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p"
};
var Typography = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.forwardRef(function Typography2(props, ref) {
  var _props$align = props.align, align = _props$align === void 0 ? "inherit" : _props$align, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "initial" : _props$color, component = props.component, _props$display = props.display, display = _props$display === void 0 ? "initial" : _props$display, _props$gutterBottom = props.gutterBottom, gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom, _props$noWrap = props.noWrap, noWrap = _props$noWrap === void 0 ? false : _props$noWrap, _props$paragraph = props.paragraph, paragraph = _props$paragraph === void 0 ? false : _props$paragraph, _props$variant = props.variant, variant = _props$variant === void 0 ? "body1" : _props$variant, _props$variantMapping = props.variantMapping, variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);
  var Component = component || (paragraph ? "p" : variantMapping[variant] || defaultVariantMapping[variant]) || "span";
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(Component, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__["default"])(classes.root, className, variant !== "inherit" && classes[variant], color !== "initial" && classes["color".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== "inherit" && classes["align".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(align))], display !== "initial" && classes["display".concat((0,_utils_capitalize__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(display))]),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__.A = ((0,_styles_withStyles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(styles, {
  name: "MuiTypography"
})(Typography));


/***/ }),

/***/ 1568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51971);
/* harmony import */ var _utils_ownerDocument__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33189);
/* harmony import */ var _utils_useForkRef__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1863);






function Unstable_TrapFocus(props) {
  var children = props.children, _props$disableAutoFoc = props.disableAutoFocus, disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc, _props$disableEnforce = props.disableEnforceFocus, disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce, _props$disableRestore = props.disableRestoreFocus, disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore, getDoc = props.getDoc, isEnabled = props.isEnabled, open = props.open;
  var ignoreNextEnforceFocus = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  var sentinelStart = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var sentinelEnd = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var nodeToRestore = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  var rootRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
  var handleOwnRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(instance) {
    rootRef.current = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(instance);
  }, []);
  var handleRef = (0,_utils_useForkRef__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(children.ref, handleOwnRef);
  var prevOpenRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
    prevOpenRef.current = open;
  }, [open]);
  if (!prevOpenRef.current && open && typeof window !== "undefined") {
    nodeToRestore.current = getDoc().activeElement;
  }
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
    if (!open) {
      return;
    }
    var doc = (0,_utils_ownerDocument__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(rootRef.current);
    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute("tabIndex")) {
        if (false) // removed by dead control flow
{}
        rootRef.current.setAttribute("tabIndex", -1);
      }
      rootRef.current.focus();
    }
    var contain = function contain2() {
      var rootElement = rootRef.current;
      if (rootElement === null) {
        return;
      }
      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }
      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
        rootRef.current.focus();
      }
    };
    var loopFocus = function loopFocus2(event) {
      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
        return;
      }
      if (doc.activeElement === rootRef.current) {
        ignoreNextEnforceFocus.current = true;
        if (event.shiftKey) {
          sentinelEnd.current.focus();
        } else {
          sentinelStart.current.focus();
        }
      }
    };
    doc.addEventListener("focus", contain, true);
    doc.addEventListener("keydown", loopFocus, true);
    var interval = setInterval(function() {
      contain();
    }, 50);
    return function() {
      clearInterval(interval);
      doc.removeEventListener("focus", contain, true);
      doc.removeEventListener("keydown", loopFocus, true);
      if (!disableRestoreFocus) {
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          nodeToRestore.current.focus();
        }
        nodeToRestore.current = null;
      }
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    tabIndex: 0,
    ref: sentinelStart,
    "data-test": "sentinelStart"
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(children, {
    ref: handleRef
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    tabIndex: 0,
    ref: sentinelEnd,
    "data-test": "sentinelEnd"
  }));
}
 false ? 0 : void 0;
if (false) // removed by dead control flow
{}
/* harmony default export */ __webpack_exports__.A = (Unstable_TrapFocus);


/***/ }),

/***/ 95464:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var blue = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
};
/* harmony default export */ __webpack_exports__.A = (blue);


/***/ }),

/***/ 30346:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var brown = {
  50: "#efebe9",
  100: "#d7ccc8",
  200: "#bcaaa4",
  300: "#a1887f",
  400: "#8d6e63",
  500: "#795548",
  600: "#6d4c41",
  700: "#5d4037",
  800: "#4e342e",
  900: "#3e2723",
  A100: "#d7ccc8",
  A200: "#bcaaa4",
  A400: "#8d6e63",
  A700: "#5d4037"
};
/* harmony default export */ __webpack_exports__.A = (brown);


/***/ }),

/***/ 53977:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var common = {
  black: "#000",
  white: "#fff"
};
/* harmony default export */ __webpack_exports__.A = (common);


/***/ }),

/***/ 94616:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var deepPurple = {
  50: "#ede7f6",
  100: "#d1c4e9",
  200: "#b39ddb",
  300: "#9575cd",
  400: "#7e57c2",
  500: "#673ab7",
  600: "#5e35b1",
  700: "#512da8",
  800: "#4527a0",
  900: "#311b92",
  A100: "#b388ff",
  A200: "#7c4dff",
  A400: "#651fff",
  A700: "#6200ea"
};
/* harmony default export */ __webpack_exports__.A = (deepPurple);


/***/ }),

/***/ 61609:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var green = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
};
/* harmony default export */ __webpack_exports__.A = (green);


/***/ }),

/***/ 36343:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var grey = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#d5d5d5",
  A200: "#aaaaaa",
  A400: "#303030",
  A700: "#616161"
};
/* harmony default export */ __webpack_exports__.A = (grey);


/***/ }),

/***/ 60698:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var indigo = {
  50: "#e8eaf6",
  100: "#c5cae9",
  200: "#9fa8da",
  300: "#7986cb",
  400: "#5c6bc0",
  500: "#3f51b5",
  600: "#3949ab",
  700: "#303f9f",
  800: "#283593",
  900: "#1a237e",
  A100: "#8c9eff",
  A200: "#536dfe",
  A400: "#3d5afe",
  A700: "#304ffe"
};
/* harmony default export */ __webpack_exports__.A = (indigo);


/***/ }),

/***/ 88858:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var lightBlue = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
};
/* harmony default export */ __webpack_exports__.A = (lightBlue);


/***/ }),

/***/ 59343:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var lightGreen = {
  50: "#f1f8e9",
  100: "#dcedc8",
  200: "#c5e1a5",
  300: "#aed581",
  400: "#9ccc65",
  500: "#8bc34a",
  600: "#7cb342",
  700: "#689f38",
  800: "#558b2f",
  900: "#33691e",
  A100: "#ccff90",
  A200: "#b2ff59",
  A400: "#76ff03",
  A700: "#64dd17"
};
/* harmony default export */ __webpack_exports__.A = (lightGreen);


/***/ }),

/***/ 71494:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var orange = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
};
/* harmony default export */ __webpack_exports__.A = (orange);


/***/ }),

/***/ 52988:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var pink = {
  50: "#fce4ec",
  100: "#f8bbd0",
  200: "#f48fb1",
  300: "#f06292",
  400: "#ec407a",
  500: "#e91e63",
  600: "#d81b60",
  700: "#c2185b",
  800: "#ad1457",
  900: "#880e4f",
  A100: "#ff80ab",
  A200: "#ff4081",
  A400: "#f50057",
  A700: "#c51162"
};
/* harmony default export */ __webpack_exports__.A = (pink);


/***/ }),

/***/ 3566:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var purple = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
};
/* harmony default export */ __webpack_exports__.A = (purple);


/***/ }),

/***/ 99129:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var red = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
};
/* harmony default export */ __webpack_exports__.A = (red);


/***/ }),

/***/ 98514:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var teal = {
  50: "#e0f2f1",
  100: "#b2dfdb",
  200: "#80cbc4",
  300: "#4db6ac",
  400: "#26a69a",
  500: "#009688",
  600: "#00897b",
  700: "#00796b",
  800: "#00695c",
  900: "#004d40",
  A100: "#a7ffeb",
  A200: "#64ffda",
  A400: "#1de9b6",
  A700: "#00bfa5"
};
/* harmony default export */ __webpack_exports__.A = (teal);


/***/ }),

/***/ 82072:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var yellow = {
  50: "#fffde7",
  100: "#fff9c4",
  200: "#fff59d",
  300: "#fff176",
  400: "#ffee58",
  500: "#ffeb3b",
  600: "#fdd835",
  700: "#fbc02d",
  800: "#f9a825",
  900: "#f57f17",
  A100: "#ffff8d",
  A200: "#ffff00",
  A400: "#ffea00",
  A700: "#ffd600"
};
/* harmony default export */ __webpack_exports__.A = (yellow);


/***/ }),

/***/ 98227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Accordion: function() { return /* reexport */ Accordion_Accordion; },
  AccordionActions: function() { return /* reexport */ AccordionActions_AccordionActions; },
  AccordionDetails: function() { return /* reexport */ AccordionDetails_AccordionDetails; },
  AccordionSummary: function() { return /* reexport */ AccordionSummary_AccordionSummary; },
  AppBar: function() { return /* reexport */ AppBar_AppBar; },
  Avatar: function() { return /* reexport */ Avatar_Avatar; },
  Backdrop: function() { return /* reexport */ Backdrop/* default */.A; },
  Badge: function() { return /* reexport */ Badge_Badge; },
  BottomNavigation: function() { return /* reexport */ BottomNavigation_BottomNavigation; },
  BottomNavigationAction: function() { return /* reexport */ BottomNavigationAction_BottomNavigationAction; },
  Box: function() { return /* reexport */ Box/* default */.A; },
  Breadcrumbs: function() { return /* reexport */ Breadcrumbs_Breadcrumbs; },
  Button: function() { return /* reexport */ Button/* default */.A; },
  ButtonBase: function() { return /* reexport */ ButtonBase/* default */.A; },
  ButtonGroup: function() { return /* reexport */ ButtonGroup_ButtonGroup; },
  Card: function() { return /* reexport */ Card_Card; },
  CardActionArea: function() { return /* reexport */ CardActionArea_CardActionArea; },
  CardActions: function() { return /* reexport */ CardActions_CardActions; },
  CardContent: function() { return /* reexport */ CardContent_CardContent; },
  CardHeader: function() { return /* reexport */ CardHeader_CardHeader; },
  CardMedia: function() { return /* reexport */ CardMedia_CardMedia; },
  Checkbox: function() { return /* reexport */ Checkbox_Checkbox; },
  Chip: function() { return /* reexport */ Chip_Chip; },
  CircularProgress: function() { return /* reexport */ CircularProgress/* default */.A; },
  ClickAwayListener: function() { return /* reexport */ ClickAwayListener_ClickAwayListener; },
  Collapse: function() { return /* reexport */ Collapse_Collapse; },
  Container: function() { return /* reexport */ Container_Container; },
  CssBaseline: function() { return /* reexport */ CssBaseline_CssBaseline; },
  Dialog: function() { return /* reexport */ Dialog/* default */.A; },
  DialogActions: function() { return /* reexport */ DialogActions/* default */.A; },
  DialogContent: function() { return /* reexport */ DialogContent/* default */.A; },
  DialogContentText: function() { return /* reexport */ DialogContentText_DialogContentText; },
  DialogTitle: function() { return /* reexport */ DialogTitle_DialogTitle; },
  Divider: function() { return /* reexport */ Divider_Divider; },
  Drawer: function() { return /* reexport */ Drawer_Drawer; },
  ExpansionPanel: function() { return /* reexport */ ExpansionPanel_ExpansionPanel; },
  ExpansionPanelActions: function() { return /* reexport */ ExpansionPanelActions_ExpansionPanelActions; },
  ExpansionPanelDetails: function() { return /* reexport */ ExpansionPanelDetails_ExpansionPanelDetails; },
  ExpansionPanelSummary: function() { return /* reexport */ ExpansionPanelSummary_ExpansionPanelSummary; },
  Fab: function() { return /* reexport */ Fab_Fab; },
  Fade: function() { return /* reexport */ Fade/* default */.A; },
  FilledInput: function() { return /* reexport */ FilledInput/* default */.A; },
  FormControl: function() { return /* reexport */ FormControl/* default */.A; },
  FormControlLabel: function() { return /* reexport */ FormControlLabel_FormControlLabel; },
  FormGroup: function() { return /* reexport */ FormGroup_FormGroup; },
  FormHelperText: function() { return /* reexport */ FormHelperText/* default */.A; },
  FormLabel: function() { return /* reexport */ FormLabel/* default */.A; },
  Grid: function() { return /* reexport */ Grid_Grid; },
  GridList: function() { return /* reexport */ GridList_GridList; },
  GridListTile: function() { return /* reexport */ GridListTile_GridListTile; },
  GridListTileBar: function() { return /* reexport */ GridListTileBar_GridListTileBar; },
  Grow: function() { return /* reexport */ Grow/* default */.A; },
  Hidden: function() { return /* reexport */ Hidden_Hidden; },
  Icon: function() { return /* reexport */ Icon_Icon; },
  IconButton: function() { return /* reexport */ IconButton/* default */.A; },
  ImageList: function() { return /* reexport */ ImageList_ImageList; },
  ImageListItem: function() { return /* reexport */ ImageListItem_ImageListItem; },
  ImageListItemBar: function() { return /* reexport */ ImageListItemBar_ImageListItemBar; },
  Input: function() { return /* reexport */ Input/* default */.A; },
  InputAdornment: function() { return /* reexport */ InputAdornment/* default */.A; },
  InputBase: function() { return /* reexport */ InputBase/* default */.A; },
  InputLabel: function() { return /* reexport */ InputLabel/* default */.A; },
  LinearProgress: function() { return /* reexport */ LinearProgress/* default */.A; },
  Link: function() { return /* reexport */ Link_Link; },
  List: function() { return /* reexport */ List/* default */.A; },
  ListItem: function() { return /* reexport */ ListItem/* default */.A; },
  ListItemAvatar: function() { return /* reexport */ ListItemAvatar_ListItemAvatar; },
  ListItemIcon: function() { return /* reexport */ ListItemIcon_ListItemIcon; },
  ListItemSecondaryAction: function() { return /* reexport */ ListItemSecondaryAction_ListItemSecondaryAction; },
  ListItemText: function() { return /* reexport */ ListItemText_ListItemText; },
  ListSubheader: function() { return /* reexport */ ListSubheader_ListSubheader; },
  Menu: function() { return /* reexport */ Menu/* default */.A; },
  MenuItem: function() { return /* reexport */ MenuItem/* default */.A; },
  MenuList: function() { return /* reexport */ MenuList/* default */.A; },
  MobileStepper: function() { return /* reexport */ MobileStepper_MobileStepper; },
  Modal: function() { return /* reexport */ Modal/* default */.A; },
  ModalManager: function() { return /* reexport */ ModalManager/* default */.A; },
  MuiThemeProvider: function() { return /* reexport */ styles.MuiThemeProvider; },
  NativeSelect: function() { return /* reexport */ NativeSelect/* default */.A; },
  NoSsr: function() { return /* reexport */ NoSsr_NoSsr; },
  OutlinedInput: function() { return /* reexport */ OutlinedInput/* default */.A; },
  Paper: function() { return /* reexport */ Paper/* default */.A; },
  Popover: function() { return /* reexport */ Popover/* default */.Ay; },
  Popper: function() { return /* reexport */ esm_Popper_Popper; },
  Portal: function() { return /* reexport */ Portal/* default */.A; },
  Radio: function() { return /* reexport */ Radio_Radio; },
  RadioGroup: function() { return /* reexport */ RadioGroup_RadioGroup; },
  RootRef: function() { return /* reexport */ RootRef_RootRef; },
  Select: function() { return /* reexport */ Select/* default */.A; },
  ServerStyleSheets: function() { return /* reexport */ styles.ServerStyleSheets; },
  Slide: function() { return /* reexport */ Slide_Slide; },
  Slider: function() { return /* reexport */ Slider_Slider; },
  Snackbar: function() { return /* reexport */ Snackbar_Snackbar; },
  SnackbarContent: function() { return /* reexport */ SnackbarContent_SnackbarContent; },
  Step: function() { return /* reexport */ Step_Step; },
  StepButton: function() { return /* reexport */ StepButton_StepButton; },
  StepConnector: function() { return /* reexport */ StepConnector_StepConnector; },
  StepContent: function() { return /* reexport */ StepContent_StepContent; },
  StepIcon: function() { return /* reexport */ StepIcon_StepIcon; },
  StepLabel: function() { return /* reexport */ StepLabel_StepLabel; },
  Stepper: function() { return /* reexport */ Stepper_Stepper; },
  StylesProvider: function() { return /* reexport */ styles.StylesProvider; },
  SvgIcon: function() { return /* reexport */ SvgIcon/* default */.A; },
  SwipeableDrawer: function() { return /* reexport */ SwipeableDrawer_SwipeableDrawer; },
  Switch: function() { return /* reexport */ Switch_Switch; },
  Tab: function() { return /* reexport */ Tab_Tab; },
  TabScrollButton: function() { return /* reexport */ TabScrollButton_TabScrollButton; },
  Table: function() { return /* reexport */ Table_Table; },
  TableBody: function() { return /* reexport */ TableBody_TableBody; },
  TableCell: function() { return /* reexport */ TableCell_TableCell; },
  TableContainer: function() { return /* reexport */ TableContainer_TableContainer; },
  TableFooter: function() { return /* reexport */ TableFooter_TableFooter; },
  TableHead: function() { return /* reexport */ TableHead_TableHead; },
  TablePagination: function() { return /* reexport */ TablePagination_TablePagination; },
  TableRow: function() { return /* reexport */ TableRow_TableRow; },
  TableSortLabel: function() { return /* reexport */ TableSortLabel_TableSortLabel; },
  Tabs: function() { return /* reexport */ Tabs_Tabs; },
  TextField: function() { return /* reexport */ TextField/* default */.A; },
  TextareaAutosize: function() { return /* reexport */ TextareaAutosize/* default */.A; },
  ThemeProvider: function() { return /* reexport */ styles.ThemeProvider; },
  Toolbar: function() { return /* reexport */ Toolbar/* default */.A; },
  Tooltip: function() { return /* reexport */ Tooltip_Tooltip; },
  Typography: function() { return /* reexport */ Typography/* default */.A; },
  Unstable_TrapFocus: function() { return /* reexport */ Unstable_TrapFocus/* default */.A; },
  Zoom: function() { return /* reexport */ Zoom_Zoom; },
  alpha: function() { return /* reexport */ styles.alpha; },
  capitalize: function() { return /* reexport */ utils.capitalize; },
  colors: function() { return /* reexport */ colors_namespaceObject; },
  createChainedFunction: function() { return /* reexport */ utils.createChainedFunction; },
  createGenerateClassName: function() { return /* reexport */ styles.createGenerateClassName; },
  createMuiTheme: function() { return /* reexport */ styles.createMuiTheme; },
  createStyles: function() { return /* reexport */ styles.createStyles; },
  createSvgIcon: function() { return /* reexport */ utils.createSvgIcon; },
  createTheme: function() { return /* reexport */ styles.createTheme; },
  darken: function() { return /* reexport */ styles.darken; },
  debounce: function() { return /* reexport */ utils.debounce; },
  decomposeColor: function() { return /* reexport */ styles.decomposeColor; },
  deprecatedPropType: function() { return /* reexport */ utils.deprecatedPropType; },
  duration: function() { return /* reexport */ styles.duration; },
  easing: function() { return /* reexport */ styles.easing; },
  emphasize: function() { return /* reexport */ styles.emphasize; },
  fade: function() { return /* reexport */ styles.fade; },
  getContrastRatio: function() { return /* reexport */ styles.getContrastRatio; },
  getLuminance: function() { return /* reexport */ styles.getLuminance; },
  hexToRgb: function() { return /* reexport */ styles.hexToRgb; },
  hslToRgb: function() { return /* reexport */ styles.hslToRgb; },
  isMuiElement: function() { return /* reexport */ utils.isMuiElement; },
  isWidthDown: function() { return /* reexport */ isWidthDown; },
  isWidthUp: function() { return /* reexport */ isWidthUp; },
  jssPreset: function() { return /* reexport */ styles.jssPreset; },
  lighten: function() { return /* reexport */ styles.lighten; },
  makeStyles: function() { return /* reexport */ styles.makeStyles; },
  ownerDocument: function() { return /* reexport */ utils.ownerDocument; },
  ownerWindow: function() { return /* reexport */ utils.ownerWindow; },
  recomposeColor: function() { return /* reexport */ styles.recomposeColor; },
  requirePropFactory: function() { return /* reexport */ utils.requirePropFactory; },
  responsiveFontSizes: function() { return /* reexport */ styles.responsiveFontSizes; },
  rgbToHex: function() { return /* reexport */ styles.rgbToHex; },
  setRef: function() { return /* reexport */ utils.setRef; },
  styleFunction: function() { return /* reexport */ Box/* styleFunction */.E; },
  styled: function() { return /* reexport */ styles.styled; },
  unstable_createMuiStrictModeTheme: function() { return /* reexport */ styles.unstable_createMuiStrictModeTheme; },
  unstable_useId: function() { return /* reexport */ utils.unstable_useId; },
  unsupportedProp: function() { return /* reexport */ utils.unsupportedProp; },
  useControlled: function() { return /* reexport */ utils.useControlled; },
  useEventCallback: function() { return /* reexport */ utils.useEventCallback; },
  useForkRef: function() { return /* reexport */ utils.useForkRef; },
  useFormControl: function() { return /* reexport */ useFormControl/* default */.A; },
  useIsFocusVisible: function() { return /* reexport */ utils.useIsFocusVisible; },
  useMediaQuery: function() { return /* reexport */ useMediaQuery; },
  useRadioGroup: function() { return /* reexport */ useRadioGroup; },
  useScrollTrigger: function() { return /* reexport */ useScrollTrigger; },
  useTheme: function() { return /* reexport */ styles.useTheme; },
  withMobileDialog: function() { return /* reexport */ withMobileDialog_withMobileDialog; },
  withStyles: function() { return /* reexport */ styles.withStyles; },
  withTheme: function() { return /* reexport */ styles.withTheme; },
  withWidth: function() { return /* reexport */ withWidth_withWidth; }
});

// NAMESPACE OBJECT: ./node_modules/@material-ui/core/esm/colors/index.js
var colors_namespaceObject = {};
__webpack_require__.r(colors_namespaceObject);
__webpack_require__.d(colors_namespaceObject, {
  amber: function() { return colors_amber; },
  blue: function() { return blue/* default */.A; },
  blueGrey: function() { return colors_blueGrey; },
  brown: function() { return brown/* default */.A; },
  common: function() { return common/* default */.A; },
  cyan: function() { return colors_cyan; },
  deepOrange: function() { return colors_deepOrange; },
  deepPurple: function() { return deepPurple/* default */.A; },
  green: function() { return green/* default */.A; },
  grey: function() { return grey/* default */.A; },
  indigo: function() { return indigo/* default */.A; },
  lightBlue: function() { return lightBlue/* default */.A; },
  lightGreen: function() { return lightGreen/* default */.A; },
  lime: function() { return colors_lime; },
  orange: function() { return orange/* default */.A; },
  pink: function() { return pink/* default */.A; },
  purple: function() { return purple/* default */.A; },
  red: function() { return red/* default */.A; },
  teal: function() { return teal/* default */.A; },
  yellow: function() { return yellow/* default */.A; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/common.js
var common = __webpack_require__(53977);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/red.js
var red = __webpack_require__(99129);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/pink.js
var pink = __webpack_require__(52988);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/purple.js
var purple = __webpack_require__(3566);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/deepPurple.js
var deepPurple = __webpack_require__(94616);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/indigo.js
var indigo = __webpack_require__(60698);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/blue.js
var blue = __webpack_require__(95464);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/lightBlue.js
var lightBlue = __webpack_require__(88858);
;// ./node_modules/@material-ui/core/esm/colors/cyan.js
var cyan = {
  50: "#e0f7fa",
  100: "#b2ebf2",
  200: "#80deea",
  300: "#4dd0e1",
  400: "#26c6da",
  500: "#00bcd4",
  600: "#00acc1",
  700: "#0097a7",
  800: "#00838f",
  900: "#006064",
  A100: "#84ffff",
  A200: "#18ffff",
  A400: "#00e5ff",
  A700: "#00b8d4"
};
/* harmony default export */ var colors_cyan = (cyan);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/teal.js
var teal = __webpack_require__(98514);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/green.js
var green = __webpack_require__(61609);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/lightGreen.js
var lightGreen = __webpack_require__(59343);
;// ./node_modules/@material-ui/core/esm/colors/lime.js
var lime = {
  50: "#f9fbe7",
  100: "#f0f4c3",
  200: "#e6ee9c",
  300: "#dce775",
  400: "#d4e157",
  500: "#cddc39",
  600: "#c0ca33",
  700: "#afb42b",
  800: "#9e9d24",
  900: "#827717",
  A100: "#f4ff81",
  A200: "#eeff41",
  A400: "#c6ff00",
  A700: "#aeea00"
};
/* harmony default export */ var colors_lime = (lime);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/yellow.js
var yellow = __webpack_require__(82072);
;// ./node_modules/@material-ui/core/esm/colors/amber.js
var amber = {
  50: "#fff8e1",
  100: "#ffecb3",
  200: "#ffe082",
  300: "#ffd54f",
  400: "#ffca28",
  500: "#ffc107",
  600: "#ffb300",
  700: "#ffa000",
  800: "#ff8f00",
  900: "#ff6f00",
  A100: "#ffe57f",
  A200: "#ffd740",
  A400: "#ffc400",
  A700: "#ffab00"
};
/* harmony default export */ var colors_amber = (amber);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/orange.js
var orange = __webpack_require__(71494);
;// ./node_modules/@material-ui/core/esm/colors/deepOrange.js
var deepOrange = {
  50: "#fbe9e7",
  100: "#ffccbc",
  200: "#ffab91",
  300: "#ff8a65",
  400: "#ff7043",
  500: "#ff5722",
  600: "#f4511e",
  700: "#e64a19",
  800: "#d84315",
  900: "#bf360c",
  A100: "#ff9e80",
  A200: "#ff6e40",
  A400: "#ff3d00",
  A700: "#dd2c00"
};
/* harmony default export */ var colors_deepOrange = (deepOrange);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/brown.js
var brown = __webpack_require__(30346);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/grey.js
var grey = __webpack_require__(36343);
;// ./node_modules/@material-ui/core/esm/colors/blueGrey.js
var blueGrey = {
  50: "#eceff1",
  100: "#cfd8dc",
  200: "#b0bec5",
  300: "#90a4ae",
  400: "#78909c",
  500: "#607d8b",
  600: "#546e7a",
  700: "#455a64",
  800: "#37474f",
  900: "#263238",
  A100: "#cfd8dc",
  A200: "#b0bec5",
  A400: "#78909c",
  A700: "#455a64"
};
/* harmony default export */ var colors_blueGrey = (blueGrey);

;// ./node_modules/@material-ui/core/esm/colors/index.js





















// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/index.js + 7 modules
var styles = __webpack_require__(52234);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/index.js + 3 modules
var utils = __webpack_require__(80040);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
var arrayWithHoles = __webpack_require__(47924);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
var iterableToArray = __webpack_require__(79290);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(14477);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
var nonIterableRest = __webpack_require__(46529);
;// ./node_modules/@babel/runtime/helpers/esm/toArray.js




function _toArray(r) {
  return (0,arrayWithHoles/* default */.A)(r) || (0,iterableToArray/* default */.A)(r) || (0,unsupportedIterableToArray/* default */.A)(r) || (0,nonIterableRest/* default */.A)();
}


// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(72943);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(89782);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(94249);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(31719);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/Transition.js + 1 modules
var Transition = __webpack_require__(51052);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(27503);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/transitions.js
var transitions = __webpack_require__(58268);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/transitions/utils.js
var transitions_utils = __webpack_require__(56571);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(9022);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(1863);
;// ./node_modules/@material-ui/core/esm/Collapse/Collapse.js














var Collapse_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 0,
      overflow: "hidden",
      transition: theme.transitions.create("height")
    },
    /* Styles applied to the root element when the transition has entered. */
    entered: {
      height: "auto",
      overflow: "visible"
    },
    /* Styles applied to the root element when the transition has exited and `collapsedSize` != 0px. */
    hidden: {
      visibility: "hidden"
    },
    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: "flex"
    },
    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: "100%"
    }
  };
};
var Collapse = /* @__PURE__ */ index_js_eager_.forwardRef(function Collapse2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, collapsedHeight = props.collapsedHeight, _props$collapsedSize = props.collapsedSize, collapsedSizeProp = _props$collapsedSize === void 0 ? "0px" : _props$collapsedSize, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? transitions/* duration */.p0.standard : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? Transition/* default */.Ay : _props$TransitionComp, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "collapsedHeight", "collapsedSize", "component", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
  var theme = (0,useTheme/* default */.A)();
  var timer = index_js_eager_.useRef();
  var wrapperRef = index_js_eager_.useRef(null);
  var autoTransitionDuration = index_js_eager_.useRef();
  var collapsedSize = typeof (collapsedHeight || collapsedSizeProp) === "number" ? "".concat(collapsedHeight || collapsedSizeProp, "px") : collapsedHeight || collapsedSizeProp;
  index_js_eager_.useEffect(function() {
    return function() {
      clearTimeout(timer.current);
    };
  }, []);
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = index_js_eager_.useRef(null);
  var handleRef = (0,useForkRef/* default */.A)(ref, enableStrictModeCompat ? nodeRef : void 0);
  var normalizedTransitionCallback = function normalizedTransitionCallback2(callback) {
    return function(nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing], _ref2 = (0,slicedToArray/* default */.A)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1];
        if (isAppearing === void 0) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };
  var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
    node.style.height = collapsedSize;
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    var _getTransitionProps = (0,transitions_utils/* getTransitionProps */.c)({
      style,
      timeout
    }, {
      mode: "enter"
    }), transitionDuration = _getTransitionProps.duration;
    if (timeout === "auto") {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : "".concat(transitionDuration, "ms");
    }
    node.style.height = "".concat(wrapperHeight, "px");
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(function(node, isAppearing) {
    node.style.height = "auto";
    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  var handleExit = normalizedTransitionCallback(function(node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    node.style.height = "".concat(wrapperHeight, "px");
    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  var handleExiting = normalizedTransitionCallback(function(node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    var _getTransitionProps2 = (0,transitions_utils/* getTransitionProps */.c)({
      style,
      timeout
    }, {
      mode: "exit"
    }), transitionDuration = _getTransitionProps2.duration;
    if (timeout === "auto") {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === "string" ? transitionDuration : "".concat(transitionDuration, "ms");
    }
    node.style.height = collapsedSize;
    if (onExiting) {
      onExiting(node);
    }
  });
  var addEndListener = function addEndListener2(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;
    if (timeout === "auto") {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }
  };
  return /* @__PURE__ */ index_js_eager_.createElement(TransitionComponent, (0,esm_extends/* default */.A)({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener,
    nodeRef: enableStrictModeCompat ? nodeRef : void 0,
    timeout: timeout === "auto" ? null : timeout
  }, other), function(state, childProps) {
    return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
      className: (0,clsx_m["default"])(classes.root, classes.container, className, {
        "entered": classes.entered,
        "exited": !inProp && collapsedSize === "0px" && classes.hidden
      }[state]),
      style: (0,esm_extends/* default */.A)({
        minHeight: collapsedSize
      }, style),
      ref: handleRef
    }, childProps), /* @__PURE__ */ index_js_eager_.createElement("div", {
      className: classes.wrapper,
      ref: wrapperRef
    }, /* @__PURE__ */ index_js_eager_.createElement("div", {
      className: classes.wrapperInner
    }, children)));
  });
});
 false ? 0 : void 0;
Collapse.muiSupportAuto = true;
/* harmony default export */ var Collapse_Collapse = ((0,withStyles/* default */.A)(Collapse_styles, {
  name: "MuiCollapse"
})(Collapse));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Paper/Paper.js
var Paper = __webpack_require__(1526);
;// ./node_modules/@material-ui/core/esm/Accordion/AccordionContext.js

var AccordionContext = index_js_eager_.createContext({});
if (false) // removed by dead control flow
{}
/* harmony default export */ var Accordion_AccordionContext = (AccordionContext);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(50842);
;// ./node_modules/@material-ui/core/esm/Accordion/Accordion.js














var Accordion_styles = function styles2(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      transition: theme.transitions.create(["margin"], transition),
      "&:before": {
        position: "absolute",
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(["opacity", "background-color"], transition)
      },
      "&:first-child": {
        "&:before": {
          display: "none"
        }
      },
      "&$expanded": {
        margin: "16px 0",
        "&:first-child": {
          marginTop: 0
        },
        "&:last-child": {
          marginBottom: 0
        },
        "&:before": {
          opacity: 0
        }
      },
      "&$expanded + &": {
        "&:before": {
          display: "none"
        }
      },
      "&$disabled": {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },
    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      "&:first-child": {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      "&:last-child": {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },
    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
};
var Accordion = /* @__PURE__ */ index_js_eager_.forwardRef(function Accordion2(props, ref) {
  var childrenProp = props.children, classes = props.classes, className = props.className, _props$defaultExpande = props.defaultExpanded, defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, expandedProp = props.expanded, onChange = props.onChange, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? Collapse_Collapse : _props$TransitionComp, TransitionProps = props.TransitionProps, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);
  var _useControlled = (0,useControlled/* default */.A)({
    controlled: expandedProp,
    default: defaultExpanded,
    name: "Accordion",
    state: "expanded"
  }), _useControlled2 = (0,slicedToArray/* default */.A)(_useControlled, 2), expanded = _useControlled2[0], setExpandedState = _useControlled2[1];
  var handleChange = index_js_eager_.useCallback(function(event) {
    setExpandedState(!expanded);
    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);
  var _React$Children$toArr = index_js_eager_.Children.toArray(childrenProp), _React$Children$toArr2 = _toArray(_React$Children$toArr), summary = _React$Children$toArr2[0], children = _React$Children$toArr2.slice(1);
  var contextValue = index_js_eager_.useMemo(function() {
    return {
      expanded,
      disabled,
      toggle: handleChange
    };
  }, [expanded, disabled, handleChange]);
  return /* @__PURE__ */ index_js_eager_.createElement(Paper/* default */.A, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
    ref,
    square
  }, other), /* @__PURE__ */ index_js_eager_.createElement(Accordion_AccordionContext.Provider, {
    value: contextValue
  }, summary), /* @__PURE__ */ index_js_eager_.createElement(TransitionComponent, (0,esm_extends/* default */.A)({
    in: expanded,
    timeout: "auto"
  }, TransitionProps), /* @__PURE__ */ index_js_eager_.createElement("div", {
    "aria-labelledby": summary.props.id,
    id: summary.props["aria-controls"],
    role: "region"
  }, children)));
});
 false ? 0 : void 0;
/* harmony default export */ var Accordion_Accordion = ((0,withStyles/* default */.A)(Accordion_styles, {
  name: "MuiAccordion"
})(Accordion));

;// ./node_modules/@material-ui/core/esm/AccordionActions/AccordionActions.js






var AccordionActions_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    alignItems: "center",
    padding: 8,
    justifyContent: "flex-end"
  },
  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    "& > :not(:first-child)": {
      marginLeft: 8
    }
  }
};
var AccordionActions = /* @__PURE__ */ index_js_eager_.forwardRef(function AccordionActions2(props, ref) {
  var classes = props.classes, className = props.className, _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "disableSpacing"]);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, !disableSpacing && classes.spacing),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var AccordionActions_AccordionActions = ((0,withStyles/* default */.A)(AccordionActions_styles, {
  name: "MuiAccordionActions"
})(AccordionActions));

;// ./node_modules/@material-ui/core/esm/AccordionDetails/AccordionDetails.js






var AccordionDetails_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "flex",
      padding: theme.spacing(1, 2, 2)
    }
  };
};
var AccordionDetails = /* @__PURE__ */ index_js_eager_.forwardRef(function AccordionDetails2(props, ref) {
  var classes = props.classes, className = props.className, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className"]);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var AccordionDetails_AccordionDetails = ((0,withStyles/* default */.A)(AccordionDetails_styles, {
  name: "MuiAccordionDetails"
})(AccordionDetails));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(44963);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(24022);
;// ./node_modules/@material-ui/core/esm/AccordionSummary/AccordionSummary.js










var AccordionSummary_styles = function styles2(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: "flex",
      minHeight: 8 * 6,
      transition: theme.transitions.create(["min-height", "background-color"], transition),
      padding: theme.spacing(0, 2),
      "&:hover:not($disabled)": {
        cursor: "pointer"
      },
      "&$expanded": {
        minHeight: 64
      },
      "&$focused, &$focusVisible": {
        backgroundColor: theme.palette.action.focus
      },
      "&$disabled": {
        opacity: theme.palette.action.disabledOpacity
      }
    },
    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},
    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focused: {},
    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the children wrapper element. */
    content: {
      display: "flex",
      flexGrow: 1,
      transition: theme.transitions.create(["margin"], transition),
      margin: "12px 0",
      "&$expanded": {
        margin: "20px 0"
      }
    },
    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: "rotate(0deg)",
      transition: theme.transitions.create("transform", transition),
      "&:hover": {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: "transparent"
      },
      "&$expanded": {
        transform: "rotate(180deg)"
      }
    }
  };
};
var AccordionSummary = /* @__PURE__ */ index_js_eager_.forwardRef(function AccordionSummary2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, expandIcon = props.expandIcon, focusVisibleClassName = props.focusVisibleClassName, _props$IconButtonProp = props.IconButtonProps, IconButtonProps = _props$IconButtonProp === void 0 ? {} : _props$IconButtonProp, onClick = props.onClick, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "expandIcon", "focusVisibleClassName", "IconButtonProps", "onClick"]);
  var _React$useContext = index_js_eager_.useContext(Accordion_AccordionContext), _React$useContext$dis = _React$useContext.disabled, disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis, expanded = _React$useContext.expanded, toggle = _React$useContext.toggle;
  var handleChange = function handleChange2(event) {
    if (toggle) {
      toggle(event);
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /* @__PURE__ */ index_js_eager_.createElement(ButtonBase/* default */.A, (0,esm_extends/* default */.A)({
    focusRipple: false,
    disableRipple: true,
    disabled,
    component: "div",
    "aria-expanded": expanded,
    className: (0,clsx_m["default"])(classes.root, className, disabled && classes.disabled, expanded && classes.expanded),
    focusVisibleClassName: (0,clsx_m["default"])(classes.focusVisible, classes.focused, focusVisibleClassName),
    onClick: handleChange,
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: (0,clsx_m["default"])(classes.content, expanded && classes.expanded)
  }, children), expandIcon && /* @__PURE__ */ index_js_eager_.createElement(IconButton/* default */.A, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
 false ? 0 : void 0;
/* harmony default export */ var AccordionSummary_AccordionSummary = ((0,withStyles/* default */.A)(AccordionSummary_styles, {
  name: "MuiAccordionSummary"
})(AccordionSummary));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(39021);
;// ./node_modules/@material-ui/core/esm/AppBar/AppBar.js








var AppBar_styles = function styles2(theme) {
  var backgroundColorDefault = theme.palette.type === "light" ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    /* Styles applied to the root element. */
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      boxSizing: "border-box",
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },
    /* Styles applied to the root element if `position="fixed"`. */
    positionFixed: {
      position: "fixed",
      top: 0,
      left: "auto",
      right: 0,
      "@media print": {
        // Prevent the app bar to be visible on each printed page.
        position: "absolute"
      }
    },
    /* Styles applied to the root element if `position="absolute"`. */
    positionAbsolute: {
      position: "absolute",
      top: 0,
      left: "auto",
      right: 0
    },
    /* Styles applied to the root element if `position="sticky"`. */
    positionSticky: {
      // ⚠️ sticky is not supported by IE 11.
      position: "sticky",
      top: 0,
      left: "auto",
      right: 0
    },
    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {
      position: "static"
    },
    /* Styles applied to the root element if `position="relative"`. */
    positionRelative: {
      position: "relative"
    },
    /* Styles applied to the root element if `color="default"`. */
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the root element if `color="transparent"`. */
    colorTransparent: {
      backgroundColor: "transparent",
      color: "inherit"
    }
  };
};
var AppBar = /* @__PURE__ */ index_js_eager_.forwardRef(function AppBar2(props, ref) {
  var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$position = props.position, position = _props$position === void 0 ? "fixed" : _props$position, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "color", "position"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Paper/* default */.A, (0,esm_extends/* default */.A)({
    square: true,
    component: "header",
    elevation: 4,
    className: (0,clsx_m["default"])(classes.root, classes["position".concat((0,capitalize/* default */.A)(position))], classes["color".concat((0,capitalize/* default */.A)(color))], className, position === "fixed" && "mui-fixed"),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var AppBar_AppBar = ((0,withStyles/* default */.A)(AppBar_styles, {
  name: "MuiAppBar"
})(AppBar));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(80868);
;// ./node_modules/@material-ui/core/esm/internal/svg-icons/Person.js


/* harmony default export */ var Person = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person"));

;// ./node_modules/@material-ui/core/esm/Avatar/Avatar.js








var Avatar_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      width: 40,
      height: 40,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      lineHeight: 1,
      borderRadius: "50%",
      overflow: "hidden",
      userSelect: "none"
    },
    /* Styles applied to the root element if not `src` or `srcSet`. */
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.type === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
    },
    /* Styles applied to the root element if `variant="circle"`. */
    circle: {},
    /* Styles applied to the root element if `variant="circular"`. */
    circular: {},
    /* Styles applied to the root element if `variant="rounded"`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },
    /* Styles applied to the root element if `variant="square"`. */
    square: {
      borderRadius: 0
    },
    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
    img: {
      width: "100%",
      height: "100%",
      textAlign: "center",
      // Handle non-square image. The property isn't supported by IE 11.
      objectFit: "cover",
      // Hide alt text.
      color: "transparent",
      // Hide the image broken icon, only works on Chrome.
      textIndent: 1e4
    },
    /* Styles applied to the fallback icon */
    fallback: {
      width: "75%",
      height: "75%"
    }
  };
};
function useLoaded(_ref) {
  var src = _ref.src, srcSet = _ref.srcSet;
  var _React$useState = index_js_eager_.useState(false), loaded = _React$useState[0], setLoaded = _React$useState[1];
  index_js_eager_.useEffect(function() {
    if (!src && !srcSet) {
      return void 0;
    }
    setLoaded(false);
    var active = true;
    var image = new Image();
    image.src = src;
    image.srcSet = srcSet;
    image.onload = function() {
      if (!active) {
        return;
      }
      setLoaded("loaded");
    };
    image.onerror = function() {
      if (!active) {
        return;
      }
      setLoaded("error");
    };
    return function() {
      active = false;
    };
  }, [src, srcSet]);
  return loaded;
}
var Avatar = /* @__PURE__ */ index_js_eager_.forwardRef(function Avatar2(props, ref) {
  var alt = props.alt, childrenProp = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, imgProps = props.imgProps, sizes = props.sizes, src = props.src, srcSet = props.srcSet, _props$variant = props.variant, variant = _props$variant === void 0 ? "circular" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["alt", "children", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"]);
  var children = null;
  var loaded = useLoaded({
    src,
    srcSet
  });
  var hasImg = src || srcSet;
  var hasImgNotFailing = hasImg && loaded !== "error";
  if (hasImgNotFailing) {
    children = /* @__PURE__ */ index_js_eager_.createElement("img", (0,esm_extends/* default */.A)({
      alt,
      src,
      srcSet,
      sizes,
      className: classes.img
    }, imgProps));
  } else if (childrenProp != null) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = /* @__PURE__ */ index_js_eager_.createElement(Person, {
      className: classes.fallback
    });
  }
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
    ref
  }, other), children);
});
 false ? 0 : void 0;
/* harmony default export */ var Avatar_Avatar = ((0,withStyles/* default */.A)(Avatar_styles, {
  name: "MuiAvatar"
})(Avatar));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Backdrop/Backdrop.js
var Backdrop = __webpack_require__(6036);
;// ./node_modules/@material-ui/core/esm/Badge/Badge.js









var RADIUS_STANDARD = 10;
var RADIUS_DOT = 4;
var Badge_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      display: "inline-flex",
      // For correct alignment with the text.
      verticalAlign: "middle",
      flexShrink: 0
    },
    /* Styles applied to the badge `span` element. */
    badge: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      alignContent: "center",
      alignItems: "center",
      position: "absolute",
      boxSizing: "border-box",
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(12),
      minWidth: RADIUS_STANDARD * 2,
      lineHeight: 1,
      padding: "0 6px",
      height: RADIUS_STANDARD * 2,
      borderRadius: RADIUS_STANDARD,
      zIndex: 1,
      // Render the badge on top of potential ripples.
      transition: theme.transitions.create("transform", {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen
      })
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },
    /* Styles applied to the root element if `variant="dot"`. */
    dot: {
      borderRadius: RADIUS_DOT,
      height: RADIUS_DOT * 2,
      minWidth: RADIUS_DOT * 2,
      padding: 0
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */
    anchorOriginTopRightRectangle: {
      top: 0,
      right: 0,
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      "&$invisible": {
        transform: "scale(0) translate(50%, -50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangular"`. */
    anchorOriginTopRightRectangular: {
      top: 0,
      right: 0,
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      "&$invisible": {
        transform: "scale(0) translate(50%, -50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */
    anchorOriginBottomRightRectangle: {
      bottom: 0,
      right: 0,
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      "&$invisible": {
        transform: "scale(0) translate(50%, 50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangular"`. */
    anchorOriginBottomRightRectangular: {
      bottom: 0,
      right: 0,
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      "&$invisible": {
        transform: "scale(0) translate(50%, 50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */
    anchorOriginTopLeftRectangle: {
      top: 0,
      left: 0,
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      "&$invisible": {
        transform: "scale(0) translate(-50%, -50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangular"`. */
    anchorOriginTopLeftRectangular: {
      top: 0,
      left: 0,
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      "&$invisible": {
        transform: "scale(0) translate(-50%, -50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */
    anchorOriginBottomLeftRectangle: {
      bottom: 0,
      left: 0,
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      "&$invisible": {
        transform: "scale(0) translate(-50%, 50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangular"`. */
    anchorOriginBottomLeftRectangular: {
      bottom: 0,
      left: 0,
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      "&$invisible": {
        transform: "scale(0) translate(-50%, 50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */
    anchorOriginTopRightCircle: {
      top: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      "&$invisible": {
        transform: "scale(0) translate(50%, -50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circular"`. */
    anchorOriginTopRightCircular: {
      top: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, -50%)",
      transformOrigin: "100% 0%",
      "&$invisible": {
        transform: "scale(0) translate(50%, -50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */
    anchorOriginBottomRightCircle: {
      bottom: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      "&$invisible": {
        transform: "scale(0) translate(50%, 50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circular"`. */
    anchorOriginBottomRightCircular: {
      bottom: "14%",
      right: "14%",
      transform: "scale(1) translate(50%, 50%)",
      transformOrigin: "100% 100%",
      "&$invisible": {
        transform: "scale(0) translate(50%, 50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */
    anchorOriginTopLeftCircle: {
      top: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      "&$invisible": {
        transform: "scale(0) translate(-50%, -50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circular"`. */
    anchorOriginTopLeftCircular: {
      top: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, -50%)",
      transformOrigin: "0% 0%",
      "&$invisible": {
        transform: "scale(0) translate(-50%, -50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */
    anchorOriginBottomLeftCircle: {
      bottom: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      "&$invisible": {
        transform: "scale(0) translate(-50%, 50%)"
      }
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circular"`. */
    anchorOriginBottomLeftCircular: {
      bottom: "14%",
      left: "14%",
      transform: "scale(1) translate(-50%, 50%)",
      transformOrigin: "0% 100%",
      "&$invisible": {
        transform: "scale(0) translate(-50%, 50%)"
      }
    },
    /* Pseudo-class to the badge `span` element if `invisible={true}`. */
    invisible: {
      transition: theme.transitions.create("transform", {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.leavingScreen
      })
    }
  };
};
var Badge = /* @__PURE__ */ index_js_eager_.forwardRef(function Badge2(props, ref) {
  var _props$anchorOrigin = props.anchorOrigin, anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: "top",
    horizontal: "right"
  } : _props$anchorOrigin, badgeContent = props.badgeContent, children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, ComponentProp = _props$component === void 0 ? "span" : _props$component, invisibleProp = props.invisible, _props$max = props.max, max = _props$max === void 0 ? 99 : _props$max, _props$overlap = props.overlap, overlap = _props$overlap === void 0 ? "rectangle" : _props$overlap, _props$showZero = props.showZero, showZero = _props$showZero === void 0 ? false : _props$showZero, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["anchorOrigin", "badgeContent", "children", "classes", "className", "color", "component", "invisible", "max", "overlap", "showZero", "variant"]);
  var invisible = invisibleProp;
  if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== "dot")) {
    invisible = true;
  }
  var displayValue = "";
  if (variant !== "dot") {
    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
  }
  return /* @__PURE__ */ index_js_eager_.createElement(ComponentProp, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref
  }, other), children, /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: (0,clsx_m["default"])(classes.badge, classes["".concat(anchorOrigin.horizontal).concat((0,capitalize/* default */.A)(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat((0,capitalize/* default */.A)(anchorOrigin.vertical)).concat((0,capitalize/* default */.A)(anchorOrigin.horizontal)).concat((0,capitalize/* default */.A)(overlap))], color !== "default" && classes["color".concat((0,capitalize/* default */.A)(color))], invisible && classes.invisible, variant === "dot" && classes.dot)
  }, displayValue));
});
 false ? 0 : void 0;
/* harmony default export */ var Badge_Badge = ((0,withStyles/* default */.A)(Badge_styles, {
  name: "MuiBadge"
})(Badge));

;// ./node_modules/@material-ui/core/esm/BottomNavigation/BottomNavigation.js







var BottomNavigation_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "flex",
      justifyContent: "center",
      height: 56,
      backgroundColor: theme.palette.background.paper
    }
  };
};
var BottomNavigation = /* @__PURE__ */ index_js_eager_.forwardRef(function BottomNavigation2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, onChange = props.onChange, _props$showLabels = props.showLabels, showLabels = _props$showLabels === void 0 ? false : _props$showLabels, value = props.value, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "component", "onChange", "showLabels", "value"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref
  }, other), index_js_eager_.Children.map(children, function(child, childIndex) {
    if (!/* @__PURE__ */ index_js_eager_.isValidElement(child)) {
      return null;
    }
    if (false) // removed by dead control flow
{}
    var childValue = child.props.value === void 0 ? childIndex : child.props.value;
    return /* @__PURE__ */ index_js_eager_.cloneElement(child, {
      selected: childValue === value,
      showLabel: child.props.showLabel !== void 0 ? child.props.showLabel : showLabels,
      value: childValue,
      onChange
    });
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var BottomNavigation_BottomNavigation = ((0,withStyles/* default */.A)(BottomNavigation_styles, {
  name: "MuiBottomNavigation"
})(BottomNavigation));

;// ./node_modules/@material-ui/core/esm/BottomNavigationAction/BottomNavigationAction.js








var BottomNavigationAction_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transition: theme.transitions.create(["color", "padding-top"], {
        duration: theme.transitions.duration.short
      }),
      padding: "6px 12px 8px",
      minWidth: 80,
      maxWidth: 168,
      color: theme.palette.text.secondary,
      flex: "1",
      "&$iconOnly": {
        paddingTop: 16
      },
      "&$selected": {
        paddingTop: 6,
        color: theme.palette.primary.main
      }
    },
    /* Pseudo-class applied to the root element if selected. */
    selected: {},
    /* Pseudo-class applied to the root element if `showLabel={false}` and not selected. */
    iconOnly: {},
    /* Styles applied to the span element that wraps the icon and label. */
    wrapper: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      flexDirection: "column"
    },
    /* Styles applied to the label's span element. */
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      opacity: 1,
      transition: "font-size 0.2s, opacity 0.2s",
      transitionDelay: "0.1s",
      "&$iconOnly": {
        opacity: 0,
        transitionDelay: "0s"
      },
      "&$selected": {
        fontSize: theme.typography.pxToRem(14)
      }
    }
  };
};
var BottomNavigationAction = /* @__PURE__ */ index_js_eager_.forwardRef(function BottomNavigationAction2(props, ref) {
  var classes = props.classes, className = props.className, icon = props.icon, label = props.label, onChange = props.onChange, onClick = props.onClick, selected = props.selected, showLabel = props.showLabel, value = props.value, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);
  var handleChange = function handleChange2(event) {
    if (onChange) {
      onChange(event, value);
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /* @__PURE__ */ index_js_eager_.createElement(ButtonBase/* default */.A, (0,esm_extends/* default */.A)({
    ref,
    className: (0,clsx_m["default"])(classes.root, className, selected ? classes.selected : !showLabel && classes.iconOnly),
    focusRipple: true,
    onClick: handleChange
  }, other), /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: classes.wrapper
  }, icon, /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: (0,clsx_m["default"])(classes.label, selected ? classes.selected : !showLabel && classes.iconOnly)
  }, label)));
});
 false ? 0 : void 0;
/* harmony default export */ var BottomNavigationAction_BottomNavigationAction = ((0,withStyles/* default */.A)(BottomNavigationAction_styles, {
  name: "MuiBottomNavigationAction"
})(BottomNavigationAction));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 12 modules
var Box = __webpack_require__(65838);
;// ./node_modules/@material-ui/core/esm/Box/index.js


// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(6849);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(54346);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(19603);
;// ./node_modules/@material-ui/core/esm/internal/svg-icons/MoreHoriz.js


/* harmony default export */ var MoreHoriz = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), "MoreHoriz"));

;// ./node_modules/@material-ui/core/esm/Breadcrumbs/BreadcrumbCollapsed.js








var BreadcrumbCollapsed_styles = function styles2(theme) {
  return {
    root: {
      display: "flex",
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.grey[700],
      borderRadius: 2,
      cursor: "pointer",
      "&:hover, &:focus": {
        backgroundColor: theme.palette.grey[200]
      },
      "&:active": {
        boxShadow: theme.shadows[0],
        backgroundColor: (0,colorManipulator/* emphasize */.tL)(theme.palette.grey[200], 0.12)
      }
    },
    icon: {
      width: 24,
      height: 16
    }
  };
};
function BreadcrumbCollapsed(props) {
  var classes = props.classes, other = (0,objectWithoutProperties/* default */.A)(props, ["classes"]);
  return /* @__PURE__ */ index_js_eager_.createElement(ButtonBase/* default */.A, (0,esm_extends/* default */.A)({
    component: "li",
    className: classes.root,
    focusRipple: true
  }, other), /* @__PURE__ */ index_js_eager_.createElement(MoreHoriz, {
    className: classes.icon
  }));
}
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_BreadcrumbCollapsed = ((0,withStyles/* default */.A)(BreadcrumbCollapsed_styles, {
  name: "PrivateBreadcrumbCollapsed"
})(BreadcrumbCollapsed));

;// ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js










var Breadcrumbs_styles = {
  /* Styles applied to the root element. */
  root: {},
  /* Styles applied to the ol element. */
  ol: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    padding: 0,
    margin: 0,
    listStyle: "none"
  },
  /* Styles applied to the li element. */
  li: {},
  /* Styles applied to the separator element. */
  separator: {
    display: "flex",
    userSelect: "none",
    marginLeft: 8,
    marginRight: 8
  }
};
function insertSeparators(items, className, separator) {
  return items.reduce(function(acc, current, index) {
    if (index < items.length - 1) {
      acc = acc.concat(current, /* @__PURE__ */ index_js_eager_.createElement("li", {
        "aria-hidden": true,
        key: "separator-".concat(index),
        className
      }, separator));
    } else {
      acc.push(current);
    }
    return acc;
  }, []);
}
var Breadcrumbs = /* @__PURE__ */ index_js_eager_.forwardRef(function Breadcrumbs2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "nav" : _props$component, _props$expandText = props.expandText, expandText = _props$expandText === void 0 ? "Show path" : _props$expandText, _props$itemsAfterColl = props.itemsAfterCollapse, itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl, _props$itemsBeforeCol = props.itemsBeforeCollapse, itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol, _props$maxItems = props.maxItems, maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems, _props$separator = props.separator, separator = _props$separator === void 0 ? "/" : _props$separator, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);
  var _React$useState = index_js_eager_.useState(false), expanded = _React$useState[0], setExpanded = _React$useState[1];
  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter2(allItems2) {
    var handleClickExpand = function handleClickExpand2(event) {
      setExpanded(true);
      var focusable = event.currentTarget.parentNode.querySelector("a[href],button,[tabindex]");
      if (focusable) {
        focusable.focus();
      }
    };
    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems2.length) {
      if (false) // removed by dead control flow
{}
      return allItems2;
    }
    return [].concat((0,toConsumableArray/* default */.A)(allItems2.slice(0, itemsBeforeCollapse)), [/* @__PURE__ */ index_js_eager_.createElement(Breadcrumbs_BreadcrumbCollapsed, {
      "aria-label": expandText,
      key: "ellipsis",
      onClick: handleClickExpand
    })], (0,toConsumableArray/* default */.A)(allItems2.slice(allItems2.length - itemsAfterCollapse, allItems2.length)));
  };
  var allItems = index_js_eager_.Children.toArray(children).filter(function(child) {
    if (false) // removed by dead control flow
{}
    return /* @__PURE__ */ index_js_eager_.isValidElement(child);
  }).map(function(child, index) {
    return /* @__PURE__ */ index_js_eager_.createElement("li", {
      className: classes.li,
      key: "child-".concat(index)
    }, child);
  });
  return /* @__PURE__ */ index_js_eager_.createElement(Typography/* default */.A, (0,esm_extends/* default */.A)({
    ref,
    component: Component,
    color: "textSecondary",
    className: (0,clsx_m["default"])(classes.root, className)
  }, other), /* @__PURE__ */ index_js_eager_.createElement("ol", {
    className: classes.ol
  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
});
 false ? 0 : void 0;
/* harmony default export */ var Breadcrumbs_Breadcrumbs = ((0,withStyles/* default */.A)(Breadcrumbs_styles, {
  name: "MuiBreadcrumbs"
})(Breadcrumbs));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(57772);
;// ./node_modules/@material-ui/core/esm/ButtonGroup/ButtonGroup.js










Button/* default.styles */.A.styles;
var ButtonGroup_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "inline-flex",
      borderRadius: theme.shape.borderRadius
    },
    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      boxShadow: theme.shadows[2]
    },
    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: "none"
    },
    /* Pseudo-class applied to child elements if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: "100%"
    },
    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      flexDirection: "column"
    },
    /* Styles applied to the children. */
    grouped: {
      minWidth: 40
    },
    /* Styles applied to the children if `orientation="horizontal"`. */
    groupedHorizontal: {
      "&:not(:first-child)": {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      "&:not(:last-child)": {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    },
    /* Styles applied to the children if `orientation="vertical"`. */
    groupedVertical: {
      "&:not(:first-child)": {
        borderTopRightRadius: 0,
        borderTopLeftRadius: 0
      },
      "&:not(:last-child)": {
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0
      }
    },
    /* Styles applied to the children if `variant="text"`. */
    groupedText: {},
    /* Styles applied to the children if `variant="text"` and `orientation="horizontal"`. */
    groupedTextHorizontal: {
      "&:not(:last-child)": {
        borderRight: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)")
      }
    },
    /* Styles applied to the children if `variant="text"` and `orientation="vertical"`. */
    groupedTextVertical: {
      "&:not(:last-child)": {
        borderBottom: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)")
      }
    },
    /* Styles applied to the children if `variant="text"` and `color="primary"`. */
    groupedTextPrimary: {
      "&:not(:last-child)": {
        borderColor: (0,colorManipulator/* alpha */.X4)(theme.palette.primary.main, 0.5)
      }
    },
    /* Styles applied to the children if `variant="text"` and `color="secondary"`. */
    groupedTextSecondary: {
      "&:not(:last-child)": {
        borderColor: (0,colorManipulator/* alpha */.X4)(theme.palette.secondary.main, 0.5)
      }
    },
    /* Styles applied to the children if `variant="outlined"`. */
    groupedOutlined: {},
    /* Styles applied to the children if `variant="outlined"` and `orientation="horizontal"`. */
    groupedOutlinedHorizontal: {
      "&:not(:first-child)": {
        marginLeft: -1
      },
      "&:not(:last-child)": {
        borderRightColor: "transparent"
      }
    },
    /* Styles applied to the children if `variant="outlined"` and `orientation="vertical"`. */
    groupedOutlinedVertical: {
      "&:not(:first-child)": {
        marginTop: -1
      },
      "&:not(:last-child)": {
        borderBottomColor: "transparent"
      }
    },
    /* Styles applied to the children if `variant="outlined"` and `color="primary"`. */
    groupedOutlinedPrimary: {
      "&:hover": {
        borderColor: theme.palette.primary.main
      }
    },
    /* Styles applied to the children if `variant="outlined"` and `color="secondary"`. */
    groupedOutlinedSecondary: {
      "&:hover": {
        borderColor: theme.palette.secondary.main
      }
    },
    /* Styles applied to the children if `variant="contained"`. */
    groupedContained: {
      boxShadow: "none"
    },
    /* Styles applied to the children if `variant="contained"` and `orientation="horizontal"`. */
    groupedContainedHorizontal: {
      "&:not(:last-child)": {
        borderRight: "1px solid ".concat(theme.palette.grey[400]),
        "&$disabled": {
          borderRight: "1px solid ".concat(theme.palette.action.disabled)
        }
      }
    },
    /* Styles applied to the children if `variant="contained"` and `orientation="vertical"`. */
    groupedContainedVertical: {
      "&:not(:last-child)": {
        borderBottom: "1px solid ".concat(theme.palette.grey[400]),
        "&$disabled": {
          borderBottom: "1px solid ".concat(theme.palette.action.disabled)
        }
      }
    },
    /* Styles applied to the children if `variant="contained"` and `color="primary"`. */
    groupedContainedPrimary: {
      "&:not(:last-child)": {
        borderColor: theme.palette.primary.dark
      }
    },
    /* Styles applied to the children if `variant="contained"` and `color="secondary"`. */
    groupedContainedSecondary: {
      "&:not(:last-child)": {
        borderColor: theme.palette.secondary.dark
      }
    }
  };
};
var ButtonGroup = /* @__PURE__ */ index_js_eager_.forwardRef(function ButtonGroup2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableElevati = props.disableElevation, disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, _props$disableRipple = props.disableRipple, disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple, _props$fullWidth = props.fullWidth, fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? "outlined" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"]);
  var buttonClassName = (0,clsx_m["default"])(classes.grouped, classes["grouped".concat((0,capitalize/* default */.A)(orientation))], classes["grouped".concat((0,capitalize/* default */.A)(variant))], classes["grouped".concat((0,capitalize/* default */.A)(variant)).concat((0,capitalize/* default */.A)(orientation))], classes["grouped".concat((0,capitalize/* default */.A)(variant)).concat(color !== "default" ? (0,capitalize/* default */.A)(color) : "")], disabled && classes.disabled);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    role: "group",
    className: (0,clsx_m["default"])(classes.root, className, fullWidth && classes.fullWidth, disableElevation && classes.disableElevation, variant === "contained" && classes.contained, orientation === "vertical" && classes.vertical),
    ref
  }, other), index_js_eager_.Children.map(children, function(child) {
    if (!/* @__PURE__ */ index_js_eager_.isValidElement(child)) {
      return null;
    }
    if (false) // removed by dead control flow
{}
    return /* @__PURE__ */ index_js_eager_.cloneElement(child, {
      className: (0,clsx_m["default"])(buttonClassName, child.props.className),
      color: child.props.color || color,
      disabled: child.props.disabled || disabled,
      disableElevation: child.props.disableElevation || disableElevation,
      disableFocusRipple,
      disableRipple,
      fullWidth,
      size: child.props.size || size,
      variant: child.props.variant || variant
    });
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var ButtonGroup_ButtonGroup = ((0,withStyles/* default */.A)(ButtonGroup_styles, {
  name: "MuiButtonGroup"
})(ButtonGroup));

;// ./node_modules/@material-ui/core/esm/Card/Card.js







var Card_styles = {
  /* Styles applied to the root element. */
  root: {
    overflow: "hidden"
  }
};
var Card = /* @__PURE__ */ index_js_eager_.forwardRef(function Card2(props, ref) {
  var classes = props.classes, className = props.className, _props$raised = props.raised, raised = _props$raised === void 0 ? false : _props$raised, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "raised"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Paper/* default */.A, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    elevation: raised ? 8 : 1,
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Card_Card = ((0,withStyles/* default */.A)(Card_styles, {
  name: "MuiCard"
})(Card));

;// ./node_modules/@material-ui/core/esm/CardActionArea/CardActionArea.js







var CardActionArea_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "block",
      textAlign: "inherit",
      width: "100%",
      "&:hover $focusHighlight": {
        opacity: theme.palette.action.hoverOpacity
      },
      "&$focusVisible $focusHighlight": {
        opacity: 0.12
      }
    },
    /* Pseudo-class applied to the ButtonBase root element if the action area is keyboard focused. */
    focusVisible: {},
    /* Styles applied to the overlay that covers the action area when it is keyboard focused. */
    focusHighlight: {
      overflow: "hidden",
      pointerEvents: "none",
      position: "absolute",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: "inherit",
      opacity: 0,
      backgroundColor: "currentcolor",
      transition: theme.transitions.create("opacity", {
        duration: theme.transitions.duration.short
      })
    }
  };
};
var CardActionArea = /* @__PURE__ */ index_js_eager_.forwardRef(function CardActionArea2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, focusVisibleClassName = props.focusVisibleClassName, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "focusVisibleClassName"]);
  return /* @__PURE__ */ index_js_eager_.createElement(ButtonBase/* default */.A, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    focusVisibleClassName: (0,clsx_m["default"])(focusVisibleClassName, classes.focusVisible),
    ref
  }, other), children, /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: classes.focusHighlight
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var CardActionArea_CardActionArea = ((0,withStyles/* default */.A)(CardActionArea_styles, {
  name: "MuiCardActionArea"
})(CardActionArea));

;// ./node_modules/@material-ui/core/esm/CardActions/CardActions.js






var CardActions_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    alignItems: "center",
    padding: 8
  },
  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    "& > :not(:first-child)": {
      marginLeft: 8
    }
  }
};
var CardActions = /* @__PURE__ */ index_js_eager_.forwardRef(function CardActions2(props, ref) {
  var _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, classes = props.classes, className = props.className, other = (0,objectWithoutProperties/* default */.A)(props, ["disableSpacing", "classes", "className"]);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, !disableSpacing && classes.spacing),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardActions_CardActions = ((0,withStyles/* default */.A)(CardActions_styles, {
  name: "MuiCardActions"
})(CardActions));

;// ./node_modules/@material-ui/core/esm/CardContent/CardContent.js






var CardContent_styles = {
  /* Styles applied to the root element. */
  root: {
    padding: 16,
    "&:last-child": {
      paddingBottom: 24
    }
  }
};
var CardContent = /* @__PURE__ */ index_js_eager_.forwardRef(function CardContent2(props, ref) {
  var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "component"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var CardContent_CardContent = ((0,withStyles/* default */.A)(CardContent_styles, {
  name: "MuiCardContent"
})(CardContent));

;// ./node_modules/@material-ui/core/esm/CardHeader/CardHeader.js







var CardHeader_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    alignItems: "center",
    padding: 16
  },
  /* Styles applied to the avatar element. */
  avatar: {
    flex: "0 0 auto",
    marginRight: 16
  },
  /* Styles applied to the action element. */
  action: {
    flex: "0 0 auto",
    alignSelf: "flex-start",
    marginTop: -8,
    marginRight: -8
  },
  /* Styles applied to the content wrapper element. */
  content: {
    flex: "1 1 auto"
  },
  /* Styles applied to the title Typography element. */
  title: {},
  /* Styles applied to the subheader Typography element. */
  subheader: {}
};
var CardHeader = /* @__PURE__ */ index_js_eager_.forwardRef(function CardHeader2(props, ref) {
  var action = props.action, avatar = props.avatar, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, subheaderProp = props.subheader, subheaderTypographyProps = props.subheaderTypographyProps, titleProp = props.title, titleTypographyProps = props.titleTypographyProps, other = (0,objectWithoutProperties/* default */.A)(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);
  var title = titleProp;
  if (title != null && title.type !== Typography/* default */.A && !disableTypography) {
    title = /* @__PURE__ */ index_js_eager_.createElement(Typography/* default */.A, (0,esm_extends/* default */.A)({
      variant: avatar ? "body2" : "h5",
      className: classes.title,
      component: "span",
      display: "block"
    }, titleTypographyProps), title);
  }
  var subheader = subheaderProp;
  if (subheader != null && subheader.type !== Typography/* default */.A && !disableTypography) {
    subheader = /* @__PURE__ */ index_js_eager_.createElement(Typography/* default */.A, (0,esm_extends/* default */.A)({
      variant: avatar ? "body2" : "body1",
      className: classes.subheader,
      color: "textSecondary",
      component: "span",
      display: "block"
    }, subheaderTypographyProps), subheader);
  }
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref
  }, other), avatar && /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.avatar
  }, avatar), /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.content
  }, title, subheader), action && /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.action
  }, action));
});
 false ? 0 : void 0;
/* harmony default export */ var CardHeader_CardHeader = ((0,withStyles/* default */.A)(CardHeader_styles, {
  name: "MuiCardHeader"
})(CardHeader));

;// ./node_modules/@material-ui/core/esm/CardMedia/CardMedia.js







var CardMedia_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "block",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center"
  },
  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
  media: {
    width: "100%"
  },
  /* Styles applied to the root element if `component="picture or img"`. */
  img: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: "cover"
  }
};
var MEDIA_COMPONENTS = ["video", "audio", "picture", "iframe", "img"];
var CardMedia = /* @__PURE__ */ index_js_eager_.forwardRef(function CardMedia2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, image = props.image, src = props.src, style = props.style, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "component", "image", "src", "style"]);
  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  var composedStyle = !isMediaComponent && image ? (0,esm_extends/* default */.A)({
    backgroundImage: 'url("'.concat(image, '")')
  }, style) : style;
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, isMediaComponent && classes.media, "picture img".indexOf(Component) !== -1 && classes.img),
    ref,
    style: composedStyle,
    src: isMediaComponent ? image || src : void 0
  }, other), children);
});
 false ? 0 : void 0;
/* harmony default export */ var CardMedia_CardMedia = ((0,withStyles/* default */.A)(CardMedia_styles, {
  name: "MuiCardMedia"
})(CardMedia));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/useFormControl.js
var useFormControl = __webpack_require__(72463);
;// ./node_modules/@material-ui/core/esm/internal/SwitchBase.js











var SwitchBase_styles = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: "inherit",
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};
var SwitchBase = /* @__PURE__ */ index_js_eager_.forwardRef(function SwitchBase2(props, ref) {
  var autoFocus = props.autoFocus, checkedProp = props.checked, checkedIcon = props.checkedIcon, classes = props.classes, className = props.className, defaultChecked = props.defaultChecked, disabledProp = props.disabled, icon = props.icon, id = props.id, inputProps = props.inputProps, inputRef = props.inputRef, name = props.name, onBlur = props.onBlur, onChange = props.onChange, onFocus = props.onFocus, readOnly = props.readOnly, required = props.required, tabIndex = props.tabIndex, type = props.type, value = props.value, other = (0,objectWithoutProperties/* default */.A)(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);
  var _useControlled = (0,useControlled/* default */.A)({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: "SwitchBase",
    state: "checked"
  }), _useControlled2 = (0,slicedToArray/* default */.A)(_useControlled, 2), checked = _useControlled2[0], setCheckedState = _useControlled2[1];
  var muiFormControl = (0,useFormControl/* default */.A)();
  var handleFocus = function handleFocus2(event) {
    if (onFocus) {
      onFocus(event);
    }
    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };
  var handleBlur = function handleBlur2(event) {
    if (onBlur) {
      onBlur(event);
    }
    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };
  var handleInputChange = function handleInputChange2(event) {
    var newChecked = event.target.checked;
    setCheckedState(newChecked);
    if (onChange) {
      onChange(event, newChecked);
    }
  };
  var disabled = disabledProp;
  if (muiFormControl) {
    if (typeof disabled === "undefined") {
      disabled = muiFormControl.disabled;
    }
  }
  var hasLabelFor = type === "checkbox" || type === "radio";
  return /* @__PURE__ */ index_js_eager_.createElement(IconButton/* default */.A, (0,esm_extends/* default */.A)({
    component: "span",
    className: (0,clsx_m["default"])(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled,
    tabIndex: null,
    role: void 0,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement("input", (0,esm_extends/* default */.A)({
    autoFocus,
    checked: checkedProp,
    defaultChecked,
    className: classes.input,
    disabled,
    id: hasLabelFor && id,
    name,
    onChange: handleInputChange,
    readOnly,
    ref: inputRef,
    required,
    tabIndex,
    type,
    value
  }, inputProps)), checked ? checkedIcon : icon);
});
 false ? 0 : void 0;
/* harmony default export */ var internal_SwitchBase = ((0,withStyles/* default */.A)(SwitchBase_styles, {
  name: "PrivateSwitchBase"
})(SwitchBase));

;// ./node_modules/@material-ui/core/esm/internal/svg-icons/CheckBoxOutlineBlank.js


/* harmony default export */ var CheckBoxOutlineBlank = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"));

;// ./node_modules/@material-ui/core/esm/internal/svg-icons/CheckBox.js


/* harmony default export */ var CheckBox = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"));

;// ./node_modules/@material-ui/core/esm/internal/svg-icons/IndeterminateCheckBox.js


/* harmony default export */ var IndeterminateCheckBox = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox"));

;// ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js













var Checkbox_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },
    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
    indeterminate: {},
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      "&$checked": {
        color: theme.palette.primary.main,
        "&:hover": {
          backgroundColor: (0,colorManipulator/* alpha */.X4)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        }
      },
      "&$disabled": {
        color: theme.palette.action.disabled
      }
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      "&$checked": {
        color: theme.palette.secondary.main,
        "&:hover": {
          backgroundColor: (0,colorManipulator/* alpha */.X4)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        }
      },
      "&$disabled": {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = /* @__PURE__ */ index_js_eager_.createElement(CheckBox, null);
var defaultIcon = /* @__PURE__ */ index_js_eager_.createElement(CheckBoxOutlineBlank, null);
var defaultIndeterminateIcon = /* @__PURE__ */ index_js_eager_.createElement(IndeterminateCheckBox, null);
var Checkbox = /* @__PURE__ */ index_js_eager_.forwardRef(function Checkbox2(props, ref) {
  var _props$checkedIcon = props.checkedIcon, checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? "secondary" : _props$color, _props$icon = props.icon, iconProp = _props$icon === void 0 ? defaultIcon : _props$icon, _props$indeterminate = props.indeterminate, indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate, _props$indeterminateI = props.indeterminateIcon, indeterminateIconProp = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI, inputProps = props.inputProps, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0,objectWithoutProperties/* default */.A)(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]);
  var icon = indeterminate ? indeterminateIconProp : iconProp;
  var indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
  return /* @__PURE__ */ index_js_eager_.createElement(internal_SwitchBase, (0,esm_extends/* default */.A)({
    type: "checkbox",
    classes: {
      root: (0,clsx_m["default"])(classes.root, classes["color".concat((0,capitalize/* default */.A)(color))], indeterminate && classes.indeterminate),
      checked: classes.checked,
      disabled: classes.disabled
    },
    color,
    inputProps: (0,esm_extends/* default */.A)({
      "data-indeterminate": indeterminate
    }, inputProps),
    icon: /* @__PURE__ */ index_js_eager_.cloneElement(icon, {
      fontSize: icon.props.fontSize === void 0 && size === "small" ? size : icon.props.fontSize
    }),
    checkedIcon: /* @__PURE__ */ index_js_eager_.cloneElement(indeterminateIcon, {
      fontSize: indeterminateIcon.props.fontSize === void 0 && size === "small" ? size : indeterminateIcon.props.fontSize
    }),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Checkbox_Checkbox = ((0,withStyles/* default */.A)(Checkbox_styles, {
  name: "MuiCheckbox"
})(Checkbox));

;// ./node_modules/@material-ui/core/esm/internal/svg-icons/Cancel.js


/* harmony default export */ var Cancel = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel"));

;// ./node_modules/@material-ui/core/esm/Chip/Chip.js












var Chip_styles = function styles2(theme) {
  var backgroundColor = theme.palette.type === "light" ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = (0,colorManipulator/* alpha */.X4)(theme.palette.text.primary, 0.26);
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      height: 32,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor,
      borderRadius: 32 / 2,
      whiteSpace: "nowrap",
      transition: theme.transitions.create(["background-color", "box-shadow"]),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: "default",
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      textDecoration: "none",
      border: "none",
      // Remove `button` border
      padding: 0,
      // Remove `button` padding
      verticalAlign: "middle",
      boxSizing: "border-box",
      "&$disabled": {
        opacity: 0.5,
        pointerEvents: "none"
      },
      "& $avatar": {
        marginLeft: 5,
        marginRight: -6,
        width: 24,
        height: 24,
        color: theme.palette.type === "light" ? theme.palette.grey[700] : theme.palette.grey[300],
        fontSize: theme.typography.pxToRem(12)
      },
      "& $avatarColorPrimary": {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark
      },
      "& $avatarColorSecondary": {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.dark
      },
      "& $avatarSmall": {
        marginLeft: 4,
        marginRight: -4,
        width: 18,
        height: 18,
        fontSize: theme.typography.pxToRem(10)
      }
    },
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      height: 24
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {
      userSelect: "none",
      WebkitTapHighlightColor: "transparent",
      cursor: "pointer",
      "&:hover, &:focus": {
        backgroundColor: (0,colorManipulator/* emphasize */.tL)(backgroundColor, 0.08)
      },
      "&:active": {
        boxShadow: theme.shadows[1]
      }
    },
    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
    clickableColorPrimary: {
      "&:hover, &:focus": {
        backgroundColor: (0,colorManipulator/* emphasize */.tL)(theme.palette.primary.main, 0.08)
      }
    },
    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
    clickableColorSecondary: {
      "&:hover, &:focus": {
        backgroundColor: (0,colorManipulator/* emphasize */.tL)(theme.palette.secondary.main, 0.08)
      }
    },
    /* Styles applied to the root element if `onDelete` is defined. */
    deletable: {
      "&:focus": {
        backgroundColor: (0,colorManipulator/* emphasize */.tL)(backgroundColor, 0.08)
      }
    },
    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
    deletableColorPrimary: {
      "&:focus": {
        backgroundColor: (0,colorManipulator/* emphasize */.tL)(theme.palette.primary.main, 0.2)
      }
    },
    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
    deletableColorSecondary: {
      "&:focus": {
        backgroundColor: (0,colorManipulator/* emphasize */.tL)(theme.palette.secondary.main, 0.2)
      }
    },
    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      backgroundColor: "transparent",
      border: "1px solid ".concat(theme.palette.type === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)"),
      "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
        backgroundColor: (0,colorManipulator/* alpha */.X4)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
      },
      "& $avatar": {
        marginLeft: 4
      },
      "& $avatarSmall": {
        marginLeft: 2
      },
      "& $icon": {
        marginLeft: 4
      },
      "& $iconSmall": {
        marginLeft: 2
      },
      "& $deleteIcon": {
        marginRight: 5
      },
      "& $deleteIconSmall": {
        marginRight: 3
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(theme.palette.primary.main),
      "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
        backgroundColor: (0,colorManipulator/* alpha */.X4)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
      }
    },
    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(theme.palette.secondary.main),
      "$clickable&:hover, $clickable&:focus, $deletable&:focus": {
        backgroundColor: (0,colorManipulator/* alpha */.X4)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
      }
    },
    // TODO v5: remove
    /* Styles applied to the `avatar` element. */
    avatar: {},
    /* Styles applied to the `avatar` element if `size="small"`. */
    avatarSmall: {},
    /* Styles applied to the `avatar` element if `color="primary"`. */
    avatarColorPrimary: {},
    /* Styles applied to the `avatar` element if `color="secondary"`. */
    avatarColorSecondary: {},
    /* Styles applied to the `icon` element. */
    icon: {
      color: theme.palette.type === "light" ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    },
    /* Styles applied to the `icon` element if `size="small"`. */
    iconSmall: {
      width: 18,
      height: 18,
      marginLeft: 4,
      marginRight: -4
    },
    /* Styles applied to the `icon` element if `color="primary"`. */
    iconColorPrimary: {
      color: "inherit"
    },
    /* Styles applied to the `icon` element if `color="secondary"`. */
    iconColorSecondary: {
      color: "inherit"
    },
    /* Styles applied to the label `span` element. */
    label: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      paddingLeft: 12,
      paddingRight: 12,
      whiteSpace: "nowrap"
    },
    /* Styles applied to the label `span` element if `size="small"`. */
    labelSmall: {
      paddingLeft: 8,
      paddingRight: 8
    },
    /* Styles applied to the `deleteIcon` element. */
    deleteIcon: {
      WebkitTapHighlightColor: "transparent",
      color: deleteIconColor,
      height: 22,
      width: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: (0,colorManipulator/* alpha */.X4)(deleteIconColor, 0.4)
      }
    },
    /* Styles applied to the `deleteIcon` element if `size="small"`. */
    deleteIconSmall: {
      height: 16,
      width: 16,
      marginRight: 4,
      marginLeft: -4
    },
    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
    deleteIconColorPrimary: {
      color: (0,colorManipulator/* alpha */.X4)(theme.palette.primary.contrastText, 0.7),
      "&:hover, &:active": {
        color: theme.palette.primary.contrastText
      }
    },
    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
    deleteIconColorSecondary: {
      color: (0,colorManipulator/* alpha */.X4)(theme.palette.secondary.contrastText, 0.7),
      "&:hover, &:active": {
        color: theme.palette.secondary.contrastText
      }
    },
    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
    deleteIconOutlinedColorPrimary: {
      color: (0,colorManipulator/* alpha */.X4)(theme.palette.primary.main, 0.7),
      "&:hover, &:active": {
        color: theme.palette.primary.main
      }
    },
    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
    deleteIconOutlinedColorSecondary: {
      color: (0,colorManipulator/* alpha */.X4)(theme.palette.secondary.main, 0.7),
      "&:hover, &:active": {
        color: theme.palette.secondary.main
      }
    }
  };
};
function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === "Backspace" || keyboardEvent.key === "Delete";
}
var Chip = /* @__PURE__ */ index_js_eager_.forwardRef(function Chip2(props, ref) {
  var avatarProp = props.avatar, classes = props.classes, className = props.className, clickableProp = props.clickable, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, ComponentProp = props.component, deleteIconProp = props.deleteIcon, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, iconProp = props.icon, label = props.label, onClick = props.onClick, onDelete = props.onDelete, onKeyDown = props.onKeyDown, onKeyUp = props.onKeyUp, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? "default" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);
  var chipRef = index_js_eager_.useRef(null);
  var handleRef = (0,useForkRef/* default */.A)(chipRef, ref);
  var handleDeleteIconClick = function handleDeleteIconClick2(event) {
    event.stopPropagation();
    if (onDelete) {
      onDelete(event);
    }
  };
  var handleKeyDown = function handleKeyDown2(event) {
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      event.preventDefault();
    }
    if (onKeyDown) {
      onKeyDown(event);
    }
  };
  var handleKeyUp = function handleKeyUp2(event) {
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === "Escape" && chipRef.current) {
        chipRef.current.blur();
      }
    }
    if (onKeyUp) {
      onKeyUp(event);
    }
  };
  var clickable = clickableProp !== false && onClick ? true : clickableProp;
  var small = size === "small";
  var Component = ComponentProp || (clickable ? ButtonBase/* default */.A : "div");
  var moreProps = Component === ButtonBase/* default */.A ? {
    component: "div"
  } : {};
  var deleteIcon = null;
  if (onDelete) {
    var customClasses = (0,clsx_m["default"])(color !== "default" && (variant === "default" ? classes["deleteIconColor".concat((0,capitalize/* default */.A)(color))] : classes["deleteIconOutlinedColor".concat((0,capitalize/* default */.A)(color))]), small && classes.deleteIconSmall);
    deleteIcon = deleteIconProp && /* @__PURE__ */ index_js_eager_.isValidElement(deleteIconProp) ? /* @__PURE__ */ index_js_eager_.cloneElement(deleteIconProp, {
      className: (0,clsx_m["default"])(deleteIconProp.props.className, classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    }) : /* @__PURE__ */ index_js_eager_.createElement(Cancel, {
      className: (0,clsx_m["default"])(classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    });
  }
  var avatar = null;
  if (avatarProp && /* @__PURE__ */ index_js_eager_.isValidElement(avatarProp)) {
    avatar = /* @__PURE__ */ index_js_eager_.cloneElement(avatarProp, {
      className: (0,clsx_m["default"])(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== "default" && classes["avatarColor".concat((0,capitalize/* default */.A)(color))])
    });
  }
  var icon = null;
  if (iconProp && /* @__PURE__ */ index_js_eager_.isValidElement(iconProp)) {
    icon = /* @__PURE__ */ index_js_eager_.cloneElement(iconProp, {
      className: (0,clsx_m["default"])(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== "default" && classes["iconColor".concat((0,capitalize/* default */.A)(color))])
    });
  }
  if (false) // removed by dead control flow
{}
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    role: clickable || onDelete ? "button" : void 0,
    className: (0,clsx_m["default"])(classes.root, className, color !== "default" && [classes["color".concat((0,capitalize/* default */.A)(color))], clickable && classes["clickableColor".concat((0,capitalize/* default */.A)(color))], onDelete && classes["deletableColor".concat((0,capitalize/* default */.A)(color))]], variant !== "default" && [classes.outlined, {
      "primary": classes.outlinedPrimary,
      "secondary": classes.outlinedSecondary
    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
    "aria-disabled": disabled ? true : void 0,
    tabIndex: clickable || onDelete ? 0 : void 0,
    onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef
  }, moreProps, other), avatar || icon, /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: (0,clsx_m["default"])(classes.label, small && classes.labelSmall)
  }, label), deleteIcon);
});
 false ? 0 : void 0;
/* harmony default export */ var Chip_Chip = ((0,withStyles/* default */.A)(Chip_styles, {
  name: "MuiChip"
})(Chip));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(52776);
// EXTERNAL MODULE: consume shared module (default) react-dom@=17.0.2 (singleton) (fallback: ./node_modules/react-dom/index.js) (eager)
var react_dom_index_js_eager_ = __webpack_require__(51971);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(33189);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(38957);
;// ./node_modules/@material-ui/core/esm/ClickAwayListener/ClickAwayListener.js







function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}
function clickedRootScrollbar(event) {
  return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
function ClickAwayListener(props) {
  var children = props.children, _props$disableReactTr = props.disableReactTree, disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr, _props$mouseEvent = props.mouseEvent, mouseEvent = _props$mouseEvent === void 0 ? "onClick" : _props$mouseEvent, onClickAway = props.onClickAway, _props$touchEvent = props.touchEvent, touchEvent = _props$touchEvent === void 0 ? "onTouchEnd" : _props$touchEvent;
  var movedRef = index_js_eager_.useRef(false);
  var nodeRef = index_js_eager_.useRef(null);
  var activatedRef = index_js_eager_.useRef(false);
  var syntheticEventRef = index_js_eager_.useRef(false);
  index_js_eager_.useEffect(function() {
    setTimeout(function() {
      activatedRef.current = true;
    }, 0);
    return function() {
      activatedRef.current = false;
    };
  }, []);
  var handleOwnRef = index_js_eager_.useCallback(function(instance) {
    nodeRef.current = react_dom_index_js_eager_.findDOMNode(instance);
  }, []);
  var handleRef = (0,useForkRef/* default */.A)(children.ref, handleOwnRef);
  var handleClickAway = (0,useEventCallback/* default */.A)(function(event) {
    var insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    if (!activatedRef.current || !nodeRef.current || clickedRootScrollbar(event)) {
      return;
    }
    if (movedRef.current) {
      movedRef.current = false;
      return;
    }
    var insideDOM;
    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      var doc = (0,ownerDocument/* default */.A)(nodeRef.current);
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }
    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  });
  var createHandleSynthetic = function createHandleSynthetic2(handlerName) {
    return function(event) {
      syntheticEventRef.current = true;
      var childrenPropsHandler = children.props[handlerName];
      if (childrenPropsHandler) {
        childrenPropsHandler(event);
      }
    };
  };
  var childrenProps = {
    ref: handleRef
  };
  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }
  index_js_eager_.useEffect(function() {
    if (touchEvent !== false) {
      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
      var doc = (0,ownerDocument/* default */.A)(nodeRef.current);
      var handleTouchMove = function handleTouchMove2() {
        movedRef.current = true;
      };
      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener("touchmove", handleTouchMove);
      return function() {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener("touchmove", handleTouchMove);
      };
    }
    return void 0;
  }, [handleClickAway, touchEvent]);
  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }
  index_js_eager_.useEffect(function() {
    if (mouseEvent !== false) {
      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      var doc = (0,ownerDocument/* default */.A)(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return function() {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }
    return void 0;
  }, [handleClickAway, mouseEvent]);
  return /* @__PURE__ */ index_js_eager_.createElement(index_js_eager_.Fragment, null, /* @__PURE__ */ index_js_eager_.cloneElement(children, childrenProps));
}
 false ? 0 : void 0;
if (false) // removed by dead control flow
{}
/* harmony default export */ var ClickAwayListener_ClickAwayListener = (ClickAwayListener);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(75054);
;// ./node_modules/@material-ui/core/esm/Container/Container.js








var Container_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,defineProperty/* default */.A)({
      width: "100%",
      marginLeft: "auto",
      boxSizing: "border-box",
      marginRight: "auto",
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      display: "block"
    }, theme.breakpoints.up("sm"), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),
    /* Styles applied to the root element if `disableGutters={true}`. */
    disableGutters: {
      paddingLeft: 0,
      paddingRight: 0
    },
    /* Styles applied to the root element if `fixed={true}`. */
    fixed: Object.keys(theme.breakpoints.values).reduce(function(acc, breakpoint) {
      var value = theme.breakpoints.values[breakpoint];
      if (value !== 0) {
        acc[theme.breakpoints.up(breakpoint)] = {
          maxWidth: value
        };
      }
      return acc;
    }, {}),
    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: (0,defineProperty/* default */.A)({}, theme.breakpoints.up("xs"), {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }),
    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: (0,defineProperty/* default */.A)({}, theme.breakpoints.up("sm"), {
      maxWidth: theme.breakpoints.values.sm
    }),
    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: (0,defineProperty/* default */.A)({}, theme.breakpoints.up("md"), {
      maxWidth: theme.breakpoints.values.md
    }),
    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: (0,defineProperty/* default */.A)({}, theme.breakpoints.up("lg"), {
      maxWidth: theme.breakpoints.values.lg
    }),
    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: (0,defineProperty/* default */.A)({}, theme.breakpoints.up("xl"), {
      maxWidth: theme.breakpoints.values.xl
    })
  };
};
var Container = /* @__PURE__ */ index_js_eager_.forwardRef(function Container2(props, ref) {
  var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$fixed = props.fixed, fixed = _props$fixed === void 0 ? false : _props$fixed, _props$maxWidth = props.maxWidth, maxWidth = _props$maxWidth === void 0 ? "lg" : _props$maxWidth, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0,capitalize/* default */.A)(String(maxWidth)))]),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Container_Container = ((0,withStyles/* default */.A)(Container_styles, {
  name: "MuiContainer"
})(Container));

;// ./node_modules/@material-ui/core/esm/CssBaseline/CssBaseline.js





var html = {
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box"
};
var body = function body2(theme) {
  return (0,esm_extends/* default */.A)({
    color: theme.palette.text.primary
  }, theme.typography.body2, {
    backgroundColor: theme.palette.background.default,
    "@media print": {
      // Save printer ink.
      backgroundColor: theme.palette.common.white
    }
  });
};
var CssBaseline_styles = function styles2(theme) {
  return {
    "@global": {
      html,
      "*, *::before, *::after": {
        boxSizing: "inherit"
      },
      "strong, b": {
        fontWeight: theme.typography.fontWeightBold
      },
      body: (0,esm_extends/* default */.A)({
        margin: 0
      }, body(theme), {
        // Add support for document.body.requestFullScreen().
        // Other elements, if background transparent, are not supported.
        "&::backdrop": {
          backgroundColor: theme.palette.background.default
        }
      })
    }
  };
};
function CssBaseline(props) {
  var _props$children = props.children, children = _props$children === void 0 ? null : _props$children, classes = props.classes;
  return /* @__PURE__ */ index_js_eager_.createElement(index_js_eager_.Fragment, null, children);
}
 false ? 0 : void 0;
if (false) // removed by dead control flow
{}
/* harmony default export */ var CssBaseline_CssBaseline = ((0,withStyles/* default */.A)(CssBaseline_styles, {
  name: "MuiCssBaseline"
})(CssBaseline));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Dialog/Dialog.js
var Dialog = __webpack_require__(42920);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogActions/DialogActions.js
var DialogActions = __webpack_require__(34130);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(69346);
;// ./node_modules/@material-ui/core/esm/DialogContentText/DialogContentText.js





var DialogContentText_styles = {
  /* Styles applied to the root element. */
  root: {
    marginBottom: 12
  }
};
var DialogContentText = /* @__PURE__ */ index_js_eager_.forwardRef(function DialogContentText2(props, ref) {
  return /* @__PURE__ */ index_js_eager_.createElement(Typography/* default */.A, (0,esm_extends/* default */.A)({
    component: "p",
    variant: "body1",
    color: "textSecondary",
    ref
  }, props));
});
 false ? 0 : void 0;
/* harmony default export */ var DialogContentText_DialogContentText = ((0,withStyles/* default */.A)(DialogContentText_styles, {
  name: "MuiDialogContentText"
})(DialogContentText));

;// ./node_modules/@material-ui/core/esm/DialogTitle/DialogTitle.js







var DialogTitle_styles = {
  /* Styles applied to the root element. */
  root: {
    margin: 0,
    padding: "16px 24px",
    flex: "0 0 auto"
  }
};
var DialogTitle = /* @__PURE__ */ index_js_eager_.forwardRef(function DialogTitle2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "disableTypography"]);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref
  }, other), disableTypography ? children : /* @__PURE__ */ index_js_eager_.createElement(Typography/* default */.A, {
    component: "h2",
    variant: "h6"
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ var DialogTitle_DialogTitle = ((0,withStyles/* default */.A)(DialogTitle_styles, {
  name: "MuiDialogTitle"
})(DialogTitle));

;// ./node_modules/@material-ui/core/esm/Divider/Divider.js







var Divider_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: "none",
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },
    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%"
    },
    /* Styles applied to the root element if `variant="inset"`. */
    inset: {
      marginLeft: 72
    },
    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: (0,colorManipulator/* alpha */.X4)(theme.palette.divider, 0.08)
    },
    /* Styles applied to the root element if `variant="middle"`. */
    middle: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },
    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      height: "100%",
      width: 1
    },
    /* Styles applied to the root element if `flexItem={true}`. */
    flexItem: {
      alignSelf: "stretch",
      height: "auto"
    }
  };
};
var Divider = /* @__PURE__ */ index_js_eager_.forwardRef(function Divider2(props, ref) {
  var _props$absolute = props.absolute, absolute = _props$absolute === void 0 ? false : _props$absolute, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "hr" : _props$component, _props$flexItem = props.flexItem, flexItem = _props$flexItem === void 0 ? false : _props$flexItem, _props$light = props.light, light = _props$light === void 0 ? false : _props$light, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, _props$role = props.role, role = _props$role === void 0 ? Component !== "hr" ? "separator" : void 0 : _props$role, _props$variant = props.variant, variant = _props$variant === void 0 ? "fullWidth" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, variant !== "fullWidth" && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === "vertical" && classes.vertical),
    role,
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Divider_Divider = ((0,withStyles/* default */.A)(Divider_styles, {
  name: "MuiDivider"
})(Divider));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/Modal.js + 1 modules
var Modal = __webpack_require__(37790);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/debounce.js
var debounce = __webpack_require__(35864);
;// ./node_modules/@material-ui/core/esm/Slide/Slide.js












function getTranslateValue(direction, node) {
  var rect = node.getBoundingClientRect();
  var transform;
  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = window.getComputedStyle(node);
    transform = computedStyle.getPropertyValue("-webkit-transform") || computedStyle.getPropertyValue("transform");
  }
  var offsetX = 0;
  var offsetY = 0;
  if (transform && transform !== "none" && typeof transform === "string") {
    var transformValues = transform.split("(")[1].split(")")[0].split(",");
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }
  if (direction === "left") {
    return "translateX(".concat(window.innerWidth, "px) translateX(").concat(offsetX - rect.left, "px)");
  }
  if (direction === "right") {
    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
  }
  if (direction === "up") {
    return "translateY(".concat(window.innerHeight, "px) translateY(").concat(offsetY - rect.top, "px)");
  }
  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}
function setTranslateValue(direction, node) {
  var transform = getTranslateValue(direction, node);
  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
var defaultTimeout = {
  enter: transitions/* duration */.p0.enteringScreen,
  exit: transitions/* duration */.p0.leavingScreen
};
var Slide = /* @__PURE__ */ index_js_eager_.forwardRef(function Slide2(props, ref) {
  var children = props.children, _props$direction = props.direction, direction = _props$direction === void 0 ? "down" : _props$direction, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? Transition/* default */.Ay : _props$TransitionComp, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "direction", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
  var theme = (0,useTheme/* default */.A)();
  var childrenRef = index_js_eager_.useRef(null);
  var handleOwnRef = index_js_eager_.useCallback(function(instance) {
    childrenRef.current = react_dom_index_js_eager_.findDOMNode(instance);
  }, []);
  var handleRefIntermediary = (0,useForkRef/* default */.A)(children.ref, handleOwnRef);
  var handleRef = (0,useForkRef/* default */.A)(handleRefIntermediary, ref);
  var normalizedTransitionCallback = function normalizedTransitionCallback2(callback) {
    return function(isAppearing) {
      if (callback) {
        if (isAppearing === void 0) {
          callback(childrenRef.current);
        } else {
          callback(childrenRef.current, isAppearing);
        }
      }
    };
  };
  var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
    setTranslateValue(direction, node);
    (0,transitions_utils/* reflow */.q)(node);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntering = normalizedTransitionCallback(function(node, isAppearing) {
    var transitionProps = (0,transitions_utils/* getTransitionProps */.c)({
      timeout,
      style
    }, {
      mode: "enter"
    });
    node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0,esm_extends/* default */.A)({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.transition = theme.transitions.create("transform", (0,esm_extends/* default */.A)({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.webkitTransform = "none";
    node.style.transform = "none";
    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function(node) {
    var transitionProps = (0,transitions_utils/* getTransitionProps */.c)({
      timeout,
      style
    }, {
      mode: "exit"
    });
    node.style.webkitTransition = theme.transitions.create("-webkit-transform", (0,esm_extends/* default */.A)({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    node.style.transition = theme.transitions.create("transform", (0,esm_extends/* default */.A)({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    setTranslateValue(direction, node);
    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(function(node) {
    node.style.webkitTransition = "";
    node.style.transition = "";
    if (onExited) {
      onExited(node);
    }
  });
  var updatePosition = index_js_eager_.useCallback(function() {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current);
    }
  }, [direction]);
  index_js_eager_.useEffect(function() {
    if (inProp || direction === "down" || direction === "right") {
      return void 0;
    }
    var handleResize = (0,debounce/* default */.A)(function() {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current);
      }
    });
    window.addEventListener("resize", handleResize);
    return function() {
      handleResize.clear();
      window.removeEventListener("resize", handleResize);
    };
  }, [direction, inProp]);
  index_js_eager_.useEffect(function() {
    if (!inProp) {
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /* @__PURE__ */ index_js_eager_.createElement(TransitionComponent, (0,esm_extends/* default */.A)({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    appear: true,
    in: inProp,
    timeout
  }, other), function(state, childProps) {
    return /* @__PURE__ */ index_js_eager_.cloneElement(children, (0,esm_extends/* default */.A)({
      ref: handleRef,
      style: (0,esm_extends/* default */.A)({
        visibility: state === "exited" && !inProp ? "hidden" : void 0
      }, style, children.props.style)
    }, childProps));
  });
});
 false ? 0 : void 0;
/* harmony default export */ var Slide_Slide = (Slide);

;// ./node_modules/@material-ui/core/esm/Drawer/Drawer.js













var Drawer_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},
    /* Styles applied to the root element if `variant="permanent or persistent"`. */
    docked: {
      flex: "0 0 auto"
    },
    /* Styles applied to the `Paper` component. */
    paper: {
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      height: "100%",
      flex: "1 0 auto",
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: "touch",
      // Add iOS momentum scrolling.
      // temporary style
      position: "fixed",
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 0
    },
    /* Styles applied to the `Paper` component if `anchor="left"`. */
    paperAnchorLeft: {
      left: 0,
      right: "auto"
    },
    /* Styles applied to the `Paper` component if `anchor="right"`. */
    paperAnchorRight: {
      left: "auto",
      right: 0
    },
    /* Styles applied to the `Paper` component if `anchor="top"`. */
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: "auto",
      right: 0,
      height: "auto",
      maxHeight: "100%"
    },
    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
    paperAnchorBottom: {
      top: "auto",
      left: 0,
      bottom: 0,
      right: 0,
      height: "auto",
      maxHeight: "100%"
    },
    /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */
    paperAnchorDockedLeft: {
      borderRight: "1px solid ".concat(theme.palette.divider)
    },
    /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */
    paperAnchorDockedTop: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    },
    /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */
    paperAnchorDockedRight: {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    },
    /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */
    paperAnchorDockedBottom: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },
    /* Styles applied to the `Modal` component. */
    modal: {}
  };
};
var oppositeDirection = {
  left: "right",
  right: "left",
  top: "down",
  bottom: "up"
};
function isHorizontal(anchor) {
  return ["left", "right"].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === "rtl" && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
var defaultTransitionDuration = {
  enter: transitions/* duration */.p0.enteringScreen,
  exit: transitions/* duration */.p0.leavingScreen
};
var Drawer = /* @__PURE__ */ index_js_eager_.forwardRef(function Drawer2(props, ref) {
  var _props$anchor = props.anchor, anchorProp = _props$anchor === void 0 ? "left" : _props$anchor, BackdropProps = props.BackdropProps, children = props.children, classes = props.classes, className = props.className, _props$elevation = props.elevation, elevation = _props$elevation === void 0 ? 16 : _props$elevation, _props$ModalProps = props.ModalProps;
  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
  var BackdropPropsProp = _props$ModalProps.BackdropProps, ModalProps = (0,objectWithoutProperties/* default */.A)(_props$ModalProps, ["BackdropProps"]), onClose = props.onClose, _props$open = props.open, open = _props$open === void 0 ? false : _props$open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, SlideProps = props.SlideProps, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? Slide_Slide : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura, _props$variant = props.variant, variant = _props$variant === void 0 ? "temporary" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"]);
  var theme = (0,useTheme/* default */.A)();
  var mounted = index_js_eager_.useRef(false);
  index_js_eager_.useEffect(function() {
    mounted.current = true;
  }, []);
  var anchor = getAnchor(theme, anchorProp);
  var drawer = /* @__PURE__ */ index_js_eager_.createElement(Paper/* default */.A, (0,esm_extends/* default */.A)({
    elevation: variant === "temporary" ? elevation : 0,
    square: true
  }, PaperProps, {
    className: (0,clsx_m["default"])(classes.paper, classes["paperAnchor".concat((0,capitalize/* default */.A)(anchor))], PaperProps.className, variant !== "temporary" && classes["paperAnchorDocked".concat((0,capitalize/* default */.A)(anchor))])
  }), children);
  if (variant === "permanent") {
    return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
      className: (0,clsx_m["default"])(classes.root, classes.docked, className),
      ref
    }, other), drawer);
  }
  var slidingDrawer = /* @__PURE__ */ index_js_eager_.createElement(TransitionComponent, (0,esm_extends/* default */.A)({
    in: open,
    direction: oppositeDirection[anchor],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps), drawer);
  if (variant === "persistent") {
    return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
      className: (0,clsx_m["default"])(classes.root, classes.docked, className),
      ref
    }, other), slidingDrawer);
  }
  return /* @__PURE__ */ index_js_eager_.createElement(Modal/* default */.A, (0,esm_extends/* default */.A)({
    BackdropProps: (0,esm_extends/* default */.A)({}, BackdropProps, BackdropPropsProp, {
      transitionDuration
    }),
    BackdropComponent: Backdrop/* default */.A,
    className: (0,clsx_m["default"])(classes.root, classes.modal, className),
    open,
    onClose,
    ref
  }, other, ModalProps), slidingDrawer);
});
 false ? 0 : void 0;
/* harmony default export */ var Drawer_Drawer = ((0,withStyles/* default */.A)(Drawer_styles, {
  name: "MuiDrawer",
  flip: false
})(Drawer));

;// ./node_modules/@material-ui/core/esm/ExpansionPanel/ExpansionPanelContext.js

var ExpansionPanelContext = index_js_eager_.createContext({});
if (false) // removed by dead control flow
{}
/* harmony default export */ var ExpansionPanel_ExpansionPanelContext = (ExpansionPanelContext);

;// ./node_modules/@material-ui/core/esm/ExpansionPanel/ExpansionPanel.js














var ExpansionPanel_styles = function styles2(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: "relative",
      transition: theme.transitions.create(["margin"], transition),
      "&:before": {
        position: "absolute",
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(["opacity", "background-color"], transition)
      },
      "&:first-child": {
        "&:before": {
          display: "none"
        }
      },
      "&$expanded": {
        margin: "16px 0",
        "&:first-child": {
          marginTop: 0
        },
        "&:last-child": {
          marginBottom: 0
        },
        "&:before": {
          opacity: 0
        }
      },
      "&$expanded + &": {
        "&:before": {
          display: "none"
        }
      },
      "&$disabled": {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },
    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      "&:first-child": {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      "&:last-child": {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },
    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},
    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
};
var warnedOnce = false;
var ExpansionPanel = /* @__PURE__ */ index_js_eager_.forwardRef(function ExpansionPanel2(props, ref) {
  if (false) // removed by dead control flow
{}
  var childrenProp = props.children, classes = props.classes, className = props.className, _props$defaultExpande = props.defaultExpanded, defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, expandedProp = props.expanded, onChange = props.onChange, _props$square = props.square, square = _props$square === void 0 ? false : _props$square, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? Collapse_Collapse : _props$TransitionComp, TransitionProps = props.TransitionProps, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);
  var _useControlled = (0,useControlled/* default */.A)({
    controlled: expandedProp,
    default: defaultExpanded,
    name: "ExpansionPanel",
    state: "expanded"
  }), _useControlled2 = (0,slicedToArray/* default */.A)(_useControlled, 2), expanded = _useControlled2[0], setExpandedState = _useControlled2[1];
  var handleChange = index_js_eager_.useCallback(function(event) {
    setExpandedState(!expanded);
    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, onChange, setExpandedState]);
  var _React$Children$toArr = index_js_eager_.Children.toArray(childrenProp), _React$Children$toArr2 = _toArray(_React$Children$toArr), summary = _React$Children$toArr2[0], children = _React$Children$toArr2.slice(1);
  var contextValue = index_js_eager_.useMemo(function() {
    return {
      expanded,
      disabled,
      toggle: handleChange
    };
  }, [expanded, disabled, handleChange]);
  return /* @__PURE__ */ index_js_eager_.createElement(Paper/* default */.A, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
    ref,
    square
  }, other), /* @__PURE__ */ index_js_eager_.createElement(ExpansionPanel_ExpansionPanelContext.Provider, {
    value: contextValue
  }, summary), /* @__PURE__ */ index_js_eager_.createElement(TransitionComponent, (0,esm_extends/* default */.A)({
    in: expanded,
    timeout: "auto"
  }, TransitionProps), /* @__PURE__ */ index_js_eager_.createElement("div", {
    "aria-labelledby": summary.props.id,
    id: summary.props["aria-controls"],
    role: "region"
  }, children)));
});
 false ? 0 : void 0;
/* harmony default export */ var ExpansionPanel_ExpansionPanel = ((0,withStyles/* default */.A)(ExpansionPanel_styles, {
  name: "MuiExpansionPanel"
})(ExpansionPanel));

;// ./node_modules/@material-ui/core/esm/ExpansionPanelActions/ExpansionPanelActions.js






var ExpansionPanelActions_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    alignItems: "center",
    padding: 8,
    justifyContent: "flex-end"
  },
  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    "& > :not(:first-child)": {
      marginLeft: 8
    }
  }
};
var ExpansionPanelActions_warnedOnce = false;
var ExpansionPanelActions = /* @__PURE__ */ index_js_eager_.forwardRef(function ExpansionPanelActions2(props, ref) {
  if (false) // removed by dead control flow
{}
  var classes = props.classes, className = props.className, _props$disableSpacing = props.disableSpacing, disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "disableSpacing"]);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, !disableSpacing && classes.spacing),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var ExpansionPanelActions_ExpansionPanelActions = ((0,withStyles/* default */.A)(ExpansionPanelActions_styles, {
  name: "MuiExpansionPanelActions"
})(ExpansionPanelActions));

;// ./node_modules/@material-ui/core/esm/ExpansionPanelDetails/ExpansionPanelDetails.js






var ExpansionPanelDetails_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "flex",
      padding: theme.spacing(1, 2, 2)
    }
  };
};
var ExpansionPanelDetails_warnedOnce = false;
var ExpansionPanelDetails = /* @__PURE__ */ index_js_eager_.forwardRef(function ExpansionPanelDetails2(props, ref) {
  if (false) // removed by dead control flow
{}
  var classes = props.classes, className = props.className, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className"]);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var ExpansionPanelDetails_ExpansionPanelDetails = ((0,withStyles/* default */.A)(ExpansionPanelDetails_styles, {
  name: "MuiExpansionPanelDetails"
})(ExpansionPanelDetails));

;// ./node_modules/@material-ui/core/esm/ExpansionPanelSummary/ExpansionPanelSummary.js









var ExpansionPanelSummary_styles = function styles2(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: "flex",
      minHeight: 8 * 6,
      transition: theme.transitions.create(["min-height", "background-color"], transition),
      padding: theme.spacing(0, 2),
      "&:hover:not($disabled)": {
        cursor: "pointer"
      },
      "&$expanded": {
        minHeight: 64
      },
      "&$focused": {
        backgroundColor: theme.palette.action.focus
      },
      "&$disabled": {
        opacity: theme.palette.action.disabledOpacity
      }
    },
    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},
    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the children wrapper element. */
    content: {
      display: "flex",
      flexGrow: 1,
      transition: theme.transitions.create(["margin"], transition),
      margin: "12px 0",
      "&$expanded": {
        margin: "20px 0"
      }
    },
    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: "rotate(0deg)",
      transition: theme.transitions.create("transform", transition),
      "&:hover": {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: "transparent"
      },
      "&$expanded": {
        transform: "rotate(180deg)"
      }
    }
  };
};
var ExpansionPanelSummary_warnedOnce = false;
var ExpansionPanelSummary = /* @__PURE__ */ index_js_eager_.forwardRef(function ExpansionPanelSummary2(props, ref) {
  if (false) // removed by dead control flow
{}
  var children = props.children, classes = props.classes, className = props.className, expandIcon = props.expandIcon, IconButtonProps = props.IconButtonProps, onBlur = props.onBlur, onClick = props.onClick, onFocusVisible = props.onFocusVisible, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);
  var _React$useState = index_js_eager_.useState(false), focusedState = _React$useState[0], setFocusedState = _React$useState[1];
  var handleFocusVisible = function handleFocusVisible2(event) {
    setFocusedState(true);
    if (onFocusVisible) {
      onFocusVisible(event);
    }
  };
  var handleBlur = function handleBlur2(event) {
    setFocusedState(false);
    if (onBlur) {
      onBlur(event);
    }
  };
  var _React$useContext = index_js_eager_.useContext(ExpansionPanel_ExpansionPanelContext), _React$useContext$dis = _React$useContext.disabled, disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis, expanded = _React$useContext.expanded, toggle = _React$useContext.toggle;
  var handleChange = function handleChange2(event) {
    if (toggle) {
      toggle(event);
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /* @__PURE__ */ index_js_eager_.createElement(ButtonBase/* default */.A, (0,esm_extends/* default */.A)({
    focusRipple: false,
    disableRipple: true,
    disabled,
    component: "div",
    "aria-expanded": expanded,
    className: (0,clsx_m["default"])(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
    onFocusVisible: handleFocusVisible,
    onBlur: handleBlur,
    onClick: handleChange,
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: (0,clsx_m["default"])(classes.content, expanded && classes.expanded)
  }, children), expandIcon && /* @__PURE__ */ index_js_eager_.createElement(IconButton/* default */.A, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
 false ? 0 : void 0;
/* harmony default export */ var ExpansionPanelSummary_ExpansionPanelSummary = ((0,withStyles/* default */.A)(ExpansionPanelSummary_styles, {
  name: "MuiExpansionPanelSummary"
})(ExpansionPanelSummary));

;// ./node_modules/@material-ui/core/esm/Fab/Fab.js









var Fab_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,esm_extends/* default */.A)({}, theme.typography.button, {
      boxSizing: "border-box",
      minHeight: 36,
      transition: theme.transitions.create(["background-color", "box-shadow", "border"], {
        duration: theme.transitions.duration.short
      }),
      borderRadius: "50%",
      padding: 0,
      minWidth: 0,
      width: 56,
      height: 56,
      boxShadow: theme.shadows[6],
      "&:active": {
        boxShadow: theme.shadows[12]
      },
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      "&:hover": {
        backgroundColor: theme.palette.grey.A100,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: theme.palette.grey[300]
        },
        "&$disabled": {
          backgroundColor: theme.palette.action.disabledBackground
        },
        textDecoration: "none"
      },
      "&$focusVisible": {
        boxShadow: theme.shadows[6]
      },
      "&$disabled": {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    }),
    /* Styles applied to the span element that wraps the children. */
    label: {
      width: "100%",
      // assure the correct width for iOS Safari
      display: "inherit",
      alignItems: "inherit",
      justifyContent: "inherit"
    },
    /* Styles applied to the root element if `color="primary"`. */
    primary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: theme.palette.primary.main
        }
      }
    },
    /* Styles applied to the root element if `color="secondary"`. */
    secondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      "&:hover": {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },
    /* Styles applied to the root element if `variant="extended"`. */
    extended: {
      borderRadius: 48 / 2,
      padding: "0 16px",
      width: "auto",
      minHeight: "auto",
      minWidth: 48,
      height: 48,
      "&$sizeSmall": {
        width: "auto",
        padding: "0 8px",
        borderRadius: 34 / 2,
        minWidth: 34,
        height: 34
      },
      "&$sizeMedium": {
        width: "auto",
        padding: "0 16px",
        borderRadius: 40 / 2,
        minWidth: 40,
        height: 40
      }
    },
    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the root element if `size="small"``. */
    sizeSmall: {
      width: 40,
      height: 40
    },
    /* Styles applied to the root element if `size="medium"``. */
    sizeMedium: {
      width: 48,
      height: 48
    }
  };
};
var Fab = /* @__PURE__ */ index_js_eager_.forwardRef(function Fab2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, focusVisibleClassName = props.focusVisibleClassName, _props$size = props.size, size = _props$size === void 0 ? "large" : _props$size, _props$variant = props.variant, variant = _props$variant === void 0 ? "circular" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"]);
  return /* @__PURE__ */ index_js_eager_.createElement(ButtonBase/* default */.A, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, size !== "large" && classes["size".concat((0,capitalize/* default */.A)(size))], disabled && classes.disabled, variant === "extended" && classes.extended, {
      "primary": classes.primary,
      "secondary": classes.secondary,
      "inherit": classes.colorInherit
    }[color]),
    component,
    disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: (0,clsx_m["default"])(classes.focusVisible, focusVisibleClassName),
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: classes.label
  }, children));
});
 false ? 0 : void 0;
/* harmony default export */ var Fab_Fab = ((0,withStyles/* default */.A)(Fab_styles, {
  name: "MuiFab"
})(Fab));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(28276);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FilledInput/FilledInput.js
var FilledInput = __webpack_require__(29118);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControl/FormControl.js
var FormControl = __webpack_require__(1586);
;// ./node_modules/@material-ui/core/esm/FormControl/index.js



;// ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js










var FormControlLabel_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "inline-flex",
      alignItems: "center",
      cursor: "pointer",
      // For correct alignment with the text.
      verticalAlign: "middle",
      WebkitTapHighlightColor: "transparent",
      marginLeft: -11,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      "&$disabled": {
        cursor: "default"
      }
    },
    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: "row-reverse",
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -11
    },
    /* Styles applied to the root element if `labelPlacement="top"`. */
    labelPlacementTop: {
      flexDirection: "column-reverse",
      marginLeft: 16
    },
    /* Styles applied to the root element if `labelPlacement="bottom"`. */
    labelPlacementBottom: {
      flexDirection: "column",
      marginLeft: 16
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the label's Typography component. */
    label: {
      "&$disabled": {
        color: theme.palette.text.disabled
      }
    }
  };
};
var FormControlLabel = /* @__PURE__ */ index_js_eager_.forwardRef(function FormControlLabel2(props, ref) {
  var checked = props.checked, classes = props.classes, className = props.className, control = props.control, disabledProp = props.disabled, inputRef = props.inputRef, label = props.label, _props$labelPlacement = props.labelPlacement, labelPlacement = _props$labelPlacement === void 0 ? "end" : _props$labelPlacement, name = props.name, onChange = props.onChange, value = props.value, other = (0,objectWithoutProperties/* default */.A)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);
  var muiFormControl = (0,useFormControl/* default */.A)();
  var disabled = disabledProp;
  if (typeof disabled === "undefined" && typeof control.props.disabled !== "undefined") {
    disabled = control.props.disabled;
  }
  if (typeof disabled === "undefined" && muiFormControl) {
    disabled = muiFormControl.disabled;
  }
  var controlProps = {
    disabled
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach(function(key) {
    if (typeof control.props[key] === "undefined" && typeof props[key] !== "undefined") {
      controlProps[key] = props[key];
    }
  });
  return /* @__PURE__ */ index_js_eager_.createElement("label", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, labelPlacement !== "end" && classes["labelPlacement".concat((0,capitalize/* default */.A)(labelPlacement))], disabled && classes.disabled),
    ref
  }, other), /* @__PURE__ */ index_js_eager_.cloneElement(control, controlProps), /* @__PURE__ */ index_js_eager_.createElement(Typography/* default */.A, {
    component: "span",
    className: (0,clsx_m["default"])(classes.label, disabled && classes.disabled)
  }, label));
});
 false ? 0 : void 0;
/* harmony default export */ var FormControlLabel_FormControlLabel = ((0,withStyles/* default */.A)(FormControlLabel_styles, {
  name: "MuiFormControlLabel"
})(FormControlLabel));

;// ./node_modules/@material-ui/core/esm/FormGroup/FormGroup.js






var FormGroup_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap"
  },
  /* Styles applied to the root element if `row={true}`. */
  row: {
    flexDirection: "row"
  }
};
var FormGroup = /* @__PURE__ */ index_js_eager_.forwardRef(function FormGroup2(props, ref) {
  var classes = props.classes, className = props.className, _props$row = props.row, row = _props$row === void 0 ? false : _props$row, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "row"]);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, row && classes.row),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var FormGroup_FormGroup = ((0,withStyles/* default */.A)(FormGroup_styles, {
  name: "MuiFormGroup"
})(FormGroup));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(95262);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormLabel/FormLabel.js
var FormLabel = __webpack_require__(95142);
;// ./node_modules/@material-ui/core/esm/Grid/Grid.js








var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var GRID_SIZES = ["auto", true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
function generateGrid(globalStyles, theme, breakpoint) {
  var styles3 = {};
  GRID_SIZES.forEach(function(size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);
    if (size === true) {
      styles3[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
      return;
    }
    if (size === "auto") {
      styles3[key] = {
        flexBasis: "auto",
        flexGrow: 0,
        maxWidth: "none"
      };
      return;
    }
    var width = "".concat(Math.round(size / 12 * 1e8) / 1e6, "%");
    styles3[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  });
  if (breakpoint === "xs") {
    (0,esm_extends/* default */.A)(globalStyles, styles3);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles3;
  }
}
function getOffset(val) {
  var div = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  var parse = parseFloat(val);
  return "".concat(parse / div).concat(String(val).replace(String(parse), "") || "px");
}
function generateGutter(theme, breakpoint) {
  var styles3 = {};
  SPACINGS.forEach(function(spacing) {
    var themeSpacing = theme.spacing(spacing);
    if (themeSpacing === 0) {
      return;
    }
    styles3["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: "-".concat(getOffset(themeSpacing, 2)),
      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
      "& > $item": {
        padding: getOffset(themeSpacing, 2)
      }
    };
  });
  return styles3;
}
var Grid_styles = function styles2(theme) {
  return (0,esm_extends/* default */.A)({
    /* Styles applied to the root element. */
    root: {},
    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: "border-box",
      display: "flex",
      flexWrap: "wrap",
      width: "100%"
    },
    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: "border-box",
      margin: "0"
      // For instance, it's useful when used with a `figure` element.
    },
    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },
    /* Styles applied to the root element if `direction="column"`. */
    "direction-xs-column": {
      flexDirection: "column"
    },
    /* Styles applied to the root element if `direction="column-reverse"`. */
    "direction-xs-column-reverse": {
      flexDirection: "column-reverse"
    },
    /* Styles applied to the root element if `direction="row-reverse"`. */
    "direction-xs-row-reverse": {
      flexDirection: "row-reverse"
    },
    /* Styles applied to the root element if `wrap="nowrap"`. */
    "wrap-xs-nowrap": {
      flexWrap: "nowrap"
    },
    /* Styles applied to the root element if `wrap="reverse"`. */
    "wrap-xs-wrap-reverse": {
      flexWrap: "wrap-reverse"
    },
    /* Styles applied to the root element if `alignItems="center"`. */
    "align-items-xs-center": {
      alignItems: "center"
    },
    /* Styles applied to the root element if `alignItems="flex-start"`. */
    "align-items-xs-flex-start": {
      alignItems: "flex-start"
    },
    /* Styles applied to the root element if `alignItems="flex-end"`. */
    "align-items-xs-flex-end": {
      alignItems: "flex-end"
    },
    /* Styles applied to the root element if `alignItems="baseline"`. */
    "align-items-xs-baseline": {
      alignItems: "baseline"
    },
    /* Styles applied to the root element if `alignContent="center"`. */
    "align-content-xs-center": {
      alignContent: "center"
    },
    /* Styles applied to the root element if `alignContent="flex-start"`. */
    "align-content-xs-flex-start": {
      alignContent: "flex-start"
    },
    /* Styles applied to the root element if `alignContent="flex-end"`. */
    "align-content-xs-flex-end": {
      alignContent: "flex-end"
    },
    /* Styles applied to the root element if `alignContent="space-between"`. */
    "align-content-xs-space-between": {
      alignContent: "space-between"
    },
    /* Styles applied to the root element if `alignContent="space-around"`. */
    "align-content-xs-space-around": {
      alignContent: "space-around"
    },
    /* Styles applied to the root element if `justifyContent="center"`. */
    "justify-content-xs-center": {
      justifyContent: "center"
    },
    /* Styles applied to the root element if `justifyContent="flex-end"`. */
    "justify-content-xs-flex-end": {
      justifyContent: "flex-end"
    },
    /* Styles applied to the root element if `justifyContent="space-between"`. */
    "justify-content-xs-space-between": {
      justifyContent: "space-between"
    },
    /* Styles applied to the root element if `justifyContent="space-around"`. */
    "justify-content-xs-space-around": {
      justifyContent: "space-around"
    },
    /* Styles applied to the root element if `justifyContent="space-evenly"`. */
    "justify-content-xs-space-evenly": {
      justifyContent: "space-evenly"
    }
  }, generateGutter(theme, "xs"), theme.breakpoints.keys.reduce(function(accumulator, key) {
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};
var Grid = /* @__PURE__ */ index_js_eager_.forwardRef(function Grid2(props, ref) {
  var _props$alignContent = props.alignContent, alignContent = _props$alignContent === void 0 ? "stretch" : _props$alignContent, _props$alignItems = props.alignItems, alignItems = _props$alignItems === void 0 ? "stretch" : _props$alignItems, classes = props.classes, classNameProp = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$container = props.container, container = _props$container === void 0 ? false : _props$container, _props$direction = props.direction, direction = _props$direction === void 0 ? "row" : _props$direction, _props$item = props.item, item = _props$item === void 0 ? false : _props$item, justify = props.justify, _props$justifyContent = props.justifyContent, justifyContent = _props$justifyContent === void 0 ? "flex-start" : _props$justifyContent, _props$lg = props.lg, lg = _props$lg === void 0 ? false : _props$lg, _props$md = props.md, md = _props$md === void 0 ? false : _props$md, _props$sm = props.sm, sm = _props$sm === void 0 ? false : _props$sm, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 0 : _props$spacing, _props$wrap = props.wrap, wrap = _props$wrap === void 0 ? "wrap" : _props$wrap, _props$xl = props.xl, xl = _props$xl === void 0 ? false : _props$xl, _props$xs = props.xs, xs = _props$xs === void 0 ? false : _props$xs, _props$zeroMinWidth = props.zeroMinWidth, zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth, other = (0,objectWithoutProperties/* default */.A)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "justifyContent", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);
  var className = (0,clsx_m["default"])(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== "row" && classes["direction-xs-".concat(String(direction))], wrap !== "wrap" && classes["wrap-xs-".concat(String(wrap))], alignItems !== "stretch" && classes["align-items-xs-".concat(String(alignItems))], alignContent !== "stretch" && classes["align-content-xs-".concat(String(alignContent))], (justify || justifyContent) !== "flex-start" && classes["justify-content-xs-".concat(String(justify || justifyContent))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className,
    ref
  }, other));
});
 false ? 0 : void 0;
var StyledGrid = (0,withStyles/* default */.A)(Grid_styles, {
  name: "MuiGrid"
})(Grid);
if (false) // removed by dead control flow
{ var requireProp; }
/* harmony default export */ var Grid_Grid = (StyledGrid);

;// ./node_modules/@material-ui/core/esm/GridList/GridList.js







var GridList_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    flexWrap: "wrap",
    overflowY: "auto",
    listStyle: "none",
    padding: 0,
    WebkitOverflowScrolling: "touch"
    // Add iOS momentum scrolling.
  }
};
var GridList_warnedOnce = false;
var GridList = /* @__PURE__ */ index_js_eager_.forwardRef(function GridList2(props, ref) {
  if (false) // removed by dead control flow
{}
  var _props$cellHeight = props.cellHeight, cellHeight = _props$cellHeight === void 0 ? 180 : _props$cellHeight, children = props.children, classes = props.classes, className = props.className, _props$cols = props.cols, cols = _props$cols === void 0 ? 2 : _props$cols, _props$component = props.component, Component = _props$component === void 0 ? "ul" : _props$component, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 4 : _props$spacing, style = props.style, other = (0,objectWithoutProperties/* default */.A)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref,
    style: (0,esm_extends/* default */.A)({
      margin: -spacing / 2
    }, style)
  }, other), index_js_eager_.Children.map(children, function(child) {
    if (!/* @__PURE__ */ index_js_eager_.isValidElement(child)) {
      return null;
    }
    if (false) // removed by dead control flow
{}
    var childCols = child.props.cols || 1;
    var childRows = child.props.rows || 1;
    return /* @__PURE__ */ index_js_eager_.cloneElement(child, {
      style: (0,esm_extends/* default */.A)({
        width: "".concat(100 / cols * childCols, "%"),
        height: cellHeight === "auto" ? "auto" : cellHeight * childRows + spacing,
        padding: spacing / 2
      }, child.props.style)
    });
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var GridList_GridList = ((0,withStyles/* default */.A)(GridList_styles, {
  name: "MuiGridList"
})(GridList));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(75900);
;// ./node_modules/@material-ui/core/esm/GridListTile/GridListTile.js









var GridListTile_styles = {
  /* Styles applied to the root element. */
  root: {
    boxSizing: "border-box",
    flexShrink: 0
  },
  /* Styles applied to the `div` element that wraps the children. */
  tile: {
    position: "relative",
    display: "block",
    // In case it's not rendered with a div.
    height: "100%",
    overflow: "hidden"
  },
  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullHeight: {
    height: "100%",
    transform: "translateX(-50%)",
    position: "relative",
    left: "50%"
  },
  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullWidth: {
    width: "100%",
    position: "relative",
    transform: "translateY(-50%)",
    top: "50%"
  }
};
var fit = function fit2(imgEl, classes) {
  if (!imgEl || !imgEl.complete) {
    return;
  }
  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
    var _imgEl$classList, _imgEl$classList2;
    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, (0,toConsumableArray/* default */.A)(classes.imgFullWidth.split(" ")));
    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, (0,toConsumableArray/* default */.A)(classes.imgFullHeight.split(" ")));
  } else {
    var _imgEl$classList3, _imgEl$classList4;
    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, (0,toConsumableArray/* default */.A)(classes.imgFullHeight.split(" ")));
    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, (0,toConsumableArray/* default */.A)(classes.imgFullWidth.split(" ")));
  }
};
function ensureImageCover(imgEl, classes) {
  if (!imgEl) {
    return;
  }
  if (imgEl.complete) {
    fit(imgEl, classes);
  } else {
    imgEl.addEventListener("load", function() {
      fit(imgEl, classes);
    });
  }
}
var GridListTile_warnedOnce = false;
var GridListTile = /* @__PURE__ */ index_js_eager_.forwardRef(function GridListTile2(props, ref) {
  if (false) // removed by dead control flow
{}
  var children = props.children, classes = props.classes, className = props.className, _props$cols = props.cols, cols = _props$cols === void 0 ? 1 : _props$cols, _props$component = props.component, Component = _props$component === void 0 ? "li" : _props$component, _props$rows = props.rows, rows = _props$rows === void 0 ? 1 : _props$rows, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "cols", "component", "rows"]);
  var imgRef = index_js_eager_.useRef(null);
  index_js_eager_.useEffect(function() {
    ensureImageCover(imgRef.current, classes);
  });
  index_js_eager_.useEffect(function() {
    var handleResize = (0,debounce/* default */.A)(function() {
      fit(imgRef.current, classes);
    });
    window.addEventListener("resize", handleResize);
    return function() {
      handleResize.clear();
      window.removeEventListener("resize", handleResize);
    };
  }, [classes]);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.tile
  }, index_js_eager_.Children.map(children, function(child) {
    if (!/* @__PURE__ */ index_js_eager_.isValidElement(child)) {
      return null;
    }
    if (child.type === "img" || (0,isMuiElement/* default */.A)(child, ["Image"])) {
      return /* @__PURE__ */ index_js_eager_.cloneElement(child, {
        ref: imgRef
      });
    }
    return child;
  })));
});
 false ? 0 : void 0;
/* harmony default export */ var GridListTile_GridListTile = ((0,withStyles/* default */.A)(GridListTile_styles, {
  name: "MuiGridListTile"
})(GridListTile));

;// ./node_modules/@material-ui/core/esm/GridListTileBar/GridListTileBar.js






var GridListTileBar_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "absolute",
      left: 0,
      right: 0,
      height: 48,
      background: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      fontFamily: theme.typography.fontFamily
    },
    /* Styles applied to the root element if `titlePosition="bottom"`. */
    titlePositionBottom: {
      bottom: 0
    },
    /* Styles applied to the root element if `titlePosition="top"`. */
    titlePositionTop: {
      top: 0
    },
    /* Styles applied to the root element if a `subtitle` is provided. */
    rootSubtitle: {
      height: 68
    },
    /* Styles applied to the title and subtitle container element. */
    titleWrap: {
      flexGrow: 1,
      marginLeft: 16,
      marginRight: 16,
      color: theme.palette.common.white,
      overflow: "hidden"
    },
    /* Styles applied to the container element if `actionPosition="left"`. */
    titleWrapActionPosLeft: {
      marginLeft: 0
    },
    /* Styles applied to the container element if `actionPosition="right"`. */
    titleWrapActionPosRight: {
      marginRight: 0
    },
    /* Styles applied to the title container element. */
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: "24px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap"
    },
    /* Styles applied to the subtitle container element. */
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1,
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap"
    },
    /* Styles applied to the actionIcon if supplied. */
    actionIcon: {},
    /* Styles applied to the actionIcon if `actionPosition="left"`. */
    actionIconActionPosLeft: {
      order: -1
    }
  };
};
var GridListTileBar_warnedOnce = false;
var GridListTileBar = /* @__PURE__ */ index_js_eager_.forwardRef(function GridListTileBar2(props, ref) {
  if (false) // removed by dead control flow
{}
  var actionIcon = props.actionIcon, _props$actionPosition = props.actionPosition, actionPosition = _props$actionPosition === void 0 ? "right" : _props$actionPosition, classes = props.classes, className = props.className, subtitle = props.subtitle, title = props.title, _props$titlePosition = props.titlePosition, titlePosition = _props$titlePosition === void 0 ? "bottom" : _props$titlePosition, other = (0,objectWithoutProperties/* default */.A)(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);
  var actionPos = actionIcon && actionPosition;
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, titlePosition === "top" ? classes.titlePositionTop : classes.titlePositionBottom, subtitle && classes.rootSubtitle),
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: (0,clsx_m["default"])(classes.titleWrap, {
      "left": classes.titleWrapActionPosLeft,
      "right": classes.titleWrapActionPosRight
    }[actionPos])
  }, /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.title
  }, title), subtitle ? /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.subtitle
  }, subtitle) : null), actionIcon ? /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: (0,clsx_m["default"])(classes.actionIcon, actionPos === "left" && classes.actionIconActionPosLeft)
  }, actionIcon) : null);
});
 false ? 0 : void 0;
/* harmony default export */ var GridListTileBar_GridListTileBar = ((0,withStyles/* default */.A)(GridListTileBar_styles, {
  name: "MuiGridListTileBar"
})(GridListTileBar));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grow/Grow.js
var Grow = __webpack_require__(75282);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(52074);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/getThemeProps/getThemeProps.js
var getThemeProps = __webpack_require__(29663);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(78576);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createBreakpoints.js
var createBreakpoints = __webpack_require__(15744);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme_useTheme = __webpack_require__(9341);
;// ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js



function useMediaQuery(queryInput) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var theme = (0,useTheme_useTheme/* default */.A)();
  var props = (0,getThemeProps/* default */.A)({
    theme,
    name: "MuiUseMediaQuery",
    props: {}
  });
  if (false) // removed by dead control flow
{}
  var query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, "");
  var supportMatchMedia = typeof window !== "undefined" && typeof window.matchMedia !== "undefined";
  var _props$options = (0,esm_extends/* default */.A)({}, props, options), _props$options$defaul = _props$options.defaultMatches, defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul, _props$options$matchM = _props$options.matchMedia, matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM, _props$options$noSsr = _props$options.noSsr, noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr, _props$options$ssrMat = _props$options.ssrMatchMedia, ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
  var _React$useState = index_js_eager_.useState(function() {
    if (noSsr && supportMatchMedia) {
      return matchMedia(query).matches;
    }
    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    }
    return defaultMatches;
  }), match = _React$useState[0], setMatch = _React$useState[1];
  index_js_eager_.useEffect(function() {
    var active = true;
    if (!supportMatchMedia) {
      return void 0;
    }
    var queryList = matchMedia(query);
    var updateMatch = function updateMatch2() {
      if (active) {
        setMatch(queryList.matches);
      }
    };
    updateMatch();
    queryList.addListener(updateMatch);
    return function() {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia, supportMatchMedia]);
  if (false) // removed by dead control flow
{}
  return match;
}

;// ./node_modules/@material-ui/core/esm/withWidth/withWidth.js










var isWidthUp = function isWidthUp2(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  if (inclusive) {
    return createBreakpoints/* keys */.H.indexOf(breakpoint) <= createBreakpoints/* keys */.H.indexOf(width);
  }
  return createBreakpoints/* keys */.H.indexOf(breakpoint) < createBreakpoints/* keys */.H.indexOf(width);
};
var isWidthDown = function isWidthDown2(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
  if (inclusive) {
    return createBreakpoints/* keys */.H.indexOf(width) <= createBreakpoints/* keys */.H.indexOf(breakpoint);
  }
  return createBreakpoints/* keys */.H.indexOf(width) < createBreakpoints/* keys */.H.indexOf(breakpoint);
};
var useEnhancedEffect = typeof window === "undefined" ? index_js_eager_.useEffect : index_js_eager_.useLayoutEffect;
var withWidth = function withWidth2() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return function(Component) {
    var _options$withTheme = options.withTheme, withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme, _options$noSSR = options.noSSR, noSSR = _options$noSSR === void 0 ? false : _options$noSSR, initialWidthOption = options.initialWidth;
    function WithWidth(props) {
      var contextTheme = (0,useTheme/* default */.A)();
      var theme = props.theme || contextTheme;
      var _getThemeProps = (0,getThemeProps/* default */.A)({
        theme,
        name: "MuiWithWidth",
        props: (0,esm_extends/* default */.A)({}, props)
      }), initialWidth = _getThemeProps.initialWidth, width = _getThemeProps.width, other = (0,objectWithoutProperties/* default */.A)(_getThemeProps, ["initialWidth", "width"]);
      var _React$useState = index_js_eager_.useState(false), mountedState = _React$useState[0], setMountedState = _React$useState[1];
      useEnhancedEffect(function() {
        setMountedState(true);
      }, []);
      var keys = theme.breakpoints.keys.slice().reverse();
      var widthComputed = keys.reduce(function(output, key) {
        var matches = useMediaQuery(theme.breakpoints.up(key));
        return !output && matches ? key : output;
      }, null);
      var more = (0,esm_extends/* default */.A)({
        width: width || (mountedState || noSSR ? widthComputed : void 0) || initialWidth || initialWidthOption
      }, withThemeOption ? {
        theme
      } : {}, other);
      if (more.width === void 0) {
        return null;
      }
      return /* @__PURE__ */ index_js_eager_.createElement(Component, more);
    }
     false ? 0 : void 0;
    if (false) // removed by dead control flow
{}
    hoist_non_react_statics_cjs_default()(WithWidth, Component);
    return WithWidth;
  };
};
/* harmony default export */ var withWidth_withWidth = (withWidth);

;// ./node_modules/@material-ui/core/esm/Hidden/HiddenJs.js




function HiddenJs(props) {
  var children = props.children, only = props.only, width = props.width;
  var theme = (0,useTheme/* default */.A)();
  var visible = true;
  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];
        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  }
  if (visible) {
    for (var _i = 0; _i < theme.breakpoints.keys.length; _i += 1) {
      var _breakpoint = theme.breakpoints.keys[_i];
      var breakpointUp = props["".concat(_breakpoint, "Up")];
      var breakpointDown = props["".concat(_breakpoint, "Down")];
      if (breakpointUp && isWidthUp(_breakpoint, width) || breakpointDown && isWidthDown(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }
  if (!visible) {
    return null;
  }
  return children;
}
HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: (prop_types_default()).node,
  /**
   * @ignore
   */
  className: (prop_types_default()).string,
  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: prop_types_default().oneOf(["js", "css"]),
  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: prop_types_default().oneOf(["xs", "sm", "md", "lg", "xl"]),
  /**
   * If `true`, screens this size and down will be hidden.
   */
  lgDown: (prop_types_default()).bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  lgUp: (prop_types_default()).bool,
  /**
   * If `true`, screens this size and down will be hidden.
   */
  mdDown: (prop_types_default()).bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  mdUp: (prop_types_default()).bool,
  /**
   * Hide the given breakpoint(s).
   */
  only: prop_types_default().oneOfType([prop_types_default().oneOf(["xs", "sm", "md", "lg", "xl"]), prop_types_default().arrayOf(prop_types_default().oneOf(["xs", "sm", "md", "lg", "xl"]))]),
  /**
   * If `true`, screens this size and down will be hidden.
   */
  smDown: (prop_types_default()).bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  smUp: (prop_types_default()).bool,
  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: (prop_types_default()).string.isRequired,
  /**
   * If `true`, screens this size and down will be hidden.
   */
  xlDown: (prop_types_default()).bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  xlUp: (prop_types_default()).bool,
  /**
   * If `true`, screens this size and down will be hidden.
   */
  xsDown: (prop_types_default()).bool,
  /**
   * If `true`, screens this size and up will be hidden.
   */
  xsUp: (prop_types_default()).bool
};
if (false) // removed by dead control flow
{}
/* harmony default export */ var Hidden_HiddenJs = (withWidth_withWidth()(HiddenJs));

;// ./node_modules/@material-ui/core/esm/Hidden/HiddenCss.js







var HiddenCss_styles = function styles2(theme) {
  var hidden = {
    display: "none"
  };
  return theme.breakpoints.keys.reduce(function(acc, key) {
    acc["only".concat((0,capitalize/* default */.A)(key))] = (0,defineProperty/* default */.A)({}, theme.breakpoints.only(key), hidden);
    acc["".concat(key, "Up")] = (0,defineProperty/* default */.A)({}, theme.breakpoints.up(key), hidden);
    acc["".concat(key, "Down")] = (0,defineProperty/* default */.A)({}, theme.breakpoints.down(key), hidden);
    return acc;
  }, {});
};
function HiddenCss(props) {
  var children = props.children, classes = props.classes, className = props.className, only = props.only, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "only"]);
  var theme = (0,useTheme/* default */.A)();
  if (false) // removed by dead control flow
{ var unknownProps; }
  var clsx = [];
  if (className) {
    clsx.push(className);
  }
  for (var i = 0; i < theme.breakpoints.keys.length; i += 1) {
    var breakpoint = theme.breakpoints.keys[i];
    var breakpointUp = props["".concat(breakpoint, "Up")];
    var breakpointDown = props["".concat(breakpoint, "Down")];
    if (breakpointUp) {
      clsx.push(classes["".concat(breakpoint, "Up")]);
    }
    if (breakpointDown) {
      clsx.push(classes["".concat(breakpoint, "Down")]);
    }
  }
  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function(breakpoint2) {
      clsx.push(classes["only".concat((0,capitalize/* default */.A)(breakpoint2))]);
    });
  }
  return /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: clsx.join(" ")
  }, children);
}
 false ? 0 : void 0;
/* harmony default export */ var Hidden_HiddenCss = ((0,withStyles/* default */.A)(HiddenCss_styles, {
  name: "PrivateHiddenCss"
})(HiddenCss));

;// ./node_modules/@material-ui/core/esm/Hidden/Hidden.js






function Hidden(props) {
  var _props$implementation = props.implementation, implementation = _props$implementation === void 0 ? "js" : _props$implementation, _props$lgDown = props.lgDown, lgDown = _props$lgDown === void 0 ? false : _props$lgDown, _props$lgUp = props.lgUp, lgUp = _props$lgUp === void 0 ? false : _props$lgUp, _props$mdDown = props.mdDown, mdDown = _props$mdDown === void 0 ? false : _props$mdDown, _props$mdUp = props.mdUp, mdUp = _props$mdUp === void 0 ? false : _props$mdUp, _props$smDown = props.smDown, smDown = _props$smDown === void 0 ? false : _props$smDown, _props$smUp = props.smUp, smUp = _props$smUp === void 0 ? false : _props$smUp, _props$xlDown = props.xlDown, xlDown = _props$xlDown === void 0 ? false : _props$xlDown, _props$xlUp = props.xlUp, xlUp = _props$xlUp === void 0 ? false : _props$xlUp, _props$xsDown = props.xsDown, xsDown = _props$xsDown === void 0 ? false : _props$xsDown, _props$xsUp = props.xsUp, xsUp = _props$xsUp === void 0 ? false : _props$xsUp, other = (0,objectWithoutProperties/* default */.A)(props, ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
  if (implementation === "js") {
    return /* @__PURE__ */ index_js_eager_.createElement(Hidden_HiddenJs, (0,esm_extends/* default */.A)({
      lgDown,
      lgUp,
      mdDown,
      mdUp,
      smDown,
      smUp,
      xlDown,
      xlUp,
      xsDown,
      xsUp
    }, other));
  }
  return /* @__PURE__ */ index_js_eager_.createElement(Hidden_HiddenCss, (0,esm_extends/* default */.A)({
    lgDown,
    lgUp,
    mdDown,
    mdUp,
    smDown,
    smUp,
    xlDown,
    xlUp,
    xsDown,
    xsUp
  }, other));
}
 false ? 0 : void 0;
/* harmony default export */ var Hidden_Hidden = (Hidden);

;// ./node_modules/@material-ui/core/esm/Icon/Icon.js








var Icon_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: "none",
      fontSize: theme.typography.pxToRem(24),
      width: "1em",
      height: "1em",
      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
      // To remove at some point.
      overflow: "hidden",
      flexShrink: 0
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },
    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },
    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: "inherit"
    },
    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },
    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(36)
    }
  };
};
var Icon = /* @__PURE__ */ index_js_eager_.forwardRef(function Icon2(props, ref) {
  var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "inherit" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "span" : _props$component, _props$fontSize = props.fontSize, fontSize = _props$fontSize === void 0 ? "medium" : _props$fontSize, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "color", "component", "fontSize"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])("material-icons", classes.root, className, color !== "inherit" && classes["color".concat((0,capitalize/* default */.A)(color))], fontSize !== "default" && fontSize !== "medium" && classes["fontSize".concat((0,capitalize/* default */.A)(fontSize))]),
    "aria-hidden": true,
    ref
  }, other));
});
 false ? 0 : void 0;
Icon.muiName = "Icon";
/* harmony default export */ var Icon_Icon = ((0,withStyles/* default */.A)(Icon_styles, {
  name: "MuiIcon"
})(Icon));

;// ./node_modules/@material-ui/core/esm/ImageList/ImageList.js








var ImageList_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    flexWrap: "wrap",
    overflowY: "auto",
    listStyle: "none",
    padding: 0,
    WebkitOverflowScrolling: "touch"
    // Add iOS momentum scrolling.
  }
};
var ImageList = /* @__PURE__ */ index_js_eager_.forwardRef(function ImageList2(props, ref) {
  var cellHeight = props.cellHeight, children = props.children, classes = props.classes, className = props.className, _props$cols = props.cols, cols = _props$cols === void 0 ? 2 : _props$cols, _props$component = props.component, Component = _props$component === void 0 ? "ul" : _props$component, _props$gap = props.gap, gapProp = _props$gap === void 0 ? 4 : _props$gap, _props$rowHeight = props.rowHeight, rowHeightProp = _props$rowHeight === void 0 ? 180 : _props$rowHeight, spacing = props.spacing, style = props.style, other = (0,objectWithoutProperties/* default */.A)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "gap", "rowHeight", "spacing", "style"]);
  var gap = spacing || gapProp;
  var rowHeight = cellHeight || rowHeightProp;
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref,
    style: (0,esm_extends/* default */.A)({
      margin: -gap / 2
    }, style)
  }, other), index_js_eager_.Children.map(children, function(child) {
    if (!/* @__PURE__ */ index_js_eager_.isValidElement(child)) {
      return null;
    }
    if (false) // removed by dead control flow
{}
    var childCols = child.props.cols || 1;
    var childRows = child.props.rows || 1;
    return /* @__PURE__ */ index_js_eager_.cloneElement(child, {
      style: (0,esm_extends/* default */.A)({
        width: "".concat(100 / cols * childCols, "%"),
        height: rowHeight === "auto" ? "auto" : rowHeight * childRows + gap,
        padding: gap / 2
      }, child.props.style)
    });
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var ImageList_ImageList = ((0,withStyles/* default */.A)(ImageList_styles, {
  name: "MuiImageList"
})(ImageList));

;// ./node_modules/@material-ui/core/esm/ImageListItem/ImageListItem.js









var ImageListItem_styles = {
  /* Styles applied to the root element. */
  root: {
    boxSizing: "border-box",
    flexShrink: 0
  },
  /* Styles applied to the `div` element that wraps the children. */
  item: {
    position: "relative",
    display: "block",
    // In case it's not rendered with a div.
    height: "100%",
    overflow: "hidden"
  },
  /* Styles applied to an `img` element child, if needed to ensure it covers the item. */
  imgFullHeight: {
    height: "100%",
    transform: "translateX(-50%)",
    position: "relative",
    left: "50%"
  },
  /* Styles applied to an `img` element child, if needed to ensure it covers the item. */
  imgFullWidth: {
    width: "100%",
    position: "relative",
    transform: "translateY(-50%)",
    top: "50%"
  }
};
var ImageListItem_fit = function fit2(imgEl, classes) {
  if (!imgEl || !imgEl.complete) {
    return;
  }
  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
    var _imgEl$classList, _imgEl$classList2;
    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, (0,toConsumableArray/* default */.A)(classes.imgFullWidth.split(" ")));
    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, (0,toConsumableArray/* default */.A)(classes.imgFullHeight.split(" ")));
  } else {
    var _imgEl$classList3, _imgEl$classList4;
    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, (0,toConsumableArray/* default */.A)(classes.imgFullHeight.split(" ")));
    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, (0,toConsumableArray/* default */.A)(classes.imgFullWidth.split(" ")));
  }
};
function ImageListItem_ensureImageCover(imgEl, classes) {
  if (!imgEl) {
    return;
  }
  if (imgEl.complete) {
    ImageListItem_fit(imgEl, classes);
  } else {
    imgEl.addEventListener("load", function() {
      ImageListItem_fit(imgEl, classes);
    });
  }
}
var ImageListItem = /* @__PURE__ */ index_js_eager_.forwardRef(function ImageListItem2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$cols = props.cols, cols = _props$cols === void 0 ? 1 : _props$cols, _props$component = props.component, Component = _props$component === void 0 ? "li" : _props$component, _props$rows = props.rows, rows = _props$rows === void 0 ? 1 : _props$rows, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "cols", "component", "rows"]);
  var imgRef = index_js_eager_.useRef(null);
  index_js_eager_.useEffect(function() {
    ImageListItem_ensureImageCover(imgRef.current, classes);
  });
  index_js_eager_.useEffect(function() {
    var handleResize = (0,debounce/* default */.A)(function() {
      ImageListItem_fit(imgRef.current, classes);
    });
    window.addEventListener("resize", handleResize);
    return function() {
      handleResize.clear();
      window.removeEventListener("resize", handleResize);
    };
  }, [classes]);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.item
  }, index_js_eager_.Children.map(children, function(child) {
    if (!/* @__PURE__ */ index_js_eager_.isValidElement(child)) {
      return null;
    }
    if (child.type === "img" || (0,isMuiElement/* default */.A)(child, ["Image"])) {
      return /* @__PURE__ */ index_js_eager_.cloneElement(child, {
        ref: imgRef
      });
    }
    return child;
  })));
});
 false ? 0 : void 0;
/* harmony default export */ var ImageListItem_ImageListItem = ((0,withStyles/* default */.A)(ImageListItem_styles, {
  name: "MuiImageListItem"
})(ImageListItem));

;// ./node_modules/@material-ui/core/esm/ImageListItemBar/ImageListItemBar.js







var ImageListItemBar_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "absolute",
      left: 0,
      right: 0,
      height: 48,
      background: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      fontFamily: theme.typography.fontFamily
    },
    /* Styles applied to the root element if `position="bottom"`. */
    positionBottom: {
      bottom: 0
    },
    /* Styles applied to the root element if `position="top"`. */
    positionTop: {
      top: 0
    },
    /* Styles applied to the root element if a `subtitle` is provided. */
    rootSubtitle: {
      height: 68
    },
    /* Styles applied to the title and subtitle container element. */
    titleWrap: {
      flexGrow: 1,
      marginLeft: 16,
      marginRight: 16,
      color: theme.palette.common.white,
      overflow: "hidden"
    },
    /* Styles applied to the container element if `actionPosition="left"`. */
    titleWrapActionPosLeft: {
      marginLeft: 0
    },
    /* Styles applied to the container element if `actionPosition="right"`. */
    titleWrapActionPosRight: {
      marginRight: 0
    },
    /* Styles applied to the title container element. */
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: "24px",
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap"
    },
    /* Styles applied to the subtitle container element. */
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1,
      textOverflow: "ellipsis",
      overflow: "hidden",
      whiteSpace: "nowrap"
    },
    /* Styles applied to the actionIcon if supplied. */
    actionIcon: {},
    /* Styles applied to the actionIcon if `actionPosition="left"`. */
    actionIconActionPosLeft: {
      order: -1
    }
  };
};
var ImageListItemBar = /* @__PURE__ */ index_js_eager_.forwardRef(function ImageListItemBar2(props, ref) {
  var actionIcon = props.actionIcon, _props$actionPosition = props.actionPosition, actionPosition = _props$actionPosition === void 0 ? "right" : _props$actionPosition, classes = props.classes, className = props.className, subtitle = props.subtitle, title = props.title, _props$position = props.position, positionProp = _props$position === void 0 ? "bottom" : _props$position, titlePosition = props.titlePosition, other = (0,objectWithoutProperties/* default */.A)(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "position", "titlePosition"]);
  var position = titlePosition || positionProp;
  var actionPos = actionIcon && actionPosition;
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, subtitle && classes.rootSubtitle, {
      "bottom": classes.positionBottom,
      "top": classes.positionTop
    }[position]),
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: (0,clsx_m["default"])(classes.titleWrap, {
      "left": classes.titleWrapActionPosLeft,
      "right": classes.titleWrapActionPosRight
    }[actionPos])
  }, /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.title
  }, title), subtitle ? /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.subtitle
  }, subtitle) : null), actionIcon ? /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: (0,clsx_m["default"])(classes.actionIcon, actionPos === "left" && classes.actionIconActionPosLeft)
  }, actionIcon) : null);
});
 false ? 0 : void 0;
/* harmony default export */ var ImageListItemBar_ImageListItemBar = ((0,withStyles/* default */.A)(ImageListItemBar_styles, {
  name: "MuiImageListItemBar"
})(ImageListItemBar));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Input/Input.js
var Input = __webpack_require__(99266);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputAdornment/InputAdornment.js
var InputAdornment = __webpack_require__(73968);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputBase/InputBase.js
var InputBase = __webpack_require__(1766);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/InputLabel/InputLabel.js
var InputLabel = __webpack_require__(96900);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(96724);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(6606);
;// ./node_modules/@material-ui/core/esm/Link/Link.js











var Link_styles = {
  /* Styles applied to the root element. */
  root: {},
  /* Styles applied to the root element if `underline="none"`. */
  underlineNone: {
    textDecoration: "none"
  },
  /* Styles applied to the root element if `underline="hover"`. */
  underlineHover: {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  /* Styles applied to the root element if `underline="always"`. */
  underlineAlways: {
    textDecoration: "underline"
  },
  // Same reset as ButtonBase.root
  /* Styles applied to the root element if `component="button"`. */
  button: {
    position: "relative",
    WebkitTapHighlightColor: "transparent",
    backgroundColor: "transparent",
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    "-moz-appearance": "none",
    // Reset
    "-webkit-appearance": "none",
    // Reset
    "&::-moz-focus-inner": {
      borderStyle: "none"
      // Remove Firefox dotted outline.
    },
    "&$focusVisible": {
      outline: "auto"
    }
  },
  /* Pseudo-class applied to the root element if the link is keyboard focused. */
  focusVisible: {}
};
var Link = /* @__PURE__ */ index_js_eager_.forwardRef(function Link2(props, ref) {
  var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, component = _props$component === void 0 ? "a" : _props$component, onBlur = props.onBlur, onFocus = props.onFocus, TypographyClasses = props.TypographyClasses, _props$underline = props.underline, underline = _props$underline === void 0 ? "hover" : _props$underline, _props$variant = props.variant, variant = _props$variant === void 0 ? "inherit" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]);
  var _useIsFocusVisible = (0,useIsFocusVisible/* default */.A)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
  var _React$useState = index_js_eager_.useState(false), focusVisible = _React$useState[0], setFocusVisible = _React$useState[1];
  var handlerRef = (0,useForkRef/* default */.A)(ref, focusVisibleRef);
  var handleBlur = function handleBlur2(event) {
    if (focusVisible) {
      onBlurVisible();
      setFocusVisible(false);
    }
    if (onBlur) {
      onBlur(event);
    }
  };
  var handleFocus = function handleFocus2(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  return /* @__PURE__ */ index_js_eager_.createElement(Typography/* default */.A, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, classes["underline".concat((0,capitalize/* default */.A)(underline))], className, focusVisible && classes.focusVisible, component === "button" && classes.button),
    classes: TypographyClasses,
    color,
    component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    variant
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Link_Link = ((0,withStyles/* default */.A)(Link_styles, {
  name: "MuiLink"
})(Link));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/List.js
var List = __webpack_require__(2544);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/ListItem/ListItem.js
var ListItem = __webpack_require__(2002);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/List/ListContext.js
var ListContext = __webpack_require__(36421);
;// ./node_modules/@material-ui/core/esm/ListItemAvatar/ListItemAvatar.js







var ListItemAvatar_styles = {
  /* Styles applied to the root element. */
  root: {
    minWidth: 56,
    flexShrink: 0
  },
  /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
  alignItemsFlexStart: {
    marginTop: 8
  }
};
var ListItemAvatar = /* @__PURE__ */ index_js_eager_.forwardRef(function ListItemAvatar2(props, ref) {
  var classes = props.classes, className = props.className, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className"]);
  var context = index_js_eager_.useContext(ListContext/* default */.A);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, context.alignItems === "flex-start" && classes.alignItemsFlexStart),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var ListItemAvatar_ListItemAvatar = ((0,withStyles/* default */.A)(ListItemAvatar_styles, {
  name: "MuiListItemAvatar"
})(ListItemAvatar));

;// ./node_modules/@material-ui/core/esm/ListItemIcon/ListItemIcon.js







var ListItemIcon_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      minWidth: 56,
      color: theme.palette.action.active,
      flexShrink: 0,
      display: "inline-flex"
    },
    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      marginTop: 8
    }
  };
};
var ListItemIcon = /* @__PURE__ */ index_js_eager_.forwardRef(function ListItemIcon2(props, ref) {
  var classes = props.classes, className = props.className, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className"]);
  var context = index_js_eager_.useContext(ListContext/* default */.A);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, context.alignItems === "flex-start" && classes.alignItemsFlexStart),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var ListItemIcon_ListItemIcon = ((0,withStyles/* default */.A)(ListItemIcon_styles, {
  name: "MuiListItemIcon"
})(ListItemIcon));

;// ./node_modules/@material-ui/core/esm/ListItemSecondaryAction/ListItemSecondaryAction.js






var ListItemSecondaryAction_styles = {
  /* Styles applied to the root element. */
  root: {
    position: "absolute",
    right: 16,
    top: "50%",
    transform: "translateY(-50%)"
  }
};
var ListItemSecondaryAction = /* @__PURE__ */ index_js_eager_.forwardRef(function ListItemSecondaryAction2(props, ref) {
  var classes = props.classes, className = props.className, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className"]);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref
  }, other));
});
 false ? 0 : void 0;
ListItemSecondaryAction.muiName = "ListItemSecondaryAction";
/* harmony default export */ var ListItemSecondaryAction_ListItemSecondaryAction = ((0,withStyles/* default */.A)(ListItemSecondaryAction_styles, {
  name: "MuiListItemSecondaryAction"
})(ListItemSecondaryAction));

;// ./node_modules/@material-ui/core/esm/ListItemText/ListItemText.js








var ListItemText_styles = {
  /* Styles applied to the root element. */
  root: {
    flex: "1 1 auto",
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4
  },
  /* Styles applied to the `Typography` components if primary and secondary are set. */
  multiline: {
    marginTop: 6,
    marginBottom: 6
  },
  /* Styles applied to the `Typography` components if dense. */
  dense: {},
  /* Styles applied to the root element if `inset={true}`. */
  inset: {
    paddingLeft: 56
  },
  /* Styles applied to the primary `Typography` component. */
  primary: {},
  /* Styles applied to the secondary `Typography` component. */
  secondary: {}
};
var ListItemText = /* @__PURE__ */ index_js_eager_.forwardRef(function ListItemText2(props, ref) {
  var children = props.children, classes = props.classes, className = props.className, _props$disableTypogra = props.disableTypography, disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra, _props$inset = props.inset, inset = _props$inset === void 0 ? false : _props$inset, primaryProp = props.primary, primaryTypographyProps = props.primaryTypographyProps, secondaryProp = props.secondary, secondaryTypographyProps = props.secondaryTypographyProps, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);
  var _React$useContext = index_js_eager_.useContext(ListContext/* default */.A), dense = _React$useContext.dense;
  var primary = primaryProp != null ? primaryProp : children;
  if (primary != null && primary.type !== Typography/* default */.A && !disableTypography) {
    primary = /* @__PURE__ */ index_js_eager_.createElement(Typography/* default */.A, (0,esm_extends/* default */.A)({
      variant: dense ? "body2" : "body1",
      className: classes.primary,
      component: "span",
      display: "block"
    }, primaryTypographyProps), primary);
  }
  var secondary = secondaryProp;
  if (secondary != null && secondary.type !== Typography/* default */.A && !disableTypography) {
    secondary = /* @__PURE__ */ index_js_eager_.createElement(Typography/* default */.A, (0,esm_extends/* default */.A)({
      variant: "body2",
      className: classes.secondary,
      color: "textSecondary",
      display: "block"
    }, secondaryTypographyProps), secondary);
  }
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
    ref
  }, other), primary, secondary);
});
 false ? 0 : void 0;
/* harmony default export */ var ListItemText_ListItemText = ((0,withStyles/* default */.A)(ListItemText_styles, {
  name: "MuiListItemText"
})(ListItemText));

;// ./node_modules/@material-ui/core/esm/ListSubheader/ListSubheader.js







var ListSubheader_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      boxSizing: "border-box",
      lineHeight: "48px",
      listStyle: "none",
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14)
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },
    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: "inherit"
    },
    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },
    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      paddingLeft: 72
    },
    /* Styles applied to the root element if `disableSticky={false}`. */
    sticky: {
      position: "sticky",
      top: 0,
      zIndex: 1,
      backgroundColor: "inherit"
    }
  };
};
var ListSubheader = /* @__PURE__ */ index_js_eager_.forwardRef(function ListSubheader2(props, ref) {
  var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "default" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "li" : _props$component, _props$disableGutters = props.disableGutters, disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters, _props$disableSticky = props.disableSticky, disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky, _props$inset = props.inset, inset = _props$inset === void 0 ? false : _props$inset, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, color !== "default" && classes["color".concat((0,capitalize/* default */.A)(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var ListSubheader_ListSubheader = ((0,withStyles/* default */.A)(ListSubheader_styles, {
  name: "MuiListSubheader"
})(ListSubheader));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Menu/Menu.js
var Menu = __webpack_require__(12330);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(91336);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/MenuList/MenuList.js
var MenuList = __webpack_require__(2434);
;// ./node_modules/@material-ui/core/esm/MobileStepper/MobileStepper.js










var MobileStepper_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      background: theme.palette.background.default,
      padding: 8
    },
    /* Styles applied to the root element if `position="bottom"`. */
    positionBottom: {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },
    /* Styles applied to the root element if `position="top"`. */
    positionTop: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },
    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {},
    /* Styles applied to the dots container if `variant="dots"`. */
    dots: {
      display: "flex",
      flexDirection: "row"
    },
    /* Styles applied to each dot if `variant="dots"`. */
    dot: {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: "50%",
      width: 8,
      height: 8,
      margin: "0 2px"
    },
    /* Styles applied to a dot if `variant="dots"` and this is the active step. */
    dotActive: {
      backgroundColor: theme.palette.primary.main
    },
    /* Styles applied to the Linear Progress component if `variant="progress"`. */
    progress: {
      width: "50%"
    }
  };
};
var MobileStepper = /* @__PURE__ */ index_js_eager_.forwardRef(function MobileStepper2(props, ref) {
  var _props$activeStep = props.activeStep, activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep, backButton = props.backButton, classes = props.classes, className = props.className, LinearProgressProps = props.LinearProgressProps, nextButton = props.nextButton, _props$position = props.position, position = _props$position === void 0 ? "bottom" : _props$position, steps = props.steps, _props$variant = props.variant, variant = _props$variant === void 0 ? "dots" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["activeStep", "backButton", "classes", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Paper/* default */.A, (0,esm_extends/* default */.A)({
    square: true,
    elevation: 0,
    className: (0,clsx_m["default"])(classes.root, classes["position".concat((0,capitalize/* default */.A)(position))], className),
    ref
  }, other), backButton, variant === "text" && /* @__PURE__ */ index_js_eager_.createElement(index_js_eager_.Fragment, null, activeStep + 1, " / ", steps), variant === "dots" && /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.dots
  }, (0,toConsumableArray/* default */.A)(new Array(steps)).map(function(_, index) {
    return /* @__PURE__ */ index_js_eager_.createElement("div", {
      key: index,
      className: (0,clsx_m["default"])(classes.dot, index === activeStep && classes.dotActive)
    });
  })), variant === "progress" && /* @__PURE__ */ index_js_eager_.createElement(LinearProgress/* default */.A, (0,esm_extends/* default */.A)({
    className: classes.progress,
    variant: "determinate",
    value: Math.ceil(activeStep / (steps - 1) * 100)
  }, LinearProgressProps)), nextButton);
});
 false ? 0 : void 0;
/* harmony default export */ var MobileStepper_MobileStepper = ((0,withStyles/* default */.A)(MobileStepper_styles, {
  name: "MuiMobileStepper"
})(MobileStepper));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Modal/ModalManager.js
var ModalManager = __webpack_require__(2563);
;// ./node_modules/@material-ui/core/esm/Modal/index.js



// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/NativeSelect/NativeSelect.js
var NativeSelect = __webpack_require__(10922);
;// ./node_modules/@material-ui/core/esm/NoSsr/NoSsr.js



var NoSsr_useEnhancedEffect = typeof window !== "undefined" && "production" !== "test" ? index_js_eager_.useLayoutEffect : index_js_eager_.useEffect;
function NoSsr(props) {
  var children = props.children, _props$defer = props.defer, defer = _props$defer === void 0 ? false : _props$defer, _props$fallback = props.fallback, fallback = _props$fallback === void 0 ? null : _props$fallback;
  var _React$useState = index_js_eager_.useState(false), mountedState = _React$useState[0], setMountedState = _React$useState[1];
  NoSsr_useEnhancedEffect(function() {
    if (!defer) {
      setMountedState(true);
    }
  }, [defer]);
  index_js_eager_.useEffect(function() {
    if (defer) {
      setMountedState(true);
    }
  }, [defer]);
  return /* @__PURE__ */ index_js_eager_.createElement(index_js_eager_.Fragment, null, mountedState ? children : fallback);
}
 false ? 0 : void 0;
if (false) // removed by dead control flow
{}
/* harmony default export */ var NoSsr_NoSsr = (NoSsr);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/OutlinedInput/OutlinedInput.js + 1 modules
var OutlinedInput = __webpack_require__(28662);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Popover/Popover.js
var Popover = __webpack_require__(898);
;// ./node_modules/popper.js/dist/esm/popper.js
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
var timeoutDuration = (function() {
  var longerTimeoutBrowsers = ["Edge", "Trident", "Firefox"];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
})();
function microtaskDebounce(fn) {
  var called = false;
  return function() {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function() {
      called = false;
      fn();
    });
  };
}
function taskDebounce(fn) {
  var scheduled = false;
  return function() {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function() {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}
var supportsMicroTasks = isBrowser && window.Promise;
var popper_debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
}
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  var window2 = element.ownerDocument.defaultView;
  var css = window2.getComputedStyle(element, null);
  return property ? css[property] : css;
}
function getParentNode(element) {
  if (element.nodeName === "HTML") {
    return element;
  }
  return element.parentNode || element.host;
}
function getScrollParent(element) {
  if (!element) {
    return document.body;
  }
  switch (element.nodeName) {
    case "HTML":
    case "BODY":
      return element.ownerDocument.body;
    case "#document":
      return element.body;
  }
  var _getStyleComputedProp = getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }
  return getScrollParent(getParentNode(element));
}
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }
  var noOffsetParent = isIE(10) ? document.body : null;
  var offsetParent = element.offsetParent || null;
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }
  var nodeName = offsetParent && offsetParent.nodeName;
  if (!nodeName || nodeName === "BODY" || nodeName === "HTML") {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }
  if (["TH", "TD", "TABLE"].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, "position") === "static") {
    return getOffsetParent(offsetParent);
  }
  return offsetParent;
}
function isOffsetContainer(element) {
  var nodeName = element.nodeName;
  if (nodeName === "BODY") {
    return false;
  }
  return nodeName === "HTML" || getOffsetParent(element.firstElementChild) === element;
}
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }
  return node;
}
function findCommonOffsetParent(element1, element2) {
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;
  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }
    return getOffsetParent(commonAncestorContainer);
  }
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "top";
  var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
  var nodeName = element.nodeName;
  if (nodeName === "BODY" || nodeName === "HTML") {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }
  return element[upperSide];
}
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var scrollTop = getScroll(element, "top");
  var scrollLeft = getScroll(element, "left");
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}
function getBordersSize(styles, axis) {
  var sideA = axis === "x" ? "Left" : "Top";
  var sideB = sideA === "Left" ? "Right" : "Bottom";
  return parseFloat(styles["border" + sideA + "Width"]) + parseFloat(styles["border" + sideB + "Width"]);
}
function getSize(axis, body, html, computedStyle) {
  return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], isIE(10) ? parseInt(html["offset" + axis]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
}
function getWindowSizes(document2) {
  var body = document2.body;
  var html = document2.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);
  return {
    height: getSize("Height", body, html, computedStyle),
    width: getSize("Width", body, html, computedStyle)
  };
}
var classCallCheck = function(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = /* @__PURE__ */ (function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();
var popper_defineProperty = function(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
};
var _extends = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}
function getBoundingClientRect(element) {
  var rect = {};
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, "top");
      var scrollLeft = getScroll(element, "left");
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {
  }
  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
  var sizes = element.nodeName === "HTML" ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;
  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, "x");
    vertScrollbar -= getBordersSize(styles, "y");
    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }
  return getClientRect(result);
}
function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var isIE102 = isIE(10);
  var isHTML = parent.nodeName === "HTML";
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);
  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;
  if (!isIE102 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);
    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }
  if (isIE102 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== "BODY") {
    offsets = includeScroll(offsets, parent);
  }
  return offsets;
}
function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);
  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, "left") : 0;
  var offset2 = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width,
    height
  };
  return getClientRect(offset2);
}
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === "BODY" || nodeName === "HTML") {
    return false;
  }
  if (getStyleComputedProperty(element, "position") === "fixed") {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}
function getFixedPositionOffsetParent(element) {
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, "transform") === "none") {
    el = el.parentElement;
  }
  return el || document.documentElement;
}
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  if (boundariesElement === "viewport") {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    var boundariesNode = void 0;
    if (boundariesElement === "scrollParent") {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === "BODY") {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === "window") {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }
    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
    if (boundariesNode.nodeName === "HTML" && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      boundaries = offsets;
    }
  }
  padding = padding || 0;
  var isPaddingNumber = typeof padding === "number";
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
  return boundaries;
}
function getArea(_ref) {
  var width = _ref.width, height = _ref.height;
  return width * height;
}
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
  if (placement.indexOf("auto") === -1) {
    return placement;
  }
  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };
  var sortedAreas = Object.keys(rects).map(function(key) {
    return _extends({
      key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function(a, b) {
    return b.area - a.area;
  });
  var filteredAreas = sortedAreas.filter(function(_ref2) {
    var width = _ref2.width, height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });
  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
  var variation = placement.split("-")[1];
  return computedPlacement + (variation ? "-" + variation : "");
}
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
function getOuterSizes(element) {
  var window2 = element.ownerDocument.defaultView;
  var styles = window2.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}
function getOppositePlacement(placement) {
  var hash = { left: "right", right: "left", bottom: "top", top: "bottom" };
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash[matched];
  });
}
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split("-")[0];
  var popperRect = getOuterSizes(popper);
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };
  var isHoriz = ["right", "left"].indexOf(placement) !== -1;
  var mainSide = isHoriz ? "top" : "left";
  var secondarySide = isHoriz ? "left" : "top";
  var measurement = isHoriz ? "height" : "width";
  var secondaryMeasurement = !isHoriz ? "height" : "width";
  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }
  return popperOffsets;
}
function find(arr, check) {
  if (Array.prototype.find) {
    return arr.find(check);
  }
  return arr.filter(check)[0];
}
function findIndex(arr, prop, value) {
  if (Array.prototype.findIndex) {
    return arr.findIndex(function(cur) {
      return cur[prop] === value;
    });
  }
  var match = find(arr, function(obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}
function runModifiers(modifiers2, data, ends) {
  var modifiersToRun = ends === void 0 ? modifiers2 : modifiers2.slice(0, findIndex(modifiers2, "name", ends));
  modifiersToRun.forEach(function(modifier) {
    if (modifier["function"]) {
      console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
    }
    var fn = modifier["function"] || modifier.fn;
    if (modifier.enabled && isFunction(fn)) {
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);
      data = fn(data, modifier);
    }
  });
  return data;
}
function update() {
  if (this.state.isDestroyed) {
    return;
  }
  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
  data.originalPlacement = data.placement;
  data.positionFixed = this.options.positionFixed;
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
  data = runModifiers(this.modifiers, data);
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}
function isModifierEnabled(modifiers2, modifierName) {
  return modifiers2.some(function(_ref) {
    var name = _ref.name, enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}
function getSupportedPropertyName(property) {
  var prefixes = [false, "ms", "Webkit", "Moz", "O"];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? "" + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== "undefined") {
      return toCheck;
    }
  }
  return null;
}
function destroy() {
  this.state.isDestroyed = true;
  if (isModifierEnabled(this.modifiers, "applyStyle")) {
    this.popper.removeAttribute("x-placement");
    this.popper.style.position = "";
    this.popper.style.top = "";
    this.popper.style.left = "";
    this.popper.style.right = "";
    this.popper.style.bottom = "";
    this.popper.style.willChange = "";
    this.popper.style[getSupportedPropertyName("transform")] = "";
  }
  this.disableEventListeners();
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}
function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === "BODY";
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });
  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}
function setupEventListeners(reference, options, state, updateBound) {
  state.updateBound = updateBound;
  getWindow(reference).addEventListener("resize", state.updateBound, { passive: true });
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;
  return state;
}
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}
function removeEventListeners(reference, state) {
  getWindow(reference).removeEventListener("resize", state.updateBound);
  state.scrollParents.forEach(function(target) {
    target.removeEventListener("scroll", state.updateBound);
  });
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}
function isNumeric(n) {
  return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
}
function setStyles(element, styles) {
  Object.keys(styles).forEach(function(prop) {
    var unit = "";
    if (["width", "height", "top", "right", "bottom", "left"].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = "px";
    }
    element.style[prop] = styles[prop] + unit;
  });
}
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function(prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}
function applyStyle(data) {
  setStyles(data.instance.popper, data.styles);
  setAttributes(data.instance.popper, data.attributes);
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }
  return data;
}
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
  popper.setAttribute("x-placement", placement);
  setStyles(popper, { position: options.positionFixed ? "fixed" : "absolute" });
  return options;
}
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var round = Math.round, floor = Math.floor;
  var noRound = function noRound2(v) {
    return v;
  };
  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);
  var isVertical = ["left", "right"].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf("-") !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;
  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}
var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
function computeStyle(data, options) {
  var x = options.x, y = options.y;
  var popper = data.offsets.popper;
  var legacyGpuAccelerationOption = find(data.instance.modifiers, function(modifier) {
    return modifier.name === "applyStyle";
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== void 0) {
    console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== void 0 ? legacyGpuAccelerationOption : options.gpuAcceleration;
  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);
  var styles = {
    position: popper.position
  };
  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
  var sideA = x === "bottom" ? "top" : "bottom";
  var sideB = y === "right" ? "left" : "right";
  var prefixedProperty = getSupportedPropertyName("transform");
  var left = void 0, top = void 0;
  if (sideA === "bottom") {
    if (offsetParent.nodeName === "HTML") {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === "right") {
    if (offsetParent.nodeName === "HTML") {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = "transform";
  } else {
    var invertTop = sideA === "bottom" ? -1 : 1;
    var invertLeft = sideB === "right" ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ", " + sideB;
  }
  var attributes = {
    "x-placement": data.placement
  };
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
  return data;
}
function isModifierRequired(modifiers2, requestingName, requestedName) {
  var requesting = find(modifiers2, function(_ref) {
    var name = _ref.name;
    return name === requestingName;
  });
  var isRequired = !!requesting && modifiers2.some(function(modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });
  if (!isRequired) {
    var _requesting = "`" + requestingName + "`";
    var requested = "`" + requestedName + "`";
    console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
  }
  return isRequired;
}
function arrow(data, options) {
  var _data$offsets$arrow;
  if (!isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) {
    return data;
  }
  var arrowElement = options.element;
  if (typeof arrowElement === "string") {
    arrowElement = data.instance.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return data;
    }
  } else {
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn("WARNING: `arrow.element` must be child of its popper element!");
      return data;
    }
  }
  var placement = data.placement.split("-")[0];
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var isVertical = ["left", "right"].indexOf(placement) !== -1;
  var len = isVertical ? "height" : "width";
  var sideCapitalized = isVertical ? "Top" : "Left";
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? "left" : "top";
  var opSide = isVertical ? "bottom" : "right";
  var arrowElementSize = getOuterSizes(arrowElement)[len];
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css["margin" + sideCapitalized]);
  var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"]);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, popper_defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), popper_defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
  return data;
}
function getOppositeVariation(variation) {
  if (variation === "end") {
    return "start";
  } else if (variation === "start") {
    return "end";
  }
  return variation;
}
var placements = ["auto-start", "auto", "auto-end", "top-start", "top", "top-end", "right-start", "right", "right-end", "bottom-end", "bottom", "bottom-start", "left-end", "left", "left-start"];
var validPlacements = placements.slice(3);
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}
var BEHAVIORS = {
  FLIP: "flip",
  CLOCKWISE: "clockwise",
  COUNTERCLOCKWISE: "counterclockwise"
};
function flip(data, options) {
  if (isModifierEnabled(data.instance.modifiers, "inner")) {
    return data;
  }
  if (data.flipped && data.placement === data.originalPlacement) {
    return data;
  }
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
  var placement = data.placement.split("-")[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split("-")[1] || "";
  var flipOrder = [];
  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }
  flipOrder.forEach(function(step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }
    placement = data.placement.split("-")[0];
    placementOpposite = getOppositePlacement(placement);
    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;
    var floor = Math.floor;
    var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
    var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
    var isVertical = ["top", "bottom"].indexOf(placement) !== -1;
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      data.flipped = true;
      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }
      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }
      data.placement = placement + (variation ? "-" + variation : "");
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
      data = runModifiers(data.instance.modifiers, data, "flip");
    }
  });
  return data;
}
function keepTogether(data) {
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var placement = data.placement.split("-")[0];
  var floor = Math.floor;
  var isVertical = ["top", "bottom"].indexOf(placement) !== -1;
  var side = isVertical ? "right" : "bottom";
  var opSide = isVertical ? "left" : "top";
  var measurement = isVertical ? "width" : "height";
  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }
  return data;
}
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];
  if (!value) {
    return str;
  }
  if (unit.indexOf("%") === 0) {
    var element = void 0;
    switch (unit) {
      case "%p":
        element = popperOffsets;
        break;
      case "%":
      case "%r":
      default:
        element = referenceOffsets;
    }
    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === "vh" || unit === "vw") {
    var size = void 0;
    if (unit === "vh") {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    return value;
  }
}
function parseOffset(offset2, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];
  var useHeight = ["right", "left"].indexOf(basePlacement) !== -1;
  var fragments = offset2.split(/(\+|\-)/).map(function(frag) {
    return frag.trim();
  });
  var divider = fragments.indexOf(find(fragments, function(frag) {
    return frag.search(/,|\s/) !== -1;
  }));
  if (fragments[divider] && fragments[divider].indexOf(",") === -1) {
    console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
  }
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
  ops = ops.map(function(op, index) {
    var measurement = (index === 1 ? !useHeight : useHeight) ? "height" : "width";
    var mergeWithPrevious = false;
    return op.reduce(function(a, b) {
      if (a[a.length - 1] === "" && ["+", "-"].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, []).map(function(str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });
  ops.forEach(function(op, index) {
    op.forEach(function(frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
      }
    });
  });
  return offsets;
}
function offset(data, _ref) {
  var offset2 = _ref.offset;
  var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var basePlacement = placement.split("-")[0];
  var offsets = void 0;
  if (isNumeric(+offset2)) {
    offsets = [+offset2, 0];
  } else {
    offsets = parseOffset(offset2, popper, reference, basePlacement);
  }
  if (basePlacement === "left") {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === "right") {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === "top") {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === "bottom") {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }
  data.popper = popper;
  return data;
}
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }
  var transformProp = getSupportedPropertyName("transform");
  var popperStyles = data.instance.popper.style;
  var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
  popperStyles.top = "";
  popperStyles.left = "";
  popperStyles[transformProp] = "";
  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;
  options.boundaries = boundaries;
  var order = options.priority;
  var popper = data.offsets.popper;
  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return popper_defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === "right" ? "left" : "top";
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
      }
      return popper_defineProperty({}, mainSide, value);
    }
  };
  order.forEach(function(placement) {
    var side = ["left", "top"].indexOf(placement) !== -1 ? "primary" : "secondary";
    popper = _extends({}, popper, check[side](placement));
  });
  data.offsets.popper = popper;
  return data;
}
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split("-")[0];
  var shiftvariation = placement.split("-")[1];
  if (shiftvariation) {
    var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
    var isVertical = ["bottom", "top"].indexOf(basePlacement) !== -1;
    var side = isVertical ? "left" : "top";
    var measurement = isVertical ? "width" : "height";
    var shiftOffsets = {
      start: popper_defineProperty({}, side, reference[side]),
      end: popper_defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };
    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }
  return data;
}
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) {
    return data;
  }
  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function(modifier) {
    return modifier.name === "preventOverflow";
  }).boundaries;
  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    if (data.hide === true) {
      return data;
    }
    data.hide = true;
    data.attributes["x-out-of-boundaries"] = "";
  } else {
    if (data.hide === false) {
      return data;
    }
    data.hide = false;
    data.attributes["x-out-of-boundaries"] = false;
  }
  return data;
}
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split("-")[0];
  var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
  var isHoriz = ["left", "right"].indexOf(basePlacement) !== -1;
  var subtractLength = ["top", "left"].indexOf(basePlacement) === -1;
  popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);
  return data;
}
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },
  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },
  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ["left", "right", "top", "bottom"],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: "scrollParent"
  },
  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },
  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: "[x-arrow]"
  },
  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: "flip",
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: "viewport",
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },
  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },
  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },
  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: "bottom",
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: "right"
  },
  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: void 0
  }
};
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: "bottom",
  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,
  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,
  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,
  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {
  },
  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {
  },
  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers
};
var Popper = (function() {
  function Popper2(reference, popper) {
    var _this = this;
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    classCallCheck(this, Popper2);
    this.scheduleUpdate = function() {
      return requestAnimationFrame(_this.update);
    };
    this.update = popper_debounce(this.update.bind(this));
    this.options = _extends({}, Popper2.Defaults, options);
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper2.Defaults.modifiers, options.modifiers)).forEach(function(name) {
      _this.options.modifiers[name] = _extends({}, Popper2.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });
    this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
      return _extends({
        name
      }, _this.options.modifiers[name]);
    }).sort(function(a, b) {
      return a.order - b.order;
    });
    this.modifiers.forEach(function(modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });
    this.update();
    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      this.enableEventListeners();
    }
    this.state.eventsEnabled = eventsEnabled;
  }
  createClass(Popper2, [{
    key: "update",
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: "destroy",
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: "enableEventListeners",
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: "disableEventListeners",
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }
    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */
    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */
  }]);
  return Popper2;
})();
Popper.Utils = (typeof window !== "undefined" ? window : __webpack_require__.g).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;
/* harmony default export */ var esm_popper = (Popper);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Portal/Portal.js
var Portal = __webpack_require__(4163);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(33771);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/setRef.js
var setRef = __webpack_require__(58094);
;// ./node_modules/@material-ui/core/esm/Popper/Popper.js











function flipPlacement(placement, theme) {
  var direction = theme && theme.direction || "ltr";
  if (direction === "ltr") {
    return placement;
  }
  switch (placement) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return placement;
  }
}
function getAnchorEl(anchorEl) {
  return typeof anchorEl === "function" ? anchorEl() : anchorEl;
}
var Popper_useEnhancedEffect = typeof window !== "undefined" ? index_js_eager_.useLayoutEffect : index_js_eager_.useEffect;
var defaultPopperOptions = {};
var Popper_Popper = /* @__PURE__ */ index_js_eager_.forwardRef(function Popper2(props, ref) {
  var anchorEl = props.anchorEl, children = props.children, container = props.container, _props$disablePortal = props.disablePortal, disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal, _props$keepMounted = props.keepMounted, keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted, modifiers = props.modifiers, open = props.open, _props$placement = props.placement, initialPlacement = _props$placement === void 0 ? "bottom" : _props$placement, _props$popperOptions = props.popperOptions, popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions, popperRefProp = props.popperRef, style = props.style, _props$transition = props.transition, transition = _props$transition === void 0 ? false : _props$transition, other = (0,objectWithoutProperties/* default */.A)(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);
  var tooltipRef = index_js_eager_.useRef(null);
  var ownRef = (0,useForkRef/* default */.A)(tooltipRef, ref);
  var popperRef = index_js_eager_.useRef(null);
  var handlePopperRef = (0,useForkRef/* default */.A)(popperRef, popperRefProp);
  var handlePopperRefRef = index_js_eager_.useRef(handlePopperRef);
  Popper_useEnhancedEffect(function() {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  index_js_eager_.useImperativeHandle(popperRefProp, function() {
    return popperRef.current;
  }, []);
  var _React$useState = index_js_eager_.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
  var theme = (0,useTheme_useTheme/* default */.A)();
  var rtlPlacement = flipPlacement(initialPlacement, theme);
  var _React$useState2 = index_js_eager_.useState(rtlPlacement), placement = _React$useState2[0], setPlacement = _React$useState2[1];
  index_js_eager_.useEffect(function() {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });
  var handleOpen = index_js_eager_.useCallback(function() {
    if (!tooltipRef.current || !anchorEl || !open) {
      return;
    }
    if (popperRef.current) {
      popperRef.current.destroy();
      handlePopperRefRef.current(null);
    }
    var handlePopperUpdate = function handlePopperUpdate2(data) {
      setPlacement(data.placement);
    };
    var resolvedAnchorEl = getAnchorEl(anchorEl);
    if (false) // removed by dead control flow
{ var box; }
    var popper = new esm_popper(getAnchorEl(anchorEl), tooltipRef.current, (0,esm_extends/* default */.A)({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: (0,esm_extends/* default */.A)({}, disablePortal ? {} : {
        // It's using scrollParent by default, we can use the viewport when using a portal.
        preventOverflow: {
          boundariesElement: "window"
        }
      }, modifiers, popperOptions.modifiers),
      // We could have been using a custom modifier like react-popper is doing.
      // But it seems this is the best public API for this use case.
      onCreate: (0,createChainedFunction/* default */.A)(handlePopperUpdate, popperOptions.onCreate),
      onUpdate: (0,createChainedFunction/* default */.A)(handlePopperUpdate, popperOptions.onUpdate)
    }));
    handlePopperRefRef.current(popper);
  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
  var handleRef = index_js_eager_.useCallback(function(node) {
    (0,setRef/* default */.A)(ownRef, node);
    handleOpen();
  }, [ownRef, handleOpen]);
  var handleEnter = function handleEnter2() {
    setExited(false);
  };
  var handleClose = function handleClose2() {
    if (!popperRef.current) {
      return;
    }
    popperRef.current.destroy();
    handlePopperRefRef.current(null);
  };
  var handleExited = function handleExited2() {
    setExited(true);
    handleClose();
  };
  index_js_eager_.useEffect(function() {
    return function() {
      handleClose();
    };
  }, []);
  index_js_eager_.useEffect(function() {
    if (!open && !transition) {
      handleClose();
    }
  }, [open, transition]);
  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }
  var childProps = {
    placement
  };
  if (transition) {
    childProps.TransitionProps = {
      in: open,
      onEnter: handleEnter,
      onExited: handleExited
    };
  }
  return /* @__PURE__ */ index_js_eager_.createElement(Portal/* default */.A, {
    disablePortal,
    container
  }, /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    ref: handleRef,
    role: "tooltip"
  }, other, {
    style: (0,esm_extends/* default */.A)({
      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
      position: "fixed",
      // Fix Popper.js display issue
      top: 0,
      left: 0,
      display: !open && keepMounted && !transition ? "none" : null
    }, style)
  }), typeof children === "function" ? children(childProps) : children));
});
 false ? 0 : void 0;
/* harmony default export */ var esm_Popper_Popper = (Popper_Popper);

;// ./node_modules/@material-ui/core/esm/internal/svg-icons/RadioButtonUnchecked.js


/* harmony default export */ var RadioButtonUnchecked = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"));

;// ./node_modules/@material-ui/core/esm/internal/svg-icons/RadioButtonChecked.js


/* harmony default export */ var RadioButtonChecked = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"));

;// ./node_modules/@material-ui/core/esm/Radio/RadioButtonIcon.js






var RadioButtonIcon_styles = function styles2(theme) {
  return {
    root: {
      position: "relative",
      display: "flex",
      "&$checked $layer": {
        transform: "scale(1)",
        transition: theme.transitions.create("transform", {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shortest
        })
      }
    },
    layer: {
      left: 0,
      position: "absolute",
      transform: "scale(0)",
      transition: theme.transitions.create("transform", {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {}
  };
};
function RadioButtonIcon(props) {
  var checked = props.checked, classes = props.classes, fontSize = props.fontSize;
  return /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: (0,clsx_m["default"])(classes.root, checked && classes.checked)
  }, /* @__PURE__ */ index_js_eager_.createElement(RadioButtonUnchecked, {
    fontSize
  }), /* @__PURE__ */ index_js_eager_.createElement(RadioButtonChecked, {
    fontSize,
    className: classes.layer
  }));
}
 false ? 0 : void 0;
/* harmony default export */ var Radio_RadioButtonIcon = ((0,withStyles/* default */.A)(RadioButtonIcon_styles, {
  name: "PrivateRadioButtonIcon"
})(RadioButtonIcon));

;// ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroupContext.js

var RadioGroupContext = index_js_eager_.createContext();
if (false) // removed by dead control flow
{}
/* harmony default export */ var RadioGroup_RadioGroupContext = (RadioGroupContext);

;// ./node_modules/@material-ui/core/esm/RadioGroup/useRadioGroup.js


function useRadioGroup() {
  return index_js_eager_.useContext(RadioGroup_RadioGroupContext);
}

;// ./node_modules/@material-ui/core/esm/Radio/Radio.js













var Radio_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },
    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      "&$checked": {
        color: theme.palette.primary.main,
        "&:hover": {
          backgroundColor: (0,colorManipulator/* alpha */.X4)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        }
      },
      "&$disabled": {
        color: theme.palette.action.disabled
      }
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      "&$checked": {
        color: theme.palette.secondary.main,
        "&:hover": {
          backgroundColor: (0,colorManipulator/* alpha */.X4)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        }
      },
      "&$disabled": {
        color: theme.palette.action.disabled
      }
    }
  };
};
var Radio_defaultCheckedIcon = /* @__PURE__ */ index_js_eager_.createElement(Radio_RadioButtonIcon, {
  checked: true
});
var Radio_defaultIcon = /* @__PURE__ */ index_js_eager_.createElement(Radio_RadioButtonIcon, null);
var Radio = /* @__PURE__ */ index_js_eager_.forwardRef(function Radio2(props, ref) {
  var checkedProp = props.checked, classes = props.classes, _props$color = props.color, color = _props$color === void 0 ? "secondary" : _props$color, nameProp = props.name, onChangeProp = props.onChange, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0,objectWithoutProperties/* default */.A)(props, ["checked", "classes", "color", "name", "onChange", "size"]);
  var radioGroup = useRadioGroup();
  var checked = checkedProp;
  var onChange = (0,createChainedFunction/* default */.A)(onChangeProp, radioGroup && radioGroup.onChange);
  var name = nameProp;
  if (radioGroup) {
    if (typeof checked === "undefined") {
      checked = radioGroup.value === props.value;
    }
    if (typeof name === "undefined") {
      name = radioGroup.name;
    }
  }
  return /* @__PURE__ */ index_js_eager_.createElement(internal_SwitchBase, (0,esm_extends/* default */.A)({
    color,
    type: "radio",
    icon: /* @__PURE__ */ index_js_eager_.cloneElement(Radio_defaultIcon, {
      fontSize: size === "small" ? "small" : "medium"
    }),
    checkedIcon: /* @__PURE__ */ index_js_eager_.cloneElement(Radio_defaultCheckedIcon, {
      fontSize: size === "small" ? "small" : "medium"
    }),
    classes: {
      root: (0,clsx_m["default"])(classes.root, classes["color".concat((0,capitalize/* default */.A)(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    name,
    checked,
    onChange,
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Radio_Radio = ((0,withStyles/* default */.A)(Radio_styles, {
  name: "MuiRadio"
})(Radio));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unstable_useId.js
var unstable_useId = __webpack_require__(11518);
;// ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js










var RadioGroup = /* @__PURE__ */ index_js_eager_.forwardRef(function RadioGroup2(props, ref) {
  var actions = props.actions, children = props.children, nameProp = props.name, valueProp = props.value, onChange = props.onChange, other = (0,objectWithoutProperties/* default */.A)(props, ["actions", "children", "name", "value", "onChange"]);
  var rootRef = index_js_eager_.useRef(null);
  var _useControlled = (0,useControlled/* default */.A)({
    controlled: valueProp,
    default: props.defaultValue,
    name: "RadioGroup"
  }), _useControlled2 = (0,slicedToArray/* default */.A)(_useControlled, 2), value = _useControlled2[0], setValue = _useControlled2[1];
  index_js_eager_.useImperativeHandle(actions, function() {
    return {
      focus: function focus() {
        var input = rootRef.current.querySelector("input:not(:disabled):checked");
        if (!input) {
          input = rootRef.current.querySelector("input:not(:disabled)");
        }
        if (input) {
          input.focus();
        }
      }
    };
  }, []);
  var handleRef = (0,useForkRef/* default */.A)(ref, rootRef);
  var handleChange = function handleChange2(event) {
    setValue(event.target.value);
    if (onChange) {
      onChange(event, event.target.value);
    }
  };
  var name = (0,unstable_useId/* default */.A)(nameProp);
  return /* @__PURE__ */ index_js_eager_.createElement(RadioGroup_RadioGroupContext.Provider, {
    value: {
      name,
      onChange: handleChange,
      value
    }
  }, /* @__PURE__ */ index_js_eager_.createElement(FormGroup_FormGroup, (0,esm_extends/* default */.A)({
    role: "radiogroup",
    ref: handleRef
  }, other), children));
});
 false ? 0 : void 0;
/* harmony default export */ var RadioGroup_RadioGroup = (RadioGroup);

;// ./node_modules/@material-ui/core/esm/RadioGroup/index.js



// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var esm_classCallCheck = __webpack_require__(82548);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var esm_createClass = __webpack_require__(64970);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(51836);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(9329);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(27983);
;// ./node_modules/@material-ui/core/esm/RootRef/RootRef.js





function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0,getPrototypeOf/* default */.A)(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0,getPrototypeOf/* default */.A)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0,possibleConstructorReturn/* default */.A)(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}





var RootRef_warnedOnce = false;
var RootRef = /* @__PURE__ */ (function(_React$Component) {
  (0,inherits/* default */.A)(RootRef2, _React$Component);
  var _super = _createSuper(RootRef2);
  function RootRef2() {
    (0,esm_classCallCheck/* default */.A)(this, RootRef2);
    return _super.apply(this, arguments);
  }
  (0,esm_createClass/* default */.A)(RootRef2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ref = react_dom_index_js_eager_.findDOMNode(this);
      (0,setRef/* default */.A)(this.props.rootRef, this.ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var ref = react_dom_index_js_eager_.findDOMNode(this);
      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
        if (prevProps.rootRef !== this.props.rootRef) {
          (0,setRef/* default */.A)(prevProps.rootRef, null);
        }
        this.ref = ref;
        (0,setRef/* default */.A)(this.props.rootRef, this.ref);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ref = null;
      (0,setRef/* default */.A)(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      if (false) // removed by dead control flow
{}
      return this.props.children;
    }
  }]);
  return RootRef2;
})(index_js_eager_.Component);
 false ? 0 : void 0;
if (false) // removed by dead control flow
{}
/* harmony default export */ var RootRef_RootRef = (RootRef);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Select/Select.js + 1 modules
var Select = __webpack_require__(73815);
;// ./node_modules/@material-ui/core/esm/Slider/ValueLabel.js




var ValueLabel_styles = function styles2(theme) {
  return {
    thumb: {
      "&$open": {
        "& $offset": {
          transform: "scale(1) translateY(-10px)"
        }
      }
    },
    open: {},
    offset: (0,esm_extends/* default */.A)({
      zIndex: 1
    }, theme.typography.body2, {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.2,
      transition: theme.transitions.create(["transform"], {
        duration: theme.transitions.duration.shortest
      }),
      top: -34,
      transformOrigin: "bottom center",
      transform: "scale(0)",
      position: "absolute"
    }),
    circle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: 32,
      height: 32,
      borderRadius: "50% 50% 50% 0",
      backgroundColor: "currentColor",
      transform: "rotate(-45deg)"
    },
    label: {
      color: theme.palette.primary.contrastText,
      transform: "rotate(45deg)"
    }
  };
};
function ValueLabel(props) {
  var children = props.children, classes = props.classes, className = props.className, open = props.open, value = props.value, valueLabelDisplay = props.valueLabelDisplay;
  if (valueLabelDisplay === "off") {
    return children;
  }
  return /* @__PURE__ */ index_js_eager_.cloneElement(children, {
    className: (0,clsx_m["default"])(children.props.className, (open || valueLabelDisplay === "on") && classes.open, classes.thumb)
  }, /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: (0,clsx_m["default"])(classes.offset, className)
  }, /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: classes.circle
  }, /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: classes.label
  }, value))));
}
/* harmony default export */ var Slider_ValueLabel = ((0,withStyles/* default */.A)(ValueLabel_styles, {
  name: "PrivateValueLabel"
})(ValueLabel));

;// ./node_modules/@material-ui/core/esm/Slider/Slider.js


















function asc(a, b) {
  return a - b;
}
function clamp(value, min, max) {
  return Math.min(Math.max(min, value), max);
}
function findClosest(values, currentValue) {
  var _values$reduce = values.reduce(function(acc, value, index) {
    var distance = Math.abs(currentValue - value);
    if (acc === null || distance < acc.distance || distance === acc.distance) {
      return {
        distance,
        index
      };
    }
    return acc;
  }, null), closestIndex = _values$reduce.index;
  return closestIndex;
}
function trackFinger(event, touchId) {
  if (touchId.current !== void 0 && event.changedTouches) {
    for (var i = 0; i < event.changedTouches.length; i += 1) {
      var touch = event.changedTouches[i];
      if (touch.identifier === touchId.current) {
        return {
          x: touch.clientX,
          y: touch.clientY
        };
      }
    }
    return false;
  }
  return {
    x: event.clientX,
    y: event.clientY
  };
}
function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}
function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}
function getDecimalPrecision(num) {
  if (Math.abs(num) < 1) {
    var parts = num.toExponential().split("e-");
    var matissaDecimalPart = parts[0].split(".")[1];
    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
  }
  var decimalPart = num.toString().split(".")[1];
  return decimalPart ? decimalPart.length : 0;
}
function roundValueToStep(value, step, min) {
  var nearest = Math.round((value - min) / step) * step + min;
  return Number(nearest.toFixed(getDecimalPrecision(step)));
}
function setValueIndex(_ref) {
  var values = _ref.values, source = _ref.source, newValue = _ref.newValue, index = _ref.index;
  if (values[index] === newValue) {
    return source;
  }
  var output = values.slice();
  output[index] = newValue;
  return output;
}
function focusThumb(_ref2) {
  var sliderRef = _ref2.sliderRef, activeIndex = _ref2.activeIndex, setActive = _ref2.setActive;
  if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute("data-index")) !== activeIndex) {
    sliderRef.current.querySelector('[role="slider"][data-index="'.concat(activeIndex, '"]')).focus();
  }
  if (setActive) {
    setActive(activeIndex);
  }
}
var axisProps = {
  horizontal: {
    offset: function offset(percent) {
      return {
        left: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        width: "".concat(percent, "%")
      };
    }
  },
  "horizontal-reverse": {
    offset: function offset2(percent) {
      return {
        right: "".concat(percent, "%")
      };
    },
    leap: function leap2(percent) {
      return {
        width: "".concat(percent, "%")
      };
    }
  },
  vertical: {
    offset: function offset3(percent) {
      return {
        bottom: "".concat(percent, "%")
      };
    },
    leap: function leap3(percent) {
      return {
        height: "".concat(percent, "%")
      };
    }
  }
};
var Identity = function Identity2(x) {
  return x;
};
var Slider_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 2,
      width: "100%",
      boxSizing: "content-box",
      padding: "13px 0",
      display: "inline-block",
      position: "relative",
      cursor: "pointer",
      touchAction: "none",
      color: theme.palette.primary.main,
      WebkitTapHighlightColor: "transparent",
      "&$disabled": {
        pointerEvents: "none",
        cursor: "default",
        color: theme.palette.grey[400]
      },
      "&$vertical": {
        width: 2,
        height: "100%",
        padding: "0 13px"
      },
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      "@media (pointer: coarse)": {
        // Reach 42px touch target, about ~8mm on screen.
        padding: "20px 0",
        "&$vertical": {
          padding: "0 20px"
        }
      },
      "@media print": {
        colorAdjust: "exact"
      }
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      // TODO v5: move the style here
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },
    /* Styles applied to the root element if `marks` is provided with at least one label. */
    marked: {
      marginBottom: 20,
      "&$vertical": {
        marginBottom: "auto",
        marginRight: 20
      }
    },
    /* Pseudo-class applied to the root element if `orientation="vertical"`. */
    vertical: {},
    /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the rail element. */
    rail: {
      display: "block",
      position: "absolute",
      width: "100%",
      height: 2,
      borderRadius: 1,
      backgroundColor: "currentColor",
      opacity: 0.38,
      "$vertical &": {
        height: "100%",
        width: 2
      }
    },
    /* Styles applied to the track element. */
    track: {
      display: "block",
      position: "absolute",
      height: 2,
      borderRadius: 1,
      backgroundColor: "currentColor",
      "$vertical &": {
        width: 2
      }
    },
    /* Styles applied to the track element if `track={false}`. */
    trackFalse: {
      "& $track": {
        display: "none"
      }
    },
    /* Styles applied to the track element if `track="inverted"`. */
    trackInverted: {
      "& $track": {
        backgroundColor: (
          // Same logic as the LinearProgress track color
          theme.palette.type === "light" ? (0,colorManipulator/* lighten */.a)(theme.palette.primary.main, 0.62) : (0,colorManipulator/* darken */.e$)(theme.palette.primary.main, 0.5)
        )
      },
      "& $rail": {
        opacity: 1
      }
    },
    /* Styles applied to the thumb element. */
    thumb: {
      position: "absolute",
      width: 12,
      height: 12,
      marginLeft: -6,
      marginTop: -5,
      boxSizing: "border-box",
      borderRadius: "50%",
      outline: 0,
      backgroundColor: "currentColor",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: theme.transitions.create(["box-shadow"], {
        duration: theme.transitions.duration.shortest
      }),
      "&::after": {
        position: "absolute",
        content: '""',
        borderRadius: "50%",
        // reach 42px hit target (2 * 15 + thumb diameter)
        left: -15,
        top: -15,
        right: -15,
        bottom: -15
      },
      "&$focusVisible,&:hover": {
        boxShadow: "0px 0px 0px 8px ".concat((0,colorManipulator/* alpha */.X4)(theme.palette.primary.main, 0.16)),
        "@media (hover: none)": {
          boxShadow: "none"
        }
      },
      "&$active": {
        boxShadow: "0px 0px 0px 14px ".concat((0,colorManipulator/* alpha */.X4)(theme.palette.primary.main, 0.16))
      },
      "&$disabled": {
        width: 8,
        height: 8,
        marginLeft: -4,
        marginTop: -3,
        "&:hover": {
          boxShadow: "none"
        }
      },
      "$vertical &": {
        marginLeft: -5,
        marginBottom: -6
      },
      "$vertical &$disabled": {
        marginLeft: -3,
        marginBottom: -4
      }
    },
    /* Styles applied to the thumb element if `color="primary"`. */
    thumbColorPrimary: {
      // TODO v5: move the style here
    },
    /* Styles applied to the thumb element if `color="secondary"`. */
    thumbColorSecondary: {
      "&$focusVisible,&:hover": {
        boxShadow: "0px 0px 0px 8px ".concat((0,colorManipulator/* alpha */.X4)(theme.palette.secondary.main, 0.16))
      },
      "&$active": {
        boxShadow: "0px 0px 0px 14px ".concat((0,colorManipulator/* alpha */.X4)(theme.palette.secondary.main, 0.16))
      }
    },
    /* Pseudo-class applied to the thumb element if it's active. */
    active: {},
    /* Pseudo-class applied to the thumb element if keyboard focused. */
    focusVisible: {},
    /* Styles applied to the thumb label element. */
    valueLabel: {
      // IE 11 centering bug, to remove from the customization demos once no longer supported
      left: "calc(-50% - 4px)"
    },
    /* Styles applied to the mark element. */
    mark: {
      position: "absolute",
      width: 2,
      height: 2,
      borderRadius: 1,
      backgroundColor: "currentColor"
    },
    /* Styles applied to the mark element if active (depending on the value). */
    markActive: {
      backgroundColor: theme.palette.background.paper,
      opacity: 0.8
    },
    /* Styles applied to the mark label element. */
    markLabel: (0,esm_extends/* default */.A)({}, theme.typography.body2, {
      color: theme.palette.text.secondary,
      position: "absolute",
      top: 26,
      transform: "translateX(-50%)",
      whiteSpace: "nowrap",
      "$vertical &": {
        top: "auto",
        left: 26,
        transform: "translateY(50%)"
      },
      "@media (pointer: coarse)": {
        top: 40,
        "$vertical &": {
          left: 31
        }
      }
    }),
    /* Styles applied to the mark label element if active (depending on the value). */
    markLabelActive: {
      color: theme.palette.text.primary
    }
  };
};
var Slider = /* @__PURE__ */ index_js_eager_.forwardRef(function Slider2(props, ref) {
  var ariaLabel = props["aria-label"], ariaLabelledby = props["aria-labelledby"], ariaValuetext = props["aria-valuetext"], classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "primary" : _props$color, _props$component = props.component, Component = _props$component === void 0 ? "span" : _props$component, defaultValue = props.defaultValue, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, getAriaLabel = props.getAriaLabel, getAriaValueText = props.getAriaValueText, _props$marks = props.marks, marksProp = _props$marks === void 0 ? false : _props$marks, _props$max = props.max, max = _props$max === void 0 ? 100 : _props$max, _props$min = props.min, min = _props$min === void 0 ? 0 : _props$min, name = props.name, onChange = props.onChange, onChangeCommitted = props.onChangeCommitted, onMouseDown = props.onMouseDown, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, _props$scale = props.scale, scale = _props$scale === void 0 ? Identity : _props$scale, _props$step = props.step, step = _props$step === void 0 ? 1 : _props$step, _props$ThumbComponent = props.ThumbComponent, ThumbComponent = _props$ThumbComponent === void 0 ? "span" : _props$ThumbComponent, _props$track = props.track, track = _props$track === void 0 ? "normal" : _props$track, valueProp = props.value, _props$ValueLabelComp = props.ValueLabelComponent, ValueLabelComponent = _props$ValueLabelComp === void 0 ? Slider_ValueLabel : _props$ValueLabelComp, _props$valueLabelDisp = props.valueLabelDisplay, valueLabelDisplay = _props$valueLabelDisp === void 0 ? "off" : _props$valueLabelDisp, _props$valueLabelForm = props.valueLabelFormat, valueLabelFormat = _props$valueLabelForm === void 0 ? Identity : _props$valueLabelForm, other = (0,objectWithoutProperties/* default */.A)(props, ["aria-label", "aria-labelledby", "aria-valuetext", "classes", "className", "color", "component", "defaultValue", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "scale", "step", "ThumbComponent", "track", "value", "ValueLabelComponent", "valueLabelDisplay", "valueLabelFormat"]);
  var theme = (0,useTheme/* default */.A)();
  var touchId = index_js_eager_.useRef();
  var _React$useState = index_js_eager_.useState(-1), active = _React$useState[0], setActive = _React$useState[1];
  var _React$useState2 = index_js_eager_.useState(-1), open = _React$useState2[0], setOpen = _React$useState2[1];
  var _useControlled = (0,useControlled/* default */.A)({
    controlled: valueProp,
    default: defaultValue,
    name: "Slider"
  }), _useControlled2 = (0,slicedToArray/* default */.A)(_useControlled, 2), valueDerived = _useControlled2[0], setValueState = _useControlled2[1];
  var range = Array.isArray(valueDerived);
  var values = range ? valueDerived.slice().sort(asc) : [valueDerived];
  values = values.map(function(value) {
    return clamp(value, min, max);
  });
  var marks = marksProp === true && step !== null ? (0,toConsumableArray/* default */.A)(Array(Math.floor((max - min) / step) + 1)).map(function(_, index) {
    return {
      value: min + step * index
    };
  }) : marksProp || [];
  var _useIsFocusVisible = (0,useIsFocusVisible/* default */.A)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
  var _React$useState3 = index_js_eager_.useState(-1), focusVisible = _React$useState3[0], setFocusVisible = _React$useState3[1];
  var sliderRef = index_js_eager_.useRef();
  var handleFocusRef = (0,useForkRef/* default */.A)(focusVisibleRef, sliderRef);
  var handleRef = (0,useForkRef/* default */.A)(ref, handleFocusRef);
  var handleFocus = (0,useEventCallback/* default */.A)(function(event) {
    var index = Number(event.currentTarget.getAttribute("data-index"));
    if (isFocusVisible(event)) {
      setFocusVisible(index);
    }
    setOpen(index);
  });
  var handleBlur = (0,useEventCallback/* default */.A)(function() {
    if (focusVisible !== -1) {
      setFocusVisible(-1);
      onBlurVisible();
    }
    setOpen(-1);
  });
  var handleMouseOver = (0,useEventCallback/* default */.A)(function(event) {
    var index = Number(event.currentTarget.getAttribute("data-index"));
    setOpen(index);
  });
  var handleMouseLeave = (0,useEventCallback/* default */.A)(function() {
    setOpen(-1);
  });
  var isRtl = theme.direction === "rtl";
  var handleKeyDown = (0,useEventCallback/* default */.A)(function(event) {
    var index = Number(event.currentTarget.getAttribute("data-index"));
    var value = values[index];
    var tenPercents = (max - min) / 10;
    var marksValues = marks.map(function(mark) {
      return mark.value;
    });
    var marksIndex = marksValues.indexOf(value);
    var newValue;
    var increaseKey = isRtl ? "ArrowLeft" : "ArrowRight";
    var decreaseKey = isRtl ? "ArrowRight" : "ArrowLeft";
    switch (event.key) {
      case "Home":
        newValue = min;
        break;
      case "End":
        newValue = max;
        break;
      case "PageUp":
        if (step) {
          newValue = value + tenPercents;
        }
        break;
      case "PageDown":
        if (step) {
          newValue = value - tenPercents;
        }
        break;
      case increaseKey:
      case "ArrowUp":
        if (step) {
          newValue = value + step;
        } else {
          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
        }
        break;
      case decreaseKey:
      case "ArrowDown":
        if (step) {
          newValue = value - step;
        } else {
          newValue = marksValues[marksIndex - 1] || marksValues[0];
        }
        break;
      default:
        return;
    }
    event.preventDefault();
    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    }
    newValue = clamp(newValue, min, max);
    if (range) {
      var previousValue = newValue;
      newValue = setValueIndex({
        values,
        source: valueDerived,
        newValue,
        index
      }).sort(asc);
      focusThumb({
        sliderRef,
        activeIndex: newValue.indexOf(previousValue)
      });
    }
    setValueState(newValue);
    setFocusVisible(index);
    if (onChange) {
      onChange(event, newValue);
    }
    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }
  });
  var previousIndex = index_js_eager_.useRef();
  var axis = orientation;
  if (isRtl && orientation !== "vertical") {
    axis += "-reverse";
  }
  var getFingerNewValue = function getFingerNewValue2(_ref3) {
    var finger = _ref3.finger, _ref3$move = _ref3.move, move = _ref3$move === void 0 ? false : _ref3$move, values2 = _ref3.values, source = _ref3.source;
    var slider = sliderRef.current;
    var _slider$getBoundingCl = slider.getBoundingClientRect(), width = _slider$getBoundingCl.width, height = _slider$getBoundingCl.height, bottom = _slider$getBoundingCl.bottom, left = _slider$getBoundingCl.left;
    var percent;
    if (axis.indexOf("vertical") === 0) {
      percent = (bottom - finger.y) / height;
    } else {
      percent = (finger.x - left) / width;
    }
    if (axis.indexOf("-reverse") !== -1) {
      percent = 1 - percent;
    }
    var newValue;
    newValue = percentToValue(percent, min, max);
    if (step) {
      newValue = roundValueToStep(newValue, step, min);
    } else {
      var marksValues = marks.map(function(mark) {
        return mark.value;
      });
      var closestIndex = findClosest(marksValues, newValue);
      newValue = marksValues[closestIndex];
    }
    newValue = clamp(newValue, min, max);
    var activeIndex = 0;
    if (range) {
      if (!move) {
        activeIndex = findClosest(values2, newValue);
      } else {
        activeIndex = previousIndex.current;
      }
      var previousValue = newValue;
      newValue = setValueIndex({
        values: values2,
        source,
        newValue,
        index: activeIndex
      }).sort(asc);
      activeIndex = newValue.indexOf(previousValue);
      previousIndex.current = activeIndex;
    }
    return {
      newValue,
      activeIndex
    };
  };
  var handleTouchMove = (0,useEventCallback/* default */.A)(function(event) {
    var finger = trackFinger(event, touchId);
    if (!finger) {
      return;
    }
    var _getFingerNewValue = getFingerNewValue({
      finger,
      move: true,
      values,
      source: valueDerived
    }), newValue = _getFingerNewValue.newValue, activeIndex = _getFingerNewValue.activeIndex;
    focusThumb({
      sliderRef,
      activeIndex,
      setActive
    });
    setValueState(newValue);
    if (onChange) {
      onChange(event, newValue);
    }
  });
  var handleTouchEnd = (0,useEventCallback/* default */.A)(function(event) {
    var finger = trackFinger(event, touchId);
    if (!finger) {
      return;
    }
    var _getFingerNewValue2 = getFingerNewValue({
      finger,
      values,
      source: valueDerived
    }), newValue = _getFingerNewValue2.newValue;
    setActive(-1);
    if (event.type === "touchend") {
      setOpen(-1);
    }
    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }
    touchId.current = void 0;
    var doc = (0,ownerDocument/* default */.A)(sliderRef.current);
    doc.removeEventListener("mousemove", handleTouchMove);
    doc.removeEventListener("mouseup", handleTouchEnd);
    doc.removeEventListener("touchmove", handleTouchMove);
    doc.removeEventListener("touchend", handleTouchEnd);
  });
  var handleTouchStart = (0,useEventCallback/* default */.A)(function(event) {
    event.preventDefault();
    var touch = event.changedTouches[0];
    if (touch != null) {
      touchId.current = touch.identifier;
    }
    var finger = trackFinger(event, touchId);
    var _getFingerNewValue3 = getFingerNewValue({
      finger,
      values,
      source: valueDerived
    }), newValue = _getFingerNewValue3.newValue, activeIndex = _getFingerNewValue3.activeIndex;
    focusThumb({
      sliderRef,
      activeIndex,
      setActive
    });
    setValueState(newValue);
    if (onChange) {
      onChange(event, newValue);
    }
    var doc = (0,ownerDocument/* default */.A)(sliderRef.current);
    doc.addEventListener("touchmove", handleTouchMove);
    doc.addEventListener("touchend", handleTouchEnd);
  });
  index_js_eager_.useEffect(function() {
    var slider = sliderRef.current;
    slider.addEventListener("touchstart", handleTouchStart);
    var doc = (0,ownerDocument/* default */.A)(slider);
    return function() {
      slider.removeEventListener("touchstart", handleTouchStart);
      doc.removeEventListener("mousemove", handleTouchMove);
      doc.removeEventListener("mouseup", handleTouchEnd);
      doc.removeEventListener("touchmove", handleTouchMove);
      doc.removeEventListener("touchend", handleTouchEnd);
    };
  }, [handleTouchEnd, handleTouchMove, handleTouchStart]);
  var handleMouseDown = (0,useEventCallback/* default */.A)(function(event) {
    if (onMouseDown) {
      onMouseDown(event);
    }
    event.preventDefault();
    var finger = trackFinger(event, touchId);
    var _getFingerNewValue4 = getFingerNewValue({
      finger,
      values,
      source: valueDerived
    }), newValue = _getFingerNewValue4.newValue, activeIndex = _getFingerNewValue4.activeIndex;
    focusThumb({
      sliderRef,
      activeIndex,
      setActive
    });
    setValueState(newValue);
    if (onChange) {
      onChange(event, newValue);
    }
    var doc = (0,ownerDocument/* default */.A)(sliderRef.current);
    doc.addEventListener("mousemove", handleTouchMove);
    doc.addEventListener("mouseup", handleTouchEnd);
  });
  var trackOffset = valueToPercent(range ? values[0] : min, min, max);
  var trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;
  var trackStyle = (0,esm_extends/* default */.A)({}, axisProps[axis].offset(trackOffset), axisProps[axis].leap(trackLeap));
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    ref: handleRef,
    className: (0,clsx_m["default"])(classes.root, classes["color".concat((0,capitalize/* default */.A)(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function(mark) {
      return mark.label;
    }) && classes.marked, track === false && classes.trackFalse, orientation === "vertical" && classes.vertical, track === "inverted" && classes.trackInverted),
    onMouseDown: handleMouseDown
  }, other), /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: classes.rail
  }), /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: classes.track,
    style: trackStyle
  }), /* @__PURE__ */ index_js_eager_.createElement("input", {
    value: values.join(","),
    name,
    type: "hidden"
  }), marks.map(function(mark, index) {
    var percent = valueToPercent(mark.value, min, max);
    var style = axisProps[axis].offset(percent);
    var markActive;
    if (track === false) {
      markActive = values.indexOf(mark.value) !== -1;
    } else {
      markActive = track === "normal" && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === "inverted" && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
    }
    return /* @__PURE__ */ index_js_eager_.createElement(index_js_eager_.Fragment, {
      key: mark.value
    }, /* @__PURE__ */ index_js_eager_.createElement("span", {
      style,
      "data-index": index,
      className: (0,clsx_m["default"])(classes.mark, markActive && classes.markActive)
    }), mark.label != null ? /* @__PURE__ */ index_js_eager_.createElement("span", {
      "aria-hidden": true,
      "data-index": index,
      style,
      className: (0,clsx_m["default"])(classes.markLabel, markActive && classes.markLabelActive)
    }, mark.label) : null);
  }), values.map(function(value, index) {
    var percent = valueToPercent(value, min, max);
    var style = axisProps[axis].offset(percent);
    return /* @__PURE__ */ index_js_eager_.createElement(ValueLabelComponent, {
      key: index,
      valueLabelFormat,
      valueLabelDisplay,
      className: classes.valueLabel,
      value: typeof valueLabelFormat === "function" ? valueLabelFormat(scale(value), index) : valueLabelFormat,
      index,
      open: open === index || active === index || valueLabelDisplay === "on",
      disabled
    }, /* @__PURE__ */ index_js_eager_.createElement(ThumbComponent, {
      className: (0,clsx_m["default"])(classes.thumb, classes["thumbColor".concat((0,capitalize/* default */.A)(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
      tabIndex: disabled ? null : 0,
      role: "slider",
      style,
      "data-index": index,
      "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
      "aria-labelledby": ariaLabelledby,
      "aria-orientation": orientation,
      "aria-valuemax": scale(max),
      "aria-valuemin": scale(min),
      "aria-valuenow": scale(value),
      "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
      onKeyDown: handleKeyDown,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onMouseOver: handleMouseOver,
      onMouseLeave: handleMouseLeave
    }));
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Slider_Slider = ((0,withStyles/* default */.A)(Slider_styles, {
  name: "MuiSlider"
})(Slider));

;// ./node_modules/@material-ui/core/esm/SnackbarContent/SnackbarContent.js









var SnackbarContent_styles = function styles2(theme) {
  var emphasis = theme.palette.type === "light" ? 0.8 : 0.98;
  var backgroundColor = (0,colorManipulator/* emphasize */.tL)(theme.palette.background.default, emphasis);
  return {
    /* Styles applied to the root element. */
    root: (0,esm_extends/* default */.A)({}, theme.typography.body2, (0,defineProperty/* default */.A)({
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor,
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      padding: "6px 16px",
      borderRadius: theme.shape.borderRadius,
      flexGrow: 1
    }, theme.breakpoints.up("sm"), {
      flexGrow: "initial",
      minWidth: 288
    })),
    /* Styles applied to the message wrapper element. */
    message: {
      padding: "8px 0"
    },
    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: "flex",
      alignItems: "center",
      marginLeft: "auto",
      paddingLeft: 16,
      marginRight: -8
    }
  };
};
var SnackbarContent = /* @__PURE__ */ index_js_eager_.forwardRef(function SnackbarContent2(props, ref) {
  var action = props.action, classes = props.classes, className = props.className, message = props.message, _props$role = props.role, role = _props$role === void 0 ? "alert" : _props$role, other = (0,objectWithoutProperties/* default */.A)(props, ["action", "classes", "className", "message", "role"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Paper/* default */.A, (0,esm_extends/* default */.A)({
    role,
    square: true,
    elevation: 6,
    className: (0,clsx_m["default"])(classes.root, className),
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.message
  }, message), action ? /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.action
  }, action) : null);
});
 false ? 0 : void 0;
/* harmony default export */ var SnackbarContent_SnackbarContent = ((0,withStyles/* default */.A)(SnackbarContent_styles, {
  name: "MuiSnackbarContent"
})(SnackbarContent));

;// ./node_modules/@material-ui/core/esm/Snackbar/Snackbar.js















var Snackbar_styles = function styles2(theme) {
  var top1 = {
    top: 8
  };
  var bottom1 = {
    bottom: 8
  };
  var right = {
    justifyContent: "flex-end"
  };
  var left = {
    justifyContent: "flex-start"
  };
  var top3 = {
    top: 24
  };
  var bottom3 = {
    bottom: 24
  };
  var right3 = {
    right: 24
  };
  var left3 = {
    left: 24
  };
  var center = {
    left: "50%",
    right: "auto",
    transform: "translateX(-50%)"
  };
  return {
    /* Styles applied to the root element. */
    root: {
      zIndex: theme.zIndex.snackbar,
      position: "fixed",
      display: "flex",
      left: 8,
      right: 8,
      justifyContent: "center",
      alignItems: "center"
    },
    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
    anchorOriginTopCenter: (0,esm_extends/* default */.A)({}, top1, (0,defineProperty/* default */.A)({}, theme.breakpoints.up("sm"), (0,esm_extends/* default */.A)({}, top3, center))),
    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
    anchorOriginBottomCenter: (0,esm_extends/* default */.A)({}, bottom1, (0,defineProperty/* default */.A)({}, theme.breakpoints.up("sm"), (0,esm_extends/* default */.A)({}, bottom3, center))),
    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
    anchorOriginTopRight: (0,esm_extends/* default */.A)({}, top1, right, (0,defineProperty/* default */.A)({}, theme.breakpoints.up("sm"), (0,esm_extends/* default */.A)({
      left: "auto"
    }, top3, right3))),
    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
    anchorOriginBottomRight: (0,esm_extends/* default */.A)({}, bottom1, right, (0,defineProperty/* default */.A)({}, theme.breakpoints.up("sm"), (0,esm_extends/* default */.A)({
      left: "auto"
    }, bottom3, right3))),
    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
    anchorOriginTopLeft: (0,esm_extends/* default */.A)({}, top1, left, (0,defineProperty/* default */.A)({}, theme.breakpoints.up("sm"), (0,esm_extends/* default */.A)({
      right: "auto"
    }, top3, left3))),
    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
    anchorOriginBottomLeft: (0,esm_extends/* default */.A)({}, bottom1, left, (0,defineProperty/* default */.A)({}, theme.breakpoints.up("sm"), (0,esm_extends/* default */.A)({
      right: "auto"
    }, bottom3, left3)))
  };
};
var Snackbar = /* @__PURE__ */ index_js_eager_.forwardRef(function Snackbar2(props, ref) {
  var action = props.action, _props$anchorOrigin = props.anchorOrigin;
  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: "bottom",
    horizontal: "center"
  } : _props$anchorOrigin;
  var vertical = _props$anchorOrigin.vertical, horizontal = _props$anchorOrigin.horizontal, _props$autoHideDurati = props.autoHideDuration, autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati, children = props.children, classes = props.classes, className = props.className, ClickAwayListenerProps = props.ClickAwayListenerProps, ContentProps = props.ContentProps, _props$disableWindowB = props.disableWindowBlurListener, disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB, message = props.message, onClose = props.onClose, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, open = props.open, resumeHideDuration = props.resumeHideDuration, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? Grow/* default */.A : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? {
    enter: transitions/* duration */.p0.enteringScreen,
    exit: transitions/* duration */.p0.leavingScreen
  } : _props$transitionDura, TransitionProps = props.TransitionProps, other = (0,objectWithoutProperties/* default */.A)(props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]);
  var timerAutoHide = index_js_eager_.useRef();
  var _React$useState = index_js_eager_.useState(true), exited = _React$useState[0], setExited = _React$useState[1];
  var handleClose = (0,useEventCallback/* default */.A)(function() {
    if (onClose) {
      onClose.apply(void 0, arguments);
    }
  });
  var setAutoHideTimer = (0,useEventCallback/* default */.A)(function(autoHideDurationParam) {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }
    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(function() {
      handleClose(null, "timeout");
    }, autoHideDurationParam);
  });
  index_js_eager_.useEffect(function() {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }
    return function() {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, autoHideDuration, setAutoHideTimer]);
  var handlePause = function handlePause2() {
    clearTimeout(timerAutoHide.current);
  };
  var handleResume = index_js_eager_.useCallback(function() {
    if (autoHideDuration != null) {
      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);
  var handleMouseEnter = function handleMouseEnter2(event) {
    if (onMouseEnter) {
      onMouseEnter(event);
    }
    handlePause();
  };
  var handleMouseLeave = function handleMouseLeave2(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }
    handleResume();
  };
  var handleClickAway = function handleClickAway2(event) {
    if (onClose) {
      onClose(event, "clickaway");
    }
  };
  var handleExited = function handleExited2() {
    setExited(true);
  };
  var handleEnter = function handleEnter2() {
    setExited(false);
  };
  index_js_eager_.useEffect(function() {
    if (!disableWindowBlurListener && open) {
      window.addEventListener("focus", handleResume);
      window.addEventListener("blur", handlePause);
      return function() {
        window.removeEventListener("focus", handleResume);
        window.removeEventListener("blur", handlePause);
      };
    }
    return void 0;
  }, [disableWindowBlurListener, handleResume, open]);
  if (!open && exited) {
    return null;
  }
  return /* @__PURE__ */ index_js_eager_.createElement(ClickAwayListener_ClickAwayListener, (0,esm_extends/* default */.A)({
    onClickAway: handleClickAway
  }, ClickAwayListenerProps), /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, classes["anchorOrigin".concat((0,capitalize/* default */.A)(vertical)).concat((0,capitalize/* default */.A)(horizontal))], className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement(TransitionComponent, (0,esm_extends/* default */.A)({
    appear: true,
    in: open,
    onEnter: (0,createChainedFunction/* default */.A)(handleEnter, onEnter),
    onEntered,
    onEntering,
    onExit,
    onExited: (0,createChainedFunction/* default */.A)(handleExited, onExited),
    onExiting,
    timeout: transitionDuration,
    direction: vertical === "top" ? "down" : "up"
  }, TransitionProps), children || /* @__PURE__ */ index_js_eager_.createElement(SnackbarContent_SnackbarContent, (0,esm_extends/* default */.A)({
    message,
    action
  }, ContentProps)))));
});
 false ? 0 : void 0;
/* harmony default export */ var Snackbar_Snackbar = ((0,withStyles/* default */.A)(Snackbar_styles, {
  flip: false,
  name: "MuiSnackbar"
})(Snackbar));

;// ./node_modules/@material-ui/core/esm/Step/Step.js







var Step_styles = {
  /* Styles applied to the root element. */
  root: {},
  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    paddingLeft: 8,
    paddingRight: 8
  },
  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {},
  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    flex: 1,
    position: "relative"
  },
  /* Pseudo-class applied to the root element if `completed={true}`. */
  completed: {}
};
var Step = /* @__PURE__ */ index_js_eager_.forwardRef(function Step2(props, ref) {
  var _props$active = props.active, active = _props$active === void 0 ? false : _props$active, alternativeLabel = props.alternativeLabel, children = props.children, classes = props.classes, className = props.className, _props$completed = props.completed, completed = _props$completed === void 0 ? false : _props$completed, connectorProp = props.connector, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$expanded = props.expanded, expanded = _props$expanded === void 0 ? false : _props$expanded, index = props.index, last = props.last, orientation = props.orientation, other = (0,objectWithoutProperties/* default */.A)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "expanded", "index", "last", "orientation"]);
  var connector = connectorProp ? /* @__PURE__ */ index_js_eager_.cloneElement(connectorProp, {
    orientation,
    alternativeLabel,
    index,
    active,
    completed,
    disabled
  }) : null;
  var newChildren = /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, completed && classes.completed),
    ref
  }, other), connector && alternativeLabel && index !== 0 ? connector : null, index_js_eager_.Children.map(children, function(child) {
    if (!/* @__PURE__ */ index_js_eager_.isValidElement(child)) {
      return null;
    }
    if (false) // removed by dead control flow
{}
    return /* @__PURE__ */ index_js_eager_.cloneElement(child, (0,esm_extends/* default */.A)({
      active,
      alternativeLabel,
      completed,
      disabled,
      expanded,
      last,
      icon: index + 1,
      orientation
    }, child.props));
  }));
  if (connector && !alternativeLabel && index !== 0) {
    return /* @__PURE__ */ index_js_eager_.createElement(index_js_eager_.Fragment, null, connector, newChildren);
  }
  return newChildren;
});
 false ? 0 : void 0;
/* harmony default export */ var Step_Step = ((0,withStyles/* default */.A)(Step_styles, {
  name: "MuiStep"
})(Step));

;// ./node_modules/@material-ui/core/esm/internal/svg-icons/CheckCircle.js


/* harmony default export */ var CheckCircle = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle"));

;// ./node_modules/@material-ui/core/esm/internal/svg-icons/Warning.js


/* harmony default export */ var Warning = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning"));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(97186);
;// ./node_modules/@material-ui/core/esm/StepIcon/StepIcon.js







var StepIcon_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "block",
      color: theme.palette.text.disabled,
      "&$completed": {
        color: theme.palette.primary.main
      },
      "&$active": {
        color: theme.palette.primary.main
      },
      "&$error": {
        color: theme.palette.error.main
      }
    },
    /* Styles applied to the SVG text element. */
    text: {
      fill: theme.palette.primary.contrastText,
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.fontFamily
    },
    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},
    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {},
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {}
  };
};
var _ref = /* @__PURE__ */ index_js_eager_.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12"
});
var StepIcon = /* @__PURE__ */ index_js_eager_.forwardRef(function StepIcon2(props, ref) {
  var _props$completed = props.completed, completed = _props$completed === void 0 ? false : _props$completed, icon = props.icon, _props$active = props.active, active = _props$active === void 0 ? false : _props$active, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, classes = props.classes;
  if (typeof icon === "number" || typeof icon === "string") {
    var className = (0,clsx_m["default"])(classes.root, active && classes.active, error && classes.error, completed && classes.completed);
    if (error) {
      return /* @__PURE__ */ index_js_eager_.createElement(Warning, {
        className,
        ref
      });
    }
    if (completed) {
      return /* @__PURE__ */ index_js_eager_.createElement(CheckCircle, {
        className,
        ref
      });
    }
    return /* @__PURE__ */ index_js_eager_.createElement(SvgIcon/* default */.A, {
      className,
      ref
    }, _ref, /* @__PURE__ */ index_js_eager_.createElement("text", {
      className: classes.text,
      x: "12",
      y: "16",
      textAnchor: "middle"
    }, icon));
  }
  return icon;
});
 false ? 0 : void 0;
/* harmony default export */ var StepIcon_StepIcon = ((0,withStyles/* default */.A)(StepIcon_styles, {
  name: "MuiStepIcon"
})(StepIcon));

;// ./node_modules/@material-ui/core/esm/StepLabel/StepLabel.js








var StepLabel_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "flex",
      alignItems: "center",
      "&$alternativeLabel": {
        flexDirection: "column"
      },
      "&$disabled": {
        cursor: "default"
      }
    },
    /* Styles applied to the root element if `orientation="horizontal"`. */
    horizontal: {},
    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {},
    /* Styles applied to the `Typography` component which wraps `children`. */
    label: {
      color: theme.palette.text.secondary,
      "&$active": {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      "&$completed": {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      "&$alternativeLabel": {
        textAlign: "center",
        marginTop: 16
      },
      "&$error": {
        color: theme.palette.error.main
      }
    },
    /* Pseudo-class applied to the `Typography` component if `active={true}`. */
    active: {},
    /* Pseudo-class applied to the `Typography` component if `completed={true}`. */
    completed: {},
    /* Pseudo-class applied to the root element and `Typography` component if `error={true}`. */
    error: {},
    /* Pseudo-class applied to the root element and `Typography` component if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the `icon` container element. */
    iconContainer: {
      flexShrink: 0,
      // Fix IE 11 issue
      display: "flex",
      paddingRight: 8,
      "&$alternativeLabel": {
        paddingRight: 0
      }
    },
    /* Pseudo-class applied to the root and icon container and `Typography` if `alternativeLabel={true}`. */
    alternativeLabel: {},
    /* Styles applied to the container element which wraps `Typography` and `optional`. */
    labelContainer: {
      width: "100%"
    }
  };
};
var StepLabel = /* @__PURE__ */ index_js_eager_.forwardRef(function StepLabel2(props, ref) {
  var _props$active = props.active, active = _props$active === void 0 ? false : _props$active, _props$alternativeLab = props.alternativeLabel, alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab, children = props.children, classes = props.classes, className = props.className, _props$completed = props.completed, completed = _props$completed === void 0 ? false : _props$completed, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$error = props.error, error = _props$error === void 0 ? false : _props$error, expanded = props.expanded, icon = props.icon, last = props.last, optional = props.optional, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, StepIconComponentProp = props.StepIconComponent, StepIconProps = props.StepIconProps, other = (0,objectWithoutProperties/* default */.A)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "expanded", "icon", "last", "optional", "orientation", "StepIconComponent", "StepIconProps"]);
  var StepIconComponent = StepIconComponentProp;
  if (icon && !StepIconComponent) {
    StepIconComponent = StepIcon_StepIcon;
  }
  return /* @__PURE__ */ index_js_eager_.createElement("span", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, classes[orientation], className, disabled && classes.disabled, alternativeLabel && classes.alternativeLabel, error && classes.error),
    ref
  }, other), icon || StepIconComponent ? /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: (0,clsx_m["default"])(classes.iconContainer, alternativeLabel && classes.alternativeLabel)
  }, /* @__PURE__ */ index_js_eager_.createElement(StepIconComponent, (0,esm_extends/* default */.A)({
    completed,
    active,
    error,
    icon
  }, StepIconProps))) : null, /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: classes.labelContainer
  }, children ? /* @__PURE__ */ index_js_eager_.createElement(Typography/* default */.A, {
    variant: "body2",
    component: "span",
    display: "block",
    className: (0,clsx_m["default"])(classes.label, alternativeLabel && classes.alternativeLabel, completed && classes.completed, active && classes.active, error && classes.error)
  }, children) : null, optional));
});
 false ? 0 : void 0;
StepLabel.muiName = "StepLabel";
/* harmony default export */ var StepLabel_StepLabel = ((0,withStyles/* default */.A)(StepLabel_styles, {
  name: "MuiStepLabel"
})(StepLabel));

;// ./node_modules/@material-ui/core/esm/StepButton/StepButton.js









var StepButton_styles = {
  /* Styles applied to the root element. */
  root: {
    width: "100%",
    padding: "24px 16px",
    margin: "-24px -16px",
    boxSizing: "content-box"
  },
  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {},
  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    justifyContent: "flex-start",
    padding: "8px",
    margin: "-8px"
  },
  /* Styles applied to the `ButtonBase` touch-ripple. */
  touchRipple: {
    color: "rgba(0, 0, 0, 0.3)"
  }
};
var StepButton = /* @__PURE__ */ index_js_eager_.forwardRef(function StepButton2(props, ref) {
  var active = props.active, alternativeLabel = props.alternativeLabel, children = props.children, classes = props.classes, className = props.className, completed = props.completed, disabled = props.disabled, expanded = props.expanded, icon = props.icon, last = props.last, optional = props.optional, orientation = props.orientation, other = (0,objectWithoutProperties/* default */.A)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "expanded", "icon", "last", "optional", "orientation"]);
  var childProps = {
    active,
    alternativeLabel,
    completed,
    disabled,
    icon,
    optional,
    orientation
  };
  var child = (0,isMuiElement/* default */.A)(children, ["StepLabel"]) ? /* @__PURE__ */ index_js_eager_.cloneElement(children, childProps) : /* @__PURE__ */ index_js_eager_.createElement(StepLabel_StepLabel, childProps, children);
  return /* @__PURE__ */ index_js_eager_.createElement(ButtonBase/* default */.A, (0,esm_extends/* default */.A)({
    focusRipple: true,
    disabled,
    TouchRippleProps: {
      className: classes.touchRipple
    },
    className: (0,clsx_m["default"])(classes.root, classes[orientation], className),
    ref
  }, other), child);
});
 false ? 0 : void 0;
/* harmony default export */ var StepButton_StepButton = ((0,withStyles/* default */.A)(StepButton_styles, {
  name: "MuiStepButton"
})(StepButton));

;// ./node_modules/@material-ui/core/esm/StepConnector/StepConnector.js






var StepConnector_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: "1 1 auto"
    },
    /* Styles applied to the root element if `orientation="horizontal"`. */
    horizontal: {},
    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      marginLeft: 12,
      // half icon
      padding: "0 0 8px"
    },
    /* Styles applied to the root element if `alternativeLabel={true}`. */
    alternativeLabel: {
      position: "absolute",
      top: 8 + 4,
      left: "calc(-50% + 20px)",
      right: "calc(50% + 20px)"
    },
    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},
    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {},
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the line element. */
    line: {
      display: "block",
      borderColor: theme.palette.type === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
    },
    /* Styles applied to the root element if `orientation="horizontal"`. */
    lineHorizontal: {
      borderTopStyle: "solid",
      borderTopWidth: 1
    },
    /* Styles applied to the root element if `orientation="vertical"`. */
    lineVertical: {
      borderLeftStyle: "solid",
      borderLeftWidth: 1,
      minHeight: 24
    }
  };
};
var StepConnector = /* @__PURE__ */ index_js_eager_.forwardRef(function StepConnector2(props, ref) {
  var active = props.active, _props$alternativeLab = props.alternativeLabel, alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab, classes = props.classes, className = props.className, completed = props.completed, disabled = props.disabled, index = props.index, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, other = (0,objectWithoutProperties/* default */.A)(props, ["active", "alternativeLabel", "classes", "className", "completed", "disabled", "index", "orientation"]);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, active && classes.active, completed && classes.completed, disabled && classes.disabled),
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: (0,clsx_m["default"])(classes.line, {
      "horizontal": classes.lineHorizontal,
      "vertical": classes.lineVertical
    }[orientation])
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var StepConnector_StepConnector = ((0,withStyles/* default */.A)(StepConnector_styles, {
  name: "MuiStepConnector"
})(StepConnector));

;// ./node_modules/@material-ui/core/esm/StepContent/StepContent.js







var StepContent_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      marginTop: 8,
      marginLeft: 12,
      // half icon
      paddingLeft: 8 + 12,
      // margin + half icon
      paddingRight: 8,
      borderLeft: "1px solid ".concat(theme.palette.type === "light" ? theme.palette.grey[400] : theme.palette.grey[600])
    },
    /* Styles applied to the root element if `last={true}` (controlled by `Step`). */
    last: {
      borderLeft: "none"
    },
    /* Styles applied to the Transition component. */
    transition: {}
  };
};
var StepContent = /* @__PURE__ */ index_js_eager_.forwardRef(function StepContent2(props, ref) {
  var active = props.active, alternativeLabel = props.alternativeLabel, children = props.children, classes = props.classes, className = props.className, completed = props.completed, expanded = props.expanded, last = props.last, optional = props.optional, orientation = props.orientation, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? Collapse_Collapse : _props$TransitionComp, _props$transitionDura = props.transitionDuration, transitionDurationProp = _props$transitionDura === void 0 ? "auto" : _props$transitionDura, TransitionProps = props.TransitionProps, other = (0,objectWithoutProperties/* default */.A)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "expanded", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);
  if (false) // removed by dead control flow
{}
  var transitionDuration = transitionDurationProp;
  if (transitionDurationProp === "auto" && !TransitionComponent.muiSupportAuto) {
    transitionDuration = void 0;
  }
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, last && classes.last),
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement(TransitionComponent, (0,esm_extends/* default */.A)({
    in: active || expanded,
    className: classes.transition,
    timeout: transitionDuration,
    unmountOnExit: true
  }, TransitionProps), children));
});
 false ? 0 : void 0;
/* harmony default export */ var StepContent_StepContent = ((0,withStyles/* default */.A)(StepContent_styles, {
  name: "MuiStepContent"
})(StepContent));

;// ./node_modules/@material-ui/core/esm/Stepper/Stepper.js








var Stepper_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "flex",
    padding: 24
  },
  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    flexDirection: "row",
    alignItems: "center"
  },
  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    flexDirection: "column"
  },
  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    alignItems: "flex-start"
  }
};
var defaultConnector = /* @__PURE__ */ index_js_eager_.createElement(StepConnector_StepConnector, null);
var Stepper = /* @__PURE__ */ index_js_eager_.forwardRef(function Stepper2(props, ref) {
  var _props$activeStep = props.activeStep, activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep, _props$alternativeLab = props.alternativeLabel, alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab, children = props.children, classes = props.classes, className = props.className, _props$connector = props.connector, connectorProp = _props$connector === void 0 ? defaultConnector : _props$connector, _props$nonLinear = props.nonLinear, nonLinear = _props$nonLinear === void 0 ? false : _props$nonLinear, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, other = (0,objectWithoutProperties/* default */.A)(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);
  var connector = /* @__PURE__ */ index_js_eager_.isValidElement(connectorProp) ? /* @__PURE__ */ index_js_eager_.cloneElement(connectorProp, {
    orientation
  }) : null;
  var childrenArray = index_js_eager_.Children.toArray(children);
  var steps = childrenArray.map(function(step, index) {
    var state = {
      index,
      active: false,
      completed: false,
      disabled: false
    };
    if (activeStep === index) {
      state.active = true;
    } else if (!nonLinear && activeStep > index) {
      state.completed = true;
    } else if (!nonLinear && activeStep < index) {
      state.disabled = true;
    }
    return /* @__PURE__ */ index_js_eager_.cloneElement(step, (0,esm_extends/* default */.A)({
      alternativeLabel,
      connector,
      last: index + 1 === childrenArray.length,
      orientation
    }, state, step.props));
  });
  return /* @__PURE__ */ index_js_eager_.createElement(Paper/* default */.A, (0,esm_extends/* default */.A)({
    square: true,
    elevation: 0,
    className: (0,clsx_m["default"])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel),
    ref
  }, other), steps);
});
 false ? 0 : void 0;
/* harmony default export */ var Stepper_Stepper = ((0,withStyles/* default */.A)(Stepper_styles, {
  name: "MuiStepper"
})(Stepper));

;// ./node_modules/@material-ui/core/esm/SwipeableDrawer/SwipeArea.js









var SwipeArea_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      zIndex: theme.zIndex.drawer - 1
    },
    anchorLeft: {
      right: "auto"
    },
    anchorRight: {
      left: "auto",
      right: 0
    },
    anchorTop: {
      bottom: "auto",
      right: 0
    },
    anchorBottom: {
      top: "auto",
      bottom: 0,
      right: 0
    }
  };
};
var SwipeArea = /* @__PURE__ */ index_js_eager_.forwardRef(function SwipeArea2(props, ref) {
  var anchor = props.anchor, classes = props.classes, className = props.className, width = props.width, other = (0,objectWithoutProperties/* default */.A)(props, ["anchor", "classes", "className", "width"]);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, classes["anchor".concat((0,capitalize/* default */.A)(anchor))], className),
    ref,
    style: (0,defineProperty/* default */.A)({}, isHorizontal(anchor) ? "width" : "height", width)
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var SwipeableDrawer_SwipeArea = ((0,withStyles/* default */.A)(SwipeArea_styles, {
  name: "PrivateSwipeArea"
})(SwipeArea));

;// ./node_modules/@material-ui/core/esm/SwipeableDrawer/SwipeableDrawer.js















var UNCERTAINTY_THRESHOLD = 3;
var nodeThatClaimedTheSwipe = null;
function SwipeableDrawer_reset() {
  nodeThatClaimedTheSwipe = null;
}
function calculateCurrentX(anchor, touches) {
  return anchor === "right" ? document.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}
function calculateCurrentY(anchor, touches) {
  return anchor === "bottom" ? window.innerHeight - touches[0].clientY : touches[0].clientY;
}
function getMaxTranslate(horizontalSwipe, paperInstance) {
  return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}
function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
  return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}
function getDomTreeShapes(element, rootNode) {
  var domTreeShapes = [];
  while (element && element !== rootNode) {
    var style = window.getComputedStyle(element);
    if (
      // Ignore the scroll children if the element is absolute positioned.
      style.getPropertyValue("position") === "absolute" || // Ignore the scroll children if the element has an overflowX hidden
      style.getPropertyValue("overflow-x") === "hidden"
    ) {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      domTreeShapes.push(element);
    }
    element = element.parentElement;
  }
  return domTreeShapes;
}
function findNativeHandler(_ref) {
  var domTreeShapes = _ref.domTreeShapes, start = _ref.start, current = _ref.current, anchor = _ref.anchor;
  var axisProperties = {
    scrollPosition: {
      x: "scrollLeft",
      y: "scrollTop"
    },
    scrollLength: {
      x: "scrollWidth",
      y: "scrollHeight"
    },
    clientLength: {
      x: "clientWidth",
      y: "clientHeight"
    }
  };
  return domTreeShapes.some(function(shape) {
    var goingForward = current >= start;
    if (anchor === "top" || anchor === "left") {
      goingForward = !goingForward;
    }
    var axis = anchor === "left" || anchor === "right" ? "x" : "y";
    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      return shape;
    }
    return null;
  });
}
var iOS = typeof navigator !== "undefined" && /iPad|iPhone|iPod/.test(navigator.userAgent);
var transitionDurationDefault = {
  enter: transitions/* duration */.p0.enteringScreen,
  exit: transitions/* duration */.p0.leavingScreen
};
var SwipeableDrawer_useEnhancedEffect = typeof window !== "undefined" ? index_js_eager_.useLayoutEffect : index_js_eager_.useEffect;
var SwipeableDrawer = /* @__PURE__ */ index_js_eager_.forwardRef(function SwipeableDrawer2(inProps, ref) {
  var theme = (0,useTheme/* default */.A)();
  var props = (0,getThemeProps/* default */.A)({
    name: "MuiSwipeableDrawer",
    props: (0,esm_extends/* default */.A)({}, inProps),
    theme
  });
  var _props$anchor = props.anchor, anchor = _props$anchor === void 0 ? "left" : _props$anchor, _props$disableBackdro = props.disableBackdropTransition, disableBackdropTransition = _props$disableBackdro === void 0 ? false : _props$disableBackdro, _props$disableDiscove = props.disableDiscovery, disableDiscovery = _props$disableDiscove === void 0 ? false : _props$disableDiscove, _props$disableSwipeTo = props.disableSwipeToOpen, disableSwipeToOpen = _props$disableSwipeTo === void 0 ? iOS : _props$disableSwipeTo, hideBackdrop = props.hideBackdrop, _props$hysteresis = props.hysteresis, hysteresis = _props$hysteresis === void 0 ? 0.52 : _props$hysteresis, _props$minFlingVeloci = props.minFlingVelocity, minFlingVelocity = _props$minFlingVeloci === void 0 ? 450 : _props$minFlingVeloci, _props$ModalProps = props.ModalProps;
  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
  var BackdropProps = _props$ModalProps.BackdropProps, ModalPropsProp = (0,objectWithoutProperties/* default */.A)(_props$ModalProps, ["BackdropProps"]), onClose = props.onClose, onOpen = props.onOpen, open = props.open, _props$PaperProps = props.PaperProps, PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps, SwipeAreaProps = props.SwipeAreaProps, _props$swipeAreaWidth = props.swipeAreaWidth, swipeAreaWidth = _props$swipeAreaWidth === void 0 ? 20 : _props$swipeAreaWidth, _props$transitionDura = props.transitionDuration, transitionDuration = _props$transitionDura === void 0 ? transitionDurationDefault : _props$transitionDura, _props$variant = props.variant, variant = _props$variant === void 0 ? "temporary" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"]);
  var _React$useState = index_js_eager_.useState(false), maybeSwiping = _React$useState[0], setMaybeSwiping = _React$useState[1];
  var swipeInstance = index_js_eager_.useRef({
    isSwiping: null
  });
  var swipeAreaRef = index_js_eager_.useRef();
  var backdropRef = index_js_eager_.useRef();
  var paperRef = index_js_eager_.useRef();
  var touchDetected = index_js_eager_.useRef(false);
  var calculatedDurationRef = index_js_eager_.useRef();
  SwipeableDrawer_useEnhancedEffect(function() {
    calculatedDurationRef.current = null;
  }, [open]);
  var setPosition = index_js_eager_.useCallback(function(translate) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options$mode = options.mode, mode = _options$mode === void 0 ? null : _options$mode, _options$changeTransi = options.changeTransition, changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
    var anchorRtl = getAnchor(theme, anchor);
    var rtlTranslateMultiplier = ["right", "bottom"].indexOf(anchorRtl) !== -1 ? 1 : -1;
    var horizontalSwipe = isHorizontal(anchor);
    var transform = horizontalSwipe ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
    var drawerStyle = paperRef.current.style;
    drawerStyle.webkitTransform = transform;
    drawerStyle.transform = transform;
    var transition = "";
    if (mode) {
      transition = theme.transitions.create("all", (0,transitions_utils/* getTransitionProps */.c)({
        timeout: transitionDuration
      }, {
        mode
      }));
    }
    if (changeTransition) {
      drawerStyle.webkitTransition = transition;
      drawerStyle.transition = transition;
    }
    if (!disableBackdropTransition && !hideBackdrop) {
      var backdropStyle = backdropRef.current.style;
      backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);
      if (changeTransition) {
        backdropStyle.webkitTransition = transition;
        backdropStyle.transition = transition;
      }
    }
  }, [anchor, disableBackdropTransition, hideBackdrop, theme, transitionDuration]);
  var handleBodyTouchEnd = (0,useEventCallback/* default */.A)(function(event) {
    if (!touchDetected.current) {
      return;
    }
    nodeThatClaimedTheSwipe = null;
    touchDetected.current = false;
    setMaybeSwiping(false);
    if (!swipeInstance.current.isSwiping) {
      swipeInstance.current.isSwiping = null;
      return;
    }
    swipeInstance.current.isSwiping = null;
    var anchorRtl = getAnchor(theme, anchor);
    var horizontal = isHorizontal(anchor);
    var current;
    if (horizontal) {
      current = calculateCurrentX(anchorRtl, event.changedTouches);
    } else {
      current = calculateCurrentY(anchorRtl, event.changedTouches);
    }
    var startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
    var maxTranslate = getMaxTranslate(horizontal, paperRef.current);
    var currentTranslate = getTranslate(current, startLocation, open, maxTranslate);
    var translateRatio = currentTranslate / maxTranslate;
    if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) {
      calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1e3;
    }
    if (open) {
      if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) {
        onClose();
      } else {
        setPosition(0, {
          mode: "exit"
        });
      }
      return;
    }
    if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) {
      onOpen();
    } else {
      setPosition(getMaxTranslate(horizontal, paperRef.current), {
        mode: "enter"
      });
    }
  });
  var handleBodyTouchMove = (0,useEventCallback/* default */.A)(function(event) {
    if (!paperRef.current || !touchDetected.current) {
      return;
    }
    if (nodeThatClaimedTheSwipe != null && nodeThatClaimedTheSwipe !== swipeInstance.current) {
      return;
    }
    var anchorRtl = getAnchor(theme, anchor);
    var horizontalSwipe = isHorizontal(anchor);
    var currentX = calculateCurrentX(anchorRtl, event.touches);
    var currentY = calculateCurrentY(anchorRtl, event.touches);
    if (open && paperRef.current.contains(event.target) && nodeThatClaimedTheSwipe == null) {
      var domTreeShapes = getDomTreeShapes(event.target, paperRef.current);
      var nativeHandler = findNativeHandler({
        domTreeShapes,
        start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
        current: horizontalSwipe ? currentX : currentY,
        anchor
      });
      if (nativeHandler) {
        nodeThatClaimedTheSwipe = nativeHandler;
        return;
      }
      nodeThatClaimedTheSwipe = swipeInstance.current;
    }
    if (swipeInstance.current.isSwiping == null) {
      var dx = Math.abs(currentX - swipeInstance.current.startX);
      var dy = Math.abs(currentY - swipeInstance.current.startY);
      if (dx > dy) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
      var definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;
      if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
        swipeInstance.current.isSwiping = definitelySwiping;
        if (!definitelySwiping) {
          handleBodyTouchEnd(event);
          return;
        }
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
        if (!disableDiscovery && !open) {
          if (horizontalSwipe) {
            swipeInstance.current.startX -= swipeAreaWidth;
          } else {
            swipeInstance.current.startY -= swipeAreaWidth;
          }
        }
      }
    }
    if (!swipeInstance.current.isSwiping) {
      return;
    }
    var maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
    var startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
    if (open && !swipeInstance.current.paperHit) {
      startLocation = Math.min(startLocation, maxTranslate);
    }
    var translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);
    if (open) {
      if (!swipeInstance.current.paperHit) {
        var paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;
        if (paperHit) {
          swipeInstance.current.paperHit = true;
          swipeInstance.current.startX = currentX;
          swipeInstance.current.startY = currentY;
        } else {
          return;
        }
      } else if (translate === 0) {
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
      }
    }
    if (swipeInstance.current.lastTranslate === null) {
      swipeInstance.current.lastTranslate = translate;
      swipeInstance.current.lastTime = performance.now() + 1;
    }
    var velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3;
    swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
    swipeInstance.current.lastTranslate = translate;
    swipeInstance.current.lastTime = performance.now();
    if (event.cancelable) {
      event.preventDefault();
    }
    setPosition(translate);
  });
  var handleBodyTouchStart = (0,useEventCallback/* default */.A)(function(event) {
    if (event.defaultPrevented) {
      return;
    }
    if (event.muiHandled) {
      return;
    }
    if (open && !backdropRef.current.contains(event.target) && !paperRef.current.contains(event.target)) {
      return;
    }
    var anchorRtl = getAnchor(theme, anchor);
    var horizontalSwipe = isHorizontal(anchor);
    var currentX = calculateCurrentX(anchorRtl, event.touches);
    var currentY = calculateCurrentY(anchorRtl, event.touches);
    if (!open) {
      if (disableSwipeToOpen || event.target !== swipeAreaRef.current) {
        return;
      }
      if (horizontalSwipe) {
        if (currentX > swipeAreaWidth) {
          return;
        }
      } else if (currentY > swipeAreaWidth) {
        return;
      }
    }
    event.muiHandled = true;
    nodeThatClaimedTheSwipe = null;
    swipeInstance.current.startX = currentX;
    swipeInstance.current.startY = currentY;
    setMaybeSwiping(true);
    if (!open && paperRef.current) {
      setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 20 : -swipeAreaWidth), {
        changeTransition: false
      });
    }
    swipeInstance.current.velocity = 0;
    swipeInstance.current.lastTime = null;
    swipeInstance.current.lastTranslate = null;
    swipeInstance.current.paperHit = false;
    touchDetected.current = true;
  });
  index_js_eager_.useEffect(function() {
    if (variant === "temporary") {
      var doc = (0,ownerDocument/* default */.A)(paperRef.current);
      doc.addEventListener("touchstart", handleBodyTouchStart);
      doc.addEventListener("touchmove", handleBodyTouchMove, {
        passive: false
      });
      doc.addEventListener("touchend", handleBodyTouchEnd);
      return function() {
        doc.removeEventListener("touchstart", handleBodyTouchStart);
        doc.removeEventListener("touchmove", handleBodyTouchMove, {
          passive: false
        });
        doc.removeEventListener("touchend", handleBodyTouchEnd);
      };
    }
    return void 0;
  }, [variant, handleBodyTouchStart, handleBodyTouchMove, handleBodyTouchEnd]);
  index_js_eager_.useEffect(function() {
    return function() {
      if (nodeThatClaimedTheSwipe === swipeInstance.current) {
        nodeThatClaimedTheSwipe = null;
      }
    };
  }, []);
  index_js_eager_.useEffect(function() {
    if (!open) {
      setMaybeSwiping(false);
    }
  }, [open]);
  var handleBackdropRef = index_js_eager_.useCallback(function(instance) {
    backdropRef.current = react_dom_index_js_eager_.findDOMNode(instance);
  }, []);
  return /* @__PURE__ */ index_js_eager_.createElement(index_js_eager_.Fragment, null, /* @__PURE__ */ index_js_eager_.createElement(Drawer_Drawer, (0,esm_extends/* default */.A)({
    open: variant === "temporary" && maybeSwiping ? true : open,
    variant,
    ModalProps: (0,esm_extends/* default */.A)({
      BackdropProps: (0,esm_extends/* default */.A)({}, BackdropProps, {
        ref: handleBackdropRef
      })
    }, ModalPropsProp),
    PaperProps: (0,esm_extends/* default */.A)({}, PaperProps, {
      style: (0,esm_extends/* default */.A)({
        pointerEvents: variant === "temporary" && !open ? "none" : ""
      }, PaperProps.style),
      ref: paperRef
    }),
    anchor,
    transitionDuration: calculatedDurationRef.current || transitionDuration,
    onClose,
    ref
  }, other)), !disableSwipeToOpen && variant === "temporary" && /* @__PURE__ */ index_js_eager_.createElement(NoSsr_NoSsr, null, /* @__PURE__ */ index_js_eager_.createElement(SwipeableDrawer_SwipeArea, (0,esm_extends/* default */.A)({
    anchor,
    ref: swipeAreaRef,
    width: swipeAreaWidth
  }, SwipeAreaProps))));
});
 false ? 0 : void 0;
/* harmony default export */ var SwipeableDrawer_SwipeableDrawer = (SwipeableDrawer);

;// ./node_modules/@material-ui/core/esm/Switch/Switch.js










var Switch_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "inline-flex",
      width: 34 + 12 * 2,
      height: 14 + 12 * 2,
      overflow: "hidden",
      padding: 12,
      boxSizing: "border-box",
      position: "relative",
      flexShrink: 0,
      zIndex: 0,
      // Reset the stacking context.
      verticalAlign: "middle",
      // For correct alignment with the text.
      "@media print": {
        colorAdjust: "exact"
      }
    },
    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -8
    },
    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -8
    },
    /* Styles applied to the internal `SwitchBase` component's `root` class. */
    switchBase: {
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 1,
      // Render above the focus ripple.
      color: theme.palette.type === "light" ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create(["left", "transform"], {
        duration: theme.transitions.duration.shortest
      }),
      "&$checked": {
        transform: "translateX(20px)"
      },
      "&$disabled": {
        color: theme.palette.type === "light" ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      "&$checked + $track": {
        opacity: 0.5
      },
      "&$disabled + $track": {
        opacity: theme.palette.type === "light" ? 0.12 : 0.1
      }
    },
    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
    colorPrimary: {
      "&$checked": {
        color: theme.palette.primary.main,
        "&:hover": {
          backgroundColor: (0,colorManipulator/* alpha */.X4)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        }
      },
      "&$disabled": {
        color: theme.palette.type === "light" ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      "&$checked + $track": {
        backgroundColor: theme.palette.primary.main
      },
      "&$disabled + $track": {
        backgroundColor: theme.palette.type === "light" ? theme.palette.common.black : theme.palette.common.white
      }
    },
    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
    colorSecondary: {
      "&$checked": {
        color: theme.palette.secondary.main,
        "&:hover": {
          backgroundColor: (0,colorManipulator/* alpha */.X4)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        }
      },
      "&$disabled": {
        color: theme.palette.type === "light" ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      "&$checked + $track": {
        backgroundColor: theme.palette.secondary.main
      },
      "&$disabled + $track": {
        backgroundColor: theme.palette.type === "light" ? theme.palette.common.black : theme.palette.common.white
      }
    },
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      width: 40,
      height: 24,
      padding: 7,
      "& $thumb": {
        width: 16,
        height: 16
      },
      "& $switchBase": {
        padding: 4,
        "&$checked": {
          transform: "translateX(16px)"
        }
      }
    },
    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
    checked: {},
    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
    disabled: {},
    /* Styles applied to the internal SwitchBase component's input element. */
    input: {
      left: "-100%",
      width: "300%"
    },
    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
    thumb: {
      boxShadow: theme.shadows[1],
      backgroundColor: "currentColor",
      width: 20,
      height: 20,
      borderRadius: "50%"
    },
    /* Styles applied to the track element. */
    track: {
      height: "100%",
      width: "100%",
      borderRadius: 14 / 2,
      zIndex: -1,
      transition: theme.transitions.create(["opacity", "background-color"], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === "light" ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === "light" ? 0.38 : 0.3
    }
  };
};
var Switch = /* @__PURE__ */ index_js_eager_.forwardRef(function Switch2(props, ref) {
  var classes = props.classes, className = props.className, _props$color = props.color, color = _props$color === void 0 ? "secondary" : _props$color, _props$edge = props.edge, edge = _props$edge === void 0 ? false : _props$edge, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "color", "edge", "size"]);
  var icon = /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: classes.thumb
  });
  return /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: (0,clsx_m["default"])(classes.root, className, {
      "start": classes.edgeStart,
      "end": classes.edgeEnd
    }[edge], size === "small" && classes["size".concat((0,capitalize/* default */.A)(size))])
  }, /* @__PURE__ */ index_js_eager_.createElement(internal_SwitchBase, (0,esm_extends/* default */.A)({
    type: "checkbox",
    icon,
    checkedIcon: icon,
    classes: {
      root: (0,clsx_m["default"])(classes.switchBase, classes["color".concat((0,capitalize/* default */.A)(color))]),
      input: classes.input,
      checked: classes.checked,
      disabled: classes.disabled
    },
    ref
  }, other)), /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: classes.track
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Switch_Switch = ((0,withStyles/* default */.A)(Switch_styles, {
  name: "MuiSwitch"
})(Switch));

;// ./node_modules/@material-ui/core/esm/Tab/Tab.js










var Tab_styles = function styles2(theme) {
  var _extends2;
  return {
    /* Styles applied to the root element. */
    root: (0,esm_extends/* default */.A)({}, theme.typography.button, (_extends2 = {
      maxWidth: 264,
      minWidth: 72,
      position: "relative",
      boxSizing: "border-box",
      minHeight: 48,
      flexShrink: 0,
      padding: "6px 12px"
    }, (0,defineProperty/* default */.A)(_extends2, theme.breakpoints.up("sm"), {
      padding: "6px 24px"
    }), (0,defineProperty/* default */.A)(_extends2, "overflow", "hidden"), (0,defineProperty/* default */.A)(_extends2, "whiteSpace", "normal"), (0,defineProperty/* default */.A)(_extends2, "textAlign", "center"), (0,defineProperty/* default */.A)(_extends2, theme.breakpoints.up("sm"), {
      minWidth: 160
    }), _extends2)),
    /* Styles applied to the root element if both `icon` and `label` are provided. */
    labelIcon: {
      minHeight: 72,
      paddingTop: 9,
      "& $wrapper > *:first-child": {
        marginBottom: 6
      }
    },
    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */
    textColorInherit: {
      color: "inherit",
      opacity: 0.7,
      "&$selected": {
        opacity: 1
      },
      "&$disabled": {
        opacity: 0.5
      }
    },
    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */
    textColorPrimary: {
      color: theme.palette.text.secondary,
      "&$selected": {
        color: theme.palette.primary.main
      },
      "&$disabled": {
        color: theme.palette.text.disabled
      }
    },
    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */
    textColorSecondary: {
      color: theme.palette.text.secondary,
      "&$selected": {
        color: theme.palette.secondary.main
      },
      "&$disabled": {
        color: theme.palette.text.disabled
      }
    },
    /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */
    selected: {},
    /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
    disabled: {},
    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
    fullWidth: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: "none"
    },
    /* Styles applied to the root element if `wrapped={true}`. */
    wrapped: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.5
    },
    /* Styles applied to the `icon` and `label`'s wrapper element. */
    wrapper: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      flexDirection: "column"
    }
  };
};
var Tab = /* @__PURE__ */ index_js_eager_.forwardRef(function Tab2(props, ref) {
  var classes = props.classes, className = props.className, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$disableFocusRi = props.disableFocusRipple, disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi, fullWidth = props.fullWidth, icon = props.icon, indicator = props.indicator, label = props.label, onChange = props.onChange, onClick = props.onClick, onFocus = props.onFocus, selected = props.selected, selectionFollowsFocus = props.selectionFollowsFocus, _props$textColor = props.textColor, textColor = _props$textColor === void 0 ? "inherit" : _props$textColor, value = props.value, _props$wrapped = props.wrapped, wrapped = _props$wrapped === void 0 ? false : _props$wrapped, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "disabled", "disableFocusRipple", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"]);
  var handleClick = function handleClick2(event) {
    if (onChange) {
      onChange(event, value);
    }
    if (onClick) {
      onClick(event);
    }
  };
  var handleFocus = function handleFocus2(event) {
    if (selectionFollowsFocus && !selected && onChange) {
      onChange(event, value);
    }
    if (onFocus) {
      onFocus(event);
    }
  };
  return /* @__PURE__ */ index_js_eager_.createElement(ButtonBase/* default */.A, (0,esm_extends/* default */.A)({
    focusRipple: !disableFocusRipple,
    className: (0,clsx_m["default"])(classes.root, classes["textColor".concat((0,capitalize/* default */.A)(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
    ref,
    role: "tab",
    "aria-selected": selected,
    disabled,
    onClick: handleClick,
    onFocus: handleFocus,
    tabIndex: selected ? 0 : -1
  }, other), /* @__PURE__ */ index_js_eager_.createElement("span", {
    className: classes.wrapper
  }, icon, label), indicator);
});
 false ? 0 : void 0;
/* harmony default export */ var Tab_Tab = ((0,withStyles/* default */.A)(Tab_styles, {
  name: "MuiTab"
})(Tab));

;// ./node_modules/@material-ui/core/esm/Table/TableContext.js

var TableContext = index_js_eager_.createContext();
if (false) // removed by dead control flow
{}
/* harmony default export */ var Table_TableContext = (TableContext);

;// ./node_modules/@material-ui/core/esm/Table/Table.js








var Table_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: "table",
      width: "100%",
      borderCollapse: "collapse",
      borderSpacing: 0,
      "& caption": (0,esm_extends/* default */.A)({}, theme.typography.body2, {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        textAlign: "left",
        captionSide: "bottom"
      })
    },
    /* Styles applied to the root element if `stickyHeader={true}`. */
    stickyHeader: {
      borderCollapse: "separate"
    }
  };
};
var defaultComponent = "table";
var Table = /* @__PURE__ */ index_js_eager_.forwardRef(function Table2(props, ref) {
  var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? defaultComponent : _props$component, _props$padding = props.padding, padding = _props$padding === void 0 ? "normal" : _props$padding, _props$size = props.size, size = _props$size === void 0 ? "medium" : _props$size, _props$stickyHeader = props.stickyHeader, stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);
  var table = index_js_eager_.useMemo(function() {
    return {
      padding,
      size,
      stickyHeader
    };
  }, [padding, size, stickyHeader]);
  return /* @__PURE__ */ index_js_eager_.createElement(Table_TableContext.Provider, {
    value: table
  }, /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    role: Component === defaultComponent ? null : "table",
    ref,
    className: (0,clsx_m["default"])(classes.root, className, stickyHeader && classes.stickyHeader)
  }, other)));
});
 false ? 0 : void 0;
/* harmony default export */ var Table_Table = ((0,withStyles/* default */.A)(Table_styles, {
  name: "MuiTable"
})(Table));

;// ./node_modules/@material-ui/core/esm/Table/Tablelvl2Context.js

var Tablelvl2Context = index_js_eager_.createContext();
if (false) // removed by dead control flow
{}
/* harmony default export */ var Table_Tablelvl2Context = (Tablelvl2Context);

;// ./node_modules/@material-ui/core/esm/TableBody/TableBody.js







var TableBody_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "table-row-group"
  }
};
var tablelvl2 = {
  variant: "body"
};
var TableBody_defaultComponent = "tbody";
var TableBody = /* @__PURE__ */ index_js_eager_.forwardRef(function TableBody2(props, ref) {
  var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? TableBody_defaultComponent : _props$component, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "component"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Table_Tablelvl2Context.Provider, {
    value: tablelvl2
  }, /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref,
    role: Component === TableBody_defaultComponent ? null : "rowgroup"
  }, other)));
});
 false ? 0 : void 0;
/* harmony default export */ var TableBody_TableBody = ((0,withStyles/* default */.A)(TableBody_styles, {
  name: "MuiTableBody"
})(TableBody));

;// ./node_modules/@material-ui/core/esm/TableCell/TableCell.js











var TableCell_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: (0,esm_extends/* default */.A)({}, theme.typography.body2, {
      display: "table-cell",
      verticalAlign: "inherit",
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === "light" ? (0,colorManipulator/* lighten */.a)((0,colorManipulator/* alpha */.X4)(theme.palette.divider, 1), 0.88) : (0,colorManipulator/* darken */.e$)((0,colorManipulator/* alpha */.X4)(theme.palette.divider, 1), 0.68)),
      textAlign: "left",
      padding: 16
    }),
    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium
    },
    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary
    },
    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      color: theme.palette.text.secondary,
      lineHeight: theme.typography.pxToRem(21),
      fontSize: theme.typography.pxToRem(12)
    },
    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: "6px 24px 6px 16px",
      "&:last-child": {
        paddingRight: 16
      },
      "&$paddingCheckbox": {
        width: 24,
        // prevent the checkbox column from growing
        padding: "0 12px 0 16px",
        "&:last-child": {
          paddingLeft: 12,
          paddingRight: 16
        },
        "& > *": {
          padding: 0
        }
      }
    },
    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      width: 48,
      // prevent the checkbox column from growing
      padding: "0 0 0 4px",
      "&:last-child": {
        paddingLeft: 0,
        paddingRight: 4
      }
    },
    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      "&:last-child": {
        padding: 0
      }
    },
    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: "left"
    },
    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: "center"
    },
    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: "right",
      flexDirection: "row-reverse"
    },
    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: "justify"
    },
    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
    stickyHeader: {
      position: "sticky",
      top: 0,
      left: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.default
    }
  };
};
var TableCell = /* @__PURE__ */ index_js_eager_.forwardRef(function TableCell2(props, ref) {
  var _props$align = props.align, align = _props$align === void 0 ? "inherit" : _props$align, classes = props.classes, className = props.className, component = props.component, paddingProp = props.padding, scopeProp = props.scope, sizeProp = props.size, sortDirection = props.sortDirection, variantProp = props.variant, other = (0,objectWithoutProperties/* default */.A)(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);
  var table = index_js_eager_.useContext(Table_TableContext);
  var tablelvl2 = index_js_eager_.useContext(Table_Tablelvl2Context);
  var isHeadCell = tablelvl2 && tablelvl2.variant === "head";
  var role;
  var Component;
  if (component) {
    Component = component;
    role = isHeadCell ? "columnheader" : "cell";
  } else {
    Component = isHeadCell ? "th" : "td";
  }
  var scope = scopeProp;
  if (!scope && isHeadCell) {
    scope = "col";
  }
  var padding = paddingProp || (table && table.padding ? table.padding : "normal");
  var size = sizeProp || (table && table.size ? table.size : "medium");
  var variant = variantProp || tablelvl2 && tablelvl2.variant;
  var ariaSort = null;
  if (sortDirection) {
    ariaSort = sortDirection === "asc" ? "ascending" : "descending";
  }
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    ref,
    className: (0,clsx_m["default"])(classes.root, classes[variant], className, align !== "inherit" && classes["align".concat((0,capitalize/* default */.A)(align))], padding !== "normal" && classes["padding".concat((0,capitalize/* default */.A)(padding))], size !== "medium" && classes["size".concat((0,capitalize/* default */.A)(size))], variant === "head" && table && table.stickyHeader && classes.stickyHeader),
    "aria-sort": ariaSort,
    role,
    scope
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var TableCell_TableCell = ((0,withStyles/* default */.A)(TableCell_styles, {
  name: "MuiTableCell"
})(TableCell));

;// ./node_modules/@material-ui/core/esm/TableContainer/TableContainer.js






var TableContainer_styles = {
  /* Styles applied to the root element. */
  root: {
    width: "100%",
    overflowX: "auto"
  }
};
var TableContainer = /* @__PURE__ */ index_js_eager_.forwardRef(function TableContainer2(props, ref) {
  var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "component"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    ref,
    className: (0,clsx_m["default"])(classes.root, className)
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var TableContainer_TableContainer = ((0,withStyles/* default */.A)(TableContainer_styles, {
  name: "MuiTableContainer"
})(TableContainer));

;// ./node_modules/@material-ui/core/esm/TableFooter/TableFooter.js







var TableFooter_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "table-footer-group"
  }
};
var TableFooter_tablelvl2 = {
  variant: "footer"
};
var TableFooter_defaultComponent = "tfoot";
var TableFooter = /* @__PURE__ */ index_js_eager_.forwardRef(function TableFooter2(props, ref) {
  var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? TableFooter_defaultComponent : _props$component, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "component"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Table_Tablelvl2Context.Provider, {
    value: TableFooter_tablelvl2
  }, /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref,
    role: Component === TableFooter_defaultComponent ? null : "rowgroup"
  }, other)));
});
 false ? 0 : void 0;
/* harmony default export */ var TableFooter_TableFooter = ((0,withStyles/* default */.A)(TableFooter_styles, {
  name: "MuiTableFooter"
})(TableFooter));

;// ./node_modules/@material-ui/core/esm/TableHead/TableHead.js







var TableHead_styles = {
  /* Styles applied to the root element. */
  root: {
    display: "table-header-group"
  }
};
var TableHead_tablelvl2 = {
  variant: "head"
};
var TableHead_defaultComponent = "thead";
var TableHead = /* @__PURE__ */ index_js_eager_.forwardRef(function TableHead2(props, ref) {
  var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? TableHead_defaultComponent : _props$component, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "component"]);
  return /* @__PURE__ */ index_js_eager_.createElement(Table_Tablelvl2Context.Provider, {
    value: TableHead_tablelvl2
  }, /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    ref,
    role: Component === TableHead_defaultComponent ? null : "rowgroup"
  }, other)));
});
 false ? 0 : void 0;
/* harmony default export */ var TableHead_TableHead = ((0,withStyles/* default */.A)(TableHead_styles, {
  name: "MuiTableHead"
})(TableHead));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(30178);
;// ./node_modules/@material-ui/core/esm/internal/svg-icons/KeyboardArrowLeft.js


/* harmony default export */ var KeyboardArrowLeft = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"));

;// ./node_modules/@material-ui/core/esm/internal/svg-icons/KeyboardArrowRight.js


/* harmony default export */ var KeyboardArrowRight = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight"));

;// ./node_modules/@material-ui/core/esm/TablePagination/TablePaginationActions.js








var TablePaginationActions_ref = /* @__PURE__ */ index_js_eager_.createElement(KeyboardArrowRight, null);
var _ref2 = /* @__PURE__ */ index_js_eager_.createElement(KeyboardArrowLeft, null);
var _ref3 = /* @__PURE__ */ index_js_eager_.createElement(KeyboardArrowLeft, null);
var _ref4 = /* @__PURE__ */ index_js_eager_.createElement(KeyboardArrowRight, null);
var TablePaginationActions = /* @__PURE__ */ index_js_eager_.forwardRef(function TablePaginationActions2(props, ref) {
  var backIconButtonProps = props.backIconButtonProps, count = props.count, nextIconButtonProps = props.nextIconButtonProps, _props$onChangePage = props.onChangePage, onChangePage = _props$onChangePage === void 0 ? function() {
  } : _props$onChangePage, _props$onPageChange = props.onPageChange, onPageChange = _props$onPageChange === void 0 ? function() {
  } : _props$onPageChange, page = props.page, rowsPerPage = props.rowsPerPage, other = (0,objectWithoutProperties/* default */.A)(props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "onPageChange", "page", "rowsPerPage"]);
  var theme = (0,useTheme/* default */.A)();
  var handleBackButtonClick = function handleBackButtonClick2(event) {
    onChangePage(event, page - 1);
    onPageChange(event, page - 1);
  };
  var handleNextButtonClick = function handleNextButtonClick2(event) {
    onChangePage(event, page + 1);
    onPageChange(event, page + 1);
  };
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement(IconButton/* default */.A, (0,esm_extends/* default */.A)({
    onClick: handleBackButtonClick,
    disabled: page === 0,
    color: "inherit"
  }, backIconButtonProps), theme.direction === "rtl" ? TablePaginationActions_ref : _ref2), /* @__PURE__ */ index_js_eager_.createElement(IconButton/* default */.A, (0,esm_extends/* default */.A)({
    onClick: handleNextButtonClick,
    disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
    color: "inherit"
  }, nextIconButtonProps), theme.direction === "rtl" ? _ref3 : _ref4));
});
 false ? 0 : void 0;
/* harmony default export */ var TablePagination_TablePaginationActions = (TablePaginationActions);

;// ./node_modules/@material-ui/core/esm/TablePagination/TablePagination.js
















var TablePagination_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      overflow: "auto",
      // Increase the specificity to override TableCell.
      "&:last-child": {
        padding: 0
      }
    },
    /* Styles applied to the Toolbar component. */
    toolbar: {
      minHeight: 52,
      paddingRight: 2
    },
    /* Styles applied to the spacer element. */
    spacer: {
      flex: "1 1 100%"
    },
    /* Styles applied to the caption Typography components if `variant="caption"`. */
    caption: {
      flexShrink: 0
    },
    // TODO v5: `.selectRoot` should be merged with `.input`
    /* Styles applied to the Select component root element. */
    selectRoot: {
      marginRight: 32,
      marginLeft: 8
    },
    /* Styles applied to the Select component `select` class. */
    select: {
      paddingLeft: 8,
      paddingRight: 24,
      textAlign: "right",
      textAlignLast: "right"
      // Align <select> on Chrome.
    },
    // TODO v5: remove
    /* Styles applied to the Select component `icon` class. */
    selectIcon: {},
    /* Styles applied to the `InputBase` component. */
    input: {
      color: "inherit",
      fontSize: "inherit",
      flexShrink: 0
    },
    /* Styles applied to the MenuItem component. */
    menuItem: {},
    /* Styles applied to the internal `TablePaginationActions` component. */
    actions: {
      flexShrink: 0,
      marginLeft: 20
    }
  };
};
var defaultLabelDisplayedRows = function defaultLabelDisplayedRows2(_ref) {
  var from = _ref.from, to = _ref.to, count = _ref.count;
  return "".concat(from, "-").concat(to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
};
var defaultRowsPerPageOptions = [10, 25, 50, 100];
var TablePagination = /* @__PURE__ */ index_js_eager_.forwardRef(function TablePagination2(props, ref) {
  var _props$ActionsCompone = props.ActionsComponent, ActionsComponent = _props$ActionsCompone === void 0 ? TablePagination_TablePaginationActions : _props$ActionsCompone, backIconButtonProps = props.backIconButtonProps, _props$backIconButton = props.backIconButtonText, backIconButtonText = _props$backIconButton === void 0 ? "Previous page" : _props$backIconButton, classes = props.classes, className = props.className, colSpanProp = props.colSpan, _props$component = props.component, Component = _props$component === void 0 ? TableCell_TableCell : _props$component, count = props.count, _props$labelDisplayed = props.labelDisplayedRows, labelDisplayedRows = _props$labelDisplayed === void 0 ? defaultLabelDisplayedRows : _props$labelDisplayed, _props$labelRowsPerPa = props.labelRowsPerPage, labelRowsPerPage = _props$labelRowsPerPa === void 0 ? "Rows per page:" : _props$labelRowsPerPa, nextIconButtonProps = props.nextIconButtonProps, _props$nextIconButton = props.nextIconButtonText, nextIconButtonText = _props$nextIconButton === void 0 ? "Next page" : _props$nextIconButton, onChangePage = props.onChangePage, onPageChange = props.onPageChange, onChangeRowsPerPageProp = props.onChangeRowsPerPage, onRowsPerPageChangeProp = props.onRowsPerPageChange, page = props.page, rowsPerPage = props.rowsPerPage, _props$rowsPerPageOpt = props.rowsPerPageOptions, rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? defaultRowsPerPageOptions : _props$rowsPerPageOpt, _props$SelectProps = props.SelectProps, SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps, other = (0,objectWithoutProperties/* default */.A)(props, ["ActionsComponent", "backIconButtonProps", "backIconButtonText", "classes", "className", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "nextIconButtonText", "onChangePage", "onPageChange", "onChangeRowsPerPage", "onRowsPerPageChange", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);
  var onChangeRowsPerPage = onChangeRowsPerPageProp || onRowsPerPageChangeProp;
  var colSpan;
  if (Component === TableCell_TableCell || Component === "td") {
    colSpan = colSpanProp || 1e3;
  }
  var selectId = (0,unstable_useId/* default */.A)();
  var labelId = (0,unstable_useId/* default */.A)();
  var MenuItemComponent = SelectProps.native ? "option" : MenuItem/* default */.A;
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className),
    colSpan,
    ref
  }, other), /* @__PURE__ */ index_js_eager_.createElement(Toolbar/* default */.A, {
    className: classes.toolbar
  }, /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: classes.spacer
  }), rowsPerPageOptions.length > 1 && /* @__PURE__ */ index_js_eager_.createElement(Typography/* default */.A, {
    color: "inherit",
    variant: "body2",
    className: classes.caption,
    id: labelId
  }, labelRowsPerPage), rowsPerPageOptions.length > 1 && /* @__PURE__ */ index_js_eager_.createElement(Select/* default */.A, (0,esm_extends/* default */.A)({
    classes: {
      select: classes.select,
      icon: classes.selectIcon
    },
    input: /* @__PURE__ */ index_js_eager_.createElement(InputBase/* default */.A, {
      className: (0,clsx_m["default"])(classes.input, classes.selectRoot)
    }),
    value: rowsPerPage,
    onChange: onChangeRowsPerPage,
    id: selectId,
    labelId
  }, SelectProps), rowsPerPageOptions.map(function(rowsPerPageOption) {
    return /* @__PURE__ */ index_js_eager_.createElement(MenuItemComponent, {
      className: classes.menuItem,
      key: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption,
      value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
    }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
  })), /* @__PURE__ */ index_js_eager_.createElement(Typography/* default */.A, {
    color: "inherit",
    variant: "body2",
    className: classes.caption
  }, labelDisplayedRows({
    from: count === 0 ? 0 : page * rowsPerPage + 1,
    to: count !== -1 ? Math.min(count, (page + 1) * rowsPerPage) : (page + 1) * rowsPerPage,
    count: count === -1 ? -1 : count,
    page
  })), /* @__PURE__ */ index_js_eager_.createElement(ActionsComponent, {
    className: classes.actions,
    backIconButtonProps: (0,esm_extends/* default */.A)({
      title: backIconButtonText,
      "aria-label": backIconButtonText
    }, backIconButtonProps),
    count,
    nextIconButtonProps: (0,esm_extends/* default */.A)({
      title: nextIconButtonText,
      "aria-label": nextIconButtonText
    }, nextIconButtonProps),
    onChangePage,
    onPageChange,
    page,
    rowsPerPage
  })));
});
 false ? 0 : void 0;
/* harmony default export */ var TablePagination_TablePagination = ((0,withStyles/* default */.A)(TablePagination_styles, {
  name: "MuiTablePagination"
})(TablePagination));

;// ./node_modules/@material-ui/core/esm/TableRow/TableRow.js








var TableRow_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: "inherit",
      display: "table-row",
      verticalAlign: "middle",
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      "&$hover:hover": {
        backgroundColor: theme.palette.action.hover
      },
      "&$selected, &$selected:hover": {
        backgroundColor: (0,colorManipulator/* alpha */.X4)(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
      }
    },
    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},
    /* Pseudo-class applied to the root element if `hover={true}`. */
    hover: {},
    /* Styles applied to the root element if table variant="head". */
    head: {},
    /* Styles applied to the root element if table variant="footer". */
    footer: {}
  };
};
var TableRow_defaultComponent = "tr";
var TableRow = /* @__PURE__ */ index_js_eager_.forwardRef(function TableRow2(props, ref) {
  var classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? TableRow_defaultComponent : _props$component, _props$hover = props.hover, hover = _props$hover === void 0 ? false : _props$hover, _props$selected = props.selected, selected = _props$selected === void 0 ? false : _props$selected, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "component", "hover", "selected"]);
  var tablelvl2 = index_js_eager_.useContext(Table_Tablelvl2Context);
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    ref,
    className: (0,clsx_m["default"])(classes.root, className, tablelvl2 && {
      "head": classes.head,
      "footer": classes.footer
    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
    role: Component === TableRow_defaultComponent ? null : "row"
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var TableRow_TableRow = ((0,withStyles/* default */.A)(TableRow_styles, {
  name: "MuiTableRow"
})(TableRow));

;// ./node_modules/@material-ui/core/esm/internal/svg-icons/ArrowDownward.js


/* harmony default export */ var ArrowDownward = ((0,createSvgIcon/* default */.A)(/* @__PURE__ */ index_js_eager_.createElement("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), "ArrowDownward"));

;// ./node_modules/@material-ui/core/esm/TableSortLabel/TableSortLabel.js









var TableSortLabel_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      cursor: "pointer",
      display: "inline-flex",
      justifyContent: "flex-start",
      flexDirection: "inherit",
      alignItems: "center",
      "&:focus": {
        color: theme.palette.text.secondary
      },
      "&:hover": {
        color: theme.palette.text.secondary,
        "& $icon": {
          opacity: 0.5
        }
      },
      "&$active": {
        color: theme.palette.text.primary,
        // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
        "&& $icon": {
          opacity: 1,
          color: theme.palette.text.secondary
        }
      }
    },
    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},
    /* Styles applied to the icon component. */
    icon: {
      fontSize: 18,
      marginRight: 4,
      marginLeft: 4,
      opacity: 0,
      transition: theme.transitions.create(["opacity", "transform"], {
        duration: theme.transitions.duration.shorter
      }),
      userSelect: "none"
    },
    /* Styles applied to the icon component if `direction="desc"`. */
    iconDirectionDesc: {
      transform: "rotate(0deg)"
    },
    /* Styles applied to the icon component if `direction="asc"`. */
    iconDirectionAsc: {
      transform: "rotate(180deg)"
    }
  };
};
var TableSortLabel = /* @__PURE__ */ index_js_eager_.forwardRef(function TableSortLabel2(props, ref) {
  var _props$active = props.active, active = _props$active === void 0 ? false : _props$active, children = props.children, classes = props.classes, className = props.className, _props$direction = props.direction, direction = _props$direction === void 0 ? "asc" : _props$direction, _props$hideSortIcon = props.hideSortIcon, hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon, _props$IconComponent = props.IconComponent, IconComponent = _props$IconComponent === void 0 ? ArrowDownward : _props$IconComponent, other = (0,objectWithoutProperties/* default */.A)(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);
  return /* @__PURE__ */ index_js_eager_.createElement(ButtonBase/* default */.A, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, active && classes.active),
    component: "span",
    disableRipple: true,
    ref
  }, other), children, hideSortIcon && !active ? null : /* @__PURE__ */ index_js_eager_.createElement(IconComponent, {
    className: (0,clsx_m["default"])(classes.icon, classes["iconDirection".concat((0,capitalize/* default */.A)(direction))])
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var TableSortLabel_TableSortLabel = ((0,withStyles/* default */.A)(TableSortLabel_styles, {
  name: "MuiTableSortLabel"
})(TableSortLabel));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(37940);
;// ./node_modules/@material-ui/core/esm/utils/scrollLeft.js
var cachedType;
function detectScrollType() {
  if (cachedType) {
    return cachedType;
  }
  var dummy = document.createElement("div");
  var container = document.createElement("div");
  container.style.width = "10px";
  container.style.height = "1px";
  dummy.appendChild(container);
  dummy.dir = "rtl";
  dummy.style.fontSize = "14px";
  dummy.style.width = "4px";
  dummy.style.height = "1px";
  dummy.style.position = "absolute";
  dummy.style.top = "-1000px";
  dummy.style.overflow = "scroll";
  document.body.appendChild(dummy);
  cachedType = "reverse";
  if (dummy.scrollLeft > 0) {
    cachedType = "default";
  } else {
    dummy.scrollLeft = 1;
    if (dummy.scrollLeft === 0) {
      cachedType = "negative";
    }
  }
  document.body.removeChild(dummy);
  return cachedType;
}
function getNormalizedScrollLeft(element, direction) {
  var scrollLeft = element.scrollLeft;
  if (direction !== "rtl") {
    return scrollLeft;
  }
  var type = detectScrollType();
  switch (type) {
    case "negative":
      return element.scrollWidth - element.clientWidth + scrollLeft;
    case "reverse":
      return element.scrollWidth - element.clientWidth - scrollLeft;
    default:
      return scrollLeft;
  }
}

;// ./node_modules/@material-ui/core/esm/internal/animate.js
function easeInOutSin(time) {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function animate(property, element, to) {
  var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var cb = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {
  };
  var _options$ease = options.ease, ease = _options$ease === void 0 ? easeInOutSin : _options$ease, _options$duration = options.duration, duration = _options$duration === void 0 ? 300 : _options$duration;
  var start = null;
  var from = element[property];
  var cancelled = false;
  var cancel = function cancel2() {
    cancelled = true;
  };
  var step = function step2(timestamp) {
    if (cancelled) {
      cb(new Error("Animation cancelled"));
      return;
    }
    if (start === null) {
      start = timestamp;
    }
    var time = Math.min(1, (timestamp - start) / duration);
    element[property] = ease(time) * (to - from) + from;
    if (time >= 1) {
      requestAnimationFrame(function() {
        cb(null);
      });
      return;
    }
    requestAnimationFrame(step2);
  };
  if (from === to) {
    cb(new Error("Element already at target position"));
    return cancel;
  }
  requestAnimationFrame(step);
  return cancel;
}

;// ./node_modules/@material-ui/core/esm/Tabs/ScrollbarSize.js





var ScrollbarSize_styles = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function ScrollbarSize(props) {
  var onChange = props.onChange, other = (0,objectWithoutProperties/* default */.A)(props, ["onChange"]);
  var scrollbarHeight = index_js_eager_.useRef();
  var nodeRef = index_js_eager_.useRef(null);
  var setMeasurements = function setMeasurements2() {
    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
  };
  index_js_eager_.useEffect(function() {
    var handleResize = (0,debounce/* default */.A)(function() {
      var prevHeight = scrollbarHeight.current;
      setMeasurements();
      if (prevHeight !== scrollbarHeight.current) {
        onChange(scrollbarHeight.current);
      }
    });
    window.addEventListener("resize", handleResize);
    return function() {
      handleResize.clear();
      window.removeEventListener("resize", handleResize);
    };
  }, [onChange]);
  index_js_eager_.useEffect(function() {
    setMeasurements();
    onChange(scrollbarHeight.current);
  }, [onChange]);
  return /* @__PURE__ */ index_js_eager_.createElement("div", (0,esm_extends/* default */.A)({
    style: ScrollbarSize_styles,
    ref: nodeRef
  }, other));
}
 false ? 0 : void 0;

;// ./node_modules/@material-ui/core/esm/Tabs/TabIndicator.js







var TabIndicator_styles = function styles2(theme) {
  return {
    root: {
      position: "absolute",
      height: 2,
      bottom: 0,
      width: "100%",
      transition: theme.transitions.create()
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },
    vertical: {
      height: "100%",
      width: 2,
      right: 0
    }
  };
};
var TabIndicator = /* @__PURE__ */ index_js_eager_.forwardRef(function TabIndicator2(props, ref) {
  var classes = props.classes, className = props.className, color = props.color, orientation = props.orientation, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "color", "orientation"]);
  return /* @__PURE__ */ index_js_eager_.createElement("span", (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, classes["color".concat((0,capitalize/* default */.A)(color))], className, orientation === "vertical" && classes.vertical),
    ref
  }, other));
});
 false ? 0 : void 0;
/* harmony default export */ var Tabs_TabIndicator = ((0,withStyles/* default */.A)(TabIndicator_styles, {
  name: "PrivateTabIndicator"
})(TabIndicator));

;// ./node_modules/@material-ui/core/esm/TabScrollButton/TabScrollButton.js









var TabScrollButton_styles = {
  /* Styles applied to the root element. */
  root: {
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    "&$disabled": {
      opacity: 0
    }
  },
  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    width: "100%",
    height: 40,
    "& svg": {
      transform: "rotate(90deg)"
    }
  },
  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {}
};
var TabScrollButton_ref = /* @__PURE__ */ index_js_eager_.createElement(KeyboardArrowLeft, {
  fontSize: "small"
});
var TabScrollButton_ref2 = /* @__PURE__ */ index_js_eager_.createElement(KeyboardArrowRight, {
  fontSize: "small"
});
var TabScrollButton = /* @__PURE__ */ index_js_eager_.forwardRef(function TabScrollButton2(props, ref) {
  var classes = props.classes, classNameProp = props.className, direction = props.direction, orientation = props.orientation, disabled = props.disabled, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "className", "direction", "orientation", "disabled"]);
  return /* @__PURE__ */ index_js_eager_.createElement(ButtonBase/* default */.A, (0,esm_extends/* default */.A)({
    component: "div",
    className: (0,clsx_m["default"])(classes.root, classNameProp, disabled && classes.disabled, orientation === "vertical" && classes.vertical),
    ref,
    role: null,
    tabIndex: null
  }, other), direction === "left" ? TabScrollButton_ref : TabScrollButton_ref2);
});
 false ? 0 : void 0;
/* harmony default export */ var TabScrollButton_TabScrollButton = ((0,withStyles/* default */.A)(TabScrollButton_styles, {
  name: "MuiTabScrollButton"
})(TabScrollButton));

;// ./node_modules/@material-ui/core/esm/Tabs/Tabs.js


















var Tabs_styles = function styles2(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: "hidden",
      minHeight: 48,
      WebkitOverflowScrolling: "touch",
      // Add iOS momentum scrolling.
      display: "flex"
    },
    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      flexDirection: "column"
    },
    /* Styles applied to the flex container element. */
    flexContainer: {
      display: "flex"
    },
    /* Styles applied to the flex container element if `orientation="vertical"`. */
    flexContainerVertical: {
      flexDirection: "column"
    },
    /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
    centered: {
      justifyContent: "center"
    },
    /* Styles applied to the tablist element. */
    scroller: {
      position: "relative",
      display: "inline-block",
      flex: "1 1 auto",
      whiteSpace: "nowrap"
    },
    /* Styles applied to the tablist element if `!variant="scrollable"`. */
    fixed: {
      overflowX: "hidden",
      width: "100%"
    },
    /* Styles applied to the tablist element if `variant="scrollable"`. */
    scrollable: {
      overflowX: "scroll",
      // Hide dimensionless scrollbar on MacOS
      scrollbarWidth: "none",
      // Firefox
      "&::-webkit-scrollbar": {
        display: "none"
        // Safari + Chrome
      }
    },
    /* Styles applied to the `ScrollButtonComponent` component. */
    scrollButtons: {},
    /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
    scrollButtonsDesktop: (0,defineProperty/* default */.A)({}, theme.breakpoints.down("xs"), {
      display: "none"
    }),
    /* Styles applied to the `TabIndicator` component. */
    indicator: {}
  };
};
var Tabs = /* @__PURE__ */ index_js_eager_.forwardRef(function Tabs2(props, ref) {
  var ariaLabel = props["aria-label"], ariaLabelledBy = props["aria-labelledby"], action = props.action, _props$centered = props.centered, centered = _props$centered === void 0 ? false : _props$centered, childrenProp = props.children, classes = props.classes, className = props.className, _props$component = props.component, Component = _props$component === void 0 ? "div" : _props$component, _props$indicatorColor = props.indicatorColor, indicatorColor = _props$indicatorColor === void 0 ? "secondary" : _props$indicatorColor, onChange = props.onChange, _props$orientation = props.orientation, orientation = _props$orientation === void 0 ? "horizontal" : _props$orientation, _props$ScrollButtonCo = props.ScrollButtonComponent, ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? TabScrollButton_TabScrollButton : _props$ScrollButtonCo, _props$scrollButtons = props.scrollButtons, scrollButtons = _props$scrollButtons === void 0 ? "auto" : _props$scrollButtons, selectionFollowsFocus = props.selectionFollowsFocus, _props$TabIndicatorPr = props.TabIndicatorProps, TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr, TabScrollButtonProps = props.TabScrollButtonProps, _props$textColor = props.textColor, textColor = _props$textColor === void 0 ? "inherit" : _props$textColor, value = props.value, _props$variant = props.variant, variant = _props$variant === void 0 ? "standard" : _props$variant, other = (0,objectWithoutProperties/* default */.A)(props, ["aria-label", "aria-labelledby", "action", "centered", "children", "classes", "className", "component", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant"]);
  var theme = (0,useTheme/* default */.A)();
  var scrollable = variant === "scrollable";
  var isRtl = theme.direction === "rtl";
  var vertical = orientation === "vertical";
  var scrollStart = vertical ? "scrollTop" : "scrollLeft";
  var start = vertical ? "top" : "left";
  var end = vertical ? "bottom" : "right";
  var clientSize = vertical ? "clientHeight" : "clientWidth";
  var size = vertical ? "height" : "width";
  if (false) // removed by dead control flow
{}
  var _React$useState = index_js_eager_.useState(false), mounted = _React$useState[0], setMounted = _React$useState[1];
  var _React$useState2 = index_js_eager_.useState({}), indicatorStyle = _React$useState2[0], setIndicatorStyle = _React$useState2[1];
  var _React$useState3 = index_js_eager_.useState({
    start: false,
    end: false
  }), displayScroll = _React$useState3[0], setDisplayScroll = _React$useState3[1];
  var _React$useState4 = index_js_eager_.useState({
    overflow: "hidden",
    marginBottom: null
  }), scrollerStyle = _React$useState4[0], setScrollerStyle = _React$useState4[1];
  var valueToIndex = /* @__PURE__ */ new Map();
  var tabsRef = index_js_eager_.useRef(null);
  var tabListRef = index_js_eager_.useRef(null);
  var getTabsMeta = function getTabsMeta2() {
    var tabsNode = tabsRef.current;
    var tabsMeta;
    if (tabsNode) {
      var rect = tabsNode.getBoundingClientRect();
      tabsMeta = {
        clientWidth: tabsNode.clientWidth,
        scrollLeft: tabsNode.scrollLeft,
        scrollTop: tabsNode.scrollTop,
        scrollLeftNormalized: getNormalizedScrollLeft(tabsNode, theme.direction),
        scrollWidth: tabsNode.scrollWidth,
        top: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        right: rect.right
      };
    }
    var tabMeta;
    if (tabsNode && value !== false) {
      var _children = tabListRef.current.children;
      if (_children.length > 0) {
        var tab = _children[valueToIndex.get(value)];
        if (false) // removed by dead control flow
{}
        tabMeta = tab ? tab.getBoundingClientRect() : null;
      }
    }
    return {
      tabsMeta,
      tabMeta
    };
  };
  var updateIndicatorState = (0,useEventCallback/* default */.A)(function() {
    var _newIndicatorStyle;
    var _getTabsMeta = getTabsMeta(), tabsMeta = _getTabsMeta.tabsMeta, tabMeta = _getTabsMeta.tabMeta;
    var startValue = 0;
    if (tabMeta && tabsMeta) {
      if (vertical) {
        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
      } else {
        var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        startValue = tabMeta.left - tabsMeta.left + correction;
      }
    }
    var newIndicatorStyle = (_newIndicatorStyle = {}, (0,defineProperty/* default */.A)(_newIndicatorStyle, start, startValue), (0,defineProperty/* default */.A)(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);
    if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) {
      setIndicatorStyle(newIndicatorStyle);
    } else {
      var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
      var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
      if (dStart >= 1 || dSize >= 1) {
        setIndicatorStyle(newIndicatorStyle);
      }
    }
  });
  var scroll = function scroll2(scrollValue) {
    animate(scrollStart, tabsRef.current, scrollValue);
  };
  var moveTabsScroll = function moveTabsScroll2(delta) {
    var scrollValue = tabsRef.current[scrollStart];
    if (vertical) {
      scrollValue += delta;
    } else {
      scrollValue += delta * (isRtl ? -1 : 1);
      scrollValue *= isRtl && detectScrollType() === "reverse" ? -1 : 1;
    }
    scroll(scrollValue);
  };
  var handleStartScrollClick = function handleStartScrollClick2() {
    moveTabsScroll(-tabsRef.current[clientSize]);
  };
  var handleEndScrollClick = function handleEndScrollClick2() {
    moveTabsScroll(tabsRef.current[clientSize]);
  };
  var handleScrollbarSizeChange = index_js_eager_.useCallback(function(scrollbarHeight) {
    setScrollerStyle({
      overflow: null,
      marginBottom: -scrollbarHeight
    });
  }, []);
  var getConditionalElements = function getConditionalElements2() {
    var conditionalElements2 = {};
    conditionalElements2.scrollbarSizeListener = scrollable ? /* @__PURE__ */ index_js_eager_.createElement(ScrollbarSize, {
      className: classes.scrollable,
      onChange: handleScrollbarSizeChange
    }) : null;
    var scrollButtonsActive = displayScroll.start || displayScroll.end;
    var showScrollButtons = scrollable && (scrollButtons === "auto" && scrollButtonsActive || scrollButtons === "desktop" || scrollButtons === "on");
    conditionalElements2.scrollButtonStart = showScrollButtons ? /* @__PURE__ */ index_js_eager_.createElement(ScrollButtonComponent, (0,esm_extends/* default */.A)({
      orientation,
      direction: isRtl ? "right" : "left",
      onClick: handleStartScrollClick,
      disabled: !displayScroll.start,
      className: (0,clsx_m["default"])(classes.scrollButtons, scrollButtons !== "on" && classes.scrollButtonsDesktop)
    }, TabScrollButtonProps)) : null;
    conditionalElements2.scrollButtonEnd = showScrollButtons ? /* @__PURE__ */ index_js_eager_.createElement(ScrollButtonComponent, (0,esm_extends/* default */.A)({
      orientation,
      direction: isRtl ? "left" : "right",
      onClick: handleEndScrollClick,
      disabled: !displayScroll.end,
      className: (0,clsx_m["default"])(classes.scrollButtons, scrollButtons !== "on" && classes.scrollButtonsDesktop)
    }, TabScrollButtonProps)) : null;
    return conditionalElements2;
  };
  var scrollSelectedIntoView = (0,useEventCallback/* default */.A)(function() {
    var _getTabsMeta2 = getTabsMeta(), tabsMeta = _getTabsMeta2.tabsMeta, tabMeta = _getTabsMeta2.tabMeta;
    if (!tabMeta || !tabsMeta) {
      return;
    }
    if (tabMeta[start] < tabsMeta[start]) {
      var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
      scroll(nextScrollStart);
    } else if (tabMeta[end] > tabsMeta[end]) {
      var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
      scroll(_nextScrollStart);
    }
  });
  var updateScrollButtonState = (0,useEventCallback/* default */.A)(function() {
    if (scrollable && scrollButtons !== "off") {
      var _tabsRef$current = tabsRef.current, scrollTop = _tabsRef$current.scrollTop, scrollHeight = _tabsRef$current.scrollHeight, clientHeight = _tabsRef$current.clientHeight, scrollWidth = _tabsRef$current.scrollWidth, clientWidth = _tabsRef$current.clientWidth;
      var showStartScroll;
      var showEndScroll;
      if (vertical) {
        showStartScroll = scrollTop > 1;
        showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
      } else {
        var scrollLeft = getNormalizedScrollLeft(tabsRef.current, theme.direction);
        showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
        showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
      }
      if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) {
        setDisplayScroll({
          start: showStartScroll,
          end: showEndScroll
        });
      }
    }
  });
  index_js_eager_.useEffect(function() {
    var handleResize = (0,debounce/* default */.A)(function() {
      updateIndicatorState();
      updateScrollButtonState();
    });
    var win = (0,ownerWindow/* default */.A)(tabsRef.current);
    win.addEventListener("resize", handleResize);
    return function() {
      handleResize.clear();
      win.removeEventListener("resize", handleResize);
    };
  }, [updateIndicatorState, updateScrollButtonState]);
  var handleTabsScroll = index_js_eager_.useCallback((0,debounce/* default */.A)(function() {
    updateScrollButtonState();
  }));
  index_js_eager_.useEffect(function() {
    return function() {
      handleTabsScroll.clear();
    };
  }, [handleTabsScroll]);
  index_js_eager_.useEffect(function() {
    setMounted(true);
  }, []);
  index_js_eager_.useEffect(function() {
    updateIndicatorState();
    updateScrollButtonState();
  });
  index_js_eager_.useEffect(function() {
    scrollSelectedIntoView();
  }, [scrollSelectedIntoView, indicatorStyle]);
  index_js_eager_.useImperativeHandle(action, function() {
    return {
      updateIndicator: updateIndicatorState,
      updateScrollButtons: updateScrollButtonState
    };
  }, [updateIndicatorState, updateScrollButtonState]);
  var indicator = /* @__PURE__ */ index_js_eager_.createElement(Tabs_TabIndicator, (0,esm_extends/* default */.A)({
    className: classes.indicator,
    orientation,
    color: indicatorColor
  }, TabIndicatorProps, {
    style: (0,esm_extends/* default */.A)({}, indicatorStyle, TabIndicatorProps.style)
  }));
  var childIndex = 0;
  var children = index_js_eager_.Children.map(childrenProp, function(child) {
    if (!/* @__PURE__ */ index_js_eager_.isValidElement(child)) {
      return null;
    }
    if (false) // removed by dead control flow
{}
    var childValue = child.props.value === void 0 ? childIndex : child.props.value;
    valueToIndex.set(childValue, childIndex);
    var selected = childValue === value;
    childIndex += 1;
    return /* @__PURE__ */ index_js_eager_.cloneElement(child, {
      fullWidth: variant === "fullWidth",
      indicator: selected && !mounted && indicator,
      selected,
      selectionFollowsFocus,
      onChange,
      textColor,
      value: childValue
    });
  });
  var handleKeyDown = function handleKeyDown2(event) {
    var target = event.target;
    var role = target.getAttribute("role");
    if (role !== "tab") {
      return;
    }
    var newFocusTarget = null;
    var previousItemKey = orientation !== "vertical" ? "ArrowLeft" : "ArrowUp";
    var nextItemKey = orientation !== "vertical" ? "ArrowRight" : "ArrowDown";
    if (orientation !== "vertical" && theme.direction === "rtl") {
      previousItemKey = "ArrowRight";
      nextItemKey = "ArrowLeft";
    }
    switch (event.key) {
      case previousItemKey:
        newFocusTarget = target.previousElementSibling || tabListRef.current.lastChild;
        break;
      case nextItemKey:
        newFocusTarget = target.nextElementSibling || tabListRef.current.firstChild;
        break;
      case "Home":
        newFocusTarget = tabListRef.current.firstChild;
        break;
      case "End":
        newFocusTarget = tabListRef.current.lastChild;
        break;
      default:
        break;
    }
    if (newFocusTarget !== null) {
      newFocusTarget.focus();
      event.preventDefault();
    }
  };
  var conditionalElements = getConditionalElements();
  return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.root, className, vertical && classes.vertical),
    ref
  }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /* @__PURE__ */ index_js_eager_.createElement("div", {
    className: (0,clsx_m["default"])(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
    style: scrollerStyle,
    ref: tabsRef,
    onScroll: handleTabsScroll
  }, /* @__PURE__ */ index_js_eager_.createElement("div", {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    className: (0,clsx_m["default"])(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
    onKeyDown: handleKeyDown,
    ref: tabListRef,
    role: "tablist"
  }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
});
 false ? 0 : void 0;
/* harmony default export */ var Tabs_Tabs = ((0,withStyles/* default */.A)(Tabs_styles, {
  name: "MuiTabs"
})(Tabs));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextField/TextField.js
var TextField = __webpack_require__(62894);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/TextareaAutosize/TextareaAutosize.js
var TextareaAutosize = __webpack_require__(64916);
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35701);
;// ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js




















function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
function arrowGenerator() {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: "-0.71em",
      marginLeft: 4,
      marginRight: 4,
      "&::before": {
        transformOrigin: "0 100%"
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: "-0.71em",
      marginLeft: 4,
      marginRight: 4,
      "&::before": {
        transformOrigin: "100% 0"
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: "-0.71em",
      height: "1em",
      width: "0.71em",
      marginTop: 4,
      marginBottom: 4,
      "&::before": {
        transformOrigin: "100% 100%"
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: "-0.71em",
      height: "1em",
      width: "0.71em",
      marginTop: 4,
      marginBottom: 4,
      "&::before": {
        transformOrigin: "0 0"
      }
    }
  };
}
var Tooltip_styles = function styles2(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      pointerEvents: "none"
      // disable jss-rtl plugin
    },
    /* Styles applied to the Popper component if `interactive={true}`. */
    popperInteractive: {
      pointerEvents: "auto"
    },
    /* Styles applied to the Popper component if `arrow={true}`. */
    popperArrow: arrowGenerator(),
    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: (0,colorManipulator/* alpha */.X4)(theme.palette.grey[700], 0.9),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: "4px 8px",
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(round(14 / 10), "em"),
      maxWidth: 300,
      wordWrap: "break-word",
      fontWeight: theme.typography.fontWeightMedium
    },
    /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
    tooltipArrow: {
      position: "relative",
      margin: "0"
    },
    /* Styles applied to the arrow element. */
    arrow: {
      overflow: "hidden",
      position: "absolute",
      width: "1em",
      height: "0.71em",
      boxSizing: "border-box",
      color: (0,colorManipulator/* alpha */.X4)(theme.palette.grey[700], 0.9),
      "&::before": {
        content: '""',
        margin: "auto",
        display: "block",
        width: "100%",
        height: "100%",
        backgroundColor: "currentColor",
        transform: "rotate(45deg)"
      }
    },
    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: "8px 16px",
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(round(16 / 14), "em"),
      fontWeight: theme.typography.fontWeightRegular
    },
    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: (0,defineProperty/* default */.A)({
      transformOrigin: "right center",
      margin: "0 24px "
    }, theme.breakpoints.up("sm"), {
      margin: "0 14px"
    }),
    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: (0,defineProperty/* default */.A)({
      transformOrigin: "left center",
      margin: "0 24px"
    }, theme.breakpoints.up("sm"), {
      margin: "0 14px"
    }),
    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: (0,defineProperty/* default */.A)({
      transformOrigin: "center bottom",
      margin: "24px 0"
    }, theme.breakpoints.up("sm"), {
      margin: "14px 0"
    }),
    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: (0,defineProperty/* default */.A)({
      transformOrigin: "center top",
      margin: "24px 0"
    }, theme.breakpoints.up("sm"), {
      margin: "14px 0"
    })
  };
};
var hystersisOpen = false;
var hystersisTimer = null;
function testReset() {
  hystersisOpen = false;
  clearTimeout(hystersisTimer);
}
var Tooltip = /* @__PURE__ */ index_js_eager_.forwardRef(function Tooltip2(props, ref) {
  var _props$arrow = props.arrow, arrow = _props$arrow === void 0 ? false : _props$arrow, children = props.children, classes = props.classes, _props$disableFocusLi = props.disableFocusListener, disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi, _props$disableHoverLi = props.disableHoverListener, disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi, _props$disableTouchLi = props.disableTouchListener, disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi, _props$enterDelay = props.enterDelay, enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay, _props$enterNextDelay = props.enterNextDelay, enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay, _props$enterTouchDela = props.enterTouchDelay, enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela, idProp = props.id, _props$interactive = props.interactive, interactive = _props$interactive === void 0 ? false : _props$interactive, _props$leaveDelay = props.leaveDelay, leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay, _props$leaveTouchDela = props.leaveTouchDelay, leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela, onClose = props.onClose, onOpen = props.onOpen, openProp = props.open, _props$placement = props.placement, placement = _props$placement === void 0 ? "bottom" : _props$placement, _props$PopperComponen = props.PopperComponent, PopperComponent = _props$PopperComponen === void 0 ? esm_Popper_Popper : _props$PopperComponen, PopperProps = props.PopperProps, title = props.title, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? Grow/* default */.A : _props$TransitionComp, TransitionProps = props.TransitionProps, other = (0,objectWithoutProperties/* default */.A)(props, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);
  var theme = (0,useTheme/* default */.A)();
  var _React$useState = index_js_eager_.useState(), childNode = _React$useState[0], setChildNode = _React$useState[1];
  var _React$useState2 = index_js_eager_.useState(null), arrowRef = _React$useState2[0], setArrowRef = _React$useState2[1];
  var ignoreNonTouchEvents = index_js_eager_.useRef(false);
  var closeTimer = index_js_eager_.useRef();
  var enterTimer = index_js_eager_.useRef();
  var leaveTimer = index_js_eager_.useRef();
  var touchTimer = index_js_eager_.useRef();
  var _useControlled = (0,useControlled/* default */.A)({
    controlled: openProp,
    default: false,
    name: "Tooltip",
    state: "open"
  }), _useControlled2 = (0,slicedToArray/* default */.A)(_useControlled, 2), openState = _useControlled2[0], setOpenState = _useControlled2[1];
  var open = openState;
  if (false) // removed by dead control flow
{ var _React$useRef, isControlled; }
  var id = (0,unstable_useId/* default */.A)(idProp);
  index_js_eager_.useEffect(function() {
    return function() {
      clearTimeout(closeTimer.current);
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      clearTimeout(touchTimer.current);
    };
  }, []);
  var handleOpen = function handleOpen2(event) {
    clearTimeout(hystersisTimer);
    hystersisOpen = true;
    setOpenState(true);
    if (onOpen) {
      onOpen(event);
    }
  };
  var handleEnter = function handleEnter2() {
    var forward = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    return function(event) {
      var childrenProps2 = children.props;
      if (event.type === "mouseover" && childrenProps2.onMouseOver && forward) {
        childrenProps2.onMouseOver(event);
      }
      if (ignoreNonTouchEvents.current && event.type !== "touchstart") {
        return;
      }
      if (childNode) {
        childNode.removeAttribute("title");
      }
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      if (enterDelay || hystersisOpen && enterNextDelay) {
        event.persist();
        enterTimer.current = setTimeout(function() {
          handleOpen(event);
        }, hystersisOpen ? enterNextDelay : enterDelay);
      } else {
        handleOpen(event);
      }
    };
  };
  var _useIsFocusVisible = (0,useIsFocusVisible/* default */.A)(), isFocusVisible = _useIsFocusVisible.isFocusVisible, onBlurVisible = _useIsFocusVisible.onBlurVisible, focusVisibleRef = _useIsFocusVisible.ref;
  var _React$useState3 = index_js_eager_.useState(false), childIsFocusVisible = _React$useState3[0], setChildIsFocusVisible = _React$useState3[1];
  var handleBlur = function handleBlur2() {
    if (childIsFocusVisible) {
      setChildIsFocusVisible(false);
      onBlurVisible();
    }
  };
  var handleFocus = function handleFocus2() {
    var forward = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    return function(event) {
      if (!childNode) {
        setChildNode(event.currentTarget);
      }
      if (isFocusVisible(event)) {
        setChildIsFocusVisible(true);
        handleEnter()(event);
      }
      var childrenProps2 = children.props;
      if (childrenProps2.onFocus && forward) {
        childrenProps2.onFocus(event);
      }
    };
  };
  var handleClose = function handleClose2(event) {
    clearTimeout(hystersisTimer);
    hystersisTimer = setTimeout(function() {
      hystersisOpen = false;
    }, 800 + leaveDelay);
    setOpenState(false);
    if (onClose) {
      onClose(event);
    }
    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(function() {
      ignoreNonTouchEvents.current = false;
    }, theme.transitions.duration.shortest);
  };
  var handleLeave = function handleLeave2() {
    var forward = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    return function(event) {
      var childrenProps2 = children.props;
      if (event.type === "blur") {
        if (childrenProps2.onBlur && forward) {
          childrenProps2.onBlur(event);
        }
        handleBlur();
      }
      if (event.type === "mouseleave" && childrenProps2.onMouseLeave && event.currentTarget === childNode) {
        childrenProps2.onMouseLeave(event);
      }
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      event.persist();
      leaveTimer.current = setTimeout(function() {
        handleClose(event);
      }, leaveDelay);
    };
  };
  var detectTouchStart = function detectTouchStart2(event) {
    ignoreNonTouchEvents.current = true;
    var childrenProps2 = children.props;
    if (childrenProps2.onTouchStart) {
      childrenProps2.onTouchStart(event);
    }
  };
  var handleTouchStart = function handleTouchStart2(event) {
    detectTouchStart(event);
    clearTimeout(leaveTimer.current);
    clearTimeout(closeTimer.current);
    clearTimeout(touchTimer.current);
    event.persist();
    touchTimer.current = setTimeout(function() {
      handleEnter()(event);
    }, enterTouchDelay);
  };
  var handleTouchEnd = function handleTouchEnd2(event) {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }
    clearTimeout(touchTimer.current);
    clearTimeout(leaveTimer.current);
    event.persist();
    leaveTimer.current = setTimeout(function() {
      handleClose(event);
    }, leaveTouchDelay);
  };
  var handleUseRef = (0,useForkRef/* default */.A)(setChildNode, ref);
  var handleFocusRef = (0,useForkRef/* default */.A)(focusVisibleRef, handleUseRef);
  var handleOwnRef = index_js_eager_.useCallback(function(instance) {
    (0,setRef/* default */.A)(handleFocusRef, react_dom_index_js_eager_.findDOMNode(instance));
  }, [handleFocusRef]);
  var handleRef = (0,useForkRef/* default */.A)(children.ref, handleOwnRef);
  if (title === "") {
    open = false;
  }
  var shouldShowNativeTitle = !open && !disableHoverListener;
  var childrenProps = (0,esm_extends/* default */.A)({
    "aria-describedby": open ? id : null,
    title: shouldShowNativeTitle && typeof title === "string" ? title : null
  }, other, children.props, {
    className: (0,clsx_m["default"])(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  });
  var interactiveWrapperListeners = {};
  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }
  if (!disableHoverListener) {
    childrenProps.onMouseOver = handleEnter();
    childrenProps.onMouseLeave = handleLeave();
    if (interactive) {
      interactiveWrapperListeners.onMouseOver = handleEnter(false);
      interactiveWrapperListeners.onMouseLeave = handleLeave(false);
    }
  }
  if (!disableFocusListener) {
    childrenProps.onFocus = handleFocus();
    childrenProps.onBlur = handleLeave();
    if (interactive) {
      interactiveWrapperListeners.onFocus = handleFocus(false);
      interactiveWrapperListeners.onBlur = handleLeave(false);
    }
  }
  if (false) // removed by dead control flow
{}
  var mergedPopperProps = index_js_eager_.useMemo(function() {
    return (0,deepmerge/* default */.A)({
      popperOptions: {
        modifiers: {
          arrow: {
            enabled: Boolean(arrowRef),
            element: arrowRef
          }
        }
      }
    }, PopperProps);
  }, [arrowRef, PopperProps]);
  return /* @__PURE__ */ index_js_eager_.createElement(index_js_eager_.Fragment, null, /* @__PURE__ */ index_js_eager_.cloneElement(children, childrenProps), /* @__PURE__ */ index_js_eager_.createElement(PopperComponent, (0,esm_extends/* default */.A)({
    className: (0,clsx_m["default"])(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
    placement,
    anchorEl: childNode,
    open: childNode ? open : false,
    id: childrenProps["aria-describedby"],
    transition: true
  }, interactiveWrapperListeners, mergedPopperProps), function(_ref) {
    var placementInner = _ref.placement, TransitionPropsInner = _ref.TransitionProps;
    return /* @__PURE__ */ index_js_eager_.createElement(TransitionComponent, (0,esm_extends/* default */.A)({
      timeout: theme.transitions.duration.shorter
    }, TransitionPropsInner, TransitionProps), /* @__PURE__ */ index_js_eager_.createElement("div", {
      className: (0,clsx_m["default"])(classes.tooltip, classes["tooltipPlacement".concat((0,capitalize/* default */.A)(placementInner.split("-")[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
    }, title, arrow ? /* @__PURE__ */ index_js_eager_.createElement("span", {
      className: classes.arrow,
      ref: setArrowRef
    }) : null));
  }));
});
 false ? 0 : void 0;
/* harmony default export */ var Tooltip_Tooltip = ((0,withStyles/* default */.A)(Tooltip_styles, {
  name: "MuiTooltip",
  flip: false
})(Tooltip));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Unstable_TrapFocus/Unstable_TrapFocus.js
var Unstable_TrapFocus = __webpack_require__(1568);
;// ./node_modules/@material-ui/core/esm/useScrollTrigger/useScrollTrigger.js



function defaultTrigger(store, options) {
  var _options$disableHyste = options.disableHysteresis, disableHysteresis = _options$disableHyste === void 0 ? false : _options$disableHyste, _options$threshold = options.threshold, threshold = _options$threshold === void 0 ? 100 : _options$threshold, target = options.target;
  var previous = store.current;
  if (target) {
    store.current = target.pageYOffset !== void 0 ? target.pageYOffset : target.scrollTop;
  }
  if (!disableHysteresis && previous !== void 0) {
    if (store.current < previous) {
      return false;
    }
  }
  return store.current > threshold;
}
var defaultTarget = typeof window !== "undefined" ? window : null;
function useScrollTrigger() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _options$getTrigger = options.getTrigger, getTrigger = _options$getTrigger === void 0 ? defaultTrigger : _options$getTrigger, _options$target = options.target, target = _options$target === void 0 ? defaultTarget : _options$target, other = (0,objectWithoutProperties/* default */.A)(options, ["getTrigger", "target"]);
  var store = index_js_eager_.useRef();
  var _React$useState = index_js_eager_.useState(function() {
    return getTrigger(store, other);
  }), trigger = _React$useState[0], setTrigger = _React$useState[1];
  index_js_eager_.useEffect(function() {
    var handleScroll = function handleScroll2() {
      setTrigger(getTrigger(store, (0,esm_extends/* default */.A)({
        target
      }, other)));
    };
    handleScroll();
    target.addEventListener("scroll", handleScroll);
    return function() {
      target.removeEventListener("scroll", handleScroll);
    };
  }, [target, getTrigger, JSON.stringify(other)]);
  return trigger;
}

;// ./node_modules/@material-ui/core/esm/withMobileDialog/withMobileDialog.js




var withMobileDialog_warnedOnce = false;
var withMobileDialog = function withMobileDialog2() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return function(Component) {
    if (false) // removed by dead control flow
{}
    var _options$breakpoint = options.breakpoint, breakpoint = _options$breakpoint === void 0 ? "sm" : _options$breakpoint;
    function WithMobileDialog(props) {
      return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
        fullScreen: isWidthDown(breakpoint, props.width)
      }, props));
    }
     false ? 0 : void 0;
    return withWidth_withWidth()(WithMobileDialog);
  };
};
/* harmony default export */ var withMobileDialog_withMobileDialog = (withMobileDialog);

;// ./node_modules/@material-ui/core/esm/withWidth/index.js



;// ./node_modules/@material-ui/core/esm/Zoom/Zoom.js










var Zoom_styles = {
  entering: {
    transform: "none"
  },
  entered: {
    transform: "none"
  }
};
var Zoom_defaultTimeout = {
  enter: transitions/* duration */.p0.enteringScreen,
  exit: transitions/* duration */.p0.leavingScreen
};
var Zoom = /* @__PURE__ */ index_js_eager_.forwardRef(function Zoom2(props, ref) {
  var children = props.children, _props$disableStrictM = props.disableStrictModeCompat, disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _props$timeout = props.timeout, timeout = _props$timeout === void 0 ? Zoom_defaultTimeout : _props$timeout, _props$TransitionComp = props.TransitionComponent, TransitionComponent = _props$TransitionComp === void 0 ? Transition/* default */.Ay : _props$TransitionComp, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);
  var theme = (0,useTheme/* default */.A)();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = index_js_eager_.useRef(null);
  var foreignRef = (0,useForkRef/* default */.A)(children.ref, ref);
  var handleRef = (0,useForkRef/* default */.A)(enableStrictModeCompat ? nodeRef : void 0, foreignRef);
  var normalizedTransitionCallback = function normalizedTransitionCallback2(callback) {
    return function(nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing], _ref2 = (0,slicedToArray/* default */.A)(_ref, 2), node = _ref2[0], isAppearing = _ref2[1];
        if (isAppearing === void 0) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };
  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function(node, isAppearing) {
    (0,transitions_utils/* reflow */.q)(node);
    var transitionProps = (0,transitions_utils/* getTransitionProps */.c)({
      style,
      timeout
    }, {
      mode: "enter"
    });
    node.style.webkitTransition = theme.transitions.create("transform", transitionProps);
    node.style.transition = theme.transitions.create("transform", transitionProps);
    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function(node) {
    var transitionProps = (0,transitions_utils/* getTransitionProps */.c)({
      style,
      timeout
    }, {
      mode: "exit"
    });
    node.style.webkitTransition = theme.transitions.create("transform", transitionProps);
    node.style.transition = theme.transitions.create("transform", transitionProps);
    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /* @__PURE__ */ index_js_eager_.createElement(TransitionComponent, (0,esm_extends/* default */.A)({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : void 0,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout
  }, other), function(state, childProps) {
    return /* @__PURE__ */ index_js_eager_.cloneElement(children, (0,esm_extends/* default */.A)({
      style: (0,esm_extends/* default */.A)({
        transform: "scale(0)",
        visibility: state === "exited" && !inProp ? "hidden" : void 0
      }, Zoom_styles[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? 0 : void 0;
/* harmony default export */ var Zoom_Zoom = (Zoom);

;// ./node_modules/@material-ui/core/esm/index.js
/** @license Material-UI v4.12.4
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */






























































































































































































































































/***/ }),

/***/ 91893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);
/* harmony import */ var _utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80868);


/* harmony default export */ __webpack_exports__.A = ((0,_utils_createSvgIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(/* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"));


/***/ }),

/***/ 19603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   E2: function() { return /* binding */ hexToRgb; },
/* harmony export */   J1: function() { return /* binding */ getLuminance; },
/* harmony export */   Ob: function() { return /* binding */ rgbToHex; },
/* harmony export */   Rv: function() { return /* binding */ fade; },
/* harmony export */   X0: function() { return /* binding */ recomposeColor; },
/* harmony export */   X4: function() { return /* binding */ alpha; },
/* harmony export */   YL: function() { return /* binding */ hslToRgb; },
/* harmony export */   a: function() { return /* binding */ lighten; },
/* harmony export */   e$: function() { return /* binding */ darken; },
/* harmony export */   eM: function() { return /* binding */ getContrastRatio; },
/* harmony export */   rP: function() { return /* binding */ decomposeColor; },
/* harmony export */   tL: function() { return /* binding */ emphasize; }
/* harmony export */ });
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44998);

function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
  if (false) // removed by dead control flow
{}
  return Math.min(Math.max(min, value), max);
}
function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), "g");
  var colors = color.match(re);
  if (colors && colors[0].length === 1) {
    colors = colors.map(function(n) {
      return n + n;
    });
  }
  return colors ? "rgb".concat(colors.length === 4 ? "a" : "", "(").concat(colors.map(function(n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3;
  }).join(", "), ")") : "";
}
function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}
function rgbToHex(color) {
  if (color.indexOf("#") === 0) {
    return color;
  }
  var _decomposeColor = decomposeColor(color), values = _decomposeColor.values;
  return "#".concat(values.map(function(n) {
    return intToHex(n);
  }).join(""));
}
function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color, values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);
  var f = function f2(n) {
    var k = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };
  var type = "rgb";
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
  if (color.type === "hsla") {
    type += "a";
    rgb.push(values[3]);
  }
  return recomposeColor({
    type,
    values: rgb
  });
}
function decomposeColor(color) {
  if (color.type) {
    return color;
  }
  if (color.charAt(0) === "#") {
    return decomposeColor(hexToRgb(color));
  }
  var marker = color.indexOf("(");
  var type = color.substring(0, marker);
  if (["rgb", "rgba", "hsl", "hsla"].indexOf(type) === -1) {
    throw new Error( false ? 0 : (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(3, color));
  }
  var values = color.substring(marker + 1, color.length - 1).split(",");
  values = values.map(function(value) {
    return parseFloat(value);
  });
  return {
    type,
    values
  };
}
function recomposeColor(color) {
  var type = color.type;
  var values = color.values;
  if (type.indexOf("rgb") !== -1) {
    values = values.map(function(n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf("hsl") !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }
  return "".concat(type, "(").concat(values.join(", "), ")");
}
function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === "hsl" ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function(val) {
    val /= 255;
    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  });
  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
var warnedOnce = false;
function fade(color, value) {
  if (false) // removed by dead control flow
{}
  return alpha(color, value);
}
function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp(value);
  if (color.type === "rgb" || color.type === "hsl") {
    color.type += "a";
  }
  color.values[3] = value;
  return recomposeColor(color);
}
function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);
  if (color.type.indexOf("hsl") !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf("rgb") !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }
  return recomposeColor(color);
}
function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);
  if (color.type.indexOf("hsl") !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf("rgb") !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }
  return recomposeColor(color);
}


/***/ }),

/***/ 15744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ createBreakpoints; },
/* harmony export */   H: function() { return /* binding */ keys; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);


var keys = ["xs", "sm", "md", "lg", "xl"];
function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values, values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values, _breakpoints$unit = breakpoints.unit, unit = _breakpoints$unit === void 0 ? "px" : _breakpoints$unit, _breakpoints$step = breakpoints.step, step = _breakpoints$step === void 0 ? 5 : _breakpoints$step, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(breakpoints, ["values", "unit", "step"]);
  function up(key) {
    var value = typeof values[key] === "number" ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }
  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];
    if (endIndex === keys.length) {
      return up("xs");
    }
    var value = typeof upperbound === "number" && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }
  function between(start, end) {
    var endIndex = keys.indexOf(end);
    if (endIndex === keys.length - 1) {
      return up(start);
    }
    return "@media (min-width:".concat(typeof values[start] === "number" ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === "number" ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }
  function only(key) {
    return between(key, key);
  }
  var warnedOnce = false;
  function width(key) {
    if (false) // removed by dead control flow
{}
    return values[key];
  }
  return (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    keys,
    values,
    up,
    down,
    between,
    only,
    width
  }, other);
}


/***/ }),

/***/ 89081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ createStyles_createStyles; }
});

;// ./node_modules/@material-ui/styles/esm/createStyles/createStyles.js
function createStyles(styles) {
  return styles;
}

;// ./node_modules/@material-ui/core/esm/styles/createStyles.js

function createStyles_createStyles(styles) {
  return createStyles(styles);
}


/***/ }),

/***/ 23602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  D: function() { return /* binding */ createMuiTheme; },
  A: function() { return /* binding */ styles_createTheme; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(89782);
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35701);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createBreakpoints.js
var createBreakpoints = __webpack_require__(15744);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(75054);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
;// ./node_modules/@material-ui/core/esm/styles/createMixins.js


function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;
  return (0,esm_extends/* default */.A)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      console.warn(["Material-UI: theme.mixins.gutters() is deprecated.", "You can use the source of the mixin directly:", "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join("\n"));
      return (0,esm_extends/* default */.A)({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, (0,defineProperty/* default */.A)({}, breakpoints.up("sm"), (0,esm_extends/* default */.A)({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up("sm")])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0,defineProperty/* default */.A)(_toolbar, "".concat(breakpoints.up("xs"), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0,defineProperty/* default */.A)(_toolbar, breakpoints.up("sm"), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(44998);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/common.js
var common = __webpack_require__(53977);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/grey.js
var grey = __webpack_require__(36343);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/indigo.js
var indigo = __webpack_require__(60698);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/pink.js
var pink = __webpack_require__(52988);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/red.js
var red = __webpack_require__(99129);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/orange.js
var orange = __webpack_require__(71494);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/blue.js
var blue = __webpack_require__(95464);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/colors/green.js
var green = __webpack_require__(61609);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(19603);
;// ./node_modules/@material-ui/core/esm/styles/createPalette.js













var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.54)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)",
    // Text hints.
    hint: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common/* default */.A.white,
    default: grey/* default */.A[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common/* default */.A.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    hint: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: grey/* default */.A[800],
    default: "#303030"
  },
  action: {
    active: common/* default */.A.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === "light") {
      intent.light = (0,colorManipulator/* lighten */.a)(intent.main, tonalOffsetLight);
    } else if (direction === "dark") {
      intent.dark = (0,colorManipulator/* darken */.e$)(intent.main, tonalOffsetDark);
    }
  }
}
function createPalette(palette) {
  var _palette$primary = palette.primary, primary = _palette$primary === void 0 ? {
    light: indigo/* default */.A[300],
    main: indigo/* default */.A[500],
    dark: indigo/* default */.A[700]
  } : _palette$primary, _palette$secondary = palette.secondary, secondary = _palette$secondary === void 0 ? {
    light: pink/* default */.A.A200,
    main: pink/* default */.A.A400,
    dark: pink/* default */.A.A700
  } : _palette$secondary, _palette$error = palette.error, error = _palette$error === void 0 ? {
    light: red/* default */.A[300],
    main: red/* default */.A[500],
    dark: red/* default */.A[700]
  } : _palette$error, _palette$warning = palette.warning, warning = _palette$warning === void 0 ? {
    light: orange/* default */.A[300],
    main: orange/* default */.A[500],
    dark: orange/* default */.A[700]
  } : _palette$warning, _palette$info = palette.info, info = _palette$info === void 0 ? {
    light: blue/* default */.A[300],
    main: blue/* default */.A[500],
    dark: blue/* default */.A[700]
  } : _palette$info, _palette$success = palette.success, success = _palette$success === void 0 ? {
    light: green/* default */.A[300],
    main: green/* default */.A[500],
    dark: green/* default */.A[700]
  } : _palette$success, _palette$type = palette.type, type = _palette$type === void 0 ? "light" : _palette$type, _palette$contrastThre = palette.contrastThreshold, contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre, _palette$tonalOffset = palette.tonalOffset, tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset, other = (0,objectWithoutProperties/* default */.A)(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]);
  function getContrastText(background) {
    var contrastText = (0,colorManipulator/* getContrastRatio */.eM)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
    if (false) // removed by dead control flow
{ var contrast; }
    return contrastText;
  }
  var augmentColor = function augmentColor2(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 700;
    color = (0,esm_extends/* default */.A)({}, color);
    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }
    if (!color.main) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.A)(4, mainShade));
    }
    if (typeof color.main !== "string") {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.A)(5, JSON.stringify(color.main)));
    }
    addLightOrDark(color, "light", lightShade, tonalOffset);
    addLightOrDark(color, "dark", darkShade, tonalOffset);
    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }
    return color;
  };
  var types = {
    dark,
    light
  };
  if (false) // removed by dead control flow
{}
  var paletteOutput = (0,deepmerge/* default */.A)((0,esm_extends/* default */.A)({
    // A collection of common colors.
    common: common/* default */.A,
    // The palette type, can be light or dark.
    type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, "A400", "A200", "A700"),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey/* default */.A,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

;// ./node_modules/@material-ui/core/esm/styles/createTypography.js



function round(value) {
  return Math.round(value * 1e5) / 1e5;
}
var warnedOnce = false;
function roundWithDeprecationWarning(value) {
  if (false) // removed by dead control flow
{}
  return round(value);
}
var caseAllCaps = {
  textTransform: "uppercase"
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function createTypography(palette, typography) {
  var _ref = typeof typography === "function" ? typography(palette) : typography, _ref$fontFamily = _ref.fontFamily, fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily, _ref$fontSize = _ref.fontSize, fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize, _ref$fontWeightLight = _ref.fontWeightLight, fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight, _ref$fontWeightRegula = _ref.fontWeightRegular, fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula, _ref$fontWeightMedium = _ref.fontWeightMedium, fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium, _ref$fontWeightBold = _ref.fontWeightBold, fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold, _ref$htmlFontSize = _ref.htmlFontSize, htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize, allVariants = _ref.allVariants, pxToRem2 = _ref.pxToRem, other = (0,objectWithoutProperties/* default */.A)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
  if (false) // removed by dead control flow
{}
  var coef = fontSize / 14;
  var pxToRem = pxToRem2 || function(size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };
  var buildVariant = function buildVariant2(fontWeight, size, lineHeight, letterSpacing, casing) {
    return (0,esm_extends/* default */.A)({
      fontFamily,
      fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };
  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return (0,deepmerge/* default */.A)((0,esm_extends/* default */.A)({
    htmlFontSize,
    pxToRem,
    round: roundWithDeprecationWarning,
    // TODO v5: remove
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false
    // No need to clone deep
  });
}

;// ./node_modules/@material-ui/core/esm/styles/shadows.js
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;
function createShadow() {
  return ["".concat(arguments.length <= 0 ? void 0 : arguments[0], "px ").concat(arguments.length <= 1 ? void 0 : arguments[1], "px ").concat(arguments.length <= 2 ? void 0 : arguments[2], "px ").concat(arguments.length <= 3 ? void 0 : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? void 0 : arguments[4], "px ").concat(arguments.length <= 5 ? void 0 : arguments[5], "px ").concat(arguments.length <= 6 ? void 0 : arguments[6], "px ").concat(arguments.length <= 7 ? void 0 : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? void 0 : arguments[8], "px ").concat(arguments.length <= 9 ? void 0 : arguments[9], "px ").concat(arguments.length <= 10 ? void 0 : arguments[10], "px ").concat(arguments.length <= 11 ? void 0 : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(",");
}
var shadows = ["none", createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ var styles_shadows = (shadows);

;// ./node_modules/@material-ui/core/esm/styles/shape.js
var shape = {
  borderRadius: 4
};
/* harmony default export */ var styles_shape = (shape);

// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/spacing.js + 1 modules
var esm_spacing = __webpack_require__(59259);
;// ./node_modules/@material-ui/core/esm/styles/createSpacing.js

var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 8;
  if (spacingInput.mui) {
    return spacingInput;
  }
  var transform = (0,esm_spacing/* createUnarySpacing */.L)({
    spacing: spacingInput
  });
  var spacing = function spacing2() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (false) // removed by dead control flow
{}
    if (args.length === 0) {
      return transform(1);
    }
    if (args.length === 1) {
      return transform(args[0]);
    }
    return args.map(function(argument) {
      if (typeof argument === "string") {
        return argument;
      }
      var output = transform(argument);
      return typeof output === "number" ? "".concat(output, "px") : output;
    }).join(" ");
  };
  Object.defineProperty(spacing, "unit", {
    get: function get() {
      if (false) // removed by dead control flow
{}
      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/transitions.js
var transitions = __webpack_require__(58268);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/zIndex.js
var zIndex = __webpack_require__(31372);
;// ./node_modules/@material-ui/core/esm/styles/createTheme.js












function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints, breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints, _options$mixins = options.mixins, mixinsInput = _options$mixins === void 0 ? {} : _options$mixins, _options$palette = options.palette, paletteInput = _options$palette === void 0 ? {} : _options$palette, spacingInput = options.spacing, _options$typography = options.typography, typographyInput = _options$typography === void 0 ? {} : _options$typography, other = (0,objectWithoutProperties/* default */.A)(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);
  var palette = createPalette(paletteInput);
  var breakpoints = (0,createBreakpoints/* default */.A)(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = (0,deepmerge/* default */.A)({
    breakpoints,
    direction: "ltr",
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette,
    props: {},
    // Provide default props
    shadows: styles_shadows,
    typography: createTypography(palette, typographyInput),
    spacing,
    shape: styles_shape,
    transitions: transitions/* default */.Ay,
    zIndex: zIndex/* default */.A
  }, other);
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  muiTheme = args.reduce(function(acc, argument) {
    return (0,deepmerge/* default */.A)(acc, argument);
  }, muiTheme);
  if (false) // removed by dead control flow
{ var traverse, pseudoClasses; }
  return muiTheme;
}
var createTheme_warnedOnce = false;
function createMuiTheme() {
  if (false) // removed by dead control flow
{}
  return createTheme.apply(void 0, arguments);
}
/* harmony default export */ var styles_createTheme = (createTheme);


/***/ }),

/***/ 62584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _createTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23602);

var defaultTheme = (0,_createTheme__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)();
/* harmony default export */ __webpack_exports__.A = (defaultTheme);


/***/ }),

/***/ 52234:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  MuiThemeProvider: function() { return /* reexport */ ThemeProvider_ThemeProvider; },
  ServerStyleSheets: function() { return /* reexport */ ServerStyleSheets; },
  StylesProvider: function() { return /* reexport */ StylesProvider/* default */.Ay; },
  ThemeProvider: function() { return /* reexport */ ThemeProvider_ThemeProvider; },
  alpha: function() { return /* reexport */ colorManipulator/* alpha */.X4; },
  createGenerateClassName: function() { return /* reexport */ createGenerateClassName/* default */.A; },
  createMuiTheme: function() { return /* reexport */ createTheme/* createMuiTheme */.D; },
  createStyles: function() { return /* reexport */ createStyles/* default */.A; },
  createTheme: function() { return /* reexport */ createTheme/* default */.A; },
  darken: function() { return /* reexport */ colorManipulator/* darken */.e$; },
  decomposeColor: function() { return /* reexport */ colorManipulator/* decomposeColor */.rP; },
  duration: function() { return /* reexport */ transitions/* duration */.p0; },
  easing: function() { return /* reexport */ transitions/* easing */.cz; },
  emphasize: function() { return /* reexport */ colorManipulator/* emphasize */.tL; },
  fade: function() { return /* reexport */ colorManipulator/* fade */.Rv; },
  getContrastRatio: function() { return /* reexport */ colorManipulator/* getContrastRatio */.eM; },
  getLuminance: function() { return /* reexport */ colorManipulator/* getLuminance */.J1; },
  hexToRgb: function() { return /* reexport */ colorManipulator/* hexToRgb */.E2; },
  hslToRgb: function() { return /* reexport */ colorManipulator/* hslToRgb */.YL; },
  jssPreset: function() { return /* reexport */ jssPreset/* default */.A; },
  lighten: function() { return /* reexport */ colorManipulator/* lighten */.a; },
  makeStyles: function() { return /* reexport */ makeStyles/* default */.A; },
  recomposeColor: function() { return /* reexport */ colorManipulator/* recomposeColor */.X0; },
  responsiveFontSizes: function() { return /* reexport */ responsiveFontSizes; },
  rgbToHex: function() { return /* reexport */ colorManipulator/* rgbToHex */.Ob; },
  styled: function() { return /* reexport */ styled/* default */.A; },
  unstable_createMuiStrictModeTheme: function() { return /* reexport */ createMuiStrictModeTheme; },
  useTheme: function() { return /* reexport */ useTheme/* default */.A; },
  withStyles: function() { return /* reexport */ withStyles/* default */.A; },
  withTheme: function() { return /* reexport */ styles_withTheme; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/colorManipulator.js
var colorManipulator = __webpack_require__(19603);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createTheme.js + 6 modules
var createTheme = __webpack_require__(23602);
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35701);
;// ./node_modules/@material-ui/core/esm/styles/createMuiStrictModeTheme.js


function createMuiStrictModeTheme(options) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  return createTheme/* default */.A.apply(void 0, [(0,deepmerge/* default */.A)({
    unstable_strictMode: true
  }, options)].concat(args));
}

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(89081);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(42806);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/formatMuiErrorMessage.js
var formatMuiErrorMessage = __webpack_require__(44998);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(75054);
;// ./node_modules/@material-ui/core/esm/styles/cssUtils.js

function isUnitless(value) {
  return String(parseFloat(value)).length === String(value).length;
}
function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function toUnitless(length) {
  return parseFloat(length);
}
function convertLength(baseFontSize) {
  return function(length, toUnit) {
    var fromUnit = getUnit(length);
    if (fromUnit === toUnit) {
      return length;
    }
    var pxLength = toUnitless(length);
    if (fromUnit !== "px") {
      if (fromUnit === "em") {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
      } else if (fromUnit === "rem") {
        pxLength = toUnitless(length) * toUnitless(baseFontSize);
        return length;
      }
    }
    var outputLength = pxLength;
    if (toUnit !== "px") {
      if (toUnit === "em") {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else if (toUnit === "rem") {
        outputLength = pxLength / toUnitless(baseFontSize);
      } else {
        return length;
      }
    }
    return parseFloat(outputLength.toFixed(5)) + toUnit;
  };
}
function alignProperty(_ref) {
  var size = _ref.size, grid = _ref.grid;
  var sizeBelow = size - size % grid;
  var sizeAbove = sizeBelow + grid;
  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function fontGrid(_ref2) {
  var lineHeight = _ref2.lineHeight, pixels = _ref2.pixels, htmlFontSize = _ref2.htmlFontSize;
  return pixels / (lineHeight * htmlFontSize);
}
function responsiveProperty(_ref3) {
  var cssProperty = _ref3.cssProperty, min = _ref3.min, max = _ref3.max, _ref3$unit = _ref3.unit, unit = _ref3$unit === void 0 ? "rem" : _ref3$unit, _ref3$breakpoints = _ref3.breakpoints, breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints, _ref3$transform = _ref3.transform, transform = _ref3$transform === void 0 ? null : _ref3$transform;
  var output = (0,defineProperty/* default */.A)({}, cssProperty, "".concat(min).concat(unit));
  var factor = (max - min) / breakpoints[breakpoints.length - 1];
  breakpoints.forEach(function(breakpoint) {
    var value = min + factor * breakpoint;
    if (transform !== null) {
      value = transform(value);
    }
    output["@media (min-width:".concat(breakpoint, "px)")] = (0,defineProperty/* default */.A)({}, cssProperty, "".concat(Math.round(value * 1e4) / 1e4).concat(unit));
  });
  return output;
}

;// ./node_modules/@material-ui/core/esm/styles/responsiveFontSizes.js



function responsiveFontSizes(themeInput) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _options$breakpoints = options.breakpoints, breakpoints = _options$breakpoints === void 0 ? ["sm", "md", "lg"] : _options$breakpoints, _options$disableAlign = options.disableAlign, disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign, _options$factor = options.factor, factor = _options$factor === void 0 ? 2 : _options$factor, _options$variants = options.variants, variants = _options$variants === void 0 ? ["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button", "overline"] : _options$variants;
  var theme = (0,esm_extends/* default */.A)({}, themeInput);
  theme.typography = (0,esm_extends/* default */.A)({}, theme.typography);
  var typography = theme.typography;
  var convert = convertLength(typography.htmlFontSize);
  var breakpointValues = breakpoints.map(function(x) {
    return theme.breakpoints.values[x];
  });
  variants.forEach(function(variant) {
    var style = typography[variant];
    var remFontSize = parseFloat(convert(style.fontSize, "rem"));
    if (remFontSize <= 1) {
      return;
    }
    var maxFontSize = remFontSize;
    var minFontSize = 1 + (maxFontSize - 1) / factor;
    var lineHeight = style.lineHeight;
    if (!isUnitless(lineHeight) && !disableAlign) {
      throw new Error( false ? 0 : (0,formatMuiErrorMessage/* default */.A)(6));
    }
    if (!isUnitless(lineHeight)) {
      lineHeight = parseFloat(convert(lineHeight, "rem")) / parseFloat(remFontSize);
    }
    var transform = null;
    if (!disableAlign) {
      transform = function transform2(value) {
        return alignProperty({
          size: value,
          grid: fontGrid({
            pixels: 4,
            lineHeight,
            htmlFontSize: typography.htmlFontSize
          })
        });
      };
    }
    typography[variant] = (0,esm_extends/* default */.A)({}, style, responsiveProperty({
      cssProperty: "fontSize",
      min: minFontSize,
      max: maxFontSize,
      unit: "rem",
      breakpoints: breakpointValues,
      transform
    }));
  });
  return theme;
}

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/styled.js + 1 modules
var styled = __webpack_require__(50501);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/transitions.js
var transitions = __webpack_require__(58268);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(9022);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(27503);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(89782);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(78576);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme_useTheme = __webpack_require__(9341);
;// ./node_modules/@material-ui/styles/esm/withTheme/withTheme.js







function withThemeCreator() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var defaultTheme = options.defaultTheme;
  var withTheme2 = function withTheme3(Component) {
    if (false) // removed by dead control flow
{}
    var WithTheme = /* @__PURE__ */ index_js_eager_.forwardRef(function WithTheme2(props, ref) {
      var innerRef = props.innerRef, other = (0,objectWithoutProperties/* default */.A)(props, ["innerRef"]);
      var theme = (0,useTheme_useTheme/* default */.A)() || defaultTheme;
      return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
        theme,
        ref: innerRef || ref
      }, other));
    });
     false ? 0 : void 0;
    if (false) // removed by dead control flow
{}
    hoist_non_react_statics_cjs_default()(WithTheme, Component);
    if (false) // removed by dead control flow
{}
    return WithTheme;
  };
  return withTheme2;
}
var withTheme = withThemeCreator();
/* harmony default export */ var withTheme_withTheme = ((/* unused pure expression or super */ null && (withTheme)));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/defaultTheme.js
var defaultTheme = __webpack_require__(62584);
;// ./node_modules/@material-ui/core/esm/styles/withTheme.js


var styles_withTheme_withTheme = withThemeCreator({
  defaultTheme: defaultTheme/* default */.A
});
/* harmony default export */ var styles_withTheme = (styles_withTheme_withTheme);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(82548);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(64970);
// EXTERNAL MODULE: ./node_modules/jss/dist/jss.esm.js
var jss_esm = __webpack_require__(6243);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/StylesProvider/StylesProvider.js
var StylesProvider = __webpack_require__(53091);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/createGenerateClassName/createGenerateClassName.js
var createGenerateClassName = __webpack_require__(87327);
;// ./node_modules/@material-ui/styles/esm/ServerStyleSheets/ServerStyleSheets.js







var ServerStyleSheets = /* @__PURE__ */ (function() {
  function ServerStyleSheets2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0,classCallCheck/* default */.A)(this, ServerStyleSheets2);
    this.options = options;
  }
  (0,createClass/* default */.A)(ServerStyleSheets2, [{
    key: "collect",
    value: function collect(children) {
      var sheetsManager = /* @__PURE__ */ new Map();
      this.sheetsRegistry = new jss_esm/* SheetsRegistry */.SN();
      var generateClassName = (0,createGenerateClassName/* default */.A)();
      return /* @__PURE__ */ index_js_eager_.createElement(StylesProvider/* default */.Ay, (0,esm_extends/* default */.A)({
        sheetsManager,
        serverGenerateClassName: generateClassName,
        sheetsRegistry: this.sheetsRegistry
      }, this.options), children);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.sheetsRegistry ? this.sheetsRegistry.toString() : "";
    }
  }, {
    key: "getStyleElement",
    value: function getStyleElement(props) {
      return /* @__PURE__ */ index_js_eager_.createElement("style", (0,esm_extends/* default */.A)({
        id: "jss-server-side",
        key: "jss-server-side",
        dangerouslySetInnerHTML: {
          __html: this.toString()
        }
      }, props));
    }
  }]);
  return ServerStyleSheets2;
})();


// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/ThemeContext.js
var ThemeContext = __webpack_require__(77693);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/ThemeProvider/nested.js
var nested = __webpack_require__(43312);
;// ./node_modules/@material-ui/styles/esm/ThemeProvider/ThemeProvider.js







function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === "function") {
    var mergedTheme = localTheme(outerTheme);
    if (false) // removed by dead control flow
{}
    return mergedTheme;
  }
  return (0,esm_extends/* default */.A)({}, outerTheme, localTheme);
}
function ThemeProvider(props) {
  var children = props.children, localTheme = props.theme;
  var outerTheme = (0,useTheme_useTheme/* default */.A)();
  if (false) // removed by dead control flow
{}
  var theme = index_js_eager_.useMemo(function() {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
    if (output != null) {
      output[nested/* default */.A] = outerTheme !== null;
    }
    return output;
  }, [localTheme, outerTheme]);
  return /* @__PURE__ */ index_js_eager_.createElement(ThemeContext/* default */.A.Provider, {
    value: theme
  }, children);
}
 false ? 0 : void 0;
if (false) // removed by dead control flow
{}
/* harmony default export */ var ThemeProvider_ThemeProvider = (ThemeProvider);

// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/jssPreset/jssPreset.js + 9 modules
var jssPreset = __webpack_require__(66920);
;// ./node_modules/@material-ui/core/esm/styles/index.js














/***/ }),

/***/ 42806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81497);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62584);



function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(stylesOrCreator, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
    defaultTheme: _defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A
  }, options));
}
/* harmony default export */ __webpack_exports__.A = (makeStyles);


/***/ }),

/***/ 50501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ styles_styled; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(89782);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(31719);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(78576);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/makeStyles.js + 4 modules
var makeStyles = __webpack_require__(81497);
;// ./node_modules/@material-ui/styles/esm/styled/styled.js








function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function(prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}
function styled(Component) {
  var componentCreator = function componentCreator2(style) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var name = options.name, stylesOptions = (0,objectWithoutProperties/* default */.A)(options, ["name"]);
    if (false) // removed by dead control flow
{}
    var classNamePrefix = name;
    if (false) // removed by dead control flow
{ var displayName; }
    var stylesOrCreator = typeof style === "function" ? function(theme) {
      return {
        root: function root(props) {
          return style((0,esm_extends/* default */.A)({
            theme
          }, props));
        }
      };
    } : {
      root: style
    };
    var useStyles = (0,makeStyles/* default */.A)(stylesOrCreator, (0,esm_extends/* default */.A)({
      Component,
      name: name || Component.displayName,
      classNamePrefix
    }, stylesOptions));
    var filterProps;
    var propTypes = {};
    if (style.filterProps) {
      filterProps = style.filterProps;
      delete style.filterProps;
    }
    if (style.propTypes) {
      propTypes = style.propTypes;
      delete style.propTypes;
    }
    var StyledComponent = /* @__PURE__ */ index_js_eager_.forwardRef(function StyledComponent2(props, ref) {
      var children = props.children, classNameProp = props.className, clone = props.clone, ComponentProp = props.component, other = (0,objectWithoutProperties/* default */.A)(props, ["children", "className", "clone", "component"]);
      var classes = useStyles(props);
      var className = (0,clsx_m["default"])(classes.root, classNameProp);
      var spread = other;
      if (filterProps) {
        spread = omit(spread, filterProps);
      }
      if (clone) {
        return /* @__PURE__ */ index_js_eager_.cloneElement(children, (0,esm_extends/* default */.A)({
          className: (0,clsx_m["default"])(children.props.className, className)
        }, spread));
      }
      if (typeof children === "function") {
        return children((0,esm_extends/* default */.A)({
          className
        }, spread));
      }
      var FinalComponent = ComponentProp || Component;
      return /* @__PURE__ */ index_js_eager_.createElement(FinalComponent, (0,esm_extends/* default */.A)({
        ref,
        className
      }, spread), children);
    });
     false ? 0 : void 0;
    if (false) // removed by dead control flow
{}
    hoist_non_react_statics_cjs_default()(StyledComponent, Component);
    return StyledComponent;
  };
  return componentCreator;
}

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/defaultTheme.js
var defaultTheme = __webpack_require__(62584);
;// ./node_modules/@material-ui/core/esm/styles/styled.js



var styled_styled = function styled2(Component) {
  var componentCreator = styled(Component);
  return function(style, options) {
    return componentCreator(style, (0,esm_extends/* default */.A)({
      defaultTheme: defaultTheme/* default */.A
    }, options));
  };
};
/* harmony default export */ var styles_styled = (styled_styled);


/***/ }),

/***/ 58268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   cz: function() { return /* binding */ easing; },
/* harmony export */   p0: function() { return /* binding */ duration; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89782);

var easing = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
};
var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/* harmony default export */ __webpack_exports__.Ay = ({
  easing,
  duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : ["all"];
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options$duration = options.duration, durationOption = _options$duration === void 0 ? duration.standard : _options$duration, _options$easing = options.easing, easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing, _options$delay = options.delay, delay = _options$delay === void 0 ? 0 : _options$delay, other = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(options, ["duration", "easing", "delay"]);
    if (false) // removed by dead control flow
{ var isNumber, isString; }
    return (Array.isArray(props) ? props : [props]).map(function(animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === "string" ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === "string" ? delay : formatMs(delay));
    }).join(",");
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }
    var constant = height / 36;
    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
});


/***/ }),

/***/ 9022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var _material_ui_styles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9341);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12549);
/* harmony import */ var _defaultTheme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62584);



function useTheme() {
  var theme = (0,_material_ui_styles__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)() || _defaultTheme__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A;
  if (false) // removed by dead control flow
{}
  return theme;
}


/***/ }),

/***/ 27503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ styles_withStyles; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(89782);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(78576);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/makeStyles/makeStyles.js + 4 modules
var makeStyles = __webpack_require__(81497);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/getThemeProps/getThemeProps.js
var getThemeProps = __webpack_require__(29663);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(9341);
;// ./node_modules/@material-ui/styles/esm/withStyles/withStyles.js









var withStyles = function withStyles2(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return function(Component) {
    var defaultTheme = options.defaultTheme, _options$withTheme = options.withTheme, withTheme = _options$withTheme === void 0 ? false : _options$withTheme, name = options.name, stylesOptions = (0,objectWithoutProperties/* default */.A)(options, ["defaultTheme", "withTheme", "name"]);
    if (false) // removed by dead control flow
{}
    var classNamePrefix = name;
    if (false) // removed by dead control flow
{ var displayName; }
    var useStyles = (0,makeStyles/* default */.A)(stylesOrCreator, (0,esm_extends/* default */.A)({
      defaultTheme,
      Component,
      name: name || Component.displayName,
      classNamePrefix
    }, stylesOptions));
    var WithStyles = /* @__PURE__ */ index_js_eager_.forwardRef(function WithStyles2(props, ref) {
      var classesProp = props.classes, innerRef = props.innerRef, other = (0,objectWithoutProperties/* default */.A)(props, ["classes", "innerRef"]);
      var classes = useStyles((0,esm_extends/* default */.A)({}, Component.defaultProps, props));
      var theme;
      var more = other;
      if (typeof name === "string" || withTheme) {
        theme = (0,useTheme/* default */.A)() || defaultTheme;
        if (name) {
          more = (0,getThemeProps/* default */.A)({
            theme,
            name,
            props: other
          });
        }
        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }
      return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({
        ref: innerRef || ref,
        classes
      }, more));
    });
     false ? 0 : void 0;
    if (false) // removed by dead control flow
{}
    hoist_non_react_statics_cjs_default()(WithStyles, Component);
    if (false) // removed by dead control flow
{}
    return WithStyles;
  };
};
/* harmony default export */ var withStyles_withStyles = (withStyles);

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/defaultTheme.js
var defaultTheme = __webpack_require__(62584);
;// ./node_modules/@material-ui/core/esm/styles/withStyles.js



function styles_withStyles_withStyles(stylesOrCreator, options) {
  return withStyles_withStyles(stylesOrCreator, (0,esm_extends/* default */.A)({
    defaultTheme: defaultTheme/* default */.A
  }, options));
}
/* harmony default export */ var styles_withStyles = (styles_withStyles_withStyles);


/***/ }),

/***/ 31372:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var zIndex = {
  mobileStepper: 1e3,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ __webpack_exports__.A = (zIndex);


/***/ }),

/***/ 56571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   c: function() { return /* binding */ getTransitionProps; },
/* harmony export */   q: function() { return /* binding */ reflow; }
/* harmony export */ });
var reflow = function reflow2(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout, _props$style = props.style, style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === "number" ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}


/***/ }),

/***/ 39021:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ capitalize; }
/* harmony export */ });
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44998);

function capitalize(string) {
  if (typeof string !== "string") {
    throw new Error( false ? 0 : (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(7));
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}


/***/ }),

/***/ 33771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ createChainedFunction; }
/* harmony export */ });
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  return funcs.reduce(function(acc, func) {
    if (func == null) {
      return acc;
    }
    if (false) // removed by dead control flow
{}
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function() {
  });
}


/***/ }),

/***/ 80868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ createSvgIcon; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12549);
/* harmony import */ var _SvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97186);



function createSvgIcon(path, displayName) {
  var Component = function Component2(props, ref) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.createElement(_SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
      ref
    }, props), path);
  };
  if (false) // removed by dead control flow
{}
  Component.muiName = _SvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A.muiName;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.memo(/* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(Component));
}


/***/ }),

/***/ 35864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ debounce; }
/* harmony export */ });
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 166;
  var timeout;
  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var that = this;
    var later = function later2() {
      func.apply(that, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = function() {
    clearTimeout(timeout);
  };
  return debounced;
}


/***/ }),

/***/ 57040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ getScrollbarSize; }
/* harmony export */ });
function getScrollbarSize() {
  var scrollDiv = document.createElement("div");
  scrollDiv.style.width = "99px";
  scrollDiv.style.height = "99px";
  scrollDiv.style.position = "absolute";
  scrollDiv.style.top = "-9999px";
  scrollDiv.style.overflow = "scroll";
  document.body.appendChild(scrollDiv);
  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
}


/***/ }),

/***/ 80040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  capitalize: function() { return /* reexport */ capitalize/* default */.A; },
  createChainedFunction: function() { return /* reexport */ createChainedFunction/* default */.A; },
  createSvgIcon: function() { return /* reexport */ createSvgIcon/* default */.A; },
  debounce: function() { return /* reexport */ debounce/* default */.A; },
  deprecatedPropType: function() { return /* reexport */ deprecatedPropType; },
  isMuiElement: function() { return /* reexport */ isMuiElement/* default */.A; },
  ownerDocument: function() { return /* reexport */ ownerDocument/* default */.A; },
  ownerWindow: function() { return /* reexport */ ownerWindow/* default */.A; },
  requirePropFactory: function() { return /* reexport */ requirePropFactory; },
  setRef: function() { return /* reexport */ setRef/* default */.A; },
  unstable_useId: function() { return /* reexport */ unstable_useId/* default */.A; },
  unsupportedProp: function() { return /* reexport */ unsupportedProp; },
  useControlled: function() { return /* reexport */ useControlled/* default */.A; },
  useEventCallback: function() { return /* reexport */ useEventCallback/* default */.A; },
  useForkRef: function() { return /* reexport */ useForkRef/* default */.A; },
  useIsFocusVisible: function() { return /* reexport */ useIsFocusVisible/* default */.A; }
});

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/capitalize.js
var capitalize = __webpack_require__(39021);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createChainedFunction.js
var createChainedFunction = __webpack_require__(33771);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(80868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/debounce.js
var debounce = __webpack_require__(35864);
;// ./node_modules/@material-ui/core/esm/utils/deprecatedPropType.js
function deprecatedPropType(validator, reason) {
  if (true) {
    return function() {
      return null;
    };
  }
  // removed by dead control flow

}

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/isMuiElement.js
var isMuiElement = __webpack_require__(75900);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerDocument.js
var ownerDocument = __webpack_require__(33189);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/ownerWindow.js
var ownerWindow = __webpack_require__(37940);
;// ./node_modules/@material-ui/core/esm/utils/requirePropFactory.js
function requirePropFactory(componentNameInError) {
  if (true) {
    return function() {
      return null;
    };
  }
  // removed by dead control flow
 var requireProp; 
  // removed by dead control flow

}

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/setRef.js
var setRef = __webpack_require__(58094);
;// ./node_modules/@material-ui/core/esm/utils/unsupportedProp.js
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }
  // removed by dead control flow
 var propFullNameSafe; 
  // removed by dead control flow

  // removed by dead control flow

}

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useControlled.js
var useControlled = __webpack_require__(50842);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useEventCallback.js
var useEventCallback = __webpack_require__(38957);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useForkRef.js
var useForkRef = __webpack_require__(1863);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/unstable_useId.js
var unstable_useId = __webpack_require__(11518);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/utils/useIsFocusVisible.js
var useIsFocusVisible = __webpack_require__(6606);
;// ./node_modules/@material-ui/core/esm/utils/index.js


















/***/ }),

/***/ 75900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ isMuiElement; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);

function isMuiElement(element, muiNames) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}


/***/ }),

/***/ 33189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ ownerDocument; }
/* harmony export */ });
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}


/***/ }),

/***/ 37940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ ownerWindow; }
/* harmony export */ });
/* harmony import */ var _ownerDocument__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33189);

function ownerWindow(node) {
  var doc = (0,_ownerDocument__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(node);
  return doc.defaultView || window;
}


/***/ }),

/***/ 58094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ setRef; }
/* harmony export */ });
function setRef(ref, value) {
  if (typeof ref === "function") {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}


/***/ }),

/***/ 11518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ useId; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);

function useId(idOverride) {
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(idOverride), defaultId = _React$useState[0], setDefaultId = _React$useState[1];
  var id = idOverride || defaultId;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
    if (defaultId == null) {
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}


/***/ }),

/***/ 50842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ useControlled; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);

function useControlled(_ref) {
  var controlled = _ref.controlled, defaultProp = _ref.default, name = _ref.name, _ref$state = _ref.state, state = _ref$state === void 0 ? "value" : _ref$state;
  var _React$useRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(controlled !== void 0), isControlled = _React$useRef.current;
  var _React$useState = react__WEBPACK_IMPORTED_MODULE_0__.useState(defaultProp), valueState = _React$useState[0], setValue = _React$useState[1];
  var value = isControlled ? controlled : valueState;
  if (false) // removed by dead control flow
{ var _React$useRef2, defaultValue; }
  var setValueIfUncontrolled = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}


/***/ }),

/***/ 38957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ useEventCallback; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);

var useEnhancedEffect = typeof window !== "undefined" ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : react__WEBPACK_IMPORTED_MODULE_0__.useEffect;
function useEventCallback(fn) {
  var ref = react__WEBPACK_IMPORTED_MODULE_0__.useRef(fn);
  useEnhancedEffect(function() {
    ref.current = fn;
  });
  return react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
    return (0, ref.current).apply(void 0, arguments);
  }, []);
}


/***/ }),

/***/ 1863:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ useForkRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);
/* harmony import */ var _setRef__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58094);


function useForkRef(refA, refB) {
  return react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
    if (refA == null && refB == null) {
      return null;
    }
    return function(refValue) {
      (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(refA, refValue);
      (0,_setRef__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(refB, refValue);
    };
  }, [refA, refB]);
}


/***/ }),

/***/ 6606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ useIsFocusVisible; }
/* harmony export */ });
/* unused harmony export teardown */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51971);


var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  "datetime-local": true
};
function focusTriggersKeyboardModality(node) {
  var type = node.type, tagName = node.tagName;
  if (tagName === "INPUT" && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }
  if (tagName === "TEXTAREA" && !node.readOnly) {
    return true;
  }
  if (node.isContentEditable) {
    return true;
  }
  return false;
}
function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }
  hadKeyboardEvent = true;
}
function handlePointerDown() {
  hadKeyboardEvent = false;
}
function handleVisibilityChange() {
  if (this.visibilityState === "hidden") {
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}
function prepare(doc) {
  doc.addEventListener("keydown", handleKeyDown, true);
  doc.addEventListener("mousedown", handlePointerDown, true);
  doc.addEventListener("pointerdown", handlePointerDown, true);
  doc.addEventListener("touchstart", handlePointerDown, true);
  doc.addEventListener("visibilitychange", handleVisibilityChange, true);
}
function teardown(doc) {
  doc.removeEventListener("keydown", handleKeyDown, true);
  doc.removeEventListener("mousedown", handlePointerDown, true);
  doc.removeEventListener("pointerdown", handlePointerDown, true);
  doc.removeEventListener("touchstart", handlePointerDown, true);
  doc.removeEventListener("visibilitychange", handleVisibilityChange, true);
}
function isFocusVisible(event) {
  var target = event.target;
  try {
    return target.matches(":focus-visible");
  } catch (error) {
  }
  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
function handleBlurVisible() {
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
    hadFocusVisibleRecently = false;
  }, 100);
}
function useIsFocusVisible() {
  var ref = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(instance) {
    var node = react_dom__WEBPACK_IMPORTED_MODULE_1__.findDOMNode(instance);
    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  if (false) // removed by dead control flow
{}
  return {
    isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref
  };
}


/***/ }),

/***/ 53091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ay: function() { return /* binding */ StylesProvider; },
/* harmony export */   si: function() { return /* binding */ StylesContext; }
/* harmony export */ });
/* unused harmony export sheetsManager */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89782);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12549);
/* harmony import */ var _createGenerateClassName__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87327);
/* harmony import */ var jss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6243);
/* harmony import */ var _jssPreset__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66920);








var jss = (0,jss__WEBPACK_IMPORTED_MODULE_4__/* .create */ .vt)((0,_jssPreset__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)());
var generateClassName = (0,_createGenerateClassName__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)();
var sheetsManager = /* @__PURE__ */ new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName,
  jss,
  sheetsCache: null,
  sheetsManager,
  sheetsRegistry: null
};
var StylesContext = react__WEBPACK_IMPORTED_MODULE_2__.createContext(defaultOptions);
if (false) // removed by dead control flow
{}
var injectFirstNode;
function StylesProvider(props) {
  var children = props.children, _props$injectFirst = props.injectFirst, injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst, _props$disableGenerat = props.disableGeneration, disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat, localOptions = (0,_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(props, ["children", "injectFirst", "disableGeneration"]);
  var outerOptions = react__WEBPACK_IMPORTED_MODULE_2__.useContext(StylesContext);
  var context = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, outerOptions, {
    disableGeneration
  }, localOptions);
  if (false) // removed by dead control flow
{}
  if (false) // removed by dead control flow
{}
  if (false) // removed by dead control flow
{}
  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== "undefined") {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment("mui-inject-first");
      head.insertBefore(injectFirstNode, head.firstChild);
    }
    context.jss = (0,jss__WEBPACK_IMPORTED_MODULE_4__/* .create */ .vt)({
      plugins: (0,_jssPreset__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)().plugins,
      insertionPoint: injectFirstNode
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_2__.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
 false ? 0 : void 0;
if (false) // removed by dead control flow
{}


/***/ }),

/***/ 43312:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var hasSymbol = typeof Symbol === "function" && Symbol.for;
/* harmony default export */ __webpack_exports__.A = (hasSymbol ? /* @__PURE__ */ Symbol.for("mui.nested") : "__THEME_NESTED__");


/***/ }),

/***/ 87327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ createGenerateClassName; }
/* harmony export */ });
/* harmony import */ var _ThemeProvider_nested__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43312);

var pseudoClasses = ["checked", "disabled", "error", "focused", "focusVisible", "required", "expanded", "selected"];
function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal, disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba, _options$productionPr = options.productionPrefix, productionPrefix = _options$productionPr === void 0 ? "jss" : _options$productionPr, _options$seed = options.seed, seed = _options$seed === void 0 ? "" : _options$seed;
  var seedPrefix = seed === "" ? "" : "".concat(seed, "-");
  var ruleCounter = 0;
  var getNextCounterId = function getNextCounterId2() {
    ruleCounter += 1;
    if (false) // removed by dead control flow
{}
    return ruleCounter;
  };
  return function(rule, styleSheet) {
    var name = styleSheet.options.name;
    if (name && name.indexOf("Mui") === 0 && !styleSheet.options.link && !disableGlobal) {
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }
      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
      if (!styleSheet.options.theme[_ThemeProvider_nested__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A] || seed !== "") {
        return prefix;
      }
      return "".concat(prefix, "-").concat(getNextCounterId());
    }
    if (true) {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }
    // removed by dead control flow
 var suffix; 
    // removed by dead control flow

    // removed by dead control flow

  };
}


/***/ }),

/***/ 29663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ getThemeProps; }
/* harmony export */ });
function getThemeProps(params) {
  var theme = params.theme, name = params.name, props = params.props;
  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  }
  var defaultProps = theme.props[name];
  var propName;
  for (propName in defaultProps) {
    if (props[propName] === void 0) {
      props[propName] = defaultProps[propName];
    }
  }
  return props;
}


/***/ }),

/***/ 66920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ jssPreset; }
});

// EXTERNAL MODULE: ./node_modules/jss/dist/jss.esm.js
var jss_esm = __webpack_require__(6243);
;// ./node_modules/jss-plugin-rule-value-function/dist/jss-plugin-rule-value-function.esm.js


var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;
var functionPlugin = function functionPlugin2() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== "function") return null;
      var rule = (0,jss_esm/* createRule */.D_)(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};
      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== "function") continue;
        delete style[prop];
        fnValues[prop] = value;
      }
      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs];
      if (fnRule) {
        styleRule.style = fnRule(data) || {};
        if (false) // removed by dead control flow
{ var prop; }
      }
      var fnValues = styleRule[fnValuesNs];
      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};
/* harmony default export */ var jss_plugin_rule_value_function_esm = (functionPlugin);

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
;// ./node_modules/jss-plugin-global/dist/jss-plugin-global.esm.js


var at = "@global";
var atPrefix = "@global ";
var GlobalContainerRule = /* @__PURE__ */ (function() {
  function GlobalContainerRule2(key, styles, options) {
    this.type = "global";
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new jss_esm/* RuleList */.VZ((0,esm_extends/* default */.A)({}, options, {
      parent: this
    }));
    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }
    this.rules.process();
  }
  var _proto = GlobalContainerRule2.prototype;
  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  };
  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  };
  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  };
  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  };
  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };
  return GlobalContainerRule2;
})();
var GlobalPrefixedRule = /* @__PURE__ */ (function() {
  function GlobalPrefixedRule2(key, style, options) {
    this.type = "global";
    this.at = at;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, (0,esm_extends/* default */.A)({}, options, {
      parent: this
    }));
  }
  var _proto2 = GlobalPrefixedRule2.prototype;
  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : "";
  };
  return GlobalPrefixedRule2;
})();
var separatorRegExp = /\s*,\s*/g;
function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = "";
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ", ";
  }
  return scoped;
}
function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options, style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;
  for (var name in rules) {
    sheet.addRule(name, rules[name], (0,esm_extends/* default */.A)({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }
  delete style[at];
}
function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options, style = rule.style;
  for (var prop in style) {
    if (prop[0] !== "@" || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], (0,esm_extends/* default */.A)({}, options, {
      selector
    }));
    delete style[prop];
  }
}
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;
    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }
    if (name[0] === "@" && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }
    var parent = options.parent;
    if (parent) {
      if (parent.type === "global" || parent.options.parent && parent.options.parent.type === "global") {
        options.scoped = false;
      }
    }
    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }
    return null;
  }
  function onProcessRule(rule, sheet) {
    if (rule.type !== "style" || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }
  return {
    onCreateRule,
    onProcessRule
  };
}
/* harmony default export */ var jss_plugin_global_esm = (jssGlobal);

;// ./node_modules/jss-plugin-nested/dist/jss-plugin-nested.esm.js


var jss_plugin_nested_esm_separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
function jssNested() {
  function getReplaceRef(container, sheet) {
    return function(match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);
      if (rule) {
        return rule.selector;
      }
       false ? 0 : void 0;
      return key;
    };
  }
  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(jss_plugin_nested_esm_separatorRegExp);
    var nestedSelectors = nestedProp.split(jss_plugin_nested_esm_separatorRegExp);
    var result = "";
    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];
      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ", ";
        result += nested.indexOf("&") !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }
    return result;
  }
  function getOptions(rule, container, prevOptions) {
    if (prevOptions) return (0,esm_extends/* default */.A)({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === void 0 ? 1 : nestingLevel + 1;
    var options = (0,esm_extends/* default */.A)({}, rule.options, {
      nestingLevel,
      index: container.indexOf(rule) + 1
      // We don't need the parent name to be set options for chlid.
    });
    delete options.name;
    return options;
  }
  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== "style") return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;
    for (var prop in style) {
      var isNested = prop.indexOf("&") !== -1;
      var isNestedConditional = prop[0] === "@";
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);
      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector);
        if (!replaceRef) replaceRef = getReplaceRef(container, sheet);
        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;
        if ("replaceRule" in container) {
          container.replaceRule(name, style[prop], (0,esm_extends/* default */.A)({}, options, {
            selector
          }));
        } else {
          container.addRule(name, style[prop], (0,esm_extends/* default */.A)({}, options, {
            selector
          }));
        }
      } else if (isNestedConditional) {
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }
      delete style[prop];
    }
    return style;
  }
  return {
    onProcessStyle
  };
}
/* harmony default export */ var jss_plugin_nested_esm = (jssNested);

;// ./node_modules/hyphenate-style-name/index.js
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};
function toHyphenLower(match) {
  return "-" + match.toLowerCase();
}
function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name];
  }
  var hName = name.replace(uppercasePattern, toHyphenLower);
  return cache[name] = msPattern.test(hName) ? "-" + hName : hName;
}
/* harmony default export */ var hyphenate_style_name = (hyphenateStyleName);

;// ./node_modules/jss-plugin-camel-case/dist/jss-plugin-camel-case.esm.js

function convertCase(style) {
  var converted = {};
  for (var prop in style) {
    var key = prop.indexOf("--") === 0 ? prop : hyphenate_style_name(prop);
    converted[key] = style[prop];
  }
  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);
    else converted.fallbacks = convertCase(style.fallbacks);
  }
  return converted;
}
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }
    return convertCase(style);
  }
  function onChangeValue(value, prop, rule) {
    if (prop.indexOf("--") === 0) {
      return value;
    }
    var hyphenatedProp = hyphenate_style_name(prop);
    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value);
    return null;
  }
  return {
    onProcessStyle,
    onChangeValue
  };
}
/* harmony default export */ var jss_plugin_camel_case_esm = (camelCase);

;// ./node_modules/jss-plugin-default-unit/dist/jss-plugin-default-unit.esm.js

var px = jss_esm/* hasCSSTOMSupport */.rN && CSS ? CSS.px : "px";
var ms = jss_esm/* hasCSSTOMSupport */.rN && CSS ? CSS.ms : "ms";
var percent = jss_esm/* hasCSSTOMSupport */.rN && CSS ? CSS.percent : "%";
var defaultUnits = {
  // Animation properties
  "animation-delay": ms,
  "animation-duration": ms,
  // Background properties
  "background-position": px,
  "background-position-x": px,
  "background-position-y": px,
  "background-size": px,
  // Border Properties
  border: px,
  "border-bottom": px,
  "border-bottom-left-radius": px,
  "border-bottom-right-radius": px,
  "border-bottom-width": px,
  "border-left": px,
  "border-left-width": px,
  "border-radius": px,
  "border-right": px,
  "border-right-width": px,
  "border-top": px,
  "border-top-left-radius": px,
  "border-top-right-radius": px,
  "border-top-width": px,
  "border-width": px,
  "border-block": px,
  "border-block-end": px,
  "border-block-end-width": px,
  "border-block-start": px,
  "border-block-start-width": px,
  "border-block-width": px,
  "border-inline": px,
  "border-inline-end": px,
  "border-inline-end-width": px,
  "border-inline-start": px,
  "border-inline-start-width": px,
  "border-inline-width": px,
  "border-start-start-radius": px,
  "border-start-end-radius": px,
  "border-end-start-radius": px,
  "border-end-end-radius": px,
  // Margin properties
  margin: px,
  "margin-bottom": px,
  "margin-left": px,
  "margin-right": px,
  "margin-top": px,
  "margin-block": px,
  "margin-block-end": px,
  "margin-block-start": px,
  "margin-inline": px,
  "margin-inline-end": px,
  "margin-inline-start": px,
  // Padding properties
  padding: px,
  "padding-bottom": px,
  "padding-left": px,
  "padding-right": px,
  "padding-top": px,
  "padding-block": px,
  "padding-block-end": px,
  "padding-block-start": px,
  "padding-inline": px,
  "padding-inline-end": px,
  "padding-inline-start": px,
  // Mask properties
  "mask-position-x": px,
  "mask-position-y": px,
  "mask-size": px,
  // Width and height properties
  height: px,
  width: px,
  "min-height": px,
  "max-height": px,
  "min-width": px,
  "max-width": px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  "inset-block": px,
  "inset-block-end": px,
  "inset-block-start": px,
  "inset-inline": px,
  "inset-inline-end": px,
  "inset-inline-start": px,
  // Shadow properties
  "box-shadow": px,
  "text-shadow": px,
  // Column properties
  "column-gap": px,
  "column-rule": px,
  "column-rule-width": px,
  "column-width": px,
  // Font and text properties
  "font-size": px,
  "font-size-delta": px,
  "letter-spacing": px,
  "text-decoration-thickness": px,
  "text-indent": px,
  "text-stroke": px,
  "text-stroke-width": px,
  "word-spacing": px,
  // Motion properties
  motion: px,
  "motion-offset": px,
  // Outline properties
  outline: px,
  "outline-offset": px,
  "outline-width": px,
  // Perspective properties
  perspective: px,
  "perspective-origin-x": percent,
  "perspective-origin-y": percent,
  // Transform properties
  "transform-origin": percent,
  "transform-origin-x": percent,
  "transform-origin-y": percent,
  "transform-origin-z": percent,
  // Transition properties
  "transition-delay": ms,
  "transition-duration": ms,
  // Alignment properties
  "vertical-align": px,
  "flex-basis": px,
  // Some random properties
  "shape-margin": px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  "grid-gap": px,
  "row-gap": px,
  "grid-row-gap": px,
  "grid-column-gap": px,
  "grid-template-rows": px,
  "grid-template-columns": px,
  "grid-auto-rows": px,
  "grid-auto-columns": px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  "box-shadow-x": px,
  "box-shadow-y": px,
  "box-shadow-blur": px,
  "box-shadow-spread": px,
  "font-line-height": px,
  "text-shadow-x": px,
  "text-shadow-y": px,
  "text-shadow-blur": px
};
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace2(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}
var units = addCamelCasedVersion(defaultUnits);
function iterate(prop, value, options) {
  if (value == null) return value;
  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === "object") {
    if (prop === "fallbacks") {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    }
  } else if (typeof value === "number" && isNaN(value) === false) {
    var unit = options[prop] || units[prop];
    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === "function" ? unit(value).toString() : "" + value + unit;
    }
    return value.toString();
  }
  return value;
}
function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }
  var camelCasedOptions = addCamelCasedVersion(options);
  function onProcessStyle(style, rule) {
    if (rule.type !== "style") return style;
    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }
    return style;
  }
  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }
  return {
    onProcessStyle,
    onChangeValue
  };
}
/* harmony default export */ var jss_plugin_default_unit_esm = (defaultUnit);

// EXTERNAL MODULE: ./node_modules/is-in-browser/dist/module.js
var dist_module = __webpack_require__(91885);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(6849);
;// ./node_modules/css-vendor/dist/css-vendor.esm.js


var js = "";
var css = "";
var vendor = "";
var browser = "";
var isTouch = dist_module/* default */.A && "ontouchstart" in document.documentElement;
if (dist_module/* default */.A) {
  var jsCssMap = {
    Moz: "-moz-",
    ms: "-ms-",
    O: "-o-",
    Webkit: "-webkit-"
  };
  var _document$createEleme = document.createElement("p"), style = _document$createEleme.style;
  var testProp = "Transform";
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
  if (js === "Webkit" && "msHyphens" in style) {
    js = "ms";
    css = jsCssMap.ms;
    browser = "edge";
  }
  if (js === "Webkit" && "-apple-trailing-word" in style) {
    vendor = "apple";
  }
}
var prefix = {
  js,
  css,
  vendor,
  browser,
  isTouch
};
function supportedKeyframes(key2) {
  if (key2[1] === "-") return key2;
  if (prefix.js === "ms") return key2;
  return "@" + prefix.css + "keyframes" + key2.substr(10);
}
var appearence = {
  noPrefill: ["appearance"],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== "appearance") return false;
    if (prefix.js === "ms") return "-webkit-" + prop;
    return prefix.css + prop;
  }
};
var colorAdjust = {
  noPrefill: ["color-adjust"],
  supportedProperty: function supportedProperty2(prop) {
    if (prop !== "color-adjust") return false;
    if (prefix.js === "Webkit") return prefix.css + "print-" + prop;
    return prop;
  }
};
var regExp = /[-\s]+(.)?/g;
function toUpper(match, c) {
  return c ? c.toUpperCase() : "";
}
function camelize(str) {
  return str.replace(regExp, toUpper);
}
function pascalize(str) {
  return camelize("-" + str);
}
var mask = {
  noPrefill: ["mask"],
  supportedProperty: function supportedProperty3(prop, style2) {
    if (!/^mask/.test(prop)) return false;
    if (prefix.js === "Webkit") {
      var longhand = "mask-image";
      if (camelize(longhand) in style2) {
        return prop;
      }
      if (prefix.js + pascalize(longhand) in style2) {
        return prefix.css + prop;
      }
    }
    return prop;
  }
};
var textOrientation = {
  noPrefill: ["text-orientation"],
  supportedProperty: function supportedProperty4(prop) {
    if (prop !== "text-orientation") return false;
    if (prefix.vendor === "apple" && !prefix.isTouch) {
      return prefix.css + prop;
    }
    return prop;
  }
};
var transform = {
  noPrefill: ["transform"],
  supportedProperty: function supportedProperty5(prop, style2, options) {
    if (prop !== "transform") return false;
    if (options.transform) {
      return prop;
    }
    return prefix.css + prop;
  }
};
var transition = {
  noPrefill: ["transition"],
  supportedProperty: function supportedProperty6(prop, style2, options) {
    if (prop !== "transition") return false;
    if (options.transition) {
      return prop;
    }
    return prefix.css + prop;
  }
};
var writingMode = {
  noPrefill: ["writing-mode"],
  supportedProperty: function supportedProperty7(prop) {
    if (prop !== "writing-mode") return false;
    if (prefix.js === "Webkit" || prefix.js === "ms" && prefix.browser !== "edge") {
      return prefix.css + prop;
    }
    return prop;
  }
};
var userSelect = {
  noPrefill: ["user-select"],
  supportedProperty: function supportedProperty8(prop) {
    if (prop !== "user-select") return false;
    if (prefix.js === "Moz" || prefix.js === "ms" || prefix.vendor === "apple") {
      return prefix.css + prop;
    }
    return prop;
  }
};
var breakPropsOld = {
  supportedProperty: function supportedProperty9(prop, style2) {
    if (!/^break-/.test(prop)) return false;
    if (prefix.js === "Webkit") {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style2 ? prefix.css + "column-" + prop : false;
    }
    if (prefix.js === "Moz") {
      var _jsProp = "page" + pascalize(prop);
      return _jsProp in style2 ? "page-" + prop : false;
    }
    return false;
  }
};
var inlineLogicalOld = {
  supportedProperty: function supportedProperty10(prop, style2) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === "Moz") return prop;
    var newProp = prop.replace("-inline", "");
    return prefix.js + pascalize(newProp) in style2 ? prefix.css + newProp : false;
  }
};
var unprefixed = {
  supportedProperty: function supportedProperty11(prop, style2) {
    return camelize(prop) in style2 ? prop : false;
  }
};
var prefixed = {
  supportedProperty: function supportedProperty12(prop, style2) {
    var pascalized = pascalize(prop);
    if (prop[0] === "-") return prop;
    if (prop[0] === "-" && prop[1] === "-") return prop;
    if (prefix.js + pascalized in style2) return prefix.css + prop;
    if (prefix.js !== "Webkit" && "Webkit" + pascalized in style2) return "-webkit-" + prop;
    return false;
  }
};
var scrollSnap = {
  supportedProperty: function supportedProperty13(prop) {
    if (prop.substring(0, 11) !== "scroll-snap") return false;
    if (prefix.js === "ms") {
      return "" + prefix.css + prop;
    }
    return prop;
  }
};
var overscrollBehavior = {
  supportedProperty: function supportedProperty14(prop) {
    if (prop !== "overscroll-behavior") return false;
    if (prefix.js === "ms") {
      return prefix.css + "scroll-chaining";
    }
    return prop;
  }
};
var propMap = {
  "flex-grow": "flex-positive",
  "flex-shrink": "flex-negative",
  "flex-basis": "flex-preferred-size",
  "justify-content": "flex-pack",
  order: "flex-order",
  "align-items": "flex-align",
  "align-content": "flex-line-pack"
  // 'align-self' is handled by 'align-self' plugin.
};
var flex2012 = {
  supportedProperty: function supportedProperty15(prop, style2) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style2 ? prefix.css + newProp : false;
  }
};
var propMap$1 = {
  flex: "box-flex",
  "flex-grow": "box-flex",
  "flex-direction": ["box-orient", "box-direction"],
  order: "box-ordinal-group",
  "align-items": "box-align",
  "flex-flow": ["box-orient", "box-direction"],
  "justify-content": "box-pack"
};
var propKeys = Object.keys(propMap$1);
var prefixCss = function prefixCss2(p) {
  return prefix.css + p;
};
var flex2009 = {
  supportedProperty: function supportedProperty16(prop, style2, _ref) {
    var multiple = _ref.multiple;
    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];
      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style2 ? prefix.css + newProp : false;
      }
      if (!multiple) return false;
      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style2)) {
          return false;
        }
      }
      return newProp.map(prefixCss);
    }
    return false;
  }
};
var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function(p) {
  return p.supportedProperty;
}).map(function(p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function(p) {
  return p.noPrefill;
}).reduce(function(a, p) {
  a.push.apply(a, (0,toConsumableArray/* default */.A)(p.noPrefill));
  return a;
}, []);
var el;
var css_vendor_esm_cache = {};
if (dist_module/* default */.A) {
  el = document.createElement("p");
  var computed = window.getComputedStyle(document.documentElement, "");
  for (var key$1 in computed) {
    if (!isNaN(key$1)) css_vendor_esm_cache[computed[key$1]] = computed[key$1];
  }
  noPrefill.forEach(function(x) {
    return delete css_vendor_esm_cache[x];
  });
}
function supportedProperty17(prop, options) {
  if (options === void 0) {
    options = {};
  }
  if (!el) return prop;
  if ( true && css_vendor_esm_cache[prop] != null) {
    return css_vendor_esm_cache[prop];
  }
  if (prop === "transition" || prop === "transform") {
    options[prop] = prop in el.style;
  }
  for (var i = 0; i < propertyDetectors.length; i++) {
    css_vendor_esm_cache[prop] = propertyDetectors[i](prop, el.style, options);
    if (css_vendor_esm_cache[prop]) break;
  }
  try {
    el.style[prop] = "";
  } catch (err) {
    return false;
  }
  return css_vendor_esm_cache[prop];
}
var cache$1 = {};
var transitionProperties = {
  transition: 1,
  "transition-property": 1,
  "-webkit-transition": 1,
  "-webkit-transition-property": 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
function prefixTransitionCallback(match, p1, p2) {
  if (p1 === "var") return "var";
  if (p1 === "all") return "all";
  if (p2 === "all") return ", all";
  var prefixedValue = p1 ? supportedProperty17(p1) : ", " + supportedProperty17(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}
if (dist_module/* default */.A) el$1 = document.createElement("p");
function supportedValue(property, value) {
  var prefixedValue = value;
  if (!el$1 || property === "content") return value;
  if (typeof prefixedValue !== "string" || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  }
  var cacheKey = property + prefixedValue;
  if ( true && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  }
  try {
    el$1.style[property] = prefixedValue;
  } catch (err) {
    cache$1[cacheKey] = false;
    return false;
  }
  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === "") {
    prefixedValue = prefix.css + prefixedValue;
    if (prefixedValue === "-ms-flex") el$1.style[property] = "-ms-flexbox";
    el$1.style[property] = prefixedValue;
    if (el$1.style[property] === "") {
      cache$1[cacheKey] = false;
      return false;
    }
  }
  el$1.style[property] = "";
  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}


;// ./node_modules/jss-plugin-vendor-prefixer/dist/jss-plugin-vendor-prefixer.esm.js


function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === "keyframes") {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }
  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];
      if (prop === "fallbacks" && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }
      var changeProp = false;
      var supportedProp = supportedProperty17(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, (0,jss_esm/* toCssValue */.Sg)(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;
      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }
    return style;
  }
  function onProcessStyle(style, rule) {
    if (rule.type !== "style") return style;
    return prefixStyle(style);
  }
  function onChangeValue(value, prop) {
    return supportedValue(prop, (0,jss_esm/* toCssValue */.Sg)(value)) || value;
  }
  return {
    onProcessRule,
    onProcessStyle,
    onChangeValue
  };
}
/* harmony default export */ var jss_plugin_vendor_prefixer_esm = (jssVendorPrefixer);

;// ./node_modules/jss-plugin-props-sort/dist/jss-plugin-props-sort.esm.js
function jssPropsSort() {
  var sort = function sort2(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }
    return prop0.length - prop1.length;
  };
  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== "style") return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);
      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }
      return newStyle;
    }
  };
}
/* harmony default export */ var jss_plugin_props_sort_esm = (jssPropsSort);

;// ./node_modules/@material-ui/styles/esm/jssPreset/jssPreset.js







function jssPreset() {
  return {
    plugins: [
      jss_plugin_rule_value_function_esm(),
      jss_plugin_global_esm(),
      jss_plugin_nested_esm(),
      jss_plugin_camel_case_esm(),
      jss_plugin_default_unit_esm(),
      // Disable the vendor prefixer server-side, it does nothing.
      // This way, we can get a performance boost.
      // In the documentation, we are using `autoprefixer` to solve this problem.
      typeof window === "undefined" ? null : jss_plugin_vendor_prefixer_esm(),
      jss_plugin_props_sort_esm()
    ]
  };
}


/***/ }),

/***/ 81497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ makeStyles; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(89782);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: ./node_modules/jss/dist/jss.esm.js
var jss_esm = __webpack_require__(6243);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/mergeClasses/mergeClasses.js
var mergeClasses = __webpack_require__(31185);
;// ./node_modules/@material-ui/styles/esm/makeStyles/multiKeyStore.js
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);
    if (!subCache) {
      subCache = /* @__PURE__ */ new Map();
      cache.set(key1, subCache);
    }
    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : void 0;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
/* harmony default export */ var makeStyles_multiKeyStore = (multiKeyStore);

// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/useTheme/useTheme.js
var useTheme = __webpack_require__(9341);
// EXTERNAL MODULE: ./node_modules/@material-ui/styles/esm/StylesProvider/StylesProvider.js
var StylesProvider = __webpack_require__(53091);
;// ./node_modules/@material-ui/styles/esm/makeStyles/indexCounter.js
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;
  if (false) // removed by dead control flow
{}
  return indexCounter;
}

// EXTERNAL MODULE: ./node_modules/@material-ui/utils/esm/deepmerge.js
var deepmerge = __webpack_require__(35701);
;// ./node_modules/@material-ui/styles/esm/getStylesCreator/getStylesCreator.js




function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === "function";
  if (false) // removed by dead control flow
{}
  return {
    create: function create(theme, name) {
      var styles;
      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) // removed by dead control flow
{}
        throw err;
      }
      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }
      var overrides = theme.overrides[name];
      var stylesWithOverrides = (0,esm_extends/* default */.A)({}, styles);
      Object.keys(overrides).forEach(function(key) {
        if (false) // removed by dead control flow
{}
        stylesWithOverrides[key] = (0,deepmerge/* default */.A)(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

;// ./node_modules/@material-ui/styles/esm/getStylesCreator/noopTheme.js
var noopTheme = {};
/* harmony default export */ var getStylesCreator_noopTheme = (noopTheme);

;// ./node_modules/@material-ui/styles/esm/makeStyles/makeStyles.js











function getClasses(_ref, classes, Component) {
  var state = _ref.state, stylesOptions = _ref.stylesOptions;
  if (stylesOptions.disableGeneration) {
    return classes || {};
  }
  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  }
  var generate = false;
  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }
  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }
  if (generate) {
    state.cacheClasses.value = (0,mergeClasses/* default */.A)({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component
    });
  }
  return state.cacheClasses.value;
}
function attach(_ref2, props) {
  var state = _ref2.state, theme = _ref2.theme, stylesOptions = _ref2.stylesOptions, stylesCreator = _ref2.stylesCreator, name = _ref2.name;
  if (stylesOptions.disableGeneration) {
    return;
  }
  var sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    makeStyles_multiKeyStore.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }
  var options = (0,esm_extends/* default */.A)({}, stylesCreator.options, stylesOptions, {
    theme,
    flip: typeof stylesOptions.flip === "boolean" ? stylesOptions.flip : theme.direction === "rtl"
  });
  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;
  if (sheetManager.refs === 0) {
    var staticSheet;
    if (stylesOptions.sheetsCache) {
      staticSheet = makeStyles_multiKeyStore.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }
    var styles = stylesCreator.create(theme, name);
    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0,esm_extends/* default */.A)({
        link: false
      }, options));
      staticSheet.attach();
      if (stylesOptions.sheetsCache) {
        makeStyles_multiKeyStore.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }
    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }
    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = (0,jss_esm/* getDynamicStyles */.ih)(styles);
  }
  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0,esm_extends/* default */.A)({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = (0,mergeClasses/* default */.A)({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });
    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }
  sheetManager.refs += 1;
}
function update(_ref3, props) {
  var state = _ref3.state;
  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}
function detach(_ref4) {
  var state = _ref4.state, theme = _ref4.theme, stylesOptions = _ref4.stylesOptions, stylesCreator = _ref4.stylesCreator;
  if (stylesOptions.disableGeneration) {
    return;
  }
  var sheetManager = makeStyles_multiKeyStore.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;
  if (sheetManager.refs === 0) {
    makeStyles_multiKeyStore.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }
  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}
function useSynchronousEffect(func, values) {
  var key = index_js_eager_.useRef([]);
  var output;
  var currentKey = index_js_eager_.useMemo(function() {
    return {};
  }, values);
  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }
  index_js_eager_.useEffect(
    function() {
      return function() {
        if (output) {
          output();
        }
      };
    },
    [currentKey]
    // eslint-disable-line react-hooks/exhaustive-deps
  );
}
function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var name = options.name, classNamePrefixOption = options.classNamePrefix, Component = options.Component, _options$defaultTheme = options.defaultTheme, defaultTheme = _options$defaultTheme === void 0 ? getStylesCreator_noopTheme : _options$defaultTheme, stylesOptions2 = (0,objectWithoutProperties/* default */.A)(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);
  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || "makeStyles";
  stylesCreator.options = {
    index: increment(),
    name,
    meta: classNamePrefix,
    classNamePrefix
  };
  var useStyles = function useStyles2() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var theme = (0,useTheme/* default */.A)() || defaultTheme;
    var stylesOptions = (0,esm_extends/* default */.A)({}, index_js_eager_.useContext(StylesProvider/* StylesContext */.si), stylesOptions2);
    var instance = index_js_eager_.useRef();
    var shouldUpdate = index_js_eager_.useRef();
    useSynchronousEffect(function() {
      var current = {
        name,
        state: {},
        stylesCreator,
        stylesOptions,
        theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function() {
        detach(current);
      };
    }, [theme, stylesCreator]);
    index_js_eager_.useEffect(function() {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }
      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);
    if (false) // removed by dead control flow
{}
    return classes;
  };
  return useStyles;
}


/***/ }),

/***/ 31185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ mergeClasses; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);


function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var baseClasses = options.baseClasses, newClasses = options.newClasses, Component = options.Component;
  if (!newClasses) {
    return baseClasses;
  }
  var nextClasses = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, baseClasses);
  if (false) // removed by dead control flow
{}
  Object.keys(newClasses).forEach(function(key) {
    if (false) // removed by dead control flow
{}
    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}


/***/ }),

/***/ 77693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);

var ThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
if (false) // removed by dead control flow
{}
/* harmony default export */ __webpack_exports__.A = (ThemeContext);


/***/ }),

/***/ 9341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ useTheme; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);
/* harmony import */ var _ThemeContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77693);


function useTheme() {
  var theme = react__WEBPACK_IMPORTED_MODULE_0__.useContext(_ThemeContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A);
  if (false) // removed by dead control flow
{}
  return theme;
}


/***/ }),

/***/ 299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   N: function() { return /* binding */ handleBreakpoints; }
/* harmony export */ });
/* unused harmony import specifier */ var _toConsumableArray;
/* unused harmony import specifier */ var _extends;
/* unused harmony import specifier */ var merge;
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47421);





var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (false) // removed by dead control flow
{}
  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function(acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }
  if ((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(propValue) === "object") {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce(function(acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }
  var output = styleFromPropValue(propValue);
  return output;
}
function breakpoints(styleFunction) {
  var newStyleFunction = function newStyleFunction2(props) {
    var base = styleFunction(props);
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    var extended = themeBreakpoints.keys.reduce(function(acc, key) {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(_extends({
          theme: props.theme
        }, props[key]));
      }
      return acc;
    }, null);
    return merge(base, extended);
  };
  newStyleFunction.propTypes =  false ? 0 : {};
  newStyleFunction.filterProps = ["xs", "sm", "md", "lg", "xl"].concat(_toConsumableArray(styleFunction.filterProps));
  return newStyleFunction;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (breakpoints)));


/***/ }),

/***/ 81979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35701);

function merge(acc, item) {
  if (!item) {
    return acc;
  }
  return (0,_material_ui_utils__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)(acc, item, {
    clone: false
    // No need to clone deep, it's way faster.
  });
}
/* harmony default export */ __webpack_exports__.A = (merge);


/***/ }),

/***/ 59259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  L: function() { return /* binding */ createUnarySpacing; },
  A: function() { return /* binding */ esm_spacing; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(72943);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/breakpoints.js
var breakpoints = __webpack_require__(299);
// EXTERNAL MODULE: ./node_modules/@material-ui/system/esm/merge.js
var merge = __webpack_require__(81979);
;// ./node_modules/@material-ui/system/esm/memoize.js
function memoize(fn) {
  var cache = {};
  return function(arg) {
    if (cache[arg] === void 0) {
      cache[arg] = fn(arg);
    }
    return cache[arg];
  };
}

;// ./node_modules/@material-ui/system/esm/spacing.js





var properties = {
  m: "margin",
  p: "padding"
};
var directions = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
};
var aliases = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
};
var getCssProperties = memoize(function(prop) {
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }
  var _prop$split = prop.split(""), _prop$split2 = (0,slicedToArray/* default */.A)(_prop$split, 2), a = _prop$split2[0], b = _prop$split2[1];
  var property = properties[a];
  var direction = directions[b] || "";
  return Array.isArray(direction) ? direction.map(function(dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ["m", "mt", "mr", "mb", "ml", "mx", "my", "p", "pt", "pr", "pb", "pl", "px", "py", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY"];
function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;
  if (typeof themeSpacing === "number") {
    return function(abs) {
      if (false) // removed by dead control flow
{}
      return themeSpacing * abs;
    };
  }
  if (Array.isArray(themeSpacing)) {
    return function(abs) {
      if (false) // removed by dead control flow
{}
      return themeSpacing[abs];
    };
  }
  if (typeof themeSpacing === "function") {
    return themeSpacing;
  }
  if (false) // removed by dead control flow
{}
  return function() {
    return void 0;
  };
}
function getValue(transformer, propValue) {
  if (typeof propValue === "string" || propValue == null) {
    return propValue;
  }
  var abs = Math.abs(propValue);
  var transformed = transformer(abs);
  if (propValue >= 0) {
    return transformed;
  }
  if (typeof transformed === "number") {
    return -transformed;
  }
  return "-".concat(transformed);
}
function getStyleFromPropValue(cssProperties, transformer) {
  return function(propValue) {
    return cssProperties.reduce(function(acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}
function spacing(props) {
  var theme = props.theme;
  var transformer = createUnarySpacing(theme);
  return Object.keys(props).map(function(prop) {
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }
    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return (0,breakpoints/* handleBreakpoints */.N)(props, propValue, styleFromPropValue);
  }).reduce(merge/* default */.A, {});
}
spacing.propTypes =  false ? 0 : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ var esm_spacing = (spacing);


/***/ }),

/***/ 35701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ deepmerge; }
/* harmony export */ });
/* unused harmony export isPlainObject */
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47421);


function isPlainObject(item) {
  return item && (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A)(item) === "object" && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, target) : target;
  if (isPlainObject(target) && isPlainObject(source)) {
    Object.keys(source).forEach(function(key) {
      if (key === "__proto__") {
        return;
      }
      if (isPlainObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
}


/***/ }),

/***/ 44998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ formatMuiErrorMessage; }
/* harmony export */ });
function formatMuiErrorMessage(code) {
  var url = "https://mui.com/production-error/?code=" + code;
  for (var i = 1; i < arguments.length; i += 1) {
    url += "&args[]=" + encodeURIComponent(arguments[i]);
  }
  return "Minified Material-UI error #" + code + "; visit " + url + " for the full message.";
}


/***/ }),

/***/ 25472:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
/*! For license information please see index.js.LICENSE.txt */
!(function(e, t) {
   true ? module.exports = t(__webpack_require__(4919), __webpack_require__(12549), __webpack_require__(59377)) : 0;
})(self, (e, t, r) => (() => {
  var n = { 3144(e2, t2, r2) {
    "use strict";
    var n2 = r2(6743), s2 = r2(1002), i2 = r2(76), o2 = r2(7119);
    e2.exports = o2 || n2.call(i2, s2);
  }, 1002(e2) {
    "use strict";
    e2.exports = Function.prototype.apply;
  }, 76(e2) {
    "use strict";
    e2.exports = Function.prototype.call;
  }, 3126(e2, t2, r2) {
    "use strict";
    var n2 = r2(6743), s2 = r2(9675), i2 = r2(76), o2 = r2(3144);
    e2.exports = function(e3) {
      if (e3.length < 1 || "function" != typeof e3[0]) throw new s2("a function is required");
      return o2(n2, i2, e3);
    };
  }, 7119(e2) {
    "use strict";
    e2.exports = "undefined" != typeof Reflect && Reflect && Reflect.apply;
  }, 6556(e2, t2, r2) {
    "use strict";
    var n2 = r2(453), s2 = r2(3126), i2 = s2([n2("%String.prototype.indexOf%")]);
    e2.exports = function(e3, t3) {
      var r3 = n2(e3, !!t3);
      return "function" == typeof r3 && i2(e3, ".prototype.") > -1 ? s2([r3]) : r3;
    };
  }, 8750(e2, t2, r2) {
    "use strict";
    r2.d(t2, { A: () => a });
    var n2 = r2(1601), s2 = r2.n(n2), i2 = r2(6314), o2 = r2.n(i2)()(s2());
    o2.push([e2.id, ":root {\n  --toastify-color-light: #fff;\n  --toastify-color-dark: #121212;\n  --toastify-color-info: #3498db;\n  --toastify-color-success: #07bc0c;\n  --toastify-color-warning: #f1c40f;\n  --toastify-color-error: #e74c3c;\n  --toastify-color-transparent: rgba(255, 255, 255, 0.7);\n  --toastify-icon-color-info: var(--toastify-color-info);\n  --toastify-icon-color-success: var(--toastify-color-success);\n  --toastify-icon-color-warning: var(--toastify-color-warning);\n  --toastify-icon-color-error: var(--toastify-color-error);\n  --toastify-toast-width: 320px;\n  --toastify-toast-background: #fff;\n  --toastify-toast-min-height: 64px;\n  --toastify-toast-max-height: 800px;\n  --toastify-font-family: sans-serif;\n  --toastify-z-index: 9999;\n  --toastify-text-color-light: #757575;\n  --toastify-text-color-dark: #fff;\n  --toastify-text-color-info: #fff;\n  --toastify-text-color-success: #fff;\n  --toastify-text-color-warning: #fff;\n  --toastify-text-color-error: #fff;\n  --toastify-spinner-color: #616161;\n  --toastify-spinner-color-empty-area: #e0e0e0;\n  --toastify-color-progress-light: linear-gradient(\n    to right,\n    #4cd964,\n    #5ac8fa,\n    #007aff,\n    #34aadc,\n    #5856d6,\n    #ff2d55\n  );\n  --toastify-color-progress-dark: #bb86fc;\n  --toastify-color-progress-info: var(--toastify-color-info);\n  --toastify-color-progress-success: var(--toastify-color-success);\n  --toastify-color-progress-warning: var(--toastify-color-warning);\n  --toastify-color-progress-error: var(--toastify-color-error);\n}\n\n.Toastify__toast-container {\n  z-index: var(--toastify-z-index);\n  -webkit-transform: translate3d(0, 0, var(--toastify-z-index) px);\n  position: fixed;\n  padding: 4px;\n  width: var(--toastify-toast-width);\n  box-sizing: border-box;\n  color: #fff;\n}\n.Toastify__toast-container--top-left {\n  top: 1em;\n  left: 1em;\n}\n.Toastify__toast-container--top-center {\n  top: 1em;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.Toastify__toast-container--top-right {\n  top: 1em;\n  right: 1em;\n}\n.Toastify__toast-container--bottom-left {\n  bottom: 1em;\n  left: 1em;\n}\n.Toastify__toast-container--bottom-center {\n  bottom: 1em;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.Toastify__toast-container--bottom-right {\n  bottom: 1em;\n  right: 1em;\n}\n\n@media only screen and (max-width : 480px) {\n  .Toastify__toast-container {\n    width: 100vw;\n    padding: 0;\n    left: 0;\n    margin: 0;\n  }\n  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {\n    top: 0;\n    transform: translateX(0);\n  }\n  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {\n    bottom: 0;\n    transform: translateX(0);\n  }\n  .Toastify__toast-container--rtl {\n    right: 0;\n    left: initial;\n  }\n}\n.Toastify__toast {\n  position: relative;\n  min-height: var(--toastify-toast-min-height);\n  box-sizing: border-box;\n  margin-bottom: 1rem;\n  padding: 8px;\n  border-radius: 4px;\n  box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  max-height: var(--toastify-toast-max-height);\n  overflow: hidden;\n  font-family: var(--toastify-font-family);\n  cursor: pointer;\n  direction: ltr;\n}\n.Toastify__toast--rtl {\n  direction: rtl;\n}\n.Toastify__toast-body {\n  margin: auto 0;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  padding: 6px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.Toastify__toast-body > div:last-child {\n  -ms-flex: 1;\n      flex: 1;\n}\n.Toastify__toast-icon {\n  -webkit-margin-end: 10px;\n          margin-inline-end: 10px;\n  width: 20px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.Toastify--animate {\n  animation-fill-mode: both;\n  animation-duration: 0.7s;\n}\n\n.Toastify--animate-icon {\n  animation-fill-mode: both;\n  animation-duration: 0.3s;\n}\n\n@media only screen and (max-width : 480px) {\n  .Toastify__toast {\n    margin-bottom: 0;\n    border-radius: 0;\n  }\n}\n.Toastify__toast-theme--dark {\n  background: var(--toastify-color-dark);\n  color: var(--toastify-text-color-dark);\n}\n.Toastify__toast-theme--light {\n  background: var(--toastify-color-light);\n  color: var(--toastify-text-color-light);\n}\n.Toastify__toast-theme--colored.Toastify__toast--default {\n  background: var(--toastify-color-light);\n  color: var(--toastify-text-color-light);\n}\n.Toastify__toast-theme--colored.Toastify__toast--info {\n  color: var(--toastify-text-color-info);\n  background: var(--toastify-color-info);\n}\n.Toastify__toast-theme--colored.Toastify__toast--success {\n  color: var(--toastify-text-color-success);\n  background: var(--toastify-color-success);\n}\n.Toastify__toast-theme--colored.Toastify__toast--warning {\n  color: var(--toastify-text-color-warning);\n  background: var(--toastify-color-warning);\n}\n.Toastify__toast-theme--colored.Toastify__toast--error {\n  color: var(--toastify-text-color-error);\n  background: var(--toastify-color-error);\n}\n\n.Toastify__progress-bar-theme--light {\n  background: var(--toastify-color-progress-light);\n}\n.Toastify__progress-bar-theme--dark {\n  background: var(--toastify-color-progress-dark);\n}\n.Toastify__progress-bar--info {\n  background: var(--toastify-color-progress-info);\n}\n.Toastify__progress-bar--success {\n  background: var(--toastify-color-progress-success);\n}\n.Toastify__progress-bar--warning {\n  background: var(--toastify-color-progress-warning);\n}\n.Toastify__progress-bar--error {\n  background: var(--toastify-color-progress-error);\n}\n.Toastify__progress-bar-theme--colored.Toastify__progress-bar--info, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--success, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning, .Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {\n  background: var(--toastify-color-transparent);\n}\n\n.Toastify__close-button {\n  color: #fff;\n  background: transparent;\n  outline: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0.7;\n  transition: 0.3s ease;\n  -ms-flex-item-align: start;\n      align-self: flex-start;\n}\n.Toastify__close-button--light {\n  color: #000;\n  opacity: 0.3;\n}\n.Toastify__close-button > svg {\n  fill: currentColor;\n  height: 16px;\n  width: 14px;\n}\n.Toastify__close-button:hover, .Toastify__close-button:focus {\n  opacity: 1;\n}\n\n@keyframes Toastify__trackProgress {\n  0% {\n    transform: scaleX(1);\n  }\n  100% {\n    transform: scaleX(0);\n  }\n}\n.Toastify__progress-bar {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 5px;\n  z-index: var(--toastify-z-index);\n  opacity: 0.7;\n  transform-origin: left;\n}\n.Toastify__progress-bar--animated {\n  animation: Toastify__trackProgress linear 1 forwards;\n}\n.Toastify__progress-bar--controlled {\n  transition: transform 0.2s;\n}\n.Toastify__progress-bar--rtl {\n  right: 0;\n  left: initial;\n  transform-origin: right;\n}\n\n.Toastify__spinner {\n  width: 20px;\n  height: 20px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: var(--toastify-spinner-color-empty-area);\n  border-right-color: var(--toastify-spinner-color);\n  animation: Toastify__spin 0.65s linear infinite;\n}\n\n@keyframes Toastify__bounceInRight {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(-25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(-5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutRight {\n  20% {\n    opacity: 1;\n    transform: translate3d(-20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInLeft {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(-3000px, 0, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(25px, 0, 0);\n  }\n  75% {\n    transform: translate3d(-10px, 0, 0);\n  }\n  90% {\n    transform: translate3d(5px, 0, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutLeft {\n  20% {\n    opacity: 1;\n    transform: translate3d(20px, 0, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(-2000px, 0, 0);\n  }\n}\n@keyframes Toastify__bounceInUp {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  from {\n    opacity: 0;\n    transform: translate3d(0, 3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  75% {\n    transform: translate3d(0, 10px, 0);\n  }\n  90% {\n    transform: translate3d(0, -5px, 0);\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__bounceOutUp {\n  20% {\n    transform: translate3d(0, -10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, 20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, -2000px, 0);\n  }\n}\n@keyframes Toastify__bounceInDown {\n  from, 60%, 75%, 90%, to {\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n  }\n  0% {\n    opacity: 0;\n    transform: translate3d(0, -3000px, 0);\n  }\n  60% {\n    opacity: 1;\n    transform: translate3d(0, 25px, 0);\n  }\n  75% {\n    transform: translate3d(0, -10px, 0);\n  }\n  90% {\n    transform: translate3d(0, 5px, 0);\n  }\n  to {\n    transform: none;\n  }\n}\n@keyframes Toastify__bounceOutDown {\n  20% {\n    transform: translate3d(0, 10px, 0);\n  }\n  40%, 45% {\n    opacity: 1;\n    transform: translate3d(0, -20px, 0);\n  }\n  to {\n    opacity: 0;\n    transform: translate3d(0, 2000px, 0);\n  }\n}\n.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {\n  animation-name: Toastify__bounceInLeft;\n}\n.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {\n  animation-name: Toastify__bounceInRight;\n}\n.Toastify__bounce-enter--top-center {\n  animation-name: Toastify__bounceInDown;\n}\n.Toastify__bounce-enter--bottom-center {\n  animation-name: Toastify__bounceInUp;\n}\n\n.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {\n  animation-name: Toastify__bounceOutLeft;\n}\n.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {\n  animation-name: Toastify__bounceOutRight;\n}\n.Toastify__bounce-exit--top-center {\n  animation-name: Toastify__bounceOutUp;\n}\n.Toastify__bounce-exit--bottom-center {\n  animation-name: Toastify__bounceOutDown;\n}\n\n@keyframes Toastify__zoomIn {\n  from {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n@keyframes Toastify__zoomOut {\n  from {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n  to {\n    opacity: 0;\n  }\n}\n.Toastify__zoom-enter {\n  animation-name: Toastify__zoomIn;\n}\n\n.Toastify__zoom-exit {\n  animation-name: Toastify__zoomOut;\n}\n\n@keyframes Toastify__flipIn {\n  from {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    animation-timing-function: ease-in;\n    opacity: 0;\n  }\n  40% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    animation-timing-function: ease-in;\n  }\n  60% {\n    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n    opacity: 1;\n  }\n  80% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);\n  }\n  to {\n    transform: perspective(400px);\n  }\n}\n@keyframes Toastify__flipOut {\n  from {\n    transform: perspective(400px);\n  }\n  30% {\n    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n    opacity: 1;\n  }\n  to {\n    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n    opacity: 0;\n  }\n}\n.Toastify__flip-enter {\n  animation-name: Toastify__flipIn;\n}\n\n.Toastify__flip-exit {\n  animation-name: Toastify__flipOut;\n}\n\n@keyframes Toastify__slideInRight {\n  from {\n    transform: translate3d(110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInLeft {\n  from {\n    transform: translate3d(-110%, 0, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInUp {\n  from {\n    transform: translate3d(0, 110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideInDown {\n  from {\n    transform: translate3d(0, -110%, 0);\n    visibility: visible;\n  }\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutRight {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutLeft {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(-110%, 0, 0);\n  }\n}\n@keyframes Toastify__slideOutDown {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, 500px, 0);\n  }\n}\n@keyframes Toastify__slideOutUp {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    visibility: hidden;\n    transform: translate3d(0, -500px, 0);\n  }\n}\n.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {\n  animation-name: Toastify__slideInLeft;\n}\n.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {\n  animation-name: Toastify__slideInRight;\n}\n.Toastify__slide-enter--top-center {\n  animation-name: Toastify__slideInDown;\n}\n.Toastify__slide-enter--bottom-center {\n  animation-name: Toastify__slideInUp;\n}\n\n.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {\n  animation-name: Toastify__slideOutLeft;\n}\n.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {\n  animation-name: Toastify__slideOutRight;\n}\n.Toastify__slide-exit--top-center {\n  animation-name: Toastify__slideOutUp;\n}\n.Toastify__slide-exit--bottom-center {\n  animation-name: Toastify__slideOutDown;\n}\n\n@keyframes Toastify__spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}", ""]);
    const a = o2;
  }, 6314(e2) {
    "use strict";
    e2.exports = function(e3) {
      var t2 = [];
      return t2.toString = function() {
        return this.map(function(t3) {
          var r2 = "", n2 = void 0 !== t3[5];
          return t3[4] && (r2 += "@supports (".concat(t3[4], ") {")), t3[2] && (r2 += "@media ".concat(t3[2], " {")), n2 && (r2 += "@layer".concat(t3[5].length > 0 ? " ".concat(t3[5]) : "", " {")), r2 += e3(t3), n2 && (r2 += "}"), t3[2] && (r2 += "}"), t3[4] && (r2 += "}"), r2;
        }).join("");
      }, t2.i = function(e4, r2, n2, s2, i2) {
        "string" == typeof e4 && (e4 = [[null, e4, void 0]]);
        var o2 = {};
        if (n2) for (var a = 0; a < this.length; a++) {
          var c = this[a][0];
          null != c && (o2[c] = true);
        }
        for (var l = 0; l < e4.length; l++) {
          var u = [].concat(e4[l]);
          n2 && o2[u[0]] || (void 0 !== i2 && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = i2), r2 && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = r2) : u[2] = r2), s2 && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = s2) : u[4] = "".concat(s2)), t2.push(u));
        }
      }, t2;
    };
  }, 1601(e2) {
    "use strict";
    e2.exports = function(e3) {
      return e3[1];
    };
  }, 7176(e2, t2, r2) {
    "use strict";
    var n2, s2 = r2(3126), i2 = r2(5795);
    try {
      n2 = [].__proto__ === Array.prototype;
    } catch (e3) {
      if (!e3 || "object" != typeof e3 || !("code" in e3) || "ERR_PROTO_ACCESS" !== e3.code) throw e3;
    }
    var o2 = !!n2 && i2 && i2(Object.prototype, "__proto__"), a = Object, c = a.getPrototypeOf;
    e2.exports = o2 && "function" == typeof o2.get ? s2([o2.get]) : "function" == typeof c && function(e3) {
      return c(null == e3 ? e3 : a(e3));
    };
  }, 655(e2) {
    "use strict";
    var t2 = Object.defineProperty || false;
    if (t2) try {
      t2({}, "a", { value: 1 });
    } catch (e3) {
      t2 = false;
    }
    e2.exports = t2;
  }, 1237(e2) {
    "use strict";
    e2.exports = EvalError;
  }, 9383(e2) {
    "use strict";
    e2.exports = Error;
  }, 9290(e2) {
    "use strict";
    e2.exports = RangeError;
  }, 9538(e2) {
    "use strict";
    e2.exports = ReferenceError;
  }, 8068(e2) {
    "use strict";
    e2.exports = SyntaxError;
  }, 9675(e2) {
    "use strict";
    e2.exports = TypeError;
  }, 5345(e2) {
    "use strict";
    e2.exports = URIError;
  }, 9612(e2) {
    "use strict";
    e2.exports = Object;
  }, 9353(e2) {
    "use strict";
    var t2 = Object.prototype.toString, r2 = Math.max, n2 = function(e3, t3) {
      for (var r3 = [], n3 = 0; n3 < e3.length; n3 += 1) r3[n3] = e3[n3];
      for (var s2 = 0; s2 < t3.length; s2 += 1) r3[s2 + e3.length] = t3[s2];
      return r3;
    };
    e2.exports = function(e3) {
      var s2 = this;
      if ("function" != typeof s2 || "[object Function]" !== t2.apply(s2)) throw new TypeError("Function.prototype.bind called on incompatible " + s2);
      for (var i2, o2 = (function(e4, t3) {
        for (var r3 = [], n3 = t3 || 0, s3 = 0; n3 < e4.length; n3 += 1, s3 += 1) r3[s3] = e4[n3];
        return r3;
      })(arguments, 1), a = r2(0, s2.length - o2.length), c = [], l = 0; l < a; l++) c[l] = "$" + l;
      if (i2 = Function("binder", "return function (" + (function(e4, t3) {
        for (var r3 = "", n3 = 0; n3 < e4.length; n3 += 1) r3 += e4[n3], n3 + 1 < e4.length && (r3 += t3);
        return r3;
      })(c, ",") + "){ return binder.apply(this,arguments); }")(function() {
        if (this instanceof i2) {
          var t3 = s2.apply(this, n2(o2, arguments));
          return Object(t3) === t3 ? t3 : this;
        }
        return s2.apply(e3, n2(o2, arguments));
      }), s2.prototype) {
        var u = function() {
        };
        u.prototype = s2.prototype, i2.prototype = new u(), u.prototype = null;
      }
      return i2;
    };
  }, 6743(e2, t2, r2) {
    "use strict";
    var n2 = r2(9353);
    e2.exports = Function.prototype.bind || n2;
  }, 453(e2, t2, r2) {
    "use strict";
    var n2, s2 = r2(9612), i2 = r2(9383), o2 = r2(1237), a = r2(9290), c = r2(9538), l = r2(8068), u = r2(9675), d = r2(5345), h = r2(1514), p = r2(8968), f = r2(6188), g = r2(8002), y = r2(5880), m = r2(414), _ = r2(3093), w = Function, v = function(e3) {
      try {
        return w('"use strict"; return (' + e3 + ").constructor;")();
      } catch (e4) {
      }
    }, b = r2(5795), S = r2(655), k = function() {
      throw new u();
    }, x = b ? (function() {
      try {
        return k;
      } catch (e3) {
        try {
          return b(arguments, "callee").get;
        } catch (e4) {
          return k;
        }
      }
    })() : k, T = r2(4039)(), E = r2(3628), R = r2(1064), A = r2(8648), O = r2(1002), C = r2(76), I = {}, P = "undefined" != typeof Uint8Array && E ? E(Uint8Array) : n2, N = { __proto__: null, "%AggregateError%": "undefined" == typeof AggregateError ? n2 : AggregateError, "%Array%": Array, "%ArrayBuffer%": "undefined" == typeof ArrayBuffer ? n2 : ArrayBuffer, "%ArrayIteratorPrototype%": T && E ? E([][Symbol.iterator]()) : n2, "%AsyncFromSyncIteratorPrototype%": n2, "%AsyncFunction%": I, "%AsyncGenerator%": I, "%AsyncGeneratorFunction%": I, "%AsyncIteratorPrototype%": I, "%Atomics%": "undefined" == typeof Atomics ? n2 : Atomics, "%BigInt%": "undefined" == typeof BigInt ? n2 : BigInt, "%BigInt64Array%": "undefined" == typeof BigInt64Array ? n2 : BigInt64Array, "%BigUint64Array%": "undefined" == typeof BigUint64Array ? n2 : BigUint64Array, "%Boolean%": Boolean, "%DataView%": "undefined" == typeof DataView ? n2 : DataView, "%Date%": Date, "%decodeURI%": decodeURI, "%decodeURIComponent%": decodeURIComponent, "%encodeURI%": encodeURI, "%encodeURIComponent%": encodeURIComponent, "%Error%": i2, "%eval%": eval, "%EvalError%": o2, "%Float16Array%": "undefined" == typeof Float16Array ? n2 : Float16Array, "%Float32Array%": "undefined" == typeof Float32Array ? n2 : Float32Array, "%Float64Array%": "undefined" == typeof Float64Array ? n2 : Float64Array, "%FinalizationRegistry%": "undefined" == typeof FinalizationRegistry ? n2 : FinalizationRegistry, "%Function%": w, "%GeneratorFunction%": I, "%Int8Array%": "undefined" == typeof Int8Array ? n2 : Int8Array, "%Int16Array%": "undefined" == typeof Int16Array ? n2 : Int16Array, "%Int32Array%": "undefined" == typeof Int32Array ? n2 : Int32Array, "%isFinite%": isFinite, "%isNaN%": isNaN, "%IteratorPrototype%": T && E ? E(E([][Symbol.iterator]())) : n2, "%JSON%": "object" == typeof JSON ? JSON : n2, "%Map%": "undefined" == typeof Map ? n2 : Map, "%MapIteratorPrototype%": "undefined" != typeof Map && T && E ? E((/* @__PURE__ */ new Map())[Symbol.iterator]()) : n2, "%Math%": Math, "%Number%": Number, "%Object%": s2, "%Object.getOwnPropertyDescriptor%": b, "%parseFloat%": parseFloat, "%parseInt%": parseInt, "%Promise%": "undefined" == typeof Promise ? n2 : Promise, "%Proxy%": "undefined" == typeof Proxy ? n2 : Proxy, "%RangeError%": a, "%ReferenceError%": c, "%Reflect%": "undefined" == typeof Reflect ? n2 : Reflect, "%RegExp%": RegExp, "%Set%": "undefined" == typeof Set ? n2 : Set, "%SetIteratorPrototype%": "undefined" != typeof Set && T && E ? E((/* @__PURE__ */ new Set())[Symbol.iterator]()) : n2, "%SharedArrayBuffer%": "undefined" == typeof SharedArrayBuffer ? n2 : SharedArrayBuffer, "%String%": String, "%StringIteratorPrototype%": T && E ? E(""[Symbol.iterator]()) : n2, "%Symbol%": T ? Symbol : n2, "%SyntaxError%": l, "%ThrowTypeError%": x, "%TypedArray%": P, "%TypeError%": u, "%Uint8Array%": "undefined" == typeof Uint8Array ? n2 : Uint8Array, "%Uint8ClampedArray%": "undefined" == typeof Uint8ClampedArray ? n2 : Uint8ClampedArray, "%Uint16Array%": "undefined" == typeof Uint16Array ? n2 : Uint16Array, "%Uint32Array%": "undefined" == typeof Uint32Array ? n2 : Uint32Array, "%URIError%": d, "%WeakMap%": "undefined" == typeof WeakMap ? n2 : WeakMap, "%WeakRef%": "undefined" == typeof WeakRef ? n2 : WeakRef, "%WeakSet%": "undefined" == typeof WeakSet ? n2 : WeakSet, "%Function.prototype.call%": C, "%Function.prototype.apply%": O, "%Object.defineProperty%": S, "%Object.getPrototypeOf%": R, "%Math.abs%": h, "%Math.floor%": p, "%Math.max%": f, "%Math.min%": g, "%Math.pow%": y, "%Math.round%": m, "%Math.sign%": _, "%Reflect.getPrototypeOf%": A };
    if (E) try {
      null.error;
    } catch (e3) {
      var j = E(E(e3));
      N["%Error.prototype%"] = j;
    }
    var U = function e3(t3) {
      var r3;
      if ("%AsyncFunction%" === t3) r3 = v("async function () {}");
      else if ("%GeneratorFunction%" === t3) r3 = v("function* () {}");
      else if ("%AsyncGeneratorFunction%" === t3) r3 = v("async function* () {}");
      else if ("%AsyncGenerator%" === t3) {
        var n3 = e3("%AsyncGeneratorFunction%");
        n3 && (r3 = n3.prototype);
      } else if ("%AsyncIteratorPrototype%" === t3) {
        var s3 = e3("%AsyncGenerator%");
        s3 && E && (r3 = E(s3.prototype));
      }
      return N[t3] = r3, r3;
    }, L = { __proto__: null, "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"], "%ArrayPrototype%": ["Array", "prototype"], "%ArrayProto_entries%": ["Array", "prototype", "entries"], "%ArrayProto_forEach%": ["Array", "prototype", "forEach"], "%ArrayProto_keys%": ["Array", "prototype", "keys"], "%ArrayProto_values%": ["Array", "prototype", "values"], "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"], "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"], "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"], "%BooleanPrototype%": ["Boolean", "prototype"], "%DataViewPrototype%": ["DataView", "prototype"], "%DatePrototype%": ["Date", "prototype"], "%ErrorPrototype%": ["Error", "prototype"], "%EvalErrorPrototype%": ["EvalError", "prototype"], "%Float32ArrayPrototype%": ["Float32Array", "prototype"], "%Float64ArrayPrototype%": ["Float64Array", "prototype"], "%FunctionPrototype%": ["Function", "prototype"], "%Generator%": ["GeneratorFunction", "prototype"], "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"], "%Int8ArrayPrototype%": ["Int8Array", "prototype"], "%Int16ArrayPrototype%": ["Int16Array", "prototype"], "%Int32ArrayPrototype%": ["Int32Array", "prototype"], "%JSONParse%": ["JSON", "parse"], "%JSONStringify%": ["JSON", "stringify"], "%MapPrototype%": ["Map", "prototype"], "%NumberPrototype%": ["Number", "prototype"], "%ObjectPrototype%": ["Object", "prototype"], "%ObjProto_toString%": ["Object", "prototype", "toString"], "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"], "%PromisePrototype%": ["Promise", "prototype"], "%PromiseProto_then%": ["Promise", "prototype", "then"], "%Promise_all%": ["Promise", "all"], "%Promise_reject%": ["Promise", "reject"], "%Promise_resolve%": ["Promise", "resolve"], "%RangeErrorPrototype%": ["RangeError", "prototype"], "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"], "%RegExpPrototype%": ["RegExp", "prototype"], "%SetPrototype%": ["Set", "prototype"], "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"], "%StringPrototype%": ["String", "prototype"], "%SymbolPrototype%": ["Symbol", "prototype"], "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"], "%TypedArrayPrototype%": ["TypedArray", "prototype"], "%TypeErrorPrototype%": ["TypeError", "prototype"], "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"], "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"], "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"], "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"], "%URIErrorPrototype%": ["URIError", "prototype"], "%WeakMapPrototype%": ["WeakMap", "prototype"], "%WeakSetPrototype%": ["WeakSet", "prototype"] }, F = r2(6743), M = r2(9957), D = F.call(C, Array.prototype.concat), q = F.call(O, Array.prototype.splice), $ = F.call(C, String.prototype.replace), B = F.call(C, String.prototype.slice), z = F.call(C, RegExp.prototype.exec), H = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, K = /\\(\\)?/g, V = function(e3, t3) {
      var r3, n3 = e3;
      if (M(L, n3) && (n3 = "%" + (r3 = L[n3])[0] + "%"), M(N, n3)) {
        var s3 = N[n3];
        if (s3 === I && (s3 = U(n3)), void 0 === s3 && !t3) throw new u("intrinsic " + e3 + " exists, but is not available. Please file an issue!");
        return { alias: r3, name: n3, value: s3 };
      }
      throw new l("intrinsic " + e3 + " does not exist!");
    };
    e2.exports = function(e3, t3) {
      if ("string" != typeof e3 || 0 === e3.length) throw new u("intrinsic name must be a non-empty string");
      if (arguments.length > 1 && "boolean" != typeof t3) throw new u('"allowMissing" argument must be a boolean');
      if (null === z(/^%?[^%]*%?$/, e3)) throw new l("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
      var r3 = (function(e4) {
        var t4 = B(e4, 0, 1), r4 = B(e4, -1);
        if ("%" === t4 && "%" !== r4) throw new l("invalid intrinsic syntax, expected closing `%`");
        if ("%" === r4 && "%" !== t4) throw new l("invalid intrinsic syntax, expected opening `%`");
        var n4 = [];
        return $(e4, H, function(e5, t5, r5, s4) {
          n4[n4.length] = r5 ? $(s4, K, "$1") : t5 || e5;
        }), n4;
      })(e3), n3 = r3.length > 0 ? r3[0] : "", s3 = V("%" + n3 + "%", t3), i3 = s3.name, o3 = s3.value, a2 = false, c2 = s3.alias;
      c2 && (n3 = c2[0], q(r3, D([0, 1], c2)));
      for (var d2 = 1, h2 = true; d2 < r3.length; d2 += 1) {
        var p2 = r3[d2], f2 = B(p2, 0, 1), g2 = B(p2, -1);
        if (('"' === f2 || "'" === f2 || "`" === f2 || '"' === g2 || "'" === g2 || "`" === g2) && f2 !== g2) throw new l("property names with quotes must have matching quotes");
        if ("constructor" !== p2 && h2 || (a2 = true), M(N, i3 = "%" + (n3 += "." + p2) + "%")) o3 = N[i3];
        else if (null != o3) {
          if (!(p2 in o3)) {
            if (!t3) throw new u("base intrinsic for " + e3 + " exists, but the property is not available.");
            return;
          }
          if (b && d2 + 1 >= r3.length) {
            var y2 = b(o3, p2);
            o3 = (h2 = !!y2) && "get" in y2 && !("originalValue" in y2.get) ? y2.get : o3[p2];
          } else h2 = M(o3, p2), o3 = o3[p2];
          h2 && !a2 && (N[i3] = o3);
        }
      }
      return o3;
    };
  }, 1064(e2, t2, r2) {
    "use strict";
    var n2 = r2(9612);
    e2.exports = n2.getPrototypeOf || null;
  }, 8648(e2) {
    "use strict";
    e2.exports = "undefined" != typeof Reflect && Reflect.getPrototypeOf || null;
  }, 3628(e2, t2, r2) {
    "use strict";
    var n2 = r2(8648), s2 = r2(1064), i2 = r2(7176);
    e2.exports = n2 ? function(e3) {
      return n2(e3);
    } : s2 ? function(e3) {
      if (!e3 || "object" != typeof e3 && "function" != typeof e3) throw new TypeError("getProto: not an object");
      return s2(e3);
    } : i2 ? function(e3) {
      return i2(e3);
    } : null;
  }, 6549(e2) {
    "use strict";
    e2.exports = Object.getOwnPropertyDescriptor;
  }, 5795(e2, t2, r2) {
    "use strict";
    var n2 = r2(6549);
    if (n2) try {
      n2([], "length");
    } catch (e3) {
      n2 = null;
    }
    e2.exports = n2;
  }, 4039(e2, t2, r2) {
    "use strict";
    var n2 = "undefined" != typeof Symbol && Symbol, s2 = r2(1333);
    e2.exports = function() {
      return "function" == typeof n2 && ("function" == typeof Symbol && ("symbol" == typeof n2("foo") && ("symbol" == typeof /* @__PURE__ */ Symbol("bar") && s2())));
    };
  }, 1333(e2) {
    "use strict";
    e2.exports = function() {
      if ("function" != typeof Symbol || "function" != typeof Object.getOwnPropertySymbols) return false;
      if ("symbol" == typeof Symbol.iterator) return true;
      var e3 = {}, t2 = /* @__PURE__ */ Symbol("test"), r2 = Object(t2);
      if ("string" == typeof t2) return false;
      if ("[object Symbol]" !== Object.prototype.toString.call(t2)) return false;
      if ("[object Symbol]" !== Object.prototype.toString.call(r2)) return false;
      for (var n2 in e3[t2] = 42, e3) return false;
      if ("function" == typeof Object.keys && 0 !== Object.keys(e3).length) return false;
      if ("function" == typeof Object.getOwnPropertyNames && 0 !== Object.getOwnPropertyNames(e3).length) return false;
      var s2 = Object.getOwnPropertySymbols(e3);
      if (1 !== s2.length || s2[0] !== t2) return false;
      if (!Object.prototype.propertyIsEnumerable.call(e3, t2)) return false;
      if ("function" == typeof Object.getOwnPropertyDescriptor) {
        var i2 = Object.getOwnPropertyDescriptor(e3, t2);
        if (42 !== i2.value || true !== i2.enumerable) return false;
      }
      return true;
    };
  }, 9957(e2, t2, r2) {
    "use strict";
    var n2 = Function.prototype.call, s2 = Object.prototype.hasOwnProperty, i2 = r2(6743);
    e2.exports = i2.call(n2, s2);
  }, 1514(e2) {
    "use strict";
    e2.exports = Math.abs;
  }, 8968(e2) {
    "use strict";
    e2.exports = Math.floor;
  }, 4459(e2) {
    "use strict";
    e2.exports = Number.isNaN || function(e3) {
      return e3 != e3;
    };
  }, 6188(e2) {
    "use strict";
    e2.exports = Math.max;
  }, 8002(e2) {
    "use strict";
    e2.exports = Math.min;
  }, 5880(e2) {
    "use strict";
    e2.exports = Math.pow;
  }, 414(e2) {
    "use strict";
    e2.exports = Math.round;
  }, 3093(e2, t2, r2) {
    "use strict";
    var n2 = r2(4459);
    e2.exports = function(e3) {
      return n2(e3) || 0 === e3 ? e3 : e3 < 0 ? -1 : 1;
    };
  }, 8859(e2, t2, r2) {
    var n2 = "function" == typeof Map && Map.prototype, s2 = Object.getOwnPropertyDescriptor && n2 ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null, i2 = n2 && s2 && "function" == typeof s2.get ? s2.get : null, o2 = n2 && Map.prototype.forEach, a = "function" == typeof Set && Set.prototype, c = Object.getOwnPropertyDescriptor && a ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null, l = a && c && "function" == typeof c.get ? c.get : null, u = a && Set.prototype.forEach, d = "function" == typeof WeakMap && WeakMap.prototype ? WeakMap.prototype.has : null, h = "function" == typeof WeakSet && WeakSet.prototype ? WeakSet.prototype.has : null, p = "function" == typeof WeakRef && WeakRef.prototype ? WeakRef.prototype.deref : null, f = Boolean.prototype.valueOf, g = Object.prototype.toString, y = Function.prototype.toString, m = String.prototype.match, _ = String.prototype.slice, w = String.prototype.replace, v = String.prototype.toUpperCase, b = String.prototype.toLowerCase, S = RegExp.prototype.test, k = Array.prototype.concat, x = Array.prototype.join, T = Array.prototype.slice, E = Math.floor, R = "function" == typeof BigInt ? BigInt.prototype.valueOf : null, A = Object.getOwnPropertySymbols, O = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? Symbol.prototype.toString : null, C = "function" == typeof Symbol && "object" == typeof Symbol.iterator, I = "function" == typeof Symbol && Symbol.toStringTag && (typeof Symbol.toStringTag === C || "symbol") ? Symbol.toStringTag : null, P = Object.prototype.propertyIsEnumerable, N = ("function" == typeof Reflect ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype ? function(e3) {
      return e3.__proto__;
    } : null);
    function j(e3, t3) {
      if (e3 === 1 / 0 || e3 === -1 / 0 || e3 != e3 || e3 && e3 > -1e3 && e3 < 1e3 || S.call(/e/, t3)) return t3;
      var r3 = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
      if ("number" == typeof e3) {
        var n3 = e3 < 0 ? -E(-e3) : E(e3);
        if (n3 !== e3) {
          var s3 = String(n3), i3 = _.call(t3, s3.length + 1);
          return w.call(s3, r3, "$&_") + "." + w.call(w.call(i3, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
      }
      return w.call(t3, r3, "$&_");
    }
    var U = r2(2634), L = U.custom, F = K(L) ? L : null, M = { __proto__: null, double: '"', single: "'" }, D = { __proto__: null, double: /(["\\])/g, single: /(['\\])/g };
    function q(e3, t3, r3) {
      var n3 = r3.quoteStyle || t3, s3 = M[n3];
      return s3 + e3 + s3;
    }
    function $(e3) {
      return w.call(String(e3), /"/g, "&quot;");
    }
    function B(e3) {
      return !I || !("object" == typeof e3 && (I in e3 || void 0 !== e3[I]));
    }
    function z(e3) {
      return "[object Array]" === Z(e3) && B(e3);
    }
    function H(e3) {
      return "[object RegExp]" === Z(e3) && B(e3);
    }
    function K(e3) {
      if (C) return e3 && "object" == typeof e3 && e3 instanceof Symbol;
      if ("symbol" == typeof e3) return true;
      if (!e3 || "object" != typeof e3 || !O) return false;
      try {
        return O.call(e3), true;
      } catch (e4) {
      }
      return false;
    }
    e2.exports = function e3(t3, n3, s3, a2) {
      var c2 = n3 || {};
      if (W(c2, "quoteStyle") && !W(M, c2.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
      if (W(c2, "maxStringLength") && ("number" == typeof c2.maxStringLength ? c2.maxStringLength < 0 && c2.maxStringLength !== 1 / 0 : null !== c2.maxStringLength)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
      var g2 = !W(c2, "customInspect") || c2.customInspect;
      if ("boolean" != typeof g2 && "symbol" !== g2) throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
      if (W(c2, "indent") && null !== c2.indent && "	" !== c2.indent && !(parseInt(c2.indent, 10) === c2.indent && c2.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
      if (W(c2, "numericSeparator") && "boolean" != typeof c2.numericSeparator) throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
      var v2 = c2.numericSeparator;
      if (void 0 === t3) return "undefined";
      if (null === t3) return "null";
      if ("boolean" == typeof t3) return t3 ? "true" : "false";
      if ("string" == typeof t3) return G(t3, c2);
      if ("number" == typeof t3) {
        if (0 === t3) return 1 / 0 / t3 > 0 ? "0" : "-0";
        var S2 = String(t3);
        return v2 ? j(t3, S2) : S2;
      }
      if ("bigint" == typeof t3) {
        var E2 = String(t3) + "n";
        return v2 ? j(t3, E2) : E2;
      }
      var A2 = void 0 === c2.depth ? 5 : c2.depth;
      if (void 0 === s3 && (s3 = 0), s3 >= A2 && A2 > 0 && "object" == typeof t3) return z(t3) ? "[Array]" : "[Object]";
      var L2 = (function(e4, t4) {
        var r3;
        if ("	" === e4.indent) r3 = "	";
        else {
          if (!("number" == typeof e4.indent && e4.indent > 0)) return null;
          r3 = x.call(Array(e4.indent + 1), " ");
        }
        return { base: r3, prev: x.call(Array(t4 + 1), r3) };
      })(c2, s3);
      if (void 0 === a2) a2 = [];
      else if (J(a2, t3) >= 0) return "[Circular]";
      function D2(t4, r3, n4) {
        if (r3 && (a2 = T.call(a2)).push(r3), n4) {
          var i3 = { depth: c2.depth };
          return W(c2, "quoteStyle") && (i3.quoteStyle = c2.quoteStyle), e3(t4, i3, s3 + 1, a2);
        }
        return e3(t4, c2, s3 + 1, a2);
      }
      if ("function" == typeof t3 && !H(t3)) {
        var V2 = (function(e4) {
          if (e4.name) return e4.name;
          var t4 = m.call(y.call(e4), /^function\s*([\w$]+)/);
          if (t4) return t4[1];
          return null;
        })(t3), X2 = re(t3, D2);
        return "[Function" + (V2 ? ": " + V2 : " (anonymous)") + "]" + (X2.length > 0 ? " { " + x.call(X2, ", ") + " }" : "");
      }
      if (K(t3)) {
        var ne = C ? w.call(String(t3), /^(Symbol\(.*\))_[^)]*$/, "$1") : O.call(t3);
        return "object" != typeof t3 || C ? ne : Q(ne);
      }
      if ((function(e4) {
        if (!e4 || "object" != typeof e4) return false;
        if ("undefined" != typeof HTMLElement && e4 instanceof HTMLElement) return true;
        return "string" == typeof e4.nodeName && "function" == typeof e4.getAttribute;
      })(t3)) {
        for (var se = "<" + b.call(String(t3.nodeName)), ie = t3.attributes || [], oe = 0; oe < ie.length; oe++) se += " " + ie[oe].name + "=" + q($(ie[oe].value), "double", c2);
        return se += ">", t3.childNodes && t3.childNodes.length && (se += "..."), se += "</" + b.call(String(t3.nodeName)) + ">";
      }
      if (z(t3)) {
        if (0 === t3.length) return "[]";
        var ae = re(t3, D2);
        return L2 && !(function(e4) {
          for (var t4 = 0; t4 < e4.length; t4++) if (J(e4[t4], "\n") >= 0) return false;
          return true;
        })(ae) ? "[" + te(ae, L2) + "]" : "[ " + x.call(ae, ", ") + " ]";
      }
      if ((function(e4) {
        return "[object Error]" === Z(e4) && B(e4);
      })(t3)) {
        var ce = re(t3, D2);
        return "cause" in Error.prototype || !("cause" in t3) || P.call(t3, "cause") ? 0 === ce.length ? "[" + String(t3) + "]" : "{ [" + String(t3) + "] " + x.call(ce, ", ") + " }" : "{ [" + String(t3) + "] " + x.call(k.call("[cause]: " + D2(t3.cause), ce), ", ") + " }";
      }
      if ("object" == typeof t3 && g2) {
        if (F && "function" == typeof t3[F] && U) return U(t3, { depth: A2 - s3 });
        if ("symbol" !== g2 && "function" == typeof t3.inspect) return t3.inspect();
      }
      if ((function(e4) {
        if (!i2 || !e4 || "object" != typeof e4) return false;
        try {
          i2.call(e4);
          try {
            l.call(e4);
          } catch (e5) {
            return true;
          }
          return e4 instanceof Map;
        } catch (e5) {
        }
        return false;
      })(t3)) {
        var le = [];
        return o2 && o2.call(t3, function(e4, r3) {
          le.push(D2(r3, t3, true) + " => " + D2(e4, t3));
        }), ee("Map", i2.call(t3), le, L2);
      }
      if ((function(e4) {
        if (!l || !e4 || "object" != typeof e4) return false;
        try {
          l.call(e4);
          try {
            i2.call(e4);
          } catch (e5) {
            return true;
          }
          return e4 instanceof Set;
        } catch (e5) {
        }
        return false;
      })(t3)) {
        var ue = [];
        return u && u.call(t3, function(e4) {
          ue.push(D2(e4, t3));
        }), ee("Set", l.call(t3), ue, L2);
      }
      if ((function(e4) {
        if (!d || !e4 || "object" != typeof e4) return false;
        try {
          d.call(e4, d);
          try {
            h.call(e4, h);
          } catch (e5) {
            return true;
          }
          return e4 instanceof WeakMap;
        } catch (e5) {
        }
        return false;
      })(t3)) return Y("WeakMap");
      if ((function(e4) {
        if (!h || !e4 || "object" != typeof e4) return false;
        try {
          h.call(e4, h);
          try {
            d.call(e4, d);
          } catch (e5) {
            return true;
          }
          return e4 instanceof WeakSet;
        } catch (e5) {
        }
        return false;
      })(t3)) return Y("WeakSet");
      if ((function(e4) {
        if (!p || !e4 || "object" != typeof e4) return false;
        try {
          return p.call(e4), true;
        } catch (e5) {
        }
        return false;
      })(t3)) return Y("WeakRef");
      if ((function(e4) {
        return "[object Number]" === Z(e4) && B(e4);
      })(t3)) return Q(D2(Number(t3)));
      if ((function(e4) {
        if (!e4 || "object" != typeof e4 || !R) return false;
        try {
          return R.call(e4), true;
        } catch (e5) {
        }
        return false;
      })(t3)) return Q(D2(R.call(t3)));
      if ((function(e4) {
        return "[object Boolean]" === Z(e4) && B(e4);
      })(t3)) return Q(f.call(t3));
      if ((function(e4) {
        return "[object String]" === Z(e4) && B(e4);
      })(t3)) return Q(D2(String(t3)));
      if ("undefined" != typeof window && t3 === window) return "{ [object Window] }";
      if ("undefined" != typeof globalThis && t3 === globalThis || void 0 !== r2.g && t3 === r2.g) return "{ [object globalThis] }";
      if (!(function(e4) {
        return "[object Date]" === Z(e4) && B(e4);
      })(t3) && !H(t3)) {
        var de = re(t3, D2), he = N ? N(t3) === Object.prototype : t3 instanceof Object || t3.constructor === Object, pe = t3 instanceof Object ? "" : "null prototype", fe = !he && I && Object(t3) === t3 && I in t3 ? _.call(Z(t3), 8, -1) : pe ? "Object" : "", ge = (he || "function" != typeof t3.constructor ? "" : t3.constructor.name ? t3.constructor.name + " " : "") + (fe || pe ? "[" + x.call(k.call([], fe || [], pe || []), ": ") + "] " : "");
        return 0 === de.length ? ge + "{}" : L2 ? ge + "{" + te(de, L2) + "}" : ge + "{ " + x.call(de, ", ") + " }";
      }
      return String(t3);
    };
    var V = Object.prototype.hasOwnProperty || function(e3) {
      return e3 in this;
    };
    function W(e3, t3) {
      return V.call(e3, t3);
    }
    function Z(e3) {
      return g.call(e3);
    }
    function J(e3, t3) {
      if (e3.indexOf) return e3.indexOf(t3);
      for (var r3 = 0, n3 = e3.length; r3 < n3; r3++) if (e3[r3] === t3) return r3;
      return -1;
    }
    function G(e3, t3) {
      if (e3.length > t3.maxStringLength) {
        var r3 = e3.length - t3.maxStringLength, n3 = "... " + r3 + " more character" + (r3 > 1 ? "s" : "");
        return G(_.call(e3, 0, t3.maxStringLength), t3) + n3;
      }
      var s3 = D[t3.quoteStyle || "single"];
      return s3.lastIndex = 0, q(w.call(w.call(e3, s3, "\\$1"), /[\x00-\x1f]/g, X), "single", t3);
    }
    function X(e3) {
      var t3 = e3.charCodeAt(0), r3 = { 8: "b", 9: "t", 10: "n", 12: "f", 13: "r" }[t3];
      return r3 ? "\\" + r3 : "\\x" + (t3 < 16 ? "0" : "") + v.call(t3.toString(16));
    }
    function Q(e3) {
      return "Object(" + e3 + ")";
    }
    function Y(e3) {
      return e3 + " { ? }";
    }
    function ee(e3, t3, r3, n3) {
      return e3 + " (" + t3 + ") {" + (n3 ? te(r3, n3) : x.call(r3, ", ")) + "}";
    }
    function te(e3, t3) {
      if (0 === e3.length) return "";
      var r3 = "\n" + t3.prev + t3.base;
      return r3 + x.call(e3, "," + r3) + "\n" + t3.prev;
    }
    function re(e3, t3) {
      var r3 = z(e3), n3 = [];
      if (r3) {
        n3.length = e3.length;
        for (var s3 = 0; s3 < e3.length; s3++) n3[s3] = W(e3, s3) ? t3(e3[s3], e3) : "";
      }
      var i3, o3 = "function" == typeof A ? A(e3) : [];
      if (C) {
        i3 = {};
        for (var a2 = 0; a2 < o3.length; a2++) i3["$" + o3[a2]] = o3[a2];
      }
      for (var c2 in e3) W(e3, c2) && (r3 && String(Number(c2)) === c2 && c2 < e3.length || C && i3["$" + c2] instanceof Symbol || (S.call(/[^\w$]/, c2) ? n3.push(t3(c2, e3) + ": " + t3(e3[c2], e3)) : n3.push(c2 + ": " + t3(e3[c2], e3))));
      if ("function" == typeof A) for (var l2 = 0; l2 < o3.length; l2++) P.call(e3, o3[l2]) && n3.push("[" + t3(o3[l2]) + "]: " + t3(e3[o3[l2]], e3));
      return n3;
    }
  }, 4765(e2) {
    "use strict";
    var t2 = String.prototype.replace, r2 = /%20/g, n2 = "RFC1738", s2 = "RFC3986";
    e2.exports = { default: s2, formatters: { RFC1738: function(e3) {
      return t2.call(e3, r2, "+");
    }, RFC3986: function(e3) {
      return String(e3);
    } }, RFC1738: n2, RFC3986: s2 };
  }, 5373(e2, t2, r2) {
    "use strict";
    var n2 = r2(8636), s2 = r2(2642), i2 = r2(4765);
    e2.exports = { formats: i2, parse: s2, stringify: n2 };
  }, 2642(e2, t2, r2) {
    "use strict";
    var n2 = r2(7720), s2 = Object.prototype.hasOwnProperty, i2 = Array.isArray, o2 = { allowDots: false, allowEmptyArrays: false, allowPrototypes: false, allowSparse: false, arrayLimit: 20, charset: "utf-8", charsetSentinel: false, comma: false, decodeDotInKeys: false, decoder: n2.decode, delimiter: "&", depth: 5, duplicates: "combine", ignoreQueryPrefix: false, interpretNumericEntities: false, parameterLimit: 1e3, parseArrays: true, plainObjects: false, strictDepth: false, strictMerge: true, strictNullHandling: false, throwOnLimitExceeded: false }, a = function(e3) {
      return e3.replace(/&#(\d+);/g, function(e4, t3) {
        return String.fromCharCode(parseInt(t3, 10));
      });
    }, c = function(e3, t3, r3) {
      if (e3 && "string" == typeof e3 && t3.comma && e3.indexOf(",") > -1) return e3.split(",");
      if (t3.throwOnLimitExceeded && r3 >= t3.arrayLimit) throw new RangeError("Array limit exceeded. Only " + t3.arrayLimit + " element" + (1 === t3.arrayLimit ? "" : "s") + " allowed in an array.");
      return e3;
    }, l = function(e3, t3, r3, i3) {
      if (e3) {
        var o3 = (function(e4, t4) {
          var r4 = t4.allowDots ? e4.replace(/\.([^.[]+)/g, "[$1]") : e4;
          if (t4.depth <= 0) {
            if (!t4.plainObjects && s2.call(Object.prototype, r4) && !t4.allowPrototypes) return;
            return [r4];
          }
          var n3 = /(\[[^[\]]*])/g, i4 = /(\[[^[\]]*])/.exec(r4), o4 = i4 ? r4.slice(0, i4.index) : r4, a2 = [];
          if (o4) {
            if (!t4.plainObjects && s2.call(Object.prototype, o4) && !t4.allowPrototypes) return;
            a2[a2.length] = o4;
          }
          for (var c2 = 0; null !== (i4 = n3.exec(r4)) && c2 < t4.depth; ) {
            c2 += 1;
            var l2 = i4[1].slice(1, -1);
            if (!t4.plainObjects && s2.call(Object.prototype, l2) && !t4.allowPrototypes) return;
            a2[a2.length] = i4[1];
          }
          if (i4) {
            if (true === t4.strictDepth) throw new RangeError("Input depth exceeded depth option of " + t4.depth + " and strictDepth is true");
            a2[a2.length] = "[" + r4.slice(i4.index) + "]";
          }
          return a2;
        })(e3, r3);
        if (o3) return (function(e4, t4, r4, s3) {
          var i4 = 0;
          if (e4.length > 0 && "[]" === e4[e4.length - 1]) {
            var o4 = e4.slice(0, -1).join("");
            i4 = Array.isArray(t4) && t4[o4] ? t4[o4].length : 0;
          }
          for (var a2 = s3 ? t4 : c(t4, r4, i4), l2 = e4.length - 1; l2 >= 0; --l2) {
            var u, d = e4[l2];
            if ("[]" === d && r4.parseArrays) u = n2.isOverflow(a2) ? a2 : r4.allowEmptyArrays && ("" === a2 || r4.strictNullHandling && null === a2) ? [] : n2.combine([], a2, r4.arrayLimit, r4.plainObjects);
            else {
              u = r4.plainObjects ? { __proto__: null } : {};
              var h = "[" === d.charAt(0) && "]" === d.charAt(d.length - 1) ? d.slice(1, -1) : d, p = r4.decodeDotInKeys ? h.replace(/%2E/g, ".") : h, f = parseInt(p, 10), g = !isNaN(f) && d !== p && String(f) === p && f >= 0 && r4.parseArrays;
              if (r4.parseArrays || "" !== p) if (g && f < r4.arrayLimit) (u = [])[f] = a2;
              else {
                if (g && r4.throwOnLimitExceeded) throw new RangeError("Array limit exceeded. Only " + r4.arrayLimit + " element" + (1 === r4.arrayLimit ? "" : "s") + " allowed in an array.");
                g ? (u[f] = a2, n2.markOverflow(u, f)) : "__proto__" !== p && (u[p] = a2);
              }
              else u = { 0: a2 };
            }
            a2 = u;
          }
          return a2;
        })(o3, t3, r3, i3);
      }
    };
    e2.exports = function(e3, t3) {
      var r3 = (function(e4) {
        if (!e4) return o2;
        if (void 0 !== e4.allowEmptyArrays && "boolean" != typeof e4.allowEmptyArrays) throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
        if (void 0 !== e4.decodeDotInKeys && "boolean" != typeof e4.decodeDotInKeys) throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
        if (null !== e4.decoder && void 0 !== e4.decoder && "function" != typeof e4.decoder) throw new TypeError("Decoder has to be a function.");
        if (void 0 !== e4.charset && "utf-8" !== e4.charset && "iso-8859-1" !== e4.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        if (void 0 !== e4.throwOnLimitExceeded && "boolean" != typeof e4.throwOnLimitExceeded) throw new TypeError("`throwOnLimitExceeded` option must be a boolean");
        var t4 = void 0 === e4.charset ? o2.charset : e4.charset, r4 = void 0 === e4.duplicates ? o2.duplicates : e4.duplicates;
        if ("combine" !== r4 && "first" !== r4 && "last" !== r4) throw new TypeError("The duplicates option must be either combine, first, or last");
        return { allowDots: void 0 === e4.allowDots ? true === e4.decodeDotInKeys || o2.allowDots : !!e4.allowDots, allowEmptyArrays: "boolean" == typeof e4.allowEmptyArrays ? !!e4.allowEmptyArrays : o2.allowEmptyArrays, allowPrototypes: "boolean" == typeof e4.allowPrototypes ? e4.allowPrototypes : o2.allowPrototypes, allowSparse: "boolean" == typeof e4.allowSparse ? e4.allowSparse : o2.allowSparse, arrayLimit: "number" == typeof e4.arrayLimit ? e4.arrayLimit : o2.arrayLimit, charset: t4, charsetSentinel: "boolean" == typeof e4.charsetSentinel ? e4.charsetSentinel : o2.charsetSentinel, comma: "boolean" == typeof e4.comma ? e4.comma : o2.comma, decodeDotInKeys: "boolean" == typeof e4.decodeDotInKeys ? e4.decodeDotInKeys : o2.decodeDotInKeys, decoder: "function" == typeof e4.decoder ? e4.decoder : o2.decoder, delimiter: "string" == typeof e4.delimiter || n2.isRegExp(e4.delimiter) ? e4.delimiter : o2.delimiter, depth: "number" == typeof e4.depth || false === e4.depth ? +e4.depth : o2.depth, duplicates: r4, ignoreQueryPrefix: true === e4.ignoreQueryPrefix, interpretNumericEntities: "boolean" == typeof e4.interpretNumericEntities ? e4.interpretNumericEntities : o2.interpretNumericEntities, parameterLimit: "number" == typeof e4.parameterLimit ? e4.parameterLimit : o2.parameterLimit, parseArrays: false !== e4.parseArrays, plainObjects: "boolean" == typeof e4.plainObjects ? e4.plainObjects : o2.plainObjects, strictDepth: "boolean" == typeof e4.strictDepth ? !!e4.strictDepth : o2.strictDepth, strictMerge: "boolean" == typeof e4.strictMerge ? !!e4.strictMerge : o2.strictMerge, strictNullHandling: "boolean" == typeof e4.strictNullHandling ? e4.strictNullHandling : o2.strictNullHandling, throwOnLimitExceeded: "boolean" == typeof e4.throwOnLimitExceeded && e4.throwOnLimitExceeded };
      })(t3);
      if ("" === e3 || null == e3) return r3.plainObjects ? { __proto__: null } : {};
      for (var u = "string" == typeof e3 ? (function(e4, t4) {
        var r4 = { __proto__: null }, l2 = t4.ignoreQueryPrefix ? e4.replace(/^\?/, "") : e4;
        l2 = l2.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
        var u2 = t4.parameterLimit === 1 / 0 ? void 0 : t4.parameterLimit, d2 = l2.split(t4.delimiter, t4.throwOnLimitExceeded && void 0 !== u2 ? u2 + 1 : u2);
        if (t4.throwOnLimitExceeded && void 0 !== u2 && d2.length > u2) throw new RangeError("Parameter limit exceeded. Only " + u2 + " parameter" + (1 === u2 ? "" : "s") + " allowed.");
        var h2, p2 = -1, f2 = t4.charset;
        if (t4.charsetSentinel) for (h2 = 0; h2 < d2.length; ++h2) 0 === d2[h2].indexOf("utf8=") && ("utf8=%E2%9C%93" === d2[h2] ? f2 = "utf-8" : "utf8=%26%2310003%3B" === d2[h2] && (f2 = "iso-8859-1"), p2 = h2, h2 = d2.length);
        for (h2 = 0; h2 < d2.length; ++h2) if (h2 !== p2) {
          var g2, y, m = d2[h2], _ = m.indexOf("]="), w = -1 === _ ? m.indexOf("=") : _ + 1;
          if (-1 === w ? (g2 = t4.decoder(m, o2.decoder, f2, "key"), y = t4.strictNullHandling ? null : "") : null !== (g2 = t4.decoder(m.slice(0, w), o2.decoder, f2, "key")) && (y = n2.maybeMap(c(m.slice(w + 1), t4, i2(r4[g2]) ? r4[g2].length : 0), function(e5) {
            return t4.decoder(e5, o2.decoder, f2, "value");
          })), y && t4.interpretNumericEntities && "iso-8859-1" === f2 && (y = a(String(y))), m.indexOf("[]=") > -1 && (y = i2(y) ? [y] : y), t4.comma && i2(y) && y.length > t4.arrayLimit) {
            if (t4.throwOnLimitExceeded) throw new RangeError("Array limit exceeded. Only " + t4.arrayLimit + " element" + (1 === t4.arrayLimit ? "" : "s") + " allowed in an array.");
            y = n2.combine([], y, t4.arrayLimit, t4.plainObjects);
          }
          if (null !== g2) {
            var v = s2.call(r4, g2);
            v && ("combine" === t4.duplicates || m.indexOf("[]=") > -1) ? r4[g2] = n2.combine(r4[g2], y, t4.arrayLimit, t4.plainObjects) : v && "last" !== t4.duplicates || (r4[g2] = y);
          }
        }
        return r4;
      })(e3, r3) : e3, d = r3.plainObjects ? { __proto__: null } : {}, h = Object.keys(u), p = 0; p < h.length; ++p) {
        var f = h[p], g = l(f, u[f], r3, "string" == typeof e3);
        d = n2.merge(d, g, r3);
      }
      return true === r3.allowSparse ? d : n2.compact(d);
    };
  }, 8636(e2, t2, r2) {
    "use strict";
    var n2 = r2(920), s2 = r2(7720), i2 = r2(4765), o2 = Object.prototype.hasOwnProperty, a = { brackets: function(e3) {
      return e3 + "[]";
    }, comma: "comma", indices: function(e3, t3) {
      return e3 + "[" + t3 + "]";
    }, repeat: function(e3) {
      return e3;
    } }, c = Array.isArray, l = Array.prototype.push, u = function(e3, t3) {
      l.apply(e3, c(t3) ? t3 : [t3]);
    }, d = Date.prototype.toISOString, h = i2.default, p = { addQueryPrefix: false, allowDots: false, allowEmptyArrays: false, arrayFormat: "indices", charset: "utf-8", charsetSentinel: false, commaRoundTrip: false, delimiter: "&", encode: true, encodeDotInKeys: false, encoder: s2.encode, encodeValuesOnly: false, filter: void 0, format: h, formatter: i2.formatters[h], indices: false, serializeDate: function(e3) {
      return d.call(e3);
    }, skipNulls: false, strictNullHandling: false }, f = {}, g = function e3(t3, r3, i3, o3, a2, l2, d2, h2, g2, y, m, _, w, v, b, S, k, x) {
      for (var T, E = t3, R = x, A = 0, O = false; void 0 !== (R = R.get(f)) && !O; ) {
        var C = R.get(t3);
        if (A += 1, void 0 !== C) {
          if (C === A) throw new RangeError("Cyclic object value");
          O = true;
        }
        void 0 === R.get(f) && (A = 0);
      }
      if ("function" == typeof y ? E = y(r3, E) : E instanceof Date ? E = w(E) : "comma" === i3 && c(E) && (E = s2.maybeMap(E, function(e4) {
        return e4 instanceof Date ? w(e4) : e4;
      })), null === E) {
        if (l2) return g2 && !S ? g2(r3, p.encoder, k, "key", v) : r3;
        E = "";
      }
      if ("string" == typeof (T = E) || "number" == typeof T || "boolean" == typeof T || "symbol" == typeof T || "bigint" == typeof T || s2.isBuffer(E)) return g2 ? [b(S ? r3 : g2(r3, p.encoder, k, "key", v)) + "=" + b(g2(E, p.encoder, k, "value", v))] : [b(r3) + "=" + b(String(E))];
      var I, P = [];
      if (void 0 === E) return P;
      if ("comma" === i3 && c(E)) S && g2 && (E = s2.maybeMap(E, g2)), I = [{ value: E.length > 0 ? E.join(",") || null : void 0 }];
      else if (c(y)) I = y;
      else {
        var N = Object.keys(E);
        I = m ? N.sort(m) : N;
      }
      var j = h2 ? String(r3).replace(/\./g, "%2E") : String(r3), U = o3 && c(E) && 1 === E.length ? j + "[]" : j;
      if (a2 && c(E) && 0 === E.length) return U + "[]";
      for (var L = 0; L < I.length; ++L) {
        var F = I[L], M = "object" == typeof F && F && void 0 !== F.value ? F.value : E[F];
        if (!d2 || null !== M) {
          var D = _ && h2 ? String(F).replace(/\./g, "%2E") : String(F), q = c(E) ? "function" == typeof i3 ? i3(U, D) : U : U + (_ ? "." + D : "[" + D + "]");
          x.set(t3, A);
          var $ = n2();
          $.set(f, x), u(P, e3(M, q, i3, o3, a2, l2, d2, h2, "comma" === i3 && S && c(E) ? null : g2, y, m, _, w, v, b, S, k, $));
        }
      }
      return P;
    };
    e2.exports = function(e3, t3) {
      var r3, s3 = e3, l2 = (function(e4) {
        if (!e4) return p;
        if (void 0 !== e4.allowEmptyArrays && "boolean" != typeof e4.allowEmptyArrays) throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
        if (void 0 !== e4.encodeDotInKeys && "boolean" != typeof e4.encodeDotInKeys) throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
        if (null !== e4.encoder && void 0 !== e4.encoder && "function" != typeof e4.encoder) throw new TypeError("Encoder has to be a function.");
        var t4 = e4.charset || p.charset;
        if (void 0 !== e4.charset && "utf-8" !== e4.charset && "iso-8859-1" !== e4.charset) throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
        var r4 = i2.default;
        if (void 0 !== e4.format) {
          if (!o2.call(i2.formatters, e4.format)) throw new TypeError("Unknown format option provided.");
          r4 = e4.format;
        }
        var n3, s4 = i2.formatters[r4], l3 = p.filter;
        if (("function" == typeof e4.filter || c(e4.filter)) && (l3 = e4.filter), n3 = e4.arrayFormat in a ? e4.arrayFormat : "indices" in e4 ? e4.indices ? "indices" : "repeat" : p.arrayFormat, "commaRoundTrip" in e4 && "boolean" != typeof e4.commaRoundTrip) throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
        var u2 = void 0 === e4.allowDots ? true === e4.encodeDotInKeys || p.allowDots : !!e4.allowDots;
        return { addQueryPrefix: "boolean" == typeof e4.addQueryPrefix ? e4.addQueryPrefix : p.addQueryPrefix, allowDots: u2, allowEmptyArrays: "boolean" == typeof e4.allowEmptyArrays ? !!e4.allowEmptyArrays : p.allowEmptyArrays, arrayFormat: n3, charset: t4, charsetSentinel: "boolean" == typeof e4.charsetSentinel ? e4.charsetSentinel : p.charsetSentinel, commaRoundTrip: !!e4.commaRoundTrip, delimiter: void 0 === e4.delimiter ? p.delimiter : e4.delimiter, encode: "boolean" == typeof e4.encode ? e4.encode : p.encode, encodeDotInKeys: "boolean" == typeof e4.encodeDotInKeys ? e4.encodeDotInKeys : p.encodeDotInKeys, encoder: "function" == typeof e4.encoder ? e4.encoder : p.encoder, encodeValuesOnly: "boolean" == typeof e4.encodeValuesOnly ? e4.encodeValuesOnly : p.encodeValuesOnly, filter: l3, format: r4, formatter: s4, serializeDate: "function" == typeof e4.serializeDate ? e4.serializeDate : p.serializeDate, skipNulls: "boolean" == typeof e4.skipNulls ? e4.skipNulls : p.skipNulls, sort: "function" == typeof e4.sort ? e4.sort : null, strictNullHandling: "boolean" == typeof e4.strictNullHandling ? e4.strictNullHandling : p.strictNullHandling };
      })(t3);
      "function" == typeof l2.filter ? s3 = (0, l2.filter)("", s3) : c(l2.filter) && (r3 = l2.filter);
      var d2 = [];
      if ("object" != typeof s3 || null === s3) return "";
      var h2 = a[l2.arrayFormat], f2 = "comma" === h2 && l2.commaRoundTrip;
      r3 || (r3 = Object.keys(s3)), l2.sort && r3.sort(l2.sort);
      for (var y = n2(), m = 0; m < r3.length; ++m) {
        var _ = r3[m], w = s3[_];
        l2.skipNulls && null === w || u(d2, g(w, _, h2, f2, l2.allowEmptyArrays, l2.strictNullHandling, l2.skipNulls, l2.encodeDotInKeys, l2.encode ? l2.encoder : null, l2.filter, l2.sort, l2.allowDots, l2.serializeDate, l2.format, l2.formatter, l2.encodeValuesOnly, l2.charset, y));
      }
      var v = d2.join(l2.delimiter), b = true === l2.addQueryPrefix ? "?" : "";
      return l2.charsetSentinel && ("iso-8859-1" === l2.charset ? b += "utf8=%26%2310003%3B&" : b += "utf8=%E2%9C%93&"), v.length > 0 ? b + v : "";
    };
  }, 7720(e2, t2, r2) {
    "use strict";
    var n2 = r2(4765), s2 = r2(920), i2 = Object.prototype.hasOwnProperty, o2 = Array.isArray, a = s2(), c = function(e3, t3) {
      return a.set(e3, t3), e3;
    }, l = function(e3) {
      return a.has(e3);
    }, u = function(e3) {
      return a.get(e3);
    }, d = function(e3, t3) {
      a.set(e3, t3);
    }, h = (function() {
      for (var e3 = [], t3 = 0; t3 < 256; ++t3) e3[e3.length] = "%" + ((t3 < 16 ? "0" : "") + t3.toString(16)).toUpperCase();
      return e3;
    })(), p = function(e3, t3) {
      for (var r3 = t3 && t3.plainObjects ? { __proto__: null } : {}, n3 = 0; n3 < e3.length; ++n3) void 0 !== e3[n3] && (r3[n3] = e3[n3]);
      return r3;
    }, f = 1024;
    e2.exports = { arrayToObject: p, assign: function(e3, t3) {
      return Object.keys(t3).reduce(function(e4, r3) {
        return e4[r3] = t3[r3], e4;
      }, e3);
    }, combine: function(e3, t3, r3, n3) {
      if (l(e3)) {
        var s3 = u(e3) + 1;
        return e3[s3] = t3, d(e3, s3), e3;
      }
      var i3 = [].concat(e3, t3);
      return i3.length > r3 ? c(p(i3, { plainObjects: n3 }), i3.length - 1) : i3;
    }, compact: function(e3) {
      for (var t3 = [{ obj: { o: e3 }, prop: "o" }], r3 = [], n3 = 0; n3 < t3.length; ++n3) for (var s3 = t3[n3], i3 = s3.obj[s3.prop], a2 = Object.keys(i3), c2 = 0; c2 < a2.length; ++c2) {
        var l2 = a2[c2], u2 = i3[l2];
        "object" == typeof u2 && null !== u2 && -1 === r3.indexOf(u2) && (t3[t3.length] = { obj: i3, prop: l2 }, r3[r3.length] = u2);
      }
      return (function(e4) {
        for (; e4.length > 1; ) {
          var t4 = e4.pop(), r4 = t4.obj[t4.prop];
          if (o2(r4)) {
            for (var n4 = [], s4 = 0; s4 < r4.length; ++s4) void 0 !== r4[s4] && (n4[n4.length] = r4[s4]);
            t4.obj[t4.prop] = n4;
          }
        }
      })(t3), e3;
    }, decode: function(e3, t3, r3) {
      var n3 = e3.replace(/\+/g, " ");
      if ("iso-8859-1" === r3) return n3.replace(/%[0-9a-f]{2}/gi, unescape);
      try {
        return decodeURIComponent(n3);
      } catch (e4) {
        return n3;
      }
    }, encode: function(e3, t3, r3, s3, i3) {
      if (0 === e3.length) return e3;
      var o3 = e3;
      if ("symbol" == typeof e3 ? o3 = Symbol.prototype.toString.call(e3) : "string" != typeof e3 && (o3 = String(e3)), "iso-8859-1" === r3) return escape(o3).replace(/%u[0-9a-f]{4}/gi, function(e4) {
        return "%26%23" + parseInt(e4.slice(2), 16) + "%3B";
      });
      for (var a2 = "", c2 = 0; c2 < o3.length; c2 += f) {
        for (var l2 = o3.length >= f ? o3.slice(c2, c2 + f) : o3, u2 = [], d2 = 0; d2 < l2.length; ++d2) {
          var p2 = l2.charCodeAt(d2);
          45 === p2 || 46 === p2 || 95 === p2 || 126 === p2 || p2 >= 48 && p2 <= 57 || p2 >= 65 && p2 <= 90 || p2 >= 97 && p2 <= 122 || i3 === n2.RFC1738 && (40 === p2 || 41 === p2) ? u2[u2.length] = l2.charAt(d2) : p2 < 128 ? u2[u2.length] = h[p2] : p2 < 2048 ? u2[u2.length] = h[192 | p2 >> 6] + h[128 | 63 & p2] : p2 < 55296 || p2 >= 57344 ? u2[u2.length] = h[224 | p2 >> 12] + h[128 | p2 >> 6 & 63] + h[128 | 63 & p2] : (d2 += 1, p2 = 65536 + ((1023 & p2) << 10 | 1023 & l2.charCodeAt(d2)), u2[u2.length] = h[240 | p2 >> 18] + h[128 | p2 >> 12 & 63] + h[128 | p2 >> 6 & 63] + h[128 | 63 & p2]);
        }
        a2 += u2.join("");
      }
      return a2;
    }, isBuffer: function(e3) {
      return !(!e3 || "object" != typeof e3) && !!(e3.constructor && e3.constructor.isBuffer && e3.constructor.isBuffer(e3));
    }, isOverflow: l, isRegExp: function(e3) {
      return "[object RegExp]" === Object.prototype.toString.call(e3);
    }, markOverflow: c, maybeMap: function(e3, t3) {
      if (o2(e3)) {
        for (var r3 = [], n3 = 0; n3 < e3.length; n3 += 1) r3[r3.length] = t3(e3[n3]);
        return r3;
      }
      return t3(e3);
    }, merge: function e3(t3, r3, n3) {
      if (!r3) return t3;
      if ("object" != typeof r3 && "function" != typeof r3) {
        if (o2(t3)) {
          var s3 = t3.length;
          if (n3 && "number" == typeof n3.arrayLimit && s3 > n3.arrayLimit) return c(p(t3.concat(r3), n3), s3);
          t3[s3] = r3;
        } else {
          if (!t3 || "object" != typeof t3) return [t3, r3];
          if (l(t3)) {
            var a2 = u(t3) + 1;
            t3[a2] = r3, d(t3, a2);
          } else {
            if (n3 && n3.strictMerge) return [t3, r3];
            (n3 && (n3.plainObjects || n3.allowPrototypes) || !i2.call(Object.prototype, r3)) && (t3[r3] = true);
          }
        }
        return t3;
      }
      if (!t3 || "object" != typeof t3) {
        if (l(r3)) {
          for (var h2 = Object.keys(r3), f2 = n3 && n3.plainObjects ? { __proto__: null, 0: t3 } : { 0: t3 }, g = 0; g < h2.length; g++) {
            f2[parseInt(h2[g], 10) + 1] = r3[h2[g]];
          }
          return c(f2, u(r3) + 1);
        }
        var y = [t3].concat(r3);
        return n3 && "number" == typeof n3.arrayLimit && y.length > n3.arrayLimit ? c(p(y, n3), y.length - 1) : y;
      }
      var m = t3;
      return o2(t3) && !o2(r3) && (m = p(t3, n3)), o2(t3) && o2(r3) ? (r3.forEach(function(r4, s4) {
        if (i2.call(t3, s4)) {
          var o3 = t3[s4];
          o3 && "object" == typeof o3 && r4 && "object" == typeof r4 ? t3[s4] = e3(o3, r4, n3) : t3[t3.length] = r4;
        } else t3[s4] = r4;
      }), t3) : Object.keys(r3).reduce(function(t4, s4) {
        var o3 = r3[s4];
        if (i2.call(t4, s4) ? t4[s4] = e3(t4[s4], o3, n3) : t4[s4] = o3, l(r3) && !l(t4) && c(t4, u(r3)), l(t4)) {
          var a3 = parseInt(s4, 10);
          String(a3) === s4 && a3 >= 0 && a3 > u(t4) && d(t4, a3);
        }
        return t4;
      }, m);
    } };
  }, 4803(e2, t2, r2) {
    "use strict";
    var n2 = r2(8859), s2 = r2(9675), i2 = function(e3, t3, r3) {
      for (var n3, s3 = e3; null != (n3 = s3.next); s3 = n3) if (n3.key === t3) return s3.next = n3.next, r3 || (n3.next = e3.next, e3.next = n3), n3;
    };
    e2.exports = function() {
      var e3, t3 = { assert: function(e4) {
        if (!t3.has(e4)) throw new s2("Side channel does not contain " + n2(e4));
      }, delete: function(t4) {
        var r3 = (function(e4, t5) {
          if (e4) return i2(e4, t5, true);
        })(e3, t4);
        return r3 && e3 && !e3.next && (e3 = void 0), !!r3;
      }, get: function(t4) {
        return (function(e4, t5) {
          if (e4) {
            var r3 = i2(e4, t5);
            return r3 && r3.value;
          }
        })(e3, t4);
      }, has: function(t4) {
        return (function(e4, t5) {
          return !!e4 && !!i2(e4, t5);
        })(e3, t4);
      }, set: function(t4, r3) {
        e3 || (e3 = { next: void 0 }), (function(e4, t5, r4) {
          var n3 = i2(e4, t5);
          n3 ? n3.value = r4 : e4.next = { key: t5, next: e4.next, value: r4 };
        })(e3, t4, r3);
      } };
      return t3;
    };
  }, 507(e2, t2, r2) {
    "use strict";
    var n2 = r2(453), s2 = r2(6556), i2 = r2(8859), o2 = r2(9675), a = n2("%Map%", true), c = s2("Map.prototype.get", true), l = s2("Map.prototype.set", true), u = s2("Map.prototype.has", true), d = s2("Map.prototype.delete", true), h = s2("Map.prototype.size", true);
    e2.exports = !!a && function() {
      var e3, t3 = { assert: function(e4) {
        if (!t3.has(e4)) throw new o2("Side channel does not contain " + i2(e4));
      }, delete: function(t4) {
        if (e3) {
          var r3 = d(e3, t4);
          return 0 === h(e3) && (e3 = void 0), r3;
        }
        return false;
      }, get: function(t4) {
        if (e3) return c(e3, t4);
      }, has: function(t4) {
        return !!e3 && u(e3, t4);
      }, set: function(t4, r3) {
        e3 || (e3 = new a()), l(e3, t4, r3);
      } };
      return t3;
    };
  }, 2271(e2, t2, r2) {
    "use strict";
    var n2 = r2(453), s2 = r2(6556), i2 = r2(8859), o2 = r2(507), a = r2(9675), c = n2("%WeakMap%", true), l = s2("WeakMap.prototype.get", true), u = s2("WeakMap.prototype.set", true), d = s2("WeakMap.prototype.has", true), h = s2("WeakMap.prototype.delete", true);
    e2.exports = c ? function() {
      var e3, t3, r3 = { assert: function(e4) {
        if (!r3.has(e4)) throw new a("Side channel does not contain " + i2(e4));
      }, delete: function(r4) {
        if (c && r4 && ("object" == typeof r4 || "function" == typeof r4)) {
          if (e3) return h(e3, r4);
        } else if (o2 && t3) return t3.delete(r4);
        return false;
      }, get: function(r4) {
        return c && r4 && ("object" == typeof r4 || "function" == typeof r4) && e3 ? l(e3, r4) : t3 && t3.get(r4);
      }, has: function(r4) {
        return c && r4 && ("object" == typeof r4 || "function" == typeof r4) && e3 ? d(e3, r4) : !!t3 && t3.has(r4);
      }, set: function(r4, n3) {
        c && r4 && ("object" == typeof r4 || "function" == typeof r4) ? (e3 || (e3 = new c()), u(e3, r4, n3)) : o2 && (t3 || (t3 = o2()), t3.set(r4, n3));
      } };
      return r3;
    } : o2;
  }, 920(e2, t2, r2) {
    "use strict";
    var n2 = r2(9675), s2 = r2(8859), i2 = r2(4803), o2 = r2(507), a = r2(2271) || o2 || i2;
    e2.exports = function() {
      var e3, t3 = { assert: function(e4) {
        if (!t3.has(e4)) throw new n2("Side channel does not contain " + s2(e4));
      }, delete: function(t4) {
        return !!e3 && e3.delete(t4);
      }, get: function(t4) {
        return e3 && e3.get(t4);
      }, has: function(t4) {
        return !!e3 && e3.has(t4);
      }, set: function(t4, r3) {
        e3 || (e3 = a()), e3.set(t4, r3);
      } };
      return t3;
    };
  }, 5072(e2) {
    "use strict";
    var t2 = [];
    function r2(e3) {
      for (var r3 = -1, n3 = 0; n3 < t2.length; n3++) if (t2[n3].identifier === e3) {
        r3 = n3;
        break;
      }
      return r3;
    }
    function n2(e3, n3) {
      for (var i2 = {}, o2 = [], a = 0; a < e3.length; a++) {
        var c = e3[a], l = n3.base ? c[0] + n3.base : c[0], u = i2[l] || 0, d = "".concat(l, " ").concat(u);
        i2[l] = u + 1;
        var h = r2(d), p = { css: c[1], media: c[2], sourceMap: c[3], supports: c[4], layer: c[5] };
        if (-1 !== h) t2[h].references++, t2[h].updater(p);
        else {
          var f = s2(p, n3);
          n3.byIndex = a, t2.splice(a, 0, { identifier: d, updater: f, references: 1 });
        }
        o2.push(d);
      }
      return o2;
    }
    function s2(e3, t3) {
      var r3 = t3.domAPI(t3);
      r3.update(e3);
      return function(t4) {
        if (t4) {
          if (t4.css === e3.css && t4.media === e3.media && t4.sourceMap === e3.sourceMap && t4.supports === e3.supports && t4.layer === e3.layer) return;
          r3.update(e3 = t4);
        } else r3.remove();
      };
    }
    e2.exports = function(e3, s3) {
      var i2 = n2(e3 = e3 || [], s3 = s3 || {});
      return function(e4) {
        e4 = e4 || [];
        for (var o2 = 0; o2 < i2.length; o2++) {
          var a = r2(i2[o2]);
          t2[a].references--;
        }
        for (var c = n2(e4, s3), l = 0; l < i2.length; l++) {
          var u = r2(i2[l]);
          0 === t2[u].references && (t2[u].updater(), t2.splice(u, 1));
        }
        i2 = c;
      };
    };
  }, 7659(e2) {
    "use strict";
    var t2 = {};
    e2.exports = function(e3, r2) {
      var n2 = (function(e4) {
        if (void 0 === t2[e4]) {
          var r3 = document.querySelector(e4);
          if (window.HTMLIFrameElement && r3 instanceof window.HTMLIFrameElement) try {
            r3 = r3.contentDocument.head;
          } catch (e5) {
            r3 = null;
          }
          t2[e4] = r3;
        }
        return t2[e4];
      })(e3);
      if (!n2) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
      n2.appendChild(r2);
    };
  }, 540(e2) {
    "use strict";
    e2.exports = function(e3) {
      var t2 = document.createElement("style");
      return e3.setAttributes(t2, e3.attributes), e3.insert(t2, e3.options), t2;
    };
  }, 5056(e2, t2, r2) {
    "use strict";
    e2.exports = function(e3) {
      var t3 = r2.nc;
      t3 && e3.setAttribute("nonce", t3);
    };
  }, 7825(e2) {
    "use strict";
    e2.exports = function(e3) {
      if ("undefined" == typeof document) return { update: function() {
      }, remove: function() {
      } };
      var t2 = e3.insertStyleElement(e3);
      return { update: function(r2) {
        !(function(e4, t3, r3) {
          var n2 = "";
          r3.supports && (n2 += "@supports (".concat(r3.supports, ") {")), r3.media && (n2 += "@media ".concat(r3.media, " {"));
          var s2 = void 0 !== r3.layer;
          s2 && (n2 += "@layer".concat(r3.layer.length > 0 ? " ".concat(r3.layer) : "", " {")), n2 += r3.css, s2 && (n2 += "}"), r3.media && (n2 += "}"), r3.supports && (n2 += "}");
          var i2 = r3.sourceMap;
          i2 && "undefined" != typeof btoa && (n2 += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(i2)))), " */")), t3.styleTagTransform(n2, e4, t3.options);
        })(t2, e3, r2);
      }, remove: function() {
        !(function(e4) {
          if (null === e4.parentNode) return false;
          e4.parentNode.removeChild(e4);
        })(t2);
      } };
    };
  }, 1113(e2) {
    "use strict";
    e2.exports = function(e3, t2) {
      if (t2.styleSheet) t2.styleSheet.cssText = e3;
      else {
        for (; t2.firstChild; ) t2.removeChild(t2.firstChild);
        t2.appendChild(document.createTextNode(e3));
      }
    };
  }, 5793(e2, t2, r2) {
    "use strict";
    r2.d(t2, { createZitadelAuth: () => ue });
    class n2 extends Error {
    }
    function s2(e3) {
      let t3 = e3.replace(/-/g, "+").replace(/_/g, "/");
      switch (t3.length % 4) {
        case 0:
          break;
        case 2:
          t3 += "==";
          break;
        case 3:
          t3 += "=";
          break;
        default:
          throw new Error("base64 string is not of the correct length");
      }
      try {
        return (function(e4) {
          return decodeURIComponent(atob(e4).replace(/(.)/g, (e5, t4) => {
            let r3 = t4.charCodeAt(0).toString(16).toUpperCase();
            return r3.length < 2 && (r3 = "0" + r3), "%" + r3;
          }));
        })(t3);
      } catch (e4) {
        return atob(t3);
      }
    }
    n2.prototype.name = "InvalidTokenError";
    var i2, o2, a, c = { debug: () => {
    }, info: () => {
    }, warn: () => {
    }, error: () => {
    } }, l = ((e3) => (e3[e3.NONE = 0] = "NONE", e3[e3.ERROR = 1] = "ERROR", e3[e3.WARN = 2] = "WARN", e3[e3.INFO = 3] = "INFO", e3[e3.DEBUG = 4] = "DEBUG", e3))(l || {});
    (a = l || (l = {})).reset = function() {
      i2 = 3, o2 = c;
    }, a.setLevel = function(e3) {
      if (!(0 <= e3 && e3 <= 4)) throw new Error("Invalid log level");
      i2 = e3;
    }, a.setLogger = function(e3) {
      o2 = e3;
    };
    var u = class e3 {
      constructor(e4) {
        this._name = e4;
      }
      debug(...t3) {
        i2 >= 4 && o2.debug(e3._format(this._name, this._method), ...t3);
      }
      info(...t3) {
        i2 >= 3 && o2.info(e3._format(this._name, this._method), ...t3);
      }
      warn(...t3) {
        i2 >= 2 && o2.warn(e3._format(this._name, this._method), ...t3);
      }
      error(...t3) {
        i2 >= 1 && o2.error(e3._format(this._name, this._method), ...t3);
      }
      throw(e4) {
        throw this.error(e4), e4;
      }
      create(e4) {
        const t3 = Object.create(this);
        return t3._method = e4, t3.debug("begin"), t3;
      }
      static createStatic(t3, r3) {
        const n3 = new e3(`${t3}.${r3}`);
        return n3.debug("begin"), n3;
      }
      static _format(e4, t3) {
        const r3 = `[${e4}]`;
        return t3 ? `${r3} ${t3}:` : r3;
      }
      static debug(t3, ...r3) {
        i2 >= 4 && o2.debug(e3._format(t3), ...r3);
      }
      static info(t3, ...r3) {
        i2 >= 3 && o2.info(e3._format(t3), ...r3);
      }
      static warn(t3, ...r3) {
        i2 >= 2 && o2.warn(e3._format(t3), ...r3);
      }
      static error(t3, ...r3) {
        i2 >= 1 && o2.error(e3._format(t3), ...r3);
      }
    };
    l.reset();
    var d = class {
      static decode(e3) {
        try {
          return (function(e4, t3) {
            if ("string" != typeof e4) throw new n2("Invalid token specified: must be a string");
            t3 || (t3 = {});
            const r3 = true === t3.header ? 0 : 1, i3 = e4.split(".")[r3];
            if ("string" != typeof i3) throw new n2(`Invalid token specified: missing part #${r3 + 1}`);
            let o3;
            try {
              o3 = s2(i3);
            } catch (e5) {
              throw new n2(`Invalid token specified: invalid base64 for part #${r3 + 1} (${e5.message})`);
            }
            try {
              return JSON.parse(o3);
            } catch (e5) {
              throw new n2(`Invalid token specified: invalid json for part #${r3 + 1} (${e5.message})`);
            }
          })(e3);
        } catch (e4) {
          throw u.error("JwtUtils.decode", e4), e4;
        }
      }
      static async generateSignedJwt(e3, t3, r3) {
        const n3 = `${f.encodeBase64Url(new TextEncoder().encode(JSON.stringify(e3)))}.${f.encodeBase64Url(new TextEncoder().encode(JSON.stringify(t3)))}`, s3 = await window.crypto.subtle.sign({ name: "ECDSA", hash: { name: "SHA-256" } }, r3, new TextEncoder().encode(n3));
        return `${n3}.${f.encodeBase64Url(new Uint8Array(s3))}`;
      }
      static async generateSignedJwtWithHmac(e3, t3, r3) {
        const n3 = `${f.encodeBase64Url(new TextEncoder().encode(JSON.stringify(e3)))}.${f.encodeBase64Url(new TextEncoder().encode(JSON.stringify(t3)))}`, s3 = await window.crypto.subtle.sign("HMAC", r3, new TextEncoder().encode(n3));
        return `${n3}.${f.encodeBase64Url(new Uint8Array(s3))}`;
      }
    }, h = (e3) => btoa([...new Uint8Array(e3)].map((e4) => String.fromCharCode(e4)).join("")), p = class e3 {
      static _randomWord() {
        const e4 = new Uint32Array(1);
        return crypto.getRandomValues(e4), e4[0];
      }
      static generateUUIDv4() {
        return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (t3) => (+t3 ^ e3._randomWord() & 15 >> +t3 / 4).toString(16)).replace(/-/g, "");
      }
      static generateCodeVerifier() {
        return e3.generateUUIDv4() + e3.generateUUIDv4() + e3.generateUUIDv4();
      }
      static async generateCodeChallenge(e4) {
        if (!crypto.subtle) throw new Error("Crypto.subtle is available only in secure contexts (HTTPS).");
        try {
          const t3 = new TextEncoder().encode(e4), r3 = await crypto.subtle.digest("SHA-256", t3);
          return h(r3).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
        } catch (e5) {
          throw u.error("CryptoUtils.generateCodeChallenge", e5), e5;
        }
      }
      static generateBasicAuth(e4, t3) {
        const r3 = new TextEncoder().encode([e4, t3].join(":"));
        return h(r3);
      }
      static async hash(e4, t3) {
        const r3 = new TextEncoder().encode(t3), n3 = await crypto.subtle.digest(e4, r3);
        return new Uint8Array(n3);
      }
      static async customCalculateJwkThumbprint(t3) {
        let r3;
        switch (t3.kty) {
          case "RSA":
            r3 = { e: t3.e, kty: t3.kty, n: t3.n };
            break;
          case "EC":
            r3 = { crv: t3.crv, kty: t3.kty, x: t3.x, y: t3.y };
            break;
          case "OKP":
            r3 = { crv: t3.crv, kty: t3.kty, x: t3.x };
            break;
          case "oct":
            r3 = { crv: t3.k, kty: t3.kty };
            break;
          default:
            throw new Error("Unknown jwk type");
        }
        const n3 = await e3.hash("SHA-256", JSON.stringify(r3));
        return e3.encodeBase64Url(n3);
      }
      static async generateDPoPProof({ url: t3, accessToken: r3, httpMethod: n3, keyPair: s3, nonce: i3 }) {
        let o3, a2;
        const c2 = { jti: window.crypto.randomUUID(), htm: null != n3 ? n3 : "GET", htu: t3, iat: Math.floor(Date.now() / 1e3) };
        r3 && (o3 = await e3.hash("SHA-256", r3), a2 = e3.encodeBase64Url(o3), c2.ath = a2), i3 && (c2.nonce = i3);
        try {
          const e4 = await crypto.subtle.exportKey("jwk", s3.publicKey), t4 = { alg: "ES256", typ: "dpop+jwt", jwk: { crv: e4.crv, kty: e4.kty, x: e4.x, y: e4.y } };
          return await d.generateSignedJwt(t4, c2, s3.privateKey);
        } catch (e4) {
          throw e4 instanceof TypeError ? new Error(`Error exporting dpop public key: ${e4.message}`) : e4;
        }
      }
      static async generateDPoPJkt(t3) {
        try {
          const r3 = await crypto.subtle.exportKey("jwk", t3.publicKey);
          return await e3.customCalculateJwkThumbprint(r3);
        } catch (e4) {
          throw e4 instanceof TypeError ? new Error(`Could not retrieve dpop keys from storage: ${e4.message}`) : e4;
        }
      }
      static async generateDPoPKeys() {
        return await window.crypto.subtle.generateKey({ name: "ECDSA", namedCurve: "P-256" }, false, ["sign", "verify"]);
      }
      static async generateClientAssertionJwt(t3, r3, n3, s3 = "HS256") {
        const i3 = Math.floor(Date.now() / 1e3), o3 = { alg: s3, typ: "JWT" }, a2 = { iss: t3, sub: t3, aud: n3, jti: e3.generateUUIDv4(), exp: i3 + 300, iat: i3 }, c2 = { HS256: "SHA-256", HS384: "SHA-384", HS512: "SHA-512" }[s3];
        if (!c2) throw new Error(`Unsupported algorithm: ${s3}. Supported algorithms are: HS256, HS384, HS512`);
        const l2 = new TextEncoder(), u2 = await crypto.subtle.importKey("raw", l2.encode(r3), { name: "HMAC", hash: c2 }, false, ["sign"]);
        return await d.generateSignedJwtWithHmac(o3, a2, u2);
      }
    };
    p.encodeBase64Url = (e3) => h(e3).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    var f = p, g = class {
      constructor(e3) {
        this._name = e3, this._callbacks = [], this._logger = new u(`Event('${this._name}')`);
      }
      addHandler(e3) {
        return this._callbacks.push(e3), () => this.removeHandler(e3);
      }
      removeHandler(e3) {
        const t3 = this._callbacks.lastIndexOf(e3);
        t3 >= 0 && this._callbacks.splice(t3, 1);
      }
      async raise(...e3) {
        this._logger.debug("raise:", ...e3);
        for (const t3 of this._callbacks) await t3(...e3);
      }
    }, y = class {
      static center({ ...e3 }) {
        var t3;
        return null == e3.width && (e3.width = null != (t3 = [800, 720, 600, 480].find((e4) => e4 <= window.outerWidth / 1.618)) ? t3 : 360), null != e3.left || (e3.left = Math.max(0, Math.round(window.screenX + (window.outerWidth - e3.width) / 2))), null != e3.height && (null != e3.top || (e3.top = Math.max(0, Math.round(window.screenY + (window.outerHeight - e3.height) / 2)))), e3;
      }
      static serialize(e3) {
        return Object.entries(e3).filter(([, e4]) => null != e4).map(([e4, t3]) => `${e4}=${"boolean" != typeof t3 ? t3 : t3 ? "yes" : "no"}`).join(",");
      }
    }, m = class e3 extends g {
      constructor() {
        super(...arguments), this._logger = new u(`Timer('${this._name}')`), this._timerHandle = null, this._expiration = 0, this._callback = () => {
          const t3 = this._expiration - e3.getEpochTime();
          this._logger.debug("timer completes in", t3), this._expiration <= e3.getEpochTime() && (this.cancel(), super.raise());
        };
      }
      static getEpochTime() {
        return Math.floor(Date.now() / 1e3);
      }
      init(t3) {
        const r3 = this._logger.create("init");
        t3 = Math.max(Math.floor(t3), 1);
        const n3 = e3.getEpochTime() + t3;
        if (this.expiration === n3 && this._timerHandle) return void r3.debug("skipping since already initialized for expiration at", this.expiration);
        this.cancel(), r3.debug("using duration", t3), this._expiration = n3;
        const s3 = Math.min(t3, 5);
        this._timerHandle = setInterval(this._callback, 1e3 * s3);
      }
      get expiration() {
        return this._expiration;
      }
      cancel() {
        this._logger.create("cancel"), this._timerHandle && (clearInterval(this._timerHandle), this._timerHandle = null);
      }
    }, _ = class {
      static readParams(e3, t3 = "query") {
        if (!e3) throw new TypeError("Invalid URL");
        const r3 = new URL(e3, "http://127.0.0.1")["fragment" === t3 ? "hash" : "search"];
        return new URLSearchParams(r3.slice(1));
      }
    }, w = ";", v = class extends Error {
      constructor(e3, t3) {
        var r3, n3, s3;
        if (super(e3.error_description || e3.error || ""), this.form = t3, this.name = "ErrorResponse", !e3.error) throw u.error("ErrorResponse", "No error passed"), new Error("No error passed");
        this.error = e3.error, this.error_description = null != (r3 = e3.error_description) ? r3 : null, this.error_uri = null != (n3 = e3.error_uri) ? n3 : null, this.state = e3.userState, this.session_state = null != (s3 = e3.session_state) ? s3 : null, this.url_state = e3.url_state;
      }
    }, b = class extends Error {
      constructor(e3) {
        super(e3), this.name = "ErrorTimeout";
      }
    }, S = class {
      constructor(e3) {
        this._logger = new u("AccessTokenEvents"), this._expiringTimer = new m("Access token expiring"), this._expiredTimer = new m("Access token expired"), this._expiringNotificationTimeInSeconds = e3.expiringNotificationTimeInSeconds;
      }
      async load(e3) {
        const t3 = this._logger.create("load");
        if (e3.access_token && void 0 !== e3.expires_in) {
          const r3 = e3.expires_in;
          if (t3.debug("access token present, remaining duration:", r3), r3 > 0) {
            let e4 = r3 - this._expiringNotificationTimeInSeconds;
            e4 <= 0 && (e4 = 1), t3.debug("registering expiring timer, raising in", e4, "seconds"), this._expiringTimer.init(e4);
          } else t3.debug("canceling existing expiring timer because we're past expiration."), this._expiringTimer.cancel();
          const n3 = r3 + 1;
          t3.debug("registering expired timer, raising in", n3, "seconds"), this._expiredTimer.init(n3);
        } else this._expiringTimer.cancel(), this._expiredTimer.cancel();
      }
      async unload() {
        this._logger.debug("unload: canceling existing access token timers"), this._expiringTimer.cancel(), this._expiredTimer.cancel();
      }
      addAccessTokenExpiring(e3) {
        return this._expiringTimer.addHandler(e3);
      }
      removeAccessTokenExpiring(e3) {
        this._expiringTimer.removeHandler(e3);
      }
      addAccessTokenExpired(e3) {
        return this._expiredTimer.addHandler(e3);
      }
      removeAccessTokenExpired(e3) {
        this._expiredTimer.removeHandler(e3);
      }
    }, k = class {
      constructor(e3, t3, r3, n3, s3) {
        this._callback = e3, this._client_id = t3, this._intervalInSeconds = n3, this._stopOnError = s3, this._logger = new u("CheckSessionIFrame"), this._timer = null, this._session_state = null, this._message = (e4) => {
          e4.origin === this._frame_origin && e4.source === this._frame.contentWindow && ("error" === e4.data ? (this._logger.error("error message from check session op iframe"), this._stopOnError && this.stop()) : "changed" === e4.data ? (this._logger.debug("changed message from check session op iframe"), this.stop(), this._callback()) : this._logger.debug(e4.data + " message from check session op iframe"));
        };
        const i3 = new URL(r3);
        this._frame_origin = i3.origin, this._frame = window.document.createElement("iframe"), this._frame.style.visibility = "hidden", this._frame.style.position = "fixed", this._frame.style.left = "-1000px", this._frame.style.top = "0", this._frame.width = "0", this._frame.height = "0", this._frame.src = i3.href;
      }
      load() {
        return new Promise((e3) => {
          this._frame.onload = () => {
            e3();
          }, window.document.body.appendChild(this._frame), window.addEventListener("message", this._message, false);
        });
      }
      start(e3) {
        if (this._session_state === e3) return;
        this._logger.create("start"), this.stop(), this._session_state = e3;
        const t3 = () => {
          this._frame.contentWindow && this._session_state && this._frame.contentWindow.postMessage(this._client_id + " " + this._session_state, this._frame_origin);
        };
        t3(), this._timer = setInterval(t3, 1e3 * this._intervalInSeconds);
      }
      stop() {
        this._logger.create("stop"), this._session_state = null, this._timer && (clearInterval(this._timer), this._timer = null);
      }
    }, x = class {
      constructor() {
        this._logger = new u("InMemoryWebStorage"), this._data = {};
      }
      clear() {
        this._logger.create("clear"), this._data = {};
      }
      getItem(e3) {
        return this._logger.create(`getItem('${e3}')`), this._data[e3];
      }
      setItem(e3, t3) {
        this._logger.create(`setItem('${e3}')`), this._data[e3] = t3;
      }
      removeItem(e3) {
        this._logger.create(`removeItem('${e3}')`), delete this._data[e3];
      }
      get length() {
        return Object.getOwnPropertyNames(this._data).length;
      }
      key(e3) {
        return Object.getOwnPropertyNames(this._data)[e3];
      }
    }, T = class extends Error {
      constructor(e3, t3) {
        super(t3), this.name = "ErrorDPoPNonce", this.nonce = e3;
      }
    }, E = class {
      constructor(e3 = [], t3 = null, r3 = {}) {
        this._jwtHandler = t3, this._extraHeaders = r3, this._logger = new u("JsonService"), this._contentTypes = [], this._contentTypes.push(...e3, "application/json"), t3 && this._contentTypes.push("application/jwt");
      }
      async fetchWithTimeout(e3, t3 = {}) {
        const { timeoutInSeconds: r3, ...n3 } = t3;
        if (!r3) return await fetch(e3, n3);
        const s3 = new AbortController(), i3 = setTimeout(() => s3.abort(), 1e3 * r3);
        try {
          return await fetch(e3, { ...t3, signal: s3.signal });
        } catch (e4) {
          if (e4 instanceof DOMException && "AbortError" === e4.name) throw new b("Network timed out");
          throw e4;
        } finally {
          clearTimeout(i3);
        }
      }
      async getJson(e3, { token: t3, credentials: r3, timeoutInSeconds: n3 } = {}) {
        const s3 = this._logger.create("getJson"), i3 = { Accept: this._contentTypes.join(", ") };
        let o3;
        t3 && (s3.debug("token passed, setting Authorization header"), i3.Authorization = "Bearer " + t3), this._appendExtraHeaders(i3);
        try {
          s3.debug("url:", e3), o3 = await this.fetchWithTimeout(e3, { method: "GET", headers: i3, timeoutInSeconds: n3, credentials: r3 });
        } catch (e4) {
          throw s3.error("Network Error"), e4;
        }
        s3.debug("HTTP response received, status", o3.status);
        const a2 = o3.headers.get("Content-Type");
        if (a2 && !this._contentTypes.find((e4) => a2.startsWith(e4)) && s3.throw(new Error(`Invalid response Content-Type: ${null != a2 ? a2 : "undefined"}, from URL: ${e3}`)), o3.ok && this._jwtHandler && (null == a2 ? void 0 : a2.startsWith("application/jwt"))) return await this._jwtHandler(await o3.text());
        let c2;
        try {
          c2 = await o3.json();
        } catch (e4) {
          if (s3.error("Error parsing JSON response", e4), o3.ok) throw e4;
          throw new Error(`${o3.statusText} (${o3.status})`);
        }
        if (!o3.ok) {
          if (s3.error("Error from server:", c2), c2.error) throw new v(c2);
          throw new Error(`${o3.statusText} (${o3.status}): ${JSON.stringify(c2)}`);
        }
        return c2;
      }
      async postForm(e3, { body: t3, basicAuth: r3, timeoutInSeconds: n3, initCredentials: s3, extraHeaders: i3 }) {
        const o3 = this._logger.create("postForm"), a2 = { Accept: this._contentTypes.join(", "), "Content-Type": "application/x-www-form-urlencoded", ...i3 };
        let c2;
        void 0 !== r3 && (a2.Authorization = "Basic " + r3), this._appendExtraHeaders(a2);
        try {
          o3.debug("url:", e3), c2 = await this.fetchWithTimeout(e3, { method: "POST", headers: a2, body: t3, timeoutInSeconds: n3, credentials: s3 });
        } catch (e4) {
          throw o3.error("Network error"), e4;
        }
        o3.debug("HTTP response received, status", c2.status);
        const l2 = c2.headers.get("Content-Type");
        if (l2 && !this._contentTypes.find((e4) => l2.startsWith(e4))) throw new Error(`Invalid response Content-Type: ${null != l2 ? l2 : "undefined"}, from URL: ${e3}`);
        const u2 = await c2.text();
        let d2 = {};
        if (u2) try {
          d2 = JSON.parse(u2);
        } catch (e4) {
          if (o3.error("Error parsing JSON response", e4), c2.ok) throw e4;
          throw new Error(`${c2.statusText} (${c2.status})`);
        }
        if (!c2.ok) {
          if (o3.error("Error from server:", d2), c2.headers.has("dpop-nonce")) {
            const e4 = c2.headers.get("dpop-nonce");
            throw new T(e4, `${JSON.stringify(d2)}`);
          }
          if (d2.error) throw new v(d2, t3);
          throw new Error(`${c2.statusText} (${c2.status}): ${JSON.stringify(d2)}`);
        }
        return d2;
      }
      _appendExtraHeaders(e3) {
        const t3 = this._logger.create("appendExtraHeaders"), r3 = Object.keys(this._extraHeaders), n3 = ["accept", "content-type"], s3 = ["authorization"];
        0 !== r3.length && r3.forEach((r4) => {
          if (n3.includes(r4.toLocaleLowerCase())) return void t3.warn("Protected header could not be set", r4, n3);
          if (s3.includes(r4.toLocaleLowerCase()) && Object.keys(e3).includes(r4)) return void t3.warn("Header could not be overridden", r4, s3);
          const i3 = "function" == typeof this._extraHeaders[r4] ? this._extraHeaders[r4]() : this._extraHeaders[r4];
          i3 && "" !== i3 && (e3[r4] = i3);
        });
      }
    }, R = class {
      constructor(e3) {
        this._settings = e3, this._logger = new u("MetadataService"), this._signingKeys = null, this._metadata = null, this._metadataUrl = this._settings.metadataUrl, this._jsonService = new E(["application/jwk-set+json"], null, this._settings.extraHeaders), this._settings.signingKeys && (this._logger.debug("using signingKeys from settings"), this._signingKeys = this._settings.signingKeys), this._settings.metadata && (this._logger.debug("using metadata from settings"), this._metadata = this._settings.metadata), this._settings.fetchRequestCredentials && (this._logger.debug("using fetchRequestCredentials from settings"), this._fetchRequestCredentials = this._settings.fetchRequestCredentials);
      }
      resetSigningKeys() {
        this._signingKeys = null;
      }
      async getMetadata() {
        const e3 = this._logger.create("getMetadata");
        if (this._metadata) return e3.debug("using cached values"), this._metadata;
        if (!this._metadataUrl) throw e3.throw(new Error("No authority or metadataUrl configured on settings")), null;
        e3.debug("getting metadata from", this._metadataUrl);
        const t3 = await this._jsonService.getJson(this._metadataUrl, { credentials: this._fetchRequestCredentials, timeoutInSeconds: this._settings.requestTimeoutInSeconds });
        return e3.debug("merging remote JSON with seed metadata"), this._metadata = Object.assign({}, t3, this._settings.metadataSeed), this._metadata;
      }
      getIssuer() {
        return this._getMetadataProperty("issuer");
      }
      getAuthorizationEndpoint() {
        return this._getMetadataProperty("authorization_endpoint");
      }
      getUserInfoEndpoint() {
        return this._getMetadataProperty("userinfo_endpoint");
      }
      getTokenEndpoint(e3 = true) {
        return this._getMetadataProperty("token_endpoint", e3);
      }
      getCheckSessionIframe() {
        return this._getMetadataProperty("check_session_iframe", true);
      }
      getEndSessionEndpoint() {
        return this._getMetadataProperty("end_session_endpoint", true);
      }
      getRevocationEndpoint(e3 = true) {
        return this._getMetadataProperty("revocation_endpoint", e3);
      }
      getKeysEndpoint(e3 = true) {
        return this._getMetadataProperty("jwks_uri", e3);
      }
      async _getMetadataProperty(e3, t3 = false) {
        const r3 = this._logger.create(`_getMetadataProperty('${e3}')`), n3 = await this.getMetadata();
        if (r3.debug("resolved"), void 0 === n3[e3]) {
          if (true === t3) return void r3.warn("Metadata does not contain optional property");
          r3.throw(new Error("Metadata does not contain property " + e3));
        }
        return n3[e3];
      }
      async getSigningKeys() {
        const e3 = this._logger.create("getSigningKeys");
        if (this._signingKeys) return e3.debug("returning signingKeys from cache"), this._signingKeys;
        const t3 = await this.getKeysEndpoint(false);
        e3.debug("got jwks_uri", t3);
        const r3 = await this._jsonService.getJson(t3, { timeoutInSeconds: this._settings.requestTimeoutInSeconds });
        if (e3.debug("got key set", r3), !Array.isArray(r3.keys)) throw e3.throw(new Error("Missing keys on keyset")), null;
        return this._signingKeys = r3.keys, this._signingKeys;
      }
    }, A = class {
      constructor({ prefix: e3 = "oidc.", store: t3 = localStorage } = {}) {
        this._logger = new u("WebStorageStateStore"), this._store = t3, this._prefix = e3;
      }
      async set(e3, t3) {
        this._logger.create(`set('${e3}')`), e3 = this._prefix + e3, await this._store.setItem(e3, t3);
      }
      async get(e3) {
        this._logger.create(`get('${e3}')`), e3 = this._prefix + e3;
        return await this._store.getItem(e3);
      }
      async remove(e3) {
        this._logger.create(`remove('${e3}')`), e3 = this._prefix + e3;
        const t3 = await this._store.getItem(e3);
        return await this._store.removeItem(e3), t3;
      }
      async getAllKeys() {
        this._logger.create("getAllKeys");
        const e3 = await this._store.length, t3 = [];
        for (let r3 = 0; r3 < e3; r3++) {
          const e4 = await this._store.key(r3);
          e4 && 0 === e4.indexOf(this._prefix) && t3.push(e4.substr(this._prefix.length));
        }
        return t3;
      }
    }, O = class {
      constructor({ authority: e3, metadataUrl: t3, metadata: r3, signingKeys: n3, metadataSeed: s3, client_id: i3, client_secret: o3, response_type: a2 = "code", scope: c2 = "openid", redirect_uri: l2, post_logout_redirect_uri: u2, client_authentication: d2 = "client_secret_post", token_endpoint_auth_signing_alg: h2 = "HS256", prompt: p2, display: f2, max_age: g2, ui_locales: y2, acr_values: m2, resource: _2, response_mode: w2, filterProtocolClaims: v2 = true, loadUserInfo: b2 = false, requestTimeoutInSeconds: S2, staleStateAgeInSeconds: k2 = 900, mergeClaimsStrategy: T2 = { array: "replace" }, disablePKCE: E2 = false, stateStore: R2, revokeTokenAdditionalContentTypes: O2, fetchRequestCredentials: C2, refreshTokenAllowedScope: I2, extraQueryParams: P2 = {}, extraTokenParams: N2 = {}, extraHeaders: j2 = {}, dpop: U2, omitScopeWhenRequesting: L2 = false }) {
        var F2;
        if (this.authority = e3, t3 ? this.metadataUrl = t3 : (this.metadataUrl = e3, e3 && (this.metadataUrl.endsWith("/") || (this.metadataUrl += "/"), this.metadataUrl += ".well-known/openid-configuration")), this.metadata = r3, this.metadataSeed = s3, this.signingKeys = n3, this.client_id = i3, this.client_secret = o3, this.response_type = a2, this.scope = c2, this.redirect_uri = l2, this.post_logout_redirect_uri = u2, this.client_authentication = d2, this.token_endpoint_auth_signing_alg = h2, this.prompt = p2, this.display = f2, this.max_age = g2, this.ui_locales = y2, this.acr_values = m2, this.resource = _2, this.response_mode = w2, this.filterProtocolClaims = null == v2 || v2, this.loadUserInfo = !!b2, this.staleStateAgeInSeconds = k2, this.mergeClaimsStrategy = T2, this.omitScopeWhenRequesting = L2, this.disablePKCE = !!E2, this.revokeTokenAdditionalContentTypes = O2, this.fetchRequestCredentials = C2 || "same-origin", this.requestTimeoutInSeconds = S2, R2) this.stateStore = R2;
        else {
          const e4 = "undefined" != typeof window ? window.localStorage : new x();
          this.stateStore = new A({ store: e4 });
        }
        if (this.refreshTokenAllowedScope = I2, this.extraQueryParams = P2, this.extraTokenParams = N2, this.extraHeaders = j2, this.dpop = U2, this.dpop && !(null == (F2 = this.dpop) ? void 0 : F2.store)) throw new Error("A DPoPStore is required when dpop is enabled");
      }
    }, C = class {
      constructor(e3, t3) {
        this._settings = e3, this._metadataService = t3, this._logger = new u("UserInfoService"), this._getClaimsFromJwt = async (e4) => {
          const t4 = this._logger.create("_getClaimsFromJwt");
          try {
            const r3 = d.decode(e4);
            return t4.debug("JWT decoding successful"), r3;
          } catch (e5) {
            throw t4.error("Error parsing JWT response"), e5;
          }
        }, this._jsonService = new E(void 0, this._getClaimsFromJwt, this._settings.extraHeaders);
      }
      async getClaims(e3) {
        const t3 = this._logger.create("getClaims");
        e3 || this._logger.throw(new Error("No token passed"));
        const r3 = await this._metadataService.getUserInfoEndpoint();
        t3.debug("got userinfo url", r3);
        const n3 = await this._jsonService.getJson(r3, { token: e3, credentials: this._settings.fetchRequestCredentials, timeoutInSeconds: this._settings.requestTimeoutInSeconds });
        return t3.debug("got claims", n3), n3;
      }
    }, I = class {
      constructor(e3, t3) {
        this._settings = e3, this._metadataService = t3, this._logger = new u("TokenClient"), this._jsonService = new E(this._settings.revokeTokenAdditionalContentTypes, null, this._settings.extraHeaders);
      }
      async exchangeCode({ grant_type: e3 = "authorization_code", redirect_uri: t3 = this._settings.redirect_uri, client_id: r3 = this._settings.client_id, client_secret: n3 = this._settings.client_secret, extraHeaders: s3, ...i3 }) {
        const o3 = this._logger.create("exchangeCode");
        r3 || o3.throw(new Error("A client_id is required")), t3 || o3.throw(new Error("A redirect_uri is required")), i3.code || o3.throw(new Error("A code is required"));
        const a2 = new URLSearchParams({ grant_type: e3, redirect_uri: t3 });
        for (const [e4, t4] of Object.entries(i3)) null != t4 && a2.set(e4, t4);
        if (("client_secret_basic" === this._settings.client_authentication || "client_secret_jwt" === this._settings.client_authentication) && null == n3) throw o3.throw(new Error("A client_secret is required")), null;
        let c2;
        const l2 = await this._metadataService.getTokenEndpoint(false);
        switch (this._settings.client_authentication) {
          case "client_secret_basic":
            c2 = f.generateBasicAuth(r3, n3);
            break;
          case "client_secret_post":
            a2.append("client_id", r3), n3 && a2.append("client_secret", n3);
            break;
          case "client_secret_jwt": {
            const e4 = await f.generateClientAssertionJwt(r3, n3, l2, this._settings.token_endpoint_auth_signing_alg);
            a2.append("client_id", r3), a2.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), a2.append("client_assertion", e4);
            break;
          }
        }
        o3.debug("got token endpoint");
        const u2 = await this._jsonService.postForm(l2, { body: a2, basicAuth: c2, timeoutInSeconds: this._settings.requestTimeoutInSeconds, initCredentials: this._settings.fetchRequestCredentials, extraHeaders: s3 });
        return o3.debug("got response"), u2;
      }
      async exchangeCredentials({ grant_type: e3 = "password", client_id: t3 = this._settings.client_id, client_secret: r3 = this._settings.client_secret, scope: n3 = this._settings.scope, ...s3 }) {
        const i3 = this._logger.create("exchangeCredentials");
        t3 || i3.throw(new Error("A client_id is required"));
        const o3 = new URLSearchParams({ grant_type: e3 });
        this._settings.omitScopeWhenRequesting || o3.set("scope", n3);
        for (const [e4, t4] of Object.entries(s3)) null != t4 && o3.set(e4, t4);
        if (("client_secret_basic" === this._settings.client_authentication || "client_secret_jwt" === this._settings.client_authentication) && null == r3) throw i3.throw(new Error("A client_secret is required")), null;
        let a2;
        const c2 = await this._metadataService.getTokenEndpoint(false);
        switch (this._settings.client_authentication) {
          case "client_secret_basic":
            a2 = f.generateBasicAuth(t3, r3);
            break;
          case "client_secret_post":
            o3.append("client_id", t3), r3 && o3.append("client_secret", r3);
            break;
          case "client_secret_jwt": {
            const e4 = await f.generateClientAssertionJwt(t3, r3, c2, this._settings.token_endpoint_auth_signing_alg);
            o3.append("client_id", t3), o3.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), o3.append("client_assertion", e4);
            break;
          }
        }
        i3.debug("got token endpoint");
        const l2 = await this._jsonService.postForm(c2, { body: o3, basicAuth: a2, timeoutInSeconds: this._settings.requestTimeoutInSeconds, initCredentials: this._settings.fetchRequestCredentials });
        return i3.debug("got response"), l2;
      }
      async exchangeRefreshToken({ grant_type: e3 = "refresh_token", client_id: t3 = this._settings.client_id, client_secret: r3 = this._settings.client_secret, timeoutInSeconds: n3, extraHeaders: s3, ...i3 }) {
        const o3 = this._logger.create("exchangeRefreshToken");
        t3 || o3.throw(new Error("A client_id is required")), i3.refresh_token || o3.throw(new Error("A refresh_token is required"));
        const a2 = new URLSearchParams({ grant_type: e3 });
        for (const [e4, t4] of Object.entries(i3)) Array.isArray(t4) ? t4.forEach((t5) => a2.append(e4, t5)) : null != t4 && a2.set(e4, t4);
        if (("client_secret_basic" === this._settings.client_authentication || "client_secret_jwt" === this._settings.client_authentication) && null == r3) throw o3.throw(new Error("A client_secret is required")), null;
        let c2;
        const l2 = await this._metadataService.getTokenEndpoint(false);
        switch (this._settings.client_authentication) {
          case "client_secret_basic":
            c2 = f.generateBasicAuth(t3, r3);
            break;
          case "client_secret_post":
            a2.append("client_id", t3), r3 && a2.append("client_secret", r3);
            break;
          case "client_secret_jwt": {
            const e4 = await f.generateClientAssertionJwt(t3, r3, l2, this._settings.token_endpoint_auth_signing_alg);
            a2.append("client_id", t3), a2.append("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), a2.append("client_assertion", e4);
            break;
          }
        }
        o3.debug("got token endpoint");
        const u2 = await this._jsonService.postForm(l2, { body: a2, basicAuth: c2, timeoutInSeconds: n3, initCredentials: this._settings.fetchRequestCredentials, extraHeaders: s3 });
        return o3.debug("got response"), u2;
      }
      async revoke(e3) {
        var t3;
        const r3 = this._logger.create("revoke");
        e3.token || r3.throw(new Error("A token is required"));
        const n3 = await this._metadataService.getRevocationEndpoint(false);
        r3.debug(`got revocation endpoint, revoking ${null != (t3 = e3.token_type_hint) ? t3 : "default token type"}`);
        const s3 = new URLSearchParams();
        for (const [t4, r4] of Object.entries(e3)) null != r4 && s3.set(t4, r4);
        s3.set("client_id", this._settings.client_id), this._settings.client_secret && s3.set("client_secret", this._settings.client_secret), await this._jsonService.postForm(n3, { body: s3, timeoutInSeconds: this._settings.requestTimeoutInSeconds }), r3.debug("got response");
      }
    }, P = class {
      constructor(e3, t3, r3) {
        this._settings = e3, this._metadataService = t3, this._claimsService = r3, this._logger = new u("ResponseValidator"), this._userInfoService = new C(this._settings, this._metadataService), this._tokenClient = new I(this._settings, this._metadataService);
      }
      async validateSigninResponse(e3, t3, r3) {
        const n3 = this._logger.create("validateSigninResponse");
        this._processSigninState(e3, t3), n3.debug("state processed"), await this._processCode(e3, t3, r3), n3.debug("code processed"), e3.isOpenId && this._validateIdTokenAttributes(e3, "", t3.nonce), n3.debug("tokens validated"), await this._processClaims(e3, null == t3 ? void 0 : t3.skipUserInfo, e3.isOpenId), n3.debug("claims processed");
      }
      async validateCredentialsResponse(e3, t3) {
        const r3 = this._logger.create("validateCredentialsResponse"), n3 = e3.isOpenId && !!e3.id_token;
        n3 && this._validateIdTokenAttributes(e3), r3.debug("tokens validated"), await this._processClaims(e3, t3, n3), r3.debug("claims processed");
      }
      async validateRefreshResponse(e3, t3) {
        const r3 = this._logger.create("validateRefreshResponse");
        e3.userState = t3.data, null != e3.session_state || (e3.session_state = t3.session_state), null != e3.scope || (e3.scope = t3.scope), e3.isOpenId && e3.id_token && (this._validateIdTokenAttributes(e3, t3.id_token), r3.debug("ID Token validated")), e3.id_token || (e3.id_token = t3.id_token, e3.profile = t3.profile);
        const n3 = e3.isOpenId && !!e3.id_token;
        await this._processClaims(e3, false, n3), r3.debug("claims processed");
      }
      validateSignoutResponse(e3, t3) {
        const r3 = this._logger.create("validateSignoutResponse");
        if (t3.id !== e3.state && r3.throw(new Error("State does not match")), r3.debug("state validated"), e3.userState = t3.data, e3.error) throw r3.warn("Response was error", e3.error), new v(e3);
      }
      _processSigninState(e3, t3) {
        const r3 = this._logger.create("_processSigninState");
        if (t3.id !== e3.state && r3.throw(new Error("State does not match")), t3.client_id || r3.throw(new Error("No client_id on state")), t3.authority || r3.throw(new Error("No authority on state")), this._settings.authority !== t3.authority && r3.throw(new Error("authority mismatch on settings vs. signin state")), this._settings.client_id && this._settings.client_id !== t3.client_id && r3.throw(new Error("client_id mismatch on settings vs. signin state")), r3.debug("state validated"), e3.userState = t3.data, e3.url_state = t3.url_state, null != e3.scope || (e3.scope = t3.scope), e3.error) throw r3.warn("Response was error", e3.error), new v(e3);
        t3.code_verifier && !e3.code && r3.throw(new Error("Expected code in response"));
      }
      async _processClaims(e3, t3 = false, r3 = true) {
        const n3 = this._logger.create("_processClaims");
        if (e3.profile = this._claimsService.filterProtocolClaims(e3.profile), t3 || !this._settings.loadUserInfo || !e3.access_token) return void n3.debug("not loading user info");
        n3.debug("loading user info");
        const s3 = await this._userInfoService.getClaims(e3.access_token);
        n3.debug("user info claims received from user info endpoint"), r3 && s3.sub !== e3.profile.sub && n3.throw(new Error("subject from UserInfo response does not match subject in ID Token")), e3.profile = this._claimsService.mergeClaims(e3.profile, this._claimsService.filterProtocolClaims(s3)), n3.debug("user info claims received, updated profile:", e3.profile);
      }
      async _processCode(e3, t3, r3) {
        const n3 = this._logger.create("_processCode");
        if (e3.code) {
          n3.debug("Validating code");
          const s3 = await this._tokenClient.exchangeCode({ client_id: t3.client_id, client_secret: t3.client_secret, code: e3.code, redirect_uri: t3.redirect_uri, code_verifier: t3.code_verifier, extraHeaders: r3, ...t3.extraTokenParams });
          Object.assign(e3, s3);
        } else n3.debug("No code to process");
      }
      _validateIdTokenAttributes(e3, t3, r3) {
        var n3;
        const s3 = this._logger.create("_validateIdTokenAttributes");
        s3.debug("decoding ID Token JWT");
        const i3 = d.decode(null != (n3 = e3.id_token) ? n3 : "");
        if (i3.sub || s3.throw(new Error("ID Token is missing a subject claim")), r3 && i3.nonce !== r3 && s3.throw(new Error("nonce in id_token does not match nonce in client storage")), t3) {
          const e4 = d.decode(t3);
          i3.sub !== e4.sub && s3.throw(new Error("sub in id_token does not match current sub")), i3.auth_time && i3.auth_time !== e4.auth_time && s3.throw(new Error("auth_time in id_token does not match original auth_time")), i3.azp && i3.azp !== e4.azp && s3.throw(new Error("azp in id_token does not match original azp")), !i3.azp && e4.azp && s3.throw(new Error("azp not in id_token, but present in original id_token"));
        }
        e3.profile = i3;
      }
    }, N = class e3 {
      constructor(e4) {
        this.id = e4.id || f.generateUUIDv4(), this.data = e4.data, e4.created && e4.created > 0 ? this.created = e4.created : this.created = m.getEpochTime(), this.request_type = e4.request_type, this.url_state = e4.url_state;
      }
      toStorageString() {
        return new u("State").create("toStorageString"), JSON.stringify({ id: this.id, data: this.data, created: this.created, request_type: this.request_type, url_state: this.url_state });
      }
      static fromStorageString(t3) {
        return u.createStatic("State", "fromStorageString"), Promise.resolve(new e3(JSON.parse(t3)));
      }
      static async clearStaleState(t3, r3) {
        const n3 = u.createStatic("State", "clearStaleState"), s3 = m.getEpochTime() - r3, i3 = await t3.getAllKeys();
        n3.debug("got keys", i3);
        for (let r4 = 0; r4 < i3.length; r4++) {
          const o3 = i3[r4], a2 = await t3.get(o3);
          let c2 = false;
          if (a2) try {
            const t4 = await e3.fromStorageString(a2);
            n3.debug("got item from key:", o3, t4.created), t4.created <= s3 && (c2 = true);
          } catch (e4) {
            n3.error("Error parsing state for key:", o3, e4), c2 = true;
          }
          else n3.debug("no item in storage for key:", o3), c2 = true;
          c2 && (n3.debug("removed item for key:", o3), t3.remove(o3));
        }
      }
    }, j = class e3 extends N {
      constructor(e4) {
        super(e4), this.code_verifier = e4.code_verifier, this.code_challenge = e4.code_challenge, this.authority = e4.authority, this.client_id = e4.client_id, this.redirect_uri = e4.redirect_uri, this.scope = e4.scope, this.client_secret = e4.client_secret, this.extraTokenParams = e4.extraTokenParams, this.response_mode = e4.response_mode, this.skipUserInfo = e4.skipUserInfo, this.nonce = e4.nonce;
      }
      static async create(t3) {
        const r3 = true === t3.code_verifier ? f.generateCodeVerifier() : t3.code_verifier || void 0, n3 = r3 ? await f.generateCodeChallenge(r3) : void 0;
        return new e3({ ...t3, code_verifier: r3, code_challenge: n3 });
      }
      toStorageString() {
        return new u("SigninState").create("toStorageString"), JSON.stringify({ id: this.id, data: this.data, created: this.created, request_type: this.request_type, url_state: this.url_state, code_verifier: this.code_verifier, authority: this.authority, client_id: this.client_id, redirect_uri: this.redirect_uri, scope: this.scope, client_secret: this.client_secret, extraTokenParams: this.extraTokenParams, response_mode: this.response_mode, skipUserInfo: this.skipUserInfo, nonce: this.nonce });
      }
      static fromStorageString(t3) {
        u.createStatic("SigninState", "fromStorageString");
        const r3 = JSON.parse(t3);
        return e3.create(r3);
      }
    }, U = class e3 {
      constructor(e4) {
        this.url = e4.url, this.state = e4.state;
      }
      static async create({ url: t3, authority: r3, client_id: n3, redirect_uri: s3, response_type: i3, scope: o3, state_data: a2, response_mode: c2, request_type: l2, client_secret: u2, nonce: d2, url_state: h2, resource: p2, skipUserInfo: f2, extraQueryParams: g2, extraTokenParams: y2, disablePKCE: m2, dpopJkt: _2, omitScopeWhenRequesting: v2, ...b2 }) {
        if (!t3) throw this._logger.error("create: No url passed"), new Error("url");
        if (!n3) throw this._logger.error("create: No client_id passed"), new Error("client_id");
        if (!s3) throw this._logger.error("create: No redirect_uri passed"), new Error("redirect_uri");
        if (!i3) throw this._logger.error("create: No response_type passed"), new Error("response_type");
        if (!o3) throw this._logger.error("create: No scope passed"), new Error("scope");
        if (!r3) throw this._logger.error("create: No authority passed"), new Error("authority");
        const S2 = await j.create({ data: a2, request_type: l2, url_state: h2, code_verifier: !m2, client_id: n3, authority: r3, redirect_uri: s3, response_mode: c2, client_secret: u2, scope: o3, extraTokenParams: y2, skipUserInfo: f2, nonce: d2 }), k2 = new URL(t3);
        k2.searchParams.append("client_id", n3), k2.searchParams.append("redirect_uri", s3), k2.searchParams.append("response_type", i3), v2 || k2.searchParams.append("scope", o3), d2 && k2.searchParams.append("nonce", d2), _2 && k2.searchParams.append("dpop_jkt", _2);
        let x2 = S2.id;
        if (h2 && (x2 = `${x2}${w}${h2}`), k2.searchParams.append("state", x2), S2.code_challenge && (k2.searchParams.append("code_challenge", S2.code_challenge), k2.searchParams.append("code_challenge_method", "S256")), p2) {
          (Array.isArray(p2) ? p2 : [p2]).forEach((e4) => k2.searchParams.append("resource", e4));
        }
        for (const [e4, t4] of Object.entries({ response_mode: c2, ...b2, ...g2 })) null != t4 && k2.searchParams.append(e4, t4.toString());
        return new e3({ url: k2.href, state: S2 });
      }
    };
    U._logger = new u("SigninRequest");
    var L = U, F = class {
      constructor(e3) {
        if (this.access_token = "", this.token_type = "", this.profile = {}, this.state = e3.get("state"), this.session_state = e3.get("session_state"), this.state) {
          const e4 = decodeURIComponent(this.state).split(w);
          this.state = e4[0], e4.length > 1 && (this.url_state = e4.slice(1).join(w));
        }
        this.error = e3.get("error"), this.error_description = e3.get("error_description"), this.error_uri = e3.get("error_uri"), this.code = e3.get("code");
      }
      get expires_in() {
        if (void 0 !== this.expires_at) return this.expires_at - m.getEpochTime();
      }
      set expires_in(e3) {
        "string" == typeof e3 && (e3 = Number(e3)), void 0 !== e3 && e3 >= 0 && (this.expires_at = Math.floor(e3) + m.getEpochTime());
      }
      get isOpenId() {
        var e3;
        return (null == (e3 = this.scope) ? void 0 : e3.split(" ").includes("openid")) || !!this.id_token;
      }
    }, M = class {
      constructor({ url: e3, state_data: t3, id_token_hint: r3, post_logout_redirect_uri: n3, extraQueryParams: s3, request_type: i3, client_id: o3, url_state: a2 }) {
        if (this._logger = new u("SignoutRequest"), !e3) throw this._logger.error("ctor: No url passed"), new Error("url");
        const c2 = new URL(e3);
        if (r3 && c2.searchParams.append("id_token_hint", r3), o3 && c2.searchParams.append("client_id", o3), n3 && (c2.searchParams.append("post_logout_redirect_uri", n3), t3 || a2)) {
          this.state = new N({ data: t3, request_type: i3, url_state: a2 });
          let e4 = this.state.id;
          a2 && (e4 = `${e4}${w}${a2}`), c2.searchParams.append("state", e4);
        }
        for (const [e4, t4] of Object.entries({ ...s3 })) null != t4 && c2.searchParams.append(e4, t4.toString());
        this.url = c2.href;
      }
    }, D = class {
      constructor(e3) {
        if (this.state = e3.get("state"), this.state) {
          const e4 = decodeURIComponent(this.state).split(w);
          this.state = e4[0], e4.length > 1 && (this.url_state = e4.slice(1).join(w));
        }
        this.error = e3.get("error"), this.error_description = e3.get("error_description"), this.error_uri = e3.get("error_uri");
      }
    }, q = ["nbf", "jti", "auth_time", "nonce", "acr", "amr", "azp", "at_hash"], $ = ["sub", "iss", "aud", "exp", "iat"], B = class {
      constructor(e3) {
        this._settings = e3, this._logger = new u("ClaimsService");
      }
      filterProtocolClaims(e3) {
        const t3 = { ...e3 };
        if (this._settings.filterProtocolClaims) {
          let e4;
          e4 = Array.isArray(this._settings.filterProtocolClaims) ? this._settings.filterProtocolClaims : q;
          for (const r3 of e4) $.includes(r3) || delete t3[r3];
        }
        return t3;
      }
      mergeClaims(e3, t3) {
        const r3 = { ...e3 };
        for (const [e4, n3] of Object.entries(t3)) if (r3[e4] !== n3) if (Array.isArray(r3[e4]) || Array.isArray(n3)) if ("replace" == this._settings.mergeClaimsStrategy.array) r3[e4] = n3;
        else {
          const t4 = Array.isArray(r3[e4]) ? r3[e4] : [r3[e4]];
          for (const e5 of Array.isArray(n3) ? n3 : [n3]) t4.includes(e5) || t4.push(e5);
          r3[e4] = t4;
        }
        else "object" == typeof r3[e4] && "object" == typeof n3 ? r3[e4] = this.mergeClaims(r3[e4], n3) : r3[e4] = n3;
        return r3;
      }
    }, z = class {
      constructor(e3, t3) {
        this.keys = e3, this.nonce = t3;
      }
    }, H = class {
      constructor(e3, t3) {
        this._logger = new u("OidcClient"), this.settings = e3 instanceof O ? e3 : new O(e3), this.metadataService = null != t3 ? t3 : new R(this.settings), this._claimsService = new B(this.settings), this._validator = new P(this.settings, this.metadataService, this._claimsService), this._tokenClient = new I(this.settings, this.metadataService);
      }
      async createSigninRequest({ state: e3, request: t3, request_uri: r3, request_type: n3, id_token_hint: s3, login_hint: i3, skipUserInfo: o3, nonce: a2, url_state: c2, response_type: l2 = this.settings.response_type, scope: u2 = this.settings.scope, redirect_uri: d2 = this.settings.redirect_uri, prompt: h2 = this.settings.prompt, display: p2 = this.settings.display, max_age: f2 = this.settings.max_age, ui_locales: g2 = this.settings.ui_locales, acr_values: y2 = this.settings.acr_values, resource: m2 = this.settings.resource, response_mode: _2 = this.settings.response_mode, extraQueryParams: w2 = this.settings.extraQueryParams, extraTokenParams: v2 = this.settings.extraTokenParams, dpopJkt: b2, omitScopeWhenRequesting: S2 = this.settings.omitScopeWhenRequesting }) {
        const k2 = this._logger.create("createSigninRequest");
        if ("code" !== l2) throw new Error("Only the Authorization Code flow (with PKCE) is supported");
        const x2 = await this.metadataService.getAuthorizationEndpoint();
        k2.debug("Received authorization endpoint", x2);
        const T2 = await L.create({ url: x2, authority: this.settings.authority, client_id: this.settings.client_id, redirect_uri: d2, response_type: l2, scope: u2, state_data: e3, url_state: c2, prompt: h2, display: p2, max_age: f2, ui_locales: g2, id_token_hint: s3, login_hint: i3, acr_values: y2, dpopJkt: b2, resource: m2, request: t3, request_uri: r3, extraQueryParams: w2, extraTokenParams: v2, request_type: n3, response_mode: _2, client_secret: this.settings.client_secret, skipUserInfo: o3, nonce: a2, disablePKCE: this.settings.disablePKCE, omitScopeWhenRequesting: S2 });
        await this.clearStaleState();
        const E2 = T2.state;
        return await this.settings.stateStore.set(E2.id, E2.toStorageString()), T2;
      }
      async readSigninResponseState(e3, t3 = false) {
        const r3 = this._logger.create("readSigninResponseState"), n3 = new F(_.readParams(e3, this.settings.response_mode));
        if (!n3.state) throw r3.throw(new Error("No state in response")), null;
        const s3 = await this.settings.stateStore[t3 ? "remove" : "get"](n3.state);
        if (!s3) throw r3.throw(new Error("No matching state found in storage")), null;
        return { state: await j.fromStorageString(s3), response: n3 };
      }
      async processSigninResponse(e3, t3, r3 = true) {
        const n3 = this._logger.create("processSigninResponse"), { state: s3, response: i3 } = await this.readSigninResponseState(e3, r3);
        if (n3.debug("received state from storage; validating response"), this.settings.dpop && this.settings.dpop.store) {
          const e4 = await this.getDpopProof(this.settings.dpop.store);
          t3 = { ...t3, DPoP: e4 };
        }
        try {
          await this._validator.validateSigninResponse(i3, s3, t3);
        } catch (e4) {
          if (!(e4 instanceof T && this.settings.dpop)) throw e4;
          {
            const r4 = await this.getDpopProof(this.settings.dpop.store, e4.nonce);
            t3.DPoP = r4, await this._validator.validateSigninResponse(i3, s3, t3);
          }
        }
        return i3;
      }
      async getDpopProof(e3, t3) {
        let r3, n3;
        return (await e3.getAllKeys()).includes(this.settings.client_id) ? (n3 = await e3.get(this.settings.client_id), n3.nonce !== t3 && t3 && (n3.nonce = t3, await e3.set(this.settings.client_id, n3))) : (r3 = await f.generateDPoPKeys(), n3 = new z(r3, t3), await e3.set(this.settings.client_id, n3)), await f.generateDPoPProof({ url: await this.metadataService.getTokenEndpoint(false), httpMethod: "POST", keyPair: n3.keys, nonce: n3.nonce });
      }
      async processResourceOwnerPasswordCredentials({ username: e3, password: t3, skipUserInfo: r3 = false, extraTokenParams: n3 = {} }) {
        const s3 = await this._tokenClient.exchangeCredentials({ username: e3, password: t3, ...n3 }), i3 = new F(new URLSearchParams());
        return Object.assign(i3, s3), await this._validator.validateCredentialsResponse(i3, r3), i3;
      }
      async useRefreshToken({ state: e3, redirect_uri: t3, resource: r3, timeoutInSeconds: n3, extraHeaders: s3, extraTokenParams: i3 }) {
        var o3;
        const a2 = this._logger.create("useRefreshToken");
        let c2, l2;
        if (void 0 === this.settings.refreshTokenAllowedScope) c2 = e3.scope;
        else {
          const t4 = this.settings.refreshTokenAllowedScope.split(" ");
          c2 = ((null == (o3 = e3.scope) ? void 0 : o3.split(" ")) || []).filter((e4) => t4.includes(e4)).join(" ");
        }
        if (this.settings.dpop && this.settings.dpop.store) {
          const e4 = await this.getDpopProof(this.settings.dpop.store);
          s3 = { ...s3, DPoP: e4 };
        }
        try {
          l2 = await this._tokenClient.exchangeRefreshToken({ refresh_token: e3.refresh_token, scope: c2, redirect_uri: t3, resource: r3, timeoutInSeconds: n3, extraHeaders: s3, ...i3 });
        } catch (o4) {
          if (!(o4 instanceof T && this.settings.dpop)) throw o4;
          s3.DPoP = await this.getDpopProof(this.settings.dpop.store, o4.nonce), l2 = await this._tokenClient.exchangeRefreshToken({ refresh_token: e3.refresh_token, scope: c2, redirect_uri: t3, resource: r3, timeoutInSeconds: n3, extraHeaders: s3, ...i3 });
        }
        const u2 = new F(new URLSearchParams());
        return Object.assign(u2, l2), a2.debug("validating response", u2), await this._validator.validateRefreshResponse(u2, { ...e3, scope: c2 }), u2;
      }
      async createSignoutRequest({ state: e3, id_token_hint: t3, client_id: r3, request_type: n3, url_state: s3, post_logout_redirect_uri: i3 = this.settings.post_logout_redirect_uri, extraQueryParams: o3 = this.settings.extraQueryParams } = {}) {
        const a2 = this._logger.create("createSignoutRequest"), c2 = await this.metadataService.getEndSessionEndpoint();
        if (!c2) throw a2.throw(new Error("No end session endpoint")), null;
        a2.debug("Received end session endpoint", c2), r3 || !i3 || t3 || (r3 = this.settings.client_id);
        const l2 = new M({ url: c2, id_token_hint: t3, client_id: r3, post_logout_redirect_uri: i3, state_data: e3, extraQueryParams: o3, request_type: n3, url_state: s3 });
        await this.clearStaleState();
        const u2 = l2.state;
        return u2 && (a2.debug("Signout request has state to persist"), await this.settings.stateStore.set(u2.id, u2.toStorageString())), l2;
      }
      async readSignoutResponseState(e3, t3 = false) {
        const r3 = this._logger.create("readSignoutResponseState"), n3 = new D(_.readParams(e3, this.settings.response_mode));
        if (!n3.state) {
          if (r3.debug("No state in response"), n3.error) throw r3.warn("Response was error:", n3.error), new v(n3);
          return { state: void 0, response: n3 };
        }
        const s3 = await this.settings.stateStore[t3 ? "remove" : "get"](n3.state);
        if (!s3) throw r3.throw(new Error("No matching state found in storage")), null;
        return { state: await N.fromStorageString(s3), response: n3 };
      }
      async processSignoutResponse(e3) {
        const t3 = this._logger.create("processSignoutResponse"), { state: r3, response: n3 } = await this.readSignoutResponseState(e3, true);
        return r3 ? (t3.debug("Received state from storage; validating response"), this._validator.validateSignoutResponse(n3, r3)) : t3.debug("No state from storage; skipping response validation"), n3;
      }
      clearStaleState() {
        return this._logger.create("clearStaleState"), N.clearStaleState(this.settings.stateStore, this.settings.staleStateAgeInSeconds);
      }
      async revokeToken(e3, t3) {
        return this._logger.create("revokeToken"), await this._tokenClient.revoke({ token: e3, token_type_hint: t3 });
      }
    }, K = class {
      constructor(e3) {
        this._userManager = e3, this._logger = new u("SessionMonitor"), this._start = async (e4) => {
          const t3 = e4.session_state;
          if (!t3) return;
          const r3 = this._logger.create("_start");
          if (e4.profile ? (this._sub = e4.profile.sub, r3.debug("session_state", t3, ", sub", this._sub)) : (this._sub = void 0, r3.debug("session_state", t3, ", anonymous user")), this._checkSessionIFrame) this._checkSessionIFrame.start(t3);
          else try {
            const e5 = await this._userManager.metadataService.getCheckSessionIframe();
            if (e5) {
              r3.debug("initializing check session iframe");
              const n3 = this._userManager.settings.client_id, s3 = this._userManager.settings.checkSessionIntervalInSeconds, i3 = this._userManager.settings.stopCheckSessionOnError, o3 = new k(this._callback, n3, e5, s3, i3);
              await o3.load(), this._checkSessionIFrame = o3, o3.start(t3);
            } else r3.warn("no check session iframe found in the metadata");
          } catch (e5) {
            r3.error("Error from getCheckSessionIframe:", e5 instanceof Error ? e5.message : e5);
          }
        }, this._stop = () => {
          const e4 = this._logger.create("_stop");
          if (this._sub = void 0, this._checkSessionIFrame && this._checkSessionIFrame.stop(), this._userManager.settings.monitorAnonymousSession) {
            const t3 = setInterval(async () => {
              clearInterval(t3);
              try {
                const e5 = await this._userManager.querySessionStatus();
                if (e5) {
                  const t4 = { session_state: e5.session_state, profile: e5.sub ? { sub: e5.sub } : null };
                  this._start(t4);
                }
              } catch (t4) {
                e4.error("error from querySessionStatus", t4 instanceof Error ? t4.message : t4);
              }
            }, 1e3);
          }
        }, this._callback = async () => {
          const e4 = this._logger.create("_callback");
          try {
            const t3 = await this._userManager.querySessionStatus();
            let r3 = true;
            t3 && this._checkSessionIFrame ? t3.sub === this._sub ? (r3 = false, this._checkSessionIFrame.start(t3.session_state), e4.debug("same sub still logged in at OP, session state has changed, restarting check session iframe; session_state", t3.session_state), await this._userManager.events._raiseUserSessionChanged()) : e4.debug("different subject signed into OP", t3.sub) : e4.debug("subject no longer signed into OP"), r3 ? this._sub ? await this._userManager.events._raiseUserSignedOut() : await this._userManager.events._raiseUserSignedIn() : e4.debug("no change in session detected, no event to raise");
          } catch (t3) {
            this._sub && (e4.debug("Error calling queryCurrentSigninSession; raising signed out event", t3), await this._userManager.events._raiseUserSignedOut());
          }
        }, e3 || this._logger.throw(new Error("No user manager passed")), this._userManager.events.addUserLoaded(this._start), this._userManager.events.addUserUnloaded(this._stop), this._init().catch((e4) => {
          this._logger.error(e4);
        });
      }
      async _init() {
        this._logger.create("_init");
        const e3 = await this._userManager.getUser();
        if (e3) this._start(e3);
        else if (this._userManager.settings.monitorAnonymousSession) {
          const e4 = await this._userManager.querySessionStatus();
          if (e4) {
            const t3 = { session_state: e4.session_state, profile: e4.sub ? { sub: e4.sub } : null };
            this._start(t3);
          }
        }
      }
    }, V = class e3 {
      constructor(e4) {
        var t3;
        this.id_token = e4.id_token, this.session_state = null != (t3 = e4.session_state) ? t3 : null, this.access_token = e4.access_token, this.refresh_token = e4.refresh_token, this.token_type = e4.token_type, this.scope = e4.scope, this.profile = e4.profile, this.expires_at = e4.expires_at, this.state = e4.userState, this.url_state = e4.url_state;
      }
      get expires_in() {
        if (void 0 !== this.expires_at) return this.expires_at - m.getEpochTime();
      }
      set expires_in(e4) {
        void 0 !== e4 && (this.expires_at = Math.floor(e4) + m.getEpochTime());
      }
      get expired() {
        const e4 = this.expires_in;
        if (void 0 !== e4) return e4 <= 0;
      }
      get scopes() {
        var e4, t3;
        return null != (t3 = null == (e4 = this.scope) ? void 0 : e4.split(" ")) ? t3 : [];
      }
      toStorageString() {
        return new u("User").create("toStorageString"), JSON.stringify({ id_token: this.id_token, session_state: this.session_state, access_token: this.access_token, refresh_token: this.refresh_token, token_type: this.token_type, scope: this.scope, profile: this.profile, expires_at: this.expires_at });
      }
      static fromStorageString(t3) {
        return u.createStatic("User", "fromStorageString"), new e3(JSON.parse(t3));
      }
    }, W = "oidc-client", Z = class {
      constructor() {
        this._abort = new g("Window navigation aborted"), this._disposeHandlers = /* @__PURE__ */ new Set(), this._window = null;
      }
      async navigate(e3) {
        const t3 = this._logger.create("navigate");
        if (!this._window) throw new Error("Attempted to navigate on a disposed window");
        t3.debug("setting URL in window"), this._window.location.replace(e3.url);
        const { url: r3, keepOpen: n3 } = await new Promise((r4, n4) => {
          const s3 = (s4) => {
            var i4;
            const o3 = s4.data, a2 = null != (i4 = e3.scriptOrigin) ? i4 : window.location.origin;
            if (s4.origin === a2 && (null == o3 ? void 0 : o3.source) === W) {
              try {
                const r5 = _.readParams(o3.url, e3.response_mode).get("state");
                if (r5 || t3.warn("no state found in response url"), s4.source !== this._window && r5 !== e3.state) return;
              } catch {
                this._dispose(), n4(new Error("Invalid response from window"));
              }
              r4(o3);
            }
          };
          window.addEventListener("message", s3, false), this._disposeHandlers.add(() => window.removeEventListener("message", s3, false));
          const i3 = new BroadcastChannel(`oidc-client-popup-${e3.state}`);
          i3.addEventListener("message", s3, false), this._disposeHandlers.add(() => i3.close()), this._disposeHandlers.add(this._abort.addHandler((e4) => {
            this._dispose(), n4(e4);
          }));
        });
        return t3.debug("got response from window"), this._dispose(), n3 || this.close(), { url: r3 };
      }
      _dispose() {
        this._logger.create("_dispose");
        for (const e3 of this._disposeHandlers) e3();
        this._disposeHandlers.clear();
      }
      static _notifyParent(e3, t3, r3 = false, n3 = window.location.origin) {
        const s3 = { source: W, url: t3, keepOpen: r3 }, i3 = new u("_notifyParent");
        if (e3) i3.debug("With parent. Using parent.postMessage."), e3.postMessage(s3, n3);
        else {
          i3.debug("No parent. Using BroadcastChannel.");
          const e4 = new URL(t3).searchParams.get("state");
          if (!e4) throw new Error("No parent and no state in URL. Can't complete notification.");
          const r4 = new BroadcastChannel(`oidc-client-popup-${e4}`);
          r4.postMessage(s3), r4.close();
        }
      }
    }, J = { location: false, toolbar: false, height: 640, closePopupWindowAfterInSeconds: -1 }, G = "_blank", X = 60, Q = 2, Y = class extends O {
      constructor(e3) {
        const { popup_redirect_uri: t3 = e3.redirect_uri, popup_post_logout_redirect_uri: r3 = e3.post_logout_redirect_uri, popupWindowFeatures: n3 = J, popupWindowTarget: s3 = G, redirectMethod: i3 = "assign", redirectTarget: o3 = "self", iframeNotifyParentOrigin: a2 = e3.iframeNotifyParentOrigin, iframeScriptOrigin: c2 = e3.iframeScriptOrigin, requestTimeoutInSeconds: l2, silent_redirect_uri: u2 = e3.redirect_uri, silentRequestTimeoutInSeconds: d2, automaticSilentRenew: h2 = true, validateSubOnSilentRenew: p2 = true, includeIdTokenInSilentRenew: f2 = false, monitorSession: g2 = false, monitorAnonymousSession: y2 = false, checkSessionIntervalInSeconds: m2 = Q, query_status_response_type: _2 = "code", stopCheckSessionOnError: w2 = true, revokeTokenTypes: v2 = ["access_token", "refresh_token"], revokeTokensOnSignout: b2 = false, includeIdTokenInSilentSignout: S2 = false, accessTokenExpiringNotificationTimeInSeconds: k2 = X, maxSilentRenewTimeoutRetries: T2, userStore: E2 } = e3;
        if (super(e3), this.popup_redirect_uri = t3, this.popup_post_logout_redirect_uri = r3, this.popupWindowFeatures = n3, this.popupWindowTarget = s3, this.redirectMethod = i3, this.redirectTarget = o3, this.iframeNotifyParentOrigin = a2, this.iframeScriptOrigin = c2, this.silent_redirect_uri = u2, this.silentRequestTimeoutInSeconds = d2 || l2 || 10, this.automaticSilentRenew = h2, this.validateSubOnSilentRenew = p2, this.includeIdTokenInSilentRenew = f2, this.monitorSession = g2, this.monitorAnonymousSession = y2, this.checkSessionIntervalInSeconds = m2, this.stopCheckSessionOnError = w2, this.query_status_response_type = _2, this.revokeTokenTypes = v2, this.revokeTokensOnSignout = b2, this.includeIdTokenInSilentSignout = S2, this.accessTokenExpiringNotificationTimeInSeconds = k2, this.maxSilentRenewTimeoutRetries = T2, E2) this.userStore = E2;
        else {
          const e4 = "undefined" != typeof window ? window.sessionStorage : new x();
          this.userStore = new A({ store: e4 });
        }
      }
    }, ee = class e3 extends Z {
      constructor({ silentRequestTimeoutInSeconds: t3 = 10 }) {
        super(), this._logger = new u("IFrameWindow"), this._timeoutInSeconds = t3, this._frame = e3.createHiddenIframe(), this._window = this._frame.contentWindow;
      }
      static createHiddenIframe() {
        const e4 = window.document.createElement("iframe");
        return e4.style.visibility = "hidden", e4.style.position = "fixed", e4.style.left = "-1000px", e4.style.top = "0", e4.width = "0", e4.height = "0", window.document.body.appendChild(e4), e4;
      }
      async navigate(e4) {
        this._logger.debug("navigate: Using timeout of:", this._timeoutInSeconds);
        const t3 = setTimeout(() => {
          this._abort.raise(new b("IFrame timed out without a response"));
        }, 1e3 * this._timeoutInSeconds);
        return this._disposeHandlers.add(() => clearTimeout(t3)), await super.navigate(e4);
      }
      close() {
        var e4;
        this._frame && (this._frame.parentNode && (this._frame.addEventListener("load", (e5) => {
          var t3;
          const r3 = e5.target;
          null == (t3 = r3.parentNode) || t3.removeChild(r3), this._abort.raise(new Error("IFrame removed from DOM"));
        }, true), null == (e4 = this._frame.contentWindow) || e4.location.replace("about:blank")), this._frame = null), this._window = null;
      }
      static notifyParent(e4, t3) {
        return super._notifyParent(window.parent, e4, false, t3);
      }
    }, te = class {
      constructor(e3) {
        this._settings = e3, this._logger = new u("IFrameNavigator");
      }
      async prepare({ silentRequestTimeoutInSeconds: e3 = this._settings.silentRequestTimeoutInSeconds }) {
        return new ee({ silentRequestTimeoutInSeconds: e3 });
      }
      async callback(e3) {
        this._logger.create("callback"), ee.notifyParent(e3, this._settings.iframeNotifyParentOrigin);
      }
    }, re = class extends Z {
      constructor({ popupWindowTarget: e3 = G, popupWindowFeatures: t3 = {}, popupSignal: r3, popupAbortOnClose: n3 }) {
        super(), this._logger = new u("PopupWindow");
        const s3 = y.center({ ...J, ...t3 });
        this._window = window.open(void 0, e3, y.serialize(s3)), this.abortOnClose = Boolean(n3), r3 && r3.addEventListener("abort", () => {
          var e4;
          this._abort.raise(new Error(null != (e4 = r3.reason) ? e4 : "Popup aborted"));
        }), t3.closePopupWindowAfterInSeconds && t3.closePopupWindowAfterInSeconds > 0 && setTimeout(() => {
          this._window && "boolean" == typeof this._window.closed && !this._window.closed ? this.close() : this._abort.raise(new Error("Popup blocked by user"));
        }, 1e3 * t3.closePopupWindowAfterInSeconds);
      }
      async navigate(e3) {
        var t3;
        null == (t3 = this._window) || t3.focus();
        const r3 = setInterval(() => {
          this._window && !this._window.closed || (this._logger.debug("Popup closed by user or isolated by redirect"), n3(), this._disposeHandlers.delete(n3), this.abortOnClose && this._abort.raise(new Error("Popup closed by user")));
        }, 500), n3 = () => clearInterval(r3);
        return this._disposeHandlers.add(n3), await super.navigate(e3);
      }
      close() {
        this._window && (this._window.closed || (this._window.close(), this._abort.raise(new Error("Popup closed")))), this._window = null;
      }
      static notifyOpener(e3, t3) {
        super._notifyParent(window.opener, e3, t3), t3 || window.opener || window.close();
      }
    }, ne = class {
      constructor(e3) {
        this._settings = e3, this._logger = new u("PopupNavigator");
      }
      async prepare({ popupWindowFeatures: e3 = this._settings.popupWindowFeatures, popupWindowTarget: t3 = this._settings.popupWindowTarget, popupSignal: r3, popupAbortOnClose: n3 }) {
        return new re({ popupWindowFeatures: e3, popupWindowTarget: t3, popupSignal: r3, popupAbortOnClose: n3 });
      }
      async callback(e3, { keepOpen: t3 = false }) {
        this._logger.create("callback"), re.notifyOpener(e3, t3);
      }
    }, se = class {
      constructor(e3) {
        this._settings = e3, this._logger = new u("RedirectNavigator");
      }
      async prepare({ redirectMethod: e3 = this._settings.redirectMethod, redirectTarget: t3 = this._settings.redirectTarget }) {
        var r3;
        this._logger.create("prepare");
        let n3 = window.self;
        "top" === t3 && (n3 = null != (r3 = window.top) ? r3 : window.self);
        const s3 = n3.location[e3].bind(n3.location);
        let i3;
        return { navigate: async (e4) => {
          this._logger.create("navigate");
          const t4 = new Promise((t5, r4) => {
            i3 = r4, window.addEventListener("pageshow", () => t5(window.location.href)), s3(e4.url);
          });
          return await t4;
        }, close: () => {
          this._logger.create("close"), null == i3 || i3(new Error("Redirect aborted")), n3.stop();
        } };
      }
      async callback() {
      }
    }, ie = class extends S {
      constructor(e3) {
        super({ expiringNotificationTimeInSeconds: e3.accessTokenExpiringNotificationTimeInSeconds }), this._logger = new u("UserManagerEvents"), this._userLoaded = new g("User loaded"), this._userUnloaded = new g("User unloaded"), this._silentRenewError = new g("Silent renew error"), this._userSignedIn = new g("User signed in"), this._userSignedOut = new g("User signed out"), this._userSessionChanged = new g("User session changed");
      }
      async load(e3, t3 = true) {
        await super.load(e3), t3 && await this._userLoaded.raise(e3);
      }
      async unload() {
        await super.unload(), await this._userUnloaded.raise();
      }
      addUserLoaded(e3) {
        return this._userLoaded.addHandler(e3);
      }
      removeUserLoaded(e3) {
        return this._userLoaded.removeHandler(e3);
      }
      addUserUnloaded(e3) {
        return this._userUnloaded.addHandler(e3);
      }
      removeUserUnloaded(e3) {
        return this._userUnloaded.removeHandler(e3);
      }
      addSilentRenewError(e3) {
        return this._silentRenewError.addHandler(e3);
      }
      removeSilentRenewError(e3) {
        return this._silentRenewError.removeHandler(e3);
      }
      async _raiseSilentRenewError(e3) {
        await this._silentRenewError.raise(e3);
      }
      addUserSignedIn(e3) {
        return this._userSignedIn.addHandler(e3);
      }
      removeUserSignedIn(e3) {
        this._userSignedIn.removeHandler(e3);
      }
      async _raiseUserSignedIn() {
        await this._userSignedIn.raise();
      }
      addUserSignedOut(e3) {
        return this._userSignedOut.addHandler(e3);
      }
      removeUserSignedOut(e3) {
        this._userSignedOut.removeHandler(e3);
      }
      async _raiseUserSignedOut() {
        await this._userSignedOut.raise();
      }
      addUserSessionChanged(e3) {
        return this._userSessionChanged.addHandler(e3);
      }
      removeUserSessionChanged(e3) {
        this._userSessionChanged.removeHandler(e3);
      }
      async _raiseUserSessionChanged() {
        await this._userSessionChanged.raise();
      }
    }, oe = class {
      constructor(e3) {
        this._userManager = e3, this._logger = new u("SilentRenewService"), this._isStarted = false, this._retryTimer = new m("Retry Silent Renew"), this._timeoutRetryCount = 0, this._tokenExpiring = async () => {
          const e4 = this._logger.create("_tokenExpiring");
          try {
            await this._userManager.signinSilent(), this._timeoutRetryCount = 0, e4.debug("silent token renewal successful");
          } catch (t3) {
            if (t3 instanceof b) {
              this._timeoutRetryCount++;
              const r3 = this._userManager.settings.maxSilentRenewTimeoutRetries;
              return void 0 !== r3 && this._timeoutRetryCount > r3 ? (e4.error(`Timeout retry limit reached (${this._timeoutRetryCount} > ${r3}), raising silentRenewError:`, t3), this._timeoutRetryCount = 0, void await this._userManager.events._raiseSilentRenewError(t3)) : (e4.warn(`ErrorTimeout from signinSilent (attempt ${this._timeoutRetryCount}), retry in 5s:`, t3), void this._retryTimer.init(5));
            }
            e4.error("Error from signinSilent:", t3), this._timeoutRetryCount = 0, await this._userManager.events._raiseSilentRenewError(t3);
          }
        };
      }
      async start() {
        const e3 = this._logger.create("start");
        if (!this._isStarted) {
          this._isStarted = true, this._userManager.events.addAccessTokenExpiring(this._tokenExpiring), this._retryTimer.addHandler(this._tokenExpiring);
          try {
            await this._userManager.getUser();
          } catch (t3) {
            e3.error("getUser error", t3);
          }
        }
      }
      stop() {
        this._isStarted && (this._retryTimer.cancel(), this._retryTimer.removeHandler(this._tokenExpiring), this._userManager.events.removeAccessTokenExpiring(this._tokenExpiring), this._isStarted = false);
      }
    }, ae = class {
      constructor(e3) {
        this.refresh_token = e3.refresh_token, this.id_token = e3.id_token, this.session_state = e3.session_state, this.scope = e3.scope, this.profile = e3.profile, this.data = e3.state;
      }
    }, ce = class {
      constructor(e3, t3, r3, n3) {
        this._logger = new u("UserManager"), this.settings = new Y(e3), this._client = new H(e3), this._redirectNavigator = null != t3 ? t3 : new se(this.settings), this._popupNavigator = null != r3 ? r3 : new ne(this.settings), this._iframeNavigator = null != n3 ? n3 : new te(this.settings), this._events = new ie(this.settings), this._silentRenewService = new oe(this), this.settings.automaticSilentRenew && this.startSilentRenew(), this._sessionMonitor = null, this.settings.monitorSession && (this._sessionMonitor = new K(this));
      }
      get events() {
        return this._events;
      }
      get metadataService() {
        return this._client.metadataService;
      }
      async getUser(e3 = false) {
        const t3 = this._logger.create("getUser"), r3 = await this._loadUser();
        return r3 ? (t3.info("user loaded"), await this._events.load(r3, e3), r3) : (t3.info("user not found in storage"), null);
      }
      async removeUser() {
        const e3 = this._logger.create("removeUser");
        await this.storeUser(null), e3.info("user removed from storage"), await this._events.unload();
      }
      async signinRedirect(e3 = {}) {
        var t3;
        this._logger.create("signinRedirect");
        const { redirectMethod: r3, ...n3 } = e3;
        let s3;
        (null == (t3 = this.settings.dpop) ? void 0 : t3.bind_authorization_code) && (s3 = await this.generateDPoPJkt(this.settings.dpop));
        const i3 = await this._redirectNavigator.prepare({ redirectMethod: r3 });
        await this._signinStart({ request_type: "si:r", dpopJkt: s3, ...n3 }, i3);
      }
      async signinRedirectCallback(e3 = window.location.href) {
        const t3 = this._logger.create("signinRedirectCallback"), r3 = await this._signinEnd(e3);
        return r3.profile && r3.profile.sub ? t3.info("success, signed in subject", r3.profile.sub) : t3.info("no subject"), r3;
      }
      async signinResourceOwnerCredentials({ username: e3, password: t3, skipUserInfo: r3 = false }) {
        const n3 = this._logger.create("signinResourceOwnerCredential"), s3 = await this._client.processResourceOwnerPasswordCredentials({ username: e3, password: t3, skipUserInfo: r3, extraTokenParams: this.settings.extraTokenParams });
        n3.debug("got signin response");
        const i3 = await this._buildUser(s3);
        return i3.profile && i3.profile.sub ? n3.info("success, signed in subject", i3.profile.sub) : n3.info("no subject"), i3;
      }
      async signinPopup(e3 = {}) {
        var t3;
        const r3 = this._logger.create("signinPopup");
        let n3;
        (null == (t3 = this.settings.dpop) ? void 0 : t3.bind_authorization_code) && (n3 = await this.generateDPoPJkt(this.settings.dpop));
        const { popupWindowFeatures: s3, popupWindowTarget: i3, popupSignal: o3, popupAbortOnClose: a2, ...c2 } = e3, l2 = this.settings.popup_redirect_uri;
        l2 || r3.throw(new Error("No popup_redirect_uri configured"));
        const u2 = await this._popupNavigator.prepare({ popupWindowFeatures: s3, popupWindowTarget: i3, popupSignal: o3, popupAbortOnClose: a2 }), d2 = await this._signin({ request_type: "si:p", redirect_uri: l2, display: "popup", dpopJkt: n3, ...c2 }, u2);
        return d2 && (d2.profile && d2.profile.sub ? r3.info("success, signed in subject", d2.profile.sub) : r3.info("no subject")), d2;
      }
      async signinPopupCallback(e3 = window.location.href, t3 = false) {
        const r3 = this._logger.create("signinPopupCallback");
        await this._popupNavigator.callback(e3, { keepOpen: t3 }), r3.info("success");
      }
      async signinSilent(e3 = {}) {
        var t3, r3;
        const n3 = this._logger.create("signinSilent"), { silentRequestTimeoutInSeconds: s3, ...i3 } = e3;
        let o3, a2 = await this._loadUser();
        if (!e3.forceIframeAuth && (null == a2 ? void 0 : a2.refresh_token)) {
          n3.debug("using refresh token");
          const e4 = new ae(a2);
          return await this._useRefreshToken({ state: e4, redirect_uri: i3.redirect_uri, resource: i3.resource, extraTokenParams: i3.extraTokenParams, timeoutInSeconds: s3 });
        }
        (null == (t3 = this.settings.dpop) ? void 0 : t3.bind_authorization_code) && (o3 = await this.generateDPoPJkt(this.settings.dpop));
        const c2 = this.settings.silent_redirect_uri;
        let l2;
        c2 || n3.throw(new Error("No silent_redirect_uri configured")), a2 && this.settings.validateSubOnSilentRenew && (n3.debug("subject prior to silent renew:", a2.profile.sub), l2 = a2.profile.sub);
        const u2 = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: s3 });
        return a2 = await this._signin({ request_type: "si:s", redirect_uri: c2, prompt: "none", id_token_hint: this.settings.includeIdTokenInSilentRenew ? null == a2 ? void 0 : a2.id_token : void 0, dpopJkt: o3, ...i3 }, u2, l2), a2 && ((null == (r3 = a2.profile) ? void 0 : r3.sub) ? n3.info("success, signed in subject", a2.profile.sub) : n3.info("no subject")), a2;
      }
      async _useRefreshToken(e3) {
        const t3 = await this._client.useRefreshToken({ timeoutInSeconds: this.settings.silentRequestTimeoutInSeconds, ...e3 }), r3 = new V({ ...e3.state, ...t3 });
        return await this.storeUser(r3), await this._events.load(r3), r3;
      }
      async signinSilentCallback(e3 = window.location.href) {
        const t3 = this._logger.create("signinSilentCallback");
        await this._iframeNavigator.callback(e3), t3.info("success");
      }
      async signinCallback(e3 = window.location.href) {
        const { state: t3 } = await this._client.readSigninResponseState(e3);
        switch (t3.request_type) {
          case "si:r":
            return await this.signinRedirectCallback(e3);
          case "si:p":
            await this.signinPopupCallback(e3);
            break;
          case "si:s":
            await this.signinSilentCallback(e3);
            break;
          default:
            throw new Error("invalid request_type in state");
        }
      }
      async signoutCallback(e3 = window.location.href, t3 = false) {
        const { state: r3 } = await this._client.readSignoutResponseState(e3);
        if (r3) switch (r3.request_type) {
          case "so:r":
            return await this.signoutRedirectCallback(e3);
          case "so:p":
            await this.signoutPopupCallback(e3, t3);
            break;
          case "so:s":
            await this.signoutSilentCallback(e3);
            break;
          default:
            throw new Error("invalid request_type in state");
        }
      }
      async querySessionStatus(e3 = {}) {
        const t3 = this._logger.create("querySessionStatus"), { silentRequestTimeoutInSeconds: r3, ...n3 } = e3, s3 = this.settings.silent_redirect_uri;
        s3 || t3.throw(new Error("No silent_redirect_uri configured"));
        const i3 = await this._loadUser(), o3 = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: r3 }), a2 = await this._signinStart({ request_type: "si:s", redirect_uri: s3, prompt: "none", id_token_hint: this.settings.includeIdTokenInSilentRenew ? null == i3 ? void 0 : i3.id_token : void 0, response_type: this.settings.query_status_response_type, scope: "openid", skipUserInfo: true, ...n3 }, o3);
        try {
          const e4 = {}, r4 = await this._client.processSigninResponse(a2.url, e4);
          return t3.debug("got signin response"), r4.session_state && r4.profile.sub ? (t3.info("success for subject", r4.profile.sub), { session_state: r4.session_state, sub: r4.profile.sub }) : (t3.info("success, user not authenticated"), null);
        } catch (e4) {
          if (this.settings.monitorAnonymousSession && e4 instanceof v) switch (e4.error) {
            case "login_required":
            case "consent_required":
            case "interaction_required":
            case "account_selection_required":
              return t3.info("success for anonymous user"), { session_state: e4.session_state };
          }
          throw e4;
        }
      }
      async _signin(e3, t3, r3) {
        const n3 = await this._signinStart(e3, t3);
        return await this._signinEnd(n3.url, r3);
      }
      async _signinStart(e3, t3) {
        const r3 = this._logger.create("_signinStart");
        try {
          const n3 = await this._client.createSigninRequest(e3);
          return r3.debug("got signin request"), await t3.navigate({ url: n3.url, state: n3.state.id, response_mode: n3.state.response_mode, scriptOrigin: this.settings.iframeScriptOrigin });
        } catch (e4) {
          throw r3.debug("error after preparing navigator, closing navigator window"), t3.close(), e4;
        }
      }
      async _signinEnd(e3, t3) {
        const r3 = this._logger.create("_signinEnd"), n3 = await this._client.processSigninResponse(e3, {});
        r3.debug("got signin response");
        return await this._buildUser(n3, t3);
      }
      async _buildUser(e3, t3) {
        const r3 = this._logger.create("_buildUser"), n3 = new V(e3);
        if (t3) {
          if (t3 !== n3.profile.sub) throw r3.debug("current user does not match user returned from signin. sub from signin:", n3.profile.sub), new v({ ...e3, error: "login_required" });
          r3.debug("current user matches user returned from signin");
        }
        return await this.storeUser(n3), r3.debug("user stored"), await this._events.load(n3), n3;
      }
      async signoutRedirect(e3 = {}) {
        const t3 = this._logger.create("signoutRedirect"), { redirectMethod: r3, ...n3 } = e3, s3 = await this._redirectNavigator.prepare({ redirectMethod: r3 });
        await this._signoutStart({ request_type: "so:r", post_logout_redirect_uri: this.settings.post_logout_redirect_uri, ...n3 }, s3), t3.info("success");
      }
      async signoutRedirectCallback(e3 = window.location.href) {
        const t3 = this._logger.create("signoutRedirectCallback"), r3 = await this._signoutEnd(e3);
        return t3.info("success"), r3;
      }
      async signoutPopup(e3 = {}) {
        const t3 = this._logger.create("signoutPopup"), { popupWindowFeatures: r3, popupWindowTarget: n3, popupSignal: s3, ...i3 } = e3, o3 = this.settings.popup_post_logout_redirect_uri, a2 = await this._popupNavigator.prepare({ popupWindowFeatures: r3, popupWindowTarget: n3, popupSignal: s3 });
        await this._signout({ request_type: "so:p", post_logout_redirect_uri: o3, state: null == o3 ? void 0 : {}, ...i3 }, a2), t3.info("success");
      }
      async signoutPopupCallback(e3 = window.location.href, t3 = false) {
        const r3 = this._logger.create("signoutPopupCallback");
        await this._popupNavigator.callback(e3, { keepOpen: t3 }), r3.info("success");
      }
      async _signout(e3, t3) {
        const r3 = await this._signoutStart(e3, t3);
        return await this._signoutEnd(r3.url);
      }
      async _signoutStart(e3 = {}, t3) {
        var r3;
        const n3 = this._logger.create("_signoutStart");
        try {
          const s3 = await this._loadUser();
          n3.debug("loaded current user from storage"), this.settings.revokeTokensOnSignout && await this._revokeInternal(s3);
          const i3 = e3.id_token_hint || s3 && s3.id_token;
          i3 && (n3.debug("setting id_token_hint in signout request"), e3.id_token_hint = i3), await this.removeUser(), n3.debug("user removed, creating signout request");
          const o3 = await this._client.createSignoutRequest(e3);
          return n3.debug("got signout request"), await t3.navigate({ url: o3.url, state: null == (r3 = o3.state) ? void 0 : r3.id, scriptOrigin: this.settings.iframeScriptOrigin });
        } catch (e4) {
          throw n3.debug("error after preparing navigator, closing navigator window"), t3.close(), e4;
        }
      }
      async _signoutEnd(e3) {
        const t3 = this._logger.create("_signoutEnd"), r3 = await this._client.processSignoutResponse(e3);
        return t3.debug("got signout response"), r3;
      }
      async signoutSilent(e3 = {}) {
        var t3;
        const r3 = this._logger.create("signoutSilent"), { silentRequestTimeoutInSeconds: n3, ...s3 } = e3, i3 = this.settings.includeIdTokenInSilentSignout ? null == (t3 = await this._loadUser()) ? void 0 : t3.id_token : void 0, o3 = this.settings.popup_post_logout_redirect_uri, a2 = await this._iframeNavigator.prepare({ silentRequestTimeoutInSeconds: n3 });
        await this._signout({ request_type: "so:s", post_logout_redirect_uri: o3, id_token_hint: i3, ...s3 }, a2), r3.info("success");
      }
      async signoutSilentCallback(e3 = window.location.href) {
        const t3 = this._logger.create("signoutSilentCallback");
        await this._iframeNavigator.callback(e3), t3.info("success");
      }
      async revokeTokens(e3) {
        const t3 = await this._loadUser();
        await this._revokeInternal(t3, e3);
      }
      async _revokeInternal(e3, t3 = this.settings.revokeTokenTypes) {
        const r3 = this._logger.create("_revokeInternal");
        if (!e3) return;
        const n3 = t3.filter((t4) => "string" == typeof e3[t4]);
        if (n3.length) {
          for (const t4 of n3) await this._client.revokeToken(e3[t4], t4), r3.info(`${t4} revoked successfully`), "access_token" !== t4 && (e3[t4] = null);
          await this.storeUser(e3), r3.debug("user stored"), await this._events.load(e3);
        } else r3.debug("no need to revoke due to no token(s)");
      }
      startSilentRenew() {
        this._logger.create("startSilentRenew"), this._silentRenewService.start();
      }
      stopSilentRenew() {
        this._silentRenewService.stop();
      }
      get _userStoreKey() {
        return `user:${this.settings.authority}:${this.settings.client_id}`;
      }
      async _loadUser() {
        const e3 = this._logger.create("_loadUser"), t3 = await this.settings.userStore.get(this._userStoreKey);
        return t3 ? (e3.debug("user storageString loaded"), V.fromStorageString(t3)) : (e3.debug("no user storageString"), null);
      }
      async storeUser(e3) {
        const t3 = this._logger.create("storeUser");
        if (e3) {
          t3.debug("storing user");
          const r3 = e3.toStorageString();
          await this.settings.userStore.set(this._userStoreKey, r3);
        } else this._logger.debug("removing user"), await this.settings.userStore.remove(this._userStoreKey), this.settings.dpop && await this.settings.dpop.store.remove(this.settings.client_id);
      }
      async clearStaleState() {
        await this._client.clearStaleState();
      }
      async dpopProof(e3, t3, r3, n3) {
        var s3, i3;
        const o3 = await (null == (i3 = null == (s3 = this.settings.dpop) ? void 0 : s3.store) ? void 0 : i3.get(this.settings.client_id));
        if (o3) return await f.generateDPoPProof({ url: e3, accessToken: null == t3 ? void 0 : t3.access_token, httpMethod: r3, keyPair: o3.keys, nonce: n3 });
      }
      async generateDPoPJkt(e3) {
        let t3 = await e3.store.get(this.settings.client_id);
        if (!t3) {
          const r3 = await f.generateDPoPKeys();
          t3 = new z(r3), await e3.store.set(this.settings.client_id, t3);
        }
        return await f.generateDPoPJkt(t3.keys);
      }
    };
    class le extends ce {
      constructor(e3, t3 = true) {
        super({ ...e3, automaticSilentRenew: false, monitorSession: false, monitorAnonymousSession: false, checkSessionIntervalInSeconds: 0, accessTokenExpiringNotificationTimeInSeconds: 0, validateSubOnSilentRenew: false, includeIdTokenInSilentRenew: false, silent_redirect_uri: void 0 });
        __publicField(this, "_disabled");
        this._disabled = t3, t3 && this._disableAllAutoRenew();
      }
      _disableAllAutoRenew() {
        this._blockSilentRenewService(), this._blockSessionMonitor(), this._blockEvents();
      }
      _blockSilentRenewService() {
        this._silentRenewService && (this._silentRenewService.start = () => {
          console.warn("SilentRenewService.start() disabled");
        }, this._silentRenewService.stop = () => {
          console.warn("SilentRenewService.stop() disabled");
        });
      }
      _blockSessionMonitor() {
        this._sessionMonitor && (this._sessionMonitor.start = () => {
          console.warn("SessionMonitor.start() disabled");
        }, this._sessionMonitor.stop = () => {
          console.warn("SessionMonitor.stop() disabled");
        });
      }
      _blockEvents() {
        const e3 = this.events.load;
        this.events.load = (t3) => (console.log("User loaded, but auto-renew disabled"), e3.call(this.events, t3));
        this.events.addAccessTokenExpiring;
        this.events.addAccessTokenExpiring = (e4) => (console.warn("AccessTokenExpiring events disabled"), () => {
        });
      }
      startSilentRenew() {
        this._disabled ? console.warn("startSilentRenew() disabled by NoAutoRenewUserManager") : super.startSilentRenew();
      }
      stopSilentRenew() {
        this._disabled ? console.warn("stopSilentRenew() disabled by NoAutoRenewUserManager") : super.stopSilentRenew();
      }
      async signinSilent(e3) {
        if (this._disabled && !e3?.unlockSilentSigin) throw console.warn("signinSilent() disabled by NoAutoRenewUserManager"), new Error("Automatic silent renew is disabled. Use manual token management.");
        return super.signinSilent(e3);
      }
      async querySessionStatus(e3) {
        return this._disabled ? (console.warn("querySessionStatus() disabled by NoAutoRenewUserManager"), null) : super.querySessionStatus(e3);
      }
      isTokenExpired(e3) {
        return !e3 || !e3.expires_at || 1e3 * e3.expires_at < Date.now();
      }
      getTokenExpiryTime(e3) {
        return e3 && e3.expires_at ? 1e3 * e3.expires_at - Date.now() : null;
      }
    }
    function ue(e3) {
      const t3 = new le(e3, true);
      return { async authorize() {
        try {
          const e4 = await t3.getUser();
          e4 && !e4.expired || await t3.signinRedirect();
        } catch (e4) {
          console.error("Authorization failed:", e4);
        }
      }, async signout() {
        try {
          await t3.signoutRedirect();
        } catch (e4) {
          console.error("Signout failed:", e4);
        }
      }, userManager: t3 };
    }
  }, 9155(e2) {
    "use strict";
    e2.exports = t;
  }, 4442(e2) {
    "use strict";
    e2.exports = r;
  }, 8673(t2) {
    "use strict";
    t2.exports = e;
  }, 2634() {
  } }, s = {};
  function i(e2) {
    var t2 = s[e2];
    if (void 0 !== t2) return t2.exports;
    var r2 = s[e2] = { id: e2, exports: {} };
    return n[e2](r2, r2.exports, i), r2.exports;
  }
  i.n = (e2) => {
    var t2 = e2 && e2.__esModule ? () => e2.default : () => e2;
    return i.d(t2, { a: t2 }), t2;
  }, i.d = (e2, t2) => {
    for (var r2 in t2) i.o(t2, r2) && !i.o(e2, r2) && Object.defineProperty(e2, r2, { enumerable: true, get: t2[r2] });
  }, i.g = (function() {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e2) {
      if ("object" == typeof window) return window;
    }
  })(), i.o = (e2, t2) => Object.prototype.hasOwnProperty.call(e2, t2), i.r = (e2) => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e2, "__esModule", { value: true });
  }, i.nc = void 0;
  var o = {};
  return (() => {
    "use strict";
    i.r(o), i.d(o, { AuthOriginalProvider: () => ko, AuthProvider: () => xo, AuthZitadelProvider: () => bo, EnumEnvironment: () => Qi, EnumServices: () => Xi, STORAGE: () => Vt, SessionTracker: () => Fi, asCacheTag: () => Ur, clearCache: () => On, createCacheTag: () => jr, createHttpService: () => Ji, directApiService: () => Gi, enableCacheDebugTools: () => Fn, entityCacheFromBodyField: () => Nn, entityCacheKey: () => En, eventIsRefreshingAccessTokenInfo: () => Tt, eventTokensInfo: () => xt, getAccessToken: () => Wt, getCSRF: () => Qt, getCacheDebugToolsEnabled: () => kr, getClientId: () => Gt, getExternalAuthRecoverMethod: () => Bt, getExternalCookieInfo: () => Xt, getIdentityToken: () => Jt, getIsRefreshingNow: () => Ut, getPageUUID: () => jt, getRefreshToken: () => Zt, getSessionTracker: () => Di, getSharedHttpServiceConfig: () => br, getTypeOfHttpService: () => Sr, hashCacheKey: () => Zr, invalidateByTags: () => Cn, makeListenerForRefreshingAccessTokenInfo: () => Dt, makeListenerForTokensInfo: () => Mt, resolveHost: () => Br, setCacheDebugToolsEnabled: () => vr, setExternalAuthRecoverMethod: () => $t, setSessionTracker: () => qi, setSharedHttpServiceConfig: () => wr, setTokensInfoIntoWindowEvents: () => Lt, setTypeOfHttpService: () => _r, stableStringify: () => mn, storage: () => t2 });
    var e2 = {};
    i.r(e2), i.d(e2, { hasBrowserEnv: () => ke, hasStandardBrowserEnv: () => Te, hasStandardBrowserWebWorkerEnv: () => Ee, navigator: () => xe, origin: () => Re });
    var t2 = {};
    function r2(e3, t3) {
      return function() {
        return e3.apply(t3, arguments);
      };
    }
    i.r(t2), i.d(t2, { STORAGE: () => Vt, csrfHeader: () => Kt, getAccessToken: () => Wt, getCSRF: () => Qt, getClientId: () => Gt, getExternalCookieInfo: () => Xt, getExternalRecoverState: () => er, getIdentityToken: () => Jt, getRefreshToken: () => Zt, getRefreshVersion: () => Yt, removeAccessToken: () => lr, removeCSRF: () => hr, removeClientId: () => fr, removeExternalCookieInfo: () => dr, removeIdentityToken: () => pr, removeRefreshToken: () => ur, setAccessToken: () => tr, setCSRF: () => or, setClientId: () => sr, setExternalCookieInfo: () => ir, setExternalRecoverState: () => ar, setExternalRecoverStateExtra: () => cr, setIdentityToken: () => nr, setRefreshToken: () => rr });
    const { toString: n2 } = Object.prototype, { getPrototypeOf: s2 } = Object, { iterator: a, toStringTag: c } = Symbol, l = (u = /* @__PURE__ */ Object.create(null), (e3) => {
      const t3 = n2.call(e3);
      return u[t3] || (u[t3] = t3.slice(8, -1).toLowerCase());
    });
    var u;
    const d = (e3) => (e3 = e3.toLowerCase(), (t3) => l(t3) === e3), h = (e3) => (t3) => typeof t3 === e3, { isArray: p } = Array, f = h("undefined");
    function g(e3) {
      return null !== e3 && !f(e3) && null !== e3.constructor && !f(e3.constructor) && _(e3.constructor.isBuffer) && e3.constructor.isBuffer(e3);
    }
    const y = d("ArrayBuffer");
    const m = h("string"), _ = h("function"), w = h("number"), v = (e3) => null !== e3 && "object" == typeof e3, b = (e3) => {
      if ("object" !== l(e3)) return false;
      const t3 = s2(e3);
      return !(null !== t3 && t3 !== Object.prototype && null !== Object.getPrototypeOf(t3) || c in e3 || a in e3);
    }, S = d("Date"), k = d("File"), x = d("Blob"), T = d("FileList");
    const E = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== i.g ? i.g : {}, R = void 0 !== E.FormData ? E.FormData : void 0, A = d("URLSearchParams"), [O, C, I, P] = ["ReadableStream", "Request", "Response", "Headers"].map(d);
    function N(e3, t3, { allOwnKeys: r3 = false } = {}) {
      if (null == e3) return;
      let n3, s3;
      if ("object" != typeof e3 && (e3 = [e3]), p(e3)) for (n3 = 0, s3 = e3.length; n3 < s3; n3++) t3.call(null, e3[n3], n3, e3);
      else {
        if (g(e3)) return;
        const s4 = r3 ? Object.getOwnPropertyNames(e3) : Object.keys(e3), i2 = s4.length;
        let o2;
        for (n3 = 0; n3 < i2; n3++) o2 = s4[n3], t3.call(null, e3[o2], o2, e3);
      }
    }
    function j(e3, t3) {
      if (g(e3)) return null;
      t3 = t3.toLowerCase();
      const r3 = Object.keys(e3);
      let n3, s3 = r3.length;
      for (; s3-- > 0; ) if (n3 = r3[s3], t3 === n3.toLowerCase()) return n3;
      return null;
    }
    const U = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : i.g, L = (e3) => !f(e3) && e3 !== U;
    const F = (M = "undefined" != typeof Uint8Array && s2(Uint8Array), (e3) => M && e3 instanceof M);
    var M;
    const D = d("HTMLFormElement"), q = (({ hasOwnProperty: e3 }) => (t3, r3) => e3.call(t3, r3))(Object.prototype), $ = d("RegExp"), B = (e3, t3) => {
      const r3 = Object.getOwnPropertyDescriptors(e3), n3 = {};
      N(r3, (r4, s3) => {
        let i2;
        false !== (i2 = t3(r4, s3, e3)) && (n3[s3] = i2 || r4);
      }), Object.defineProperties(e3, n3);
    };
    const z = d("AsyncFunction"), H = (K = "function" == typeof setImmediate, V = _(U.postMessage), K ? setImmediate : V ? (W = `axios@${Math.random()}`, Z = [], U.addEventListener("message", ({ source: e3, data: t3 }) => {
      e3 === U && t3 === W && Z.length && Z.shift()();
    }, false), (e3) => {
      Z.push(e3), U.postMessage(W, "*");
    }) : (e3) => setTimeout(e3));
    var K, V, W, Z;
    const J = "undefined" != typeof queueMicrotask ? queueMicrotask.bind(U) : "undefined" != typeof process && process.nextTick || H, G = { isArray: p, isArrayBuffer: y, isBuffer: g, isFormData: (e3) => {
      if (!e3) return false;
      if (R && e3 instanceof R) return true;
      const t3 = s2(e3);
      if (!t3 || t3 === Object.prototype) return false;
      if (!_(e3.append)) return false;
      const r3 = l(e3);
      return "formdata" === r3 || "object" === r3 && _(e3.toString) && "[object FormData]" === e3.toString();
    }, isArrayBufferView: function(e3) {
      let t3;
      return t3 = "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(e3) : e3 && e3.buffer && y(e3.buffer), t3;
    }, isString: m, isNumber: w, isBoolean: (e3) => true === e3 || false === e3, isObject: v, isPlainObject: b, isEmptyObject: (e3) => {
      if (!v(e3) || g(e3)) return false;
      try {
        return 0 === Object.keys(e3).length && Object.getPrototypeOf(e3) === Object.prototype;
      } catch (e4) {
        return false;
      }
    }, isReadableStream: O, isRequest: C, isResponse: I, isHeaders: P, isUndefined: f, isDate: S, isFile: k, isReactNativeBlob: (e3) => !(!e3 || void 0 === e3.uri), isReactNative: (e3) => e3 && void 0 !== e3.getParts, isBlob: x, isRegExp: $, isFunction: _, isStream: (e3) => v(e3) && _(e3.pipe), isURLSearchParams: A, isTypedArray: F, isFileList: T, forEach: N, merge: function e3(...t3) {
      const { caseless: r3, skipUndefined: n3 } = L(this) && this || {}, s3 = {}, i2 = (t4, i3) => {
        if ("__proto__" === i3 || "constructor" === i3 || "prototype" === i3) return;
        const o2 = r3 && j(s3, i3) || i3, a2 = q(s3, o2) ? s3[o2] : void 0;
        b(a2) && b(t4) ? s3[o2] = e3(a2, t4) : b(t4) ? s3[o2] = e3({}, t4) : p(t4) ? s3[o2] = t4.slice() : n3 && f(t4) || (s3[o2] = t4);
      };
      for (let e4 = 0, r4 = t3.length; e4 < r4; e4++) t3[e4] && N(t3[e4], i2);
      return s3;
    }, extend: (e3, t3, n3, { allOwnKeys: s3 } = {}) => (N(t3, (t4, s4) => {
      n3 && _(t4) ? Object.defineProperty(e3, s4, { __proto__: null, value: r2(t4, n3), writable: true, enumerable: true, configurable: true }) : Object.defineProperty(e3, s4, { __proto__: null, value: t4, writable: true, enumerable: true, configurable: true });
    }, { allOwnKeys: s3 }), e3), trim: (e3) => e3.trim ? e3.trim() : e3.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (e3) => (65279 === e3.charCodeAt(0) && (e3 = e3.slice(1)), e3), inherits: (e3, t3, r3, n3) => {
      e3.prototype = Object.create(t3.prototype, n3), Object.defineProperty(e3.prototype, "constructor", { __proto__: null, value: e3, writable: true, enumerable: false, configurable: true }), Object.defineProperty(e3, "super", { __proto__: null, value: t3.prototype }), r3 && Object.assign(e3.prototype, r3);
    }, toFlatObject: (e3, t3, r3, n3) => {
      let i2, o2, a2;
      const c2 = {};
      if (t3 = t3 || {}, null == e3) return t3;
      do {
        for (i2 = Object.getOwnPropertyNames(e3), o2 = i2.length; o2-- > 0; ) a2 = i2[o2], n3 && !n3(a2, e3, t3) || c2[a2] || (t3[a2] = e3[a2], c2[a2] = true);
        e3 = false !== r3 && s2(e3);
      } while (e3 && (!r3 || r3(e3, t3)) && e3 !== Object.prototype);
      return t3;
    }, kindOf: l, kindOfTest: d, endsWith: (e3, t3, r3) => {
      e3 = String(e3), (void 0 === r3 || r3 > e3.length) && (r3 = e3.length), r3 -= t3.length;
      const n3 = e3.indexOf(t3, r3);
      return -1 !== n3 && n3 === r3;
    }, toArray: (e3) => {
      if (!e3) return null;
      if (p(e3)) return e3;
      let t3 = e3.length;
      if (!w(t3)) return null;
      const r3 = new Array(t3);
      for (; t3-- > 0; ) r3[t3] = e3[t3];
      return r3;
    }, forEachEntry: (e3, t3) => {
      const r3 = (e3 && e3[a]).call(e3);
      let n3;
      for (; (n3 = r3.next()) && !n3.done; ) {
        const r4 = n3.value;
        t3.call(e3, r4[0], r4[1]);
      }
    }, matchAll: (e3, t3) => {
      let r3;
      const n3 = [];
      for (; null !== (r3 = e3.exec(t3)); ) n3.push(r3);
      return n3;
    }, isHTMLForm: D, hasOwnProperty: q, hasOwnProp: q, reduceDescriptors: B, freezeMethods: (e3) => {
      B(e3, (t3, r3) => {
        if (_(e3) && ["arguments", "caller", "callee"].includes(r3)) return false;
        const n3 = e3[r3];
        _(n3) && (t3.enumerable = false, "writable" in t3 ? t3.writable = false : t3.set || (t3.set = () => {
          throw Error("Can not rewrite read-only method '" + r3 + "'");
        }));
      });
    }, toObjectSet: (e3, t3) => {
      const r3 = {}, n3 = (e4) => {
        e4.forEach((e5) => {
          r3[e5] = true;
        });
      };
      return p(e3) ? n3(e3) : n3(String(e3).split(t3)), r3;
    }, toCamelCase: (e3) => e3.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e4, t3, r3) {
      return t3.toUpperCase() + r3;
    }), noop: () => {
    }, toFiniteNumber: (e3, t3) => null != e3 && Number.isFinite(e3 = +e3) ? e3 : t3, findKey: j, global: U, isContextDefined: L, isSpecCompliantForm: function(e3) {
      return !!(e3 && _(e3.append) && "FormData" === e3[c] && e3[a]);
    }, toJSONObject: (e3) => {
      const t3 = new Array(10), r3 = (e4, n3) => {
        if (v(e4)) {
          if (t3.indexOf(e4) >= 0) return;
          if (g(e4)) return e4;
          if (!("toJSON" in e4)) {
            t3[n3] = e4;
            const s3 = p(e4) ? [] : {};
            return N(e4, (e5, t4) => {
              const i2 = r3(e5, n3 + 1);
              !f(i2) && (s3[t4] = i2);
            }), t3[n3] = void 0, s3;
          }
        }
        return e4;
      };
      return r3(e3, 0);
    }, isAsyncFn: z, isThenable: (e3) => e3 && (v(e3) || _(e3)) && _(e3.then) && _(e3.catch), setImmediate: H, asap: J, isIterable: (e3) => null != e3 && _(e3[a]) }, X = G.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), Q = (e3) => {
      const t3 = {};
      let r3, n3, s3;
      return e3 && e3.split("\n").forEach(function(e4) {
        s3 = e4.indexOf(":"), r3 = e4.substring(0, s3).trim().toLowerCase(), n3 = e4.substring(s3 + 1).trim(), !r3 || t3[r3] && X[r3] || ("set-cookie" === r3 ? t3[r3] ? t3[r3].push(n3) : t3[r3] = [n3] : t3[r3] = t3[r3] ? t3[r3] + ", " + n3 : n3);
      }), t3;
    };
    (Object.getOwnPropertyDescriptor(Q, "name") || {}).writable || Object.defineProperty(Q, "name", { value: "default", configurable: true });
    const Y = /* @__PURE__ */ Symbol("internals"), ee = /[^\x09\x20-\x7E\x80-\xFF]/g;
    function te(e3) {
      return e3 && String(e3).trim().toLowerCase();
    }
    function re(e3) {
      return false === e3 || null == e3 ? e3 : G.isArray(e3) ? e3.map(re) : (function(e4) {
        let t3 = 0, r3 = e4.length;
        for (; t3 < r3; ) {
          const r4 = e4.charCodeAt(t3);
          if (9 !== r4 && 32 !== r4) break;
          t3 += 1;
        }
        for (; r3 > t3; ) {
          const t4 = e4.charCodeAt(r3 - 1);
          if (9 !== t4 && 32 !== t4) break;
          r3 -= 1;
        }
        return 0 === t3 && r3 === e4.length ? e4 : e4.slice(t3, r3);
      })(String(e3).replace(ee, ""));
    }
    function ne(e3, t3, r3, n3, s3) {
      return G.isFunction(n3) ? n3.call(this, t3, r3) : (s3 && (t3 = r3), G.isString(t3) ? G.isString(n3) ? -1 !== t3.indexOf(n3) : G.isRegExp(n3) ? n3.test(t3) : void 0 : void 0);
    }
    class se {
      constructor(e3) {
        e3 && this.set(e3);
      }
      set(e3, t3, r3) {
        const n3 = this;
        function s3(e4, t4, r4) {
          const s4 = te(t4);
          if (!s4) throw new Error("header name must be a non-empty string");
          const i3 = G.findKey(n3, s4);
          (!i3 || void 0 === n3[i3] || true === r4 || void 0 === r4 && false !== n3[i3]) && (n3[i3 || t4] = re(e4));
        }
        const i2 = (e4, t4) => G.forEach(e4, (e5, r4) => s3(e5, r4, t4));
        if (G.isPlainObject(e3) || e3 instanceof this.constructor) i2(e3, t3);
        else if (G.isString(e3) && (e3 = e3.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e3.trim())) i2(Q(e3), t3);
        else if (G.isObject(e3) && G.isIterable(e3)) {
          let r4, n4, s4 = {};
          for (const t4 of e3) {
            if (!G.isArray(t4)) throw TypeError("Object iterator must return a key-value pair");
            s4[n4 = t4[0]] = (r4 = s4[n4]) ? G.isArray(r4) ? [...r4, t4[1]] : [r4, t4[1]] : t4[1];
          }
          i2(s4, t3);
        } else null != e3 && s3(t3, e3, r3);
        return this;
      }
      get(e3, t3) {
        if (e3 = te(e3)) {
          const r3 = G.findKey(this, e3);
          if (r3) {
            const e4 = this[r3];
            if (!t3) return e4;
            if (true === t3) return (function(e5) {
              const t4 = /* @__PURE__ */ Object.create(null), r4 = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
              let n3;
              for (; n3 = r4.exec(e5); ) t4[n3[1]] = n3[2];
              return t4;
            })(e4);
            if (G.isFunction(t3)) return t3.call(this, e4, r3);
            if (G.isRegExp(t3)) return t3.exec(e4);
            throw new TypeError("parser must be boolean|regexp|function");
          }
        }
      }
      has(e3, t3) {
        if (e3 = te(e3)) {
          const r3 = G.findKey(this, e3);
          return !(!r3 || void 0 === this[r3] || t3 && !ne(0, this[r3], r3, t3));
        }
        return false;
      }
      delete(e3, t3) {
        const r3 = this;
        let n3 = false;
        function s3(e4) {
          if (e4 = te(e4)) {
            const s4 = G.findKey(r3, e4);
            !s4 || t3 && !ne(0, r3[s4], s4, t3) || (delete r3[s4], n3 = true);
          }
        }
        return G.isArray(e3) ? e3.forEach(s3) : s3(e3), n3;
      }
      clear(e3) {
        const t3 = Object.keys(this);
        let r3 = t3.length, n3 = false;
        for (; r3--; ) {
          const s3 = t3[r3];
          e3 && !ne(0, this[s3], s3, e3, true) || (delete this[s3], n3 = true);
        }
        return n3;
      }
      normalize(e3) {
        const t3 = this, r3 = {};
        return G.forEach(this, (n3, s3) => {
          const i2 = G.findKey(r3, s3);
          if (i2) return t3[i2] = re(n3), void delete t3[s3];
          const o2 = e3 ? (function(e4) {
            return e4.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e5, t4, r4) => t4.toUpperCase() + r4);
          })(s3) : String(s3).trim();
          o2 !== s3 && delete t3[s3], t3[o2] = re(n3), r3[o2] = true;
        }), this;
      }
      concat(...e3) {
        return this.constructor.concat(this, ...e3);
      }
      toJSON(e3) {
        const t3 = /* @__PURE__ */ Object.create(null);
        return G.forEach(this, (r3, n3) => {
          null != r3 && false !== r3 && (t3[n3] = e3 && G.isArray(r3) ? r3.join(", ") : r3);
        }), t3;
      }
      [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
      }
      toString() {
        return Object.entries(this.toJSON()).map(([e3, t3]) => e3 + ": " + t3).join("\n");
      }
      getSetCookie() {
        return this.get("set-cookie") || [];
      }
      get [Symbol.toStringTag]() {
        return "AxiosHeaders";
      }
      static from(e3) {
        return e3 instanceof this ? e3 : new this(e3);
      }
      static concat(e3, ...t3) {
        const r3 = new this(e3);
        return t3.forEach((e4) => r3.set(e4)), r3;
      }
      static accessor(e3) {
        const t3 = (this[Y] = this[Y] = { accessors: {} }).accessors, r3 = this.prototype;
        function n3(e4) {
          const n4 = te(e4);
          t3[n4] || (!(function(e5, t4) {
            const r4 = G.toCamelCase(" " + t4);
            ["get", "set", "has"].forEach((n5) => {
              Object.defineProperty(e5, n5 + r4, { __proto__: null, value: function(e6, r5, s3) {
                return this[n5].call(this, t4, e6, r5, s3);
              }, configurable: true });
            });
          })(r3, e4), t3[n4] = true);
        }
        return G.isArray(e3) ? e3.forEach(n3) : n3(e3), this;
      }
    }
    se.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), G.reduceDescriptors(se.prototype, ({ value: e3 }, t3) => {
      let r3 = t3[0].toUpperCase() + t3.slice(1);
      return { get: () => e3, set(e4) {
        this[r3] = e4;
      } };
    }), G.freezeMethods(se);
    const ie = se;
    function oe(e3, t3) {
      const r3 = new Set(t3.map((e4) => String(e4).toLowerCase())), n3 = [], s3 = (e4) => {
        if (null === e4 || "object" != typeof e4) return e4;
        if (G.isBuffer(e4)) return e4;
        if (-1 !== n3.indexOf(e4)) return;
        let t4;
        if (e4 instanceof ie && (e4 = e4.toJSON()), n3.push(e4), G.isArray(e4)) t4 = [], e4.forEach((e5, r4) => {
          const n4 = s3(e5);
          G.isUndefined(n4) || (t4[r4] = n4);
        });
        else {
          if (!G.isPlainObject(e4) && (function(e5) {
            if (G.hasOwnProp(e5, "toJSON")) return true;
            let t5 = Object.getPrototypeOf(e5);
            for (; t5 && t5 !== Object.prototype; ) {
              if (G.hasOwnProp(t5, "toJSON")) return true;
              t5 = Object.getPrototypeOf(t5);
            }
            return false;
          })(e4)) return n3.pop(), e4;
          t4 = /* @__PURE__ */ Object.create(null);
          for (const [n4, i2] of Object.entries(e4)) {
            const e5 = r3.has(n4.toLowerCase()) ? "[REDACTED ****]" : s3(i2);
            G.isUndefined(e5) || (t4[n4] = e5);
          }
        }
        return n3.pop(), t4;
      };
      return s3(e3);
    }
    class ae extends Error {
      static from(e3, t3, r3, n3, s3, i2) {
        const o2 = new ae(e3.message, t3 || e3.code, r3, n3, s3);
        return o2.cause = e3, o2.name = e3.name, null != e3.status && null == o2.status && (o2.status = e3.status), i2 && Object.assign(o2, i2), o2;
      }
      constructor(e3, t3, r3, n3, s3) {
        super(e3), Object.defineProperty(this, "message", { __proto__: null, value: e3, enumerable: true, writable: true, configurable: true }), this.name = "AxiosError", this.isAxiosError = true, t3 && (this.code = t3), r3 && (this.config = r3), n3 && (this.request = n3), s3 && (this.response = s3, this.status = s3.status);
      }
      toJSON() {
        const e3 = this.config, t3 = e3 && G.hasOwnProp(e3, "redact") ? e3.redact : void 0, r3 = G.isArray(t3) && t3.length > 0 ? oe(e3, t3) : G.toJSONObject(e3);
        return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: r3, code: this.code, status: this.status };
      }
    }
    ae.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE", ae.ERR_BAD_OPTION = "ERR_BAD_OPTION", ae.ECONNABORTED = "ECONNABORTED", ae.ETIMEDOUT = "ETIMEDOUT", ae.ECONNREFUSED = "ECONNREFUSED", ae.ERR_NETWORK = "ERR_NETWORK", ae.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS", ae.ERR_DEPRECATED = "ERR_DEPRECATED", ae.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE", ae.ERR_BAD_REQUEST = "ERR_BAD_REQUEST", ae.ERR_CANCELED = "ERR_CANCELED", ae.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT", ae.ERR_INVALID_URL = "ERR_INVALID_URL", ae.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
    const ce = ae;
    function le(e3) {
      return G.isPlainObject(e3) || G.isArray(e3);
    }
    function ue(e3) {
      return G.endsWith(e3, "[]") ? e3.slice(0, -2) : e3;
    }
    function de(e3, t3, r3) {
      return e3 ? e3.concat(t3).map(function(e4, t4) {
        return e4 = ue(e4), !r3 && t4 ? "[" + e4 + "]" : e4;
      }).join(r3 ? "." : "") : t3;
    }
    const he = G.toFlatObject(G, {}, null, function(e3) {
      return /^is[A-Z]/.test(e3);
    });
    const pe = function(e3, t3, r3) {
      if (!G.isObject(e3)) throw new TypeError("target must be an object");
      t3 = t3 || new FormData();
      const n3 = (r3 = G.toFlatObject(r3, { metaTokens: true, dots: false, indexes: false }, false, function(e4, t4) {
        return !G.isUndefined(t4[e4]);
      })).metaTokens, s3 = r3.visitor || d2, i2 = r3.dots, o2 = r3.indexes, a2 = r3.Blob || "undefined" != typeof Blob && Blob, c2 = void 0 === r3.maxDepth ? 100 : r3.maxDepth, l2 = a2 && G.isSpecCompliantForm(t3);
      if (!G.isFunction(s3)) throw new TypeError("visitor must be a function");
      function u2(e4) {
        if (null === e4) return "";
        if (G.isDate(e4)) return e4.toISOString();
        if (G.isBoolean(e4)) return e4.toString();
        if (!l2 && G.isBlob(e4)) throw new ce("Blob is not supported. Use a Buffer instead.");
        return G.isArrayBuffer(e4) || G.isTypedArray(e4) ? l2 && "function" == typeof Blob ? new Blob([e4]) : Buffer.from(e4) : e4;
      }
      function d2(e4, r4, s4) {
        let a3 = e4;
        if (G.isReactNative(t3) && G.isReactNativeBlob(e4)) return t3.append(de(s4, r4, i2), u2(e4)), false;
        if (e4 && !s4 && "object" == typeof e4) {
          if (G.endsWith(r4, "{}")) r4 = n3 ? r4 : r4.slice(0, -2), e4 = JSON.stringify(e4);
          else if (G.isArray(e4) && (function(e5) {
            return G.isArray(e5) && !e5.some(le);
          })(e4) || (G.isFileList(e4) || G.endsWith(r4, "[]")) && (a3 = G.toArray(e4))) return r4 = ue(r4), a3.forEach(function(e5, n4) {
            !G.isUndefined(e5) && null !== e5 && t3.append(true === o2 ? de([r4], n4, i2) : null === o2 ? r4 : r4 + "[]", u2(e5));
          }), false;
        }
        return !!le(e4) || (t3.append(de(s4, r4, i2), u2(e4)), false);
      }
      const h2 = [], p2 = Object.assign(he, { defaultVisitor: d2, convertValue: u2, isVisitable: le });
      if (!G.isObject(e3)) throw new TypeError("data must be an object");
      return (function e4(r4, n4, i3 = 0) {
        if (!G.isUndefined(r4)) {
          if (i3 > c2) throw new ce("Object is too deeply nested (" + i3 + " levels). Max depth: " + c2, ce.ERR_FORM_DATA_DEPTH_EXCEEDED);
          if (-1 !== h2.indexOf(r4)) throw Error("Circular reference detected in " + n4.join("."));
          h2.push(r4), G.forEach(r4, function(r5, o3) {
            true === (!(G.isUndefined(r5) || null === r5) && s3.call(t3, r5, G.isString(o3) ? o3.trim() : o3, n4, p2)) && e4(r5, n4 ? n4.concat(o3) : [o3], i3 + 1);
          }), h2.pop();
        }
      })(e3), t3;
    };
    function fe(e3) {
      const t3 = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+" };
      return encodeURIComponent(e3).replace(/[!'()~]|%20/g, function(e4) {
        return t3[e4];
      });
    }
    function ge(e3, t3) {
      this._pairs = [], e3 && pe(e3, this, t3);
    }
    const ye = ge.prototype;
    ye.append = function(e3, t3) {
      this._pairs.push([e3, t3]);
    }, ye.toString = function(e3) {
      const t3 = e3 ? function(t4) {
        return e3.call(this, t4, fe);
      } : fe;
      return this._pairs.map(function(e4) {
        return t3(e4[0]) + "=" + t3(e4[1]);
      }, "").join("&");
    };
    const me = ge;
    function _e(e3) {
      return encodeURIComponent(e3).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
    }
    function we(e3, t3, r3) {
      if (!t3) return e3;
      const n3 = r3 && r3.encode || _e, s3 = G.isFunction(r3) ? { serialize: r3 } : r3, i2 = s3 && s3.serialize;
      let o2;
      if (o2 = i2 ? i2(t3, s3) : G.isURLSearchParams(t3) ? t3.toString() : new me(t3, s3).toString(n3), o2) {
        const t4 = e3.indexOf("#");
        -1 !== t4 && (e3 = e3.slice(0, t4)), e3 += (-1 === e3.indexOf("?") ? "?" : "&") + o2;
      }
      return e3;
    }
    const ve = class {
      constructor() {
        this.handlers = [];
      }
      use(e3, t3, r3) {
        return this.handlers.push({ fulfilled: e3, rejected: t3, synchronous: !!r3 && r3.synchronous, runWhen: r3 ? r3.runWhen : null }), this.handlers.length - 1;
      }
      eject(e3) {
        this.handlers[e3] && (this.handlers[e3] = null);
      }
      clear() {
        this.handlers && (this.handlers = []);
      }
      forEach(e3) {
        G.forEach(this.handlers, function(t3) {
          null !== t3 && e3(t3);
        });
      }
    }, be = { silentJSONParsing: true, forcedJSONParsing: true, clarifyTimeoutError: false, legacyInterceptorReqResOrdering: true }, Se = { isBrowser: true, classes: { URLSearchParams: "undefined" != typeof URLSearchParams ? URLSearchParams : me, FormData: "undefined" != typeof FormData ? FormData : null, Blob: "undefined" != typeof Blob ? Blob : null }, protocols: ["http", "https", "file", "blob", "url", "data"] }, ke = "undefined" != typeof window && "undefined" != typeof document, xe = "object" == typeof navigator && navigator || void 0, Te = ke && (!xe || ["ReactNative", "NativeScript", "NS"].indexOf(xe.product) < 0), Ee = "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope && "function" == typeof self.importScripts, Re = ke && window.location.href || "http://localhost", Ae = { ...e2, ...Se };
    const Oe = function(e3) {
      function t3(e4, r3, n3, s3) {
        let i2 = e4[s3++];
        if ("__proto__" === i2) return true;
        const o2 = Number.isFinite(+i2), a2 = s3 >= e4.length;
        if (i2 = !i2 && G.isArray(n3) ? n3.length : i2, a2) return G.hasOwnProp(n3, i2) ? n3[i2] = G.isArray(n3[i2]) ? n3[i2].concat(r3) : [n3[i2], r3] : n3[i2] = r3, !o2;
        n3[i2] && G.isObject(n3[i2]) || (n3[i2] = []);
        return t3(e4, r3, n3[i2], s3) && G.isArray(n3[i2]) && (n3[i2] = (function(e5) {
          const t4 = {}, r4 = Object.keys(e5);
          let n4;
          const s4 = r4.length;
          let i3;
          for (n4 = 0; n4 < s4; n4++) i3 = r4[n4], t4[i3] = e5[i3];
          return t4;
        })(n3[i2])), !o2;
      }
      if (G.isFormData(e3) && G.isFunction(e3.entries)) {
        const r3 = {};
        return G.forEachEntry(e3, (e4, n3) => {
          t3((function(e5) {
            return G.matchAll(/\w+|\[(\w*)]/g, e5).map((e6) => "[]" === e6[0] ? "" : e6[1] || e6[0]);
          })(e4), n3, r3, 0);
        }), r3;
      }
      return null;
    }, Ce = (e3, t3) => null != e3 && G.hasOwnProp(e3, t3) ? e3[t3] : void 0;
    const Ie = { transitional: be, adapter: ["xhr", "http", "fetch"], transformRequest: [function(e3, t3) {
      const r3 = t3.getContentType() || "", n3 = r3.indexOf("application/json") > -1, s3 = G.isObject(e3);
      s3 && G.isHTMLForm(e3) && (e3 = new FormData(e3));
      if (G.isFormData(e3)) return n3 ? JSON.stringify(Oe(e3)) : e3;
      if (G.isArrayBuffer(e3) || G.isBuffer(e3) || G.isStream(e3) || G.isFile(e3) || G.isBlob(e3) || G.isReadableStream(e3)) return e3;
      if (G.isArrayBufferView(e3)) return e3.buffer;
      if (G.isURLSearchParams(e3)) return t3.setContentType("application/x-www-form-urlencoded;charset=utf-8", false), e3.toString();
      let i2;
      if (s3) {
        const t4 = Ce(this, "formSerializer");
        if (r3.indexOf("application/x-www-form-urlencoded") > -1) return (function(e4, t5) {
          return pe(e4, new Ae.classes.URLSearchParams(), { visitor: function(e5, t6, r4, n4) {
            return Ae.isNode && G.isBuffer(e5) ? (this.append(t6, e5.toString("base64")), false) : n4.defaultVisitor.apply(this, arguments);
          }, ...t5 });
        })(e3, t4).toString();
        if ((i2 = G.isFileList(e3)) || r3.indexOf("multipart/form-data") > -1) {
          const r4 = Ce(this, "env"), n4 = r4 && r4.FormData;
          return pe(i2 ? { "files[]": e3 } : e3, n4 && new n4(), t4);
        }
      }
      return s3 || n3 ? (t3.setContentType("application/json", false), (function(e4, t4, r4) {
        if (G.isString(e4)) try {
          return (t4 || JSON.parse)(e4), G.trim(e4);
        } catch (e5) {
          if ("SyntaxError" !== e5.name) throw e5;
        }
        return (r4 || JSON.stringify)(e4);
      })(e3)) : e3;
    }], transformResponse: [function(e3) {
      const t3 = Ce(this, "transitional") || Ie.transitional, r3 = t3 && t3.forcedJSONParsing, n3 = Ce(this, "responseType"), s3 = "json" === n3;
      if (G.isResponse(e3) || G.isReadableStream(e3)) return e3;
      if (e3 && G.isString(e3) && (r3 && !n3 || s3)) {
        const r4 = !(t3 && t3.silentJSONParsing) && s3;
        try {
          return JSON.parse(e3, Ce(this, "parseReviver"));
        } catch (e4) {
          if (r4) {
            if ("SyntaxError" === e4.name) throw ce.from(e4, ce.ERR_BAD_RESPONSE, this, null, Ce(this, "response"));
            throw e4;
          }
        }
      }
      return e3;
    }], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: Ae.classes.FormData, Blob: Ae.classes.Blob }, validateStatus: function(e3) {
      return e3 >= 200 && e3 < 300;
    }, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
    G.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e3) => {
      Ie.headers[e3] = {};
    });
    const Pe = Ie;
    function Ne(e3, t3) {
      const r3 = this || Pe, n3 = t3 || r3, s3 = ie.from(n3.headers);
      let i2 = n3.data;
      return G.forEach(e3, function(e4) {
        i2 = e4.call(r3, i2, s3.normalize(), t3 ? t3.status : void 0);
      }), s3.normalize(), i2;
    }
    function je(e3) {
      return !(!e3 || !e3.__CANCEL__);
    }
    const Ue = class extends ce {
      constructor(e3, t3, r3) {
        super(null == e3 ? "canceled" : e3, ce.ERR_CANCELED, t3, r3), this.name = "CanceledError", this.__CANCEL__ = true;
      }
    };
    function Le(e3, t3, r3) {
      const n3 = r3.config.validateStatus;
      r3.status && n3 && !n3(r3.status) ? t3(new ce("Request failed with status code " + r3.status, r3.status >= 400 && r3.status < 500 ? ce.ERR_BAD_REQUEST : ce.ERR_BAD_RESPONSE, r3.config, r3.request, r3)) : e3(r3);
    }
    const Fe = function(e3, t3) {
      e3 = e3 || 10;
      const r3 = new Array(e3), n3 = new Array(e3);
      let s3, i2 = 0, o2 = 0;
      return t3 = void 0 !== t3 ? t3 : 1e3, function(a2) {
        const c2 = Date.now(), l2 = n3[o2];
        s3 || (s3 = c2), r3[i2] = a2, n3[i2] = c2;
        let u2 = o2, d2 = 0;
        for (; u2 !== i2; ) d2 += r3[u2++], u2 %= e3;
        if (i2 = (i2 + 1) % e3, i2 === o2 && (o2 = (o2 + 1) % e3), c2 - s3 < t3) return;
        const h2 = l2 && c2 - l2;
        return h2 ? Math.round(1e3 * d2 / h2) : void 0;
      };
    };
    const Me = function(e3, t3) {
      let r3, n3, s3 = 0, i2 = 1e3 / t3;
      const o2 = (t4, i3 = Date.now()) => {
        s3 = i3, r3 = null, n3 && (clearTimeout(n3), n3 = null), e3(...t4);
      };
      return [(...e4) => {
        const t4 = Date.now(), a2 = t4 - s3;
        a2 >= i2 ? o2(e4, t4) : (r3 = e4, n3 || (n3 = setTimeout(() => {
          n3 = null, o2(r3);
        }, i2 - a2)));
      }, () => r3 && o2(r3)];
    }, De = (e3, t3, r3 = 3) => {
      let n3 = 0;
      const s3 = Fe(50, 250);
      return Me((r4) => {
        const i2 = r4.loaded, o2 = r4.lengthComputable ? r4.total : void 0, a2 = null != o2 ? Math.min(i2, o2) : i2, c2 = Math.max(0, a2 - n3), l2 = s3(c2);
        n3 = Math.max(n3, a2);
        e3({ loaded: a2, total: o2, progress: o2 ? a2 / o2 : void 0, bytes: c2, rate: l2 || void 0, estimated: l2 && o2 ? (o2 - a2) / l2 : void 0, event: r4, lengthComputable: null != o2, [t3 ? "download" : "upload"]: true });
      }, r3);
    }, qe = (e3, t3) => {
      const r3 = null != e3;
      return [(n3) => t3[0]({ lengthComputable: r3, total: e3, loaded: n3 }), t3[1]];
    }, $e = (e3) => (...t3) => G.asap(() => e3(...t3)), Be = Ae.hasStandardBrowserEnv ? /* @__PURE__ */ ((e3, t3) => (r3) => (r3 = new URL(r3, Ae.origin), e3.protocol === r3.protocol && e3.host === r3.host && (t3 || e3.port === r3.port)))(new URL(Ae.origin), Ae.navigator && /(msie|trident)/i.test(Ae.navigator.userAgent)) : () => true, ze = Ae.hasStandardBrowserEnv ? { write(e3, t3, r3, n3, s3, i2, o2) {
      if ("undefined" == typeof document) return;
      const a2 = [`${e3}=${encodeURIComponent(t3)}`];
      G.isNumber(r3) && a2.push(`expires=${new Date(r3).toUTCString()}`), G.isString(n3) && a2.push(`path=${n3}`), G.isString(s3) && a2.push(`domain=${s3}`), true === i2 && a2.push("secure"), G.isString(o2) && a2.push(`SameSite=${o2}`), document.cookie = a2.join("; ");
    }, read(e3) {
      if ("undefined" == typeof document) return null;
      const t3 = document.cookie.split(";");
      for (let r3 = 0; r3 < t3.length; r3++) {
        const n3 = t3[r3].replace(/^\s+/, ""), s3 = n3.indexOf("=");
        if (-1 !== s3 && n3.slice(0, s3) === e3) return decodeURIComponent(n3.slice(s3 + 1));
      }
      return null;
    }, remove(e3) {
      this.write(e3, "", Date.now() - 864e5, "/");
    } } : { write() {
    }, read: () => null, remove() {
    } };
    function He(e3, t3, r3) {
      let n3 = !("string" == typeof (s3 = t3) && /^([a-z][a-z\d+\-.]*:)?\/\//i.test(s3));
      var s3;
      return e3 && (n3 || false === r3) ? (function(e4, t4) {
        return t4 ? e4.replace(/\/?\/$/, "") + "/" + t4.replace(/^\/+/, "") : e4;
      })(e3, t3) : t3;
    }
    const Ke = (e3) => e3 instanceof ie ? { ...e3 } : e3;
    function Ve(e3, t3) {
      t3 = t3 || {};
      const r3 = /* @__PURE__ */ Object.create(null);
      function n3(e4, t4, r4, n4) {
        return G.isPlainObject(e4) && G.isPlainObject(t4) ? G.merge.call({ caseless: n4 }, e4, t4) : G.isPlainObject(t4) ? G.merge({}, t4) : G.isArray(t4) ? t4.slice() : t4;
      }
      function s3(e4, t4, r4, s4) {
        return G.isUndefined(t4) ? G.isUndefined(e4) ? void 0 : n3(void 0, e4, 0, s4) : n3(e4, t4, 0, s4);
      }
      function i2(e4, t4) {
        if (!G.isUndefined(t4)) return n3(void 0, t4);
      }
      function o2(e4, t4) {
        return G.isUndefined(t4) ? G.isUndefined(e4) ? void 0 : n3(void 0, e4) : n3(void 0, t4);
      }
      function a2(r4, s4, i3) {
        return G.hasOwnProp(t3, i3) ? n3(r4, s4) : G.hasOwnProp(e3, i3) ? n3(void 0, r4) : void 0;
      }
      Object.defineProperty(r3, "hasOwnProperty", { __proto__: null, value: Object.prototype.hasOwnProperty, enumerable: false, writable: true, configurable: true });
      const c2 = { url: i2, method: i2, data: i2, baseURL: o2, transformRequest: o2, transformResponse: o2, paramsSerializer: o2, timeout: o2, timeoutMessage: o2, withCredentials: o2, withXSRFToken: o2, adapter: o2, responseType: o2, xsrfCookieName: o2, xsrfHeaderName: o2, onUploadProgress: o2, onDownloadProgress: o2, decompress: o2, maxContentLength: o2, maxBodyLength: o2, beforeRedirect: o2, transport: o2, httpAgent: o2, httpsAgent: o2, cancelToken: o2, socketPath: o2, allowedSocketPaths: o2, responseEncoding: o2, validateStatus: a2, headers: (e4, t4, r4) => s3(Ke(e4), Ke(t4), 0, true) };
      return G.forEach(Object.keys({ ...e3, ...t3 }), function(n4) {
        if ("__proto__" === n4 || "constructor" === n4 || "prototype" === n4) return;
        const i3 = G.hasOwnProp(c2, n4) ? c2[n4] : s3, o3 = i3(G.hasOwnProp(e3, n4) ? e3[n4] : void 0, G.hasOwnProp(t3, n4) ? t3[n4] : void 0, n4);
        G.isUndefined(o3) && i3 !== a2 || (r3[n4] = o3);
      }), r3;
    }
    const We = ["content-type", "content-length"];
    const Ze = (e3) => {
      const t3 = Ve({}, e3), r3 = (e4) => G.hasOwnProp(t3, e4) ? t3[e4] : void 0, n3 = r3("data");
      let s3 = r3("withXSRFToken");
      const i2 = r3("xsrfHeaderName"), o2 = r3("xsrfCookieName");
      let a2 = r3("headers");
      const c2 = r3("auth"), l2 = r3("baseURL"), u2 = r3("allowAbsoluteUrls"), d2 = r3("url");
      var h2;
      if (t3.headers = a2 = ie.from(a2), t3.url = we(He(l2, d2, u2), e3.params, e3.paramsSerializer), c2 && a2.set("Authorization", "Basic " + btoa((c2.username || "") + ":" + (c2.password ? (h2 = c2.password, encodeURIComponent(h2).replace(/%([0-9A-F]{2})/gi, (e4, t4) => String.fromCharCode(parseInt(t4, 16)))) : ""))), G.isFormData(n3) && (Ae.hasStandardBrowserEnv || Ae.hasStandardBrowserWebWorkerEnv ? a2.setContentType(void 0) : G.isFunction(n3.getHeaders) && (function(e4, t4, r4) {
        "content-only" === r4 ? Object.entries(t4).forEach(([t5, r5]) => {
          We.includes(t5.toLowerCase()) && e4.set(t5, r5);
        }) : e4.set(t4);
      })(a2, n3.getHeaders(), r3("formDataHeaderPolicy"))), Ae.hasStandardBrowserEnv) {
        G.isFunction(s3) && (s3 = s3(t3));
        if (true === s3 || null == s3 && Be(t3.url)) {
          const e4 = i2 && o2 && ze.read(o2);
          e4 && a2.set(i2, e4);
        }
      }
      return t3;
    };
    (Object.getOwnPropertyDescriptor(Ze, "name") || {}).writable || Object.defineProperty(Ze, "name", { value: "default", configurable: true });
    const Je = "undefined" != typeof XMLHttpRequest && function(e3) {
      return new Promise(function(t3, r3) {
        const n3 = Ze(e3);
        let s3 = n3.data;
        const i2 = ie.from(n3.headers).normalize();
        let o2, a2, c2, l2, u2, { responseType: d2, onUploadProgress: h2, onDownloadProgress: p2 } = n3;
        function f2() {
          l2 && l2(), u2 && u2(), n3.cancelToken && n3.cancelToken.unsubscribe(o2), n3.signal && n3.signal.removeEventListener("abort", o2);
        }
        let g2 = new XMLHttpRequest();
        function y2() {
          if (!g2) return;
          const n4 = ie.from("getAllResponseHeaders" in g2 && g2.getAllResponseHeaders());
          Le(function(e4) {
            t3(e4), f2();
          }, function(e4) {
            r3(e4), f2();
          }, { data: d2 && "text" !== d2 && "json" !== d2 ? g2.response : g2.responseText, status: g2.status, statusText: g2.statusText, headers: n4, config: e3, request: g2 }), g2 = null;
        }
        g2.open(n3.method.toUpperCase(), n3.url, true), g2.timeout = n3.timeout, "onloadend" in g2 ? g2.onloadend = y2 : g2.onreadystatechange = function() {
          g2 && 4 === g2.readyState && (0 !== g2.status || g2.responseURL && g2.responseURL.startsWith("file:")) && setTimeout(y2);
        }, g2.onabort = function() {
          g2 && (r3(new ce("Request aborted", ce.ECONNABORTED, e3, g2)), f2(), g2 = null);
        }, g2.onerror = function(t4) {
          const n4 = t4 && t4.message ? t4.message : "Network Error", s4 = new ce(n4, ce.ERR_NETWORK, e3, g2);
          s4.event = t4 || null, r3(s4), f2(), g2 = null;
        }, g2.ontimeout = function() {
          let t4 = n3.timeout ? "timeout of " + n3.timeout + "ms exceeded" : "timeout exceeded";
          const s4 = n3.transitional || be;
          n3.timeoutErrorMessage && (t4 = n3.timeoutErrorMessage), r3(new ce(t4, s4.clarifyTimeoutError ? ce.ETIMEDOUT : ce.ECONNABORTED, e3, g2)), f2(), g2 = null;
        }, void 0 === s3 && i2.setContentType(null), "setRequestHeader" in g2 && G.forEach(i2.toJSON(), function(e4, t4) {
          g2.setRequestHeader(t4, e4);
        }), G.isUndefined(n3.withCredentials) || (g2.withCredentials = !!n3.withCredentials), d2 && "json" !== d2 && (g2.responseType = n3.responseType), p2 && ([c2, u2] = De(p2, true), g2.addEventListener("progress", c2)), h2 && g2.upload && ([a2, l2] = De(h2), g2.upload.addEventListener("progress", a2), g2.upload.addEventListener("loadend", l2)), (n3.cancelToken || n3.signal) && (o2 = (t4) => {
          g2 && (r3(!t4 || t4.type ? new Ue(null, e3, g2) : t4), g2.abort(), f2(), g2 = null);
        }, n3.cancelToken && n3.cancelToken.subscribe(o2), n3.signal && (n3.signal.aborted ? o2() : n3.signal.addEventListener("abort", o2)));
        const m2 = (function(e4) {
          const t4 = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e4);
          return t4 && t4[1] || "";
        })(n3.url);
        !m2 || Ae.protocols.includes(m2) ? g2.send(s3 || null) : r3(new ce("Unsupported protocol " + m2 + ":", ce.ERR_BAD_REQUEST, e3));
      });
    }, Ge = (e3, t3) => {
      const { length: r3 } = e3 = e3 ? e3.filter(Boolean) : [];
      if (t3 || r3) {
        let r4, n3 = new AbortController();
        const s3 = function(e4) {
          if (!r4) {
            r4 = true, o2();
            const t4 = e4 instanceof Error ? e4 : this.reason;
            n3.abort(t4 instanceof ce ? t4 : new Ue(t4 instanceof Error ? t4.message : t4));
          }
        };
        let i2 = t3 && setTimeout(() => {
          i2 = null, s3(new ce(`timeout of ${t3}ms exceeded`, ce.ETIMEDOUT));
        }, t3);
        const o2 = () => {
          e3 && (i2 && clearTimeout(i2), i2 = null, e3.forEach((e4) => {
            e4.unsubscribe ? e4.unsubscribe(s3) : e4.removeEventListener("abort", s3);
          }), e3 = null);
        };
        e3.forEach((e4) => e4.addEventListener("abort", s3));
        const { signal: a2 } = n3;
        return a2.unsubscribe = () => G.asap(o2), a2;
      }
    }, Xe = function* (e3, t3) {
      let r3 = e3.byteLength;
      if (!t3 || r3 < t3) return void (yield e3);
      let n3, s3 = 0;
      for (; s3 < r3; ) n3 = s3 + t3, yield e3.slice(s3, n3), s3 = n3;
    }, Qe = async function* (e3) {
      if (e3[Symbol.asyncIterator]) return void (yield* e3);
      const t3 = e3.getReader();
      try {
        for (; ; ) {
          const { done: e4, value: r3 } = await t3.read();
          if (e4) break;
          yield r3;
        }
      } finally {
        await t3.cancel();
      }
    }, Ye = (e3, t3, r3, n3) => {
      const s3 = (async function* (e4, t4) {
        for await (const r4 of Qe(e4)) yield* Xe(r4, t4);
      })(e3, t3);
      let i2, o2 = 0, a2 = (e4) => {
        i2 || (i2 = true, n3 && n3(e4));
      };
      return new ReadableStream({ async pull(e4) {
        try {
          const { done: t4, value: n4 } = await s3.next();
          if (t4) return a2(), void e4.close();
          let i3 = n4.byteLength;
          if (r3) {
            let e5 = o2 += i3;
            r3(e5);
          }
          e4.enqueue(new Uint8Array(n4));
        } catch (e5) {
          throw a2(e5), e5;
        }
      }, cancel: (e4) => (a2(e4), s3.return()) }, { highWaterMark: 2 });
    };
    const et = "1.16.0", { isFunction: tt } = G, rt = (e3, ...t3) => {
      try {
        return !!e3(...t3);
      } catch (e4) {
        return false;
      }
    }, nt = (e3) => {
      const t3 = G.global ?? globalThis, { ReadableStream: r3, TextEncoder: n3 } = t3;
      e3 = G.merge.call({ skipUndefined: true }, { Request: t3.Request, Response: t3.Response }, e3);
      const { fetch: s3, Request: i2, Response: o2 } = e3, a2 = s3 ? tt(s3) : "function" == typeof fetch, c2 = tt(i2), l2 = tt(o2);
      if (!a2) return false;
      const u2 = a2 && tt(r3), d2 = a2 && ("function" == typeof n3 ? (h2 = new n3(), (e4) => h2.encode(e4)) : async (e4) => new Uint8Array(await new i2(e4).arrayBuffer()));
      var h2;
      const p2 = c2 && u2 && rt(() => {
        let e4 = false;
        const t4 = new i2(Ae.origin, { body: new r3(), method: "POST", get duplex() {
          return e4 = true, "half";
        } }), n4 = t4.headers.has("Content-Type");
        return null != t4.body && t4.body.cancel(), e4 && !n4;
      }), f2 = l2 && u2 && rt(() => G.isReadableStream(new o2("").body)), g2 = { stream: f2 && ((e4) => e4.body) };
      a2 && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e4) => {
        !g2[e4] && (g2[e4] = (t4, r4) => {
          let n4 = t4 && t4[e4];
          if (n4) return n4.call(t4);
          throw new ce(`Response type '${e4}' is not supported`, ce.ERR_NOT_SUPPORT, r4);
        });
      });
      const y2 = async (e4, t4) => {
        const r4 = G.toFiniteNumber(e4.getContentLength());
        return null == r4 ? (async (e5) => {
          if (null == e5) return 0;
          if (G.isBlob(e5)) return e5.size;
          if (G.isSpecCompliantForm(e5)) {
            const t5 = new i2(Ae.origin, { method: "POST", body: e5 });
            return (await t5.arrayBuffer()).byteLength;
          }
          return G.isArrayBufferView(e5) || G.isArrayBuffer(e5) ? e5.byteLength : (G.isURLSearchParams(e5) && (e5 += ""), G.isString(e5) ? (await d2(e5)).byteLength : void 0);
        })(t4) : r4;
      };
      return async (e4) => {
        let { url: t4, method: r4, data: a3, signal: l3, cancelToken: u3, timeout: d3, onDownloadProgress: h3, onUploadProgress: m2, responseType: _2, headers: w2, withCredentials: v2 = "same-origin", fetchOptions: b2, maxContentLength: S2, maxBodyLength: k2 } = Ze(e4);
        const x2 = G.isNumber(S2) && S2 > -1, T2 = G.isNumber(k2) && k2 > -1;
        let E2 = s3 || fetch;
        _2 = _2 ? (_2 + "").toLowerCase() : "text";
        let R2 = Ge([l3, u3 && u3.toAbortSignal()], d3), A2 = null;
        const O2 = R2 && R2.unsubscribe && (() => {
          R2.unsubscribe();
        });
        let C2;
        try {
          if (x2 && "string" == typeof t4 && t4.startsWith("data:")) {
            const r5 = (function(e5) {
              if (!e5 || "string" != typeof e5) return 0;
              if (!e5.startsWith("data:")) return 0;
              const t5 = e5.indexOf(",");
              if (t5 < 0) return 0;
              const r6 = e5.slice(5, t5), n4 = e5.slice(t5 + 1);
              if (/;base64/i.test(r6)) {
                let e6 = n4.length;
                const t6 = n4.length;
                for (let r8 = 0; r8 < t6; r8++) if (37 === n4.charCodeAt(r8) && r8 + 2 < t6) {
                  const t7 = n4.charCodeAt(r8 + 1), s7 = n4.charCodeAt(r8 + 2);
                  (t7 >= 48 && t7 <= 57 || t7 >= 65 && t7 <= 70 || t7 >= 97 && t7 <= 102) && (s7 >= 48 && s7 <= 57 || s7 >= 65 && s7 <= 70 || s7 >= 97 && s7 <= 102) && (e6 -= 2, r8 += 2);
                }
                let r7 = 0, s6 = t6 - 1;
                const i3 = (e7) => e7 >= 2 && 37 === n4.charCodeAt(e7 - 2) && 51 === n4.charCodeAt(e7 - 1) && (68 === n4.charCodeAt(e7) || 100 === n4.charCodeAt(e7));
                s6 >= 0 && (61 === n4.charCodeAt(s6) ? (r7++, s6--) : i3(s6) && (r7++, s6 -= 3)), 1 === r7 && s6 >= 0 && (61 === n4.charCodeAt(s6) || i3(s6)) && r7++;
                const o3 = 3 * Math.floor(e6 / 4) - (r7 || 0);
                return o3 > 0 ? o3 : 0;
              }
              if ("undefined" != typeof Buffer && "function" == typeof Buffer.byteLength) return Buffer.byteLength(n4, "utf8");
              let s5 = 0;
              for (let e6 = 0, t6 = n4.length; e6 < t6; e6++) {
                const r7 = n4.charCodeAt(e6);
                if (r7 < 128) s5 += 1;
                else if (r7 < 2048) s5 += 2;
                else if (r7 >= 55296 && r7 <= 56319 && e6 + 1 < t6) {
                  const t7 = n4.charCodeAt(e6 + 1);
                  t7 >= 56320 && t7 <= 57343 ? (s5 += 4, e6++) : s5 += 3;
                } else s5 += 3;
              }
              return s5;
            })(t4);
            if (r5 > S2) throw new ce("maxContentLength size of " + S2 + " exceeded", ce.ERR_BAD_RESPONSE, e4, A2);
          }
          if (T2 && "get" !== r4 && "head" !== r4) {
            const t5 = await y2(w2, a3);
            if ("number" == typeof t5 && isFinite(t5) && t5 > k2) throw new ce("Request body larger than maxBodyLength limit", ce.ERR_BAD_REQUEST, e4, A2);
          }
          if (m2 && p2 && "get" !== r4 && "head" !== r4 && 0 !== (C2 = await y2(w2, a3))) {
            let e5, r5 = new i2(t4, { method: "POST", body: a3, duplex: "half" });
            if (G.isFormData(a3) && (e5 = r5.headers.get("content-type")) && w2.setContentType(e5), r5.body) {
              const [e6, t5] = qe(C2, De($e(m2)));
              a3 = Ye(r5.body, 65536, e6, t5);
            }
          }
          G.isString(v2) || (v2 = v2 ? "include" : "omit");
          const s4 = c2 && "credentials" in i2.prototype;
          if (G.isFormData(a3)) {
            const e5 = w2.getContentType();
            e5 && /^multipart\/form-data/i.test(e5) && !/boundary=/i.test(e5) && w2.delete("content-type");
          }
          w2.set("User-Agent", "axios/" + et, false);
          const l4 = { ...b2, signal: R2, method: r4.toUpperCase(), headers: w2.normalize().toJSON(), body: a3, duplex: "half", credentials: s4 ? v2 : void 0 };
          A2 = c2 && new i2(t4, l4);
          let u4 = await (c2 ? E2(A2, b2) : E2(t4, l4));
          if (x2) {
            const t5 = G.toFiniteNumber(u4.headers.get("content-length"));
            if (null != t5 && t5 > S2) throw new ce("maxContentLength size of " + S2 + " exceeded", ce.ERR_BAD_RESPONSE, e4, A2);
          }
          const d4 = f2 && ("stream" === _2 || "response" === _2);
          if (f2 && u4.body && (h3 || x2 || d4 && O2)) {
            const t5 = {};
            ["status", "statusText", "headers"].forEach((e5) => {
              t5[e5] = u4[e5];
            });
            const r5 = G.toFiniteNumber(u4.headers.get("content-length")), [n4, s5] = h3 && qe(r5, De($e(h3), true)) || [];
            let i3 = 0;
            const a4 = (t6) => {
              if (x2 && (i3 = t6, i3 > S2)) throw new ce("maxContentLength size of " + S2 + " exceeded", ce.ERR_BAD_RESPONSE, e4, A2);
              n4 && n4(t6);
            };
            u4 = new o2(Ye(u4.body, 65536, a4, () => {
              s5 && s5(), O2 && O2();
            }), t5);
          }
          _2 = _2 || "text";
          let I2 = await g2[G.findKey(g2, _2) || "text"](u4, e4);
          if (x2 && !f2 && !d4) {
            let t5;
            if (null != I2 && ("number" == typeof I2.byteLength ? t5 = I2.byteLength : "number" == typeof I2.size ? t5 = I2.size : "string" == typeof I2 && (t5 = "function" == typeof n3 ? new n3().encode(I2).byteLength : I2.length)), "number" == typeof t5 && t5 > S2) throw new ce("maxContentLength size of " + S2 + " exceeded", ce.ERR_BAD_RESPONSE, e4, A2);
          }
          return !d4 && O2 && O2(), await new Promise((t5, r5) => {
            Le(t5, r5, { data: I2, headers: ie.from(u4.headers), status: u4.status, statusText: u4.statusText, config: e4, request: A2 });
          });
        } catch (t5) {
          if (O2 && O2(), R2 && R2.aborted && R2.reason instanceof ce) {
            const r5 = R2.reason;
            throw r5.config = e4, A2 && (r5.request = A2), t5 !== r5 && (r5.cause = t5), r5;
          }
          if (t5 && "TypeError" === t5.name && /Load failed|fetch/i.test(t5.message)) throw Object.assign(new ce("Network Error", ce.ERR_NETWORK, e4, A2, t5 && t5.response), { cause: t5.cause || t5 });
          throw ce.from(t5, t5 && t5.code, e4, A2, t5 && t5.response);
        }
      };
    }, st = /* @__PURE__ */ new Map(), it = (e3) => {
      let t3 = e3 && e3.env || {};
      const { fetch: r3, Request: n3, Response: s3 } = t3, i2 = [n3, s3, r3];
      let o2, a2, c2 = i2.length, l2 = st;
      for (; c2--; ) o2 = i2[c2], a2 = l2.get(o2), void 0 === a2 && l2.set(o2, a2 = c2 ? /* @__PURE__ */ new Map() : nt(t3)), l2 = a2;
      return a2;
    }, ot = (it(), { http: null, xhr: Je, fetch: { get: it } });
    G.forEach(ot, (e3, t3) => {
      if (e3) {
        try {
          Object.defineProperty(e3, "name", { __proto__: null, value: t3 });
        } catch (e4) {
        }
        Object.defineProperty(e3, "adapterName", { __proto__: null, value: t3 });
      }
    });
    const at = (e3) => `- ${e3}`, ct = (e3) => G.isFunction(e3) || null === e3 || false === e3;
    const lt = { getAdapter: function(e3, t3) {
      e3 = G.isArray(e3) ? e3 : [e3];
      const { length: r3 } = e3;
      let n3, s3;
      const i2 = {};
      for (let o2 = 0; o2 < r3; o2++) {
        let r4;
        if (n3 = e3[o2], s3 = n3, !ct(n3) && (s3 = ot[(r4 = String(n3)).toLowerCase()], void 0 === s3)) throw new ce(`Unknown adapter '${r4}'`);
        if (s3 && (G.isFunction(s3) || (s3 = s3.get(t3)))) break;
        i2[r4 || "#" + o2] = s3;
      }
      if (!s3) {
        const e4 = Object.entries(i2).map(([e5, t5]) => `adapter ${e5} ` + (false === t5 ? "is not supported by the environment" : "is not available in the build"));
        let t4 = r3 ? e4.length > 1 ? "since :\n" + e4.map(at).join("\n") : " " + at(e4[0]) : "as no adapter specified";
        throw new ce("There is no suitable adapter to dispatch the request " + t4, "ERR_NOT_SUPPORT");
      }
      return s3;
    }, adapters: ot };
    function ut(e3) {
      if (e3.cancelToken && e3.cancelToken.throwIfRequested(), e3.signal && e3.signal.aborted) throw new Ue(null, e3);
    }
    function dt(e3) {
      ut(e3), e3.headers = ie.from(e3.headers), e3.data = Ne.call(e3, e3.transformRequest), -1 !== ["post", "put", "patch"].indexOf(e3.method) && e3.headers.setContentType("application/x-www-form-urlencoded", false);
      return lt.getAdapter(e3.adapter || Pe.adapter, e3)(e3).then(function(t3) {
        ut(e3), e3.response = t3;
        try {
          t3.data = Ne.call(e3, e3.transformResponse, t3);
        } finally {
          delete e3.response;
        }
        return t3.headers = ie.from(t3.headers), t3;
      }, function(t3) {
        if (!je(t3) && (ut(e3), t3 && t3.response)) {
          e3.response = t3.response;
          try {
            t3.response.data = Ne.call(e3, e3.transformResponse, t3.response);
          } finally {
            delete e3.response;
          }
          t3.response.headers = ie.from(t3.response.headers);
        }
        return Promise.reject(t3);
      });
    }
    const ht = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach((e3, t3) => {
      ht[e3] = function(r3) {
        return typeof r3 === e3 || "a" + (t3 < 1 ? "n " : " ") + e3;
      };
    });
    const pt = {};
    ht.transitional = function(e3, t3, r3) {
      function n3(e4, t4) {
        return "[Axios v" + et + "] Transitional option '" + e4 + "'" + t4 + (r3 ? ". " + r3 : "");
      }
      return (r4, s3, i2) => {
        if (false === e3) throw new ce(n3(s3, " has been removed" + (t3 ? " in " + t3 : "")), ce.ERR_DEPRECATED);
        return t3 && !pt[s3] && (pt[s3] = true, console.warn(n3(s3, " has been deprecated since v" + t3 + " and will be removed in the near future"))), !e3 || e3(r4, s3, i2);
      };
    }, ht.spelling = function(e3) {
      return (t3, r3) => (console.warn(`${r3} is likely a misspelling of ${e3}`), true);
    };
    const ft = { assertOptions: function(e3, t3, r3) {
      if ("object" != typeof e3) throw new ce("options must be an object", ce.ERR_BAD_OPTION_VALUE);
      const n3 = Object.keys(e3);
      let s3 = n3.length;
      for (; s3-- > 0; ) {
        const i2 = n3[s3], o2 = Object.prototype.hasOwnProperty.call(t3, i2) ? t3[i2] : void 0;
        if (o2) {
          const t4 = e3[i2], r4 = void 0 === t4 || o2(t4, i2, e3);
          if (true !== r4) throw new ce("option " + i2 + " must be " + r4, ce.ERR_BAD_OPTION_VALUE);
          continue;
        }
        if (true !== r3) throw new ce("Unknown option " + i2, ce.ERR_BAD_OPTION);
      }
    }, validators: ht }, gt = ft.validators;
    class yt {
      constructor(e3) {
        this.defaults = e3 || {}, this.interceptors = { request: new ve(), response: new ve() };
      }
      async request(e3, t3) {
        try {
          return await this._request(e3, t3);
        } catch (e4) {
          if (e4 instanceof Error) {
            let t4 = {};
            Error.captureStackTrace ? Error.captureStackTrace(t4) : t4 = new Error();
            const r3 = (() => {
              if (!t4.stack) return "";
              const e5 = t4.stack.indexOf("\n");
              return -1 === e5 ? "" : t4.stack.slice(e5 + 1);
            })();
            try {
              if (e4.stack) {
                if (r3) {
                  const t5 = r3.indexOf("\n"), n3 = -1 === t5 ? -1 : r3.indexOf("\n", t5 + 1), s3 = -1 === n3 ? "" : r3.slice(n3 + 1);
                  String(e4.stack).endsWith(s3) || (e4.stack += "\n" + r3);
                }
              } else e4.stack = r3;
            } catch (e5) {
            }
          }
          throw e4;
        }
      }
      _request(e3, t3) {
        "string" == typeof e3 ? (t3 = t3 || {}).url = e3 : t3 = e3 || {}, t3 = Ve(this.defaults, t3);
        const { transitional: r3, paramsSerializer: n3, headers: s3 } = t3;
        void 0 !== r3 && ft.assertOptions(r3, { silentJSONParsing: gt.transitional(gt.boolean), forcedJSONParsing: gt.transitional(gt.boolean), clarifyTimeoutError: gt.transitional(gt.boolean), legacyInterceptorReqResOrdering: gt.transitional(gt.boolean) }, false), null != n3 && (G.isFunction(n3) ? t3.paramsSerializer = { serialize: n3 } : ft.assertOptions(n3, { encode: gt.function, serialize: gt.function }, true)), void 0 !== t3.allowAbsoluteUrls || (void 0 !== this.defaults.allowAbsoluteUrls ? t3.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t3.allowAbsoluteUrls = true), ft.assertOptions(t3, { baseUrl: gt.spelling("baseURL"), withXsrfToken: gt.spelling("withXSRFToken") }, true), t3.method = (t3.method || this.defaults.method || "get").toLowerCase();
        let i2 = s3 && G.merge(s3.common, s3[t3.method]);
        s3 && G.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (e4) => {
          delete s3[e4];
        }), t3.headers = ie.concat(i2, s3);
        const o2 = [];
        let a2 = true;
        this.interceptors.request.forEach(function(e4) {
          if ("function" == typeof e4.runWhen && false === e4.runWhen(t3)) return;
          a2 = a2 && e4.synchronous;
          const r4 = t3.transitional || be;
          r4 && r4.legacyInterceptorReqResOrdering ? o2.unshift(e4.fulfilled, e4.rejected) : o2.push(e4.fulfilled, e4.rejected);
        });
        const c2 = [];
        let l2;
        this.interceptors.response.forEach(function(e4) {
          c2.push(e4.fulfilled, e4.rejected);
        });
        let u2, d2 = 0;
        if (!a2) {
          const e4 = [dt.bind(this), void 0];
          for (e4.unshift(...o2), e4.push(...c2), u2 = e4.length, l2 = Promise.resolve(t3); d2 < u2; ) l2 = l2.then(e4[d2++], e4[d2++]);
          return l2;
        }
        u2 = o2.length;
        let h2 = t3;
        for (; d2 < u2; ) {
          const e4 = o2[d2++], t4 = o2[d2++];
          try {
            h2 = e4(h2);
          } catch (e5) {
            t4.call(this, e5);
            break;
          }
        }
        try {
          l2 = dt.call(this, h2);
        } catch (e4) {
          return Promise.reject(e4);
        }
        for (d2 = 0, u2 = c2.length; d2 < u2; ) l2 = l2.then(c2[d2++], c2[d2++]);
        return l2;
      }
      getUri(e3) {
        return we(He((e3 = Ve(this.defaults, e3)).baseURL, e3.url, e3.allowAbsoluteUrls), e3.params, e3.paramsSerializer);
      }
    }
    G.forEach(["delete", "get", "head", "options"], function(e3) {
      yt.prototype[e3] = function(t3, r3) {
        return this.request(Ve(r3 || {}, { method: e3, url: t3, data: (r3 || {}).data }));
      };
    }), G.forEach(["post", "put", "patch", "query"], function(e3) {
      function t3(t4) {
        return function(r3, n3, s3) {
          return this.request(Ve(s3 || {}, { method: e3, headers: t4 ? { "Content-Type": "multipart/form-data" } : {}, url: r3, data: n3 }));
        };
      }
      yt.prototype[e3] = t3(), "query" !== e3 && (yt.prototype[e3 + "Form"] = t3(true));
    });
    const mt = yt;
    class _t {
      constructor(e3) {
        if ("function" != typeof e3) throw new TypeError("executor must be a function.");
        let t3;
        this.promise = new Promise(function(e4) {
          t3 = e4;
        });
        const r3 = this;
        this.promise.then((e4) => {
          if (!r3._listeners) return;
          let t4 = r3._listeners.length;
          for (; t4-- > 0; ) r3._listeners[t4](e4);
          r3._listeners = null;
        }), this.promise.then = (e4) => {
          let t4;
          const n3 = new Promise((e5) => {
            r3.subscribe(e5), t4 = e5;
          }).then(e4);
          return n3.cancel = function() {
            r3.unsubscribe(t4);
          }, n3;
        }, e3(function(e4, n3, s3) {
          r3.reason || (r3.reason = new Ue(e4, n3, s3), t3(r3.reason));
        });
      }
      throwIfRequested() {
        if (this.reason) throw this.reason;
      }
      subscribe(e3) {
        this.reason ? e3(this.reason) : this._listeners ? this._listeners.push(e3) : this._listeners = [e3];
      }
      unsubscribe(e3) {
        if (!this._listeners) return;
        const t3 = this._listeners.indexOf(e3);
        -1 !== t3 && this._listeners.splice(t3, 1);
      }
      toAbortSignal() {
        const e3 = new AbortController(), t3 = (t4) => {
          e3.abort(t4);
        };
        return this.subscribe(t3), e3.signal.unsubscribe = () => this.unsubscribe(t3), e3.signal;
      }
      static source() {
        let e3;
        return { token: new _t(function(t3) {
          e3 = t3;
        }), cancel: e3 };
      }
    }
    const wt = _t;
    const vt = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511, WebServerIsDown: 521, ConnectionTimedOut: 522, OriginIsUnreachable: 523, TimeoutOccurred: 524, SslHandshakeFailed: 525, InvalidSslCertificate: 526 };
    Object.entries(vt).forEach(([e3, t3]) => {
      vt[t3] = e3;
    });
    const bt = vt;
    const St = (function e3(t3) {
      const n3 = new mt(t3), s3 = r2(mt.prototype.request, n3);
      return G.extend(s3, mt.prototype, n3, { allOwnKeys: true }), G.extend(s3, n3, null, { allOwnKeys: true }), s3.create = function(r3) {
        return e3(Ve(t3, r3));
      }, s3;
    })(Pe);
    St.Axios = mt, St.CanceledError = Ue, St.CancelToken = wt, St.isCancel = je, St.VERSION = et, St.toFormData = pe, St.AxiosError = ce, St.Cancel = St.CanceledError, St.all = function(e3) {
      return Promise.all(e3);
    }, St.spread = function(e3) {
      return function(t3) {
        return e3.apply(null, t3);
      };
    }, St.isAxiosError = function(e3) {
      return G.isObject(e3) && true === e3.isAxiosError;
    }, St.mergeConfig = Ve, St.AxiosHeaders = ie, St.formToJSON = (e3) => Oe(G.isHTMLForm(e3) ? new FormData(e3) : e3), St.getAdapter = lt.getAdapter, St.HttpStatusCode = bt, St.default = St;
    const kt = St, xt = "tokensInfo", Tt = "isRefreshingAccessTokenInfo", Et = (() => {
      try {
        return crypto.randomUUID();
      } catch {
        return Array.from({ length: 4 }).map((e3) => (16777215 * Math.random() | 0).toString(16)).join("-");
      }
    })();
    let Rt = null;
    const At = (e3) => {
      const t3 = new CustomEvent(e3.type, { detail: e3 });
      window.dispatchEvent(t3);
    }, Ot = (e3) => {
      const t3 = Rt || (Rt = new BroadcastChannel("sarex_tokenSync"), Rt.addEventListener("message", (e4) => {
        e4.data.owner !== jt() && (console.debug("[SDK] This page ID: ", jt()), console.debug("[SDK] Handle broadcast event from page: ", e4.data.owner, e4.data), At(e4.data));
      }), Rt);
      t3?.postMessage(e3), At(e3);
    }, Ct = (e3) => {
      if ("document" in self) {
        const t3 = (t4) => e3(!document.hidden);
        return self.document.addEventListener("visibilitychange", t3), e3(!document.hidden), () => self.document.removeEventListener("visibilitychange", t3);
      }
      return e3(true), () => {
      };
    };
    let It = true, Pt = 0;
    Ct((e3) => {
      if (clearTimeout(Pt), !e3) return console.log("[SDK] Run passivation"), void (Pt = setTimeout(() => {
        It = false, console.warn("[SDK] Page not active, GET requests will suppressed!");
      }, 9e4));
      It = e3;
    });
    const Nt = async (e3) => navigator.locks.request("AUTH_REFRESH_LOCK", e3), jt = () => Et, Ut = () => true === window.isRefreshingNow, Lt = ({ isExpired: e3, reason: t3 }) => {
      Ft({ isExpired: e3, reason: t3 });
    }, Ft = ({ isRefreshing: e3, isExpired: t3, reason: r3 }) => {
      null != e3 && Ot({ type: Tt, isRefreshing: e3, owner: jt() }), null != t3 && Ot({ type: xt, isExpired: t3, reason: r3, owner: jt() });
    }, Mt = ({ fn: e3 }) => {
      window.addEventListener(xt, e3);
    }, Dt = ({ fn: e3 }) => (window.addEventListener(Tt, e3), () => {
      window.removeEventListener(Tt, e3);
    });
    let qt = null;
    const $t = (e3) => {
      qt = e3;
    }, Bt = () => qt;
    function zt(e3) {
      for (var t3 = 1; t3 < arguments.length; t3++) {
        var r3 = arguments[t3];
        for (var n3 in r3) e3[n3] = r3[n3];
      }
      return e3;
    }
    var Ht = (function e3(t3, r3) {
      function n3(e4, n4, s3) {
        if ("undefined" != typeof document) {
          "number" == typeof (s3 = zt({}, r3, s3)).expires && (s3.expires = new Date(Date.now() + 864e5 * s3.expires)), s3.expires && (s3.expires = s3.expires.toUTCString()), e4 = encodeURIComponent(e4).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
          var i2 = "";
          for (var o2 in s3) s3[o2] && (i2 += "; " + o2, true !== s3[o2] && (i2 += "=" + s3[o2].split(";")[0]));
          return document.cookie = e4 + "=" + t3.write(n4, e4) + i2;
        }
      }
      return Object.create({ set: n3, get: function(e4) {
        if ("undefined" != typeof document && (!arguments.length || e4)) {
          for (var r4 = document.cookie ? document.cookie.split("; ") : [], n4 = {}, s3 = 0; s3 < r4.length; s3++) {
            var i2 = r4[s3].split("="), o2 = i2.slice(1).join("=");
            try {
              var a2 = decodeURIComponent(i2[0]);
              if (n4[a2] = t3.read(o2, a2), e4 === a2) break;
            } catch (e5) {
            }
          }
          return e4 ? n4[e4] : n4;
        }
      }, remove: function(e4, t4) {
        n3(e4, "", zt({}, t4, { expires: -1 }));
      }, withAttributes: function(t4) {
        return e3(this.converter, zt({}, this.attributes, t4));
      }, withConverter: function(t4) {
        return e3(zt({}, this.converter, t4), this.attributes);
      } }, { attributes: { value: Object.freeze(r3) }, converter: { value: Object.freeze(t3) } });
    })({ read: function(e3) {
      return '"' === e3[0] && (e3 = e3.slice(1, -1)), e3.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    }, write: function(e3) {
      return encodeURIComponent(e3).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    } }, { path: "/" });
    const Kt = "X-CSRFToken";
    var Vt;
    !(function(e3) {
      e3.CLIENT_ID = "client_id", e3.ACCESS_TOKEN = "sarex_at", e3.REFRESH_TOKEN = "sarex_rt", e3.REFRESH_VERSION = "sarex_rt_ver", e3.EXTERNAL_RECOVER_STATE = "sarex_zitadel_external_recover_state", e3.IDENTITY_TOKEN = "sarex_idt", e3.EXTERNAL_COOKIE_INFO = "isUsingExternalCookie", e3.CSRF = "csrftoken", e3.AUTHORITY = "authority";
    })(Vt || (Vt = {}));
    const Wt = () => localStorage.getItem(Vt.ACCESS_TOKEN), Zt = () => localStorage.getItem(Vt.REFRESH_TOKEN), Jt = () => localStorage.getItem(Vt.IDENTITY_TOKEN), Gt = () => localStorage.getItem(Vt.CLIENT_ID), Xt = () => localStorage.getItem(Vt.EXTERNAL_COOKIE_INFO), Qt = () => Ht.get(Vt.CSRF), Yt = () => {
      const e3 = +(localStorage.getItem(Vt.REFRESH_VERSION) || "-1"), t3 = Zt(), r3 = isFinite(e3) ? e3 : -1;
      return !t3 && r3 >= 0 ? (console.warn("[SDK] Refresh token was removed outside own service. Version resync detected!"), localStorage.removeItem(Vt.REFRESH_VERSION), -1) : r3;
    }, er = () => {
      const e3 = localStorage.getItem(Vt.EXTERNAL_RECOVER_STATE);
      if (!e3) return null;
      try {
        const t3 = JSON.parse(e3);
        return "number" == typeof t3.refreshVersion && "number" == typeof t3.updatedAt && ["started", "failed", "resolved"].includes(t3.status) ? t3 : null;
      } catch {
        return null;
      }
    }, tr = (e3) => {
      localStorage.setItem(Vt.ACCESS_TOKEN, e3);
    }, rr = (e3) => {
      localStorage.setItem(Vt.REFRESH_TOKEN, e3), localStorage.setItem(Vt.REFRESH_VERSION, "" + (Yt() + 1));
    }, nr = (e3) => {
      localStorage.setItem(Vt.IDENTITY_TOKEN, e3);
    }, sr = (e3) => {
      localStorage.setItem(Vt.CLIENT_ID, e3);
    }, ir = (e3) => {
      localStorage.setItem(Vt.EXTERNAL_COOKIE_INFO, e3.toString());
    }, or = (e3) => {
      Ht.set(Vt.CSRF, e3);
    }, ar = (e3) => {
      const t3 = er();
      localStorage.setItem(Vt.EXTERNAL_RECOVER_STATE, JSON.stringify({ ...e3, extra: e3.extra ?? t3?.extra, updatedAt: Date.now() }));
    }, cr = (e3) => {
      const t3 = er();
      t3 && ar({ refreshVersion: t3.refreshVersion, status: t3.status, reason: t3.reason, resolvedRefreshVersion: t3.resolvedRefreshVersion, extra: e3 });
    }, lr = () => {
      localStorage.removeItem(Vt.ACCESS_TOKEN);
    }, ur = () => {
      localStorage.removeItem(Vt.REFRESH_TOKEN), localStorage.removeItem(Vt.REFRESH_VERSION), localStorage.removeItem(Vt.EXTERNAL_RECOVER_STATE);
    }, dr = () => {
      localStorage.removeItem(Vt.EXTERNAL_COOKIE_INFO);
    }, hr = () => {
      Ht.remove(Vt.CSRF);
    }, pr = () => {
      localStorage.removeItem(Vt.IDENTITY_TOKEN);
    }, fr = () => {
      localStorage.removeItem(Vt.CLIENT_ID);
    }, gr = "jwt-session-based";
    let yr = { type: "zitadel", oidcProviderConfig: { host: "", clientId: "" }, accessTokenRefreshRetryCount: null }, mr = false;
    const _r = (e3) => {
    }, wr = (e3) => {
      yr = { ...yr, ...e3 };
    }, vr = (e3) => {
      mr = e3;
    }, br = () => yr, Sr = () => yr.type, kr = () => mr, xr = 15e4, Tr = "", Er = ":", Rr = "", Ar = 32, Or = 5e4, Cr = new AbortController().signal, Ir = () => Object.assign(new Error("canceled"), { code: "ERR_CANCELED", name: "CanceledError" });
    const Pr = new class {
      constructor() {
        __publicField(this, "entries", /* @__PURE__ */ new Map());
        __publicField(this, "inFlight", /* @__PURE__ */ new Map());
        __publicField(this, "clock", 0);
        __publicField(this, "clearedAt", 0);
        __publicField(this, "tagInvalidatedAt", /* @__PURE__ */ new Map());
        __publicField(this, "tagIndex", /* @__PURE__ */ new Map());
      }
      get epoch() {
        return this.clock;
      }
      getEntry(e3) {
        const t3 = this.entries.get(e3);
        if (t3) {
          if (!(Date.now() > t3.staleUntil)) return this.entries.delete(e3), this.entries.set(e3, t3), { value: t3.value, etag: t3.etag, isFresh: Date.now() <= t3.expiresAt };
          this.removeEntry(e3);
        }
      }
      get(e3) {
        const t3 = this.getEntry(e3);
        return t3?.isFresh ? t3.value : void 0;
      }
      set(e3, t3, r3, n3 = [], s3 = this.clock, i2, o2 = 3e5) {
        if (this.isStale(n3, s3)) return;
        this.removeEntry(e3);
        const a2 = Date.now() + r3;
        if (this.entries.set(e3, { value: t3, expiresAt: a2, staleUntil: a2 + o2, tags: n3, etag: i2 }), this.indexKey(e3, n3), this.maybeSweep(), this.entries.size > xr) {
          const e4 = this.entries.keys().next().value;
          void 0 !== e4 && this.removeEntry(e4);
        }
      }
      maybeSweep() {
        if (this.entries.size <= 75e3) return;
        const e3 = Date.now();
        let t3 = 8;
        for (const [r3, n3] of this.entries) {
          if (t3-- <= 0) break;
          e3 > n3.staleUntil && this.removeEntry(r3);
        }
      }
      pruneTagInvalidations() {
        if (0 === this.inFlight.size) return void this.tagInvalidatedAt.clear();
        let e3 = 1 / 0;
        for (const { startedAt: t3 } of this.inFlight.values()) t3 < e3 && (e3 = t3);
        for (const [t3, r3] of this.tagInvalidatedAt) r3 <= e3 && this.tagInvalidatedAt.delete(t3);
      }
      isStale(e3, t3) {
        if (t3 < this.clearedAt) return true;
        for (const r3 of e3) {
          let e4 = false;
          if (this.forEachTagPrefix(r3, (r4) => {
            const n3 = this.tagInvalidatedAt.get(r4);
            void 0 !== n3 && n3 > t3 && (e4 = true);
          }), e4) return true;
        }
        return false;
      }
      invalidateByTags(e3 = []) {
        if (!e3.length) return;
        const t3 = ++this.clock;
        for (const r3 of e3) this.tagInvalidatedAt.delete(r3), this.tagInvalidatedAt.set(r3, t3);
        for (const t4 of e3) {
          const e4 = this.tagIndex.get(t4);
          if (e4) for (const t5 of [...e4]) this.removeEntry(t5);
        }
        if (this.tagInvalidatedAt.size > 1e4) {
          const e4 = this.tagInvalidatedAt.keys().next().value;
          void 0 !== e4 && this.tagInvalidatedAt.delete(e4);
        }
      }
      delete(e3) {
        this.removeEntry(e3);
      }
      clear() {
        this.clearedAt = ++this.clock, this.tagInvalidatedAt.clear(), this.entries.clear(), this.tagIndex.clear(), this.inFlight.clear();
      }
      dedupe(e3, t3, r3 = [], n3) {
        const s3 = this.inFlight.get(e3);
        let i2;
        if (s3 && !this.isStale(s3.tags, s3.startedAt)) i2 = s3.promise;
        else {
          const n4 = this.clock, s4 = t3().finally(() => {
            this.inFlight.get(e3)?.promise === s4 && (this.inFlight.delete(e3), this.pruneTagInvalidations());
          });
          this.inFlight.set(e3, { promise: s4, startedAt: n4, tags: r3 }), i2 = s4;
        }
        return this.isolate(i2, n3);
      }
      isolate(e3, t3) {
        return t3 ? t3.aborted ? Promise.reject(Ir()) : new Promise((r3, n3) => {
          const s3 = () => n3(Ir());
          t3.addEventListener("abort", s3, { once: true }), e3.then((e4) => {
            t3.removeEventListener("abort", s3), r3(e4);
          }, (e4) => {
            t3.removeEventListener("abort", s3), n3(e4);
          });
        }) : e3;
      }
      touch(e3, t3, r3 = this.clock, n3 = 3e5) {
        const s3 = this.entries.get(e3);
        return !!s3 && (!this.isStale(s3.tags, r3) && (s3.expiresAt = Date.now() + t3, s3.staleUntil = s3.expiresAt + n3, this.entries.delete(e3), this.entries.set(e3, s3), true));
      }
      forEachTagPrefix(e3, t3) {
        t3(e3);
        let r3 = -1;
        for (; -1 !== (r3 = e3.indexOf(Er, r3 + 1)); ) t3(e3.slice(0, r3));
      }
      indexKey(e3, t3) {
        for (const r3 of t3) this.forEachTagPrefix(r3, (t4) => {
          let r4 = this.tagIndex.get(t4);
          r4 || this.tagIndex.set(t4, r4 = /* @__PURE__ */ new Set()), r4.add(e3);
        });
      }
      unindexKey(e3, t3) {
        for (const r3 of t3) this.forEachTagPrefix(r3, (t4) => {
          const r4 = this.tagIndex.get(t4);
          r4 && (r4.delete(e3), 0 === r4.size && this.tagIndex.delete(t4));
        });
      }
      removeEntry(e3) {
        const t3 = this.entries.get(e3);
        t3 && (this.unindexKey(e3, t3.tags), this.entries.delete(e3));
      }
    }(), Nr = (e3) => encodeURIComponent(String(e3)), jr = (...e3) => e3.map(Nr).join(Er), Ur = (e3) => e3, Lr = { workspaces: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u043E\u0431\u043B\u0430\u0441\u0442\u0435\u0439", google: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445", bim: "\u0421\u0435\u0440\u0432\u0438\u0441 BIM", bimv2: "\u0421\u0435\u0440\u0432\u0438\u0441 BIM_V2", absolute: "\u0421\u0435\u0440\u0432\u0438\u0441", sarex: "\u041B\u043E\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0435\u0440\u0432\u0438\u0441 \u0434\u0430\u043D\u043D\u044B\u0445", documentations: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u0438", workflows: "\u0421\u0435\u0440\u0432\u0438\u0441 \u043E\u0431\u0440\u0430\u0431\u043E\u0442\u043A\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432", sarexApi: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0434\u0430\u043D\u043D\u044B\u0445", comparisons: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u0439", remarks: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0437\u0430\u043C\u0435\u0447\u0430\u043D\u0438\u0439", gateway: "\u0421\u0435\u0440\u0432\u0438\u0441 gateway", projects: "\u0421\u0435\u0440\u0432\u0438\u0441 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432", eavV1: "\u0421\u0435\u0440\u0432\u0438\u0441 eav", notifications: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439", zitadel: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0410\u0443\u0442\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438", relative: "\u0421\u0435\u0440\u0432\u0438\u0441 relative", processes: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0432", files: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0444\u0430\u0439\u043B\u043E\u0432", transmittals: "\u0421\u0435\u0440\u0432\u0438\u0441 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u0438", flows: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u043F\u0440\u043E\u0446\u0435\u0441\u0441\u043E\u0432", drawings: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0447\u0435\u0440\u0442\u0435\u0436\u0435\u0439", notes: "\u0421\u0435\u0440\u0432\u0438\u0441 \u0437\u0430\u043C\u0435\u0442\u043E\u043A", contracts: "\u0421\u0435\u0440\u0432\u0438\u0441 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u043E\u0432" }, Fr = { 400: (e3) => `\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u0444\u043E\u0440\u043C\u0430\u0442 \u0437\u0430\u043F\u0440\u043E\u0441\u0430, \u043E\u0448\u0438\u0431\u043A\u0430 ${e3}`, 403: (e3) => `\u0414\u043E\u0441\u0442\u0443\u043F \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D, \u043E\u0448\u0438\u0431\u043A\u0430 ${e3}`, 404: (e3) => `\u0420\u0435\u0441\u0443\u0440\u0441 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D, \u043E\u0448\u0438\u0431\u043A\u0430 ${e3}`, 500: (e3) => `\u041E\u0448\u0438\u0431\u043A\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430, \u043E\u0448\u0438\u0431\u043A\u0430 ${e3}`, default: (e3) => `\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u0448\u0438\u0431\u043A\u0430, \u043A\u043E\u0434 ${e3}` }, Mr = (e3, t3) => {
      const r3 = Lr[e3] ?? "\u0421\u0435\u0440\u0432\u0438\u0441", n3 = ((e4) => Fr[e4] ? Fr[e4](e4) : e4 >= 400 && e4 < 500 && Fr[400] ? Fr[400](e4) : Fr[500] ? Fr[500](e4) : void 0)(t3);
      return `${r3} \u0432\u0435\u0440\u043D\u0443\u043B \u043E\u0448\u0438\u0431\u043A\u0443: ${n3}.`;
    };
    var Dr = i(8673);
    const qr = ({ type: e3, message: t3 }) => {
      switch (e3) {
        case "success":
        default:
          Dr.toast.success(t3);
          break;
        case "error":
          Dr.toast.error(t3);
          break;
        case "info":
          Dr.toast.info(t3);
          break;
        case "warning":
          Dr.toast.warning(t3);
      }
    }, $r = ({ notificationType: e3, successMessage: t3 }) => {
      e3 && t3 && qr({ message: t3, type: e3 });
    }, Br = ({ service: e3, buildEnv: t3, hosts: r3 }) => {
      const n3 = window.location.origin;
      if ("relative" === e3) return n3;
      const s3 = r3[t3];
      if (s3 && void 0 !== s3.hosts[e3]) {
        const r4 = s3.hosts[e3], i2 = r4.endsWith("/") ? r4.slice(0, -1) : r4;
        return "contour" === t3 ? `${n3}${i2}` : i2;
      }
      return console.warn(`Service ${e3} not found for environment ${t3}.`), "";
    }, zr = ({ currentConfig: e3, newConfig: t3 }) => ({ ...e3, ...t3, headers: { ...e3.headers, ...t3?.headers || {} } }), Hr = (e3, t3, r3) => {
      const n3 = r3 && r3 >= 400 ? Mr(e3, r3) : ((e4, t4) => `${Lr[e4] ?? "\u0421\u0435\u0440\u0432\u0438\u0441"} \u0432\u0435\u0440\u043D\u0443\u043B \u043E\u0448\u0438\u0431\u043A\u0443: ${t4.name}: ${t4.message}.`)(e3, t3);
      return { ...t3, errMessage: n3 };
    }, Kr = (e3) => {
      const t3 = ((e4) => {
        try {
          const t4 = e4.split(".")[1];
          return JSON.parse(atob(t4));
        } catch (e5) {
          return null;
        }
      })(e3);
      if (!t3?.exp) return null;
      const r3 = Math.floor(Date.now() / 1e3);
      return t3.exp - r3;
    }, Vr = async (e3, t3 = {}) => {
      const { maxAttempts: r3 = 1, baseDelay: n3 = 1e3, shouldRetry: s3 = () => true } = t3;
      let i2, o2 = 0;
      for (; o2 < r3; ) try {
        return await e3();
      } catch (e4) {
        if (o2++, i2 = e4, o2 >= r3 || !s3(e4)) throw i2;
        const t4 = n3 * Math.pow(2, o2 - 1);
        await new Promise((e5) => setTimeout(e5, t4));
      }
      throw i2;
    }, Wr = (e3, t3 = 0) => {
      let r3 = 3735928559 ^ t3, n3 = 1103547991 ^ t3;
      for (let t4 = 0; t4 < e3.length; t4++) {
        const s3 = e3.charCodeAt(t4);
        r3 = Math.imul(r3 ^ s3, 2654435761), n3 = Math.imul(n3 ^ s3, 1597334677);
      }
      return r3 = Math.imul(r3 ^ r3 >>> 16, 2246822507) ^ Math.imul(n3 ^ n3 >>> 13, 3266489909), n3 = Math.imul(n3 ^ n3 >>> 16, 2246822507) ^ Math.imul(r3 ^ r3 >>> 13, 3266489909), 4294967296 * (2097151 & n3) + (r3 >>> 0);
    };
    function Zr(e3, t3 = 0) {
      return Wr(e3, t3).toString(36);
    }
    const Jr = () => Pr, Gr = 12, Xr = 16, Qr = 64, Yr = (e3) => Number.isInteger(e3) && e3 >= -1073741824 && e3 <= 1073741823, en = () => ({ objects: /* @__PURE__ */ new WeakSet(), strings: /* @__PURE__ */ new Set() }), tn = (e3, t3) => t3.strings.has(e3) ? 0 : (t3.strings.add(e3), ((e4) => {
      return t4 = 12 + (((e5) => {
        for (let t5 = 0; t5 < e5.length; t5++) if (e5.charCodeAt(t5) > 255) return false;
        return true;
      })(e4) ? e4.length : 2 * e4.length), t4 + 7 & -8;
      // removed by dead control flow
 var t4; 
    })(e3)), rn = (e3, t3) => {
      if (null == e3 || "boolean" == typeof e3) return 0;
      if ("number" == typeof e3) return Yr(e3) ? 0 : 12;
      if ("string" == typeof e3) return tn(e3, t3);
      if ("bigint" == typeof e3) return 12;
      if ("object" != typeof e3) return 0;
      if (t3.objects.has(e3)) return 0;
      if (t3.objects.add(e3), "undefined" != typeof Blob && e3 instanceof Blob) return e3.size;
      if (e3 instanceof ArrayBuffer) return e3.byteLength;
      if (ArrayBuffer.isView(e3)) {
        const { buffer: r4 } = e3;
        return t3.objects.has(r4) ? Gr : (t3.objects.add(r4), Gr + r4.byteLength);
      }
      if (e3 instanceof Date) return 20;
      if (e3 instanceof Map) {
        let r4 = Qr + 22 * e3.size;
        for (const [n4, s3] of e3) r4 += rn(n4, t3) + rn(s3, t3);
        return r4;
      }
      if (e3 instanceof Set) {
        let r4 = Qr + 16 * e3.size;
        for (const n4 of e3) r4 += rn(n4, t3);
        return r4;
      }
      if (Array.isArray(e3)) {
        if (0 === e3.length) return Xr;
        if (e3.every((e4) => "number" == typeof e4)) {
          const t4 = e3.every(Yr) ? 4 : 8;
          return 24 + e3.length * t4;
        }
        let r4 = 24 + 4 * e3.length;
        for (const n4 of e3) r4 += rn(n4, t3);
        return r4;
      }
      const r3 = Object.keys(e3);
      let n3 = Gr + 4 * r3.length;
      for (const s3 of r3) n3 += rn(e3[s3], t3);
      return n3;
    }, nn = (e3, t3, r3 = en()) => {
      let n3 = 78 + tn(e3, r3);
      t3.etag && (n3 += tn(t3.etag, r3)), n3 += 0 === t3.tags.length ? Xr : 24 + 4 * t3.tags.length;
      for (const e4 of t3.tags) n3 += tn(e4, r3);
      return n3 + rn(t3.value, r3);
    }, sn = (e3) => +(e3 / 1048576).toFixed(3), on = () => {
      const e3 = Date.now();
      return [...Jr().entries].map(([t3, r3]) => ({ key: t3, tags: r3.tags.join(", "), body: pn(t3)?.slice(0, 120) ?? "", custom: t3.includes(Rr), state: e3 <= r3.expiresAt ? "fresh" : e3 <= r3.staleUntil ? "stale" : "dead", msToExpire: r3.expiresAt - e3, msToDead: r3.staleUntil - e3, etag: r3.etag ?? "", approxKB: +(nn(t3, r3) / 1024).toFixed(2) }));
    }, an = [];
    let cn = false;
    const ln = (e3, t3, r3) => {
      an.push({ t: Date.now(), event: e3, key: t3, info: r3 }), an.length > 500 && an.shift(), cn && console.debug(`[cache] ${e3}`, t3 ?? "", r3 ?? "");
    };
    let un = false;
    const dn = /* @__PURE__ */ new Map(), hn = (e3, t3) => {
      if (dn.delete(e3), dn.set(e3, t3), dn.size > 200) {
        const e4 = dn.keys().next().value;
        void 0 !== e4 && dn.delete(e4);
      }
    }, pn = (e3) => dn.get(e3), fn = /* @__PURE__ */ new Map();
    function gn(e3) {
      if (null == e3) return false;
      if ("object" != typeof e3) return false;
      if ("undefined" != typeof ArrayBuffer && e3 instanceof ArrayBuffer) return true;
      if ("undefined" != typeof ArrayBuffer && ArrayBuffer.isView(e3)) return true;
      if ("undefined" != typeof Blob && e3 instanceof Blob) return true;
      if ("undefined" != typeof FormData && e3 instanceof FormData) return true;
      if ("undefined" != typeof URLSearchParams && e3 instanceof URLSearchParams) return true;
      if ("undefined" != typeof ReadableStream && e3 instanceof ReadableStream) return true;
      const t3 = e3;
      return !("function" != typeof t3.pipe || "function" != typeof t3.read && !t3._readableState);
    }
    let yn = null;
    function mn(e3, t3 = /* @__PURE__ */ new WeakSet(), r3 = 0, n3 = { nodes: 0 }) {
      if (n3.nodes += 1, n3.nodes > Or) throw new TypeError(`Cannot serialize to cache key: too many nodes (>${Or})`);
      if (r3 > Ar) throw new TypeError(`Cannot serialize to cache key: max depth ${Ar} exceeded`);
      if (void 0 === e3) return "undefined";
      if (null === e3) return "null";
      if ("number" == typeof e3) return String(e3);
      if ("bigint" == typeof e3 || "function" == typeof e3 || "symbol" == typeof e3) throw new TypeError(`Cannot serialize ${typeof e3} to cache key`);
      if ("object" != typeof e3) return JSON.stringify(e3);
      if (e3 instanceof Date) return JSON.stringify(e3.toISOString());
      if (gn(e3)) throw new TypeError(`Cannot serialize ${(function(e4) {
        return null == e4 ? String(e4) : "undefined" != typeof ArrayBuffer && e4 instanceof ArrayBuffer ? "ArrayBuffer" : "undefined" != typeof ArrayBuffer && ArrayBuffer.isView(e4) ? e4.constructor?.name || "ArrayBufferView" : "undefined" != typeof Blob && e4 instanceof Blob ? e4.constructor?.name || "Blob" : "undefined" != typeof FormData && e4 instanceof FormData ? "FormData" : "undefined" != typeof URLSearchParams && e4 instanceof URLSearchParams ? "URLSearchParams" : "undefined" != typeof ReadableStream && e4 instanceof ReadableStream ? "ReadableStream" : "object" == typeof e4 && null !== e4 && "function" == typeof e4.pipe ? "Stream" : Object.prototype.toString.call(e4);
      })(e3)} to cache key (non-JSON body)`);
      if (t3.has(e3)) throw new TypeError("Converting circular structure to cache key");
      const s3 = (function() {
        if (yn) return yn;
        const e4 = /* @__PURE__ */ new Map();
        return yn = e4, queueMicrotask(() => {
          e4.clear(), yn === e4 && (yn = null);
        }), e4;
      })(), i2 = s3.get(e3);
      if (void 0 !== i2) return i2;
      t3.add(e3);
      try {
        let i3;
        if (Array.isArray(e3)) i3 = `[${e3.map((e4) => mn(e4, t3, r3 + 1, n3)).join(",")}]`;
        else {
          i3 = `{${Object.keys(e3).filter((t4) => void 0 !== e3[t4]).sort().map((s4) => `${JSON.stringify(s4)}:${mn(e3[s4], t3, r3 + 1, n3)}`).join(",")}}`;
        }
        return s3.set(e3, i3), i3;
      } finally {
        t3.delete(e3);
      }
    }
    function _n(e3, t3, r3, n3) {
      try {
        return (function(e4, t4, r4, n4) {
          if (gn(n4)) throw new TypeError("Cannot build cache key from non-JSON body");
          const s3 = mn(n4 ?? null), i2 = s3.length > 512, o2 = i2 ? `#${s3.length}${Tr}${Wr(s3).toString(36)}` : s3, a2 = `${e4}${Tr}${t4}${Tr}${r4}${Tr}${o2}`;
          return i2 && hn(a2, s3), a2;
        })(e3, t3, r3, n3);
      } catch (e4) {
        return e4 instanceof TypeError || console.error("[sdk-js cache] unexpected error while building cache key", e4), null;
      }
    }
    const wn = ["common", "get", "post", "put", "patch", "delete", "head"], vn = (e3) => null != e3 && "object" == typeof e3 && !Array.isArray(e3);
    function bn(e3, t3, r3) {
      if (!t3?.length) return;
      const n3 = (function(e4, t4) {
        const r4 = /* @__PURE__ */ new Map(), n4 = (e5, t5) => {
          null != t5 && false !== t5 && (Array.isArray(t5) ? r4.set(e5.toLowerCase(), t5.map(String).join(", ")) : "object" != typeof t5 && r4.set(e5.toLowerCase(), String(t5)));
        }, s4 = (e5) => {
          if (!vn(e5)) return;
          const t5 = e5.toJSON, r5 = "function" == typeof t5 ? t5.call(e5) : e5;
          if (vn(r5)) for (const [e6, t6] of Object.entries(r5)) wn.includes(e6) || n4(e6, t6);
        };
        return vn(e4) ? (wn.some((t5) => t5 in e4) ? (s4(e4.common), t4 && s4(e4[t4.toLowerCase()]), s4(e4)) : s4(e4), r4) : r4;
      })(e3, r3), s3 = {};
      for (const e4 of t3) {
        const t4 = n3.get(e4.toLowerCase());
        void 0 !== t4 && (s3[e4] = t4);
      }
      const i2 = Object.keys(s3);
      if (!i2.length) return;
      i2.sort((e4, t4) => e4.localeCompare(t4));
      const o2 = {};
      for (const e4 of i2) o2[e4] = s3[e4];
      return o2;
    }
    function Sn(e3, t3, r3, n3) {
      const s3 = "GET" === e3 ? null : t3, i2 = void 0 !== r3, o2 = void 0 !== n3;
      return i2 || o2 ? { body: s3, ...i2 ? { params: r3 } : {}, ...o2 ? { headers: n3 } : {} } : s3;
    }
    function kn(e3, t3) {
      return t3 && 0 !== Object.keys(t3).length ? `${e3}${Tr}${mn(t3)}` : e3;
    }
    const xn = (e3) => Sn(e3.method, e3.data, e3.params, e3.headers);
    function Tn(e3, t3, r3, n3) {
      let s3;
      try {
        s3 = e3(t3);
      } catch (e4) {
        return console.error("[sdk-js cache] cache.cacheKey threw; falling back to default key", e4), _n(r3, n3, t3.path, xn(t3));
      }
      return "string" != typeof s3 || 0 === s3.length ? (console.error("[sdk-js cache] cache.cacheKey must return a non-empty string; falling back to default key", { got: s3 }), _n(r3, n3, t3.path, xn(t3))) : `${r3}${Tr}${n3}${Tr}${Rr}${((e4) => {
        let t4 = "";
        for (let r4 = 0; r4 < e4.length; r4++) {
          const n4 = e4.charCodeAt(r4);
          t4 += n4 < 32 || 37 === n4 ? `%${n4.toString(16).padStart(2, "0").toUpperCase()}` : e4[r4];
        }
        return t4.length > 1024 ? `#${t4.length}${Tr}${Zr(t4)}` : t4;
      })(s3)}`;
    }
    function En(e3, t3) {
      return `${e3}${Er}${Nr(t3)}`;
    }
    const Rn = (e3, t3) => {
      if (!e3) return [];
      return ("function" == typeof e3 ? e3(t3) : e3).map((e4) => Ur(String(e4)));
    }, An = ({ method: e3, service: t3, baseURL: r3, url: n3, data: s3, params: i2, headers: o2, keyBuilder: a2 }) => {
      const c2 = t3 ?? "http", l2 = `${r3 ?? ""}${n3}`, u2 = bn(o2, br().cacheVaryHeaders, e3);
      if (a2) {
        const t4 = { service: c2, method: e3, baseURL: r3, url: n3, path: l2, data: "GET" === e3 ? void 0 : s3, params: i2, ...u2 ? { headers: u2 } : {} }, o3 = Tn(a2, t4, c2, e3);
        if (null == o3) return null;
        const d2 = o3.includes(Rr) ? kn(o3, u2) : o3;
        if (d2.includes(Rr) && kr()) {
          let e4;
          try {
            e4 = mn({ path: l2, data: t4.data, params: i2, headers: u2 });
          } catch {
            e4 = `${String(l2)}|${String(t4.data)}|${String(i2)}|${String(u2)}`;
          }
          ((e5, t5) => {
            if (!kr()) return;
            hn(e5, t5);
            const r4 = Zr(t5), n4 = fn.get(e5);
            if (n4 && n4.originHash !== r4 && console.error("[sdk-js cache] custom cacheKey collision: same key for different requests", { key: e5, previous: n4.origin, current: t5 }), fn.delete(e5), fn.set(e5, { originHash: r4, origin: t5 }), fn.size > 200) {
              const e6 = fn.keys().next().value;
              void 0 !== e6 && fn.delete(e6);
            }
          })(d2, e4);
        }
        return d2;
      }
      return _n(c2, e3, l2, Sn(e3, s3, i2, u2));
    }, On = () => {
      Pr.clear();
    }, Cn = (e3 = []) => {
      e3.length && Pr.invalidateByTags(e3.map((e4) => Ur(String(e4))));
    };
    async function In({ key: e3, cache: t3, forceRequest: r3 = false, ttlMs: n3, tags: s3 = [], retry: i2, signal: o2, axiosRequest: a2 }) {
      const c2 = t3 && !r3 ? Pr.getEntry(e3) : void 0, l2 = void 0 !== c2;
      if (t3 && !r3 && c2?.isFresh) return { response: c2.value, fromCache: true, hadEntry: l2 };
      const u2 = t3 && !r3 && c2 && !c2.isFresh ? c2.etag : void 0, d2 = t3 && n3 > 0, h2 = d2 ? Cr : o2, p2 = (e4) => Vr(() => a2(h2, e4), { maxAttempts: void 0 !== i2 ? i2 + 1 : 1, baseDelay: 1e3, shouldRetry: () => !!Zt() }), f2 = (r4, i3) => {
        !t3 || n3 <= 0 || 304 !== r4.status && Pr.set(e3, r4, n3, s3, i3, ((e4) => {
          const t4 = e4.headers?.etag ?? e4.headers?.ETag;
          return "string" == typeof t4 && t4.length > 0 ? t4 : void 0;
        })(r4));
      }, g2 = async () => {
        const t4 = Pr.epoch, r4 = await p2(u2 ? { "If-None-Match": u2 } : void 0);
        if (304 === r4.status) {
          if (u2 && Pr.touch(e3, n3, t4)) return c2.value;
          const r5 = Pr.epoch, s4 = await p2();
          return f2(s4, r5), s4;
        }
        return f2(r4, t4), r4;
      };
      return { response: d2 ? await Pr.dedupe(e3, g2, s3, o2) : await g2(), fromCache: false, hadEntry: l2 };
    }
    const Pn = (e3, t3) => {
      const r3 = Rn(e3, t3);
      r3.length && Pr.invalidateByTags(r3);
    };
    function Nn(e3) {
      return { getIds: ({ data: t3 }) => {
        const r3 = t3?.[e3.idsParam];
        return Array.isArray(r3) ? r3 : [];
      }, withIds: ({ data: t3, url: r3 }, n3) => ({ url: r3, data: { ...t3 ?? {}, [e3.idsParam]: n3 } }), getNamespace: ({ data: t3 }) => e3.getNamespace(t3), unwrapItems: e3.unwrapItems, getItemId: e3.getItemId, rewrap: e3.rewrap, onUnresolvedIds: e3.onUnresolvedIds };
    }
    async function jn({ method: e3, service: t3, baseURL: r3, params: n3, headers: s3, ctx: i2, config: o2, ttlMs: a2, forceRequest: c2 = false, signal: l2, execute: u2 }) {
      const d2 = Ur(String(o2.getNamespace(i2))), h2 = o2.getIds(i2).map((e4) => ({ id: e4, key: String(e4) })), p2 = bn(s3, br().cacheVaryHeaders, e3), f2 = (e4) => kn(En(d2, e4), p2), g2 = async (s4) => {
        const c3 = o2.withIds(i2, s4), h3 = o2.withIds(i2, ((e4) => [...e4].sort((e5, t4) => String(e5).localeCompare(String(t4))))(s4)), g3 = `${r3 ?? ""}${h3.url}`, y3 = Sn(e3, h3.data, n3, p2), m3 = _n(t3, e3, g3, y3);
        if (!m3) {
          const e4 = Pr.epoch, t4 = await u2(c3, Cr);
          for (const r4 of o2.unwrapItems(t4.data)) {
            const t5 = String(o2.getItemId(r4)), n4 = En(d2, t5);
            Pr.set(f2(t5), r4, a2, [d2, n4], e4);
          }
          return t4;
        }
        const _3 = [d2, ...s4.map((e4) => En(d2, String(e4)))];
        return Pr.dedupe(m3, async () => {
          const e4 = Pr.epoch, t4 = await u2(c3, Cr);
          for (const r4 of o2.unwrapItems(t4.data)) {
            const t5 = String(o2.getItemId(r4)), n4 = En(d2, t5);
            Pr.set(f2(t5), r4, a2, [d2, n4], e4);
          }
          return t4;
        }, _3, l2);
      }, y2 = /* @__PURE__ */ new Map(), m2 = [], _2 = /* @__PURE__ */ new Set();
      let w2, v2, b2 = false;
      for (const { id: e4, key: t4 } of h2) {
        if (c2) {
          _2.has(t4) || (_2.add(t4), m2.push(e4));
          continue;
        }
        const r4 = Pr.get(f2(t4));
        void 0 !== r4 ? (b2 = true, y2.set(t4, r4)) : _2.has(t4) || (_2.add(t4), m2.push(e4));
      }
      if (m2.length > 0) {
        const e4 = Pr.epoch, t4 = await g2(m2);
        w2 = t4, v2 = t4.data;
        for (const e5 of o2.unwrapItems(t4.data)) y2.set(String(o2.getItemId(e5)), e5);
        if (Pr.epoch > e4) {
          const e5 = [], t5 = /* @__PURE__ */ new Set();
          for (const { id: r4, key: n4 } of h2) {
            const s4 = Pr.get(f2(n4));
            void 0 !== s4 ? y2.set(n4, s4) : (y2.delete(n4), t5.has(n4) || (t5.add(n4), e5.push(r4)));
          }
          if (e5.length > 0) {
            await g2(e5);
            for (const t6 of e5) {
              const e6 = String(t6), r4 = Pr.get(f2(e6));
              void 0 !== r4 && y2.set(e6, r4);
            }
          }
        }
      }
      const S2 = [], k2 = [], x2 = /* @__PURE__ */ new Set();
      for (const { id: e4, key: t4 } of h2) {
        const r4 = y2.get(t4);
        void 0 !== r4 ? S2.push(r4) : x2.has(t4) || (x2.add(t4), k2.push(e4));
      }
      const T2 = o2.rewrap(S2, v2);
      return k2.length > 0 && o2.onUnresolvedIds?.(k2), { data: T2, fromNetwork: void 0 !== w2, hadEntry: b2, networkResponse: w2, unresolvedIds: k2.length > 0 ? k2 : void 0 };
    }
    const Un = { inspect: () => {
      const e3 = Jr(), t3 = en();
      let r3 = 0;
      for (const [n4, s4] of e3.entries) r3 += nn(n4, s4, t3);
      const n3 = ((e4, t4) => {
        let r4 = Qr;
        for (const [n4, s4] of e4.tagIndex) r4 += 86 + 16 * s4.size + tn(n4, t4);
        return r4;
      })(e3, t3), s3 = ((e4) => {
        let t4 = 0;
        if (dn) {
          t4 += Qr;
          for (const [r4, n4] of dn) t4 += 22 + tn(r4, e4) + tn(n4, e4);
        }
        t4 += 24 + 4 * an.length;
        for (const r4 of an) t4 += 28 + rn(r4.key, e4) + rn(r4.info, e4);
        return t4;
      })(t3);
      return { clock: e3.clock, clearedAt: e3.clearedAt, entries: e3.entries.size, limit: xr, fill: +(e3.entries.size / xr * 100).toFixed(1) + "%", inFlight: [...e3.inFlight.keys()], tagInvalidatedAt: [...e3.tagInvalidatedAt], approxMB: sn(r3), tagIndexMB: sn(n3), devMB: sn(s3), totalMB: sn(r3 + n3 + s3), worstCaseMB: e3.entries.size ? sn((r3 + n3) / e3.entries.size * xr) : 0 };
    }, byTag: () => {
      const e3 = Jr();
      return [...e3.tagIndex].map(([t3, r3]) => {
        const n3 = en();
        let s3 = Qr + 16 * r3.size;
        for (const t4 of r3) {
          const r4 = e3.entries.get(t4);
          r4 && (s3 += nn(t4, r4, n3));
        }
        return { tag: t3, keys: r3.size, approxKB: +(s3 / 1024).toFixed(2) };
      }).sort((e4, t3) => t3.approxKB - e4.approxKB);
    }, entries: on, table: () => {
      console.table(on());
    }, history: (e3 = 50) => e3 > 0 ? an.slice(-e3) : [], trace: (e3 = true) => (((e4) => {
      cn = e4;
    })(e3), e3 ? "cache trace ON" : "cache trace OFF"), clear: () => Pr.clear() };
    let Ln = false;
    const Fn = () => {
      kr() && (Ln || (Ln = true, (() => {
        if (un) return;
        un = true;
        const e3 = Pr, t3 = e3.getEntry.bind(e3);
        e3.getEntry = (e4) => {
          const r4 = t3(e4);
          return ln(r4 ? r4.isFresh ? "hit" : "stale-hit" : "miss", e4), r4;
        };
        const r3 = e3.set.bind(e3);
        e3.set = (e4, ...t4) => {
          r3(e4, ...t4), ln(Jr().entries.has(e4) ? "set" : "set-discarded", e4);
        };
        const n3 = e3.invalidateByTags.bind(e3);
        e3.invalidateByTags = (e4 = []) => {
          n3(e4), e4?.length && ln("invalidate", void 0, e4);
        };
        const s3 = e3.touch.bind(e3);
        e3.touch = (e4, ...t4) => {
          const r4 = s3(e4, ...t4);
          return ln(r4 ? "304-touch" : "304-touch-fail", e4), r4;
        };
        const i2 = e3.dedupe.bind(e3);
        e3.dedupe = (t4, r4, n4 = [], s4) => {
          const o3 = Jr().inFlight.get(t4), a2 = o3 && !e3.isStale(o3.tags, o3.startedAt);
          return ln(a2 ? "dedupe-join" : o3 ? "dedupe-restart" : "dedupe-start", t4), i2(t4, r4, n4, s4);
        };
        const o2 = e3.clear.bind(e3);
        e3.clear = () => {
          o2(), ln("clear");
        };
      })()), globalThis.__cache = Un);
    }, Mn = ({ message: e3, buildEnv: t3 }) => {
      "local" !== t3 && "stage" !== t3 || console.log(e3);
    };
    const Dn = class {
      constructor({ config: e3 = { accessTokenRefreshRetryCount: 7 }, httpRequests: t3, interceptors: r3, axiosConfig: n3, buildEnv: s3, hosts: i2, removeTokensFN: o2, getValidAccessTokenFN: a2, getAuthHeadersFN: c2, refreshAccessTokenFN: l2, loginFN: u2 }) {
        __publicField(this, "config", {});
        __publicField(this, "axiosConfig", {});
        __publicField(this, "interceptors");
        __publicField(this, "httpRequests");
        __publicField(this, "removeTokensFN");
        __publicField(this, "getValidAccessTokenFN");
        __publicField(this, "getAuthHeadersFN");
        __publicField(this, "refreshAccessTokenFN");
        __publicField(this, "loginFN");
        __publicField(this, "activeControllers", /* @__PURE__ */ new Set());
        __publicField(this, "TOKEN_LIFETIME_THRESHOLD", 120);
        __publicField(this, "tokenRefreshTimeoutId", null);
        __publicField(this, "buildEnv");
        __publicField(this, "hosts");
        this.axiosConfig = zr({ currentConfig: this.axiosConfig, newConfig: n3 || {} }), this.config = { ...e3, accessTokenRefreshRetryCount: br().accessTokenRefreshRetryCount ?? e3.accessTokenRefreshRetryCount }, this.interceptors = r3, this.httpRequests = t3, this.buildEnv = s3, this.hosts = i2, this.removeTokensFN = o2, this.getValidAccessTokenFN = a2, this.getAuthHeadersFN = c2, this.refreshAccessTokenFN = l2, this.loginFN = u2, this.setupTokenObserver();
      }
      createInstance({ axiosConfig: e3 = {}, isCSRF: t3, service: r3, controller: n3, withoutInterceptors: s3, withoutAutoLogout: i2, withoutAutoAbort: o2 = false }) {
        const a2 = n3 || new AbortController();
        o2 || (this.activeControllers.add(a2), a2.signal.addEventListener("abort", () => {
          this.activeControllers.delete(a2);
        }));
        const c2 = zr({ currentConfig: this.axiosConfig, newConfig: { ...e3, baseURL: Br({ service: r3, buildEnv: this.buildEnv, hosts: this.hosts }), signal: a2.signal } }), l2 = kt.create(c2);
        if (e3.headers?.Authorization) l2.interceptors.request.use((e4) => (e4.headers.Authorization = e4.headers?.Authorization, e4));
        else if (!s3) {
          const e4 = "true" === Xt();
          this.applyInterceptors({ applyMethod: "tokens", axiosInstance: l2, interceptors: this.interceptors, isCSRF: false, service: r3, withoutAutoLogout: i2, accessTokenRefreshRetryCount: this.config.accessTokenRefreshRetryCount ?? 7, isUsingExternalCookie: e4 });
        }
        return l2;
      }
      setupTokenObserver() {
        this.scheduleTokenRefresh({ detail: { isExpired: false } }), Mt({ fn: this.scheduleTokenRefresh.bind(this) }), Ct((e3) => {
          e3 ? (this.scheduleTokenRefresh({ detail: { isExpired: false } }), Mn({ message: "Tab is visible", buildEnv: this.buildEnv })) : (this.clearTokenRefreshTimeout(), Mn({ message: "Tab is hidden", buildEnv: this.buildEnv }));
        });
      }
      scheduleTokenRefresh(e3) {
        if (e3.detail.isExpired) return this.clearTokenRefreshTimeout(), void this.abortAllActiveRequests();
        if (!Zt()) return this.clearTokenRefreshTimeout(), void this.abortAllActiveRequests();
        const t3 = Wt();
        if (!t3) return void this.clearTokenRefreshTimeout();
        this.clearTokenRefreshTimeout();
        const r3 = Kr(t3);
        if (null === r3) return;
        if (r3 <= this.TOKEN_LIFETIME_THRESHOLD && Zt()) return void this.refreshAccessTokenFN({ isBackgroundRefresh: true, removeAccessToken: false, accessTokenRefreshRetryCount: 1, buildEnv: this.buildEnv, hosts: this.hosts });
        const n3 = 1e3 * (r3 - this.TOKEN_LIFETIME_THRESHOLD);
        this.tokenRefreshTimeoutId = setTimeout(() => {
          this.refreshAccessTokenFN({ isBackgroundRefresh: true, removeAccessToken: false, accessTokenRefreshRetryCount: 1, buildEnv: this.buildEnv, hosts: this.hosts });
        }, n3);
      }
      clearTokenRefreshTimeout() {
        Mn({ message: "clearTokenRefreshTimeout", buildEnv: this.buildEnv }), this.tokenRefreshTimeoutId && (clearTimeout(this.tokenRefreshTimeoutId), this.tokenRefreshTimeoutId = null);
      }
      applyInterceptors({ applyMethod: e3, axiosInstance: t3, isCSRF: r3 = false, service: n3, withoutAutoLogout: s3, accessTokenRefreshRetryCount: i2, isUsingExternalCookie: o2 }) {
        this.interceptors[e3]({ axiosInstance: t3, service: n3, withoutAutoLogout: s3, accessTokenRefreshRetryCount: i2, isCSRF: r3, isUsingExternalCookie: o2, buildEnv: this.buildEnv, hosts: this.hosts });
      }
      getRequest({ ...e3 }) {
        const { axiosConfig: t3, isCSRF: r3, service: n3, controller: s3, withoutInterceptors: i2, withoutAutoLogout: o2, withoutAutoAbort: a2 } = e3, c2 = this.createInstance({ axiosConfig: t3, isCSRF: r3, service: n3, controller: s3, withoutInterceptors: i2, withoutAutoLogout: o2, withoutAutoAbort: a2 });
        return this.httpRequests.get({ ...e3, axiosInstance: c2 });
      }
      postRequest({ ...e3 }) {
        const { axiosConfig: t3, isCSRF: r3, service: n3, controller: s3, withoutInterceptors: i2, withoutAutoLogout: o2, withoutAutoAbort: a2 } = e3, c2 = this.createInstance({ axiosConfig: t3, isCSRF: r3, service: n3, controller: s3, withoutInterceptors: i2, withoutAutoLogout: o2, withoutAutoAbort: a2 });
        return this.httpRequests.post({ ...e3, axiosInstance: c2 });
      }
      putRequest({ ...e3 }) {
        const { axiosConfig: t3, isCSRF: r3, service: n3, controller: s3, withoutInterceptors: i2, withoutAutoLogout: o2, withoutAutoAbort: a2 } = e3, c2 = this.createInstance({ axiosConfig: t3, isCSRF: r3, service: n3, controller: s3, withoutInterceptors: i2, withoutAutoLogout: o2, withoutAutoAbort: a2 });
        return this.httpRequests.put({ ...e3, axiosInstance: c2 });
      }
      patchRequest({ ...e3 }) {
        const { axiosConfig: t3, isCSRF: r3, service: n3, controller: s3, withoutInterceptors: i2, withoutAutoLogout: o2, withoutAutoAbort: a2 } = e3, c2 = this.createInstance({ axiosConfig: t3, isCSRF: r3, service: n3, controller: s3, withoutInterceptors: i2, withoutAutoLogout: o2, withoutAutoAbort: a2 });
        return this.httpRequests.patch({ ...e3, axiosInstance: c2 });
      }
      deleteRequest({ ...e3 }) {
        const { axiosConfig: t3, isCSRF: r3, service: n3, controller: s3, withoutInterceptors: i2, withoutAutoLogout: o2, withoutAutoAbort: a2 } = e3, c2 = this.createInstance({ axiosConfig: t3, isCSRF: r3, service: n3, controller: s3, withoutInterceptors: i2, withoutAutoLogout: o2, withoutAutoAbort: a2 });
        return this.httpRequests.delete({ ...e3, axiosInstance: c2 });
      }
      removeTokens(e3) {
        On(), this.removeTokensFN(e3);
      }
      login({ username: e3, password: t3 }) {
        return this.loginFN({ username: e3, password: t3, buildEnv: this.buildEnv, hosts: this.hosts });
      }
      getAuthHeaders() {
        return this.getAuthHeadersFN({ accessTokenRefreshRetryCount: 1, buildEnv: this.buildEnv, hosts: this.hosts });
      }
      getValidAccessToken() {
        return this.getValidAccessTokenFN({ accessTokenRefreshRetryCount: 1, buildEnv: this.buildEnv, hosts: this.hosts });
      }
      abortAllActiveRequests() {
        this.activeControllers.forEach((e3) => {
          e3.abort();
        }), this.activeControllers.clear();
      }
    };
    var qn, $n;
    !(function(e3) {
      e3.assertEqual = (e4) => {
      }, e3.assertIs = function(e4) {
      }, e3.assertNever = function(e4) {
        throw new Error();
      }, e3.arrayToEnum = (e4) => {
        const t3 = {};
        for (const r3 of e4) t3[r3] = r3;
        return t3;
      }, e3.getValidEnumValues = (t3) => {
        const r3 = e3.objectKeys(t3).filter((e4) => "number" != typeof t3[t3[e4]]), n3 = {};
        for (const e4 of r3) n3[e4] = t3[e4];
        return e3.objectValues(n3);
      }, e3.objectValues = (t3) => e3.objectKeys(t3).map(function(e4) {
        return t3[e4];
      }), e3.objectKeys = "function" == typeof Object.keys ? (e4) => Object.keys(e4) : (e4) => {
        const t3 = [];
        for (const r3 in e4) Object.prototype.hasOwnProperty.call(e4, r3) && t3.push(r3);
        return t3;
      }, e3.find = (e4, t3) => {
        for (const r3 of e4) if (t3(r3)) return r3;
      }, e3.isInteger = "function" == typeof Number.isInteger ? (e4) => Number.isInteger(e4) : (e4) => "number" == typeof e4 && Number.isFinite(e4) && Math.floor(e4) === e4, e3.joinValues = function(e4, t3 = " | ") {
        return e4.map((e5) => "string" == typeof e5 ? `'${e5}'` : e5).join(t3);
      }, e3.jsonStringifyReplacer = (e4, t3) => "bigint" == typeof t3 ? t3.toString() : t3;
    })(qn || (qn = {})), (function(e3) {
      e3.mergeShapes = (e4, t3) => ({ ...e4, ...t3 });
    })($n || ($n = {}));
    const Bn = qn.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]), zn = (e3) => {
      switch (typeof e3) {
        case "undefined":
          return Bn.undefined;
        case "string":
          return Bn.string;
        case "number":
          return Number.isNaN(e3) ? Bn.nan : Bn.number;
        case "boolean":
          return Bn.boolean;
        case "function":
          return Bn.function;
        case "bigint":
          return Bn.bigint;
        case "symbol":
          return Bn.symbol;
        case "object":
          return Array.isArray(e3) ? Bn.array : null === e3 ? Bn.null : e3.then && "function" == typeof e3.then && e3.catch && "function" == typeof e3.catch ? Bn.promise : "undefined" != typeof Map && e3 instanceof Map ? Bn.map : "undefined" != typeof Set && e3 instanceof Set ? Bn.set : "undefined" != typeof Date && e3 instanceof Date ? Bn.date : Bn.object;
        default:
          return Bn.unknown;
      }
    }, Hn = qn.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]);
    class Kn extends Error {
      get errors() {
        return this.issues;
      }
      constructor(e3) {
        super(), this.issues = [], this.addIssue = (e4) => {
          this.issues = [...this.issues, e4];
        }, this.addIssues = (e4 = []) => {
          this.issues = [...this.issues, ...e4];
        };
        const t3 = new.target.prototype;
        Object.setPrototypeOf ? Object.setPrototypeOf(this, t3) : this.__proto__ = t3, this.name = "ZodError", this.issues = e3;
      }
      format(e3) {
        const t3 = e3 || function(e4) {
          return e4.message;
        }, r3 = { _errors: [] }, n3 = (e4) => {
          for (const s3 of e4.issues) if ("invalid_union" === s3.code) s3.unionErrors.map(n3);
          else if ("invalid_return_type" === s3.code) n3(s3.returnTypeError);
          else if ("invalid_arguments" === s3.code) n3(s3.argumentsError);
          else if (0 === s3.path.length) r3._errors.push(t3(s3));
          else {
            let e5 = r3, n4 = 0;
            for (; n4 < s3.path.length; ) {
              const r4 = s3.path[n4];
              n4 === s3.path.length - 1 ? (e5[r4] = e5[r4] || { _errors: [] }, e5[r4]._errors.push(t3(s3))) : e5[r4] = e5[r4] || { _errors: [] }, e5 = e5[r4], n4++;
            }
          }
        };
        return n3(this), r3;
      }
      static assert(e3) {
        if (!(e3 instanceof Kn)) throw new Error(`Not a ZodError: ${e3}`);
      }
      toString() {
        return this.message;
      }
      get message() {
        return JSON.stringify(this.issues, qn.jsonStringifyReplacer, 2);
      }
      get isEmpty() {
        return 0 === this.issues.length;
      }
      flatten(e3 = (e4) => e4.message) {
        const t3 = {}, r3 = [];
        for (const n3 of this.issues) if (n3.path.length > 0) {
          const r4 = n3.path[0];
          t3[r4] = t3[r4] || [], t3[r4].push(e3(n3));
        } else r3.push(e3(n3));
        return { formErrors: r3, fieldErrors: t3 };
      }
      get formErrors() {
        return this.flatten();
      }
    }
    Kn.create = (e3) => new Kn(e3);
    const Vn = (e3, t3) => {
      let r3;
      switch (e3.code) {
        case Hn.invalid_type:
          r3 = e3.received === Bn.undefined ? "Required" : `Expected ${e3.expected}, received ${e3.received}`;
          break;
        case Hn.invalid_literal:
          r3 = `Invalid literal value, expected ${JSON.stringify(e3.expected, qn.jsonStringifyReplacer)}`;
          break;
        case Hn.unrecognized_keys:
          r3 = `Unrecognized key(s) in object: ${qn.joinValues(e3.keys, ", ")}`;
          break;
        case Hn.invalid_union:
          r3 = "Invalid input";
          break;
        case Hn.invalid_union_discriminator:
          r3 = `Invalid discriminator value. Expected ${qn.joinValues(e3.options)}`;
          break;
        case Hn.invalid_enum_value:
          r3 = `Invalid enum value. Expected ${qn.joinValues(e3.options)}, received '${e3.received}'`;
          break;
        case Hn.invalid_arguments:
          r3 = "Invalid function arguments";
          break;
        case Hn.invalid_return_type:
          r3 = "Invalid function return type";
          break;
        case Hn.invalid_date:
          r3 = "Invalid date";
          break;
        case Hn.invalid_string:
          "object" == typeof e3.validation ? "includes" in e3.validation ? (r3 = `Invalid input: must include "${e3.validation.includes}"`, "number" == typeof e3.validation.position && (r3 = `${r3} at one or more positions greater than or equal to ${e3.validation.position}`)) : "startsWith" in e3.validation ? r3 = `Invalid input: must start with "${e3.validation.startsWith}"` : "endsWith" in e3.validation ? r3 = `Invalid input: must end with "${e3.validation.endsWith}"` : qn.assertNever(e3.validation) : r3 = "regex" !== e3.validation ? `Invalid ${e3.validation}` : "Invalid";
          break;
        case Hn.too_small:
          r3 = "array" === e3.type ? `Array must contain ${e3.exact ? "exactly" : e3.inclusive ? "at least" : "more than"} ${e3.minimum} element(s)` : "string" === e3.type ? `String must contain ${e3.exact ? "exactly" : e3.inclusive ? "at least" : "over"} ${e3.minimum} character(s)` : "number" === e3.type || "bigint" === e3.type ? `Number must be ${e3.exact ? "exactly equal to " : e3.inclusive ? "greater than or equal to " : "greater than "}${e3.minimum}` : "date" === e3.type ? `Date must be ${e3.exact ? "exactly equal to " : e3.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e3.minimum))}` : "Invalid input";
          break;
        case Hn.too_big:
          r3 = "array" === e3.type ? `Array must contain ${e3.exact ? "exactly" : e3.inclusive ? "at most" : "less than"} ${e3.maximum} element(s)` : "string" === e3.type ? `String must contain ${e3.exact ? "exactly" : e3.inclusive ? "at most" : "under"} ${e3.maximum} character(s)` : "number" === e3.type ? `Number must be ${e3.exact ? "exactly" : e3.inclusive ? "less than or equal to" : "less than"} ${e3.maximum}` : "bigint" === e3.type ? `BigInt must be ${e3.exact ? "exactly" : e3.inclusive ? "less than or equal to" : "less than"} ${e3.maximum}` : "date" === e3.type ? `Date must be ${e3.exact ? "exactly" : e3.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e3.maximum))}` : "Invalid input";
          break;
        case Hn.custom:
          r3 = "Invalid input";
          break;
        case Hn.invalid_intersection_types:
          r3 = "Intersection results could not be merged";
          break;
        case Hn.not_multiple_of:
          r3 = `Number must be a multiple of ${e3.multipleOf}`;
          break;
        case Hn.not_finite:
          r3 = "Number must be finite";
          break;
        default:
          r3 = t3.defaultError, qn.assertNever(e3);
      }
      return { message: r3 };
    };
    let Wn = Vn;
    function Zn() {
      return Wn;
    }
    var Jn;
    !(function(e3) {
      e3.errToObj = (e4) => "string" == typeof e4 ? { message: e4 } : e4 || {}, e3.toString = (e4) => "string" == typeof e4 ? e4 : e4?.message;
    })(Jn || (Jn = {}));
    const Gn = (e3) => {
      const { data: t3, path: r3, errorMaps: n3, issueData: s3 } = e3, i2 = [...r3, ...s3.path || []], o2 = { ...s3, path: i2 };
      if (void 0 !== s3.message) return { ...s3, path: i2, message: s3.message };
      let a2 = "";
      const c2 = n3.filter((e4) => !!e4).slice().reverse();
      for (const e4 of c2) a2 = e4(o2, { data: t3, defaultError: a2 }).message;
      return { ...s3, path: i2, message: a2 };
    };
    function Xn(e3, t3) {
      const r3 = Zn(), n3 = Gn({ issueData: t3, data: e3.data, path: e3.path, errorMaps: [e3.common.contextualErrorMap, e3.schemaErrorMap, r3, r3 === Vn ? void 0 : Vn].filter((e4) => !!e4) });
      e3.common.issues.push(n3);
    }
    class Qn {
      constructor() {
        this.value = "valid";
      }
      dirty() {
        "valid" === this.value && (this.value = "dirty");
      }
      abort() {
        "aborted" !== this.value && (this.value = "aborted");
      }
      static mergeArray(e3, t3) {
        const r3 = [];
        for (const n3 of t3) {
          if ("aborted" === n3.status) return Yn;
          "dirty" === n3.status && e3.dirty(), r3.push(n3.value);
        }
        return { status: e3.value, value: r3 };
      }
      static async mergeObjectAsync(e3, t3) {
        const r3 = [];
        for (const e4 of t3) {
          const t4 = await e4.key, n3 = await e4.value;
          r3.push({ key: t4, value: n3 });
        }
        return Qn.mergeObjectSync(e3, r3);
      }
      static mergeObjectSync(e3, t3) {
        const r3 = {};
        for (const n3 of t3) {
          const { key: t4, value: s3 } = n3;
          if ("aborted" === t4.status) return Yn;
          if ("aborted" === s3.status) return Yn;
          "dirty" === t4.status && e3.dirty(), "dirty" === s3.status && e3.dirty(), "__proto__" === t4.value || void 0 === s3.value && !n3.alwaysSet || (r3[t4.value] = s3.value);
        }
        return { status: e3.value, value: r3 };
      }
    }
    const Yn = Object.freeze({ status: "aborted" }), es = (e3) => ({ status: "dirty", value: e3 }), ts = (e3) => ({ status: "valid", value: e3 }), rs = (e3) => "aborted" === e3.status, ns = (e3) => "dirty" === e3.status, ss = (e3) => "valid" === e3.status, is = (e3) => "undefined" != typeof Promise && e3 instanceof Promise;
    class os {
      constructor(e3, t3, r3, n3) {
        this._cachedPath = [], this.parent = e3, this.data = t3, this._path = r3, this._key = n3;
      }
      get path() {
        return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
      }
    }
    const as = (e3, t3) => {
      if (ss(t3)) return { success: true, data: t3.value };
      if (!e3.common.issues.length) throw new Error("Validation failed but no issues detected.");
      return { success: false, get error() {
        if (this._error) return this._error;
        const t4 = new Kn(e3.common.issues);
        return this._error = t4, this._error;
      } };
    };
    function cs(e3) {
      if (!e3) return {};
      const { errorMap: t3, invalid_type_error: r3, required_error: n3, description: s3 } = e3;
      if (t3 && (r3 || n3)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
      if (t3) return { errorMap: t3, description: s3 };
      return { errorMap: (t4, s4) => {
        const { message: i2 } = e3;
        return "invalid_enum_value" === t4.code ? { message: i2 ?? s4.defaultError } : void 0 === s4.data ? { message: i2 ?? n3 ?? s4.defaultError } : "invalid_type" !== t4.code ? { message: s4.defaultError } : { message: i2 ?? r3 ?? s4.defaultError };
      }, description: s3 };
    }
    class ls {
      get description() {
        return this._def.description;
      }
      _getType(e3) {
        return zn(e3.data);
      }
      _getOrReturnCtx(e3, t3) {
        return t3 || { common: e3.parent.common, data: e3.data, parsedType: zn(e3.data), schemaErrorMap: this._def.errorMap, path: e3.path, parent: e3.parent };
      }
      _processInputParams(e3) {
        return { status: new Qn(), ctx: { common: e3.parent.common, data: e3.data, parsedType: zn(e3.data), schemaErrorMap: this._def.errorMap, path: e3.path, parent: e3.parent } };
      }
      _parseSync(e3) {
        const t3 = this._parse(e3);
        if (is(t3)) throw new Error("Synchronous parse encountered promise.");
        return t3;
      }
      _parseAsync(e3) {
        const t3 = this._parse(e3);
        return Promise.resolve(t3);
      }
      parse(e3, t3) {
        const r3 = this.safeParse(e3, t3);
        if (r3.success) return r3.data;
        throw r3.error;
      }
      safeParse(e3, t3) {
        const r3 = { common: { issues: [], async: t3?.async ?? false, contextualErrorMap: t3?.errorMap }, path: t3?.path || [], schemaErrorMap: this._def.errorMap, parent: null, data: e3, parsedType: zn(e3) }, n3 = this._parseSync({ data: e3, path: r3.path, parent: r3 });
        return as(r3, n3);
      }
      "~validate"(e3) {
        const t3 = { common: { issues: [], async: !!this["~standard"].async }, path: [], schemaErrorMap: this._def.errorMap, parent: null, data: e3, parsedType: zn(e3) };
        if (!this["~standard"].async) try {
          const r3 = this._parseSync({ data: e3, path: [], parent: t3 });
          return ss(r3) ? { value: r3.value } : { issues: t3.common.issues };
        } catch (e4) {
          e4?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = true), t3.common = { issues: [], async: true };
        }
        return this._parseAsync({ data: e3, path: [], parent: t3 }).then((e4) => ss(e4) ? { value: e4.value } : { issues: t3.common.issues });
      }
      async parseAsync(e3, t3) {
        const r3 = await this.safeParseAsync(e3, t3);
        if (r3.success) return r3.data;
        throw r3.error;
      }
      async safeParseAsync(e3, t3) {
        const r3 = { common: { issues: [], contextualErrorMap: t3?.errorMap, async: true }, path: t3?.path || [], schemaErrorMap: this._def.errorMap, parent: null, data: e3, parsedType: zn(e3) }, n3 = this._parse({ data: e3, path: r3.path, parent: r3 }), s3 = await (is(n3) ? n3 : Promise.resolve(n3));
        return as(r3, s3);
      }
      refine(e3, t3) {
        const r3 = (e4) => "string" == typeof t3 || void 0 === t3 ? { message: t3 } : "function" == typeof t3 ? t3(e4) : t3;
        return this._refinement((t4, n3) => {
          const s3 = e3(t4), i2 = () => n3.addIssue({ code: Hn.custom, ...r3(t4) });
          return "undefined" != typeof Promise && s3 instanceof Promise ? s3.then((e4) => !!e4 || (i2(), false)) : !!s3 || (i2(), false);
        });
      }
      refinement(e3, t3) {
        return this._refinement((r3, n3) => !!e3(r3) || (n3.addIssue("function" == typeof t3 ? t3(r3, n3) : t3), false));
      }
      _refinement(e3) {
        return new ai({ schema: this, typeName: yi.ZodEffects, effect: { type: "refinement", refinement: e3 } });
      }
      superRefine(e3) {
        return this._refinement(e3);
      }
      constructor(e3) {
        this.spa = this.safeParseAsync, this._def = e3, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = { version: 1, vendor: "zod", validate: (e4) => this["~validate"](e4) };
      }
      optional() {
        return ci.create(this, this._def);
      }
      nullable() {
        return li.create(this, this._def);
      }
      nullish() {
        return this.nullable().optional();
      }
      array() {
        return Vs.create(this);
      }
      promise() {
        return oi.create(this, this._def);
      }
      or(e3) {
        return Js.create([this, e3], this._def);
      }
      and(e3) {
        return Xs.create(this, e3, this._def);
      }
      transform(e3) {
        return new ai({ ...cs(this._def), schema: this, typeName: yi.ZodEffects, effect: { type: "transform", transform: e3 } });
      }
      default(e3) {
        const t3 = "function" == typeof e3 ? e3 : () => e3;
        return new ui({ ...cs(this._def), innerType: this, defaultValue: t3, typeName: yi.ZodDefault });
      }
      brand() {
        return new pi({ typeName: yi.ZodBranded, type: this, ...cs(this._def) });
      }
      catch(e3) {
        const t3 = "function" == typeof e3 ? e3 : () => e3;
        return new di({ ...cs(this._def), innerType: this, catchValue: t3, typeName: yi.ZodCatch });
      }
      describe(e3) {
        return new (0, this.constructor)({ ...this._def, description: e3 });
      }
      pipe(e3) {
        return fi.create(this, e3);
      }
      readonly() {
        return gi.create(this);
      }
      isOptional() {
        return this.safeParse(void 0).success;
      }
      isNullable() {
        return this.safeParse(null).success;
      }
    }
    const us = /^c[^\s-]{8,}$/i, ds = /^[0-9a-z]+$/, hs = /^[0-9A-HJKMNP-TV-Z]{26}$/i, ps = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, fs = /^[a-z0-9_-]{21}$/i, gs = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, ys = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, ms = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
    let _s;
    const ws = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, vs = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, bs = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Ss = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, ks = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, xs = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ts = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Es = new RegExp(`^${Ts}$`);
    function Rs(e3) {
      let t3 = "[0-5]\\d";
      e3.precision ? t3 = `${t3}\\.\\d{${e3.precision}}` : null == e3.precision && (t3 = `${t3}(\\.\\d+)?`);
      return `([01]\\d|2[0-3]):[0-5]\\d(:${t3})${e3.precision ? "+" : "?"}`;
    }
    function As(e3) {
      return new RegExp(`^${Rs(e3)}$`);
    }
    function Os(e3) {
      let t3 = `${Ts}T${Rs(e3)}`;
      const r3 = [];
      return r3.push(e3.local ? "Z?" : "Z"), e3.offset && r3.push("([+-]\\d{2}:?\\d{2})"), t3 = `${t3}(${r3.join("|")})`, new RegExp(`^${t3}$`);
    }
    function Cs(e3, t3) {
      return !("v4" !== t3 && t3 || !ws.test(e3)) || !("v6" !== t3 && t3 || !bs.test(e3));
    }
    function Is(e3, t3) {
      if (!gs.test(e3)) return false;
      try {
        const [r3] = e3.split(".");
        if (!r3) return false;
        const n3 = r3.replace(/-/g, "+").replace(/_/g, "/").padEnd(r3.length + (4 - r3.length % 4) % 4, "="), s3 = JSON.parse(atob(n3));
        return "object" == typeof s3 && null !== s3 && ((!("typ" in s3) || "JWT" === s3?.typ) && (!!s3.alg && (!t3 || s3.alg === t3)));
      } catch {
        return false;
      }
    }
    function Ps(e3, t3) {
      return !("v4" !== t3 && t3 || !vs.test(e3)) || !("v6" !== t3 && t3 || !Ss.test(e3));
    }
    class Ns extends ls {
      _parse(e3) {
        this._def.coerce && (e3.data = String(e3.data));
        if (this._getType(e3) !== Bn.string) {
          const t4 = this._getOrReturnCtx(e3);
          return Xn(t4, { code: Hn.invalid_type, expected: Bn.string, received: t4.parsedType }), Yn;
        }
        const t3 = new Qn();
        let r3;
        for (const n3 of this._def.checks) if ("min" === n3.kind) e3.data.length < n3.value && (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { code: Hn.too_small, minimum: n3.value, type: "string", inclusive: true, exact: false, message: n3.message }), t3.dirty());
        else if ("max" === n3.kind) e3.data.length > n3.value && (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { code: Hn.too_big, maximum: n3.value, type: "string", inclusive: true, exact: false, message: n3.message }), t3.dirty());
        else if ("length" === n3.kind) {
          const s3 = e3.data.length > n3.value, i2 = e3.data.length < n3.value;
          (s3 || i2) && (r3 = this._getOrReturnCtx(e3, r3), s3 ? Xn(r3, { code: Hn.too_big, maximum: n3.value, type: "string", inclusive: true, exact: true, message: n3.message }) : i2 && Xn(r3, { code: Hn.too_small, minimum: n3.value, type: "string", inclusive: true, exact: true, message: n3.message }), t3.dirty());
        } else if ("email" === n3.kind) ms.test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "email", code: Hn.invalid_string, message: n3.message }), t3.dirty());
        else if ("emoji" === n3.kind) _s || (_s = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u")), _s.test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "emoji", code: Hn.invalid_string, message: n3.message }), t3.dirty());
        else if ("uuid" === n3.kind) ps.test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "uuid", code: Hn.invalid_string, message: n3.message }), t3.dirty());
        else if ("nanoid" === n3.kind) fs.test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "nanoid", code: Hn.invalid_string, message: n3.message }), t3.dirty());
        else if ("cuid" === n3.kind) us.test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "cuid", code: Hn.invalid_string, message: n3.message }), t3.dirty());
        else if ("cuid2" === n3.kind) ds.test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "cuid2", code: Hn.invalid_string, message: n3.message }), t3.dirty());
        else if ("ulid" === n3.kind) hs.test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "ulid", code: Hn.invalid_string, message: n3.message }), t3.dirty());
        else if ("url" === n3.kind) try {
          new URL(e3.data);
        } catch {
          r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "url", code: Hn.invalid_string, message: n3.message }), t3.dirty();
        }
        else if ("regex" === n3.kind) {
          n3.regex.lastIndex = 0;
          n3.regex.test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "regex", code: Hn.invalid_string, message: n3.message }), t3.dirty());
        } else if ("trim" === n3.kind) e3.data = e3.data.trim();
        else if ("includes" === n3.kind) e3.data.includes(n3.value, n3.position) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { code: Hn.invalid_string, validation: { includes: n3.value, position: n3.position }, message: n3.message }), t3.dirty());
        else if ("toLowerCase" === n3.kind) e3.data = e3.data.toLowerCase();
        else if ("toUpperCase" === n3.kind) e3.data = e3.data.toUpperCase();
        else if ("startsWith" === n3.kind) e3.data.startsWith(n3.value) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { code: Hn.invalid_string, validation: { startsWith: n3.value }, message: n3.message }), t3.dirty());
        else if ("endsWith" === n3.kind) e3.data.endsWith(n3.value) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { code: Hn.invalid_string, validation: { endsWith: n3.value }, message: n3.message }), t3.dirty());
        else if ("datetime" === n3.kind) {
          Os(n3).test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { code: Hn.invalid_string, validation: "datetime", message: n3.message }), t3.dirty());
        } else if ("date" === n3.kind) {
          Es.test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { code: Hn.invalid_string, validation: "date", message: n3.message }), t3.dirty());
        } else if ("time" === n3.kind) {
          As(n3).test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { code: Hn.invalid_string, validation: "time", message: n3.message }), t3.dirty());
        } else "duration" === n3.kind ? ys.test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "duration", code: Hn.invalid_string, message: n3.message }), t3.dirty()) : "ip" === n3.kind ? Cs(e3.data, n3.version) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "ip", code: Hn.invalid_string, message: n3.message }), t3.dirty()) : "jwt" === n3.kind ? Is(e3.data, n3.alg) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "jwt", code: Hn.invalid_string, message: n3.message }), t3.dirty()) : "cidr" === n3.kind ? Ps(e3.data, n3.version) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "cidr", code: Hn.invalid_string, message: n3.message }), t3.dirty()) : "base64" === n3.kind ? ks.test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "base64", code: Hn.invalid_string, message: n3.message }), t3.dirty()) : "base64url" === n3.kind ? xs.test(e3.data) || (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { validation: "base64url", code: Hn.invalid_string, message: n3.message }), t3.dirty()) : qn.assertNever(n3);
        return { status: t3.value, value: e3.data };
      }
      _regex(e3, t3, r3) {
        return this.refinement((t4) => e3.test(t4), { validation: t3, code: Hn.invalid_string, ...Jn.errToObj(r3) });
      }
      _addCheck(e3) {
        return new Ns({ ...this._def, checks: [...this._def.checks, e3] });
      }
      email(e3) {
        return this._addCheck({ kind: "email", ...Jn.errToObj(e3) });
      }
      url(e3) {
        return this._addCheck({ kind: "url", ...Jn.errToObj(e3) });
      }
      emoji(e3) {
        return this._addCheck({ kind: "emoji", ...Jn.errToObj(e3) });
      }
      uuid(e3) {
        return this._addCheck({ kind: "uuid", ...Jn.errToObj(e3) });
      }
      nanoid(e3) {
        return this._addCheck({ kind: "nanoid", ...Jn.errToObj(e3) });
      }
      cuid(e3) {
        return this._addCheck({ kind: "cuid", ...Jn.errToObj(e3) });
      }
      cuid2(e3) {
        return this._addCheck({ kind: "cuid2", ...Jn.errToObj(e3) });
      }
      ulid(e3) {
        return this._addCheck({ kind: "ulid", ...Jn.errToObj(e3) });
      }
      base64(e3) {
        return this._addCheck({ kind: "base64", ...Jn.errToObj(e3) });
      }
      base64url(e3) {
        return this._addCheck({ kind: "base64url", ...Jn.errToObj(e3) });
      }
      jwt(e3) {
        return this._addCheck({ kind: "jwt", ...Jn.errToObj(e3) });
      }
      ip(e3) {
        return this._addCheck({ kind: "ip", ...Jn.errToObj(e3) });
      }
      cidr(e3) {
        return this._addCheck({ kind: "cidr", ...Jn.errToObj(e3) });
      }
      datetime(e3) {
        return "string" == typeof e3 ? this._addCheck({ kind: "datetime", precision: null, offset: false, local: false, message: e3 }) : this._addCheck({ kind: "datetime", precision: void 0 === e3?.precision ? null : e3?.precision, offset: e3?.offset ?? false, local: e3?.local ?? false, ...Jn.errToObj(e3?.message) });
      }
      date(e3) {
        return this._addCheck({ kind: "date", message: e3 });
      }
      time(e3) {
        return "string" == typeof e3 ? this._addCheck({ kind: "time", precision: null, message: e3 }) : this._addCheck({ kind: "time", precision: void 0 === e3?.precision ? null : e3?.precision, ...Jn.errToObj(e3?.message) });
      }
      duration(e3) {
        return this._addCheck({ kind: "duration", ...Jn.errToObj(e3) });
      }
      regex(e3, t3) {
        return this._addCheck({ kind: "regex", regex: e3, ...Jn.errToObj(t3) });
      }
      includes(e3, t3) {
        return this._addCheck({ kind: "includes", value: e3, position: t3?.position, ...Jn.errToObj(t3?.message) });
      }
      startsWith(e3, t3) {
        return this._addCheck({ kind: "startsWith", value: e3, ...Jn.errToObj(t3) });
      }
      endsWith(e3, t3) {
        return this._addCheck({ kind: "endsWith", value: e3, ...Jn.errToObj(t3) });
      }
      min(e3, t3) {
        return this._addCheck({ kind: "min", value: e3, ...Jn.errToObj(t3) });
      }
      max(e3, t3) {
        return this._addCheck({ kind: "max", value: e3, ...Jn.errToObj(t3) });
      }
      length(e3, t3) {
        return this._addCheck({ kind: "length", value: e3, ...Jn.errToObj(t3) });
      }
      nonempty(e3) {
        return this.min(1, Jn.errToObj(e3));
      }
      trim() {
        return new Ns({ ...this._def, checks: [...this._def.checks, { kind: "trim" }] });
      }
      toLowerCase() {
        return new Ns({ ...this._def, checks: [...this._def.checks, { kind: "toLowerCase" }] });
      }
      toUpperCase() {
        return new Ns({ ...this._def, checks: [...this._def.checks, { kind: "toUpperCase" }] });
      }
      get isDatetime() {
        return !!this._def.checks.find((e3) => "datetime" === e3.kind);
      }
      get isDate() {
        return !!this._def.checks.find((e3) => "date" === e3.kind);
      }
      get isTime() {
        return !!this._def.checks.find((e3) => "time" === e3.kind);
      }
      get isDuration() {
        return !!this._def.checks.find((e3) => "duration" === e3.kind);
      }
      get isEmail() {
        return !!this._def.checks.find((e3) => "email" === e3.kind);
      }
      get isURL() {
        return !!this._def.checks.find((e3) => "url" === e3.kind);
      }
      get isEmoji() {
        return !!this._def.checks.find((e3) => "emoji" === e3.kind);
      }
      get isUUID() {
        return !!this._def.checks.find((e3) => "uuid" === e3.kind);
      }
      get isNANOID() {
        return !!this._def.checks.find((e3) => "nanoid" === e3.kind);
      }
      get isCUID() {
        return !!this._def.checks.find((e3) => "cuid" === e3.kind);
      }
      get isCUID2() {
        return !!this._def.checks.find((e3) => "cuid2" === e3.kind);
      }
      get isULID() {
        return !!this._def.checks.find((e3) => "ulid" === e3.kind);
      }
      get isIP() {
        return !!this._def.checks.find((e3) => "ip" === e3.kind);
      }
      get isCIDR() {
        return !!this._def.checks.find((e3) => "cidr" === e3.kind);
      }
      get isBase64() {
        return !!this._def.checks.find((e3) => "base64" === e3.kind);
      }
      get isBase64url() {
        return !!this._def.checks.find((e3) => "base64url" === e3.kind);
      }
      get minLength() {
        let e3 = null;
        for (const t3 of this._def.checks) "min" === t3.kind && (null === e3 || t3.value > e3) && (e3 = t3.value);
        return e3;
      }
      get maxLength() {
        let e3 = null;
        for (const t3 of this._def.checks) "max" === t3.kind && (null === e3 || t3.value < e3) && (e3 = t3.value);
        return e3;
      }
    }
    function js(e3, t3) {
      const r3 = (e3.toString().split(".")[1] || "").length, n3 = (t3.toString().split(".")[1] || "").length, s3 = r3 > n3 ? r3 : n3;
      return Number.parseInt(e3.toFixed(s3).replace(".", "")) % Number.parseInt(t3.toFixed(s3).replace(".", "")) / 10 ** s3;
    }
    Ns.create = (e3) => new Ns({ checks: [], typeName: yi.ZodString, coerce: e3?.coerce ?? false, ...cs(e3) });
    class Us extends ls {
      constructor() {
        super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
      }
      _parse(e3) {
        this._def.coerce && (e3.data = Number(e3.data));
        if (this._getType(e3) !== Bn.number) {
          const t4 = this._getOrReturnCtx(e3);
          return Xn(t4, { code: Hn.invalid_type, expected: Bn.number, received: t4.parsedType }), Yn;
        }
        let t3;
        const r3 = new Qn();
        for (const n3 of this._def.checks) if ("int" === n3.kind) qn.isInteger(e3.data) || (t3 = this._getOrReturnCtx(e3, t3), Xn(t3, { code: Hn.invalid_type, expected: "integer", received: "float", message: n3.message }), r3.dirty());
        else if ("min" === n3.kind) {
          (n3.inclusive ? e3.data < n3.value : e3.data <= n3.value) && (t3 = this._getOrReturnCtx(e3, t3), Xn(t3, { code: Hn.too_small, minimum: n3.value, type: "number", inclusive: n3.inclusive, exact: false, message: n3.message }), r3.dirty());
        } else if ("max" === n3.kind) {
          (n3.inclusive ? e3.data > n3.value : e3.data >= n3.value) && (t3 = this._getOrReturnCtx(e3, t3), Xn(t3, { code: Hn.too_big, maximum: n3.value, type: "number", inclusive: n3.inclusive, exact: false, message: n3.message }), r3.dirty());
        } else "multipleOf" === n3.kind ? 0 !== js(e3.data, n3.value) && (t3 = this._getOrReturnCtx(e3, t3), Xn(t3, { code: Hn.not_multiple_of, multipleOf: n3.value, message: n3.message }), r3.dirty()) : "finite" === n3.kind ? Number.isFinite(e3.data) || (t3 = this._getOrReturnCtx(e3, t3), Xn(t3, { code: Hn.not_finite, message: n3.message }), r3.dirty()) : qn.assertNever(n3);
        return { status: r3.value, value: e3.data };
      }
      gte(e3, t3) {
        return this.setLimit("min", e3, true, Jn.toString(t3));
      }
      gt(e3, t3) {
        return this.setLimit("min", e3, false, Jn.toString(t3));
      }
      lte(e3, t3) {
        return this.setLimit("max", e3, true, Jn.toString(t3));
      }
      lt(e3, t3) {
        return this.setLimit("max", e3, false, Jn.toString(t3));
      }
      setLimit(e3, t3, r3, n3) {
        return new Us({ ...this._def, checks: [...this._def.checks, { kind: e3, value: t3, inclusive: r3, message: Jn.toString(n3) }] });
      }
      _addCheck(e3) {
        return new Us({ ...this._def, checks: [...this._def.checks, e3] });
      }
      int(e3) {
        return this._addCheck({ kind: "int", message: Jn.toString(e3) });
      }
      positive(e3) {
        return this._addCheck({ kind: "min", value: 0, inclusive: false, message: Jn.toString(e3) });
      }
      negative(e3) {
        return this._addCheck({ kind: "max", value: 0, inclusive: false, message: Jn.toString(e3) });
      }
      nonpositive(e3) {
        return this._addCheck({ kind: "max", value: 0, inclusive: true, message: Jn.toString(e3) });
      }
      nonnegative(e3) {
        return this._addCheck({ kind: "min", value: 0, inclusive: true, message: Jn.toString(e3) });
      }
      multipleOf(e3, t3) {
        return this._addCheck({ kind: "multipleOf", value: e3, message: Jn.toString(t3) });
      }
      finite(e3) {
        return this._addCheck({ kind: "finite", message: Jn.toString(e3) });
      }
      safe(e3) {
        return this._addCheck({ kind: "min", inclusive: true, value: Number.MIN_SAFE_INTEGER, message: Jn.toString(e3) })._addCheck({ kind: "max", inclusive: true, value: Number.MAX_SAFE_INTEGER, message: Jn.toString(e3) });
      }
      get minValue() {
        let e3 = null;
        for (const t3 of this._def.checks) "min" === t3.kind && (null === e3 || t3.value > e3) && (e3 = t3.value);
        return e3;
      }
      get maxValue() {
        let e3 = null;
        for (const t3 of this._def.checks) "max" === t3.kind && (null === e3 || t3.value < e3) && (e3 = t3.value);
        return e3;
      }
      get isInt() {
        return !!this._def.checks.find((e3) => "int" === e3.kind || "multipleOf" === e3.kind && qn.isInteger(e3.value));
      }
      get isFinite() {
        let e3 = null, t3 = null;
        for (const r3 of this._def.checks) {
          if ("finite" === r3.kind || "int" === r3.kind || "multipleOf" === r3.kind) return true;
          "min" === r3.kind ? (null === t3 || r3.value > t3) && (t3 = r3.value) : "max" === r3.kind && (null === e3 || r3.value < e3) && (e3 = r3.value);
        }
        return Number.isFinite(t3) && Number.isFinite(e3);
      }
    }
    Us.create = (e3) => new Us({ checks: [], typeName: yi.ZodNumber, coerce: e3?.coerce || false, ...cs(e3) });
    class Ls extends ls {
      constructor() {
        super(...arguments), this.min = this.gte, this.max = this.lte;
      }
      _parse(e3) {
        if (this._def.coerce) try {
          e3.data = BigInt(e3.data);
        } catch {
          return this._getInvalidInput(e3);
        }
        if (this._getType(e3) !== Bn.bigint) return this._getInvalidInput(e3);
        let t3;
        const r3 = new Qn();
        for (const n3 of this._def.checks) if ("min" === n3.kind) {
          (n3.inclusive ? e3.data < n3.value : e3.data <= n3.value) && (t3 = this._getOrReturnCtx(e3, t3), Xn(t3, { code: Hn.too_small, type: "bigint", minimum: n3.value, inclusive: n3.inclusive, message: n3.message }), r3.dirty());
        } else if ("max" === n3.kind) {
          (n3.inclusive ? e3.data > n3.value : e3.data >= n3.value) && (t3 = this._getOrReturnCtx(e3, t3), Xn(t3, { code: Hn.too_big, type: "bigint", maximum: n3.value, inclusive: n3.inclusive, message: n3.message }), r3.dirty());
        } else "multipleOf" === n3.kind ? e3.data % n3.value !== BigInt(0) && (t3 = this._getOrReturnCtx(e3, t3), Xn(t3, { code: Hn.not_multiple_of, multipleOf: n3.value, message: n3.message }), r3.dirty()) : qn.assertNever(n3);
        return { status: r3.value, value: e3.data };
      }
      _getInvalidInput(e3) {
        const t3 = this._getOrReturnCtx(e3);
        return Xn(t3, { code: Hn.invalid_type, expected: Bn.bigint, received: t3.parsedType }), Yn;
      }
      gte(e3, t3) {
        return this.setLimit("min", e3, true, Jn.toString(t3));
      }
      gt(e3, t3) {
        return this.setLimit("min", e3, false, Jn.toString(t3));
      }
      lte(e3, t3) {
        return this.setLimit("max", e3, true, Jn.toString(t3));
      }
      lt(e3, t3) {
        return this.setLimit("max", e3, false, Jn.toString(t3));
      }
      setLimit(e3, t3, r3, n3) {
        return new Ls({ ...this._def, checks: [...this._def.checks, { kind: e3, value: t3, inclusive: r3, message: Jn.toString(n3) }] });
      }
      _addCheck(e3) {
        return new Ls({ ...this._def, checks: [...this._def.checks, e3] });
      }
      positive(e3) {
        return this._addCheck({ kind: "min", value: BigInt(0), inclusive: false, message: Jn.toString(e3) });
      }
      negative(e3) {
        return this._addCheck({ kind: "max", value: BigInt(0), inclusive: false, message: Jn.toString(e3) });
      }
      nonpositive(e3) {
        return this._addCheck({ kind: "max", value: BigInt(0), inclusive: true, message: Jn.toString(e3) });
      }
      nonnegative(e3) {
        return this._addCheck({ kind: "min", value: BigInt(0), inclusive: true, message: Jn.toString(e3) });
      }
      multipleOf(e3, t3) {
        return this._addCheck({ kind: "multipleOf", value: e3, message: Jn.toString(t3) });
      }
      get minValue() {
        let e3 = null;
        for (const t3 of this._def.checks) "min" === t3.kind && (null === e3 || t3.value > e3) && (e3 = t3.value);
        return e3;
      }
      get maxValue() {
        let e3 = null;
        for (const t3 of this._def.checks) "max" === t3.kind && (null === e3 || t3.value < e3) && (e3 = t3.value);
        return e3;
      }
    }
    Ls.create = (e3) => new Ls({ checks: [], typeName: yi.ZodBigInt, coerce: e3?.coerce ?? false, ...cs(e3) });
    class Fs extends ls {
      _parse(e3) {
        this._def.coerce && (e3.data = Boolean(e3.data));
        if (this._getType(e3) !== Bn.boolean) {
          const t3 = this._getOrReturnCtx(e3);
          return Xn(t3, { code: Hn.invalid_type, expected: Bn.boolean, received: t3.parsedType }), Yn;
        }
        return ts(e3.data);
      }
    }
    Fs.create = (e3) => new Fs({ typeName: yi.ZodBoolean, coerce: e3?.coerce || false, ...cs(e3) });
    class Ms extends ls {
      _parse(e3) {
        this._def.coerce && (e3.data = new Date(e3.data));
        if (this._getType(e3) !== Bn.date) {
          const t4 = this._getOrReturnCtx(e3);
          return Xn(t4, { code: Hn.invalid_type, expected: Bn.date, received: t4.parsedType }), Yn;
        }
        if (Number.isNaN(e3.data.getTime())) {
          return Xn(this._getOrReturnCtx(e3), { code: Hn.invalid_date }), Yn;
        }
        const t3 = new Qn();
        let r3;
        for (const n3 of this._def.checks) "min" === n3.kind ? e3.data.getTime() < n3.value && (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { code: Hn.too_small, message: n3.message, inclusive: true, exact: false, minimum: n3.value, type: "date" }), t3.dirty()) : "max" === n3.kind ? e3.data.getTime() > n3.value && (r3 = this._getOrReturnCtx(e3, r3), Xn(r3, { code: Hn.too_big, message: n3.message, inclusive: true, exact: false, maximum: n3.value, type: "date" }), t3.dirty()) : qn.assertNever(n3);
        return { status: t3.value, value: new Date(e3.data.getTime()) };
      }
      _addCheck(e3) {
        return new Ms({ ...this._def, checks: [...this._def.checks, e3] });
      }
      min(e3, t3) {
        return this._addCheck({ kind: "min", value: e3.getTime(), message: Jn.toString(t3) });
      }
      max(e3, t3) {
        return this._addCheck({ kind: "max", value: e3.getTime(), message: Jn.toString(t3) });
      }
      get minDate() {
        let e3 = null;
        for (const t3 of this._def.checks) "min" === t3.kind && (null === e3 || t3.value > e3) && (e3 = t3.value);
        return null != e3 ? new Date(e3) : null;
      }
      get maxDate() {
        let e3 = null;
        for (const t3 of this._def.checks) "max" === t3.kind && (null === e3 || t3.value < e3) && (e3 = t3.value);
        return null != e3 ? new Date(e3) : null;
      }
    }
    Ms.create = (e3) => new Ms({ checks: [], coerce: e3?.coerce || false, typeName: yi.ZodDate, ...cs(e3) });
    class Ds extends ls {
      _parse(e3) {
        if (this._getType(e3) !== Bn.symbol) {
          const t3 = this._getOrReturnCtx(e3);
          return Xn(t3, { code: Hn.invalid_type, expected: Bn.symbol, received: t3.parsedType }), Yn;
        }
        return ts(e3.data);
      }
    }
    Ds.create = (e3) => new Ds({ typeName: yi.ZodSymbol, ...cs(e3) });
    class qs extends ls {
      _parse(e3) {
        if (this._getType(e3) !== Bn.undefined) {
          const t3 = this._getOrReturnCtx(e3);
          return Xn(t3, { code: Hn.invalid_type, expected: Bn.undefined, received: t3.parsedType }), Yn;
        }
        return ts(e3.data);
      }
    }
    qs.create = (e3) => new qs({ typeName: yi.ZodUndefined, ...cs(e3) });
    class $s extends ls {
      _parse(e3) {
        if (this._getType(e3) !== Bn.null) {
          const t3 = this._getOrReturnCtx(e3);
          return Xn(t3, { code: Hn.invalid_type, expected: Bn.null, received: t3.parsedType }), Yn;
        }
        return ts(e3.data);
      }
    }
    $s.create = (e3) => new $s({ typeName: yi.ZodNull, ...cs(e3) });
    class Bs extends ls {
      constructor() {
        super(...arguments), this._any = true;
      }
      _parse(e3) {
        return ts(e3.data);
      }
    }
    Bs.create = (e3) => new Bs({ typeName: yi.ZodAny, ...cs(e3) });
    class zs extends ls {
      constructor() {
        super(...arguments), this._unknown = true;
      }
      _parse(e3) {
        return ts(e3.data);
      }
    }
    zs.create = (e3) => new zs({ typeName: yi.ZodUnknown, ...cs(e3) });
    class Hs extends ls {
      _parse(e3) {
        const t3 = this._getOrReturnCtx(e3);
        return Xn(t3, { code: Hn.invalid_type, expected: Bn.never, received: t3.parsedType }), Yn;
      }
    }
    Hs.create = (e3) => new Hs({ typeName: yi.ZodNever, ...cs(e3) });
    class Ks extends ls {
      _parse(e3) {
        if (this._getType(e3) !== Bn.undefined) {
          const t3 = this._getOrReturnCtx(e3);
          return Xn(t3, { code: Hn.invalid_type, expected: Bn.void, received: t3.parsedType }), Yn;
        }
        return ts(e3.data);
      }
    }
    Ks.create = (e3) => new Ks({ typeName: yi.ZodVoid, ...cs(e3) });
    class Vs extends ls {
      _parse(e3) {
        const { ctx: t3, status: r3 } = this._processInputParams(e3), n3 = this._def;
        if (t3.parsedType !== Bn.array) return Xn(t3, { code: Hn.invalid_type, expected: Bn.array, received: t3.parsedType }), Yn;
        if (null !== n3.exactLength) {
          const e4 = t3.data.length > n3.exactLength.value, s4 = t3.data.length < n3.exactLength.value;
          (e4 || s4) && (Xn(t3, { code: e4 ? Hn.too_big : Hn.too_small, minimum: s4 ? n3.exactLength.value : void 0, maximum: e4 ? n3.exactLength.value : void 0, type: "array", inclusive: true, exact: true, message: n3.exactLength.message }), r3.dirty());
        }
        if (null !== n3.minLength && t3.data.length < n3.minLength.value && (Xn(t3, { code: Hn.too_small, minimum: n3.minLength.value, type: "array", inclusive: true, exact: false, message: n3.minLength.message }), r3.dirty()), null !== n3.maxLength && t3.data.length > n3.maxLength.value && (Xn(t3, { code: Hn.too_big, maximum: n3.maxLength.value, type: "array", inclusive: true, exact: false, message: n3.maxLength.message }), r3.dirty()), t3.common.async) return Promise.all([...t3.data].map((e4, r4) => n3.type._parseAsync(new os(t3, e4, t3.path, r4)))).then((e4) => Qn.mergeArray(r3, e4));
        const s3 = [...t3.data].map((e4, r4) => n3.type._parseSync(new os(t3, e4, t3.path, r4)));
        return Qn.mergeArray(r3, s3);
      }
      get element() {
        return this._def.type;
      }
      min(e3, t3) {
        return new Vs({ ...this._def, minLength: { value: e3, message: Jn.toString(t3) } });
      }
      max(e3, t3) {
        return new Vs({ ...this._def, maxLength: { value: e3, message: Jn.toString(t3) } });
      }
      length(e3, t3) {
        return new Vs({ ...this._def, exactLength: { value: e3, message: Jn.toString(t3) } });
      }
      nonempty(e3) {
        return this.min(1, e3);
      }
    }
    function Ws(e3) {
      if (e3 instanceof Zs) {
        const t3 = {};
        for (const r3 in e3.shape) {
          const n3 = e3.shape[r3];
          t3[r3] = ci.create(Ws(n3));
        }
        return new Zs({ ...e3._def, shape: () => t3 });
      }
      return e3 instanceof Vs ? new Vs({ ...e3._def, type: Ws(e3.element) }) : e3 instanceof ci ? ci.create(Ws(e3.unwrap())) : e3 instanceof li ? li.create(Ws(e3.unwrap())) : e3 instanceof Qs ? Qs.create(e3.items.map((e4) => Ws(e4))) : e3;
    }
    Vs.create = (e3, t3) => new Vs({ type: e3, minLength: null, maxLength: null, exactLength: null, typeName: yi.ZodArray, ...cs(t3) });
    class Zs extends ls {
      constructor() {
        super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
      }
      _getCached() {
        if (null !== this._cached) return this._cached;
        const e3 = this._def.shape(), t3 = qn.objectKeys(e3);
        return this._cached = { shape: e3, keys: t3 }, this._cached;
      }
      _parse(e3) {
        if (this._getType(e3) !== Bn.object) {
          const t4 = this._getOrReturnCtx(e3);
          return Xn(t4, { code: Hn.invalid_type, expected: Bn.object, received: t4.parsedType }), Yn;
        }
        const { status: t3, ctx: r3 } = this._processInputParams(e3), { shape: n3, keys: s3 } = this._getCached(), i2 = [];
        if (!(this._def.catchall instanceof Hs && "strip" === this._def.unknownKeys)) for (const e4 in r3.data) s3.includes(e4) || i2.push(e4);
        const o2 = [];
        for (const e4 of s3) {
          const t4 = n3[e4], s4 = r3.data[e4];
          o2.push({ key: { status: "valid", value: e4 }, value: t4._parse(new os(r3, s4, r3.path, e4)), alwaysSet: e4 in r3.data });
        }
        if (this._def.catchall instanceof Hs) {
          const e4 = this._def.unknownKeys;
          if ("passthrough" === e4) for (const e5 of i2) o2.push({ key: { status: "valid", value: e5 }, value: { status: "valid", value: r3.data[e5] } });
          else if ("strict" === e4) i2.length > 0 && (Xn(r3, { code: Hn.unrecognized_keys, keys: i2 }), t3.dirty());
          else if ("strip" !== e4) throw new Error("Internal ZodObject error: invalid unknownKeys value.");
        } else {
          const e4 = this._def.catchall;
          for (const t4 of i2) {
            const n4 = r3.data[t4];
            o2.push({ key: { status: "valid", value: t4 }, value: e4._parse(new os(r3, n4, r3.path, t4)), alwaysSet: t4 in r3.data });
          }
        }
        return r3.common.async ? Promise.resolve().then(async () => {
          const e4 = [];
          for (const t4 of o2) {
            const r4 = await t4.key, n4 = await t4.value;
            e4.push({ key: r4, value: n4, alwaysSet: t4.alwaysSet });
          }
          return e4;
        }).then((e4) => Qn.mergeObjectSync(t3, e4)) : Qn.mergeObjectSync(t3, o2);
      }
      get shape() {
        return this._def.shape();
      }
      strict(e3) {
        return Jn.errToObj, new Zs({ ...this._def, unknownKeys: "strict", ...void 0 !== e3 ? { errorMap: (t3, r3) => {
          const n3 = this._def.errorMap?.(t3, r3).message ?? r3.defaultError;
          return "unrecognized_keys" === t3.code ? { message: Jn.errToObj(e3).message ?? n3 } : { message: n3 };
        } } : {} });
      }
      strip() {
        return new Zs({ ...this._def, unknownKeys: "strip" });
      }
      passthrough() {
        return new Zs({ ...this._def, unknownKeys: "passthrough" });
      }
      extend(e3) {
        return new Zs({ ...this._def, shape: () => ({ ...this._def.shape(), ...e3 }) });
      }
      merge(e3) {
        return new Zs({ unknownKeys: e3._def.unknownKeys, catchall: e3._def.catchall, shape: () => ({ ...this._def.shape(), ...e3._def.shape() }), typeName: yi.ZodObject });
      }
      setKey(e3, t3) {
        return this.augment({ [e3]: t3 });
      }
      catchall(e3) {
        return new Zs({ ...this._def, catchall: e3 });
      }
      pick(e3) {
        const t3 = {};
        for (const r3 of qn.objectKeys(e3)) e3[r3] && this.shape[r3] && (t3[r3] = this.shape[r3]);
        return new Zs({ ...this._def, shape: () => t3 });
      }
      omit(e3) {
        const t3 = {};
        for (const r3 of qn.objectKeys(this.shape)) e3[r3] || (t3[r3] = this.shape[r3]);
        return new Zs({ ...this._def, shape: () => t3 });
      }
      deepPartial() {
        return Ws(this);
      }
      partial(e3) {
        const t3 = {};
        for (const r3 of qn.objectKeys(this.shape)) {
          const n3 = this.shape[r3];
          e3 && !e3[r3] ? t3[r3] = n3 : t3[r3] = n3.optional();
        }
        return new Zs({ ...this._def, shape: () => t3 });
      }
      required(e3) {
        const t3 = {};
        for (const r3 of qn.objectKeys(this.shape)) if (e3 && !e3[r3]) t3[r3] = this.shape[r3];
        else {
          let e4 = this.shape[r3];
          for (; e4 instanceof ci; ) e4 = e4._def.innerType;
          t3[r3] = e4;
        }
        return new Zs({ ...this._def, shape: () => t3 });
      }
      keyof() {
        return ni(qn.objectKeys(this.shape));
      }
    }
    Zs.create = (e3, t3) => new Zs({ shape: () => e3, unknownKeys: "strip", catchall: Hs.create(), typeName: yi.ZodObject, ...cs(t3) }), Zs.strictCreate = (e3, t3) => new Zs({ shape: () => e3, unknownKeys: "strict", catchall: Hs.create(), typeName: yi.ZodObject, ...cs(t3) }), Zs.lazycreate = (e3, t3) => new Zs({ shape: e3, unknownKeys: "strip", catchall: Hs.create(), typeName: yi.ZodObject, ...cs(t3) });
    class Js extends ls {
      _parse(e3) {
        const { ctx: t3 } = this._processInputParams(e3), r3 = this._def.options;
        if (t3.common.async) return Promise.all(r3.map(async (e4) => {
          const r4 = { ...t3, common: { ...t3.common, issues: [] }, parent: null };
          return { result: await e4._parseAsync({ data: t3.data, path: t3.path, parent: r4 }), ctx: r4 };
        })).then(function(e4) {
          for (const t4 of e4) if ("valid" === t4.result.status) return t4.result;
          for (const r5 of e4) if ("dirty" === r5.result.status) return t3.common.issues.push(...r5.ctx.common.issues), r5.result;
          const r4 = e4.map((e5) => new Kn(e5.ctx.common.issues));
          return Xn(t3, { code: Hn.invalid_union, unionErrors: r4 }), Yn;
        });
        {
          let e4;
          const n3 = [];
          for (const s4 of r3) {
            const r4 = { ...t3, common: { ...t3.common, issues: [] }, parent: null }, i2 = s4._parseSync({ data: t3.data, path: t3.path, parent: r4 });
            if ("valid" === i2.status) return i2;
            "dirty" !== i2.status || e4 || (e4 = { result: i2, ctx: r4 }), r4.common.issues.length && n3.push(r4.common.issues);
          }
          if (e4) return t3.common.issues.push(...e4.ctx.common.issues), e4.result;
          const s3 = n3.map((e5) => new Kn(e5));
          return Xn(t3, { code: Hn.invalid_union, unionErrors: s3 }), Yn;
        }
      }
      get options() {
        return this._def.options;
      }
    }
    Js.create = (e3, t3) => new Js({ options: e3, typeName: yi.ZodUnion, ...cs(t3) });
    function Gs(e3, t3) {
      const r3 = zn(e3), n3 = zn(t3);
      if (e3 === t3) return { valid: true, data: e3 };
      if (r3 === Bn.object && n3 === Bn.object) {
        const r4 = qn.objectKeys(t3), n4 = qn.objectKeys(e3).filter((e4) => -1 !== r4.indexOf(e4)), s3 = { ...e3, ...t3 };
        for (const r5 of n4) {
          const n5 = Gs(e3[r5], t3[r5]);
          if (!n5.valid) return { valid: false };
          s3[r5] = n5.data;
        }
        return { valid: true, data: s3 };
      }
      if (r3 === Bn.array && n3 === Bn.array) {
        if (e3.length !== t3.length) return { valid: false };
        const r4 = [];
        for (let n4 = 0; n4 < e3.length; n4++) {
          const s3 = Gs(e3[n4], t3[n4]);
          if (!s3.valid) return { valid: false };
          r4.push(s3.data);
        }
        return { valid: true, data: r4 };
      }
      return r3 === Bn.date && n3 === Bn.date && +e3 === +t3 ? { valid: true, data: e3 } : { valid: false };
    }
    class Xs extends ls {
      _parse(e3) {
        const { status: t3, ctx: r3 } = this._processInputParams(e3), n3 = (e4, n4) => {
          if (rs(e4) || rs(n4)) return Yn;
          const s3 = Gs(e4.value, n4.value);
          return s3.valid ? ((ns(e4) || ns(n4)) && t3.dirty(), { status: t3.value, value: s3.data }) : (Xn(r3, { code: Hn.invalid_intersection_types }), Yn);
        };
        return r3.common.async ? Promise.all([this._def.left._parseAsync({ data: r3.data, path: r3.path, parent: r3 }), this._def.right._parseAsync({ data: r3.data, path: r3.path, parent: r3 })]).then(([e4, t4]) => n3(e4, t4)) : n3(this._def.left._parseSync({ data: r3.data, path: r3.path, parent: r3 }), this._def.right._parseSync({ data: r3.data, path: r3.path, parent: r3 }));
      }
    }
    Xs.create = (e3, t3, r3) => new Xs({ left: e3, right: t3, typeName: yi.ZodIntersection, ...cs(r3) });
    class Qs extends ls {
      _parse(e3) {
        const { status: t3, ctx: r3 } = this._processInputParams(e3);
        if (r3.parsedType !== Bn.array) return Xn(r3, { code: Hn.invalid_type, expected: Bn.array, received: r3.parsedType }), Yn;
        if (r3.data.length < this._def.items.length) return Xn(r3, { code: Hn.too_small, minimum: this._def.items.length, inclusive: true, exact: false, type: "array" }), Yn;
        !this._def.rest && r3.data.length > this._def.items.length && (Xn(r3, { code: Hn.too_big, maximum: this._def.items.length, inclusive: true, exact: false, type: "array" }), t3.dirty());
        const n3 = [...r3.data].map((e4, t4) => {
          const n4 = this._def.items[t4] || this._def.rest;
          return n4 ? n4._parse(new os(r3, e4, r3.path, t4)) : null;
        }).filter((e4) => !!e4);
        return r3.common.async ? Promise.all(n3).then((e4) => Qn.mergeArray(t3, e4)) : Qn.mergeArray(t3, n3);
      }
      get items() {
        return this._def.items;
      }
      rest(e3) {
        return new Qs({ ...this._def, rest: e3 });
      }
    }
    Qs.create = (e3, t3) => {
      if (!Array.isArray(e3)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
      return new Qs({ items: e3, typeName: yi.ZodTuple, rest: null, ...cs(t3) });
    };
    class Ys extends ls {
      get keySchema() {
        return this._def.keyType;
      }
      get valueSchema() {
        return this._def.valueType;
      }
      _parse(e3) {
        const { status: t3, ctx: r3 } = this._processInputParams(e3);
        if (r3.parsedType !== Bn.map) return Xn(r3, { code: Hn.invalid_type, expected: Bn.map, received: r3.parsedType }), Yn;
        const n3 = this._def.keyType, s3 = this._def.valueType, i2 = [...r3.data.entries()].map(([e4, t4], i3) => ({ key: n3._parse(new os(r3, e4, r3.path, [i3, "key"])), value: s3._parse(new os(r3, t4, r3.path, [i3, "value"])) }));
        if (r3.common.async) {
          const e4 = /* @__PURE__ */ new Map();
          return Promise.resolve().then(async () => {
            for (const r4 of i2) {
              const n4 = await r4.key, s4 = await r4.value;
              if ("aborted" === n4.status || "aborted" === s4.status) return Yn;
              "dirty" !== n4.status && "dirty" !== s4.status || t3.dirty(), e4.set(n4.value, s4.value);
            }
            return { status: t3.value, value: e4 };
          });
        }
        {
          const e4 = /* @__PURE__ */ new Map();
          for (const r4 of i2) {
            const n4 = r4.key, s4 = r4.value;
            if ("aborted" === n4.status || "aborted" === s4.status) return Yn;
            "dirty" !== n4.status && "dirty" !== s4.status || t3.dirty(), e4.set(n4.value, s4.value);
          }
          return { status: t3.value, value: e4 };
        }
      }
    }
    Ys.create = (e3, t3, r3) => new Ys({ valueType: t3, keyType: e3, typeName: yi.ZodMap, ...cs(r3) });
    class ei extends ls {
      _parse(e3) {
        const { status: t3, ctx: r3 } = this._processInputParams(e3);
        if (r3.parsedType !== Bn.set) return Xn(r3, { code: Hn.invalid_type, expected: Bn.set, received: r3.parsedType }), Yn;
        const n3 = this._def;
        null !== n3.minSize && r3.data.size < n3.minSize.value && (Xn(r3, { code: Hn.too_small, minimum: n3.minSize.value, type: "set", inclusive: true, exact: false, message: n3.minSize.message }), t3.dirty()), null !== n3.maxSize && r3.data.size > n3.maxSize.value && (Xn(r3, { code: Hn.too_big, maximum: n3.maxSize.value, type: "set", inclusive: true, exact: false, message: n3.maxSize.message }), t3.dirty());
        const s3 = this._def.valueType;
        function i2(e4) {
          const r4 = /* @__PURE__ */ new Set();
          for (const n4 of e4) {
            if ("aborted" === n4.status) return Yn;
            "dirty" === n4.status && t3.dirty(), r4.add(n4.value);
          }
          return { status: t3.value, value: r4 };
        }
        const o2 = [...r3.data.values()].map((e4, t4) => s3._parse(new os(r3, e4, r3.path, t4)));
        return r3.common.async ? Promise.all(o2).then((e4) => i2(e4)) : i2(o2);
      }
      min(e3, t3) {
        return new ei({ ...this._def, minSize: { value: e3, message: Jn.toString(t3) } });
      }
      max(e3, t3) {
        return new ei({ ...this._def, maxSize: { value: e3, message: Jn.toString(t3) } });
      }
      size(e3, t3) {
        return this.min(e3, t3).max(e3, t3);
      }
      nonempty(e3) {
        return this.min(1, e3);
      }
    }
    ei.create = (e3, t3) => new ei({ valueType: e3, minSize: null, maxSize: null, typeName: yi.ZodSet, ...cs(t3) });
    class ti extends ls {
      get schema() {
        return this._def.getter();
      }
      _parse(e3) {
        const { ctx: t3 } = this._processInputParams(e3);
        return this._def.getter()._parse({ data: t3.data, path: t3.path, parent: t3 });
      }
    }
    ti.create = (e3, t3) => new ti({ getter: e3, typeName: yi.ZodLazy, ...cs(t3) });
    class ri extends ls {
      _parse(e3) {
        if (e3.data !== this._def.value) {
          const t3 = this._getOrReturnCtx(e3);
          return Xn(t3, { received: t3.data, code: Hn.invalid_literal, expected: this._def.value }), Yn;
        }
        return { status: "valid", value: e3.data };
      }
      get value() {
        return this._def.value;
      }
    }
    function ni(e3, t3) {
      return new si({ values: e3, typeName: yi.ZodEnum, ...cs(t3) });
    }
    ri.create = (e3, t3) => new ri({ value: e3, typeName: yi.ZodLiteral, ...cs(t3) });
    class si extends ls {
      _parse(e3) {
        if ("string" != typeof e3.data) {
          const t3 = this._getOrReturnCtx(e3), r3 = this._def.values;
          return Xn(t3, { expected: qn.joinValues(r3), received: t3.parsedType, code: Hn.invalid_type }), Yn;
        }
        if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e3.data)) {
          const t3 = this._getOrReturnCtx(e3), r3 = this._def.values;
          return Xn(t3, { received: t3.data, code: Hn.invalid_enum_value, options: r3 }), Yn;
        }
        return ts(e3.data);
      }
      get options() {
        return this._def.values;
      }
      get enum() {
        const e3 = {};
        for (const t3 of this._def.values) e3[t3] = t3;
        return e3;
      }
      get Values() {
        const e3 = {};
        for (const t3 of this._def.values) e3[t3] = t3;
        return e3;
      }
      get Enum() {
        const e3 = {};
        for (const t3 of this._def.values) e3[t3] = t3;
        return e3;
      }
      extract(e3, t3 = this._def) {
        return si.create(e3, { ...this._def, ...t3 });
      }
      exclude(e3, t3 = this._def) {
        return si.create(this.options.filter((t4) => !e3.includes(t4)), { ...this._def, ...t3 });
      }
    }
    si.create = ni;
    class ii extends ls {
      _parse(e3) {
        const t3 = qn.getValidEnumValues(this._def.values), r3 = this._getOrReturnCtx(e3);
        if (r3.parsedType !== Bn.string && r3.parsedType !== Bn.number) {
          const e4 = qn.objectValues(t3);
          return Xn(r3, { expected: qn.joinValues(e4), received: r3.parsedType, code: Hn.invalid_type }), Yn;
        }
        if (this._cache || (this._cache = new Set(qn.getValidEnumValues(this._def.values))), !this._cache.has(e3.data)) {
          const e4 = qn.objectValues(t3);
          return Xn(r3, { received: r3.data, code: Hn.invalid_enum_value, options: e4 }), Yn;
        }
        return ts(e3.data);
      }
      get enum() {
        return this._def.values;
      }
    }
    ii.create = (e3, t3) => new ii({ values: e3, typeName: yi.ZodNativeEnum, ...cs(t3) });
    class oi extends ls {
      unwrap() {
        return this._def.type;
      }
      _parse(e3) {
        const { ctx: t3 } = this._processInputParams(e3);
        if (t3.parsedType !== Bn.promise && false === t3.common.async) return Xn(t3, { code: Hn.invalid_type, expected: Bn.promise, received: t3.parsedType }), Yn;
        const r3 = t3.parsedType === Bn.promise ? t3.data : Promise.resolve(t3.data);
        return ts(r3.then((e4) => this._def.type.parseAsync(e4, { path: t3.path, errorMap: t3.common.contextualErrorMap })));
      }
    }
    oi.create = (e3, t3) => new oi({ type: e3, typeName: yi.ZodPromise, ...cs(t3) });
    class ai extends ls {
      innerType() {
        return this._def.schema;
      }
      sourceType() {
        return this._def.schema._def.typeName === yi.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
      }
      _parse(e3) {
        const { status: t3, ctx: r3 } = this._processInputParams(e3), n3 = this._def.effect || null, s3 = { addIssue: (e4) => {
          Xn(r3, e4), e4.fatal ? t3.abort() : t3.dirty();
        }, get path() {
          return r3.path;
        } };
        if (s3.addIssue = s3.addIssue.bind(s3), "preprocess" === n3.type) {
          const e4 = n3.transform(r3.data, s3);
          if (r3.common.async) return Promise.resolve(e4).then(async (e5) => {
            if ("aborted" === t3.value) return Yn;
            const n4 = await this._def.schema._parseAsync({ data: e5, path: r3.path, parent: r3 });
            return "aborted" === n4.status ? Yn : "dirty" === n4.status || "dirty" === t3.value ? es(n4.value) : n4;
          });
          {
            if ("aborted" === t3.value) return Yn;
            const n4 = this._def.schema._parseSync({ data: e4, path: r3.path, parent: r3 });
            return "aborted" === n4.status ? Yn : "dirty" === n4.status || "dirty" === t3.value ? es(n4.value) : n4;
          }
        }
        if ("refinement" === n3.type) {
          const e4 = (e5) => {
            const t4 = n3.refinement(e5, s3);
            if (r3.common.async) return Promise.resolve(t4);
            if (t4 instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
            return e5;
          };
          if (false === r3.common.async) {
            const n4 = this._def.schema._parseSync({ data: r3.data, path: r3.path, parent: r3 });
            return "aborted" === n4.status ? Yn : ("dirty" === n4.status && t3.dirty(), e4(n4.value), { status: t3.value, value: n4.value });
          }
          return this._def.schema._parseAsync({ data: r3.data, path: r3.path, parent: r3 }).then((r4) => "aborted" === r4.status ? Yn : ("dirty" === r4.status && t3.dirty(), e4(r4.value).then(() => ({ status: t3.value, value: r4.value }))));
        }
        if ("transform" === n3.type) {
          if (false === r3.common.async) {
            const e4 = this._def.schema._parseSync({ data: r3.data, path: r3.path, parent: r3 });
            if (!ss(e4)) return Yn;
            const i2 = n3.transform(e4.value, s3);
            if (i2 instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
            return { status: t3.value, value: i2 };
          }
          return this._def.schema._parseAsync({ data: r3.data, path: r3.path, parent: r3 }).then((e4) => ss(e4) ? Promise.resolve(n3.transform(e4.value, s3)).then((e5) => ({ status: t3.value, value: e5 })) : Yn);
        }
        qn.assertNever(n3);
      }
    }
    ai.create = (e3, t3, r3) => new ai({ schema: e3, typeName: yi.ZodEffects, effect: t3, ...cs(r3) }), ai.createWithPreprocess = (e3, t3, r3) => new ai({ schema: t3, effect: { type: "preprocess", transform: e3 }, typeName: yi.ZodEffects, ...cs(r3) });
    class ci extends ls {
      _parse(e3) {
        return this._getType(e3) === Bn.undefined ? ts(void 0) : this._def.innerType._parse(e3);
      }
      unwrap() {
        return this._def.innerType;
      }
    }
    ci.create = (e3, t3) => new ci({ innerType: e3, typeName: yi.ZodOptional, ...cs(t3) });
    class li extends ls {
      _parse(e3) {
        return this._getType(e3) === Bn.null ? ts(null) : this._def.innerType._parse(e3);
      }
      unwrap() {
        return this._def.innerType;
      }
    }
    li.create = (e3, t3) => new li({ innerType: e3, typeName: yi.ZodNullable, ...cs(t3) });
    class ui extends ls {
      _parse(e3) {
        const { ctx: t3 } = this._processInputParams(e3);
        let r3 = t3.data;
        return t3.parsedType === Bn.undefined && (r3 = this._def.defaultValue()), this._def.innerType._parse({ data: r3, path: t3.path, parent: t3 });
      }
      removeDefault() {
        return this._def.innerType;
      }
    }
    ui.create = (e3, t3) => new ui({ innerType: e3, typeName: yi.ZodDefault, defaultValue: "function" == typeof t3.default ? t3.default : () => t3.default, ...cs(t3) });
    class di extends ls {
      _parse(e3) {
        const { ctx: t3 } = this._processInputParams(e3), r3 = { ...t3, common: { ...t3.common, issues: [] } }, n3 = this._def.innerType._parse({ data: r3.data, path: r3.path, parent: { ...r3 } });
        return is(n3) ? n3.then((e4) => ({ status: "valid", value: "valid" === e4.status ? e4.value : this._def.catchValue({ get error() {
          return new Kn(r3.common.issues);
        }, input: r3.data }) })) : { status: "valid", value: "valid" === n3.status ? n3.value : this._def.catchValue({ get error() {
          return new Kn(r3.common.issues);
        }, input: r3.data }) };
      }
      removeCatch() {
        return this._def.innerType;
      }
    }
    di.create = (e3, t3) => new di({ innerType: e3, typeName: yi.ZodCatch, catchValue: "function" == typeof t3.catch ? t3.catch : () => t3.catch, ...cs(t3) });
    class hi extends ls {
      _parse(e3) {
        if (this._getType(e3) !== Bn.nan) {
          const t3 = this._getOrReturnCtx(e3);
          return Xn(t3, { code: Hn.invalid_type, expected: Bn.nan, received: t3.parsedType }), Yn;
        }
        return { status: "valid", value: e3.data };
      }
    }
    hi.create = (e3) => new hi({ typeName: yi.ZodNaN, ...cs(e3) });
    /* @__PURE__ */ Symbol("zod_brand");
    class pi extends ls {
      _parse(e3) {
        const { ctx: t3 } = this._processInputParams(e3), r3 = t3.data;
        return this._def.type._parse({ data: r3, path: t3.path, parent: t3 });
      }
      unwrap() {
        return this._def.type;
      }
    }
    class fi extends ls {
      _parse(e3) {
        const { status: t3, ctx: r3 } = this._processInputParams(e3);
        if (r3.common.async) {
          return (async () => {
            const e4 = await this._def.in._parseAsync({ data: r3.data, path: r3.path, parent: r3 });
            return "aborted" === e4.status ? Yn : "dirty" === e4.status ? (t3.dirty(), es(e4.value)) : this._def.out._parseAsync({ data: e4.value, path: r3.path, parent: r3 });
          })();
        }
        {
          const e4 = this._def.in._parseSync({ data: r3.data, path: r3.path, parent: r3 });
          return "aborted" === e4.status ? Yn : "dirty" === e4.status ? (t3.dirty(), { status: "dirty", value: e4.value }) : this._def.out._parseSync({ data: e4.value, path: r3.path, parent: r3 });
        }
      }
      static create(e3, t3) {
        return new fi({ in: e3, out: t3, typeName: yi.ZodPipeline });
      }
    }
    class gi extends ls {
      _parse(e3) {
        const t3 = this._def.innerType._parse(e3), r3 = (e4) => (ss(e4) && (e4.value = Object.freeze(e4.value)), e4);
        return is(t3) ? t3.then((e4) => r3(e4)) : r3(t3);
      }
      unwrap() {
        return this._def.innerType;
      }
    }
    gi.create = (e3, t3) => new gi({ innerType: e3, typeName: yi.ZodReadonly, ...cs(t3) });
    Zs.lazycreate;
    var yi;
    !(function(e3) {
      e3.ZodString = "ZodString", e3.ZodNumber = "ZodNumber", e3.ZodNaN = "ZodNaN", e3.ZodBigInt = "ZodBigInt", e3.ZodBoolean = "ZodBoolean", e3.ZodDate = "ZodDate", e3.ZodSymbol = "ZodSymbol", e3.ZodUndefined = "ZodUndefined", e3.ZodNull = "ZodNull", e3.ZodAny = "ZodAny", e3.ZodUnknown = "ZodUnknown", e3.ZodNever = "ZodNever", e3.ZodVoid = "ZodVoid", e3.ZodArray = "ZodArray", e3.ZodObject = "ZodObject", e3.ZodUnion = "ZodUnion", e3.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e3.ZodIntersection = "ZodIntersection", e3.ZodTuple = "ZodTuple", e3.ZodRecord = "ZodRecord", e3.ZodMap = "ZodMap", e3.ZodSet = "ZodSet", e3.ZodFunction = "ZodFunction", e3.ZodLazy = "ZodLazy", e3.ZodLiteral = "ZodLiteral", e3.ZodEnum = "ZodEnum", e3.ZodEffects = "ZodEffects", e3.ZodNativeEnum = "ZodNativeEnum", e3.ZodOptional = "ZodOptional", e3.ZodNullable = "ZodNullable", e3.ZodDefault = "ZodDefault", e3.ZodCatch = "ZodCatch", e3.ZodPromise = "ZodPromise", e3.ZodBranded = "ZodBranded", e3.ZodPipeline = "ZodPipeline", e3.ZodReadonly = "ZodReadonly";
    })(yi || (yi = {}));
    Ns.create, Us.create, hi.create, Ls.create, Fs.create, Ms.create, Ds.create, qs.create, $s.create;
    const mi = Bs.create, _i = (zs.create, Hs.create, Ks.create, Vs.create, Zs.create, Zs.strictCreate, Js.create, Xs.create, Qs.create, Ys.create, ei.create, ti.create, ri.create, si.create, ii.create, oi.create, ai.create, ci.create, li.create, ai.createWithPreprocess, fi.create, (e3, t3) => Vr(e3, { maxAttempts: void 0 !== t3 ? t3 + 1 : 1, baseDelay: 1e3, shouldRetry: () => !!Zt() })), wi = ({ error: e3, showErrorNotification: t3, errorMessage: r3 }) => {
      const n3 = e3;
      "ERR_CANCELED" === n3.code ? console.warn("\u0417\u0430\u043F\u0440\u043E\u0441 \u0431\u044B\u043B \u043E\u0442\u043C\u0435\u043D\u0435\u043D", n3) : e3 instanceof Kn ? console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u0432\u0430\u043B\u0438\u0434\u0430\u0446\u0438\u0438 \u0434\u0430\u043D\u043D\u044B\u0445", e3) : (t3 || r3) && (r3 ? qr({ message: r3, type: "error" }) : (({ error: e4, isNotification: t4 }) => {
        console.error("\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 \u0437\u0430\u043F\u0440\u043E\u0441\u0430:", e4), t4 && qr({ message: `${e4.errMessage ?? e4.message}`, type: "error" });
      })({ error: e3, isNotification: t3 }));
    }, vi = (e3, t3) => {
      e3?.entity && e3?.cacheKey && console.warn("[sdk-js cache] cache.entity and cache.cacheKey cannot be used together; cacheKey is ignored in entity mode");
      const r3 = Rn(e3?.tags, t3);
      return { enabled: true === e3?.enabled, tags: r3, forceRequest: e3?.forceRequest ?? false, ttlMs: (n3 = e3?.stateTime, n3 ?? 6e5), invalidateTags: e3?.invalidateTags, entity: e3?.entity, cacheKey: e3?.cacheKey };
      // removed by dead control flow
 var n3; 
    }, bi = (e3, t3, r3) => {
      if (!e3) return { key: "", cacheEnabled: false };
      const n3 = r3();
      return null == n3 ? (console.warn(`[sdk-js cache] ${t3}: cannot build cache key from body/params (non-JSON payload, max depth/nodes exceeded, or circular). cache/dedupe disabled for this request; proceeding without cache.`), { key: "", cacheEnabled: false }) : { key: n3, cacheEnabled: true };
    }, Si = (e3) => e3 >= 200 && e3 < 300 || 304 === e3, ki = (e3, t3, r3) => ({ ...t3 ? { signal: t3 } : {}, ...r3 ? { headers: r3 } : {}, ...e3 ? { validateStatus: Si } : {} }), xi = (e3, t3) => t3 ? { ...t3, data: e3 } : { data: e3, status: 200, statusText: "OK", headers: {}, config: {} }, Ti = { async get({ url: e3, service: t3, schema: r3 = mi(), cache: n3, queryOptions: s3, successMessage: i2 = null, successNotificationType: o2 = "success", showErrorNotification: a2 = false, errorMessage: c2 = null, axiosInstance: l2, controller: u2 }) {
      try {
        const a3 = vi(n3), c3 = u2?.signal;
        if (a3.enabled && a3.entity) {
          const n4 = await jn({ method: "GET", service: String(t3), baseURL: l2.defaults.baseURL, params: l2.defaults.params, headers: l2.defaults.headers, ctx: { url: e3 }, config: a3.entity, ttlMs: a3.ttlMs, forceRequest: a3.forceRequest, signal: c3, execute: (e4, t4) => _i(() => l2.get(e4.url, t4 ? { signal: t4 } : void 0), s3?.retry) }), u3 = xi(n4.data, n4.networkResponse);
          return r3.parse(u3.data), n4.hadEntry && !a3.forceRequest || $r({ successMessage: i2, notificationType: o2 }), u3;
        }
        const { key: d2, cacheEnabled: h2 } = bi(a3.enabled, "GET", () => An({ method: "GET", service: t3, baseURL: l2.defaults.baseURL, url: e3, params: l2.defaults.params, headers: l2.defaults.headers, keyBuilder: a3.cacheKey })), { response: p2, hadEntry: f2 } = await In({ key: d2, cache: h2, forceRequest: a3.forceRequest, ttlMs: a3.ttlMs, tags: a3.tags, retry: s3?.retry, signal: c3, axiosRequest: (t4, r4) => l2.get(e3, ki(h2, t4, r4)) });
        return r3.parse(p2.data), f2 && !a3.forceRequest || $r({ successMessage: i2, notificationType: o2 }), p2;
      } catch (e4) {
        throw wi({ error: e4, showErrorNotification: a2, errorMessage: c2 }), e4;
      }
    }, async post({ url: e3, service: t3, schema: r3 = mi(), cache: n3, queryOptions: s3, successMessage: i2 = null, successNotificationType: o2 = "success", showErrorNotification: a2 = false, errorMessage: c2 = null, data: l2, axiosInstance: u2, controller: d2 }) {
      try {
        const a3 = vi(n3, l2), c3 = d2?.signal;
        if (a3.enabled && a3.entity) {
          const n4 = await jn({ method: "POST", service: String(t3), baseURL: u2.defaults.baseURL, params: u2.defaults.params, headers: u2.defaults.headers, ctx: { url: e3, data: l2 }, config: a3.entity, ttlMs: a3.ttlMs, forceRequest: a3.forceRequest, signal: c3, execute: (e4, t4) => _i(() => u2.post(e4.url, e4.data, t4 ? { signal: t4 } : void 0), s3?.retry) }), d3 = xi(n4.data, n4.networkResponse);
          return n4.fromNetwork && Pn(a3.invalidateTags, l2), r3.parse(d3.data), n4.hadEntry && !a3.forceRequest || $r({ successMessage: i2, notificationType: o2 }), d3;
        }
        const { key: h2, cacheEnabled: p2 } = bi(a3.enabled, "POST", () => An({ method: "POST", service: t3, baseURL: u2.defaults.baseURL, url: e3, data: l2, params: u2.defaults.params, headers: u2.defaults.headers, keyBuilder: a3.cacheKey })), { response: f2, fromCache: g2, hadEntry: y2 } = await In({ key: h2, cache: p2, forceRequest: a3.forceRequest, ttlMs: a3.ttlMs, tags: a3.tags, retry: s3?.retry, signal: c3, axiosRequest: (t4, r4) => u2.post(e3, l2, ki(p2, t4, r4)) });
        return g2 || Pn(a3.invalidateTags, l2), r3.parse(f2.data), y2 && !a3.forceRequest || $r({ successMessage: i2, notificationType: o2 }), f2;
      } catch (e4) {
        throw wi({ error: e4, showErrorNotification: a2, errorMessage: c2 }), e4;
      }
    }, async put({ url: e3, schema: t3 = mi(), successMessage: r3 = null, successNotificationType: n3 = "success", showErrorNotification: s3 = false, errorMessage: i2 = null, data: o2, axiosInstance: a2, queryOptions: c2, cache: l2 }) {
      try {
        const s4 = await _i(() => a2.put(e3, o2), c2?.retry);
        return Pn(l2?.invalidateTags, o2), $r({ successMessage: r3, notificationType: n3 }), t3.parse(s4.data), s4;
      } catch (e4) {
        throw wi({ error: e4, showErrorNotification: s3, errorMessage: i2 }), e4;
      }
    }, async patch({ url: e3, axiosInstance: t3, schema: r3 = mi(), successMessage: n3 = null, successNotificationType: s3 = "success", showErrorNotification: i2 = false, errorMessage: o2 = null, data: a2, queryOptions: c2, cache: l2 }) {
      try {
        const i3 = await _i(() => t3.patch(e3, a2), c2?.retry);
        return Pn(l2?.invalidateTags, a2), $r({ successMessage: n3, notificationType: s3 }), r3.parse(i3.data), i3;
      } catch (e4) {
        throw wi({ error: e4, showErrorNotification: i2, errorMessage: o2 }), e4;
      }
    }, async delete({ url: e3, schema: t3 = mi(), axiosInstance: r3, successMessage: n3 = null, successNotificationType: s3 = "success", showErrorNotification: i2 = false, errorMessage: o2 = null, data: a2, queryOptions: c2, cache: l2 }) {
      try {
        const i3 = await _i(() => r3.delete(e3, { data: a2 }), c2?.retry);
        return Pn(l2?.invalidateTags, a2), $r({ successMessage: n3, notificationType: s3 }), t3.parse(i3.data), i3;
      } catch (e4) {
        throw wi({ error: e4, showErrorNotification: i2, errorMessage: o2 }), e4;
      }
    } }, Ei = Ti;
    const Ri = new class {
      constructor() {
        __publicField(this, "refreshPromise", null);
      }
      async requestNewAccessToken({ buildEnv: e3, hosts: t3 }) {
        const r3 = `${Br({ service: "sarex", buildEnv: e3, hosts: t3 })}/api/token/refresh/`, n3 = Zt();
        console.debug("Try refresh with:", n3);
        return (await kt.post(r3, { refresh: n3 })).data;
      }
      async getNewAccessToken({ isBackgroundRefresh: e3, removeAccessToken: t3, accessTokenRefreshRetryCount: r3, buildEnv: n3, hosts: s3 }) {
        if (this.refreshPromise) return this.refreshPromise;
        Ft({ isRefreshing: true });
        const i2 = Yt();
        return this.refreshPromise = Nt(async () => {
          await new Promise((e4) => setTimeout(e4, 50));
          const o2 = Yt();
          if (i2 !== o2) return;
          t3 && lr();
          const { data: a2, error: c2 } = await (async () => {
            let e4;
            for (let t4 = 0; t4 <= r3; t4++) {
              try {
                return { data: await Ri.requestNewAccessToken({ buildEnv: n3, hosts: s3 }), error: null };
              } catch (t5) {
                if (e4 = t5, 401 === e4.status || 400 === e4.status) return { error: e4, data: null };
              }
              if (t4 < r3) {
                const e5 = 2e3 * Math.pow(2, t4);
                await new Promise((t5) => setTimeout(t5, e5));
              }
            }
            return { data: null, error: e4 };
          })();
          if (null !== c2) throw e3 && 401 === c2.status && this.removeTokens(), c2;
          a2 && (tr(a2.access), rr(a2.refresh));
        }), this.refreshPromise.catch(console.error).finally(() => {
          this.refreshPromise = null;
          const e4 = Yt();
          Ft({ isExpired: e4 < 0 || e4 == i2, isRefreshing: false });
        }), this.refreshPromise;
      }
      removeTokens({ silent: e3 = false } = {}) {
        On(), lr(), ur(), hr(), e3 || Lt({ isExpired: true });
      }
      async login({ username: e3, password: t3, buildEnv: r3, hosts: n3 }) {
        const s3 = `${Br({ service: "sarex", buildEnv: r3, hosts: n3 })}/api/token/`;
        try {
          const r4 = await kt.post(s3, { username: e3, password: t3 });
          return tr(r4.data.access), rr(r4.data.refresh), Lt({ isExpired: false }), r4.status;
        } catch (e4) {
          throw console.error(e4), e4;
        }
      }
      async getValidAccessToken({ accessTokenRefreshRetryCount: e3, buildEnv: t3, hosts: r3 }) {
        const n3 = Wt(), s3 = async () => {
          try {
            await Ri.getNewAccessToken({ isBackgroundRefresh: true, removeAccessToken: false, accessTokenRefreshRetryCount: e3, buildEnv: t3, hosts: r3 });
            const n4 = Wt();
            return n4 || null;
          } catch (e4) {
            return null;
          }
        };
        if (!n3) return await s3();
        const i2 = Kr(n3);
        return null === i2 ? null : i2 <= 60 ? await s3() : n3;
      }
      async getAuthHeaders({ accessTokenRefreshRetryCount: e3, buildEnv: t3, hosts: r3 }) {
        const n3 = await Ri.getValidAccessToken({ accessTokenRefreshRetryCount: e3, buildEnv: t3, hosts: r3 });
        if (!n3) throw new Error("No token");
        return { Authorization: `Bearer ${n3}` };
      }
      async getTokensByExternalCookie({ buildEnv: e3, hosts: t3 }) {
        try {
          const r3 = `${Br({ service: "sarex", buildEnv: e3, hosts: t3 })}/api/token/`, n3 = await kt.get(r3), { data: s3 } = n3;
          return s3.access && s3.refresh ? (tr(s3.access), rr(s3.refresh), s3) : null;
        } catch (e4) {
          return null;
        }
      }
      defineAuthMode(e3) {
        const t3 = e3?.web?.auth_mode;
        ir(!(!t3 || t3 !== gr));
      }
    }();
    let Ai = false;
    const Oi = [], Ci = ({ token: e3, error: t3 }) => {
      Oi.forEach((r3) => r3({ token: e3, error: t3 })), Oi.length = 0;
    }, Ii = (e3) => {
      throw Ri.removeTokens(), Ci({ token: null, error: e3 }), e3;
    }, Pi = ({ axiosInstance: e3, service: t3, withoutAutoLogout: r3, accessTokenRefreshRetryCount: n3, isCSRF: s3, isUsingExternalCookie: i2, buildEnv: o2, hosts: a2 }) => {
      e3.interceptors.request.use((e4) => {
        const t4 = Wt(), r4 = Qt();
        return e4.headers && (t4 && (e4.headers.Authorization = `Bearer ${t4}`), s3 && r4 && (e4.headers[Kt] = r4)), e4;
      }), e3.interceptors.response.use((e4) => e4, async (e4) => {
        const { response: s4, config: c2 } = e4;
        if (s4) {
          const { status: l2 } = s4;
          if (401 !== l2 || c2._isRetry) {
            const r4 = Hr(t3, e4, l2);
            return Promise.reject(r4);
          }
          if (Zt()) return c2._isRetry = true, (async ({ originalRequest: e5, withoutAutoLogout: t4, accessTokenRefreshRetryCount: r4, isUsingExternalCookie: n4, buildEnv: s5, hosts: i3 }) => {
            if (Ai) return new Promise((t5, r5) => {
              Oi.push(({ token: n5, error: s6 }) => {
                s6 ? r5(s6) : n5 && (e5.headers.Authorization = `Bearer ${n5}`, t5(kt.request(e5)));
              });
            });
            Ai = true;
            try {
              if (!Zt()) return Ii(new Error("Refresh token is missing"));
              await Ri.getNewAccessToken({ isBackgroundRefresh: false, removeAccessToken: true, accessTokenRefreshRetryCount: r4, buildEnv: s5, hosts: i3 });
              const n5 = Wt();
              if (t4 && !n5) {
                const e6 = new Error("Access token is missing");
                throw Ci({ token: null, error: e6 }), e6;
              }
              return n5 ? (Ai = false, Ci({ token: n5 }), e5.headers.Authorization = `Bearer ${n5}`, kt.request(e5)) : Ii(new Error("Access token is missing"));
            } catch (r5) {
              if (Ai = false, t4) {
                if (n4) {
                  const t5 = await Ri.getTokensByExternalCookie({ buildEnv: s5, hosts: i3 });
                  if (t5 && t5.access) return Ci({ token: t5.access }), e5.headers.Authorization = `Bearer ${t5.access}`, kt.request(e5);
                  throw Ci({ token: null, error: r5 }), r5;
                }
                throw Ci({ token: null, error: r5 }), r5;
              }
              if (n4) {
                const t5 = await Ri.getTokensByExternalCookie({ buildEnv: s5, hosts: i3 });
                return t5 && t5.access ? (Ci({ token: t5.access }), e5.headers.Authorization = `Bearer ${t5.access}`, kt.request(e5)) : Ii(r5);
              }
              return Ii(r5);
            }
          })({ originalRequest: c2, withoutAutoLogout: r3, accessTokenRefreshRetryCount: n3, isUsingExternalCookie: i2, buildEnv: o2, hosts: a2 });
          if (i2) {
            const e5 = await Ri.getTokensByExternalCookie({ buildEnv: o2, hosts: a2 });
            if (e5) return c2.headers.Authorization = `Bearer ${e5.access}`, kt.request(c2);
          }
          return Ri.removeTokens(), Promise.reject({ message: "Refresh token is missing" });
        }
        {
          const r4 = Hr(t3, e4);
          return Promise.reject(r4);
        }
      });
    }, Ni = Ti;
    var ji = i(5373), Ui = i.n(ji);
    const Li = "[SessionTracker]";
    class Fi {
      constructor(e3 = { logToConsole: true }) {
        __publicField(this, "sessionStartedAt", null);
        __publicField(this, "sessionId", null);
        __publicField(this, "sentry");
        __publicField(this, "logToConsole");
        __publicField(this, "tokensHandler", null);
        __publicField(this, "unsubscribeRefreshing", null);
        __publicField(this, "refreshStartedInThisTab", false);
        __publicField(this, "lastRefreshTrigger", "unknown");
        this.sentry = e3.sentry ?? null, this.logToConsole = e3.logToConsole, this.setupListeners();
      }
      log(e3, t3) {
        this.logToConsole && (t3 ? console.log(Li, e3, t3) : console.log(Li, e3)), this.sentry?.addBreadcrumb?.({ category: "session", message: e3, level: "info", data: t3 });
      }
      logWarn(e3, t3) {
        this.logToConsole && (t3 ? console.warn(Li, e3, t3) : console.warn(Li, e3)), this.sentry?.addBreadcrumb?.({ category: "session", message: e3, level: "warning", data: t3 });
      }
      logRefreshNotCompletedInTimeout({ elapsedMs: e3, additionalInfo: t3 }) {
        const r3 = Math.round(e3 / 1e3), n3 = { elapsedMs: e3, elapsedSec: r3, additionalInfo: t3 };
        this.logWarn(`Token refresh has not completed in ${r3} seconds`, n3), this.sentry?.setTag?.("auth.refresh_slow", "true");
      }
      logRefreshCompletedInTimeout({ elapsedMs: e3, additionalInfo: t3 }) {
        const r3 = Math.round(e3 / 1e3);
        this.logWarn(`Token refresh has completed successfully in ${r3} seconds`, { additionalInfo: t3 }), this.sentry?.setTag?.("auth.refresh_slow", "false");
      }
      setupListeners() {
        Zt() && this.startSession(), this.tokensHandler = (e3) => {
          const { isExpired: t3 } = e3?.detail ?? {};
          t3 ? this.endSession("tokens_have_expired") : Zt() && this.startSession();
        }, Mt({ fn: this.tokensHandler }), this.unsubscribeRefreshing = Dt({ fn: (e3) => {
          const { isRefreshing: t3 } = e3?.detail ?? {};
          if (t3) {
            const e4 = false;
            this.refreshStartedInThisTab = Ut() && !e4, this.log("Token refresh started", { source: e4 ? "other_tab" : "this_tab", multiTab: e4 }), this.sentry?.setTag?.("auth.refresh_in_progress", "true");
          } else this.log("Token refresh finished", { wasStartedInThisTab: this.refreshStartedInThisTab }), this.sentry?.setTag?.("auth.refresh_in_progress", "false"), this.refreshStartedInThisTab = false;
        } });
      }
      startSession() {
        null == this.sessionStartedAt && (this.sessionStartedAt = Date.now().toString(), this.sessionId = `session_${new Date(Number(this.sessionStartedAt)).toISOString()}_${Math.random().toString(36).slice(2, 9)}`, this.log("Session started", { sessionId: this.sessionId }), this.sentry?.setTag?.("session.id", this.sessionId), this.sentry?.addBreadcrumb?.({ category: "session", message: "Session started", level: "info", data: { sessionId: this.sessionId } }));
      }
      endSession(e3, t3) {
        if (null == this.sessionStartedAt) return void this.log("refresh_token_is_expired", { source: "this_tab" });
        const r3 = "tokens_were_cleared" === e3 ? void 0 : this.lastRefreshTrigger, n3 = Date.now() - Number(this.sessionStartedAt), s3 = Math.round(n3 / 1e3);
        this.log("Session ended", { reason: e3, sessionId: this.sessionId, durationSec: s3, refreshTrigger: r3, additionalInfo: t3 }), this.sentry?.setTag?.("session.end_reason", e3), this.sentry?.setTag?.("session.duration_sec", String(s3)), this.sentry?.setTag?.("session.additional_info", t3 ?? ""), this.sentry?.addBreadcrumb?.({ category: "session", message: `Session ended: ${e3}`, level: "user_logged_out" === e3 ? "info" : "warning", data: { reason: e3, sessionId: this.sessionId, durationSec: s3, refreshTrigger: r3, additionalInfo: t3 } }), this.sentry?.captureMessage?.(`Session ended: ${e3}`, "info"), this.sessionStartedAt = null, this.sessionId = null, this.lastRefreshTrigger = "unknown";
      }
      onTokenRefreshStarted({ isBackgroundRefresh: e3, additionalInfo: t3 }) {
        this.refreshStartedInThisTab = true, this.lastRefreshTrigger = e3 ? "background" : "reactive", this.log("Token refresh started", { source: "this_tab", multiTab: false, refreshTrigger: this.lastRefreshTrigger, additionalInfo: t3 });
      }
      onTokenRefreshFinished(e3, t3) {
        this.refreshStartedInThisTab = false, this.log("Refreshing tokens finished", { source: "this_tab", durationMs: e3, durationSec: Math.round(e3 / 1e3), refreshTrigger: this.lastRefreshTrigger, additionalInfo: t3 }), this.lastRefreshTrigger = "unknown";
      }
      onTokenRefreshError(e3, t3) {
        this.log("Token refresh error", { reason: e3, additionalInfo: t3 }), this.endSession(e3, t3);
      }
      onLogout() {
        this.endSession("user_logged_out");
      }
      getSessionId() {
        return this.sessionId;
      }
      getSessionStartedAt() {
        return this.sessionStartedAt;
      }
      destroy() {
        this.tokensHandler && "undefined" != typeof window && (window.removeEventListener(xt, this.tokensHandler), this.tokensHandler = null), this.unsubscribeRefreshing?.(), this.unsubscribeRefreshing = null, this.sessionStartedAt = null, this.sessionId = null;
      }
    }
    let Mi = null;
    function Di(e3) {
      return Mi || (Mi = new Fi(e3 ?? { logToConsole: true })), Mi;
    }
    function qi(e3) {
      Mi?.destroy(), Mi = new Fi(e3 ?? { logToConsole: true });
    }
    const $i = new class {
      constructor() {
        __publicField(this, "refreshPromise", null);
        __publicField(this, "banAutoTokensRemove", true);
        this.getNewAccessToken = this.getNewAccessToken.bind(this), this.getNewAccessTokenState = this.getNewAccessTokenState.bind(this), this.requestNewAccessToken = this.requestNewAccessToken.bind(this), this.getValidAccessToken = this.getValidAccessToken.bind(this), this.removeTokens = this.removeTokens.bind(this), this.getAuthHeaders = this.getAuthHeaders.bind(this);
      }
      getResolvedRefreshState(e3) {
        const t3 = Wt(), r3 = Zt(), n3 = Jt(), s3 = Yt();
        if (!t3 || !r3 || !n3) throw new Error("Refresh state is incomplete");
        return { source: e3, accessToken: t3, refreshToken: r3, identityToken: n3, refreshVersion: s3 };
      }
      async tryExternalAuthRecover({ refreshVersion: e3 }) {
        const t3 = Bt();
        if (!t3) return console.debug("[SDK] External auth recover skipped: method is not set"), null;
        const r3 = er();
        if (r3?.refreshVersion === e3 && "failed" === r3.status) return console.debug("[SDK] External auth recover skipped: already failed for refresh version", { refreshVersion: e3, externalRecoverState: r3 }), null;
        console.debug("[SDK] External auth recover started", { refreshVersion: e3, externalRecoverState: r3 }), ar({ refreshVersion: e3, status: "started" });
        let n3, s3 = { state: "skipped", reason: "not_enter" };
        try {
          s3 = await t3("zitadel", { getState: er, setState: cr });
        } catch (e4) {
          s3 = { state: "skipped", reason: e4 instanceof Error ? e4.message : "external_recover_crashed" };
        }
        if ("skipped" === s3?.state) return ar({ refreshVersion: e3, status: "skipped", reason: s3.reason }), console.debug("[SDK] External auth recover  skiped!", { refreshVersion: e3, reason: s3.reason }), null;
        if ("failed" === s3?.state) return ar({ refreshVersion: e3, status: "failed", reason: s3.reason }), null;
        try {
          n3 = this.getResolvedRefreshState("external");
        } catch (t4) {
          return console.debug("[SDK] External auth recover resolved without complete token state", { refreshVersion: e3, error: t4 }), ar({ refreshVersion: e3, status: "failed", reason: "external_recover_incomplete_token_state" }), null;
        }
        return n3.refreshVersion <= e3 ? (console.debug("[SDK] External auth recover resolved without refresh version bump", { refreshVersion: e3, actualRefreshVersion: n3.refreshVersion }), ar({ refreshVersion: e3, status: "failed", reason: "external_recover_without_version_bump", resolvedRefreshVersion: n3.refreshVersion }), null) : (console.debug("[SDK] External auth recover resolved token state", { refreshVersion: e3, actualRefreshVersion: n3.refreshVersion }), ar({ refreshVersion: e3, status: "resolved", reason: "external_recover_resolved", resolvedRefreshVersion: n3.refreshVersion }), n3);
      }
      broadcastRefreshValidation(e3) {
        "resolved" !== e3.kind ? Ft({ isExpired: e3.isExpired, isRefreshing: false, reason: e3.reason }) : e3.shouldBroadcast && Ft({ isExpired: false, isRefreshing: false, reason: e3.reason });
      }
      validateFailedRefresh({ error: e3, lastVersion: t3 }) {
        if (400 === e3.status) {
          if (Yt() > t3) {
            console.debug("[SDK] Recover state after 400 race");
            try {
              return { kind: "resolved", state: this.getResolvedRefreshState("external"), shouldBroadcast: false };
            } catch {
            }
          }
        }
        return 401 === e3.status || 400 === e3.status ? { kind: "rejected", isExpired: true, reason: 401 === e3.status ? "refresh_401" : "refresh_400", error: e3 } : { kind: "rejected", isExpired: false, reason: "refresh_retry_exhausted", error: e3 };
      }
      async requestNewAccessToken({ buildEnv: e3, hosts: t3 }) {
        let r3 = br().oidcProviderConfig.host;
        if ("" === r3 || void 0 === r3) {
          if ("local" !== e3) throw new Error("Host for the OIDC provider was not setted in shared http service config");
          r3 = `${Br({ service: "zitadel", buildEnv: e3, hosts: t3 })}`;
        }
        const n3 = `${r3}/oauth/v2/token`, s3 = Zt(), i2 = { method: "post", maxBodyLength: 1 / 0, url: n3, headers: { "Content-Type": "application/x-www-form-urlencoded" }, data: Ui().stringify({ grant_type: "refresh_token", client_id: Gt(), refresh_token: s3 }) };
        return (await kt.request(i2)).data;
      }
      async getNewAccessTokenState({ isBackgroundRefresh: e3, removeAccessToken: t3, accessTokenRefreshRetryCount: r3, buildEnv: n3, hosts: s3, additionalInfo: i2 }) {
        if (this.refreshPromise) return this.refreshPromise;
        const o2 = Yt();
        Di().onTokenRefreshStarted({ isBackgroundRefresh: !i2, additionalInfo: i2 });
        const a2 = async () => {
          let e4;
          for (let t4 = 0; t4 <= r3; t4++) {
            try {
              return { data: await this.requestNewAccessToken({ buildEnv: n3, hosts: s3 }), error: null };
            } catch (t5) {
              if (e4 = t5, 401 === e4.status || 400 === e4.status) return { error: e4, data: null };
            }
            if (t4 < r3) {
              const e5 = 2e3 * Math.pow(2, t4);
              await new Promise((t5) => setTimeout(t5, e5));
            }
          }
          return { data: null, error: e4 };
        };
        return this.refreshPromise = Nt(async () => {
          const e4 = Date.now();
          await new Promise((e5) => setTimeout(e5, 50));
          const r4 = Yt();
          if (o2 !== r4) try {
            return this.getResolvedRefreshState("external");
          } catch {
            throw this.broadcastRefreshValidation({ kind: "rejected", isExpired: true, reason: "refresh_token_missing" }), new Error("Refresh token is missing after external refresh resolution");
          }
          Ft({ isRefreshing: true });
          if (!!!Zt()) {
            const e5 = await this.tryExternalAuthRecover({ refreshVersion: r4 });
            if (e5) return this.broadcastRefreshValidation({ kind: "resolved", state: e5, shouldBroadcast: true, reason: "external_recover_resolved" }), e5;
            throw this.broadcastRefreshValidation({ kind: "rejected", isExpired: true, reason: "refresh_token_missing" }), new Error("Refresh token is missing");
          }
          t3 && !this.banAutoTokensRemove && (lr(), pr());
          const { data: n4, error: s4 } = await a2();
          if (Di().onTokenRefreshFinished(Date.now() - e4, i2), null !== s4) {
            const e5 = this.validateFailedRefresh({ error: s4, lastVersion: o2 });
            if ("resolved" === e5.kind) return this.broadcastRefreshValidation(e5), e5.state;
            if ("refresh_400" === e5.reason) {
              const e6 = await this.tryExternalAuthRecover({ refreshVersion: o2 });
              if (e6) return this.broadcastRefreshValidation({ kind: "resolved", state: e6, shouldBroadcast: true, reason: "external_recover_resolved" }), e6;
            }
            e5.error && e5.reason && Di().onTokenRefreshError(e5.reason, i2);
            const t4 = Yt();
            throw t4 === o2 ? this.removeTokens({ silent: true }) : console.debug("[SDK] Skip token removal after refresh_400: refresh version changed", { refreshVersion: o2, actualRefreshVersion: t4 }), this.broadcastRefreshValidation(e5), e5.error;
          }
          if (n4) {
            tr(n4.access_token), rr(n4.refresh_token), nr(n4.id_token);
            const e5 = this.getResolvedRefreshState("self");
            return this.broadcastRefreshValidation({ state: e5, kind: "resolved", shouldBroadcast: true, reason: "refresh_resolved" }), e5;
          }
          throw this.broadcastRefreshValidation({ kind: "rejected", isExpired: true, reason: "refresh_result_missing_tokens" }), new Error("Refresh request completed without tokens");
        }), this.refreshPromise.finally(() => {
          this.refreshPromise = null;
        }), this.refreshPromise;
      }
      async getNewAccessToken(e3) {
        await this.getNewAccessTokenState(e3);
      }
      removeTokens({ silent: e3 = false } = {}) {
        Di().endSession("tokens_were_cleared"), On(), lr(), pr(), ur(), hr(), e3 || Ft({ isExpired: true, reason: "tokens_were_cleared" });
      }
      async login({ username: e3, password: t3 }) {
        return Promise.resolve(200);
      }
      async getValidAccessToken({ accessTokenRefreshRetryCount: e3, buildEnv: t3, hosts: r3 }) {
        const n3 = Wt(), s3 = async ({ reason: n4 }) => {
          try {
            return (await this.getNewAccessTokenState({ isBackgroundRefresh: true, removeAccessToken: false, accessTokenRefreshRetryCount: e3, buildEnv: t3, hosts: r3, additionalInfo: `reason: ${n4}, event was triggered by: getValidAccessToken()` })).accessToken;
          } catch (e4) {
            return null;
          }
        };
        if (!n3) return await s3({ reason: "token_doesnt_exist" });
        const i2 = Kr(n3);
        return null === i2 ? null : i2 <= 120 ? await s3({ reason: "token_is_almost_expired" }) : n3;
      }
      async getAuthHeaders({ accessTokenRefreshRetryCount: e3, buildEnv: t3, hosts: r3 }) {
        const n3 = await this.getValidAccessToken({ accessTokenRefreshRetryCount: e3, buildEnv: t3, hosts: r3 }), s3 = Jt();
        if (!n3 || !s3) throw new Error("No tokens");
        return { Authorization: `Bearer ${n3}`, Identity: `Bearer ${s3}` };
      }
    }();
    let Bi = false;
    const zi = [], Hi = ({ tokens: e3, error: t3 }) => {
      zi.forEach((r3) => r3({ tokens: e3, error: t3 })), zi.length = 0;
    }, Ki = async ({ originalRequest: e3, withoutAutoLogout: t3, accessTokenRefreshRetryCount: r3, buildEnv: n3, hosts: s3 }) => {
      if (Bi) return new Promise((t4, r4) => {
        zi.push(({ tokens: n4, error: s4 }) => {
          s4 ? r4(s4) : n4 && (e3.headers.Authorization = `Bearer ${n4.accessToken}`, e3.headers.Identity = `Bearer ${n4.identityToken}`, t4(kt.request(e3)));
        });
      });
      Bi = true;
      try {
        const t4 = await $i.getNewAccessTokenState({ isBackgroundRefresh: false, removeAccessToken: true, accessTokenRefreshRetryCount: r3, buildEnv: n3, hosts: s3 });
        return Hi({ tokens: t4 }), e3.headers.Authorization = `Bearer ${t4.accessToken}`, e3.headers.Identity = `Bearer ${t4.identityToken}`, kt.request(e3);
      } catch (e4) {
        if (t3) throw Hi({ tokens: null, error: e4 }), e4;
        return ((e5) => {
          throw Hi({ tokens: null, error: e5 }), e5;
        })(e4);
      } finally {
        Bi = false;
      }
    }, Vi = new AbortController();
    Vi.abort("Page is hidden");
    const Wi = ({ axiosInstance: e3, service: t3, withoutAutoLogout: r3, accessTokenRefreshRetryCount: n3, isCSRF: s3, buildEnv: i2, hosts: o2 }) => {
      e3.interceptors.request.use((e4) => (((e5 = false) => e5 ? !("document" in self) || !document.hidden : It)() || "get" !== e4.method || (e4.signal = Vi.signal), e4));
    }, Zi = (e3) => {
      Wi(e3), (({ axiosInstance: e4, service: t3, withoutAutoLogout: r3, accessTokenRefreshRetryCount: n3, isCSRF: s3, buildEnv: i2, hosts: o2 }) => {
        e4.interceptors.request.use((e5) => {
          const t4 = Wt(), r4 = Jt(), n4 = Qt();
          return e5.headers && (t4 && (e5.headers.Authorization = `Bearer ${t4}`), r4 && (e5.headers.Identity = `Bearer ${r4}`), s3 && n4 && (e5.headers[Kt] = n4)), e5;
        }), e4.interceptors.response.use((e5) => e5, async (e5) => {
          const { response: s4, config: a2 } = e5;
          if (s4) {
            const { status: c2 } = s4;
            if (401 !== c2 || a2._isRetry) {
              const r4 = Hr(t3, e5, c2);
              return Promise.reject(r4);
            }
            return a2._isRetry = true, Ki({ originalRequest: a2, withoutAutoLogout: r3, accessTokenRefreshRetryCount: n3, buildEnv: i2, hosts: o2 });
          }
          {
            const r4 = Hr(t3, e5);
            return Promise.reject(r4);
          }
        });
      })(e3);
    }, Ji = ({ config: e3, axiosConfig: t3, buildEnv: r3, hosts: n3 }) => {
      if ("original" === Sr()) {
        return new Dn({ httpRequests: Ei, interceptors: { tokens: Pi }, config: e3, axiosConfig: t3, buildEnv: r3, hosts: n3, removeTokensFN: Ri.removeTokens, getValidAccessTokenFN: Ri.getValidAccessToken, getAuthHeadersFN: Ri.getAuthHeaders, refreshAccessTokenFN: Ri.getNewAccessToken, loginFN: Ri.login });
      }
      return new Dn({ httpRequests: Ni, interceptors: { tokens: Zi }, config: e3, axiosConfig: t3, buildEnv: r3, hosts: n3, removeTokensFN: $i.removeTokens, getValidAccessTokenFN: $i.getValidAccessToken, getAuthHeadersFN: $i.getAuthHeaders, refreshAccessTokenFN: $i.getNewAccessToken, loginFN: $i.login });
    }, Gi = { getAppSettingsInfo: async ({ buildEnv: e3, hosts: t3 }) => {
      const r3 = Sr(), n3 = `${Br({ service: "sarex", buildEnv: e3, hosts: t3 })}/api/app-settings/`, s3 = await kt.get(n3);
      return "original" === r3 && Ri.defineAuthMode(s3.data), s3;
    }, axiosFetch: async ({ url: e3, method: t3, data: r3, ...n3 }) => await kt.request({ url: e3, method: t3, data: r3, ...n3 }) };
    var Xi, Qi;
    !(function(e3) {
      e3.SAREX = "sarex", e3.SAREX_API = "sarexApi", e3.GATEWAY = "gateway", e3.WORKSAPCES = "workspaces", e3.GOOGLE = "google", e3.BIM = "bim", e3.BIMV2 = "bimv2", e3.DOCUMENTATIONS = "documentations", e3.WORKFLOWS = "workflows", e3.COMPARISONS = "comparisons", e3.REMARKS = "remarks", e3.PROJECTS = "projects", e3.EAVV1 = "eavV1", e3.NOTIFICATIONS = "notifications", e3.ZITADEL = "zitadel", e3.ABSOLUTE = "absolute", e3.RELATIVE = "relative", e3.PROCESSES = "processes", e3.FILES = "files", e3.TRANSMITTALS = "transmittals", e3.FLOWS = "flows", e3.DRAWINGS = "drawings", e3.NOTES = "notes", e3.CONTRACTS = "contracts";
    })(Xi || (Xi = {})), (function(e3) {
      e3.STAGE = "stage", e3.PROD = "prod", e3.LOCAL = "local", e3.CONTOUR = "contour", e3.PREPROD = "preprod", e3.CPS = "cps";
    })(Qi || (Qi = {}));
    var Yi = i(9155), eo = i.n(Yi), to = i(5072), ro = i.n(to), no = i(7825), so = i.n(no), io = i(7659), oo = i.n(io), ao = i(5056), co = i.n(ao), lo = i(540), uo = i.n(lo), ho = i(1113), po = i.n(ho), fo = i(8750), go = {};
    go.styleTagTransform = po(), go.setAttributes = co(), go.insert = oo().bind(null, "head"), go.domAPI = so(), go.insertStyleElement = uo();
    ro()(fo.A, go);
    fo.A && fo.A.locals && fo.A.locals;
    var yo = i(5793), mo = i(4442);
    const _o = ({ login: e3, isAuth: t3, homePageURL: r3 }) => t3 ? eo().createElement(mo.Redirect, { to: r3 }) : eo().createElement("div", null, eo().createElement("div", { style: { display: "flex", margin: "auto", width: "100vw", height: "100vh", justifyContent: "center", alignItems: "center" } }, eo().createElement("div", null, eo().createElement("h2", null, "Login Page"), eo().createElement("button", { onClick: e3 }, "Sign in with zitadel")))), wo = ({ setIsAuth: e3, zitadel: t3, Loader: r3, children: n3 }) => {
      const [s3, i2] = (0, Yi.useState)(false);
      return (0, Yi.useEffect)(() => {
        Zt() || (i2(true), t3.userManager.signinCallback().then((t4) => {
          t4 ? (e3(true), tr(t4.access_token), t4.refresh_token && rr(t4.refresh_token), t4.id_token && nr(t4.id_token), Lt({ isExpired: false })) : e3(false);
        }).catch((r4) => {
          t3.signout(), e3(false);
        }).finally(() => i2(false)));
      }, [t3.userManager]), s3 ? eo().createElement(eo().Fragment, null, r3 ?? eo().createElement("div", null, "Loading...")) : Zt() ? eo().createElement(eo().Fragment, null, n3) : eo().createElement(eo().Fragment, null, r3 ?? eo().createElement("div", null, "Loading..."));
    }, vo = ({ zitadel: e3, setIsAuth: t3, Loader: r3, homePageURL: n3 }) => {
      const s3 = (0, mo.useHistory)();
      return (0, Yi.useEffect)(() => {
        e3.userManager.signinCallback().then((e4) => {
          e4 ? (t3(true), tr(e4.access_token), e4.refresh_token && rr(e4.refresh_token), e4.id_token && nr(e4.id_token), Lt({ isExpired: false }), s3.push(n3)) : t3(false);
        }).catch((r4) => {
          e3.signout(), t3(false);
        });
      }, []), eo().createElement(eo().Fragment, null, r3 ?? eo().createElement("div", null, "Loading..."));
    }, bo = ({ children: e3, Loader: t3, httpService: r3, showLogoutButton: n3 = false, zitadelUrls: s3, zitadelClientId: i2, customConfigZitadel: o2, authCallbackPageURL: a2 = "/auth/callback", loginPageURL: c2 = "/login", homePageURL: l2 = "/" }) => {
      const [u2, d2] = (0, Yi.useState)(false), h2 = o2 ?? { authority: s3?.authority ?? "https://idp.dev.stage.sarex.io", response_type: "code", client_id: i2 ?? "", scope: "openid profile email offline_access urn:zitadel:iam:user:metadata", redirect_uri: s3?.redirect_uri ?? `https://localhost:9000${a2}`, post_logout_redirect_uri: s3?.post_logout_redirect_uri ?? `https://localhost:9000${c2}`, redirectMethod: "replace", revokeTokensOnSignout: false, automaticSilentRenew: false, validateSubOnSilentRenew: false }, p2 = (0, yo.createZitadelAuth)(h2);
      return (0, Yi.useEffect)(() => {
        p2.userManager.getUser().then((e4) => {
          e4 ? (d2(true), Lt({ isExpired: false })) : d2(false);
        });
      }, [p2.userManager]), (0, Yi.useEffect)(() => {
        localStorage.setItem(Vt.CLIENT_ID, i2 ?? "");
        const e4 = (e5) => {
          e5.detail && e5.detail.isExpired && p2.signout();
        };
        return Mt({ fn: e4 }), () => {
          window.removeEventListener(xt, e4);
        };
      }, []), eo().createElement(eo().Fragment, null, n3 && u2 && eo().createElement("button", { onClick: function() {
        u2 && (Di().onLogout(), r3.removeTokens());
      } }, "Log out"), eo().createElement(mo.Switch, null, eo().createElement(mo.Route, { path: c2, exact: true }, eo().createElement(_o, { login: function() {
        p2.authorize();
      }, isAuth: u2, homePageURL: l2 })), eo().createElement(mo.Route, { path: a2 }, eo().createElement(vo, { zitadel: p2, setIsAuth: d2, homePageURL: l2 })), eo().createElement(mo.Route, null, eo().createElement(wo, { setIsAuth: d2, zitadel: p2, Loader: t3 }, e3))));
    }, So = ({ httpService: e3 }) => eo().createElement("div", null, eo().createElement("div", { style: { display: "flex", margin: "auto", width: "100vw", height: "100vh", justifyContent: "center", alignItems: "center" } }, eo().createElement("div", null, eo().createElement("h2", null, "Login"), eo().createElement("form", { style: { display: "flex", flexDirection: "column", gap: 10 }, onSubmit: async (t3) => {
      t3.preventDefault();
      const r3 = t3.target, n3 = { password: r3.password.value, username: r3.username.value };
      try {
        await e3.login(n3);
      } catch (e4) {
        console.error(e4);
      }
    } }, eo().createElement("label", { style: { display: "flex", flexDirection: "column", gap: 5 } }, eo().createElement("span", null, "Username"), eo().createElement("input", { type: "text", name: "username" })), eo().createElement("label", { style: { display: "flex", flexDirection: "column", gap: 5 } }, eo().createElement("span", null, "Password"), eo().createElement("input", { type: "password", name: "password" })), eo().createElement("button", { type: "submit" }, "Login"))))), ko = ({ children: e3, httpService: t3, showLogoutButton: r3 = false, loginPageURL: n3 = "/login" }) => {
      const [s3, i2] = (0, Yi.useState)(false), o2 = (0, mo.useHistory)();
      return (0, Yi.useEffect)(() => {
        s3 && o2.push(n3);
      }, [s3, o2]), (0, Yi.useEffect)(() => {
        Wt() || Zt() || i2(true);
        const e4 = async (e5) => {
          e5.detail && (e5.detail.isExpired ? i2(true) : i2(false));
        };
        return Mt({ fn: e4 }), () => {
          window.removeEventListener(xt, e4);
        };
      }, []), !s3 && Zt() ? eo().createElement(eo().Fragment, null, r3 ? eo().createElement(eo().Fragment, null, eo().createElement("button", { onClick: () => {
        t3.removeTokens();
      } }, "Logout"), e3) : eo().createElement(eo().Fragment, null, e3)) : eo().createElement(So, { httpService: t3 });
    }, xo = ({ children: e3, httpService: t3, showLogoutButton: r3, loginPageURL: n3, authCallbackPageURL: s3, Loader: i2, zitadelUrls: o2, zitadelClientId: a2, customConfigZitadel: c2, homePageURL: l2 }) => {
      const u2 = Sr();
      return "zitadel" === u2 ? eo().createElement(bo, { httpService: t3, showLogoutButton: r3, Loader: i2, zitadelUrls: o2, zitadelClientId: a2, customConfigZitadel: c2, authCallbackPageURL: s3, homePageURL: l2, loginPageURL: n3 }, e3) : "original" === u2 ? eo().createElement(ko, { httpService: t3, showLogoutButton: r3, loginPageURL: n3 }, e3) : eo().createElement(eo().Fragment, null, e3);
    };
  })(), o;
})());


/***/ }),

/***/ 4919:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bounce: function() { return /* binding */ Bounce; },
/* harmony export */   Flip: function() { return /* binding */ Flip; },
/* harmony export */   Icons: function() { return /* binding */ Icons; },
/* harmony export */   Slide: function() { return /* binding */ Slide; },
/* harmony export */   ToastContainer: function() { return /* binding */ ToastContainer; },
/* harmony export */   Zoom: function() { return /* binding */ Zoom; },
/* harmony export */   collapseToast: function() { return /* binding */ collapseToast; },
/* harmony export */   cssTransition: function() { return /* binding */ cssTransition; },
/* harmony export */   toast: function() { return /* binding */ toast; },
/* harmony export */   useToast: function() { return /* binding */ useToast; },
/* harmony export */   useToastContainer: function() { return /* binding */ useToastContainer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31719);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51971);



function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function isNum(v) {
  return typeof v === "number" && !isNaN(v);
}
function isBool(v) {
  return typeof v === "boolean";
}
function isStr(v) {
  return typeof v === "string";
}
function isFn(v) {
  return typeof v === "function";
}
function parseClassName(v) {
  return isStr(v) || isFn(v) ? v : null;
}
function isToastIdValid(toastId) {
  return toastId === 0 || toastId;
}
function getAutoCloseDelay(toastAutoClose, containerAutoClose) {
  return toastAutoClose === false || isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var canUseDom = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function canBeRendered(content) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(content) || isStr(content) || isFn(content) || isNum(content);
}
var POSITION = {
  TOP_LEFT: "top-left",
  TOP_RIGHT: "top-right",
  TOP_CENTER: "top-center",
  BOTTOM_LEFT: "bottom-left",
  BOTTOM_RIGHT: "bottom-right",
  BOTTOM_CENTER: "bottom-center"
};
var TYPE = {
  INFO: "info",
  SUCCESS: "success",
  WARNING: "warning",
  ERROR: "error",
  DEFAULT: "default"
};
function collapseToast(node, done, duration) {
  if (duration === void 0) {
    duration = 300;
  }
  var scrollHeight = node.scrollHeight, style = node.style;
  requestAnimationFrame(function() {
    style.minHeight = "initial";
    style.height = scrollHeight + "px";
    style.transition = "all " + duration + "ms";
    requestAnimationFrame(function() {
      style.height = "0";
      style.padding = "0";
      style.margin = "0";
      setTimeout(done, duration);
    });
  });
}
function cssTransition(_ref) {
  var enter = _ref.enter, exit = _ref.exit, _ref$appendPosition = _ref.appendPosition, appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition, _ref$collapse = _ref.collapse, collapse = _ref$collapse === void 0 ? true : _ref$collapse, _ref$collapseDuration = _ref.collapseDuration, collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
  return function ToastTransition(_ref2) {
    var children = _ref2.children, position = _ref2.position, preventExitTransition = _ref2.preventExitTransition, done = _ref2.done, nodeRef = _ref2.nodeRef, isIn = _ref2.isIn;
    var enterClassName = appendPosition ? enter + "--" + position : enter;
    var exitClassName = appendPosition ? exit + "--" + position : exit;
    var baseClassName = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var animationStep = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(
      0
      /* Enter */
    );
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect)(function() {
      onEnter();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
      if (!isIn) preventExitTransition ? onExited() : onExit();
    }, [isIn]);
    function onEnter() {
      var node = nodeRef.current;
      baseClassName.current = node.className;
      node.className += " " + enterClassName;
      node.addEventListener("animationend", onEntered);
      node.addEventListener("animationcancel", onEntered);
    }
    function onEntered(e) {
      if (e.target !== nodeRef.current) return;
      var node = nodeRef.current;
      node.dispatchEvent(new Event(
        "d"
        /* ENTRANCE_ANIMATION_END */
      ));
      node.removeEventListener("animationend", onEntered);
      node.removeEventListener("animationcancel", onEntered);
      if (animationStep.current === 0) {
        node.className = baseClassName.current;
      }
    }
    function onExit() {
      animationStep.current = 1;
      var node = nodeRef.current;
      node.className += " " + exitClassName;
      node.addEventListener("animationend", onExited);
    }
    function onExited() {
      var node = nodeRef.current;
      node.removeEventListener("animationend", onExited);
      collapse ? collapseToast(node, done, collapseDuration) : done();
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  };
}
var eventManager = {
  list: /* @__PURE__ */ new Map(),
  emitQueue: /* @__PURE__ */ new Map(),
  on: function on(event, callback) {
    this.list.has(event) || this.list.set(event, []);
    this.list.get(event).push(callback);
    return this;
  },
  off: function off(event, callback) {
    if (callback) {
      var cb = this.list.get(event).filter(function(cb2) {
        return cb2 !== callback;
      });
      this.list.set(event, cb);
      return this;
    }
    this.list["delete"](event);
    return this;
  },
  cancelEmit: function cancelEmit(event) {
    var timers = this.emitQueue.get(event);
    if (timers) {
      timers.forEach(clearTimeout);
      this.emitQueue["delete"](event);
    }
    return this;
  },
  /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */
  emit: function emit(event) {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    this.list.has(event) && this.list.get(event).forEach(function(callback) {
      var timer = setTimeout(function() {
        callback.apply(void 0, args);
      }, 0);
      _this.emitQueue.has(event) || _this.emitQueue.set(event, []);
      _this.emitQueue.get(event).push(timer);
    });
  }
};
var _excluded = ["delay", "staleId"];
function useToastContainer(props) {
  var _useReducer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(function(x) {
    return x + 1;
  }, 0), forceUpdate = _useReducer[1];
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), toastIds = _useState[0], setToastIds = _useState[1];
  var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var toastToRender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(/* @__PURE__ */ new Map()).current;
  var isToastActive = function isToastActive2(id) {
    return toastIds.indexOf(id) !== -1;
  };
  var instance = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    toastKey: 1,
    displayedToast: 0,
    count: 0,
    queue: [],
    props,
    containerId: null,
    isToastActive,
    getToast: function getToast2(id) {
      return toastToRender.get(id);
    }
  }).current;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
    instance.containerId = props.containerId;
    eventManager.cancelEmit(
      3
      /* WillUnmount */
    ).on(
      0,
      buildToast
    ).on(
      1,
      function(toastId) {
        return containerRef.current && removeToast(toastId);
      }
    ).on(
      5,
      clearWaitingQueue
    ).emit(
      2,
      instance
    );
    return function() {
      return eventManager.emit(
        3,
        instance
      );
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
    instance.isToastActive = isToastActive;
    instance.displayedToast = toastIds.length;
    eventManager.emit(
      4,
      toastIds.length,
      props.containerId
    );
  }, [toastIds]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
    instance.props = props;
  });
  function clearWaitingQueue(_ref) {
    var containerId = _ref.containerId;
    var limit = instance.props.limit;
    if (limit && (!containerId || instance.containerId === containerId)) {
      instance.count -= instance.queue.length;
      instance.queue = [];
    }
  }
  function removeToast(toastId) {
    setToastIds(function(state) {
      return isToastIdValid(toastId) ? state.filter(function(id) {
        return id !== toastId;
      }) : [];
    });
  }
  function dequeueToast() {
    var _instance$queue$shift = instance.queue.shift(), toastContent = _instance$queue$shift.toastContent, toastProps = _instance$queue$shift.toastProps, staleId = _instance$queue$shift.staleId;
    appendToast(toastContent, toastProps, staleId);
  }
  function isNotValid(options) {
    return !containerRef.current || instance.props.enableMultiContainer && options.containerId !== instance.props.containerId || toastToRender.has(options.toastId) && options.updateId == null;
  }
  function buildToast(content, _ref2) {
    var delay = _ref2.delay, staleId = _ref2.staleId, options = _objectWithoutPropertiesLoose(_ref2, _excluded);
    if (!canBeRendered(content) || isNotValid(options)) return;
    var toastId = options.toastId, updateId = options.updateId, data = options.data;
    var props2 = instance.props;
    var closeToast = function closeToast2() {
      return removeToast(toastId);
    };
    var isNotAnUpdate = updateId == null;
    if (isNotAnUpdate) instance.count++;
    var toastProps = {
      toastId,
      updateId,
      isLoading: options.isLoading,
      theme: options.theme || props2.theme,
      icon: options.icon != null ? options.icon : props2.icon,
      isIn: false,
      key: options.key || instance.toastKey++,
      type: options.type,
      closeToast,
      closeButton: options.closeButton,
      rtl: props2.rtl,
      position: options.position || props2.position,
      transition: options.transition || props2.transition,
      className: parseClassName(options.className || props2.toastClassName),
      bodyClassName: parseClassName(options.bodyClassName || props2.bodyClassName),
      style: options.style || props2.toastStyle,
      bodyStyle: options.bodyStyle || props2.bodyStyle,
      onClick: options.onClick || props2.onClick,
      pauseOnHover: isBool(options.pauseOnHover) ? options.pauseOnHover : props2.pauseOnHover,
      pauseOnFocusLoss: isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props2.pauseOnFocusLoss,
      draggable: isBool(options.draggable) ? options.draggable : props2.draggable,
      draggablePercent: options.draggablePercent || props2.draggablePercent,
      draggableDirection: options.draggableDirection || props2.draggableDirection,
      closeOnClick: isBool(options.closeOnClick) ? options.closeOnClick : props2.closeOnClick,
      progressClassName: parseClassName(options.progressClassName || props2.progressClassName),
      progressStyle: options.progressStyle || props2.progressStyle,
      autoClose: options.isLoading ? false : getAutoCloseDelay(options.autoClose, props2.autoClose),
      hideProgressBar: isBool(options.hideProgressBar) ? options.hideProgressBar : props2.hideProgressBar,
      progress: options.progress,
      role: options.role || props2.role,
      deleteToast: function deleteToast() {
        toastToRender["delete"](toastId);
        var queueLen = instance.queue.length;
        instance.count = isToastIdValid(toastId) ? instance.count - 1 : instance.count - instance.displayedToast;
        if (instance.count < 0) instance.count = 0;
        if (queueLen > 0) {
          var freeSlot = isToastIdValid(toastId) ? 1 : instance.props.limit;
          if (queueLen === 1 || freeSlot === 1) {
            instance.displayedToast++;
            dequeueToast();
          } else {
            var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
            instance.displayedToast = toDequeue;
            for (var i = 0; i < toDequeue; i++) {
              dequeueToast();
            }
          }
        } else {
          forceUpdate();
        }
      }
    };
    if (isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
    if (isFn(options.onClose)) toastProps.onClose = options.onClose;
    toastProps.closeButton = props2.closeButton;
    if (options.closeButton === false || canBeRendered(options.closeButton)) {
      toastProps.closeButton = options.closeButton;
    } else if (options.closeButton === true) {
      toastProps.closeButton = canBeRendered(props2.closeButton) ? props2.closeButton : true;
    }
    var toastContent = content;
    if ((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(content) && !isStr(content.type)) {
      toastContent = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(content, {
        closeToast,
        toastProps,
        data
      });
    } else if (isFn(content)) {
      toastContent = content({
        closeToast,
        toastProps,
        data
      });
    }
    if (props2.limit && props2.limit > 0 && instance.count > props2.limit && isNotAnUpdate) {
      instance.queue.push({
        toastContent,
        toastProps,
        staleId
      });
    } else if (isNum(delay) && delay > 0) {
      setTimeout(function() {
        appendToast(toastContent, toastProps, staleId);
      }, delay);
    } else {
      appendToast(toastContent, toastProps, staleId);
    }
  }
  function appendToast(content, toastProps, staleId) {
    var toastId = toastProps.toastId;
    if (staleId) toastToRender["delete"](staleId);
    toastToRender.set(toastId, {
      content,
      props: toastProps
    });
    setToastIds(function(state) {
      return [].concat(state, [toastId]).filter(function(id) {
        return id !== staleId;
      });
    });
  }
  function getToastToRender(cb) {
    var toRender = /* @__PURE__ */ new Map();
    var collection = Array.from(toastToRender.values());
    if (props.newestOnTop) collection.reverse();
    collection.forEach(function(toast2) {
      var position = toast2.props.position;
      toRender.has(position) || toRender.set(position, []);
      toRender.get(position).push(toast2);
    });
    return Array.from(toRender, function(p) {
      return cb(p[0], p[1]);
    });
  }
  return {
    getToastToRender,
    containerRef,
    isToastActive
  };
}
function getX(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}
function getY(e) {
  return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}
function useToast(props) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isRunning = _useState[0], setIsRunning = _useState[1];
  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), preventExitTransition = _useState2[0], setPreventExitTransition = _useState2[1];
  var toastRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var drag = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
    start: 0,
    x: 0,
    y: 0,
    delta: 0,
    removalDistance: 0,
    canCloseOnClick: true,
    canDrag: false,
    boundingRect: null,
    didMove: false
  }).current;
  var syncProps = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(props);
  var autoClose = props.autoClose, pauseOnHover = props.pauseOnHover, closeToast = props.closeToast, onClick = props.onClick, closeOnClick = props.closeOnClick;
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
    syncProps.current = props;
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
    if (toastRef.current) toastRef.current.addEventListener(
      "d",
      playToast,
      {
        once: true
      }
    );
    if (isFn(props.onOpen)) props.onOpen((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(props.children) && props.children.props);
    return function() {
      var props2 = syncProps.current;
      if (isFn(props2.onClose)) props2.onClose((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(props2.children) && props2.children.props);
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
    props.pauseOnFocusLoss && bindFocusEvents();
    return function() {
      props.pauseOnFocusLoss && unbindFocusEvents();
    };
  }, [props.pauseOnFocusLoss]);
  function onDragStart(e) {
    if (props.draggable) {
      bindDragEvents();
      var toast2 = toastRef.current;
      drag.canCloseOnClick = true;
      drag.canDrag = true;
      drag.boundingRect = toast2.getBoundingClientRect();
      toast2.style.transition = "";
      drag.x = getX(e.nativeEvent);
      drag.y = getY(e.nativeEvent);
      if (props.draggableDirection === "x") {
        drag.start = drag.x;
        drag.removalDistance = toast2.offsetWidth * (props.draggablePercent / 100);
      } else {
        drag.start = drag.y;
        drag.removalDistance = toast2.offsetHeight * (props.draggablePercent === 80 ? props.draggablePercent * 1.5 : props.draggablePercent / 100);
      }
    }
  }
  function onDragTransitionEnd() {
    if (drag.boundingRect) {
      var _drag$boundingRect = drag.boundingRect, top = _drag$boundingRect.top, bottom = _drag$boundingRect.bottom, left = _drag$boundingRect.left, right = _drag$boundingRect.right;
      if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) {
        pauseToast();
      } else {
        playToast();
      }
    }
  }
  function playToast() {
    setIsRunning(true);
  }
  function pauseToast() {
    setIsRunning(false);
  }
  function bindFocusEvents() {
    if (!document.hasFocus()) pauseToast();
    window.addEventListener("focus", playToast);
    window.addEventListener("blur", pauseToast);
  }
  function unbindFocusEvents() {
    window.removeEventListener("focus", playToast);
    window.removeEventListener("blur", pauseToast);
  }
  function bindDragEvents() {
    drag.didMove = false;
    document.addEventListener("mousemove", onDragMove);
    document.addEventListener("mouseup", onDragEnd);
    document.addEventListener("touchmove", onDragMove);
    document.addEventListener("touchend", onDragEnd);
  }
  function unbindDragEvents() {
    document.removeEventListener("mousemove", onDragMove);
    document.removeEventListener("mouseup", onDragEnd);
    document.removeEventListener("touchmove", onDragMove);
    document.removeEventListener("touchend", onDragEnd);
  }
  function onDragMove(e) {
    var toast2 = toastRef.current;
    if (drag.canDrag && toast2) {
      drag.didMove = true;
      if (isRunning) pauseToast();
      drag.x = getX(e);
      drag.y = getY(e);
      if (props.draggableDirection === "x") {
        drag.delta = drag.x - drag.start;
      } else {
        drag.delta = drag.y - drag.start;
      }
      if (drag.start !== drag.x) drag.canCloseOnClick = false;
      toast2.style.transform = "translate" + props.draggableDirection + "(" + drag.delta + "px)";
      toast2.style.opacity = "" + (1 - Math.abs(drag.delta / drag.removalDistance));
    }
  }
  function onDragEnd() {
    unbindDragEvents();
    var toast2 = toastRef.current;
    if (drag.canDrag && drag.didMove && toast2) {
      drag.canDrag = false;
      if (Math.abs(drag.delta) > drag.removalDistance) {
        setPreventExitTransition(true);
        props.closeToast();
        return;
      }
      toast2.style.transition = "transform 0.2s, opacity 0.2s";
      toast2.style.transform = "translate" + props.draggableDirection + "(0)";
      toast2.style.opacity = "1";
    }
  }
  var eventHandlers = {
    onMouseDown: onDragStart,
    onTouchStart: onDragStart,
    onMouseUp: onDragTransitionEnd,
    onTouchEnd: onDragTransitionEnd
  };
  if (autoClose && pauseOnHover) {
    eventHandlers.onMouseEnter = pauseToast;
    eventHandlers.onMouseLeave = playToast;
  }
  if (closeOnClick) {
    eventHandlers.onClick = function(e) {
      onClick && onClick(e);
      drag.canCloseOnClick && closeToast();
    };
  }
  return {
    playToast,
    pauseToast,
    isRunning,
    preventExitTransition,
    toastRef,
    eventHandlers
  };
}
function CloseButton(_ref) {
  var closeToast = _ref.closeToast, theme = _ref.theme, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? "close" : _ref$ariaLabel;
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("button", {
    className: "Toastify__close-button Toastify__close-button--" + theme,
    type: "button",
    onClick: function onClick(e) {
      e.stopPropagation();
      closeToast(e);
    },
    "aria-label": ariaLabel
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", {
    "aria-hidden": "true",
    viewBox: "0 0 14 16"
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    fillRule: "evenodd",
    d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
  })));
}
function ProgressBar(_ref) {
  var _cx, _animationEvent;
  var delay = _ref.delay, isRunning = _ref.isRunning, closeToast = _ref.closeToast, type = _ref.type, hide = _ref.hide, className = _ref.className, userStyle = _ref.style, controlledProgress = _ref.controlledProgress, progress = _ref.progress, rtl = _ref.rtl, isIn = _ref.isIn, theme = _ref.theme;
  var style = _extends({}, userStyle, {
    animationDuration: delay + "ms",
    animationPlayState: isRunning ? "running" : "paused",
    opacity: hide ? 0 : 1
  });
  if (controlledProgress) style.transform = "scaleX(" + progress + ")";
  var defaultClassName = (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify__progress-bar", controlledProgress ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", "Toastify__progress-bar-theme--" + theme, "Toastify__progress-bar--" + type, (_cx = {}, _cx["Toastify__progress-bar--rtl"] = rtl, _cx));
  var classNames = isFn(className) ? className({
    rtl,
    type,
    defaultClassName
  }) : (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])(defaultClassName, className);
  var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? "onTransitionEnd" : "onAnimationEnd"] = controlledProgress && progress < 1 ? null : function() {
    isIn && closeToast();
  }, _animationEvent);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", Object.assign({
    role: "progressbar",
    "aria-hidden": hide ? "true" : "false",
    "aria-label": "notification timer",
    className: classNames,
    style
  }, animationEvent));
}
ProgressBar.defaultProps = {
  type: TYPE.DEFAULT,
  hide: false
};
var _excluded$1 = ["theme", "type"];
var Svg = function Svg2(_ref) {
  var theme = _ref.theme, type = _ref.type, rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("svg", Object.assign({
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    fill: theme === "colored" ? "currentColor" : "var(--toastify-icon-color-" + type + ")"
  }, rest));
};
function Warning(props) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Svg, Object.assign({}, props), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z"
  }));
}
function Info(props) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Svg, Object.assign({}, props), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z"
  }));
}
function Success(props) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Svg, Object.assign({}, props), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z"
  }));
}
function Error(props) {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Svg, Object.assign({}, props), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("path", {
    d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z"
  }));
}
function Spinner() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", {
    className: "Toastify__spinner"
  });
}
var Icons = {
  info: Info,
  warning: Warning,
  success: Success,
  error: Error,
  spinner: Spinner
};
var Toast = function Toast2(props) {
  var _cx, _cx2;
  var _useToast = useToast(props), isRunning = _useToast.isRunning, preventExitTransition = _useToast.preventExitTransition, toastRef = _useToast.toastRef, eventHandlers = _useToast.eventHandlers;
  var closeButton = props.closeButton, children = props.children, autoClose = props.autoClose, onClick = props.onClick, type = props.type, hideProgressBar = props.hideProgressBar, closeToast = props.closeToast, Transition = props.transition, position = props.position, className = props.className, style = props.style, bodyClassName = props.bodyClassName, bodyStyle = props.bodyStyle, progressClassName = props.progressClassName, progressStyle = props.progressStyle, updateId = props.updateId, role = props.role, progress = props.progress, rtl = props.rtl, toastId = props.toastId, deleteToast = props.deleteToast, isIn = props.isIn, isLoading = props.isLoading, icon = props.icon, theme = props.theme;
  var defaultClassName = (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify__toast", "Toastify__toast-theme--" + theme, "Toastify__toast--" + type, (_cx = {}, _cx["Toastify__toast--rtl"] = rtl, _cx));
  var cssClasses = isFn(className) ? className({
    rtl,
    position,
    type,
    defaultClassName
  }) : (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])(defaultClassName, className);
  var isProgressControlled = !!progress;
  var maybeIcon = Icons[type];
  var iconProps = {
    theme,
    type
  };
  var Icon = maybeIcon && maybeIcon(iconProps);
  if (icon === false) {
    Icon = void 0;
  } else if (isFn(icon)) {
    Icon = icon(iconProps);
  } else if ((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(icon)) {
    Icon = (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(icon, iconProps);
  } else if (isStr(icon)) {
    Icon = icon;
  } else if (isLoading) {
    Icon = Icons.spinner();
  }
  function renderCloseButton(closeButton2) {
    if (!closeButton2) return;
    var props2 = {
      closeToast,
      type,
      theme
    };
    if (isFn(closeButton2)) return closeButton2(props2);
    if ((0,react__WEBPACK_IMPORTED_MODULE_0__.isValidElement)(closeButton2)) return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(closeButton2, props2);
  }
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Transition, {
    isIn,
    done: deleteToast,
    position,
    preventExitTransition,
    nodeRef: toastRef
  }, (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", Object.assign({
    id: toastId,
    onClick,
    className: cssClasses
  }, eventHandlers, {
    style,
    ref: toastRef
  }), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", Object.assign({}, isIn && {
    role
  }, {
    className: isFn(bodyClassName) ? bodyClassName({
      type
    }) : (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify__toast-body", bodyClassName),
    style: bodyStyle
  }), Icon && (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", {
    className: (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify__toast-icon", (_cx2 = {}, _cx2["Toastify--animate-icon Toastify__zoom-enter"] = !isLoading, _cx2))
  }, Icon), (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", null, children)), renderCloseButton(closeButton), (autoClose || isProgressControlled) && (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ProgressBar, Object.assign({}, updateId && !isProgressControlled ? {
    key: "pb-" + updateId
  } : {}, {
    rtl,
    theme,
    delay: autoClose,
    isRunning,
    isIn,
    closeToast,
    hide: hideProgressBar,
    type,
    style: progressStyle,
    className: progressClassName,
    controlledProgress: isProgressControlled,
    progress
  }))));
};
var Bounce = /* @__PURE__ */ cssTransition({
  enter: "Toastify--animate Toastify__bounce-enter",
  exit: "Toastify--animate Toastify__bounce-exit",
  appendPosition: true
});
var Slide = /* @__PURE__ */ cssTransition({
  enter: "Toastify--animate Toastify__slide-enter",
  exit: "Toastify--animate Toastify__slide-exit",
  appendPosition: true
});
var Zoom = /* @__PURE__ */ cssTransition({
  enter: "Toastify--animate Toastify__zoom-enter",
  exit: "Toastify--animate Toastify__zoom-exit"
});
var Flip = /* @__PURE__ */ cssTransition({
  enter: "Toastify--animate Toastify__flip-enter",
  exit: "Toastify--animate Toastify__flip-exit"
});
var ToastContainer = function ToastContainer2(props) {
  var _useToastContainer = useToastContainer(props), getToastToRender = _useToastContainer.getToastToRender, containerRef = _useToastContainer.containerRef, isToastActive = _useToastContainer.isToastActive;
  var className = props.className, style = props.style, rtl = props.rtl, containerId = props.containerId;
  function getClassName(position) {
    var _cx;
    var defaultClassName = (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])("Toastify__toast-container", "Toastify__toast-container--" + position, (_cx = {}, _cx["Toastify__toast-container--rtl"] = rtl, _cx));
    return isFn(className) ? className({
      position,
      rtl,
      defaultClassName
    }) : (0,clsx__WEBPACK_IMPORTED_MODULE_1__["default"])(defaultClassName, parseClassName(className));
  }
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", {
    ref: containerRef,
    className: "Toastify",
    id: containerId
  }, getToastToRender(function(position, toastList) {
    var containerStyle = !toastList.length ? _extends({}, style, {
      pointerEvents: "none"
    }) : _extends({}, style);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)("div", {
      className: getClassName(position),
      style: containerStyle,
      key: "container-" + position
    }, toastList.map(function(_ref) {
      var content = _ref.content, toastProps = _ref.props;
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(Toast, Object.assign({}, toastProps, {
        isIn: isToastActive(toastProps.toastId),
        key: "toast-" + toastProps.key,
        closeButton: toastProps.closeButton === true ? CloseButton : toastProps.closeButton
      }), content);
    }));
  }));
};
ToastContainer.defaultProps = {
  position: POSITION.TOP_RIGHT,
  transition: Bounce,
  rtl: false,
  autoClose: 5e3,
  hideProgressBar: false,
  closeButton: CloseButton,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  closeOnClick: true,
  newestOnTop: false,
  draggable: true,
  draggablePercent: 80,
  draggableDirection: "x",
  role: "alert",
  theme: "light"
};
var containers = /* @__PURE__ */ new Map();
var latestInstance;
var containerDomNode;
var containerConfig;
var queue = [];
var lazy = false;
function getToast(toastId, _ref) {
  var containerId = _ref.containerId;
  var container = containers.get(containerId || latestInstance);
  if (!container) return null;
  return container.getToast(toastId);
}
function generateToastId() {
  return Math.random().toString(36).substring(2, 9);
}
function getToastId(options) {
  if (options && (isStr(options.toastId) || isNum(options.toastId))) {
    return options.toastId;
  }
  return generateToastId();
}
function dispatchToast(content, options) {
  if (containers.size > 0) {
    eventManager.emit(
      0,
      content,
      options
    );
  } else {
    queue.push({
      content,
      options
    });
    if (lazy && canUseDom) {
      lazy = false;
      containerDomNode = document.createElement("div");
      document.body.appendChild(containerDomNode);
      (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.render)((0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(ToastContainer, Object.assign({}, containerConfig)), containerDomNode);
    }
  }
  return options.toastId;
}
function mergeOptions(type, options) {
  return _extends({}, options, {
    type: options && options.type || type,
    toastId: getToastId(options)
  });
}
function createToastByType(type) {
  return function(content, options) {
    return dispatchToast(content, mergeOptions(type, options));
  };
}
function toast(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, options));
}
toast.loading = function(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, _extends({
    isLoading: true,
    autoClose: false,
    closeOnClick: false,
    closeButton: false,
    draggable: false
  }, options)));
};
function handlePromise(promise, _ref2, options) {
  var pending = _ref2.pending, error = _ref2.error, success = _ref2.success;
  var id;
  if (pending) {
    id = isStr(pending) ? toast.loading(pending, options) : toast.loading(pending.render, _extends({}, options, pending));
  }
  var resetParams = {
    isLoading: null,
    autoClose: null,
    closeOnClick: null,
    closeButton: null,
    draggable: null
  };
  var resolver = function resolver2(type, input, result) {
    if (input == null) {
      toast.dismiss(id);
      return;
    }
    var baseParams = _extends({
      type
    }, resetParams, options, {
      data: result
    });
    var params = isStr(input) ? {
      render: input
    } : input;
    if (id) {
      toast.update(id, _extends({}, baseParams, params));
    } else {
      toast(params.render, _extends({}, baseParams, params));
    }
    return result;
  };
  var p = isFn(promise) ? promise() : promise;
  p.then(function(result) {
    return resolver("success", success, result);
  })["catch"](function(err) {
    return resolver("error", error, err);
  });
  return p;
}
toast.promise = handlePromise;
toast.success = /* @__PURE__ */ createToastByType(TYPE.SUCCESS);
toast.info = /* @__PURE__ */ createToastByType(TYPE.INFO);
toast.error = /* @__PURE__ */ createToastByType(TYPE.ERROR);
toast.warning = /* @__PURE__ */ createToastByType(TYPE.WARNING);
toast.warn = toast.warning;
toast.dark = function(content, options) {
  return dispatchToast(content, mergeOptions(TYPE.DEFAULT, _extends({
    theme: "dark"
  }, options)));
};
toast.dismiss = function(id) {
  return eventManager.emit(
    1,
    id
  );
};
toast.clearWaitingQueue = function(params) {
  if (params === void 0) {
    params = {};
  }
  return eventManager.emit(
    5,
    params
  );
};
toast.isActive = function(id) {
  var isToastActive = false;
  containers.forEach(function(container) {
    if (container.isToastActive && container.isToastActive(id)) {
      isToastActive = true;
    }
  });
  return isToastActive;
};
toast.update = function(toastId, options) {
  if (options === void 0) {
    options = {};
  }
  setTimeout(function() {
    var toast2 = getToast(toastId, options);
    if (toast2) {
      var oldOptions = toast2.props, oldContent = toast2.content;
      var nextOptions = _extends({}, oldOptions, options, {
        toastId: options.toastId || toastId,
        updateId: generateToastId()
      });
      if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
      var content = nextOptions.render || oldContent;
      delete nextOptions.render;
      dispatchToast(content, nextOptions);
    }
  }, 0);
};
toast.done = function(id) {
  toast.update(id, {
    progress: 1
  });
};
toast.onChange = function(callback) {
  if (isFn(callback)) {
    eventManager.on(
      4,
      callback
    );
  }
  return function() {
    isFn(callback) && eventManager.off(
      4,
      callback
    );
  };
};
toast.configure = function(config) {
  if (config === void 0) {
    config = {};
  }
  lazy = true;
  containerConfig = config;
};
toast.POSITION = POSITION;
toast.TYPE = TYPE;
eventManager.on(
  2,
  function(containerInstance) {
    latestInstance = containerInstance.containerId || containerInstance;
    containers.set(latestInstance, containerInstance);
    queue.forEach(function(item) {
      eventManager.emit(
        0,
        item.content,
        item.options
      );
    });
    queue = [];
  }
).on(
  3,
  function(containerInstance) {
    containers["delete"](containerInstance.containerId || containerInstance);
    if (containers.size === 0) {
      eventManager.off(
        0
        /* Show */
      ).off(
        1
        /* Clear */
      ).off(
        5
        /* ClearWaitingQueue */
      );
    }
    if (canUseDom && containerDomNode) {
      document.body.removeChild(containerDomNode);
    }
  }
);



/***/ }),

/***/ 73370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  CompareRuntimeHost: function() { return /* reexport */ CompareRuntimeHost; },
  CpuBitmapCompare: function() { return /* reexport */ CpuBitmapCompare; },
  GPU_COMPARE_MAX_PIXELS: function() { return /* reexport */ GPU_COMPARE_MAX_PIXELS; },
  GpuCompare: function() { return /* reexport */ GpuCompare; },
  MupdfRuntimeUrls: function() { return /* reexport */ MupdfRuntimeUrls; },
  MupdfWorkerHost: function() { return /* reexport */ MupdfWorkerHost; },
  WebGpuCompare: function() { return /* reexport */ WebGpuCompare; },
  checkAssetIsValid: function() { return /* reexport */ checkAssetIsValid; },
  compareData: function() { return /* reexport */ compareData; },
  compareIndirect: function() { return /* reexport */ compareIndirect; },
  computeIntersectionRect: function() { return /* reexport */ computeIntersectionRect; },
  configureSharedPdfRuntime: function() { return /* reexport */ configureSharedPdfRuntime; },
  createBitmapCompare: function() { return /* reexport */ createBitmapCompare; },
  createCompareEngine: function() { return /* reexport */ createCompareEngine; },
  createMupdfRuntimeUrls: function() { return /* reexport */ createMupdfRuntimeUrls; },
  getImageURL: function() { return /* reexport */ getImageURL; },
  getSharedPdfRuntimeConfig: function() { return /* reexport */ getSharedPdfRuntimeConfig; },
  mergePdfRuntimeConfig: function() { return /* reexport */ mergePdfRuntimeConfig; },
  prepareData: function() { return /* reexport */ prepareData; },
  terminateCompareRuntime: function() { return /* reexport */ terminateCompareRuntime; },
  validateCompareFrame: function() { return /* reexport */ validateCompareFrame; }
});

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/utils/mupdfLibUrls.js
const DEFAULT_WORKER_VERSION = "2.0.0";
const DEFAULT_ASSETS_ROUTE = "assets/";
const DEFAULT_MUPDF_SCRIPT_FILE = "mupdf.js";
const DEFAULT_WASM_FILE = "mupdf-wasm.wasm";
const RUNTIME_CONFIG_REQUIRED_ERROR = "[PDF Runtime] runtimeConfig.baseUrl is required when shared runtime config is not configured";
const normalizeBaseUrl = (value) => {
  if (!value) {
    return value;
  }
  return value.endsWith("/") ? value : `${value}/`;
};
const normalizeRoute = (value) => {
  if (!value) {
    return value;
  }
  const route = value.startsWith("/") ? value.slice(1) : value;
  return route.endsWith("/") ? route : `${route}/`;
};
const normalizePdfRuntimeConfig = (config = {}) => ({
  ...config,
  baseUrl: config.baseUrl !== void 0 ? normalizeBaseUrl(config.baseUrl) : void 0,
  assetsBaseUrl: config.assetsBaseUrl !== void 0 ? normalizeBaseUrl(config.assetsBaseUrl) : void 0,
  assetsRoute: config.assetsRoute !== void 0 ? normalizeRoute(config.assetsRoute) : void 0
});
const mergePdfRuntimeConfig = (base = {}, override = {}) => normalizePdfRuntimeConfig({
  ...base,
  ...override
});
const hasExplicitRuntimeLocation = (config = {}) => !!(config.baseUrl || config.assetsBaseUrl || config.workerUrl || config.compareWorkerUrl || config.mupdfScriptUrl || config.wasmUrl);
class MupdfRuntimeUrls {
  constructor(config = {}) {
    this._config = normalizePdfRuntimeConfig(config);
  }
  get config() {
    return { ...this._config };
  }
  configure(config = {}) {
    this._config = mergePdfRuntimeConfig(this._config, config);
  }
  get assetsBaseUrl() {
    const baseUrl = this._config.baseUrl || this._config.assetsBaseUrl;
    if (!baseUrl) {
      throw new Error(RUNTIME_CONFIG_REQUIRED_ERROR);
    }
    return normalizeBaseUrl(baseUrl);
  }
  get workerFileName() {
    return this._config.workerFileName || `mupdf.worker-${this._config.workerVersion || DEFAULT_WORKER_VERSION}.js`;
  }
  get rootWorkerModule() {
    if (this._config.workerUrl) {
      return this._config.workerUrl;
    }
    return new URL(this.workerFileName, this.assetsBaseUrl).toString();
  }
  get compareWorkerFileName() {
    return this._config.compareWorkerFileName || `compare.worker-${this._config.workerVersion || DEFAULT_WORKER_VERSION}.js`;
  }
  get compareWorkerModule() {
    if (this._config.compareWorkerUrl) {
      return this._config.compareWorkerUrl;
    }
    return new URL(this.compareWorkerFileName, this.assetsBaseUrl).toString();
  }
  get base() {
    return new URL(this._config.assetsRoute || DEFAULT_ASSETS_ROUTE, this.assetsBaseUrl).toString();
  }
  get module() {
    if (this._config.mupdfScriptUrl) {
      return this._config.mupdfScriptUrl;
    }
    return new URL(this._config.mupdfScriptFileName || DEFAULT_MUPDF_SCRIPT_FILE, this.base).toString();
  }
  get wasm() {
    if (this._config.wasmUrl) {
      return this._config.wasmUrl;
    }
    return new URL(this._config.wasmFileName || DEFAULT_WASM_FILE, this.base).toString();
  }
}
const toPdfRuntimeConfig = (config = {}) => config instanceof MupdfRuntimeUrls ? config.config : config;
let sharedBaseConfig = null;
const configureSharedPdfRuntime = (config = {}) => {
  const nextConfig = mergePdfRuntimeConfig(sharedBaseConfig || {}, toPdfRuntimeConfig(config));
  if (!hasExplicitRuntimeLocation(nextConfig)) {
    throw new Error(RUNTIME_CONFIG_REQUIRED_ERROR);
  }
  sharedBaseConfig = nextConfig;
};
const getSharedPdfRuntimeConfig = () => sharedBaseConfig ? {
  ...sharedBaseConfig
} : null;
const createMupdfRuntimeUrls = (config = {}) => {
  const normalizedConfig = normalizePdfRuntimeConfig(toPdfRuntimeConfig(config));
  if (!sharedBaseConfig && !hasExplicitRuntimeLocation(normalizedConfig)) {
    throw new Error(RUNTIME_CONFIG_REQUIRED_ERROR);
  }
  if (sharedBaseConfig && normalizedConfig.preferShared) {
    return new MupdfRuntimeUrls(sharedBaseConfig);
  }
  return new MupdfRuntimeUrls(sharedBaseConfig ? mergePdfRuntimeConfig(sharedBaseConfig, normalizedConfig) : normalizedConfig);
};
const stringifyError = (error) => error instanceof Error ? error.message : String(error);
const fetchAssetProbe = async (url) => {
  try {
    const head = await fetch(url, {
      method: "HEAD",
      cache: "no-store"
    });
    if (head.ok || head.status !== 405) {
      return head;
    }
  } catch (error) {
    console.debug("[PDF Runtime] HEAD asset probe failed, fallback to GET", url, error);
  }
  return fetch(url, {
    method: "GET",
    cache: "no-store",
    headers: {
      Range: "bytes=0-0"
    }
  });
};
const checkResolvedUrl = (name, url) => {
  try {
    return {
      name,
      url: new URL(url).toString(),
      ok: true
    };
  } catch (error) {
    return {
      name,
      url,
      ok: false,
      error: stringifyError(error)
    };
  }
};
const checkAssetRequest = async (name, url, strict) => {
  const item = checkResolvedUrl(name, url);
  if (!item.ok) {
    return item;
  }
  try {
    const response = await fetchAssetProbe(item.url);
    const contentType = response.headers.get("content-type");
    const wasmMimeIsValid = name !== "wasm" || !strict || !!contentType?.includes("application/wasm");
    return {
      ...item,
      ok: response.ok && wasmMimeIsValid,
      status: response.status,
      contentType,
      error: response.ok ? wasmMimeIsValid ? void 0 : `Invalid wasm MIME type: ${contentType || "empty"}` : `Unexpected response status: ${response.status}`
    };
  } catch (error) {
    return {
      ...item,
      ok: false,
      error: stringifyError(error)
    };
  }
};
const checkAssetIsValid = async (config = {}, strict = false) => {
  const urls = config instanceof MupdfRuntimeUrls ? config : createMupdfRuntimeUrls(config);
  const targets = strict ? [
    ["mupdf-worker", urls.rootWorkerModule],
    ["compare-worker", urls.compareWorkerModule],
    ["module", urls.module],
    ["wasm", urls.wasm]
  ] : [["wasm", urls.wasm]];
  const items = await Promise.all(targets.map(([name, url]) => checkAssetRequest(name, url, strict)));
  const errors = items.filter((item) => !item.ok).map((item) => `${item.name} (${item.url}): ${item.error || "invalid asset"}`);
  const result = {
    ok: errors.length === 0,
    strict,
    urls: {
      worker: urls.rootWorkerModule,
      module: urls.module,
      wasm: urls.wasm
    },
    items,
    errors
  };
  if (strict && !result.ok) {
    throw new Error(`[PDF Runtime] Asset validation failed: ${errors.join("; ")}`);
  }
  return result;
};

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/utils/simpleVerifedStorage.js
class SimpleVerifedStorage {
  constructor(storageKey, storageVersion = 1, storageLivetime = -1) {
    this.storageKey = storageKey;
    this.storageVersion = storageVersion;
    this.storageLivetime = storageLivetime;
  }
  read(validateLivetime = true) {
    try {
      const data = JSON.parse(self.localStorage.getItem(this.storageKey) || "{}");
      if (data.version !== this.storageVersion) {
        this.write(null);
        return null;
      }
      if (validateLivetime && data.validUntil && data.validUntil < Date.now()) {
        this.write(null);
        return null;
      }
      return data.data;
    } catch {
      return null;
    }
  }
  write(data, livetime = this.storageLivetime) {
    try {
      if (data == null) {
        self.localStorage.removeItem(this.storageKey);
        return;
      }
      self.localStorage.setItem(this.storageKey, JSON.stringify({
        data,
        version: this.storageVersion,
        validUntil: livetime && livetime > 0 ? Date.now() + livetime : void 0
      }));
    } catch (e) {
    }
  }
}

;// ./node_modules/comlink/dist/esm/comlink.mjs
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
const proxyMarker = Symbol("Comlink.proxy");
const createEndpoint = Symbol("Comlink.endpoint");
const releaseProxy = Symbol("Comlink.releaseProxy");
const finalizer = Symbol("Comlink.finalizer");
const throwMarker = Symbol("Comlink.thrown");
const isObject = (val) => (typeof val === "object" && val !== null) || typeof val === "function";
/**
 * Internal transfer handle to handle objects marked to proxy.
 */
const proxyTransferHandler = {
    canHandle: (val) => isObject(val) && val[proxyMarker],
    serialize(obj) {
        const { port1, port2 } = new MessageChannel();
        expose(obj, port1);
        return [port2, [port2]];
    },
    deserialize(port) {
        port.start();
        return wrap(port);
    },
};
/**
 * Internal transfer handler to handle thrown exceptions.
 */
const throwTransferHandler = {
    canHandle: (value) => isObject(value) && throwMarker in value,
    serialize({ value }) {
        let serialized;
        if (value instanceof Error) {
            serialized = {
                isError: true,
                value: {
                    message: value.message,
                    name: value.name,
                    stack: value.stack,
                },
            };
        }
        else {
            serialized = { isError: false, value };
        }
        return [serialized, []];
    },
    deserialize(serialized) {
        if (serialized.isError) {
            throw Object.assign(new Error(serialized.value.message), serialized.value);
        }
        throw serialized.value;
    },
};
/**
 * Allows customizing the serialization of certain values.
 */
const transferHandlers = new Map([
    ["proxy", proxyTransferHandler],
    ["throw", throwTransferHandler],
]);
function isAllowedOrigin(allowedOrigins, origin) {
    for (const allowedOrigin of allowedOrigins) {
        if (origin === allowedOrigin || allowedOrigin === "*") {
            return true;
        }
        if (allowedOrigin instanceof RegExp && allowedOrigin.test(origin)) {
            return true;
        }
    }
    return false;
}
function expose(obj, ep = globalThis, allowedOrigins = ["*"]) {
    ep.addEventListener("message", function callback(ev) {
        if (!ev || !ev.data) {
            return;
        }
        if (!isAllowedOrigin(allowedOrigins, ev.origin)) {
            console.warn(`Invalid origin '${ev.origin}' for comlink proxy`);
            return;
        }
        const { id, type, path } = Object.assign({ path: [] }, ev.data);
        const argumentList = (ev.data.argumentList || []).map(fromWireValue);
        let returnValue;
        try {
            const parent = path.slice(0, -1).reduce((obj, prop) => obj[prop], obj);
            const rawValue = path.reduce((obj, prop) => obj[prop], obj);
            switch (type) {
                case "GET" /* MessageType.GET */:
                    {
                        returnValue = rawValue;
                    }
                    break;
                case "SET" /* MessageType.SET */:
                    {
                        parent[path.slice(-1)[0]] = fromWireValue(ev.data.value);
                        returnValue = true;
                    }
                    break;
                case "APPLY" /* MessageType.APPLY */:
                    {
                        returnValue = rawValue.apply(parent, argumentList);
                    }
                    break;
                case "CONSTRUCT" /* MessageType.CONSTRUCT */:
                    {
                        const value = new rawValue(...argumentList);
                        returnValue = proxy(value);
                    }
                    break;
                case "ENDPOINT" /* MessageType.ENDPOINT */:
                    {
                        const { port1, port2 } = new MessageChannel();
                        expose(obj, port2);
                        returnValue = transfer(port1, [port1]);
                    }
                    break;
                case "RELEASE" /* MessageType.RELEASE */:
                    {
                        returnValue = undefined;
                    }
                    break;
                default:
                    return;
            }
        }
        catch (value) {
            returnValue = { value, [throwMarker]: 0 };
        }
        Promise.resolve(returnValue)
            .catch((value) => {
            return { value, [throwMarker]: 0 };
        })
            .then((returnValue) => {
            const [wireValue, transferables] = toWireValue(returnValue);
            ep.postMessage(Object.assign(Object.assign({}, wireValue), { id }), transferables);
            if (type === "RELEASE" /* MessageType.RELEASE */) {
                // detach and deactive after sending release response above.
                ep.removeEventListener("message", callback);
                closeEndPoint(ep);
                if (finalizer in obj && typeof obj[finalizer] === "function") {
                    obj[finalizer]();
                }
            }
        })
            .catch((error) => {
            // Send Serialization Error To Caller
            const [wireValue, transferables] = toWireValue({
                value: new TypeError("Unserializable return value"),
                [throwMarker]: 0,
            });
            ep.postMessage(Object.assign(Object.assign({}, wireValue), { id }), transferables);
        });
    });
    if (ep.start) {
        ep.start();
    }
}
function isMessagePort(endpoint) {
    return endpoint.constructor.name === "MessagePort";
}
function closeEndPoint(endpoint) {
    if (isMessagePort(endpoint))
        endpoint.close();
}
function wrap(ep, target) {
    const pendingListeners = new Map();
    ep.addEventListener("message", function handleMessage(ev) {
        const { data } = ev;
        if (!data || !data.id) {
            return;
        }
        const resolver = pendingListeners.get(data.id);
        if (!resolver) {
            return;
        }
        try {
            resolver(data);
        }
        finally {
            pendingListeners.delete(data.id);
        }
    });
    return createProxy(ep, pendingListeners, [], target);
}
function throwIfProxyReleased(isReleased) {
    if (isReleased) {
        throw new Error("Proxy has been released and is not useable");
    }
}
function releaseEndpoint(ep) {
    return requestResponseMessage(ep, new Map(), {
        type: "RELEASE" /* MessageType.RELEASE */,
    }).then(() => {
        closeEndPoint(ep);
    });
}
const proxyCounter = new WeakMap();
const proxyFinalizers = "FinalizationRegistry" in globalThis &&
    new FinalizationRegistry((ep) => {
        const newCount = (proxyCounter.get(ep) || 0) - 1;
        proxyCounter.set(ep, newCount);
        if (newCount === 0) {
            releaseEndpoint(ep);
        }
    });
function registerProxy(proxy, ep) {
    const newCount = (proxyCounter.get(ep) || 0) + 1;
    proxyCounter.set(ep, newCount);
    if (proxyFinalizers) {
        proxyFinalizers.register(proxy, ep, proxy);
    }
}
function unregisterProxy(proxy) {
    if (proxyFinalizers) {
        proxyFinalizers.unregister(proxy);
    }
}
function createProxy(ep, pendingListeners, path = [], target = function () { }) {
    let isProxyReleased = false;
    const proxy = new Proxy(target, {
        get(_target, prop) {
            throwIfProxyReleased(isProxyReleased);
            if (prop === releaseProxy) {
                return () => {
                    unregisterProxy(proxy);
                    releaseEndpoint(ep);
                    pendingListeners.clear();
                    isProxyReleased = true;
                };
            }
            if (prop === "then") {
                if (path.length === 0) {
                    return { then: () => proxy };
                }
                const r = requestResponseMessage(ep, pendingListeners, {
                    type: "GET" /* MessageType.GET */,
                    path: path.map((p) => p.toString()),
                }).then(fromWireValue);
                return r.then.bind(r);
            }
            return createProxy(ep, pendingListeners, [...path, prop]);
        },
        set(_target, prop, rawValue) {
            throwIfProxyReleased(isProxyReleased);
            // FIXME: ES6 Proxy Handler `set` methods are supposed to return a
            // boolean. To show good will, we return true asynchronously ¯\_(ツ)_/¯
            const [value, transferables] = toWireValue(rawValue);
            return requestResponseMessage(ep, pendingListeners, {
                type: "SET" /* MessageType.SET */,
                path: [...path, prop].map((p) => p.toString()),
                value,
            }, transferables).then(fromWireValue);
        },
        apply(_target, _thisArg, rawArgumentList) {
            throwIfProxyReleased(isProxyReleased);
            const last = path[path.length - 1];
            if (last === createEndpoint) {
                return requestResponseMessage(ep, pendingListeners, {
                    type: "ENDPOINT" /* MessageType.ENDPOINT */,
                }).then(fromWireValue);
            }
            // We just pretend that `bind()` didn’t happen.
            if (last === "bind") {
                return createProxy(ep, pendingListeners, path.slice(0, -1));
            }
            const [argumentList, transferables] = processArguments(rawArgumentList);
            return requestResponseMessage(ep, pendingListeners, {
                type: "APPLY" /* MessageType.APPLY */,
                path: path.map((p) => p.toString()),
                argumentList,
            }, transferables).then(fromWireValue);
        },
        construct(_target, rawArgumentList) {
            throwIfProxyReleased(isProxyReleased);
            const [argumentList, transferables] = processArguments(rawArgumentList);
            return requestResponseMessage(ep, pendingListeners, {
                type: "CONSTRUCT" /* MessageType.CONSTRUCT */,
                path: path.map((p) => p.toString()),
                argumentList,
            }, transferables).then(fromWireValue);
        },
    });
    registerProxy(proxy, ep);
    return proxy;
}
function myFlat(arr) {
    return Array.prototype.concat.apply([], arr);
}
function processArguments(argumentList) {
    const processed = argumentList.map(toWireValue);
    return [processed.map((v) => v[0]), myFlat(processed.map((v) => v[1]))];
}
const transferCache = new WeakMap();
function transfer(obj, transfers) {
    transferCache.set(obj, transfers);
    return obj;
}
function proxy(obj) {
    return Object.assign(obj, { [proxyMarker]: true });
}
function windowEndpoint(w, context = globalThis, targetOrigin = "*") {
    return {
        postMessage: (msg, transferables) => w.postMessage(msg, targetOrigin, transferables),
        addEventListener: context.addEventListener.bind(context),
        removeEventListener: context.removeEventListener.bind(context),
    };
}
function toWireValue(value) {
    for (const [name, handler] of transferHandlers) {
        if (handler.canHandle(value)) {
            const [serializedValue, transferables] = handler.serialize(value);
            return [
                {
                    type: "HANDLER" /* WireValueType.HANDLER */,
                    name,
                    value: serializedValue,
                },
                transferables,
            ];
        }
    }
    return [
        {
            type: "RAW" /* WireValueType.RAW */,
            value,
        },
        transferCache.get(value) || [],
    ];
}
function fromWireValue(value) {
    switch (value.type) {
        case "HANDLER" /* WireValueType.HANDLER */:
            return transferHandlers.get(value.name).deserialize(value.value);
        case "RAW" /* WireValueType.RAW */:
            return value.value;
    }
}
function requestResponseMessage(ep, pendingListeners, msg, transfers) {
    return new Promise((resolve) => {
        const id = generateUUID();
        pendingListeners.set(id, resolve);
        if (ep.start) {
            ep.start();
        }
        ep.postMessage(Object.assign({ id }, msg), transfers);
    });
}
function generateUUID() {
    return new Array(4)
        .fill(0)
        .map(() => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(16))
        .join("-");
}


//# sourceMappingURL=comlink.mjs.map

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/utils/corsWorker.js
const prefetchedWorkerBlob = {};
const getLocationOrigin = () => {
  if (typeof location === "undefined") {
    throw new Error("[Cors worker] Can't resolve worker URL without location");
  }
  return location.origin;
};
const resolveWorkerUrl = (source) => {
  try {
    return new URL(source).toString();
  } catch {
  }
  if (source.startsWith("/")) {
    return new URL(source, getLocationOrigin()).toString();
  }
  throw new Error("[Cors worker] Worker URL must be absolute or root-relative");
};
const WORKER_LOADER = (workerFullUrl) => {
  return `
	const urlString = ${JSON.stringify(workerFullUrl)};
	const originURL = new URL(urlString);
	const isValidUrl = (value) => {
		try { return Boolean(new URL(value, originURL)); } catch(e) { return false; }
	};
	const originalImportScripts = self.importScripts;
	self.importScripts = (url) => {
		if (url.startsWith("blob:") && isValidUrl(url.replace("blob:", ""))) {
			const urlWithoutBlob = url.replace("blob:", "");
			const { pathname } = new URL(urlWithoutBlob, originURL);
			url = pathname && pathname.substring(1);
		}

		const newUrl = new URL(url, originURL).toString();
		console.debug("[Cors worker] remap module url:" + originURL + "=>" + newUrl);
		originalImportScripts.call(self, newUrl);
	};
	importScripts(urlString);
	// worker loader body used for bypassing runtime CORS isolation for workers
	`;
};
const queryWorkerUrl = async (source, crossSite = false) => {
  if (!crossSite)
    return source;
  const workerFullUrl = resolveWorkerUrl(source);
  if (prefetchedWorkerBlob[workerFullUrl])
    return prefetchedWorkerBlob[workerFullUrl];
  const blob = new Blob([WORKER_LOADER(workerFullUrl)], { type: "application/javascript" });
  prefetchedWorkerBlob[workerFullUrl] = URL.createObjectURL(blob);
  return prefetchedWorkerBlob[workerFullUrl];
};
const constructWorker = async (source, name = "", crossSite = false) => {
  const url = await queryWorkerUrl(source, crossSite);
  return new Worker(url, {
    name
  });
};

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/utils/queryPrecompiledModule.js
const precompiledMupdfModule = {};
const queryPrecompiledModule = async (url) => {
  if (url in precompiledMupdfModule) {
    return precompiledMupdfModule[url];
  }
  const blob = await fetch(url);
  try {
    precompiledMupdfModule[url] = await WebAssembly.compileStreaming(blob);
  } catch {
    console.warn("[queryPrecompiledModule] Wasm straming compile error, fallback to sync compile");
    const b = await blob.arrayBuffer();
    precompiledMupdfModule[url] = await WebAssembly.compile(b);
  }
  return precompiledMupdfModule[url];
};

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/internal/MupdfWorkerProxy.js


const PDF_USE_PRECOMPILE = true;
class MupdfWorkerProxy {
  constructor(context) {
    this.context = context;
    this._worker = null;
    this._proxy = null;
    this._startPromise = null;
    this._version = 0;
    this._disposed = false;
    this._sharableData = {
      offscreenSupport: null,
      disableOffscreen: false,
      forceOcr: false,
      keepTextLine: true
    };
    this.start = async () => {
      this._assertAlive("start");
      if (this._proxy) {
        return;
      }
      if (this._startPromise) {
        return this._startPromise;
      }
      const ver = this._version;
      this._startPromise = this._startUnsafe(ver).finally(() => {
        if (this._version === ver) {
          this._startPromise = null;
        }
      });
      return this._startPromise;
    };
    this._startUnsafe = async (tVersion) => {
      this._assertAlive("start");
      const cached = this.sharedStorage.read(true);
      if (cached?.offscreenData) {
        this._sharableData.offscreenSupport = cached.offscreenData;
        console.debug("[MupdfWorkerProxy]::start recover pdf settings", cached);
      }
      const runtimeUrls = this.context.runtimeUrls;
      console.debug("[MupdfWorkerProxy]::start module path", {
        assetsBaseUrl: runtimeUrls.assetsBaseUrl,
        worker: runtimeUrls.rootWorkerModule,
        module: "file:///opt/react_client/node_modules/@sarex-team/srx-pdf-runtime/dist/internal/MupdfWorkerProxy.js"
      });
      if (runtimeUrls.config.strictAssetValidation) {
        await checkAssetIsValid(runtimeUrls, true);
      }
      this._worker = await constructWorker(runtimeUrls.rootWorkerModule, "mupdf-worker", true);
      this._assertSameVersion("start:create-worker", tVersion);
      this._proxy = wrap(this._worker);
      if (true) {
        try {
          this._sharableData.precompilledModule = await queryPrecompiledModule(runtimeUrls.wasm);
        } catch (error) {
          console.warn("[MupdfWorkerProxy]::start precompiled module unavailable", error);
        }
      }
      this._assertSameVersion("start:precompile", tVersion);
      const sharable = await this._proxy.init(runtimeUrls.module, runtimeUrls.base, this._sharableData);
      this._assertSameVersion("start:init", tVersion);
      if (sharable) {
        if (sharable.offscreenSupport && !this._sharableData.offscreenSupport) {
          this.sharedStorage.write({
            offscreenData: sharable.offscreenSupport
          });
        }
        this._sharableData = sharable;
      }
      console.debug("[MupdfWorkerProxy]::start worker ready");
    };
    this.kill = (reason = "manual kill") => {
      if (this._disposed) {
        return;
      }
      console.warn("[MupdfWorkerProxy]::kill", reason);
      this._version++;
      this._proxy?.[releaseProxy]();
      this._worker?.terminate();
      this._worker = null;
      this._proxy = null;
      this._startPromise = null;
    };
    this.dispose = () => {
      if (this._disposed) {
        return;
      }
      this.kill("dispose");
      this._disposed = true;
    };
    this.loadDocument = async (arrayBuffer, storageKey) => {
      const proxy = this._assertProxy("loadDocument");
      const epoch = this._version;
      const result = await proxy.loadDocument(arrayBuffer, storageKey);
      this._assertSameVersion("loadDocument", epoch);
      return result;
    };
    this.getDocumentDescriptor = async () => {
      const proxy = this._assertProxy("getDocumentDescriptor");
      const epoch = this._version;
      const result = await proxy.getDocumentDescriptor();
      this._assertSameVersion("getDocumentDescriptor", epoch);
      return result;
    };
    this.getPageBounds = async (pageIndex) => {
      const proxy = this._assertProxy("getPageBounds");
      const epoch = this._version;
      const result = await proxy.getPageBounds(pageIndex);
      this._assertSameVersion("getPageBounds", epoch);
      return result;
    };
    this.getPageMetadata = async (pageIndex) => {
      const proxy = this._assertProxy("getPageMetadata");
      const epoch = this._version;
      const result = await proxy.getPageMetadata(pageIndex);
      this._assertSameVersion("getPageMetadata", epoch);
      return result;
    };
    this.getTextTree = async (pageIndex) => {
      const proxy = this._assertProxy("getTextTree");
      const epoch = this._version;
      const result = await proxy.getTextTree(pageIndex);
      this._assertSameVersion("getTextTree", epoch);
      return result;
    };
    this.renderAsBlobURL = async (pageIndex, scale) => {
      const proxy = this._assertProxy("renderAsBlobURL");
      const epoch = this._version;
      const result = await proxy.renderAsBlobURL(pageIndex, scale);
      this._assertSameVersion("renderAsBlobURL", epoch);
      return result;
    };
    this.renderPageAsImageData = async (pageIndex, scale) => {
      const proxy = this._assertProxy("renderPageAsImageData");
      const epoch = this._version;
      const result = await proxy.renderPageAsImageData(pageIndex, scale);
      this._assertSameVersion("renderPageAsImageData", epoch);
      return result;
    };
    this.renderAsImageBitmap = async (pageIndex, scale, rect) => {
      const proxy = this._assertProxy("renderAsImageBitmap");
      const epoch = this._version;
      const result = await proxy.renderAsImageBitmap(pageIndex, scale, rect);
      this._assertSameVersion("renderAsImageBitmap", epoch);
      return result;
    };
    this.renderAsImageBitmapResult = async (options) => {
      const proxy = this._assertProxy("renderAsImageBitmapResult");
      const epoch = this._version;
      const result = await proxy.renderAsImageBitmapResult(options);
      this._assertSameVersion("renderAsImageBitmapResult", epoch);
      return result;
    };
    this.dumpLastImageData = async () => {
      const proxy = this._assertProxy("dumpLastImageData");
      const epoch = this._version;
      const result = await proxy.dumpLastImageData();
      this._assertSameVersion("dumpLastImageData", epoch);
      return result;
    };
  }
  get sharedStorage() {
    return this.context.sharedStorage;
  }
  get version() {
    return this._version;
  }
  get isStarted() {
    return !!this._proxy;
  }
  get isDisposed() {
    return this._disposed;
  }
  get isOffscreenSupport() {
    return !!this._sharableData.offscreenSupport?.isSupport;
  }
  _assertAlive(method) {
    if (this._disposed) {
      throw new Error(`[MupdfWorkerProxy]::${method}, proxy disposed`);
    }
  }
  _assertProxy(method) {
    this._assertAlive(method);
    if (!this._proxy) {
      throw new Error(`[MupdfWorkerProxy]::${method}, worker not started`);
    }
    return this._proxy;
  }
  _assertSameVersion(method, epoch) {
    this._assertAlive(method);
    if (this._version !== epoch) {
      throw new Error(`[MupdfWorkerProxy]::${method}, worker version changed`);
    }
  }
}

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/PageProxy.js
class PageProxy {
  constructor(context, pageIndex, source, meta) {
    this.context = context;
    this.pageIndex = pageIndex;
    this.source = source;
    this.meta = meta;
  }
  get isDetached() {
    return !this.context.isValidProxy(this);
  }
  get key() {
    return this.source.key;
  }
  get bounds() {
    return this.meta.bbox;
  }
  renderIndirect(scaleOrOptions, ratio, target) {
    if (this.isDetached) {
      throw new Error("Try use unbound page");
    }
    if (typeof scaleOrOptions === "object") {
      return this.context.renderPageIndirect({
        ...scaleOrOptions,
        pageIndex: this.pageIndex
      });
    }
    return this.context.renderPageIndirect({
      pageIndex: this.pageIndex,
      scale: scaleOrOptions,
      pixelRatio: ratio,
      canvas: target
    });
  }
  async renderImageBitmap(options) {
    if (this.isDetached) {
      throw new Error("Try use unbound page");
    }
    const w = this.bounds[2] - this.bounds[0];
    const h = this.bounds[3] - this.bounds[1];
    return this.context.renderImageBitmap({
      ...options,
      pageIndex: this.pageIndex,
      rect: options.rect || {
        x: 0,
        y: 0,
        width: w,
        height: h
      }
    });
  }
  getTextTree() {
    if (this.isDetached) {
      throw new Error("Try use unbound page");
    }
    return this.context.getPageTree(this.pageIndex);
  }
}

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/MupdfWorkerHost.js



const PDF_STORAGE_KEY = "__pdf__sharable__";
const PDF_STORAGE_VERSION = 1;
const PDF_STORAGE_LIVETIME = 3600 * 24 * 1e3;
const MAX_PENDING_TIME = 2e3;
class MupdfWorkerHost {
  static checkAssetIsValid(config = {}, strict = false) {
    return checkAssetIsValid(mergePdfRuntimeConfig(getSharedPdfRuntimeConfig() || {}, config), strict);
  }
  constructor({ worker, sourceQuery, runtimeConfig }) {
    this.sharedStorage = new SimpleVerifedStorage(PDF_STORAGE_KEY, PDF_STORAGE_VERSION, PDF_STORAGE_LIVETIME);
    this.currentPage = 0;
    this._docIsLoaded = false;
    this._isTaskDone = true;
    this._pageQueryApi = null;
    this._activeBoundSource = null;
    this._boundPageProxy = null;
    this._boundsCache = /* @__PURE__ */ new Map();
    this._taskTail = Promise.resolve();
    this._pendingTasks = 0;
    this._assertDoc = (method) => {
      if (!this._docIsLoaded) {
        throw new Error(`[MupdfWorkerHost]::${method}, Document not loaded`);
      }
    };
    this.start = async () => {
      return this.worker.start();
    };
    this.restart = async (force = false) => {
      if (force) {
        this.worker.kill("forced restart");
        this._taskTail = Promise.resolve();
        this._activeBoundSource = null;
        this._docIsLoaded = false;
        this._boundsCache.clear();
      }
      await this.worker.start();
    };
    this.terminate = () => {
      this.worker.dispose();
      this._docIsLoaded = false;
      this._activeBoundSource = null;
      this._pageQueryApi = null;
      this._boundsCache.clear();
    };
    this._loadDocument = async (arrayBuffer, storageKey) => {
      this._docIsLoaded = false;
      this._boundsCache.clear();
      const res = await this._guardTask(this.worker.loadDocument(arrayBuffer, storageKey));
      if (!res) {
        throw new Error("[MupdfWorkerHost] No renderer accepted the document");
      }
      this._docIsLoaded = true;
      return res;
    };
    this.renderPageAsBlobURL = (pageIndex, scale, pixelRatio) => this._enqueueTask(async () => {
      await this._loadSource(pageIndex);
      this._assertDoc("renderPageAsBlobURL");
      this.currentPage = pageIndex;
      return this._guardTask(this.worker.renderAsBlobURL(this._resolverRealPage(pageIndex), scale * pixelRatio));
    });
    this.renderPageAsImageData = async (pageIndex, scale, pixelRatio) => {
      throw new Error("Depricated, use ImageBitmap instead");
    };
    this.renderImageBitmap = (options) => this._enqueueTask(async () => {
      await this._loadSource(options.pageIndex);
      this._assertDoc("renderPageAsImageBitmap");
      this.currentPage = options.pageIndex;
      const scale = (options.scale ?? 1) * (options.pixelRatio ?? 1);
      const result = await this._guardTask(this.worker.renderAsImageBitmapResult({
        ...options,
        page: this._resolverRealPage(options.pageIndex),
        scale,
        rect: options.rect
      }));
      try {
        const imageData = options.capture === "imageData" ? await this._dumpLastImageData() ?? void 0 : void 0;
        if (options.capture === "imageData" && !imageData) {
          throw new Error("[MupdfWorkerHost] Requested render snapshot is unavailable");
        }
        return {
          imageBitmap: result.imageBitmap,
          imageData,
          id: options.id,
          rect: result.rect,
          frame: result.frame,
          scale: result.scale,
          reducedScale: result.reducedScale
        };
      } catch (error) {
        result.imageBitmap.close();
        throw error;
      }
    });
    this.renderPageAsImageBitmap = (pageIndex, scale, pixelRatio, rect) => this._enqueueTask(async () => {
      await this._loadSource(pageIndex);
      this._assertDoc("renderPageAsImageBitmap");
      this.currentPage = pageIndex;
      return this._guardTask(this.worker.renderAsImageBitmap(this._resolverRealPage(pageIndex), scale * pixelRatio, rect));
    });
    this._createRenderIndirectResult = async (pageIndex, width, height, scale, pixelRatio, options, renderInfo) => {
      const bounds = await this._getPageBounds(pageIndex);
      const pageWidth = (bounds[2] || 0) - (bounds[0] || 0);
      const pageHeight = (bounds[3] || 0) - (bounds[1] || 0);
      const frame = options?.rect ? {
        x: options.rect.x * scale,
        y: options.rect.y * scale,
        width: options.rect.width * scale,
        height: options.rect.height * scale
      } : {
        x: 0,
        y: 0,
        width: pageWidth * scale,
        height: pageHeight * scale
      };
      return {
        id: options?.id,
        width,
        height,
        scale: renderInfo?.scale ?? (pageWidth ? width / pageWidth : 0),
        pixelRatio,
        reducedScale: renderInfo?.reducedScale,
        rect: renderInfo?.rect ?? options?.rect,
        frame: renderInfo?.frame ?? frame
      };
    };
    this._renderPageIndirect_ImageData = async (pageIndex, scale, pixelRatio, options) => {
      console.warn("[MupdfWorkerHost]::renderPageIndirect, OffscreenCanvas not suported, compose in main thread without tiling");
      const data = await this.renderPageAsImageData(pageIndex, scale, pixelRatio);
      const canvas = options?.canvas;
      if (canvas) {
        if (canvas.height > data.height) {
          canvas.height = data.height;
        }
        if (canvas.width !== data.width) {
          canvas.width = data.width;
        }
        if (canvas.height !== data.height) {
          canvas.height = data.height;
        }
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          throw new Error("[MupdfWorkerHost]::renderPageIndirect_ImageData, can't allocate 2d context of canvas");
        }
        ctx?.putImageData(data, 0, 0);
      }
      return {
        ...await this._createRenderIndirectResult(pageIndex, data.width, data.height, scale, pixelRatio, options),
        imageData: options?.capture === "imageData" ? data : void 0
      };
    };
    this._renderPageIndirect_ImageBitmap = async (pageIndex, scale, pixelRatio, options) => {
      await this._loadSource(pageIndex);
      this._assertDoc("renderPageIndirect");
      if (!this.isOffscreenSupport) {
        throw new Error("[MupdfWorkerHost]::renderPageIndirect, Can't use indirect ImageBitmap target on this device. OffscreenCanvas not supported");
      }
      this.currentPage = pageIndex;
      const data = await this._guardTask(this.worker.renderAsImageBitmapResult({
        page: this._resolverRealPage(pageIndex),
        scale: scale * pixelRatio,
        rect: options?.rect,
        quality: options?.quality,
        customAALevel: options?.customAALevel,
        minLineWidth: options?.minLineWidth,
        capture: options?.capture,
        keepLods: options?.keepLods,
        blendLods: options?.blendLods
      }));
      const canvas = options?.canvas;
      console.debug("[MupdfWorkerHost]::renderPageIndirect, use ImageBitmap");
      const { width, height } = data;
      let imageData;
      if (canvas) {
        const ctx = canvas.getContext("2d");
        if (!ctx) {
          throw new Error("[MupdfWorkerHost]::renderPageIndirect Can't allocate canvas context");
        }
        if (canvas.height > height) {
          canvas.height = height;
        }
        if (canvas.width !== width) {
          canvas.width = width;
        }
        if (canvas.height !== height) {
          canvas.height = height;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(data.imageBitmap, 0, 0, width, height);
        if (options?.capture === "imageData") {
          imageData = await this._dumpLastImageData() ?? void 0;
        }
        if (options?.capture !== "imageBitmap") {
          data.imageBitmap.close();
        }
      } else if (options?.capture !== "imageBitmap") {
        data.imageBitmap.close();
      }
      return {
        ...await this._createRenderIndirectResult(pageIndex, width, height, scale, pixelRatio, options, {
          rect: data.rect,
          frame: data.frame,
          scale: data.scale,
          reducedScale: data.reducedScale
        }),
        imageBitmap: options?.capture === "imageBitmap" ? data.imageBitmap : void 0,
        imageData: options?.capture === "imageData" ? imageData ?? await this._dumpLastImageData() ?? void 0 : void 0
      };
    };
    this.renderPageIndirect = (opt, scale, pixelRatio, target) => this._enqueueTask(async () => {
      const renderArgs = typeof opt === "object" && "pageIndex" in opt ? opt : {
        pageIndex: opt,
        scale,
        pixelRatio,
        canvas: target
      };
      const pageIndex = renderArgs.pageIndex;
      const renderScale = renderArgs.scale;
      const renderPixelRatio = renderArgs.pixelRatio ?? 1;
      const renderOptions = renderArgs;
      await this._loadSource(pageIndex);
      this._assertDoc("renderPageIndirect");
      return this._renderPageIndirect_ImageBitmap(pageIndex, renderScale, renderPixelRatio, renderOptions);
    });
    this.dumpLastImageData = () => this._enqueueTask(() => this._dumpLastImageData());
    this._dumpLastImageData = async () => {
      this._assertDoc("dumpLastImageData");
      return this._guardTask(this.worker.dumpLastImageData());
    };
    this.getDocumentDescriptor = (pageIndex = 0) => this._enqueueTask(async () => {
      await this._loadSource(pageIndex);
      this._assertDoc("getDocumentDescriptor");
      const source = this._activeBoundSource;
      if (!source) {
        throw new Error("[MupdfWorkerHost] getDocumentDescriptor: Source unbound");
      }
      const descriptor = await this._guardTask(this.worker.getDocumentDescriptor());
      if (!this._docIsLoaded || this._activeBoundSource !== source || source.runtimeVersion !== this.worker.version) {
        throw new Error("[MupdfWorkerHost] getDocumentDescriptor: Source changed");
      }
      return { sourceKey: source.sourceKey, pages: descriptor.pages };
    });
    this.getPageBounds = (pageIndex) => this._enqueueTask(() => this._getPageBounds(pageIndex));
    this._getPageBounds = async (pageIndex) => {
      await this._loadSource(pageIndex);
      const realPage = this._resolverRealPage(pageIndex);
      const cacheKey = this._getBoundsCacheKey(pageIndex, realPage);
      const cachedBounds = this._boundsCache.get(cacheKey);
      if (cachedBounds) {
        return [...cachedBounds];
      }
      const bounds = await this._guardTask(this.worker.getPageBounds(realPage));
      this._boundsCache.set(cacheKey, [...bounds]);
      return bounds;
    };
    this.getPageMetadata = (pageIndex) => this._enqueueTask(async () => {
      await this._loadSource(pageIndex);
      this._assertDoc("getPageMetadata");
      return this._guardTask(this.worker.getPageMetadata(this._resolverRealPage(pageIndex)));
    });
    this.getPageTree = (pageIndex, options) => this._enqueueTask(async () => {
      await this._loadSource(pageIndex);
      this._assertDoc("getPageTree");
      return this._guardTask(this.worker.getTextTree(this._resolverRealPage(pageIndex), options));
    });
    this.getPagePreview = async (pageIndex) => {
      const q = this._pageQueryApi;
      if (!q) {
        throw new Error("[MupdfWorkerHost] source query is not bound");
      }
      return q.getPagePreview(pageIndex);
    };
    this.getPageProxy = (pageIndex) => this._enqueueTask(async () => {
      await this._loadSource(pageIndex);
      this._assertDoc("getPageProxy");
      const source = this._activeBoundSource;
      const meta = await this._guardTask(this.worker.getPageMetadata(this._resolverRealPage(pageIndex)));
      if (this.isValidProxy(this._boundPageProxy)) {
        return this._boundPageProxy;
      }
      this._boundPageProxy = new PageProxy(this, pageIndex, source, meta);
      return this._boundPageProxy;
    });
    const shared = getSharedPdfRuntimeConfig();
    if (!runtimeConfig && !shared) {
      throw new Error("[MupdfWorkerHost] runtimeConfig must be passed if no default config set");
    }
    if (!runtimeConfig) {
      runtimeConfig = shared;
      console.debug("[MupdfWorkerHost] runtimeConfig ommit, use default", runtimeConfig);
    }
    this.runtimeUrls = createMupdfRuntimeUrls(runtimeConfig);
    this.worker = worker || new MupdfWorkerProxy(this);
    this.setSourceQuery(sourceQuery);
  }
  getConfig() {
    return this.runtimeUrls.config;
  }
  setConfig(config = {}) {
    this.runtimeUrls.configure(config);
  }
  checkAssetIsValid(strict = false) {
    return checkAssetIsValid(this.runtimeUrls, strict);
  }
  setSourceQuery(q) {
    console.debug("[MupdfWorkerHost]::setSourceQuery interface bind to:", q);
    this._pageQueryApi = q;
    this._activeBoundSource = null;
    this._docIsLoaded = false;
    this._boundsCache.clear();
  }
  getSourceQuery() {
    return this._pageQueryApi;
  }
  _resolverRealPage(relPage) {
    if (!this._pageQueryApi) {
      return relPage;
    }
    if (!this._activeBoundSource) {
      throw new Error("[MupdfWorkerHost] Can't localte page index because source unbound!");
    }
    return this._activeBoundSource.localIndex;
  }
  async _loadSource(pageNumber) {
    if (!this._pageQueryApi)
      return;
    const oldSource = this._activeBoundSource;
    const source = this._pageQueryApi.getPageSource(pageNumber);
    if (!source || !source.key || !source.sourceKey) {
      throw new Error("[MupdfWorkerHost] Source must resolved with valid source/key!");
    }
    const sourceDataIsAlive = this._docIsLoaded && oldSource && oldSource.runtimeVersion === this.worker.version && oldSource.sourceKey === source.sourceKey;
    const pageDataIsAlive = sourceDataIsAlive && oldSource.key === source.key;
    if (pageDataIsAlive) {
      return;
    }
    const nextSource = {
      key: source.key,
      sourceKey: source.sourceKey,
      localIndex: source.localIndex,
      runtimeVersion: this.worker.version
    };
    if (sourceDataIsAlive) {
      this._activeBoundSource = nextSource;
      return;
    }
    this._activeBoundSource = null;
    this._docIsLoaded = false;
    const sourceData = await source.getSource();
    if (!(sourceData instanceof ArrayBuffer)) {
      throw new Error("[MupdfWorkerHost] Only array buffer source is supported now!");
    }
    console.debug("[MupdfWorkerHost]::_loadSource start Load source", source.sourceKey);
    await this._loadDocument(sourceData, source.sourceKey);
    this._activeBoundSource = nextSource;
  }
  _guardTask(promise) {
    const start = performance.now();
    this._isTaskDone = false;
    return promise.finally(() => {
      const end = performance.now();
      const delta = end - start;
      if (delta > MAX_PENDING_TIME) {
        console.warn(`[MupdfWorkerHost], Task dispath take ${(delta / 1e3).toFixed(1)} seconds for work. Performance degradataion!`);
      }
      this._isTaskDone = true;
    });
  }
  _enqueueTask(task) {
    const sourceQuery = this._pageQueryApi;
    const version = this.worker.version;
    this._pendingTasks++;
    const result = this._taskTail.then(() => {
      if (this.worker.isDisposed || this.worker.version !== version || this._pageQueryApi !== sourceQuery) {
        throw new Error("[MupdfWorkerHost] Queued task invalidated by source/runtime change");
      }
      return task();
    }).finally(() => {
      this._pendingTasks--;
    });
    this._taskTail = result.catch(() => void 0);
    return result;
  }
  get isTasksDone() {
    return this._isTaskDone && this._pendingTasks === 0;
  }
  get isOffscreenSupport() {
    return !!this.worker.isOffscreenSupport;
  }
  isValidProxy(proxy) {
    return !!this._activeBoundSource && this._activeBoundSource.key === proxy?.key;
  }
  _getBoundsCacheKey(requestPage, realPage) {
    const source = this._activeBoundSource;
    if (!source) {
      return `direct:${this.worker.version}:${requestPage}:${realPage}`;
    }
    return `${source.runtimeVersion}:${source.sourceKey}:${source.localIndex}`;
  }
}

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/comparison/fastFrameCopy.js
function fastFrameCopy(image, res, sx = 0, sy = 0) {
  const src = image.data;
  const srcWidth = image.width;
  const srcHeight = image.height;
  const tw = res.width;
  const th = res.height;
  const target = res.data;
  const sourceStride = srcWidth * 4;
  const targetStride = tw * 4;
  const copyX = Math.max(0, Math.floor(sx));
  const copyY = Math.max(0, Math.floor(sy));
  const copyW = Math.min(tw, Math.max(0, srcWidth - copyX));
  const copyH = Math.min(th, Math.max(0, srcHeight - copyY));
  if (copyW <= 0 || copyH <= 0) {
    return res;
  }
  const copyRowBytes = copyW * 4;
  const srcOffsetBytes = (copyY * srcWidth + copyX) * 4;
  if (sx === 0 && targetStride === sourceStride) {
    target.set(src.subarray(srcOffsetBytes, srcOffsetBytes + copyH * sourceStride));
  } else {
    for (let i = 0; i < copyH; i++) {
      const start = srcOffsetBytes + i * sourceStride;
      target.set(src.subarray(start, start + copyRowBytes), i * targetStride);
    }
  }
  return res;
}

;// ./node_modules/pixelmatch/index.js
function pixelmatch(img1, img2, output, width, height, options = {}) {
  const {
    threshold = 0.1,
    alpha = 0.1,
    aaColor = [255, 255, 0],
    diffColor = [255, 0, 0],
    checkerboard = true,
    includeAA,
    diffColorAlt,
    diffMask
  } = options;
  if (!isPixelData(img1) || !isPixelData(img2) || output && !isPixelData(output))
    throw new Error("Image data: Uint8Array, Uint8ClampedArray or Buffer expected.");
  if (img1.length !== img2.length || output && output.length !== img1.length)
    throw new Error(`Image sizes do not match. Image 1 size: ${img1.length}, image 2 size: ${img2.length}`);
  if (img1.length !== width * height * 4) throw new Error(`Image data size does not match width/height. Expecting ${width * height * 4}. Got ${img1.length}`);
  const len = width * height;
  const a32 = new Uint32Array(img1.buffer, img1.byteOffset, len);
  const b32 = new Uint32Array(img2.buffer, img2.byteOffset, len);
  let identical = true;
  for (let i = 0; i < len; i++) {
    if (a32[i] !== b32[i]) {
      identical = false;
      break;
    }
  }
  if (identical) {
    if (output && !diffMask) {
      for (let i = 0, pos = 0; i < len; i++, pos += 4) drawGrayPixel(img1, pos, alpha, output);
    }
    return 0;
  }
  const maxDelta = 35215 * threshold * threshold;
  const [aaR, aaG, aaB] = aaColor;
  const [diffR, diffG, diffB] = diffColor;
  const [altR, altG, altB] = diffColorAlt || diffColor;
  let diff = 0;
  for (let i = 0, pos = 0; i < len; i++, pos += 4) {
    const delta = a32[i] === b32[i] ? 0 : colorDelta(img1, img2, pos, pos, checkerboard);
    if (Math.abs(delta) > maxDelta) {
      const x = i % width;
      const y = i / width | 0;
      const isExcludedAA = !includeAA && (antialiased(img1, x, y, width, height, a32, b32, checkerboard) || antialiased(img2, x, y, width, height, b32, a32, checkerboard));
      if (isExcludedAA) {
        if (output && !diffMask) drawPixel(output, pos, aaR, aaG, aaB);
      } else {
        if (output) {
          if (delta < 0) {
            drawPixel(output, pos, altR, altG, altB);
          } else {
            drawPixel(output, pos, diffR, diffG, diffB);
          }
        }
        diff++;
      }
    } else if (output && !diffMask) {
      drawGrayPixel(img1, pos, alpha, output);
    }
  }
  return diff;
}
function isPixelData(arr) {
  return ArrayBuffer.isView(arr) && arr.BYTES_PER_ELEMENT === 1;
}
function antialiased(img, x1, y1, width, height, a32, b32, checkerboard) {
  const x0 = Math.max(x1 - 1, 0);
  const y0 = Math.max(y1 - 1, 0);
  const x2 = Math.min(x1 + 1, width - 1);
  const y2 = Math.min(y1 + 1, height - 1);
  const pos4 = (y1 * width + x1) * 4;
  const cr = img[pos4];
  const cg = img[pos4 + 1];
  const cb = img[pos4 + 2];
  const ca = img[pos4 + 3];
  let zeroes = x1 === x0 || x1 === x2 || y1 === y0 || y1 === y2 ? 1 : 0;
  let min = 0;
  let max = 0;
  let minX = 0;
  let minY = 0;
  let maxX = 0;
  let maxY = 0;
  for (let x = x0; x <= x2; x++) {
    for (let y = y0; y <= y2; y++) {
      if (x === x1 && y === y1) continue;
      const delta = brightnessDelta(img, pos4, (y * width + x) * 4, cr, cg, cb, ca, checkerboard);
      if (delta === 0) {
        zeroes++;
        if (zeroes > 2) return false;
      } else if (delta < min) {
        min = delta;
        minX = x;
        minY = y;
      } else if (delta > max) {
        max = delta;
        maxX = x;
        maxY = y;
      }
    }
  }
  if (min === 0 || max === 0) return false;
  return hasManySiblings(a32, minX, minY, width, height) && hasManySiblings(b32, minX, minY, width, height) || hasManySiblings(a32, maxX, maxY, width, height) && hasManySiblings(b32, maxX, maxY, width, height);
}
function hasManySiblings(img, x1, y1, width, height) {
  const x0 = Math.max(x1 - 1, 0);
  const y0 = Math.max(y1 - 1, 0);
  const x2 = Math.min(x1 + 1, width - 1);
  const y2 = Math.min(y1 + 1, height - 1);
  const val = img[y1 * width + x1];
  let zeroes = x1 === x0 || x1 === x2 || y1 === y0 || y1 === y2 ? 1 : 0;
  for (let x = x0; x <= x2; x++) {
    for (let y = y0; y <= y2; y++) {
      if (x === x1 && y === y1) continue;
      zeroes += +(val === img[y * width + x]);
      if (zeroes > 2) return true;
    }
  }
  return false;
}
function colorDelta(img1, img2, k, m, checkerboard) {
  const r1 = img1[k];
  const g1 = img1[k + 1];
  const b1 = img1[k + 2];
  const a1 = img1[k + 3];
  const r2 = img2[m];
  const g2 = img2[m + 1];
  const b2 = img2[m + 2];
  const a2 = img2[m + 3];
  let dr = r1 - r2;
  let dg = g1 - g2;
  let db = b1 - b2;
  const da = a1 - a2;
  if (a1 < 255 || a2 < 255) {
    let rb = 255, gb = 255, bb = 255;
    if (checkerboard) {
      rb = 48 + 159 * (k % 2);
      gb = 48 + 159 * ((k / 1.618033988749895 | 0) % 2);
      bb = 48 + 159 * ((k / 2.618033988749895 | 0) % 2);
    }
    dr = (r1 * a1 - r2 * a2 - rb * da) / 255;
    dg = (g1 * a1 - g2 * a2 - gb * da) / 255;
    db = (b1 * a1 - b2 * a2 - bb * da) / 255;
  }
  const y = dr * 0.29889531 + dg * 0.58662247 + db * 0.11448223;
  const i = dr * 0.59597799 - dg * 0.2741761 - db * 0.32180189;
  const q = dr * 0.21147017 - dg * 0.52261711 + db * 0.31114694;
  const delta = 0.5053 * y * y + 0.299 * i * i + 0.1957 * q * q;
  return y > 0 ? -delta : delta;
}
function brightnessDelta(img, k, m, r1, g1, b1, a1, checkerboard) {
  const r2 = img[m];
  const g2 = img[m + 1];
  const b2 = img[m + 2];
  const a2 = img[m + 3];
  let dr = r1 - r2;
  let dg = g1 - g2;
  let db = b1 - b2;
  const da = a1 - a2;
  if (!dr && !dg && !db && !da) return 0;
  if (a1 < 255 || a2 < 255) {
    let rb = 255, gb = 255, bb = 255;
    if (checkerboard) {
      rb = 48 + 159 * (k % 2);
      gb = 48 + 159 * ((k / 1.618033988749895 | 0) % 2);
      bb = 48 + 159 * ((k / 2.618033988749895 | 0) % 2);
    }
    dr = (r1 * a1 - r2 * a2 - rb * da) / 255;
    dg = (g1 * a1 - g2 * a2 - gb * da) / 255;
    db = (b1 * a1 - b2 * a2 - bb * da) / 255;
  }
  return dr * 0.29889531 + dg * 0.58662247 + db * 0.11448223;
}
function drawPixel(output, pos, r, g, b) {
  output[pos] = r;
  output[pos + 1] = g;
  output[pos + 2] = b;
  output[pos + 3] = 255;
}
function drawGrayPixel(img, i, alpha, output) {
  const val = 255 + (img[i] * 0.29889531 + img[i + 1] * 0.58662247 + img[i + 2] * 0.11448223 - 255) * alpha * img[i + 3] / 255;
  drawPixel(output, i, val, val, val);
}

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/comparison/compare.js


const getImageURL = (data, type = "image/png") => {
  const canvas = self.OffscreenCanvas ? new OffscreenCanvas(data.width, data.height) : "document" in self ? document.createElement("canvas") : null;
  if (!canvas) {
    throw new Error("Can't allocate canvas for image decode!");
  }
  canvas.width = data.width;
  canvas.height = data.height;
  const ctx = canvas.getContext("2d");
  if (ctx) {
    ctx.putImageData(data, 0, 0);
  }
  const htmlCanvas = canvas;
  let task = null;
  if (htmlCanvas["toBlob"]) {
    task = new Promise((res) => htmlCanvas.toBlob(res, type));
  } else {
    task = canvas.convertToBlob({ type });
  }
  return task.then((blob) => {
    if (!blob) {
      throw new Error("Can't resolve blob");
    }
    return URL.createObjectURL(blob);
  });
};
const computeIntersectionRect = (payload) => {
  const { sourceA, sourceB, scale } = payload;
  if (!sourceA.width || !sourceA.height)
    return null;
  if (!sourceB.width || !sourceB.height)
    return null;
  const EPS = 1e-6;
  const makeRect = (source) => ({
    x1: Math.floor(source.offset.x * scale + EPS),
    y1: Math.floor(source.offset.y * scale + EPS),
    x2: Math.ceil((source.offset.x + source.width) * scale - EPS),
    y2: Math.ceil((source.offset.y + source.height) * scale - EPS)
  });
  const rectA = makeRect(sourceA);
  const rectB = makeRect(sourceB);
  const dx1 = Math.max(rectA.x1, rectB.x1);
  const dy1 = Math.max(rectA.y1, rectB.y1);
  const dx2 = Math.min(rectA.x2, rectB.x2);
  const dy2 = Math.min(rectA.y2, rectB.y2);
  const dw = dx2 - dx1;
  const dh = dy2 - dy1;
  if (dw <= 0 || dh <= 0) {
    return null;
  }
  const intersectRect = {
    x: dx1,
    y: dy1,
    width: dw,
    height: dh
  };
  const sourceARect = {
    x: dx1 - rectA.x1,
    y: dy1 - rectA.y1,
    width: dw,
    height: dh
  };
  const sourceBRect = {
    x: dx1 - rectB.x1,
    y: dy1 - rectB.y1,
    width: dw,
    height: dh
  };
  return {
    sourceARect,
    sourceBRect,
    intersectRect
  };
};
const prepareData = (payload) => {
  const { sourceA, sourceB, rects } = payload;
  if (!rects.intersectRect || !sourceA.imageData || !sourceB.imageData) {
    throw new Error("Invalid data, rects and image MUST be valid");
  }
  const { sourceARect, sourceBRect } = rects;
  const makeCopyWhenNeeds = (source, rect) => {
    const width = rect.width;
    const height = rect.height;
    if (width === source.width && height === source.height) {
      return source;
    }
    return fastFrameCopy(source, new ImageData(width, height), rect.x, rect.y);
  };
  const rawSourceA = makeCopyWhenNeeds(sourceA.imageData, sourceARect);
  const rawSourceB = makeCopyWhenNeeds(sourceB.imageData, sourceBRect);
  return {
    frame: rects.intersectRect,
    rawSourceA,
    rawSourceB,
    originalA: rawSourceA === sourceA.imageData,
    originalB: rawSourceB === sourceB.imageData
  };
};
let ID = 0;
const compareData = async (payload, options) => {
  const trace = {
    prepare: 0,
    diff: 0,
    decode: 0
  };
  if (!payload.rects.intersectRect) {
    throw new Error("No any interection");
  }
  const id = options.id == void 0 ? ++ID : options.id;
  let diffCount = -1;
  trace.prepare = performance.now();
  const prepared = prepareData(payload);
  trace.prepare = performance.now() - trace.prepare;
  trace.diff = performance.now();
  const diffRawData = new ImageData(prepared.rawSourceA.width, prepared.rawSourceA.height);
  try {
    diffCount = pixelmatch(prepared.rawSourceA.data, prepared.rawSourceB.data, diffRawData.data, prepared.rawSourceA.width, prepared.rawSourceA.height, options);
  } catch (error) {
    throw new Error("Error while execute pixelmatch", { cause: error });
  }
  trace.diff = performance.now() - trace.diff;
  trace.decode = performance.now();
  let url;
  if (!options.rawImageData) {
    url = await getImageURL(diffRawData);
  }
  trace.decode = performance.now() - trace.decode;
  return {
    url,
    id,
    imageData: options.rawImageData ? diffRawData : void 0,
    frame: prepared.frame,
    diffCount,
    trace
  };
};

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/comparison/CompareRuntimeHost.js


const getPayloadTransferList = (payload) => {
  const sourceA = payload.sourceA.imageData?.data.buffer;
  const sourceB = payload.sourceB.imageData?.data.buffer;
  if (!sourceA || !sourceB) {
    throw new Error("[Comparer] Can't transfer compare payload without source image data");
  }
  return Array.from(/* @__PURE__ */ new Set([sourceA, sourceB]));
};
const detachPayloadImageData = (payload) => {
  payload.sourceA.imageData = void 0;
  payload.sourceB.imageData = void 0;
};
class CompareRuntimeHost {
  static checkAssetIsValid(config = {}, strict = false) {
    return checkAssetIsValid(config, strict);
  }
  constructor(init = {}) {
    this._workerTask = null;
    this.runtimeUrls = createMupdfRuntimeUrls(init.runtimeConfig);
  }
  getConfig() {
    return this.runtimeUrls.config;
  }
  setConfig(config = {}) {
    this.runtimeUrls.configure(config);
  }
  checkAssetIsValid(strict = false) {
    return checkAssetIsValid(this.runtimeUrls, strict);
  }
  terminate() {
    if (this._workerTask) {
      this._workerTask.api[releaseProxy]();
      this._workerTask.worker.terminate();
    }
    this._workerTask = null;
  }
  async compareIndirect(payload, options) {
    const runtimeUrls = this.runtimeUrls;
    if (this._workerTask && this._workerTask.active) {
      console.debug("[Comparer] Worker busy, kill and respawn");
      this.terminate();
    }
    if (this._workerTask && this._workerTask.url !== runtimeUrls.compareWorkerModule) {
      this.terminate();
    }
    if (!this._workerTask) {
      if (runtimeUrls.config.strictAssetValidation) {
        await checkAssetIsValid(runtimeUrls, true);
      }
      const worker = await constructWorker(runtimeUrls.compareWorkerModule, "pdf-compare-worker", true);
      const api = wrap(worker);
      this._workerTask = {
        worker,
        api,
        active: false,
        url: runtimeUrls.compareWorkerModule
      };
    }
    this._workerTask.active = true;
    try {
      await this._workerTask.api.init();
      payload = options.transfer ? transfer(payload, getPayloadTransferList(payload)) : payload;
      const compareTask = this._workerTask.api.compare(payload, options);
      detachPayloadImageData(payload);
      return await compareTask;
    } finally {
      if (this._workerTask) {
        this._workerTask.active = false;
      }
    }
  }
}
let defaultCompareRuntimeHost = null;
const getDefaultCompareRuntimeHost = () => {
  if (!defaultCompareRuntimeHost) {
    defaultCompareRuntimeHost = new CompareRuntimeHost();
  }
  return defaultCompareRuntimeHost;
};
const resetDefaultCompareRuntimeHost = () => {
  defaultCompareRuntimeHost?.terminate();
  defaultCompareRuntimeHost = null;
};
const terminateCompareRuntime = () => {
  resetDefaultCompareRuntimeHost();
};
const compareIndirect = (payload, options) => getDefaultCompareRuntimeHost().compareIndirect(payload, options);

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/comparison/GpuCompare.js
const GPU_COMPARE_MAX_PIXELS = 4 * 1024 * 1024;
const vertexSource = `#version 300 es
void main() {
	vec2 p = vec2(float((gl_VertexID << 1) & 2), float(gl_VertexID & 2));
	gl_Position = vec4(p * 2.0 - 1.0, 0.0, 1.0);
}`;
const fragmentSource = `#version 300 es
precision highp float;
uniform sampler2D imageA;
uniform sampler2D imageB;
uniform vec2 sizeA;
uniform vec2 sizeB;
uniform vec2 offsetA;
uniform vec2 offsetB;
uniform vec2 origin;
uniform float height;
uniform float threshold;
uniform float alpha;
out vec4 result;

vec3 sampleWhite(sampler2D image, vec2 size, vec2 point) {
	if (any(lessThan(point, vec2(0.0))) || any(greaterThanEqual(point, size))) {
		return vec3(255.0);
	}
	vec4 pixel = texelFetch(image, ivec2(point), 0);
	return mix(vec3(255.0), pixel.rgb * 255.0, pixel.a);
}

void main() {
	// ImageBitmap uploads start at its top-left; the framebuffer starts at bottom-left.
	vec2 point = origin + vec2(gl_FragCoord.x, height - gl_FragCoord.y);
	vec3 a = sampleWhite(imageA, sizeA, point - offsetA);
	vec3 b = sampleWhite(imageB, sizeB, point - offsetB);
	vec3 d = a - b;
	float y = dot(d, vec3(0.29889531, 0.58662247, 0.11448223));
	float i = dot(d, vec3(0.59597799, -0.27417610, -0.32180189));
	float q = dot(d, vec3(0.21147017, -0.52261711, 0.31114694));
	float delta = 0.5053 * y * y + 0.299 * i * i + 0.1957 * q * q;
	float gray = dot(a, vec3(0.29889531, 0.58662247, 0.11448223));
	vec3 color = vec3(255.0 + (gray - 255.0) * alpha);

	if (delta > 35215.0 * threshold * threshold) {
		color = y > 0.0 ? vec3(0.0, 0.0, 230.0) : vec3(245.0, 0.0, 0.0);
	}
	result = vec4(color / 255.0, 1.0);
}`;
const regionFragmentSource = `#version 300 es
precision highp float;
precision highp int;
uniform sampler2D diffImage;
uniform ivec2 imageSize;
uniform int rows;
uniform int blockSize;
out vec4 result;

void main() {
	ivec2 cell = ivec2(int(gl_FragCoord.x), rows - 1 - int(gl_FragCoord.y));
	ivec2 origin = cell * blockSize;
	uvec2 counts = uvec2(0u);

	for (int y = 0; y < blockSize; y++) {
		for (int x = 0; x < blockSize; x++) {
			ivec2 point = origin + ivec2(x, y);

			if (point.x >= imageSize.x || point.y >= imageSize.y) {
				continue;
			}

			uvec3 pixel = uvec3(round(texelFetch(diffImage, ivec2(point.x, imageSize.y - 1 - point.y), 0).rgb * 255.0));
			// Exact display palette, not near-gray channel dominance after GPU rounding.
			counts.x += all(equal(pixel, uvec3(245u, 0u, 0u))) ? 1u : 0u;
			counts.y += all(equal(pixel, uvec3(0u, 0u, 230u))) ? 1u : 0u;
		}
	}

	// Raw RGBA8 data target, never exported through ImageBitmap/premultiplied canvas.
	result = vec4(uvec4(counts.x & 255u, counts.x >> 8u, counts.y & 255u, counts.y >> 8u)) / 255.0;
}`;
class GpuCompare {
  constructor(canvas = new OffscreenCanvas(1, 1)) {
    this.textures = [];
    this.sources = [];
    this.regionTextures = [];
    this.regionSizes = [];
    this.disposed = false;
    const gl = canvas.getContext("webgl2", {
      alpha: false,
      antialias: false,
      depth: false,
      stencil: false,
      preserveDrawingBuffer: false
    });
    if (!gl) {
      throw new Error("WebGL2 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D. GPU compare \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u0441\u043A\u0440\u044B\u0442\u043E\u0433\u043E CPU fallback.");
    }
    this.canvas = canvas;
    this.gl = gl;
    this.maxSize = Math.min(gl.getParameter(gl.MAX_TEXTURE_SIZE), gl.getParameter(gl.MAX_RENDERBUFFER_SIZE), ...gl.getParameter(gl.MAX_VIEWPORT_DIMS));
    try {
      this.program = this.createProgram(fragmentSource);
      gl.useProgram(this.program);
      gl.disable(gl.DITHER);
      gl.uniform1i(gl.getUniformLocation(this.program, "imageA"), 0);
      gl.uniform1i(gl.getUniformLocation(this.program, "imageB"), 1);
      for (let index = 0; index < 2; index++) {
        const texture = gl.createTexture();
        if (!texture) {
          throw new Error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C texture \u0434\u043B\u044F \u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u044F.");
        }
        this.textures.push(texture);
        gl.activeTexture(gl.TEXTURE0 + index);
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
      }
    } catch (error) {
      this.dispose();
      throw error;
    }
  }
  compareFrame(frame, options = {}) {
    const { threshold = 0.1, alpha = 0.1, regionBlockSize } = options;
    if (regionBlockSize !== void 0) {
      return this.compareWithRegions(frame, threshold, alpha, regionBlockSize);
    }
    return { bitmap: this.compare(frame, threshold, alpha) };
  }
  compare(frame, threshold = 0.1, alpha = 0.1) {
    this.drawFrame(frame, threshold, alpha);
    return this.canvas.transferToImageBitmap();
  }
  compareWithRegions(frame, threshold = 0.1, alpha = 0.1, blockSize = 32) {
    if (!Number.isInteger(blockSize) || blockSize < 8 || blockSize > 64) {
      throw new Error("Region blockSize \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0446\u0435\u043B\u044B\u043C \u043E\u0442 8 \u0434\u043E 64 pixels.");
    }
    this.drawFrame(frame, threshold, alpha);
    const regions = this.collectRegions(frame, blockSize);
    const bitmap = this.canvas.transferToImageBitmap();
    return { bitmap, regions };
  }
  drawFrame(frame, threshold, alpha) {
    const { a, b, x, y, width, height } = frame;
    const gl = this.gl;
    const program = this.program;
    if (this.disposed || !program || gl.isContextLost()) {
      throw new Error("GPU compare \u0437\u0430\u043A\u0440\u044B\u0442 \u0438\u043B\u0438 WebGL context \u043F\u043E\u0442\u0435\u0440\u044F\u043D; \u0441\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u044D\u043A\u0437\u0435\u043C\u043F\u043B\u044F\u0440.");
    }
    this.validateSize(width, height);
    this.validateSize(a.bitmap.width, a.bitmap.height);
    this.validateSize(b.bitmap.width, b.bitmap.height);
    const validPlacement = [x, y, a.x, a.y, b.x, b.y].every(Number.isSafeInteger);
    const validOptions = Number.isFinite(threshold) && threshold >= 0 && threshold <= 1 && Number.isFinite(alpha) && alpha >= 0 && alpha <= 1;
    if (!validPlacement || !validOptions) {
      throw new Error("Compare \u0442\u0440\u0435\u0431\u0443\u0435\u0442 \u0446\u0435\u043B\u043E\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u0439 placement \u0438 threshold/alpha \u043E\u0442 0 \u0434\u043E 1.");
    }
    if (width < this.canvas.width) {
      this.canvas.width = width;
    }
    if (this.canvas.height !== height) {
      this.canvas.height = height;
    }
    if (this.canvas.width !== width) {
      this.canvas.width = width;
    }
    try {
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.useProgram(program);
      for (const [index, source] of [a, b].entries()) {
        const name = index === 0 ? "A" : "B";
        gl.activeTexture(gl.TEXTURE0 + index);
        gl.bindTexture(gl.TEXTURE_2D, this.textures[index]);
        if (this.sources[index] !== source.bitmap) {
          gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, source.bitmap);
          this.sources[index] = source.bitmap;
        }
        gl.uniform2f(gl.getUniformLocation(program, `size${name}`), source.bitmap.width, source.bitmap.height);
        gl.uniform2f(gl.getUniformLocation(program, `offset${name}`), source.x, source.y);
      }
      gl.uniform1f(gl.getUniformLocation(program, "height"), height);
      gl.uniform2f(gl.getUniformLocation(program, "origin"), x, y);
      gl.uniform1f(gl.getUniformLocation(program, "threshold"), threshold);
      gl.uniform1f(gl.getUniformLocation(program, "alpha"), alpha);
      gl.viewport(0, 0, width, height);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      const error = gl.getError();
      if (error !== gl.NO_ERROR || gl.isContextLost()) {
        throw new Error(`GPU compare: WebGL error ${error}.`);
      }
    } catch (error) {
      this.sources = [];
      throw error;
    }
  }
  dispose() {
    if (this.disposed) {
      return;
    }
    this.disposed = true;
    this.sources = [];
    for (const texture of this.textures) {
      this.gl.deleteTexture(texture);
    }
    for (const texture of this.regionTextures) {
      this.gl.deleteTexture(texture);
    }
    if (this.regionProgram) {
      this.gl.deleteProgram(this.regionProgram);
    }
    if (this.regionFramebuffer) {
      this.gl.deleteFramebuffer(this.regionFramebuffer);
    }
    if (this.program) {
      this.gl.deleteProgram(this.program);
    }
    this.textures = [];
    this.regionTextures = [];
    this.regionSizes = [];
    this.regionProgram = void 0;
    this.regionFramebuffer = void 0;
    this.program = void 0;
    this.canvas.width = 0;
    this.canvas.height = 0;
    this.gl.getExtension("WEBGL_lose_context")?.loseContext();
  }
  validateSize(width, height) {
    const valid = Number.isSafeInteger(width) && Number.isSafeInteger(height) && width > 0 && height > 0 && width <= this.maxSize && height <= this.maxSize && width * height <= GPU_COMPARE_MAX_PIXELS;
    if (!valid) {
      throw new Error(`Compare: \u0440\u0430\u0437\u043C\u0435\u0440 ${width}\xD7${height} \u0432\u043D\u0435 \u043B\u0438\u043C\u0438\u0442\u0430 4 Mi pixels / WebGL limits.`);
    }
  }
  collectRegions(frame, blockSize) {
    const gl = this.gl;
    const columns = Math.ceil(frame.width / blockSize);
    const rows = Math.ceil(frame.height / blockSize);
    const sizes = [{ width: frame.width, height: frame.height }, { width: columns, height: rows }];
    try {
      if (!this.regionProgram) {
        try {
          this.regionProgram = this.createProgram(regionFragmentSource);
          this.regionFramebuffer = gl.createFramebuffer() || void 0;
          if (!this.regionFramebuffer) {
            throw new Error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C region framebuffer.");
          }
          for (let index = 0; index < 2; index++) {
            const texture = gl.createTexture();
            if (!texture) {
              throw new Error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C region texture.");
            }
            this.regionTextures.push(texture);
            gl.activeTexture(gl.TEXTURE2);
            gl.bindTexture(gl.TEXTURE_2D, texture);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
          }
        } catch (error2) {
          this.dispose();
          throw error2;
        }
      }
      for (let index = 0; index < 2; index++) {
        const size = sizes[index];
        const previous = this.regionSizes[index];
        gl.activeTexture(gl.TEXTURE2);
        gl.bindTexture(gl.TEXTURE_2D, this.regionTextures[index]);
        if (!previous || previous.width !== size.width || previous.height !== size.height) {
          const internalFormat = index === 0 ? gl.RGB8 : gl.RGBA8;
          const format = index === 0 ? gl.RGB : gl.RGBA;
          gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, size.width, size.height, 0, format, gl.UNSIGNED_BYTE, null);
        }
      }
      gl.bindTexture(gl.TEXTURE_2D, this.regionTextures[0]);
      gl.copyTexSubImage2D(gl.TEXTURE_2D, 0, 0, 0, 0, 0, frame.width, frame.height);
      gl.bindFramebuffer(gl.FRAMEBUFFER, this.regionFramebuffer);
      gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.regionTextures[1], 0);
      if (gl.checkFramebufferStatus(gl.FRAMEBUFFER) !== gl.FRAMEBUFFER_COMPLETE) {
        throw new Error("Region framebuffer incomplete.");
      }
      gl.useProgram(this.regionProgram);
      gl.uniform1i(gl.getUniformLocation(this.regionProgram, "diffImage"), 2);
      gl.uniform2i(gl.getUniformLocation(this.regionProgram, "imageSize"), frame.width, frame.height);
      gl.uniform1i(gl.getUniformLocation(this.regionProgram, "rows"), rows);
      gl.uniform1i(gl.getUniformLocation(this.regionProgram, "blockSize"), blockSize);
      gl.viewport(0, 0, columns, rows);
      gl.drawArrays(gl.TRIANGLES, 0, 3);
      const raw = new Uint8Array(columns * rows * 4);
      gl.readPixels(0, 0, columns, rows, gl.RGBA, gl.UNSIGNED_BYTE, raw);
      const error = gl.getError();
      if (error !== gl.NO_ERROR || gl.isContextLost()) {
        throw new Error(`GPU regions: WebGL error ${error}.`);
      }
      const counts = new Uint16Array(columns * rows * 2);
      for (let y = 0; y < rows; y++) {
        for (let x = 0; x < columns; x++) {
          const from = ((rows - 1 - y) * columns + x) * 4;
          const to = (y * columns + x) * 2;
          counts[to] = raw[from] + (raw[from + 1] << 8);
          counts[to + 1] = raw[from + 2] + (raw[from + 3] << 8);
        }
      }
      this.regionSizes = sizes;
      return {
        x: frame.x,
        y: frame.y,
        width: frame.width,
        height: frame.height,
        blockSize,
        columns,
        rows,
        counts
      };
    } catch (error) {
      this.regionSizes = [];
      throw error;
    } finally {
      gl.bindFramebuffer(gl.FRAMEBUFFER, null);
      gl.useProgram(this.program || null);
      gl.viewport(0, 0, this.canvas.width, this.canvas.height);
    }
  }
  createProgram(fragment) {
    const gl = this.gl;
    const program = gl.createProgram();
    const shaders = [];
    if (!program) {
      throw new Error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C WebGL program.");
    }
    try {
      for (const [type, source] of [[gl.VERTEX_SHADER, vertexSource], [gl.FRAGMENT_SHADER, fragment]]) {
        const shader = gl.createShader(type);
        if (!shader) {
          throw new Error("\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u0441\u043E\u0437\u0434\u0430\u0442\u044C WebGL shader.");
        }
        shaders.push(shader);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
          throw new Error(gl.getShaderInfoLog(shader) || "WebGL shader compilation failed.");
        }
        gl.attachShader(program, shader);
      }
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        throw new Error(gl.getProgramInfoLog(program) || "WebGL program link failed.");
      }
      for (const shader of shaders) {
        gl.detachShader(program, shader);
      }
      return program;
    } catch (error) {
      gl.deleteProgram(program);
      throw error;
    } finally {
      for (const shader of shaders) {
        gl.deleteShader(shader);
      }
    }
  }
}

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/comparison/BitmapCompare.js

function validateCompareFrame(frame, options, maxSize, maxPixels = GPU_COMPARE_MAX_PIXELS) {
  const images = [frame.a, frame.b].map((source) => "image" in source ? source.image : source.bitmap);
  const sizes = [frame, ...images];
  const { threshold = 0.1, alpha = 0.1, regionBlockSize } = options;
  const validSizes = sizes.every(({ width, height }) => Number.isSafeInteger(width) && Number.isSafeInteger(height) && width > 0 && height > 0 && width <= maxSize && height <= maxSize && width * height <= maxPixels);
  const validPlacement = [frame.x, frame.y, frame.a.x, frame.a.y, frame.b.x, frame.b.y].every(Number.isSafeInteger);
  const validOptions = Number.isFinite(threshold) && threshold >= 0 && threshold <= 1 && Number.isFinite(alpha) && alpha >= 0 && alpha <= 1;
  const validBlock = regionBlockSize === void 0 || Number.isInteger(regionBlockSize) && regionBlockSize >= 8 && regionBlockSize <= 64;
  const validPixels = images.every((image) => !("data" in image) || ArrayBuffer.isView(image.data) && image.data.BYTES_PER_ELEMENT === 1 && image.data.length === image.width * image.height * 4 && (!("colorSpace" in image) || image.colorSpace === "srgb"));
  if (!validSizes || !validPlacement || !validOptions || !validBlock || !validPixels) {
    throw new Error(`Compare: integer placement/size, \u2264${maxPixels / (1024 * 1024)} Mi pixels, RGBA8/sRGB, threshold/alpha [0,1], region block [8,64] required.`);
  }
}

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/comparison/WebGpuApi.js
const textureUsage = { COPY_SRC: 1, COPY_DST: 2, TEXTURE_BINDING: 4, RENDER_ATTACHMENT: 16 };
const bufferUsage = { MAP_READ: 1, COPY_SRC: 4, COPY_DST: 8, UNIFORM: 64, STORAGE: 128 };

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/comparison/WebGpuCompare.js


const WEBGPU_COMPARE_MAX_PIXELS = 16 * 1024 * 1024;
const shader = `
struct Params {
	origin: vec2i,
	offsetA: vec2i,
	offsetB: vec2i,
	size: vec2u,
	threshold: f32,
	alpha: f32,
	block: u32,
	columns: u32,
}
@group(0) @binding(0) var imageA: texture_2d<f32>;
@group(0) @binding(1) var imageB: texture_2d<f32>;
@group(0) @binding(2) var<uniform> params: Params;

@vertex fn vertexMain(@builtin(vertex_index) index: u32) -> @builtin(position) vec4f {
	let p = vec2f(f32((index << 1u) & 2u), f32(index & 2u));
	return vec4f(p * 2.0 - 1.0, 0.0, 1.0);
}
fn sampleWhite(image: texture_2d<f32>, point: vec2i) -> vec3f {
	if (any(point < vec2i(0)) || any(point >= vec2i(textureDimensions(image)))) {
		return vec3f(255.0);
	}
	let pixel = textureLoad(image, point, 0);
	return mix(vec3f(255.0), pixel.rgb * 255.0, pixel.a);
}
@fragment fn fragmentMain(@builtin(position) point: vec4f) -> @location(0) vec4f {
	let position = params.origin + vec2i(point.xy);
	let a = sampleWhite(imageA, position - params.offsetA);
	let b = sampleWhite(imageB, position - params.offsetB);
	let d = a - b;
	let y = dot(d, vec3f(0.29889531, 0.58662247, 0.11448223));
	let i = dot(d, vec3f(0.59597799, -0.27417610, -0.32180189));
	let q = dot(d, vec3f(0.21147017, -0.52261711, 0.31114694));
	let delta = 0.5053 * y * y + 0.299 * i * i + 0.1957 * q * q;
	let gray = dot(a, vec3f(0.29889531, 0.58662247, 0.11448223));
	var color = vec3f(255.0 + (gray - 255.0) * params.alpha);
	if (delta > 35215.0 * params.threshold * params.threshold) {
		color = select(vec3f(245.0, 0.0, 0.0), vec3f(0.0, 0.0, 230.0), y > 0.0);
	}
	return vec4f(color / 255.0, 1.0);
}
`;
const regionShader = `
struct Params {
	origin: vec2i, offsetA: vec2i, offsetB: vec2i, size: vec2u,
	threshold: f32, alpha: f32, block: u32, columns: u32,
}
@group(0) @binding(0) var diff: texture_2d<f32>;
@group(0) @binding(1) var<uniform> params: Params;
@group(0) @binding(2) var<storage, read_write> counts: array<u32>;
var<workgroup> before: atomic<u32>;
var<workgroup> after: atomic<u32>;

@compute @workgroup_size(8, 8) fn main(
	@builtin(workgroup_id) cell: vec3u,
	@builtin(local_invocation_id) lane: vec3u,
	@builtin(local_invocation_index) index: u32,
) {
	// Workgroup memory is zero-initialized per dispatch; each lane scans a disjoint subset.
	var a = 0u;
	var b = 0u;
	for (var y = lane.y; y < params.block; y += 8u) {
		for (var x = lane.x; x < params.block; x += 8u) {
			let point = cell.xy * params.block + vec2u(x, y);
			if (all(point < params.size)) {
				let pixel = vec3u(round(textureLoad(diff, vec2i(point), 0).rgb * 255.0));
				// Almost-gray 1-LSB channel rounding is context, not a directional change.
				a += select(0u, 1u, all(pixel == vec3u(245u, 0u, 0u)));
				b += select(0u, 1u, all(pixel == vec3u(0u, 0u, 230u)));
			}
		}
	}
	atomicAdd(&before, a);
	atomicAdd(&after, b);
	workgroupBarrier();
	if (index == 0u) {
		counts[cell.y * params.columns + cell.x] = atomicLoad(&before) | (atomicLoad(&after) << 16u);
	}
}`;
class WebGpuCompare {
  constructor(device, format, adapterInfo, pipeline, regionPipeline, canvas) {
    this.device = device;
    this.adapterInfo = adapterInfo;
    this.pipeline = pipeline;
    this.regionPipeline = regionPipeline;
    this.canvas = canvas;
    this.backend = "gpu";
    this.params = new ArrayBuffer(48);
    this.integers = new Int32Array(this.params);
    this.floats = new Float32Array(this.params);
    this.bytes = new Uint8Array(this.params);
    this.sources = [];
    this.textures = [];
    this.disposed = false;
    this.busy = false;
    this.failure = "";
    const context = this.canvas.getContext("webgpu");
    if (!context) {
      throw new Error("OffscreenCanvas WebGPU context \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D.");
    }
    this.context = context;
    this.uniform = device.createBuffer({ size: 48, usage: bufferUsage.UNIFORM | bufferUsage.COPY_DST });
    context.configure({ device, format, usage: textureUsage.RENDER_ATTACHMENT | textureUsage.TEXTURE_BINDING, alphaMode: "opaque" });
    device.onuncapturederror = (event) => {
      this.failure = event.error.message || "WebGPU runtime error";
    };
    void device.lost.then((info) => {
      this.failure = info.message || "WebGPU device lost";
    });
  }
  static async create(gpu = navigator.gpu, canvas) {
    if (!gpu) {
      throw new Error(`WebGPU API \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D (secureContext=${globalThis.isSecureContext}). \u041D\u0443\u0436\u0435\u043D localhost \u0438\u043B\u0438 HTTPS; fallback \u043D\u0435 \u0432\u043A\u043B\u044E\u0447\u0451\u043D.`);
    }
    const adapter = await gpu.requestAdapter();
    if (!adapter) {
      throw new Error("WebGPU requestAdapter \u0432\u0435\u0440\u043D\u0443\u043B null; fallback \u043D\u0435 \u0432\u043A\u043B\u044E\u0447\u0451\u043D.");
    }
    const device = await adapter.requestDevice();
    let engine;
    device.pushErrorScope("out-of-memory");
    device.pushErrorScope("internal");
    device.pushErrorScope("validation");
    try {
      try {
        const format = gpu.getPreferredCanvasFormat();
        const module = device.createShaderModule({ code: shader });
        const pipeline = await device.createRenderPipelineAsync({
          layout: "auto",
          vertex: { module, entryPoint: "vertexMain" },
          fragment: { module, entryPoint: "fragmentMain", targets: [{ format }] }
        });
        const regionPipeline = await device.createComputePipelineAsync({
          layout: "auto",
          compute: { module: device.createShaderModule({ code: regionShader }), entryPoint: "main" }
        });
        const info = adapter.info;
        const label = info ? [info.vendor, info.architecture, info.description, info.device].filter(Boolean).join(" \xB7 ") : "Adapter info unavailable";
        engine = new WebGpuCompare(device, format, label, pipeline, regionPipeline, canvas || new OffscreenCanvas(1, 1));
        return engine;
      } finally {
        const errors = await Promise.all([device.popErrorScope(), device.popErrorScope(), device.popErrorScope()]);
        const error = errors.find(Boolean);
        if (error) {
          throw new Error(error.message);
        }
      }
    } catch (error) {
      if (engine) {
        engine.dispose();
      } else {
        device.destroy();
      }
      throw error;
    }
  }
  compareFrame(frame, options = {}) {
    return this.compare({
      ...frame,
      a: { image: frame.a.bitmap, x: frame.a.x, y: frame.a.y },
      b: { image: frame.b.bitmap, x: frame.b.x, y: frame.b.y }
    }, options);
  }
  async compare(frame, options = {}) {
    if (this.disposed || this.failure || this.busy) {
      throw new Error(this.failure || "WebGPU compare disposed \u0438\u043B\u0438 \u0437\u0430\u043D\u044F\u0442; \u043F\u0430\u0440\u0430\u043B\u043B\u0435\u043B\u044C\u043D\u044B\u0435 \u0432\u044B\u0437\u043E\u0432\u044B \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u044B.");
    }
    validateCompareFrame(frame, options, this.device.limits.maxTextureDimension2D, WEBGPU_COMPARE_MAX_PIXELS);
    const { threshold = 0.1, alpha = 0.1, regionBlockSize } = options;
    const device = this.device;
    const columns = regionBlockSize ? Math.ceil(frame.width / regionBlockSize) : 0;
    const rows = regionBlockSize ? Math.ceil(frame.height / regionBlockSize) : 0;
    const integers = this.integers;
    const floats = this.floats;
    const offsets = [frame.a.x - frame.x, frame.a.y - frame.y, frame.b.x - frame.x, frame.b.y - frame.y];
    let bitmap;
    if (offsets.some((value) => value < -2147483648 || value > 2147483647)) {
      throw new Error("WebGPU source offsets \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043A\u0430\u0434\u0440\u0430 \u043F\u0440\u0435\u0432\u044B\u0448\u0430\u044E\u0442 int32.");
    }
    this.busy = true;
    try {
      integers.set([0, 0, ...offsets, frame.width, frame.height]);
      floats[8] = threshold;
      floats[9] = alpha;
      integers[10] = regionBlockSize || 0;
      integers[11] = columns;
      device.queue.writeBuffer(this.uniform, 0, this.bytes);
      for (const [index, source] of [frame.a, frame.b].entries()) {
        const image = source.image;
        const pixels = "data" in image;
        if (pixels || this.sources[index] !== image) {
          const { width, height } = image;
          let slot = this.textures[index];
          if (!slot || slot.width !== width || slot.height !== height) {
            slot?.texture.destroy();
            this.textures[index] = void 0;
            this.group = void 0;
            const texture = device.createTexture({
              size: [width, height],
              format: "rgba8unorm",
              usage: textureUsage.COPY_DST | textureUsage.TEXTURE_BINDING | textureUsage.RENDER_ATTACHMENT
            });
            slot = { texture, width, height };
            this.textures[index] = slot;
          }
          if ("data" in image) {
            device.queue.writeTexture({ texture: slot.texture }, image.data, { bytesPerRow: width * 4 }, [width, height]);
          } else {
            device.queue.copyExternalImageToTexture({ source: image }, { texture: slot.texture, premultipliedAlpha: false, colorSpace: "srgb" }, [width, height]);
          }
          this.sources[index] = image;
        }
      }
      if (frame.width < this.canvas.width) {
        this.canvas.width = frame.width;
      }
      if (this.canvas.height !== frame.height) {
        this.canvas.height = frame.height;
      }
      if (this.canvas.width !== frame.width) {
        this.canvas.width = frame.width;
      }
      const target = this.context.getCurrentTexture();
      const encoder = device.createCommandEncoder();
      if (!this.group) {
        this.group = device.createBindGroup({ layout: this.pipeline.getBindGroupLayout(0), entries: [
          { binding: 0, resource: this.textures[0].texture.createView() },
          { binding: 1, resource: this.textures[1].texture.createView() },
          { binding: 2, resource: { buffer: this.uniform } }
        ] });
      }
      const pass = encoder.beginRenderPass({ colorAttachments: [
        { view: target.createView(), loadOp: "clear", storeOp: "store", clearValue: [1, 1, 1, 1] }
      ] });
      pass.setPipeline(this.pipeline);
      pass.setBindGroup(0, this.group);
      pass.draw(3);
      pass.end();
      if (regionBlockSize) {
        const bytes = columns * rows * 4;
        if (this.regionBuffers?.bytes !== bytes) {
          this.regionBuffers?.storage.destroy();
          this.regionBuffers?.readback.destroy();
          this.regionBuffers = {
            storage: device.createBuffer({ size: bytes, usage: bufferUsage.STORAGE | bufferUsage.COPY_SRC }),
            readback: device.createBuffer({ size: bytes, usage: bufferUsage.MAP_READ | bufferUsage.COPY_DST }),
            bytes
          };
        }
        const regionGroup = device.createBindGroup({ layout: this.regionPipeline.getBindGroupLayout(0), entries: [
          { binding: 0, resource: target.createView() },
          { binding: 1, resource: { buffer: this.uniform } },
          { binding: 2, resource: { buffer: this.regionBuffers.storage } }
        ] });
        const compute = encoder.beginComputePass();
        compute.setPipeline(this.regionPipeline);
        compute.setBindGroup(0, regionGroup);
        compute.dispatchWorkgroups(columns, rows);
        compute.end();
        encoder.copyBufferToBuffer(this.regionBuffers.storage, 0, this.regionBuffers.readback, 0, bytes);
      }
      device.queue.submit([encoder.finish()]);
      bitmap = this.canvas.transferToImageBitmap();
      let regions;
      if (regionBlockSize) {
        const readback = this.regionBuffers.readback;
        await readback.mapAsync(1);
        try {
          const packed = new Uint32Array(readback.getMappedRange());
          const counts = new Uint16Array(columns * rows * 2);
          for (let index = 0; index < packed.length; index++) {
            counts[index * 2] = packed[index] & 65535;
            counts[index * 2 + 1] = packed[index] >>> 16;
          }
          regions = { x: frame.x, y: frame.y, width: frame.width, height: frame.height, blockSize: regionBlockSize, columns, rows, counts };
        } finally {
          readback.unmap();
        }
      }
      if (this.disposed || this.failure) {
        throw new Error(this.failure || "WebGPU disposed during compare.");
      }
      return { bitmap, regions };
    } catch (error) {
      bitmap?.close();
      this.sources = [];
      throw error;
    } finally {
      this.busy = false;
    }
  }
  dispose() {
    if (this.disposed) {
      return;
    }
    this.disposed = true;
    this.device.onuncapturederror = null;
    this.context.unconfigure();
    this.textures.forEach((slot) => slot?.texture.destroy());
    this.sources = [];
    this.textures = [];
    this.group = void 0;
    this.uniform.destroy();
    this.regionBuffers?.storage.destroy();
    this.regionBuffers?.readback.destroy();
    this.regionBuffers = void 0;
    this.canvas.width = 0;
    this.canvas.height = 0;
    this.device.destroy();
  }
}

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/comparison/CpuBitmapCompare.js


class CpuBitmapCompare {
  constructor(canvas = new OffscreenCanvas(1, 1)) {
    this.canvas = canvas;
    this.backend = "cpu";
    this.cached = [];
    this.disposed = false;
    this.busy = false;
    const context = canvas.getContext("2d", { willReadFrequently: true });
    if (!context) {
      throw new Error("CPU compare requires a 2D canvas context.");
    }
    this.context = context;
  }
  compareFrame(frame, options = {}) {
    return this.compare({
      ...frame,
      a: { image: frame.a.bitmap, x: frame.a.x, y: frame.a.y },
      b: { image: frame.b.bitmap, x: frame.b.x, y: frame.b.y }
    }, options);
  }
  async compare(frame, options = {}) {
    if (this.disposed || this.busy) {
      throw new Error("CPU compare disposed \u0438\u043B\u0438 \u0437\u0430\u043D\u044F\u0442.");
    }
    validateCompareFrame(frame, options, 16384);
    const { threshold = 0.1, alpha = 0.1, regionBlockSize } = options;
    const inputs = [];
    const nextCache = [];
    this.busy = true;
    try {
      for (const source of [frame.a, frame.b]) {
        const image = source.image;
        const x = source.x - frame.x;
        const y = source.y - frame.y;
        const fullFrame = x === 0 && y === 0 && image.width === frame.width && image.height === frame.height;
        if ("data" in image && fullFrame) {
          inputs.push(image);
          continue;
        }
        let cached = !("data" in image) ? this.cached.find((entry) => entry.image === image && entry.x === x && entry.y === y && entry.data.width === frame.width && entry.data.height === frame.height) : void 0;
        if (!cached) {
          if (frame.width < this.canvas.width) {
            this.canvas.width = frame.width;
          }
          if (this.canvas.height !== frame.height) {
            this.canvas.height = frame.height;
          }
          if (this.canvas.width !== frame.width) {
            this.canvas.width = frame.width;
          }
          this.context.fillStyle = "white";
          this.context.fillRect(0, 0, frame.width, frame.height);
          this.context.clearRect(x, y, image.width, image.height);
          if ("data" in image) {
            this.context.putImageData(image, x, y);
          } else {
            this.context.drawImage(image, x, y);
          }
          cached = { image, x, y, data: this.context.getImageData(0, 0, frame.width, frame.height) };
        }
        if (!("data" in image)) {
          nextCache.push(cached);
        }
        inputs.push(cached.data);
      }
      this.cached = nextCache;
      const rect = { x: 0, y: 0, width: frame.width, height: frame.height };
      const result = await compareData({
        rects: { intersectRect: rect, sourceARect: rect, sourceBRect: rect },
        sourceA: { imageData: inputs[0], offset: { x: 0, y: 0 }, scale: 1 },
        sourceB: { imageData: inputs[1], offset: { x: 0, y: 0 }, scale: 1 }
      }, {
        threshold,
        alpha,
        includeAA: true,
        rawImageData: true,
        diffColor: [245, 0, 0],
        diffColorAlt: [0, 0, 230],
        diffMask: false
      });
      if (this.disposed) {
        throw new Error("CPU compare disposed during compare.");
      }
      const data = result.imageData;
      let regions;
      if (regionBlockSize !== void 0) {
        const columns = Math.ceil(frame.width / regionBlockSize);
        const rows = Math.ceil(frame.height / regionBlockSize);
        const counts = new Uint16Array(columns * rows * 2);
        for (let y = 0; y < frame.height; y++) {
          for (let x = 0; x < frame.width; x++) {
            const offset = (y * frame.width + x) * 4;
            const r = data.data[offset];
            const g = data.data[offset + 1];
            const b = data.data[offset + 2];
            const index = (Math.floor(y / regionBlockSize) * columns + Math.floor(x / regionBlockSize)) * 2;
            const before = r === 245 && g === 0 && b === 0;
            const after = r === 0 && g === 0 && b === 230;
            if (before || after) {
              counts[index + (before ? 0 : 1)]++;
            }
          }
        }
        regions = { x: frame.x, y: frame.y, width: frame.width, height: frame.height, blockSize: regionBlockSize, columns, rows, counts };
      }
      if (frame.width < this.canvas.width) {
        this.canvas.width = frame.width;
      }
      if (this.canvas.height !== frame.height) {
        this.canvas.height = frame.height;
      }
      if (this.canvas.width !== frame.width) {
        this.canvas.width = frame.width;
      }
      this.context.putImageData(data, 0, 0);
      return { bitmap: this.canvas.transferToImageBitmap(), regions };
    } finally {
      this.busy = false;
    }
  }
  dispose() {
    this.disposed = true;
    this.cached = [];
    this.canvas.width = 0;
    this.canvas.height = 0;
  }
}

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/comparison/CpuWorkerCompare.js



class CpuWorkerCompare {
  constructor(worker, api) {
    this.worker = worker;
    this.api = api;
    this.backend = "cpu";
    this.disposed = false;
    this.busy = false;
    this.onWorkerError = () => {
      this.rejectPending?.(new Error("CPU compare worker failed."));
      this.dispose();
    };
    worker.addEventListener("error", this.onWorkerError);
    worker.addEventListener("messageerror", this.onWorkerError);
  }
  static async create(runtimeConfig) {
    const urls = createMupdfRuntimeUrls(runtimeConfig);
    const worker = await constructWorker(urls.compareWorkerModule, "pdf-bitmap-compare-worker", true);
    const engine = new CpuWorkerCompare(worker, wrap(worker));
    try {
      await engine.run(() => engine.api.initBitmap());
      return engine;
    } catch (error) {
      engine.dispose();
      throw error;
    }
  }
  compareFrame(frame, options = {}) {
    return this.compare({
      ...frame,
      a: { image: frame.a.bitmap, x: frame.a.x, y: frame.a.y },
      b: { image: frame.b.bitmap, x: frame.b.x, y: frame.b.y }
    }, options);
  }
  async compare(frame, options = {}) {
    validateCompareFrame(frame, options, 16384);
    return this.run(async () => {
      const result = await this.api.compareFrame(frame, options);
      if (this.disposed) {
        result.bitmap.close();
        throw new Error("CPU compare disposed during compare.");
      }
      return result;
    });
  }
  async run(request) {
    if (this.disposed || this.busy) {
      throw new Error("CPU compare disposed or busy.");
    }
    this.busy = true;
    try {
      const cancelled = new Promise((_, reject) => {
        this.rejectPending = reject;
      });
      return await Promise.race([cancelled, request()]);
    } finally {
      this.rejectPending = void 0;
      this.busy = false;
    }
  }
  dispose() {
    if (this.disposed) {
      return;
    }
    this.disposed = true;
    this.rejectPending?.(new Error("CPU compare disposed."));
    this.worker.removeEventListener("error", this.onWorkerError);
    this.worker.removeEventListener("messageerror", this.onWorkerError);
    try {
      this.api[releaseProxy]();
    } finally {
      this.worker.terminate();
    }
  }
}

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/comparison/createBitmapCompare.js



async function createBitmapCompare(backend, runtimeConfig) {
  switch (backend) {
    case "webgpu":
      return WebGpuCompare.create();
    case "webgl2":
      return new GpuCompare();
    case "cpu":
      return CpuWorkerCompare.create(runtimeConfig);
    default:
      throw new Error(`Unknown comparison backend: ${backend}`);
  }
}

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/comparison/createCompareEngine.js


async function createCompareEngine({ mode = "auto", runtimeConfig } = {}) {
  if (mode === "cpu") {
    return CpuWorkerCompare.create(runtimeConfig);
  }
  if (mode !== "auto") {
    throw new Error(`Unknown comparison mode: ${mode}`);
  }
  try {
    return await WebGpuCompare.create();
  } catch (error) {
    console.warn("[Compare] WebGPU initialization failed; using CPU.", error);
    return CpuWorkerCompare.create(runtimeConfig);
  }
}

;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/comparison/index.js











;// ./node_modules/@sarex-team/srx-pdf-runtime/dist/index.js





/***/ }),

/***/ 95562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var mobx__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64806);
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

class l {
  constructor() {
    __publicField(this, "value", "");
    (0,mobx__WEBPACK_IMPORTED_MODULE_0__.makeObservable)(this, { value: mobx__WEBPACK_IMPORTED_MODULE_0__.observable, set: mobx__WEBPACK_IMPORTED_MODULE_0__.action });
  }
  set(e2) {
    this.value = e2;
  }
}
class n {
  constructor() {
    __publicField(this, "data", null);
    (0,mobx__WEBPACK_IMPORTED_MODULE_0__.makeObservable)(this, { data: mobx__WEBPACK_IMPORTED_MODULE_0__.observable.shallow, set: mobx__WEBPACK_IMPORTED_MODULE_0__.action });
  }
  set(e2) {
    this.data = e2;
  }
  get(e2) {
    if (this.data) return this.data[e2];
  }
}
class r {
  constructor(e2) {
    __publicField(this, "_load");
    __publicField(this, "promise", null);
    this._load = e2;
  }
  load() {
    return this.promise || (this.promise = this._load().then((e2) => e2.default)), this.promise;
  }
}
class o {
  constructor() {
    __publicField(this, "data", new n());
    __publicField(this, "loader", null);
  }
  load() {
    this.loader?.load().then((e2) => {
      this.data.set(e2);
    });
  }
  setJSONImportLoader(e2) {
    this.loader = new r(e2);
  }
}
class i {
  constructor() {
    __publicField(this, "code", new l());
    __publicField(this, "translations", new o());
  }
}
class d {
  constructor() {
    __publicField(this, "map", /* @__PURE__ */ new Map());
  }
  add(e2) {
    const a2 = new i();
    return a2.code.value = e2, this.map.set(e2, a2), a2;
  }
  get(e2) {
    return this.map.get(e2) || this.add(e2);
  }
}
class g {
  constructor(e2) {
    __publicField(this, "selectedLanguageCode");
    __publicField(this, "languages", new d());
    __publicField(this, "translate", (e2, a2) => {
      const t2 = this.selectedLanguageCode.value;
      if (!t2) return this.replaceVariables(e2, a2);
      const s2 = this.languages.get(t2).translations.data.get(e2) || e2;
      return this.replaceVariables(s2, a2);
    });
    this.selectedLanguageCode = e2, (0,mobx__WEBPACK_IMPORTED_MODULE_0__.reaction)(() => e2.value, (e3) => {
      this.loadLanguage(e3);
    }, { fireImmediately: true });
  }
  loadLanguage(e2) {
    e2 && this.languages.get(e2).translations.load();
  }
  getLanguage() {
    return this.selectedLanguageCode.value;
  }
  importLanguage(e2, a2) {
    const t2 = this.languages.get(e2).translations;
    t2.setJSONImportLoader(a2), this.selectedLanguageCode.value === e2 && t2.load();
  }
  setLanguage(e2) {
    this.selectedLanguageCode.set(e2);
  }
  createNamespace() {
    return new g(this.selectedLanguageCode);
  }
  replaceVariables(e2, a2) {
    return a2 ? e2.replace(/{{(\w+)}}/g, (e3, t2) => a2[t2]?.toString() || e3) : e2;
  }
}
const u = new g(new l());


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "globalTranslator", 0, /* binding */ u
/* harmony export */ ]);


/***/ }),

/***/ 42689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!(function(e, t) {
   true ? module.exports = t(__webpack_require__(12549), __webpack_require__(23552), __webpack_require__(37072), __webpack_require__(80739), __webpack_require__(52234)) : 0;
})(self, (e, t, n, r, a) => (() => {
  "use strict";
  var l = { 276(e2) {
    e2.exports = t;
  }, 375(e2) {
    e2.exports = n;
  }, 471(e2) {
    e2.exports = a;
  }, 154(e2) {
    e2.exports = r;
  }, 155(t2) {
    t2.exports = e;
  } }, o = {};
  function i(e2) {
    var t2 = o[e2];
    if (void 0 !== t2) return t2.exports;
    var n2 = o[e2] = { exports: {} };
    return l[e2](n2, n2.exports, i), n2.exports;
  }
  i.n = (e2) => {
    var t2 = e2 && e2.__esModule ? () => e2.default : () => e2;
    return i.d(t2, { a: t2 }), t2;
  }, i.d = (e2, t2) => {
    for (var n2 in t2) i.o(t2, n2) && !i.o(e2, n2) && Object.defineProperty(e2, n2, { enumerable: true, get: t2[n2] });
  }, i.o = (e2, t2) => Object.prototype.hasOwnProperty.call(e2, t2), i.r = (e2) => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e2, "__esModule", { value: true });
  };
  var c = {};
  i.r(c), i.d(c, { Button: () => m, ChevronDownIcon: () => Ct, ChevronLeftIcon: () => Et, ChevronRightIcon: () => Mt, ChevronUpIcon: () => Lt, CircleCheckedIcon: () => Nt, CircleIcon: () => kt, CloseIcon: () => Zt, ComposableSelectContent: () => Xt, ComposableSelectGroupLabel: () => Cn, ComposableSelectItem: () => In, ComposableSelectList: () => Ln, ComposableSelectRoot: () => Nn, ComposableSelectSearch: () => Dn, ComposableSelectTrigger: () => Rn, DEFAULT_ICON_COLOR: () => mt, DEFAULT_ICON_COLOR_MUTED: () => vt, DocumentIcon: () => He, DynamicSelectContent: () => Kn, DynamicSelectItem: () => Qn, DynamicSelectList: () => nr, DynamicSelectRoot: () => _n, DynamicSelectSearch: () => Jn, DynamicSelectTrigger: () => Un, DynamicTreeSelectContent: () => wr, DynamicTreeSelectItem: () => Lr, DynamicTreeSelectItemRow: () => Ir, DynamicTreeSelectList: () => Nr, DynamicTreeSelectRoot: () => hr, DynamicTreeSelectSearch: () => Dr, DynamicTreeSelectSelectedList: () => jr, DynamicTreeSelectTrigger: () => Fr, FunnelIcon: () => Pt, IconButton: () => _e, ItemTree: () => et, MinusIcon: () => Dt, Pagination: () => pt, PaintBucketIcon: () => Tt, PlusIcon: () => jt, SearchField: () => Kt, SearchIcon: () => Rt, Select: () => Ar, SettingsIcon: () => zt, SquareCheckedIcon: () => Ht, SquareIcon: () => Ft, TextField: () => ma, ThemeProvider: () => ga, TrashIcon: () => Wt, Tree: () => Je, TreeItem: () => Ue, TreeSelectContent: () => _r, TreeSelectItem: () => $r, TreeSelectItemRow: () => Gr, TreeSelectList: () => ea, TreeSelectRoot: () => aa, TreeSelectSearch: () => ia, TreeSelectSelectedList: () => sa, TreeSelectTrigger: () => pa, createIcon: () => yt, darkThemeOptions: () => ba, lightThemeOptions: () => va, useDynamicSelect: () => ir, useDynamicTreeSelect: () => yr });
  var s, u = i(155), d = i.n(u), p = i(276), f = function() {
    return f = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, f.apply(this, arguments);
  }, h = (0, p.makeStyles)(function() {
    return { label: { textTransform: "none", fontWeight: 600, fontSize: "12px" }, root: function(e2) {
      var t2 = e2.small;
      return { padding: "".concat(t2 ? 1 : 7, "px 16px") };
    } };
  }), m = function(e2) {
    var t2 = e2.children, n2 = e2.small, r2 = e2.secondary, a2 = h(e2);
    return d().createElement(p.Button, f({ variant: r2 ? "outlined" : "contained", disableElevation: true, fullWidth: true, color: "primary", size: n2 ? "small" : "medium", classes: a2 }, e2), t2);
  };
  function v() {
    return v = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, v.apply(null, arguments);
  }
  const g = function(e2) {
    return u.createElement("svg", v({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), s || (s = u.createElement("path", { clipRule: "evenodd", d: "M17.827 7.256c.154.164.24.387.24.619V8.5H5.933V6.875c0-.232.086-.455.24-.619A.79.79 0 0 1 6.75 6h3.524l1.4 1h5.576a.79.79 0 0 1 .577.256ZM5.836 17.227 5.002 9.92a.4.4 0 0 1 .086-.293.352.352 0 0 1 .119-.093.33.33 0 0 1 .143-.033h13.3a.33.33 0 0 1 .143.033.352.352 0 0 1 .119.093.399.399 0 0 1 .086.293l-.833 7.308a.897.897 0 0 1-.269.552.786.786 0 0 1-.543.221H6.649a.786.786 0 0 1-.544-.22.897.897 0 0 1-.269-.553Z" })));
  };
  var b;
  function y() {
    return y = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, y.apply(null, arguments);
  }
  const x = function(e2) {
    return u.createElement("svg", y({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), b || (b = u.createElement("path", { clipRule: "evenodd", d: "m18.99 12.397-1-4.744C17.795 6.618 17.051 6 16 6H8c-.525 0-.969.147-1.316.436-.346.289-.574.697-.674 1.215l-1 4.746A.52.52 0 0 0 5 12.5V16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-3.5a.525.525 0 0 0-.01-.103Zm-12-4.544v-.009c.11-.576.43-.843 1.008-.843H16c.582 0 .902.267 1.008.84l.002.008v.005l.842 3.996a.125.125 0 0 1-.122.15H14a.498.498 0 0 0-.5.495 1.5 1.5 0 1 1-3 0A.497.497 0 0 0 10 12H6.27a.125.125 0 0 1-.122-.15l.841-3.997ZM15.5 9h-7a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1ZM8 11h8a.5.5 0 0 0 0-1H8a.5.5 0 0 0 0 1Z" })));
  };
  var w;
  function C() {
    return C = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, C.apply(null, arguments);
  }
  const S = function(e2) {
    return u.createElement("svg", C({ width: 24, height: 24, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), w || (w = u.createElement("path", { d: "M6.23 3.816 9 5.382l2.77-1.566L9 2.25 6.23 3.816ZM12.573 4.27l-2.77 1.566 2.77 1.566 2.769-1.566-2.77-1.566ZM12.177 8.087 9.396 6.514v7.663l2.781 1.573V8.087ZM5.427 8.556l-2.769 1.566 2.77 1.566 2.769-1.566-2.77-1.566ZM8.604 9.444V6.067L5.823 4.494v3.377l2.781 1.573ZM12.968 8.088v7.662l2.782-1.573V6.514l-2.782 1.574ZM5.823 12.373v3.377l2.781-1.573V10.8l-2.781 1.573ZM5.032 12.373 2.25 10.8v3.377l2.782 1.573v-3.377Z" })));
  };
  var E;
  function I() {
    return I = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, I.apply(null, arguments);
  }
  const M = function(e2) {
    return u.createElement("svg", I({ width: 24, height: 24, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), E || (E = u.createElement("path", { d: "M1.895 10.184a.396.396 0 0 0-.395.395c0 .217.178.395.395.395a.396.396 0 0 0 .394-.395.396.396 0 0 0-.394-.395ZM1.895 7.026a.396.396 0 0 0-.395.395c0 .217.178.395.395.395a.396.396 0 0 0 .394-.395.396.396 0 0 0-.394-.395ZM7.421 15.71a.396.396 0 0 0-.395.395c0 .217.178.395.395.395a.396.396 0 0 0 .395-.395.396.396 0 0 0-.395-.395ZM4.263 3.474a.792.792 0 0 0-.79.79c0 .433.356.789.79.789.434 0 .79-.356.79-.79a.792.792 0 0 0-.79-.79ZM4.263 6.632a.792.792 0 0 0-.79.79c0 .433.356.789.79.789.434 0 .79-.356.79-.79a.792.792 0 0 0-.79-.79ZM4.263 9.79a.792.792 0 0 0-.79.789c0 .434.356.79.79.79.434 0 .79-.356.79-.79a.792.792 0 0 0-.79-.79ZM16.105 7.816a.396.396 0 0 0 .395-.395.396.396 0 0 0-.395-.395.396.396 0 0 0-.394.395c0 .217.177.395.394.395ZM10.579 2.29a.396.396 0 0 0 .395-.395.396.396 0 0 0-.395-.395.396.396 0 0 0-.395.395c0 .217.178.394.395.394ZM7.421 5.053c.434 0 .79-.356.79-.79a.792.792 0 0 0-.79-.79.792.792 0 0 0-.79.79c0 .434.356.79.79.79ZM7.421 2.29a.396.396 0 0 0 .395-.395.396.396 0 0 0-.395-.395.396.396 0 0 0-.395.395c0 .217.178.394.395.394ZM10.579 5.053c.434 0 .79-.356.79-.79a.792.792 0 0 0-.79-.79.792.792 0 0 0-.79.79c0 .434.356.79.79.79ZM4.263 12.947a.792.792 0 0 0-.79.79c0 .434.356.79.79.79.434 0 .79-.356.79-.79a.792.792 0 0 0-.79-.79ZM10.579 6.237c-.655 0-1.184.529-1.184 1.184 0 .655.529 1.184 1.184 1.184.655 0 1.184-.529 1.184-1.184 0-.655-.529-1.184-1.184-1.184ZM13.737 9.79a.792.792 0 0 0-.79.789c0 .434.356.79.79.79.434 0 .79-.356.79-.79a.792.792 0 0 0-.79-.79ZM13.737 12.947a.792.792 0 0 0-.79.79c0 .434.356.79.79.79.434 0 .79-.356.79-.79a.792.792 0 0 0-.79-.79ZM13.737 6.632a.792.792 0 0 0-.79.79c0 .433.356.789.79.789.434 0 .79-.356.79-.79a.792.792 0 0 0-.79-.79ZM16.105 10.184a.396.396 0 0 0-.394.395c0 .217.177.395.394.395a.396.396 0 0 0 .395-.395.396.396 0 0 0-.395-.395ZM13.737 3.474a.792.792 0 0 0-.79.79c0 .433.356.789.79.789.434 0 .79-.356.79-.79a.792.792 0 0 0-.79-.79ZM7.421 9.395c-.655 0-1.184.529-1.184 1.184 0 .655.529 1.184 1.184 1.184.655 0 1.184-.529 1.184-1.184 0-.655-.529-1.184-1.184-1.184ZM7.421 12.947a.792.792 0 0 0-.79.79c0 .434.356.79.79.79.434 0 .79-.356.79-.79a.792.792 0 0 0-.79-.79ZM7.421 6.237c-.655 0-1.184.529-1.184 1.184 0 .655.529 1.184 1.184 1.184.655 0 1.184-.529 1.184-1.184 0-.655-.529-1.184-1.184-1.184ZM10.579 12.947a.792.792 0 0 0-.79.79c0 .434.356.79.79.79.434 0 .79-.356.79-.79a.792.792 0 0 0-.79-.79ZM10.579 15.71a.396.396 0 0 0-.395.395.396.396 0 0 0 .79 0 .396.396 0 0 0-.395-.395ZM10.579 9.395c-.655 0-1.184.529-1.184 1.184 0 .655.529 1.184 1.184 1.184.655 0 1.184-.529 1.184-1.184 0-.655-.529-1.184-1.184-1.184Z" })));
  };
  var O;
  function L() {
    return L = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, L.apply(null, arguments);
  }
  const k = function(e2) {
    return u.createElement("svg", L({ width: 24, height: 20, viewBox: "0 0 24 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), O || (O = u.createElement("path", { d: "M24 13.54H0l1.19-2.066 3.708-6.422c.656-1.135 1.726-1.135 2.38 0 0 0 .861 1.49.965 1.665.493-.852 3.12-5.406 3.12-5.406.658-1.134 1.728-1.134 2.382 0l5.22 9.043c.27-.467.535-.925.738-1.284.475-.819 1.245-.819 1.722 0a652.32 652.32 0 0 0 1.72 2.978L24 13.54Z" })));
  };
  var N;
  function Z() {
    return Z = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, Z.apply(null, arguments);
  }
  const P = function(e2) {
    return u.createElement("svg", Z({ width: 24, height: 24, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), N || (N = u.createElement("path", { d: "M4.25 2.25a2 2 0 0 0-2 2v9.5a2 2 0 0 0 2 2h9.5a2 2 0 0 0 2-2v-9.5a2 2 0 0 0-2-2h-9.5Zm4.188 12.375H3.375v-9h5.063v9Zm6.187 0H9.562v-3.938h5.063v3.938Zm0-5.063H9.562V5.626h5.063v3.938Z" })));
  };
  var D, T, j;
  function R() {
    return R = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, R.apply(null, arguments);
  }
  const z = function(e2) {
    return u.createElement("svg", R({ width: 24, height: 24, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), D || (D = u.createElement("path", { d: "M14.52 6.073h-.3V5.96c0-.508-.2-.991-.563-1.36l-1.702-1.733a2.095 2.095 0 0 0-1.488-.617H5.01c-.678 0-1.23.532-1.23 1.187v2.636h-.3c-.678 0-1.23.533-1.23 1.187v4.746c0 .654.552 1.186 1.23 1.186h.3v1.371c0 .655.552 1.187 1.23 1.187h7.98c.678 0 1.23-.532 1.23-1.187v-1.37h.3c.678 0 1.23-.533 1.23-1.187V7.26c0-.654-.552-1.187-1.23-1.187ZM4.6 3.437c0-.219.184-.396.41-.396h5.457c.336 0 .662.135.893.37l1.703 1.733c.217.221.337.511.337.816v.113H4.6V3.437Zm8.8 11.127a.403.403 0 0 1-.41.395H5.01a.403.403 0 0 1-.41-.396v-1.37h8.8v1.37Zm1.53-2.558a.403.403 0 0 1-.41.395H3.48a.403.403 0 0 1-.41-.395V7.26c0-.218.184-.396.41-.396h11.04c.226 0 .41.178.41.396v4.746Z" })), T || (T = u.createElement("path", { d: "M3 6.75h12v6H3z" })), j || (j = u.createElement("path", { d: "M5.53 10.68v.72c0 .067-.033.1-.1.1h-.44c-.066 0-.1-.033-.1-.1V8.8c0-.067.034-.1.1-.1h1.64c.467 0 .7.233.7.7v.58c0 .467-.233.7-.7.7h-1.1Zm0-1.42v.86h.94c.147 0 .22-.073.22-.22v-.42c0-.147-.073-.22-.22-.22h-.94Zm4.22-.56c.467 0 .7.233.7.7v1.4c0 .467-.233.7-.7.7H7.99c-.066 0-.1-.033-.1-.1V8.8c0-.067.034-.1.1-.1h1.76Zm-1.22 2.24h1.06c.147 0 .22-.073.22-.22V9.48c0-.147-.073-.22-.22-.22H8.53v1.68Zm3.16.46c0 .067-.033.1-.1.1h-.44c-.066 0-.1-.033-.1-.1V8.8c0-.067.034-.1.1-.1h2.1c.067 0 .1.033.1.1v.36c0 .067-.033.1-.1.1h-1.56v.66h1.04c.067 0 .1.033.1.1v.36c0 .067-.033.1-.1.1h-1.04v.92Z", fill: "#fff" })));
  };
  var F, H, W;
  function A() {
    return A = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, A.apply(null, arguments);
  }
  const V = function(e2) {
    return u.createElement("svg", A({ width: 24, height: 24, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), F || (F = u.createElement("path", { d: "M14.52 6.073h-.3V5.96c0-.508-.2-.991-.563-1.36l-1.702-1.733a2.095 2.095 0 0 0-1.488-.617H5.01c-.678 0-1.23.532-1.23 1.187v2.636h-.3c-.678 0-1.23.533-1.23 1.187v4.746c0 .654.552 1.186 1.23 1.186h.3v1.371c0 .655.552 1.187 1.23 1.187h7.98c.678 0 1.23-.532 1.23-1.187v-1.37h.3c.678 0 1.23-.533 1.23-1.187V7.26c0-.654-.552-1.187-1.23-1.187ZM4.6 3.437c0-.219.184-.396.41-.396h5.457c.336 0 .662.135.893.37l1.703 1.733c.217.221.337.511.337.816v.113H4.6V3.437Zm8.8 11.127a.403.403 0 0 1-.41.395H5.01a.403.403 0 0 1-.41-.396v-1.37h8.8v1.37Zm1.53-2.558a.403.403 0 0 1-.41.395H3.48a.403.403 0 0 1-.41-.395V7.26c0-.218.184-.396.41-.396h11.04c.226 0 .41.178.41.396v4.746Z" })), H || (H = u.createElement("path", { d: "M3 6.75h12v6H3v-6Z" })), W || (W = u.createElement("path", { d: "M5.403 8.292c.414 0 .622.243.622.729v1.458c0 .486-.208.73-.622.73H3.839c-.06 0-.089-.035-.089-.105V8.396c0-.07.03-.104.089-.104h1.564Zm-1.084 2.333h.942c.13 0 .195-.076.195-.23v-1.29c0-.154-.065-.23-.195-.23h-.942v1.75ZM8.85 10.52c0 .487-.207.73-.621.73H7.145c-.415 0-.622-.243-.622-.73V8.98c0-.487.207-.73.622-.73h1.084c.414 0 .622.243.622.73v1.54Zm-.568-1.457c0-.153-.065-.23-.195-.23h-.8c-.13 0-.196.077-.196.23v1.374c0 .153.065.23.196.23h.8c.13 0 .195-.077.195-.23V9.063ZM11.623 9.188c0 .069-.03.104-.089.104h-.39c-.06 0-.09-.035-.09-.104v-.126c0-.152-.065-.229-.195-.229h-.747c-.13 0-.195.077-.195.23v1.374c0 .153.065.23.195.23h.747c.13 0 .195-.077.195-.23v-.124c0-.07.03-.105.09-.105h.39c.06 0 .089.035.089.104v.209c0 .486-.207.729-.622.729H9.97c-.416 0-.623-.243-.623-.73V8.98c0-.487.207-.73.622-.73H11c.416 0 .623.243.623.73v.207ZM13.06 9.167l.427-.771a.44.44 0 0 1 .057-.075c.021-.02.05-.03.085-.03h.463a.07.07 0 0 1 .06.03c.014.02.012.044-.007.075l-.746 1.27.835 1.438c.019.03.021.056.007.075a.07.07 0 0 1-.06.03h-.463a.122.122 0 0 1-.085-.03.438.438 0 0 1-.057-.075l-.515-.916h-.036l-.515.916a.353.353 0 0 1-.06.075c-.02.02-.047.03-.082.03h-.462a.07.07 0 0 1-.06-.03c-.015-.02-.013-.044.006-.075l.836-1.437-.747-1.271c-.019-.03-.021-.056-.007-.075a.07.07 0 0 1 .06-.03h.463c.035 0 .062.01.081.03a.35.35 0 0 1 .06.075l.427.77h.036Z", fill: "#fff" })));
  };
  var _, B, q;
  function U() {
    return U = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, U.apply(null, arguments);
  }
  const G = function(e2) {
    return u.createElement("svg", U({ width: 24, height: 24, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), _ || (_ = u.createElement("path", { d: "M14.52 6.073h-.3V5.96c0-.508-.2-.991-.563-1.36l-1.702-1.733a2.095 2.095 0 0 0-1.488-.617H5.01c-.678 0-1.23.532-1.23 1.187v2.636h-.3c-.678 0-1.23.533-1.23 1.187v4.746c0 .654.552 1.186 1.23 1.186h.3v1.371c0 .655.552 1.187 1.23 1.187h7.98c.678 0 1.23-.532 1.23-1.187v-1.37h.3c.678 0 1.23-.533 1.23-1.187V7.26c0-.654-.552-1.187-1.23-1.187ZM4.6 3.437c0-.219.184-.396.41-.396h5.457c.336 0 .662.135.893.37l1.703 1.733c.217.221.337.511.337.816v.113H4.6V3.437Zm8.8 11.127a.403.403 0 0 1-.41.395H5.01a.403.403 0 0 1-.41-.396v-1.37h8.8v1.37Zm1.53-2.558a.403.403 0 0 1-.41.395H3.48a.403.403 0 0 1-.41-.395V7.26c0-.218.184-.396.41-.396h11.04c.226 0 .41.178.41.396v4.746Z" })), B || (B = u.createElement("path", { d: "M3 6.75h12v6H3v-6Z" })), q || (q = u.createElement("path", { d: "m5.49 9.186.433-.666a.393.393 0 0 1 .057-.065.137.137 0 0 1 .087-.025h.468c.026 0 .046.008.06.025.015.017.013.039-.006.065l-.756 1.098.846 1.242c.019.026.021.048.007.065a.076.076 0 0 1-.061.025h-.468a.137.137 0 0 1-.087-.025.393.393 0 0 1-.057-.065l-.522-.792h-.036l-.522.792a.319.319 0 0 1-.062.065c-.019.017-.046.025-.082.025H4.32a.076.076 0 0 1-.062-.025c-.014-.017-.012-.039.008-.065l.846-1.242-.756-1.098c-.02-.026-.022-.048-.008-.065a.076.076 0 0 1 .062-.025h.468c.036 0 .063.008.082.025a.319.319 0 0 1 .062.065l.432.666h.036ZM7.56 10.446h1.35c.06 0 .09.03.09.09v.324c0 .06-.03.09-.09.09H7.074c-.06 0-.09-.03-.09-.09V8.52c0-.06.03-.09.09-.09h.396c.06 0 .09.03.09.09v1.926ZM10.855 10.212c0-.086-.054-.146-.162-.18l-.99-.306a.723.723 0 0 1-.324-.187c-.072-.082-.108-.2-.108-.353v-.162c0-.42.21-.63.63-.63h.864c.42 0 .63.21.63.63v.18c0 .06-.03.09-.09.09h-.396c-.06 0-.09-.03-.09-.09v-.108c0-.132-.066-.198-.198-.198h-.576c-.132 0-.198.066-.198.198v.036c0 .089.054.149.162.18l.99.306c.144.046.252.11.324.19.072.08.108.196.108.35v.198c0 .42-.21.63-.63.63h-.954c-.42 0-.63-.21-.63-.63v-.18c0-.06.03-.09.09-.09h.396c.06 0 .09.03.09.09v.108c0 .132.066.198.198.198h.666c.132 0 .198-.066.198-.198v-.072ZM12.852 9.186l.432-.666a.393.393 0 0 1 .058-.065.137.137 0 0 1 .086-.025h.468c.027 0 .047.008.062.025.014.017.012.039-.008.065l-.756 1.098.846 1.242c.02.026.022.048.008.065a.076.076 0 0 1-.062.025h-.468a.137.137 0 0 1-.086-.025.393.393 0 0 1-.058-.065l-.522-.792h-.036l-.522.792a.319.319 0 0 1-.06.065c-.02.017-.048.025-.084.025h-.468a.076.076 0 0 1-.06-.025c-.015-.017-.013-.039.006-.065l.846-1.242-.756-1.098c-.019-.026-.021-.048-.007-.065a.076.076 0 0 1 .061-.025h.468c.036 0 .064.008.083.025a.319.319 0 0 1 .061.065l.432.666h.036Z", fill: "#fff" })));
  };
  var K, Y;
  function X() {
    return X = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, X.apply(null, arguments);
  }
  const J = function(e2) {
    return u.createElement("svg", X({ width: 24, height: 24, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), K || (K = u.createElement("path", { d: "M5.324 7.642a.252.252 0 0 0 .232-.146H7.88c.125.041.253.073.383.096v.385h1.219v-.261c1.628.371 1.661 2.2 1.662 2.288h-.354v1.141h1.22v-1.14h-.354a3.53 3.53 0 0 0-.338-1.399 2.48 2.48 0 0 0-1.036-1.11h1.909a.256.256 0 0 0 .281.142.24.24 0 0 0 .203-.231.24.24 0 0 0-.203-.231.255.255 0 0 0-.281.141H9.867a2.807 2.807 0 0 0-.383-.095v-.386h-1.22v.262c-1.629-.372-1.662-2.2-1.662-2.288h.354V3.669h-1.22v1.14h.354c.015.483.13.957.339 1.398.213.462.576.85 1.036 1.11H5.556a.251.251 0 0 0-.207-.144.258.258 0 0 0-.235.103.223.223 0 0 0-.013.242c.044.077.13.125.223.125ZM7.516 13.797a.506.506 0 0 0-.418-.168H6.84v1.354h.252a.634.634 0 0 0 .278-.053.431.431 0 0 0 .173-.148.6.6 0 0 0 .087-.217 1.338 1.338 0 0 0-.01-.558.581.581 0 0 0-.104-.21Z" })), Y || (Y = u.createElement("path", { d: "M14.49 12.091V5.806L10.692 2.25H4.277c-.271 0-.53.1-.723.28a.927.927 0 0 0-.299.676v8.066a.493.493 0 0 0-.186.173.453.453 0 0 0-.069.238v3.475c0 .317.135.62.374.845.24.224.564.35.903.35h9.192c.338 0 .663-.126.902-.35a1.16 1.16 0 0 0 .375-.845v-2.655a.454.454 0 0 0-.069-.238.494.494 0 0 0-.187-.174Zm-6.412 2.67a.828.828 0 0 1-.201.334 1.02 1.02 0 0 1-.773.278h-.751v-2.134h.745a1.3 1.3 0 0 1 .469.076.844.844 0 0 1 .325.216.88.88 0 0 1 .189.337c.043.144.063.292.061.44.003.153-.019.306-.064.453Zm1.311.612-.346-.663-.346.663h-.536l.616-1.093-.58-1.041h.537l.31.6.309-.6h.536l-.58 1.041.616 1.093H9.39Zm2.188-1.745h-.99v.436h.739l.003.39-.74.003v.916H10.1v-2.134h1.477v.389Zm2.403-1.603H8.384l-.613-.657a.527.527 0 0 0-.384-.163H3.766v-8c0-.126.054-.248.15-.337a.529.529 0 0 1 .36-.14h6.055v2.46c0 .253.107.496.299.676.191.179.451.28.722.28h2.628v5.88Z" })));
  };
  var $, Q;
  function ee() {
    return ee = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, ee.apply(null, arguments);
  }
  const te = function(e2) {
    return u.createElement("svg", ee({ width: 24, height: 24, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), $ || ($ = u.createElement("path", { d: "M15.354 11.136h-8.49v-8.49a.396.396 0 0 0-.395-.396H2.646a.396.396 0 0 0-.396.396v12.709c0 .218.177.395.396.395h12.709a.396.396 0 0 0 .395-.396v-3.823a.396.396 0 0 0-.396-.395ZM3.041 3.04h3.032v1.134h-.87a.396.396 0 0 0 0 .79h.87v.897h-.448a.396.396 0 0 0 0 .791h.448v.897h-.87a.396.396 0 0 0 0 .79h.87v.897h-.448a.396.396 0 0 0 0 .791h.448v1.108H3.041V3.04Zm0 8.886h3.032v3.032H3.041v-3.032Zm11.918 3.032H6.864v-3.032h1.108v.87a.396.396 0 0 0 .79 0v-.87h.897v.448a.396.396 0 0 0 .791 0v-.448h.897v.87a.396.396 0 0 0 .79 0v-.87h.897v.448a.396.396 0 0 0 .791 0v-.448h1.134v3.032Z" })), Q || (Q = u.createElement("path", { d: "M4.958 13.352a.396.396 0 1 0-.776.155.396.396 0 0 0 .776-.155Z" })));
  };
  var ne, re, ae, le;
  function oe() {
    return oe = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, oe.apply(null, arguments);
  }
  const ie = function(e2) {
    return u.createElement("svg", oe({ width: 24, height: 30, viewBox: "0 0 18 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), ne || (ne = u.createElement("path", { d: "M8.1 7.267c-.126 0-.229.11-.229.243 0 .134.103.243.23.243.125 0 .228-.11.228-.243s-.103-.243-.229-.243ZM8.1 5.324c-.126 0-.229.11-.229.243s.103.243.23.243c.125 0 .228-.11.228-.243 0-.134-.103-.243-.229-.243ZM11.309 10.668c-.126 0-.23.11-.23.243 0 .134.104.243.23.243s.23-.11.23-.243c0-.134-.104-.243-.23-.243ZM9.475 3.138c-.252 0-.458.218-.458.485 0 .268.206.486.458.486.253 0 .459-.218.459-.486 0-.267-.206-.485-.459-.485ZM9.475 5.081c-.252 0-.458.219-.458.486s.206.486.458.486c.253 0 .459-.219.459-.486s-.206-.486-.459-.486ZM9.475 7.024c-.252 0-.458.219-.458.486s.206.486.458.486c.253 0 .459-.219.459-.486s-.206-.486-.459-.486ZM16.352 5.81c.125 0 .229-.11.229-.243 0-.134-.104-.243-.23-.243s-.229.11-.229.243.103.243.23.243ZM13.143 2.409c.126 0 .229-.11.229-.243 0-.134-.103-.243-.23-.243-.125 0-.229.11-.229.243 0 .134.104.243.23.243ZM11.309 4.11c.252 0 .458-.22.458-.486 0-.268-.206-.486-.458-.486s-.458.218-.458.486c0 .267.206.485.458.485ZM11.309 2.409c.126 0 .23-.11.23-.243 0-.134-.104-.243-.23-.243s-.23.11-.23.243c0 .134.104.243.23.243ZM13.143 4.11c.252 0 .458-.22.458-.486 0-.268-.206-.486-.458-.486-.253 0-.459.218-.459.486 0 .267.207.485.459.485ZM9.475 8.968c-.252 0-.458.218-.458.485 0 .268.206.486.458.486.253 0 .459-.218.459-.486 0-.267-.206-.485-.459-.485ZM13.143 4.838c-.38 0-.688.326-.688.729 0 .403.307.729.688.729.38 0 .687-.326.687-.73 0-.402-.307-.728-.687-.728ZM14.976 7.024c-.252 0-.458.219-.458.486s.206.486.458.486.459-.219.459-.486-.207-.486-.459-.486ZM14.976 8.968c-.252 0-.458.218-.458.485 0 .268.206.486.458.486s.459-.218.459-.486c0-.267-.207-.485-.459-.485ZM14.976 5.081c-.252 0-.458.219-.458.486s.206.486.458.486.459-.219.459-.486-.207-.486-.459-.486ZM16.352 7.267c-.127 0-.23.11-.23.243 0 .134.103.243.23.243.125 0 .229-.11.229-.243s-.104-.243-.23-.243ZM14.976 3.138c-.252 0-.458.218-.458.485 0 .268.206.486.458.486s.459-.218.459-.486c0-.267-.207-.485-.459-.485ZM11.309 6.781c-.38 0-.688.326-.688.73 0 .402.307.728.688.728.38 0 .688-.326.688-.729 0-.403-.307-.729-.688-.729ZM11.309 8.968c-.252 0-.458.218-.458.485 0 .268.206.486.458.486s.458-.218.458-.486c0-.267-.206-.485-.458-.485ZM11.309 4.838c-.38 0-.688.326-.688.729 0 .403.307.729.688.729.38 0 .688-.326.688-.73 0-.402-.307-.728-.688-.728ZM13.143 8.968c-.253 0-.459.218-.459.485 0 .268.207.486.459.486s.458-.218.458-.486c0-.267-.206-.485-.458-.485ZM13.143 10.668c-.126 0-.23.11-.23.243 0 .134.104.243.23.243s.229-.11.229-.243c0-.134-.103-.243-.23-.243ZM13.143 6.781c-.38 0-.688.326-.688.73 0 .402.307.728.688.728.38 0 .687-.326.687-.729 0-.403-.307-.729-.687-.729Z" })), re || (re = u.createElement("g", { clipPath: "url(#ico-type-c2s_svg__a)", fill: "#FF5C4A", stroke: "#FF5C4A", strokeWidth: 0.3 }, u.createElement("path", { d: "M4.8 14.284a.248.248 0 0 1 .187-.088c.07 0 .136.031.186.088.024.027.044.06.057.097a.337.337 0 0 1-.057.327l-1.487 1.678a.248.248 0 0 1-.186.088.248.248 0 0 1-.186-.088l-1.487-1.678a.303.303 0 0 1-.057-.097.338.338 0 0 1 .057-.327.248.248 0 0 1 .186-.088c.07 0 .137.031.186.088l1.302 1.375 1.3-1.375ZM2.2 10.716a.248.248 0 0 1-.187.089.248.248 0 0 1-.186-.088.303.303 0 0 1-.057-.098.338.338 0 0 1 .057-.327l1.487-1.677a.248.248 0 0 1 .186-.088c.07 0 .137.031.186.088l1.487 1.677c.024.028.044.06.057.097a.337.337 0 0 1-.057.328.248.248 0 0 1-.186.088.248.248 0 0 1-.186-.088L3.499 9.34l-1.3 1.376Z" }), u.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.316 16.2V8.8h.369v7.4h-.369Z" }))), ae || (ae = u.createElement("g", { clipPath: "url(#ico-type-c2s_svg__b)" }, u.createElement("path", { d: "M17.45 21.073H7l.518-.9 1.615-2.796c.285-.494.751-.494 1.036 0l.42.725 1.359-2.354c.286-.494.752-.494 1.037 0l2.273 3.937c.117-.203.233-.402.321-.559.207-.356.542-.356.75 0 .205.358.542.942.749 1.297l.372.65Z" }))), le || (le = u.createElement("defs", null, u.createElement("clipPath", { id: "ico-type-c2s_svg__a" }, u.createElement("path", { fill: "#fff", transform: "rotate(90 -.5 7.5)", d: "M0 0h9v7H0z" })), u.createElement("clipPath", { id: "ico-type-c2s_svg__b" }, u.createElement("path", { fill: "#fff", transform: "translate(7 13)", d: "M0 0h10.45v10.45H0z" })))));
  };
  var ce, se, ue, de;
  function pe() {
    return pe = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, pe.apply(null, arguments);
  }
  const fe = function(e2) {
    return u.createElement("svg", pe({ width: 24, height: 30, viewBox: "0 0 18 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), ce || (ce = u.createElement("path", { d: "M7.649 6.267c-.127 0-.23.11-.23.243 0 .134.104.243.23.243s.229-.11.229-.243-.103-.243-.23-.243ZM7.649 4.324c-.127 0-.23.11-.23.243s.104.243.23.243.229-.11.229-.243c0-.134-.103-.243-.23-.243ZM10.857 9.668c-.126 0-.229.11-.229.243 0 .134.103.243.23.243.125 0 .229-.11.229-.243 0-.134-.104-.243-.23-.243ZM9.024 2.138c-.252 0-.459.218-.459.485 0 .268.207.486.459.486s.458-.218.458-.486c0-.267-.206-.485-.458-.485ZM9.024 4.081c-.252 0-.459.219-.459.486s.207.486.459.486.458-.219.458-.486-.206-.486-.458-.486ZM9.024 6.024c-.252 0-.459.219-.459.486s.207.486.459.486.458-.219.458-.486-.206-.486-.458-.486ZM15.9 4.81c.126 0 .23-.11.23-.243 0-.134-.104-.243-.23-.243s-.23.11-.23.243.104.243.23.243ZM12.691 1.409c.126 0 .23-.11.23-.243 0-.134-.104-.243-.23-.243s-.23.11-.23.243c0 .134.104.243.23.243ZM10.857 3.11c.253 0 .459-.22.459-.486 0-.268-.207-.486-.459-.486s-.458.218-.458.486c0 .267.206.485.458.485ZM10.857 1.409c.127 0 .23-.11.23-.243 0-.134-.104-.243-.23-.243s-.229.11-.229.243c0 .134.103.243.23.243ZM12.691 3.11c.252 0 .458-.22.458-.486 0-.268-.206-.486-.458-.486s-.458.218-.458.486c0 .267.206.485.458.485ZM9.024 7.968c-.252 0-.459.218-.459.485 0 .268.207.486.459.486s.458-.218.458-.486c0-.267-.206-.485-.458-.485ZM12.691 3.838c-.38 0-.688.326-.688.729 0 .403.307.729.688.729.38 0 .688-.326.688-.73 0-.402-.307-.728-.688-.728ZM14.525 6.024c-.252 0-.459.219-.459.486s.207.486.459.486.458-.219.458-.486-.206-.486-.458-.486ZM14.525 7.968c-.252 0-.459.218-.459.485 0 .268.207.486.459.486s.458-.218.458-.486c0-.267-.206-.485-.458-.485ZM14.525 4.081c-.252 0-.459.219-.459.486s.207.486.459.486.458-.219.458-.486-.206-.486-.458-.486ZM15.9 6.267c-.126 0-.23.11-.23.243 0 .134.104.243.23.243s.23-.11.23-.243c-.001-.133-.104-.243-.23-.243ZM14.525 2.138c-.252 0-.459.218-.459.485 0 .268.207.486.459.486s.458-.218.458-.486c0-.267-.206-.485-.458-.485ZM10.857 5.781c-.38 0-.687.326-.687.73 0 .402.307.728.687.728.38 0 .688-.326.688-.729 0-.403-.307-.729-.688-.729ZM10.857 7.968c-.252 0-.458.218-.458.485 0 .268.206.486.458.486.253 0 .459-.218.459-.486 0-.267-.207-.485-.459-.485ZM10.857 3.838c-.38 0-.687.326-.687.729 0 .403.307.729.687.729.38 0 .688-.326.688-.73 0-.402-.307-.728-.688-.728ZM12.691 7.968c-.252 0-.458.218-.458.485 0 .268.206.486.458.486s.458-.218.458-.486c0-.267-.206-.485-.458-.485ZM12.691 9.668c-.126 0-.23.11-.23.243 0 .134.104.243.23.243s.23-.11.23-.243c0-.134-.104-.243-.23-.243ZM12.691 5.781c-.38 0-.688.326-.688.73 0 .402.307.728.688.728.38 0 .688-.326.688-.729 0-.403-.307-.729-.688-.729Z" })), se || (se = u.createElement("g", { clipPath: "url(#ico-type-c2c_svg__a)" }, u.createElement("path", { d: "M11.087 14.09c0-.134-.104-.244-.23-.244s-.229.11-.229.243c0 .134.103.243.23.243.125 0 .229-.11.229-.243ZM12.92 14.09c0-.134-.103-.244-.229-.244s-.23.11-.23.243c0 .134.104.243.23.243s.23-.11.23-.243ZM7.878 17.49c0-.134-.103-.243-.23-.243-.125 0-.229.11-.229.243 0 .134.104.243.23.243s.229-.11.229-.243ZM14.983 15.547c0-.268-.206-.486-.458-.486s-.459.219-.459.486.207.485.459.485.458-.218.458-.485ZM13.15 15.547c0-.268-.207-.486-.459-.486s-.458.219-.458.486.206.485.458.485.458-.218.458-.485ZM11.316 15.547c0-.268-.207-.486-.459-.486s-.458.219-.458.486.206.485.458.485c.253 0 .459-.218.459-.485ZM12.462 22.834c0 .134.103.243.229.243s.23-.11.23-.243c0-.134-.104-.243-.23-.243s-.23.11-.23.243ZM15.67 19.433c0 .134.104.243.23.243s.229-.11.229-.243-.103-.243-.23-.243c-.125 0-.228.11-.228.243ZM14.066 17.49c0 .267.207.486.459.486s.458-.219.458-.486-.206-.486-.458-.486-.459.219-.459.486ZM15.67 17.49c0 .134.104.243.23.243s.229-.11.229-.243c0-.134-.103-.243-.23-.243-.125 0-.228.11-.228.243ZM14.066 19.433c0 .268.207.486.459.486s.458-.218.458-.486c0-.267-.206-.486-.458-.486s-.459.22-.459.486ZM9.482 15.547c0-.268-.206-.486-.458-.486s-.459.219-.459.486.207.485.459.485.458-.218.458-.485ZM13.379 19.433c0-.403-.307-.729-.688-.729-.38 0-.688.326-.688.73 0 .402.307.728.688.728.38 0 .688-.325.688-.729ZM11.316 21.377c0-.268-.207-.486-.459-.486s-.458.218-.458.486c0 .267.206.485.458.485.253 0 .459-.218.459-.485ZM9.482 21.377c0-.268-.206-.486-.458-.486s-.459.218-.459.486c0 .267.207.485.459.485s.458-.218.458-.485ZM13.15 21.377c0-.268-.207-.486-.459-.486s-.458.218-.458.486c0 .267.206.485.458.485s.458-.218.458-.485ZM11.087 22.834c0-.134-.104-.243-.23-.243s-.229.11-.229.243c0 .134.103.243.23.243.125 0 .229-.11.229-.243ZM14.983 21.377c0-.268-.206-.486-.458-.486s-.459.218-.459.486c0 .267.207.485.459.485s.458-.218.458-.485ZM11.545 17.49c0-.403-.307-.729-.688-.729-.38 0-.687.326-.687.729 0 .403.307.729.687.729.38 0 .688-.326.688-.73ZM9.482 17.49c0-.267-.206-.486-.458-.486s-.459.219-.459.486.207.486.459.486.458-.219.458-.486ZM13.379 17.49c0-.403-.307-.729-.688-.729-.38 0-.688.326-.688.729 0 .403.307.729.688.729.38 0 .688-.326.688-.73ZM9.482 19.433c0-.267-.206-.486-.458-.486s-.459.22-.459.486c0 .268.207.486.459.486s.458-.218.458-.486ZM7.878 19.433c0-.133-.103-.243-.23-.243-.125 0-.229.11-.229.243 0 .134.104.243.23.243s.229-.11.229-.243ZM11.545 19.433c0-.403-.307-.729-.688-.729-.38 0-.687.326-.687.73 0 .402.307.728.687.728.38 0 .688-.325.688-.729Z" }))), ue || (ue = u.createElement("g", { clipPath: "url(#ico-type-c2c_svg__b)", fill: "#FF5C4A", stroke: "#FF5C4A", strokeWidth: 0.3 }, u.createElement("path", { d: "M4.8 13.284a.248.248 0 0 1 .187-.088c.07 0 .136.031.186.088.024.027.044.06.057.097a.337.337 0 0 1-.057.327l-1.487 1.678a.248.248 0 0 1-.186.088.248.248 0 0 1-.186-.088l-1.487-1.678a.303.303 0 0 1-.057-.097.338.338 0 0 1 .057-.327.248.248 0 0 1 .186-.088c.07 0 .137.031.186.088l1.302 1.375 1.3-1.375ZM2.2 9.717a.248.248 0 0 1-.187.088.248.248 0 0 1-.186-.088.303.303 0 0 1-.057-.098.337.337 0 0 1 .057-.327l1.487-1.677a.248.248 0 0 1 .186-.088c.07 0 .137.031.186.088l1.487 1.677c.024.028.044.06.057.097a.337.337 0 0 1-.057.328.248.248 0 0 1-.186.088.248.248 0 0 1-.186-.088L3.499 8.34 2.2 9.717Z" }), u.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.316 15.2V7.8h.369v7.4h-.369Z" }))), de || (de = u.createElement("defs", null, u.createElement("clipPath", { id: "ico-type-c2c_svg__a" }, u.createElement("path", { fill: "#fff", transform: "rotate(90 2.038 14.962)", d: "M0 0h11.077v10.452H0z" })), u.createElement("clipPath", { id: "ico-type-c2c_svg__b" }, u.createElement("path", { fill: "#fff", transform: "rotate(90 0 7)", d: "M0 0h9v7H0z" })))));
  };
  var he, me, ve, ge;
  function be() {
    return be = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, be.apply(null, arguments);
  }
  const ye = function(e2) {
    return u.createElement("svg", be({ width: 24, height: 30, viewBox: "0 0 18 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), he || (he = u.createElement("path", { d: "M8.1 6.267c-.126 0-.229.11-.229.243 0 .134.103.243.23.243.125 0 .228-.11.228-.243s-.103-.243-.229-.243ZM8.1 4.324c-.126 0-.229.11-.229.243s.103.243.23.243c.125 0 .228-.11.228-.243 0-.134-.103-.243-.229-.243ZM11.309 9.668c-.126 0-.23.11-.23.243 0 .134.104.243.23.243s.23-.11.23-.243c0-.134-.104-.243-.23-.243ZM9.475 2.138c-.252 0-.458.218-.458.485 0 .268.206.486.458.486.253 0 .459-.218.459-.486 0-.267-.206-.485-.459-.485ZM9.475 4.081c-.252 0-.458.219-.458.486s.206.486.458.486c.253 0 .459-.219.459-.486s-.206-.486-.459-.486ZM9.475 6.024c-.252 0-.458.219-.458.486s.206.486.458.486c.253 0 .459-.219.459-.486s-.206-.486-.459-.486ZM16.352 4.81c.125 0 .229-.11.229-.243 0-.134-.104-.243-.23-.243s-.229.11-.229.243.103.243.23.243ZM13.143 1.409c.126 0 .229-.11.229-.243 0-.134-.103-.243-.23-.243-.125 0-.229.11-.229.243 0 .134.104.243.23.243ZM11.309 3.11c.252 0 .458-.22.458-.486 0-.268-.206-.486-.458-.486s-.458.218-.458.486c0 .267.206.485.458.485ZM11.309 1.409c.126 0 .23-.11.23-.243 0-.134-.104-.243-.23-.243s-.23.11-.23.243c0 .134.104.243.23.243ZM13.143 3.11c.252 0 .458-.22.458-.486 0-.268-.206-.486-.458-.486-.253 0-.459.218-.459.486 0 .267.207.485.459.485ZM9.475 7.968c-.252 0-.458.218-.458.485 0 .268.206.486.458.486.253 0 .459-.218.459-.486 0-.267-.206-.485-.459-.485ZM13.143 3.838c-.38 0-.688.326-.688.729 0 .403.307.729.688.729.38 0 .687-.326.687-.73 0-.402-.307-.728-.687-.728ZM14.976 6.024c-.252 0-.458.219-.458.486s.206.486.458.486.459-.219.459-.486-.207-.486-.459-.486ZM14.976 7.968c-.252 0-.458.218-.458.485 0 .268.206.486.458.486s.459-.218.459-.486c0-.267-.207-.485-.459-.485ZM14.976 4.081c-.252 0-.458.219-.458.486s.206.486.458.486.459-.219.459-.486-.207-.486-.459-.486ZM16.352 6.267c-.127 0-.23.11-.23.243 0 .134.103.243.23.243.125 0 .229-.11.229-.243s-.104-.243-.23-.243ZM14.976 2.138c-.252 0-.458.218-.458.485 0 .268.206.486.458.486s.459-.218.459-.486c0-.267-.207-.485-.459-.485ZM11.309 5.781c-.38 0-.688.326-.688.73 0 .402.307.728.688.728.38 0 .688-.326.688-.729 0-.403-.307-.729-.688-.729ZM11.309 7.968c-.252 0-.458.218-.458.485 0 .268.206.486.458.486s.458-.218.458-.486c0-.267-.206-.485-.458-.485ZM11.309 3.838c-.38 0-.688.326-.688.729 0 .403.307.729.688.729.38 0 .688-.326.688-.73 0-.402-.307-.728-.688-.728ZM13.143 7.968c-.253 0-.459.218-.459.485 0 .268.207.486.459.486s.458-.218.458-.486c0-.267-.206-.485-.458-.485ZM13.143 9.668c-.126 0-.23.11-.23.243 0 .134.104.243.23.243s.229-.11.229-.243c0-.134-.103-.243-.23-.243ZM13.143 5.781c-.38 0-.688.326-.688.73 0 .402.307.728.688.728.38 0 .687-.326.687-.729 0-.403-.307-.729-.687-.729Z" })), me || (me = u.createElement("g", { clipPath: "url(#ico-type-abap_svg__a)", fill: "#FF5C4A", stroke: "#FF5C4A", strokeWidth: 0.3 }, u.createElement("path", { d: "M4.8 13.284a.248.248 0 0 1 .187-.088c.07 0 .136.031.186.088.024.027.044.06.057.097a.337.337 0 0 1-.057.327l-1.487 1.678a.248.248 0 0 1-.186.088.248.248 0 0 1-.186-.088l-1.487-1.678a.303.303 0 0 1-.057-.097.338.338 0 0 1 .057-.327.248.248 0 0 1 .186-.088c.07 0 .137.031.186.088l1.302 1.375 1.3-1.375ZM2.2 9.717a.248.248 0 0 1-.187.088.248.248 0 0 1-.186-.088.303.303 0 0 1-.057-.098.337.337 0 0 1 .057-.327l1.487-1.677a.248.248 0 0 1 .186-.088c.07 0 .137.031.186.088l1.487 1.677c.024.028.044.06.057.097a.337.337 0 0 1-.057.328.248.248 0 0 1-.186.088.248.248 0 0 1-.186-.088L3.499 8.34 2.2 9.717Z" }), u.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.316 15.2V7.8h.369v7.4h-.369Z" }))), ve || (ve = u.createElement("path", { d: "m10.617 15.215 1.608.91 1.608-.91-1.608-.909-1.608.91ZM14.3 15.48l-1.609.908 1.608.91 1.608-.91-1.608-.909ZM14.07 17.695l-1.615-.913v4.448l1.615.914v-4.449ZM10.15 17.967l-1.607.91 1.608.909 1.607-.91-1.607-.909ZM11.995 18.483v-1.96l-1.615-.914v1.96l1.615.914ZM14.529 17.695v4.449l1.615-.913v-4.449l-1.615.913ZM10.38 20.183v1.96l1.615-.913v-1.96l-1.615.913ZM9.921 20.183l-1.615-.913v1.96l1.615.914v-1.96Z" })), ge || (ge = u.createElement("defs", null, u.createElement("clipPath", { id: "ico-type-abap_svg__a" }, u.createElement("path", { fill: "#fff", transform: "rotate(90 0 7)", d: "M0 0h9v7H0z" })))));
  };
  var xe;
  function we() {
    return we = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, we.apply(null, arguments);
  }
  const Ce = function(e2) {
    return u.createElement("svg", we({ width: 24, height: 24, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), xe || (xe = u.createElement("path", { d: "M16 3.75v1.5c0 .199-.082.39-.228.53a.793.793 0 0 1-.55.22H2V3h13.222c.206 0 .404.079.55.22.146.14.228.331.228.53Zm-4.669 4.5v1.5c0 .199-.082.39-.228.53a.793.793 0 0 1-.55.22H2v-3h8.553c.206 0 .404.079.55.22.146.14.228.331.228.53Zm-4.668 4.5v1.5c0 .199-.082.39-.228.53a.793.793 0 0 1-.55.22H2v-3h3.884c.207 0 .405.079.55.22.147.14.229.331.229.53Z" })));
  };
  var Se, Ee, Ie;
  function Me() {
    return Me = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, Me.apply(null, arguments);
  }
  const Oe = function(e2) {
    return u.createElement("svg", Me({ width: 24, height: 24, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), Se || (Se = u.createElement("path", { d: "M14.52 6.073h-.3V5.96c0-.508-.2-.991-.563-1.36l-1.702-1.733a2.095 2.095 0 0 0-1.488-.617H5.01c-.678 0-1.23.532-1.23 1.187v2.636h-.3c-.678 0-1.23.533-1.23 1.187v4.746c0 .654.552 1.186 1.23 1.186h.3v1.371c0 .655.552 1.187 1.23 1.187h7.98c.678 0 1.23-.532 1.23-1.187v-1.37h.3c.678 0 1.23-.533 1.23-1.187V7.26c0-.654-.552-1.187-1.23-1.187ZM4.6 3.437c0-.219.184-.396.41-.396h5.457c.336 0 .662.135.893.37l1.703 1.733c.217.221.337.511.337.816v.113H4.6V3.437Zm8.8 11.127a.403.403 0 0 1-.41.395H5.01a.403.403 0 0 1-.41-.396v-1.37h8.8v1.37Zm1.53-2.558a.403.403 0 0 1-.41.395H3.48a.403.403 0 0 1-.41-.395V7.26c0-.218.184-.396.41-.396h11.04c.226 0 .41.178.41.396v4.746Z" })), Ee || (Ee = u.createElement("path", { d: "M3 6.75h12v6H3v-6Z" })), Ie || (Ie = u.createElement("path", { d: "M12.994 10.368c0 .412-.206.617-.617.617h-1.022c-.412 0-.617-.205-.617-.617V9.064c0-.411.205-.617.617-.617h1.022c.411 0 .617.206.617.617v.176c0 .06-.03.088-.088.088h-.388c-.059 0-.088-.029-.088-.088v-.105c0-.13-.065-.194-.194-.194h-.74c-.13 0-.194.064-.194.194v1.163c0 .13.064.194.194.194h.74c.13 0 .194-.065.194-.194v-.23h-.458c-.06 0-.089-.029-.089-.087v-.318c0-.058.03-.088.089-.088h.934c.058 0 .088.03.088.088v.705ZM8.775 9.434l-.423 1.428a.15.15 0 0 1-.042.063c-.02.017-.046.025-.082.025h-.282c-.035 0-.062-.008-.08-.025a.15.15 0 0 1-.043-.063L7.136 8.57c-.02-.06-.001-.089.053-.089h.405c.066 0 .107.03.123.089l.388 1.374h.035l.388-1.374c.017-.06.058-.089.123-.089h.282c.066 0 .107.03.124.089l.388 1.374h.035l.388-1.374c.016-.06.057-.089.123-.089h.405c.054 0 .072.03.053.089l-.687 2.29a.15.15 0 0 1-.042.064c-.02.017-.046.025-.082.025h-.282c-.065 0-.106-.03-.123-.088L8.81 9.434h-.035ZM6.23 8.482c.41 0 .617.206.617.617v1.234c0 .411-.206.617-.617.617H4.679c-.06 0-.088-.03-.088-.088V8.57c0-.06.029-.089.088-.089h1.55Zm-1.075 1.975h.934c.129 0 .194-.065.194-.194V9.17c0-.13-.065-.194-.194-.194h-.934v1.48Z", fill: "#fff" })));
  };
  var Le, ke, Ne;
  function Ze() {
    return Ze = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, Ze.apply(null, arguments);
  }
  const Pe = function(e2) {
    return u.createElement("svg", Ze({ width: 24, height: 24, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), Le || (Le = u.createElement("path", { d: "M14.52 6.073h-.3V5.96c0-.508-.2-.991-.563-1.36l-1.702-1.733a2.095 2.095 0 0 0-1.488-.617H5.01c-.678 0-1.23.532-1.23 1.187v2.636h-.3c-.678 0-1.23.533-1.23 1.187v4.746c0 .654.552 1.186 1.23 1.186h.3v1.371c0 .655.552 1.187 1.23 1.187h7.98c.678 0 1.23-.532 1.23-1.187v-1.37h.3c.678 0 1.23-.533 1.23-1.187V7.26c0-.654-.552-1.187-1.23-1.187ZM4.6 3.437c0-.219.184-.396.41-.396h5.457c.336 0 .662.135.893.37l1.703 1.733c.217.221.337.511.337.816v.113H4.6V3.437Zm8.8 11.127a.403.403 0 0 1-.41.395H5.01a.403.403 0 0 1-.41-.396v-1.37h8.8v1.37Zm1.53-2.558a.403.403 0 0 1-.41.395H3.48a.403.403 0 0 1-.41-.395V7.26c0-.218.184-.396.41-.396h11.04c.226 0 .41.178.41.396v4.746Z" })), ke || (ke = u.createElement("path", { d: "M3 6.75h12v6H3v-6Z" })), Ne || (Ne = u.createElement("path", { d: "M11.279 10.95a.15.15 0 0 1-.088-.025.154.154 0 0 1-.053-.063l-.635-1.393h-.035v1.393c0 .059-.03.088-.088.088h-.388c-.059 0-.088-.03-.088-.088V8.57c0-.06.03-.089.088-.089h.511a.15.15 0 0 1 .088.025.154.154 0 0 1 .053.064l.723 1.586h.035l.723-1.586a.154.154 0 0 1 .053-.064.15.15 0 0 1 .088-.025h.51c.06 0 .089.03.089.089v2.29c0 .06-.03.089-.088.089h-.388c-.059 0-.088-.03-.088-.088V9.469h-.035l-.635 1.393a.154.154 0 0 1-.053.063.15.15 0 0 1-.088.025h-.211ZM8.034 10.457h1.392c.06 0 .089.029.089.088v.317c0 .059-.03.088-.089.088H7.558c-.059 0-.088-.03-.088-.088V8.57c0-.06.03-.089.088-.089h1.833c.059 0 .088.03.088.089v.317c0 .059-.03.088-.088.088H8.034v.476h1.04c.059 0 .088.03.088.088v.317c0 .059-.03.088-.088.088h-1.04v.511ZM6.324 8.482c.412 0 .617.206.617.617v1.234c0 .411-.205.617-.617.617h-1.55c-.06 0-.089-.03-.089-.088V8.57c0-.06.03-.089.088-.089h1.551ZM5.25 10.457h.934c.13 0 .194-.065.194-.194V9.17c0-.13-.064-.194-.194-.194H5.25v1.48Z", fill: "#fff" })));
  };
  var De, Te, je;
  function Re() {
    return Re = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, Re.apply(null, arguments);
  }
  const ze = function(e2) {
    return u.createElement("svg", Re({ width: 24, height: 24, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), De || (De = u.createElement("path", { d: "M14.52 6.073h-.3V5.96c0-.508-.2-.991-.563-1.36l-1.702-1.733a2.095 2.095 0 0 0-1.488-.617H5.01c-.678 0-1.23.532-1.23 1.187v2.636h-.3c-.678 0-1.23.533-1.23 1.187v4.746c0 .654.552 1.186 1.23 1.186h.3v1.371c0 .655.552 1.187 1.23 1.187h7.98c.678 0 1.23-.532 1.23-1.187v-1.37h.3c.678 0 1.23-.533 1.23-1.187V7.26c0-.654-.552-1.187-1.23-1.187ZM4.6 3.437c0-.219.184-.396.41-.396h5.457c.336 0 .662.135.893.37l1.703 1.733c.217.221.337.511.337.816v.113H4.6V3.437Zm8.8 11.127a.403.403 0 0 1-.41.395H5.01a.403.403 0 0 1-.41-.396v-1.37h8.8v1.37Zm1.53-2.558a.403.403 0 0 1-.41.395H3.48a.403.403 0 0 1-.41-.395V7.26c0-.218.184-.396.41-.396h11.04c.226 0 .41.178.41.396v4.746Z" })), Te || (Te = u.createElement("path", { d: "M3 6.75h12v6H3v-6Z" })), je || (je = u.createElement("path", { d: "M11.778 10.862c0 .059-.029.088-.088.088h-.387c-.06 0-.089-.03-.089-.088V8.976h-.705c-.058 0-.088-.03-.088-.088V8.57c0-.06.03-.089.088-.089h1.974c.06 0 .088.03.088.089v.317c0 .059-.029.088-.088.088h-.705v1.886ZM10.178 9.558c0 .134-.021.24-.064.317a.582.582 0 0 1-.13.173.447.447 0 0 1-.194.091l.406.723c.014.026.015.047.003.063-.012.017-.03.025-.056.025H9.72a.15.15 0 0 1-.088-.025.2.2 0 0 1-.053-.063l-.37-.688h-.617v.688c0 .059-.03.088-.088.088h-.388c-.059 0-.088-.03-.088-.088V8.57c0-.06.03-.089.088-.089H9.56c.411 0 .617.206.617.617v.459Zm-1.586-.582v.705h.828c.13 0 .194-.065.194-.194V9.17c0-.13-.065-.194-.194-.194h-.828ZM7.5 10.368c0 .412-.206.617-.618.617H5.807c-.411 0-.617-.205-.617-.617V9.064c0-.411.206-.617.617-.617h1.075c.412 0 .617.206.617.617v1.304Zm-.565-1.233c0-.13-.064-.194-.194-.194h-.793c-.129 0-.194.064-.194.194v1.163c0 .13.065.194.194.194h.793c.13 0 .194-.065.194-.194V9.135Z", fill: "#fff" })));
  };
  var Fe = (0, p.makeStyles)(function(e2) {
    return { documentIcon: { width: "24px", height: "24px", display: "flex", justifyContent: "center", alignItems: "center" } };
  }), He = function(e2) {
    var t2 = e2.type, n2 = Fe(), r2 = (0, p.useTheme)();
    return d().createElement("div", { className: n2.documentIcon }, (function(e3, t3) {
      switch (void 0 === t3 && (t3 = "#3c4051"), e3) {
        case "abap":
          return d().createElement(ye, { fill: t3 });
        case "bim":
        case "bimv2":
        case "bimv3":
          return d().createElement(S, { fill: t3 });
        case "c2c":
          return d().createElement(fe, { fill: t3 });
        case "c2s":
          return d().createElement(ie, { fill: t3 });
        case "cloud":
          return d().createElement(M, { fill: t3 });
        case "deviation":
          return d().createElement(te, { fill: t3 });
        case "docx":
        case "docx_template":
        case "docx_maf":
          return d().createElement(V, { fill: t3 });
        case "dxf":
          return d().createElement(J, { fill: t3 });
        case "folder":
        case "project":
        case "root":
          return d().createElement(g, { fill: t3 });
        case "ksg":
          return d().createElement(Ce, { fill: t3 });
        case "pdf":
          return d().createElement(z, { fill: t3 });
        case "surface":
          return d().createElement(k, { fill: t3 });
        case "workspace":
          return d().createElement(P, { fill: t3 });
        case "xlsx":
          return d().createElement(G, { fill: t3 });
        case "dwg":
          return d().createElement(Oe, { fill: t3 });
        case "dem":
          return d().createElement(Pe, { fill: t3 });
        case "orthophoto":
          return d().createElement(ze, { fill: t3 });
        default:
          return d().createElement(x, { fill: t3 });
      }
    })(t2, r2.palette.text.primary));
  };
  function We(e2) {
    var t2, n2, r2 = "";
    if ("string" == typeof e2 || "number" == typeof e2) r2 += e2;
    else if ("object" == typeof e2) if (Array.isArray(e2)) for (t2 = 0; t2 < e2.length; t2++) e2[t2] && (n2 = We(e2[t2])) && (r2 && (r2 += " "), r2 += n2);
    else for (t2 in e2) e2[t2] && (r2 && (r2 += " "), r2 += t2);
    return r2;
  }
  function Ae() {
    for (var e2, t2, n2 = 0, r2 = ""; n2 < arguments.length; ) (e2 = arguments[n2++]) && (t2 = We(e2)) && (r2 && (r2 += " "), r2 += t2);
    return r2;
  }
  var Ve = (0, p.makeStyles)(function(e2) {
    return { iconButton: { width: "24px", height: "24px", borderRadius: "50%", cursor: "pointer", transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms", display: "flex", justifyContent: "center", alignItems: "center", "&:hover": { backgroundColor: e2.palette.action.hover } }, disabled: { opacity: "0.5", pointerEvents: "none", cursor: "default" } };
  }), _e = function(e2) {
    var t2, n2 = e2.children, r2 = e2.className, a2 = e2.disabled, l2 = e2.onClick, o2 = e2.style, i2 = Ve();
    return d().createElement("div", { className: Ae(i2.iconButton, r2, (t2 = {}, t2[i2.disabled] = a2, t2)), style: o2, onClick: function(e3) {
      l2 && !a2 && l2(e3);
    } }, n2);
  }, Be = function() {
    return Be = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, Be.apply(this, arguments);
  }, qe = (0, p.makeStyles)(function(e2) {
    return { treeItem: { boxSizing: "border-box", textAlign: "left", cursor: "pointer" }, name: { padding: "5px 0 5px 10px" }, highlighted: {}, ".highlighted > name": { background: "#73747c", color: "#fff" } };
  }), Ue = function(e2) {
    var t2 = e2.data, n2 = e2.itemElement, r2 = e2.offsetPerLevel, a2 = (e2.isSelectionEnabled, e2.isDragEnabled), l2 = void 0 !== a2 && a2, o2 = e2.onDragStart, i2 = e2.onDragEnd, c2 = e2.onDrop, s2 = e2.onHighlight, u2 = e2.onSelect, p2 = e2.onExpand, f2 = e2.contentRef, h2 = qe();
    return d().createElement("div", Be({ className: h2.treeItem, onClick: function(e3) {
      e3.stopPropagation(), null == p2 || p2(t2.id), u2(t2.id);
    }, onDragEnter: function(e3) {
      t2.isDroppable && (t2.isFolder ? s2(t2.id) : s2(t2.parentId));
    }, onDragLeave: function(e3) {
      e3.preventDefault(), e3.stopPropagation(), e3.dataTransfer.dropEffect = "move";
    } }, l2 && t2.isDraggable && { draggable: true, onDragStart: function(e3) {
      e3.dataTransfer.effectAllowed = "move", e3.dataTransfer.setData("text/plain", t2.id), null == o2 || o2(t2.id);
    }, onDragEnd: function(e3) {
      s2(null), null == i2 || i2();
    } }, l2 && t2.isDroppable && { onDragOver: function(e3) {
      e3.preventDefault(), e3.stopPropagation(), e3.dataTransfer.dropEffect = "move";
    }, onDrop: function(e3) {
      e3.preventDefault(), e3.stopPropagation();
      var n3 = t2.isFolder ? t2.id : t2.parentId, r3 = e3.dataTransfer.getData("text/plain"), a3 = e3.dataTransfer.files;
      r3 && r3 !== n3 ? null == c2 || c2(n3, { recordId: r3 }) : a3 && (null == c2 || c2(n3, { files: a3 }));
    } }, { ref: f2 }), n2 || d().createElement("div", { className: h2.name, style: { paddingLeft: "".concat(t2.level * r2, "px") } }, t2.name));
  };
  const Ge = Ue;
  var Ke, Ye = function() {
    return Ye = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, Ye.apply(this, arguments);
  }, Xe = (0, p.makeStyles)(function(e2) {
    return { tree: { position: "relative" }, treeContent: { position: "relative" } };
  }), Je = function(e2) {
    var t2 = e2.items, n2 = e2.Item, r2 = e2.offsetPerLevel, a2 = void 0 === r2 ? 24 : r2, l2 = e2.isDragEnabled, o2 = void 0 !== l2 && l2, i2 = e2.isSelectionEnabled, c2 = void 0 !== i2 && i2, s2 = e2.onAction, u2 = e2.onDragStart, p2 = e2.onDragEnd, f2 = e2.onDrop, h2 = e2.onHighlight, m2 = e2.onSelect, v2 = e2.onEdit, g2 = (e2.onExpand, e2.onCollapse), b2 = e2.contentRef, y2 = e2.scrollToId, x2 = void 0 === y2 ? null : y2, w2 = Xe(), C2 = function(e3) {
      null == u2 || u2(e3);
    }, S2 = function() {
      null == p2 || p2();
    }, E2 = function(e3, t3) {
      null == f2 || f2(e3, t3);
    }, I2 = function(e3) {
      h2(e3);
    }, M2 = function(e3) {
      m2(e3);
    }, O2 = function(e3) {
      v2(e3);
    }, L2 = function(e3) {
      g2(e3);
    };
    return d().createElement("div", { className: w2.tree }, d().createElement("div", { className: w2.treeContent }, t2.map(function(e3) {
      return d().createElement(Ge, Ye({ itemElement: d().createElement(n2, { data: e3, offsetPerLevel: a2, isSelectionEnabled: c2, onSelect: M2, onEdit: O2, onAction: s2 }), data: e3, offsetPerLevel: a2, isSelectionEnabled: c2, isDragEnabled: o2 }, o2 && { onDragStart: C2, onDragEnd: S2, onDrop: E2 }, { onHighlight: I2, onSelect: M2, onCollapse: L2, key: e3.id }, e3.id === x2 && { contentRef: b2 }));
    })));
  }, $e = function(e2, t2, n2) {
    if (n2 || 2 === arguments.length) for (var r2, a2 = 0, l2 = t2.length; a2 < l2; a2++) !r2 && a2 in t2 || (r2 || (r2 = Array.prototype.slice.call(t2, 0, a2)), r2[a2] = t2[a2]);
    return e2.concat(r2 || Array.prototype.slice.call(t2));
  }, Qe = (0, p.makeStyles)(function(e2) {
    return { itemTree: { backgroundColor: e2.palette.background.paper, userSelect: "none" } };
  }), et = function(e2) {
    var t2, n2, r2, a2 = e2.Item, l2 = e2.items, o2 = e2.activeId, i2 = e2.selectedIds, c2 = e2.rootId, s2 = e2.openedPath, p2 = e2.multiselect, f2 = void 0 !== p2 && p2, h2 = e2.searchValue, m2 = void 0 === h2 ? "" : h2, v2 = e2.sort, g2 = void 0 === v2 ? { by: "name", order: "ASC" } : v2, b2 = e2.onAction, y2 = e2.filteredIds, x2 = e2.saveTreeState, w2 = e2.isSelectable, C2 = (0, u.useState)(null), S2 = C2[0], E2 = C2[1], I2 = (0, u.useState)(null != s2 ? s2 : []), M2 = I2[0], O2 = I2[1], L2 = (0, u.useState)(null != i2 ? i2 : []), k2 = L2[0], N2 = L2[1], Z2 = (0, u.useState)([]), P2 = (Z2[0], Z2[1], (0, u.useState)("")), D2 = P2[0], T2 = P2[1], j2 = (0, u.useState)([]), R2 = j2[0], z2 = j2[1], F2 = (0, u.useState)(null), H2 = F2[0], W2 = F2[1], A2 = (0, u.useState)(null), V2 = A2[0], _2 = A2[1], B2 = (0, u.useRef)(null), q2 = Qe(), U2 = [], G2 = (0, u.useState)([]), K2 = G2[0], Y2 = G2[1];
    (0, u.useEffect)(function() {
      var e3 = l2.filter(function(e4) {
        return !e4.hasChildren && !M2.includes(e4.id);
      }).map(function(e4) {
        return e4.id;
      });
      O2(function(t4) {
        return $e($e([], t4, true), e3, true);
      });
      var t3 = l2.filter(function(e4) {
        return e4.hasChildren && !K2.includes(e4.id);
      }).map(function(e4) {
        return e4.id;
      });
      Y2(function(e4) {
        return $e($e([], e4, true), t3, true);
      });
    }, [l2.length]), t2 = function() {
      N2([]);
    }, n2 = [f2], r2 = (0, u.useRef)(false), (0, u.useEffect)(function() {
      if (r2.current) return t2();
      r2.current = true;
    }, n2), (0, u.useEffect)(function() {
      if (s2) {
        var e3 = s2.slice().pop();
        _2(e3 || null);
      }
    }, [s2]), (0, u.useEffect)(function() {
      var e3;
      V2 && (null === (e3 = null == B2 ? void 0 : B2.current) || void 0 === e3 || e3.scrollIntoView({ behavior: "smooth", block: "center" }));
    }, [V2]), (0, u.useEffect)(function() {
      "" !== m2 && O2([]);
    }, [m2]), (0, u.useEffect)(function() {
      var e3 = y2, t3 = [];
      e3 && l2.filter(function(t4) {
        return e3.includes(t4.id);
      }).map(function(e4) {
        return e4.fullPathIds;
      }).forEach(function(e4) {
        t3 = $e($e([], t3, true), e4, true);
      }), z2(t3);
    }, [y2.length]);
    var X2 = (0, u.useRef)(M2);
    (0, u.useEffect)(function() {
      return function() {
        null == x2 || x2(X2.current);
      };
    }, []), (0, u.useEffect)(function() {
      X2.current = M2;
    }, [M2]);
    var J2 = function(e3, t3) {
      var n3 = new Intl.Collator("en", { numeric: true, sensitivity: "base" }), r3 = l2.filter(function(t4) {
        return t4.parentId === e3;
      }).sort(function(e4, t4) {
        if (e4.isFolder === t4.isFolder) {
          var r4 = 0, a4 = String(e4.optional[g2.by]).toLocaleLowerCase().trim(), l3 = String(t4.optional[g2.by]).toLocaleLowerCase().trim(), o3 = n3.compare(a4, l3) < 0, i3 = n3.compare(a4, l3) > 0;
          if (null != a4 && null != l3 && (o3 && (r4 = "ASC" === g2.order ? -1 : 1), i3 && (r4 = "ASC" === g2.order ? 1 : -1)), !r4) {
            var c3 = e4.name.toLocaleLowerCase(), s3 = t4.name.toLocaleLowerCase();
            c3 < s3 && (r4 = -1), c3 > s3 && (r4 = 1);
          }
          return r4;
        }
        return e4.isFolder ? -1 : t4.isFolder ? 1 : 0;
      }), a3 = [];
      y2.length > 0 ? r3.forEach(function(e4) {
        R2.includes(e4.id) && a3.push(e4);
      }) : a3 = r3, a3.forEach(function(e4) {
        var n4, a4 = e4.id, l3 = { id: a4, parentId: e4.parentId, fullPathIds: e4.fullPathIds, name: e4.name, isFolder: e4.isFolder, isDownloaded: e4.isDownloaded, isDownloading: e4.isDownloading, level: t3, isActive: a4 === o2, isHighlighted: a4 === S2, isSelected: k2.includes(a4), isSelectable: (n4 = e4, !w2 || w2(n4)), isOpened: M2.includes(a4), isInEditMode: a4 === H2, isDraggable: e4.parentId !== c2, isDroppable: !e4.fullPathIds.includes(D2), optional: e4.optional, hasChildren: K2.includes(a4) };
        y2.length > 0 && r3.forEach(function(e5) {
          R2.includes(e5.id) && l3.isFolder && (l3.isOpened = true);
        }), U2.push(l3), l3.isFolder && l3.isOpened && J2(l3.id, t3 + 1);
      });
    };
    J2(c2, 0);
    var $2 = function(e3) {
      var t3 = e3.payload.documentIds[0];
      switch (e3.type) {
        case "expand":
          O2($e($e([], M2, true), [t3], false));
          break;
        case "collapse":
          O2(M2.filter(function(e4) {
            return e4 !== t3;
          }));
      }
      null == b2 || b2(e3), W2("");
    };
    return d().createElement("div", { className: q2.itemTree }, d().createElement(Je, { items: U2, Item: a2, offsetPerLevel: 24, isDragEnabled: true, isSelectionEnabled: true, onDragStart: function(e3) {
      T2(e3);
    }, onDragEnd: function() {
      T2("");
    }, onDrop: function(e3, t3) {
      t3.recordId ? (T2(""), E2(null), $2({ type: "move", payload: { documentIds: [t3.recordId], parentId: e3 } })) : t3.files && (E2(null), $2({ type: "upload", payload: { documentIds: [e3], files: t3.files } }));
    }, onHighlight: function(e3) {
      E2(e3);
    }, onCollapse: function(e3) {
    }, onSelect: function(e3) {
      var t3;
      t3 = f2 ? k2.includes(e3) ? k2.filter(function(t4) {
        return t4 !== e3;
      }) : $e($e([], k2, true), [e3], false) : k2.includes(e3) ? [] : [e3], N2(t3), $2({ type: "select", payload: { documentIds: t3 } });
    }, onEdit: function(e3) {
      W2(e3 === H2 ? "" : e3);
    }, onAction: $2, contentRef: B2, scrollToId: V2 }));
  }, tt = (0, p.makeStyles)(function(e2) {
    return { pagination: { fontSize: "12px", color: e2.palette.text.primary, userSelect: "none", display: "flex", justifyContent: "space-between", alignItems: "center" }, details: { display: "flex", justifyContent: "flex-start", alignItems: "center" }, pages: { display: "flex", justifyContent: "flex-start", alignItems: "center" }, label: { whiteSpace: "nowrap", cursor: "default" }, option: { fontSize: "12px" }, buttons: { width: "100%", margin: "0 auto" }, button: { boxSizing: "border-box", marginLeft: "5px", width: "32px", height: "32px", backgroundColor: e2.palette.background.paper, border: "1px solid ".concat(e2.palette.divider), borderRadius: "4px", fontWeight: 600, color: e2.palette.text.primary, cursor: "pointer", display: "flex", justifyContent: "center", alignItems: "center", "&:hover": { backgroundColor: e2.palette.divider } }, current: { backgroundColor: e2.palette.primary.main, border: "1px solid ".concat(e2.palette.primary.main), color: e2.palette.background.paper, cursor: "default", "&:hover": { backgroundColor: e2.palette.primary.main } }, disabled: { opacity: 0.5, cursor: "default", "&:hover": { backgroundColor: e2.palette.background.paper } }, ellipsis: { backgroundColor: e2.palette.background.paper, borderColor: e2.palette.background.paper, cursor: "default", "&:hover": { backgroundColor: e2.palette.background.paper } }, formField: { marginLeft: "7px", marginRight: "7px", "& .MuiInputLabel-root": { transform: "translate(2px, 8px) scale(0.8)", fontSize: "10px", fontWeight: 400, color: e2.palette.text.secondary, left: 10, "&.MuiInputLabel-shrink": { transform: "translate(2px, 8px) scale(0.8)" } } }, select: { border: "1px solid ".concat(e2.palette.divider), borderRadius: "4px", background: "transparent", "&.MuiFilledInput-root.Mui-disabled ": { background: "transparent" }, "& .MuiSelect-filled": { paddingTop: "6px", paddingBottom: "5px", fontSize: "12px" }, "&:before": { content: "none" }, "&:after": { content: "none" }, "&:hover": { background: "transparent" } }, selectIcon: { top: "calc(50% - 9px)" }, menuItemIcon: { position: "absolute", right: "10px" }, menuPaper: { marginTop: "5px", maxHeight: 200 } };
  });
  function nt() {
    return nt = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, nt.apply(null, arguments);
  }
  const rt = function(e2) {
    return u.createElement("svg", nt({ xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, fill: "none" }, e2), Ke || (Ke = u.createElement("path", { d: "M12.345 6.953a.67.67 0 0 1 .478-.203.67.67 0 0 1 .479.203.69.69 0 0 1 .198.49.705.705 0 0 1-.198.488l-3.823 3.866A.671.671 0 0 1 9 12a.671.671 0 0 1-.479-.203L4.698 7.931a.688.688 0 0 1-.198-.489.705.705 0 0 1 .198-.489.67.67 0 0 1 .479-.203.67.67 0 0 1 .478.203l3.346 3.17 3.344-3.17Z" })));
  };
  var at;
  function lt() {
    return lt = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, lt.apply(null, arguments);
  }
  const ot = function(e2) {
    return u.createElement("svg", lt({ width: 16, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), at || (at = u.createElement("path", { d: "M6.94 4 6 4.94 9.053 8 6 11.06l.94.94 4-4-4-4Z" })));
  };
  var it;
  function ct() {
    return ct = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, ct.apply(null, arguments);
  }
  const st = function(e2) {
    return u.createElement("svg", ct({ width: 16, height: 16, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, e2), it || (it = u.createElement("path", { d: "m10.06 12 .94-.94L7.947 8 11 4.94 10.06 4l-4 4 4 4Z" })));
  };
  var ut = function() {
    return ut = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, ut.apply(this, arguments);
  }, dt = [{ id: "10", name: "10", value: 10 }, { id: "25", name: "25", value: 25 }, { id: "50", name: "50", value: 50 }, { id: "100", name: "100", value: 100 }], pt = function(e2) {
    var t2, n2, r2, a2, l2, o2, i2 = e2.count, c2 = e2.pageIndex, s2 = e2.rowsPerPage, u2 = e2.labelRowsPerPage, f2 = e2.labelRowsPerPageAfterSelect, h2 = e2.onChangePage, m2 = e2.onChangeRowsPerPage, v2 = e2.isLoading, g2 = void 0 !== v2 && v2, b2 = (0, p.useTheme)(), y2 = tt(), x2 = dt.find(function(e3) {
      return e3.value === s2;
    }) || dt[0], w2 = Math.ceil(i2 / s2), C2 = 0 === c2, S2 = c2 === w2 - 1 || 0 === w2, E2 = [], I2 = 0, M2 = 0, O2 = false, L2 = false;
    c2 >= 0 && c2 < 4 ? (I2 = 0, M2 = 4 < w2 - 1 ? 4 : w2 - 1, O2 = false, L2 = 4 < w2 - 1) : c2 < w2 && c2 > w2 - 5 ? (I2 = w2 - 5 > 0 ? w2 - 5 : 0, M2 = w2 - 1, O2 = w2 - 5 > 0, L2 = false) : (I2 = c2 - 1 > 0 ? c2 - 1 : 0, M2 = c2 + 1 < w2 - 1 ? c2 + 1 : w2 - 1, O2 = true, L2 = true);
    for (var k2 = I2; k2 <= M2; ) E2.push(k2 + 1), k2++;
    return d().createElement("div", { className: y2.pagination }, d().createElement("div", { className: y2.details }, d().createElement("div", { className: y2.label }, u2), d().createElement(p.FormControl, { className: y2.formField, fullWidth: true }, d().createElement(p.Select, { variant: "filled", className: y2.select, IconComponent: function(e3) {
      return d().createElement(rt, ut({}, e3, { fill: b2.palette.text.primary }));
    }, classes: { icon: y2.selectIcon }, MenuProps: { anchorOrigin: { vertical: "bottom", horizontal: "left" }, getContentAnchorEl: null, classes: { paper: y2.menuPaper } }, value: x2.name, renderValue: function(e3) {
      return e3;
    }, disabled: g2 || 0 === w2 }, dt.map(function(e3) {
      return d().createElement(p.MenuItem, { onClick: function() {
        m2(e3.value);
      }, value: e3.name, key: e3.id }, d().createElement("div", { className: y2.option }, e3.name));
    }))), d().createElement("div", { className: y2.label }, f2)), d().createElement("div", { className: y2.pages }, d().createElement("div", { className: Ae((t2 = {}, t2[y2.button] = true, t2[y2.disabled] = C2, t2)), onClick: function() {
      C2 || h2(c2 - 1);
    } }, d().createElement(st, { fill: b2.palette.text.primary })), O2 && d().createElement(d().Fragment, null, d().createElement("div", { className: Ae((n2 = {}, n2[y2.button] = true, n2[y2.current] = false, n2)), onClick: function() {
      h2(0);
    } }, "1"), d().createElement("div", { className: Ae((r2 = {}, r2[y2.button] = true, r2[y2.ellipsis] = true, r2)) }, "\u2026")), (function() {
      for (var e3 = [], t3 = function(t4) {
        var n4;
        e3.push(d().createElement("div", { className: Ae((n4 = {}, n4[y2.button] = true, n4[y2.current] = c2 === t4, n4)), onClick: function() {
          h2(t4);
        }, key: t4 }, t4 + 1));
      }, n3 = I2; n3 <= M2; n3++) t3(n3);
      return e3;
    })(), L2 && d().createElement(d().Fragment, null, d().createElement("div", { className: Ae((a2 = {}, a2[y2.button] = true, a2[y2.ellipsis] = true, a2)) }, "\u2026"), d().createElement("div", { className: Ae((l2 = {}, l2[y2.button] = true, l2)), onClick: function() {
      h2(w2 - 1);
    } }, w2)), d().createElement("div", { className: Ae((o2 = {}, o2[y2.button] = true, o2[y2.disabled] = S2, o2)), onClick: function() {
      S2 || h2(c2 + 1);
    } }, d().createElement(ot, { fill: b2.palette.text.primary }))));
  }, ft = i(375), ht = i.n(ft), mt = "#3c4051", vt = "#D3D4DC", gt = function() {
    return gt = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, gt.apply(this, arguments);
  }, bt = function(e2, t2) {
    var n2 = {};
    for (var r2 in e2) Object.prototype.hasOwnProperty.call(e2, r2) && t2.indexOf(r2) < 0 && (n2[r2] = e2[r2]);
    if (null != e2 && "function" == typeof Object.getOwnPropertySymbols) {
      var a2 = 0;
      for (r2 = Object.getOwnPropertySymbols(e2); a2 < r2.length; a2++) t2.indexOf(r2[a2]) < 0 && Object.prototype.propertyIsEnumerable.call(e2, r2[a2]) && (n2[r2[a2]] = e2[r2[a2]]);
    }
    return n2;
  };
  function yt(e2) {
    var t2 = e2.displayName, n2 = e2.path, r2 = e2.viewBox, a2 = void 0 === r2 ? "0 0 24 24" : r2, l2 = e2.defaultSize, o2 = void 0 === l2 ? 24 : l2, i2 = e2.defaultColor, c2 = void 0 === i2 ? mt : i2, s2 = (0, u.forwardRef)(function(e3, t3) {
      var r3 = e3.size, l3 = void 0 === r3 ? o2 : r3, i3 = e3.color, s3 = void 0 === i3 ? c2 : i3, u2 = e3.fill, p2 = e3.stroke, f2 = e3.className, h2 = e3.style, m2 = bt(e3, ["size", "color", "fill", "stroke", "className", "style"]), v2 = s3 !== c2 ? s3 : u2 || p2 || c2;
      return d().createElement("svg", gt({ ref: t3, width: l3, height: l3, viewBox: a2, fill: "none", xmlns: "http://www.w3.org/2000/svg", className: f2, style: h2 }, m2), n2(v2));
    });
    return s2.displayName = t2, s2;
  }
  var xt = yt({ displayName: "Chevron", path: function(e2) {
    return d().createElement("path", { d: "M14.7293 16.4599C14.9027 16.6296 15 16.8588 15 17.0976C15 17.3365 14.9027 17.5657 14.7293 17.7354C14.6441 17.8192 14.5426 17.8858 14.4307 17.9312C14.3187 17.9766 14.1986 18 14.0772 18C13.9558 18 13.8357 17.9766 13.7237 17.9312C13.6118 17.8858 13.5103 17.8192 13.4251 17.7354L8.27028 12.6384C8.0971 12.4683 8 12.239 8 12C8 11.761 8.0971 11.5317 8.27028 11.3616L13.4251 6.26458C13.5103 6.18079 13.6118 6.11424 13.7237 6.06882C13.8357 6.02339 13.9558 6 14.0772 6C14.1986 6 14.3187 6.02339 14.4307 6.06882C14.5426 6.11424 14.6441 6.18079 14.7293 6.26458C14.9027 6.43431 15 6.66351 15 6.90236C15 7.14121 14.9027 7.37041 14.7293 7.54014L10.5018 12.002L14.7293 16.4599Z", fill: e2 });
  } }), wt = function() {
    return wt = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, wt.apply(this, arguments);
  }, Ct = (0, u.forwardRef)(function(e2, t2) {
    var n2 = e2.style, r2 = (function(e3, t3) {
      var n3 = {};
      for (var r3 in e3) Object.prototype.hasOwnProperty.call(e3, r3) && t3.indexOf(r3) < 0 && (n3[r3] = e3[r3]);
      if (null != e3 && "function" == typeof Object.getOwnPropertySymbols) {
        var a2 = 0;
        for (r3 = Object.getOwnPropertySymbols(e3); a2 < r3.length; a2++) t3.indexOf(r3[a2]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, r3[a2]) && (n3[r3[a2]] = e3[r3[a2]]);
      }
      return n3;
    })(e2, ["style"]);
    return d().createElement(xt, wt({ ref: t2, style: wt({ transform: "rotate(-90deg)" }, n2) }, r2));
  });
  Ct.displayName = "ChevronDown";
  var St = function() {
    return St = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, St.apply(this, arguments);
  }, Et = (0, u.forwardRef)(function(e2, t2) {
    return d().createElement(xt, St({ ref: t2 }, e2));
  });
  Et.displayName = "ChevronLeft";
  var It = function() {
    return It = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, It.apply(this, arguments);
  }, Mt = (0, u.forwardRef)(function(e2, t2) {
    var n2 = e2.style, r2 = (function(e3, t3) {
      var n3 = {};
      for (var r3 in e3) Object.prototype.hasOwnProperty.call(e3, r3) && t3.indexOf(r3) < 0 && (n3[r3] = e3[r3]);
      if (null != e3 && "function" == typeof Object.getOwnPropertySymbols) {
        var a2 = 0;
        for (r3 = Object.getOwnPropertySymbols(e3); a2 < r3.length; a2++) t3.indexOf(r3[a2]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, r3[a2]) && (n3[r3[a2]] = e3[r3[a2]]);
      }
      return n3;
    })(e2, ["style"]);
    return d().createElement(xt, It({ ref: t2, style: It({ transform: "rotate(180deg)" }, n2) }, r2));
  });
  Mt.displayName = "ChevronRight";
  var Ot = function() {
    return Ot = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, Ot.apply(this, arguments);
  }, Lt = (0, u.forwardRef)(function(e2, t2) {
    var n2 = e2.style, r2 = (function(e3, t3) {
      var n3 = {};
      for (var r3 in e3) Object.prototype.hasOwnProperty.call(e3, r3) && t3.indexOf(r3) < 0 && (n3[r3] = e3[r3]);
      if (null != e3 && "function" == typeof Object.getOwnPropertySymbols) {
        var a2 = 0;
        for (r3 = Object.getOwnPropertySymbols(e3); a2 < r3.length; a2++) t3.indexOf(r3[a2]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, r3[a2]) && (n3[r3[a2]] = e3[r3[a2]]);
      }
      return n3;
    })(e2, ["style"]);
    return d().createElement(xt, Ot({ ref: t2, style: Ot({ transform: "rotate(90deg)" }, n2) }, r2));
  });
  Lt.displayName = "ChevronUp";
  var kt = yt({ displayName: "Circle", viewBox: "0 0 18 18", defaultSize: 18, defaultColor: vt, path: function(e2) {
    return d().createElement("circle", { cx: "9", cy: "9", r: "5.25", stroke: e2, strokeWidth: "1.5" });
  } }), Nt = yt({ displayName: "CircleChecked", viewBox: "0 0 18 18", defaultSize: 18, path: function(e2) {
    return d().createElement(d().Fragment, null, d().createElement("circle", { cx: "9", cy: "9", r: "5.25", stroke: e2, strokeWidth: "1.5" }), d().createElement("circle", { cx: "9", cy: "9", r: "2.25", fill: e2 }));
  } }), Zt = yt({ displayName: "Close", viewBox: "0 0 18 18", defaultSize: 18, path: function(e2) {
    return d().createElement("path", { d: "M8.99988 10.1933L12.3397 13.5331C12.498 13.6916 12.7127 13.7808 12.9366 13.781C13.1606 13.7812 13.3755 13.6924 13.534 13.5342C13.6925 13.3759 13.7816 13.1612 13.7818 12.9373C13.782 12.7133 13.6933 12.4984 13.535 12.3399L10.1952 9.00006L13.535 5.66022C13.6935 5.50171 13.7826 5.28672 13.7826 5.06256C13.7826 4.8384 13.6935 4.62341 13.535 4.4649C13.3765 4.3064 13.1615 4.21735 12.9374 4.21735C12.7132 4.21735 12.4982 4.3064 12.3397 4.4649L8.99988 7.80475L5.66003 4.4649C5.50153 4.30639 5.28654 4.21735 5.06238 4.21735C4.83821 4.21735 4.62323 4.30639 4.46472 4.4649C4.30621 4.62341 4.21717 4.83839 4.21717 5.06256C4.21717 5.28672 4.30621 5.50171 4.46472 5.66022L7.80457 9.00006L4.46472 12.3399C4.30621 12.4984 4.21716 12.7134 4.21716 12.9376C4.21716 13.1617 4.30621 13.3767 4.46472 13.5352C4.62323 13.6937 4.83821 13.7828 5.06238 13.7828C5.28654 13.7828 5.50153 13.6937 5.66003 13.5352L8.99988 10.1933Z", fill: e2 });
  } }), Pt = yt({ displayName: "Funnel", viewBox: "0 0 18 18", defaultSize: 18, path: function(e2) {
    return d().createElement("path", { d: "M16.2 4.01253C16.1999 3.70995 16.0824 3.41921 15.8723 3.20143C15.6623 2.98365 15.376 2.85578 15.0736 2.84469V2.84253H3.03266V2.84577C3.01178 2.84469 2.99108 2.84253 2.97002 2.84253C2.72805 2.84269 2.49208 2.91786 2.29461 3.0577C2.09714 3.19754 1.94789 3.39516 1.8674 3.62335C1.78692 3.85154 1.77916 4.09908 1.8452 4.33186C1.91124 4.56464 2.04783 4.77122 2.23616 4.92315L7.66136 10.3482L7.66118 13.696V13.7237H7.66388C7.66842 13.8269 7.6991 13.9273 7.75302 14.0155C7.80695 14.1036 7.88237 14.1767 7.97222 14.2277L7.9706 14.2306L9.38756 15.0487C9.39944 15.057 9.41258 15.0629 9.425 15.0703L9.43004 15.0732V15.073C9.5204 15.1252 9.62408 15.1574 9.73604 15.1574C9.81679 15.1574 9.89676 15.1415 9.97137 15.1107C10.046 15.0798 10.1138 15.0345 10.1709 14.9774C10.228 14.9203 10.2733 14.8525 10.3042 14.7779C10.3351 14.7032 10.3509 14.6233 10.3509 14.5425C10.3509 14.5263 10.3473 14.511 10.3462 14.4952H10.3509V10.3532L15.826 4.87833L15.8206 4.87293C15.9401 4.76376 16.0356 4.63086 16.101 4.48272C16.1663 4.33457 16.2 4.17444 16.2 4.01253ZM5.80484 5.18253H5.80736L5.80754 5.18523L5.80484 5.18253Z", fill: e2 });
  } }), Dt = yt({ displayName: "Minus", path: function(e2) {
    return d().createElement("path", { d: "M18 12.998H6C5.73478 12.998 5.48043 12.8926 5.29289 12.7051C5.10536 12.5176 5 12.2632 5 11.998C5 11.7328 5.10536 11.4784 5.29289 11.2909C5.48043 11.1033 5.73478 10.998 6 10.998H18C18.2652 10.998 18.5196 11.1033 18.7071 11.2909C18.8946 11.4784 19 11.7328 19 11.998C19 12.2632 18.8946 12.5176 18.7071 12.7051C18.5196 12.8926 18.2652 12.998 18 12.998Z", fill: e2 });
  } }), Tt = yt({ displayName: "PaintBucket", path: function(e2) {
    return d().createElement(d().Fragment, null, d().createElement("path", { d: "M4.85 19.15H20.15C20.5144 19.15 20.85 19.5071 20.85 20C20.85 20.4929 20.5144 20.85 20.15 20.85H4.85C4.48558 20.85 4.15 20.4929 4.15 20C4.15 19.5071 4.48558 19.15 4.85 19.15Z", fill: e2, stroke: e2, strokeWidth: "0.3" }), d().createElement("path", { d: "M9.97951 3.34583L9.97953 3.34581C10.2406 3.08473 10.6623 3.08473 10.9234 3.34581L17.6542 10.0768C17.9153 10.3379 17.9153 10.7596 17.6542 11.0207L11.4842 17.1908C11.0451 17.63 10.4682 17.85 9.89063 17.85C9.31312 17.85 8.73618 17.63 8.29621 17.19L3.80874 12.7024C2.93042 11.8241 2.93042 10.3935 3.80874 9.51513L9.97951 3.34583ZM10.5575 4.86691L10.4515 4.76084L10.3454 4.86691L4.75343 10.459C4.72624 10.4862 4.70986 10.5154 4.70167 10.53C4.69986 10.5332 4.69849 10.5357 4.69736 10.5377C4.69522 10.5416 4.69395 10.5438 4.69225 10.5467C4.69128 10.5483 4.69071 10.5492 4.69049 10.5495L4.4959 10.7928H4.80799H15.9314H15.9936L16.0375 10.7488L16.1323 10.654L16.2384 10.5479L16.1323 10.4419L10.5575 4.86691Z", fill: e2, stroke: e2, strokeWidth: "0.3" }), d().createElement("path", { d: "M19.3798 13.3154L19.3801 13.3158C19.5547 13.5525 19.9259 14.0726 20.2528 14.634C20.4163 14.9148 20.567 15.2032 20.6765 15.4698C20.7873 15.7395 20.85 15.9733 20.85 16.1493C20.85 17.076 20.0307 17.85 19 17.85C17.9693 17.85 17.15 17.076 17.15 16.1493C17.15 15.9733 17.2127 15.7395 17.3235 15.4698C17.433 15.2032 17.5837 14.9148 17.7472 14.634C18.0741 14.0726 18.4453 13.5525 18.6199 13.3158L18.6202 13.3154C18.6953 13.2129 18.8387 13.15 19 13.15C19.1613 13.15 19.3047 13.2129 19.3798 13.3154Z", fill: e2, stroke: e2, strokeWidth: "0.3" }));
  } }), jt = yt({ displayName: "Plus", path: function(e2) {
    return d().createElement("path", { d: "M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z", fill: e2 });
  } }), Rt = yt({ displayName: "Search", path: function(e2) {
    return d().createElement("path", { d: "M20.7241 19.1932L16.6436 15.1127C17.626 13.8049 18.1563 12.213 18.1546 10.5773C18.1546 6.39919 14.7554 3 10.5773 3C6.39919 3 3 6.39919 3 10.5773C3 14.7554 6.39919 18.1546 10.5773 18.1546C12.213 18.1563 13.8049 17.626 15.1127 16.6436L19.1932 20.7241C19.3998 20.9088 19.6692 21.0073 19.9461 20.9996C20.2231 20.9918 20.4865 20.8783 20.6824 20.6824C20.8783 20.4865 20.9918 20.2231 20.9996 19.9461C21.0073 19.6692 20.9088 19.3998 20.7241 19.1932ZM5.16494 10.5773C5.16494 9.50682 5.48237 8.4604 6.07708 7.57034C6.6718 6.68029 7.51709 5.98657 8.50607 5.57693C9.49504 5.16728 10.5833 5.0601 11.6332 5.26893C12.6831 5.47777 13.6475 5.99325 14.4044 6.75018C15.1613 7.5071 15.6768 8.47149 15.8856 9.52138C16.0945 10.5713 15.9873 11.6595 15.5776 12.6485C15.168 13.6375 14.4743 14.4828 13.5842 15.0775C12.6942 15.6722 11.6477 15.9896 10.5773 15.9896C9.14237 15.9879 7.76672 15.4171 6.75208 14.4025C5.73744 13.3878 5.16666 12.0122 5.16494 10.5773Z", fill: e2 });
  } }), zt = yt({ displayName: "Settings", viewBox: "0 0 20 20", defaultSize: 20, path: function(e2) {
    return d().createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.2293 10C17.2293 10.34 17.1993 10.66 17.1593 10.98L19.2693 12.63C19.4593 12.78 19.5093 13.05 19.3893 13.27L17.3893 16.73C17.2693 16.95 17.0093 17.04 16.7793 16.95L14.2893 15.95C13.7693 16.34 13.2093 16.68 12.5993 16.93L12.2193 19.58C12.1893 19.82 11.9793 20 11.7293 20H7.72933C7.47933 20 7.26933 19.82 7.23933 19.58L6.85933 16.93C6.24933 16.68 5.68933 16.35 5.16933 15.95L2.67933 16.95C2.45933 17.03 2.18933 16.95 2.06933 16.73L0.0693316 13.27C-0.0506684 13.05 -0.000668392 12.78 0.189332 12.63L2.29933 10.98C2.25933 10.66 2.22933 10.33 2.22933 10C2.22933 9.67 2.25933 9.34 2.29933 9.02L0.189332 7.37C-0.000668392 7.22 -0.0606684 6.95 0.0693316 6.73L2.06933 3.27C2.18933 3.05 2.44933 2.96 2.67933 3.05L5.16933 4.05C5.68933 3.66 6.24933 3.32 6.85933 3.07L7.23933 0.42C7.26933 0.18 7.47933 0 7.72933 0H11.7293C11.9793 0 12.1893 0.18 12.2193 0.42L12.5993 3.07C13.2093 3.32 13.7693 3.65 14.2893 4.05L16.7793 3.05C16.9993 2.97 17.2693 3.05 17.3893 3.27L19.3893 6.73C19.5093 6.95 19.4593 7.22 19.2693 7.37L17.1593 9.02C17.1993 9.34 17.2293 9.66 17.2293 10ZM6.22933 10C6.22933 11.93 7.79933 13.5 9.72933 13.5C11.6593 13.5 13.2293 11.93 13.2293 10C13.2293 8.07 11.6593 6.5 9.72933 6.5C7.79933 6.5 6.22933 8.07 6.22933 10Z", fill: e2 });
  } }), Ft = yt({ displayName: "Square", viewBox: "0 0 18 18", defaultSize: 18, defaultColor: vt, path: function(e2) {
    return d().createElement("rect", { x: "3.75", y: "3.75", width: "10.5", height: "10.5", rx: "1.25", stroke: e2, strokeWidth: "1.5" });
  } }), Ht = yt({ displayName: "SquareChecked", viewBox: "0 0 18 18", defaultSize: 18, path: function(e2) {
    return d().createElement(d().Fragment, null, d().createElement("path", { d: "M8.24349 9.58014L6.85576 8.22618L6 9.06111L8.24349 11.25L12 7.58493L11.1442 6.75L8.24349 9.58014Z", fill: e2 }), d().createElement("rect", { x: "3.75", y: "3.75", width: "10.5", height: "10.5", rx: "1.25", stroke: e2, strokeWidth: "1.5" }));
  } }), Wt = yt({ displayName: "Trash", path: function(e2) {
    return d().createElement("path", { d: "M15.0769 5.25H18.7692C19.5077 5.25 20 5.7 20 6.375V7.5H4V6.375C4 5.7 4.61538 5.25 5.23077 5.25H8.92308C9.16923 4.0125 10.5231 3 12 3C13.4769 3 14.8308 4.0125 15.0769 5.25ZM10.1538 5.25H13.8462C13.6 4.575 12.7385 4.125 12 4.125C11.2615 4.125 10.4 4.575 10.1538 5.25ZM5.23077 8.625H18.7692L17.6615 19.9875C17.6615 20.55 17.0462 21 16.4308 21H7.56923C6.95385 21 6.46154 20.55 6.33846 19.9875L5.23077 8.625Z", fill: e2 });
  } }), At = i(154);
  const Vt = JSON.parse('{"\u041F\u043E\u0438\u0441\u043A":"Search","\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445":"No data","\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u0430\u043D\u043D\u044B\u0445...":"Loading data...","\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435":"Select value","\u041E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442 \u0434\u0430\u043D\u043D\u044B\u0435":"Missing data","\u0412\u0441\u0435":"All"}'), _t = JSON.parse('{"\u041F\u043E\u0438\u0441\u043A":"\u641C\u7D22","\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445":"\u6CA1\u6709\u6570\u636E","\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u0430\u043D\u043D\u044B\u0445...":"\u52A0\u8F7D\u6570\u636E...","\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435":"\u9009\u62E9\u503C","\u041E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442 \u0434\u0430\u043D\u043D\u044B\u0435":"\u7F3A\u5931\u6570\u636E","\u0412\u0441\u0435":"\u5168\u90E8"}');
  var Bt = At.globalTranslator.createNamespace();
  Bt.importLanguage("en", function() {
    return Promise.resolve({ default: Vt });
  }), Bt.importLanguage("zh-CN", function() {
    return Promise.resolve({ default: _t });
  });
  var qt = Bt.translate, Ut = (0, p.makeStyles)(function(e2) {
    return { textField: { maxWidth: "160px", height: "26px", paddingRight: 0, "& .MuiInputBase-input": { padding: "5px 10px", paddingRight: 0, fontSize: "10px" }, "& .MuiOutlinedInput-notchedOutline": { border: "1px solid ".concat(e2.palette.divider) } }, fullWidth: { width: "100%", maxWidth: "none" }, search: { marginRight: 10 } };
  }, { name: "SearchField" }), Gt = function() {
    return Gt = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, Gt.apply(this, arguments);
  }, Kt = (0, u.forwardRef)(function(e2, t2) {
    var n2 = e2.className, r2 = e2.fullWidth, a2 = e2.onChange, l2 = e2.handleReset, o2 = e2.needSearchReset, i2 = e2.autoFocus, c2 = e2.debouncedDelay, s2 = e2.value, f2 = e2.defaultValue, h2 = void 0 === f2 ? "" : f2, m2 = e2.rightIcon, v2 = e2.searchIcon, g2 = e2.clearIcon, b2 = e2.placeholder, y2 = e2.disabled, x2 = void 0 !== y2 && y2, w2 = (function(e3, t3) {
      var n3 = {};
      for (var r3 in e3) Object.prototype.hasOwnProperty.call(e3, r3) && t3.indexOf(r3) < 0 && (n3[r3] = e3[r3]);
      if (null != e3 && "function" == typeof Object.getOwnPropertySymbols) {
        var a3 = 0;
        for (r3 = Object.getOwnPropertySymbols(e3); a3 < r3.length; a3++) t3.indexOf(r3[a3]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, r3[a3]) && (n3[r3[a3]] = e3[r3[a3]]);
      }
      return n3;
    })(e2, ["className", "fullWidth", "onChange", "handleReset", "needSearchReset", "autoFocus", "debouncedDelay", "value", "defaultValue", "rightIcon", "searchIcon", "clearIcon", "placeholder", "disabled"]), C2 = (0, u.useRef)(null), S2 = void 0 !== s2, E2 = (0, u.useState)(h2), I2 = E2[0], M2 = E2[1], O2 = S2 ? s2 : I2;
    (0, u.useImperativeHandle)(t2, function() {
      return C2.current;
    }, []);
    var L2, k2 = Ut(), N2 = Ae(n2, k2.textField, r2 && k2.fullWidth), Z2 = (function(e3, t3) {
      var n3 = (0, u.useRef)(null), r3 = (0, u.useRef)(e3);
      r3.current = e3;
      var a3 = (0, u.useCallback)(function() {
        null !== n3.current && (clearTimeout(n3.current), n3.current = null);
      }, []), l3 = (0, u.useCallback)(function() {
        for (var e4 = [], a4 = 0; a4 < arguments.length; a4++) e4[a4] = arguments[a4];
        null !== n3.current && clearTimeout(n3.current), n3.current = setTimeout(function() {
          var t4;
          n3.current = null, null === (t4 = r3.current) || void 0 === t4 || t4.call.apply(t4, (function(e5, t5, n4) {
            if (n4 || 2 === arguments.length) for (var r4, a5 = 0, l4 = t5.length; a5 < l4; a5++) !r4 && a5 in t5 || (r4 || (r4 = Array.prototype.slice.call(t5, 0, a5)), r4[a5] = t5[a5]);
            return e5.concat(r4 || Array.prototype.slice.call(t5));
          })([r3], e4, false));
        }, t3);
      }, [t3]);
      return l3.cancel = a3, (0, u.useEffect)(function() {
        return a3;
      }, [a3]), null != e3 ? l3 : null;
    })(a2, null != c2 ? c2 : 300), P2 = function() {
      var e3;
      null === (e3 = null == Z2 ? void 0 : Z2.cancel) || void 0 === e3 || e3.call(Z2), S2 || M2(""), a2 && a2({ target: { value: "" } }), l2 && l2("");
    };
    return (0, u.useEffect)(function() {
      var e3;
      o2 && (null === (e3 = null == Z2 ? void 0 : Z2.cancel) || void 0 === e3 || e3.call(Z2), S2 || M2(""), l2 && l2(""));
    }, [o2, l2, S2, Z2]), d().createElement(p.OutlinedInput, Gt({ inputRef: C2, placeholder: b2 || qt("\u041F\u043E\u0438\u0441\u043A"), className: N2, value: O2, onChange: function(e3) {
      var t3 = e3.target.value;
      S2 || M2(t3), Z2 ? Z2({ target: { value: t3 } }) : a2 && a2(e3);
    }, disabled: x2, autoFocus: i2, endAdornment: d().createElement(ht(), { position: "end", className: k2.search, style: { cursor: m2 || !O2 || x2 ? "default" : "pointer" } }, (L2 = { display: "flex", alignItems: "center", opacity: x2 ? 0.38 : 1, transition: "opacity 0.2s" }, m2 ? d().createElement("div", { style: L2 }, m2) : O2 && !x2 ? g2 ? d().createElement("div", { onClick: P2, style: Gt(Gt({}, L2), { cursor: "pointer" }) }, g2) : d().createElement("div", { style: Gt(Gt({}, L2), { cursor: "pointer" }) }, d().createElement(Zt, { onClick: P2, height: 18, width: 18 })) : d().createElement("div", { style: L2 }, v2 || d().createElement(Rt, { height: 18, width: 18 })))), onKeyDown: function(e3) {
      "Escape" !== e3.key && e3.stopPropagation();
    } }, w2));
  });
  Kt.displayName = "SearchField";
  var Yt = (0, p.makeStyles)(function() {
    return { listWrapper: { display: "flex", flexDirection: "column" } };
  }, { name: "ComposableSelectContent" }), Xt = function(e2) {
    var t2 = e2.children, n2 = e2.classNameForListWrapper, r2 = e2.maxContentHeight, a2 = void 0 === r2 ? 300 : r2, l2 = Yt();
    return d().createElement("div", { className: Ae(l2.listWrapper, n2), style: { maxHeight: a2 } }, t2);
  };
  function Jt() {
    return Jt = Object.assign ? Object.assign.bind() : function(e2) {
      for (var t2 = 1; t2 < arguments.length; t2++) {
        var n2 = arguments[t2];
        for (var r2 in n2) ({}).hasOwnProperty.call(n2, r2) && (e2[r2] = n2[r2]);
      }
      return e2;
    }, Jt.apply(null, arguments);
  }
  function $t(e2) {
    if (void 0 === e2) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e2;
  }
  function Qt(e2, t2) {
    return Qt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e3, t3) {
      return e3.__proto__ = t3, e3;
    }, Qt(e2, t2);
  }
  var en = Number.isNaN || function(e2) {
    return "number" == typeof e2 && e2 != e2;
  };
  function tn(e2, t2) {
    return e2 === t2 || !(!en(e2) || !en(t2));
  }
  function nn(e2, t2) {
    if (e2.length !== t2.length) return false;
    for (var n2 = 0; n2 < e2.length; n2++) if (!tn(e2[n2], t2[n2])) return false;
    return true;
  }
  const rn = function(e2, t2) {
    var n2;
    void 0 === t2 && (t2 = nn);
    var r2, a2 = [], l2 = false;
    return function() {
      for (var o2 = [], i2 = 0; i2 < arguments.length; i2++) o2[i2] = arguments[i2];
      return l2 && n2 === this && t2(o2, a2) || (r2 = e2.apply(this, o2), l2 = true, n2 = this, a2 = o2), r2;
    };
  };
  var an = "object" == typeof performance && "function" == typeof performance.now ? function() {
    return performance.now();
  } : function() {
    return Date.now();
  };
  function ln(e2) {
    cancelAnimationFrame(e2.id);
  }
  var on = -1;
  function cn(e2) {
    if (void 0 === e2 && (e2 = false), -1 === on || e2) {
      var t2 = document.createElement("div"), n2 = t2.style;
      n2.width = "50px", n2.height = "50px", n2.overflow = "scroll", document.body.appendChild(t2), on = t2.offsetWidth - t2.clientWidth, document.body.removeChild(t2);
    }
    return on;
  }
  var sn = null;
  function un(e2) {
    if (void 0 === e2 && (e2 = false), null === sn || e2) {
      var t2 = document.createElement("div"), n2 = t2.style;
      n2.width = "50px", n2.height = "50px", n2.overflow = "scroll", n2.direction = "rtl";
      var r2 = document.createElement("div"), a2 = r2.style;
      return a2.width = "100px", a2.height = "100px", t2.appendChild(r2), document.body.appendChild(t2), t2.scrollLeft > 0 ? sn = "positive-descending" : (t2.scrollLeft = 1, sn = 0 === t2.scrollLeft ? "negative" : "positive-ascending"), document.body.removeChild(t2), sn;
    }
    return sn;
  }
  var dn = function(e2, t2) {
    return e2;
  };
  function pn(e2) {
    var t2, n2 = e2.getItemOffset, r2 = e2.getEstimatedTotalSize, a2 = e2.getItemSize, l2 = e2.getOffsetForIndexAndAlignment, o2 = e2.getStartIndexForOffset, i2 = e2.getStopIndexForStartIndex, c2 = e2.initInstanceProps, s2 = e2.shouldResetStyleCacheOnItemSizeChange, d2 = e2.validateProps;
    return t2 = (function(e3) {
      function t3(t4) {
        var r3;
        return (r3 = e3.call(this, t4) || this)._instanceProps = c2(r3.props, $t(r3)), r3._outerRef = void 0, r3._resetIsScrollingTimeoutId = null, r3.state = { instance: $t(r3), isScrolling: false, scrollDirection: "forward", scrollOffset: "number" == typeof r3.props.initialScrollOffset ? r3.props.initialScrollOffset : 0, scrollUpdateWasRequested: false }, r3._callOnItemsRendered = void 0, r3._callOnItemsRendered = rn(function(e4, t5, n3, a3) {
          return r3.props.onItemsRendered({ overscanStartIndex: e4, overscanStopIndex: t5, visibleStartIndex: n3, visibleStopIndex: a3 });
        }), r3._callOnScroll = void 0, r3._callOnScroll = rn(function(e4, t5, n3) {
          return r3.props.onScroll({ scrollDirection: e4, scrollOffset: t5, scrollUpdateWasRequested: n3 });
        }), r3._getItemStyle = void 0, r3._getItemStyle = function(e4) {
          var t5, l3 = r3.props, o3 = l3.direction, i3 = l3.itemSize, c3 = l3.layout, u2 = r3._getItemStyleCache(s2 && i3, s2 && c3, s2 && o3);
          if (u2.hasOwnProperty(e4)) t5 = u2[e4];
          else {
            var d3 = n2(r3.props, e4, r3._instanceProps), p3 = a2(r3.props, e4, r3._instanceProps), f3 = "horizontal" === o3 || "horizontal" === c3, h3 = "rtl" === o3, m2 = f3 ? d3 : 0;
            u2[e4] = t5 = { position: "absolute", left: h3 ? void 0 : m2, right: h3 ? m2 : void 0, top: f3 ? 0 : d3, height: f3 ? "100%" : p3, width: f3 ? p3 : "100%" };
          }
          return t5;
        }, r3._getItemStyleCache = void 0, r3._getItemStyleCache = rn(function(e4, t5, n3) {
          return {};
        }), r3._onScrollHorizontal = function(e4) {
          var t5 = e4.currentTarget, n3 = t5.clientWidth, a3 = t5.scrollLeft, l3 = t5.scrollWidth;
          r3.setState(function(e5) {
            if (e5.scrollOffset === a3) return null;
            var t6 = r3.props.direction, o3 = a3;
            if ("rtl" === t6) switch (un()) {
              case "negative":
                o3 = -a3;
                break;
              case "positive-descending":
                o3 = l3 - n3 - a3;
            }
            return o3 = Math.max(0, Math.min(o3, l3 - n3)), { isScrolling: true, scrollDirection: e5.scrollOffset < o3 ? "forward" : "backward", scrollOffset: o3, scrollUpdateWasRequested: false };
          }, r3._resetIsScrollingDebounced);
        }, r3._onScrollVertical = function(e4) {
          var t5 = e4.currentTarget, n3 = t5.clientHeight, a3 = t5.scrollHeight, l3 = t5.scrollTop;
          r3.setState(function(e5) {
            if (e5.scrollOffset === l3) return null;
            var t6 = Math.max(0, Math.min(l3, a3 - n3));
            return { isScrolling: true, scrollDirection: e5.scrollOffset < t6 ? "forward" : "backward", scrollOffset: t6, scrollUpdateWasRequested: false };
          }, r3._resetIsScrollingDebounced);
        }, r3._outerRefSetter = function(e4) {
          var t5 = r3.props.outerRef;
          r3._outerRef = e4, "function" == typeof t5 ? t5(e4) : null != t5 && "object" == typeof t5 && t5.hasOwnProperty("current") && (t5.current = e4);
        }, r3._resetIsScrollingDebounced = function() {
          var e4, t5, n3, a3;
          null !== r3._resetIsScrollingTimeoutId && ln(r3._resetIsScrollingTimeoutId), r3._resetIsScrollingTimeoutId = (e4 = r3._resetIsScrolling, t5 = 150, n3 = an(), a3 = { id: requestAnimationFrame(function r4() {
            an() - n3 >= t5 ? e4.call(null) : a3.id = requestAnimationFrame(r4);
          }) });
        }, r3._resetIsScrolling = function() {
          r3._resetIsScrollingTimeoutId = null, r3.setState({ isScrolling: false }, function() {
            r3._getItemStyleCache(-1, null);
          });
        }, r3;
      }
      var p2, f2;
      f2 = e3, (p2 = t3).prototype = Object.create(f2.prototype), p2.prototype.constructor = p2, Qt(p2, f2), t3.getDerivedStateFromProps = function(e4, t4) {
        return fn(e4, t4), d2(e4), null;
      };
      var h2 = t3.prototype;
      return h2.scrollTo = function(e4) {
        e4 = Math.max(0, e4), this.setState(function(t4) {
          return t4.scrollOffset === e4 ? null : { scrollDirection: t4.scrollOffset < e4 ? "forward" : "backward", scrollOffset: e4, scrollUpdateWasRequested: true };
        }, this._resetIsScrollingDebounced);
      }, h2.scrollToItem = function(e4, t4) {
        void 0 === t4 && (t4 = "auto");
        var n3 = this.props, r3 = n3.itemCount, a3 = n3.layout, o3 = this.state.scrollOffset;
        e4 = Math.max(0, Math.min(e4, r3 - 1));
        var i3 = 0;
        if (this._outerRef) {
          var c3 = this._outerRef;
          i3 = "vertical" === a3 ? c3.scrollWidth > c3.clientWidth ? cn() : 0 : c3.scrollHeight > c3.clientHeight ? cn() : 0;
        }
        this.scrollTo(l2(this.props, e4, t4, o3, this._instanceProps, i3));
      }, h2.componentDidMount = function() {
        var e4 = this.props, t4 = e4.direction, n3 = e4.initialScrollOffset, r3 = e4.layout;
        if ("number" == typeof n3 && null != this._outerRef) {
          var a3 = this._outerRef;
          "horizontal" === t4 || "horizontal" === r3 ? a3.scrollLeft = n3 : a3.scrollTop = n3;
        }
        this._callPropsCallbacks();
      }, h2.componentDidUpdate = function() {
        var e4 = this.props, t4 = e4.direction, n3 = e4.layout, r3 = this.state, a3 = r3.scrollOffset;
        if (r3.scrollUpdateWasRequested && null != this._outerRef) {
          var l3 = this._outerRef;
          if ("horizontal" === t4 || "horizontal" === n3) if ("rtl" === t4) switch (un()) {
            case "negative":
              l3.scrollLeft = -a3;
              break;
            case "positive-ascending":
              l3.scrollLeft = a3;
              break;
            default:
              var o3 = l3.clientWidth, i3 = l3.scrollWidth;
              l3.scrollLeft = i3 - o3 - a3;
          }
          else l3.scrollLeft = a3;
          else l3.scrollTop = a3;
        }
        this._callPropsCallbacks();
      }, h2.componentWillUnmount = function() {
        null !== this._resetIsScrollingTimeoutId && ln(this._resetIsScrollingTimeoutId);
      }, h2.render = function() {
        var e4 = this.props, t4 = e4.children, n3 = e4.className, a3 = e4.direction, l3 = e4.height, o3 = e4.innerRef, i3 = e4.innerElementType, c3 = e4.innerTagName, s3 = e4.itemCount, d3 = e4.itemData, p3 = e4.itemKey, f3 = void 0 === p3 ? dn : p3, h3 = e4.layout, m2 = e4.outerElementType, v2 = e4.outerTagName, g2 = e4.style, b2 = e4.useIsScrolling, y2 = e4.width, x2 = this.state.isScrolling, w2 = "horizontal" === a3 || "horizontal" === h3, C2 = w2 ? this._onScrollHorizontal : this._onScrollVertical, S2 = this._getRangeToRender(), E2 = S2[0], I2 = S2[1], M2 = [];
        if (s3 > 0) for (var O2 = E2; O2 <= I2; O2++) M2.push((0, u.createElement)(t4, { data: d3, key: f3(O2, d3), index: O2, isScrolling: b2 ? x2 : void 0, style: this._getItemStyle(O2) }));
        var L2 = r2(this.props, this._instanceProps);
        return (0, u.createElement)(m2 || v2 || "div", { className: n3, onScroll: C2, ref: this._outerRefSetter, style: Jt({ position: "relative", height: l3, width: y2, overflow: "auto", WebkitOverflowScrolling: "touch", willChange: "transform", direction: a3 }, g2) }, (0, u.createElement)(i3 || c3 || "div", { children: M2, ref: o3, style: { height: w2 ? "100%" : L2, pointerEvents: x2 ? "none" : void 0, width: w2 ? L2 : "100%" } }));
      }, h2._callPropsCallbacks = function() {
        if ("function" == typeof this.props.onItemsRendered && this.props.itemCount > 0) {
          var e4 = this._getRangeToRender(), t4 = e4[0], n3 = e4[1], r3 = e4[2], a3 = e4[3];
          this._callOnItemsRendered(t4, n3, r3, a3);
        }
        if ("function" == typeof this.props.onScroll) {
          var l3 = this.state, o3 = l3.scrollDirection, i3 = l3.scrollOffset, c3 = l3.scrollUpdateWasRequested;
          this._callOnScroll(o3, i3, c3);
        }
      }, h2._getRangeToRender = function() {
        var e4 = this.props, t4 = e4.itemCount, n3 = e4.overscanCount, r3 = this.state, a3 = r3.isScrolling, l3 = r3.scrollDirection, c3 = r3.scrollOffset;
        if (0 === t4) return [0, 0, 0, 0];
        var s3 = o2(this.props, c3, this._instanceProps), u2 = i2(this.props, s3, c3, this._instanceProps), d3 = a3 && "backward" !== l3 ? 1 : Math.max(1, n3), p3 = a3 && "forward" !== l3 ? 1 : Math.max(1, n3);
        return [Math.max(0, s3 - d3), Math.max(0, Math.min(t4 - 1, u2 + p3)), s3, u2];
      }, t3;
    })(u.PureComponent), t2.defaultProps = { direction: "ltr", itemData: void 0, layout: "vertical", overscanCount: 2, useIsScrolling: false }, t2;
  }
  var fn = function(e2, t2) {
    e2.children, e2.direction, e2.height, e2.layout, e2.innerTagName, e2.outerTagName, e2.width, t2.instance;
  }, hn = function(e2, t2, n2) {
    var r2 = e2.itemSize, a2 = n2.itemMetadataMap, l2 = n2.lastMeasuredIndex;
    if (t2 > l2) {
      var o2 = 0;
      if (l2 >= 0) {
        var i2 = a2[l2];
        o2 = i2.offset + i2.size;
      }
      for (var c2 = l2 + 1; c2 <= t2; c2++) {
        var s2 = r2(c2);
        a2[c2] = { offset: o2, size: s2 }, o2 += s2;
      }
      n2.lastMeasuredIndex = t2;
    }
    return a2[t2];
  }, mn = function(e2, t2, n2, r2, a2) {
    for (; r2 <= n2; ) {
      var l2 = r2 + Math.floor((n2 - r2) / 2), o2 = hn(e2, l2, t2).offset;
      if (o2 === a2) return l2;
      o2 < a2 ? r2 = l2 + 1 : o2 > a2 && (n2 = l2 - 1);
    }
    return r2 > 0 ? r2 - 1 : 0;
  }, vn = function(e2, t2) {
    var n2 = e2.itemCount, r2 = t2.itemMetadataMap, a2 = t2.estimatedItemSize, l2 = t2.lastMeasuredIndex, o2 = 0;
    if (l2 >= n2 && (l2 = n2 - 1), l2 >= 0) {
      var i2 = r2[l2];
      o2 = i2.offset + i2.size;
    }
    return o2 + (n2 - l2 - 1) * a2;
  }, gn = pn({ getItemOffset: function(e2, t2, n2) {
    return hn(e2, t2, n2).offset;
  }, getItemSize: function(e2, t2, n2) {
    return n2.itemMetadataMap[t2].size;
  }, getEstimatedTotalSize: vn, getOffsetForIndexAndAlignment: function(e2, t2, n2, r2, a2, l2) {
    var o2 = e2.direction, i2 = e2.height, c2 = e2.layout, s2 = e2.width, u2 = "horizontal" === o2 || "horizontal" === c2 ? s2 : i2, d2 = hn(e2, t2, a2), p2 = vn(e2, a2), f2 = Math.max(0, Math.min(p2 - u2, d2.offset)), h2 = Math.max(0, d2.offset - u2 + d2.size + l2);
    switch ("smart" === n2 && (n2 = r2 >= h2 - u2 && r2 <= f2 + u2 ? "auto" : "center"), n2) {
      case "start":
        return f2;
      case "end":
        return h2;
      case "center":
        return Math.round(h2 + (f2 - h2) / 2);
      default:
        return r2 >= h2 && r2 <= f2 ? r2 : r2 < h2 ? h2 : f2;
    }
  }, getStartIndexForOffset: function(e2, t2, n2) {
    return (function(e3, t3, n3) {
      var r2 = t3.itemMetadataMap, a2 = t3.lastMeasuredIndex;
      return (a2 > 0 ? r2[a2].offset : 0) >= n3 ? mn(e3, t3, a2, 0, n3) : (function(e4, t4, n4, r3) {
        for (var a3 = e4.itemCount, l2 = 1; n4 < a3 && hn(e4, n4, t4).offset < r3; ) n4 += l2, l2 *= 2;
        return mn(e4, t4, Math.min(n4, a3 - 1), Math.floor(n4 / 2), r3);
      })(e3, t3, Math.max(0, a2), n3);
    })(e2, n2, t2);
  }, getStopIndexForStartIndex: function(e2, t2, n2, r2) {
    for (var a2 = e2.direction, l2 = e2.height, o2 = e2.itemCount, i2 = e2.layout, c2 = e2.width, s2 = "horizontal" === a2 || "horizontal" === i2 ? c2 : l2, u2 = hn(e2, t2, r2), d2 = n2 + s2, p2 = u2.offset + u2.size, f2 = t2; f2 < o2 - 1 && p2 < d2; ) f2++, p2 += hn(e2, f2, r2).size;
    return f2;
  }, initInstanceProps: function(e2, t2) {
    var n2 = { itemMetadataMap: {}, estimatedItemSize: e2.estimatedItemSize || 50, lastMeasuredIndex: -1 };
    return t2.resetAfterIndex = function(e3, r2) {
      void 0 === r2 && (r2 = true), n2.lastMeasuredIndex = Math.min(n2.lastMeasuredIndex, e3 - 1), t2._getItemStyleCache(-1), r2 && t2.forceUpdate();
    }, n2;
  }, shouldResetStyleCacheOnItemSizeChange: false, validateProps: function(e2) {
    e2.itemSize;
  } }), bn = pn({ getItemOffset: function(e2, t2) {
    return t2 * e2.itemSize;
  }, getItemSize: function(e2, t2) {
    return e2.itemSize;
  }, getEstimatedTotalSize: function(e2) {
    var t2 = e2.itemCount;
    return e2.itemSize * t2;
  }, getOffsetForIndexAndAlignment: function(e2, t2, n2, r2, a2, l2) {
    var o2 = e2.direction, i2 = e2.height, c2 = e2.itemCount, s2 = e2.itemSize, u2 = e2.layout, d2 = e2.width, p2 = "horizontal" === o2 || "horizontal" === u2 ? d2 : i2, f2 = Math.max(0, c2 * s2 - p2), h2 = Math.min(f2, t2 * s2), m2 = Math.max(0, t2 * s2 - p2 + s2 + l2);
    switch ("smart" === n2 && (n2 = r2 >= m2 - p2 && r2 <= h2 + p2 ? "auto" : "center"), n2) {
      case "start":
        return h2;
      case "end":
        return m2;
      case "center":
        var v2 = Math.round(m2 + (h2 - m2) / 2);
        return v2 < Math.ceil(p2 / 2) ? 0 : v2 > f2 + Math.floor(p2 / 2) ? f2 : v2;
      default:
        return r2 >= m2 && r2 <= h2 ? r2 : r2 < m2 ? m2 : h2;
    }
  }, getStartIndexForOffset: function(e2, t2) {
    var n2 = e2.itemCount, r2 = e2.itemSize;
    return Math.max(0, Math.min(n2 - 1, Math.floor(t2 / r2)));
  }, getStopIndexForStartIndex: function(e2, t2, n2) {
    var r2 = e2.direction, a2 = e2.height, l2 = e2.itemCount, o2 = e2.itemSize, i2 = e2.layout, c2 = e2.width, s2 = t2 * o2, u2 = "horizontal" === r2 || "horizontal" === i2 ? c2 : a2, d2 = Math.ceil((u2 + n2 - s2) / o2);
    return Math.max(0, Math.min(l2 - 1, t2 + d2 - 1));
  }, initInstanceProps: function(e2) {
  }, shouldResetStyleCacheOnItemSizeChange: true, validateProps: function(e2) {
    e2.itemSize;
  } }), yn = (0, u.createContext)(null), xn = function() {
    var e2 = (0, u.useContext)(yn);
    if (!e2) throw new Error("Composable Select components must be used within a Composable Select provider");
    return e2;
  }, wn = (0, p.makeStyles)(function(e2) {
    return { groupLabel: { padding: "6px 10px", fontSize: "12px", fontWeight: 600, color: e2.palette.primary.main, letterSpacing: "0.5px", position: "sticky", top: 0, zIndex: 1, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", transition: "background-color 0.2s ease", userSelect: "none" }, labelText: { flex: 1 }, chevronIcon: { display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "8px", "& svg": { width: "16px", height: "16px" } } };
  }, { name: "ComposableSelectGroupLabel" }), Cn = function(e2) {
    var t2, n2 = e2.label, r2 = e2.groupIndex, a2 = wn(), l2 = xn(), o2 = l2.expandedGroups, i2 = l2.toggleGroup, c2 = null === (t2 = null == o2 ? void 0 : o2.has(r2)) || void 0 === t2 || t2;
    return d().createElement("div", { className: a2.groupLabel, onClick: function() {
      null == i2 || i2(r2);
    } }, d().createElement("span", { className: a2.labelText }, n2), d().createElement("span", { className: a2.chevronIcon }, c2 ? d().createElement(Lt, null) : d().createElement(Ct, null)));
  }, Sn = i(471), En = (0, p.makeStyles)(function(e2) {
    return { itemText: { fontSize: 10, display: "flex", width: "100%", justifyContent: "space-between", paddingLeft: 10, paddingRight: 10, fontWeight: 600 }, activeItemText: { background: "#EEEEEE" }, name: { alignItems: "center", justifyContent: "space-between", fontSize: "12px", lineHeight: "20px", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }, nameWithCheckbox: { paddingRight: "25px" }, menuItemIcon: { position: "absolute", right: 5 }, customTooltip: { transform: "translate(10px, -10px) !important" } };
  }, { name: "ComposableSelectItem" }), In = function(e2) {
    var t2, n2, r2 = e2.value, a2 = e2.label, l2 = e2.isAllItem, o2 = void 0 !== l2 && l2, i2 = e2.isDisabled, c2 = void 0 !== i2 && i2, s2 = xn(), u2 = s2.selectedData, f2 = s2.options, h2 = s2.chooseAll, m2 = s2.handleClick, v2 = s2.handleClose, g2 = s2.showTooltipForLabel, b2 = s2.multiSelect, y2 = (0, Sn.useTheme)(), x2 = En(), w2 = o2 ? u2.length === f2.length : u2.some(function(e3) {
      return void 0 !== e3.value && null !== e3.value ? e3.value === r2 : e3 === r2;
    });
    return d().createElement(p.MenuItem, { value: r2, key: r2, onClick: function() {
      c2 || (o2 ? null == h2 || h2() : (m2(r2), b2 || v2()));
    }, onKeyDown: function(e3) {
      e3.stopPropagation(), e3.preventDefault();
    }, className: Ae(x2.itemText, (t2 = {}, t2[x2.activeItemText] = !b2 && w2, t2)), disabled: c2 }, d().createElement(p.Tooltip, { title: g2 ? a2 : "", placement: "bottom-start", classes: { tooltip: x2.customTooltip }, PopperProps: { style: { zIndex: y2.zIndex.tooltip } } }, d().createElement("div", { className: Ae(x2.name, (n2 = {}, n2[x2.nameWithCheckbox] = b2, n2)) }, a2)), d().createElement(p.IconButton, { className: x2.menuItemIcon, size: "small" }, b2 ? w2 ? d().createElement(Ht, null) : d().createElement(Ft, null) : null));
  }, Mn = (0, p.makeStyles)(function(e2) {
    return { noData: { padding: "6px 10px", fontSize: 10, fontWeight: 600, color: e2.palette.text.secondary, textAlign: "center" }, name: { alignItems: "center", justifyContent: "space-between", fontSize: "12px", lineHeight: "20px", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } };
  }, { name: "ComposableSelectList" }), On = function() {
    return On = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, On.apply(this, arguments);
  }, Ln = function(e2) {
    var t2 = e2.renderItem, n2 = e2.maxListHeight, r2 = void 0 === n2 ? 300 : n2, a2 = xn(), l2 = a2.filteredOptions, o2 = a2.filteredGroups, i2 = a2.chooseAll, c2 = a2.expandedGroups, s2 = a2.disabledAllOptions, p2 = Mn(), f2 = (0, u.useMemo)(function() {
      return i2 ? (function(e3, t3, n3) {
        if (n3 || 2 === arguments.length) for (var r3, a3 = 0, l3 = t3.length; a3 < l3; a3++) !r3 && a3 in t3 || (r3 || (r3 = Array.prototype.slice.call(t3, 0, a3)), r3[a3] = t3[a3]);
        return e3.concat(r3 || Array.prototype.slice.call(t3));
      })([{ label: qt("\u0412\u0441\u0435"), value: "all" }], l2, true) : l2;
    }, [l2, i2]), h2 = (0, u.useMemo)(function() {
      if (!o2) return f2.map(function(e4) {
        return On({ type: "option" }, e4);
      });
      var e3 = [];
      return o2.forEach(function(t3, n3) {
        var r3;
        e3.push({ type: "group-label", label: t3.label, groupIndex: n3 }), (null === (r3 = null == c2 ? void 0 : c2.has(n3)) || void 0 === r3 || r3) && t3.options.forEach(function(t4) {
          e3.push(On({ type: "option" }, t4));
        });
      }), e3;
    }, [o2, f2, c2]), m2 = (0, u.useCallback)(function(e3) {
      return h2[e3].type, 32;
    }, [h2]), v2 = (0, u.useCallback)(function(e3) {
      var n3 = e3.index, r3 = e3.style, a3 = h2[n3];
      if ("group-label" === a3.type) return d().createElement("div", { style: r3, key: "group-".concat(a3.groupIndex) }, d().createElement(Cn, { label: a3.label, groupIndex: a3.groupIndex }));
      var l3 = a3.label, o3 = a3.value, c3 = a3.isDisabled, u2 = "all" === o3 && !!i2;
      return d().createElement("div", { style: r3, key: o3 }, t2 ? t2({ label: l3, value: o3, isDisabled: c3 || s2 }) : d().createElement(In, { key: o3, value: o3, label: l3, isAllItem: u2, isDisabled: c3 || s2 }));
    }, [h2, i2, t2, s2]), g2 = (0, u.useMemo)(function() {
      var e3 = h2.reduce(function(e4, t3) {
        return e4 + (t3.type, 32);
      }, 0);
      return Math.min(e3, r2);
    }, [h2, r2]);
    return d().createElement(d().Fragment, null, o2 ? d().createElement(gn, { height: g2, width: "100%", itemCount: h2.length, itemSize: m2 }, v2) : d().createElement(bn, { height: g2, width: "100%", itemCount: h2.length, itemSize: 32 }, v2), (0 === h2.length || 1 === h2.length && i2) && d().createElement("div", { className: p2.noData }, d().createElement("div", { className: p2.name }, qt("\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445"))));
  }, kn = function() {
    return kn = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, kn.apply(this, arguments);
  }, Nn = function(e2) {
    var t2 = e2.children, n2 = e2.selectedData, r2 = e2.data, a2 = void 0 === r2 ? [] : r2, l2 = e2.groups, o2 = e2.handleClick, i2 = e2.name, c2 = e2.disabledSelect, s2 = void 0 !== c2 && c2, p2 = e2.disabledAllOptions, f2 = void 0 !== p2 && p2, h2 = e2.required, m2 = void 0 !== h2 && h2, v2 = e2.multiSelect, g2 = void 0 !== v2 && v2, b2 = e2.autoOpen, y2 = void 0 !== b2 && b2, x2 = e2.showTooltipForLabel, w2 = void 0 !== x2 && x2, C2 = e2.chooseAll, S2 = e2.clearAll, E2 = e2.renderValue, I2 = e2.sortBy, M2 = (0, u.useState)(""), O2 = M2[0], L2 = M2[1], k2 = (0, u.useState)(false), N2 = k2[0], Z2 = k2[1], P2 = (0, u.useState)(function() {
      return l2 ? new Set(l2.map(function(e3, t3) {
        return t3;
      })) : /* @__PURE__ */ new Set();
    }), D2 = P2[0], T2 = P2[1], j2 = (0, u.useCallback)(function(e3, t3) {
      return e3.toLowerCase().indexOf(t3.toLowerCase()) > -1;
    }, []), R2 = (0, u.useMemo)(function() {
      return l2 ? l2.flatMap(function(e3) {
        return e3.options;
      }) : a2;
    }, [a2, l2]), z2 = (0, u.useMemo)(function() {
      if (O2) {
        var e3 = R2.filter(function(e4) {
          var t3 = e4.label;
          return j2(t3, O2);
        });
        return I2 && (e3 = e3.sort(function(e4, t3) {
          return "asc" === I2 ? e4.label.localeCompare(t3.label, "en") : t3.label.localeCompare(e4.label, "en");
        })), e3;
      }
      return I2 ? R2.sort(function(e4, t3) {
        return "asc" === I2 ? e4.label.localeCompare(t3.label, "en") : t3.label.localeCompare(e4.label, "en");
      }) : R2;
    }, [R2, O2, j2, I2]), F2 = (0, u.useMemo)(function() {
      if (l2) {
        var e3 = function(e4) {
          return I2 ? (function(e5, t3, n3) {
            if (n3 || 2 === arguments.length) for (var r3, a3 = 0, l3 = t3.length; a3 < l3; a3++) !r3 && a3 in t3 || (r3 || (r3 = Array.prototype.slice.call(t3, 0, a3)), r3[a3] = t3[a3]);
            return e5.concat(r3 || Array.prototype.slice.call(t3));
          })([], e4, true).sort(function(e5, t3) {
            return "asc" === I2 ? e5.label.localeCompare(t3.label, "en") : t3.label.localeCompare(e5.label, "en");
          }) : e4;
        };
        return O2 ? l2.map(function(t3) {
          return kn(kn({}, t3), { options: e3(t3.options.filter(function(e4) {
            var t4 = e4.label;
            return j2(t4, O2);
          })) });
        }).filter(function(e4) {
          return e4.options.length > 0;
        }) : l2.map(function(t3) {
          return kn(kn({}, t3), { options: e3(t3.options) });
        });
      }
    }, [l2, O2, j2, I2]), H2 = (0, u.useCallback)(function() {
      Z2(true);
    }, []), W2 = (0, u.useCallback)(function() {
      Z2(false), L2("");
    }, []), A2 = (0, u.useCallback)(function(e3) {
      T2(function(t3) {
        var n3 = new Set(t3);
        return n3.has(e3) ? n3.delete(e3) : n3.add(e3), n3;
      });
    }, []);
    (0, u.useEffect)(function() {
      y2 && setTimeout(function() {
        Z2(true);
      }, 300);
    }, [y2]);
    var V2 = (0, u.useMemo)(function() {
      return { open: N2, search: O2, selectedData: n2, options: R2, filteredOptions: z2, groups: l2, filteredGroups: F2, expandedGroups: l2 ? D2 : void 0, toggleGroup: l2 ? A2 : void 0, setOpen: Z2, setSearch: L2, handleClick: o2, handleOpen: H2, handleClose: W2, name: i2, disabledSelect: s2, disabledAllOptions: f2, required: m2, multiSelect: g2, chooseAll: C2, clearAll: S2, showTooltipForLabel: w2, renderValue: E2 };
    }, [N2, O2, n2, R2, z2, l2, F2, D2, A2, o2, H2, W2, i2, s2, f2, m2, g2, C2, S2, w2, E2]);
    return d().createElement(yn.Provider, { value: V2 }, t2);
  }, Zn = (0, p.makeStyles)(function(e2) {
    return { search: { background: e2.palette.background.paper, padding: "0 10px", zIndex: 2 } };
  }, { name: "ComposableSelectSearch" }), Pn = function() {
    return Pn = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, Pn.apply(this, arguments);
  }, Dn = function(e2) {
    var t2 = e2.classNameForSearchField, n2 = e2.searchFieldProps, r2 = xn(), a2 = Zn(), l2 = r2.setSearch;
    return d().createElement(p.ListSubheader, { className: a2.search }, d().createElement(Kt, Pn({ className: t2, onChange: function(e3) {
      return l2(e3.target.value);
    }, fullWidth: true, handleReset: l2 }, n2)));
  }, Tn = (0, p.makeStyles)(function(e2) {
    return { formField: { width: "100%", position: "relative", "& .MuiInputLabel-root": { transform: "translate(2px, 16px) scale(1)", fontSize: "10px", fontWeight: 400, color: e2.palette.text.secondary, left: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", right: 5, "&.MuiInputLabel-shrink": { transform: "translate(2px, 8px) scale(0.8)" } }, "& .MuiSelect-icon": { display: "none !important" } }, select: { border: "1px solid ".concat(e2.palette.divider), borderRadius: "4px", background: "transparent", "& .MuiSelect-filled.MuiSelect-filled": { fontSize: "10px", paddingTop: "14px", paddingBottom: "5px", paddingRight: "50px", fontWeight: 500, color: e2.palette.text.primary }, "&:before": { content: "none" }, "&:after": { content: "none" } }, selectNoLabel: { "& .MuiSelect-filled.MuiSelect-filled": { paddingTop: "9.5px", paddingBottom: "9.5px" } }, selectDisabled: { "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.12);" } }, selectError: { border: "1px solid ".concat(e2.palette.error.main, " !important") }, paper: { marginTop: "5px" }, list: { padding: 0 }, labelError: { color: e2.palette.error.main, position: "absolute", bottom: "-20px", left: "12px", fontSize: "10px", margin: 0 }, iconsContainer: { position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", pointerEvents: "none", zIndex: 1, gap: "4px" }, selectIcon: { display: "flex", alignItems: "center", justifyContent: "center", transition: "transform 0.3s ease", transform: "rotate(0deg)", pointerEvents: "none" }, selectIconOpen: { transform: "rotate(180deg)" }, selectIconDisabled: { opacity: 0.6 }, clearIcon: { display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", opacity: 0.6, transition: "opacity 0.2s ease", pointerEvents: "auto", "&:hover": { opacity: 1 } } };
  }, { name: "ComposableSelectTrigger" }), jn = function() {
    return jn = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, jn.apply(this, arguments);
  }, Rn = function(e2) {
    var t2, n2, r2 = e2.children, a2 = e2.label, l2 = e2.errorMessage, o2 = e2.classNameForFormControl, i2 = e2.classnameForSelect, c2 = e2.classNameForHelperText, s2 = e2.IconComponent, u2 = void 0 === s2 ? Ct : s2, f2 = e2.formControlProps, h2 = e2.selectProps, m2 = Tn(), v2 = xn(), g2 = v2.open, b2 = v2.selectedData, y2 = v2.name, x2 = v2.disabledSelect, w2 = v2.disabledAllOptions, C2 = v2.required, S2 = v2.renderValue, E2 = v2.handleOpen, I2 = v2.handleClose, M2 = v2.clearAll;
    return d().createElement(p.FormControl, jn({ className: Ae(m2.formField, o2), error: !!l2, required: C2 }, f2), a2 && d().createElement(d().Fragment, null, b2.length > 0 ? d().createElement(p.InputLabel, null, a2) : d().createElement(p.InputLabel, { shrink: true }, a2)), d().createElement(p.Select, jn({ labelId: "input-label", open: g2, multiple: true, displayEmpty: true, disabled: x2, required: C2, className: Ae(m2.select, (t2 = {}, t2[m2.selectDisabled] = x2, t2[m2.selectError] = !!l2, t2[m2.selectNoLabel] = !a2, t2), i2), name: y2, MenuProps: { anchorOrigin: { vertical: "bottom", horizontal: "left" }, getContentAnchorEl: null, autoFocus: false, classes: { paper: m2.paper, list: m2.list } }, variant: "filled", value: b2, renderValue: S2, onOpen: E2, onClose: I2, error: !!l2 }, h2), r2), d().createElement("div", { className: m2.iconsContainer }, b2.length > 0 && M2 && !x2 && !w2 && d().createElement("div", { className: m2.clearIcon, onClick: function(e3) {
      e3.preventDefault(), e3.stopPropagation(), !M2 || x2 || w2 || M2();
    }, onMouseDown: function(e3) {
      e3.preventDefault(), e3.stopPropagation();
    }, role: "button", "aria-label": "clear all selected values" }, d().createElement(Zt, { width: 14, height: 14 })), d().createElement("div", { className: Ae(m2.selectIcon, (n2 = {}, n2[m2.selectIconOpen] = g2, n2[m2.selectIconDisabled] = x2, n2)) }, d().createElement(u2, { width: 18, height: 18 }))), l2 && d().createElement(p.FormHelperText, { className: Ae(m2.labelError, c2) }, l2));
  }, zn = (0, u.createContext)(null), Fn = function() {
    var e2 = (0, u.useContext)(zn);
    if (!e2) throw new Error("Dynamic Select components must be used within a Dynamic Select provider");
    return e2;
  }, Hn = function() {
    return Hn = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, Hn.apply(this, arguments);
  }, Wn = function(e2, t2, n2, r2) {
    return new (n2 || (n2 = Promise))(function(a2, l2) {
      function o2(e3) {
        try {
          c2(r2.next(e3));
        } catch (e4) {
          l2(e4);
        }
      }
      function i2(e3) {
        try {
          c2(r2.throw(e3));
        } catch (e4) {
          l2(e4);
        }
      }
      function c2(e3) {
        var t3;
        e3.done ? a2(e3.value) : (t3 = e3.value, t3 instanceof n2 ? t3 : new n2(function(e4) {
          e4(t3);
        })).then(o2, i2);
      }
      c2((r2 = r2.apply(e2, t2 || [])).next());
    });
  }, An = function(e2, t2) {
    var n2, r2, a2, l2, o2 = { label: 0, sent: function() {
      if (1 & a2[0]) throw a2[1];
      return a2[1];
    }, trys: [], ops: [] };
    return l2 = { next: i2(0), throw: i2(1), return: i2(2) }, "function" == typeof Symbol && (l2[Symbol.iterator] = function() {
      return this;
    }), l2;
    function i2(i3) {
      return function(c2) {
        return (function(i4) {
          if (n2) throw new TypeError("Generator is already executing.");
          for (; l2 && (l2 = 0, i4[0] && (o2 = 0)), o2; ) try {
            if (n2 = 1, r2 && (a2 = 2 & i4[0] ? r2.return : i4[0] ? r2.throw || ((a2 = r2.return) && a2.call(r2), 0) : r2.next) && !(a2 = a2.call(r2, i4[1])).done) return a2;
            switch (r2 = 0, a2 && (i4 = [2 & i4[0], a2.value]), i4[0]) {
              case 0:
              case 1:
                a2 = i4;
                break;
              case 4:
                return o2.label++, { value: i4[1], done: false };
              case 5:
                o2.label++, r2 = i4[1], i4 = [0];
                continue;
              case 7:
                i4 = o2.ops.pop(), o2.trys.pop();
                continue;
              default:
                if (!((a2 = (a2 = o2.trys).length > 0 && a2[a2.length - 1]) || 6 !== i4[0] && 2 !== i4[0])) {
                  o2 = 0;
                  continue;
                }
                if (3 === i4[0] && (!a2 || i4[1] > a2[0] && i4[1] < a2[3])) {
                  o2.label = i4[1];
                  break;
                }
                if (6 === i4[0] && o2.label < a2[1]) {
                  o2.label = a2[1], a2 = i4;
                  break;
                }
                if (a2 && o2.label < a2[2]) {
                  o2.label = a2[2], o2.ops.push(i4);
                  break;
                }
                a2[2] && o2.ops.pop(), o2.trys.pop();
                continue;
            }
            i4 = t2.call(e2, o2);
          } catch (e3) {
            i4 = [6, e3], r2 = 0;
          } finally {
            n2 = a2 = 0;
          }
          if (5 & i4[0]) throw i4[1];
          return { value: i4[0] ? i4[1] : void 0, done: true };
        })([i3, c2]);
      };
    }
  }, Vn = function(e2, t2, n2) {
    if (n2 || 2 === arguments.length) for (var r2, a2 = 0, l2 = t2.length; a2 < l2; a2++) !r2 && a2 in t2 || (r2 || (r2 = Array.prototype.slice.call(t2, 0, a2)), r2[a2] = t2[a2]);
    return e2.concat(r2 || Array.prototype.slice.call(t2));
  }, _n = function(e2) {
    var t2 = e2.children, n2 = e2.selectedData, r2 = e2.data, a2 = e2.handleClick, l2 = e2.name, o2 = e2.disabledSelect, i2 = void 0 !== o2 && o2, c2 = e2.disabledAllOptions, s2 = void 0 !== c2 && c2, p2 = e2.required, f2 = void 0 !== p2 && p2, h2 = e2.multiSelect, m2 = void 0 !== h2 && h2, v2 = e2.autoOpen, g2 = void 0 !== v2 && v2, b2 = e2.showTooltipForLabel, y2 = void 0 !== b2 && b2, x2 = e2.textForEmptyLabel, w2 = e2.renderValue, C2 = e2.onSearch, S2 = e2.onLoadMore, E2 = e2.onClose, I2 = e2.isLoading, M2 = e2.isLoadingMore, O2 = e2.totalCount, L2 = e2.currentPage, k2 = e2.loadInitialData, N2 = e2.hasMore, Z2 = e2.searchValue, P2 = e2.debounceDelay, D2 = void 0 === P2 ? 500 : P2, T2 = e2.clearAll, j2 = (0, u.useState)(false), R2 = j2[0], z2 = j2[1], F2 = (0, u.useState)(false), H2 = F2[0], W2 = F2[1], A2 = (0, u.useState)(false), V2 = A2[0], _2 = A2[1], B2 = (0, u.useRef)(null), q2 = (0, u.useRef)(false), U2 = (0, u.useRef)(false), G2 = (0, u.useState)({ upperListOptions: [], options: [], totalCount: 0 }), K2 = G2[0], Y2 = G2[1], X2 = (0, u.useCallback)(function(e3) {
      var t3 = e3.search, n3 = e3.page;
      return Wn(void 0, void 0, void 0, function() {
        return An(this, function(e4) {
          return U2.current || (B2.current && clearTimeout(B2.current), B2.current = setTimeout(function() {
            return Wn(void 0, void 0, void 0, function() {
              return An(this, function(e5) {
                switch (e5.label) {
                  case 0:
                    return e5.trys.push([0, , 2, 3]), W2(true), [4, C2({ search: t3, page: n3 })];
                  case 1:
                    return e5.sent(), [3, 3];
                  case 2:
                    return W2(false), [7];
                  case 3:
                    return [2];
                }
              });
            });
          }, 500)), [2];
        });
      });
    }, [C2]);
    (0, u.useEffect)(function() {
      var e3 = "" !== Z2.trim() ? n2.filter(function(e4) {
        var t4;
        return null === (t4 = e4.label) || void 0 === t4 ? void 0 : t4.toLowerCase().includes(Z2.toLowerCase());
      }) : n2, t3 = r2.filter(function(e4) {
        return !n2.some(function(t4) {
          return void 0 !== t4.value && null !== t4.value ? t4.value === e4.value : t4 === e4.value;
        });
      });
      Y2({ upperListOptions: e3.map(function(e4) {
        return Hn(Hn({}, e4), { isSelected: true });
      }), options: t3.map(function(e4) {
        return Hn(Hn({}, e4), { isSelected: false });
      }), totalCount: e3.length + t3.length });
    }, [Z2, r2]);
    var J2 = (0, u.useCallback)(function() {
      U2.current = false, z2(true), _2(true), C2({ search: "", page: 1 }).finally(function() {
        _2(false);
      });
    }, [C2]), $2 = (0, u.useCallback)(function() {
      U2.current = true, z2(false), W2(false), B2.current && clearTimeout(B2.current), setTimeout(function() {
        null == E2 || E2();
      }, 100);
    }, [E2]), Q2 = (0, u.useCallback)(function(e3) {
      a2(e3);
      var t3 = K2.upperListOptions.find(function(t4) {
        return t4.value === e3;
      });
      if (t3) Y2(function(n4) {
        return { upperListOptions: n4.upperListOptions.filter(function(t4) {
          return t4.value !== e3;
        }), options: Vn([Hn(Hn({}, t3), { isSelected: false })], n4.options, true), totalCount: n4.totalCount };
      });
      else {
        var n3 = K2.options.find(function(t4) {
          return t4.value === e3;
        });
        (null == n3 ? void 0 : n3.isSelected) ? Y2(function(t4) {
          return { upperListOptions: t4.upperListOptions, options: t4.options.map(function(t5) {
            return Hn(Hn({}, t5), { isSelected: t5.value !== e3 && t5.isSelected });
          }), totalCount: t4.totalCount };
        }) : Y2(function(t4) {
          return { upperListOptions: t4.upperListOptions, options: t4.options.map(function(t5) {
            return Hn(Hn({}, t5), { isSelected: t5.value === e3 || t5.isSelected });
          }), totalCount: t4.totalCount };
        });
      }
    }, [a2, K2.upperListOptions, K2.options]);
    (0, u.useEffect)(function() {
      g2 && setTimeout(function() {
        J2();
      }, 300);
    }, [g2, J2]), (0, u.useEffect)(function() {
      q2.current || (q2.current = true, 0 !== n2.length && (R2 || (_2(true), k2().finally(function() {
        _2(false);
      }))));
    }, [k2, n2.length]), (0, u.useEffect)(function() {
      return function() {
        B2.current && clearTimeout(B2.current);
      };
    }, []);
    var ee2 = (0, u.useMemo)(function() {
      return { open: R2, searchValue: Z2, selectedData: n2, data: r2, optionsListData: K2, setOpen: z2, handleClick: Q2, handleOpen: J2, handleClose: $2, handleSearchChange: X2, name: l2, disabledSelect: i2, disabledAllOptions: s2, required: f2, multiSelect: m2, showTooltipForLabel: y2, textForEmptyLabel: x2, renderValue: w2, isLoading: I2, isLoadingMore: M2, isInitialLoading: V2, isSearching: H2, hasMore: N2, currentPage: L2, totalCount: O2, onLoadMore: S2, debounceDelay: D2, clearAll: T2 };
    }, [R2, Z2, n2, r2, K2, Q2, J2, $2, X2, l2, i2, s2, f2, m2, y2, x2, w2, I2, M2, V2, H2, N2, L2, O2, S2, D2, T2]);
    return d().createElement(zn.Provider, { value: ee2 }, t2);
  }, Bn = (0, p.makeStyles)(function(e2) {
    return { formField: { width: "100%", position: "relative", "& .MuiInputLabel-root": { transform: "translate(2px, 16px) scale(1)", fontSize: "10px", fontWeight: 400, color: e2.palette.text.secondary, left: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", right: 5, "&.MuiInputLabel-shrink": { transform: "translate(2px, 8px) scale(0.8)" } }, "& .MuiSelect-icon": { display: "none !important" } }, paper: { marginTop: "5px", maxHeight: 400 }, select: { border: "1px solid ".concat(e2.palette.divider), borderRadius: "4px", background: "transparent", "& .MuiSelect-filled.MuiSelect-filled": { fontSize: "10px", paddingTop: "14px", paddingBottom: "5px", paddingRight: "50px", fontWeight: 500, color: e2.palette.text.primary }, "&:before": { content: "none" }, "&:after": { content: "none" }, "&:hover": { background: "transparent" } }, selectDisabled: { "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.12);" } }, selectError: { borderColor: e2.palette.error.main }, iconsContainer: { position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", pointerEvents: "none", zIndex: 1, gap: "4px" }, clearIcon: { display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", opacity: 0.6, transition: "opacity 0.2s ease", pointerEvents: "auto", "&:hover": { opacity: 1 } }, selectIcon: { display: "flex", alignItems: "center", justifyContent: "center", transition: "transform 0.3s ease", transform: "rotate(0deg)", pointerEvents: "none" }, selectIconOpen: { transform: "rotate(180deg)" }, selectIconDisabled: { opacity: 0.6 }, list: { padding: 0 }, labelError: { color: e2.palette.error.main }, selectNoLabel: { "& .MuiSelect-filled.MuiSelect-filled": { paddingTop: "9.5px", paddingBottom: "9.5px" } } };
  }, { name: "DynamicSelectTrigger" }), qn = function() {
    return qn = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, qn.apply(this, arguments);
  }, Un = function(e2) {
    var t2, n2, r2 = e2.children, a2 = e2.label, l2 = e2.errorMessage, o2 = e2.classNameForFormControl, i2 = e2.classnameForSelect, c2 = e2.classNameForHelperText, s2 = e2.IconComponent, u2 = void 0 === s2 ? Ct : s2, f2 = e2.formControlProps, h2 = e2.selectProps, m2 = Bn(), v2 = Fn(), g2 = v2.open, b2 = v2.selectedData, y2 = v2.name, x2 = v2.disabledSelect, w2 = v2.disabledAllOptions, C2 = v2.required, S2 = v2.renderValue, E2 = v2.handleOpen, I2 = v2.handleClose, M2 = v2.clearAll;
    return d().createElement(p.FormControl, qn({ className: Ae(m2.formField, o2), error: !!l2, required: C2 }, f2), a2 && d().createElement(d().Fragment, null, b2.length > 0 ? d().createElement(p.InputLabel, null, a2) : d().createElement(p.InputLabel, { shrink: true }, a2)), d().createElement(p.Select, qn({ labelId: "input-label", open: g2, multiple: true, displayEmpty: true, disabled: x2, required: C2, className: Ae(m2.select, (t2 = {}, t2[m2.selectDisabled] = x2, t2[m2.selectError] = !!l2, t2[m2.selectNoLabel] = !a2, t2), i2), name: y2, MenuProps: { anchorOrigin: { vertical: "bottom", horizontal: "left" }, getContentAnchorEl: null, autoFocus: false, classes: { paper: m2.paper, list: m2.list } }, variant: "filled", value: b2, renderValue: S2, onOpen: E2, onClose: I2, error: !!l2 }, h2), r2), d().createElement("div", { className: m2.iconsContainer }, b2.length > 0 && M2 && !x2 && !w2 && d().createElement("div", { className: m2.clearIcon, onClick: function(e3) {
      e3.preventDefault(), e3.stopPropagation(), !M2 || x2 || w2 || M2();
    }, onMouseDown: function(e3) {
      e3.preventDefault(), e3.stopPropagation();
    }, role: "button", "aria-label": "clear all selected values" }, d().createElement(Zt, { width: 14, height: 14 })), d().createElement("div", { className: Ae(m2.selectIcon, (n2 = {}, n2[m2.selectIconOpen] = g2, n2[m2.selectIconDisabled] = x2, n2)) }, d().createElement(u2, { width: 18, height: 18 }))), l2 && d().createElement(p.FormHelperText, { className: Ae(m2.labelError, c2) }, l2));
  }, Gn = (0, p.makeStyles)(function() {
    return { listWrapper: { minHeight: 300, position: "relative", overflowX: "hidden", display: "flex", flexDirection: "column" } };
  }, { name: "DynamicSelectContent" }), Kn = function(e2) {
    var t2 = e2.children, n2 = e2.classNameForListWrapper, r2 = e2.maxContentHeight, a2 = void 0 === r2 ? 300 : r2, l2 = Gn();
    return d().createElement("div", { className: Ae(l2.listWrapper, n2), style: { maxHeight: a2 } }, t2);
  }, Yn = (0, p.makeStyles)(function() {
    return { search: { background: "#ffffff", padding: "0 10px", zIndex: 2, position: "relative" } };
  }, { name: "DynamicSelectSearch" }), Xn = function() {
    return Xn = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, Xn.apply(this, arguments);
  }, Jn = function(e2) {
    var t2 = e2.classNameForSearchField, n2 = e2.searchFieldProps, r2 = Yn(), a2 = Fn(), l2 = a2.handleSearchChange, o2 = a2.isSearching, i2 = a2.isLoading, c2 = a2.isLoadingMore, s2 = a2.isInitialLoading, u2 = a2.debounceDelay, f2 = o2 || i2 || c2 || s2;
    return d().createElement(p.ListSubheader, { className: r2.search }, d().createElement(Kt, Xn({ className: t2, onChange: function(e3) {
      return l2({ search: e3.target.value, page: 1 });
    }, fullWidth: true, handleReset: function() {
      l2({ search: "", page: 1 });
    }, rightIcon: f2 ? d().createElement(p.CircularProgress, { size: 16 }) : void 0 }, n2, { debouncedDelay: u2 })));
  }, $n = (0, p.makeStyles)(function(e2) {
    return { itemText: { fontSize: 10, display: "flex", justifyContent: "space-between", paddingLeft: 10, paddingRight: 10, fontWeight: 600 }, activeItemText: { background: "#EEEEEE" }, name: { alignItems: "center", justifyContent: "space-between", fontSize: "12px", lineHeight: "20px", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }, nameWithCheckbox: { paddingRight: "25px" }, menuItemIcon: { position: "absolute", right: 5 }, customTooltip: { transform: "translate(10px, -10px) !important" }, selectedItemInList: { backgroundColor: "#f5f5f5 !important", "&:hover": { backgroundColor: "#eeeeee !important" } } };
  }, { name: "DynamicSelectItem" }), Qn = function(e2) {
    var t2, n2, r2 = e2.value, a2 = e2.label, l2 = e2.isDisabled, o2 = void 0 !== l2 && l2, i2 = e2.isSelected, c2 = Fn(), s2 = c2.handleClick, u2 = c2.handleClose, f2 = c2.showTooltipForLabel, h2 = c2.multiSelect, m2 = c2.textForEmptyLabel, v2 = (0, p.useTheme)(), g2 = $n(), b2 = null != m2 ? m2 : qt("\u041E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442 \u0434\u0430\u043D\u043D\u044B\u0435") + ": " + r2, y2 = void 0 !== a2 && a2 || b2;
    return d().createElement(p.MenuItem, { value: r2, key: r2, onClick: function() {
      o2 || (s2(r2), h2 || u2());
    }, onKeyDown: function(e3) {
      e3.stopPropagation(), e3.preventDefault();
    }, className: Ae(g2.itemText, (t2 = {}, t2[g2.activeItemText] = !h2 && i2, t2[g2.selectedItemInList] = i2, t2)), disabled: o2 }, d().createElement(p.Tooltip, { title: f2 && a2 || "", placement: "bottom-start", classes: { tooltip: g2.customTooltip }, PopperProps: { style: { zIndex: v2.zIndex.tooltip } } }, d().createElement("div", { className: Ae(g2.name, (n2 = {}, n2[g2.nameWithCheckbox] = h2, n2)) }, y2)), h2 && d().createElement(p.IconButton, { className: g2.menuItemIcon, size: "small" }, h2 ? i2 ? d().createElement(Ht, null) : d().createElement(Ft, null) : null));
  }, er = (0, p.makeStyles)(function(e2) {
    return { noData: { padding: "6px 10px", fontSize: 10, fontWeight: 600, color: e2.palette.text.secondary, textAlign: "center" }, name: { alignItems: "center", justifyContent: "space-between", fontSize: "12px", lineHeight: "20px", fontWeight: 500, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } };
  }, { name: "DynamicSelectList" }), tr = function(e2, t2, n2) {
    if (n2 || 2 === arguments.length) for (var r2, a2 = 0, l2 = t2.length; a2 < l2; a2++) !r2 && a2 in t2 || (r2 || (r2 = Array.prototype.slice.call(t2, 0, a2)), r2[a2] = t2[a2]);
    return e2.concat(r2 || Array.prototype.slice.call(t2));
  }, nr = function(e2) {
    var t2 = e2.renderItem, n2 = e2.maxListHeight, r2 = void 0 === n2 ? 300 : n2, a2 = Fn(), l2 = a2.optionsListData, o2 = a2.isInitialLoading, i2 = a2.isSearching, c2 = a2.isLoadingMore, s2 = a2.isLoading, p2 = a2.hasMore, f2 = a2.onLoadMore, h2 = a2.currentPage, m2 = a2.open, v2 = a2.disabledAllOptions, g2 = (0, u.useRef)(null), b2 = er(), y2 = (0, u.useCallback)(function(e3) {
      var t3 = e3.scrollOffset;
      e3.scrollUpdateWasRequested || c2 || s2 || !p2 || i2 || !m2 || t3 + (g2.current ? Math.min(32 * l2.totalCount, r2) : r2) >= 32 * l2.totalCount - 96 && f2({ page: h2 + 1 });
    }, [c2, s2, p2, l2.totalCount, f2, h2, i2, r2]), x2 = (0, u.useCallback)(function(e3) {
      var n3 = e3.index, r3 = e3.style, a3 = tr(tr([], l2.upperListOptions, true), l2.options, true), o3 = a3[n3], i3 = o3.label, c3 = o3.value, s3 = o3.isDisabled;
      return d().createElement("div", { style: r3, key: c3 }, t2 ? t2({ label: i3, value: c3, isDisabled: s3 || v2, index: n3, isSelected: a3[n3].isSelected }) : d().createElement(Qn, { key: c3, value: c3, label: i3, isDisabled: s3 || v2, isSelected: a3[n3].isSelected }));
    }, [l2.upperListOptions, l2.options, t2, v2]), w2 = (0, u.useMemo)(function() {
      var e3 = 32 * l2.totalCount;
      return Math.min(e3, r2);
    }, [l2.totalCount, r2]);
    return o2 || i2 ? d().createElement("div", { className: b2.noData }, d().createElement("div", { className: b2.name }, qt("\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u0430\u043D\u043D\u044B\u0445..."))) : 0 === l2.totalCount ? d().createElement("div", { className: b2.noData }, d().createElement("div", { className: b2.name }, qt("\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445"))) : d().createElement(bn, { ref: g2, height: w2, width: "100%", itemCount: l2.totalCount, itemSize: 32, onScroll: y2 }, x2);
  }, rr = function(e2, t2, n2, r2) {
    return new (n2 || (n2 = Promise))(function(a2, l2) {
      function o2(e3) {
        try {
          c2(r2.next(e3));
        } catch (e4) {
          l2(e4);
        }
      }
      function i2(e3) {
        try {
          c2(r2.throw(e3));
        } catch (e4) {
          l2(e4);
        }
      }
      function c2(e3) {
        var t3;
        e3.done ? a2(e3.value) : (t3 = e3.value, t3 instanceof n2 ? t3 : new n2(function(e4) {
          e4(t3);
        })).then(o2, i2);
      }
      c2((r2 = r2.apply(e2, t2 || [])).next());
    });
  }, ar = function(e2, t2) {
    var n2, r2, a2, l2, o2 = { label: 0, sent: function() {
      if (1 & a2[0]) throw a2[1];
      return a2[1];
    }, trys: [], ops: [] };
    return l2 = { next: i2(0), throw: i2(1), return: i2(2) }, "function" == typeof Symbol && (l2[Symbol.iterator] = function() {
      return this;
    }), l2;
    function i2(i3) {
      return function(c2) {
        return (function(i4) {
          if (n2) throw new TypeError("Generator is already executing.");
          for (; l2 && (l2 = 0, i4[0] && (o2 = 0)), o2; ) try {
            if (n2 = 1, r2 && (a2 = 2 & i4[0] ? r2.return : i4[0] ? r2.throw || ((a2 = r2.return) && a2.call(r2), 0) : r2.next) && !(a2 = a2.call(r2, i4[1])).done) return a2;
            switch (r2 = 0, a2 && (i4 = [2 & i4[0], a2.value]), i4[0]) {
              case 0:
              case 1:
                a2 = i4;
                break;
              case 4:
                return o2.label++, { value: i4[1], done: false };
              case 5:
                o2.label++, r2 = i4[1], i4 = [0];
                continue;
              case 7:
                i4 = o2.ops.pop(), o2.trys.pop();
                continue;
              default:
                if (!((a2 = (a2 = o2.trys).length > 0 && a2[a2.length - 1]) || 6 !== i4[0] && 2 !== i4[0])) {
                  o2 = 0;
                  continue;
                }
                if (3 === i4[0] && (!a2 || i4[1] > a2[0] && i4[1] < a2[3])) {
                  o2.label = i4[1];
                  break;
                }
                if (6 === i4[0] && o2.label < a2[1]) {
                  o2.label = a2[1], a2 = i4;
                  break;
                }
                if (a2 && o2.label < a2[2]) {
                  o2.label = a2[2], o2.ops.push(i4);
                  break;
                }
                a2[2] && o2.ops.pop(), o2.trys.pop();
                continue;
            }
            i4 = t2.call(e2, o2);
          } catch (e3) {
            i4 = [6, e3], r2 = 0;
          } finally {
            n2 = a2 = 0;
          }
          if (5 & i4[0]) throw i4[1];
          return { value: i4[0] ? i4[1] : void 0, done: true };
        })([i3, c2]);
      };
    }
  }, lr = function(e2, t2, n2) {
    if (n2 || 2 === arguments.length) for (var r2, a2 = 0, l2 = t2.length; a2 < l2; a2++) !r2 && a2 in t2 || (r2 || (r2 = Array.prototype.slice.call(t2, 0, a2)), r2[a2] = t2[a2]);
    return e2.concat(r2 || Array.prototype.slice.call(t2));
  }, or = function(e2, t2) {
    return "".concat(e2.toLowerCase().trim(), "_").concat(t2);
  }, ir = function(e2) {
    var t2 = e2.fetchData, n2 = e2.fetchInitialData, r2 = e2.itemsPerPage, a2 = void 0 === r2 ? 20 : r2, l2 = e2.cachedData, o2 = e2.selectedData, i2 = e2.setSelectedData, c2 = e2.enableCache, s2 = void 0 === c2 || c2, d2 = e2.cacheTTL, p2 = void 0 === d2 ? 3e5 : d2, f2 = (0, u.useState)([]), h2 = f2[0], m2 = f2[1], v2 = (0, u.useState)(false), g2 = v2[0], b2 = v2[1], y2 = (0, u.useState)(false), x2 = y2[0], w2 = y2[1], C2 = (0, u.useState)(false), S2 = C2[0], E2 = C2[1], I2 = (0, u.useState)(true), M2 = I2[0], O2 = I2[1], L2 = (0, u.useState)(1), k2 = L2[0], N2 = L2[1], Z2 = (0, u.useState)(0), P2 = Z2[0], D2 = Z2[1], T2 = (0, u.useState)(""), j2 = T2[0], R2 = T2[1], z2 = (0, u.useRef)(/* @__PURE__ */ new Map()), F2 = (0, u.useRef)(null), H2 = (0, u.useRef)(0), W2 = (0, u.useRef)(0), A2 = (0, u.useCallback)(function() {
      return null !== F2.current && (p2 <= 0 || Date.now() - F2.current < p2);
    }, [p2]), V2 = (0, u.useCallback)(function() {
      null === F2.current || A2() || (z2.current.clear(), F2.current = null);
    }, [A2]), _2 = (0, u.useCallback)(function(e3, t3) {
      var n3;
      if (!s2) return null;
      V2();
      var r3 = or(e3, t3);
      return null !== (n3 = z2.current.get(r3)) && void 0 !== n3 ? n3 : null;
    }, [s2, V2]), B2 = (0, u.useCallback)(function(e3, t3, n3, r3) {
      if (s2) {
        null === F2.current && (F2.current = Date.now());
        var a3 = or(e3, t3);
        z2.current.set(a3, { data: n3, count: r3 });
      }
    }, [s2]), q2 = (0, u.useCallback)(function() {
      z2.current.clear(), F2.current = null;
    }, []), U2 = (0, u.useCallback)(function() {
      return rr(void 0, void 0, void 0, function() {
        var e3, t3;
        return ar(this, function(r3) {
          switch (r3.label) {
            case 0:
              if (!n2 || !o2.length) return [2];
              b2(true), w2(true), r3.label = 1;
            case 1:
              return r3.trys.push([1, 3, 4, 5]), [4, n2()];
            case 2:
              return e3 = r3.sent(), i2(e3), e3.forEach(function(e4) {
                l2.current.set(e4.value, e4);
              }), [3, 5];
            case 3:
              return t3 = r3.sent(), console.error(t3), [3, 5];
            case 4:
              return b2(false), w2(false), [7];
            case 5:
              return [2];
          }
        });
      });
    }, [o2, n2]), G2 = (0, u.useCallback)(function(e3) {
      var n3 = e3.search, r3 = e3.page;
      return rr(void 0, void 0, void 0, function() {
        var e4, o3, i3, c3;
        return ar(this, function(s3) {
          switch (s3.label) {
            case 0:
              if (e4 = ++H2.current, W2.current += 1, E2(false), R2(n3), N2(r3), o3 = _2(n3, r3)) return e4 !== H2.current || (w2(false), m2(o3.data), D2(o3.count), O2(o3.count > o3.data.length + (r3 - 1) * a2)), [2];
              w2(true), s3.label = 1;
            case 1:
              return s3.trys.push([1, 3, 4, 5]), [4, t2({ search: n3, limit: a2, offset: (r3 - 1) * a2 })];
            case 2:
              return i3 = s3.sent(), e4 !== H2.current ? [2] : (m2(i3.data), i3.data.forEach(function(e5) {
                l2.current.set(e5.value, e5);
              }), B2(n3, r3, i3.data, i3.count), D2(i3.count), O2(i3.count > i3.data.length + (r3 - 1) * a2), [3, 5]);
            case 3:
              return c3 = s3.sent(), e4 !== H2.current ? [2] : (console.error(c3), [3, 5]);
            case 4:
              return e4 === H2.current && w2(false), [7];
            case 5:
              return [2];
          }
        });
      });
    }, [a2, _2, B2, t2]), K2 = (0, u.useCallback)(function(e3) {
      var n3 = e3.page;
      return rr(void 0, void 0, void 0, function() {
        var e4, r3, o3, i3;
        return ar(this, function(c3) {
          switch (c3.label) {
            case 0:
              if (!M2 || S2) return [2];
              if (e4 = ++W2.current, N2(n3), r3 = _2(j2, n3)) return e4 !== W2.current || (m2(function(e5) {
                return lr(lr([], e5, true), r3.data, true);
              }), D2(r3.count), O2(r3.count > r3.data.length + (n3 - 1) * a2)), [2];
              c3.label = 1;
            case 1:
              return c3.trys.push([1, 3, 4, 5]), E2(true), [4, t2({ search: j2, limit: a2, offset: (n3 - 1) * a2 })];
            case 2:
              return o3 = c3.sent(), e4 !== W2.current ? [2] : (m2(function(e5) {
                return lr(lr([], e5, true), o3.data, true);
              }), o3.data.forEach(function(e5) {
                l2.current.set(e5.value, e5);
              }), B2(j2, n3, o3.data, o3.count), D2(o3.count), O2(o3.count > o3.data.length + (n3 - 1) * a2), [3, 5]);
            case 3:
              return i3 = c3.sent(), e4 !== W2.current ? [2] : (console.error(i3), [3, 5]);
            case 4:
              return e4 === W2.current && E2(false), [7];
            case 5:
              return [2];
          }
        });
      });
    }, [a2, j2, M2, S2, _2, B2, t2]), Y2 = (0, u.useCallback)(function() {
      m2([]), R2(""), N2(1), O2(true);
    }, []);
    return (0, u.useMemo)(function() {
      return { getInitialDataInfo: U2, getFoundDataInfo: G2, getMoreDataInfo: K2, selectedData: o2, data: h2, isLoading: x2, isLoadingMore: S2, hasMore: M2, totalCount: P2, searchValue: j2, currentPage: k2, setData: m2, setHasMore: O2, setSearchValue: R2, setCurrentPage: N2, setSelectedData: i2, onClose: Y2, cachedData: l2, isLoadingInitialData: g2, clearSearchCache: q2 };
    }, [U2, G2, K2, o2, h2, x2, S2, M2, P2, j2, k2, g2, q2]);
  }, cr = (0, u.createContext)(void 0), sr = function() {
    var e2 = (0, u.useContext)(cr);
    if (void 0 === e2) throw new Error("useDynamicTreeSelectContext must be used within a DynamicTreeSelectRoot");
    return e2;
  }, ur = function() {
    return ur = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, ur.apply(this, arguments);
  }, dr = function(e2, t2, n2, r2) {
    return new (n2 || (n2 = Promise))(function(a2, l2) {
      function o2(e3) {
        try {
          c2(r2.next(e3));
        } catch (e4) {
          l2(e4);
        }
      }
      function i2(e3) {
        try {
          c2(r2.throw(e3));
        } catch (e4) {
          l2(e4);
        }
      }
      function c2(e3) {
        var t3;
        e3.done ? a2(e3.value) : (t3 = e3.value, t3 instanceof n2 ? t3 : new n2(function(e4) {
          e4(t3);
        })).then(o2, i2);
      }
      c2((r2 = r2.apply(e2, t2 || [])).next());
    });
  }, pr = function(e2, t2) {
    var n2, r2, a2, l2, o2 = { label: 0, sent: function() {
      if (1 & a2[0]) throw a2[1];
      return a2[1];
    }, trys: [], ops: [] };
    return l2 = { next: i2(0), throw: i2(1), return: i2(2) }, "function" == typeof Symbol && (l2[Symbol.iterator] = function() {
      return this;
    }), l2;
    function i2(i3) {
      return function(c2) {
        return (function(i4) {
          if (n2) throw new TypeError("Generator is already executing.");
          for (; l2 && (l2 = 0, i4[0] && (o2 = 0)), o2; ) try {
            if (n2 = 1, r2 && (a2 = 2 & i4[0] ? r2.return : i4[0] ? r2.throw || ((a2 = r2.return) && a2.call(r2), 0) : r2.next) && !(a2 = a2.call(r2, i4[1])).done) return a2;
            switch (r2 = 0, a2 && (i4 = [2 & i4[0], a2.value]), i4[0]) {
              case 0:
              case 1:
                a2 = i4;
                break;
              case 4:
                return o2.label++, { value: i4[1], done: false };
              case 5:
                o2.label++, r2 = i4[1], i4 = [0];
                continue;
              case 7:
                i4 = o2.ops.pop(), o2.trys.pop();
                continue;
              default:
                if (!((a2 = (a2 = o2.trys).length > 0 && a2[a2.length - 1]) || 6 !== i4[0] && 2 !== i4[0])) {
                  o2 = 0;
                  continue;
                }
                if (3 === i4[0] && (!a2 || i4[1] > a2[0] && i4[1] < a2[3])) {
                  o2.label = i4[1];
                  break;
                }
                if (6 === i4[0] && o2.label < a2[1]) {
                  o2.label = a2[1], a2 = i4;
                  break;
                }
                if (a2 && o2.label < a2[2]) {
                  o2.label = a2[2], o2.ops.push(i4);
                  break;
                }
                a2[2] && o2.ops.pop(), o2.trys.pop();
                continue;
            }
            i4 = t2.call(e2, o2);
          } catch (e3) {
            i4 = [6, e3], r2 = 0;
          } finally {
            n2 = a2 = 0;
          }
          if (5 & i4[0]) throw i4[1];
          return { value: i4[0] ? i4[1] : void 0, done: true };
        })([i3, c2]);
      };
    }
  }, fr = function(e2, t2, n2) {
    if (n2 || 2 === arguments.length) for (var r2, a2 = 0, l2 = t2.length; a2 < l2; a2++) !r2 && a2 in t2 || (r2 || (r2 = Array.prototype.slice.call(t2, 0, a2)), r2[a2] = t2[a2]);
    return e2.concat(r2 || Array.prototype.slice.call(t2));
  }, hr = function(e2) {
    var t2 = e2.children, n2 = e2.selectedIds, r2 = e2.setSelectedIds, a2 = e2.treeData, l2 = e2.setTreeData, o2 = e2.searchValue, i2 = e2.onSearch, c2 = e2.onClose, s2 = e2.loadInitialData, p2 = e2.isLoading, f2 = e2.cachedData, h2 = e2.name, m2 = e2.disabledSelect, v2 = void 0 !== m2 && m2, g2 = e2.disabledAllOptions, b2 = void 0 !== g2 && g2, y2 = e2.required, x2 = void 0 !== y2 && y2, w2 = e2.multiSelect, C2 = void 0 !== w2 && w2, S2 = e2.autoOpen, E2 = void 0 !== S2 && S2, I2 = e2.showTooltipForLabel, M2 = void 0 !== I2 && I2, O2 = e2.textForEmptyLabel, L2 = e2.renderValue, k2 = e2.debounceDelay, N2 = void 0 === k2 ? 300 : k2, Z2 = (e2.minSearchLength, e2.loadNodesByParentId), P2 = e2.showLine, D2 = void 0 !== P2 && P2, T2 = e2.onNodeClick, j2 = e2.clearAll, R2 = (0, u.useState)(false), z2 = R2[0], F2 = R2[1], H2 = (0, u.useState)(false), W2 = H2[0], A2 = H2[1], V2 = (0, u.useState)(false), _2 = V2[0], B2 = V2[1], q2 = (0, u.useState)(/* @__PURE__ */ new Set()), U2 = q2[0], G2 = q2[1], K2 = (0, u.useState)(/* @__PURE__ */ new Set()), Y2 = K2[0], X2 = K2[1], J2 = (0, u.useRef)(null), $2 = (0, u.useRef)(false), Q2 = (0, u.useRef)(false), ee2 = (0, u.useRef)(""), te2 = (0, u.useMemo)(function() {
      return (function(e3, t3) {
        void 0 === t3 && (t3 = /* @__PURE__ */ new Set());
        var n3 = /* @__PURE__ */ new Map();
        e3.forEach(function(e4) {
          return n3.set(e4.id, e4);
        });
        var r3 = (function(e4) {
          var t4 = /* @__PURE__ */ new Map();
          return e4.forEach(function(e5) {
            var n4, r4 = null !== (n4 = e5.parentId) && void 0 !== n4 ? n4 : null;
            t4.has(r4) || t4.set(r4, []), t4.get(r4).push(e5);
          }), t4;
        })(e3), a3 = [], l3 = /* @__PURE__ */ new Set(), o3 = function(e4) {
          var i3, c3;
          if (!l3.has(e4.id)) {
            l3.add(e4.id);
            var s3 = (function(e5, t4) {
              for (var n4 = 0, r4 = e5.parentId; null != r4; ) {
                var a4 = t4.get(r4);
                if (!a4) break;
                n4++, r4 = a4.parentId;
              }
              return n4;
            })(e4, n3), u2 = (function(e5, t4) {
              for (var n4 = [e5.id], r4 = e5.parentId; null != r4; ) {
                var a4 = t4.get(r4);
                if (!a4) break;
                n4.unshift(r4), r4 = a4.parentId;
              }
              return n4;
            })(e4, n3), d2 = t3.has(e4.id), p3 = r3.get(e4.id) || [], f3 = p3.map(function(e5) {
              return e5.id;
            }), h3 = f3.length > 0;
            a3.push({ id: e4.id, label: e4.label, level: s3, parentId: null !== (i3 = e4.parentId) && void 0 !== i3 ? i3 : null, isExpanded: d2, isSelected: false, isIndeterminate: false, hasChildren: null !== (c3 = e4.hasChildren) && void 0 !== c3 ? c3 : h3, isDisabled: e4.isDisabled, isVisible: true, isLoading: e4.isLoading, children: f3, path: u2, originalNode: e4 }), d2 && h3 && p3.forEach(o3);
          }
        };
        return (r3.get(null) || []).forEach(o3), e3.forEach(function(e4) {
          var i3, c3;
          if (!(l3.has(e4.id) || null != e4.parentId && n3.has(e4.parentId))) {
            var s3 = r3.get(e4.id) || [], u2 = s3.map(function(e5) {
              return e5.id;
            }), d2 = u2.length > 0;
            a3.push({ id: e4.id, label: e4.label, level: 0, parentId: null !== (i3 = e4.parentId) && void 0 !== i3 ? i3 : null, isExpanded: t3.has(e4.id), isSelected: false, isIndeterminate: false, hasChildren: null !== (c3 = e4.hasChildren) && void 0 !== c3 ? c3 : d2, isDisabled: e4.isDisabled, isVisible: true, isLoading: e4.isLoading, children: u2, path: [e4.id], originalNode: e4 }), l3.add(e4.id), t3.has(e4.id) && d2 && s3.forEach(o3);
          }
        }), a3;
      })(a2, U2);
    }, [a2, U2]), ne2 = (0, u.useMemo)(function() {
      var e3 = new Set(n2);
      return te2.map(function(t3) {
        var n3 = e3.has(t3.id), r3 = Y2.has(t3.id) || t3.isLoading, a3 = false;
        if (!n3 && t3.children.length > 0) {
          var l3 = (function(e4, t4) {
            var n4 = [];
            if (!e4.find(function(e5) {
              return e5.id === t4;
            })) return n4;
            var r4 = function(t5) {
              e4.filter(function(e5) {
                return e5.parentId === t5;
              }).forEach(function(e5) {
                n4.push(e5.id), e5.children.length > 0 && r4(e5.id);
              });
            };
            return r4(t4), n4;
          })(te2, t3.id), o3 = l3.filter(function(t4) {
            return e3.has(t4);
          });
          a3 = o3.length > 0 && o3.length < l3.length;
        }
        return ur(ur({}, t3), { isSelected: n3, isIndeterminate: a3, isLoading: r3 });
      });
    }, [te2, n2, Y2]), re2 = (0, u.useMemo)(function() {
      return ne2;
    }, [ne2]), ae2 = (0, u.useMemo)(function() {
      return n2.map(function(e3) {
        var t3, n3, r3;
        return null !== (r3 = null !== (t3 = a2.find(function(t4) {
          return t4.id === e3;
        })) && void 0 !== t3 ? t3 : null === (n3 = ne2.find(function(t4) {
          return t4.id === e3;
        })) || void 0 === n3 ? void 0 : n3.originalNode) && void 0 !== r3 ? r3 : null == f2 ? void 0 : f2.current.get(e3);
      }).filter(function(e3) {
        return null != e3;
      });
    }, [a2, n2, f2, ne2]);
    (0, u.useEffect)(function() {
      !ee2.current.trim() && o2.trim() && G2(/* @__PURE__ */ new Set()), ee2.current = o2;
    }, [o2]);
    var le2 = (0, u.useCallback)(function(e3) {
      var t3 = e3.search;
      return dr(void 0, void 0, void 0, function() {
        return pr(this, function(e4) {
          return Q2.current || (J2.current && clearTimeout(J2.current), J2.current = setTimeout(function() {
            return dr(void 0, void 0, void 0, function() {
              return pr(this, function(e5) {
                switch (e5.label) {
                  case 0:
                    return e5.trys.push([0, , 2, 3]), A2(true), [4, i2({ search: t3 })];
                  case 1:
                    return e5.sent(), [3, 3];
                  case 2:
                    return A2(false), [7];
                  case 3:
                    return [2];
                }
              });
            });
          }, N2)), [2];
        });
      });
    }, [i2, N2]), oe2 = (0, u.useCallback)(function() {
      Q2.current = false, F2(true), B2(true), i2({ search: "" }).finally(function() {
        B2(false);
      });
    }, [i2]), ie2 = (0, u.useCallback)(function() {
      Q2.current = true, F2(false), A2(false), B2(false), G2(/* @__PURE__ */ new Set()), ee2.current = "", J2.current && clearTimeout(J2.current), setTimeout(function() {
        return c2();
      }, 100);
    }, [c2]), ce2 = (0, u.useCallback)(function(e3) {
      return dr(void 0, void 0, void 0, function() {
        return pr(this, function(t3) {
          switch (t3.label) {
            case 0:
              return [4, Z2(e3)];
            case 1:
              return t3.sent(), [2];
          }
        });
      });
    }, [Z2, l2, f2]), se2 = ce2, ue2 = (0, u.useCallback)(function(e3) {
      var t3, a3 = re2, l3 = a3.find(function(t4) {
        return t4.id === e3;
      });
      l3 && (null == l3 ? void 0 : l3.isDisabled) || (t3 = T2 && l3 ? T2(e3, l3, n2, a3) : C2 ? n2.includes(e3) ? n2.filter(function(t4) {
        return t4 !== e3;
      }) : fr(fr([], n2, true), [e3], false) : [e3], r2(t3));
    }, [re2, n2, C2, T2, r2]), de2 = (0, u.useCallback)(function(e3) {
      return dr(void 0, void 0, void 0, function() {
        var t3, n3, r3;
        return pr(this, function(a3) {
          switch (a3.label) {
            case 0:
              if (!(t3 = re2.find(function(t4) {
                return t4.id === e3;
              }))) return [2];
              if ((n3 = U2.has(e3)) || !se2 || !t3.hasChildren) return [3, 5];
              X2(function(t4) {
                return new Set(t4).add(e3);
              }), a3.label = 1;
            case 1:
              return a3.trys.push([1, 3, 4, 5]), [4, se2(t3.originalNode)];
            case 2:
              return a3.sent(), [3, 5];
            case 3:
              return r3 = a3.sent(), console.error("Failed to load tree node data:", r3), [3, 5];
            case 4:
              return X2(function(t4) {
                var n4 = new Set(t4);
                return n4.delete(e3), n4;
              }), [7];
            case 5:
              return G2(function(t4) {
                var r4 = new Set(t4);
                return n3 ? r4.delete(e3) : r4.add(e3), r4;
              }), [2];
          }
        });
      });
    }, [U2, re2, se2]);
    (0, u.useEffect)(function() {
      E2 && setTimeout(function() {
        return oe2();
      }, 300);
    }, [E2, oe2]), (0, u.useEffect)(function() {
      $2.current || 0 !== n2.length && ($2.current = true, z2 || (B2(true), s2().finally(function() {
        B2(false);
      })));
    }, [s2, n2.length]), (0, u.useEffect)(function() {
      return function() {
        J2.current && clearTimeout(J2.current);
      };
    }, []);
    var pe2 = (0, u.useMemo)(function() {
      return { open: z2, searchValue: o2, selectedNodes: ae2, flatNodes: ne2, visibleNodes: re2, setOpen: F2, handleNodeClick: ue2, handleNodeExpand: de2, handleOpen: oe2, onClose: ie2, handleSearchChange: le2, name: h2, disabledSelect: v2, disabledAllOptions: b2, required: x2, multiSelect: C2, showTooltipForLabel: M2, textForEmptyLabel: O2, renderValue: null != L2 ? L2 : function() {
        return "";
      }, isLoading: p2, isInitialLoading: _2, isSearching: W2, loadData: se2, debounceDelay: N2, showLine: D2, clearAll: j2, setLoadingKeys: X2, loadingKeys: Y2 };
    }, [z2, o2, ae2, ne2, re2, ue2, de2, oe2, ie2, le2, h2, v2, b2, x2, C2, M2, O2, L2, p2, _2, W2, se2, N2, D2, j2, Y2]);
    return d().createElement(cr.Provider, { value: pe2 }, t2);
  }, mr = function(e2, t2, n2, r2) {
    return new (n2 || (n2 = Promise))(function(a2, l2) {
      function o2(e3) {
        try {
          c2(r2.next(e3));
        } catch (e4) {
          l2(e4);
        }
      }
      function i2(e3) {
        try {
          c2(r2.throw(e3));
        } catch (e4) {
          l2(e4);
        }
      }
      function c2(e3) {
        var t3;
        e3.done ? a2(e3.value) : (t3 = e3.value, t3 instanceof n2 ? t3 : new n2(function(e4) {
          e4(t3);
        })).then(o2, i2);
      }
      c2((r2 = r2.apply(e2, t2 || [])).next());
    });
  }, vr = function(e2, t2) {
    var n2, r2, a2, l2, o2 = { label: 0, sent: function() {
      if (1 & a2[0]) throw a2[1];
      return a2[1];
    }, trys: [], ops: [] };
    return l2 = { next: i2(0), throw: i2(1), return: i2(2) }, "function" == typeof Symbol && (l2[Symbol.iterator] = function() {
      return this;
    }), l2;
    function i2(i3) {
      return function(c2) {
        return (function(i4) {
          if (n2) throw new TypeError("Generator is already executing.");
          for (; l2 && (l2 = 0, i4[0] && (o2 = 0)), o2; ) try {
            if (n2 = 1, r2 && (a2 = 2 & i4[0] ? r2.return : i4[0] ? r2.throw || ((a2 = r2.return) && a2.call(r2), 0) : r2.next) && !(a2 = a2.call(r2, i4[1])).done) return a2;
            switch (r2 = 0, a2 && (i4 = [2 & i4[0], a2.value]), i4[0]) {
              case 0:
              case 1:
                a2 = i4;
                break;
              case 4:
                return o2.label++, { value: i4[1], done: false };
              case 5:
                o2.label++, r2 = i4[1], i4 = [0];
                continue;
              case 7:
                i4 = o2.ops.pop(), o2.trys.pop();
                continue;
              default:
                if (!((a2 = (a2 = o2.trys).length > 0 && a2[a2.length - 1]) || 6 !== i4[0] && 2 !== i4[0])) {
                  o2 = 0;
                  continue;
                }
                if (3 === i4[0] && (!a2 || i4[1] > a2[0] && i4[1] < a2[3])) {
                  o2.label = i4[1];
                  break;
                }
                if (6 === i4[0] && o2.label < a2[1]) {
                  o2.label = a2[1], a2 = i4;
                  break;
                }
                if (a2 && o2.label < a2[2]) {
                  o2.label = a2[2], o2.ops.push(i4);
                  break;
                }
                a2[2] && o2.ops.pop(), o2.trys.pop();
                continue;
            }
            i4 = t2.call(e2, o2);
          } catch (e3) {
            i4 = [6, e3], r2 = 0;
          } finally {
            n2 = a2 = 0;
          }
          if (5 & i4[0]) throw i4[1];
          return { value: i4[0] ? i4[1] : void 0, done: true };
        })([i3, c2]);
      };
    }
  }, gr = function(e2, t2, n2) {
    if (n2 || 2 === arguments.length) for (var r2, a2 = 0, l2 = t2.length; a2 < l2; a2++) !r2 && a2 in t2 || (r2 || (r2 = Array.prototype.slice.call(t2, 0, a2)), r2[a2] = t2[a2]);
    return e2.concat(r2 || Array.prototype.slice.call(t2));
  }, br = function(e2) {
    return "".concat(e2.toLowerCase().trim());
  }, yr = function(e2) {
    var t2 = e2.fetchData, n2 = e2.fetchInitialData, r2 = e2.initialTreeData, a2 = void 0 === r2 ? [] : r2, l2 = e2.cachedData, o2 = e2.selectedIds, i2 = e2.setSelectedIds, c2 = e2.enableCache, s2 = void 0 === c2 || c2, d2 = e2.cacheTTL, p2 = void 0 === d2 ? 3e5 : d2, f2 = e2.onCloseCallback, h2 = e2.onLoadNodesByParentId, m2 = (0, u.useState)(a2), v2 = m2[0], g2 = m2[1], b2 = (0, u.useState)(""), y2 = b2[0], x2 = b2[1], w2 = (0, u.useState)(false), C2 = w2[0], S2 = w2[1], E2 = (0, u.useRef)(/* @__PURE__ */ new Map()), I2 = (0, u.useRef)(null), M2 = (0, u.useRef)(/* @__PURE__ */ new Set()), O2 = (0, u.useRef)(0), L2 = (0, u.useCallback)(function() {
      return null !== I2.current && (p2 <= 0 || Date.now() - I2.current < p2);
    }, [p2]), k2 = (0, u.useCallback)(function() {
      null === I2.current || L2() || (E2.current.clear(), I2.current = null);
    }, [L2]), N2 = (0, u.useCallback)(function(e3) {
      var t3;
      if (!s2) return null;
      k2();
      var n3 = br(e3);
      return null !== (t3 = E2.current.get(n3)) && void 0 !== t3 ? t3 : null;
    }, [s2, k2]), Z2 = (0, u.useCallback)(function(e3, t3) {
      if (s2) {
        null === I2.current && (I2.current = Date.now());
        var n3 = br(e3);
        E2.current.set(n3, { data: t3 });
      }
    }, [s2]), P2 = (0, u.useCallback)(function() {
      E2.current.clear(), I2.current = null;
    }, []), D2 = (0, u.useCallback)(function(e3) {
      for (var t3 = 0, n3 = e3; t3 < n3.length; t3++) {
        var r3 = n3[t3];
        l2.current.set(r3.id, r3);
      }
    }, [l2]), T2 = (0, u.useCallback)(function(e3) {
      return mr(void 0, void 0, void 0, function() {
        var n3, r3, a3, l3, o3, i3;
        return vr(this, function(c3) {
          switch (c3.label) {
            case 0:
              if (n3 = e3.search, r3 = ++O2.current, x2(n3), a3 = N2(n3)) return r3 !== O2.current || (g2(a3.data), D2(a3.data)), [2];
              S2(true), c3.label = 1;
            case 1:
              return c3.trys.push([1, 3, 4, 5]), [4, t2(e3)];
            case 2:
              return l3 = c3.sent(), r3 !== O2.current ? [2] : (o3 = l3.data, g2(o3), D2(o3), Z2(n3, o3), [3, 5]);
            case 3:
              return i3 = c3.sent(), r3 !== O2.current ? [2] : (console.error("Failed to fetch tree data:", i3), g2([]), [3, 5]);
            case 4:
              return r3 === O2.current && S2(false), [7];
            case 5:
              return [2];
          }
        });
      });
    }, [t2, N2, Z2, D2]), j2 = (0, u.useCallback)(function(e3) {
      return mr(void 0, void 0, void 0, function() {
        var t3, n3;
        return vr(this, function(r3) {
          switch (r3.label) {
            case 0:
              return M2.current.has(e3.id) ? ((t3 = Array.from(l2.current.values()).filter(function(t4) {
                return t4.parentId === e3.id;
              })).length > 0 && g2(function(e4) {
                var n4 = new Set(e4.map(function(e5) {
                  return e5.id;
                })), r4 = t3.filter(function(e5) {
                  return !n4.has(e5.id);
                });
                return 0 === r4.length ? e4 : gr(gr([], e4, true), r4, true);
              }), [3, 3]) : [3, 1];
            case 1:
              return [4, h2(e3)];
            case 2:
              n3 = r3.sent(), D2(n3), g2(function(e4) {
                return gr(gr([], e4, true), n3, true);
              }), M2.current.add(e3.id), r3.label = 3;
            case 3:
              return [2];
          }
        });
      });
    }, [h2, D2]), R2 = (0, u.useCallback)(function() {
      x2(""), null == f2 || f2(), a2.length > 0 && g2(a2);
    }, [a2, f2]), z2 = (0, u.useCallback)(function() {
      return mr(void 0, void 0, void 0, function() {
        var e3, t3;
        return vr(this, function(r3) {
          switch (r3.label) {
            case 0:
              if (!n2 || !o2.length) return [2];
              S2(true), r3.label = 1;
            case 1:
              return r3.trys.push([1, 3, 4, 5]), [4, n2()];
            case 2:
              return e3 = r3.sent(), g2(e3), D2(e3), [3, 5];
            case 3:
              return t3 = r3.sent(), console.error("Failed to load initial tree data:", t3), [3, 5];
            case 4:
              return S2(false), [7];
            case 5:
              return [2];
          }
        });
      });
    }, [n2, D2, o2]);
    return (0, u.useMemo)(function() {
      return { selectedIds: o2, setSelectedIds: i2, treeData: v2, setTreeData: g2, searchValue: y2, getFoundDataInfo: T2, isLoading: C2, onClose: R2, getInitialDataInfo: z2, cachedData: l2, clearSearchCache: P2, loadNodesByParentId: j2 };
    }, [o2, i2, v2, y2, T2, C2, R2, z2, l2, P2, j2]);
  }, xr = (0, p.makeStyles)(function() {
    return { listWrapper: { position: "relative", display: "flex", flexDirection: "column", width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", overflow: "hidden" } };
  }, { name: "DynamicTreeSelectContent" }), wr = function(e2) {
    var t2 = e2.children, n2 = e2.classNameForListWrapper, r2 = xr();
    return d().createElement("div", { className: Ae(r2.listWrapper, n2) }, t2);
  }, Cr = (0, p.makeStyles)(function(e2) {
    return { item: { display: "flex", alignItems: "center", paddingInline: 8, cursor: "pointer", fontSize: "12px", userSelect: "none", width: "100%", maxWidth: "100%", minWidth: 0, height: "auto", padding: 0, borderRadius: "4px", boxSizing: "border-box" }, itemDisabled: { opacity: 0.5, cursor: "not-allowed", "&:hover": { backgroundColor: "transparent" } }, itemSelected: { backgroundColor: (0, p.alpha)(e2.palette.primary.main, 0.15), "&:hover": { backgroundColor: (0, p.alpha)(e2.palette.primary.main, 0.15) } }, labelWrapper: { display: "flex", flexDirection: "column", alignItems: "stretch", justifyContent: "center", minWidth: 0, flex: "1 1 0%" }, label: { minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, additionalLabel: { color: e2.palette.text.secondary, fontSize: "10px", lineHeight: 1.2, minWidth: 0, width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, customTooltip: { transform: "translate(10px, -10px) !important" } };
  }, { name: "DynamicTreeSelectItemRow" }), Sr = function(e2) {
    return !!e2 && e2.scrollWidth > e2.clientWidth + 1;
  }, Er = function(e2) {
    return null != e2 && null != e2;
  }, Ir = function(e2) {
    var t2, n2 = e2.label, r2 = e2.additionalLabel, a2 = e2.disabled, l2 = void 0 !== a2 && a2, o2 = e2.selected, i2 = void 0 !== o2 && o2, c2 = e2.onClick, s2 = e2.onContextMenu, f2 = e2.showTooltip, h2 = void 0 !== f2 && f2, m2 = e2.className, v2 = e2.component, g2 = void 0 === v2 ? "li" : v2, b2 = e2.isAdvancedItem, y2 = void 0 !== b2 && b2, x2 = Cr(), w2 = (0, u.useRef)(null), C2 = (0, u.useRef)(null), S2 = (0, u.useState)(false), E2 = S2[0], I2 = S2[1], M2 = (0, u.useState)(false), O2 = M2[0], L2 = M2[1], k2 = (0, p.useTheme)(), N2 = (0, u.useCallback)(function() {
      if (!h2) return I2(false), void L2(false);
      I2(Sr(w2.current)), Er(r2) ? L2(Sr(C2.current)) : L2(false);
    }, [h2, r2]);
    (0, u.useLayoutEffect)(function() {
      N2();
    }, [n2, N2]), (0, u.useLayoutEffect)(function() {
      if (h2 && "undefined" != typeof ResizeObserver) {
        var e3 = new ResizeObserver(function() {
          N2();
        }), t3 = w2.current, n3 = C2.current;
        return t3 && e3.observe(t3), n3 && e3.observe(n3), function() {
          return e3.disconnect();
        };
      }
    }, [h2, n2, r2, N2]);
    var Z2 = h2 && E2, P2 = h2 && Er(r2) && O2;
    return d().createElement(p.MenuItem, { component: g2, className: Ae(x2.item, (t2 = {}, t2[x2.itemDisabled] = l2, t2[x2.itemSelected] = i2, t2), m2), style: { minHeight: Er(r2) || y2 ? "30px" : "24px" }, onClick: c2, onContextMenu: s2, disabled: l2 }, d().createElement("div", { className: x2.labelWrapper }, d().createElement(p.Tooltip, { title: Z2 ? n2 : "", placement: "bottom-start", classes: { tooltip: x2.customTooltip }, disableHoverListener: !Z2, disableFocusListener: !Z2, disableTouchListener: !Z2, PopperProps: { style: { zIndex: k2.zIndex.tooltip } } }, d().createElement("div", { ref: w2, className: x2.label }, n2)), Er(r2) && d().createElement(p.Tooltip, { title: P2 && null != r2 ? r2 : "", placement: "bottom-start", classes: { tooltip: x2.customTooltip }, disableHoverListener: !P2, disableFocusListener: !P2, disableTouchListener: !P2, PopperProps: { style: { zIndex: k2.zIndex.tooltip } } }, d().createElement("div", { ref: C2, className: x2.additionalLabel }, r2))));
  }, Mr = (0, p.makeStyles)(function(e2) {
    return { wrapper: { display: "flex", alignItems: "flex-start", padding: 0, fontSize: "12px", userSelect: "none", width: "100%", minWidth: 0 }, itemRowFlex: { flex: "1 1 0%", minWidth: 0 }, expandIconWrapper: { display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px", "&:hover": { backgroundColor: e2.palette.action.hover }, cursor: "pointer", marginRight: 4 }, expandIcon: { display: "flex", alignItems: "center", justifyContent: "center", transition: "transform 0.3s ease", flexShrink: 0 }, expandIconExpanded: { transform: "rotate(90deg)" }, expandIconPlaceholder: { width: "16px", height: "16px", marginRight: "4px", flexShrink: 0 } };
  }, { name: "DynamicTreeSelectItem" }), Or = function() {
    return Or = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, Or.apply(this, arguments);
  }, Lr = function(e2) {
    var t2, n2 = e2.node, r2 = e2.classNameForItem, a2 = e2.classNameForRow, l2 = e2.style, o2 = e2.isAdvancedItem, i2 = e2.maxWidth, c2 = e2.onNodeContextMenu, s2 = e2.onContextMenuItem, f2 = Mr(), h2 = sr(), m2 = h2.handleNodeClick, v2 = h2.handleNodeExpand, g2 = h2.disabledAllOptions, b2 = h2.showTooltipForLabel, y2 = h2.selectedNodes, x2 = h2.visibleNodes, w2 = h2.setLoadingKeys, C2 = (0, u.useCallback)(function(e3) {
      return t3 = void 0, r3 = void 0, l3 = function() {
        var t4;
        return (function(e4, t5) {
          var n3, r4, a4, l4, o3 = { label: 0, sent: function() {
            if (1 & a4[0]) throw a4[1];
            return a4[1];
          }, trys: [], ops: [] };
          return l4 = { next: i3(0), throw: i3(1), return: i3(2) }, "function" == typeof Symbol && (l4[Symbol.iterator] = function() {
            return this;
          }), l4;
          function i3(i4) {
            return function(c3) {
              return (function(i5) {
                if (n3) throw new TypeError("Generator is already executing.");
                for (; l4 && (l4 = 0, i5[0] && (o3 = 0)), o3; ) try {
                  if (n3 = 1, r4 && (a4 = 2 & i5[0] ? r4.return : i5[0] ? r4.throw || ((a4 = r4.return) && a4.call(r4), 0) : r4.next) && !(a4 = a4.call(r4, i5[1])).done) return a4;
                  switch (r4 = 0, a4 && (i5 = [2 & i5[0], a4.value]), i5[0]) {
                    case 0:
                    case 1:
                      a4 = i5;
                      break;
                    case 4:
                      return o3.label++, { value: i5[1], done: false };
                    case 5:
                      o3.label++, r4 = i5[1], i5 = [0];
                      continue;
                    case 7:
                      i5 = o3.ops.pop(), o3.trys.pop();
                      continue;
                    default:
                      if (!((a4 = (a4 = o3.trys).length > 0 && a4[a4.length - 1]) || 6 !== i5[0] && 2 !== i5[0])) {
                        o3 = 0;
                        continue;
                      }
                      if (3 === i5[0] && (!a4 || i5[1] > a4[0] && i5[1] < a4[3])) {
                        o3.label = i5[1];
                        break;
                      }
                      if (6 === i5[0] && o3.label < a4[1]) {
                        o3.label = a4[1], a4 = i5;
                        break;
                      }
                      if (a4 && o3.label < a4[2]) {
                        o3.label = a4[2], o3.ops.push(i5);
                        break;
                      }
                      a4[2] && o3.ops.pop(), o3.trys.pop();
                      continue;
                  }
                  i5 = t5.call(e4, o3);
                } catch (e5) {
                  i5 = [6, e5], r4 = 0;
                } finally {
                  n3 = a4 = 0;
                }
                if (5 & i5[0]) throw i5[1];
                return { value: i5[0] ? i5[1] : void 0, done: true };
              })([i4, c3]);
            };
          }
        })(this, function(r4) {
          switch (r4.label) {
            case 0:
              if (e3.stopPropagation(), !c2 && !s2) return [2];
              t4 = y2.map(function(e4) {
                return e4.id;
              }), w2(function(e4) {
                return new Set(e4).add(n2.id);
              }), r4.label = 1;
            case 1:
              return r4.trys.push([1, , 4, 5]), [4, Promise.resolve(null == c2 ? void 0 : c2(e3, n2.id, n2, t4, x2))];
            case 2:
              return r4.sent(), [4, Promise.resolve(null == s2 ? void 0 : s2(e3, n2.id, n2, t4, x2))];
            case 3:
              return r4.sent(), [3, 5];
            case 4:
              return w2(function(e4) {
                var t5 = new Set(e4);
                return t5.delete(n2.id), t5;
              }), [7];
            case 5:
              return [2];
          }
        });
      }, new ((a3 = void 0) || (a3 = Promise))(function(e4, n3) {
        function o3(e5) {
          try {
            c3(l3.next(e5));
          } catch (e6) {
            n3(e6);
          }
        }
        function i3(e5) {
          try {
            c3(l3.throw(e5));
          } catch (e6) {
            n3(e6);
          }
        }
        function c3(t4) {
          var n4;
          t4.done ? e4(t4.value) : (n4 = t4.value, n4 instanceof a3 ? n4 : new a3(function(e5) {
            e5(n4);
          })).then(o3, i3);
        }
        c3((l3 = l3.apply(t3, r3 || [])).next());
      });
      // removed by dead control flow
 var t3, r3, a3, l3; 
    }, [n2, c2, s2, y2, x2, w2]), S2 = function(e3) {
      e3.stopPropagation(), n2.hasChildren && v2(n2.id);
    }, E2 = 0 === n2.level ? 10 : 24 * n2.level, I2 = "".concat(E2, "px"), M2 = (0, u.useMemo)(function() {
      if (i2) return i2 + E2 + (o2 ? 30 : 24);
    }, [i2, o2, n2.level, E2]);
    return d().createElement("div", { className: Ae(f2.wrapper, a2), style: Or(Or(Or({}, l2), { paddingLeft: I2 }), null != M2 ? { display: "inline-flex", width: "auto", maxWidth: M2, minWidth: i2 } : {}) }, (function() {
      var e3;
      return n2.isLoading ? d().createElement("div", { className: f2.expandIconWrapper, style: { width: o2 ? "30px" : "24px", height: o2 ? "30px" : "24px" } }, d().createElement(p.CircularProgress, { size: 12 })) : n2.hasChildren ? d().createElement("div", { className: f2.expandIconWrapper, style: { width: o2 ? "30px" : "24px", height: o2 ? "30px" : "24px" }, onClick: S2 }, d().createElement("div", { className: Ae(f2.expandIcon, (e3 = {}, e3[f2.expandIconExpanded] = n2.isExpanded, e3)) }, d().createElement(Mt, { width: 14, height: 14 }))) : d().createElement("div", { className: f2.expandIconPlaceholder, style: { width: o2 ? "30px" : "24px", height: o2 ? "30px" : "24px" } });
    })(), d().createElement(Ir, { label: n2.label, additionalLabel: null === (t2 = n2.originalNode) || void 0 === t2 ? void 0 : t2.additionalLabel, disabled: n2.isDisabled || g2, selected: n2.isSelected, onClick: function(e3) {
      e3.stopPropagation(), n2.isDisabled || g2 || m2(n2.id);
    }, onContextMenu: c2 || s2 ? C2 : void 0, showTooltip: !!b2, className: Ae(f2.itemRowFlex, r2), isAdvancedItem: o2 }));
  }, kr = (0, p.makeStyles)(function(e2) {
    return { listWrapper: { paddingTop: 8 }, list: { listStyle: "none", margin: 0, overflowY: "auto", overflowX: "auto" }, emptyText: { padding: "12px 16px", fontSize: "12px", color: e2.palette.text.secondary, textAlign: "center" }, loadingText: { padding: "12px 16px", fontSize: "12px", color: e2.palette.text.secondary, textAlign: "center" }, renderRow: { display: "flex", paddingInline: "10px", boxSizing: "border-box", width: "100%" } };
  }, { name: "DynamicTreeSelectList" }), Nr = function(e2) {
    var t2 = e2.onNodeContextMenu, n2 = e2.onContextMenuItem, r2 = e2.classNameForList, a2 = e2.emptyText, l2 = void 0 === a2 ? "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445" : a2, o2 = e2.maxContentHeight, i2 = void 0 === o2 ? 300 : o2, c2 = e2.itemHeight, s2 = void 0 === c2 ? 28 : c2, p2 = e2.advancedItemHeight, f2 = void 0 === p2 ? 34 : p2, h2 = kr(), m2 = sr(), v2 = m2.visibleNodes, g2 = m2.isLoading, b2 = m2.isInitialLoading, y2 = m2.isSearching, x2 = m2.searchValue, w2 = m2.flatNodes, C2 = (0, u.useRef)(null), S2 = (0, u.useMemo)(function() {
      return w2.some(function(e3) {
        var t3, n3;
        return null != (null === (t3 = e3.originalNode) || void 0 === t3 ? void 0 : t3.additionalLabel) && null != (null === (n3 = e3.originalNode) || void 0 === n3 ? void 0 : n3.additionalLabel);
      });
    }, [w2]), E2 = (0, u.useMemo)(function() {
      return S2 ? f2 : s2;
    }, [S2, f2, s2]), I2 = (0, u.useCallback)(function(e3) {
      var r3, a3, l3 = e3.index, o3 = e3.style, i3 = v2[l3], c3 = i3.path.join("-");
      return d().createElement(Lr, { key: c3, node: i3, style: o3, classNameForRow: h2.renderRow, isAdvancedItem: S2, maxWidth: (null === (r3 = C2.current) || void 0 === r3 ? void 0 : r3.getBoundingClientRect().width) ? null === (a3 = C2.current) || void 0 === a3 ? void 0 : a3.getBoundingClientRect().width : void 0, onNodeContextMenu: t2, onContextMenuItem: n2 });
    }, [v2, S2, C2.current, t2, n2]);
    if (g2 || y2 || b2) return d().createElement("div", { className: h2.loadingText }, qt("\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0434\u0430\u043D\u043D\u044B\u0445..."));
    if (0 === v2.length) return d().createElement("div", { className: h2.emptyText }, qt(l2));
    var M2 = Math.min(v2.length * E2 + 6, i2 + 6), O2 = x2 ? "search" : "normal";
    return d().createElement("div", { className: Ae(h2.listWrapper, r2), ref: C2 }, d().createElement(bn, { key: O2, height: M2, width: "100%", itemCount: v2.length, itemSize: E2, className: h2.list }, I2));
  }, Zr = (0, p.makeStyles)(function(e2) {
    return { search: { background: e2.palette.background.paper, padding: "0 10px", zIndex: 2 } };
  }, { name: "DynamicTreeSelectSearch" }), Pr = function() {
    return Pr = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, Pr.apply(this, arguments);
  }, Dr = function(e2) {
    var t2 = e2.classNameForSearchField, n2 = e2.searchFieldProps, r2 = Zr(), a2 = sr(), l2 = a2.handleSearchChange, o2 = a2.isSearching, i2 = a2.isLoading, c2 = a2.isInitialLoading, s2 = a2.debounceDelay, u2 = o2 || i2 || c2;
    return d().createElement(p.ListSubheader, { className: r2.search }, d().createElement(Kt, Pr({ className: t2, onChange: function(e3) {
      return l2({ search: e3.target.value });
    }, fullWidth: true, handleReset: function() {
      return l2({ search: "" });
    }, rightIcon: u2 ? d().createElement(p.CircularProgress, { size: 16 }) : void 0 }, n2, { debouncedDelay: s2 })));
  }, Tr = (0, p.makeStyles)(function(e2) {
    return { root: { display: "flex", flexDirection: "column", width: "100%", minHeight: 0, flexShrink: 0 }, groupLabel: { padding: "8px", paddingInline: 10, fontSize: "12px", fontWeight: 600, color: e2.palette.primary.main, letterSpacing: "0.5px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", transition: "background-color 0.2s ease", userSelect: "none" }, labelText: { flex: 1 }, chevronIcon: { display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "8px", "& svg": { width: "16px", height: "16px" }, "& path": { fill: e2.palette.primary.main } }, listWrapper: { boxSizing: "border-box", width: "100%", maxWidth: "100%", minWidth: 0, paddingBottom: 4 }, virtualList: { listStyle: "none", margin: 0, overflowX: "hidden", overflowY: "auto", WebkitOverflowScrolling: "touch" }, itemRowWrap: { width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", paddingInline: "10px" }, clearIcon: { display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", opacity: 0.6, transition: "opacity 0.2s ease", pointerEvents: "auto", "&:hover": { opacity: 1 } } };
  }, { name: "DynamicTreeSelectSelectedList" }), jr = function(e2) {
    var t2 = e2.label, n2 = e2.defaultExpanded, r2 = void 0 === n2 || n2, a2 = e2.hideWhenEmpty, l2 = void 0 === a2 || a2, o2 = e2.className, i2 = e2.maxContentHeight, c2 = void 0 === i2 ? 140 : i2, s2 = Tr(), p2 = (0, u.useState)(r2), f2 = p2[0], h2 = p2[1], m2 = sr(), v2 = m2.selectedNodes, g2 = m2.handleNodeClick, b2 = m2.disabledAllOptions, y2 = m2.disabledSelect, x2 = m2.showTooltipForLabel, w2 = m2.clearAll, C2 = m2.flatNodes, S2 = (0, u.useCallback)(function() {
      h2(function(e3) {
        return !e3;
      });
    }, []), E2 = (0, u.useCallback)(function(e3, t3) {
      y2 || b2 || t3 || g2(e3);
    }, [y2, b2, g2]), I2 = (0, u.useMemo)(function() {
      return C2.some(function(e3) {
        var t3, n3;
        return null != (null === (t3 = e3.originalNode) || void 0 === t3 ? void 0 : t3.additionalLabel) && null != (null === (n3 = e3.originalNode) || void 0 === n3 ? void 0 : n3.additionalLabel);
      });
    }, [C2]), M2 = (0, u.useMemo)(function() {
      return I2 ? 34 : 28;
    }, [I2]), O2 = (0, u.useMemo)(function() {
      return Math.min(v2.length * M2, c2);
    }, [v2.length, M2, c2]), L2 = (0, u.useCallback)(function(e3) {
      var t3, n3 = e3.index, r3 = e3.style, a3 = e3.data[n3], l3 = a3.originalNode, o3 = null !== (t3 = null == l3 ? void 0 : l3.additionalLabel) && void 0 !== t3 ? t3 : a3.additionalLabel;
      return d().createElement("div", { style: r3, className: s2.itemRowWrap }, d().createElement(Ir, { component: "div", label: a3.label, additionalLabel: o3, disabled: y2 || b2 || !!a3.isDisabled, selected: true, showTooltip: !!x2, onClick: function(e4) {
        e4.stopPropagation(), E2(a3.id, a3.isDisabled);
      }, isAdvancedItem: I2 }));
    }, [s2.itemRowWrap, y2, b2, x2, E2, I2]);
    return l2 && 0 === v2.length ? null : d().createElement("div", { className: Ae(s2.root, o2) }, d().createElement("div", { className: s2.groupLabel, onClick: S2, role: "button" }, d().createElement("span", { className: s2.labelText }, t2), w2 && d().createElement("div", { className: s2.clearIcon, onClick: function(e3) {
      e3.preventDefault(), e3.stopPropagation(), !w2 || y2 || b2 || w2();
    }, role: "button", "aria-label": "clear all selected values" }, d().createElement(Zt, { width: 14, height: 14 })), d().createElement("span", { className: s2.chevronIcon }, f2 ? d().createElement(Lt, null) : d().createElement(Ct, null))), f2 && v2.length > 0 ? d().createElement("div", { className: s2.listWrapper }, d().createElement(bn, { height: O2, width: "100%", itemCount: v2.length, itemSize: M2, itemData: v2, className: s2.virtualList }, L2)) : f2 && d().createElement("div", { className: s2.listWrapper }));
  }, Rr = (0, p.makeStyles)(function(e2) {
    return { formField: { width: "100%", position: "relative", "& .MuiInputLabel-root": { transform: "translate(2px, 16px) scale(1)", fontSize: "10px", fontWeight: 400, color: e2.palette.text.secondary, left: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", right: 5, "&.MuiInputLabel-shrink": { transform: "translate(2px, 8px) scale(0.8)" } }, "& .MuiSelect-icon": { display: "none !important" } }, anchor: { width: "100%" }, paper: { marginTop: "5px", overflowX: "hidden", boxSizing: "border-box" }, select: { border: "1px solid ".concat(e2.palette.divider), borderRadius: "4px", background: "transparent", "& .MuiSelect-filled.MuiSelect-filled": { fontSize: "10px", paddingTop: "14px", paddingBottom: "5px", paddingRight: "50px", fontWeight: 500, color: e2.palette.text.primary }, "&:before": { content: "none" }, "&:after": { content: "none" }, "&:hover": { background: "transparent" } }, selectDisabled: { "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.12)" } }, selectError: { borderColor: e2.palette.error.main }, iconsContainer: { position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", pointerEvents: "none", zIndex: 1, gap: "4px" }, clearIcon: { display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", opacity: 0.6, transition: "opacity 0.2s ease", pointerEvents: "auto", "&:hover": { opacity: 1 } }, selectIcon: { display: "flex", alignItems: "center", justifyContent: "center", transition: "transform 0.3s ease", transform: "rotate(0deg)", pointerEvents: "none" }, selectIconOpen: { transform: "rotate(180deg)" }, selectIconDisabled: { opacity: 0.6 }, list: { padding: 0 }, labelError: { color: e2.palette.error.main }, selectNoLabel: { "& .MuiSelect-filled.MuiSelect-filled": { paddingTop: "9.5px", paddingBottom: "9.5px" } } };
  }, { name: "DynamicTreeSelectTrigger" }), zr = function() {
    return zr = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, zr.apply(this, arguments);
  }, Fr = function(e2) {
    var t2, n2, r2, a2, l2 = e2.children, o2 = e2.label, i2 = e2.errorMessage, c2 = e2.classNameForFormControl, s2 = e2.classnameForSelect, f2 = e2.classNameForHelperText, h2 = e2.IconComponent, m2 = void 0 === h2 ? Ct : h2, v2 = e2.formControlProps, g2 = e2.selectProps, b2 = Rr(), y2 = (0, u.useRef)(null), x2 = (0, u.useState)(), w2 = x2[0], C2 = x2[1], S2 = sr(), E2 = S2.open, I2 = S2.selectedNodes, M2 = S2.name, O2 = S2.disabledSelect, L2 = S2.disabledAllOptions, k2 = S2.required, N2 = S2.renderValue, Z2 = S2.handleOpen, P2 = S2.onClose, D2 = S2.multiSelect, T2 = S2.clearAll, j2 = null != g2 ? g2 : {}, R2 = j2.MenuProps, z2 = (function(e3, t3) {
      var n3 = {};
      for (var r3 in e3) Object.prototype.hasOwnProperty.call(e3, r3) && t3.indexOf(r3) < 0 && (n3[r3] = e3[r3]);
      if (null != e3 && "function" == typeof Object.getOwnPropertySymbols) {
        var a3 = 0;
        for (r3 = Object.getOwnPropertySymbols(e3); a3 < r3.length; a3++) t3.indexOf(r3[a3]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, r3[a3]) && (n3[r3[a3]] = e3[r3[a3]]);
      }
      return n3;
    })(j2, ["MenuProps"]);
    (0, u.useLayoutEffect)(function() {
      var e3;
      if (E2) {
        var t3 = null === (e3 = y2.current) || void 0 === e3 ? void 0 : e3.offsetWidth;
        null != t3 && t3 > 0 && C2(t3);
      }
    }, [E2]);
    var F2 = (0, u.useMemo)(function() {
      var e3 = null == R2 ? void 0 : R2.PaperProps, t3 = e3 && "style" in e3 ? e3.style : void 0;
      return zr(zr({ anchorOrigin: { vertical: "bottom", horizontal: "left" }, getContentAnchorEl: null, autoFocus: false, classes: { paper: b2.paper, list: b2.list } }, R2), { PaperProps: zr(zr({}, e3), { style: zr(zr({}, t3), null != w2 ? { width: w2, maxWidth: w2, boxSizing: "border-box" } : {}) }) });
    }, [b2.list, b2.paper, w2, R2]);
    return d().createElement("div", { ref: y2, className: b2.anchor }, d().createElement(p.FormControl, zr({ className: Ae(b2.formField, c2), error: !!i2, required: k2 }, v2), o2 && d().createElement(p.InputLabel, { shrink: true }, o2), d().createElement(p.Select, zr({ labelId: "input-label", open: E2, multiple: D2, displayEmpty: true, disabled: O2, required: k2, className: Ae(b2.select, (t2 = {}, t2[b2.selectDisabled] = O2, t2[b2.selectError] = !!i2, t2[b2.selectNoLabel] = !o2, t2), s2), name: M2, MenuProps: F2, variant: "filled", value: D2 ? I2.map(function(e3) {
      return e3.id;
    }) : null !== (a2 = null === (r2 = I2[0]) || void 0 === r2 ? void 0 : r2.id) && void 0 !== a2 ? a2 : "", renderValue: function() {
      return N2(I2);
    }, onOpen: Z2, onClose: P2, error: !!i2 }, z2), l2), d().createElement("div", { className: b2.iconsContainer }, I2.length > 0 && T2 && !O2 && !L2 && d().createElement("div", { className: b2.clearIcon, onClick: function(e3) {
      e3.preventDefault(), e3.stopPropagation(), !T2 || O2 || L2 || T2();
    }, onMouseDown: function(e3) {
      e3.preventDefault(), e3.stopPropagation();
    }, role: "button", "aria-label": "clear all selected values" }, d().createElement(Zt, { width: 14, height: 14 })), d().createElement("div", { className: Ae(b2.selectIcon, (n2 = {}, n2[b2.selectIconOpen] = E2, n2[b2.selectIconDisabled] = O2, n2)) }, d().createElement(m2, { width: 18, height: 18 }))), i2 && d().createElement(p.FormHelperText, { className: Ae(b2.labelError, f2) }, i2)));
  }, Hr = function() {
    return Hr = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, Hr.apply(this, arguments);
  }, Wr = (0, p.makeStyles)(function() {
    return { formField: { width: "100%", margin: "10px 0", "& .MuiInputLabel-root": { transform: "translate(2px, 16px) scale(1)", fontSize: "10px", fontWeight: 400, color: "#73747C", left: 10, "&.MuiInputLabel-shrink": { transform: "translate(2px, 8px) scale(0.8)" } } }, paper: { marginTop: "5px" }, select: { border: "1px solid #c4c4c4", borderRadius: "4px", background: "transparent", "& .MuiSelect-filled.MuiSelect-filled": { fontSize: "12px", paddingTop: "14px", paddingBottom: "5px" }, "&:before": { content: "none" }, "&:after": { content: "none" }, "&:hover": { background: "transparent" } } };
  }), Ar = function(e2) {
    var t2 = e2.formControlProps, n2 = e2.selectProps, r2 = e2.label, a2 = e2.children, l2 = (function(e3, t3) {
      var n3 = {};
      for (var r3 in e3) Object.prototype.hasOwnProperty.call(e3, r3) && t3.indexOf(r3) < 0 && (n3[r3] = e3[r3]);
      if (null != e3 && "function" == typeof Object.getOwnPropertySymbols) {
        var a3 = 0;
        for (r3 = Object.getOwnPropertySymbols(e3); a3 < r3.length; a3++) t3.indexOf(r3[a3]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, r3[a3]) && (n3[r3[a3]] = e3[r3[a3]]);
      }
      return n3;
    })(e2, ["formControlProps", "selectProps", "label", "children"]), o2 = Wr(l2);
    return d().createElement(p.FormControl, Hr({ className: o2.formField }, t2), r2 && d().createElement(p.InputLabel, null, r2), d().createElement(p.Select, Hr({ className: o2.select, MenuProps: { anchorOrigin: { vertical: "bottom", horizontal: "left" }, getContentAnchorEl: null, classes: { paper: o2.paper } }, variant: "filled" }, n2), a2));
  }, Vr = (0, p.makeStyles)(function() {
    return { listWrapper: { position: "relative", display: "flex", flexDirection: "column", width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", overflow: "hidden" } };
  }, { name: "TreeSelectContent" }), _r = function(e2) {
    var t2 = e2.children, n2 = e2.classNameForListWrapper, r2 = Vr();
    return d().createElement("div", { className: Ae(r2.listWrapper, n2) }, t2);
  }, Br = (0, p.makeStyles)(function(e2) {
    return { item: { display: "flex", alignItems: "center", paddingInline: 8, cursor: "pointer", fontSize: "12px", userSelect: "none", width: "100%", maxWidth: "100%", minWidth: 0, height: "auto", padding: 0, borderRadius: "4px", boxSizing: "border-box" }, itemDisabled: { opacity: 0.5, cursor: "not-allowed", "&:hover": { backgroundColor: "transparent" } }, itemSelected: { backgroundColor: (0, p.alpha)(e2.palette.primary.main, 0.15), "&:hover": { backgroundColor: (0, p.alpha)(e2.palette.primary.main, 0.15) } }, labelWrapper: { display: "flex", flexDirection: "column", alignItems: "stretch", justifyContent: "center", minWidth: 0, flex: "1 1 0%" }, label: { minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, additionalLabel: { color: e2.palette.text.secondary, fontSize: "10px", lineHeight: 1.2, minWidth: 0, width: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, customTooltip: { transform: "translate(10px, -10px) !important" } };
  }, { name: "TreeSelectItemRow" }), qr = function(e2) {
    return !!e2 && e2.scrollWidth > e2.clientWidth + 1;
  }, Ur = function(e2) {
    return null != e2 && null != e2;
  }, Gr = function(e2) {
    var t2, n2 = e2.label, r2 = e2.additionalLabel, a2 = e2.disabled, l2 = void 0 !== a2 && a2, o2 = e2.selected, i2 = void 0 !== o2 && o2, c2 = e2.onClick, s2 = e2.showTooltip, f2 = void 0 !== s2 && s2, h2 = e2.className, m2 = e2.component, v2 = void 0 === m2 ? "li" : m2, g2 = e2.isAdvancedItem, b2 = void 0 !== g2 && g2, y2 = e2.onContextMenu, x2 = Br(), w2 = (0, u.useRef)(null), C2 = (0, u.useRef)(null), S2 = (0, u.useState)(false), E2 = S2[0], I2 = S2[1], M2 = (0, u.useState)(false), O2 = M2[0], L2 = M2[1], k2 = (0, p.useTheme)(), N2 = (0, u.useCallback)(function() {
      if (!f2) return I2(false), void L2(false);
      I2(qr(w2.current)), Ur(r2) ? L2(qr(C2.current)) : L2(false);
    }, [f2, r2]);
    (0, u.useLayoutEffect)(function() {
      N2();
    }, [n2, N2]), (0, u.useLayoutEffect)(function() {
      if (f2 && "undefined" != typeof ResizeObserver) {
        var e3 = new ResizeObserver(function() {
          N2();
        }), t3 = w2.current, n3 = C2.current;
        return t3 && e3.observe(t3), n3 && e3.observe(n3), function() {
          return e3.disconnect();
        };
      }
    }, [f2, n2, r2, N2]);
    var Z2 = f2 && E2, P2 = f2 && Ur(r2) && O2;
    return d().createElement(p.MenuItem, { component: v2, className: Ae(x2.item, (t2 = {}, t2[x2.itemDisabled] = l2, t2[x2.itemSelected] = i2, t2), h2), style: { minHeight: Ur(r2) || b2 ? "30px" : "24px" }, onClick: c2, disabled: l2, onContextMenu: y2 }, d().createElement("div", { className: x2.labelWrapper }, d().createElement(p.Tooltip, { title: Z2 ? n2 : "", placement: "bottom-start", classes: { tooltip: x2.customTooltip }, disableHoverListener: !Z2, disableFocusListener: !Z2, disableTouchListener: !Z2, PopperProps: { style: { zIndex: k2.zIndex.tooltip } } }, d().createElement("div", { ref: w2, className: x2.label }, n2)), Ur(r2) && d().createElement(p.Tooltip, { title: P2 && null != r2 ? r2 : "", placement: "bottom-start", classes: { tooltip: x2.customTooltip }, disableHoverListener: !P2, disableFocusListener: !P2, disableTouchListener: !P2, PopperProps: { style: { zIndex: k2.zIndex.tooltip } } }, d().createElement("div", { ref: C2, className: x2.additionalLabel }, r2))));
  }, Kr = (0, u.createContext)(void 0), Yr = function() {
    var e2 = (0, u.useContext)(Kr);
    if (void 0 === e2) throw new Error("useTreeSelectContext must be used within a TreeSelectRoot");
    return e2;
  }, Xr = (0, p.makeStyles)(function(e2) {
    return { wrapper: { display: "flex", alignItems: "flex-start", padding: 0, fontSize: "12px", userSelect: "none", width: "100%", minWidth: 0 }, itemRowFlex: { flex: "1 1 0%", minWidth: 0 }, expandIconWrapper: { display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "4px", "&:hover": { backgroundColor: e2.palette.action.hover }, cursor: "pointer", marginRight: 4, flexShrink: 0 }, expandIcon: { display: "flex", alignItems: "center", justifyContent: "center", transition: "transform 0.3s ease", flexShrink: 0 }, expandIconExpanded: { transform: "rotate(90deg)" }, expandIconPlaceholder: { width: "16px", height: "16px", marginRight: "4px", flexShrink: 0 } };
  }, { name: "TreeSelectItem" }), Jr = function() {
    return Jr = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, Jr.apply(this, arguments);
  }, $r = function(e2) {
    var t2, n2 = e2.node, r2 = e2.classNameForItem, a2 = e2.classNameForRow, l2 = e2.style, o2 = e2.isAdvancedItem, i2 = e2.maxWidth, c2 = e2.onNodeContextMenu, s2 = e2.onContextMenuItem, p2 = Xr(), f2 = Yr(), h2 = f2.handleNodeClick, m2 = f2.handleNodeExpand, v2 = f2.disabledAllOptions, g2 = f2.showTooltipForLabel, b2 = f2.selectedNodes, y2 = f2.visibleNodes, x2 = (0, u.useCallback)(function(e3) {
      if (e3.stopPropagation(), c2 || s2) {
        var t3 = b2.map(function(e4) {
          return e4.id;
        });
        null == c2 || c2(e3, n2.id, n2, t3, y2), null == s2 || s2(e3, n2.id, n2, t3, y2);
      }
    }, [n2, c2, s2, b2, y2]), w2 = function(e3) {
      e3.stopPropagation(), n2.hasChildren && m2(n2.path.join("-"));
    }, C2 = 0 === n2.level ? 10 : 24 * n2.level, S2 = "".concat(C2, "px"), E2 = (0, u.useMemo)(function() {
      if (i2) return i2 + C2 + (o2 ? 30 : 24);
    }, [i2, o2, n2.level, C2]);
    return d().createElement("div", { className: Ae(p2.wrapper, a2), style: Jr(Jr(Jr({}, l2), { paddingLeft: S2 }), null != E2 ? { display: "inline-flex", width: "auto", maxWidth: E2, minWidth: i2 } : {}) }, (function() {
      var e3;
      return n2.hasChildren ? d().createElement("div", { className: p2.expandIconWrapper, style: { width: o2 ? "30px" : "24px", height: o2 ? "30px" : "24px" }, onClick: w2 }, d().createElement("div", { className: Ae(p2.expandIcon, (e3 = {}, e3[p2.expandIconExpanded] = n2.isExpanded, e3)) }, d().createElement(Mt, { width: 14, height: 14 }))) : d().createElement("div", { className: p2.expandIconPlaceholder, style: { width: o2 ? "30px" : "24px", height: o2 ? "30px" : "24px" } });
    })(), d().createElement(Gr, { label: n2.label, additionalLabel: null === (t2 = n2.originalNode) || void 0 === t2 ? void 0 : t2.additionalLabel, disabled: true === n2.isDisabled || v2, selected: n2.isSelected, onClick: function(e3) {
      e3.stopPropagation(), n2.isDisabled || v2 || h2(n2.id);
    }, showTooltip: !!g2, className: Ae(p2.itemRowFlex, r2), isAdvancedItem: o2, onContextMenu: c2 || s2 ? x2 : void 0 }));
  }, Qr = (0, p.makeStyles)(function(e2) {
    return { listWrapper: { paddingTop: 8 }, list: { listStyle: "none", margin: 0, overflowY: "auto", overflowX: "auto" }, emptyText: { padding: "12px 16px", fontSize: "12px", color: e2.palette.text.secondary, textAlign: "center" }, loadingText: { padding: "12px 16px", fontSize: "12px", color: e2.palette.text.secondary, textAlign: "center" }, renderRow: { display: "flex", paddingInline: "10px", boxSizing: "border-box", width: "100%" } };
  }, { name: "TreeSelectList" }), ea = function(e2) {
    var t2 = e2.classNameForList, n2 = e2.emptyText, r2 = void 0 === n2 ? "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445" : n2, a2 = e2.maxContentHeight, l2 = void 0 === a2 ? 300 : a2, o2 = e2.itemHeight, i2 = void 0 === o2 ? 28 : o2, c2 = e2.advancedItemHeight, s2 = void 0 === c2 ? 34 : c2, p2 = e2.onNodeContextMenu, f2 = e2.onContextMenuItem, h2 = Qr(), m2 = Yr(), v2 = m2.visibleNodes, g2 = m2.searchValue, b2 = m2.flatNodes, y2 = (0, u.useRef)(null), x2 = (0, u.useMemo)(function() {
      return b2.some(function(e3) {
        var t3;
        return null === (t3 = e3.originalNode) || void 0 === t3 ? void 0 : t3.additionalLabel;
      });
    }, [b2]), w2 = (0, u.useMemo)(function() {
      return x2 ? s2 : i2;
    }, [x2, s2, i2]), C2 = (0, u.useCallback)(function(e3) {
      var t3, n3, r3 = e3.index, a3 = e3.style, l3 = v2[r3], o3 = l3.path.join("-");
      return d().createElement($r, { key: o3, node: l3, style: a3, classNameForRow: h2.renderRow, isAdvancedItem: x2, maxWidth: (null === (t3 = y2.current) || void 0 === t3 ? void 0 : t3.getBoundingClientRect().width) ? null === (n3 = y2.current) || void 0 === n3 ? void 0 : n3.getBoundingClientRect().width : void 0, onNodeContextMenu: p2, onContextMenuItem: f2 });
    }, [v2, x2, y2.current, p2, f2]);
    if (0 === v2.length) return d().createElement("div", { className: h2.emptyText }, qt(r2));
    var S2 = Math.min(v2.length * w2, l2), E2 = g2 ? "search" : "normal";
    return d().createElement("div", { className: Ae(h2.listWrapper, t2), ref: y2 }, d().createElement(bn, { key: E2, height: S2, width: "100%", itemCount: v2.length, itemSize: w2, className: h2.list }, C2));
  }, ta = function(e2) {
    var t2 = /* @__PURE__ */ new Map();
    return e2.forEach(function(e3) {
      var n2, r2 = null !== (n2 = e3.parentId) && void 0 !== n2 ? n2 : null;
      t2.has(r2) || t2.set(r2, []), t2.get(r2).push(e3);
    }), t2;
  }, na = function() {
    return na = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, na.apply(this, arguments);
  }, ra = function(e2, t2, n2) {
    if (n2 || 2 === arguments.length) for (var r2, a2 = 0, l2 = t2.length; a2 < l2; a2++) !r2 && a2 in t2 || (r2 || (r2 = Array.prototype.slice.call(t2, 0, a2)), r2[a2] = t2[a2]);
    return e2.concat(r2 || Array.prototype.slice.call(t2));
  }, aa = function(e2) {
    var t2 = e2.children, n2 = e2.selectedIds, r2 = e2.treeData, a2 = e2.onChange, l2 = e2.name, o2 = e2.disabledSelect, i2 = void 0 !== o2 && o2, c2 = e2.disabledAllOptions, s2 = void 0 !== c2 && c2, p2 = e2.required, f2 = void 0 !== p2 && p2, h2 = e2.multiSelect, m2 = void 0 !== h2 && h2, v2 = e2.autoOpen, g2 = void 0 !== v2 && v2, b2 = e2.showTooltipForLabel, y2 = void 0 !== b2 && b2, x2 = e2.textForEmptyLabel, w2 = e2.renderValue, C2 = e2.onClose, S2 = e2.searchValue, E2 = e2.debounceDelay, I2 = void 0 === E2 ? 300 : E2, M2 = e2.minSearchLength, O2 = e2.showLine, L2 = void 0 !== O2 && O2, k2 = e2.onNodeClick, N2 = e2.clearAll, Z2 = (0, u.useState)(false), P2 = Z2[0], D2 = Z2[1], T2 = (0, u.useState)(""), j2 = T2[0], R2 = T2[1], z2 = (0, u.useState)(/* @__PURE__ */ new Set()), F2 = z2[0], H2 = z2[1], W2 = (0, u.useRef)(null), A2 = (0, u.useRef)(false), V2 = (0, u.useRef)(""), _2 = null != S2 ? S2 : j2, B2 = (0, u.useMemo)(function() {
      return (function(e3, t3) {
        void 0 === t3 && (t3 = /* @__PURE__ */ new Set());
        var n3 = /* @__PURE__ */ new Map();
        e3.forEach(function(e4) {
          return n3.set(e4.id, e4);
        });
        var r3 = ta(e3), a3 = [], l3 = /* @__PURE__ */ new Set(), o3 = function(e4) {
          var i3, c3;
          if (!l3.has(e4.id)) {
            l3.add(e4.id);
            var s3 = (function(e5, t4) {
              for (var n4 = 0, r4 = e5.parentId; null != r4; ) {
                var a4 = t4.get(r4);
                if (!a4) break;
                n4++, r4 = a4.parentId;
              }
              return n4;
            })(e4, n3), u2 = (function(e5, t4) {
              for (var n4 = [e5.id], r4 = e5.parentId; null != r4; ) {
                var a4 = t4.get(r4);
                if (!a4) break;
                n4.unshift(r4), r4 = a4.parentId;
              }
              return n4;
            })(e4, n3), d2 = u2.join("-"), p3 = t3.has(d2), f3 = r3.get(e4.id) || [], h3 = f3.map(function(e5) {
              return e5.id;
            }), m3 = h3.length > 0, v3 = { id: e4.id, label: e4.label, level: s3, parentId: null !== (i3 = e4.parentId) && void 0 !== i3 ? i3 : null, isExpanded: p3, isSelected: false, isIndeterminate: false, hasChildren: null !== (c3 = e4.hasChildren) && void 0 !== c3 ? c3 : m3, isDisabled: e4.isDisabled, isVisible: true, children: h3, path: u2, originalNode: e4 };
            a3.push(v3), p3 && m3 && f3.forEach(o3);
          }
        };
        return (r3.get(null) || []).forEach(o3), e3.forEach(function(e4) {
          var i3, c3;
          if (!(l3.has(e4.id) || null != e4.parentId && n3.has(e4.parentId))) {
            var s3 = r3.get(e4.id) || [], u2 = s3.map(function(e5) {
              return e5.id;
            }), d2 = u2.length > 0, p3 = [e4.id].join("-"), f3 = { id: e4.id, label: e4.label, level: 0, parentId: null !== (i3 = e4.parentId) && void 0 !== i3 ? i3 : null, isExpanded: t3.has(p3), isSelected: false, isIndeterminate: false, hasChildren: null !== (c3 = e4.hasChildren) && void 0 !== c3 ? c3 : d2, isDisabled: e4.isDisabled, isVisible: true, children: u2, path: [e4.id], originalNode: e4 };
            a3.push(f3), l3.add(e4.id), t3.has(p3) && d2 && s3.forEach(o3);
          }
        }), a3;
      })(r2, F2);
    }, [r2, F2]), q2 = (0, u.useMemo)(function() {
      var e3 = new Set(n2);
      return B2.map(function(t3) {
        var n3 = e3.has(t3.id), r3 = false;
        if (!n3 && t3.children.length > 0) {
          var a3 = (function(e4, t4) {
            var n4 = [];
            if (!e4.find(function(e5) {
              return e5.id === t4;
            })) return n4;
            var r4 = function(t5) {
              for (var a4 = 0, l4 = e4.filter(function(e5) {
                return e5.parentId === t5;
              }); a4 < l4.length; a4++) {
                var o3 = l4[a4];
                n4.push(o3.id), o3.children.length > 0 && r4(o3.id);
              }
            };
            return r4(t4), n4;
          })(B2, t3.id), l3 = a3.filter(function(t4) {
            return e3.has(t4);
          });
          r3 = l3.length > 0 && l3.length < a3.length;
        }
        return na(na({}, t3), { isSelected: n3, isIndeterminate: r3 });
      });
    }, [B2, n2]), U2 = (0, u.useMemo)(function() {
      if (!_2.trim() || M2 && _2.trim().length < M2) return q2;
      var e3 = _2.toLowerCase(), t3 = /* @__PURE__ */ new Map();
      r2.forEach(function(e4) {
        return t3.set(e4.id, e4);
      });
      for (var a3 = ta(r2), l3 = new Set(n2), o3 = r2.filter(function(t4) {
        return t4.label.toLowerCase().includes(e3);
      }), i3 = /* @__PURE__ */ new Set(), c3 = /* @__PURE__ */ new Set(), s3 = function(e4) {
        i3.add(e4.id), c3.add(e4.id);
        var t4 = function(e5) {
          (a3.get(e5) || []).forEach(function(e6) {
            i3.add(e6.id), t4(e6.id);
          });
        };
        t4(e4.id);
      }, u2 = 0, d2 = o3; u2 < d2.length; u2++) s3(d2[u2]);
      var p3 = [], f3 = function(e4, n3, r3) {
        var o4, c4 = (function(e5, n4, r4) {
          var o5, c5;
          if (!i3.has(e5)) return null;
          var s5 = t3.get(e5);
          if (!s5) return null;
          var u4 = (a3.get(e5) || []).map(function(e6) {
            return e6.id;
          }), d4 = u4.length > 0 || null !== (o5 = s5.hasChildren) && void 0 !== o5 && o5, p4 = l3.has(e5), f4 = r4.join("-"), h4 = F2.has(f4), m4 = false;
          if (!p4 && u4.length > 0) {
            var v3 = (function(e6, t4) {
              var n5 = [], r5 = function(e7) {
                for (var a4 = 0, l4 = t4.get(e7) || []; a4 < l4.length; a4++) {
                  var o6 = l4[a4];
                  n5.push(o6.id), r5(o6.id);
                }
              };
              return r5(e6), n5;
            })(e5, a3), g3 = v3.filter(function(e6) {
              return l3.has(e6);
            });
            m4 = g3.length > 0 && g3.length < v3.length;
          }
          return { id: e5, label: s5.label, level: n4, parentId: null !== (c5 = s5.parentId) && void 0 !== c5 ? c5 : null, isExpanded: h4, isSelected: p4, isIndeterminate: m4, hasChildren: d4, isDisabled: s5.isDisabled, isVisible: true, children: u4, path: r4, originalNode: s5 };
        })(e4, n3, r3);
        if (c4) {
          p3.push(c4);
          var s4 = t3.get(e4);
          if (s4) {
            var u3 = r3.join("-"), d3 = F2.has(u3), h3 = a3.get(e4) || [], m3 = h3.length > 0 || null !== (o4 = s4.hasChildren) && void 0 !== o4 && o4;
            d3 && m3 && h3.forEach(function(e5) {
              i3.has(e5.id) && f3(e5.id, n3 + 1, ra(ra([], r3, true), [e5.id], false));
            });
          }
        }
      };
      return Array.from(c3).forEach(function(e4) {
        f3(e4, 0, [e4]);
      }), p3;
    }, [r2, _2, n2, F2, M2]), G2 = (0, u.useMemo)(function() {
      return r2.filter(function(e3) {
        return n2.includes(e3.id);
      });
    }, [r2, n2]);
    (0, u.useEffect)(function() {
      var e3 = !V2.current.trim(), t3 = _2.trim();
      e3 && t3 && H2(/* @__PURE__ */ new Set()), V2.current = _2;
    }, [_2]);
    var K2 = (0, u.useCallback)(function(e3) {
      var t3 = e3.search;
      A2.current || (W2.current && clearTimeout(W2.current), W2.current = setTimeout(function() {
        R2(t3);
      }, I2));
    }, [I2]), Y2 = (0, u.useCallback)(function() {
      A2.current = false, D2(true);
    }, []), X2 = (0, u.useCallback)(function() {
      A2.current = true, D2(false), R2(""), H2(/* @__PURE__ */ new Set()), V2.current = "", W2.current && clearTimeout(W2.current), setTimeout(function() {
        null == C2 || C2();
      }, 100);
    }, [C2]), J2 = (0, u.useCallback)(function(e3) {
      var t3 = _2.trim() ? U2 : q2, l3 = t3.find(function(t4) {
        return t4.id === e3;
      });
      if (!l3 || !(null == l3 ? void 0 : l3.isDisabled)) {
        var o3;
        if (k2 && l3) o3 = k2(e3, l3, n2, t3);
        else if (m2) {
          var i3 = n2.includes(e3);
          o3 = i3 ? n2.filter(function(t4) {
            return t4 !== e3;
          }) : ra(ra([], n2, true), [e3], false);
        } else o3 = [e3];
        var c3 = r2.filter(function(e4) {
          return o3.includes(e4.id);
        });
        a2(o3, c3);
      }
    }, [q2, U2, _2, n2, m2, a2, k2, r2]), $2 = (0, u.useCallback)(function(e3) {
      H2(function(t3) {
        var n3 = new Set(t3);
        return n3.has(e3) ? n3.delete(e3) : n3.add(e3), n3;
      });
    }, []);
    (0, u.useEffect)(function() {
      g2 && setTimeout(function() {
        Y2();
      }, 300);
    }, [g2, Y2]), (0, u.useEffect)(function() {
      return function() {
        W2.current && clearTimeout(W2.current);
      };
    }, []);
    var Q2 = (0, u.useMemo)(function() {
      return { open: P2, searchValue: _2, selectedNodes: G2, flatNodes: q2, visibleNodes: U2, setOpen: D2, handleNodeClick: J2, handleNodeExpand: $2, handleOpen: Y2, handleClose: X2, handleSearchChange: K2, name: l2, disabledSelect: i2, disabledAllOptions: s2, required: f2, multiSelect: m2, showTooltipForLabel: y2, textForEmptyLabel: x2, renderValue: w2, debounceDelay: I2, showLine: L2, clearAll: N2 };
    }, [P2, _2, G2, q2, U2, J2, $2, Y2, X2, K2, l2, i2, s2, f2, m2, y2, x2, w2, I2, L2, N2]);
    return d().createElement(Kr.Provider, { value: Q2 }, t2);
  }, la = (0, p.makeStyles)(function(e2) {
    return { search: { background: e2.palette.background.paper, padding: "0 10px", zIndex: 2 } };
  }, { name: "TreeSelectSearch" }), oa = function() {
    return oa = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, oa.apply(this, arguments);
  }, ia = function(e2) {
    var t2 = e2.classNameForSearchField, n2 = e2.searchFieldProps, r2 = la(), a2 = Yr(), l2 = a2.handleSearchChange, o2 = a2.debounceDelay;
    return d().createElement(p.ListSubheader, { className: r2.search }, d().createElement(Kt, oa({ className: t2, onChange: function(e3) {
      return l2({ search: e3.target.value });
    }, fullWidth: true, handleReset: function() {
      return l2({ search: "" });
    } }, n2, { debouncedDelay: o2 })));
  }, ca = (0, p.makeStyles)(function(e2) {
    return { root: { display: "flex", flexDirection: "column", width: "100%", minHeight: 0, flexShrink: 0 }, groupLabel: { padding: "8px", paddingInline: 10, fontSize: "12px", fontWeight: 600, color: e2.palette.primary.main, letterSpacing: "0.5px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "space-between", transition: "background-color 0.2s ease", userSelect: "none" }, labelText: { flex: 1 }, chevronIcon: { display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "8px", "& svg": { width: "16px", height: "16px" }, "& path": { fill: e2.palette.primary.main } }, listWrapper: { boxSizing: "border-box", width: "100%", maxWidth: "100%", minWidth: 0, paddingBottom: 4 }, virtualList: { listStyle: "none", margin: 0, overflowX: "hidden", overflowY: "auto", WebkitOverflowScrolling: "touch" }, itemRowWrap: { width: "100%", maxWidth: "100%", minWidth: 0, boxSizing: "border-box", paddingInline: "10px" }, clearIcon: { display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", opacity: 0.6, transition: "opacity 0.2s ease", pointerEvents: "auto", "&:hover": { opacity: 1 } } };
  }, { name: "TreeSelectSelectedList" }), sa = function(e2) {
    var t2 = e2.label, n2 = e2.defaultExpanded, r2 = void 0 === n2 || n2, a2 = e2.hideWhenEmpty, l2 = void 0 === a2 || a2, o2 = e2.className, i2 = e2.maxContentHeight, c2 = void 0 === i2 ? 140 : i2, s2 = ca(), p2 = (0, u.useState)(r2), f2 = p2[0], h2 = p2[1], m2 = Yr(), v2 = m2.selectedNodes, g2 = m2.handleNodeClick, b2 = m2.disabledAllOptions, y2 = m2.disabledSelect, x2 = m2.showTooltipForLabel, w2 = m2.clearAll, C2 = m2.flatNodes, S2 = (0, u.useCallback)(function() {
      h2(function(e3) {
        return !e3;
      });
    }, []), E2 = (0, u.useCallback)(function(e3, t3) {
      y2 || b2 || t3 || g2(e3);
    }, [y2, b2, g2]), I2 = (0, u.useMemo)(function() {
      return C2.some(function(e3) {
        var t3, n3;
        return null != (null === (t3 = e3.originalNode) || void 0 === t3 ? void 0 : t3.additionalLabel) && null != (null === (n3 = e3.originalNode) || void 0 === n3 ? void 0 : n3.additionalLabel);
      });
    }, [C2]), M2 = (0, u.useMemo)(function() {
      return I2 ? 34 : 28;
    }, [I2]), O2 = (0, u.useMemo)(function() {
      return Math.min(v2.length * M2, c2);
    }, [v2.length, M2, c2]), L2 = (0, u.useCallback)(function(e3) {
      var t3 = e3.index, n3 = e3.style, r3 = e3.data[t3];
      return d().createElement("div", { style: n3, className: s2.itemRowWrap }, d().createElement(Gr, { component: "div", label: r3.label, additionalLabel: r3.additionalLabel, disabled: y2 || b2 || !!r3.isDisabled, selected: true, showTooltip: !!x2, onClick: function(e4) {
        e4.stopPropagation(), E2(r3.id, r3.isDisabled);
      }, isAdvancedItem: I2 }));
    }, [s2.itemRowWrap, y2, b2, x2, E2, I2]);
    return l2 && 0 === v2.length ? null : d().createElement("div", { className: Ae(s2.root, o2) }, d().createElement("div", { className: s2.groupLabel, onClick: S2, role: "button" }, d().createElement("span", { className: s2.labelText }, t2), w2 && v2.length > 0 && d().createElement("div", { className: s2.clearIcon, onClick: function(e3) {
      e3.preventDefault(), e3.stopPropagation(), !w2 || y2 || b2 || w2();
    }, role: "button", "aria-label": "clear all selected values" }, d().createElement(Zt, { width: 14, height: 14 })), d().createElement("span", { className: s2.chevronIcon }, f2 ? d().createElement(Lt, null) : d().createElement(Ct, null))), f2 && v2.length > 0 ? d().createElement("div", { className: s2.listWrapper }, d().createElement(bn, { height: O2, width: "100%", itemCount: v2.length, itemSize: M2, itemData: v2, className: s2.virtualList }, L2)) : f2 && d().createElement("div", { className: s2.listWrapper }));
  }, ua = (0, p.makeStyles)(function(e2) {
    return { formField: { width: "100%", position: "relative", "& .MuiInputLabel-root": { transform: "translate(2px, 16px) scale(1)", fontSize: "10px", fontWeight: 400, color: e2.palette.text.secondary, left: 10, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", right: 5, "&.MuiInputLabel-shrink": { transform: "translate(2px, 8px) scale(0.8)" } }, "& .MuiSelect-icon": { display: "none !important" } }, anchor: { width: "100%" }, paper: { marginTop: "5px", overflowX: "hidden", boxSizing: "border-box" }, select: { border: "1px solid ".concat(e2.palette.divider), borderRadius: "4px", background: "transparent", "& .MuiSelect-filled.MuiSelect-filled": { fontSize: "10px", paddingTop: "14px", paddingBottom: "5px", paddingRight: "50px", fontWeight: 500, color: e2.palette.text.primary }, "&:before": { content: "none" }, "&:after": { content: "none" }, "&:hover": { background: "transparent" } }, selectDisabled: { "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.12)" } }, selectError: { borderColor: e2.palette.error.main }, iconsContainer: { position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", pointerEvents: "none", zIndex: 1, gap: "4px" }, clearIcon: { display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", opacity: 0.6, transition: "opacity 0.2s ease", pointerEvents: "auto", "&:hover": { opacity: 1 } }, selectIcon: { display: "flex", alignItems: "center", justifyContent: "center", transition: "transform 0.3s ease", transform: "rotate(0deg)", pointerEvents: "none" }, selectIconOpen: { transform: "rotate(180deg)" }, selectIconDisabled: { opacity: 0.6 }, list: { padding: 0 }, labelError: { color: e2.palette.error.main }, selectNoLabel: { "& .MuiSelect-filled.MuiSelect-filled": { paddingTop: "9.5px", paddingBottom: "9.5px" } } };
  }, { name: "TreeSelectTrigger" }), da = function() {
    return da = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, da.apply(this, arguments);
  }, pa = function(e2) {
    var t2, n2, r2, a2, l2 = e2.children, o2 = e2.label, i2 = e2.errorMessage, c2 = e2.classNameForFormControl, s2 = e2.classnameForSelect, f2 = e2.classNameForHelperText, h2 = e2.IconComponent, m2 = void 0 === h2 ? Ct : h2, v2 = e2.formControlProps, g2 = e2.selectProps, b2 = ua(), y2 = (0, u.useRef)(null), x2 = (0, u.useState)(), w2 = x2[0], C2 = x2[1], S2 = Yr(), E2 = S2.open, I2 = S2.selectedNodes, M2 = S2.name, O2 = S2.disabledSelect, L2 = S2.disabledAllOptions, k2 = S2.required, N2 = S2.renderValue, Z2 = S2.handleOpen, P2 = S2.handleClose, D2 = S2.multiSelect, T2 = S2.clearAll, j2 = null != g2 ? g2 : {}, R2 = j2.MenuProps, z2 = (function(e3, t3) {
      var n3 = {};
      for (var r3 in e3) Object.prototype.hasOwnProperty.call(e3, r3) && t3.indexOf(r3) < 0 && (n3[r3] = e3[r3]);
      if (null != e3 && "function" == typeof Object.getOwnPropertySymbols) {
        var a3 = 0;
        for (r3 = Object.getOwnPropertySymbols(e3); a3 < r3.length; a3++) t3.indexOf(r3[a3]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, r3[a3]) && (n3[r3[a3]] = e3[r3[a3]]);
      }
      return n3;
    })(j2, ["MenuProps"]);
    (0, u.useLayoutEffect)(function() {
      var e3;
      if (E2) {
        var t3 = null === (e3 = y2.current) || void 0 === e3 ? void 0 : e3.offsetWidth;
        null != t3 && t3 > 0 && C2(t3);
      }
    }, [E2]);
    var F2 = (0, u.useMemo)(function() {
      var e3 = null == R2 ? void 0 : R2.PaperProps, t3 = e3 && "style" in e3 ? e3.style : void 0;
      return da(da({ anchorOrigin: { vertical: "bottom", horizontal: "left" }, getContentAnchorEl: null, autoFocus: false, classes: { paper: b2.paper, list: b2.list } }, R2), { PaperProps: da(da({}, e3), { style: da(da({}, t3), null != w2 ? { width: w2, maxWidth: w2, boxSizing: "border-box" } : {}) }) });
    }, [b2.list, b2.paper, w2, R2]);
    return d().createElement("div", { ref: y2, className: b2.anchor }, d().createElement(p.FormControl, da({ className: Ae(b2.formField, c2), error: !!i2, required: k2 }, v2), o2 && d().createElement(p.InputLabel, { shrink: true }, o2), d().createElement(p.Select, da({ labelId: "input-label", open: E2, multiple: D2, displayEmpty: true, disabled: O2, required: k2, className: Ae(b2.select, (t2 = {}, t2[b2.selectDisabled] = O2, t2[b2.selectError] = !!i2, t2[b2.selectNoLabel] = !o2, t2), s2), name: M2, MenuProps: F2, variant: "filled", value: D2 ? I2.map(function(e3) {
      return e3.id;
    }) : null !== (a2 = null === (r2 = I2[0]) || void 0 === r2 ? void 0 : r2.id) && void 0 !== a2 ? a2 : "", renderValue: function() {
      return N2(I2);
    }, onOpen: Z2, onClose: P2, error: !!i2 }, z2), l2), d().createElement("div", { className: b2.iconsContainer }, I2.length > 0 && T2 && !O2 && !L2 && d().createElement("div", { className: b2.clearIcon, onClick: function(e3) {
      e3.preventDefault(), e3.stopPropagation(), !T2 || O2 || L2 || T2();
    }, onMouseDown: function(e3) {
      e3.preventDefault(), e3.stopPropagation();
    }, role: "button", "aria-label": "clear all selected values" }, d().createElement(Zt, { width: 14, height: 14 })), d().createElement("div", { className: Ae(b2.selectIcon, (n2 = {}, n2[b2.selectIconOpen] = E2, n2[b2.selectIconDisabled] = O2, n2)) }, d().createElement(m2, { width: 18, height: 18 }))), i2 && d().createElement(p.FormHelperText, { className: Ae(b2.labelError, f2) }, i2)));
  }, fa = function() {
    return fa = Object.assign || function(e2) {
      for (var t2, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var a2 in t2 = arguments[n2]) Object.prototype.hasOwnProperty.call(t2, a2) && (e2[a2] = t2[a2]);
      return e2;
    }, fa.apply(this, arguments);
  }, ha = (0, p.makeStyles)(function() {
    return { input: { border: "1px solid #c4c4c4", borderRadius: "4px", background: "transparent", fontSize: "12px", "& input": { fontSize: "12px", paddingTop: "14px" }, "& input::-webkit-outer-spin-button, input::-webkit-inner-spin-button": { "-webkit-appearance": "none", margin: 0 }, "& input[type=number]": { "-moz-appearance": "textfield" }, "&:before": { content: "none" }, "&:after": { content: "none" }, "&:not(.MuiFilledInput-root.Mui-disabled):hover": { background: "transparent" } }, inputLabel: { fontSize: "10px", lineHeight: "4px", color: "#73747C", transform: "translate(12px, 19px) scale(1)", "&.MuiInputLabel-filled.MuiInputLabel-shrink": { transform: "translate(12px, 10px) scale(.8)" }, "&.Mui-focused": { color: "#73747C" } } };
  }), ma = function(e2) {
    var t2 = (function(e3, t3) {
      var n3 = {};
      for (var r2 in e3) Object.prototype.hasOwnProperty.call(e3, r2) && t3.indexOf(r2) < 0 && (n3[r2] = e3[r2]);
      if (null != e3 && "function" == typeof Object.getOwnPropertySymbols) {
        var a2 = 0;
        for (r2 = Object.getOwnPropertySymbols(e3); a2 < r2.length; a2++) t3.indexOf(r2[a2]) < 0 && Object.prototype.propertyIsEnumerable.call(e3, r2[a2]) && (n3[r2[a2]] = e3[r2[a2]]);
      }
      return n3;
    })(e2, []), n2 = ha(t2);
    return d().createElement(p.TextField, fa({ variant: "filled" }, e2, { InputLabelProps: fa({ className: n2.inputLabel }, e2.InputLabelProps), InputProps: fa({ className: n2.input }, e2.InputProps) }));
  };
  const va = { overrides: { MuiFormLabel: { asterisk: { color: "#db3131", "&$error": { color: "#db3131" } } }, MuiButton: { root: { letterSpacing: "normal" }, contained: { boxShadow: "none" } }, MuiInputBase: { root: { fontFamily: "inherit" } } }, palette: { type: "light", primary: { main: "#f0a601", contrastText: "#fff" }, secondary: { main: "#3c4051" }, warning: { main: "#f0a601" }, error: { main: "#ff5c4a" }, success: { main: "#43c079" }, text: { primary: "#3c4051", secondary: "#73747c", disabled: "", hint: "" }, divider: "#ebeff2", background: { default: "#f5f6fa", paper: "#fff" } }, zIndex: { modal: 99997, snackbar: 99998, tooltip: 99999 } };
  var ga = function(e2) {
    var t2 = e2.children, n2 = e2.themeOptions;
    if (!n2) return d().createElement(d().Fragment, null);
    var r2 = (0, Sn.createTheme)(n2 || va);
    return d().createElement(Sn.ThemeProvider, { theme: r2 }, d().createElement(p.CssBaseline, null), t2);
  };
  const ba = { overrides: { MuiFormLabel: { asterisk: { color: "#db3131", "&$error": { color: "#db3131" } } }, MuiButton: { root: { letterSpacing: "normal" }, contained: { boxShadow: "none" } }, MuiInputBase: { root: { fontFamily: "inherit" } } }, palette: { type: "dark", primary: { main: "#f0a601", contrastText: "#fff" }, secondary: { main: "#3c4051" }, warning: { main: "#f0a601" }, error: { main: "#ff5c4a" }, success: { main: "#43c079" }, text: { primary: "#c9cdcf", secondary: "#73747c", disabled: "", hint: "" }, divider: "#3a3a3a", background: { default: "#151516", paper: "#252526" } } };
  return c;
})());


/***/ }),

/***/ 60096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "T", 0, /* binding */ DEBUG_BUILD
/* harmony export */ ]);


/***/ }),

/***/ 16487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   qd: function() { return /* binding */ getNativeImplementation; },
/* harmony export */   wg: function() { return /* binding */ setTimeout; },
/* harmony export */   y7: function() { return /* binding */ clearCachedImplementation; }
/* harmony export */ });
/* unused harmony export fetch */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62183);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53717);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60096);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84335);



const cachedImplementations = {};
function getNativeImplementation(name) {
  const cached = cachedImplementations[name];
  if (cached) {
    return cached;
  }
  let impl = _types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j[name];
  if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .isNativeFunction */ .a3)(impl)) {
    return cachedImplementations[name] = impl.bind(_types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j);
  }
  const document = _types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j.document;
  if (document && typeof document.createElement === "function") {
    try {
      const sandbox = document.createElement("iframe");
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow?.[name]) {
        impl = contentWindow[name];
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .T && _sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .debug */ .Yz.warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
  }
  if (!impl) {
    return impl;
  }
  return cachedImplementations[name] = impl.bind(_types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j);
}
function clearCachedImplementation(name) {
  cachedImplementations[name] = void 0;
}
function fetch(...rest) {
  return getNativeImplementation("fetch")(...rest);
}
function setTimeout(...rest) {
  return getNativeImplementation("setTimeout")(...rest);
}



/***/ }),

/***/ 89972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: function() { return /* binding */ htmlTreeAsString; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91973);

const DEFAULT_MAX_STRING_LENGTH = 80;
const accessors = {};
try {
  if (typeof Node !== "undefined") {
    accessors.parentNode = Object.getOwnPropertyDescriptor(Node.prototype, "parentNode").get;
  }
  if (typeof Element !== "undefined") {
    accessors.tagName = Object.getOwnPropertyDescriptor(Element.prototype, "tagName").get;
    accessors.id = Object.getOwnPropertyDescriptor(Element.prototype, "id").get;
    accessors.className = Object.getOwnPropertyDescriptor(Element.prototype, "className").get;
    accessors.getAttribute = Element.prototype.getAttribute;
  }
  if (typeof HTMLElement !== "undefined") {
    accessors.dataset = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "dataset").get;
  }
} catch {
}
function _safeRead(el, prop, arg) {
  const fn = accessors[prop];
  if (fn) {
    try {
      return fn.call(el, arg);
    } catch {
    }
  }
  const val = el[prop];
  return typeof val === "function" ? val.call(el, arg) : val;
}
function htmlTreeAsString(elem, options = {}) {
  if (!elem) {
    return "<unknown>";
  }
  try {
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = " > ";
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) {
        break;
      }
      out.push(nextStr);
      len += nextStr.length;
      currentElem = _safeRead(currentElem, "parentNode");
    }
    return out.reverse().join(separator);
  } catch {
    return "<unknown>";
  }
}
function _htmlElementAsString(el, keyAttrs) {
  const out = [];
  const tagName = _safeRead(el, "tagName");
  if (!tagName) {
    return "";
  }
  if (typeof HTMLElement !== "undefined") {
    if (el instanceof HTMLElement) {
      const dataset = _safeRead(el, "dataset");
      if (dataset) {
        if (dataset["sentryComponent"]) {
          return dataset["sentryComponent"];
        }
        if (dataset["sentryElement"]) {
          return dataset["sentryElement"];
        }
      }
    }
  }
  out.push(tagName.toLowerCase());
  const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr) => _safeRead(el, "getAttribute", keyAttr)).map((keyAttr) => [keyAttr, _safeRead(el, "getAttribute", keyAttr)]) : null;
  if (keyAttrPairs?.length) {
    keyAttrPairs.forEach((keyAttrPair) => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    const id = _safeRead(el, "id");
    if (id) {
      out.push(`#${id}`);
    }
    const className = _safeRead(el, "className");
    if (className && (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .Kg)(className)) {
      const classes = className.split(/\s+/);
      for (const c of classes) {
        out.push(`.${c}`);
      }
    }
  }
  for (const k of ["aria-label", "type", "name", "title", "alt"]) {
    const attr = _safeRead(el, "getAttribute", k);
    if (attr) {
      out.push(`[${k}="${attr}"]`);
    }
  }
  return out.join("");
}



/***/ }),

/***/ 8634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: function() { return /* binding */ addClickKeypressInstrumentationHandler; }
/* harmony export */ });
/* unused harmony export instrumentDOM */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20360);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16513);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50742);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84335);


const DEBOUNCE_DURATION = 1e3;
let debounceTimerID;
let lastCapturedEventType;
let lastCapturedEventTargetId;
function addClickKeypressInstrumentationHandler(handler) {
  const type = "dom";
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .s5)(type, handler);
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .AS)(type, instrumentDOM);
}
function instrumentDOM() {
  if (!_types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j.document) {
    return;
  }
  const triggerDOMHandler = _sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .aj.bind(null, "dom");
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  _types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j.document.addEventListener("click", globalDOMEventHandler, false);
  _types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j.document.addEventListener("keypress", globalDOMEventHandler, false);
  ["EventTarget", "Node"].forEach((target) => {
    const globalObject = _types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j;
    const proto = globalObject[target]?.prototype;
    if (!proto?.hasOwnProperty?.("addEventListener")) {
      return;
    }
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .GS)(proto, "addEventListener", function(originalAddEventListener) {
      return function(type, listener, options) {
        if (type === "click" || type == "keypress") {
          try {
            const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
            const handlerForType = handlers[type] = handlers[type] || { refCount: 0 };
            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }
            handlerForType.refCount++;
          } catch {
          }
        }
        return originalAddEventListener.call(this, type, listener, options);
      };
    });
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .GS)(
      proto,
      "removeEventListener",
      function(originalRemoveEventListener) {
        return function(type, listener, options) {
          if (type === "click" || type == "keypress") {
            try {
              const handlers = this.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];
              if (handlerForType) {
                handlerForType.refCount--;
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = void 0;
                  delete handlers[type];
                }
                if (Object.keys(handlers).length === 0) {
                  delete this.__sentry_instrumentation_handlers__;
                }
              }
            } catch {
            }
          }
          return originalRemoveEventListener.call(this, type, listener, options);
        };
      }
    );
  });
}
function isSimilarToLastCapturedEvent(event) {
  if (event.type !== lastCapturedEventType) {
    return false;
  }
  try {
    if (!event.target || event.target._sentryId !== lastCapturedEventTargetId) {
      return false;
    }
  } catch {
  }
  return true;
}
function shouldSkipDOMEvent(eventType, target) {
  if (eventType !== "keypress") {
    return false;
  }
  if (!target?.tagName) {
    return true;
  }
  if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
    return false;
  }
  return true;
}
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    if (!event || event["_sentryCaptured"]) {
      return;
    }
    const target = getEventTarget(event);
    if (shouldSkipDOMEvent(event.type, target)) {
      return;
    }
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .my)(event, "_sentryCaptured", true);
    if (target && !target._sentryId) {
      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .my)(target, "_sentryId", (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .eJ)());
    }
    const name = event.type === "keypress" ? "input" : event.type;
    if (!isSimilarToLastCapturedEvent(event)) {
      const handlerData = { event, name, global: globalListener };
      handler(handlerData);
      lastCapturedEventType = event.type;
      lastCapturedEventTargetId = target ? target._sentryId : void 0;
    }
    clearTimeout(debounceTimerID);
    debounceTimerID = _types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j.setTimeout(() => {
      lastCapturedEventTargetId = void 0;
      lastCapturedEventType = void 0;
    }, DEBOUNCE_DURATION);
  };
}
function getEventTarget(event) {
  try {
    return event.target;
  } catch {
    return null;
  }
}



/***/ }),

/***/ 19150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: function() { return /* binding */ addHistoryInstrumentationHandler; }
/* harmony export */ });
/* unused harmony export instrumentHistory */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20360);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50742);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53717);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84335);


let lastHref;
function addHistoryInstrumentationHandler(handler) {
  const type = "history";
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .s5)(type, handler);
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .AS)(type, instrumentHistory);
}
function instrumentHistory() {
  _types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j.addEventListener("popstate", () => {
    const to = _types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j.location.href;
    const from = lastHref;
    lastHref = to;
    if (from === to) {
      return;
    }
    const handlerData = { from, to };
    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .aj)("history", handlerData);
  });
  if (!(0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .supportsHistory */ .NJ)()) {
    return;
  }
  function historyReplacementFunction(originalHistoryFunction) {
    return function(...args) {
      const url = args.length > 2 ? args[2] : void 0;
      if (url) {
        const from = lastHref;
        const to = getAbsoluteUrl(String(url));
        lastHref = to;
        if (from === to) {
          return originalHistoryFunction.apply(this, args);
        }
        const handlerData = { from, to };
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .aj)("history", handlerData);
      }
      return originalHistoryFunction.apply(this, args);
    };
  }
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .GS)(_types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j.history, "pushState", historyReplacementFunction);
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .GS)(_types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j.history, "replaceState", historyReplacementFunction);
}
function getAbsoluteUrl(urlOrPath) {
  try {
    const url = new URL(urlOrPath, _types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j.location.origin);
    return url.toString();
  } catch {
    return urlOrPath;
  }
}



/***/ }),

/***/ 7440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Mn: function() { return /* binding */ addXhrInstrumentationHandler; }
/* harmony export */ });
/* unused harmony export instrumentXHR */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20360);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91973);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39612);
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84335);


const SENTRY_XHR_DATA_KEY = "__sentry_xhr_v3__";
function addXhrInstrumentationHandler(handler) {
  const type = "xhr";
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .addHandler */ .s5)(type, handler);
  (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .maybeInstrument */ .AS)(type, instrumentXHR);
}
function instrumentXHR() {
  if (!_types_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .j.XMLHttpRequest) {
    return;
  }
  const xhrproto = XMLHttpRequest.prototype;
  xhrproto.open = new Proxy(xhrproto.open, {
    apply(originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
      const virtualError = new Error();
      const startTimestamp = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .zf)() * 1e3;
      const method = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .Kg)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : void 0;
      const url = parseXhrUrlArg(xhrOpenArgArray[1]);
      if (!method || !url) {
        return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
      }
      xhrOpenThisArg[SENTRY_XHR_DATA_KEY] = {
        method,
        url,
        request_headers: {}
      };
      if (method === "POST" && url.match(/sentry_key/)) {
        xhrOpenThisArg.__sentry_own_request__ = true;
      }
      const onreadystatechangeHandler = () => {
        const xhrInfo = xhrOpenThisArg[SENTRY_XHR_DATA_KEY];
        if (!xhrInfo) {
          return;
        }
        if (xhrOpenThisArg.readyState === 4) {
          try {
            xhrInfo.status_code = xhrOpenThisArg.status;
          } catch {
          }
          const handlerData = {
            endTimestamp: (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .zf)() * 1e3,
            startTimestamp,
            xhr: xhrOpenThisArg,
            virtualError
          };
          (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .aj)("xhr", handlerData);
        }
      };
      if ("onreadystatechange" in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === "function") {
        xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
          apply(originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
            onreadystatechangeHandler();
            return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
          }
        });
      } else {
        xhrOpenThisArg.addEventListener("readystatechange", onreadystatechangeHandler);
      }
      xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
        apply(originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
          const [header, value] = setRequestHeaderArgArray;
          const xhrInfo = setRequestHeaderThisArg[SENTRY_XHR_DATA_KEY];
          if (xhrInfo && (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .Kg)(header) && (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .Kg)(value)) {
            xhrInfo.request_headers[header.toLowerCase()] = value;
          }
          return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
        }
      });
      return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
    }
  });
  xhrproto.send = new Proxy(xhrproto.send, {
    apply(originalSend, sendThisArg, sendArgArray) {
      const sentryXhrData = sendThisArg[SENTRY_XHR_DATA_KEY];
      if (!sentryXhrData) {
        return originalSend.apply(sendThisArg, sendArgArray);
      }
      if (sendArgArray[0] !== void 0) {
        sentryXhrData.body = sendArgArray[0];
      }
      const handlerData = {
        startTimestamp: (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .zf)() * 1e3,
        xhr: sendThisArg
      };
      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .triggerHandlers */ .aj)("xhr", handlerData);
      return originalSend.apply(sendThisArg, sendArgArray);
    }
  });
}
function parseXhrUrlArg(url) {
  if ((0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .Kg)(url)) {
    return url;
  }
  try {
    return url.toString();
  } catch {
  }
  return void 0;
}


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "Er", 0, /* binding */ SENTRY_XHR_DATA_KEY
/* harmony export */ ]);


/***/ }),

/***/ 60061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  QU: function() { return /* binding */ addPerformanceEntries; },
  e4: function() { return /* binding */ addWebVitalsToSpan; },
  DI: function() { return /* binding */ startTrackingInteractions; },
  U$: function() { return /* binding */ startTrackingLongAnimationFrames; },
  c8: function() { return /* binding */ startTrackingLongTasks; },
  bk: function() { return /* binding */ startTrackingWebVitals; }
});

// UNUSED EXPORTS: _addMeasureSpans, _addNavigationSpans, _addResourceSpans, _setResourceRequestAttributes

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/time.js
var time = __webpack_require__(39612);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(42896);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91302);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/browser.js
var browser = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-logger.js
var debug_logger = __webpack_require__(62183);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/measurement.js
var tracing_measurement = __webpack_require__(54886);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/string.js
var string = __webpack_require__(26228);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/is.js
var is = __webpack_require__(91973);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/url.js
var url = __webpack_require__(77636);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/htmlTreeAsString.js
var htmlTreeAsString = __webpack_require__(89972);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/types.js
var types = __webpack_require__(84335);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/debug-build.js
var debug_build = __webpack_require__(60096);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/instrument.js + 15 modules
var instrument = __webpack_require__(33731);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/utils.js + 1 modules
var utils = __webpack_require__(66116);
;// ./node_modules/@sentry/browser-utils/build/esm/metrics/cls.js





function trackClsAsStandaloneSpan(client) {
  let standaloneCLsValue = 0;
  let standaloneClsEntry;
  if (!(0,utils/* supportsWebVital */.Jy)("layout-shift")) {
    return;
  }
  const cleanupClsHandler = (0,instrument/* addClsInstrumentationHandler */.a9)(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    standaloneCLsValue = metric.value;
    standaloneClsEntry = entry;
  }, true);
  (0,utils/* listenForWebVitalReportEvents */.WF)(client, (reportEvent, pageloadSpanId) => {
    _sendStandaloneClsSpan(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
    cleanupClsHandler();
  });
}
function _sendStandaloneClsSpan(clsValue, entry, pageloadSpanId, reportEvent) {
  debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log(`Sending CLS span (${clsValue})`);
  const startTime = entry ? (0,utils/* msToSec */.rv)(((0,time/* browserPerformanceTimeOrigin */.k3)() || 0) + entry.startTime) : (0,time/* timestampInSeconds */.zf)();
  const routeName = (0,currentScopes/* getCurrentScope */.o5)().getScopeData().transactionName;
  const name = entry ? (0,htmlTreeAsString/* htmlTreeAsString */.H)(entry.sources[0]?.node) : "Layout shift";
  const attributes = {
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.http.browser.cls",
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.uT]: "ui.webvital.cls",
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME */.jG]: 0,
    // attach the pageload span id to the CLS span so that we can link them in the UI
    "sentry.pageload.span_id": pageloadSpanId,
    // describes what triggered the web vital to be reported
    "sentry.report_event": reportEvent
  };
  if (entry?.sources) {
    entry.sources.forEach((source, index) => {
      attributes[`cls.source.${index + 1}`] = (0,htmlTreeAsString/* htmlTreeAsString */.H)(source.node);
    });
  }
  const span = (0,utils/* startStandaloneWebVitalSpan */.kD)({
    name,
    transaction: routeName,
    attributes,
    startTime
  });
  if (span) {
    span.addEvent("cls", {
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT */.Sn]: "",
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE */.xc]: clsValue
    });
    span.end(startTime);
  }
}


// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/lcp.js
var lcp = __webpack_require__(30075);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/resourceTiming.js
var resourceTiming = __webpack_require__(78280);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/getActivationStart.js
var getActivationStart = __webpack_require__(83387);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/getNavigationEntry.js
var getNavigationEntry = __webpack_require__(70277);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/getVisibilityWatcher.js
var getVisibilityWatcher = __webpack_require__(25499);
;// ./node_modules/@sentry/browser-utils/build/esm/metrics/browserMetrics.js












const MAX_INT_AS_BYTES = 2147483647;
let _performanceCursor = 0;
let _measurements = {};
let _lcpEntry;
let _clsEntry;
function startTrackingWebVitals({
  recordClsStandaloneSpans,
  recordLcpStandaloneSpans,
  client
}) {
  const performance = (0,utils/* getBrowserPerformanceAPI */.D)();
  if (performance && (0,time/* browserPerformanceTimeOrigin */.k3)()) {
    if (performance.mark) {
      types/* WINDOW */.j.performance.mark("sentry-tracing-init");
    }
    const lcpCleanupCallback = recordLcpStandaloneSpans ? (0,lcp/* trackLcpAsStandaloneSpan */.Qv)(client) : recordLcpStandaloneSpans === false ? _trackLCP() : void 0;
    const clsCleanupCallback = recordClsStandaloneSpans ? trackClsAsStandaloneSpan(client) : recordClsStandaloneSpans === false ? _trackCLS() : void 0;
    const ttfbCleanupCallback = _trackTtfb();
    const fpFcpCleanupCallback = _trackFpFcp();
    return () => {
      ttfbCleanupCallback();
      fpFcpCleanupCallback();
      lcpCleanupCallback?.();
      clsCleanupCallback?.();
    };
  }
  return () => void 0;
}
function startTrackingLongTasks() {
  (0,instrument/* addPerformanceInstrumentationHandler */.wv)("longtask", ({ entries }) => {
    const parent = (0,spanUtils/* getActiveSpan */.Bk)();
    if (!parent) {
      return;
    }
    const { op: parentOp, start_timestamp: parentStartTimestamp } = (0,spanUtils/* spanToJSON */.et)(parent);
    for (const entry of entries) {
      const startTime = (0,utils/* msToSec */.rv)((0,time/* browserPerformanceTimeOrigin */.k3)() + entry.startTime);
      const duration = (0,utils/* msToSec */.rv)(entry.duration);
      if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) {
        continue;
      }
      (0,utils/* startAndEndSpan */.Tn)(parent, startTime, startTime + duration, {
        name: "Main UI thread blocked",
        op: "ui.long-task",
        attributes: {
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.ui.browser.metrics"
        }
      });
    }
  });
}
function startTrackingLongAnimationFrames() {
  const observer = new PerformanceObserver((list) => {
    const parent = (0,spanUtils/* getActiveSpan */.Bk)();
    if (!parent) {
      return;
    }
    for (const entry of list.getEntries()) {
      if (!entry.scripts[0]) {
        continue;
      }
      const startTime = (0,utils/* msToSec */.rv)((0,time/* browserPerformanceTimeOrigin */.k3)() + entry.startTime);
      const { start_timestamp: parentStartTimestamp, op: parentOp } = (0,spanUtils/* spanToJSON */.et)(parent);
      if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) {
        continue;
      }
      const duration = (0,utils/* msToSec */.rv)(entry.duration);
      const attributes = {
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.ui.browser.metrics"
      };
      const initialScript = entry.scripts[0];
      const { invoker, invokerType, sourceURL, sourceFunctionName, sourceCharPosition } = initialScript;
      attributes["browser.script.invoker"] = invoker;
      attributes["browser.script.invoker_type"] = invokerType;
      if (sourceURL) {
        attributes["code.filepath"] = sourceURL;
      }
      if (sourceFunctionName) {
        attributes["code.function"] = sourceFunctionName;
      }
      if (sourceCharPosition !== -1) {
        attributes["browser.script.source_char_position"] = sourceCharPosition;
      }
      (0,utils/* startAndEndSpan */.Tn)(parent, startTime, startTime + duration, {
        name: "Main UI thread blocked",
        op: "ui.long-animation-frame",
        attributes
      });
    }
  });
  observer.observe({ type: "long-animation-frame", buffered: true });
}
function startTrackingInteractions() {
  (0,instrument/* addPerformanceInstrumentationHandler */.wv)("event", ({ entries }) => {
    const parent = (0,spanUtils/* getActiveSpan */.Bk)();
    if (!parent) {
      return;
    }
    for (const entry of entries) {
      if (entry.name === "click") {
        const startTime = (0,utils/* msToSec */.rv)((0,time/* browserPerformanceTimeOrigin */.k3)() + entry.startTime);
        const duration = (0,utils/* msToSec */.rv)(entry.duration);
        const spanOptions = {
          name: (0,htmlTreeAsString/* htmlTreeAsString */.H)(entry.target),
          op: `ui.interaction.${entry.name}`,
          startTime,
          attributes: {
            [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.ui.browser.metrics"
          }
        };
        const componentName = (0,browser/* getComponentName */.xE)(entry.target);
        if (componentName) {
          spanOptions.attributes["ui.component_name"] = componentName;
        }
        (0,utils/* startAndEndSpan */.Tn)(parent, startTime, startTime + duration, spanOptions);
      }
    }
  });
}
function _trackCLS() {
  return (0,instrument/* addClsInstrumentationHandler */.a9)(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    _measurements["cls"] = { value: metric.value, unit: "" };
    _clsEntry = entry;
  }, true);
}
function _trackLCP() {
  return (0,instrument/* addLcpInstrumentationHandler */.Pt)(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry || !(0,lcp/* isValidLcpMetric */.CE)(metric.value)) {
      return;
    }
    _measurements["lcp"] = { value: metric.value, unit: "millisecond" };
    _lcpEntry = entry;
  }, true);
}
function _trackTtfb() {
  return (0,instrument/* addTtfbInstrumentationHandler */.YG)(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    _measurements["ttfb"] = { value: metric.value, unit: "millisecond" };
  });
}
function _trackFpFcp() {
  return (0,instrument/* addPerformanceInstrumentationHandler */.wv)("paint", ({ entries }) => {
    const firstHidden = (0,getVisibilityWatcher/* getVisibilityWatcher */.N)();
    for (const entry of entries) {
      const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
      if (entry.name === "first-paint" && shouldRecord) {
        _measurements["fp"] = { value: entry.startTime, unit: "millisecond" };
      }
      if (entry.name === "first-contentful-paint" && shouldRecord) {
        _measurements["fcp"] = { value: entry.startTime, unit: "millisecond" };
      }
    }
  });
}
function addPerformanceEntries(span, options) {
  const performance = (0,utils/* getBrowserPerformanceAPI */.D)();
  const origin = (0,time/* browserPerformanceTimeOrigin */.k3)();
  if (!performance?.getEntries || !origin) {
    return;
  }
  const { spanStreamingEnabled, ignorePerformanceApiSpans, ignoreResourceSpans } = options;
  const timeOrigin = (0,utils/* msToSec */.rv)(origin);
  const performanceEntries = performance.getEntries();
  const { op, start_timestamp: transactionStartTime } = (0,spanUtils/* spanToJSON */.et)(span);
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = (0,utils/* msToSec */.rv)(entry.startTime);
    const duration = (0,utils/* msToSec */.rv)(
      // Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
      // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
      // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
      // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
      Math.max(0, entry.duration)
    );
    if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) {
      return;
    }
    switch (entry.entryType) {
      case "navigation": {
        _addNavigationSpans(span, entry, timeOrigin);
        break;
      }
      case "mark":
      case "paint":
      case "measure": {
        _addMeasureSpans(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans);
        break;
      }
      case "resource": {
        _addResourceSpans(
          span,
          entry,
          entry.name,
          startTime,
          duration,
          timeOrigin,
          ignoreResourceSpans
        );
        break;
      }
    }
  });
  _performanceCursor = Math.max(performanceEntries.length - 1, 0);
  _trackNavigator(span, spanStreamingEnabled);
}
function addWebVitalsToSpan(span, options) {
  const origin = (0,time/* browserPerformanceTimeOrigin */.k3)();
  if (!(0,utils/* getBrowserPerformanceAPI */.D)()?.getEntries || !origin) {
    resetWebVitalState();
    return;
  }
  const { spanStreamingEnabled, recordClsOnPageloadSpan, recordLcpOnPageloadSpan } = options;
  const timeOrigin = (0,utils/* msToSec */.rv)(origin);
  if ((0,spanUtils/* spanToJSON */.et)(span).op === "pageload") {
    _addTtfbRequestTimeToMeasurements(_measurements);
    if (spanStreamingEnabled) {
      const setAttr = (shortWebVitalName, value, customAttrName) => {
        const attrKey = customAttrName ?? `browser.web_vital.${shortWebVitalName}.value`;
        span.setAttribute(attrKey, value);
        debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log("Setting web vital attribute", { [attrKey]: value }, "on pageload span");
      };
      ["ttfb", "fp", "fcp"].forEach((measurementName) => {
        if (_measurements[measurementName]) {
          setAttr(measurementName, _measurements[measurementName].value);
        }
      });
      if (_measurements["ttfb.requestTime"]) {
        setAttr("ttfb.requestTime", _measurements["ttfb.requestTime"].value, "browser.web_vital.ttfb.request_time");
      }
    } else {
      if (!recordClsOnPageloadSpan) {
        delete _measurements.cls;
      }
      if (!recordLcpOnPageloadSpan) {
        delete _measurements.lcp;
      }
      Object.entries(_measurements).forEach(([measurementName, measurement]) => {
        (0,tracing_measurement/* setMeasurement */.X)(measurementName, measurement.value, measurement.unit, span);
      });
      _setWebVitalAttributes(span, options);
    }
    span.setAttribute(spanStreamingEnabled ? "browser.performance.time_origin" : "performance.timeOrigin", timeOrigin);
    span.setAttribute(
      spanStreamingEnabled ? "browser.performance.navigation.activation_start" : "performance.activationStart",
      (0,getActivationStart/* getActivationStart */.b)()
    );
  }
  resetWebVitalState();
}
function resetWebVitalState() {
  _lcpEntry = void 0;
  _clsEntry = void 0;
  _measurements = {};
}
function isReact19MeasureEntry(entry) {
  if (entry?.entryType !== "measure") {
    return;
  }
  try {
    return entry.detail.devtools.track === "Components \u269B";
  } catch {
    return;
  }
}
function _addMeasureSpans(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
  if (isReact19MeasureEntry(entry)) {
    return;
  }
  if (["mark", "measure"].includes(entry.entryType) && (0,string/* stringMatchesSomePattern */.Xr)(entry.name, ignorePerformanceApiSpans)) {
    return;
  }
  const navEntry = (0,getNavigationEntry/* getNavigationEntry */.z)(false);
  const requestTime = (0,utils/* msToSec */.rv)(navEntry ? navEntry.requestStart : 0);
  const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
  const startTimeStamp = timeOrigin + startTime;
  const measureEndTimestamp = startTimeStamp + duration;
  const attributes = {
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.resource.browser.metrics"
  };
  if (measureStartTimestamp !== startTimeStamp) {
    attributes["sentry.browser.measure_happened_before_request"] = true;
    attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
  }
  _addDetailToSpanAttributes(attributes, entry);
  if (measureStartTimestamp <= measureEndTimestamp) {
    (0,utils/* startAndEndSpan */.Tn)(span, measureStartTimestamp, measureEndTimestamp, {
      name: entry.name,
      op: entry.entryType,
      attributes
    });
  }
}
function _addDetailToSpanAttributes(attributes, performanceMeasure) {
  try {
    const detail = performanceMeasure.detail;
    if (!detail) {
      return;
    }
    if (typeof detail === "object") {
      for (const [key, value] of Object.entries(detail)) {
        if (value && (0,is/* isPrimitive */.sO)(value)) {
          attributes[`sentry.browser.measure.detail.${key}`] = value;
        } else if (value !== void 0) {
          try {
            attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
          } catch {
          }
        }
      }
      return;
    }
    if ((0,is/* isPrimitive */.sO)(detail)) {
      attributes["sentry.browser.measure.detail"] = detail;
      return;
    }
    try {
      attributes["sentry.browser.measure.detail"] = JSON.stringify(detail);
    } catch {
    }
  } catch {
  }
}
function _addNavigationSpans(span, entry, timeOrigin) {
  ["unloadEvent", "redirect", "domContentLoadedEvent", "loadEvent", "connect"].forEach((event) => {
    _addPerformanceNavigationTiming(span, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
  _addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
  _addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
  _addRequest(span, entry, timeOrigin);
}
function _addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
  const eventEnd = _getEndPropertyNameForNavigationTiming(event);
  const end = entry[eventEnd];
  const start = entry[`${event}Start`];
  if (!start || !end) {
    return;
  }
  (0,utils/* startAndEndSpan */.Tn)(span, timeOrigin + (0,utils/* msToSec */.rv)(start), timeOrigin + (0,utils/* msToSec */.rv)(end), {
    op: `browser.${name}`,
    name: entry.name,
    attributes: {
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.ui.browser.metrics",
      ...event === "redirect" && entry.redirectCount != null ? { "http.redirect_count": entry.redirectCount } : {}
    }
  });
}
function _getEndPropertyNameForNavigationTiming(event) {
  if (event === "secureConnection") {
    return "connectEnd";
  }
  if (event === "fetch") {
    return "domainLookupStart";
  }
  return `${event}End`;
}
function _addRequest(span, entry, timeOrigin) {
  const requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.rv)(entry.requestStart);
  const responseEndTimestamp = timeOrigin + (0,utils/* msToSec */.rv)(entry.responseEnd);
  const responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.rv)(entry.responseStart);
  if (entry.responseEnd) {
    (0,utils/* startAndEndSpan */.Tn)(span, requestStartTimestamp, responseEndTimestamp, {
      op: "browser.request",
      name: entry.name,
      attributes: {
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.ui.browser.metrics"
      }
    });
    (0,utils/* startAndEndSpan */.Tn)(span, responseStartTimestamp, responseEndTimestamp, {
      op: "browser.response",
      name: entry.name,
      attributes: {
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.ui.browser.metrics"
      }
    });
  }
}
function _addResourceSpans(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
  if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") {
    return;
  }
  const op = entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other";
  if (ignoredResourceSpanOps?.includes(op)) {
    return;
  }
  const attributes = {
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.resource.browser.metrics"
  };
  const parsedUrl = (0,url/* parseUrl */.Dl)(resourceUrl);
  if (parsedUrl.protocol) {
    attributes["url.scheme"] = parsedUrl.protocol.split(":").pop();
  }
  if (parsedUrl.host) {
    attributes["server.address"] = parsedUrl.host;
  }
  attributes["url.same_origin"] = resourceUrl.includes(types/* WINDOW */.j.location.origin);
  attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_URL_FULL */.c9] = resourceUrl;
  _setResourceRequestAttributes(entry, attributes, [
    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
    ["responseStatus", "http.response.status_code"],
    ["transferSize", "http.response_transfer_size"],
    ["encodedBodySize", "http.response_content_length"],
    ["decodedBodySize", "http.decoded_response_content_length"],
    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
    ["renderBlockingStatus", "resource.render_blocking_status"],
    // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
    ["deliveryType", "http.response_delivery_type"]
  ]);
  const attributesWithResourceTiming = { ...attributes, ...(0,resourceTiming/* resourceTimingToSpanAttributes */.v)(entry) };
  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;
  (0,utils/* startAndEndSpan */.Tn)(span, startTimestamp, endTimestamp, {
    name: resourceUrl.replace(types/* WINDOW */.j.location.origin, ""),
    op,
    attributes: attributesWithResourceTiming
  });
}
function _trackNavigator(span, spanStreamingEnabled) {
  const navigator = types/* WINDOW */.j.navigator;
  if (!navigator) {
    return;
  }
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      span.setAttribute(
        spanStreamingEnabled ? "network.connection.effective_type" : "effectiveConnectionType",
        connection.effectiveType
      );
    }
    if (connection.type) {
      span.setAttribute(spanStreamingEnabled ? "network.connection.type" : "connectionType", connection.type);
    }
    if ((0,utils/* isMeasurementValue */.Kk)(connection.rtt)) {
      if (spanStreamingEnabled) {
        span.setAttribute("network.connection.rtt", connection.rtt);
      } else if ((0,spanUtils/* spanToJSON */.et)(span).op === "pageload") {
        (0,tracing_measurement/* setMeasurement */.X)("connection.rtt", connection.rtt, "millisecond");
      }
    }
  }
  if ((0,utils/* isMeasurementValue */.Kk)(navigator.deviceMemory)) {
    if (spanStreamingEnabled) {
      span.setAttribute("device.memory.estimated_capacity", navigator.deviceMemory);
    } else {
      span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    }
  }
  if ((0,utils/* isMeasurementValue */.Kk)(navigator.hardwareConcurrency)) {
    if (spanStreamingEnabled) {
      span.setAttribute("device.processor_count", navigator.hardwareConcurrency);
    } else {
      span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
    }
  }
}
function _setWebVitalAttributes(span, options) {
  if (_lcpEntry && options.recordLcpOnPageloadSpan) {
    if (_lcpEntry.element) {
      span.setAttribute("lcp.element", (0,htmlTreeAsString/* htmlTreeAsString */.H)(_lcpEntry.element));
    }
    if (_lcpEntry.id) {
      span.setAttribute("lcp.id", _lcpEntry.id);
    }
    if (_lcpEntry.url) {
      span.setAttribute("lcp.url", _lcpEntry.url.trim().slice(0, 200));
    }
    if (_lcpEntry.loadTime != null) {
      span.setAttribute("lcp.loadTime", _lcpEntry.loadTime);
    }
    if (_lcpEntry.renderTime != null) {
      span.setAttribute("lcp.renderTime", _lcpEntry.renderTime);
    }
    span.setAttribute("lcp.size", _lcpEntry.size);
  }
  if (_clsEntry?.sources && options.recordClsOnPageloadSpan) {
    _clsEntry.sources.forEach(
      (source, index) => span.setAttribute(`cls.source.${index + 1}`, (0,htmlTreeAsString/* htmlTreeAsString */.H)(source.node))
    );
  }
}
function _setResourceRequestAttributes(entry, attributes, properties) {
  properties.forEach(([entryKey, attributeKey]) => {
    const entryVal = entry[entryKey];
    if (entryVal != null && (typeof entryVal === "number" && entryVal < MAX_INT_AS_BYTES || typeof entryVal === "string")) {
      attributes[attributeKey] = entryVal;
    }
  });
}
function _addTtfbRequestTimeToMeasurements(_measurements2) {
  const navEntry = (0,getNavigationEntry/* getNavigationEntry */.z)(false);
  if (!navEntry) {
    return;
  }
  const { responseStart, requestStart } = navEntry;
  if (requestStart <= responseStart) {
    _measurements2["ttfb.requestTime"] = {
      value: responseStart - requestStart,
      unit: "millisecond"
    };
  }
}



/***/ }),

/***/ 33731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  a9: function() { return /* binding */ addClsInstrumentationHandler; },
  hT: function() { return /* binding */ addInpInstrumentationHandler; },
  Pt: function() { return /* binding */ addLcpInstrumentationHandler; },
  wv: function() { return /* binding */ addPerformanceInstrumentationHandler; },
  YG: function() { return /* binding */ addTtfbInstrumentationHandler; },
  tC: function() { return /* binding */ isPerformanceEventTiming; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-logger.js
var debug_logger = __webpack_require__(62183);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/stacktrace.js
var stacktrace = __webpack_require__(52992);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/debug-build.js
var debug_build = __webpack_require__(60096);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/types.js
var types = __webpack_require__(84335);
;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/bindReporter.js
const getRating = (value, thresholds) => {
  if (value > thresholds[1]) {
    return "poor";
  }
  if (value > thresholds[0]) {
    return "needs-improvement";
  }
  return "good";
};
const bindReporter = (callback, metric, thresholds, reportAllChanges) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue ?? 0);
        if (delta || prevValue === void 0) {
          prevValue = metric.value;
          metric.delta = delta;
          metric.rating = getRating(metric.value, thresholds);
          callback(metric);
        }
      }
    }
  };
};


// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/getVisibilityWatcher.js
var getVisibilityWatcher = __webpack_require__(25499);
;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/generateUniqueID.js
const generateUniqueID = () => {
  return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/getActivationStart.js
var getActivationStart = __webpack_require__(83387);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/getNavigationEntry.js
var getNavigationEntry = __webpack_require__(70277);
;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/initMetric.js




const initMetric = (name, value = -1) => {
  const navEntry = (0,getNavigationEntry/* getNavigationEntry */.z)();
  let navigationType = "navigate";
  if (navEntry) {
    if (types/* WINDOW */.j.document?.prerendering || (0,getActivationStart/* getActivationStart */.b)() > 0) {
      navigationType = "prerender";
    } else if (types/* WINDOW */.j.document?.wasDiscarded) {
      navigationType = "restore";
    } else if (navEntry.type) {
      navigationType = navEntry.type.replace(/_/g, "-");
    }
  }
  const entries = [];
  return {
    name,
    value,
    rating: "good",
    // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
    delta: 0,
    entries,
    id: generateUniqueID(),
    navigationType
  };
};


;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/initUnique.js
const instanceMap = /* @__PURE__ */ new WeakMap();
function initUnique(identityObj, ClassObj) {
  try {
    if (!instanceMap.get(identityObj)) {
      instanceMap.set(identityObj, new ClassObj());
    }
    return instanceMap.get(identityObj);
  } catch (_e) {
    return new ClassObj();
  }
}


;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/LayoutShiftManager.js
class LayoutShiftManager {
  constructor() {
    this._sessionValue = 0;
    this._sessionEntries = [];
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _processEntry(entry) {
    if (entry.hadRecentInput) return;
    const firstSessionEntry = this._sessionEntries[0];
    const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
    if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1e3 && entry.startTime - firstSessionEntry.startTime < 5e3) {
      this._sessionValue += entry.value;
      this._sessionEntries.push(entry);
    } else {
      this._sessionValue = entry.value;
      this._sessionEntries = [entry];
    }
    this._onAfterProcessingUnexpectedShift?.(entry);
  }
}


;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/observe.js
const observe = (type, callback, opts = {}) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver((list) => {
        Promise.resolve().then(() => {
          callback(list.getEntries());
        });
      });
      po.observe({ type, buffered: true, ...opts });
      return po;
    }
  } catch {
  }
  return;
};


// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/runOnce.js
var runOnce = __webpack_require__(4767);
;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/whenActivated.js

const whenActivated = (callback) => {
  if (types/* WINDOW */.j.document?.prerendering) {
    addEventListener("prerenderingchange", () => callback(), true);
  } else {
    callback();
  }
};


;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/onFCP.js






const FCPThresholds = [1800, 3e3];
const onFCP = (onReport, opts = {}) => {
  whenActivated(() => {
    const visibilityWatcher = (0,getVisibilityWatcher/* getVisibilityWatcher */.N)();
    const metric = initMetric("FCP");
    let report;
    const handleEntries = (entries) => {
      for (const entry of entries) {
        if (entry.name === "first-contentful-paint") {
          po.disconnect();
          if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = Math.max(entry.startTime - (0,getActivationStart/* getActivationStart */.b)(), 0);
            metric.entries.push(entry);
            report(true);
          }
        }
      }
    };
    const po = observe("paint", handleEntries);
    if (po) {
      report = bindReporter(onReport, metric, FCPThresholds, opts.reportAllChanges);
    }
  });
};


;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/getCLS.js









const CLSThresholds = [0.1, 0.25];
const onCLS = (onReport, opts = {}) => {
  onFCP(
    (0,runOnce/* runOnce */.J)(() => {
      const metric = initMetric("CLS", 0);
      let report;
      const visibilityWatcher = (0,getVisibilityWatcher/* getVisibilityWatcher */.N)();
      const layoutShiftManager = initUnique(opts, LayoutShiftManager);
      const handleEntries = (entries) => {
        for (const entry of entries) {
          layoutShiftManager._processEntry(entry);
        }
        if (layoutShiftManager._sessionValue > metric.value) {
          metric.value = layoutShiftManager._sessionValue;
          metric.entries = layoutShiftManager._sessionEntries;
          report();
        }
      };
      const po = observe("layout-shift", handleEntries);
      if (po) {
        report = bindReporter(onReport, metric, CLSThresholds, opts.reportAllChanges);
        visibilityWatcher.onHidden(() => {
          handleEntries(po.takeRecords());
          report(true);
        });
        types/* WINDOW */.j?.setTimeout?.(report);
      }
    })
  );
};


;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/polyfills/interactionCountPolyfill.js

let interactionCountEstimate = 0;
let minKnownInteractionId = Infinity;
let maxKnownInteractionId = 0;
const updateEstimate = (entries) => {
  entries.forEach((e) => {
    if (e.interactionId) {
      minKnownInteractionId = Math.min(minKnownInteractionId, e.interactionId);
      maxKnownInteractionId = Math.max(maxKnownInteractionId, e.interactionId);
      interactionCountEstimate = maxKnownInteractionId ? (maxKnownInteractionId - minKnownInteractionId) / 7 + 1 : 0;
    }
  });
};
let po;
const getInteractionCount = () => {
  return po ? interactionCountEstimate : performance.interactionCount || 0;
};
const initInteractionCountPolyfill = () => {
  if ("interactionCount" in performance || po) return;
  po = observe("event", updateEstimate, {
    type: "event",
    buffered: true,
    durationThreshold: 0
  });
};


;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/InteractionManager.js

const MAX_INTERACTIONS_TO_CONSIDER = 10;
let prevInteractionCount = 0;
const getInteractionCountForNavigation = () => {
  return getInteractionCount() - prevInteractionCount;
};
class InteractionManager {
  constructor() {
    this._longestInteractionList = [];
    this._longestInteractionMap = /* @__PURE__ */ new Map();
  }
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
  _resetInteractions() {
    prevInteractionCount = getInteractionCount();
    this._longestInteractionList.length = 0;
    this._longestInteractionMap.clear();
  }
  /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _estimateP98LongestInteraction() {
    const candidateInteractionIndex = Math.min(
      this._longestInteractionList.length - 1,
      Math.floor(getInteractionCountForNavigation() / 50)
    );
    return this._longestInteractionList[candidateInteractionIndex];
  }
  /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
  _processEntry(entry) {
    this._onBeforeProcessingEntry?.(entry);
    if (!(entry.interactionId || entry.entryType === "first-input")) return;
    const minLongestInteraction = this._longestInteractionList.at(-1);
    let interaction = this._longestInteractionMap.get(entry.interactionId);
    if (interaction || this._longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
    entry.duration > minLongestInteraction._latency) {
      if (interaction) {
        if (entry.duration > interaction._latency) {
          interaction.entries = [entry];
          interaction._latency = entry.duration;
        } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) {
          interaction.entries.push(entry);
        }
      } else {
        interaction = {
          id: entry.interactionId,
          entries: [entry],
          _latency: entry.duration
        };
        this._longestInteractionMap.set(interaction.id, interaction);
        this._longestInteractionList.push(interaction);
      }
      this._longestInteractionList.sort((a, b) => b._latency - a._latency);
      if (this._longestInteractionList.length > MAX_INTERACTIONS_TO_CONSIDER) {
        const removedInteractions = this._longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER);
        for (const interaction2 of removedInteractions) {
          this._longestInteractionMap.delete(interaction2.id);
        }
      }
      this._onAfterProcessingINPCandidate?.(interaction);
    }
  }
}


// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/whenIdleOrHidden.js
var whenIdleOrHidden = __webpack_require__(32664);
;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/getINP.js









const INPThresholds = [200, 500];
const DEFAULT_DURATION_THRESHOLD = 40;
const onINP = (onReport, opts = {}) => {
  if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) {
    return;
  }
  const visibilityWatcher = (0,getVisibilityWatcher/* getVisibilityWatcher */.N)();
  whenActivated(() => {
    initInteractionCountPolyfill();
    const metric = initMetric("INP");
    let report;
    const interactionManager = initUnique(opts, InteractionManager);
    const handleEntries = (entries) => {
      (0,whenIdleOrHidden/* whenIdleOrHidden */.k)(() => {
        for (const entry of entries) {
          interactionManager._processEntry(entry);
        }
        const inp = interactionManager._estimateP98LongestInteraction();
        if (inp && inp._latency !== metric.value) {
          metric.value = inp._latency;
          metric.entries = inp.entries;
          report();
        }
      });
    };
    const po = observe("event", handleEntries, {
      // Event Timing entries have their durations rounded to the nearest 8ms,
      // so a duration of 40ms would be any event that spans 2.5 or more frames
      // at 60Hz. This threshold is chosen to strike a balance between usefulness
      // and performance. Running this callback for any interaction that spans
      // just one or two frames is likely not worth the insight that could be
      // gained.
      durationThreshold: opts.durationThreshold ?? DEFAULT_DURATION_THRESHOLD
    });
    report = bindReporter(onReport, metric, INPThresholds, opts.reportAllChanges);
    if (po) {
      po.observe({ type: "first-input", buffered: true });
      visibilityWatcher.onHidden(() => {
        handleEntries(po.takeRecords());
        report(true);
      });
    }
  });
};


// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/globalListeners.js
var globalListeners = __webpack_require__(93335);
;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/LCPEntryManager.js
class LCPEntryManager {
  // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
  _processEntry(entry) {
    this._onBeforeProcessingEntry?.(entry);
  }
}


;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/getLCP.js











const LCPThresholds = [2500, 4e3];
const onLCP = (onReport, opts = {}) => {
  whenActivated(() => {
    const visibilityWatcher = (0,getVisibilityWatcher/* getVisibilityWatcher */.N)();
    const metric = initMetric("LCP");
    let report;
    const lcpEntryManager = initUnique(opts, LCPEntryManager);
    const handleEntries = (entries) => {
      if (!opts.reportAllChanges) {
        entries = entries.slice(-1);
      }
      for (const entry of entries) {
        lcpEntryManager._processEntry(entry);
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
          metric.value = Math.max(entry.startTime - (0,getActivationStart/* getActivationStart */.b)(), 0);
          metric.entries = [entry];
          report();
        }
      }
    };
    const po = observe("largest-contentful-paint", handleEntries);
    if (po) {
      report = bindReporter(onReport, metric, LCPThresholds, opts.reportAllChanges);
      const stopListening = (0,runOnce/* runOnce */.J)(() => {
        handleEntries(po.takeRecords());
        po.disconnect();
        report(true);
      });
      const stopListeningWrapper = (event) => {
        if (event.isTrusted) {
          (0,whenIdleOrHidden/* whenIdleOrHidden */.k)(stopListening);
          (0,globalListeners/* removePageListener */.Q)(event.type, stopListeningWrapper, {
            capture: true
          });
        }
      };
      for (const type of ["keydown", "click", "visibilitychange"]) {
        (0,globalListeners/* addPageListener */.d)(type, stopListeningWrapper, {
          capture: true
        });
      }
    }
  });
};


;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/onTTFB.js






const TTFBThresholds = [800, 1800];
const whenReady = (callback) => {
  if (types/* WINDOW */.j.document?.prerendering) {
    whenActivated(() => whenReady(callback));
  } else if (types/* WINDOW */.j.document?.readyState !== "complete") {
    addEventListener("load", () => whenReady(callback), true);
  } else {
    setTimeout(callback);
  }
};
const onTTFB = (onReport, opts = {}) => {
  const metric = initMetric("TTFB");
  const report = bindReporter(onReport, metric, TTFBThresholds, opts.reportAllChanges);
  whenReady(() => {
    const navigationEntry = (0,getNavigationEntry/* getNavigationEntry */.z)();
    if (navigationEntry) {
      metric.value = Math.max(navigationEntry.responseStart - (0,getActivationStart/* getActivationStart */.b)(), 0);
      metric.entries = [navigationEntry];
      report(true);
    }
  });
};


;// ./node_modules/@sentry/browser-utils/build/esm/metrics/instrument.js







const handlers = {};
const instrumented = {};
let _previousCls;
let _previousLcp;
let _previousTtfb;
let _previousInp;
function addClsInstrumentationHandler(callback, stopOnCallback = false) {
  return addMetricObserver("cls", callback, instrumentCls, _previousCls, stopOnCallback);
}
function addLcpInstrumentationHandler(callback, stopOnCallback = false) {
  return addMetricObserver("lcp", callback, instrumentLcp, _previousLcp, stopOnCallback);
}
function addTtfbInstrumentationHandler(callback) {
  return addMetricObserver("ttfb", callback, instrumentTtfb, _previousTtfb);
}
function addInpInstrumentationHandler(callback) {
  return addMetricObserver("inp", callback, instrumentInp, _previousInp);
}
function addPerformanceInstrumentationHandler(type, callback) {
  addHandler(type, callback);
  if (!instrumented[type]) {
    instrumentPerformanceObserver(type);
    instrumented[type] = true;
  }
  return getCleanupCallback(type, callback);
}
function triggerHandlers(type, data) {
  const typeHandlers = handlers[type];
  if (!typeHandlers?.length) {
    return;
  }
  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.error(
        `Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0,stacktrace/* getFunctionName */.qQ)(handler)}
Error:`,
        e
      );
    }
  }
}
function instrumentCls() {
  return onCLS(
    (metric) => {
      triggerHandlers("cls", {
        metric
      });
      _previousCls = metric;
    },
    // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: true }
  );
}
function instrumentLcp() {
  return onLCP(
    (metric) => {
      triggerHandlers("lcp", {
        metric
      });
      _previousLcp = metric;
    },
    // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    { reportAllChanges: true }
  );
}
function instrumentTtfb() {
  return onTTFB((metric) => {
    triggerHandlers("ttfb", {
      metric
    });
    _previousTtfb = metric;
  });
}
function instrumentInp() {
  return onINP((metric) => {
    triggerHandlers("inp", {
      metric
    });
    _previousInp = metric;
  });
}
function addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
  addHandler(type, callback);
  let stopListening;
  if (!instrumented[type]) {
    stopListening = instrumentFn();
    instrumented[type] = true;
  }
  if (previousValue) {
    callback({ metric: previousValue });
  }
  return getCleanupCallback(type, callback, stopOnCallback ? stopListening : void 0);
}
function instrumentPerformanceObserver(type) {
  const options = {};
  if (type === "event") {
    options.durationThreshold = 0;
  }
  observe(
    type,
    (entries) => {
      triggerHandlers(type, { entries });
    },
    options
  );
}
function addHandler(type, handler) {
  handlers[type] = handlers[type] || [];
  handlers[type].push(handler);
}
function getCleanupCallback(type, callback, stopListening) {
  return () => {
    if (stopListening) {
      stopListening();
    }
    const typeHandlers = handlers[type];
    if (!typeHandlers) {
      return;
    }
    const index = typeHandlers.indexOf(callback);
    if (index !== -1) {
      typeHandlers.splice(index, 1);
    }
  };
}
function isPerformanceEventTiming(entry) {
  return "duration" in entry;
}



/***/ }),

/***/ 30075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CE: function() { return /* binding */ isValidLcpMetric; },
/* harmony export */   Qv: function() { return /* binding */ trackLcpAsStandaloneSpan; }
/* harmony export */ });
/* unused harmony exports MAX_PLAUSIBLE_LCP_DURATION, _sendStandaloneLcpSpan */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91302);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79255);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62183);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39612);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60096);
/* harmony import */ var _htmlTreeAsString_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89972);
/* harmony import */ var _instrument_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33731);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66116);





const MAX_PLAUSIBLE_LCP_DURATION = 6e4;
function isValidLcpMetric(lcpValue) {
  return lcpValue != null && lcpValue > 0 && lcpValue <= MAX_PLAUSIBLE_LCP_DURATION;
}
function trackLcpAsStandaloneSpan(client) {
  let standaloneLcpValue = 0;
  let standaloneLcpEntry;
  if (!(0,_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .supportsWebVital */ .Jy)("largest-contentful-paint")) {
    return;
  }
  const cleanupLcpHandler = (0,_instrument_js__WEBPACK_IMPORTED_MODULE_6__/* .addLcpInstrumentationHandler */ .Pt)(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry || !isValidLcpMetric(metric.value)) {
      return;
    }
    standaloneLcpValue = metric.value;
    standaloneLcpEntry = entry;
  }, true);
  (0,_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .listenForWebVitalReportEvents */ .WF)(client, (reportEvent, pageloadSpanId) => {
    _sendStandaloneLcpSpan(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
    cleanupLcpHandler();
  });
}
function _sendStandaloneLcpSpan(lcpValue, entry, pageloadSpanId, reportEvent) {
  if (!isValidLcpMetric(lcpValue)) {
    return;
  }
  _debug_build_js__WEBPACK_IMPORTED_MODULE_4__/* .DEBUG_BUILD */ .T && _sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.log(`Sending LCP span (${lcpValue})`);
  const startTime = (0,_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .msToSec */ .rv)(((0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .browserPerformanceTimeOrigin */ .k3)() || 0) + (entry?.startTime || 0));
  const routeName = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentScope */ .o5)().getScopeData().transactionName;
  const name = entry ? (0,_htmlTreeAsString_js__WEBPACK_IMPORTED_MODULE_5__/* .htmlTreeAsString */ .H)(entry.element) : "Largest contentful paint";
  const attributes = {
    [_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .JD]: "auto.http.browser.lcp",
    [_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .uT]: "ui.webvital.lcp",
    [_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME */ .jG]: 0,
    // LCP is a point-in-time metric
    // attach the pageload span id to the LCP span so that we can link them in the UI
    "sentry.pageload.span_id": pageloadSpanId,
    // describes what triggered the web vital to be reported
    "sentry.report_event": reportEvent
  };
  if (entry) {
    entry.element && (attributes["lcp.element"] = (0,_htmlTreeAsString_js__WEBPACK_IMPORTED_MODULE_5__/* .htmlTreeAsString */ .H)(entry.element));
    entry.id && (attributes["lcp.id"] = entry.id);
    entry.url && (attributes["lcp.url"] = entry.url);
    entry.loadTime != null && (attributes["lcp.loadTime"] = entry.loadTime);
    entry.renderTime != null && (attributes["lcp.renderTime"] = entry.renderTime);
    entry.size != null && (attributes["lcp.size"] = entry.size);
  }
  const span = (0,_utils_js__WEBPACK_IMPORTED_MODULE_7__/* .startStandaloneWebVitalSpan */ .kD)({
    name,
    transaction: routeName,
    attributes,
    startTime
  });
  if (span) {
    span.addEvent("lcp", {
      [_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT */ .Sn]: "millisecond",
      [_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE */ .xc]: lcpValue
    });
    span.end(startTime);
  }
}



/***/ }),

/***/ 78280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   v: function() { return /* binding */ resourceTimingToSpanAttributes; }
/* harmony export */ });
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39612);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66116);


function getAbsoluteTime(time) {
  return time ? (((0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .browserPerformanceTimeOrigin */ .k3)() || performance.timeOrigin) + time) / 1e3 : time;
}
function resourceTimingToSpanAttributes(resourceTiming) {
  const timingSpanData = {};
  if (resourceTiming.nextHopProtocol != void 0) {
    const { name, version } = (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .extractNetworkProtocol */ .Ep)(resourceTiming.nextHopProtocol);
    timingSpanData["network.protocol.version"] = version;
    timingSpanData["network.protocol.name"] = name;
  }
  if (!((0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .browserPerformanceTimeOrigin */ .k3)() || (0,_utils_js__WEBPACK_IMPORTED_MODULE_1__/* .getBrowserPerformanceAPI */ .D)()?.timeOrigin)) {
    return timingSpanData;
  }
  return dropUndefinedKeysFromObject({
    ...timingSpanData,
    "http.request.redirect_start": getAbsoluteTime(resourceTiming.redirectStart),
    "http.request.redirect_end": getAbsoluteTime(resourceTiming.redirectEnd),
    "http.request.worker_start": getAbsoluteTime(resourceTiming.workerStart),
    "http.request.fetch_start": getAbsoluteTime(resourceTiming.fetchStart),
    "http.request.domain_lookup_start": getAbsoluteTime(resourceTiming.domainLookupStart),
    "http.request.domain_lookup_end": getAbsoluteTime(resourceTiming.domainLookupEnd),
    "http.request.connect_start": getAbsoluteTime(resourceTiming.connectStart),
    "http.request.secure_connection_start": getAbsoluteTime(resourceTiming.secureConnectionStart),
    "http.request.connection_end": getAbsoluteTime(resourceTiming.connectEnd),
    "http.request.request_start": getAbsoluteTime(resourceTiming.requestStart),
    "http.request.response_start": getAbsoluteTime(resourceTiming.responseStart),
    "http.request.response_end": getAbsoluteTime(resourceTiming.responseEnd),
    // For TTFB we actually want the relative time from timeOrigin to responseStart
    // This way, TTFB always measures the "first page load" experience.
    // see: https://web.dev/articles/ttfb#measure-resource-requests
    "http.request.time_to_first_byte": resourceTiming.responseStart != null ? resourceTiming.responseStart / 1e3 : void 0
  });
}
function dropUndefinedKeysFromObject(attrs) {
  return Object.fromEntries(Object.entries(attrs).filter(([, value]) => value != null));
}



/***/ }),

/***/ 66116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Ep: function() { return /* binding */ extractNetworkProtocol; },
  D: function() { return /* binding */ getBrowserPerformanceAPI; },
  Kk: function() { return /* binding */ isMeasurementValue; },
  WF: function() { return /* binding */ listenForWebVitalReportEvents; },
  rv: function() { return /* binding */ msToSec; },
  Tn: function() { return /* binding */ startAndEndSpan; },
  kD: function() { return /* binding */ startStandaloneWebVitalSpan; },
  Jy: function() { return /* binding */ supportsWebVital; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(42896);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/trace.js + 1 modules
var trace = __webpack_require__(1523);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/types.js
var types = __webpack_require__(84335);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/globalListeners.js
var globalListeners = __webpack_require__(93335);
;// ./node_modules/@sentry/browser-utils/build/esm/metrics/web-vitals/lib/onHidden.js


const onHidden = (cb) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === "pagehide" || types/* WINDOW */.j.document?.visibilityState === "hidden") {
      cb(event);
    }
  };
  (0,globalListeners/* addPageListener */.d)("visibilitychange", onHiddenOrPageHide, { capture: true, once: true });
  (0,globalListeners/* addPageListener */.d)("pagehide", onHiddenOrPageHide, { capture: true, once: true });
};


;// ./node_modules/@sentry/browser-utils/build/esm/metrics/utils.js



function isMeasurementValue(value) {
  return typeof value === "number" && isFinite(value);
}
function startAndEndSpan(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
  const parentStartTime = (0,spanUtils/* spanToJSON */.et)(parentSpan).start_timestamp;
  if (parentStartTime && parentStartTime > startTimeInSeconds) {
    if (typeof parentSpan.updateStartTime === "function") {
      parentSpan.updateStartTime(startTimeInSeconds);
    }
  }
  return (0,trace/* withActiveSpan */.hb)(parentSpan, () => {
    const span = (0,trace/* startInactiveSpan */.Uk)({
      startTime: startTimeInSeconds,
      ...ctx
    });
    if (span) {
      span.end(endTime);
    }
    return span;
  });
}
function startStandaloneWebVitalSpan(options) {
  const client = (0,currentScopes/* getClient */.KU)();
  if (!client) {
    return;
  }
  const { name, transaction, attributes: passedAttributes, startTime } = options;
  const { release, environment } = client.getOptions();
  const { userInfo } = client.getDataCollectionOptions();
  const replay = client.getIntegrationByName("Replay");
  const replayId = replay?.getReplayId();
  const scope = (0,currentScopes/* getCurrentScope */.o5)();
  const user = scope.getUser();
  const userDisplay = user !== void 0 ? user.email || user.id || user.ip_address : void 0;
  let profileId;
  try {
    profileId = scope.getScopeData().contexts.profile.profile_id;
  } catch {
  }
  const attributes = {
    release,
    environment,
    user: userDisplay || void 0,
    profile_id: profileId || void 0,
    replay_id: replayId || void 0,
    transaction,
    // Web vital score calculation relies on the user agent to account for different
    // browsers setting different thresholds for what is considered a good/meh/bad value.
    // For example: Chrome vs. Chrome Mobile
    "user_agent.original": types/* WINDOW */.j.navigator?.userAgent,
    // This tells Sentry to infer the IP address from the request
    "client.address": userInfo ? "{{auto}}" : void 0,
    ...passedAttributes
  };
  return (0,trace/* startInactiveSpan */.Uk)({
    name,
    attributes,
    startTime,
    experimental: {
      standalone: true
    }
  });
}
function getBrowserPerformanceAPI() {
  return types/* WINDOW */.j.addEventListener && types/* WINDOW */.j.performance;
}
function msToSec(time) {
  return time / 1e3;
}
function extractNetworkProtocol(nextHopProtocol) {
  let name = "unknown";
  let version = "unknown";
  let _name = "";
  for (const char of nextHopProtocol) {
    if (char === "/") {
      [name, version] = nextHopProtocol.split("/");
      break;
    }
    if (!isNaN(Number(char))) {
      name = _name === "h" ? "http" : _name;
      version = nextHopProtocol.split(_name)[1];
      break;
    }
    _name += char;
  }
  if (_name === nextHopProtocol) {
    name = _name;
  }
  return { name, version };
}
function supportsWebVital(entryType) {
  try {
    return PerformanceObserver.supportedEntryTypes.includes(entryType);
  } catch {
    return false;
  }
}
function listenForWebVitalReportEvents(client, collectorCallback) {
  let pageloadSpan;
  let collected = false;
  function _runCollectorCallbackOnce(event) {
    if (!collected && pageloadSpan) {
      collectorCallback(event, pageloadSpan.spanContext().spanId, pageloadSpan);
    }
    collected = true;
  }
  onHidden(() => {
    _runCollectorCallbackOnce("pagehide");
  });
  const unsubscribeStartNavigation = client.on("beforeStartNavigationSpan", (_, options) => {
    if (!options?.isRedirect) {
      _runCollectorCallbackOnce("navigation");
      unsubscribeStartNavigation();
      unsubscribeAfterStartPageLoadSpan();
    }
  });
  const unsubscribeAfterStartPageLoadSpan = client.on("afterStartPageLoadSpan", (span) => {
    pageloadSpan = span;
    unsubscribeAfterStartPageLoadSpan();
  });
}



/***/ }),

/***/ 83387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _getNavigationEntry_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70277);

const getActivationStart = () => {
  const navEntry = (0,_getNavigationEntry_js__WEBPACK_IMPORTED_MODULE_0__/* .getNavigationEntry */ .z)();
  return navEntry?.activationStart ?? 0;
};


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "b", 0, /* binding */ getActivationStart
/* harmony export */ ]);


/***/ }),

/***/ 70277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84335);

const getNavigationEntry = (checkResponseStart = true) => {
  const navigationEntry = _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.performance?.getEntriesByType?.("navigation")[0];
  if (
    // sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()
  ) {
    return navigationEntry;
  }
};


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "z", 0, /* binding */ getNavigationEntry
/* harmony export */ ]);


/***/ }),

/***/ 25499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84335);
/* harmony import */ var _getActivationStart_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83387);
/* harmony import */ var _globalListeners_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93335);



let firstHiddenTime = -1;
const onHiddenFunctions = /* @__PURE__ */ new Set();
const initHiddenTime = () => {
  return _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.document?.visibilityState === "hidden" && !_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.document?.prerendering ? 0 : Infinity;
};
const onVisibilityUpdate = (event) => {
  if (isPageHidden(event) && firstHiddenTime > -1) {
    if (event.type === "visibilitychange" || event.type === "pagehide") {
      for (const onHiddenFunction of onHiddenFunctions) {
        onHiddenFunction();
      }
    }
    if (!isFinite(firstHiddenTime)) {
      firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
      (0,_globalListeners_js__WEBPACK_IMPORTED_MODULE_2__/* .removePageListener */ .Q)("prerenderingchange", onVisibilityUpdate, true);
    }
  }
};
const getVisibilityWatcher = () => {
  if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.document && firstHiddenTime < 0) {
    const activationStart = (0,_getActivationStart_js__WEBPACK_IMPORTED_MODULE_1__/* .getActivationStart */ .b)();
    const firstVisibilityStateHiddenTime = !_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.document.prerendering ? globalThis.performance.getEntriesByType("visibility-state").filter((e) => e.name === "hidden" && e.startTime > activationStart)[0]?.startTime : void 0;
    firstHiddenTime = firstVisibilityStateHiddenTime ?? initHiddenTime();
    (0,_globalListeners_js__WEBPACK_IMPORTED_MODULE_2__/* .addPageListener */ .d)("visibilitychange", onVisibilityUpdate, true);
    (0,_globalListeners_js__WEBPACK_IMPORTED_MODULE_2__/* .addPageListener */ .d)("pagehide", onVisibilityUpdate, true);
    (0,_globalListeners_js__WEBPACK_IMPORTED_MODULE_2__/* .addPageListener */ .d)("prerenderingchange", onVisibilityUpdate, true);
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
    onHidden(cb) {
      onHiddenFunctions.add(cb);
    }
  };
};
function isPageHidden(event) {
  return event.type === "pagehide" || _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.document?.visibilityState === "hidden";
}


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "N", 0, /* binding */ getVisibilityWatcher
/* harmony export */ ]);


/***/ }),

/***/ 93335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Q: function() { return /* binding */ removePageListener; },
/* harmony export */   d: function() { return /* binding */ addPageListener; }
/* harmony export */ });
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84335);

function addPageListener(type, listener, options) {
  if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.document) {
    _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.addEventListener(type, listener, options);
  }
}
function removePageListener(type, listener, options) {
  if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.document) {
    _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.removeEventListener(type, listener, options);
  }
}



/***/ }),

/***/ 4767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
const runOnce = (cb) => {
  let called = false;
  return () => {
    if (!called) {
      cb();
      called = true;
    }
  };
};


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "J", 0, /* binding */ runOnce
/* harmony export */ ]);


/***/ }),

/***/ 32664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _types_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(84335);
/* harmony import */ var _globalListeners_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93335);
/* harmony import */ var _runOnce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4767);



const whenIdleOrHidden = (cb) => {
  const rIC = _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.requestIdleCallback || _types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.setTimeout;
  if (_types_js__WEBPACK_IMPORTED_MODULE_0__/* .WINDOW */ .j.document?.visibilityState === "hidden") {
    cb();
  } else {
    cb = (0,_runOnce_js__WEBPACK_IMPORTED_MODULE_2__/* .runOnce */ .J)(cb);
    (0,_globalListeners_js__WEBPACK_IMPORTED_MODULE_1__/* .addPageListener */ .d)("visibilitychange", cb, { once: true, capture: true });
    (0,_globalListeners_js__WEBPACK_IMPORTED_MODULE_1__/* .addPageListener */ .d)("pagehide", cb, { once: true, capture: true });
    rIC(() => {
      cb();
      (0,_globalListeners_js__WEBPACK_IMPORTED_MODULE_1__/* .removePageListener */ .Q)("visibilitychange", cb, { capture: true });
      (0,_globalListeners_js__WEBPACK_IMPORTED_MODULE_1__/* .removePageListener */ .Q)("pagehide", cb, { capture: true });
    });
  }
};


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "k", 0, /* binding */ whenIdleOrHidden
/* harmony export */ ]);


/***/ }),

/***/ 99323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Gv: function() { return /* binding */ getFetchRequestArgBody; },
/* harmony export */   P4: function() { return /* binding */ serializeFormData; },
/* harmony export */   sY: function() { return /* binding */ getBodyString; },
/* harmony export */   ti: function() { return /* binding */ parseXhrResponseHeaders; }
/* harmony export */ });
/* unused harmony export ORIGINAL_REQ_BODY */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62183);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60096);


const ORIGINAL_REQ_BODY = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
function serializeFormData(formData) {
  return new URLSearchParams(formData).toString();
}
function getBodyString(body, _debug = _sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .debug */ .Yz) {
  try {
    if (typeof body === "string") {
      return [body];
    }
    if (body instanceof URLSearchParams) {
      return [body.toString()];
    }
    if (body instanceof FormData) {
      return [serializeFormData(body)];
    }
    if (!body) {
      return [void 0];
    }
  } catch (error) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T && _debug.error(error, "Failed to serialize body", body);
    return [void 0, "BODY_PARSE_ERROR"];
  }
  _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T && _debug.log("Skipping network body because of body type", body);
  return [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function getFetchRequestArgBody(fetchArgs = []) {
  if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === "object" && "body" in fetchArgs[1]) {
    return fetchArgs[1].body;
  }
  if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
    const request = fetchArgs[0];
    const originalBody = request[ORIGINAL_REQ_BODY];
    if (originalBody !== void 0) {
      return originalBody;
    }
    return void 0;
  }
  return void 0;
}
function parseXhrResponseHeaders(xhr) {
  let headers;
  try {
    headers = xhr.getAllResponseHeaders();
  } catch (error) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T && _sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .debug */ .Yz.error(error, "Failed to get xhr response headers", xhr);
    return {};
  }
  if (!headers) {
    return {};
  }
  return headers.split("\r\n").reduce((acc, line) => {
    const [key, value] = line.split(": ");
    if (value) {
      acc[key.toLowerCase()] = value;
    }
    return acc;
  }, {});
}



/***/ }),

/***/ 84335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70774);

const WINDOW = _sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .O;


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "j", 0, /* binding */ WINDOW
/* harmony export */ ]);


/***/ }),

/***/ 18369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  y: function() { return /* binding */ BrowserClient; }
});

// UNUSED EXPORTS: applyDefaultOptions

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/api.js
var api = __webpack_require__(31007);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/constants.js
var constants = __webpack_require__(9358);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/debug-build.js
var debug_build = __webpack_require__(97169);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/envelope.js
var envelope = __webpack_require__(81507);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/integration.js
var esm_integration = __webpack_require__(94893);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/logs/internal.js + 2 modules
var internal = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/metrics/internal.js + 1 modules
var metrics_internal = __webpack_require__(32977);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/session.js
var esm_session = __webpack_require__(53835);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/dynamicSamplingContext.js
var tracing_dynamicSamplingContext = __webpack_require__(49271);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/spans/beforeSendSpan.js
var spans_beforeSendSpan = __webpack_require__(62635);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/isBrowser.js
var isBrowser = __webpack_require__(82257);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/spans/hasSpanStreamingEnabled.js
var hasSpanStreamingEnabled = __webpack_require__(97989);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(42896);
;// ./node_modules/@sentry/core/build/esm/tracing/spans/spanJsonToStreamedSpan.js

function spanJsonToSerializedStreamedSpan(span) {
  const streamedSpan = {
    trace_id: span.trace_id,
    span_id: span.span_id,
    parent_span_id: span.parent_span_id,
    name: span.description || "",
    start_timestamp: span.start_timestamp,
    end_timestamp: span.timestamp || span.start_timestamp,
    status: !span.status || span.status === "ok" || span.status === "cancelled" ? "ok" : "error",
    is_segment: false,
    attributes: { ...span.data },
    links: span.links
  };
  return (0,spanUtils/* streamedSpanJsonToSerializedSpan */.PL)(streamedSpan);
}


;// ./node_modules/@sentry/core/build/esm/tracing/spans/extractGenAiSpans.js



function extractGenAiSpansFromEvent(event, client) {
  if (event.type !== "transaction" || !event.spans?.length || !event.sdkProcessingMetadata?.hasGenAiSpans || client.getOptions().streamGenAiSpans === false || (0,hasSpanStreamingEnabled/* hasSpanStreamingEnabled */.K)(client)) {
    return void 0;
  }
  const genAiSpans = [];
  const remainingSpans = [];
  for (const span of event.spans) {
    if (span.op?.startsWith("gen_ai.")) {
      genAiSpans.push(spanJsonToSerializedStreamedSpan(span));
    } else {
      remainingSpans.push(span);
    }
  }
  if (genAiSpans.length === 0) {
    return void 0;
  }
  event.spans = remainingSpans;
  const inferSetting = client.getDataCollectionOptions().userInfo ? "auto" : "never";
  return [
    { type: "span", item_count: genAiSpans.length, content_type: "application/vnd.sentry.items.span.v2+json" },
    {
      version: 2,
      ...(0,isBrowser/* isBrowser */.B)() && {
        ingest_settings: { infer_ip: inferSetting, infer_user_agent: inferSetting }
      },
      items: genAiSpans
    }
  ];
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/envelope.js
var utils_envelope = __webpack_require__(22265);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/time.js
var time = __webpack_require__(39612);
;// ./node_modules/@sentry/core/build/esm/utils/clientreport.js


function createClientReportEnvelope(discarded_events, dsn, timestamp) {
  const clientReportItem = [
    { type: "client_report" },
    {
      timestamp: timestamp || (0,time/* dateTimestampInSeconds */.lu)(),
      discarded_events
    }
  ];
  return (0,utils_envelope/* createEnvelope */.h4)(dsn ? { dsn } : {}, [clientReportItem]);
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-logger.js
var debug_logger = __webpack_require__(62183);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/dsn.js
var dsn = __webpack_require__(56648);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/eventUtils.js
var eventUtils = __webpack_require__(20516);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/is.js
var is = __webpack_require__(91973);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/merge.js
var merge = __webpack_require__(69201);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/misc.js
var misc = __webpack_require__(16513);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/parseSampleRate.js
var parseSampleRate = __webpack_require__(91554);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/prepareEvent.js + 1 modules
var prepareEvent = __webpack_require__(8665);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/promisebuffer.js
var promisebuffer = __webpack_require__(50198);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/randomSafeContext.js
var randomSafeContext = __webpack_require__(23324);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/should-ignore-span.js
var should_ignore_span = __webpack_require__(90622);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/syncpromise.js
var syncpromise = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/timer.js
var timer = __webpack_require__(35084);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91302);
;// ./node_modules/@sentry/core/build/esm/utils/transactionEvent.js

function convertTransactionEventToSpanJson(event) {
  const { trace_id, parent_span_id, span_id, status, origin, data, op } = event.contexts?.trace ?? {};
  return {
    data: data ?? {},
    description: event.transaction,
    op,
    parent_span_id,
    span_id: span_id ?? "",
    start_timestamp: event.start_timestamp ?? 0,
    status,
    timestamp: event.timestamp,
    trace_id: trace_id ?? "",
    origin,
    profile_id: data?.[semanticAttributes/* SEMANTIC_ATTRIBUTE_PROFILE_ID */.E1],
    exclusive_time: data?.[semanticAttributes/* SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME */.jG],
    measurements: event.measurements,
    is_segment: true
  };
}
function convertSpanJsonToTransactionEvent(span) {
  return {
    type: "transaction",
    timestamp: span.timestamp,
    start_timestamp: span.start_timestamp,
    transaction: span.description,
    contexts: {
      trace: {
        trace_id: span.trace_id,
        span_id: span.span_id,
        parent_span_id: span.parent_span_id,
        op: span.op,
        status: span.status,
        origin: span.origin,
        data: {
          ...span.data,
          ...span.profile_id && { [semanticAttributes/* SEMANTIC_ATTRIBUTE_PROFILE_ID */.E1]: span.profile_id },
          ...span.exclusive_time && { [semanticAttributes/* SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME */.jG]: span.exclusive_time }
        }
      }
    },
    measurements: span.measurements
  };
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/data-collection/filtering-snippets.js
var filtering_snippets = __webpack_require__(73182);
;// ./node_modules/@sentry/core/build/esm/utils/data-collection/defaultPiiToCollectionOptions.js

function defaultPiiToCollectionOptions(sendDefaultPii) {
  return sendDefaultPii === true ? {
    userInfo: true,
    cookies: true,
    httpHeaders: { request: true, response: true },
    httpBodies: ["incomingRequest", "outgoingRequest", "incomingResponse", "outgoingResponse"],
    queryParams: true,
    genAI: { inputs: true, outputs: true },
    stackFrameVariables: true,
    frameContextLines: 7
    // default should be 5, but ContextLines integration uses 7
  } : {
    userInfo: false,
    cookies: { deny: filtering_snippets/* PII_HEADER_SNIPPETS */.UA },
    httpHeaders: { request: { deny: filtering_snippets/* PII_HEADER_SNIPPETS */.UA }, response: { deny: filtering_snippets/* PII_HEADER_SNIPPETS */.UA } },
    httpBodies: [],
    queryParams: { deny: filtering_snippets/* PII_HEADER_SNIPPETS */.UA },
    genAI: { inputs: false, outputs: false },
    stackFrameVariables: true,
    frameContextLines: 7
    // default should be 5, but ContextLines integration uses 7
  };
}


;// ./node_modules/@sentry/core/build/esm/utils/data-collection/resolveDataCollectionOptions.js

const DEFAULTS = {
  userInfo: true,
  cookies: true,
  httpHeaders: { request: true, response: true },
  httpBodies: ["incomingRequest", "outgoingRequest", "incomingResponse", "outgoingResponse"],
  queryParams: true,
  genAI: { inputs: true, outputs: true },
  stackFrameVariables: true,
  frameContextLines: 5
};
function resolveDataCollectionOptions(options) {
  const base = options.dataCollection != null ? DEFAULTS : defaultPiiToCollectionOptions(options.sendDefaultPii);
  const dc = options.dataCollection ?? {};
  return {
    userInfo: dc.userInfo ?? base.userInfo,
    cookies: dc.cookies ?? base.cookies,
    httpHeaders: {
      request: dc.httpHeaders?.request ?? base.httpHeaders.request,
      response: dc.httpHeaders?.response ?? base.httpHeaders.response
    },
    httpBodies: dc.httpBodies ?? base.httpBodies,
    queryParams: dc.queryParams ?? base.queryParams,
    genAI: {
      inputs: dc.genAI?.inputs ?? base.genAI.inputs,
      outputs: dc.genAI?.outputs ?? base.genAI.outputs
    },
    stackFrameVariables: dc.stackFrameVariables ?? base.stackFrameVariables,
    frameContextLines: dc.frameContextLines ?? base.frameContextLines
  };
}


;// ./node_modules/@sentry/core/build/esm/client.js































const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const MISSING_RELEASE_FOR_SESSION_ERROR = "Discarded session because of missing or non-string release";
const INTERNAL_ERROR_SYMBOL = /* @__PURE__ */ Symbol.for("SentryInternalError");
const DO_NOT_SEND_EVENT_SYMBOL = /* @__PURE__ */ Symbol.for("SentryDoNotSendEventError");
const DEFAULT_FLUSH_INTERVAL = 5e3;
function _makeInternalError(message) {
  return {
    message,
    [INTERNAL_ERROR_SYMBOL]: true
  };
}
function _makeDoNotSendEventError(message) {
  return {
    message,
    [DO_NOT_SEND_EVENT_SYMBOL]: true
  };
}
function _isInternalError(error) {
  return !!error && typeof error === "object" && INTERNAL_ERROR_SYMBOL in error;
}
function _isDoNotSendEventError(error) {
  return !!error && typeof error === "object" && DO_NOT_SEND_EVENT_SYMBOL in error;
}
function setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
  let weight = 0;
  let flushTimeout;
  let isTimerActive = false;
  client.on(flushHook, () => {
    weight = 0;
    clearTimeout(flushTimeout);
    isTimerActive = false;
  });
  client.on(afterCaptureHook, (item) => {
    weight += estimateSizeFn(item);
    if (weight >= 8e5) {
      flushFn(client);
    } else if (!isTimerActive) {
      const flushInterval = client.getOptions()._flushInterval ?? DEFAULT_FLUSH_INTERVAL;
      if (flushInterval > 0) {
        isTimerActive = true;
        flushTimeout = (0,timer/* safeUnref */.G)(
          setTimeout(() => {
            flushFn(client);
          }, flushInterval)
        );
      }
    }
  });
  client.on("flush", () => {
    flushFn(client);
  });
}
class Client {
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(options) {
    this._options = options;
    this._integrations = {};
    this._numProcessing = 0;
    this._outcomes = {};
    this._hooks = {};
    this._eventProcessors = [];
    this._promiseBuffer = (0,promisebuffer/* makePromiseBuffer */.C)(options.transportOptions?.bufferSize ?? (/* inlined export .DEFAULT_TRANSPORT_BUFFER_SIZE */64));
    this._dataCollection = resolveDataCollectionOptions(options);
    if (options.dsn) {
      this._dsn = (0,dsn/* makeDsn */.AD)(options.dsn);
    } else {
      debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn("No DSN provided, client will not send events.");
    }
    if (this._dsn) {
      const url = (0,api/* getEnvelopeEndpointWithUrlEncodedAuth */.Z8)(
        this._dsn,
        options.tunnel,
        options._metadata ? options._metadata.sdk : void 0
      );
      this._transport = options.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url
      });
    }
    this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
    if (this._options.enableLogs) {
      setupWeightBasedFlushing(this, "afterCaptureLog", "flushLogs", estimateLogSizeInBytes, internal/* _INTERNAL_flushLogsBuffer */.lt);
    }
    const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
    if (enableMetrics) {
      setupWeightBasedFlushing(
        this,
        "afterCaptureMetric",
        "flushMetrics",
        estimateMetricSizeInBytes,
        metrics_internal/* _INTERNAL_flushMetricsBuffer */.NG
      );
    }
  }
  /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureException(exception, hint, scope) {
    const eventId = (0,misc/* uuid4 */.eJ)();
    if ((0,misc/* checkOrSetAlreadyCaught */.GR)(exception)) {
      debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log(ALREADY_SEEN_ERROR);
      return eventId;
    }
    const hintWithEventId = {
      event_id: eventId,
      ...hint
    };
    this._process(
      () => this.eventFromException(exception, hintWithEventId).then((event) => this._captureEvent(event, hintWithEventId, scope)).then((res) => res),
      "error"
    );
    return hintWithEventId.event_id;
  }
  /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureMessage(message, level, hint, currentScope) {
    const hintWithEventId = {
      event_id: (0,misc/* uuid4 */.eJ)(),
      ...hint
    };
    const eventMessage = (0,is/* isParameterizedString */.NF)(message) ? message : String(message);
    const isMessage = (0,is/* isPrimitive */.sO)(message);
    const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
    this._process(
      () => promisedEvent.then((event) => this._captureEvent(event, hintWithEventId, currentScope)),
      isMessage ? "unknown" : "error"
    );
    return hintWithEventId.event_id;
  }
  /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */
  captureEvent(event, hint, currentScope) {
    const eventId = (0,misc/* uuid4 */.eJ)();
    if (hint?.originalException && (0,misc/* checkOrSetAlreadyCaught */.GR)(hint.originalException)) {
      debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log(ALREADY_SEEN_ERROR);
      return eventId;
    }
    const hintWithEventId = {
      event_id: eventId,
      ...hint
    };
    const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
    const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
    const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
    const dataCategory = getDataCategoryByType(event.type);
    this._process(
      () => this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope),
      dataCategory
    );
    return hintWithEventId.event_id;
  }
  /**
   * Captures a session.
   */
  captureSession(session) {
    this.sendSession(session);
    (0,esm_session/* updateSession */.qO)(session, { init: false });
  }
  /**
   * Get the current Dsn.
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * Get the current options.
   */
  getOptions() {
    return this._options;
  }
  /**
   * Get the resolved data collection configuration.
   */
  getDataCollectionOptions() {
    return this._dataCollection;
  }
  /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */
  getTransport() {
    return this._transport;
  }
  /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */
  // @ts-expect-error - PromiseLike is a subset of Promise
  async flush(timeout) {
    const transport = this._transport;
    this.emit("flush");
    if (!transport) {
      return true;
    }
    const clientFinished = await this._isClientDoneProcessing(timeout);
    const transportFlushed = await transport.flush(timeout);
    return clientFinished && transportFlushed;
  }
  /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */
  // @ts-expect-error - PromiseLike is a subset of Promise
  async close(timeout) {
    (0,internal/* _INTERNAL_flushLogsBuffer */.lt)(this);
    const result = await this.flush(timeout);
    this.getOptions().enabled = false;
    this.emit("close");
    return result;
  }
  /**
   * Get all installed event processors.
   */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /**
   * Adds an event processor that applies to any event processed by this client.
   */
  addEventProcessor(eventProcessor) {
    this._eventProcessors.push(eventProcessor);
  }
  /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */
  init() {
    if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
    // Spotlight enabled. This is particularly important for browser as we
    // don't support the `spotlight` option there and rely on the users
    // adding the `spotlightBrowserIntegration()` to their integrations which
    // wouldn't get initialized with the check below when there's no DSN set.
    this._options.integrations.some(({ name }) => name.startsWith("Spotlight"))) {
      this._setupIntegrations();
    }
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(integrationName) {
    return this._integrations[integrationName];
  }
  /**
   * Returns the names of all installed integrations.
   */
  getIntegrationNames() {
    return Object.keys(this._integrations);
  }
  /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */
  addIntegration(integration) {
    const isAlreadyInstalled = this._integrations[integration.name];
    if (!isAlreadyInstalled && integration.beforeSetup) {
      integration.beforeSetup(this);
    }
    (0,esm_integration/* setupIntegration */.qm)(this, integration, this._integrations);
    if (!isAlreadyInstalled) {
      (0,esm_integration/* afterSetupIntegrations */.lc)(this, [integration]);
    }
  }
  /**
   * Send a fully prepared event to Sentry.
   */
  sendEvent(event, hint = {}) {
    this.emit("beforeSendEvent", event, hint);
    const genAiSpanItem = extractGenAiSpansFromEvent(event, this);
    let env = (0,envelope/* createEventEnvelope */.V7)(event, this._dsn, this._options._metadata, this._options.tunnel);
    for (const attachment of hint.attachments || []) {
      env = (0,utils_envelope/* addItemToEnvelope */.W3)(env, (0,utils_envelope/* createAttachmentEnvelopeItem */.bm)(attachment));
    }
    if (genAiSpanItem) {
      env = (0,utils_envelope/* addItemToEnvelope */.W3)(env, genAiSpanItem);
    }
    this.sendEnvelope(env).then((sendResponse) => this.emit("afterSendEvent", event, sendResponse));
  }
  /**
   * Send a session or session aggregrates to Sentry.
   */
  sendSession(session) {
    const { release: clientReleaseOption, environment: clientEnvironmentOption = constants/* DEFAULT_ENVIRONMENT */.U } = this._options;
    if ("aggregates" in session) {
      const sessionAttrs = session.attrs || {};
      if (!sessionAttrs.release && !clientReleaseOption) {
        debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn(MISSING_RELEASE_FOR_SESSION_ERROR);
        return;
      }
      sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
      sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
      session.attrs = sessionAttrs;
    } else {
      if (!session.release && !clientReleaseOption) {
        debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn(MISSING_RELEASE_FOR_SESSION_ERROR);
        return;
      }
      session.release = session.release || clientReleaseOption;
      session.environment = session.environment || clientEnvironmentOption;
    }
    this.emit("beforeSendSession", session);
    const env = (0,envelope/* createSessionEnvelope */.LE)(session, this._dsn, this._options._metadata, this._options.tunnel);
    this.sendEnvelope(env);
  }
  /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */
  recordDroppedEvent(reason, category, count = 1) {
    if (this._options.sendClientReports) {
      const key = `${reason}:${category}`;
      debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ""}`);
      this._outcomes[key] = (this._outcomes[key] || 0) + count;
    }
  }
  /**
   * Register a hook on this client.
   */
  on(hook, callback) {
    const hookCallbacks = this._hooks[hook] = this._hooks[hook] || /* @__PURE__ */ new Set();
    const uniqueCallback = (...args) => callback(...args);
    hookCallbacks.add(uniqueCallback);
    return () => {
      hookCallbacks.delete(uniqueCallback);
    };
  }
  /**
   * Emit a hook that was previously registered via `on()`.
   */
  emit(hook, ...rest) {
    const callbacks = this._hooks[hook];
    if (callbacks) {
      callbacks.forEach((callback) => callback(...rest));
    }
  }
  /**
   * Send an envelope to Sentry.
   */
  // @ts-expect-error - PromiseLike is a subset of Promise
  async sendEnvelope(envelope) {
    this.emit("beforeEnvelope", envelope);
    if (this._isEnabled() && this._transport) {
      try {
        return await this._transport.send(envelope);
      } catch (reason) {
        debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.error("Error while sending envelope:", reason);
        return {};
      }
    }
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.error("Transport disabled");
    return {};
  }
  /**
   * Register a cleanup function to be called when the client is disposed.
   * This is useful for integrations that need to clean up global state.
   *
   * NOTE: This is a no-op in the base `Client` class. Subclasses like `ServerRuntimeClient`
   * override this method to actually register and execute cleanup callbacks.
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  registerCleanup(callback) {
  }
  /**
   * Disposes of the client and releases all resources.
   *
   * Subclasses should override this method to clean up their own resources, including invoking
   * any callbacks registered via {@link Client.registerCleanup}. The base implementation is a
   * no-op and does NOT execute registered cleanup callbacks.
   *
   * After calling dispose(), the client should not be used anymore.
   */
  dispose() {
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations } = this._options;
    this._integrations = (0,esm_integration/* setupIntegrations */.P$)(this, integrations);
    (0,esm_integration/* afterSetupIntegrations */.lc)(this, integrations);
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(session, event) {
    let crashed = event.level === "fatal";
    let errored = false;
    const exceptions = event.exception?.values;
    if (exceptions) {
      errored = true;
      crashed = false;
      for (const ex of exceptions) {
        if (ex.mechanism?.handled === false) {
          crashed = true;
          break;
        }
      }
    }
    const sessionNonTerminal = session.status === "ok";
    const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.qO)(session, {
        ...crashed && { status: "crashed" },
        errors: session.errors || Number(errored || crashed)
      });
      this.captureSession(session);
    }
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  async _isClientDoneProcessing(timeout) {
    let ticked = 0;
    while (!timeout || ticked < timeout) {
      await new Promise((resolve) => setTimeout(resolve, 1));
      if (!this._numProcessing) {
        return true;
      }
      ticked++;
    }
    return false;
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== false && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(event, hint, currentScope, isolationScope) {
    const options = this.getOptions();
    const integrations = this.getIntegrationNames();
    if (!hint.integrations && integrations.length) {
      hint.integrations = integrations;
    }
    this.emit("preprocessEvent", event, hint);
    if (!event.type) {
      isolationScope.setLastEventId(event.event_id || hint.event_id);
    }
    return (0,prepareEvent/* prepareEvent */.mG)(options, event, hint, currentScope, this, isolationScope).then((evt) => {
      if (evt === null) {
        return evt;
      }
      this.emit("postprocessEvent", evt, hint);
      evt.contexts = {
        trace: { ...evt.contexts?.trace, ...(0,currentScopes/* getTraceContextFromScope */.vn)(currentScope) },
        ...evt.contexts
      };
      const dynamicSamplingContext = (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromScope */.ao)(this, currentScope);
      evt.sdkProcessingMetadata = {
        dynamicSamplingContext,
        ...evt.sdkProcessingMetadata
      };
      return evt;
    });
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(event, hint = {}, currentScope = (0,currentScopes/* getCurrentScope */.o5)(), isolationScope = (0,currentScopes/* getIsolationScope */.rm)()) {
    if (debug_build/* DEBUG_BUILD */.T && isErrorEvent(event)) {
      debug_logger/* debug */.Yz.log(`Captured error event \`${(0,eventUtils/* getPossibleEventMessages */.G)(event)[0] || "<unknown>"}\``);
    }
    return this._processEvent(event, hint, currentScope, isolationScope).then(
      (finalEvent) => {
        return finalEvent.event_id;
      },
      (reason) => {
        if (debug_build/* DEBUG_BUILD */.T) {
          if (_isDoNotSendEventError(reason)) {
            debug_logger/* debug */.Yz.log(reason.message);
          } else if (_isInternalError(reason)) {
            debug_logger/* debug */.Yz.warn(reason.message);
          } else {
            debug_logger/* debug */.Yz.warn(reason);
          }
        }
        return void 0;
      }
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(event, hint, currentScope, isolationScope) {
    const options = this.getOptions();
    const { sampleRate } = options;
    const isTransaction = isTransactionEvent(event);
    const isError = isErrorEvent(event);
    const eventType = event.type || "error";
    const beforeSendLabel = `before send for type \`${eventType}\``;
    const parsedSampleRate = typeof sampleRate === "undefined" ? void 0 : (0,parseSampleRate/* parseSampleRate */.i)(sampleRate);
    if (isError && typeof parsedSampleRate === "number" && (0,randomSafeContext/* safeMathRandom */.hY)() > parsedSampleRate) {
      this.recordDroppedEvent("sample_rate", "error");
      return (0,syncpromise/* rejectedSyncPromise */.xg)(
        _makeDoNotSendEventError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`
        )
      );
    }
    const dataCategory = getDataCategoryByType(event.type);
    return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared) => {
      if (prepared === null) {
        this.recordDroppedEvent("event_processor", dataCategory);
        throw _makeDoNotSendEventError("An event processor returned `null`, will not send event.");
      }
      const isInternalException = hint.data?.__sentry__ === true;
      if (isInternalException) {
        return prepared;
      }
      const result = processBeforeSend(this, options, prepared, hint);
      return _validateBeforeSendResult(result, beforeSendLabel);
    }).then((processedEvent) => {
      if (processedEvent === null) {
        this.recordDroppedEvent("before_send", dataCategory);
        if (isTransaction) {
          const spans = event.spans || [];
          const spanCount = 1 + spans.length;
          this.recordDroppedEvent("before_send", "span", spanCount);
        }
        throw _makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
      }
      const session = currentScope.getSession() || isolationScope.getSession();
      if (isError && session) {
        this._updateSessionFromEvent(session, processedEvent);
      }
      if (isTransaction) {
        const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
        const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
        const droppedSpanCount = spanCountBefore - spanCountAfter;
        if (droppedSpanCount > 0) {
          this.recordDroppedEvent("before_send", "span", droppedSpanCount);
        }
      }
      const transactionInfo = processedEvent.transaction_info;
      if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
        const source = "custom";
        processedEvent.transaction_info = {
          ...transactionInfo,
          source
        };
      }
      this.sendEvent(processedEvent, hint);
      return processedEvent;
    }).then(null, (reason) => {
      if (_isDoNotSendEventError(reason) || _isInternalError(reason)) {
        throw reason;
      }
      this.captureException(reason, {
        mechanism: {
          handled: false,
          type: "internal"
        },
        data: {
          __sentry__: true
        },
        originalException: reason
      });
      throw _makeInternalError(
        `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`
      );
    });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(taskProducer, dataCategory) {
    this._numProcessing++;
    void this._promiseBuffer.add(taskProducer).then(
      (value) => {
        this._numProcessing--;
        return value;
      },
      (reason) => {
        this._numProcessing--;
        if (reason === promisebuffer/* SENTRY_BUFFER_FULL_ERROR */.a) {
          this.recordDroppedEvent("queue_overflow", dataCategory);
        }
        return reason;
      }
    );
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.entries(outcomes).map(([key, quantity]) => {
      const [reason, category] = key.split(":");
      return {
        reason,
        category,
        quantity
      };
    });
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log("Flushing outcomes...");
    const outcomes = this._clearOutcomes();
    if (outcomes.length === 0) {
      debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log("No outcomes to send");
      return;
    }
    if (!this._dsn) {
      debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log("No dsn provided, will not send outcomes");
      return;
    }
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log("Sending outcomes:", outcomes);
    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && (0,dsn/* dsnToString */.SB)(this._dsn));
    this.sendEnvelope(envelope);
  }
}
function getDataCategoryByType(type) {
  return type === "replay_event" ? "replay" : type || "error";
}
function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.Qg)(beforeSendResult)) {
    return beforeSendResult.then(
      (event) => {
        if (!(0,is/* isPlainObject */.Qd)(event) && event !== null) {
          throw _makeInternalError(invalidValueError);
        }
        return event;
      },
      (e) => {
        throw _makeInternalError(`${beforeSendLabel} rejected with ${e}`);
      }
    );
  } else if (!(0,is/* isPlainObject */.Qd)(beforeSendResult) && beforeSendResult !== null) {
    throw _makeInternalError(invalidValueError);
  }
  return beforeSendResult;
}
function processBeforeSend(client, options, event, hint) {
  const { beforeSend, beforeSendTransaction, ignoreSpans } = options;
  const beforeSendSpan = !(0,spans_beforeSendSpan/* isStreamedBeforeSendSpanCallback */.S)(options.beforeSendSpan) && options.beforeSendSpan;
  let processedEvent = event;
  if (isErrorEvent(processedEvent) && beforeSend) {
    return beforeSend(processedEvent, hint);
  }
  if (isTransactionEvent(processedEvent)) {
    if (beforeSendSpan || ignoreSpans) {
      const rootSpanJson = convertTransactionEventToSpanJson(processedEvent);
      if (ignoreSpans?.length && (0,should_ignore_span/* shouldIgnoreSpan */.e)(
        { description: rootSpanJson.description, op: rootSpanJson.op, attributes: rootSpanJson.data },
        ignoreSpans
      )) {
        return null;
      }
      if (beforeSendSpan) {
        const processedRootSpanJson = beforeSendSpan(rootSpanJson);
        if (!processedRootSpanJson) {
          (0,spanUtils/* showSpanDropWarning */.xl)();
        } else {
          processedEvent = (0,merge/* merge */.h)(event, convertSpanJsonToTransactionEvent(processedRootSpanJson));
        }
      }
      if (processedEvent.spans) {
        const processedSpans = [];
        const initialSpans = processedEvent.spans;
        for (const span of initialSpans) {
          if (ignoreSpans?.length && (0,should_ignore_span/* shouldIgnoreSpan */.e)({ description: span.description, op: span.op, attributes: span.data }, ignoreSpans)) {
            (0,should_ignore_span/* reparentChildSpans */.R)(initialSpans, span);
            continue;
          }
          if (beforeSendSpan) {
            const processedSpan = beforeSendSpan(span);
            if (!processedSpan) {
              (0,spanUtils/* showSpanDropWarning */.xl)();
              processedSpans.push(span);
            } else {
              processedSpans.push(processedSpan);
            }
          } else {
            processedSpans.push(span);
          }
        }
        const droppedSpans = processedEvent.spans.length - processedSpans.length;
        if (droppedSpans) {
          client.recordDroppedEvent("before_send", "span", droppedSpans);
        }
        processedEvent.spans = processedSpans;
      }
    }
    if (beforeSendTransaction) {
      if (processedEvent.spans) {
        const spanCountBefore = processedEvent.spans.length;
        processedEvent.sdkProcessingMetadata = {
          ...event.sdkProcessingMetadata,
          spanCountBeforeProcessing: spanCountBefore
        };
      }
      return beforeSendTransaction(processedEvent, hint);
    }
  }
  return processedEvent;
}
function isErrorEvent(event) {
  return event.type === void 0;
}
function isTransactionEvent(event) {
  return event.type === "transaction";
}
function estimateMetricSizeInBytes(metric) {
  let weight = 0;
  if (metric.name) {
    weight += metric.name.length * 2;
  }
  weight += 8;
  return weight + estimateAttributesSizeInBytes(metric.attributes);
}
function estimateLogSizeInBytes(log) {
  let weight = 0;
  if (log.message) {
    weight += log.message.length * 2;
  }
  return weight + estimateAttributesSizeInBytes(log.attributes);
}
function estimateAttributesSizeInBytes(attributes) {
  if (!attributes) {
    return 0;
  }
  let weight = 0;
  Object.values(attributes).forEach((value) => {
    if (Array.isArray(value)) {
      weight += value.length * estimatePrimitiveSizeInBytes(value[0]);
    } else if ((0,is/* isPrimitive */.sO)(value)) {
      weight += estimatePrimitiveSizeInBytes(value);
    } else {
      weight += 100;
    }
  });
  return weight;
}
function estimatePrimitiveSizeInBytes(value) {
  if (typeof value === "string") {
    return value.length * 2;
  } else if (typeof value === "number") {
    return 8;
  } else if (typeof value === "boolean") {
    return 4;
  }
  return 0;
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/env.js
var env = __webpack_require__(42730);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/sdkMetadata.js
var sdkMetadata = __webpack_require__(80064);
;// ./node_modules/@sentry/core/build/esm/utils/ipAddress.js
function addAutoIpAddressToUser(objWithMaybeUser) {
  if (objWithMaybeUser.user?.ip_address === void 0) {
    objWithMaybeUser.user = {
      ...objWithMaybeUser.user,
      ip_address: "{{auto}}"
    };
  }
}
function addAutoIpAddressToSession(session) {
  if ("aggregates" in session) {
    if (session.attrs?.["ip_address"] === void 0) {
      session.attrs = {
        ...session.attrs,
        ip_address: "{{auto}}"
      };
    }
  } else {
    if (session.ipAddress === void 0) {
      session.ipAddress = "{{auto}}";
    }
  }
}


// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/eventbuilder.js + 1 modules
var eventbuilder = __webpack_require__(19417);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/helpers.js
var helpers = __webpack_require__(89401);
;// ./node_modules/@sentry/browser/build/npm/esm/prod/client.js



class BrowserClient extends Client {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(options) {
    const opts = applyDefaultOptions(options);
    const sdkSource = helpers/* WINDOW */.jf.SENTRY_SDK_SOURCE || (0,env/* getSDKSource */.e)();
    (0,sdkMetadata/* applySdkMetadata */.K)(opts, "browser", ["browser"], sdkSource);
    super(opts);
    const { userInfo } = this.getDataCollectionOptions();
    if (opts._metadata?.sdk) {
      opts._metadata.sdk.settings = {
        // Only allow IP inferral by Relay if the user opted in via dataCollection
        infer_ip: userInfo ? "auto" : "never",
        // purposefully allowing already passed settings to override the default
        ...opts._metadata.sdk.settings
      };
    }
    const { sendClientReports, enableLogs, _experiments, enableMetrics: enableMetricsOption } = this._options;
    const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
    if (helpers/* WINDOW */.jf.document && (sendClientReports || enableLogs || enableMetrics)) {
      helpers/* WINDOW */.jf.document.addEventListener("visibilitychange", () => {
        if (helpers/* WINDOW */.jf.document.visibilityState === "hidden") {
          if (sendClientReports) {
            this._flushOutcomes();
          }
          if (enableLogs) {
            (0,internal/* _INTERNAL_flushLogsBuffer */.lt)(this);
          }
          if (enableMetrics) {
            (0,metrics_internal/* _INTERNAL_flushMetricsBuffer */.NG)(this);
          }
        }
      });
    }
    if (userInfo) {
      this.on("beforeSendSession", addAutoIpAddressToSession);
    }
  }
  /**
   * @inheritDoc
   */
  eventFromException(exception, hint) {
    return (0,eventbuilder/* eventFromException */.u)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(message, level = "info", hint) {
    return (0,eventbuilder/* eventFromMessage */.qv)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(event, hint, currentScope, isolationScope) {
    event.platform = event.platform || "javascript";
    return super._prepareEvent(event, hint, currentScope, isolationScope);
  }
}
function applyDefaultOptions(optionsArg) {
  return {
    release: typeof __SENTRY_RELEASE__ === "string" ? __SENTRY_RELEASE__ : helpers/* WINDOW */.jf.SENTRY_RELEASE?.id,
    // This supports the variable that sentry-webpack-plugin injects
    sendClientReports: true,
    // We default this to true, as it is the safer scenario
    parentSpanIsAlwaysRootSpan: true,
    ...optionsArg
  };
}



/***/ }),

/***/ 76418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "T", 0, /* binding */ DEBUG_BUILD
/* harmony export */ ]);


/***/ }),

/***/ 19417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  u: function() { return /* binding */ eventFromException; },
  qv: function() { return /* binding */ eventbuilder_eventFromMessage; },
  H7: function() { return /* binding */ eventbuilder_eventFromUnknownInput; },
  K8: function() { return /* binding */ eventbuilder_exceptionFromError; }
});

// UNUSED EXPORTS: extractMessage, extractType

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/normalize.js
var normalize = __webpack_require__(51830);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/is.js
var is = __webpack_require__(91973);
;// ./node_modules/@sentry/core/build/esm/utils/eventbuilder.js
/* unused harmony import specifier */ var isErrorEvent;
/* unused harmony import specifier */ var isError;
/* unused harmony import specifier */ var isPlainObject;
/* unused harmony import specifier */ var isParameterizedString;
/* unused harmony import specifier */ var addExceptionTypeValue;
/* unused harmony import specifier */ var addExceptionMechanism;
/* unused harmony import specifier */ var normalizeToSize;
/* unused harmony import specifier */ var extractExceptionKeysForMessage;




function parseStackFrames(stackParser, error) {
  return stackParser(error.stack || "", 1);
}
function hasSentryFetchUrlHost(error) {
  return (0,is/* isError */.bJ)(error) && "__sentry_fetch_url_host__" in error && typeof error.__sentry_fetch_url_host__ === "string";
}
function _enhanceErrorWithSentryInfo(error) {
  if (hasSentryFetchUrlHost(error)) {
    return `${error.message} (${error.__sentry_fetch_url_host__})`;
  }
  return error.message;
}
function exceptionFromError(stackParser, error) {
  const exception = {
    type: error.name || error.constructor.name,
    value: _enhanceErrorWithSentryInfo(error)
  };
  const frames = parseStackFrames(stackParser, error);
  if (frames.length) {
    exception.stacktrace = { frames };
  }
  return exception;
}
function getErrorPropertyFromObject(obj) {
  for (const prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      const value = obj[prop];
      if (value instanceof Error) {
        return value;
      }
    }
  }
  return void 0;
}
function getMessageForObject(exception) {
  if ("name" in exception && typeof exception.name === "string") {
    let message = `'${exception.name}' captured as exception`;
    if ("message" in exception && typeof exception.message === "string") {
      message += ` with message '${exception.message}'`;
    }
    return message;
  } else if ("message" in exception && typeof exception.message === "string") {
    return exception.message;
  }
  const keys = extractExceptionKeysForMessage(exception);
  if (isErrorEvent(exception)) {
    return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
  }
  const className = getObjectClassName(exception);
  return `${className && className !== "Object" ? `'${className}'` : "Object"} captured as exception with keys: ${keys}`;
}
function getObjectClassName(obj) {
  try {
    const prototype = Object.getPrototypeOf(obj);
    return prototype ? prototype.constructor.name : void 0;
  } catch {
  }
}
function getException(client, mechanism, exception, hint) {
  if (isError(exception)) {
    return [exception, void 0];
  }
  mechanism.synthetic = true;
  if (isPlainObject(exception)) {
    const normalizeDepth = client?.getOptions().normalizeDepth;
    const extras = { ["__serialized__"]: normalizeToSize(exception, normalizeDepth) };
    const errorFromProp = getErrorPropertyFromObject(exception);
    if (errorFromProp) {
      return [errorFromProp, extras];
    }
    const message = getMessageForObject(exception);
    const ex2 = hint?.syntheticException || new Error(message);
    ex2.message = message;
    return [ex2, extras];
  }
  const ex = hint?.syntheticException || new Error(exception);
  ex.message = `${exception}`;
  return [ex, void 0];
}
function eventFromUnknownInput(client, stackParser, exception, hint) {
  const providedMechanism = hint?.data && hint.data.mechanism;
  const mechanism = providedMechanism || {
    handled: true,
    type: "generic"
  };
  const [ex, extras] = getException(client, mechanism, exception, hint);
  const event = {
    exception: {
      values: [exceptionFromError(stackParser, ex)]
    }
  };
  if (extras) {
    event.extra = extras;
  }
  addExceptionTypeValue(event, void 0, void 0);
  addExceptionMechanism(event, mechanism);
  return {
    ...event,
    event_id: hint?.event_id
  };
}
function eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
  const event = {
    event_id: hint?.event_id,
    level
  };
  if (attachStacktrace && hint?.syntheticException) {
    const frames = parseStackFrames(stackParser, hint.syntheticException);
    if (frames.length) {
      event.exception = {
        values: [
          {
            value: message,
            stacktrace: { frames }
          }
        ]
      };
      addExceptionMechanism(event, { synthetic: true });
    }
  }
  if (isParameterizedString(message)) {
    const { __sentry_template_string__, __sentry_template_values__ } = message;
    event.logentry = {
      message: __sentry_template_string__,
      params: __sentry_template_values__
    };
    return event;
  }
  event.message = message;
  return event;
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/misc.js
var misc = __webpack_require__(16513);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/syncpromise.js
var syncpromise = __webpack_require__(18533);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/object.js
var object = __webpack_require__(50742);
;// ./node_modules/@sentry/browser/build/npm/esm/prod/eventbuilder.js

function eventbuilder_exceptionFromError(stackParser, ex) {
  const frames = eventbuilder_parseStackFrames(stackParser, ex);
  const exception = {
    type: extractType(ex),
    value: extractMessage(ex)
  };
  if (frames.length) {
    exception.stacktrace = { frames };
  }
  if (exception.type === void 0 && exception.value === "") {
    exception.value = "Unrecoverable error caught";
  }
  return exception;
}
function eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
  const client = (0,currentScopes/* getClient */.KU)();
  const normalizeDepth = client?.getOptions().normalizeDepth;
  const errorFromProp = eventbuilder_getErrorPropertyFromObject(exception);
  const extra = {
    __serialized__: (0,normalize/* normalizeToSize */.cd)(exception, normalizeDepth)
  };
  if (errorFromProp) {
    return {
      exception: {
        values: [eventbuilder_exceptionFromError(stackParser, errorFromProp)]
      },
      extra
    };
  }
  const event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.xH)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
          value: getNonErrorObjectExceptionValue(exception, { isUnhandledRejection })
        }
      ]
    },
    extra
  };
  if (syntheticException) {
    const frames = eventbuilder_parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception.values[0].stacktrace = { frames };
    }
  }
  return event;
}
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [eventbuilder_exceptionFromError(stackParser, ex)]
    }
  };
}
function eventbuilder_parseStackFrames(stackParser, ex) {
  const stacktrace = ex.stacktrace || ex.stack || "";
  const skipLines = getSkipFirstStackStringLines(ex);
  const framesToPop = getPopFirstTopFrames(ex);
  try {
    return stackParser(stacktrace, skipLines, framesToPop);
  } catch {
  }
  return [];
}
const reactMinifiedRegexp = /Minified React error #\d+;/i;
function getSkipFirstStackStringLines(ex) {
  if (ex && reactMinifiedRegexp.test(ex.message)) {
    return 1;
  }
  return 0;
}
function getPopFirstTopFrames(ex) {
  if (typeof ex.framesToPop === "number") {
    return ex.framesToPop;
  }
  return 0;
}
function isWebAssemblyException(exception) {
  if (typeof WebAssembly !== "undefined" && typeof WebAssembly.Exception !== "undefined") {
    return exception instanceof WebAssembly.Exception;
  } else {
    return false;
  }
}
function extractType(ex) {
  const name = ex?.name;
  if (!name && isWebAssemblyException(ex)) {
    const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
    return hasTypeInMessage ? ex.message[0] : "WebAssembly.Exception";
  }
  return name;
}
function extractMessage(ex) {
  const message = ex?.message;
  if (isWebAssemblyException(ex)) {
    if (Array.isArray(ex.message) && ex.message.length == 2) {
      return ex.message[1];
    }
    return "wasm exception";
  }
  if (!message) {
    return "No error message";
  }
  if (message.error && typeof message.error.message === "string") {
    return _enhanceErrorWithSentryInfo(message.error);
  }
  return _enhanceErrorWithSentryInfo(ex);
}
function eventFromException(stackParser, exception, hint, attachStacktrace) {
  const syntheticException = hint?.syntheticException || void 0;
  const event = eventbuilder_eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.M6)(event);
  event.level = "error";
  if (hint?.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.XW)(event);
}
function eventbuilder_eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
  const syntheticException = hint?.syntheticException || void 0;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint?.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.XW)(event);
}
function eventbuilder_eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
  let event;
  if ((0,is/* isErrorEvent */.T2)(exception) && exception.error) {
    const errorEvent = exception;
    return eventFromError(stackParser, errorEvent.error);
  }
  if ((0,is/* isDOMError */.BD)(exception) || (0,is/* isDOMException */.W6)(exception)) {
    const domException = exception;
    if ("stack" in exception) {
      event = eventFromError(stackParser, exception);
      const firstException = event.exception?.values?.[0];
      if (attachStacktrace && syntheticException && firstException && !firstException.stacktrace) {
        const frames = eventbuilder_parseStackFrames(stackParser, syntheticException);
        if (frames.length) {
          firstException.stacktrace = { frames };
          (0,misc/* addExceptionMechanism */.M6)(event, { synthetic: true });
        }
      }
    } else {
      const name = domException.name || ((0,is/* isDOMError */.BD)(domException) ? "DOMError" : "DOMException");
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.gO)(event, message);
    }
    if ("code" in domException) {
      event.tags = { ...event.tags, "DOMException.code": `${domException.code}` };
    }
    return event;
  }
  if ((0,is/* isError */.bJ)(exception)) {
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.Qd)(exception) || (0,is/* isEvent */.xH)(exception)) {
    const objectException = exception;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.M6)(event, {
      synthetic: true
    });
    return event;
  }
  event = eventFromString(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.gO)(event, `${exception}`, void 0);
  (0,misc/* addExceptionMechanism */.M6)(event, {
    synthetic: true
  });
  return event;
}
function eventFromString(stackParser, message, syntheticException, attachStacktrace) {
  const event = {};
  if (attachStacktrace && syntheticException) {
    const frames = eventbuilder_parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: message, stacktrace: { frames } }]
      };
    }
    (0,misc/* addExceptionMechanism */.M6)(event, { synthetic: true });
  }
  if ((0,is/* isParameterizedString */.NF)(message)) {
    const { __sentry_template_string__, __sentry_template_values__ } = message;
    event.logentry = {
      message: __sentry_template_string__,
      params: __sentry_template_values__
    };
    return event;
  }
  event.message = message;
  return event;
}
function getNonErrorObjectExceptionValue(exception, { isUnhandledRejection }) {
  const keys = (0,object/* extractExceptionKeysForMessage */.HF)(exception);
  const captureType = isUnhandledRejection ? "promise rejection" : "exception";
  if ((0,is/* isErrorEvent */.T2)(exception)) {
    return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
  }
  if ((0,is/* isEvent */.xH)(exception)) {
    const className = eventbuilder_getObjectClassName(exception);
    return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
  }
  return `Object captured as ${captureType} with keys: ${keys}`;
}
function eventbuilder_getObjectClassName(obj) {
  try {
    const prototype = Object.getPrototypeOf(obj);
    return prototype ? prototype.constructor.name : void 0;
  } catch {
  }
}
function eventbuilder_getErrorPropertyFromObject(obj) {
  return Object.values(obj).find((v) => v instanceof Error);
}



/***/ }),

/***/ 89401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AP: function() { return /* binding */ getHttpRequestData; },
/* harmony export */   LV: function() { return /* binding */ wrap; },
/* harmony export */   jN: function() { return /* binding */ shouldIgnoreOnError; }
/* harmony export */ });
/* unused harmony export ignoreNextOnError */
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60068);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79255);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70774);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16513);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50742);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57333);

const WINDOW = _sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_OBJ */ .O;
let ignoreOnError = 0;
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}
function ignoreNextOnError() {
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}
function wrap(fn, options = {}) {
  function isFunction(fn2) {
    return typeof fn2 === "function";
  }
  if (!isFunction(fn)) {
    return fn;
  }
  try {
    const hasOwnWrapper = Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__");
    if (hasOwnWrapper) {
      const wrapper = fn.__sentry_wrapped__;
      if (typeof wrapper === "function") {
        return wrapper;
      } else {
        return fn;
      }
    }
    if ((0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_4__/* .getOriginalFunction */ .sp)(fn)) {
      return fn;
    }
  } catch {
    return fn;
  }
  const sentryWrapped = function(...args) {
    _sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_OBJ */ .O._sentryWrappedDepth = (_sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_OBJ */ .O._sentryWrappedDepth || 0) + 1;
    try {
      const wrappedArguments = args.map((arg) => wrap(arg, options));
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();
      (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .withScope */ .v4)((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionTypeValue */ .gO)(event, void 0, void 0);
            (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_3__/* .addExceptionMechanism */ .M6)(event, options.mechanism);
          }
          event.extra = {
            ...event.extra,
            arguments: args
          };
          return event;
        });
        (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .captureException */ .Cp)(ex);
      });
      throw ex;
    } finally {
      _sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_OBJ */ .O._sentryWrappedDepth = (_sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_OBJ */ .O._sentryWrappedDepth || 0) - 1;
    }
  };
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch {
  }
  (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_4__/* .markFunctionWrapped */ .pO)(sentryWrapped, fn);
  (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_4__/* .addNonEnumerableProperty */ .my)(fn, "__sentry_wrapped__", sentryWrapped);
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, "name", {
        get() {
          return fn.name;
        }
      });
    }
  } catch {
  }
  return sentryWrapped;
}
function getHttpRequestData() {
  const url = (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_5__/* .getLocationHref */ .$N)();
  const { referrer } = WINDOW.document || {};
  const { userAgent } = WINDOW.navigator || {};
  const headers = {
    ...referrer && { Referer: referrer },
    ...userAgent && { "User-Agent": userAgent }
  };
  const request = {
    url,
    headers
  };
  return request;
}


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "jf", 0, /* binding */ WINDOW
/* harmony export */ ]);


/***/ }),

/***/ 85148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  F: function() { return /* binding */ breadcrumbsIntegration; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/instrument/console.js
var console = __webpack_require__(42248);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/instrument/fetch.js
var fetch = __webpack_require__(42793);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/integration.js
var integration = __webpack_require__(94893);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/breadcrumbs.js
var breadcrumbs = __webpack_require__(55121);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/misc.js
var misc = __webpack_require__(16513);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-logger.js
var debug_logger = __webpack_require__(62183);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/browser.js
var browser = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/severity.js
var severity = __webpack_require__(1682);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/string.js
var string = __webpack_require__(26228);
;// ./node_modules/@sentry/core/build/esm/utils/breadcrumb-log-level.js
function getBreadcrumbLogLevelFromHttpStatusCode(statusCode) {
  if (statusCode === void 0) {
    return void 0;
  } else if (statusCode >= 400 && statusCode < 500) {
    return "warning";
  } else if (statusCode >= 500) {
    return "error";
  } else {
    return void 0;
  }
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/url.js
var url = __webpack_require__(77636);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/instrument/dom.js
var dom = __webpack_require__(8634);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/instrument/xhr.js
var xhr = __webpack_require__(7440);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/instrument/history.js
var instrument_history = __webpack_require__(19150);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/htmlTreeAsString.js
var htmlTreeAsString = __webpack_require__(89972);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/debug-build.js
var debug_build = __webpack_require__(76418);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/helpers.js
var helpers = __webpack_require__(89401);
;// ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/breadcrumbs.js




const MAX_ALLOWED_STRING_LENGTH = 1024;
const INTEGRATION_NAME = "Breadcrumbs";
const _breadcrumbsIntegration = ((options = {}) => {
  const _options = {
    console: true,
    dom: true,
    fetch: true,
    history: true,
    sentry: true,
    xhr: true,
    ...options
  };
  return {
    name: INTEGRATION_NAME,
    setup(client) {
      if (_options.console) {
        (0,console/* addConsoleInstrumentationHandler */.P)(_getConsoleBreadcrumbHandler(client));
      }
      if (_options.dom) {
        (0,dom/* addClickKeypressInstrumentationHandler */.i)(_getDomBreadcrumbHandler(client, _options.dom));
      }
      if (_options.xhr) {
        (0,xhr/* addXhrInstrumentationHandler */.Mn)(_getXhrBreadcrumbHandler(client));
      }
      if (_options.fetch) {
        (0,fetch/* addFetchInstrumentationHandler */.ur)(_getFetchBreadcrumbHandler(client));
      }
      if (_options.history) {
        (0,instrument_history/* addHistoryInstrumentationHandler */._)(_getHistoryBreadcrumbHandler(client));
      }
      if (_options.sentry) {
        client.on("beforeSendEvent", _getSentryBreadcrumbHandler(client));
      }
    }
  };
});
const breadcrumbsIntegration = (0,integration/* defineIntegration */._C)(_breadcrumbsIntegration);
function _getSentryBreadcrumbHandler(client) {
  return function addSentryBreadcrumb(event) {
    if ((0,currentScopes/* getClient */.KU)() !== client) {
      return;
    }
    (0,breadcrumbs/* addBreadcrumb */.Z)(
      {
        category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
        event_id: event.event_id,
        level: event.level,
        message: (0,misc/* getEventDescription */.$X)(event)
      },
      {
        event
      }
    );
  };
}
function _getDomBreadcrumbHandler(client, dom) {
  return function _innerDomBreadcrumb(handlerData) {
    if ((0,currentScopes/* getClient */.KU)() !== client) {
      return;
    }
    let target;
    let componentName;
    let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
    let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn(
        `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`
      );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }
    if (typeof keyAttrs === "string") {
      keyAttrs = [keyAttrs];
    }
    try {
      const event = handlerData.event;
      const element = _isEvent(event) ? event.target : event;
      target = (0,htmlTreeAsString/* htmlTreeAsString */.H)(element, { keyAttrs, maxStringLength });
      componentName = (0,browser/* getComponentName */.xE)(element);
    } catch {
      target = "<unknown>";
    }
    if (target.length === 0) {
      return;
    }
    const breadcrumb = {
      category: `ui.${handlerData.name}`,
      message: target
    };
    if (componentName) {
      breadcrumb.data = { "ui.component_name": componentName };
    }
    (0,breadcrumbs/* addBreadcrumb */.Z)(breadcrumb, {
      event: handlerData.event,
      name: handlerData.name,
      global: handlerData.global
    });
  };
}
function _getConsoleBreadcrumbHandler(client) {
  return function _consoleBreadcrumb(handlerData) {
    if ((0,currentScopes/* getClient */.KU)() !== client) {
      return;
    }
    const breadcrumb = {
      category: "console",
      data: {
        arguments: handlerData.args,
        logger: "console"
      },
      level: (0,severity/* severityLevelFromString */.t)(handlerData.level),
      message: (0,string/* safeJoin */.gt)(handlerData.args, " ")
    };
    if (handlerData.level === "assert") {
      if (handlerData.args[0] === false) {
        breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.gt)(handlerData.args.slice(1), " ") || "console.assert"}`;
        breadcrumb.data.arguments = handlerData.args.slice(1);
      } else {
        return;
      }
    }
    (0,breadcrumbs/* addBreadcrumb */.Z)(breadcrumb, {
      input: handlerData.args,
      level: handlerData.level
    });
  };
}
function _getXhrBreadcrumbHandler(client) {
  return function _xhrBreadcrumb(handlerData) {
    if ((0,currentScopes/* getClient */.KU)() !== client) {
      return;
    }
    const { startTimestamp, endTimestamp } = handlerData;
    const sentryXhrData = handlerData.xhr[xhr/* SENTRY_XHR_DATA_KEY */.Er];
    if (!startTimestamp || !endTimestamp || !sentryXhrData) {
      return;
    }
    const { method, url, status_code, body } = sentryXhrData;
    const data = {
      method,
      url,
      status_code
    };
    const hint = {
      xhr: handlerData.xhr,
      input: body,
      startTimestamp,
      endTimestamp
    };
    const breadcrumb = {
      category: "xhr",
      data,
      type: "http",
      level: getBreadcrumbLogLevelFromHttpStatusCode(status_code)
    };
    client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
    (0,breadcrumbs/* addBreadcrumb */.Z)(breadcrumb, hint);
  };
}
function _getFetchBreadcrumbHandler(client) {
  return function _fetchBreadcrumb(handlerData) {
    if ((0,currentScopes/* getClient */.KU)() !== client) {
      return;
    }
    const { startTimestamp, endTimestamp } = handlerData;
    if (!endTimestamp) {
      return;
    }
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") {
      return;
    }
    if (handlerData.error) {
      const hint = {
        data: handlerData.error,
        input: handlerData.args,
        startTimestamp,
        endTimestamp
      };
      const breadcrumb = {
        category: "fetch",
        data: handlerData.fetchData,
        level: "error",
        type: "http"
      };
      client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
      (0,breadcrumbs/* addBreadcrumb */.Z)(breadcrumb, hint);
    } else {
      const response = handlerData.response;
      const data = {
        ...handlerData.fetchData,
        status_code: response?.status
      };
      const hint = {
        input: handlerData.args,
        response,
        startTimestamp,
        endTimestamp
      };
      const breadcrumb = {
        category: "fetch",
        data,
        type: "http",
        level: getBreadcrumbLogLevelFromHttpStatusCode(data.status_code)
      };
      client.emit("beforeOutgoingRequestBreadcrumb", breadcrumb, hint);
      (0,breadcrumbs/* addBreadcrumb */.Z)(breadcrumb, hint);
    }
  };
}
function _getHistoryBreadcrumbHandler(client) {
  return function _historyBreadcrumb(handlerData) {
    if ((0,currentScopes/* getClient */.KU)() !== client) {
      return;
    }
    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = (0,url/* parseUrl */.Dl)(helpers/* WINDOW */.jf.location.href);
    let parsedFrom = from ? (0,url/* parseUrl */.Dl)(from) : void 0;
    const parsedTo = (0,url/* parseUrl */.Dl)(to);
    if (!parsedFrom?.path) {
      parsedFrom = parsedLoc;
    }
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
      to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
      from = parsedFrom.relative;
    }
    (0,breadcrumbs/* addBreadcrumb */.Z)({
      category: "navigation",
      data: {
        from,
        to
      }
    });
  };
}
function _isEvent(event) {
  return !!event && !!event.target;
}



/***/ }),

/***/ 19647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94893);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50742);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52992);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89401);


const DEFAULT_EVENT_TARGET = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,BroadcastChannel,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,SharedWorker,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(
  ","
);
const INTEGRATION_NAME = "BrowserApiErrors";
const _browserApiErrorsIntegration = ((options = {}) => {
  const _options = {
    XMLHttpRequest: true,
    eventTarget: true,
    requestAnimationFrame: true,
    setInterval: true,
    setTimeout: true,
    unregisterOriginalCallbacks: false,
    ...options
  };
  return {
    name: INTEGRATION_NAME,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      if (_options.setTimeout) {
        (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .GS)(_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .jf, "setTimeout", _wrapTimeFunction);
      }
      if (_options.setInterval) {
        (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .GS)(_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .jf, "setInterval", _wrapTimeFunction);
      }
      if (_options.requestAnimationFrame) {
        (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .GS)(_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .jf, "requestAnimationFrame", _wrapRAF);
      }
      if (_options.XMLHttpRequest && "XMLHttpRequest" in _helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .jf) {
        (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .GS)(XMLHttpRequest.prototype, "send", _wrapXHR);
      }
      const eventTargetOption = _options.eventTarget;
      if (eventTargetOption) {
        const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
        eventTarget.forEach((target) => _wrapEventTarget(target, _options));
      }
    }
  };
});
const browserApiErrorsIntegration = (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .defineIntegration */ ._C)(_browserApiErrorsIntegration);
function _wrapTimeFunction(original) {
  return function(...args) {
    const originalCallback = args[0];
    args[0] = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .LV)(originalCallback, {
      mechanism: {
        handled: false,
        type: `auto.browser.browserapierrors.${(0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .qQ)(original)}`
      }
    });
    return original.apply(this, args);
  };
}
function _wrapRAF(original) {
  return function(callback) {
    return original.apply(this, [
      (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .LV)(callback, {
        mechanism: {
          data: {
            handler: (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .qQ)(original)
          },
          handled: false,
          type: "auto.browser.browserapierrors.requestAnimationFrame"
        }
      })
    ]);
  };
}
function _wrapXHR(originalSend) {
  return function(...args) {
    const xhr = this;
    const xmlHttpRequestProps = ["onload", "onerror", "onprogress", "onreadystatechange"];
    xmlHttpRequestProps.forEach((prop) => {
      if (prop in xhr && typeof xhr[prop] === "function") {
        (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .GS)(xhr, prop, function(original) {
          const wrapOptions = {
            mechanism: {
              data: {
                handler: (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .qQ)(original)
              },
              handled: false,
              type: `auto.browser.browserapierrors.xhr.${prop}`
            }
          };
          const originalFunction = (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .getOriginalFunction */ .sp)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .qQ)(originalFunction);
          }
          return (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .LV)(original, wrapOptions);
        });
      }
    });
    return originalSend.apply(this, args);
  };
}
function _wrapEventTarget(target, integrationOptions) {
  const globalObject = _helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .jf;
  const proto = globalObject[target]?.prototype;
  if (!proto?.hasOwnProperty?.("addEventListener")) {
    return;
  }
  (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .GS)(proto, "addEventListener", function(original) {
    return function(eventName, fn, options) {
      try {
        if (isEventListenerObject(fn)) {
          fn.handleEvent = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .LV)(fn.handleEvent, {
            mechanism: {
              data: {
                handler: (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .qQ)(fn),
                target
              },
              handled: false,
              type: "auto.browser.browserapierrors.handleEvent"
            }
          });
        }
      } catch {
      }
      if (integrationOptions.unregisterOriginalCallbacks) {
        unregisterOriginalCallback(this, eventName, fn);
      }
      return original.apply(this, [
        eventName,
        (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .wrap */ .LV)(fn, {
          mechanism: {
            data: {
              handler: (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .qQ)(fn),
              target
            },
            handled: false,
            type: "auto.browser.browserapierrors.addEventListener"
          }
        }),
        options
      ]);
    };
  });
  (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .GS)(proto, "removeEventListener", function(originalRemoveEventListener) {
    return function(eventName, fn, options) {
      try {
        if (Object.prototype.hasOwnProperty.call(fn, "__sentry_wrapped__")) {
          const originalEventHandler = fn.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        }
      } catch {
      }
      return originalRemoveEventListener.call(this, eventName, fn, options);
    };
  });
}
function isEventListenerObject(obj) {
  return typeof obj.handleEvent === "function";
}
function unregisterOriginalCallback(target, eventName, fn) {
  if (target && typeof target === "object" && "removeEventListener" in target && typeof target.removeEventListener === "function") {
    target.removeEventListener(eventName, fn);
  }
}


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "G", 0, /* binding */ browserApiErrorsIntegration
/* harmony export */ ]);


/***/ }),

/***/ 56576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60068);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79255);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94893);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62183);
/* harmony import */ var _sentry_browser_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32664);
/* harmony import */ var _sentry_browser_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19150);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76418);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89401);




const browserSessionIntegration = (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .defineIntegration */ ._C)((options = {}) => {
  const lifecycle = options.lifecycle ?? "route";
  return {
    name: "BrowserSession",
    setupOnce() {
      if (typeof _helpers_js__WEBPACK_IMPORTED_MODULE_7__/* .WINDOW */ .jf.document === "undefined") {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .T && _sentry_core_browser__WEBPACK_IMPORTED_MODULE_3__/* .debug */ .Yz.warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
        return;
      }
      (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .startSession */ .J0)({ ignoreDuration: true });
      let initialSessionSent = false;
      (0,_sentry_browser_utils__WEBPACK_IMPORTED_MODULE_4__/* .whenIdleOrHidden */ .k)(() => {
        if (!initialSessionSent) {
          (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .captureSession */ .J5)();
          initialSessionSent = true;
        }
      });
      const isolationScope = (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .getIsolationScope */ .rm)();
      let previousUser = isolationScope.getUser();
      isolationScope.addScopeListener((scope) => {
        const maybeNewUser = scope.getUser();
        if (previousUser?.id !== maybeNewUser?.id || previousUser?.ip_address !== maybeNewUser?.ip_address) {
          previousUser = maybeNewUser;
          if (initialSessionSent) {
            (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .captureSession */ .J5)();
          }
        }
      });
      if (lifecycle === "route") {
        (0,_sentry_browser_utils__WEBPACK_IMPORTED_MODULE_5__/* .addHistoryInstrumentationHandler */ ._)(({ from, to }) => {
          if (from !== to) {
            (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .startSession */ .J0)({ ignoreDuration: true });
            (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .captureSession */ .J5)();
            initialSessionSent = true;
          }
        });
      }
    }
  };
});


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "p", 0, /* binding */ browserSessionIntegration
/* harmony export */ ]);


/***/ }),

/***/ 19157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18912);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94893);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89401);


const INTEGRATION_NAME = "CultureContext";
const _cultureContextIntegration = (() => {
  return {
    name: INTEGRATION_NAME,
    preprocessEvent(event) {
      const culture = getCultureContext();
      if (culture) {
        event.contexts = {
          ...event.contexts,
          culture: { ...culture, ...event.contexts?.culture }
        };
      }
    },
    processSegmentSpan(span) {
      const culture = getCultureContext();
      if (culture) {
        (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .safeSetSpanJSONAttributes */ .FD)(span, {
          "culture.locale": culture.locale,
          "culture.timezone": culture.timezone,
          "culture.calendar": culture.calendar
        });
      }
    }
  };
});
const cultureContextIntegration = (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .defineIntegration */ ._C)(_cultureContextIntegration);
function getCultureContext() {
  try {
    const intl = _helpers_js__WEBPACK_IMPORTED_MODULE_2__/* .WINDOW */ .jf.Intl;
    if (!intl) {
      return void 0;
    }
    const options = intl.DateTimeFormat().resolvedOptions();
    return {
      locale: options.locale,
      timezone: options.timeZone,
      calendar: options.calendar
    };
  } catch {
    return void 0;
  }
}


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "y", 0, /* binding */ cultureContextIntegration
/* harmony export */ ]);


/***/ }),

/***/ 8590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1523);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91302);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94893);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42793);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77636);

const responseToStreamSpan = /* @__PURE__ */ new WeakMap();
const responseToFallbackTimeout = /* @__PURE__ */ new WeakMap();
const STREAM_RESOLVE_FALLBACK_MS = 9e4;
const STREAMING_CONTENT_TYPES = ["text/event-stream", "application/x-ndjson", "application/stream+json"];
const fetchStreamPerformanceIntegration = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .defineIntegration */ ._C)(() => {
  return {
    name: "FetchStreamPerformance",
    setup() {
      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .addFetchEndInstrumentationHandler */ .B$)((handlerData) => {
        if (handlerData.response) {
          const streamSpan = responseToStreamSpan.get(handlerData.response);
          if (streamSpan && handlerData.endTimestamp) {
            streamSpan.end(handlerData.endTimestamp);
            const fallbackTimeout = responseToFallbackTimeout.get(handlerData.response);
            if (fallbackTimeout) {
              clearTimeout(fallbackTimeout);
            }
          }
        }
      });
      (0,_sentry_core__WEBPACK_IMPORTED_MODULE_3__/* .addFetchInstrumentationHandler */ .ur)((handlerData) => {
        if (handlerData.endTimestamp && handlerData.response) {
          const contentType = handlerData.response.headers?.get("content-type") || "";
          if (handlerData.response.headers?.get("content-length") || !STREAMING_CONTENT_TYPES.some((t) => contentType.startsWith(t))) {
            return;
          }
          const url = handlerData.fetchData?.url || "";
          const method = handlerData.fetchData?.method || "GET";
          const parsedUrl = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_4__/* .parseStringToURLObject */ .kg)(url);
          const sanitizedUrl = url.startsWith("data:") ? (0,_sentry_core__WEBPACK_IMPORTED_MODULE_4__/* .stripDataUrlContent */ .zm)(url) : parsedUrl ? (0,_sentry_core__WEBPACK_IMPORTED_MODULE_4__/* .getSanitizedUrlStringFromUrlObject */ .CH)(parsedUrl) : url;
          const streamSpan = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .startInactiveSpan */ .Uk)({
            name: `${method} ${sanitizedUrl}`,
            startTime: handlerData.endTimestamp,
            attributes: {
              url: (0,_sentry_core__WEBPACK_IMPORTED_MODULE_4__/* .stripDataUrlContent */ .zm)(url),
              "http.method": method,
              type: "fetch",
              [_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .uT]: "http.client.stream",
              [_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .JD]: "auto.http.browser.stream"
            }
          });
          responseToStreamSpan.set(handlerData.response, streamSpan);
          const fallbackTimeout = setTimeout(() => {
            if (streamSpan.isRecording()) {
              streamSpan.end();
            }
          }, STREAM_RESOLVE_FALLBACK_MS);
          responseToFallbackTimeout.set(handlerData.response, fallbackTimeout);
        }
      });
    }
  };
});


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "z", 0, /* binding */ fetchStreamPerformanceIntegration
/* harmony export */ ]);


/***/ }),

/***/ 81094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C$: function() { return /* binding */ _eventFromRejectionWithPrimitive; },
/* harmony export */   sc: function() { return /* binding */ _getUnhandledRejectionError; }
/* harmony export */ });
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60068);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79255);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94893);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38482);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76676);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91973);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62183);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77636);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(57333);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(76418);
/* harmony import */ var _eventbuilder_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19417);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(89401);




const INTEGRATION_NAME = "GlobalHandlers";
const _globalHandlersIntegration = ((options = {}) => {
  const _options = {
    onerror: true,
    onunhandledrejection: true,
    ...options
  };
  return {
    name: INTEGRATION_NAME,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(client) {
      if (_options.onerror) {
        _installGlobalOnErrorHandler(client);
        globalHandlerLog("onerror");
      }
      if (_options.onunhandledrejection) {
        _installGlobalOnUnhandledRejectionHandler(client);
        globalHandlerLog("onunhandledrejection");
      }
    }
  };
});
const globalHandlersIntegration = (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .defineIntegration */ ._C)(_globalHandlersIntegration);
function _installGlobalOnErrorHandler(client) {
  (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_3__/* .addGlobalErrorInstrumentationHandler */ .L)((data) => {
    const { stackParser, attachStacktrace } = getOptions();
    if ((0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .getClient */ .KU)() !== client || (0,_helpers_js__WEBPACK_IMPORTED_MODULE_12__/* .shouldIgnoreOnError */ .jN)()) {
      return;
    }
    const { msg, url, line, column, error } = data;
    const event = _enhanceEventWithInitialFrame(
      (0,_eventbuilder_js__WEBPACK_IMPORTED_MODULE_11__/* .eventFromUnknownInput */ .H7)(stackParser, error || msg, void 0, attachStacktrace, false),
      url,
      line,
      column
    );
    event.level = "error";
    (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .captureEvent */ .r)(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: "auto.browser.global_handlers.onerror"
      }
    });
  });
}
function _installGlobalOnUnhandledRejectionHandler(client) {
  (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_4__/* .addGlobalUnhandledRejectionInstrumentationHandler */ .r)((e) => {
    const { stackParser, attachStacktrace } = getOptions();
    if ((0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .getClient */ .KU)() !== client || (0,_helpers_js__WEBPACK_IMPORTED_MODULE_12__/* .shouldIgnoreOnError */ .jN)()) {
      return;
    }
    const error = _getUnhandledRejectionError(e);
    const event = (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_5__/* .isPrimitive */ .sO)(error) ? _eventFromRejectionWithPrimitive(error) : (0,_eventbuilder_js__WEBPACK_IMPORTED_MODULE_11__/* .eventFromUnknownInput */ .H7)(stackParser, error, void 0, attachStacktrace, true);
    event.level = "error";
    (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .captureEvent */ .r)(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: "auto.browser.global_handlers.onunhandledrejection"
      }
    });
  });
}
function _getUnhandledRejectionError(error) {
  if ((0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_5__/* .isPrimitive */ .sO)(error)) {
    return error;
  }
  try {
    if ("reason" in error) {
      return error.reason;
    }
    if ("detail" in error && "reason" in error.detail) {
      return error.detail.reason;
    }
  } catch {
  }
  return error;
}
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: "UnhandledRejection",
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`
        }
      ]
    }
  };
}
function _enhanceEventWithInitialFrame(event, url, lineno, colno) {
  const e = event.exception = event.exception || {};
  const ev = e.values = e.values || [];
  const ev0 = ev[0] = ev[0] || {};
  const ev0s = ev0.stacktrace = ev0.stacktrace || {};
  const ev0sf = ev0s.frames = ev0s.frames || [];
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      lineno,
      filename: getFilenameFromUrl(url) ?? (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_9__/* .getLocationHref */ .$N)(),
      function: (/* inlined export .UNKNOWN_FUNCTION */"?"),
      in_app: true
    });
  }
  return event;
}
function globalHandlerLog(type) {
  _debug_build_js__WEBPACK_IMPORTED_MODULE_10__/* .DEBUG_BUILD */ .T && _sentry_core_browser__WEBPACK_IMPORTED_MODULE_6__/* .debug */ .Yz.log(`Global Handler attached: ${type}`);
}
function getOptions() {
  const client = (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .getClient */ .KU)();
  const options = client?.getOptions() || {
    stackParser: () => [],
    attachStacktrace: false
  };
  return options;
}
function getFilenameFromUrl(url) {
  if (!(0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .Kg)(url) || url.length === 0) {
    return void 0;
  }
  if (url.startsWith("data:")) {
    return `<${(0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_8__/* .stripDataUrlContent */ .zm)(url, false)}>`;
  }
  return url;
}


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "LO", 0, /* binding */ globalHandlersIntegration
/* harmony export */ ]);


/***/ }),

/***/ 5293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18912);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91302);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94893);
/* harmony import */ var _helpers_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89401);


const httpContextIntegration = (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_2__/* .defineIntegration */ ._C)(() => {
  return {
    name: "HttpContext",
    preprocessEvent(event) {
      if (!_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .jf.navigator && !_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .jf.location && !_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .jf.document) {
        return;
      }
      const reqData = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .getHttpRequestData */ .AP)();
      const headers = {
        ...reqData.headers,
        ...event.request?.headers
      };
      event.request = {
        ...reqData,
        ...event.request,
        headers
      };
    },
    processSegmentSpan(span) {
      const spanOp = span.attributes?.[_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .uT];
      if (!_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .jf.navigator && !_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .jf.location && !_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .WINDOW */ .jf.document) {
        return;
      }
      const reqData = (0,_helpers_js__WEBPACK_IMPORTED_MODULE_3__/* .getHttpRequestData */ .AP)();
      (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .safeSetSpanJSONAttributes */ .FD)(span, {
        // Coerce empty string to undefined so the helper's nullish check drops it,
        // rather than writing an empty `url.full` attribute onto the span.
        "url.full": spanOp !== "http.client" ? reqData.url : void 0,
        "http.request.header.user_agent": reqData.headers["User-Agent"],
        "http.request.header.referer": reqData.headers["Referer"]
      });
    }
  };
});


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "M", 0, /* binding */ httpContextIntegration
/* harmony export */ ]);


/***/ }),

/***/ 76618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  p: function() { return /* binding */ linkedErrorsIntegration; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/is.js
var is = __webpack_require__(91973);
;// ./node_modules/@sentry/core/build/esm/utils/aggregate-errors.js

function applyAggregateErrorsToEvent(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
  if (!event.exception?.values || !hint || !(0,is/* isInstanceOf */.tH)(hint.originalException, Error)) {
    return;
  }
  const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : void 0;
  if (originalException) {
    event.exception.values = aggregateExceptionsFromError(
      exceptionFromErrorImplementation,
      parser,
      limit,
      hint.originalException,
      key,
      event.exception.values,
      originalException,
      0
    );
  }
}
function aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
  if (prevExceptions.length >= limit + 1) {
    return prevExceptions;
  }
  let newExceptions = [...prevExceptions];
  if ((0,is/* isInstanceOf */.tH)(error[key], Error)) {
    applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
    const newException = exceptionFromErrorImplementation(parser, error[key]);
    const newExceptionId = newExceptions.length;
    applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
    newExceptions = aggregateExceptionsFromError(
      exceptionFromErrorImplementation,
      parser,
      limit,
      error[key],
      key,
      [newException, ...newExceptions],
      newException,
      newExceptionId
    );
  }
  if (isExceptionGroup(error)) {
    error.errors.forEach((childError, i) => {
      if ((0,is/* isInstanceOf */.tH)(childError, Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, childError);
        const newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(
          exceptionFromErrorImplementation,
          parser,
          limit,
          childError,
          key,
          [newException, ...newExceptions],
          newException,
          newExceptionId
        );
      }
    });
  }
  return newExceptions;
}
function isExceptionGroup(error) {
  return Array.isArray(error.errors);
}
function applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
  exception.mechanism = {
    handled: true,
    type: "auto.core.linked_errors",
    ...isExceptionGroup(error) && { is_exception_group: true },
    ...exception.mechanism,
    exception_id: exceptionId
  };
}
function applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
  exception.mechanism = {
    handled: true,
    ...exception.mechanism,
    type: "chained",
    source,
    exception_id: exceptionId,
    parent_id: parentId
  };
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/integration.js
var integration = __webpack_require__(94893);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/eventbuilder.js + 1 modules
var eventbuilder = __webpack_require__(19417);
;// ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/linkederrors.js


const DEFAULT_KEY = "cause";
const DEFAULT_LIMIT = 5;
const INTEGRATION_NAME = "LinkedErrors";
const _linkedErrorsIntegration = ((options = {}) => {
  const limit = options.limit || DEFAULT_LIMIT;
  const key = options.key || DEFAULT_KEY;
  return {
    name: INTEGRATION_NAME,
    preprocessEvent(event, hint, client) {
      const options2 = client.getOptions();
      applyAggregateErrorsToEvent(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        eventbuilder/* exceptionFromError */.K8,
        options2.stackParser,
        key,
        limit,
        event,
        hint
      );
    }
  };
});
const linkedErrorsIntegration = (0,integration/* defineIntegration */._C)(_linkedErrorsIntegration);



/***/ }),

/***/ 23492:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Q: function() { return /* binding */ WEB_VITALS_INTEGRATION_NAME; },
  K: function() { return /* binding */ webVitalsIntegration; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/integration.js
var integration = __webpack_require__(94893);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/spans/hasSpanStreamingEnabled.js
var hasSpanStreamingEnabled = __webpack_require__(97989);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/browserMetrics.js + 1 modules
var browserMetrics = __webpack_require__(60061);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91302);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(42896);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/trace.js + 1 modules
var trace = __webpack_require__(1523);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-logger.js
var debug_logger = __webpack_require__(62183);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/time.js
var time = __webpack_require__(39612);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/debug-build.js
var debug_build = __webpack_require__(60096);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/htmlTreeAsString.js
var htmlTreeAsString = __webpack_require__(89972);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/types.js
var types = __webpack_require__(84335);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/isBrowser.js
var isBrowser = __webpack_require__(82257);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/instrument.js + 15 modules
var instrument = __webpack_require__(33731);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/utils.js + 1 modules
var utils = __webpack_require__(66116);
;// ./node_modules/@sentry/browser-utils/build/esm/metrics/inp.js





const LAST_INTERACTIONS = [];
const INTERACTIONS_SPAN_MAP = /* @__PURE__ */ new Map();
const ELEMENT_NAME_TIMESTAMP_MAP = /* @__PURE__ */ new Map();
const MAX_PLAUSIBLE_INP_DURATION = 60;
function startTrackingINP() {
  const performance = (0,utils/* getBrowserPerformanceAPI */.D)();
  if (performance && (0,time/* browserPerformanceTimeOrigin */.k3)()) {
    const inpCallback = _trackINP();
    return () => {
      inpCallback();
    };
  }
  return () => void 0;
}
const INP_ENTRY_MAP = {
  click: "click",
  pointerdown: "click",
  pointerup: "click",
  mousedown: "click",
  mouseup: "click",
  touchstart: "click",
  touchend: "click",
  mouseover: "hover",
  mouseout: "hover",
  mouseenter: "hover",
  mouseleave: "hover",
  pointerover: "hover",
  pointerout: "hover",
  pointerenter: "hover",
  pointerleave: "hover",
  dragstart: "drag",
  dragend: "drag",
  drag: "drag",
  dragenter: "drag",
  dragleave: "drag",
  dragover: "drag",
  drop: "drag",
  keydown: "press",
  keyup: "press",
  keypress: "press",
  input: "press"
};
function _trackINP() {
  return (0,instrument/* addInpInstrumentationHandler */.hT)(_onInp);
}
const _onInp = ({ metric }) => {
  if (metric.value == void 0) {
    return;
  }
  const duration = (0,utils/* msToSec */.rv)(metric.value);
  if (duration > MAX_PLAUSIBLE_INP_DURATION) {
    return;
  }
  const entry = metric.entries.find((entry2) => entry2.duration === metric.value && INP_ENTRY_MAP[entry2.name]);
  if (!entry) {
    return;
  }
  const { interactionId } = entry;
  const interactionType = INP_ENTRY_MAP[entry.name];
  const startTime = (0,utils/* msToSec */.rv)((0,time/* browserPerformanceTimeOrigin */.k3)() + entry.startTime);
  const activeSpan = (0,spanUtils/* getActiveSpan */.Bk)();
  const rootSpan = activeSpan ? (0,spanUtils/* getRootSpan */.zU)(activeSpan) : void 0;
  const cachedInteractionContext = interactionId != null ? INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
  const spanToUse = cachedInteractionContext?.span || rootSpan;
  const routeName = spanToUse ? (0,spanUtils/* spanToJSON */.et)(spanToUse).description : (0,currentScopes/* getCurrentScope */.o5)().getScopeData().transactionName;
  const name = cachedInteractionContext?.elementName || (0,htmlTreeAsString/* htmlTreeAsString */.H)(entry.target);
  const attributes = {
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.http.browser.inp",
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.uT]: `ui.interaction.${interactionType}`,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME */.jG]: entry.duration
  };
  const span = (0,utils/* startStandaloneWebVitalSpan */.kD)({
    name,
    transaction: routeName,
    attributes,
    startTime
  });
  if (span) {
    span.addEvent("inp", {
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT */.Sn]: "millisecond",
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE */.xc]: metric.value
    });
    span.end(startTime + duration);
  }
};
function getCachedInteractionContext(interactionId) {
  return interactionId != null ? INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
}
function registerInpInteractionListener() {
  const interactionEvents = Object.keys(INP_ENTRY_MAP);
  if ((0,isBrowser/* isBrowser */.B)()) {
    interactionEvents.forEach((eventType) => {
      types/* WINDOW */.j.addEventListener(eventType, captureElementFromEvent, { capture: true, passive: true });
    });
  }
  function captureElementFromEvent(event) {
    const target = event.target;
    if (!target) {
      return;
    }
    const elementName = (0,htmlTreeAsString/* htmlTreeAsString */.H)(target);
    const timestamp = Math.round(event.timeStamp);
    ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
    if (ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
      const firstKey = ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
      if (firstKey !== void 0) {
        ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
      }
    }
  }
  function resolveElementNameFromEntry(entry) {
    const timestamp = Math.round(entry.startTime);
    let elementName = ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
    if (!elementName) {
      for (let offset = -5; offset <= 5; offset++) {
        const nearbyName = ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
        if (nearbyName) {
          elementName = nearbyName;
          break;
        }
      }
    }
    return elementName || "<unknown>";
  }
  const handleEntries = ({ entries }) => {
    const activeSpan = (0,spanUtils/* getActiveSpan */.Bk)();
    const activeRootSpan = activeSpan && (0,spanUtils/* getRootSpan */.zU)(activeSpan);
    entries.forEach((entry) => {
      if (!(0,instrument/* isPerformanceEventTiming */.tC)(entry)) {
        return;
      }
      const interactionId = entry.interactionId;
      if (interactionId == null) {
        return;
      }
      if (INTERACTIONS_SPAN_MAP.has(interactionId)) {
        return;
      }
      const elementName = entry.target ? (0,htmlTreeAsString/* htmlTreeAsString */.H)(entry.target) : resolveElementNameFromEntry(entry);
      if (LAST_INTERACTIONS.length > 10) {
        const last = LAST_INTERACTIONS.shift();
        INTERACTIONS_SPAN_MAP.delete(last);
      }
      LAST_INTERACTIONS.push(interactionId);
      INTERACTIONS_SPAN_MAP.set(interactionId, {
        span: activeRootSpan,
        elementName
      });
    });
  };
  (0,instrument/* addPerformanceInstrumentationHandler */.wv)("event", handleEntries);
  (0,instrument/* addPerformanceInstrumentationHandler */.wv)("first-input", handleEntries);
}


// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/lcp.js
var lcp = __webpack_require__(30075);
;// ./node_modules/@sentry/browser-utils/build/esm/metrics/webVitalSpans.js








function _emitWebVitalSpan(options) {
  const {
    name,
    op,
    origin,
    metricName,
    value,
    attributes: passedAttributes,
    parentSpan,
    reportEvent,
    startTime,
    endTime
  } = options;
  const routeName = (0,currentScopes/* getCurrentScope */.o5)().getScopeData().transactionName;
  const attributes = {
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: origin,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.uT]: op,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME */.jG]: 0,
    [`browser.web_vital.${metricName}.value`]: value,
    "sentry.transaction": routeName,
    // Web vital score calculation relies on the user agent
    "user_agent.original": types/* WINDOW */.j.navigator?.userAgent,
    ...passedAttributes
  };
  if (parentSpan && (0,spanUtils/* spanToStreamedSpanJSON */.RD)(parentSpan).attributes?.[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.uT] === "pageload") {
    attributes["sentry.pageload.span_id"] = parentSpan.spanContext().spanId;
  }
  if (reportEvent) {
    attributes[`browser.web_vital.${metricName}.report_event`] = reportEvent;
  }
  const span = (0,trace/* startInactiveSpan */.Uk)({
    name,
    attributes,
    startTime,
    // if we have a pageload span, we let the web vital span start as its parent. This ensures that
    // it is not started as a segment span, without having to manually set it to a "standalone" v2 span
    // that has `segment: false` but no actual parent span.
    parentSpan
  });
  if (span) {
    span.end(endTime ?? startTime);
  }
}
function trackLcpAsSpan(client) {
  let lcpValue = 0;
  let lcpEntry;
  if (!(0,utils/* supportsWebVital */.Jy)("largest-contentful-paint")) {
    return;
  }
  const cleanupLcpHandler = (0,instrument/* addLcpInstrumentationHandler */.Pt)(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry || !(0,lcp/* isValidLcpMetric */.CE)(metric.value)) {
      return;
    }
    lcpValue = metric.value;
    lcpEntry = entry;
  }, true);
  (0,utils/* listenForWebVitalReportEvents */.WF)(client, (reportEvent, _, pageloadSpan) => {
    _sendLcpSpan(lcpValue, lcpEntry, pageloadSpan, reportEvent);
    cleanupLcpHandler();
  });
}
function _sendLcpSpan(lcpValue, entry, pageloadSpan, reportEvent) {
  if (!(0,lcp/* isValidLcpMetric */.CE)(lcpValue)) {
    return;
  }
  debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log(`Sending LCP span (${lcpValue})`);
  const performanceTimeOrigin = (0,time/* browserPerformanceTimeOrigin */.k3)() || 0;
  const timeOrigin = (0,utils/* msToSec */.rv)(performanceTimeOrigin);
  const endTime = (0,utils/* msToSec */.rv)(performanceTimeOrigin + (entry?.startTime || 0));
  const name = entry ? (0,htmlTreeAsString/* htmlTreeAsString */.H)(entry.element) : "Largest contentful paint";
  const attributes = {};
  entry?.element && (attributes["browser.web_vital.lcp.element"] = (0,htmlTreeAsString/* htmlTreeAsString */.H)(entry.element));
  entry?.id && (attributes["browser.web_vital.lcp.id"] = entry.id);
  entry?.url && (attributes["browser.web_vital.lcp.url"] = entry.url);
  entry?.loadTime != null && (attributes["browser.web_vital.lcp.load_time"] = entry.loadTime);
  entry?.renderTime != null && (attributes["browser.web_vital.lcp.render_time"] = entry.renderTime);
  entry?.size != null && (attributes["browser.web_vital.lcp.size"] = entry.size);
  _emitWebVitalSpan({
    name,
    op: "ui.webvital.lcp",
    origin: "auto.http.browser.lcp",
    metricName: "lcp",
    value: lcpValue,
    attributes,
    parentSpan: pageloadSpan,
    reportEvent,
    startTime: timeOrigin,
    endTime
  });
}
function trackClsAsSpan(client) {
  let clsValue = 0;
  let clsEntry;
  if (!(0,utils/* supportsWebVital */.Jy)("layout-shift")) {
    return;
  }
  const cleanupClsHandler = (0,instrument/* addClsInstrumentationHandler */.a9)(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }
    clsValue = metric.value;
    clsEntry = entry;
  }, true);
  (0,utils/* listenForWebVitalReportEvents */.WF)(client, (reportEvent, _, pageloadSpan) => {
    _sendClsSpan(clsValue, clsEntry, pageloadSpan, reportEvent);
    cleanupClsHandler();
  });
}
function _sendClsSpan(clsValue, entry, pageloadSpan, reportEvent) {
  debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log(`Sending CLS span (${clsValue})`);
  const startTime = entry ? (0,utils/* msToSec */.rv)(((0,time/* browserPerformanceTimeOrigin */.k3)() || 0) + entry.startTime) : (0,time/* timestampInSeconds */.zf)();
  const name = entry ? (0,htmlTreeAsString/* htmlTreeAsString */.H)(entry.sources[0]?.node) : "Layout shift";
  const attributes = {};
  if (entry?.sources) {
    entry.sources.forEach((source, index) => {
      attributes[`browser.web_vital.cls.source.${index + 1}`] = (0,htmlTreeAsString/* htmlTreeAsString */.H)(source.node);
    });
  }
  _emitWebVitalSpan({
    name,
    op: "ui.webvital.cls",
    origin: "auto.http.browser.cls",
    metricName: "cls",
    value: clsValue,
    attributes,
    parentSpan: pageloadSpan,
    reportEvent,
    startTime
  });
}
function trackInpAsSpan() {
  const performance = (0,utils/* getBrowserPerformanceAPI */.D)();
  if (!performance || !(0,time/* browserPerformanceTimeOrigin */.k3)()) {
    return;
  }
  const onInp = ({ metric }) => {
    if (metric.value == null) {
      return;
    }
    const duration = (0,utils/* msToSec */.rv)(metric.value);
    if (duration > (/* inlined export .MAX_PLAUSIBLE_INP_DURATION */60)) {
      return;
    }
    const entry = metric.entries.find((e) => e.duration === metric.value && INP_ENTRY_MAP[e.name]);
    if (!entry) {
      return;
    }
    _sendInpSpan(metric.value, entry);
  };
  (0,instrument/* addInpInstrumentationHandler */.hT)(onInp);
}
function _sendInpSpan(inpValue, entry) {
  debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log(`Sending INP span (${inpValue})`);
  const startTime = (0,utils/* msToSec */.rv)((0,time/* browserPerformanceTimeOrigin */.k3)() + entry.startTime);
  const duration = (0,utils/* msToSec */.rv)(inpValue);
  const interactionType = INP_ENTRY_MAP[entry.name];
  const cachedContext = getCachedInteractionContext(entry.interactionId);
  const activeSpan = (0,spanUtils/* getActiveSpan */.Bk)();
  const rootSpan = activeSpan ? (0,spanUtils/* getRootSpan */.zU)(activeSpan) : void 0;
  const spanToUse = cachedContext?.span || rootSpan;
  const routeName = spanToUse ? (0,spanUtils/* spanToStreamedSpanJSON */.RD)(spanToUse).name : (0,currentScopes/* getCurrentScope */.o5)().getScopeData().transactionName;
  const name = cachedContext?.elementName || (0,htmlTreeAsString/* htmlTreeAsString */.H)(entry.target);
  _emitWebVitalSpan({
    name,
    op: `ui.interaction.${interactionType}`,
    origin: "auto.http.browser.inp",
    metricName: "inp",
    value: inpValue,
    attributes: {
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME */.jG]: entry.duration,
      "sentry.transaction": routeName
    },
    startTime,
    endTime: startTime + duration,
    parentSpan: spanToUse
  });
}


;// ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/webVitals.js


const WEB_VITALS_INTEGRATION_NAME = "WebVitals";
const webVitalsIntegration = (0,integration/* defineIntegration */._C)((options = {}) => {
  const ignored = new Set(options.ignore ?? []);
  return {
    name: WEB_VITALS_INTEGRATION_NAME,
    setup(client) {
      const spanStreamingEnabled = (0,hasSpanStreamingEnabled/* hasSpanStreamingEnabled */.K)(client);
      const { enableStandaloneClsSpans, enableStandaloneLcpSpans } = options._experiments ?? {};
      const recordClsStandaloneSpans = spanStreamingEnabled || ignored.has("cls") ? void 0 : enableStandaloneClsSpans || false;
      const recordLcpStandaloneSpans = spanStreamingEnabled || ignored.has("lcp") ? void 0 : enableStandaloneLcpSpans || false;
      const finalizeWebVitals = (0,browserMetrics/* startTrackingWebVitals */.bk)({
        recordClsStandaloneSpans,
        recordLcpStandaloneSpans,
        client
      });
      const pageloadSpans = /* @__PURE__ */ new WeakSet();
      client.on("afterStartPageLoadSpan", (span) => {
        pageloadSpans.add(span);
      });
      client.on("spanEnd", (span) => {
        if (!pageloadSpans.delete(span)) {
          return;
        }
        finalizeWebVitals();
        (0,browserMetrics/* addWebVitalsToSpan */.e4)(span, {
          // CLS/LCP are recorded as pageload span measurements only when they're neither
          // tracked as standalone spans nor handled by span streaming (and not ignored).
          recordClsOnPageloadSpan: recordClsStandaloneSpans === false,
          recordLcpOnPageloadSpan: recordLcpStandaloneSpans === false,
          spanStreamingEnabled
        });
      });
      if (spanStreamingEnabled) {
        if (!ignored.has("lcp")) {
          trackLcpAsSpan(client);
        }
        if (!ignored.has("cls")) {
          trackClsAsSpan(client);
        }
        if (!ignored.has("inp")) {
          trackInpAsSpan();
        }
      } else if (!ignored.has("inp")) {
        startTrackingINP();
      }
    },
    afterAllSetup() {
      if (!ignored.has("inp")) {
        registerInpInteractionListener();
      }
    }
  };
});



/***/ }),

/***/ 83367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  U: function() { return /* binding */ normalizeStringifyValue; }
});

;// ./node_modules/@sentry/browser-utils/build/esm/is.js
function isElement(wat) {
  if (typeof Element === "undefined") {
    return false;
  }
  try {
    return wat instanceof Element;
  } catch {
    return false;
  }
}


// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/htmlTreeAsString.js
var htmlTreeAsString = __webpack_require__(89972);
;// ./node_modules/@sentry/browser/build/npm/esm/prod/normalizeStringifyValue.js

const HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX = /^HTML(\w*)Element$/;
function normalizeStringifyValue(value) {
  if (typeof window !== "undefined" && value === window) {
    return "[Window]";
  }
  if (typeof document !== "undefined" && value === document) {
    return "[Document]";
  }
  if (isElement(value)) {
    const objName = getConstructorName(value);
    if (HTML_ELEMENT_CONSTRUCTOR_NAME_REGEX.test(objName)) {
      return `[HTMLElement: ${(0,htmlTreeAsString/* htmlTreeAsString */.H)(value)}]`;
    }
  }
  return void 0;
}
function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);
  return prototype?.constructor ? prototype.constructor.name : "null prototype";
}



/***/ }),

/***/ 4576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  w7: function() { return /* binding */ forceLoad; },
  nI: function() { return /* binding */ getDefaultIntegrations; },
  Ts: function() { return /* binding */ init; },
  kF: function() { return /* binding */ onLoad; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/integrations/eventFilters.js
var eventFilters = __webpack_require__(98748);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/integrations/functiontostring.js
var functiontostring = __webpack_require__(6111);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/integration.js
var integration = __webpack_require__(94893);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91302);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(42896);
;// ./node_modules/@sentry/core/build/esm/integrations/conversationId.js




const INTEGRATION_NAME = "ConversationId";
const _conversationIdIntegration = (() => {
  return {
    name: INTEGRATION_NAME,
    setup(client) {
      client.on("spanStart", (span) => {
        const scopeData = (0,currentScopes/* getCurrentScope */.o5)().getScopeData();
        const isolationScopeData = (0,currentScopes/* getIsolationScope */.rm)().getScopeData();
        const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
        if (conversationId) {
          const { op, data: attributes, description: name } = (0,spanUtils/* spanToJSON */.et)(span);
          if (!op?.startsWith("gen_ai.") && !attributes["ai.operationId"] && !name?.startsWith("ai.")) {
            return;
          }
          span.setAttribute(semanticAttributes/* GEN_AI_CONVERSATION_ID_ATTRIBUTE */.Fy, conversationId);
        }
      });
    }
  };
});
const conversationIdIntegration = (0,integration/* defineIntegration */._C)(_conversationIdIntegration);


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/integrations/dedupe.js
var dedupe = __webpack_require__(11360);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/stacktrace.js
var stacktrace = __webpack_require__(52992);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/normalize.js
var normalize = __webpack_require__(51830);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/sdk.js
var sdk = __webpack_require__(35427);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/client.js + 8 modules
var client = __webpack_require__(18369);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/breadcrumbs.js + 1 modules
var breadcrumbs = __webpack_require__(85148);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/browserapierrors.js
var browserapierrors = __webpack_require__(19647);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/browsersession.js
var browsersession = __webpack_require__(56576);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/culturecontext.js
var culturecontext = __webpack_require__(19157);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/globalhandlers.js
var globalhandlers = __webpack_require__(81094);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/httpcontext.js
var httpcontext = __webpack_require__(5293);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/linkederrors.js + 1 modules
var linkederrors = __webpack_require__(76618);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/stack-parsers.js
var stack_parsers = __webpack_require__(57693);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/transports/fetch.js
var fetch = __webpack_require__(29391);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/normalizeStringifyValue.js + 1 modules
var normalizeStringifyValue = __webpack_require__(83367);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-logger.js
var debug_logger = __webpack_require__(62183);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/browser.js
var browser = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/debug-build.js
var debug_build = __webpack_require__(76418);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/helpers.js
var helpers = __webpack_require__(89401);
;// ./node_modules/@sentry/browser/build/npm/esm/prod/utils/detectBrowserExtension.js



function checkAndWarnIfIsEmbeddedBrowserExtension() {
  if (_isEmbeddedBrowserExtension()) {
    if (debug_build/* DEBUG_BUILD */.T) {
      (0,debug_logger/* consoleSandbox */.pq)(() => {
        console.error(
          "[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/"
        );
      });
    }
    return true;
  }
  return false;
}
function _isEmbeddedBrowserExtension() {
  if (typeof helpers/* WINDOW */.jf.window === "undefined") {
    return false;
  }
  const _window = helpers/* WINDOW */.jf;
  if (_window.nw) {
    return false;
  }
  const extensionObject = _window["chrome"] || _window["browser"];
  if (!extensionObject?.runtime?.id) {
    return false;
  }
  const href = (0,browser/* getLocationHref */.$N)();
  const isDedicatedExtensionPage = helpers/* WINDOW */.jf === helpers/* WINDOW */.jf.top && /^(?:chrome-extension|moz-extension|ms-browser-extension|safari-web-extension):\/\//.test(href);
  return !isDedicatedExtensionPage;
}


;// ./node_modules/@sentry/browser/build/npm/esm/prod/sdk.js













function getDefaultIntegrations(_options) {
  return [
    // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
    // eslint-disable-next-line typescript/no-deprecated
    (0,eventFilters/* inboundFiltersIntegration */.D)(),
    (0,functiontostring/* functionToStringIntegration */.Z)(),
    conversationIdIntegration(),
    (0,browserapierrors/* browserApiErrorsIntegration */.G)(),
    (0,breadcrumbs/* breadcrumbsIntegration */.F)(),
    (0,globalhandlers/* globalHandlersIntegration */.LO)(),
    (0,linkederrors/* linkedErrorsIntegration */.p)(),
    (0,dedupe/* dedupeIntegration */.s)(),
    (0,httpcontext/* httpContextIntegration */.M)(),
    (0,culturecontext/* cultureContextIntegration */.y)(),
    (0,browsersession/* browserSessionIntegration */.p)()
  ];
}
function init(options = {}) {
  const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && checkAndWarnIfIsEmbeddedBrowserExtension();
  let defaultIntegrations = options.defaultIntegrations == null ? getDefaultIntegrations() : options.defaultIntegrations;
  const clientOptions = {
    ...options,
    enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.vk)(options.stackParser || stack_parsers/* defaultStackParser */.lG),
    integrations: (0,integration/* getIntegrationsToSetup */.mH)({
      integrations: options.integrations,
      defaultIntegrations
    }),
    transport: options.transport || fetch/* makeFetchTransport */._
  };
  (0,normalize/* setNormalizeStringifier */.Ip)(normalizeStringifyValue/* normalizeStringifyValue */.U);
  return (0,sdk/* initAndBind */.J)(client/* BrowserClient */.y, clientOptions);
}
function forceLoad() {
}
function onLoad(callback) {
  callback();
}



/***/ }),

/***/ 57693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52992);

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func === "<anonymous>" ? (/* inlined export .UNKNOWN_FUNCTION */"?") : func,
    in_app: true
    // All browser frames are considered in_app
  };
  if (lineno !== void 0) {
    frame.lineno = lineno;
  }
  if (colno !== void 0) {
    frame.colno = colno;
  }
  return frame;
}
const chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
const chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
const chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
const chromeStackParserFn = (line) => {
  const dataUriMatch = line.match(chromeDataUriRegex);
  if (dataUriMatch) {
    return {
      filename: `<data:${dataUriMatch[2]}>`,
      function: dataUriMatch[1]
    };
  }
  const noFnParts = chromeRegexNoFnName.exec(line);
  if (noFnParts) {
    const [, filename, line2, col] = noFnParts;
    return createFrame(filename, (/* inlined export .UNKNOWN_FUNCTION */"?"), +line2, +col);
  }
  const parts = chromeRegex.exec(line);
  if (parts) {
    const isEval = parts[2]?.indexOf("eval") === 0;
    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);
      if (subMatch) {
        parts[2] = subMatch[1];
        parts[3] = subMatch[2];
        parts[4] = subMatch[3];
      }
    }
    const [func, filename] = extractSafariExtensionDetails(parts[1] || (/* inlined export .UNKNOWN_FUNCTION */"?"), parts[2]);
    return createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
  }
  return;
};
const chromeStackLineParser = [CHROME_PRIORITY, chromeStackParserFn];
const geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const gecko = (line) => {
  const parts = geckoREgex.exec(line);
  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);
      if (subMatch) {
        parts[1] = parts[1] || "eval";
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = "";
      }
    }
    let filename = parts[3];
    let func = parts[1] || (/* inlined export .UNKNOWN_FUNCTION */"?");
    [func, filename] = extractSafariExtensionDetails(func, filename);
    return createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
  }
  return;
};
const geckoStackLineParser = [GECKO_PRIORITY, gecko];
const winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const winjs = (line) => {
  const parts = winjsRegex.exec(line);
  return parts ? createFrame(parts[2], parts[1] || (/* inlined export .UNKNOWN_FUNCTION */"?"), +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
};
const winjsStackLineParser = [WINJS_PRIORITY, winjs];
const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const opera10 = (line) => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || (/* inlined export .UNKNOWN_FUNCTION */"?"), +parts[1]) : void 0;
};
const opera10StackLineParser = [OPERA10_PRIORITY, opera10];
const opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const opera11 = (line) => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || (/* inlined export .UNKNOWN_FUNCTION */"?"), +parts[1], +parts[2]) : void 0;
};
const opera11StackLineParser = [OPERA11_PRIORITY, opera11];
const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser];
const defaultStackParser = (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .createStackParser */ .gd)(...defaultStackLineParsers);
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf("safari-extension") !== -1;
  const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
  return isSafariExtension || isSafariWebExtension ? [
    func.indexOf("@") !== -1 ? func.split("@")[0] : (/* inlined export .UNKNOWN_FUNCTION */"?"),
    isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
  ] : [func, filename];
};


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "$2", 0, /* binding */ winjsStackLineParser,
/* harmony export */   "Q_", 0, /* binding */ opera10StackLineParser,
/* harmony export */   "Vv", 0, /* binding */ opera11StackLineParser,
/* harmony export */   "Yj", 0, /* binding */ chromeStackLineParser,
/* harmony export */   "c9", 0, /* binding */ defaultStackLineParsers,
/* harmony export */   "dY", 0, /* binding */ geckoStackLineParser,
/* harmony export */   "lG", 0, /* binding */ defaultStackParser
/* harmony export */ ]);


/***/ }),

/***/ 22518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  dp: function() { return /* binding */ browserTracingIntegration; },
  e3: function() { return /* binding */ isBotUserAgent; },
  Nt: function() { return /* binding */ startBrowserTracingNavigationSpan; },
  Sx: function() { return /* binding */ startBrowserTracingPageLoadSpan; }
});

// UNUSED EXPORTS: BROWSER_TRACING_INTEGRATION_ID, getMetaContent, getServerTiming

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/debug-build.js
var debug_build = __webpack_require__(97169);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91302);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-logger.js
var debug_logger = __webpack_require__(62183);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/hasSpansEnabled.js
var hasSpansEnabled = __webpack_require__(91811);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/should-ignore-span.js
var should_ignore_span = __webpack_require__(90622);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanOnScope.js
var spanOnScope = __webpack_require__(99070);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(42896);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/time.js
var time = __webpack_require__(39612);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/sentryNonRecordingSpan.js
var sentryNonRecordingSpan = __webpack_require__(45729);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/sentrySpan.js
var sentrySpan = __webpack_require__(76303);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/trace.js + 1 modules
var trace = __webpack_require__(1523);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/utils.js
var utils = __webpack_require__(28175);
;// ./node_modules/@sentry/core/build/esm/tracing/idleSpan.js














const TRACING_DEFAULTS = {
  idleTimeout: 1e3,
  finalTimeout: 3e4,
  childSpanTimeout: 15e3
};
const FINISH_REASON_HEARTBEAT_FAILED = "heartbeatFailed";
const FINISH_REASON_IDLE_TIMEOUT = "idleTimeout";
const FINISH_REASON_FINAL_TIMEOUT = "finalTimeout";
const FINISH_REASON_EXTERNAL_FINISH = "externalFinish";
function startIdleSpan(startSpanOptions, options = {}) {
  const activities = /* @__PURE__ */ new Map();
  let _finished = false;
  let _idleTimeoutID;
  let _finishReason = FINISH_REASON_EXTERNAL_FINISH;
  let _autoFinishAllowed = !options.disableAutoFinish;
  const _cleanupHooks = [];
  const {
    idleTimeout = TRACING_DEFAULTS.idleTimeout,
    finalTimeout = TRACING_DEFAULTS.finalTimeout,
    childSpanTimeout = TRACING_DEFAULTS.childSpanTimeout,
    beforeSpanEnd,
    trimIdleSpanEndTimestamp = true
  } = options;
  const client = (0,currentScopes/* getClient */.KU)();
  const scope = (0,currentScopes/* getCurrentScope */.o5)();
  if (!client || !(0,hasSpansEnabled/* hasSpansEnabled */.f)()) {
    const span2 = new sentryNonRecordingSpan/* SentryNonRecordingSpan */.w({ traceId: scope.getPropagationContext().traceId });
    (0,utils/* setCapturedScopesOnSpan */.d_)(span2, scope, (0,currentScopes/* getIsolationScope */.rm)());
    return span2;
  }
  const previousActiveSpan = (0,spanUtils/* getActiveSpan */.Bk)();
  const span = _startIdleSpan(startSpanOptions);
  span.end = new Proxy(span.end, {
    apply(target, thisArg, args) {
      if (beforeSpanEnd) {
        beforeSpanEnd(span);
      }
      if ((0,sentryNonRecordingSpan/* spanIsNonRecordingSpan */.h)(thisArg)) {
        return;
      }
      const [definedEndTimestamp, ...rest] = args;
      const timestamp = definedEndTimestamp || (0,time/* timestampInSeconds */.zf)();
      const spanEndTimestamp = (0,spanUtils/* spanTimeInputToSeconds */.cI)(timestamp);
      const spans = (0,spanUtils/* getSpanDescendants */.xO)(span).filter((child) => child !== span);
      const spanJson = (0,spanUtils/* spanToJSON */.et)(span);
      if (!spans.length || !trimIdleSpanEndTimestamp) {
        onIdleSpanEnded(spanEndTimestamp);
        return Reflect.apply(target, thisArg, [spanEndTimestamp, ...rest]);
      }
      const ignoreSpans = client.getOptions().ignoreSpans;
      const latestSpanEndTimestamp = spans?.reduce((acc, current) => {
        const currentSpanJson = (0,spanUtils/* spanToJSON */.et)(current);
        if (!currentSpanJson.timestamp) {
          return acc;
        }
        if (ignoreSpans && (0,should_ignore_span/* shouldIgnoreSpan */.e)(
          { description: currentSpanJson.description, op: currentSpanJson.op, attributes: currentSpanJson.data },
          ignoreSpans
        )) {
          return acc;
        }
        return acc ? Math.max(acc, currentSpanJson.timestamp) : currentSpanJson.timestamp;
      }, void 0);
      const spanStartTimestamp = spanJson.start_timestamp;
      const endTimestamp = Math.min(
        spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1e3 : Infinity,
        Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity))
      );
      onIdleSpanEnded(endTimestamp);
      return Reflect.apply(target, thisArg, [endTimestamp, ...rest]);
    }
  });
  function _cancelIdleTimeout() {
    if (_idleTimeoutID) {
      clearTimeout(_idleTimeoutID);
      _idleTimeoutID = void 0;
    }
  }
  function _restartIdleTimeout(endTimestamp) {
    _cancelIdleTimeout();
    _idleTimeoutID = setTimeout(() => {
      if (!_finished && activities.size === 0 && _autoFinishAllowed) {
        _finishReason = FINISH_REASON_IDLE_TIMEOUT;
        span.end(endTimestamp);
      }
    }, idleTimeout);
  }
  function _restartChildSpanTimeout(endTimestamp) {
    _idleTimeoutID = setTimeout(() => {
      if (!_finished && _autoFinishAllowed) {
        _finishReason = FINISH_REASON_HEARTBEAT_FAILED;
        span.end(endTimestamp);
      }
    }, childSpanTimeout);
  }
  function _pushActivity(spanId) {
    _cancelIdleTimeout();
    activities.set(spanId, true);
    const endTimestamp = (0,time/* timestampInSeconds */.zf)();
    _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1e3);
  }
  function _popActivity(spanId) {
    if (activities.has(spanId)) {
      activities.delete(spanId);
    }
    if (activities.size === 0) {
      const endTimestamp = (0,time/* timestampInSeconds */.zf)();
      _restartIdleTimeout(endTimestamp + idleTimeout / 1e3);
    }
  }
  function onIdleSpanEnded(endTimestamp) {
    _finished = true;
    activities.clear();
    _cleanupHooks.forEach((cleanup) => cleanup());
    (0,spanOnScope/* _setSpanForScope */.r)(scope, previousActiveSpan);
    const spanJSON = (0,spanUtils/* spanToJSON */.et)(span);
    const { start_timestamp: startTimestamp } = spanJSON;
    if (!startTimestamp) {
      return;
    }
    const attributes = spanJSON.data;
    if (!attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON */.fs]) {
      span.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON */.fs, _finishReason);
    }
    const currentStatus = spanJSON.status;
    if (!currentStatus || currentStatus === "unknown") {
      span.setStatus({ code: (/* inlined export .SPAN_STATUS_OK */1) });
    }
    debug_logger/* debug */.Yz.log(`[Tracing] Idle span "${spanJSON.op}" finished`);
    const childSpans = (0,spanUtils/* getSpanDescendants */.xO)(span).filter((child) => child !== span);
    let discardedSpans = 0;
    childSpans.forEach((childSpan) => {
      if (childSpan.isRecording()) {
        childSpan.setStatus({ code: (/* inlined export .SPAN_STATUS_ERROR */2), message: "cancelled" });
        childSpan.end(endTimestamp);
        debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log("[Tracing] Cancelling span since span ended early", JSON.stringify(childSpan, void 0, 2));
      }
      const childSpanJSON = (0,spanUtils/* spanToJSON */.et)(childSpan);
      const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
      const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
      const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1e3;
      const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp <= timeoutWithMarginOfError;
      if (debug_build/* DEBUG_BUILD */.T) {
        const stringifiedSpan = JSON.stringify(childSpan, void 0, 2);
        if (!spanStartedBeforeIdleSpanEnd) {
          debug_logger/* debug */.Yz.log("[Tracing] Discarding span since it happened after idle span was finished", stringifiedSpan);
        } else if (!spanEndedBeforeFinalTimeout) {
          debug_logger/* debug */.Yz.log("[Tracing] Discarding span since it finished after idle span final timeout", stringifiedSpan);
        }
      }
      if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
        (0,spanUtils/* removeChildSpanFromSpan */.VS)(span, childSpan);
        discardedSpans++;
      }
    });
    if (discardedSpans > 0) {
      span.setAttribute("sentry.idle_span_discarded_spans", discardedSpans);
    }
  }
  _cleanupHooks.push(
    client.on("spanStart", (startedSpan) => {
      if (_finished || startedSpan === span || !!(0,spanUtils/* spanToJSON */.et)(startedSpan).timestamp || startedSpan instanceof sentrySpan/* SentrySpan */.W && startedSpan.isStandaloneSpan()) {
        return;
      }
      const allSpans = (0,spanUtils/* getSpanDescendants */.xO)(span);
      if (allSpans.includes(startedSpan)) {
        _pushActivity(startedSpan.spanContext().spanId);
      }
    })
  );
  _cleanupHooks.push(
    client.on("spanEnd", (endedSpan) => {
      if (_finished) {
        return;
      }
      _popActivity(endedSpan.spanContext().spanId);
    })
  );
  _cleanupHooks.push(
    client.on("idleSpanEnableAutoFinish", (spanToAllowAutoFinish) => {
      if (spanToAllowAutoFinish === span) {
        _autoFinishAllowed = true;
        _restartIdleTimeout();
        if (activities.size) {
          _restartChildSpanTimeout();
        }
      }
    })
  );
  if (!options.disableAutoFinish) {
    _restartIdleTimeout();
  }
  setTimeout(() => {
    if (!_finished) {
      span.setStatus({ code: (/* inlined export .SPAN_STATUS_ERROR */2), message: "deadline_exceeded" });
      _finishReason = FINISH_REASON_FINAL_TIMEOUT;
      span.end();
    }
  }, finalTimeout);
  return span;
}
function _startIdleSpan(options) {
  const span = (0,trace/* startInactiveSpan */.Uk)(options);
  (0,spanOnScope/* _setSpanForScope */.r)((0,currentScopes/* getCurrentScope */.o5)(), span);
  debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log("[Tracing] Started span is an idle span");
  return span;
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/spans/hasSpanStreamingEnabled.js
var hasSpanStreamingEnabled = __webpack_require__(97989);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/dynamicSamplingContext.js
var dynamicSamplingContext = __webpack_require__(49271);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/errors.js
var errors = __webpack_require__(25443);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/worldwide.js
var worldwide = __webpack_require__(70774);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/propagationContext.js
var utils_propagationContext = __webpack_require__(66508);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/tracing.js
var tracing = __webpack_require__(36779);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/browser.js
var browser = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/url.js
var url = __webpack_require__(77636);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/object.js
var object = __webpack_require__(50742);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/browserMetrics.js + 1 modules
var browserMetrics = __webpack_require__(60061);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/instrument/history.js
var instrument_history = __webpack_require__(19150);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/debug-build.js
var prod_debug_build = __webpack_require__(76418);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/helpers.js
var helpers = __webpack_require__(89401);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/fetchStreamPerformance.js
var fetchStreamPerformance = __webpack_require__(8590);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/integrations/webVitals.js + 2 modules
var webVitals = __webpack_require__(23492);
;// ./node_modules/@sentry/browser/build/npm/esm/prod/tracing/backgroundtab.js



function registerBackgroundTabDetection() {
  if (helpers/* WINDOW */.jf.document) {
    helpers/* WINDOW */.jf.document.addEventListener("visibilitychange", () => {
      const activeSpan = (0,spanUtils/* getActiveSpan */.Bk)();
      if (!activeSpan) {
        return;
      }
      const rootSpan = (0,spanUtils/* getRootSpan */.zU)(activeSpan);
      if (helpers/* WINDOW */.jf.document.hidden && rootSpan) {
        const cancelledStatus = "cancelled";
        const { op, status } = (0,spanUtils/* spanToJSON */.et)(rootSpan);
        if (prod_debug_build/* DEBUG_BUILD */.T) {
          debug_logger/* debug */.Yz.log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
        }
        if (!status) {
          rootSpan.setStatus({ code: (/* inlined export .SPAN_STATUS_ERROR */2), message: cancelledStatus });
        }
        rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
        rootSpan.end();
      }
    });
  } else {
    prod_debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn("[Tracing] Could not set up background tab detection due to lack of global document");
  }
}


;// ./node_modules/@sentry/browser/build/npm/esm/prod/tracing/linkedTraces.js












const PREVIOUS_TRACE_MAX_DURATION = 3600;
const PREVIOUS_TRACE_KEY = "sentry_previous_trace";
const PREVIOUS_TRACE_TMP_SPAN_ATTRIBUTE = "sentry.previous_trace";
function linkTraces(client, {
  linkPreviousTrace,
  consistentTraceSampling
}) {
  const useSessionStorage = linkPreviousTrace === "session-storage";
  let inMemoryPreviousTraceInfo = useSessionStorage ? getPreviousTraceFromSessionStorage() : void 0;
  client.on("spanStart", (span) => {
    if ((0,spanUtils/* getRootSpan */.zU)(span) !== span) {
      return;
    }
    const oldPropagationContext = (0,currentScopes/* getCurrentScope */.o5)().getPropagationContext();
    inMemoryPreviousTraceInfo = addPreviousTraceSpanLink(inMemoryPreviousTraceInfo, span, oldPropagationContext);
    if (useSessionStorage) {
      storePreviousTraceInSessionStorage(inMemoryPreviousTraceInfo);
    }
  });
  let isFirstTraceOnPageload = true;
  if (consistentTraceSampling) {
    client.on("beforeSampling", (mutableSamplingContextData) => {
      if (!inMemoryPreviousTraceInfo) {
        return;
      }
      const scope = (0,currentScopes/* getCurrentScope */.o5)();
      const currentPropagationContext = scope.getPropagationContext();
      if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
        isFirstTraceOnPageload = false;
        return;
      }
      scope.setPropagationContext({
        ...currentPropagationContext,
        dsc: {
          ...currentPropagationContext.dsc,
          sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
          sampled: String(spanContextSampled(inMemoryPreviousTraceInfo.spanContext))
        },
        sampleRand: inMemoryPreviousTraceInfo.sampleRand
      });
      mutableSamplingContextData.parentSampled = spanContextSampled(inMemoryPreviousTraceInfo.spanContext);
      mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
      mutableSamplingContextData.spanAttributes = {
        ...mutableSamplingContextData.spanAttributes,
        [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE */.Ef]: inMemoryPreviousTraceInfo.sampleRate
      };
    });
  }
}
function addPreviousTraceSpanLink(previousTraceInfo, span, oldPropagationContext) {
  const spanJson = (0,spanUtils/* spanToJSON */.et)(span);
  function getSampleRate() {
    try {
      const oldSampleRate = Number(
        spanJson.data?.[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */.sy] ?? oldPropagationContext.dsc?.sample_rate
      );
      return Number.isNaN(oldSampleRate) ? 0 : oldSampleRate;
    } catch {
      return 0;
    }
  }
  const updatedPreviousTraceInfo = {
    spanContext: span.spanContext(),
    startTimestamp: spanJson.start_timestamp,
    sampleRate: getSampleRate(),
    sampleRand: oldPropagationContext.sampleRand
  };
  if (!previousTraceInfo) {
    return updatedPreviousTraceInfo;
  }
  const previousTraceSpanCtx = previousTraceInfo.spanContext;
  if (previousTraceSpanCtx.traceId === spanJson.trace_id) {
    return previousTraceInfo;
  }
  if (Date.now() / 1e3 - previousTraceInfo.startTimestamp <= PREVIOUS_TRACE_MAX_DURATION) {
    if (prod_debug_build/* DEBUG_BUILD */.T) {
      debug_logger/* debug */.Yz.log(
        `Adding previous_trace \`${JSON.stringify(previousTraceSpanCtx)}\` link to span \`${JSON.stringify({
          op: spanJson.op,
          ...span.spanContext()
        })}\``
      );
    }
    span.addLink({
      context: previousTraceSpanCtx,
      attributes: {
        [semanticAttributes/* SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE */.Lc]: "previous_trace"
      }
    });
    span.setAttribute(
      PREVIOUS_TRACE_TMP_SPAN_ATTRIBUTE,
      `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${spanContextSampled(previousTraceSpanCtx) ? 1 : 0}`
    );
  }
  return updatedPreviousTraceInfo;
}
function storePreviousTraceInSessionStorage(previousTraceInfo) {
  try {
    helpers/* WINDOW */.jf.sessionStorage.setItem(PREVIOUS_TRACE_KEY, JSON.stringify(previousTraceInfo));
  } catch (e) {
    prod_debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn("Could not store previous trace in sessionStorage", e);
  }
}
function getPreviousTraceFromSessionStorage() {
  try {
    const previousTraceInfo = helpers/* WINDOW */.jf.sessionStorage?.getItem(PREVIOUS_TRACE_KEY);
    return JSON.parse(previousTraceInfo);
  } catch {
    return void 0;
  }
}
function spanContextSampled(ctx) {
  return ctx.traceFlags === 1;
}


// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/tracing/request.js + 2 modules
var request = __webpack_require__(99371);
;// ./node_modules/@sentry/browser/build/npm/esm/prod/tracing/browserTracingIntegration.js









const BROWSER_TRACING_INTEGRATION_ID = "BrowserTracing";
const BOT_USER_AGENT_RE = /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i;
function isBotUserAgent() {
  const nav = helpers/* WINDOW */.jf.navigator;
  if (!nav?.userAgent) {
    return false;
  }
  return BOT_USER_AGENT_RE.test(nav.userAgent);
}
const DEFAULT_BROWSER_TRACING_OPTIONS = {
  ...TRACING_DEFAULTS,
  instrumentNavigation: true,
  instrumentPageLoad: true,
  markBackgroundSpan: true,
  enableLongTask: true,
  enableLongAnimationFrame: true,
  enableInp: true,
  ignoreResourceSpans: [],
  ignorePerformanceApiSpans: [],
  detectRedirects: true,
  linkPreviousTrace: "in-memory",
  consistentTraceSampling: false,
  enableReportPageLoaded: false,
  _experiments: {},
  ...request/* defaultRequestInstrumentationOptions */.h$
};
const browserTracingIntegration = ((options = {}) => {
  if ("enableElementTiming" in options) {
    (0,debug_logger/* consoleSandbox */.pq)(() => {
      console.warn(
        "[Sentry] `enableElementTiming` is deprecated and no longer has any effect. Use the standalone `elementTimingIntegration` instead."
      );
    });
  }
  const latestRoute = {
    name: void 0,
    source: void 0
  };
  const optionalWindowDocument = helpers/* WINDOW */.jf.document;
  const {
    enableInp,
    enableLongTask,
    enableLongAnimationFrame,
    _experiments: { enableInteractions, enableStandaloneClsSpans, enableStandaloneLcpSpans },
    beforeStartSpan,
    idleTimeout,
    finalTimeout,
    childSpanTimeout,
    markBackgroundSpan,
    traceFetch,
    traceXHR,
    // eslint-disable-next-line typescript/no-deprecated
    trackFetchStreamPerformance,
    shouldCreateSpanForRequest,
    enableHTTPTimings,
    ignoreResourceSpans,
    ignorePerformanceApiSpans,
    instrumentPageLoad,
    instrumentNavigation,
    detectRedirects,
    linkPreviousTrace,
    consistentTraceSampling,
    enableReportPageLoaded,
    onRequestSpanStart,
    onRequestSpanEnd
  } = {
    ...DEFAULT_BROWSER_TRACING_OPTIONS,
    ...options
  };
  const _isBot = isBotUserAgent();
  let lastInteractionTimestamp;
  let _pageloadSpan;
  function _createRouteSpan(client, startSpanOptions, makeActive = true) {
    const isPageloadSpan = startSpanOptions.op === "pageload";
    const initialSpanName = startSpanOptions.name;
    const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
    const attributes = finalStartSpanOptions.attributes || {};
    if (initialSpanName !== finalStartSpanOptions.name) {
      attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.i_] = "custom";
      finalStartSpanOptions.attributes = attributes;
    }
    if (!makeActive) {
      const now = (0,time/* dateTimestampInSeconds */.lu)();
      (0,trace/* startInactiveSpan */.Uk)({
        ...finalStartSpanOptions,
        startTime: now
      }).end(now);
      return;
    }
    latestRoute.name = finalStartSpanOptions.name;
    latestRoute.source = attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.i_];
    const idleSpan = startIdleSpan(finalStartSpanOptions, {
      idleTimeout,
      finalTimeout,
      childSpanTimeout,
      // should wait for finish signal if it's a pageload transaction
      disableAutoFinish: isPageloadSpan,
      beforeSpanEnd: (span) => {
        (0,browserMetrics/* addPerformanceEntries */.QU)(span, {
          ignoreResourceSpans,
          ignorePerformanceApiSpans,
          spanStreamingEnabled: (0,hasSpanStreamingEnabled/* hasSpanStreamingEnabled */.K)(client)
        });
        setActiveIdleSpan(client, void 0);
        const scope = (0,currentScopes/* getCurrentScope */.o5)();
        const oldPropagationContext = scope.getPropagationContext();
        scope.setPropagationContext({
          ...oldPropagationContext,
          traceId: idleSpan.spanContext().traceId,
          sampled: (0,spanUtils/* spanIsSampled */.pK)(idleSpan),
          dsc: (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.k1)(span)
        });
        if (isPageloadSpan) {
          _pageloadSpan = void 0;
        }
      },
      trimIdleSpanEndTimestamp: !enableReportPageLoaded
    });
    if (isPageloadSpan && enableReportPageLoaded) {
      _pageloadSpan = idleSpan;
    }
    setActiveIdleSpan(client, idleSpan);
    function emitFinish() {
      if (optionalWindowDocument && ["interactive", "complete"].includes(optionalWindowDocument.readyState)) {
        client.emit("idleSpanEnableAutoFinish", idleSpan);
        optionalWindowDocument.removeEventListener("readystatechange", emitFinish);
      }
    }
    if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
      optionalWindowDocument.addEventListener("readystatechange", emitFinish);
      emitFinish();
    }
  }
  return {
    name: BROWSER_TRACING_INTEGRATION_ID,
    setup(client) {
      if (_isBot) {
        prod_debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log("[Tracing] Skipping browserTracingIntegration setup for bot user agent.");
        return;
      }
      (0,errors/* registerSpanErrorInstrumentation */.s)();
      if (enableLongAnimationFrame && worldwide/* GLOBAL_OBJ */.O.PerformanceObserver && PerformanceObserver.supportedEntryTypes?.includes("long-animation-frame")) {
        (0,browserMetrics/* startTrackingLongAnimationFrames */.U$)();
      } else if (enableLongTask) {
        (0,browserMetrics/* startTrackingLongTasks */.c8)();
      }
      if (enableInteractions) {
        (0,browserMetrics/* startTrackingInteractions */.DI)();
      }
      if (detectRedirects && optionalWindowDocument) {
        const interactionHandler = () => {
          lastInteractionTimestamp = (0,time/* timestampInSeconds */.zf)();
        };
        addEventListener("click", interactionHandler, { capture: true });
        addEventListener("keydown", interactionHandler, { capture: true, passive: true });
      }
      function maybeEndActiveSpan() {
        const activeSpan = getActiveIdleSpan(client);
        if (activeSpan && !(0,spanUtils/* spanToJSON */.et)(activeSpan).timestamp) {
          prod_debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log(`[Tracing] Finishing current active span with op: ${(0,spanUtils/* spanToJSON */.et)(activeSpan).op}`);
          activeSpan.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON */.fs, "cancelled");
          activeSpan.end();
        }
      }
      client.on("startNavigationSpan", (startSpanOptions, navigationOptions) => {
        if ((0,currentScopes/* getClient */.KU)() !== client) {
          return;
        }
        if (navigationOptions?.isRedirect) {
          prod_debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span.");
          _createRouteSpan(
            client,
            {
              op: "navigation.redirect",
              ...startSpanOptions
            },
            false
          );
          return;
        }
        lastInteractionTimestamp = void 0;
        maybeEndActiveSpan();
        (0,currentScopes/* getIsolationScope */.rm)().setPropagationContext({
          traceId: (0,utils_propagationContext/* generateTraceId */.e)(),
          sampleRand: Math.random(),
          propagationSpanId: (0,hasSpansEnabled/* hasSpansEnabled */.f)() ? void 0 : (0,utils_propagationContext/* generateSpanId */.Z)()
        });
        const scope = (0,currentScopes/* getCurrentScope */.o5)();
        scope.setPropagationContext({
          traceId: (0,utils_propagationContext/* generateTraceId */.e)(),
          sampleRand: Math.random(),
          propagationSpanId: (0,hasSpansEnabled/* hasSpansEnabled */.f)() ? void 0 : (0,utils_propagationContext/* generateSpanId */.Z)()
        });
        scope.setSDKProcessingMetadata({
          normalizedRequest: void 0
        });
        _createRouteSpan(client, {
          op: "navigation",
          ...startSpanOptions,
          // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
          parentSpan: null,
          forceTransaction: true
        });
      });
      client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {}) => {
        if ((0,currentScopes/* getClient */.KU)() !== client) {
          return;
        }
        maybeEndActiveSpan();
        const sentryTrace = traceOptions.sentryTrace || getMetaContent("sentry-trace") || getServerTiming("sentry-trace");
        const baggage = traceOptions.baggage || getMetaContent("baggage") || getServerTiming("baggage");
        const propagationContext = (0,tracing/* propagationContextFromHeaders */.kM)(sentryTrace, baggage);
        const scope = (0,currentScopes/* getCurrentScope */.o5)();
        scope.setPropagationContext(propagationContext);
        if (!(0,hasSpansEnabled/* hasSpansEnabled */.f)()) {
          scope.getPropagationContext().propagationSpanId = (0,utils_propagationContext/* generateSpanId */.Z)();
        }
        scope.setSDKProcessingMetadata({
          normalizedRequest: (0,helpers/* getHttpRequestData */.AP)()
        });
        _createRouteSpan(client, {
          op: "pageload",
          ...startSpanOptions
        });
      });
      client.on("endPageloadSpan", () => {
        if (enableReportPageLoaded && _pageloadSpan) {
          _pageloadSpan.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON */.fs, "reportPageLoaded");
          _pageloadSpan.end();
        }
      });
    },
    afterAllSetup(client) {
      if (_isBot) {
        return;
      }
      if (client.addIntegration && !client.getIntegrationByName?.(webVitals/* WEB_VITALS_INTEGRATION_NAME */.Q)) {
        client.addIntegration(
          (0,webVitals/* webVitalsIntegration */.K)({
            ignore: enableInp ? [] : ["inp"],
            _experiments: {
              enableStandaloneClsSpans,
              enableStandaloneLcpSpans
            }
          })
        );
      }
      let startingUrl = (0,browser/* getLocationHref */.$N)();
      if (linkPreviousTrace !== "off") {
        linkTraces(client, { linkPreviousTrace, consistentTraceSampling });
      }
      if (helpers/* WINDOW */.jf.location) {
        if (instrumentPageLoad) {
          const origin = (0,time/* browserPerformanceTimeOrigin */.k3)();
          startBrowserTracingPageLoadSpan(client, {
            name: helpers/* WINDOW */.jf.location.pathname,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTime: origin ? origin / 1e3 : void 0,
            attributes: {
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.i_]: "url",
              [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.pageload.browser"
            }
          });
        }
        if (instrumentNavigation) {
          (0,instrument_history/* addHistoryInstrumentationHandler */._)(({ to, from }) => {
            if (from === void 0 && startingUrl?.indexOf(to) !== -1) {
              startingUrl = void 0;
              return;
            }
            startingUrl = void 0;
            const parsed = (0,url/* parseStringToURLObject */.kg)(to);
            const activeSpan = getActiveIdleSpan(client);
            const navigationIsRedirect = activeSpan && detectRedirects && isRedirect(activeSpan, lastInteractionTimestamp);
            startBrowserTracingNavigationSpan(
              client,
              {
                name: parsed?.pathname || helpers/* WINDOW */.jf.location.pathname,
                attributes: {
                  [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.i_]: "url",
                  [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.navigation.browser"
                }
              },
              { url: to, isRedirect: navigationIsRedirect }
            );
          });
        }
      }
      if (markBackgroundSpan) {
        registerBackgroundTabDetection();
      }
      if (enableInteractions) {
        registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
      }
      (0,request/* instrumentOutgoingRequests */.Qb)(client, {
        traceFetch,
        traceXHR,
        tracePropagationTargets: client.getOptions().tracePropagationTargets,
        shouldCreateSpanForRequest,
        enableHTTPTimings,
        onRequestSpanStart,
        onRequestSpanEnd
      });
      if (trackFetchStreamPerformance) {
        client.addIntegration((0,fetchStreamPerformance/* fetchStreamPerformanceIntegration */.z)());
      }
    }
  };
});
function startBrowserTracingPageLoadSpan(client, spanOptions, traceOptions) {
  client.emit("startPageLoadSpan", spanOptions, traceOptions);
  (0,currentScopes/* getCurrentScope */.o5)().setTransactionName(spanOptions.name);
  const pageloadSpan = getActiveIdleSpan(client);
  if (pageloadSpan) {
    client.emit("afterStartPageLoadSpan", pageloadSpan);
  }
  return pageloadSpan;
}
function startBrowserTracingNavigationSpan(client, spanOptions, options) {
  const { url, isRedirect: isRedirect2 } = options || {};
  client.emit("beforeStartNavigationSpan", spanOptions, { isRedirect: isRedirect2 });
  client.emit("startNavigationSpan", spanOptions, { isRedirect: isRedirect2 });
  const scope = (0,currentScopes/* getCurrentScope */.o5)();
  scope.setTransactionName(spanOptions.name);
  if (url && !isRedirect2) {
    scope.setSDKProcessingMetadata({
      normalizedRequest: {
        ...(0,helpers/* getHttpRequestData */.AP)(),
        url
      }
    });
  }
  return getActiveIdleSpan(client);
}
function getMetaContent(metaName) {
  const optionalWindowDocument = helpers/* WINDOW */.jf.document;
  const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
  return metaTag?.getAttribute("content") || void 0;
}
function getServerTiming(name) {
  const navigation = helpers/* WINDOW */.jf.performance?.getEntriesByType?.("navigation")[0];
  const entry = navigation?.serverTiming?.find((entry2) => entry2.name === name);
  return entry?.description;
}
function registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
  const optionalWindowDocument = helpers/* WINDOW */.jf.document;
  let inflightInteractionSpan;
  const registerInteractionTransaction = () => {
    const op = "ui.action.click";
    const activeIdleSpan = getActiveIdleSpan(client);
    if (activeIdleSpan) {
      const currentRootSpanOp = (0,spanUtils/* spanToJSON */.et)(activeIdleSpan).op;
      if (["navigation", "pageload"].includes(currentRootSpanOp)) {
        prod_debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
        return void 0;
      }
    }
    if (inflightInteractionSpan) {
      inflightInteractionSpan.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON */.fs, "interactionInterrupted");
      inflightInteractionSpan.end();
      inflightInteractionSpan = void 0;
    }
    if (!latestRoute.name) {
      prod_debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
      return void 0;
    }
    inflightInteractionSpan = startIdleSpan(
      {
        name: latestRoute.name,
        op,
        attributes: {
          [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.i_]: latestRoute.source || "url"
        }
      },
      {
        idleTimeout,
        finalTimeout,
        childSpanTimeout
      }
    );
  };
  if (optionalWindowDocument) {
    addEventListener("click", registerInteractionTransaction, { capture: true });
  }
}
const ACTIVE_IDLE_SPAN_PROPERTY = "_sentry_idleSpan";
function getActiveIdleSpan(client) {
  return client[ACTIVE_IDLE_SPAN_PROPERTY];
}
function setActiveIdleSpan(client, span) {
  (0,object/* addNonEnumerableProperty */.my)(client, ACTIVE_IDLE_SPAN_PROPERTY, span);
}
const REDIRECT_THRESHOLD = 1.5;
function isRedirect(activeSpan, lastInteractionTimestamp) {
  const spanData = (0,spanUtils/* spanToJSON */.et)(activeSpan);
  const now = (0,time/* dateTimestampInSeconds */.lu)();
  const startTimestamp = spanData.start_timestamp;
  if (now - startTimestamp > REDIRECT_THRESHOLD) {
    return false;
  }
  if (lastInteractionTimestamp && now - lastInteractionTimestamp <= REDIRECT_THRESHOLD) {
    return false;
  }
  return true;
}



/***/ }),

/***/ 99371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  h$: function() { return /* binding */ defaultRequestInstrumentationOptions; },
  Qb: function() { return /* binding */ instrumentOutgoingRequests; }
});

// UNUSED EXPORTS: shouldAttachHeaders

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/instrument/fetch.js
var fetch = __webpack_require__(42793);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91302);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(42896);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/spanstatus.js
var spanstatus = __webpack_require__(20950);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/is.js
var is = __webpack_require__(91973);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/hasSpansEnabled.js
var hasSpansEnabled = __webpack_require__(91811);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/sentryNonRecordingSpan.js
var sentryNonRecordingSpan = __webpack_require__(45729);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/baggage.js
var baggage = __webpack_require__(94787);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/spans/hasSpanStreamingEnabled.js
var hasSpanStreamingEnabled = __webpack_require__(97989);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/trace.js + 1 modules
var trace = __webpack_require__(1523);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/traceData.js
var traceData = __webpack_require__(51096);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/url.js
var utils_url = __webpack_require__(77636);
;// ./node_modules/@sentry/core/build/esm/fetch.js












function instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOriginOrOptions) {
  if (!handlerData.fetchData) {
    return void 0;
  }
  const { method, url } = handlerData.fetchData;
  const shouldCreateSpanResult = (0,hasSpansEnabled/* hasSpansEnabled */.f)() && shouldCreateSpan(url);
  if (handlerData.endTimestamp) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;
    const span2 = spans[spanId];
    if (span2) {
      if (shouldCreateSpanResult) {
        endSpan(span2, handlerData);
        _callOnRequestSpanEnd(span2, handlerData, spanOriginOrOptions);
      }
      delete spans[spanId];
    }
    return void 0;
  }
  const { spanOrigin = "auto.http.browser", propagateTraceparent = false } = typeof spanOriginOrOptions === "object" ? spanOriginOrOptions : { spanOrigin: spanOriginOrOptions };
  const client = (0,currentScopes/* getClient */.KU)();
  const hasParent = !!(0,spanUtils/* getActiveSpan */.Bk)();
  const shouldEmitSpan = hasParent || !!client && (0,hasSpanStreamingEnabled/* hasSpanStreamingEnabled */.K)(client);
  const span = shouldCreateSpanResult && shouldEmitSpan ? (0,trace/* startInactiveSpan */.Uk)(getSpanStartOptions(url, method, spanOrigin)) : new sentryNonRecordingSpan/* SentryNonRecordingSpan */.w();
  if (shouldCreateSpanResult && !shouldEmitSpan) {
    client?.recordDroppedEvent("no_parent_span", "span");
  }
  handlerData.fetchData.__span = span.spanContext().spanId;
  spans[span.spanContext().spanId] = span;
  if (shouldAttachHeaders(handlerData.fetchData.url)) {
    const request = handlerData.args[0];
    const options = { ...handlerData.args[1] || {} };
    const headers = _INTERNAL_getTracingHeadersForFetchRequest(
      request,
      options,
      // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
      // we do not want to use the span as base for the trace headers,
      // which means that the headers will be generated from the scope and the sampling decision is deferred
      (0,hasSpansEnabled/* hasSpansEnabled */.f)() && shouldEmitSpan ? span : void 0,
      propagateTraceparent
    );
    if (headers) {
      handlerData.args[1] = options;
      options.headers = headers;
    }
  }
  if (client) {
    const fetchHint = {
      input: handlerData.args,
      response: handlerData.response,
      startTimestamp: handlerData.startTimestamp,
      endTimestamp: handlerData.endTimestamp
    };
    client.emit("beforeOutgoingRequestSpan", span, fetchHint);
  }
  return span;
}
function _callOnRequestSpanEnd(span, handlerData, spanOriginOrOptions) {
  const onRequestSpanEnd = typeof spanOriginOrOptions === "object" && spanOriginOrOptions !== null ? spanOriginOrOptions.onRequestSpanEnd : void 0;
  onRequestSpanEnd?.(span, {
    headers: handlerData.response?.headers,
    error: handlerData.error
  });
}
function _INTERNAL_getTracingHeadersForFetchRequest(request, fetchOptionsObj, span, propagateTraceparent) {
  const traceHeaders = (0,traceData/* getTraceData */.i)({ span, propagateTraceparent });
  const sentryTrace = traceHeaders["sentry-trace"];
  const baggage = traceHeaders.baggage;
  const traceparent = traceHeaders.traceparent;
  if (!sentryTrace) {
    return void 0;
  }
  const originalHeaders = fetchOptionsObj.headers || ((0,is/* isRequest */.ks)(request) ? request.headers : void 0);
  if (!originalHeaders) {
    return { ...traceHeaders };
  } else if (isHeaders(originalHeaders)) {
    const newHeaders = new Headers(originalHeaders);
    if (!newHeaders.get("sentry-trace")) {
      newHeaders.set("sentry-trace", sentryTrace);
    }
    if (propagateTraceparent && traceparent && !newHeaders.get("traceparent")) {
      newHeaders.set("traceparent", traceparent);
    }
    if (baggage) {
      const prevBaggageHeader = newHeaders.get("baggage");
      if (!prevBaggageHeader) {
        newHeaders.set("baggage", baggage);
      } else if (!baggageHeaderHasSentryBaggageValues(prevBaggageHeader)) {
        newHeaders.set("baggage", `${prevBaggageHeader},${baggage}`);
      }
    }
    return newHeaders;
  } else if (isHeadersInitTupleArray(originalHeaders)) {
    const newHeaders = [...originalHeaders];
    if (!newHeaders.find((header) => header[0] === "sentry-trace")) {
      newHeaders.push(["sentry-trace", sentryTrace]);
    }
    if (propagateTraceparent && traceparent && !newHeaders.find((header) => header[0] === "traceparent")) {
      newHeaders.push(["traceparent", traceparent]);
    }
    const prevBaggageHeaderWithSentryValues = originalHeaders.find(
      (header) => header[0] === "baggage" && typeof header[1] === "string" && baggageHeaderHasSentryBaggageValues(header[1])
    );
    if (baggage && !prevBaggageHeaderWithSentryValues) {
      newHeaders.push(["baggage", baggage]);
    }
    return newHeaders;
  } else {
    const existingSentryTraceHeader = "sentry-trace" in originalHeaders ? originalHeaders["sentry-trace"] : void 0;
    const existingTraceparentHeader = "traceparent" in originalHeaders ? originalHeaders.traceparent : void 0;
    const existingBaggageHeader = "baggage" in originalHeaders ? originalHeaders.baggage : void 0;
    const newBaggageHeaders = existingBaggageHeader ? Array.isArray(existingBaggageHeader) ? [...existingBaggageHeader] : [existingBaggageHeader] : [];
    const prevBaggageHeaderWithSentryValues = existingBaggageHeader && (Array.isArray(existingBaggageHeader) ? existingBaggageHeader.find((headerItem) => baggageHeaderHasSentryBaggageValues(headerItem)) : baggageHeaderHasSentryBaggageValues(existingBaggageHeader));
    if (baggage && !prevBaggageHeaderWithSentryValues) {
      newBaggageHeaders.push(baggage);
    }
    const newHeaders = Object.assign({}, originalHeaders, {
      "sentry-trace": existingSentryTraceHeader ?? sentryTrace,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(",") : void 0
    });
    if (propagateTraceparent && traceparent && !existingTraceparentHeader) {
      newHeaders.traceparent = traceparent;
    }
    return newHeaders;
  }
}
function endSpan(span, handlerData) {
  if (handlerData.response) {
    (0,spanstatus/* setHttpStatus */.N)(span, handlerData.response.status);
    const contentLength = handlerData.response?.headers?.get("content-length");
    if (contentLength) {
      const contentLengthNum = parseInt(contentLength);
      if (contentLengthNum > 0) {
        span.setAttribute("http.response_content_length", contentLengthNum);
      }
    }
  } else if (handlerData.error) {
    span.setStatus({ code: (/* inlined export .SPAN_STATUS_ERROR */2), message: "internal_error" });
  }
  span.end();
}
function baggageHeaderHasSentryBaggageValues(baggageHeader) {
  if (typeof baggageHeader !== "string") {
    return false;
  }
  return baggageHeader.split(",").some((baggageEntry) => baggageEntry.trim().startsWith(baggage/* SENTRY_BAGGAGE_KEY_PREFIX */.sv));
}
function isHeaders(headers) {
  return typeof Headers !== "undefined" && (0,is/* isInstanceOf */.tH)(headers, Headers);
}
function isHeadersInitTupleArray(headers) {
  if (!Array.isArray(headers)) {
    return false;
  }
  return headers.every(
    (item) => Array.isArray(item) && item.length === 2 && typeof item[0] === "string"
  );
}
function getSpanStartOptions(url, method, spanOrigin) {
  if (url.startsWith("data:")) {
    const sanitizedUrl2 = (0,utils_url/* stripDataUrlContent */.zm)(url);
    return {
      name: `${method} ${sanitizedUrl2}`,
      attributes: getFetchSpanAttributes(url, void 0, method, spanOrigin)
    };
  }
  const parsedUrl = (0,utils_url/* parseStringToURLObject */.kg)(url);
  const sanitizedUrl = parsedUrl ? (0,utils_url/* getSanitizedUrlStringFromUrlObject */.CH)(parsedUrl) : url;
  return {
    name: `${method} ${sanitizedUrl}`,
    attributes: getFetchSpanAttributes(url, parsedUrl, method, spanOrigin)
  };
}
function getFetchSpanAttributes(url, parsedUrl, method, spanOrigin) {
  const attributes = {
    url: (0,utils_url/* stripDataUrlContent */.zm)(url),
    type: "fetch",
    "http.method": method,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: spanOrigin,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.uT]: "http.client"
  };
  if (parsedUrl) {
    if (!(0,utils_url/* isURLObjectRelative */.nt)(parsedUrl)) {
      attributes["http.url"] = (0,utils_url/* stripDataUrlContent */.zm)(parsedUrl.href);
      attributes["server.address"] = parsedUrl.host;
    }
    if (parsedUrl.search) {
      attributes["http.query"] = parsedUrl.search;
    }
    if (parsedUrl.hash) {
      attributes["http.fragment"] = parsedUrl.hash;
    }
  }
  return attributes;
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/time.js
var time = __webpack_require__(39612);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/browser.js
var browser = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/string.js
var string = __webpack_require__(26228);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/instrument/xhr.js
var instrument_xhr = __webpack_require__(7440);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/instrument.js + 15 modules
var instrument = __webpack_require__(33731);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/resourceTiming.js
var resourceTiming = __webpack_require__(78280);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/networkUtils.js
var networkUtils = __webpack_require__(99323);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/helpers.js
var helpers = __webpack_require__(89401);
;// ./node_modules/@sentry/browser/build/npm/esm/prod/tracing/utils.js

function baggageHeaderHasSentryValues(baggageHeader) {
  return baggageHeader.split(",").some((value) => value.trim().startsWith("sentry-"));
}
function getFullURL(url) {
  try {
    const parsed = new URL(url, helpers/* WINDOW */.jf.location.origin);
    return parsed.href;
  } catch {
    return void 0;
  }
}
function isPerformanceResourceTiming(entry) {
  return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
function createHeadersSafely(headers) {
  try {
    return new Headers(headers);
  } catch {
    return void 0;
  }
}


;// ./node_modules/@sentry/browser/build/npm/esm/prod/tracing/request.js



const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  enableHTTPTimings: true,
  trackFetchStreamPerformance: false
};
function instrumentOutgoingRequests(client, _options) {
  const {
    traceFetch,
    traceXHR,
    shouldCreateSpanForRequest,
    enableHTTPTimings,
    tracePropagationTargets,
    onRequestSpanStart,
    onRequestSpanEnd
  } = {
    ...defaultRequestInstrumentationOptions,
    ..._options
  };
  const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_) => true;
  const shouldAttachHeadersWithTargets = (url) => shouldAttachHeaders(url, tracePropagationTargets);
  const spans = {};
  const propagateTraceparent = client.getOptions().propagateTraceparent;
  if (traceFetch) {
    (0,fetch/* addFetchInstrumentationHandler */.ur)((handlerData) => {
      const createdSpan = instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
        propagateTraceparent,
        onRequestSpanEnd
      });
      if (createdSpan) {
        const fullUrl = getFullURL(handlerData.fetchData.url);
        const host = fullUrl ? (0,utils_url/* parseUrl */.Dl)(fullUrl).host : void 0;
        const sanitizedFullUrl = fullUrl ? (0,utils_url/* stripDataUrlContent */.zm)(fullUrl) : void 0;
        createdSpan.setAttributes({
          "http.url": sanitizedFullUrl,
          // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
          // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
          "url.full": sanitizedFullUrl,
          "server.address": host
        });
        if (enableHTTPTimings) {
          addHTTPTimings(createdSpan, client);
        }
        onRequestSpanStart?.(createdSpan, { headers: handlerData.headers });
      }
    });
  }
  if (traceXHR) {
    (0,instrument_xhr/* addXhrInstrumentationHandler */.Mn)((handlerData) => {
      const createdSpan = xhrCallback(
        handlerData,
        shouldCreateSpan,
        shouldAttachHeadersWithTargets,
        spans,
        propagateTraceparent,
        onRequestSpanEnd
      );
      if (createdSpan) {
        if (enableHTTPTimings) {
          addHTTPTimings(createdSpan, client);
        }
        onRequestSpanStart?.(createdSpan, {
          headers: createHeadersSafely(handlerData.xhr.__sentry_xhr_v3__?.request_headers)
        });
      }
    });
  }
}
const HTTP_TIMING_WAIT_MS = 300;
function addHTTPTimings(span, client) {
  const { url } = (0,spanUtils/* spanToJSON */.et)(span).data;
  if (!url || typeof url !== "string") {
    return;
  }
  let onEntryFound = () => void setTimeout(unsubscribePerformanceObsever);
  if ((0,hasSpanStreamingEnabled/* hasSpanStreamingEnabled */.K)(client)) {
    const originalEnd = span.end.bind(span);
    span.end = (endTimestamp) => {
      const capturedEndTimestamp = endTimestamp ?? (0,time/* timestampInSeconds */.zf)();
      let isEnded = false;
      const endSpanAndCleanup = () => {
        if (isEnded) {
          return;
        }
        isEnded = true;
        setTimeout(unsubscribePerformanceObsever);
        originalEnd(capturedEndTimestamp);
        clearTimeout(fallbackTimeout);
      };
      onEntryFound = endSpanAndCleanup;
      const fallbackTimeout = setTimeout(endSpanAndCleanup, HTTP_TIMING_WAIT_MS);
    };
  }
  const unsubscribePerformanceObsever = (0,instrument/* addPerformanceInstrumentationHandler */.wv)("resource", ({ entries }) => {
    entries.forEach((entry) => {
      if (isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
        span.setAttributes((0,resourceTiming/* resourceTimingToSpanAttributes */.v)(entry));
        onEntryFound();
      }
    });
  });
}
function shouldAttachHeaders(targetUrl, tracePropagationTargets) {
  const href = (0,browser/* getLocationHref */.$N)();
  if (!href) {
    const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
    if (!tracePropagationTargets) {
      return isRelativeSameOriginRequest;
    } else {
      return (0,string/* stringMatchesSomePattern */.Xr)(targetUrl, tracePropagationTargets);
    }
  } else {
    let resolvedUrl;
    let currentOrigin;
    try {
      resolvedUrl = new URL(targetUrl, href);
      currentOrigin = new URL(href).origin;
    } catch {
      return false;
    }
    const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
    if (!tracePropagationTargets) {
      return isSameOriginRequest;
    } else {
      return (0,string/* stringMatchesSomePattern */.Xr)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0,string/* stringMatchesSomePattern */.Xr)(resolvedUrl.pathname, tracePropagationTargets);
    }
  }
}
function xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders2, spans, propagateTraceparent, onRequestSpanEnd) {
  const xhr = handlerData.xhr;
  const sentryXhrData = xhr?.[instrument_xhr/* SENTRY_XHR_DATA_KEY */.Er];
  if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) {
    return void 0;
  }
  const { url, method } = sentryXhrData;
  const shouldCreateSpanResult = (0,hasSpansEnabled/* hasSpansEnabled */.f)() && shouldCreateSpan(url);
  if (handlerData.endTimestamp) {
    const spanId = xhr.__sentry_xhr_span_id__;
    if (!spanId) return;
    const span2 = spans[spanId];
    if (span2) {
      if (shouldCreateSpanResult && sentryXhrData.status_code !== void 0) {
        (0,spanstatus/* setHttpStatus */.N)(span2, sentryXhrData.status_code);
        span2.end();
        onRequestSpanEnd?.(span2, {
          headers: createHeadersSafely((0,networkUtils/* parseXhrResponseHeaders */.ti)(xhr)),
          error: handlerData.error
        });
      }
      delete spans[spanId];
    }
    return void 0;
  }
  const fullUrl = getFullURL(url);
  const parsedUrl = fullUrl ? (0,utils_url/* parseUrl */.Dl)(fullUrl) : (0,utils_url/* parseUrl */.Dl)(url);
  const sanitizedFullUrl = fullUrl ? (0,utils_url/* stripDataUrlContent */.zm)(fullUrl) : void 0;
  const urlForSpanName = (0,utils_url/* stripDataUrlContent */.zm)((0,utils_url/* stripUrlQueryAndFragment */.f)(url));
  const client = (0,currentScopes/* getClient */.KU)();
  const hasParent = !!(0,spanUtils/* getActiveSpan */.Bk)();
  const shouldEmitSpan = hasParent || !!client && (0,hasSpanStreamingEnabled/* hasSpanStreamingEnabled */.K)(client);
  const span = shouldCreateSpanResult && shouldEmitSpan ? (0,trace/* startInactiveSpan */.Uk)({
    name: `${method} ${urlForSpanName}`,
    attributes: {
      url: (0,utils_url/* stripDataUrlContent */.zm)(url),
      type: "xhr",
      "http.method": method,
      "http.url": sanitizedFullUrl,
      // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
      // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
      "url.full": sanitizedFullUrl,
      "server.address": parsedUrl?.host,
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.JD]: "auto.http.browser",
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.uT]: "http.client",
      ...parsedUrl?.search && { "http.query": parsedUrl?.search },
      ...parsedUrl?.hash && { "http.fragment": parsedUrl?.hash }
    }
  }) : new sentryNonRecordingSpan/* SentryNonRecordingSpan */.w();
  if (shouldCreateSpanResult && !shouldEmitSpan) {
    client?.recordDroppedEvent("no_parent_span", "span");
  }
  xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
  spans[xhr.__sentry_xhr_span_id__] = span;
  if (shouldAttachHeaders2(url)) {
    addTracingHeadersToXhrRequest(
      xhr,
      // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
      // we do not want to use the span as base for the trace headers,
      // which means that the headers will be generated from the scope and the sampling decision is deferred
      (0,hasSpansEnabled/* hasSpansEnabled */.f)() && shouldEmitSpan ? span : void 0,
      propagateTraceparent
    );
  }
  if (client) {
    client.emit("beforeOutgoingRequestSpan", span, handlerData);
  }
  return span;
}
function addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
  const { "sentry-trace": sentryTrace, baggage, traceparent } = (0,traceData/* getTraceData */.i)({ span, propagateTraceparent });
  if (sentryTrace) {
    setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
  }
}
function setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
  const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
  if (originalHeaders?.["sentry-trace"] || !xhr.setRequestHeader) {
    return;
  }
  try {
    xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
    if (traceparentHeader && !originalHeaders?.["traceparent"]) {
      xhr.setRequestHeader("traceparent", traceparentHeader);
    }
    if (sentryBaggageHeader) {
      const originalBaggageHeader = originalHeaders?.["baggage"];
      if (!originalBaggageHeader || !baggageHeaderHasSentryValues(originalBaggageHeader)) {
        xhr.setRequestHeader("baggage", sentryBaggageHeader);
      }
    }
  } catch {
  }
}



/***/ }),

/***/ 29391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   _: function() { return /* binding */ makeFetchTransport; }
/* harmony export */ });
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40413);
/* harmony import */ var _sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50198);
/* harmony import */ var _sentry_browser_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16487);


const DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
function makeFetchTransport(options, nativeFetch = (0,_sentry_browser_utils__WEBPACK_IMPORTED_MODULE_2__/* .getNativeImplementation */ .qd)("fetch")) {
  let pendingBodySize = 0;
  let pendingCount = 0;
  async function makeRequest(request) {
    const requestSize = request.body.length;
    pendingBodySize += requestSize;
    pendingCount++;
    const requestOptions = {
      body: request.body,
      method: "POST",
      referrerPolicy: "strict-origin",
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
      ...options.fetchOptions
    };
    try {
      const response = await nativeFetch(options.url, requestOptions);
      return {
        statusCode: response.status,
        headers: {
          "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
          "retry-after": response.headers.get("Retry-After")
        }
      };
    } catch (e) {
      (0,_sentry_browser_utils__WEBPACK_IMPORTED_MODULE_2__/* .clearCachedImplementation */ .y7)("fetch");
      throw e;
    } finally {
      pendingBodySize -= requestSize;
      pendingCount--;
    }
  }
  return (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_0__/* .createTransport */ .o)(
    options,
    makeRequest,
    (0,_sentry_core_browser__WEBPACK_IMPORTED_MODULE_1__/* .makePromiseBuffer */ .C)(options.bufferSize || DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE)
  );
}



/***/ }),

/***/ 31007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z8: function() { return /* binding */ getEnvelopeEndpointWithUrlEncodedAuth; },
/* harmony export */   kJ: function() { return /* binding */ getReportDialogEndpoint; }
/* harmony export */ });
/* unused harmony export SENTRY_API_VERSION */
/* harmony import */ var _utils_dsn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56648);

const SENTRY_API_VERSION = "7";
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
  const port = dsn.port ? `:${dsn.port}` : "";
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function _encodedAuth(dsn, sdkInfo) {
  const params = {
    sentry_version: SENTRY_API_VERSION
  };
  if (dsn.publicKey) {
    params.sentry_key = dsn.publicKey;
  }
  if (sdkInfo) {
    params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
  }
  return new URLSearchParams(params).toString();
}
function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel, sdkInfo) {
  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}
function getReportDialogEndpoint(dsnLike, dialogOptions) {
  const dsn = (0,_utils_dsn_js__WEBPACK_IMPORTED_MODULE_0__/* .makeDsn */ .AD)(dsnLike);
  if (!dsn) {
    return "";
  }
  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;
  let encodedOptions = `dsn=${(0,_utils_dsn_js__WEBPACK_IMPORTED_MODULE_0__/* .dsnToString */ .SB)(dsn)}`;
  for (const key in dialogOptions) {
    if (key === "dsn") {
      continue;
    }
    if (key === "onClose") {
      continue;
    }
    if (key === "user") {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
  }
  return `${endpoint}?${encodedOptions}`;
}



/***/ }),

/***/ 27657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  h: function() { return /* binding */ getAsyncContextStrategy; }
});

// UNUSED EXPORTS: setAsyncContextStrategy

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/carrier.js
var esm_carrier = __webpack_require__(35179);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/scope.js
var esm_scope = __webpack_require__(61003);
;// ./node_modules/@sentry/core/build/esm/defaultScopes.js


function getDefaultCurrentScope() {
  return (0,esm_carrier/* getGlobalSingleton */.BY)("defaultCurrentScope", () => new esm_scope/* Scope */.H());
}
function getDefaultIsolationScope() {
  return (0,esm_carrier/* getGlobalSingleton */.BY)("defaultIsolationScope", () => new esm_scope/* Scope */.H());
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/chain-and-copy-promiselike.js
var chain_and_copy_promiselike = __webpack_require__(92547);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/is.js
var is = __webpack_require__(91973);
;// ./node_modules/@sentry/core/build/esm/asyncContext/stackStrategy.js





class AsyncContextStack {
  constructor(scope, isolationScope) {
    let assignedScope;
    if (!scope) {
      assignedScope = new esm_scope/* Scope */.H();
    } else {
      assignedScope = scope;
    }
    let assignedIsolationScope;
    if (!isolationScope) {
      assignedIsolationScope = new esm_scope/* Scope */.H();
    } else {
      assignedIsolationScope = isolationScope;
    }
    this._stack = [{ scope: assignedScope }];
    this._isolationScope = assignedIsolationScope;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(callback) {
    const scope = this._pushScope();
    let maybePromiseResult;
    try {
      maybePromiseResult = callback(scope);
    } catch (e) {
      this._popScope();
      throw e;
    }
    if ((0,is/* isThenable */.Qg)(maybePromiseResult)) {
      return (0,chain_and_copy_promiselike/* chainAndCopyPromiseLike */.i)(
        maybePromiseResult,
        () => this._popScope(),
        () => this._popScope()
      );
    }
    this._popScope();
    return maybePromiseResult;
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const scope = this.getScope().clone();
    this._stack.push({
      client: this.getClient(),
      scope
    });
    return scope;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    if (this._stack.length <= 1) return false;
    return !!this._stack.pop();
  }
}
function getAsyncContextStack() {
  const registry = (0,esm_carrier/* getMainCarrier */.EU)();
  const sentry = (0,esm_carrier/* getSentryCarrier */.Se)(registry);
  return sentry.stack = sentry.stack || new AsyncContextStack(getDefaultCurrentScope(), getDefaultIsolationScope());
}
function withScope(callback) {
  return getAsyncContextStack().withScope(callback);
}
function withSetScope(scope, callback) {
  const stack = getAsyncContextStack();
  return stack.withScope(() => {
    stack.getStackTop().scope = scope;
    return callback(scope);
  });
}
function withIsolationScope(callback) {
  return getAsyncContextStack().withScope(() => {
    return callback(getAsyncContextStack().getIsolationScope());
  });
}
function getStackAsyncContextStrategy() {
  return {
    withIsolationScope,
    withScope,
    withSetScope,
    withSetIsolationScope: (_isolationScope, callback) => {
      return withIsolationScope(callback);
    },
    getCurrentScope: () => getAsyncContextStack().getScope(),
    getIsolationScope: () => getAsyncContextStack().getIsolationScope()
  };
}


;// ./node_modules/@sentry/core/build/esm/asyncContext/index.js
/* unused harmony import specifier */ var getMainCarrier;
/* unused harmony import specifier */ var getSentryCarrier;


function setAsyncContextStrategy(strategy) {
  const registry = getMainCarrier();
  const sentry = getSentryCarrier(registry);
  sentry.acs = strategy;
}
function getAsyncContextStrategy(carrier) {
  const sentry = (0,esm_carrier/* getSentryCarrier */.Se)(carrier);
  if (sentry.acs) {
    return sentry.acs;
  }
  return getStackAsyncContextStrategy();
}



/***/ }),

/***/ 93778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SY: function() { return /* binding */ serializeAttributes; },
/* harmony export */   n9: function() { return /* binding */ estimateTypedAttributesSizeInBytes; }
/* harmony export */ });
/* unused harmony exports attributeValueToTypedAttributeValue, isAttributeObject */
/* harmony import */ var _utils_is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91973);

function isAttributeObject(maybeObj) {
  return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function attributeValueToTypedAttributeValue(rawValue, useFallback) {
  const { value, unit } = isAttributeObject(rawValue) ? rawValue : { value: rawValue, unit: void 0 };
  const attributeValue = getTypedAttributeValue(value);
  const checkedUnit = unit && typeof unit === "string" ? { unit } : {};
  if (attributeValue) {
    return { ...attributeValue, ...checkedUnit };
  }
  if (!useFallback || useFallback === "skip-undefined" && value === void 0) {
    return;
  }
  let stringValue = "";
  try {
    stringValue = JSON.stringify(value) ?? "";
  } catch {
  }
  return {
    value: stringValue,
    type: "string",
    ...checkedUnit
  };
}
function serializeAttributes(attributes, fallback = false) {
  const serializedAttributes = {};
  for (const [key, value] of Object.entries(attributes ?? {})) {
    const typedValue = attributeValueToTypedAttributeValue(value, fallback);
    if (typedValue) {
      serializedAttributes[key] = typedValue;
    }
  }
  return serializedAttributes;
}
function estimateTypedAttributesSizeInBytes(attributes) {
  if (!attributes) {
    return 0;
  }
  let weight = 0;
  for (const [key, attr] of Object.entries(attributes)) {
    weight += key.length * 2;
    weight += attr.type.length * 2;
    weight += (attr.unit?.length ?? 0) * 2;
    const val = attr.value;
    if (Array.isArray(val)) {
      weight += estimatePrimitiveSizeInBytes(val[0]) * val.length;
    } else if ((0,_utils_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPrimitive */ .sO)(val)) {
      weight += estimatePrimitiveSizeInBytes(val);
    } else {
      weight += 100;
    }
  }
  return weight;
}
function estimatePrimitiveSizeInBytes(value) {
  if (typeof value === "string") {
    return value.length * 2;
  } else if (typeof value === "boolean") {
    return 4;
  } else if (typeof value === "number") {
    return 8;
  }
  return 0;
}
function getTypedAttributeValue(value) {
  if (Array.isArray(value)) {
    return { value, type: "array" };
  }
  const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
  if (primitiveType) {
    return { value, type: primitiveType };
  }
}



/***/ }),

/***/ 55121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ addBreadcrumb; }
/* harmony export */ });
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79255);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62183);
/* harmony import */ var _utils_time_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39612);



const DEFAULT_BREADCRUMBS = 100;
function addBreadcrumb(breadcrumb, hint) {
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .KU)();
  const isolationScope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)();
  if (!client) return;
  const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } = client.getOptions();
  if (maxBreadcrumbs <= 0) return;
  const timestamp = (0,_utils_time_js__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .lu)();
  const mergedBreadcrumb = { timestamp, ...breadcrumb };
  const finalBreadcrumb = beforeBreadcrumb ? (0,_utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .consoleSandbox */ .pq)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
  if (finalBreadcrumb === null) return;
  if (client.emit) {
    client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
  }
  isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}



/***/ }),

/***/ 35179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BY: function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   EU: function() { return /* binding */ getMainCarrier; },
/* harmony export */   Se: function() { return /* binding */ getSentryCarrier; }
/* harmony export */ });
/* harmony import */ var _utils_version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83965);
/* harmony import */ var _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70774);


function getMainCarrier() {
  getSentryCarrier(_utils_worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ */ .O);
  return _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ */ .O;
}
function getSentryCarrier(carrier) {
  const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
  __SENTRY__.version = __SENTRY__.version || _utils_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .M;
  return __SENTRY__[_utils_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .M] = __SENTRY__[_utils_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .M] || {};
}
function getGlobalSingleton(name, creator, obj = _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ */ .O) {
  const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
  const carrier = __SENTRY__[_utils_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .M] = __SENTRY__[_utils_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .M] || {};
  return carrier[name] || (carrier[name] = creator());
}



/***/ }),

/***/ 9358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEV_ENVIRONMENT */
const DEFAULT_ENVIRONMENT = "production";
const DEV_ENVIRONMENT = "development";


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "U", 0, /* binding */ DEFAULT_ENVIRONMENT
/* harmony export */ ]);


/***/ }),

/***/ 79255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bi: function() { return /* binding */ hasExternalPropagationContext; },
/* harmony export */   KU: function() { return /* binding */ getClient; },
/* harmony export */   m6: function() { return /* binding */ getGlobalScope; },
/* harmony export */   o5: function() { return /* binding */ getCurrentScope; },
/* harmony export */   rB: function() { return /* binding */ withIsolationScope; },
/* harmony export */   rm: function() { return /* binding */ getIsolationScope; },
/* harmony export */   v4: function() { return /* binding */ withScope; },
/* harmony export */   vn: function() { return /* binding */ getTraceContextFromScope; }
/* harmony export */ });
/* unused harmony exports getExternalPropagationContext, registerExternalPropagationContext */
/* harmony import */ var _asyncContext_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27657);
/* harmony import */ var _carrier_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35179);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61003);
/* harmony import */ var _utils_propagationContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66508);




let _externalPropagationContextProvider;
function registerExternalPropagationContext(fn) {
  _externalPropagationContextProvider = fn;
}
function getExternalPropagationContext() {
  return _externalPropagationContextProvider?.();
}
function hasExternalPropagationContext() {
  return _externalPropagationContextProvider !== void 0;
}
function getCurrentScope() {
  const carrier = (0,_carrier_js__WEBPACK_IMPORTED_MODULE_1__/* .getMainCarrier */ .EU)();
  const acs = (0,_asyncContext_index_js__WEBPACK_IMPORTED_MODULE_0__/* .getAsyncContextStrategy */ .h)(carrier);
  return acs.getCurrentScope();
}
function getIsolationScope() {
  const carrier = (0,_carrier_js__WEBPACK_IMPORTED_MODULE_1__/* .getMainCarrier */ .EU)();
  const acs = (0,_asyncContext_index_js__WEBPACK_IMPORTED_MODULE_0__/* .getAsyncContextStrategy */ .h)(carrier);
  return acs.getIsolationScope();
}
function getGlobalScope() {
  return (0,_carrier_js__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalSingleton */ .BY)("globalScope", () => new _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope */ .H());
}
function withScope(...rest) {
  const carrier = (0,_carrier_js__WEBPACK_IMPORTED_MODULE_1__/* .getMainCarrier */ .EU)();
  const acs = (0,_asyncContext_index_js__WEBPACK_IMPORTED_MODULE_0__/* .getAsyncContextStrategy */ .h)(carrier);
  if (rest.length === 2) {
    const [scope, callback] = rest;
    if (!scope) {
      return acs.withScope(callback);
    }
    return acs.withSetScope(scope, callback);
  }
  return acs.withScope(rest[0]);
}
function withIsolationScope(...rest) {
  const carrier = (0,_carrier_js__WEBPACK_IMPORTED_MODULE_1__/* .getMainCarrier */ .EU)();
  const acs = (0,_asyncContext_index_js__WEBPACK_IMPORTED_MODULE_0__/* .getAsyncContextStrategy */ .h)(carrier);
  if (rest.length === 2) {
    const [isolationScope, callback] = rest;
    if (!isolationScope) {
      return acs.withIsolationScope(callback);
    }
    return acs.withSetIsolationScope(isolationScope, callback);
  }
  return acs.withIsolationScope(rest[0]);
}
function getClient() {
  return getCurrentScope().getClient();
}
function getTraceContextFromScope(scope) {
  const externalContext = getExternalPropagationContext();
  if (externalContext) {
    return { trace_id: externalContext.traceId, span_id: externalContext.spanId };
  }
  const propagationContext = scope.getPropagationContext();
  const { traceId, parentSpanId, propagationSpanId } = propagationContext;
  const traceContext = {
    trace_id: traceId,
    span_id: propagationSpanId || (0,_utils_propagationContext_js__WEBPACK_IMPORTED_MODULE_3__/* .generateSpanId */ .Z)()
  };
  if (parentSpanId) {
    traceContext.parent_span_id = parentSpanId;
  }
  return traceContext;
}



/***/ }),

/***/ 97169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "T", 0, /* binding */ DEBUG_BUILD
/* harmony export */ ]);


/***/ }),

/***/ 81507:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LE: function() { return /* binding */ createSessionEnvelope; },
/* harmony export */   V7: function() { return /* binding */ createEventEnvelope; },
/* harmony export */   lu: function() { return /* binding */ createSpanEnvelope; }
/* harmony export */ });
/* unused harmony export _enhanceEventWithSdkInfo */
/* harmony import */ var _tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49271);
/* harmony import */ var _tracing_spans_beforeSendSpan_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62635);
/* harmony import */ var _utils_dsn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56648);
/* harmony import */ var _utils_envelope_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22265);
/* harmony import */ var _utils_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23324);
/* harmony import */ var _utils_should_ignore_span_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90622);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42896);







function _enhanceEventWithSdkInfo(event, newSdkInfo) {
  if (!newSdkInfo) {
    return event;
  }
  const eventSdkInfo = event.sdk || {};
  event.sdk = {
    ...eventSdkInfo,
    name: eventSdkInfo.name || newSdkInfo.name,
    version: eventSdkInfo.version || newSdkInfo.version,
    integrations: [...event.sdk?.integrations || [], ...newSdkInfo.integrations || []],
    packages: [...event.sdk?.packages || [], ...newSdkInfo.packages || []],
    settings: event.sdk?.settings || newSdkInfo.settings ? {
      ...event.sdk?.settings,
      ...newSdkInfo.settings
    } : void 0
  };
  return event;
}
function createSessionEnvelope(session, dsn, metadata, tunnel) {
  const sdkInfo = (0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_3__/* .getSdkMetadataForEnvelopeHeader */ .Cj)(metadata);
  const envelopeHeaders = {
    sent_at: new Date((0,_utils_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_4__/* .safeDateNow */ .Wk)()).toISOString(),
    ...sdkInfo && { sdk: sdkInfo },
    ...!!tunnel && dsn && { dsn: (0,_utils_dsn_js__WEBPACK_IMPORTED_MODULE_2__/* .dsnToString */ .SB)(dsn) }
  };
  const envelopeItem = "aggregates" in session ? [{ type: "sessions" }, session] : [{ type: "session" }, session.toJSON()];
  return (0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_3__/* .createEnvelope */ .h4)(envelopeHeaders, [envelopeItem]);
}
function createEventEnvelope(event, dsn, metadata, tunnel) {
  const sdkInfo = (0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_3__/* .getSdkMetadataForEnvelopeHeader */ .Cj)(metadata);
  const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
  _enhanceEventWithSdkInfo(event, metadata?.sdk);
  const envelopeHeaders = (0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_3__/* .createEventEnvelopeHeaders */ .n2)(event, sdkInfo, tunnel, dsn);
  delete event.sdkProcessingMetadata;
  const eventItem = [{ type: eventType }, event];
  return (0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_3__/* .createEnvelope */ .h4)(envelopeHeaders, [eventItem]);
}
function createSpanEnvelope(spans, client) {
  function dscHasRequiredProps(dsc2) {
    return !!dsc2.trace_id && !!dsc2.public_key;
  }
  const dsc = (0,_tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_0__/* .getDynamicSamplingContextFromSpan */ .k1)(spans[0]);
  const dsn = client?.getDsn();
  const tunnel = client?.getOptions().tunnel;
  const headers = {
    sent_at: new Date((0,_utils_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_4__/* .safeDateNow */ .Wk)()).toISOString(),
    ...dscHasRequiredProps(dsc) && { trace: dsc },
    ...!!tunnel && dsn && { dsn: (0,_utils_dsn_js__WEBPACK_IMPORTED_MODULE_2__/* .dsnToString */ .SB)(dsn) }
  };
  const { beforeSendSpan, ignoreSpans } = client?.getOptions() || {};
  const filteredSpans = ignoreSpans?.length ? spans.filter((span) => {
    const json = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .spanToJSON */ .et)(span);
    return !(0,_utils_should_ignore_span_js__WEBPACK_IMPORTED_MODULE_5__/* .shouldIgnoreSpan */ .e)({ description: json.description, op: json.op, attributes: json.data }, ignoreSpans);
  }) : spans;
  const droppedSpans = spans.length - filteredSpans.length;
  if (droppedSpans) {
    client?.recordDroppedEvent("before_send", "span", droppedSpans);
  }
  const convertToSpanJSON = beforeSendSpan ? (span) => {
    const spanJson = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .spanToJSON */ .et)(span);
    const processedSpan = !(0,_tracing_spans_beforeSendSpan_js__WEBPACK_IMPORTED_MODULE_1__/* .isStreamedBeforeSendSpanCallback */ .S)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
    if (!processedSpan) {
      (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .showSpanDropWarning */ .xl)();
      return spanJson;
    }
    return processedSpan;
  } : _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .spanToJSON */ .et;
  const items = [];
  for (const span of filteredSpans) {
    const spanJson = convertToSpanJSON(span);
    if (spanJson) {
      items.push((0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_3__/* .createSpanEnvelopeItem */ .y5)(spanJson));
    }
  }
  return (0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_3__/* .createEnvelope */ .h4)(headers, items);
}



/***/ }),

/***/ 60068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bq: function() { return /* binding */ setAttribute; },
/* harmony export */   Cp: function() { return /* binding */ captureException; },
/* harmony export */   Dp: function() { return /* binding */ isInitialized; },
/* harmony export */   J0: function() { return /* binding */ startSession; },
/* harmony export */   J5: function() { return /* binding */ captureSession; },
/* harmony export */   Ji: function() { return /* binding */ setConversationId; },
/* harmony export */   NA: function() { return /* binding */ setTag; },
/* harmony export */   Ol: function() { return /* binding */ isEnabled; },
/* harmony export */   Q: function() { return /* binding */ lastEventId; },
/* harmony export */   SA: function() { return /* binding */ addEventProcessor; },
/* harmony export */   VN: function() { return /* binding */ close; },
/* harmony export */   Wp: function() { return /* binding */ setAttributes; },
/* harmony export */   Wt: function() { return /* binding */ setTags; },
/* harmony export */   bX: function() { return /* binding */ flush; },
/* harmony export */   cx: function() { return /* binding */ setExtras; },
/* harmony export */   gV: function() { return /* binding */ setUser; },
/* harmony export */   ky: function() { return /* binding */ endSession; },
/* harmony export */   l7: function() { return /* binding */ setExtra; },
/* harmony export */   o: function() { return /* binding */ setContext; },
/* harmony export */   r: function() { return /* binding */ captureEvent; },
/* harmony export */   wd: function() { return /* binding */ captureMessage; }
/* harmony export */ });
/* unused harmony exports captureCheckIn, withMonitor */
/* unused harmony import specifier */ var getCurrentScope;
/* unused harmony import specifier */ var getClient;
/* unused harmony import specifier */ var withIsolationScope;
/* unused harmony import specifier */ var DEBUG_BUILD;
/* unused harmony import specifier */ var startNewTrace;
/* unused harmony import specifier */ var debug;
/* unused harmony import specifier */ var isThenable;
/* unused harmony import specifier */ var uuid4;
/* unused harmony import specifier */ var timestampInSeconds;
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79255);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97169);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53835);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62183);
/* harmony import */ var _utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8665);
/* harmony import */ var _utils_scopeData_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35845);
/* harmony import */ var _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70774);











function captureException(exception, hint) {
  return (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .o5)().captureException(exception, (0,_utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_4__/* .parseEventHintOrCaptureContext */ .li)(hint));
}
function captureMessage(message, captureContext) {
  const level = typeof captureContext === "string" ? captureContext : void 0;
  const hint = typeof captureContext !== "string" ? { captureContext } : void 0;
  return (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .o5)().captureMessage(message, level, hint);
}
function captureEvent(event, hint) {
  return (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .o5)().captureEvent(event, hint);
}
function setContext(name, context) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)().setContext(name, context);
}
function setExtras(extras) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)().setExtras(extras);
}
function setExtra(key, extra) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)().setExtra(key, extra);
}
function setTags(tags) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)().setTags(tags);
}
function setTag(key, value) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)().setTag(key, value);
}
function setAttributes(attributes) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)().setAttributes(attributes);
}
function setAttribute(key, value) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)().setAttribute(key, value);
}
function setUser(user) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)().setUser(user);
}
function setConversationId(conversationId) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)().setConversationId(conversationId);
}
function lastEventId() {
  return (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)().lastEventId();
}
function captureCheckIn(checkIn, upsertMonitorConfig) {
  const scope = getCurrentScope();
  const client = getClient();
  if (!client) {
    DEBUG_BUILD && debug.warn("Cannot capture check-in. No client defined.");
  } else if (!client.captureCheckIn) {
    DEBUG_BUILD && debug.warn("Cannot capture check-in. Client does not support sending check-ins.");
  } else {
    return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
  }
  return uuid4();
}
function withMonitor(monitorSlug, callback, upsertMonitorConfig) {
  function runCallback() {
    const checkInId = captureCheckIn({ monitorSlug, status: "in_progress" }, upsertMonitorConfig);
    const now = timestampInSeconds();
    function finishCheckIn(status) {
      captureCheckIn({ monitorSlug, status, checkInId, duration: timestampInSeconds() - now });
    }
    let maybePromiseResult;
    try {
      maybePromiseResult = callback();
    } catch (e) {
      finishCheckIn("error");
      throw e;
    }
    if (isThenable(maybePromiseResult)) {
      return maybePromiseResult.then(
        (r) => {
          finishCheckIn("ok");
          return r;
        },
        (e) => {
          finishCheckIn("error");
          throw e;
        }
      );
    }
    finishCheckIn("ok");
    return maybePromiseResult;
  }
  return withIsolationScope(() => upsertMonitorConfig?.isolateTrace ? startNewTrace(runCallback) : runCallback());
}
async function flush(timeout) {
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .KU)();
  if (client) {
    return client.flush(timeout);
  }
  _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_3__/* .debug */ .Yz.warn("Cannot flush events. No client defined.");
  return Promise.resolve(false);
}
async function close(timeout) {
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .KU)();
  if (client) {
    return client.close(timeout);
  }
  _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_3__/* .debug */ .Yz.warn("Cannot flush events and disable SDK. No client defined.");
  return Promise.resolve(false);
}
function isInitialized() {
  return !!(0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .KU)();
}
function isEnabled() {
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .KU)();
  return client?.getOptions().enabled !== false && !!client?.getTransport();
}
function addEventProcessor(callback) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)().addEventProcessor(callback);
}
function startSession(context) {
  const isolationScope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)();
  const { user } = (0,_utils_scopeData_js__WEBPACK_IMPORTED_MODULE_5__/* .getCombinedScopeData */ .Om)(isolationScope, (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .o5)());
  const { userAgent } = _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_6__/* .GLOBAL_OBJ */ .O.navigator || {};
  const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_2__/* .makeSession */ .fj)({
    user,
    ...userAgent && { userAgent },
    ...context
  });
  const currentSession = isolationScope.getSession();
  if (currentSession?.status === "ok") {
    (0,_session_js__WEBPACK_IMPORTED_MODULE_2__/* .updateSession */ .qO)(currentSession, { status: "exited" });
  }
  endSession();
  isolationScope.setSession(session);
  return session;
}
function endSession() {
  const isolationScope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)();
  const currentScope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .o5)();
  const session = currentScope.getSession() || isolationScope.getSession();
  if (session) {
    (0,_session_js__WEBPACK_IMPORTED_MODULE_2__/* .closeSession */ .Vu)(session);
  }
  _sendSessionUpdate();
  isolationScope.setSession();
}
function _sendSessionUpdate() {
  const isolationScope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .rm)();
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .KU)();
  const session = isolationScope.getSession();
  if (session && client) {
    client.captureSession(session);
  }
}
function captureSession(end = false) {
  if (end) {
    endSession();
    return;
  }
  _sendSessionUpdate();
}



/***/ }),

/***/ 42248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P: function() { return /* binding */ addConsoleInstrumentationHandler; }
/* harmony export */ });
/* unused harmony export addConsoleInstrumentationFilter */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62183);
/* harmony import */ var _utils_object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50742);
/* harmony import */ var _utils_string_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26228);
/* harmony import */ var _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70774);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20360);






const _filter = /* @__PURE__ */ new Set([]);
function addConsoleInstrumentationHandler(handler) {
  const type = "console";
  const removeHandler = (0,_handlers_js__WEBPACK_IMPORTED_MODULE_5__/* .addHandler */ .s5)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_5__/* .maybeInstrument */ .AS)(type, instrumentConsole);
  return removeHandler;
}
function addConsoleInstrumentationFilter(filter) {
  for (const f of filter) {
    _filter.add(f);
  }
  return () => {
    for (const f of filter) {
      _filter.delete(f);
    }
  };
}
function instrumentConsole() {
  if (!("console" in _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_4__/* .GLOBAL_OBJ */ .O)) {
    return;
  }
  _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .CONSOLE_LEVELS */ .Ow.forEach(function(level) {
    if (!(level in _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_4__/* .GLOBAL_OBJ */ .O.console)) {
      return;
    }
    (0,_utils_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .GS)(_utils_worldwide_js__WEBPACK_IMPORTED_MODULE_4__/* .GLOBAL_OBJ */ .O.console, level, function(originalConsoleMethod) {
      _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .originalConsoleMethods */ .Z9[level] = originalConsoleMethod;
      return function(...args) {
        const firstArg = args[0];
        const log = _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .originalConsoleMethods */ .Z9[level];
        const isFiltered = _filter.size && typeof firstArg === "string" && (0,_utils_string_js__WEBPACK_IMPORTED_MODULE_3__/* .stringMatchesSomePattern */ .Xr)(firstArg, _filter);
        if (!isFiltered) {
          (0,_handlers_js__WEBPACK_IMPORTED_MODULE_5__/* .triggerHandlers */ .aj)("console", { args, level });
        }
        if (!isFiltered || _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.isEnabled()) {
          log?.apply(_utils_worldwide_js__WEBPACK_IMPORTED_MODULE_4__/* .GLOBAL_OBJ */ .O.console, args);
        }
      };
    });
  });
}



/***/ }),

/***/ 42793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B$: function() { return /* binding */ addFetchEndInstrumentationHandler; },
/* harmony export */   ur: function() { return /* binding */ addFetchInstrumentationHandler; }
/* harmony export */ });
/* unused harmony export parseFetchArgs */
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79255);
/* harmony import */ var _utils_is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91973);
/* harmony import */ var _utils_object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50742);
/* harmony import */ var _utils_supports_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53717);
/* harmony import */ var _utils_time_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39612);
/* harmony import */ var _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70774);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(20360);







function addFetchInstrumentationHandler(handler, skipNativeFetchCheck) {
  const type = "fetch";
  const removeHandler = (0,_handlers_js__WEBPACK_IMPORTED_MODULE_6__/* .addHandler */ .s5)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_6__/* .maybeInstrument */ .AS)(type, () => instrumentFetch(void 0, skipNativeFetchCheck));
  return removeHandler;
}
function addFetchEndInstrumentationHandler(handler) {
  const type = "fetch-body-resolved";
  const removeHandler = (0,_handlers_js__WEBPACK_IMPORTED_MODULE_6__/* .addHandler */ .s5)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_6__/* .maybeInstrument */ .AS)(type, () => instrumentFetch(streamHandler));
  return removeHandler;
}
function instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
  if (skipNativeFetchCheck && !(0,_utils_supports_js__WEBPACK_IMPORTED_MODULE_3__/* .supportsNativeFetch */ .m7)()) {
    return;
  }
  (0,_utils_object_js__WEBPACK_IMPORTED_MODULE_2__/* .fill */ .GS)(_utils_worldwide_js__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ */ .O, "fetch", function(originalFetch) {
    return function(...args) {
      const virtualError = new Error();
      const { method, url } = parseFetchArgs(args);
      const handlerData = {
        args,
        fetchData: {
          method,
          url
        },
        startTimestamp: (0,_utils_time_js__WEBPACK_IMPORTED_MODULE_4__/* .timestampInSeconds */ .zf)() * 1e3,
        // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
        virtualError,
        headers: getHeadersFromFetchArgs(args)
      };
      if (!onFetchResolved) {
        (0,_handlers_js__WEBPACK_IMPORTED_MODULE_6__/* .triggerHandlers */ .aj)("fetch", {
          ...handlerData
        });
      }
      return originalFetch.apply(_utils_worldwide_js__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ */ .O, args).then(
        async (response) => {
          if (onFetchResolved) {
            onFetchResolved(response);
          } else {
            (0,_handlers_js__WEBPACK_IMPORTED_MODULE_6__/* .triggerHandlers */ .aj)("fetch", {
              ...handlerData,
              endTimestamp: (0,_utils_time_js__WEBPACK_IMPORTED_MODULE_4__/* .timestampInSeconds */ .zf)() * 1e3,
              response
            });
          }
          return response;
        },
        (error) => {
          (0,_handlers_js__WEBPACK_IMPORTED_MODULE_6__/* .triggerHandlers */ .aj)("fetch", {
            ...handlerData,
            endTimestamp: (0,_utils_time_js__WEBPACK_IMPORTED_MODULE_4__/* .timestampInSeconds */ .zf)() * 1e3,
            error
          });
          if ((0,_utils_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isError */ .bJ)(error) && error.stack === void 0) {
            error.stack = virtualError.stack;
            (0,_utils_object_js__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .my)(error, "framesToPop", 1);
          }
          const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .KU)();
          const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
          const shouldEnhance = enhanceOption !== false;
          if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) {
            try {
              const url2 = new URL(handlerData.fetchData.url);
              const hostname = url2.host;
              if (enhanceOption === "always") {
                error.message = `${error.message} (${hostname})`;
              } else {
                (0,_utils_object_js__WEBPACK_IMPORTED_MODULE_2__/* .addNonEnumerableProperty */ .my)(error, "__sentry_fetch_url_host__", hostname);
              }
            } catch {
            }
          }
          throw error;
        }
      );
    };
  });
}
async function resolveResponse(res, onFinishedResolving) {
  if (res?.body) {
    const body = res.body;
    const responseReader = body.getReader();
    const maxFetchDurationTimeout = setTimeout(
      () => {
        body.cancel().then(null, () => {
        });
      },
      90 * 1e3
      // 90s
    );
    let readingActive = true;
    while (readingActive) {
      let chunkTimeout;
      try {
        chunkTimeout = setTimeout(() => {
          body.cancel().then(null, () => {
          });
        }, 5e3);
        const { done } = await responseReader.read();
        clearTimeout(chunkTimeout);
        if (done) {
          onFinishedResolving();
          readingActive = false;
        }
      } catch {
        readingActive = false;
      } finally {
        clearTimeout(chunkTimeout);
      }
    }
    clearTimeout(maxFetchDurationTimeout);
    responseReader.releaseLock();
    body.cancel().then(null, () => {
    });
  }
}
function streamHandler(response) {
  let clonedResponseForResolving;
  try {
    clonedResponseForResolving = response.clone();
  } catch {
    return;
  }
  resolveResponse(clonedResponseForResolving, () => {
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_6__/* .triggerHandlers */ .aj)("fetch-body-resolved", {
      endTimestamp: (0,_utils_time_js__WEBPACK_IMPORTED_MODULE_4__/* .timestampInSeconds */ .zf)() * 1e3,
      response
    });
  });
}
function hasProp(obj, prop) {
  return !!obj && typeof obj === "object" && !!obj[prop];
}
function getUrlFromResource(resource) {
  if (typeof resource === "string") {
    return resource;
  }
  if (!resource) {
    return "";
  }
  if (hasProp(resource, "url")) {
    return resource.url;
  }
  if (resource.toString) {
    return resource.toString();
  }
  return "";
}
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return { method: "GET", url: "" };
  }
  if (fetchArgs.length === 2) {
    const [resource, options] = fetchArgs;
    return {
      url: getUrlFromResource(resource),
      method: hasProp(options, "method") ? String(options.method).toUpperCase() : (
        // Request object as first argument
        (0,_utils_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isRequest */ .ks)(resource) && hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
      )
    };
  }
  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg),
    method: hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
  };
}
function getHeadersFromFetchArgs(fetchArgs) {
  const [requestArgument, optionsArgument] = fetchArgs;
  try {
    if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) {
      return new Headers(optionsArgument.headers);
    }
    if ((0,_utils_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isRequest */ .ks)(requestArgument)) {
      return new Headers(requestArgument.headers);
    }
  } catch {
  }
  return;
}



/***/ }),

/***/ 38482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   L: function() { return /* binding */ addGlobalErrorInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70774);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20360);


let _oldOnErrorHandler = null;
function addGlobalErrorInstrumentationHandler(handler) {
  const type = "error";
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .addHandler */ .s5)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .maybeInstrument */ .AS)(type, instrumentError);
}
function instrumentError() {
  _oldOnErrorHandler = _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .O.onerror;
  _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .O.onerror = function(msg, url, line, column, error) {
    const handlerData = {
      column,
      error,
      line,
      msg,
      url
    };
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .triggerHandlers */ .aj)("error", handlerData);
    if (_oldOnErrorHandler) {
      return _oldOnErrorHandler.apply(this, arguments);
    }
    return false;
  };
  _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .O.onerror.__SENTRY_INSTRUMENTED__ = true;
}



/***/ }),

/***/ 76676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   r: function() { return /* binding */ addGlobalUnhandledRejectionInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70774);
/* harmony import */ var _handlers_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20360);


let _oldOnUnhandledRejectionHandler = null;
function addGlobalUnhandledRejectionInstrumentationHandler(handler) {
  const type = "unhandledrejection";
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .addHandler */ .s5)(type, handler);
  (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .maybeInstrument */ .AS)(type, instrumentUnhandledRejection);
}
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .O.onunhandledrejection;
  _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .O.onunhandledrejection = function(e) {
    const handlerData = e;
    (0,_handlers_js__WEBPACK_IMPORTED_MODULE_1__/* .triggerHandlers */ .aj)("unhandledrejection", handlerData);
    if (_oldOnUnhandledRejectionHandler) {
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }
    return true;
  };
  _utils_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .O.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}



/***/ }),

/***/ 20360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AS: function() { return /* binding */ maybeInstrument; },
/* harmony export */   aj: function() { return /* binding */ triggerHandlers; },
/* harmony export */   s5: function() { return /* binding */ addHandler; }
/* harmony export */ });
/* unused harmony export resetInstrumentationHandlers */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62183);
/* harmony import */ var _utils_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52992);



const handlers = {};
const instrumented = {};
function addHandler(type, handler) {
  handlers[type] = handlers[type] || [];
  handlers[type].push(handler);
  return () => {
    const typeHandlers = handlers[type];
    if (typeHandlers) {
      const index = typeHandlers.indexOf(handler);
      if (index !== -1) {
        typeHandlers.splice(index, 1);
      }
    }
  };
}
function resetInstrumentationHandlers() {
  Object.keys(handlers).forEach((key) => {
    handlers[key] = void 0;
  });
}
function maybeInstrument(type, instrumentFn) {
  if (!instrumented[type]) {
    instrumented[type] = true;
    try {
      instrumentFn();
    } catch (e) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.error(`Error while instrumenting ${type}`, e);
    }
  }
}
function triggerHandlers(type, data) {
  const typeHandlers = type && handlers[type];
  if (!typeHandlers) {
    return;
  }
  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.error(
        `Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0,_utils_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .qQ)(handler)}
Error:`,
        e
      );
    }
  }
}



/***/ }),

/***/ 94893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   P$: function() { return /* binding */ setupIntegrations; },
/* harmony export */   Q8: function() { return /* binding */ addIntegration; },
/* harmony export */   _C: function() { return /* binding */ defineIntegration; },
/* harmony export */   lc: function() { return /* binding */ afterSetupIntegrations; },
/* harmony export */   mH: function() { return /* binding */ getIntegrationsToSetup; },
/* harmony export */   qm: function() { return /* binding */ setupIntegration; }
/* harmony export */ });
/* unused harmony exports extendIntegration, installedIntegrations */
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79255);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97169);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62183);



const installedIntegrations = [];
function filterDuplicates(integrations) {
  const integrationsByName = {};
  integrations.forEach((currentInstance) => {
    const { name } = currentInstance;
    const existingInstance = integrationsByName[name];
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }
    integrationsByName[name] = currentInstance;
  });
  return Object.values(integrationsByName);
}
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;
  defaultIntegrations.forEach((integration) => {
    integration.isDefaultInstance = true;
  });
  let integrations;
  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === "function") {
    const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
    integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [resolvedUserIntegrations];
  } else {
    integrations = defaultIntegrations;
  }
  return filterDuplicates(integrations);
}
function setupIntegrations(client, integrations) {
  const integrationIndex = {};
  integrations.forEach((integration) => {
    if (integration?.beforeSetup) {
      integration.beforeSetup(client);
    }
  });
  integrations.forEach((integration) => {
    if (integration) {
      setupIntegration(client, integration, integrationIndex);
    }
  });
  return integrationIndex;
}
function afterSetupIntegrations(client, integrations) {
  for (const integration of integrations) {
    if (integration?.afterAllSetup) {
      integration.afterAllSetup(client);
    }
  }
}
function setupIntegration(client, integration, integrationIndex) {
  if (integrationIndex[integration.name]) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.log(`Integration skipped because it was already installed: ${integration.name}`);
    return;
  }
  integrationIndex[integration.name] = integration;
  if (!installedIntegrations.includes(integration.name) && typeof integration.setupOnce === "function") {
    integration.setupOnce();
    installedIntegrations.push(integration.name);
  }
  if (integration.setup && typeof integration.setup === "function") {
    integration.setup(client);
  }
  if (typeof integration.preprocessEvent === "function") {
    const callback = integration.preprocessEvent.bind(integration);
    client.on("preprocessEvent", (event, hint) => callback(event, hint, client));
  }
  if (typeof integration.processEvent === "function") {
    const callback = integration.processEvent.bind(integration);
    const processor = Object.assign((event, hint) => callback(event, hint, client), {
      id: integration.name
    });
    client.addEventProcessor(processor);
  }
  ["processSpan", "processSegmentSpan"].forEach((hook) => {
    const callback = integration[hook];
    if (typeof callback === "function") {
      client.on(hook, (span) => callback.call(integration, span, client));
    }
  });
  _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.log(`Integration installed: ${integration.name}`);
}
function addIntegration(integration) {
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .KU)();
  if (!client) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
    return;
  }
  client.addIntegration(integration);
}
function defineIntegration(fn) {
  return fn;
}
function extendIntegration(integration, extendedIntegration) {
  const wrappedIntegration = {
    ...integration,
    ...extendedIntegration
  };
  for (const key in extendedIntegration) {
    const baseValue = integration[key];
    const extendedValue = extendedIntegration[key];
    if (typeof baseValue === "function" && typeof extendedValue === "function") {
      const wrappedFunction = new Proxy(baseValue, {
        apply: (target, thisArg, args) => {
          Reflect.apply(target, thisArg, args);
          return Reflect.apply(extendedValue, thisArg, args);
        }
      });
      wrappedIntegration[key] = wrappedFunction;
    }
  }
  return wrappedIntegration;
}



/***/ }),

/***/ 11360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _shouldDropEvent */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _integration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94893);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62183);
/* harmony import */ var _utils_stacktrace_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52992);




const INTEGRATION_NAME = "Dedupe";
const _dedupeIntegration = (() => {
  let previousEvent;
  return {
    name: INTEGRATION_NAME,
    processEvent(currentEvent) {
      if (currentEvent.type) {
        return currentEvent;
      }
      try {
        if (_shouldDropEvent(currentEvent, previousEvent)) {
          _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.warn("Event dropped due to being a duplicate of previously captured event.");
          return null;
        }
      } catch {
      }
      return previousEvent = currentEvent;
    }
  };
});
const dedupeIntegration = (0,_integration_js__WEBPACK_IMPORTED_MODULE_1__/* .defineIntegration */ ._C)(_dedupeIntegration);
function _shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }
  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }
  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }
  return false;
}
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;
  if (!currentMessage && !previousMessage) {
    return false;
  }
  if (currentMessage && !previousMessage || !currentMessage && previousMessage) {
    return false;
  }
  if (currentMessage !== previousMessage) {
    return false;
  }
  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }
  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }
  return true;
}
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);
  if (!previousException || !currentException) {
    return false;
  }
  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }
  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }
  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }
  return true;
}
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = (0,_utils_stacktrace_js__WEBPACK_IMPORTED_MODULE_3__/* .getFramesFromEvent */ .RV)(currentEvent);
  let previousFrames = (0,_utils_stacktrace_js__WEBPACK_IMPORTED_MODULE_3__/* .getFramesFromEvent */ .RV)(previousEvent);
  if (!currentFrames && !previousFrames) {
    return true;
  }
  if (currentFrames && !previousFrames || !currentFrames && previousFrames) {
    return false;
  }
  currentFrames = currentFrames;
  previousFrames = previousFrames;
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];
    if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) {
      return false;
    }
  }
  return true;
}
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }
  if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) {
    return false;
  }
  currentFingerprint = currentFingerprint;
  previousFingerprint = previousFingerprint;
  try {
    return !!(currentFingerprint.join("") === previousFingerprint.join(""));
  } catch {
    return false;
  }
}
function _getExceptionFromEvent(event) {
  return event.exception?.values?.[0];
}


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "s", 0, /* binding */ dedupeIntegration
/* harmony export */ ]);


/***/ }),

/***/ 98748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _integration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94893);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62183);
/* harmony import */ var _utils_eventUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20516);
/* harmony import */ var _utils_misc_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16513);
/* harmony import */ var _utils_string_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26228);






const DEFAULT_IGNORE_ERRORS = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
  /^Cannot redefine property: googletag$/,
  // This is thrown when google tag manager is used in combination with an ad blocker
  /^Can't find variable: gmo$/,
  // Error from Google Search App https://issuetracker.google.com/issues/396043331
  /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
  // Random error that happens but not actionable or noticeable to end-users.
  /can't redefine non-configurable property "solana"/,
  // Probably a browser extension or custom browser (Brave) throwing this error
  /vv\(\)\.getRestrictions is not a function/,
  // Error thrown by GTM, seemingly not affecting end-users
  /Can't find variable: _AutofillCallbackHandler/,
  // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
  /Object Not Found Matching Id:\d+, MethodName:simulateEvent/,
  // unactionable error from CEFSharp, a .NET library that embeds chromium in .NET apps
  /^Java exception was raised during method invocation$/
  // error from Facebook Mobile browser (https://github.com/getsentry/sentry-javascript/issues/15065)
];
const INTEGRATION_NAME = "EventFilters";
const eventFiltersIntegration = (0,_integration_js__WEBPACK_IMPORTED_MODULE_1__/* .defineIntegration */ ._C)((options = {}) => {
  let mergedOptions;
  return {
    name: INTEGRATION_NAME,
    setup(client) {
      const clientOptions = client.getOptions();
      mergedOptions = _mergeOptions(options, clientOptions);
    },
    processEvent(event, _hint, client) {
      if (!mergedOptions) {
        const clientOptions = client.getOptions();
        mergedOptions = _mergeOptions(options, clientOptions);
      }
      return _shouldDropEvent(event, mergedOptions) ? null : event;
    }
  };
});
const inboundFiltersIntegration = (0,_integration_js__WEBPACK_IMPORTED_MODULE_1__/* .defineIntegration */ ._C)(((options = {}) => {
  return {
    ...eventFiltersIntegration(options),
    name: "InboundFilters"
  };
}));
function _mergeOptions(internalOptions = {}, clientOptions = {}) {
  return {
    allowUrls: [...internalOptions.allowUrls || [], ...clientOptions.allowUrls || []],
    denyUrls: [...internalOptions.denyUrls || [], ...clientOptions.denyUrls || []],
    ignoreErrors: [
      ...internalOptions.ignoreErrors || [],
      ...clientOptions.ignoreErrors || [],
      ...internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS
    ],
    ignoreTransactions: [...internalOptions.ignoreTransactions || [], ...clientOptions.ignoreTransactions || []]
  };
}
function _shouldDropEvent(event, options) {
  if (!event.type) {
    if (_isIgnoredError(event, options.ignoreErrors)) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${(0,_utils_misc_js__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .$X)(event)}`
      );
      return true;
    }
    if (_isUselessError(event)) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.warn(
        `Event dropped due to not having an error message, error type or stacktrace.
Event: ${(0,_utils_misc_js__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .$X)(
          event
        )}`
      );
      return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.warn(
        `Event dropped due to being matched by \`denyUrls\` option.
Event: ${(0,_utils_misc_js__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .$X)(
          event
        )}.
Url: ${_getEventFilterUrl(event)}`
      );
      return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${(0,_utils_misc_js__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .$X)(
          event
        )}.
Url: ${_getEventFilterUrl(event)}`
      );
      return true;
    }
  } else if (event.type === "transaction") {
    if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${(0,_utils_misc_js__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .$X)(event)}`
      );
      return true;
    }
  }
  return false;
}
function _isIgnoredError(event, ignoreErrors) {
  if (!ignoreErrors?.length) {
    return false;
  }
  return (0,_utils_eventUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .getPossibleEventMessages */ .G)(event).some((message) => (0,_utils_string_js__WEBPACK_IMPORTED_MODULE_5__/* .stringMatchesSomePattern */ .Xr)(message, ignoreErrors));
}
function _isIgnoredTransaction(event, ignoreTransactions) {
  if (!ignoreTransactions?.length) {
    return false;
  }
  const name = event.transaction;
  return name ? (0,_utils_string_js__WEBPACK_IMPORTED_MODULE_5__/* .stringMatchesSomePattern */ .Xr)(name, ignoreTransactions) : false;
}
function _isDeniedUrl(event, denyUrls) {
  if (!denyUrls?.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,_utils_string_js__WEBPACK_IMPORTED_MODULE_5__/* .stringMatchesSomePattern */ .Xr)(url, denyUrls);
}
function _isAllowedUrl(event, allowUrls) {
  if (!allowUrls?.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,_utils_string_js__WEBPACK_IMPORTED_MODULE_5__/* .stringMatchesSomePattern */ .Xr)(url, allowUrls);
}
function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];
    if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") {
      return frame.filename || null;
    }
  }
  return null;
}
function _getEventFilterUrl(event) {
  try {
    const rootException = [...event.exception?.values ?? []].reverse().find((value) => value.mechanism?.parent_id === void 0 && value.stacktrace?.frames?.length);
    const frames = rootException?.stacktrace?.frames;
    return frames ? _getLastValidUrl(frames) : null;
  } catch {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.error(`Cannot extract url for event ${(0,_utils_misc_js__WEBPACK_IMPORTED_MODULE_4__/* .getEventDescription */ .$X)(event)}`);
    return null;
  }
}
function _isUselessError(event) {
  if (!event.exception?.values?.length) {
    return false;
  }
  return (
    // No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value) => value.stacktrace || value.type && value.type !== "Error" || value.value)
  );
}


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "A", 0, /* binding */ eventFiltersIntegration,
/* harmony export */   "D", 0, /* binding */ inboundFiltersIntegration
/* harmony export */ ]);


/***/ }),

/***/ 6111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79255);
/* harmony import */ var _integration_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94893);
/* harmony import */ var _utils_object_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50742);



let originalFunctionToString;
const INTEGRATION_NAME = "FunctionToString";
const SETUP_CLIENTS = /* @__PURE__ */ new WeakMap();
const _functionToStringIntegration = (() => {
  return {
    name: INTEGRATION_NAME,
    setupOnce() {
      originalFunctionToString = Function.prototype.toString;
      try {
        Function.prototype.toString = function(...args) {
          const originalFunction = (0,_utils_object_js__WEBPACK_IMPORTED_MODULE_2__/* .getOriginalFunction */ .sp)(this);
          const context = SETUP_CLIENTS.has((0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .KU)()) && originalFunction !== void 0 ? originalFunction : this;
          return originalFunctionToString.apply(context, args);
        };
      } catch {
      }
    },
    setup(client) {
      SETUP_CLIENTS.set(client, true);
    }
  };
});
const functionToStringIntegration = (0,_integration_js__WEBPACK_IMPORTED_MODULE_1__/* .defineIntegration */ ._C)(_functionToStringIntegration);


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "Z", 0, /* binding */ functionToStringIntegration
/* harmony export */ ]);


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  KG: function() { return /* binding */ _INTERNAL_captureLog; },
  lt: function() { return /* binding */ _INTERNAL_flushLogsBuffer; }
});

// UNUSED EXPORTS: _INTERNAL_captureSerializedLog, _INTERNAL_getLogBuffer, _removeLoneSurrogates

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/attributes.js
var attributes = __webpack_require__(93778);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/carrier.js
var carrier = __webpack_require__(35179);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/debug-build.js
var debug_build = __webpack_require__(97169);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-logger.js
var debug_logger = __webpack_require__(62183);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/is.js
var is = __webpack_require__(91973);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/scopeData.js
var scopeData = __webpack_require__(35845);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanOnScope.js
var spanOnScope = __webpack_require__(99070);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/time.js
var time = __webpack_require__(39612);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/timestampSequence.js
var timestampSequence = __webpack_require__(78172);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/trace-info.js
var trace_info = __webpack_require__(65653);
;// ./node_modules/@sentry/core/build/esm/logs/constants.js
const SEVERITY_TEXT_TO_SEVERITY_NUMBER = {
  trace: 1,
  debug: 5,
  info: 9,
  warn: 13,
  error: 17,
  fatal: 21
};


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/dsn.js
var utils_dsn = __webpack_require__(56648);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/envelope.js
var envelope = __webpack_require__(22265);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/isBrowser.js
var isBrowser = __webpack_require__(82257);
;// ./node_modules/@sentry/core/build/esm/logs/envelope.js



function createLogContainerEnvelopeItem(items, inferUserData) {
  const inferSetting = inferUserData ? "auto" : "never";
  return [
    {
      type: "log",
      item_count: items.length,
      content_type: "application/vnd.sentry.items.log+json"
    },
    {
      version: 2,
      ...(0,isBrowser/* isBrowser */.B)() && {
        ingest_settings: { infer_ip: inferSetting, infer_user_agent: inferSetting }
      },
      items
    }
  ];
}
function createLogEnvelope(logs, metadata, tunnel, dsn, inferUserData) {
  const headers = {};
  if (metadata?.sdk) {
    headers.sdk = {
      name: metadata.sdk.name,
      version: metadata.sdk.version
    };
  }
  if (!!tunnel && !!dsn) {
    headers.dsn = (0,utils_dsn/* dsnToString */.SB)(dsn);
  }
  return (0,envelope/* createEnvelope */.h4)(headers, [createLogContainerEnvelopeItem(logs, inferUserData)]);
}


;// ./node_modules/@sentry/core/build/esm/logs/internal.js













const MAX_LOG_BUFFER_SIZE = 100;
function setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
  if (value && (!logAttributes[key] || setEvenIfPresent)) {
    logAttributes[key] = value;
  }
}
function _INTERNAL_captureSerializedLog(client, serializedLog) {
  const bufferMap = _getBufferMap();
  const logBuffer = _INTERNAL_getLogBuffer(client);
  if (logBuffer === void 0) {
    bufferMap.set(client, [serializedLog]);
  } else {
    if (logBuffer.length >= MAX_LOG_BUFFER_SIZE) {
      _INTERNAL_flushLogsBuffer(client, logBuffer);
      bufferMap.set(client, [serializedLog]);
    } else {
      bufferMap.set(client, [...logBuffer, serializedLog]);
    }
  }
}
function _INTERNAL_captureLog(beforeLog, currentScope = (0,currentScopes/* getCurrentScope */.o5)(), captureSerializedLog = _INTERNAL_captureSerializedLog) {
  const client = currentScope?.getClient() ?? (0,currentScopes/* getClient */.KU)();
  if (!client) {
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn("No client available to capture log.");
    return;
  }
  const { release, environment, enableLogs = false, beforeSendLog } = client.getOptions();
  if (!enableLogs) {
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn("logging option not enabled, log will not be captured.");
    return;
  }
  const [, traceContext] = (0,trace_info/* _getTraceInfoFromScope */.V)(client, currentScope);
  const processedLogAttributes = {
    ...beforeLog.attributes
  };
  const {
    user: { id, email, username },
    attributes: scopeAttributes = {}
  } = (0,scopeData/* getCombinedScopeData */.Om)((0,currentScopes/* getIsolationScope */.rm)(), currentScope);
  setLogAttribute(processedLogAttributes, "user.id", id, false);
  setLogAttribute(processedLogAttributes, "user.email", email, false);
  setLogAttribute(processedLogAttributes, "user.name", username, false);
  setLogAttribute(processedLogAttributes, "sentry.release", release);
  setLogAttribute(processedLogAttributes, "sentry.environment", environment);
  const { name, version } = client.getSdkMetadata()?.sdk ?? {};
  setLogAttribute(processedLogAttributes, "sentry.sdk.name", name);
  setLogAttribute(processedLogAttributes, "sentry.sdk.version", version);
  const replay = client.getIntegrationByName("Replay");
  const replayId = replay?.getReplayId(true);
  setLogAttribute(processedLogAttributes, "sentry.replay_id", replayId);
  if (replayId && replay?.getRecordingMode() === "buffer") {
    setLogAttribute(processedLogAttributes, "sentry._internal.replay_is_buffering", true);
  }
  const beforeLogMessage = beforeLog.message;
  if ((0,is/* isParameterizedString */.NF)(beforeLogMessage)) {
    const { __sentry_template_string__, __sentry_template_values__ = [] } = beforeLogMessage;
    if (__sentry_template_values__?.length) {
      processedLogAttributes["sentry.message.template"] = __sentry_template_string__;
    }
    __sentry_template_values__.forEach((param, index) => {
      processedLogAttributes[`sentry.message.parameter.${index}`] = param;
    });
  }
  const span = (0,spanOnScope/* _getSpanForScope */.f)(currentScope);
  setLogAttribute(processedLogAttributes, "sentry.trace.parent_span_id", span?.spanContext().spanId);
  const processedLog = { ...beforeLog, attributes: processedLogAttributes };
  client.emit("beforeCaptureLog", processedLog);
  const log = beforeSendLog ? (0,debug_logger/* consoleSandbox */.pq)(() => beforeSendLog(processedLog)) : processedLog;
  if (!log) {
    client.recordDroppedEvent("before_send", "log_item", 1);
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn("beforeSendLog returned null, log will not be captured.");
    return;
  }
  const { level, message, attributes: logAttributes = {}, severityNumber } = log;
  const timestamp = (0,time/* timestampInSeconds */.zf)();
  const sequenceAttr = (0,timestampSequence/* getSequenceAttribute */.o)(timestamp);
  const serializedLog = {
    timestamp,
    level,
    body: _removeLoneSurrogates(String(message)),
    trace_id: traceContext?.trace_id,
    severity_number: severityNumber ?? SEVERITY_TEXT_TO_SEVERITY_NUMBER[level],
    attributes: sanitizeLogAttributes({
      ...(0,attributes/* serializeAttributes */.SY)(scopeAttributes),
      ...(0,attributes/* serializeAttributes */.SY)(logAttributes, true),
      [sequenceAttr.key]: sequenceAttr.value
    })
  };
  captureSerializedLog(client, serializedLog);
  client.emit("afterCaptureLog", log);
}
function _INTERNAL_flushLogsBuffer(client, maybeLogBuffer) {
  const logBuffer = maybeLogBuffer ?? _INTERNAL_getLogBuffer(client) ?? [];
  if (logBuffer.length === 0) {
    return;
  }
  const clientOptions = client.getOptions();
  const envelope = createLogEnvelope(
    logBuffer,
    clientOptions._metadata,
    clientOptions.tunnel,
    client.getDsn(),
    client.getDataCollectionOptions().userInfo
  );
  _getBufferMap().set(client, []);
  client.emit("flushLogs");
  client.sendEnvelope(envelope);
}
function _INTERNAL_getLogBuffer(client) {
  return _getBufferMap().get(client);
}
function _getBufferMap() {
  return (0,carrier/* getGlobalSingleton */.BY)("clientToLogBufferMap", () => /* @__PURE__ */ new WeakMap());
}
function sanitizeLogAttributes(attributes) {
  const sanitized = {};
  for (const [key, attr] of Object.entries(attributes)) {
    const sanitizedKey = _removeLoneSurrogates(key);
    if (attr.type === "string") {
      sanitized[sanitizedKey] = { ...attr, value: _removeLoneSurrogates(attr.value) };
    } else {
      sanitized[sanitizedKey] = attr;
    }
  }
  return sanitized;
}
function _removeLoneSurrogates(str) {
  const strObj = Object(str);
  const isWellFormed = strObj["isWellFormed"];
  const toWellFormed = strObj["toWellFormed"];
  if (typeof isWellFormed === "function" && typeof toWellFormed === "function") {
    return isWellFormed.call(str) ? str : toWellFormed.call(str);
  }
  return str;
}



/***/ }),

/***/ 32977:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  g: function() { return /* binding */ _INTERNAL_captureMetric; },
  NG: function() { return /* binding */ _INTERNAL_flushMetricsBuffer; }
});

// UNUSED EXPORTS: _INTERNAL_captureSerializedMetric, _INTERNAL_getMetricBuffer

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/attributes.js
var attributes = __webpack_require__(93778);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/carrier.js
var carrier = __webpack_require__(35179);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/debug-build.js
var debug_build = __webpack_require__(97169);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-logger.js
var debug_logger = __webpack_require__(62183);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/scopeData.js
var scopeData = __webpack_require__(35845);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanOnScope.js
var spanOnScope = __webpack_require__(99070);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/time.js
var time = __webpack_require__(39612);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/timestampSequence.js
var timestampSequence = __webpack_require__(78172);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/trace-info.js
var trace_info = __webpack_require__(65653);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/dsn.js
var utils_dsn = __webpack_require__(56648);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/envelope.js
var envelope = __webpack_require__(22265);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/isBrowser.js
var isBrowser = __webpack_require__(82257);
;// ./node_modules/@sentry/core/build/esm/metrics/envelope.js



function createMetricContainerEnvelopeItem(items, inferUserData) {
  const inferSetting = inferUserData ? "auto" : "never";
  return [
    {
      type: "trace_metric",
      item_count: items.length,
      content_type: "application/vnd.sentry.items.trace-metric+json"
    },
    {
      version: 2,
      ...(0,isBrowser/* isBrowser */.B)() && {
        ingest_settings: { infer_ip: inferSetting, infer_user_agent: inferSetting }
      },
      items
    }
  ];
}
function createMetricEnvelope(metrics, metadata, tunnel, dsn, inferUserData) {
  const headers = {};
  if (metadata?.sdk) {
    headers.sdk = {
      name: metadata.sdk.name,
      version: metadata.sdk.version
    };
  }
  if (!!tunnel && !!dsn) {
    headers.dsn = (0,utils_dsn/* dsnToString */.SB)(dsn);
  }
  return (0,envelope/* createEnvelope */.h4)(headers, [createMetricContainerEnvelopeItem(metrics, inferUserData)]);
}


;// ./node_modules/@sentry/core/build/esm/metrics/internal.js











const MAX_METRIC_BUFFER_SIZE = 1e3;
function setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
  if (value && (setEvenIfPresent || !(key in metricAttributes))) {
    metricAttributes[key] = value;
  }
}
function _INTERNAL_captureSerializedMetric(client, serializedMetric) {
  const bufferMap = _getBufferMap();
  const metricBuffer = _INTERNAL_getMetricBuffer(client);
  if (metricBuffer === void 0) {
    bufferMap.set(client, [serializedMetric]);
  } else {
    if (metricBuffer.length >= MAX_METRIC_BUFFER_SIZE) {
      _INTERNAL_flushMetricsBuffer(client, metricBuffer);
      bufferMap.set(client, [serializedMetric]);
    } else {
      bufferMap.set(client, [...metricBuffer, serializedMetric]);
    }
  }
}
function _enrichMetricAttributes(beforeMetric, client, user) {
  const { release, environment } = client.getOptions();
  const processedMetricAttributes = {
    ...beforeMetric.attributes
  };
  setMetricAttribute(processedMetricAttributes, "user.id", user.id, false);
  setMetricAttribute(processedMetricAttributes, "user.email", user.email, false);
  setMetricAttribute(processedMetricAttributes, "user.name", user.username, false);
  setMetricAttribute(processedMetricAttributes, "sentry.release", release);
  setMetricAttribute(processedMetricAttributes, "sentry.environment", environment);
  const { name, version } = client.getSdkMetadata()?.sdk ?? {};
  setMetricAttribute(processedMetricAttributes, "sentry.sdk.name", name);
  setMetricAttribute(processedMetricAttributes, "sentry.sdk.version", version);
  const replay = client.getIntegrationByName("Replay");
  const replayId = replay?.getReplayId(true);
  setMetricAttribute(processedMetricAttributes, "sentry.replay_id", replayId);
  if (replayId && replay?.getRecordingMode() === "buffer") {
    setMetricAttribute(processedMetricAttributes, "sentry._internal.replay_is_buffering", true);
  }
  return {
    ...beforeMetric,
    attributes: processedMetricAttributes
  };
}
function _buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
  const [, traceContext] = (0,trace_info/* _getTraceInfoFromScope */.V)(client, currentScope);
  const span = (0,spanOnScope/* _getSpanForScope */.f)(currentScope);
  const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
  const spanId = span ? span.spanContext().spanId : void 0;
  const timestamp = (0,time/* timestampInSeconds */.zf)();
  const sequenceAttr = (0,timestampSequence/* getSequenceAttribute */.o)(timestamp);
  return {
    timestamp,
    trace_id: traceId ?? "",
    span_id: spanId,
    name: metric.name,
    type: metric.type,
    unit: metric.unit,
    value: metric.value,
    attributes: {
      ...(0,attributes/* serializeAttributes */.SY)(scopeAttributes),
      ...(0,attributes/* serializeAttributes */.SY)(metric.attributes, "skip-undefined"),
      [sequenceAttr.key]: sequenceAttr.value
    }
  };
}
function _INTERNAL_captureMetric(beforeMetric, options) {
  const currentScope = options?.scope ?? (0,currentScopes/* getCurrentScope */.o5)();
  const captureSerializedMetric = options?.captureSerializedMetric ?? _INTERNAL_captureSerializedMetric;
  const client = currentScope?.getClient() ?? (0,currentScopes/* getClient */.KU)();
  if (!client) {
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn("No client available to capture metric.");
    return;
  }
  const { _experiments, enableMetrics, beforeSendMetric } = client.getOptions();
  const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
  if (!metricsEnabled) {
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn("metrics option not enabled, metric will not be captured.");
    return;
  }
  const { user, attributes: scopeAttributes } = (0,scopeData/* getCombinedScopeData */.Om)((0,currentScopes/* getIsolationScope */.rm)(), currentScope);
  const enrichedMetric = _enrichMetricAttributes(beforeMetric, client, user);
  client.emit("processMetric", enrichedMetric);
  const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
  const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
  if (!processedMetric) {
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log("`beforeSendMetric` returned `null`, will not send metric.");
    return;
  }
  const serializedMetric = _buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
  debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log("[Metric]", serializedMetric);
  captureSerializedMetric(client, serializedMetric);
  client.emit("afterCaptureMetric", processedMetric);
}
function _INTERNAL_flushMetricsBuffer(client, maybeMetricBuffer) {
  const metricBuffer = maybeMetricBuffer ?? _INTERNAL_getMetricBuffer(client) ?? [];
  if (metricBuffer.length === 0) {
    return;
  }
  const clientOptions = client.getOptions();
  const envelope = createMetricEnvelope(
    metricBuffer,
    clientOptions._metadata,
    clientOptions.tunnel,
    client.getDsn(),
    client.getDataCollectionOptions().userInfo
  );
  _getBufferMap().set(client, []);
  client.emit("flushMetrics");
  client.sendEnvelope(envelope);
}
function _INTERNAL_getMetricBuffer(client) {
  return _getBufferMap().get(client);
}
function _getBufferMap() {
  return (0,carrier/* getGlobalSingleton */.BY)("clientToMetricBufferMap", () => /* @__PURE__ */ new WeakMap());
}



/***/ }),

/***/ 61003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   H: function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53835);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62183);
/* harmony import */ var _utils_is_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91973);
/* harmony import */ var _utils_merge_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69201);
/* harmony import */ var _utils_misc_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16513);
/* harmony import */ var _utils_propagationContext_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66508);
/* harmony import */ var _utils_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23324);
/* harmony import */ var _utils_spanOnScope_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99070);
/* harmony import */ var _utils_string_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26228);
/* harmony import */ var _utils_time_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(39612);











const DEFAULT_MAX_BREADCRUMBS = 100;
class Scope {
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._attributes = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = {
      traceId: (0,_utils_propagationContext_js__WEBPACK_IMPORTED_MODULE_6__/* .generateTraceId */ .e)(),
      sampleRand: (0,_utils_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_7__/* .safeMathRandom */ .hY)()
    };
  }
  /**
   * Clone all data from this scope into a new scope.
   */
  clone() {
    const newScope = new Scope();
    newScope._breadcrumbs = [...this._breadcrumbs];
    newScope._tags = { ...this._tags };
    newScope._attributes = { ...this._attributes };
    newScope._extra = { ...this._extra };
    newScope._contexts = { ...this._contexts };
    if (this._contexts.flags) {
      newScope._contexts.flags = {
        values: [...this._contexts.flags.values]
      };
    }
    newScope._user = this._user;
    newScope._level = this._level;
    newScope._session = this._session;
    newScope._transactionName = this._transactionName;
    newScope._fingerprint = this._fingerprint;
    newScope._eventProcessors = [...this._eventProcessors];
    newScope._attachments = [...this._attachments];
    newScope._sdkProcessingMetadata = { ...this._sdkProcessingMetadata };
    newScope._propagationContext = { ...this._propagationContext };
    newScope._client = this._client;
    newScope._lastEventId = this._lastEventId;
    newScope._conversationId = this._conversationId;
    (0,_utils_spanOnScope_js__WEBPACK_IMPORTED_MODULE_8__/* ._setSpanForScope */ .r)(newScope, (0,_utils_spanOnScope_js__WEBPACK_IMPORTED_MODULE_8__/* ._getSpanForScope */ .f)(this));
    return newScope;
  }
  /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */
  setClient(client) {
    this._client = client;
  }
  /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */
  setLastEventId(lastEventId) {
    this._lastEventId = lastEventId;
  }
  /**
   * Get the client assigned to this scope.
   */
  getClient() {
    return this._client;
  }
  /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }
  /**
   * Add an event processor that will be called before an event is sent.
   */
  addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }
  /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */
  setUser(user) {
    this._user = user || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    };
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_1__/* .updateSession */ .qO)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Get the user from this scope.
   */
  getUser() {
    return this._user;
  }
  /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */
  setConversationId(conversationId) {
    this._conversationId = conversationId || void 0;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */
  setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags
    };
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Set a single tag that will be sent as tags data with the event.
   */
  setTag(key, value) {
    return this.setTags({ [key]: value });
  }
  /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */
  setAttributes(newAttributes) {
    this._attributes = {
      ...this._attributes,
      ...newAttributes
    };
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setAttribute(key, value) {
    return this.setAttributes({ [key]: value });
  }
  /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */
  removeAttribute(key) {
    if (key in this._attributes) {
      delete this._attributes[key];
      this._notifyScopeListeners();
    }
    return this;
  }
  /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */
  setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras
    };
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */
  setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */
  setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Sets the level on the scope for future events.
   */
  setLevel(level) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */
  setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */
  setContext(key, context) {
    if (context === null) {
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Set the session for the scope.
   */
  setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Get the session from the scope.
   */
  getSession() {
    return this._session;
  }
  /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */
  update(captureContext) {
    if (!captureContext) {
      return this;
    }
    const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
    const scopeInstance = scopeToMerge instanceof Scope ? scopeToMerge.getScopeData() : (0,_utils_is_js__WEBPACK_IMPORTED_MODULE_3__/* .isPlainObject */ .Qd)(scopeToMerge) ? captureContext : void 0;
    const {
      tags,
      attributes,
      extra,
      user,
      contexts,
      level,
      fingerprint = [],
      propagationContext,
      conversationId
    } = scopeInstance || {};
    this._tags = { ...this._tags, ...tags };
    this._attributes = { ...this._attributes, ...attributes };
    this._extra = { ...this._extra, ...extra };
    this._contexts = { ...this._contexts, ...contexts };
    if (user && Object.keys(user).length) {
      this._user = user;
    }
    if (level) {
      this._level = level;
    }
    if (fingerprint.length) {
      this._fingerprint = fingerprint;
    }
    if (propagationContext) {
      this._propagationContext = propagationContext;
    }
    if (conversationId) {
      this._conversationId = conversationId;
    }
    return this;
  }
  /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */
  clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._attributes = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = void 0;
    this._transactionName = void 0;
    this._fingerprint = void 0;
    this._session = void 0;
    this._conversationId = void 0;
    (0,_utils_spanOnScope_js__WEBPACK_IMPORTED_MODULE_8__/* ._setSpanForScope */ .r)(this, void 0);
    this._attachments = [];
    this.setPropagationContext({
      traceId: (0,_utils_propagationContext_js__WEBPACK_IMPORTED_MODULE_6__/* .generateTraceId */ .e)(),
      sampleRand: (0,_utils_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_7__/* .safeMathRandom */ .hY)()
    });
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */
  addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
    if (maxCrumbs <= 0) {
      return this;
    }
    const mergedBreadcrumb = {
      timestamp: (0,_utils_time_js__WEBPACK_IMPORTED_MODULE_10__/* .dateTimestampInSeconds */ .lu)(),
      ...breadcrumb,
      // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
      message: breadcrumb.message ? (0,_utils_string_js__WEBPACK_IMPORTED_MODULE_9__/* .truncate */ .xv)(breadcrumb.message, 2048) : breadcrumb.message
    };
    this._breadcrumbs.push(mergedBreadcrumb);
    if (this._breadcrumbs.length > maxCrumbs) {
      this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
      this._client?.recordDroppedEvent("buffer_overflow", "log_item");
    }
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Get the last breadcrumb of the scope.
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * Clear all breadcrumbs from the scope.
   */
  clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }
  /**
   * Add an attachment to the scope.
   */
  addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }
  /**
   * Clear all attachments from the scope.
   */
  clearAttachments() {
    this._attachments = [];
    return this;
  }
  /**
   * Get the data of this scope, which should be applied to an event during processing.
   */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      attributes: this._attributes,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: (0,_utils_spanOnScope_js__WEBPACK_IMPORTED_MODULE_8__/* ._getSpanForScope */ .f)(this),
      conversationId: this._conversationId
    };
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */
  setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = (0,_utils_merge_js__WEBPACK_IMPORTED_MODULE_4__/* .merge */ .h)(this._sdkProcessingMetadata, newData, 2);
    return this;
  }
  /**
   * Add propagation context to the scope, used for distributed tracing
   */
  setPropagationContext(context) {
    this._propagationContext = context;
    return this;
  }
  /**
   * Get propagation context from the scope, used for distributed tracing
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */
  captureException(exception, hint) {
    const eventId = hint?.event_id || (0,_utils_misc_js__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .eJ)();
    if (!this._client) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.warn("No client configured on scope - will not capture exception!");
      return eventId;
    }
    const syntheticException = new Error("Sentry syntheticException");
    this._client.captureException(
      exception,
      {
        originalException: exception,
        syntheticException,
        ...hint,
        event_id: eventId
      },
      this
    );
    return eventId;
  }
  /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */
  captureMessage(message, level, hint) {
    const eventId = hint?.event_id || (0,_utils_misc_js__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .eJ)();
    if (!this._client) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.warn("No client configured on scope - will not capture message!");
      return eventId;
    }
    const syntheticException = hint?.syntheticException ?? new Error(message);
    this._client.captureMessage(
      message,
      level,
      {
        originalException: message,
        syntheticException,
        ...hint,
        event_id: eventId
      },
      this
    );
    return eventId;
  }
  /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */
  captureEvent(event, hint) {
    const eventId = event.event_id || hint?.event_id || (0,_utils_misc_js__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .eJ)();
    if (!this._client) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.warn("No client configured on scope - will not capture event!");
      return eventId;
    }
    this._client.captureEvent(event, { ...hint, event_id: eventId }, this);
    return eventId;
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach((callback) => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }
}



/***/ }),

/***/ 35427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: function() { return /* binding */ setCurrentClient; },
/* harmony export */   J: function() { return /* binding */ initAndBind; }
/* harmony export */ });
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79255);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97169);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62183);



function initAndBind(clientClass, options) {
  if (options.debug === true) {
    if (_debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T) {
      _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.enable();
    } else {
      (0,_utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .consoleSandbox */ .pq)(() => {
        console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
      });
    }
  }
  const scope = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .o5)();
  scope.update(options.initialScope);
  const client = new clientClass(options);
  setCurrentClient(client);
  client.init();
  return client;
}
function setCurrentClient(client) {
  (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .o5)().setClient(client);
}



/***/ }),

/***/ 91302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports SEMANTIC_ATTRIBUTE_CACHE_HIT, SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE, SEMANTIC_ATTRIBUTE_CACHE_KEY */
const SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = "sentry.source";
const SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = "sentry.sample_rate";
const SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE = "sentry.previous_trace_sample_rate";
const SEMANTIC_ATTRIBUTE_SENTRY_OP = "sentry.op";
const SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = "sentry.origin";
const SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE = "sentry.status.message";
const SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON = "sentry.idle_span_finish_reason";
const SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT = "sentry.measurement_unit";
const SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE = "sentry.measurement_value";
const SEMANTIC_ATTRIBUTE_SENTRY_RELEASE = "sentry.release";
const SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT = "sentry.environment";
const SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME = "sentry.segment.name";
const SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID = "sentry.segment.id";
const SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME = "sentry.sdk.name";
const SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION = "sentry.sdk.version";
const SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS = "sentry.sdk.integrations";
const SEMANTIC_ATTRIBUTE_USER_ID = "user.id";
const SEMANTIC_ATTRIBUTE_USER_EMAIL = "user.email";
const SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS = "user.ip_address";
const SEMANTIC_ATTRIBUTE_USER_USERNAME = "user.name";
const SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME = "sentry.custom_span_name";
const SEMANTIC_ATTRIBUTE_PROFILE_ID = "sentry.profile_id";
const SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME = "sentry.exclusive_time";
const SEMANTIC_ATTRIBUTE_CACHE_HIT = "cache.hit";
const SEMANTIC_ATTRIBUTE_CACHE_KEY = "cache.key";
const SEMANTIC_ATTRIBUTE_CACHE_ITEM_SIZE = "cache.item_size";
const SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD = "http.request.method";
const SEMANTIC_ATTRIBUTE_URL_FULL = "url.full";
const SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE = "sentry.link.type";
const GEN_AI_CONVERSATION_ID_ATTRIBUTE = "gen_ai.conversation.id";


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "E1", 0, /* binding */ SEMANTIC_ATTRIBUTE_PROFILE_ID,
/* harmony export */   "Ef", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE,
/* harmony export */   "Ft", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE,
/* harmony export */   "Fy", 0, /* binding */ GEN_AI_CONVERSATION_ID_ATTRIBUTE,
/* harmony export */   "JD", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN,
/* harmony export */   "Kh", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_RELEASE,
/* harmony export */   "Kp", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID,
/* harmony export */   "Lc", 0, /* binding */ SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE,
/* harmony export */   "Le", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME,
/* harmony export */   "Sn", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT,
/* harmony export */   "Ts", 0, /* binding */ SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD,
/* harmony export */   "Wp", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT,
/* harmony export */   "Xg", 0, /* binding */ SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS,
/* harmony export */   "_8", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME,
/* harmony export */   "bC", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME,
/* harmony export */   "c9", 0, /* binding */ SEMANTIC_ATTRIBUTE_URL_FULL,
/* harmony export */   "dB", 0, /* binding */ SEMANTIC_ATTRIBUTE_USER_EMAIL,
/* harmony export */   "fU", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS,
/* harmony export */   "fs", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON,
/* harmony export */   "g1", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION,
/* harmony export */   "i_", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SOURCE,
/* harmony export */   "jG", 0, /* binding */ SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME,
/* harmony export */   "oJ", 0, /* binding */ SEMANTIC_ATTRIBUTE_USER_ID,
/* harmony export */   "sy", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE,
/* harmony export */   "uT", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_OP,
/* harmony export */   "xc", 0, /* binding */ SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE,
/* harmony export */   "zR", 0, /* binding */ SEMANTIC_ATTRIBUTE_USER_USERNAME
/* harmony export */ ]);


/***/ }),

/***/ 53835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Vu: function() { return /* binding */ closeSession; },
/* harmony export */   fj: function() { return /* binding */ makeSession; },
/* harmony export */   qO: function() { return /* binding */ updateSession; }
/* harmony export */ });
/* harmony import */ var _utils_misc_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16513);
/* harmony import */ var _utils_time_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39612);


function makeSession(context) {
  const startingTime = (0,_utils_time_js__WEBPACK_IMPORTED_MODULE_1__/* .timestampInSeconds */ .zf)();
  const session = {
    sid: (0,_utils_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .eJ)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session)
  };
  if (context) {
    updateSession(session, context);
  }
  return session;
}
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }
    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }
  session.timestamp = context.timestamp || (0,_utils_time_js__WEBPACK_IMPORTED_MODULE_1__/* .timestampInSeconds */ .zf)();
  if (context.abnormal_mechanism) {
    session.abnormal_mechanism = context.abnormal_mechanism;
  }
  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    session.sid = context.sid.length === 32 ? context.sid : (0,_utils_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .eJ)();
  }
  if (context.init !== void 0) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === "number") {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = void 0;
  } else if (typeof context.duration === "number") {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === "number") {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === "ok") {
    context = { status: "exited" };
  }
  updateSession(session, context);
}
function sessionToJSON(session) {
  return {
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1e3).toISOString(),
    timestamp: new Date(session.timestamp * 1e3).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
    duration: session.duration,
    abnormal_mechanism: session.abnormal_mechanism,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent
    }
  };
}



/***/ }),

/***/ 49271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HW: function() { return /* binding */ spanToBaggageHeader; },
/* harmony export */   LZ: function() { return /* binding */ freezeDscOnSpan; },
/* harmony export */   ao: function() { return /* binding */ getDynamicSamplingContextFromScope; },
/* harmony export */   k1: function() { return /* binding */ getDynamicSamplingContextFromSpan; }
/* harmony export */ });
/* unused harmony export getDynamicSamplingContextFromClient */
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9358);
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79255);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91302);
/* harmony import */ var _utils_baggage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94787);
/* harmony import */ var _utils_dsn_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(56648);
/* harmony import */ var _utils_hasSpansEnabled_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91811);
/* harmony import */ var _utils_object_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50742);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42896);
/* harmony import */ var _sentryNonRecordingSpan_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45729);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(28175);










const FROZEN_DSC_FIELD = "_frozenDsc";
function freezeDscOnSpan(span, dsc) {
  const spanWithMaybeDsc = span;
  (0,_utils_object_js__WEBPACK_IMPORTED_MODULE_6__/* .addNonEnumerableProperty */ .my)(spanWithMaybeDsc, FROZEN_DSC_FIELD, dsc);
}
function getDynamicSamplingContextFromClient(trace_id, client) {
  const options = client.getOptions();
  const { publicKey: public_key } = client.getDsn() || {};
  const dsc = {
    environment: options.environment || _constants_js__WEBPACK_IMPORTED_MODULE_0__/* .DEFAULT_ENVIRONMENT */ .U,
    release: options.release,
    public_key,
    trace_id,
    org_id: (0,_utils_dsn_js__WEBPACK_IMPORTED_MODULE_4__/* .extractOrgIdFromClient */ .ul)(client)
  };
  client.emit("createDsc", dsc);
  return dsc;
}
function getDynamicSamplingContextFromScope(client, scope) {
  const propagationContext = scope.getPropagationContext();
  return propagationContext.dsc || getDynamicSamplingContextFromClient(propagationContext.traceId, client);
}
function getDynamicSamplingContextFromSpan(span) {
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_1__/* .getClient */ .KU)();
  if (!client) {
    return {};
  }
  const rootSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .getRootSpan */ .zU)(span);
  const rootSpanJson = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .spanToJSON */ .et)(rootSpan);
  const rootSpanAttributes = rootSpanJson.data;
  const traceState = rootSpan.spanContext().traceState;
  const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */ .sy] ?? rootSpanAttributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE */ .Ef];
  function applyLocalSampleRateToDsc(dsc2) {
    if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") {
      dsc2.sample_rate = `${rootSpanSampleRate}`;
    }
    return dsc2;
  }
  const frozenDsc = rootSpan[FROZEN_DSC_FIELD];
  if (frozenDsc) {
    return applyLocalSampleRateToDsc(frozenDsc);
  }
  if ((0,_sentryNonRecordingSpan_js__WEBPACK_IMPORTED_MODULE_8__/* .spanIsNonRecordingSpan */ .h)(rootSpan) && !(0,_utils_hasSpansEnabled_js__WEBPACK_IMPORTED_MODULE_5__/* .hasSpansEnabled */ .f)(client.getOptions())) {
    const capturedScope = (0,_utils_js__WEBPACK_IMPORTED_MODULE_9__/* .getCapturedScopesOnSpan */ .Lb)(rootSpan).scope;
    if (capturedScope) {
      return applyLocalSampleRateToDsc({ ...getDynamicSamplingContextFromScope(client, capturedScope) });
    }
  }
  const traceStateDsc = traceState?.get("sentry.dsc");
  const dscOnTraceState = traceStateDsc && (0,_utils_baggage_js__WEBPACK_IMPORTED_MODULE_3__/* .baggageHeaderToDynamicSamplingContext */ .yD)(traceStateDsc);
  if (dscOnTraceState) {
    return applyLocalSampleRateToDsc(dscOnTraceState);
  }
  const dsc = getDynamicSamplingContextFromClient(span.spanContext().traceId, client);
  const source = rootSpanAttributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_2__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .i_] ?? rootSpanAttributes["sentry.span.source"];
  const name = rootSpanJson.description;
  if (source !== "url" && name) {
    dsc.transaction = name;
  }
  if ((0,_utils_hasSpansEnabled_js__WEBPACK_IMPORTED_MODULE_5__/* .hasSpansEnabled */ .f)()) {
    dsc.sampled = String((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_7__/* .spanIsSampled */ .pK)(rootSpan));
    dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
    // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
    traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
    (0,_utils_js__WEBPACK_IMPORTED_MODULE_9__/* .getCapturedScopesOnSpan */ .Lb)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
  }
  applyLocalSampleRateToDsc(dsc);
  client.emit("createDsc", dsc, rootSpan);
  return dsc;
}
function spanToBaggageHeader(span) {
  const dsc = getDynamicSamplingContextFromSpan(span);
  return (0,_utils_baggage_js__WEBPACK_IMPORTED_MODULE_3__/* .dynamicSamplingContextToSentryBaggageHeader */ .De)(dsc);
}



/***/ }),

/***/ 25443:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   s: function() { return /* binding */ registerSpanErrorInstrumentation; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _instrument_globalError_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38482);
/* harmony import */ var _instrument_globalUnhandledRejection_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76676);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62183);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42896);






let errorsInstrumented = false;
function registerSpanErrorInstrumentation() {
  if (errorsInstrumented) {
    return;
  }
  function errorCallback() {
    const activeSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_4__/* .getActiveSpan */ .Bk)();
    const rootSpan = activeSpan && (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_4__/* .getRootSpan */ .zU)(activeSpan);
    if (rootSpan) {
      const message = "internal_error";
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_3__/* .debug */ .Yz.log(`[Tracing] Root span: ${message} -> Global error occurred`);
      rootSpan.setStatus({ code: (/* inlined export .SPAN_STATUS_ERROR */2), message });
    }
  }
  errorsInstrumented = true;
  (0,_instrument_globalError_js__WEBPACK_IMPORTED_MODULE_1__/* .addGlobalErrorInstrumentationHandler */ .L)(errorCallback);
  (0,_instrument_globalUnhandledRejection_js__WEBPACK_IMPORTED_MODULE_2__/* .addGlobalUnhandledRejectionInstrumentationHandler */ .r)(errorCallback);
}



/***/ }),

/***/ 34223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   U: function() { return /* binding */ logSpanEnd; },
/* harmony export */   z: function() { return /* binding */ logSpanStart; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62183);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42896);



function logSpanStart(span) {
  if (!_debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T) return;
  const { description = "< unknown name >", op = "< unknown op >", parent_span_id: parentSpanId } = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .spanToJSON */ .et)(span);
  const { spanId } = span.spanContext();
  const sampled = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .spanIsSampled */ .pK)(span);
  const rootSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .getRootSpan */ .zU)(span);
  const isRootSpan = rootSpan === span;
  const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
  const infoParts = [`op: ${op}`, `name: ${description}`, `ID: ${spanId}`];
  if (parentSpanId) {
    infoParts.push(`parent ID: ${parentSpanId}`);
  }
  if (!isRootSpan) {
    const { op: op2, description: description2 } = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .spanToJSON */ .et)(rootSpan);
    infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
    if (op2) {
      infoParts.push(`root op: ${op2}`);
    }
    if (description2) {
      infoParts.push(`root description: ${description2}`);
    }
  }
  _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.log(`${header}
  ${infoParts.join("\n  ")}`);
}
function logSpanEnd(span) {
  if (!_debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T) return;
  const { description = "< unknown name >", op = "< unknown op >" } = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .spanToJSON */ .et)(span);
  const { spanId } = span.spanContext();
  const rootSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .getRootSpan */ .zU)(span);
  const isRootSpan = rootSpan === span;
  const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
  _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.log(msg);
}



/***/ }),

/***/ 54886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $: function() { return /* binding */ timedEventsToMeasurements; },
/* harmony export */   X: function() { return /* binding */ setMeasurement; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91302);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62183);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42896);




function setMeasurement(name, value, unit, activeSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .getActiveSpan */ .Bk)()) {
  const rootSpan = activeSpan && (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .getRootSpan */ .zU)(activeSpan);
  if (rootSpan) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_2__/* .debug */ .Yz.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
    rootSpan.addEvent(name, {
      [_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE */ .xc]: value,
      [_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT */ .Sn]: unit
    });
  }
}
function timedEventsToMeasurements(events) {
  if (!events || events.length === 0) {
    return void 0;
  }
  const measurements = {};
  events.forEach((event) => {
    const attributes = event.attributes || {};
    const unit = attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT */ .Sn];
    const value = attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_1__/* .SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE */ .xc];
    if (typeof unit === "string" && typeof value === "number") {
      measurements[event.name] = { value, unit };
    }
  });
  return measurements;
}



/***/ }),

/***/ 45729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: function() { return /* binding */ spanIsNonRecordingSpan; },
/* harmony export */   w: function() { return /* binding */ SentryNonRecordingSpan; }
/* harmony export */ });
/* harmony import */ var _utils_object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50742);
/* harmony import */ var _utils_propagationContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66508);



const NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class SentryNonRecordingSpan {
  constructor(spanContext = {}) {
    this._traceId = spanContext.traceId || (0,_utils_propagationContext_js__WEBPACK_IMPORTED_MODULE_1__/* .generateTraceId */ .e)();
    this._spanId = spanContext.spanId || (0,_utils_propagationContext_js__WEBPACK_IMPORTED_MODULE_1__/* .generateSpanId */ .Z)();
    this.dropReason = spanContext.dropReason;
    (0,_utils_object_js__WEBPACK_IMPORTED_MODULE_0__/* .addNonEnumerableProperty */ .my)(this, NON_RECORDING_SPAN_FIELD, true);
  }
  /** @inheritdoc */
  spanContext() {
    return {
      spanId: this._spanId,
      traceId: this._traceId,
      traceFlags: (/* inlined export .TRACE_FLAG_NONE */0)
    };
  }
  /** @inheritdoc */
  end(_timestamp) {
  }
  /** @inheritdoc */
  setAttribute(_key, _value) {
    return this;
  }
  /** @inheritdoc */
  setAttributes(_values) {
    return this;
  }
  /** @inheritdoc */
  setStatus(_status) {
    return this;
  }
  /** @inheritdoc */
  updateName(_name) {
    return this;
  }
  /** @inheritdoc */
  isRecording() {
    return false;
  }
  /** @inheritdoc */
  addEvent(_name, _attributesOrStartTime, _startTime) {
    return this;
  }
  /** @inheritDoc */
  addLink(_link) {
    return this;
  }
  /** @inheritDoc */
  addLinks(_links) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(_exception, _time) {
  }
}
function spanIsNonRecordingSpan(span) {
  return !!span && span[NON_RECORDING_SPAN_FIELD] === true;
}



/***/ }),

/***/ 76303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   W: function() { return /* binding */ SentrySpan; }
/* harmony export */ });
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79255);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97169);
/* harmony import */ var _envelope_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81507);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91302);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62183);
/* harmony import */ var _utils_propagationContext_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66508);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42896);
/* harmony import */ var _utils_time_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39612);
/* harmony import */ var _dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49271);
/* harmony import */ var _logSpans_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34223);
/* harmony import */ var _measurement_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54886);
/* harmony import */ var _spans_hasSpanStreamingEnabled_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97989);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28175);













const MAX_SPAN_COUNT = 1e3;
class SentrySpan {
  /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(spanContext = {}) {
    this._traceId = spanContext.traceId || (0,_utils_propagationContext_js__WEBPACK_IMPORTED_MODULE_5__/* .generateTraceId */ .e)();
    this._spanId = spanContext.spanId || (0,_utils_propagationContext_js__WEBPACK_IMPORTED_MODULE_5__/* .generateSpanId */ .Z)();
    this._startTime = spanContext.startTimestamp || (0,_utils_time_js__WEBPACK_IMPORTED_MODULE_7__/* .timestampInSeconds */ .zf)();
    this._links = spanContext.links;
    this._attributes = {};
    this.setAttributes({
      [_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .JD]: "manual",
      [_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .uT]: spanContext.op,
      ...spanContext.attributes
    });
    this._name = spanContext.name;
    if (spanContext.parentSpanId) {
      this._parentSpanId = spanContext.parentSpanId;
    }
    if ("sampled" in spanContext) {
      this._sampled = spanContext.sampled;
    }
    if (spanContext.endTimestamp) {
      this._endTime = spanContext.endTimestamp;
    }
    this._events = [];
    this._isStandaloneSpan = spanContext.isStandalone;
    if (this._endTime) {
      this._onSpanEnded();
    }
  }
  /** @inheritDoc */
  addLink(link) {
    if (this._links) {
      this._links.push(link);
    } else {
      this._links = [link];
    }
    return this;
  }
  /** @inheritDoc */
  addLinks(links) {
    if (this._links) {
      this._links.push(...links);
    } else {
      this._links = links;
    }
    return this;
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(_exception, _time) {
  }
  /** @inheritdoc */
  spanContext() {
    const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
    return {
      spanId,
      traceId,
      traceFlags: sampled ? (/* inlined export .TRACE_FLAG_SAMPLED */1) : (/* inlined export .TRACE_FLAG_NONE */0)
    };
  }
  /** @inheritdoc */
  setAttribute(key, value) {
    if (value === void 0) {
      delete this._attributes[key];
    } else {
      this._attributes[key] = value;
    }
    return this;
  }
  /** @inheritdoc */
  setAttributes(attributes) {
    Object.keys(attributes).forEach((key) => this.setAttribute(key, attributes[key]));
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */
  updateStartTime(timeInput) {
    this._startTime = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .spanTimeInputToSeconds */ .cI)(timeInput);
  }
  /**
   * @inheritDoc
   */
  setStatus(value) {
    this._status = value;
    return this;
  }
  /**
   * @inheritDoc
   */
  updateName(name) {
    this._name = name;
    if (!(0,_utils_js__WEBPACK_IMPORTED_MODULE_12__/* .spanShouldInferOtelSource */ .ZO)(this)) {
      this.setAttribute(_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .i_, "custom");
    }
    return this;
  }
  /** @inheritdoc */
  end(endTimestamp) {
    if (this._endTime) {
      return;
    }
    this._endTime = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .spanTimeInputToSeconds */ .cI)(endTimestamp);
    (0,_logSpans_js__WEBPACK_IMPORTED_MODULE_9__/* .logSpanEnd */ .U)(this);
    this._onSpanEnded();
  }
  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
  getSpanJSON() {
    return {
      data: this._attributes,
      description: this._name,
      op: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .uT],
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .getStatusMessage */ .yW)(this._status),
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .JD],
      profile_id: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_PROFILE_ID */ .E1],
      exclusive_time: this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_EXCLUSIVE_TIME */ .jG],
      measurements: (0,_measurement_js__WEBPACK_IMPORTED_MODULE_10__/* .timedEventsToMeasurements */ .$)(this._events),
      is_segment: this._isStandaloneSpan && (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .getRootSpan */ .zU)(this) === this || void 0,
      segment_id: this._isStandaloneSpan ? (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .getRootSpan */ .zU)(this).spanContext().spanId : void 0,
      links: (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .convertSpanLinksForEnvelope */ .uU)(this._links)
    };
  }
  /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */
  getStreamedSpanJSON() {
    return {
      name: this._name ?? "",
      span_id: this._spanId,
      trace_id: this._traceId,
      parent_span_id: this._parentSpanId,
      start_timestamp: this._startTime,
      // just in case _endTime is not set, we use the start time (i.e. duration 0)
      end_timestamp: this._endTime ?? this._startTime,
      is_segment: this._isStandaloneSpan || this === (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .getRootSpan */ .zU)(this),
      status: (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .getSimpleStatus */ .dZ)(this._status),
      attributes: (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .addStatusMessageAttribute */ .fy)(this._attributes, this._status),
      links: (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .getStreamedSpanLinks */ .HQ)(this._links)
    };
  }
  /** @inheritdoc */
  isRecording() {
    return !this._endTime && !!this._sampled;
  }
  /**
   * @inheritdoc
   */
  addEvent(name, attributesOrStartTime, startTime) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_4__/* .debug */ .Yz.log("[Tracing] Adding an event to span:", name);
    const time = isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0,_utils_time_js__WEBPACK_IMPORTED_MODULE_7__/* .timestampInSeconds */ .zf)();
    const attributes = isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
    const event = {
      name,
      time: (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .spanTimeInputToSeconds */ .cI)(time),
      attributes
    };
    this._events.push(event);
    return this;
  }
  /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */
  isStandaloneSpan() {
    return !!this._isStandaloneSpan;
  }
  /** Emit `spanEnd` when the span is ended. */
  _onSpanEnded() {
    const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .KU)();
    if (client) {
      client.emit("spanEnd", this);
      if (!this._isStandaloneSpan) {
        client.emit("afterSpanEnd", this);
      }
    }
    const isSegmentSpan = this._isStandaloneSpan || this === (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .getRootSpan */ .zU)(this);
    if (!isSegmentSpan) {
      return;
    }
    if (this._isStandaloneSpan) {
      if (this._sampled) {
        sendSpanEnvelope((0,_envelope_js__WEBPACK_IMPORTED_MODULE_2__/* .createSpanEnvelope */ .lu)([this], client));
      } else {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_4__/* .debug */ .Yz.log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
        if (client) {
          client.recordDroppedEvent("sample_rate", "span");
        }
      }
      return;
    } else if (client && (0,_spans_hasSpanStreamingEnabled_js__WEBPACK_IMPORTED_MODULE_11__/* .hasSpanStreamingEnabled */ .K)(client)) {
      client.emit("afterSegmentSpanEnd", this);
      return;
    }
    const transactionEvent = this._convertSpanToTransaction();
    if (transactionEvent) {
      const scope = (0,_utils_js__WEBPACK_IMPORTED_MODULE_12__/* .getCapturedScopesOnSpan */ .Lb)(this).scope || (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentScope */ .o5)();
      scope.captureEvent(transactionEvent);
    }
  }
  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
  _convertSpanToTransaction() {
    if (!isFullFinishedSpan((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .spanToJSON */ .et)(this))) {
      return void 0;
    }
    if (!this._name) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_4__/* .debug */ .Yz.warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
      this._name = "<unlabeled transaction>";
    }
    const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0,_utils_js__WEBPACK_IMPORTED_MODULE_12__/* .getCapturedScopesOnSpan */ .Lb)(this);
    const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
    if (this._sampled !== true) {
      return void 0;
    }
    const finishedSpans = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .getSpanDescendants */ .xO)(this).filter((span) => span !== this && !isStandaloneSpan(span));
    const spans = finishedSpans.map((span) => (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .spanToJSON */ .et)(span)).filter(isFullFinishedSpan);
    const source = this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .i_];
    delete this._attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME */ .Le];
    let hasGenAiSpans = false;
    spans.forEach((span) => {
      delete span.data[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_3__/* .SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME */ .Le];
      if (span.op?.startsWith("gen_ai.")) {
        hasGenAiSpans = true;
      }
    });
    const transaction = {
      contexts: {
        trace: (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_6__/* .spanToTransactionTraceContext */ .Ck)(this)
      },
      spans: (
        // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
        // we do not use spans anymore after this point
        spans.length > MAX_SPAN_COUNT ? spans.sort((a, b) => a.start_timestamp - b.start_timestamp).slice(0, MAX_SPAN_COUNT) : spans
      ),
      start_timestamp: this._startTime,
      timestamp: this._endTime,
      transaction: this._name,
      type: "transaction",
      sdkProcessingMetadata: {
        capturedSpanScope,
        capturedSpanIsolationScope,
        dynamicSamplingContext: (0,_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_8__/* .getDynamicSamplingContextFromSpan */ .k1)(this),
        hasGenAiSpans
      },
      request: normalizedRequest,
      ...source && {
        transaction_info: {
          source
        }
      }
    };
    const measurements = (0,_measurement_js__WEBPACK_IMPORTED_MODULE_10__/* .timedEventsToMeasurements */ .$)(this._events);
    const hasMeasurements = measurements && Object.keys(measurements).length;
    if (hasMeasurements) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_4__/* .debug */ .Yz.log(
        "[Measurements] Adding measurements to transaction event",
        JSON.stringify(measurements, void 0, 2)
      );
      transaction.measurements = measurements;
    }
    return transaction;
  }
}
function isSpanTimeInput(value) {
  return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function isFullFinishedSpan(input) {
  return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function isStandaloneSpan(span) {
  return span instanceof SentrySpan && span.isStandaloneSpan();
}
function sendSpanEnvelope(envelope) {
  const client = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .KU)();
  if (!client) {
    return;
  }
  const spanItems = envelope[1];
  if (!spanItems || spanItems.length === 0) {
    client.recordDroppedEvent("before_send", "span");
    return;
  }
  client.sendEnvelope(envelope);
}



/***/ }),

/***/ 62635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   S: function() { return /* binding */ isStreamedBeforeSendSpanCallback; },
/* harmony export */   e: function() { return /* binding */ withStreamedSpan; }
/* harmony export */ });
/* harmony import */ var _utils_object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50742);

function withStreamedSpan(callback) {
  (0,_utils_object_js__WEBPACK_IMPORTED_MODULE_0__/* .addNonEnumerableProperty */ .my)(callback, "_streamed", true);
  return callback;
}
function isStreamedBeforeSendSpanCallback(callback) {
  return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}



/***/ }),

/***/ 18912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  JI: function() { return /* binding */ captureSpan; },
  FD: function() { return /* binding */ safeSetSpanJSONAttributes; }
});

// UNUSED EXPORTS: applyBeforeSendSpanCallback

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91302);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/scopeData.js
var scopeData = __webpack_require__(35845);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(42896);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/utils.js
var utils = __webpack_require__(28175);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/spans/beforeSendSpan.js
var spans_beforeSendSpan = __webpack_require__(62635);
;// ./node_modules/@sentry/core/build/esm/tracing/spans/scopeContextAttributes.js
function scopeContextsToSpanAttributes(contexts) {
  const attrs = {};
  const { response, profile, cloud_resource, culture, state } = contexts;
  if (response) {
    if (response.status_code != null) {
      attrs["http.response.status_code"] = response.status_code;
    }
    if (response.body_size != null) {
      attrs["http.response.body.size"] = response.body_size;
    }
  }
  if (profile) {
    if (profile.profile_id) {
      attrs["sentry.profile_id"] = profile.profile_id;
    }
    if (profile.profiler_id) {
      attrs["sentry.profiler_id"] = profile.profiler_id;
    }
  }
  if (cloud_resource) {
    for (const [key, value] of Object.entries(cloud_resource)) {
      if (value != null) {
        attrs[key] = value;
      }
    }
  }
  if (culture) {
    if (culture.locale) {
      attrs["culture.locale"] = culture.locale;
    }
    if (culture.timezone) {
      attrs["culture.timezone"] = culture.timezone;
    }
  }
  if (state?.state && typeof state.state.type === "string") {
    attrs["state.type"] = state.state.type;
  }
  const angular = contexts["angular"];
  if (angular) {
    const version = angular["version"];
    if (typeof version === "string" || typeof version === "number") {
      attrs["angular.version"] = version;
    }
  }
  const react = contexts["react"];
  if (react) {
    const version = react["version"];
    if (typeof version === "string" || typeof version === "number") {
      attrs["react.version"] = version;
    }
  }
  return attrs;
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/constants.js
var constants = __webpack_require__(9358);
;// ./node_modules/@sentry/core/build/esm/tracing/spans/captureSpan.js







function captureSpan(span, client) {
  const spanJSON = (0,spanUtils/* spanToStreamedSpanJSON */.RD)(span);
  const segmentSpan = (0,spanUtils/* INTERNAL_getSegmentSpan */.aW)(span);
  const serializedSegmentSpan = (0,spanUtils/* spanToStreamedSpanJSON */.RD)(segmentSpan);
  const { isolationScope: spanIsolationScope, scope: spanScope } = (0,utils/* getCapturedScopesOnSpan */.Lb)(span);
  const finalScopeData = (0,scopeData/* getCombinedScopeData */.Om)(spanIsolationScope, spanScope);
  applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, finalScopeData);
  const spanKind = span.kind;
  client.emit("preprocessSpan", spanJSON, { spanKind });
  if (spanJSON.is_segment) {
    applyScopeToSegmentSpan(spanJSON, finalScopeData);
    applySdkMetadataToSegmentSpan(spanJSON, client);
    client.emit("processSegmentSpan", spanJSON);
  }
  client.emit("processSpan", spanJSON);
  const { beforeSendSpan } = client.getOptions();
  const processedSpan = beforeSendSpan && (0,spans_beforeSendSpan/* isStreamedBeforeSendSpanCallback */.S)(beforeSendSpan) ? applyBeforeSendSpanCallback(spanJSON, beforeSendSpan) : spanJSON;
  const spanNameSource = processedSpan.attributes?.[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.i_];
  if (spanNameSource) {
    safeSetSpanJSONAttributes(processedSpan, {
      // Purposefully not using a constant defined here like in other attributes:
      // This will be the name for SEMANTIC_ATTRIBUTE_SENTRY_SOURCE in v11
      "sentry.span.source": spanNameSource
    });
  }
  return {
    ...(0,spanUtils/* streamedSpanJsonToSerializedSpan */.PL)(processedSpan),
    _segmentSpan: segmentSpan
  };
}
function applyScopeToSegmentSpan(segmentSpanJSON, scopeData) {
  const contextAttributes = scopeContextsToSpanAttributes(scopeData.contexts);
  safeSetSpanJSONAttributes(segmentSpanJSON, contextAttributes);
}
function safeSetSpanJSONAttributes(spanJSON, newAttributes) {
  const originalAttributes = spanJSON.attributes ?? (spanJSON.attributes = {});
  Object.entries(newAttributes).forEach(([key, value]) => {
    if (value != null && !(key in originalAttributes)) {
      originalAttributes[key] = value;
    }
  });
}
function applySdkMetadataToSegmentSpan(segmentSpanJSON, client) {
  const integrationNames = client.getIntegrationNames();
  if (!integrationNames.length) return;
  safeSetSpanJSONAttributes(segmentSpanJSON, {
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SDK_INTEGRATIONS */.fU]: integrationNames
  });
}
function applyCommonSpanAttributes(spanJSON, serializedSegmentSpan, client, scopeData) {
  const sdk = client.getSdkMetadata();
  const { release, environment } = client.getOptions();
  safeSetSpanJSONAttributes(spanJSON, {
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_RELEASE */.Kh]: release,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ENVIRONMENT */.Wp]: environment || constants/* DEFAULT_ENVIRONMENT */.U,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_NAME */._8]: serializedSegmentSpan.name,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SEGMENT_ID */.Kp]: serializedSegmentSpan.span_id,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SDK_NAME */.bC]: sdk?.sdk?.name,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SDK_VERSION */.g1]: sdk?.sdk?.version,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_USER_ID */.oJ]: scopeData.user?.id,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_USER_EMAIL */.dB]: scopeData.user?.email,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_USER_IP_ADDRESS */.Xg]: scopeData.user?.ip_address,
    [semanticAttributes/* SEMANTIC_ATTRIBUTE_USER_USERNAME */.zR]: scopeData.user?.username,
    ...scopeData.attributes
  });
}
function applyBeforeSendSpanCallback(span, beforeSendSpan) {
  const modifedSpan = beforeSendSpan(span);
  if (!modifedSpan) {
    (0,spanUtils/* showSpanDropWarning */.xl)();
    return span;
  }
  return modifedSpan;
}



/***/ }),

/***/ 97989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: function() { return /* binding */ hasSpanStreamingEnabled; }
/* harmony export */ });
function hasSpanStreamingEnabled(client) {
  return client.getOptions().traceLifecycle === "stream";
}



/***/ }),

/***/ 20950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ getSpanStatusFromHttpCode; },
/* harmony export */   N: function() { return /* binding */ setHttpStatus; }
/* harmony export */ });
const SPAN_STATUS_UNSET = 0;
const SPAN_STATUS_OK = 1;
const SPAN_STATUS_ERROR = 2;
function getSpanStatusFromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return { code: SPAN_STATUS_OK };
  }
  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return { code: SPAN_STATUS_ERROR, message: "unauthenticated" };
      case 403:
        return { code: SPAN_STATUS_ERROR, message: "permission_denied" };
      case 404:
        return { code: SPAN_STATUS_ERROR, message: "not_found" };
      case 409:
        return { code: SPAN_STATUS_ERROR, message: "already_exists" };
      case 413:
        return { code: SPAN_STATUS_ERROR, message: "failed_precondition" };
      case 429:
        return { code: SPAN_STATUS_ERROR, message: "resource_exhausted" };
      case 499:
        return { code: SPAN_STATUS_ERROR, message: "cancelled" };
      default:
        return { code: SPAN_STATUS_ERROR, message: "invalid_argument" };
    }
  }
  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return { code: SPAN_STATUS_ERROR, message: "unimplemented" };
      case 503:
        return { code: SPAN_STATUS_ERROR, message: "unavailable" };
      case 504:
        return { code: SPAN_STATUS_ERROR, message: "deadline_exceeded" };
      default:
        return { code: SPAN_STATUS_ERROR, message: "internal_error" };
    }
  }
  return { code: SPAN_STATUS_ERROR, message: "internal_error" };
}
function setHttpStatus(span, httpStatus) {
  span.setAttribute("http.response.status_code", httpStatus);
  const spanStatus = getSpanStatusFromHttpCode(httpStatus);
  if (spanStatus.message !== "unknown_error") {
    span.setStatus(spanStatus);
  }
}



/***/ }),

/***/ 1523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  V4: function() { return /* binding */ continueTrace; },
  Uk: function() { return /* binding */ startInactiveSpan; },
  Y7: function() { return /* binding */ startNewTrace; },
  Lk: function() { return /* binding */ startSpan; },
  nV: function() { return /* binding */ startSpanManual; },
  M1: function() { return /* binding */ suppressTracing; },
  hb: function() { return /* binding */ withActiveSpan; }
});

// UNUSED EXPORTS: SUPPRESS_TRACING_KEY, isTracingSuppressed

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/asyncContext/index.js + 2 modules
var asyncContext = __webpack_require__(27657);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/carrier.js
var esm_carrier = __webpack_require__(35179);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/debug-build.js
var debug_build = __webpack_require__(97169);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91302);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/baggage.js
var utils_baggage = __webpack_require__(94787);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-logger.js
var debug_logger = __webpack_require__(62183);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/handleCallbackErrors.js
var handleCallbackErrors = __webpack_require__(97879);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/hasSpansEnabled.js
var hasSpansEnabled = __webpack_require__(91811);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/should-ignore-span.js
var should_ignore_span = __webpack_require__(90622);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/spans/hasSpanStreamingEnabled.js
var hasSpanStreamingEnabled = __webpack_require__(97989);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/parseSampleRate.js
var parseSampleRate = __webpack_require__(91554);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/propagationContext.js
var propagationContext = __webpack_require__(66508);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/randomSafeContext.js
var randomSafeContext = __webpack_require__(23324);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanOnScope.js
var spanOnScope = __webpack_require__(99070);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(42896);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/tracing.js
var tracing = __webpack_require__(36779);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/dynamicSamplingContext.js
var dynamicSamplingContext = __webpack_require__(49271);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/logSpans.js
var logSpans = __webpack_require__(34223);
;// ./node_modules/@sentry/core/build/esm/tracing/sampling.js




function sampleSpan(options, samplingContext, sampleRand) {
  if (!(0,hasSpansEnabled/* hasSpansEnabled */.f)(options)) {
    return [false];
  }
  let localSampleRateWasApplied = void 0;
  let sampleRate;
  if (typeof options.tracesSampler === "function") {
    sampleRate = options.tracesSampler({
      ...samplingContext,
      inheritOrSampleWith: (fallbackSampleRate) => {
        if (typeof samplingContext.parentSampleRate === "number") {
          return samplingContext.parentSampleRate;
        }
        if (typeof samplingContext.parentSampled === "boolean") {
          return Number(samplingContext.parentSampled);
        }
        return fallbackSampleRate;
      }
    });
    localSampleRateWasApplied = true;
  } else if (samplingContext.parentSampled !== void 0) {
    sampleRate = samplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== "undefined") {
    sampleRate = options.tracesSampleRate;
    localSampleRateWasApplied = true;
  }
  const parsedSampleRate = (0,parseSampleRate/* parseSampleRate */.i)(sampleRate);
  if (parsedSampleRate === void 0) {
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.warn(
      `[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
        sampleRate
      )} of type ${JSON.stringify(typeof sampleRate)}.`
    );
    return [false];
  }
  if (!parsedSampleRate) {
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log(
      `[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`
    );
    return [false, parsedSampleRate, localSampleRateWasApplied];
  }
  const shouldSample = sampleRand < parsedSampleRate;
  if (!shouldSample) {
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log(
      `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
        sampleRate
      )})`
    );
  }
  return [shouldSample, parsedSampleRate, localSampleRateWasApplied];
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/sentryNonRecordingSpan.js
var sentryNonRecordingSpan = __webpack_require__(45729);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/sentrySpan.js
var sentrySpan = __webpack_require__(76303);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/utils.js
var utils = __webpack_require__(28175);
;// ./node_modules/@sentry/core/build/esm/tracing/trace.js
























const SUPPRESS_TRACING_KEY = "__SENTRY_SUPPRESS_TRACING__";
function startSpan(options, callback) {
  const acs = getAcs();
  if (acs.startSpan) {
    return acs.startSpan(options, callback);
  }
  const spanArguments = parseSentrySpanArguments(options);
  const { forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
  const customForkedScope = customScope?.clone();
  return (0,currentScopes/* withScope */.v4)(customForkedScope, () => {
    const wrapper = getActiveSpanWrapper(customParentSpan);
    return wrapper(() => {
      const scope = (0,currentScopes/* getCurrentScope */.o5)();
      const parentSpan = getParentSpan(scope, customParentSpan);
      const client = (0,currentScopes/* getClient */.KU)();
      const missingRequiredParent = options.onlyIfParent && !parentSpan;
      const activeSpan = missingRequiredParent ? startMissingRequiredParentSpan(scope, client) : createChildOrRootSpan({
        parentSpan,
        spanArguments,
        forceTransaction,
        scope
      });
      if (!_isIgnoredSpan(activeSpan) || !parentSpan) {
        (0,spanOnScope/* _setSpanForScope */.r)(scope, activeSpan);
      }
      return (0,handleCallbackErrors/* handleCallbackErrors */.x)(
        () => callback(activeSpan),
        () => {
          const { status } = (0,spanUtils/* spanToJSON */.et)(activeSpan);
          if (activeSpan.isRecording() && (!status || status === "ok")) {
            activeSpan.setStatus({ code: (/* inlined export .SPAN_STATUS_ERROR */2), message: "internal_error" });
          }
        },
        () => {
          activeSpan.end();
        }
      );
    });
  });
}
function startSpanManual(options, callback) {
  const acs = getAcs();
  if (acs.startSpanManual) {
    return acs.startSpanManual(options, callback);
  }
  const spanArguments = parseSentrySpanArguments(options);
  const { forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
  const customForkedScope = customScope?.clone();
  return (0,currentScopes/* withScope */.v4)(customForkedScope, () => {
    const wrapper = getActiveSpanWrapper(customParentSpan);
    return wrapper(() => {
      const scope = (0,currentScopes/* getCurrentScope */.o5)();
      const parentSpan = getParentSpan(scope, customParentSpan);
      const missingRequiredParent = options.onlyIfParent && !parentSpan;
      const activeSpan = missingRequiredParent ? startMissingRequiredParentSpan(scope, (0,currentScopes/* getClient */.KU)()) : createChildOrRootSpan({
        parentSpan,
        spanArguments,
        forceTransaction,
        scope
      });
      if (!_isIgnoredSpan(activeSpan) || !parentSpan) {
        (0,spanOnScope/* _setSpanForScope */.r)(scope, activeSpan);
      }
      return (0,handleCallbackErrors/* handleCallbackErrors */.x)(
        // We pass the `finish` function to the callback, so the user can finish the span manually
        // this is mainly here for historic purposes because previously, we instructed users to call
        // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
        // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
        () => callback(activeSpan, () => activeSpan.end()),
        () => {
          const { status } = (0,spanUtils/* spanToJSON */.et)(activeSpan);
          if (activeSpan.isRecording() && (!status || status === "ok")) {
            activeSpan.setStatus({ code: (/* inlined export .SPAN_STATUS_ERROR */2), message: "internal_error" });
          }
        }
      );
    });
  });
}
function startInactiveSpan(options) {
  const acs = getAcs();
  if (acs.startInactiveSpan) {
    return acs.startInactiveSpan(options);
  }
  const spanArguments = parseSentrySpanArguments(options);
  const { forceTransaction, parentSpan: customParentSpan } = options;
  const wrapper = options.scope ? (callback) => (0,currentScopes/* withScope */.v4)(options.scope, callback) : customParentSpan !== void 0 ? (callback) => withActiveSpan(customParentSpan, callback) : (callback) => callback();
  return wrapper(() => {
    const scope = (0,currentScopes/* getCurrentScope */.o5)();
    const parentSpan = getParentSpan(scope, customParentSpan);
    const client = (0,currentScopes/* getClient */.KU)();
    const missingRequiredParent = options.onlyIfParent && !parentSpan;
    if (missingRequiredParent) {
      return startMissingRequiredParentSpan(scope, client);
    }
    return createChildOrRootSpan({
      parentSpan,
      spanArguments,
      forceTransaction,
      scope
    });
  });
}
const continueTrace = (options, callback) => {
  const carrier = (0,esm_carrier/* getMainCarrier */.EU)();
  const acs = (0,asyncContext/* getAsyncContextStrategy */.h)(carrier);
  if (acs.continueTrace) {
    return acs.continueTrace(options, callback);
  }
  const { sentryTrace, baggage } = options;
  const client = (0,currentScopes/* getClient */.KU)();
  const incomingDsc = (0,utils_baggage/* baggageHeaderToDynamicSamplingContext */.yD)(baggage);
  if (client && !(0,tracing/* shouldContinueTrace */.A9)(client, incomingDsc?.org_id)) {
    return startNewTrace(callback);
  }
  return (0,currentScopes/* withScope */.v4)((scope) => {
    const propagationContext = (0,tracing/* propagationContextFromHeaders */.kM)(sentryTrace, baggage);
    scope.setPropagationContext(propagationContext);
    (0,spanOnScope/* _setSpanForScope */.r)(scope, void 0);
    return callback();
  });
};
function withActiveSpan(span, callback) {
  const acs = getAcs();
  if (acs.withActiveSpan) {
    return acs.withActiveSpan(span, callback);
  }
  return (0,currentScopes/* withScope */.v4)((scope) => {
    (0,spanOnScope/* _setSpanForScope */.r)(scope, span || void 0);
    return callback(scope);
  });
}
function suppressTracing(callback) {
  const acs = getAcs();
  if (acs.suppressTracing) {
    return acs.suppressTracing(callback);
  }
  return (0,currentScopes/* withScope */.v4)((scope) => {
    scope.setSDKProcessingMetadata({ [SUPPRESS_TRACING_KEY]: true });
    const res = callback();
    scope.setSDKProcessingMetadata({ [SUPPRESS_TRACING_KEY]: void 0 });
    return res;
  });
}
function isTracingSuppressed(scope = (0,currentScopes/* getCurrentScope */.o5)()) {
  const acs = getAcs();
  if (acs.isTracingSuppressed) {
    return acs.isTracingSuppressed(scope);
  }
  return scope.getScopeData().sdkProcessingMetadata[SUPPRESS_TRACING_KEY] === true;
}
function startNewTrace(callback) {
  const acs = getAcs();
  if (acs.startNewTrace) {
    return acs.startNewTrace(callback);
  }
  return (0,currentScopes/* withScope */.v4)((scope) => {
    scope.setPropagationContext({
      traceId: (0,propagationContext/* generateTraceId */.e)(),
      sampleRand: (0,randomSafeContext/* safeMathRandom */.hY)()
    });
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
    return withActiveSpan(null, callback);
  });
}
function startMissingRequiredParentSpan(scope, client) {
  client?.recordDroppedEvent("no_parent_span", "span");
  const span = new sentryNonRecordingSpan/* SentryNonRecordingSpan */.w({ traceId: scope.getPropagationContext().traceId });
  (0,utils/* setCapturedScopesOnSpan */.d_)(span, scope, (0,currentScopes/* getIsolationScope */.rm)());
  return span;
}
function createChildOrRootSpan({
  parentSpan,
  spanArguments,
  forceTransaction,
  scope
}) {
  const isolationScope = (0,currentScopes/* getIsolationScope */.rm)();
  if (!(0,hasSpansEnabled/* hasSpansEnabled */.f)()) {
    const scopePropagationContext = { ...isolationScope.getPropagationContext(), ...scope.getPropagationContext() };
    const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
    const span2 = new sentryNonRecordingSpan/* SentryNonRecordingSpan */.w({ traceId });
    if (parentSpan && !forceTransaction) {
      (0,spanUtils/* addChildSpanToSpan */.Hu)(parentSpan, span2);
    }
    (0,utils/* setCapturedScopesOnSpan */.d_)(span2, scope, isolationScope);
    return span2;
  }
  const client = (0,currentScopes/* getClient */.KU)();
  if (_shouldIgnoreStreamedSpan(client, spanArguments)) {
    if (!isTracingSuppressed(scope)) {
      client?.recordDroppedEvent("ignored", "span");
    }
    const ignoredSpan = new sentryNonRecordingSpan/* SentryNonRecordingSpan */.w({
      dropReason: "ignored",
      traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
    });
    (0,utils/* setCapturedScopesOnSpan */.d_)(ignoredSpan, scope, isolationScope);
    return ignoredSpan;
  }
  let span;
  if (parentSpan && !forceTransaction) {
    span = _startChildSpan(parentSpan, scope, spanArguments, isolationScope);
    (0,spanUtils/* addChildSpanToSpan */.Hu)(parentSpan, span);
  } else if (parentSpan) {
    const dsc = (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.k1)(parentSpan);
    const { traceId, spanId: parentSpanId } = parentSpan.spanContext();
    const parentSampled = (0,spanUtils/* spanIsSampled */.pK)(parentSpan);
    span = _startRootSpan(
      {
        traceId,
        parentSpanId,
        ...spanArguments
      },
      scope,
      isolationScope,
      parentSampled
    );
    (0,dynamicSamplingContext/* freezeDscOnSpan */.LZ)(span, dsc);
  } else {
    const {
      traceId,
      dsc,
      parentSpanId,
      sampled: parentSampled
    } = {
      ...isolationScope.getPropagationContext(),
      ...scope.getPropagationContext()
    };
    span = _startRootSpan(
      {
        traceId,
        parentSpanId,
        ...spanArguments
      },
      scope,
      isolationScope,
      parentSampled
    );
    if (dsc) {
      (0,dynamicSamplingContext/* freezeDscOnSpan */.LZ)(span, dsc);
    }
  }
  (0,logSpans/* logSpanStart */.z)(span);
  return span;
}
function parseSentrySpanArguments(options) {
  const exp = options.experimental || {};
  const initialCtx = {
    isStandalone: exp.standalone,
    ...options
  };
  if (options.startTime) {
    const ctx = { ...initialCtx };
    ctx.startTimestamp = (0,spanUtils/* spanTimeInputToSeconds */.cI)(options.startTime);
    delete ctx.startTime;
    return ctx;
  }
  return initialCtx;
}
function getAcs() {
  const carrier = (0,esm_carrier/* getMainCarrier */.EU)();
  return (0,asyncContext/* getAsyncContextStrategy */.h)(carrier);
}
function _startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
  const client = (0,currentScopes/* getClient */.KU)();
  const options = client?.getOptions() || {};
  const { name = "" } = spanArguments;
  const mutableSpanSamplingData = { spanAttributes: { ...spanArguments.attributes }, spanName: name, parentSampled };
  client?.emit("beforeSampling", mutableSpanSamplingData, { decision: false });
  const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
  const finalAttributes = mutableSpanSamplingData.spanAttributes;
  const currentPropagationContext = scope.getPropagationContext();
  const _isTracingSuppressed = isTracingSuppressed(scope);
  const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [false] : sampleSpan(
    options,
    {
      name,
      parentSampled: finalParentSampled,
      attributes: finalAttributes,
      normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
      parentSampleRate: (0,parseSampleRate/* parseSampleRate */.i)(currentPropagationContext.dsc?.sample_rate)
    },
    currentPropagationContext.sampleRand
  );
  const rootSpan = new sentrySpan/* SentrySpan */.W({
    ...spanArguments,
    attributes: {
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.i_]: "custom",
      [semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE */.sy]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
      ...finalAttributes
    },
    sampled
  });
  if (!sampled && client && !_isTracingSuppressed) {
    debug_build/* DEBUG_BUILD */.T && debug_logger/* debug */.Yz.log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
    client.recordDroppedEvent("sample_rate", (0,hasSpanStreamingEnabled/* hasSpanStreamingEnabled */.K)(client) ? "span" : "transaction");
  }
  (0,utils/* setCapturedScopesOnSpan */.d_)(rootSpan, scope, isolationScope);
  if (client) {
    client.emit("spanStart", rootSpan);
  }
  return rootSpan;
}
function _startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
  const { spanId, traceId } = parentSpan.spanContext();
  const _isTracingSuppressed = isTracingSuppressed(scope);
  const sampled = _isTracingSuppressed ? false : (0,spanUtils/* spanIsSampled */.pK)(parentSpan);
  const childSpan = sampled ? new sentrySpan/* SentrySpan */.W({
    ...spanArguments,
    parentSpanId: spanId,
    traceId,
    sampled
  }) : new sentryNonRecordingSpan/* SentryNonRecordingSpan */.w({ traceId });
  (0,spanUtils/* addChildSpanToSpan */.Hu)(parentSpan, childSpan);
  (0,utils/* setCapturedScopesOnSpan */.d_)(childSpan, scope, isolationScope);
  const client = (0,currentScopes/* getClient */.KU)();
  if (!client) {
    return childSpan;
  }
  if ((0,hasSpanStreamingEnabled/* hasSpanStreamingEnabled */.K)(client) && (0,sentryNonRecordingSpan/* spanIsNonRecordingSpan */.h)(childSpan)) {
    if ((0,sentryNonRecordingSpan/* spanIsNonRecordingSpan */.h)(parentSpan) && parentSpan.dropReason) {
      childSpan.dropReason = parentSpan.dropReason;
      client.recordDroppedEvent(parentSpan.dropReason, "span");
    } else if (!_isTracingSuppressed) {
      childSpan.dropReason = "sample_rate";
      client.recordDroppedEvent("sample_rate", "span");
    }
  }
  client.emit("spanStart", childSpan);
  if (spanArguments.endTimestamp) {
    client.emit("spanEnd", childSpan);
    client.emit("afterSpanEnd", childSpan);
  }
  return childSpan;
}
function getParentSpan(scope, customParentSpan) {
  if (customParentSpan) {
    return customParentSpan;
  }
  if (customParentSpan === null) {
    return void 0;
  }
  const span = (0,spanOnScope/* _getSpanForScope */.f)(scope);
  if (!span) {
    return void 0;
  }
  const client = (0,currentScopes/* getClient */.KU)();
  const options = client ? client.getOptions() : {};
  if (options.parentSpanIsAlwaysRootSpan) {
    return (0,spanUtils/* getRootSpan */.zU)(span);
  }
  return span;
}
function getActiveSpanWrapper(parentSpan) {
  return parentSpan !== void 0 ? (callback) => {
    return withActiveSpan(parentSpan, callback);
  } : (callback) => callback();
}
function _shouldIgnoreStreamedSpan(client, spanArguments) {
  const ignoreSpans = client?.getOptions().ignoreSpans;
  if (!client || !(0,hasSpanStreamingEnabled/* hasSpanStreamingEnabled */.K)(client) || !ignoreSpans?.length) {
    return false;
  }
  return (0,should_ignore_span/* shouldIgnoreSpan */.e)(
    {
      description: spanArguments.name || "",
      op: spanArguments.attributes?.[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.uT] || spanArguments.op,
      attributes: spanArguments.attributes
    },
    ignoreSpans
  );
}
function _isIgnoredSpan(span) {
  return (0,sentryNonRecordingSpan/* spanIsNonRecordingSpan */.h)(span) && span.dropReason === "ignored";
}



/***/ }),

/***/ 28175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Lb: function() { return /* binding */ getCapturedScopesOnSpan; },
/* harmony export */   ZO: function() { return /* binding */ spanShouldInferOtelSource; },
/* harmony export */   d_: function() { return /* binding */ setCapturedScopesOnSpan; }
/* harmony export */ });
/* unused harmony export markSpanForOtelSourceInference */
/* unused harmony import specifier */ var addNonEnumerableProperty;
/* harmony import */ var _utils_object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50742);
/* harmony import */ var _utils_weakRef_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69236);


const SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
function setCapturedScopesOnSpan(span, scope, isolationScope) {
  if (span) {
    (0,_utils_object_js__WEBPACK_IMPORTED_MODULE_0__/* .addNonEnumerableProperty */ .my)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0,_utils_weakRef_js__WEBPACK_IMPORTED_MODULE_1__/* .makeWeakRef */ .Z)(isolationScope));
    (0,_utils_object_js__WEBPACK_IMPORTED_MODULE_0__/* .addNonEnumerableProperty */ .my)(span, SCOPE_ON_START_SPAN_FIELD, scope);
  }
}
function getCapturedScopesOnSpan(span) {
  const spanWithScopes = span;
  return {
    scope: spanWithScopes[SCOPE_ON_START_SPAN_FIELD],
    isolationScope: (0,_utils_weakRef_js__WEBPACK_IMPORTED_MODULE_1__/* .derefWeakRef */ .q)(spanWithScopes[ISOLATION_SCOPE_ON_START_SPAN_FIELD])
  };
}
function markSpanForOtelSourceInference(span) {
  addNonEnumerableProperty(span, OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function spanShouldInferOtelSource(span) {
  return span[OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}



/***/ }),

/***/ 40413:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   o: function() { return /* binding */ createTransport; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62183);
/* harmony import */ var _utils_envelope_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22265);
/* harmony import */ var _utils_promisebuffer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50198);
/* harmony import */ var _utils_ratelimit_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40156);





const DEFAULT_TRANSPORT_BUFFER_SIZE = 64;
function createTransport(options, makeRequest, buffer = (0,_utils_promisebuffer_js__WEBPACK_IMPORTED_MODULE_3__/* .makePromiseBuffer */ .C)(
  options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE
)) {
  let rateLimits = {};
  const flush = (timeout) => buffer.drain(timeout);
  function send(envelope) {
    const filteredEnvelopeItems = [];
    (0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_2__/* .forEachEnvelopeItem */ .yH)(envelope, (item, type) => {
      const dataCategory = (0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_2__/* .envelopeItemTypeToDataCategory */ .zk)(type);
      if ((0,_utils_ratelimit_js__WEBPACK_IMPORTED_MODULE_4__/* .isRateLimited */ .Jz)(rateLimits, dataCategory)) {
        options.recordDroppedEvent("ratelimit_backoff", dataCategory);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });
    if (filteredEnvelopeItems.length === 0) {
      return Promise.resolve({});
    }
    const filteredEnvelope = (0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_2__/* .createEnvelope */ .h4)(envelope[0], filteredEnvelopeItems);
    const recordEnvelopeLoss = (reason) => {
      if ((0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_2__/* .envelopeContainsItemType */ .hP)(filteredEnvelope, ["client_report"])) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
        return;
      }
      (0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_2__/* .forEachEnvelopeItem */ .yH)(filteredEnvelope, (item, type) => {
        options.recordDroppedEvent(reason, (0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_2__/* .envelopeItemTypeToDataCategory */ .zk)(type));
      });
    };
    const requestTask = () => makeRequest({ body: (0,_utils_envelope_js__WEBPACK_IMPORTED_MODULE_2__/* .serializeEnvelope */ .bN)(filteredEnvelope) }).then(
      (response) => {
        if (response.statusCode === 413) {
          _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.error(
            "Sentry responded with status code 413. Envelope was discarded due to exceeding size limits."
          );
          recordEnvelopeLoss("send_error");
          return response;
        }
        if (_debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && response.statusCode !== void 0 && (response.statusCode < 200 || response.statusCode >= 300)) {
          _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
        }
        rateLimits = (0,_utils_ratelimit_js__WEBPACK_IMPORTED_MODULE_4__/* .updateRateLimits */ .wq)(rateLimits, response);
        return response;
      },
      (error) => {
        recordEnvelopeLoss("network_error");
        _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.error("Encountered error running transport request:", error);
        throw error;
      }
    );
    return buffer.add(requestTask).then(
      (result) => result,
      (error) => {
        if (error === _utils_promisebuffer_js__WEBPACK_IMPORTED_MODULE_3__/* .SENTRY_BUFFER_FULL_ERROR */ .a) {
          _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _utils_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.error("Skipped sending event because buffer is full.");
          recordEnvelopeLoss("queue_overflow");
          return Promise.resolve({});
        } else {
          throw error;
        }
      }
    );
  }
  return {
    send,
    flush
  };
}



/***/ }),

/***/ 94787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   De: function() { return /* binding */ dynamicSamplingContextToSentryBaggageHeader; },
/* harmony export */   yD: function() { return /* binding */ baggageHeaderToDynamicSamplingContext; }
/* harmony export */ });
/* unused harmony exports MAX_BAGGAGE_STRING_LENGTH, SENTRY_BAGGAGE_KEY_PREFIX_REGEX, mergeBaggageHeaders, objectToBaggageHeader, parseBaggageHeader */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62183);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91973);



const SENTRY_BAGGAGE_KEY_PREFIX = "sentry-";
const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;
const MAX_BAGGAGE_STRING_LENGTH = 8192;
function baggageHeaderToDynamicSamplingContext(baggageHeader) {
  const baggageObject = parseBaggageHeader(baggageHeader);
  if (!baggageObject) {
    return void 0;
  }
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.startsWith(SENTRY_BAGGAGE_KEY_PREFIX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext;
  } else {
    return void 0;
  }
}
function dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext) {
  if (!dynamicSamplingContext) {
    return void 0;
  }
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {}
  );
  return objectToBaggageHeader(sentryPrefixedDSC);
}
function parseBaggageHeader(baggageHeader) {
  if (!baggageHeader || !(0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isString */ .Kg)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return void 0;
  }
  if (Array.isArray(baggageHeader)) {
    return baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      Object.entries(currBaggageObject).forEach(([key, value]) => {
        acc[key] = value;
      });
      return acc;
    }, {});
  }
  return baggageHeaderToObject(baggageHeader);
}
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader.split(",").map((baggageEntry) => {
    const eqIdx = baggageEntry.indexOf("=");
    if (eqIdx === -1) {
      return [];
    }
    const key = baggageEntry.slice(0, eqIdx);
    const value = baggageEntry.slice(eqIdx + 1);
    return [key, value].map((keyOrValue) => {
      try {
        return decodeURIComponent(keyOrValue.trim());
      } catch {
        return;
      }
    });
  }).reduce((acc, [key, value]) => {
    if (key && value) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    return void 0;
  }
  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.warn(
        `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`
      );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, "");
}
function mergeBaggageHeaders(existing, incoming) {
  if (!existing) {
    return incoming;
  }
  const existingEntries = parseBaggageHeader(existing);
  const incomingEntries = parseBaggageHeader(incoming);
  if (!incomingEntries) {
    return existing;
  }
  const merged = {};
  let hasNewSentryEntries = false;
  const newSentryEntries = {};
  const newNonSentryEntries = {};
  for (const [key, value] of Object.entries(incomingEntries)) {
    if (key.startsWith(SENTRY_BAGGAGE_KEY_PREFIX)) {
      newSentryEntries[key] = value;
      hasNewSentryEntries = true;
    } else {
      newNonSentryEntries[key] = value;
    }
  }
  if (existingEntries) {
    for (const [key, value] of Object.entries(existingEntries)) {
      if (!hasNewSentryEntries || !key.startsWith(SENTRY_BAGGAGE_KEY_PREFIX)) {
        merged[key] = value;
      }
    }
  }
  if (hasNewSentryEntries) {
    Object.assign(merged, newSentryEntries);
  }
  for (const [key, value] of Object.entries(newNonSentryEntries)) {
    merged[key] ?? (merged[key] = value);
  }
  return objectToBaggageHeader(merged);
}


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "sv", 0, /* binding */ SENTRY_BAGGAGE_KEY_PREFIX
/* harmony export */ ]);


/***/ }),

/***/ 57333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $N: function() { return /* binding */ getLocationHref; },
/* harmony export */   xE: function() { return /* binding */ getComponentName; }
/* harmony export */ });
/* unused harmony export htmlTreeAsString */
/* unused harmony import specifier */ var isString;
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70774);


const WINDOW = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .O;
const DEFAULT_MAX_STRING_LENGTH = 80;
function htmlTreeAsString(elem, options = {}) {
  if (!elem) {
    return "<unknown>";
  }
  try {
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = " > ";
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) {
        break;
      }
      out.push(nextStr);
      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }
    return out.reverse().join(separator);
  } catch {
    return "<unknown>";
  }
}
function _htmlElementAsString(el, keyAttrs) {
  const elem = el;
  const out = [];
  if (!elem?.tagName) {
    return "";
  }
  if (WINDOW.HTMLElement) {
    if (elem instanceof HTMLElement && elem.dataset) {
      if (elem.dataset["sentryComponent"]) {
        return elem.dataset["sentryComponent"];
      }
      if (elem.dataset["sentryElement"]) {
        return elem.dataset["sentryElement"];
      }
    }
  }
  out.push(elem.tagName.toLowerCase());
  const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr) => elem.getAttribute(keyAttr)).map((keyAttr) => [keyAttr, elem.getAttribute(keyAttr)]) : null;
  if (keyAttrPairs?.length) {
    keyAttrPairs.forEach((keyAttrPair) => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }
    const className = elem.className;
    if (className && isString(className)) {
      const classes = className.split(/\s+/);
      for (const c of classes) {
        out.push(`.${c}`);
      }
    }
  }
  for (const k of ["aria-label", "type", "name", "title", "alt"]) {
    const attr = elem.getAttribute(k);
    if (attr) {
      out.push(`[${k}="${attr}"]`);
    }
  }
  return out.join("");
}
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch {
    return "";
  }
}
function getComponentName(elem, maxTraverseHeight = 5) {
  if (!WINDOW.HTMLElement) {
    return null;
  }
  let currentElem = elem;
  for (let i = 0; i < maxTraverseHeight; i++) {
    if (!currentElem) {
      return null;
    }
    if (currentElem instanceof HTMLElement) {
      if (currentElem.dataset["sentryComponent"]) {
        return currentElem.dataset["sentryComponent"];
      }
      if (currentElem.dataset["sentryElement"]) {
        return currentElem.dataset["sentryElement"];
      }
    }
    currentElem = currentElem.parentNode;
  }
  return null;
}



/***/ }),

/***/ 92547:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
const isActualPromise = (p) => p instanceof Promise && !p[kChainedCopy];
const kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const chainAndCopyPromiseLike = (original, onSuccess, onError) => {
  const chained = original.then(
    (value) => {
      onSuccess(value);
      return value;
    },
    (err) => {
      onError(err);
      throw err;
    }
  );
  return isActualPromise(chained) && isActualPromise(original) ? chained : copyProps(original, chained);
};
const copyProps = (original, chained) => {
  if (!chained) return original;
  let mutated = false;
  for (const key in original) {
    if (key in chained) continue;
    mutated = true;
    const value = original[key];
    if (typeof value === "function") {
      Object.defineProperty(chained, key, {
        value: (...args) => value.apply(original, args),
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      chained[key] = value;
    }
  }
  if (mutated) Object.assign(chained, { [kChainedCopy]: true });
  return chained;
};


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "i", 0, /* binding */ chainAndCopyPromiseLike
/* harmony export */ ]);


/***/ }),

/***/ 73182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
const FILTERED_VALUE = "[Filtered]";
const PII_HEADER_SNIPPETS = ["forwarded", "-ip", "remote-", "via", "-user"];
const SENSITIVE_KEY_SNIPPETS = [
  "auth",
  "token",
  "secret",
  "session",
  // for the user_session cookie
  "password",
  "passwd",
  "pwd",
  "key",
  "jwt",
  "bearer",
  "sso",
  "saml",
  "csrf",
  "xsrf",
  "credentials",
  "sid",
  "identity",
  // Always treat cookie headers as sensitive in case individual key-value cookie pairs cannot properly be extracted
  "set-cookie",
  "cookie"
];
const SENSITIVE_COOKIE_NAME_SNIPPETS = [
  // Express / Connect default session cookie
  ".sid",
  // Opaque session ids (PHPSESSID, ASPSESSIONID*, BIGipServer*, *sessid*, …)
  "sessid",
  // Laravel etc. "remember me" tokens
  "remember",
  // OIDC / OAuth auxiliary (`oauth*` covered by header snippet `auth`)
  "oidc",
  "pkce",
  "nonce",
  // RFC 6265bis high-security cookie name prefixes
  "__secure-",
  "__host-",
  // Load balancer / CDN sticky-session cookies (opaque routing tokens)
  "awsalb",
  "awselb",
  "akamai",
  // BaaS / IdP session cookies (names often omit "session")
  "__stripe",
  "cognito",
  "firebase",
  "supabase",
  "sb-",
  // Step-up / MFA cookies
  "mfa",
  "2fa"
];


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "Av", 0, /* binding */ FILTERED_VALUE,
/* harmony export */   "UA", 0, /* binding */ PII_HEADER_SNIPPETS,
/* harmony export */   "d$", 0, /* binding */ SENSITIVE_COOKIE_NAME_SNIPPETS,
/* harmony export */   "kQ", 0, /* binding */ SENSITIVE_KEY_SNIPPETS
/* harmony export */ ]);


/***/ }),

/***/ 88889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: function() { return /* binding */ getDebugImagesForResources; },
/* harmony export */   z: function() { return /* binding */ getFilenameToDebugIdMap; }
/* harmony export */ });
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52992);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70774);


let parsedStackResults;
let lastSentryKeysCount;
let lastNativeKeysCount;
let cachedFilenameDebugIds;
function getFilenameToDebugIdMap(stackParser) {
  const sentryDebugIdMap = _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ */ .O._sentryDebugIds;
  const nativeDebugIdMap = _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ */ .O._debugIds;
  if (!sentryDebugIdMap && !nativeDebugIdMap) {
    return {};
  }
  const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
  const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
  if (cachedFilenameDebugIds && sentryDebugIdKeys.length === lastSentryKeysCount && nativeDebugIdKeys.length === lastNativeKeysCount) {
    return cachedFilenameDebugIds;
  }
  lastSentryKeysCount = sentryDebugIdKeys.length;
  lastNativeKeysCount = nativeDebugIdKeys.length;
  cachedFilenameDebugIds = {};
  if (!parsedStackResults) {
    parsedStackResults = {};
  }
  const processDebugIds = (debugIdKeys, debugIdMap) => {
    for (const key of debugIdKeys) {
      const debugId = debugIdMap[key];
      const result = parsedStackResults?.[key];
      if (result && cachedFilenameDebugIds && debugId) {
        cachedFilenameDebugIds[result[0]] = debugId;
        if (parsedStackResults) {
          parsedStackResults[key] = [result[0], debugId];
        }
      } else if (debugId) {
        const parsedStack = stackParser(key);
        for (let i = parsedStack.length - 1; i >= 0; i--) {
          const stackFrame = parsedStack[i];
          const filename = stackFrame?.filename;
          if (filename && cachedFilenameDebugIds && parsedStackResults) {
            cachedFilenameDebugIds[filename] = debugId;
            parsedStackResults[key] = [filename, debugId];
            break;
          }
        }
      }
    }
  };
  if (sentryDebugIdMap) {
    processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
  }
  if (nativeDebugIdMap) {
    processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
  }
  return cachedFilenameDebugIds;
}
function getDebugImagesForResources(stackParser, resource_paths) {
  const filenameDebugIdMap = getFilenameToDebugIdMap(stackParser);
  if (!filenameDebugIdMap) {
    return [];
  }
  const images = [];
  for (const path of resource_paths) {
    const normalizedPath = (0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_0__/* .normalizeStackTracePath */ .Wt)(path);
    if (normalizedPath && filenameDebugIdMap[normalizedPath]) {
      images.push({
        type: "sourcemap",
        code_file: path,
        debug_id: filenameDebugIdMap[normalizedPath]
      });
    }
  }
  return images;
}



/***/ }),

/***/ 62183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   pq: function() { return /* binding */ consoleSandbox; }
/* harmony export */ });
/* harmony import */ var _carrier_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35179);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97169);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70774);



const CONSOLE_LEVELS = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
];
const PREFIX = "Sentry Logger ";
const originalConsoleMethods = {};
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_OBJ */ .O)) {
    return callback();
  }
  const console = _worldwide_js__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_OBJ */ .O.console;
  const wrappedFuncs = {};
  const wrappedLevels = Object.keys(originalConsoleMethods);
  wrappedLevels.forEach((level) => {
    const originalConsoleMethod = originalConsoleMethods[level];
    wrappedFuncs[level] = console[level];
    console[level] = originalConsoleMethod;
  });
  try {
    return callback();
  } finally {
    wrappedLevels.forEach((level) => {
      console[level] = wrappedFuncs[level];
    });
  }
}
function enable() {
  _getLoggerSettings().enabled = true;
}
function disable() {
  _getLoggerSettings().enabled = false;
}
function isEnabled() {
  return _getLoggerSettings().enabled;
}
function log(...args) {
  _maybeLog("log", ...args);
}
function warn(...args) {
  _maybeLog("warn", ...args);
}
function error(...args) {
  _maybeLog("error", ...args);
}
function _maybeLog(level, ...args) {
  if (!_debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T) {
    return;
  }
  if (isEnabled()) {
    consoleSandbox(() => {
      _worldwide_js__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_OBJ */ .O.console[level](`${PREFIX}[${level}]:`, ...args);
    });
  }
}
function _getLoggerSettings() {
  if (!_debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .T) {
    return { enabled: false };
  }
  return (0,_carrier_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .BY)("loggerSettings", () => ({ enabled: false }));
}
const debug = {
  /** Enable logging. */
  enable,
  /** Disable logging. */
  disable,
  /** Check if logging is enabled. */
  isEnabled,
  /** Log a message. */
  log,
  /** Log a warning. */
  warn,
  /** Log an error. */
  error
};


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "Ow", 0, /* binding */ CONSOLE_LEVELS,
/* harmony export */   "Yz", 0, /* binding */ debug,
/* harmony export */   "Z9", 0, /* binding */ originalConsoleMethods
/* harmony export */ ]);


/***/ }),

/***/ 56648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AD: function() { return /* binding */ makeDsn; },
/* harmony export */   SB: function() { return /* binding */ dsnToString; },
/* harmony export */   hH: function() { return /* binding */ dsnFromString; },
/* harmony export */   ul: function() { return /* binding */ extractOrgIdFromClient; }
/* harmony export */ });
/* unused harmony export extractOrgIdFromDsnHost */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62183);


const ORG_ID_REGEX = /^o(\d+)\./;
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
  return protocol === "http" || protocol === "https";
}
function dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);
  if (!match) {
    (0,_debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .consoleSandbox */ .pq)(() => {
      console.error(`Invalid Sentry Dsn: ${str}`);
    });
    return void 0;
  }
  const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
  let path = "";
  let projectId = lastPath;
  const split = projectId.split("/");
  if (split.length > 1) {
    path = split.slice(0, -1).join("/");
    projectId = split.pop();
  }
  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }
  return dsnFromComponents({ host, pass, path, projectId, port, protocol, publicKey });
}
function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || "",
    pass: components.pass || "",
    host: components.host,
    port: components.port || "",
    path: components.path || "",
    projectId: components.projectId
  };
}
function validateDsn(dsn) {
  if (!_debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T) {
    return true;
  }
  const { port, projectId, protocol } = dsn;
  const requiredComponents = ["protocol", "publicKey", "host", "projectId"];
  const hasMissingRequiredComponent = requiredComponents.find((component) => {
    if (!dsn[component]) {
      _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });
  if (hasMissingRequiredComponent) {
    return false;
  }
  if (!projectId.match(/^\d+$/)) {
    _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }
  if (!isValidProtocol(protocol)) {
    _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }
  if (port && isNaN(parseInt(port, 10))) {
    _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }
  return true;
}
function extractOrgIdFromDsnHost(host) {
  const match = host.match(ORG_ID_REGEX);
  return match?.[1];
}
function extractOrgIdFromClient(client) {
  const options = client.getOptions();
  const { host } = client.getDsn() || {};
  let org_id;
  if (options.orgId) {
    org_id = String(options.orgId);
  } else if (host) {
    org_id = extractOrgIdFromDsnHost(host);
  }
  return org_id;
}
function makeDsn(from) {
  const components = typeof from === "string" ? dsnFromString(from) : dsnFromComponents(from);
  if (!components || !validateDsn(components)) {
    return void 0;
  }
  return components;
}



/***/ }),

/***/ 42730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ isBrowserBundle; },
/* harmony export */   e: function() { return /* binding */ getSDKSource; }
/* harmony export */ });
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function getSDKSource() {
  /*! __SENTRY_SDK_SOURCE__ */
  return "npm";
}



/***/ }),

/***/ 22265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Cj: function() { return /* binding */ getSdkMetadataForEnvelopeHeader; },
/* harmony export */   W3: function() { return /* binding */ addItemToEnvelope; },
/* harmony export */   bN: function() { return /* binding */ serializeEnvelope; },
/* harmony export */   bm: function() { return /* binding */ createAttachmentEnvelopeItem; },
/* harmony export */   h4: function() { return /* binding */ createEnvelope; },
/* harmony export */   hP: function() { return /* binding */ envelopeContainsItemType; },
/* harmony export */   mE: function() { return /* binding */ parseEnvelope; },
/* harmony export */   n2: function() { return /* binding */ createEventEnvelopeHeaders; },
/* harmony export */   y5: function() { return /* binding */ createSpanEnvelopeItem; },
/* harmony export */   yH: function() { return /* binding */ forEachEnvelopeItem; },
/* harmony export */   zk: function() { return /* binding */ envelopeItemTypeToDataCategory; }
/* harmony export */ });
/* harmony import */ var _carrier_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35179);
/* harmony import */ var _dsn_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56648);
/* harmony import */ var _normalize_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51830);
/* harmony import */ var _randomSafeContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23324);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70774);





function createEnvelope(headers, items = []) {
  return [headers, items];
}
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]];
}
function forEachEnvelopeItem(envelope, callback) {
  const envelopeItems = envelope[1];
  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);
    if (result) {
      return true;
    }
  }
  return false;
}
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}
function encodeUTF8(input) {
  const carrier = (0,_carrier_js__WEBPACK_IMPORTED_MODULE_0__/* .getSentryCarrier */ .Se)(_worldwide_js__WEBPACK_IMPORTED_MODULE_4__/* .GLOBAL_OBJ */ .O);
  return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function decodeUTF8(input) {
  const carrier = (0,_carrier_js__WEBPACK_IMPORTED_MODULE_0__/* .getSentryCarrier */ .Se)(_worldwide_js__WEBPACK_IMPORTED_MODULE_4__/* .GLOBAL_OBJ */ .O);
  return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function serializeEnvelope(envelope) {
  const [envHeaders, items] = envelope;
  let parts = JSON.stringify(envHeaders);
  function append(next) {
    if (typeof parts === "string") {
      parts = typeof next === "string" ? parts + next : [encodeUTF8(parts), next];
    } else {
      parts.push(typeof next === "string" ? encodeUTF8(next) : next);
    }
  }
  for (const item of items) {
    const [itemHeaders, payload] = item;
    append(`
${JSON.stringify(itemHeaders)}
`);
    if (typeof payload === "string" || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch {
        stringifiedPayload = JSON.stringify((0,_normalize_js__WEBPACK_IMPORTED_MODULE_2__/* .normalize */ .S8)(payload));
      }
      append(stringifiedPayload);
    }
  }
  return typeof parts === "string" ? parts : concatBuffers(parts);
}
function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);
  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }
  return merged;
}
function parseEnvelope(env) {
  let buffer = typeof env === "string" ? encodeUTF8(env) : env;
  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    buffer = buffer.subarray(length + 1);
    return bin;
  }
  function readJson() {
    let i = buffer.indexOf(10);
    if (i < 0) {
      i = buffer.length;
    }
    return JSON.parse(decodeUTF8(readBinary(i)));
  }
  const envelopeHeader = readJson();
  const items = [];
  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }
  return [envelopeHeader, items];
}
function createSpanEnvelopeItem(spanJson) {
  const spanHeaders = {
    type: "span"
  };
  return [spanHeaders, spanJson];
}
function createAttachmentEnvelopeItem(attachment) {
  const buffer = typeof attachment.data === "string" ? encodeUTF8(attachment.data) : attachment.data;
  return [
    {
      type: "attachment",
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType
    },
    buffer
  ];
}
const DATA_CATEGORY_OVERRIDES = {
  sessions: "session",
  event: "error",
  client_report: "internal",
  user_report: "default",
  profile_chunk: "profile",
  replay_event: "replay",
  replay_recording: "replay",
  check_in: "monitor",
  raw_security: "security",
  log: "log_item",
  trace_metric: "metric"
};
function _isOverriddenType(type) {
  return type in DATA_CATEGORY_OVERRIDES;
}
function envelopeItemTypeToDataCategory(type) {
  return _isOverriddenType(type) ? DATA_CATEGORY_OVERRIDES[type] : type;
}
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent?.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}
function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
  const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
  return {
    event_id: event.event_id,
    sent_at: new Date((0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_3__/* .safeDateNow */ .Wk)()).toISOString(),
    ...sdkInfo && { sdk: sdkInfo },
    ...!!tunnel && dsn && { dsn: (0,_dsn_js__WEBPACK_IMPORTED_MODULE_1__/* .dsnToString */ .SB)(dsn) },
    ...dynamicSamplingContext && {
      trace: dynamicSamplingContext
    }
  };
}



/***/ }),

/***/ 20516:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G: function() { return /* binding */ getPossibleEventMessages; }
/* harmony export */ });
function getPossibleEventMessages(event) {
  const possibleMessages = [];
  if (event.message) {
    possibleMessages.push(event.message);
  }
  try {
    const lastException = event.exception.values[event.exception.values.length - 1];
    if (lastException?.value) {
      possibleMessages.push(lastException.value);
      if (lastException.type) {
        possibleMessages.push(`${lastException.type}: ${lastException.value}`);
      }
    }
  } catch {
  }
  return possibleMessages;
}



/***/ }),

/***/ 97879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   x: function() { return /* binding */ handleCallbackErrors; }
/* harmony export */ });
/* harmony import */ var _chain_and_copy_promiselike_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92547);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91973);


function handleCallbackErrors(fn, onError, onFinally = () => {
}, onSuccess = () => {
}) {
  let maybePromiseResult;
  try {
    maybePromiseResult = fn();
  } catch (e) {
    onError(e);
    onFinally();
    throw e;
  }
  return maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .Qg)(value)) {
    return (0,_chain_and_copy_promiselike_js__WEBPACK_IMPORTED_MODULE_0__/* .chainAndCopyPromiseLike */ .i)(
      value,
      (result) => {
        onFinally();
        onSuccess(result);
      },
      (err) => {
        onError(err);
        onFinally();
      }
    );
  }
  onFinally();
  onSuccess(value);
  return value;
}



/***/ }),

/***/ 91811:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: function() { return /* binding */ hasSpansEnabled; }
/* harmony export */ });
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79255);

function hasSpansEnabled(maybeOptions) {
  if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) {
    return false;
  }
  const options = maybeOptions || (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getClient */ .KU)()?.getOptions();
  return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
  (options.tracesSampleRate != null || !!options.tracesSampler);
}



/***/ }),

/***/ 91973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BD: function() { return /* binding */ isDOMError; },
/* harmony export */   Kg: function() { return /* binding */ isString; },
/* harmony export */   NF: function() { return /* binding */ isParameterizedString; },
/* harmony export */   Qd: function() { return /* binding */ isPlainObject; },
/* harmony export */   Qg: function() { return /* binding */ isThenable; },
/* harmony export */   T2: function() { return /* binding */ isErrorEvent; },
/* harmony export */   W6: function() { return /* binding */ isDOMException; },
/* harmony export */   bJ: function() { return /* binding */ isError; },
/* harmony export */   gd: function() { return /* binding */ isRegExp; },
/* harmony export */   ks: function() { return /* binding */ isRequest; },
/* harmony export */   sO: function() { return /* binding */ isPrimitive; },
/* harmony export */   tH: function() { return /* binding */ isInstanceOf; },
/* harmony export */   xH: function() { return /* binding */ isEvent; }
/* harmony export */ });
/* unused harmony exports isElement, isSyntheticEvent, isVueViewModel */
const objectToString = Object.prototype.toString;
function isError(wat) {
  switch (objectToString.call(wat)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object WebAssembly.Exception]":
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}
function isErrorEvent(wat) {
  return isBuiltin(wat, "ErrorEvent");
}
function isDOMError(wat) {
  return isBuiltin(wat, "DOMError");
}
function isDOMException(wat) {
  return isBuiltin(wat, "DOMException");
}
function isString(wat) {
  return isBuiltin(wat, "String");
}
function isParameterizedString(wat) {
  return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
function isPrimitive(wat) {
  return wat === null || isParameterizedString(wat) || typeof wat !== "object" && typeof wat !== "function";
}
function isPlainObject(wat) {
  return isBuiltin(wat, "Object");
}
function isEvent(wat) {
  return typeof Event !== "undefined" && isInstanceOf(wat, Event);
}
function isElement(wat) {
  return typeof Element !== "undefined" && isInstanceOf(wat, Element);
}
function isRegExp(wat) {
  return isBuiltin(wat, "RegExp");
}
function isThenable(wat) {
  return Boolean(wat?.then && typeof wat.then === "function");
}
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch {
    return false;
  }
}
function isVueViewModel(wat) {
  return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
function isRequest(request) {
  return typeof Request !== "undefined" && isInstanceOf(request, Request);
}



/***/ }),

/***/ 82257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   B: function() { return /* binding */ isBrowser; }
/* harmony export */ });
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65453);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70774);


function isBrowser() {
  return typeof window !== "undefined" && (!(0,_node_js__WEBPACK_IMPORTED_MODULE_0__/* .isNodeEnv */ .w)() || isElectronNodeRenderer());
}
function isElectronNodeRenderer() {
  const process = _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ */ .O.process;
  return process?.type === "renderer";
}



/***/ }),

/***/ 55344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ isSentryRequestUrl; }
/* harmony export */ });
/* harmony import */ var _url_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77636);

function isSentryRequestUrl(url, client) {
  const dsn = client?.getDsn();
  const tunnel = client?.getOptions().tunnel;
  return checkDsn(url, dsn) || checkTunnel(url, tunnel);
}
function checkTunnel(url, tunnel) {
  if (!tunnel) {
    return false;
  }
  return removeTrailingSlash(url) === removeTrailingSlash(tunnel);
}
function checkDsn(url, dsn) {
  const urlParts = (0,_url_js__WEBPACK_IMPORTED_MODULE_0__/* .parseStringToURLObject */ .kg)(url);
  if (!urlParts || (0,_url_js__WEBPACK_IMPORTED_MODULE_0__/* .isURLObjectRelative */ .nt)(urlParts)) {
    return false;
  }
  if (!dsn) {
    return false;
  }
  return hostnameMatchesDsnHost(urlParts.hostname, dsn.host) && /(^|&|\?)sentry_key=/.test(urlParts.search);
}
function hostnameMatchesDsnHost(hostname, dsnHost) {
  return hostname === dsnHost || dsnHost.length > 0 && hostname.endsWith(`.${dsnHost}`);
}
function removeTrailingSlash(str) {
  return str[str.length - 1] === "/" ? str.slice(0, -1) : str;
}



/***/ }),

/***/ 69201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   h: function() { return /* binding */ merge; }
/* harmony export */ });
function merge(initialObj, mergeObj, levels = 2) {
  if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) {
    return mergeObj;
  }
  if (initialObj && Object.keys(mergeObj).length === 0) {
    return initialObj;
  }
  const output = { ...initialObj };
  for (const key in mergeObj) {
    if (Object.prototype.hasOwnProperty.call(mergeObj, key)) {
      output[key] = merge(output[key], mergeObj[key], levels - 1);
    }
  }
  return output;
}



/***/ }),

/***/ 16513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $X: function() { return /* binding */ getEventDescription; },
/* harmony export */   GR: function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   M6: function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   db: function() { return /* binding */ addContextToFrame; },
/* harmony export */   eJ: function() { return /* binding */ uuid4; },
/* harmony export */   gO: function() { return /* binding */ addExceptionTypeValue; }
/* harmony export */ });
/* unused harmony exports isAlreadyCaptured, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50742);
/* harmony import */ var _randomSafeContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23324);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26228);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70774);




function getCrypto() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_OBJ */ .O;
  return gbl.crypto || gbl.msCrypto;
}
let emptyUuid;
function getRandomByte() {
  return (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_1__/* .safeMathRandom */ .hY)() * 16;
}
function uuid4(crypto = getCrypto()) {
  try {
    if (crypto?.randomUUID) {
      return (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_1__/* .withRandomSafeContext */ .Qw)(() => crypto.randomUUID()).replace(/-/g, "");
    }
  } catch {
  }
  if (!emptyUuid) {
    emptyUuid = "10000000100040008000" + 1e11;
  }
  return emptyUuid.replace(
    /[018]/g,
    (c) => (
      // eslint-disable-next-line no-bitwise
      (c ^ (getRandomByte() & 15) >> c / 4).toString(16)
    )
  );
}
function getFirstException(event) {
  return event.exception?.values?.[0];
}
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }
  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || "<unknown>";
  }
  return eventId || "<unknown>";
}
function addExceptionTypeValue(event, value, type) {
  const exception = event.exception = event.exception || {};
  const values = exception.values = exception.values || [];
  const firstException = values[0] = values[0] || {};
  if (!firstException.value) {
    firstException.value = value || "";
  }
  if (!firstException.type) {
    firstException.type = type || "Error";
  }
}
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }
  const defaultMechanism = { type: "generic", handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };
  if (newMechanism && "data" in newMechanism) {
    const mergedData = { ...currentMechanism?.data, ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}
const SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function _parseInt(input) {
  return parseInt(input || "", 10);
}
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = _parseInt(match[1]);
  const minor = _parseInt(match[2]);
  const patch = _parseInt(match[3]);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? void 0 : major,
    minor: isNaN(minor) ? void 0 : minor,
    patch: isNaN(patch) ? void 0 : patch,
    prerelease: match[4]
  };
}
function addContextToFrame(lines, frame, linesOfContext = 5) {
  if (frame.lineno === void 0) {
    return;
  }
  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
  frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line) => (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .snipLine */ .nC)(line, 0));
  const lineIndex = Math.min(maxLines - 1, sourceLine);
  frame.context_line = (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .snipLine */ .nC)(lines[lineIndex], frame.colno || 0);
  frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line) => (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .snipLine */ .nC)(line, 0));
}
function checkOrSetAlreadyCaught(exception) {
  if (isAlreadyCaptured(exception)) {
    return true;
  }
  try {
    (0,_object_js__WEBPACK_IMPORTED_MODULE_0__/* .addNonEnumerableProperty */ .my)(exception, "__sentry_captured__", true);
  } catch {
  }
  return false;
}
function isAlreadyCaptured(exception) {
  try {
    return exception.__sentry_captured__;
  } catch {
  }
}



/***/ }),

/***/ 65453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   w: function() { return /* binding */ isNodeEnv; }
/* harmony export */ });
/* unused harmony export loadModule */
/* harmony import */ var _env_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42730);
/* module decorator */ module = __webpack_require__.hmd(module);

function isNodeEnv() {
  return !(0,_env_js__WEBPACK_IMPORTED_MODULE_0__/* .isBrowserBundle */ .Z)() && Object.prototype.toString.call(typeof process !== "undefined" ? process : 0) === "[object process]";
}
function dynamicRequire(mod, request) {
  return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
  let mod;
  try {
    mod = dynamicRequire(existingModule, moduleName);
  } catch {
  }
  if (!mod) {
    try {
      const { cwd } = dynamicRequire(existingModule, "process");
      mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch {
    }
  }
  return mod;
}



/***/ }),

/***/ 43696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ef: function() { return /* binding */ hasSkipNormalizationHint; },
/* harmony export */   Gc: function() { return /* binding */ setSkipNormalizationHint; },
/* harmony export */   We: function() { return /* binding */ getNormalizationDepthOverrideHint; },
/* harmony export */   uy: function() { return /* binding */ setNormalizationDepthOverrideHint; }
/* harmony export */ });
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50742);

const SENTRY_SKIP_NORMALIZATION = /* @__PURE__ */ Symbol.for("sentry.skipNormalization");
const SENTRY_OVERRIDE_NORMALIZATION_DEPTH = /* @__PURE__ */ Symbol.for("sentry.overrideNormalizationDepth");
function setSkipNormalizationHint(obj) {
  (0,_object_js__WEBPACK_IMPORTED_MODULE_0__/* .addNonEnumerableProperty */ .my)(obj, SENTRY_SKIP_NORMALIZATION, true);
}
function setNormalizationDepthOverrideHint(obj, depth) {
  (0,_object_js__WEBPACK_IMPORTED_MODULE_0__/* .addNonEnumerableProperty */ .my)(obj, SENTRY_OVERRIDE_NORMALIZATION_DEPTH, depth);
}
function hasSkipNormalizationHint(value) {
  return Boolean(value[SENTRY_SKIP_NORMALIZATION]);
}
function getNormalizationDepthOverrideHint(value) {
  const v = value[SENTRY_OVERRIDE_NORMALIZATION_DEPTH];
  return typeof v === "number" ? v : void 0;
}



/***/ }),

/***/ 51830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Ip: function() { return /* binding */ setNormalizeStringifier; },
/* harmony export */   S8: function() { return /* binding */ normalize; },
/* harmony export */   cd: function() { return /* binding */ normalizeToSize; },
/* harmony export */   ng: function() { return /* binding */ stringifyValue; }
/* harmony export */ });
/* unused harmony export normalizeUrlToBase */
/* harmony import */ var _normalizationHints_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43696);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50742);
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52992);



let stringifier;
function setNormalizeStringifier(newStringifier) {
  stringifier = newStringifier;
}
function normalize(input, depth = 100, maxProperties = Infinity) {
  try {
    return visit("", input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}
function normalizeToSize(object, depth = 3, maxSize = 100 * 1024) {
  const normalized = normalize(object, depth);
  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }
  return normalized;
}
function visit(key, value, depth = Infinity, maxProperties = Infinity, memo = memoBuilder()) {
  const [memoize, unmemoize] = memo;
  if (value == null || // this matches null and undefined -> eqeq not eqeqeq
  ["boolean", "string"].includes(typeof value) || typeof value === "number" && Number.isFinite(value)) {
    return value;
  }
  const stringified = stringifyValue(key, value);
  if (!stringified.startsWith("[object ")) {
    return stringified;
  }
  if ((0,_normalizationHints_js__WEBPACK_IMPORTED_MODULE_0__/* .hasSkipNormalizationHint */ .Ef)(value)) {
    return value;
  }
  const overrideDepth = (0,_normalizationHints_js__WEBPACK_IMPORTED_MODULE_0__/* .getNormalizationDepthOverrideHint */ .We)(value);
  const remainingDepth = overrideDepth !== void 0 ? overrideDepth : depth;
  if (remainingDepth === 0) {
    return stringified.replace("object ", "");
  }
  if (memoize(value)) {
    return "[Circular ~]";
  }
  const valueWithToJSON = value;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      return visit("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch {
    }
  }
  const normalized = Array.isArray(value) ? [] : {};
  let numAdded = 0;
  const visitable = (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .convertToPlainObject */ .W4)(value);
  for (const visitKey in visitable) {
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }
    if (numAdded >= maxProperties) {
      normalized[visitKey] = "[MaxProperties ~]";
      break;
    }
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
    numAdded++;
  }
  unmemoize(value);
  return normalized;
}
function stringifyValue(key, value) {
  try {
    if (stringifier) {
      const stringified = stringifier(value);
      if (stringified) {
        return stringified;
      }
    }
    if (typeof __webpack_require__.g !== "undefined" && value === __webpack_require__.g) {
      return "[Global]";
    }
    if (typeof value === "number" && !Number.isFinite(value)) {
      return `[${value}]`;
    }
    if (typeof value === "function") {
      return `[Function: ${(0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .qQ)(value)}]`;
    }
    if (typeof value === "symbol") {
      return `[${String(value)}]`;
    }
    if (typeof value === "bigint") {
      return `[BigInt: ${String(value)}]`;
    }
    const objName = getConstructorName(value);
    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);
  return prototype?.constructor ? prototype.constructor.name : "null prototype";
}
function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}
function normalizeUrlToBase(url, basePath) {
  const escapedBase = basePath.replace(/\\/g, "/").replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
  let newUrl = url;
  try {
    newUrl = decodeURI(url);
  } catch {
  }
  return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "").replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}
function memoBuilder() {
  const inner = /* @__PURE__ */ new WeakSet();
  function memoize(obj) {
    if (inner.has(obj)) {
      return true;
    }
    inner.add(obj);
    return false;
  }
  function unmemoize(obj) {
    inner.delete(obj);
  }
  return [memoize, unmemoize];
}



/***/ }),

/***/ 50742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   GS: function() { return /* binding */ fill; },
/* harmony export */   HF: function() { return /* binding */ extractExceptionKeysForMessage; },
/* harmony export */   W4: function() { return /* binding */ convertToPlainObject; },
/* harmony export */   my: function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   pO: function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   sp: function() { return /* binding */ getOriginalFunction; }
/* harmony export */ });
/* unused harmony exports dropUndefinedKeys, objectify, wrapMethod */
/* unused harmony import specifier */ var isPrimitive;
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62183);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91973);



function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }
  const original = source[name];
  if (typeof original !== "function") {
    return;
  }
  const wrapped = replacementFactory(original);
  if (typeof wrapped === "function") {
    markFunctionWrapped(wrapped, original);
  }
  try {
    source[name] = wrapped;
  } catch {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.log(`Failed to replace method "${name}" in object`, source);
  }
}
function addNonEnumerableProperty(obj, name, value) {
  try {
    Object.defineProperty(obj, name, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value,
      writable: true,
      configurable: true
    });
  } catch {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.log(`Failed to add non-enumerable property "${String(name)}" to object`, obj);
  }
}
function markFunctionWrapped(wrapped, original) {
  try {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, "__sentry_original__", original);
  } catch {
  }
}
function wrapMethod(obj, field, wrapped, enumerable = true) {
  const original = obj[field];
  if (typeof original !== "function") {
    throw new Error(`Cannot wrap method: ${field} is not a function`);
  }
  if (getOriginalFunction(original)) {
    throw new Error(`Attempting to wrap method ${field} multiple times`);
  }
  markFunctionWrapped(wrapped, original);
  Object.defineProperty(obj, field, {
    writable: true,
    configurable: true,
    enumerable,
    value: wrapped
  });
}
function getOriginalFunction(func) {
  return func.__sentry_original__;
}
function convertToPlainObject(value) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isError */ .bJ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value)
    };
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isEvent */ .xH)(value)) {
    const { type, target, currentTarget, detail } = value;
    return {
      type,
      target,
      currentTarget,
      ...detail ? { detail } : {},
      ...getOwnProperties(value)
    };
  }
  return value;
}
function getOwnProperties(obj) {
  if (typeof obj === "object" && obj !== null) {
    return Object.fromEntries(Object.entries(obj));
  }
  return {};
}
function extractExceptionKeysForMessage(exception) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();
  return !keys[0] ? "[object has no keys]" : keys.join(", ");
}
function dropUndefinedKeys(inputValue) {
  const memoizationMap = /* @__PURE__ */ new Map();
  return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
  if (inputValue === null || typeof inputValue !== "object") {
    return inputValue;
  }
  const memoVal = memoizationMap.get(inputValue);
  if (memoVal !== void 0) {
    return memoVal;
  }
  if (Array.isArray(inputValue)) {
    const returnValue = [];
    memoizationMap.set(inputValue, returnValue);
    inputValue.forEach((value) => {
      returnValue.push(_dropUndefinedKeys(value, memoizationMap));
    });
    return returnValue;
  }
  if (isPojo(inputValue)) {
    const returnValue = {};
    memoizationMap.set(inputValue, returnValue);
    const keys = Object.keys(inputValue);
    keys.forEach((key) => {
      const val = inputValue[key];
      if (val !== void 0) {
        returnValue[key] = _dropUndefinedKeys(val, memoizationMap);
      }
    });
    return returnValue;
  }
  return inputValue;
}
function isPojo(input) {
  const constructor = input.constructor;
  return constructor === Object || constructor === void 0;
}
function objectify(wat) {
  let objectified;
  switch (true) {
    // this will catch both undefined and null
    case wat == void 0:
      objectified = new String(wat);
      break;
    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case (typeof wat === "symbol" || typeof wat === "bigint"):
      objectified = Object(wat);
      break;
    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      objectified = new wat.constructor(wat);
      break;
    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}



/***/ }),

/***/ 91554:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: function() { return /* binding */ parseSampleRate; }
/* harmony export */ });
function parseSampleRate(sampleRate) {
  if (typeof sampleRate === "boolean") {
    return Number(sampleRate);
  }
  const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
  if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) {
    return void 0;
  }
  return rate;
}



/***/ }),

/***/ 8665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  li: function() { return /* binding */ parseEventHintOrCaptureContext; },
  mG: function() { return /* binding */ prepareEvent; }
});

// UNUSED EXPORTS: applyClientOptions, applyDebugIds, applyDebugMeta

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/constants.js
var constants = __webpack_require__(9358);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/debug-build.js
var debug_build = __webpack_require__(97169);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-logger.js
var debug_logger = __webpack_require__(62183);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/is.js
var is = __webpack_require__(91973);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/syncpromise.js
var syncpromise = __webpack_require__(18533);
;// ./node_modules/@sentry/core/build/esm/eventProcessors.js




function notifyEventProcessors(processors, event, hint, index = 0) {
  try {
    const result = _notifyEventProcessors(event, hint, processors, index);
    return (0,is/* isThenable */.Qg)(result) ? result : (0,syncpromise/* resolvedSyncPromise */.XW)(result);
  } catch (error) {
    return (0,syncpromise/* rejectedSyncPromise */.xg)(error);
  }
}
function _notifyEventProcessors(event, hint, processors, index) {
  const processor = processors[index];
  if (!event || !processor) {
    return event;
  }
  const result = processor({ ...event }, hint);
  debug_build/* DEBUG_BUILD */.T && result === null && debug_logger/* debug */.Yz.log(`Event processor "${processor.id || "?"}" dropped event`);
  if ((0,is/* isThenable */.Qg)(result)) {
    return result.then((final) => _notifyEventProcessors(final, hint, processors, index + 1));
  }
  return _notifyEventProcessors(result, hint, processors, index + 1);
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/scope.js
var esm_scope = __webpack_require__(61003);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-ids.js
var debug_ids = __webpack_require__(88889);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/misc.js
var misc = __webpack_require__(16513);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/normalize.js
var normalize = __webpack_require__(51830);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/scopeData.js
var scopeData = __webpack_require__(35845);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/string.js
var string = __webpack_require__(26228);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/time.js
var time = __webpack_require__(39612);
;// ./node_modules/@sentry/core/build/esm/utils/prepareEvent.js










function prepareEvent(options, event, hint, scope, client, isolationScope) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1e3 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || (0,misc/* uuid4 */.eJ)(),
    timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.lu)()
  };
  const integrations = hint.integrations || options.integrations.map((i) => i.name);
  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);
  if (client) {
    client.emit("applyFrameMetadata", event);
  }
  if (event.type === void 0) {
    applyDebugIds(prepared, options.stackParser);
  }
  const finalScope = getFinalScope(scope, hint.captureContext);
  if (hint.mechanism) {
    (0,misc/* addExceptionMechanism */.M6)(prepared, hint.mechanism);
  }
  const clientEventProcessors = client ? client.getEventProcessors() : [];
  const data = (0,scopeData/* getCombinedScopeData */.Om)(isolationScope, finalScope);
  const attachments = [...hint.attachments || [], ...data.attachments];
  if (attachments.length) {
    hint.attachments = attachments;
  }
  (0,scopeData/* applyScopeDataToEvent */.e2)(prepared, data);
  const eventProcessors = [
    ...clientEventProcessors,
    // Run scope event processors _after_ all other processors
    ...data.eventProcessors
  ];
  const isInternalException = hint.data && hint.data.__sentry__ === true;
  const result = isInternalException ? (0,syncpromise/* resolvedSyncPromise */.XW)(prepared) : notifyEventProcessors(eventProcessors, prepared, hint);
  return result.then((evt) => {
    if (evt) {
      applyDebugMeta(evt);
    }
    if (typeof normalizeDepth === "number" && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength } = options;
  event.environment = event.environment || environment || constants/* DEFAULT_ENVIRONMENT */.U;
  if (!event.release && release) {
    event.release = release;
  }
  if (!event.dist && dist) {
    event.dist = dist;
  }
  const request = event.request;
  if (request?.url && maxValueLength) {
    request.url = (0,string/* truncate */.xv)(request.url, maxValueLength);
  }
  if (maxValueLength) {
    event.exception?.values?.forEach((exception) => {
      if (exception.value) {
        exception.value = (0,string/* truncate */.xv)(exception.value, maxValueLength);
      }
    });
  }
}
function applyDebugIds(event, stackParser) {
  const filenameDebugIdMap = (0,debug_ids/* getFilenameToDebugIdMap */.z)(stackParser);
  event.exception?.values?.forEach((exception) => {
    exception.stacktrace?.frames?.forEach((frame) => {
      if (frame.filename) {
        frame.debug_id = filenameDebugIdMap[frame.filename];
      }
    });
  });
}
function applyDebugMeta(event) {
  const filenameDebugIdMap = {};
  event.exception?.values?.forEach((exception) => {
    exception.stacktrace?.frames?.forEach((frame) => {
      if (frame.debug_id) {
        if (frame.abs_path) {
          filenameDebugIdMap[frame.abs_path] = frame.debug_id;
        } else if (frame.filename) {
          filenameDebugIdMap[frame.filename] = frame.debug_id;
        }
        delete frame.debug_id;
      }
    });
  });
  if (Object.keys(filenameDebugIdMap).length === 0) {
    return;
  }
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  Object.entries(filenameDebugIdMap).forEach(([filename, debug_id]) => {
    images.push({
      type: "sourcemap",
      code_file: filename,
      debug_id
    });
  });
}
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...event.sdk.integrations || [], ...integrationNames];
  }
}
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }
  const normalized = {
    ...event,
    ...event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map((b) => ({
        ...b,
        ...b.data && {
          data: (0,normalize/* normalize */.S8)(b.data, depth, maxBreadth)
        }
      }))
    },
    ...event.user && {
      user: (0,normalize/* normalize */.S8)(event.user, depth, maxBreadth)
    },
    ...event.contexts && {
      contexts: (0,normalize/* normalize */.S8)(event.contexts, depth, maxBreadth)
    },
    ...event.extra && {
      extra: (0,normalize/* normalize */.S8)(event.extra, depth, maxBreadth)
    }
  };
  if (event.contexts?.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = (0,normalize/* normalize */.S8)(event.contexts.trace.data, depth, maxBreadth);
    }
  }
  if (event.spans) {
    normalized.spans = event.spans.map((span) => {
      return {
        ...span,
        ...span.data && {
          data: (0,normalize/* normalize */.S8)(span.data, depth, maxBreadth)
        }
      };
    });
  }
  if (event.contexts?.flags && normalized.contexts) {
    normalized.contexts.flags = (0,normalize/* normalize */.S8)(event.contexts.flags, 3, maxBreadth);
  }
  return normalized;
}
function getFinalScope(scope, captureContext) {
  if (!captureContext) {
    return scope;
  }
  const finalScope = scope ? scope.clone() : new esm_scope/* Scope */.H();
  finalScope.update(captureContext);
  return finalScope;
}
function parseEventHintOrCaptureContext(hint) {
  if (!hint) {
    return void 0;
  }
  if (hintIsScopeOrFunction(hint)) {
    return { captureContext: hint };
  }
  if (hintIsScopeContext(hint)) {
    return {
      captureContext: hint
    };
  }
  return hint;
}
function hintIsScopeOrFunction(hint) {
  return hint instanceof esm_scope/* Scope */.H || typeof hint === "function";
}
const captureContextKeys = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "propagationContext"
];
function hintIsScopeContext(hint) {
  return Object.keys(hint).some((key) => captureContextKeys.includes(key));
}



/***/ }),

/***/ 50198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C: function() { return /* binding */ makePromiseBuffer; }
/* harmony export */ });
/* harmony import */ var _syncpromise_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18533);
/* harmony import */ var _timer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35084);


const SENTRY_BUFFER_FULL_ERROR = /* @__PURE__ */ Symbol.for("SentryBufferFullError");
function makePromiseBuffer(limit = 100) {
  const buffer = /* @__PURE__ */ new Set();
  function isReady() {
    return buffer.size < limit;
  }
  function remove(task) {
    buffer.delete(task);
  }
  function add(taskProducer) {
    if (!isReady()) {
      return (0,_syncpromise_js__WEBPACK_IMPORTED_MODULE_0__/* .rejectedSyncPromise */ .xg)(SENTRY_BUFFER_FULL_ERROR);
    }
    const task = taskProducer();
    buffer.add(task);
    void task.then(
      () => remove(task),
      () => remove(task)
    );
    return task;
  }
  function drain(timeout) {
    if (!buffer.size) {
      return (0,_syncpromise_js__WEBPACK_IMPORTED_MODULE_0__/* .resolvedSyncPromise */ .XW)(true);
    }
    const drainPromise = Promise.allSettled(Array.from(buffer)).then(() => true);
    if (!timeout) {
      return drainPromise;
    }
    const promises = [
      drainPromise,
      new Promise((resolve) => (0,_timer_js__WEBPACK_IMPORTED_MODULE_1__/* .safeUnref */ .G)(setTimeout(() => resolve(false), timeout)))
    ];
    return Promise.race(promises);
  }
  return {
    get $() {
      return Array.from(buffer);
    },
    add,
    drain
  };
}


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "a", 0, /* binding */ SENTRY_BUFFER_FULL_ERROR
/* harmony export */ ]);


/***/ }),

/***/ 66508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ generateSpanId; },
/* harmony export */   e: function() { return /* binding */ generateTraceId; }
/* harmony export */ });
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16513);

function generateTraceId() {
  return (0,_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .eJ)();
}
function generateSpanId() {
  return (0,_misc_js__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .eJ)().substring(16);
}



/***/ }),

/***/ 23324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Qw: function() { return /* binding */ withRandomSafeContext; },
/* harmony export */   Wk: function() { return /* binding */ safeDateNow; },
/* harmony export */   hY: function() { return /* binding */ safeMathRandom; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70774);

let RESOLVED_RUNNER;
function withRandomSafeContext(cb) {
  if (RESOLVED_RUNNER !== void 0) {
    return RESOLVED_RUNNER ? RESOLVED_RUNNER(cb) : cb();
  }
  const sym = /* @__PURE__ */ Symbol.for("__SENTRY_SAFE_RANDOM_ID_WRAPPER__");
  const globalWithSymbol = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .O;
  if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === "function") {
    RESOLVED_RUNNER = globalWithSymbol[sym];
    return RESOLVED_RUNNER(cb);
  }
  RESOLVED_RUNNER = null;
  return cb();
}
function safeMathRandom() {
  return withRandomSafeContext(() => Math.random());
}
function safeDateNow() {
  return withRandomSafeContext(() => Date.now());
}



/***/ }),

/***/ 40156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FA: function() { return /* binding */ parseRetryAfterHeader; },
/* harmony export */   Jz: function() { return /* binding */ isRateLimited; },
/* harmony export */   wq: function() { return /* binding */ updateRateLimits; }
/* harmony export */ });
/* unused harmony exports DEFAULT_RETRY_AFTER, disabledUntil */
/* harmony import */ var _randomSafeContext_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23324);

const DEFAULT_RETRY_AFTER = 60 * 1e3;
function parseRetryAfterHeader(header, now = (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_0__/* .safeDateNow */ .Wk)()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1e3;
  }
  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }
  return DEFAULT_RETRY_AFTER;
}
function disabledUntil(limits, dataCategory) {
  return limits[dataCategory] || limits.all || 0;
}
function isRateLimited(limits, dataCategory, now = (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_0__/* .safeDateNow */ .Wk)()) {
  return disabledUntil(limits, dataCategory) > now;
}
function updateRateLimits(limits, { statusCode, headers }, now = (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_0__/* .safeDateNow */ .Wk)()) {
  const updatedRateLimits = {
    ...limits
  };
  const rateLimitHeader = headers?.["x-sentry-rate-limits"];
  const retryAfterHeader = headers?.["retry-after"];
  if (rateLimitHeader) {
    for (const limit of rateLimitHeader.trim().split(",")) {
      const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(";")) {
          if (category === "metric_bucket") {
            if (!namespaces || namespaces.split(";").includes("custom")) {
              updatedRateLimits[category] = now + delay;
            }
          } else {
            updatedRateLimits[category] = now + delay;
          }
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1e3;
  }
  return updatedRateLimits;
}



/***/ }),

/***/ 35845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Om: function() { return /* binding */ getCombinedScopeData; },
/* harmony export */   e2: function() { return /* binding */ applyScopeDataToEvent; }
/* harmony export */ });
/* unused harmony exports mergeAndOverwriteScopeData, mergeScopeData */
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79255);
/* harmony import */ var _tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49271);
/* harmony import */ var _merge_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69201);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42896);




function applyScopeDataToEvent(event, data) {
  const { fingerprint, span, breadcrumbs, sdkProcessingMetadata } = data;
  applyDataToEvent(event, data);
  if (span) {
    applySpanToEvent(event, span);
  }
  applyFingerprintToEvent(event, fingerprint);
  applyBreadcrumbsToEvent(event, breadcrumbs);
  applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
function mergeScopeData(data, mergeData) {
  const {
    extra,
    tags,
    attributes,
    user,
    contexts,
    level,
    sdkProcessingMetadata,
    breadcrumbs,
    fingerprint,
    eventProcessors,
    attachments,
    propagationContext,
    transactionName,
    span
  } = mergeData;
  mergeAndOverwriteScopeData(data, "extra", extra);
  mergeAndOverwriteScopeData(data, "tags", tags);
  mergeAndOverwriteScopeData(data, "attributes", attributes);
  mergeAndOverwriteScopeData(data, "user", user);
  mergeAndOverwriteScopeData(data, "contexts", contexts);
  data.sdkProcessingMetadata = (0,_merge_js__WEBPACK_IMPORTED_MODULE_2__/* .merge */ .h)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
  if (level) {
    data.level = level;
  }
  if (transactionName) {
    data.transactionName = transactionName;
  }
  if (span) {
    data.span = span;
  }
  if (breadcrumbs.length) {
    data.breadcrumbs = [...data.breadcrumbs, ...breadcrumbs];
  }
  if (fingerprint.length) {
    data.fingerprint = [...data.fingerprint, ...fingerprint];
  }
  if (eventProcessors.length) {
    data.eventProcessors = [...data.eventProcessors, ...eventProcessors];
  }
  if (attachments.length) {
    data.attachments = [...data.attachments, ...attachments];
  }
  data.propagationContext = { ...data.propagationContext, ...propagationContext };
}
function mergeAndOverwriteScopeData(data, prop, mergeVal) {
  data[prop] = (0,_merge_js__WEBPACK_IMPORTED_MODULE_2__/* .merge */ .h)(data[prop], mergeVal, 1);
}
function getCombinedScopeData(isolationScope, currentScope) {
  const scopeData = (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalScope */ .m6)().getScopeData();
  isolationScope && mergeScopeData(scopeData, isolationScope.getScopeData());
  currentScope && mergeScopeData(scopeData, currentScope.getScopeData());
  return scopeData;
}
function applyDataToEvent(event, data) {
  const { extra, tags, user, contexts, level, transactionName } = data;
  if (Object.keys(extra).length) {
    event.extra = { ...extra, ...event.extra };
  }
  if (Object.keys(tags).length) {
    event.tags = { ...tags, ...event.tags };
  }
  if (Object.keys(user).length) {
    event.user = { ...user, ...event.user };
  }
  if (Object.keys(contexts).length) {
    event.contexts = { ...contexts, ...event.contexts };
  }
  if (level) {
    event.level = level;
  }
  if (transactionName && event.type !== "transaction") {
    event.transaction = transactionName;
  }
}
function applyBreadcrumbsToEvent(event, breadcrumbs) {
  const mergedBreadcrumbs = [...event.breadcrumbs || [], ...breadcrumbs];
  event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : void 0;
}
function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
  event.sdkProcessingMetadata = {
    ...event.sdkProcessingMetadata,
    ...sdkProcessingMetadata
  };
}
function applySpanToEvent(event, span) {
  event.contexts = {
    trace: (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToTraceContext */ .kX)(span),
    ...event.contexts
  };
  event.sdkProcessingMetadata = {
    dynamicSamplingContext: (0,_tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_1__/* .getDynamicSamplingContextFromSpan */ .k1)(span),
    ...event.sdkProcessingMetadata
  };
  const rootSpan = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .getRootSpan */ .zU)(span);
  const transactionName = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .et)(rootSpan).description;
  if (transactionName && !event.transaction && event.type === "transaction") {
    event.transaction = transactionName;
  }
}
function applyFingerprintToEvent(event, fingerprint) {
  event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [event.fingerprint] : [];
  if (fingerprint) {
    event.fingerprint = event.fingerprint.concat(fingerprint);
  }
  if (!event.fingerprint.length) {
    delete event.fingerprint;
  }
}



/***/ }),

/***/ 80064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   K: function() { return /* binding */ applySdkMetadata; }
/* harmony export */ });
/* harmony import */ var _version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83965);

function applySdkMetadata(options, name, names = [name], source = "npm") {
  const sdk = (options._metadata = options._metadata || {}).sdk = options._metadata.sdk || {};
  if (!sdk.name) {
    sdk.name = `sentry.javascript.${name}`;
    sdk.packages = names.map((name2) => ({
      name: `${source}:@sentry/${name2}`,
      version: _version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .M
    }));
    sdk.version = _version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .M;
  }
}



/***/ }),

/***/ 1682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   t: function() { return /* binding */ severityLevelFromString; }
/* harmony export */ });
function severityLevelFromString(level) {
  return level === "warn" ? "warning" : ["fatal", "error", "warning", "log", "info", "debug"].includes(level) ? level : "log";
}



/***/ }),

/***/ 90622:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   R: function() { return /* binding */ reparentChildSpans; },
/* harmony export */   e: function() { return /* binding */ shouldIgnoreSpan; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62183);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26228);



function logIgnoredSpan(droppedSpan) {
  _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function shouldIgnoreSpan(span, ignoreSpans) {
  if (!ignoreSpans?.length) {
    return false;
  }
  for (const pattern of ignoreSpans) {
    if (isStringOrRegExp(pattern)) {
      if (span.description && (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .isMatchingPattern */ ._c)(span.description, pattern)) {
        _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && logIgnoredSpan(span);
        return true;
      }
      continue;
    }
    const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
    if (!pattern.name && !pattern.op && !hasAttributes) {
      continue;
    }
    const nameMatches = pattern.name ? span.description && (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .isMatchingPattern */ ._c)(span.description, pattern.name) : true;
    const opMatches = pattern.op ? span.op && (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .isMatchingPattern */ ._c)(span.op, pattern.op) : true;
    const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(
      ([key, valuePattern]) => _matchesAttributeValue(span.attributes?.[key], valuePattern)
    ) : true;
    if (nameMatches && opMatches && attrsMatch) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && logIgnoredSpan(span);
      return true;
    }
  }
  return false;
}
function _matchesAttributeValue(actual, pat) {
  if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .isMatchingPattern */ ._c)(actual, pat);
  }
  if (Array.isArray(actual) && Array.isArray(pat)) {
    return actual.length === pat.length && actual.every((v, i) => v === pat[i]);
  }
  return actual === pat;
}
function reparentChildSpans(spans, dropSpan) {
  const droppedSpanParentId = dropSpan.parent_span_id;
  const droppedSpanId = dropSpan.span_id;
  if (!droppedSpanParentId) {
    return;
  }
  for (const span of spans) {
    if (span.parent_span_id === droppedSpanId) {
      span.parent_span_id = droppedSpanParentId;
    }
  }
}
function isStringOrRegExp(value) {
  return typeof value === "string" || value instanceof RegExp;
}



/***/ }),

/***/ 99070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   f: function() { return /* binding */ _getSpanForScope; },
/* harmony export */   r: function() { return /* binding */ _setSpanForScope; }
/* harmony export */ });
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50742);
/* harmony import */ var _weakRef_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69236);


const SCOPE_SPAN_FIELD = "_sentrySpan";
function _setSpanForScope(scope, span) {
  if (span) {
    (0,_object_js__WEBPACK_IMPORTED_MODULE_0__/* .addNonEnumerableProperty */ .my)(scope, SCOPE_SPAN_FIELD, (0,_weakRef_js__WEBPACK_IMPORTED_MODULE_1__/* .makeWeakRef */ .Z)(span));
  } else {
    delete scope[SCOPE_SPAN_FIELD];
  }
}
function _getSpanForScope(scope) {
  return (0,_weakRef_js__WEBPACK_IMPORTED_MODULE_1__/* .derefWeakRef */ .q)(scope[SCOPE_SPAN_FIELD]);
}



/***/ }),

/***/ 42896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Bk: function() { return /* binding */ getActiveSpan; },
/* harmony export */   Ck: function() { return /* binding */ spanToTransactionTraceContext; },
/* harmony export */   G_: function() { return /* binding */ spanToTraceparentHeader; },
/* harmony export */   HQ: function() { return /* binding */ getStreamedSpanLinks; },
/* harmony export */   Hu: function() { return /* binding */ addChildSpanToSpan; },
/* harmony export */   PL: function() { return /* binding */ streamedSpanJsonToSerializedSpan; },
/* harmony export */   Qh: function() { return /* binding */ spanToTraceHeader; },
/* harmony export */   RD: function() { return /* binding */ spanToStreamedSpanJSON; },
/* harmony export */   VS: function() { return /* binding */ removeChildSpanFromSpan; },
/* harmony export */   aW: function() { return /* binding */ INTERNAL_getSegmentSpan; },
/* harmony export */   cI: function() { return /* binding */ spanTimeInputToSeconds; },
/* harmony export */   dZ: function() { return /* binding */ getSimpleStatus; },
/* harmony export */   et: function() { return /* binding */ spanToJSON; },
/* harmony export */   fy: function() { return /* binding */ addStatusMessageAttribute; },
/* harmony export */   kX: function() { return /* binding */ spanToTraceContext; },
/* harmony export */   pK: function() { return /* binding */ spanIsSampled; },
/* harmony export */   uU: function() { return /* binding */ convertSpanLinksForEnvelope; },
/* harmony export */   xO: function() { return /* binding */ getSpanDescendants; },
/* harmony export */   xl: function() { return /* binding */ showSpanDropWarning; },
/* harmony export */   yW: function() { return /* binding */ getStatusMessage; },
/* harmony export */   zQ: function() { return /* binding */ updateSpanName; }
/* harmony export */ });
/* harmony import */ var _asyncContext_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27657);
/* harmony import */ var _attributes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93778);
/* harmony import */ var _carrier_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35179);
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79255);
/* harmony import */ var _semanticAttributes_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91302);
/* harmony import */ var _tracing_utils_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28175);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(50742);
/* harmony import */ var _propagationContext_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66508);
/* harmony import */ var _time_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39612);
/* harmony import */ var _tracing_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36779);
/* harmony import */ var _debug_logger_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62183);
/* harmony import */ var _spanOnScope_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99070);













const TRACE_FLAG_NONE = 0;
const TRACE_FLAG_SAMPLED = 1;
let hasShownSpanDropWarning = false;
function spanToTransactionTraceContext(span) {
  const { spanId: span_id, traceId: trace_id } = span.spanContext();
  const { data, op, parent_span_id, status, origin, links } = spanToJSON(span);
  return {
    parent_span_id,
    span_id,
    trace_id,
    data,
    op,
    status,
    origin,
    links
  };
}
function spanToTraceContext(span) {
  const { spanId, traceId: trace_id, isRemote } = span.spanContext();
  const parent_span_id = isRemote ? spanId : spanToJSON(span).parent_span_id;
  const scope = (0,_tracing_utils_js__WEBPACK_IMPORTED_MODULE_6__/* .getCapturedScopesOnSpan */ .Lb)(span).scope;
  const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0,_propagationContext_js__WEBPACK_IMPORTED_MODULE_8__/* .generateSpanId */ .Z)() : spanId;
  return {
    parent_span_id,
    span_id,
    trace_id
  };
}
function spanToTraceHeader(span) {
  const { traceId, spanId } = span.spanContext();
  const sampled = spanIsSampled(span);
  return (0,_tracing_js__WEBPACK_IMPORTED_MODULE_10__/* .generateSentryTraceHeader */ .TC)(traceId, spanId, sampled);
}
function spanToTraceparentHeader(span) {
  const { traceId, spanId } = span.spanContext();
  const sampled = spanIsSampled(span);
  return (0,_tracing_js__WEBPACK_IMPORTED_MODULE_10__/* .generateTraceparentHeader */ .Iy)(traceId, spanId, sampled);
}
function convertSpanLinksForEnvelope(links) {
  if (links && links.length > 0) {
    return links.map(({ context: { spanId, traceId, traceFlags, ...restContext }, attributes }) => ({
      span_id: spanId,
      trace_id: traceId,
      sampled: traceFlags === TRACE_FLAG_SAMPLED,
      attributes,
      ...restContext
    }));
  } else {
    return void 0;
  }
}
function getStreamedSpanLinks(links) {
  if (links?.length) {
    return links.map(({ context: { spanId, traceId, traceFlags }, attributes }) => ({
      span_id: spanId,
      trace_id: traceId,
      sampled: traceFlags === TRACE_FLAG_SAMPLED,
      attributes
    }));
  } else {
    return void 0;
  }
}
function spanTimeInputToSeconds(input) {
  if (typeof input === "number") {
    return ensureTimestampInSeconds(input);
  }
  if (Array.isArray(input)) {
    return input[0] + input[1] / 1e9;
  }
  if (input instanceof Date) {
    return ensureTimestampInSeconds(input.getTime());
  }
  return (0,_time_js__WEBPACK_IMPORTED_MODULE_9__/* .timestampInSeconds */ .zf)();
}
function ensureTimestampInSeconds(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp / 1e3 : timestamp;
}
function spanToJSON(span) {
  if (spanIsSentrySpan(span)) {
    return span.getSpanJSON();
  }
  const { spanId: span_id, traceId: trace_id } = span.spanContext();
  if (spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
    const { attributes, startTime, name, endTime, status, links } = span;
    return {
      span_id,
      trace_id,
      data: attributes,
      description: name,
      parent_span_id: getOtelParentSpanId(span),
      start_timestamp: spanTimeInputToSeconds(startTime),
      // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
      timestamp: spanTimeInputToSeconds(endTime) || void 0,
      status: getStatusMessage(status),
      op: attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_4__/* .SEMANTIC_ATTRIBUTE_SENTRY_OP */ .uT],
      origin: attributes[_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_4__/* .SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */ .JD],
      links: convertSpanLinksForEnvelope(links)
    };
  }
  return {
    span_id,
    trace_id,
    start_timestamp: 0,
    data: {}
  };
}
function spanToStreamedSpanJSON(span) {
  if (spanIsSentrySpan(span)) {
    return span.getStreamedSpanJSON();
  }
  const { spanId: span_id, traceId: trace_id } = span.spanContext();
  if (spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
    const { attributes, startTime, name, endTime, status, links } = span;
    return {
      name,
      span_id,
      trace_id,
      parent_span_id: getOtelParentSpanId(span),
      start_timestamp: spanTimeInputToSeconds(startTime),
      end_timestamp: spanTimeInputToSeconds(endTime),
      is_segment: span === INTERNAL_getSegmentSpan(span),
      status: getSimpleStatus(status),
      attributes: addStatusMessageAttribute(attributes, status),
      links: getStreamedSpanLinks(links)
    };
  }
  return {
    span_id,
    trace_id,
    start_timestamp: 0,
    name: "",
    end_timestamp: 0,
    status: "ok",
    is_segment: span === INTERNAL_getSegmentSpan(span)
  };
}
function getOtelParentSpanId(span) {
  return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function streamedSpanJsonToSerializedSpan(spanJson) {
  return {
    ...spanJson,
    attributes: (0,_attributes_js__WEBPACK_IMPORTED_MODULE_1__/* .serializeAttributes */ .SY)(spanJson.attributes),
    links: spanJson.links?.map((link) => ({
      ...link,
      attributes: (0,_attributes_js__WEBPACK_IMPORTED_MODULE_1__/* .serializeAttributes */ .SY)(link.attributes)
    }))
  };
}
function spanIsOpenTelemetrySdkTraceBaseSpan(span) {
  const castSpan = span;
  return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function spanIsSentrySpan(span) {
  return typeof span.getSpanJSON === "function";
}
function spanIsSampled(span) {
  const { traceFlags } = span.spanContext();
  return traceFlags === TRACE_FLAG_SAMPLED;
}
function getStatusMessage(status) {
  if (!status || status.code === (/* inlined export .SPAN_STATUS_UNSET */0)) {
    return void 0;
  }
  if (status.code === (/* inlined export .SPAN_STATUS_OK */1)) {
    return "ok";
  }
  return status.message || "internal_error";
}
function getSimpleStatus(status) {
  return !status || status.code === (/* inlined export .SPAN_STATUS_OK */1) || status.code === (/* inlined export .SPAN_STATUS_UNSET */0) || status.message === "cancelled" ? "ok" : "error";
}
function addStatusMessageAttribute(attributes, status) {
  const statusMessage = getSimpleStatus(status) === "error" ? status?.message : void 0;
  return {
    ...statusMessage && { [_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_4__/* .SEMANTIC_ATTRIBUTE_SENTRY_STATUS_MESSAGE */ .Ft]: statusMessage },
    ...attributes
  };
}
const CHILD_SPANS_FIELD = "_sentryChildSpans";
const ROOT_SPAN_FIELD = "_sentryRootSpan";
function addChildSpanToSpan(span, childSpan) {
  const rootSpan = span[ROOT_SPAN_FIELD] || span;
  (0,_object_js__WEBPACK_IMPORTED_MODULE_7__/* .addNonEnumerableProperty */ .my)(childSpan, ROOT_SPAN_FIELD, rootSpan);
  if (span[CHILD_SPANS_FIELD]) {
    span[CHILD_SPANS_FIELD].add(childSpan);
  } else {
    (0,_object_js__WEBPACK_IMPORTED_MODULE_7__/* .addNonEnumerableProperty */ .my)(span, CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([childSpan]));
  }
}
function removeChildSpanFromSpan(span, childSpan) {
  if (span[CHILD_SPANS_FIELD]) {
    span[CHILD_SPANS_FIELD].delete(childSpan);
  }
}
function getSpanDescendants(span) {
  const resultSet = /* @__PURE__ */ new Set();
  function addSpanChildren(span2) {
    if (resultSet.has(span2)) {
      return;
    } else if (spanIsSampled(span2)) {
      resultSet.add(span2);
      const childSpans = span2[CHILD_SPANS_FIELD] ? Array.from(span2[CHILD_SPANS_FIELD]) : [];
      for (const childSpan of childSpans) {
        addSpanChildren(childSpan);
      }
    }
  }
  addSpanChildren(span);
  return Array.from(resultSet);
}
const getRootSpan = INTERNAL_getSegmentSpan;
function INTERNAL_getSegmentSpan(span) {
  return span[ROOT_SPAN_FIELD] || span;
}
function getActiveSpan() {
  const carrier = (0,_carrier_js__WEBPACK_IMPORTED_MODULE_2__/* .getMainCarrier */ .EU)();
  const acs = (0,_asyncContext_index_js__WEBPACK_IMPORTED_MODULE_0__/* .getAsyncContextStrategy */ .h)(carrier);
  if (acs.getActiveSpan) {
    return acs.getActiveSpan();
  }
  return (0,_spanOnScope_js__WEBPACK_IMPORTED_MODULE_12__/* ._getSpanForScope */ .f)((0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_3__/* .getCurrentScope */ .o5)());
}
function showSpanDropWarning() {
  if (!hasShownSpanDropWarning) {
    (0,_debug_logger_js__WEBPACK_IMPORTED_MODULE_11__/* .consoleSandbox */ .pq)(() => {
      console.warn(
        "[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`."
      );
    });
    hasShownSpanDropWarning = true;
  }
}
function updateSpanName(span, name) {
  span.updateName(name);
  span.setAttributes({
    [_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_4__/* .SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */ .i_]: "custom",
    [_semanticAttributes_js__WEBPACK_IMPORTED_MODULE_4__/* .SEMANTIC_ATTRIBUTE_SENTRY_CUSTOM_SPAN_NAME */ .Le]: name
  });
}


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "zU", 0, /* binding */ getRootSpan
/* harmony export */ ]);


/***/ }),

/***/ 52992:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   RV: function() { return /* binding */ getFramesFromEvent; },
/* harmony export */   Wt: function() { return /* binding */ normalizeStackTracePath; },
/* harmony export */   gd: function() { return /* binding */ createStackParser; },
/* harmony export */   qQ: function() { return /* binding */ getFunctionName; },
/* harmony export */   vk: function() { return /* binding */ stackParserFromStackParserOptions; }
/* harmony export */ });
/* unused harmony export stripSentryFramesAndReverse */
const STACKTRACE_FRAME_LIMIT = 50;
const UNKNOWN_FUNCTION = "?";
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const STRIP_FRAME_REGEXP = /captureMessage|captureException/;
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map((p) => p[1]);
  return (stack, skipFirstLines = 0, framesToPop = 0) => {
    const frames = [];
    const lines = stack.split("\n");
    for (let i = skipFirstLines; i < lines.length; i++) {
      let line = lines[i];
      if (line.length > 1024) {
        line = line.slice(0, 1024);
      }
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, "$1") : line;
      if (cleanedLine.includes("Error: ")) {
        continue;
      }
      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);
        if (frame) {
          frames.push(frame);
          break;
        }
      }
      if (frames.length >= STACKTRACE_FRAME_LIMIT + framesToPop) {
        break;
      }
    }
    return stripSentryFramesAndReverse(frames.slice(framesToPop));
  };
}
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }
  const localStack = Array.from(stack);
  if (/sentryWrapped/.test(getLastStackFrame(localStack).function || "")) {
    localStack.pop();
  }
  localStack.reverse();
  if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || "")) {
    localStack.pop();
    if (STRIP_FRAME_REGEXP.test(getLastStackFrame(localStack).function || "")) {
      localStack.pop();
    }
  }
  return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map((frame) => ({
    ...frame,
    filename: frame.filename || getLastStackFrame(localStack).filename,
    function: frame.function || UNKNOWN_FUNCTION
  }));
}
function getLastStackFrame(arr) {
  return arr[arr.length - 1] || {};
}
const defaultFunctionName = "<anonymous>";
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== "function") {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch {
    return defaultFunctionName;
  }
}
function getFramesFromEvent(event) {
  const exception = event.exception;
  if (exception) {
    const frames = [];
    try {
      exception.values.forEach((value) => {
        if (value.stacktrace.frames) {
          frames.push(...value.stacktrace.frames);
        }
      });
      return frames;
    } catch {
      return void 0;
    }
  }
  return void 0;
}
function normalizeStackTracePath(path) {
  let filename = path?.startsWith("file://") ? path.slice(7) : path;
  if (filename?.match(/\/[A-Z]:/)) {
    filename = filename.slice(1);
  }
  return filename;
}



/***/ }),

/***/ 26228:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Xr: function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   _c: function() { return /* binding */ isMatchingPattern; },
/* harmony export */   gt: function() { return /* binding */ safeJoin; },
/* harmony export */   nC: function() { return /* binding */ snipLine; },
/* harmony export */   xv: function() { return /* binding */ truncate; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91973);
/* harmony import */ var _normalize_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51830);


function truncate(str, max = 0) {
  if (typeof str !== "string" || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    colno = lineLength;
  }
  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }
  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }
  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += " {snip}";
  }
  return newLine;
}
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return "";
  }
  const output = [];
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPrimitive */ .sO)(value)) {
      output.push(String(value));
    } else if (value instanceof Error) {
      output.push(value.message ? `${value.name}: ${value.message}` : value.name);
    } else {
      output.push((0,_normalize_js__WEBPACK_IMPORTED_MODULE_1__/* .stringifyValue */ .ng)(void 0, value));
    }
  }
  return output.join(delimiter);
}
function isMatchingPattern(value, pattern, requireExactStringMatch = false) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .Kg)(value)) {
    return false;
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .gd)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .Kg)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }
  if (typeof pattern === "function") {
    return pattern(value);
  }
  return false;
}
function stringMatchesSomePattern(testString, patterns = [], requireExactStringMatch = false) {
  for (const pattern of patterns) {
    if (isMatchingPattern(testString, pattern, requireExactStringMatch)) {
      return true;
    }
  }
  return false;
}



/***/ }),

/***/ 53717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NJ: function() { return /* binding */ supportsHistory; },
/* harmony export */   a3: function() { return /* binding */ isNativeFunction; },
/* harmony export */   m7: function() { return /* binding */ supportsNativeFetch; },
/* harmony export */   vQ: function() { return /* binding */ supportsReportingObserver; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsFetch, supportsReferrerPolicy */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97169);
/* harmony import */ var _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62183);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70774);



const WINDOW = _worldwide_js__WEBPACK_IMPORTED_MODULE_2__/* .GLOBAL_OBJ */ .O;
function supportsErrorEvent() {
  try {
    new ErrorEvent("");
    return true;
  } catch {
    return false;
  }
}
function supportsDOMError() {
  try {
    new DOMError("");
    return true;
  } catch {
    return false;
  }
}
function supportsDOMException() {
  try {
    new DOMException("");
    return true;
  } catch {
    return false;
  }
}
function supportsHistory() {
  return "history" in WINDOW && !!WINDOW.history;
}
const supportsFetch = (/* unused pure expression or super */ null && (_isFetchSupported));
function _isFetchSupported() {
  if (!("fetch" in WINDOW)) {
    return false;
  }
  try {
    new Headers();
    new Request("data:,");
    new Response();
    return true;
  } catch {
    return false;
  }
}
function isNativeFunction(func) {
  return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function supportsNativeFetch() {
  if (typeof EdgeRuntime === "string") {
    return true;
  }
  if (!_isFetchSupported()) {
    return false;
  }
  if (isNativeFunction(WINDOW.fetch)) {
    return true;
  }
  let result = false;
  const doc = WINDOW.document;
  if (doc && typeof doc.createElement === "function") {
    try {
      const sandbox = doc.createElement("iframe");
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow?.fetch) {
        result = isNativeFunction(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .T && _debug_logger_js__WEBPACK_IMPORTED_MODULE_1__/* .debug */ .Yz.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
  }
  return result;
}
function supportsReportingObserver() {
  return "ReportingObserver" in WINDOW;
}
function supportsReferrerPolicy() {
  if (!_isFetchSupported()) {
    return false;
  }
  try {
    new Request("_", {
      referrerPolicy: "origin"
    });
    return true;
  } catch {
    return false;
  }
}



/***/ }),

/***/ 18533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   XW: function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   xg: function() { return /* binding */ rejectedSyncPromise; }
/* harmony export */ });
/* unused harmony export SyncPromise */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91973);

const STATE_PENDING = 0;
const STATE_RESOLVED = 1;
const STATE_REJECTED = 2;
function resolvedSyncPromise(value) {
  return new SyncPromise((resolve) => {
    resolve(value);
  });
}
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}
class SyncPromise {
  constructor(executor) {
    this._state = STATE_PENDING;
    this._handlers = [];
    this._runExecutor(executor);
  }
  /** @inheritdoc */
  then(onfulfilled, onrejected) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        (result) => {
          if (!onfulfilled) {
            resolve(result);
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        (reason) => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        }
      ]);
      this._executeHandlers();
    });
  }
  /** @inheritdoc */
  catch(onrejected) {
    return this.then((val) => val, onrejected);
  }
  /** @inheritdoc */
  finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;
      return this.then(
        (value) => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        (reason) => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        }
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }
        resolve(val);
      });
    });
  }
  /** Excute the resolve/reject handlers. */
  _executeHandlers() {
    if (this._state === STATE_PENDING) {
      return;
    }
    const cachedHandlers = this._handlers.slice();
    this._handlers = [];
    cachedHandlers.forEach((handler) => {
      if (handler[0]) {
        return;
      }
      if (this._state === STATE_RESOLVED) {
        handler[1](this._value);
      }
      if (this._state === STATE_REJECTED) {
        handler[2](this._value);
      }
      handler[0] = true;
    });
  }
  /** Run the executor for the SyncPromise. */
  _runExecutor(executor) {
    const setResult = (state, value) => {
      if (this._state !== STATE_PENDING) {
        return;
      }
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .Qg)(value)) {
        void value.then(resolve, reject);
        return;
      }
      this._state = state;
      this._value = value;
      this._executeHandlers();
    };
    const resolve = (value) => {
      setResult(STATE_RESOLVED, value);
    };
    const reject = (reason) => {
      setResult(STATE_REJECTED, reason);
    };
    try {
      executor(resolve, reject);
    } catch (e) {
      reject(e);
    }
  }
}



/***/ }),

/***/ 39612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   k3: function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   lu: function() { return /* binding */ dateTimestampInSeconds; },
/* harmony export */   zf: function() { return /* binding */ timestampInSeconds; }
/* harmony export */ });
/* harmony import */ var _randomSafeContext_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23324);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70774);


const ONE_SECOND_IN_MS = 1e3;
function dateTimestampInSeconds() {
  return (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_0__/* .safeDateNow */ .Wk)() / ONE_SECOND_IN_MS;
}
function createUnixTimestampInSecondsFunc() {
  const { performance } = _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ */ .O;
  if (!performance?.now || !performance.timeOrigin) {
    return dateTimestampInSeconds;
  }
  const timeOrigin = performance.timeOrigin;
  return () => {
    return (timeOrigin + (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_0__/* .withRandomSafeContext */ .Qw)(() => performance.now())) / ONE_SECOND_IN_MS;
  };
}
let _cachedTimestampInSeconds;
function timestampInSeconds() {
  const func = _cachedTimestampInSeconds ?? (_cachedTimestampInSeconds = createUnixTimestampInSecondsFunc());
  return func();
}
let cachedTimeOrigin = null;
function getBrowserTimeOrigin() {
  const { performance } = _worldwide_js__WEBPACK_IMPORTED_MODULE_1__/* .GLOBAL_OBJ */ .O;
  if (!performance?.now) {
    return void 0;
  }
  const threshold = 3e5;
  const performanceNow = (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_0__/* .withRandomSafeContext */ .Qw)(() => performance.now());
  const dateNow = (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_0__/* .safeDateNow */ .Wk)();
  const timeOrigin = performance.timeOrigin;
  if (typeof timeOrigin === "number") {
    const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
    if (timeOriginDelta < threshold) {
      return timeOrigin;
    }
  }
  const navigationStart = performance.timing?.navigationStart;
  if (typeof navigationStart === "number") {
    const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
    if (navigationStartDelta < threshold) {
      return navigationStart;
    }
  }
  return dateNow - performanceNow;
}
function browserPerformanceTimeOrigin() {
  if (cachedTimeOrigin === null) {
    cachedTimeOrigin = getBrowserTimeOrigin();
  }
  return cachedTimeOrigin;
}



/***/ }),

/***/ 35084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   G: function() { return /* binding */ safeUnref; }
/* harmony export */ });
function safeUnref(timer) {
  if (typeof timer === "object" && typeof timer.unref === "function") {
    timer.unref();
  }
  return timer;
}



/***/ }),

/***/ 78172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   o: function() { return /* binding */ getSequenceAttribute; }
/* harmony export */ });
const SEQUENCE_ATTR_KEY = "sentry.timestamp.sequence";
let _sequenceNumber = 0;
let _previousTimestampMs;
function getSequenceAttribute(timestampInSeconds) {
  const nowMs = Math.floor(timestampInSeconds * 1e3);
  if (_previousTimestampMs !== void 0 && nowMs !== _previousTimestampMs) {
    _sequenceNumber = 0;
  }
  const value = _sequenceNumber;
  _sequenceNumber++;
  _previousTimestampMs = nowMs;
  return {
    key: SEQUENCE_ATTR_KEY,
    value: { value, type: "integer" }
  };
}



/***/ }),

/***/ 65653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   V: function() { return /* binding */ _getTraceInfoFromScope; }
/* harmony export */ });
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79255);
/* harmony import */ var _tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49271);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42896);



function _getTraceInfoFromScope(client, scope) {
  if (!scope) {
    return [void 0, void 0];
  }
  return (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .withScope */ .v4)(scope, () => {
    const span = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .getActiveSpan */ .Bk)();
    const traceContext = span ? (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_2__/* .spanToTraceContext */ .kX)(span) : (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_0__/* .getTraceContextFromScope */ .vn)(scope);
    const dynamicSamplingContext = span ? (0,_tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_1__/* .getDynamicSamplingContextFromSpan */ .k1)(span) : (0,_tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_1__/* .getDynamicSamplingContextFromScope */ .ao)(client, scope);
    return [dynamicSamplingContext, traceContext];
  });
}



/***/ }),

/***/ 51096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   i: function() { return /* binding */ getTraceData; }
/* harmony export */ });
/* harmony import */ var _asyncContext_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27657);
/* harmony import */ var _carrier_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35179);
/* harmony import */ var _currentScopes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79255);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60068);
/* harmony import */ var _debug_logger_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62183);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42896);
/* harmony import */ var _hasSpansEnabled_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91811);
/* harmony import */ var _tracing_sentryNonRecordingSpan_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45729);
/* harmony import */ var _tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49271);
/* harmony import */ var _baggage_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94787);
/* harmony import */ var _tracing_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36779);











function getTraceData(options = {}) {
  const client = options.client || (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_2__/* .getClient */ .KU)();
  if (!(0,_exports_js__WEBPACK_IMPORTED_MODULE_3__/* .isEnabled */ .Ol)() || !client) {
    return {};
  }
  const carrier = (0,_carrier_js__WEBPACK_IMPORTED_MODULE_1__/* .getMainCarrier */ .EU)();
  const acs = (0,_asyncContext_index_js__WEBPACK_IMPORTED_MODULE_0__/* .getAsyncContextStrategy */ .h)(carrier);
  if (acs.getTraceData) {
    return acs.getTraceData(options);
  }
  const scope = options.scope || (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentScope */ .o5)();
  const span = options.span || (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_5__/* .getActiveSpan */ .Bk)();
  const isTwpPlaceholder = (0,_tracing_sentryNonRecordingSpan_js__WEBPACK_IMPORTED_MODULE_7__/* .spanIsNonRecordingSpan */ .h)(span) && !(0,_hasSpansEnabled_js__WEBPACK_IMPORTED_MODULE_6__/* .hasSpansEnabled */ .f)(client.getOptions());
  if (!span && (0,_currentScopes_js__WEBPACK_IMPORTED_MODULE_2__/* .hasExternalPropagationContext */ .Bi)()) {
    return {};
  }
  const sentryTrace = span && !isTwpPlaceholder ? (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_5__/* .spanToTraceHeader */ .Qh)(span) : scopeToTraceHeader(scope);
  const dsc = span ? (0,_tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_8__/* .getDynamicSamplingContextFromSpan */ .k1)(span) : (0,_tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_8__/* .getDynamicSamplingContextFromScope */ .ao)(client, scope);
  const baggage = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_9__/* .dynamicSamplingContextToSentryBaggageHeader */ .De)(dsc);
  const isValidSentryTraceHeader = _tracing_js__WEBPACK_IMPORTED_MODULE_10__/* .TRACEPARENT_REGEXP */ .MI.test(sentryTrace);
  if (!isValidSentryTraceHeader) {
    _debug_logger_js__WEBPACK_IMPORTED_MODULE_4__/* .debug */ .Yz.warn("Invalid sentry-trace data. Cannot generate trace data");
    return {};
  }
  const traceData = {
    "sentry-trace": sentryTrace,
    baggage
  };
  if (options.propagateTraceparent) {
    traceData.traceparent = span && !isTwpPlaceholder ? (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_5__/* .spanToTraceparentHeader */ .G_)(span) : scopeToTraceparentHeader(scope);
  }
  return traceData;
}
function scopeToTraceHeader(scope) {
  const { traceId, sampled, propagationSpanId } = scope.getPropagationContext();
  return (0,_tracing_js__WEBPACK_IMPORTED_MODULE_10__/* .generateSentryTraceHeader */ .TC)(traceId, propagationSpanId, sampled);
}
function scopeToTraceparentHeader(scope) {
  const { traceId, sampled, propagationSpanId } = scope.getPropagationContext();
  return (0,_tracing_js__WEBPACK_IMPORTED_MODULE_10__/* .generateTraceparentHeader */ .Iy)(traceId, propagationSpanId, sampled);
}



/***/ }),

/***/ 36779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A9: function() { return /* binding */ shouldContinueTrace; },
/* harmony export */   Iy: function() { return /* binding */ generateTraceparentHeader; },
/* harmony export */   TC: function() { return /* binding */ generateSentryTraceHeader; },
/* harmony export */   kM: function() { return /* binding */ propagationContextFromHeaders; }
/* harmony export */ });
/* unused harmony export extractTraceparentData */
/* harmony import */ var _debug_logger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62183);
/* harmony import */ var _baggage_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94787);
/* harmony import */ var _dsn_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56648);
/* harmony import */ var _parseSampleRate_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91554);
/* harmony import */ var _propagationContext_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66508);
/* harmony import */ var _randomSafeContext_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23324);






const TRACEPARENT_REGEXP = new RegExp(
  "^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$"
  // whitespace
);
function extractTraceparentData(traceparent) {
  if (!traceparent) {
    return void 0;
  }
  const matches = traceparent.match(TRACEPARENT_REGEXP);
  if (!matches) {
    return void 0;
  }
  let parentSampled;
  if (matches[3] === "1") {
    parentSampled = true;
  } else if (matches[3] === "0") {
    parentSampled = false;
  }
  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2]
  };
}
function propagationContextFromHeaders(sentryTrace, baggage) {
  const traceparentData = extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_1__/* .baggageHeaderToDynamicSamplingContext */ .yD)(baggage);
  if (!traceparentData?.traceId) {
    return {
      traceId: (0,_propagationContext_js__WEBPACK_IMPORTED_MODULE_4__/* .generateTraceId */ .e)(),
      sampleRand: (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_5__/* .safeMathRandom */ .hY)()
    };
  }
  const sampleRand = getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
  if (dynamicSamplingContext) {
    dynamicSamplingContext.sample_rand = sampleRand.toString();
  }
  const { traceId, parentSpanId, parentSampled } = traceparentData;
  return {
    traceId,
    parentSpanId,
    sampled: parentSampled,
    dsc: dynamicSamplingContext || {},
    // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
    sampleRand
  };
}
function generateSentryTraceHeader(traceId = (0,_propagationContext_js__WEBPACK_IMPORTED_MODULE_4__/* .generateTraceId */ .e)(), spanId = (0,_propagationContext_js__WEBPACK_IMPORTED_MODULE_4__/* .generateSpanId */ .Z)(), sampled) {
  let sampledString = "";
  if (sampled !== void 0) {
    sampledString = sampled ? "-1" : "-0";
  }
  return `${traceId}-${spanId}${sampledString}`;
}
function generateTraceparentHeader(traceId = (0,_propagationContext_js__WEBPACK_IMPORTED_MODULE_4__/* .generateTraceId */ .e)(), spanId = (0,_propagationContext_js__WEBPACK_IMPORTED_MODULE_4__/* .generateSpanId */ .Z)(), sampled) {
  return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
  const parsedSampleRand = (0,_parseSampleRate_js__WEBPACK_IMPORTED_MODULE_3__/* .parseSampleRate */ .i)(dsc?.sample_rand);
  if (parsedSampleRand !== void 0) {
    return parsedSampleRand;
  }
  const parsedSampleRate = (0,_parseSampleRate_js__WEBPACK_IMPORTED_MODULE_3__/* .parseSampleRate */ .i)(dsc?.sample_rate);
  if (parsedSampleRate && traceparentData?.parentSampled !== void 0) {
    return traceparentData.parentSampled ? (
      // Returns a sample rand with positive sampling decision [0, sampleRate)
      (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_5__/* .safeMathRandom */ .hY)() * parsedSampleRate
    ) : (
      // Returns a sample rand with negative sampling decision [sampleRate, 1)
      parsedSampleRate + (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_5__/* .safeMathRandom */ .hY)() * (1 - parsedSampleRate)
    );
  } else {
    return (0,_randomSafeContext_js__WEBPACK_IMPORTED_MODULE_5__/* .safeMathRandom */ .hY)();
  }
}
function shouldContinueTrace(client, baggageOrgId) {
  const clientOrgId = (0,_dsn_js__WEBPACK_IMPORTED_MODULE_2__/* .extractOrgIdFromClient */ .ul)(client);
  if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
    _debug_logger_js__WEBPACK_IMPORTED_MODULE_0__/* .debug */ .Yz.log(
      `Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`
    );
    return false;
  }
  const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
  if (strictTraceContinuation) {
    if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
      _debug_logger_js__WEBPACK_IMPORTED_MODULE_0__/* .debug */ .Yz.log(
        `Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`
      );
      return false;
    }
  }
  return true;
}


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "MI", 0, /* binding */ TRACEPARENT_REGEXP
/* harmony export */ ]);


/***/ }),

/***/ 77636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CH: function() { return /* binding */ getSanitizedUrlStringFromUrlObject; },
/* harmony export */   Dl: function() { return /* binding */ parseUrl; },
/* harmony export */   f: function() { return /* binding */ stripUrlQueryAndFragment; },
/* harmony export */   kg: function() { return /* binding */ parseStringToURLObject; },
/* harmony export */   nt: function() { return /* binding */ isURLObjectRelative; },
/* harmony export */   zm: function() { return /* binding */ stripDataUrlContent; }
/* harmony export */ });
/* unused harmony exports getHttpSpanDetailsFromUrlObject, getSanitizedUrlString */
/* unused harmony import specifier */ var SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN;
/* unused harmony import specifier */ var SEMANTIC_ATTRIBUTE_SENTRY_SOURCE;
/* unused harmony import specifier */ var SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD;
/* unused harmony import specifier */ var SEMANTIC_ATTRIBUTE_URL_FULL;

const DEFAULT_BASE_URL = "thismessage:/";
function isURLObjectRelative(url) {
  return "isRelative" in url;
}
function parseStringToURLObject(url, urlBase) {
  const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
  const base = urlBase ?? (isRelative ? DEFAULT_BASE_URL : void 0);
  try {
    if ("canParse" in URL && !URL.canParse(url, base)) {
      return void 0;
    }
    const fullUrlObject = new URL(url, base);
    if (isRelative) {
      return {
        isRelative,
        pathname: fullUrlObject.pathname,
        search: fullUrlObject.search,
        hash: fullUrlObject.hash
      };
    }
    return fullUrlObject;
  } catch {
  }
  return void 0;
}
function getSanitizedUrlStringFromUrlObject(url) {
  if (isURLObjectRelative(url)) {
    return url.pathname;
  }
  const newUrl = new URL(url);
  newUrl.search = "";
  newUrl.hash = "";
  if (["80", "443"].includes(newUrl.port)) {
    newUrl.port = "";
  }
  if (newUrl.password) {
    newUrl.password = "%filtered%";
  }
  if (newUrl.username) {
    newUrl.username = "%filtered%";
  }
  return newUrl.toString();
}
function getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
  const method = request?.method?.toUpperCase() ?? "GET";
  const route = routeName ? routeName : urlObject ? kind === "client" ? getSanitizedUrlStringFromUrlObject(urlObject) : urlObject.pathname : "/";
  return `${method} ${route}`;
}
function getHttpSpanDetailsFromUrlObject(urlObject, kind, spanOrigin, request, routeName) {
  const attributes = {
    [SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
    [SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: "url"
  };
  if (routeName) {
    attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
    attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
  }
  if (request?.method) {
    attributes[SEMANTIC_ATTRIBUTE_HTTP_REQUEST_METHOD] = request.method.toUpperCase();
  }
  if (urlObject) {
    if (urlObject.search) {
      attributes["url.query"] = urlObject.search;
    }
    if (urlObject.hash) {
      attributes["url.fragment"] = urlObject.hash;
    }
    if (urlObject.pathname) {
      attributes["url.path"] = urlObject.pathname;
      if (urlObject.pathname === "/") {
        attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "route";
      }
    }
    if (!isURLObjectRelative(urlObject)) {
      attributes[SEMANTIC_ATTRIBUTE_URL_FULL] = urlObject.href;
      if (urlObject.port) {
        attributes["url.port"] = urlObject.port;
      }
      if (urlObject.protocol) {
        attributes["url.scheme"] = urlObject.protocol;
      }
      if (urlObject.hostname) {
        attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
      }
    }
  }
  return [getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName), attributes];
}
function parseUrl(url) {
  if (!url) {
    return {};
  }
  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!match) {
    return {};
  }
  const query = match[6] || "";
  const fragment = match[8] || "";
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment
    // everything minus origin
  };
}
function stripUrlQueryAndFragment(urlPath) {
  return urlPath.split(/[?#]/, 1)[0];
}
function getSanitizedUrlString(url) {
  const { protocol, host, path } = url;
  const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
  return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function stripDataUrlContent(url, includeDataPrefix = true) {
  if (url.startsWith("data:")) {
    const match = url.match(/^data:([^;,]+)/);
    const mimeType = match ? match[1] : "text/plain";
    const isBase64 = url.includes(";base64,");
    const dataStart = url.indexOf(",");
    let dataPrefix = "";
    if (includeDataPrefix && dataStart !== -1) {
      const data = url.slice(dataStart + 1);
      dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
    }
    return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
  }
  return url;
}



/***/ }),

/***/ 83965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
const SDK_VERSION = "10.63.0";


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "M", 0, /* binding */ SDK_VERSION
/* harmony export */ ]);


/***/ }),

/***/ 69236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: function() { return /* binding */ makeWeakRef; },
/* harmony export */   q: function() { return /* binding */ derefWeakRef; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70774);

function makeWeakRef(value) {
  try {
    const WeakRefImpl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .O.WeakRef;
    if (typeof WeakRefImpl === "function") {
      return new WeakRefImpl(value);
    }
  } catch {
  }
  return value;
}
function derefWeakRef(ref) {
  if (!ref) {
    return void 0;
  }
  if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") {
    try {
      return ref.deref();
    } catch {
      return void 0;
    }
  }
  return ref;
}



/***/ }),

/***/ 70774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
const GLOBAL_OBJ = globalThis;


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "O", 0, /* binding */ GLOBAL_OBJ
/* harmony export */ ]);


/***/ }),

/***/ 56220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  T: function() { return /* binding */ init; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/exports.js
var esm_exports = __webpack_require__(60068);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/sdk.js + 2 modules
var sdk = __webpack_require__(4576);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/build/npm/esm/prod/normalizeStringifyValue.js + 1 modules
var normalizeStringifyValue = __webpack_require__(83367);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/sdkMetadata.js
var sdkMetadata = __webpack_require__(80064);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/normalize.js
var normalize = __webpack_require__(51830);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/is.js
var is = __webpack_require__(91973);
;// ./node_modules/@sentry/react/build/esm/isSyntheticEvent.js

function isSyntheticEvent(wat) {
  return (0,is/* isPlainObject */.Qd)(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}


;// ./node_modules/@sentry/react/build/esm/sdk.js




function init(options) {
  const opts = {
    ...options
  };
  (0,sdkMetadata/* applySdkMetadata */.K)(opts, "react");
  (0,esm_exports/* setContext */.o)("react", { version: index_js_eager_.version });
  const client = (0,sdk/* init */.Ts)(opts);
  (0,normalize/* setNormalizeStringifier */.Ip)(sdk_normalizeStringifyValue);
  return client;
}
function sdk_normalizeStringifyValue(value) {
  if (isSyntheticEvent(value)) {
    return "[SyntheticEvent]";
  }
  return (0,normalizeStringifyValue/* normalizeStringifyValue */.U)(value);
}



/***/ }),

/***/ 58779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  M: function() { return /* binding */ getReplay; },
  w: function() { return /* binding */ replayIntegration; }
});

// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/worldwide.js
var worldwide = __webpack_require__(70774);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/normalize.js
var normalize = __webpack_require__(51830);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/object.js
var object = __webpack_require__(50742);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/time.js
var utils_time = __webpack_require__(39612);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/breadcrumbs.js
var breadcrumbs = __webpack_require__(55121);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/debug-logger.js
var debug_logger = __webpack_require__(62183);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/severity.js
var severity = __webpack_require__(1682);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/exports.js
var esm_exports = __webpack_require__(60068);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/misc.js
var misc = __webpack_require__(16513);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/currentScopes.js
var currentScopes = __webpack_require__(79255);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(42896);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/browser.js
var browser = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/dynamicSamplingContext.js
var dynamicSamplingContext = __webpack_require__(49271);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/isSentryRequestUrl.js
var isSentryRequestUrl = __webpack_require__(55344);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/string.js
var string = __webpack_require__(26228);
;// ./node_modules/@sentry/core/build/esm/utils/debounce.js
function debounce(func, wait, options) {
  let callbackReturnValue;
  let timerId;
  let maxTimerId;
  const maxWait = options?.maxWait ? Math.max(options.maxWait, wait) : 0;
  const setTimeoutImpl = options?.setTimeoutImpl || setTimeout;
  function invokeFunc() {
    cancelTimers();
    callbackReturnValue = func();
    return callbackReturnValue;
  }
  function cancelTimers() {
    timerId !== void 0 && clearTimeout(timerId);
    maxTimerId !== void 0 && clearTimeout(maxTimerId);
    timerId = maxTimerId = void 0;
  }
  function flush() {
    if (timerId !== void 0 || maxTimerId !== void 0) {
      return invokeFunc();
    }
    return callbackReturnValue;
  }
  function debounced() {
    if (timerId) {
      clearTimeout(timerId);
    }
    timerId = setTimeoutImpl(invokeFunc, wait);
    if (maxWait && maxTimerId === void 0) {
      maxTimerId = setTimeoutImpl(invokeFunc, maxWait);
    }
    return callbackReturnValue;
  }
  debounced.cancel = cancelTimers;
  debounced.flush = flush;
  return debounced;
}


// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/envelope.js
var envelope = __webpack_require__(22265);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/prepareEvent.js + 1 modules
var prepareEvent = __webpack_require__(8665);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/ratelimit.js
var ratelimit = __webpack_require__(40156);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91302);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/isBrowser.js
var isBrowser = __webpack_require__(82257);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/tracing/spans/captureSpan.js + 1 modules
var captureSpan = __webpack_require__(18912);
// EXTERNAL MODULE: ./node_modules/@sentry/core/build/esm/utils/parseSampleRate.js
var parseSampleRate = __webpack_require__(91554);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/getNativeImplementation.js
var getNativeImplementation = __webpack_require__(16487);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/htmlTreeAsString.js
var htmlTreeAsString = __webpack_require__(89972);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/metrics/instrument.js + 15 modules
var instrument = __webpack_require__(33731);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/networkUtils.js
var networkUtils = __webpack_require__(99323);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/instrument/xhr.js
var instrument_xhr = __webpack_require__(7440);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/instrument/dom.js
var dom = __webpack_require__(8634);
// EXTERNAL MODULE: ./node_modules/@sentry/browser-utils/build/esm/instrument/history.js
var instrument_history = __webpack_require__(19150);
;// ./node_modules/@sentry/replay/build/npm/esm/index.js


const WINDOW = worldwide/* GLOBAL_OBJ */.O;
const REPLAY_SESSION_KEY = "sentryReplaySession";
const REPLAY_EVENT_NAME = "replay_event";
const UNABLE_TO_SEND_REPLAY = "Unable to send Replay";
const SESSION_IDLE_PAUSE_DURATION = 3e5;
const SESSION_IDLE_EXPIRE_DURATION = 9e5;
const DEFAULT_FLUSH_MIN_DELAY = 5e3;
const DEFAULT_FLUSH_MAX_DELAY = 5500;
const BUFFER_CHECKOUT_TIME = 6e4;
const RETRY_BASE_INTERVAL = 5e3;
const RETRY_MAX_COUNT = 3;
const NETWORK_BODY_MAX_SIZE = 15e4;
const CONSOLE_ARG_MAX_SIZE = 5e3;
const SLOW_CLICK_THRESHOLD = 3e3;
const SLOW_CLICK_SCROLL_TIMEOUT = 300;
const REPLAY_MAX_EVENT_BUFFER_SIZE = 2e7;
const MIN_REPLAY_DURATION = 4999;
const MIN_REPLAY_DURATION_LIMIT = 5e4;
const MAX_REPLAY_DURATION = 36e5;
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var NodeType$1 = /* @__PURE__ */ ((NodeType2) => {
  NodeType2[NodeType2["Document"] = 0] = "Document";
  NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
  NodeType2[NodeType2["Element"] = 2] = "Element";
  NodeType2[NodeType2["Text"] = 3] = "Text";
  NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
  NodeType2[NodeType2["Comment"] = 5] = "Comment";
  return NodeType2;
})(NodeType$1 || {});
function isElement$1(n2) {
  return n2.nodeType === n2.ELEMENT_NODE;
}
function isShadowRoot(n2) {
  const host = n2?.host;
  return Boolean(host?.shadowRoot === n2);
}
function isNativeShadowDom(shadowRoot) {
  return Object.prototype.toString.call(shadowRoot) === "[object ShadowRoot]";
}
function fixBrowserCompatibilityIssuesInCSS(cssText) {
  if (cssText.includes(" background-clip: text;") && !cssText.includes(" -webkit-background-clip: text;")) {
    cssText = cssText.replace(
      /\sbackground-clip:\s*text;/g,
      " -webkit-background-clip: text; background-clip: text;"
    );
  }
  return cssText;
}
function escapeImportStatement(rule) {
  const { cssText } = rule;
  if (cssText.split('"').length < 3) return cssText;
  const statement = ["@import", `url(${JSON.stringify(rule.href)})`];
  if (rule.layerName === "") {
    statement.push(`layer`);
  } else if (rule.layerName) {
    statement.push(`layer(${rule.layerName})`);
  }
  if (rule.supportsText) {
    statement.push(`supports(${rule.supportsText})`);
  }
  if (rule.media.length) {
    statement.push(rule.media.mediaText);
  }
  return statement.join(" ") + ";";
}
function stringifyStylesheet(s) {
  try {
    const rules = s.rules || s.cssRules;
    return rules ? fixBrowserCompatibilityIssuesInCSS(
      Array.from(rules, stringifyRule).join("")
    ) : null;
  } catch (error) {
    return null;
  }
}
function fixAllCssProperty(rule) {
  let styles = "";
  for (let i2 = 0; i2 < rule.style.length; i2++) {
    const styleDeclaration = rule.style;
    const attribute = styleDeclaration[i2];
    const isImportant = styleDeclaration.getPropertyPriority(attribute);
    styles += `${attribute}:${styleDeclaration.getPropertyValue(attribute)}${isImportant ? ` !important` : ""};`;
  }
  return `${rule.selectorText} { ${styles} }`;
}
function stringifyRule(rule) {
  let importStringified;
  if (isCSSImportRule(rule)) {
    try {
      importStringified = // for same-origin stylesheets,
      // we can access the imported stylesheet rules directly
      stringifyStylesheet(rule.styleSheet) || // work around browser issues with the raw string `@import url(...)` statement
      escapeImportStatement(rule);
    } catch (error) {
    }
  } else if (isCSSStyleRule(rule)) {
    let cssText = rule.cssText;
    const needsSafariColonFix = rule.selectorText.includes(":");
    const needsAllFix = typeof rule.style["all"] === "string" && rule.style["all"];
    if (needsAllFix) {
      cssText = fixAllCssProperty(rule);
    }
    if (needsSafariColonFix) {
      cssText = fixSafariColons(cssText);
    }
    if (needsSafariColonFix || needsAllFix) {
      return cssText;
    }
  }
  return importStringified || rule.cssText;
}
function fixSafariColons(cssStringified) {
  const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
  return cssStringified.replace(regex, "$1\\$2");
}
function isCSSImportRule(rule) {
  return "styleSheet" in rule;
}
function isCSSStyleRule(rule) {
  return "selectorText" in rule;
}
class Mirror {
  constructor() {
    __publicField(this, "idNodeMap", /* @__PURE__ */ new Map());
    __publicField(this, "nodeMetaMap", /* @__PURE__ */ new WeakMap());
  }
  getId(n2) {
    if (!n2) return -1;
    const id = this.getMeta(n2)?.id;
    return id ?? -1;
  }
  getNode(id) {
    return this.idNodeMap.get(id) || null;
  }
  getIds() {
    return Array.from(this.idNodeMap.keys());
  }
  getMeta(n2) {
    return this.nodeMetaMap.get(n2) || null;
  }
  // removes the node from idNodeMap
  // doesn't remove the node from nodeMetaMap
  removeNodeFromMap(n2) {
    const id = this.getId(n2);
    this.idNodeMap.delete(id);
    if (n2.childNodes) {
      n2.childNodes.forEach(
        (childNode) => this.removeNodeFromMap(childNode)
      );
    }
  }
  has(id) {
    return this.idNodeMap.has(id);
  }
  hasNode(node) {
    return this.nodeMetaMap.has(node);
  }
  add(n2, meta) {
    const id = meta.id;
    this.idNodeMap.set(id, n2);
    this.nodeMetaMap.set(n2, meta);
  }
  replace(id, n2) {
    const oldNode = this.getNode(id);
    if (oldNode) {
      const meta = this.nodeMetaMap.get(oldNode);
      if (meta) this.nodeMetaMap.set(n2, meta);
    }
    this.idNodeMap.set(id, n2);
  }
  reset() {
    this.idNodeMap = /* @__PURE__ */ new Map();
    this.nodeMetaMap = /* @__PURE__ */ new WeakMap();
  }
}
function createMirror() {
  return new Mirror();
}
function shouldMaskInput({
  maskInputOptions,
  tagName,
  type
}) {
  if (tagName === "OPTION") {
    tagName = "SELECT";
  }
  return Boolean(
    maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === "password" || // Default to "text" option for inputs without a "type" attribute defined
    tagName === "INPUT" && !type && maskInputOptions["text"]
  );
}
function maskInputValue({
  isMasked,
  element,
  value,
  maskInputFn
}) {
  let text = value || "";
  if (!isMasked) {
    return text;
  }
  if (maskInputFn) {
    text = maskInputFn(text, element);
  }
  return "*".repeat(text.length);
}
function toLowerCase(str) {
  return str.toLowerCase();
}
function toUpperCase(str) {
  return str.toUpperCase();
}
const ORIGINAL_ATTRIBUTE_NAME = "__rrweb_original__";
function is2DCanvasBlank(canvas) {
  const ctx = canvas.getContext("2d");
  if (!ctx) return true;
  const chunkSize = 50;
  for (let x = 0; x < canvas.width; x += chunkSize) {
    for (let y = 0; y < canvas.height; y += chunkSize) {
      const getImageData = ctx.getImageData;
      const originalGetImageData = ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[ORIGINAL_ATTRIBUTE_NAME] : getImageData;
      const pixelBuffer = new Uint32Array(
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-unsafe-member-access
        originalGetImageData.call(
          ctx,
          x,
          y,
          Math.min(chunkSize, canvas.width - x),
          Math.min(chunkSize, canvas.height - y)
        ).data.buffer
      );
      if (pixelBuffer.some((pixel) => pixel !== 0)) return false;
    }
  }
  return true;
}
function getInputType(element) {
  const type = element.type;
  return element.hasAttribute("data-rr-is-password") ? "password" : type ? (
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
    toLowerCase(type)
  ) : null;
}
function getInputValue(el, tagName, type) {
  if (tagName === "INPUT" && (type === "radio" || type === "checkbox")) {
    return el.getAttribute("value") || "";
  }
  return el.value;
}
function extractFileExtension(path, baseURL) {
  let url;
  try {
    url = new URL(path, baseURL ?? window.location.href);
  } catch (err) {
    return null;
  }
  const regex = /\.([0-9a-z]+)(?:$)/i;
  const match = url.pathname.match(regex);
  return match?.[1] ?? null;
}
const cachedImplementations$1 = {};
function getImplementation$1(name) {
  const cached = cachedImplementations$1[name];
  if (cached) {
    return cached;
  }
  const document2 = window.document;
  let impl = window[name];
  if (document2 && typeof document2.createElement === "function") {
    try {
      const sandbox = document2.createElement("iframe");
      sandbox.hidden = true;
      document2.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow[name]) {
        impl = // eslint-disable-next-line @typescript-eslint/unbound-method
        contentWindow[name];
      }
      document2.head.removeChild(sandbox);
    } catch (e2) {
    }
  }
  return cachedImplementations$1[name] = impl.bind(
    window
  );
}
function setTimeout$1(...rest) {
  return getImplementation$1("setTimeout")(...rest);
}
function clearTimeout$1(...rest) {
  return getImplementation$1("clearTimeout")(...rest);
}
function getIFrameContentDocument$1(iframe) {
  try {
    return iframe.contentDocument;
  } catch {
  }
}
function getIFrameContentWindow$1(iframe) {
  try {
    return iframe.contentWindow;
  } catch {
  }
}
let _id = 1;
const tagNameRegex = new RegExp("[^a-z0-9-_:]");
const IGNORED_NODE = -2;
function genId() {
  return _id++;
}
function getValidTagName(element) {
  if (element instanceof HTMLFormElement) {
    return "form";
  }
  const processedTagName = toLowerCase(element.tagName);
  if (tagNameRegex.test(processedTagName)) {
    return "div";
  }
  return processedTagName;
}
function extractOrigin(url) {
  let origin = "";
  if (url.indexOf("//") > -1) {
    origin = url.split("/").slice(0, 3).join("/");
  } else {
    origin = url.split("/")[0];
  }
  origin = origin.split("?")[0];
  return origin;
}
let canvasService;
let canvasCtx;
const URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const URL_WWW_MATCH = /^www\..*/i;
const DATA_URI = /^(data:)([^,]*),(.*)/i;
function filterCSSPropertiesFromInlineStyle(cssText, ignoredProperties) {
  if (!cssText || ignoredProperties.size === 0) {
    return cssText;
  }
  try {
    const properties = cssText.split(";");
    const filteredProperties = [];
    for (let property of properties) {
      property = property.trim();
      if (!property) continue;
      const colonIndex = property.indexOf(":");
      if (colonIndex === -1) {
        filteredProperties.push(property);
        continue;
      }
      const propertyName = property.slice(0, colonIndex).trim();
      if (!ignoredProperties.has(propertyName)) {
        filteredProperties.push(property);
      }
    }
    return filteredProperties.join("; ") + (filteredProperties.length > 0 && cssText.endsWith(";") ? ";" : "");
  } catch (error) {
    console.warn("Error filtering CSS properties:", error);
    return cssText;
  }
}
function absoluteToStylesheet(cssText, href) {
  return (cssText || "").replace(
    URL_IN_CSS_REF,
    (origin, quote1, path1, quote2, path2, path3) => {
      const filePath = path1 || path2 || path3;
      const maybeQuote = quote1 || quote2 || "";
      if (!filePath) {
        return origin;
      }
      if (URL_PROTOCOL_MATCH.test(filePath) || URL_WWW_MATCH.test(filePath)) {
        return `url(${maybeQuote}${filePath}${maybeQuote})`;
      }
      if (DATA_URI.test(filePath)) {
        return `url(${maybeQuote}${filePath}${maybeQuote})`;
      }
      if (filePath[0] === "/") {
        return `url(${maybeQuote}${extractOrigin(href) + filePath}${maybeQuote})`;
      }
      const stack = href.split("/");
      const parts = filePath.split("/");
      stack.pop();
      for (const part of parts) {
        if (part === ".") {
          continue;
        } else if (part === "..") {
          stack.pop();
        } else {
          stack.push(part);
        }
      }
      return `url(${maybeQuote}${stack.join("/")}${maybeQuote})`;
    }
  );
}
const SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function getAbsoluteSrcsetString(doc, attributeValue) {
  if (attributeValue.trim() === "") {
    return attributeValue;
  }
  let pos = 0;
  function collectCharacters(regEx) {
    let chars2;
    const match = regEx.exec(attributeValue.substring(pos));
    if (match) {
      chars2 = match[0];
      pos += chars2.length;
      return chars2;
    }
    return "";
  }
  const output = [];
  while (true) {
    collectCharacters(SRCSET_COMMAS_OR_SPACES);
    if (pos >= attributeValue.length) {
      break;
    }
    let url = collectCharacters(SRCSET_NOT_SPACES);
    if (url.slice(-1) === ",") {
      url = absoluteToDoc(doc, url.substring(0, url.length - 1));
      output.push(url);
    } else {
      let descriptorsStr = "";
      url = absoluteToDoc(doc, url);
      let inParens = false;
      while (true) {
        const c = attributeValue.charAt(pos);
        if (c === "") {
          output.push((url + descriptorsStr).trim());
          break;
        } else if (!inParens) {
          if (c === ",") {
            pos += 1;
            output.push((url + descriptorsStr).trim());
            break;
          } else if (c === "(") {
            inParens = true;
          }
        } else {
          if (c === ")") {
            inParens = false;
          }
        }
        descriptorsStr += c;
        pos += 1;
      }
    }
  }
  return output.join(", ");
}
const cachedDocument = /* @__PURE__ */ new WeakMap();
function absoluteToDoc(doc, attributeValue) {
  if (!attributeValue || attributeValue.trim() === "") {
    return attributeValue;
  }
  return getHref(doc, attributeValue);
}
function isSVGElement(el) {
  return Boolean(el.tagName === "svg" || el.ownerSVGElement);
}
function getHref(doc, customHref) {
  let a = cachedDocument.get(doc);
  if (!a) {
    a = doc.createElement("a");
    cachedDocument.set(doc, a);
  }
  if (!customHref) {
    customHref = "";
  } else if (customHref.startsWith("blob:") || customHref.startsWith("data:")) {
    return customHref;
  }
  a.setAttribute("href", customHref);
  return a.href;
}
function transformAttribute(doc, tagName, name, value, element, maskAttributeFn, ignoreCSSAttributes) {
  if (!value) {
    return value;
  }
  if (name === "src" || name === "href" && !(tagName === "use" && value[0] === "#")) {
    return absoluteToDoc(doc, value);
  } else if (name === "xlink:href" && value[0] !== "#") {
    return absoluteToDoc(doc, value);
  } else if (name === "background" && (tagName === "table" || tagName === "td" || tagName === "th")) {
    return absoluteToDoc(doc, value);
  } else if (name === "srcset") {
    return getAbsoluteSrcsetString(doc, value);
  } else if (name === "style") {
    let processedStyle = absoluteToStylesheet(value, getHref(doc));
    if (ignoreCSSAttributes && ignoreCSSAttributes.size > 0) {
      processedStyle = filterCSSPropertiesFromInlineStyle(
        processedStyle,
        ignoreCSSAttributes
      );
    }
    return processedStyle;
  } else if (tagName === "object" && name === "data") {
    return absoluteToDoc(doc, value);
  }
  if (typeof maskAttributeFn === "function") {
    return maskAttributeFn(name, value, element);
  }
  return value;
}
function ignoreAttribute(tagName, name, _value) {
  return (tagName === "video" || tagName === "audio") && name === "autoplay";
}
function _isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
  try {
    if (unblockSelector && element.matches(unblockSelector)) {
      return false;
    }
    if (typeof blockClass === "string") {
      if (element.classList.contains(blockClass)) {
        return true;
      }
    } else {
      for (let eIndex = element.classList.length; eIndex--; ) {
        const className = element.classList[eIndex];
        if (blockClass.test(className)) {
          return true;
        }
      }
    }
    if (blockSelector) {
      return element.matches(blockSelector);
    }
  } catch (e2) {
  }
  return false;
}
function elementClassMatchesRegex(el, regex) {
  for (let eIndex = el.classList.length; eIndex--; ) {
    const className = el.classList[eIndex];
    if (regex.test(className)) {
      return true;
    }
  }
  return false;
}
function distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
  if (!node) return -1;
  if (node.nodeType !== node.ELEMENT_NODE) return -1;
  if (distance > limit) return -1;
  if (matchPredicate(node)) return distance;
  return distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function createMatchPredicate(className, selector) {
  return (node) => {
    const el = node;
    if (el === null) return false;
    try {
      if (className) {
        if (typeof className === "string") {
          if (el.matches(`.${className}`)) return true;
        } else if (elementClassMatchesRegex(el, className)) {
          return true;
        }
      }
      if (selector && el.matches(selector)) return true;
      return false;
    } catch {
      return false;
    }
  };
}
function needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
  try {
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    if (el === null) return false;
    if (el.tagName === "INPUT") {
      const autocomplete = el.getAttribute("autocomplete");
      const disallowedAutocompleteValues = [
        "current-password",
        "new-password",
        "cc-number",
        "cc-exp",
        "cc-exp-month",
        "cc-exp-year",
        "cc-csc"
      ];
      if (disallowedAutocompleteValues.includes(autocomplete)) {
        return true;
      }
    }
    let maskDistance = -1;
    let unmaskDistance = -1;
    if (maskAllText) {
      unmaskDistance = distanceToMatch(
        el,
        createMatchPredicate(unmaskTextClass, unmaskTextSelector)
      );
      if (unmaskDistance < 0) {
        return true;
      }
      maskDistance = distanceToMatch(
        el,
        createMatchPredicate(maskTextClass, maskTextSelector),
        unmaskDistance >= 0 ? unmaskDistance : Infinity
      );
    } else {
      maskDistance = distanceToMatch(
        el,
        createMatchPredicate(maskTextClass, maskTextSelector)
      );
      if (maskDistance < 0) {
        return false;
      }
      unmaskDistance = distanceToMatch(
        el,
        createMatchPredicate(unmaskTextClass, unmaskTextSelector),
        maskDistance >= 0 ? maskDistance : Infinity
      );
    }
    return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
  } catch (e2) {
  }
  return !!maskAllText;
}
function onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
  const win = getIFrameContentWindow$1(iframeEl);
  if (!win) {
    return;
  }
  let fired = false;
  let readyState;
  try {
    readyState = win.document.readyState;
  } catch (error) {
    return;
  }
  if (readyState !== "complete") {
    const timer = setTimeout$1(() => {
      if (!fired) {
        listener();
        fired = true;
      }
    }, iframeLoadTimeout);
    iframeEl.addEventListener("load", () => {
      clearTimeout$1(timer);
      fired = true;
      listener();
    });
    return;
  }
  const blankUrl = "about:blank";
  if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === "") {
    setTimeout$1(listener, 0);
    return iframeEl.addEventListener("load", listener);
  }
  iframeEl.addEventListener("load", listener);
}
function onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
  let fired = false;
  let styleSheetLoaded;
  try {
    styleSheetLoaded = link.sheet;
  } catch (error) {
    styleSheetLoaded = null;
  }
  if (styleSheetLoaded) return;
  const timer = setTimeout$1(() => {
    if (!fired) {
      listener();
      fired = true;
    }
  }, styleSheetLoadTimeout);
  link.addEventListener("load", () => {
    clearTimeout$1(timer);
    fired = true;
    listener();
  });
}
function serializeNode(n2, options) {
  const {
    doc,
    mirror: mirror2,
    blockClass,
    blockSelector,
    unblockSelector,
    maskAllText,
    maskAttributeFn,
    maskTextClass,
    unmaskTextClass,
    maskTextSelector,
    unmaskTextSelector,
    inlineStylesheet,
    maskInputOptions = {},
    maskTextFn,
    maskInputFn,
    dataURLOptions = {},
    inlineImages,
    recordCanvas,
    keepIframeSrcFn,
    newlyAddedElement = false,
    ignoreCSSAttributes
  } = options;
  const rootId = getRootId(doc, mirror2);
  switch (n2.nodeType) {
    case n2.DOCUMENT_NODE:
      if (n2.compatMode !== "CSS1Compat") {
        return {
          type: NodeType$1.Document,
          childNodes: [],
          compatMode: n2.compatMode
          // probably "BackCompat"
        };
      } else {
        return {
          type: NodeType$1.Document,
          childNodes: []
        };
      }
    case n2.DOCUMENT_TYPE_NODE:
      return {
        type: NodeType$1.DocumentType,
        name: n2.name,
        publicId: n2.publicId,
        systemId: n2.systemId,
        rootId
      };
    case n2.ELEMENT_NODE:
      return serializeElementNode(n2, {
        doc,
        blockClass,
        blockSelector,
        unblockSelector,
        inlineStylesheet,
        maskAttributeFn,
        maskInputOptions,
        maskInputFn,
        dataURLOptions,
        inlineImages,
        recordCanvas,
        keepIframeSrcFn,
        newlyAddedElement,
        rootId,
        maskTextClass,
        unmaskTextClass,
        maskTextSelector,
        unmaskTextSelector,
        ignoreCSSAttributes
      });
    case n2.TEXT_NODE:
      return serializeTextNode(n2, {
        doc,
        maskAllText,
        maskTextClass,
        unmaskTextClass,
        maskTextSelector,
        unmaskTextSelector,
        maskTextFn,
        maskInputOptions,
        maskInputFn,
        rootId
      });
    case n2.CDATA_SECTION_NODE:
      return {
        type: NodeType$1.CDATA,
        textContent: "",
        rootId
      };
    case n2.COMMENT_NODE:
      return {
        type: NodeType$1.Comment,
        textContent: n2.textContent || "",
        rootId
      };
    default:
      return false;
  }
}
function getRootId(doc, mirror2) {
  if (!mirror2.hasNode(doc)) return void 0;
  const docId = mirror2.getId(doc);
  return docId === 1 ? void 0 : docId;
}
function serializeTextNode(n2, options) {
  const {
    maskAllText,
    maskTextClass,
    unmaskTextClass,
    maskTextSelector,
    unmaskTextSelector,
    maskTextFn,
    maskInputOptions,
    maskInputFn,
    rootId
  } = options;
  const parentTagName = n2.parentNode && n2.parentNode.tagName;
  let textContent = n2.textContent;
  const isStyle = parentTagName === "STYLE" ? true : void 0;
  const isScript = parentTagName === "SCRIPT" ? true : void 0;
  const isTextarea = parentTagName === "TEXTAREA" ? true : void 0;
  if (isStyle && textContent) {
    try {
      if (n2.nextSibling || n2.previousSibling) {
      } else if (n2.parentNode.sheet?.cssRules) {
        textContent = stringifyStylesheet(
          n2.parentNode.sheet
        );
      }
    } catch (err) {
      console.warn(
        `Cannot get CSS styles from text's parentNode. Error: ${err}`,
        n2
      );
    }
    textContent = absoluteToStylesheet(textContent, getHref(options.doc));
  }
  if (isScript) {
    textContent = "SCRIPT_PLACEHOLDER";
  }
  const forceMask = needMaskingText(
    n2,
    maskTextClass,
    maskTextSelector,
    unmaskTextClass,
    unmaskTextSelector,
    maskAllText
  );
  if (!isStyle && !isScript && !isTextarea && textContent && forceMask) {
    textContent = maskTextFn ? maskTextFn(textContent, n2.parentElement) : textContent.replace(/[\S]/g, "*");
  }
  if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) {
    textContent = maskInputFn ? maskInputFn(textContent, n2.parentNode) : textContent.replace(/[\S]/g, "*");
  }
  if (parentTagName === "OPTION" && textContent) {
    const isInputMasked = shouldMaskInput({
      type: null,
      tagName: parentTagName,
      maskInputOptions
    });
    textContent = maskInputValue({
      isMasked: needMaskingText(
        n2,
        maskTextClass,
        maskTextSelector,
        unmaskTextClass,
        unmaskTextSelector,
        isInputMasked
      ),
      element: n2,
      value: textContent,
      maskInputFn
    });
  }
  return {
    type: NodeType$1.Text,
    textContent: textContent || "",
    isStyle,
    rootId
  };
}
function serializeElementNode(n2, options) {
  const {
    doc,
    blockClass,
    blockSelector,
    unblockSelector,
    inlineStylesheet,
    maskInputOptions = {},
    maskAttributeFn,
    maskInputFn,
    dataURLOptions = {},
    inlineImages,
    recordCanvas,
    keepIframeSrcFn,
    newlyAddedElement = false,
    rootId,
    maskTextClass,
    unmaskTextClass,
    maskTextSelector,
    unmaskTextSelector,
    ignoreCSSAttributes
  } = options;
  const needBlock = _isBlockedElement(
    n2,
    blockClass,
    blockSelector,
    unblockSelector
  );
  const tagName = getValidTagName(n2);
  let attributes2 = {};
  const len = n2.attributes.length;
  for (let i2 = 0; i2 < len; i2++) {
    const attr = n2.attributes[i2];
    if (attr.name && !ignoreAttribute(tagName, attr.name, attr.value)) {
      attributes2[attr.name] = transformAttribute(
        doc,
        tagName,
        toLowerCase(attr.name),
        attr.value,
        n2,
        maskAttributeFn,
        ignoreCSSAttributes
      );
    }
  }
  if (tagName === "link" && inlineStylesheet) {
    const stylesheet = Array.from(doc.styleSheets).find((s) => {
      return s.href === n2.href;
    });
    let cssText = null;
    if (stylesheet) {
      cssText = stringifyStylesheet(stylesheet);
    }
    if (cssText) {
      attributes2.rel = null;
      attributes2.href = null;
      attributes2.crossorigin = null;
      attributes2._cssText = absoluteToStylesheet(cssText, stylesheet.href);
    }
  }
  if (tagName === "style" && n2.sheet && // TODO: Currently we only try to get dynamic stylesheet when it is an empty style element
  !(n2.innerText || n2.textContent || "").trim().length) {
    const cssText = stringifyStylesheet(
      n2.sheet
    );
    if (cssText) {
      attributes2._cssText = absoluteToStylesheet(cssText, getHref(doc));
    }
  }
  if (tagName === "input" || tagName === "textarea" || tagName === "select" || tagName === "option") {
    const el = n2;
    const type = getInputType(el);
    const value = getInputValue(el, toUpperCase(tagName), type);
    const checked = el.checked;
    if (type !== "submit" && type !== "button" && value) {
      const forceMask = needMaskingText(
        el,
        maskTextClass,
        maskTextSelector,
        unmaskTextClass,
        unmaskTextSelector,
        shouldMaskInput({
          type,
          tagName: toUpperCase(tagName),
          maskInputOptions
        })
      );
      attributes2.value = maskInputValue({
        isMasked: forceMask,
        element: el,
        value,
        maskInputFn
      });
    }
    if (checked) {
      attributes2.checked = checked;
    }
  }
  if (tagName === "option") {
    if (n2.selected && !maskInputOptions["select"]) {
      attributes2.selected = true;
    } else {
      delete attributes2.selected;
    }
  }
  if (tagName === "canvas" && recordCanvas) {
    if (n2.__context === "2d") {
      if (!is2DCanvasBlank(n2)) {
        attributes2.rr_dataURL = n2.toDataURL(
          dataURLOptions.type,
          dataURLOptions.quality
        );
      }
    } else if (!("__context" in n2)) {
      const canvasDataURL = n2.toDataURL(
        dataURLOptions.type,
        dataURLOptions.quality
      );
      const blankCanvas = doc.createElement("canvas");
      blankCanvas.width = n2.width;
      blankCanvas.height = n2.height;
      const blankCanvasDataURL = blankCanvas.toDataURL(
        dataURLOptions.type,
        dataURLOptions.quality
      );
      if (canvasDataURL !== blankCanvasDataURL) {
        attributes2.rr_dataURL = canvasDataURL;
      }
    }
  }
  if (tagName === "img" && inlineImages) {
    if (!canvasService) {
      canvasService = doc.createElement("canvas");
      canvasCtx = canvasService.getContext("2d");
    }
    const image = n2;
    const imageSrc = image.currentSrc || image.getAttribute("src") || "<unknown-src>";
    const priorCrossOrigin = image.crossOrigin;
    const recordInlineImage = () => {
      image.removeEventListener("load", recordInlineImage);
      try {
        canvasService.width = image.naturalWidth;
        canvasService.height = image.naturalHeight;
        canvasCtx.drawImage(image, 0, 0);
        attributes2.rr_dataURL = canvasService.toDataURL(
          dataURLOptions.type,
          dataURLOptions.quality
        );
      } catch (err) {
        if (image.crossOrigin !== "anonymous") {
          image.crossOrigin = "anonymous";
          if (image.complete && image.naturalWidth !== 0)
            recordInlineImage();
          else image.addEventListener("load", recordInlineImage);
          return;
        } else {
          console.warn(
            `Cannot inline img src=${imageSrc}! Error: ${err}`
          );
        }
      }
      if (image.crossOrigin === "anonymous") {
        priorCrossOrigin ? attributes2.crossOrigin = priorCrossOrigin : image.removeAttribute("crossorigin");
      }
    };
    if (image.complete && image.naturalWidth !== 0) recordInlineImage();
    else image.addEventListener("load", recordInlineImage);
  }
  if (tagName === "audio" || tagName === "video") {
    attributes2.rr_mediaState = n2.paused ? "paused" : "played";
    attributes2.rr_mediaCurrentTime = n2.currentTime;
  }
  if (!newlyAddedElement) {
    if (n2.scrollLeft) {
      attributes2.rr_scrollLeft = n2.scrollLeft;
    }
    if (n2.scrollTop) {
      attributes2.rr_scrollTop = n2.scrollTop;
    }
  }
  if (needBlock) {
    const { width, height } = n2.getBoundingClientRect();
    attributes2 = {
      class: attributes2.class,
      rr_width: `${width}px`,
      rr_height: `${height}px`
    };
  }
  if (tagName === "iframe" && !keepIframeSrcFn(attributes2.src)) {
    if (!needBlock && !getIFrameContentDocument$1(n2)) {
      attributes2.rr_src = attributes2.src;
    }
    delete attributes2.src;
  }
  let isCustomElement;
  try {
    if (customElements.get(tagName)) isCustomElement = true;
  } catch (e2) {
  }
  return {
    type: NodeType$1.Element,
    tagName,
    attributes: attributes2,
    childNodes: [],
    isSVG: isSVGElement(n2) || void 0,
    needBlock,
    rootId,
    isCustom: isCustomElement
  };
}
function lowerIfExists(maybeAttr) {
  if (maybeAttr === void 0 || maybeAttr === null) {
    return "";
  } else {
    return maybeAttr.toLowerCase();
  }
}
function slimDOMExcluded(sn, slimDOMOptions) {
  if (slimDOMOptions.comment && sn.type === NodeType$1.Comment) {
    return true;
  } else if (sn.type === NodeType$1.Element) {
    if (slimDOMOptions.script && // script tag
    (sn.tagName === "script" || // (module)preload link
    sn.tagName === "link" && (sn.attributes.rel === "preload" || sn.attributes.rel === "modulepreload") || // prefetch link
    sn.tagName === "link" && sn.attributes.rel === "prefetch" && typeof sn.attributes.href === "string" && extractFileExtension(sn.attributes.href) === "js")) {
      return true;
    } else if (slimDOMOptions.headFavicon && (sn.tagName === "link" && sn.attributes.rel === "shortcut icon" || sn.tagName === "meta" && (lowerIfExists(sn.attributes.name).match(
      /^msapplication-tile(image|color)$/
    ) || lowerIfExists(sn.attributes.name) === "application-name" || lowerIfExists(sn.attributes.rel) === "icon" || lowerIfExists(sn.attributes.rel) === "apple-touch-icon" || lowerIfExists(sn.attributes.rel) === "shortcut icon"))) {
      return true;
    } else if (sn.tagName === "meta") {
      if (slimDOMOptions.headMetaDescKeywords && lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) {
        return true;
      } else if (slimDOMOptions.headMetaSocial && (lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || // og = opengraph (facebook)
      lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || lowerIfExists(sn.attributes.name) === "pinterest")) {
        return true;
      } else if (slimDOMOptions.headMetaRobots && (lowerIfExists(sn.attributes.name) === "robots" || lowerIfExists(sn.attributes.name) === "googlebot" || lowerIfExists(sn.attributes.name) === "bingbot")) {
        return true;
      } else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes["http-equiv"] !== void 0) {
        return true;
      } else if (slimDOMOptions.headMetaAuthorship && (lowerIfExists(sn.attributes.name) === "author" || lowerIfExists(sn.attributes.name) === "generator" || lowerIfExists(sn.attributes.name) === "framework" || lowerIfExists(sn.attributes.name) === "publisher" || lowerIfExists(sn.attributes.name) === "progid" || lowerIfExists(sn.attributes.property).match(/^article:/) || lowerIfExists(sn.attributes.property).match(/^product:/))) {
        return true;
      } else if (slimDOMOptions.headMetaVerification && (lowerIfExists(sn.attributes.name) === "google-site-verification" || lowerIfExists(sn.attributes.name) === "yandex-verification" || lowerIfExists(sn.attributes.name) === "csrf-token" || lowerIfExists(sn.attributes.name) === "p:domain_verify" || lowerIfExists(sn.attributes.name) === "verify-v1" || lowerIfExists(sn.attributes.name) === "verification" || lowerIfExists(sn.attributes.name) === "shopify-checkout-api-token")) {
        return true;
      }
    }
  }
  return false;
}
function serializeNodeWithId(n2, options) {
  const {
    doc,
    mirror: mirror2,
    blockClass,
    blockSelector,
    unblockSelector,
    maskAllText,
    maskTextClass,
    unmaskTextClass,
    maskTextSelector,
    unmaskTextSelector,
    skipChild = false,
    inlineStylesheet = true,
    maskInputOptions = {},
    maskAttributeFn,
    maskTextFn,
    maskInputFn,
    slimDOMOptions,
    dataURLOptions = {},
    inlineImages = false,
    recordCanvas = false,
    onSerialize,
    onIframeLoad,
    iframeLoadTimeout = 5e3,
    onBlockedImageLoad,
    onStylesheetLoad,
    stylesheetLoadTimeout = 5e3,
    keepIframeSrcFn = () => false,
    newlyAddedElement = false,
    ignoreCSSAttributes
  } = options;
  let { preserveWhiteSpace = true } = options;
  const _serializedNode = serializeNode(n2, {
    doc,
    mirror: mirror2,
    blockClass,
    blockSelector,
    maskAllText,
    unblockSelector,
    maskTextClass,
    unmaskTextClass,
    maskTextSelector,
    unmaskTextSelector,
    inlineStylesheet,
    maskInputOptions,
    maskAttributeFn,
    maskTextFn,
    maskInputFn,
    dataURLOptions,
    inlineImages,
    recordCanvas,
    keepIframeSrcFn,
    newlyAddedElement,
    ignoreCSSAttributes
  });
  if (!_serializedNode) {
    console.warn(n2, "not serialized");
    return null;
  }
  let id;
  if (mirror2.hasNode(n2)) {
    id = mirror2.getId(n2);
  } else if (slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.trim().length) {
    id = IGNORED_NODE;
  } else {
    id = genId();
  }
  const serializedNode2 = Object.assign(_serializedNode, { id });
  mirror2.add(n2, serializedNode2);
  if (id === IGNORED_NODE) {
    return null;
  }
  if (onSerialize) {
    onSerialize(n2);
  }
  let recordChild = !skipChild;
  if (serializedNode2.type === NodeType$1.Element) {
    recordChild = recordChild && !serializedNode2.needBlock;
    const shadowRoot = n2.shadowRoot;
    if (shadowRoot && isNativeShadowDom(shadowRoot))
      serializedNode2.isShadowHost = true;
  }
  if ((serializedNode2.type === NodeType$1.Document || serializedNode2.type === NodeType$1.Element) && recordChild) {
    if (slimDOMOptions.headWhitespace && serializedNode2.type === NodeType$1.Element && serializedNode2.tagName === "head") {
      preserveWhiteSpace = false;
    }
    const bypassOptions = {
      doc,
      mirror: mirror2,
      blockClass,
      blockSelector,
      maskAllText,
      unblockSelector,
      maskTextClass,
      unmaskTextClass,
      maskTextSelector,
      unmaskTextSelector,
      skipChild,
      inlineStylesheet,
      maskInputOptions,
      maskAttributeFn,
      maskTextFn,
      maskInputFn,
      slimDOMOptions,
      dataURLOptions,
      inlineImages,
      recordCanvas,
      preserveWhiteSpace,
      onSerialize,
      onIframeLoad,
      iframeLoadTimeout,
      onBlockedImageLoad,
      onStylesheetLoad,
      stylesheetLoadTimeout,
      keepIframeSrcFn,
      ignoreCSSAttributes
    };
    const childNodes = n2.childNodes ? Array.from(n2.childNodes) : [];
    for (const childN of childNodes) {
      const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
      if (serializedChildNode) {
        serializedNode2.childNodes.push(serializedChildNode);
      }
    }
    if (isElement$1(n2) && n2.shadowRoot) {
      for (const childN of Array.from(n2.shadowRoot.childNodes)) {
        const serializedChildNode = serializeNodeWithId(childN, bypassOptions);
        if (serializedChildNode) {
          isNativeShadowDom(n2.shadowRoot) && (serializedChildNode.isShadow = true);
          serializedNode2.childNodes.push(serializedChildNode);
        }
      }
    }
  }
  if (n2.parentNode && isShadowRoot(n2.parentNode) && isNativeShadowDom(n2.parentNode)) {
    serializedNode2.isShadow = true;
  }
  if (serializedNode2.type === NodeType$1.Element && serializedNode2.tagName === "iframe" && !serializedNode2.needBlock) {
    onceIframeLoaded(
      n2,
      () => {
        const iframeDoc = getIFrameContentDocument$1(n2);
        if (iframeDoc && onIframeLoad) {
          const serializedIframeNode = serializeNodeWithId(iframeDoc, {
            doc: iframeDoc,
            mirror: mirror2,
            blockClass,
            blockSelector,
            unblockSelector,
            maskAllText,
            maskTextClass,
            unmaskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            skipChild: false,
            inlineStylesheet,
            maskInputOptions,
            maskAttributeFn,
            maskTextFn,
            maskInputFn,
            slimDOMOptions,
            dataURLOptions,
            inlineImages,
            recordCanvas,
            preserveWhiteSpace,
            onSerialize,
            onIframeLoad,
            iframeLoadTimeout,
            onStylesheetLoad,
            stylesheetLoadTimeout,
            keepIframeSrcFn,
            ignoreCSSAttributes
          });
          if (serializedIframeNode) {
            onIframeLoad(
              n2,
              serializedIframeNode
            );
          }
        }
      },
      iframeLoadTimeout
    );
  }
  if (serializedNode2.type === NodeType$1.Element && serializedNode2.tagName === "img" && !n2.complete && serializedNode2.needBlock) {
    const image = n2;
    const updateImageDimensions = () => {
      if (image.isConnected && !image.complete && onBlockedImageLoad) {
        try {
          const rect = image.getBoundingClientRect();
          if (rect.width > 0 && rect.height > 0) {
            onBlockedImageLoad(image, serializedNode2, rect);
          }
        } catch (error) {
        }
      }
      image.removeEventListener("load", updateImageDimensions);
    };
    if (image.isConnected) {
      image.addEventListener("load", updateImageDimensions);
    }
  }
  if (serializedNode2.type === NodeType$1.Element && serializedNode2.tagName === "link" && typeof serializedNode2.attributes.rel === "string" && (serializedNode2.attributes.rel === "stylesheet" || serializedNode2.attributes.rel === "preload" && typeof serializedNode2.attributes.href === "string" && extractFileExtension(serializedNode2.attributes.href) === "css")) {
    onceStylesheetLoaded(
      n2,
      () => {
        if (onStylesheetLoad) {
          const serializedLinkNode = serializeNodeWithId(n2, {
            doc,
            mirror: mirror2,
            blockClass,
            blockSelector,
            unblockSelector,
            maskAllText,
            maskTextClass,
            unmaskTextClass,
            maskTextSelector,
            unmaskTextSelector,
            skipChild: false,
            inlineStylesheet,
            maskInputOptions,
            maskAttributeFn,
            maskTextFn,
            maskInputFn,
            slimDOMOptions,
            dataURLOptions,
            inlineImages,
            recordCanvas,
            preserveWhiteSpace,
            onSerialize,
            onIframeLoad,
            iframeLoadTimeout,
            onStylesheetLoad,
            stylesheetLoadTimeout,
            keepIframeSrcFn,
            ignoreCSSAttributes
          });
          if (serializedLinkNode) {
            onStylesheetLoad(
              n2,
              serializedLinkNode
            );
          }
        }
      },
      stylesheetLoadTimeout
    );
  }
  if (serializedNode2.type === NodeType$1.Element) {
    delete serializedNode2.needBlock;
  }
  return serializedNode2;
}
function snapshot(n2, options) {
  const {
    mirror: mirror2 = new Mirror(),
    blockClass = "rr-block",
    blockSelector = null,
    unblockSelector = null,
    maskAllText = false,
    maskTextClass = "rr-mask",
    unmaskTextClass = null,
    maskTextSelector = null,
    unmaskTextSelector = null,
    inlineStylesheet = true,
    inlineImages = false,
    recordCanvas = false,
    maskAllInputs = false,
    maskAttributeFn,
    maskTextFn,
    maskInputFn,
    slimDOM = false,
    dataURLOptions,
    preserveWhiteSpace,
    onSerialize,
    onIframeLoad,
    iframeLoadTimeout,
    onBlockedImageLoad,
    onStylesheetLoad,
    stylesheetLoadTimeout,
    keepIframeSrcFn = () => false,
    ignoreCSSAttributes = /* @__PURE__ */ new Set([])
  } = options || {};
  const maskInputOptions = maskAllInputs === true ? {
    color: true,
    date: true,
    "datetime-local": true,
    email: true,
    month: true,
    number: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true,
    textarea: true,
    select: true
  } : maskAllInputs === false ? {} : maskAllInputs;
  const slimDOMOptions = slimDOM === true || slimDOM === "all" ? (
    // if true: set of sensible options that should not throw away any information
    {
      script: true,
      comment: true,
      headFavicon: true,
      headWhitespace: true,
      headMetaDescKeywords: slimDOM === "all",
      // destructive
      headMetaSocial: true,
      headMetaRobots: true,
      headMetaHttpEquiv: true,
      headMetaAuthorship: true,
      headMetaVerification: true
    }
  ) : slimDOM === false ? {} : slimDOM;
  return serializeNodeWithId(n2, {
    doc: n2,
    mirror: mirror2,
    blockClass,
    blockSelector,
    unblockSelector,
    maskAllText,
    maskTextClass,
    unmaskTextClass,
    maskTextSelector,
    unmaskTextSelector,
    skipChild: false,
    inlineStylesheet,
    maskInputOptions,
    maskAttributeFn,
    maskTextFn,
    maskInputFn,
    slimDOMOptions,
    dataURLOptions,
    inlineImages,
    recordCanvas,
    preserveWhiteSpace,
    onSerialize,
    onIframeLoad,
    iframeLoadTimeout,
    onBlockedImageLoad,
    onStylesheetLoad,
    stylesheetLoadTimeout,
    keepIframeSrcFn,
    newlyAddedElement: false,
    ignoreCSSAttributes
  });
}
function on(type, fn, target = document) {
  const options = { capture: true, passive: true };
  target.addEventListener(type, fn, options);
  return () => target.removeEventListener(type, fn, options);
}
const DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let _mirror = {
  map: {},
  getId() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return -1;
  },
  getNode() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return null;
  },
  removeNodeFromMap() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  },
  has() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
    return false;
  },
  reset() {
    console.error(DEPARTED_MIRROR_ACCESS_WARNING);
  }
};
if (typeof window !== "undefined" && window.Proxy && window.Reflect) {
  _mirror = new Proxy(_mirror, {
    get(target, prop, receiver) {
      if (prop === "map") {
        console.error(DEPARTED_MIRROR_ACCESS_WARNING);
      }
      return Reflect.get(target, prop, receiver);
    }
  });
}
function throttle$1(func, wait, options = {}) {
  let timeout = null;
  let previous = 0;
  return function(...args) {
    const now = Date.now();
    if (!previous && options.leading === false) {
      previous = now;
    }
    const remaining = wait - (now - previous);
    const context = this;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout$2(timeout);
        timeout = null;
      }
      previous = now;
      func.apply(context, args);
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout$2(() => {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        func.apply(context, args);
      }, remaining);
    }
  };
}
function hookSetter(target, key, d, isRevoked, win = window) {
  const original = win.Object.getOwnPropertyDescriptor(target, key);
  win.Object.defineProperty(
    target,
    key,
    isRevoked ? d : {
      set(value) {
        setTimeout$2(() => {
          d.set.call(this, value);
        }, 0);
        if (original && original.set) {
          original.set.call(this, value);
        }
      }
    }
  );
  return () => hookSetter(target, key, original || {}, true);
}
function patch(source, name, replacement) {
  try {
    if (!(name in source)) {
      return () => {
      };
    }
    const original = source[name];
    const wrapped = replacement(original);
    if (typeof wrapped === "function") {
      wrapped.prototype = wrapped.prototype || {};
      Object.defineProperties(wrapped, {
        __rrweb_original__: {
          enumerable: false,
          value: original
        }
      });
    }
    source[name] = wrapped;
    return () => {
      source[name] = original;
    };
  } catch {
    return () => {
    };
  }
}
let nowTimestamp = Date.now;
if (!/* @__PURE__ */ /[1-9][0-9]{12}/.test(Date.now().toString())) {
  nowTimestamp = () => (/* @__PURE__ */ new Date()).getTime();
}
function getWindowScroll(win) {
  const doc = win.document;
  return {
    left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== void 0 ? win.pageXOffset : doc?.documentElement.scrollLeft || doc?.body?.parentElement?.scrollLeft || doc?.body?.scrollLeft || 0,
    top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== void 0 ? win.pageYOffset : doc?.documentElement.scrollTop || doc?.body?.parentElement?.scrollTop || doc?.body?.scrollTop || 0
  };
}
function getWindowHeight() {
  return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function getWindowWidth() {
  return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function closestElementOfNode$1(node) {
  if (!node) {
    return null;
  }
  try {
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
  } catch (error) {
    return null;
  }
}
function isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
  if (!node) {
    return false;
  }
  const el = closestElementOfNode$1(node);
  if (!el) {
    return false;
  }
  const blockedPredicate = createMatchPredicate(blockClass, blockSelector);
  if (!checkAncestors) {
    const isUnblocked = unblockSelector && el.matches(unblockSelector);
    return blockedPredicate(el) && !isUnblocked;
  }
  const blockDistance = distanceToMatch(el, blockedPredicate);
  let unblockDistance = -1;
  if (blockDistance < 0) {
    return false;
  }
  if (unblockSelector) {
    unblockDistance = distanceToMatch(
      el,
      createMatchPredicate(null, unblockSelector)
    );
  }
  if (blockDistance > -1 && unblockDistance < 0) {
    return true;
  }
  return blockDistance < unblockDistance;
}
function isSerialized(n2, mirror2) {
  return mirror2.getId(n2) !== -1;
}
function isIgnored(n2, mirror2) {
  return mirror2.getId(n2) === IGNORED_NODE;
}
function isAncestorRemoved(target, mirror2) {
  if (isShadowRoot(target)) {
    return false;
  }
  const id = mirror2.getId(target);
  if (!mirror2.has(id)) {
    return true;
  }
  if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) {
    return false;
  }
  if (!target.parentNode) {
    return true;
  }
  return isAncestorRemoved(target.parentNode, mirror2);
}
function legacy_isTouchEvent(event) {
  return Boolean(event.changedTouches);
}
function polyfill(win = window) {
  if ("NodeList" in win && !win.NodeList.prototype.forEach) {
    win.NodeList.prototype.forEach = Array.prototype.forEach;
  }
  if ("DOMTokenList" in win && !win.DOMTokenList.prototype.forEach) {
    win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
  }
  if (!Node.prototype.contains) {
    Node.prototype.contains = (...args) => {
      let node = args[0];
      if (!(0 in args)) {
        throw new TypeError("1 argument is required");
      }
      do {
        if (this === node) {
          return true;
        }
      } while (node = node && node.parentNode);
      return false;
    };
  }
}
function isSerializedIframe(n2, mirror2) {
  return Boolean(n2.nodeName === "IFRAME" && mirror2.getMeta(n2));
}
function isSerializedStylesheet(n2, mirror2) {
  return Boolean(
    n2.nodeName === "LINK" && n2.nodeType === n2.ELEMENT_NODE && n2.getAttribute && n2.getAttribute("rel") === "stylesheet" && mirror2.getMeta(n2)
  );
}
function hasShadowRoot(n2) {
  return Boolean(n2?.shadowRoot);
}
class StyleSheetMirror {
  constructor() {
    this.id = 1;
    this.styleIDMap = /* @__PURE__ */ new WeakMap();
    this.idStyleMap = /* @__PURE__ */ new Map();
  }
  getId(stylesheet) {
    return this.styleIDMap.get(stylesheet) ?? -1;
  }
  has(stylesheet) {
    return this.styleIDMap.has(stylesheet);
  }
  /**
   * @returns If the stylesheet is in the mirror, returns the id of the stylesheet. If not, return the new assigned id.
   */
  add(stylesheet, id) {
    if (this.has(stylesheet)) return this.getId(stylesheet);
    let newId;
    if (id === void 0) {
      newId = this.id++;
    } else newId = id;
    this.styleIDMap.set(stylesheet, newId);
    this.idStyleMap.set(newId, stylesheet);
    return newId;
  }
  getStyle(id) {
    return this.idStyleMap.get(id) || null;
  }
  reset() {
    this.styleIDMap = /* @__PURE__ */ new WeakMap();
    this.idStyleMap = /* @__PURE__ */ new Map();
    this.id = 1;
  }
  generateId() {
    return this.id++;
  }
}
function getShadowHost(n2) {
  let shadowHost = null;
  if (n2.getRootNode?.()?.nodeType === Node.DOCUMENT_FRAGMENT_NODE && n2.getRootNode().host)
    shadowHost = n2.getRootNode().host;
  return shadowHost;
}
function getRootShadowHost(n2) {
  let rootShadowHost = n2;
  let shadowHost;
  while (shadowHost = getShadowHost(rootShadowHost))
    rootShadowHost = shadowHost;
  return rootShadowHost;
}
function shadowHostInDom(n2) {
  const doc = n2.ownerDocument;
  if (!doc) return false;
  const shadowHost = getRootShadowHost(n2);
  return doc.contains(shadowHost);
}
function inDom(n2) {
  const doc = n2.ownerDocument;
  if (!doc) return false;
  return doc.contains(n2) || shadowHostInDom(n2);
}
const cachedImplementations = {};
function getImplementation(name) {
  const cached = cachedImplementations[name];
  if (cached) {
    return cached;
  }
  const document2 = window.document;
  let impl = window[name];
  if (document2 && typeof document2.createElement === "function") {
    try {
      const sandbox = document2.createElement("iframe");
      sandbox.hidden = true;
      document2.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow[name]) {
        impl = // eslint-disable-next-line @typescript-eslint/unbound-method
        contentWindow[name];
      }
      document2.head.removeChild(sandbox);
    } catch (e2) {
    }
  }
  return cachedImplementations[name] = impl.bind(
    window
  );
}
function onRequestAnimationFrame(...rest) {
  return getImplementation("requestAnimationFrame")(...rest);
}
function setTimeout$2(...rest) {
  return getImplementation("setTimeout")(...rest);
}
function clearTimeout$2(...rest) {
  return getImplementation("clearTimeout")(...rest);
}
var EventType = /* @__PURE__ */ ((EventType2) => {
  EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
  EventType2[EventType2["Load"] = 1] = "Load";
  EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
  EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
  EventType2[EventType2["Meta"] = 4] = "Meta";
  EventType2[EventType2["Custom"] = 5] = "Custom";
  EventType2[EventType2["Plugin"] = 6] = "Plugin";
  return EventType2;
})(EventType || {});
var IncrementalSource = /* @__PURE__ */ ((IncrementalSource2) => {
  IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
  IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
  IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
  IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
  IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
  IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
  IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
  IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
  IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
  IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
  IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
  IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
  IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
  IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
  IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
  IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
  IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
  return IncrementalSource2;
})(IncrementalSource || {});
var MouseInteractions = /* @__PURE__ */ ((MouseInteractions2) => {
  MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
  MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
  MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
  MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
  MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
  MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
  MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
  MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
  MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
  MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
  MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
  return MouseInteractions2;
})(MouseInteractions || {});
var PointerTypes = /* @__PURE__ */ ((PointerTypes2) => {
  PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
  PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
  PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
  return PointerTypes2;
})(PointerTypes || {});
var MediaInteractions = /* @__PURE__ */ ((MediaInteractions2) => {
  MediaInteractions2[MediaInteractions2["Play"] = 0] = "Play";
  MediaInteractions2[MediaInteractions2["Pause"] = 1] = "Pause";
  MediaInteractions2[MediaInteractions2["Seeked"] = 2] = "Seeked";
  MediaInteractions2[MediaInteractions2["VolumeChange"] = 3] = "VolumeChange";
  MediaInteractions2[MediaInteractions2["RateChange"] = 4] = "RateChange";
  return MediaInteractions2;
})(MediaInteractions || {});
let errorHandler;
function registerErrorHandler(handler) {
  errorHandler = handler;
}
function unregisterErrorHandler() {
  errorHandler = void 0;
}
const callbackWrapper = (cb) => {
  if (!errorHandler) {
    return cb;
  }
  const rrwebWrapped = ((...rest) => {
    try {
      return cb(...rest);
    } catch (error) {
      if (errorHandler && errorHandler(error) === true) {
        return () => {
        };
      }
      throw error;
    }
  });
  return rrwebWrapped;
};
var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
for (var i = 0; i < chars.length; i++) {
  lookup[chars.charCodeAt(i)] = i;
}
class CanvasManagerNoop {
  reset() {
  }
  freeze() {
  }
  unfreeze() {
  }
  lock() {
  }
  unlock() {
  }
  snapshot() {
  }
  addWindow() {
  }
  addShadowRoot() {
  }
  resetShadowRoots() {
  }
}
function getIFrameContentDocument(iframe) {
  try {
    return iframe.contentDocument;
  } catch (e2) {
  }
}
function getIFrameContentWindow(iframe) {
  try {
    return iframe.contentWindow;
  } catch (e2) {
  }
}
class StyleDeclarationParser {
  constructor(doc) {
    this.doc = doc;
    this.unattachedDoc = null;
  }
  parse(styleText) {
    return this.parseWithConstructableStylesheet(styleText) || this.parseWithDetachedElement(styleText);
  }
  parseWithConstructableStylesheet(styleText) {
    if (typeof CSSStyleSheet === "undefined" || typeof CSSStyleSheet.prototype.replaceSync !== "function") {
      return null;
    }
    try {
      const sheet = new CSSStyleSheet();
      sheet.replaceSync(`x { ${styleText} }`);
      const rule = sheet.cssRules[0];
      if (!rule || rule.type !== CSSRule.STYLE_RULE) {
        return null;
      }
      return rule.style;
    } catch {
      return null;
    }
  }
  parseWithDetachedElement(styleText) {
    const old = this.getUnattachedDoc().createElement("span");
    old.setAttribute("style", styleText);
    return old.style;
  }
  getUnattachedDoc() {
    if (!this.unattachedDoc) {
      try {
        this.unattachedDoc = document.implementation.createHTMLDocument();
      } catch {
        this.unattachedDoc = this.doc;
      }
    }
    return this.unattachedDoc;
  }
}
function isNodeInLinkedList(n2) {
  return "__ln" in n2;
}
class DoubleLinkedList {
  constructor() {
    this.length = 0;
    this.head = null;
    this.tail = null;
  }
  get(position) {
    if (position >= this.length) {
      throw new Error("Position outside of list range");
    }
    let current = this.head;
    for (let index = 0; index < position; index++) {
      current = current?.next || null;
    }
    return current;
  }
  addNode(n2) {
    const node = {
      value: n2,
      previous: null,
      next: null
    };
    n2.__ln = node;
    if (n2.previousSibling && isNodeInLinkedList(n2.previousSibling)) {
      const current = n2.previousSibling.__ln.next;
      node.next = current;
      node.previous = n2.previousSibling.__ln;
      n2.previousSibling.__ln.next = node;
      if (current) {
        current.previous = node;
      }
    } else if (n2.nextSibling && isNodeInLinkedList(n2.nextSibling) && n2.nextSibling.__ln.previous) {
      const current = n2.nextSibling.__ln.previous;
      node.previous = current;
      node.next = n2.nextSibling.__ln;
      n2.nextSibling.__ln.previous = node;
      if (current) {
        current.next = node;
      }
    } else {
      if (this.head) {
        this.head.previous = node;
      }
      node.next = this.head;
      this.head = node;
    }
    if (node.next === null) {
      this.tail = node;
    }
    this.length++;
  }
  removeNode(n2) {
    const current = n2.__ln;
    if (!this.head) {
      return;
    }
    if (!current.previous) {
      this.head = current.next;
      if (this.head) {
        this.head.previous = null;
      } else {
        this.tail = null;
      }
    } else {
      current.previous.next = current.next;
      if (current.next) {
        current.next.previous = current.previous;
      } else {
        this.tail = current.previous;
      }
    }
    if (n2.__ln) {
      delete n2.__ln;
    }
    this.length--;
  }
}
const moveKey = (id, parentId) => `${id}@${parentId}`;
class MutationBuffer {
  constructor() {
    this.frozen = false;
    this.locked = false;
    this.texts = [];
    this.attributes = [];
    this.attributeMap = /* @__PURE__ */ new WeakMap();
    this.removes = [];
    this.mapRemoves = [];
    this.movedMap = {};
    this.addedSet = /* @__PURE__ */ new Set();
    this.movedSet = /* @__PURE__ */ new Set();
    this.droppedSet = /* @__PURE__ */ new Set();
    this.processMutations = (mutations) => {
      mutations.forEach(this.processMutation);
      this.emit();
    };
    this.emit = () => {
      if (this.frozen || this.locked) {
        return;
      }
      const adds = [];
      const addedIds = /* @__PURE__ */ new Set();
      const addList = new DoubleLinkedList();
      const getNextId = (n2) => {
        let ns = n2;
        let nextId = IGNORED_NODE;
        while (nextId === IGNORED_NODE) {
          ns = ns && ns.nextSibling;
          nextId = ns && this.mirror.getId(ns);
        }
        return nextId;
      };
      const pushAdd = (n2) => {
        if (!n2.parentNode || !inDom(n2)) {
          return;
        }
        const parentId = isShadowRoot(n2.parentNode) ? this.mirror.getId(getShadowHost(n2)) : this.mirror.getId(n2.parentNode);
        const nextId = getNextId(n2);
        if (parentId === -1 || nextId === -1) {
          return addList.addNode(n2);
        }
        const sn = serializeNodeWithId(n2, {
          doc: this.doc,
          mirror: this.mirror,
          blockClass: this.blockClass,
          blockSelector: this.blockSelector,
          maskAllText: this.maskAllText,
          unblockSelector: this.unblockSelector,
          maskTextClass: this.maskTextClass,
          unmaskTextClass: this.unmaskTextClass,
          maskTextSelector: this.maskTextSelector,
          unmaskTextSelector: this.unmaskTextSelector,
          skipChild: true,
          newlyAddedElement: true,
          inlineStylesheet: this.inlineStylesheet,
          maskInputOptions: this.maskInputOptions,
          maskAttributeFn: this.maskAttributeFn,
          maskTextFn: this.maskTextFn,
          maskInputFn: this.maskInputFn,
          slimDOMOptions: this.slimDOMOptions,
          dataURLOptions: this.dataURLOptions,
          recordCanvas: this.recordCanvas,
          inlineImages: this.inlineImages,
          onSerialize: (currentN) => {
            if (isSerializedIframe(currentN, this.mirror) && !isBlocked(
              currentN,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              false
            )) {
              this.iframeManager.addIframe(currentN);
            }
            if (isSerializedStylesheet(currentN, this.mirror)) {
              this.stylesheetManager.trackLinkElement(
                currentN
              );
            }
            if (hasShadowRoot(n2)) {
              this.shadowDomManager.addShadowRoot(n2.shadowRoot, this.doc);
            }
          },
          onIframeLoad: (iframe, childSn) => {
            if (isBlocked(
              iframe,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              false
            )) {
              return;
            }
            this.iframeManager.attachIframe(iframe, childSn);
            const contentWindow = getIFrameContentWindow(iframe);
            if (contentWindow) {
              this.canvasManager.addWindow(contentWindow);
            }
            this.shadowDomManager.observeAttachShadow(iframe);
          },
          onStylesheetLoad: (link, childSn) => {
            this.stylesheetManager.attachLinkElement(link, childSn);
          },
          onBlockedImageLoad: (_imageEl, serializedNode, { width, height }) => {
            this.mutationCb({
              adds: [],
              removes: [],
              texts: [],
              attributes: [
                {
                  id: serializedNode.id,
                  attributes: {
                    style: {
                      width: `${width}px`,
                      height: `${height}px`
                    }
                  }
                }
              ]
            });
          },
          ignoreCSSAttributes: this.ignoreCSSAttributes
        });
        if (sn) {
          adds.push({
            parentId,
            nextId,
            node: sn
          });
          addedIds.add(sn.id);
        }
      };
      while (this.mapRemoves.length) {
        this.mirror.removeNodeFromMap(this.mapRemoves.shift());
      }
      for (const n2 of this.movedSet) {
        if (isParentRemoved(this.removes, n2, this.mirror) && !this.movedSet.has(n2.parentNode)) {
          continue;
        }
        pushAdd(n2);
      }
      for (const n2 of this.addedSet) {
        if (!isAncestorInSet(this.droppedSet, n2) && !isParentRemoved(this.removes, n2, this.mirror)) {
          pushAdd(n2);
        } else if (isAncestorInSet(this.movedSet, n2)) {
          pushAdd(n2);
        } else {
          this.droppedSet.add(n2);
        }
      }
      let candidate = null;
      while (addList.length) {
        let node = null;
        if (candidate) {
          const parentId = this.mirror.getId(candidate.value.parentNode);
          const nextId = getNextId(candidate.value);
          if (parentId !== -1 && nextId !== -1) {
            node = candidate;
          }
        }
        if (!node) {
          let tailNode = addList.tail;
          while (tailNode) {
            const _node = tailNode;
            tailNode = tailNode.previous;
            if (_node) {
              const parentId = this.mirror.getId(_node.value.parentNode);
              const nextId = getNextId(_node.value);
              if (nextId === -1) continue;
              else if (parentId !== -1) {
                node = _node;
                break;
              } else {
                const unhandledNode = _node.value;
                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                  const shadowHost = unhandledNode.parentNode.host;
                  const parentId2 = this.mirror.getId(shadowHost);
                  if (parentId2 !== -1) {
                    node = _node;
                    break;
                  }
                }
              }
            }
          }
        }
        if (!node) {
          while (addList.head) {
            addList.removeNode(addList.head.value);
          }
          break;
        }
        candidate = node.previous;
        addList.removeNode(node.value);
        pushAdd(node.value);
      }
      const payload = {
        texts: this.texts.map((text) => ({
          id: this.mirror.getId(text.node),
          value: text.value
        })).filter((text) => !addedIds.has(text.id)).filter((text) => this.mirror.has(text.id)),
        attributes: this.attributes.map((attribute) => {
          const { attributes } = attribute;
          if (typeof attributes.style === "string") {
            const diffAsStr = JSON.stringify(attribute.styleDiff);
            const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
            if (diffAsStr.length < attributes.style.length) {
              if ((diffAsStr + unchangedAsStr).split("var(").length === attributes.style.split("var(").length) {
                attributes.style = attribute.styleDiff;
              }
            }
          }
          return {
            id: this.mirror.getId(attribute.node),
            attributes
          };
        }).filter((attribute) => !addedIds.has(attribute.id)).filter((attribute) => this.mirror.has(attribute.id)),
        removes: this.removes,
        adds
      };
      if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) {
        return;
      }
      this.texts = [];
      this.attributes = [];
      this.attributeMap = /* @__PURE__ */ new WeakMap();
      this.removes = [];
      this.addedSet = /* @__PURE__ */ new Set();
      this.movedSet = /* @__PURE__ */ new Set();
      this.droppedSet = /* @__PURE__ */ new Set();
      this.movedMap = {};
      this.mutationCb(payload);
    };
    this.processMutation = (m) => {
      if (isIgnored(m.target, this.mirror)) {
        return;
      }
      switch (m.type) {
        case "characterData": {
          const value = m.target.textContent;
          if (!isBlocked(
            m.target,
            this.blockClass,
            this.blockSelector,
            this.unblockSelector,
            false
          ) && value !== m.oldValue) {
            this.texts.push({
              value: needMaskingText(
                m.target,
                this.maskTextClass,
                this.maskTextSelector,
                this.unmaskTextClass,
                this.unmaskTextSelector,
                this.maskAllText
              ) && value ? this.maskTextFn ? this.maskTextFn(value, closestElementOfNode$1(m.target)) : value.replace(/[\S]/g, "*") : value,
              node: m.target
            });
          }
          break;
        }
        case "attributes": {
          const target = m.target;
          let attributeName = m.attributeName;
          let value = m.target.getAttribute(attributeName);
          if (attributeName === "value") {
            const type = getInputType(target);
            const tagName = target.tagName;
            value = getInputValue(target, tagName, type);
            const isInputMasked = shouldMaskInput({
              maskInputOptions: this.maskInputOptions,
              tagName,
              type
            });
            const forceMask = needMaskingText(
              m.target,
              this.maskTextClass,
              this.maskTextSelector,
              this.unmaskTextClass,
              this.unmaskTextSelector,
              isInputMasked
            );
            value = maskInputValue({
              isMasked: forceMask,
              element: target,
              value,
              maskInputFn: this.maskInputFn
            });
          }
          if (isBlocked(
            m.target,
            this.blockClass,
            this.blockSelector,
            this.unblockSelector,
            false
          ) || value === m.oldValue) {
            return;
          }
          let item = this.attributeMap.get(m.target);
          if (target.tagName === "IFRAME" && attributeName === "src" && !this.keepIframeSrcFn(value)) {
            const iframeDoc = getIFrameContentDocument(
              target
            );
            if (!iframeDoc) {
              attributeName = "rr_src";
            } else {
              return;
            }
          }
          if (!item) {
            item = {
              node: m.target,
              attributes: {},
              styleDiff: {},
              _unchangedStyles: {}
            };
            this.attributes.push(item);
            this.attributeMap.set(m.target, item);
          }
          if (attributeName === "type" && target.tagName === "INPUT" && (m.oldValue || "").toLowerCase() === "password") {
            target.setAttribute("data-rr-is-password", "true");
          }
          if (!ignoreAttribute(target.tagName, attributeName)) {
            item.attributes[attributeName] = transformAttribute(
              this.doc,
              toLowerCase(target.tagName),
              toLowerCase(attributeName),
              value,
              target,
              this.maskAttributeFn
            );
            if (attributeName === "style") {
              const oldStyle = m.oldValue ? this.styleDeclarationParser.parse(m.oldValue) : null;
              for (const pname of Array.from(target.style)) {
                const newValue = target.style.getPropertyValue(pname);
                const newPriority = target.style.getPropertyPriority(pname);
                if (newValue !== (oldStyle?.getPropertyValue(pname) || "") || newPriority !== (oldStyle?.getPropertyPriority(pname) || "")) {
                  if (newPriority === "") {
                    item.styleDiff[pname] = newValue;
                  } else {
                    item.styleDiff[pname] = [newValue, newPriority];
                  }
                } else {
                  item._unchangedStyles[pname] = [newValue, newPriority];
                }
              }
              if (oldStyle) {
                for (const pname of Array.from(oldStyle)) {
                  if (target.style.getPropertyValue(pname) === "") {
                    item.styleDiff[pname] = false;
                  }
                }
              }
            }
          }
          break;
        }
        case "childList": {
          if (isBlocked(
            m.target,
            this.blockClass,
            this.blockSelector,
            this.unblockSelector,
            true
          )) {
            return;
          }
          m.addedNodes.forEach((n2) => this.genAdds(n2, m.target));
          m.removedNodes.forEach((n2) => {
            const nodeId = this.mirror.getId(n2);
            const parentId = isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
            if (isBlocked(
              m.target,
              this.blockClass,
              this.blockSelector,
              this.unblockSelector,
              false
            ) || isIgnored(n2, this.mirror) || !isSerialized(n2, this.mirror)) {
              return;
            }
            if (this.addedSet.has(n2)) {
              deepDelete(this.addedSet, n2);
              this.droppedSet.add(n2);
            } else if (this.addedSet.has(m.target) && nodeId === -1) ;
            else if (isAncestorRemoved(m.target, this.mirror)) ;
            else if (this.movedSet.has(n2) && this.movedMap[moveKey(nodeId, parentId)]) {
              deepDelete(this.movedSet, n2);
            } else {
              this.removes.push({
                parentId,
                id: nodeId,
                isShadow: isShadowRoot(m.target) && isNativeShadowDom(m.target) ? true : void 0
              });
            }
            this.mapRemoves.push(n2);
          });
          break;
        }
      }
    };
    this.genAdds = (n2, target) => {
      if (this.processedNodeManager.inOtherBuffer(n2, this)) return;
      if (this.addedSet.has(n2) || this.movedSet.has(n2)) return;
      if (this.mirror.hasNode(n2)) {
        if (isIgnored(n2, this.mirror)) {
          return;
        }
        this.movedSet.add(n2);
        let targetId = null;
        if (target && this.mirror.hasNode(target)) {
          targetId = this.mirror.getId(target);
        }
        if (targetId && targetId !== -1) {
          this.movedMap[moveKey(this.mirror.getId(n2), targetId)] = true;
        }
      } else {
        this.addedSet.add(n2);
        this.droppedSet.delete(n2);
      }
      if (!isBlocked(
        n2,
        this.blockClass,
        this.blockSelector,
        this.unblockSelector,
        false
      )) {
        if (n2.childNodes) {
          n2.childNodes.forEach((childN) => this.genAdds(childN));
        }
        if (hasShadowRoot(n2)) {
          n2.shadowRoot.childNodes.forEach((childN) => {
            this.processedNodeManager.add(childN, this);
            this.genAdds(childN, n2);
          });
        }
      }
    };
  }
  init(options) {
    [
      "mutationCb",
      "blockClass",
      "blockSelector",
      "unblockSelector",
      "maskAllText",
      "maskTextClass",
      "unmaskTextClass",
      "maskTextSelector",
      "unmaskTextSelector",
      "inlineStylesheet",
      "maskInputOptions",
      "maskAttributeFn",
      "maskTextFn",
      "maskInputFn",
      "keepIframeSrcFn",
      "recordCanvas",
      "inlineImages",
      "slimDOMOptions",
      "dataURLOptions",
      "doc",
      "mirror",
      "iframeManager",
      "stylesheetManager",
      "shadowDomManager",
      "canvasManager",
      "processedNodeManager",
      "ignoreCSSAttributes"
    ].forEach((key) => {
      this[key] = options[key];
    });
    this.styleDeclarationParser = new StyleDeclarationParser(this.doc);
  }
  freeze() {
    this.frozen = true;
    this.canvasManager.freeze();
  }
  unfreeze() {
    this.frozen = false;
    this.canvasManager.unfreeze();
    this.emit();
  }
  isFrozen() {
    return this.frozen;
  }
  lock() {
    this.locked = true;
    this.canvasManager.lock();
  }
  unlock() {
    this.locked = false;
    this.canvasManager.unlock();
    this.emit();
  }
  reset() {
    this.shadowDomManager.reset();
    this.canvasManager.reset();
  }
}
function deepDelete(addsSet, n2) {
  addsSet.delete(n2);
  n2.childNodes?.forEach((childN) => deepDelete(addsSet, childN));
}
function isParentRemoved(removes, n2, mirror2) {
  if (removes.length === 0) return false;
  return _isParentRemoved(removes, n2, mirror2);
}
function _isParentRemoved(removes, n2, mirror2) {
  let node = n2.parentNode;
  while (node) {
    const parentId = mirror2.getId(node);
    if (removes.some((r2) => r2.id === parentId)) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}
function isAncestorInSet(set, n2) {
  if (set.size === 0) return false;
  return _isAncestorInSet(set, n2);
}
function _isAncestorInSet(set, n2) {
  const { parentNode } = n2;
  if (!parentNode) {
    return false;
  }
  if (set.has(parentNode)) {
    return true;
  }
  return _isAncestorInSet(set, parentNode);
}
const mutationBuffers = [];
function getEventTarget(event) {
  try {
    if ("composedPath" in event) {
      const path = event.composedPath();
      if (path.length) {
        return path[0];
      }
    } else if ("path" in event && event.path.length) {
      return event.path[0];
    }
  } catch {
  }
  return event && event.target;
}
function initMutationObserver(options, rootEl) {
  const mutationBuffer = new MutationBuffer();
  mutationBuffers.push(mutationBuffer);
  mutationBuffer.init(options);
  let mutationObserverCtor = window.MutationObserver || /**
  * Some websites may disable MutationObserver by removing it from the window object.
  * If someone is using rrweb to build a browser extention or things like it, they
  * could not change the website's code but can have an opportunity to inject some
  * code before the website executing its JS logic.
  * Then they can do this to store the native MutationObserver:
  * window.__rrMutationObserver = MutationObserver
  */
  window.__rrMutationObserver;
  const angularZoneSymbol = window?.Zone?.__symbol__?.("MutationObserver");
  if (angularZoneSymbol && window[angularZoneSymbol]) {
    mutationObserverCtor = window[angularZoneSymbol];
  }
  const observer = new mutationObserverCtor(
    callbackWrapper((mutations) => {
      if (options.onMutation && options.onMutation(mutations) === false) {
        return;
      }
      mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    })
  );
  observer.observe(rootEl, {
    attributes: true,
    attributeOldValue: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true
  });
  return observer;
}
function initMoveObserver({
  mousemoveCb,
  sampling,
  doc,
  mirror: mirror2
}) {
  if (sampling.mousemove === false) {
    return () => {
    };
  }
  const threshold = typeof sampling.mousemove === "number" ? sampling.mousemove : 50;
  const callbackThreshold = typeof sampling.mousemoveCallback === "number" ? sampling.mousemoveCallback : 500;
  let positions = [];
  let timeBaseline;
  const wrappedCb = throttle$1(
    callbackWrapper(
      (source) => {
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(
          positions.map((p) => {
            p.timeOffset -= totalOffset;
            return p;
          }),
          source
        );
        positions = [];
        timeBaseline = null;
      }
    ),
    callbackThreshold
  );
  const updatePosition = callbackWrapper(
    throttle$1(
      callbackWrapper((evt) => {
        const target = getEventTarget(evt);
        const { clientX, clientY } = legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) {
          timeBaseline = nowTimestamp();
        }
        positions.push({
          x: clientX,
          y: clientY,
          id: mirror2.getId(target),
          timeOffset: nowTimestamp() - timeBaseline
        });
        wrappedCb(
          typeof DragEvent !== "undefined" && evt instanceof DragEvent ? IncrementalSource.Drag : evt instanceof MouseEvent ? IncrementalSource.MouseMove : IncrementalSource.TouchMove
        );
      }),
      threshold,
      {
        trailing: false
      }
    )
  );
  const handlers2 = [
    on("mousemove", updatePosition, doc),
    on("touchmove", updatePosition, doc),
    on("drag", updatePosition, doc)
  ];
  return callbackWrapper(() => {
    handlers2.forEach((h) => h());
  });
}
function initMouseInteractionObserver({
  mouseInteractionCb,
  doc,
  mirror: mirror2,
  blockClass,
  blockSelector,
  unblockSelector,
  sampling
}) {
  if (sampling.mouseInteraction === false) {
    return () => {
    };
  }
  const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === void 0 ? {} : sampling.mouseInteraction;
  const handlers2 = [];
  let currentPointerType = null;
  const getHandler = (eventKey) => {
    return (event) => {
      const target = getEventTarget(event);
      if (isBlocked(target, blockClass, blockSelector, unblockSelector, true)) {
        return;
      }
      let pointerType = null;
      let thisEventKey = eventKey;
      if ("pointerType" in event) {
        switch (event.pointerType) {
          case "mouse":
            pointerType = PointerTypes.Mouse;
            break;
          case "touch":
            pointerType = PointerTypes.Touch;
            break;
          case "pen":
            pointerType = PointerTypes.Pen;
            break;
        }
        if (pointerType === PointerTypes.Touch) {
          if (MouseInteractions[eventKey] === MouseInteractions.MouseDown) {
            thisEventKey = "TouchStart";
          } else if (MouseInteractions[eventKey] === MouseInteractions.MouseUp) {
            thisEventKey = "TouchEnd";
          }
        } else if (pointerType === PointerTypes.Pen) ;
      } else if (legacy_isTouchEvent(event)) {
        pointerType = PointerTypes.Touch;
      }
      if (pointerType !== null) {
        currentPointerType = pointerType;
        if (thisEventKey.startsWith("Touch") && pointerType === PointerTypes.Touch || thisEventKey.startsWith("Mouse") && pointerType === PointerTypes.Mouse) {
          pointerType = null;
        }
      } else if (MouseInteractions[eventKey] === MouseInteractions.Click) {
        pointerType = currentPointerType;
        currentPointerType = null;
      }
      const e2 = legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
      if (!e2) {
        return;
      }
      const id = mirror2.getId(target);
      const { clientX, clientY } = e2;
      callbackWrapper(mouseInteractionCb)({
        type: MouseInteractions[thisEventKey],
        id,
        x: clientX,
        y: clientY,
        ...pointerType !== null && { pointerType }
      });
    };
  };
  Object.keys(MouseInteractions).filter(
    (key) => Number.isNaN(Number(key)) && !key.endsWith("_Departed") && disableMap[key] !== false
  ).forEach((eventKey) => {
    let eventName = toLowerCase(eventKey);
    const handler = getHandler(eventKey);
    if (window.PointerEvent) {
      switch (MouseInteractions[eventKey]) {
        case MouseInteractions.MouseDown:
        case MouseInteractions.MouseUp:
          eventName = eventName.replace(
            "mouse",
            "pointer"
          );
          break;
        case MouseInteractions.TouchStart:
        case MouseInteractions.TouchEnd:
          return;
      }
    }
    handlers2.push(on(eventName, handler, doc));
  });
  return callbackWrapper(() => {
    handlers2.forEach((h) => h());
  });
}
function initScrollObserver({
  scrollCb,
  doc,
  mirror: mirror2,
  blockClass,
  blockSelector,
  unblockSelector,
  sampling
}) {
  const updatePosition = callbackWrapper(
    throttle$1(
      callbackWrapper((evt) => {
        const target = getEventTarget(evt);
        if (!target || isBlocked(
          target,
          blockClass,
          blockSelector,
          unblockSelector,
          true
        )) {
          return;
        }
        const id = mirror2.getId(target);
        if (target === doc && doc.defaultView) {
          const scrollLeftTop = getWindowScroll(doc.defaultView);
          scrollCb({
            id,
            x: scrollLeftTop.left,
            y: scrollLeftTop.top
          });
        } else {
          scrollCb({
            id,
            x: target.scrollLeft,
            y: target.scrollTop
          });
        }
      }),
      sampling.scroll || 100
    )
  );
  return on("scroll", updatePosition, doc);
}
function initViewportResizeObserver({ viewportResizeCb }, { win }) {
  let lastH = -1;
  let lastW = -1;
  const updateDimension = callbackWrapper(
    throttle$1(
      callbackWrapper(() => {
        const height = getWindowHeight();
        const width = getWindowWidth();
        if (lastH !== height || lastW !== width) {
          viewportResizeCb({
            width: Number(width),
            height: Number(height)
          });
          lastH = height;
          lastW = width;
        }
      }),
      200
    )
  );
  return on("resize", updateDimension, win);
}
const INPUT_TAGS = ["INPUT", "TEXTAREA", "SELECT"];
const lastInputValueMap = /* @__PURE__ */ new WeakMap();
function initInputObserver({
  inputCb,
  doc,
  mirror: mirror2,
  blockClass,
  blockSelector,
  unblockSelector,
  ignoreClass,
  ignoreSelector,
  maskInputOptions,
  maskInputFn,
  sampling,
  userTriggeredOnInput,
  maskTextClass,
  unmaskTextClass,
  maskTextSelector,
  unmaskTextSelector
}) {
  function eventHandler(event) {
    let target = getEventTarget(event);
    const userTriggered = event.isTrusted;
    const tagName = target && toUpperCase(target.tagName);
    if (tagName === "OPTION") target = target.parentElement;
    if (!target || !tagName || INPUT_TAGS.indexOf(tagName) < 0 || isBlocked(
      target,
      blockClass,
      blockSelector,
      unblockSelector,
      true
    )) {
      return;
    }
    const el = target;
    if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) {
      return;
    }
    const type = getInputType(target);
    let text = getInputValue(el, tagName, type);
    let isChecked = false;
    const isInputMasked = shouldMaskInput({
      maskInputOptions,
      tagName,
      type
    });
    const forceMask = needMaskingText(
      target,
      maskTextClass,
      maskTextSelector,
      unmaskTextClass,
      unmaskTextSelector,
      isInputMasked
    );
    if (type === "radio" || type === "checkbox") {
      isChecked = target.checked;
    }
    text = maskInputValue({
      isMasked: forceMask,
      element: target,
      value: text,
      maskInputFn
    });
    cbWithDedup(
      target,
      userTriggeredOnInput ? { text, isChecked, userTriggered } : { text, isChecked }
    );
    const name = target.name;
    if (type === "radio" && name && isChecked) {
      doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el2) => {
        if (el2 !== target) {
          const text2 = maskInputValue({
            // share mask behavior of `target`
            isMasked: forceMask,
            element: el2,
            value: getInputValue(el2, tagName, type),
            maskInputFn
          });
          cbWithDedup(
            el2,
            userTriggeredOnInput ? { text: text2, isChecked: !isChecked, userTriggered: false } : { text: text2, isChecked: !isChecked }
          );
        }
      });
    }
  }
  function cbWithDedup(target, v2) {
    const lastInputValue = lastInputValueMap.get(target);
    if (!lastInputValue || lastInputValue.text !== v2.text || lastInputValue.isChecked !== v2.isChecked) {
      lastInputValueMap.set(target, v2);
      const id = mirror2.getId(target);
      callbackWrapper(inputCb)({
        ...v2,
        id
      });
    }
  }
  const events = sampling.input === "last" ? ["change"] : ["input", "change"];
  const handlers2 = events.map(
    (eventName) => on(eventName, callbackWrapper(eventHandler), doc)
  );
  const currentWindow = doc.defaultView;
  if (!currentWindow) {
    return () => {
      handlers2.forEach((h) => h());
    };
  }
  const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(
    currentWindow.HTMLInputElement.prototype,
    "value"
  );
  const hookProperties = [
    [currentWindow.HTMLInputElement.prototype, "value"],
    [currentWindow.HTMLInputElement.prototype, "checked"],
    [currentWindow.HTMLSelectElement.prototype, "value"],
    [currentWindow.HTMLTextAreaElement.prototype, "value"],
    // Some UI library use selectedIndex to set select value
    [currentWindow.HTMLSelectElement.prototype, "selectedIndex"],
    [currentWindow.HTMLOptionElement.prototype, "selected"]
  ];
  if (propertyDescriptor && propertyDescriptor.set) {
    handlers2.push(
      ...hookProperties.map(
        (p) => hookSetter(
          p[0],
          p[1],
          {
            set() {
              callbackWrapper(eventHandler)({
                target: this,
                isTrusted: false
                // userTriggered to false as this could well be programmatic
              });
            }
          },
          false,
          currentWindow
        )
      )
    );
  }
  return callbackWrapper(() => {
    handlers2.forEach((h) => h());
  });
}
function getNestedCSSRulePositions(rule) {
  const positions = [];
  function recurse(childRule, pos) {
    if (hasNestedCSSRule("CSSGroupingRule") && childRule.parentRule instanceof CSSGroupingRule || hasNestedCSSRule("CSSMediaRule") && childRule.parentRule instanceof CSSMediaRule || hasNestedCSSRule("CSSSupportsRule") && childRule.parentRule instanceof CSSSupportsRule || hasNestedCSSRule("CSSConditionRule") && childRule.parentRule instanceof CSSConditionRule) {
      const rules2 = Array.from(
        childRule.parentRule.cssRules
      );
      const index = rules2.indexOf(childRule);
      pos.unshift(index);
    } else if (childRule.parentStyleSheet) {
      const rules2 = Array.from(childRule.parentStyleSheet.cssRules);
      const index = rules2.indexOf(childRule);
      pos.unshift(index);
    }
    return pos;
  }
  return recurse(rule, positions);
}
function getIdAndStyleId(sheet, mirror2, styleMirror) {
  let id, styleId;
  if (!sheet) return {};
  if (sheet.ownerNode) id = mirror2.getId(sheet.ownerNode);
  else styleId = styleMirror.getId(sheet);
  return {
    styleId,
    id
  };
}
function initStyleSheetObserver({ styleSheetRuleCb, mirror: mirror2, stylesheetManager }, { win }) {
  if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) {
    return () => {
    };
  }
  const insertRule = win.CSSStyleSheet.prototype.insertRule;
  win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
    apply: callbackWrapper(
      (target, thisArg, argumentsList) => {
        const [rule, index] = argumentsList;
        const { id, styleId } = getIdAndStyleId(
          thisArg,
          mirror2,
          stylesheetManager.styleMirror
        );
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            adds: [{ rule, index }]
          });
        }
        return target.apply(thisArg, argumentsList);
      }
    )
  });
  const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
  win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
    apply: callbackWrapper(
      (target, thisArg, argumentsList) => {
        const [index] = argumentsList;
        const { id, styleId } = getIdAndStyleId(
          thisArg,
          mirror2,
          stylesheetManager.styleMirror
        );
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleSheetRuleCb({
            id,
            styleId,
            removes: [{ index }]
          });
        }
        return target.apply(thisArg, argumentsList);
      }
    )
  });
  let replace;
  if (win.CSSStyleSheet.prototype.replace) {
    replace = win.CSSStyleSheet.prototype.replace;
    win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
      apply: callbackWrapper(
        (target, thisArg, argumentsList) => {
          const [text] = argumentsList;
          const { id, styleId } = getIdAndStyleId(
            thisArg,
            mirror2,
            stylesheetManager.styleMirror
          );
          if (id && id !== -1 || styleId && styleId !== -1) {
            styleSheetRuleCb({
              id,
              styleId,
              replace: text
            });
          }
          return target.apply(thisArg, argumentsList);
        }
      )
    });
  }
  let replaceSync;
  if (win.CSSStyleSheet.prototype.replaceSync) {
    replaceSync = win.CSSStyleSheet.prototype.replaceSync;
    win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
      apply: callbackWrapper(
        (target, thisArg, argumentsList) => {
          const [text] = argumentsList;
          const { id, styleId } = getIdAndStyleId(
            thisArg,
            mirror2,
            stylesheetManager.styleMirror
          );
          if (id && id !== -1 || styleId && styleId !== -1) {
            styleSheetRuleCb({
              id,
              styleId,
              replaceSync: text
            });
          }
          return target.apply(thisArg, argumentsList);
        }
      )
    });
  }
  const supportedNestedCSSRuleTypes = {};
  if (canMonkeyPatchNestedCSSRule("CSSGroupingRule")) {
    supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
  } else {
    if (canMonkeyPatchNestedCSSRule("CSSMediaRule")) {
      supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
    }
    if (canMonkeyPatchNestedCSSRule("CSSConditionRule")) {
      supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
    }
    if (canMonkeyPatchNestedCSSRule("CSSSupportsRule")) {
      supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
  }
  const unmodifiedFunctions = {};
  Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
    unmodifiedFunctions[typeKey] = {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      insertRule: type.prototype.insertRule,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      deleteRule: type.prototype.deleteRule
    };
    type.prototype.insertRule = new Proxy(
      unmodifiedFunctions[typeKey].insertRule,
      {
        apply: callbackWrapper(
          (target, thisArg, argumentsList) => {
            const [rule, index] = argumentsList;
            const { id, styleId } = getIdAndStyleId(
              thisArg.parentStyleSheet,
              mirror2,
              stylesheetManager.styleMirror
            );
            if (id && id !== -1 || styleId && styleId !== -1) {
              styleSheetRuleCb({
                id,
                styleId,
                adds: [
                  {
                    rule,
                    index: [
                      ...getNestedCSSRulePositions(thisArg),
                      index || 0
                      // defaults to 0
                    ]
                  }
                ]
              });
            }
            return target.apply(thisArg, argumentsList);
          }
        )
      }
    );
    type.prototype.deleteRule = new Proxy(
      unmodifiedFunctions[typeKey].deleteRule,
      {
        apply: callbackWrapper(
          (target, thisArg, argumentsList) => {
            const [index] = argumentsList;
            const { id, styleId } = getIdAndStyleId(
              thisArg.parentStyleSheet,
              mirror2,
              stylesheetManager.styleMirror
            );
            if (id && id !== -1 || styleId && styleId !== -1) {
              styleSheetRuleCb({
                id,
                styleId,
                removes: [
                  { index: [...getNestedCSSRulePositions(thisArg), index] }
                ]
              });
            }
            return target.apply(thisArg, argumentsList);
          }
        )
      }
    );
  });
  return callbackWrapper(() => {
    win.CSSStyleSheet.prototype.insertRule = insertRule;
    win.CSSStyleSheet.prototype.deleteRule = deleteRule;
    replace && (win.CSSStyleSheet.prototype.replace = replace);
    replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type]) => {
      type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
      type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
    });
  });
}
function initAdoptedStyleSheetObserver({
  mirror: mirror2,
  stylesheetManager
}, host) {
  let hostId = null;
  if (host.nodeName === "#document") hostId = mirror2.getId(host);
  else hostId = mirror2.getId(host.host);
  const patchTarget = host.nodeName === "#document" ? host.defaultView?.Document : host.ownerDocument?.defaultView?.ShadowRoot;
  const originalPropertyDescriptor = patchTarget?.prototype ? Object.getOwnPropertyDescriptor(
    patchTarget?.prototype,
    "adoptedStyleSheets"
  ) : void 0;
  if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor)
    return () => {
    };
  Object.defineProperty(host, "adoptedStyleSheets", {
    configurable: originalPropertyDescriptor.configurable,
    enumerable: originalPropertyDescriptor.enumerable,
    get() {
      return originalPropertyDescriptor.get?.call(this);
    },
    set(sheets) {
      const result = originalPropertyDescriptor.set?.call(this, sheets);
      if (hostId !== null && hostId !== -1) {
        try {
          stylesheetManager.adoptStyleSheets(sheets, hostId);
        } catch (e2) {
        }
      }
      return result;
    }
  });
  return callbackWrapper(() => {
    Object.defineProperty(host, "adoptedStyleSheets", {
      configurable: originalPropertyDescriptor.configurable,
      enumerable: originalPropertyDescriptor.enumerable,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      get: originalPropertyDescriptor.get,
      // eslint-disable-next-line @typescript-eslint/unbound-method
      set: originalPropertyDescriptor.set
    });
  });
}
function initStyleDeclarationObserver({
  styleDeclarationCb,
  mirror: mirror2,
  ignoreCSSAttributes,
  stylesheetManager
}, { win }) {
  const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
  win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
    apply: callbackWrapper(
      (target, thisArg, argumentsList) => {
        const [property, value, priority] = argumentsList;
        if (ignoreCSSAttributes.has(property)) {
          return setProperty.apply(thisArg, [property, value, priority]);
        }
        const { id, styleId } = getIdAndStyleId(
          thisArg.parentRule?.parentStyleSheet,
          mirror2,
          stylesheetManager.styleMirror
        );
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleDeclarationCb({
            id,
            styleId,
            set: {
              property,
              value,
              priority
            },
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            index: getNestedCSSRulePositions(thisArg.parentRule)
          });
        }
        return target.apply(thisArg, argumentsList);
      }
    )
  });
  const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
  win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
    apply: callbackWrapper(
      (target, thisArg, argumentsList) => {
        const [property] = argumentsList;
        if (ignoreCSSAttributes.has(property)) {
          return removeProperty.apply(thisArg, [property]);
        }
        const { id, styleId } = getIdAndStyleId(
          thisArg.parentRule?.parentStyleSheet,
          mirror2,
          stylesheetManager.styleMirror
        );
        if (id && id !== -1 || styleId && styleId !== -1) {
          styleDeclarationCb({
            id,
            styleId,
            remove: {
              property
            },
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            index: getNestedCSSRulePositions(thisArg.parentRule)
          });
        }
        return target.apply(thisArg, argumentsList);
      }
    )
  });
  return callbackWrapper(() => {
    win.CSSStyleDeclaration.prototype.setProperty = setProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
  });
}
function initMediaInteractionObserver({
  mediaInteractionCb,
  blockClass,
  blockSelector,
  unblockSelector,
  mirror: mirror2,
  sampling,
  doc
}) {
  const handler = callbackWrapper(
    (type) => throttle$1(
      callbackWrapper((event) => {
        const target = getEventTarget(event);
        if (!target || isBlocked(
          target,
          blockClass,
          blockSelector,
          unblockSelector,
          true
        )) {
          return;
        }
        const { currentTime, volume, muted, playbackRate } = target;
        mediaInteractionCb({
          type,
          id: mirror2.getId(target),
          currentTime,
          volume,
          muted,
          playbackRate
        });
      }),
      sampling.media || 500
    )
  );
  const handlers2 = [
    on("play", handler(MediaInteractions.Play), doc),
    on("pause", handler(MediaInteractions.Pause), doc),
    on("seeked", handler(MediaInteractions.Seeked), doc),
    on("volumechange", handler(MediaInteractions.VolumeChange), doc),
    on("ratechange", handler(MediaInteractions.RateChange), doc)
  ];
  return callbackWrapper(() => {
    handlers2.forEach((h) => h());
  });
}
function initFontObserver({ fontCb, doc }) {
  const win = doc.defaultView;
  if (!win) {
    return () => {
    };
  }
  const handlers2 = [];
  const fontMap = /* @__PURE__ */ new WeakMap();
  const originalFontFace = win.FontFace;
  win.FontFace = function FontFace2(family, source, descriptors) {
    const fontFace = new originalFontFace(family, source, descriptors);
    fontMap.set(fontFace, {
      family,
      buffer: typeof source !== "string",
      descriptors,
      fontSource: typeof source === "string" ? source : JSON.stringify(Array.from(new Uint8Array(source)))
    });
    return fontFace;
  };
  const restoreHandler = patch(
    doc.fonts,
    "add",
    function(original) {
      return function(fontFace) {
        setTimeout$2(
          callbackWrapper(() => {
            const p = fontMap.get(fontFace);
            if (p) {
              fontCb(p);
              fontMap.delete(fontFace);
            }
          }),
          0
        );
        return original.apply(this, [fontFace]);
      };
    }
  );
  handlers2.push(() => {
    win.FontFace = originalFontFace;
  });
  handlers2.push(restoreHandler);
  return callbackWrapper(() => {
    handlers2.forEach((h) => h());
  });
}
function initSelectionObserver(param) {
  const {
    doc,
    mirror: mirror2,
    blockClass,
    blockSelector,
    unblockSelector,
    selectionCb
  } = param;
  let collapsed = true;
  const updateSelection = callbackWrapper(() => {
    const selection = doc.getSelection();
    if (!selection || collapsed && selection?.isCollapsed) return;
    collapsed = selection.isCollapsed || false;
    const ranges = [];
    const count = selection.rangeCount || 0;
    for (let i2 = 0; i2 < count; i2++) {
      const range = selection.getRangeAt(i2);
      const { startContainer, startOffset, endContainer, endOffset } = range;
      const blocked = isBlocked(
        startContainer,
        blockClass,
        blockSelector,
        unblockSelector,
        true
      ) || isBlocked(
        endContainer,
        blockClass,
        blockSelector,
        unblockSelector,
        true
      );
      if (blocked) continue;
      ranges.push({
        start: mirror2.getId(startContainer),
        startOffset,
        end: mirror2.getId(endContainer),
        endOffset
      });
    }
    selectionCb({ ranges });
  });
  updateSelection();
  return on("selectionchange", updateSelection);
}
function initCustomElementObserver({
  doc,
  customElementCb
}) {
  const win = doc.defaultView;
  if (!win || !win.customElements) return () => {
  };
  const restoreHandler = patch(
    win.customElements,
    "define",
    function(original) {
      return function(name, constructor, options) {
        try {
          customElementCb({
            define: {
              name
            }
          });
        } catch (e2) {
        }
        return original.apply(this, [name, constructor, options]);
      };
    }
  );
  return restoreHandler;
}
function initObservers(o2, _hooks = {}) {
  const currentWindow = o2.doc.defaultView;
  if (!currentWindow) {
    return () => {
    };
  }
  let mutationObserver;
  if (o2.recordDOM) {
    mutationObserver = initMutationObserver(o2, o2.doc);
  }
  const mousemoveHandler = initMoveObserver(o2);
  const mouseInteractionHandler = initMouseInteractionObserver(o2);
  const scrollHandler = initScrollObserver(o2);
  const viewportResizeHandler = initViewportResizeObserver(o2, {
    win: currentWindow
  });
  const inputHandler = initInputObserver(o2);
  const mediaInteractionHandler = initMediaInteractionObserver(o2);
  let styleSheetObserver = () => {
  };
  let adoptedStyleSheetObserver = () => {
  };
  let styleDeclarationObserver = () => {
  };
  let fontObserver = () => {
  };
  if (o2.recordDOM) {
    styleSheetObserver = initStyleSheetObserver(o2, { win: currentWindow });
    adoptedStyleSheetObserver = initAdoptedStyleSheetObserver(o2, o2.doc);
    styleDeclarationObserver = initStyleDeclarationObserver(o2, {
      win: currentWindow
    });
    if (o2.collectFonts) {
      fontObserver = initFontObserver(o2);
    }
  }
  const selectionObserver = initSelectionObserver(o2);
  const customElementObserver = initCustomElementObserver(o2);
  const pluginHandlers = [];
  for (const plugin of o2.plugins) {
    pluginHandlers.push(
      plugin.observer(plugin.callback, currentWindow, plugin.options)
    );
  }
  return callbackWrapper(() => {
    mutationBuffers.forEach((b) => b.reset());
    mutationObserver?.disconnect();
    mousemoveHandler();
    mouseInteractionHandler();
    scrollHandler();
    viewportResizeHandler();
    inputHandler();
    mediaInteractionHandler();
    styleSheetObserver();
    adoptedStyleSheetObserver();
    styleDeclarationObserver();
    fontObserver();
    selectionObserver();
    customElementObserver();
    pluginHandlers.forEach((h) => h());
  });
}
function hasNestedCSSRule(prop) {
  return typeof window[prop] !== "undefined";
}
function canMonkeyPatchNestedCSSRule(prop) {
  return Boolean(
    typeof window[prop] !== "undefined" && // Note: Generally, this check _shouldn't_ be necessary
    // However, in some scenarios (e.g. jsdom) this can sometimes fail, so we check for it here
    window[prop].prototype && "insertRule" in window[prop].prototype && "deleteRule" in window[prop].prototype
  );
}
class CrossOriginIframeMirror {
  constructor(generateIdFn) {
    this.generateIdFn = generateIdFn;
    this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
    this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
  }
  getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
    const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
    const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
    let id = idToRemoteIdMap.get(remoteId);
    if (!id) {
      id = this.generateIdFn();
      idToRemoteIdMap.set(remoteId, id);
      remoteIdToIdMap.set(id, remoteId);
    }
    return id;
  }
  getIds(iframe, remoteId) {
    const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
    const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
    return remoteId.map(
      (id) => this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap)
    );
  }
  getRemoteId(iframe, id, map) {
    const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
    if (typeof id !== "number") return id;
    const remoteId = remoteIdToIdMap.get(id);
    if (!remoteId) return -1;
    return remoteId;
  }
  getRemoteIds(iframe, ids) {
    const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
    return ids.map((id) => this.getRemoteId(iframe, id, remoteIdToIdMap));
  }
  reset(iframe) {
    if (!iframe) {
      this.iframeIdToRemoteIdMap = /* @__PURE__ */ new WeakMap();
      this.iframeRemoteIdToIdMap = /* @__PURE__ */ new WeakMap();
      return;
    }
    this.iframeIdToRemoteIdMap.delete(iframe);
    this.iframeRemoteIdToIdMap.delete(iframe);
  }
  getIdToRemoteIdMap(iframe) {
    let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
    if (!idToRemoteIdMap) {
      idToRemoteIdMap = /* @__PURE__ */ new Map();
      this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
    }
    return idToRemoteIdMap;
  }
  getRemoteIdToIdMap(iframe) {
    let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
    if (!remoteIdToIdMap) {
      remoteIdToIdMap = /* @__PURE__ */ new Map();
      this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
    }
    return remoteIdToIdMap;
  }
}
class IframeManagerNoop {
  constructor() {
    this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
    this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
  }
  addIframe() {
  }
  addLoadListener() {
  }
  attachIframe() {
  }
}
class IframeManager {
  constructor(options) {
    this.iframes = /* @__PURE__ */ new WeakMap();
    this.crossOriginIframeMap = /* @__PURE__ */ new WeakMap();
    this.crossOriginIframeMirror = new CrossOriginIframeMirror(genId);
    this.crossOriginIframeRootIdMap = /* @__PURE__ */ new WeakMap();
    this.mutationCb = options.mutationCb;
    this.wrappedEmit = options.wrappedEmit;
    this.stylesheetManager = options.stylesheetManager;
    this.recordCrossOriginIframes = options.recordCrossOriginIframes;
    this.crossOriginIframeStyleMirror = new CrossOriginIframeMirror(
      this.stylesheetManager.styleMirror.generateId.bind(
        this.stylesheetManager.styleMirror
      )
    );
    this.mirror = options.mirror;
    if (this.recordCrossOriginIframes) {
      window.addEventListener("message", this.handleMessage.bind(this));
    }
  }
  addIframe(iframeEl) {
    this.iframes.set(iframeEl, true);
    const contentWindow = getIFrameContentWindow(iframeEl);
    if (contentWindow) this.crossOriginIframeMap.set(contentWindow, iframeEl);
  }
  addLoadListener(cb) {
    this.loadListener = cb;
  }
  attachIframe(iframeEl, childSn) {
    this.mutationCb({
      adds: [
        {
          parentId: this.mirror.getId(iframeEl),
          nextId: null,
          node: childSn
        }
      ],
      removes: [],
      texts: [],
      attributes: [],
      isAttachIframe: true
    });
    if (this.recordCrossOriginIframes) {
      getIFrameContentWindow(iframeEl)?.addEventListener(
        "message",
        this.handleMessage.bind(this)
      );
    }
    this.loadListener?.(iframeEl);
    const iframeDoc = getIFrameContentDocument(iframeEl);
    if (iframeDoc && iframeDoc.adoptedStyleSheets && iframeDoc.adoptedStyleSheets.length > 0)
      this.stylesheetManager.adoptStyleSheets(
        iframeDoc.adoptedStyleSheets,
        this.mirror.getId(iframeDoc)
      );
  }
  handleMessage(message) {
    const crossOriginMessageEvent = message;
    if (crossOriginMessageEvent.data.type !== "rrweb" || // To filter out the rrweb messages which are forwarded by some sites.
    crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin)
      return;
    const iframeSourceWindow = message.source;
    if (!iframeSourceWindow) return;
    const iframeEl = this.crossOriginIframeMap.get(message.source);
    if (!iframeEl) return;
    const transformedEvent = this.transformCrossOriginEvent(
      iframeEl,
      crossOriginMessageEvent.data.event
    );
    if (transformedEvent)
      this.wrappedEmit(
        transformedEvent,
        crossOriginMessageEvent.data.isCheckout
      );
  }
  transformCrossOriginEvent(iframeEl, e2) {
    switch (e2.type) {
      case EventType.FullSnapshot: {
        this.crossOriginIframeMirror.reset(iframeEl);
        this.crossOriginIframeStyleMirror.reset(iframeEl);
        this.replaceIdOnNode(e2.data.node, iframeEl);
        const rootId = e2.data.node.id;
        this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
        this.patchRootIdOnNode(e2.data.node, rootId);
        return {
          timestamp: e2.timestamp,
          type: EventType.IncrementalSnapshot,
          data: {
            source: IncrementalSource.Mutation,
            adds: [
              {
                parentId: this.mirror.getId(iframeEl),
                nextId: null,
                node: e2.data.node
              }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
          }
        };
      }
      case EventType.Meta:
      case EventType.Load:
      case EventType.DomContentLoaded: {
        return false;
      }
      case EventType.Plugin: {
        return e2;
      }
      case EventType.Custom: {
        this.replaceIds(
          e2.data.payload,
          iframeEl,
          ["id", "parentId", "previousId", "nextId"]
        );
        return e2;
      }
      case EventType.IncrementalSnapshot: {
        switch (e2.data.source) {
          case IncrementalSource.Mutation: {
            e2.data.adds.forEach((n2) => {
              this.replaceIds(n2, iframeEl, [
                "parentId",
                "nextId",
                "previousId"
              ]);
              this.replaceIdOnNode(n2.node, iframeEl);
              const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
              rootId && this.patchRootIdOnNode(n2.node, rootId);
            });
            e2.data.removes.forEach((n2) => {
              this.replaceIds(n2, iframeEl, ["parentId", "id"]);
            });
            e2.data.attributes.forEach((n2) => {
              this.replaceIds(n2, iframeEl, ["id"]);
            });
            e2.data.texts.forEach((n2) => {
              this.replaceIds(n2, iframeEl, ["id"]);
            });
            return e2;
          }
          case IncrementalSource.Drag:
          case IncrementalSource.TouchMove:
          case IncrementalSource.MouseMove: {
            e2.data.positions.forEach((p) => {
              this.replaceIds(p, iframeEl, ["id"]);
            });
            return e2;
          }
          case IncrementalSource.ViewportResize: {
            return false;
          }
          case IncrementalSource.MediaInteraction:
          case IncrementalSource.MouseInteraction:
          case IncrementalSource.Scroll:
          case IncrementalSource.CanvasMutation:
          case IncrementalSource.Input: {
            this.replaceIds(e2.data, iframeEl, ["id"]);
            return e2;
          }
          case IncrementalSource.StyleSheetRule:
          case IncrementalSource.StyleDeclaration: {
            this.replaceIds(e2.data, iframeEl, ["id"]);
            this.replaceStyleIds(e2.data, iframeEl, ["styleId"]);
            return e2;
          }
          case IncrementalSource.Font: {
            return e2;
          }
          case IncrementalSource.Selection: {
            e2.data.ranges.forEach((range) => {
              this.replaceIds(range, iframeEl, ["start", "end"]);
            });
            return e2;
          }
          case IncrementalSource.AdoptedStyleSheet: {
            this.replaceIds(e2.data, iframeEl, ["id"]);
            this.replaceStyleIds(e2.data, iframeEl, ["styleIds"]);
            e2.data.styles?.forEach((style) => {
              this.replaceStyleIds(style, iframeEl, ["styleId"]);
            });
            return e2;
          }
        }
      }
    }
    return false;
  }
  replace(iframeMirror, obj, iframeEl, keys) {
    for (const key of keys) {
      if (!Array.isArray(obj[key]) && typeof obj[key] !== "number") continue;
      if (Array.isArray(obj[key])) {
        obj[key] = iframeMirror.getIds(
          iframeEl,
          obj[key]
        );
      } else {
        obj[key] = iframeMirror.getId(iframeEl, obj[key]);
      }
    }
    return obj;
  }
  replaceIds(obj, iframeEl, keys) {
    return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
  }
  replaceStyleIds(obj, iframeEl, keys) {
    return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
  }
  replaceIdOnNode(node, iframeEl) {
    this.replaceIds(node, iframeEl, ["id", "rootId"]);
    if ("childNodes" in node) {
      node.childNodes.forEach((child) => {
        this.replaceIdOnNode(child, iframeEl);
      });
    }
  }
  patchRootIdOnNode(node, rootId) {
    if (node.type !== NodeType$1.Document && !node.rootId) node.rootId = rootId;
    if ("childNodes" in node) {
      node.childNodes.forEach((child) => {
        this.patchRootIdOnNode(child, rootId);
      });
    }
  }
}
class ShadowDomManagerNoop {
  init() {
  }
  addShadowRoot() {
  }
  observeAttachShadow() {
  }
  reset() {
  }
}
class ShadowDomManager {
  constructor(options) {
    this.shadowDoms = /* @__PURE__ */ new WeakSet();
    this.restoreHandlers = [];
    this.mutationCb = options.mutationCb;
    this.scrollCb = options.scrollCb;
    this.bypassOptions = options.bypassOptions;
    this.mirror = options.mirror;
    this.init();
  }
  init() {
    this.reset();
    this.patchAttachShadow(Element, document);
  }
  addShadowRoot(shadowRoot, doc) {
    if (!isNativeShadowDom(shadowRoot)) return;
    if (this.shadowDoms.has(shadowRoot)) return;
    this.shadowDoms.add(shadowRoot);
    this.bypassOptions.canvasManager.addShadowRoot(shadowRoot);
    const observer = initMutationObserver(
      {
        ...this.bypassOptions,
        doc,
        mutationCb: this.mutationCb,
        mirror: this.mirror,
        shadowDomManager: this
      },
      shadowRoot
    );
    this.restoreHandlers.push(() => observer.disconnect());
    this.restoreHandlers.push(
      initScrollObserver({
        ...this.bypassOptions,
        scrollCb: this.scrollCb,
        // https://gist.github.com/praveenpuglia/0832da687ed5a5d7a0907046c9ef1813
        // scroll is not allowed to pass the boundary, so we need to listen the shadow document
        doc: shadowRoot,
        mirror: this.mirror
      })
    );
    setTimeout$2(() => {
      if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0)
        this.bypassOptions.stylesheetManager.adoptStyleSheets(
          shadowRoot.adoptedStyleSheets,
          this.mirror.getId(shadowRoot.host)
        );
      this.restoreHandlers.push(
        initAdoptedStyleSheetObserver(
          {
            mirror: this.mirror,
            stylesheetManager: this.bypassOptions.stylesheetManager
          },
          shadowRoot
        )
      );
    }, 0);
  }
  /**
   * Monkey patch 'attachShadow' of an IFrameElement to observe newly added shadow doms.
   */
  observeAttachShadow(iframeElement) {
    const iframeDoc = getIFrameContentDocument(iframeElement);
    const iframeWindow = getIFrameContentWindow(iframeElement);
    if (!iframeDoc || !iframeWindow) return;
    this.patchAttachShadow(
      iframeWindow.Element,
      iframeDoc
    );
  }
  /**
   * Patch 'attachShadow' to observe newly added shadow doms.
   */
  patchAttachShadow(element, doc) {
    const manager = this;
    this.restoreHandlers.push(
      patch(
        element.prototype,
        "attachShadow",
        function(original) {
          return function(option) {
            const shadowRoot = original.call(this, option);
            if (this.shadowRoot && inDom(this))
              manager.addShadowRoot(this.shadowRoot, doc);
            return shadowRoot;
          };
        }
      )
    );
  }
  reset() {
    this.restoreHandlers.forEach((handler) => {
      try {
        handler();
      } catch (e2) {
      }
    });
    this.restoreHandlers = [];
    this.shadowDoms = /* @__PURE__ */ new WeakSet();
    this.bypassOptions.canvasManager.resetShadowRoots();
  }
}
class StylesheetManager {
  constructor(options) {
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
    this.styleMirror = new StyleSheetMirror();
    this.mutationCb = options.mutationCb;
    this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
  }
  attachLinkElement(linkEl, childSn) {
    if ("_cssText" in childSn.attributes)
      this.mutationCb({
        adds: [],
        removes: [],
        texts: [],
        attributes: [
          {
            id: childSn.id,
            attributes: childSn.attributes
          }
        ]
      });
    this.trackLinkElement(linkEl);
  }
  trackLinkElement(linkEl) {
    if (this.trackedLinkElements.has(linkEl)) return;
    this.trackedLinkElements.add(linkEl);
    this.trackStylesheetInLinkElement(linkEl);
  }
  adoptStyleSheets(sheets, hostId) {
    if (sheets.length === 0) return;
    const adoptedStyleSheetData = {
      id: hostId,
      styleIds: []
    };
    const styles = [];
    for (const sheet of sheets) {
      let styleId;
      if (!this.styleMirror.has(sheet)) {
        styleId = this.styleMirror.add(sheet);
        styles.push({
          styleId,
          rules: Array.from(sheet.rules || CSSRule, (r2, index) => ({
            rule: stringifyRule(r2),
            index
          }))
        });
      } else styleId = this.styleMirror.getId(sheet);
      adoptedStyleSheetData.styleIds.push(styleId);
    }
    if (styles.length > 0) adoptedStyleSheetData.styles = styles;
    this.adoptedStyleSheetCb(adoptedStyleSheetData);
  }
  reset() {
    this.styleMirror.reset();
    this.trackedLinkElements = /* @__PURE__ */ new WeakSet();
  }
  // TODO: take snapshot on stylesheet reload by applying event listener
  trackStylesheetInLinkElement(_linkEl) {
  }
}
class ProcessedNodeManager {
  constructor() {
    this.nodeMap = /* @__PURE__ */ new WeakMap();
    this.active = false;
  }
  inOtherBuffer(node, thisBuffer) {
    const buffers = this.nodeMap.get(node);
    return buffers && Array.from(buffers).some((buffer) => buffer !== thisBuffer);
  }
  add(node, buffer) {
    if (!this.active) {
      this.active = true;
      onRequestAnimationFrame(() => {
        this.nodeMap = /* @__PURE__ */ new WeakMap();
        this.active = false;
      });
    }
    this.nodeMap.set(node, (this.nodeMap.get(node) || /* @__PURE__ */ new Set()).add(buffer));
  }
  destroy() {
  }
}
let wrappedEmit;
let _takeFullSnapshot;
try {
  if (Array.from([1], (x) => x * 2)[0] !== 2) {
    const cleanFrame = document.createElement("iframe");
    document.body.appendChild(cleanFrame);
    Array.from = cleanFrame.contentWindow?.Array.from || Array.from;
    document.body.removeChild(cleanFrame);
  }
} catch (err) {
  console.debug("Unable to override Array.from", err);
}
const mirror = createMirror();
function record(options = {}) {
  const {
    emit,
    checkoutEveryNms,
    checkoutEveryNth,
    blockClass = "rr-block",
    blockSelector = null,
    unblockSelector = null,
    ignoreClass = "rr-ignore",
    ignoreSelector = null,
    maskAllText = false,
    maskTextClass = "rr-mask",
    unmaskTextClass = null,
    maskTextSelector = null,
    unmaskTextSelector = null,
    inlineStylesheet = true,
    maskAllInputs,
    maskInputOptions: _maskInputOptions,
    slimDOMOptions: _slimDOMOptions,
    maskAttributeFn,
    maskInputFn,
    maskTextFn,
    maxCanvasSize = null,
    packFn,
    sampling = {},
    dataURLOptions = {},
    mousemoveWait,
    recordDOM = true,
    recordCanvas = false,
    recordCrossOriginIframes = false,
    recordAfter = options.recordAfter === "DOMContentLoaded" ? options.recordAfter : "load",
    userTriggeredOnInput = false,
    collectFonts = false,
    inlineImages = false,
    plugins,
    keepIframeSrcFn = () => false,
    ignoreCSSAttributes = /* @__PURE__ */ new Set([]),
    errorHandler: errorHandler2,
    onMutation,
    getCanvasManager
  } = options;
  registerErrorHandler(errorHandler2);
  const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
  let passEmitsToParent = false;
  if (!inEmittingFrame) {
    try {
      if (window.parent.document) {
        passEmitsToParent = false;
      }
    } catch (e2) {
      passEmitsToParent = true;
    }
  }
  if (inEmittingFrame && !emit) {
    throw new Error("emit function is required");
  }
  if (!inEmittingFrame && !passEmitsToParent) {
    return () => {
    };
  }
  if (mousemoveWait !== void 0 && sampling.mousemove === void 0) {
    sampling.mousemove = mousemoveWait;
  }
  mirror.reset();
  const maskInputOptions = maskAllInputs === true ? {
    color: true,
    date: true,
    "datetime-local": true,
    email: true,
    month: true,
    number: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true,
    textarea: true,
    select: true,
    radio: true,
    checkbox: true
  } : _maskInputOptions !== void 0 ? _maskInputOptions : {};
  const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === "all" ? {
    script: true,
    comment: true,
    headFavicon: true,
    headWhitespace: true,
    headMetaSocial: true,
    headMetaRobots: true,
    headMetaHttpEquiv: true,
    headMetaVerification: true,
    // the following are off for slimDOMOptions === true,
    // as they destroy some (hidden) info:
    headMetaAuthorship: _slimDOMOptions === "all",
    headMetaDescKeywords: _slimDOMOptions === "all"
  } : _slimDOMOptions ? _slimDOMOptions : {};
  polyfill();
  let lastFullSnapshotEvent;
  let incrementalSnapshotCount = 0;
  const eventProcessor = (e2) => {
    for (const plugin of plugins || []) {
      if (plugin.eventProcessor) {
        e2 = plugin.eventProcessor(e2);
      }
    }
    if (packFn && // Disable packing events which will be emitted to parent frames.
    !passEmitsToParent) {
      e2 = packFn(e2);
    }
    return e2;
  };
  wrappedEmit = (r2, isCheckout) => {
    const e2 = r2;
    e2.timestamp = nowTimestamp();
    if (mutationBuffers[0]?.isFrozen() && e2.type !== EventType.FullSnapshot && !(e2.type === EventType.IncrementalSnapshot && e2.data.source === IncrementalSource.Mutation)) {
      mutationBuffers.forEach((buf) => buf.unfreeze());
    }
    if (inEmittingFrame) {
      emit?.(eventProcessor(e2), isCheckout);
    } else if (passEmitsToParent) {
      const message = {
        type: "rrweb",
        event: eventProcessor(e2),
        origin: window.location.origin,
        isCheckout
      };
      window.parent.postMessage(message, "*");
    }
    if (e2.type === EventType.FullSnapshot) {
      lastFullSnapshotEvent = e2;
      incrementalSnapshotCount = 0;
    } else if (e2.type === EventType.IncrementalSnapshot) {
      if (e2.data.source === IncrementalSource.Mutation && e2.data.isAttachIframe) {
        return;
      }
      incrementalSnapshotCount++;
      const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
      const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e2.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
      if (exceedCount || exceedTime) {
        takeFullSnapshot2(true);
      }
    }
  };
  const wrappedMutationEmit = (m) => {
    wrappedEmit({
      type: EventType.IncrementalSnapshot,
      data: {
        source: IncrementalSource.Mutation,
        ...m
      }
    });
  };
  const wrappedScrollEmit = (p) => wrappedEmit({
    type: EventType.IncrementalSnapshot,
    data: {
      source: IncrementalSource.Scroll,
      ...p
    }
  });
  const wrappedCanvasMutationEmit = (p) => wrappedEmit({
    type: EventType.IncrementalSnapshot,
    data: {
      source: IncrementalSource.CanvasMutation,
      ...p
    }
  });
  const wrappedAdoptedStyleSheetEmit = (a2) => wrappedEmit({
    type: EventType.IncrementalSnapshot,
    data: {
      source: IncrementalSource.AdoptedStyleSheet,
      ...a2
    }
  });
  const stylesheetManager = new StylesheetManager({
    mutationCb: wrappedMutationEmit,
    adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
  });
  const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === "boolean" && __RRWEB_EXCLUDE_IFRAME__ ? new IframeManagerNoop() : new IframeManager({
    mirror,
    mutationCb: wrappedMutationEmit,
    stylesheetManager,
    recordCrossOriginIframes,
    wrappedEmit
  });
  for (const plugin of plugins || []) {
    if (plugin.getMirror)
      plugin.getMirror({
        nodeMirror: mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
      });
  }
  const processedNodeManager = new ProcessedNodeManager();
  const canvasManager = _getCanvasManager(
    getCanvasManager,
    {
      mirror,
      win: window,
      mutationCb: (p) => wrappedEmit({
        type: EventType.IncrementalSnapshot,
        data: {
          source: IncrementalSource.CanvasMutation,
          ...p
        }
      }),
      recordCanvas,
      blockClass,
      blockSelector,
      unblockSelector,
      maxCanvasSize,
      sampling: sampling["canvas"],
      dataURLOptions,
      errorHandler: errorHandler2
    }
  );
  const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === "boolean" && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new ShadowDomManagerNoop() : new ShadowDomManager({
    mutationCb: wrappedMutationEmit,
    scrollCb: wrappedScrollEmit,
    bypassOptions: {
      onMutation,
      blockClass,
      blockSelector,
      unblockSelector,
      maskAllText,
      maskTextClass,
      unmaskTextClass,
      maskTextSelector,
      unmaskTextSelector,
      inlineStylesheet,
      maskInputOptions,
      dataURLOptions,
      maskAttributeFn,
      maskTextFn,
      maskInputFn,
      recordCanvas,
      inlineImages,
      sampling,
      slimDOMOptions,
      iframeManager,
      stylesheetManager,
      canvasManager,
      keepIframeSrcFn,
      processedNodeManager,
      ignoreCSSAttributes
    },
    mirror
  });
  const takeFullSnapshot2 = (isCheckout = false) => {
    if (!recordDOM) {
      return;
    }
    wrappedEmit(
      {
        type: EventType.Meta,
        data: {
          href: window.location.href,
          width: getWindowWidth(),
          height: getWindowHeight()
        }
      },
      isCheckout
    );
    stylesheetManager.reset();
    shadowDomManager.init();
    mutationBuffers.forEach((buf) => buf.lock());
    const node = snapshot(document, {
      mirror,
      blockClass,
      blockSelector,
      unblockSelector,
      maskAllText,
      maskTextClass,
      unmaskTextClass,
      maskTextSelector,
      unmaskTextSelector,
      inlineStylesheet,
      maskAllInputs: maskInputOptions,
      maskAttributeFn,
      maskInputFn,
      maskTextFn,
      slimDOM: slimDOMOptions,
      dataURLOptions,
      recordCanvas,
      inlineImages,
      onSerialize: (n2) => {
        if (isSerializedIframe(n2, mirror)) {
          iframeManager.addIframe(n2);
        }
        if (isSerializedStylesheet(n2, mirror)) {
          stylesheetManager.trackLinkElement(n2);
        }
        if (hasShadowRoot(n2)) {
          shadowDomManager.addShadowRoot(n2.shadowRoot, document);
        }
      },
      onIframeLoad: (iframe, childSn) => {
        iframeManager.attachIframe(iframe, childSn);
        const contentWindow = getIFrameContentWindow(iframe);
        if (contentWindow) {
          canvasManager.addWindow(contentWindow);
        }
        shadowDomManager.observeAttachShadow(iframe);
      },
      onStylesheetLoad: (linkEl, childSn) => {
        stylesheetManager.attachLinkElement(linkEl, childSn);
      },
      onBlockedImageLoad: (_imageEl, serializedNode, { width, height }) => {
        wrappedMutationEmit({
          adds: [],
          removes: [],
          texts: [],
          attributes: [
            {
              id: serializedNode.id,
              attributes: {
                style: {
                  width: `${width}px`,
                  height: `${height}px`
                }
              }
            }
          ]
        });
      },
      keepIframeSrcFn,
      ignoreCSSAttributes
    });
    if (!node) {
      return console.warn("Failed to snapshot the document");
    }
    wrappedEmit({
      type: EventType.FullSnapshot,
      data: {
        node,
        initialOffset: getWindowScroll(window)
      }
    });
    mutationBuffers.forEach((buf) => buf.unlock());
    if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0)
      stylesheetManager.adoptStyleSheets(
        document.adoptedStyleSheets,
        mirror.getId(document)
      );
  };
  _takeFullSnapshot = takeFullSnapshot2;
  try {
    const handlers2 = [];
    const observe = (doc) => {
      return callbackWrapper(initObservers)(
        {
          onMutation,
          mutationCb: wrappedMutationEmit,
          mousemoveCb: (positions, source) => wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
              source,
              positions
            }
          }),
          mouseInteractionCb: (d) => wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
              source: IncrementalSource.MouseInteraction,
              ...d
            }
          }),
          scrollCb: wrappedScrollEmit,
          viewportResizeCb: (d) => wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
              source: IncrementalSource.ViewportResize,
              ...d
            }
          }),
          inputCb: (v2) => wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
              source: IncrementalSource.Input,
              ...v2
            }
          }),
          mediaInteractionCb: (p) => wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
              source: IncrementalSource.MediaInteraction,
              ...p
            }
          }),
          styleSheetRuleCb: (r2) => wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
              source: IncrementalSource.StyleSheetRule,
              ...r2
            }
          }),
          styleDeclarationCb: (r2) => wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
              source: IncrementalSource.StyleDeclaration,
              ...r2
            }
          }),
          canvasMutationCb: wrappedCanvasMutationEmit,
          fontCb: (p) => wrappedEmit({
            type: EventType.IncrementalSnapshot,
            data: {
              source: IncrementalSource.Font,
              ...p
            }
          }),
          selectionCb: (p) => {
            wrappedEmit({
              type: EventType.IncrementalSnapshot,
              data: {
                source: IncrementalSource.Selection,
                ...p
              }
            });
          },
          customElementCb: (c2) => {
            wrappedEmit({
              type: EventType.IncrementalSnapshot,
              data: {
                source: IncrementalSource.CustomElement,
                ...c2
              }
            });
          },
          blockClass,
          ignoreClass,
          ignoreSelector,
          maskAllText,
          maskTextClass,
          unmaskTextClass,
          maskTextSelector,
          unmaskTextSelector,
          maskInputOptions,
          inlineStylesheet,
          sampling,
          recordDOM,
          recordCanvas,
          inlineImages,
          userTriggeredOnInput,
          collectFonts,
          doc,
          maskAttributeFn,
          maskInputFn,
          maskTextFn,
          keepIframeSrcFn,
          blockSelector,
          unblockSelector,
          slimDOMOptions,
          dataURLOptions,
          mirror,
          iframeManager,
          stylesheetManager,
          shadowDomManager,
          processedNodeManager,
          canvasManager,
          ignoreCSSAttributes,
          plugins: plugins?.filter((p) => p.observer)?.map((p) => ({
            observer: p.observer,
            options: p.options,
            callback: (payload) => wrappedEmit({
              type: EventType.Plugin,
              data: {
                plugin: p.name,
                payload
              }
            })
          })) || []
        },
        {}
      );
    };
    iframeManager.addLoadListener((iframeEl) => {
      try {
        handlers2.push(observe(iframeEl.contentDocument));
      } catch (error) {
        console.warn(error);
      }
    });
    const init = () => {
      takeFullSnapshot2();
      handlers2.push(observe(document));
    };
    if (document.readyState === "interactive" || document.readyState === "complete") {
      init();
    } else {
      handlers2.push(
        on("DOMContentLoaded", () => {
          wrappedEmit({
            type: EventType.DomContentLoaded,
            data: {}
          });
          if (recordAfter === "DOMContentLoaded") init();
        })
      );
      handlers2.push(
        on(
          "load",
          () => {
            wrappedEmit({
              type: EventType.Load,
              data: {}
            });
            if (recordAfter === "load") init();
          },
          window
        )
      );
    }
    return () => {
      handlers2.forEach((h) => h());
      processedNodeManager.destroy();
      _takeFullSnapshot = void 0;
      unregisterErrorHandler();
    };
  } catch (error) {
    console.warn(error);
  }
}
function takeFullSnapshot(isCheckout) {
  if (!_takeFullSnapshot) {
    throw new Error("please take full snapshot after start recording");
  }
  _takeFullSnapshot(isCheckout);
}
record.mirror = mirror;
record.takeFullSnapshot = takeFullSnapshot;
function _getCanvasManager(getCanvasManagerFn, options) {
  try {
    return getCanvasManagerFn ? getCanvasManagerFn(options) : new CanvasManagerNoop();
  } catch {
    console.warn("Unable to initialize CanvasManager");
    return new CanvasManagerNoop();
  }
}
var n;
!(function(t2) {
  t2[t2.NotStarted = 0] = "NotStarted", t2[t2.Running = 1] = "Running", t2[t2.Stopped = 2] = "Stopped";
})(n || (n = {}));
const ReplayEventTypeIncrementalSnapshot = 3;
const ReplayEventTypeCustom = 5;
function timestampToMs(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp : timestamp * 1e3;
}
function timestampToS(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp / 1e3 : timestamp;
}
function addBreadcrumbEvent(replay, breadcrumb) {
  if (breadcrumb.category === "sentry.transaction") {
    return;
  }
  if (["ui.click", "ui.input"].includes(breadcrumb.category)) {
    replay.triggerUserActivity();
  } else {
    replay.checkAndHandleExpiredSession();
  }
  replay.addUpdate(() => {
    replay.throttledAddEvent({
      type: EventType.Custom,
      // TODO: We were converting from ms to seconds for breadcrumbs, spans,
      // but maybe we should just keep them as milliseconds
      timestamp: (breadcrumb.timestamp || 0) * 1e3,
      data: {
        tag: "breadcrumb",
        // normalize to max. 10 depth and 1_000 properties per object
        payload: (0,normalize/* normalize */.S8)(breadcrumb, 10, 1e3)
      }
    });
    return breadcrumb.category === "console";
  });
}
const INTERACTIVE_SELECTOR = "button,a";
function getClosestInteractive(element) {
  const closestInteractive = element.closest(INTERACTIVE_SELECTOR);
  return closestInteractive || element;
}
function getClickTargetNode(event) {
  const target = getTargetNode(event);
  if (!target || !(target instanceof Element)) {
    return target;
  }
  return getClosestInteractive(target);
}
function getTargetNode(event) {
  if (isEventWithTarget(event)) {
    return event.target;
  }
  return event;
}
function isEventWithTarget(event) {
  return typeof event === "object" && !!event && "target" in event;
}
let handlers;
function onWindowOpen(cb) {
  if (!handlers) {
    handlers = [];
    monkeyPatchWindowOpen();
  }
  handlers.push(cb);
  return () => {
    const pos = handlers ? handlers.indexOf(cb) : -1;
    if (pos > -1) {
      handlers.splice(pos, 1);
    }
  };
}
function monkeyPatchWindowOpen() {
  (0,object/* fill */.GS)(WINDOW, "open", function(originalWindowOpen) {
    return function(...args) {
      if (handlers) {
        try {
          handlers.forEach((handler) => handler());
        } catch {
        }
      }
      return originalWindowOpen.apply(WINDOW, args);
    };
  });
}
const IncrementalMutationSources = /* @__PURE__ */ new Set([
  IncrementalSource.Mutation,
  IncrementalSource.StyleSheetRule,
  IncrementalSource.StyleDeclaration,
  IncrementalSource.AdoptedStyleSheet,
  IncrementalSource.CanvasMutation,
  IncrementalSource.Selection,
  IncrementalSource.MediaInteraction
]);
function handleClick(clickDetector, clickBreadcrumb, node) {
  clickDetector.handleClick(clickBreadcrumb, node);
}
class ClickDetector {
  constructor(replay, slowClickConfig, _addBreadcrumbEvent = addBreadcrumbEvent) {
    this._lastMutation = 0;
    this._lastScroll = 0;
    this._clicks = [];
    this._timeout = slowClickConfig.timeout / 1e3;
    this._threshold = slowClickConfig.threshold / 1e3;
    this._scrollTimeout = slowClickConfig.scrollTimeout / 1e3;
    this._replay = replay;
    this._ignoreSelector = slowClickConfig.ignoreSelector;
    this._addBreadcrumbEvent = _addBreadcrumbEvent;
  }
  /** Register click detection handlers on mutation or scroll. */
  addListeners() {
    const cleanupWindowOpen = onWindowOpen(() => {
      this._lastMutation = nowInSeconds();
    });
    this._teardown = () => {
      cleanupWindowOpen();
      this._clicks = [];
      this._lastMutation = 0;
      this._lastScroll = 0;
    };
  }
  /** Clean up listeners. */
  removeListeners() {
    if (this._teardown) {
      this._teardown();
    }
    if (this._checkClickTimeout) {
      clearTimeout(this._checkClickTimeout);
    }
  }
  /** @inheritDoc */
  handleClick(breadcrumb, node) {
    if (ignoreElement(node, this._ignoreSelector) || !isClickBreadcrumb(breadcrumb)) {
      return;
    }
    const newClick = {
      timestamp: timestampToS(breadcrumb.timestamp),
      clickBreadcrumb: breadcrumb,
      // Set this to 0 so we know it originates from the click breadcrumb
      clickCount: 0,
      node
    };
    if (this._clicks.some((click) => click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) {
      return;
    }
    this._clicks.push(newClick);
    if (this._clicks.length === 1) {
      this._scheduleCheckClicks();
    }
  }
  /** @inheritDoc */
  registerMutation(timestamp = Date.now()) {
    this._lastMutation = timestampToS(timestamp);
  }
  /** @inheritDoc */
  registerScroll(timestamp = Date.now()) {
    this._lastScroll = timestampToS(timestamp);
  }
  /** @inheritDoc */
  registerClick(element) {
    const node = getClosestInteractive(element);
    this._handleMultiClick(node);
  }
  /** Count multiple clicks on elements. */
  _handleMultiClick(node) {
    this._getClicks(node).forEach((click) => {
      click.clickCount++;
    });
  }
  /** Get all pending clicks for a given node. */
  _getClicks(node) {
    return this._clicks.filter((click) => click.node === node);
  }
  /** Check the clicks that happened. */
  _checkClicks() {
    const timedOutClicks = [];
    const now = nowInSeconds();
    this._clicks.forEach((click) => {
      if (!click.mutationAfter && this._lastMutation) {
        click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : void 0;
      }
      if (!click.scrollAfter && this._lastScroll) {
        click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : void 0;
      }
      if (click.timestamp + this._timeout <= now) {
        timedOutClicks.push(click);
      }
    });
    for (const click of timedOutClicks) {
      const pos = this._clicks.indexOf(click);
      if (pos > -1) {
        this._generateBreadcrumbs(click);
        this._clicks.splice(pos, 1);
      }
    }
    if (this._clicks.length) {
      this._scheduleCheckClicks();
    }
  }
  /** Generate matching breadcrumb(s) for the click. */
  _generateBreadcrumbs(click) {
    const replay = this._replay;
    const hadScroll = click.scrollAfter && click.scrollAfter <= this._scrollTimeout;
    const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
    const isSlowClick = !hadScroll && !hadMutation;
    const { clickCount, clickBreadcrumb } = click;
    if (isSlowClick) {
      const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1e3;
      const endReason = timeAfterClickMs < this._timeout * 1e3 ? "mutation" : "timeout";
      const breadcrumb = {
        type: "default",
        message: clickBreadcrumb.message,
        timestamp: clickBreadcrumb.timestamp,
        category: "ui.slowClickDetected",
        data: {
          ...clickBreadcrumb.data,
          url: WINDOW.location.href,
          route: replay.getCurrentRoute(),
          timeAfterClickMs,
          endReason,
          // If clickCount === 0, it means multiClick was not correctly captured here
          // - we still want to send 1 in this case
          clickCount: clickCount || 1
        }
      };
      this._addBreadcrumbEvent(replay, breadcrumb);
      return;
    }
    if (clickCount > 1) {
      const breadcrumb = {
        type: "default",
        message: clickBreadcrumb.message,
        timestamp: clickBreadcrumb.timestamp,
        category: "ui.multiClick",
        data: {
          ...clickBreadcrumb.data,
          url: WINDOW.location.href,
          route: replay.getCurrentRoute(),
          clickCount,
          metric: true
        }
      };
      this._addBreadcrumbEvent(replay, breadcrumb);
    }
  }
  /** Schedule to check current clicks. */
  _scheduleCheckClicks() {
    if (this._checkClickTimeout) {
      clearTimeout(this._checkClickTimeout);
    }
    this._checkClickTimeout = (0,getNativeImplementation/* setTimeout */.wg)(() => this._checkClicks(), 1e3);
  }
}
const SLOW_CLICK_TAGS = ["A", "BUTTON", "INPUT"];
function ignoreElement(node, ignoreSelector) {
  if (!SLOW_CLICK_TAGS.includes(node.tagName)) {
    return true;
  }
  if (node.tagName === "INPUT" && !["submit", "button"].includes(node.getAttribute("type") || "")) {
    return true;
  }
  if (node.tagName === "A" && (node.hasAttribute("download") || node.hasAttribute("target") && node.getAttribute("target") !== "_self")) {
    return true;
  }
  if (ignoreSelector && node.matches(ignoreSelector)) {
    return true;
  }
  return false;
}
function isClickBreadcrumb(breadcrumb) {
  return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === "number" && breadcrumb.timestamp);
}
function nowInSeconds() {
  return Date.now() / 1e3;
}
function updateClickDetectorForRecordingEvent(clickDetector, event) {
  try {
    if (!isIncrementalEvent(event)) {
      return;
    }
    const { source } = event.data;
    if (IncrementalMutationSources.has(source)) {
      clickDetector.registerMutation(event.timestamp);
    }
    if (source === IncrementalSource.Scroll) {
      clickDetector.registerScroll(event.timestamp);
    }
    if (isIncrementalMouseInteraction(event)) {
      const { type, id } = event.data;
      const node = record.mirror.getNode(id);
      if (node instanceof HTMLElement && type === MouseInteractions.Click) {
        clickDetector.registerClick(node);
      }
    }
  } catch {
  }
}
function isIncrementalEvent(event) {
  return event.type === ReplayEventTypeIncrementalSnapshot;
}
function isIncrementalMouseInteraction(event) {
  return event.data.source === IncrementalSource.MouseInteraction;
}
function createBreadcrumb(breadcrumb) {
  return {
    timestamp: Date.now() / 1e3,
    type: "default",
    ...breadcrumb
  };
}
var NodeType = /* @__PURE__ */ ((NodeType2) => {
  NodeType2[NodeType2["Document"] = 0] = "Document";
  NodeType2[NodeType2["DocumentType"] = 1] = "DocumentType";
  NodeType2[NodeType2["Element"] = 2] = "Element";
  NodeType2[NodeType2["Text"] = 3] = "Text";
  NodeType2[NodeType2["CDATA"] = 4] = "CDATA";
  NodeType2[NodeType2["Comment"] = 5] = "Comment";
  return NodeType2;
})(NodeType || {});
const ATTRIBUTES_TO_RECORD = /* @__PURE__ */ new Set([
  "id",
  "class",
  "aria-label",
  "role",
  "name",
  "alt",
  "title",
  "data-test-id",
  "data-testid",
  "disabled",
  "aria-disabled",
  "data-sentry-component"
]);
function getAttributesToRecord(attributes) {
  const obj = {};
  if (!attributes["data-sentry-component"] && attributes["data-sentry-element"]) {
    attributes["data-sentry-component"] = attributes["data-sentry-element"];
  }
  for (const key in attributes) {
    if (ATTRIBUTES_TO_RECORD.has(key)) {
      let normalizedKey = key;
      if (key === "data-testid" || key === "data-test-id") {
        normalizedKey = "testId";
      }
      obj[normalizedKey] = attributes[key];
    }
  }
  return obj;
}
const handleDomListener = (replay) => {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }
    const result = handleDom(handlerData);
    if (!result) {
      return;
    }
    const isClick = handlerData.name === "click";
    const event = isClick ? handlerData.event : void 0;
    if (isClick && replay.clickDetector && event?.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      handleClick(
        replay.clickDetector,
        result,
        getClickTargetNode(handlerData.event)
      );
    }
    addBreadcrumbEvent(replay, result);
  };
};
function getBaseDomBreadcrumb(target, message) {
  const nodeId = record.mirror.getId(target);
  const node = nodeId && record.mirror.getNode(nodeId);
  const meta = node && record.mirror.getMeta(node);
  const element = meta && isElement(meta) ? meta : null;
  return {
    message,
    data: element ? {
      nodeId,
      node: {
        id: nodeId,
        tagName: element.tagName,
        textContent: Array.from(element.childNodes).map((node2) => node2.type === NodeType.Text && node2.textContent).filter(Boolean).map((text) => text.trim()).join(""),
        attributes: getAttributesToRecord(element.attributes)
      }
    } : {}
  };
}
function handleDom(handlerData) {
  const { target, message } = getDomTarget(handlerData);
  return createBreadcrumb({
    category: `ui.${handlerData.name}`,
    ...getBaseDomBreadcrumb(target, message)
  });
}
function getDomTarget(handlerData) {
  const isClick = handlerData.name === "click";
  let message;
  let target = null;
  try {
    target = isClick ? getClickTargetNode(handlerData.event) : getTargetNode(handlerData.event);
    message = (0,htmlTreeAsString/* htmlTreeAsString */.H)(target, { maxStringLength: 200 }) || "<unknown>";
  } catch {
    message = "<unknown>";
  }
  return { target, message };
}
function isElement(node) {
  return node.type === NodeType.Element;
}
function handleKeyboardEvent(replay, event) {
  if (!replay.isEnabled()) {
    return;
  }
  replay.updateUserActivity();
  const breadcrumb = getKeyboardBreadcrumb(event);
  if (!breadcrumb) {
    return;
  }
  addBreadcrumbEvent(replay, breadcrumb);
}
function getKeyboardBreadcrumb(event) {
  const { metaKey, shiftKey, ctrlKey, altKey, key, target } = event;
  if (!target || isInputElement(target) || !key) {
    return null;
  }
  const hasModifierKey = metaKey || ctrlKey || altKey;
  const isCharacterKey = key.length === 1;
  if (!hasModifierKey && isCharacterKey) {
    return null;
  }
  const message = (0,htmlTreeAsString/* htmlTreeAsString */.H)(target, { maxStringLength: 200 }) || "<unknown>";
  const baseBreadcrumb = getBaseDomBreadcrumb(target, message);
  return createBreadcrumb({
    category: "ui.keyDown",
    message,
    data: {
      ...baseBreadcrumb.data,
      metaKey,
      shiftKey,
      ctrlKey,
      altKey,
      key
    }
  });
}
function isInputElement(target) {
  return target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable;
}
const ENTRY_TYPES = {
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  resource: createResourceEntry,
  paint: createPaintEntry,
  // @ts-expect-error TODO: entry type does not fit the create* functions entry type
  navigation: createNavigationEntry
};
function webVitalHandler(getter, replay) {
  return ({ metric }) => void replay.replayPerformanceEntries.push(getter(metric));
}
function createPerformanceEntries(entries) {
  return entries.map(createPerformanceEntry).filter(Boolean);
}
function createPerformanceEntry(entry) {
  const entryType = ENTRY_TYPES[entry.entryType];
  if (!entryType) {
    return null;
  }
  return entryType(entry);
}
function getAbsoluteTime(time) {
  return (((0,utils_time/* browserPerformanceTimeOrigin */.k3)() || WINDOW.performance.timeOrigin) + time) / 1e3;
}
function createPaintEntry(entry) {
  const { duration, entryType, name, startTime } = entry;
  const start = getAbsoluteTime(startTime);
  return {
    type: entryType,
    name,
    start,
    end: start + duration,
    data: void 0
  };
}
function createNavigationEntry(entry) {
  const {
    entryType,
    name,
    decodedBodySize,
    duration,
    domComplete,
    encodedBodySize,
    domContentLoadedEventStart,
    domContentLoadedEventEnd,
    domInteractive,
    loadEventStart,
    loadEventEnd,
    redirectCount,
    startTime,
    transferSize,
    type
  } = entry;
  if (duration === 0) {
    return null;
  }
  return {
    type: `${entryType}.${type}`,
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(domComplete),
    name,
    data: {
      size: transferSize,
      decodedBodySize,
      encodedBodySize,
      duration,
      domInteractive,
      domContentLoadedEventStart,
      domContentLoadedEventEnd,
      loadEventStart,
      loadEventEnd,
      domComplete,
      redirectCount
    }
  };
}
function createResourceEntry(entry) {
  const {
    entryType,
    initiatorType,
    name,
    responseEnd,
    startTime,
    decodedBodySize,
    encodedBodySize,
    responseStatus,
    transferSize
  } = entry;
  if (["fetch", "xmlhttprequest"].includes(initiatorType)) {
    return null;
  }
  return {
    type: `${entryType}.${initiatorType}`,
    start: getAbsoluteTime(startTime),
    end: getAbsoluteTime(responseEnd),
    name,
    data: {
      size: transferSize,
      statusCode: responseStatus,
      decodedBodySize,
      encodedBodySize
    }
  };
}
function getLargestContentfulPaint(metric) {
  const lastEntry = metric.entries[metric.entries.length - 1];
  const node = lastEntry?.element ? [lastEntry.element] : void 0;
  return getWebVital(metric, "largest-contentful-paint", node);
}
function isLayoutShift(entry) {
  return entry.sources !== void 0;
}
function getCumulativeLayoutShift(metric) {
  const layoutShifts = [];
  const nodes = [];
  for (const entry of metric.entries) {
    if (isLayoutShift(entry)) {
      const nodeIds = [];
      for (const source of entry.sources) {
        if (source.node) {
          nodes.push(source.node);
          const nodeId = record.mirror.getId(source.node);
          if (nodeId) {
            nodeIds.push(nodeId);
          }
        }
      }
      layoutShifts.push({ value: entry.value, nodeIds: nodeIds.length ? nodeIds : void 0 });
    }
  }
  return getWebVital(metric, "cumulative-layout-shift", nodes, layoutShifts);
}
function getInteractionToNextPaint(metric) {
  const lastEntry = metric.entries[metric.entries.length - 1];
  const node = lastEntry?.target ? [lastEntry.target] : void 0;
  return getWebVital(metric, "interaction-to-next-paint", node);
}
function getWebVital(metric, name, nodes, attributions) {
  const value = metric.value;
  const rating = metric.rating;
  const end = getAbsoluteTime(value);
  return {
    type: "web-vital",
    name,
    start: end,
    end,
    data: {
      value,
      size: value,
      rating,
      nodeIds: nodes ? nodes.map((node) => record.mirror.getId(node)) : void 0,
      attributions
    }
  };
}
function setupPerformanceObserver(replay) {
  function addPerformanceEntry(entry) {
    if (!replay.performanceEntries.includes(entry)) {
      replay.performanceEntries.push(entry);
    }
  }
  function onEntries({ entries }) {
    entries.forEach(addPerformanceEntry);
  }
  const clearCallbacks = [];
  ["navigation", "paint", "resource"].forEach((type) => {
    clearCallbacks.push((0,instrument/* addPerformanceInstrumentationHandler */.wv)(type, onEntries));
  });
  clearCallbacks.push(
    (0,instrument/* addLcpInstrumentationHandler */.Pt)(webVitalHandler(getLargestContentfulPaint, replay)),
    (0,instrument/* addClsInstrumentationHandler */.a9)(webVitalHandler(getCumulativeLayoutShift, replay)),
    (0,instrument/* addInpInstrumentationHandler */.hT)(webVitalHandler(getInteractionToNextPaint, replay))
  );
  return () => {
    clearCallbacks.forEach((clearCallback) => clearCallback());
  };
}
const DEBUG_BUILD = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;
const r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function e() {
  const e2 = new Blob([r]);
  return URL.createObjectURL(e2);
}
const CONSOLE_LEVELS = ["log", "warn", "error"];
const PREFIX = "[Replay] ";
function _addBreadcrumb(message, level = "info") {
  (0,breadcrumbs/* addBreadcrumb */.Z)(
    {
      category: "console",
      data: {
        logger: "replay"
      },
      level,
      message: `${PREFIX}${message}`
    },
    { level }
  );
}
function makeReplayDebugLogger() {
  let _capture = false;
  let _trace = false;
  const _debug = {
    exception: () => void 0,
    infoTick: () => void 0,
    setConfig: (opts) => {
      _capture = !!opts.captureExceptions;
      _trace = !!opts.traceInternals;
    }
  };
  if (DEBUG_BUILD) {
    CONSOLE_LEVELS.forEach((name) => {
      _debug[name] = (...args) => {
        debug_logger/* debug */.Yz[name](PREFIX, ...args);
        if (_trace) {
          _addBreadcrumb(args.join(""), (0,severity/* severityLevelFromString */.t)(name));
        }
      };
    });
    _debug.exception = (error, ...message) => {
      if (message.length && _debug.error) {
        _debug.error(...message);
      }
      debug_logger/* debug */.Yz.error(PREFIX, error);
      if (_capture) {
        (0,esm_exports/* captureException */.Cp)(error, {
          mechanism: {
            handled: true,
            type: "auto.function.replay.debug"
          }
        });
      } else if (_trace) {
        _addBreadcrumb(error, "error");
      }
    };
    _debug.infoTick = (...args) => {
      debug_logger/* debug */.Yz.log(PREFIX, ...args);
      if (_trace) {
        setTimeout(() => _addBreadcrumb(args[0]), 0);
      }
    };
  } else {
    CONSOLE_LEVELS.forEach((name) => {
      _debug[name] = () => void 0;
    });
  }
  return _debug;
}
const debug = makeReplayDebugLogger();
class EventBufferSizeExceededError extends Error {
  constructor() {
    super(`Event buffer exceeded maximum size of ${REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
  }
}
class EventBufferArray {
  constructor() {
    this.events = [];
    this._totalSize = 0;
    this.hasCheckout = false;
    this.waitForCheckout = false;
  }
  /** @inheritdoc */
  get hasEvents() {
    return this.events.length > 0;
  }
  /** @inheritdoc */
  get type() {
    return "sync";
  }
  /** @inheritdoc */
  destroy() {
    this.events = [];
  }
  /** @inheritdoc */
  async addEvent(event) {
    const eventSize = JSON.stringify(event).length;
    this._totalSize += eventSize;
    if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
      throw new EventBufferSizeExceededError();
    }
    this.events.push(event);
  }
  /** @inheritdoc */
  finish() {
    return new Promise((resolve) => {
      const eventsRet = this.events;
      this.clear();
      resolve(JSON.stringify(eventsRet));
    });
  }
  /** @inheritdoc */
  clear() {
    this.events = [];
    this._totalSize = 0;
    this.hasCheckout = false;
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    let ts = null;
    for (const { timestamp } of this.events) {
      if (ts === null || timestamp < ts) ts = timestamp;
    }
    return ts === null ? ts : timestampToMs(ts);
  }
}
class WorkerHandler {
  constructor(worker) {
    this._onMessage = ({ data }) => {
      const response = data;
      if (typeof response.id !== "number") {
        return;
      }
      const pending = this._pending.get(response.id);
      if (!pending || pending.method !== response.method) {
        return;
      }
      this._pending.delete(response.id);
      if (!response.success) {
        DEBUG_BUILD && debug.error("Error in compression worker: ", response.response);
        pending.reject(new Error("Error in compression worker"));
        return;
      }
      pending.resolve(response.response);
    };
    this._worker = worker;
    this._id = 0;
    this._pending = /* @__PURE__ */ new Map();
    this._worker.addEventListener("message", this._onMessage);
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    if (this._ensureReadyPromise) {
      return this._ensureReadyPromise;
    }
    this._ensureReadyPromise = new Promise((resolve, reject) => {
      this._worker.addEventListener(
        "message",
        ({ data }) => {
          if (data.success) {
            resolve();
          } else {
            DEBUG_BUILD && debug.warn("Received worker message with unsuccessful status", data);
            reject(new Error("Received worker message with unsuccessful status"));
          }
        },
        { once: true }
      );
      this._worker.addEventListener(
        "error",
        (error) => {
          DEBUG_BUILD && debug.warn("Failed to load Replay compression worker", error);
          reject(
            new Error(
              `Failed to load Replay compression worker: ${error instanceof ErrorEvent && error.message ? error.message : "Unknown error. This can happen due to CSP policy restrictions, network issues, or the worker script failing to load."}`
            )
          );
        },
        { once: true }
      );
    });
    return this._ensureReadyPromise;
  }
  /**
   * Destroy the worker.
   */
  destroy() {
    DEBUG_BUILD && debug.log("Destroying compression worker");
    this._worker.removeEventListener("message", this._onMessage);
    this._pending.forEach((pending) => pending.reject(new Error("Worker destroyed")));
    this._pending.clear();
    this._worker.terminate();
  }
  /**
   * Post message to worker and wait for response before resolving promise.
   */
  postMessage(method, arg) {
    const id = this._getAndIncrementId();
    return new Promise((resolve, reject) => {
      this._pending.set(id, {
        method,
        resolve,
        reject
      });
      try {
        this._worker.postMessage({ id, method, arg });
      } catch (error) {
        this._pending.delete(id);
        reject(error);
      }
    });
  }
  /** Get the current ID and increment it for the next call. */
  _getAndIncrementId() {
    return this._id++;
  }
}
class EventBufferCompressionWorker {
  constructor(worker) {
    this._worker = new WorkerHandler(worker);
    this._earliestTimestamp = null;
    this._totalSize = 0;
    this.hasCheckout = false;
    this.waitForCheckout = false;
  }
  /** @inheritdoc */
  get hasEvents() {
    return !!this._earliestTimestamp;
  }
  /** @inheritdoc */
  get type() {
    return "worker";
  }
  /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occurred.
   */
  ensureReady() {
    return this._worker.ensureReady();
  }
  /**
   * Destroy the event buffer.
   */
  destroy() {
    this._worker.destroy();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully received and processed by worker.
   */
  addEvent(event) {
    const timestamp = timestampToMs(event.timestamp);
    if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) {
      this._earliestTimestamp = timestamp;
    }
    const data = JSON.stringify(event);
    this._totalSize += data.length;
    if (this._totalSize > REPLAY_MAX_EVENT_BUFFER_SIZE) {
      return Promise.reject(new EventBufferSizeExceededError());
    }
    return this._sendEventToWorker(data);
  }
  /**
   * Finish the event buffer and return the compressed data.
   */
  finish() {
    return this._finishRequest();
  }
  /** @inheritdoc */
  clear() {
    this._earliestTimestamp = null;
    this._totalSize = 0;
    this.hasCheckout = false;
    this._worker.postMessage("clear").then(null, (e2) => {
      DEBUG_BUILD && debug.exception(e2, 'Sending "clear" message to worker failed', e2);
    });
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._earliestTimestamp;
  }
  /**
   * Send the event to the worker.
   */
  _sendEventToWorker(data) {
    return this._worker.postMessage("addEvent", data);
  }
  /**
   * Finish the request and return the compressed data from the worker.
   */
  async _finishRequest() {
    const response = await this._worker.postMessage("finish");
    this._earliestTimestamp = null;
    this._totalSize = 0;
    return response;
  }
}
class EventBufferProxy {
  constructor(worker) {
    this._fallback = new EventBufferArray();
    this._compression = new EventBufferCompressionWorker(worker);
    this._used = this._fallback;
    this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
  }
  /** @inheritdoc */
  get waitForCheckout() {
    return this._used.waitForCheckout;
  }
  /** @inheritdoc */
  get type() {
    return this._used.type;
  }
  /** @inheritDoc */
  get hasEvents() {
    return this._used.hasEvents;
  }
  /** @inheritdoc */
  get hasCheckout() {
    return this._used.hasCheckout;
  }
  /** @inheritdoc */
  set hasCheckout(value) {
    this._used.hasCheckout = value;
  }
  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/adjacent-overload-signatures
  set waitForCheckout(value) {
    this._used.waitForCheckout = value;
  }
  /** @inheritDoc */
  destroy() {
    this._fallback.destroy();
    this._compression.destroy();
  }
  /** @inheritdoc */
  clear() {
    return this._used.clear();
  }
  /** @inheritdoc */
  getEarliestTimestamp() {
    return this._used.getEarliestTimestamp();
  }
  /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */
  addEvent(event) {
    return this._used.addEvent(event);
  }
  /** @inheritDoc */
  async finish() {
    await this.ensureWorkerIsLoaded();
    return this._used.finish();
  }
  /** Ensure the worker has loaded. */
  ensureWorkerIsLoaded() {
    return this._ensureWorkerIsLoadedPromise;
  }
  /** Actually check if the worker has been loaded. */
  async _ensureWorkerIsLoaded() {
    try {
      await this._compression.ensureReady();
    } catch (error) {
      DEBUG_BUILD && debug.exception(error, "Failed to load the compression worker, falling back to simple buffer");
      return;
    }
    await this._switchToCompressionWorker();
  }
  /** Switch the used buffer to the compression worker. */
  async _switchToCompressionWorker() {
    const { events, hasCheckout, waitForCheckout } = this._fallback;
    const addEventPromises = [];
    for (const event of events) {
      addEventPromises.push(this._compression.addEvent(event));
    }
    this._compression.hasCheckout = hasCheckout;
    this._compression.waitForCheckout = waitForCheckout;
    this._used = this._compression;
    try {
      await Promise.all(addEventPromises);
      this._fallback.clear();
    } catch (error) {
      DEBUG_BUILD && debug.exception(error, "Failed to add events when switching buffers.");
    }
  }
}
function createEventBuffer({
  useCompression,
  workerUrl: customWorkerUrl
}) {
  if (useCompression && // eslint-disable-next-line no-restricted-globals
  window.Worker) {
    const worker = _loadWorker(customWorkerUrl);
    if (worker) {
      return worker;
    }
  }
  DEBUG_BUILD && debug.log("Using simple buffer");
  return new EventBufferArray();
}
function _loadWorker(customWorkerUrl) {
  try {
    const workerUrl = customWorkerUrl || _getWorkerUrl();
    if (!workerUrl) {
      return;
    }
    DEBUG_BUILD && debug.log(`Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ""}`);
    const worker = new Worker(workerUrl);
    return new EventBufferProxy(worker);
  } catch (error) {
    DEBUG_BUILD && debug.exception(error, "Failed to create compression worker");
  }
}
function _getWorkerUrl() {
  if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === "undefined" || !__SENTRY_EXCLUDE_REPLAY_WORKER__) {
    return e();
  }
  return "";
}
function hasSessionStorage() {
  try {
    return "sessionStorage" in WINDOW && !!WINDOW.sessionStorage;
  } catch {
    return false;
  }
}
function clearSession(replay) {
  deleteSession();
  replay.session = void 0;
}
function deleteSession() {
  if (!hasSessionStorage()) {
    return;
  }
  try {
    WINDOW.sessionStorage.removeItem(REPLAY_SESSION_KEY);
  } catch {
  }
}
function isSampled(sampleRate) {
  if (sampleRate === void 0) {
    return false;
  }
  return Math.random() < sampleRate;
}
function saveSession(session) {
  if (!hasSessionStorage()) {
    return;
  }
  try {
    WINDOW.sessionStorage.setItem(REPLAY_SESSION_KEY, JSON.stringify(session));
  } catch {
  }
}
function makeSession(session) {
  const now = Date.now();
  const id = session.id || (0,misc/* uuid4 */.eJ)();
  const started = session.started || now;
  const lastActivity = session.lastActivity || now;
  const segmentId = session.segmentId || 0;
  const sampled = session.sampled;
  const previousSessionId = session.previousSessionId;
  const dirty = session.dirty || false;
  return {
    id,
    started,
    lastActivity,
    segmentId,
    sampled,
    previousSessionId,
    dirty
  };
}
function getSessionSampleType(sessionSampleRate, allowBuffering) {
  return isSampled(sessionSampleRate) ? "session" : allowBuffering ? "buffer" : false;
}
function createSession({ sessionSampleRate, allowBuffering, stickySession = false }, { previousSessionId } = {}) {
  const sampled = getSessionSampleType(sessionSampleRate, allowBuffering);
  const session = makeSession({
    sampled,
    previousSessionId
  });
  if (stickySession) {
    saveSession(session);
  }
  return session;
}
function fetchSession() {
  if (!hasSessionStorage()) {
    return null;
  }
  try {
    const sessionStringFromStorage = WINDOW.sessionStorage.getItem(REPLAY_SESSION_KEY);
    if (!sessionStringFromStorage) {
      return null;
    }
    const sessionObj = JSON.parse(sessionStringFromStorage);
    DEBUG_BUILD && debug.infoTick("Loading existing session");
    return makeSession(sessionObj);
  } catch {
    return null;
  }
}
function isExpired(initialTime, expiry, targetTime = +/* @__PURE__ */ new Date()) {
  if (initialTime === null || expiry === void 0 || expiry < 0) {
    return true;
  }
  if (expiry === 0) {
    return false;
  }
  return initialTime + expiry <= targetTime;
}
function isSessionExpired(session, {
  maxReplayDuration,
  sessionIdleExpire,
  targetTime = Date.now()
}) {
  return (
    // First, check that maximum session length has not been exceeded
    isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    isExpired(session.lastActivity, sessionIdleExpire, targetTime)
  );
}
function shouldRefreshSession(session, { sessionIdleExpire, maxReplayDuration }) {
  if (!isSessionExpired(session, { sessionIdleExpire, maxReplayDuration })) {
    return false;
  }
  if (session.sampled === "buffer" && session.segmentId === 0) {
    return false;
  }
  return true;
}
function loadOrCreateSession({
  sessionIdleExpire,
  maxReplayDuration,
  previousSessionId
}, sessionOptions) {
  const existingSession = sessionOptions.stickySession && fetchSession();
  if (!existingSession) {
    DEBUG_BUILD && debug.infoTick("Creating new session");
    return createSession(sessionOptions, { previousSessionId });
  }
  if (!shouldRefreshSession(existingSession, { sessionIdleExpire, maxReplayDuration })) {
    return existingSession;
  }
  DEBUG_BUILD && debug.infoTick("Session in sessionStorage is expired, creating new one...");
  return createSession(sessionOptions, { previousSessionId: existingSession.id });
}
function isCustomEvent(event) {
  return event.type === EventType.Custom;
}
function addEventSync(replay, event, isCheckout) {
  if (!shouldAddEvent(replay, event)) {
    return false;
  }
  _addEvent(replay, event, isCheckout);
  return true;
}
function addEvent(replay, event, isCheckout) {
  if (!shouldAddEvent(replay, event)) {
    return Promise.resolve(null);
  }
  return _addEvent(replay, event, isCheckout);
}
async function _addEvent(replay, event, isCheckout) {
  const { eventBuffer } = replay;
  if (!eventBuffer || eventBuffer.waitForCheckout && !isCheckout) {
    return null;
  }
  const isBufferMode = replay.recordingMode === "buffer";
  try {
    if (isCheckout && isBufferMode) {
      eventBuffer.clear();
    }
    if (isCheckout) {
      eventBuffer.hasCheckout = true;
      eventBuffer.waitForCheckout = false;
    }
    const replayOptions = replay.getOptions();
    const eventAfterPossibleCallback = maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
    if (!eventAfterPossibleCallback) {
      return;
    }
    return await eventBuffer.addEvent(eventAfterPossibleCallback);
  } catch (error) {
    const isExceeded = error && error instanceof EventBufferSizeExceededError;
    const reason = isExceeded ? "eventBufferOverflow" : "eventBufferError";
    const client = (0,currentScopes/* getClient */.KU)();
    if (client) {
      const dropReason = isExceeded ? "buffer_overflow" : "internal_sdk_error";
      client.recordDroppedEvent(dropReason, "replay");
    }
    if (isExceeded && isBufferMode) {
      eventBuffer.clear();
      eventBuffer.waitForCheckout = true;
      return null;
    }
    replay.handleException(error);
    await replay.stop({ reason });
  }
}
function shouldAddEvent(replay, event) {
  if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) {
    return false;
  }
  const timestampInMs = timestampToMs(event.timestamp);
  if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) {
    return false;
  }
  if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
    DEBUG_BUILD && debug.infoTick(`Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`);
    return false;
  }
  return true;
}
function maybeApplyCallback(event, callback) {
  try {
    if (typeof callback === "function" && isCustomEvent(event)) {
      return callback(event);
    }
  } catch (error) {
    DEBUG_BUILD && debug.exception(error, "An error occurred in the `beforeAddRecordingEvent` callback, skipping the event...");
    return null;
  }
  return event;
}
const MAX_TRACE_IDS = 100;
function addTraceIdToContext(replay, traceId) {
  const replayContext = replay.getContext();
  if (replayContext.traceIds.size < MAX_TRACE_IDS) {
    replayContext.traceIds.add(traceId);
  }
}
function handleAfterSegmentSpanEnd(replay) {
  return (segmentSpan) => {
    if (!replay.isEnabled() || !(0,spanUtils/* spanIsSampled */.pK)(segmentSpan)) {
      return;
    }
    const traceId = segmentSpan.spanContext().traceId;
    if (traceId) {
      addTraceIdToContext(replay, traceId);
    }
  };
}
function isErrorEvent(event) {
  return !event.type;
}
function isTransactionEvent(event) {
  return event.type === "transaction";
}
function isReplayEvent(event) {
  return event.type === "replay_event";
}
function isFeedbackEvent(event) {
  return event.type === "feedback";
}
function handleAfterSendEvent(replay) {
  return (event, sendResponse) => {
    if (!replay.isEnabled() || !isErrorEvent(event) && !isTransactionEvent(event)) {
      return;
    }
    const statusCode = sendResponse.statusCode;
    if (!statusCode || statusCode < 200 || statusCode >= 300) {
      return;
    }
    if (isTransactionEvent(event)) {
      handleTransactionEvent(replay, event);
      return;
    }
    handleErrorEvent(replay, event);
  };
}
function handleTransactionEvent(replay, event) {
  const traceId = event.contexts?.trace?.trace_id;
  if (traceId) {
    addTraceIdToContext(replay, traceId);
  }
}
function handleErrorEvent(replay, event) {
  const replayContext = replay.getContext();
  if (event.event_id && replayContext.errorIds.size < 100) {
    replayContext.errorIds.add(event.event_id);
  }
  if (replay.recordingMode !== "buffer" || !event.tags?.replayId) {
    return;
  }
  const { beforeErrorSampling } = replay.getOptions();
  if (typeof beforeErrorSampling === "function" && !beforeErrorSampling(event)) {
    return;
  }
  (0,getNativeImplementation/* setTimeout */.wg)(async () => {
    try {
      await replay.sendBufferedReplayOrFlush();
    } catch (err) {
      replay.handleException(err);
    }
  });
}
function handleBeforeSendEvent(replay) {
  return (event) => {
    if (!replay.isEnabled() || !isErrorEvent(event)) {
      return;
    }
    handleHydrationError(replay, event);
  };
}
function handleHydrationError(replay, event) {
  const exceptionValue = event.exception?.values?.[0]?.value;
  if (typeof exceptionValue !== "string") {
    return;
  }
  if (
    // Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    // With newer React versions, the messages changed to a different website https://react.dev/errors/418
    exceptionValue.match(
      /(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/
    ) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)
  ) {
    const breadcrumb = createBreadcrumb({
      category: "replay.hydrate-error",
      data: {
        url: (0,browser/* getLocationHref */.$N)()
      }
    });
    addBreadcrumbEvent(replay, breadcrumb);
  }
}
function handleBreadcrumbs(replay) {
  const client = (0,currentScopes/* getClient */.KU)();
  if (!client) {
    return;
  }
  client.on("beforeAddBreadcrumb", (breadcrumb) => beforeAddBreadcrumb(replay, breadcrumb));
}
function beforeAddBreadcrumb(replay, breadcrumb) {
  if (!replay.isEnabled() || !isBreadcrumbWithCategory(breadcrumb)) {
    return;
  }
  const result = normalizeBreadcrumb(breadcrumb);
  if (result) {
    addBreadcrumbEvent(replay, result);
  }
}
function normalizeBreadcrumb(breadcrumb) {
  if (!isBreadcrumbWithCategory(breadcrumb) || [
    // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
    "fetch",
    "xhr",
    // These two are breadcrumbs for emitted sentry events, we don't care about them
    "sentry.event",
    "sentry.transaction"
  ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
  breadcrumb.category.startsWith("ui.")) {
    return null;
  }
  if (breadcrumb.category === "console") {
    return normalizeConsoleBreadcrumb(breadcrumb);
  }
  return createBreadcrumb(breadcrumb);
}
function normalizeConsoleBreadcrumb(breadcrumb) {
  const args = breadcrumb.data?.arguments;
  if (!Array.isArray(args) || args.length === 0) {
    return createBreadcrumb(breadcrumb);
  }
  let isTruncated = false;
  const normalizedArgs = args.map((arg) => {
    if (!arg) {
      return arg;
    }
    if (typeof arg === "string") {
      if (arg.length > CONSOLE_ARG_MAX_SIZE) {
        isTruncated = true;
        return `${arg.slice(0, CONSOLE_ARG_MAX_SIZE)}\u2026`;
      }
      return arg;
    }
    if (typeof arg === "object") {
      try {
        const normalizedArg = (0,normalize/* normalize */.S8)(arg, 7);
        const stringified = JSON.stringify(normalizedArg);
        if (stringified.length > CONSOLE_ARG_MAX_SIZE) {
          isTruncated = true;
          return `${JSON.stringify(normalizedArg, null, 2).slice(0, CONSOLE_ARG_MAX_SIZE)}\u2026`;
        }
        return normalizedArg;
      } catch {
      }
    }
    return arg;
  });
  return createBreadcrumb({
    ...breadcrumb,
    data: {
      ...breadcrumb.data,
      arguments: normalizedArgs,
      ...isTruncated ? { _meta: { warnings: ["CONSOLE_ARG_TRUNCATED"] } } : {}
    }
  });
}
function isBreadcrumbWithCategory(breadcrumb) {
  return !!breadcrumb.category;
}
function isRrwebError(event, hint) {
  if (event.type || !event.exception?.values?.length) {
    return false;
  }
  if (hint.originalException?.__rrweb__) {
    return true;
  }
  return false;
}
function resetReplayIdOnDynamicSamplingContext() {
  const dsc = (0,currentScopes/* getCurrentScope */.o5)().getPropagationContext().dsc;
  if (dsc) {
    delete dsc.replay_id;
  }
  const activeSpan = (0,spanUtils/* getActiveSpan */.Bk)();
  if (activeSpan) {
    const dsc2 = (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.k1)(activeSpan);
    delete dsc2.replay_id;
  }
}
function setReplayIdOnDynamicSamplingContext(replayId) {
  const dsc = (0,currentScopes/* getCurrentScope */.o5)().getPropagationContext().dsc;
  if (dsc) {
    dsc.replay_id = replayId;
  }
  const activeSpan = (0,spanUtils/* getActiveSpan */.Bk)();
  if (activeSpan) {
    const dsc2 = (0,dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.k1)(activeSpan);
    dsc2.replay_id = replayId;
  }
}
function addFeedbackBreadcrumb(replay, event) {
  replay.triggerUserActivity();
  replay.addUpdate(() => {
    if (!event.timestamp) {
      return true;
    }
    replay.throttledAddEvent({
      type: EventType.Custom,
      timestamp: event.timestamp * 1e3,
      data: {
        tag: "breadcrumb",
        payload: {
          timestamp: event.timestamp,
          type: "default",
          category: "sentry.feedback",
          data: {
            feedbackId: event.event_id
          }
        }
      }
    });
    return false;
  });
}
function shouldSampleForBufferEvent(replay, event) {
  if (replay.recordingMode !== "buffer") {
    return false;
  }
  if (event.message === UNABLE_TO_SEND_REPLAY) {
    return false;
  }
  if (!event.exception || event.type) {
    return false;
  }
  return isSampled(replay.getOptions().errorSampleRate);
}
function handleGlobalEventListener(replay) {
  return Object.assign(
    (event, hint) => {
      if (replay.session && shouldRefreshSession(replay.session, {
        maxReplayDuration: replay.getOptions().maxReplayDuration,
        sessionIdleExpire: replay.timeouts.sessionIdleExpire
      })) {
        resetReplayIdOnDynamicSamplingContext();
      }
      if (!replay.isEnabled() || replay.isPaused()) {
        return event;
      }
      if (isReplayEvent(event)) {
        delete event.breadcrumbs;
        return event;
      }
      if (!isErrorEvent(event) && !isTransactionEvent(event) && !isFeedbackEvent(event)) {
        return event;
      }
      const isSessionActive = replay.checkAndHandleExpiredSession();
      if (!isSessionActive) {
        resetReplayIdOnDynamicSamplingContext();
        return event;
      }
      if (isFeedbackEvent(event)) {
        replay.flush();
        event.contexts.feedback.replay_id = replay.getSessionId();
        addFeedbackBreadcrumb(replay, event);
        return event;
      }
      if (isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
        DEBUG_BUILD && debug.log("Ignoring error from rrweb internals", event);
        return null;
      }
      const isErrorEventSampled = shouldSampleForBufferEvent(replay, event);
      const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === "session";
      if (shouldTagReplayId) {
        event.tags = { ...event.tags, replayId: replay.getSessionId() };
      }
      if (isErrorEventSampled && replay.recordingMode === "buffer" && replay.session?.sampled === "buffer") {
        const session = replay.session;
        session.dirty = true;
        if (replay.getOptions().stickySession) {
          saveSession(session);
        }
      }
      return event;
    },
    { id: "Replay" }
  );
}
function createPerformanceSpans(replay, entries) {
  return entries.map(({ type, start, end, name, data }) => {
    const response = replay.throttledAddEvent({
      type: EventType.Custom,
      timestamp: start,
      data: {
        tag: "performanceSpan",
        payload: {
          op: type,
          description: name,
          startTimestamp: start,
          endTimestamp: end,
          data
        }
      }
    });
    return typeof response === "string" ? Promise.resolve(null) : response;
  });
}
function handleHistory(handlerData) {
  const { from, to } = handlerData;
  const now = Date.now() / 1e3;
  return {
    type: "navigation.push",
    start: now,
    end: now,
    name: to,
    data: {
      previous: from
    }
  };
}
function handleHistorySpanListener(replay) {
  return (handlerData) => {
    if (!replay.isEnabled()) {
      return;
    }
    const result = handleHistory(handlerData);
    if (result === null) {
      return;
    }
    replay.getContext().urls.push(result.name);
    replay.triggerUserActivity();
    replay.addUpdate(() => {
      createPerformanceSpans(replay, [result]);
      return false;
    });
  };
}
function shouldFilterRequest(replay, url) {
  if (DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) {
    return false;
  }
  return (0,isSentryRequestUrl/* isSentryRequestUrl */.A)(url, (0,currentScopes/* getClient */.KU)());
}
function addNetworkBreadcrumb(replay, result) {
  if (!replay.isEnabled()) {
    return;
  }
  if (result === null) {
    return;
  }
  if (shouldFilterRequest(replay, result.name)) {
    return;
  }
  replay.addUpdate(() => {
    createPerformanceSpans(replay, [result]);
    return true;
  });
}
function getBodySize(body) {
  if (!body) {
    return void 0;
  }
  const textEncoder = new TextEncoder();
  try {
    if (typeof body === "string") {
      return textEncoder.encode(body).length;
    }
    if (body instanceof URLSearchParams) {
      return textEncoder.encode(body.toString()).length;
    }
    if (body instanceof FormData) {
      const formDataStr = (0,networkUtils/* serializeFormData */.P4)(body);
      return textEncoder.encode(formDataStr).length;
    }
    if (body instanceof Blob) {
      return body.size;
    }
    if (body instanceof ArrayBuffer) {
      return body.byteLength;
    }
  } catch {
  }
  return void 0;
}
function parseContentLengthHeader(header) {
  if (!header) {
    return void 0;
  }
  const size = parseInt(header, 10);
  return isNaN(size) ? void 0 : size;
}
function mergeWarning(info, warning) {
  if (!info) {
    return {
      headers: {},
      size: void 0,
      _meta: {
        warnings: [warning]
      }
    };
  }
  const newMeta = { ...info._meta };
  const existingWarnings = newMeta.warnings || [];
  newMeta.warnings = [...existingWarnings, warning];
  info._meta = newMeta;
  return info;
}
function makeNetworkReplayBreadcrumb(type, data) {
  if (!data) {
    return null;
  }
  const { startTimestamp, endTimestamp, url, method, statusCode, request, response } = data;
  const result = {
    type,
    start: startTimestamp / 1e3,
    end: endTimestamp / 1e3,
    name: url,
    data: {
      method,
      statusCode,
      request,
      response
    }
  };
  return result;
}
function buildSkippedNetworkRequestOrResponse(bodySize) {
  return {
    headers: {},
    size: bodySize,
    _meta: {
      warnings: ["URL_SKIPPED"]
    }
  };
}
function buildNetworkRequestOrResponse(headers, bodySize, body) {
  if (!bodySize && Object.keys(headers).length === 0) {
    return void 0;
  }
  if (!bodySize) {
    return {
      headers
    };
  }
  if (!body) {
    return {
      headers,
      size: bodySize
    };
  }
  const info = {
    headers,
    size: bodySize
  };
  const { body: normalizedBody, warnings } = normalizeNetworkBody(body);
  info.body = normalizedBody;
  if (warnings?.length) {
    info._meta = {
      warnings
    };
  }
  return info;
}
function getAllowedHeaders(headers, allowedHeaders) {
  return Object.entries(headers).reduce((filteredHeaders, [key, value]) => {
    const normalizedKey = key.toLowerCase();
    if (allowedHeaders.includes(normalizedKey) && headers[key]) {
      filteredHeaders[normalizedKey] = value;
    }
    return filteredHeaders;
  }, {});
}
function normalizeNetworkBody(body) {
  if (!body || typeof body !== "string") {
    return {
      body
    };
  }
  const exceedsSizeLimit = body.length > NETWORK_BODY_MAX_SIZE;
  const isProbablyJson = _strIsProbablyJson(body);
  if (exceedsSizeLimit) {
    const truncatedBody = body.slice(0, NETWORK_BODY_MAX_SIZE);
    if (isProbablyJson) {
      return {
        body: truncatedBody,
        warnings: ["MAYBE_JSON_TRUNCATED"]
      };
    }
    return {
      body: `${truncatedBody}\u2026`,
      warnings: ["TEXT_TRUNCATED"]
    };
  }
  if (isProbablyJson) {
    try {
      const jsonBody = JSON.parse(body);
      return {
        body: jsonBody
      };
    } catch {
    }
  }
  return {
    body
  };
}
function _strIsProbablyJson(str) {
  const first = str[0];
  const last = str[str.length - 1];
  return first === "[" && last === "]" || first === "{" && last === "}";
}
function urlMatches(url, urls) {
  const fullUrl = getFullUrl(url);
  return (0,string/* stringMatchesSomePattern */.Xr)(fullUrl, urls);
}
function getFullUrl(url, baseURI = WINDOW.document.baseURI) {
  if (url.startsWith("http://") || url.startsWith("https://") || url.startsWith(WINDOW.location.origin)) {
    return url;
  }
  const fixedUrl = new URL(url, baseURI);
  if (fixedUrl.origin !== new URL(baseURI).origin) {
    return url;
  }
  const fullUrl = fixedUrl.href;
  if (!url.endsWith("/") && fullUrl.endsWith("/")) {
    return fullUrl.slice(0, -1);
  }
  return fullUrl;
}
async function captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
  try {
    const data = await _prepareFetchData(breadcrumb, hint, options);
    const result = makeNetworkReplayBreadcrumb("resource.fetch", data);
    addNetworkBreadcrumb(options.replay, result);
  } catch (error) {
    DEBUG_BUILD && debug.exception(error, "Failed to capture fetch breadcrumb");
  }
}
function enrichFetchBreadcrumb(breadcrumb, hint) {
  const { input, response } = hint;
  const body = input ? (0,networkUtils/* getFetchRequestArgBody */.Gv)(input) : void 0;
  const reqSize = getBodySize(body);
  const resSize = response ? parseContentLengthHeader(response.headers.get("content-length")) : void 0;
  if (reqSize !== void 0) {
    breadcrumb.data.request_body_size = reqSize;
  }
  if (resSize !== void 0) {
    breadcrumb.data.response_body_size = resSize;
  }
}
async function _prepareFetchData(breadcrumb, hint, options) {
  const now = Date.now();
  const { startTimestamp = now, endTimestamp = now } = hint;
  const {
    url,
    method,
    status_code: statusCode = 0,
    request_body_size: requestBodySize,
    response_body_size: responseBodySize
  } = breadcrumb.data;
  const captureDetails = urlMatches(url, options.networkDetailAllowUrls) && !urlMatches(url, options.networkDetailDenyUrls);
  const request = captureDetails ? _getRequestInfo(options, hint.input, requestBodySize) : buildSkippedNetworkRequestOrResponse(requestBodySize);
  const response = await _getResponseInfo(captureDetails, options, hint.response, responseBodySize);
  return {
    startTimestamp,
    endTimestamp,
    url,
    method,
    statusCode,
    request,
    response
  };
}
function _getRequestInfo({ networkCaptureBodies, networkRequestHeaders }, input, requestBodySize) {
  const headers = input ? getRequestHeaders(input, networkRequestHeaders) : {};
  if (!networkCaptureBodies) {
    return buildNetworkRequestOrResponse(headers, requestBodySize, void 0);
  }
  const requestBody = (0,networkUtils/* getFetchRequestArgBody */.Gv)(input);
  const [bodyStr, warning] = (0,networkUtils/* getBodyString */.sY)(requestBody, debug);
  const data = buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
  if (warning) {
    return mergeWarning(data, warning);
  }
  return data;
}
async function _getResponseInfo(captureDetails, {
  networkCaptureBodies,
  networkResponseHeaders
}, response, responseBodySize) {
  if (!captureDetails && responseBodySize !== void 0) {
    return buildSkippedNetworkRequestOrResponse(responseBodySize);
  }
  const headers = response ? getAllHeaders(response.headers, networkResponseHeaders) : {};
  if (!response || !networkCaptureBodies && responseBodySize !== void 0) {
    return buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
  }
  const [bodyText, warning] = await _parseFetchResponseBody(response);
  const result = getResponseData(bodyText, {
    networkCaptureBodies,
    responseBodySize,
    captureDetails,
    headers
  });
  if (warning) {
    return mergeWarning(result, warning);
  }
  return result;
}
function getResponseData(bodyText, {
  networkCaptureBodies,
  responseBodySize,
  captureDetails,
  headers
}) {
  try {
    const size = bodyText?.length && responseBodySize === void 0 ? getBodySize(bodyText) : responseBodySize;
    if (!captureDetails) {
      return buildSkippedNetworkRequestOrResponse(size);
    }
    if (networkCaptureBodies) {
      return buildNetworkRequestOrResponse(headers, size, bodyText);
    }
    return buildNetworkRequestOrResponse(headers, size, void 0);
  } catch (error) {
    DEBUG_BUILD && debug.exception(error, "Failed to serialize response body");
    return buildNetworkRequestOrResponse(headers, responseBodySize, void 0);
  }
}
async function _parseFetchResponseBody(response) {
  const res = _tryCloneResponse(response);
  if (!res) {
    return [void 0, "BODY_PARSE_ERROR"];
  }
  try {
    const text = await _tryGetResponseText(res);
    return [text];
  } catch (error) {
    if (error instanceof Error && error.message.indexOf("Timeout") > -1) {
      DEBUG_BUILD && debug.warn("Parsing text body from response timed out");
      return [void 0, "BODY_PARSE_TIMEOUT"];
    }
    DEBUG_BUILD && debug.exception(error, "Failed to get text body from response");
    return [void 0, "BODY_PARSE_ERROR"];
  }
}
function getAllHeaders(headers, allowedHeaders) {
  const allHeaders = {};
  allowedHeaders.forEach((header) => {
    if (headers.get(header)) {
      allHeaders[header] = headers.get(header);
    }
  });
  return allHeaders;
}
function getRequestHeaders(fetchArgs, allowedHeaders) {
  if (fetchArgs.length === 1 && typeof fetchArgs[0] !== "string") {
    return getHeadersFromOptions(fetchArgs[0], allowedHeaders);
  }
  if (fetchArgs.length === 2) {
    return getHeadersFromOptions(fetchArgs[1], allowedHeaders);
  }
  return {};
}
function getHeadersFromOptions(input, allowedHeaders) {
  if (!input) {
    return {};
  }
  const headers = input.headers;
  if (!headers) {
    return {};
  }
  if (headers instanceof Headers) {
    return getAllHeaders(headers, allowedHeaders);
  }
  if (Array.isArray(headers)) {
    return {};
  }
  return getAllowedHeaders(headers, allowedHeaders);
}
function _tryCloneResponse(response) {
  try {
    return response.clone();
  } catch (error) {
    DEBUG_BUILD && debug.exception(error, "Failed to clone response body");
  }
}
function _tryGetResponseText(response) {
  return new Promise((resolve, reject) => {
    const timeout = (0,getNativeImplementation/* setTimeout */.wg)(() => reject(new Error("Timeout while trying to read response body")), 500);
    _getResponseText(response).then(
      (txt) => resolve(txt),
      (reason) => reject(reason)
    ).finally(() => clearTimeout(timeout));
  });
}
async function _getResponseText(response) {
  return await response.text();
}
async function captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
  try {
    const data = _prepareXhrData(breadcrumb, hint, options);
    const result = makeNetworkReplayBreadcrumb("resource.xhr", data);
    addNetworkBreadcrumb(options.replay, result);
  } catch (error) {
    DEBUG_BUILD && debug.exception(error, "Failed to capture xhr breadcrumb");
  }
}
function enrichXhrBreadcrumb(breadcrumb, hint) {
  const { xhr, input } = hint;
  if (!xhr) {
    return;
  }
  const reqSize = getBodySize(input);
  const resSize = xhr.getResponseHeader("content-length") ? parseContentLengthHeader(xhr.getResponseHeader("content-length")) : _getBodySize(xhr.response, xhr.responseType);
  if (reqSize !== void 0) {
    breadcrumb.data.request_body_size = reqSize;
  }
  if (resSize !== void 0) {
    breadcrumb.data.response_body_size = resSize;
  }
}
function _prepareXhrData(breadcrumb, hint, options) {
  const now = Date.now();
  const { startTimestamp = now, endTimestamp = now, input, xhr } = hint;
  const {
    url,
    method,
    status_code: statusCode = 0,
    request_body_size: requestBodySize,
    response_body_size: responseBodySize
  } = breadcrumb.data;
  if (!url) {
    return null;
  }
  if (!xhr || !urlMatches(url, options.networkDetailAllowUrls) || urlMatches(url, options.networkDetailDenyUrls)) {
    const request2 = buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response2 = buildSkippedNetworkRequestOrResponse(responseBodySize);
    return {
      startTimestamp,
      endTimestamp,
      url,
      method,
      statusCode,
      request: request2,
      response: response2
    };
  }
  const xhrInfo = xhr[instrument_xhr/* SENTRY_XHR_DATA_KEY */.Er];
  const networkRequestHeaders = xhrInfo ? getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
  const networkResponseHeaders = getAllowedHeaders((0,networkUtils/* parseXhrResponseHeaders */.ti)(xhr), options.networkResponseHeaders);
  const [requestBody, requestWarning] = options.networkCaptureBodies ? (0,networkUtils/* getBodyString */.sY)(input, debug) : [void 0];
  const [responseBody, responseWarning] = options.networkCaptureBodies ? _getXhrResponseBody(xhr) : [void 0];
  const request = buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
  const response = buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
  return {
    startTimestamp,
    endTimestamp,
    url,
    method,
    statusCode,
    request: requestWarning ? mergeWarning(request, requestWarning) : request,
    response: responseWarning ? mergeWarning(response, responseWarning) : response
  };
}
function _getXhrResponseBody(xhr) {
  const errors = [];
  try {
    return [xhr.responseText];
  } catch (e2) {
    errors.push(e2);
  }
  try {
    return _parseXhrResponse(xhr.response, xhr.responseType);
  } catch (e2) {
    errors.push(e2);
  }
  DEBUG_BUILD && debug.warn("Failed to get xhr response body", ...errors);
  return [void 0];
}
function _parseXhrResponse(body, responseType) {
  try {
    if (typeof body === "string") {
      return [body];
    }
    if (body instanceof Document) {
      return [body.body.outerHTML];
    }
    if (responseType === "json" && body && typeof body === "object") {
      return [JSON.stringify(body)];
    }
    if (!body) {
      return [void 0];
    }
  } catch (error) {
    DEBUG_BUILD && debug.exception(error, "Failed to serialize body", body);
    return [void 0, "BODY_PARSE_ERROR"];
  }
  DEBUG_BUILD && debug.log("Skipping network body because of body type", body);
  return [void 0, "UNPARSEABLE_BODY_TYPE"];
}
function _getBodySize(body, responseType) {
  try {
    const bodyStr = responseType === "json" && body && typeof body === "object" ? JSON.stringify(body) : body;
    return getBodySize(bodyStr);
  } catch {
    return void 0;
  }
}
function handleNetworkBreadcrumbs(replay) {
  const client = (0,currentScopes/* getClient */.KU)();
  try {
    const {
      networkDetailAllowUrls,
      networkDetailDenyUrls,
      networkCaptureBodies,
      networkRequestHeaders,
      networkResponseHeaders
    } = replay.getOptions();
    const options = {
      replay,
      networkDetailAllowUrls,
      networkDetailDenyUrls,
      networkCaptureBodies,
      networkRequestHeaders,
      networkResponseHeaders
    };
    if (client) {
      client.on("beforeAddBreadcrumb", (breadcrumb, hint) => beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    }
  } catch {
  }
}
function beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
  if (!breadcrumb.data) {
    return;
  }
  try {
    if (_isXhrBreadcrumb(breadcrumb) && _isXhrHint(hint)) {
      enrichXhrBreadcrumb(breadcrumb, hint);
      captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
    }
    if (_isFetchBreadcrumb(breadcrumb) && _isFetchHint(hint)) {
      enrichFetchBreadcrumb(breadcrumb, hint);
      captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
    }
  } catch (e2) {
    DEBUG_BUILD && debug.exception(e2, "Error when enriching network breadcrumb");
  }
}
function _isXhrBreadcrumb(breadcrumb) {
  return breadcrumb.category === "xhr";
}
function _isFetchBreadcrumb(breadcrumb) {
  return breadcrumb.category === "fetch";
}
function _isXhrHint(hint) {
  return hint?.xhr;
}
function _isFetchHint(hint) {
  return hint?.input !== void 0;
}
function addGlobalListeners(replay) {
  const client = (0,currentScopes/* getClient */.KU)();
  (0,dom/* addClickKeypressInstrumentationHandler */.i)(handleDomListener(replay));
  (0,instrument_history/* addHistoryInstrumentationHandler */._)(handleHistorySpanListener(replay));
  handleBreadcrumbs(replay);
  handleNetworkBreadcrumbs(replay);
  const eventProcessor = handleGlobalEventListener(replay);
  (0,esm_exports/* addEventProcessor */.SA)(eventProcessor);
  if (client) {
    client.on("beforeSendEvent", handleBeforeSendEvent(replay));
    client.on("afterSendEvent", handleAfterSendEvent(replay));
    client.on("createDsc", (dsc) => {
      const replayId = replay.getSessionId();
      if (replayId && replay.isEnabled() && replay.recordingMode === "session") {
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (isSessionActive) {
          dsc.replay_id = replayId;
        }
      }
    });
    client.on("afterSegmentSpanEnd", handleAfterSegmentSpanEnd(replay));
    client.on("spanStart", (span) => {
      replay.lastActiveSpan = span;
    });
    client.on("spanEnd", (span) => {
      replay.lastActiveSpan = span;
    });
    client.on("beforeSendFeedback", async (feedbackEvent, options) => {
      const replayId = replay.getSessionId();
      if (options?.includeReplay && replay.isEnabled() && replayId && feedbackEvent.contexts?.feedback) {
        if (feedbackEvent.contexts.feedback.source === "api") {
          await replay.sendBufferedReplayOrFlush();
        }
        feedbackEvent.contexts.feedback.replay_id = replayId;
      }
    });
    client.on("openFeedbackWidget", async () => {
      await replay.sendBufferedReplayOrFlush();
    });
  }
}
async function addMemoryEntry(replay) {
  try {
    return Promise.all(
      createPerformanceSpans(replay, [
        // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
        createMemoryEntry(WINDOW.performance.memory)
      ])
    );
  } catch {
    return [];
  }
}
function createMemoryEntry(memoryEntry) {
  const { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize } = memoryEntry;
  const time = Date.now() / 1e3;
  return {
    type: "memory",
    name: "memory",
    start: time,
    end: time,
    data: {
      memory: {
        jsHeapSizeLimit,
        totalJSHeapSize,
        usedJSHeapSize
      }
    }
  };
}
function esm_debounce(func, wait, options) {
  return debounce(func, wait, {
    ...options,
    // @ts-expect-error - Not quite sure why these types do not match, but this is fine
    setTimeoutImpl: getNativeImplementation/* setTimeout */.wg
  });
}
const NAVIGATOR = worldwide/* GLOBAL_OBJ */.O.navigator;
function getRecordingSamplingOptions() {
  if (/iPhone|iPad|iPod/i.test(NAVIGATOR?.userAgent ?? "") || /Macintosh/i.test(NAVIGATOR?.userAgent ?? "") && NAVIGATOR?.maxTouchPoints && NAVIGATOR?.maxTouchPoints > 1) {
    return {
      sampling: {
        mousemove: false
      }
    };
  }
  return {};
}
function getHandleRecordingEmit(replay) {
  let hadFirstEvent = false;
  return (event, _isCheckout) => {
    if (!replay.checkAndHandleExpiredSession()) {
      DEBUG_BUILD && debug.warn("Received replay event after session expired.");
      return;
    }
    const isCheckout = _isCheckout || !hadFirstEvent;
    hadFirstEvent = true;
    syncMirrorAttributesFromMutationEvent(event);
    if (replay.clickDetector) {
      updateClickDetectorForRecordingEvent(replay.clickDetector, event);
    }
    replay.addUpdate(() => {
      if (replay.recordingMode === "buffer" && isCheckout) {
        replay.setInitialState();
      }
      if (!addEventSync(replay, event, isCheckout)) {
        return true;
      }
      if (!isCheckout) {
        return false;
      }
      const session = replay.session;
      addSettingsEvent(replay, isCheckout);
      if (replay.recordingMode === "buffer" && session && replay.eventBuffer && !session.dirty) {
        const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
        if (earliestEvent) {
          DEBUG_BUILD && debug.log(`Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`);
          session.started = earliestEvent;
          if (replay.getOptions().stickySession) {
            saveSession(session);
          }
        }
      }
      if (session?.previousSessionId) {
        return true;
      }
      if (replay.recordingMode === "session") {
        void replay.flush();
      }
      return true;
    });
  };
}
function syncMirrorAttributesFromMutationEvent(event) {
  const data = event.data;
  if (event.type !== EventType.IncrementalSnapshot || !data || typeof data !== "object" || !("source" in data) || data.source !== IncrementalSource.Mutation || !("attributes" in data) || !Array.isArray(data.attributes)) {
    return;
  }
  for (const mutation of data.attributes) {
    const node = record.mirror.getNode(mutation.id);
    const meta = node && record.mirror.getMeta(node);
    if (meta?.type !== NodeType.Element) {
      continue;
    }
    for (const [attributeName, value] of Object.entries(mutation.attributes)) {
      if (value === null) {
        delete meta.attributes[attributeName];
      } else {
        meta.attributes[attributeName] = value;
      }
    }
  }
}
function createOptionsEvent(replay) {
  const options = replay.getOptions();
  return {
    type: EventType.Custom,
    timestamp: Date.now(),
    data: {
      tag: "options",
      payload: {
        shouldRecordCanvas: replay.isRecordingCanvas(),
        sessionSampleRate: options.sessionSampleRate,
        errorSampleRate: options.errorSampleRate,
        useCompressionOption: options.useCompression,
        blockAllMedia: options.blockAllMedia,
        maskAllText: options.maskAllText,
        maskAllInputs: options.maskAllInputs,
        useCompression: replay.eventBuffer ? replay.eventBuffer.type === "worker" : false,
        networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
        networkCaptureBodies: options.networkCaptureBodies,
        networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
        networkResponseHasHeaders: options.networkResponseHeaders.length > 0
      }
    }
  };
}
function addSettingsEvent(replay, isCheckout) {
  if (!isCheckout || replay.session?.segmentId !== 0) {
    return;
  }
  addEventSync(replay, createOptionsEvent(replay), false);
}
function closestElementOfNode(node) {
  if (!node) {
    return null;
  }
  try {
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
  } catch {
    return null;
  }
}
function createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
  return (0,envelope/* createEnvelope */.h4)(
    (0,envelope/* createEventEnvelopeHeaders */.n2)(replayEvent, (0,envelope/* getSdkMetadataForEnvelopeHeader */.Cj)(replayEvent), tunnel, dsn),
    [
      [{ type: "replay_event" }, replayEvent],
      [
        {
          type: "replay_recording",
          // If string then we need to encode to UTF8, otherwise will have
          // wrong size. TextEncoder has similar browser support to
          // MutationObserver, although it does not accept IE11.
          length: typeof recordingData === "string" ? new TextEncoder().encode(recordingData).length : recordingData.length
        },
        recordingData
      ]
    ]
  );
}
function prepareRecordingData({
  recordingData,
  headers
}) {
  let payloadWithSequence;
  const replayHeaders = `${JSON.stringify(headers)}
`;
  if (typeof recordingData === "string") {
    payloadWithSequence = `${replayHeaders}${recordingData}`;
  } else {
    const enc = new TextEncoder();
    const sequence = enc.encode(replayHeaders);
    payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
    payloadWithSequence.set(sequence);
    payloadWithSequence.set(recordingData, sequence.length);
  }
  return payloadWithSequence;
}
async function prepareReplayEvent({
  client,
  scope,
  replayId: event_id,
  event
}) {
  const integrations = typeof client["_integrations"] === "object" && client["_integrations"] !== null && !Array.isArray(client["_integrations"]) ? Object.keys(client["_integrations"]) : void 0;
  const eventHint = { event_id, integrations };
  client.emit("preprocessEvent", event, eventHint);
  const preparedEvent = await (0,prepareEvent/* prepareEvent */.mG)(
    client.getOptions(),
    event,
    eventHint,
    scope,
    client,
    (0,currentScopes/* getIsolationScope */.rm)()
  );
  if (!preparedEvent) {
    return null;
  }
  client.emit("postprocessEvent", preparedEvent, eventHint);
  preparedEvent.platform = preparedEvent.platform || "javascript";
  const metadata = client.getSdkMetadata();
  const { name, version, settings } = metadata?.sdk || {};
  preparedEvent.sdk = {
    ...preparedEvent.sdk,
    name: name || "sentry.javascript.unknown",
    version: version || "0.0.0",
    settings
  };
  return preparedEvent;
}
async function sendReplayRequest({
  recordingData,
  replayId,
  segmentId: segment_id,
  eventContext,
  timestamp,
  session
}) {
  const preparedRecordingData = prepareRecordingData({
    recordingData,
    headers: {
      segment_id
    }
  });
  const { urls, errorIds, traceIds, initialTimestamp } = eventContext;
  const client = (0,currentScopes/* getClient */.KU)();
  const scope = (0,currentScopes/* getCurrentScope */.o5)();
  const transport = client?.getTransport();
  const dsn = client?.getDsn();
  if (!client || !transport || !dsn || !session.sampled) {
    return Promise.resolve({});
  }
  const baseEvent = {
    type: REPLAY_EVENT_NAME,
    replay_start_timestamp: initialTimestamp / 1e3,
    timestamp: timestamp / 1e3,
    error_ids: errorIds,
    trace_ids: traceIds,
    urls,
    replay_id: replayId,
    segment_id,
    replay_type: session.sampled
  };
  const replayEvent = await prepareReplayEvent({ scope, client, replayId, event: baseEvent });
  if (!replayEvent) {
    client.recordDroppedEvent("event_processor", "replay");
    DEBUG_BUILD && debug.log("An event processor returned `null`, will not send event.");
    return Promise.resolve({});
  }
  delete replayEvent.sdkProcessingMetadata;
  const envelope = createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
  let response;
  try {
    response = await transport.send(envelope);
  } catch (err) {
    const error = new Error(UNABLE_TO_SEND_REPLAY);
    try {
      error.cause = err;
    } catch {
    }
    throw error;
  }
  const rateLimits = (0,ratelimit/* updateRateLimits */.wq)({}, response);
  if ((0,ratelimit/* isRateLimited */.Jz)(rateLimits, "replay")) {
    throw new RateLimitError(rateLimits);
  }
  if (typeof response.statusCode === "number" && (response.statusCode < 200 || response.statusCode >= 300)) {
    throw new TransportStatusCodeError(response.statusCode);
  }
  return response;
}
class TransportStatusCodeError extends Error {
  constructor(statusCode) {
    super(`Transport returned status code ${statusCode}`);
  }
}
class RateLimitError extends Error {
  constructor(rateLimits) {
    super("Rate limit hit");
    this.rateLimits = rateLimits;
  }
}
class ReplayDurationLimitError extends Error {
  constructor() {
    super("Session is too long, not sending replay");
  }
}
async function sendReplay(replayData, retryConfig = {
  count: 0,
  interval: RETRY_BASE_INTERVAL
}) {
  const { recordingData, onError } = replayData;
  if (!recordingData.length) {
    return;
  }
  try {
    await sendReplayRequest(replayData);
    return true;
  } catch (err) {
    if (err instanceof TransportStatusCodeError || err instanceof RateLimitError) {
      throw err;
    }
    (0,esm_exports/* setContext */.o)("Replays", {
      _retryCount: retryConfig.count
    });
    if (onError) {
      onError(err);
    }
    if (retryConfig.count >= RETRY_MAX_COUNT) {
      const error = new Error(`${UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
      try {
        error.cause = err;
      } catch {
      }
      throw error;
    }
    retryConfig.interval *= ++retryConfig.count;
    return new Promise((resolve, reject) => {
      (0,getNativeImplementation/* setTimeout */.wg)(async () => {
        try {
          await sendReplay(replayData, retryConfig);
          resolve(true);
        } catch (err2) {
          reject(err2);
        }
      }, retryConfig.interval);
    });
  }
}
const THROTTLED = "__THROTTLED";
const SKIPPED = "__SKIPPED";
function throttle(fn, maxCount, durationSeconds) {
  const counter = /* @__PURE__ */ new Map();
  const _cleanup = (now) => {
    const threshold = now - durationSeconds;
    counter.forEach((_value, key) => {
      if (key < threshold) {
        counter.delete(key);
      }
    });
  };
  const _getTotalCount = () => {
    return [...counter.values()].reduce((a, b) => a + b, 0);
  };
  let isThrottled = false;
  return (...rest) => {
    const now = Math.floor(Date.now() / 1e3);
    _cleanup(now);
    if (_getTotalCount() >= maxCount) {
      const wasThrottled = isThrottled;
      isThrottled = true;
      return wasThrottled ? SKIPPED : THROTTLED;
    }
    isThrottled = false;
    const count = counter.get(now) || 0;
    counter.set(now, count + 1);
    return fn(...rest);
  };
}
class ReplayContainer {
  constructor({
    options,
    recordingOptions
  }) {
    this.eventBuffer = null;
    this.performanceEntries = [];
    this.replayPerformanceEntries = [];
    this.recordingMode = "session";
    this.timeouts = {
      sessionIdlePause: SESSION_IDLE_PAUSE_DURATION,
      sessionIdleExpire: SESSION_IDLE_EXPIRE_DURATION
    };
    this._lastActivity = Date.now();
    this._isEnabled = false;
    this._isPaused = false;
    this._requiresManualStart = false;
    this._hasInitializedCoreListeners = false;
    this._context = {
      errorIds: /* @__PURE__ */ new Set(),
      traceIds: /* @__PURE__ */ new Set(),
      urls: [],
      initialTimestamp: Date.now(),
      initialUrl: ""
    };
    this._recordingOptions = recordingOptions;
    this._options = options;
    this._debouncedFlush = esm_debounce(() => this._flush(), this._options.flushMinDelay, {
      maxWait: this._options.flushMaxDelay
    });
    this._throttledAddEvent = throttle(
      (event, isCheckout) => addEvent(this, event, isCheckout),
      // Max 300 events...
      300,
      // ... per 5s
      5
    );
    const { slowClickTimeout, slowClickIgnoreSelectors } = this.getOptions();
    const slowClickConfig = slowClickTimeout ? {
      threshold: Math.min(SLOW_CLICK_THRESHOLD, slowClickTimeout),
      timeout: slowClickTimeout,
      scrollTimeout: SLOW_CLICK_SCROLL_TIMEOUT,
      ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(",") : ""
    } : void 0;
    if (slowClickConfig) {
      this.clickDetector = new ClickDetector(this, slowClickConfig);
    }
    if (DEBUG_BUILD) {
      const experiments = options._experiments;
      debug.setConfig({
        captureExceptions: !!experiments.captureExceptions,
        traceInternals: !!experiments.traceInternals
      });
    }
    this._handleVisibilityChange = () => {
      if (WINDOW.document.visibilityState === "visible") {
        this._doChangeToForegroundTasks();
      } else {
        this._doChangeToBackgroundTasks();
      }
    };
    this._handleWindowBlur = () => {
      const breadcrumb = createBreadcrumb({
        category: "ui.blur"
      });
      this._doChangeToBackgroundTasks(breadcrumb);
    };
    this._handleWindowFocus = () => {
      const breadcrumb = createBreadcrumb({
        category: "ui.focus"
      });
      this._doChangeToForegroundTasks(breadcrumb);
    };
    this._handleKeyboardEvent = (event) => {
      handleKeyboardEvent(this, event);
    };
  }
  /** Get the event context. */
  getContext() {
    return this._context;
  }
  /** If recording is currently enabled. */
  isEnabled() {
    return this._isEnabled;
  }
  /** If recording is currently paused. */
  isPaused() {
    return this._isPaused;
  }
  /**
   * Determine if canvas recording is enabled
   */
  isRecordingCanvas() {
    return Boolean(this._canvas);
  }
  /** Get the replay integration options. */
  getOptions() {
    return this._options;
  }
  /** A wrapper to conditionally capture exceptions. */
  handleException(error) {
    DEBUG_BUILD && debug.exception(error);
    if (this._options.onError) {
      this._options.onError(error);
    }
  }
  /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */
  initializeSampling(previousSessionId) {
    const { errorSampleRate, sessionSampleRate } = this._options;
    const requiresManualStart = errorSampleRate <= 0 && sessionSampleRate <= 0;
    this._requiresManualStart = requiresManualStart;
    if (requiresManualStart) {
      return;
    }
    this._initializeSessionForSampling(previousSessionId);
    if (!this.session) {
      DEBUG_BUILD && debug.exception(new Error("Unable to initialize and create session"));
      return;
    }
    if (this.session.sampled === false) {
      return;
    }
    this.recordingMode = this.session.sampled === "buffer" && this.session.segmentId === 0 ? "buffer" : "session";
    DEBUG_BUILD && debug.infoTick(`Starting replay in ${this.recordingMode} mode`);
    this._initializeRecording();
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    if (this._isEnabled && this.recordingMode === "session") {
      DEBUG_BUILD && debug.log("Recording is already in progress");
      return;
    }
    if (this._isEnabled && this.recordingMode === "buffer") {
      DEBUG_BUILD && debug.log("Buffering is in progress, call `flush()` to save the replay");
      return;
    }
    DEBUG_BUILD && debug.infoTick("Starting replay in session mode");
    this._updateUserActivity();
    const session = loadOrCreateSession(
      {
        maxReplayDuration: this._options.maxReplayDuration,
        sessionIdleExpire: this.timeouts.sessionIdleExpire
      },
      {
        stickySession: this._options.stickySession,
        // This is intentional: create a new session-based replay when calling `start()`
        sessionSampleRate: 1,
        allowBuffering: false
      }
    );
    this.session = session;
    this.recordingMode = "session";
    this._initializeRecording();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */
  startBuffering() {
    if (this._isEnabled) {
      DEBUG_BUILD && debug.log("Buffering is in progress, call `flush()` to save the replay");
      return;
    }
    DEBUG_BUILD && debug.infoTick("Starting replay in buffer mode");
    const session = loadOrCreateSession(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: 0,
        allowBuffering: true
      }
    );
    this.session = session;
    this.recordingMode = "buffer";
    this._initializeRecording();
  }
  /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */
  startRecording() {
    try {
      const canvasOptions = this._canvas;
      this._stopRecording = record({
        ...this._recordingOptions,
        // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
        // Without this, it would record forever, until an error happens, which we don't want
        // instead, we'll always keep the last 60 seconds of replay before an error happened
        ...this.recordingMode === "buffer" ? { checkoutEveryNms: BUFFER_CHECKOUT_TIME } : (
          // Otherwise, use experimental option w/ min checkout time of 6 minutes
          // This is to improve playback seeking as there could potentially be
          // less mutations to process in the worse cases.
          //
          // checkout by "N" events is probably ideal, but means we have less
          // control about the number of checkouts we make (which generally
          // increases replay size)
          this._options._experiments.continuousCheckout && {
            // Minimum checkout time is 6 minutes
            checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout)
          }
        ),
        emit: getHandleRecordingEmit(this),
        ...getRecordingSamplingOptions(),
        onMutation: this._onMutationHandler.bind(this),
        ...canvasOptions ? {
          recordCanvas: canvasOptions.recordCanvas,
          getCanvasManager: canvasOptions.getCanvasManager,
          sampling: canvasOptions.sampling,
          dataURLOptions: canvasOptions.dataURLOptions
        } : {}
      });
    } catch (err) {
      this.handleException(err);
    }
  }
  /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */
  stopRecording() {
    try {
      if (this._stopRecording) {
        this._stopRecording();
        this._stopRecording = void 0;
      }
      return true;
    } catch (err) {
      this.handleException(err);
      return false;
    }
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  async stop({
    forceFlush = false,
    reason
  } = {}) {
    if (!this._isEnabled) {
      return;
    }
    this._isEnabled = false;
    this.recordingMode = "buffer";
    const stopReason = reason ?? "manual";
    (0,currentScopes/* getClient */.KU)()?.emit("replayEnd", { sessionId: this.session?.id, reason: stopReason });
    try {
      DEBUG_BUILD && debug.log(`Stopping Replay triggered by ${stopReason}`);
      resetReplayIdOnDynamicSamplingContext();
      this._removeListeners();
      this.stopRecording();
      this._debouncedFlush.cancel();
      if (forceFlush) {
        await this._flush({ force: true });
      }
      this.eventBuffer?.destroy();
      this.eventBuffer = null;
      clearSession(this);
    } catch (err) {
      this.handleException(err);
    }
  }
  /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */
  pause() {
    if (this._isPaused) {
      return;
    }
    this._isPaused = true;
    this.stopRecording();
    DEBUG_BUILD && debug.log("Pausing replay");
  }
  /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */
  resume() {
    if (!this._isPaused || !this._checkSession()) {
      return;
    }
    this._isPaused = false;
    this.startRecording();
    DEBUG_BUILD && debug.log("Resuming replay");
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  async sendBufferedReplayOrFlush({ continueRecording = true } = {}) {
    if (this.recordingMode === "session") {
      return this.flushImmediate();
    }
    const activityTime = Date.now();
    DEBUG_BUILD && debug.log("Converting buffer to session");
    await this.flushImmediate();
    const hasStoppedRecording = this.stopRecording();
    if (!continueRecording || !hasStoppedRecording) {
      return;
    }
    if (this.recordingMode === "session") {
      return;
    }
    this.recordingMode = "session";
    if (this.session) {
      this.session.dirty = false;
      this._updateUserActivity(activityTime);
      this._updateSessionActivity(activityTime);
      this._maybeSaveSession();
      setReplayIdOnDynamicSamplingContext(this.session.id);
    }
    this.startRecording();
  }
  /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */
  addUpdate(cb) {
    const cbResult = cb();
    if (this.recordingMode === "buffer" || !this._isEnabled) {
      return;
    }
    if (cbResult === true) {
      return;
    }
    this._debouncedFlush();
  }
  /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */
  triggerUserActivity() {
    this._updateUserActivity();
    if (!this._stopRecording) {
      if (!this._checkSession()) {
        return;
      }
      this.resume();
      return;
    }
    this.checkAndHandleExpiredSession();
    this._updateSessionActivity();
  }
  /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */
  updateUserActivity() {
    this._updateUserActivity();
    this._updateSessionActivity();
  }
  /**
   * Only flush if `this.recordingMode === 'session'`
   */
  conditionalFlush() {
    if (this.recordingMode === "buffer") {
      return Promise.resolve();
    }
    return this.flushImmediate();
  }
  /**
   * Flush using debounce flush
   */
  flush() {
    return this._debouncedFlush();
  }
  /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of multiple flushes happening closely together.
   */
  flushImmediate() {
    this._debouncedFlush();
    return this._debouncedFlush.flush();
  }
  /**
   * Cancels queued up flushes.
   */
  cancelFlush() {
    this._debouncedFlush.cancel();
  }
  /** Get the current session (=replay) ID
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   */
  getSessionId(onlyIfSampled) {
    if (onlyIfSampled && this.session?.sampled === false) {
      return void 0;
    }
    return this.session?.id;
  }
  /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */
  checkAndHandleExpiredSession() {
    if (this._lastActivity && isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session?.sampled === "session") {
      this.pause();
      return;
    }
    if (!this._checkSession()) {
      return false;
    }
    return true;
  }
  /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */
  setInitialState() {
    const urlPath = `${WINDOW.location.pathname}${WINDOW.location.hash}${WINDOW.location.search}`;
    const url = `${WINDOW.location.origin}${urlPath}`;
    this.performanceEntries = [];
    this.replayPerformanceEntries = [];
    this._clearContext();
    this._context.initialUrl = url;
    this._context.initialTimestamp = Date.now();
    this._context.urls.push(url);
  }
  /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */
  throttledAddEvent(event, isCheckout) {
    const res = this._throttledAddEvent(event, isCheckout);
    if (res === THROTTLED) {
      const breadcrumb = createBreadcrumb({
        category: "replay.throttled"
      });
      this.addUpdate(() => {
        return !addEventSync(this, {
          type: ReplayEventTypeCustom,
          timestamp: breadcrumb.timestamp || 0,
          data: {
            tag: "breadcrumb",
            payload: breadcrumb,
            metric: true
          }
        });
      });
    }
    return res;
  }
  /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */
  getCurrentRoute() {
    const lastActiveSpan = this.lastActiveSpan || (0,spanUtils/* getActiveSpan */.Bk)();
    const lastRootSpan = lastActiveSpan && (0,spanUtils/* getRootSpan */.zU)(lastActiveSpan);
    const attributes = lastRootSpan && (0,spanUtils/* spanToJSON */.et)(lastRootSpan).data || {};
    const source = attributes[semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.i_];
    if (!lastRootSpan || !source || !["route", "custom"].includes(source)) {
      return void 0;
    }
    return (0,spanUtils/* spanToJSON */.et)(lastRootSpan).description;
  }
  /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */
  _initializeRecording() {
    this.setInitialState();
    this._updateSessionActivity();
    this.eventBuffer = createEventBuffer({
      useCompression: this._options.useCompression,
      workerUrl: this._options.workerUrl
    });
    this._removeListeners();
    this._addListeners();
    this._isEnabled = true;
    this._isPaused = false;
    if (this.session) {
      (0,currentScopes/* getClient */.KU)()?.emit("replayStart", {
        sessionId: this.session.id,
        recordingMode: this.recordingMode
      });
    }
    this.startRecording();
    if (this.recordingMode === "session" && this.session) {
      setReplayIdOnDynamicSamplingContext(this.session.id);
    }
  }
  /**
   * Loads (or refreshes) the current session.
   */
  _initializeSessionForSampling(previousSessionId) {
    const allowBuffering = this._options.errorSampleRate > 0;
    const session = loadOrCreateSession(
      {
        sessionIdleExpire: this.timeouts.sessionIdleExpire,
        maxReplayDuration: this._options.maxReplayDuration,
        previousSessionId
      },
      {
        stickySession: this._options.stickySession,
        sessionSampleRate: this._options.sessionSampleRate,
        allowBuffering
      }
    );
    this.session = session;
  }
  /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */
  _checkSession() {
    if (!this.session) {
      return false;
    }
    const currentSession = this.session;
    if (shouldRefreshSession(currentSession, {
      sessionIdleExpire: this.timeouts.sessionIdleExpire,
      maxReplayDuration: this._options.maxReplayDuration
    })) {
      this._refreshSession(currentSession);
      return false;
    }
    return true;
  }
  /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */
  async _refreshSession(session) {
    if (!this._isEnabled) {
      return;
    }
    await this.stop({ reason: "sessionExpired" });
    this.initializeSampling(session.id);
  }
  /**
   * Adds listeners to record events for the replay
   */
  _addListeners() {
    try {
      WINDOW.document.addEventListener("visibilitychange", this._handleVisibilityChange);
      WINDOW.addEventListener("blur", this._handleWindowBlur);
      WINDOW.addEventListener("focus", this._handleWindowFocus);
      WINDOW.addEventListener("keydown", this._handleKeyboardEvent);
      if (this.clickDetector) {
        this.clickDetector.addListeners();
      }
      if (!this._hasInitializedCoreListeners) {
        addGlobalListeners(this);
        this._hasInitializedCoreListeners = true;
      }
    } catch (err) {
      this.handleException(err);
    }
    this._performanceCleanupCallback = setupPerformanceObserver(this);
  }
  /**
   * Cleans up listeners that were created in `_addListeners`
   */
  _removeListeners() {
    try {
      WINDOW.document.removeEventListener("visibilitychange", this._handleVisibilityChange);
      WINDOW.removeEventListener("blur", this._handleWindowBlur);
      WINDOW.removeEventListener("focus", this._handleWindowFocus);
      WINDOW.removeEventListener("keydown", this._handleKeyboardEvent);
      if (this.clickDetector) {
        this.clickDetector.removeListeners();
      }
      if (this._performanceCleanupCallback) {
        this._performanceCleanupCallback();
      }
    } catch (err) {
      this.handleException(err);
    }
  }
  /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */
  _doChangeToBackgroundTasks(breadcrumb) {
    if (!this.session) {
      return;
    }
    const expired = shouldRefreshSession(this.session, {
      maxReplayDuration: this._options.maxReplayDuration,
      sessionIdleExpire: this.timeouts.sessionIdleExpire
    });
    if (expired) {
      resetReplayIdOnDynamicSamplingContext();
      return;
    }
    if (breadcrumb) {
      this._createCustomBreadcrumb(breadcrumb);
    }
    void this.conditionalFlush();
  }
  /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */
  _doChangeToForegroundTasks(breadcrumb) {
    if (!this.session) {
      return;
    }
    const isSessionActive = this.checkAndHandleExpiredSession();
    if (!isSessionActive) {
      DEBUG_BUILD && debug.log("Document has become active, but session has expired");
      return;
    }
    if (breadcrumb) {
      this._createCustomBreadcrumb(breadcrumb);
    }
  }
  /**
   * Update user activity (across session lifespans)
   */
  _updateUserActivity(_lastActivity = Date.now()) {
    this._lastActivity = _lastActivity;
  }
  /**
   * Updates the session's last activity timestamp
   */
  _updateSessionActivity(_lastActivity = Date.now()) {
    if (this.session) {
      this.session.lastActivity = _lastActivity;
      this._maybeSaveSession();
    }
  }
  /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */
  _createCustomBreadcrumb(breadcrumb) {
    this.addUpdate(() => {
      this.throttledAddEvent({
        type: EventType.Custom,
        timestamp: breadcrumb.timestamp || 0,
        data: {
          tag: "breadcrumb",
          payload: breadcrumb
        }
      });
    });
  }
  /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */
  _addPerformanceEntries() {
    let performanceEntries = createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
    this.performanceEntries = [];
    this.replayPerformanceEntries = [];
    if (this._requiresManualStart) {
      const initialTimestampInSeconds = this._context.initialTimestamp / 1e3;
      performanceEntries = performanceEntries.filter((entry) => entry.start >= initialTimestampInSeconds);
    }
    return Promise.all(createPerformanceSpans(this, performanceEntries));
  }
  /**
   * Clear _context
   */
  _clearContext() {
    this._context.errorIds.clear();
    this._context.traceIds.clear();
    this._context.urls = [];
  }
  /** Update the initial timestamp based on the buffer content. */
  _updateInitialTimestampFromEventBuffer() {
    const { session, eventBuffer } = this;
    if (!session || !eventBuffer || this._requiresManualStart) {
      return;
    }
    if (session.segmentId) {
      return;
    }
    const earliestEvent = eventBuffer.getEarliestTimestamp();
    if (earliestEvent && earliestEvent < this._context.initialTimestamp) {
      this._context.initialTimestamp = earliestEvent;
    }
  }
  /**
   * Return and clear _context
   */
  _popEventContext() {
    const _context = {
      initialTimestamp: this._context.initialTimestamp,
      initialUrl: this._context.initialUrl,
      errorIds: Array.from(this._context.errorIds),
      traceIds: Array.from(this._context.traceIds),
      urls: this._context.urls
    };
    this._clearContext();
    return _context;
  }
  /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */
  async _runFlush() {
    const replayId = this.getSessionId();
    if (!this.session || !this.eventBuffer || !replayId) {
      DEBUG_BUILD && debug.error("No session or eventBuffer found to flush.");
      return;
    }
    await this._addPerformanceEntries();
    if (!this.eventBuffer?.hasEvents) {
      return;
    }
    await addMemoryEntry(this);
    if (!this.eventBuffer) {
      return;
    }
    if (replayId !== this.getSessionId()) {
      return;
    }
    try {
      this._updateInitialTimestampFromEventBuffer();
      const timestamp = Date.now();
      if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4) {
        throw new ReplayDurationLimitError();
      }
      const eventContext = this._popEventContext();
      const segmentId = this.session.segmentId++;
      this._maybeSaveSession();
      const recordingData = await this.eventBuffer.finish();
      await sendReplay({
        replayId,
        recordingData,
        segmentId,
        eventContext,
        session: this.session,
        timestamp,
        onError: (err) => this.handleException(err)
      });
    } catch (err) {
      this.handleException(err);
      this.stop({ reason: "sendError" });
      const client = (0,currentScopes/* getClient */.KU)();
      if (client) {
        let dropReason;
        if (err instanceof RateLimitError) {
          dropReason = "ratelimit_backoff";
        } else if (err instanceof ReplayDurationLimitError) {
          dropReason = "invalid";
        } else {
          dropReason = "send_error";
        }
        client.recordDroppedEvent(dropReason, "replay");
      }
    }
  }
  /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */
  async _flush({
    force = false
  } = {}) {
    if (!this._isEnabled && !force) {
      return;
    }
    if (!this.checkAndHandleExpiredSession()) {
      DEBUG_BUILD && debug.error("Attempting to finish replay event after session expired.");
      return;
    }
    if (!this.session) {
      return;
    }
    const start = this.session.started;
    const now = Date.now();
    const duration = now - start;
    this._debouncedFlush.cancel();
    const tooShort = duration < this._options.minReplayDuration;
    const tooLong = duration > this._options.maxReplayDuration + 5e3;
    if (tooShort || tooLong) {
      DEBUG_BUILD && debug.log(
        `Session duration (${Math.floor(duration / 1e3)}s) is too ${tooShort ? "short" : "long"}, not sending replay.`
      );
      if (tooShort) {
        this._debouncedFlush();
      }
      return;
    }
    const eventBuffer = this.eventBuffer;
    if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) {
      DEBUG_BUILD && debug.log("Flushing initial segment without checkout.");
    }
    const _flushInProgress = !!this._flushLock;
    if (!this._flushLock) {
      this._flushLock = this._runFlush();
    }
    try {
      await this._flushLock;
    } catch (err) {
      this.handleException(err);
    } finally {
      this._flushLock = void 0;
      if (_flushInProgress) {
        this._debouncedFlush();
      }
    }
  }
  /** Save the session, if it is sticky */
  _maybeSaveSession() {
    if (this.session && this._options.stickySession) {
      saveSession(this.session);
    }
  }
  /** Handler for rrweb.record.onMutation */
  _onMutationHandler(mutations) {
    const { ignoreMutations } = this._options._experiments;
    if (ignoreMutations?.length) {
      if (mutations.some((mutation) => {
        const el = closestElementOfNode(mutation.target);
        const selector = ignoreMutations.join(",");
        return el?.matches(selector);
      })) {
        return false;
      }
    }
    const count = mutations.length;
    const mutationLimit = this._options.mutationLimit;
    const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
    const overMutationLimit = mutationLimit && count > mutationLimit;
    if (count > mutationBreadcrumbLimit || overMutationLimit) {
      const breadcrumb = createBreadcrumb({
        category: "replay.mutations",
        data: {
          count,
          limit: overMutationLimit
        }
      });
      this._createCustomBreadcrumb(breadcrumb);
    }
    if (overMutationLimit) {
      this.stop({ reason: "mutationLimit", forceFlush: this.recordingMode === "session" });
      return false;
    }
    return true;
  }
}
function getOption(selectors, defaultSelectors) {
  return [
    ...selectors,
    // sentry defaults
    ...defaultSelectors
  ].join(",");
}
function getPrivacyOptions({ mask, unmask, block, unblock, ignore }) {
  const defaultBlockedElements = ["base", "iframe[srcdoc]:not([src])"];
  const maskSelector = getOption(mask, [".sentry-mask", "[data-sentry-mask]"]);
  const unmaskSelector = getOption(unmask, []);
  const options = {
    // We are making the decision to make text and input selectors the same
    maskTextSelector: maskSelector,
    unmaskTextSelector: unmaskSelector,
    blockSelector: getOption(block, [".sentry-block", "[data-sentry-block]", ...defaultBlockedElements]),
    unblockSelector: getOption(unblock, []),
    ignoreSelector: getOption(ignore, [".sentry-ignore", "[data-sentry-ignore]", 'input[type="file"]'])
  };
  return options;
}
function maskAttribute({
  el,
  key,
  maskAttributes,
  maskAllText,
  privacyOptions,
  value
}) {
  if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) {
    return value;
  }
  const masksNamedAttribute = maskAttributes.includes(key);
  const masksSubmitButtonValue = maskAllText && key === "value" && el.tagName === "INPUT" && ["submit", "button"].includes(el.getAttribute("type") || "");
  if (masksNamedAttribute || masksSubmitButtonValue) {
    return value.replace(/[\S]/g, "*");
  }
  return value;
}
const MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const DEFAULT_NETWORK_HEADERS = ["content-length", "content-type", "accept"];
const ORIGINAL_BODY = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
let _initialized = false;
let _isRequestInstrumented = false;
function _INTERNAL_instrumentRequestInterface() {
  if (typeof Request === "undefined" || _isRequestInstrumented) {
    return;
  }
  const OriginalRequest = Request;
  try {
    const SentryRequest = function(input, init) {
      const request = new OriginalRequest(input, init);
      if (init?.body != null) {
        request[ORIGINAL_BODY] = init.body;
      }
      return request;
    };
    SentryRequest.prototype = OriginalRequest.prototype;
    worldwide/* GLOBAL_OBJ */.O.Request = SentryRequest;
    _isRequestInstrumented = true;
  } catch {
  }
}
const replayIntegration = ((options) => {
  return new Replay(options);
});
class Replay {
  constructor({
    flushMinDelay = DEFAULT_FLUSH_MIN_DELAY,
    flushMaxDelay = DEFAULT_FLUSH_MAX_DELAY,
    minReplayDuration = MIN_REPLAY_DURATION,
    maxReplayDuration = MAX_REPLAY_DURATION,
    stickySession = true,
    useCompression = true,
    workerUrl,
    _experiments = {},
    maskAllText = true,
    maskAllInputs = true,
    blockAllMedia = true,
    mutationBreadcrumbLimit = 750,
    mutationLimit = 1e4,
    slowClickTimeout = 7e3,
    slowClickIgnoreSelectors = [],
    networkDetailAllowUrls = [],
    networkDetailDenyUrls = [],
    networkCaptureBodies = true,
    networkRequestHeaders = [],
    networkResponseHeaders = [],
    mask = [],
    maskAttributes = ["title", "placeholder", "aria-label"],
    unmask = [],
    block = [],
    unblock = [],
    ignore = [],
    maskFn,
    beforeAddRecordingEvent,
    beforeErrorSampling,
    onError,
    attachRawBodyFromRequest = false
  } = {}) {
    this.name = "Replay";
    const privacyOptions = getPrivacyOptions({
      mask,
      unmask,
      block,
      unblock,
      ignore
    });
    this._recordingOptions = {
      maskAllInputs,
      maskAllText,
      maskInputOptions: { password: true },
      maskTextFn: maskFn,
      maskInputFn: maskFn,
      maskAttributeFn: (key, value, el) => maskAttribute({
        maskAttributes,
        maskAllText,
        privacyOptions,
        key,
        value,
        el
      }),
      ...privacyOptions,
      // Our defaults
      slimDOMOptions: "all",
      inlineStylesheet: true,
      // Disable inline images as it will increase segment/replay size
      inlineImages: false,
      // collect fonts, but be aware that `sentry.io` needs to be an allowed
      // origin for playback
      collectFonts: true,
      errorHandler: (err) => {
        try {
          err.__rrweb__ = true;
        } catch {
        }
      },
      // experimental support for recording iframes from different origins
      recordCrossOriginIframes: Boolean(_experiments.recordCrossOriginIframes)
    };
    this._initialOptions = {
      flushMinDelay,
      flushMaxDelay,
      minReplayDuration: Math.min(minReplayDuration, MIN_REPLAY_DURATION_LIMIT),
      maxReplayDuration: Math.min(maxReplayDuration, MAX_REPLAY_DURATION),
      stickySession,
      useCompression,
      workerUrl,
      blockAllMedia,
      maskAllInputs,
      maskAllText,
      mutationBreadcrumbLimit,
      mutationLimit,
      slowClickTimeout,
      slowClickIgnoreSelectors,
      networkDetailAllowUrls,
      networkDetailDenyUrls,
      networkCaptureBodies,
      networkRequestHeaders: _getMergedNetworkHeaders(networkRequestHeaders),
      networkResponseHeaders: _getMergedNetworkHeaders(networkResponseHeaders),
      beforeAddRecordingEvent,
      beforeErrorSampling,
      onError,
      attachRawBodyFromRequest,
      _experiments
    };
    if (this._initialOptions.blockAllMedia) {
      this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${MEDIA_SELECTORS}`;
      this._recordingOptions.ignoreCSSAttributes = /* @__PURE__ */ new Set(["background-image"]);
    }
    if (this._isInitialized && (0,isBrowser/* isBrowser */.B)()) {
      throw new Error("Multiple Sentry Session Replay instances are not supported");
    }
    this._isInitialized = true;
  }
  /** If replay has already been initialized */
  get _isInitialized() {
    return _initialized;
  }
  /** Update _isInitialized */
  set _isInitialized(value) {
    _initialized = value;
  }
  /**
   * Setup and initialize replay container
   */
  afterAllSetup(client) {
    if (!(0,isBrowser/* isBrowser */.B)() || this._replay) {
      return;
    }
    if (this._initialOptions.attachRawBodyFromRequest) {
      _INTERNAL_instrumentRequestInterface();
    }
    this._setup(client);
    this._initialize(client);
  }
  /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will log a message if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */
  start() {
    if (!this._replay) {
      return;
    }
    this._replay.start();
  }
  /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */
  startBuffering() {
    if (!this._replay) {
      return;
    }
    this._replay.startBuffering();
  }
  /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */
  stop() {
    if (!this._replay) {
      return Promise.resolve();
    }
    return this._replay.stop({ forceFlush: this._replay.recordingMode === "session", reason: "manual" });
  }
  /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * If replay is not enabled, a new session replay is started.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */
  flush(options) {
    if (!this._replay) {
      return Promise.resolve();
    }
    if (!this._replay.isEnabled()) {
      this._replay.start();
      return Promise.resolve();
    }
    return this._replay.sendBufferedReplayOrFlush(options);
  }
  /**
   * Get the current session ID.
   *
   * @param onlyIfSampled - If true, will only return the session ID if the session is sampled.
   *
   */
  getReplayId(onlyIfSampled) {
    if (!this._replay?.isEnabled()) {
      return;
    }
    return this._replay.getSessionId(onlyIfSampled);
  }
  /**
   * Get the current recording mode. This can be either `session` or `buffer`.
   *
   * `session`: Recording the whole session, sending it continuously
   * `buffer`: Always keeping the last 60s of recording, requires:
   *   - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *   - or calling `flush()` to send the replay
   */
  getRecordingMode() {
    if (!this._replay?.isEnabled()) {
      return;
    }
    return this._replay.recordingMode;
  }
  processSpan(span) {
    const replayId = this.getReplayId(true);
    if (replayId) {
      (0,captureSpan/* safeSetSpanJSONAttributes */.FD)(span, { "sentry.replay_id": replayId });
      if (this.getRecordingMode() === "buffer") {
        (0,captureSpan/* safeSetSpanJSONAttributes */.FD)(span, { "sentry._internal.replay_is_buffering": true });
      }
    }
  }
  /**
   * Initializes replay.
   */
  _initialize(client) {
    if (!this._replay) {
      return;
    }
    this._maybeLoadFromReplayCanvasIntegration(client);
    this._replay.initializeSampling();
  }
  /** Setup the integration. */
  _setup(client) {
    const finalOptions = loadReplayOptionsFromClient(this._initialOptions, client);
    this._replay = new ReplayContainer({
      options: finalOptions,
      recordingOptions: this._recordingOptions
    });
  }
  /** Get canvas options from ReplayCanvas integration, if it is also added. */
  _maybeLoadFromReplayCanvasIntegration(client) {
    try {
      const canvasIntegration = client.getIntegrationByName("ReplayCanvas");
      if (!canvasIntegration) {
        return;
      }
      this._replay["_canvas"] = canvasIntegration.getOptions();
    } catch {
    }
  }
}
function loadReplayOptionsFromClient(initialOptions, client) {
  const opt = client.getOptions();
  const finalOptions = {
    sessionSampleRate: 0,
    errorSampleRate: 0,
    ...initialOptions
  };
  const replaysSessionSampleRate = (0,parseSampleRate/* parseSampleRate */.i)(opt.replaysSessionSampleRate);
  const replaysOnErrorSampleRate = (0,parseSampleRate/* parseSampleRate */.i)(opt.replaysOnErrorSampleRate);
  if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) {
    (0,debug_logger/* consoleSandbox */.pq)(() => {
      console.warn(
        "Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set."
      );
    });
  }
  if (replaysSessionSampleRate != null) {
    finalOptions.sessionSampleRate = replaysSessionSampleRate;
  }
  if (replaysOnErrorSampleRate != null) {
    finalOptions.errorSampleRate = replaysOnErrorSampleRate;
  }
  return finalOptions;
}
function _getMergedNetworkHeaders(headers) {
  return [...DEFAULT_NETWORK_HEADERS, ...headers.map((header) => header.toLowerCase())];
}
function getReplay() {
  const client = (0,currentScopes/* getClient */.KU)();
  return client?.getIntegrationByName("Replay");
}



/***/ }),

/***/ 31719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   clsx: function() { return /* binding */ clsx; }
/* harmony export */ });
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e) n += e;
  else if ("object" == typeof e) if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
  else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length; ) (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
/* harmony default export */ __webpack_exports__["default"] = (clsx);


/***/ }),

/***/ 59676:
/***/ (function(module) {

"use strict";

module.exports = function(cssWithMappingToString) {
  var list = [];
  list.toString = function toString() {
    return this.map(function(item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, void 0]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};


/***/ }),

/***/ 32919:
/***/ (function(module) {

"use strict";

module.exports = function(url, options) {
  if (!options) {
    options = {};
  }
  if (!url) {
    return url;
  }
  url = String(url.__esModule ? url.default : url);
  if (/^['"].*['"]$/.test(url)) {
    url = url.slice(1, -1);
  }
  if (options.hash) {
    url += options.hash;
  }
  if (/["'() \t\n]|(%20)/.test(url) || options.needQuotes) {
    return '"'.concat(url.replace(/"/g, '\\"').replace(/\n/g, "\\n"), '"');
  }
  return url;
};


/***/ }),

/***/ 90660:
/***/ (function(module) {

"use strict";

module.exports = function(item) {
  var content = item[1];
  var cssMapping = item[3];
  if (!cssMapping) {
    return content;
  }
  if (typeof btoa === "function") {
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    return [content].concat([sourceMapping]).join("\n");
  }
  return [content].join("\n");
};


/***/ }),

/***/ 60396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  zR: function() { return /* binding */ createBrowserHistory; },
  TM: function() { return /* binding */ createHashHistory; },
  yJ: function() { return /* binding */ createLocation; },
  sC: function() { return /* binding */ createMemoryHistory; },
  AO: function() { return /* binding */ createPath; },
  Fu: function() { return /* binding */ locationsAreEqual; }
});

// UNUSED EXPORTS: parsePath

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
;// ./node_modules/resolve-pathname/esm/resolve-pathname.js
function isAbsolute(pathname) {
  return pathname.charAt(0) === "/";
}
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }
  list.pop();
}
function resolvePathname(to, from) {
  if (from === void 0) from = "";
  var toParts = to && to.split("/") || [];
  var fromParts = from && from.split("/") || [];
  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;
  if (to && isAbsolute(to)) {
    fromParts = toParts;
  } else if (toParts.length) {
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }
  if (!fromParts.length) return "/";
  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === "." || last === ".." || last === "";
  } else {
    hasTrailingSlash = false;
  }
  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];
    if (part === ".") {
      spliceOne(fromParts, i);
    } else if (part === "..") {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }
  if (!mustEndAbs) for (; up--; up) fromParts.unshift("..");
  if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !isAbsolute(fromParts[0])))
    fromParts.unshift("");
  var result = fromParts.join("/");
  if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
  return result;
}
/* harmony default export */ var resolve_pathname = (resolvePathname);

;// ./node_modules/value-equal/esm/value-equal.js
function value_equal_valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function valueEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
      return valueEqual(item, b[index]);
    });
  }
  if (typeof a === "object" || typeof b === "object") {
    var aValue = value_equal_valueOf(a);
    var bValue = value_equal_valueOf(b);
    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }
  return false;
}
/* harmony default export */ var value_equal = (valueEqual);

// EXTERNAL MODULE: ./node_modules/tiny-invariant/dist/esm/tiny-invariant.js
var tiny_invariant = __webpack_require__(51910);
;// ./node_modules/history/esm/history.js





function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === "/" ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || "/";
  var search = "";
  var hash = "";
  var hashIndex = pathname.indexOf("#");
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }
  var searchIndex = pathname.indexOf("?");
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }
  return {
    pathname,
    search: search === "?" ? "" : search,
    hash: hash === "#" ? "" : hash
  };
}
function createPath(location) {
  var pathname = location.pathname, search = location.search, hash = location.hash;
  var path = pathname || "/";
  if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
  if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
  return path;
}
function createLocation(path, state, key, currentLocation) {
  var location;
  if (typeof path === "string") {
    location = parsePath(path);
    location.state = state;
  } else {
    location = (0,esm_extends/* default */.A)({}, path);
    if (location.pathname === void 0) location.pathname = "";
    if (location.search) {
      if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
    } else {
      location.search = "";
    }
    if (location.hash) {
      if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
    } else {
      location.hash = "";
    }
    if (state !== void 0 && location.state === void 0) location.state = state;
  }
  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }
  if (key) location.key = key;
  if (currentLocation) {
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== "/") {
      location.pathname = resolve_pathname(location.pathname, currentLocation.pathname);
    }
  } else {
    if (!location.pathname) {
      location.pathname = "/";
    }
  }
  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && value_equal(a.state, b.state);
}
function createTransitionManager() {
  var prompt = null;
  function setPrompt(nextPrompt) {
     false ? 0 : void 0;
    prompt = nextPrompt;
    return function() {
      if (prompt === nextPrompt) prompt = null;
    };
  }
  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    if (prompt != null) {
      var result = typeof prompt === "function" ? prompt(location, action) : prompt;
      if (typeof result === "string") {
        if (typeof getUserConfirmation === "function") {
          getUserConfirmation(result, callback);
        } else {
           false ? 0 : void 0;
          callback(true);
        }
      } else {
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }
  var listeners = [];
  function appendListener(fn) {
    var isActive = true;
    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }
    listeners.push(listener);
    return function() {
      isActive = false;
      listeners = listeners.filter(function(item) {
        return item !== listener;
      });
    };
  }
  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    listeners.forEach(function(listener) {
      return listener.apply(void 0, args);
    });
  }
  return {
    setPrompt,
    confirmTransitionTo,
    appendListener,
    notifyListeners
  };
}
var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message));
}
function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
  return window.history && "pushState" in window.history;
}
function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf("Trident") === -1;
}
function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf("Firefox") === -1;
}
function isExtraneousPopstateEvent(event) {
  return event.state === void 0 && navigator.userAgent.indexOf("CriOS") === -1;
}
var PopStateEvent = "popstate";
var HashChangeEvent = "hashchange";
function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    return {};
  }
}
function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }
  !canUseDOM ?  false ? 0 : (0,tiny_invariant/* default */.A)(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
  function getDOMLocation(historyState) {
    var _ref = historyState || {}, key = _ref.key, state = _ref.state;
    var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? 0 : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }
  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }
  var transitionManager = createTransitionManager();
  function setState(nextState) {
    (0,esm_extends/* default */.A)(history, nextState);
    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }
  function handlePopState(event) {
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }
  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }
  var forceNextPop = false;
  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = "POP";
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
        if (ok) {
          setState({
            action,
            location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }
  function revertPop(fromLocation) {
    var toLocation = history.location;
    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;
    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }
  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];
  function createHref(location) {
    return basename + createPath(location);
  }
  function push(path, state) {
     false ? 0 : void 0;
    var action = "PUSH";
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key, state2 = location.state;
      if (canUseHistory) {
        globalHistory.pushState({
          key,
          state: state2
        }, null, href);
        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action,
            location
          });
        }
      } else {
         false ? 0 : void 0;
        window.location.href = href;
      }
    });
  }
  function replace(path, state) {
     false ? 0 : void 0;
    var action = "REPLACE";
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key, state2 = location.state;
      if (canUseHistory) {
        globalHistory.replaceState({
          key,
          state: state2
        }, null, href);
        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action,
            location
          });
        }
      } else {
         false ? 0 : void 0;
        window.location.replace(href);
      }
    });
  }
  function go(n) {
    globalHistory.go(n);
  }
  function goBack() {
    go(-1);
  }
  function goForward() {
    go(1);
  }
  var listenerCount = 0;
  function checkDOMListeners(delta) {
    listenerCount += delta;
    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }
  var isBlocked = false;
  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }
    var unblock = transitionManager.setPrompt(prompt);
    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }
    return function() {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }
      return unblock();
    };
  }
  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function() {
      checkDOMListeners(-1);
      unlisten();
    };
  }
  var history = {
    length: globalHistory.length,
    action: "POP",
    location: initialLocation,
    createHref,
    push,
    replace,
    go,
    goBack,
    goForward,
    block,
    listen
  };
  return history;
}
var HashChangeEvent$1 = "hashchange";
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === "!" ? path : "!/" + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === "!" ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};
function stripHash(url) {
  var hashIndex = url.indexOf("#");
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function getHashPath() {
  var href = window.location.href;
  var hashIndex = href.indexOf("#");
  return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function pushHashPath(path) {
  window.location.hash = path;
}
function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + "#" + path);
}
function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }
  !canUseDOM ?  false ? 0 : (0,tiny_invariant/* default */.A)(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : "";
  var _HashPathCoders$hashT = HashPathCoders[hashType], encodePath2 = _HashPathCoders$hashT.encodePath, decodePath2 = _HashPathCoders$hashT.decodePath;
  function getDOMLocation() {
    var path2 = decodePath2(getHashPath());
     false ? 0 : void 0;
    if (basename) path2 = stripBasename(path2, basename);
    return createLocation(path2);
  }
  var transitionManager = createTransitionManager();
  function setState(nextState) {
    (0,esm_extends/* default */.A)(history, nextState);
    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }
  var forceNextPop = false;
  var ignorePath = null;
  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }
  function handleHashChange() {
    var path2 = getHashPath();
    var encodedPath2 = encodePath2(path2);
    if (path2 !== encodedPath2) {
      replaceHashPath(encodedPath2);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return;
      if (ignorePath === createPath(location)) return;
      ignorePath = null;
      handlePop(location);
    }
  }
  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = "POP";
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
        if (ok) {
          setState({
            action,
            location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }
  function revertPop(fromLocation) {
    var toLocation = history.location;
    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;
    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }
  var path = getHashPath();
  var encodedPath = encodePath2(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)];
  function createHref(location) {
    var baseTag = document.querySelector("base");
    var href = "";
    if (baseTag && baseTag.getAttribute("href")) {
      href = stripHash(window.location.href);
    }
    return href + "#" + encodePath2(basename + createPath(location));
  }
  function push(path2, state) {
     false ? 0 : void 0;
    var action = "PUSH";
    var location = createLocation(path2, void 0, void 0, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
      if (!ok) return;
      var path3 = createPath(location);
      var encodedPath2 = encodePath2(basename + path3);
      var hashChanged = getHashPath() !== encodedPath2;
      if (hashChanged) {
        ignorePath = path3;
        pushHashPath(encodedPath2);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path3);
        allPaths = nextPaths;
        setState({
          action,
          location
        });
      } else {
         false ? 0 : void 0;
        setState();
      }
    });
  }
  function replace(path2, state) {
     false ? 0 : void 0;
    var action = "REPLACE";
    var location = createLocation(path2, void 0, void 0, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
      if (!ok) return;
      var path3 = createPath(location);
      var encodedPath2 = encodePath2(basename + path3);
      var hashChanged = getHashPath() !== encodedPath2;
      if (hashChanged) {
        ignorePath = path3;
        replaceHashPath(encodedPath2);
      }
      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path3;
      setState({
        action,
        location
      });
    });
  }
  function go(n) {
     false ? 0 : void 0;
    globalHistory.go(n);
  }
  function goBack() {
    go(-1);
  }
  function goForward() {
    go(1);
  }
  var listenerCount = 0;
  function checkDOMListeners(delta) {
    listenerCount += delta;
    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }
  var isBlocked = false;
  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }
    var unblock = transitionManager.setPrompt(prompt);
    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }
    return function() {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }
      return unblock();
    };
  }
  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function() {
      checkDOMListeners(-1);
      unlisten();
    };
  }
  var history = {
    length: globalHistory.length,
    action: "POP",
    location: initialLocation,
    createHref,
    push,
    replace,
    go,
    goBack,
    goForward,
    block,
    listen
  };
  return history;
}
function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }
  var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? ["/"] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();
  function setState(nextState) {
    (0,esm_extends/* default */.A)(history, nextState);
    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }
  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }
  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function(entry) {
    return typeof entry === "string" ? createLocation(entry, void 0, createKey()) : createLocation(entry, void 0, entry.key || createKey());
  });
  var createHref = createPath;
  function push(path, state) {
     false ? 0 : void 0;
    var action = "PUSH";
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }
      setState({
        action,
        location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }
  function replace(path, state) {
     false ? 0 : void 0;
    var action = "REPLACE";
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action,
        location
      });
    });
  }
  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = "POP";
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
      if (ok) {
        setState({
          action,
          location,
          index: nextIndex
        });
      } else {
        setState();
      }
    });
  }
  function goBack() {
    go(-1);
  }
  function goForward() {
    go(1);
  }
  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }
  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }
    return transitionManager.setPrompt(prompt);
  }
  function listen(listener) {
    return transitionManager.appendListener(listener);
  }
  var history = {
    length: entries.length,
    action: "POP",
    location: entries[index],
    index,
    entries,
    createHref,
    push,
    replace,
    go,
    goBack,
    goForward,
    canGo,
    block,
    listen
  };
  return history;
}



/***/ }),

/***/ 78576:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var reactIs = __webpack_require__(91122);
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  "$$typeof": true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  "$$typeof": true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }
  return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== "string") {
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys = getOwnPropertyNames(sourceComponent);
    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }
    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);
    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];
      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
        try {
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {
        }
      }
    }
  }
  return targetComponent;
}
module.exports = hoistNonReactStatics;


/***/ }),

/***/ 28206:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = "function" === typeof Symbol && Symbol.for, c = b ? /* @__PURE__ */ Symbol.for("react.element") : 60103, d = b ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, e = b ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, f = b ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, g = b ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, h = b ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, k = b ? /* @__PURE__ */ Symbol.for("react.context") : 60110, l = b ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, m = b ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, n = b ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, p = b ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, q = b ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, r = b ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, t = b ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, v = b ? /* @__PURE__ */ Symbol.for("react.block") : 60121, w = b ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, x = b ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, y = b ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
exports.AsyncMode = l;
exports.ConcurrentMode = m;
exports.ContextConsumer = k;
exports.ContextProvider = h;
exports.Element = c;
exports.ForwardRef = n;
exports.Fragment = e;
exports.Lazy = t;
exports.Memo = r;
exports.Portal = d;
exports.Profiler = g;
exports.StrictMode = f;
exports.Suspense = p;
exports.isAsyncMode = function(a) {
  return A(a) || z(a) === l;
};
exports.isConcurrentMode = A;
exports.isContextConsumer = function(a) {
  return z(a) === k;
};
exports.isContextProvider = function(a) {
  return z(a) === h;
};
exports.isElement = function(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
exports.isForwardRef = function(a) {
  return z(a) === n;
};
exports.isFragment = function(a) {
  return z(a) === e;
};
exports.isLazy = function(a) {
  return z(a) === t;
};
exports.isMemo = function(a) {
  return z(a) === r;
};
exports.isPortal = function(a) {
  return z(a) === d;
};
exports.isProfiler = function(a) {
  return z(a) === g;
};
exports.isStrictMode = function(a) {
  return z(a) === f;
};
exports.isSuspense = function(a) {
  return z(a) === p;
};
exports.isValidElementType = function(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
exports.typeOf = z;


/***/ }),

/***/ 91122:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

if (true) {
  module.exports = __webpack_require__(28206);
} else // removed by dead control flow
{}


/***/ }),

/***/ 89068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports changeLanguage, createInstance, dir, exists, getFixedT, hasLoadedNamespace, init, loadLanguages, loadNamespaces, loadResources, reloadResources, setDefaultNamespace, t, use */
const isString = (obj) => typeof obj === "string";
const defer = () => {
  let res;
  let rej;
  const promise = new Promise((resolve, reject) => {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
};
const makeString = (object) => {
  if (object == null) return "";
  return "" + object;
};
const copy = (a, s, t2) => {
  a.forEach((m) => {
    if (s[m]) t2[m] = s[m];
  });
};
const lastOfPathSeparatorRegExp = /###/g;
const cleanKey = (key) => key && key.indexOf("###") > -1 ? key.replace(lastOfPathSeparatorRegExp, ".") : key;
const canNotTraverseDeeper = (object) => !object || isString(object);
const getLastOfPath = (object, path, Empty) => {
  const stack = !isString(path) ? path : path.split(".");
  let stackIndex = 0;
  while (stackIndex < stack.length - 1) {
    if (canNotTraverseDeeper(object)) return {};
    const key = cleanKey(stack[stackIndex]);
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
    ++stackIndex;
  }
  if (canNotTraverseDeeper(object)) return {};
  return {
    obj: object,
    k: cleanKey(stack[stackIndex])
  };
};
const setPath = (object, path, newValue) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  if (obj !== void 0 || path.length === 1) {
    obj[k] = newValue;
    return;
  }
  let e = path[path.length - 1];
  let p = path.slice(0, path.length - 1);
  let last = getLastOfPath(object, p, Object);
  while (last.obj === void 0 && p.length) {
    e = `${p[p.length - 1]}.${e}`;
    p = p.slice(0, p.length - 1);
    last = getLastOfPath(object, p, Object);
    if (last && last.obj && typeof last.obj[`${last.k}.${e}`] !== "undefined") {
      last.obj = void 0;
    }
  }
  last.obj[`${last.k}.${e}`] = newValue;
};
const pushPath = (object, path, newValue, concat) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path, Object);
  obj[k] = obj[k] || [];
  obj[k].push(newValue);
};
const getPath = (object, path) => {
  const {
    obj,
    k
  } = getLastOfPath(object, path);
  if (!obj) return void 0;
  return obj[k];
};
const getPathWithDefaults = (data, defaultData, key) => {
  const value = getPath(data, key);
  if (value !== void 0) {
    return value;
  }
  return getPath(defaultData, key);
};
const deepExtend = (target, source, overwrite) => {
  for (const prop in source) {
    if (prop !== "__proto__" && prop !== "constructor") {
      if (prop in target) {
        if (isString(target[prop]) || target[prop] instanceof String || isString(source[prop]) || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
};
const regexEscape = (str) => str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var _entityMap = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const escape = (data) => {
  if (isString(data)) {
    return data.replace(/[&<>"'\/]/g, (s) => _entityMap[s]);
  }
  return data;
};
class RegExpCache {
  constructor(capacity) {
    this.capacity = capacity;
    this.regExpMap = /* @__PURE__ */ new Map();
    this.regExpQueue = [];
  }
  getRegExp(pattern) {
    const regExpFromCache = this.regExpMap.get(pattern);
    if (regExpFromCache !== void 0) {
      return regExpFromCache;
    }
    const regExpNew = new RegExp(pattern);
    if (this.regExpQueue.length === this.capacity) {
      this.regExpMap.delete(this.regExpQueue.shift());
    }
    this.regExpMap.set(pattern, regExpNew);
    this.regExpQueue.push(pattern);
    return regExpNew;
  }
}
const chars = [" ", ",", "?", "!", ";"];
const looksLikeObjectPathRegExpCache = new RegExpCache(20);
const looksLikeObjectPath = (key, nsSeparator, keySeparator) => {
  nsSeparator = nsSeparator || "";
  keySeparator = keySeparator || "";
  const possibleChars = chars.filter((c) => nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0);
  if (possibleChars.length === 0) return true;
  const r = looksLikeObjectPathRegExpCache.getRegExp(`(${possibleChars.map((c) => c === "?" ? "\\?" : c).join("|")})`);
  let matched = !r.test(key);
  if (!matched) {
    const ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
};
const deepFind = function(obj, path) {
  let keySeparator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!obj) return void 0;
  if (obj[path]) return obj[path];
  const tokens = path.split(keySeparator);
  let current = obj;
  for (let i = 0; i < tokens.length; ) {
    if (!current || typeof current !== "object") {
      return void 0;
    }
    let next;
    let nextPath = "";
    for (let j = i; j < tokens.length; ++j) {
      if (j !== i) {
        nextPath += keySeparator;
      }
      nextPath += tokens[j];
      next = current[nextPath];
      if (next !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof next) > -1 && j < tokens.length - 1) {
          continue;
        }
        i += j - i + 1;
        break;
      }
    }
    current = next;
  }
  return current;
};
const getCleanedCode = (code) => code && code.replace("_", "-");
const consoleLogger = {
  type: "logger",
  log(args) {
    this.output("log", args);
  },
  warn(args) {
    this.output("warn", args);
  },
  error(args) {
    this.output("error", args);
  },
  output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};
class Logger {
  constructor(concreteLogger) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(concreteLogger, options);
  }
  init(concreteLogger) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = options.prefix || "i18next:";
    this.logger = concreteLogger || consoleLogger;
    this.options = options;
    this.debug = options.debug;
  }
  log() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return this.forward(args, "log", "", true);
  }
  warn() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return this.forward(args, "warn", "", true);
  }
  error() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return this.forward(args, "error", "");
  }
  deprecate() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }
    return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
  }
  forward(args, lvl, prefix, debugOnly) {
    if (debugOnly && !this.debug) return null;
    if (isString(args[0])) args[0] = `${prefix}${this.prefix} ${args[0]}`;
    return this.logger[lvl](args);
  }
  create(moduleName) {
    return new Logger(this.logger, {
      ...{
        prefix: `${this.prefix}:${moduleName}:`
      },
      ...this.options
    });
  }
  clone(options) {
    options = options || this.options;
    options.prefix = options.prefix || this.prefix;
    return new Logger(this.logger, options);
  }
}
var baseLogger = new Logger();
class EventEmitter {
  constructor() {
    this.observers = {};
  }
  on(events, listener) {
    events.split(" ").forEach((event) => {
      if (!this.observers[event]) this.observers[event] = /* @__PURE__ */ new Map();
      const numListeners = this.observers[event].get(listener) || 0;
      this.observers[event].set(listener, numListeners + 1);
    });
    return this;
  }
  off(event, listener) {
    if (!this.observers[event]) return;
    if (!listener) {
      delete this.observers[event];
      return;
    }
    this.observers[event].delete(listener);
  }
  emit(event) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (this.observers[event]) {
      const cloned = Array.from(this.observers[event].entries());
      cloned.forEach((_ref) => {
        let [observer, numTimesAdded] = _ref;
        for (let i = 0; i < numTimesAdded; i++) {
          observer(...args);
        }
      });
    }
    if (this.observers["*"]) {
      const cloned = Array.from(this.observers["*"].entries());
      cloned.forEach((_ref2) => {
        let [observer, numTimesAdded] = _ref2;
        for (let i = 0; i < numTimesAdded; i++) {
          observer.apply(observer, [event, ...args]);
        }
      });
    }
  }
}
class ResourceStore extends EventEmitter {
  constructor(data) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super();
    this.data = data || {};
    this.options = options;
    if (this.options.keySeparator === void 0) {
      this.options.keySeparator = ".";
    }
    if (this.options.ignoreJSONStructure === void 0) {
      this.options.ignoreJSONStructure = true;
    }
  }
  addNamespaces(ns) {
    if (this.options.ns.indexOf(ns) < 0) {
      this.options.ns.push(ns);
    }
  }
  removeNamespaces(ns) {
    const index = this.options.ns.indexOf(ns);
    if (index > -1) {
      this.options.ns.splice(index, 1);
    }
  }
  getResource(lng, ns, key) {
    let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
    const ignoreJSONStructure = options.ignoreJSONStructure !== void 0 ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let path;
    if (lng.indexOf(".") > -1) {
      path = lng.split(".");
    } else {
      path = [lng, ns];
      if (key) {
        if (Array.isArray(key)) {
          path.push(...key);
        } else if (isString(key) && keySeparator) {
          path.push(...key.split(keySeparator));
        } else {
          path.push(key);
        }
      }
    }
    const result = getPath(this.data, path);
    if (!result && !ns && !key && lng.indexOf(".") > -1) {
      lng = path[0];
      ns = path[1];
      key = path.slice(2).join(".");
    }
    if (result || !ignoreJSONStructure || !isString(key)) return result;
    return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
  }
  addResource(lng, ns, key, value) {
    let options = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: false
    };
    const keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
    let path = [lng, ns];
    if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
    if (lng.indexOf(".") > -1) {
      path = lng.split(".");
      value = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    setPath(this.data, path, value);
    if (!options.silent) this.emit("added", lng, ns, key, value);
  }
  addResources(lng, ns, resources) {
    let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: false
    };
    for (const m in resources) {
      if (isString(resources[m]) || Array.isArray(resources[m])) this.addResource(lng, ns, m, resources[m], {
        silent: true
      });
    }
    if (!options.silent) this.emit("added", lng, ns, resources);
  }
  addResourceBundle(lng, ns, resources, deep, overwrite) {
    let options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: false,
      skipCopy: false
    };
    let path = [lng, ns];
    if (lng.indexOf(".") > -1) {
      path = lng.split(".");
      deep = resources;
      resources = ns;
      ns = path[1];
    }
    this.addNamespaces(ns);
    let pack = getPath(this.data, path) || {};
    if (!options.skipCopy) resources = JSON.parse(JSON.stringify(resources));
    if (deep) {
      deepExtend(pack, resources, overwrite);
    } else {
      pack = {
        ...pack,
        ...resources
      };
    }
    setPath(this.data, path, pack);
    if (!options.silent) this.emit("added", lng, ns, resources);
  }
  removeResourceBundle(lng, ns) {
    if (this.hasResourceBundle(lng, ns)) {
      delete this.data[lng][ns];
    }
    this.removeNamespaces(ns);
    this.emit("removed", lng, ns);
  }
  hasResourceBundle(lng, ns) {
    return this.getResource(lng, ns) !== void 0;
  }
  getResourceBundle(lng, ns) {
    if (!ns) ns = this.options.defaultNS;
    if (this.options.compatibilityAPI === "v1") return {
      ...{},
      ...this.getResource(lng, ns)
    };
    return this.getResource(lng, ns);
  }
  getDataByLanguage(lng) {
    return this.data[lng];
  }
  hasLanguageSomeTranslations(lng) {
    const data = this.getDataByLanguage(lng);
    const n = data && Object.keys(data) || [];
    return !!n.find((v) => data[v] && Object.keys(data[v]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var postProcessor = {
  processors: {},
  addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle(processors, value, key, options, translator) {
    processors.forEach((processor) => {
      if (this.processors[processor]) value = this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};
const checkedLoadedFor = {};
class Translator extends EventEmitter {
  constructor(services) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super();
    copy(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], services, this);
    this.options = options;
    if (this.options.keySeparator === void 0) {
      this.options.keySeparator = ".";
    }
    this.logger = baseLogger.create("translator");
  }
  changeLanguage(lng) {
    if (lng) this.language = lng;
  }
  exists(key) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (key === void 0 || key === null) {
      return false;
    }
    const resolved = this.resolve(key, options);
    return resolved && resolved.res !== void 0;
  }
  extractFromKey(key, options) {
    let nsSeparator = options.nsSeparator !== void 0 ? options.nsSeparator : this.options.nsSeparator;
    if (nsSeparator === void 0) nsSeparator = ":";
    const keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
    let namespaces = options.ns || this.options.defaultNS || [];
    const wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
    const seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
    if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
      const m = key.match(this.interpolator.nestingRegexp);
      if (m && m.length > 0) {
        return {
          key,
          namespaces: isString(namespaces) ? [namespaces] : namespaces
        };
      }
      const parts = key.split(nsSeparator);
      if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
      key = parts.join(keySeparator);
    }
    return {
      key,
      namespaces: isString(namespaces) ? [namespaces] : namespaces
    };
  }
  translate(keys, options, lastKey) {
    if (typeof options !== "object" && this.options.overloadTranslationOptionHandler) {
      options = this.options.overloadTranslationOptionHandler(arguments);
    }
    if (typeof options === "object") options = {
      ...options
    };
    if (!options) options = {};
    if (keys === void 0 || keys === null) return "";
    if (!Array.isArray(keys)) keys = [String(keys)];
    const returnDetails = options.returnDetails !== void 0 ? options.returnDetails : this.options.returnDetails;
    const keySeparator = options.keySeparator !== void 0 ? options.keySeparator : this.options.keySeparator;
    const {
      key,
      namespaces
    } = this.extractFromKey(keys[keys.length - 1], options);
    const namespace = namespaces[namespaces.length - 1];
    const lng = options.lng || this.language;
    const appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (lng && lng.toLowerCase() === "cimode") {
      if (appendNamespaceToCIMode) {
        const nsSeparator = options.nsSeparator || this.options.nsSeparator;
        if (returnDetails) {
          return {
            res: `${namespace}${nsSeparator}${key}`,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace,
            usedParams: this.getUsedParamsDetails(options)
          };
        }
        return `${namespace}${nsSeparator}${key}`;
      }
      if (returnDetails) {
        return {
          res: key,
          usedKey: key,
          exactUsedKey: key,
          usedLng: lng,
          usedNS: namespace,
          usedParams: this.getUsedParamsDetails(options)
        };
      }
      return key;
    }
    const resolved = this.resolve(keys, options);
    let res = resolved && resolved.res;
    const resUsedKey = resolved && resolved.usedKey || key;
    const resExactUsedKey = resolved && resolved.exactUsedKey || key;
    const resType = Object.prototype.toString.apply(res);
    const noObject = ["[object Number]", "[object Function]", "[object RegExp]"];
    const joinArrays = options.joinArrays !== void 0 ? options.joinArrays : this.options.joinArrays;
    const handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
    const handleAsObject = !isString(res) && typeof res !== "boolean" && typeof res !== "number";
    if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(isString(joinArrays) && Array.isArray(res))) {
      if (!options.returnObjects && !this.options.returnObjects) {
        if (!this.options.returnedObjectHandler) {
          this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        }
        const r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, {
          ...options,
          ns: namespaces
        }) : `key '${key} (${this.language})' returned an object instead of string.`;
        if (returnDetails) {
          resolved.res = r;
          resolved.usedParams = this.getUsedParamsDetails(options);
          return resolved;
        }
        return r;
      }
      if (keySeparator) {
        const resTypeIsArray = Array.isArray(res);
        const copy2 = resTypeIsArray ? [] : {};
        const newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
        for (const m in res) {
          if (Object.prototype.hasOwnProperty.call(res, m)) {
            const deepKey = `${newKeyToUse}${keySeparator}${m}`;
            copy2[m] = this.translate(deepKey, {
              ...options,
              ...{
                joinArrays: false,
                ns: namespaces
              }
            });
            if (copy2[m] === deepKey) copy2[m] = res[m];
          }
        }
        res = copy2;
      }
    } else if (handleAsObjectInI18nFormat && isString(joinArrays) && Array.isArray(res)) {
      res = res.join(joinArrays);
      if (res) res = this.extendTranslation(res, keys, options, lastKey);
    } else {
      let usedDefault = false;
      let usedKey = false;
      const needsPluralHandling = options.count !== void 0 && !isString(options.count);
      const hasDefaultValue = Translator.hasDefaultValue(options);
      const defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
      const defaultValueSuffixOrdinalFallback = options.ordinal && needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, {
        ordinal: false
      }) : "";
      const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
      const defaultValue = needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] || options[`defaultValue${defaultValueSuffix}`] || options[`defaultValue${defaultValueSuffixOrdinalFallback}`] || options.defaultValue;
      if (!this.isValidLookup(res) && hasDefaultValue) {
        usedDefault = true;
        res = defaultValue;
      }
      if (!this.isValidLookup(res)) {
        usedKey = true;
        res = key;
      }
      const missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
      const resForMissing = missingKeyNoValueFallbackToKey && usedKey ? void 0 : res;
      const updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
      if (usedKey || usedDefault || updateMissing) {
        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
        if (keySeparator) {
          const fk = this.resolve(key, {
            ...options,
            keySeparator: false
          });
          if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let lngs = [];
        const fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) {
          for (let i = 0; i < fallbackLngs.length; i++) {
            lngs.push(fallbackLngs[i]);
          }
        } else if (this.options.saveMissingTo === "all") {
          lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
        } else {
          lngs.push(options.lng || this.language);
        }
        const send = (l, k, specificDefaultValue) => {
          const defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
          if (this.options.missingKeyHandler) {
            this.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
          } else if (this.backendConnector && this.backendConnector.saveMissing) {
            this.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
          }
          this.emit("missingKey", l, namespace, k, res);
        };
        if (this.options.saveMissing) {
          if (this.options.saveMissingPlurals && needsPluralHandling) {
            lngs.forEach((language) => {
              const suffixes = this.pluralResolver.getSuffixes(language, options);
              if (needsZeroSuffixLookup && options[`defaultValue${this.options.pluralSeparator}zero`] && suffixes.indexOf(`${this.options.pluralSeparator}zero`) < 0) {
                suffixes.push(`${this.options.pluralSeparator}zero`);
              }
              suffixes.forEach((suffix) => {
                send([language], key + suffix, options[`defaultValue${suffix}`] || defaultValue);
              });
            });
          } else {
            send(lngs, key, defaultValue);
          }
        }
      }
      res = this.extendTranslation(res, keys, options, resolved, lastKey);
      if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = `${namespace}:${key}`;
      if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
        if (this.options.compatibilityAPI !== "v1") {
          res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${namespace}:${key}` : key, usedDefault ? res : void 0);
        } else {
          res = this.options.parseMissingKeyHandler(res);
        }
      }
    }
    if (returnDetails) {
      resolved.res = res;
      resolved.usedParams = this.getUsedParamsDetails(options);
      return resolved;
    }
    return res;
  }
  extendTranslation(res, key, options, resolved, lastKey) {
    var _this = this;
    if (this.i18nFormat && this.i18nFormat.parse) {
      res = this.i18nFormat.parse(res, {
        ...this.options.interpolation.defaultVariables,
        ...options
      }, options.lng || this.language || resolved.usedLng, resolved.usedNS, resolved.usedKey, {
        resolved
      });
    } else if (!options.skipInterpolation) {
      if (options.interpolation) this.interpolator.init({
        ...options,
        ...{
          interpolation: {
            ...this.options.interpolation,
            ...options.interpolation
          }
        }
      });
      const skipOnVariables = isString(res) && (options && options.interpolation && options.interpolation.skipOnVariables !== void 0 ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let nestBef;
      if (skipOnVariables) {
        const nb = res.match(this.interpolator.nestingRegexp);
        nestBef = nb && nb.length;
      }
      let data = options.replace && !isString(options.replace) ? options.replace : options;
      if (this.options.interpolation.defaultVariables) data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
      res = this.interpolator.interpolate(res, data, options.lng || this.language || resolved.usedLng, options);
      if (skipOnVariables) {
        const na = res.match(this.interpolator.nestingRegexp);
        const nestAft = na && na.length;
        if (nestBef < nestAft) options.nest = false;
      }
      if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = this.language || resolved.usedLng;
      if (options.nest !== false) res = this.interpolator.nest(res, function() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (lastKey && lastKey[0] === args[0] && !options.context) {
          _this.logger.warn(`It seems you are nesting recursively key: ${args[0]} in key: ${key[0]}`);
          return null;
        }
        return _this.translate(...args, key);
      }, options);
      if (options.interpolation) this.interpolator.reset();
    }
    const postProcess = options.postProcess || this.options.postProcess;
    const postProcessorNames = isString(postProcess) ? [postProcess] : postProcess;
    if (res !== void 0 && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
      res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? {
        i18nResolved: {
          ...resolved,
          usedParams: this.getUsedParamsDetails(options)
        },
        ...options
      } : options, this);
    }
    return res;
  }
  resolve(keys) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    let found;
    let usedKey;
    let exactUsedKey;
    let usedLng;
    let usedNS;
    if (isString(keys)) keys = [keys];
    keys.forEach((k) => {
      if (this.isValidLookup(found)) return;
      const extracted = this.extractFromKey(k, options);
      const key = extracted.key;
      usedKey = key;
      let namespaces = extracted.namespaces;
      if (this.options.fallbackNS) namespaces = namespaces.concat(this.options.fallbackNS);
      const needsPluralHandling = options.count !== void 0 && !isString(options.count);
      const needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && this.pluralResolver.shouldUseIntlApi();
      const needsContextHandling = options.context !== void 0 && (isString(options.context) || typeof options.context === "number") && options.context !== "";
      const codes = options.lngs ? options.lngs : this.languageUtils.toResolveHierarchy(options.lng || this.language, options.fallbackLng);
      namespaces.forEach((ns) => {
        if (this.isValidLookup(found)) return;
        usedNS = ns;
        if (!checkedLoadedFor[`${codes[0]}-${ns}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(usedNS)) {
          checkedLoadedFor[`${codes[0]}-${ns}`] = true;
          this.logger.warn(`key "${usedKey}" for languages "${codes.join(", ")}" won't get resolved as namespace "${usedNS}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
        }
        codes.forEach((code) => {
          if (this.isValidLookup(found)) return;
          usedLng = code;
          const finalKeys = [key];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys) {
            this.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
          } else {
            let pluralSuffix;
            if (needsPluralHandling) pluralSuffix = this.pluralResolver.getSuffix(code, options.count, options);
            const zeroSuffix = `${this.options.pluralSeparator}zero`;
            const ordinalPrefix = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (needsPluralHandling) {
              finalKeys.push(key + pluralSuffix);
              if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                finalKeys.push(key + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
              }
              if (needsZeroSuffixLookup) {
                finalKeys.push(key + zeroSuffix);
              }
            }
            if (needsContextHandling) {
              const contextKey = `${key}${this.options.contextSeparator}${options.context}`;
              finalKeys.push(contextKey);
              if (needsPluralHandling) {
                finalKeys.push(contextKey + pluralSuffix);
                if (options.ordinal && pluralSuffix.indexOf(ordinalPrefix) === 0) {
                  finalKeys.push(contextKey + pluralSuffix.replace(ordinalPrefix, this.options.pluralSeparator));
                }
                if (needsZeroSuffixLookup) {
                  finalKeys.push(contextKey + zeroSuffix);
                }
              }
            }
          }
          let possibleKey;
          while (possibleKey = finalKeys.pop()) {
            if (!this.isValidLookup(found)) {
              exactUsedKey = possibleKey;
              found = this.getResource(code, ns, possibleKey, options);
            }
          }
        });
      });
    });
    return {
      res: found,
      usedKey,
      exactUsedKey,
      usedLng,
      usedNS
    };
  }
  isValidLookup(res) {
    return res !== void 0 && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
  }
  getResource(code, ns, key) {
    let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
    return this.resourceStore.getResource(code, ns, key, options);
  }
  getUsedParamsDetails() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const optionsKeys = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"];
    const useOptionsReplaceForData = options.replace && !isString(options.replace);
    let data = useOptionsReplaceForData ? options.replace : options;
    if (useOptionsReplaceForData && typeof options.count !== "undefined") {
      data.count = options.count;
    }
    if (this.options.interpolation.defaultVariables) {
      data = {
        ...this.options.interpolation.defaultVariables,
        ...data
      };
    }
    if (!useOptionsReplaceForData) {
      data = {
        ...data
      };
      for (const key of optionsKeys) {
        delete data[key];
      }
    }
    return data;
  }
  static hasDefaultValue(options) {
    const prefix = "defaultValue";
    for (const option in options) {
      if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && void 0 !== options[option]) {
        return true;
      }
    }
    return false;
  }
}
const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);
class LanguageUtil {
  constructor(options) {
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create("languageUtils");
  }
  getScriptPartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf("-") < 0) return null;
    const p = code.split("-");
    if (p.length === 2) return null;
    p.pop();
    if (p[p.length - 1].toLowerCase() === "x") return null;
    return this.formatLanguageCode(p.join("-"));
  }
  getLanguagePartFromCode(code) {
    code = getCleanedCode(code);
    if (!code || code.indexOf("-") < 0) return code;
    const p = code.split("-");
    return this.formatLanguageCode(p[0]);
  }
  formatLanguageCode(code) {
    if (isString(code) && code.indexOf("-") > -1) {
      if (typeof Intl !== "undefined" && typeof Intl.getCanonicalLocales !== "undefined") {
        try {
          let formattedCode = Intl.getCanonicalLocales(code)[0];
          if (formattedCode && this.options.lowerCaseLng) {
            formattedCode = formattedCode.toLowerCase();
          }
          if (formattedCode) return formattedCode;
        } catch (e) {
        }
      }
      const specialCases = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let p = code.split("-");
      if (this.options.lowerCaseLng) {
        p = p.map((part) => part.toLowerCase());
      } else if (p.length === 2) {
        p[0] = p[0].toLowerCase();
        p[1] = p[1].toUpperCase();
        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
      } else if (p.length === 3) {
        p[0] = p[0].toLowerCase();
        if (p[1].length === 2) p[1] = p[1].toUpperCase();
        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
      }
      return p.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
  }
  isSupportedCode(code) {
    if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) {
      code = this.getLanguagePartFromCode(code);
    }
    return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
  }
  getBestMatchFromCodes(codes) {
    if (!codes) return null;
    let found;
    codes.forEach((code) => {
      if (found) return;
      const cleanedLng = this.formatLanguageCode(code);
      if (!this.options.supportedLngs || this.isSupportedCode(cleanedLng)) found = cleanedLng;
    });
    if (!found && this.options.supportedLngs) {
      codes.forEach((code) => {
        if (found) return;
        const lngOnly = this.getLanguagePartFromCode(code);
        if (this.isSupportedCode(lngOnly)) return found = lngOnly;
        found = this.options.supportedLngs.find((supportedLng) => {
          if (supportedLng === lngOnly) return supportedLng;
          if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
          if (supportedLng.indexOf("-") > 0 && lngOnly.indexOf("-") < 0 && supportedLng.substring(0, supportedLng.indexOf("-")) === lngOnly) return supportedLng;
          if (supportedLng.indexOf(lngOnly) === 0 && lngOnly.length > 1) return supportedLng;
        });
      });
    }
    if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
    return found;
  }
  getFallbackCodes(fallbacks, code) {
    if (!fallbacks) return [];
    if (typeof fallbacks === "function") fallbacks = fallbacks(code);
    if (isString(fallbacks)) fallbacks = [fallbacks];
    if (Array.isArray(fallbacks)) return fallbacks;
    if (!code) return fallbacks.default || [];
    let found = fallbacks[code];
    if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
    if (!found) found = fallbacks[this.formatLanguageCode(code)];
    if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
    if (!found) found = fallbacks.default;
    return found || [];
  }
  toResolveHierarchy(code, fallbackCode) {
    const fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
    const codes = [];
    const addCode = (c) => {
      if (!c) return;
      if (this.isSupportedCode(c)) {
        codes.push(c);
      } else {
        this.logger.warn(`rejecting language code not found in supportedLngs: ${c}`);
      }
    };
    if (isString(code) && (code.indexOf("-") > -1 || code.indexOf("_") > -1)) {
      if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
      if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
      if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
    } else if (isString(code)) {
      addCode(this.formatLanguageCode(code));
    }
    fallbackCodes.forEach((fc) => {
      if (codes.indexOf(fc) < 0) addCode(this.formatLanguageCode(fc));
    });
    return codes;
  }
}
let sets = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}];
let _rulesPluralsTypes = {
  1: (n) => Number(n > 1),
  2: (n) => Number(n != 1),
  3: (n) => 0,
  4: (n) => Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
  5: (n) => Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5),
  6: (n) => Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2),
  7: (n) => Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
  8: (n) => Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3),
  9: (n) => Number(n >= 2),
  10: (n) => Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4),
  11: (n) => Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3),
  12: (n) => Number(n % 10 != 1 || n % 100 == 11),
  13: (n) => Number(n !== 0),
  14: (n) => Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3),
  15: (n) => Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2),
  16: (n) => Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2),
  17: (n) => Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1),
  18: (n) => Number(n == 0 ? 0 : n == 1 ? 1 : 2),
  19: (n) => Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3),
  20: (n) => Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2),
  21: (n) => Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0),
  22: (n) => Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3)
};
const nonIntlVersions = ["v1", "v2", "v3"];
const intlVersions = ["v4"];
const suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
const createRules = () => {
  const rules = {};
  sets.forEach((set) => {
    set.lngs.forEach((l) => {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
};
class PluralResolver {
  constructor(languageUtils) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create("pluralResolver");
    if ((!this.options.compatibilityJSON || intlVersions.includes(this.options.compatibilityJSON)) && (typeof Intl === "undefined" || !Intl.PluralRules)) {
      this.options.compatibilityJSON = "v3";
      this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
    }
    this.rules = createRules();
    this.pluralRulesCache = {};
  }
  addRule(lng, obj) {
    this.rules[lng] = obj;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(code) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi()) {
      const cleanedCode = getCleanedCode(code === "dev" ? "en" : code);
      const type = options.ordinal ? "ordinal" : "cardinal";
      const cacheKey = JSON.stringify({
        cleanedCode,
        type
      });
      if (cacheKey in this.pluralRulesCache) {
        return this.pluralRulesCache[cacheKey];
      }
      let rule;
      try {
        rule = new Intl.PluralRules(cleanedCode, {
          type
        });
      } catch (err) {
        if (!code.match(/-|_/)) return;
        const lngPart = this.languageUtils.getLanguagePartFromCode(code);
        rule = this.getRule(lngPart, options);
      }
      this.pluralRulesCache[cacheKey] = rule;
      return rule;
    }
    return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
  }
  needsPlural(code) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const rule = this.getRule(code, options);
    if (this.shouldUseIntlApi()) {
      return rule && rule.resolvedOptions().pluralCategories.length > 1;
    }
    return rule && rule.numbers.length > 1;
  }
  getPluralFormsOfKey(code, key) {
    let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(code, options).map((suffix) => `${key}${suffix}`);
  }
  getSuffixes(code) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const rule = this.getRule(code, options);
    if (!rule) {
      return [];
    }
    if (this.shouldUseIntlApi()) {
      return rule.resolvedOptions().pluralCategories.sort((pluralCategory1, pluralCategory2) => suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2]).map((pluralCategory) => `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${pluralCategory}`);
    }
    return rule.numbers.map((number) => this.getSuffix(code, number, options));
  }
  getSuffix(code, count) {
    let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const rule = this.getRule(code, options);
    if (rule) {
      if (this.shouldUseIntlApi()) {
        return `${this.options.prepend}${options.ordinal ? `ordinal${this.options.prepend}` : ""}${rule.select(count)}`;
      }
      return this.getSuffixRetroCompatible(rule, count);
    }
    this.logger.warn(`no plural rule found for: ${code}`);
    return "";
  }
  getSuffixRetroCompatible(rule, count) {
    const idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
    let suffix = rule.numbers[idx];
    if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
      if (suffix === 2) {
        suffix = "plural";
      } else if (suffix === 1) {
        suffix = "";
      }
    }
    const returnSuffix = () => this.options.prepend && suffix.toString() ? this.options.prepend + suffix.toString() : suffix.toString();
    if (this.options.compatibilityJSON === "v1") {
      if (suffix === 1) return "";
      if (typeof suffix === "number") return `_plural_${suffix.toString()}`;
      return returnSuffix();
    } else if (this.options.compatibilityJSON === "v2") {
      return returnSuffix();
    } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
      return returnSuffix();
    }
    return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
  }
  shouldUseIntlApi() {
    return !nonIntlVersions.includes(this.options.compatibilityJSON);
  }
}
const deepFindWithDefaults = function(data, defaultData, key) {
  let keySeparator = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".";
  let ignoreJSONStructure = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
  let path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && isString(key)) {
    path = deepFind(data, key, keySeparator);
    if (path === void 0) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
};
const regexSafe = (val) => val.replace(/\$/g, "$$$$");
class Interpolator {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = baseLogger.create("interpolator");
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || ((value) => value);
    this.init(options);
  }
  init() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!options.interpolation) options.interpolation = {
      escapeValue: true
    };
    const {
      escape: escape$1,
      escapeValue,
      useRawValueToEscape,
      prefix,
      prefixEscaped,
      suffix,
      suffixEscaped,
      formatSeparator,
      unescapeSuffix,
      unescapePrefix,
      nestingPrefix,
      nestingPrefixEscaped,
      nestingSuffix,
      nestingSuffixEscaped,
      nestingOptionsSeparator,
      maxReplaces,
      alwaysFormat
    } = options.interpolation;
    this.escape = escape$1 !== void 0 ? escape$1 : escape;
    this.escapeValue = escapeValue !== void 0 ? escapeValue : true;
    this.useRawValueToEscape = useRawValueToEscape !== void 0 ? useRawValueToEscape : false;
    this.prefix = prefix ? regexEscape(prefix) : prefixEscaped || "{{";
    this.suffix = suffix ? regexEscape(suffix) : suffixEscaped || "}}";
    this.formatSeparator = formatSeparator || ",";
    this.unescapePrefix = unescapeSuffix ? "" : unescapePrefix || "-";
    this.unescapeSuffix = this.unescapePrefix ? "" : unescapeSuffix || "";
    this.nestingPrefix = nestingPrefix ? regexEscape(nestingPrefix) : nestingPrefixEscaped || regexEscape("$t(");
    this.nestingSuffix = nestingSuffix ? regexEscape(nestingSuffix) : nestingSuffixEscaped || regexEscape(")");
    this.nestingOptionsSeparator = nestingOptionsSeparator || ",";
    this.maxReplaces = maxReplaces || 1e3;
    this.alwaysFormat = alwaysFormat !== void 0 ? alwaysFormat : false;
    this.resetRegExp();
  }
  reset() {
    if (this.options) this.init(this.options);
  }
  resetRegExp() {
    const getOrResetRegExp = (existingRegExp, pattern) => {
      if (existingRegExp && existingRegExp.source === pattern) {
        existingRegExp.lastIndex = 0;
        return existingRegExp;
      }
      return new RegExp(pattern, "g");
    };
    this.regexp = getOrResetRegExp(this.regexp, `${this.prefix}(.+?)${this.suffix}`);
    this.regexpUnescape = getOrResetRegExp(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`);
    this.nestingRegexp = getOrResetRegExp(this.nestingRegexp, `${this.nestingPrefix}(.+?)${this.nestingSuffix}`);
  }
  interpolate(str, data, lng, options) {
    let match;
    let value;
    let replaces;
    const defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    const handleFormat = (key) => {
      if (key.indexOf(this.formatSeparator) < 0) {
        const path = deepFindWithDefaults(data, defaultData, key, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(path, void 0, lng, {
          ...options,
          ...data,
          interpolationkey: key
        }) : path;
      }
      const p = key.split(this.formatSeparator);
      const k = p.shift().trim();
      const f = p.join(this.formatSeparator).trim();
      return this.format(deepFindWithDefaults(data, defaultData, k, this.options.keySeparator, this.options.ignoreJSONStructure), f, lng, {
        ...options,
        ...data,
        interpolationkey: k
      });
    };
    this.resetRegExp();
    const missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
    const skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== void 0 ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    const todos = [{
      regex: this.regexpUnescape,
      safeValue: (val) => regexSafe(val)
    }, {
      regex: this.regexp,
      safeValue: (val) => this.escapeValue ? regexSafe(this.escape(val)) : regexSafe(val)
    }];
    todos.forEach((todo) => {
      replaces = 0;
      while (match = todo.regex.exec(str)) {
        const matchedVar = match[1].trim();
        value = handleFormat(matchedVar);
        if (value === void 0) {
          if (typeof missingInterpolationHandler === "function") {
            const temp = missingInterpolationHandler(str, match, options);
            value = isString(temp) ? temp : "";
          } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
            value = "";
          } else if (skipOnVariables) {
            value = match[0];
            continue;
          } else {
            this.logger.warn(`missed to pass in variable ${matchedVar} for interpolating ${str}`);
            value = "";
          }
        } else if (!isString(value) && !this.useRawValueToEscape) {
          value = makeString(value);
        }
        const safeValue = todo.safeValue(value);
        str = str.replace(match[0], safeValue);
        if (skipOnVariables) {
          todo.regex.lastIndex += value.length;
          todo.regex.lastIndex -= match[0].length;
        } else {
          todo.regex.lastIndex = 0;
        }
        replaces++;
        if (replaces >= this.maxReplaces) {
          break;
        }
      }
    });
    return str;
  }
  nest(str, fc) {
    let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    let match;
    let value;
    let clonedOptions;
    const handleHasOptions = (key, inheritedOptions) => {
      const sep = this.nestingOptionsSeparator;
      if (key.indexOf(sep) < 0) return key;
      const c = key.split(new RegExp(`${sep}[ ]*{`));
      let optionsString = `{${c[1]}`;
      key = c[0];
      optionsString = this.interpolate(optionsString, clonedOptions);
      const matchedSingleQuotes = optionsString.match(/'/g);
      const matchedDoubleQuotes = optionsString.match(/"/g);
      if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
        optionsString = optionsString.replace(/'/g, '"');
      }
      try {
        clonedOptions = JSON.parse(optionsString);
        if (inheritedOptions) clonedOptions = {
          ...inheritedOptions,
          ...clonedOptions
        };
      } catch (e) {
        this.logger.warn(`failed parsing options string in nesting for key ${key}`, e);
        return `${key}${sep}${optionsString}`;
      }
      if (clonedOptions.defaultValue && clonedOptions.defaultValue.indexOf(this.prefix) > -1) delete clonedOptions.defaultValue;
      return key;
    };
    while (match = this.nestingRegexp.exec(str)) {
      let formatters = [];
      clonedOptions = {
        ...options
      };
      clonedOptions = clonedOptions.replace && !isString(clonedOptions.replace) ? clonedOptions.replace : clonedOptions;
      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;
      let doReduce = false;
      if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
        const r = match[1].split(this.formatSeparator).map((elem) => elem.trim());
        match[1] = r.shift();
        formatters = r;
        doReduce = true;
      }
      value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
      if (value && match[0] === str && !isString(value)) return value;
      if (!isString(value)) value = makeString(value);
      if (!value) {
        this.logger.warn(`missed to resolve ${match[1]} for nesting ${str}`);
        value = "";
      }
      if (doReduce) {
        value = formatters.reduce((v, f) => this.format(v, f, options.lng, {
          ...options,
          interpolationkey: match[1].trim()
        }), value.trim());
      }
      str = str.replace(match[0], value);
      this.regexp.lastIndex = 0;
    }
    return str;
  }
}
const parseFormatStr = (formatStr) => {
  let formatName = formatStr.toLowerCase().trim();
  const formatOptions = {};
  if (formatStr.indexOf("(") > -1) {
    const p = formatStr.split("(");
    formatName = p[0].toLowerCase().trim();
    const optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === "currency" && optStr.indexOf(":") < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      const opts = optStr.split(";");
      opts.forEach((opt) => {
        if (opt) {
          const [key, ...rest] = opt.split(":");
          const val = rest.join(":").trim().replace(/^'+|'+$/g, "");
          const trimmedKey = key.trim();
          if (!formatOptions[trimmedKey]) formatOptions[trimmedKey] = val;
          if (val === "false") formatOptions[trimmedKey] = false;
          if (val === "true") formatOptions[trimmedKey] = true;
          if (!isNaN(val)) formatOptions[trimmedKey] = parseInt(val, 10);
        }
      });
    }
  }
  return {
    formatName,
    formatOptions
  };
};
const createCachedFormatter = (fn) => {
  const cache = {};
  return (val, lng, options) => {
    let optForCache = options;
    if (options && options.interpolationkey && options.formatParams && options.formatParams[options.interpolationkey] && options[options.interpolationkey]) {
      optForCache = {
        ...optForCache,
        [options.interpolationkey]: void 0
      };
    }
    const key = lng + JSON.stringify(optForCache);
    let formatter = cache[key];
    if (!formatter) {
      formatter = fn(getCleanedCode(lng), options);
      cache[key] = formatter;
    }
    return formatter(val);
  };
};
class Formatter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = baseLogger.create("formatter");
    this.options = options;
    this.formats = {
      number: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt
        });
        return (val) => formatter.format(val);
      }),
      currency: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.NumberFormat(lng, {
          ...opt,
          style: "currency"
        });
        return (val) => formatter.format(val);
      }),
      datetime: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.DateTimeFormat(lng, {
          ...opt
        });
        return (val) => formatter.format(val);
      }),
      relativetime: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.RelativeTimeFormat(lng, {
          ...opt
        });
        return (val) => formatter.format(val, opt.range || "day");
      }),
      list: createCachedFormatter((lng, opt) => {
        const formatter = new Intl.ListFormat(lng, {
          ...opt
        });
        return (val) => formatter.format(val);
      })
    };
    this.init(options);
  }
  init(services) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    this.formatSeparator = options.interpolation.formatSeparator || ",";
  }
  add(name, fc) {
    this.formats[name.toLowerCase().trim()] = fc;
  }
  addCached(name, fc) {
    this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
  }
  format(value, format, lng) {
    let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const formats = format.split(this.formatSeparator);
    if (formats.length > 1 && formats[0].indexOf("(") > 1 && formats[0].indexOf(")") < 0 && formats.find((f) => f.indexOf(")") > -1)) {
      const lastIndex = formats.findIndex((f) => f.indexOf(")") > -1);
      formats[0] = [formats[0], ...formats.splice(1, lastIndex)].join(this.formatSeparator);
    }
    const result = formats.reduce((mem, f) => {
      const {
        formatName,
        formatOptions
      } = parseFormatStr(f);
      if (this.formats[formatName]) {
        let formatted = mem;
        try {
          const valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
          const l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
          formatted = this.formats[formatName](mem, l, {
            ...formatOptions,
            ...options,
            ...valOptions
          });
        } catch (error) {
          this.logger.warn(error);
        }
        return formatted;
      } else {
        this.logger.warn(`there was no format function for ${formatName}`);
      }
      return mem;
    }, value);
    return result;
  }
}
const removePending = (q, name) => {
  if (q.pending[name] !== void 0) {
    delete q.pending[name];
    q.pendingCount--;
  }
};
class Connector extends EventEmitter {
  constructor(backend, store, services) {
    let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super();
    this.backend = backend;
    this.store = store;
    this.services = services;
    this.languageUtils = services.languageUtils;
    this.options = options;
    this.logger = baseLogger.create("backendConnector");
    this.waitingReads = [];
    this.maxParallelReads = options.maxParallelReads || 10;
    this.readingCalls = 0;
    this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    this.state = {};
    this.queue = [];
    if (this.backend && this.backend.init) {
      this.backend.init(services, options.backend, options);
    }
  }
  queueLoad(languages, namespaces, options, callback) {
    const toLoad = {};
    const pending = {};
    const toLoadLanguages = {};
    const toLoadNamespaces = {};
    languages.forEach((lng) => {
      let hasAllNamespaces = true;
      namespaces.forEach((ns) => {
        const name = `${lng}|${ns}`;
        if (!options.reload && this.store.hasResourceBundle(lng, ns)) {
          this.state[name] = 2;
        } else if (this.state[name] < 0) ;
        else if (this.state[name] === 1) {
          if (pending[name] === void 0) pending[name] = true;
        } else {
          this.state[name] = 1;
          hasAllNamespaces = false;
          if (pending[name] === void 0) pending[name] = true;
          if (toLoad[name] === void 0) toLoad[name] = true;
          if (toLoadNamespaces[ns] === void 0) toLoadNamespaces[ns] = true;
        }
      });
      if (!hasAllNamespaces) toLoadLanguages[lng] = true;
    });
    if (Object.keys(toLoad).length || Object.keys(pending).length) {
      this.queue.push({
        pending,
        pendingCount: Object.keys(pending).length,
        loaded: {},
        errors: [],
        callback
      });
    }
    return {
      toLoad: Object.keys(toLoad),
      pending: Object.keys(pending),
      toLoadLanguages: Object.keys(toLoadLanguages),
      toLoadNamespaces: Object.keys(toLoadNamespaces)
    };
  }
  loaded(name, err, data) {
    const s = name.split("|");
    const lng = s[0];
    const ns = s[1];
    if (err) this.emit("failedLoading", lng, ns, err);
    if (!err && data) {
      this.store.addResourceBundle(lng, ns, data, void 0, void 0, {
        skipCopy: true
      });
    }
    this.state[name] = err ? -1 : 2;
    if (err && data) this.state[name] = 0;
    const loaded = {};
    this.queue.forEach((q) => {
      pushPath(q.loaded, [lng], ns);
      removePending(q, name);
      if (err) q.errors.push(err);
      if (q.pendingCount === 0 && !q.done) {
        Object.keys(q.loaded).forEach((l) => {
          if (!loaded[l]) loaded[l] = {};
          const loadedKeys = q.loaded[l];
          if (loadedKeys.length) {
            loadedKeys.forEach((n) => {
              if (loaded[l][n] === void 0) loaded[l][n] = true;
            });
          }
        });
        q.done = true;
        if (q.errors.length) {
          q.callback(q.errors);
        } else {
          q.callback();
        }
      }
    });
    this.emit("loaded", loaded);
    this.queue = this.queue.filter((q) => !q.done);
  }
  read(lng, ns, fcName) {
    let tried = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    let wait = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout;
    let callback = arguments.length > 5 ? arguments[5] : void 0;
    if (!lng.length) return callback(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng,
        ns,
        fcName,
        tried,
        wait,
        callback
      });
      return;
    }
    this.readingCalls++;
    const resolver = (err, data) => {
      this.readingCalls--;
      if (this.waitingReads.length > 0) {
        const next = this.waitingReads.shift();
        this.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
      }
      if (err && data && tried < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, lng, ns, fcName, tried + 1, wait * 2, callback);
        }, wait);
        return;
      }
      callback(err, data);
    };
    const fc = this.backend[fcName].bind(this.backend);
    if (fc.length === 2) {
      try {
        const r = fc(lng, ns);
        if (r && typeof r.then === "function") {
          r.then((data) => resolver(null, data)).catch(resolver);
        } else {
          resolver(null, r);
        }
      } catch (err) {
        resolver(err);
      }
      return;
    }
    return fc(lng, ns, resolver);
  }
  prepareLoading(languages, namespaces) {
    let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    let callback = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend) {
      this.logger.warn("No backend was added via i18next.use. Will not load resources.");
      return callback && callback();
    }
    if (isString(languages)) languages = this.languageUtils.toResolveHierarchy(languages);
    if (isString(namespaces)) namespaces = [namespaces];
    const toLoad = this.queueLoad(languages, namespaces, options, callback);
    if (!toLoad.toLoad.length) {
      if (!toLoad.pending.length) callback();
      return null;
    }
    toLoad.toLoad.forEach((name) => {
      this.loadOne(name);
    });
  }
  load(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {}, callback);
  }
  reload(languages, namespaces, callback) {
    this.prepareLoading(languages, namespaces, {
      reload: true
    }, callback);
  }
  loadOne(name) {
    let prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const s = name.split("|");
    const lng = s[0];
    const ns = s[1];
    this.read(lng, ns, "read", void 0, void 0, (err, data) => {
      if (err) this.logger.warn(`${prefix}loading namespace ${ns} for language ${lng} failed`, err);
      if (!err && data) this.logger.log(`${prefix}loaded namespace ${ns} for language ${lng}`, data);
      this.loaded(name, err, data);
    });
  }
  saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
    let options = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
    let clb = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
      this.logger.warn(`did not save key "${key}" as the namespace "${namespace}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (key === void 0 || key === null || key === "") return;
    if (this.backend && this.backend.create) {
      const opts = {
        ...options,
        isUpdate
      };
      const fc = this.backend.create.bind(this.backend);
      if (fc.length < 6) {
        try {
          let r;
          if (fc.length === 5) {
            r = fc(languages, namespace, key, fallbackValue, opts);
          } else {
            r = fc(languages, namespace, key, fallbackValue);
          }
          if (r && typeof r.then === "function") {
            r.then((data) => clb(null, data)).catch(clb);
          } else {
            clb(null, r);
          }
        } catch (err) {
          clb(err);
        }
      } else {
        fc(languages, namespace, key, fallbackValue, clb, opts);
      }
    }
    if (!languages || !languages[0]) return;
    this.store.addResource(languages[0], namespace, key, fallbackValue);
  }
}
const get = () => ({
  debug: false,
  initImmediate: true,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: false,
  supportedLngs: false,
  nonExplicitSupportedLngs: false,
  load: "all",
  preload: false,
  simplifyPluralSuffix: true,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: false,
  saveMissing: false,
  updateMissing: false,
  saveMissingTo: "fallback",
  saveMissingPlurals: true,
  missingKeyHandler: false,
  missingInterpolationHandler: false,
  postProcess: false,
  postProcessPassResolved: false,
  returnNull: false,
  returnEmptyString: true,
  returnObjects: false,
  joinArrays: false,
  returnedObjectHandler: false,
  parseMissingKeyHandler: false,
  appendNamespaceToMissingKey: false,
  appendNamespaceToCIMode: false,
  overloadTranslationOptionHandler: (args) => {
    let ret = {};
    if (typeof args[1] === "object") ret = args[1];
    if (isString(args[1])) ret.defaultValue = args[1];
    if (isString(args[2])) ret.tDescription = args[2];
    if (typeof args[2] === "object" || typeof args[3] === "object") {
      const options = args[3] || args[2];
      Object.keys(options).forEach((key) => {
        ret[key] = options[key];
      });
    }
    return ret;
  },
  interpolation: {
    escapeValue: true,
    format: (value) => value,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: true
  }
});
const transformOptions = (options) => {
  if (isString(options.ns)) options.ns = [options.ns];
  if (isString(options.fallbackLng)) options.fallbackLng = [options.fallbackLng];
  if (isString(options.fallbackNS)) options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) {
    options.supportedLngs = options.supportedLngs.concat(["cimode"]);
  }
  return options;
};
const noop = () => {
};
const bindMemberFunctions = (inst) => {
  const mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach((mem) => {
    if (typeof inst[mem] === "function") {
      inst[mem] = inst[mem].bind(inst);
    }
  });
};
class I18n extends EventEmitter {
  constructor() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : void 0;
    super();
    this.options = transformOptions(options);
    this.services = {};
    this.logger = baseLogger;
    this.modules = {
      external: []
    };
    bindMemberFunctions(this);
    if (callback && !this.isInitialized && !options.isClone) {
      if (!this.options.initImmediate) {
        this.init(options, callback);
        return this;
      }
      setTimeout(() => {
        this.init(options, callback);
      }, 0);
    }
  }
  init() {
    var _this = this;
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : void 0;
    this.isInitializing = true;
    if (typeof options === "function") {
      callback = options;
      options = {};
    }
    if (!options.defaultNS && options.defaultNS !== false && options.ns) {
      if (isString(options.ns)) {
        options.defaultNS = options.ns;
      } else if (options.ns.indexOf("translation") < 0) {
        options.defaultNS = options.ns[0];
      }
    }
    const defOpts = get();
    this.options = {
      ...defOpts,
      ...this.options,
      ...transformOptions(options)
    };
    if (this.options.compatibilityAPI !== "v1") {
      this.options.interpolation = {
        ...defOpts.interpolation,
        ...this.options.interpolation
      };
    }
    if (options.keySeparator !== void 0) {
      this.options.userDefinedKeySeparator = options.keySeparator;
    }
    if (options.nsSeparator !== void 0) {
      this.options.userDefinedNsSeparator = options.nsSeparator;
    }
    const createClassOnDemand = (ClassOrObject) => {
      if (!ClassOrObject) return null;
      if (typeof ClassOrObject === "function") return new ClassOrObject();
      return ClassOrObject;
    };
    if (!this.options.isClone) {
      if (this.modules.logger) {
        baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
      } else {
        baseLogger.init(null, this.options);
      }
      let formatter;
      if (this.modules.formatter) {
        formatter = this.modules.formatter;
      } else if (typeof Intl !== "undefined") {
        formatter = Formatter;
      }
      const lu = new LanguageUtil(this.options);
      this.store = new ResourceStore(this.options.resources, this.options);
      const s = this.services;
      s.logger = baseLogger;
      s.resourceStore = this.store;
      s.languageUtils = lu;
      s.pluralResolver = new PluralResolver(lu, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      });
      if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
        s.formatter = createClassOnDemand(formatter);
        s.formatter.init(s, this.options);
        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
      }
      s.interpolator = new Interpolator(this.options);
      s.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      };
      s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
      s.backendConnector.on("*", function(event) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        _this.emit(event, ...args);
      });
      if (this.modules.languageDetector) {
        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
      }
      if (this.modules.i18nFormat) {
        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
        if (s.i18nFormat.init) s.i18nFormat.init(this);
      }
      this.translator = new Translator(this.services, this.options);
      this.translator.on("*", function(event) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        _this.emit(event, ...args);
      });
      this.modules.external.forEach((m) => {
        if (m.init) m.init(this);
      });
    }
    this.format = this.options.interpolation.format;
    if (!callback) callback = noop;
    if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
    }
    if (!this.services.languageDetector && !this.options.lng) {
      this.logger.warn("init: no languageDetector is used and no lng is defined");
    }
    const storeApi = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
    storeApi.forEach((fcName) => {
      this[fcName] = function() {
        return _this.store[fcName](...arguments);
      };
    });
    const storeApiChained = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
    storeApiChained.forEach((fcName) => {
      this[fcName] = function() {
        _this.store[fcName](...arguments);
        return _this;
      };
    });
    const deferred = defer();
    const load = () => {
      const finish = (err, t2) => {
        this.isInitializing = false;
        if (this.isInitialized && !this.initializedStoreOnce) this.logger.warn("init: i18next is already initialized. You should call init just once!");
        this.isInitialized = true;
        if (!this.options.isClone) this.logger.log("initialized", this.options);
        this.emit("initialized", this.options);
        deferred.resolve(t2);
        callback(err, t2);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized) return finish(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, finish);
    };
    if (this.options.resources || !this.options.initImmediate) {
      load();
    } else {
      setTimeout(load, 0);
    }
    return deferred;
  }
  loadResources(language) {
    let callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
    let usedCallback = callback;
    const usedLng = isString(language) ? language : this.language;
    if (typeof language === "function") usedCallback = language;
    if (!this.options.resources || this.options.partialBundledLanguages) {
      if (usedLng && usedLng.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return usedCallback();
      const toLoad = [];
      const append = (lng) => {
        if (!lng) return;
        if (lng === "cimode") return;
        const lngs = this.services.languageUtils.toResolveHierarchy(lng);
        lngs.forEach((l) => {
          if (l === "cimode") return;
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      if (!usedLng) {
        const fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        fallbacks.forEach((l) => append(l));
      } else {
        append(usedLng);
      }
      if (this.options.preload) {
        this.options.preload.forEach((l) => append(l));
      }
      this.services.backendConnector.load(toLoad, this.options.ns, (e) => {
        if (!e && !this.resolvedLanguage && this.language) this.setResolvedLanguage(this.language);
        usedCallback(e);
      });
    } else {
      usedCallback(null);
    }
  }
  reloadResources(lngs, ns, callback) {
    const deferred = defer();
    if (typeof lngs === "function") {
      callback = lngs;
      lngs = void 0;
    }
    if (typeof ns === "function") {
      callback = ns;
      ns = void 0;
    }
    if (!lngs) lngs = this.languages;
    if (!ns) ns = this.options.ns;
    if (!callback) callback = noop;
    this.services.backendConnector.reload(lngs, ns, (err) => {
      deferred.resolve();
      callback(err);
    });
    return deferred;
  }
  use(module) {
    if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    if (module.type === "backend") {
      this.modules.backend = module;
    }
    if (module.type === "logger" || module.log && module.warn && module.error) {
      this.modules.logger = module;
    }
    if (module.type === "languageDetector") {
      this.modules.languageDetector = module;
    }
    if (module.type === "i18nFormat") {
      this.modules.i18nFormat = module;
    }
    if (module.type === "postProcessor") {
      postProcessor.addPostProcessor(module);
    }
    if (module.type === "formatter") {
      this.modules.formatter = module;
    }
    if (module.type === "3rdParty") {
      this.modules.external.push(module);
    }
    return this;
  }
  setResolvedLanguage(l) {
    if (!l || !this.languages) return;
    if (["cimode", "dev"].indexOf(l) > -1) return;
    for (let li = 0; li < this.languages.length; li++) {
      const lngInLngs = this.languages[li];
      if (["cimode", "dev"].indexOf(lngInLngs) > -1) continue;
      if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
        this.resolvedLanguage = lngInLngs;
        break;
      }
    }
  }
  changeLanguage(lng, callback) {
    var _this2 = this;
    this.isLanguageChangingTo = lng;
    const deferred = defer();
    this.emit("languageChanging", lng);
    const setLngProps = (l) => {
      this.language = l;
      this.languages = this.services.languageUtils.toResolveHierarchy(l);
      this.resolvedLanguage = void 0;
      this.setResolvedLanguage(l);
    };
    const done = (err, l) => {
      if (l) {
        setLngProps(l);
        this.translator.changeLanguage(l);
        this.isLanguageChangingTo = void 0;
        this.emit("languageChanged", l);
        this.logger.log("languageChanged", l);
      } else {
        this.isLanguageChangingTo = void 0;
      }
      deferred.resolve(function() {
        return _this2.t(...arguments);
      });
      if (callback) callback(err, function() {
        return _this2.t(...arguments);
      });
    };
    const setLng = (lngs) => {
      if (!lng && !lngs && this.services.languageDetector) lngs = [];
      const l = isString(lngs) ? lngs : this.services.languageUtils.getBestMatchFromCodes(lngs);
      if (l) {
        if (!this.language) {
          setLngProps(l);
        }
        if (!this.translator.language) this.translator.changeLanguage(l);
        if (this.services.languageDetector && this.services.languageDetector.cacheUserLanguage) this.services.languageDetector.cacheUserLanguage(l);
      }
      this.loadResources(l, (err) => {
        done(err, l);
      });
    };
    if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
      setLng(this.services.languageDetector.detect());
    } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
      if (this.services.languageDetector.detect.length === 0) {
        this.services.languageDetector.detect().then(setLng);
      } else {
        this.services.languageDetector.detect(setLng);
      }
    } else {
      setLng(lng);
    }
    return deferred;
  }
  getFixedT(lng, ns, keyPrefix) {
    var _this3 = this;
    const fixedT = function(key, opts) {
      let options;
      if (typeof opts !== "object") {
        for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
          rest[_key3 - 2] = arguments[_key3];
        }
        options = _this3.options.overloadTranslationOptionHandler([key, opts].concat(rest));
      } else {
        options = {
          ...opts
        };
      }
      options.lng = options.lng || fixedT.lng;
      options.lngs = options.lngs || fixedT.lngs;
      options.ns = options.ns || fixedT.ns;
      if (options.keyPrefix !== "") options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
      const keySeparator = _this3.options.keySeparator || ".";
      let resultKey;
      if (options.keyPrefix && Array.isArray(key)) {
        resultKey = key.map((k) => `${options.keyPrefix}${keySeparator}${k}`);
      } else {
        resultKey = options.keyPrefix ? `${options.keyPrefix}${keySeparator}${key}` : key;
      }
      return _this3.t(resultKey, options);
    };
    if (isString(lng)) {
      fixedT.lng = lng;
    } else {
      fixedT.lngs = lng;
    }
    fixedT.ns = ns;
    fixedT.keyPrefix = keyPrefix;
    return fixedT;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(ns) {
    this.options.defaultNS = ns;
  }
  hasLoadedNamespace(ns) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized) {
      this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
      return false;
    }
    if (!this.languages || !this.languages.length) {
      this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
      return false;
    }
    const lng = options.lng || this.resolvedLanguage || this.languages[0];
    const fallbackLng = this.options ? this.options.fallbackLng : false;
    const lastLng = this.languages[this.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    const loadNotPending = (l, n) => {
      const loadState = this.services.backendConnector.state[`${l}|${n}`];
      return loadState === -1 || loadState === 0 || loadState === 2;
    };
    if (options.precheck) {
      const preResult = options.precheck(this, loadNotPending);
      if (preResult !== void 0) return preResult;
    }
    if (this.hasResourceBundle(lng, ns)) return true;
    if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
  }
  loadNamespaces(ns, callback) {
    const deferred = defer();
    if (!this.options.ns) {
      if (callback) callback();
      return Promise.resolve();
    }
    if (isString(ns)) ns = [ns];
    ns.forEach((n) => {
      if (this.options.ns.indexOf(n) < 0) this.options.ns.push(n);
    });
    this.loadResources((err) => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  loadLanguages(lngs, callback) {
    const deferred = defer();
    if (isString(lngs)) lngs = [lngs];
    const preloaded = this.options.preload || [];
    const newLngs = lngs.filter((lng) => preloaded.indexOf(lng) < 0 && this.services.languageUtils.isSupportedCode(lng));
    if (!newLngs.length) {
      if (callback) callback();
      return Promise.resolve();
    }
    this.options.preload = preloaded.concat(newLngs);
    this.loadResources((err) => {
      deferred.resolve();
      if (callback) callback(err);
    });
    return deferred;
  }
  dir(lng) {
    if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
    if (!lng) return "rtl";
    const rtlLngs = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"];
    const languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
    return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    let callback = arguments.length > 1 ? arguments[1] : void 0;
    return new I18n(options, callback);
  }
  cloneInstance() {
    let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    let callback = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : noop;
    const forkResourceStore = options.forkResourceStore;
    if (forkResourceStore) delete options.forkResourceStore;
    const mergedOptions = {
      ...this.options,
      ...options,
      ...{
        isClone: true
      }
    };
    const clone = new I18n(mergedOptions);
    if (options.debug !== void 0 || options.prefix !== void 0) {
      clone.logger = clone.logger.clone(options);
    }
    const membersToCopy = ["store", "services", "language"];
    membersToCopy.forEach((m) => {
      clone[m] = this[m];
    });
    clone.services = {
      ...this.services
    };
    clone.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    if (forkResourceStore) {
      clone.store = new ResourceStore(this.store.data, mergedOptions);
      clone.services.resourceStore = clone.store;
    }
    clone.translator = new Translator(clone.services, mergedOptions);
    clone.translator.on("*", function(event) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      clone.emit(event, ...args);
    });
    clone.init(mergedOptions, callback);
    clone.translator.options = mergedOptions;
    clone.translator.backendConnector.services.utils = {
      hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
    };
    return clone;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
const createInstance = instance.createInstance;
const dir = instance.dir;
const init = instance.init;
const loadResources = instance.loadResources;
const reloadResources = instance.reloadResources;
const use = instance.use;
const changeLanguage = instance.changeLanguage;
const getFixedT = instance.getFixedT;
const t = instance.t;
const exists = instance.exists;
const setDefaultNamespace = instance.setDefaultNamespace;
const hasLoadedNamespace = instance.hasLoadedNamespace;
const loadNamespaces = instance.loadNamespaces;
const loadLanguages = instance.loadLanguages;


/* harmony export */ __webpack_require__.d(__webpack_exports__, [
/* harmony export */   "Ay", 0, /* binding */ instance
/* harmony export */ ]);


/***/ }),

/***/ 91885:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* unused harmony export isBrowser */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === "object" && document.nodeType === 9;
/* harmony default export */ __webpack_exports__.A = (isBrowser);


/***/ }),

/***/ 1756:
/***/ (function(module) {

module.exports = Array.isArray || function(arr) {
  return Object.prototype.toString.call(arr) == "[object Array]";
};


/***/ }),

/***/ 6243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   D_: function() { return /* binding */ createRule; },
/* harmony export */   SN: function() { return /* binding */ SheetsRegistry; },
/* harmony export */   Sg: function() { return /* binding */ toCssValue; },
/* harmony export */   VZ: function() { return /* binding */ RuleList; },
/* harmony export */   ih: function() { return /* binding */ getDynamicStyles; },
/* harmony export */   rN: function() { return /* binding */ hasCSSTOMSupport; },
/* harmony export */   vt: function() { return /* binding */ createJss; }
/* harmony export */ });
/* unused harmony exports SheetsManager, createGenerateId, sheets */
/* unused harmony import specifier */ var warning;
/* unused harmony import specifier */ var _createClass;
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89435);
/* harmony import */ var is_in_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91885);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64970);
/* harmony import */ var _babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34280);
/* harmony import */ var _babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60326);
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90018);







var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== "object") return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};
  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }
  return newStyle;
}
function createRule(name, decl, options) {
  if (name === void 0) {
    name = "unnamed";
  }
  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;
  if (name[0] === "@") {
     false ? 0 : void 0;
  }
  return null;
}
var join = function join2(value, by) {
  var result = "";
  for (var i = 0; i < value.length; i++) {
    if (value[i] === "!important") break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};
var toCssValue = function toCssValue2(value) {
  if (!Array.isArray(value)) return value;
  var cssValue = "";
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === "!important") break;
      if (cssValue) cssValue += ", ";
      cssValue += join(value[i], " ");
    }
  } else cssValue = join(value, ", ");
  if (value[value.length - 1] === "!important") {
    cssValue += " !important";
  }
  return cssValue;
};
function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: "",
      space: ""
    };
  }
  return {
    linebreak: "\n",
    space: " "
  };
}
function indentStr(str, indent) {
  var result = "";
  for (var index2 = 0; index2 < indent; index2++) {
    result += "  ";
  }
  return result + str;
}
function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }
  var result = "";
  if (!style) return result;
  var _options = options, _options$indent = _options.indent, indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (options.format === false) {
    indent = -Infinity;
  }
  var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak, space = _getWhitespaceSymbols.space;
  if (selector) indent++;
  if (fallbacks) {
    if (Array.isArray(fallbacks)) {
      for (var index2 = 0; index2 < fallbacks.length; index2++) {
        var fallback = fallbacks[index2];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }
  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== "fallbacks") {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  }
  if (!result && !options.allowEmpty) return result;
  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr("}", indent);
}
var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== "undefined" && CSS.escape;
var escape = (function(str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, "\\$1");
});
var BaseStyleRule = /* @__PURE__ */ (function() {
  function BaseStyleRule2(key, style, options) {
    this.type = "style";
    this.isProcessed = false;
    var sheet = options.sheet, Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;
    else if (Renderer) this.renderer = new Renderer();
  }
  var _proto = BaseStyleRule2.prototype;
  _proto.prop = function prop(name, value, options) {
    if (value === void 0) return this.style[name];
    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;
    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }
    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style;
    if (isEmpty && !isDefined && !force) return this;
    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];
    else this.style[name] = newValue;
    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);
      else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }
    var sheet = this.options.sheet;
    if (sheet && sheet.attached) {
       false ? 0 : void 0;
    }
    return this;
  };
  return BaseStyleRule2;
})();
var StyleRule = /* @__PURE__ */ (function(_BaseStyleRule) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(StyleRule2, _BaseStyleRule);
  function StyleRule2(key, style, options) {
    var _this;
    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector, scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)((0,_babel_runtime_helpers_esm_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .A)(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }
    return _this;
  }
  var _proto2 = StyleRule2.prototype;
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;
    if (renderer) {
      var json = this.toJSON();
      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }
    return this;
  };
  _proto2.toJSON = function toJSON() {
    var json = {};
    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== "object") json[prop] = value;
      else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }
    return json;
  };
  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(StyleRule2, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer, renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector);
      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    },
    get: function get() {
      return this.selectorText;
    }
  }]);
  return StyleRule2;
})(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === "@" || options.parent && options.parent.type === "keyframes") {
      return null;
    }
    return new StyleRule(key, style, options);
  }
};
var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
var ConditionalRule = /* @__PURE__ */ (function() {
  function ConditionalRule2(key, styles, options) {
    this.type = "conditional";
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : "unknown";
    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, options, {
      parent: this
    }));
    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }
    this.rules.process();
  }
  var _proto = ConditionalRule2.prototype;
  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  };
  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  };
  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  };
  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  };
  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;
    if (options.children === false) {
      return this.query + " {}";
    }
    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : "";
  };
  return ConditionalRule2;
})();
var keyRegExp = /@container|@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule2(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};
var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
var KeyframesRule = /* @__PURE__ */ (function() {
  function KeyframesRule2(key, frames, options) {
    this.type = "keyframes";
    this.at = "@keyframes";
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);
    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = "noname";
       false ? 0 : void 0;
    }
    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped, sheet = options.sheet, generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList((0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, options, {
      parent: this
    }));
    for (var name in frames) {
      this.rules.add(name, frames[name], (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, options, {
        parent: this
      }));
    }
    this.rules.process();
  }
  var _proto = KeyframesRule2.prototype;
  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;
    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }
    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };
  return KeyframesRule2;
})();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;
var findReferencedKeyframe = function findReferencedKeyframe2(val, keyframes) {
  if (typeof val === "string") {
    return val.replace(refRegExp, function(match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }
       false ? 0 : void 0;
      return match;
    });
  }
  return val;
};
var replaceRef = function replaceRef2(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);
  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};
var pluginKeyframesRule = {
  onCreateRule: function onCreateRule3(key, frames, options) {
    return typeof key === "string" && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== "style" || !sheet) return style;
    if ("animation-name" in style) replaceRef(style, "animation-name", sheet.keyframes);
    if ("animation" in style) replaceRef(style, "animation", sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;
    if (!sheet) {
      return val;
    }
    switch (prop) {
      case "animation":
        return findReferencedKeyframe(val, sheet.keyframes);
      case "animation-name":
        return findReferencedKeyframe(val, sheet.keyframes);
      default:
        return val;
    }
  }
};
var KeyframeRule = /* @__PURE__ */ (function(_BaseStyleRule) {
  (0,_babel_runtime_helpers_esm_inheritsLoose__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .A)(KeyframeRule2, _BaseStyleRule);
  function KeyframeRule2() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }
  var _proto = KeyframeRule2.prototype;
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };
  return KeyframeRule2;
})(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule4(key, style, options) {
    if (options.parent && options.parent.type === "keyframes") {
      return new KeyframeRule(key, style, options);
    }
    return null;
  }
};
var FontFaceRule = /* @__PURE__ */ (function() {
  function FontFaceRule2(key, style, options) {
    this.type = "font-face";
    this.at = "@font-face";
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  var _proto = FontFaceRule2.prototype;
  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
    if (Array.isArray(this.style)) {
      var str = "";
      for (var index2 = 0; index2 < this.style.length; index2++) {
        str += toCss(this.at, this.style[index2]);
        if (this.style[index2 + 1]) str += linebreak;
      }
      return str;
    }
    return toCss(this.at, this.style, options);
  };
  return FontFaceRule2;
})();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule5(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};
var ViewportRule = /* @__PURE__ */ (function() {
  function ViewportRule2(key, style, options) {
    this.type = "viewport";
    this.at = "@viewport";
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  var _proto = ViewportRule2.prototype;
  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };
  return ViewportRule2;
})();
var pluginViewportRule = {
  onCreateRule: function onCreateRule6(key, style, options) {
    return key === "@viewport" || key === "@-ms-viewport" ? new ViewportRule(key, style, options) : null;
  }
};
var SimpleRule = /* @__PURE__ */ (function() {
  function SimpleRule2(key, value, options) {
    this.type = "simple";
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  var _proto = SimpleRule2.prototype;
  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = "";
      for (var index2 = 0; index2 < this.value.length; index2++) {
        str += this.key + " " + this.value[index2] + ";";
        if (this.value[index2 + 1]) str += "\n";
      }
      return str;
    }
    return this.key + " " + this.value + ";";
  };
  return SimpleRule2;
})();
var keysMap = {
  "@charset": true,
  "@import": true,
  "@namespace": true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule7(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};
var plugins = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];
var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */
};
var RuleList = /* @__PURE__ */ (function() {
  function RuleList2(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  var _proto = RuleList2.prototype;
  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options, parent = _this$options.parent, sheet = _this$options.sheet, jss = _this$options.jss, Renderer = _this$options.Renderer, generateId = _this$options.generateId, scoped = _this$options.scoped;
    var options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({
      classes: this.classes,
      parent,
      sheet,
      jss,
      Renderer,
      generateId,
      scoped,
      name,
      keyframes: this.keyframes,
      selector: void 0
    }, ruleOptions);
    var key = name;
    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    }
    this.raw[key] = decl;
    if (key in this.classes) {
      options.selector = "." + escape(this.classes[key]);
    }
    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index2 = options.index === void 0 ? this.index.length : options.index;
    this.index.splice(index2, 0, rule);
    return rule;
  };
  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);
    if (oldRule) {
      this.remove(oldRule);
    }
    var options = ruleOptions;
    if (oldIndex !== -1) options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  };
  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  };
  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  };
  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  };
  _proto.process = function process2() {
    var plugins2 = this.options.jss.plugins;
    this.index.slice(0).forEach(plugins2.onProcessRule, plugins2);
  };
  _proto.register = function register(rule) {
    this.map[rule.key] = rule;
    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  };
  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];
    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  };
  _proto.update = function update() {
    var name;
    var data;
    var options;
    if (typeof (arguments.length <= 0 ? void 0 : arguments[0]) === "string") {
      name = arguments.length <= 0 ? void 0 : arguments[0];
      data = arguments.length <= 1 ? void 0 : arguments[1];
      options = arguments.length <= 2 ? void 0 : arguments[2];
    } else {
      data = arguments.length <= 0 ? void 0 : arguments[0];
      options = arguments.length <= 1 ? void 0 : arguments[1];
      name = null;
    }
    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index2 = 0; index2 < this.index.length; index2++) {
        this.updateOne(this.index[index2], data, options);
      }
    }
  };
  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }
    var _this$options2 = this.options, plugins2 = _this$options2.jss.plugins, sheet = _this$options2.sheet;
    if (rule.rules instanceof RuleList2) {
      rule.rules.update(data, options);
      return;
    }
    var style = rule.style;
    plugins2.onUpdate(data, rule, sheet, options);
    if (options.process && style && style !== rule.style) {
      plugins2.onProcessStyle(rule.style, rule, sheet);
      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop];
        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      }
      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop];
        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  };
  _proto.toString = function toString(options) {
    var str = "";
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
    for (var index2 = 0; index2 < this.index.length; index2++) {
      var rule = this.index[index2];
      var css = rule.toString(options);
      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }
    return str;
  };
  return RuleList2;
})();
var StyleSheet = /* @__PURE__ */ (function() {
  function StyleSheet2(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });
    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }
    this.rules = new RuleList(this.options);
    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }
    this.rules.process();
  }
  var _proto = StyleSheet2.prototype;
  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true;
    if (!this.deployed) this.deploy();
    return this;
  };
  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  };
  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue;
    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    if (this.attached) {
      if (!this.deployed) return rule;
      if (queue) queue.push(rule);
      else {
        this.insertRule(rule);
        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = void 0;
        }
      }
      return rule;
    }
    this.deployed = false;
    return rule;
  };
  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);
    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }
    if (this.attached) {
      if (!this.deployed) return newRule;
      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }
      return newRule;
    }
    this.deployed = false;
    return newRule;
  };
  _proto.insertRule = function insertRule2(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  };
  _proto.addRules = function addRules(styles, options) {
    var added = [];
    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }
    return added;
  };
  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  };
  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === "object" ? name : this.rules.get(name);
    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }
    this.rules.remove(rule);
    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }
    return true;
  };
  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  };
  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  };
  _proto.update = function update() {
    var _this$rules;
    (_this$rules = this.rules).update.apply(_this$rules, arguments);
    return this;
  };
  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  };
  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };
  return StyleSheet2;
})();
var PluginsRegistry = /* @__PURE__ */ (function() {
  function PluginsRegistry2() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }
  var _proto = PluginsRegistry2.prototype;
  _proto.onCreateRule = function onCreateRule8(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }
    return null;
  };
  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;
    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }
    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  };
  _proto.onProcessStyle = function onProcessStyle2(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  };
  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  };
  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  };
  _proto.onChangeValue = function onChangeValue2(value, prop, rule) {
    var processedValue = value;
    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }
    return processedValue;
  };
  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: "external"
      };
    }
    var plugins2 = this.plugins[options.queue];
    if (plugins2.indexOf(newPlugin) !== -1) {
      return;
    }
    plugins2.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function(registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? 0 : void 0;
        }
      }
      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };
  return PluginsRegistry2;
})();
var SheetsRegistry = /* @__PURE__ */ (function() {
  function SheetsRegistry2() {
    this.registry = [];
  }
  var _proto = SheetsRegistry2.prototype;
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index2 = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;
    if (registry.length === 0 || index2 >= this.index) {
      registry.push(sheet);
      return;
    }
    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index2) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  };
  _proto.reset = function reset() {
    this.registry = [];
  };
  _proto.remove = function remove(sheet) {
    var index2 = this.registry.indexOf(sheet);
    this.registry.splice(index2, 1);
  };
  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, attached = _ref.attached, options = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .A)(_ref, ["attached"]);
    var _getWhitespaceSymbols = getWhitespaceSymbols(options), linebreak = _getWhitespaceSymbols.linebreak;
    var css = "";
    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];
      if (attached != null && sheet.attached !== attached) {
        continue;
      }
      if (css) css += linebreak;
      css += sheet.toString(options);
    }
    return css;
  };
  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)(SheetsRegistry2, [{
    key: "index",
    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);
  return SheetsRegistry2;
})();
var sheets = new SheetsRegistry();
var globalThis$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" && window.Math === Math ? window : typeof self !== "undefined" && self.Math === Math ? self : Function("return this")();
var ns = "2f1acc6c3a606b082e5eef5e54414ffb";
if (globalThis$1[ns] == null) globalThis$1[ns] = 0;
var moduleId = globalThis$1[ns]++;
var maxRules = 1e10;
var createGenerateId = function createGenerateId2(options) {
  if (options === void 0) {
    options = {};
  }
  var ruleCounter = 0;
  var generateId = function generateId2(rule, sheet) {
    ruleCounter += 1;
    if (ruleCounter > maxRules) {
       false ? 0 : void 0;
    }
    var jssId = "";
    var prefix = "";
    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }
      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }
    if (options.minify) {
      return "" + (prefix || "c") + moduleId + jssId + ruleCounter;
    }
    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : "") + "-" + ruleCounter;
  };
  return generateId;
};
var memoize = function memoize2(fn) {
  var value;
  return function() {
    if (!value) value = fn();
    return value;
  };
};
var getPropertyValue = function getPropertyValue2(cssRule, prop) {
  try {
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    return "";
  }
};
var setProperty = function setProperty2(cssRule, prop, value) {
  try {
    var cssValue = value;
    if (Array.isArray(value)) {
      cssValue = toCssValue(value);
    }
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      var indexOfImportantFlag = cssValue ? cssValue.indexOf("!important") : -1;
      var cssValueWithoutImportantFlag = indexOfImportantFlag > -1 ? cssValue.substr(0, indexOfImportantFlag - 1) : cssValue;
      cssRule.style.setProperty(prop, cssValueWithoutImportantFlag, indexOfImportantFlag > -1 ? "important" : "");
    }
  } catch (err) {
    return false;
  }
  return true;
};
var removeProperty = function removeProperty2(cssRule, prop) {
  try {
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? 0 : void 0;
  }
};
var setSelector = function setSelector2(cssRule, selectorText) {
  cssRule.selectorText = selectorText;
  return cssRule.selectorText === selectorText;
};
var getHead = memoize(function() {
  return document.querySelector("head");
});
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}
function findPrevNode(options) {
  var registry = sheets.registry;
  if (registry.length > 0) {
    var sheet = findHigherSheet(registry, options);
    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    }
    sheet = findHighestSheet(registry, options);
    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  }
  var insertionPoint = options.insertionPoint;
  if (insertionPoint && typeof insertionPoint === "string") {
    var comment = findCommentNode(insertionPoint);
    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    }
     false ? 0 : void 0;
  }
  return false;
}
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);
  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  }
  if (insertionPoint && typeof insertionPoint.nodeType === "number") {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
    else  false ? 0 : void 0;
    return;
  }
  getHead().appendChild(style);
}
var getNonce = memoize(function() {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute("content") : null;
});
var _insertRule = function insertRule(container, rule, index2) {
  try {
    if ("insertRule" in container) {
      container.insertRule(rule, index2);
    } else if ("appendRule" in container) {
      container.appendRule(rule);
    }
  } catch (err) {
     false ? 0 : void 0;
    return false;
  }
  return container.cssRules[index2];
};
var getValidRuleInsertionIndex = function getValidRuleInsertionIndex2(container, index2) {
  var maxIndex = container.cssRules.length;
  if (index2 === void 0 || index2 > maxIndex) {
    return maxIndex;
  }
  return index2;
};
var createStyle = function createStyle2() {
  var el = document.createElement("style");
  el.textContent = "\n";
  return el;
};
var DomRenderer = /* @__PURE__ */ (function() {
  function DomRenderer2(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;
    var _ref = this.sheet ? this.sheet.options : {}, media = _ref.media, meta = _ref.meta, element = _ref.element;
    this.element = element || createStyle();
    this.element.setAttribute("data-jss", "");
    if (media) this.element.setAttribute("media", media);
    if (meta) this.element.setAttribute("data-meta", meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute("nonce", nonce);
  }
  var _proto = DomRenderer2.prototype;
  _proto.attach = function attach() {
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options);
    var deployed = Boolean(this.sheet && this.sheet.deployed);
    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  };
  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element);
    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = "\n";
    }
  };
  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;
    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }
    this.element.textContent = "\n" + sheet.toString() + "\n";
  };
  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  };
  _proto.insertRule = function insertRule2(rule, index2, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }
    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;
      if (rule.type === "conditional" || rule.type === "keyframes") {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index2);
        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);
        if (latestNativeParent === false) {
          return false;
        }
        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }
      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }
    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index2);
    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);
    if (nativeRule === false) {
      return false;
    }
    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };
  _proto.refCssRule = function refCssRule(rule, index2, cssRule) {
    rule.renderable = cssRule;
    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index2, 0, cssRule);
    }
  };
  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index2 = this.indexOf(cssRule);
    if (index2 === -1) return false;
    sheet.deleteRule(index2);
    this.cssRules.splice(index2, 1);
    return true;
  };
  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  };
  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index2 = this.indexOf(cssRule);
    if (index2 === -1) return false;
    this.element.sheet.deleteRule(index2);
    this.cssRules.splice(index2, 1);
    return this.insertRule(rule, index2);
  };
  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };
  return DomRenderer2;
})();
var instanceCounter = 0;
var Jss = /* @__PURE__ */ (function() {
  function Jss2(options) {
    this.id = instanceCounter++;
    this.version = "10.10.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId,
      Renderer: is_in_browser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });
    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: "internal"
      });
    }
    this.setup(options);
  }
  var _proto = Jss2.prototype;
  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }
    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }
    if (options.id) {
      this.options.id = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, this.options.id, options.id);
    }
    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }
    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
    if ("Renderer" in options) {
      this.options.Renderer = options.Renderer;
    }
    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  };
  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }
    var _options = options, index2 = _options.index;
    if (typeof index2 !== "number") {
      index2 = sheets.index === 0 ? 0 : sheets.index + 1;
    }
    var sheet = new StyleSheet(styles, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index2
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  };
  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  };
  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }
    if (options === void 0) {
      options = {};
    }
    if (typeof name === "object") {
      return this.createRule(void 0, name, style);
    }
    var ruleOptions = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .A)({}, options, {
      name,
      jss: this,
      Renderer: this.options.Renderer
    });
    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
    var rule = createRule(name, style, ruleOptions);
    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  };
  _proto.use = function use() {
    var _this = this;
    for (var _len = arguments.length, plugins2 = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins2[_key] = arguments[_key];
    }
    plugins2.forEach(function(plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };
  return Jss2;
})();
var createJss = function createJss2(options) {
  return new Jss(options);
};
var SheetsManager = /* @__PURE__ */ (/* unused pure expression or super */ null && ((function() {
  function SheetsManager2() {
    this.length = 0;
    this.sheets = /* @__PURE__ */ new WeakMap();
  }
  var _proto = SheetsManager2.prototype;
  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };
  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet,
      refs: 0
    });
  };
  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);
    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }
      entry.refs++;
      return entry.sheet;
    }
    warning(false, "[JSS] SheetsManager: can't find sheet to manage");
    return void 0;
  };
  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);
    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      warning(false, "SheetsManager: can't find sheet to unmanage");
    }
  };
  _createClass(SheetsManager2, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);
  return SheetsManager2;
})()));
var hasCSSTOMSupport = typeof CSS === "object" && CSS != null && "number" in CSS;
function getDynamicStyles(styles) {
  var to = null;
  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;
    if (type === "function") {
      if (!to) to = {};
      to[key] = value;
    } else if (type === "object" && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }
  return to;
}
/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
var index = createJss();
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (index)));



/***/ }),

/***/ 32939:
/***/ (function(__unused_webpack_module, exports) {

/* @preserve
 * L2DV 1.9.4, a JS library for interactive maps. https://L2DVjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */
(function(global, factory) {
   true ? factory(exports) : 0;
})(this, (function(exports2) {
  "use strict";
  var version = "1.9.4";
  function extend(dest) {
    var i, j, len, src;
    for (j = 1, len = arguments.length; j < len; j++) {
      src = arguments[j];
      for (i in src) {
        dest[i] = src[i];
      }
    }
    return dest;
  }
  var create$2 = Object.create || /* @__PURE__ */ (function() {
    function F() {
    }
    return function(proto) {
      F.prototype = proto;
      return new F();
    };
  })();
  function bind(fn, obj) {
    var slice = Array.prototype.slice;
    if (fn.bind) {
      return fn.bind.apply(fn, slice.call(arguments, 1));
    }
    var args = slice.call(arguments, 2);
    return function() {
      return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
    };
  }
  var lastId = 0;
  function stamp(obj) {
    if (!("_L2DV_id" in obj)) {
      obj["_L2DV_id"] = ++lastId;
    }
    return obj._L2DV_id;
  }
  function throttle(fn, time, context) {
    var lock, args, wrapperFn, later;
    later = function() {
      lock = false;
      if (args) {
        wrapperFn.apply(context, args);
        args = false;
      }
    };
    wrapperFn = function() {
      if (lock) {
        args = arguments;
      } else {
        fn.apply(context, arguments);
        setTimeout(later, time);
        lock = true;
      }
    };
    return wrapperFn;
  }
  function wrapNum(x, range, includeMax) {
    var max = range[1], min = range[0], d = max - min;
    return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
  }
  function falseFn() {
    return false;
  }
  function formatNum(num, precision) {
    if (precision === false) {
      return num;
    }
    var pow = Math.pow(10, precision === void 0 ? 6 : precision);
    return Math.round(num * pow) / pow;
  }
  function trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
  }
  function splitWords(str) {
    return trim(str).split(/\s+/);
  }
  function setOptions(obj, options) {
    if (!Object.prototype.hasOwnProperty.call(obj, "options")) {
      obj.options = obj.options ? create$2(obj.options) : {};
    }
    for (var i in options) {
      obj.options[i] = options[i];
    }
    return obj.options;
  }
  function getParamString(obj, existingUrl, uppercase) {
    var params = [];
    for (var i in obj) {
      params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + "=" + encodeURIComponent(obj[i]));
    }
    return (!existingUrl || existingUrl.indexOf("?") === -1 ? "?" : "&") + params.join("&");
  }
  var templateRe = /\{ *([\w_ -]+) *\}/g;
  function template(str, data) {
    return str.replace(templateRe, function(str2, key) {
      var value = data[key];
      if (value === void 0) {
        throw new Error("No value provided for variable " + str2);
      } else if (typeof value === "function") {
        value = value(data);
      }
      return value;
    });
  }
  var isArray = Array.isArray || function(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
  };
  function indexOf(array, el) {
    for (var i = 0; i < array.length; i++) {
      if (array[i] === el) {
        return i;
      }
    }
    return -1;
  }
  var emptyImageUrl = "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=";
  function getPrefixed(name) {
    return window["webkit" + name] || window["moz" + name] || window["ms" + name];
  }
  var lastTime = 0;
  function timeoutDefer(fn) {
    var time = +/* @__PURE__ */ new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
    lastTime = time + timeToCall;
    return window.setTimeout(fn, timeToCall);
  }
  var requestFn = window.requestAnimationFrame || getPrefixed("RequestAnimationFrame") || timeoutDefer;
  var cancelFn = window.cancelAnimationFrame || getPrefixed("CancelAnimationFrame") || getPrefixed("CancelRequestAnimationFrame") || function(id) {
    window.clearTimeout(id);
  };
  function requestAnimFrame(fn, context, immediate) {
    if (immediate && requestFn === timeoutDefer) {
      fn.call(context);
    } else {
      return requestFn.call(window, bind(fn, context));
    }
  }
  function cancelAnimFrame(id) {
    if (id) {
      cancelFn.call(window, id);
    }
  }
  var Util = {
    __proto__: null,
    extend,
    create: create$2,
    bind,
    get lastId() {
      return lastId;
    },
    stamp,
    throttle,
    wrapNum,
    falseFn,
    formatNum,
    trim,
    splitWords,
    setOptions,
    getParamString,
    template,
    isArray,
    indexOf,
    emptyImageUrl,
    requestFn,
    cancelFn,
    requestAnimFrame,
    cancelAnimFrame
  };
  function Class() {
  }
  Class.extend = function(props) {
    var NewClass = function() {
      setOptions(this);
      if (this.initialize) {
        this.initialize.apply(this, arguments);
      }
      this.callInitHooks();
    };
    var parentProto = NewClass.__super__ = this.prototype;
    var proto = create$2(parentProto);
    proto.constructor = NewClass;
    NewClass.prototype = proto;
    for (var i in this) {
      if (Object.prototype.hasOwnProperty.call(this, i) && i !== "prototype" && i !== "__super__") {
        NewClass[i] = this[i];
      }
    }
    if (props.statics) {
      extend(NewClass, props.statics);
    }
    if (props.includes) {
      checkDeprecatedMixinEvents(props.includes);
      extend.apply(null, [proto].concat(props.includes));
    }
    extend(proto, props);
    delete proto.statics;
    delete proto.includes;
    if (proto.options) {
      proto.options = parentProto.options ? create$2(parentProto.options) : {};
      extend(proto.options, props.options);
    }
    proto._initHooks = [];
    proto.callInitHooks = function() {
      if (this._initHooksCalled) {
        return;
      }
      if (parentProto.callInitHooks) {
        parentProto.callInitHooks.call(this);
      }
      this._initHooksCalled = true;
      for (var i2 = 0, len = proto._initHooks.length; i2 < len; i2++) {
        proto._initHooks[i2].call(this);
      }
    };
    return NewClass;
  };
  Class.include = function(props) {
    var parentOptions = this.prototype.options;
    extend(this.prototype, props);
    if (props.options) {
      this.prototype.options = parentOptions;
      this.mergeOptions(props.options);
    }
    return this;
  };
  Class.mergeOptions = function(options) {
    extend(this.prototype.options, options);
    return this;
  };
  Class.addInitHook = function(fn) {
    var args = Array.prototype.slice.call(arguments, 1);
    var init = typeof fn === "function" ? fn : function() {
      this[fn].apply(this, args);
    };
    this.prototype._initHooks = this.prototype._initHooks || [];
    this.prototype._initHooks.push(init);
    return this;
  };
  function checkDeprecatedMixinEvents(includes) {
    if (typeof L === "undefined" || !L || !L.Mixin) {
      return;
    }
    includes = isArray(includes) ? includes : [includes];
    for (var i = 0; i < includes.length; i++) {
      if (includes[i] === L.Mixin.Events) {
        console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
      }
    }
  }
  var Events = {
    /* @method on(type: String, fn: Function, context?: Object): this
     * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
     *
     * @alternative
     * @method on(eventMap: Object): this
     * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
     */
    on: function(types, fn, context) {
      if (typeof types === "object") {
        for (var type in types) {
          this._on(type, types[type], fn);
        }
      } else {
        types = splitWords(types);
        for (var i = 0, len = types.length; i < len; i++) {
          this._on(types[i], fn, context);
        }
      }
      return this;
    },
    /* @method off(type: String, fn?: Function, context?: Object): this
     * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
     *
     * @alternative
     * @method off(eventMap: Object): this
     * Removes a set of type/listener pairs.
     *
     * @alternative
     * @method off: this
     * Removes all listeners to all events on the object. This includes implicitly attached events.
     */
    off: function(types, fn, context) {
      if (!arguments.length) {
        delete this._events;
      } else if (typeof types === "object") {
        for (var type in types) {
          this._off(type, types[type], fn);
        }
      } else {
        types = splitWords(types);
        var removeAll = arguments.length === 1;
        for (var i = 0, len = types.length; i < len; i++) {
          if (removeAll) {
            this._off(types[i]);
          } else {
            this._off(types[i], fn, context);
          }
        }
      }
      return this;
    },
    // attach listener (without syntactic sugar now)
    _on: function(type, fn, context, _once) {
      if (typeof fn !== "function") {
        console.warn("wrong listener type: " + typeof fn);
        return;
      }
      if (this._listens(type, fn, context) !== false) {
        return;
      }
      if (context === this) {
        context = void 0;
      }
      var newListener = { fn, ctx: context };
      if (_once) {
        newListener.once = true;
      }
      this._events = this._events || {};
      this._events[type] = this._events[type] || [];
      this._events[type].push(newListener);
    },
    _off: function(type, fn, context) {
      var listeners, i, len;
      if (!this._events) {
        return;
      }
      listeners = this._events[type];
      if (!listeners) {
        return;
      }
      if (arguments.length === 1) {
        if (this._firingCount) {
          for (i = 0, len = listeners.length; i < len; i++) {
            listeners[i].fn = falseFn;
          }
        }
        delete this._events[type];
        return;
      }
      if (typeof fn !== "function") {
        console.warn("wrong listener type: " + typeof fn);
        return;
      }
      var index2 = this._listens(type, fn, context);
      if (index2 !== false) {
        var listener = listeners[index2];
        if (this._firingCount) {
          listener.fn = falseFn;
          this._events[type] = listeners = listeners.slice();
        }
        listeners.splice(index2, 1);
      }
    },
    // @method fire(type: String, data?: Object, propagate?: Boolean): this
    // Fires an event of the specified type. You can optionally provide a data
    // object — the first argument of the listener function will contain its
    // properties. The event can optionally be propagated to event parents.
    fire: function(type, data, propagate) {
      if (!this.listens(type, propagate)) {
        return this;
      }
      var event = extend({}, data, {
        type,
        target: this,
        sourceTarget: data && data.sourceTarget || this
      });
      if (this._events) {
        var listeners = this._events[type];
        if (listeners) {
          this._firingCount = this._firingCount + 1 || 1;
          for (var i = 0, len = listeners.length; i < len; i++) {
            var l = listeners[i];
            var fn = l.fn;
            if (l.once) {
              this.off(type, fn, l.ctx);
            }
            fn.call(l.ctx || this, event);
          }
          this._firingCount--;
        }
      }
      if (propagate) {
        this._propagateEvent(event);
      }
      return this;
    },
    // @method listens(type: String, propagate?: Boolean): Boolean
    // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
    // Returns `true` if a particular event type has any listeners attached to it.
    // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
    listens: function(type, fn, context, propagate) {
      if (typeof type !== "string") {
        console.warn('"string" type argument expected');
      }
      var _fn = fn;
      if (typeof fn !== "function") {
        propagate = !!fn;
        _fn = void 0;
        context = void 0;
      }
      var listeners = this._events && this._events[type];
      if (listeners && listeners.length) {
        if (this._listens(type, _fn, context) !== false) {
          return true;
        }
      }
      if (propagate) {
        for (var id in this._eventParents) {
          if (this._eventParents[id].listens(type, fn, context, propagate)) {
            return true;
          }
        }
      }
      return false;
    },
    // returns the index (number) or false
    _listens: function(type, fn, context) {
      if (!this._events) {
        return false;
      }
      var listeners = this._events[type] || [];
      if (!fn) {
        return !!listeners.length;
      }
      if (context === this) {
        context = void 0;
      }
      for (var i = 0, len = listeners.length; i < len; i++) {
        if (listeners[i].fn === fn && listeners[i].ctx === context) {
          return i;
        }
      }
      return false;
    },
    // @method once(…): this
    // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
    once: function(types, fn, context) {
      if (typeof types === "object") {
        for (var type in types) {
          this._on(type, types[type], fn, true);
        }
      } else {
        types = splitWords(types);
        for (var i = 0, len = types.length; i < len; i++) {
          this._on(types[i], fn, context, true);
        }
      }
      return this;
    },
    // @method addEventParent(obj: Evented): this
    // Adds an event parent - an `Evented` that will receive propagated events
    addEventParent: function(obj) {
      this._eventParents = this._eventParents || {};
      this._eventParents[stamp(obj)] = obj;
      return this;
    },
    // @method removeEventParent(obj: Evented): this
    // Removes an event parent, so it will stop receiving propagated events
    removeEventParent: function(obj) {
      if (this._eventParents) {
        delete this._eventParents[stamp(obj)];
      }
      return this;
    },
    _propagateEvent: function(e) {
      for (var id in this._eventParents) {
        this._eventParents[id].fire(e.type, extend({
          layer: e.target,
          propagatedFrom: e.target
        }, e), true);
      }
    }
  };
  Events.addEventListener = Events.on;
  Events.removeEventListener = Events.clearAllEventListeners = Events.off;
  Events.addOneTimeEventListener = Events.once;
  Events.fireEvent = Events.fire;
  Events.hasEventListeners = Events.listens;
  var Evented = Class.extend(Events);
  function Point(x, y, round) {
    this.x = round ? Math.round(x) : x;
    this.y = round ? Math.round(y) : y;
  }
  var trunc = Math.trunc || function(v) {
    return v > 0 ? Math.floor(v) : Math.ceil(v);
  };
  Point.prototype = {
    // @method clone(): Point
    // Returns a copy of the current point.
    clone: function() {
      return new Point(this.x, this.y);
    },
    // @method add(otherPoint: Point): Point
    // Returns the result of addition of the current and the given points.
    add: function(point) {
      return this.clone()._add(toPoint(point));
    },
    _add: function(point) {
      this.x += point.x;
      this.y += point.y;
      return this;
    },
    // @method subtract(otherPoint: Point): Point
    // Returns the result of subtraction of the given point from the current.
    subtract: function(point) {
      return this.clone()._subtract(toPoint(point));
    },
    _subtract: function(point) {
      this.x -= point.x;
      this.y -= point.y;
      return this;
    },
    // @method divideBy(num: Number): Point
    // Returns the result of division of the current point by the given number.
    divideBy: function(num) {
      return this.clone()._divideBy(num);
    },
    _divideBy: function(num) {
      this.x /= num;
      this.y /= num;
      return this;
    },
    // @method multiplyBy(num: Number): Point
    // Returns the result of multiplication of the current point by the given number.
    multiplyBy: function(num) {
      return this.clone()._multiplyBy(num);
    },
    _multiplyBy: function(num) {
      this.x *= num;
      this.y *= num;
      return this;
    },
    // @method scaleBy(scale: Point): Point
    // Multiply each coordinate of the current point by each coordinate of
    // `scale`. In linear algebra terms, multiply the point by the
    // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
    // defined by `scale`.
    scaleBy: function(point) {
      return new Point(this.x * point.x, this.y * point.y);
    },
    // @method unscaleBy(scale: Point): Point
    // Inverse of `scaleBy`. Divide each coordinate of the current point by
    // each coordinate of `scale`.
    unscaleBy: function(point) {
      return new Point(this.x / point.x, this.y / point.y);
    },
    // @method round(): Point
    // Returns a copy of the current point with rounded coordinates.
    round: function() {
      return this.clone()._round();
    },
    _round: function() {
      this.x = Math.round(this.x);
      this.y = Math.round(this.y);
      return this;
    },
    // @method floor(): Point
    // Returns a copy of the current point with floored coordinates (rounded down).
    floor: function() {
      return this.clone()._floor();
    },
    _floor: function() {
      this.x = Math.floor(this.x);
      this.y = Math.floor(this.y);
      return this;
    },
    // @method ceil(): Point
    // Returns a copy of the current point with ceiled coordinates (rounded up).
    ceil: function() {
      return this.clone()._ceil();
    },
    _ceil: function() {
      this.x = Math.ceil(this.x);
      this.y = Math.ceil(this.y);
      return this;
    },
    // @method trunc(): Point
    // Returns a copy of the current point with truncated coordinates (rounded towards zero).
    trunc: function() {
      return this.clone()._trunc();
    },
    _trunc: function() {
      this.x = trunc(this.x);
      this.y = trunc(this.y);
      return this;
    },
    // @method distanceTo(otherPoint: Point): Number
    // Returns the cartesian distance between the current and the given points.
    distanceTo: function(point) {
      point = toPoint(point);
      var x = point.x - this.x, y = point.y - this.y;
      return Math.sqrt(x * x + y * y);
    },
    // @method equals(otherPoint: Point): Boolean
    // Returns `true` if the given point has the same coordinates.
    equals: function(point) {
      point = toPoint(point);
      return point.x === this.x && point.y === this.y;
    },
    // @method contains(otherPoint: Point): Boolean
    // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
    contains: function(point) {
      point = toPoint(point);
      return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
    },
    // @method toString(): String
    // Returns a string representation of the point for debugging purposes.
    toString: function() {
      return "Point(" + formatNum(this.x) + ", " + formatNum(this.y) + ")";
    }
  };
  function toPoint(x, y, round) {
    if (x instanceof Point) {
      return x;
    }
    if (isArray(x)) {
      return new Point(x[0], x[1]);
    }
    if (x === void 0 || x === null) {
      return x;
    }
    if (typeof x === "object" && "x" in x && "y" in x) {
      return new Point(x.x, x.y);
    }
    return new Point(x, y, round);
  }
  function Bounds(a, b) {
    if (!a) {
      return;
    }
    var points = b ? [a, b] : a;
    for (var i = 0, len = points.length; i < len; i++) {
      this.extend(points[i]);
    }
  }
  Bounds.prototype = {
    // @method extend(point: Point): this
    // Extends the bounds to contain the given point.
    // @alternative
    // @method extend(otherBounds: Bounds): this
    // Extend the bounds to contain the given bounds
    extend: function(obj) {
      var min2, max2;
      if (!obj) {
        return this;
      }
      if (obj instanceof Point || typeof obj[0] === "number" || "x" in obj) {
        min2 = max2 = toPoint(obj);
      } else {
        obj = toBounds(obj);
        min2 = obj.min;
        max2 = obj.max;
        if (!min2 || !max2) {
          return this;
        }
      }
      if (!this.min && !this.max) {
        this.min = min2.clone();
        this.max = max2.clone();
      } else {
        this.min.x = Math.min(min2.x, this.min.x);
        this.max.x = Math.max(max2.x, this.max.x);
        this.min.y = Math.min(min2.y, this.min.y);
        this.max.y = Math.max(max2.y, this.max.y);
      }
      return this;
    },
    // @method getCenter(round?: Boolean): Point
    // Returns the center point of the bounds.
    getCenter: function(round) {
      return toPoint(
        (this.min.x + this.max.x) / 2,
        (this.min.y + this.max.y) / 2,
        round
      );
    },
    // @method getBottomLeft(): Point
    // Returns the bottom-left point of the bounds.
    getBottomLeft: function() {
      return toPoint(this.min.x, this.max.y);
    },
    // @method getTopRight(): Point
    // Returns the top-right point of the bounds.
    getTopRight: function() {
      return toPoint(this.max.x, this.min.y);
    },
    // @method getTopLeft(): Point
    // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
    getTopLeft: function() {
      return this.min;
    },
    // @method getBottomRight(): Point
    // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
    getBottomRight: function() {
      return this.max;
    },
    // @method getSize(): Point
    // Returns the size of the given bounds
    getSize: function() {
      return this.max.subtract(this.min);
    },
    // @method contains(otherBounds: Bounds): Boolean
    // Returns `true` if the rectangle contains the given one.
    // @alternative
    // @method contains(point: Point): Boolean
    // Returns `true` if the rectangle contains the given point.
    contains: function(obj) {
      var min, max;
      if (typeof obj[0] === "number" || obj instanceof Point) {
        obj = toPoint(obj);
      } else {
        obj = toBounds(obj);
      }
      if (obj instanceof Bounds) {
        min = obj.min;
        max = obj.max;
      } else {
        min = max = obj;
      }
      return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
    },
    // @method intersects(otherBounds: Bounds): Boolean
    // Returns `true` if the rectangle intersects the given bounds. Two bounds
    // intersect if they have at least one point in common.
    intersects: function(bounds) {
      bounds = toBounds(bounds);
      var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
      return xIntersects && yIntersects;
    },
    // @method overlaps(otherBounds: Bounds): Boolean
    // Returns `true` if the rectangle overlaps the given bounds. Two bounds
    // overlap if their intersection is an area.
    overlaps: function(bounds) {
      bounds = toBounds(bounds);
      var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
      return xOverlaps && yOverlaps;
    },
    // @method isValid(): Boolean
    // Returns `true` if the bounds are properly initialized.
    isValid: function() {
      return !!(this.min && this.max);
    },
    // @method pad(bufferRatio: Number): Bounds
    // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
    // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
    // Negative values will retract the bounds.
    pad: function(bufferRatio) {
      var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
      return toBounds(
        toPoint(min.x - heightBuffer, min.y - widthBuffer),
        toPoint(max.x + heightBuffer, max.y + widthBuffer)
      );
    },
    // @method equals(otherBounds: Bounds): Boolean
    // Returns `true` if the rectangle is equivalent to the given bounds.
    equals: function(bounds) {
      if (!bounds) {
        return false;
      }
      bounds = toBounds(bounds);
      return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
    }
  };
  function toBounds(a, b) {
    if (!a || a instanceof Bounds) {
      return a;
    }
    return new Bounds(a, b);
  }
  function LatLngBounds(corner1, corner2) {
    if (!corner1) {
      return;
    }
    var latlngs = corner2 ? [corner1, corner2] : corner1;
    for (var i = 0, len = latlngs.length; i < len; i++) {
      this.extend(latlngs[i]);
    }
  }
  LatLngBounds.prototype = {
    // @method extend(latlng: LatLng): this
    // Extend the bounds to contain the given point
    // @alternative
    // @method extend(otherBounds: LatLngBounds): this
    // Extend the bounds to contain the given bounds
    extend: function(obj) {
      var sw = this._southWest, ne = this._northEast, sw2, ne2;
      if (obj instanceof LatLng) {
        sw2 = obj;
        ne2 = obj;
      } else if (obj instanceof LatLngBounds) {
        sw2 = obj._southWest;
        ne2 = obj._northEast;
        if (!sw2 || !ne2) {
          return this;
        }
      } else {
        return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
      }
      if (!sw && !ne) {
        this._southWest = new LatLng(sw2.lat, sw2.lng);
        this._northEast = new LatLng(ne2.lat, ne2.lng);
      } else {
        sw.lat = Math.min(sw2.lat, sw.lat);
        sw.lng = Math.min(sw2.lng, sw.lng);
        ne.lat = Math.max(ne2.lat, ne.lat);
        ne.lng = Math.max(ne2.lng, ne.lng);
      }
      return this;
    },
    // @method pad(bufferRatio: Number): LatLngBounds
    // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
    // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
    // Negative values will retract the bounds.
    pad: function(bufferRatio) {
      var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
      return new LatLngBounds(
        new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer),
        new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer)
      );
    },
    // @method getCenter(): LatLng
    // Returns the center point of the bounds.
    getCenter: function() {
      return new LatLng(
        (this._southWest.lat + this._northEast.lat) / 2,
        (this._southWest.lng + this._northEast.lng) / 2
      );
    },
    // @method getSouthWest(): LatLng
    // Returns the south-west point of the bounds.
    getSouthWest: function() {
      return this._southWest;
    },
    // @method getNorthEast(): LatLng
    // Returns the north-east point of the bounds.
    getNorthEast: function() {
      return this._northEast;
    },
    // @method getNorthWest(): LatLng
    // Returns the north-west point of the bounds.
    getNorthWest: function() {
      return new LatLng(this.getNorth(), this.getWest());
    },
    // @method getSouthEast(): LatLng
    // Returns the south-east point of the bounds.
    getSouthEast: function() {
      return new LatLng(this.getSouth(), this.getEast());
    },
    // @method getWest(): Number
    // Returns the west longitude of the bounds
    getWest: function() {
      return this._southWest.lng;
    },
    // @method getSouth(): Number
    // Returns the south latitude of the bounds
    getSouth: function() {
      return this._southWest.lat;
    },
    // @method getEast(): Number
    // Returns the east longitude of the bounds
    getEast: function() {
      return this._northEast.lng;
    },
    // @method getNorth(): Number
    // Returns the north latitude of the bounds
    getNorth: function() {
      return this._northEast.lat;
    },
    // @method contains(otherBounds: LatLngBounds): Boolean
    // Returns `true` if the rectangle contains the given one.
    // @alternative
    // @method contains (latlng: LatLng): Boolean
    // Returns `true` if the rectangle contains the given point.
    contains: function(obj) {
      if (typeof obj[0] === "number" || obj instanceof LatLng || "lat" in obj) {
        obj = toLatLng(obj);
      } else {
        obj = toLatLngBounds(obj);
      }
      var sw = this._southWest, ne = this._northEast, sw2, ne2;
      if (obj instanceof LatLngBounds) {
        sw2 = obj.getSouthWest();
        ne2 = obj.getNorthEast();
      } else {
        sw2 = ne2 = obj;
      }
      return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
    },
    // @method intersects(otherBounds: LatLngBounds): Boolean
    // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
    intersects: function(bounds) {
      bounds = toLatLngBounds(bounds);
      var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
      return latIntersects && lngIntersects;
    },
    // @method overlaps(otherBounds: LatLngBounds): Boolean
    // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
    overlaps: function(bounds) {
      bounds = toLatLngBounds(bounds);
      var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
      return latOverlaps && lngOverlaps;
    },
    // @method toBBoxString(): String
    // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
    toBBoxString: function() {
      return [this.getWest(), this.getSouth(), this.getEast(), this.getNorth()].join(",");
    },
    // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
    // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
    equals: function(bounds, maxMargin) {
      if (!bounds) {
        return false;
      }
      bounds = toLatLngBounds(bounds);
      return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
    },
    // @method isValid(): Boolean
    // Returns `true` if the bounds are properly initialized.
    isValid: function() {
      return !!(this._southWest && this._northEast);
    }
  };
  function toLatLngBounds(a, b) {
    if (a instanceof LatLngBounds) {
      return a;
    }
    return new LatLngBounds(a, b);
  }
  function LatLng(lat, lng, alt) {
    if (isNaN(lat) || isNaN(lng)) {
      throw new Error("Invalid LatLng object: (" + lat + ", " + lng + ")");
    }
    this.lat = +lat;
    this.lng = +lng;
    if (alt !== void 0) {
      this.alt = +alt;
    }
  }
  LatLng.prototype = {
    // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
    // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
    equals: function(obj, maxMargin) {
      if (!obj) {
        return false;
      }
      obj = toLatLng(obj);
      var margin = Math.max(
        Math.abs(this.lat - obj.lat),
        Math.abs(this.lng - obj.lng)
      );
      return margin <= (maxMargin === void 0 ? 1e-9 : maxMargin);
    },
    // @method toString(): String
    // Returns a string representation of the point (for debugging purposes).
    toString: function(precision) {
      return "LatLng(" + formatNum(this.lat, precision) + ", " + formatNum(this.lng, precision) + ")";
    },
    // @method distanceTo(otherLatLng: LatLng): Number
    // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
    distanceTo: function(other) {
      return Earth.distance(this, toLatLng(other));
    },
    // @method wrap(): LatLng
    // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
    wrap: function() {
      return Earth.wrapLatLng(this);
    },
    // @method toBounds(sizeInMeters: Number): LatLngBounds
    // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
    toBounds: function(sizeInMeters) {
      var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
      return toLatLngBounds(
        [this.lat - latAccuracy, this.lng - lngAccuracy],
        [this.lat + latAccuracy, this.lng + lngAccuracy]
      );
    },
    clone: function() {
      return new LatLng(this.lat, this.lng, this.alt);
    }
  };
  function toLatLng(a, b, c) {
    if (a instanceof LatLng) {
      return a;
    }
    if (isArray(a) && typeof a[0] !== "object") {
      if (a.length === 3) {
        return new LatLng(a[0], a[1], a[2]);
      }
      if (a.length === 2) {
        return new LatLng(a[0], a[1]);
      }
      return null;
    }
    if (a === void 0 || a === null) {
      return a;
    }
    if (typeof a === "object" && "lat" in a) {
      return new LatLng(a.lat, "lng" in a ? a.lng : a.lon, a.alt);
    }
    if (b === void 0) {
      return null;
    }
    return new LatLng(a, b, c);
  }
  var CRS = {
    // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
    // Projects geographical coordinates into pixel coordinates for a given zoom.
    latLngToPoint: function(latlng, zoom2) {
      var projectedPoint = this.projection.project(latlng), scale2 = this.scale(zoom2);
      return this.transformation._transform(projectedPoint, scale2);
    },
    // @method pointToLatLng(point: Point, zoom: Number): LatLng
    // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
    // zoom into geographical coordinates.
    pointToLatLng: function(point, zoom2) {
      var scale2 = this.scale(zoom2), untransformedPoint = this.transformation.untransform(point, scale2);
      return this.projection.unproject(untransformedPoint);
    },
    // @method project(latlng: LatLng): Point
    // Projects geographical coordinates into coordinates in units accepted for
    // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
    project: function(latlng) {
      return this.projection.project(latlng);
    },
    // @method unproject(point: Point): LatLng
    // Given a projected coordinate returns the corresponding LatLng.
    // The inverse of `project`.
    unproject: function(point) {
      return this.projection.unproject(point);
    },
    // @method scale(zoom: Number): Number
    // Returns the scale used when transforming projected coordinates into
    // pixel coordinates for a particular zoom. For example, it returns
    // `256 * 2^zoom` for Mercator-based CRS.
    scale: function(zoom2) {
      return 256 * Math.pow(2, zoom2);
    },
    // @method zoom(scale: Number): Number
    // Inverse of `scale()`, returns the zoom level corresponding to a scale
    // factor of `scale`.
    zoom: function(scale2) {
      return Math.log(scale2 / 256) / Math.LN2;
    },
    // @method getProjectedBounds(zoom: Number): Bounds
    // Returns the projection's bounds scaled and transformed for the provided `zoom`.
    getProjectedBounds: function(zoom2) {
      if (this.infinite) {
        return null;
      }
      var b = this.projection.bounds, s = this.scale(zoom2), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
      return new Bounds(min, max);
    },
    // @method distance(latlng1: LatLng, latlng2: LatLng): Number
    // Returns the distance between two geographical coordinates.
    // @property code: String
    // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
    //
    // @property wrapLng: Number[]
    // An array of two numbers defining whether the longitude (horizontal) coordinate
    // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
    // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
    //
    // @property wrapLat: Number[]
    // Like `wrapLng`, but for the latitude (vertical) axis.
    // wrapLng: [min, max],
    // wrapLat: [min, max],
    // @property infinite: Boolean
    // If true, the coordinate space will be unbounded (infinite in both axes)
    infinite: false,
    // @method wrapLatLng(latlng: LatLng): LatLng
    // Returns a `LatLng` where lat and lng has been wrapped according to the
    // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
    wrapLatLng: function(latlng) {
      var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
      return new LatLng(lat, lng, alt);
    },
    // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
    // Returns a `LatLngBounds` with the same size as the given one, ensuring
    // that its center is within the CRS's bounds.
    // Only accepts actual `L.LatLngBounds` instances, not arrays.
    wrapLatLngBounds: function(bounds) {
      var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
      if (latShift === 0 && lngShift === 0) {
        return bounds;
      }
      var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
      return new LatLngBounds(newSw, newNe);
    }
  };
  var Earth = extend({}, CRS, {
    wrapLng: [-180, 180],
    // Mean Earth Radius, as recommended for use by
    // the International Union of Geodesy and Geophysics,
    // see https://rosettacode.org/wiki/Haversine_formula
    R: 6371e3,
    // distance between two geographical points using spherical law of cosines approximation
    distance: function(latlng1, latlng2) {
      var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return this.R * c;
    }
  });
  var earthRadius = 6378137;
  var SphericalMercator = {
    R: earthRadius,
    MAX_LATITUDE: 85.0511287798,
    project: function(latlng) {
      var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
      return new Point(
        this.R * latlng.lng * d,
        this.R * Math.log((1 + sin) / (1 - sin)) / 2
      );
    },
    unproject: function(point) {
      var d = 180 / Math.PI;
      return new LatLng(
        (2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d,
        point.x * d / this.R
      );
    },
    bounds: (function() {
      var d = earthRadius * Math.PI;
      return new Bounds([-d, -d], [d, d]);
    })()
  };
  function Transformation(a, b, c, d) {
    if (isArray(a)) {
      this._a = a[0];
      this._b = a[1];
      this._c = a[2];
      this._d = a[3];
      return;
    }
    this._a = a;
    this._b = b;
    this._c = c;
    this._d = d;
  }
  Transformation.prototype = {
    // @method transform(point: Point, scale?: Number): Point
    // Returns a transformed point, optionally multiplied by the given scale.
    // Only accepts actual `L.Point` instances, not arrays.
    transform: function(point, scale2) {
      return this._transform(point.clone(), scale2);
    },
    // destructive transform (faster)
    _transform: function(point, scale2) {
      scale2 = scale2 || 1;
      point.x = scale2 * (this._a * point.x + this._b);
      point.y = scale2 * (this._c * point.y + this._d);
      return point;
    },
    // @method untransform(point: Point, scale?: Number): Point
    // Returns the reverse transformation of the given point, optionally divided
    // by the given scale. Only accepts actual `L.Point` instances, not arrays.
    untransform: function(point, scale2) {
      scale2 = scale2 || 1;
      return new Point(
        (point.x / scale2 - this._b) / this._a,
        (point.y / scale2 - this._d) / this._c
      );
    }
  };
  function toTransformation(a, b, c, d) {
    return new Transformation(a, b, c, d);
  }
  var EPSG3857 = extend({}, Earth, {
    code: "EPSG:3857",
    projection: SphericalMercator,
    transformation: (function() {
      var scale2 = 0.5 / (Math.PI * SphericalMercator.R);
      return toTransformation(scale2, 0.5, -scale2, 0.5);
    })()
  });
  var EPSG900913 = extend({}, EPSG3857, {
    code: "EPSG:900913"
  });
  function svgCreate(name) {
    return document.createElementNS("http://www.w3.org/2000/svg", name);
  }
  function pointsToPath(rings, closed) {
    var str = "", i, j, len, len2, points, p;
    for (i = 0, len = rings.length; i < len; i++) {
      points = rings[i];
      for (j = 0, len2 = points.length; j < len2; j++) {
        p = points[j];
        str += (j ? "L" : "M") + p.x + " " + p.y;
      }
      str += closed ? Browser.svg ? "z" : "x" : "";
    }
    return str || "M0 0";
  }
  var style = document.documentElement.style;
  var ie = "ActiveXObject" in window;
  var ielt9 = ie && !document.addEventListener;
  var edge = "msLaunchUri" in navigator && !("documentMode" in document);
  var webkit = userAgentContains("webkit");
  var android = userAgentContains("android");
  var android23 = userAgentContains("android 2") || userAgentContains("android 3");
  var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10);
  var androidStock = android && userAgentContains("Google") && webkitVer < 537 && !("AudioNode" in window);
  var opera = !!window.opera;
  var chrome = !edge && userAgentContains("chrome");
  var gecko = userAgentContains("gecko") && !webkit && !opera && !ie;
  var safari = !chrome && userAgentContains("safari");
  var phantom = userAgentContains("phantom");
  var opera12 = "OTransition" in style;
  var win = navigator.platform.indexOf("Win") === 0;
  var ie3d = ie && "transition" in style;
  var webkit3d = "WebKitCSSMatrix" in window && "m11" in new window.WebKitCSSMatrix() && !android23;
  var gecko3d = "MozPerspective" in style;
  var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
  var mobile = typeof orientation !== "undefined" || userAgentContains("mobile");
  var mobileWebkit = mobile && webkit;
  var mobileWebkit3d = mobile && webkit3d;
  var msPointer = !window.PointerEvent && window.MSPointerEvent;
  var pointer = !!(window.PointerEvent || msPointer);
  var touchNative = "ontouchstart" in window || !!window.TouchEvent;
  var touch = !window.L_NO_TOUCH && (touchNative || pointer);
  var mobileOpera = mobile && opera;
  var mobileGecko = mobile && gecko;
  var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
  var passiveEvents = (function() {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, "passive", {
        get: function() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener("testPassiveEventSupport", falseFn, opts);
      window.removeEventListener("testPassiveEventSupport", falseFn, opts);
    } catch (e) {
    }
    return supportsPassiveOption;
  })();
  var canvas$1 = (function() {
    return !!document.createElement("canvas").getContext;
  })();
  var svg$1 = !!(document.createElementNS && svgCreate("svg").createSVGRect);
  var inlineSvg = !!svg$1 && (function() {
    var div = document.createElement("div");
    div.innerHTML = "<svg/>";
    return (div.firstChild && div.firstChild.namespaceURI) === "http://www.w3.org/2000/svg";
  })();
  var vml = !svg$1 && (function() {
    try {
      var div = document.createElement("div");
      div.innerHTML = '<v:shape adj="1"/>';
      var shape = div.firstChild;
      shape.style.behavior = "url(#default#VML)";
      return shape && typeof shape.adj === "object";
    } catch (e) {
      return false;
    }
  })();
  var mac = navigator.platform.indexOf("Mac") === 0;
  var linux = navigator.platform.indexOf("Linux") === 0;
  function userAgentContains(str) {
    return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
  }
  var Browser = {
    ie,
    ielt9,
    edge,
    webkit,
    android,
    android23,
    androidStock,
    opera,
    chrome,
    gecko,
    safari,
    phantom,
    opera12,
    win,
    ie3d,
    webkit3d,
    gecko3d,
    any3d,
    mobile,
    mobileWebkit,
    mobileWebkit3d,
    msPointer,
    pointer,
    touch,
    touchNative,
    mobileOpera,
    mobileGecko,
    retina,
    passiveEvents,
    canvas: canvas$1,
    svg: svg$1,
    vml,
    inlineSvg,
    mac,
    linux
  };
  var POINTER_DOWN = Browser.msPointer ? "MSPointerDown" : "pointerdown";
  var POINTER_MOVE = Browser.msPointer ? "MSPointerMove" : "pointermove";
  var POINTER_UP = Browser.msPointer ? "MSPointerUp" : "pointerup";
  var POINTER_CANCEL = Browser.msPointer ? "MSPointerCancel" : "pointercancel";
  var pEvent = {
    touchstart: POINTER_DOWN,
    touchmove: POINTER_MOVE,
    touchend: POINTER_UP,
    touchcancel: POINTER_CANCEL
  };
  var handle = {
    touchstart: _onPointerStart,
    touchmove: _handlePointer,
    touchend: _handlePointer,
    touchcancel: _handlePointer
  };
  var _pointers = {};
  var _pointerDocListener = false;
  function addPointerListener(obj, type, handler) {
    if (type === "touchstart") {
      _addPointerDocListener();
    }
    if (!handle[type]) {
      console.warn("wrong event specified:", type);
      return falseFn;
    }
    handler = handle[type].bind(this, handler);
    obj.addEventListener(pEvent[type], handler, false);
    return handler;
  }
  function removePointerListener(obj, type, handler) {
    if (!pEvent[type]) {
      console.warn("wrong event specified:", type);
      return;
    }
    obj.removeEventListener(pEvent[type], handler, false);
  }
  function _globalPointerDown(e) {
    _pointers[e.pointerId] = e;
  }
  function _globalPointerMove(e) {
    if (_pointers[e.pointerId]) {
      _pointers[e.pointerId] = e;
    }
  }
  function _globalPointerUp(e) {
    delete _pointers[e.pointerId];
  }
  function _addPointerDocListener() {
    if (!_pointerDocListener) {
      document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
      document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
      document.addEventListener(POINTER_UP, _globalPointerUp, true);
      document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
      _pointerDocListener = true;
    }
  }
  function _handlePointer(handler, e) {
    if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || "mouse")) {
      return;
    }
    e.touches = [];
    for (var i in _pointers) {
      e.touches.push(_pointers[i]);
    }
    e.changedTouches = [e];
    handler(e);
  }
  function _onPointerStart(handler, e) {
    if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) {
      preventDefault(e);
    }
    _handlePointer(handler, e);
  }
  function makeDblclick(event) {
    var newEvent = {}, prop, i;
    for (i in event) {
      prop = event[i];
      newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
    }
    event = newEvent;
    newEvent.type = "dblclick";
    newEvent.detail = 2;
    newEvent.isTrusted = false;
    newEvent._simulated = true;
    return newEvent;
  }
  var delay = 200;
  function addDoubleTapListener(obj, handler) {
    obj.addEventListener("dblclick", handler);
    var last = 0, detail;
    function simDblclick(e) {
      if (e.detail !== 1) {
        detail = e.detail;
        return;
      }
      if (e.pointerType === "mouse" || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) {
        return;
      }
      var path = getPropagationPath(e);
      if (path.some(function(el) {
        return el instanceof HTMLLabelElement && el.attributes.for;
      }) && !path.some(function(el) {
        return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
      })) {
        return;
      }
      var now = Date.now();
      if (now - last <= delay) {
        detail++;
        if (detail === 2) {
          handler(makeDblclick(e));
        }
      } else {
        detail = 1;
      }
      last = now;
    }
    obj.addEventListener("click", simDblclick);
    return {
      dblclick: handler,
      simDblclick
    };
  }
  function removeDoubleTapListener(obj, handlers) {
    obj.removeEventListener("dblclick", handlers.dblclick);
    obj.removeEventListener("click", handlers.simDblclick);
  }
  var TRANSFORM = testProp(
    ["transform", "webkitTransform", "OTransform", "MozTransform", "msTransform"]
  );
  var TRANSITION = testProp(
    ["webkitTransition", "transition", "OTransition", "MozTransition", "msTransition"]
  );
  var TRANSITION_END = TRANSITION === "webkitTransition" || TRANSITION === "OTransition" ? TRANSITION + "End" : "transitionend";
  function get(id) {
    return typeof id === "string" ? document.getElementById(id) : id;
  }
  function getStyle(el, style2) {
    var value = el.style[style2] || el.currentStyle && el.currentStyle[style2];
    if ((!value || value === "auto") && document.defaultView) {
      var css = document.defaultView.getComputedStyle(el, null);
      value = css ? css[style2] : null;
    }
    return value === "auto" ? null : value;
  }
  function create$1(tagName, className, container) {
    var el = document.createElement(tagName);
    el.className = className || "";
    if (container) {
      container.appendChild(el);
    }
    return el;
  }
  function remove(el) {
    var parent = el.parentNode;
    if (parent) {
      parent.removeChild(el);
    }
  }
  function empty(el) {
    while (el.firstChild) {
      el.removeChild(el.firstChild);
    }
  }
  function toFront(el) {
    var parent = el.parentNode;
    if (parent && parent.lastChild !== el) {
      parent.appendChild(el);
    }
  }
  function toBack(el) {
    var parent = el.parentNode;
    if (parent && parent.firstChild !== el) {
      parent.insertBefore(el, parent.firstChild);
    }
  }
  function hasClass(el, name) {
    if (el.classList !== void 0) {
      return el.classList.contains(name);
    }
    var className = getClass(el);
    return className.length > 0 && new RegExp("(^|\\s)" + name + "(\\s|$)").test(className);
  }
  function addClass(el, name) {
    if (el.classList !== void 0) {
      var classes = splitWords(name);
      for (var i = 0, len = classes.length; i < len; i++) {
        el.classList.add(classes[i]);
      }
    } else if (!hasClass(el, name)) {
      var className = getClass(el);
      setClass(el, (className ? className + " " : "") + name);
    }
  }
  function removeClass(el, name) {
    if (el.classList !== void 0) {
      el.classList.remove(name);
    } else {
      setClass(el, trim((" " + getClass(el) + " ").replace(" " + name + " ", " ")));
    }
  }
  function setClass(el, name) {
    if (el.className.baseVal === void 0) {
      el.className = name;
    } else {
      el.className.baseVal = name;
    }
  }
  function getClass(el) {
    if (el.correspondingElement) {
      el = el.correspondingElement;
    }
    return el.className.baseVal === void 0 ? el.className : el.className.baseVal;
  }
  function setOpacity(el, value) {
    if ("opacity" in el.style) {
      el.style.opacity = value;
    } else if ("filter" in el.style) {
      _setOpacityIE(el, value);
    }
  }
  function _setOpacityIE(el, value) {
    var filter = false, filterName = "DXImageTransform.Microsoft.Alpha";
    try {
      filter = el.filters.item(filterName);
    } catch (e) {
      if (value === 1) {
        return;
      }
    }
    value = Math.round(value * 100);
    if (filter) {
      filter.Enabled = value !== 100;
      filter.Opacity = value;
    } else {
      el.style.filter += " progid:" + filterName + "(opacity=" + value + ")";
    }
  }
  function testProp(props) {
    var style2 = document.documentElement.style;
    for (var i = 0; i < props.length; i++) {
      if (props[i] in style2) {
        return props[i];
      }
    }
    return false;
  }
  function setTransform(el, offset, scale2) {
    var pos = offset || new Point(0, 0);
    el.style[TRANSFORM] = (Browser.ie3d ? "translate(" + pos.x + "px," + pos.y + "px)" : "translate3d(" + pos.x + "px," + pos.y + "px,0)") + (scale2 ? " scale(" + scale2 + ")" : "");
  }
  function setPosition(el, point) {
    el._L2DV_pos = point;
    if (Browser.any3d) {
      setTransform(el, point);
    } else {
      el.style.left = point.x + "px";
      el.style.top = point.y + "px";
    }
  }
  function getPosition(el) {
    return el._L2DV_pos || new Point(0, 0);
  }
  var disableTextSelection;
  var enableTextSelection;
  var _userSelect;
  if ("onselectstart" in document) {
    disableTextSelection = function() {
      on(window, "selectstart", preventDefault);
    };
    enableTextSelection = function() {
      off(window, "selectstart", preventDefault);
    };
  } else {
    var userSelectProperty = testProp(
      ["userSelect", "WebkitUserSelect", "OUserSelect", "MozUserSelect", "msUserSelect"]
    );
    disableTextSelection = function() {
      if (userSelectProperty) {
        var style2 = document.documentElement.style;
        _userSelect = style2[userSelectProperty];
        style2[userSelectProperty] = "none";
      }
    };
    enableTextSelection = function() {
      if (userSelectProperty) {
        document.documentElement.style[userSelectProperty] = _userSelect;
        _userSelect = void 0;
      }
    };
  }
  function disableImageDrag() {
    on(window, "dragstart", preventDefault);
  }
  function enableImageDrag() {
    off(window, "dragstart", preventDefault);
  }
  var _outlineElement, _outlineStyle;
  function preventOutline(element) {
    while (element.tabIndex === -1) {
      element = element.parentNode;
    }
    if (!element.style) {
      return;
    }
    restoreOutline();
    _outlineElement = element;
    _outlineStyle = element.style.outlineStyle;
    element.style.outlineStyle = "none";
    on(window, "keydown", restoreOutline);
  }
  function restoreOutline() {
    if (!_outlineElement) {
      return;
    }
    _outlineElement.style.outlineStyle = _outlineStyle;
    _outlineElement = void 0;
    _outlineStyle = void 0;
    off(window, "keydown", restoreOutline);
  }
  function getSizedParentNode(element) {
    do {
      element = element.parentNode;
    } while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
    return element;
  }
  function getScale(element) {
    var rect = element.getBoundingClientRect();
    return {
      x: rect.width / element.offsetWidth || 1,
      y: rect.height / element.offsetHeight || 1,
      boundingClientRect: rect
    };
  }
  var DomUtil = {
    __proto__: null,
    TRANSFORM,
    TRANSITION,
    TRANSITION_END,
    get,
    getStyle,
    create: create$1,
    remove,
    empty,
    toFront,
    toBack,
    hasClass,
    addClass,
    removeClass,
    setClass,
    getClass,
    setOpacity,
    testProp,
    setTransform,
    setPosition,
    getPosition,
    get disableTextSelection() {
      return disableTextSelection;
    },
    get enableTextSelection() {
      return enableTextSelection;
    },
    disableImageDrag,
    enableImageDrag,
    preventOutline,
    restoreOutline,
    getSizedParentNode,
    getScale
  };
  function on(obj, types, fn, context) {
    if (types && typeof types === "object") {
      for (var type in types) {
        addOne(obj, type, types[type], fn);
      }
    } else {
      types = splitWords(types);
      for (var i = 0, len = types.length; i < len; i++) {
        addOne(obj, types[i], fn, context);
      }
    }
    return this;
  }
  var eventsKey = "_L2DV_events";
  function off(obj, types, fn, context) {
    if (arguments.length === 1) {
      batchRemove(obj);
      delete obj[eventsKey];
    } else if (types && typeof types === "object") {
      for (var type in types) {
        removeOne(obj, type, types[type], fn);
      }
    } else {
      types = splitWords(types);
      if (arguments.length === 2) {
        batchRemove(obj, function(type2) {
          return indexOf(types, type2) !== -1;
        });
      } else {
        for (var i = 0, len = types.length; i < len; i++) {
          removeOne(obj, types[i], fn, context);
        }
      }
    }
    return this;
  }
  function batchRemove(obj, filterFn) {
    for (var id in obj[eventsKey]) {
      var type = id.split(/\d/)[0];
      if (!filterFn || filterFn(type)) {
        removeOne(obj, type, null, null, id);
      }
    }
  }
  var mouseSubst = {
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    wheel: !("onwheel" in window) && "mousewheel"
  };
  function addOne(obj, type, fn, context) {
    var id = type + stamp(fn) + (context ? "_" + stamp(context) : "");
    if (obj[eventsKey] && obj[eventsKey][id]) {
      return this;
    }
    var handler = function(e) {
      return fn.call(context || obj, e || window.event);
    };
    var originalHandler = handler;
    if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) {
      handler = addPointerListener(obj, type, handler);
    } else if (Browser.touch && type === "dblclick") {
      handler = addDoubleTapListener(obj, handler);
    } else if ("addEventListener" in obj) {
      if (type === "touchstart" || type === "touchmove" || type === "wheel" || type === "mousewheel") {
        obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? { passive: false } : false);
      } else if (type === "mouseenter" || type === "mouseleave") {
        handler = function(e) {
          e = e || window.event;
          if (isExternalTarget(obj, e)) {
            originalHandler(e);
          }
        };
        obj.addEventListener(mouseSubst[type], handler, false);
      } else {
        obj.addEventListener(type, originalHandler, false);
      }
    } else {
      obj.attachEvent("on" + type, handler);
    }
    obj[eventsKey] = obj[eventsKey] || {};
    obj[eventsKey][id] = handler;
  }
  function removeOne(obj, type, fn, context, id) {
    id = id || type + stamp(fn) + (context ? "_" + stamp(context) : "");
    var handler = obj[eventsKey] && obj[eventsKey][id];
    if (!handler) {
      return this;
    }
    if (!Browser.touchNative && Browser.pointer && type.indexOf("touch") === 0) {
      removePointerListener(obj, type, handler);
    } else if (Browser.touch && type === "dblclick") {
      removeDoubleTapListener(obj, handler);
    } else if ("removeEventListener" in obj) {
      obj.removeEventListener(mouseSubst[type] || type, handler, false);
    } else {
      obj.detachEvent("on" + type, handler);
    }
    obj[eventsKey][id] = null;
  }
  function stopPropagation(e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    } else if (e.originalEvent) {
      e.originalEvent._stopped = true;
    } else {
      e.cancelBubble = true;
    }
    return this;
  }
  function disableScrollPropagation(el) {
    addOne(el, "wheel", stopPropagation);
    return this;
  }
  function disableClickPropagation(el) {
    on(el, "mousedown touchstart dblclick contextmenu", stopPropagation);
    el["_L2DV_disable_click"] = true;
    return this;
  }
  function preventDefault(e) {
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      e.returnValue = false;
    }
    return this;
  }
  function stop(e) {
    preventDefault(e);
    stopPropagation(e);
    return this;
  }
  function getPropagationPath(ev) {
    if (ev.composedPath) {
      return ev.composedPath();
    }
    var path = [];
    var el = ev.target;
    while (el) {
      path.push(el);
      el = el.parentNode;
    }
    return path;
  }
  function getMousePosition(e, container) {
    if (!container) {
      return new Point(e.clientX, e.clientY);
    }
    var scale2 = getScale(container), offset = scale2.boundingClientRect;
    return new Point(
      // offset.left/top values are in page scale (like clientX/Y),
      // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
      (e.clientX - offset.left) / scale2.x - container.clientLeft,
      (e.clientY - offset.top) / scale2.y - container.clientTop
    );
  }
  var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
  function getWheelDelta(e) {
    return Browser.edge ? e.wheelDeltaY / 2 : (
      // Don't trust window-geometry-based delta
      e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : (
        // Pixels
        e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : (
          // Lines
          e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : (
            // Pages
            e.deltaX || e.deltaZ ? 0 : (
              // Skip horizontal/depth wheel events
              e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : (
                // Legacy IE pixels
                e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : (
                  // Legacy Moz lines
                  e.detail ? e.detail / -32765 * 60 : (
                    // Legacy Moz pages
                    0
                  )
                )
              )
            )
          )
        )
      )
    );
  }
  function isExternalTarget(el, e) {
    var related = e.relatedTarget;
    if (!related) {
      return true;
    }
    try {
      while (related && related !== el) {
        related = related.parentNode;
      }
    } catch (err) {
      return false;
    }
    return related !== el;
  }
  var DomEvent = {
    __proto__: null,
    on,
    off,
    stopPropagation,
    disableScrollPropagation,
    disableClickPropagation,
    preventDefault,
    stop,
    getPropagationPath,
    getMousePosition,
    getWheelDelta,
    isExternalTarget,
    addListener: on,
    removeListener: off
  };
  var PosAnimation = Evented.extend({
    // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
    // Run an animation of a given element to a new position, optionally setting
    // duration in seconds (`0.25` by default) and easing linearity factor (3rd
    // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
    // `0.5` by default).
    run: function(el, newPos, duration, easeLinearity) {
      this.stop();
      this._el = el;
      this._inProgress = true;
      this._duration = duration || 0.25;
      this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
      this._startPos = getPosition(el);
      this._offset = newPos.subtract(this._startPos);
      this._startTime = +/* @__PURE__ */ new Date();
      this.fire("start");
      this._animate();
    },
    // @method stop()
    // Stops the animation (if currently running).
    stop: function() {
      if (!this._inProgress) {
        return;
      }
      this._step(true);
      this._complete();
    },
    _animate: function() {
      this._animId = requestAnimFrame(this._animate, this);
      this._step();
    },
    _step: function(round) {
      var elapsed = +/* @__PURE__ */ new Date() - this._startTime, duration = this._duration * 1e3;
      if (elapsed < duration) {
        this._runFrame(this._easeOut(elapsed / duration), round);
      } else {
        this._runFrame(1);
        this._complete();
      }
    },
    _runFrame: function(progress, round) {
      var pos = this._startPos.add(this._offset.multiplyBy(progress));
      if (round) {
        pos._round();
      }
      setPosition(this._el, pos);
      this.fire("step");
    },
    _complete: function() {
      cancelAnimFrame(this._animId);
      this._inProgress = false;
      this.fire("end");
    },
    _easeOut: function(t) {
      return 1 - Math.pow(1 - t, this._easeOutPower);
    }
  });
  var Map = Evented.extend({
    options: {
      // @section Map State Options
      // @option crs: CRS = L.CRS.EPSG3857
      // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
      // sure what it means.
      crs: EPSG3857,
      // @option center: LatLng = undefined
      // Initial geographic center of the map
      center: void 0,
      // @option zoom: Number = undefined
      // Initial map zoom level
      zoom: void 0,
      // @option minZoom: Number = *
      // Minimum zoom level of the map.
      // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
      // the lowest of their `minZoom` options will be used instead.
      minZoom: void 0,
      // @option maxZoom: Number = *
      // Maximum zoom level of the map.
      // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
      // the highest of their `maxZoom` options will be used instead.
      maxZoom: void 0,
      // @option layers: Layer[] = []
      // Array of layers that will be added to the map initially
      layers: [],
      // @option maxBounds: LatLngBounds = null
      // When this option is set, the map restricts the view to the given
      // geographical bounds, bouncing the user back if the user tries to pan
      // outside the view. To set the restriction dynamically, use
      // [`setMaxBounds`](#map-setmaxbounds) method.
      maxBounds: void 0,
      // @option renderer: Renderer = *
      // The default method for drawing vector layers on the map. `L.SVG`
      // or `L.Canvas` by default depending on browser support.
      renderer: void 0,
      // @section Animation Options
      // @option zoomAnimation: Boolean = true
      // Whether the map zoom animation is enabled. By default it's enabled
      // in all browsers that support CSS3 Transitions except Android.
      zoomAnimation: true,
      // @option zoomAnimationThreshold: Number = 4
      // Won't animate zoom if the zoom difference exceeds this value.
      zoomAnimationThreshold: 4,
      // @option fadeAnimation: Boolean = true
      // Whether the tile fade animation is enabled. By default it's enabled
      // in all browsers that support CSS3 Transitions except Android.
      fadeAnimation: true,
      // @option markerZoomAnimation: Boolean = true
      // Whether markers animate their zoom with the zoom animation, if disabled
      // they will disappear for the length of the animation. By default it's
      // enabled in all browsers that support CSS3 Transitions except Android.
      markerZoomAnimation: true,
      // @option transform3DLimit: Number = 2^23
      // Defines the maximum size of a CSS translation transform. The default
      // value should not be changed unless a web browser positions layers in
      // the wrong place after doing a large `panBy`.
      transform3DLimit: 8388608,
      // Precision limit of a 32-bit float
      // @section Interaction Options
      // @option zoomSnap: Number = 1
      // Forces the map's zoom level to always be a multiple of this, particularly
      // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
      // By default, the zoom level snaps to the nearest integer; lower values
      // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
      // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
      zoomSnap: 1,
      // @option zoomDelta: Number = 1
      // Controls how much the map's zoom level will change after a
      // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
      // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
      // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
      zoomDelta: 1,
      // @option trackResize: Boolean = true
      // Whether the map automatically handles browser window resize to update itself.
      trackResize: true
    },
    initialize: function(id, options) {
      options = setOptions(this, options);
      this._handlers = [];
      this._layers = {};
      this._zoomBoundLayers = {};
      this._sizeChanged = true;
      this._initContainer(id);
      this._initLayout();
      this._onResize = bind(this._onResize, this);
      this._initEvents();
      if (options.maxBounds) {
        this.setMaxBounds(options.maxBounds);
      }
      if (options.zoom !== void 0) {
        this._zoom = this._limitZoom(options.zoom);
      }
      if (options.center && options.zoom !== void 0) {
        this.setView(toLatLng(options.center), options.zoom, { reset: true });
      }
      this.callInitHooks();
      this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
      if (this._zoomAnimated) {
        this._createAnimProxy();
        on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
      }
      this._addLayers(this.options.layers);
    },
    // @section Methods for modifying map state
    // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
    // Sets the view of the map (geographical center and zoom) with the given
    // animation options.
    setView: function(center, zoom2, options) {
      zoom2 = zoom2 === void 0 ? this._zoom : this._limitZoom(zoom2);
      center = this._limitCenter(toLatLng(center), zoom2, this.options.maxBounds);
      options = options || {};
      this._stop();
      if (this._loaded && !options.reset && options !== true) {
        if (options.animate !== void 0) {
          options.zoom = extend({ animate: options.animate }, options.zoom);
          options.pan = extend({ animate: options.animate, duration: options.duration }, options.pan);
        }
        var moved = this._zoom !== zoom2 ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom2, options.zoom) : this._tryAnimatedPan(center, options.pan);
        if (moved) {
          clearTimeout(this._sizeTimer);
          return this;
        }
      }
      this._resetView(center, zoom2, options.pan && options.pan.noMoveStart);
      return this;
    },
    // @method setZoom(zoom: Number, options?: Zoom/pan options): this
    // Sets the zoom of the map.
    setZoom: function(zoom2, options) {
      if (!this._loaded) {
        this._zoom = zoom2;
        return this;
      }
      return this.setView(this.getCenter(), zoom2, { zoom: options });
    },
    // @method zoomIn(delta?: Number, options?: Zoom options): this
    // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
    zoomIn: function(delta, options) {
      delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
      return this.setZoom(this._zoom + delta, options);
    },
    // @method zoomOut(delta?: Number, options?: Zoom options): this
    // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
    zoomOut: function(delta, options) {
      delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
      return this.setZoom(this._zoom - delta, options);
    },
    // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
    // Zooms the map while keeping a specified geographical point on the map
    // stationary (e.g. used internally for scroll zoom and double-click zoom).
    // @alternative
    // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
    // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
    setZoomAround: function(latlng, zoom2, options) {
      var scale2 = this.getZoomScale(zoom2), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale2), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
      return this.setView(newCenter, zoom2, { zoom: options });
    },
    _getBoundsCenterZoom: function(bounds, options) {
      options = options || {};
      bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
      var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]), zoom2 = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
      zoom2 = typeof options.maxZoom === "number" ? Math.min(options.maxZoom, zoom2) : zoom2;
      if (zoom2 === Infinity) {
        return {
          center: bounds.getCenter(),
          zoom: zoom2
        };
      }
      var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom2), nePoint = this.project(bounds.getNorthEast(), zoom2), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom2);
      return {
        center,
        zoom: zoom2
      };
    },
    // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
    // Sets a map view that contains the given geographical bounds with the
    // maximum zoom level possible.
    fitBounds: function(bounds, options) {
      bounds = toLatLngBounds(bounds);
      if (!bounds.isValid()) {
        throw new Error("Bounds are not valid.");
      }
      var target = this._getBoundsCenterZoom(bounds, options);
      return this.setView(target.center, target.zoom, options);
    },
    // @method fitWorld(options?: fitBounds options): this
    // Sets a map view that mostly contains the whole world with the maximum
    // zoom level possible.
    fitWorld: function(options) {
      return this.fitBounds([[-90, -180], [90, 180]], options);
    },
    // @method panTo(latlng: LatLng, options?: Pan options): this
    // Pans the map to a given center.
    panTo: function(center, options) {
      return this.setView(center, this._zoom, { pan: options });
    },
    // @method panBy(offset: Point, options?: Pan options): this
    // Pans the map by a given number of pixels (animated).
    panBy: function(offset, options) {
      offset = toPoint(offset).round();
      options = options || {};
      if (!offset.x && !offset.y) {
        return this.fire("moveend");
      }
      if (options.animate !== true && !this.getSize().contains(offset)) {
        this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
        return this;
      }
      if (!this._panAnim) {
        this._panAnim = new PosAnimation();
        this._panAnim.on({
          "step": this._onPanTransitionStep,
          "end": this._onPanTransitionEnd
        }, this);
      }
      if (!options.noMoveStart) {
        this.fire("movestart");
      }
      if (options.animate !== false) {
        addClass(this._mapPane, "L2DV-pan-anim");
        var newPos = this._getMapPanePos().subtract(offset).round();
        this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
      } else {
        this._rawPanBy(offset);
        this.fire("move").fire("moveend");
      }
      return this;
    },
    // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
    // Sets the view of the map (geographical center and zoom) performing a smooth
    // pan-zoom animation.
    flyTo: function(targetCenter, targetZoom, options) {
      options = options || {};
      if (options.animate === false || !Browser.any3d) {
        return this.setView(targetCenter, targetZoom, options);
      }
      this._stop();
      var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
      targetCenter = toLatLng(targetCenter);
      targetZoom = targetZoom === void 0 ? startZoom : targetZoom;
      var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
      function r(i) {
        var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
        var log = sq < 1e-9 ? -18 : Math.log(sq);
        return log;
      }
      function sinh(n) {
        return (Math.exp(n) - Math.exp(-n)) / 2;
      }
      function cosh(n) {
        return (Math.exp(n) + Math.exp(-n)) / 2;
      }
      function tanh(n) {
        return sinh(n) / cosh(n);
      }
      var r0 = r(0);
      function w(s) {
        return w0 * (cosh(r0) / cosh(r0 + rho * s));
      }
      function u(s) {
        return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
      }
      function easeOut(t) {
        return 1 - Math.pow(1 - t, 1.5);
      }
      var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1e3 * options.duration : 1e3 * S * 0.8;
      function frame() {
        var t = (Date.now() - start) / duration, s = easeOut(t) * S;
        if (t <= 1) {
          this._flyToFrame = requestAnimFrame(frame, this);
          this._move(
            this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom),
            this.getScaleZoom(w0 / w(s), startZoom),
            { flyTo: true }
          );
        } else {
          this._move(targetCenter, targetZoom)._moveEnd(true);
        }
      }
      this._moveStart(true, options.noMoveStart);
      frame.call(this);
      return this;
    },
    // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
    // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
    // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
    flyToBounds: function(bounds, options) {
      var target = this._getBoundsCenterZoom(bounds, options);
      return this.flyTo(target.center, target.zoom, options);
    },
    // @method setMaxBounds(bounds: LatLngBounds): this
    // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
    setMaxBounds: function(bounds) {
      bounds = toLatLngBounds(bounds);
      if (this.listens("moveend", this._panInsideMaxBounds)) {
        this.off("moveend", this._panInsideMaxBounds);
      }
      if (!bounds.isValid()) {
        this.options.maxBounds = null;
        return this;
      }
      this.options.maxBounds = bounds;
      if (this._loaded) {
        this._panInsideMaxBounds();
      }
      return this.on("moveend", this._panInsideMaxBounds);
    },
    // @method setMinZoom(zoom: Number): this
    // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
    setMinZoom: function(zoom2) {
      var oldZoom = this.options.minZoom;
      this.options.minZoom = zoom2;
      if (this._loaded && oldZoom !== zoom2) {
        this.fire("zoomlevelschange");
        if (this.getZoom() < this.options.minZoom) {
          return this.setZoom(zoom2);
        }
      }
      return this;
    },
    // @method setMaxZoom(zoom: Number): this
    // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
    setMaxZoom: function(zoom2) {
      var oldZoom = this.options.maxZoom;
      this.options.maxZoom = zoom2;
      if (this._loaded && oldZoom !== zoom2) {
        this.fire("zoomlevelschange");
        if (this.getZoom() > this.options.maxZoom) {
          return this.setZoom(zoom2);
        }
      }
      return this;
    },
    // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
    // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
    panInsideBounds: function(bounds, options) {
      this._enforcingBounds = true;
      var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
      if (!center.equals(newCenter)) {
        this.panTo(newCenter, options);
      }
      this._enforcingBounds = false;
      return this;
    },
    // @method panInside(latlng: LatLng, options?: padding options): this
    // Pans the map the minimum amount to make the `latlng` visible. Use
    // padding options to fit the display to more restricted bounds.
    // If `latlng` is already within the (optionally padded) display bounds,
    // the map will not be panned.
    panInside: function(latlng, options) {
      options = options || {};
      var paddingTL = toPoint(options.paddingTopLeft || options.padding || [0, 0]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [0, 0]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([pixelBounds.min.add(paddingTL), pixelBounds.max.subtract(paddingBR)]), paddedSize = paddedBounds.getSize();
      if (!paddedBounds.contains(pixelPoint)) {
        this._enforcingBounds = true;
        var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
        var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
        pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
        pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
        this.panTo(this.unproject(pixelCenter), options);
        this._enforcingBounds = false;
      }
      return this;
    },
    // @method invalidateSize(options: Zoom/pan options): this
    // Checks if the map container size changed and updates the map if so —
    // call it after you've changed the map size dynamically, also animating
    // pan by default. If `options.pan` is `false`, panning will not occur.
    // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
    // that it doesn't happen often even if the method is called many
    // times in a row.
    // @alternative
    // @method invalidateSize(animate: Boolean): this
    // Checks if the map container size changed and updates the map if so —
    // call it after you've changed the map size dynamically, also animating
    // pan by default.
    invalidateSize: function(options) {
      if (!this._loaded) {
        return this;
      }
      options = extend({
        animate: false,
        pan: true
      }, options === true ? { animate: true } : options);
      var oldSize = this.getSize();
      this._sizeChanged = true;
      this._lastCenter = null;
      var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
      if (!offset.x && !offset.y) {
        return this;
      }
      if (options.animate && options.pan) {
        this.panBy(offset);
      } else {
        if (options.pan) {
          this._rawPanBy(offset);
        }
        this.fire("move");
        if (options.debounceMoveend) {
          clearTimeout(this._sizeTimer);
          this._sizeTimer = setTimeout(bind(this.fire, this, "moveend"), 200);
        } else {
          this.fire("moveend");
        }
      }
      return this.fire("resize", {
        oldSize,
        newSize
      });
    },
    // @section Methods for modifying map state
    // @method stop(): this
    // Stops the currently running `panTo` or `flyTo` animation, if any.
    stop: function() {
      this.setZoom(this._limitZoom(this._zoom));
      if (!this.options.zoomSnap) {
        this.fire("viewreset");
      }
      return this._stop();
    },
    // @section Geolocation methods
    // @method locate(options?: Locate options): this
    // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
    // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
    // and optionally sets the map view to the user's location with respect to
    // detection accuracy (or to the world view if geolocation failed).
    // Note that, if your page doesn't use HTTPS, this method will fail in
    // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
    // See `Locate options` for more details.
    locate: function(options) {
      options = this._locateOptions = extend({
        timeout: 1e4,
        watch: false
        // setView: false
        // maxZoom: <Number>
        // maximumAge: 0
        // enableHighAccuracy: false
      }, options);
      if (!("geolocation" in navigator)) {
        this._handleGeolocationError({
          code: 0,
          message: "Geolocation not supported."
        });
        return this;
      }
      var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
      if (options.watch) {
        this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
      } else {
        navigator.geolocation.getCurrentPosition(onResponse, onError, options);
      }
      return this;
    },
    // @method stopLocate(): this
    // Stops watching location previously initiated by `map.locate({watch: true})`
    // and aborts resetting the map view if map.locate was called with
    // `{setView: true}`.
    stopLocate: function() {
      if (navigator.geolocation && navigator.geolocation.clearWatch) {
        navigator.geolocation.clearWatch(this._locationWatchId);
      }
      if (this._locateOptions) {
        this._locateOptions.setView = false;
      }
      return this;
    },
    _handleGeolocationError: function(error) {
      if (!this._container._L2DV_id) {
        return;
      }
      var c = error.code, message = error.message || (c === 1 ? "permission denied" : c === 2 ? "position unavailable" : "timeout");
      if (this._locateOptions.setView && !this._loaded) {
        this.fitWorld();
      }
      this.fire("locationerror", {
        code: c,
        message: "Geolocation error: " + message + "."
      });
    },
    _handleGeolocationResponse: function(pos) {
      if (!this._container._L2DV_id) {
        return;
      }
      var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
      if (options.setView) {
        var zoom2 = this.getBoundsZoom(bounds);
        this.setView(latlng, options.maxZoom ? Math.min(zoom2, options.maxZoom) : zoom2);
      }
      var data = {
        latlng,
        bounds,
        timestamp: pos.timestamp
      };
      for (var i in pos.coords) {
        if (typeof pos.coords[i] === "number") {
          data[i] = pos.coords[i];
        }
      }
      this.fire("locationfound", data);
    },
    // TODO Appropriate docs section?
    // @section Other Methods
    // @method addHandler(name: String, HandlerClass: Function): this
    // Adds a new `Handler` to the map, given its name and constructor function.
    addHandler: function(name, HandlerClass) {
      if (!HandlerClass) {
        return this;
      }
      var handler = this[name] = new HandlerClass(this);
      this._handlers.push(handler);
      if (this.options[name]) {
        handler.enable();
      }
      return this;
    },
    // @method remove(): this
    // Destroys the map and clears all related event listeners.
    remove: function() {
      this._initEvents(true);
      if (this.options.maxBounds) {
        this.off("moveend", this._panInsideMaxBounds);
      }
      if (this._containerId !== this._container._L2DV_id) {
        throw new Error("Map container is being reused by another instance");
      }
      try {
        delete this._container._L2DV_id;
        delete this._containerId;
      } catch (e) {
        this._container._L2DV_id = void 0;
        this._containerId = void 0;
      }
      if (this._locationWatchId !== void 0) {
        this.stopLocate();
      }
      this._stop();
      remove(this._mapPane);
      if (this._clearControlPos) {
        this._clearControlPos();
      }
      if (this._resizeRequest) {
        cancelAnimFrame(this._resizeRequest);
        this._resizeRequest = null;
      }
      this._clearHandlers();
      if (this._loaded) {
        this.fire("unload");
      }
      var i;
      for (i in this._layers) {
        this._layers[i].remove();
      }
      for (i in this._panes) {
        remove(this._panes[i]);
      }
      this._layers = [];
      this._panes = [];
      delete this._mapPane;
      delete this._renderer;
      return this;
    },
    // @section Other Methods
    // @method createPane(name: String, container?: HTMLElement): HTMLElement
    // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
    // then returns it. The pane is created as a child of `container`, or
    // as a child of the main map pane if not set.
    createPane: function(name, container) {
      var className = "L2DV-pane" + (name ? " L2DV-" + name.replace("Pane", "") + "-pane" : ""), pane = create$1("div", className, container || this._mapPane);
      if (name) {
        this._panes[name] = pane;
      }
      return pane;
    },
    // @section Methods for Getting Map State
    // @method getCenter(): LatLng
    // Returns the geographical center of the map view
    getCenter: function() {
      this._checkIfLoaded();
      if (this._lastCenter && !this._moved()) {
        return this._lastCenter.clone();
      }
      return this.layerPointToLatLng(this._getCenterLayerPoint());
    },
    // @method getZoom(): Number
    // Returns the current zoom level of the map view
    getZoom: function() {
      return this._zoom;
    },
    // @method getBounds(): LatLngBounds
    // Returns the geographical bounds visible in the current map view
    getBounds: function() {
      var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
      return new LatLngBounds(sw, ne);
    },
    // @method getMinZoom(): Number
    // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
    getMinZoom: function() {
      return this.options.minZoom === void 0 ? this._layersMinZoom || 0 : this.options.minZoom;
    },
    // @method getMaxZoom(): Number
    // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
    getMaxZoom: function() {
      return this.options.maxZoom === void 0 ? this._layersMaxZoom === void 0 ? Infinity : this._layersMaxZoom : this.options.maxZoom;
    },
    // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
    // Returns the maximum zoom level on which the given bounds fit to the map
    // view in its entirety. If `inside` (optional) is set to `true`, the method
    // instead returns the minimum zoom level on which the map view fits into
    // the given bounds in its entirety.
    getBoundsZoom: function(bounds, inside, padding) {
      bounds = toLatLngBounds(bounds);
      padding = toPoint(padding || [0, 0]);
      var zoom2 = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom2), this.project(nw, zoom2)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale2 = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
      zoom2 = this.getScaleZoom(scale2, zoom2);
      if (snap) {
        zoom2 = Math.round(zoom2 / (snap / 100)) * (snap / 100);
        zoom2 = inside ? Math.ceil(zoom2 / snap) * snap : Math.floor(zoom2 / snap) * snap;
      }
      return Math.max(min, Math.min(max, zoom2));
    },
    // @method getSize(): Point
    // Returns the current size of the map container (in pixels).
    getSize: function() {
      if (!this._size || this._sizeChanged) {
        this._size = new Point(
          this._container.clientWidth || 0,
          this._container.clientHeight || 0
        );
        this._sizeChanged = false;
      }
      return this._size.clone();
    },
    // @method getPixelBounds(): Bounds
    // Returns the bounds of the current map view in projected pixel
    // coordinates (sometimes useful in layer and overlay implementations).
    getPixelBounds: function(center, zoom2) {
      var topLeftPoint = this._getTopLeftPoint(center, zoom2);
      return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
    },
    // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
    // the map pane? "left point of the map layer" can be confusing, specially
    // since there can be negative offsets.
    // @method getPixelOrigin(): Point
    // Returns the projected pixel coordinates of the top left point of
    // the map layer (useful in custom layer and overlay implementations).
    getPixelOrigin: function() {
      this._checkIfLoaded();
      return this._pixelOrigin;
    },
    // @method getPixelWorldBounds(zoom?: Number): Bounds
    // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
    // If `zoom` is omitted, the map's current zoom level is used.
    getPixelWorldBounds: function(zoom2) {
      return this.options.crs.getProjectedBounds(zoom2 === void 0 ? this.getZoom() : zoom2);
    },
    // @section Other Methods
    // @method getPane(pane: String|HTMLElement): HTMLElement
    // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
    getPane: function(pane) {
      return typeof pane === "string" ? this._panes[pane] : pane;
    },
    // @method getPanes(): Object
    // Returns a plain object containing the names of all [panes](#map-pane) as keys and
    // the panes as values.
    getPanes: function() {
      return this._panes;
    },
    // @method getContainer: HTMLElement
    // Returns the HTML element that contains the map.
    getContainer: function() {
      return this._container;
    },
    // @section Conversion Methods
    // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
    // Returns the scale factor to be applied to a map transition from zoom level
    // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
    getZoomScale: function(toZoom, fromZoom) {
      var crs = this.options.crs;
      fromZoom = fromZoom === void 0 ? this._zoom : fromZoom;
      return crs.scale(toZoom) / crs.scale(fromZoom);
    },
    // @method getScaleZoom(scale: Number, fromZoom: Number): Number
    // Returns the zoom level that the map would end up at, if it is at `fromZoom`
    // level and everything is scaled by a factor of `scale`. Inverse of
    // [`getZoomScale`](#map-getZoomScale).
    getScaleZoom: function(scale2, fromZoom) {
      var crs = this.options.crs;
      fromZoom = fromZoom === void 0 ? this._zoom : fromZoom;
      var zoom2 = crs.zoom(scale2 * crs.scale(fromZoom));
      return isNaN(zoom2) ? Infinity : zoom2;
    },
    // @method project(latlng: LatLng, zoom: Number): Point
    // Projects a geographical coordinate `LatLng` according to the projection
    // of the map's CRS, then scales it according to `zoom` and the CRS's
    // `Transformation`. The result is pixel coordinate relative to
    // the CRS origin.
    project: function(latlng, zoom2) {
      zoom2 = zoom2 === void 0 ? this._zoom : zoom2;
      return this.options.crs.latLngToPoint(toLatLng(latlng), zoom2);
    },
    // @method unproject(point: Point, zoom: Number): LatLng
    // Inverse of [`project`](#map-project).
    unproject: function(point, zoom2) {
      zoom2 = zoom2 === void 0 ? this._zoom : zoom2;
      return this.options.crs.pointToLatLng(toPoint(point), zoom2);
    },
    // @method layerPointToLatLng(point: Point): LatLng
    // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
    // returns the corresponding geographical coordinate (for the current zoom level).
    layerPointToLatLng: function(point) {
      var projectedPoint = toPoint(point).add(this.getPixelOrigin());
      return this.unproject(projectedPoint);
    },
    // @method latLngToLayerPoint(latlng: LatLng): Point
    // Given a geographical coordinate, returns the corresponding pixel coordinate
    // relative to the [origin pixel](#map-getpixelorigin).
    latLngToLayerPoint: function(latlng) {
      var projectedPoint = this.project(toLatLng(latlng))._round();
      return projectedPoint._subtract(this.getPixelOrigin());
    },
    // @method wrapLatLng(latlng: LatLng): LatLng
    // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
    // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
    // CRS's bounds.
    // By default this means longitude is wrapped around the dateline so its
    // value is between -180 and +180 degrees.
    wrapLatLng: function(latlng) {
      return this.options.crs.wrapLatLng(toLatLng(latlng));
    },
    // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
    // Returns a `LatLngBounds` with the same size as the given one, ensuring that
    // its center is within the CRS's bounds.
    // By default this means the center longitude is wrapped around the dateline so its
    // value is between -180 and +180 degrees, and the majority of the bounds
    // overlaps the CRS's bounds.
    wrapLatLngBounds: function(latlng) {
      return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
    },
    // @method distance(latlng1: LatLng, latlng2: LatLng): Number
    // Returns the distance between two geographical coordinates according to
    // the map's CRS. By default this measures distance in meters.
    distance: function(latlng1, latlng2) {
      return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
    },
    // @method containerPointToLayerPoint(point: Point): Point
    // Given a pixel coordinate relative to the map container, returns the corresponding
    // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
    containerPointToLayerPoint: function(point) {
      return toPoint(point).subtract(this._getMapPanePos());
    },
    // @method layerPointToContainerPoint(point: Point): Point
    // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
    // returns the corresponding pixel coordinate relative to the map container.
    layerPointToContainerPoint: function(point) {
      return toPoint(point).add(this._getMapPanePos());
    },
    // @method containerPointToLatLng(point: Point): LatLng
    // Given a pixel coordinate relative to the map container, returns
    // the corresponding geographical coordinate (for the current zoom level).
    containerPointToLatLng: function(point) {
      var layerPoint = this.containerPointToLayerPoint(toPoint(point));
      return this.layerPointToLatLng(layerPoint);
    },
    // @method latLngToContainerPoint(latlng: LatLng): Point
    // Given a geographical coordinate, returns the corresponding pixel coordinate
    // relative to the map container.
    latLngToContainerPoint: function(latlng) {
      return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
    },
    // @method mouseEventToContainerPoint(ev: MouseEvent): Point
    // Given a MouseEvent object, returns the pixel coordinate relative to the
    // map container where the event took place.
    mouseEventToContainerPoint: function(e) {
      return getMousePosition(e, this._container);
    },
    // @method mouseEventToLayerPoint(ev: MouseEvent): Point
    // Given a MouseEvent object, returns the pixel coordinate relative to
    // the [origin pixel](#map-getpixelorigin) where the event took place.
    mouseEventToLayerPoint: function(e) {
      return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
    },
    // @method mouseEventToLatLng(ev: MouseEvent): LatLng
    // Given a MouseEvent object, returns geographical coordinate where the
    // event took place.
    mouseEventToLatLng: function(e) {
      return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
    },
    // map initialization methods
    _initContainer: function(id) {
      var container = this._container = get(id);
      if (!container) {
        throw new Error("Map container not found.");
      } else if (container._L2DV_id) {
        throw new Error("Map container is already initialized.");
      }
      on(container, "scroll", this._onScroll, this);
      this._containerId = stamp(container);
    },
    _initLayout: function() {
      var container = this._container;
      this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
      addClass(container, "L2DV-container" + (Browser.touch ? " L2DV-touch" : "") + (Browser.retina ? " L2DV-retina" : "") + (Browser.ielt9 ? " L2DV-oldie" : "") + (Browser.safari ? " L2DV-safari" : "") + (this._fadeAnimated ? " L2DV-fade-anim" : ""));
      var position = getStyle(container, "position");
      if (position !== "absolute" && position !== "relative" && position !== "fixed" && position !== "sticky") {
        container.style.position = "relative";
      }
      this._initPanes();
      if (this._initControlPos) {
        this._initControlPos();
      }
    },
    _initPanes: function() {
      var panes = this._panes = {};
      this._paneRenderers = {};
      this._mapPane = this.createPane("mapPane", this._container);
      setPosition(this._mapPane, new Point(0, 0));
      this.createPane("tilePane");
      this.createPane("overlayPane");
      this.createPane("shadowPane");
      this.createPane("markerPane");
      this.createPane("tooltipPane");
      this.createPane("popupPane");
      if (!this.options.markerZoomAnimation) {
        addClass(panes.markerPane, "L2DV-zoom-hide");
        addClass(panes.shadowPane, "L2DV-zoom-hide");
      }
    },
    // private methods that modify map state
    // @section Map state change events
    _resetView: function(center, zoom2, noMoveStart) {
      setPosition(this._mapPane, new Point(0, 0));
      var loading = !this._loaded;
      this._loaded = true;
      zoom2 = this._limitZoom(zoom2);
      this.fire("viewprereset");
      var zoomChanged = this._zoom !== zoom2;
      this._moveStart(zoomChanged, noMoveStart)._move(center, zoom2)._moveEnd(zoomChanged);
      this.fire("viewreset");
      if (loading) {
        this.fire("load");
      }
    },
    _moveStart: function(zoomChanged, noMoveStart) {
      if (zoomChanged) {
        this.fire("zoomstart");
      }
      if (!noMoveStart) {
        this.fire("movestart");
      }
      return this;
    },
    _move: function(center, zoom2, data, supressEvent) {
      if (zoom2 === void 0) {
        zoom2 = this._zoom;
      }
      var zoomChanged = this._zoom !== zoom2;
      this._zoom = zoom2;
      this._lastCenter = center;
      this._pixelOrigin = this._getNewPixelOrigin(center);
      if (!supressEvent) {
        if (zoomChanged || data && data.pinch) {
          this.fire("zoom", data);
        }
        this.fire("move", data);
      } else if (data && data.pinch) {
        this.fire("zoom", data);
      }
      return this;
    },
    _moveEnd: function(zoomChanged) {
      if (zoomChanged) {
        this.fire("zoomend");
      }
      return this.fire("moveend");
    },
    _stop: function() {
      cancelAnimFrame(this._flyToFrame);
      if (this._panAnim) {
        this._panAnim.stop();
      }
      return this;
    },
    _rawPanBy: function(offset) {
      setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
    },
    _getZoomSpan: function() {
      return this.getMaxZoom() - this.getMinZoom();
    },
    _panInsideMaxBounds: function() {
      if (!this._enforcingBounds) {
        this.panInsideBounds(this.options.maxBounds);
      }
    },
    _checkIfLoaded: function() {
      if (!this._loaded) {
        throw new Error("Set map center and zoom first.");
      }
    },
    // DOM event handling
    // @section Interaction events
    _initEvents: function(remove2) {
      this._targets = {};
      this._targets[stamp(this._container)] = this;
      var onOff = remove2 ? off : on;
      onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
      if (this.options.trackResize) {
        onOff(window, "resize", this._onResize, this);
      }
      if (Browser.any3d && this.options.transform3DLimit) {
        (remove2 ? this.off : this.on).call(this, "moveend", this._onMoveEnd);
      }
    },
    _onResize: function() {
      cancelAnimFrame(this._resizeRequest);
      this._resizeRequest = requestAnimFrame(
        function() {
          this.invalidateSize({ debounceMoveend: true });
        },
        this
      );
    },
    _onScroll: function() {
      this._container.scrollTop = 0;
      this._container.scrollLeft = 0;
    },
    _onMoveEnd: function() {
      var pos = this._getMapPanePos();
      if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) {
        this._resetView(this.getCenter(), this.getZoom());
      }
    },
    _findEventTargets: function(e, type) {
      var targets = [], target, isHover = type === "mouseout" || type === "mouseover", src = e.target || e.srcElement, dragging = false;
      while (src) {
        target = this._targets[stamp(src)];
        if (target && (type === "click" || type === "preclick") && this._draggableMoved(target)) {
          dragging = true;
          break;
        }
        if (target && target.listens(type, true)) {
          if (isHover && !isExternalTarget(src, e)) {
            break;
          }
          targets.push(target);
          if (isHover) {
            break;
          }
        }
        if (src === this._container) {
          break;
        }
        src = src.parentNode;
      }
      if (!targets.length && !dragging && !isHover && this.listens(type, true)) {
        targets = [this];
      }
      return targets;
    },
    _isClickDisabled: function(el) {
      while (el && el !== this._container) {
        if (el["_L2DV_disable_click"]) {
          return true;
        }
        el = el.parentNode;
      }
    },
    _handleDOMEvent: function(e) {
      var el = e.target || e.srcElement;
      if (!this._loaded || el["_L2DV_disable_events"] || e.type === "click" && this._isClickDisabled(el)) {
        return;
      }
      var type = e.type;
      if (type === "mousedown") {
        preventOutline(el);
      }
      this._fireDOMEvent(e, type);
    },
    _mouseEvents: ["click", "dblclick", "mouseover", "mouseout", "contextmenu"],
    _fireDOMEvent: function(e, type, canvasTargets) {
      if (e.type === "click") {
        var synth = extend({}, e);
        synth.type = "preclick";
        this._fireDOMEvent(synth, synth.type, canvasTargets);
      }
      var targets = this._findEventTargets(e, type);
      if (canvasTargets) {
        var filtered = [];
        for (var i = 0; i < canvasTargets.length; i++) {
          if (canvasTargets[i].listens(type, true)) {
            filtered.push(canvasTargets[i]);
          }
        }
        targets = filtered.concat(targets);
      }
      if (!targets.length) {
        return;
      }
      if (type === "contextmenu") {
        preventDefault(e);
      }
      var target = targets[0];
      var data = {
        originalEvent: e
      };
      if (e.type !== "keypress" && e.type !== "keydown" && e.type !== "keyup") {
        var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
        data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
        data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
        data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
      }
      for (i = 0; i < targets.length; i++) {
        targets[i].fire(type, data, true);
        if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) {
          return;
        }
      }
    },
    _draggableMoved: function(obj) {
      obj = obj.dragging && obj.dragging.enabled() ? obj : this;
      return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
    },
    _clearHandlers: function() {
      for (var i = 0, len = this._handlers.length; i < len; i++) {
        this._handlers[i].disable();
      }
    },
    // @section Other Methods
    // @method whenReady(fn: Function, context?: Object): this
    // Runs the given function `fn` when the map gets initialized with
    // a view (center and zoom) and at least one layer, or immediately
    // if it's already initialized, optionally passing a function context.
    whenReady: function(callback, context) {
      if (this._loaded) {
        callback.call(context || this, { target: this });
      } else {
        this.on("load", callback, context);
      }
      return this;
    },
    // private methods for getting map state
    _getMapPanePos: function() {
      return getPosition(this._mapPane) || new Point(0, 0);
    },
    _moved: function() {
      var pos = this._getMapPanePos();
      return pos && !pos.equals([0, 0]);
    },
    _getTopLeftPoint: function(center, zoom2) {
      var pixelOrigin = center && zoom2 !== void 0 ? this._getNewPixelOrigin(center, zoom2) : this.getPixelOrigin();
      return pixelOrigin.subtract(this._getMapPanePos());
    },
    _getNewPixelOrigin: function(center, zoom2) {
      var viewHalf = this.getSize()._divideBy(2);
      return this.project(center, zoom2)._subtract(viewHalf)._add(this._getMapPanePos())._round();
    },
    _latLngToNewLayerPoint: function(latlng, zoom2, center) {
      var topLeft = this._getNewPixelOrigin(center, zoom2);
      return this.project(latlng, zoom2)._subtract(topLeft);
    },
    _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom2, center) {
      var topLeft = this._getNewPixelOrigin(center, zoom2);
      return toBounds([
        this.project(latLngBounds.getSouthWest(), zoom2)._subtract(topLeft),
        this.project(latLngBounds.getNorthWest(), zoom2)._subtract(topLeft),
        this.project(latLngBounds.getSouthEast(), zoom2)._subtract(topLeft),
        this.project(latLngBounds.getNorthEast(), zoom2)._subtract(topLeft)
      ]);
    },
    // layer point of the current center
    _getCenterLayerPoint: function() {
      return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
    },
    // offset of the specified place to the current center in pixels
    _getCenterOffset: function(latlng) {
      return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
    },
    // adjust center for view to get inside bounds
    _limitCenter: function(center, zoom2, bounds) {
      if (!bounds) {
        return center;
      }
      var centerPoint = this.project(center, zoom2), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom2);
      if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) {
        return center;
      }
      return this.unproject(centerPoint.add(offset), zoom2);
    },
    // adjust offset for view to get inside bounds
    _limitOffset: function(offset, bounds) {
      if (!bounds) {
        return offset;
      }
      var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
      return offset.add(this._getBoundsOffset(newBounds, bounds));
    },
    // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
    _getBoundsOffset: function(pxBounds, maxBounds, zoom2) {
      var projectedMaxBounds = toBounds(
        this.project(maxBounds.getNorthEast(), zoom2),
        this.project(maxBounds.getSouthWest(), zoom2)
      ), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
      return new Point(dx, dy);
    },
    _rebound: function(left, right) {
      return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
    },
    _limitZoom: function(zoom2) {
      var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
      if (snap) {
        zoom2 = Math.round(zoom2 / snap) * snap;
      }
      return Math.max(min, Math.min(max, zoom2));
    },
    _onPanTransitionStep: function() {
      this.fire("move");
    },
    _onPanTransitionEnd: function() {
      removeClass(this._mapPane, "L2DV-pan-anim");
      this.fire("moveend");
    },
    _tryAnimatedPan: function(center, options) {
      var offset = this._getCenterOffset(center)._trunc();
      if ((options && options.animate) !== true && !this.getSize().contains(offset)) {
        return false;
      }
      this.panBy(offset, options);
      return true;
    },
    _createAnimProxy: function() {
      var proxy = this._proxy = create$1("div", "L2DV-proxy L2DV-zoom-animated");
      this._panes.mapPane.appendChild(proxy);
      this.on("zoomanim", function(e) {
        var prop = TRANSFORM, transform = this._proxy.style[prop];
        setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
        if (transform === this._proxy.style[prop] && this._animatingZoom) {
          this._onZoomTransitionEnd();
        }
      }, this);
      this.on("load moveend", this._animMoveEnd, this);
      this._on("unload", this._destroyAnimProxy, this);
    },
    _destroyAnimProxy: function() {
      remove(this._proxy);
      this.off("load moveend", this._animMoveEnd, this);
      delete this._proxy;
    },
    _animMoveEnd: function() {
      var c = this.getCenter(), z = this.getZoom();
      setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
    },
    _catchTransitionEnd: function(e) {
      if (this._animatingZoom && e.propertyName.indexOf("transform") >= 0) {
        this._onZoomTransitionEnd();
      }
    },
    _nothingToAnimate: function() {
      return !this._container.getElementsByClassName("L2DV-zoom-animated").length;
    },
    _tryAnimatedZoom: function(center, zoom2, options) {
      if (this._animatingZoom) {
        return true;
      }
      options = options || {};
      if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom2 - this._zoom) > this.options.zoomAnimationThreshold) {
        return false;
      }
      var scale2 = this.getZoomScale(zoom2), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale2);
      if (options.animate !== true && !this.getSize().contains(offset)) {
        return false;
      }
      requestAnimFrame(function() {
        this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom2, true);
      }, this);
      return true;
    },
    _animateZoom: function(center, zoom2, startAnim, noUpdate) {
      if (!this._mapPane) {
        return;
      }
      if (startAnim) {
        this._animatingZoom = true;
        this._animateToCenter = center;
        this._animateToZoom = zoom2;
        addClass(this._mapPane, "L2DV-zoom-anim");
      }
      this.fire("zoomanim", {
        center,
        zoom: zoom2,
        noUpdate
      });
      if (!this._tempFireZoomEvent) {
        this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
      }
      this._move(this._animateToCenter, this._animateToZoom, void 0, true);
      setTimeout(bind(this._onZoomTransitionEnd, this), 250);
    },
    _onZoomTransitionEnd: function() {
      if (!this._animatingZoom) {
        return;
      }
      if (this._mapPane) {
        removeClass(this._mapPane, "L2DV-zoom-anim");
      }
      this._animatingZoom = false;
      this._move(this._animateToCenter, this._animateToZoom, void 0, true);
      if (this._tempFireZoomEvent) {
        this.fire("zoom");
      }
      delete this._tempFireZoomEvent;
      this.fire("move");
      this._moveEnd(true);
    }
  });
  function createMap(id, options) {
    return new Map(id, options);
  }
  var Control = Class.extend({
    // @section
    // @aka Control Options
    options: {
      // @option position: String = 'topright'
      // The position of the control (one of the map corners). Possible values are `'topleft'`,
      // `'topright'`, `'bottomleft'` or `'bottomright'`
      position: "topright"
    },
    initialize: function(options) {
      setOptions(this, options);
    },
    /* @section
     * Classes extending L.Control will inherit the following methods:
     *
     * @method getPosition: string
     * Returns the position of the control.
     */
    getPosition: function() {
      return this.options.position;
    },
    // @method setPosition(position: string): this
    // Sets the position of the control.
    setPosition: function(position) {
      var map = this._map;
      if (map) {
        map.removeControl(this);
      }
      this.options.position = position;
      if (map) {
        map.addControl(this);
      }
      return this;
    },
    // @method getContainer: HTMLElement
    // Returns the HTMLElement that contains the control.
    getContainer: function() {
      return this._container;
    },
    // @method addTo(map: Map): this
    // Adds the control to the given map.
    addTo: function(map) {
      this.remove();
      this._map = map;
      var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
      addClass(container, "L2DV-control");
      if (pos.indexOf("bottom") !== -1) {
        corner.insertBefore(container, corner.firstChild);
      } else {
        corner.appendChild(container);
      }
      this._map.on("unload", this.remove, this);
      return this;
    },
    // @method remove: this
    // Removes the control from the map it is currently active on.
    remove: function() {
      if (!this._map) {
        return this;
      }
      remove(this._container);
      if (this.onRemove) {
        this.onRemove(this._map);
      }
      this._map.off("unload", this.remove, this);
      this._map = null;
      return this;
    },
    _refocusOnMap: function(e) {
      if (this._map && e && e.screenX > 0 && e.screenY > 0) {
        this._map.getContainer().focus();
      }
    }
  });
  var control = function(options) {
    return new Control(options);
  };
  Map.include({
    // @method addControl(control: Control): this
    // Adds the given control to the map
    addControl: function(control2) {
      control2.addTo(this);
      return this;
    },
    // @method removeControl(control: Control): this
    // Removes the given control from the map
    removeControl: function(control2) {
      control2.remove();
      return this;
    },
    _initControlPos: function() {
      var corners = this._controlCorners = {}, l = "L2DV-", container = this._controlContainer = create$1("div", l + "control-container", this._container);
      function createCorner(vSide, hSide) {
        var className = l + vSide + " " + l + hSide;
        corners[vSide + hSide] = create$1("div", className, container);
      }
      createCorner("top", "left");
      createCorner("top", "right");
      createCorner("bottom", "left");
      createCorner("bottom", "right");
    },
    _clearControlPos: function() {
      for (var i in this._controlCorners) {
        remove(this._controlCorners[i]);
      }
      remove(this._controlContainer);
      delete this._controlCorners;
      delete this._controlContainer;
    }
  });
  var Layers = Control.extend({
    // @section
    // @aka Control.Layers options
    options: {
      // @option collapsed: Boolean = true
      // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
      collapsed: true,
      position: "topright",
      // @option autoZIndex: Boolean = true
      // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
      autoZIndex: true,
      // @option hideSingleBase: Boolean = false
      // If `true`, the base layers in the control will be hidden when there is only one.
      hideSingleBase: false,
      // @option sortLayers: Boolean = false
      // Whether to sort the layers. When `false`, layers will keep the order
      // in which they were added to the control.
      sortLayers: false,
      // @option sortFunction: Function = *
      // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
      // that will be used for sorting the layers, when `sortLayers` is `true`.
      // The function receives both the `L.Layer` instances and their names, as in
      // `sortFunction(layerA, layerB, nameA, nameB)`.
      // By default, it sorts layers alphabetically by their name.
      sortFunction: function(layerA, layerB, nameA, nameB) {
        return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
      }
    },
    initialize: function(baseLayers, overlays, options) {
      setOptions(this, options);
      this._layerControlInputs = [];
      this._layers = [];
      this._lastZIndex = 0;
      this._handlingClick = false;
      this._preventClick = false;
      for (var i in baseLayers) {
        this._addLayer(baseLayers[i], i);
      }
      for (i in overlays) {
        this._addLayer(overlays[i], i, true);
      }
    },
    onAdd: function(map) {
      this._initLayout();
      this._update();
      this._map = map;
      map.on("zoomend", this._checkDisabledLayers, this);
      for (var i = 0; i < this._layers.length; i++) {
        this._layers[i].layer.on("add remove", this._onLayerChange, this);
      }
      return this._container;
    },
    addTo: function(map) {
      Control.prototype.addTo.call(this, map);
      return this._expandIfNotCollapsed();
    },
    onRemove: function() {
      this._map.off("zoomend", this._checkDisabledLayers, this);
      for (var i = 0; i < this._layers.length; i++) {
        this._layers[i].layer.off("add remove", this._onLayerChange, this);
      }
    },
    // @method addBaseLayer(layer: Layer, name: String): this
    // Adds a base layer (radio button entry) with the given name to the control.
    addBaseLayer: function(layer, name) {
      this._addLayer(layer, name);
      return this._map ? this._update() : this;
    },
    // @method addOverlay(layer: Layer, name: String): this
    // Adds an overlay (checkbox entry) with the given name to the control.
    addOverlay: function(layer, name) {
      this._addLayer(layer, name, true);
      return this._map ? this._update() : this;
    },
    // @method removeLayer(layer: Layer): this
    // Remove the given layer from the control.
    removeLayer: function(layer) {
      layer.off("add remove", this._onLayerChange, this);
      var obj = this._getLayer(stamp(layer));
      if (obj) {
        this._layers.splice(this._layers.indexOf(obj), 1);
      }
      return this._map ? this._update() : this;
    },
    // @method expand(): this
    // Expand the control container if collapsed.
    expand: function() {
      addClass(this._container, "L2DV-control-layers-expanded");
      this._section.style.height = null;
      var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
      if (acceptableHeight < this._section.clientHeight) {
        addClass(this._section, "L2DV-control-layers-scrollbar");
        this._section.style.height = acceptableHeight + "px";
      } else {
        removeClass(this._section, "L2DV-control-layers-scrollbar");
      }
      this._checkDisabledLayers();
      return this;
    },
    // @method collapse(): this
    // Collapse the control container if expanded.
    collapse: function() {
      removeClass(this._container, "L2DV-control-layers-expanded");
      return this;
    },
    _initLayout: function() {
      var className = "L2DV-control-layers", container = this._container = create$1("div", className), collapsed = this.options.collapsed;
      container.setAttribute("aria-haspopup", true);
      disableClickPropagation(container);
      disableScrollPropagation(container);
      var section = this._section = create$1("section", className + "-list");
      if (collapsed) {
        this._map.on("click", this.collapse, this);
        on(container, {
          mouseenter: this._expandSafely,
          mouseleave: this.collapse
        }, this);
      }
      var link = this._layersLink = create$1("a", className + "-toggle", container);
      link.href = "#";
      link.title = "Layers";
      link.setAttribute("role", "button");
      on(link, {
        keydown: function(e) {
          if (e.keyCode === 13) {
            this._expandSafely();
          }
        },
        // Certain screen readers intercept the key event and instead send a click event
        click: function(e) {
          preventDefault(e);
          this._expandSafely();
        }
      }, this);
      if (!collapsed) {
        this.expand();
      }
      this._baseLayersList = create$1("div", className + "-base", section);
      this._separator = create$1("div", className + "-separator", section);
      this._overlaysList = create$1("div", className + "-overlays", section);
      container.appendChild(section);
    },
    _getLayer: function(id) {
      for (var i = 0; i < this._layers.length; i++) {
        if (this._layers[i] && stamp(this._layers[i].layer) === id) {
          return this._layers[i];
        }
      }
    },
    _addLayer: function(layer, name, overlay) {
      if (this._map) {
        layer.on("add remove", this._onLayerChange, this);
      }
      this._layers.push({
        layer,
        name,
        overlay
      });
      if (this.options.sortLayers) {
        this._layers.sort(bind(function(a, b) {
          return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
        }, this));
      }
      if (this.options.autoZIndex && layer.setZIndex) {
        this._lastZIndex++;
        layer.setZIndex(this._lastZIndex);
      }
      this._expandIfNotCollapsed();
    },
    _update: function() {
      if (!this._container) {
        return this;
      }
      empty(this._baseLayersList);
      empty(this._overlaysList);
      this._layerControlInputs = [];
      var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
      for (i = 0; i < this._layers.length; i++) {
        obj = this._layers[i];
        this._addItem(obj);
        overlaysPresent = overlaysPresent || obj.overlay;
        baseLayersPresent = baseLayersPresent || !obj.overlay;
        baseLayersCount += !obj.overlay ? 1 : 0;
      }
      if (this.options.hideSingleBase) {
        baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
        this._baseLayersList.style.display = baseLayersPresent ? "" : "none";
      }
      this._separator.style.display = overlaysPresent && baseLayersPresent ? "" : "none";
      return this;
    },
    _onLayerChange: function(e) {
      if (!this._handlingClick) {
        this._update();
      }
      var obj = this._getLayer(stamp(e.target));
      var type = obj.overlay ? e.type === "add" ? "overlayadd" : "overlayremove" : e.type === "add" ? "baselayerchange" : null;
      if (type) {
        this._map.fire(type, obj);
      }
    },
    // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
    _createRadioElement: function(name, checked) {
      var radioHtml = '<input type="radio" class="L2DV-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : "") + "/>";
      var radioFragment = document.createElement("div");
      radioFragment.innerHTML = radioHtml;
      return radioFragment.firstChild;
    },
    _addItem: function(obj) {
      var label = document.createElement("label"), checked = this._map.hasLayer(obj.layer), input;
      if (obj.overlay) {
        input = document.createElement("input");
        input.type = "checkbox";
        input.className = "L2DV-control-layers-selector";
        input.defaultChecked = checked;
      } else {
        input = this._createRadioElement("L2DV-base-layers_" + stamp(this), checked);
      }
      this._layerControlInputs.push(input);
      input.layerId = stamp(obj.layer);
      on(input, "click", this._onInputClick, this);
      var name = document.createElement("span");
      name.innerHTML = " " + obj.name;
      var holder = document.createElement("span");
      label.appendChild(holder);
      holder.appendChild(input);
      holder.appendChild(name);
      var container = obj.overlay ? this._overlaysList : this._baseLayersList;
      container.appendChild(label);
      this._checkDisabledLayers();
      return label;
    },
    _onInputClick: function() {
      if (this._preventClick) {
        return;
      }
      var inputs = this._layerControlInputs, input, layer;
      var addedLayers = [], removedLayers = [];
      this._handlingClick = true;
      for (var i = inputs.length - 1; i >= 0; i--) {
        input = inputs[i];
        layer = this._getLayer(input.layerId).layer;
        if (input.checked) {
          addedLayers.push(layer);
        } else if (!input.checked) {
          removedLayers.push(layer);
        }
      }
      for (i = 0; i < removedLayers.length; i++) {
        if (this._map.hasLayer(removedLayers[i])) {
          this._map.removeLayer(removedLayers[i]);
        }
      }
      for (i = 0; i < addedLayers.length; i++) {
        if (!this._map.hasLayer(addedLayers[i])) {
          this._map.addLayer(addedLayers[i]);
        }
      }
      this._handlingClick = false;
      this._refocusOnMap();
    },
    _checkDisabledLayers: function() {
      var inputs = this._layerControlInputs, input, layer, zoom2 = this._map.getZoom();
      for (var i = inputs.length - 1; i >= 0; i--) {
        input = inputs[i];
        layer = this._getLayer(input.layerId).layer;
        input.disabled = layer.options.minZoom !== void 0 && zoom2 < layer.options.minZoom || layer.options.maxZoom !== void 0 && zoom2 > layer.options.maxZoom;
      }
    },
    _expandIfNotCollapsed: function() {
      if (this._map && !this.options.collapsed) {
        this.expand();
      }
      return this;
    },
    _expandSafely: function() {
      var section = this._section;
      this._preventClick = true;
      on(section, "click", preventDefault);
      this.expand();
      var that = this;
      setTimeout(function() {
        off(section, "click", preventDefault);
        that._preventClick = false;
      });
    }
  });
  var layers = function(baseLayers, overlays, options) {
    return new Layers(baseLayers, overlays, options);
  };
  var Zoom = Control.extend({
    // @section
    // @aka Control.Zoom options
    options: {
      position: "topleft",
      // @option zoomInText: String = '<span aria-hidden="true">+</span>'
      // The text set on the 'zoom in' button.
      zoomInText: '<span aria-hidden="true">+</span>',
      // @option zoomInTitle: String = 'Zoom in'
      // The title set on the 'zoom in' button.
      zoomInTitle: "Zoom in",
      // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
      // The text set on the 'zoom out' button.
      zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
      // @option zoomOutTitle: String = 'Zoom out'
      // The title set on the 'zoom out' button.
      zoomOutTitle: "Zoom out"
    },
    onAdd: function(map) {
      var zoomName = "L2DV-control-zoom", container = create$1("div", zoomName + " L2DV-bar"), options = this.options;
      this._zoomInButton = this._createButton(
        options.zoomInText,
        options.zoomInTitle,
        zoomName + "-in",
        container,
        this._zoomIn
      );
      this._zoomOutButton = this._createButton(
        options.zoomOutText,
        options.zoomOutTitle,
        zoomName + "-out",
        container,
        this._zoomOut
      );
      this._updateDisabled();
      map.on("zoomend zoomlevelschange", this._updateDisabled, this);
      return container;
    },
    onRemove: function(map) {
      map.off("zoomend zoomlevelschange", this._updateDisabled, this);
    },
    disable: function() {
      this._disabled = true;
      this._updateDisabled();
      return this;
    },
    enable: function() {
      this._disabled = false;
      this._updateDisabled();
      return this;
    },
    _zoomIn: function(e) {
      if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) {
        this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
      }
    },
    _zoomOut: function(e) {
      if (!this._disabled && this._map._zoom > this._map.getMinZoom()) {
        this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
      }
    },
    _createButton: function(html, title, className, container, fn) {
      var link = create$1("a", className, container);
      link.innerHTML = html;
      link.href = "#";
      link.title = title;
      link.setAttribute("role", "button");
      link.setAttribute("aria-label", title);
      disableClickPropagation(link);
      on(link, "click", stop);
      on(link, "click", fn, this);
      on(link, "click", this._refocusOnMap, this);
      return link;
    },
    _updateDisabled: function() {
      var map = this._map, className = "L2DV-disabled";
      removeClass(this._zoomInButton, className);
      removeClass(this._zoomOutButton, className);
      this._zoomInButton.setAttribute("aria-disabled", "false");
      this._zoomOutButton.setAttribute("aria-disabled", "false");
      if (this._disabled || map._zoom === map.getMinZoom()) {
        addClass(this._zoomOutButton, className);
        this._zoomOutButton.setAttribute("aria-disabled", "true");
      }
      if (this._disabled || map._zoom === map.getMaxZoom()) {
        addClass(this._zoomInButton, className);
        this._zoomInButton.setAttribute("aria-disabled", "true");
      }
    }
  });
  Map.mergeOptions({
    zoomControl: true
  });
  Map.addInitHook(function() {
    if (this.options.zoomControl) {
      this.zoomControl = new Zoom();
      this.addControl(this.zoomControl);
    }
  });
  var zoom = function(options) {
    return new Zoom(options);
  };
  var Scale = Control.extend({
    // @section
    // @aka Control.Scale options
    options: {
      position: "bottomleft",
      // @option maxWidth: Number = 100
      // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
      maxWidth: 100,
      // @option metric: Boolean = True
      // Whether to show the metric scale line (m/km).
      metric: true,
      // @option imperial: Boolean = True
      // Whether to show the imperial scale line (mi/ft).
      imperial: true
      // @option updateWhenIdle: Boolean = false
      // If `true`, the control is updated on [`moveend`](#map-moveend), otherwise it's always up-to-date (updated on [`move`](#map-move)).
    },
    onAdd: function(map) {
      var className = "L2DV-control-scale", container = create$1("div", className), options = this.options;
      this._addScales(options, className + "-line", container);
      map.on(options.updateWhenIdle ? "moveend" : "move", this._update, this);
      map.whenReady(this._update, this);
      return container;
    },
    onRemove: function(map) {
      map.off(this.options.updateWhenIdle ? "moveend" : "move", this._update, this);
    },
    _addScales: function(options, className, container) {
      if (options.metric) {
        this._mScale = create$1("div", className, container);
      }
      if (options.imperial) {
        this._iScale = create$1("div", className, container);
      }
    },
    _update: function() {
      var map = this._map, y = map.getSize().y / 2;
      var maxMeters = map.distance(
        map.containerPointToLatLng([0, y]),
        map.containerPointToLatLng([this.options.maxWidth, y])
      );
      this._updateScales(maxMeters);
    },
    _updateScales: function(maxMeters) {
      if (this.options.metric && maxMeters) {
        this._updateMetric(maxMeters);
      }
      if (this.options.imperial && maxMeters) {
        this._updateImperial(maxMeters);
      }
    },
    _updateMetric: function(maxMeters) {
      var meters = this._getRoundNum(maxMeters), label = meters < 1e3 ? meters + " m" : meters / 1e3 + " km";
      this._updateScale(this._mScale, label, meters / maxMeters);
    },
    _updateImperial: function(maxMeters) {
      var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
      if (maxFeet > 5280) {
        maxMiles = maxFeet / 5280;
        miles = this._getRoundNum(maxMiles);
        this._updateScale(this._iScale, miles + " mi", miles / maxMiles);
      } else {
        feet = this._getRoundNum(maxFeet);
        this._updateScale(this._iScale, feet + " ft", feet / maxFeet);
      }
    },
    _updateScale: function(scale2, text, ratio) {
      scale2.style.width = Math.round(this.options.maxWidth * ratio) + "px";
      scale2.innerHTML = text;
    },
    _getRoundNum: function(num) {
      var pow10 = Math.pow(10, (Math.floor(num) + "").length - 1), d = num / pow10;
      d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
      return pow10 * d;
    }
  });
  var scale = function(options) {
    return new Scale(options);
  };
  var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="L2DV-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
  var Attribution = Control.extend({
    // @section
    // @aka Control.Attribution options
    options: {
      position: "bottomright",
      // @option prefix: String|false = 'L2DV'
      // The HTML text shown before the attributions. Pass `false` to disable.
      prefix: '<a href="https://L2DVjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + " " : "") + "L2DV</a>"
    },
    initialize: function(options) {
      setOptions(this, options);
      this._attributions = {};
    },
    onAdd: function(map) {
      map.attributionControl = this;
      this._container = create$1("div", "L2DV-control-attribution");
      disableClickPropagation(this._container);
      for (var i in map._layers) {
        if (map._layers[i].getAttribution) {
          this.addAttribution(map._layers[i].getAttribution());
        }
      }
      this._update();
      map.on("layeradd", this._addAttribution, this);
      return this._container;
    },
    onRemove: function(map) {
      map.off("layeradd", this._addAttribution, this);
    },
    _addAttribution: function(ev) {
      if (ev.layer.getAttribution) {
        this.addAttribution(ev.layer.getAttribution());
        ev.layer.once("remove", function() {
          this.removeAttribution(ev.layer.getAttribution());
        }, this);
      }
    },
    // @method setPrefix(prefix: String|false): this
    // The HTML text shown before the attributions. Pass `false` to disable.
    setPrefix: function(prefix) {
      this.options.prefix = prefix;
      this._update();
      return this;
    },
    // @method addAttribution(text: String): this
    // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
    addAttribution: function(text) {
      if (!text) {
        return this;
      }
      if (!this._attributions[text]) {
        this._attributions[text] = 0;
      }
      this._attributions[text]++;
      this._update();
      return this;
    },
    // @method removeAttribution(text: String): this
    // Removes an attribution text.
    removeAttribution: function(text) {
      if (!text) {
        return this;
      }
      if (this._attributions[text]) {
        this._attributions[text]--;
        this._update();
      }
      return this;
    },
    _update: function() {
      if (!this._map) {
        return;
      }
      var attribs = [];
      for (var i in this._attributions) {
        if (this._attributions[i]) {
          attribs.push(i);
        }
      }
      var prefixAndAttribs = [];
      if (this.options.prefix) {
        prefixAndAttribs.push(this.options.prefix);
      }
      if (attribs.length) {
        prefixAndAttribs.push(attribs.join(", "));
      }
      this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
    }
  });
  Map.mergeOptions({
    attributionControl: true
  });
  Map.addInitHook(function() {
    if (this.options.attributionControl) {
      new Attribution().addTo(this);
    }
  });
  var attribution = function(options) {
    return new Attribution(options);
  };
  Control.Layers = Layers;
  Control.Zoom = Zoom;
  Control.Scale = Scale;
  Control.Attribution = Attribution;
  control.layers = layers;
  control.zoom = zoom;
  control.scale = scale;
  control.attribution = attribution;
  var Handler = Class.extend({
    initialize: function(map) {
      this._map = map;
    },
    // @method enable(): this
    // Enables the handler
    enable: function() {
      if (this._enabled) {
        return this;
      }
      this._enabled = true;
      this.addHooks();
      return this;
    },
    // @method disable(): this
    // Disables the handler
    disable: function() {
      if (!this._enabled) {
        return this;
      }
      this._enabled = false;
      this.removeHooks();
      return this;
    },
    // @method enabled(): Boolean
    // Returns `true` if the handler is enabled
    enabled: function() {
      return !!this._enabled;
    }
    // @section Extension methods
    // Classes inheriting from `Handler` must implement the two following methods:
    // @method addHooks()
    // Called when the handler is enabled, should add event hooks.
    // @method removeHooks()
    // Called when the handler is disabled, should remove the event hooks added previously.
  });
  Handler.addTo = function(map, name) {
    map.addHandler(name, this);
    return this;
  };
  var Mixin = { Events };
  var START = Browser.touch ? "touchstart mousedown" : "mousedown";
  var Draggable = Evented.extend({
    options: {
      // @section
      // @aka Draggable options
      // @option clickTolerance: Number = 3
      // The max number of pixels a user can shift the mouse pointer during a click
      // for it to be considered a valid click (as opposed to a mouse drag).
      clickTolerance: 3
    },
    // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
    // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
    initialize: function(element, dragStartTarget, preventOutline2, options) {
      setOptions(this, options);
      this._element = element;
      this._dragStartTarget = dragStartTarget || element;
      this._preventOutline = preventOutline2;
    },
    // @method enable()
    // Enables the dragging ability
    enable: function() {
      if (this._enabled) {
        return;
      }
      on(this._dragStartTarget, START, this._onDown, this);
      this._enabled = true;
    },
    // @method disable()
    // Disables the dragging ability
    disable: function() {
      if (!this._enabled) {
        return;
      }
      if (Draggable._dragging === this) {
        this.finishDrag(true);
      }
      off(this._dragStartTarget, START, this._onDown, this);
      this._enabled = false;
      this._moved = false;
    },
    _onDown: function(e) {
      if (!this._enabled) {
        return;
      }
      this._moved = false;
      if (hasClass(this._element, "L2DV-zoom-anim")) {
        return;
      }
      if (e.touches && e.touches.length !== 1) {
        if (Draggable._dragging === this) {
          this.finishDrag();
        }
        return;
      }
      if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) {
        return;
      }
      Draggable._dragging = this;
      if (this._preventOutline) {
        preventOutline(this._element);
      }
      disableImageDrag();
      disableTextSelection();
      if (this._moving) {
        return;
      }
      this.fire("down");
      var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
      this._startPoint = new Point(first.clientX, first.clientY);
      this._startPos = getPosition(this._element);
      this._parentScale = getScale(sizedParent);
      var mouseevent = e.type === "mousedown";
      on(document, mouseevent ? "mousemove" : "touchmove", this._onMove, this);
      on(document, mouseevent ? "mouseup" : "touchend touchcancel", this._onUp, this);
    },
    _onMove: function(e) {
      if (!this._enabled) {
        return;
      }
      if (e.touches && e.touches.length > 1) {
        this._moved = true;
        return;
      }
      var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
      if (!offset.x && !offset.y) {
        return;
      }
      if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) {
        return;
      }
      offset.x /= this._parentScale.x;
      offset.y /= this._parentScale.y;
      preventDefault(e);
      if (!this._moved) {
        this.fire("dragstart");
        this._moved = true;
        addClass(document.body, "L2DV-dragging");
        this._lastTarget = e.target || e.srcElement;
        if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) {
          this._lastTarget = this._lastTarget.correspondingUseElement;
        }
        addClass(this._lastTarget, "L2DV-drag-target");
      }
      this._newPos = this._startPos.add(offset);
      this._moving = true;
      this._lastEvent = e;
      this._updatePosition();
    },
    _updatePosition: function() {
      var e = { originalEvent: this._lastEvent };
      this.fire("predrag", e);
      setPosition(this._element, this._newPos);
      this.fire("drag", e);
    },
    _onUp: function() {
      if (!this._enabled) {
        return;
      }
      this.finishDrag();
    },
    finishDrag: function(noInertia) {
      removeClass(document.body, "L2DV-dragging");
      if (this._lastTarget) {
        removeClass(this._lastTarget, "L2DV-drag-target");
        this._lastTarget = null;
      }
      off(document, "mousemove touchmove", this._onMove, this);
      off(document, "mouseup touchend touchcancel", this._onUp, this);
      enableImageDrag();
      enableTextSelection();
      var fireDragend = this._moved && this._moving;
      this._moving = false;
      Draggable._dragging = false;
      if (fireDragend) {
        this.fire("dragend", {
          noInertia,
          distance: this._newPos.distanceTo(this._startPos)
        });
      }
    }
  });
  function clipPolygon(points, bounds, round) {
    var clippedPoints, edges = [1, 4, 2, 8], i, j, k, a, b, len, edge2, p;
    for (i = 0, len = points.length; i < len; i++) {
      points[i]._code = _getBitCode(points[i], bounds);
    }
    for (k = 0; k < 4; k++) {
      edge2 = edges[k];
      clippedPoints = [];
      for (i = 0, len = points.length, j = len - 1; i < len; j = i++) {
        a = points[i];
        b = points[j];
        if (!(a._code & edge2)) {
          if (b._code & edge2) {
            p = _getEdgeIntersection(b, a, edge2, bounds, round);
            p._code = _getBitCode(p, bounds);
            clippedPoints.push(p);
          }
          clippedPoints.push(a);
        } else if (!(b._code & edge2)) {
          p = _getEdgeIntersection(b, a, edge2, bounds, round);
          p._code = _getBitCode(p, bounds);
          clippedPoints.push(p);
        }
      }
      points = clippedPoints;
    }
    return points;
  }
  function polygonCenter(latlngs, crs) {
    var i, j, p1, p2, f, area, x, y, center;
    if (!latlngs || latlngs.length === 0) {
      throw new Error("latlngs not passed");
    }
    if (!isFlat(latlngs)) {
      console.warn("latlngs are not flat! Only the first ring will be used");
      latlngs = latlngs[0];
    }
    var centroidLatLng = toLatLng([0, 0]);
    var bounds = toLatLngBounds(latlngs);
    var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
    if (areaBounds < 1700) {
      centroidLatLng = centroid(latlngs);
    }
    var len = latlngs.length;
    var points = [];
    for (i = 0; i < len; i++) {
      var latlng = toLatLng(latlngs[i]);
      points.push(crs.project(toLatLng([latlng.lat - centroidLatLng.lat, latlng.lng - centroidLatLng.lng])));
    }
    area = x = y = 0;
    for (i = 0, j = len - 1; i < len; j = i++) {
      p1 = points[i];
      p2 = points[j];
      f = p1.y * p2.x - p2.y * p1.x;
      x += (p1.x + p2.x) * f;
      y += (p1.y + p2.y) * f;
      area += f * 3;
    }
    if (area === 0) {
      center = points[0];
    } else {
      center = [x / area, y / area];
    }
    var latlngCenter = crs.unproject(toPoint(center));
    return toLatLng([latlngCenter.lat + centroidLatLng.lat, latlngCenter.lng + centroidLatLng.lng]);
  }
  function centroid(coords) {
    var latSum = 0;
    var lngSum = 0;
    var len = 0;
    for (var i = 0; i < coords.length; i++) {
      var latlng = toLatLng(coords[i]);
      latSum += latlng.lat;
      lngSum += latlng.lng;
      len++;
    }
    return toLatLng([latSum / len, lngSum / len]);
  }
  var PolyUtil = {
    __proto__: null,
    clipPolygon,
    polygonCenter,
    centroid
  };
  function simplify(points, tolerance) {
    if (!tolerance || !points.length) {
      return points.slice();
    }
    var sqTolerance = tolerance * tolerance;
    points = _reducePoints(points, sqTolerance);
    points = _simplifyDP(points, sqTolerance);
    return points;
  }
  function pointToSegmentDistance(p, p1, p2) {
    return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
  }
  function closestPointOnSegment(p, p1, p2) {
    return _sqClosestPointOnSegment(p, p1, p2);
  }
  function _simplifyDP(points, sqTolerance) {
    var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
    markers[0] = markers[len - 1] = 1;
    _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
    var i, newPoints = [];
    for (i = 0; i < len; i++) {
      if (markers[i]) {
        newPoints.push(points[i]);
      }
    }
    return newPoints;
  }
  function _simplifyDPStep(points, markers, sqTolerance, first, last) {
    var maxSqDist = 0, index2, i, sqDist;
    for (i = first + 1; i <= last - 1; i++) {
      sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
      if (sqDist > maxSqDist) {
        index2 = i;
        maxSqDist = sqDist;
      }
    }
    if (maxSqDist > sqTolerance) {
      markers[index2] = 1;
      _simplifyDPStep(points, markers, sqTolerance, first, index2);
      _simplifyDPStep(points, markers, sqTolerance, index2, last);
    }
  }
  function _reducePoints(points, sqTolerance) {
    var reducedPoints = [points[0]];
    for (var i = 1, prev = 0, len = points.length; i < len; i++) {
      if (_sqDist(points[i], points[prev]) > sqTolerance) {
        reducedPoints.push(points[i]);
        prev = i;
      }
    }
    if (prev < len - 1) {
      reducedPoints.push(points[len - 1]);
    }
    return reducedPoints;
  }
  var _lastCode;
  function clipSegment(a, b, bounds, useLastCode, round) {
    var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
    _lastCode = codeB;
    while (true) {
      if (!(codeA | codeB)) {
        return [a, b];
      }
      if (codeA & codeB) {
        return false;
      }
      codeOut = codeA || codeB;
      p = _getEdgeIntersection(a, b, codeOut, bounds, round);
      newCode = _getBitCode(p, bounds);
      if (codeOut === codeA) {
        a = p;
        codeA = newCode;
      } else {
        b = p;
        codeB = newCode;
      }
    }
  }
  function _getEdgeIntersection(a, b, code, bounds, round) {
    var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
    if (code & 8) {
      x = a.x + dx * (max.y - a.y) / dy;
      y = max.y;
    } else if (code & 4) {
      x = a.x + dx * (min.y - a.y) / dy;
      y = min.y;
    } else if (code & 2) {
      x = max.x;
      y = a.y + dy * (max.x - a.x) / dx;
    } else if (code & 1) {
      x = min.x;
      y = a.y + dy * (min.x - a.x) / dx;
    }
    return new Point(x, y, round);
  }
  function _getBitCode(p, bounds) {
    var code = 0;
    if (p.x < bounds.min.x) {
      code |= 1;
    } else if (p.x > bounds.max.x) {
      code |= 2;
    }
    if (p.y < bounds.min.y) {
      code |= 4;
    } else if (p.y > bounds.max.y) {
      code |= 8;
    }
    return code;
  }
  function _sqDist(p1, p2) {
    var dx = p2.x - p1.x, dy = p2.y - p1.y;
    return dx * dx + dy * dy;
  }
  function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
    var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
    if (dot > 0) {
      t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
      if (t > 1) {
        x = p2.x;
        y = p2.y;
      } else if (t > 0) {
        x += dx * t;
        y += dy * t;
      }
    }
    dx = p.x - x;
    dy = p.y - y;
    return sqDist ? dx * dx + dy * dy : new Point(x, y);
  }
  function isFlat(latlngs) {
    return !isArray(latlngs[0]) || typeof latlngs[0][0] !== "object" && typeof latlngs[0][0] !== "undefined";
  }
  function _flat(latlngs) {
    console.warn("Deprecated use of _flat, please use L.LineUtil.isFlat instead.");
    return isFlat(latlngs);
  }
  function polylineCenter(latlngs, crs) {
    var i, halfDist, segDist, dist, p1, p2, ratio, center;
    if (!latlngs || latlngs.length === 0) {
      throw new Error("latlngs not passed");
    }
    if (!isFlat(latlngs)) {
      console.warn("latlngs are not flat! Only the first ring will be used");
      latlngs = latlngs[0];
    }
    var centroidLatLng = toLatLng([0, 0]);
    var bounds = toLatLngBounds(latlngs);
    var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
    if (areaBounds < 1700) {
      centroidLatLng = centroid(latlngs);
    }
    var len = latlngs.length;
    var points = [];
    for (i = 0; i < len; i++) {
      var latlng = toLatLng(latlngs[i]);
      points.push(crs.project(toLatLng([latlng.lat - centroidLatLng.lat, latlng.lng - centroidLatLng.lng])));
    }
    for (i = 0, halfDist = 0; i < len - 1; i++) {
      halfDist += points[i].distanceTo(points[i + 1]) / 2;
    }
    if (halfDist === 0) {
      center = points[0];
    } else {
      for (i = 0, dist = 0; i < len - 1; i++) {
        p1 = points[i];
        p2 = points[i + 1];
        segDist = p1.distanceTo(p2);
        dist += segDist;
        if (dist > halfDist) {
          ratio = (dist - halfDist) / segDist;
          center = [
            p2.x - ratio * (p2.x - p1.x),
            p2.y - ratio * (p2.y - p1.y)
          ];
          break;
        }
      }
    }
    var latlngCenter = crs.unproject(toPoint(center));
    return toLatLng([latlngCenter.lat + centroidLatLng.lat, latlngCenter.lng + centroidLatLng.lng]);
  }
  var LineUtil = {
    __proto__: null,
    simplify,
    pointToSegmentDistance,
    closestPointOnSegment,
    clipSegment,
    _getEdgeIntersection,
    _getBitCode,
    _sqClosestPointOnSegment,
    isFlat,
    _flat,
    polylineCenter
  };
  var LonLat = {
    project: function(latlng) {
      return new Point(latlng.lng, latlng.lat);
    },
    unproject: function(point) {
      return new LatLng(point.y, point.x);
    },
    bounds: new Bounds([-180, -90], [180, 90])
  };
  var Mercator = {
    R: 6378137,
    R_MINOR: 6356752314245179e-9,
    bounds: new Bounds([-2003750834279e-5, -1549657073972e-5], [2003750834279e-5, 1876465623138e-5]),
    project: function(latlng) {
      var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
      var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
      y = -r * Math.log(Math.max(ts, 1e-10));
      return new Point(latlng.lng * d * r, y);
    },
    unproject: function(point) {
      var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
      for (var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++) {
        con = e * Math.sin(phi);
        con = Math.pow((1 - con) / (1 + con), e / 2);
        dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
        phi += dphi;
      }
      return new LatLng(phi * d, point.x * d / r);
    }
  };
  var index = {
    __proto__: null,
    LonLat,
    Mercator,
    SphericalMercator
  };
  var EPSG3395 = extend({}, Earth, {
    code: "EPSG:3395",
    projection: Mercator,
    transformation: (function() {
      var scale2 = 0.5 / (Math.PI * Mercator.R);
      return toTransformation(scale2, 0.5, -scale2, 0.5);
    })()
  });
  var EPSG4326 = extend({}, Earth, {
    code: "EPSG:4326",
    projection: LonLat,
    transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
  });
  var Simple = extend({}, CRS, {
    projection: LonLat,
    transformation: toTransformation(1, 0, -1, 0),
    scale: function(zoom2) {
      return Math.pow(2, zoom2);
    },
    zoom: function(scale2) {
      return Math.log(scale2) / Math.LN2;
    },
    distance: function(latlng1, latlng2) {
      var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
      return Math.sqrt(dx * dx + dy * dy);
    },
    infinite: true
  });
  CRS.Earth = Earth;
  CRS.EPSG3395 = EPSG3395;
  CRS.EPSG3857 = EPSG3857;
  CRS.EPSG900913 = EPSG900913;
  CRS.EPSG4326 = EPSG4326;
  CRS.Simple = Simple;
  var Layer = Evented.extend({
    // Classes extending `L.Layer` will inherit the following options:
    options: {
      // @option pane: String = 'overlayPane'
      // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
      pane: "overlayPane",
      // @option attribution: String = null
      // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
      attribution: null,
      bubblingMouseEvents: true
    },
    /* @section
     * Classes extending `L.Layer` will inherit the following methods:
     *
     * @method addTo(map: Map|LayerGroup): this
     * Adds the layer to the given map or layer group.
     */
    addTo: function(map) {
      map.addLayer(this);
      return this;
    },
    // @method remove: this
    // Removes the layer from the map it is currently active on.
    remove: function() {
      return this.removeFrom(this._map || this._mapToAdd);
    },
    // @method removeFrom(map: Map): this
    // Removes the layer from the given map
    //
    // @alternative
    // @method removeFrom(group: LayerGroup): this
    // Removes the layer from the given `LayerGroup`
    removeFrom: function(obj) {
      if (obj) {
        obj.removeLayer(this);
      }
      return this;
    },
    // @method getPane(name? : String): HTMLElement
    // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
    getPane: function(name) {
      return this._map.getPane(name ? this.options[name] || name : this.options.pane);
    },
    addInteractiveTarget: function(targetEl) {
      this._map._targets[stamp(targetEl)] = this;
      return this;
    },
    removeInteractiveTarget: function(targetEl) {
      delete this._map._targets[stamp(targetEl)];
      return this;
    },
    // @method getAttribution: String
    // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
    getAttribution: function() {
      return this.options.attribution;
    },
    _layerAdd: function(e) {
      var map = e.target;
      if (!map.hasLayer(this)) {
        return;
      }
      this._map = map;
      this._zoomAnimated = map._zoomAnimated;
      if (this.getEvents) {
        var events = this.getEvents();
        map.on(events, this);
        this.once("remove", function() {
          map.off(events, this);
        }, this);
      }
      this.onAdd(map);
      this.fire("add");
      map.fire("layeradd", { layer: this });
    }
  });
  Map.include({
    // @method addLayer(layer: Layer): this
    // Adds the given layer to the map
    addLayer: function(layer) {
      if (!layer._layerAdd) {
        throw new Error("The provided object is not a Layer.");
      }
      var id = stamp(layer);
      if (this._layers[id]) {
        return this;
      }
      this._layers[id] = layer;
      layer._mapToAdd = this;
      if (layer.beforeAdd) {
        layer.beforeAdd(this);
      }
      this.whenReady(layer._layerAdd, layer);
      return this;
    },
    // @method removeLayer(layer: Layer): this
    // Removes the given layer from the map.
    removeLayer: function(layer) {
      var id = stamp(layer);
      if (!this._layers[id]) {
        return this;
      }
      if (this._loaded) {
        layer.onRemove(this);
      }
      delete this._layers[id];
      if (this._loaded) {
        this.fire("layerremove", { layer });
        layer.fire("remove");
      }
      layer._map = layer._mapToAdd = null;
      return this;
    },
    // @method hasLayer(layer: Layer): Boolean
    // Returns `true` if the given layer is currently added to the map
    hasLayer: function(layer) {
      return stamp(layer) in this._layers;
    },
    /* @method eachLayer(fn: Function, context?: Object): this
     * Iterates over the layers of the map, optionally specifying context of the iterator function.
     * ```
     * map.eachLayer(function(layer){
     *     layer.bindPopup('Hello');
     * });
     * ```
     */
    eachLayer: function(method, context) {
      for (var i in this._layers) {
        method.call(context, this._layers[i]);
      }
      return this;
    },
    _addLayers: function(layers2) {
      layers2 = layers2 ? isArray(layers2) ? layers2 : [layers2] : [];
      for (var i = 0, len = layers2.length; i < len; i++) {
        this.addLayer(layers2[i]);
      }
    },
    _addZoomLimit: function(layer) {
      if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
        this._zoomBoundLayers[stamp(layer)] = layer;
        this._updateZoomLevels();
      }
    },
    _removeZoomLimit: function(layer) {
      var id = stamp(layer);
      if (this._zoomBoundLayers[id]) {
        delete this._zoomBoundLayers[id];
        this._updateZoomLevels();
      }
    },
    _updateZoomLevels: function() {
      var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
      for (var i in this._zoomBoundLayers) {
        var options = this._zoomBoundLayers[i].options;
        minZoom = options.minZoom === void 0 ? minZoom : Math.min(minZoom, options.minZoom);
        maxZoom = options.maxZoom === void 0 ? maxZoom : Math.max(maxZoom, options.maxZoom);
      }
      this._layersMaxZoom = maxZoom === -Infinity ? void 0 : maxZoom;
      this._layersMinZoom = minZoom === Infinity ? void 0 : minZoom;
      if (oldZoomSpan !== this._getZoomSpan()) {
        this.fire("zoomlevelschange");
      }
      if (this.options.maxZoom === void 0 && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) {
        this.setZoom(this._layersMaxZoom);
      }
      if (this.options.minZoom === void 0 && this._layersMinZoom && this.getZoom() < this._layersMinZoom) {
        this.setZoom(this._layersMinZoom);
      }
    }
  });
  var LayerGroup = Layer.extend({
    initialize: function(layers2, options) {
      setOptions(this, options);
      this._layers = {};
      var i, len;
      if (layers2) {
        for (i = 0, len = layers2.length; i < len; i++) {
          this.addLayer(layers2[i]);
        }
      }
    },
    // @method addLayer(layer: Layer): this
    // Adds the given layer to the group.
    addLayer: function(layer) {
      var id = this.getLayerId(layer);
      this._layers[id] = layer;
      if (this._map) {
        this._map.addLayer(layer);
      }
      return this;
    },
    // @method removeLayer(layer: Layer): this
    // Removes the given layer from the group.
    // @alternative
    // @method removeLayer(id: Number): this
    // Removes the layer with the given internal ID from the group.
    removeLayer: function(layer) {
      var id = layer in this._layers ? layer : this.getLayerId(layer);
      if (this._map && this._layers[id]) {
        this._map.removeLayer(this._layers[id]);
      }
      delete this._layers[id];
      return this;
    },
    // @method hasLayer(layer: Layer): Boolean
    // Returns `true` if the given layer is currently added to the group.
    // @alternative
    // @method hasLayer(id: Number): Boolean
    // Returns `true` if the given internal ID is currently added to the group.
    hasLayer: function(layer) {
      var layerId = typeof layer === "number" ? layer : this.getLayerId(layer);
      return layerId in this._layers;
    },
    // @method clearLayers(): this
    // Removes all the layers from the group.
    clearLayers: function() {
      return this.eachLayer(this.removeLayer, this);
    },
    // @method invoke(methodName: String, …): this
    // Calls `methodName` on every layer contained in this group, passing any
    // additional parameters. Has no effect if the layers contained do not
    // implement `methodName`.
    invoke: function(methodName) {
      var args = Array.prototype.slice.call(arguments, 1), i, layer;
      for (i in this._layers) {
        layer = this._layers[i];
        if (layer[methodName]) {
          layer[methodName].apply(layer, args);
        }
      }
      return this;
    },
    onAdd: function(map) {
      this.eachLayer(map.addLayer, map);
    },
    onRemove: function(map) {
      this.eachLayer(map.removeLayer, map);
    },
    // @method eachLayer(fn: Function, context?: Object): this
    // Iterates over the layers of the group, optionally specifying context of the iterator function.
    // ```js
    // group.eachLayer(function (layer) {
    // 	layer.bindPopup('Hello');
    // });
    // ```
    eachLayer: function(method, context) {
      for (var i in this._layers) {
        method.call(context, this._layers[i]);
      }
      return this;
    },
    // @method getLayer(id: Number): Layer
    // Returns the layer with the given internal ID.
    getLayer: function(id) {
      return this._layers[id];
    },
    // @method getLayers(): Layer[]
    // Returns an array of all the layers added to the group.
    getLayers: function() {
      var layers2 = [];
      this.eachLayer(layers2.push, layers2);
      return layers2;
    },
    // @method setZIndex(zIndex: Number): this
    // Calls `setZIndex` on every layer contained in this group, passing the z-index.
    setZIndex: function(zIndex) {
      return this.invoke("setZIndex", zIndex);
    },
    // @method getLayerId(layer: Layer): Number
    // Returns the internal ID for a layer
    getLayerId: function(layer) {
      return stamp(layer);
    }
  });
  var layerGroup = function(layers2, options) {
    return new LayerGroup(layers2, options);
  };
  var FeatureGroup = LayerGroup.extend({
    addLayer: function(layer) {
      if (this.hasLayer(layer)) {
        return this;
      }
      layer.addEventParent(this);
      LayerGroup.prototype.addLayer.call(this, layer);
      return this.fire("layeradd", { layer });
    },
    removeLayer: function(layer) {
      if (!this.hasLayer(layer)) {
        return this;
      }
      if (layer in this._layers) {
        layer = this._layers[layer];
      }
      layer.removeEventParent(this);
      LayerGroup.prototype.removeLayer.call(this, layer);
      return this.fire("layerremove", { layer });
    },
    // @method setStyle(style: Path options): this
    // Sets the given path options to each layer of the group that has a `setStyle` method.
    setStyle: function(style2) {
      return this.invoke("setStyle", style2);
    },
    // @method bringToFront(): this
    // Brings the layer group to the top of all other layers
    bringToFront: function() {
      return this.invoke("bringToFront");
    },
    // @method bringToBack(): this
    // Brings the layer group to the back of all other layers
    bringToBack: function() {
      return this.invoke("bringToBack");
    },
    // @method getBounds(): LatLngBounds
    // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
    getBounds: function() {
      var bounds = new LatLngBounds();
      for (var id in this._layers) {
        var layer = this._layers[id];
        bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
      }
      return bounds;
    }
  });
  var featureGroup = function(layers2, options) {
    return new FeatureGroup(layers2, options);
  };
  var Icon = Class.extend({
    /* @section
     * @aka Icon options
     *
     * @option iconUrl: String = null
     * **(required)** The URL to the icon image (absolute or relative to your script path).
     *
     * @option iconRetinaUrl: String = null
     * The URL to a retina sized version of the icon image (absolute or relative to your
     * script path). Used for Retina screen devices.
     *
     * @option iconSize: Point = null
     * Size of the icon image in pixels.
     *
     * @option iconAnchor: Point = null
     * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
     * will be aligned so that this point is at the marker's geographical location. Centered
     * by default if size is specified, also can be set in CSS with negative margins.
     *
     * @option popupAnchor: Point = [0, 0]
     * The coordinates of the point from which popups will "open", relative to the icon anchor.
     *
     * @option tooltipAnchor: Point = [0, 0]
     * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
     *
     * @option shadowUrl: String = null
     * The URL to the icon shadow image. If not specified, no shadow image will be created.
     *
     * @option shadowRetinaUrl: String = null
     *
     * @option shadowSize: Point = null
     * Size of the shadow image in pixels.
     *
     * @option shadowAnchor: Point = null
     * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
     * as iconAnchor if not specified).
     *
     * @option className: String = ''
     * A custom class name to assign to both icon and shadow images. Empty by default.
     */
    options: {
      popupAnchor: [0, 0],
      tooltipAnchor: [0, 0],
      // @option crossOrigin: Boolean|String = false
      // Whether the crossOrigin attribute will be added to the tiles.
      // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
      // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
      crossOrigin: false
    },
    initialize: function(options) {
      setOptions(this, options);
    },
    // @method createIcon(oldIcon?: HTMLElement): HTMLElement
    // Called internally when the icon has to be shown, returns a `<img>` HTML element
    // styled according to the options.
    createIcon: function(oldIcon) {
      return this._createIcon("icon", oldIcon);
    },
    // @method createShadow(oldIcon?: HTMLElement): HTMLElement
    // As `createIcon`, but for the shadow beneath it.
    createShadow: function(oldIcon) {
      return this._createIcon("shadow", oldIcon);
    },
    _createIcon: function(name, oldIcon) {
      var src = this._getIconUrl(name);
      if (!src) {
        if (name === "icon") {
          throw new Error("iconUrl not set in Icon options (see the docs).");
        }
        return null;
      }
      var img = this._createImg(src, oldIcon && oldIcon.tagName === "IMG" ? oldIcon : null);
      this._setIconStyles(img, name);
      if (this.options.crossOrigin || this.options.crossOrigin === "") {
        img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
      }
      return img;
    },
    _setIconStyles: function(img, name) {
      var options = this.options;
      var sizeOption = options[name + "Size"];
      if (typeof sizeOption === "number") {
        sizeOption = [sizeOption, sizeOption];
      }
      var size = toPoint(sizeOption), anchor = toPoint(name === "shadow" && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
      img.className = "L2DV-marker-" + name + " " + (options.className || "");
      if (anchor) {
        img.style.marginLeft = -anchor.x + "px";
        img.style.marginTop = -anchor.y + "px";
      }
      if (size) {
        img.style.width = size.x + "px";
        img.style.height = size.y + "px";
      }
    },
    _createImg: function(src, el) {
      el = el || document.createElement("img");
      el.src = src;
      return el;
    },
    _getIconUrl: function(name) {
      return Browser.retina && this.options[name + "RetinaUrl"] || this.options[name + "Url"];
    }
  });
  function icon(options) {
    return new Icon(options);
  }
  var IconDefault = Icon.extend({
    options: {
      iconUrl: "marker-icon.png",
      iconRetinaUrl: "marker-icon-2x.png",
      shadowUrl: "marker-shadow.png",
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      tooltipAnchor: [16, -28],
      shadowSize: [41, 41]
    },
    _getIconUrl: function(name) {
      if (typeof IconDefault.imagePath !== "string") {
        IconDefault.imagePath = this._detectIconPath();
      }
      return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
    },
    _stripUrl: function(path) {
      var strip = function(str, re, idx) {
        var match = re.exec(str);
        return match && match[idx];
      };
      path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
      return path && strip(path, /^(.*)marker-icon\.png$/, 1);
    },
    _detectIconPath: function() {
      var el = create$1("div", "L2DV-default-icon-path", document.body);
      var path = getStyle(el, "background-image") || getStyle(el, "backgroundImage");
      document.body.removeChild(el);
      path = this._stripUrl(path);
      if (path) {
        return path;
      }
      var link = document.querySelector('link[href$="L2DV.css"]');
      if (!link) {
        return "";
      }
      return link.href.substring(0, link.href.length - "L2DV.css".length - 1);
    }
  });
  var MarkerDrag = Handler.extend({
    initialize: function(marker2) {
      this._marker = marker2;
    },
    addHooks: function() {
      var icon2 = this._marker._icon;
      if (!this._draggable) {
        this._draggable = new Draggable(icon2, icon2, true);
      }
      this._draggable.on({
        dragstart: this._onDragStart,
        predrag: this._onPreDrag,
        drag: this._onDrag,
        dragend: this._onDragEnd
      }, this).enable();
      addClass(icon2, "L2DV-marker-draggable");
    },
    removeHooks: function() {
      this._draggable.off({
        dragstart: this._onDragStart,
        predrag: this._onPreDrag,
        drag: this._onDrag,
        dragend: this._onDragEnd
      }, this).disable();
      if (this._marker._icon) {
        removeClass(this._marker._icon, "L2DV-marker-draggable");
      }
    },
    moved: function() {
      return this._draggable && this._draggable._moved;
    },
    _adjustPan: function(e) {
      var marker2 = this._marker, map = marker2._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker2._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
      var panBounds = toBounds(
        bounds.min._subtract(origin).add(padding),
        bounds.max._subtract(origin).subtract(padding)
      );
      if (!panBounds.contains(iconPos)) {
        var movement = toPoint(
          (Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x),
          (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)
        ).multiplyBy(speed);
        map.panBy(movement, { animate: false });
        this._draggable._newPos._add(movement);
        this._draggable._startPos._add(movement);
        setPosition(marker2._icon, this._draggable._newPos);
        this._onDrag(e);
        this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
      }
    },
    _onDragStart: function() {
      this._oldLatLng = this._marker.getLatLng();
      this._marker.closePopup && this._marker.closePopup();
      this._marker.fire("movestart").fire("dragstart");
    },
    _onPreDrag: function(e) {
      if (this._marker.options.autoPan) {
        cancelAnimFrame(this._panRequest);
        this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
      }
    },
    _onDrag: function(e) {
      var marker2 = this._marker, shadow = marker2._shadow, iconPos = getPosition(marker2._icon), latlng = marker2._map.layerPointToLatLng(iconPos);
      if (shadow) {
        setPosition(shadow, iconPos);
      }
      marker2._latlng = latlng;
      e.latlng = latlng;
      e.oldLatLng = this._oldLatLng;
      marker2.fire("move", e).fire("drag", e);
    },
    _onDragEnd: function(e) {
      cancelAnimFrame(this._panRequest);
      delete this._oldLatLng;
      this._marker.fire("moveend").fire("dragend", e);
    }
  });
  var Marker = Layer.extend({
    // @section
    // @aka Marker options
    options: {
      // @option icon: Icon = *
      // Icon instance to use for rendering the marker.
      // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
      // If not specified, a common instance of `L.Icon.Default` is used.
      icon: new IconDefault(),
      // Option inherited from "Interactive layer" abstract class
      interactive: true,
      // @option keyboard: Boolean = true
      // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
      keyboard: true,
      // @option title: String = ''
      // Text for the browser tooltip that appear on marker hover (no tooltip by default).
      // [Useful for accessibility](https://L2DVjs.com/examples/accessibility/#markers-must-be-labelled).
      title: "",
      // @option alt: String = 'Marker'
      // Text for the `alt` attribute of the icon image.
      // [Useful for accessibility](https://L2DVjs.com/examples/accessibility/#markers-must-be-labelled).
      alt: "Marker",
      // @option zIndexOffset: Number = 0
      // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
      zIndexOffset: 0,
      // @option opacity: Number = 1.0
      // The opacity of the marker.
      opacity: 1,
      // @option riseOnHover: Boolean = false
      // If `true`, the marker will get on top of others when you hover the mouse over it.
      riseOnHover: false,
      // @option riseOffset: Number = 250
      // The z-index offset used for the `riseOnHover` feature.
      riseOffset: 250,
      // @option pane: String = 'markerPane'
      // `Map pane` where the markers icon will be added.
      pane: "markerPane",
      // @option shadowPane: String = 'shadowPane'
      // `Map pane` where the markers shadow will be added.
      shadowPane: "shadowPane",
      // @option bubblingMouseEvents: Boolean = false
      // When `true`, a mouse event on this marker will trigger the same event on the map
      // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
      bubblingMouseEvents: false,
      // @option autoPanOnFocus: Boolean = true
      // When `true`, the map will pan whenever the marker is focused (via
      // e.g. pressing `tab` on the keyboard) to ensure the marker is
      // visible within the map's bounds
      autoPanOnFocus: true,
      // @section Draggable marker options
      // @option draggable: Boolean = false
      // Whether the marker is draggable with mouse/touch or not.
      draggable: false,
      // @option autoPan: Boolean = false
      // Whether to pan the map when dragging this marker near its edge or not.
      autoPan: false,
      // @option autoPanPadding: Point = Point(50, 50)
      // Distance (in pixels to the left/right and to the top/bottom) of the
      // map edge to start panning the map.
      autoPanPadding: [50, 50],
      // @option autoPanSpeed: Number = 10
      // Number of pixels the map should pan by.
      autoPanSpeed: 10
    },
    /* @section
     *
     * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
     */
    initialize: function(latlng, options) {
      setOptions(this, options);
      this._latlng = toLatLng(latlng);
    },
    onAdd: function(map) {
      this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
      if (this._zoomAnimated) {
        map.on("zoomanim", this._animateZoom, this);
      }
      this._initIcon();
      this.update();
    },
    onRemove: function(map) {
      if (this.dragging && this.dragging.enabled()) {
        this.options.draggable = true;
        this.dragging.removeHooks();
      }
      delete this.dragging;
      if (this._zoomAnimated) {
        map.off("zoomanim", this._animateZoom, this);
      }
      this._removeIcon();
      this._removeShadow();
    },
    getEvents: function() {
      return {
        zoom: this.update,
        viewreset: this.update
      };
    },
    // @method getLatLng: LatLng
    // Returns the current geographical position of the marker.
    getLatLng: function() {
      return this._latlng;
    },
    // @method setLatLng(latlng: LatLng): this
    // Changes the marker position to the given point.
    setLatLng: function(latlng) {
      var oldLatLng = this._latlng;
      this._latlng = toLatLng(latlng);
      this.update();
      return this.fire("move", { oldLatLng, latlng: this._latlng });
    },
    // @method setZIndexOffset(offset: Number): this
    // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
    setZIndexOffset: function(offset) {
      this.options.zIndexOffset = offset;
      return this.update();
    },
    // @method getIcon: Icon
    // Returns the current icon used by the marker
    getIcon: function() {
      return this.options.icon;
    },
    // @method setIcon(icon: Icon): this
    // Changes the marker icon.
    setIcon: function(icon2) {
      this.options.icon = icon2;
      if (this._map) {
        this._initIcon();
        this.update();
      }
      if (this._popup) {
        this.bindPopup(this._popup, this._popup.options);
      }
      return this;
    },
    getElement: function() {
      return this._icon;
    },
    update: function() {
      if (this._icon && this._map) {
        var pos = this._map.latLngToLayerPoint(this._latlng).round();
        this._setPos(pos);
      }
      return this;
    },
    _initIcon: function() {
      var options = this.options, classToAdd = "L2DV-zoom-" + (this._zoomAnimated ? "animated" : "hide");
      var icon2 = options.icon.createIcon(this._icon), addIcon = false;
      if (icon2 !== this._icon) {
        if (this._icon) {
          this._removeIcon();
        }
        addIcon = true;
        if (options.title) {
          icon2.title = options.title;
        }
        if (icon2.tagName === "IMG") {
          icon2.alt = options.alt || "";
        }
      }
      addClass(icon2, classToAdd);
      if (options.keyboard) {
        icon2.tabIndex = "0";
        icon2.setAttribute("role", "button");
      }
      this._icon = icon2;
      if (options.riseOnHover) {
        this.on({
          mouseover: this._bringToFront,
          mouseout: this._resetZIndex
        });
      }
      if (this.options.autoPanOnFocus) {
        on(icon2, "focus", this._panOnFocus, this);
      }
      var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
      if (newShadow !== this._shadow) {
        this._removeShadow();
        addShadow = true;
      }
      if (newShadow) {
        addClass(newShadow, classToAdd);
        newShadow.alt = "";
      }
      this._shadow = newShadow;
      if (options.opacity < 1) {
        this._updateOpacity();
      }
      if (addIcon) {
        this.getPane().appendChild(this._icon);
      }
      this._initInteraction();
      if (newShadow && addShadow) {
        this.getPane(options.shadowPane).appendChild(this._shadow);
      }
    },
    _removeIcon: function() {
      if (this.options.riseOnHover) {
        this.off({
          mouseover: this._bringToFront,
          mouseout: this._resetZIndex
        });
      }
      if (this.options.autoPanOnFocus) {
        off(this._icon, "focus", this._panOnFocus, this);
      }
      remove(this._icon);
      this.removeInteractiveTarget(this._icon);
      this._icon = null;
    },
    _removeShadow: function() {
      if (this._shadow) {
        remove(this._shadow);
      }
      this._shadow = null;
    },
    _setPos: function(pos) {
      if (this._icon) {
        setPosition(this._icon, pos);
      }
      if (this._shadow) {
        setPosition(this._shadow, pos);
      }
      this._zIndex = pos.y + this.options.zIndexOffset;
      this._resetZIndex();
    },
    _updateZIndex: function(offset) {
      if (this._icon) {
        this._icon.style.zIndex = this._zIndex + offset;
      }
    },
    _animateZoom: function(opt) {
      var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
      this._setPos(pos);
    },
    _initInteraction: function() {
      if (!this.options.interactive) {
        return;
      }
      addClass(this._icon, "L2DV-interactive");
      this.addInteractiveTarget(this._icon);
      if (MarkerDrag) {
        var draggable = this.options.draggable;
        if (this.dragging) {
          draggable = this.dragging.enabled();
          this.dragging.disable();
        }
        this.dragging = new MarkerDrag(this);
        if (draggable) {
          this.dragging.enable();
        }
      }
    },
    // @method setOpacity(opacity: Number): this
    // Changes the opacity of the marker.
    setOpacity: function(opacity) {
      this.options.opacity = opacity;
      if (this._map) {
        this._updateOpacity();
      }
      return this;
    },
    _updateOpacity: function() {
      var opacity = this.options.opacity;
      if (this._icon) {
        setOpacity(this._icon, opacity);
      }
      if (this._shadow) {
        setOpacity(this._shadow, opacity);
      }
    },
    _bringToFront: function() {
      this._updateZIndex(this.options.riseOffset);
    },
    _resetZIndex: function() {
      this._updateZIndex(0);
    },
    _panOnFocus: function() {
      var map = this._map;
      if (!map) {
        return;
      }
      var iconOpts = this.options.icon.options;
      var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
      var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
      map.panInside(this._latlng, {
        paddingTopLeft: anchor,
        paddingBottomRight: size.subtract(anchor)
      });
    },
    _getPopupAnchor: function() {
      return this.options.icon.options.popupAnchor;
    },
    _getTooltipAnchor: function() {
      return this.options.icon.options.tooltipAnchor;
    }
  });
  function marker(latlng, options) {
    return new Marker(latlng, options);
  }
  var Path = Layer.extend({
    // @section
    // @aka Path options
    options: {
      // @option stroke: Boolean = true
      // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
      stroke: true,
      // @option color: String = '#3388ff'
      // Stroke color
      color: "#3388ff",
      // @option weight: Number = 3
      // Stroke width in pixels
      weight: 3,
      // @option opacity: Number = 1.0
      // Stroke opacity
      opacity: 1,
      // @option lineCap: String= 'round'
      // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
      lineCap: "round",
      // @option lineJoin: String = 'round'
      // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
      lineJoin: "round",
      // @option dashArray: String = null
      // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
      dashArray: null,
      // @option dashOffset: String = null
      // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
      dashOffset: null,
      // @option fill: Boolean = depends
      // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
      fill: false,
      // @option fillColor: String = *
      // Fill color. Defaults to the value of the [`color`](#path-color) option
      fillColor: null,
      // @option fillOpacity: Number = 0.2
      // Fill opacity.
      fillOpacity: 0.2,
      // @option fillRule: String = 'evenodd'
      // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
      fillRule: "evenodd",
      // className: '',
      // Option inherited from "Interactive layer" abstract class
      interactive: true,
      // @option bubblingMouseEvents: Boolean = true
      // When `true`, a mouse event on this path will trigger the same event on the map
      // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
      bubblingMouseEvents: true
    },
    beforeAdd: function(map) {
      this._renderer = map.getRenderer(this);
    },
    onAdd: function() {
      this._renderer._initPath(this);
      this._reset();
      this._renderer._addPath(this);
    },
    onRemove: function() {
      this._renderer._removePath(this);
    },
    // @method redraw(): this
    // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
    redraw: function() {
      if (this._map) {
        this._renderer._updatePath(this);
      }
      return this;
    },
    // @method setStyle(style: Path options): this
    // Changes the appearance of a Path based on the options in the `Path options` object.
    setStyle: function(style2) {
      setOptions(this, style2);
      if (this._renderer) {
        this._renderer._updateStyle(this);
        if (this.options.stroke && style2 && Object.prototype.hasOwnProperty.call(style2, "weight")) {
          this._updateBounds();
        }
      }
      return this;
    },
    // @method bringToFront(): this
    // Brings the layer to the top of all path layers.
    bringToFront: function() {
      if (this._renderer) {
        this._renderer._bringToFront(this);
      }
      return this;
    },
    // @method bringToBack(): this
    // Brings the layer to the bottom of all path layers.
    bringToBack: function() {
      if (this._renderer) {
        this._renderer._bringToBack(this);
      }
      return this;
    },
    getElement: function() {
      return this._path;
    },
    _reset: function() {
      this._project();
      this._update();
    },
    _clickTolerance: function() {
      return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
    }
  });
  var CircleMarker = Path.extend({
    // @section
    // @aka CircleMarker options
    options: {
      fill: true,
      // @option radius: Number = 10
      // Radius of the circle marker, in pixels
      radius: 10
    },
    initialize: function(latlng, options) {
      setOptions(this, options);
      this._latlng = toLatLng(latlng);
      this._radius = this.options.radius;
    },
    // @method setLatLng(latLng: LatLng): this
    // Sets the position of a circle marker to a new location.
    setLatLng: function(latlng) {
      var oldLatLng = this._latlng;
      this._latlng = toLatLng(latlng);
      this.redraw();
      return this.fire("move", { oldLatLng, latlng: this._latlng });
    },
    // @method getLatLng(): LatLng
    // Returns the current geographical position of the circle marker
    getLatLng: function() {
      return this._latlng;
    },
    // @method setRadius(radius: Number): this
    // Sets the radius of a circle marker. Units are in pixels.
    setRadius: function(radius) {
      this.options.radius = this._radius = radius;
      return this.redraw();
    },
    // @method getRadius(): Number
    // Returns the current radius of the circle
    getRadius: function() {
      return this._radius;
    },
    setStyle: function(options) {
      var radius = options && options.radius || this._radius;
      Path.prototype.setStyle.call(this, options);
      this.setRadius(radius);
      return this;
    },
    _project: function() {
      this._point = this._map.latLngToLayerPoint(this._latlng);
      this._updateBounds();
    },
    _updateBounds: function() {
      var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [r + w, r2 + w];
      this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
    },
    _update: function() {
      if (this._map) {
        this._updatePath();
      }
    },
    _updatePath: function() {
      this._renderer._updateCircle(this);
    },
    _empty: function() {
      return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
    },
    // Needed by the `Canvas` renderer for interactivity
    _containsPoint: function(p) {
      return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
    }
  });
  function circleMarker(latlng, options) {
    return new CircleMarker(latlng, options);
  }
  var Circle = CircleMarker.extend({
    initialize: function(latlng, options, legacyOptions) {
      if (typeof options === "number") {
        options = extend({}, legacyOptions, { radius: options });
      }
      setOptions(this, options);
      this._latlng = toLatLng(latlng);
      if (isNaN(this.options.radius)) {
        throw new Error("Circle radius cannot be NaN");
      }
      this._mRadius = this.options.radius;
    },
    // @method setRadius(radius: Number): this
    // Sets the radius of a circle. Units are in meters.
    setRadius: function(radius) {
      this._mRadius = radius;
      return this.redraw();
    },
    // @method getRadius(): Number
    // Returns the current radius of a circle. Units are in meters.
    getRadius: function() {
      return this._mRadius;
    },
    // @method getBounds(): LatLngBounds
    // Returns the `LatLngBounds` of the path.
    getBounds: function() {
      var half = [this._radius, this._radiusY || this._radius];
      return new LatLngBounds(
        this._map.layerPointToLatLng(this._point.subtract(half)),
        this._map.layerPointToLatLng(this._point.add(half))
      );
    },
    setStyle: Path.prototype.setStyle,
    _project: function() {
      var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
      if (crs.distance === Earth.distance) {
        var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([lat + latR, lng]), bottom = map.project([lat - latR, lng]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
        if (isNaN(lngR) || lngR === 0) {
          lngR = latR / Math.cos(Math.PI / 180 * lat);
        }
        this._point = p.subtract(map.getPixelOrigin());
        this._radius = isNaN(lngR) ? 0 : p.x - map.project([lat2, lng - lngR]).x;
        this._radiusY = p.y - top.y;
      } else {
        var latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));
        this._point = map.latLngToLayerPoint(this._latlng);
        this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
      }
      this._updateBounds();
    }
  });
  function circle(latlng, options, legacyOptions) {
    return new Circle(latlng, options, legacyOptions);
  }
  var Polyline = Path.extend({
    // @section
    // @aka Polyline options
    options: {
      // @option smoothFactor: Number = 1.0
      // How much to simplify the polyline on each zoom level. More means
      // better performance and smoother look, and less means more accurate representation.
      smoothFactor: 1,
      // @option noClip: Boolean = false
      // Disable polyline clipping.
      noClip: false
    },
    initialize: function(latlngs, options) {
      setOptions(this, options);
      this._setLatLngs(latlngs);
    },
    // @method getLatLngs(): LatLng[]
    // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
    getLatLngs: function() {
      return this._latlngs;
    },
    // @method setLatLngs(latlngs: LatLng[]): this
    // Replaces all the points in the polyline with the given array of geographical points.
    setLatLngs: function(latlngs) {
      this._setLatLngs(latlngs);
      return this.redraw();
    },
    // @method isEmpty(): Boolean
    // Returns `true` if the Polyline has no LatLngs.
    isEmpty: function() {
      return !this._latlngs.length;
    },
    // @method closestLayerPoint(p: Point): Point
    // Returns the point closest to `p` on the Polyline.
    closestLayerPoint: function(p) {
      var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
      for (var j = 0, jLen = this._parts.length; j < jLen; j++) {
        var points = this._parts[j];
        for (var i = 1, len = points.length; i < len; i++) {
          p1 = points[i - 1];
          p2 = points[i];
          var sqDist = closest(p, p1, p2, true);
          if (sqDist < minDistance) {
            minDistance = sqDist;
            minPoint = closest(p, p1, p2);
          }
        }
      }
      if (minPoint) {
        minPoint.distance = Math.sqrt(minDistance);
      }
      return minPoint;
    },
    // @method getCenter(): LatLng
    // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
    getCenter: function() {
      if (!this._map) {
        throw new Error("Must add layer to map before using getCenter()");
      }
      return polylineCenter(this._defaultShape(), this._map.options.crs);
    },
    // @method getBounds(): LatLngBounds
    // Returns the `LatLngBounds` of the path.
    getBounds: function() {
      return this._bounds;
    },
    // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
    // Adds a given point to the polyline. By default, adds to the first ring of
    // the polyline in case of a multi-polyline, but can be overridden by passing
    // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
    addLatLng: function(latlng, latlngs) {
      latlngs = latlngs || this._defaultShape();
      latlng = toLatLng(latlng);
      latlngs.push(latlng);
      this._bounds.extend(latlng);
      return this.redraw();
    },
    _setLatLngs: function(latlngs) {
      this._bounds = new LatLngBounds();
      this._latlngs = this._convertLatLngs(latlngs);
    },
    _defaultShape: function() {
      return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
    },
    // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
    _convertLatLngs: function(latlngs) {
      var result = [], flat = isFlat(latlngs);
      for (var i = 0, len = latlngs.length; i < len; i++) {
        if (flat) {
          result[i] = toLatLng(latlngs[i]);
          this._bounds.extend(result[i]);
        } else {
          result[i] = this._convertLatLngs(latlngs[i]);
        }
      }
      return result;
    },
    _project: function() {
      var pxBounds = new Bounds();
      this._rings = [];
      this._projectLatlngs(this._latlngs, this._rings, pxBounds);
      if (this._bounds.isValid() && pxBounds.isValid()) {
        this._rawPxBounds = pxBounds;
        this._updateBounds();
      }
    },
    _updateBounds: function() {
      var w = this._clickTolerance(), p = new Point(w, w);
      if (!this._rawPxBounds) {
        return;
      }
      this._pxBounds = new Bounds([
        this._rawPxBounds.min.subtract(p),
        this._rawPxBounds.max.add(p)
      ]);
    },
    // recursively turns latlngs into a set of rings with projected coordinates
    _projectLatlngs: function(latlngs, result, projectedBounds) {
      var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
      if (flat) {
        ring = [];
        for (i = 0; i < len; i++) {
          ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
          projectedBounds.extend(ring[i]);
        }
        result.push(ring);
      } else {
        for (i = 0; i < len; i++) {
          this._projectLatlngs(latlngs[i], result, projectedBounds);
        }
      }
    },
    // clip polyline by renderer bounds so that we have less to render for performance
    _clipPoints: function() {
      var bounds = this._renderer._bounds;
      this._parts = [];
      if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
        return;
      }
      if (this.options.noClip) {
        this._parts = this._rings;
        return;
      }
      var parts = this._parts, i, j, k, len, len2, segment, points;
      for (i = 0, k = 0, len = this._rings.length; i < len; i++) {
        points = this._rings[i];
        for (j = 0, len2 = points.length; j < len2 - 1; j++) {
          segment = clipSegment(points[j], points[j + 1], bounds, j, true);
          if (!segment) {
            continue;
          }
          parts[k] = parts[k] || [];
          parts[k].push(segment[0]);
          if (segment[1] !== points[j + 1] || j === len2 - 2) {
            parts[k].push(segment[1]);
            k++;
          }
        }
      }
    },
    // simplify each clipped part of the polyline for performance
    _simplifyPoints: function() {
      var parts = this._parts, tolerance = this.options.smoothFactor;
      for (var i = 0, len = parts.length; i < len; i++) {
        parts[i] = simplify(parts[i], tolerance);
      }
    },
    _update: function() {
      if (!this._map) {
        return;
      }
      this._clipPoints();
      this._simplifyPoints();
      this._updatePath();
    },
    _updatePath: function() {
      this._renderer._updatePoly(this);
    },
    // Needed by the `Canvas` renderer for interactivity
    _containsPoint: function(p, closed) {
      var i, j, k, len, len2, part, w = this._clickTolerance();
      if (!this._pxBounds || !this._pxBounds.contains(p)) {
        return false;
      }
      for (i = 0, len = this._parts.length; i < len; i++) {
        part = this._parts[i];
        for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
          if (!closed && j === 0) {
            continue;
          }
          if (pointToSegmentDistance(p, part[k], part[j]) <= w) {
            return true;
          }
        }
      }
      return false;
    }
  });
  function polyline(latlngs, options) {
    return new Polyline(latlngs, options);
  }
  Polyline._flat = _flat;
  var Polygon = Polyline.extend({
    options: {
      fill: true
    },
    isEmpty: function() {
      return !this._latlngs.length || !this._latlngs[0].length;
    },
    // @method getCenter(): LatLng
    // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
    getCenter: function() {
      if (!this._map) {
        throw new Error("Must add layer to map before using getCenter()");
      }
      return polygonCenter(this._defaultShape(), this._map.options.crs);
    },
    _convertLatLngs: function(latlngs) {
      var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
      if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) {
        result.pop();
      }
      return result;
    },
    _setLatLngs: function(latlngs) {
      Polyline.prototype._setLatLngs.call(this, latlngs);
      if (isFlat(this._latlngs)) {
        this._latlngs = [this._latlngs];
      }
    },
    _defaultShape: function() {
      return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
    },
    _clipPoints: function() {
      var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
      bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
      this._parts = [];
      if (!this._pxBounds || !this._pxBounds.intersects(bounds)) {
        return;
      }
      if (this.options.noClip) {
        this._parts = this._rings;
        return;
      }
      for (var i = 0, len = this._rings.length, clipped; i < len; i++) {
        clipped = clipPolygon(this._rings[i], bounds, true);
        if (clipped.length) {
          this._parts.push(clipped);
        }
      }
    },
    _updatePath: function() {
      this._renderer._updatePoly(this, true);
    },
    // Needed by the `Canvas` renderer for interactivity
    _containsPoint: function(p) {
      var inside = false, part, p1, p2, i, j, k, len, len2;
      if (!this._pxBounds || !this._pxBounds.contains(p)) {
        return false;
      }
      for (i = 0, len = this._parts.length; i < len; i++) {
        part = this._parts[i];
        for (j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++) {
          p1 = part[j];
          p2 = part[k];
          if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) {
            inside = !inside;
          }
        }
      }
      return inside || Polyline.prototype._containsPoint.call(this, p, true);
    }
  });
  function polygon(latlngs, options) {
    return new Polygon(latlngs, options);
  }
  var GeoJSON = FeatureGroup.extend({
    /* @section
     * @aka GeoJSON options
     *
     * @option pointToLayer: Function = *
     * A `Function` defining how GeoJSON points spawn L2DV layers. It is internally
     * called when data is added, passing the GeoJSON point feature and its `LatLng`.
     * The default is to spawn a default `Marker`:
     * ```js
     * function(geoJsonPoint, latlng) {
     * 	return L.marker(latlng);
     * }
     * ```
     *
     * @option style: Function = *
     * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
     * called internally when data is added.
     * The default value is to not override any defaults:
     * ```js
     * function (geoJsonFeature) {
     * 	return {}
     * }
     * ```
     *
     * @option onEachFeature: Function = *
     * A `Function` that will be called once for each created `Feature`, after it has
     * been created and styled. Useful for attaching events and popups to features.
     * The default is to do nothing with the newly created layers:
     * ```js
     * function (feature, layer) {}
     * ```
     *
     * @option filter: Function = *
     * A `Function` that will be used to decide whether to include a feature or not.
     * The default is to include all features:
     * ```js
     * function (geoJsonFeature) {
     * 	return true;
     * }
     * ```
     * Note: dynamically changing the `filter` option will have effect only on newly
     * added data. It will _not_ re-evaluate already included features.
     *
     * @option coordsToLatLng: Function = *
     * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
     * The default is the `coordsToLatLng` static method.
     *
     * @option markersInheritOptions: Boolean = false
     * Whether default Markers for "Point" type Features inherit from group options.
     */
    initialize: function(geojson, options) {
      setOptions(this, options);
      this._layers = {};
      if (geojson) {
        this.addData(geojson);
      }
    },
    // @method addData( <GeoJSON> data ): this
    // Adds a GeoJSON object to the layer.
    addData: function(geojson) {
      var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
      if (features) {
        for (i = 0, len = features.length; i < len; i++) {
          feature = features[i];
          if (feature.geometries || feature.geometry || feature.features || feature.coordinates) {
            this.addData(feature);
          }
        }
        return this;
      }
      var options = this.options;
      if (options.filter && !options.filter(geojson)) {
        return this;
      }
      var layer = geometryToLayer(geojson, options);
      if (!layer) {
        return this;
      }
      layer.feature = asFeature(geojson);
      layer.defaultOptions = layer.options;
      this.resetStyle(layer);
      if (options.onEachFeature) {
        options.onEachFeature(geojson, layer);
      }
      return this.addLayer(layer);
    },
    // @method resetStyle( <Path> layer? ): this
    // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
    // If `layer` is omitted, the style of all features in the current layer is reset.
    resetStyle: function(layer) {
      if (layer === void 0) {
        return this.eachLayer(this.resetStyle, this);
      }
      layer.options = extend({}, layer.defaultOptions);
      this._setLayerStyle(layer, this.options.style);
      return this;
    },
    // @method setStyle( <Function> style ): this
    // Changes styles of GeoJSON vector layers with the given style function.
    setStyle: function(style2) {
      return this.eachLayer(function(layer) {
        this._setLayerStyle(layer, style2);
      }, this);
    },
    _setLayerStyle: function(layer, style2) {
      if (layer.setStyle) {
        if (typeof style2 === "function") {
          style2 = style2(layer.feature);
        }
        layer.setStyle(style2);
      }
    }
  });
  function geometryToLayer(geojson, options) {
    var geometry = geojson.type === "Feature" ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers2 = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
    if (!coords && !geometry) {
      return null;
    }
    switch (geometry.type) {
      case "Point":
        latlng = _coordsToLatLng(coords);
        return _pointToLayer(pointToLayer, geojson, latlng, options);
      case "MultiPoint":
        for (i = 0, len = coords.length; i < len; i++) {
          latlng = _coordsToLatLng(coords[i]);
          layers2.push(_pointToLayer(pointToLayer, geojson, latlng, options));
        }
        return new FeatureGroup(layers2);
      case "LineString":
      case "MultiLineString":
        latlngs = coordsToLatLngs(coords, geometry.type === "LineString" ? 0 : 1, _coordsToLatLng);
        return new Polyline(latlngs, options);
      case "Polygon":
      case "MultiPolygon":
        latlngs = coordsToLatLngs(coords, geometry.type === "Polygon" ? 1 : 2, _coordsToLatLng);
        return new Polygon(latlngs, options);
      case "GeometryCollection":
        for (i = 0, len = geometry.geometries.length; i < len; i++) {
          var geoLayer = geometryToLayer({
            geometry: geometry.geometries[i],
            type: "Feature",
            properties: geojson.properties
          }, options);
          if (geoLayer) {
            layers2.push(geoLayer);
          }
        }
        return new FeatureGroup(layers2);
      case "FeatureCollection":
        for (i = 0, len = geometry.features.length; i < len; i++) {
          var featureLayer = geometryToLayer(geometry.features[i], options);
          if (featureLayer) {
            layers2.push(featureLayer);
          }
        }
        return new FeatureGroup(layers2);
      default:
        throw new Error("Invalid GeoJSON object.");
    }
  }
  function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
    return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
  }
  function coordsToLatLng(coords) {
    return new LatLng(coords[1], coords[0], coords[2]);
  }
  function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
    var latlngs = [];
    for (var i = 0, len = coords.length, latlng; i < len; i++) {
      latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
      latlngs.push(latlng);
    }
    return latlngs;
  }
  function latLngToCoords(latlng, precision) {
    latlng = toLatLng(latlng);
    return latlng.alt !== void 0 ? [formatNum(latlng.lng, precision), formatNum(latlng.lat, precision), formatNum(latlng.alt, precision)] : [formatNum(latlng.lng, precision), formatNum(latlng.lat, precision)];
  }
  function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
    var coords = [];
    for (var i = 0, len = latlngs.length; i < len; i++) {
      coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
    }
    if (!levelsDeep && closed && coords.length > 0) {
      coords.push(coords[0].slice());
    }
    return coords;
  }
  function getFeature(layer, newGeometry) {
    return layer.feature ? extend({}, layer.feature, { geometry: newGeometry }) : asFeature(newGeometry);
  }
  function asFeature(geojson) {
    if (geojson.type === "Feature" || geojson.type === "FeatureCollection") {
      return geojson;
    }
    return {
      type: "Feature",
      properties: {},
      geometry: geojson
    };
  }
  var PointToGeoJSON = {
    toGeoJSON: function(precision) {
      return getFeature(this, {
        type: "Point",
        coordinates: latLngToCoords(this.getLatLng(), precision)
      });
    }
  };
  Marker.include(PointToGeoJSON);
  Circle.include(PointToGeoJSON);
  CircleMarker.include(PointToGeoJSON);
  Polyline.include({
    toGeoJSON: function(precision) {
      var multi = !isFlat(this._latlngs);
      var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
      return getFeature(this, {
        type: (multi ? "Multi" : "") + "LineString",
        coordinates: coords
      });
    }
  });
  Polygon.include({
    toGeoJSON: function(precision) {
      var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
      var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
      if (!holes) {
        coords = [coords];
      }
      return getFeature(this, {
        type: (multi ? "Multi" : "") + "Polygon",
        coordinates: coords
      });
    }
  });
  LayerGroup.include({
    toMultiPoint: function(precision) {
      var coords = [];
      this.eachLayer(function(layer) {
        coords.push(layer.toGeoJSON(precision).geometry.coordinates);
      });
      return getFeature(this, {
        type: "MultiPoint",
        coordinates: coords
      });
    },
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
    toGeoJSON: function(precision) {
      var type = this.feature && this.feature.geometry && this.feature.geometry.type;
      if (type === "MultiPoint") {
        return this.toMultiPoint(precision);
      }
      var isGeometryCollection = type === "GeometryCollection", jsons = [];
      this.eachLayer(function(layer) {
        if (layer.toGeoJSON) {
          var json = layer.toGeoJSON(precision);
          if (isGeometryCollection) {
            jsons.push(json.geometry);
          } else {
            var feature = asFeature(json);
            if (feature.type === "FeatureCollection") {
              jsons.push.apply(jsons, feature.features);
            } else {
              jsons.push(feature);
            }
          }
        }
      });
      if (isGeometryCollection) {
        return getFeature(this, {
          geometries: jsons,
          type: "GeometryCollection"
        });
      }
      return {
        type: "FeatureCollection",
        features: jsons
      };
    }
  });
  function geoJSON(geojson, options) {
    return new GeoJSON(geojson, options);
  }
  var geoJson = geoJSON;
  var ImageOverlay = Layer.extend({
    // @section
    // @aka ImageOverlay options
    options: {
      // @option opacity: Number = 1.0
      // The opacity of the image overlay.
      opacity: 1,
      // @option alt: String = ''
      // Text for the `alt` attribute of the image (useful for accessibility).
      alt: "",
      // @option interactive: Boolean = false
      // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
      interactive: false,
      // @option crossOrigin: Boolean|String = false
      // Whether the crossOrigin attribute will be added to the image.
      // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
      // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
      crossOrigin: false,
      // @option errorOverlayUrl: String = ''
      // URL to the overlay image to show in place of the overlay that failed to load.
      errorOverlayUrl: "",
      // @option zIndex: Number = 1
      // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
      zIndex: 1,
      // @option className: String = ''
      // A custom class name to assign to the image. Empty by default.
      className: ""
    },
    initialize: function(url, bounds, options) {
      this._url = url;
      this._bounds = toLatLngBounds(bounds);
      setOptions(this, options);
    },
    onAdd: function() {
      if (!this._image) {
        this._initImage();
        if (this.options.opacity < 1) {
          this._updateOpacity();
        }
      }
      if (this.options.interactive) {
        addClass(this._image, "L2DV-interactive");
        this.addInteractiveTarget(this._image);
      }
      this.getPane().appendChild(this._image);
      this._reset();
    },
    onRemove: function() {
      remove(this._image);
      if (this.options.interactive) {
        this.removeInteractiveTarget(this._image);
      }
    },
    // @method setOpacity(opacity: Number): this
    // Sets the opacity of the overlay.
    setOpacity: function(opacity) {
      this.options.opacity = opacity;
      if (this._image) {
        this._updateOpacity();
      }
      return this;
    },
    setStyle: function(styleOpts) {
      if (styleOpts.opacity) {
        this.setOpacity(styleOpts.opacity);
      }
      return this;
    },
    // @method bringToFront(): this
    // Brings the layer to the top of all overlays.
    bringToFront: function() {
      if (this._map) {
        toFront(this._image);
      }
      return this;
    },
    // @method bringToBack(): this
    // Brings the layer to the bottom of all overlays.
    bringToBack: function() {
      if (this._map) {
        toBack(this._image);
      }
      return this;
    },
    // @method setUrl(url: String): this
    // Changes the URL of the image.
    setUrl: function(url) {
      this._url = url;
      if (this._image) {
        this._image.src = url;
      }
      return this;
    },
    // @method setBounds(bounds: LatLngBounds): this
    // Update the bounds that this ImageOverlay covers
    setBounds: function(bounds) {
      this._bounds = toLatLngBounds(bounds);
      if (this._map) {
        this._reset();
      }
      return this;
    },
    getEvents: function() {
      var events = {
        zoom: this._reset,
        viewreset: this._reset
      };
      if (this._zoomAnimated) {
        events.zoomanim = this._animateZoom;
      }
      return events;
    },
    // @method setZIndex(value: Number): this
    // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
    setZIndex: function(value) {
      this.options.zIndex = value;
      this._updateZIndex();
      return this;
    },
    // @method getBounds(): LatLngBounds
    // Get the bounds that this ImageOverlay covers
    getBounds: function() {
      return this._bounds;
    },
    // @method getElement(): HTMLElement
    // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
    // used by this overlay.
    getElement: function() {
      return this._image;
    },
    _initImage: function() {
      var wasElementSupplied = this._url.tagName === "IMG";
      var img = this._image = wasElementSupplied ? this._url : create$1("img");
      addClass(img, "L2DV-image-layer");
      if (this._zoomAnimated) {
        addClass(img, "L2DV-zoom-animated");
      }
      if (this.options.className) {
        addClass(img, this.options.className);
      }
      img.onselectstart = falseFn;
      img.onmousemove = falseFn;
      img.onload = bind(this.fire, this, "load");
      img.onerror = bind(this._overlayOnError, this, "error");
      if (this.options.crossOrigin || this.options.crossOrigin === "") {
        img.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
      }
      if (this.options.zIndex) {
        this._updateZIndex();
      }
      if (wasElementSupplied) {
        this._url = img.src;
        return;
      }
      img.src = this._url;
      img.alt = this.options.alt;
    },
    _animateZoom: function(e) {
      var scale2 = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
      setTransform(this._image, offset, scale2);
    },
    _reset: function() {
      var image = this._image, bounds = new Bounds(
        this._map.latLngToLayerPoint(this._bounds.getNorthWest()),
        this._map.latLngToLayerPoint(this._bounds.getSouthEast())
      ), size = bounds.getSize();
      setPosition(image, bounds.min);
      image.style.width = size.x + "px";
      image.style.height = size.y + "px";
    },
    _updateOpacity: function() {
      setOpacity(this._image, this.options.opacity);
    },
    _updateZIndex: function() {
      if (this._image && this.options.zIndex !== void 0 && this.options.zIndex !== null) {
        this._image.style.zIndex = this.options.zIndex;
      }
    },
    _overlayOnError: function() {
      this.fire("error");
      var errorUrl = this.options.errorOverlayUrl;
      if (errorUrl && this._url !== errorUrl) {
        this._url = errorUrl;
        this._image.src = errorUrl;
      }
    },
    // @method getCenter(): LatLng
    // Returns the center of the ImageOverlay.
    getCenter: function() {
      return this._bounds.getCenter();
    }
  });
  var imageOverlay = function(url, bounds, options) {
    return new ImageOverlay(url, bounds, options);
  };
  var VideoOverlay = ImageOverlay.extend({
    // @section
    // @aka VideoOverlay options
    options: {
      // @option autoplay: Boolean = true
      // Whether the video starts playing automatically when loaded.
      // On some browsers autoplay will only work with `muted: true`
      autoplay: true,
      // @option loop: Boolean = true
      // Whether the video will loop back to the beginning when played.
      loop: true,
      // @option keepAspectRatio: Boolean = true
      // Whether the video will save aspect ratio after the projection.
      // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
      keepAspectRatio: true,
      // @option muted: Boolean = false
      // Whether the video starts on mute when loaded.
      muted: false,
      // @option playsInline: Boolean = true
      // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
      playsInline: true
    },
    _initImage: function() {
      var wasElementSupplied = this._url.tagName === "VIDEO";
      var vid = this._image = wasElementSupplied ? this._url : create$1("video");
      addClass(vid, "L2DV-image-layer");
      if (this._zoomAnimated) {
        addClass(vid, "L2DV-zoom-animated");
      }
      if (this.options.className) {
        addClass(vid, this.options.className);
      }
      vid.onselectstart = falseFn;
      vid.onmousemove = falseFn;
      vid.onloadeddata = bind(this.fire, this, "load");
      if (wasElementSupplied) {
        var sourceElements = vid.getElementsByTagName("source");
        var sources = [];
        for (var j = 0; j < sourceElements.length; j++) {
          sources.push(sourceElements[j].src);
        }
        this._url = sourceElements.length > 0 ? sources : [vid.src];
        return;
      }
      if (!isArray(this._url)) {
        this._url = [this._url];
      }
      if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, "objectFit")) {
        vid.style["objectFit"] = "fill";
      }
      vid.autoplay = !!this.options.autoplay;
      vid.loop = !!this.options.loop;
      vid.muted = !!this.options.muted;
      vid.playsInline = !!this.options.playsInline;
      for (var i = 0; i < this._url.length; i++) {
        var source = create$1("source");
        source.src = this._url[i];
        vid.appendChild(source);
      }
    }
    // @method getElement(): HTMLVideoElement
    // Returns the instance of [`HTMLVideoElement`](https://developer.mozilla.org/docs/Web/API/HTMLVideoElement)
    // used by this overlay.
  });
  function videoOverlay(video, bounds, options) {
    return new VideoOverlay(video, bounds, options);
  }
  var SVGOverlay = ImageOverlay.extend({
    _initImage: function() {
      var el = this._image = this._url;
      addClass(el, "L2DV-image-layer");
      if (this._zoomAnimated) {
        addClass(el, "L2DV-zoom-animated");
      }
      if (this.options.className) {
        addClass(el, this.options.className);
      }
      el.onselectstart = falseFn;
      el.onmousemove = falseFn;
    }
    // @method getElement(): SVGElement
    // Returns the instance of [`SVGElement`](https://developer.mozilla.org/docs/Web/API/SVGElement)
    // used by this overlay.
  });
  function svgOverlay(el, bounds, options) {
    return new SVGOverlay(el, bounds, options);
  }
  var DivOverlay = Layer.extend({
    // @section
    // @aka DivOverlay options
    options: {
      // @option interactive: Boolean = false
      // If true, the popup/tooltip will listen to the mouse events.
      interactive: false,
      // @option offset: Point = Point(0, 0)
      // The offset of the overlay position.
      offset: [0, 0],
      // @option className: String = ''
      // A custom CSS class name to assign to the overlay.
      className: "",
      // @option pane: String = undefined
      // `Map pane` where the overlay will be added.
      pane: void 0,
      // @option content: String|HTMLElement|Function = ''
      // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
      // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
      content: ""
    },
    initialize: function(options, source) {
      if (options && (options instanceof LatLng || isArray(options))) {
        this._latlng = toLatLng(options);
        setOptions(this, source);
      } else {
        setOptions(this, options);
        this._source = source;
      }
      if (this.options.content) {
        this._content = this.options.content;
      }
    },
    // @method openOn(map: Map): this
    // Adds the overlay to the map.
    // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
    openOn: function(map) {
      map = arguments.length ? map : this._source._map;
      if (!map.hasLayer(this)) {
        map.addLayer(this);
      }
      return this;
    },
    // @method close(): this
    // Closes the overlay.
    // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
    // and `layer.closePopup()`/`.closeTooltip()`.
    close: function() {
      if (this._map) {
        this._map.removeLayer(this);
      }
      return this;
    },
    // @method toggle(layer?: Layer): this
    // Opens or closes the overlay bound to layer depending on its current state.
    // Argument may be omitted only for overlay bound to layer.
    // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
    toggle: function(layer) {
      if (this._map) {
        this.close();
      } else {
        if (arguments.length) {
          this._source = layer;
        } else {
          layer = this._source;
        }
        this._prepareOpen();
        this.openOn(layer._map);
      }
      return this;
    },
    onAdd: function(map) {
      this._zoomAnimated = map._zoomAnimated;
      if (!this._container) {
        this._initLayout();
      }
      if (map._fadeAnimated) {
        setOpacity(this._container, 0);
      }
      clearTimeout(this._removeTimeout);
      this.getPane().appendChild(this._container);
      this.update();
      if (map._fadeAnimated) {
        setOpacity(this._container, 1);
      }
      this.bringToFront();
      if (this.options.interactive) {
        addClass(this._container, "L2DV-interactive");
        this.addInteractiveTarget(this._container);
      }
    },
    onRemove: function(map) {
      if (map._fadeAnimated) {
        setOpacity(this._container, 0);
        this._removeTimeout = setTimeout(bind(remove, void 0, this._container), 200);
      } else {
        remove(this._container);
      }
      if (this.options.interactive) {
        removeClass(this._container, "L2DV-interactive");
        this.removeInteractiveTarget(this._container);
      }
    },
    // @namespace DivOverlay
    // @method getLatLng: LatLng
    // Returns the geographical point of the overlay.
    getLatLng: function() {
      return this._latlng;
    },
    // @method setLatLng(latlng: LatLng): this
    // Sets the geographical point where the overlay will open.
    setLatLng: function(latlng) {
      this._latlng = toLatLng(latlng);
      if (this._map) {
        this._updatePosition();
        this._adjustPan();
      }
      return this;
    },
    // @method getContent: String|HTMLElement
    // Returns the content of the overlay.
    getContent: function() {
      return this._content;
    },
    // @method setContent(htmlContent: String|HTMLElement|Function): this
    // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
    // The function should return a `String` or `HTMLElement` to be used in the overlay.
    setContent: function(content) {
      this._content = content;
      this.update();
      return this;
    },
    // @method getElement: String|HTMLElement
    // Returns the HTML container of the overlay.
    getElement: function() {
      return this._container;
    },
    // @method update: null
    // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
    update: function() {
      if (!this._map) {
        return;
      }
      this._container.style.visibility = "hidden";
      this._updateContent();
      this._updateLayout();
      this._updatePosition();
      this._container.style.visibility = "";
      this._adjustPan();
    },
    getEvents: function() {
      var events = {
        zoom: this._updatePosition,
        viewreset: this._updatePosition
      };
      if (this._zoomAnimated) {
        events.zoomanim = this._animateZoom;
      }
      return events;
    },
    // @method isOpen: Boolean
    // Returns `true` when the overlay is visible on the map.
    isOpen: function() {
      return !!this._map && this._map.hasLayer(this);
    },
    // @method bringToFront: this
    // Brings this overlay in front of other overlays (in the same map pane).
    bringToFront: function() {
      if (this._map) {
        toFront(this._container);
      }
      return this;
    },
    // @method bringToBack: this
    // Brings this overlay to the back of other overlays (in the same map pane).
    bringToBack: function() {
      if (this._map) {
        toBack(this._container);
      }
      return this;
    },
    // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
    _prepareOpen: function(latlng) {
      var source = this._source;
      if (!source._map) {
        return false;
      }
      if (source instanceof FeatureGroup) {
        source = null;
        var layers2 = this._source._layers;
        for (var id in layers2) {
          if (layers2[id]._map) {
            source = layers2[id];
            break;
          }
        }
        if (!source) {
          return false;
        }
        this._source = source;
      }
      if (!latlng) {
        if (source.getCenter) {
          latlng = source.getCenter();
        } else if (source.getLatLng) {
          latlng = source.getLatLng();
        } else if (source.getBounds) {
          latlng = source.getBounds().getCenter();
        } else {
          throw new Error("Unable to get source layer LatLng.");
        }
      }
      this.setLatLng(latlng);
      if (this._map) {
        this.update();
      }
      return true;
    },
    _updateContent: function() {
      if (!this._content) {
        return;
      }
      var node = this._contentNode;
      var content = typeof this._content === "function" ? this._content(this._source || this) : this._content;
      if (typeof content === "string") {
        node.innerHTML = content;
      } else {
        while (node.hasChildNodes()) {
          node.removeChild(node.firstChild);
        }
        node.appendChild(content);
      }
      this.fire("contentupdate");
    },
    _updatePosition: function() {
      if (!this._map) {
        return;
      }
      var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
      if (this._zoomAnimated) {
        setPosition(this._container, pos.add(anchor));
      } else {
        offset = offset.add(pos).add(anchor);
      }
      var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
      this._container.style.bottom = bottom + "px";
      this._container.style.left = left + "px";
    },
    _getAnchor: function() {
      return [0, 0];
    }
  });
  Map.include({
    _initOverlay: function(OverlayClass, content, latlng, options) {
      var overlay = content;
      if (!(overlay instanceof OverlayClass)) {
        overlay = new OverlayClass(options).setContent(content);
      }
      if (latlng) {
        overlay.setLatLng(latlng);
      }
      return overlay;
    }
  });
  Layer.include({
    _initOverlay: function(OverlayClass, old, content, options) {
      var overlay = content;
      if (overlay instanceof OverlayClass) {
        setOptions(overlay, options);
        overlay._source = this;
      } else {
        overlay = old && !options ? old : new OverlayClass(options, this);
        overlay.setContent(content);
      }
      return overlay;
    }
  });
  var Popup = DivOverlay.extend({
    // @section
    // @aka Popup options
    options: {
      // @option pane: String = 'popupPane'
      // `Map pane` where the popup will be added.
      pane: "popupPane",
      // @option offset: Point = Point(0, 7)
      // The offset of the popup position.
      offset: [0, 7],
      // @option maxWidth: Number = 300
      // Max width of the popup, in pixels.
      maxWidth: 300,
      // @option minWidth: Number = 50
      // Min width of the popup, in pixels.
      minWidth: 50,
      // @option maxHeight: Number = null
      // If set, creates a scrollable container of the given height
      // inside a popup if its content exceeds it.
      // The scrollable container can be styled using the
      // `L2DV-popup-scrolled` CSS class selector.
      maxHeight: null,
      // @option autoPan: Boolean = true
      // Set it to `false` if you don't want the map to do panning animation
      // to fit the opened popup.
      autoPan: true,
      // @option autoPanPaddingTopLeft: Point = null
      // The margin between the popup and the top left corner of the map
      // view after autopanning was performed.
      autoPanPaddingTopLeft: null,
      // @option autoPanPaddingBottomRight: Point = null
      // The margin between the popup and the bottom right corner of the map
      // view after autopanning was performed.
      autoPanPaddingBottomRight: null,
      // @option autoPanPadding: Point = Point(5, 5)
      // Equivalent of setting both top left and bottom right autopan padding to the same value.
      autoPanPadding: [5, 5],
      // @option keepInView: Boolean = false
      // Set it to `true` if you want to prevent users from panning the popup
      // off of the screen while it is open.
      keepInView: false,
      // @option closeButton: Boolean = true
      // Controls the presence of a close button in the popup.
      closeButton: true,
      // @option autoClose: Boolean = true
      // Set it to `false` if you want to override the default behavior of
      // the popup closing when another popup is opened.
      autoClose: true,
      // @option closeOnEscapeKey: Boolean = true
      // Set it to `false` if you want to override the default behavior of
      // the ESC key for closing of the popup.
      closeOnEscapeKey: true,
      // @option closeOnClick: Boolean = *
      // Set it if you want to override the default behavior of the popup closing when user clicks
      // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
      // @option className: String = ''
      // A custom CSS class name to assign to the popup.
      className: ""
    },
    // @namespace Popup
    // @method openOn(map: Map): this
    // Alternative to `map.openPopup(popup)`.
    // Adds the popup to the map and closes the previous one.
    openOn: function(map) {
      map = arguments.length ? map : this._source._map;
      if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) {
        map.removeLayer(map._popup);
      }
      map._popup = this;
      return DivOverlay.prototype.openOn.call(this, map);
    },
    onAdd: function(map) {
      DivOverlay.prototype.onAdd.call(this, map);
      map.fire("popupopen", { popup: this });
      if (this._source) {
        this._source.fire("popupopen", { popup: this }, true);
        if (!(this._source instanceof Path)) {
          this._source.on("preclick", stopPropagation);
        }
      }
    },
    onRemove: function(map) {
      DivOverlay.prototype.onRemove.call(this, map);
      map.fire("popupclose", { popup: this });
      if (this._source) {
        this._source.fire("popupclose", { popup: this }, true);
        if (!(this._source instanceof Path)) {
          this._source.off("preclick", stopPropagation);
        }
      }
    },
    getEvents: function() {
      var events = DivOverlay.prototype.getEvents.call(this);
      if (this.options.closeOnClick !== void 0 ? this.options.closeOnClick : this._map.options.closePopupOnClick) {
        events.preclick = this.close;
      }
      if (this.options.keepInView) {
        events.moveend = this._adjustPan;
      }
      return events;
    },
    _initLayout: function() {
      var prefix = "L2DV-popup", container = this._container = create$1(
        "div",
        prefix + " " + (this.options.className || "") + " L2DV-zoom-animated"
      );
      var wrapper = this._wrapper = create$1("div", prefix + "-content-wrapper", container);
      this._contentNode = create$1("div", prefix + "-content", wrapper);
      disableClickPropagation(container);
      disableScrollPropagation(this._contentNode);
      on(container, "contextmenu", stopPropagation);
      this._tipContainer = create$1("div", prefix + "-tip-container", container);
      this._tip = create$1("div", prefix + "-tip", this._tipContainer);
      if (this.options.closeButton) {
        var closeButton = this._closeButton = create$1("a", prefix + "-close-button", container);
        closeButton.setAttribute("role", "button");
        closeButton.setAttribute("aria-label", "Close popup");
        closeButton.href = "#close";
        closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
        on(closeButton, "click", function(ev) {
          preventDefault(ev);
          this.close();
        }, this);
      }
    },
    _updateLayout: function() {
      var container = this._contentNode, style2 = container.style;
      style2.width = "";
      style2.whiteSpace = "nowrap";
      var width = container.offsetWidth;
      width = Math.min(width, this.options.maxWidth);
      width = Math.max(width, this.options.minWidth);
      style2.width = width + 1 + "px";
      style2.whiteSpace = "";
      style2.height = "";
      var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = "L2DV-popup-scrolled";
      if (maxHeight && height > maxHeight) {
        style2.height = maxHeight + "px";
        addClass(container, scrolledClass);
      } else {
        removeClass(container, scrolledClass);
      }
      this._containerWidth = this._container.offsetWidth;
    },
    _animateZoom: function(e) {
      var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
      setPosition(this._container, pos.add(anchor));
    },
    _adjustPan: function() {
      if (!this.options.autoPan) {
        return;
      }
      if (this._map._panAnim) {
        this._map._panAnim.stop();
      }
      if (this._autopanning) {
        this._autopanning = false;
        return;
      }
      var map = this._map, marginBottom = parseInt(getStyle(this._container, "marginBottom"), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
      layerPos._add(getPosition(this._container));
      var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
      if (containerPos.x + containerWidth + paddingBR.x > size.x) {
        dx = containerPos.x + containerWidth - size.x + paddingBR.x;
      }
      if (containerPos.x - dx - paddingTL.x < 0) {
        dx = containerPos.x - paddingTL.x;
      }
      if (containerPos.y + containerHeight + paddingBR.y > size.y) {
        dy = containerPos.y + containerHeight - size.y + paddingBR.y;
      }
      if (containerPos.y - dy - paddingTL.y < 0) {
        dy = containerPos.y - paddingTL.y;
      }
      if (dx || dy) {
        if (this.options.keepInView) {
          this._autopanning = true;
        }
        map.fire("autopanstart").panBy([dx, dy]);
      }
    },
    _getAnchor: function() {
      return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [0, 0]);
    }
  });
  var popup = function(options, source) {
    return new Popup(options, source);
  };
  Map.mergeOptions({
    closePopupOnClick: true
  });
  Map.include({
    // @method openPopup(popup: Popup): this
    // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
    // @alternative
    // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
    // Creates a popup with the specified content and options and opens it in the given point on a map.
    openPopup: function(popup2, latlng, options) {
      this._initOverlay(Popup, popup2, latlng, options).openOn(this);
      return this;
    },
    // @method closePopup(popup?: Popup): this
    // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
    closePopup: function(popup2) {
      popup2 = arguments.length ? popup2 : this._popup;
      if (popup2) {
        popup2.close();
      }
      return this;
    }
  });
  Layer.include({
    // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
    // Binds a popup to the layer with the passed `content` and sets up the
    // necessary event listeners. If a `Function` is passed it will receive
    // the layer as the first argument and should return a `String` or `HTMLElement`.
    bindPopup: function(content, options) {
      this._popup = this._initOverlay(Popup, this._popup, content, options);
      if (!this._popupHandlersAdded) {
        this.on({
          click: this._openPopup,
          keypress: this._onKeyPress,
          remove: this.closePopup,
          move: this._movePopup
        });
        this._popupHandlersAdded = true;
      }
      return this;
    },
    // @method unbindPopup(): this
    // Removes the popup previously bound with `bindPopup`.
    unbindPopup: function() {
      if (this._popup) {
        this.off({
          click: this._openPopup,
          keypress: this._onKeyPress,
          remove: this.closePopup,
          move: this._movePopup
        });
        this._popupHandlersAdded = false;
        this._popup = null;
      }
      return this;
    },
    // @method openPopup(latlng?: LatLng): this
    // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
    openPopup: function(latlng) {
      if (this._popup) {
        if (!(this instanceof FeatureGroup)) {
          this._popup._source = this;
        }
        if (this._popup._prepareOpen(latlng || this._latlng)) {
          this._popup.openOn(this._map);
        }
      }
      return this;
    },
    // @method closePopup(): this
    // Closes the popup bound to this layer if it is open.
    closePopup: function() {
      if (this._popup) {
        this._popup.close();
      }
      return this;
    },
    // @method togglePopup(): this
    // Opens or closes the popup bound to this layer depending on its current state.
    togglePopup: function() {
      if (this._popup) {
        this._popup.toggle(this);
      }
      return this;
    },
    // @method isPopupOpen(): boolean
    // Returns `true` if the popup bound to this layer is currently open.
    isPopupOpen: function() {
      return this._popup ? this._popup.isOpen() : false;
    },
    // @method setPopupContent(content: String|HTMLElement|Popup): this
    // Sets the content of the popup bound to this layer.
    setPopupContent: function(content) {
      if (this._popup) {
        this._popup.setContent(content);
      }
      return this;
    },
    // @method getPopup(): Popup
    // Returns the popup bound to this layer.
    getPopup: function() {
      return this._popup;
    },
    _openPopup: function(e) {
      if (!this._popup || !this._map) {
        return;
      }
      stop(e);
      var target = e.layer || e.target;
      if (this._popup._source === target && !(target instanceof Path)) {
        if (this._map.hasLayer(this._popup)) {
          this.closePopup();
        } else {
          this.openPopup(e.latlng);
        }
        return;
      }
      this._popup._source = target;
      this.openPopup(e.latlng);
    },
    _movePopup: function(e) {
      this._popup.setLatLng(e.latlng);
    },
    _onKeyPress: function(e) {
      if (e.originalEvent.keyCode === 13) {
        this._openPopup(e);
      }
    }
  });
  var Tooltip = DivOverlay.extend({
    // @section
    // @aka Tooltip options
    options: {
      // @option pane: String = 'tooltipPane'
      // `Map pane` where the tooltip will be added.
      pane: "tooltipPane",
      // @option offset: Point = Point(0, 0)
      // Optional offset of the tooltip position.
      offset: [0, 0],
      // @option direction: String = 'auto'
      // Direction where to open the tooltip. Possible values are: `right`, `left`,
      // `top`, `bottom`, `center`, `auto`.
      // `auto` will dynamically switch between `right` and `left` according to the tooltip
      // position on the map.
      direction: "auto",
      // @option permanent: Boolean = false
      // Whether to open the tooltip permanently or only on mouseover.
      permanent: false,
      // @option sticky: Boolean = false
      // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
      sticky: false,
      // @option opacity: Number = 0.9
      // Tooltip container opacity.
      opacity: 0.9
    },
    onAdd: function(map) {
      DivOverlay.prototype.onAdd.call(this, map);
      this.setOpacity(this.options.opacity);
      map.fire("tooltipopen", { tooltip: this });
      if (this._source) {
        this.addEventParent(this._source);
        this._source.fire("tooltipopen", { tooltip: this }, true);
      }
    },
    onRemove: function(map) {
      DivOverlay.prototype.onRemove.call(this, map);
      map.fire("tooltipclose", { tooltip: this });
      if (this._source) {
        this.removeEventParent(this._source);
        this._source.fire("tooltipclose", { tooltip: this }, true);
      }
    },
    getEvents: function() {
      var events = DivOverlay.prototype.getEvents.call(this);
      if (!this.options.permanent) {
        events.preclick = this.close;
      }
      return events;
    },
    _initLayout: function() {
      var prefix = "L2DV-tooltip", className = prefix + " " + (this.options.className || "") + " L2DV-zoom-" + (this._zoomAnimated ? "animated" : "hide");
      this._contentNode = this._container = create$1("div", className);
      this._container.setAttribute("role", "tooltip");
      this._container.setAttribute("id", "L2DV-tooltip-" + stamp(this));
    },
    _updateLayout: function() {
    },
    _adjustPan: function() {
    },
    _setPosition: function(pos) {
      var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
      if (direction === "top") {
        subX = tooltipWidth / 2;
        subY = tooltipHeight;
      } else if (direction === "bottom") {
        subX = tooltipWidth / 2;
        subY = 0;
      } else if (direction === "center") {
        subX = tooltipWidth / 2;
        subY = tooltipHeight / 2;
      } else if (direction === "right") {
        subX = 0;
        subY = tooltipHeight / 2;
      } else if (direction === "left") {
        subX = tooltipWidth;
        subY = tooltipHeight / 2;
      } else if (tooltipPoint.x < centerPoint.x) {
        direction = "right";
        subX = 0;
        subY = tooltipHeight / 2;
      } else {
        direction = "left";
        subX = tooltipWidth + (offset.x + anchor.x) * 2;
        subY = tooltipHeight / 2;
      }
      pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
      removeClass(container, "L2DV-tooltip-right");
      removeClass(container, "L2DV-tooltip-left");
      removeClass(container, "L2DV-tooltip-top");
      removeClass(container, "L2DV-tooltip-bottom");
      addClass(container, "L2DV-tooltip-" + direction);
      setPosition(container, pos);
    },
    _updatePosition: function() {
      var pos = this._map.latLngToLayerPoint(this._latlng);
      this._setPosition(pos);
    },
    setOpacity: function(opacity) {
      this.options.opacity = opacity;
      if (this._container) {
        setOpacity(this._container, opacity);
      }
    },
    _animateZoom: function(e) {
      var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
      this._setPosition(pos);
    },
    _getAnchor: function() {
      return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [0, 0]);
    }
  });
  var tooltip = function(options, source) {
    return new Tooltip(options, source);
  };
  Map.include({
    // @method openTooltip(tooltip: Tooltip): this
    // Opens the specified tooltip.
    // @alternative
    // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
    // Creates a tooltip with the specified content and options and open it.
    openTooltip: function(tooltip2, latlng, options) {
      this._initOverlay(Tooltip, tooltip2, latlng, options).openOn(this);
      return this;
    },
    // @method closeTooltip(tooltip: Tooltip): this
    // Closes the tooltip given as parameter.
    closeTooltip: function(tooltip2) {
      tooltip2.close();
      return this;
    }
  });
  Layer.include({
    // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
    // Binds a tooltip to the layer with the passed `content` and sets up the
    // necessary event listeners. If a `Function` is passed it will receive
    // the layer as the first argument and should return a `String` or `HTMLElement`.
    bindTooltip: function(content, options) {
      if (this._tooltip && this.isTooltipOpen()) {
        this.unbindTooltip();
      }
      this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
      this._initTooltipInteractions();
      if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) {
        this.openTooltip();
      }
      return this;
    },
    // @method unbindTooltip(): this
    // Removes the tooltip previously bound with `bindTooltip`.
    unbindTooltip: function() {
      if (this._tooltip) {
        this._initTooltipInteractions(true);
        this.closeTooltip();
        this._tooltip = null;
      }
      return this;
    },
    _initTooltipInteractions: function(remove2) {
      if (!remove2 && this._tooltipHandlersAdded) {
        return;
      }
      var onOff = remove2 ? "off" : "on", events = {
        remove: this.closeTooltip,
        move: this._moveTooltip
      };
      if (!this._tooltip.options.permanent) {
        events.mouseover = this._openTooltip;
        events.mouseout = this.closeTooltip;
        events.click = this._openTooltip;
        if (this._map) {
          this._addFocusListeners();
        } else {
          events.add = this._addFocusListeners;
        }
      } else {
        events.add = this._openTooltip;
      }
      if (this._tooltip.options.sticky) {
        events.mousemove = this._moveTooltip;
      }
      this[onOff](events);
      this._tooltipHandlersAdded = !remove2;
    },
    // @method openTooltip(latlng?: LatLng): this
    // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
    openTooltip: function(latlng) {
      if (this._tooltip) {
        if (!(this instanceof FeatureGroup)) {
          this._tooltip._source = this;
        }
        if (this._tooltip._prepareOpen(latlng)) {
          this._tooltip.openOn(this._map);
          if (this.getElement) {
            this._setAriaDescribedByOnLayer(this);
          } else if (this.eachLayer) {
            this.eachLayer(this._setAriaDescribedByOnLayer, this);
          }
        }
      }
      return this;
    },
    // @method closeTooltip(): this
    // Closes the tooltip bound to this layer if it is open.
    closeTooltip: function() {
      if (this._tooltip) {
        return this._tooltip.close();
      }
    },
    // @method toggleTooltip(): this
    // Opens or closes the tooltip bound to this layer depending on its current state.
    toggleTooltip: function() {
      if (this._tooltip) {
        this._tooltip.toggle(this);
      }
      return this;
    },
    // @method isTooltipOpen(): boolean
    // Returns `true` if the tooltip bound to this layer is currently open.
    isTooltipOpen: function() {
      return this._tooltip.isOpen();
    },
    // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
    // Sets the content of the tooltip bound to this layer.
    setTooltipContent: function(content) {
      if (this._tooltip) {
        this._tooltip.setContent(content);
      }
      return this;
    },
    // @method getTooltip(): Tooltip
    // Returns the tooltip bound to this layer.
    getTooltip: function() {
      return this._tooltip;
    },
    _addFocusListeners: function() {
      if (this.getElement) {
        this._addFocusListenersOnLayer(this);
      } else if (this.eachLayer) {
        this.eachLayer(this._addFocusListenersOnLayer, this);
      }
    },
    _addFocusListenersOnLayer: function(layer) {
      var el = typeof layer.getElement === "function" && layer.getElement();
      if (el) {
        on(el, "focus", function() {
          this._tooltip._source = layer;
          this.openTooltip();
        }, this);
        on(el, "blur", this.closeTooltip, this);
      }
    },
    _setAriaDescribedByOnLayer: function(layer) {
      var el = typeof layer.getElement === "function" && layer.getElement();
      if (el) {
        el.setAttribute("aria-describedby", this._tooltip._container.id);
      }
    },
    _openTooltip: function(e) {
      if (!this._tooltip || !this._map) {
        return;
      }
      if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
        this._openOnceFlag = true;
        var that = this;
        this._map.once("moveend", function() {
          that._openOnceFlag = false;
          that._openTooltip(e);
        });
        return;
      }
      this._tooltip._source = e.layer || e.target;
      this.openTooltip(this._tooltip.options.sticky ? e.latlng : void 0);
    },
    _moveTooltip: function(e) {
      var latlng = e.latlng, containerPoint, layerPoint;
      if (this._tooltip.options.sticky && e.originalEvent) {
        containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
        layerPoint = this._map.containerPointToLayerPoint(containerPoint);
        latlng = this._map.layerPointToLatLng(layerPoint);
      }
      this._tooltip.setLatLng(latlng);
    }
  });
  var DivIcon = Icon.extend({
    options: {
      // @section
      // @aka DivIcon options
      iconSize: [12, 12],
      // also can be set through CSS
      // iconAnchor: (Point),
      // popupAnchor: (Point),
      // @option html: String|HTMLElement = ''
      // Custom HTML code to put inside the div element, empty by default. Alternatively,
      // an instance of `HTMLElement`.
      html: false,
      // @option bgPos: Point = [0, 0]
      // Optional relative position of the background, in pixels
      bgPos: null,
      className: "L2DV-div-icon"
    },
    createIcon: function(oldIcon) {
      var div = oldIcon && oldIcon.tagName === "DIV" ? oldIcon : document.createElement("div"), options = this.options;
      if (options.html instanceof Element) {
        empty(div);
        div.appendChild(options.html);
      } else {
        div.innerHTML = options.html !== false ? options.html : "";
      }
      if (options.bgPos) {
        var bgPos = toPoint(options.bgPos);
        div.style.backgroundPosition = -bgPos.x + "px " + -bgPos.y + "px";
      }
      this._setIconStyles(div, "icon");
      return div;
    },
    createShadow: function() {
      return null;
    }
  });
  function divIcon(options) {
    return new DivIcon(options);
  }
  Icon.Default = IconDefault;
  var GridLayer = Layer.extend({
    // @section
    // @aka GridLayer options
    options: {
      // @option tileSize: Number|Point = 256
      // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
      tileSize: 256,
      // @option opacity: Number = 1.0
      // Opacity of the tiles. Can be used in the `createTile()` function.
      opacity: 1,
      // @option updateWhenIdle: Boolean = (depends)
      // Load new tiles only when panning ends.
      // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
      // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
      // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
      updateWhenIdle: Browser.mobile,
      // @option updateWhenZooming: Boolean = true
      // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
      updateWhenZooming: true,
      // @option updateInterval: Number = 200
      // Tiles will not update more than once every `updateInterval` milliseconds when panning.
      updateInterval: 200,
      // @option zIndex: Number = 1
      // The explicit zIndex of the tile layer.
      zIndex: 1,
      // @option bounds: LatLngBounds = undefined
      // If set, tiles will only be loaded inside the set `LatLngBounds`.
      bounds: null,
      // @option minZoom: Number = 0
      // The minimum zoom level down to which this layer will be displayed (inclusive).
      minZoom: 0,
      // @option maxZoom: Number = undefined
      // The maximum zoom level up to which this layer will be displayed (inclusive).
      maxZoom: void 0,
      // @option maxNativeZoom: Number = undefined
      // Maximum zoom number the tile source has available. If it is specified,
      // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
      // from `maxNativeZoom` level and auto-scaled.
      maxNativeZoom: void 0,
      // @option minNativeZoom: Number = undefined
      // Minimum zoom number the tile source has available. If it is specified,
      // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
      // from `minNativeZoom` level and auto-scaled.
      minNativeZoom: void 0,
      // @option noWrap: Boolean = false
      // Whether the layer is wrapped around the antimeridian. If `true`, the
      // GridLayer will only be displayed once at low zoom levels. Has no
      // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
      // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
      // tiles outside the CRS limits.
      noWrap: false,
      // @option pane: String = 'tilePane'
      // `Map pane` where the grid layer will be added.
      pane: "tilePane",
      // @option className: String = ''
      // A custom class name to assign to the tile layer. Empty by default.
      className: "",
      // @option keepBuffer: Number = 2
      // When panning the map, keep this many rows and columns of tiles before unloading them.
      keepBuffer: 2
    },
    initialize: function(options) {
      setOptions(this, options);
    },
    onAdd: function() {
      this._initContainer();
      this._levels = {};
      this._tiles = {};
      this._resetView();
    },
    beforeAdd: function(map) {
      map._addZoomLimit(this);
    },
    onRemove: function(map) {
      this._removeAllTiles();
      remove(this._container);
      map._removeZoomLimit(this);
      this._container = null;
      this._tileZoom = void 0;
    },
    // @method bringToFront: this
    // Brings the tile layer to the top of all tile layers.
    bringToFront: function() {
      if (this._map) {
        toFront(this._container);
        this._setAutoZIndex(Math.max);
      }
      return this;
    },
    // @method bringToBack: this
    // Brings the tile layer to the bottom of all tile layers.
    bringToBack: function() {
      if (this._map) {
        toBack(this._container);
        this._setAutoZIndex(Math.min);
      }
      return this;
    },
    // @method getContainer: HTMLElement
    // Returns the HTML element that contains the tiles for this layer.
    getContainer: function() {
      return this._container;
    },
    // @method setOpacity(opacity: Number): this
    // Changes the [opacity](#gridlayer-opacity) of the grid layer.
    setOpacity: function(opacity) {
      this.options.opacity = opacity;
      this._updateOpacity();
      return this;
    },
    // @method setZIndex(zIndex: Number): this
    // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
    setZIndex: function(zIndex) {
      this.options.zIndex = zIndex;
      this._updateZIndex();
      return this;
    },
    // @method isLoading: Boolean
    // Returns `true` if any tile in the grid layer has not finished loading.
    isLoading: function() {
      return this._loading;
    },
    // @method redraw: this
    // Causes the layer to clear all the tiles and request them again.
    redraw: function() {
      if (this._map) {
        this._removeAllTiles();
        var tileZoom = this._clampZoom(this._map.getZoom());
        if (tileZoom !== this._tileZoom) {
          this._tileZoom = tileZoom;
          this._updateLevels();
        }
        this._update();
      }
      return this;
    },
    getEvents: function() {
      var events = {
        viewprereset: this._invalidateAll,
        viewreset: this._resetView,
        zoom: this._resetView,
        moveend: this._onMoveEnd
      };
      if (!this.options.updateWhenIdle) {
        if (!this._onMove) {
          this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
        }
        events.move = this._onMove;
      }
      if (this._zoomAnimated) {
        events.zoomanim = this._animateZoom;
      }
      return events;
    },
    // @section Extension methods
    // Layers extending `GridLayer` shall reimplement the following method.
    // @method createTile(coords: Object, done?: Function): HTMLElement
    // Called only internally, must be overridden by classes extending `GridLayer`.
    // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
    // is specified, it must be called when the tile has finished loading and drawing.
    createTile: function() {
      return document.createElement("div");
    },
    // @section
    // @method getTileSize: Point
    // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
    getTileSize: function() {
      var s = this.options.tileSize;
      return s instanceof Point ? s : new Point(s, s);
    },
    _updateZIndex: function() {
      if (this._container && this.options.zIndex !== void 0 && this.options.zIndex !== null) {
        this._container.style.zIndex = this.options.zIndex;
      }
    },
    _setAutoZIndex: function(compare) {
      var layers2 = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity);
      for (var i = 0, len = layers2.length, zIndex; i < len; i++) {
        zIndex = layers2[i].style.zIndex;
        if (layers2[i] !== this._container && zIndex) {
          edgeZIndex = compare(edgeZIndex, +zIndex);
        }
      }
      if (isFinite(edgeZIndex)) {
        this.options.zIndex = edgeZIndex + compare(-1, 1);
        this._updateZIndex();
      }
    },
    _updateOpacity: function() {
      if (!this._map) {
        return;
      }
      if (Browser.ielt9) {
        return;
      }
      setOpacity(this._container, this.options.opacity);
      var now = +/* @__PURE__ */ new Date(), nextFrame = false, willPrune = false;
      for (var key in this._tiles) {
        var tile = this._tiles[key];
        if (!tile.current || !tile.loaded) {
          continue;
        }
        var fade = Math.min(1, (now - tile.loaded) / 200);
        setOpacity(tile.el, fade);
        if (fade < 1) {
          nextFrame = true;
        } else {
          if (tile.active) {
            willPrune = true;
          } else {
            this._onOpaqueTile(tile);
          }
          tile.active = true;
        }
      }
      if (willPrune && !this._noPrune) {
        this._pruneTiles();
      }
      if (nextFrame) {
        cancelAnimFrame(this._fadeFrame);
        this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
      }
    },
    _onOpaqueTile: falseFn,
    _initContainer: function() {
      if (this._container) {
        return;
      }
      this._container = create$1("div", "L2DV-layer " + (this.options.className || ""));
      this._updateZIndex();
      if (this.options.opacity < 1) {
        this._updateOpacity();
      }
      this.getPane().appendChild(this._container);
    },
    _updateLevels: function() {
      var zoom2 = this._tileZoom, maxZoom = this.options.maxZoom;
      if (zoom2 === void 0) {
        return void 0;
      }
      for (var z in this._levels) {
        z = Number(z);
        if (this._levels[z].el.children.length || z === zoom2) {
          this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom2 - z);
          this._onUpdateLevel(z);
        } else {
          remove(this._levels[z].el);
          this._removeTilesAtZoom(z);
          this._onRemoveLevel(z);
          delete this._levels[z];
        }
      }
      var level = this._levels[zoom2], map = this._map;
      if (!level) {
        level = this._levels[zoom2] = {};
        level.el = create$1("div", "L2DV-tile-container L2DV-zoom-animated", this._container);
        level.el.style.zIndex = maxZoom;
        level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom2).round();
        level.zoom = zoom2;
        this._setZoomTransform(level, map.getCenter(), map.getZoom());
        falseFn(level.el.offsetWidth);
        this._onCreateLevel(level);
      }
      this._level = level;
      return level;
    },
    _onUpdateLevel: falseFn,
    _onRemoveLevel: falseFn,
    _onCreateLevel: falseFn,
    _pruneTiles: function() {
      if (!this._map) {
        return;
      }
      var key, tile;
      var zoom2 = this._map.getZoom();
      if (zoom2 > this.options.maxZoom || zoom2 < this.options.minZoom) {
        this._removeAllTiles();
        return;
      }
      for (key in this._tiles) {
        tile = this._tiles[key];
        tile.retain = tile.current;
      }
      for (key in this._tiles) {
        tile = this._tiles[key];
        if (tile.current && !tile.active) {
          var coords = tile.coords;
          if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) {
            this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
          }
        }
      }
      for (key in this._tiles) {
        if (!this._tiles[key].retain) {
          this._removeTile(key);
        }
      }
    },
    _removeTilesAtZoom: function(zoom2) {
      for (var key in this._tiles) {
        if (this._tiles[key].coords.z !== zoom2) {
          continue;
        }
        this._removeTile(key);
      }
    },
    _removeAllTiles: function() {
      for (var key in this._tiles) {
        this._removeTile(key);
      }
    },
    _invalidateAll: function() {
      for (var z in this._levels) {
        remove(this._levels[z].el);
        this._onRemoveLevel(Number(z));
        delete this._levels[z];
      }
      this._removeAllTiles();
      this._tileZoom = void 0;
    },
    _retainParent: function(x, y, z, minZoom) {
      var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
      coords2.z = +z2;
      var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
      if (tile && tile.active) {
        tile.retain = true;
        return true;
      } else if (tile && tile.loaded) {
        tile.retain = true;
      }
      if (z2 > minZoom) {
        return this._retainParent(x2, y2, z2, minZoom);
      }
      return false;
    },
    _retainChildren: function(x, y, z, maxZoom) {
      for (var i = 2 * x; i < 2 * x + 2; i++) {
        for (var j = 2 * y; j < 2 * y + 2; j++) {
          var coords = new Point(i, j);
          coords.z = z + 1;
          var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
          if (tile && tile.active) {
            tile.retain = true;
            continue;
          } else if (tile && tile.loaded) {
            tile.retain = true;
          }
          if (z + 1 < maxZoom) {
            this._retainChildren(i, j, z + 1, maxZoom);
          }
        }
      }
    },
    _resetView: function(e) {
      var animating = e && (e.pinch || e.flyTo);
      this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
    },
    _animateZoom: function(e) {
      this._setView(e.center, e.zoom, true, e.noUpdate);
    },
    _clampZoom: function(zoom2) {
      var options = this.options;
      if (void 0 !== options.minNativeZoom && zoom2 < options.minNativeZoom) {
        return options.minNativeZoom;
      }
      if (void 0 !== options.maxNativeZoom && options.maxNativeZoom < zoom2) {
        return options.maxNativeZoom;
      }
      return zoom2;
    },
    _setView: function(center, zoom2, noPrune, noUpdate) {
      var tileZoom = Math.round(zoom2);
      if (this.options.maxZoom !== void 0 && tileZoom > this.options.maxZoom || this.options.minZoom !== void 0 && tileZoom < this.options.minZoom) {
        tileZoom = void 0;
      } else {
        tileZoom = this._clampZoom(tileZoom);
      }
      var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
      if (!noUpdate || tileZoomChanged) {
        this._tileZoom = tileZoom;
        if (this._abortLoading) {
          this._abortLoading();
        }
        this._updateLevels();
        this._resetGrid();
        if (tileZoom !== void 0) {
          this._update(center);
        }
        if (!noPrune) {
          this._pruneTiles();
        }
        this._noPrune = !!noPrune;
      }
      this._setZoomTransforms(center, zoom2);
    },
    _setZoomTransforms: function(center, zoom2) {
      for (var i in this._levels) {
        this._setZoomTransform(this._levels[i], center, zoom2);
      }
    },
    _setZoomTransform: function(level, center, zoom2) {
      var scale2 = this._map.getZoomScale(zoom2, level.zoom), translate = level.origin.multiplyBy(scale2).subtract(this._map._getNewPixelOrigin(center, zoom2)).round();
      if (Browser.any3d) {
        setTransform(level.el, translate, scale2);
      } else {
        setPosition(level.el, translate);
      }
    },
    _resetGrid: function() {
      var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
      var bounds = this._map.getPixelWorldBounds(this._tileZoom);
      if (bounds) {
        this._globalTileRange = this._pxBoundsToTileRange(bounds);
      }
      this._wrapX = crs.wrapLng && !this.options.noWrap && [
        Math.floor(map.project([0, crs.wrapLng[0]], tileZoom).x / tileSize.x),
        Math.ceil(map.project([0, crs.wrapLng[1]], tileZoom).x / tileSize.y)
      ];
      this._wrapY = crs.wrapLat && !this.options.noWrap && [
        Math.floor(map.project([crs.wrapLat[0], 0], tileZoom).y / tileSize.x),
        Math.ceil(map.project([crs.wrapLat[1], 0], tileZoom).y / tileSize.y)
      ];
    },
    _onMoveEnd: function() {
      if (!this._map || this._map._animatingZoom) {
        return;
      }
      this._update();
    },
    _getTiledPixelBounds: function(center) {
      var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale2 = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale2 * 2);
      return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
    },
    // Private method to load tiles in the grid's active zoom level according to map bounds
    _update: function(center) {
      var map = this._map;
      if (!map) {
        return;
      }
      var zoom2 = this._clampZoom(map.getZoom());
      if (center === void 0) {
        center = map.getCenter();
      }
      if (this._tileZoom === void 0) {
        return;
      }
      var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(
        tileRange.getBottomLeft().subtract([margin, -margin]),
        tileRange.getTopRight().add([margin, -margin])
      );
      if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) {
        throw new Error("Attempted to load an infinite number of tiles");
      }
      for (var key in this._tiles) {
        var c = this._tiles[key].coords;
        if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) {
          this._tiles[key].current = false;
        }
      }
      if (Math.abs(zoom2 - this._tileZoom) > 1) {
        this._setView(center, zoom2);
        return;
      }
      for (var j = tileRange.min.y; j <= tileRange.max.y; j++) {
        for (var i = tileRange.min.x; i <= tileRange.max.x; i++) {
          var coords = new Point(i, j);
          coords.z = this._tileZoom;
          if (!this._isValidTile(coords)) {
            continue;
          }
          var tile = this._tiles[this._tileCoordsToKey(coords)];
          if (tile) {
            tile.current = true;
          } else {
            queue.push(coords);
          }
        }
      }
      queue.sort(function(a, b) {
        return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
      });
      if (queue.length !== 0) {
        if (!this._loading) {
          this._loading = true;
          this.fire("loading");
        }
        var fragment = document.createDocumentFragment();
        for (i = 0; i < queue.length; i++) {
          this._addTile(queue[i], fragment);
        }
        this._level.el.appendChild(fragment);
      }
    },
    _isValidTile: function(coords) {
      var crs = this._map.options.crs;
      if (!crs.infinite) {
        var bounds = this._globalTileRange;
        if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) {
          return false;
        }
      }
      if (!this.options.bounds) {
        return true;
      }
      var tileBounds = this._tileCoordsToBounds(coords);
      return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
    },
    _keyToBounds: function(key) {
      return this._tileCoordsToBounds(this._keyToTileCoords(key));
    },
    _tileCoordsToNwSe: function(coords) {
      var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
      return [nw, se];
    },
    // converts tile coordinates to its geographical bounds
    _tileCoordsToBounds: function(coords) {
      var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
      if (!this.options.noWrap) {
        bounds = this._map.wrapLatLngBounds(bounds);
      }
      return bounds;
    },
    // converts tile coordinates to key for the tile cache
    _tileCoordsToKey: function(coords) {
      return coords.x + ":" + coords.y + ":" + coords.z;
    },
    // converts tile cache key to coordinates
    _keyToTileCoords: function(key) {
      var k = key.split(":"), coords = new Point(+k[0], +k[1]);
      coords.z = +k[2];
      return coords;
    },
    _removeTile: function(key) {
      var tile = this._tiles[key];
      if (!tile) {
        return;
      }
      remove(tile.el);
      delete this._tiles[key];
      this.fire("tileunload", {
        tile: tile.el,
        coords: this._keyToTileCoords(key)
      });
    },
    _initTile: function(tile) {
      addClass(tile, "L2DV-tile");
      var tileSize = this.getTileSize();
      tile.style.width = tileSize.x + "px";
      tile.style.height = tileSize.y + "px";
      tile.onselectstart = falseFn;
      tile.onmousemove = falseFn;
      if (Browser.ielt9 && this.options.opacity < 1) {
        setOpacity(tile, this.options.opacity);
      }
    },
    _addTile: function(coords, container) {
      var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
      var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
      this._initTile(tile);
      if (this.createTile.length < 2) {
        requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
      }
      setPosition(tile, tilePos);
      this._tiles[key] = {
        el: tile,
        coords,
        current: true
      };
      container.appendChild(tile);
      this.fire("tileloadstart", {
        tile,
        coords
      });
    },
    _tileReady: function(coords, err, tile) {
      if (err) {
        this.fire("tileerror", {
          error: err,
          tile,
          coords
        });
      }
      var key = this._tileCoordsToKey(coords);
      tile = this._tiles[key];
      if (!tile) {
        return;
      }
      tile.loaded = +/* @__PURE__ */ new Date();
      if (this._map._fadeAnimated) {
        setOpacity(tile.el, 0);
        cancelAnimFrame(this._fadeFrame);
        this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
      } else {
        tile.active = true;
        this._pruneTiles();
      }
      if (!err) {
        addClass(tile.el, "L2DV-tile-loaded");
        this.fire("tileload", {
          tile: tile.el,
          coords
        });
      }
      if (this._noTilesToLoad()) {
        this._loading = false;
        this.fire("load");
        if (Browser.ielt9 || !this._map._fadeAnimated) {
          requestAnimFrame(this._pruneTiles, this);
        } else {
          setTimeout(bind(this._pruneTiles, this), 250);
        }
      }
    },
    _getTilePos: function(coords) {
      return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
    },
    _wrapCoords: function(coords) {
      var newCoords = new Point(
        this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x,
        this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y
      );
      newCoords.z = coords.z;
      return newCoords;
    },
    _pxBoundsToTileRange: function(bounds) {
      var tileSize = this.getTileSize();
      return new Bounds(
        bounds.min.unscaleBy(tileSize).floor(),
        bounds.max.unscaleBy(tileSize).ceil().subtract([1, 1])
      );
    },
    _noTilesToLoad: function() {
      for (var key in this._tiles) {
        if (!this._tiles[key].loaded) {
          return false;
        }
      }
      return true;
    }
  });
  function gridLayer(options) {
    return new GridLayer(options);
  }
  var TileLayer = GridLayer.extend({
    // @section
    // @aka TileLayer options
    options: {
      // @option minZoom: Number = 0
      // The minimum zoom level down to which this layer will be displayed (inclusive).
      minZoom: 0,
      // @option maxZoom: Number = 18
      // The maximum zoom level up to which this layer will be displayed (inclusive).
      maxZoom: 18,
      // @option subdomains: String|String[] = 'abc'
      // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
      subdomains: "abc",
      // @option errorTileUrl: String = ''
      // URL to the tile image to show in place of the tile that failed to load.
      errorTileUrl: "",
      // @option zoomOffset: Number = 0
      // The zoom number used in tile URLs will be offset with this value.
      zoomOffset: 0,
      // @option tms: Boolean = false
      // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
      tms: false,
      // @option zoomReverse: Boolean = false
      // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
      zoomReverse: false,
      // @option detectRetina: Boolean = false
      // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
      detectRetina: false,
      // @option crossOrigin: Boolean|String = false
      // Whether the crossOrigin attribute will be added to the tiles.
      // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
      // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
      crossOrigin: false,
      // @option referrerPolicy: Boolean|String = false
      // Whether the referrerPolicy attribute will be added to the tiles.
      // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
      // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
      // (e.g. to validate an API token).
      // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
      referrerPolicy: false
    },
    initialize: function(url, options) {
      this._url = url;
      options = setOptions(this, options);
      if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
        options.tileSize = Math.floor(options.tileSize / 2);
        if (!options.zoomReverse) {
          options.zoomOffset++;
          options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
        } else {
          options.zoomOffset--;
          options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
        }
        options.minZoom = Math.max(0, options.minZoom);
      } else if (!options.zoomReverse) {
        options.maxZoom = Math.max(options.minZoom, options.maxZoom);
      } else {
        options.minZoom = Math.min(options.maxZoom, options.minZoom);
      }
      if (typeof options.subdomains === "string") {
        options.subdomains = options.subdomains.split("");
      }
      this.on("tileunload", this._onTileRemove);
    },
    // @method setUrl(url: String, noRedraw?: Boolean): this
    // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
    // If the URL does not change, the layer will not be redrawn unless
    // the noRedraw parameter is set to false.
    setUrl: function(url, noRedraw) {
      if (this._url === url && noRedraw === void 0) {
        noRedraw = true;
      }
      this._url = url;
      if (!noRedraw) {
        this.redraw();
      }
      return this;
    },
    // @method createTile(coords: Object, done?: Function): HTMLElement
    // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
    // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
    // callback is called when the tile has been loaded.
    createTile: function(coords, done) {
      var tile = document.createElement("img");
      on(tile, "load", bind(this._tileOnLoad, this, done, tile));
      on(tile, "error", bind(this._tileOnError, this, done, tile));
      if (this.options.crossOrigin || this.options.crossOrigin === "") {
        tile.crossOrigin = this.options.crossOrigin === true ? "" : this.options.crossOrigin;
      }
      if (typeof this.options.referrerPolicy === "string") {
        tile.referrerPolicy = this.options.referrerPolicy;
      }
      tile.alt = "";
      tile.src = this.getTileUrl(coords);
      return tile;
    },
    // @section Extension methods
    // @uninheritable
    // Layers extending `TileLayer` might reimplement the following method.
    // @method getTileUrl(coords: Object): String
    // Called only internally, returns the URL for a tile given its coordinates.
    // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
    getTileUrl: function(coords) {
      var data = {
        r: Browser.retina ? "@2x" : "",
        s: this._getSubdomain(coords),
        x: coords.x,
        y: coords.y,
        z: this._getZoomForUrl()
      };
      if (this._map && !this._map.options.crs.infinite) {
        var invertedY = this._globalTileRange.max.y - coords.y;
        if (this.options.tms) {
          data["y"] = invertedY;
        }
        data["-y"] = invertedY;
      }
      return template(this._url, extend(data, this.options));
    },
    _tileOnLoad: function(done, tile) {
      if (Browser.ielt9) {
        setTimeout(bind(done, this, null, tile), 0);
      } else {
        done(null, tile);
      }
    },
    _tileOnError: function(done, tile, e) {
      var errorUrl = this.options.errorTileUrl;
      if (errorUrl && tile.getAttribute("src") !== errorUrl) {
        tile.src = errorUrl;
      }
      done(e, tile);
    },
    _onTileRemove: function(e) {
      e.tile.onload = null;
    },
    _getZoomForUrl: function() {
      var zoom2 = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
      if (zoomReverse) {
        zoom2 = maxZoom - zoom2;
      }
      return zoom2 + zoomOffset;
    },
    _getSubdomain: function(tilePoint) {
      var index2 = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
      return this.options.subdomains[index2];
    },
    // stops loading all tiles in the background layer
    _abortLoading: function() {
      var i, tile;
      for (i in this._tiles) {
        if (this._tiles[i].coords.z !== this._tileZoom) {
          tile = this._tiles[i].el;
          tile.onload = falseFn;
          tile.onerror = falseFn;
          if (!tile.complete) {
            tile.src = emptyImageUrl;
            var coords = this._tiles[i].coords;
            remove(tile);
            delete this._tiles[i];
            this.fire("tileabort", {
              tile,
              coords
            });
          }
        }
      }
    },
    _removeTile: function(key) {
      var tile = this._tiles[key];
      if (!tile) {
        return;
      }
      tile.el.setAttribute("src", emptyImageUrl);
      return GridLayer.prototype._removeTile.call(this, key);
    },
    _tileReady: function(coords, err, tile) {
      if (!this._map || tile && tile.getAttribute("src") === emptyImageUrl) {
        return;
      }
      return GridLayer.prototype._tileReady.call(this, coords, err, tile);
    }
  });
  function tileLayer(url, options) {
    return new TileLayer(url, options);
  }
  var TileLayerWMS = TileLayer.extend({
    // @section
    // @aka TileLayer.WMS options
    // If any custom options not documented here are used, they will be sent to the
    // WMS server as extra parameters in each request URL. This can be useful for
    // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
    defaultWmsParams: {
      service: "WMS",
      request: "GetMap",
      // @option layers: String = ''
      // **(required)** Comma-separated list of WMS layers to show.
      layers: "",
      // @option styles: String = ''
      // Comma-separated list of WMS styles.
      styles: "",
      // @option format: String = 'image/jpeg'
      // WMS image format (use `'image/png'` for layers with transparency).
      format: "image/jpeg",
      // @option transparent: Boolean = false
      // If `true`, the WMS service will return images with transparency.
      transparent: false,
      // @option version: String = '1.1.1'
      // Version of the WMS service to use
      version: "1.1.1"
    },
    options: {
      // @option crs: CRS = null
      // Coordinate Reference System to use for the WMS requests, defaults to
      // map CRS. Don't change this if you're not sure what it means.
      crs: null,
      // @option uppercase: Boolean = false
      // If `true`, WMS request parameter keys will be uppercase.
      uppercase: false
    },
    initialize: function(url, options) {
      this._url = url;
      var wmsParams = extend({}, this.defaultWmsParams);
      for (var i in options) {
        if (!(i in this.options)) {
          wmsParams[i] = options[i];
        }
      }
      options = setOptions(this, options);
      var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
      var tileSize = this.getTileSize();
      wmsParams.width = tileSize.x * realRetina;
      wmsParams.height = tileSize.y * realRetina;
      this.wmsParams = wmsParams;
    },
    onAdd: function(map) {
      this._crs = this.options.crs || map.options.crs;
      this._wmsVersion = parseFloat(this.wmsParams.version);
      var projectionKey = this._wmsVersion >= 1.3 ? "crs" : "srs";
      this.wmsParams[projectionKey] = this._crs.code;
      TileLayer.prototype.onAdd.call(this, map);
    },
    getTileUrl: function(coords) {
      var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [min.y, min.x, max.y, max.x] : [min.x, min.y, max.x, max.y]).join(","), url = TileLayer.prototype.getTileUrl.call(this, coords);
      return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? "&BBOX=" : "&bbox=") + bbox;
    },
    // @method setParams(params: Object, noRedraw?: Boolean): this
    // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
    setParams: function(params, noRedraw) {
      extend(this.wmsParams, params);
      if (!noRedraw) {
        this.redraw();
      }
      return this;
    }
  });
  function tileLayerWMS(url, options) {
    return new TileLayerWMS(url, options);
  }
  TileLayer.WMS = TileLayerWMS;
  tileLayer.wms = tileLayerWMS;
  var Renderer = Layer.extend({
    // @section
    // @aka Renderer options
    options: {
      // @option padding: Number = 0.1
      // How much to extend the clip area around the map view (relative to its size)
      // e.g. 0.1 would be 10% of map view in each direction
      padding: 0.1
    },
    initialize: function(options) {
      setOptions(this, options);
      stamp(this);
      this._layers = this._layers || {};
    },
    onAdd: function() {
      if (!this._container) {
        this._initContainer();
        addClass(this._container, "L2DV-zoom-animated");
      }
      this.getPane().appendChild(this._container);
      this._update();
      this.on("update", this._updatePaths, this);
    },
    onRemove: function() {
      this.off("update", this._updatePaths, this);
      this._destroyContainer();
    },
    getEvents: function() {
      var events = {
        viewreset: this._reset,
        zoom: this._onZoom,
        moveend: this._update,
        zoomend: this._onZoomEnd
      };
      if (this._zoomAnimated) {
        events.zoomanim = this._onAnimZoom;
      }
      return events;
    },
    _onAnimZoom: function(ev) {
      this._updateTransform(ev.center, ev.zoom);
    },
    _onZoom: function() {
      this._updateTransform(this._map.getCenter(), this._map.getZoom());
    },
    _updateTransform: function(center, zoom2) {
      var scale2 = this._map.getZoomScale(zoom2, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom2), topLeftOffset = viewHalf.multiplyBy(-scale2).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom2));
      if (Browser.any3d) {
        setTransform(this._container, topLeftOffset, scale2);
      } else {
        setPosition(this._container, topLeftOffset);
      }
    },
    _reset: function() {
      this._update();
      this._updateTransform(this._center, this._zoom);
      for (var id in this._layers) {
        this._layers[id]._reset();
      }
    },
    _onZoomEnd: function() {
      for (var id in this._layers) {
        this._layers[id]._project();
      }
    },
    _updatePaths: function() {
      for (var id in this._layers) {
        this._layers[id]._update();
      }
    },
    _update: function() {
      var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
      this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
      this._center = this._map.getCenter();
      this._zoom = this._map.getZoom();
    }
  });
  var Canvas = Renderer.extend({
    // @section
    // @aka Canvas options
    options: {
      // @option tolerance: Number = 0
      // How much to extend the click tolerance around a path/object on the map.
      tolerance: 0
    },
    getEvents: function() {
      var events = Renderer.prototype.getEvents.call(this);
      events.viewprereset = this._onViewPreReset;
      return events;
    },
    _onViewPreReset: function() {
      this._postponeUpdatePaths = true;
    },
    onAdd: function() {
      Renderer.prototype.onAdd.call(this);
      this._draw();
    },
    _initContainer: function() {
      var container = this._container = document.createElement("canvas");
      on(container, "mousemove", this._onMouseMove, this);
      on(container, "click dblclick mousedown mouseup contextmenu", this._onClick, this);
      on(container, "mouseout", this._handleMouseOut, this);
      container["_L2DV_disable_events"] = true;
      this._ctx = container.getContext("2d");
    },
    _destroyContainer: function() {
      cancelAnimFrame(this._redrawRequest);
      delete this._ctx;
      remove(this._container);
      off(this._container);
      delete this._container;
    },
    _updatePaths: function() {
      if (this._postponeUpdatePaths) {
        return;
      }
      var layer;
      this._redrawBounds = null;
      for (var id in this._layers) {
        layer = this._layers[id];
        layer._update();
      }
      this._redraw();
    },
    _update: function() {
      if (this._map._animatingZoom && this._bounds) {
        return;
      }
      Renderer.prototype._update.call(this);
      var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
      setPosition(container, b.min);
      container.width = m * size.x;
      container.height = m * size.y;
      container.style.width = size.x + "px";
      container.style.height = size.y + "px";
      if (Browser.retina) {
        this._ctx.scale(2, 2);
      }
      this._ctx.translate(-b.min.x, -b.min.y);
      this.fire("update");
    },
    _reset: function() {
      Renderer.prototype._reset.call(this);
      if (this._postponeUpdatePaths) {
        this._postponeUpdatePaths = false;
        this._updatePaths();
      }
    },
    _initPath: function(layer) {
      this._updateDashArray(layer);
      this._layers[stamp(layer)] = layer;
      var order = layer._order = {
        layer,
        prev: this._drawLast,
        next: null
      };
      if (this._drawLast) {
        this._drawLast.next = order;
      }
      this._drawLast = order;
      this._drawFirst = this._drawFirst || this._drawLast;
    },
    _addPath: function(layer) {
      this._requestRedraw(layer);
    },
    _removePath: function(layer) {
      var order = layer._order;
      var next = order.next;
      var prev = order.prev;
      if (next) {
        next.prev = prev;
      } else {
        this._drawLast = prev;
      }
      if (prev) {
        prev.next = next;
      } else {
        this._drawFirst = next;
      }
      delete layer._order;
      delete this._layers[stamp(layer)];
      this._requestRedraw(layer);
    },
    _updatePath: function(layer) {
      this._extendRedrawBounds(layer);
      layer._project();
      layer._update();
      this._requestRedraw(layer);
    },
    _updateStyle: function(layer) {
      this._updateDashArray(layer);
      this._requestRedraw(layer);
    },
    _updateDashArray: function(layer) {
      if (typeof layer.options.dashArray === "string") {
        var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
        for (i = 0; i < parts.length; i++) {
          dashValue = Number(parts[i]);
          if (isNaN(dashValue)) {
            return;
          }
          dashArray.push(dashValue);
        }
        layer.options._dashArray = dashArray;
      } else {
        layer.options._dashArray = layer.options.dashArray;
      }
    },
    _requestRedraw: function(layer) {
      if (!this._map) {
        return;
      }
      this._extendRedrawBounds(layer);
      this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
    },
    _extendRedrawBounds: function(layer) {
      if (layer._pxBounds) {
        var padding = (layer.options.weight || 0) + 1;
        this._redrawBounds = this._redrawBounds || new Bounds();
        this._redrawBounds.extend(layer._pxBounds.min.subtract([padding, padding]));
        this._redrawBounds.extend(layer._pxBounds.max.add([padding, padding]));
      }
    },
    _redraw: function() {
      this._redrawRequest = null;
      if (this._redrawBounds) {
        this._redrawBounds.min._floor();
        this._redrawBounds.max._ceil();
      }
      this._clear();
      this._draw();
      this._redrawBounds = null;
    },
    _clear: function() {
      var bounds = this._redrawBounds;
      if (bounds) {
        var size = bounds.getSize();
        this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
      } else {
        this._ctx.save();
        this._ctx.setTransform(1, 0, 0, 1, 0, 0);
        this._ctx.clearRect(0, 0, this._container.width, this._container.height);
        this._ctx.restore();
      }
    },
    _draw: function() {
      var layer, bounds = this._redrawBounds;
      this._ctx.save();
      if (bounds) {
        var size = bounds.getSize();
        this._ctx.beginPath();
        this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
        this._ctx.clip();
      }
      this._drawing = true;
      for (var order = this._drawFirst; order; order = order.next) {
        layer = order.layer;
        if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) {
          layer._updatePath();
        }
      }
      this._drawing = false;
      this._ctx.restore();
    },
    _updatePoly: function(layer, closed) {
      if (!this._drawing) {
        return;
      }
      var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
      if (!len) {
        return;
      }
      ctx.beginPath();
      for (i = 0; i < len; i++) {
        for (j = 0, len2 = parts[i].length; j < len2; j++) {
          p = parts[i][j];
          ctx[j ? "lineTo" : "moveTo"](p.x, p.y);
        }
        if (closed) {
          ctx.closePath();
        }
      }
      this._fillStroke(ctx, layer);
    },
    _updateCircle: function(layer) {
      if (!this._drawing || layer._empty()) {
        return;
      }
      var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
      if (s !== 1) {
        ctx.save();
        ctx.scale(1, s);
      }
      ctx.beginPath();
      ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
      if (s !== 1) {
        ctx.restore();
      }
      this._fillStroke(ctx, layer);
    },
    _fillStroke: function(ctx, layer) {
      var options = layer.options;
      if (options.fill) {
        ctx.globalAlpha = options.fillOpacity;
        ctx.fillStyle = options.fillColor || options.color;
        ctx.fill(options.fillRule || "evenodd");
      }
      if (options.stroke && options.weight !== 0) {
        if (ctx.setLineDash) {
          ctx.setLineDash(layer.options && layer.options._dashArray || []);
        }
        ctx.globalAlpha = options.opacity;
        ctx.lineWidth = options.weight;
        ctx.strokeStyle = options.color;
        ctx.lineCap = options.lineCap;
        ctx.lineJoin = options.lineJoin;
        ctx.stroke();
      }
    },
    // Canvas obviously doesn't have mouse events for individual drawn objects,
    // so we emulate that by calculating what's under the mouse on mousemove/click manually
    _onClick: function(e) {
      var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
      for (var order = this._drawFirst; order; order = order.next) {
        layer = order.layer;
        if (layer.options.interactive && layer._containsPoint(point)) {
          if (!(e.type === "click" || e.type === "preclick") || !this._map._draggableMoved(layer)) {
            clickedLayer = layer;
          }
        }
      }
      this._fireEvent(clickedLayer ? [clickedLayer] : false, e);
    },
    _onMouseMove: function(e) {
      if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) {
        return;
      }
      var point = this._map.mouseEventToLayerPoint(e);
      this._handleMouseHover(e, point);
    },
    _handleMouseOut: function(e) {
      var layer = this._hoveredLayer;
      if (layer) {
        removeClass(this._container, "L2DV-interactive");
        this._fireEvent([layer], e, "mouseout");
        this._hoveredLayer = null;
        this._mouseHoverThrottled = false;
      }
    },
    _handleMouseHover: function(e, point) {
      if (this._mouseHoverThrottled) {
        return;
      }
      var layer, candidateHoveredLayer;
      for (var order = this._drawFirst; order; order = order.next) {
        layer = order.layer;
        if (layer.options.interactive && layer._containsPoint(point)) {
          candidateHoveredLayer = layer;
        }
      }
      if (candidateHoveredLayer !== this._hoveredLayer) {
        this._handleMouseOut(e);
        if (candidateHoveredLayer) {
          addClass(this._container, "L2DV-interactive");
          this._fireEvent([candidateHoveredLayer], e, "mouseover");
          this._hoveredLayer = candidateHoveredLayer;
        }
      }
      this._fireEvent(this._hoveredLayer ? [this._hoveredLayer] : false, e);
      this._mouseHoverThrottled = true;
      setTimeout(bind(function() {
        this._mouseHoverThrottled = false;
      }, this), 32);
    },
    _fireEvent: function(layers2, e, type) {
      this._map._fireDOMEvent(e, type || e.type, layers2);
    },
    _bringToFront: function(layer) {
      var order = layer._order;
      if (!order) {
        return;
      }
      var next = order.next;
      var prev = order.prev;
      if (next) {
        next.prev = prev;
      } else {
        return;
      }
      if (prev) {
        prev.next = next;
      } else if (next) {
        this._drawFirst = next;
      }
      order.prev = this._drawLast;
      this._drawLast.next = order;
      order.next = null;
      this._drawLast = order;
      this._requestRedraw(layer);
    },
    _bringToBack: function(layer) {
      var order = layer._order;
      if (!order) {
        return;
      }
      var next = order.next;
      var prev = order.prev;
      if (prev) {
        prev.next = next;
      } else {
        return;
      }
      if (next) {
        next.prev = prev;
      } else if (prev) {
        this._drawLast = prev;
      }
      order.prev = null;
      order.next = this._drawFirst;
      this._drawFirst.prev = order;
      this._drawFirst = order;
      this._requestRedraw(layer);
    }
  });
  function canvas(options) {
    return Browser.canvas ? new Canvas(options) : null;
  }
  var vmlCreate = (function() {
    try {
      document.namespaces.add("lvml", "urn:schemas-microsoft-com:vml");
      return function(name) {
        return document.createElement("<lvml:" + name + ' class="lvml">');
      };
    } catch (e) {
    }
    return function(name) {
      return document.createElement("<" + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
    };
  })();
  var vmlMixin = {
    _initContainer: function() {
      this._container = create$1("div", "L2DV-vml-container");
    },
    _update: function() {
      if (this._map._animatingZoom) {
        return;
      }
      Renderer.prototype._update.call(this);
      this.fire("update");
    },
    _initPath: function(layer) {
      var container = layer._container = vmlCreate("shape");
      addClass(container, "L2DV-vml-shape " + (this.options.className || ""));
      container.coordsize = "1 1";
      layer._path = vmlCreate("path");
      container.appendChild(layer._path);
      this._updateStyle(layer);
      this._layers[stamp(layer)] = layer;
    },
    _addPath: function(layer) {
      var container = layer._container;
      this._container.appendChild(container);
      if (layer.options.interactive) {
        layer.addInteractiveTarget(container);
      }
    },
    _removePath: function(layer) {
      var container = layer._container;
      remove(container);
      layer.removeInteractiveTarget(container);
      delete this._layers[stamp(layer)];
    },
    _updateStyle: function(layer) {
      var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
      container.stroked = !!options.stroke;
      container.filled = !!options.fill;
      if (options.stroke) {
        if (!stroke) {
          stroke = layer._stroke = vmlCreate("stroke");
        }
        container.appendChild(stroke);
        stroke.weight = options.weight + "px";
        stroke.color = options.color;
        stroke.opacity = options.opacity;
        if (options.dashArray) {
          stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(" ") : options.dashArray.replace(/( *, *)/g, " ");
        } else {
          stroke.dashStyle = "";
        }
        stroke.endcap = options.lineCap.replace("butt", "flat");
        stroke.joinstyle = options.lineJoin;
      } else if (stroke) {
        container.removeChild(stroke);
        layer._stroke = null;
      }
      if (options.fill) {
        if (!fill) {
          fill = layer._fill = vmlCreate("fill");
        }
        container.appendChild(fill);
        fill.color = options.fillColor || options.color;
        fill.opacity = options.fillOpacity;
      } else if (fill) {
        container.removeChild(fill);
        layer._fill = null;
      }
    },
    _updateCircle: function(layer) {
      var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
      this._setPath(layer, layer._empty() ? "M0 0" : "AL " + p.x + "," + p.y + " " + r + "," + r2 + " 0," + 65535 * 360);
    },
    _setPath: function(layer, path) {
      layer._path.v = path;
    },
    _bringToFront: function(layer) {
      toFront(layer._container);
    },
    _bringToBack: function(layer) {
      toBack(layer._container);
    }
  };
  var create = Browser.vml ? vmlCreate : svgCreate;
  var SVG = Renderer.extend({
    _initContainer: function() {
      this._container = create("svg");
      this._container.setAttribute("pointer-events", "none");
      this._rootGroup = create("g");
      this._container.appendChild(this._rootGroup);
    },
    _destroyContainer: function() {
      remove(this._container);
      off(this._container);
      delete this._container;
      delete this._rootGroup;
      delete this._svgSize;
    },
    _update: function() {
      if (this._map._animatingZoom && this._bounds) {
        return;
      }
      Renderer.prototype._update.call(this);
      var b = this._bounds, size = b.getSize(), container = this._container;
      if (!this._svgSize || !this._svgSize.equals(size)) {
        this._svgSize = size;
        container.setAttribute("width", size.x);
        container.setAttribute("height", size.y);
      }
      setPosition(container, b.min);
      container.setAttribute("viewBox", [b.min.x, b.min.y, size.x, size.y].join(" "));
      this.fire("update");
    },
    // methods below are called by vector layers implementations
    _initPath: function(layer) {
      var path = layer._path = create("path");
      if (layer.options.className) {
        addClass(path, layer.options.className);
      }
      if (layer.options.interactive) {
        addClass(path, "L2DV-interactive");
      }
      this._updateStyle(layer);
      this._layers[stamp(layer)] = layer;
    },
    _addPath: function(layer) {
      if (!this._rootGroup) {
        this._initContainer();
      }
      this._rootGroup.appendChild(layer._path);
      layer.addInteractiveTarget(layer._path);
    },
    _removePath: function(layer) {
      remove(layer._path);
      layer.removeInteractiveTarget(layer._path);
      delete this._layers[stamp(layer)];
    },
    _updatePath: function(layer) {
      layer._project();
      layer._update();
    },
    _updateStyle: function(layer) {
      var path = layer._path, options = layer.options;
      if (!path) {
        return;
      }
      if (options.stroke) {
        path.setAttribute("stroke", options.color);
        path.setAttribute("stroke-opacity", options.opacity);
        path.setAttribute("stroke-width", options.weight);
        path.setAttribute("stroke-linecap", options.lineCap);
        path.setAttribute("stroke-linejoin", options.lineJoin);
        if (options.dashArray) {
          path.setAttribute("stroke-dasharray", options.dashArray);
        } else {
          path.removeAttribute("stroke-dasharray");
        }
        if (options.dashOffset) {
          path.setAttribute("stroke-dashoffset", options.dashOffset);
        } else {
          path.removeAttribute("stroke-dashoffset");
        }
      } else {
        path.setAttribute("stroke", "none");
      }
      if (options.fill) {
        path.setAttribute("fill", options.fillColor || options.color);
        path.setAttribute("fill-opacity", options.fillOpacity);
        path.setAttribute("fill-rule", options.fillRule || "evenodd");
      } else {
        path.setAttribute("fill", "none");
      }
    },
    _updatePoly: function(layer, closed) {
      this._setPath(layer, pointsToPath(layer._parts, closed));
    },
    _updateCircle: function(layer) {
      var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = "a" + r + "," + r2 + " 0 1,0 ";
      var d = layer._empty() ? "M0 0" : "M" + (p.x - r) + "," + p.y + arc + r * 2 + ",0 " + arc + -r * 2 + ",0 ";
      this._setPath(layer, d);
    },
    _setPath: function(layer, path) {
      layer._path.setAttribute("d", path);
    },
    // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
    _bringToFront: function(layer) {
      toFront(layer._path);
    },
    _bringToBack: function(layer) {
      toBack(layer._path);
    }
  });
  if (Browser.vml) {
    SVG.include(vmlMixin);
  }
  function svg(options) {
    return Browser.svg || Browser.vml ? new SVG(options) : null;
  }
  Map.include({
    // @namespace Map; @method getRenderer(layer: Path): Renderer
    // Returns the instance of `Renderer` that should be used to render the given
    // `Path`. It will ensure that the `renderer` options of the map and paths
    // are respected, and that the renderers do exist on the map.
    getRenderer: function(layer) {
      var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
      if (!renderer) {
        renderer = this._renderer = this._createRenderer();
      }
      if (!this.hasLayer(renderer)) {
        this.addLayer(renderer);
      }
      return renderer;
    },
    _getPaneRenderer: function(name) {
      if (name === "overlayPane" || name === void 0) {
        return false;
      }
      var renderer = this._paneRenderers[name];
      if (renderer === void 0) {
        renderer = this._createRenderer({ pane: name });
        this._paneRenderers[name] = renderer;
      }
      return renderer;
    },
    _createRenderer: function(options) {
      return this.options.preferCanvas && canvas(options) || svg(options);
    }
  });
  var Rectangle = Polygon.extend({
    initialize: function(latLngBounds, options) {
      Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
    },
    // @method setBounds(latLngBounds: LatLngBounds): this
    // Redraws the rectangle with the passed bounds.
    setBounds: function(latLngBounds) {
      return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
    },
    _boundsToLatLngs: function(latLngBounds) {
      latLngBounds = toLatLngBounds(latLngBounds);
      return [
        latLngBounds.getSouthWest(),
        latLngBounds.getNorthWest(),
        latLngBounds.getNorthEast(),
        latLngBounds.getSouthEast()
      ];
    }
  });
  function rectangle(latLngBounds, options) {
    return new Rectangle(latLngBounds, options);
  }
  SVG.create = create;
  SVG.pointsToPath = pointsToPath;
  GeoJSON.geometryToLayer = geometryToLayer;
  GeoJSON.coordsToLatLng = coordsToLatLng;
  GeoJSON.coordsToLatLngs = coordsToLatLngs;
  GeoJSON.latLngToCoords = latLngToCoords;
  GeoJSON.latLngsToCoords = latLngsToCoords;
  GeoJSON.getFeature = getFeature;
  GeoJSON.asFeature = asFeature;
  Map.mergeOptions({
    // @option boxZoom: Boolean = true
    // Whether the map can be zoomed to a rectangular area specified by
    // dragging the mouse while pressing the shift key.
    boxZoom: true
  });
  var BoxZoom = Handler.extend({
    initialize: function(map) {
      this._map = map;
      this._container = map._container;
      this._pane = map._panes.overlayPane;
      this._resetStateTimeout = 0;
      map.on("unload", this._destroy, this);
    },
    addHooks: function() {
      on(this._container, "mousedown", this._onMouseDown, this);
    },
    removeHooks: function() {
      off(this._container, "mousedown", this._onMouseDown, this);
    },
    moved: function() {
      return this._moved;
    },
    _destroy: function() {
      remove(this._pane);
      delete this._pane;
    },
    _resetState: function() {
      this._resetStateTimeout = 0;
      this._moved = false;
    },
    _clearDeferredResetState: function() {
      if (this._resetStateTimeout !== 0) {
        clearTimeout(this._resetStateTimeout);
        this._resetStateTimeout = 0;
      }
    },
    _onMouseDown: function(e) {
      if (!e.shiftKey || e.which !== 1 && e.button !== 1) {
        return false;
      }
      this._clearDeferredResetState();
      this._resetState();
      disableTextSelection();
      disableImageDrag();
      this._startPoint = this._map.mouseEventToContainerPoint(e);
      on(document, {
        contextmenu: stop,
        mousemove: this._onMouseMove,
        mouseup: this._onMouseUp,
        keydown: this._onKeyDown
      }, this);
    },
    _onMouseMove: function(e) {
      if (!this._moved) {
        this._moved = true;
        this._box = create$1("div", "L2DV-zoom-box", this._container);
        addClass(this._container, "L2DV-crosshair");
        this._map.fire("boxzoomstart");
      }
      this._point = this._map.mouseEventToContainerPoint(e);
      var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
      setPosition(this._box, bounds.min);
      this._box.style.width = size.x + "px";
      this._box.style.height = size.y + "px";
    },
    _finish: function() {
      if (this._moved) {
        remove(this._box);
        removeClass(this._container, "L2DV-crosshair");
      }
      enableTextSelection();
      enableImageDrag();
      off(document, {
        contextmenu: stop,
        mousemove: this._onMouseMove,
        mouseup: this._onMouseUp,
        keydown: this._onKeyDown
      }, this);
    },
    _onMouseUp: function(e) {
      if (e.which !== 1 && e.button !== 1) {
        return;
      }
      this._finish();
      if (!this._moved) {
        return;
      }
      this._clearDeferredResetState();
      this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
      var bounds = new LatLngBounds(
        this._map.containerPointToLatLng(this._startPoint),
        this._map.containerPointToLatLng(this._point)
      );
      this._map.fitBounds(bounds).fire("boxzoomend", { boxZoomBounds: bounds });
    },
    _onKeyDown: function(e) {
      if (e.keyCode === 27) {
        this._finish();
        this._clearDeferredResetState();
        this._resetState();
      }
    }
  });
  Map.addInitHook("addHandler", "boxZoom", BoxZoom);
  Map.mergeOptions({
    // @option doubleClickZoom: Boolean|String = true
    // Whether the map can be zoomed in by double clicking on it and
    // zoomed out by double clicking while holding shift. If passed
    // `'center'`, double-click zoom will zoom to the center of the
    //  view regardless of where the mouse was.
    doubleClickZoom: true
  });
  var DoubleClickZoom = Handler.extend({
    addHooks: function() {
      this._map.on("dblclick", this._onDoubleClick, this);
    },
    removeHooks: function() {
      this._map.off("dblclick", this._onDoubleClick, this);
    },
    _onDoubleClick: function(e) {
      var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom2 = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
      if (map.options.doubleClickZoom === "center") {
        map.setZoom(zoom2);
      } else {
        map.setZoomAround(e.containerPoint, zoom2);
      }
    }
  });
  Map.addInitHook("addHandler", "doubleClickZoom", DoubleClickZoom);
  Map.mergeOptions({
    // @option dragging: Boolean = true
    // Whether the map is draggable with mouse/touch or not.
    dragging: true,
    // @section Panning Inertia Options
    // @option inertia: Boolean = *
    // If enabled, panning of the map will have an inertia effect where
    // the map builds momentum while dragging and continues moving in
    // the same direction for some time. Feels especially nice on touch
    // devices. Enabled by default.
    inertia: true,
    // @option inertiaDeceleration: Number = 3000
    // The rate with which the inertial movement slows down, in pixels/second².
    inertiaDeceleration: 3400,
    // px/s^2
    // @option inertiaMaxSpeed: Number = Infinity
    // Max speed of the inertial movement, in pixels/second.
    inertiaMaxSpeed: Infinity,
    // px/s
    // @option easeLinearity: Number = 0.2
    easeLinearity: 0.2,
    // TODO refactor, move to CRS
    // @option worldCopyJump: Boolean = false
    // With this option enabled, the map tracks when you pan to another "copy"
    // of the world and seamlessly jumps to the original one so that all overlays
    // like markers and vector layers are still visible.
    worldCopyJump: false,
    // @option maxBoundsViscosity: Number = 0.0
    // If `maxBounds` is set, this option will control how solid the bounds
    // are when dragging the map around. The default value of `0.0` allows the
    // user to drag outside the bounds at normal speed, higher values will
    // slow down map dragging outside bounds, and `1.0` makes the bounds fully
    // solid, preventing the user from dragging outside the bounds.
    maxBoundsViscosity: 0
  });
  var Drag = Handler.extend({
    addHooks: function() {
      if (!this._draggable) {
        var map = this._map;
        this._draggable = new Draggable(map._mapPane, map._container);
        this._draggable.on({
          dragstart: this._onDragStart,
          drag: this._onDrag,
          dragend: this._onDragEnd
        }, this);
        this._draggable.on("predrag", this._onPreDragLimit, this);
        if (map.options.worldCopyJump) {
          this._draggable.on("predrag", this._onPreDragWrap, this);
          map.on("zoomend", this._onZoomEnd, this);
          map.whenReady(this._onZoomEnd, this);
        }
      }
      addClass(this._map._container, "L2DV-grab L2DV-touch-drag");
      this._draggable.enable();
      this._positions = [];
      this._times = [];
    },
    removeHooks: function() {
      removeClass(this._map._container, "L2DV-grab");
      removeClass(this._map._container, "L2DV-touch-drag");
      this._draggable.disable();
    },
    moved: function() {
      return this._draggable && this._draggable._moved;
    },
    moving: function() {
      return this._draggable && this._draggable._moving;
    },
    _onDragStart: function() {
      var map = this._map;
      map._stop();
      if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
        var bounds = toLatLngBounds(this._map.options.maxBounds);
        this._offsetLimit = toBounds(
          this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1),
          this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize())
        );
        this._viscosity = Math.min(1, Math.max(0, this._map.options.maxBoundsViscosity));
      } else {
        this._offsetLimit = null;
      }
      map.fire("movestart").fire("dragstart");
      if (map.options.inertia) {
        this._positions = [];
        this._times = [];
      }
    },
    _onDrag: function(e) {
      if (this._map.options.inertia) {
        var time = this._lastTime = +/* @__PURE__ */ new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
        this._positions.push(pos);
        this._times.push(time);
        this._prunePositions(time);
      }
      this._map.fire("move", e).fire("drag", e);
    },
    _prunePositions: function(time) {
      while (this._positions.length > 1 && time - this._times[0] > 50) {
        this._positions.shift();
        this._times.shift();
      }
    },
    _onZoomEnd: function() {
      var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([0, 0]);
      this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
      this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
    },
    _viscousLimit: function(value, threshold) {
      return value - (value - threshold) * this._viscosity;
    },
    _onPreDragLimit: function() {
      if (!this._viscosity || !this._offsetLimit) {
        return;
      }
      var offset = this._draggable._newPos.subtract(this._draggable._startPos);
      var limit = this._offsetLimit;
      if (offset.x < limit.min.x) {
        offset.x = this._viscousLimit(offset.x, limit.min.x);
      }
      if (offset.y < limit.min.y) {
        offset.y = this._viscousLimit(offset.y, limit.min.y);
      }
      if (offset.x > limit.max.x) {
        offset.x = this._viscousLimit(offset.x, limit.max.x);
      }
      if (offset.y > limit.max.y) {
        offset.y = this._viscousLimit(offset.y, limit.max.y);
      }
      this._draggable._newPos = this._draggable._startPos.add(offset);
    },
    _onPreDragWrap: function() {
      var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
      this._draggable._absPos = this._draggable._newPos.clone();
      this._draggable._newPos.x = newX;
    },
    _onDragEnd: function(e) {
      var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
      map.fire("dragend", e);
      if (noInertia) {
        map.fire("moveend");
      } else {
        this._prunePositions(+/* @__PURE__ */ new Date());
        var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1e3, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([0, 0]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
        if (!offset.x && !offset.y) {
          map.fire("moveend");
        } else {
          offset = map._limitOffset(offset, map.options.maxBounds);
          requestAnimFrame(function() {
            map.panBy(offset, {
              duration: decelerationDuration,
              easeLinearity: ease,
              noMoveStart: true,
              animate: true
            });
          });
        }
      }
    }
  });
  Map.addInitHook("addHandler", "dragging", Drag);
  Map.mergeOptions({
    // @option keyboard: Boolean = true
    // Makes the map focusable and allows users to navigate the map with keyboard
    // arrows and `+`/`-` keys.
    keyboard: true,
    // @option keyboardPanDelta: Number = 80
    // Amount of pixels to pan when pressing an arrow key.
    keyboardPanDelta: 80
  });
  var Keyboard = Handler.extend({
    keyCodes: {
      left: [37],
      right: [39],
      down: [40],
      up: [38],
      zoomIn: [187, 107, 61, 171],
      zoomOut: [189, 109, 54, 173]
    },
    initialize: function(map) {
      this._map = map;
      this._setPanDelta(map.options.keyboardPanDelta);
      this._setZoomDelta(map.options.zoomDelta);
    },
    addHooks: function() {
      var container = this._map._container;
      if (container.tabIndex <= 0) {
        container.tabIndex = "0";
      }
      on(container, {
        focus: this._onFocus,
        blur: this._onBlur,
        mousedown: this._onMouseDown
      }, this);
      this._map.on({
        focus: this._addHooks,
        blur: this._removeHooks
      }, this);
    },
    removeHooks: function() {
      this._removeHooks();
      off(this._map._container, {
        focus: this._onFocus,
        blur: this._onBlur,
        mousedown: this._onMouseDown
      }, this);
      this._map.off({
        focus: this._addHooks,
        blur: this._removeHooks
      }, this);
    },
    _onMouseDown: function() {
      if (this._focused) {
        return;
      }
      var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
      this._map._container.focus();
      window.scrollTo(left, top);
    },
    _onFocus: function() {
      this._focused = true;
      this._map.fire("focus");
    },
    _onBlur: function() {
      this._focused = false;
      this._map.fire("blur");
    },
    _setPanDelta: function(panDelta) {
      var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
      for (i = 0, len = codes.left.length; i < len; i++) {
        keys[codes.left[i]] = [-1 * panDelta, 0];
      }
      for (i = 0, len = codes.right.length; i < len; i++) {
        keys[codes.right[i]] = [panDelta, 0];
      }
      for (i = 0, len = codes.down.length; i < len; i++) {
        keys[codes.down[i]] = [0, panDelta];
      }
      for (i = 0, len = codes.up.length; i < len; i++) {
        keys[codes.up[i]] = [0, -1 * panDelta];
      }
    },
    _setZoomDelta: function(zoomDelta) {
      var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
      for (i = 0, len = codes.zoomIn.length; i < len; i++) {
        keys[codes.zoomIn[i]] = zoomDelta;
      }
      for (i = 0, len = codes.zoomOut.length; i < len; i++) {
        keys[codes.zoomOut[i]] = -zoomDelta;
      }
    },
    _addHooks: function() {
      on(document, "keydown", this._onKeyDown, this);
    },
    _removeHooks: function() {
      off(document, "keydown", this._onKeyDown, this);
    },
    _onKeyDown: function(e) {
      if (e.altKey || e.ctrlKey || e.metaKey) {
        return;
      }
      var key = e.keyCode, map = this._map, offset;
      if (key in this._panKeys) {
        if (!map._panAnim || !map._panAnim._inProgress) {
          offset = this._panKeys[key];
          if (e.shiftKey) {
            offset = toPoint(offset).multiplyBy(3);
          }
          if (map.options.maxBounds) {
            offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
          }
          if (map.options.worldCopyJump) {
            var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
            map.panTo(newLatLng);
          } else {
            map.panBy(offset);
          }
        }
      } else if (key in this._zoomKeys) {
        map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
      } else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) {
        map.closePopup();
      } else {
        return;
      }
      stop(e);
    }
  });
  Map.addInitHook("addHandler", "keyboard", Keyboard);
  Map.mergeOptions({
    // @section Mouse wheel options
    // @option scrollWheelZoom: Boolean|String = true
    // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
    // it will zoom to the center of the view regardless of where the mouse was.
    scrollWheelZoom: true,
    // @option wheelDebounceTime: Number = 40
    // Limits the rate at which a wheel can fire (in milliseconds). By default
    // user can't zoom via wheel more often than once per 40 ms.
    wheelDebounceTime: 40,
    // @option wheelPxPerZoomLevel: Number = 60
    // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
    // mean a change of one full zoom level. Smaller values will make wheel-zooming
    // faster (and vice versa).
    wheelPxPerZoomLevel: 60
  });
  var ScrollWheelZoom = Handler.extend({
    addHooks: function() {
      on(this._map._container, "wheel", this._onWheelScroll, this);
      this._delta = 0;
    },
    removeHooks: function() {
      off(this._map._container, "wheel", this._onWheelScroll, this);
    },
    _onWheelScroll: function(e) {
      var delta = getWheelDelta(e);
      var debounce = this._map.options.wheelDebounceTime;
      this._delta += delta;
      this._lastMousePos = this._map.mouseEventToContainerPoint(e);
      if (!this._startTime) {
        this._startTime = +/* @__PURE__ */ new Date();
      }
      var left = Math.max(debounce - (+/* @__PURE__ */ new Date() - this._startTime), 0);
      clearTimeout(this._timer);
      this._timer = setTimeout(bind(this._performZoom, this), left);
      stop(e);
    },
    _performZoom: function() {
      var map = this._map, zoom2 = map.getZoom(), snap = this._map.options.zoomSnap || 0;
      map._stop();
      var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom2 + (this._delta > 0 ? d4 : -d4)) - zoom2;
      this._delta = 0;
      this._startTime = null;
      if (!delta) {
        return;
      }
      if (map.options.scrollWheelZoom === "center") {
        map.setZoom(zoom2 + delta);
      } else {
        map.setZoomAround(this._lastMousePos, zoom2 + delta);
      }
    }
  });
  Map.addInitHook("addHandler", "scrollWheelZoom", ScrollWheelZoom);
  var tapHoldDelay = 600;
  Map.mergeOptions({
    // @section Touch interaction options
    // @option tapHold: Boolean
    // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
    tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
    // @option tapTolerance: Number = 15
    // The max number of pixels a user can shift his finger during touch
    // for it to be considered a valid tap.
    tapTolerance: 15
  });
  var TapHold = Handler.extend({
    addHooks: function() {
      on(this._map._container, "touchstart", this._onDown, this);
    },
    removeHooks: function() {
      off(this._map._container, "touchstart", this._onDown, this);
    },
    _onDown: function(e) {
      clearTimeout(this._holdTimeout);
      if (e.touches.length !== 1) {
        return;
      }
      var first = e.touches[0];
      this._startPos = this._newPos = new Point(first.clientX, first.clientY);
      this._holdTimeout = setTimeout(bind(function() {
        this._cancel();
        if (!this._isTapValid()) {
          return;
        }
        on(document, "touchend", preventDefault);
        on(document, "touchend touchcancel", this._cancelClickPrevent);
        this._simulateEvent("contextmenu", first);
      }, this), tapHoldDelay);
      on(document, "touchend touchcancel contextmenu", this._cancel, this);
      on(document, "touchmove", this._onMove, this);
    },
    _cancelClickPrevent: function cancelClickPrevent() {
      off(document, "touchend", preventDefault);
      off(document, "touchend touchcancel", cancelClickPrevent);
    },
    _cancel: function() {
      clearTimeout(this._holdTimeout);
      off(document, "touchend touchcancel contextmenu", this._cancel, this);
      off(document, "touchmove", this._onMove, this);
    },
    _onMove: function(e) {
      var first = e.touches[0];
      this._newPos = new Point(first.clientX, first.clientY);
    },
    _isTapValid: function() {
      return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
    },
    _simulateEvent: function(type, e) {
      var simulatedEvent = new MouseEvent(type, {
        bubbles: true,
        cancelable: true,
        view: window,
        // detail: 1,
        screenX: e.screenX,
        screenY: e.screenY,
        clientX: e.clientX,
        clientY: e.clientY
        // button: 2,
        // buttons: 2
      });
      simulatedEvent._simulated = true;
      e.target.dispatchEvent(simulatedEvent);
    }
  });
  Map.addInitHook("addHandler", "tapHold", TapHold);
  Map.mergeOptions({
    // @section Touch interaction options
    // @option touchZoom: Boolean|String = *
    // Whether the map can be zoomed by touch-dragging with two fingers. If
    // passed `'center'`, it will zoom to the center of the view regardless of
    // where the touch events (fingers) were. Enabled for touch-capable web
    // browsers.
    touchZoom: Browser.touch,
    // @option bounceAtZoomLimits: Boolean = true
    // Set it to false if you don't want the map to zoom beyond min/max zoom
    // and then bounce back when pinch-zooming.
    bounceAtZoomLimits: true
  });
  var TouchZoom = Handler.extend({
    addHooks: function() {
      addClass(this._map._container, "L2DV-touch-zoom");
      on(this._map._container, "touchstart", this._onTouchStart, this);
    },
    removeHooks: function() {
      removeClass(this._map._container, "L2DV-touch-zoom");
      off(this._map._container, "touchstart", this._onTouchStart, this);
    },
    _onTouchStart: function(e) {
      var map = this._map;
      if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) {
        return;
      }
      var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
      this._centerPoint = map.getSize()._divideBy(2);
      this._startLatLng = map.containerPointToLatLng(this._centerPoint);
      if (map.options.touchZoom !== "center") {
        this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
      }
      this._startDist = p1.distanceTo(p2);
      this._startZoom = map.getZoom();
      this._moved = false;
      this._zooming = true;
      map._stop();
      on(document, "touchmove", this._onTouchMove, this);
      on(document, "touchend touchcancel", this._onTouchEnd, this);
      preventDefault(e);
    },
    _onTouchMove: function(e) {
      if (!e.touches || e.touches.length !== 2 || !this._zooming) {
        return;
      }
      var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale2 = p1.distanceTo(p2) / this._startDist;
      this._zoom = map.getScaleZoom(scale2, this._startZoom);
      if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale2 < 1 || this._zoom > map.getMaxZoom() && scale2 > 1)) {
        this._zoom = map._limitZoom(this._zoom);
      }
      if (map.options.touchZoom === "center") {
        this._center = this._startLatLng;
        if (scale2 === 1) {
          return;
        }
      } else {
        var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
        if (scale2 === 1 && delta.x === 0 && delta.y === 0) {
          return;
        }
        this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
      }
      if (!this._moved) {
        map._moveStart(true, false);
        this._moved = true;
      }
      cancelAnimFrame(this._animRequest);
      var moveFn = bind(map._move, map, this._center, this._zoom, { pinch: true, round: false }, void 0);
      this._animRequest = requestAnimFrame(moveFn, this, true);
      preventDefault(e);
    },
    _onTouchEnd: function() {
      if (!this._moved || !this._zooming) {
        this._zooming = false;
        return;
      }
      this._zooming = false;
      cancelAnimFrame(this._animRequest);
      off(document, "touchmove", this._onTouchMove, this);
      off(document, "touchend touchcancel", this._onTouchEnd, this);
      if (this._map.options.zoomAnimation) {
        this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
      } else {
        this._map._resetView(this._center, this._map._limitZoom(this._zoom));
      }
    }
  });
  Map.addInitHook("addHandler", "touchZoom", TouchZoom);
  Map.BoxZoom = BoxZoom;
  Map.DoubleClickZoom = DoubleClickZoom;
  Map.Drag = Drag;
  Map.Keyboard = Keyboard;
  Map.ScrollWheelZoom = ScrollWheelZoom;
  Map.TapHold = TapHold;
  Map.TouchZoom = TouchZoom;
  exports2.Bounds = Bounds;
  exports2.Browser = Browser;
  exports2.CRS = CRS;
  exports2.Canvas = Canvas;
  exports2.Circle = Circle;
  exports2.CircleMarker = CircleMarker;
  exports2.Class = Class;
  exports2.Control = Control;
  exports2.DivIcon = DivIcon;
  exports2.DivOverlay = DivOverlay;
  exports2.DomEvent = DomEvent;
  exports2.DomUtil = DomUtil;
  exports2.Draggable = Draggable;
  exports2.Evented = Evented;
  exports2.FeatureGroup = FeatureGroup;
  exports2.GeoJSON = GeoJSON;
  exports2.GridLayer = GridLayer;
  exports2.Handler = Handler;
  exports2.Icon = Icon;
  exports2.ImageOverlay = ImageOverlay;
  exports2.LatLng = LatLng;
  exports2.LatLngBounds = LatLngBounds;
  exports2.Layer = Layer;
  exports2.LayerGroup = LayerGroup;
  exports2.LineUtil = LineUtil;
  exports2.Map = Map;
  exports2.Marker = Marker;
  exports2.Mixin = Mixin;
  exports2.Path = Path;
  exports2.Point = Point;
  exports2.PolyUtil = PolyUtil;
  exports2.Polygon = Polygon;
  exports2.Polyline = Polyline;
  exports2.Popup = Popup;
  exports2.PosAnimation = PosAnimation;
  exports2.Projection = index;
  exports2.Rectangle = Rectangle;
  exports2.Renderer = Renderer;
  exports2.SVG = SVG;
  exports2.SVGOverlay = SVGOverlay;
  exports2.TileLayer = TileLayer;
  exports2.Tooltip = Tooltip;
  exports2.Transformation = Transformation;
  exports2.Util = Util;
  exports2.VideoOverlay = VideoOverlay;
  exports2.bind = bind;
  exports2.bounds = toBounds;
  exports2.canvas = canvas;
  exports2.circle = circle;
  exports2.circleMarker = circleMarker;
  exports2.control = control;
  exports2.divIcon = divIcon;
  exports2.extend = extend;
  exports2.featureGroup = featureGroup;
  exports2.geoJSON = geoJSON;
  exports2.geoJson = geoJson;
  exports2.gridLayer = gridLayer;
  exports2.icon = icon;
  exports2.imageOverlay = imageOverlay;
  exports2.latLng = toLatLng;
  exports2.latLngBounds = toLatLngBounds;
  exports2.layerGroup = layerGroup;
  exports2.map = createMap;
  exports2.marker = marker;
  exports2.point = toPoint;
  exports2.polygon = polygon;
  exports2.polyline = polyline;
  exports2.popup = popup;
  exports2.rectangle = rectangle;
  exports2.setOptions = setOptions;
  exports2.stamp = stamp;
  exports2.svg = svg;
  exports2.svgOverlay = svgOverlay;
  exports2.tileLayer = tileLayer;
  exports2.tooltip = tooltip;
  exports2.transformation = toTransformation;
  exports2.version = version;
  exports2.videoOverlay = videoOverlay;
  var oldL = window.L;
  exports2.noConflict = function() {
    window.L = oldL;
    return this;
  };
  window.L = exports2;
}));


/***/ }),

/***/ 3707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Observer: function() { return /* reexport */ ObserverComponent; },
  clearTimers: function() { return /* binding */ clearTimers; },
  enableStaticRendering: function() { return /* reexport */ enableStaticRendering; },
  isObserverBatched: function() { return /* reexport */ isObserverBatched; },
  isUsingStaticRendering: function() { return /* reexport */ isUsingStaticRendering; },
  observer: function() { return /* reexport */ observer; },
  observerBatching: function() { return /* reexport */ observerBatching; },
  useAsObservableSource: function() { return /* reexport */ useAsObservableSource; },
  useLocalObservable: function() { return /* reexport */ useLocalObservable; },
  useLocalStore: function() { return /* reexport */ useLocalStore; },
  useObserver: function() { return /* binding */ es_useObserver; },
  useStaticRendering: function() { return /* binding */ useStaticRendering; }
});

// EXTERNAL MODULE: consume shared module (default) mobx@^6.1.0 (singleton) (fallback: ./node_modules/mobx/dist/mobx.esm.js) (eager)
var mobx_esm_js_eager_ = __webpack_require__(59217);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
;// ./node_modules/mobx-react-lite/es/utils/assertEnvironment.js


if (!index_js_eager_.useState) {
  throw new Error("mobx-react-lite requires React with Hooks support");
}
if (!mobx_esm_js_eager_.makeObservable) {
  throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");
}

// EXTERNAL MODULE: consume shared module (default) react-dom@=17.0.2 (singleton) (fallback: ./node_modules/react-dom/index.js) (eager)
var react_dom_index_js_eager_ = __webpack_require__(51971);
;// ./node_modules/mobx-react-lite/es/utils/reactBatchedUpdates.js


;// ./node_modules/mobx-react-lite/es/utils/observerBatching.js

function defaultNoopBatch(callback) {
  callback();
}
function observerBatching(reactionScheduler) {
  if (!reactionScheduler) {
    reactionScheduler = defaultNoopBatch;
    if (false) // removed by dead control flow
{}
  }
  (0,mobx_esm_js_eager_.configure)({ reactionScheduler });
}
var isObserverBatched = function() {
  if (false) // removed by dead control flow
{}
  return true;
};

;// ./node_modules/mobx-react-lite/es/utils/printDebugValue.js

function printDebugValue(v) {
  return (0,mobx_esm_js_eager_.getDependencyTree)(v);
}

;// ./node_modules/mobx-react-lite/es/utils/UniversalFinalizationRegistry.js
var REGISTRY_FINALIZE_AFTER = 1e4;
var REGISTRY_SWEEP_INTERVAL = 1e4;
var TimerBasedFinalizationRegistry = (
  /** @class */
  (function() {
    function TimerBasedFinalizationRegistry2(finalize) {
      var _this = this;
      Object.defineProperty(this, "finalize", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: finalize
      });
      Object.defineProperty(this, "registrations", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: /* @__PURE__ */ new Map()
      });
      Object.defineProperty(this, "sweepTimeout", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: void 0
      });
      Object.defineProperty(this, "sweep", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: function(maxAge) {
          if (maxAge === void 0) {
            maxAge = REGISTRY_FINALIZE_AFTER;
          }
          clearTimeout(_this.sweepTimeout);
          _this.sweepTimeout = void 0;
          var now = Date.now();
          _this.registrations.forEach(function(registration, token) {
            if (now - registration.registeredAt >= maxAge) {
              _this.finalize(registration.value);
              _this.registrations.delete(token);
            }
          });
          if (_this.registrations.size > 0) {
            _this.scheduleSweep();
          }
        }
      });
      Object.defineProperty(this, "finalizeAllImmediately", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: function() {
          _this.sweep(0);
        }
      });
    }
    Object.defineProperty(TimerBasedFinalizationRegistry2.prototype, "register", {
      enumerable: false,
      configurable: true,
      writable: true,
      value: function(target, value, token) {
        this.registrations.set(token, {
          value,
          registeredAt: Date.now()
        });
        this.scheduleSweep();
      }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry2.prototype, "unregister", {
      enumerable: false,
      configurable: true,
      writable: true,
      value: function(token) {
        this.registrations.delete(token);
      }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry2.prototype, "scheduleSweep", {
      enumerable: false,
      configurable: true,
      writable: true,
      value: function() {
        if (this.sweepTimeout === void 0) {
          this.sweepTimeout = setTimeout(this.sweep, REGISTRY_SWEEP_INTERVAL);
        }
      }
    });
    return TimerBasedFinalizationRegistry2;
  })()
);

var UniversalFinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : TimerBasedFinalizationRegistry;

;// ./node_modules/mobx-react-lite/es/utils/observerFinalizationRegistry.js

var observerFinalizationRegistry = new UniversalFinalizationRegistry(function(adm) {
  var _a;
  (_a = adm.reaction) === null || _a === void 0 ? void 0 : _a.dispose();
  adm.reaction = null;
});

;// ./node_modules/mobx-react-lite/es/staticRendering.js
var globalIsUsingStaticRendering = false;
function enableStaticRendering(enable) {
  globalIsUsingStaticRendering = enable;
}
function isUsingStaticRendering() {
  return globalIsUsingStaticRendering;
}

;// ./node_modules/mobx-react-lite/es/useObserver.js
var __read = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};





function observerComponentNameFor(baseComponentName) {
  return "observer".concat(baseComponentName);
}
var ObjectToBeRetainedByReact = (
  /** @class */
  /* @__PURE__ */ (function() {
    function ObjectToBeRetainedByReact2() {
    }
    return ObjectToBeRetainedByReact2;
  })()
);
function objectToBeRetainedByReactFactory() {
  return new ObjectToBeRetainedByReact();
}
function useObserver(fn, baseComponentName) {
  if (baseComponentName === void 0) {
    baseComponentName = "observed";
  }
  if (isUsingStaticRendering()) {
    return fn();
  }
  var _a = __read(index_js_eager_.useState(objectToBeRetainedByReactFactory), 1), objectRetainedByReact = _a[0];
  var _b = __read(index_js_eager_.useState(), 2), setState = _b[1];
  var forceUpdate = function() {
    return setState([]);
  };
  var admRef = index_js_eager_.useRef(null);
  if (!admRef.current) {
    admRef.current = {
      reaction: null,
      mounted: false,
      changedBeforeMount: false
    };
  }
  var adm = admRef.current;
  if (!adm.reaction) {
    adm.reaction = new mobx_esm_js_eager_.Reaction(observerComponentNameFor(baseComponentName), function() {
      if (adm.mounted) {
        forceUpdate();
      } else {
        adm.changedBeforeMount = true;
      }
    });
    observerFinalizationRegistry.register(objectRetainedByReact, adm, adm);
  }
  index_js_eager_.useDebugValue(adm.reaction, printDebugValue);
  index_js_eager_.useEffect(function() {
    observerFinalizationRegistry.unregister(adm);
    adm.mounted = true;
    if (adm.reaction) {
      if (adm.changedBeforeMount) {
        adm.changedBeforeMount = false;
        forceUpdate();
      }
    } else {
      adm.reaction = new mobx_esm_js_eager_.Reaction(observerComponentNameFor(baseComponentName), function() {
        forceUpdate();
      });
      forceUpdate();
    }
    return function() {
      adm.reaction.dispose();
      adm.reaction = null;
      adm.mounted = false;
      adm.changedBeforeMount = false;
    };
  }, []);
  var rendering;
  var exception;
  adm.reaction.track(function() {
    try {
      rendering = fn();
    } catch (e) {
      exception = e;
    }
  });
  if (exception) {
    throw exception;
  }
  return rendering;
}

;// ./node_modules/mobx-react-lite/es/observer.js



var warnObserverOptionsDeprecated = true;
var hasSymbol = typeof Symbol === "function" && Symbol.for;
var ReactForwardRefSymbol = hasSymbol ? /* @__PURE__ */ Symbol.for("react.forward_ref") : typeof index_js_eager_.forwardRef === "function" && (0,index_js_eager_.forwardRef)(function(props) {
  return null;
})["$$typeof"];
var ReactMemoSymbol = hasSymbol ? /* @__PURE__ */ Symbol.for("react.memo") : typeof index_js_eager_.memo === "function" && (0,index_js_eager_.memo)(function(props) {
  return null;
})["$$typeof"];
function observer(baseComponent, options) {
  var _a;
  if (false) // removed by dead control flow
{}
  if (ReactMemoSymbol && baseComponent["$$typeof"] === ReactMemoSymbol) {
    throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
  }
  if (isUsingStaticRendering()) {
    return baseComponent;
  }
  var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
  var render = baseComponent;
  var baseComponentName = baseComponent.displayName || baseComponent.name;
  if (ReactForwardRefSymbol && baseComponent["$$typeof"] === ReactForwardRefSymbol) {
    useForwardRef = true;
    render = baseComponent["render"];
    if (typeof render !== "function") {
      throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
  }
  var observerComponent = function(props, ref) {
    return useObserver(function() {
      return render(props, ref);
    }, baseComponentName);
  };
  if (baseComponentName !== "") {
    ;
    observerComponent.displayName = baseComponentName;
  }
  if (baseComponent.contextTypes) {
    ;
    observerComponent.contextTypes = baseComponent.contextTypes;
  }
  if (useForwardRef) {
    observerComponent = (0,index_js_eager_.forwardRef)(observerComponent);
  }
  observerComponent = (0,index_js_eager_.memo)(observerComponent);
  copyStaticProperties(baseComponent, observerComponent);
  if (false) // removed by dead control flow
{}
  return observerComponent;
}
var hoistBlackList = {
  $$typeof: true,
  render: true,
  compare: true,
  type: true,
  // Don't redefine `displayName`,
  // it's defined as getter-setter pair on `memo` (see #3192).
  displayName: true
};
function copyStaticProperties(base, target) {
  Object.keys(base).forEach(function(key) {
    if (!hoistBlackList[key]) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    }
  });
}

;// ./node_modules/mobx-react-lite/es/ObserverComponent.js

function ObserverComponent(_a) {
  var children = _a.children, render = _a.render;
  var component = children || render;
  if (typeof component !== "function") {
    return null;
  }
  return useObserver(component);
}
if (false) // removed by dead control flow
{}
ObserverComponent.displayName = "Observer";

function ObserverPropsCheck(props, key, componentName, location, propFullName) {
  var extraKey = key === "children" ? "render" : "children";
  var hasProp = typeof props[key] === "function";
  var hasExtraProp = typeof props[extraKey] === "function";
  if (hasProp && hasExtraProp) {
    return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
  }
  if (hasProp || hasExtraProp) {
    return null;
  }
  return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to `" + componentName + "`, expected `function`.");
}

;// ./node_modules/mobx-react-lite/es/useLocalObservable.js


function useLocalObservable(initializer, annotations) {
  return (0,index_js_eager_.useState)(function() {
    return (0,mobx_esm_js_eager_.observable)(initializer(), annotations, { autoBind: true });
  })[0];
}

;// ./node_modules/mobx-react-lite/es/useAsObservableSource.js
var useAsObservableSource_read = function(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = { error };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};



function useAsObservableSource(current) {
  if (false)
    // removed by dead control flow
{}
  var _a = useAsObservableSource_read((0,index_js_eager_.useState)(function() {
    return (0,mobx_esm_js_eager_.observable)(current, {}, { deep: false });
  }), 1), res = _a[0];
  (0,mobx_esm_js_eager_.runInAction)(function() {
    Object.assign(res, current);
  });
  return res;
}

;// ./node_modules/mobx-react-lite/es/useLocalStore.js




function useLocalStore(initializer, current) {
  if (false)
    // removed by dead control flow
{}
  var source = current && useAsObservableSource(current);
  return (0,index_js_eager_.useState)(function() {
    return (0,mobx_esm_js_eager_.observable)(initializer(source), void 0, { autoBind: true });
  })[0];
}

;// ./node_modules/mobx-react-lite/es/index.js
var _a;







observerBatching(react_dom_index_js_eager_.unstable_batchedUpdates);






var clearTimers = (_a = observerFinalizationRegistry["finalizeAllImmediately"]) !== null && _a !== void 0 ? _a : (function() {
});
function es_useObserver(fn, baseComponentName) {
  if (baseComponentName === void 0) {
    baseComponentName = "observed";
  }
  if (false) // removed by dead control flow
{}
  return useObserver(fn, baseComponentName);
}

function useStaticRendering(enable) {
  if (false) // removed by dead control flow
{}
  enableStaticRendering(enable);
}


/***/ }),

/***/ 48235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   $mobx: function() { return /* binding */ $mobx; },
/* harmony export */   FlowCancellationError: function() { return /* binding */ FlowCancellationError; },
/* harmony export */   ObservableMap: function() { return /* binding */ ObservableMap; },
/* harmony export */   ObservableSet: function() { return /* binding */ ObservableSet; },
/* harmony export */   Reaction: function() { return /* binding */ Reaction; },
/* harmony export */   _allowStateChanges: function() { return /* binding */ allowStateChanges; },
/* harmony export */   _allowStateChangesInsideComputed: function() { return /* binding */ runInAction; },
/* harmony export */   _allowStateReadsEnd: function() { return /* binding */ allowStateReadsEnd; },
/* harmony export */   _allowStateReadsStart: function() { return /* binding */ allowStateReadsStart; },
/* harmony export */   _autoAction: function() { return /* binding */ autoAction; },
/* harmony export */   _endAction: function() { return /* binding */ _endAction; },
/* harmony export */   _getAdministration: function() { return /* binding */ getAdministration; },
/* harmony export */   _getGlobalState: function() { return /* binding */ getGlobalState; },
/* harmony export */   _interceptReads: function() { return /* binding */ interceptReads; },
/* harmony export */   _isComputingDerivation: function() { return /* binding */ isComputingDerivation; },
/* harmony export */   _resetGlobalState: function() { return /* binding */ resetGlobalState; },
/* harmony export */   _startAction: function() { return /* binding */ _startAction; },
/* harmony export */   action: function() { return /* binding */ action; },
/* harmony export */   autorun: function() { return /* binding */ autorun; },
/* harmony export */   comparer: function() { return /* binding */ comparer; },
/* harmony export */   computed: function() { return /* binding */ computed; },
/* harmony export */   configure: function() { return /* binding */ configure; },
/* harmony export */   createAtom: function() { return /* binding */ createAtom; },
/* harmony export */   defineProperty: function() { return /* binding */ apiDefineProperty; },
/* harmony export */   entries: function() { return /* binding */ entries; },
/* harmony export */   extendObservable: function() { return /* binding */ extendObservable; },
/* harmony export */   flow: function() { return /* binding */ flow; },
/* harmony export */   flowResult: function() { return /* binding */ flowResult; },
/* harmony export */   get: function() { return /* binding */ get; },
/* harmony export */   getAtom: function() { return /* binding */ getAtom; },
/* harmony export */   getDebugName: function() { return /* binding */ getDebugName; },
/* harmony export */   getDependencyTree: function() { return /* binding */ getDependencyTree; },
/* harmony export */   getObserverTree: function() { return /* binding */ getObserverTree; },
/* harmony export */   has: function() { return /* binding */ has; },
/* harmony export */   intercept: function() { return /* binding */ intercept; },
/* harmony export */   isAction: function() { return /* binding */ isAction; },
/* harmony export */   isBoxedObservable: function() { return /* binding */ isObservableValue; },
/* harmony export */   isComputed: function() { return /* binding */ isComputed; },
/* harmony export */   isComputedProp: function() { return /* binding */ isComputedProp; },
/* harmony export */   isFlow: function() { return /* binding */ isFlow; },
/* harmony export */   isFlowCancellationError: function() { return /* binding */ isFlowCancellationError; },
/* harmony export */   isObservable: function() { return /* binding */ isObservable; },
/* harmony export */   isObservableArray: function() { return /* binding */ isObservableArray; },
/* harmony export */   isObservableMap: function() { return /* binding */ isObservableMap; },
/* harmony export */   isObservableObject: function() { return /* binding */ isObservableObject; },
/* harmony export */   isObservableProp: function() { return /* binding */ isObservableProp; },
/* harmony export */   isObservableSet: function() { return /* binding */ isObservableSet; },
/* harmony export */   keys: function() { return /* binding */ keys; },
/* harmony export */   makeAutoObservable: function() { return /* binding */ makeAutoObservable; },
/* harmony export */   makeObservable: function() { return /* binding */ makeObservable; },
/* harmony export */   observable: function() { return /* binding */ observable; },
/* harmony export */   observe: function() { return /* binding */ observe; },
/* harmony export */   onBecomeObserved: function() { return /* binding */ onBecomeObserved; },
/* harmony export */   onBecomeUnobserved: function() { return /* binding */ onBecomeUnobserved; },
/* harmony export */   onReactionError: function() { return /* binding */ onReactionError; },
/* harmony export */   override: function() { return /* binding */ override; },
/* harmony export */   ownKeys: function() { return /* binding */ apiOwnKeys; },
/* harmony export */   reaction: function() { return /* binding */ reaction; },
/* harmony export */   remove: function() { return /* binding */ remove; },
/* harmony export */   runInAction: function() { return /* binding */ runInAction; },
/* harmony export */   set: function() { return /* binding */ set2; },
/* harmony export */   spy: function() { return /* binding */ spy; },
/* harmony export */   toJS: function() { return /* binding */ toJS; },
/* harmony export */   trace: function() { return /* binding */ trace; },
/* harmony export */   transaction: function() { return /* binding */ transaction; },
/* harmony export */   untracked: function() { return /* binding */ untracked; },
/* harmony export */   values: function() { return /* binding */ values; },
/* harmony export */   when: function() { return /* binding */ when; }
/* harmony export */ });
var niceErrors = (/* unused pure expression or super */ null && ({
  0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
  1: function _(annotationType, key) {
    return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
  },
  /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */
  5: "'keys()' can only be used on observable objects, arrays, sets and maps",
  6: "'values()' can only be used on observable objects, arrays, sets and maps",
  7: "'entries()' can only be used on observable objects, arrays and maps",
  8: "'set()' can only be used on observable objects, arrays and maps",
  9: "'remove()' can only be used on observable objects, arrays and maps",
  10: "'has()' can only be used on observable objects, arrays and maps",
  11: "'get()' can only be used on observable objects, arrays and maps",
  12: "Invalid annotation",
  13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  14: "Intercept handlers should return nothing or a change object",
  15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
  16: "Modification exception: the internal structure of an observable array was changed.",
  17: function _2(index, length) {
    return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
  },
  18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
  19: function _3(other) {
    return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
  },
  20: function _4(other) {
    return "Cannot initialize map from " + other;
  },
  21: function _5(dataStructure) {
    return "Cannot convert to map from '" + dataStructure + "'";
  },
  22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
  23: "It is not possible to get index atoms from arrays",
  24: function _6(thing) {
    return "Cannot obtain administration from " + thing;
  },
  25: function _7(property, name) {
    return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
  },
  26: "please specify a property",
  27: function _8(property, name) {
    return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
  },
  28: function _9(thing) {
    return "Cannot obtain atom from " + thing;
  },
  29: "Expecting some object",
  30: "invalid action stack. did you forget to finish an action?",
  31: "missing option for computed: get",
  32: function _10(name, derivation) {
    return "Cycle detected in computation " + name + ": " + derivation;
  },
  33: function _11(name) {
    return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
  },
  34: function _12(name) {
    return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
  },
  35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
  36: "isolateGlobalState should be called before MobX is running any reactions",
  37: function _13(method) {
    return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
  },
  38: "'ownKeys()' can only be used on observable objects",
  39: "'defineProperty()' can only be used on observable objects"
}));
var errors = (/* unused pure expression or super */ null && ( false ? 0 : {}));
function die(error) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  if (false) // removed by dead control flow
{ var e; }
  throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof __webpack_require__.g !== "undefined") {
    return __webpack_require__.g;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  return mockGlobal;
}
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /* @__PURE__ */ Object.toString();
function assertProxies() {
  if (!hasProxy) {
    die( false ? 0 : "Proxy not available");
  }
}
function warnAboutProxyRequirement(msg) {
  if (false) // removed by dead control flow
{}
}
function getNextId() {
  return ++globalState.mobxGuid;
}
function once(func) {
  var invoked = false;
  return function() {
    if (invoked) {
      return;
    }
    invoked = true;
    return func.apply(this, arguments);
  };
}
var noop = function noop2() {
};
function isFunction(fn) {
  return typeof fn === "function";
}
function isStringish(value) {
  var t = typeof value;
  switch (t) {
    case "string":
    case "symbol":
    case "number":
      return true;
  }
  return false;
}
function isObject(value) {
  return value !== null && typeof value === "object";
}
function isPlainObject(value) {
  if (!isObject(value)) {
    return false;
  }
  var proto = Object.getPrototypeOf(value);
  if (proto == null) {
    return true;
  }
  var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
function isGenerator(obj) {
  var constructor = obj == null ? void 0 : obj.constructor;
  if (!constructor) {
    return false;
  }
  if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) {
    return true;
  }
  return false;
}
function addHiddenProp(object2, propName, value) {
  defineProperty(object2, propName, {
    enumerable: false,
    writable: true,
    configurable: true,
    value
  });
}
function addHiddenFinalProp(object2, propName, value) {
  defineProperty(object2, propName, {
    enumerable: false,
    writable: false,
    configurable: true,
    value
  });
}
function createInstanceofPredicate(name, theClass) {
  var propName = "isMobX" + name;
  theClass.prototype[propName] = true;
  return function(x) {
    return isObject(x) && x[propName] === true;
  };
}
function isES6Map(thing) {
  return thing instanceof Map;
}
function isES6Set(thing) {
  return thing instanceof Set;
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
function getPlainObjectKeys(object2) {
  var keys2 = Object.keys(object2);
  if (!hasGetOwnPropertySymbols) {
    return keys2;
  }
  var symbols = Object.getOwnPropertySymbols(object2);
  if (!symbols.length) {
    return keys2;
  }
  return [].concat(keys2, symbols.filter(function(s) {
    return objectPrototype.propertyIsEnumerable.call(object2, s);
  }));
}
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
  return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : (
  /* istanbul ignore next */
  Object.getOwnPropertyNames
);
function stringifyKey(key) {
  if (typeof key === "string") {
    return key;
  }
  if (typeof key === "symbol") {
    return key.toString();
  }
  return new String(key).toString();
}
function toPrimitive(value) {
  return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
  return objectPrototype.hasOwnProperty.call(target, prop);
}
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors2(target) {
  var res = {};
  ownKeys(target).forEach(function(key) {
    res[key] = getDescriptor(target, key);
  });
  return res;
};
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function() {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
var storedAnnotationsSymbol = /* @__PURE__ */ Symbol("mobx-stored-annotations");
function createDecoratorAnnotation(annotation) {
  function decorator(target, property) {
    storeAnnotation(target, property, annotation);
  }
  return Object.assign(decorator, annotation);
}
function storeAnnotation(prototype, key, annotation) {
  if (!hasProp(prototype, storedAnnotationsSymbol)) {
    addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
  }
  if (false) // removed by dead control flow
{ var fieldName; }
  assertNotDecorated(prototype, annotation, key);
  if (!isOverride(annotation)) {
    prototype[storedAnnotationsSymbol][key] = annotation;
  }
}
function assertNotDecorated(prototype, annotation, key) {
  if (false) // removed by dead control flow
{ var requestedAnnotationType, currentAnnotationType, fieldName; }
}
function collectStoredAnnotations(target) {
  if (!hasProp(target, storedAnnotationsSymbol)) {
    if (false) // removed by dead control flow
{}
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
  }
  return target[storedAnnotationsSymbol];
}
var $mobx = /* @__PURE__ */ Symbol("mobx administration");
var Atom = /* @__PURE__ */ (function() {
  function Atom2(name_) {
    if (name_ === void 0) {
      name_ =  false ? 0 : "Atom";
    }
    this.name_ = void 0;
    this.isPendingUnobservation_ = false;
    this.isBeingObserved_ = false;
    this.observers_ = /* @__PURE__ */ new Set();
    this.diffValue_ = 0;
    this.lastAccessedBy_ = 0;
    this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
    this.onBOL = void 0;
    this.onBUOL = void 0;
    this.name_ = name_;
  }
  var _proto = Atom2.prototype;
  _proto.onBO = function onBO() {
    if (this.onBOL) {
      this.onBOL.forEach(function(listener) {
        return listener();
      });
    }
  };
  _proto.onBUO = function onBUO() {
    if (this.onBUOL) {
      this.onBUOL.forEach(function(listener) {
        return listener();
      });
    }
  };
  _proto.reportObserved = function reportObserved$1() {
    return reportObserved(this);
  };
  _proto.reportChanged = function reportChanged() {
    startBatch();
    propagateChanged(this);
    globalState.stateVersion = globalState.stateVersion < Number.MAX_SAFE_INTEGER ? globalState.stateVersion + 1 : Number.MIN_SAFE_INTEGER;
    endBatch();
  };
  _proto.toString = function toString2() {
    return this.name_;
  };
  return Atom2;
})();
var isAtom = /* @__PURE__ */ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
  if (onBecomeObservedHandler === void 0) {
    onBecomeObservedHandler = noop;
  }
  if (onBecomeUnobservedHandler === void 0) {
    onBecomeUnobservedHandler = noop;
  }
  var atom = new Atom(name);
  if (onBecomeObservedHandler !== noop) {
    onBecomeObserved(atom, onBecomeObservedHandler);
  }
  if (onBecomeUnobservedHandler !== noop) {
    onBecomeUnobserved(atom, onBecomeUnobservedHandler);
  }
  return atom;
}
function identityComparer(a, b) {
  return a === b;
}
function structuralComparer(a, b) {
  return deepEqual(a, b);
}
function shallowComparer(a, b) {
  return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
  if (Object.is) {
    return Object.is(a, b);
  }
  return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
  identity: identityComparer,
  structural: structuralComparer,
  "default": defaultComparer,
  shallow: shallowComparer
};
function deepEnhancer(v, _14, name) {
  if (isObservable(v)) {
    return v;
  }
  if (Array.isArray(v)) {
    return observable.array(v, {
      name
    });
  }
  if (isPlainObject(v)) {
    return observable.object(v, void 0, {
      name
    });
  }
  if (isES6Map(v)) {
    return observable.map(v, {
      name
    });
  }
  if (isES6Set(v)) {
    return observable.set(v, {
      name
    });
  }
  if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
    if (isGenerator(v)) {
      return flow(v);
    } else {
      return autoAction(name, v);
    }
  }
  return v;
}
function shallowEnhancer(v, _14, name) {
  if (v === void 0 || v === null) {
    return v;
  }
  if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) {
    return v;
  }
  if (Array.isArray(v)) {
    return observable.array(v, {
      name,
      deep: false
    });
  }
  if (isPlainObject(v)) {
    return observable.object(v, void 0, {
      name,
      deep: false
    });
  }
  if (isES6Map(v)) {
    return observable.map(v, {
      name,
      deep: false
    });
  }
  if (isES6Set(v)) {
    return observable.set(v, {
      name,
      deep: false
    });
  }
  if (false) // removed by dead control flow
{}
}
function referenceEnhancer(newValue) {
  return newValue;
}
function refStructEnhancer(v, oldValue) {
  if (false) // removed by dead control flow
{}
  if (deepEqual(v, oldValue)) {
    return oldValue;
  }
  return v;
}
var OVERRIDE = "override";
var override = /* @__PURE__ */ createDecoratorAnnotation({
  annotationType_: OVERRIDE,
  make_,
  extend_
});
function isOverride(annotation) {
  return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
  if (false) // removed by dead control flow
{}
  if (false) // removed by dead control flow
{}
  return 0;
}
function extend_(adm, key, descriptor, proxyTrap) {
  die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function createActionAnnotation(name, options) {
  return {
    annotationType_: name,
    options_: options,
    make_: make_$1,
    extend_: extend_$1
  };
}
function make_$1(adm, key, descriptor, source) {
  var _this$options_;
  if ((_this$options_ = this.options_) != null && _this$options_.bound) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 : 1;
  }
  if (source === adm.target_) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 : 2;
  }
  if (isAction(descriptor.value)) {
    return 1;
  }
  var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
  defineProperty(source, key, actionDescriptor);
  return 2;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
  var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
  return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
  var annotationType_ = _ref.annotationType_;
  var value = _ref2.value;
  if (false) // removed by dead control flow
{}
}
function createActionDescriptor(adm, annotation, key, descriptor, safeDescriptors) {
  var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
  if (safeDescriptors === void 0) {
    safeDescriptors = globalState.safeDescriptors;
  }
  assertActionDescriptor(adm, annotation, key, descriptor);
  var value = descriptor.value;
  if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
    var _adm$proxy_;
    value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
  }
  return {
    value: createAction(
      (_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(),
      value,
      (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false,
      // https://github.com/mobxjs/mobx/discussions/3140
      (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : void 0
    ),
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: safeDescriptors ? adm.isPlainObject_ : true,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: false,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: safeDescriptors ? false : true
  };
}
function createFlowAnnotation(name, options) {
  return {
    annotationType_: name,
    options_: options,
    make_: make_$2,
    extend_: extend_$2
  };
}
function make_$2(adm, key, descriptor, source) {
  var _this$options_;
  if (source === adm.target_) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 : 2;
  }
  if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
    if (this.extend_(adm, key, descriptor, false) === null) {
      return 0;
    }
  }
  if (isFlow(descriptor.value)) {
    return 1;
  }
  var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
  defineProperty(source, key, flowDescriptor);
  return 2;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
  var _this$options_2;
  var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
  return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
  var annotationType_ = _ref.annotationType_;
  var value = _ref2.value;
  if (false) // removed by dead control flow
{}
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, safeDescriptors) {
  if (safeDescriptors === void 0) {
    safeDescriptors = globalState.safeDescriptors;
  }
  assertFlowDescriptor(adm, annotation, key, descriptor);
  var value = descriptor.value;
  if (!isFlow(value)) {
    value = flow(value);
  }
  if (bound) {
    var _adm$proxy_;
    value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    value.isMobXFlow = true;
  }
  return {
    value,
    // Non-configurable for classes
    // prevents accidental field redefinition in subclass
    configurable: safeDescriptors ? adm.isPlainObject_ : true,
    // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
    enumerable: false,
    // Non-obsevable, therefore non-writable
    // Also prevents rewriting in subclass constructor
    writable: safeDescriptors ? false : true
  };
}
function createComputedAnnotation(name, options) {
  return {
    annotationType_: name,
    options_: options,
    make_: make_$3,
    extend_: extend_$3
  };
}
function make_$3(adm, key, descriptor) {
  return this.extend_(adm, key, descriptor, false) === null ? 0 : 1;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
  assertComputedDescriptor(adm, this, key, descriptor);
  return adm.defineComputedProperty_(key, _extends({}, this.options_, {
    get: descriptor.get,
    set: descriptor.set
  }), proxyTrap);
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
  var annotationType_ = _ref.annotationType_;
  var get4 = _ref2.get;
  if (false) // removed by dead control flow
{}
}
function createObservableAnnotation(name, options) {
  return {
    annotationType_: name,
    options_: options,
    make_: make_$4,
    extend_: extend_$4
  };
}
function make_$4(adm, key, descriptor) {
  return this.extend_(adm, key, descriptor, false) === null ? 0 : 1;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
  var _this$options_$enhanc, _this$options_;
  assertObservableDescriptor(adm, this, key, descriptor);
  return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
  var annotationType_ = _ref.annotationType_;
  if (false) // removed by dead control flow
{}
}
var AUTO = "true";
var autoAnnotation = /* @__PURE__ */ createAutoAnnotation();
function createAutoAnnotation(options) {
  return {
    annotationType_: AUTO,
    options_: options,
    make_: make_$5,
    extend_: extend_$5
  };
}
function make_$5(adm, key, descriptor, source) {
  var _this$options_3, _this$options_4;
  if (descriptor.get) {
    return computed.make_(adm, key, descriptor, source);
  }
  if (descriptor.set) {
    var set5 = createAction(key.toString(), descriptor.set);
    if (source === adm.target_) {
      return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: set5
      }) === null ? 0 : 2;
    }
    defineProperty(source, key, {
      configurable: true,
      set: set5
    });
    return 2;
  }
  if (source !== adm.target_ && typeof descriptor.value === "function") {
    var _this$options_2;
    if (isGenerator(descriptor.value)) {
      var _this$options_;
      var flowAnnotation2 = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
      return flowAnnotation2.make_(adm, key, descriptor, source);
    }
    var actionAnnotation2 = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
    return actionAnnotation2.make_(adm, key, descriptor, source);
  }
  var observableAnnotation2 = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
  if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
    var _adm$proxy_;
    descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
  }
  return observableAnnotation2.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
  var _this$options_5, _this$options_6;
  if (descriptor.get) {
    return computed.extend_(adm, key, descriptor, proxyTrap);
  }
  if (descriptor.set) {
    return adm.defineProperty_(key, {
      configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
      set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
  }
  if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
    var _adm$proxy_2;
    descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
  }
  var observableAnnotation2 = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
  return observableAnnotation2.extend_(adm, key, descriptor, proxyTrap);
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
var defaultCreateObservableOptions = {
  deep: true,
  name: void 0,
  defaultDecorator: void 0,
  proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
  return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE_REF, {
  enhancer: referenceEnhancer
});
var observableShallowAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE_SHALLOW, {
  enhancer: shallowEnhancer
});
var observableStructAnnotation = /* @__PURE__ */ createObservableAnnotation(OBSERVABLE_STRUCT, {
  enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /* @__PURE__ */ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
  return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
  var _options$defaultDecor;
  return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : void 0;
}
function getEnhancerFromAnnotation(annotation) {
  var _annotation$options_$, _annotation$options_;
  return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
function createObservable(v, arg2, arg3) {
  if (isStringish(arg2)) {
    storeAnnotation(v, arg2, observableAnnotation);
    return;
  }
  if (isObservable(v)) {
    return v;
  }
  if (isPlainObject(v)) {
    return observable.object(v, arg2, arg3);
  }
  if (Array.isArray(v)) {
    return observable.array(v, arg2);
  }
  if (isES6Map(v)) {
    return observable.map(v, arg2);
  }
  if (isES6Set(v)) {
    return observable.set(v, arg2);
  }
  if (typeof v === "object" && v !== null) {
    return v;
  }
  return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
  box: function box(value, options) {
    var o = asCreateObservableOptions(options);
    return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
  },
  array: function array(initialValues, options) {
    var o = asCreateObservableOptions(options);
    return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
  },
  map: function map(initialValues, options) {
    var o = asCreateObservableOptions(options);
    return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
  },
  set: function set(initialValues, options) {
    var o = asCreateObservableOptions(options);
    return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
  },
  object: function object(props, decorators, options) {
    return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
  },
  ref: /* @__PURE__ */ createDecoratorAnnotation(observableRefAnnotation),
  shallow: /* @__PURE__ */ createDecoratorAnnotation(observableShallowAnnotation),
  deep: observableDecoratorAnnotation,
  struct: /* @__PURE__ */ createDecoratorAnnotation(observableStructAnnotation)
};
var observable = /* @__PURE__ */ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /* @__PURE__ */ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /* @__PURE__ */ createComputedAnnotation(COMPUTED_STRUCT, {
  equals: comparer.structural
});
var computed = function computed2(arg1, arg2) {
  if (isStringish(arg2)) {
    return storeAnnotation(arg1, arg2, computedAnnotation);
  }
  if (isPlainObject(arg1)) {
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
  }
  if (false) // removed by dead control flow
{}
  var opts = isPlainObject(arg2) ? arg2 : {};
  opts.get = arg1;
  opts.name || (opts.name = arg1.name || "");
  return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /* @__PURE__ */ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /* @__PURE__ */ getDescriptor(function() {
}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
var tmpNameDescriptor = {
  value: "action",
  configurable: true,
  writable: false,
  enumerable: false
};
function createAction(actionName, fn, autoAction2, ref) {
  if (autoAction2 === void 0) {
    autoAction2 = false;
  }
  if (false) // removed by dead control flow
{}
  function res() {
    return executeAction(actionName, autoAction2, fn, ref || this, arguments);
  }
  res.isMobxAction = true;
  if (isFunctionNameConfigurable) {
    tmpNameDescriptor.value = actionName;
    defineProperty(res, "name", tmpNameDescriptor);
  }
  return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
  var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
  try {
    return fn.apply(scope, args);
  } catch (err) {
    runInfo.error_ = err;
    throw err;
  } finally {
    _endAction(runInfo);
  }
}
function _startAction(actionName, canRunAsDerivation, scope, args) {
  var notifySpy_ =  false && 0;
  var startTime_ = 0;
  if (false) // removed by dead control flow
{ var flattenedArgs; }
  var prevDerivation_ = globalState.trackingDerivation;
  var runAsAction = !canRunAsDerivation || !prevDerivation_;
  startBatch();
  var prevAllowStateChanges_ = globalState.allowStateChanges;
  if (runAsAction) {
    untrackedStart();
    prevAllowStateChanges_ = allowStateChangesStart(true);
  }
  var prevAllowStateReads_ = allowStateReadsStart(true);
  var runInfo = {
    runAsAction_: runAsAction,
    prevDerivation_,
    prevAllowStateChanges_,
    prevAllowStateReads_,
    notifySpy_,
    startTime_,
    actionId_: nextActionId++,
    parentActionId_: currentActionId
  };
  currentActionId = runInfo.actionId_;
  return runInfo;
}
function _endAction(runInfo) {
  if (currentActionId !== runInfo.actionId_) {
    die(30);
  }
  currentActionId = runInfo.parentActionId_;
  if (runInfo.error_ !== void 0) {
    globalState.suppressReactionErrors = true;
  }
  allowStateChangesEnd(runInfo.prevAllowStateChanges_);
  allowStateReadsEnd(runInfo.prevAllowStateReads_);
  endBatch();
  if (runInfo.runAsAction_) {
    untrackedEnd(runInfo.prevDerivation_);
  }
  if (false) // removed by dead control flow
{}
  globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges2, func) {
  var prev = allowStateChangesStart(allowStateChanges2);
  try {
    return func();
  } finally {
    allowStateChangesEnd(prev);
  }
}
function allowStateChangesStart(allowStateChanges2) {
  var prev = globalState.allowStateChanges;
  globalState.allowStateChanges = allowStateChanges2;
  return prev;
}
function allowStateChangesEnd(prev) {
  globalState.allowStateChanges = prev;
}
var _Symbol$toPrimitive;
var CREATE = "create";
_Symbol$toPrimitive = Symbol.toPrimitive;
var ObservableValue = /* @__PURE__ */ (function(_Atom) {
  _inheritsLoose(ObservableValue2, _Atom);
  function ObservableValue2(value, enhancer, name_, notifySpy, equals) {
    var _this;
    if (name_ === void 0) {
      name_ =  false ? 0 : "ObservableValue";
    }
    if (notifySpy === void 0) {
      notifySpy = true;
    }
    if (equals === void 0) {
      equals = comparer["default"];
    }
    _this = _Atom.call(this, name_) || this;
    _this.enhancer = void 0;
    _this.name_ = void 0;
    _this.equals = void 0;
    _this.hasUnreportedChange_ = false;
    _this.interceptors_ = void 0;
    _this.changeListeners_ = void 0;
    _this.value_ = void 0;
    _this.dehancer = void 0;
    _this.enhancer = enhancer;
    _this.name_ = name_;
    _this.equals = equals;
    _this.value_ = enhancer(value, void 0, name_);
    if (false) // removed by dead control flow
{}
    return _this;
  }
  var _proto = ObservableValue2.prototype;
  _proto.dehanceValue = function dehanceValue(value) {
    if (this.dehancer !== void 0) {
      return this.dehancer(value);
    }
    return value;
  };
  _proto.set = function set5(newValue) {
    var oldValue = this.value_;
    newValue = this.prepareNewValue_(newValue);
    if (newValue !== globalState.UNCHANGED) {
      var notifySpy = isSpyEnabled();
      if (false) // removed by dead control flow
{}
      this.setNewValue_(newValue);
      if (false) // removed by dead control flow
{}
    }
  };
  _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
    checkIfStateModificationsAreAllowed(this);
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        object: this,
        type: UPDATE,
        newValue
      });
      if (!change) {
        return globalState.UNCHANGED;
      }
      newValue = change.newValue;
    }
    newValue = this.enhancer(newValue, this.value_, this.name_);
    return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
  };
  _proto.setNewValue_ = function setNewValue_(newValue) {
    var oldValue = this.value_;
    this.value_ = newValue;
    this.reportChanged();
    if (hasListeners(this)) {
      notifyListeners(this, {
        type: UPDATE,
        object: this,
        newValue,
        oldValue
      });
    }
  };
  _proto.get = function get4() {
    this.reportObserved();
    return this.dehanceValue(this.value_);
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    if (fireImmediately) {
      listener({
        observableKind: "value",
        debugObjectName: this.name_,
        object: this,
        type: UPDATE,
        newValue: this.value_,
        oldValue: void 0
      });
    }
    return registerListener(this, listener);
  };
  _proto.raw = function raw() {
    return this.value_;
  };
  _proto.toJSON = function toJSON2() {
    return this.get();
  };
  _proto.toString = function toString2() {
    return this.name_ + "[" + this.value_ + "]";
  };
  _proto.valueOf = function valueOf() {
    return toPrimitive(this.get());
  };
  _proto[_Symbol$toPrimitive] = function() {
    return this.valueOf();
  };
  return ObservableValue2;
})(Atom);
var isObservableValue = /* @__PURE__ */ createInstanceofPredicate("ObservableValue", ObservableValue);
var _Symbol$toPrimitive$1;
_Symbol$toPrimitive$1 = Symbol.toPrimitive;
var ComputedValue = /* @__PURE__ */ (function() {
  function ComputedValue2(options) {
    this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
    this.observing_ = [];
    this.newObserving_ = null;
    this.isBeingObserved_ = false;
    this.isPendingUnobservation_ = false;
    this.observers_ = /* @__PURE__ */ new Set();
    this.diffValue_ = 0;
    this.runId_ = 0;
    this.lastAccessedBy_ = 0;
    this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    this.unboundDepsCount_ = 0;
    this.value_ = new CaughtException(null);
    this.name_ = void 0;
    this.triggeredBy_ = void 0;
    this.isComputing_ = false;
    this.isRunningSetter_ = false;
    this.derivation = void 0;
    this.setter_ = void 0;
    this.isTracing_ = TraceMode.NONE;
    this.scope_ = void 0;
    this.equals_ = void 0;
    this.requiresReaction_ = void 0;
    this.keepAlive_ = void 0;
    this.onBOL = void 0;
    this.onBUOL = void 0;
    if (!options.get) {
      die(31);
    }
    this.derivation = options.get;
    this.name_ = options.name || ( false ? 0 : "ComputedValue");
    if (options.set) {
      this.setter_ = createAction( false ? 0 : "ComputedValue-setter", options.set);
    }
    this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
    this.scope_ = options.context;
    this.requiresReaction_ = options.requiresReaction;
    this.keepAlive_ = !!options.keepAlive;
  }
  var _proto = ComputedValue2.prototype;
  _proto.onBecomeStale_ = function onBecomeStale_() {
    propagateMaybeChanged(this);
  };
  _proto.onBO = function onBO() {
    if (this.onBOL) {
      this.onBOL.forEach(function(listener) {
        return listener();
      });
    }
  };
  _proto.onBUO = function onBUO() {
    if (this.onBUOL) {
      this.onBUOL.forEach(function(listener) {
        return listener();
      });
    }
  };
  _proto.get = function get4() {
    if (this.isComputing_) {
      die(32, this.name_, this.derivation);
    }
    if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
    this.observers_.size === 0 && !this.keepAlive_) {
      if (shouldCompute(this)) {
        this.warnAboutUntrackedRead_();
        startBatch();
        this.value_ = this.computeValue_(false);
        endBatch();
      }
    } else {
      reportObserved(this);
      if (shouldCompute(this)) {
        var prevTrackingContext = globalState.trackingContext;
        if (this.keepAlive_ && !prevTrackingContext) {
          globalState.trackingContext = this;
        }
        if (this.trackAndCompute()) {
          propagateChangeConfirmed(this);
        }
        globalState.trackingContext = prevTrackingContext;
      }
    }
    var result = this.value_;
    if (isCaughtException(result)) {
      throw result.cause;
    }
    return result;
  };
  _proto.set = function set5(value) {
    if (this.setter_) {
      if (this.isRunningSetter_) {
        die(33, this.name_);
      }
      this.isRunningSetter_ = true;
      try {
        this.setter_.call(this.scope_, value);
      } finally {
        this.isRunningSetter_ = false;
      }
    } else {
      die(34, this.name_);
    }
  };
  _proto.trackAndCompute = function trackAndCompute() {
    var oldValue = this.value_;
    var wasSuspended = (
      /* see #1208 */
      this.dependenciesState_ === IDerivationState_.NOT_TRACKING_
    );
    var newValue = this.computeValue_(true);
    var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
    if (changed) {
      this.value_ = newValue;
      if (false) // removed by dead control flow
{}
    }
    return changed;
  };
  _proto.computeValue_ = function computeValue_(track) {
    this.isComputing_ = true;
    var prev = allowStateChangesStart(false);
    var res;
    if (track) {
      res = trackDerivedFunction(this, this.derivation, this.scope_);
    } else {
      if (globalState.disableErrorBoundaries === true) {
        res = this.derivation.call(this.scope_);
      } else {
        try {
          res = this.derivation.call(this.scope_);
        } catch (e) {
          res = new CaughtException(e);
        }
      }
    }
    allowStateChangesEnd(prev);
    this.isComputing_ = false;
    return res;
  };
  _proto.suspend_ = function suspend_() {
    if (!this.keepAlive_) {
      clearObserving(this);
      this.value_ = void 0;
      if (false) // removed by dead control flow
{}
    }
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    var _this = this;
    var firstTime = true;
    var prevValue = void 0;
    return autorun(function() {
      var newValue = _this.get();
      if (!firstTime || fireImmediately) {
        var prevU = untrackedStart();
        listener({
          observableKind: "computed",
          debugObjectName: _this.name_,
          type: UPDATE,
          object: _this,
          newValue,
          oldValue: prevValue
        });
        untrackedEnd(prevU);
      }
      firstTime = false;
      prevValue = newValue;
    });
  };
  _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
    if (true) {
      return;
    }
    // removed by dead control flow

    // removed by dead control flow

  };
  _proto.toString = function toString2() {
    return this.name_ + "[" + this.derivation.toString() + "]";
  };
  _proto.valueOf = function valueOf() {
    return toPrimitive(this.get());
  };
  _proto[_Symbol$toPrimitive$1] = function() {
    return this.valueOf();
  };
  return ComputedValue2;
})();
var isComputedValue = /* @__PURE__ */ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_2) {
  IDerivationState_2[IDerivationState_2["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
  IDerivationState_2[IDerivationState_2["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
  IDerivationState_2[IDerivationState_2["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
  IDerivationState_2[IDerivationState_2["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode2) {
  TraceMode2[TraceMode2["NONE"] = 0] = "NONE";
  TraceMode2[TraceMode2["LOG"] = 1] = "LOG";
  TraceMode2[TraceMode2["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException2(cause) {
  this.cause = void 0;
  this.cause = cause;
};
function isCaughtException(e) {
  return e instanceof CaughtException;
}
function shouldCompute(derivation) {
  switch (derivation.dependenciesState_) {
    case IDerivationState_.UP_TO_DATE_:
      return false;
    case IDerivationState_.NOT_TRACKING_:
    case IDerivationState_.STALE_:
      return true;
    case IDerivationState_.POSSIBLY_STALE_: {
      var prevAllowStateReads = allowStateReadsStart(true);
      var prevUntracked = untrackedStart();
      var obs = derivation.observing_, l = obs.length;
      for (var i = 0; i < l; i++) {
        var obj = obs[i];
        if (isComputedValue(obj)) {
          if (globalState.disableErrorBoundaries) {
            obj.get();
          } else {
            try {
              obj.get();
            } catch (e) {
              untrackedEnd(prevUntracked);
              allowStateReadsEnd(prevAllowStateReads);
              return true;
            }
          }
          if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return true;
          }
        }
      }
      changeDependenciesStateTo0(derivation);
      untrackedEnd(prevUntracked);
      allowStateReadsEnd(prevAllowStateReads);
      return false;
    }
  }
}
function isComputingDerivation() {
  return globalState.trackingDerivation !== null;
}
function checkIfStateModificationsAreAllowed(atom) {
  if (true) {
    return;
  }
  // removed by dead control flow
 var hasObservers2; 
  // removed by dead control flow

}
function checkIfStateReadsAreAllowed(observable2) {
  if (false) // removed by dead control flow
{}
}
function trackDerivedFunction(derivation, f, context) {
  var prevAllowStateReads = allowStateReadsStart(true);
  changeDependenciesStateTo0(derivation);
  derivation.newObserving_ = new Array(derivation.observing_.length + 100);
  derivation.unboundDepsCount_ = 0;
  derivation.runId_ = ++globalState.runId;
  var prevTracking = globalState.trackingDerivation;
  globalState.trackingDerivation = derivation;
  globalState.inBatch++;
  var result;
  if (globalState.disableErrorBoundaries === true) {
    result = f.call(context);
  } else {
    try {
      result = f.call(context);
    } catch (e) {
      result = new CaughtException(e);
    }
  }
  globalState.inBatch--;
  globalState.trackingDerivation = prevTracking;
  bindDependencies(derivation);
  warnAboutDerivationWithoutDependencies(derivation);
  allowStateReadsEnd(prevAllowStateReads);
  return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
  if (true) {
    return;
  }
  // removed by dead control flow

  // removed by dead control flow

}
function bindDependencies(derivation) {
  var prevObserving = derivation.observing_;
  var observing = derivation.observing_ = derivation.newObserving_;
  var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
  var i0 = 0, l = derivation.unboundDepsCount_;
  for (var i = 0; i < l; i++) {
    var dep = observing[i];
    if (dep.diffValue_ === 0) {
      dep.diffValue_ = 1;
      if (i0 !== i) {
        observing[i0] = dep;
      }
      i0++;
    }
    if (dep.dependenciesState_ > lowestNewObservingDerivationState) {
      lowestNewObservingDerivationState = dep.dependenciesState_;
    }
  }
  observing.length = i0;
  derivation.newObserving_ = null;
  l = prevObserving.length;
  while (l--) {
    var _dep = prevObserving[l];
    if (_dep.diffValue_ === 0) {
      removeObserver(_dep, derivation);
    }
    _dep.diffValue_ = 0;
  }
  while (i0--) {
    var _dep2 = observing[i0];
    if (_dep2.diffValue_ === 1) {
      _dep2.diffValue_ = 0;
      addObserver(_dep2, derivation);
    }
  }
  if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
    derivation.dependenciesState_ = lowestNewObservingDerivationState;
    derivation.onBecomeStale_();
  }
}
function clearObserving(derivation) {
  var obs = derivation.observing_;
  derivation.observing_ = [];
  var i = obs.length;
  while (i--) {
    removeObserver(obs[i], derivation);
  }
  derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action2) {
  var prev = untrackedStart();
  try {
    return action2();
  } finally {
    untrackedEnd(prev);
  }
}
function untrackedStart() {
  var prev = globalState.trackingDerivation;
  globalState.trackingDerivation = null;
  return prev;
}
function untrackedEnd(prev) {
  globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
  var prev = globalState.allowStateReads;
  globalState.allowStateReads = allowStateReads;
  return prev;
}
function allowStateReadsEnd(prev) {
  globalState.allowStateReads = prev;
}
function changeDependenciesStateTo0(derivation) {
  if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
    return;
  }
  derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
  var obs = derivation.observing_;
  var i = obs.length;
  while (i--) {
    obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
  }
}
var persistentKeys = ["mobxGuid", "spyListeners", "enforceActions", "computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "allowStateReads", "disableErrorBoundaries", "runId", "UNCHANGED", "useProxies"];
var MobXGlobals = function MobXGlobals2() {
  this.version = 6;
  this.UNCHANGED = {};
  this.trackingDerivation = null;
  this.trackingContext = null;
  this.runId = 0;
  this.mobxGuid = 0;
  this.inBatch = 0;
  this.pendingUnobservations = [];
  this.pendingReactions = [];
  this.isRunningReactions = false;
  this.allowStateChanges = false;
  this.allowStateReads = true;
  this.enforceActions = true;
  this.spyListeners = [];
  this.globalReactionErrorHandlers = [];
  this.computedRequiresReaction = false;
  this.reactionRequiresObservable = false;
  this.observableRequiresReaction = false;
  this.disableErrorBoundaries = false;
  this.suppressReactionErrors = false;
  this.useProxies = true;
  this.verifyProxies = false;
  this.safeDescriptors = true;
  this.stateVersion = Number.MIN_SAFE_INTEGER;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /* @__PURE__ */ (function() {
  var global2 = /* @__PURE__ */ getGlobal();
  if (global2.__mobxInstanceCount > 0 && !global2.__mobxGlobals) {
    canMergeGlobalState = false;
  }
  if (global2.__mobxGlobals && global2.__mobxGlobals.version !== new MobXGlobals().version) {
    canMergeGlobalState = false;
  }
  if (!canMergeGlobalState) {
    setTimeout(function() {
      if (!isolateCalled) {
        die(35);
      }
    }, 1);
    return new MobXGlobals();
  } else if (global2.__mobxGlobals) {
    global2.__mobxInstanceCount += 1;
    if (!global2.__mobxGlobals.UNCHANGED) {
      global2.__mobxGlobals.UNCHANGED = {};
    }
    return global2.__mobxGlobals;
  } else {
    global2.__mobxInstanceCount = 1;
    return global2.__mobxGlobals = /* @__PURE__ */ new MobXGlobals();
  }
})();
function isolateGlobalState() {
  if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) {
    die(36);
  }
  isolateCalled = true;
  if (canMergeGlobalState) {
    var global2 = getGlobal();
    if (--global2.__mobxInstanceCount === 0) {
      global2.__mobxGlobals = void 0;
    }
    globalState = new MobXGlobals();
  }
}
function getGlobalState() {
  return globalState;
}
function resetGlobalState() {
  var defaultGlobals = new MobXGlobals();
  for (var key in defaultGlobals) {
    if (persistentKeys.indexOf(key) === -1) {
      globalState[key] = defaultGlobals[key];
    }
  }
  globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable2) {
  return observable2.observers_ && observable2.observers_.size > 0;
}
function getObservers(observable2) {
  return observable2.observers_;
}
function addObserver(observable2, node) {
  observable2.observers_.add(node);
  if (observable2.lowestObserverState_ > node.dependenciesState_) {
    observable2.lowestObserverState_ = node.dependenciesState_;
  }
}
function removeObserver(observable2, node) {
  observable2.observers_["delete"](node);
  if (observable2.observers_.size === 0) {
    queueForUnobservation(observable2);
  }
}
function queueForUnobservation(observable2) {
  if (observable2.isPendingUnobservation_ === false) {
    observable2.isPendingUnobservation_ = true;
    globalState.pendingUnobservations.push(observable2);
  }
}
function startBatch() {
  globalState.inBatch++;
}
function endBatch() {
  if (--globalState.inBatch === 0) {
    runReactions();
    var list = globalState.pendingUnobservations;
    for (var i = 0; i < list.length; i++) {
      var observable2 = list[i];
      observable2.isPendingUnobservation_ = false;
      if (observable2.observers_.size === 0) {
        if (observable2.isBeingObserved_) {
          observable2.isBeingObserved_ = false;
          observable2.onBUO();
        }
        if (observable2 instanceof ComputedValue) {
          observable2.suspend_();
        }
      }
    }
    globalState.pendingUnobservations = [];
  }
}
function reportObserved(observable2) {
  checkIfStateReadsAreAllowed(observable2);
  var derivation = globalState.trackingDerivation;
  if (derivation !== null) {
    if (derivation.runId_ !== observable2.lastAccessedBy_) {
      observable2.lastAccessedBy_ = derivation.runId_;
      derivation.newObserving_[derivation.unboundDepsCount_++] = observable2;
      if (!observable2.isBeingObserved_ && globalState.trackingContext) {
        observable2.isBeingObserved_ = true;
        observable2.onBO();
      }
    }
    return observable2.isBeingObserved_;
  } else if (observable2.observers_.size === 0 && globalState.inBatch > 0) {
    queueForUnobservation(observable2);
  }
  return false;
}
function propagateChanged(observable2) {
  if (observable2.lowestObserverState_ === IDerivationState_.STALE_) {
    return;
  }
  observable2.lowestObserverState_ = IDerivationState_.STALE_;
  observable2.observers_.forEach(function(d) {
    if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
      if (false) // removed by dead control flow
{}
      d.onBecomeStale_();
    }
    d.dependenciesState_ = IDerivationState_.STALE_;
  });
}
function propagateChangeConfirmed(observable2) {
  if (observable2.lowestObserverState_ === IDerivationState_.STALE_) {
    return;
  }
  observable2.lowestObserverState_ = IDerivationState_.STALE_;
  observable2.observers_.forEach(function(d) {
    if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) {
      d.dependenciesState_ = IDerivationState_.STALE_;
      if (false) // removed by dead control flow
{}
    } else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
      observable2.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    }
  });
}
function propagateMaybeChanged(observable2) {
  if (observable2.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) {
    return;
  }
  observable2.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
  observable2.observers_.forEach(function(d) {
    if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
      d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
      d.onBecomeStale_();
    }
  });
}
function logTraceInfo(derivation, observable2) {
  console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable2.name_ + "'");
  if (derivation.isTracing_ === TraceMode.BREAK) {
    var lines = [];
    printDepTree(getDependencyTree(derivation), lines, 1);
    new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable2.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
  }
}
function printDepTree(tree, lines, depth) {
  if (lines.length >= 1e3) {
    lines.push("(and many more)");
    return;
  }
  lines.push("" + "	".repeat(depth - 1) + tree.name);
  if (tree.dependencies) {
    tree.dependencies.forEach(function(child) {
      return printDepTree(child, lines, depth + 1);
    });
  }
}
var Reaction = /* @__PURE__ */ (function() {
  function Reaction2(name_, onInvalidate_, errorHandler_, requiresObservable_) {
    if (name_ === void 0) {
      name_ =  false ? 0 : "Reaction";
    }
    this.name_ = void 0;
    this.onInvalidate_ = void 0;
    this.errorHandler_ = void 0;
    this.requiresObservable_ = void 0;
    this.observing_ = [];
    this.newObserving_ = [];
    this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
    this.diffValue_ = 0;
    this.runId_ = 0;
    this.unboundDepsCount_ = 0;
    this.isDisposed_ = false;
    this.isScheduled_ = false;
    this.isTrackPending_ = false;
    this.isRunning_ = false;
    this.isTracing_ = TraceMode.NONE;
    this.name_ = name_;
    this.onInvalidate_ = onInvalidate_;
    this.errorHandler_ = errorHandler_;
    this.requiresObservable_ = requiresObservable_;
  }
  var _proto = Reaction2.prototype;
  _proto.onBecomeStale_ = function onBecomeStale_() {
    this.schedule_();
  };
  _proto.schedule_ = function schedule_() {
    if (!this.isScheduled_) {
      this.isScheduled_ = true;
      globalState.pendingReactions.push(this);
      runReactions();
    }
  };
  _proto.isScheduled = function isScheduled() {
    return this.isScheduled_;
  };
  _proto.runReaction_ = function runReaction_() {
    if (!this.isDisposed_) {
      startBatch();
      this.isScheduled_ = false;
      var prev = globalState.trackingContext;
      globalState.trackingContext = this;
      if (shouldCompute(this)) {
        this.isTrackPending_ = true;
        try {
          this.onInvalidate_();
          if (false) // removed by dead control flow
{}
        } catch (e) {
          this.reportExceptionInDerivation_(e);
        }
      }
      globalState.trackingContext = prev;
      endBatch();
    }
  };
  _proto.track = function track(fn) {
    if (this.isDisposed_) {
      return;
    }
    startBatch();
    var notify = isSpyEnabled();
    var startTime;
    if (false) // removed by dead control flow
{}
    this.isRunning_ = true;
    var prevReaction = globalState.trackingContext;
    globalState.trackingContext = this;
    var result = trackDerivedFunction(this, fn, void 0);
    globalState.trackingContext = prevReaction;
    this.isRunning_ = false;
    this.isTrackPending_ = false;
    if (this.isDisposed_) {
      clearObserving(this);
    }
    if (isCaughtException(result)) {
      this.reportExceptionInDerivation_(result.cause);
    }
    if (false) // removed by dead control flow
{}
    endBatch();
  };
  _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
    var _this = this;
    if (this.errorHandler_) {
      this.errorHandler_(error, this);
      return;
    }
    if (globalState.disableErrorBoundaries) {
      throw error;
    }
    var message =  false ? 0 : "[mobx] uncaught error in '" + this + "'";
    if (!globalState.suppressReactionErrors) {
      console.error(message, error);
    } else if (false) // removed by dead control flow
{}
    if (false) // removed by dead control flow
{}
    globalState.globalReactionErrorHandlers.forEach(function(f) {
      return f(error, _this);
    });
  };
  _proto.dispose = function dispose() {
    if (!this.isDisposed_) {
      this.isDisposed_ = true;
      if (!this.isRunning_) {
        startBatch();
        clearObserving(this);
        endBatch();
      }
    }
  };
  _proto.getDisposer_ = function getDisposer_() {
    var r = this.dispose.bind(this);
    r[$mobx] = this;
    return r;
  };
  _proto.toString = function toString2() {
    return "Reaction[" + this.name_ + "]";
  };
  _proto.trace = function trace$1(enterBreakPoint) {
    if (enterBreakPoint === void 0) {
      enterBreakPoint = false;
    }
    trace(this, enterBreakPoint);
  };
  return Reaction2;
})();
function onReactionError(handler) {
  globalState.globalReactionErrorHandlers.push(handler);
  return function() {
    var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
    if (idx >= 0) {
      globalState.globalReactionErrorHandlers.splice(idx, 1);
    }
  };
}
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler2(f) {
  return f();
};
function runReactions() {
  if (globalState.inBatch > 0 || globalState.isRunningReactions) {
    return;
  }
  reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
  globalState.isRunningReactions = true;
  var allReactions = globalState.pendingReactions;
  var iterations = 0;
  while (allReactions.length > 0) {
    if (++iterations === MAX_REACTION_ITERATIONS) {
      console.error( false ? 0 : "[mobx] cycle in reaction: " + allReactions[0]);
      allReactions.splice(0);
    }
    var remainingReactions = allReactions.splice(0);
    for (var i = 0, l = remainingReactions.length; i < l; i++) {
      remainingReactions[i].runReaction_();
    }
  }
  globalState.isRunningReactions = false;
}
var isReaction = /* @__PURE__ */ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
  var baseScheduler = reactionScheduler;
  reactionScheduler = function reactionScheduler3(f) {
    return fn(function() {
      return baseScheduler(f);
    });
  };
}
function isSpyEnabled() {
  return  false && 0;
}
function spyReport(event) {
  if (true) {
    return;
  }
  // removed by dead control flow

  // removed by dead control flow
 var listeners; 
  // removed by dead control flow
 var i, l; 
}
function spyReportStart(event) {
  if (true) {
    return;
  }
  // removed by dead control flow
 var change; 
  // removed by dead control flow

}
var END_EVENT = (/* unused pure expression or super */ null && ({
  type: "report-end",
  spyReportEnd: true
}));
function spyReportEnd(change) {
  if (true) {
    return;
  }
  // removed by dead control flow

}
function spy(listener) {
  if (true) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {
    };
  } else // removed by dead control flow
{}
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /* @__PURE__ */ createActionAnnotation(ACTION);
var actionBoundAnnotation = /* @__PURE__ */ createActionAnnotation(ACTION_BOUND, {
  bound: true
});
var autoActionAnnotation = /* @__PURE__ */ createActionAnnotation(AUTOACTION, {
  autoAction: true
});
var autoActionBoundAnnotation = /* @__PURE__ */ createActionAnnotation(AUTOACTION_BOUND, {
  autoAction: true,
  bound: true
});
function createActionFactory(autoAction2) {
  var res = function action2(arg1, arg2) {
    if (isFunction(arg1)) {
      return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction2);
    }
    if (isFunction(arg2)) {
      return createAction(arg1, arg2, autoAction2);
    }
    if (isStringish(arg2)) {
      return storeAnnotation(arg1, arg2, autoAction2 ? autoActionAnnotation : actionAnnotation);
    }
    if (isStringish(arg1)) {
      return createDecoratorAnnotation(createActionAnnotation(autoAction2 ? AUTOACTION : ACTION, {
        name: arg1,
        autoAction: autoAction2
      }));
    }
    if (false) // removed by dead control flow
{}
  };
  return res;
}
var action = /* @__PURE__ */ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /* @__PURE__ */ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /* @__PURE__ */ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /* @__PURE__ */ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
  return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, void 0);
}
function isAction(thing) {
  return isFunction(thing) && thing.isMobxAction === true;
}
function autorun(view, opts) {
  var _opts$name, _opts;
  if (opts === void 0) {
    opts = EMPTY_OBJECT;
  }
  if (false) // removed by dead control flow
{}
  var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name :  false ? 0 : "Autorun";
  var runSync = !opts.scheduler && !opts.delay;
  var reaction2;
  if (runSync) {
    reaction2 = new Reaction(name, function() {
      this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
  } else {
    var scheduler = createSchedulerFromOptions(opts);
    var isScheduled = false;
    reaction2 = new Reaction(name, function() {
      if (!isScheduled) {
        isScheduled = true;
        scheduler(function() {
          isScheduled = false;
          if (!reaction2.isDisposed_) {
            reaction2.track(reactionRunner);
          }
        });
      }
    }, opts.onError, opts.requiresObservable);
  }
  function reactionRunner() {
    view(reaction2);
  }
  reaction2.schedule_();
  return reaction2.getDisposer_();
}
var run = function run2(f) {
  return f();
};
function createSchedulerFromOptions(opts) {
  return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
    return setTimeout(f, opts.delay);
  } : run;
}
function reaction(expression, effect, opts) {
  var _opts$name2;
  if (opts === void 0) {
    opts = EMPTY_OBJECT;
  }
  if (false) // removed by dead control flow
{}
  var name = (_opts$name2 = opts.name) != null ? _opts$name2 :  false ? 0 : "Reaction";
  var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
  var runSync = !opts.scheduler && !opts.delay;
  var scheduler = createSchedulerFromOptions(opts);
  var firstTime = true;
  var isScheduled = false;
  var value;
  var oldValue;
  var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
  var r = new Reaction(name, function() {
    if (firstTime || runSync) {
      reactionRunner();
    } else if (!isScheduled) {
      isScheduled = true;
      scheduler(reactionRunner);
    }
  }, opts.onError, opts.requiresObservable);
  function reactionRunner() {
    isScheduled = false;
    if (r.isDisposed_) {
      return;
    }
    var changed = false;
    r.track(function() {
      var nextValue = allowStateChanges(false, function() {
        return expression(r);
      });
      changed = firstTime || !equals(value, nextValue);
      oldValue = value;
      value = nextValue;
    });
    if (firstTime && opts.fireImmediately) {
      effectAction(value, oldValue, r);
    } else if (!firstTime && changed) {
      effectAction(value, oldValue, r);
    }
    firstTime = false;
  }
  r.schedule_();
  return r.getDisposer_();
}
function wrapErrorHandler(errorHandler, baseFn) {
  return function() {
    try {
      return baseFn.apply(this, arguments);
    } catch (e) {
      errorHandler.call(this, e);
    }
  };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
  return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
  return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
  var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
  var cb = isFunction(arg3) ? arg3 : arg2;
  var listenersKey = hook + "L";
  if (atom[listenersKey]) {
    atom[listenersKey].add(cb);
  } else {
    atom[listenersKey] = /* @__PURE__ */ new Set([cb]);
  }
  return function() {
    var hookListeners = atom[listenersKey];
    if (hookListeners) {
      hookListeners["delete"](cb);
      if (hookListeners.size === 0) {
        delete atom[listenersKey];
      }
    }
  };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
function configure(options) {
  if (options.isolateGlobalState === true) {
    isolateGlobalState();
  }
  var useProxies = options.useProxies, enforceActions = options.enforceActions;
  if (useProxies !== void 0) {
    globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
  }
  if (useProxies === "ifavailable") {
    globalState.verifyProxies = true;
  }
  if (enforceActions !== void 0) {
    var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
    globalState.enforceActions = ea;
    globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
  }
  ["computedRequiresReaction", "reactionRequiresObservable", "observableRequiresReaction", "disableErrorBoundaries", "safeDescriptors"].forEach(function(key) {
    if (key in options) {
      globalState[key] = !!options[key];
    }
  });
  globalState.allowStateReads = !globalState.observableRequiresReaction;
  if (false) // removed by dead control flow
{}
  if (options.reactionScheduler) {
    setReactionScheduler(options.reactionScheduler);
  }
}
function extendObservable(target, properties, annotations, options) {
  if (false) // removed by dead control flow
{}
  var descriptors = getOwnPropertyDescriptors(properties);
  var adm = asObservableObject(target, options)[$mobx];
  startBatch();
  try {
    ownKeys(descriptors).forEach(function(key) {
      adm.extend_(
        key,
        descriptors[key],
        // must pass "undefined" for { key: undefined }
        !annotations ? true : key in annotations ? annotations[key] : true
      );
    });
  } finally {
    endBatch();
  }
  return target;
}
function getDependencyTree(thing, property) {
  return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
  var result = {
    name: node.name_
  };
  if (node.observing_ && node.observing_.length > 0) {
    result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
  }
  return result;
}
function getObserverTree(thing, property) {
  return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
  var result = {
    name: node.name_
  };
  if (hasObservers(node)) {
    result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
  }
  return result;
}
function unique(list) {
  return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
  this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /* @__PURE__ */ Object.create(Error.prototype);
function isFlowCancellationError(error) {
  return error instanceof FlowCancellationError;
}
var flowAnnotation = /* @__PURE__ */ createFlowAnnotation("flow");
var flowBoundAnnotation = /* @__PURE__ */ createFlowAnnotation("flow.bound", {
  bound: true
});
var flow = /* @__PURE__ */ Object.assign(function flow2(arg1, arg2) {
  if (isStringish(arg2)) {
    return storeAnnotation(arg1, arg2, flowAnnotation);
  }
  if (false) // removed by dead control flow
{}
  var generator = arg1;
  var name = generator.name || "<unnamed flow>";
  var res = function res2() {
    var ctx = this;
    var args = arguments;
    var runId = ++generatorId;
    var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
    var rejector;
    var pendingPromise = void 0;
    var promise = new Promise(function(resolve, reject) {
      var stepId = 0;
      rejector = reject;
      function onFulfilled(res3) {
        pendingPromise = void 0;
        var ret;
        try {
          ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res3);
        } catch (e) {
          return reject(e);
        }
        next(ret);
      }
      function onRejected(err) {
        pendingPromise = void 0;
        var ret;
        try {
          ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
        } catch (e) {
          return reject(e);
        }
        next(ret);
      }
      function next(ret) {
        if (isFunction(ret == null ? void 0 : ret.then)) {
          ret.then(next, reject);
          return;
        }
        if (ret.done) {
          return resolve(ret.value);
        }
        pendingPromise = Promise.resolve(ret.value);
        return pendingPromise.then(onFulfilled, onRejected);
      }
      onFulfilled(void 0);
    });
    promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
      try {
        if (pendingPromise) {
          cancelPromise(pendingPromise);
        }
        var _res = gen["return"](void 0);
        var yieldedPromise = Promise.resolve(_res.value);
        yieldedPromise.then(noop, noop);
        cancelPromise(yieldedPromise);
        rejector(new FlowCancellationError());
      } catch (e) {
        rejector(e);
      }
    });
    return promise;
  };
  res.isMobXFlow = true;
  return res;
}, flowAnnotation);
flow.bound = /* @__PURE__ */ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
  if (isFunction(promise.cancel)) {
    promise.cancel();
  }
}
function flowResult(result) {
  return result;
}
function isFlow(fn) {
  return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
  var target;
  if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) {
    target = getAdministration(thing);
  } else if (isObservableObject(thing)) {
    if (false) // removed by dead control flow
{}
    target = getAdministration(thing, propOrHandler);
  } else if (false) // removed by dead control flow
{}
  if (false) // removed by dead control flow
{}
  target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
  return function() {
    target.dehancer = void 0;
  };
}
function intercept(thing, propOrHandler, handler) {
  if (isFunction(handler)) {
    return interceptProperty(thing, propOrHandler, handler);
  } else {
    return interceptInterceptable(thing, propOrHandler);
  }
}
function interceptInterceptable(thing, handler) {
  return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
  return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
  if (property === void 0) {
    return isComputedValue(value);
  }
  if (isObservableObject(value) === false) {
    return false;
  }
  if (!value[$mobx].values_.has(property)) {
    return false;
  }
  var atom = getAtom(value, property);
  return isComputedValue(atom);
}
function isComputed(value) {
  if (false) // removed by dead control flow
{}
  return _isComputed(value);
}
function isComputedProp(value, propName) {
  if (false) // removed by dead control flow
{}
  return _isComputed(value, propName);
}
function _isObservable(value, property) {
  if (!value) {
    return false;
  }
  if (property !== void 0) {
    if (false) // removed by dead control flow
{}
    if (isObservableObject(value)) {
      return value[$mobx].values_.has(property);
    }
    return false;
  }
  return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
  if (false) // removed by dead control flow
{}
  return _isObservable(value);
}
function isObservableProp(value, propName) {
  if (false) // removed by dead control flow
{}
  return _isObservable(value, propName);
}
function keys(obj) {
  if (isObservableObject(obj)) {
    return obj[$mobx].keys_();
  }
  if (isObservableMap(obj) || isObservableSet(obj)) {
    return Array.from(obj.keys());
  }
  if (isObservableArray(obj)) {
    return obj.map(function(_14, index) {
      return index;
    });
  }
  die(5);
}
function values(obj) {
  if (isObservableObject(obj)) {
    return keys(obj).map(function(key) {
      return obj[key];
    });
  }
  if (isObservableMap(obj)) {
    return keys(obj).map(function(key) {
      return obj.get(key);
    });
  }
  if (isObservableSet(obj)) {
    return Array.from(obj.values());
  }
  if (isObservableArray(obj)) {
    return obj.slice();
  }
  die(6);
}
function entries(obj) {
  if (isObservableObject(obj)) {
    return keys(obj).map(function(key) {
      return [key, obj[key]];
    });
  }
  if (isObservableMap(obj)) {
    return keys(obj).map(function(key) {
      return [key, obj.get(key)];
    });
  }
  if (isObservableSet(obj)) {
    return Array.from(obj.entries());
  }
  if (isObservableArray(obj)) {
    return obj.map(function(key, index) {
      return [index, key];
    });
  }
  die(7);
}
function set2(obj, key, value) {
  if (arguments.length === 2 && !isObservableSet(obj)) {
    startBatch();
    var _values = key;
    try {
      for (var _key in _values) {
        set2(obj, _key, _values[_key]);
      }
    } finally {
      endBatch();
    }
    return;
  }
  if (isObservableObject(obj)) {
    obj[$mobx].set_(key, value);
  } else if (isObservableMap(obj)) {
    obj.set(key, value);
  } else if (isObservableSet(obj)) {
    obj.add(key);
  } else if (isObservableArray(obj)) {
    if (typeof key !== "number") {
      key = parseInt(key, 10);
    }
    if (key < 0) {
      die("Invalid index: '" + key + "'");
    }
    startBatch();
    if (key >= obj.length) {
      obj.length = key + 1;
    }
    obj[key] = value;
    endBatch();
  } else {
    die(8);
  }
}
function remove(obj, key) {
  if (isObservableObject(obj)) {
    obj[$mobx].delete_(key);
  } else if (isObservableMap(obj)) {
    obj["delete"](key);
  } else if (isObservableSet(obj)) {
    obj["delete"](key);
  } else if (isObservableArray(obj)) {
    if (typeof key !== "number") {
      key = parseInt(key, 10);
    }
    obj.splice(key, 1);
  } else {
    die(9);
  }
}
function has(obj, key) {
  if (isObservableObject(obj)) {
    return obj[$mobx].has_(key);
  } else if (isObservableMap(obj)) {
    return obj.has(key);
  } else if (isObservableSet(obj)) {
    return obj.has(key);
  } else if (isObservableArray(obj)) {
    return key >= 0 && key < obj.length;
  }
  die(10);
}
function get(obj, key) {
  if (!has(obj, key)) {
    return void 0;
  }
  if (isObservableObject(obj)) {
    return obj[$mobx].get_(key);
  } else if (isObservableMap(obj)) {
    return obj.get(key);
  } else if (isObservableArray(obj)) {
    return obj[key];
  }
  die(11);
}
function apiDefineProperty(obj, key, descriptor) {
  if (isObservableObject(obj)) {
    return obj[$mobx].defineProperty_(key, descriptor);
  }
  die(39);
}
function apiOwnKeys(obj) {
  if (isObservableObject(obj)) {
    return obj[$mobx].ownKeys_();
  }
  die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
  if (isFunction(cbOrFire)) {
    return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
  } else {
    return observeObservable(thing, propOrCb, cbOrFire);
  }
}
function observeObservable(thing, listener, fireImmediately) {
  return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
  return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map2, key, value) {
  map2.set(key, value);
  return value;
}
function toJSHelper(source, __alreadySeen) {
  if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) {
    return source;
  }
  if (isObservableValue(source) || isComputedValue(source)) {
    return toJSHelper(source.get(), __alreadySeen);
  }
  if (__alreadySeen.has(source)) {
    return __alreadySeen.get(source);
  }
  if (isObservableArray(source)) {
    var res = cache(__alreadySeen, source, new Array(source.length));
    source.forEach(function(value, idx) {
      res[idx] = toJSHelper(value, __alreadySeen);
    });
    return res;
  }
  if (isObservableSet(source)) {
    var _res = cache(__alreadySeen, source, /* @__PURE__ */ new Set());
    source.forEach(function(value) {
      _res.add(toJSHelper(value, __alreadySeen));
    });
    return _res;
  }
  if (isObservableMap(source)) {
    var _res2 = cache(__alreadySeen, source, /* @__PURE__ */ new Map());
    source.forEach(function(value, key) {
      _res2.set(key, toJSHelper(value, __alreadySeen));
    });
    return _res2;
  } else {
    var _res3 = cache(__alreadySeen, source, {});
    apiOwnKeys(source).forEach(function(key) {
      if (objectPrototype.propertyIsEnumerable.call(source, key)) {
        _res3[key] = toJSHelper(source[key], __alreadySeen);
      }
    });
    return _res3;
  }
}
function toJS(source, options) {
  if (false) // removed by dead control flow
{}
  return toJSHelper(source, /* @__PURE__ */ new Map());
}
function trace() {
  if (true) {
    die("trace() is not available in production builds");
  }
  var enterBreakPoint = false;
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (typeof args[args.length - 1] === "boolean") {
    enterBreakPoint = args.pop();
  }
  var derivation = getAtomFromArgs(args);
  if (!derivation) {
    return die("'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
  }
  if (derivation.isTracing_ === TraceMode.NONE) {
    console.log("[mobx.trace] '" + derivation.name_ + "' tracing enabled");
  }
  derivation.isTracing_ = enterBreakPoint ? TraceMode.BREAK : TraceMode.LOG;
}
function getAtomFromArgs(args) {
  switch (args.length) {
    case 0:
      return globalState.trackingDerivation;
    case 1:
      return getAtom(args[0]);
    case 2:
      return getAtom(args[0], args[1]);
  }
}
function transaction(action2, thisArg) {
  if (thisArg === void 0) {
    thisArg = void 0;
  }
  startBatch();
  try {
    return action2.apply(thisArg);
  } finally {
    endBatch();
  }
}
function when(predicate, arg1, arg2) {
  if (arguments.length === 1 || arg1 && typeof arg1 === "object") {
    return whenPromise(predicate, arg1);
  }
  return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
  var timeoutHandle;
  if (typeof opts.timeout === "number") {
    var error = new Error("WHEN_TIMEOUT");
    timeoutHandle = setTimeout(function() {
      if (!disposer[$mobx].isDisposed_) {
        disposer();
        if (opts.onError) {
          opts.onError(error);
        } else {
          throw error;
        }
      }
    }, opts.timeout);
  }
  opts.name =  false ? 0 : "When";
  var effectAction = createAction( false ? 0 : "When-effect", effect);
  var disposer = autorun(function(r) {
    var cond = allowStateChanges(false, predicate);
    if (cond) {
      r.dispose();
      if (timeoutHandle) {
        clearTimeout(timeoutHandle);
      }
      effectAction();
    }
  }, opts);
  return disposer;
}
function whenPromise(predicate, opts) {
  var _opts$signal;
  if (false) // removed by dead control flow
{}
  if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) {
    return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
      cancel: function cancel2() {
        return null;
      }
    });
  }
  var cancel;
  var abort;
  var res = new Promise(function(resolve, reject) {
    var _opts$signal2;
    var disposer = _when(predicate, resolve, _extends({}, opts, {
      onError: reject
    }));
    cancel = function cancel2() {
      disposer();
      reject(new Error("WHEN_CANCELLED"));
    };
    abort = function abort2() {
      disposer();
      reject(new Error("WHEN_ABORTED"));
    };
    opts == null ? void 0 : (_opts$signal2 = opts.signal) == null ? void 0 : _opts$signal2.addEventListener == null ? void 0 : _opts$signal2.addEventListener("abort", abort);
  })["finally"](function() {
    var _opts$signal3;
    return opts == null ? void 0 : (_opts$signal3 = opts.signal) == null ? void 0 : _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
  });
  res.cancel = cancel;
  return res;
}
function getAdm(target) {
  return target[$mobx];
}
var objectProxyTraps = {
  has: function has2(target, name) {
    if (false) // removed by dead control flow
{}
    return getAdm(target).has_(name);
  },
  get: function get2(target, name) {
    return getAdm(target).get_(name);
  },
  set: function set3(target, name, value) {
    var _getAdm$set_;
    if (!isStringish(name)) {
      return false;
    }
    if (false) // removed by dead control flow
{}
    return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
  },
  deleteProperty: function deleteProperty(target, name) {
    var _getAdm$delete_;
    if (false) // removed by dead control flow
{}
    if (!isStringish(name)) {
      return false;
    }
    return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
  },
  defineProperty: function defineProperty2(target, name, descriptor) {
    var _getAdm$definePropert;
    if (false) // removed by dead control flow
{}
    return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
  },
  ownKeys: function ownKeys2(target) {
    if (false) // removed by dead control flow
{}
    return getAdm(target).ownKeys_();
  },
  preventExtensions: function preventExtensions(target) {
    die(13);
  }
};
function asDynamicObservableObject(target, options) {
  var _target$$mobx, _target$$mobx$proxy_;
  assertProxies();
  target = asObservableObject(target, options);
  return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
  return interceptable.interceptors_ !== void 0 && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
  var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
  interceptors.push(handler);
  return once(function() {
    var idx = interceptors.indexOf(handler);
    if (idx !== -1) {
      interceptors.splice(idx, 1);
    }
  });
}
function interceptChange(interceptable, change) {
  var prevU = untrackedStart();
  try {
    var interceptors = [].concat(interceptable.interceptors_ || []);
    for (var i = 0, l = interceptors.length; i < l; i++) {
      change = interceptors[i](change);
      if (change && !change.type) {
        die(14);
      }
      if (!change) {
        break;
      }
    }
    return change;
  } finally {
    untrackedEnd(prevU);
  }
}
function hasListeners(listenable) {
  return listenable.changeListeners_ !== void 0 && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
  var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
  listeners.push(handler);
  return once(function() {
    var idx = listeners.indexOf(handler);
    if (idx !== -1) {
      listeners.splice(idx, 1);
    }
  });
}
function notifyListeners(listenable, change) {
  var prevU = untrackedStart();
  var listeners = listenable.changeListeners_;
  if (!listeners) {
    return;
  }
  listeners = listeners.slice();
  for (var i = 0, l = listeners.length; i < l; i++) {
    listeners[i](change);
  }
  untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
  var adm = asObservableObject(target, options)[$mobx];
  startBatch();
  try {
    var _annotations;
    if (false) // removed by dead control flow
{}
    (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
    ownKeys(annotations).forEach(function(key) {
      return adm.make_(key, annotations[key]);
    });
  } finally {
    endBatch();
  }
  return target;
}
var keysSymbol = /* @__PURE__ */ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
  if (false) // removed by dead control flow
{}
  if (isPlainObject(target)) {
    return extendObservable(target, target, overrides, options);
  }
  var adm = asObservableObject(target, options)[$mobx];
  if (!target[keysSymbol]) {
    var proto = Object.getPrototypeOf(target);
    var keys2 = new Set([].concat(ownKeys(target), ownKeys(proto)));
    keys2["delete"]("constructor");
    keys2["delete"]($mobx);
    addHiddenProp(proto, keysSymbol, keys2);
  }
  startBatch();
  try {
    target[keysSymbol].forEach(function(key) {
      return adm.make_(
        key,
        // must pass "undefined" for { key: undefined }
        !overrides ? true : key in overrides ? overrides[key] : true
      );
    });
  } finally {
    endBatch();
  }
  return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 1e4;
var arrayTraps = {
  get: function get3(target, name) {
    var adm = target[$mobx];
    if (name === $mobx) {
      return adm;
    }
    if (name === "length") {
      return adm.getArrayLength_();
    }
    if (typeof name === "string" && !isNaN(name)) {
      return adm.get_(parseInt(name));
    }
    if (hasProp(arrayExtensions, name)) {
      return arrayExtensions[name];
    }
    return target[name];
  },
  set: function set4(target, name, value) {
    var adm = target[$mobx];
    if (name === "length") {
      adm.setArrayLength_(value);
    }
    if (typeof name === "symbol" || isNaN(name)) {
      target[name] = value;
    } else {
      adm.set_(parseInt(name), value);
    }
    return true;
  },
  preventExtensions: function preventExtensions2() {
    die(15);
  }
};
var ObservableArrayAdministration = /* @__PURE__ */ (function() {
  function ObservableArrayAdministration2(name, enhancer, owned_, legacyMode_) {
    if (name === void 0) {
      name =  false ? 0 : "ObservableArray";
    }
    this.owned_ = void 0;
    this.legacyMode_ = void 0;
    this.atom_ = void 0;
    this.values_ = [];
    this.interceptors_ = void 0;
    this.changeListeners_ = void 0;
    this.enhancer_ = void 0;
    this.dehancer = void 0;
    this.proxy_ = void 0;
    this.lastKnownLength_ = 0;
    this.owned_ = owned_;
    this.legacyMode_ = legacyMode_;
    this.atom_ = new Atom(name);
    this.enhancer_ = function(newV, oldV) {
      return enhancer(newV, oldV,  false ? 0 : "ObservableArray[..]");
    };
  }
  var _proto = ObservableArrayAdministration2.prototype;
  _proto.dehanceValue_ = function dehanceValue_(value) {
    if (this.dehancer !== void 0) {
      return this.dehancer(value);
    }
    return value;
  };
  _proto.dehanceValues_ = function dehanceValues_(values2) {
    if (this.dehancer !== void 0 && values2.length > 0) {
      return values2.map(this.dehancer);
    }
    return values2;
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    if (fireImmediately === void 0) {
      fireImmediately = false;
    }
    if (fireImmediately) {
      listener({
        observableKind: "array",
        object: this.proxy_,
        debugObjectName: this.atom_.name_,
        type: "splice",
        index: 0,
        added: this.values_.slice(),
        addedCount: this.values_.length,
        removed: [],
        removedCount: 0
      });
    }
    return registerListener(this, listener);
  };
  _proto.getArrayLength_ = function getArrayLength_() {
    this.atom_.reportObserved();
    return this.values_.length;
  };
  _proto.setArrayLength_ = function setArrayLength_(newLength) {
    if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) {
      die("Out of range: " + newLength);
    }
    var currentLength = this.values_.length;
    if (newLength === currentLength) {
      return;
    } else if (newLength > currentLength) {
      var newItems = new Array(newLength - currentLength);
      for (var i = 0; i < newLength - currentLength; i++) {
        newItems[i] = void 0;
      }
      this.spliceWithArray_(currentLength, 0, newItems);
    } else {
      this.spliceWithArray_(newLength, currentLength - newLength);
    }
  };
  _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
    if (oldLength !== this.lastKnownLength_) {
      die(16);
    }
    this.lastKnownLength_ += delta;
    if (this.legacyMode_ && delta > 0) {
      reserveArrayBuffer(oldLength + delta + 1);
    }
  };
  _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
    var _this = this;
    checkIfStateModificationsAreAllowed(this.atom_);
    var length = this.values_.length;
    if (index === void 0) {
      index = 0;
    } else if (index > length) {
      index = length;
    } else if (index < 0) {
      index = Math.max(0, length + index);
    }
    if (arguments.length === 1) {
      deleteCount = length - index;
    } else if (deleteCount === void 0 || deleteCount === null) {
      deleteCount = 0;
    } else {
      deleteCount = Math.max(0, Math.min(deleteCount, length - index));
    }
    if (newItems === void 0) {
      newItems = EMPTY_ARRAY;
    }
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        object: this.proxy_,
        type: SPLICE,
        index,
        removedCount: deleteCount,
        added: newItems
      });
      if (!change) {
        return EMPTY_ARRAY;
      }
      deleteCount = change.removedCount;
      newItems = change.added;
    }
    newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
      return _this.enhancer_(v, void 0);
    });
    if (this.legacyMode_ || "production" !== "production") {
      var lengthDelta = newItems.length - deleteCount;
      this.updateArrayLength_(length, lengthDelta);
    }
    var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
    if (deleteCount !== 0 || newItems.length !== 0) {
      this.notifyArraySplice_(index, newItems, res);
    }
    return this.dehanceValues_(res);
  };
  _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
    if (newItems.length < MAX_SPLICE_SIZE) {
      var _this$values_;
      return (_this$values_ = this.values_).splice.apply(_this$values_, [index, deleteCount].concat(newItems));
    } else {
      var res = this.values_.slice(index, index + deleteCount);
      var oldItems = this.values_.slice(index + deleteCount);
      this.values_.length += newItems.length - deleteCount;
      for (var i = 0; i < newItems.length; i++) {
        this.values_[index + i] = newItems[i];
      }
      for (var _i = 0; _i < oldItems.length; _i++) {
        this.values_[index + newItems.length + _i] = oldItems[_i];
      }
      return res;
    }
  };
  _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
    var notifySpy = !this.owned_ && isSpyEnabled();
    var notify = hasListeners(this);
    var change = notify || notifySpy ? {
      observableKind: "array",
      object: this.proxy_,
      type: UPDATE,
      debugObjectName: this.atom_.name_,
      index,
      newValue,
      oldValue
    } : null;
    if (false) // removed by dead control flow
{}
    this.atom_.reportChanged();
    if (notify) {
      notifyListeners(this, change);
    }
    if (false) // removed by dead control flow
{}
  };
  _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
    var notifySpy = !this.owned_ && isSpyEnabled();
    var notify = hasListeners(this);
    var change = notify || notifySpy ? {
      observableKind: "array",
      object: this.proxy_,
      debugObjectName: this.atom_.name_,
      type: SPLICE,
      index,
      removed,
      added,
      removedCount: removed.length,
      addedCount: added.length
    } : null;
    if (false) // removed by dead control flow
{}
    this.atom_.reportChanged();
    if (notify) {
      notifyListeners(this, change);
    }
    if (false) // removed by dead control flow
{}
  };
  _proto.get_ = function get_(index) {
    if (this.legacyMode_ && index >= this.values_.length) {
      console.warn( false ? 0 : "[mobx] Out of bounds read: " + index);
      return void 0;
    }
    this.atom_.reportObserved();
    return this.dehanceValue_(this.values_[index]);
  };
  _proto.set_ = function set_(index, newValue) {
    var values2 = this.values_;
    if (this.legacyMode_ && index > values2.length) {
      die(17, index, values2.length);
    }
    if (index < values2.length) {
      checkIfStateModificationsAreAllowed(this.atom_);
      var oldValue = values2[index];
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          type: UPDATE,
          object: this.proxy_,
          index,
          newValue
        });
        if (!change) {
          return;
        }
        newValue = change.newValue;
      }
      newValue = this.enhancer_(newValue, oldValue);
      var changed = newValue !== oldValue;
      if (changed) {
        values2[index] = newValue;
        this.notifyArrayChildUpdate_(index, newValue, oldValue);
      }
    } else {
      var newItems = new Array(index + 1 - values2.length);
      for (var i = 0; i < newItems.length - 1; i++) {
        newItems[i] = void 0;
      }
      newItems[newItems.length - 1] = newValue;
      this.spliceWithArray_(values2.length, 0, newItems);
    }
  };
  return ObservableArrayAdministration2;
})();
function createObservableArray(initialValues, enhancer, name, owned) {
  if (name === void 0) {
    name =  false ? 0 : "ObservableArray";
  }
  if (owned === void 0) {
    owned = false;
  }
  assertProxies();
  var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
  addHiddenFinalProp(adm.values_, $mobx, adm);
  var proxy = new Proxy(adm.values_, arrayTraps);
  adm.proxy_ = proxy;
  if (initialValues && initialValues.length) {
    var prev = allowStateChangesStart(true);
    adm.spliceWithArray_(0, 0, initialValues);
    allowStateChangesEnd(prev);
  }
  return proxy;
}
var arrayExtensions = {
  clear: function clear() {
    return this.splice(0);
  },
  replace: function replace(newItems) {
    var adm = this[$mobx];
    return adm.spliceWithArray_(0, adm.values_.length, newItems);
  },
  // Used by JSON.stringify
  toJSON: function toJSON() {
    return this.slice();
  },
  /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */
  splice: function splice(index, deleteCount) {
    for (var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      newItems[_key - 2] = arguments[_key];
    }
    var adm = this[$mobx];
    switch (arguments.length) {
      case 0:
        return [];
      case 1:
        return adm.spliceWithArray_(index);
      case 2:
        return adm.spliceWithArray_(index, deleteCount);
    }
    return adm.spliceWithArray_(index, deleteCount, newItems);
  },
  spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
    return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
  },
  push: function push() {
    var adm = this[$mobx];
    for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      items[_key2] = arguments[_key2];
    }
    adm.spliceWithArray_(adm.values_.length, 0, items);
    return adm.values_.length;
  },
  pop: function pop() {
    return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
  },
  shift: function shift() {
    return this.splice(0, 1)[0];
  },
  unshift: function unshift() {
    var adm = this[$mobx];
    for (var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      items[_key3] = arguments[_key3];
    }
    adm.spliceWithArray_(0, 0, items);
    return adm.values_.length;
  },
  reverse: function reverse() {
    if (globalState.trackingDerivation) {
      die(37, "reverse");
    }
    this.replace(this.slice().reverse());
    return this;
  },
  sort: function sort() {
    if (globalState.trackingDerivation) {
      die(37, "sort");
    }
    var copy = this.slice();
    copy.sort.apply(copy, arguments);
    this.replace(copy);
    return this;
  },
  remove: function remove2(value) {
    var adm = this[$mobx];
    var idx = adm.dehanceValues_(adm.values_).indexOf(value);
    if (idx > -1) {
      this.splice(idx, 1);
      return true;
    }
    return false;
  }
};
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
  if (typeof Array.prototype[funcName] === "function") {
    arrayExtensions[funcName] = funcFactory(funcName);
  }
}
function simpleFunc(funcName) {
  return function() {
    var adm = this[$mobx];
    adm.atom_.reportObserved();
    var dehancedValues = adm.dehanceValues_(adm.values_);
    return dehancedValues[funcName].apply(dehancedValues, arguments);
  };
}
function mapLikeFunc(funcName) {
  return function(callback, thisArg) {
    var _this2 = this;
    var adm = this[$mobx];
    adm.atom_.reportObserved();
    var dehancedValues = adm.dehanceValues_(adm.values_);
    return dehancedValues[funcName](function(element, index) {
      return callback.call(thisArg, element, index, _this2);
    });
  };
}
function reduceLikeFunc(funcName) {
  return function() {
    var _this3 = this;
    var adm = this[$mobx];
    adm.atom_.reportObserved();
    var dehancedValues = adm.dehanceValues_(adm.values_);
    var callback = arguments[0];
    arguments[0] = function(accumulator, currentValue, index) {
      return callback(accumulator, currentValue, index, _this3);
    };
    return dehancedValues[funcName].apply(dehancedValues, arguments);
  };
}
var isObservableArrayAdministration = /* @__PURE__ */ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
  return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var _Symbol$iterator, _Symbol$toStringTag;
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
_Symbol$iterator = Symbol.iterator;
_Symbol$toStringTag = Symbol.toStringTag;
var ObservableMap = /* @__PURE__ */ (function() {
  function ObservableMap2(initialData, enhancer_, name_) {
    var _this = this;
    if (enhancer_ === void 0) {
      enhancer_ = deepEnhancer;
    }
    if (name_ === void 0) {
      name_ =  false ? 0 : "ObservableMap";
    }
    this.enhancer_ = void 0;
    this.name_ = void 0;
    this[$mobx] = ObservableMapMarker;
    this.data_ = void 0;
    this.hasMap_ = void 0;
    this.keysAtom_ = void 0;
    this.interceptors_ = void 0;
    this.changeListeners_ = void 0;
    this.dehancer = void 0;
    this.enhancer_ = enhancer_;
    this.name_ = name_;
    if (!isFunction(Map)) {
      die(18);
    }
    this.keysAtom_ = createAtom( false ? 0 : "ObservableMap.keys()");
    this.data_ = /* @__PURE__ */ new Map();
    this.hasMap_ = /* @__PURE__ */ new Map();
    allowStateChanges(true, function() {
      _this.merge(initialData);
    });
  }
  var _proto = ObservableMap2.prototype;
  _proto.has_ = function has_(key) {
    return this.data_.has(key);
  };
  _proto.has = function has3(key) {
    var _this2 = this;
    if (!globalState.trackingDerivation) {
      return this.has_(key);
    }
    var entry = this.hasMap_.get(key);
    if (!entry) {
      var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer,  false ? 0 : "ObservableMap.key?", false);
      this.hasMap_.set(key, newEntry);
      onBecomeUnobserved(newEntry, function() {
        return _this2.hasMap_["delete"](key);
      });
    }
    return entry.get();
  };
  _proto.set = function set5(key, value) {
    var hasKey = this.has_(key);
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: hasKey ? UPDATE : ADD,
        object: this,
        newValue: value,
        name: key
      });
      if (!change) {
        return this;
      }
      value = change.newValue;
    }
    if (hasKey) {
      this.updateValue_(key, value);
    } else {
      this.addValue_(key, value);
    }
    return this;
  };
  _proto["delete"] = function _delete(key) {
    var _this3 = this;
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: DELETE,
        object: this,
        name: key
      });
      if (!change) {
        return false;
      }
    }
    if (this.has_(key)) {
      var notifySpy = isSpyEnabled();
      var notify = hasListeners(this);
      var _change = notify || notifySpy ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: DELETE,
        object: this,
        oldValue: this.data_.get(key).value_,
        name: key
      } : null;
      if (false) // removed by dead control flow
{}
      transaction(function() {
        var _this3$hasMap_$get;
        _this3.keysAtom_.reportChanged();
        (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null ? void 0 : _this3$hasMap_$get.setNewValue_(false);
        var observable2 = _this3.data_.get(key);
        observable2.setNewValue_(void 0);
        _this3.data_["delete"](key);
      });
      if (notify) {
        notifyListeners(this, _change);
      }
      if (false) // removed by dead control flow
{}
      return true;
    }
    return false;
  };
  _proto.updateValue_ = function updateValue_(key, newValue) {
    var observable2 = this.data_.get(key);
    newValue = observable2.prepareNewValue_(newValue);
    if (newValue !== globalState.UNCHANGED) {
      var notifySpy = isSpyEnabled();
      var notify = hasListeners(this);
      var change = notify || notifySpy ? {
        observableKind: "map",
        debugObjectName: this.name_,
        type: UPDATE,
        object: this,
        oldValue: observable2.value_,
        name: key,
        newValue
      } : null;
      if (false) // removed by dead control flow
{}
      observable2.setNewValue_(newValue);
      if (notify) {
        notifyListeners(this, change);
      }
      if (false) // removed by dead control flow
{}
    }
  };
  _proto.addValue_ = function addValue_(key, newValue) {
    var _this4 = this;
    checkIfStateModificationsAreAllowed(this.keysAtom_);
    transaction(function() {
      var _this4$hasMap_$get;
      var observable2 = new ObservableValue(newValue, _this4.enhancer_,  false ? 0 : "ObservableMap.key", false);
      _this4.data_.set(key, observable2);
      newValue = observable2.value_;
      (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null ? void 0 : _this4$hasMap_$get.setNewValue_(true);
      _this4.keysAtom_.reportChanged();
    });
    var notifySpy = isSpyEnabled();
    var notify = hasListeners(this);
    var change = notify || notifySpy ? {
      observableKind: "map",
      debugObjectName: this.name_,
      type: ADD,
      object: this,
      name: key,
      newValue
    } : null;
    if (false) // removed by dead control flow
{}
    if (notify) {
      notifyListeners(this, change);
    }
    if (false) // removed by dead control flow
{}
  };
  _proto.get = function get4(key) {
    if (this.has(key)) {
      return this.dehanceValue_(this.data_.get(key).get());
    }
    return this.dehanceValue_(void 0);
  };
  _proto.dehanceValue_ = function dehanceValue_(value) {
    if (this.dehancer !== void 0) {
      return this.dehancer(value);
    }
    return value;
  };
  _proto.keys = function keys2() {
    this.keysAtom_.reportObserved();
    return this.data_.keys();
  };
  _proto.values = function values2() {
    var self2 = this;
    var keys2 = this.keys();
    return makeIterable({
      next: function next() {
        var _keys$next = keys2.next(), done = _keys$next.done, value = _keys$next.value;
        return {
          done,
          value: done ? void 0 : self2.get(value)
        };
      }
    });
  };
  _proto.entries = function entries2() {
    var self2 = this;
    var keys2 = this.keys();
    return makeIterable({
      next: function next() {
        var _keys$next2 = keys2.next(), done = _keys$next2.done, value = _keys$next2.value;
        return {
          done,
          value: done ? void 0 : [value, self2.get(value)]
        };
      }
    });
  };
  _proto[_Symbol$iterator] = function() {
    return this.entries();
  };
  _proto.forEach = function forEach(callback, thisArg) {
    for (var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done; ) {
      var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
      callback.call(thisArg, value, key, this);
    }
  };
  _proto.merge = function merge(other) {
    var _this5 = this;
    if (isObservableMap(other)) {
      other = new Map(other);
    }
    transaction(function() {
      if (isPlainObject(other)) {
        getPlainObjectKeys(other).forEach(function(key) {
          return _this5.set(key, other[key]);
        });
      } else if (Array.isArray(other)) {
        other.forEach(function(_ref) {
          var key = _ref[0], value = _ref[1];
          return _this5.set(key, value);
        });
      } else if (isES6Map(other)) {
        if (other.constructor !== Map) {
          die(19, other);
        }
        other.forEach(function(value, key) {
          return _this5.set(key, value);
        });
      } else if (other !== null && other !== void 0) {
        die(20, other);
      }
    });
    return this;
  };
  _proto.clear = function clear2() {
    var _this6 = this;
    transaction(function() {
      untracked(function() {
        for (var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done; ) {
          var key = _step2.value;
          _this6["delete"](key);
        }
      });
    });
  };
  _proto.replace = function replace2(values2) {
    var _this7 = this;
    transaction(function() {
      var replacementMap = convertToMap(values2);
      var orderedData = /* @__PURE__ */ new Map();
      var keysReportChangedCalled = false;
      for (var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done; ) {
        var key = _step3.value;
        if (!replacementMap.has(key)) {
          var deleted = _this7["delete"](key);
          if (deleted) {
            keysReportChangedCalled = true;
          } else {
            var value = _this7.data_.get(key);
            orderedData.set(key, value);
          }
        }
      }
      for (var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done; ) {
        var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
        var keyExisted = _this7.data_.has(_key);
        _this7.set(_key, _value);
        if (_this7.data_.has(_key)) {
          var _value2 = _this7.data_.get(_key);
          orderedData.set(_key, _value2);
          if (!keyExisted) {
            keysReportChangedCalled = true;
          }
        }
      }
      if (!keysReportChangedCalled) {
        if (_this7.data_.size !== orderedData.size) {
          _this7.keysAtom_.reportChanged();
        } else {
          var iter1 = _this7.data_.keys();
          var iter2 = orderedData.keys();
          var next1 = iter1.next();
          var next2 = iter2.next();
          while (!next1.done) {
            if (next1.value !== next2.value) {
              _this7.keysAtom_.reportChanged();
              break;
            }
            next1 = iter1.next();
            next2 = iter2.next();
          }
        }
      }
      _this7.data_ = orderedData;
    });
    return this;
  };
  _proto.toString = function toString2() {
    return "[object ObservableMap]";
  };
  _proto.toJSON = function toJSON2() {
    return Array.from(this);
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    if (false) // removed by dead control flow
{}
    return registerListener(this, listener);
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _createClass(ObservableMap2, [{
    key: "size",
    get: function get4() {
      this.keysAtom_.reportObserved();
      return this.data_.size;
    }
  }, {
    key: _Symbol$toStringTag,
    get: function get4() {
      return "Map";
    }
  }]);
  return ObservableMap2;
})();
var isObservableMap = /* @__PURE__ */ createInstanceofPredicate("ObservableMap", ObservableMap);
function convertToMap(dataStructure) {
  if (isES6Map(dataStructure) || isObservableMap(dataStructure)) {
    return dataStructure;
  } else if (Array.isArray(dataStructure)) {
    return new Map(dataStructure);
  } else if (isPlainObject(dataStructure)) {
    var map2 = /* @__PURE__ */ new Map();
    for (var key in dataStructure) {
      map2.set(key, dataStructure[key]);
    }
    return map2;
  } else {
    return die(21, dataStructure);
  }
}
var _Symbol$iterator$1, _Symbol$toStringTag$1;
var ObservableSetMarker = {};
_Symbol$iterator$1 = Symbol.iterator;
_Symbol$toStringTag$1 = Symbol.toStringTag;
var ObservableSet = /* @__PURE__ */ (function() {
  function ObservableSet2(initialData, enhancer, name_) {
    if (enhancer === void 0) {
      enhancer = deepEnhancer;
    }
    if (name_ === void 0) {
      name_ =  false ? 0 : "ObservableSet";
    }
    this.name_ = void 0;
    this[$mobx] = ObservableSetMarker;
    this.data_ = /* @__PURE__ */ new Set();
    this.atom_ = void 0;
    this.changeListeners_ = void 0;
    this.interceptors_ = void 0;
    this.dehancer = void 0;
    this.enhancer_ = void 0;
    this.name_ = name_;
    if (!isFunction(Set)) {
      die(22);
    }
    this.atom_ = createAtom(this.name_);
    this.enhancer_ = function(newV, oldV) {
      return enhancer(newV, oldV, name_);
    };
    if (initialData) {
      this.replace(initialData);
    }
  }
  var _proto = ObservableSet2.prototype;
  _proto.dehanceValue_ = function dehanceValue_(value) {
    if (this.dehancer !== void 0) {
      return this.dehancer(value);
    }
    return value;
  };
  _proto.clear = function clear2() {
    var _this = this;
    transaction(function() {
      untracked(function() {
        for (var _iterator = _createForOfIteratorHelperLoose(_this.data_.values()), _step; !(_step = _iterator()).done; ) {
          var value = _step.value;
          _this["delete"](value);
        }
      });
    });
  };
  _proto.forEach = function forEach(callbackFn, thisArg) {
    for (var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done; ) {
      var value = _step2.value;
      callbackFn.call(thisArg, value, value, this);
    }
  };
  _proto.add = function add(value) {
    var _this2 = this;
    checkIfStateModificationsAreAllowed(this.atom_);
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: ADD,
        object: this,
        newValue: value
      });
      if (!change) {
        return this;
      }
    }
    if (!this.has(value)) {
      transaction(function() {
        _this2.data_.add(_this2.enhancer_(value, void 0));
        _this2.atom_.reportChanged();
      });
      var notifySpy =  false && 0;
      var notify = hasListeners(this);
      var _change = notify || notifySpy ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: ADD,
        object: this,
        newValue: value
      } : null;
      if (notifySpy && "production" !== "production") // removed by dead control flow
{}
      if (notify) {
        notifyListeners(this, _change);
      }
      if (notifySpy && "production" !== "production") // removed by dead control flow
{}
    }
    return this;
  };
  _proto["delete"] = function _delete(value) {
    var _this3 = this;
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: DELETE,
        object: this,
        oldValue: value
      });
      if (!change) {
        return false;
      }
    }
    if (this.has(value)) {
      var notifySpy =  false && 0;
      var notify = hasListeners(this);
      var _change2 = notify || notifySpy ? {
        observableKind: "set",
        debugObjectName: this.name_,
        type: DELETE,
        object: this,
        oldValue: value
      } : null;
      if (notifySpy && "production" !== "production") // removed by dead control flow
{}
      transaction(function() {
        _this3.atom_.reportChanged();
        _this3.data_["delete"](value);
      });
      if (notify) {
        notifyListeners(this, _change2);
      }
      if (notifySpy && "production" !== "production") // removed by dead control flow
{}
      return true;
    }
    return false;
  };
  _proto.has = function has3(value) {
    this.atom_.reportObserved();
    return this.data_.has(this.dehanceValue_(value));
  };
  _proto.entries = function entries2() {
    var nextIndex = 0;
    var keys2 = Array.from(this.keys());
    var values2 = Array.from(this.values());
    return makeIterable({
      next: function next() {
        var index = nextIndex;
        nextIndex += 1;
        return index < values2.length ? {
          value: [keys2[index], values2[index]],
          done: false
        } : {
          done: true
        };
      }
    });
  };
  _proto.keys = function keys2() {
    return this.values();
  };
  _proto.values = function values2() {
    this.atom_.reportObserved();
    var self2 = this;
    var nextIndex = 0;
    var observableValues = Array.from(this.data_.values());
    return makeIterable({
      next: function next() {
        return nextIndex < observableValues.length ? {
          value: self2.dehanceValue_(observableValues[nextIndex++]),
          done: false
        } : {
          done: true
        };
      }
    });
  };
  _proto.replace = function replace2(other) {
    var _this4 = this;
    if (isObservableSet(other)) {
      other = new Set(other);
    }
    transaction(function() {
      if (Array.isArray(other)) {
        _this4.clear();
        other.forEach(function(value) {
          return _this4.add(value);
        });
      } else if (isES6Set(other)) {
        _this4.clear();
        other.forEach(function(value) {
          return _this4.add(value);
        });
      } else if (other !== null && other !== void 0) {
        die("Cannot initialize set from " + other);
      }
    });
    return this;
  };
  _proto.observe_ = function observe_(listener, fireImmediately) {
    if (false) // removed by dead control flow
{}
    return registerListener(this, listener);
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _proto.toJSON = function toJSON2() {
    return Array.from(this);
  };
  _proto.toString = function toString2() {
    return "[object ObservableSet]";
  };
  _proto[_Symbol$iterator$1] = function() {
    return this.values();
  };
  _createClass(ObservableSet2, [{
    key: "size",
    get: function get4() {
      this.atom_.reportObserved();
      return this.data_.size;
    }
  }, {
    key: _Symbol$toStringTag$1,
    get: function get4() {
      return "Set";
    }
  }]);
  return ObservableSet2;
})();
var isObservableSet = /* @__PURE__ */ createInstanceofPredicate("ObservableSet", ObservableSet);
var descriptorCache = /* @__PURE__ */ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /* @__PURE__ */ (function() {
  function ObservableObjectAdministration2(target_, values_, name_, defaultAnnotation_) {
    if (values_ === void 0) {
      values_ = /* @__PURE__ */ new Map();
    }
    if (defaultAnnotation_ === void 0) {
      defaultAnnotation_ = autoAnnotation;
    }
    this.target_ = void 0;
    this.values_ = void 0;
    this.name_ = void 0;
    this.defaultAnnotation_ = void 0;
    this.keysAtom_ = void 0;
    this.changeListeners_ = void 0;
    this.interceptors_ = void 0;
    this.proxy_ = void 0;
    this.isPlainObject_ = void 0;
    this.appliedAnnotations_ = void 0;
    this.pendingKeys_ = void 0;
    this.target_ = target_;
    this.values_ = values_;
    this.name_ = name_;
    this.defaultAnnotation_ = defaultAnnotation_;
    this.keysAtom_ = new Atom( false ? 0 : "ObservableObject.keys");
    this.isPlainObject_ = isPlainObject(this.target_);
    if (false) // removed by dead control flow
{}
    if (false) // removed by dead control flow
{}
  }
  var _proto = ObservableObjectAdministration2.prototype;
  _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
    return this.values_.get(key).get();
  };
  _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
    var observable2 = this.values_.get(key);
    if (observable2 instanceof ComputedValue) {
      observable2.set(newValue);
      return true;
    }
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        type: UPDATE,
        object: this.proxy_ || this.target_,
        name: key,
        newValue
      });
      if (!change) {
        return null;
      }
      newValue = change.newValue;
    }
    newValue = observable2.prepareNewValue_(newValue);
    if (newValue !== globalState.UNCHANGED) {
      var notify = hasListeners(this);
      var notifySpy =  false && 0;
      var _change = notify || notifySpy ? {
        type: UPDATE,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        oldValue: observable2.value_,
        name: key,
        newValue
      } : null;
      if (false) // removed by dead control flow
{}
      observable2.setNewValue_(newValue);
      if (notify) {
        notifyListeners(this, _change);
      }
      if (false) // removed by dead control flow
{}
    }
    return true;
  };
  _proto.get_ = function get_(key) {
    if (globalState.trackingDerivation && !hasProp(this.target_, key)) {
      this.has_(key);
    }
    return this.target_[key];
  };
  _proto.set_ = function set_(key, value, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    if (hasProp(this.target_, key)) {
      if (this.values_.has(key)) {
        return this.setObservablePropValue_(key, value);
      } else if (proxyTrap) {
        return Reflect.set(this.target_, key, value);
      } else {
        this.target_[key] = value;
        return true;
      }
    } else {
      return this.extend_(key, {
        value,
        enumerable: true,
        writable: true,
        configurable: true
      }, this.defaultAnnotation_, proxyTrap);
    }
  };
  _proto.has_ = function has_(key) {
    if (!globalState.trackingDerivation) {
      return key in this.target_;
    }
    this.pendingKeys_ || (this.pendingKeys_ = /* @__PURE__ */ new Map());
    var entry = this.pendingKeys_.get(key);
    if (!entry) {
      entry = new ObservableValue(key in this.target_, referenceEnhancer,  false ? 0 : "ObservableObject.key?", false);
      this.pendingKeys_.set(key, entry);
    }
    return entry.get();
  };
  _proto.make_ = function make_2(key, annotation) {
    if (annotation === true) {
      annotation = this.defaultAnnotation_;
    }
    if (annotation === false) {
      return;
    }
    assertAnnotable(this, annotation, key);
    if (!(key in this.target_)) {
      var _this$target_$storedA;
      if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) {
        return;
      } else {
        die(1, annotation.annotationType_, this.name_ + "." + key.toString());
      }
    }
    var source = this.target_;
    while (source && source !== objectPrototype) {
      var descriptor = getDescriptor(source, key);
      if (descriptor) {
        var outcome = annotation.make_(this, key, descriptor, source);
        if (outcome === 0) {
          return;
        }
        if (outcome === 1) {
          break;
        }
      }
      source = Object.getPrototypeOf(source);
    }
    recordAnnotationApplied(this, annotation, key);
  };
  _proto.extend_ = function extend_2(key, descriptor, annotation, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    if (annotation === true) {
      annotation = this.defaultAnnotation_;
    }
    if (annotation === false) {
      return this.defineProperty_(key, descriptor, proxyTrap);
    }
    assertAnnotable(this, annotation, key);
    var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
    if (outcome) {
      recordAnnotationApplied(this, annotation, key);
    }
    return outcome;
  };
  _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    try {
      startBatch();
      var deleteOutcome = this.delete_(key);
      if (!deleteOutcome) {
        return deleteOutcome;
      }
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: key,
          type: ADD,
          newValue: descriptor.value
        });
        if (!change) {
          return null;
        }
        var newValue = change.newValue;
        if (descriptor.value !== newValue) {
          descriptor = _extends({}, descriptor, {
            value: newValue
          });
        }
      }
      if (proxyTrap) {
        if (!Reflect.defineProperty(this.target_, key, descriptor)) {
          return false;
        }
      } else {
        defineProperty(this.target_, key, descriptor);
      }
      this.notifyPropertyAddition_(key, descriptor.value);
    } finally {
      endBatch();
    }
    return true;
  };
  _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    try {
      startBatch();
      var deleteOutcome = this.delete_(key);
      if (!deleteOutcome) {
        return deleteOutcome;
      }
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: key,
          type: ADD,
          newValue: value
        });
        if (!change) {
          return null;
        }
        value = change.newValue;
      }
      var cachedDescriptor = getCachedObservablePropDescriptor(key);
      var descriptor = {
        configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
        enumerable: true,
        get: cachedDescriptor.get,
        set: cachedDescriptor.set
      };
      if (proxyTrap) {
        if (!Reflect.defineProperty(this.target_, key, descriptor)) {
          return false;
        }
      } else {
        defineProperty(this.target_, key, descriptor);
      }
      var observable2 = new ObservableValue(value, enhancer,  false ? 0 : "ObservableObject.key", false);
      this.values_.set(key, observable2);
      this.notifyPropertyAddition_(key, observable2.value_);
    } finally {
      endBatch();
    }
    return true;
  };
  _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    try {
      startBatch();
      var deleteOutcome = this.delete_(key);
      if (!deleteOutcome) {
        return deleteOutcome;
      }
      if (hasInterceptors(this)) {
        var change = interceptChange(this, {
          object: this.proxy_ || this.target_,
          name: key,
          type: ADD,
          newValue: void 0
        });
        if (!change) {
          return null;
        }
      }
      options.name || (options.name =  false ? 0 : "ObservableObject.key");
      options.context = this.proxy_ || this.target_;
      var cachedDescriptor = getCachedObservablePropDescriptor(key);
      var descriptor = {
        configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
        enumerable: false,
        get: cachedDescriptor.get,
        set: cachedDescriptor.set
      };
      if (proxyTrap) {
        if (!Reflect.defineProperty(this.target_, key, descriptor)) {
          return false;
        }
      } else {
        defineProperty(this.target_, key, descriptor);
      }
      this.values_.set(key, new ComputedValue(options));
      this.notifyPropertyAddition_(key, void 0);
    } finally {
      endBatch();
    }
    return true;
  };
  _proto.delete_ = function delete_(key, proxyTrap) {
    if (proxyTrap === void 0) {
      proxyTrap = false;
    }
    if (!hasProp(this.target_, key)) {
      return true;
    }
    if (hasInterceptors(this)) {
      var change = interceptChange(this, {
        object: this.proxy_ || this.target_,
        name: key,
        type: REMOVE
      });
      if (!change) {
        return null;
      }
    }
    try {
      var _this$pendingKeys_, _this$pendingKeys_$ge;
      startBatch();
      var notify = hasListeners(this);
      var notifySpy =  false && 0;
      var observable2 = this.values_.get(key);
      var value = void 0;
      if (!observable2 && (notify || notifySpy)) {
        var _getDescriptor2;
        value = (_getDescriptor2 = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor2.value;
      }
      if (proxyTrap) {
        if (!Reflect.deleteProperty(this.target_, key)) {
          return false;
        }
      } else {
        delete this.target_[key];
      }
      if (false) // removed by dead control flow
{}
      if (observable2) {
        this.values_["delete"](key);
        if (observable2 instanceof ObservableValue) {
          value = observable2.value_;
        }
        propagateChanged(observable2);
      }
      this.keysAtom_.reportChanged();
      (_this$pendingKeys_ = this.pendingKeys_) == null ? void 0 : (_this$pendingKeys_$ge = _this$pendingKeys_.get(key)) == null ? void 0 : _this$pendingKeys_$ge.set(key in this.target_);
      if (notify || notifySpy) {
        var _change2 = {
          type: REMOVE,
          observableKind: "object",
          object: this.proxy_ || this.target_,
          debugObjectName: this.name_,
          oldValue: value,
          name: key
        };
        if (false) // removed by dead control flow
{}
        if (notify) {
          notifyListeners(this, _change2);
        }
        if (false) // removed by dead control flow
{}
      }
    } finally {
      endBatch();
    }
    return true;
  };
  _proto.observe_ = function observe_(callback, fireImmediately) {
    if (false) // removed by dead control flow
{}
    return registerListener(this, callback);
  };
  _proto.intercept_ = function intercept_(handler) {
    return registerInterceptor(this, handler);
  };
  _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
    var _this$pendingKeys_2, _this$pendingKeys_2$g;
    var notify = hasListeners(this);
    var notifySpy =  false && 0;
    if (notify || notifySpy) {
      var change = notify || notifySpy ? {
        type: ADD,
        observableKind: "object",
        debugObjectName: this.name_,
        object: this.proxy_ || this.target_,
        name: key,
        newValue: value
      } : null;
      if (false) // removed by dead control flow
{}
      if (notify) {
        notifyListeners(this, change);
      }
      if (false) // removed by dead control flow
{}
    }
    (_this$pendingKeys_2 = this.pendingKeys_) == null ? void 0 : (_this$pendingKeys_2$g = _this$pendingKeys_2.get(key)) == null ? void 0 : _this$pendingKeys_2$g.set(true);
    this.keysAtom_.reportChanged();
  };
  _proto.ownKeys_ = function ownKeys_() {
    this.keysAtom_.reportObserved();
    return ownKeys(this.target_);
  };
  _proto.keys_ = function keys_() {
    this.keysAtom_.reportObserved();
    return Object.keys(this.target_);
  };
  return ObservableObjectAdministration2;
})();
function asObservableObject(target, options) {
  var _options$name;
  if (false) // removed by dead control flow
{}
  if (hasProp(target, $mobx)) {
    if (false) // removed by dead control flow
{}
    return target;
  }
  if (false) // removed by dead control flow
{}
  var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name :  false ? 0 : "ObservableObject";
  var adm = new ObservableObjectAdministration(target, /* @__PURE__ */ new Map(), String(name), getAnnotationFromOptions(options));
  addHiddenProp(target, $mobx, adm);
  return target;
}
var isObservableObjectAdministration = /* @__PURE__ */ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
  return descriptorCache[key] || (descriptorCache[key] = {
    get: function get4() {
      return this[$mobx].getObservablePropValue_(key);
    },
    set: function set5(value) {
      return this[$mobx].setObservablePropValue_(key, value);
    }
  });
}
function isObservableObject(thing) {
  if (isObject(thing)) {
    return isObservableObjectAdministration(thing[$mobx]);
  }
  return false;
}
function recordAnnotationApplied(adm, annotation, key) {
  var _adm$target_$storedAn;
  if (false) // removed by dead control flow
{}
  (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null ? true : delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
  if (false) // removed by dead control flow
{}
  if (false) // removed by dead control flow
{ var requestedAnnotationType, currentAnnotationType, fieldName; }
}
var ENTRY_0 = /* @__PURE__ */ createArrayEntryDescriptor(0);
var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
var StubArray = function StubArray2() {
};
function inherit(ctor, proto) {
  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ctor.prototype, proto);
  } else if (ctor.prototype.__proto__ !== void 0) {
    ctor.prototype.__proto__ = proto;
  } else {
    ctor.prototype = proto;
  }
}
inherit(StubArray, Array.prototype);
var LegacyObservableArray = /* @__PURE__ */ (function(_StubArray, _Symbol$toStringTag2, _Symbol$iterator2) {
  _inheritsLoose(LegacyObservableArray2, _StubArray);
  function LegacyObservableArray2(initialValues, enhancer, name, owned) {
    var _this;
    if (name === void 0) {
      name =  false ? 0 : "ObservableArray";
    }
    if (owned === void 0) {
      owned = false;
    }
    _this = _StubArray.call(this) || this;
    var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
    adm.proxy_ = _assertThisInitialized(_this);
    addHiddenFinalProp(_assertThisInitialized(_this), $mobx, adm);
    if (initialValues && initialValues.length) {
      var prev = allowStateChangesStart(true);
      _this.spliceWithArray(0, 0, initialValues);
      allowStateChangesEnd(prev);
    }
    {
      Object.defineProperty(_assertThisInitialized(_this), "0", ENTRY_0);
    }
    return _this;
  }
  var _proto = LegacyObservableArray2.prototype;
  _proto.concat = function concat() {
    this[$mobx].atom_.reportObserved();
    for (var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++) {
      arrays[_key] = arguments[_key];
    }
    return Array.prototype.concat.apply(
      this.slice(),
      //@ts-ignore
      arrays.map(function(a) {
        return isObservableArray(a) ? a.slice() : a;
      })
    );
  };
  _proto[_Symbol$iterator2] = function() {
    var self2 = this;
    var nextIndex = 0;
    return makeIterable({
      next: function next() {
        return nextIndex < self2.length ? {
          value: self2[nextIndex++],
          done: false
        } : {
          done: true,
          value: void 0
        };
      }
    });
  };
  _createClass(LegacyObservableArray2, [{
    key: "length",
    get: function get4() {
      return this[$mobx].getArrayLength_();
    },
    set: function set5(newLength) {
      this[$mobx].setArrayLength_(newLength);
    }
  }, {
    key: _Symbol$toStringTag2,
    get: function get4() {
      return "Array";
    }
  }]);
  return LegacyObservableArray2;
})(StubArray, Symbol.toStringTag, Symbol.iterator);
Object.entries(arrayExtensions).forEach(function(_ref) {
  var prop = _ref[0], fn = _ref[1];
  if (prop !== "concat") {
    addHiddenProp(LegacyObservableArray.prototype, prop, fn);
  }
});
function createArrayEntryDescriptor(index) {
  return {
    enumerable: false,
    configurable: true,
    get: function get4() {
      return this[$mobx].get_(index);
    },
    set: function set5(value) {
      this[$mobx].set_(index, value);
    }
  };
}
function createArrayBufferItem(index) {
  defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
  if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
    for (var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++) {
      createArrayBufferItem(index);
    }
    OBSERVABLE_ARRAY_BUFFER_SIZE = max;
  }
}
reserveArrayBuffer(1e3);
function createLegacyArray(initialValues, enhancer, name) {
  return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
  if (typeof thing === "object" && thing !== null) {
    if (isObservableArray(thing)) {
      if (property !== void 0) {
        die(23);
      }
      return thing[$mobx].atom_;
    }
    if (isObservableSet(thing)) {
      return thing.atom_;
    }
    if (isObservableMap(thing)) {
      if (property === void 0) {
        return thing.keysAtom_;
      }
      var observable2 = thing.data_.get(property) || thing.hasMap_.get(property);
      if (!observable2) {
        die(25, property, getDebugName(thing));
      }
      return observable2;
    }
    if (isObservableObject(thing)) {
      if (!property) {
        return die(26);
      }
      var _observable = thing[$mobx].values_.get(property);
      if (!_observable) {
        die(27, property, getDebugName(thing));
      }
      return _observable;
    }
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
      return thing;
    }
  } else if (isFunction(thing)) {
    if (isReaction(thing[$mobx])) {
      return thing[$mobx];
    }
  }
  die(28);
}
function getAdministration(thing, property) {
  if (!thing) {
    die(29);
  }
  if (property !== void 0) {
    return getAdministration(getAtom(thing, property));
  }
  if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) {
    return thing;
  }
  if (isObservableMap(thing) || isObservableSet(thing)) {
    return thing;
  }
  if (thing[$mobx]) {
    return thing[$mobx];
  }
  die(24, thing);
}
function getDebugName(thing, property) {
  var named;
  if (property !== void 0) {
    named = getAtom(thing, property);
  } else if (isAction(thing)) {
    return thing.name;
  } else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) {
    named = getAdministration(thing);
  } else {
    named = getAtom(thing);
  }
  return named.name_;
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
  if (depth === void 0) {
    depth = -1;
  }
  return eq(a, b, depth);
}
function eq(a, b, depth, aStack, bStack) {
  if (a === b) {
    return a !== 0 || 1 / a === 1 / b;
  }
  if (a == null || b == null) {
    return false;
  }
  if (a !== a) {
    return b !== b;
  }
  var type = typeof a;
  if (type !== "function" && type !== "object" && typeof b != "object") {
    return false;
  }
  var className = toString.call(a);
  if (className !== toString.call(b)) {
    return false;
  }
  switch (className) {
    // Strings, numbers, regular expressions, dates, and booleans are compared by value.
    case "[object RegExp]":
    // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
    case "[object String]":
      return "" + a === "" + b;
    case "[object Number]":
      if (+a !== +a) {
        return +b !== +b;
      }
      return +a === 0 ? 1 / +a === 1 / b : +a === +b;
    case "[object Date]":
    case "[object Boolean]":
      return +a === +b;
    case "[object Symbol]":
      return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
    case "[object Map]":
    case "[object Set]":
      if (depth >= 0) {
        depth++;
      }
      break;
  }
  a = unwrap(a);
  b = unwrap(b);
  var areArrays = className === "[object Array]";
  if (!areArrays) {
    if (typeof a != "object" || typeof b != "object") {
      return false;
    }
    var aCtor = a.constructor, bCtor = b.constructor;
    if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) {
      return false;
    }
  }
  if (depth === 0) {
    return false;
  } else if (depth < 0) {
    depth = -1;
  }
  aStack = aStack || [];
  bStack = bStack || [];
  var length = aStack.length;
  while (length--) {
    if (aStack[length] === a) {
      return bStack[length] === b;
    }
  }
  aStack.push(a);
  bStack.push(b);
  if (areArrays) {
    length = a.length;
    if (length !== b.length) {
      return false;
    }
    while (length--) {
      if (!eq(a[length], b[length], depth - 1, aStack, bStack)) {
        return false;
      }
    }
  } else {
    var keys2 = Object.keys(a);
    var key;
    length = keys2.length;
    if (Object.keys(b).length !== length) {
      return false;
    }
    while (length--) {
      key = keys2[length];
      if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) {
        return false;
      }
    }
  }
  aStack.pop();
  bStack.pop();
  return true;
}
function unwrap(a) {
  if (isObservableArray(a)) {
    return a.slice();
  }
  if (isES6Map(a) || isObservableMap(a)) {
    return Array.from(a.entries());
  }
  if (isES6Set(a) || isObservableSet(a)) {
    return Array.from(a.entries());
  }
  return a;
}
function makeIterable(iterator) {
  iterator[Symbol.iterator] = getSelf;
  return iterator;
}
function getSelf() {
  return this;
}
function isAnnotation(thing) {
  return (
    // Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_)
  );
}
["Symbol", "Map", "Set"].forEach(function(m) {
  var g = getGlobal();
  if (typeof g[m] === "undefined") {
    die("MobX requires global '" + m + "' to be available or polyfilled");
  }
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
  __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy,
    extras: {
      getDebugName
    },
    $mobx
  });
}



/***/ }),

/***/ 50247:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var af = moment.defineLocale("af", {
    months: "Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),
    weekdays: "Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split(
      "_"
    ),
    weekdaysShort: "Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),
    weekdaysMin: "So_Ma_Di_Wo_Do_Vr_Sa".split("_"),
    meridiemParse: /vm|nm/i,
    isPM: function(input) {
      return /^nm$/i.test(input);
    },
    meridiem: function(hours, minutes, isLower) {
      if (hours < 12) {
        return isLower ? "vm" : "VM";
      } else {
        return isLower ? "nm" : "NM";
      }
    },
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Vandag om] LT",
      nextDay: "[M\xF4re om] LT",
      nextWeek: "dddd [om] LT",
      lastDay: "[Gister om] LT",
      lastWeek: "[Laas] dddd [om] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "oor %s",
      past: "%s gelede",
      s: "'n paar sekondes",
      ss: "%d sekondes",
      m: "'n minuut",
      mm: "%d minute",
      h: "'n uur",
      hh: "%d ure",
      d: "'n dag",
      dd: "%d dae",
      M: "'n maand",
      MM: "%d maande",
      y: "'n jaar",
      yy: "%d jaar"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal: function(number) {
      return number + (number === 1 || number === 8 || number >= 20 ? "ste" : "de");
    },
    week: {
      dow: 1,
      // Maandag is die eerste dag van die week.
      doy: 4
      // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
    }
  });
  return af;
}));


/***/ }),

/***/ 68118:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var pluralForm = function(n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
  }, plurals = {
    s: [
      "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
      "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
      ["\u062B\u0627\u0646\u064A\u062A\u0627\u0646", "\u062B\u0627\u0646\u064A\u062A\u064A\u0646"],
      "%d \u062B\u0648\u0627\u0646",
      "%d \u062B\u0627\u0646\u064A\u0629",
      "%d \u062B\u0627\u0646\u064A\u0629"
    ],
    m: [
      "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
      "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
      ["\u062F\u0642\u064A\u0642\u062A\u0627\u0646", "\u062F\u0642\u064A\u0642\u062A\u064A\u0646"],
      "%d \u062F\u0642\u0627\u0626\u0642",
      "%d \u062F\u0642\u064A\u0642\u0629",
      "%d \u062F\u0642\u064A\u0642\u0629"
    ],
    h: [
      "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
      "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
      ["\u0633\u0627\u0639\u062A\u0627\u0646", "\u0633\u0627\u0639\u062A\u064A\u0646"],
      "%d \u0633\u0627\u0639\u0627\u062A",
      "%d \u0633\u0627\u0639\u0629",
      "%d \u0633\u0627\u0639\u0629"
    ],
    d: [
      "\u0623\u0642\u0644 \u0645\u0646 \u064A\u0648\u0645",
      "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
      ["\u064A\u0648\u0645\u0627\u0646", "\u064A\u0648\u0645\u064A\u0646"],
      "%d \u0623\u064A\u0627\u0645",
      "%d \u064A\u0648\u0645\u064B\u0627",
      "%d \u064A\u0648\u0645"
    ],
    M: [
      "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
      "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
      ["\u0634\u0647\u0631\u0627\u0646", "\u0634\u0647\u0631\u064A\u0646"],
      "%d \u0623\u0634\u0647\u0631",
      "%d \u0634\u0647\u0631\u0627",
      "%d \u0634\u0647\u0631"
    ],
    y: [
      "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
      "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
      ["\u0639\u0627\u0645\u0627\u0646", "\u0639\u0627\u0645\u064A\u0646"],
      "%d \u0623\u0639\u0648\u0627\u0645",
      "%d \u0639\u0627\u0645\u064B\u0627",
      "%d \u0639\u0627\u0645"
    ]
  }, pluralize = function(u) {
    return function(number, withoutSuffix, string, isFuture) {
      var f = pluralForm(number), str = plurals[u][pluralForm(number)];
      if (f === 2) {
        str = str[withoutSuffix ? 0 : 1];
      }
      return str.replace(/%d/i, number);
    };
  }, months = [
    "\u062C\u0627\u0646\u0641\u064A",
    "\u0641\u064A\u0641\u0631\u064A",
    "\u0645\u0627\u0631\u0633",
    "\u0623\u0641\u0631\u064A\u0644",
    "\u0645\u0627\u064A",
    "\u062C\u0648\u0627\u0646",
    "\u062C\u0648\u064A\u0644\u064A\u0629",
    "\u0623\u0648\u062A",
    "\u0633\u0628\u062A\u0645\u0628\u0631",
    "\u0623\u0643\u062A\u0648\u0628\u0631",
    "\u0646\u0648\u0641\u0645\u0628\u0631",
    "\u062F\u064A\u0633\u0645\u0628\u0631"
  ];
  var arDz = moment.defineLocale("ar-dz", {
    months,
    monthsShort: months,
    weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
    weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
    weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "D/\u200FM/\u200FYYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    meridiemParse: /ص|م/,
    isPM: function(input) {
      return "\u0645" === input;
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u0635";
      } else {
        return "\u0645";
      }
    },
    calendar: {
      sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextDay: "[\u063A\u062F\u064B\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0628\u0639\u062F %s",
      past: "\u0645\u0646\u0630 %s",
      s: pluralize("s"),
      ss: pluralize("s"),
      m: pluralize("m"),
      mm: pluralize("m"),
      h: pluralize("h"),
      hh: pluralize("h"),
      d: pluralize("d"),
      dd: pluralize("d"),
      M: pluralize("M"),
      MM: pluralize("M"),
      y: pluralize("y"),
      yy: pluralize("y")
    },
    postformat: function(string) {
      return string.replace(/,/g, "\u060C");
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return arDz;
}));


/***/ }),

/***/ 15302:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var arKw = moment.defineLocale("ar-kw", {
    months: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648\u0632_\u063A\u0634\u062A_\u0634\u062A\u0646\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062F\u062C\u0646\u0628\u0631".split(
      "_"
    ),
    monthsShort: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648\u0632_\u063A\u0634\u062A_\u0634\u062A\u0646\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062F\u062C\u0646\u0628\u0631".split(
      "_"
    ),
    weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062A\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
    weekdaysShort: "\u0627\u062D\u062F_\u0627\u062A\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
    weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0641\u064A %s",
      past: "\u0645\u0646\u0630 %s",
      s: "\u062B\u0648\u0627\u0646",
      ss: "%d \u062B\u0627\u0646\u064A\u0629",
      m: "\u062F\u0642\u064A\u0642\u0629",
      mm: "%d \u062F\u0642\u0627\u0626\u0642",
      h: "\u0633\u0627\u0639\u0629",
      hh: "%d \u0633\u0627\u0639\u0627\u062A",
      d: "\u064A\u0648\u0645",
      dd: "%d \u0623\u064A\u0627\u0645",
      M: "\u0634\u0647\u0631",
      MM: "%d \u0623\u0634\u0647\u0631",
      y: "\u0633\u0646\u0629",
      yy: "%d \u0633\u0646\u0648\u0627\u062A"
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 12
      // The week that contains Jan 12th is the first week of the year.
    }
  });
  return arKw;
}));


/***/ }),

/***/ 80891:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "1",
    2: "2",
    3: "3",
    4: "4",
    5: "5",
    6: "6",
    7: "7",
    8: "8",
    9: "9",
    0: "0"
  }, pluralForm = function(n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
  }, plurals = {
    s: [
      "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
      "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
      ["\u062B\u0627\u0646\u064A\u062A\u0627\u0646", "\u062B\u0627\u0646\u064A\u062A\u064A\u0646"],
      "%d \u062B\u0648\u0627\u0646",
      "%d \u062B\u0627\u0646\u064A\u0629",
      "%d \u062B\u0627\u0646\u064A\u0629"
    ],
    m: [
      "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
      "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
      ["\u062F\u0642\u064A\u0642\u062A\u0627\u0646", "\u062F\u0642\u064A\u0642\u062A\u064A\u0646"],
      "%d \u062F\u0642\u0627\u0626\u0642",
      "%d \u062F\u0642\u064A\u0642\u0629",
      "%d \u062F\u0642\u064A\u0642\u0629"
    ],
    h: [
      "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
      "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
      ["\u0633\u0627\u0639\u062A\u0627\u0646", "\u0633\u0627\u0639\u062A\u064A\u0646"],
      "%d \u0633\u0627\u0639\u0627\u062A",
      "%d \u0633\u0627\u0639\u0629",
      "%d \u0633\u0627\u0639\u0629"
    ],
    d: [
      "\u0623\u0642\u0644 \u0645\u0646 \u064A\u0648\u0645",
      "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
      ["\u064A\u0648\u0645\u0627\u0646", "\u064A\u0648\u0645\u064A\u0646"],
      "%d \u0623\u064A\u0627\u0645",
      "%d \u064A\u0648\u0645\u064B\u0627",
      "%d \u064A\u0648\u0645"
    ],
    M: [
      "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
      "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
      ["\u0634\u0647\u0631\u0627\u0646", "\u0634\u0647\u0631\u064A\u0646"],
      "%d \u0623\u0634\u0647\u0631",
      "%d \u0634\u0647\u0631\u0627",
      "%d \u0634\u0647\u0631"
    ],
    y: [
      "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
      "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
      ["\u0639\u0627\u0645\u0627\u0646", "\u0639\u0627\u0645\u064A\u0646"],
      "%d \u0623\u0639\u0648\u0627\u0645",
      "%d \u0639\u0627\u0645\u064B\u0627",
      "%d \u0639\u0627\u0645"
    ]
  }, pluralize = function(u) {
    return function(number, withoutSuffix, string, isFuture) {
      var f = pluralForm(number), str = plurals[u][pluralForm(number)];
      if (f === 2) {
        str = str[withoutSuffix ? 0 : 1];
      }
      return str.replace(/%d/i, number);
    };
  }, months = [
    "\u064A\u0646\u0627\u064A\u0631",
    "\u0641\u0628\u0631\u0627\u064A\u0631",
    "\u0645\u0627\u0631\u0633",
    "\u0623\u0628\u0631\u064A\u0644",
    "\u0645\u0627\u064A\u0648",
    "\u064A\u0648\u0646\u064A\u0648",
    "\u064A\u0648\u0644\u064A\u0648",
    "\u0623\u063A\u0633\u0637\u0633",
    "\u0633\u0628\u062A\u0645\u0628\u0631",
    "\u0623\u0643\u062A\u0648\u0628\u0631",
    "\u0646\u0648\u0641\u0645\u0628\u0631",
    "\u062F\u064A\u0633\u0645\u0628\u0631"
  ];
  var arLy = moment.defineLocale("ar-ly", {
    months,
    monthsShort: months,
    weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
    weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
    weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "D/\u200FM/\u200FYYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    meridiemParse: /ص|م/,
    isPM: function(input) {
      return "\u0645" === input;
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u0635";
      } else {
        return "\u0645";
      }
    },
    calendar: {
      sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextDay: "[\u063A\u062F\u064B\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0628\u0639\u062F %s",
      past: "\u0645\u0646\u0630 %s",
      s: pluralize("s"),
      ss: pluralize("s"),
      m: pluralize("m"),
      mm: pluralize("m"),
      h: pluralize("h"),
      hh: pluralize("h"),
      d: pluralize("d"),
      dd: pluralize("d"),
      M: pluralize("M"),
      MM: pluralize("M"),
      y: pluralize("y"),
      yy: pluralize("y")
    },
    preparse: function(string) {
      return string.replace(/،/g, ",");
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      }).replace(/,/g, "\u060C");
    },
    week: {
      dow: 6,
      // Saturday is the first day of the week.
      doy: 12
      // The week that contains Jan 12th is the first week of the year.
    }
  });
  return arLy;
}));


/***/ }),

/***/ 18:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var arMa = moment.defineLocale("ar-ma", {
    months: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648\u0632_\u063A\u0634\u062A_\u0634\u062A\u0646\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062F\u062C\u0646\u0628\u0631".split(
      "_"
    ),
    monthsShort: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648\u0632_\u063A\u0634\u062A_\u0634\u062A\u0646\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0646\u0628\u0631_\u062F\u062C\u0646\u0628\u0631".split(
      "_"
    ),
    weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
    weekdaysShort: "\u0627\u062D\u062F_\u0627\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
    weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0641\u064A %s",
      past: "\u0645\u0646\u0630 %s",
      s: "\u062B\u0648\u0627\u0646",
      ss: "%d \u062B\u0627\u0646\u064A\u0629",
      m: "\u062F\u0642\u064A\u0642\u0629",
      mm: "%d \u062F\u0642\u0627\u0626\u0642",
      h: "\u0633\u0627\u0639\u0629",
      hh: "%d \u0633\u0627\u0639\u0627\u062A",
      d: "\u064A\u0648\u0645",
      dd: "%d \u0623\u064A\u0627\u0645",
      M: "\u0634\u0647\u0631",
      MM: "%d \u0623\u0634\u0647\u0631",
      y: "\u0633\u0646\u0629",
      yy: "%d \u0633\u0646\u0648\u0627\u062A"
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return arMa;
}));


/***/ }),

/***/ 9129:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Palestine) [ar-ps]
//! author : Majd Al-Shihabi : https://github.com/majdal
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u0661",
    2: "\u0662",
    3: "\u0663",
    4: "\u0664",
    5: "\u0665",
    6: "\u0666",
    7: "\u0667",
    8: "\u0668",
    9: "\u0669",
    0: "\u0660"
  }, numberMap = {
    "\u0661": "1",
    "\u0662": "2",
    "\u0663": "3",
    "\u0664": "4",
    "\u0665": "5",
    "\u0666": "6",
    "\u0667": "7",
    "\u0668": "8",
    "\u0669": "9",
    "\u0660": "0"
  };
  var arPs = moment.defineLocale("ar-ps", {
    months: "\u0643\u0627\u0646\u0648\u0646 \u0627\u0644\u062B\u0627\u0646\u064A_\u0634\u0628\u0627\u0637_\u0622\u0630\u0627\u0631_\u0646\u064A\u0633\u0627\u0646_\u0623\u064A\u0651\u0627\u0631_\u062D\u0632\u064A\u0631\u0627\u0646_\u062A\u0645\u0651\u0648\u0632_\u0622\u0628_\u0623\u064A\u0644\u0648\u0644_\u062A\u0634\u0631\u064A \u0627\u0644\u0623\u0648\u0651\u0644_\u062A\u0634\u0631\u064A\u0646 \u0627\u0644\u062B\u0627\u0646\u064A_\u0643\u0627\u0646\u0648\u0646 \u0627\u0644\u0623\u0648\u0651\u0644".split(
      "_"
    ),
    monthsShort: "\u0643\u0662_\u0634\u0628\u0627\u0637_\u0622\u0630\u0627\u0631_\u0646\u064A\u0633\u0627\u0646_\u0623\u064A\u0651\u0627\u0631_\u062D\u0632\u064A\u0631\u0627\u0646_\u062A\u0645\u0651\u0648\u0632_\u0622\u0628_\u0623\u064A\u0644\u0648\u0644_\u062A\u0661_\u062A\u0662_\u0643\u0661".split("_"),
    weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
    weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
    weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    meridiemParse: /ص|م/,
    isPM: function(input) {
      return "\u0645" === input;
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u0635";
      } else {
        return "\u0645";
      }
    },
    calendar: {
      sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0641\u064A %s",
      past: "\u0645\u0646\u0630 %s",
      s: "\u062B\u0648\u0627\u0646",
      ss: "%d \u062B\u0627\u0646\u064A\u0629",
      m: "\u062F\u0642\u064A\u0642\u0629",
      mm: "%d \u062F\u0642\u0627\u0626\u0642",
      h: "\u0633\u0627\u0639\u0629",
      hh: "%d \u0633\u0627\u0639\u0627\u062A",
      d: "\u064A\u0648\u0645",
      dd: "%d \u0623\u064A\u0627\u0645",
      M: "\u0634\u0647\u0631",
      MM: "%d \u0623\u0634\u0647\u0631",
      y: "\u0633\u0646\u0629",
      yy: "%d \u0633\u0646\u0648\u0627\u062A"
    },
    preparse: function(string) {
      return string.replace(/[٣٤٥٦٧٨٩٠]/g, function(match) {
        return numberMap[match];
      }).split("").reverse().join("").replace(/[١٢](?![\u062a\u0643])/g, function(match) {
        return numberMap[match];
      }).split("").reverse().join("").replace(/،/g, ",");
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      }).replace(/,/g, "\u060C");
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return arPs;
}));


/***/ }),

/***/ 74712:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u0661",
    2: "\u0662",
    3: "\u0663",
    4: "\u0664",
    5: "\u0665",
    6: "\u0666",
    7: "\u0667",
    8: "\u0668",
    9: "\u0669",
    0: "\u0660"
  }, numberMap = {
    "\u0661": "1",
    "\u0662": "2",
    "\u0663": "3",
    "\u0664": "4",
    "\u0665": "5",
    "\u0666": "6",
    "\u0667": "7",
    "\u0668": "8",
    "\u0669": "9",
    "\u0660": "0"
  };
  var arSa = moment.defineLocale("ar-sa", {
    months: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A\u0648_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648_\u0623\u063A\u0633\u0637\u0633_\u0633\u0628\u062A\u0645\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062F\u064A\u0633\u0645\u0628\u0631".split(
      "_"
    ),
    monthsShort: "\u064A\u0646\u0627\u064A\u0631_\u0641\u0628\u0631\u0627\u064A\u0631_\u0645\u0627\u0631\u0633_\u0623\u0628\u0631\u064A\u0644_\u0645\u0627\u064A\u0648_\u064A\u0648\u0646\u064A\u0648_\u064A\u0648\u0644\u064A\u0648_\u0623\u063A\u0633\u0637\u0633_\u0633\u0628\u062A\u0645\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062F\u064A\u0633\u0645\u0628\u0631".split(
      "_"
    ),
    weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
    weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
    weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    meridiemParse: /ص|م/,
    isPM: function(input) {
      return "\u0645" === input;
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u0635";
      } else {
        return "\u0645";
      }
    },
    calendar: {
      sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0641\u064A %s",
      past: "\u0645\u0646\u0630 %s",
      s: "\u062B\u0648\u0627\u0646",
      ss: "%d \u062B\u0627\u0646\u064A\u0629",
      m: "\u062F\u0642\u064A\u0642\u0629",
      mm: "%d \u062F\u0642\u0627\u0626\u0642",
      h: "\u0633\u0627\u0639\u0629",
      hh: "%d \u0633\u0627\u0639\u0627\u062A",
      d: "\u064A\u0648\u0645",
      dd: "%d \u0623\u064A\u0627\u0645",
      M: "\u0634\u0647\u0631",
      MM: "%d \u0623\u0634\u0647\u0631",
      y: "\u0633\u0646\u0629",
      yy: "%d \u0633\u0646\u0648\u0627\u062A"
    },
    preparse: function(string) {
      return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(match) {
        return numberMap[match];
      }).replace(/،/g, ",");
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      }).replace(/,/g, "\u060C");
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return arSa;
}));


/***/ }),

/***/ 54058:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var arTn = moment.defineLocale("ar-tn", {
    months: "\u062C\u0627\u0646\u0641\u064A_\u0641\u064A\u0641\u0631\u064A_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064A\u0644_\u0645\u0627\u064A_\u062C\u0648\u0627\u0646_\u062C\u0648\u064A\u0644\u064A\u0629_\u0623\u0648\u062A_\u0633\u0628\u062A\u0645\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062F\u064A\u0633\u0645\u0628\u0631".split(
      "_"
    ),
    monthsShort: "\u062C\u0627\u0646\u0641\u064A_\u0641\u064A\u0641\u0631\u064A_\u0645\u0627\u0631\u0633_\u0623\u0641\u0631\u064A\u0644_\u0645\u0627\u064A_\u062C\u0648\u0627\u0646_\u062C\u0648\u064A\u0644\u064A\u0629_\u0623\u0648\u062A_\u0633\u0628\u062A\u0645\u0628\u0631_\u0623\u0643\u062A\u0648\u0628\u0631_\u0646\u0648\u0641\u0645\u0628\u0631_\u062F\u064A\u0633\u0645\u0628\u0631".split(
      "_"
    ),
    weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
    weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
    weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextDay: "[\u063A\u062F\u0627 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastDay: "[\u0623\u0645\u0633 \u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastWeek: "dddd [\u0639\u0644\u0649 \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0641\u064A %s",
      past: "\u0645\u0646\u0630 %s",
      s: "\u062B\u0648\u0627\u0646",
      ss: "%d \u062B\u0627\u0646\u064A\u0629",
      m: "\u062F\u0642\u064A\u0642\u0629",
      mm: "%d \u062F\u0642\u0627\u0626\u0642",
      h: "\u0633\u0627\u0639\u0629",
      hh: "%d \u0633\u0627\u0639\u0627\u062A",
      d: "\u064A\u0648\u0645",
      dd: "%d \u0623\u064A\u0627\u0645",
      M: "\u0634\u0647\u0631",
      MM: "%d \u0623\u0634\u0647\u0631",
      y: "\u0633\u0646\u0629",
      yy: "%d \u0633\u0646\u0648\u0627\u062A"
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return arTn;
}));


/***/ }),

/***/ 80627:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u0661",
    2: "\u0662",
    3: "\u0663",
    4: "\u0664",
    5: "\u0665",
    6: "\u0666",
    7: "\u0667",
    8: "\u0668",
    9: "\u0669",
    0: "\u0660"
  }, numberMap = {
    "\u0661": "1",
    "\u0662": "2",
    "\u0663": "3",
    "\u0664": "4",
    "\u0665": "5",
    "\u0666": "6",
    "\u0667": "7",
    "\u0668": "8",
    "\u0669": "9",
    "\u0660": "0"
  }, pluralForm = function(n) {
    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
  }, plurals = {
    s: [
      "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
      "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
      ["\u062B\u0627\u0646\u064A\u062A\u0627\u0646", "\u062B\u0627\u0646\u064A\u062A\u064A\u0646"],
      "%d \u062B\u0648\u0627\u0646",
      "%d \u062B\u0627\u0646\u064A\u0629",
      "%d \u062B\u0627\u0646\u064A\u0629"
    ],
    m: [
      "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
      "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
      ["\u062F\u0642\u064A\u0642\u062A\u0627\u0646", "\u062F\u0642\u064A\u0642\u062A\u064A\u0646"],
      "%d \u062F\u0642\u0627\u0626\u0642",
      "%d \u062F\u0642\u064A\u0642\u0629",
      "%d \u062F\u0642\u064A\u0642\u0629"
    ],
    h: [
      "\u0623\u0642\u0644 \u0645\u0646 \u0633\u0627\u0639\u0629",
      "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
      ["\u0633\u0627\u0639\u062A\u0627\u0646", "\u0633\u0627\u0639\u062A\u064A\u0646"],
      "%d \u0633\u0627\u0639\u0627\u062A",
      "%d \u0633\u0627\u0639\u0629",
      "%d \u0633\u0627\u0639\u0629"
    ],
    d: [
      "\u0623\u0642\u0644 \u0645\u0646 \u064A\u0648\u0645",
      "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
      ["\u064A\u0648\u0645\u0627\u0646", "\u064A\u0648\u0645\u064A\u0646"],
      "%d \u0623\u064A\u0627\u0645",
      "%d \u064A\u0648\u0645\u064B\u0627",
      "%d \u064A\u0648\u0645"
    ],
    M: [
      "\u0623\u0642\u0644 \u0645\u0646 \u0634\u0647\u0631",
      "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
      ["\u0634\u0647\u0631\u0627\u0646", "\u0634\u0647\u0631\u064A\u0646"],
      "%d \u0623\u0634\u0647\u0631",
      "%d \u0634\u0647\u0631\u0627",
      "%d \u0634\u0647\u0631"
    ],
    y: [
      "\u0623\u0642\u0644 \u0645\u0646 \u0639\u0627\u0645",
      "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
      ["\u0639\u0627\u0645\u0627\u0646", "\u0639\u0627\u0645\u064A\u0646"],
      "%d \u0623\u0639\u0648\u0627\u0645",
      "%d \u0639\u0627\u0645\u064B\u0627",
      "%d \u0639\u0627\u0645"
    ]
  }, pluralize = function(u) {
    return function(number, withoutSuffix, string, isFuture) {
      var f = pluralForm(number), str = plurals[u][pluralForm(number)];
      if (f === 2) {
        str = str[withoutSuffix ? 0 : 1];
      }
      return str.replace(/%d/i, number);
    };
  }, months = [
    "\u064A\u0646\u0627\u064A\u0631",
    "\u0641\u0628\u0631\u0627\u064A\u0631",
    "\u0645\u0627\u0631\u0633",
    "\u0623\u0628\u0631\u064A\u0644",
    "\u0645\u0627\u064A\u0648",
    "\u064A\u0648\u0646\u064A\u0648",
    "\u064A\u0648\u0644\u064A\u0648",
    "\u0623\u063A\u0633\u0637\u0633",
    "\u0633\u0628\u062A\u0645\u0628\u0631",
    "\u0623\u0643\u062A\u0648\u0628\u0631",
    "\u0646\u0648\u0641\u0645\u0628\u0631",
    "\u062F\u064A\u0633\u0645\u0628\u0631"
  ];
  var ar = moment.defineLocale("ar", {
    months,
    monthsShort: months,
    weekdays: "\u0627\u0644\u0623\u062D\u062F_\u0627\u0644\u0625\u062B\u0646\u064A\u0646_\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621_\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621_\u0627\u0644\u062E\u0645\u064A\u0633_\u0627\u0644\u062C\u0645\u0639\u0629_\u0627\u0644\u0633\u0628\u062A".split("_"),
    weekdaysShort: "\u0623\u062D\u062F_\u0625\u062B\u0646\u064A\u0646_\u062B\u0644\u0627\u062B\u0627\u0621_\u0623\u0631\u0628\u0639\u0627\u0621_\u062E\u0645\u064A\u0633_\u062C\u0645\u0639\u0629_\u0633\u0628\u062A".split("_"),
    weekdaysMin: "\u062D_\u0646_\u062B_\u0631_\u062E_\u062C_\u0633".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "D/\u200FM/\u200FYYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    meridiemParse: /ص|م/,
    isPM: function(input) {
      return "\u0645" === input;
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u0635";
      } else {
        return "\u0645";
      }
    },
    calendar: {
      sameDay: "[\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextDay: "[\u063A\u062F\u064B\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      nextWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastDay: "[\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      lastWeek: "dddd [\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0628\u0639\u062F %s",
      past: "\u0645\u0646\u0630 %s",
      s: pluralize("s"),
      ss: pluralize("s"),
      m: pluralize("m"),
      mm: pluralize("m"),
      h: pluralize("h"),
      hh: pluralize("h"),
      d: pluralize("d"),
      dd: pluralize("d"),
      M: pluralize("M"),
      MM: pluralize("M"),
      y: pluralize("y"),
      yy: pluralize("y")
    },
    preparse: function(string) {
      return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(match) {
        return numberMap[match];
      }).replace(/،/g, ",");
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      }).replace(/,/g, "\u060C");
    },
    week: {
      dow: 6,
      // Saturday is the first day of the week.
      doy: 12
      // The week that contains Jan 12th is the first week of the year.
    }
  });
  return ar;
}));


/***/ }),

/***/ 91611:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var suffixes = {
    1: "-inci",
    5: "-inci",
    8: "-inci",
    70: "-inci",
    80: "-inci",
    2: "-nci",
    7: "-nci",
    20: "-nci",
    50: "-nci",
    3: "-\xFCnc\xFC",
    4: "-\xFCnc\xFC",
    100: "-\xFCnc\xFC",
    6: "-nc\u0131",
    9: "-uncu",
    10: "-uncu",
    30: "-uncu",
    60: "-\u0131nc\u0131",
    90: "-\u0131nc\u0131"
  };
  var az = moment.defineLocale("az", {
    months: "yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split(
      "_"
    ),
    monthsShort: "yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),
    weekdays: "Bazar_Bazar ert\u0259si_\xC7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131_\xC7\u0259r\u015F\u0259nb\u0259_C\xFCm\u0259 ax\u015Fam\u0131_C\xFCm\u0259_\u015E\u0259nb\u0259".split(
      "_"
    ),
    weekdaysShort: "Baz_BzE_\xC7Ax_\xC7\u0259r_CAx_C\xFCm_\u015E\u0259n".split("_"),
    weekdaysMin: "Bz_BE_\xC7A_\xC7\u0259_CA_C\xFC_\u015E\u0259".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[bug\xFCn saat] LT",
      nextDay: "[sabah saat] LT",
      nextWeek: "[g\u0259l\u0259n h\u0259ft\u0259] dddd [saat] LT",
      lastDay: "[d\xFCn\u0259n] LT",
      lastWeek: "[ke\xE7\u0259n h\u0259ft\u0259] dddd [saat] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s sonra",
      past: "%s \u0259vv\u0259l",
      s: "bir ne\xE7\u0259 saniy\u0259",
      ss: "%d saniy\u0259",
      m: "bir d\u0259qiq\u0259",
      mm: "%d d\u0259qiq\u0259",
      h: "bir saat",
      hh: "%d saat",
      d: "bir g\xFCn",
      dd: "%d g\xFCn",
      M: "bir ay",
      MM: "%d ay",
      y: "bir il",
      yy: "%d il"
    },
    meridiemParse: /gecə|səhər|gündüz|axşam/,
    isPM: function(input) {
      return /^(gündüz|axşam)$/.test(input);
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "gec\u0259";
      } else if (hour < 12) {
        return "s\u0259h\u0259r";
      } else if (hour < 17) {
        return "g\xFCnd\xFCz";
      } else {
        return "ax\u015Fam";
      }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
    ordinal: function(number) {
      if (number === 0) {
        return number + "-\u0131nc\u0131";
      }
      var a = number % 10, b = number % 100 - a, c = number >= 100 ? 100 : null;
      return number + (suffixes[a] || suffixes[b] || suffixes[c]);
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return az;
}));


/***/ }),

/***/ 2269:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function plural(word, num) {
    var forms = word.split("_");
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
  }
  function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
      ss: withoutSuffix ? "\u0441\u0435\u043A\u0443\u043D\u0434\u0430_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434" : "\u0441\u0435\u043A\u0443\u043D\u0434\u0443_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434",
      mm: withoutSuffix ? "\u0445\u0432\u0456\u043B\u0456\u043D\u0430_\u0445\u0432\u0456\u043B\u0456\u043D\u044B_\u0445\u0432\u0456\u043B\u0456\u043D" : "\u0445\u0432\u0456\u043B\u0456\u043D\u0443_\u0445\u0432\u0456\u043B\u0456\u043D\u044B_\u0445\u0432\u0456\u043B\u0456\u043D",
      hh: withoutSuffix ? "\u0433\u0430\u0434\u0437\u0456\u043D\u0430_\u0433\u0430\u0434\u0437\u0456\u043D\u044B_\u0433\u0430\u0434\u0437\u0456\u043D" : "\u0433\u0430\u0434\u0437\u0456\u043D\u0443_\u0433\u0430\u0434\u0437\u0456\u043D\u044B_\u0433\u0430\u0434\u0437\u0456\u043D",
      dd: "\u0434\u0437\u0435\u043D\u044C_\u0434\u043D\u0456_\u0434\u0437\u0451\u043D",
      MM: "\u043C\u0435\u0441\u044F\u0446_\u043C\u0435\u0441\u044F\u0446\u044B_\u043C\u0435\u0441\u044F\u0446\u0430\u045E",
      yy: "\u0433\u043E\u0434_\u0433\u0430\u0434\u044B_\u0433\u0430\u0434\u043E\u045E"
    };
    if (key === "m") {
      return withoutSuffix ? "\u0445\u0432\u0456\u043B\u0456\u043D\u0430" : "\u0445\u0432\u0456\u043B\u0456\u043D\u0443";
    } else if (key === "h") {
      return withoutSuffix ? "\u0433\u0430\u0434\u0437\u0456\u043D\u0430" : "\u0433\u0430\u0434\u0437\u0456\u043D\u0443";
    } else {
      return number + " " + plural(format[key], +number);
    }
  }
  var be = moment.defineLocale("be", {
    months: {
      format: "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F_\u043B\u044E\u0442\u0430\u0433\u0430_\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430_\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430_\u0442\u0440\u0430\u045E\u043D\u044F_\u0447\u044D\u0440\u0432\u0435\u043D\u044F_\u043B\u0456\u043F\u0435\u043D\u044F_\u0436\u043D\u0456\u045E\u043D\u044F_\u0432\u0435\u0440\u0430\u0441\u043D\u044F_\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430_\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430_\u0441\u043D\u0435\u0436\u043D\u044F".split(
        "_"
      ),
      standalone: "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C_\u043B\u044E\u0442\u044B_\u0441\u0430\u043A\u0430\u0432\u0456\u043A_\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A_\u0442\u0440\u0430\u0432\u0435\u043D\u044C_\u0447\u044D\u0440\u0432\u0435\u043D\u044C_\u043B\u0456\u043F\u0435\u043D\u044C_\u0436\u043D\u0456\u0432\u0435\u043D\u044C_\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C_\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A_\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434_\u0441\u043D\u0435\u0436\u0430\u043D\u044C".split(
        "_"
      )
    },
    monthsShort: "\u0441\u0442\u0443\u0434_\u043B\u044E\u0442_\u0441\u0430\u043A_\u043A\u0440\u0430\u0441_\u0442\u0440\u0430\u0432_\u0447\u044D\u0440\u0432_\u043B\u0456\u043F_\u0436\u043D\u0456\u0432_\u0432\u0435\u0440_\u043A\u0430\u0441\u0442_\u043B\u0456\u0441\u0442_\u0441\u043D\u0435\u0436".split("_"),
    weekdays: {
      format: "\u043D\u044F\u0434\u0437\u0435\u043B\u044E_\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A_\u0430\u045E\u0442\u043E\u0440\u0430\u043A_\u0441\u0435\u0440\u0430\u0434\u0443_\u0447\u0430\u0446\u0432\u0435\u0440_\u043F\u044F\u0442\u043D\u0456\u0446\u0443_\u0441\u0443\u0431\u043E\u0442\u0443".split(
        "_"
      ),
      standalone: "\u043D\u044F\u0434\u0437\u0435\u043B\u044F_\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A_\u0430\u045E\u0442\u043E\u0440\u0430\u043A_\u0441\u0435\u0440\u0430\u0434\u0430_\u0447\u0430\u0446\u0432\u0435\u0440_\u043F\u044F\u0442\u043D\u0456\u0446\u0430_\u0441\u0443\u0431\u043E\u0442\u0430".split(
        "_"
      ),
      isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
    },
    weekdaysShort: "\u043D\u0434_\u043F\u043D_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043F\u0442_\u0441\u0431".split("_"),
    weekdaysMin: "\u043D\u0434_\u043F\u043D_\u0430\u0442_\u0441\u0440_\u0447\u0446_\u043F\u0442_\u0441\u0431".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY \u0433.",
      LLL: "D MMMM YYYY \u0433., HH:mm",
      LLLL: "dddd, D MMMM YYYY \u0433., HH:mm"
    },
    calendar: {
      sameDay: "[\u0421\u0451\u043D\u043D\u044F \u045E] LT",
      nextDay: "[\u0417\u0430\u045E\u0442\u0440\u0430 \u045E] LT",
      lastDay: "[\u0423\u0447\u043E\u0440\u0430 \u045E] LT",
      nextWeek: function() {
        return "[\u0423] dddd [\u045E] LT";
      },
      lastWeek: function() {
        switch (this.day()) {
          case 0:
          case 3:
          case 5:
          case 6:
            return "[\u0423 \u043C\u0456\u043D\u0443\u043B\u0443\u044E] dddd [\u045E] LT";
          case 1:
          case 2:
          case 4:
            return "[\u0423 \u043C\u0456\u043D\u0443\u043B\u044B] dddd [\u045E] LT";
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "\u043F\u0440\u0430\u0437 %s",
      past: "%s \u0442\u0430\u043C\u0443",
      s: "\u043D\u0435\u043A\u0430\u043B\u044C\u043A\u0456 \u0441\u0435\u043A\u0443\u043D\u0434",
      m: relativeTimeWithPlural,
      mm: relativeTimeWithPlural,
      h: relativeTimeWithPlural,
      hh: relativeTimeWithPlural,
      d: "\u0434\u0437\u0435\u043D\u044C",
      dd: relativeTimeWithPlural,
      M: "\u043C\u0435\u0441\u044F\u0446",
      MM: relativeTimeWithPlural,
      y: "\u0433\u043E\u0434",
      yy: relativeTimeWithPlural
    },
    meridiemParse: /ночы|раніцы|дня|вечара/,
    isPM: function(input) {
      return /^(дня|вечара)$/.test(input);
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u043D\u043E\u0447\u044B";
      } else if (hour < 12) {
        return "\u0440\u0430\u043D\u0456\u0446\u044B";
      } else if (hour < 17) {
        return "\u0434\u043D\u044F";
      } else {
        return "\u0432\u0435\u0447\u0430\u0440\u0430";
      }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
    ordinal: function(number, period) {
      switch (period) {
        case "M":
        case "d":
        case "DDD":
        case "w":
        case "W":
          return (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? number + "-\u0456" : number + "-\u044B";
        case "D":
          return number + "-\u0433\u0430";
        default:
          return number;
      }
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return be;
}));


/***/ }),

/***/ 22011:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var bg = moment.defineLocale("bg", {
    months: "\u044F\u043D\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0438\u043B_\u043C\u0430\u0439_\u044E\u043D\u0438_\u044E\u043B\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438_\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438_\u043D\u043E\u0435\u043C\u0432\u0440\u0438_\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438".split(
      "_"
    ),
    monthsShort: "\u044F\u043D\u0443_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0439_\u044E\u043D\u0438_\u044E\u043B\u0438_\u0430\u0432\u0433_\u0441\u0435\u043F_\u043E\u043A\u0442_\u043D\u043E\u0435_\u0434\u0435\u043A".split("_"),
    weekdays: "\u043D\u0435\u0434\u0435\u043B\u044F_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u044F\u0434\u0430_\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A_\u043F\u0435\u0442\u044A\u043A_\u0441\u044A\u0431\u043E\u0442\u0430".split(
      "_"
    ),
    weekdaysShort: "\u043D\u0435\u0434_\u043F\u043E\u043D_\u0432\u0442\u043E_\u0441\u0440\u044F_\u0447\u0435\u0442_\u043F\u0435\u0442_\u0441\u044A\u0431".split("_"),
    weekdaysMin: "\u043D\u0434_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "D.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY H:mm",
      LLLL: "dddd, D MMMM YYYY H:mm"
    },
    calendar: {
      sameDay: "[\u0414\u043D\u0435\u0441 \u0432] LT",
      nextDay: "[\u0423\u0442\u0440\u0435 \u0432] LT",
      nextWeek: "dddd [\u0432] LT",
      lastDay: "[\u0412\u0447\u0435\u0440\u0430 \u0432] LT",
      lastWeek: function() {
        switch (this.day()) {
          case 0:
          case 3:
          case 6:
            return "[\u041C\u0438\u043D\u0430\u043B\u0430\u0442\u0430] dddd [\u0432] LT";
          case 1:
          case 2:
          case 4:
          case 5:
            return "[\u041C\u0438\u043D\u0430\u043B\u0438\u044F] dddd [\u0432] LT";
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0441\u043B\u0435\u0434 %s",
      past: "\u043F\u0440\u0435\u0434\u0438 %s",
      s: "\u043D\u044F\u043A\u043E\u043B\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
      ss: "%d \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
      m: "\u043C\u0438\u043D\u0443\u0442\u0430",
      mm: "%d \u043C\u0438\u043D\u0443\u0442\u0438",
      h: "\u0447\u0430\u0441",
      hh: "%d \u0447\u0430\u0441\u0430",
      d: "\u0434\u0435\u043D",
      dd: "%d \u0434\u0435\u043D\u0430",
      w: "\u0441\u0435\u0434\u043C\u0438\u0446\u0430",
      ww: "%d \u0441\u0435\u0434\u043C\u0438\u0446\u0438",
      M: "\u043C\u0435\u0441\u0435\u0446",
      MM: "%d \u043C\u0435\u0441\u0435\u0446\u0430",
      y: "\u0433\u043E\u0434\u0438\u043D\u0430",
      yy: "%d \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal: function(number) {
      var lastDigit = number % 10, last2Digits = number % 100;
      if (number === 0) {
        return number + "-\u0435\u0432";
      } else if (last2Digits === 0) {
        return number + "-\u0435\u043D";
      } else if (last2Digits > 10 && last2Digits < 20) {
        return number + "-\u0442\u0438";
      } else if (lastDigit === 1) {
        return number + "-\u0432\u0438";
      } else if (lastDigit === 2) {
        return number + "-\u0440\u0438";
      } else if (lastDigit === 7 || lastDigit === 8) {
        return number + "-\u043C\u0438";
      } else {
        return number + "-\u0442\u0438";
      }
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return bg;
}));


/***/ }),

/***/ 42869:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var bm = moment.defineLocale("bm", {
    months: "Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_M\u025Bkalo_Zuw\u025Bnkalo_Zuluyekalo_Utikalo_S\u025Btanburukalo_\u0254kut\u0254burukalo_Nowanburukalo_Desanburukalo".split(
      "_"
    ),
    monthsShort: "Zan_Few_Mar_Awi_M\u025B_Zuw_Zul_Uti_S\u025Bt_\u0254ku_Now_Des".split("_"),
    weekdays: "Kari_Nt\u025Bn\u025Bn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),
    weekdaysShort: "Kar_Nt\u025B_Tar_Ara_Ala_Jum_Sib".split("_"),
    weekdaysMin: "Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "MMMM [tile] D [san] YYYY",
      LLL: "MMMM [tile] D [san] YYYY [l\u025Br\u025B] HH:mm",
      LLLL: "dddd MMMM [tile] D [san] YYYY [l\u025Br\u025B] HH:mm"
    },
    calendar: {
      sameDay: "[Bi l\u025Br\u025B] LT",
      nextDay: "[Sini l\u025Br\u025B] LT",
      nextWeek: "dddd [don l\u025Br\u025B] LT",
      lastDay: "[Kunu l\u025Br\u025B] LT",
      lastWeek: "dddd [t\u025Bm\u025Bnen l\u025Br\u025B] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s k\u0254n\u0254",
      past: "a b\u025B %s b\u0254",
      s: "sanga dama dama",
      ss: "sekondi %d",
      m: "miniti kelen",
      mm: "miniti %d",
      h: "l\u025Br\u025B kelen",
      hh: "l\u025Br\u025B %d",
      d: "tile kelen",
      dd: "tile %d",
      M: "kalo kelen",
      MM: "kalo %d",
      y: "san kelen",
      yy: "san %d"
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return bm;
}));


/***/ }),

/***/ 56463:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u09E7",
    2: "\u09E8",
    3: "\u09E9",
    4: "\u09EA",
    5: "\u09EB",
    6: "\u09EC",
    7: "\u09ED",
    8: "\u09EE",
    9: "\u09EF",
    0: "\u09E6"
  }, numberMap = {
    "\u09E7": "1",
    "\u09E8": "2",
    "\u09E9": "3",
    "\u09EA": "4",
    "\u09EB": "5",
    "\u09EC": "6",
    "\u09ED": "7",
    "\u09EE": "8",
    "\u09EF": "9",
    "\u09E6": "0"
  };
  var bnBd = moment.defineLocale("bn-bd", {
    months: "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF_\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF_\u09AE\u09BE\u09B0\u09CD\u099A_\u098F\u09AA\u09CD\u09B0\u09BF\u09B2_\u09AE\u09C7_\u099C\u09C1\u09A8_\u099C\u09C1\u09B2\u09BE\u0987_\u0986\u0997\u09B8\u09CD\u099F_\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0_\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0_\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0_\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0".split(
      "_"
    ),
    monthsShort: "\u099C\u09BE\u09A8\u09C1_\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1_\u09AE\u09BE\u09B0\u09CD\u099A_\u098F\u09AA\u09CD\u09B0\u09BF\u09B2_\u09AE\u09C7_\u099C\u09C1\u09A8_\u099C\u09C1\u09B2\u09BE\u0987_\u0986\u0997\u09B8\u09CD\u099F_\u09B8\u09C7\u09AA\u09CD\u099F_\u0985\u0995\u09CD\u099F\u09CB_\u09A8\u09AD\u09C7_\u09A1\u09BF\u09B8\u09C7".split(
      "_"
    ),
    weekdays: "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0_\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0_\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0_\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0_\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0_\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0_\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0".split(
      "_"
    ),
    weekdaysShort: "\u09B0\u09AC\u09BF_\u09B8\u09CB\u09AE_\u09AE\u0999\u09CD\u0997\u09B2_\u09AC\u09C1\u09A7_\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF_\u09B6\u09C1\u0995\u09CD\u09B0_\u09B6\u09A8\u09BF".split("_"),
    weekdaysMin: "\u09B0\u09AC\u09BF_\u09B8\u09CB\u09AE_\u09AE\u0999\u09CD\u0997\u09B2_\u09AC\u09C1\u09A7_\u09AC\u09C3\u09B9_\u09B6\u09C1\u0995\u09CD\u09B0_\u09B6\u09A8\u09BF".split("_"),
    longDateFormat: {
      LT: "A h:mm \u09B8\u09AE\u09DF",
      LTS: "A h:mm:ss \u09B8\u09AE\u09DF",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, A h:mm \u09B8\u09AE\u09DF",
      LLLL: "dddd, D MMMM YYYY, A h:mm \u09B8\u09AE\u09DF"
    },
    calendar: {
      sameDay: "[\u0986\u099C] LT",
      nextDay: "[\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2] LT",
      nextWeek: "dddd, LT",
      lastDay: "[\u0997\u09A4\u0995\u09BE\u09B2] LT",
      lastWeek: "[\u0997\u09A4] dddd, LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u09AA\u09B0\u09C7",
      past: "%s \u0986\u0997\u09C7",
      s: "\u0995\u09DF\u09C7\u0995 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
      ss: "%d \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
      m: "\u098F\u0995 \u09AE\u09BF\u09A8\u09BF\u099F",
      mm: "%d \u09AE\u09BF\u09A8\u09BF\u099F",
      h: "\u098F\u0995 \u0998\u09A8\u09CD\u099F\u09BE",
      hh: "%d \u0998\u09A8\u09CD\u099F\u09BE",
      d: "\u098F\u0995 \u09A6\u09BF\u09A8",
      dd: "%d \u09A6\u09BF\u09A8",
      M: "\u098F\u0995 \u09AE\u09BE\u09B8",
      MM: "%d \u09AE\u09BE\u09B8",
      y: "\u098F\u0995 \u09AC\u099B\u09B0",
      yy: "%d \u09AC\u099B\u09B0"
    },
    preparse: function(string) {
      return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function(match) {
        return numberMap[match];
      });
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      });
    },
    meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u09B0\u09BE\u09A4") {
        return hour < 4 ? hour : hour + 12;
      } else if (meridiem === "\u09AD\u09CB\u09B0") {
        return hour;
      } else if (meridiem === "\u09B8\u0995\u09BE\u09B2") {
        return hour;
      } else if (meridiem === "\u09A6\u09C1\u09AA\u09C1\u09B0") {
        return hour >= 3 ? hour : hour + 12;
      } else if (meridiem === "\u09AC\u09BF\u0995\u09BE\u09B2") {
        return hour + 12;
      } else if (meridiem === "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u09B0\u09BE\u09A4";
      } else if (hour < 6) {
        return "\u09AD\u09CB\u09B0";
      } else if (hour < 12) {
        return "\u09B8\u0995\u09BE\u09B2";
      } else if (hour < 15) {
        return "\u09A6\u09C1\u09AA\u09C1\u09B0";
      } else if (hour < 18) {
        return "\u09AC\u09BF\u0995\u09BE\u09B2";
      } else if (hour < 20) {
        return "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE";
      } else {
        return "\u09B0\u09BE\u09A4";
      }
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return bnBd;
}));


/***/ }),

/***/ 61292:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u09E7",
    2: "\u09E8",
    3: "\u09E9",
    4: "\u09EA",
    5: "\u09EB",
    6: "\u09EC",
    7: "\u09ED",
    8: "\u09EE",
    9: "\u09EF",
    0: "\u09E6"
  }, numberMap = {
    "\u09E7": "1",
    "\u09E8": "2",
    "\u09E9": "3",
    "\u09EA": "4",
    "\u09EB": "5",
    "\u09EC": "6",
    "\u09ED": "7",
    "\u09EE": "8",
    "\u09EF": "9",
    "\u09E6": "0"
  };
  var bn = moment.defineLocale("bn", {
    months: "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF_\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF_\u09AE\u09BE\u09B0\u09CD\u099A_\u098F\u09AA\u09CD\u09B0\u09BF\u09B2_\u09AE\u09C7_\u099C\u09C1\u09A8_\u099C\u09C1\u09B2\u09BE\u0987_\u0986\u0997\u09B8\u09CD\u099F_\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0_\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0_\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0_\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0".split(
      "_"
    ),
    monthsShort: "\u099C\u09BE\u09A8\u09C1_\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1_\u09AE\u09BE\u09B0\u09CD\u099A_\u098F\u09AA\u09CD\u09B0\u09BF\u09B2_\u09AE\u09C7_\u099C\u09C1\u09A8_\u099C\u09C1\u09B2\u09BE\u0987_\u0986\u0997\u09B8\u09CD\u099F_\u09B8\u09C7\u09AA\u09CD\u099F_\u0985\u0995\u09CD\u099F\u09CB_\u09A8\u09AD\u09C7_\u09A1\u09BF\u09B8\u09C7".split(
      "_"
    ),
    weekdays: "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0_\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0_\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0_\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0_\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0_\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0_\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0".split(
      "_"
    ),
    weekdaysShort: "\u09B0\u09AC\u09BF_\u09B8\u09CB\u09AE_\u09AE\u0999\u09CD\u0997\u09B2_\u09AC\u09C1\u09A7_\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF_\u09B6\u09C1\u0995\u09CD\u09B0_\u09B6\u09A8\u09BF".split("_"),
    weekdaysMin: "\u09B0\u09AC\u09BF_\u09B8\u09CB\u09AE_\u09AE\u0999\u09CD\u0997\u09B2_\u09AC\u09C1\u09A7_\u09AC\u09C3\u09B9_\u09B6\u09C1\u0995\u09CD\u09B0_\u09B6\u09A8\u09BF".split("_"),
    longDateFormat: {
      LT: "A h:mm \u09B8\u09AE\u09DF",
      LTS: "A h:mm:ss \u09B8\u09AE\u09DF",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, A h:mm \u09B8\u09AE\u09DF",
      LLLL: "dddd, D MMMM YYYY, A h:mm \u09B8\u09AE\u09DF"
    },
    calendar: {
      sameDay: "[\u0986\u099C] LT",
      nextDay: "[\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2] LT",
      nextWeek: "dddd, LT",
      lastDay: "[\u0997\u09A4\u0995\u09BE\u09B2] LT",
      lastWeek: "[\u0997\u09A4] dddd, LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u09AA\u09B0\u09C7",
      past: "%s \u0986\u0997\u09C7",
      s: "\u0995\u09DF\u09C7\u0995 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
      ss: "%d \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
      m: "\u098F\u0995 \u09AE\u09BF\u09A8\u09BF\u099F",
      mm: "%d \u09AE\u09BF\u09A8\u09BF\u099F",
      h: "\u098F\u0995 \u0998\u09A8\u09CD\u099F\u09BE",
      hh: "%d \u0998\u09A8\u09CD\u099F\u09BE",
      d: "\u098F\u0995 \u09A6\u09BF\u09A8",
      dd: "%d \u09A6\u09BF\u09A8",
      M: "\u098F\u0995 \u09AE\u09BE\u09B8",
      MM: "%d \u09AE\u09BE\u09B8",
      y: "\u098F\u0995 \u09AC\u099B\u09B0",
      yy: "%d \u09AC\u099B\u09B0"
    },
    preparse: function(string) {
      return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function(match) {
        return numberMap[match];
      });
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      });
    },
    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u09B0\u09BE\u09A4" && hour >= 4 || meridiem === "\u09A6\u09C1\u09AA\u09C1\u09B0" && hour < 5 || meridiem === "\u09AC\u09BF\u0995\u09BE\u09B2") {
        return hour + 12;
      } else {
        return hour;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u09B0\u09BE\u09A4";
      } else if (hour < 10) {
        return "\u09B8\u0995\u09BE\u09B2";
      } else if (hour < 17) {
        return "\u09A6\u09C1\u09AA\u09C1\u09B0";
      } else if (hour < 20) {
        return "\u09AC\u09BF\u0995\u09BE\u09B2";
      } else {
        return "\u09B0\u09BE\u09A4";
      }
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return bn;
}));


/***/ }),

/***/ 11027:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u0F21",
    2: "\u0F22",
    3: "\u0F23",
    4: "\u0F24",
    5: "\u0F25",
    6: "\u0F26",
    7: "\u0F27",
    8: "\u0F28",
    9: "\u0F29",
    0: "\u0F20"
  }, numberMap = {
    "\u0F21": "1",
    "\u0F22": "2",
    "\u0F23": "3",
    "\u0F24": "4",
    "\u0F25": "5",
    "\u0F26": "6",
    "\u0F27": "7",
    "\u0F28": "8",
    "\u0F29": "9",
    "\u0F20": "0"
  };
  var bo = moment.defineLocale("bo", {
    months: "\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F51\u0F44\u0F0B\u0F54\u0F7C_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F42\u0F49\u0F72\u0F66\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F42\u0F66\u0F74\u0F58\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F5E\u0F72\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F63\u0F94\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F51\u0FB2\u0F74\u0F42\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F51\u0F74\u0F53\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F62\u0F92\u0FB1\u0F51\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F51\u0F42\u0F74\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F45\u0F74\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F45\u0F74\u0F0B\u0F42\u0F45\u0F72\u0F42\u0F0B\u0F54_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F56\u0F45\u0F74\u0F0B\u0F42\u0F49\u0F72\u0F66\u0F0B\u0F54".split(
      "_"
    ),
    monthsShort: "\u0F5F\u0FB3\u0F0B1_\u0F5F\u0FB3\u0F0B2_\u0F5F\u0FB3\u0F0B3_\u0F5F\u0FB3\u0F0B4_\u0F5F\u0FB3\u0F0B5_\u0F5F\u0FB3\u0F0B6_\u0F5F\u0FB3\u0F0B7_\u0F5F\u0FB3\u0F0B8_\u0F5F\u0FB3\u0F0B9_\u0F5F\u0FB3\u0F0B10_\u0F5F\u0FB3\u0F0B11_\u0F5F\u0FB3\u0F0B12".split(
      "_"
    ),
    monthsShortRegex: /^(ཟླ་\d{1,2})/,
    monthsParseExact: true,
    weekdays: "\u0F42\u0F5F\u0F60\u0F0B\u0F49\u0F72\u0F0B\u0F58\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F5F\u0FB3\u0F0B\u0F56\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F58\u0F72\u0F42\u0F0B\u0F51\u0F58\u0F62\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F63\u0FB7\u0F42\u0F0B\u0F54\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F55\u0F74\u0F62\u0F0B\u0F56\u0F74_\u0F42\u0F5F\u0F60\u0F0B\u0F54\u0F0B\u0F66\u0F44\u0F66\u0F0B_\u0F42\u0F5F\u0F60\u0F0B\u0F66\u0FA4\u0F7A\u0F53\u0F0B\u0F54\u0F0B".split(
      "_"
    ),
    weekdaysShort: "\u0F49\u0F72\u0F0B\u0F58\u0F0B_\u0F5F\u0FB3\u0F0B\u0F56\u0F0B_\u0F58\u0F72\u0F42\u0F0B\u0F51\u0F58\u0F62\u0F0B_\u0F63\u0FB7\u0F42\u0F0B\u0F54\u0F0B_\u0F55\u0F74\u0F62\u0F0B\u0F56\u0F74_\u0F54\u0F0B\u0F66\u0F44\u0F66\u0F0B_\u0F66\u0FA4\u0F7A\u0F53\u0F0B\u0F54\u0F0B".split(
      "_"
    ),
    weekdaysMin: "\u0F49\u0F72_\u0F5F\u0FB3_\u0F58\u0F72\u0F42_\u0F63\u0FB7\u0F42_\u0F55\u0F74\u0F62_\u0F66\u0F44\u0F66_\u0F66\u0FA4\u0F7A\u0F53".split("_"),
    longDateFormat: {
      LT: "A h:mm",
      LTS: "A h:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, A h:mm",
      LLLL: "dddd, D MMMM YYYY, A h:mm"
    },
    calendar: {
      sameDay: "[\u0F51\u0F72\u0F0B\u0F62\u0F72\u0F44] LT",
      nextDay: "[\u0F66\u0F44\u0F0B\u0F49\u0F72\u0F53] LT",
      nextWeek: "[\u0F56\u0F51\u0F74\u0F53\u0F0B\u0F55\u0FB2\u0F42\u0F0B\u0F62\u0F97\u0F7A\u0F66\u0F0B\u0F58], LT",
      lastDay: "[\u0F41\u0F0B\u0F66\u0F44] LT",
      lastWeek: "[\u0F56\u0F51\u0F74\u0F53\u0F0B\u0F55\u0FB2\u0F42\u0F0B\u0F58\u0F50\u0F60\u0F0B\u0F58] dddd, LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0F63\u0F0B",
      past: "%s \u0F66\u0F94\u0F53\u0F0B\u0F63",
      s: "\u0F63\u0F58\u0F0B\u0F66\u0F44",
      ss: "%d \u0F66\u0F90\u0F62\u0F0B\u0F46\u0F0D",
      m: "\u0F66\u0F90\u0F62\u0F0B\u0F58\u0F0B\u0F42\u0F45\u0F72\u0F42",
      mm: "%d \u0F66\u0F90\u0F62\u0F0B\u0F58",
      h: "\u0F46\u0F74\u0F0B\u0F5A\u0F7C\u0F51\u0F0B\u0F42\u0F45\u0F72\u0F42",
      hh: "%d \u0F46\u0F74\u0F0B\u0F5A\u0F7C\u0F51",
      d: "\u0F49\u0F72\u0F53\u0F0B\u0F42\u0F45\u0F72\u0F42",
      dd: "%d \u0F49\u0F72\u0F53\u0F0B",
      M: "\u0F5F\u0FB3\u0F0B\u0F56\u0F0B\u0F42\u0F45\u0F72\u0F42",
      MM: "%d \u0F5F\u0FB3\u0F0B\u0F56",
      y: "\u0F63\u0F7C\u0F0B\u0F42\u0F45\u0F72\u0F42",
      yy: "%d \u0F63\u0F7C"
    },
    preparse: function(string) {
      return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function(match) {
        return numberMap[match];
      });
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      });
    },
    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u0F58\u0F5A\u0F53\u0F0B\u0F58\u0F7C" && hour >= 4 || meridiem === "\u0F49\u0F72\u0F53\u0F0B\u0F42\u0F74\u0F44" && hour < 5 || meridiem === "\u0F51\u0F42\u0F7C\u0F44\u0F0B\u0F51\u0F42") {
        return hour + 12;
      } else {
        return hour;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u0F58\u0F5A\u0F53\u0F0B\u0F58\u0F7C";
      } else if (hour < 10) {
        return "\u0F5E\u0F7C\u0F42\u0F66\u0F0B\u0F40\u0F66";
      } else if (hour < 17) {
        return "\u0F49\u0F72\u0F53\u0F0B\u0F42\u0F74\u0F44";
      } else if (hour < 20) {
        return "\u0F51\u0F42\u0F7C\u0F44\u0F0B\u0F51\u0F42";
      } else {
        return "\u0F58\u0F5A\u0F53\u0F0B\u0F58\u0F7C";
      }
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return bo;
}));


/***/ }),

/***/ 75800:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function relativeTimeWithMutation(number, withoutSuffix, key) {
    var format = {
      mm: "munutenn",
      MM: "miz",
      dd: "devezh"
    };
    return number + " " + mutation(format[key], number);
  }
  function specialMutationForYears(number) {
    switch (lastNumber(number)) {
      case 1:
      case 3:
      case 4:
      case 5:
      case 9:
        return number + " bloaz";
      default:
        return number + " vloaz";
    }
  }
  function lastNumber(number) {
    if (number > 9) {
      return lastNumber(number % 10);
    }
    return number;
  }
  function mutation(text, number) {
    if (number === 2) {
      return softMutation(text);
    }
    return text;
  }
  function softMutation(text) {
    var mutationTable = {
      m: "v",
      b: "v",
      d: "z"
    };
    if (mutationTable[text.charAt(0)] === void 0) {
      return text;
    }
    return mutationTable[text.charAt(0)] + text.substring(1);
  }
  var monthsParse = [
    /^gen/i,
    /^c[ʼ\']hwe/i,
    /^meu/i,
    /^ebr/i,
    /^mae/i,
    /^(mez|eve)/i,
    /^gou/i,
    /^eos/i,
    /^gwe/i,
    /^her/i,
    /^du/i,
    /^ker/i
  ], monthsRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i, monthsStrictRegex = /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i, monthsShortStrictRegex = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i, fullWeekdaysParse = [
    /^sul/i,
    /^lun/i,
    /^meurzh/i,
    /^merc[ʼ\']her/i,
    /^yaou/i,
    /^gwener/i,
    /^sadorn/i
  ], shortWeekdaysParse = [
    /^Sul/i,
    /^Lun/i,
    /^Meu/i,
    /^Mer/i,
    /^Yao/i,
    /^Gwe/i,
    /^Sad/i
  ], minWeekdaysParse = [
    /^Su/i,
    /^Lu/i,
    /^Me([^r]|$)/i,
    /^Mer/i,
    /^Ya/i,
    /^Gw/i,
    /^Sa/i
  ];
  var br = moment.defineLocale("br", {
    months: "Genver_C\u02BChwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split(
      "_"
    ),
    monthsShort: "Gen_C\u02BChwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),
    weekdays: "Sul_Lun_Meurzh_Merc\u02BCher_Yaou_Gwener_Sadorn".split("_"),
    weekdaysShort: "Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),
    weekdaysMin: "Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),
    weekdaysParse: minWeekdaysParse,
    fullWeekdaysParse,
    shortWeekdaysParse,
    minWeekdaysParse,
    monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex,
    monthsShortStrictRegex,
    monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D [a viz] MMMM YYYY",
      LLL: "D [a viz] MMMM YYYY HH:mm",
      LLLL: "dddd, D [a viz] MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Hiziv da] LT",
      nextDay: "[Warc\u02BChoazh da] LT",
      nextWeek: "dddd [da] LT",
      lastDay: "[Dec\u02BCh da] LT",
      lastWeek: "dddd [paset da] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "a-benn %s",
      past: "%s \u02BCzo",
      s: "un nebeud segondenno\xF9",
      ss: "%d eilenn",
      m: "ur vunutenn",
      mm: relativeTimeWithMutation,
      h: "un eur",
      hh: "%d eur",
      d: "un devezh",
      dd: relativeTimeWithMutation,
      M: "ur miz",
      MM: relativeTimeWithMutation,
      y: "ur bloaz",
      yy: specialMutationForYears
    },
    dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
    ordinal: function(number) {
      var output = number === 1 ? "a\xF1" : "vet";
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    },
    meridiemParse: /a.m.|g.m./,
    // goude merenn | a-raok merenn
    isPM: function(token) {
      return token === "g.m.";
    },
    meridiem: function(hour, minute, isLower) {
      return hour < 12 ? "a.m." : "g.m.";
    }
  });
  return br;
}));


/***/ }),

/***/ 10159:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! author : Rasid Redzic : https://github.com/rasidre
//! based on (hr) translation by Bojan Marković
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function processRelativeTime(number, withoutSuffix, key, isFuture) {
    switch (key) {
      case "m":
        return withoutSuffix ? "jedna minuta" : isFuture ? "jednu minutu" : "jedne minute";
    }
  }
  function translate(number, withoutSuffix, key) {
    var result = number + " ";
    switch (key) {
      case "ss":
        if (number === 1) {
          result += "sekunda";
        } else if (number === 2 || number === 3 || number === 4) {
          result += "sekunde";
        } else {
          result += "sekundi";
        }
        return result;
      case "mm":
        if (number === 1) {
          result += "minuta";
        } else if (number === 2 || number === 3 || number === 4) {
          result += "minute";
        } else {
          result += "minuta";
        }
        return result;
      case "h":
        return withoutSuffix ? "jedan sat" : "jedan sat";
      case "hh":
        if (number === 1) {
          result += "sat";
        } else if (number === 2 || number === 3 || number === 4) {
          result += "sata";
        } else {
          result += "sati";
        }
        return result;
      case "dd":
        if (number === 1) {
          result += "dan";
        } else {
          result += "dana";
        }
        return result;
      case "MM":
        if (number === 1) {
          result += "mjesec";
        } else if (number === 2 || number === 3 || number === 4) {
          result += "mjeseca";
        } else {
          result += "mjeseci";
        }
        return result;
      case "yy":
        if (number === 1) {
          result += "godina";
        } else if (number === 2 || number === 3 || number === 4) {
          result += "godine";
        } else {
          result += "godina";
        }
        return result;
    }
  }
  var bs = moment.defineLocale("bs", {
    months: "januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split(
      "_"
    ),
    monthsShort: "jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010Detvrtak_petak_subota".split(
      "_"
    ),
    weekdaysShort: "ned._pon._uto._sri._\u010Det._pet._sub.".split("_"),
    weekdaysMin: "ne_po_ut_sr_\u010De_pe_su".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY H:mm",
      LLLL: "dddd, D. MMMM YYYY H:mm"
    },
    calendar: {
      sameDay: "[danas u] LT",
      nextDay: "[sutra u] LT",
      nextWeek: function() {
        switch (this.day()) {
          case 0:
            return "[u] [nedjelju] [u] LT";
          case 3:
            return "[u] [srijedu] [u] LT";
          case 6:
            return "[u] [subotu] [u] LT";
          case 1:
          case 2:
          case 4:
          case 5:
            return "[u] dddd [u] LT";
        }
      },
      lastDay: "[ju\u010Der u] LT",
      lastWeek: function() {
        switch (this.day()) {
          case 0:
          case 3:
            return "[pro\u0161lu] dddd [u] LT";
          case 6:
            return "[pro\u0161le] [subote] [u] LT";
          case 1:
          case 2:
          case 4:
          case 5:
            return "[pro\u0161li] dddd [u] LT";
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "za %s",
      past: "prije %s",
      s: "par sekundi",
      ss: translate,
      m: processRelativeTime,
      mm: translate,
      h: translate,
      hh: translate,
      d: "dan",
      dd: translate,
      M: "mjesec",
      MM: translate,
      y: "godinu",
      yy: translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return bs;
}));


/***/ }),

/***/ 56376:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var ca = moment.defineLocale("ca", {
    months: {
      standalone: "gener_febrer_mar\xE7_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split(
        "_"
      ),
      format: "de gener_de febrer_de mar\xE7_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
        "_"
      ),
      isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort: "gen._febr._mar\xE7_abr._maig_juny_jul._ag._set._oct._nov._des.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split(
      "_"
    ),
    weekdaysShort: "dg._dl._dt._dc._dj._dv._ds.".split("_"),
    weekdaysMin: "dg_dl_dt_dc_dj_dv_ds".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM [de] YYYY",
      ll: "D MMM YYYY",
      LLL: "D MMMM [de] YYYY [a les] H:mm",
      lll: "D MMM YYYY, H:mm",
      LLLL: "dddd D MMMM [de] YYYY [a les] H:mm",
      llll: "ddd D MMM YYYY, H:mm"
    },
    calendar: {
      sameDay: function() {
        return "[avui a " + (this.hours() !== 1 ? "les" : "la") + "] LT";
      },
      nextDay: function() {
        return "[dem\xE0 a " + (this.hours() !== 1 ? "les" : "la") + "] LT";
      },
      nextWeek: function() {
        return "dddd [a " + (this.hours() !== 1 ? "les" : "la") + "] LT";
      },
      lastDay: function() {
        return "[ahir a " + (this.hours() !== 1 ? "les" : "la") + "] LT";
      },
      lastWeek: function() {
        return "[el] dddd [passat a " + (this.hours() !== 1 ? "les" : "la") + "] LT";
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "d'aqu\xED %s",
      past: "fa %s",
      s: "uns segons",
      ss: "%d segons",
      m: "un minut",
      mm: "%d minuts",
      h: "una hora",
      hh: "%d hores",
      d: "un dia",
      dd: "%d dies",
      M: "un mes",
      MM: "%d mesos",
      y: "un any",
      yy: "%d anys"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal: function(number, period) {
      var output = number === 1 ? "r" : number === 2 ? "n" : number === 3 ? "r" : number === 4 ? "t" : "\xE8";
      if (period === "w" || period === "W") {
        output = "a";
      }
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return ca;
}));


/***/ }),

/***/ 14610:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var months = {
    standalone: "leden_\xFAnor_b\u0159ezen_duben_kv\u011Bten_\u010Derven_\u010Dervenec_srpen_z\xE1\u0159\xED_\u0159\xEDjen_listopad_prosinec".split(
      "_"
    ),
    format: "ledna_\xFAnora_b\u0159ezna_dubna_kv\u011Btna_\u010Dervna_\u010Dervence_srpna_z\xE1\u0159\xED_\u0159\xEDjna_listopadu_prosince".split(
      "_"
    ),
    isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/
  }, monthsShort = "led_\xFAno_b\u0159e_dub_kv\u011B_\u010Dvn_\u010Dvc_srp_z\xE1\u0159_\u0159\xEDj_lis_pro".split("_"), monthsParse = [
    /^led/i,
    /^úno/i,
    /^bře/i,
    /^dub/i,
    /^kvě/i,
    /^(čvn|červen$|června)/i,
    /^(čvc|červenec|července)/i,
    /^srp/i,
    /^zář/i,
    /^říj/i,
    /^lis/i,
    /^pro/i
  ], monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
  function plural(n) {
    return n > 1 && n < 5 && ~~(n / 10) !== 1;
  }
  function translate(number, withoutSuffix, key, isFuture) {
    var result = number + " ";
    switch (key) {
      case "s":
        return withoutSuffix || isFuture ? "p\xE1r sekund" : "p\xE1r sekundami";
      case "ss":
        if (withoutSuffix || isFuture) {
          return result + (plural(number) ? "sekundy" : "sekund");
        } else {
          return result + "sekundami";
        }
      case "m":
        return withoutSuffix ? "minuta" : isFuture ? "minutu" : "minutou";
      case "mm":
        if (withoutSuffix || isFuture) {
          return result + (plural(number) ? "minuty" : "minut");
        } else {
          return result + "minutami";
        }
      case "h":
        return withoutSuffix ? "hodina" : isFuture ? "hodinu" : "hodinou";
      case "hh":
        if (withoutSuffix || isFuture) {
          return result + (plural(number) ? "hodiny" : "hodin");
        } else {
          return result + "hodinami";
        }
      case "d":
        return withoutSuffix || isFuture ? "den" : "dnem";
      case "dd":
        if (withoutSuffix || isFuture) {
          return result + (plural(number) ? "dny" : "dn\xED");
        } else {
          return result + "dny";
        }
      case "M":
        return withoutSuffix || isFuture ? "m\u011Bs\xEDc" : "m\u011Bs\xEDcem";
      case "MM":
        if (withoutSuffix || isFuture) {
          return result + (plural(number) ? "m\u011Bs\xEDce" : "m\u011Bs\xEDc\u016F");
        } else {
          return result + "m\u011Bs\xEDci";
        }
      case "y":
        return withoutSuffix || isFuture ? "rok" : "rokem";
      case "yy":
        if (withoutSuffix || isFuture) {
          return result + (plural(number) ? "roky" : "let");
        } else {
          return result + "lety";
        }
    }
  }
  var cs = moment.defineLocale("cs", {
    months,
    monthsShort,
    monthsRegex,
    monthsShortRegex: monthsRegex,
    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
    monthsStrictRegex: /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
    monthsShortStrictRegex: /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
    monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays: "ned\u011Ble_pond\u011Bl\xED_\xFAter\xFD_st\u0159eda_\u010Dtvrtek_p\xE1tek_sobota".split("_"),
    weekdaysShort: "ne_po_\xFAt_st_\u010Dt_p\xE1_so".split("_"),
    weekdaysMin: "ne_po_\xFAt_st_\u010Dt_p\xE1_so".split("_"),
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY H:mm",
      LLLL: "dddd D. MMMM YYYY H:mm",
      l: "D. M. YYYY"
    },
    calendar: {
      sameDay: "[dnes v] LT",
      nextDay: "[z\xEDtra v] LT",
      nextWeek: function() {
        switch (this.day()) {
          case 0:
            return "[v ned\u011Bli v] LT";
          case 1:
          case 2:
            return "[v] dddd [v] LT";
          case 3:
            return "[ve st\u0159edu v] LT";
          case 4:
            return "[ve \u010Dtvrtek v] LT";
          case 5:
            return "[v p\xE1tek v] LT";
          case 6:
            return "[v sobotu v] LT";
        }
      },
      lastDay: "[v\u010Dera v] LT",
      lastWeek: function() {
        switch (this.day()) {
          case 0:
            return "[minulou ned\u011Bli v] LT";
          case 1:
          case 2:
            return "[minul\xE9] dddd [v] LT";
          case 3:
            return "[minulou st\u0159edu v] LT";
          case 4:
          case 5:
            return "[minul\xFD] dddd [v] LT";
          case 6:
            return "[minulou sobotu v] LT";
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "za %s",
      past: "p\u0159ed %s",
      s: translate,
      ss: translate,
      m: translate,
      mm: translate,
      h: translate,
      hh: translate,
      d: translate,
      dd: translate,
      M: translate,
      MM: translate,
      y: translate,
      yy: translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return cs;
}));


/***/ }),

/***/ 18589:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var cv = moment.defineLocale("cv", {
    months: "\u043A\u04D1\u0440\u043B\u0430\u0447_\u043D\u0430\u0440\u04D1\u0441_\u043F\u0443\u0448_\u0430\u043A\u0430_\u043C\u0430\u0439_\u04AB\u04D7\u0440\u0442\u043C\u0435_\u0443\u0442\u04D1_\u04AB\u0443\u0440\u043B\u0430_\u0430\u0432\u04D1\u043D_\u044E\u043F\u0430_\u0447\u04F3\u043A_\u0440\u0430\u0448\u0442\u0430\u0432".split(
      "_"
    ),
    monthsShort: "\u043A\u04D1\u0440_\u043D\u0430\u0440_\u043F\u0443\u0448_\u0430\u043A\u0430_\u043C\u0430\u0439_\u04AB\u04D7\u0440_\u0443\u0442\u04D1_\u04AB\u0443\u0440_\u0430\u0432\u043D_\u044E\u043F\u0430_\u0447\u04F3\u043A_\u0440\u0430\u0448".split("_"),
    weekdays: "\u0432\u044B\u0440\u0441\u0430\u0440\u043D\u0438\u043A\u0443\u043D_\u0442\u0443\u043D\u0442\u0438\u043A\u0443\u043D_\u044B\u0442\u043B\u0430\u0440\u0438\u043A\u0443\u043D_\u044E\u043D\u043A\u0443\u043D_\u043A\u04D7\u04AB\u043D\u0435\u0440\u043D\u0438\u043A\u0443\u043D_\u044D\u0440\u043D\u0435\u043A\u0443\u043D_\u0448\u04D1\u043C\u0430\u0442\u043A\u0443\u043D".split(
      "_"
    ),
    weekdaysShort: "\u0432\u044B\u0440_\u0442\u0443\u043D_\u044B\u0442\u043B_\u044E\u043D_\u043A\u04D7\u04AB_\u044D\u0440\u043D_\u0448\u04D1\u043C".split("_"),
    weekdaysMin: "\u0432\u0440_\u0442\u043D_\u044B\u0442_\u044E\u043D_\u043A\u04AB_\u044D\u0440_\u0448\u043C".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD-MM-YYYY",
      LL: "YYYY [\u04AB\u0443\u043B\u0445\u0438] MMMM [\u0443\u0439\u04D1\u0445\u04D7\u043D] D[-\u043C\u04D7\u0448\u04D7]",
      LLL: "YYYY [\u04AB\u0443\u043B\u0445\u0438] MMMM [\u0443\u0439\u04D1\u0445\u04D7\u043D] D[-\u043C\u04D7\u0448\u04D7], HH:mm",
      LLLL: "dddd, YYYY [\u04AB\u0443\u043B\u0445\u0438] MMMM [\u0443\u0439\u04D1\u0445\u04D7\u043D] D[-\u043C\u04D7\u0448\u04D7], HH:mm"
    },
    calendar: {
      sameDay: "[\u041F\u0430\u044F\u043D] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
      nextDay: "[\u042B\u0440\u0430\u043D] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
      lastDay: "[\u04D6\u043D\u0435\u0440] LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
      nextWeek: "[\u04AA\u0438\u0442\u0435\u0441] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
      lastWeek: "[\u0418\u0440\u0442\u043D\u04D7] dddd LT [\u0441\u0435\u0445\u0435\u0442\u0440\u0435]",
      sameElse: "L"
    },
    relativeTime: {
      future: function(output) {
        var affix = /сехет$/i.exec(output) ? "\u0440\u0435\u043D" : /ҫул$/i.exec(output) ? "\u0442\u0430\u043D" : "\u0440\u0430\u043D";
        return output + affix;
      },
      past: "%s \u043A\u0430\u044F\u043B\u043B\u0430",
      s: "\u043F\u04D7\u0440-\u0438\u043A \u04AB\u0435\u043A\u043A\u0443\u043D\u0442",
      ss: "%d \u04AB\u0435\u043A\u043A\u0443\u043D\u0442",
      m: "\u043F\u04D7\u0440 \u043C\u0438\u043D\u0443\u0442",
      mm: "%d \u043C\u0438\u043D\u0443\u0442",
      h: "\u043F\u04D7\u0440 \u0441\u0435\u0445\u0435\u0442",
      hh: "%d \u0441\u0435\u0445\u0435\u0442",
      d: "\u043F\u04D7\u0440 \u043A\u0443\u043D",
      dd: "%d \u043A\u0443\u043D",
      M: "\u043F\u04D7\u0440 \u0443\u0439\u04D1\u0445",
      MM: "%d \u0443\u0439\u04D1\u0445",
      y: "\u043F\u04D7\u0440 \u04AB\u0443\u043B",
      yy: "%d \u04AB\u0443\u043B"
    },
    dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
    ordinal: "%d-\u043C\u04D7\u0448",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return cv;
}));


/***/ }),

/***/ 83808:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var cy = moment.defineLocale("cy", {
    months: "Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split(
      "_"
    ),
    monthsShort: "Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split(
      "_"
    ),
    weekdays: "Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split(
      "_"
    ),
    weekdaysShort: "Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),
    weekdaysMin: "Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),
    weekdaysParseExact: true,
    // time formats are the same as en-gb
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Heddiw am] LT",
      nextDay: "[Yfory am] LT",
      nextWeek: "dddd [am] LT",
      lastDay: "[Ddoe am] LT",
      lastWeek: "dddd [diwethaf am] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "mewn %s",
      past: "%s yn \xF4l",
      s: "ychydig eiliadau",
      ss: "%d eiliad",
      m: "munud",
      mm: "%d munud",
      h: "awr",
      hh: "%d awr",
      d: "diwrnod",
      dd: "%d diwrnod",
      M: "mis",
      MM: "%d mis",
      y: "blwyddyn",
      yy: "%d flynedd"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
    ordinal: function(number) {
      var b = number, output = "", lookup = [
        "",
        "af",
        "il",
        "ydd",
        "ydd",
        "ed",
        "ed",
        "ed",
        "fed",
        "fed",
        "fed",
        // 1af to 10fed
        "eg",
        "fed",
        "eg",
        "eg",
        "fed",
        "eg",
        "eg",
        "fed",
        "eg",
        "fed"
        // 11eg to 20fed
      ];
      if (b > 20) {
        if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
          output = "fed";
        } else {
          output = "ain";
        }
      } else if (b > 0) {
        output = lookup[b];
      }
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return cy;
}));


/***/ }),

/***/ 923:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var da = moment.defineLocale("da", {
    months: "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split(
      "_"
    ),
    monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
    weekdays: "s\xF8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xF8rdag".split("_"),
    weekdaysShort: "s\xF8n_man_tir_ons_tor_fre_l\xF8r".split("_"),
    weekdaysMin: "s\xF8_ma_ti_on_to_fr_l\xF8".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY HH:mm",
      LLLL: "dddd [d.] D. MMMM YYYY [kl.] HH:mm"
    },
    calendar: {
      sameDay: "[i dag kl.] LT",
      nextDay: "[i morgen kl.] LT",
      nextWeek: "p\xE5 dddd [kl.] LT",
      lastDay: "[i g\xE5r kl.] LT",
      lastWeek: "[i] dddd[s kl.] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "om %s",
      past: "%s siden",
      s: "f\xE5 sekunder",
      ss: "%d sekunder",
      m: "et minut",
      mm: "%d minutter",
      h: "en time",
      hh: "%d timer",
      d: "en dag",
      dd: "%d dage",
      M: "en m\xE5ned",
      MM: "%d m\xE5neder",
      y: "et \xE5r",
      yy: "%d \xE5r"
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return da;
}));


/***/ }),

/***/ 17149:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
      m: ["eine Minute", "einer Minute"],
      h: ["eine Stunde", "einer Stunde"],
      d: ["ein Tag", "einem Tag"],
      dd: [number + " Tage", number + " Tagen"],
      w: ["eine Woche", "einer Woche"],
      M: ["ein Monat", "einem Monat"],
      MM: [number + " Monate", number + " Monaten"],
      y: ["ein Jahr", "einem Jahr"],
      yy: [number + " Jahre", number + " Jahren"]
    };
    return withoutSuffix ? format[key][0] : format[key][1];
  }
  var deAt = moment.defineLocale("de-at", {
    months: "J\xE4nner_Februar_M\xE4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split(
      "_"
    ),
    monthsShort: "J\xE4n._Feb._M\xE4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
    monthsParseExact: true,
    weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split(
      "_"
    ),
    weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
    weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY HH:mm",
      LLLL: "dddd, D. MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[heute um] LT [Uhr]",
      sameElse: "L",
      nextDay: "[morgen um] LT [Uhr]",
      nextWeek: "dddd [um] LT [Uhr]",
      lastDay: "[gestern um] LT [Uhr]",
      lastWeek: "[letzten] dddd [um] LT [Uhr]"
    },
    relativeTime: {
      future: "in %s",
      past: "vor %s",
      s: "ein paar Sekunden",
      ss: "%d Sekunden",
      m: processRelativeTime,
      mm: "%d Minuten",
      h: processRelativeTime,
      hh: "%d Stunden",
      d: processRelativeTime,
      dd: processRelativeTime,
      w: processRelativeTime,
      ww: "%d Wochen",
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return deAt;
}));


/***/ }),

/***/ 33283:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
      m: ["eine Minute", "einer Minute"],
      h: ["eine Stunde", "einer Stunde"],
      d: ["ein Tag", "einem Tag"],
      dd: [number + " Tage", number + " Tagen"],
      w: ["eine Woche", "einer Woche"],
      M: ["ein Monat", "einem Monat"],
      MM: [number + " Monate", number + " Monaten"],
      y: ["ein Jahr", "einem Jahr"],
      yy: [number + " Jahre", number + " Jahren"]
    };
    return withoutSuffix ? format[key][0] : format[key][1];
  }
  var deCh = moment.defineLocale("de-ch", {
    months: "Januar_Februar_M\xE4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split(
      "_"
    ),
    monthsShort: "Jan._Feb._M\xE4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
    monthsParseExact: true,
    weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split(
      "_"
    ),
    weekdaysShort: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
    weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY HH:mm",
      LLLL: "dddd, D. MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[heute um] LT [Uhr]",
      sameElse: "L",
      nextDay: "[morgen um] LT [Uhr]",
      nextWeek: "dddd [um] LT [Uhr]",
      lastDay: "[gestern um] LT [Uhr]",
      lastWeek: "[letzten] dddd [um] LT [Uhr]"
    },
    relativeTime: {
      future: "in %s",
      past: "vor %s",
      s: "ein paar Sekunden",
      ss: "%d Sekunden",
      m: processRelativeTime,
      mm: "%d Minuten",
      h: processRelativeTime,
      hh: "%d Stunden",
      d: processRelativeTime,
      dd: processRelativeTime,
      w: processRelativeTime,
      ww: "%d Wochen",
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return deCh;
}));


/***/ }),

/***/ 3391:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
      m: ["eine Minute", "einer Minute"],
      h: ["eine Stunde", "einer Stunde"],
      d: ["ein Tag", "einem Tag"],
      dd: [number + " Tage", number + " Tagen"],
      w: ["eine Woche", "einer Woche"],
      M: ["ein Monat", "einem Monat"],
      MM: [number + " Monate", number + " Monaten"],
      y: ["ein Jahr", "einem Jahr"],
      yy: [number + " Jahre", number + " Jahren"]
    };
    return withoutSuffix ? format[key][0] : format[key][1];
  }
  var de = moment.defineLocale("de", {
    months: "Januar_Februar_M\xE4rz_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split(
      "_"
    ),
    monthsShort: "Jan._Feb._M\xE4rz_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split("_"),
    monthsParseExact: true,
    weekdays: "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split(
      "_"
    ),
    weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
    weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY HH:mm",
      LLLL: "dddd, D. MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[heute um] LT [Uhr]",
      sameElse: "L",
      nextDay: "[morgen um] LT [Uhr]",
      nextWeek: "dddd [um] LT [Uhr]",
      lastDay: "[gestern um] LT [Uhr]",
      lastWeek: "[letzten] dddd [um] LT [Uhr]"
    },
    relativeTime: {
      future: "in %s",
      past: "vor %s",
      s: "ein paar Sekunden",
      ss: "%d Sekunden",
      m: processRelativeTime,
      mm: "%d Minuten",
      h: processRelativeTime,
      hh: "%d Stunden",
      d: processRelativeTime,
      dd: processRelativeTime,
      w: processRelativeTime,
      ww: "%d Wochen",
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return de;
}));


/***/ }),

/***/ 75746:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var months = [
    "\u0796\u07AC\u0782\u07AA\u0787\u07A6\u0783\u07A9",
    "\u078A\u07AC\u0784\u07B0\u0783\u07AA\u0787\u07A6\u0783\u07A9",
    "\u0789\u07A7\u0783\u07A8\u0797\u07AA",
    "\u0787\u07AD\u0795\u07B0\u0783\u07A9\u078D\u07AA",
    "\u0789\u07AD",
    "\u0796\u07AB\u0782\u07B0",
    "\u0796\u07AA\u078D\u07A6\u0787\u07A8",
    "\u0787\u07AF\u078E\u07A6\u0790\u07B0\u0793\u07AA",
    "\u0790\u07AC\u0795\u07B0\u0793\u07AC\u0789\u07B0\u0784\u07A6\u0783\u07AA",
    "\u0787\u07AE\u0786\u07B0\u0793\u07AF\u0784\u07A6\u0783\u07AA",
    "\u0782\u07AE\u0788\u07AC\u0789\u07B0\u0784\u07A6\u0783\u07AA",
    "\u0791\u07A8\u0790\u07AC\u0789\u07B0\u0784\u07A6\u0783\u07AA"
  ], weekdays = [
    "\u0787\u07A7\u078B\u07A8\u0787\u07B0\u078C\u07A6",
    "\u0780\u07AF\u0789\u07A6",
    "\u0787\u07A6\u0782\u07B0\u078E\u07A7\u0783\u07A6",
    "\u0784\u07AA\u078B\u07A6",
    "\u0784\u07AA\u0783\u07A7\u0790\u07B0\u078A\u07A6\u078C\u07A8",
    "\u0780\u07AA\u0786\u07AA\u0783\u07AA",
    "\u0780\u07AE\u0782\u07A8\u0780\u07A8\u0783\u07AA"
  ];
  var dv = moment.defineLocale("dv", {
    months,
    monthsShort: months,
    weekdays,
    weekdaysShort: weekdays,
    weekdaysMin: "\u0787\u07A7\u078B\u07A8_\u0780\u07AF\u0789\u07A6_\u0787\u07A6\u0782\u07B0_\u0784\u07AA\u078B\u07A6_\u0784\u07AA\u0783\u07A7_\u0780\u07AA\u0786\u07AA_\u0780\u07AE\u0782\u07A8".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "D/M/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    meridiemParse: /މކ|މފ/,
    isPM: function(input) {
      return "\u0789\u078A" === input;
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u0789\u0786";
      } else {
        return "\u0789\u078A";
      }
    },
    calendar: {
      sameDay: "[\u0789\u07A8\u0787\u07A6\u078B\u07AA] LT",
      nextDay: "[\u0789\u07A7\u078B\u07A6\u0789\u07A7] LT",
      nextWeek: "dddd LT",
      lastDay: "[\u0787\u07A8\u0787\u07B0\u0794\u07AC] LT",
      lastWeek: "[\u078A\u07A7\u0787\u07A8\u078C\u07AA\u0788\u07A8] dddd LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u078C\u07AC\u0783\u07AD\u078E\u07A6\u0787\u07A8 %s",
      past: "\u0786\u07AA\u0783\u07A8\u0782\u07B0 %s",
      s: "\u0790\u07A8\u0786\u07AA\u0782\u07B0\u078C\u07AA\u0786\u07AE\u0785\u07AC\u0787\u07B0",
      ss: "d% \u0790\u07A8\u0786\u07AA\u0782\u07B0\u078C\u07AA",
      m: "\u0789\u07A8\u0782\u07A8\u0793\u07AC\u0787\u07B0",
      mm: "\u0789\u07A8\u0782\u07A8\u0793\u07AA %d",
      h: "\u078E\u07A6\u0791\u07A8\u0787\u07A8\u0783\u07AC\u0787\u07B0",
      hh: "\u078E\u07A6\u0791\u07A8\u0787\u07A8\u0783\u07AA %d",
      d: "\u078B\u07AA\u0788\u07A6\u0780\u07AC\u0787\u07B0",
      dd: "\u078B\u07AA\u0788\u07A6\u0790\u07B0 %d",
      M: "\u0789\u07A6\u0780\u07AC\u0787\u07B0",
      MM: "\u0789\u07A6\u0790\u07B0 %d",
      y: "\u0787\u07A6\u0780\u07A6\u0783\u07AC\u0787\u07B0",
      yy: "\u0787\u07A6\u0780\u07A6\u0783\u07AA %d"
    },
    preparse: function(string) {
      return string.replace(/،/g, ",");
    },
    postformat: function(string) {
      return string.replace(/,/g, "\u060C");
    },
    week: {
      dow: 7,
      // Sunday is the first day of the week.
      doy: 12
      // The week that contains Jan 12th is the first week of the year.
    }
  });
  return dv;
}));


/***/ }),

/***/ 60317:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function isFunction(input) {
    return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
  }
  var el = moment.defineLocale("el", {
    monthsNominativeEl: "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2_\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2_\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2_\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2_\u039C\u03AC\u03B9\u03BF\u03C2_\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2_\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2_\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2_\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2_\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2_\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2_\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2".split(
      "_"
    ),
    monthsGenitiveEl: "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5_\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5_\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5_\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5_\u039C\u03B1\u0390\u03BF\u03C5_\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5_\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5_\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5_\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5_\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5_\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5_\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5".split(
      "_"
    ),
    months: function(momentToFormat, format) {
      if (!momentToFormat) {
        return this._monthsNominativeEl;
      } else if (typeof format === "string" && /D/.test(format.substring(0, format.indexOf("MMMM")))) {
        return this._monthsGenitiveEl[momentToFormat.month()];
      } else {
        return this._monthsNominativeEl[momentToFormat.month()];
      }
    },
    monthsShort: "\u0399\u03B1\u03BD_\u03A6\u03B5\u03B2_\u039C\u03B1\u03C1_\u0391\u03C0\u03C1_\u039C\u03B1\u03CA_\u0399\u03BF\u03C5\u03BD_\u0399\u03BF\u03C5\u03BB_\u0391\u03C5\u03B3_\u03A3\u03B5\u03C0_\u039F\u03BA\u03C4_\u039D\u03BF\u03B5_\u0394\u03B5\u03BA".split("_"),
    weekdays: "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE_\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1_\u03A4\u03C1\u03AF\u03C4\u03B7_\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7_\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7_\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE_\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF".split(
      "_"
    ),
    weekdaysShort: "\u039A\u03C5\u03C1_\u0394\u03B5\u03C5_\u03A4\u03C1\u03B9_\u03A4\u03B5\u03C4_\u03A0\u03B5\u03BC_\u03A0\u03B1\u03C1_\u03A3\u03B1\u03B2".split("_"),
    weekdaysMin: "\u039A\u03C5_\u0394\u03B5_\u03A4\u03C1_\u03A4\u03B5_\u03A0\u03B5_\u03A0\u03B1_\u03A3\u03B1".split("_"),
    meridiem: function(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? "\u03BC\u03BC" : "\u039C\u039C";
      } else {
        return isLower ? "\u03C0\u03BC" : "\u03A0\u039C";
      }
    },
    isPM: function(input) {
      return (input + "").toLowerCase()[0] === "\u03BC";
    },
    meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
    longDateFormat: {
      LT: "h:mm A",
      LTS: "h:mm:ss A",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY h:mm A",
      LLLL: "dddd, D MMMM YYYY h:mm A"
    },
    calendarEl: {
      sameDay: "[\u03A3\u03AE\u03BC\u03B5\u03C1\u03B1 {}] LT",
      nextDay: "[\u0391\u03CD\u03C1\u03B9\u03BF {}] LT",
      nextWeek: "dddd [{}] LT",
      lastDay: "[\u03A7\u03B8\u03B5\u03C2 {}] LT",
      lastWeek: function() {
        switch (this.day()) {
          case 6:
            return "[\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF] dddd [{}] LT";
          default:
            return "[\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7] dddd [{}] LT";
        }
      },
      sameElse: "L"
    },
    calendar: function(key, mom) {
      var output = this._calendarEl[key], hours = mom && mom.hours();
      if (isFunction(output)) {
        output = output.apply(mom);
      }
      return output.replace("{}", hours % 12 === 1 ? "\u03C3\u03C4\u03B7" : "\u03C3\u03C4\u03B9\u03C2");
    },
    relativeTime: {
      future: "\u03C3\u03B5 %s",
      past: "%s \u03C0\u03C1\u03B9\u03BD",
      s: "\u03BB\u03AF\u03B3\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1",
      ss: "%d \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1",
      m: "\u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
      mm: "%d \u03BB\u03B5\u03C0\u03C4\u03AC",
      h: "\u03BC\u03AF\u03B1 \u03CE\u03C1\u03B1",
      hh: "%d \u03CE\u03C1\u03B5\u03C2",
      d: "\u03BC\u03AF\u03B1 \u03BC\u03AD\u03C1\u03B1",
      dd: "%d \u03BC\u03AD\u03C1\u03B5\u03C2",
      M: "\u03AD\u03BD\u03B1\u03C2 \u03BC\u03AE\u03BD\u03B1\u03C2",
      MM: "%d \u03BC\u03AE\u03BD\u03B5\u03C2",
      y: "\u03AD\u03BD\u03B1\u03C2 \u03C7\u03C1\u03CC\u03BD\u03BF\u03C2",
      yy: "%d \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    dayOfMonthOrdinalParse: /\d{1,2}η/,
    ordinal: "%d\u03B7",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4st is the first week of the year.
    }
  });
  return el;
}));


/***/ }),

/***/ 52610:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var enAu = moment.defineLocale("en-au", {
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
      "_"
    ),
    weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
    longDateFormat: {
      LT: "h:mm A",
      LTS: "h:mm:ss A",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY h:mm A",
      LLLL: "dddd, D MMMM YYYY h:mm A"
    },
    calendar: {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal: function(number) {
      var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
      return number + output;
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return enAu;
}));


/***/ }),

/***/ 56656:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var enCa = moment.defineLocale("en-ca", {
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
      "_"
    ),
    weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
    longDateFormat: {
      LT: "h:mm A",
      LTS: "h:mm:ss A",
      L: "YYYY-MM-DD",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY h:mm A",
      LLLL: "dddd, MMMM D, YYYY h:mm A"
    },
    calendar: {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal: function(number) {
      var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
      return number + output;
    }
  });
  return enCa;
}));


/***/ }),

/***/ 54861:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var enGb = moment.defineLocale("en-gb", {
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
      "_"
    ),
    weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal: function(number) {
      var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return enGb;
}));


/***/ }),

/***/ 15642:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var enIe = moment.defineLocale("en-ie", {
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
      "_"
    ),
    weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal: function(number) {
      var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return enIe;
}));


/***/ }),

/***/ 11441:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var enIl = moment.defineLocale("en-il", {
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
      "_"
    ),
    weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal: function(number) {
      var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
      return number + output;
    }
  });
  return enIl;
}));


/***/ }),

/***/ 83567:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var enIn = moment.defineLocale("en-in", {
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
      "_"
    ),
    weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
    longDateFormat: {
      LT: "h:mm A",
      LTS: "h:mm:ss A",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY h:mm A",
      LLLL: "dddd, D MMMM YYYY h:mm A"
    },
    calendar: {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal: function(number) {
      var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
      return number + output;
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 1st is the first week of the year.
    }
  });
  return enIn;
}));


/***/ }),

/***/ 20532:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var enNz = moment.defineLocale("en-nz", {
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
      "_"
    ),
    weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
    longDateFormat: {
      LT: "h:mm A",
      LTS: "h:mm:ss A",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY h:mm A",
      LLLL: "dddd, D MMMM YYYY h:mm A"
    },
    calendar: {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal: function(number) {
      var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return enNz;
}));


/***/ }),

/***/ 2518:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var enSg = moment.defineLocale("en-sg", {
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
      "_"
    ),
    weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Today at] LT",
      nextDay: "[Tomorrow at] LT",
      nextWeek: "dddd [at] LT",
      lastDay: "[Yesterday at] LT",
      lastWeek: "[Last] dddd [at] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "in %s",
      past: "%s ago",
      s: "a few seconds",
      ss: "%d seconds",
      m: "a minute",
      mm: "%d minutes",
      h: "an hour",
      hh: "%d hours",
      d: "a day",
      dd: "%d days",
      M: "a month",
      MM: "%d months",
      y: "a year",
      yy: "%d years"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal: function(number) {
      var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return enSg;
}));


/***/ }),

/***/ 48468:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var eo = moment.defineLocale("eo", {
    months: "januaro_februaro_marto_aprilo_majo_junio_julio_a\u016Dgusto_septembro_oktobro_novembro_decembro".split(
      "_"
    ),
    monthsShort: "jan_feb_mart_apr_maj_jun_jul_a\u016Dg_sept_okt_nov_dec".split("_"),
    weekdays: "diman\u0109o_lundo_mardo_merkredo_\u0135a\u016Ddo_vendredo_sabato".split("_"),
    weekdaysShort: "dim_lun_mard_merk_\u0135a\u016D_ven_sab".split("_"),
    weekdaysMin: "di_lu_ma_me_\u0135a_ve_sa".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "[la] D[-an de] MMMM, YYYY",
      LLL: "[la] D[-an de] MMMM, YYYY HH:mm",
      LLLL: "dddd[n], [la] D[-an de] MMMM, YYYY HH:mm",
      llll: "ddd, [la] D[-an de] MMM, YYYY HH:mm"
    },
    meridiemParse: /[ap]\.t\.m/i,
    isPM: function(input) {
      return input.charAt(0).toLowerCase() === "p";
    },
    meridiem: function(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? "p.t.m." : "P.T.M.";
      } else {
        return isLower ? "a.t.m." : "A.T.M.";
      }
    },
    calendar: {
      sameDay: "[Hodia\u016D je] LT",
      nextDay: "[Morga\u016D je] LT",
      nextWeek: "dddd[n je] LT",
      lastDay: "[Hiera\u016D je] LT",
      lastWeek: "[pasintan] dddd[n je] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "post %s",
      past: "anta\u016D %s",
      s: "kelkaj sekundoj",
      ss: "%d sekundoj",
      m: "unu minuto",
      mm: "%d minutoj",
      h: "unu horo",
      hh: "%d horoj",
      d: "unu tago",
      //ne 'diurno', ĉar estas uzita por proksimumo
      dd: "%d tagoj",
      M: "unu monato",
      MM: "%d monatoj",
      y: "unu jaro",
      yy: "%d jaroj"
    },
    dayOfMonthOrdinalParse: /\d{1,2}a/,
    ordinal: "%da",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return eo;
}));


/***/ }),

/***/ 78420:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var monthsShortDot = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
    "_"
  ), monthsShort = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), monthsParse = [
    /^ene/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ], monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
  var esDo = moment.defineLocale("es-do", {
    months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
      "_"
    ),
    monthsShort: function(m, format) {
      if (!m) {
        return monthsShortDot;
      } else if (/-MMM-/.test(format)) {
        return monthsShort[m.month()];
      } else {
        return monthsShortDot[m.month()];
      }
    },
    monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays: "domingo_lunes_martes_mi\xE9rcoles_jueves_viernes_s\xE1bado".split("_"),
    weekdaysShort: "dom._lun._mar._mi\xE9._jue._vie._s\xE1b.".split("_"),
    weekdaysMin: "do_lu_ma_mi_ju_vi_s\xE1".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "h:mm A",
      LTS: "h:mm:ss A",
      L: "DD/MM/YYYY",
      LL: "D [de] MMMM [de] YYYY",
      LLL: "D [de] MMMM [de] YYYY h:mm A",
      LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A"
    },
    calendar: {
      sameDay: function() {
        return "[hoy a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      nextDay: function() {
        return "[ma\xF1ana a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      nextWeek: function() {
        return "dddd [a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      lastDay: function() {
        return "[ayer a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      lastWeek: function() {
        return "[el] dddd [pasado a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "en %s",
      past: "hace %s",
      s: "unos segundos",
      ss: "%d segundos",
      m: "un minuto",
      mm: "%d minutos",
      h: "una hora",
      hh: "%d horas",
      d: "un d\xEDa",
      dd: "%d d\xEDas",
      w: "una semana",
      ww: "%d semanas",
      M: "un mes",
      MM: "%d meses",
      y: "un a\xF1o",
      yy: "%d a\xF1os"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: "%d\xBA",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return esDo;
}));


/***/ }),

/***/ 25604:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var monthsShortDot = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
    "_"
  ), monthsShort = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), monthsParse = [
    /^ene/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ], monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
  var esMx = moment.defineLocale("es-mx", {
    months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
      "_"
    ),
    monthsShort: function(m, format) {
      if (!m) {
        return monthsShortDot;
      } else if (/-MMM-/.test(format)) {
        return monthsShort[m.month()];
      } else {
        return monthsShortDot[m.month()];
      }
    },
    monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays: "domingo_lunes_martes_mi\xE9rcoles_jueves_viernes_s\xE1bado".split("_"),
    weekdaysShort: "dom._lun._mar._mi\xE9._jue._vie._s\xE1b.".split("_"),
    weekdaysMin: "do_lu_ma_mi_ju_vi_s\xE1".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D [de] MMMM [de] YYYY",
      LLL: "D [de] MMMM [de] YYYY H:mm",
      LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
    },
    calendar: {
      sameDay: function() {
        return "[hoy a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      nextDay: function() {
        return "[ma\xF1ana a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      nextWeek: function() {
        return "dddd [a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      lastDay: function() {
        return "[ayer a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      lastWeek: function() {
        return "[el] dddd [pasado a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "en %s",
      past: "hace %s",
      s: "unos segundos",
      ss: "%d segundos",
      m: "un minuto",
      mm: "%d minutos",
      h: "una hora",
      hh: "%d horas",
      d: "un d\xEDa",
      dd: "%d d\xEDas",
      w: "una semana",
      ww: "%d semanas",
      M: "un mes",
      MM: "%d meses",
      y: "un a\xF1o",
      yy: "%d a\xF1os"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: "%d\xBA",
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    },
    invalidDate: "Fecha inv\xE1lida"
  });
  return esMx;
}));


/***/ }),

/***/ 48605:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var monthsShortDot = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
    "_"
  ), monthsShort = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), monthsParse = [
    /^ene/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ], monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
  var esUs = moment.defineLocale("es-us", {
    months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
      "_"
    ),
    monthsShort: function(m, format) {
      if (!m) {
        return monthsShortDot;
      } else if (/-MMM-/.test(format)) {
        return monthsShort[m.month()];
      } else {
        return monthsShortDot[m.month()];
      }
    },
    monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays: "domingo_lunes_martes_mi\xE9rcoles_jueves_viernes_s\xE1bado".split("_"),
    weekdaysShort: "dom._lun._mar._mi\xE9._jue._vie._s\xE1b.".split("_"),
    weekdaysMin: "do_lu_ma_mi_ju_vi_s\xE1".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "h:mm A",
      LTS: "h:mm:ss A",
      L: "MM/DD/YYYY",
      LL: "D [de] MMMM [de] YYYY",
      LLL: "D [de] MMMM [de] YYYY h:mm A",
      LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A"
    },
    calendar: {
      sameDay: function() {
        return "[hoy a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      nextDay: function() {
        return "[ma\xF1ana a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      nextWeek: function() {
        return "dddd [a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      lastDay: function() {
        return "[ayer a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      lastWeek: function() {
        return "[el] dddd [pasado a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "en %s",
      past: "hace %s",
      s: "unos segundos",
      ss: "%d segundos",
      m: "un minuto",
      mm: "%d minutos",
      h: "una hora",
      hh: "%d horas",
      d: "un d\xEDa",
      dd: "%d d\xEDas",
      w: "una semana",
      ww: "%d semanas",
      M: "un mes",
      MM: "%d meses",
      y: "un a\xF1o",
      yy: "%d a\xF1os"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: "%d\xBA",
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return esUs;
}));


/***/ }),

/***/ 50128:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var monthsShortDot = "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
    "_"
  ), monthsShort = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"), monthsParse = [
    /^ene/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ], monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
  var es = moment.defineLocale("es", {
    months: "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
      "_"
    ),
    monthsShort: function(m, format) {
      if (!m) {
        return monthsShortDot;
      } else if (/-MMM-/.test(format)) {
        return monthsShort[m.month()];
      } else {
        return monthsShortDot[m.month()];
      }
    },
    monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays: "domingo_lunes_martes_mi\xE9rcoles_jueves_viernes_s\xE1bado".split("_"),
    weekdaysShort: "dom._lun._mar._mi\xE9._jue._vie._s\xE1b.".split("_"),
    weekdaysMin: "do_lu_ma_mi_ju_vi_s\xE1".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D [de] MMMM [de] YYYY",
      LLL: "D [de] MMMM [de] YYYY H:mm",
      LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
    },
    calendar: {
      sameDay: function() {
        return "[hoy a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      nextDay: function() {
        return "[ma\xF1ana a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      nextWeek: function() {
        return "dddd [a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      lastDay: function() {
        return "[ayer a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      lastWeek: function() {
        return "[el] dddd [pasado a la" + (this.hours() !== 1 ? "s" : "") + "] LT";
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "en %s",
      past: "hace %s",
      s: "unos segundos",
      ss: "%d segundos",
      m: "un minuto",
      mm: "%d minutos",
      h: "una hora",
      hh: "%d horas",
      d: "un d\xEDa",
      dd: "%d d\xEDas",
      w: "una semana",
      ww: "%d semanas",
      M: "un mes",
      MM: "%d meses",
      y: "un a\xF1o",
      yy: "%d a\xF1os"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: "%d\xBA",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    },
    invalidDate: "Fecha inv\xE1lida"
  });
  return es;
}));


/***/ }),

/***/ 22341:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
      s: ["m\xF5ne sekundi", "m\xF5ni sekund", "paar sekundit"],
      ss: [number + "sekundi", number + "sekundit"],
      m: ["\xFChe minuti", "\xFCks minut"],
      mm: [number + " minuti", number + " minutit"],
      h: ["\xFChe tunni", "tund aega", "\xFCks tund"],
      hh: [number + " tunni", number + " tundi"],
      d: ["\xFChe p\xE4eva", "\xFCks p\xE4ev"],
      M: ["kuu aja", "kuu aega", "\xFCks kuu"],
      MM: [number + " kuu", number + " kuud"],
      y: ["\xFChe aasta", "aasta", "\xFCks aasta"],
      yy: [number + " aasta", number + " aastat"]
    };
    if (withoutSuffix) {
      return format[key][2] ? format[key][2] : format[key][1];
    }
    return isFuture ? format[key][0] : format[key][1];
  }
  var et = moment.defineLocale("et", {
    months: "jaanuar_veebruar_m\xE4rts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split(
      "_"
    ),
    monthsShort: "jaan_veebr_m\xE4rts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split("_"),
    weekdays: "p\xFChap\xE4ev_esmasp\xE4ev_teisip\xE4ev_kolmap\xE4ev_neljap\xE4ev_reede_laup\xE4ev".split(
      "_"
    ),
    weekdaysShort: "P_E_T_K_N_R_L".split("_"),
    weekdaysMin: "P_E_T_K_N_R_L".split("_"),
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY H:mm",
      LLLL: "dddd, D. MMMM YYYY H:mm"
    },
    calendar: {
      sameDay: "[T\xE4na,] LT",
      nextDay: "[Homme,] LT",
      nextWeek: "[J\xE4rgmine] dddd LT",
      lastDay: "[Eile,] LT",
      lastWeek: "[Eelmine] dddd LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s p\xE4rast",
      past: "%s tagasi",
      s: processRelativeTime,
      ss: processRelativeTime,
      m: processRelativeTime,
      mm: processRelativeTime,
      h: processRelativeTime,
      hh: processRelativeTime,
      d: processRelativeTime,
      dd: "%d p\xE4eva",
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return et;
}));


/***/ }),

/***/ 54598:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var eu = moment.defineLocale("eu", {
    months: "urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split(
      "_"
    ),
    monthsShort: "urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split(
      "_"
    ),
    weekdaysShort: "ig._al._ar._az._og._ol._lr.".split("_"),
    weekdaysMin: "ig_al_ar_az_og_ol_lr".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "YYYY[ko] MMMM[ren] D[a]",
      LLL: "YYYY[ko] MMMM[ren] D[a] HH:mm",
      LLLL: "dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",
      l: "YYYY-M-D",
      ll: "YYYY[ko] MMM D[a]",
      lll: "YYYY[ko] MMM D[a] HH:mm",
      llll: "ddd, YYYY[ko] MMM D[a] HH:mm"
    },
    calendar: {
      sameDay: "[gaur] LT[etan]",
      nextDay: "[bihar] LT[etan]",
      nextWeek: "dddd LT[etan]",
      lastDay: "[atzo] LT[etan]",
      lastWeek: "[aurreko] dddd LT[etan]",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s barru",
      past: "duela %s",
      s: "segundo batzuk",
      ss: "%d segundo",
      m: "minutu bat",
      mm: "%d minutu",
      h: "ordu bat",
      hh: "%d ordu",
      d: "egun bat",
      dd: "%d egun",
      M: "hilabete bat",
      MM: "%d hilabete",
      y: "urte bat",
      yy: "%d urte"
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return eu;
}));


/***/ }),

/***/ 46117:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u06F1",
    2: "\u06F2",
    3: "\u06F3",
    4: "\u06F4",
    5: "\u06F5",
    6: "\u06F6",
    7: "\u06F7",
    8: "\u06F8",
    9: "\u06F9",
    0: "\u06F0"
  }, numberMap = {
    "\u06F1": "1",
    "\u06F2": "2",
    "\u06F3": "3",
    "\u06F4": "4",
    "\u06F5": "5",
    "\u06F6": "6",
    "\u06F7": "7",
    "\u06F8": "8",
    "\u06F9": "9",
    "\u06F0": "0"
  };
  var fa = moment.defineLocale("fa", {
    months: "\u0698\u0627\u0646\u0648\u06CC\u0647_\u0641\u0648\u0631\u06CC\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06CC\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06CC\u0647_\u0627\u0648\u062A_\u0633\u067E\u062A\u0627\u0645\u0628\u0631_\u0627\u06A9\u062A\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062F\u0633\u0627\u0645\u0628\u0631".split(
      "_"
    ),
    monthsShort: "\u0698\u0627\u0646\u0648\u06CC\u0647_\u0641\u0648\u0631\u06CC\u0647_\u0645\u0627\u0631\u0633_\u0622\u0648\u0631\u06CC\u0644_\u0645\u0647_\u0698\u0648\u0626\u0646_\u0698\u0648\u0626\u06CC\u0647_\u0627\u0648\u062A_\u0633\u067E\u062A\u0627\u0645\u0628\u0631_\u0627\u06A9\u062A\u0628\u0631_\u0646\u0648\u0627\u0645\u0628\u0631_\u062F\u0633\u0627\u0645\u0628\u0631".split(
      "_"
    ),
    weekdays: "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split(
      "_"
    ),
    weekdaysShort: "\u06CC\u06A9\u200C\u0634\u0646\u0628\u0647_\u062F\u0648\u0634\u0646\u0628\u0647_\u0633\u0647\u200C\u0634\u0646\u0628\u0647_\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647_\u067E\u0646\u062C\u200C\u0634\u0646\u0628\u0647_\u062C\u0645\u0639\u0647_\u0634\u0646\u0628\u0647".split(
      "_"
    ),
    weekdaysMin: "\u06CC_\u062F_\u0633_\u0686_\u067E_\u062C_\u0634".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    meridiemParse: /قبل از ظهر|بعد از ظهر/,
    isPM: function(input) {
      return /بعد از ظهر/.test(input);
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u0642\u0628\u0644 \u0627\u0632 \u0638\u0647\u0631";
      } else {
        return "\u0628\u0639\u062F \u0627\u0632 \u0638\u0647\u0631";
      }
    },
    calendar: {
      sameDay: "[\u0627\u0645\u0631\u0648\u0632 \u0633\u0627\u0639\u062A] LT",
      nextDay: "[\u0641\u0631\u062F\u0627 \u0633\u0627\u0639\u062A] LT",
      nextWeek: "dddd [\u0633\u0627\u0639\u062A] LT",
      lastDay: "[\u062F\u06CC\u0631\u0648\u0632 \u0633\u0627\u0639\u062A] LT",
      lastWeek: "dddd [\u067E\u06CC\u0634] [\u0633\u0627\u0639\u062A] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u062F\u0631 %s",
      past: "%s \u067E\u06CC\u0634",
      s: "\u0686\u0646\u062F \u062B\u0627\u0646\u06CC\u0647",
      ss: "%d \u062B\u0627\u0646\u06CC\u0647",
      m: "\u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
      mm: "%d \u062F\u0642\u06CC\u0642\u0647",
      h: "\u06CC\u06A9 \u0633\u0627\u0639\u062A",
      hh: "%d \u0633\u0627\u0639\u062A",
      d: "\u06CC\u06A9 \u0631\u0648\u0632",
      dd: "%d \u0631\u0648\u0632",
      M: "\u06CC\u06A9 \u0645\u0627\u0647",
      MM: "%d \u0645\u0627\u0647",
      y: "\u06CC\u06A9 \u0633\u0627\u0644",
      yy: "%d \u0633\u0627\u0644"
    },
    preparse: function(string) {
      return string.replace(/[۰-۹]/g, function(match) {
        return numberMap[match];
      }).replace(/،/g, ",");
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      }).replace(/,/g, "\u060C");
    },
    dayOfMonthOrdinalParse: /\d{1,2}م/,
    ordinal: "%d\u0645",
    week: {
      dow: 6,
      // Saturday is the first day of the week.
      doy: 12
      // The week that contains Jan 12th is the first week of the year.
    }
  });
  return fa;
}));


/***/ }),

/***/ 80141:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var numbersPast = "nolla yksi kaksi kolme nelj\xE4 viisi kuusi seitsem\xE4n kahdeksan yhdeks\xE4n".split(
    " "
  ), numbersFuture = [
    "nolla",
    "yhden",
    "kahden",
    "kolmen",
    "nelj\xE4n",
    "viiden",
    "kuuden",
    numbersPast[7],
    numbersPast[8],
    numbersPast[9]
  ];
  function translate(number, withoutSuffix, key, isFuture) {
    var result = "";
    switch (key) {
      case "s":
        return isFuture ? "muutaman sekunnin" : "muutama sekunti";
      case "ss":
        result = isFuture ? "sekunnin" : "sekuntia";
        break;
      case "m":
        return isFuture ? "minuutin" : "minuutti";
      case "mm":
        result = isFuture ? "minuutin" : "minuuttia";
        break;
      case "h":
        return isFuture ? "tunnin" : "tunti";
      case "hh":
        result = isFuture ? "tunnin" : "tuntia";
        break;
      case "d":
        return isFuture ? "p\xE4iv\xE4n" : "p\xE4iv\xE4";
      case "dd":
        result = isFuture ? "p\xE4iv\xE4n" : "p\xE4iv\xE4\xE4";
        break;
      case "M":
        return isFuture ? "kuukauden" : "kuukausi";
      case "MM":
        result = isFuture ? "kuukauden" : "kuukautta";
        break;
      case "y":
        return isFuture ? "vuoden" : "vuosi";
      case "yy":
        result = isFuture ? "vuoden" : "vuotta";
        break;
    }
    result = verbalNumber(number, isFuture) + " " + result;
    return result;
  }
  function verbalNumber(number, isFuture) {
    return number < 10 ? isFuture ? numbersFuture[number] : numbersPast[number] : number;
  }
  var fi = moment.defineLocale("fi", {
    months: "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kes\xE4kuu_hein\xE4kuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split(
      "_"
    ),
    monthsShort: "tammi_helmi_maalis_huhti_touko_kes\xE4_hein\xE4_elo_syys_loka_marras_joulu".split(
      "_"
    ),
    weekdays: "sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split(
      "_"
    ),
    weekdaysShort: "su_ma_ti_ke_to_pe_la".split("_"),
    weekdaysMin: "su_ma_ti_ke_to_pe_la".split("_"),
    longDateFormat: {
      LT: "HH.mm",
      LTS: "HH.mm.ss",
      L: "DD.MM.YYYY",
      LL: "Do MMMM[ta] YYYY",
      LLL: "Do MMMM[ta] YYYY, [klo] HH.mm",
      LLLL: "dddd, Do MMMM[ta] YYYY, [klo] HH.mm",
      l: "D.M.YYYY",
      ll: "Do MMM YYYY",
      lll: "Do MMM YYYY, [klo] HH.mm",
      llll: "ddd, Do MMM YYYY, [klo] HH.mm"
    },
    calendar: {
      sameDay: "[t\xE4n\xE4\xE4n] [klo] LT",
      nextDay: "[huomenna] [klo] LT",
      nextWeek: "dddd [klo] LT",
      lastDay: "[eilen] [klo] LT",
      lastWeek: "[viime] dddd[na] [klo] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s p\xE4\xE4st\xE4",
      past: "%s sitten",
      s: translate,
      ss: translate,
      m: translate,
      mm: translate,
      h: translate,
      hh: translate,
      d: translate,
      dd: translate,
      M: translate,
      MM: translate,
      y: translate,
      yy: translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return fi;
}));


/***/ }),

/***/ 66469:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var fil = moment.defineLocale("fil", {
    months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split(
      "_"
    ),
    monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
    weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split(
      "_"
    ),
    weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
    weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "MM/D/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY HH:mm",
      LLLL: "dddd, MMMM DD, YYYY HH:mm"
    },
    calendar: {
      sameDay: "LT [ngayong araw]",
      nextDay: "[Bukas ng] LT",
      nextWeek: "LT [sa susunod na] dddd",
      lastDay: "LT [kahapon]",
      lastWeek: "LT [noong nakaraang] dddd",
      sameElse: "L"
    },
    relativeTime: {
      future: "sa loob ng %s",
      past: "%s ang nakalipas",
      s: "ilang segundo",
      ss: "%d segundo",
      m: "isang minuto",
      mm: "%d minuto",
      h: "isang oras",
      hh: "%d oras",
      d: "isang araw",
      dd: "%d araw",
      M: "isang buwan",
      MM: "%d buwan",
      y: "isang taon",
      yy: "%d taon"
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal: function(number) {
      return number;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return fil;
}));


/***/ }),

/***/ 8335:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var fo = moment.defineLocale("fo", {
    months: "januar_februar_mars_apr\xEDl_mai_juni_juli_august_september_oktober_november_desember".split(
      "_"
    ),
    monthsShort: "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
    weekdays: "sunnudagur_m\xE1nadagur_t\xFDsdagur_mikudagur_h\xF3sdagur_fr\xEDggjadagur_leygardagur".split(
      "_"
    ),
    weekdaysShort: "sun_m\xE1n_t\xFDs_mik_h\xF3s_fr\xED_ley".split("_"),
    weekdaysMin: "su_m\xE1_t\xFD_mi_h\xF3_fr_le".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D. MMMM, YYYY HH:mm"
    },
    calendar: {
      sameDay: "[\xCD dag kl.] LT",
      nextDay: "[\xCD morgin kl.] LT",
      nextWeek: "dddd [kl.] LT",
      lastDay: "[\xCD gj\xE1r kl.] LT",
      lastWeek: "[s\xED\xF0stu] dddd [kl] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "um %s",
      past: "%s s\xED\xF0ani",
      s: "f\xE1 sekund",
      ss: "%d sekundir",
      m: "ein minuttur",
      mm: "%d minuttir",
      h: "ein t\xEDmi",
      hh: "%d t\xEDmar",
      d: "ein dagur",
      dd: "%d dagar",
      M: "ein m\xE1na\xF0ur",
      MM: "%d m\xE1na\xF0ir",
      y: "eitt \xE1r",
      yy: "%d \xE1r"
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return fo;
}));


/***/ }),

/***/ 63677:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var frCa = moment.defineLocale("fr-ca", {
    months: "janvier_f\xE9vrier_mars_avril_mai_juin_juillet_ao\xFBt_septembre_octobre_novembre_d\xE9cembre".split(
      "_"
    ),
    monthsShort: "janv._f\xE9vr._mars_avr._mai_juin_juil._ao\xFBt_sept._oct._nov._d\xE9c.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
    weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
    weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Aujourd\u2019hui \xE0] LT",
      nextDay: "[Demain \xE0] LT",
      nextWeek: "dddd [\xE0] LT",
      lastDay: "[Hier \xE0] LT",
      lastWeek: "dddd [dernier \xE0] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "dans %s",
      past: "il y a %s",
      s: "quelques secondes",
      ss: "%d secondes",
      m: "une minute",
      mm: "%d minutes",
      h: "une heure",
      hh: "%d heures",
      d: "un jour",
      dd: "%d jours",
      M: "un mois",
      MM: "%d mois",
      y: "un an",
      yy: "%d ans"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal: function(number, period) {
      switch (period) {
        // Words with masculine grammatical gender: mois, trimestre, jour
        default:
        case "M":
        case "Q":
        case "D":
        case "DDD":
        case "d":
          return number + (number === 1 ? "er" : "e");
        // Words with feminine grammatical gender: semaine
        case "w":
        case "W":
          return number + (number === 1 ? "re" : "e");
      }
    }
  });
  return frCa;
}));


/***/ }),

/***/ 95318:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var frCh = moment.defineLocale("fr-ch", {
    months: "janvier_f\xE9vrier_mars_avril_mai_juin_juillet_ao\xFBt_septembre_octobre_novembre_d\xE9cembre".split(
      "_"
    ),
    monthsShort: "janv._f\xE9vr._mars_avr._mai_juin_juil._ao\xFBt_sept._oct._nov._d\xE9c.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
    weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
    weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Aujourd\u2019hui \xE0] LT",
      nextDay: "[Demain \xE0] LT",
      nextWeek: "dddd [\xE0] LT",
      lastDay: "[Hier \xE0] LT",
      lastWeek: "dddd [dernier \xE0] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "dans %s",
      past: "il y a %s",
      s: "quelques secondes",
      ss: "%d secondes",
      m: "une minute",
      mm: "%d minutes",
      h: "une heure",
      hh: "%d heures",
      d: "un jour",
      dd: "%d jours",
      M: "un mois",
      MM: "%d mois",
      y: "un an",
      yy: "%d ans"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
    ordinal: function(number, period) {
      switch (period) {
        // Words with masculine grammatical gender: mois, trimestre, jour
        default:
        case "M":
        case "Q":
        case "D":
        case "DDD":
        case "d":
          return number + (number === 1 ? "er" : "e");
        // Words with feminine grammatical gender: semaine
        case "w":
        case "W":
          return number + (number === 1 ? "re" : "e");
      }
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return frCh;
}));


/***/ }),

/***/ 85644:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var monthsStrictRegex = /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i, monthsShortStrictRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i, monthsRegex = /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i, monthsParse = [
    /^janv/i,
    /^févr/i,
    /^mars/i,
    /^avr/i,
    /^mai/i,
    /^juin/i,
    /^juil/i,
    /^août/i,
    /^sept/i,
    /^oct/i,
    /^nov/i,
    /^déc/i
  ];
  var fr = moment.defineLocale("fr", {
    months: "janvier_f\xE9vrier_mars_avril_mai_juin_juillet_ao\xFBt_septembre_octobre_novembre_d\xE9cembre".split(
      "_"
    ),
    monthsShort: "janv._f\xE9vr._mars_avr._mai_juin_juil._ao\xFBt_sept._oct._nov._d\xE9c.".split(
      "_"
    ),
    monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex,
    monthsShortStrictRegex,
    monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
    weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
    weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Aujourd\u2019hui \xE0] LT",
      nextDay: "[Demain \xE0] LT",
      nextWeek: "dddd [\xE0] LT",
      lastDay: "[Hier \xE0] LT",
      lastWeek: "dddd [dernier \xE0] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "dans %s",
      past: "il y a %s",
      s: "quelques secondes",
      ss: "%d secondes",
      m: "une minute",
      mm: "%d minutes",
      h: "une heure",
      hh: "%d heures",
      d: "un jour",
      dd: "%d jours",
      w: "une semaine",
      ww: "%d semaines",
      M: "un mois",
      MM: "%d mois",
      y: "un an",
      yy: "%d ans"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal: function(number, period) {
      switch (period) {
        // TODO: Return 'e' when day of month > 1. Move this case inside
        // block for masculine words below.
        // See https://github.com/moment/moment/issues/3375
        case "D":
          return number + (number === 1 ? "er" : "");
        // Words with masculine grammatical gender: mois, trimestre, jour
        default:
        case "M":
        case "Q":
        case "DDD":
        case "d":
          return number + (number === 1 ? "er" : "e");
        // Words with feminine grammatical gender: semaine
        case "w":
        case "W":
          return number + (number === 1 ? "re" : "e");
      }
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return fr;
}));


/***/ }),

/***/ 84093:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var monthsShortWithDots = "jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split("_"), monthsShortWithoutDots = "jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");
  var fy = moment.defineLocale("fy", {
    months: "jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split(
      "_"
    ),
    monthsShort: function(m, format) {
      if (!m) {
        return monthsShortWithDots;
      } else if (/-MMM-/.test(format)) {
        return monthsShortWithoutDots[m.month()];
      } else {
        return monthsShortWithDots[m.month()];
      }
    },
    monthsParseExact: true,
    weekdays: "snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split(
      "_"
    ),
    weekdaysShort: "si._mo._ti._wo._to._fr._so.".split("_"),
    weekdaysMin: "Si_Mo_Ti_Wo_To_Fr_So".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD-MM-YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[hjoed om] LT",
      nextDay: "[moarn om] LT",
      nextWeek: "dddd [om] LT",
      lastDay: "[juster om] LT",
      lastWeek: "[\xF4fr\xFBne] dddd [om] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "oer %s",
      past: "%s lyn",
      s: "in pear sekonden",
      ss: "%d sekonden",
      m: "ien min\xFAt",
      mm: "%d minuten",
      h: "ien oere",
      hh: "%d oeren",
      d: "ien dei",
      dd: "%d dagen",
      M: "ien moanne",
      MM: "%d moannen",
      y: "ien jier",
      yy: "%d jierren"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal: function(number) {
      return number + (number === 1 || number === 8 || number >= 20 ? "ste" : "de");
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return fy;
}));


/***/ }),

/***/ 32396:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var months = [
    "Ean\xE1ir",
    "Feabhra",
    "M\xE1rta",
    "Aibre\xE1n",
    "Bealtaine",
    "Meitheamh",
    "I\xFAil",
    "L\xFAnasa",
    "Me\xE1n F\xF3mhair",
    "Deireadh F\xF3mhair",
    "Samhain",
    "Nollaig"
  ], monthsShort = [
    "Ean",
    "Feabh",
    "M\xE1rt",
    "Aib",
    "Beal",
    "Meith",
    "I\xFAil",
    "L\xFAn",
    "M.F.",
    "D.F.",
    "Samh",
    "Noll"
  ], weekdays = [
    "D\xE9 Domhnaigh",
    "D\xE9 Luain",
    "D\xE9 M\xE1irt",
    "D\xE9 C\xE9adaoin",
    "D\xE9ardaoin",
    "D\xE9 hAoine",
    "D\xE9 Sathairn"
  ], weekdaysShort = ["Domh", "Luan", "M\xE1irt", "C\xE9ad", "D\xE9ar", "Aoine", "Sath"], weekdaysMin = ["Do", "Lu", "M\xE1", "C\xE9", "D\xE9", "A", "Sa"];
  var ga = moment.defineLocale("ga", {
    months,
    monthsShort,
    monthsParseExact: true,
    weekdays,
    weekdaysShort,
    weekdaysMin,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Inniu ag] LT",
      nextDay: "[Am\xE1rach ag] LT",
      nextWeek: "dddd [ag] LT",
      lastDay: "[Inn\xE9 ag] LT",
      lastWeek: "dddd [seo caite] [ag] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "i %s",
      past: "%s \xF3 shin",
      s: "c\xFApla soicind",
      ss: "%d soicind",
      m: "n\xF3im\xE9ad",
      mm: "%d n\xF3im\xE9ad",
      h: "uair an chloig",
      hh: "%d uair an chloig",
      d: "l\xE1",
      dd: "%d l\xE1",
      M: "m\xED",
      MM: "%d m\xEDonna",
      y: "bliain",
      yy: "%d bliain"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
    ordinal: function(number) {
      var output = number === 1 ? "d" : number % 10 === 2 ? "na" : "mh";
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return ga;
}));


/***/ }),

/***/ 37367:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var months = [
    "Am Faoilleach",
    "An Gearran",
    "Am M\xE0rt",
    "An Giblean",
    "An C\xE8itean",
    "An t-\xD2gmhios",
    "An t-Iuchar",
    "An L\xF9nastal",
    "An t-Sultain",
    "An D\xE0mhair",
    "An t-Samhain",
    "An D\xF9bhlachd"
  ], monthsShort = [
    "Faoi",
    "Gear",
    "M\xE0rt",
    "Gibl",
    "C\xE8it",
    "\xD2gmh",
    "Iuch",
    "L\xF9n",
    "Sult",
    "D\xE0mh",
    "Samh",
    "D\xF9bh"
  ], weekdays = [
    "Did\xF2mhnaich",
    "Diluain",
    "Dim\xE0irt",
    "Diciadain",
    "Diardaoin",
    "Dihaoine",
    "Disathairne"
  ], weekdaysShort = ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"], weekdaysMin = ["D\xF2", "Lu", "M\xE0", "Ci", "Ar", "Ha", "Sa"];
  var gd = moment.defineLocale("gd", {
    months,
    monthsShort,
    monthsParseExact: true,
    weekdays,
    weekdaysShort,
    weekdaysMin,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[An-diugh aig] LT",
      nextDay: "[A-m\xE0ireach aig] LT",
      nextWeek: "dddd [aig] LT",
      lastDay: "[An-d\xE8 aig] LT",
      lastWeek: "dddd [seo chaidh] [aig] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "ann an %s",
      past: "bho chionn %s",
      s: "beagan diogan",
      ss: "%d diogan",
      m: "mionaid",
      mm: "%d mionaidean",
      h: "uair",
      hh: "%d uairean",
      d: "latha",
      dd: "%d latha",
      M: "m\xECos",
      MM: "%d m\xECosan",
      y: "bliadhna",
      yy: "%d bliadhna"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
    ordinal: function(number) {
      var output = number === 1 ? "d" : number % 10 === 2 ? "na" : "mh";
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return gd;
}));


/***/ }),

/***/ 11423:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var gl = moment.defineLocale("gl", {
    months: "xaneiro_febreiro_marzo_abril_maio_xu\xF1o_xullo_agosto_setembro_outubro_novembro_decembro".split(
      "_"
    ),
    monthsShort: "xan._feb._mar._abr._mai._xu\xF1._xul._ago._set._out._nov._dec.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "domingo_luns_martes_m\xE9rcores_xoves_venres_s\xE1bado".split("_"),
    weekdaysShort: "dom._lun._mar._m\xE9r._xov._ven._s\xE1b.".split("_"),
    weekdaysMin: "do_lu_ma_m\xE9_xo_ve_s\xE1".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D [de] MMMM [de] YYYY",
      LLL: "D [de] MMMM [de] YYYY H:mm",
      LLLL: "dddd, D [de] MMMM [de] YYYY H:mm"
    },
    calendar: {
      sameDay: function() {
        return "[hoxe " + (this.hours() !== 1 ? "\xE1s" : "\xE1") + "] LT";
      },
      nextDay: function() {
        return "[ma\xF1\xE1 " + (this.hours() !== 1 ? "\xE1s" : "\xE1") + "] LT";
      },
      nextWeek: function() {
        return "dddd [" + (this.hours() !== 1 ? "\xE1s" : "a") + "] LT";
      },
      lastDay: function() {
        return "[onte " + (this.hours() !== 1 ? "\xE1" : "a") + "] LT";
      },
      lastWeek: function() {
        return "[o] dddd [pasado " + (this.hours() !== 1 ? "\xE1s" : "a") + "] LT";
      },
      sameElse: "L"
    },
    relativeTime: {
      future: function(str) {
        if (str.indexOf("un") === 0) {
          return "n" + str;
        }
        return "en " + str;
      },
      past: "hai %s",
      s: "uns segundos",
      ss: "%d segundos",
      m: "un minuto",
      mm: "%d minutos",
      h: "unha hora",
      hh: "%d horas",
      d: "un d\xEDa",
      dd: "%d d\xEDas",
      M: "un mes",
      MM: "%d meses",
      y: "un ano",
      yy: "%d anos"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: "%d\xBA",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return gl;
}));


/***/ }),

/***/ 27322:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
      s: ["\u0925\u094B\u0921\u092F\u093E \u0938\u0945\u0915\u0902\u0921\u093E\u0902\u0928\u0940", "\u0925\u094B\u0921\u0947 \u0938\u0945\u0915\u0902\u0921"],
      ss: [number + " \u0938\u0945\u0915\u0902\u0921\u093E\u0902\u0928\u0940", number + " \u0938\u0945\u0915\u0902\u0921"],
      m: ["\u090F\u0915\u093E \u092E\u093F\u0923\u091F\u093E\u0928", "\u090F\u0915 \u092E\u093F\u0928\u0942\u091F"],
      mm: [number + " \u092E\u093F\u0923\u091F\u093E\u0902\u0928\u0940", number + " \u092E\u093F\u0923\u091F\u093E\u0902"],
      h: ["\u090F\u0915\u093E \u0935\u0930\u093E\u0928", "\u090F\u0915 \u0935\u0930"],
      hh: [number + " \u0935\u0930\u093E\u0902\u0928\u0940", number + " \u0935\u0930\u093E\u0902"],
      d: ["\u090F\u0915\u093E \u0926\u093F\u0938\u093E\u0928", "\u090F\u0915 \u0926\u0940\u0938"],
      dd: [number + " \u0926\u093F\u0938\u093E\u0902\u0928\u0940", number + " \u0926\u0940\u0938"],
      M: ["\u090F\u0915\u093E \u092E\u094D\u0939\u092F\u0928\u094D\u092F\u093E\u0928", "\u090F\u0915 \u092E\u094D\u0939\u092F\u0928\u094B"],
      MM: [number + " \u092E\u094D\u0939\u092F\u0928\u094D\u092F\u093E\u0928\u0940", number + " \u092E\u094D\u0939\u092F\u0928\u0947"],
      y: ["\u090F\u0915\u093E \u0935\u0930\u094D\u0938\u093E\u0928", "\u090F\u0915 \u0935\u0930\u094D\u0938"],
      yy: [number + " \u0935\u0930\u094D\u0938\u093E\u0902\u0928\u0940", number + " \u0935\u0930\u094D\u0938\u093E\u0902"]
    };
    return isFuture ? format[key][0] : format[key][1];
  }
  var gomDeva = moment.defineLocale("gom-deva", {
    months: {
      standalone: "\u091C\u093E\u0928\u0947\u0935\u093E\u0930\u0940_\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u093E\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u090F\u092A\u094D\u0930\u0940\u0932_\u092E\u0947_\u091C\u0942\u0928_\u091C\u0941\u0932\u092F_\u0911\u0917\u0938\u094D\u091F_\u0938\u092A\u094D\u091F\u0947\u0902\u092C\u0930_\u0911\u0915\u094D\u091F\u094B\u092C\u0930_\u0928\u094B\u0935\u094D\u0939\u0947\u0902\u092C\u0930_\u0921\u093F\u0938\u0947\u0902\u092C\u0930".split(
        "_"
      ),
      format: "\u091C\u093E\u0928\u0947\u0935\u093E\u0930\u0940\u091A\u094D\u092F\u093E_\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u093E\u0930\u0940\u091A\u094D\u092F\u093E_\u092E\u093E\u0930\u094D\u091A\u093E\u091A\u094D\u092F\u093E_\u090F\u092A\u094D\u0930\u0940\u0932\u093E\u091A\u094D\u092F\u093E_\u092E\u0947\u092F\u093E\u091A\u094D\u092F\u093E_\u091C\u0942\u0928\u093E\u091A\u094D\u092F\u093E_\u091C\u0941\u0932\u092F\u093E\u091A\u094D\u092F\u093E_\u0911\u0917\u0938\u094D\u091F\u093E\u091A\u094D\u092F\u093E_\u0938\u092A\u094D\u091F\u0947\u0902\u092C\u0930\u093E\u091A\u094D\u092F\u093E_\u0911\u0915\u094D\u091F\u094B\u092C\u0930\u093E\u091A\u094D\u092F\u093E_\u0928\u094B\u0935\u094D\u0939\u0947\u0902\u092C\u0930\u093E\u091A\u094D\u092F\u093E_\u0921\u093F\u0938\u0947\u0902\u092C\u0930\u093E\u091A\u094D\u092F\u093E".split(
        "_"
      ),
      isFormat: /MMMM(\s)+D[oD]?/
    },
    monthsShort: "\u091C\u093E\u0928\u0947._\u092B\u0947\u092C\u094D\u0930\u0941._\u092E\u093E\u0930\u094D\u091A_\u090F\u092A\u094D\u0930\u0940._\u092E\u0947_\u091C\u0942\u0928_\u091C\u0941\u0932._\u0911\u0917._\u0938\u092A\u094D\u091F\u0947\u0902._\u0911\u0915\u094D\u091F\u094B._\u0928\u094B\u0935\u094D\u0939\u0947\u0902._\u0921\u093F\u0938\u0947\u0902.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "\u0906\u092F\u0924\u093E\u0930_\u0938\u094B\u092E\u093E\u0930_\u092E\u0902\u0917\u0933\u093E\u0930_\u092C\u0941\u0927\u0935\u093E\u0930_\u092C\u093F\u0930\u0947\u0938\u094D\u0924\u093E\u0930_\u0938\u0941\u0915\u094D\u0930\u093E\u0930_\u0936\u0947\u0928\u0935\u093E\u0930".split("_"),
    weekdaysShort: "\u0906\u092F\u0924._\u0938\u094B\u092E._\u092E\u0902\u0917\u0933._\u092C\u0941\u0927._\u092C\u094D\u0930\u0947\u0938\u094D\u0924._\u0938\u0941\u0915\u094D\u0930._\u0936\u0947\u0928.".split("_"),
    weekdaysMin: "\u0906_\u0938\u094B_\u092E\u0902_\u092C\u0941_\u092C\u094D\u0930\u0947_\u0938\u0941_\u0936\u0947".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "A h:mm [\u0935\u093E\u091C\u0924\u093E\u0902]",
      LTS: "A h:mm:ss [\u0935\u093E\u091C\u0924\u093E\u0902]",
      L: "DD-MM-YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY A h:mm [\u0935\u093E\u091C\u0924\u093E\u0902]",
      LLLL: "dddd, MMMM Do, YYYY, A h:mm [\u0935\u093E\u091C\u0924\u093E\u0902]",
      llll: "ddd, D MMM YYYY, A h:mm [\u0935\u093E\u091C\u0924\u093E\u0902]"
    },
    calendar: {
      sameDay: "[\u0906\u092F\u091C] LT",
      nextDay: "[\u092B\u093E\u0932\u094D\u092F\u093E\u0902] LT",
      nextWeek: "[\u092B\u0941\u0921\u0932\u094B] dddd[,] LT",
      lastDay: "[\u0915\u093E\u0932] LT",
      lastWeek: "[\u092B\u093E\u091F\u0932\u094B] dddd[,] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s",
      past: "%s \u0906\u0926\u0940\u0902",
      s: processRelativeTime,
      ss: processRelativeTime,
      m: processRelativeTime,
      mm: processRelativeTime,
      h: processRelativeTime,
      hh: processRelativeTime,
      d: processRelativeTime,
      dd: processRelativeTime,
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
    ordinal: function(number, period) {
      switch (period) {
        // the ordinal 'वेर' only applies to day of the month
        case "D":
          return number + "\u0935\u0947\u0930";
        default:
        case "M":
        case "Q":
        case "DDD":
        case "d":
        case "w":
        case "W":
          return number;
      }
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week
      doy: 3
      // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
    },
    meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u0930\u093E\u0924\u0940") {
        return hour < 4 ? hour : hour + 12;
      } else if (meridiem === "\u0938\u0915\u093E\u0933\u0940\u0902") {
        return hour;
      } else if (meridiem === "\u0926\u0928\u092A\u093E\u0930\u093E\u0902") {
        return hour > 12 ? hour : hour + 12;
      } else if (meridiem === "\u0938\u093E\u0902\u091C\u0947") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u0930\u093E\u0924\u0940";
      } else if (hour < 12) {
        return "\u0938\u0915\u093E\u0933\u0940\u0902";
      } else if (hour < 16) {
        return "\u0926\u0928\u092A\u093E\u0930\u093E\u0902";
      } else if (hour < 20) {
        return "\u0938\u093E\u0902\u091C\u0947";
      } else {
        return "\u0930\u093E\u0924\u0940";
      }
    }
  });
  return gomDeva;
}));


/***/ }),

/***/ 89285:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
      s: ["thoddea sekondamni", "thodde sekond"],
      ss: [number + " sekondamni", number + " sekond"],
      m: ["eka mintan", "ek minut"],
      mm: [number + " mintamni", number + " mintam"],
      h: ["eka voran", "ek vor"],
      hh: [number + " voramni", number + " voram"],
      d: ["eka disan", "ek dis"],
      dd: [number + " disamni", number + " dis"],
      M: ["eka mhoinean", "ek mhoino"],
      MM: [number + " mhoineamni", number + " mhoine"],
      y: ["eka vorsan", "ek voros"],
      yy: [number + " vorsamni", number + " vorsam"]
    };
    return isFuture ? format[key][0] : format[key][1];
  }
  var gomLatn = moment.defineLocale("gom-latn", {
    months: {
      standalone: "Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split(
        "_"
      ),
      format: "Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea".split(
        "_"
      ),
      isFormat: /MMMM(\s)+D[oD]?/
    },
    monthsShort: "Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split("_"),
    monthsParseExact: true,
    weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split("_"),
    weekdaysShort: "Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),
    weekdaysMin: "Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "A h:mm [vazta]",
      LTS: "A h:mm:ss [vazta]",
      L: "DD-MM-YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY A h:mm [vazta]",
      LLLL: "dddd, MMMM Do, YYYY, A h:mm [vazta]",
      llll: "ddd, D MMM YYYY, A h:mm [vazta]"
    },
    calendar: {
      sameDay: "[Aiz] LT",
      nextDay: "[Faleam] LT",
      nextWeek: "[Fuddlo] dddd[,] LT",
      lastDay: "[Kal] LT",
      lastWeek: "[Fattlo] dddd[,] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s",
      past: "%s adim",
      s: processRelativeTime,
      ss: processRelativeTime,
      m: processRelativeTime,
      mm: processRelativeTime,
      h: processRelativeTime,
      hh: processRelativeTime,
      d: processRelativeTime,
      dd: processRelativeTime,
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er)/,
    ordinal: function(number, period) {
      switch (period) {
        // the ordinal 'er' only applies to day of the month
        case "D":
          return number + "er";
        default:
        case "M":
        case "Q":
        case "DDD":
        case "d":
        case "w":
        case "W":
          return number;
      }
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week
      doy: 3
      // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
    },
    meridiemParse: /rati|sokallim|donparam|sanje/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "rati") {
        return hour < 4 ? hour : hour + 12;
      } else if (meridiem === "sokallim") {
        return hour;
      } else if (meridiem === "donparam") {
        return hour > 12 ? hour : hour + 12;
      } else if (meridiem === "sanje") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "rati";
      } else if (hour < 12) {
        return "sokallim";
      } else if (hour < 16) {
        return "donparam";
      } else if (hour < 20) {
        return "sanje";
      } else {
        return "rati";
      }
    }
  });
  return gomLatn;
}));


/***/ }),

/***/ 26544:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u0AE7",
    2: "\u0AE8",
    3: "\u0AE9",
    4: "\u0AEA",
    5: "\u0AEB",
    6: "\u0AEC",
    7: "\u0AED",
    8: "\u0AEE",
    9: "\u0AEF",
    0: "\u0AE6"
  }, numberMap = {
    "\u0AE7": "1",
    "\u0AE8": "2",
    "\u0AE9": "3",
    "\u0AEA": "4",
    "\u0AEB": "5",
    "\u0AEC": "6",
    "\u0AED": "7",
    "\u0AEE": "8",
    "\u0AEF": "9",
    "\u0AE6": "0"
  };
  var gu = moment.defineLocale("gu", {
    months: "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0_\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0_\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A_\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2_\u0AAE\u0AC7_\u0A9C\u0AC2\u0AA8_\u0A9C\u0AC1\u0AB2\u0ABE\u0A88_\u0A91\u0A97\u0AB8\u0ACD\u0A9F_\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0_\u0A91\u0A95\u0ACD\u0A9F\u0ACD\u0AAC\u0AB0_\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0_\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0".split(
      "_"
    ),
    monthsShort: "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1._\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1._\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A_\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF._\u0AAE\u0AC7_\u0A9C\u0AC2\u0AA8_\u0A9C\u0AC1\u0AB2\u0ABE._\u0A91\u0A97._\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7._\u0A91\u0A95\u0ACD\u0A9F\u0ACD._\u0AA8\u0AB5\u0AC7._\u0AA1\u0ABF\u0AB8\u0AC7.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0_\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0_\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0_\u0AAC\u0AC1\u0AA7\u0ACD\u0AB5\u0ABE\u0AB0_\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0_\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0_\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0".split(
      "_"
    ),
    weekdaysShort: "\u0AB0\u0AB5\u0ABF_\u0AB8\u0ACB\u0AAE_\u0AAE\u0A82\u0A97\u0AB3_\u0AAC\u0AC1\u0AA7\u0ACD_\u0A97\u0AC1\u0AB0\u0AC1_\u0AB6\u0AC1\u0A95\u0ACD\u0AB0_\u0AB6\u0AA8\u0ABF".split("_"),
    weekdaysMin: "\u0AB0_\u0AB8\u0ACB_\u0AAE\u0A82_\u0AAC\u0AC1_\u0A97\u0AC1_\u0AB6\u0AC1_\u0AB6".split("_"),
    longDateFormat: {
      LT: "A h:mm \u0AB5\u0ABE\u0A97\u0ACD\u0AAF\u0AC7",
      LTS: "A h:mm:ss \u0AB5\u0ABE\u0A97\u0ACD\u0AAF\u0AC7",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, A h:mm \u0AB5\u0ABE\u0A97\u0ACD\u0AAF\u0AC7",
      LLLL: "dddd, D MMMM YYYY, A h:mm \u0AB5\u0ABE\u0A97\u0ACD\u0AAF\u0AC7"
    },
    calendar: {
      sameDay: "[\u0A86\u0A9C] LT",
      nextDay: "[\u0A95\u0ABE\u0AB2\u0AC7] LT",
      nextWeek: "dddd, LT",
      lastDay: "[\u0A97\u0A87\u0A95\u0ABE\u0AB2\u0AC7] LT",
      lastWeek: "[\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE] dddd, LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0AAE\u0ABE",
      past: "%s \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE",
      s: "\u0A85\u0AAE\u0AC1\u0A95 \u0AAA\u0AB3\u0ACB",
      ss: "%d \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
      m: "\u0A8F\u0A95 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
      mm: "%d \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
      h: "\u0A8F\u0A95 \u0A95\u0AB2\u0ABE\u0A95",
      hh: "%d \u0A95\u0AB2\u0ABE\u0A95",
      d: "\u0A8F\u0A95 \u0AA6\u0ABF\u0AB5\u0AB8",
      dd: "%d \u0AA6\u0ABF\u0AB5\u0AB8",
      M: "\u0A8F\u0A95 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
      MM: "%d \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
      y: "\u0A8F\u0A95 \u0AB5\u0AB0\u0ACD\u0AB7",
      yy: "%d \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    preparse: function(string) {
      return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function(match) {
        return numberMap[match];
      });
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      });
    },
    // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
    meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u0AB0\u0ABE\u0AA4") {
        return hour < 4 ? hour : hour + 12;
      } else if (meridiem === "\u0AB8\u0AB5\u0ABE\u0AB0") {
        return hour;
      } else if (meridiem === "\u0AAC\u0AAA\u0ACB\u0AB0") {
        return hour >= 10 ? hour : hour + 12;
      } else if (meridiem === "\u0AB8\u0ABE\u0A82\u0A9C") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u0AB0\u0ABE\u0AA4";
      } else if (hour < 10) {
        return "\u0AB8\u0AB5\u0ABE\u0AB0";
      } else if (hour < 17) {
        return "\u0AAC\u0AAA\u0ACB\u0AB0";
      } else if (hour < 20) {
        return "\u0AB8\u0ABE\u0A82\u0A9C";
      } else {
        return "\u0AB0\u0ABE\u0AA4";
      }
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return gu;
}));


/***/ }),

/***/ 90123:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var he = moment.defineLocale("he", {
    months: "\u05D9\u05E0\u05D5\u05D0\u05E8_\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8_\u05DE\u05E8\u05E5_\u05D0\u05E4\u05E8\u05D9\u05DC_\u05DE\u05D0\u05D9_\u05D9\u05D5\u05E0\u05D9_\u05D9\u05D5\u05DC\u05D9_\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8_\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8_\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8_\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8_\u05D3\u05E6\u05DE\u05D1\u05E8".split(
      "_"
    ),
    monthsShort: "\u05D9\u05E0\u05D5\u05F3_\u05E4\u05D1\u05E8\u05F3_\u05DE\u05E8\u05E5_\u05D0\u05E4\u05E8\u05F3_\u05DE\u05D0\u05D9_\u05D9\u05D5\u05E0\u05D9_\u05D9\u05D5\u05DC\u05D9_\u05D0\u05D5\u05D2\u05F3_\u05E1\u05E4\u05D8\u05F3_\u05D0\u05D5\u05E7\u05F3_\u05E0\u05D5\u05D1\u05F3_\u05D3\u05E6\u05DE\u05F3".split("_"),
    weekdays: "\u05E8\u05D0\u05E9\u05D5\u05DF_\u05E9\u05E0\u05D9_\u05E9\u05DC\u05D9\u05E9\u05D9_\u05E8\u05D1\u05D9\u05E2\u05D9_\u05D7\u05DE\u05D9\u05E9\u05D9_\u05E9\u05D9\u05E9\u05D9_\u05E9\u05D1\u05EA".split("_"),
    weekdaysShort: "\u05D0\u05F3_\u05D1\u05F3_\u05D2\u05F3_\u05D3\u05F3_\u05D4\u05F3_\u05D5\u05F3_\u05E9\u05F3".split("_"),
    weekdaysMin: "\u05D0_\u05D1_\u05D2_\u05D3_\u05D4_\u05D5_\u05E9".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D [\u05D1]MMMM YYYY",
      LLL: "D [\u05D1]MMMM YYYY HH:mm",
      LLLL: "dddd, D [\u05D1]MMMM YYYY HH:mm",
      l: "D/M/YYYY",
      ll: "D MMM YYYY",
      lll: "D MMM YYYY HH:mm",
      llll: "ddd, D MMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[\u05D4\u05D9\u05D5\u05DD \u05D1\u05BE]LT",
      nextDay: "[\u05DE\u05D7\u05E8 \u05D1\u05BE]LT",
      nextWeek: "dddd [\u05D1\u05E9\u05E2\u05D4] LT",
      lastDay: "[\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05BE]LT",
      lastWeek: "[\u05D1\u05D9\u05D5\u05DD] dddd [\u05D4\u05D0\u05D7\u05E8\u05D5\u05DF \u05D1\u05E9\u05E2\u05D4] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u05D1\u05E2\u05D5\u05D3 %s",
      past: "\u05DC\u05E4\u05E0\u05D9 %s",
      s: "\u05DE\u05E1\u05E4\u05E8 \u05E9\u05E0\u05D9\u05D5\u05EA",
      ss: "%d \u05E9\u05E0\u05D9\u05D5\u05EA",
      m: "\u05D3\u05E7\u05D4",
      mm: "%d \u05D3\u05E7\u05D5\u05EA",
      h: "\u05E9\u05E2\u05D4",
      hh: function(number) {
        if (number === 2) {
          return "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD";
        }
        return number + " \u05E9\u05E2\u05D5\u05EA";
      },
      d: "\u05D9\u05D5\u05DD",
      dd: function(number) {
        if (number === 2) {
          return "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD";
        }
        return number + " \u05D9\u05DE\u05D9\u05DD";
      },
      M: "\u05D7\u05D5\u05D3\u05E9",
      MM: function(number) {
        if (number === 2) {
          return "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD";
        }
        return number + " \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD";
      },
      y: "\u05E9\u05E0\u05D4",
      yy: function(number) {
        if (number === 2) {
          return "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD";
        } else if (number % 10 === 0 && number !== 10) {
          return number + " \u05E9\u05E0\u05D4";
        }
        return number + " \u05E9\u05E0\u05D9\u05DD";
      }
    },
    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
    isPM: function(input) {
      return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 5) {
        return "\u05DC\u05E4\u05E0\u05D5\u05EA \u05D1\u05D5\u05E7\u05E8";
      } else if (hour < 10) {
        return "\u05D1\u05D1\u05D5\u05E7\u05E8";
      } else if (hour < 12) {
        return isLower ? '\u05DC\u05E4\u05E0\u05D4"\u05E6' : "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD";
      } else if (hour < 18) {
        return isLower ? '\u05D0\u05D7\u05D4"\u05E6' : "\u05D0\u05D7\u05E8\u05D9 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD";
      } else {
        return "\u05D1\u05E2\u05E8\u05D1";
      }
    }
  });
  return he;
}));


/***/ }),

/***/ 63079:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u0967",
    2: "\u0968",
    3: "\u0969",
    4: "\u096A",
    5: "\u096B",
    6: "\u096C",
    7: "\u096D",
    8: "\u096E",
    9: "\u096F",
    0: "\u0966"
  }, numberMap = {
    "\u0967": "1",
    "\u0968": "2",
    "\u0969": "3",
    "\u096A": "4",
    "\u096B": "5",
    "\u096C": "6",
    "\u096D": "7",
    "\u096E": "8",
    "\u096F": "9",
    "\u0966": "0"
  }, monthsParse = [
    /^जन/i,
    /^फ़र|फर/i,
    /^मार्च/i,
    /^अप्रै/i,
    /^मई/i,
    /^जून/i,
    /^जुल/i,
    /^अग/i,
    /^सितं|सित/i,
    /^अक्टू/i,
    /^नव|नवं/i,
    /^दिसं|दिस/i
  ], shortMonthsParse = [
    /^जन/i,
    /^फ़र/i,
    /^मार्च/i,
    /^अप्रै/i,
    /^मई/i,
    /^जून/i,
    /^जुल/i,
    /^अग/i,
    /^सित/i,
    /^अक्टू/i,
    /^नव/i,
    /^दिस/i
  ];
  var hi = moment.defineLocale("hi", {
    months: {
      format: "\u091C\u0928\u0935\u0930\u0940_\u092B\u093C\u0930\u0935\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u0948\u0932_\u092E\u0908_\u091C\u0942\u0928_\u091C\u0941\u0932\u093E\u0908_\u0905\u0917\u0938\u094D\u0924_\u0938\u093F\u0924\u092E\u094D\u092C\u0930_\u0905\u0915\u094D\u091F\u0942\u092C\u0930_\u0928\u0935\u092E\u094D\u092C\u0930_\u0926\u093F\u0938\u092E\u094D\u092C\u0930".split(
        "_"
      ),
      standalone: "\u091C\u0928\u0935\u0930\u0940_\u092B\u0930\u0935\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u0948\u0932_\u092E\u0908_\u091C\u0942\u0928_\u091C\u0941\u0932\u093E\u0908_\u0905\u0917\u0938\u094D\u0924_\u0938\u093F\u0924\u0902\u092C\u0930_\u0905\u0915\u094D\u091F\u0942\u092C\u0930_\u0928\u0935\u0902\u092C\u0930_\u0926\u093F\u0938\u0902\u092C\u0930".split(
        "_"
      )
    },
    monthsShort: "\u091C\u0928._\u092B\u093C\u0930._\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u0948._\u092E\u0908_\u091C\u0942\u0928_\u091C\u0941\u0932._\u0905\u0917._\u0938\u093F\u0924._\u0905\u0915\u094D\u091F\u0942._\u0928\u0935._\u0926\u093F\u0938.".split("_"),
    weekdays: "\u0930\u0935\u093F\u0935\u093E\u0930_\u0938\u094B\u092E\u0935\u093E\u0930_\u092E\u0902\u0917\u0932\u0935\u093E\u0930_\u092C\u0941\u0927\u0935\u093E\u0930_\u0917\u0941\u0930\u0942\u0935\u093E\u0930_\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930_\u0936\u0928\u093F\u0935\u093E\u0930".split("_"),
    weekdaysShort: "\u0930\u0935\u093F_\u0938\u094B\u092E_\u092E\u0902\u0917\u0932_\u092C\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094D\u0930_\u0936\u0928\u093F".split("_"),
    weekdaysMin: "\u0930_\u0938\u094B_\u092E\u0902_\u092C\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),
    longDateFormat: {
      LT: "A h:mm \u092C\u091C\u0947",
      LTS: "A h:mm:ss \u092C\u091C\u0947",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, A h:mm \u092C\u091C\u0947",
      LLLL: "dddd, D MMMM YYYY, A h:mm \u092C\u091C\u0947"
    },
    monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse,
    monthsRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
    monthsShortRegex: /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
    monthsStrictRegex: /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
    monthsShortStrictRegex: /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
    calendar: {
      sameDay: "[\u0906\u091C] LT",
      nextDay: "[\u0915\u0932] LT",
      nextWeek: "dddd, LT",
      lastDay: "[\u0915\u0932] LT",
      lastWeek: "[\u092A\u093F\u091B\u0932\u0947] dddd, LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u092E\u0947\u0902",
      past: "%s \u092A\u0939\u0932\u0947",
      s: "\u0915\u0941\u091B \u0939\u0940 \u0915\u094D\u0937\u0923",
      ss: "%d \u0938\u0947\u0915\u0902\u0921",
      m: "\u090F\u0915 \u092E\u093F\u0928\u091F",
      mm: "%d \u092E\u093F\u0928\u091F",
      h: "\u090F\u0915 \u0918\u0902\u091F\u093E",
      hh: "%d \u0918\u0902\u091F\u0947",
      d: "\u090F\u0915 \u0926\u093F\u0928",
      dd: "%d \u0926\u093F\u0928",
      M: "\u090F\u0915 \u092E\u0939\u0940\u0928\u0947",
      MM: "%d \u092E\u0939\u0940\u0928\u0947",
      y: "\u090F\u0915 \u0935\u0930\u094D\u0937",
      yy: "%d \u0935\u0930\u094D\u0937"
    },
    preparse: function(string) {
      return string.replace(/[१२३४५६७८९०]/g, function(match) {
        return numberMap[match];
      });
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      });
    },
    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
    meridiemParse: /रात|सुबह|दोपहर|शाम/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u0930\u093E\u0924") {
        return hour < 4 ? hour : hour + 12;
      } else if (meridiem === "\u0938\u0941\u092C\u0939") {
        return hour;
      } else if (meridiem === "\u0926\u094B\u092A\u0939\u0930") {
        return hour >= 10 ? hour : hour + 12;
      } else if (meridiem === "\u0936\u093E\u092E") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u0930\u093E\u0924";
      } else if (hour < 10) {
        return "\u0938\u0941\u092C\u0939";
      } else if (hour < 17) {
        return "\u0926\u094B\u092A\u0939\u0930";
      } else if (hour < 20) {
        return "\u0936\u093E\u092E";
      } else {
        return "\u0930\u093E\u0924";
      }
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return hi;
}));


/***/ }),

/***/ 57586:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function translate(number, withoutSuffix, key) {
    var result = number + " ";
    switch (key) {
      case "ss":
        if (number === 1) {
          result += "sekunda";
        } else if (number === 2 || number === 3 || number === 4) {
          result += "sekunde";
        } else {
          result += "sekundi";
        }
        return result;
      case "m":
        return withoutSuffix ? "jedna minuta" : "jedne minute";
      case "mm":
        if (number === 1) {
          result += "minuta";
        } else if (number === 2 || number === 3 || number === 4) {
          result += "minute";
        } else {
          result += "minuta";
        }
        return result;
      case "h":
        return withoutSuffix ? "jedan sat" : "jednog sata";
      case "hh":
        if (number === 1) {
          result += "sat";
        } else if (number === 2 || number === 3 || number === 4) {
          result += "sata";
        } else {
          result += "sati";
        }
        return result;
      case "dd":
        if (number === 1) {
          result += "dan";
        } else {
          result += "dana";
        }
        return result;
      case "MM":
        if (number === 1) {
          result += "mjesec";
        } else if (number === 2 || number === 3 || number === 4) {
          result += "mjeseca";
        } else {
          result += "mjeseci";
        }
        return result;
      case "yy":
        if (number === 1) {
          result += "godina";
        } else if (number === 2 || number === 3 || number === 4) {
          result += "godine";
        } else {
          result += "godina";
        }
        return result;
    }
  }
  var hr = moment.defineLocale("hr", {
    months: {
      format: "sije\u010Dnja_velja\u010De_o\u017Eujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split(
        "_"
      ),
      standalone: "sije\u010Danj_velja\u010Da_o\u017Eujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split(
        "_"
      )
    },
    monthsShort: "sij._velj._o\u017Eu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010Detvrtak_petak_subota".split(
      "_"
    ),
    weekdaysShort: "ned._pon._uto._sri._\u010Det._pet._sub.".split("_"),
    weekdaysMin: "ne_po_ut_sr_\u010De_pe_su".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD.MM.YYYY",
      LL: "Do MMMM YYYY",
      LLL: "Do MMMM YYYY H:mm",
      LLLL: "dddd, Do MMMM YYYY H:mm"
    },
    calendar: {
      sameDay: "[danas u] LT",
      nextDay: "[sutra u] LT",
      nextWeek: function() {
        switch (this.day()) {
          case 0:
            return "[u] [nedjelju] [u] LT";
          case 3:
            return "[u] [srijedu] [u] LT";
          case 6:
            return "[u] [subotu] [u] LT";
          case 1:
          case 2:
          case 4:
          case 5:
            return "[u] dddd [u] LT";
        }
      },
      lastDay: "[ju\u010Der u] LT",
      lastWeek: function() {
        switch (this.day()) {
          case 0:
            return "[pro\u0161lu] [nedjelju] [u] LT";
          case 3:
            return "[pro\u0161lu] [srijedu] [u] LT";
          case 6:
            return "[pro\u0161le] [subote] [u] LT";
          case 1:
          case 2:
          case 4:
          case 5:
            return "[pro\u0161li] dddd [u] LT";
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "za %s",
      past: "prije %s",
      s: "par sekundi",
      ss: translate,
      m: translate,
      mm: translate,
      h: translate,
      hh: translate,
      d: "dan",
      dd: translate,
      M: "mjesec",
      MM: translate,
      y: "godinu",
      yy: translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return hr;
}));


/***/ }),

/***/ 4443:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var weekEndings = "vas\xE1rnap h\xE9tf\u0151n kedden szerd\xE1n cs\xFCt\xF6rt\xF6k\xF6n p\xE9nteken szombaton".split(" ");
  function translate(number, withoutSuffix, key, isFuture) {
    var num = number;
    switch (key) {
      case "s":
        return isFuture || withoutSuffix ? "n\xE9h\xE1ny m\xE1sodperc" : "n\xE9h\xE1ny m\xE1sodperce";
      case "ss":
        return num + (isFuture || withoutSuffix) ? " m\xE1sodperc" : " m\xE1sodperce";
      case "m":
        return "egy" + (isFuture || withoutSuffix ? " perc" : " perce");
      case "mm":
        return num + (isFuture || withoutSuffix ? " perc" : " perce");
      case "h":
        return "egy" + (isFuture || withoutSuffix ? " \xF3ra" : " \xF3r\xE1ja");
      case "hh":
        return num + (isFuture || withoutSuffix ? " \xF3ra" : " \xF3r\xE1ja");
      case "d":
        return "egy" + (isFuture || withoutSuffix ? " nap" : " napja");
      case "dd":
        return num + (isFuture || withoutSuffix ? " nap" : " napja");
      case "M":
        return "egy" + (isFuture || withoutSuffix ? " h\xF3nap" : " h\xF3napja");
      case "MM":
        return num + (isFuture || withoutSuffix ? " h\xF3nap" : " h\xF3napja");
      case "y":
        return "egy" + (isFuture || withoutSuffix ? " \xE9v" : " \xE9ve");
      case "yy":
        return num + (isFuture || withoutSuffix ? " \xE9v" : " \xE9ve");
    }
    return "";
  }
  function week(isFuture) {
    return (isFuture ? "" : "[m\xFAlt] ") + "[" + weekEndings[this.day()] + "] LT[-kor]";
  }
  var hu = moment.defineLocale("hu", {
    months: "janu\xE1r_febru\xE1r_m\xE1rcius_\xE1prilis_m\xE1jus_j\xFAnius_j\xFAlius_augusztus_szeptember_okt\xF3ber_november_december".split(
      "_"
    ),
    monthsShort: "jan._feb._m\xE1rc._\xE1pr._m\xE1j._j\xFAn._j\xFAl._aug._szept._okt._nov._dec.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "vas\xE1rnap_h\xE9tf\u0151_kedd_szerda_cs\xFCt\xF6rt\xF6k_p\xE9ntek_szombat".split("_"),
    weekdaysShort: "vas_h\xE9t_kedd_sze_cs\xFCt_p\xE9n_szo".split("_"),
    weekdaysMin: "v_h_k_sze_cs_p_szo".split("_"),
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "YYYY.MM.DD.",
      LL: "YYYY. MMMM D.",
      LLL: "YYYY. MMMM D. H:mm",
      LLLL: "YYYY. MMMM D., dddd H:mm"
    },
    meridiemParse: /de|du/i,
    isPM: function(input) {
      return input.charAt(1).toLowerCase() === "u";
    },
    meridiem: function(hours, minutes, isLower) {
      if (hours < 12) {
        return isLower === true ? "de" : "DE";
      } else {
        return isLower === true ? "du" : "DU";
      }
    },
    calendar: {
      sameDay: "[ma] LT[-kor]",
      nextDay: "[holnap] LT[-kor]",
      nextWeek: function() {
        return week.call(this, true);
      },
      lastDay: "[tegnap] LT[-kor]",
      lastWeek: function() {
        return week.call(this, false);
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "%s m\xFAlva",
      past: "%s",
      s: translate,
      ss: translate,
      m: translate,
      mm: translate,
      h: translate,
      hh: translate,
      d: translate,
      dd: translate,
      M: translate,
      MM: translate,
      y: translate,
      yy: translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return hu;
}));


/***/ }),

/***/ 91662:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var hyAm = moment.defineLocale("hy-am", {
    months: {
      format: "\u0570\u0578\u0582\u0576\u057E\u0561\u0580\u056B_\u0583\u0565\u057F\u0580\u057E\u0561\u0580\u056B_\u0574\u0561\u0580\u057F\u056B_\u0561\u057A\u0580\u056B\u056C\u056B_\u0574\u0561\u0575\u056B\u057D\u056B_\u0570\u0578\u0582\u0576\u056B\u057D\u056B_\u0570\u0578\u0582\u056C\u056B\u057D\u056B_\u0585\u0563\u0578\u057D\u057F\u0578\u057D\u056B_\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580\u056B_\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580\u056B_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580\u056B_\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580\u056B".split(
        "_"
      ),
      standalone: "\u0570\u0578\u0582\u0576\u057E\u0561\u0580_\u0583\u0565\u057F\u0580\u057E\u0561\u0580_\u0574\u0561\u0580\u057F_\u0561\u057A\u0580\u056B\u056C_\u0574\u0561\u0575\u056B\u057D_\u0570\u0578\u0582\u0576\u056B\u057D_\u0570\u0578\u0582\u056C\u056B\u057D_\u0585\u0563\u0578\u057D\u057F\u0578\u057D_\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580_\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580_\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580_\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580".split(
        "_"
      )
    },
    monthsShort: "\u0570\u0576\u057E_\u0583\u057F\u0580_\u0574\u0580\u057F_\u0561\u057A\u0580_\u0574\u0575\u057D_\u0570\u0576\u057D_\u0570\u056C\u057D_\u0585\u0563\u057D_\u057D\u057A\u057F_\u0570\u056F\u057F_\u0576\u0574\u0562_\u0564\u056F\u057F".split("_"),
    weekdays: "\u056F\u056B\u0580\u0561\u056F\u056B_\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B_\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B_\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B_\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B_\u0578\u0582\u0580\u0562\u0561\u0569_\u0577\u0561\u0562\u0561\u0569".split(
      "_"
    ),
    weekdaysShort: "\u056F\u0580\u056F_\u0565\u0580\u056F_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),
    weekdaysMin: "\u056F\u0580\u056F_\u0565\u0580\u056F_\u0565\u0580\u0584_\u0579\u0580\u0584_\u0570\u0576\u0563_\u0578\u0582\u0580\u0562_\u0577\u0562\u0569".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY \u0569.",
      LLL: "D MMMM YYYY \u0569., HH:mm",
      LLLL: "dddd, D MMMM YYYY \u0569., HH:mm"
    },
    calendar: {
      sameDay: "[\u0561\u0575\u057D\u0585\u0580] LT",
      nextDay: "[\u057E\u0561\u0572\u0568] LT",
      lastDay: "[\u0565\u0580\u0565\u056F] LT",
      nextWeek: function() {
        return "dddd [\u0585\u0580\u0568 \u056A\u0561\u0574\u0568] LT";
      },
      lastWeek: function() {
        return "[\u0561\u0576\u0581\u0561\u056E] dddd [\u0585\u0580\u0568 \u056A\u0561\u0574\u0568] LT";
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0570\u0565\u057F\u0578",
      past: "%s \u0561\u057C\u0561\u057B",
      s: "\u0574\u056B \u0584\u0561\u0576\u056B \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
      ss: "%d \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
      m: "\u0580\u0578\u057A\u0565",
      mm: "%d \u0580\u0578\u057A\u0565",
      h: "\u056A\u0561\u0574",
      hh: "%d \u056A\u0561\u0574",
      d: "\u0585\u0580",
      dd: "%d \u0585\u0580",
      M: "\u0561\u0574\u056B\u057D",
      MM: "%d \u0561\u0574\u056B\u057D",
      y: "\u057F\u0561\u0580\u056B",
      yy: "%d \u057F\u0561\u0580\u056B"
    },
    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
    isPM: function(input) {
      return /^(ցերեկվա|երեկոյան)$/.test(input);
    },
    meridiem: function(hour) {
      if (hour < 4) {
        return "\u0563\u056B\u0577\u0565\u0580\u057E\u0561";
      } else if (hour < 12) {
        return "\u0561\u057C\u0561\u057E\u0578\u057F\u057E\u0561";
      } else if (hour < 17) {
        return "\u0581\u0565\u0580\u0565\u056F\u057E\u0561";
      } else {
        return "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576";
      }
    },
    dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
    ordinal: function(number, period) {
      switch (period) {
        case "DDD":
        case "w":
        case "W":
        case "DDDo":
          if (number === 1) {
            return number + "-\u056B\u0576";
          }
          return number + "-\u0580\u0564";
        default:
          return number;
      }
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return hyAm;
}));


/***/ }),

/***/ 71969:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var id = moment.defineLocale("id", {
    months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),
    weekdays: "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
    weekdaysShort: "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
    weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),
    longDateFormat: {
      LT: "HH.mm",
      LTS: "HH.mm.ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY [pukul] HH.mm",
      LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
    },
    meridiemParse: /pagi|siang|sore|malam/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "pagi") {
        return hour;
      } else if (meridiem === "siang") {
        return hour >= 11 ? hour : hour + 12;
      } else if (meridiem === "sore" || meridiem === "malam") {
        return hour + 12;
      }
    },
    meridiem: function(hours, minutes, isLower) {
      if (hours < 11) {
        return "pagi";
      } else if (hours < 15) {
        return "siang";
      } else if (hours < 19) {
        return "sore";
      } else {
        return "malam";
      }
    },
    calendar: {
      sameDay: "[Hari ini pukul] LT",
      nextDay: "[Besok pukul] LT",
      nextWeek: "dddd [pukul] LT",
      lastDay: "[Kemarin pukul] LT",
      lastWeek: "dddd [lalu pukul] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "dalam %s",
      past: "%s yang lalu",
      s: "beberapa detik",
      ss: "%d detik",
      m: "semenit",
      mm: "%d menit",
      h: "sejam",
      hh: "%d jam",
      d: "sehari",
      dd: "%d hari",
      M: "sebulan",
      MM: "%d bulan",
      y: "setahun",
      yy: "%d tahun"
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return id;
}));


/***/ }),

/***/ 21252:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function plural(n) {
    if (n % 100 === 11) {
      return true;
    } else if (n % 10 === 1) {
      return false;
    }
    return true;
  }
  function translate(number, withoutSuffix, key, isFuture) {
    var result = number + " ";
    switch (key) {
      case "s":
        return withoutSuffix || isFuture ? "nokkrar sek\xFAndur" : "nokkrum sek\xFAndum";
      case "ss":
        if (plural(number)) {
          return result + (withoutSuffix || isFuture ? "sek\xFAndur" : "sek\xFAndum");
        }
        return result + "sek\xFAnda";
      case "m":
        return withoutSuffix ? "m\xEDn\xFAta" : "m\xEDn\xFAtu";
      case "mm":
        if (plural(number)) {
          return result + (withoutSuffix || isFuture ? "m\xEDn\xFAtur" : "m\xEDn\xFAtum");
        } else if (withoutSuffix) {
          return result + "m\xEDn\xFAta";
        }
        return result + "m\xEDn\xFAtu";
      case "hh":
        if (plural(number)) {
          return result + (withoutSuffix || isFuture ? "klukkustundir" : "klukkustundum");
        }
        return result + "klukkustund";
      case "d":
        if (withoutSuffix) {
          return "dagur";
        }
        return isFuture ? "dag" : "degi";
      case "dd":
        if (plural(number)) {
          if (withoutSuffix) {
            return result + "dagar";
          }
          return result + (isFuture ? "daga" : "d\xF6gum");
        } else if (withoutSuffix) {
          return result + "dagur";
        }
        return result + (isFuture ? "dag" : "degi");
      case "M":
        if (withoutSuffix) {
          return "m\xE1nu\xF0ur";
        }
        return isFuture ? "m\xE1nu\xF0" : "m\xE1nu\xF0i";
      case "MM":
        if (plural(number)) {
          if (withoutSuffix) {
            return result + "m\xE1nu\xF0ir";
          }
          return result + (isFuture ? "m\xE1nu\xF0i" : "m\xE1nu\xF0um");
        } else if (withoutSuffix) {
          return result + "m\xE1nu\xF0ur";
        }
        return result + (isFuture ? "m\xE1nu\xF0" : "m\xE1nu\xF0i");
      case "y":
        return withoutSuffix || isFuture ? "\xE1r" : "\xE1ri";
      case "yy":
        if (plural(number)) {
          return result + (withoutSuffix || isFuture ? "\xE1r" : "\xE1rum");
        }
        return result + (withoutSuffix || isFuture ? "\xE1r" : "\xE1ri");
    }
  }
  var is = moment.defineLocale("is", {
    months: "jan\xFAar_febr\xFAar_mars_apr\xEDl_ma\xED_j\xFAn\xED_j\xFAl\xED_\xE1g\xFAst_september_okt\xF3ber_n\xF3vember_desember".split(
      "_"
    ),
    monthsShort: "jan_feb_mar_apr_ma\xED_j\xFAn_j\xFAl_\xE1g\xFA_sep_okt_n\xF3v_des".split("_"),
    weekdays: "sunnudagur_m\xE1nudagur_\xFEri\xF0judagur_mi\xF0vikudagur_fimmtudagur_f\xF6studagur_laugardagur".split(
      "_"
    ),
    weekdaysShort: "sun_m\xE1n_\xFEri_mi\xF0_fim_f\xF6s_lau".split("_"),
    weekdaysMin: "Su_M\xE1_\xDEr_Mi_Fi_F\xF6_La".split("_"),
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY [kl.] H:mm",
      LLLL: "dddd, D. MMMM YYYY [kl.] H:mm"
    },
    calendar: {
      sameDay: "[\xED dag kl.] LT",
      nextDay: "[\xE1 morgun kl.] LT",
      nextWeek: "dddd [kl.] LT",
      lastDay: "[\xED g\xE6r kl.] LT",
      lastWeek: "[s\xED\xF0asta] dddd [kl.] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "eftir %s",
      past: "fyrir %s s\xED\xF0an",
      s: translate,
      ss: translate,
      m: translate,
      mm: translate,
      h: "klukkustund",
      hh: translate,
      d: translate,
      dd: translate,
      M: translate,
      MM: translate,
      y: translate,
      yy: translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return is;
}));


/***/ }),

/***/ 80237:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var itCh = moment.defineLocale("it-ch", {
    months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split(
      "_"
    ),
    monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
    weekdays: "domenica_luned\xEC_marted\xEC_mercoled\xEC_gioved\xEC_venerd\xEC_sabato".split(
      "_"
    ),
    weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
    weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Oggi alle] LT",
      nextDay: "[Domani alle] LT",
      nextWeek: "dddd [alle] LT",
      lastDay: "[Ieri alle] LT",
      lastWeek: function() {
        switch (this.day()) {
          case 0:
            return "[la scorsa] dddd [alle] LT";
          default:
            return "[lo scorso] dddd [alle] LT";
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: function(s) {
        return (/^[0-9].+$/.test(s) ? "tra" : "in") + " " + s;
      },
      past: "%s fa",
      s: "alcuni secondi",
      ss: "%d secondi",
      m: "un minuto",
      mm: "%d minuti",
      h: "un'ora",
      hh: "%d ore",
      d: "un giorno",
      dd: "%d giorni",
      M: "un mese",
      MM: "%d mesi",
      y: "un anno",
      yy: "%d anni"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: "%d\xBA",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return itCh;
}));


/***/ }),

/***/ 44977:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var it = moment.defineLocale("it", {
    months: "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split(
      "_"
    ),
    monthsShort: "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
    weekdays: "domenica_luned\xEC_marted\xEC_mercoled\xEC_gioved\xEC_venerd\xEC_sabato".split(
      "_"
    ),
    weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
    weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: function() {
        return "[Oggi a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
      },
      nextDay: function() {
        return "[Domani a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
      },
      nextWeek: function() {
        return "dddd [a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
      },
      lastDay: function() {
        return "[Ieri a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
      },
      lastWeek: function() {
        switch (this.day()) {
          case 0:
            return "[La scorsa] dddd [a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
          default:
            return "[Lo scorso] dddd [a" + (this.hours() > 1 ? "lle " : this.hours() === 0 ? " " : "ll'") + "]LT";
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "tra %s",
      past: "%s fa",
      s: "alcuni secondi",
      ss: "%d secondi",
      m: "un minuto",
      mm: "%d minuti",
      h: "un'ora",
      hh: "%d ore",
      d: "un giorno",
      dd: "%d giorni",
      w: "una settimana",
      ww: "%d settimane",
      M: "un mese",
      MM: "%d mesi",
      y: "un anno",
      yy: "%d anni"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: "%d\xBA",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return it;
}));


/***/ }),

/***/ 7641:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var ja = moment.defineLocale("ja", {
    eras: [
      {
        since: "2019-05-01",
        offset: 1,
        name: "\u4EE4\u548C",
        narrow: "\u32FF",
        abbr: "R"
      },
      {
        since: "1989-01-08",
        until: "2019-04-30",
        offset: 1,
        name: "\u5E73\u6210",
        narrow: "\u337B",
        abbr: "H"
      },
      {
        since: "1926-12-25",
        until: "1989-01-07",
        offset: 1,
        name: "\u662D\u548C",
        narrow: "\u337C",
        abbr: "S"
      },
      {
        since: "1912-07-30",
        until: "1926-12-24",
        offset: 1,
        name: "\u5927\u6B63",
        narrow: "\u337D",
        abbr: "T"
      },
      {
        since: "1873-01-01",
        until: "1912-07-29",
        offset: 6,
        name: "\u660E\u6CBB",
        narrow: "\u337E",
        abbr: "M"
      },
      {
        since: "0001-01-01",
        until: "1873-12-31",
        offset: 1,
        name: "\u897F\u66A6",
        narrow: "AD",
        abbr: "AD"
      },
      {
        since: "0000-12-31",
        until: -Infinity,
        offset: 1,
        name: "\u7D00\u5143\u524D",
        narrow: "BC",
        abbr: "BC"
      }
    ],
    eraYearOrdinalRegex: /(元|\d+)年/,
    eraYearOrdinalParse: function(input, match) {
      return match[1] === "\u5143" ? 1 : parseInt(match[1] || input, 10);
    },
    months: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split("_"),
    monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
      "_"
    ),
    weekdays: "\u65E5\u66DC\u65E5_\u6708\u66DC\u65E5_\u706B\u66DC\u65E5_\u6C34\u66DC\u65E5_\u6728\u66DC\u65E5_\u91D1\u66DC\u65E5_\u571F\u66DC\u65E5".split("_"),
    weekdaysShort: "\u65E5_\u6708_\u706B_\u6C34_\u6728_\u91D1_\u571F".split("_"),
    weekdaysMin: "\u65E5_\u6708_\u706B_\u6C34_\u6728_\u91D1_\u571F".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY/MM/DD",
      LL: "YYYY\u5E74M\u6708D\u65E5",
      LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
      LLLL: "YYYY\u5E74M\u6708D\u65E5 dddd HH:mm",
      l: "YYYY/MM/DD",
      ll: "YYYY\u5E74M\u6708D\u65E5",
      lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
      llll: "YYYY\u5E74M\u6708D\u65E5(ddd) HH:mm"
    },
    meridiemParse: /午前|午後/i,
    isPM: function(input) {
      return input === "\u5348\u5F8C";
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u5348\u524D";
      } else {
        return "\u5348\u5F8C";
      }
    },
    calendar: {
      sameDay: "[\u4ECA\u65E5] LT",
      nextDay: "[\u660E\u65E5] LT",
      nextWeek: function(now) {
        if (now.week() !== this.week()) {
          return "[\u6765\u9031]dddd LT";
        } else {
          return "dddd LT";
        }
      },
      lastDay: "[\u6628\u65E5] LT",
      lastWeek: function(now) {
        if (this.week() !== now.week()) {
          return "[\u5148\u9031]dddd LT";
        } else {
          return "dddd LT";
        }
      },
      sameElse: "L"
    },
    dayOfMonthOrdinalParse: /\d{1,2}日/,
    ordinal: function(number, period) {
      switch (period) {
        case "y":
          return number === 1 ? "\u5143\u5E74" : number + "\u5E74";
        case "d":
        case "D":
        case "DDD":
          return number + "\u65E5";
        default:
          return number;
      }
    },
    relativeTime: {
      future: "%s\u5F8C",
      past: "%s\u524D",
      s: "\u6570\u79D2",
      ss: "%d\u79D2",
      m: "1\u5206",
      mm: "%d\u5206",
      h: "1\u6642\u9593",
      hh: "%d\u6642\u9593",
      d: "1\u65E5",
      dd: "%d\u65E5",
      M: "1\u30F6\u6708",
      MM: "%d\u30F6\u6708",
      y: "1\u5E74",
      yy: "%d\u5E74"
    }
  });
  return ja;
}));


/***/ }),

/***/ 63196:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var jv = moment.defineLocale("jv", {
    months: "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),
    weekdays: "Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),
    weekdaysShort: "Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),
    weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),
    longDateFormat: {
      LT: "HH.mm",
      LTS: "HH.mm.ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY [pukul] HH.mm",
      LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
    },
    meridiemParse: /enjing|siyang|sonten|ndalu/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "enjing") {
        return hour;
      } else if (meridiem === "siyang") {
        return hour >= 11 ? hour : hour + 12;
      } else if (meridiem === "sonten" || meridiem === "ndalu") {
        return hour + 12;
      }
    },
    meridiem: function(hours, minutes, isLower) {
      if (hours < 11) {
        return "enjing";
      } else if (hours < 15) {
        return "siyang";
      } else if (hours < 19) {
        return "sonten";
      } else {
        return "ndalu";
      }
    },
    calendar: {
      sameDay: "[Dinten puniko pukul] LT",
      nextDay: "[Mbenjang pukul] LT",
      nextWeek: "dddd [pukul] LT",
      lastDay: "[Kala wingi pukul] LT",
      lastWeek: "dddd [kepengker pukul] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "wonten ing %s",
      past: "%s ingkang kepengker",
      s: "sawetawis detik",
      ss: "%d detik",
      m: "setunggal menit",
      mm: "%d menit",
      h: "setunggal jam",
      hh: "%d jam",
      d: "sedinten",
      dd: "%d dinten",
      M: "sewulan",
      MM: "%d wulan",
      y: "setaun",
      yy: "%d taun"
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return jv;
}));


/***/ }),

/***/ 16208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var ka = moment.defineLocale("ka", {
    months: "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8_\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8_\u10DB\u10D0\u10E0\u10E2\u10D8_\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8_\u10DB\u10D0\u10D8\u10E1\u10D8_\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8_\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8_\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD_\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8_\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8_\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8_\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8".split(
      "_"
    ),
    monthsShort: "\u10D8\u10D0\u10DC_\u10D7\u10D4\u10D1_\u10DB\u10D0\u10E0_\u10D0\u10DE\u10E0_\u10DB\u10D0\u10D8_\u10D8\u10D5\u10DC_\u10D8\u10D5\u10DA_\u10D0\u10D2\u10D5_\u10E1\u10D4\u10E5_\u10DD\u10E5\u10E2_\u10DC\u10DD\u10D4_\u10D3\u10D4\u10D9".split("_"),
    weekdays: {
      standalone: "\u10D9\u10D5\u10D8\u10E0\u10D0_\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8_\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8_\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8_\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8_\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8_\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8".split(
        "_"
      ),
      format: "\u10D9\u10D5\u10D8\u10E0\u10D0\u10E1_\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1_\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1_\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1_\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1_\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10E1_\u10E8\u10D0\u10D1\u10D0\u10D7\u10E1".split(
        "_"
      ),
      isFormat: /(წინა|შემდეგ)/
    },
    weekdaysShort: "\u10D9\u10D5\u10D8_\u10DD\u10E0\u10E8_\u10E1\u10D0\u10DB_\u10DD\u10D7\u10EE_\u10EE\u10E3\u10D7_\u10DE\u10D0\u10E0_\u10E8\u10D0\u10D1".split("_"),
    weekdaysMin: "\u10D9\u10D5_\u10DD\u10E0_\u10E1\u10D0_\u10DD\u10D7_\u10EE\u10E3_\u10DE\u10D0_\u10E8\u10D0".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[\u10D3\u10E6\u10D4\u10E1] LT[-\u10D6\u10D4]",
      nextDay: "[\u10EE\u10D5\u10D0\u10DA] LT[-\u10D6\u10D4]",
      lastDay: "[\u10D2\u10E3\u10E8\u10D8\u10DC] LT[-\u10D6\u10D4]",
      nextWeek: "[\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2] dddd LT[-\u10D6\u10D4]",
      lastWeek: "[\u10EC\u10D8\u10DC\u10D0] dddd LT-\u10D6\u10D4",
      sameElse: "L"
    },
    relativeTime: {
      future: function(s) {
        return s.replace(
          /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
          function($0, $1, $2) {
            return $2 === "\u10D8" ? $1 + "\u10E8\u10D8" : $1 + $2 + "\u10E8\u10D8";
          }
        );
      },
      past: function(s) {
        if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
          return s.replace(/(ი|ე)$/, "\u10D8\u10E1 \u10EC\u10D8\u10DC");
        }
        if (/წელი/.test(s)) {
          return s.replace(/წელი$/, "\u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC");
        }
        return s;
      },
      s: "\u10E0\u10D0\u10DB\u10D3\u10D4\u10DC\u10D8\u10DB\u10D4 \u10EC\u10D0\u10DB\u10D8",
      ss: "%d \u10EC\u10D0\u10DB\u10D8",
      m: "\u10EC\u10E3\u10D7\u10D8",
      mm: "%d \u10EC\u10E3\u10D7\u10D8",
      h: "\u10E1\u10D0\u10D0\u10D7\u10D8",
      hh: "%d \u10E1\u10D0\u10D0\u10D7\u10D8",
      d: "\u10D3\u10E6\u10D4",
      dd: "%d \u10D3\u10E6\u10D4",
      M: "\u10D7\u10D5\u10D4",
      MM: "%d \u10D7\u10D5\u10D4",
      y: "\u10EC\u10D4\u10DA\u10D8",
      yy: "%d \u10EC\u10D4\u10DA\u10D8"
    },
    dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
    ordinal: function(number) {
      if (number === 0) {
        return number;
      }
      if (number === 1) {
        return number + "-\u10DA\u10D8";
      }
      if (number < 20 || number <= 100 && number % 20 === 0 || number % 100 === 0) {
        return "\u10DB\u10D4-" + number;
      }
      return number + "-\u10D4";
    },
    week: {
      dow: 1,
      doy: 7
    }
  });
  return ka;
}));


/***/ }),

/***/ 4738:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var suffixes = {
    0: "-\u0448\u0456",
    1: "-\u0448\u0456",
    2: "-\u0448\u0456",
    3: "-\u0448\u0456",
    4: "-\u0448\u0456",
    5: "-\u0448\u0456",
    6: "-\u0448\u044B",
    7: "-\u0448\u0456",
    8: "-\u0448\u0456",
    9: "-\u0448\u044B",
    10: "-\u0448\u044B",
    20: "-\u0448\u044B",
    30: "-\u0448\u044B",
    40: "-\u0448\u044B",
    50: "-\u0448\u0456",
    60: "-\u0448\u044B",
    70: "-\u0448\u0456",
    80: "-\u0448\u0456",
    90: "-\u0448\u044B",
    100: "-\u0448\u0456"
  };
  var kk = moment.defineLocale("kk", {
    months: "\u049B\u0430\u04A3\u0442\u0430\u0440_\u0430\u049B\u043F\u0430\u043D_\u043D\u0430\u0443\u0440\u044B\u0437_\u0441\u04D9\u0443\u0456\u0440_\u043C\u0430\u043C\u044B\u0440_\u043C\u0430\u0443\u0441\u044B\u043C_\u0448\u0456\u043B\u0434\u0435_\u0442\u0430\u043C\u044B\u0437_\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A_\u049B\u0430\u0437\u0430\u043D_\u049B\u0430\u0440\u0430\u0448\u0430_\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D".split(
      "_"
    ),
    monthsShort: "\u049B\u0430\u04A3_\u0430\u049B\u043F_\u043D\u0430\u0443_\u0441\u04D9\u0443_\u043C\u0430\u043C_\u043C\u0430\u0443_\u0448\u0456\u043B_\u0442\u0430\u043C_\u049B\u044B\u0440_\u049B\u0430\u0437_\u049B\u0430\u0440_\u0436\u0435\u043B".split("_"),
    weekdays: "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456_\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456_\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456_\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456_\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456_\u0436\u04B1\u043C\u0430_\u0441\u0435\u043D\u0431\u0456".split(
      "_"
    ),
    weekdaysShort: "\u0436\u0435\u043A_\u0434\u04AF\u0439_\u0441\u0435\u0439_\u0441\u04D9\u0440_\u0431\u0435\u0439_\u0436\u04B1\u043C_\u0441\u0435\u043D".split("_"),
    weekdaysMin: "\u0436\u043A_\u0434\u0439_\u0441\u0439_\u0441\u0440_\u0431\u0439_\u0436\u043C_\u0441\u043D".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[\u0411\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442] LT",
      nextDay: "[\u0415\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442] LT",
      nextWeek: "dddd [\u0441\u0430\u0493\u0430\u0442] LT",
      lastDay: "[\u041A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442] LT",
      lastWeek: "[\u04E8\u0442\u043A\u0435\u043D \u0430\u043F\u0442\u0430\u043D\u044B\u04A3] dddd [\u0441\u0430\u0493\u0430\u0442] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0456\u0448\u0456\u043D\u0434\u0435",
      past: "%s \u0431\u04B1\u0440\u044B\u043D",
      s: "\u0431\u0456\u0440\u043D\u0435\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434",
      ss: "%d \u0441\u0435\u043A\u0443\u043D\u0434",
      m: "\u0431\u0456\u0440 \u043C\u0438\u043D\u0443\u0442",
      mm: "%d \u043C\u0438\u043D\u0443\u0442",
      h: "\u0431\u0456\u0440 \u0441\u0430\u0493\u0430\u0442",
      hh: "%d \u0441\u0430\u0493\u0430\u0442",
      d: "\u0431\u0456\u0440 \u043A\u04AF\u043D",
      dd: "%d \u043A\u04AF\u043D",
      M: "\u0431\u0456\u0440 \u0430\u0439",
      MM: "%d \u0430\u0439",
      y: "\u0431\u0456\u0440 \u0436\u044B\u043B",
      yy: "%d \u0436\u044B\u043B"
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
    ordinal: function(number) {
      var a = number % 10, b = number >= 100 ? 100 : null;
      return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return kk;
}));


/***/ }),

/***/ 3223:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u17E1",
    2: "\u17E2",
    3: "\u17E3",
    4: "\u17E4",
    5: "\u17E5",
    6: "\u17E6",
    7: "\u17E7",
    8: "\u17E8",
    9: "\u17E9",
    0: "\u17E0"
  }, numberMap = {
    "\u17E1": "1",
    "\u17E2": "2",
    "\u17E3": "3",
    "\u17E4": "4",
    "\u17E5": "5",
    "\u17E6": "6",
    "\u17E7": "7",
    "\u17E8": "8",
    "\u17E9": "9",
    "\u17E0": "0"
  };
  var km = moment.defineLocale("km", {
    months: "\u1798\u1780\u179A\u17B6_\u1780\u17BB\u1798\u17D2\u1797\u17C8_\u1798\u17B8\u1793\u17B6_\u1798\u17C1\u179F\u17B6_\u17A7\u179F\u1797\u17B6_\u1798\u17B7\u1790\u17BB\u1793\u17B6_\u1780\u1780\u17D2\u1780\u178A\u17B6_\u179F\u17B8\u17A0\u17B6_\u1780\u1789\u17D2\u1789\u17B6_\u178F\u17BB\u179B\u17B6_\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6_\u1792\u17D2\u1793\u17BC".split(
      "_"
    ),
    monthsShort: "\u1798\u1780\u179A\u17B6_\u1780\u17BB\u1798\u17D2\u1797\u17C8_\u1798\u17B8\u1793\u17B6_\u1798\u17C1\u179F\u17B6_\u17A7\u179F\u1797\u17B6_\u1798\u17B7\u1790\u17BB\u1793\u17B6_\u1780\u1780\u17D2\u1780\u178A\u17B6_\u179F\u17B8\u17A0\u17B6_\u1780\u1789\u17D2\u1789\u17B6_\u178F\u17BB\u179B\u17B6_\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6_\u1792\u17D2\u1793\u17BC".split(
      "_"
    ),
    weekdays: "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799_\u1785\u17D0\u1793\u17D2\u1791_\u17A2\u1784\u17D2\u1782\u17B6\u179A_\u1796\u17BB\u1792_\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD_\u179F\u17BB\u1780\u17D2\u179A_\u179F\u17C5\u179A\u17CD".split("_"),
    weekdaysShort: "\u17A2\u17B6_\u1785_\u17A2_\u1796_\u1796\u17D2\u179A_\u179F\u17BB_\u179F".split("_"),
    weekdaysMin: "\u17A2\u17B6_\u1785_\u17A2_\u1796_\u1796\u17D2\u179A_\u179F\u17BB_\u179F".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    meridiemParse: /ព្រឹក|ល្ងាច/,
    isPM: function(input) {
      return input === "\u179B\u17D2\u1784\u17B6\u1785";
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u1796\u17D2\u179A\u17B9\u1780";
      } else {
        return "\u179B\u17D2\u1784\u17B6\u1785";
      }
    },
    calendar: {
      sameDay: "[\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7 \u1798\u17C9\u17C4\u1784] LT",
      nextDay: "[\u179F\u17D2\u17A2\u17C2\u1780 \u1798\u17C9\u17C4\u1784] LT",
      nextWeek: "dddd [\u1798\u17C9\u17C4\u1784] LT",
      lastDay: "[\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789 \u1798\u17C9\u17C4\u1784] LT",
      lastWeek: "dddd [\u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD\u1798\u17BB\u1793] [\u1798\u17C9\u17C4\u1784] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s\u1791\u17C0\u178F",
      past: "%s\u1798\u17BB\u1793",
      s: "\u1794\u17C9\u17BB\u1793\u17D2\u1798\u17B6\u1793\u179C\u17B7\u1793\u17B6\u1791\u17B8",
      ss: "%d \u179C\u17B7\u1793\u17B6\u1791\u17B8",
      m: "\u1798\u17BD\u1799\u1793\u17B6\u1791\u17B8",
      mm: "%d \u1793\u17B6\u1791\u17B8",
      h: "\u1798\u17BD\u1799\u1798\u17C9\u17C4\u1784",
      hh: "%d \u1798\u17C9\u17C4\u1784",
      d: "\u1798\u17BD\u1799\u1790\u17D2\u1784\u17C3",
      dd: "%d \u1790\u17D2\u1784\u17C3",
      M: "\u1798\u17BD\u1799\u1781\u17C2",
      MM: "%d \u1781\u17C2",
      y: "\u1798\u17BD\u1799\u1786\u17D2\u1793\u17B6\u17C6",
      yy: "%d \u1786\u17D2\u1793\u17B6\u17C6"
    },
    dayOfMonthOrdinalParse: /ទី\d{1,2}/,
    ordinal: "\u1791\u17B8%d",
    preparse: function(string) {
      return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function(match) {
        return numberMap[match];
      });
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      });
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return km;
}));


/***/ }),

/***/ 50189:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u0CE7",
    2: "\u0CE8",
    3: "\u0CE9",
    4: "\u0CEA",
    5: "\u0CEB",
    6: "\u0CEC",
    7: "\u0CED",
    8: "\u0CEE",
    9: "\u0CEF",
    0: "\u0CE6"
  }, numberMap = {
    "\u0CE7": "1",
    "\u0CE8": "2",
    "\u0CE9": "3",
    "\u0CEA": "4",
    "\u0CEB": "5",
    "\u0CEC": "6",
    "\u0CED": "7",
    "\u0CEE": "8",
    "\u0CEF": "9",
    "\u0CE6": "0"
  };
  var kn = moment.defineLocale("kn", {
    months: "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF_\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF_\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD_\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD_\u0CAE\u0CC6\u0CD5_\u0C9C\u0CC2\u0CA8\u0CCD_\u0C9C\u0CC1\u0CB2\u0CC6\u0CD6_\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD_\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD_\u0C85\u0C95\u0CCD\u0C9F\u0CC6\u0CC2\u0CD5\u0CAC\u0CB0\u0CCD_\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD_\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD".split(
      "_"
    ),
    monthsShort: "\u0C9C\u0CA8_\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0_\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD_\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD_\u0CAE\u0CC6\u0CD5_\u0C9C\u0CC2\u0CA8\u0CCD_\u0C9C\u0CC1\u0CB2\u0CC6\u0CD6_\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD_\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82_\u0C85\u0C95\u0CCD\u0C9F\u0CC6\u0CC2\u0CD5_\u0CA8\u0CB5\u0CC6\u0C82_\u0CA1\u0CBF\u0CB8\u0CC6\u0C82".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0_\u0CB8\u0CC6\u0CC2\u0CD5\u0CAE\u0CB5\u0CBE\u0CB0_\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0_\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0_\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0_\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0_\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0".split(
      "_"
    ),
    weekdaysShort: "\u0CAD\u0CBE\u0CA8\u0CC1_\u0CB8\u0CC6\u0CC2\u0CD5\u0CAE_\u0CAE\u0C82\u0C97\u0CB3_\u0CAC\u0CC1\u0CA7_\u0C97\u0CC1\u0CB0\u0CC1_\u0CB6\u0CC1\u0C95\u0CCD\u0CB0_\u0CB6\u0CA8\u0CBF".split("_"),
    weekdaysMin: "\u0CAD\u0CBE_\u0CB8\u0CC6\u0CC2\u0CD5_\u0CAE\u0C82_\u0CAC\u0CC1_\u0C97\u0CC1_\u0CB6\u0CC1_\u0CB6".split("_"),
    longDateFormat: {
      LT: "A h:mm",
      LTS: "A h:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, A h:mm",
      LLLL: "dddd, D MMMM YYYY, A h:mm"
    },
    calendar: {
      sameDay: "[\u0C87\u0C82\u0CA6\u0CC1] LT",
      nextDay: "[\u0CA8\u0CBE\u0CB3\u0CC6] LT",
      nextWeek: "dddd, LT",
      lastDay: "[\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6] LT",
      lastWeek: "[\u0C95\u0CC6\u0CC2\u0CA8\u0CC6\u0CAF] dddd, LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0CA8\u0C82\u0CA4\u0CB0",
      past: "%s \u0CB9\u0CBF\u0C82\u0CA6\u0CC6",
      s: "\u0C95\u0CC6\u0CB2\u0CB5\u0CC1 \u0C95\u0CCD\u0CB7\u0CA3\u0C97\u0CB3\u0CC1",
      ss: "%d \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
      m: "\u0C92\u0C82\u0CA6\u0CC1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
      mm: "%d \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
      h: "\u0C92\u0C82\u0CA6\u0CC1 \u0C97\u0C82\u0C9F\u0CC6",
      hh: "%d \u0C97\u0C82\u0C9F\u0CC6",
      d: "\u0C92\u0C82\u0CA6\u0CC1 \u0CA6\u0CBF\u0CA8",
      dd: "%d \u0CA6\u0CBF\u0CA8",
      M: "\u0C92\u0C82\u0CA6\u0CC1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
      MM: "%d \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
      y: "\u0C92\u0C82\u0CA6\u0CC1 \u0CB5\u0CB0\u0CCD\u0CB7",
      yy: "%d \u0CB5\u0CB0\u0CCD\u0CB7"
    },
    preparse: function(string) {
      return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function(match) {
        return numberMap[match];
      });
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      });
    },
    meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF") {
        return hour < 4 ? hour : hour + 12;
      } else if (meridiem === "\u0CAC\u0CC6\u0CB3\u0CBF\u0C97\u0CCD\u0C97\u0CC6") {
        return hour;
      } else if (meridiem === "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8") {
        return hour >= 10 ? hour : hour + 12;
      } else if (meridiem === "\u0CB8\u0C82\u0C9C\u0CC6") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF";
      } else if (hour < 10) {
        return "\u0CAC\u0CC6\u0CB3\u0CBF\u0C97\u0CCD\u0C97\u0CC6";
      } else if (hour < 17) {
        return "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8";
      } else if (hour < 20) {
        return "\u0CB8\u0C82\u0C9C\u0CC6";
      } else {
        return "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF";
      }
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
    ordinal: function(number) {
      return number + "\u0CA8\u0CC6\u0CD5";
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return kn;
}));


/***/ }),

/***/ 89486:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var ko = moment.defineLocale("ko", {
    months: "1\uC6D4_2\uC6D4_3\uC6D4_4\uC6D4_5\uC6D4_6\uC6D4_7\uC6D4_8\uC6D4_9\uC6D4_10\uC6D4_11\uC6D4_12\uC6D4".split("_"),
    monthsShort: "1\uC6D4_2\uC6D4_3\uC6D4_4\uC6D4_5\uC6D4_6\uC6D4_7\uC6D4_8\uC6D4_9\uC6D4_10\uC6D4_11\uC6D4_12\uC6D4".split(
      "_"
    ),
    weekdays: "\uC77C\uC694\uC77C_\uC6D4\uC694\uC77C_\uD654\uC694\uC77C_\uC218\uC694\uC77C_\uBAA9\uC694\uC77C_\uAE08\uC694\uC77C_\uD1A0\uC694\uC77C".split("_"),
    weekdaysShort: "\uC77C_\uC6D4_\uD654_\uC218_\uBAA9_\uAE08_\uD1A0".split("_"),
    weekdaysMin: "\uC77C_\uC6D4_\uD654_\uC218_\uBAA9_\uAE08_\uD1A0".split("_"),
    longDateFormat: {
      LT: "A h:mm",
      LTS: "A h:mm:ss",
      L: "YYYY.MM.DD.",
      LL: "YYYY\uB144 MMMM D\uC77C",
      LLL: "YYYY\uB144 MMMM D\uC77C A h:mm",
      LLLL: "YYYY\uB144 MMMM D\uC77C dddd A h:mm",
      l: "YYYY.MM.DD.",
      ll: "YYYY\uB144 MMMM D\uC77C",
      lll: "YYYY\uB144 MMMM D\uC77C A h:mm",
      llll: "YYYY\uB144 MMMM D\uC77C dddd A h:mm"
    },
    calendar: {
      sameDay: "\uC624\uB298 LT",
      nextDay: "\uB0B4\uC77C LT",
      nextWeek: "dddd LT",
      lastDay: "\uC5B4\uC81C LT",
      lastWeek: "\uC9C0\uB09C\uC8FC dddd LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \uD6C4",
      past: "%s \uC804",
      s: "\uBA87 \uCD08",
      ss: "%d\uCD08",
      m: "1\uBD84",
      mm: "%d\uBD84",
      h: "\uD55C \uC2DC\uAC04",
      hh: "%d\uC2DC\uAC04",
      d: "\uD558\uB8E8",
      dd: "%d\uC77C",
      M: "\uD55C \uB2EC",
      MM: "%d\uB2EC",
      y: "\uC77C \uB144",
      yy: "%d\uB144"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
    ordinal: function(number, period) {
      switch (period) {
        case "d":
        case "D":
        case "DDD":
          return number + "\uC77C";
        case "M":
          return number + "\uC6D4";
        case "w":
        case "W":
          return number + "\uC8FC";
        default:
          return number;
      }
    },
    meridiemParse: /오전|오후/,
    isPM: function(token) {
      return token === "\uC624\uD6C4";
    },
    meridiem: function(hour, minute, isUpper) {
      return hour < 12 ? "\uC624\uC804" : "\uC624\uD6C4";
    }
  });
  return ko;
}));


/***/ }),

/***/ 80235:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Kurdish [ku-kmr]
//! authors : Mazlum Özdogan : https://github.com/mergehez
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function processRelativeTime(num, withoutSuffix, key, isFuture) {
    var format = {
      s: ["\xE7end san\xEEye", "\xE7end san\xEEyeyan"],
      ss: [num + " san\xEEye", num + " san\xEEyeyan"],
      m: ["deq\xEEqeyek", "deq\xEEqeyek\xEA"],
      mm: [num + " deq\xEEqe", num + " deq\xEEqeyan"],
      h: ["saetek", "saetek\xEA"],
      hh: [num + " saet", num + " saetan"],
      d: ["rojek", "rojek\xEA"],
      dd: [num + " roj", num + " rojan"],
      w: ["hefteyek", "hefteyek\xEA"],
      ww: [num + " hefte", num + " hefteyan"],
      M: ["mehek", "mehek\xEA"],
      MM: [num + " meh", num + " mehan"],
      y: ["salek", "salek\xEA"],
      yy: [num + " sal", num + " salan"]
    };
    return withoutSuffix ? format[key][0] : format[key][1];
  }
  function ezafeNumSuffix(num) {
    num = "" + num;
    var l = num.substring(num.length - 1), ll = num.length > 1 ? num.substring(num.length - 2) : "";
    if (!(ll == 12 || ll == 13) && (l == "2" || l == "3" || ll == "50" || l == "70" || l == "80"))
      return "y\xEA";
    return "\xEA";
  }
  var kuKmr = moment.defineLocale("ku-kmr", {
    // According to the spelling rules defined by the work group of Weqfa Mezopotamyayê (Mesopotamia Foundation)
    // this should be: 'Kanûna Paşîn_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Çirîya Pêşîn_Çirîya Paşîn_Kanûna Pêşîn'
    // But the names below are more well known and handy
    months: "R\xEAbendan_Sibat_Adar_N\xEEsan_Gulan_Hez\xEEran_T\xEErmeh_Tebax_\xCElon_Cotmeh_Mijdar_Berfanbar".split(
      "_"
    ),
    monthsShort: "R\xEAb_Sib_Ada_N\xEEs_Gul_Hez_T\xEEr_Teb_\xCElo_Cot_Mij_Ber".split("_"),
    monthsParseExact: true,
    weekdays: "Yek\u015Fem_Du\u015Fem_S\xEA\u015Fem_\xC7ar\u015Fem_P\xEAnc\u015Fem_\xCEn_\u015Eem\xEE".split("_"),
    weekdaysShort: "Yek_Du_S\xEA_\xC7ar_P\xEAn_\xCEn_\u015Eem".split("_"),
    weekdaysMin: "Ye_Du_S\xEA_\xC7a_P\xEA_\xCEn_\u015Ee".split("_"),
    meridiem: function(hours, minutes, isLower) {
      if (hours < 12) {
        return isLower ? "bn" : "BN";
      } else {
        return isLower ? "pn" : "PN";
      }
    },
    meridiemParse: /bn|BN|pn|PN/,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "Do MMMM[a] YYYY[an]",
      LLL: "Do MMMM[a] YYYY[an] HH:mm",
      LLLL: "dddd, Do MMMM[a] YYYY[an] HH:mm",
      ll: "Do MMM[.] YYYY[an]",
      lll: "Do MMM[.] YYYY[an] HH:mm",
      llll: "ddd[.], Do MMM[.] YYYY[an] HH:mm"
    },
    calendar: {
      sameDay: "[\xCEro di saet] LT [de]",
      nextDay: "[Sib\xEA di saet] LT [de]",
      nextWeek: "dddd [di saet] LT [de]",
      lastDay: "[Duh di saet] LT [de]",
      lastWeek: "dddd[a bor\xEE di saet] LT [de]",
      sameElse: "L"
    },
    relativeTime: {
      future: "di %s de",
      past: "ber\xEE %s",
      s: processRelativeTime,
      ss: processRelativeTime,
      m: processRelativeTime,
      mm: processRelativeTime,
      h: processRelativeTime,
      hh: processRelativeTime,
      d: processRelativeTime,
      dd: processRelativeTime,
      w: processRelativeTime,
      ww: processRelativeTime,
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
    ordinal: function(num, period) {
      var p = period.toLowerCase();
      if (p.includes("w") || p.includes("m")) return num + ".";
      return num + ezafeNumSuffix(num);
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return kuKmr;
}));


/***/ }),

/***/ 27948:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u0661",
    2: "\u0662",
    3: "\u0663",
    4: "\u0664",
    5: "\u0665",
    6: "\u0666",
    7: "\u0667",
    8: "\u0668",
    9: "\u0669",
    0: "\u0660"
  }, numberMap = {
    "\u0661": "1",
    "\u0662": "2",
    "\u0663": "3",
    "\u0664": "4",
    "\u0665": "5",
    "\u0666": "6",
    "\u0667": "7",
    "\u0668": "8",
    "\u0669": "9",
    "\u0660": "0"
  }, months = [
    "\u06A9\u0627\u0646\u0648\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
    "\u0634\u0648\u0628\u0627\u062A",
    "\u0626\u0627\u0632\u0627\u0631",
    "\u0646\u06CC\u0633\u0627\u0646",
    "\u0626\u0627\u06CC\u0627\u0631",
    "\u062D\u0648\u0632\u06D5\u06CC\u0631\u0627\u0646",
    "\u062A\u06D5\u0645\u0645\u0648\u0632",
    "\u0626\u0627\u0628",
    "\u0626\u06D5\u06CC\u0644\u0648\u0648\u0644",
    "\u062A\u0634\u0631\u06CC\u0646\u06CC \u06CC\u06D5\u0643\u06D5\u0645",
    "\u062A\u0634\u0631\u06CC\u0646\u06CC \u062F\u0648\u0648\u06D5\u0645",
    "\u0643\u0627\u0646\u0648\u0646\u06CC \u06CC\u06D5\u06A9\u06D5\u0645"
  ];
  var ku = moment.defineLocale("ku", {
    months,
    monthsShort: months,
    weekdays: "\u06CC\u0647\u200C\u0643\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u062F\u0648\u0648\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u0633\u06CE\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u0686\u0648\u0627\u0631\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u067E\u06CE\u0646\u062C\u0634\u0647\u200C\u0645\u0645\u0647\u200C_\u0647\u0647\u200C\u06CC\u0646\u06CC_\u0634\u0647\u200C\u0645\u0645\u0647\u200C".split(
      "_"
    ),
    weekdaysShort: "\u06CC\u0647\u200C\u0643\u0634\u0647\u200C\u0645_\u062F\u0648\u0648\u0634\u0647\u200C\u0645_\u0633\u06CE\u0634\u0647\u200C\u0645_\u0686\u0648\u0627\u0631\u0634\u0647\u200C\u0645_\u067E\u06CE\u0646\u062C\u0634\u0647\u200C\u0645_\u0647\u0647\u200C\u06CC\u0646\u06CC_\u0634\u0647\u200C\u0645\u0645\u0647\u200C".split("_"),
    weekdaysMin: "\u06CC_\u062F_\u0633_\u0686_\u067E_\u0647_\u0634".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    meridiemParse: /ئێواره‌|به‌یانی/,
    isPM: function(input) {
      return /ئێواره‌/.test(input);
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u0628\u0647\u200C\u06CC\u0627\u0646\u06CC";
      } else {
        return "\u0626\u06CE\u0648\u0627\u0631\u0647\u200C";
      }
    },
    calendar: {
      sameDay: "[\u0626\u0647\u200C\u0645\u0631\u06C6 \u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
      nextDay: "[\u0628\u0647\u200C\u06CC\u0627\u0646\u06CC \u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
      nextWeek: "dddd [\u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
      lastDay: "[\u062F\u0648\u06CE\u0646\u06CE \u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
      lastWeek: "dddd [\u0643\u0627\u062A\u0698\u0645\u06CE\u0631] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0644\u0647\u200C %s",
      past: "%s",
      s: "\u0686\u0647\u200C\u0646\u062F \u0686\u0631\u0643\u0647\u200C\u06CC\u0647\u200C\u0643",
      ss: "\u0686\u0631\u0643\u0647\u200C %d",
      m: "\u06CC\u0647\u200C\u0643 \u062E\u0648\u0644\u0647\u200C\u0643",
      mm: "%d \u062E\u0648\u0644\u0647\u200C\u0643",
      h: "\u06CC\u0647\u200C\u0643 \u0643\u0627\u062A\u0698\u0645\u06CE\u0631",
      hh: "%d \u0643\u0627\u062A\u0698\u0645\u06CE\u0631",
      d: "\u06CC\u0647\u200C\u0643 \u0695\u06C6\u0698",
      dd: "%d \u0695\u06C6\u0698",
      M: "\u06CC\u0647\u200C\u0643 \u0645\u0627\u0646\u06AF",
      MM: "%d \u0645\u0627\u0646\u06AF",
      y: "\u06CC\u0647\u200C\u0643 \u0633\u0627\u06B5",
      yy: "%d \u0633\u0627\u06B5"
    },
    preparse: function(string) {
      return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function(match) {
        return numberMap[match];
      }).replace(/،/g, ",");
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      }).replace(/,/g, "\u060C");
    },
    week: {
      dow: 6,
      // Saturday is the first day of the week.
      doy: 12
      // The week that contains Jan 12th is the first week of the year.
    }
  });
  return ku;
}));


/***/ }),

/***/ 23400:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var suffixes = {
    0: "-\u0447\u04AF",
    1: "-\u0447\u0438",
    2: "-\u0447\u0438",
    3: "-\u0447\u04AF",
    4: "-\u0447\u04AF",
    5: "-\u0447\u0438",
    6: "-\u0447\u044B",
    7: "-\u0447\u0438",
    8: "-\u0447\u0438",
    9: "-\u0447\u0443",
    10: "-\u0447\u0443",
    20: "-\u0447\u044B",
    30: "-\u0447\u0443",
    40: "-\u0447\u044B",
    50: "-\u0447\u04AF",
    60: "-\u0447\u044B",
    70: "-\u0447\u0438",
    80: "-\u0447\u0438",
    90: "-\u0447\u0443",
    100: "-\u0447\u04AF"
  };
  var ky = moment.defineLocale("ky", {
    months: "\u044F\u043D\u0432\u0430\u0440\u044C_\u0444\u0435\u0432\u0440\u0430\u043B\u044C_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B\u044C_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C_\u043E\u043A\u0442\u044F\u0431\u0440\u044C_\u043D\u043E\u044F\u0431\u0440\u044C_\u0434\u0435\u043A\u0430\u0431\u0440\u044C".split(
      "_"
    ),
    monthsShort: "\u044F\u043D\u0432_\u0444\u0435\u0432_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433_\u0441\u0435\u043D_\u043E\u043A\u0442_\u043D\u043E\u044F_\u0434\u0435\u043A".split(
      "_"
    ),
    weekdays: "\u0416\u0435\u043A\u0448\u0435\u043C\u0431\u0438_\u0414\u04AF\u0439\u0448\u04E9\u043C\u0431\u04AF_\u0428\u0435\u0439\u0448\u0435\u043C\u0431\u0438_\u0428\u0430\u0440\u0448\u0435\u043C\u0431\u0438_\u0411\u0435\u0439\u0448\u0435\u043C\u0431\u0438_\u0416\u0443\u043C\u0430_\u0418\u0448\u0435\u043C\u0431\u0438".split(
      "_"
    ),
    weekdaysShort: "\u0416\u0435\u043A_\u0414\u04AF\u0439_\u0428\u0435\u0439_\u0428\u0430\u0440_\u0411\u0435\u0439_\u0416\u0443\u043C_\u0418\u0448\u0435".split("_"),
    weekdaysMin: "\u0416\u043A_\u0414\u0439_\u0428\u0439_\u0428\u0440_\u0411\u0439_\u0416\u043C_\u0418\u0448".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[\u0411\u04AF\u0433\u04AF\u043D \u0441\u0430\u0430\u0442] LT",
      nextDay: "[\u042D\u0440\u0442\u0435\u04A3 \u0441\u0430\u0430\u0442] LT",
      nextWeek: "dddd [\u0441\u0430\u0430\u0442] LT",
      lastDay: "[\u041A\u0435\u0447\u044D\u044D \u0441\u0430\u0430\u0442] LT",
      lastWeek: "[\u04E8\u0442\u043A\u04E9\u043D \u0430\u043F\u0442\u0430\u043D\u044B\u043D] dddd [\u043A\u04AF\u043D\u04AF] [\u0441\u0430\u0430\u0442] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0438\u0447\u0438\u043D\u0434\u0435",
      past: "%s \u043C\u0443\u0440\u0443\u043D",
      s: "\u0431\u0438\u0440\u043D\u0435\u0447\u0435 \u0441\u0435\u043A\u0443\u043D\u0434",
      ss: "%d \u0441\u0435\u043A\u0443\u043D\u0434",
      m: "\u0431\u0438\u0440 \u043C\u04AF\u043D\u04E9\u0442",
      mm: "%d \u043C\u04AF\u043D\u04E9\u0442",
      h: "\u0431\u0438\u0440 \u0441\u0430\u0430\u0442",
      hh: "%d \u0441\u0430\u0430\u0442",
      d: "\u0431\u0438\u0440 \u043A\u04AF\u043D",
      dd: "%d \u043A\u04AF\u043D",
      M: "\u0431\u0438\u0440 \u0430\u0439",
      MM: "%d \u0430\u0439",
      y: "\u0431\u0438\u0440 \u0436\u044B\u043B",
      yy: "%d \u0436\u044B\u043B"
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
    ordinal: function(number) {
      var a = number % 10, b = number >= 100 ? 100 : null;
      return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return ky;
}));


/***/ }),

/***/ 4790:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
      m: ["eng Minutt", "enger Minutt"],
      h: ["eng Stonn", "enger Stonn"],
      d: ["een Dag", "engem Dag"],
      M: ["ee Mount", "engem Mount"],
      y: ["ee Joer", "engem Joer"]
    };
    return withoutSuffix ? format[key][0] : format[key][1];
  }
  function processFutureTime(string) {
    var number = string.substr(0, string.indexOf(" "));
    if (eifelerRegelAppliesToNumber(number)) {
      return "a " + string;
    }
    return "an " + string;
  }
  function processPastTime(string) {
    var number = string.substr(0, string.indexOf(" "));
    if (eifelerRegelAppliesToNumber(number)) {
      return "viru " + string;
    }
    return "virun " + string;
  }
  function eifelerRegelAppliesToNumber(number) {
    number = parseInt(number, 10);
    if (isNaN(number)) {
      return false;
    }
    if (number < 0) {
      return true;
    } else if (number < 10) {
      if (4 <= number && number <= 7) {
        return true;
      }
      return false;
    } else if (number < 100) {
      var lastDigit = number % 10, firstDigit = number / 10;
      if (lastDigit === 0) {
        return eifelerRegelAppliesToNumber(firstDigit);
      }
      return eifelerRegelAppliesToNumber(lastDigit);
    } else if (number < 1e4) {
      while (number >= 10) {
        number = number / 10;
      }
      return eifelerRegelAppliesToNumber(number);
    } else {
      number = number / 1e3;
      return eifelerRegelAppliesToNumber(number);
    }
  }
  var lb = moment.defineLocale("lb", {
    months: "Januar_Februar_M\xE4erz_Abr\xEBll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split(
      "_"
    ),
    monthsShort: "Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "Sonndeg_M\xE9indeg_D\xEBnschdeg_M\xEBttwoch_Donneschdeg_Freideg_Samschdeg".split(
      "_"
    ),
    weekdaysShort: "So._M\xE9._D\xEB._M\xEB._Do._Fr._Sa.".split("_"),
    weekdaysMin: "So_M\xE9_D\xEB_M\xEB_Do_Fr_Sa".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm [Auer]",
      LTS: "H:mm:ss [Auer]",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY H:mm [Auer]",
      LLLL: "dddd, D. MMMM YYYY H:mm [Auer]"
    },
    calendar: {
      sameDay: "[Haut um] LT",
      sameElse: "L",
      nextDay: "[Muer um] LT",
      nextWeek: "dddd [um] LT",
      lastDay: "[G\xEBschter um] LT",
      lastWeek: function() {
        switch (this.day()) {
          case 2:
          case 4:
            return "[Leschten] dddd [um] LT";
          default:
            return "[Leschte] dddd [um] LT";
        }
      }
    },
    relativeTime: {
      future: processFutureTime,
      past: processPastTime,
      s: "e puer Sekonnen",
      ss: "%d Sekonnen",
      m: processRelativeTime,
      mm: "%d Minutten",
      h: processRelativeTime,
      hh: "%d Stonnen",
      d: processRelativeTime,
      dd: "%d Deeg",
      M: processRelativeTime,
      MM: "%d M\xE9int",
      y: processRelativeTime,
      yy: "%d Joer"
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return lb;
}));


/***/ }),

/***/ 88897:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var lo = moment.defineLocale("lo", {
    months: "\u0EA1\u0EB1\u0E87\u0E81\u0EAD\u0E99_\u0E81\u0EB8\u0EA1\u0E9E\u0EB2_\u0EA1\u0EB5\u0E99\u0EB2_\u0EC0\u0EA1\u0EAA\u0EB2_\u0E9E\u0EB6\u0E94\u0EAA\u0EB0\u0E9E\u0EB2_\u0EA1\u0EB4\u0E96\u0EB8\u0E99\u0EB2_\u0E81\u0ECD\u0EA5\u0EB0\u0E81\u0EBB\u0E94_\u0EAA\u0EB4\u0E87\u0EAB\u0EB2_\u0E81\u0EB1\u0E99\u0E8D\u0EB2_\u0E95\u0EB8\u0EA5\u0EB2_\u0E9E\u0EB0\u0E88\u0EB4\u0E81_\u0E97\u0EB1\u0E99\u0EA7\u0EB2".split(
      "_"
    ),
    monthsShort: "\u0EA1\u0EB1\u0E87\u0E81\u0EAD\u0E99_\u0E81\u0EB8\u0EA1\u0E9E\u0EB2_\u0EA1\u0EB5\u0E99\u0EB2_\u0EC0\u0EA1\u0EAA\u0EB2_\u0E9E\u0EB6\u0E94\u0EAA\u0EB0\u0E9E\u0EB2_\u0EA1\u0EB4\u0E96\u0EB8\u0E99\u0EB2_\u0E81\u0ECD\u0EA5\u0EB0\u0E81\u0EBB\u0E94_\u0EAA\u0EB4\u0E87\u0EAB\u0EB2_\u0E81\u0EB1\u0E99\u0E8D\u0EB2_\u0E95\u0EB8\u0EA5\u0EB2_\u0E9E\u0EB0\u0E88\u0EB4\u0E81_\u0E97\u0EB1\u0E99\u0EA7\u0EB2".split(
      "_"
    ),
    weekdays: "\u0EAD\u0EB2\u0E97\u0EB4\u0E94_\u0E88\u0EB1\u0E99_\u0EAD\u0EB1\u0E87\u0E84\u0EB2\u0E99_\u0E9E\u0EB8\u0E94_\u0E9E\u0EB0\u0EAB\u0EB1\u0E94_\u0EAA\u0EB8\u0E81_\u0EC0\u0EAA\u0EBB\u0EB2".split("_"),
    weekdaysShort: "\u0E97\u0EB4\u0E94_\u0E88\u0EB1\u0E99_\u0EAD\u0EB1\u0E87\u0E84\u0EB2\u0E99_\u0E9E\u0EB8\u0E94_\u0E9E\u0EB0\u0EAB\u0EB1\u0E94_\u0EAA\u0EB8\u0E81_\u0EC0\u0EAA\u0EBB\u0EB2".split("_"),
    weekdaysMin: "\u0E97_\u0E88_\u0EAD\u0E84_\u0E9E_\u0E9E\u0EAB_\u0EAA\u0E81_\u0EAA".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "\u0EA7\u0EB1\u0E99dddd D MMMM YYYY HH:mm"
    },
    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
    isPM: function(input) {
      return input === "\u0E95\u0EAD\u0E99\u0EC1\u0EA5\u0E87";
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u0E95\u0EAD\u0E99\u0EC0\u0E8A\u0EBB\u0EC9\u0EB2";
      } else {
        return "\u0E95\u0EAD\u0E99\u0EC1\u0EA5\u0E87";
      }
    },
    calendar: {
      sameDay: "[\u0EA1\u0EB7\u0EC9\u0E99\u0EB5\u0EC9\u0EC0\u0EA7\u0EA5\u0EB2] LT",
      nextDay: "[\u0EA1\u0EB7\u0EC9\u0EAD\u0EB7\u0EC8\u0E99\u0EC0\u0EA7\u0EA5\u0EB2] LT",
      nextWeek: "[\u0EA7\u0EB1\u0E99]dddd[\u0EDC\u0EC9\u0EB2\u0EC0\u0EA7\u0EA5\u0EB2] LT",
      lastDay: "[\u0EA1\u0EB7\u0EC9\u0EA7\u0EB2\u0E99\u0E99\u0EB5\u0EC9\u0EC0\u0EA7\u0EA5\u0EB2] LT",
      lastWeek: "[\u0EA7\u0EB1\u0E99]dddd[\u0EC1\u0EA5\u0EC9\u0EA7\u0E99\u0EB5\u0EC9\u0EC0\u0EA7\u0EA5\u0EB2] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0EAD\u0EB5\u0E81 %s",
      past: "%s\u0E9C\u0EC8\u0EB2\u0E99\u0EA1\u0EB2",
      s: "\u0E9A\u0ECD\u0EC8\u0EC0\u0E97\u0EBB\u0EC8\u0EB2\u0EC3\u0E94\u0EA7\u0EB4\u0E99\u0EB2\u0E97\u0EB5",
      ss: "%d \u0EA7\u0EB4\u0E99\u0EB2\u0E97\u0EB5",
      m: "1 \u0E99\u0EB2\u0E97\u0EB5",
      mm: "%d \u0E99\u0EB2\u0E97\u0EB5",
      h: "1 \u0E8A\u0EBB\u0EC8\u0EA7\u0EC2\u0EA1\u0E87",
      hh: "%d \u0E8A\u0EBB\u0EC8\u0EA7\u0EC2\u0EA1\u0E87",
      d: "1 \u0EA1\u0EB7\u0EC9",
      dd: "%d \u0EA1\u0EB7\u0EC9",
      M: "1 \u0EC0\u0E94\u0EB7\u0EAD\u0E99",
      MM: "%d \u0EC0\u0E94\u0EB7\u0EAD\u0E99",
      y: "1 \u0E9B\u0EB5",
      yy: "%d \u0E9B\u0EB5"
    },
    dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
    ordinal: function(number) {
      return "\u0E97\u0EB5\u0EC8" + number;
    }
  });
  return lo;
}));


/***/ }),

/***/ 62960:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var units = {
    ss: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
    m: "minut\u0117_minut\u0117s_minut\u0119",
    mm: "minut\u0117s_minu\u010Di\u0173_minutes",
    h: "valanda_valandos_valand\u0105",
    hh: "valandos_valand\u0173_valandas",
    d: "diena_dienos_dien\u0105",
    dd: "dienos_dien\u0173_dienas",
    M: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
    MM: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
    y: "metai_met\u0173_metus",
    yy: "metai_met\u0173_metus"
  };
  function translateSeconds(number, withoutSuffix, key, isFuture) {
    if (withoutSuffix) {
      return "kelios sekund\u0117s";
    } else {
      return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : "kelias sekundes";
    }
  }
  function translateSingular(number, withoutSuffix, key, isFuture) {
    return withoutSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
  }
  function special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
  }
  function forms(key) {
    return units[key].split("_");
  }
  function translate(number, withoutSuffix, key, isFuture) {
    var result = number + " ";
    if (number === 1) {
      return result + translateSingular(number, withoutSuffix, key[0], isFuture);
    } else if (withoutSuffix) {
      return result + (special(number) ? forms(key)[1] : forms(key)[0]);
    } else {
      if (isFuture) {
        return result + forms(key)[1];
      } else {
        return result + (special(number) ? forms(key)[1] : forms(key)[2]);
      }
    }
  }
  var lt = moment.defineLocale("lt", {
    months: {
      format: "sausio_vasario_kovo_baland\u017Eio_gegu\u017E\u0117s_bir\u017Eelio_liepos_rugpj\u016B\u010Dio_rugs\u0117jo_spalio_lapkri\u010Dio_gruod\u017Eio".split(
        "_"
      ),
      standalone: "sausis_vasaris_kovas_balandis_gegu\u017E\u0117_bir\u017Eelis_liepa_rugpj\u016Btis_rugs\u0117jis_spalis_lapkritis_gruodis".split(
        "_"
      ),
      isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
    },
    monthsShort: "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
    weekdays: {
      format: "sekmadien\u012F_pirmadien\u012F_antradien\u012F_tre\u010Diadien\u012F_ketvirtadien\u012F_penktadien\u012F_\u0161e\u0161tadien\u012F".split(
        "_"
      ),
      standalone: "sekmadienis_pirmadienis_antradienis_tre\u010Diadienis_ketvirtadienis_penktadienis_\u0161e\u0161tadienis".split(
        "_"
      ),
      isFormat: /dddd HH:mm/
    },
    weekdaysShort: "Sek_Pir_Ant_Tre_Ket_Pen_\u0160e\u0161".split("_"),
    weekdaysMin: "S_P_A_T_K_Pn_\u0160".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "YYYY [m.] MMMM D [d.]",
      LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
      LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
      l: "YYYY-MM-DD",
      ll: "YYYY [m.] MMMM D [d.]",
      lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
      llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]"
    },
    calendar: {
      sameDay: "[\u0160iandien] LT",
      nextDay: "[Rytoj] LT",
      nextWeek: "dddd LT",
      lastDay: "[Vakar] LT",
      lastWeek: "[Pra\u0117jus\u012F] dddd LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "po %s",
      past: "prie\u0161 %s",
      s: translateSeconds,
      ss: translate,
      m: translateSingular,
      mm: translate,
      h: translateSingular,
      hh: translate,
      d: translateSingular,
      dd: translate,
      M: translateSingular,
      MM: translate,
      y: translateSingular,
      yy: translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}-oji/,
    ordinal: function(number) {
      return number + "-oji";
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return lt;
}));


/***/ }),

/***/ 83386:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var units = {
    ss: "sekundes_sekund\u0113m_sekunde_sekundes".split("_"),
    m: "min\u016Btes_min\u016Bt\u0113m_min\u016Bte_min\u016Btes".split("_"),
    mm: "min\u016Btes_min\u016Bt\u0113m_min\u016Bte_min\u016Btes".split("_"),
    h: "stundas_stund\u0101m_stunda_stundas".split("_"),
    hh: "stundas_stund\u0101m_stunda_stundas".split("_"),
    d: "dienas_dien\u0101m_diena_dienas".split("_"),
    dd: "dienas_dien\u0101m_diena_dienas".split("_"),
    M: "m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),
    MM: "m\u0113ne\u0161a_m\u0113ne\u0161iem_m\u0113nesis_m\u0113ne\u0161i".split("_"),
    y: "gada_gadiem_gads_gadi".split("_"),
    yy: "gada_gadiem_gads_gadi".split("_")
  };
  function format(forms, number, withoutSuffix) {
    if (withoutSuffix) {
      return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
    } else {
      return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
    }
  }
  function relativeTimeWithPlural(number, withoutSuffix, key) {
    return number + " " + format(units[key], number, withoutSuffix);
  }
  function relativeTimeWithSingular(number, withoutSuffix, key) {
    return format(units[key], number, withoutSuffix);
  }
  function relativeSeconds(number, withoutSuffix) {
    return withoutSuffix ? "da\u017Eas sekundes" : "da\u017E\u0101m sekund\u0113m";
  }
  var lv = moment.defineLocale("lv", {
    months: "janv\u0101ris_febru\u0101ris_marts_apr\u012Blis_maijs_j\u016Bnijs_j\u016Blijs_augusts_septembris_oktobris_novembris_decembris".split(
      "_"
    ),
    monthsShort: "jan_feb_mar_apr_mai_j\u016Bn_j\u016Bl_aug_sep_okt_nov_dec".split("_"),
    weekdays: "sv\u0113tdiena_pirmdiena_otrdiena_tre\u0161diena_ceturtdiena_piektdiena_sestdiena".split(
      "_"
    ),
    weekdaysShort: "Sv_P_O_T_C_Pk_S".split("_"),
    weekdaysMin: "Sv_P_O_T_C_Pk_S".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY.",
      LL: "YYYY. [gada] D. MMMM",
      LLL: "YYYY. [gada] D. MMMM, HH:mm",
      LLLL: "YYYY. [gada] D. MMMM, dddd, HH:mm"
    },
    calendar: {
      sameDay: "[\u0160odien pulksten] LT",
      nextDay: "[R\u012Bt pulksten] LT",
      nextWeek: "dddd [pulksten] LT",
      lastDay: "[Vakar pulksten] LT",
      lastWeek: "[Pag\u0101ju\u0161\u0101] dddd [pulksten] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "p\u0113c %s",
      past: "pirms %s",
      s: relativeSeconds,
      ss: relativeTimeWithPlural,
      m: relativeTimeWithSingular,
      mm: relativeTimeWithPlural,
      h: relativeTimeWithSingular,
      hh: relativeTimeWithPlural,
      d: relativeTimeWithSingular,
      dd: relativeTimeWithPlural,
      M: relativeTimeWithSingular,
      MM: relativeTimeWithPlural,
      y: relativeTimeWithSingular,
      yy: relativeTimeWithPlural
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return lv;
}));


/***/ }),

/***/ 60014:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var translator = {
    words: {
      //Different grammatical cases
      ss: ["sekund", "sekunda", "sekundi"],
      m: ["jedan minut", "jednog minuta"],
      mm: ["minut", "minuta", "minuta"],
      h: ["jedan sat", "jednog sata"],
      hh: ["sat", "sata", "sati"],
      dd: ["dan", "dana", "dana"],
      MM: ["mjesec", "mjeseca", "mjeseci"],
      yy: ["godina", "godine", "godina"]
    },
    correctGrammaticalCase: function(number, wordKey) {
      return number === 1 ? wordKey[0] : number >= 2 && number <= 4 ? wordKey[1] : wordKey[2];
    },
    translate: function(number, withoutSuffix, key) {
      var wordKey = translator.words[key];
      if (key.length === 1) {
        return withoutSuffix ? wordKey[0] : wordKey[1];
      } else {
        return number + " " + translator.correctGrammaticalCase(number, wordKey);
      }
    }
  };
  var me = moment.defineLocale("me", {
    months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split(
      "_"
    ),
    monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
    monthsParseExact: true,
    weekdays: "nedjelja_ponedjeljak_utorak_srijeda_\u010Detvrtak_petak_subota".split(
      "_"
    ),
    weekdaysShort: "ned._pon._uto._sri._\u010Det._pet._sub.".split("_"),
    weekdaysMin: "ne_po_ut_sr_\u010De_pe_su".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY H:mm",
      LLLL: "dddd, D. MMMM YYYY H:mm"
    },
    calendar: {
      sameDay: "[danas u] LT",
      nextDay: "[sjutra u] LT",
      nextWeek: function() {
        switch (this.day()) {
          case 0:
            return "[u] [nedjelju] [u] LT";
          case 3:
            return "[u] [srijedu] [u] LT";
          case 6:
            return "[u] [subotu] [u] LT";
          case 1:
          case 2:
          case 4:
          case 5:
            return "[u] dddd [u] LT";
        }
      },
      lastDay: "[ju\u010De u] LT",
      lastWeek: function() {
        var lastWeekDays = [
          "[pro\u0161le] [nedjelje] [u] LT",
          "[pro\u0161log] [ponedjeljka] [u] LT",
          "[pro\u0161log] [utorka] [u] LT",
          "[pro\u0161le] [srijede] [u] LT",
          "[pro\u0161log] [\u010Detvrtka] [u] LT",
          "[pro\u0161log] [petka] [u] LT",
          "[pro\u0161le] [subote] [u] LT"
        ];
        return lastWeekDays[this.day()];
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "za %s",
      past: "prije %s",
      s: "nekoliko sekundi",
      ss: translator.translate,
      m: translator.translate,
      mm: translator.translate,
      h: translator.translate,
      hh: translator.translate,
      d: "dan",
      dd: translator.translate,
      M: "mjesec",
      MM: translator.translate,
      y: "godinu",
      yy: translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return me;
}));


/***/ }),

/***/ 72474:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var mi = moment.defineLocale("mi", {
    months: "Kohi-t\u0101te_Hui-tanguru_Pout\u016B-te-rangi_Paenga-wh\u0101wh\u0101_Haratua_Pipiri_H\u014Dngoingoi_Here-turi-k\u014Dk\u0101_Mahuru_Whiringa-\u0101-nuku_Whiringa-\u0101-rangi_Hakihea".split(
      "_"
    ),
    monthsShort: "Kohi_Hui_Pou_Pae_Hara_Pipi_H\u014Dngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split(
      "_"
    ),
    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
    weekdays: "R\u0101tapu_Mane_T\u016Brei_Wenerei_T\u0101ite_Paraire_H\u0101tarei".split("_"),
    weekdaysShort: "Ta_Ma_T\u016B_We_T\u0101i_Pa_H\u0101".split("_"),
    weekdaysMin: "Ta_Ma_T\u016B_We_T\u0101i_Pa_H\u0101".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY [i] HH:mm",
      LLLL: "dddd, D MMMM YYYY [i] HH:mm"
    },
    calendar: {
      sameDay: "[i teie mahana, i] LT",
      nextDay: "[apopo i] LT",
      nextWeek: "dddd [i] LT",
      lastDay: "[inanahi i] LT",
      lastWeek: "dddd [whakamutunga i] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "i roto i %s",
      past: "%s i mua",
      s: "te h\u0113kona ruarua",
      ss: "%d h\u0113kona",
      m: "he meneti",
      mm: "%d meneti",
      h: "te haora",
      hh: "%d haora",
      d: "he ra",
      dd: "%d ra",
      M: "he marama",
      MM: "%d marama",
      y: "he tau",
      yy: "%d tau"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: "%d\xBA",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return mi;
}));


/***/ }),

/***/ 92624:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var mk = moment.defineLocale("mk", {
    months: "\u0458\u0430\u043D\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0438\u043B_\u043C\u0430\u0458_\u0458\u0443\u043D\u0438_\u0458\u0443\u043B\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438_\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438_\u043D\u043E\u0435\u043C\u0432\u0440\u0438_\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438".split(
      "_"
    ),
    monthsShort: "\u0458\u0430\u043D_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0458_\u0458\u0443\u043D_\u0458\u0443\u043B_\u0430\u0432\u0433_\u0441\u0435\u043F_\u043E\u043A\u0442_\u043D\u043E\u0435_\u0434\u0435\u043A".split("_"),
    weekdays: "\u043D\u0435\u0434\u0435\u043B\u0430_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A_\u043F\u0435\u0442\u043E\u043A_\u0441\u0430\u0431\u043E\u0442\u0430".split(
      "_"
    ),
    weekdaysShort: "\u043D\u0435\u0434_\u043F\u043E\u043D_\u0432\u0442\u043E_\u0441\u0440\u0435_\u0447\u0435\u0442_\u043F\u0435\u0442_\u0441\u0430\u0431".split("_"),
    weekdaysMin: "\u043De_\u043Fo_\u0432\u0442_\u0441\u0440_\u0447\u0435_\u043F\u0435_\u0441a".split("_"),
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "D.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY H:mm",
      LLLL: "dddd, D MMMM YYYY H:mm"
    },
    calendar: {
      sameDay: "[\u0414\u0435\u043D\u0435\u0441 \u0432\u043E] LT",
      nextDay: "[\u0423\u0442\u0440\u0435 \u0432\u043E] LT",
      nextWeek: "[\u0412\u043E] dddd [\u0432\u043E] LT",
      lastDay: "[\u0412\u0447\u0435\u0440\u0430 \u0432\u043E] LT",
      lastWeek: function() {
        switch (this.day()) {
          case 0:
          case 3:
          case 6:
            return "[\u0418\u0437\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430] dddd [\u0432\u043E] LT";
          case 1:
          case 2:
          case 4:
          case 5:
            return "[\u0418\u0437\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442] dddd [\u0432\u043E] LT";
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0437\u0430 %s",
      past: "\u043F\u0440\u0435\u0434 %s",
      s: "\u043D\u0435\u043A\u043E\u043B\u043A\u0443 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
      ss: "%d \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
      m: "\u0435\u0434\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
      mm: "%d \u043C\u0438\u043D\u0443\u0442\u0438",
      h: "\u0435\u0434\u0435\u043D \u0447\u0430\u0441",
      hh: "%d \u0447\u0430\u0441\u0430",
      d: "\u0435\u0434\u0435\u043D \u0434\u0435\u043D",
      dd: "%d \u0434\u0435\u043D\u0430",
      M: "\u0435\u0434\u0435\u043D \u043C\u0435\u0441\u0435\u0446",
      MM: "%d \u043C\u0435\u0441\u0435\u0446\u0438",
      y: "\u0435\u0434\u043D\u0430 \u0433\u043E\u0434\u0438\u043D\u0430",
      yy: "%d \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
    ordinal: function(number) {
      var lastDigit = number % 10, last2Digits = number % 100;
      if (number === 0) {
        return number + "-\u0435\u0432";
      } else if (last2Digits === 0) {
        return number + "-\u0435\u043D";
      } else if (last2Digits > 10 && last2Digits < 20) {
        return number + "-\u0442\u0438";
      } else if (lastDigit === 1) {
        return number + "-\u0432\u0438";
      } else if (lastDigit === 2) {
        return number + "-\u0440\u0438";
      } else if (lastDigit === 7 || lastDigit === 8) {
        return number + "-\u043C\u0438";
      } else {
        return number + "-\u0442\u0438";
      }
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return mk;
}));


/***/ }),

/***/ 58949:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var ml = moment.defineLocale("ml", {
    months: "\u0D1C\u0D28\u0D41\u0D35\u0D30\u0D3F_\u0D2B\u0D46\u0D2C\u0D4D\u0D30\u0D41\u0D35\u0D30\u0D3F_\u0D2E\u0D3E\u0D7C\u0D1A\u0D4D\u0D1A\u0D4D_\u0D0F\u0D2A\u0D4D\u0D30\u0D3F\u0D7D_\u0D2E\u0D47\u0D2F\u0D4D_\u0D1C\u0D42\u0D7A_\u0D1C\u0D42\u0D32\u0D48_\u0D13\u0D17\u0D38\u0D4D\u0D31\u0D4D\u0D31\u0D4D_\u0D38\u0D46\u0D2A\u0D4D\u0D31\u0D4D\u0D31\u0D02\u0D2C\u0D7C_\u0D12\u0D15\u0D4D\u0D1F\u0D4B\u0D2C\u0D7C_\u0D28\u0D35\u0D02\u0D2C\u0D7C_\u0D21\u0D3F\u0D38\u0D02\u0D2C\u0D7C".split(
      "_"
    ),
    monthsShort: "\u0D1C\u0D28\u0D41._\u0D2B\u0D46\u0D2C\u0D4D\u0D30\u0D41._\u0D2E\u0D3E\u0D7C._\u0D0F\u0D2A\u0D4D\u0D30\u0D3F._\u0D2E\u0D47\u0D2F\u0D4D_\u0D1C\u0D42\u0D7A_\u0D1C\u0D42\u0D32\u0D48._\u0D13\u0D17._\u0D38\u0D46\u0D2A\u0D4D\u0D31\u0D4D\u0D31._\u0D12\u0D15\u0D4D\u0D1F\u0D4B._\u0D28\u0D35\u0D02._\u0D21\u0D3F\u0D38\u0D02.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "\u0D1E\u0D3E\u0D2F\u0D31\u0D3E\u0D34\u0D4D\u0D1A_\u0D24\u0D3F\u0D19\u0D4D\u0D15\u0D33\u0D3E\u0D34\u0D4D\u0D1A_\u0D1A\u0D4A\u0D35\u0D4D\u0D35\u0D3E\u0D34\u0D4D\u0D1A_\u0D2C\u0D41\u0D27\u0D28\u0D3E\u0D34\u0D4D\u0D1A_\u0D35\u0D4D\u0D2F\u0D3E\u0D34\u0D3E\u0D34\u0D4D\u0D1A_\u0D35\u0D46\u0D33\u0D4D\u0D33\u0D3F\u0D2F\u0D3E\u0D34\u0D4D\u0D1A_\u0D36\u0D28\u0D3F\u0D2F\u0D3E\u0D34\u0D4D\u0D1A".split(
      "_"
    ),
    weekdaysShort: "\u0D1E\u0D3E\u0D2F\u0D7C_\u0D24\u0D3F\u0D19\u0D4D\u0D15\u0D7E_\u0D1A\u0D4A\u0D35\u0D4D\u0D35_\u0D2C\u0D41\u0D27\u0D7B_\u0D35\u0D4D\u0D2F\u0D3E\u0D34\u0D02_\u0D35\u0D46\u0D33\u0D4D\u0D33\u0D3F_\u0D36\u0D28\u0D3F".split("_"),
    weekdaysMin: "\u0D1E\u0D3E_\u0D24\u0D3F_\u0D1A\u0D4A_\u0D2C\u0D41_\u0D35\u0D4D\u0D2F\u0D3E_\u0D35\u0D46_\u0D36".split("_"),
    longDateFormat: {
      LT: "A h:mm -\u0D28\u0D41",
      LTS: "A h:mm:ss -\u0D28\u0D41",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, A h:mm -\u0D28\u0D41",
      LLLL: "dddd, D MMMM YYYY, A h:mm -\u0D28\u0D41"
    },
    calendar: {
      sameDay: "[\u0D07\u0D28\u0D4D\u0D28\u0D4D] LT",
      nextDay: "[\u0D28\u0D3E\u0D33\u0D46] LT",
      nextWeek: "dddd, LT",
      lastDay: "[\u0D07\u0D28\u0D4D\u0D28\u0D32\u0D46] LT",
      lastWeek: "[\u0D15\u0D34\u0D3F\u0D1E\u0D4D\u0D1E] dddd, LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0D15\u0D34\u0D3F\u0D1E\u0D4D\u0D1E\u0D4D",
      past: "%s \u0D2E\u0D41\u0D7B\u0D2A\u0D4D",
      s: "\u0D05\u0D7D\u0D2A \u0D28\u0D3F\u0D2E\u0D3F\u0D37\u0D19\u0D4D\u0D19\u0D7E",
      ss: "%d \u0D38\u0D46\u0D15\u0D4D\u0D15\u0D7B\u0D21\u0D4D",
      m: "\u0D12\u0D30\u0D41 \u0D2E\u0D3F\u0D28\u0D3F\u0D31\u0D4D\u0D31\u0D4D",
      mm: "%d \u0D2E\u0D3F\u0D28\u0D3F\u0D31\u0D4D\u0D31\u0D4D",
      h: "\u0D12\u0D30\u0D41 \u0D2E\u0D23\u0D3F\u0D15\u0D4D\u0D15\u0D42\u0D7C",
      hh: "%d \u0D2E\u0D23\u0D3F\u0D15\u0D4D\u0D15\u0D42\u0D7C",
      d: "\u0D12\u0D30\u0D41 \u0D26\u0D3F\u0D35\u0D38\u0D02",
      dd: "%d \u0D26\u0D3F\u0D35\u0D38\u0D02",
      M: "\u0D12\u0D30\u0D41 \u0D2E\u0D3E\u0D38\u0D02",
      MM: "%d \u0D2E\u0D3E\u0D38\u0D02",
      y: "\u0D12\u0D30\u0D41 \u0D35\u0D7C\u0D37\u0D02",
      yy: "%d \u0D35\u0D7C\u0D37\u0D02"
    },
    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u0D30\u0D3E\u0D24\u0D4D\u0D30\u0D3F" && hour >= 4 || meridiem === "\u0D09\u0D1A\u0D4D\u0D1A \u0D15\u0D34\u0D3F\u0D1E\u0D4D\u0D1E\u0D4D" || meridiem === "\u0D35\u0D48\u0D15\u0D41\u0D28\u0D4D\u0D28\u0D47\u0D30\u0D02") {
        return hour + 12;
      } else {
        return hour;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u0D30\u0D3E\u0D24\u0D4D\u0D30\u0D3F";
      } else if (hour < 12) {
        return "\u0D30\u0D3E\u0D35\u0D3F\u0D32\u0D46";
      } else if (hour < 17) {
        return "\u0D09\u0D1A\u0D4D\u0D1A \u0D15\u0D34\u0D3F\u0D1E\u0D4D\u0D1E\u0D4D";
      } else if (hour < 20) {
        return "\u0D35\u0D48\u0D15\u0D41\u0D28\u0D4D\u0D28\u0D47\u0D30\u0D02";
      } else {
        return "\u0D30\u0D3E\u0D24\u0D4D\u0D30\u0D3F";
      }
    }
  });
  return ml;
}));


/***/ }),

/***/ 49987:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function translate(number, withoutSuffix, key, isFuture) {
    switch (key) {
      case "s":
        return withoutSuffix ? "\u0445\u044D\u0434\u0445\u044D\u043D \u0441\u0435\u043A\u0443\u043D\u0434" : "\u0445\u044D\u0434\u0445\u044D\u043D \u0441\u0435\u043A\u0443\u043D\u0434\u044B\u043D";
      case "ss":
        return number + (withoutSuffix ? " \u0441\u0435\u043A\u0443\u043D\u0434" : " \u0441\u0435\u043A\u0443\u043D\u0434\u044B\u043D");
      case "m":
      case "mm":
        return number + (withoutSuffix ? " \u043C\u0438\u043D\u0443\u0442" : " \u043C\u0438\u043D\u0443\u0442\u044B\u043D");
      case "h":
      case "hh":
        return number + (withoutSuffix ? " \u0446\u0430\u0433" : " \u0446\u0430\u0433\u0438\u0439\u043D");
      case "d":
      case "dd":
        return number + (withoutSuffix ? " \u04E9\u0434\u04E9\u0440" : " \u04E9\u0434\u0440\u0438\u0439\u043D");
      case "M":
      case "MM":
        return number + (withoutSuffix ? " \u0441\u0430\u0440" : " \u0441\u0430\u0440\u044B\u043D");
      case "y":
      case "yy":
        return number + (withoutSuffix ? " \u0436\u0438\u043B" : " \u0436\u0438\u043B\u0438\u0439\u043D");
      default:
        return number;
    }
  }
  var mn = moment.defineLocale("mn", {
    months: "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440_\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440_\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0417\u0443\u0440\u0433\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0414\u043E\u043B\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440_\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043D \u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440_\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440".split(
      "_"
    ),
    monthsShort: "1 \u0441\u0430\u0440_2 \u0441\u0430\u0440_3 \u0441\u0430\u0440_4 \u0441\u0430\u0440_5 \u0441\u0430\u0440_6 \u0441\u0430\u0440_7 \u0441\u0430\u0440_8 \u0441\u0430\u0440_9 \u0441\u0430\u0440_10 \u0441\u0430\u0440_11 \u0441\u0430\u0440_12 \u0441\u0430\u0440".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "\u041D\u044F\u043C_\u0414\u0430\u0432\u0430\u0430_\u041C\u044F\u0433\u043C\u0430\u0440_\u041B\u0445\u0430\u0433\u0432\u0430_\u041F\u04AF\u0440\u044D\u0432_\u0411\u0430\u0430\u0441\u0430\u043D_\u0411\u044F\u043C\u0431\u0430".split("_"),
    weekdaysShort: "\u041D\u044F\u043C_\u0414\u0430\u0432_\u041C\u044F\u0433_\u041B\u0445\u0430_\u041F\u04AF\u0440_\u0411\u0430\u0430_\u0411\u044F\u043C".split("_"),
    weekdaysMin: "\u041D\u044F_\u0414\u0430_\u041C\u044F_\u041B\u0445_\u041F\u04AF_\u0411\u0430_\u0411\u044F".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "YYYY \u043E\u043D\u044B MMMM\u044B\u043D D",
      LLL: "YYYY \u043E\u043D\u044B MMMM\u044B\u043D D HH:mm",
      LLLL: "dddd, YYYY \u043E\u043D\u044B MMMM\u044B\u043D D HH:mm"
    },
    meridiemParse: /ҮӨ|ҮХ/i,
    isPM: function(input) {
      return input === "\u04AE\u0425";
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u04AE\u04E8";
      } else {
        return "\u04AE\u0425";
      }
    },
    calendar: {
      sameDay: "[\u04E8\u043D\u04E9\u04E9\u0434\u04E9\u0440] LT",
      nextDay: "[\u041C\u0430\u0440\u0433\u0430\u0430\u0448] LT",
      nextWeek: "[\u0418\u0440\u044D\u0445] dddd LT",
      lastDay: "[\u04E8\u0447\u0438\u0433\u0434\u04E9\u0440] LT",
      lastWeek: "[\u04E8\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D] dddd LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0434\u0430\u0440\u0430\u0430",
      past: "%s \u04E9\u043C\u043D\u04E9",
      s: translate,
      ss: translate,
      m: translate,
      mm: translate,
      h: translate,
      hh: translate,
      d: translate,
      dd: translate,
      M: translate,
      MM: translate,
      y: translate,
      yy: translate
    },
    dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
    ordinal: function(number, period) {
      switch (period) {
        case "d":
        case "D":
        case "DDD":
          return number + " \u04E9\u0434\u04E9\u0440";
        default:
          return number;
      }
    }
  });
  return mn;
}));


/***/ }),

/***/ 77503:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u0967",
    2: "\u0968",
    3: "\u0969",
    4: "\u096A",
    5: "\u096B",
    6: "\u096C",
    7: "\u096D",
    8: "\u096E",
    9: "\u096F",
    0: "\u0966"
  }, numberMap = {
    "\u0967": "1",
    "\u0968": "2",
    "\u0969": "3",
    "\u096A": "4",
    "\u096B": "5",
    "\u096C": "6",
    "\u096D": "7",
    "\u096E": "8",
    "\u096F": "9",
    "\u0966": "0"
  };
  function relativeTimeMr(number, withoutSuffix, string, isFuture) {
    var output = "";
    if (withoutSuffix) {
      switch (string) {
        case "s":
          output = "\u0915\u093E\u0939\u0940 \u0938\u0947\u0915\u0902\u0926";
          break;
        case "ss":
          output = "%d \u0938\u0947\u0915\u0902\u0926";
          break;
        case "m":
          output = "\u090F\u0915 \u092E\u093F\u0928\u093F\u091F";
          break;
        case "mm":
          output = "%d \u092E\u093F\u0928\u093F\u091F\u0947";
          break;
        case "h":
          output = "\u090F\u0915 \u0924\u093E\u0938";
          break;
        case "hh":
          output = "%d \u0924\u093E\u0938";
          break;
        case "d":
          output = "\u090F\u0915 \u0926\u093F\u0935\u0938";
          break;
        case "dd":
          output = "%d \u0926\u093F\u0935\u0938";
          break;
        case "M":
          output = "\u090F\u0915 \u092E\u0939\u093F\u0928\u093E";
          break;
        case "MM":
          output = "%d \u092E\u0939\u093F\u0928\u0947";
          break;
        case "y":
          output = "\u090F\u0915 \u0935\u0930\u094D\u0937";
          break;
        case "yy":
          output = "%d \u0935\u0930\u094D\u0937\u0947";
          break;
      }
    } else {
      switch (string) {
        case "s":
          output = "\u0915\u093E\u0939\u0940 \u0938\u0947\u0915\u0902\u0926\u093E\u0902";
          break;
        case "ss":
          output = "%d \u0938\u0947\u0915\u0902\u0926\u093E\u0902";
          break;
        case "m":
          output = "\u090F\u0915\u093E \u092E\u093F\u0928\u093F\u091F\u093E";
          break;
        case "mm":
          output = "%d \u092E\u093F\u0928\u093F\u091F\u093E\u0902";
          break;
        case "h":
          output = "\u090F\u0915\u093E \u0924\u093E\u0938\u093E";
          break;
        case "hh":
          output = "%d \u0924\u093E\u0938\u093E\u0902";
          break;
        case "d":
          output = "\u090F\u0915\u093E \u0926\u093F\u0935\u0938\u093E";
          break;
        case "dd":
          output = "%d \u0926\u093F\u0935\u0938\u093E\u0902";
          break;
        case "M":
          output = "\u090F\u0915\u093E \u092E\u0939\u093F\u0928\u094D\u092F\u093E";
          break;
        case "MM":
          output = "%d \u092E\u0939\u093F\u0928\u094D\u092F\u093E\u0902";
          break;
        case "y":
          output = "\u090F\u0915\u093E \u0935\u0930\u094D\u0937\u093E";
          break;
        case "yy":
          output = "%d \u0935\u0930\u094D\u0937\u093E\u0902";
          break;
      }
    }
    return output.replace(/%d/i, number);
  }
  var mr = moment.defineLocale("mr", {
    months: "\u091C\u093E\u0928\u0947\u0935\u093E\u0930\u0940_\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u093E\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u090F\u092A\u094D\u0930\u093F\u0932_\u092E\u0947_\u091C\u0942\u0928_\u091C\u0941\u0932\u0948_\u0911\u0917\u0938\u094D\u091F_\u0938\u092A\u094D\u091F\u0947\u0902\u092C\u0930_\u0911\u0915\u094D\u091F\u094B\u092C\u0930_\u0928\u094B\u0935\u094D\u0939\u0947\u0902\u092C\u0930_\u0921\u093F\u0938\u0947\u0902\u092C\u0930".split(
      "_"
    ),
    monthsShort: "\u091C\u093E\u0928\u0947._\u092B\u0947\u092C\u094D\u0930\u0941._\u092E\u093E\u0930\u094D\u091A._\u090F\u092A\u094D\u0930\u093F._\u092E\u0947._\u091C\u0942\u0928._\u091C\u0941\u0932\u0948._\u0911\u0917._\u0938\u092A\u094D\u091F\u0947\u0902._\u0911\u0915\u094D\u091F\u094B._\u0928\u094B\u0935\u094D\u0939\u0947\u0902._\u0921\u093F\u0938\u0947\u0902.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "\u0930\u0935\u093F\u0935\u093E\u0930_\u0938\u094B\u092E\u0935\u093E\u0930_\u092E\u0902\u0917\u0933\u0935\u093E\u0930_\u092C\u0941\u0927\u0935\u093E\u0930_\u0917\u0941\u0930\u0942\u0935\u093E\u0930_\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930_\u0936\u0928\u093F\u0935\u093E\u0930".split("_"),
    weekdaysShort: "\u0930\u0935\u093F_\u0938\u094B\u092E_\u092E\u0902\u0917\u0933_\u092C\u0941\u0927_\u0917\u0941\u0930\u0942_\u0936\u0941\u0915\u094D\u0930_\u0936\u0928\u093F".split("_"),
    weekdaysMin: "\u0930_\u0938\u094B_\u092E\u0902_\u092C\u0941_\u0917\u0941_\u0936\u0941_\u0936".split("_"),
    longDateFormat: {
      LT: "A h:mm \u0935\u093E\u091C\u0924\u093E",
      LTS: "A h:mm:ss \u0935\u093E\u091C\u0924\u093E",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, A h:mm \u0935\u093E\u091C\u0924\u093E",
      LLLL: "dddd, D MMMM YYYY, A h:mm \u0935\u093E\u091C\u0924\u093E"
    },
    calendar: {
      sameDay: "[\u0906\u091C] LT",
      nextDay: "[\u0909\u0926\u094D\u092F\u093E] LT",
      nextWeek: "dddd, LT",
      lastDay: "[\u0915\u093E\u0932] LT",
      lastWeek: "[\u092E\u093E\u0917\u0940\u0932] dddd, LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s\u092E\u0927\u094D\u092F\u0947",
      past: "%s\u092A\u0942\u0930\u094D\u0935\u0940",
      s: relativeTimeMr,
      ss: relativeTimeMr,
      m: relativeTimeMr,
      mm: relativeTimeMr,
      h: relativeTimeMr,
      hh: relativeTimeMr,
      d: relativeTimeMr,
      dd: relativeTimeMr,
      M: relativeTimeMr,
      MM: relativeTimeMr,
      y: relativeTimeMr,
      yy: relativeTimeMr
    },
    preparse: function(string) {
      return string.replace(/[१२३४५६७८९०]/g, function(match) {
        return numberMap[match];
      });
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      });
    },
    meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u092A\u0939\u093E\u091F\u0947" || meridiem === "\u0938\u0915\u093E\u0933\u0940") {
        return hour;
      } else if (meridiem === "\u0926\u0941\u092A\u093E\u0930\u0940" || meridiem === "\u0938\u093E\u092F\u0902\u0915\u093E\u0933\u0940" || meridiem === "\u0930\u093E\u0924\u094D\u0930\u0940") {
        return hour >= 12 ? hour : hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour >= 0 && hour < 6) {
        return "\u092A\u0939\u093E\u091F\u0947";
      } else if (hour < 12) {
        return "\u0938\u0915\u093E\u0933\u0940";
      } else if (hour < 17) {
        return "\u0926\u0941\u092A\u093E\u0930\u0940";
      } else if (hour < 20) {
        return "\u0938\u093E\u092F\u0902\u0915\u093E\u0933\u0940";
      } else {
        return "\u0930\u093E\u0924\u094D\u0930\u0940";
      }
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return mr;
}));


/***/ }),

/***/ 60195:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var msMy = moment.defineLocale("ms-my", {
    months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
    weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
    weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
    weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
    longDateFormat: {
      LT: "HH.mm",
      LTS: "HH.mm.ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY [pukul] HH.mm",
      LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "pagi") {
        return hour;
      } else if (meridiem === "tengahari") {
        return hour >= 11 ? hour : hour + 12;
      } else if (meridiem === "petang" || meridiem === "malam") {
        return hour + 12;
      }
    },
    meridiem: function(hours, minutes, isLower) {
      if (hours < 11) {
        return "pagi";
      } else if (hours < 15) {
        return "tengahari";
      } else if (hours < 19) {
        return "petang";
      } else {
        return "malam";
      }
    },
    calendar: {
      sameDay: "[Hari ini pukul] LT",
      nextDay: "[Esok pukul] LT",
      nextWeek: "dddd [pukul] LT",
      lastDay: "[Kelmarin pukul] LT",
      lastWeek: "dddd [lepas pukul] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "dalam %s",
      past: "%s yang lepas",
      s: "beberapa saat",
      ss: "%d saat",
      m: "seminit",
      mm: "%d minit",
      h: "sejam",
      hh: "%d jam",
      d: "sehari",
      dd: "%d hari",
      M: "sebulan",
      MM: "%d bulan",
      y: "setahun",
      yy: "%d tahun"
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return msMy;
}));


/***/ }),

/***/ 82536:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var ms = moment.defineLocale("ms", {
    months: "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
    weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
    weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
    weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
    longDateFormat: {
      LT: "HH.mm",
      LTS: "HH.mm.ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY [pukul] HH.mm",
      LLLL: "dddd, D MMMM YYYY [pukul] HH.mm"
    },
    meridiemParse: /pagi|tengahari|petang|malam/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "pagi") {
        return hour;
      } else if (meridiem === "tengahari") {
        return hour >= 11 ? hour : hour + 12;
      } else if (meridiem === "petang" || meridiem === "malam") {
        return hour + 12;
      }
    },
    meridiem: function(hours, minutes, isLower) {
      if (hours < 11) {
        return "pagi";
      } else if (hours < 15) {
        return "tengahari";
      } else if (hours < 19) {
        return "petang";
      } else {
        return "malam";
      }
    },
    calendar: {
      sameDay: "[Hari ini pukul] LT",
      nextDay: "[Esok pukul] LT",
      nextWeek: "dddd [pukul] LT",
      lastDay: "[Kelmarin pukul] LT",
      lastWeek: "dddd [lepas pukul] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "dalam %s",
      past: "%s yang lepas",
      s: "beberapa saat",
      ss: "%d saat",
      m: "seminit",
      mm: "%d minit",
      h: "sejam",
      hh: "%d jam",
      d: "sehari",
      dd: "%d hari",
      M: "sebulan",
      MM: "%d bulan",
      y: "setahun",
      yy: "%d tahun"
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return ms;
}));


/***/ }),

/***/ 96925:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var mt = moment.defineLocale("mt", {
    months: "Jannar_Frar_Marzu_April_Mejju_\u0120unju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Di\u010Bembru".split(
      "_"
    ),
    monthsShort: "Jan_Fra_Mar_Apr_Mej_\u0120un_Lul_Aww_Set_Ott_Nov_Di\u010B".split("_"),
    weekdays: "Il-\u0126add_It-Tnejn_It-Tlieta_L-Erbg\u0127a_Il-\u0126amis_Il-\u0120img\u0127a_Is-Sibt".split(
      "_"
    ),
    weekdaysShort: "\u0126ad_Tne_Tli_Erb_\u0126am_\u0120im_Sib".split("_"),
    weekdaysMin: "\u0126a_Tn_Tl_Er_\u0126a_\u0120i_Si".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Illum fil-]LT",
      nextDay: "[G\u0127ada fil-]LT",
      nextWeek: "dddd [fil-]LT",
      lastDay: "[Il-biera\u0127 fil-]LT",
      lastWeek: "dddd [li g\u0127adda] [fil-]LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "f\u2019 %s",
      past: "%s ilu",
      s: "ftit sekondi",
      ss: "%d sekondi",
      m: "minuta",
      mm: "%d minuti",
      h: "sieg\u0127a",
      hh: "%d sieg\u0127at",
      d: "\u0121urnata",
      dd: "%d \u0121ranet",
      M: "xahar",
      MM: "%d xhur",
      y: "sena",
      yy: "%d sni"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: "%d\xBA",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return mt;
}));


/***/ }),

/***/ 26186:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u1041",
    2: "\u1042",
    3: "\u1043",
    4: "\u1044",
    5: "\u1045",
    6: "\u1046",
    7: "\u1047",
    8: "\u1048",
    9: "\u1049",
    0: "\u1040"
  }, numberMap = {
    "\u1041": "1",
    "\u1042": "2",
    "\u1043": "3",
    "\u1044": "4",
    "\u1045": "5",
    "\u1046": "6",
    "\u1047": "7",
    "\u1048": "8",
    "\u1049": "9",
    "\u1040": "0"
  };
  var my = moment.defineLocale("my", {
    months: "\u1007\u1014\u103A\u1014\u101D\u102B\u101B\u102E_\u1016\u1031\u1016\u1031\u102C\u103A\u101D\u102B\u101B\u102E_\u1019\u1010\u103A_\u1027\u1015\u103C\u102E_\u1019\u1031_\u1007\u103D\u1014\u103A_\u1007\u1030\u101C\u102D\u102F\u1004\u103A_\u101E\u103C\u1002\u102F\u1010\u103A_\u1005\u1000\u103A\u1010\u1004\u103A\u1018\u102C_\u1021\u1031\u102C\u1000\u103A\u1010\u102D\u102F\u1018\u102C_\u1014\u102D\u102F\u101D\u1004\u103A\u1018\u102C_\u1012\u102E\u1007\u1004\u103A\u1018\u102C".split(
      "_"
    ),
    monthsShort: "\u1007\u1014\u103A_\u1016\u1031_\u1019\u1010\u103A_\u1015\u103C\u102E_\u1019\u1031_\u1007\u103D\u1014\u103A_\u101C\u102D\u102F\u1004\u103A_\u101E\u103C_\u1005\u1000\u103A_\u1021\u1031\u102C\u1000\u103A_\u1014\u102D\u102F_\u1012\u102E".split("_"),
    weekdays: "\u1010\u1014\u1004\u103A\u1039\u1002\u1014\u103D\u1031_\u1010\u1014\u1004\u103A\u1039\u101C\u102C_\u1021\u1004\u103A\u1039\u1002\u102B_\u1017\u102F\u1012\u1039\u1013\u101F\u1030\u1038_\u1000\u103C\u102C\u101E\u1015\u1010\u1031\u1038_\u101E\u1031\u102C\u1000\u103C\u102C_\u1005\u1014\u1031".split(
      "_"
    ),
    weekdaysShort: "\u1014\u103D\u1031_\u101C\u102C_\u1002\u102B_\u101F\u1030\u1038_\u1000\u103C\u102C_\u101E\u1031\u102C_\u1014\u1031".split("_"),
    weekdaysMin: "\u1014\u103D\u1031_\u101C\u102C_\u1002\u102B_\u101F\u1030\u1038_\u1000\u103C\u102C_\u101E\u1031\u102C_\u1014\u1031".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[\u101A\u1014\u1031.] LT [\u1019\u103E\u102C]",
      nextDay: "[\u1019\u1014\u1000\u103A\u1016\u103C\u1014\u103A] LT [\u1019\u103E\u102C]",
      nextWeek: "dddd LT [\u1019\u103E\u102C]",
      lastDay: "[\u1019\u1014\u1031.\u1000] LT [\u1019\u103E\u102C]",
      lastWeek: "[\u1015\u103C\u102E\u1038\u1001\u1032\u1037\u101E\u1031\u102C] dddd LT [\u1019\u103E\u102C]",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u101C\u102C\u1019\u100A\u103A\u1037 %s \u1019\u103E\u102C",
      past: "\u101C\u103D\u1014\u103A\u1001\u1032\u1037\u101E\u1031\u102C %s \u1000",
      s: "\u1005\u1000\u1039\u1000\u1014\u103A.\u1021\u1014\u100A\u103A\u1038\u1004\u101A\u103A",
      ss: "%d \u1005\u1000\u1039\u1000\u1014\u1037\u103A",
      m: "\u1010\u1005\u103A\u1019\u102D\u1014\u1005\u103A",
      mm: "%d \u1019\u102D\u1014\u1005\u103A",
      h: "\u1010\u1005\u103A\u1014\u102C\u101B\u102E",
      hh: "%d \u1014\u102C\u101B\u102E",
      d: "\u1010\u1005\u103A\u101B\u1000\u103A",
      dd: "%d \u101B\u1000\u103A",
      M: "\u1010\u1005\u103A\u101C",
      MM: "%d \u101C",
      y: "\u1010\u1005\u103A\u1014\u103E\u1005\u103A",
      yy: "%d \u1014\u103E\u1005\u103A"
    },
    preparse: function(string) {
      return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function(match) {
        return numberMap[match];
      });
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      });
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return my;
}));


/***/ }),

/***/ 29204:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var nb = moment.defineLocale("nb", {
    months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split(
      "_"
    ),
    monthsShort: "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
    monthsParseExact: true,
    weekdays: "s\xF8ndag_mandag_tirsdag_onsdag_torsdag_fredag_l\xF8rdag".split("_"),
    weekdaysShort: "s\xF8._ma._ti._on._to._fr._l\xF8.".split("_"),
    weekdaysMin: "s\xF8_ma_ti_on_to_fr_l\xF8".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY [kl.] HH:mm",
      LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
    },
    calendar: {
      sameDay: "[i dag kl.] LT",
      nextDay: "[i morgen kl.] LT",
      nextWeek: "dddd [kl.] LT",
      lastDay: "[i g\xE5r kl.] LT",
      lastWeek: "[forrige] dddd [kl.] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "om %s",
      past: "%s siden",
      s: "noen sekunder",
      ss: "%d sekunder",
      m: "ett minutt",
      mm: "%d minutter",
      h: "\xE9n time",
      hh: "%d timer",
      d: "\xE9n dag",
      dd: "%d dager",
      w: "\xE9n uke",
      ww: "%d uker",
      M: "\xE9n m\xE5ned",
      MM: "%d m\xE5neder",
      y: "ett \xE5r",
      yy: "%d \xE5r"
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return nb;
}));


/***/ }),

/***/ 43073:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u0967",
    2: "\u0968",
    3: "\u0969",
    4: "\u096A",
    5: "\u096B",
    6: "\u096C",
    7: "\u096D",
    8: "\u096E",
    9: "\u096F",
    0: "\u0966"
  }, numberMap = {
    "\u0967": "1",
    "\u0968": "2",
    "\u0969": "3",
    "\u096A": "4",
    "\u096B": "5",
    "\u096C": "6",
    "\u096D": "7",
    "\u096E": "8",
    "\u096F": "9",
    "\u0966": "0"
  };
  var ne = moment.defineLocale("ne", {
    months: "\u091C\u0928\u0935\u0930\u0940_\u092B\u0947\u092C\u094D\u0930\u0941\u0935\u0930\u0940_\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u093F\u0932_\u092E\u0908_\u091C\u0941\u0928_\u091C\u0941\u0932\u093E\u0908_\u0905\u0917\u0937\u094D\u091F_\u0938\u0947\u092A\u094D\u091F\u0947\u092E\u094D\u092C\u0930_\u0905\u0915\u094D\u091F\u094B\u092C\u0930_\u0928\u094B\u092D\u0947\u092E\u094D\u092C\u0930_\u0921\u093F\u0938\u0947\u092E\u094D\u092C\u0930".split(
      "_"
    ),
    monthsShort: "\u091C\u0928._\u092B\u0947\u092C\u094D\u0930\u0941._\u092E\u093E\u0930\u094D\u091A_\u0905\u092A\u094D\u0930\u093F._\u092E\u0908_\u091C\u0941\u0928_\u091C\u0941\u0932\u093E\u0908._\u0905\u0917._\u0938\u0947\u092A\u094D\u091F._\u0905\u0915\u094D\u091F\u094B._\u0928\u094B\u092D\u0947._\u0921\u093F\u0938\u0947.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "\u0906\u0907\u0924\u092C\u093E\u0930_\u0938\u094B\u092E\u092C\u093E\u0930_\u092E\u0919\u094D\u0917\u0932\u092C\u093E\u0930_\u092C\u0941\u0927\u092C\u093E\u0930_\u092C\u093F\u0939\u093F\u092C\u093E\u0930_\u0936\u0941\u0915\u094D\u0930\u092C\u093E\u0930_\u0936\u0928\u093F\u092C\u093E\u0930".split(
      "_"
    ),
    weekdaysShort: "\u0906\u0907\u0924._\u0938\u094B\u092E._\u092E\u0919\u094D\u0917\u0932._\u092C\u0941\u0927._\u092C\u093F\u0939\u093F._\u0936\u0941\u0915\u094D\u0930._\u0936\u0928\u093F.".split("_"),
    weekdaysMin: "\u0906._\u0938\u094B._\u092E\u0902._\u092C\u0941._\u092C\u093F._\u0936\u0941._\u0936.".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "A\u0915\u094B h:mm \u092C\u091C\u0947",
      LTS: "A\u0915\u094B h:mm:ss \u092C\u091C\u0947",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, A\u0915\u094B h:mm \u092C\u091C\u0947",
      LLLL: "dddd, D MMMM YYYY, A\u0915\u094B h:mm \u092C\u091C\u0947"
    },
    preparse: function(string) {
      return string.replace(/[१२३४५६७८९०]/g, function(match) {
        return numberMap[match];
      });
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      });
    },
    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u0930\u093E\u0924\u093F") {
        return hour < 4 ? hour : hour + 12;
      } else if (meridiem === "\u092C\u093F\u0939\u093E\u0928") {
        return hour;
      } else if (meridiem === "\u0926\u093F\u0909\u0901\u0938\u094B") {
        return hour >= 10 ? hour : hour + 12;
      } else if (meridiem === "\u0938\u093E\u0901\u091D") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 3) {
        return "\u0930\u093E\u0924\u093F";
      } else if (hour < 12) {
        return "\u092C\u093F\u0939\u093E\u0928";
      } else if (hour < 16) {
        return "\u0926\u093F\u0909\u0901\u0938\u094B";
      } else if (hour < 20) {
        return "\u0938\u093E\u0901\u091D";
      } else {
        return "\u0930\u093E\u0924\u093F";
      }
    },
    calendar: {
      sameDay: "[\u0906\u091C] LT",
      nextDay: "[\u092D\u094B\u0932\u093F] LT",
      nextWeek: "[\u0906\u0909\u0901\u0926\u094B] dddd[,] LT",
      lastDay: "[\u0939\u093F\u091C\u094B] LT",
      lastWeek: "[\u0917\u090F\u0915\u094B] dddd[,] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s\u092E\u093E",
      past: "%s \u0905\u0917\u093E\u0921\u093F",
      s: "\u0915\u0947\u0939\u0940 \u0915\u094D\u0937\u0923",
      ss: "%d \u0938\u0947\u0915\u0947\u0923\u094D\u0921",
      m: "\u090F\u0915 \u092E\u093F\u0928\u0947\u091F",
      mm: "%d \u092E\u093F\u0928\u0947\u091F",
      h: "\u090F\u0915 \u0918\u0923\u094D\u091F\u093E",
      hh: "%d \u0918\u0923\u094D\u091F\u093E",
      d: "\u090F\u0915 \u0926\u093F\u0928",
      dd: "%d \u0926\u093F\u0928",
      M: "\u090F\u0915 \u092E\u0939\u093F\u0928\u093E",
      MM: "%d \u092E\u0939\u093F\u0928\u093E",
      y: "\u090F\u0915 \u092C\u0930\u094D\u0937",
      yy: "%d \u092C\u0930\u094D\u0937"
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return ne;
}));


/***/ }),

/***/ 58734:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var monthsShortWithDots = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"), monthsShortWithoutDots = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"), monthsParse = [
    /^jan/i,
    /^feb/i,
    /^(maart|mrt\.?)$/i,
    /^apr/i,
    /^mei$/i,
    /^jun[i.]?$/i,
    /^jul[i.]?$/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ], monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
  var nlBe = moment.defineLocale("nl-be", {
    months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split(
      "_"
    ),
    monthsShort: function(m, format) {
      if (!m) {
        return monthsShortWithDots;
      } else if (/-MMM-/.test(format)) {
        return monthsShortWithoutDots[m.month()];
      } else {
        return monthsShortWithDots[m.month()];
      }
    },
    monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
    monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
    weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
    weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[vandaag om] LT",
      nextDay: "[morgen om] LT",
      nextWeek: "dddd [om] LT",
      lastDay: "[gisteren om] LT",
      lastWeek: "[afgelopen] dddd [om] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "over %s",
      past: "%s geleden",
      s: "een paar seconden",
      ss: "%d seconden",
      m: "\xE9\xE9n minuut",
      mm: "%d minuten",
      h: "\xE9\xE9n uur",
      hh: "%d uur",
      d: "\xE9\xE9n dag",
      dd: "%d dagen",
      M: "\xE9\xE9n maand",
      MM: "%d maanden",
      y: "\xE9\xE9n jaar",
      yy: "%d jaar"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal: function(number) {
      return number + (number === 1 || number === 8 || number >= 20 ? "ste" : "de");
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return nlBe;
}));


/***/ }),

/***/ 56586:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var monthsShortWithDots = "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"), monthsShortWithoutDots = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"), monthsParse = [
    /^jan/i,
    /^feb/i,
    /^(maart|mrt\.?)$/i,
    /^apr/i,
    /^mei$/i,
    /^jun[i.]?$/i,
    /^jul[i.]?$/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ], monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
  var nl = moment.defineLocale("nl", {
    months: "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split(
      "_"
    ),
    monthsShort: function(m, format) {
      if (!m) {
        return monthsShortWithDots;
      } else if (/-MMM-/.test(format)) {
        return monthsShortWithoutDots[m.month()];
      } else {
        return monthsShortWithDots[m.month()];
      }
    },
    monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
    monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays: "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),
    weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
    weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD-MM-YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[vandaag om] LT",
      nextDay: "[morgen om] LT",
      nextWeek: "dddd [om] LT",
      lastDay: "[gisteren om] LT",
      lastWeek: "[afgelopen] dddd [om] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "over %s",
      past: "%s geleden",
      s: "een paar seconden",
      ss: "%d seconden",
      m: "\xE9\xE9n minuut",
      mm: "%d minuten",
      h: "\xE9\xE9n uur",
      hh: "%d uur",
      d: "\xE9\xE9n dag",
      dd: "%d dagen",
      w: "\xE9\xE9n week",
      ww: "%d weken",
      M: "\xE9\xE9n maand",
      MM: "%d maanden",
      y: "\xE9\xE9n jaar",
      yy: "%d jaar"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal: function(number) {
      return number + (number === 1 || number === 8 || number >= 20 ? "ste" : "de");
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return nl;
}));


/***/ }),

/***/ 92544:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var nn = moment.defineLocale("nn", {
    months: "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split(
      "_"
    ),
    monthsShort: "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split("_"),
    monthsParseExact: true,
    weekdays: "sundag_m\xE5ndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),
    weekdaysShort: "su._m\xE5._ty._on._to._fr._lau.".split("_"),
    weekdaysMin: "su_m\xE5_ty_on_to_fr_la".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY [kl.] H:mm",
      LLLL: "dddd D. MMMM YYYY [kl.] HH:mm"
    },
    calendar: {
      sameDay: "[I dag klokka] LT",
      nextDay: "[I morgon klokka] LT",
      nextWeek: "dddd [klokka] LT",
      lastDay: "[I g\xE5r klokka] LT",
      lastWeek: "[F\xF8reg\xE5ande] dddd [klokka] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "om %s",
      past: "%s sidan",
      s: "nokre sekund",
      ss: "%d sekund",
      m: "eit minutt",
      mm: "%d minutt",
      h: "ein time",
      hh: "%d timar",
      d: "ein dag",
      dd: "%d dagar",
      w: "ei veke",
      ww: "%d veker",
      M: "ein m\xE5nad",
      MM: "%d m\xE5nader",
      y: "eit \xE5r",
      yy: "%d \xE5r"
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return nn;
}));


/***/ }),

/***/ 26828:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var ocLnc = moment.defineLocale("oc-lnc", {
    months: {
      standalone: "geni\xE8r_febri\xE8r_mar\xE7_abril_mai_junh_julhet_agost_setembre_oct\xF2bre_novembre_decembre".split(
        "_"
      ),
      format: "de geni\xE8r_de febri\xE8r_de mar\xE7_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'oct\xF2bre_de novembre_de decembre".split(
        "_"
      ),
      isFormat: /D[oD]?(\s)+MMMM/
    },
    monthsShort: "gen._febr._mar\xE7_abr._mai_junh_julh._ago._set._oct._nov._dec.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "dimenge_diluns_dimars_dim\xE8cres_dij\xF2us_divendres_dissabte".split(
      "_"
    ),
    weekdaysShort: "dg._dl._dm._dc._dj._dv._ds.".split("_"),
    weekdaysMin: "dg_dl_dm_dc_dj_dv_ds".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM [de] YYYY",
      ll: "D MMM YYYY",
      LLL: "D MMMM [de] YYYY [a] H:mm",
      lll: "D MMM YYYY, H:mm",
      LLLL: "dddd D MMMM [de] YYYY [a] H:mm",
      llll: "ddd D MMM YYYY, H:mm"
    },
    calendar: {
      sameDay: "[u\xE8i a] LT",
      nextDay: "[deman a] LT",
      nextWeek: "dddd [a] LT",
      lastDay: "[i\xE8r a] LT",
      lastWeek: "dddd [passat a] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "d'aqu\xED %s",
      past: "fa %s",
      s: "unas segondas",
      ss: "%d segondas",
      m: "una minuta",
      mm: "%d minutas",
      h: "una ora",
      hh: "%d oras",
      d: "un jorn",
      dd: "%d jorns",
      M: "un mes",
      MM: "%d meses",
      y: "un an",
      yy: "%d ans"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
    ordinal: function(number, period) {
      var output = number === 1 ? "r" : number === 2 ? "n" : number === 3 ? "r" : number === 4 ? "t" : "\xE8";
      if (period === "w" || period === "W") {
        output = "a";
      }
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
    }
  });
  return ocLnc;
}));


/***/ }),

/***/ 13891:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u0A67",
    2: "\u0A68",
    3: "\u0A69",
    4: "\u0A6A",
    5: "\u0A6B",
    6: "\u0A6C",
    7: "\u0A6D",
    8: "\u0A6E",
    9: "\u0A6F",
    0: "\u0A66"
  }, numberMap = {
    "\u0A67": "1",
    "\u0A68": "2",
    "\u0A69": "3",
    "\u0A6A": "4",
    "\u0A6B": "5",
    "\u0A6C": "6",
    "\u0A6D": "7",
    "\u0A6E": "8",
    "\u0A6F": "9",
    "\u0A66": "0"
  };
  var paIn = moment.defineLocale("pa-in", {
    // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
    months: "\u0A1C\u0A28\u0A35\u0A30\u0A40_\u0A2B\u0A3C\u0A30\u0A35\u0A30\u0A40_\u0A2E\u0A3E\u0A30\u0A1A_\u0A05\u0A2A\u0A4D\u0A30\u0A48\u0A32_\u0A2E\u0A08_\u0A1C\u0A42\u0A28_\u0A1C\u0A41\u0A32\u0A3E\u0A08_\u0A05\u0A17\u0A38\u0A24_\u0A38\u0A24\u0A70\u0A2C\u0A30_\u0A05\u0A15\u0A24\u0A42\u0A2C\u0A30_\u0A28\u0A35\u0A70\u0A2C\u0A30_\u0A26\u0A38\u0A70\u0A2C\u0A30".split(
      "_"
    ),
    monthsShort: "\u0A1C\u0A28\u0A35\u0A30\u0A40_\u0A2B\u0A3C\u0A30\u0A35\u0A30\u0A40_\u0A2E\u0A3E\u0A30\u0A1A_\u0A05\u0A2A\u0A4D\u0A30\u0A48\u0A32_\u0A2E\u0A08_\u0A1C\u0A42\u0A28_\u0A1C\u0A41\u0A32\u0A3E\u0A08_\u0A05\u0A17\u0A38\u0A24_\u0A38\u0A24\u0A70\u0A2C\u0A30_\u0A05\u0A15\u0A24\u0A42\u0A2C\u0A30_\u0A28\u0A35\u0A70\u0A2C\u0A30_\u0A26\u0A38\u0A70\u0A2C\u0A30".split(
      "_"
    ),
    weekdays: "\u0A10\u0A24\u0A35\u0A3E\u0A30_\u0A38\u0A4B\u0A2E\u0A35\u0A3E\u0A30_\u0A2E\u0A70\u0A17\u0A32\u0A35\u0A3E\u0A30_\u0A2C\u0A41\u0A27\u0A35\u0A3E\u0A30_\u0A35\u0A40\u0A30\u0A35\u0A3E\u0A30_\u0A38\u0A3C\u0A41\u0A71\u0A15\u0A30\u0A35\u0A3E\u0A30_\u0A38\u0A3C\u0A28\u0A40\u0A1A\u0A30\u0A35\u0A3E\u0A30".split(
      "_"
    ),
    weekdaysShort: "\u0A10\u0A24_\u0A38\u0A4B\u0A2E_\u0A2E\u0A70\u0A17\u0A32_\u0A2C\u0A41\u0A27_\u0A35\u0A40\u0A30_\u0A38\u0A3C\u0A41\u0A15\u0A30_\u0A38\u0A3C\u0A28\u0A40".split("_"),
    weekdaysMin: "\u0A10\u0A24_\u0A38\u0A4B\u0A2E_\u0A2E\u0A70\u0A17\u0A32_\u0A2C\u0A41\u0A27_\u0A35\u0A40\u0A30_\u0A38\u0A3C\u0A41\u0A15\u0A30_\u0A38\u0A3C\u0A28\u0A40".split("_"),
    longDateFormat: {
      LT: "A h:mm \u0A35\u0A1C\u0A47",
      LTS: "A h:mm:ss \u0A35\u0A1C\u0A47",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, A h:mm \u0A35\u0A1C\u0A47",
      LLLL: "dddd, D MMMM YYYY, A h:mm \u0A35\u0A1C\u0A47"
    },
    calendar: {
      sameDay: "[\u0A05\u0A1C] LT",
      nextDay: "[\u0A15\u0A32] LT",
      nextWeek: "[\u0A05\u0A17\u0A32\u0A3E] dddd, LT",
      lastDay: "[\u0A15\u0A32] LT",
      lastWeek: "[\u0A2A\u0A3F\u0A1B\u0A32\u0A47] dddd, LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0A35\u0A3F\u0A71\u0A1A",
      past: "%s \u0A2A\u0A3F\u0A1B\u0A32\u0A47",
      s: "\u0A15\u0A41\u0A1D \u0A38\u0A15\u0A3F\u0A70\u0A1F",
      ss: "%d \u0A38\u0A15\u0A3F\u0A70\u0A1F",
      m: "\u0A07\u0A15 \u0A2E\u0A3F\u0A70\u0A1F",
      mm: "%d \u0A2E\u0A3F\u0A70\u0A1F",
      h: "\u0A07\u0A71\u0A15 \u0A18\u0A70\u0A1F\u0A3E",
      hh: "%d \u0A18\u0A70\u0A1F\u0A47",
      d: "\u0A07\u0A71\u0A15 \u0A26\u0A3F\u0A28",
      dd: "%d \u0A26\u0A3F\u0A28",
      M: "\u0A07\u0A71\u0A15 \u0A2E\u0A39\u0A40\u0A28\u0A3E",
      MM: "%d \u0A2E\u0A39\u0A40\u0A28\u0A47",
      y: "\u0A07\u0A71\u0A15 \u0A38\u0A3E\u0A32",
      yy: "%d \u0A38\u0A3E\u0A32"
    },
    preparse: function(string) {
      return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function(match) {
        return numberMap[match];
      });
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      });
    },
    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u0A30\u0A3E\u0A24") {
        return hour < 4 ? hour : hour + 12;
      } else if (meridiem === "\u0A38\u0A35\u0A47\u0A30") {
        return hour;
      } else if (meridiem === "\u0A26\u0A41\u0A2A\u0A39\u0A3F\u0A30") {
        return hour >= 10 ? hour : hour + 12;
      } else if (meridiem === "\u0A38\u0A3C\u0A3E\u0A2E") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u0A30\u0A3E\u0A24";
      } else if (hour < 10) {
        return "\u0A38\u0A35\u0A47\u0A30";
      } else if (hour < 17) {
        return "\u0A26\u0A41\u0A2A\u0A39\u0A3F\u0A30";
      } else if (hour < 20) {
        return "\u0A38\u0A3C\u0A3E\u0A2E";
      } else {
        return "\u0A30\u0A3E\u0A24";
      }
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return paIn;
}));


/***/ }),

/***/ 62020:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var monthsNominative = "stycze\u0144_luty_marzec_kwiecie\u0144_maj_czerwiec_lipiec_sierpie\u0144_wrzesie\u0144_pa\u017Adziernik_listopad_grudzie\u0144".split(
    "_"
  ), monthsSubjective = "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_wrze\u015Bnia_pa\u017Adziernika_listopada_grudnia".split(
    "_"
  ), monthsParse = [
    /^sty/i,
    /^lut/i,
    /^mar/i,
    /^kwi/i,
    /^maj/i,
    /^cze/i,
    /^lip/i,
    /^sie/i,
    /^wrz/i,
    /^paź/i,
    /^lis/i,
    /^gru/i
  ];
  function plural(n) {
    return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
  }
  function translate(number, withoutSuffix, key) {
    var result = number + " ";
    switch (key) {
      case "ss":
        return result + (plural(number) ? "sekundy" : "sekund");
      case "m":
        return withoutSuffix ? "minuta" : "minut\u0119";
      case "mm":
        return result + (plural(number) ? "minuty" : "minut");
      case "h":
        return withoutSuffix ? "godzina" : "godzin\u0119";
      case "hh":
        return result + (plural(number) ? "godziny" : "godzin");
      case "ww":
        return result + (plural(number) ? "tygodnie" : "tygodni");
      case "MM":
        return result + (plural(number) ? "miesi\u0105ce" : "miesi\u0119cy");
      case "yy":
        return result + (plural(number) ? "lata" : "lat");
    }
  }
  var pl = moment.defineLocale("pl", {
    months: function(momentToFormat, format) {
      if (!momentToFormat) {
        return monthsNominative;
      } else if (/D MMMM/.test(format)) {
        return monthsSubjective[momentToFormat.month()];
      } else {
        return monthsNominative[momentToFormat.month()];
      }
    },
    monthsShort: "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_pa\u017A_lis_gru".split("_"),
    monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays: "niedziela_poniedzia\u0142ek_wtorek_\u015Broda_czwartek_pi\u0105tek_sobota".split("_"),
    weekdaysShort: "ndz_pon_wt_\u015Br_czw_pt_sob".split("_"),
    weekdaysMin: "Nd_Pn_Wt_\u015Ar_Cz_Pt_So".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Dzi\u015B o] LT",
      nextDay: "[Jutro o] LT",
      nextWeek: function() {
        switch (this.day()) {
          case 0:
            return "[W niedziel\u0119 o] LT";
          case 2:
            return "[We wtorek o] LT";
          case 3:
            return "[W \u015Brod\u0119 o] LT";
          case 6:
            return "[W sobot\u0119 o] LT";
          default:
            return "[W] dddd [o] LT";
        }
      },
      lastDay: "[Wczoraj o] LT",
      lastWeek: function() {
        switch (this.day()) {
          case 0:
            return "[W zesz\u0142\u0105 niedziel\u0119 o] LT";
          case 3:
            return "[W zesz\u0142\u0105 \u015Brod\u0119 o] LT";
          case 6:
            return "[W zesz\u0142\u0105 sobot\u0119 o] LT";
          default:
            return "[W zesz\u0142y] dddd [o] LT";
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "za %s",
      past: "%s temu",
      s: "kilka sekund",
      ss: translate,
      m: translate,
      mm: translate,
      h: translate,
      hh: translate,
      d: "1 dzie\u0144",
      dd: "%d dni",
      w: "tydzie\u0144",
      ww: translate,
      M: "miesi\u0105c",
      MM: translate,
      y: "rok",
      yy: translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return pl;
}));


/***/ }),

/***/ 25277:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var ptBr = moment.defineLocale("pt-br", {
    months: "janeiro_fevereiro_mar\xE7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split(
      "_"
    ),
    monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
    weekdays: "domingo_segunda-feira_ter\xE7a-feira_quarta-feira_quinta-feira_sexta-feira_s\xE1bado".split(
      "_"
    ),
    weekdaysShort: "dom_seg_ter_qua_qui_sex_s\xE1b".split("_"),
    weekdaysMin: "do_2\xAA_3\xAA_4\xAA_5\xAA_6\xAA_s\xE1".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D [de] MMMM [de] YYYY",
      LLL: "D [de] MMMM [de] YYYY [\xE0s] HH:mm",
      LLLL: "dddd, D [de] MMMM [de] YYYY [\xE0s] HH:mm"
    },
    calendar: {
      sameDay: "[Hoje \xE0s] LT",
      nextDay: "[Amanh\xE3 \xE0s] LT",
      nextWeek: "dddd [\xE0s] LT",
      lastDay: "[Ontem \xE0s] LT",
      lastWeek: function() {
        return this.day() === 0 || this.day() === 6 ? "[\xDAltimo] dddd [\xE0s] LT" : "[\xDAltima] dddd [\xE0s] LT";
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "em %s",
      past: "h\xE1 %s",
      s: "poucos segundos",
      ss: "%d segundos",
      m: "um minuto",
      mm: "%d minutos",
      h: "uma hora",
      hh: "%d horas",
      d: "um dia",
      dd: "%d dias",
      M: "um m\xEAs",
      MM: "%d meses",
      y: "um ano",
      yy: "%d anos"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: "%d\xBA",
    invalidDate: "Data inv\xE1lida"
  });
  return ptBr;
}));


/***/ }),

/***/ 72876:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var pt = moment.defineLocale("pt", {
    months: "janeiro_fevereiro_mar\xE7o_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split(
      "_"
    ),
    monthsShort: "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
    weekdays: "Domingo_Segunda-feira_Ter\xE7a-feira_Quarta-feira_Quinta-feira_Sexta-feira_S\xE1bado".split(
      "_"
    ),
    weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_S\xE1b".split("_"),
    weekdaysMin: "Do_2\xAA_3\xAA_4\xAA_5\xAA_6\xAA_S\xE1".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D [de] MMMM [de] YYYY",
      LLL: "D [de] MMMM [de] YYYY HH:mm",
      LLLL: "dddd, D [de] MMMM [de] YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Hoje \xE0s] LT",
      nextDay: "[Amanh\xE3 \xE0s] LT",
      nextWeek: "dddd [\xE0s] LT",
      lastDay: "[Ontem \xE0s] LT",
      lastWeek: function() {
        return this.day() === 0 || this.day() === 6 ? "[\xDAltimo] dddd [\xE0s] LT" : "[\xDAltima] dddd [\xE0s] LT";
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "em %s",
      past: "h\xE1 %s",
      s: "segundos",
      ss: "%d segundos",
      m: "um minuto",
      mm: "%d minutos",
      h: "uma hora",
      hh: "%d horas",
      d: "um dia",
      dd: "%d dias",
      w: "uma semana",
      ww: "%d semanas",
      M: "um m\xEAs",
      MM: "%d meses",
      y: "um ano",
      yy: "%d anos"
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: "%d\xBA",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return pt;
}));


/***/ }),

/***/ 26979:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
      ss: "secunde",
      mm: "minute",
      hh: "ore",
      dd: "zile",
      ww: "s\u0103pt\u0103m\xE2ni",
      MM: "luni",
      yy: "ani"
    }, separator = " ";
    if (number % 100 >= 20 || number >= 100 && number % 100 === 0) {
      separator = " de ";
    }
    return number + separator + format[key];
  }
  var ro = moment.defineLocale("ro", {
    months: "ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split(
      "_"
    ),
    monthsShort: "ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "duminic\u0103_luni_mar\u021Bi_miercuri_joi_vineri_s\xE2mb\u0103t\u0103".split("_"),
    weekdaysShort: "Dum_Lun_Mar_Mie_Joi_Vin_S\xE2m".split("_"),
    weekdaysMin: "Du_Lu_Ma_Mi_Jo_Vi_S\xE2".split("_"),
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY H:mm",
      LLLL: "dddd, D MMMM YYYY H:mm"
    },
    calendar: {
      sameDay: "[azi la] LT",
      nextDay: "[m\xE2ine la] LT",
      nextWeek: "dddd [la] LT",
      lastDay: "[ieri la] LT",
      lastWeek: "[fosta] dddd [la] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "peste %s",
      past: "%s \xEEn urm\u0103",
      s: "c\xE2teva secunde",
      ss: relativeTimeWithPlural,
      m: "un minut",
      mm: relativeTimeWithPlural,
      h: "o or\u0103",
      hh: relativeTimeWithPlural,
      d: "o zi",
      dd: relativeTimeWithPlural,
      w: "o s\u0103pt\u0103m\xE2n\u0103",
      ww: relativeTimeWithPlural,
      M: "o lun\u0103",
      MM: relativeTimeWithPlural,
      y: "un an",
      yy: relativeTimeWithPlural
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return ro;
}));


/***/ }),

/***/ 55581:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function plural(word, num) {
    var forms = word.split("_");
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
  }
  function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
      ss: withoutSuffix ? "\u0441\u0435\u043A\u0443\u043D\u0434\u0430_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434" : "\u0441\u0435\u043A\u0443\u043D\u0434\u0443_\u0441\u0435\u043A\u0443\u043D\u0434\u044B_\u0441\u0435\u043A\u0443\u043D\u0434",
      mm: withoutSuffix ? "\u043C\u0438\u043D\u0443\u0442\u0430_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442" : "\u043C\u0438\u043D\u0443\u0442\u0443_\u043C\u0438\u043D\u0443\u0442\u044B_\u043C\u0438\u043D\u0443\u0442",
      hh: "\u0447\u0430\u0441_\u0447\u0430\u0441\u0430_\u0447\u0430\u0441\u043E\u0432",
      dd: "\u0434\u0435\u043D\u044C_\u0434\u043D\u044F_\u0434\u043D\u0435\u0439",
      ww: "\u043D\u0435\u0434\u0435\u043B\u044F_\u043D\u0435\u0434\u0435\u043B\u0438_\u043D\u0435\u0434\u0435\u043B\u044C",
      MM: "\u043C\u0435\u0441\u044F\u0446_\u043C\u0435\u0441\u044F\u0446\u0430_\u043C\u0435\u0441\u044F\u0446\u0435\u0432",
      yy: "\u0433\u043E\u0434_\u0433\u043E\u0434\u0430_\u043B\u0435\u0442"
    };
    if (key === "m") {
      return withoutSuffix ? "\u043C\u0438\u043D\u0443\u0442\u0430" : "\u043C\u0438\u043D\u0443\u0442\u0443";
    } else {
      return number + " " + plural(format[key], +number);
    }
  }
  var monthsParse = [
    /^янв/i,
    /^фев/i,
    /^мар/i,
    /^апр/i,
    /^ма[йя]/i,
    /^июн/i,
    /^июл/i,
    /^авг/i,
    /^сен/i,
    /^окт/i,
    /^ноя/i,
    /^дек/i
  ];
  var ru = moment.defineLocale("ru", {
    months: {
      format: "\u044F\u043D\u0432\u0430\u0440\u044F_\u0444\u0435\u0432\u0440\u0430\u043B\u044F_\u043C\u0430\u0440\u0442\u0430_\u0430\u043F\u0440\u0435\u043B\u044F_\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433\u0443\u0441\u0442\u0430_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F_\u043E\u043A\u0442\u044F\u0431\u0440\u044F_\u043D\u043E\u044F\u0431\u0440\u044F_\u0434\u0435\u043A\u0430\u0431\u0440\u044F".split(
        "_"
      ),
      standalone: "\u044F\u043D\u0432\u0430\u0440\u044C_\u0444\u0435\u0432\u0440\u0430\u043B\u044C_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B\u044C_\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C_\u043E\u043A\u0442\u044F\u0431\u0440\u044C_\u043D\u043E\u044F\u0431\u0440\u044C_\u0434\u0435\u043A\u0430\u0431\u0440\u044C".split(
        "_"
      )
    },
    monthsShort: {
      // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
      format: "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440._\u0430\u043F\u0440._\u043C\u0430\u044F_\u0438\u044E\u043D\u044F_\u0438\u044E\u043B\u044F_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split(
        "_"
      ),
      standalone: "\u044F\u043D\u0432._\u0444\u0435\u0432\u0440._\u043C\u0430\u0440\u0442_\u0430\u043F\u0440._\u043C\u0430\u0439_\u0438\u044E\u043D\u044C_\u0438\u044E\u043B\u044C_\u0430\u0432\u0433._\u0441\u0435\u043D\u0442._\u043E\u043A\u0442._\u043D\u043E\u044F\u0431._\u0434\u0435\u043A.".split(
        "_"
      )
    },
    weekdays: {
      standalone: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0430_\u0441\u0443\u0431\u0431\u043E\u0442\u0430".split(
        "_"
      ),
      format: "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440\u0433_\u043F\u044F\u0442\u043D\u0438\u0446\u0443_\u0441\u0443\u0431\u0431\u043E\u0442\u0443".split(
        "_"
      ),
      isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/
    },
    weekdaysShort: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
    weekdaysMin: "\u0432\u0441_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
    monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
    // копия предыдущего
    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
    // полные названия с падежами
    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
    // Выражение, которое соответствует только сокращённым формам
    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY \u0433.",
      LLL: "D MMMM YYYY \u0433., H:mm",
      LLLL: "dddd, D MMMM YYYY \u0433., H:mm"
    },
    calendar: {
      sameDay: "[\u0421\u0435\u0433\u043E\u0434\u043D\u044F, \u0432] LT",
      nextDay: "[\u0417\u0430\u0432\u0442\u0440\u0430, \u0432] LT",
      lastDay: "[\u0412\u0447\u0435\u0440\u0430, \u0432] LT",
      nextWeek: function(now) {
        if (now.week() !== this.week()) {
          switch (this.day()) {
            case 0:
              return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435] dddd, [\u0432] LT";
            case 1:
            case 2:
            case 4:
              return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439] dddd, [\u0432] LT";
            case 3:
            case 5:
            case 6:
              return "[\u0412 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E] dddd, [\u0432] LT";
          }
        } else {
          if (this.day() === 2) {
            return "[\u0412\u043E] dddd, [\u0432] LT";
          } else {
            return "[\u0412] dddd, [\u0432] LT";
          }
        }
      },
      lastWeek: function(now) {
        if (now.week() !== this.week()) {
          switch (this.day()) {
            case 0:
              return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u043E\u0435] dddd, [\u0432] LT";
            case 1:
            case 2:
            case 4:
              return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u044B\u0439] dddd, [\u0432] LT";
            case 3:
            case 5:
            case 6:
              return "[\u0412 \u043F\u0440\u043E\u0448\u043B\u0443\u044E] dddd, [\u0432] LT";
          }
        } else {
          if (this.day() === 2) {
            return "[\u0412\u043E] dddd, [\u0432] LT";
          } else {
            return "[\u0412] dddd, [\u0432] LT";
          }
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0447\u0435\u0440\u0435\u0437 %s",
      past: "%s \u043D\u0430\u0437\u0430\u0434",
      s: "\u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434",
      ss: relativeTimeWithPlural,
      m: relativeTimeWithPlural,
      mm: relativeTimeWithPlural,
      h: "\u0447\u0430\u0441",
      hh: relativeTimeWithPlural,
      d: "\u0434\u0435\u043D\u044C",
      dd: relativeTimeWithPlural,
      w: "\u043D\u0435\u0434\u0435\u043B\u044F",
      ww: relativeTimeWithPlural,
      M: "\u043C\u0435\u0441\u044F\u0446",
      MM: relativeTimeWithPlural,
      y: "\u0433\u043E\u0434",
      yy: relativeTimeWithPlural
    },
    meridiemParse: /ночи|утра|дня|вечера/i,
    isPM: function(input) {
      return /^(дня|вечера)$/.test(input);
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u043D\u043E\u0447\u0438";
      } else if (hour < 12) {
        return "\u0443\u0442\u0440\u0430";
      } else if (hour < 17) {
        return "\u0434\u043D\u044F";
      } else {
        return "\u0432\u0435\u0447\u0435\u0440\u0430";
      }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
    ordinal: function(number, period) {
      switch (period) {
        case "M":
        case "d":
        case "DDD":
          return number + "-\u0439";
        case "D":
          return number + "-\u0433\u043E";
        case "w":
        case "W":
          return number + "-\u044F";
        default:
          return number;
      }
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return ru;
}));


/***/ }),

/***/ 22075:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var months = [
    "\u062C\u0646\u0648\u0631\u064A",
    "\u0641\u064A\u0628\u0631\u0648\u0631\u064A",
    "\u0645\u0627\u0631\u0686",
    "\u0627\u067E\u0631\u064A\u0644",
    "\u0645\u0626\u064A",
    "\u062C\u0648\u0646",
    "\u062C\u0648\u0644\u0627\u0621\u0650",
    "\u0622\u06AF\u0633\u067D",
    "\u0633\u064A\u067E\u067D\u0645\u0628\u0631",
    "\u0622\u06AA\u067D\u0648\u0628\u0631",
    "\u0646\u0648\u0645\u0628\u0631",
    "\u068A\u0633\u0645\u0628\u0631"
  ], days = ["\u0622\u0686\u0631", "\u0633\u0648\u0645\u0631", "\u0627\u06B1\u0627\u0631\u0648", "\u0627\u0631\u0628\u0639", "\u062E\u0645\u064A\u0633", "\u062C\u0645\u0639", "\u0687\u0646\u0687\u0631"];
  var sd = moment.defineLocale("sd", {
    months,
    monthsShort: months,
    weekdays: days,
    weekdaysShort: days,
    weekdaysMin: days,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd\u060C D MMMM YYYY HH:mm"
    },
    meridiemParse: /صبح|شام/,
    isPM: function(input) {
      return "\u0634\u0627\u0645" === input;
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u0635\u0628\u062D";
      }
      return "\u0634\u0627\u0645";
    },
    calendar: {
      sameDay: "[\u0627\u0684] LT",
      nextDay: "[\u0633\u0680\u0627\u06BB\u064A] LT",
      nextWeek: "dddd [\u0627\u06B3\u064A\u0646 \u0647\u0641\u062A\u064A \u062A\u064A] LT",
      lastDay: "[\u06AA\u0627\u0644\u0647\u0647] LT",
      lastWeek: "[\u06AF\u0632\u0631\u064A\u0644 \u0647\u0641\u062A\u064A] dddd [\u062A\u064A] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u067E\u0648\u0621",
      past: "%s \u0627\u06B3",
      s: "\u0686\u0646\u062F \u0633\u064A\u06AA\u0646\u068A",
      ss: "%d \u0633\u064A\u06AA\u0646\u068A",
      m: "\u0647\u06AA \u0645\u0646\u067D",
      mm: "%d \u0645\u0646\u067D",
      h: "\u0647\u06AA \u06AA\u0644\u0627\u06AA",
      hh: "%d \u06AA\u0644\u0627\u06AA",
      d: "\u0647\u06AA \u068F\u064A\u0646\u0647\u0646",
      dd: "%d \u068F\u064A\u0646\u0647\u0646",
      M: "\u0647\u06AA \u0645\u0647\u064A\u0646\u0648",
      MM: "%d \u0645\u0647\u064A\u0646\u0627",
      y: "\u0647\u06AA \u0633\u0627\u0644",
      yy: "%d \u0633\u0627\u0644"
    },
    preparse: function(string) {
      return string.replace(/،/g, ",");
    },
    postformat: function(string) {
      return string.replace(/,/g, "\u060C");
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return sd;
}));


/***/ }),

/***/ 74132:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var se = moment.defineLocale("se", {
    months: "o\u0111\u0111ajagem\xE1nnu_guovvam\xE1nnu_njuk\u010Dam\xE1nnu_cuo\u014Bom\xE1nnu_miessem\xE1nnu_geassem\xE1nnu_suoidnem\xE1nnu_borgem\xE1nnu_\u010Dak\u010Dam\xE1nnu_golggotm\xE1nnu_sk\xE1bmam\xE1nnu_juovlam\xE1nnu".split(
      "_"
    ),
    monthsShort: "o\u0111\u0111j_guov_njuk_cuo_mies_geas_suoi_borg_\u010Dak\u010D_golg_sk\xE1b_juov".split("_"),
    weekdays: "sotnabeaivi_vuoss\xE1rga_ma\u014B\u014Beb\xE1rga_gaskavahkku_duorastat_bearjadat_l\xE1vvardat".split(
      "_"
    ),
    weekdaysShort: "sotn_vuos_ma\u014B_gask_duor_bear_l\xE1v".split("_"),
    weekdaysMin: "s_v_m_g_d_b_L".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "MMMM D. [b.] YYYY",
      LLL: "MMMM D. [b.] YYYY [ti.] HH:mm",
      LLLL: "dddd, MMMM D. [b.] YYYY [ti.] HH:mm"
    },
    calendar: {
      sameDay: "[otne ti] LT",
      nextDay: "[ihttin ti] LT",
      nextWeek: "dddd [ti] LT",
      lastDay: "[ikte ti] LT",
      lastWeek: "[ovddit] dddd [ti] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s gea\u017Ees",
      past: "ma\u014Bit %s",
      s: "moadde sekunddat",
      ss: "%d sekunddat",
      m: "okta minuhta",
      mm: "%d minuhtat",
      h: "okta diimmu",
      hh: "%d diimmut",
      d: "okta beaivi",
      dd: "%d beaivvit",
      M: "okta m\xE1nnu",
      MM: "%d m\xE1nut",
      y: "okta jahki",
      yy: "%d jagit"
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return se;
}));


/***/ }),

/***/ 2784:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var si = moment.defineLocale("si", {
    months: "\u0DA2\u0DB1\u0DC0\u0DCF\u0DBB\u0DD2_\u0DB4\u0DD9\u0DB6\u0DBB\u0DC0\u0DCF\u0DBB\u0DD2_\u0DB8\u0DCF\u0DBB\u0DCA\u0DAD\u0DD4_\u0D85\u0DB4\u0DCA\u200D\u0DBB\u0DDA\u0DBD\u0DCA_\u0DB8\u0DD0\u0DBA\u0DD2_\u0DA2\u0DD6\u0DB1\u0DD2_\u0DA2\u0DD6\u0DBD\u0DD2_\u0D85\u0D9C\u0DDD\u0DC3\u0DCA\u0DAD\u0DD4_\u0DC3\u0DD0\u0DB4\u0DCA\u0DAD\u0DD0\u0DB8\u0DCA\u0DB6\u0DBB\u0DCA_\u0D94\u0D9A\u0DCA\u0DAD\u0DDD\u0DB6\u0DBB\u0DCA_\u0DB1\u0DDC\u0DC0\u0DD0\u0DB8\u0DCA\u0DB6\u0DBB\u0DCA_\u0DAF\u0DD9\u0DC3\u0DD0\u0DB8\u0DCA\u0DB6\u0DBB\u0DCA".split(
      "_"
    ),
    monthsShort: "\u0DA2\u0DB1_\u0DB4\u0DD9\u0DB6_\u0DB8\u0DCF\u0DBB\u0DCA_\u0D85\u0DB4\u0DCA_\u0DB8\u0DD0\u0DBA\u0DD2_\u0DA2\u0DD6\u0DB1\u0DD2_\u0DA2\u0DD6\u0DBD\u0DD2_\u0D85\u0D9C\u0DDD_\u0DC3\u0DD0\u0DB4\u0DCA_\u0D94\u0D9A\u0DCA_\u0DB1\u0DDC\u0DC0\u0DD0_\u0DAF\u0DD9\u0DC3\u0DD0".split(
      "_"
    ),
    weekdays: "\u0D89\u0DBB\u0DD2\u0DAF\u0DCF_\u0DC3\u0DB3\u0DD4\u0DAF\u0DCF_\u0D85\u0D9F\u0DC4\u0DBB\u0DD4\u0DC0\u0DCF\u0DAF\u0DCF_\u0DB6\u0DAF\u0DCF\u0DAF\u0DCF_\u0DB6\u0DCA\u200D\u0DBB\u0DC4\u0DC3\u0DCA\u0DB4\u0DAD\u0DD2\u0DB1\u0DCA\u0DAF\u0DCF_\u0DC3\u0DD2\u0D9A\u0DD4\u0DBB\u0DCF\u0DAF\u0DCF_\u0DC3\u0DD9\u0DB1\u0DC3\u0DD4\u0DBB\u0DCF\u0DAF\u0DCF".split(
      "_"
    ),
    weekdaysShort: "\u0D89\u0DBB\u0DD2_\u0DC3\u0DB3\u0DD4_\u0D85\u0D9F_\u0DB6\u0DAF\u0DCF_\u0DB6\u0DCA\u200D\u0DBB\u0DC4_\u0DC3\u0DD2\u0D9A\u0DD4_\u0DC3\u0DD9\u0DB1".split("_"),
    weekdaysMin: "\u0D89_\u0DC3_\u0D85_\u0DB6_\u0DB6\u0DCA\u200D\u0DBB_\u0DC3\u0DD2_\u0DC3\u0DD9".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "a h:mm",
      LTS: "a h:mm:ss",
      L: "YYYY/MM/DD",
      LL: "YYYY MMMM D",
      LLL: "YYYY MMMM D, a h:mm",
      LLLL: "YYYY MMMM D [\u0DC0\u0DD0\u0DB1\u0DD2] dddd, a h:mm:ss"
    },
    calendar: {
      sameDay: "[\u0D85\u0DAF] LT[\u0DA7]",
      nextDay: "[\u0DC4\u0DD9\u0DA7] LT[\u0DA7]",
      nextWeek: "dddd LT[\u0DA7]",
      lastDay: "[\u0D8A\u0DBA\u0DDA] LT[\u0DA7]",
      lastWeek: "[\u0DB4\u0DC3\u0DD4\u0D9C\u0DD2\u0DBA] dddd LT[\u0DA7]",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s\u0D9A\u0DD2\u0DB1\u0DCA",
      past: "%s\u0D9A\u0DA7 \u0DB4\u0DD9\u0DBB",
      s: "\u0DAD\u0DAD\u0DCA\u0DB4\u0DBB \u0D9A\u0DD2\u0DC4\u0DD2\u0DB4\u0DBA",
      ss: "\u0DAD\u0DAD\u0DCA\u0DB4\u0DBB %d",
      m: "\u0DB8\u0DD2\u0DB1\u0DD2\u0DAD\u0DCA\u0DAD\u0DD4\u0DC0",
      mm: "\u0DB8\u0DD2\u0DB1\u0DD2\u0DAD\u0DCA\u0DAD\u0DD4 %d",
      h: "\u0DB4\u0DD0\u0DBA",
      hh: "\u0DB4\u0DD0\u0DBA %d",
      d: "\u0DAF\u0DD2\u0DB1\u0DBA",
      dd: "\u0DAF\u0DD2\u0DB1 %d",
      M: "\u0DB8\u0DCF\u0DC3\u0DBA",
      MM: "\u0DB8\u0DCF\u0DC3 %d",
      y: "\u0DC0\u0DC3\u0DBB",
      yy: "\u0DC0\u0DC3\u0DBB %d"
    },
    dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
    ordinal: function(number) {
      return number + " \u0DC0\u0DD0\u0DB1\u0DD2";
    },
    meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
    isPM: function(input) {
      return input === "\u0DB4.\u0DC0." || input === "\u0DB4\u0DC3\u0DCA \u0DC0\u0DBB\u0DD4";
    },
    meridiem: function(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? "\u0DB4.\u0DC0." : "\u0DB4\u0DC3\u0DCA \u0DC0\u0DBB\u0DD4";
      } else {
        return isLower ? "\u0DB4\u0DD9.\u0DC0." : "\u0DB4\u0DD9\u0DBB \u0DC0\u0DBB\u0DD4";
      }
    }
  });
  return si;
}));


/***/ }),

/***/ 33578:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var months = "janu\xE1r_febru\xE1r_marec_apr\xEDl_m\xE1j_j\xFAn_j\xFAl_august_september_okt\xF3ber_november_december".split(
    "_"
  ), monthsShort = "jan_feb_mar_apr_m\xE1j_j\xFAn_j\xFAl_aug_sep_okt_nov_dec".split("_");
  function plural(n) {
    return n > 1 && n < 5;
  }
  function translate(number, withoutSuffix, key, isFuture) {
    var result = number + " ";
    switch (key) {
      case "s":
        return withoutSuffix || isFuture ? "p\xE1r sek\xFAnd" : "p\xE1r sekundami";
      case "ss":
        if (withoutSuffix || isFuture) {
          return result + (plural(number) ? "sekundy" : "sek\xFAnd");
        } else {
          return result + "sekundami";
        }
      case "m":
        return withoutSuffix ? "min\xFAta" : isFuture ? "min\xFAtu" : "min\xFAtou";
      case "mm":
        if (withoutSuffix || isFuture) {
          return result + (plural(number) ? "min\xFAty" : "min\xFAt");
        } else {
          return result + "min\xFAtami";
        }
      case "h":
        return withoutSuffix ? "hodina" : isFuture ? "hodinu" : "hodinou";
      case "hh":
        if (withoutSuffix || isFuture) {
          return result + (plural(number) ? "hodiny" : "hod\xEDn");
        } else {
          return result + "hodinami";
        }
      case "d":
        return withoutSuffix || isFuture ? "de\u0148" : "d\u0148om";
      case "dd":
        if (withoutSuffix || isFuture) {
          return result + (plural(number) ? "dni" : "dn\xED");
        } else {
          return result + "d\u0148ami";
        }
      case "M":
        return withoutSuffix || isFuture ? "mesiac" : "mesiacom";
      case "MM":
        if (withoutSuffix || isFuture) {
          return result + (plural(number) ? "mesiace" : "mesiacov");
        } else {
          return result + "mesiacmi";
        }
      case "y":
        return withoutSuffix || isFuture ? "rok" : "rokom";
      case "yy":
        if (withoutSuffix || isFuture) {
          return result + (plural(number) ? "roky" : "rokov");
        } else {
          return result + "rokmi";
        }
    }
  }
  var sk = moment.defineLocale("sk", {
    months,
    monthsShort,
    weekdays: "nede\u013Ea_pondelok_utorok_streda_\u0161tvrtok_piatok_sobota".split("_"),
    weekdaysShort: "ne_po_ut_st_\u0161t_pi_so".split("_"),
    weekdaysMin: "ne_po_ut_st_\u0161t_pi_so".split("_"),
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY H:mm",
      LLLL: "dddd D. MMMM YYYY H:mm"
    },
    calendar: {
      sameDay: "[dnes o] LT",
      nextDay: "[zajtra o] LT",
      nextWeek: function() {
        switch (this.day()) {
          case 0:
            return "[v nede\u013Eu o] LT";
          case 1:
          case 2:
            return "[v] dddd [o] LT";
          case 3:
            return "[v stredu o] LT";
          case 4:
            return "[vo \u0161tvrtok o] LT";
          case 5:
            return "[v piatok o] LT";
          case 6:
            return "[v sobotu o] LT";
        }
      },
      lastDay: "[v\u010Dera o] LT",
      lastWeek: function() {
        switch (this.day()) {
          case 0:
            return "[minul\xFA nede\u013Eu o] LT";
          case 1:
          case 2:
            return "[minul\xFD] dddd [o] LT";
          case 3:
            return "[minul\xFA stredu o] LT";
          case 4:
          case 5:
            return "[minul\xFD] dddd [o] LT";
          case 6:
            return "[minul\xFA sobotu o] LT";
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "za %s",
      past: "pred %s",
      s: translate,
      ss: translate,
      m: translate,
      mm: translate,
      h: translate,
      hh: translate,
      d: translate,
      dd: translate,
      M: translate,
      MM: translate,
      y: translate,
      yy: translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return sk;
}));


/***/ }),

/***/ 87795:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var result = number + " ";
    switch (key) {
      case "s":
        return withoutSuffix || isFuture ? "nekaj sekund" : "nekaj sekundami";
      case "ss":
        if (number === 1) {
          result += withoutSuffix ? "sekundo" : "sekundi";
        } else if (number === 2) {
          result += withoutSuffix || isFuture ? "sekundi" : "sekundah";
        } else if (number < 5) {
          result += withoutSuffix || isFuture ? "sekunde" : "sekundah";
        } else {
          result += "sekund";
        }
        return result;
      case "m":
        return withoutSuffix ? "ena minuta" : "eno minuto";
      case "mm":
        if (number === 1) {
          result += withoutSuffix ? "minuta" : "minuto";
        } else if (number === 2) {
          result += withoutSuffix || isFuture ? "minuti" : "minutama";
        } else if (number < 5) {
          result += withoutSuffix || isFuture ? "minute" : "minutami";
        } else {
          result += withoutSuffix || isFuture ? "minut" : "minutami";
        }
        return result;
      case "h":
        return withoutSuffix ? "ena ura" : "eno uro";
      case "hh":
        if (number === 1) {
          result += withoutSuffix ? "ura" : "uro";
        } else if (number === 2) {
          result += withoutSuffix || isFuture ? "uri" : "urama";
        } else if (number < 5) {
          result += withoutSuffix || isFuture ? "ure" : "urami";
        } else {
          result += withoutSuffix || isFuture ? "ur" : "urami";
        }
        return result;
      case "d":
        return withoutSuffix || isFuture ? "en dan" : "enim dnem";
      case "dd":
        if (number === 1) {
          result += withoutSuffix || isFuture ? "dan" : "dnem";
        } else if (number === 2) {
          result += withoutSuffix || isFuture ? "dni" : "dnevoma";
        } else {
          result += withoutSuffix || isFuture ? "dni" : "dnevi";
        }
        return result;
      case "M":
        return withoutSuffix || isFuture ? "en mesec" : "enim mesecem";
      case "MM":
        if (number === 1) {
          result += withoutSuffix || isFuture ? "mesec" : "mesecem";
        } else if (number === 2) {
          result += withoutSuffix || isFuture ? "meseca" : "mesecema";
        } else if (number < 5) {
          result += withoutSuffix || isFuture ? "mesece" : "meseci";
        } else {
          result += withoutSuffix || isFuture ? "mesecev" : "meseci";
        }
        return result;
      case "y":
        return withoutSuffix || isFuture ? "eno leto" : "enim letom";
      case "yy":
        if (number === 1) {
          result += withoutSuffix || isFuture ? "leto" : "letom";
        } else if (number === 2) {
          result += withoutSuffix || isFuture ? "leti" : "letoma";
        } else if (number < 5) {
          result += withoutSuffix || isFuture ? "leta" : "leti";
        } else {
          result += withoutSuffix || isFuture ? "let" : "leti";
        }
        return result;
    }
  }
  var sl = moment.defineLocale("sl", {
    months: "januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split(
      "_"
    ),
    monthsShort: "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "nedelja_ponedeljek_torek_sreda_\u010Detrtek_petek_sobota".split("_"),
    weekdaysShort: "ned._pon._tor._sre._\u010Det._pet._sob.".split("_"),
    weekdaysMin: "ne_po_to_sr_\u010De_pe_so".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD. MM. YYYY",
      LL: "D. MMMM YYYY",
      LLL: "D. MMMM YYYY H:mm",
      LLLL: "dddd, D. MMMM YYYY H:mm"
    },
    calendar: {
      sameDay: "[danes ob] LT",
      nextDay: "[jutri ob] LT",
      nextWeek: function() {
        switch (this.day()) {
          case 0:
            return "[v] [nedeljo] [ob] LT";
          case 3:
            return "[v] [sredo] [ob] LT";
          case 6:
            return "[v] [soboto] [ob] LT";
          case 1:
          case 2:
          case 4:
          case 5:
            return "[v] dddd [ob] LT";
        }
      },
      lastDay: "[v\u010Deraj ob] LT",
      lastWeek: function() {
        switch (this.day()) {
          case 0:
            return "[prej\u0161njo] [nedeljo] [ob] LT";
          case 3:
            return "[prej\u0161njo] [sredo] [ob] LT";
          case 6:
            return "[prej\u0161njo] [soboto] [ob] LT";
          case 1:
          case 2:
          case 4:
          case 5:
            return "[prej\u0161nji] dddd [ob] LT";
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "\u010Dez %s",
      past: "pred %s",
      s: processRelativeTime,
      ss: processRelativeTime,
      m: processRelativeTime,
      mm: processRelativeTime,
      h: processRelativeTime,
      hh: processRelativeTime,
      d: processRelativeTime,
      dd: processRelativeTime,
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return sl;
}));


/***/ }),

/***/ 52568:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var sq = moment.defineLocale("sq", {
    months: "Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_N\xEBntor_Dhjetor".split(
      "_"
    ),
    monthsShort: "Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_N\xEBn_Dhj".split("_"),
    weekdays: "E Diel_E H\xEBn\xEB_E Mart\xEB_E M\xEBrkur\xEB_E Enjte_E Premte_E Shtun\xEB".split(
      "_"
    ),
    weekdaysShort: "Die_H\xEBn_Mar_M\xEBr_Enj_Pre_Sht".split("_"),
    weekdaysMin: "D_H_Ma_M\xEB_E_P_Sh".split("_"),
    weekdaysParseExact: true,
    meridiemParse: /PD|MD/,
    isPM: function(input) {
      return input.charAt(0) === "M";
    },
    meridiem: function(hours, minutes, isLower) {
      return hours < 12 ? "PD" : "MD";
    },
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Sot n\xEB] LT",
      nextDay: "[Nes\xEBr n\xEB] LT",
      nextWeek: "dddd [n\xEB] LT",
      lastDay: "[Dje n\xEB] LT",
      lastWeek: "dddd [e kaluar n\xEB] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "n\xEB %s",
      past: "%s m\xEB par\xEB",
      s: "disa sekonda",
      ss: "%d sekonda",
      m: "nj\xEB minut\xEB",
      mm: "%d minuta",
      h: "nj\xEB or\xEB",
      hh: "%d or\xEB",
      d: "nj\xEB dit\xEB",
      dd: "%d dit\xEB",
      M: "nj\xEB muaj",
      MM: "%d muaj",
      y: "nj\xEB vit",
      yy: "%d vite"
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return sq;
}));


/***/ }),

/***/ 52016:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var translator = {
    words: {
      //Different grammatical cases
      ss: ["\u0441\u0435\u043A\u0443\u043D\u0434\u0430", "\u0441\u0435\u043A\u0443\u043D\u0434\u0435", "\u0441\u0435\u043A\u0443\u043D\u0434\u0438"],
      m: ["\u0458\u0435\u0434\u0430\u043D \u043C\u0438\u043D\u0443\u0442", "\u0458\u0435\u0434\u043D\u043E\u0433 \u043C\u0438\u043D\u0443\u0442\u0430"],
      mm: ["\u043C\u0438\u043D\u0443\u0442", "\u043C\u0438\u043D\u0443\u0442\u0430", "\u043C\u0438\u043D\u0443\u0442\u0430"],
      h: ["\u0458\u0435\u0434\u0430\u043D \u0441\u0430\u0442", "\u0458\u0435\u0434\u043D\u043E\u0433 \u0441\u0430\u0442\u0430"],
      hh: ["\u0441\u0430\u0442", "\u0441\u0430\u0442\u0430", "\u0441\u0430\u0442\u0438"],
      d: ["\u0458\u0435\u0434\u0430\u043D \u0434\u0430\u043D", "\u0458\u0435\u0434\u043D\u043E\u0433 \u0434\u0430\u043D\u0430"],
      dd: ["\u0434\u0430\u043D", "\u0434\u0430\u043D\u0430", "\u0434\u0430\u043D\u0430"],
      M: ["\u0458\u0435\u0434\u0430\u043D \u043C\u0435\u0441\u0435\u0446", "\u0458\u0435\u0434\u043D\u043E\u0433 \u043C\u0435\u0441\u0435\u0446\u0430"],
      MM: ["\u043C\u0435\u0441\u0435\u0446", "\u043C\u0435\u0441\u0435\u0446\u0430", "\u043C\u0435\u0441\u0435\u0446\u0438"],
      y: ["\u0458\u0435\u0434\u043D\u0443 \u0433\u043E\u0434\u0438\u043D\u0443", "\u0458\u0435\u0434\u043D\u0435 \u0433\u043E\u0434\u0438\u043D\u0435"],
      yy: ["\u0433\u043E\u0434\u0438\u043D\u0443", "\u0433\u043E\u0434\u0438\u043D\u0435", "\u0433\u043E\u0434\u0438\u043D\u0430"]
    },
    correctGrammaticalCase: function(number, wordKey) {
      if (number % 10 >= 1 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) {
        return number % 10 === 1 ? wordKey[0] : wordKey[1];
      }
      return wordKey[2];
    },
    translate: function(number, withoutSuffix, key, isFuture) {
      var wordKey = translator.words[key], word;
      if (key.length === 1) {
        if (key === "y" && withoutSuffix) return "\u0458\u0435\u0434\u043D\u0430 \u0433\u043E\u0434\u0438\u043D\u0430";
        return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
      }
      word = translator.correctGrammaticalCase(number, wordKey);
      if (key === "yy" && withoutSuffix && word === "\u0433\u043E\u0434\u0438\u043D\u0443") {
        return number + " \u0433\u043E\u0434\u0438\u043D\u0430";
      }
      return number + " " + word;
    }
  };
  var srCyrl = moment.defineLocale("sr-cyrl", {
    months: "\u0458\u0430\u043D\u0443\u0430\u0440_\u0444\u0435\u0431\u0440\u0443\u0430\u0440_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0438\u043B_\u043C\u0430\u0458_\u0458\u0443\u043D_\u0458\u0443\u043B_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440_\u043E\u043A\u0442\u043E\u0431\u0430\u0440_\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440_\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440".split(
      "_"
    ),
    monthsShort: "\u0458\u0430\u043D._\u0444\u0435\u0431._\u043C\u0430\u0440._\u0430\u043F\u0440._\u043C\u0430\u0458_\u0458\u0443\u043D_\u0458\u0443\u043B_\u0430\u0432\u0433._\u0441\u0435\u043F._\u043E\u043A\u0442._\u043D\u043E\u0432._\u0434\u0435\u0446.".split("_"),
    monthsParseExact: true,
    weekdays: "\u043D\u0435\u0434\u0435\u0459\u0430_\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A_\u0443\u0442\u043E\u0440\u0430\u043A_\u0441\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A_\u043F\u0435\u0442\u0430\u043A_\u0441\u0443\u0431\u043E\u0442\u0430".split("_"),
    weekdaysShort: "\u043D\u0435\u0434._\u043F\u043E\u043D._\u0443\u0442\u043E._\u0441\u0440\u0435._\u0447\u0435\u0442._\u043F\u0435\u0442._\u0441\u0443\u0431.".split("_"),
    weekdaysMin: "\u043D\u0435_\u043F\u043E_\u0443\u0442_\u0441\u0440_\u0447\u0435_\u043F\u0435_\u0441\u0443".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "D. M. YYYY.",
      LL: "D. MMMM YYYY.",
      LLL: "D. MMMM YYYY. H:mm",
      LLLL: "dddd, D. MMMM YYYY. H:mm"
    },
    calendar: {
      sameDay: "[\u0434\u0430\u043D\u0430\u0441 \u0443] LT",
      nextDay: "[\u0441\u0443\u0442\u0440\u0430 \u0443] LT",
      nextWeek: function() {
        switch (this.day()) {
          case 0:
            return "[\u0443] [\u043D\u0435\u0434\u0435\u0459\u0443] [\u0443] LT";
          case 3:
            return "[\u0443] [\u0441\u0440\u0435\u0434\u0443] [\u0443] LT";
          case 6:
            return "[\u0443] [\u0441\u0443\u0431\u043E\u0442\u0443] [\u0443] LT";
          case 1:
          case 2:
          case 4:
          case 5:
            return "[\u0443] dddd [\u0443] LT";
        }
      },
      lastDay: "[\u0458\u0443\u0447\u0435 \u0443] LT",
      lastWeek: function() {
        var lastWeekDays = [
          "[\u043F\u0440\u043E\u0448\u043B\u0435] [\u043D\u0435\u0434\u0435\u0459\u0435] [\u0443] LT",
          "[\u043F\u0440\u043E\u0448\u043B\u043E\u0433] [\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u043A\u0430] [\u0443] LT",
          "[\u043F\u0440\u043E\u0448\u043B\u043E\u0433] [\u0443\u0442\u043E\u0440\u043A\u0430] [\u0443] LT",
          "[\u043F\u0440\u043E\u0448\u043B\u0435] [\u0441\u0440\u0435\u0434\u0435] [\u0443] LT",
          "[\u043F\u0440\u043E\u0448\u043B\u043E\u0433] [\u0447\u0435\u0442\u0432\u0440\u0442\u043A\u0430] [\u0443] LT",
          "[\u043F\u0440\u043E\u0448\u043B\u043E\u0433] [\u043F\u0435\u0442\u043A\u0430] [\u0443] LT",
          "[\u043F\u0440\u043E\u0448\u043B\u0435] [\u0441\u0443\u0431\u043E\u0442\u0435] [\u0443] LT"
        ];
        return lastWeekDays[this.day()];
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0437\u0430 %s",
      past: "\u043F\u0440\u0435 %s",
      s: "\u043D\u0435\u043A\u043E\u043B\u0438\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
      ss: translator.translate,
      m: translator.translate,
      mm: translator.translate,
      h: translator.translate,
      hh: translator.translate,
      d: translator.translate,
      dd: translator.translate,
      M: translator.translate,
      MM: translator.translate,
      y: translator.translate,
      yy: translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 1st is the first week of the year.
    }
  });
  return srCyrl;
}));


/***/ }),

/***/ 32209:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var translator = {
    words: {
      //Different grammatical cases
      ss: ["sekunda", "sekunde", "sekundi"],
      m: ["jedan minut", "jednog minuta"],
      mm: ["minut", "minuta", "minuta"],
      h: ["jedan sat", "jednog sata"],
      hh: ["sat", "sata", "sati"],
      d: ["jedan dan", "jednog dana"],
      dd: ["dan", "dana", "dana"],
      M: ["jedan mesec", "jednog meseca"],
      MM: ["mesec", "meseca", "meseci"],
      y: ["jednu godinu", "jedne godine"],
      yy: ["godinu", "godine", "godina"]
    },
    correctGrammaticalCase: function(number, wordKey) {
      if (number % 10 >= 1 && number % 10 <= 4 && (number % 100 < 10 || number % 100 >= 20)) {
        return number % 10 === 1 ? wordKey[0] : wordKey[1];
      }
      return wordKey[2];
    },
    translate: function(number, withoutSuffix, key, isFuture) {
      var wordKey = translator.words[key], word;
      if (key.length === 1) {
        if (key === "y" && withoutSuffix) return "jedna godina";
        return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
      }
      word = translator.correctGrammaticalCase(number, wordKey);
      if (key === "yy" && withoutSuffix && word === "godinu") {
        return number + " godina";
      }
      return number + " " + word;
    }
  };
  var sr = moment.defineLocale("sr", {
    months: "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split(
      "_"
    ),
    monthsShort: "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split("_"),
    monthsParseExact: true,
    weekdays: "nedelja_ponedeljak_utorak_sreda_\u010Detvrtak_petak_subota".split(
      "_"
    ),
    weekdaysShort: "ned._pon._uto._sre._\u010Det._pet._sub.".split("_"),
    weekdaysMin: "ne_po_ut_sr_\u010De_pe_su".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "D. M. YYYY.",
      LL: "D. MMMM YYYY.",
      LLL: "D. MMMM YYYY. H:mm",
      LLLL: "dddd, D. MMMM YYYY. H:mm"
    },
    calendar: {
      sameDay: "[danas u] LT",
      nextDay: "[sutra u] LT",
      nextWeek: function() {
        switch (this.day()) {
          case 0:
            return "[u] [nedelju] [u] LT";
          case 3:
            return "[u] [sredu] [u] LT";
          case 6:
            return "[u] [subotu] [u] LT";
          case 1:
          case 2:
          case 4:
          case 5:
            return "[u] dddd [u] LT";
        }
      },
      lastDay: "[ju\u010De u] LT",
      lastWeek: function() {
        var lastWeekDays = [
          "[pro\u0161le] [nedelje] [u] LT",
          "[pro\u0161log] [ponedeljka] [u] LT",
          "[pro\u0161log] [utorka] [u] LT",
          "[pro\u0161le] [srede] [u] LT",
          "[pro\u0161log] [\u010Detvrtka] [u] LT",
          "[pro\u0161log] [petka] [u] LT",
          "[pro\u0161le] [subote] [u] LT"
        ];
        return lastWeekDays[this.day()];
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "za %s",
      past: "pre %s",
      s: "nekoliko sekundi",
      ss: translator.translate,
      m: translator.translate,
      mm: translator.translate,
      h: translator.translate,
      hh: translator.translate,
      d: translator.translate,
      dd: translator.translate,
      M: translator.translate,
      MM: translator.translate,
      y: translator.translate,
      yy: translator.translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return sr;
}));


/***/ }),

/***/ 64322:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var ss = moment.defineLocale("ss", {
    months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
      "_"
    ),
    monthsShort: "Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),
    weekdays: "Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split(
      "_"
    ),
    weekdaysShort: "Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),
    weekdaysMin: "Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "h:mm A",
      LTS: "h:mm:ss A",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY h:mm A",
      LLLL: "dddd, D MMMM YYYY h:mm A"
    },
    calendar: {
      sameDay: "[Namuhla nga] LT",
      nextDay: "[Kusasa nga] LT",
      nextWeek: "dddd [nga] LT",
      lastDay: "[Itolo nga] LT",
      lastWeek: "dddd [leliphelile] [nga] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "nga %s",
      past: "wenteka nga %s",
      s: "emizuzwana lomcane",
      ss: "%d mzuzwana",
      m: "umzuzu",
      mm: "%d emizuzu",
      h: "lihora",
      hh: "%d emahora",
      d: "lilanga",
      dd: "%d emalanga",
      M: "inyanga",
      MM: "%d tinyanga",
      y: "umnyaka",
      yy: "%d iminyaka"
    },
    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
    meridiem: function(hours, minutes, isLower) {
      if (hours < 11) {
        return "ekuseni";
      } else if (hours < 15) {
        return "emini";
      } else if (hours < 19) {
        return "entsambama";
      } else {
        return "ebusuku";
      }
    },
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "ekuseni") {
        return hour;
      } else if (meridiem === "emini") {
        return hour >= 11 ? hour : hour + 12;
      } else if (meridiem === "entsambama" || meridiem === "ebusuku") {
        if (hour === 0) {
          return 0;
        }
        return hour + 12;
      }
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal: "%d",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return ss;
}));


/***/ }),

/***/ 93421:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var sv = moment.defineLocale("sv", {
    months: "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split(
      "_"
    ),
    monthsShort: "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
    weekdays: "s\xF6ndag_m\xE5ndag_tisdag_onsdag_torsdag_fredag_l\xF6rdag".split("_"),
    weekdaysShort: "s\xF6n_m\xE5n_tis_ons_tor_fre_l\xF6r".split("_"),
    weekdaysMin: "s\xF6_m\xE5_ti_on_to_fr_l\xF6".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY [kl.] HH:mm",
      LLLL: "dddd D MMMM YYYY [kl.] HH:mm",
      lll: "D MMM YYYY HH:mm",
      llll: "ddd D MMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Idag] LT",
      nextDay: "[Imorgon] LT",
      lastDay: "[Ig\xE5r] LT",
      nextWeek: "[P\xE5] dddd LT",
      lastWeek: "[I] dddd[s] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "om %s",
      past: "f\xF6r %s sedan",
      s: "n\xE5gra sekunder",
      ss: "%d sekunder",
      m: "en minut",
      mm: "%d minuter",
      h: "en timme",
      hh: "%d timmar",
      d: "en dag",
      dd: "%d dagar",
      M: "en m\xE5nad",
      MM: "%d m\xE5nader",
      y: "ett \xE5r",
      yy: "%d \xE5r"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
    ordinal: function(number) {
      var b = number % 10, output = ~~(number % 100 / 10) === 1 ? ":e" : b === 1 ? ":a" : b === 2 ? ":a" : b === 3 ? ":e" : ":e";
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return sv;
}));


/***/ }),

/***/ 49070:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var sw = moment.defineLocale("sw", {
    months: "Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split(
      "_"
    ),
    monthsShort: "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),
    weekdays: "Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split(
      "_"
    ),
    weekdaysShort: "Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),
    weekdaysMin: "J2_J3_J4_J5_Al_Ij_J1".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "hh:mm A",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[leo saa] LT",
      nextDay: "[kesho saa] LT",
      nextWeek: "[wiki ijayo] dddd [saat] LT",
      lastDay: "[jana] LT",
      lastWeek: "[wiki iliyopita] dddd [saat] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s baadaye",
      past: "tokea %s",
      s: "hivi punde",
      ss: "sekunde %d",
      m: "dakika moja",
      mm: "dakika %d",
      h: "saa limoja",
      hh: "masaa %d",
      d: "siku moja",
      dd: "siku %d",
      M: "mwezi mmoja",
      MM: "miezi %d",
      y: "mwaka mmoja",
      yy: "miaka %d"
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return sw;
}));


/***/ }),

/***/ 79947:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var symbolMap = {
    1: "\u0BE7",
    2: "\u0BE8",
    3: "\u0BE9",
    4: "\u0BEA",
    5: "\u0BEB",
    6: "\u0BEC",
    7: "\u0BED",
    8: "\u0BEE",
    9: "\u0BEF",
    0: "\u0BE6"
  }, numberMap = {
    "\u0BE7": "1",
    "\u0BE8": "2",
    "\u0BE9": "3",
    "\u0BEA": "4",
    "\u0BEB": "5",
    "\u0BEC": "6",
    "\u0BED": "7",
    "\u0BEE": "8",
    "\u0BEF": "9",
    "\u0BE6": "0"
  };
  var ta = moment.defineLocale("ta", {
    months: "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF_\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF_\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD_\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD_\u0BAE\u0BC7_\u0B9C\u0BC2\u0BA9\u0BCD_\u0B9C\u0BC2\u0BB2\u0BC8_\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD_\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BC6\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD_\u0B85\u0B95\u0BCD\u0B9F\u0BC7\u0BBE\u0BAA\u0BB0\u0BCD_\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD_\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD".split(
      "_"
    ),
    monthsShort: "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF_\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF_\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD_\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD_\u0BAE\u0BC7_\u0B9C\u0BC2\u0BA9\u0BCD_\u0B9C\u0BC2\u0BB2\u0BC8_\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD_\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BC6\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD_\u0B85\u0B95\u0BCD\u0B9F\u0BC7\u0BBE\u0BAA\u0BB0\u0BCD_\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD_\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD".split(
      "_"
    ),
    weekdays: "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0B9F\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8_\u0B9A\u0BA9\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB4\u0BAE\u0BC8".split(
      "_"
    ),
    weekdaysShort: "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1_\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD_\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD_\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD_\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD_\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF_\u0B9A\u0BA9\u0BBF".split(
      "_"
    ),
    weekdaysMin: "\u0B9E\u0BBE_\u0BA4\u0BBF_\u0B9A\u0BC6_\u0BAA\u0BC1_\u0BB5\u0BBF_\u0BB5\u0BC6_\u0B9A".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, HH:mm",
      LLLL: "dddd, D MMMM YYYY, HH:mm"
    },
    calendar: {
      sameDay: "[\u0B87\u0BA9\u0BCD\u0BB1\u0BC1] LT",
      nextDay: "[\u0BA8\u0BBE\u0BB3\u0BC8] LT",
      nextWeek: "dddd, LT",
      lastDay: "[\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1] LT",
      lastWeek: "[\u0B95\u0B9F\u0BA8\u0BCD\u0BA4 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD] dddd, LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0B87\u0BB2\u0BCD",
      past: "%s \u0BAE\u0BC1\u0BA9\u0BCD",
      s: "\u0B92\u0BB0\u0BC1 \u0B9A\u0BBF\u0BB2 \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
      ss: "%d \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
      m: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
      mm: "%d \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
      h: "\u0B92\u0BB0\u0BC1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
      hh: "%d \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
      d: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBE\u0BB3\u0BCD",
      dd: "%d \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
      M: "\u0B92\u0BB0\u0BC1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
      MM: "%d \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
      y: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
      yy: "%d \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD"
    },
    dayOfMonthOrdinalParse: /\d{1,2}வது/,
    ordinal: function(number) {
      return number + "\u0BB5\u0BA4\u0BC1";
    },
    preparse: function(string) {
      return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function(match) {
        return numberMap[match];
      });
    },
    postformat: function(string) {
      return string.replace(/\d/g, function(match) {
        return symbolMap[match];
      });
    },
    // refer http://ta.wikipedia.org/s/1er1
    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
    meridiem: function(hour, minute, isLower) {
      if (hour < 2) {
        return " \u0BAF\u0BBE\u0BAE\u0BAE\u0BCD";
      } else if (hour < 6) {
        return " \u0BB5\u0BC8\u0B95\u0BB1\u0BC8";
      } else if (hour < 10) {
        return " \u0B95\u0BBE\u0BB2\u0BC8";
      } else if (hour < 14) {
        return " \u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD";
      } else if (hour < 18) {
        return " \u0B8E\u0BB1\u0BCD\u0BAA\u0BBE\u0B9F\u0BC1";
      } else if (hour < 22) {
        return " \u0BAE\u0BBE\u0BB2\u0BC8";
      } else {
        return " \u0BAF\u0BBE\u0BAE\u0BAE\u0BCD";
      }
    },
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u0BAF\u0BBE\u0BAE\u0BAE\u0BCD") {
        return hour < 2 ? hour : hour + 12;
      } else if (meridiem === "\u0BB5\u0BC8\u0B95\u0BB1\u0BC8" || meridiem === "\u0B95\u0BBE\u0BB2\u0BC8") {
        return hour;
      } else if (meridiem === "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD") {
        return hour >= 10 ? hour : hour + 12;
      } else {
        return hour + 12;
      }
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return ta;
}));


/***/ }),

/***/ 33999:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var te = moment.defineLocale("te", {
    months: "\u0C1C\u0C28\u0C35\u0C30\u0C3F_\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F_\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F_\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D_\u0C2E\u0C47_\u0C1C\u0C42\u0C28\u0C4D_\u0C1C\u0C41\u0C32\u0C48_\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41_\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D_\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D_\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D_\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D".split(
      "_"
    ),
    monthsShort: "\u0C1C\u0C28._\u0C2B\u0C3F\u0C2C\u0C4D\u0C30._\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F_\u0C0F\u0C2A\u0C4D\u0C30\u0C3F._\u0C2E\u0C47_\u0C1C\u0C42\u0C28\u0C4D_\u0C1C\u0C41\u0C32\u0C48_\u0C06\u0C17._\u0C38\u0C46\u0C2A\u0C4D._\u0C05\u0C15\u0C4D\u0C1F\u0C4B._\u0C28\u0C35._\u0C21\u0C3F\u0C38\u0C46.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02_\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02_\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02_\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02_\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02_\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02_\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02".split(
      "_"
    ),
    weekdaysShort: "\u0C06\u0C26\u0C3F_\u0C38\u0C4B\u0C2E_\u0C2E\u0C02\u0C17\u0C33_\u0C2C\u0C41\u0C27_\u0C17\u0C41\u0C30\u0C41_\u0C36\u0C41\u0C15\u0C4D\u0C30_\u0C36\u0C28\u0C3F".split("_"),
    weekdaysMin: "\u0C06_\u0C38\u0C4B_\u0C2E\u0C02_\u0C2C\u0C41_\u0C17\u0C41_\u0C36\u0C41_\u0C36".split("_"),
    longDateFormat: {
      LT: "A h:mm",
      LTS: "A h:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, A h:mm",
      LLLL: "dddd, D MMMM YYYY, A h:mm"
    },
    calendar: {
      sameDay: "[\u0C28\u0C47\u0C21\u0C41] LT",
      nextDay: "[\u0C30\u0C47\u0C2A\u0C41] LT",
      nextWeek: "dddd, LT",
      lastDay: "[\u0C28\u0C3F\u0C28\u0C4D\u0C28] LT",
      lastWeek: "[\u0C17\u0C24] dddd, LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0C32\u0C4B",
      past: "%s \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02",
      s: "\u0C15\u0C4A\u0C28\u0C4D\u0C28\u0C3F \u0C15\u0C4D\u0C37\u0C23\u0C3E\u0C32\u0C41",
      ss: "%d \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32\u0C41",
      m: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
      mm: "%d \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41",
      h: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
      hh: "%d \u0C17\u0C02\u0C1F\u0C32\u0C41",
      d: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
      dd: "%d \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41",
      M: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
      MM: "%d \u0C28\u0C46\u0C32\u0C32\u0C41",
      y: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
      yy: "%d \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
    },
    dayOfMonthOrdinalParse: /\d{1,2}వ/,
    ordinal: "%d\u0C35",
    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F") {
        return hour < 4 ? hour : hour + 12;
      } else if (meridiem === "\u0C09\u0C26\u0C2F\u0C02") {
        return hour;
      } else if (meridiem === "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02") {
        return hour >= 10 ? hour : hour + 12;
      } else if (meridiem === "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F";
      } else if (hour < 10) {
        return "\u0C09\u0C26\u0C2F\u0C02";
      } else if (hour < 17) {
        return "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02";
      } else if (hour < 20) {
        return "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02";
      } else {
        return "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F";
      }
    },
    week: {
      dow: 0,
      // Sunday is the first day of the week.
      doy: 6
      // The week that contains Jan 6th is the first week of the year.
    }
  });
  return te;
}));


/***/ }),

/***/ 72467:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var tet = moment.defineLocale("tet", {
    months: "Janeiru_Fevereiru_Marsu_Abril_Maiu_Ju\xF1u_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split(
      "_"
    ),
    monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
    weekdays: "Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split("_"),
    weekdaysShort: "Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),
    weekdaysMin: "Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[Ohin iha] LT",
      nextDay: "[Aban iha] LT",
      nextWeek: "dddd [iha] LT",
      lastDay: "[Horiseik iha] LT",
      lastWeek: "dddd [semana kotuk] [iha] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "iha %s",
      past: "%s liuba",
      s: "segundu balun",
      ss: "segundu %d",
      m: "minutu ida",
      mm: "minutu %d",
      h: "oras ida",
      hh: "oras %d",
      d: "loron ida",
      dd: "loron %d",
      M: "fulan ida",
      MM: "fulan %d",
      y: "tinan ida",
      yy: "tinan %d"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal: function(number) {
      var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return tet;
}));


/***/ }),

/***/ 4401:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var suffixes = {
    0: "-\u0443\u043C",
    1: "-\u0443\u043C",
    2: "-\u044E\u043C",
    3: "-\u044E\u043C",
    4: "-\u0443\u043C",
    5: "-\u0443\u043C",
    6: "-\u0443\u043C",
    7: "-\u0443\u043C",
    8: "-\u0443\u043C",
    9: "-\u0443\u043C",
    10: "-\u0443\u043C",
    12: "-\u0443\u043C",
    13: "-\u0443\u043C",
    20: "-\u0443\u043C",
    30: "-\u044E\u043C",
    40: "-\u0443\u043C",
    50: "-\u0443\u043C",
    60: "-\u0443\u043C",
    70: "-\u0443\u043C",
    80: "-\u0443\u043C",
    90: "-\u0443\u043C",
    100: "-\u0443\u043C"
  };
  var tg = moment.defineLocale("tg", {
    months: {
      format: "\u044F\u043D\u0432\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0430\u043B\u0438_\u043C\u0430\u0440\u0442\u0438_\u0430\u043F\u0440\u0435\u043B\u0438_\u043C\u0430\u0439\u0438_\u0438\u044E\u043D\u0438_\u0438\u044E\u043B\u0438_\u0430\u0432\u0433\u0443\u0441\u0442\u0438_\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u0438_\u043E\u043A\u0442\u044F\u0431\u0440\u0438_\u043D\u043E\u044F\u0431\u0440\u0438_\u0434\u0435\u043A\u0430\u0431\u0440\u0438".split(
        "_"
      ),
      standalone: "\u044F\u043D\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043B_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B_\u043C\u0430\u0439_\u0438\u044E\u043D_\u0438\u044E\u043B_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440_\u043E\u043A\u0442\u044F\u0431\u0440_\u043D\u043E\u044F\u0431\u0440_\u0434\u0435\u043A\u0430\u0431\u0440".split(
        "_"
      )
    },
    monthsShort: "\u044F\u043D\u0432_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0439_\u0438\u044E\u043D_\u0438\u044E\u043B_\u0430\u0432\u0433_\u0441\u0435\u043D_\u043E\u043A\u0442_\u043D\u043E\u044F_\u0434\u0435\u043A".split("_"),
    weekdays: "\u044F\u043A\u0448\u0430\u043D\u0431\u0435_\u0434\u0443\u0448\u0430\u043D\u0431\u0435_\u0441\u0435\u0448\u0430\u043D\u0431\u0435_\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0435_\u043F\u0430\u043D\u04B7\u0448\u0430\u043D\u0431\u0435_\u04B7\u0443\u043C\u044A\u0430_\u0448\u0430\u043D\u0431\u0435".split(
      "_"
    ),
    weekdaysShort: "\u044F\u0448\u0431_\u0434\u0448\u0431_\u0441\u0448\u0431_\u0447\u0448\u0431_\u043F\u0448\u0431_\u04B7\u0443\u043C_\u0448\u043D\u0431".split("_"),
    weekdaysMin: "\u044F\u0448_\u0434\u0448_\u0441\u0448_\u0447\u0448_\u043F\u0448_\u04B7\u043C_\u0448\u0431".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[\u0418\u043C\u0440\u04EF\u0437 \u0441\u043E\u0430\u0442\u0438] LT",
      nextDay: "[\u0424\u0430\u0440\u0434\u043E \u0441\u043E\u0430\u0442\u0438] LT",
      lastDay: "[\u0414\u0438\u0440\u04EF\u0437 \u0441\u043E\u0430\u0442\u0438] LT",
      nextWeek: "dddd[\u0438] [\u04B3\u0430\u0444\u0442\u0430\u0438 \u043E\u044F\u043D\u0434\u0430 \u0441\u043E\u0430\u0442\u0438] LT",
      lastWeek: "dddd[\u0438] [\u04B3\u0430\u0444\u0442\u0430\u0438 \u0433\u0443\u0437\u0430\u0448\u0442\u0430 \u0441\u043E\u0430\u0442\u0438] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0431\u0430\u044A\u0434\u0438 %s",
      past: "%s \u043F\u0435\u0448",
      s: "\u044F\u043A\u0447\u0430\u043D\u0434 \u0441\u043E\u043D\u0438\u044F",
      m: "\u044F\u043A \u0434\u0430\u049B\u0438\u049B\u0430",
      mm: "%d \u0434\u0430\u049B\u0438\u049B\u0430",
      h: "\u044F\u043A \u0441\u043E\u0430\u0442",
      hh: "%d \u0441\u043E\u0430\u0442",
      d: "\u044F\u043A \u0440\u04EF\u0437",
      dd: "%d \u0440\u04EF\u0437",
      M: "\u044F\u043A \u043C\u043E\u04B3",
      MM: "%d \u043C\u043E\u04B3",
      y: "\u044F\u043A \u0441\u043E\u043B",
      yy: "%d \u0441\u043E\u043B"
    },
    meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u0448\u0430\u0431") {
        return hour < 4 ? hour : hour + 12;
      } else if (meridiem === "\u0441\u0443\u0431\u04B3") {
        return hour;
      } else if (meridiem === "\u0440\u04EF\u0437") {
        return hour >= 11 ? hour : hour + 12;
      } else if (meridiem === "\u0431\u0435\u0433\u043E\u04B3") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u0448\u0430\u0431";
      } else if (hour < 11) {
        return "\u0441\u0443\u0431\u04B3";
      } else if (hour < 16) {
        return "\u0440\u04EF\u0437";
      } else if (hour < 19) {
        return "\u0431\u0435\u0433\u043E\u04B3";
      } else {
        return "\u0448\u0430\u0431";
      }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
    ordinal: function(number) {
      var a = number % 10, b = number >= 100 ? 100 : null;
      return number + (suffixes[number] || suffixes[a] || suffixes[b]);
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 1th is the first week of the year.
    }
  });
  return tg;
}));


/***/ }),

/***/ 64828:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var th = moment.defineLocale("th", {
    months: "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21_\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C_\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21_\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19_\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21_\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19_\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21_\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21_\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19_\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21_\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19_\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21".split(
      "_"
    ),
    monthsShort: "\u0E21.\u0E04._\u0E01.\u0E1E._\u0E21\u0E35.\u0E04._\u0E40\u0E21.\u0E22._\u0E1E.\u0E04._\u0E21\u0E34.\u0E22._\u0E01.\u0E04._\u0E2A.\u0E04._\u0E01.\u0E22._\u0E15.\u0E04._\u0E1E.\u0E22._\u0E18.\u0E04.".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C_\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C_\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23_\u0E1E\u0E38\u0E18_\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35_\u0E28\u0E38\u0E01\u0E23\u0E4C_\u0E40\u0E2A\u0E32\u0E23\u0E4C".split("_"),
    weekdaysShort: "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C_\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C_\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23_\u0E1E\u0E38\u0E18_\u0E1E\u0E24\u0E2B\u0E31\u0E2A_\u0E28\u0E38\u0E01\u0E23\u0E4C_\u0E40\u0E2A\u0E32\u0E23\u0E4C".split("_"),
    // yes, three characters difference
    weekdaysMin: "\u0E2D\u0E32._\u0E08._\u0E2D._\u0E1E._\u0E1E\u0E24._\u0E28._\u0E2A.".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "H:mm",
      LTS: "H:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY \u0E40\u0E27\u0E25\u0E32 H:mm",
      LLLL: "\u0E27\u0E31\u0E19dddd\u0E17\u0E35\u0E48 D MMMM YYYY \u0E40\u0E27\u0E25\u0E32 H:mm"
    },
    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
    isPM: function(input) {
      return input === "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07";
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07";
      } else {
        return "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07";
      }
    },
    calendar: {
      sameDay: "[\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49 \u0E40\u0E27\u0E25\u0E32] LT",
      nextDay: "[\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49 \u0E40\u0E27\u0E25\u0E32] LT",
      nextWeek: "dddd[\u0E2B\u0E19\u0E49\u0E32 \u0E40\u0E27\u0E25\u0E32] LT",
      lastDay: "[\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49 \u0E40\u0E27\u0E25\u0E32] LT",
      lastWeek: "[\u0E27\u0E31\u0E19]dddd[\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E40\u0E27\u0E25\u0E32] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0E2D\u0E35\u0E01 %s",
      past: "%s\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27",
      s: "\u0E44\u0E21\u0E48\u0E01\u0E35\u0E48\u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
      ss: "%d \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
      m: "1 \u0E19\u0E32\u0E17\u0E35",
      mm: "%d \u0E19\u0E32\u0E17\u0E35",
      h: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
      hh: "%d \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
      d: "1 \u0E27\u0E31\u0E19",
      dd: "%d \u0E27\u0E31\u0E19",
      w: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
      ww: "%d \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
      M: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
      MM: "%d \u0E40\u0E14\u0E37\u0E2D\u0E19",
      y: "1 \u0E1B\u0E35",
      yy: "%d \u0E1B\u0E35"
    }
  });
  return th;
}));


/***/ }),

/***/ 71781:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var suffixes = {
    1: "'inji",
    5: "'inji",
    8: "'inji",
    70: "'inji",
    80: "'inji",
    2: "'nji",
    7: "'nji",
    20: "'nji",
    50: "'nji",
    3: "'\xFCnji",
    4: "'\xFCnji",
    100: "'\xFCnji",
    6: "'njy",
    9: "'unjy",
    10: "'unjy",
    30: "'unjy",
    60: "'ynjy",
    90: "'ynjy"
  };
  var tk = moment.defineLocale("tk", {
    months: "\xDDanwar_Fewral_Mart_Aprel_Ma\xFD_I\xFDun_I\xFDul_Awgust_Sent\xFDabr_Okt\xFDabr_No\xFDabr_Dekabr".split(
      "_"
    ),
    monthsShort: "\xDDan_Few_Mar_Apr_Ma\xFD_I\xFDn_I\xFDl_Awg_Sen_Okt_No\xFD_Dek".split("_"),
    weekdays: "\xDDek\u015Fenbe_Du\u015Fenbe_Si\u015Fenbe_\xC7ar\u015Fenbe_Pen\u015Fenbe_Anna_\u015Eenbe".split(
      "_"
    ),
    weekdaysShort: "\xDDek_Du\u015F_Si\u015F_\xC7ar_Pen_Ann_\u015Een".split("_"),
    weekdaysMin: "\xDDk_D\u015F_S\u015F_\xC7r_Pn_An_\u015En".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[bug\xFCn sagat] LT",
      nextDay: "[ertir sagat] LT",
      nextWeek: "[indiki] dddd [sagat] LT",
      lastDay: "[d\xFC\xFDn] LT",
      lastWeek: "[ge\xE7en] dddd [sagat] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s so\u0148",
      past: "%s \xF6\u0148",
      s: "birn\xE4\xE7e sekunt",
      m: "bir minut",
      mm: "%d minut",
      h: "bir sagat",
      hh: "%d sagat",
      d: "bir g\xFCn",
      dd: "%d g\xFCn",
      M: "bir a\xFD",
      MM: "%d a\xFD",
      y: "bir \xFDyl",
      yy: "%d \xFDyl"
    },
    ordinal: function(number, period) {
      switch (period) {
        case "d":
        case "D":
        case "Do":
        case "DD":
          return number;
        default:
          if (number === 0) {
            return number + "'unjy";
          }
          var a = number % 10, b = number % 100 - a, c = number >= 100 ? 100 : null;
          return number + (suffixes[a] || suffixes[b] || suffixes[c]);
      }
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return tk;
}));


/***/ }),

/***/ 54877:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var tlPh = moment.defineLocale("tl-ph", {
    months: "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split(
      "_"
    ),
    monthsShort: "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
    weekdays: "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split(
      "_"
    ),
    weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
    weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "MM/D/YYYY",
      LL: "MMMM D, YYYY",
      LLL: "MMMM D, YYYY HH:mm",
      LLLL: "dddd, MMMM DD, YYYY HH:mm"
    },
    calendar: {
      sameDay: "LT [ngayong araw]",
      nextDay: "[Bukas ng] LT",
      nextWeek: "LT [sa susunod na] dddd",
      lastDay: "LT [kahapon]",
      lastWeek: "LT [noong nakaraang] dddd",
      sameElse: "L"
    },
    relativeTime: {
      future: "sa loob ng %s",
      past: "%s ang nakalipas",
      s: "ilang segundo",
      ss: "%d segundo",
      m: "isang minuto",
      mm: "%d minuto",
      h: "isang oras",
      hh: "%d oras",
      d: "isang araw",
      dd: "%d araw",
      M: "isang buwan",
      MM: "%d buwan",
      y: "isang taon",
      yy: "%d taon"
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal: function(number) {
      return number;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return tlPh;
}));


/***/ }),

/***/ 97546:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var numbersNouns = "pagh_wa\u2019_cha\u2019_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_");
  function translateFuture(output) {
    var time = output;
    time = output.indexOf("jaj") !== -1 ? time.slice(0, -3) + "leS" : output.indexOf("jar") !== -1 ? time.slice(0, -3) + "waQ" : output.indexOf("DIS") !== -1 ? time.slice(0, -3) + "nem" : time + " pIq";
    return time;
  }
  function translatePast(output) {
    var time = output;
    time = output.indexOf("jaj") !== -1 ? time.slice(0, -3) + "Hu\u2019" : output.indexOf("jar") !== -1 ? time.slice(0, -3) + "wen" : output.indexOf("DIS") !== -1 ? time.slice(0, -3) + "ben" : time + " ret";
    return time;
  }
  function translate(number, withoutSuffix, string, isFuture) {
    var numberNoun = numberAsNoun(number);
    switch (string) {
      case "ss":
        return numberNoun + " lup";
      case "mm":
        return numberNoun + " tup";
      case "hh":
        return numberNoun + " rep";
      case "dd":
        return numberNoun + " jaj";
      case "MM":
        return numberNoun + " jar";
      case "yy":
        return numberNoun + " DIS";
    }
  }
  function numberAsNoun(number) {
    var hundred = Math.floor(number % 1e3 / 100), ten = Math.floor(number % 100 / 10), one = number % 10, word = "";
    if (hundred > 0) {
      word += numbersNouns[hundred] + "vatlh";
    }
    if (ten > 0) {
      word += (word !== "" ? " " : "") + numbersNouns[ten] + "maH";
    }
    if (one > 0) {
      word += (word !== "" ? " " : "") + numbersNouns[one];
    }
    return word === "" ? "pagh" : word;
  }
  var tlh = moment.defineLocale("tlh", {
    months: "tera\u2019 jar wa\u2019_tera\u2019 jar cha\u2019_tera\u2019 jar wej_tera\u2019 jar loS_tera\u2019 jar vagh_tera\u2019 jar jav_tera\u2019 jar Soch_tera\u2019 jar chorgh_tera\u2019 jar Hut_tera\u2019 jar wa\u2019maH_tera\u2019 jar wa\u2019maH wa\u2019_tera\u2019 jar wa\u2019maH cha\u2019".split(
      "_"
    ),
    monthsShort: "jar wa\u2019_jar cha\u2019_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa\u2019maH_jar wa\u2019maH wa\u2019_jar wa\u2019maH cha\u2019".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split(
      "_"
    ),
    weekdaysShort: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
    weekdaysMin: "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[DaHjaj] LT",
      nextDay: "[wa\u2019leS] LT",
      nextWeek: "LLL",
      lastDay: "[wa\u2019Hu\u2019] LT",
      lastWeek: "LLL",
      sameElse: "L"
    },
    relativeTime: {
      future: translateFuture,
      past: translatePast,
      s: "puS lup",
      ss: translate,
      m: "wa\u2019 tup",
      mm: translate,
      h: "wa\u2019 rep",
      hh: translate,
      d: "wa\u2019 jaj",
      dd: translate,
      M: "wa\u2019 jar",
      MM: translate,
      y: "wa\u2019 DIS",
      yy: translate
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return tlh;
}));


/***/ }),

/***/ 99838:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var suffixes = {
    1: "'inci",
    5: "'inci",
    8: "'inci",
    70: "'inci",
    80: "'inci",
    2: "'nci",
    7: "'nci",
    20: "'nci",
    50: "'nci",
    3: "'\xFCnc\xFC",
    4: "'\xFCnc\xFC",
    100: "'\xFCnc\xFC",
    6: "'nc\u0131",
    9: "'uncu",
    10: "'uncu",
    30: "'uncu",
    60: "'\u0131nc\u0131",
    90: "'\u0131nc\u0131"
  };
  var tr = moment.defineLocale("tr", {
    months: "Ocak_\u015Eubat_Mart_Nisan_May\u0131s_Haziran_Temmuz_A\u011Fustos_Eyl\xFCl_Ekim_Kas\u0131m_Aral\u0131k".split(
      "_"
    ),
    monthsShort: "Oca_\u015Eub_Mar_Nis_May_Haz_Tem_A\u011Fu_Eyl_Eki_Kas_Ara".split("_"),
    weekdays: "Pazar_Pazartesi_Sal\u0131_\xC7ar\u015Famba_Per\u015Fembe_Cuma_Cumartesi".split(
      "_"
    ),
    weekdaysShort: "Paz_Pzt_Sal_\xC7ar_Per_Cum_Cmt".split("_"),
    weekdaysMin: "Pz_Pt_Sa_\xC7a_Pe_Cu_Ct".split("_"),
    meridiem: function(hours, minutes, isLower) {
      if (hours < 12) {
        return isLower ? "\xF6\xF6" : "\xD6\xD6";
      } else {
        return isLower ? "\xF6s" : "\xD6S";
      }
    },
    meridiemParse: /öö|ÖÖ|ös|ÖS/,
    isPM: function(input) {
      return input === "\xF6s" || input === "\xD6S";
    },
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[bug\xFCn saat] LT",
      nextDay: "[yar\u0131n saat] LT",
      nextWeek: "[gelecek] dddd [saat] LT",
      lastDay: "[d\xFCn] LT",
      lastWeek: "[ge\xE7en] dddd [saat] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s sonra",
      past: "%s \xF6nce",
      s: "birka\xE7 saniye",
      ss: "%d saniye",
      m: "bir dakika",
      mm: "%d dakika",
      h: "bir saat",
      hh: "%d saat",
      d: "bir g\xFCn",
      dd: "%d g\xFCn",
      w: "bir hafta",
      ww: "%d hafta",
      M: "bir ay",
      MM: "%d ay",
      y: "bir y\u0131l",
      yy: "%d y\u0131l"
    },
    ordinal: function(number, period) {
      switch (period) {
        case "d":
        case "D":
        case "Do":
        case "DD":
          return number;
        default:
          if (number === 0) {
            return number + "'\u0131nc\u0131";
          }
          var a = number % 10, b = number % 100 - a, c = number >= 100 ? 100 : null;
          return number + (suffixes[a] || suffixes[b] || suffixes[c]);
      }
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return tr;
}));


/***/ }),

/***/ 33360:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var tzl = moment.defineLocale("tzl", {
    months: "Januar_Fevraglh_Mar\xE7_Avr\xEFu_Mai_G\xFCn_Julia_Guscht_Setemvar_Listop\xE4ts_Noemvar_Zecemvar".split(
      "_"
    ),
    monthsShort: "Jan_Fev_Mar_Avr_Mai_G\xFCn_Jul_Gus_Set_Lis_Noe_Zec".split("_"),
    weekdays: "S\xFAladi_L\xFAne\xE7i_Maitzi_M\xE1rcuri_Xh\xFAadi_Vi\xE9ner\xE7i_S\xE1turi".split("_"),
    weekdaysShort: "S\xFAl_L\xFAn_Mai_M\xE1r_Xh\xFA_Vi\xE9_S\xE1t".split("_"),
    weekdaysMin: "S\xFA_L\xFA_Ma_M\xE1_Xh_Vi_S\xE1".split("_"),
    longDateFormat: {
      LT: "HH.mm",
      LTS: "HH.mm.ss",
      L: "DD.MM.YYYY",
      LL: "D. MMMM [dallas] YYYY",
      LLL: "D. MMMM [dallas] YYYY HH.mm",
      LLLL: "dddd, [li] D. MMMM [dallas] YYYY HH.mm"
    },
    meridiemParse: /d\'o|d\'a/i,
    isPM: function(input) {
      return "d'o" === input.toLowerCase();
    },
    meridiem: function(hours, minutes, isLower) {
      if (hours > 11) {
        return isLower ? "d'o" : "D'O";
      } else {
        return isLower ? "d'a" : "D'A";
      }
    },
    calendar: {
      sameDay: "[oxhi \xE0] LT",
      nextDay: "[dem\xE0 \xE0] LT",
      nextWeek: "dddd [\xE0] LT",
      lastDay: "[ieiri \xE0] LT",
      lastWeek: "[s\xFCr el] dddd [lasteu \xE0] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "osprei %s",
      past: "ja%s",
      s: processRelativeTime,
      ss: processRelativeTime,
      m: processRelativeTime,
      mm: processRelativeTime,
      h: processRelativeTime,
      hh: processRelativeTime,
      d: processRelativeTime,
      dd: processRelativeTime,
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: "%d.",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
      s: ["viensas secunds", "'iensas secunds"],
      ss: [number + " secunds", "" + number + " secunds"],
      m: ["'n m\xEDut", "'iens m\xEDut"],
      mm: [number + " m\xEDuts", "" + number + " m\xEDuts"],
      h: ["'n \xFEora", "'iensa \xFEora"],
      hh: [number + " \xFEoras", "" + number + " \xFEoras"],
      d: ["'n ziua", "'iensa ziua"],
      dd: [number + " ziuas", "" + number + " ziuas"],
      M: ["'n mes", "'iens mes"],
      MM: [number + " mesen", "" + number + " mesen"],
      y: ["'n ar", "'iens ar"],
      yy: [number + " ars", "" + number + " ars"]
    };
    return isFuture ? format[key][0] : withoutSuffix ? format[key][0] : format[key][1];
  }
  return tzl;
}));


/***/ }),

/***/ 96977:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var tzmLatn = moment.defineLocale("tzm-latn", {
    months: "innayr_br\u02E4ayr\u02E4_mar\u02E4s\u02E4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02E4wbr\u02E4_nwwanbir_dwjnbir".split(
      "_"
    ),
    monthsShort: "innayr_br\u02E4ayr\u02E4_mar\u02E4s\u02E4_ibrir_mayyw_ywnyw_ywlywz_\u0263w\u0161t_\u0161wtanbir_kt\u02E4wbr\u02E4_nwwanbir_dwjnbir".split(
      "_"
    ),
    weekdays: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1E0Dyas".split("_"),
    weekdaysShort: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1E0Dyas".split("_"),
    weekdaysMin: "asamas_aynas_asinas_akras_akwas_asimwas_asi\u1E0Dyas".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[asdkh g] LT",
      nextDay: "[aska g] LT",
      nextWeek: "dddd [g] LT",
      lastDay: "[assant g] LT",
      lastWeek: "dddd [g] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "dadkh s yan %s",
      past: "yan %s",
      s: "imik",
      ss: "%d imik",
      m: "minu\u1E0D",
      mm: "%d minu\u1E0D",
      h: "sa\u025Ba",
      hh: "%d tassa\u025Bin",
      d: "ass",
      dd: "%d ossan",
      M: "ayowr",
      MM: "%d iyyirn",
      y: "asgas",
      yy: "%d isgasn"
    },
    week: {
      dow: 6,
      // Saturday is the first day of the week.
      doy: 12
      // The week that contains Jan 12th is the first week of the year.
    }
  });
  return tzmLatn;
}));


/***/ }),

/***/ 57511:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var tzm = moment.defineLocale("tzm", {
    months: "\u2D49\u2D4F\u2D4F\u2D30\u2D62\u2D54_\u2D31\u2D55\u2D30\u2D62\u2D55_\u2D4E\u2D30\u2D55\u2D5A_\u2D49\u2D31\u2D54\u2D49\u2D54_\u2D4E\u2D30\u2D62\u2D62\u2D53_\u2D62\u2D53\u2D4F\u2D62\u2D53_\u2D62\u2D53\u2D4D\u2D62\u2D53\u2D63_\u2D56\u2D53\u2D5B\u2D5C_\u2D5B\u2D53\u2D5C\u2D30\u2D4F\u2D31\u2D49\u2D54_\u2D3D\u2D5F\u2D53\u2D31\u2D55_\u2D4F\u2D53\u2D61\u2D30\u2D4F\u2D31\u2D49\u2D54_\u2D37\u2D53\u2D4A\u2D4F\u2D31\u2D49\u2D54".split(
      "_"
    ),
    monthsShort: "\u2D49\u2D4F\u2D4F\u2D30\u2D62\u2D54_\u2D31\u2D55\u2D30\u2D62\u2D55_\u2D4E\u2D30\u2D55\u2D5A_\u2D49\u2D31\u2D54\u2D49\u2D54_\u2D4E\u2D30\u2D62\u2D62\u2D53_\u2D62\u2D53\u2D4F\u2D62\u2D53_\u2D62\u2D53\u2D4D\u2D62\u2D53\u2D63_\u2D56\u2D53\u2D5B\u2D5C_\u2D5B\u2D53\u2D5C\u2D30\u2D4F\u2D31\u2D49\u2D54_\u2D3D\u2D5F\u2D53\u2D31\u2D55_\u2D4F\u2D53\u2D61\u2D30\u2D4F\u2D31\u2D49\u2D54_\u2D37\u2D53\u2D4A\u2D4F\u2D31\u2D49\u2D54".split(
      "_"
    ),
    weekdays: "\u2D30\u2D59\u2D30\u2D4E\u2D30\u2D59_\u2D30\u2D62\u2D4F\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4F\u2D30\u2D59_\u2D30\u2D3D\u2D54\u2D30\u2D59_\u2D30\u2D3D\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4E\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D39\u2D62\u2D30\u2D59".split("_"),
    weekdaysShort: "\u2D30\u2D59\u2D30\u2D4E\u2D30\u2D59_\u2D30\u2D62\u2D4F\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4F\u2D30\u2D59_\u2D30\u2D3D\u2D54\u2D30\u2D59_\u2D30\u2D3D\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4E\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D39\u2D62\u2D30\u2D59".split("_"),
    weekdaysMin: "\u2D30\u2D59\u2D30\u2D4E\u2D30\u2D59_\u2D30\u2D62\u2D4F\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4F\u2D30\u2D59_\u2D30\u2D3D\u2D54\u2D30\u2D59_\u2D30\u2D3D\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D4E\u2D61\u2D30\u2D59_\u2D30\u2D59\u2D49\u2D39\u2D62\u2D30\u2D59".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[\u2D30\u2D59\u2D37\u2D45 \u2D34] LT",
      nextDay: "[\u2D30\u2D59\u2D3D\u2D30 \u2D34] LT",
      nextWeek: "dddd [\u2D34] LT",
      lastDay: "[\u2D30\u2D5A\u2D30\u2D4F\u2D5C \u2D34] LT",
      lastWeek: "dddd [\u2D34] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u2D37\u2D30\u2D37\u2D45 \u2D59 \u2D62\u2D30\u2D4F %s",
      past: "\u2D62\u2D30\u2D4F %s",
      s: "\u2D49\u2D4E\u2D49\u2D3D",
      ss: "%d \u2D49\u2D4E\u2D49\u2D3D",
      m: "\u2D4E\u2D49\u2D4F\u2D53\u2D3A",
      mm: "%d \u2D4E\u2D49\u2D4F\u2D53\u2D3A",
      h: "\u2D59\u2D30\u2D44\u2D30",
      hh: "%d \u2D5C\u2D30\u2D59\u2D59\u2D30\u2D44\u2D49\u2D4F",
      d: "\u2D30\u2D59\u2D59",
      dd: "%d o\u2D59\u2D59\u2D30\u2D4F",
      M: "\u2D30\u2D62o\u2D53\u2D54",
      MM: "%d \u2D49\u2D62\u2D62\u2D49\u2D54\u2D4F",
      y: "\u2D30\u2D59\u2D33\u2D30\u2D59",
      yy: "%d \u2D49\u2D59\u2D33\u2D30\u2D59\u2D4F"
    },
    week: {
      dow: 6,
      // Saturday is the first day of the week.
      doy: 12
      // The week that contains Jan 12th is the first week of the year.
    }
  });
  return tzm;
}));


/***/ }),

/***/ 41360:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var ugCn = moment.defineLocale("ug-cn", {
    months: "\u064A\u0627\u0646\u06CB\u0627\u0631_\u0641\u06D0\u06CB\u0631\u0627\u0644_\u0645\u0627\u0631\u062A_\u0626\u0627\u067E\u0631\u06D0\u0644_\u0645\u0627\u064A_\u0626\u0649\u064A\u06C7\u0646_\u0626\u0649\u064A\u06C7\u0644_\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A_\u0633\u06D0\u0646\u062A\u06D5\u0628\u0649\u0631_\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631_\u0646\u0648\u064A\u0627\u0628\u0649\u0631_\u062F\u06D0\u0643\u0627\u0628\u0649\u0631".split(
      "_"
    ),
    monthsShort: "\u064A\u0627\u0646\u06CB\u0627\u0631_\u0641\u06D0\u06CB\u0631\u0627\u0644_\u0645\u0627\u0631\u062A_\u0626\u0627\u067E\u0631\u06D0\u0644_\u0645\u0627\u064A_\u0626\u0649\u064A\u06C7\u0646_\u0626\u0649\u064A\u06C7\u0644_\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A_\u0633\u06D0\u0646\u062A\u06D5\u0628\u0649\u0631_\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631_\u0646\u0648\u064A\u0627\u0628\u0649\u0631_\u062F\u06D0\u0643\u0627\u0628\u0649\u0631".split(
      "_"
    ),
    weekdays: "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5_\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5_\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5_\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5_\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5_\u062C\u06C8\u0645\u06D5_\u0634\u06D5\u0646\u0628\u06D5".split(
      "_"
    ),
    weekdaysShort: "\u064A\u06D5_\u062F\u06C8_\u0633\u06D5_\u0686\u0627_\u067E\u06D5_\u062C\u06C8_\u0634\u06D5".split("_"),
    weekdaysMin: "\u064A\u06D5_\u062F\u06C8_\u0633\u06D5_\u0686\u0627_\u067E\u06D5_\u062C\u06C8_\u0634\u06D5".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY-MM-DD",
      LL: "YYYY-\u064A\u0649\u0644\u0649M-\u0626\u0627\u064A\u0646\u0649\u06ADD-\u0643\u06C8\u0646\u0649",
      LLL: "YYYY-\u064A\u0649\u0644\u0649M-\u0626\u0627\u064A\u0646\u0649\u06ADD-\u0643\u06C8\u0646\u0649\u060C HH:mm",
      LLLL: "dddd\u060C YYYY-\u064A\u0649\u0644\u0649M-\u0626\u0627\u064A\u0646\u0649\u06ADD-\u0643\u06C8\u0646\u0649\u060C HH:mm"
    },
    meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u064A\u06D0\u0631\u0649\u0645 \u0643\u06D0\u0686\u06D5" || meridiem === "\u0633\u06D5\u06BE\u06D5\u0631" || meridiem === "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646") {
        return hour;
      } else if (meridiem === "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u06D0\u064A\u0649\u0646" || meridiem === "\u0643\u06D5\u0686") {
        return hour + 12;
      } else {
        return hour >= 11 ? hour : hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      var hm = hour * 100 + minute;
      if (hm < 600) {
        return "\u064A\u06D0\u0631\u0649\u0645 \u0643\u06D0\u0686\u06D5";
      } else if (hm < 900) {
        return "\u0633\u06D5\u06BE\u06D5\u0631";
      } else if (hm < 1130) {
        return "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646";
      } else if (hm < 1230) {
        return "\u0686\u06C8\u0634";
      } else if (hm < 1800) {
        return "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u06D0\u064A\u0649\u0646";
      } else {
        return "\u0643\u06D5\u0686";
      }
    },
    calendar: {
      sameDay: "[\u0628\u06C8\u06AF\u06C8\u0646 \u0633\u0627\u0626\u06D5\u062A] LT",
      nextDay: "[\u0626\u06D5\u062A\u06D5 \u0633\u0627\u0626\u06D5\u062A] LT",
      nextWeek: "[\u0643\u06D0\u0644\u06D5\u0631\u0643\u0649] dddd [\u0633\u0627\u0626\u06D5\u062A] LT",
      lastDay: "[\u062A\u06C6\u0646\u06C8\u06AF\u06C8\u0646] LT",
      lastWeek: "[\u0626\u0627\u0644\u062F\u0649\u0646\u0642\u0649] dddd [\u0633\u0627\u0626\u06D5\u062A] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0643\u06D0\u064A\u0649\u0646",
      past: "%s \u0628\u06C7\u0631\u06C7\u0646",
      s: "\u0646\u06D5\u0686\u0686\u06D5 \u0633\u06D0\u0643\u0648\u0646\u062A",
      ss: "%d \u0633\u06D0\u0643\u0648\u0646\u062A",
      m: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
      mm: "%d \u0645\u0649\u0646\u06C7\u062A",
      h: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
      hh: "%d \u0633\u0627\u0626\u06D5\u062A",
      d: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
      dd: "%d \u0643\u06C8\u0646",
      M: "\u0628\u0649\u0631 \u0626\u0627\u064A",
      MM: "%d \u0626\u0627\u064A",
      y: "\u0628\u0649\u0631 \u064A\u0649\u0644",
      yy: "%d \u064A\u0649\u0644"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
    ordinal: function(number, period) {
      switch (period) {
        case "d":
        case "D":
        case "DDD":
          return number + "-\u0643\u06C8\u0646\u0649";
        case "w":
        case "W":
          return number + "-\u06BE\u06D5\u067E\u062A\u06D5";
        default:
          return number;
      }
    },
    preparse: function(string) {
      return string.replace(/،/g, ",");
    },
    postformat: function(string) {
      return string.replace(/,/g, "\u060C");
    },
    week: {
      // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 1st is the first week of the year.
    }
  });
  return ugCn;
}));


/***/ }),

/***/ 37144:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  function plural(word, num) {
    var forms = word.split("_");
    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2];
  }
  function relativeTimeWithPlural(number, withoutSuffix, key) {
    var format = {
      ss: withoutSuffix ? "\u0441\u0435\u043A\u0443\u043D\u0434\u0430_\u0441\u0435\u043A\u0443\u043D\u0434\u0438_\u0441\u0435\u043A\u0443\u043D\u0434" : "\u0441\u0435\u043A\u0443\u043D\u0434\u0443_\u0441\u0435\u043A\u0443\u043D\u0434\u0438_\u0441\u0435\u043A\u0443\u043D\u0434",
      mm: withoutSuffix ? "\u0445\u0432\u0438\u043B\u0438\u043D\u0430_\u0445\u0432\u0438\u043B\u0438\u043D\u0438_\u0445\u0432\u0438\u043B\u0438\u043D" : "\u0445\u0432\u0438\u043B\u0438\u043D\u0443_\u0445\u0432\u0438\u043B\u0438\u043D\u0438_\u0445\u0432\u0438\u043B\u0438\u043D",
      hh: withoutSuffix ? "\u0433\u043E\u0434\u0438\u043D\u0430_\u0433\u043E\u0434\u0438\u043D\u0438_\u0433\u043E\u0434\u0438\u043D" : "\u0433\u043E\u0434\u0438\u043D\u0443_\u0433\u043E\u0434\u0438\u043D\u0438_\u0433\u043E\u0434\u0438\u043D",
      dd: "\u0434\u0435\u043D\u044C_\u0434\u043D\u0456_\u0434\u043D\u0456\u0432",
      MM: "\u043C\u0456\u0441\u044F\u0446\u044C_\u043C\u0456\u0441\u044F\u0446\u0456_\u043C\u0456\u0441\u044F\u0446\u0456\u0432",
      yy: "\u0440\u0456\u043A_\u0440\u043E\u043A\u0438_\u0440\u043E\u043A\u0456\u0432"
    };
    if (key === "m") {
      return withoutSuffix ? "\u0445\u0432\u0438\u043B\u0438\u043D\u0430" : "\u0445\u0432\u0438\u043B\u0438\u043D\u0443";
    } else if (key === "h") {
      return withoutSuffix ? "\u0433\u043E\u0434\u0438\u043D\u0430" : "\u0433\u043E\u0434\u0438\u043D\u0443";
    } else {
      return number + " " + plural(format[key], +number);
    }
  }
  function weekdaysCaseReplace(m, format) {
    var weekdays = {
      nominative: "\u043D\u0435\u0434\u0456\u043B\u044F_\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A_\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A_\u0441\u0435\u0440\u0435\u0434\u0430_\u0447\u0435\u0442\u0432\u0435\u0440_\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F_\u0441\u0443\u0431\u043E\u0442\u0430".split(
        "_"
      ),
      accusative: "\u043D\u0435\u0434\u0456\u043B\u044E_\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A_\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A_\u0441\u0435\u0440\u0435\u0434\u0443_\u0447\u0435\u0442\u0432\u0435\u0440_\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E_\u0441\u0443\u0431\u043E\u0442\u0443".split(
        "_"
      ),
      genitive: "\u043D\u0435\u0434\u0456\u043B\u0456_\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043A\u0430_\u0432\u0456\u0432\u0442\u043E\u0440\u043A\u0430_\u0441\u0435\u0440\u0435\u0434\u0438_\u0447\u0435\u0442\u0432\u0435\u0440\u0433\u0430_\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u0456_\u0441\u0443\u0431\u043E\u0442\u0438".split(
        "_"
      )
    }, nounCase;
    if (m === true) {
      return weekdays["nominative"].slice(1, 7).concat(weekdays["nominative"].slice(0, 1));
    }
    if (!m) {
      return weekdays["nominative"];
    }
    nounCase = /(\[[ВвУу]\]) ?dddd/.test(format) ? "accusative" : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format) ? "genitive" : "nominative";
    return weekdays[nounCase][m.day()];
  }
  function processHoursFunction(str) {
    return function() {
      return str + "\u043E" + (this.hours() === 11 ? "\u0431" : "") + "] LT";
    };
  }
  var uk = moment.defineLocale("uk", {
    months: {
      format: "\u0441\u0456\u0447\u043D\u044F_\u043B\u044E\u0442\u043E\u0433\u043E_\u0431\u0435\u0440\u0435\u0437\u043D\u044F_\u043A\u0432\u0456\u0442\u043D\u044F_\u0442\u0440\u0430\u0432\u043D\u044F_\u0447\u0435\u0440\u0432\u043D\u044F_\u043B\u0438\u043F\u043D\u044F_\u0441\u0435\u0440\u043F\u043D\u044F_\u0432\u0435\u0440\u0435\u0441\u043D\u044F_\u0436\u043E\u0432\u0442\u043D\u044F_\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430_\u0433\u0440\u0443\u0434\u043D\u044F".split(
        "_"
      ),
      standalone: "\u0441\u0456\u0447\u0435\u043D\u044C_\u043B\u044E\u0442\u0438\u0439_\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C_\u043A\u0432\u0456\u0442\u0435\u043D\u044C_\u0442\u0440\u0430\u0432\u0435\u043D\u044C_\u0447\u0435\u0440\u0432\u0435\u043D\u044C_\u043B\u0438\u043F\u0435\u043D\u044C_\u0441\u0435\u0440\u043F\u0435\u043D\u044C_\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C_\u0436\u043E\u0432\u0442\u0435\u043D\u044C_\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434_\u0433\u0440\u0443\u0434\u0435\u043D\u044C".split(
        "_"
      )
    },
    monthsShort: "\u0441\u0456\u0447_\u043B\u044E\u0442_\u0431\u0435\u0440_\u043A\u0432\u0456\u0442_\u0442\u0440\u0430\u0432_\u0447\u0435\u0440\u0432_\u043B\u0438\u043F_\u0441\u0435\u0440\u043F_\u0432\u0435\u0440_\u0436\u043E\u0432\u0442_\u043B\u0438\u0441\u0442_\u0433\u0440\u0443\u0434".split(
      "_"
    ),
    weekdays: weekdaysCaseReplace,
    weekdaysShort: "\u043D\u0434_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
    weekdaysMin: "\u043D\u0434_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD.MM.YYYY",
      LL: "D MMMM YYYY \u0440.",
      LLL: "D MMMM YYYY \u0440., HH:mm",
      LLLL: "dddd, D MMMM YYYY \u0440., HH:mm"
    },
    calendar: {
      sameDay: processHoursFunction("[\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456 "),
      nextDay: processHoursFunction("[\u0417\u0430\u0432\u0442\u0440\u0430 "),
      lastDay: processHoursFunction("[\u0412\u0447\u043E\u0440\u0430 "),
      nextWeek: processHoursFunction("[\u0423] dddd ["),
      lastWeek: function() {
        switch (this.day()) {
          case 0:
          case 3:
          case 5:
          case 6:
            return processHoursFunction("[\u041C\u0438\u043D\u0443\u043B\u043E\u0457] dddd [").call(this);
          case 1:
          case 2:
          case 4:
            return processHoursFunction("[\u041C\u0438\u043D\u0443\u043B\u043E\u0433\u043E] dddd [").call(this);
        }
      },
      sameElse: "L"
    },
    relativeTime: {
      future: "\u0437\u0430 %s",
      past: "%s \u0442\u043E\u043C\u0443",
      s: "\u0434\u0435\u043A\u0456\u043B\u044C\u043A\u0430 \u0441\u0435\u043A\u0443\u043D\u0434",
      ss: relativeTimeWithPlural,
      m: relativeTimeWithPlural,
      mm: relativeTimeWithPlural,
      h: "\u0433\u043E\u0434\u0438\u043D\u0443",
      hh: relativeTimeWithPlural,
      d: "\u0434\u0435\u043D\u044C",
      dd: relativeTimeWithPlural,
      M: "\u043C\u0456\u0441\u044F\u0446\u044C",
      MM: relativeTimeWithPlural,
      y: "\u0440\u0456\u043A",
      yy: relativeTimeWithPlural
    },
    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
    meridiemParse: /ночі|ранку|дня|вечора/,
    isPM: function(input) {
      return /^(дня|вечора)$/.test(input);
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 4) {
        return "\u043D\u043E\u0447\u0456";
      } else if (hour < 12) {
        return "\u0440\u0430\u043D\u043A\u0443";
      } else if (hour < 17) {
        return "\u0434\u043D\u044F";
      } else {
        return "\u0432\u0435\u0447\u043E\u0440\u0430";
      }
    },
    dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
    ordinal: function(number, period) {
      switch (period) {
        case "M":
        case "d":
        case "DDD":
        case "w":
        case "W":
          return number + "-\u0439";
        case "D":
          return number + "-\u0433\u043E";
        default:
          return number;
      }
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return uk;
}));


/***/ }),

/***/ 53783:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var months = [
    "\u062C\u0646\u0648\u0631\u06CC",
    "\u0641\u0631\u0648\u0631\u06CC",
    "\u0645\u0627\u0631\u0686",
    "\u0627\u067E\u0631\u06CC\u0644",
    "\u0645\u0626\u06CC",
    "\u062C\u0648\u0646",
    "\u062C\u0648\u0644\u0627\u0626\u06CC",
    "\u0627\u06AF\u0633\u062A",
    "\u0633\u062A\u0645\u0628\u0631",
    "\u0627\u06A9\u062A\u0648\u0628\u0631",
    "\u0646\u0648\u0645\u0628\u0631",
    "\u062F\u0633\u0645\u0628\u0631"
  ], days = ["\u0627\u062A\u0648\u0627\u0631", "\u067E\u06CC\u0631", "\u0645\u0646\u06AF\u0644", "\u0628\u062F\u06BE", "\u062C\u0645\u0639\u0631\u0627\u062A", "\u062C\u0645\u0639\u06C1", "\u06C1\u0641\u062A\u06C1"];
  var ur = moment.defineLocale("ur", {
    months,
    monthsShort: months,
    weekdays: days,
    weekdaysShort: days,
    weekdaysMin: days,
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd\u060C D MMMM YYYY HH:mm"
    },
    meridiemParse: /صبح|شام/,
    isPM: function(input) {
      return "\u0634\u0627\u0645" === input;
    },
    meridiem: function(hour, minute, isLower) {
      if (hour < 12) {
        return "\u0635\u0628\u062D";
      }
      return "\u0634\u0627\u0645";
    },
    calendar: {
      sameDay: "[\u0622\u062C \u0628\u0648\u0642\u062A] LT",
      nextDay: "[\u06A9\u0644 \u0628\u0648\u0642\u062A] LT",
      nextWeek: "dddd [\u0628\u0648\u0642\u062A] LT",
      lastDay: "[\u06AF\u0630\u0634\u062A\u06C1 \u0631\u0648\u0632 \u0628\u0648\u0642\u062A] LT",
      lastWeek: "[\u06AF\u0630\u0634\u062A\u06C1] dddd [\u0628\u0648\u0642\u062A] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s \u0628\u0639\u062F",
      past: "%s \u0642\u0628\u0644",
      s: "\u0686\u0646\u062F \u0633\u06CC\u06A9\u0646\u0688",
      ss: "%d \u0633\u06CC\u06A9\u0646\u0688",
      m: "\u0627\u06CC\u06A9 \u0645\u0646\u0679",
      mm: "%d \u0645\u0646\u0679",
      h: "\u0627\u06CC\u06A9 \u06AF\u06BE\u0646\u0679\u06C1",
      hh: "%d \u06AF\u06BE\u0646\u0679\u06D2",
      d: "\u0627\u06CC\u06A9 \u062F\u0646",
      dd: "%d \u062F\u0646",
      M: "\u0627\u06CC\u06A9 \u0645\u0627\u06C1",
      MM: "%d \u0645\u0627\u06C1",
      y: "\u0627\u06CC\u06A9 \u0633\u0627\u0644",
      yy: "%d \u0633\u0627\u0644"
    },
    preparse: function(string) {
      return string.replace(/،/g, ",");
    },
    postformat: function(string) {
      return string.replace(/,/g, "\u060C");
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return ur;
}));


/***/ }),

/***/ 76937:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var uzLatn = moment.defineLocale("uz-latn", {
    months: "Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split(
      "_"
    ),
    monthsShort: "Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),
    weekdays: "Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split(
      "_"
    ),
    weekdaysShort: "Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),
    weekdaysMin: "Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "D MMMM YYYY, dddd HH:mm"
    },
    calendar: {
      sameDay: "[Bugun soat] LT [da]",
      nextDay: "[Ertaga] LT [da]",
      nextWeek: "dddd [kuni soat] LT [da]",
      lastDay: "[Kecha soat] LT [da]",
      lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
      sameElse: "L"
    },
    relativeTime: {
      future: "Yaqin %s ichida",
      past: "Bir necha %s oldin",
      s: "soniya",
      ss: "%d soniya",
      m: "bir daqiqa",
      mm: "%d daqiqa",
      h: "bir soat",
      hh: "%d soat",
      d: "bir kun",
      dd: "%d kun",
      M: "bir oy",
      MM: "%d oy",
      y: "bir yil",
      yy: "%d yil"
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 7th is the first week of the year.
    }
  });
  return uzLatn;
}));


/***/ }),

/***/ 59647:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var uz = moment.defineLocale("uz", {
    months: "\u044F\u043D\u0432\u0430\u0440_\u0444\u0435\u0432\u0440\u0430\u043B_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0435\u043B_\u043C\u0430\u0439_\u0438\u044E\u043D_\u0438\u044E\u043B_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043D\u0442\u044F\u0431\u0440_\u043E\u043A\u0442\u044F\u0431\u0440_\u043D\u043E\u044F\u0431\u0440_\u0434\u0435\u043A\u0430\u0431\u0440".split(
      "_"
    ),
    monthsShort: "\u044F\u043D\u0432_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0439_\u0438\u044E\u043D_\u0438\u044E\u043B_\u0430\u0432\u0433_\u0441\u0435\u043D_\u043E\u043A\u0442_\u043D\u043E\u044F_\u0434\u0435\u043A".split("_"),
    weekdays: "\u042F\u043A\u0448\u0430\u043D\u0431\u0430_\u0414\u0443\u0448\u0430\u043D\u0431\u0430_\u0421\u0435\u0448\u0430\u043D\u0431\u0430_\u0427\u043E\u0440\u0448\u0430\u043D\u0431\u0430_\u041F\u0430\u0439\u0448\u0430\u043D\u0431\u0430_\u0416\u0443\u043C\u0430_\u0428\u0430\u043D\u0431\u0430".split("_"),
    weekdaysShort: "\u042F\u043A\u0448_\u0414\u0443\u0448_\u0421\u0435\u0448_\u0427\u043E\u0440_\u041F\u0430\u0439_\u0416\u0443\u043C_\u0428\u0430\u043D".split("_"),
    weekdaysMin: "\u042F\u043A_\u0414\u0443_\u0421\u0435_\u0427\u043E_\u041F\u0430_\u0416\u0443_\u0428\u0430".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "D MMMM YYYY, dddd HH:mm"
    },
    calendar: {
      sameDay: "[\u0411\u0443\u0433\u0443\u043D \u0441\u043E\u0430\u0442] LT [\u0434\u0430]",
      nextDay: "[\u042D\u0440\u0442\u0430\u0433\u0430] LT [\u0434\u0430]",
      nextWeek: "dddd [\u043A\u0443\u043D\u0438 \u0441\u043E\u0430\u0442] LT [\u0434\u0430]",
      lastDay: "[\u041A\u0435\u0447\u0430 \u0441\u043E\u0430\u0442] LT [\u0434\u0430]",
      lastWeek: "[\u0423\u0442\u0433\u0430\u043D] dddd [\u043A\u0443\u043D\u0438 \u0441\u043E\u0430\u0442] LT [\u0434\u0430]",
      sameElse: "L"
    },
    relativeTime: {
      future: "\u042F\u043A\u0438\u043D %s \u0438\u0447\u0438\u0434\u0430",
      past: "\u0411\u0438\u0440 \u043D\u0435\u0447\u0430 %s \u043E\u043B\u0434\u0438\u043D",
      s: "\u0444\u0443\u0440\u0441\u0430\u0442",
      ss: "%d \u0444\u0443\u0440\u0441\u0430\u0442",
      m: "\u0431\u0438\u0440 \u0434\u0430\u043A\u0438\u043A\u0430",
      mm: "%d \u0434\u0430\u043A\u0438\u043A\u0430",
      h: "\u0431\u0438\u0440 \u0441\u043E\u0430\u0442",
      hh: "%d \u0441\u043E\u0430\u0442",
      d: "\u0431\u0438\u0440 \u043A\u0443\u043D",
      dd: "%d \u043A\u0443\u043D",
      M: "\u0431\u0438\u0440 \u043E\u0439",
      MM: "%d \u043E\u0439",
      y: "\u0431\u0438\u0440 \u0439\u0438\u043B",
      yy: "%d \u0439\u0438\u043B"
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 7
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return uz;
}));


/***/ }),

/***/ 94013:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var vi = moment.defineLocale("vi", {
    months: "th\xE1ng 1_th\xE1ng 2_th\xE1ng 3_th\xE1ng 4_th\xE1ng 5_th\xE1ng 6_th\xE1ng 7_th\xE1ng 8_th\xE1ng 9_th\xE1ng 10_th\xE1ng 11_th\xE1ng 12".split(
      "_"
    ),
    monthsShort: "Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "ch\u1EE7 nh\u1EADt_th\u1EE9 hai_th\u1EE9 ba_th\u1EE9 t\u01B0_th\u1EE9 n\u0103m_th\u1EE9 s\xE1u_th\u1EE9 b\u1EA3y".split(
      "_"
    ),
    weekdaysShort: "CN_T2_T3_T4_T5_T6_T7".split("_"),
    weekdaysMin: "CN_T2_T3_T4_T5_T6_T7".split("_"),
    weekdaysParseExact: true,
    meridiemParse: /sa|ch/i,
    isPM: function(input) {
      return /^ch$/i.test(input);
    },
    meridiem: function(hours, minutes, isLower) {
      if (hours < 12) {
        return isLower ? "sa" : "SA";
      } else {
        return isLower ? "ch" : "CH";
      }
    },
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM [n\u0103m] YYYY",
      LLL: "D MMMM [n\u0103m] YYYY HH:mm",
      LLLL: "dddd, D MMMM [n\u0103m] YYYY HH:mm",
      l: "DD/M/YYYY",
      ll: "D MMM YYYY",
      lll: "D MMM YYYY HH:mm",
      llll: "ddd, D MMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[H\xF4m nay l\xFAc] LT",
      nextDay: "[Ng\xE0y mai l\xFAc] LT",
      nextWeek: "dddd [tu\u1EA7n t\u1EDBi l\xFAc] LT",
      lastDay: "[H\xF4m qua l\xFAc] LT",
      lastWeek: "dddd [tu\u1EA7n tr\u01B0\u1EDBc l\xFAc] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "%s t\u1EDBi",
      past: "%s tr\u01B0\u1EDBc",
      s: "v\xE0i gi\xE2y",
      ss: "%d gi\xE2y",
      m: "m\u1ED9t ph\xFAt",
      mm: "%d ph\xFAt",
      h: "m\u1ED9t gi\u1EDD",
      hh: "%d gi\u1EDD",
      d: "m\u1ED9t ng\xE0y",
      dd: "%d ng\xE0y",
      w: "m\u1ED9t tu\u1EA7n",
      ww: "%d tu\u1EA7n",
      M: "m\u1ED9t th\xE1ng",
      MM: "%d th\xE1ng",
      y: "m\u1ED9t n\u0103m",
      yy: "%d n\u0103m"
    },
    dayOfMonthOrdinalParse: /\d{1,2}/,
    ordinal: function(number) {
      return number;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return vi;
}));


/***/ }),

/***/ 32525:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var xPseudo = moment.defineLocale("x-pseudo", {
    months: "J~\xE1\xF1\xFA\xE1~r\xFD_F~\xE9br\xFA~\xE1r\xFD_~M\xE1rc~h_\xC1p~r\xEDl_~M\xE1\xFD_~J\xFA\xF1\xE9~_J\xFAl~\xFD_\xC1\xFA~g\xFAst~_S\xE9p~t\xE9mb~\xE9r_\xD3~ct\xF3b~\xE9r_\xD1~\xF3v\xE9m~b\xE9r_~D\xE9c\xE9~mb\xE9r".split(
      "_"
    ),
    monthsShort: "J~\xE1\xF1_~F\xE9b_~M\xE1r_~\xC1pr_~M\xE1\xFD_~J\xFA\xF1_~J\xFAl_~\xC1\xFAg_~S\xE9p_~\xD3ct_~\xD1\xF3v_~D\xE9c".split(
      "_"
    ),
    monthsParseExact: true,
    weekdays: "S~\xFA\xF1d\xE1~\xFD_M\xF3~\xF1d\xE1\xFD~_T\xFA\xE9~sd\xE1\xFD~_W\xE9d~\xF1\xE9sd~\xE1\xFD_T~h\xFArs~d\xE1\xFD_~Fr\xEDd~\xE1\xFD_S~\xE1t\xFAr~d\xE1\xFD".split(
      "_"
    ),
    weekdaysShort: "S~\xFA\xF1_~M\xF3\xF1_~T\xFA\xE9_~W\xE9d_~Th\xFA_~Fr\xED_~S\xE1t".split("_"),
    weekdaysMin: "S~\xFA_M\xF3~_T\xFA_~W\xE9_T~h_Fr~_S\xE1".split("_"),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: "HH:mm",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd, D MMMM YYYY HH:mm"
    },
    calendar: {
      sameDay: "[T~\xF3d\xE1~\xFD \xE1t] LT",
      nextDay: "[T~\xF3m\xF3~rr\xF3~w \xE1t] LT",
      nextWeek: "dddd [\xE1t] LT",
      lastDay: "[\xDD~\xE9st~\xE9rd\xE1~\xFD \xE1t] LT",
      lastWeek: "[L~\xE1st] dddd [\xE1t] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "\xED~\xF1 %s",
      past: "%s \xE1~g\xF3",
      s: "\xE1 ~f\xE9w ~s\xE9c\xF3~\xF1ds",
      ss: "%d s~\xE9c\xF3\xF1~ds",
      m: "\xE1 ~m\xED\xF1~\xFAt\xE9",
      mm: "%d m~\xED\xF1\xFA~t\xE9s",
      h: "\xE1~\xF1 h\xF3~\xFAr",
      hh: "%d h~\xF3\xFArs",
      d: "\xE1 ~d\xE1\xFD",
      dd: "%d d~\xE1\xFDs",
      M: "\xE1 ~m\xF3\xF1~th",
      MM: "%d m~\xF3\xF1t~hs",
      y: "\xE1 ~\xFD\xE9\xE1r",
      yy: "%d \xFD~\xE9\xE1rs"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function(number) {
      var b = number % 10, output = ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
      return number + output;
    },
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return xPseudo;
}));


/***/ }),

/***/ 41872:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var yo = moment.defineLocale("yo", {
    months: "S\u1EB9\u0301r\u1EB9\u0301_E\u0300re\u0300le\u0300_\u1EB8r\u1EB9\u0300na\u0300_I\u0300gbe\u0301_E\u0300bibi_O\u0300ku\u0300du_Ag\u1EB9mo_O\u0300gu\u0301n_Owewe_\u1ECC\u0300wa\u0300ra\u0300_Be\u0301lu\u0301_\u1ECC\u0300p\u1EB9\u0300\u0300".split(
      "_"
    ),
    monthsShort: "S\u1EB9\u0301r_E\u0300rl_\u1EB8rn_I\u0300gb_E\u0300bi_O\u0300ku\u0300_Ag\u1EB9_O\u0300gu\u0301_Owe_\u1ECC\u0300wa\u0300_Be\u0301l_\u1ECC\u0300p\u1EB9\u0300\u0300".split("_"),
    weekdays: "A\u0300i\u0300ku\u0301_Aje\u0301_I\u0300s\u1EB9\u0301gun_\u1ECCj\u1ECD\u0301ru\u0301_\u1ECCj\u1ECD\u0301b\u1ECD_\u1EB8ti\u0300_A\u0300ba\u0301m\u1EB9\u0301ta".split("_"),
    weekdaysShort: "A\u0300i\u0300k_Aje\u0301_I\u0300s\u1EB9\u0301_\u1ECCjr_\u1ECCjb_\u1EB8ti\u0300_A\u0300ba\u0301".split("_"),
    weekdaysMin: "A\u0300i\u0300_Aj_I\u0300s_\u1ECCr_\u1ECCb_\u1EB8t_A\u0300b".split("_"),
    longDateFormat: {
      LT: "h:mm A",
      LTS: "h:mm:ss A",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY h:mm A",
      LLLL: "dddd, D MMMM YYYY h:mm A"
    },
    calendar: {
      sameDay: "[O\u0300ni\u0300 ni] LT",
      nextDay: "[\u1ECC\u0300la ni] LT",
      nextWeek: "dddd [\u1ECCs\u1EB9\u0300 to\u0301n'b\u1ECD] [ni] LT",
      lastDay: "[A\u0300na ni] LT",
      lastWeek: "dddd [\u1ECCs\u1EB9\u0300 to\u0301l\u1ECD\u0301] [ni] LT",
      sameElse: "L"
    },
    relativeTime: {
      future: "ni\u0301 %s",
      past: "%s k\u1ECDja\u0301",
      s: "i\u0300s\u1EB9ju\u0301 aaya\u0301 die",
      ss: "aaya\u0301 %d",
      m: "i\u0300s\u1EB9ju\u0301 kan",
      mm: "i\u0300s\u1EB9ju\u0301 %d",
      h: "wa\u0301kati kan",
      hh: "wa\u0301kati %d",
      d: "\u1ECDj\u1ECD\u0301 kan",
      dd: "\u1ECDj\u1ECD\u0301 %d",
      M: "osu\u0300 kan",
      MM: "osu\u0300 %d",
      y: "\u1ECDdu\u0301n kan",
      yy: "\u1ECDdu\u0301n %d"
    },
    dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
    ordinal: "\u1ECDj\u1ECD\u0301 %d",
    week: {
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return yo;
}));


/***/ }),

/***/ 10074:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var zhCn = moment.defineLocale("zh-cn", {
    months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split(
      "_"
    ),
    monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
      "_"
    ),
    weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split("_"),
    weekdaysShort: "\u5468\u65E5_\u5468\u4E00_\u5468\u4E8C_\u5468\u4E09_\u5468\u56DB_\u5468\u4E94_\u5468\u516D".split("_"),
    weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY/MM/DD",
      LL: "YYYY\u5E74M\u6708D\u65E5",
      LLL: "YYYY\u5E74M\u6708D\u65E5Ah\u70B9mm\u5206",
      LLLL: "YYYY\u5E74M\u6708D\u65E5ddddAh\u70B9mm\u5206",
      l: "YYYY/M/D",
      ll: "YYYY\u5E74M\u6708D\u65E5",
      lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
      llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") {
        return hour;
      } else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") {
        return hour + 12;
      } else {
        return hour >= 11 ? hour : hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      var hm = hour * 100 + minute;
      if (hm < 600) {
        return "\u51CC\u6668";
      } else if (hm < 900) {
        return "\u65E9\u4E0A";
      } else if (hm < 1130) {
        return "\u4E0A\u5348";
      } else if (hm < 1230) {
        return "\u4E2D\u5348";
      } else if (hm < 1800) {
        return "\u4E0B\u5348";
      } else {
        return "\u665A\u4E0A";
      }
    },
    calendar: {
      sameDay: "[\u4ECA\u5929]LT",
      nextDay: "[\u660E\u5929]LT",
      nextWeek: function(now) {
        if (now.week() !== this.week()) {
          return "[\u4E0B]dddLT";
        } else {
          return "[\u672C]dddLT";
        }
      },
      lastDay: "[\u6628\u5929]LT",
      lastWeek: function(now) {
        if (this.week() !== now.week()) {
          return "[\u4E0A]dddLT";
        } else {
          return "[\u672C]dddLT";
        }
      },
      sameElse: "L"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
    ordinal: function(number, period) {
      switch (period) {
        case "d":
        case "D":
        case "DDD":
          return number + "\u65E5";
        case "M":
          return number + "\u6708";
        case "w":
        case "W":
          return number + "\u5468";
        default:
          return number;
      }
    },
    relativeTime: {
      future: "%s\u540E",
      past: "%s\u524D",
      s: "\u51E0\u79D2",
      ss: "%d \u79D2",
      m: "1 \u5206\u949F",
      mm: "%d \u5206\u949F",
      h: "1 \u5C0F\u65F6",
      hh: "%d \u5C0F\u65F6",
      d: "1 \u5929",
      dd: "%d \u5929",
      w: "1 \u5468",
      ww: "%d \u5468",
      M: "1 \u4E2A\u6708",
      MM: "%d \u4E2A\u6708",
      y: "1 \u5E74",
      yy: "%d \u5E74"
    },
    week: {
      // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
      dow: 1,
      // Monday is the first day of the week.
      doy: 4
      // The week that contains Jan 4th is the first week of the year.
    }
  });
  return zhCn;
}));


/***/ }),

/***/ 99094:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var zhHk = moment.defineLocale("zh-hk", {
    months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split(
      "_"
    ),
    monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
      "_"
    ),
    weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split("_"),
    weekdaysShort: "\u9031\u65E5_\u9031\u4E00_\u9031\u4E8C_\u9031\u4E09_\u9031\u56DB_\u9031\u4E94_\u9031\u516D".split("_"),
    weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY/MM/DD",
      LL: "YYYY\u5E74M\u6708D\u65E5",
      LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
      LLLL: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm",
      l: "YYYY/M/D",
      ll: "YYYY\u5E74M\u6708D\u65E5",
      lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
      llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") {
        return hour;
      } else if (meridiem === "\u4E2D\u5348") {
        return hour >= 11 ? hour : hour + 12;
      } else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      var hm = hour * 100 + minute;
      if (hm < 600) {
        return "\u51CC\u6668";
      } else if (hm < 900) {
        return "\u65E9\u4E0A";
      } else if (hm < 1200) {
        return "\u4E0A\u5348";
      } else if (hm === 1200) {
        return "\u4E2D\u5348";
      } else if (hm < 1800) {
        return "\u4E0B\u5348";
      } else {
        return "\u665A\u4E0A";
      }
    },
    calendar: {
      sameDay: "[\u4ECA\u5929]LT",
      nextDay: "[\u660E\u5929]LT",
      nextWeek: "[\u4E0B]ddddLT",
      lastDay: "[\u6628\u5929]LT",
      lastWeek: "[\u4E0A]ddddLT",
      sameElse: "L"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal: function(number, period) {
      switch (period) {
        case "d":
        case "D":
        case "DDD":
          return number + "\u65E5";
        case "M":
          return number + "\u6708";
        case "w":
        case "W":
          return number + "\u9031";
        default:
          return number;
      }
    },
    relativeTime: {
      future: "%s\u5F8C",
      past: "%s\u524D",
      s: "\u5E7E\u79D2",
      ss: "%d \u79D2",
      m: "1 \u5206\u9418",
      mm: "%d \u5206\u9418",
      h: "1 \u5C0F\u6642",
      hh: "%d \u5C0F\u6642",
      d: "1 \u5929",
      dd: "%d \u5929",
      M: "1 \u500B\u6708",
      MM: "%d \u500B\u6708",
      y: "1 \u5E74",
      yy: "%d \u5E74"
    }
  });
  return zhHk;
}));


/***/ }),

/***/ 13323:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var zhMo = moment.defineLocale("zh-mo", {
    months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split(
      "_"
    ),
    monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
      "_"
    ),
    weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split("_"),
    weekdaysShort: "\u9031\u65E5_\u9031\u4E00_\u9031\u4E8C_\u9031\u4E09_\u9031\u56DB_\u9031\u4E94_\u9031\u516D".split("_"),
    weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "YYYY\u5E74M\u6708D\u65E5",
      LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
      LLLL: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm",
      l: "D/M/YYYY",
      ll: "YYYY\u5E74M\u6708D\u65E5",
      lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
      llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") {
        return hour;
      } else if (meridiem === "\u4E2D\u5348") {
        return hour >= 11 ? hour : hour + 12;
      } else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      var hm = hour * 100 + minute;
      if (hm < 600) {
        return "\u51CC\u6668";
      } else if (hm < 900) {
        return "\u65E9\u4E0A";
      } else if (hm < 1130) {
        return "\u4E0A\u5348";
      } else if (hm < 1230) {
        return "\u4E2D\u5348";
      } else if (hm < 1800) {
        return "\u4E0B\u5348";
      } else {
        return "\u665A\u4E0A";
      }
    },
    calendar: {
      sameDay: "[\u4ECA\u5929] LT",
      nextDay: "[\u660E\u5929] LT",
      nextWeek: "[\u4E0B]dddd LT",
      lastDay: "[\u6628\u5929] LT",
      lastWeek: "[\u4E0A]dddd LT",
      sameElse: "L"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal: function(number, period) {
      switch (period) {
        case "d":
        case "D":
        case "DDD":
          return number + "\u65E5";
        case "M":
          return number + "\u6708";
        case "w":
        case "W":
          return number + "\u9031";
        default:
          return number;
      }
    },
    relativeTime: {
      future: "%s\u5167",
      past: "%s\u524D",
      s: "\u5E7E\u79D2",
      ss: "%d \u79D2",
      m: "1 \u5206\u9418",
      mm: "%d \u5206\u9418",
      h: "1 \u5C0F\u6642",
      hh: "%d \u5C0F\u6642",
      d: "1 \u5929",
      dd: "%d \u5929",
      M: "1 \u500B\u6708",
      MM: "%d \u500B\u6708",
      y: "1 \u5E74",
      yy: "%d \u5E74"
    }
  });
  return zhMo;
}));


/***/ }),

/***/ 24542:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
;
(function(global, factory) {
   true ? factory(__webpack_require__(37631)) : 0;
})(this, (function(moment) {
  "use strict";
  //! moment.js locale configuration
  var zhTw = moment.defineLocale("zh-tw", {
    months: "\u4E00\u6708_\u4E8C\u6708_\u4E09\u6708_\u56DB\u6708_\u4E94\u6708_\u516D\u6708_\u4E03\u6708_\u516B\u6708_\u4E5D\u6708_\u5341\u6708_\u5341\u4E00\u6708_\u5341\u4E8C\u6708".split(
      "_"
    ),
    monthsShort: "1\u6708_2\u6708_3\u6708_4\u6708_5\u6708_6\u6708_7\u6708_8\u6708_9\u6708_10\u6708_11\u6708_12\u6708".split(
      "_"
    ),
    weekdays: "\u661F\u671F\u65E5_\u661F\u671F\u4E00_\u661F\u671F\u4E8C_\u661F\u671F\u4E09_\u661F\u671F\u56DB_\u661F\u671F\u4E94_\u661F\u671F\u516D".split("_"),
    weekdaysShort: "\u9031\u65E5_\u9031\u4E00_\u9031\u4E8C_\u9031\u4E09_\u9031\u56DB_\u9031\u4E94_\u9031\u516D".split("_"),
    weekdaysMin: "\u65E5_\u4E00_\u4E8C_\u4E09_\u56DB_\u4E94_\u516D".split("_"),
    longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "YYYY/MM/DD",
      LL: "YYYY\u5E74M\u6708D\u65E5",
      LLL: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
      LLLL: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm",
      l: "YYYY/M/D",
      ll: "YYYY\u5E74M\u6708D\u65E5",
      lll: "YYYY\u5E74M\u6708D\u65E5 HH:mm",
      llll: "YYYY\u5E74M\u6708D\u65E5dddd HH:mm"
    },
    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
    meridiemHour: function(hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === "\u51CC\u6668" || meridiem === "\u65E9\u4E0A" || meridiem === "\u4E0A\u5348") {
        return hour;
      } else if (meridiem === "\u4E2D\u5348") {
        return hour >= 11 ? hour : hour + 12;
      } else if (meridiem === "\u4E0B\u5348" || meridiem === "\u665A\u4E0A") {
        return hour + 12;
      }
    },
    meridiem: function(hour, minute, isLower) {
      var hm = hour * 100 + minute;
      if (hm < 600) {
        return "\u51CC\u6668";
      } else if (hm < 900) {
        return "\u65E9\u4E0A";
      } else if (hm < 1130) {
        return "\u4E0A\u5348";
      } else if (hm < 1230) {
        return "\u4E2D\u5348";
      } else if (hm < 1800) {
        return "\u4E0B\u5348";
      } else {
        return "\u665A\u4E0A";
      }
    },
    calendar: {
      sameDay: "[\u4ECA\u5929] LT",
      nextDay: "[\u660E\u5929] LT",
      nextWeek: "[\u4E0B]dddd LT",
      lastDay: "[\u6628\u5929] LT",
      lastWeek: "[\u4E0A]dddd LT",
      sameElse: "L"
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal: function(number, period) {
      switch (period) {
        case "d":
        case "D":
        case "DDD":
          return number + "\u65E5";
        case "M":
          return number + "\u6708";
        case "w":
        case "W":
          return number + "\u9031";
        default:
          return number;
      }
    },
    relativeTime: {
      future: "%s\u5F8C",
      past: "%s\u524D",
      s: "\u5E7E\u79D2",
      ss: "%d \u79D2",
      m: "1 \u5206\u9418",
      mm: "%d \u5206\u9418",
      h: "1 \u5C0F\u6642",
      hh: "%d \u5C0F\u6642",
      d: "1 \u5929",
      dd: "%d \u5929",
      M: "1 \u500B\u6708",
      MM: "%d \u500B\u6708",
      y: "1 \u5E74",
      yy: "%d \u5E74"
    }
  });
  return zhTw;
}));


/***/ }),

/***/ 37631:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
;
(function(global, factory) {
   true ? module.exports = factory() : 0;
})(this, (function() {
  "use strict";
  var hookCallback;
  function hooks() {
    return hookCallback.apply(null, arguments);
  }
  function setHookCallback(callback) {
    hookCallback = callback;
  }
  function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
  }
  function isObject(input) {
    return input != null && Object.prototype.toString.call(input) === "[object Object]";
  }
  function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  }
  function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
      return Object.getOwnPropertyNames(obj).length === 0;
    } else {
      var k;
      for (k in obj) {
        if (hasOwnProp(obj, k)) {
          return false;
        }
      }
      return true;
    }
  }
  function isUndefined(input) {
    return input === void 0;
  }
  function isNumber(input) {
    return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
  }
  function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
  }
  function map(arr, fn) {
    var res = [], i, arrLen = arr.length;
    for (i = 0; i < arrLen; ++i) {
      res.push(fn(arr[i], i));
    }
    return res;
  }
  function extend(a, b) {
    for (var i in b) {
      if (hasOwnProp(b, i)) {
        a[i] = b[i];
      }
    }
    if (hasOwnProp(b, "toString")) {
      a.toString = b.toString;
    }
    if (hasOwnProp(b, "valueOf")) {
      a.valueOf = b.valueOf;
    }
    return a;
  }
  function createUTC(input, format2, locale2, strict) {
    return createLocalOrUTC(input, format2, locale2, strict, true).utc();
  }
  function defaultParsingFlags() {
    return {
      empty: false,
      unusedTokens: [],
      unusedInput: [],
      overflow: -2,
      charsLeftOver: 0,
      nullInput: false,
      invalidEra: null,
      invalidMonth: null,
      invalidFormat: false,
      userInvalidated: false,
      iso: false,
      parsedDateParts: [],
      era: null,
      meridiem: null,
      rfc2822: false,
      weekdayMismatch: false
    };
  }
  function getParsingFlags(m) {
    if (m._pf == null) {
      m._pf = defaultParsingFlags();
    }
    return m._pf;
  }
  var some;
  if (Array.prototype.some) {
    some = Array.prototype.some;
  } else {
    some = function(fun) {
      var t = Object(this), len = t.length >>> 0, i;
      for (i = 0; i < len; i++) {
        if (i in t && fun.call(this, t[i], i, t)) {
          return true;
        }
      }
      return false;
    };
  }
  function isValid(m) {
    var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
    if (isNowValid) {
      flags = getParsingFlags(m);
      parsedParts = some.call(flags.parsedDateParts, function(i) {
        return i != null;
      });
      isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
      if (m._strict) {
        isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === void 0;
      }
    }
    if (Object.isFrozen == null || !Object.isFrozen(m)) {
      m._isValid = isNowValid;
    } else {
      return isNowValid;
    }
    return m._isValid;
  }
  function createInvalid(flags) {
    var m = createUTC(NaN);
    if (flags != null) {
      extend(getParsingFlags(m), flags);
    } else {
      getParsingFlags(m).userInvalidated = true;
    }
    return m;
  }
  var momentProperties = hooks.momentProperties = [], updateInProgress = false;
  function copyConfig(to2, from2) {
    var i, prop, val, momentPropertiesLen = momentProperties.length;
    if (!isUndefined(from2._isAMomentObject)) {
      to2._isAMomentObject = from2._isAMomentObject;
    }
    if (!isUndefined(from2._i)) {
      to2._i = from2._i;
    }
    if (!isUndefined(from2._f)) {
      to2._f = from2._f;
    }
    if (!isUndefined(from2._l)) {
      to2._l = from2._l;
    }
    if (!isUndefined(from2._strict)) {
      to2._strict = from2._strict;
    }
    if (!isUndefined(from2._tzm)) {
      to2._tzm = from2._tzm;
    }
    if (!isUndefined(from2._isUTC)) {
      to2._isUTC = from2._isUTC;
    }
    if (!isUndefined(from2._offset)) {
      to2._offset = from2._offset;
    }
    if (!isUndefined(from2._pf)) {
      to2._pf = getParsingFlags(from2);
    }
    if (!isUndefined(from2._locale)) {
      to2._locale = from2._locale;
    }
    if (momentPropertiesLen > 0) {
      for (i = 0; i < momentPropertiesLen; i++) {
        prop = momentProperties[i];
        val = from2[prop];
        if (!isUndefined(val)) {
          to2[prop] = val;
        }
      }
    }
    return to2;
  }
  function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
      this._d = /* @__PURE__ */ new Date(NaN);
    }
    if (updateInProgress === false) {
      updateInProgress = true;
      hooks.updateOffset(this);
      updateInProgress = false;
    }
  }
  function isMoment(obj) {
    return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
  }
  function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) {
      console.warn("Deprecation warning: " + msg);
    }
  }
  function deprecate(msg, fn) {
    var firstTime = true;
    return extend(function() {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(null, msg);
      }
      if (firstTime) {
        var args = [], arg, i, key, argLen = arguments.length;
        for (i = 0; i < argLen; i++) {
          arg = "";
          if (typeof arguments[i] === "object") {
            arg += "\n[" + i + "] ";
            for (key in arguments[0]) {
              if (hasOwnProp(arguments[0], key)) {
                arg += key + ": " + arguments[0][key] + ", ";
              }
            }
            arg = arg.slice(0, -2);
          } else {
            arg = arguments[i];
          }
          args.push(arg);
        }
        warn(
          msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack
        );
        firstTime = false;
      }
      return fn.apply(this, arguments);
    }, fn);
  }
  var deprecations = {};
  function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
      warn(msg);
      deprecations[name] = true;
    }
  }
  hooks.suppressDeprecationWarnings = false;
  hooks.deprecationHandler = null;
  function isFunction(input) {
    return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
  }
  function set(config) {
    var prop, i;
    for (i in config) {
      if (hasOwnProp(config, i)) {
        prop = config[i];
        if (isFunction(prop)) {
          this[i] = prop;
        } else {
          this["_" + i] = prop;
        }
      }
    }
    this._config = config;
    this._dayOfMonthOrdinalParseLenient = new RegExp(
      (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
    );
  }
  function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
      if (hasOwnProp(childConfig, prop)) {
        if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
          res[prop] = {};
          extend(res[prop], parentConfig[prop]);
          extend(res[prop], childConfig[prop]);
        } else if (childConfig[prop] != null) {
          res[prop] = childConfig[prop];
        } else {
          delete res[prop];
        }
      }
    }
    for (prop in parentConfig) {
      if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
        res[prop] = extend({}, res[prop]);
      }
    }
    return res;
  }
  function Locale(config) {
    if (config != null) {
      this.set(config);
    }
  }
  var keys;
  if (Object.keys) {
    keys = Object.keys;
  } else {
    keys = function(obj) {
      var i, res = [];
      for (i in obj) {
        if (hasOwnProp(obj, i)) {
          res.push(i);
        }
      }
      return res;
    };
  }
  var defaultCalendar = {
    sameDay: "[Today at] LT",
    nextDay: "[Tomorrow at] LT",
    nextWeek: "dddd [at] LT",
    lastDay: "[Yesterday at] LT",
    lastWeek: "[Last] dddd [at] LT",
    sameElse: "L"
  };
  function calendar(key, mom, now2) {
    var output = this._calendar[key] || this._calendar["sameElse"];
    return isFunction(output) ? output.call(mom, now2) : output;
  }
  function zeroFill(number, targetLength, forceSign) {
    var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign2 = number >= 0;
    return (sign2 ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
  }
  var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
  function addFormatToken(token2, padded, ordinal2, callback) {
    var func = callback;
    if (typeof callback === "string") {
      func = function() {
        return this[callback]();
      };
    }
    if (token2) {
      formatTokenFunctions[token2] = func;
    }
    if (padded) {
      formatTokenFunctions[padded[0]] = function() {
        return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
      };
    }
    if (ordinal2) {
      formatTokenFunctions[ordinal2] = function() {
        return this.localeData().ordinal(
          func.apply(this, arguments),
          token2
        );
      };
    }
  }
  function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
      return input.replace(/^\[|\]$/g, "");
    }
    return input.replace(/\\/g, "");
  }
  function makeFormatFunction(format2) {
    var array = format2.match(formattingTokens), i, length;
    for (i = 0, length = array.length; i < length; i++) {
      if (formatTokenFunctions[array[i]]) {
        array[i] = formatTokenFunctions[array[i]];
      } else {
        array[i] = removeFormattingTokens(array[i]);
      }
    }
    return function(mom) {
      var output = "", i2;
      for (i2 = 0; i2 < length; i2++) {
        output += isFunction(array[i2]) ? array[i2].call(mom, format2) : array[i2];
      }
      return output;
    };
  }
  function formatMoment(m, format2) {
    if (!m.isValid()) {
      return m.localeData().invalidDate();
    }
    format2 = expandFormat(format2, m.localeData());
    formatFunctions[format2] = formatFunctions[format2] || makeFormatFunction(format2);
    return formatFunctions[format2](m);
  }
  function expandFormat(format2, locale2) {
    var i = 5;
    function replaceLongDateFormatTokens(input) {
      return locale2.longDateFormat(input) || input;
    }
    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format2)) {
      format2 = format2.replace(
        localFormattingTokens,
        replaceLongDateFormatTokens
      );
      localFormattingTokens.lastIndex = 0;
      i -= 1;
    }
    return format2;
  }
  var defaultLongDateFormat = {
    LTS: "h:mm:ss A",
    LT: "h:mm A",
    L: "MM/DD/YYYY",
    LL: "MMMM D, YYYY",
    LLL: "MMMM D, YYYY h:mm A",
    LLLL: "dddd, MMMM D, YYYY h:mm A"
  };
  function longDateFormat(key) {
    var format2 = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
    if (format2 || !formatUpper) {
      return format2;
    }
    this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
      if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") {
        return tok.slice(1);
      }
      return tok;
    }).join("");
    return this._longDateFormat[key];
  }
  var defaultInvalidDate = "Invalid date";
  function invalidDate() {
    return this._invalidDate;
  }
  var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
  function ordinal(number) {
    return this._ordinal.replace("%d", number);
  }
  var defaultRelativeTime = {
    future: "in %s",
    past: "%s ago",
    s: "a few seconds",
    ss: "%d seconds",
    m: "a minute",
    mm: "%d minutes",
    h: "an hour",
    hh: "%d hours",
    d: "a day",
    dd: "%d days",
    w: "a week",
    ww: "%d weeks",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
  };
  function relativeTime(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
  }
  function pastFuture(diff2, output) {
    var format2 = this._relativeTime[diff2 > 0 ? "future" : "past"];
    return isFunction(format2) ? format2(output) : format2.replace(/%s/i, output);
  }
  var aliases = {
    D: "date",
    dates: "date",
    date: "date",
    d: "day",
    days: "day",
    day: "day",
    e: "weekday",
    weekdays: "weekday",
    weekday: "weekday",
    E: "isoWeekday",
    isoweekdays: "isoWeekday",
    isoweekday: "isoWeekday",
    DDD: "dayOfYear",
    dayofyears: "dayOfYear",
    dayofyear: "dayOfYear",
    h: "hour",
    hours: "hour",
    hour: "hour",
    ms: "millisecond",
    milliseconds: "millisecond",
    millisecond: "millisecond",
    m: "minute",
    minutes: "minute",
    minute: "minute",
    M: "month",
    months: "month",
    month: "month",
    Q: "quarter",
    quarters: "quarter",
    quarter: "quarter",
    s: "second",
    seconds: "second",
    second: "second",
    gg: "weekYear",
    weekyears: "weekYear",
    weekyear: "weekYear",
    GG: "isoWeekYear",
    isoweekyears: "isoWeekYear",
    isoweekyear: "isoWeekYear",
    w: "week",
    weeks: "week",
    week: "week",
    W: "isoWeek",
    isoweeks: "isoWeek",
    isoweek: "isoWeek",
    y: "year",
    years: "year",
    year: "year"
  };
  function normalizeUnits(units) {
    return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : void 0;
  }
  function normalizeObjectUnits(inputObject) {
    var normalizedInput = {}, normalizedProp, prop;
    for (prop in inputObject) {
      if (hasOwnProp(inputObject, prop)) {
        normalizedProp = normalizeUnits(prop);
        if (normalizedProp) {
          normalizedInput[normalizedProp] = inputObject[prop];
        }
      }
    }
    return normalizedInput;
  }
  var priorities = {
    date: 9,
    day: 11,
    weekday: 11,
    isoWeekday: 11,
    dayOfYear: 4,
    hour: 13,
    millisecond: 16,
    minute: 14,
    month: 8,
    quarter: 7,
    second: 15,
    weekYear: 1,
    isoWeekYear: 1,
    week: 5,
    isoWeek: 5,
    year: 1
  };
  function getPrioritizedUnits(unitsObj) {
    var units = [], u;
    for (u in unitsObj) {
      if (hasOwnProp(unitsObj, u)) {
        units.push({ unit: u, priority: priorities[u] });
      }
    }
    units.sort(function(a, b) {
      return a.priority - b.priority;
    });
    return units;
  }
  var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
  regexes = {};
  function addRegexToken(token2, regex, strictRegex) {
    regexes[token2] = isFunction(regex) ? regex : function(isStrict, localeData2) {
      return isStrict && strictRegex ? strictRegex : regex;
    };
  }
  function getParseRegexForToken(token2, config) {
    if (!hasOwnProp(regexes, token2)) {
      return new RegExp(unescapeFormat(token2));
    }
    return regexes[token2](config._strict, config._locale);
  }
  function unescapeFormat(s) {
    return regexEscape(
      s.replace("\\", "").replace(
        /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
        function(matched, p1, p2, p3, p4) {
          return p1 || p2 || p3 || p4;
        }
      )
    );
  }
  function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  }
  function absFloor(number) {
    if (number < 0) {
      return Math.ceil(number) || 0;
    } else {
      return Math.floor(number);
    }
  }
  function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion, value = 0;
    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
      value = absFloor(coercedNumber);
    }
    return value;
  }
  var tokens = {};
  function addParseToken(token2, callback) {
    var i, func = callback, tokenLen;
    if (typeof token2 === "string") {
      token2 = [token2];
    }
    if (isNumber(callback)) {
      func = function(input, array) {
        array[callback] = toInt(input);
      };
    }
    tokenLen = token2.length;
    for (i = 0; i < tokenLen; i++) {
      tokens[token2[i]] = func;
    }
  }
  function addWeekParseToken(token2, callback) {
    addParseToken(token2, function(input, array, config, token3) {
      config._w = config._w || {};
      callback(input, config._w, config, token3);
    });
  }
  function addTimeToArrayFromToken(token2, input, config) {
    if (input != null && hasOwnProp(tokens, token2)) {
      tokens[token2](input, config._a, config, token2);
    }
  }
  function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
  }
  var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
  addFormatToken("Y", 0, 0, function() {
    var y = this.year();
    return y <= 9999 ? zeroFill(y, 4) : "+" + y;
  });
  addFormatToken(0, ["YY", 2], 0, function() {
    return this.year() % 100;
  });
  addFormatToken(0, ["YYYY", 4], 0, "year");
  addFormatToken(0, ["YYYYY", 5], 0, "year");
  addFormatToken(0, ["YYYYYY", 6, true], 0, "year");
  addRegexToken("Y", matchSigned);
  addRegexToken("YY", match1to2, match2);
  addRegexToken("YYYY", match1to4, match4);
  addRegexToken("YYYYY", match1to6, match6);
  addRegexToken("YYYYYY", match1to6, match6);
  addParseToken(["YYYYY", "YYYYYY"], YEAR);
  addParseToken("YYYY", function(input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
  });
  addParseToken("YY", function(input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
  });
  addParseToken("Y", function(input, array) {
    array[YEAR] = parseInt(input, 10);
  });
  function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
  }
  hooks.parseTwoDigitYear = function(input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2e3);
  };
  var getSetYear = makeGetSet("FullYear", true);
  function getIsLeapYear() {
    return isLeapYear(this.year());
  }
  function makeGetSet(unit, keepTime) {
    return function(value) {
      if (value != null) {
        set$1(this, unit, value);
        hooks.updateOffset(this, keepTime);
        return this;
      } else {
        return get(this, unit);
      }
    };
  }
  function get(mom, unit) {
    if (!mom.isValid()) {
      return NaN;
    }
    var d = mom._d, isUTC = mom._isUTC;
    switch (unit) {
      case "Milliseconds":
        return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
      case "Seconds":
        return isUTC ? d.getUTCSeconds() : d.getSeconds();
      case "Minutes":
        return isUTC ? d.getUTCMinutes() : d.getMinutes();
      case "Hours":
        return isUTC ? d.getUTCHours() : d.getHours();
      case "Date":
        return isUTC ? d.getUTCDate() : d.getDate();
      case "Day":
        return isUTC ? d.getUTCDay() : d.getDay();
      case "Month":
        return isUTC ? d.getUTCMonth() : d.getMonth();
      case "FullYear":
        return isUTC ? d.getUTCFullYear() : d.getFullYear();
      default:
        return NaN;
    }
  }
  function set$1(mom, unit, value) {
    var d, isUTC, year, month, date;
    if (!mom.isValid() || isNaN(value)) {
      return;
    }
    d = mom._d;
    isUTC = mom._isUTC;
    switch (unit) {
      case "Milliseconds":
        return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
      case "Seconds":
        return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
      case "Minutes":
        return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
      case "Hours":
        return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
      case "Date":
        return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case "FullYear":
        break;
      // See below ...
      default:
        return;
    }
    year = value;
    month = mom.month();
    date = mom.date();
    date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
    void (isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date));
  }
  function stringGet(units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
      return this[units]();
    }
    return this;
  }
  function stringSet(units, value) {
    if (typeof units === "object") {
      units = normalizeObjectUnits(units);
      var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
      for (i = 0; i < prioritizedLen; i++) {
        this[prioritized[i].unit](units[prioritized[i].unit]);
      }
    } else {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units](value);
      }
    }
    return this;
  }
  function mod(n, x) {
    return (n % x + x) % x;
  }
  var indexOf;
  if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
  } else {
    indexOf = function(o) {
      var i;
      for (i = 0; i < this.length; ++i) {
        if (this[i] === o) {
          return i;
        }
      }
      return -1;
    };
  }
  function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
      return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
  }
  addFormatToken("M", ["MM", 2], "Mo", function() {
    return this.month() + 1;
  });
  addFormatToken("MMM", 0, 0, function(format2) {
    return this.localeData().monthsShort(this, format2);
  });
  addFormatToken("MMMM", 0, 0, function(format2) {
    return this.localeData().months(this, format2);
  });
  addRegexToken("M", match1to2, match1to2NoLeadingZero);
  addRegexToken("MM", match1to2, match2);
  addRegexToken("MMM", function(isStrict, locale2) {
    return locale2.monthsShortRegex(isStrict);
  });
  addRegexToken("MMMM", function(isStrict, locale2) {
    return locale2.monthsRegex(isStrict);
  });
  addParseToken(["M", "MM"], function(input, array) {
    array[MONTH] = toInt(input) - 1;
  });
  addParseToken(["MMM", "MMMM"], function(input, array, config, token2) {
    var month = config._locale.monthsParse(input, token2, config._strict);
    if (month != null) {
      array[MONTH] = month;
    } else {
      getParsingFlags(config).invalidMonth = input;
    }
  });
  var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split(
    "_"
  ), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
  function localeMonths(m, format2) {
    if (!m) {
      return isArray(this._months) ? this._months : this._months["standalone"];
    }
    return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format2) ? "format" : "standalone"][m.month()];
  }
  function localeMonthsShort(m, format2) {
    if (!m) {
      return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format2) ? "format" : "standalone"][m.month()];
  }
  function handleStrictParse(monthName, format2, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
      for (i = 0; i < 12; ++i) {
        mom = createUTC([2e3, i]);
        this._shortMonthsParse[i] = this.monthsShort(
          mom,
          ""
        ).toLocaleLowerCase();
        this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
      }
    }
    if (strict) {
      if (format2 === "MMM") {
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format2 === "MMM") {
        ii = indexOf.call(this._shortMonthsParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }
  function localeMonthsParse(monthName, format2, strict) {
    var i, mom, regex;
    if (this._monthsParseExact) {
      return handleStrictParse.call(this, monthName, format2, strict);
    }
    if (!this._monthsParse) {
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
    }
    for (i = 0; i < 12; i++) {
      mom = createUTC([2e3, i]);
      if (strict && !this._longMonthsParse[i]) {
        this._longMonthsParse[i] = new RegExp(
          "^" + this.months(mom, "").replace(".", "") + "$",
          "i"
        );
        this._shortMonthsParse[i] = new RegExp(
          "^" + this.monthsShort(mom, "").replace(".", "") + "$",
          "i"
        );
      }
      if (!strict && !this._monthsParse[i]) {
        regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
        this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
      }
      if (strict && format2 === "MMMM" && this._longMonthsParse[i].test(monthName)) {
        return i;
      } else if (strict && format2 === "MMM" && this._shortMonthsParse[i].test(monthName)) {
        return i;
      } else if (!strict && this._monthsParse[i].test(monthName)) {
        return i;
      }
    }
  }
  function setMonth(mom, value) {
    if (!mom.isValid()) {
      return mom;
    }
    if (typeof value === "string") {
      if (/^\d+$/.test(value)) {
        value = toInt(value);
      } else {
        value = mom.localeData().monthsParse(value);
        if (!isNumber(value)) {
          return mom;
        }
      }
    }
    var month = value, date = mom.date();
    date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
    void (mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date));
    return mom;
  }
  function getSetMonth(value) {
    if (value != null) {
      setMonth(this, value);
      hooks.updateOffset(this, true);
      return this;
    } else {
      return get(this, "Month");
    }
  }
  function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
  }
  function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, "_monthsRegex")) {
        computeMonthsParse.call(this);
      }
      if (isStrict) {
        return this._monthsShortStrictRegex;
      } else {
        return this._monthsShortRegex;
      }
    } else {
      if (!hasOwnProp(this, "_monthsShortRegex")) {
        this._monthsShortRegex = defaultMonthsShortRegex;
      }
      return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
    }
  }
  function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, "_monthsRegex")) {
        computeMonthsParse.call(this);
      }
      if (isStrict) {
        return this._monthsStrictRegex;
      } else {
        return this._monthsRegex;
      }
    } else {
      if (!hasOwnProp(this, "_monthsRegex")) {
        this._monthsRegex = defaultMonthsRegex;
      }
      return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
    }
  }
  function computeMonthsParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }
    var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
    for (i = 0; i < 12; i++) {
      mom = createUTC([2e3, i]);
      shortP = regexEscape(this.monthsShort(mom, ""));
      longP = regexEscape(this.months(mom, ""));
      shortPieces.push(shortP);
      longPieces.push(longP);
      mixedPieces.push(longP);
      mixedPieces.push(shortP);
    }
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp(
      "^(" + longPieces.join("|") + ")",
      "i"
    );
    this._monthsShortStrictRegex = new RegExp(
      "^(" + shortPieces.join("|") + ")",
      "i"
    );
  }
  function createDate(y, m, d, h, M, s, ms) {
    var date;
    if (y < 100 && y >= 0) {
      date = new Date(y + 400, m, d, h, M, s, ms);
      if (isFinite(date.getFullYear())) {
        date.setFullYear(y);
      }
    } else {
      date = new Date(y, m, d, h, M, s, ms);
    }
    return date;
  }
  function createUTCDate(y) {
    var date, args;
    if (y < 100 && y >= 0) {
      args = Array.prototype.slice.call(arguments);
      args[0] = y + 400;
      date = new Date(Date.UTC.apply(null, args));
      if (isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
      }
    } else {
      date = new Date(Date.UTC.apply(null, arguments));
    }
    return date;
  }
  function firstWeekOffset(year, dow, doy) {
    var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
  }
  function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
    if (dayOfYear <= 0) {
      resYear = year - 1;
      resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
      resYear = year + 1;
      resDayOfYear = dayOfYear - daysInYear(year);
    } else {
      resYear = year;
      resDayOfYear = dayOfYear;
    }
    return {
      year: resYear,
      dayOfYear: resDayOfYear
    };
  }
  function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
    if (week < 1) {
      resYear = mom.year() - 1;
      resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
      resWeek = week - weeksInYear(mom.year(), dow, doy);
      resYear = mom.year() + 1;
    } else {
      resYear = mom.year();
      resWeek = week;
    }
    return {
      week: resWeek,
      year: resYear
    };
  }
  function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
  }
  addFormatToken("w", ["ww", 2], "wo", "week");
  addFormatToken("W", ["WW", 2], "Wo", "isoWeek");
  addRegexToken("w", match1to2, match1to2NoLeadingZero);
  addRegexToken("ww", match1to2, match2);
  addRegexToken("W", match1to2, match1to2NoLeadingZero);
  addRegexToken("WW", match1to2, match2);
  addWeekParseToken(
    ["w", "ww", "W", "WW"],
    function(input, week, config, token2) {
      week[token2.substr(0, 1)] = toInt(input);
    }
  );
  function localeWeek(mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
  }
  var defaultLocaleWeek = {
    dow: 0,
    // Sunday is the first day of the week.
    doy: 6
    // The week that contains Jan 6th is the first week of the year.
  };
  function localeFirstDayOfWeek() {
    return this._week.dow;
  }
  function localeFirstDayOfYear() {
    return this._week.doy;
  }
  function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, "d");
  }
  function getSetISOWeek(input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, "d");
  }
  addFormatToken("d", 0, "do", "day");
  addFormatToken("dd", 0, 0, function(format2) {
    return this.localeData().weekdaysMin(this, format2);
  });
  addFormatToken("ddd", 0, 0, function(format2) {
    return this.localeData().weekdaysShort(this, format2);
  });
  addFormatToken("dddd", 0, 0, function(format2) {
    return this.localeData().weekdays(this, format2);
  });
  addFormatToken("e", 0, 0, "weekday");
  addFormatToken("E", 0, 0, "isoWeekday");
  addRegexToken("d", match1to2);
  addRegexToken("e", match1to2);
  addRegexToken("E", match1to2);
  addRegexToken("dd", function(isStrict, locale2) {
    return locale2.weekdaysMinRegex(isStrict);
  });
  addRegexToken("ddd", function(isStrict, locale2) {
    return locale2.weekdaysShortRegex(isStrict);
  });
  addRegexToken("dddd", function(isStrict, locale2) {
    return locale2.weekdaysRegex(isStrict);
  });
  addWeekParseToken(["dd", "ddd", "dddd"], function(input, week, config, token2) {
    var weekday = config._locale.weekdaysParse(input, token2, config._strict);
    if (weekday != null) {
      week.d = weekday;
    } else {
      getParsingFlags(config).invalidWeekday = input;
    }
  });
  addWeekParseToken(["d", "e", "E"], function(input, week, config, token2) {
    week[token2] = toInt(input);
  });
  function parseWeekday(input, locale2) {
    if (typeof input !== "string") {
      return input;
    }
    if (!isNaN(input)) {
      return parseInt(input, 10);
    }
    input = locale2.weekdaysParse(input);
    if (typeof input === "number") {
      return input;
    }
    return null;
  }
  function parseIsoWeekday(input, locale2) {
    if (typeof input === "string") {
      return locale2.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
  }
  function shiftWeekdays(ws, n) {
    return ws.slice(n, 7).concat(ws.slice(0, n));
  }
  var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
  function localeWeekdays(m, format2) {
    var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format2) ? "format" : "standalone"];
    return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
  }
  function localeWeekdaysShort(m) {
    return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
  }
  function localeWeekdaysMin(m) {
    return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
  }
  function handleStrictParse$1(weekdayName, format2, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._minWeekdaysParse = [];
      for (i = 0; i < 7; ++i) {
        mom = createUTC([2e3, 1]).day(i);
        this._minWeekdaysParse[i] = this.weekdaysMin(
          mom,
          ""
        ).toLocaleLowerCase();
        this._shortWeekdaysParse[i] = this.weekdaysShort(
          mom,
          ""
        ).toLocaleLowerCase();
        this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
      }
    }
    if (strict) {
      if (format2 === "dddd") {
        ii = indexOf.call(this._weekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format2 === "ddd") {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format2 === "dddd") {
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format2 === "ddd") {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }
  function localeWeekdaysParse(weekdayName, format2, strict) {
    var i, mom, regex;
    if (this._weekdaysParseExact) {
      return handleStrictParse$1.call(this, weekdayName, format2, strict);
    }
    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._minWeekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._fullWeekdaysParse = [];
    }
    for (i = 0; i < 7; i++) {
      mom = createUTC([2e3, 1]).day(i);
      if (strict && !this._fullWeekdaysParse[i]) {
        this._fullWeekdaysParse[i] = new RegExp(
          "^" + this.weekdays(mom, "").replace(".", "\\.?") + "$",
          "i"
        );
        this._shortWeekdaysParse[i] = new RegExp(
          "^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$",
          "i"
        );
        this._minWeekdaysParse[i] = new RegExp(
          "^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$",
          "i"
        );
      }
      if (!this._weekdaysParse[i]) {
        regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
        this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
      }
      if (strict && format2 === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format2 === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format2 === "dd" && this._minWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
        return i;
      }
    }
  }
  function getSetDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    var day = get(this, "Day");
    if (input != null) {
      input = parseWeekday(input, this.localeData());
      return this.add(input - day, "d");
    } else {
      return day;
    }
  }
  function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, "d");
  }
  function getSetISODayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    if (input != null) {
      var weekday = parseIsoWeekday(input, this.localeData());
      return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
      return this.day() || 7;
    }
  }
  function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, "_weekdaysRegex")) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysStrictRegex;
      } else {
        return this._weekdaysRegex;
      }
    } else {
      if (!hasOwnProp(this, "_weekdaysRegex")) {
        this._weekdaysRegex = defaultWeekdaysRegex;
      }
      return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
    }
  }
  function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, "_weekdaysRegex")) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysShortStrictRegex;
      } else {
        return this._weekdaysShortRegex;
      }
    } else {
      if (!hasOwnProp(this, "_weekdaysShortRegex")) {
        this._weekdaysShortRegex = defaultWeekdaysShortRegex;
      }
      return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
  }
  function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, "_weekdaysRegex")) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysMinStrictRegex;
      } else {
        return this._weekdaysMinRegex;
      }
    } else {
      if (!hasOwnProp(this, "_weekdaysMinRegex")) {
        this._weekdaysMinRegex = defaultWeekdaysMinRegex;
      }
      return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
  }
  function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }
    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
      mom = createUTC([2e3, 1]).day(i);
      minp = regexEscape(this.weekdaysMin(mom, ""));
      shortp = regexEscape(this.weekdaysShort(mom, ""));
      longp = regexEscape(this.weekdays(mom, ""));
      minPieces.push(minp);
      shortPieces.push(shortp);
      longPieces.push(longp);
      mixedPieces.push(minp);
      mixedPieces.push(shortp);
      mixedPieces.push(longp);
    }
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;
    this._weekdaysStrictRegex = new RegExp(
      "^(" + longPieces.join("|") + ")",
      "i"
    );
    this._weekdaysShortStrictRegex = new RegExp(
      "^(" + shortPieces.join("|") + ")",
      "i"
    );
    this._weekdaysMinStrictRegex = new RegExp(
      "^(" + minPieces.join("|") + ")",
      "i"
    );
  }
  function hFormat() {
    return this.hours() % 12 || 12;
  }
  function kFormat() {
    return this.hours() || 24;
  }
  addFormatToken("H", ["HH", 2], 0, "hour");
  addFormatToken("h", ["hh", 2], 0, hFormat);
  addFormatToken("k", ["kk", 2], 0, kFormat);
  addFormatToken("hmm", 0, 0, function() {
    return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
  });
  addFormatToken("hmmss", 0, 0, function() {
    return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });
  addFormatToken("Hmm", 0, 0, function() {
    return "" + this.hours() + zeroFill(this.minutes(), 2);
  });
  addFormatToken("Hmmss", 0, 0, function() {
    return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });
  function meridiem(token2, lowercase) {
    addFormatToken(token2, 0, 0, function() {
      return this.localeData().meridiem(
        this.hours(),
        this.minutes(),
        lowercase
      );
    });
  }
  meridiem("a", true);
  meridiem("A", false);
  function matchMeridiem(isStrict, locale2) {
    return locale2._meridiemParse;
  }
  addRegexToken("a", matchMeridiem);
  addRegexToken("A", matchMeridiem);
  addRegexToken("H", match1to2, match1to2HasZero);
  addRegexToken("h", match1to2, match1to2NoLeadingZero);
  addRegexToken("k", match1to2, match1to2NoLeadingZero);
  addRegexToken("HH", match1to2, match2);
  addRegexToken("hh", match1to2, match2);
  addRegexToken("kk", match1to2, match2);
  addRegexToken("hmm", match3to4);
  addRegexToken("hmmss", match5to6);
  addRegexToken("Hmm", match3to4);
  addRegexToken("Hmmss", match5to6);
  addParseToken(["H", "HH"], HOUR);
  addParseToken(["k", "kk"], function(input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
  });
  addParseToken(["a", "A"], function(input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
  });
  addParseToken(["h", "hh"], function(input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
  });
  addParseToken("hmm", function(input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken("hmmss", function(input, array, config) {
    var pos1 = input.length - 4, pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken("Hmm", function(input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
  });
  addParseToken("Hmmss", function(input, array, config) {
    var pos1 = input.length - 4, pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
  });
  function localeIsPM(input) {
    return (input + "").toLowerCase().charAt(0) === "p";
  }
  var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet("Hours", true);
  function localeMeridiem(hours2, minutes2, isLower) {
    if (hours2 > 11) {
      return isLower ? "pm" : "PM";
    } else {
      return isLower ? "am" : "AM";
    }
  }
  var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,
    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,
    week: defaultLocaleWeek,
    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,
    meridiemParse: defaultLocaleMeridiemParse
  };
  var locales = {}, localeFamilies = {}, globalLocale;
  function commonPrefix(arr1, arr2) {
    var i, minl = Math.min(arr1.length, arr2.length);
    for (i = 0; i < minl; i += 1) {
      if (arr1[i] !== arr2[i]) {
        return i;
      }
    }
    return minl;
  }
  function normalizeLocale(key) {
    return key ? key.toLowerCase().replace("_", "-") : key;
  }
  function chooseLocale(names) {
    var i = 0, j, next, locale2, split;
    while (i < names.length) {
      split = normalizeLocale(names[i]).split("-");
      j = split.length;
      next = normalizeLocale(names[i + 1]);
      next = next ? next.split("-") : null;
      while (j > 0) {
        locale2 = loadLocale(split.slice(0, j).join("-"));
        if (locale2) {
          return locale2;
        }
        if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
          break;
        }
        j--;
      }
      i++;
    }
    return globalLocale;
  }
  function isLocaleNameSane(name) {
    return !!(name && name.match("^[^/\\\\]*$"));
  }
  function loadLocale(name) {
    var oldLocale = null, aliasedRequire;
    if (locales[name] === void 0 && "object" !== "undefined" && module && module.exports && isLocaleNameSane(name)) {
      try {
        oldLocale = globalLocale._abbr;
        aliasedRequire = undefined;
        __webpack_require__(35358)("./" + name);
        getSetGlobalLocale(oldLocale);
      } catch (e) {
        locales[name] = null;
      }
    }
    return locales[name];
  }
  function getSetGlobalLocale(key, values) {
    var data;
    if (key) {
      if (isUndefined(values)) {
        data = getLocale(key);
      } else {
        data = defineLocale(key, values);
      }
      if (data) {
        globalLocale = data;
      } else {
        if (typeof console !== "undefined" && console.warn) {
          console.warn(
            "Locale " + key + " not found. Did you forget to load it?"
          );
        }
      }
    }
    return globalLocale._abbr;
  }
  function defineLocale(name, config) {
    if (config !== null) {
      var locale2, parentConfig = baseConfig;
      config.abbr = name;
      if (locales[name] != null) {
        deprecateSimple(
          "defineLocaleOverride",
          "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
        );
        parentConfig = locales[name]._config;
      } else if (config.parentLocale != null) {
        if (locales[config.parentLocale] != null) {
          parentConfig = locales[config.parentLocale]._config;
        } else {
          locale2 = loadLocale(config.parentLocale);
          if (locale2 != null) {
            parentConfig = locale2._config;
          } else {
            if (!localeFamilies[config.parentLocale]) {
              localeFamilies[config.parentLocale] = [];
            }
            localeFamilies[config.parentLocale].push({
              name,
              config
            });
            return null;
          }
        }
      }
      locales[name] = new Locale(mergeConfigs(parentConfig, config));
      if (localeFamilies[name]) {
        localeFamilies[name].forEach(function(x) {
          defineLocale(x.name, x.config);
        });
      }
      getSetGlobalLocale(name);
      return locales[name];
    } else {
      delete locales[name];
      return null;
    }
  }
  function updateLocale(name, config) {
    if (config != null) {
      var locale2, tmpLocale, parentConfig = baseConfig;
      if (locales[name] != null && locales[name].parentLocale != null) {
        locales[name].set(mergeConfigs(locales[name]._config, config));
      } else {
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
          parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        if (tmpLocale == null) {
          config.abbr = name;
        }
        locale2 = new Locale(config);
        locale2.parentLocale = locales[name];
        locales[name] = locale2;
      }
      getSetGlobalLocale(name);
    } else {
      if (locales[name] != null) {
        if (locales[name].parentLocale != null) {
          locales[name] = locales[name].parentLocale;
          if (name === getSetGlobalLocale()) {
            getSetGlobalLocale(name);
          }
        } else if (locales[name] != null) {
          delete locales[name];
        }
      }
    }
    return locales[name];
  }
  function getLocale(key) {
    var locale2;
    if (key && key._locale && key._locale._abbr) {
      key = key._locale._abbr;
    }
    if (!key) {
      return globalLocale;
    }
    if (!isArray(key)) {
      locale2 = loadLocale(key);
      if (locale2) {
        return locale2;
      }
      key = [key];
    }
    return chooseLocale(key);
  }
  function listLocales() {
    return keys(locales);
  }
  function checkOverflow(m) {
    var overflow, a = m._a;
    if (a && getParsingFlags(m).overflow === -2) {
      overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
      if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
        overflow = DATE;
      }
      if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
        overflow = WEEK;
      }
      if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
        overflow = WEEKDAY;
      }
      getParsingFlags(m).overflow = overflow;
    }
    return m;
  }
  var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
    ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
    ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
    ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
    ["GGGG-[W]WW", /\d{4}-W\d\d/, false],
    ["YYYY-DDD", /\d{4}-\d{3}/],
    ["YYYY-MM", /\d{4}-\d\d/, false],
    ["YYYYYYMMDD", /[+-]\d{10}/],
    ["YYYYMMDD", /\d{8}/],
    ["GGGG[W]WWE", /\d{4}W\d{3}/],
    ["GGGG[W]WW", /\d{4}W\d{2}/, false],
    ["YYYYDDD", /\d{7}/],
    ["YYYYMM", /\d{6}/, false],
    ["YYYY", /\d{4}/, false]
  ], isoTimes = [
    ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
    ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
    ["HH:mm:ss", /\d\d:\d\d:\d\d/],
    ["HH:mm", /\d\d:\d\d/],
    ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
    ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
    ["HHmmss", /\d\d\d\d\d\d/],
    ["HHmm", /\d\d\d\d/],
    ["HH", /\d\d/]
  ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
  };
  function configFromISO(config) {
    var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
    if (match) {
      getParsingFlags(config).iso = true;
      for (i = 0, l = isoDatesLen; i < l; i++) {
        if (isoDates[i][1].exec(match[1])) {
          dateFormat = isoDates[i][0];
          allowTime = isoDates[i][2] !== false;
          break;
        }
      }
      if (dateFormat == null) {
        config._isValid = false;
        return;
      }
      if (match[3]) {
        for (i = 0, l = isoTimesLen; i < l; i++) {
          if (isoTimes[i][1].exec(match[3])) {
            timeFormat = (match[2] || " ") + isoTimes[i][0];
            break;
          }
        }
        if (timeFormat == null) {
          config._isValid = false;
          return;
        }
      }
      if (!allowTime && timeFormat != null) {
        config._isValid = false;
        return;
      }
      if (match[4]) {
        if (tzRegex.exec(match[4])) {
          tzFormat = "Z";
        } else {
          config._isValid = false;
          return;
        }
      }
      config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
      configFromStringAndFormat(config);
    } else {
      config._isValid = false;
    }
  }
  function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
      untruncateYear(yearStr),
      defaultLocaleMonthsShort.indexOf(monthStr),
      parseInt(dayStr, 10),
      parseInt(hourStr, 10),
      parseInt(minuteStr, 10)
    ];
    if (secondStr) {
      result.push(parseInt(secondStr, 10));
    }
    return result;
  }
  function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
      return 2e3 + year;
    } else if (year <= 999) {
      return 1900 + year;
    }
    return year;
  }
  function preprocessRFC2822(s) {
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
  }
  function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
      var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(
        parsedInput[0],
        parsedInput[1],
        parsedInput[2]
      ).getDay();
      if (weekdayProvided !== weekdayActual) {
        getParsingFlags(config).weekdayMismatch = true;
        config._isValid = false;
        return false;
      }
    }
    return true;
  }
  function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
      return obsOffsets[obsOffset];
    } else if (militaryOffset) {
      return 0;
    } else {
      var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
      return h * 60 + m;
    }
  }
  function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
    if (match) {
      parsedArray = extractFromRFC2822Strings(
        match[4],
        match[3],
        match[2],
        match[5],
        match[6],
        match[7]
      );
      if (!checkWeekday(match[1], parsedArray, config)) {
        return;
      }
      config._a = parsedArray;
      config._tzm = calculateOffset(match[8], match[9], match[10]);
      config._d = createUTCDate.apply(null, config._a);
      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      getParsingFlags(config).rfc2822 = true;
    } else {
      config._isValid = false;
    }
  }
  function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);
    if (matched !== null) {
      config._d = /* @__PURE__ */ new Date(+matched[1]);
      return;
    }
    configFromISO(config);
    if (config._isValid === false) {
      delete config._isValid;
    } else {
      return;
    }
    configFromRFC2822(config);
    if (config._isValid === false) {
      delete config._isValid;
    } else {
      return;
    }
    if (config._strict) {
      config._isValid = false;
    } else {
      hooks.createFromInputFallback(config);
    }
  }
  hooks.createFromInputFallback = deprecate(
    "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
    function(config) {
      config._d = /* @__PURE__ */ new Date(config._i + (config._useUTC ? " UTC" : ""));
    }
  );
  function defaults(a, b, c) {
    if (a != null) {
      return a;
    }
    if (b != null) {
      return b;
    }
    return c;
  }
  function currentDateArray(config) {
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
      return [
        nowValue.getUTCFullYear(),
        nowValue.getUTCMonth(),
        nowValue.getUTCDate()
      ];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
  }
  function configFromArray(config) {
    var i, date, input = [], currentDate, expectedWeekday, yearToUse;
    if (config._d) {
      return;
    }
    currentDate = currentDateArray(config);
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
      dayOfYearFromWeekInfo(config);
    }
    if (config._dayOfYear != null) {
      yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
      if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
        getParsingFlags(config)._overflowDayOfYear = true;
      }
      date = createUTCDate(yearToUse, 0, config._dayOfYear);
      config._a[MONTH] = date.getUTCMonth();
      config._a[DATE] = date.getUTCDate();
    }
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
      config._a[i] = input[i] = currentDate[i];
    }
    for (; i < 7; i++) {
      config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
    }
    if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
      config._nextDay = true;
      config._a[HOUR] = 0;
    }
    config._d = (config._useUTC ? createUTCDate : createDate).apply(
      null,
      input
    );
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
    if (config._tzm != null) {
      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }
    if (config._nextDay) {
      config._a[HOUR] = 24;
    }
    if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) {
      getParsingFlags(config).weekdayMismatch = true;
    }
  }
  function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
      dow = 1;
      doy = 4;
      weekYear = defaults(
        w.GG,
        config._a[YEAR],
        weekOfYear(createLocal(), 1, 4).year
      );
      week = defaults(w.W, 1);
      weekday = defaults(w.E, 1);
      if (weekday < 1 || weekday > 7) {
        weekdayOverflow = true;
      }
    } else {
      dow = config._locale._week.dow;
      doy = config._locale._week.doy;
      curWeek = weekOfYear(createLocal(), dow, doy);
      weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
      week = defaults(w.w, curWeek.week);
      if (w.d != null) {
        weekday = w.d;
        if (weekday < 0 || weekday > 6) {
          weekdayOverflow = true;
        }
      } else if (w.e != null) {
        weekday = w.e + dow;
        if (w.e < 0 || w.e > 6) {
          weekdayOverflow = true;
        }
      } else {
        weekday = dow;
      }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
      getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
      getParsingFlags(config)._overflowWeekday = true;
    } else {
      temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
      config._a[YEAR] = temp.year;
      config._dayOfYear = temp.dayOfYear;
    }
  }
  hooks.ISO_8601 = function() {
  };
  hooks.RFC_2822 = function() {
  };
  function configFromStringAndFormat(config) {
    if (config._f === hooks.ISO_8601) {
      configFromISO(config);
      return;
    }
    if (config._f === hooks.RFC_2822) {
      configFromRFC2822(config);
      return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;
    var string = "" + config._i, i, parsedInput, tokens2, token2, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
    tokens2 = expandFormat(config._f, config._locale).match(formattingTokens) || [];
    tokenLen = tokens2.length;
    for (i = 0; i < tokenLen; i++) {
      token2 = tokens2[i];
      parsedInput = (string.match(getParseRegexForToken(token2, config)) || [])[0];
      if (parsedInput) {
        skipped = string.substr(0, string.indexOf(parsedInput));
        if (skipped.length > 0) {
          getParsingFlags(config).unusedInput.push(skipped);
        }
        string = string.slice(
          string.indexOf(parsedInput) + parsedInput.length
        );
        totalParsedInputLength += parsedInput.length;
      }
      if (formatTokenFunctions[token2]) {
        if (parsedInput) {
          getParsingFlags(config).empty = false;
        } else {
          getParsingFlags(config).unusedTokens.push(token2);
        }
        addTimeToArrayFromToken(token2, parsedInput, config);
      } else if (config._strict && !parsedInput) {
        getParsingFlags(config).unusedTokens.push(token2);
      }
    }
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
      getParsingFlags(config).unusedInput.push(string);
    }
    if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
      getParsingFlags(config).bigHour = void 0;
    }
    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    config._a[HOUR] = meridiemFixWrap(
      config._locale,
      config._a[HOUR],
      config._meridiem
    );
    era = getParsingFlags(config).era;
    if (era !== null) {
      config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
    }
    configFromArray(config);
    checkOverflow(config);
  }
  function meridiemFixWrap(locale2, hour, meridiem2) {
    var isPm;
    if (meridiem2 == null) {
      return hour;
    }
    if (locale2.meridiemHour != null) {
      return locale2.meridiemHour(hour, meridiem2);
    } else if (locale2.isPM != null) {
      isPm = locale2.isPM(meridiem2);
      if (isPm && hour < 12) {
        hour += 12;
      }
      if (!isPm && hour === 12) {
        hour = 0;
      }
      return hour;
    } else {
      return hour;
    }
  }
  function configFromStringAndArray(config) {
    var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
    if (configfLen === 0) {
      getParsingFlags(config).invalidFormat = true;
      config._d = /* @__PURE__ */ new Date(NaN);
      return;
    }
    for (i = 0; i < configfLen; i++) {
      currentScore = 0;
      validFormatFound = false;
      tempConfig = copyConfig({}, config);
      if (config._useUTC != null) {
        tempConfig._useUTC = config._useUTC;
      }
      tempConfig._f = config._f[i];
      configFromStringAndFormat(tempConfig);
      if (isValid(tempConfig)) {
        validFormatFound = true;
      }
      currentScore += getParsingFlags(tempConfig).charsLeftOver;
      currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
      getParsingFlags(tempConfig).score = currentScore;
      if (!bestFormatIsValid) {
        if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;
          if (validFormatFound) {
            bestFormatIsValid = true;
          }
        }
      } else {
        if (currentScore < scoreToBeat) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;
        }
      }
    }
    extend(config, bestMoment || tempConfig);
  }
  function configFromObject(config) {
    if (config._d) {
      return;
    }
    var i = normalizeObjectUnits(config._i), dayOrDate = i.day === void 0 ? i.date : i.day;
    config._a = map(
      [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
      function(obj) {
        return obj && parseInt(obj, 10);
      }
    );
    configFromArray(config);
  }
  function createFromConfig(config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
      res.add(1, "d");
      res._nextDay = void 0;
    }
    return res;
  }
  function prepareConfig(config) {
    var input = config._i, format2 = config._f;
    config._locale = config._locale || getLocale(config._l);
    if (input === null || format2 === void 0 && input === "") {
      return createInvalid({ nullInput: true });
    }
    if (typeof input === "string") {
      config._i = input = config._locale.preparse(input);
    }
    if (isMoment(input)) {
      return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
      config._d = input;
    } else if (isArray(format2)) {
      configFromStringAndArray(config);
    } else if (format2) {
      configFromStringAndFormat(config);
    } else {
      configFromInput(config);
    }
    if (!isValid(config)) {
      config._d = null;
    }
    return config;
  }
  function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
      config._d = new Date(hooks.now());
    } else if (isDate(input)) {
      config._d = new Date(input.valueOf());
    } else if (typeof input === "string") {
      configFromString(config);
    } else if (isArray(input)) {
      config._a = map(input.slice(0), function(obj) {
        return parseInt(obj, 10);
      });
      configFromArray(config);
    } else if (isObject(input)) {
      configFromObject(config);
    } else if (isNumber(input)) {
      config._d = new Date(input);
    } else {
      hooks.createFromInputFallback(config);
    }
  }
  function createLocalOrUTC(input, format2, locale2, strict, isUTC) {
    var c = {};
    if (format2 === true || format2 === false) {
      strict = format2;
      format2 = void 0;
    }
    if (locale2 === true || locale2 === false) {
      strict = locale2;
      locale2 = void 0;
    }
    if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
      input = void 0;
    }
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale2;
    c._i = input;
    c._f = format2;
    c._strict = strict;
    return createFromConfig(c);
  }
  function createLocal(input, format2, locale2, strict) {
    return createLocalOrUTC(input, format2, locale2, strict, false);
  }
  var prototypeMin = deprecate(
    "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
    function() {
      var other = createLocal.apply(null, arguments);
      if (this.isValid() && other.isValid()) {
        return other < this ? this : other;
      } else {
        return createInvalid();
      }
    }
  ), prototypeMax = deprecate(
    "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
    function() {
      var other = createLocal.apply(null, arguments);
      if (this.isValid() && other.isValid()) {
        return other > this ? this : other;
      } else {
        return createInvalid();
      }
    }
  );
  function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
      moments = moments[0];
    }
    if (!moments.length) {
      return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
      if (!moments[i].isValid() || moments[i][fn](res)) {
        res = moments[i];
      }
    }
    return res;
  }
  function min() {
    var args = [].slice.call(arguments, 0);
    return pickBy("isBefore", args);
  }
  function max() {
    var args = [].slice.call(arguments, 0);
    return pickBy("isAfter", args);
  }
  var now = function() {
    return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
  };
  var ordering = [
    "year",
    "quarter",
    "month",
    "week",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
  ];
  function isDurationValid(m) {
    var key, unitHasDecimal = false, i, orderLen = ordering.length;
    for (key in m) {
      if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
        return false;
      }
    }
    for (i = 0; i < orderLen; ++i) {
      if (m[ordering[i]]) {
        if (unitHasDecimal) {
          return false;
        }
        if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
          unitHasDecimal = true;
        }
      }
    }
    return true;
  }
  function isValid$1() {
    return this._isValid;
  }
  function createInvalid$1() {
    return createDuration(NaN);
  }
  function Duration(duration) {
    var normalizedInput = normalizeObjectUnits(duration), years2 = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months2 = normalizedInput.month || 0, weeks2 = normalizedInput.week || normalizedInput.isoWeek || 0, days2 = normalizedInput.day || 0, hours2 = normalizedInput.hour || 0, minutes2 = normalizedInput.minute || 0, seconds2 = normalizedInput.second || 0, milliseconds2 = normalizedInput.millisecond || 0;
    this._isValid = isDurationValid(normalizedInput);
    this._milliseconds = +milliseconds2 + seconds2 * 1e3 + // 1000
    minutes2 * 6e4 + // 1000 * 60
    hours2 * 1e3 * 60 * 60;
    this._days = +days2 + weeks2 * 7;
    this._months = +months2 + quarters * 3 + years2 * 12;
    this._data = {};
    this._locale = getLocale();
    this._bubble();
  }
  function isDuration(obj) {
    return obj instanceof Duration;
  }
  function absRound(number) {
    if (number < 0) {
      return Math.round(-1 * number) * -1;
    } else {
      return Math.round(number);
    }
  }
  function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
    for (i = 0; i < len; i++) {
      if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
        diffs++;
      }
    }
    return diffs + lengthDiff;
  }
  function offset(token2, separator) {
    addFormatToken(token2, 0, 0, function() {
      var offset2 = this.utcOffset(), sign2 = "+";
      if (offset2 < 0) {
        offset2 = -offset2;
        sign2 = "-";
      }
      return sign2 + zeroFill(~~(offset2 / 60), 2) + separator + zeroFill(~~offset2 % 60, 2);
    });
  }
  offset("Z", ":");
  offset("ZZ", "");
  addRegexToken("Z", matchShortOffset);
  addRegexToken("ZZ", matchShortOffset);
  addParseToken(["Z", "ZZ"], function(input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
  });
  var chunkOffset = /([\+\-]|\d\d)/gi;
  function offsetFromString(matcher, string) {
    var matches = (string || "").match(matcher), chunk, parts, minutes2;
    if (matches === null) {
      return null;
    }
    chunk = matches[matches.length - 1] || [];
    parts = (chunk + "").match(chunkOffset) || ["-", 0, 0];
    minutes2 = +(parts[1] * 60) + toInt(parts[2]);
    return minutes2 === 0 ? 0 : parts[0] === "+" ? minutes2 : -minutes2;
  }
  function cloneWithOffset(input, model) {
    var res, diff2;
    if (model._isUTC) {
      res = model.clone();
      diff2 = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
      res._d.setTime(res._d.valueOf() + diff2);
      hooks.updateOffset(res, false);
      return res;
    } else {
      return createLocal(input).local();
    }
  }
  function getDateOffset(m) {
    return -Math.round(m._d.getTimezoneOffset());
  }
  hooks.updateOffset = function() {
  };
  function getSetOffset(input, keepLocalTime, keepMinutes) {
    var offset2 = this._offset || 0, localAdjust;
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    if (input != null) {
      if (typeof input === "string") {
        input = offsetFromString(matchShortOffset, input);
        if (input === null) {
          return this;
        }
      } else if (Math.abs(input) < 16 && !keepMinutes) {
        input = input * 60;
      }
      if (!this._isUTC && keepLocalTime) {
        localAdjust = getDateOffset(this);
      }
      this._offset = input;
      this._isUTC = true;
      if (localAdjust != null) {
        this.add(localAdjust, "m");
      }
      if (offset2 !== input) {
        if (!keepLocalTime || this._changeInProgress) {
          addSubtract(
            this,
            createDuration(input - offset2, "m"),
            1,
            false
          );
        } else if (!this._changeInProgress) {
          this._changeInProgress = true;
          hooks.updateOffset(this, true);
          this._changeInProgress = null;
        }
      }
      return this;
    } else {
      return this._isUTC ? offset2 : getDateOffset(this);
    }
  }
  function getSetZone(input, keepLocalTime) {
    if (input != null) {
      if (typeof input !== "string") {
        input = -input;
      }
      this.utcOffset(input, keepLocalTime);
      return this;
    } else {
      return -this.utcOffset();
    }
  }
  function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
  }
  function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
      this.utcOffset(0, keepLocalTime);
      this._isUTC = false;
      if (keepLocalTime) {
        this.subtract(getDateOffset(this), "m");
      }
    }
    return this;
  }
  function setOffsetToParsedOffset() {
    if (this._tzm != null) {
      this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === "string") {
      var tZone = offsetFromString(matchOffset, this._i);
      if (tZone != null) {
        this.utcOffset(tZone);
      } else {
        this.utcOffset(0, true);
      }
    }
    return this;
  }
  function hasAlignedHourOffset(input) {
    if (!this.isValid()) {
      return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;
    return (this.utcOffset() - input) % 60 === 0;
  }
  function isDaylightSavingTime() {
    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
  }
  function isDaylightSavingTimeShifted() {
    if (!isUndefined(this._isDSTShifted)) {
      return this._isDSTShifted;
    }
    var c = {}, other;
    copyConfig(c, this);
    c = prepareConfig(c);
    if (c._a) {
      other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
      this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
    } else {
      this._isDSTShifted = false;
    }
    return this._isDSTShifted;
  }
  function isLocal() {
    return this.isValid() ? !this._isUTC : false;
  }
  function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
  }
  function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
  }
  var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
  function createDuration(input, key) {
    var duration = input, match = null, sign2, ret, diffRes;
    if (isDuration(input)) {
      duration = {
        ms: input._milliseconds,
        d: input._days,
        M: input._months
      };
    } else if (isNumber(input) || !isNaN(+input)) {
      duration = {};
      if (key) {
        duration[key] = +input;
      } else {
        duration.milliseconds = +input;
      }
    } else if (match = aspNetRegex.exec(input)) {
      sign2 = match[1] === "-" ? -1 : 1;
      duration = {
        y: 0,
        d: toInt(match[DATE]) * sign2,
        h: toInt(match[HOUR]) * sign2,
        m: toInt(match[MINUTE]) * sign2,
        s: toInt(match[SECOND]) * sign2,
        ms: toInt(absRound(match[MILLISECOND] * 1e3)) * sign2
        // the millisecond decimal point is included in the match
      };
    } else if (match = isoRegex.exec(input)) {
      sign2 = match[1] === "-" ? -1 : 1;
      duration = {
        y: parseIso(match[2], sign2),
        M: parseIso(match[3], sign2),
        w: parseIso(match[4], sign2),
        d: parseIso(match[5], sign2),
        h: parseIso(match[6], sign2),
        m: parseIso(match[7], sign2),
        s: parseIso(match[8], sign2)
      };
    } else if (duration == null) {
      duration = {};
    } else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
      diffRes = momentsDifference(
        createLocal(duration.from),
        createLocal(duration.to)
      );
      duration = {};
      duration.ms = diffRes.milliseconds;
      duration.M = diffRes.months;
    }
    ret = new Duration(duration);
    if (isDuration(input) && hasOwnProp(input, "_locale")) {
      ret._locale = input._locale;
    }
    if (isDuration(input) && hasOwnProp(input, "_isValid")) {
      ret._isValid = input._isValid;
    }
    return ret;
  }
  createDuration.fn = Duration.prototype;
  createDuration.invalid = createInvalid$1;
  function parseIso(inp, sign2) {
    var res = inp && parseFloat(inp.replace(",", "."));
    return (isNaN(res) ? 0 : res) * sign2;
  }
  function positiveMomentsDifference(base, other) {
    var res = {};
    res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, "M").isAfter(other)) {
      --res.months;
    }
    res.milliseconds = +other - +base.clone().add(res.months, "M");
    return res;
  }
  function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
      return { milliseconds: 0, months: 0 };
    }
    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
      res = positiveMomentsDifference(base, other);
    } else {
      res = positiveMomentsDifference(other, base);
      res.milliseconds = -res.milliseconds;
      res.months = -res.months;
    }
    return res;
  }
  function createAdder(direction, name) {
    return function(val, period) {
      var dur, tmp;
      if (period !== null && !isNaN(+period)) {
        deprecateSimple(
          name,
          "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
        );
        tmp = val;
        val = period;
        period = tmp;
      }
      dur = createDuration(val, period);
      addSubtract(this, dur, direction);
      return this;
    };
  }
  function addSubtract(mom, duration, isAdding, updateOffset) {
    var milliseconds2 = duration._milliseconds, days2 = absRound(duration._days), months2 = absRound(duration._months);
    if (!mom.isValid()) {
      return;
    }
    updateOffset = updateOffset == null ? true : updateOffset;
    if (months2) {
      setMonth(mom, get(mom, "Month") + months2 * isAdding);
    }
    if (days2) {
      set$1(mom, "Date", get(mom, "Date") + days2 * isAdding);
    }
    if (milliseconds2) {
      mom._d.setTime(mom._d.valueOf() + milliseconds2 * isAdding);
    }
    if (updateOffset) {
      hooks.updateOffset(mom, days2 || months2);
    }
  }
  var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
  function isString(input) {
    return typeof input === "string" || input instanceof String;
  }
  function isMomentInput(input) {
    return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === void 0;
  }
  function isMomentInputObject(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
      "years",
      "year",
      "y",
      "months",
      "month",
      "M",
      "days",
      "day",
      "d",
      "dates",
      "date",
      "D",
      "hours",
      "hour",
      "h",
      "minutes",
      "minute",
      "m",
      "seconds",
      "second",
      "s",
      "milliseconds",
      "millisecond",
      "ms"
    ], i, property, propertyLen = properties.length;
    for (i = 0; i < propertyLen; i += 1) {
      property = properties[i];
      propertyTest = propertyTest || hasOwnProp(input, property);
    }
    return objectTest && propertyTest;
  }
  function isNumberOrStringArray(input) {
    var arrayTest = isArray(input), dataTypeTest = false;
    if (arrayTest) {
      dataTypeTest = input.filter(function(item) {
        return !isNumber(item) && isString(input);
      }).length === 0;
    }
    return arrayTest && dataTypeTest;
  }
  function isCalendarSpec(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
      "sameDay",
      "nextDay",
      "lastDay",
      "nextWeek",
      "lastWeek",
      "sameElse"
    ], i, property;
    for (i = 0; i < properties.length; i += 1) {
      property = properties[i];
      propertyTest = propertyTest || hasOwnProp(input, property);
    }
    return objectTest && propertyTest;
  }
  function getCalendarFormat(myMoment, now2) {
    var diff2 = myMoment.diff(now2, "days", true);
    return diff2 < -6 ? "sameElse" : diff2 < -1 ? "lastWeek" : diff2 < 0 ? "lastDay" : diff2 < 1 ? "sameDay" : diff2 < 2 ? "nextDay" : diff2 < 7 ? "nextWeek" : "sameElse";
  }
  function calendar$1(time, formats) {
    if (arguments.length === 1) {
      if (!arguments[0]) {
        time = void 0;
        formats = void 0;
      } else if (isMomentInput(arguments[0])) {
        time = arguments[0];
        formats = void 0;
      } else if (isCalendarSpec(arguments[0])) {
        formats = arguments[0];
        time = void 0;
      }
    }
    var now2 = time || createLocal(), sod = cloneWithOffset(now2, this).startOf("day"), format2 = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format2]) ? formats[format2].call(this, now2) : formats[format2]);
    return this.format(
      output || this.localeData().calendar(format2, this, createLocal(now2))
    );
  }
  function clone() {
    return new Moment(this);
  }
  function isAfter(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(units) || "millisecond";
    if (units === "millisecond") {
      return this.valueOf() > localInput.valueOf();
    } else {
      return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
  }
  function isBefore(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(units) || "millisecond";
    if (units === "millisecond") {
      return this.valueOf() < localInput.valueOf();
    } else {
      return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
  }
  function isBetween(from2, to2, units, inclusivity) {
    var localFrom = isMoment(from2) ? from2 : createLocal(from2), localTo = isMoment(to2) ? to2 : createLocal(to2);
    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
      return false;
    }
    inclusivity = inclusivity || "()";
    return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
  }
  function isSame(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input), inputMs;
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(units) || "millisecond";
    if (units === "millisecond") {
      return this.valueOf() === localInput.valueOf();
    } else {
      inputMs = localInput.valueOf();
      return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
  }
  function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
  }
  function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
  }
  function diff(input, units, asFloat) {
    var that, zoneDelta, output;
    if (!this.isValid()) {
      return NaN;
    }
    that = cloneWithOffset(input, this);
    if (!that.isValid()) {
      return NaN;
    }
    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
    units = normalizeUnits(units);
    switch (units) {
      case "year":
        output = monthDiff(this, that) / 12;
        break;
      case "month":
        output = monthDiff(this, that);
        break;
      case "quarter":
        output = monthDiff(this, that) / 3;
        break;
      case "second":
        output = (this - that) / 1e3;
        break;
      // 1000
      case "minute":
        output = (this - that) / 6e4;
        break;
      // 1000 * 60
      case "hour":
        output = (this - that) / 36e5;
        break;
      // 1000 * 60 * 60
      case "day":
        output = (this - that - zoneDelta) / 864e5;
        break;
      // 1000 * 60 * 60 * 24, negate dst
      case "week":
        output = (this - that - zoneDelta) / 6048e5;
        break;
      // 1000 * 60 * 60 * 24 * 7, negate dst
      default:
        output = this - that;
    }
    return asFloat ? output : absFloor(output);
  }
  function monthDiff(a, b) {
    if (a.date() < b.date()) {
      return -monthDiff(b, a);
    }
    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
    if (b - anchor < 0) {
      anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
      adjust = (b - anchor) / (anchor - anchor2);
    } else {
      anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
      adjust = (b - anchor) / (anchor2 - anchor);
    }
    return -(wholeMonthDiff + adjust) || 0;
  }
  hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
  hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
  function toString() {
    return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
  }
  function toISOString(keepOffset) {
    if (!this.isValid()) {
      return null;
    }
    var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
      return formatMoment(
        m,
        utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
      );
    }
    if (isFunction(Date.prototype.toISOString)) {
      if (utc) {
        return this.toDate().toISOString();
      } else {
        return new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", formatMoment(m, "Z"));
      }
    }
    return formatMoment(
      m,
      utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
    );
  }
  function inspect() {
    if (!this.isValid()) {
      return "moment.invalid(/* " + this._i + " */)";
    }
    var func = "moment", zone = "", prefix, year, datetime, suffix;
    if (!this.isLocal()) {
      func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
      zone = "Z";
    }
    prefix = "[" + func + '("]';
    year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
    datetime = "-MM-DD[T]HH:mm:ss.SSS";
    suffix = zone + '[")]';
    return this.format(prefix + year + datetime + suffix);
  }
  function format(inputString) {
    if (!inputString) {
      inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
  }
  function from(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
      return createDuration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }
  function fromNow(withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
  }
  function to(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
      return createDuration({ from: this, to: time }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }
  function toNow(withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
  }
  function locale(key) {
    var newLocaleData;
    if (key === void 0) {
      return this._locale._abbr;
    } else {
      newLocaleData = getLocale(key);
      if (newLocaleData != null) {
        this._locale = newLocaleData;
      }
      return this;
    }
  }
  var lang = deprecate(
    "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
    function(key) {
      if (key === void 0) {
        return this.localeData();
      } else {
        return this.locale(key);
      }
    }
  );
  function localeData() {
    return this._locale;
  }
  var MS_PER_SECOND = 1e3, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
  function mod$1(dividend, divisor) {
    return (dividend % divisor + divisor) % divisor;
  }
  function localStartOfDate(y, m, d) {
    if (y < 100 && y >= 0) {
      return new Date(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
      return new Date(y, m, d).valueOf();
    }
  }
  function utcStartOfDate(y, m, d) {
    if (y < 100 && y >= 0) {
      return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
      return Date.UTC(y, m, d);
    }
  }
  function startOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);
    if (units === void 0 || units === "millisecond" || !this.isValid()) {
      return this;
    }
    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
    switch (units) {
      case "year":
        time = startOfDate(this.year(), 0, 1);
        break;
      case "quarter":
        time = startOfDate(
          this.year(),
          this.month() - this.month() % 3,
          1
        );
        break;
      case "month":
        time = startOfDate(this.year(), this.month(), 1);
        break;
      case "week":
        time = startOfDate(
          this.year(),
          this.month(),
          this.date() - this.weekday()
        );
        break;
      case "isoWeek":
        time = startOfDate(
          this.year(),
          this.month(),
          this.date() - (this.isoWeekday() - 1)
        );
        break;
      case "day":
      case "date":
        time = startOfDate(this.year(), this.month(), this.date());
        break;
      case "hour":
        time = this._d.valueOf();
        time -= mod$1(
          time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
          MS_PER_HOUR
        );
        break;
      case "minute":
        time = this._d.valueOf();
        time -= mod$1(time, MS_PER_MINUTE);
        break;
      case "second":
        time = this._d.valueOf();
        time -= mod$1(time, MS_PER_SECOND);
        break;
    }
    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
  }
  function endOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);
    if (units === void 0 || units === "millisecond" || !this.isValid()) {
      return this;
    }
    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
    switch (units) {
      case "year":
        time = startOfDate(this.year() + 1, 0, 1) - 1;
        break;
      case "quarter":
        time = startOfDate(
          this.year(),
          this.month() - this.month() % 3 + 3,
          1
        ) - 1;
        break;
      case "month":
        time = startOfDate(this.year(), this.month() + 1, 1) - 1;
        break;
      case "week":
        time = startOfDate(
          this.year(),
          this.month(),
          this.date() - this.weekday() + 7
        ) - 1;
        break;
      case "isoWeek":
        time = startOfDate(
          this.year(),
          this.month(),
          this.date() - (this.isoWeekday() - 1) + 7
        ) - 1;
        break;
      case "day":
      case "date":
        time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
        break;
      case "hour":
        time = this._d.valueOf();
        time += MS_PER_HOUR - mod$1(
          time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
          MS_PER_HOUR
        ) - 1;
        break;
      case "minute":
        time = this._d.valueOf();
        time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
        break;
      case "second":
        time = this._d.valueOf();
        time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
        break;
    }
    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
  }
  function valueOf() {
    return this._d.valueOf() - (this._offset || 0) * 6e4;
  }
  function unix() {
    return Math.floor(this.valueOf() / 1e3);
  }
  function toDate() {
    return new Date(this.valueOf());
  }
  function toArray() {
    var m = this;
    return [
      m.year(),
      m.month(),
      m.date(),
      m.hour(),
      m.minute(),
      m.second(),
      m.millisecond()
    ];
  }
  function toObject() {
    var m = this;
    return {
      years: m.year(),
      months: m.month(),
      date: m.date(),
      hours: m.hours(),
      minutes: m.minutes(),
      seconds: m.seconds(),
      milliseconds: m.milliseconds()
    };
  }
  function toJSON() {
    return this.isValid() ? this.toISOString() : null;
  }
  function isValid$2() {
    return isValid(this);
  }
  function parsingFlags() {
    return extend({}, getParsingFlags(this));
  }
  function invalidAt() {
    return getParsingFlags(this).overflow;
  }
  function creationData() {
    return {
      input: this._i,
      format: this._f,
      locale: this._locale,
      isUTC: this._isUTC,
      strict: this._strict
    };
  }
  addFormatToken("N", 0, 0, "eraAbbr");
  addFormatToken("NN", 0, 0, "eraAbbr");
  addFormatToken("NNN", 0, 0, "eraAbbr");
  addFormatToken("NNNN", 0, 0, "eraName");
  addFormatToken("NNNNN", 0, 0, "eraNarrow");
  addFormatToken("y", ["y", 1], "yo", "eraYear");
  addFormatToken("y", ["yy", 2], 0, "eraYear");
  addFormatToken("y", ["yyy", 3], 0, "eraYear");
  addFormatToken("y", ["yyyy", 4], 0, "eraYear");
  addRegexToken("N", matchEraAbbr);
  addRegexToken("NN", matchEraAbbr);
  addRegexToken("NNN", matchEraAbbr);
  addRegexToken("NNNN", matchEraName);
  addRegexToken("NNNNN", matchEraNarrow);
  addParseToken(
    ["N", "NN", "NNN", "NNNN", "NNNNN"],
    function(input, array, config, token2) {
      var era = config._locale.erasParse(input, token2, config._strict);
      if (era) {
        getParsingFlags(config).era = era;
      } else {
        getParsingFlags(config).invalidEra = input;
      }
    }
  );
  addRegexToken("y", matchUnsigned);
  addRegexToken("yy", matchUnsigned);
  addRegexToken("yyy", matchUnsigned);
  addRegexToken("yyyy", matchUnsigned);
  addRegexToken("yo", matchEraYearOrdinal);
  addParseToken(["y", "yy", "yyy", "yyyy"], YEAR);
  addParseToken(["yo"], function(input, array, config, token2) {
    var match;
    if (config._locale._eraYearOrdinalRegex) {
      match = input.match(config._locale._eraYearOrdinalRegex);
    }
    if (config._locale.eraYearOrdinalParse) {
      array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
    } else {
      array[YEAR] = parseInt(input, 10);
    }
  });
  function localeEras(m, format2) {
    var i, l, date, eras = this._eras || getLocale("en")._eras;
    for (i = 0, l = eras.length; i < l; ++i) {
      switch (typeof eras[i].since) {
        case "string":
          date = hooks(eras[i].since).startOf("day");
          eras[i].since = date.valueOf();
          break;
      }
      switch (typeof eras[i].until) {
        case "undefined":
          eras[i].until = Infinity;
          break;
        case "string":
          date = hooks(eras[i].until).startOf("day").valueOf();
          eras[i].until = date.valueOf();
          break;
      }
    }
    return eras;
  }
  function localeErasParse(eraName, format2, strict) {
    var i, l, eras = this.eras(), name, abbr, narrow;
    eraName = eraName.toUpperCase();
    for (i = 0, l = eras.length; i < l; ++i) {
      name = eras[i].name.toUpperCase();
      abbr = eras[i].abbr.toUpperCase();
      narrow = eras[i].narrow.toUpperCase();
      if (strict) {
        switch (format2) {
          case "N":
          case "NN":
          case "NNN":
            if (abbr === eraName) {
              return eras[i];
            }
            break;
          case "NNNN":
            if (name === eraName) {
              return eras[i];
            }
            break;
          case "NNNNN":
            if (narrow === eraName) {
              return eras[i];
            }
            break;
        }
      } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
        return eras[i];
      }
    }
  }
  function localeErasConvertYear(era, year) {
    var dir = era.since <= era.until ? 1 : -1;
    if (year === void 0) {
      return hooks(era.since).year();
    } else {
      return hooks(era.since).year() + (year - era.offset) * dir;
    }
  }
  function getEraName() {
    var i, l, val, eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      val = this.clone().startOf("day").valueOf();
      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].name;
      }
      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].name;
      }
    }
    return "";
  }
  function getEraNarrow() {
    var i, l, val, eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      val = this.clone().startOf("day").valueOf();
      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].narrow;
      }
      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].narrow;
      }
    }
    return "";
  }
  function getEraAbbr() {
    var i, l, val, eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      val = this.clone().startOf("day").valueOf();
      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].abbr;
      }
      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].abbr;
      }
    }
    return "";
  }
  function getEraYear() {
    var i, l, dir, val, eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      dir = eras[i].since <= eras[i].until ? 1 : -1;
      val = this.clone().startOf("day").valueOf();
      if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
        return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
      }
    }
    return this.year();
  }
  function erasNameRegex(isStrict) {
    if (!hasOwnProp(this, "_erasNameRegex")) {
      computeErasParse.call(this);
    }
    return isStrict ? this._erasNameRegex : this._erasRegex;
  }
  function erasAbbrRegex(isStrict) {
    if (!hasOwnProp(this, "_erasAbbrRegex")) {
      computeErasParse.call(this);
    }
    return isStrict ? this._erasAbbrRegex : this._erasRegex;
  }
  function erasNarrowRegex(isStrict) {
    if (!hasOwnProp(this, "_erasNarrowRegex")) {
      computeErasParse.call(this);
    }
    return isStrict ? this._erasNarrowRegex : this._erasRegex;
  }
  function matchEraAbbr(isStrict, locale2) {
    return locale2.erasAbbrRegex(isStrict);
  }
  function matchEraName(isStrict, locale2) {
    return locale2.erasNameRegex(isStrict);
  }
  function matchEraNarrow(isStrict, locale2) {
    return locale2.erasNarrowRegex(isStrict);
  }
  function matchEraYearOrdinal(isStrict, locale2) {
    return locale2._eraYearOrdinalRegex || matchUnsigned;
  }
  function computeErasParse() {
    var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      erasName = regexEscape(eras[i].name);
      erasAbbr = regexEscape(eras[i].abbr);
      erasNarrow = regexEscape(eras[i].narrow);
      namePieces.push(erasName);
      abbrPieces.push(erasAbbr);
      narrowPieces.push(erasNarrow);
      mixedPieces.push(erasName);
      mixedPieces.push(erasAbbr);
      mixedPieces.push(erasNarrow);
    }
    this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
    this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
    this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
    this._erasNarrowRegex = new RegExp(
      "^(" + narrowPieces.join("|") + ")",
      "i"
    );
  }
  addFormatToken(0, ["gg", 2], 0, function() {
    return this.weekYear() % 100;
  });
  addFormatToken(0, ["GG", 2], 0, function() {
    return this.isoWeekYear() % 100;
  });
  function addWeekYearFormatToken(token2, getter) {
    addFormatToken(0, [token2, token2.length], 0, getter);
  }
  addWeekYearFormatToken("gggg", "weekYear");
  addWeekYearFormatToken("ggggg", "weekYear");
  addWeekYearFormatToken("GGGG", "isoWeekYear");
  addWeekYearFormatToken("GGGGG", "isoWeekYear");
  addRegexToken("G", matchSigned);
  addRegexToken("g", matchSigned);
  addRegexToken("GG", match1to2, match2);
  addRegexToken("gg", match1to2, match2);
  addRegexToken("GGGG", match1to4, match4);
  addRegexToken("gggg", match1to4, match4);
  addRegexToken("GGGGG", match1to6, match6);
  addRegexToken("ggggg", match1to6, match6);
  addWeekParseToken(
    ["gggg", "ggggg", "GGGG", "GGGGG"],
    function(input, week, config, token2) {
      week[token2.substr(0, 2)] = toInt(input);
    }
  );
  addWeekParseToken(["gg", "GG"], function(input, week, config, token2) {
    week[token2] = hooks.parseTwoDigitYear(input);
  });
  function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(
      this,
      input,
      this.week(),
      this.weekday() + this.localeData()._week.dow,
      this.localeData()._week.dow,
      this.localeData()._week.doy
    );
  }
  function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(
      this,
      input,
      this.isoWeek(),
      this.isoWeekday(),
      1,
      4
    );
  }
  function getISOWeeksInYear() {
    return weeksInYear(this.year(), 1, 4);
  }
  function getISOWeeksInISOWeekYear() {
    return weeksInYear(this.isoWeekYear(), 1, 4);
  }
  function getWeeksInYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
  }
  function getWeeksInWeekYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
  }
  function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
      return weekOfYear(this, dow, doy).year;
    } else {
      weeksTarget = weeksInYear(input, dow, doy);
      if (week > weeksTarget) {
        week = weeksTarget;
      }
      return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
  }
  function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
  }
  addFormatToken("Q", 0, "Qo", "quarter");
  addRegexToken("Q", match1);
  addParseToken("Q", function(input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
  });
  function getSetQuarter(input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
  }
  addFormatToken("D", ["DD", 2], "Do", "date");
  addRegexToken("D", match1to2, match1to2NoLeadingZero);
  addRegexToken("DD", match1to2, match2);
  addRegexToken("Do", function(isStrict, locale2) {
    return isStrict ? locale2._dayOfMonthOrdinalParse || locale2._ordinalParse : locale2._dayOfMonthOrdinalParseLenient;
  });
  addParseToken(["D", "DD"], DATE);
  addParseToken("Do", function(input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
  });
  var getSetDayOfMonth = makeGetSet("Date", true);
  addFormatToken("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
  addRegexToken("DDD", match1to3);
  addRegexToken("DDDD", match3);
  addParseToken(["DDD", "DDDD"], function(input, array, config) {
    config._dayOfYear = toInt(input);
  });
  function getSetDayOfYear(input) {
    var dayOfYear = Math.round(
      (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
    ) + 1;
    return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
  }
  addFormatToken("m", ["mm", 2], 0, "minute");
  addRegexToken("m", match1to2, match1to2HasZero);
  addRegexToken("mm", match1to2, match2);
  addParseToken(["m", "mm"], MINUTE);
  var getSetMinute = makeGetSet("Minutes", false);
  addFormatToken("s", ["ss", 2], 0, "second");
  addRegexToken("s", match1to2, match1to2HasZero);
  addRegexToken("ss", match1to2, match2);
  addParseToken(["s", "ss"], SECOND);
  var getSetSecond = makeGetSet("Seconds", false);
  addFormatToken("S", 0, 0, function() {
    return ~~(this.millisecond() / 100);
  });
  addFormatToken(0, ["SS", 2], 0, function() {
    return ~~(this.millisecond() / 10);
  });
  addFormatToken(0, ["SSS", 3], 0, "millisecond");
  addFormatToken(0, ["SSSS", 4], 0, function() {
    return this.millisecond() * 10;
  });
  addFormatToken(0, ["SSSSS", 5], 0, function() {
    return this.millisecond() * 100;
  });
  addFormatToken(0, ["SSSSSS", 6], 0, function() {
    return this.millisecond() * 1e3;
  });
  addFormatToken(0, ["SSSSSSS", 7], 0, function() {
    return this.millisecond() * 1e4;
  });
  addFormatToken(0, ["SSSSSSSS", 8], 0, function() {
    return this.millisecond() * 1e5;
  });
  addFormatToken(0, ["SSSSSSSSS", 9], 0, function() {
    return this.millisecond() * 1e6;
  });
  addRegexToken("S", match1to3, match1);
  addRegexToken("SS", match1to3, match2);
  addRegexToken("SSS", match1to3, match3);
  var token, getSetMillisecond;
  for (token = "SSSS"; token.length <= 9; token += "S") {
    addRegexToken(token, matchUnsigned);
  }
  function parseMs(input, array) {
    array[MILLISECOND] = toInt(("0." + input) * 1e3);
  }
  for (token = "S"; token.length <= 9; token += "S") {
    addParseToken(token, parseMs);
  }
  getSetMillisecond = makeGetSet("Milliseconds", false);
  addFormatToken("z", 0, 0, "zoneAbbr");
  addFormatToken("zz", 0, 0, "zoneName");
  function getZoneAbbr() {
    return this._isUTC ? "UTC" : "";
  }
  function getZoneName() {
    return this._isUTC ? "Coordinated Universal Time" : "";
  }
  var proto = Moment.prototype;
  proto.add = add;
  proto.calendar = calendar$1;
  proto.clone = clone;
  proto.diff = diff;
  proto.endOf = endOf;
  proto.format = format;
  proto.from = from;
  proto.fromNow = fromNow;
  proto.to = to;
  proto.toNow = toNow;
  proto.get = stringGet;
  proto.invalidAt = invalidAt;
  proto.isAfter = isAfter;
  proto.isBefore = isBefore;
  proto.isBetween = isBetween;
  proto.isSame = isSame;
  proto.isSameOrAfter = isSameOrAfter;
  proto.isSameOrBefore = isSameOrBefore;
  proto.isValid = isValid$2;
  proto.lang = lang;
  proto.locale = locale;
  proto.localeData = localeData;
  proto.max = prototypeMax;
  proto.min = prototypeMin;
  proto.parsingFlags = parsingFlags;
  proto.set = stringSet;
  proto.startOf = startOf;
  proto.subtract = subtract;
  proto.toArray = toArray;
  proto.toObject = toObject;
  proto.toDate = toDate;
  proto.toISOString = toISOString;
  proto.inspect = inspect;
  if (typeof Symbol !== "undefined" && Symbol.for != null) {
    proto[/* @__PURE__ */ Symbol.for("nodejs.util.inspect.custom")] = function() {
      return "Moment<" + this.format() + ">";
    };
  }
  proto.toJSON = toJSON;
  proto.toString = toString;
  proto.unix = unix;
  proto.valueOf = valueOf;
  proto.creationData = creationData;
  proto.eraName = getEraName;
  proto.eraNarrow = getEraNarrow;
  proto.eraAbbr = getEraAbbr;
  proto.eraYear = getEraYear;
  proto.year = getSetYear;
  proto.isLeapYear = getIsLeapYear;
  proto.weekYear = getSetWeekYear;
  proto.isoWeekYear = getSetISOWeekYear;
  proto.quarter = proto.quarters = getSetQuarter;
  proto.month = getSetMonth;
  proto.daysInMonth = getDaysInMonth;
  proto.week = proto.weeks = getSetWeek;
  proto.isoWeek = proto.isoWeeks = getSetISOWeek;
  proto.weeksInYear = getWeeksInYear;
  proto.weeksInWeekYear = getWeeksInWeekYear;
  proto.isoWeeksInYear = getISOWeeksInYear;
  proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
  proto.date = getSetDayOfMonth;
  proto.day = proto.days = getSetDayOfWeek;
  proto.weekday = getSetLocaleDayOfWeek;
  proto.isoWeekday = getSetISODayOfWeek;
  proto.dayOfYear = getSetDayOfYear;
  proto.hour = proto.hours = getSetHour;
  proto.minute = proto.minutes = getSetMinute;
  proto.second = proto.seconds = getSetSecond;
  proto.millisecond = proto.milliseconds = getSetMillisecond;
  proto.utcOffset = getSetOffset;
  proto.utc = setOffsetToUTC;
  proto.local = setOffsetToLocal;
  proto.parseZone = setOffsetToParsedOffset;
  proto.hasAlignedHourOffset = hasAlignedHourOffset;
  proto.isDST = isDaylightSavingTime;
  proto.isLocal = isLocal;
  proto.isUtcOffset = isUtcOffset;
  proto.isUtc = isUtc;
  proto.isUTC = isUtc;
  proto.zoneAbbr = getZoneAbbr;
  proto.zoneName = getZoneName;
  proto.dates = deprecate(
    "dates accessor is deprecated. Use date instead.",
    getSetDayOfMonth
  );
  proto.months = deprecate(
    "months accessor is deprecated. Use month instead",
    getSetMonth
  );
  proto.years = deprecate(
    "years accessor is deprecated. Use year instead",
    getSetYear
  );
  proto.zone = deprecate(
    "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
    getSetZone
  );
  proto.isDSTShifted = deprecate(
    "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
    isDaylightSavingTimeShifted
  );
  function createUnix(input) {
    return createLocal(input * 1e3);
  }
  function createInZone() {
    return createLocal.apply(null, arguments).parseZone();
  }
  function preParsePostFormat(string) {
    return string;
  }
  var proto$1 = Locale.prototype;
  proto$1.calendar = calendar;
  proto$1.longDateFormat = longDateFormat;
  proto$1.invalidDate = invalidDate;
  proto$1.ordinal = ordinal;
  proto$1.preparse = preParsePostFormat;
  proto$1.postformat = preParsePostFormat;
  proto$1.relativeTime = relativeTime;
  proto$1.pastFuture = pastFuture;
  proto$1.set = set;
  proto$1.eras = localeEras;
  proto$1.erasParse = localeErasParse;
  proto$1.erasConvertYear = localeErasConvertYear;
  proto$1.erasAbbrRegex = erasAbbrRegex;
  proto$1.erasNameRegex = erasNameRegex;
  proto$1.erasNarrowRegex = erasNarrowRegex;
  proto$1.months = localeMonths;
  proto$1.monthsShort = localeMonthsShort;
  proto$1.monthsParse = localeMonthsParse;
  proto$1.monthsRegex = monthsRegex;
  proto$1.monthsShortRegex = monthsShortRegex;
  proto$1.week = localeWeek;
  proto$1.firstDayOfYear = localeFirstDayOfYear;
  proto$1.firstDayOfWeek = localeFirstDayOfWeek;
  proto$1.weekdays = localeWeekdays;
  proto$1.weekdaysMin = localeWeekdaysMin;
  proto$1.weekdaysShort = localeWeekdaysShort;
  proto$1.weekdaysParse = localeWeekdaysParse;
  proto$1.weekdaysRegex = weekdaysRegex;
  proto$1.weekdaysShortRegex = weekdaysShortRegex;
  proto$1.weekdaysMinRegex = weekdaysMinRegex;
  proto$1.isPM = localeIsPM;
  proto$1.meridiem = localeMeridiem;
  function get$1(format2, index, field, setter) {
    var locale2 = getLocale(), utc = createUTC().set(setter, index);
    return locale2[field](utc, format2);
  }
  function listMonthsImpl(format2, index, field) {
    if (isNumber(format2)) {
      index = format2;
      format2 = void 0;
    }
    format2 = format2 || "";
    if (index != null) {
      return get$1(format2, index, field, "month");
    }
    var i, out = [];
    for (i = 0; i < 12; i++) {
      out[i] = get$1(format2, i, field, "month");
    }
    return out;
  }
  function listWeekdaysImpl(localeSorted, format2, index, field) {
    if (typeof localeSorted === "boolean") {
      if (isNumber(format2)) {
        index = format2;
        format2 = void 0;
      }
      format2 = format2 || "";
    } else {
      format2 = localeSorted;
      index = format2;
      localeSorted = false;
      if (isNumber(format2)) {
        index = format2;
        format2 = void 0;
      }
      format2 = format2 || "";
    }
    var locale2 = getLocale(), shift = localeSorted ? locale2._week.dow : 0, i, out = [];
    if (index != null) {
      return get$1(format2, (index + shift) % 7, field, "day");
    }
    for (i = 0; i < 7; i++) {
      out[i] = get$1(format2, (i + shift) % 7, field, "day");
    }
    return out;
  }
  function listMonths(format2, index) {
    return listMonthsImpl(format2, index, "months");
  }
  function listMonthsShort(format2, index) {
    return listMonthsImpl(format2, index, "monthsShort");
  }
  function listWeekdays(localeSorted, format2, index) {
    return listWeekdaysImpl(localeSorted, format2, index, "weekdays");
  }
  function listWeekdaysShort(localeSorted, format2, index) {
    return listWeekdaysImpl(localeSorted, format2, index, "weekdaysShort");
  }
  function listWeekdaysMin(localeSorted, format2, index) {
    return listWeekdaysImpl(localeSorted, format2, index, "weekdaysMin");
  }
  getSetGlobalLocale("en", {
    eras: [
      {
        since: "0001-01-01",
        until: Infinity,
        offset: 1,
        name: "Anno Domini",
        narrow: "AD",
        abbr: "AD"
      },
      {
        since: "0000-12-31",
        until: -Infinity,
        offset: 1,
        name: "Before Christ",
        narrow: "BC",
        abbr: "BC"
      }
    ],
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function(number) {
      var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
      return number + output;
    }
  });
  hooks.lang = deprecate(
    "moment.lang is deprecated. Use moment.locale instead.",
    getSetGlobalLocale
  );
  hooks.langData = deprecate(
    "moment.langData is deprecated. Use moment.localeData instead.",
    getLocale
  );
  var mathAbs = Math.abs;
  function abs() {
    var data = this._data;
    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);
    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);
    return this;
  }
  function addSubtract$1(duration, input, value, direction) {
    var other = createDuration(input, value);
    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;
    return duration._bubble();
  }
  function add$1(input, value) {
    return addSubtract$1(this, input, value, 1);
  }
  function subtract$1(input, value) {
    return addSubtract$1(this, input, value, -1);
  }
  function absCeil(number) {
    if (number < 0) {
      return Math.floor(number);
    } else {
      return Math.ceil(number);
    }
  }
  function bubble() {
    var milliseconds2 = this._milliseconds, days2 = this._days, months2 = this._months, data = this._data, seconds2, minutes2, hours2, years2, monthsFromDays;
    if (!(milliseconds2 >= 0 && days2 >= 0 && months2 >= 0 || milliseconds2 <= 0 && days2 <= 0 && months2 <= 0)) {
      milliseconds2 += absCeil(monthsToDays(months2) + days2) * 864e5;
      days2 = 0;
      months2 = 0;
    }
    data.milliseconds = milliseconds2 % 1e3;
    seconds2 = absFloor(milliseconds2 / 1e3);
    data.seconds = seconds2 % 60;
    minutes2 = absFloor(seconds2 / 60);
    data.minutes = minutes2 % 60;
    hours2 = absFloor(minutes2 / 60);
    data.hours = hours2 % 24;
    days2 += absFloor(hours2 / 24);
    monthsFromDays = absFloor(daysToMonths(days2));
    months2 += monthsFromDays;
    days2 -= absCeil(monthsToDays(monthsFromDays));
    years2 = absFloor(months2 / 12);
    months2 %= 12;
    data.days = days2;
    data.months = months2;
    data.years = years2;
    return this;
  }
  function daysToMonths(days2) {
    return days2 * 4800 / 146097;
  }
  function monthsToDays(months2) {
    return months2 * 146097 / 4800;
  }
  function as(units) {
    if (!this.isValid()) {
      return NaN;
    }
    var days2, months2, milliseconds2 = this._milliseconds;
    units = normalizeUnits(units);
    if (units === "month" || units === "quarter" || units === "year") {
      days2 = this._days + milliseconds2 / 864e5;
      months2 = this._months + daysToMonths(days2);
      switch (units) {
        case "month":
          return months2;
        case "quarter":
          return months2 / 3;
        case "year":
          return months2 / 12;
      }
    } else {
      days2 = this._days + Math.round(monthsToDays(this._months));
      switch (units) {
        case "week":
          return days2 / 7 + milliseconds2 / 6048e5;
        case "day":
          return days2 + milliseconds2 / 864e5;
        case "hour":
          return days2 * 24 + milliseconds2 / 36e5;
        case "minute":
          return days2 * 1440 + milliseconds2 / 6e4;
        case "second":
          return days2 * 86400 + milliseconds2 / 1e3;
        // Math.floor prevents floating point math errors here
        case "millisecond":
          return Math.floor(days2 * 864e5) + milliseconds2;
        default:
          throw new Error("Unknown unit " + units);
      }
    }
  }
  function makeAs(alias) {
    return function() {
      return this.as(alias);
    };
  }
  var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
  function clone$1() {
    return createDuration(this);
  }
  function get$2(units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + "s"]() : NaN;
  }
  function makeGetter(name) {
    return function() {
      return this.isValid() ? this._data[name] : NaN;
    };
  }
  var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
  function weeks() {
    return absFloor(this.days() / 7);
  }
  var round = Math.round, thresholds = {
    ss: 44,
    // a few seconds to seconds
    s: 45,
    // seconds to minute
    m: 45,
    // minutes to hour
    h: 22,
    // hours to day
    d: 26,
    // days to month/week
    w: null,
    // weeks to month
    M: 11
    // months to year
  };
  function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale2) {
    return locale2.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
  }
  function relativeTime$1(posNegDuration, withoutSuffix, thresholds2, locale2) {
    var duration = createDuration(posNegDuration).abs(), seconds2 = round(duration.as("s")), minutes2 = round(duration.as("m")), hours2 = round(duration.as("h")), days2 = round(duration.as("d")), months2 = round(duration.as("M")), weeks2 = round(duration.as("w")), years2 = round(duration.as("y")), a = seconds2 <= thresholds2.ss && ["s", seconds2] || seconds2 < thresholds2.s && ["ss", seconds2] || minutes2 <= 1 && ["m"] || minutes2 < thresholds2.m && ["mm", minutes2] || hours2 <= 1 && ["h"] || hours2 < thresholds2.h && ["hh", hours2] || days2 <= 1 && ["d"] || days2 < thresholds2.d && ["dd", days2];
    if (thresholds2.w != null) {
      a = a || weeks2 <= 1 && ["w"] || weeks2 < thresholds2.w && ["ww", weeks2];
    }
    a = a || months2 <= 1 && ["M"] || months2 < thresholds2.M && ["MM", months2] || years2 <= 1 && ["y"] || ["yy", years2];
    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale2;
    return substituteTimeAgo.apply(null, a);
  }
  function getSetRelativeTimeRounding(roundingFunction) {
    if (roundingFunction === void 0) {
      return round;
    }
    if (typeof roundingFunction === "function") {
      round = roundingFunction;
      return true;
    }
    return false;
  }
  function getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === void 0) {
      return false;
    }
    if (limit === void 0) {
      return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === "s") {
      thresholds.ss = limit - 1;
    }
    return true;
  }
  function humanize(argWithSuffix, argThresholds) {
    if (!this.isValid()) {
      return this.localeData().invalidDate();
    }
    var withSuffix = false, th = thresholds, locale2, output;
    if (typeof argWithSuffix === "object") {
      argThresholds = argWithSuffix;
      argWithSuffix = false;
    }
    if (typeof argWithSuffix === "boolean") {
      withSuffix = argWithSuffix;
    }
    if (typeof argThresholds === "object") {
      th = Object.assign({}, thresholds, argThresholds);
      if (argThresholds.s != null && argThresholds.ss == null) {
        th.ss = argThresholds.s - 1;
      }
    }
    locale2 = this.localeData();
    output = relativeTime$1(this, !withSuffix, th, locale2);
    if (withSuffix) {
      output = locale2.pastFuture(+this, output);
    }
    return locale2.postformat(output);
  }
  var abs$1 = Math.abs;
  function sign(x) {
    return (x > 0) - (x < 0) || +x;
  }
  function toISOString$1() {
    if (!this.isValid()) {
      return this.localeData().invalidDate();
    }
    var seconds2 = abs$1(this._milliseconds) / 1e3, days2 = abs$1(this._days), months2 = abs$1(this._months), minutes2, hours2, years2, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
    if (!total) {
      return "P0D";
    }
    minutes2 = absFloor(seconds2 / 60);
    hours2 = absFloor(minutes2 / 60);
    seconds2 %= 60;
    minutes2 %= 60;
    years2 = absFloor(months2 / 12);
    months2 %= 12;
    s = seconds2 ? seconds2.toFixed(3).replace(/\.?0+$/, "") : "";
    totalSign = total < 0 ? "-" : "";
    ymSign = sign(this._months) !== sign(total) ? "-" : "";
    daysSign = sign(this._days) !== sign(total) ? "-" : "";
    hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
    return totalSign + "P" + (years2 ? ymSign + years2 + "Y" : "") + (months2 ? ymSign + months2 + "M" : "") + (days2 ? daysSign + days2 + "D" : "") + (hours2 || minutes2 || seconds2 ? "T" : "") + (hours2 ? hmsSign + hours2 + "H" : "") + (minutes2 ? hmsSign + minutes2 + "M" : "") + (seconds2 ? hmsSign + s + "S" : "");
  }
  var proto$2 = Duration.prototype;
  proto$2.isValid = isValid$1;
  proto$2.abs = abs;
  proto$2.add = add$1;
  proto$2.subtract = subtract$1;
  proto$2.as = as;
  proto$2.asMilliseconds = asMilliseconds;
  proto$2.asSeconds = asSeconds;
  proto$2.asMinutes = asMinutes;
  proto$2.asHours = asHours;
  proto$2.asDays = asDays;
  proto$2.asWeeks = asWeeks;
  proto$2.asMonths = asMonths;
  proto$2.asQuarters = asQuarters;
  proto$2.asYears = asYears;
  proto$2.valueOf = valueOf$1;
  proto$2._bubble = bubble;
  proto$2.clone = clone$1;
  proto$2.get = get$2;
  proto$2.milliseconds = milliseconds;
  proto$2.seconds = seconds;
  proto$2.minutes = minutes;
  proto$2.hours = hours;
  proto$2.days = days;
  proto$2.weeks = weeks;
  proto$2.months = months;
  proto$2.years = years;
  proto$2.humanize = humanize;
  proto$2.toISOString = toISOString$1;
  proto$2.toString = toISOString$1;
  proto$2.toJSON = toISOString$1;
  proto$2.locale = locale;
  proto$2.localeData = localeData;
  proto$2.toIsoString = deprecate(
    "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
    toISOString$1
  );
  proto$2.lang = lang;
  addFormatToken("X", 0, 0, "unix");
  addFormatToken("x", 0, 0, "valueOf");
  addRegexToken("x", matchSigned);
  addRegexToken("X", matchTimestamp);
  addParseToken("X", function(input, array, config) {
    config._d = new Date(parseFloat(input) * 1e3);
  });
  addParseToken("x", function(input, array, config) {
    config._d = new Date(toInt(input));
  });
  //! moment.js
  hooks.version = "2.30.1";
  setHookCallback(createLocal);
  hooks.fn = proto;
  hooks.min = min;
  hooks.max = max;
  hooks.now = now;
  hooks.utc = createUTC;
  hooks.unix = createUnix;
  hooks.months = listMonths;
  hooks.isDate = isDate;
  hooks.locale = getSetGlobalLocale;
  hooks.invalid = createInvalid;
  hooks.duration = createDuration;
  hooks.isMoment = isMoment;
  hooks.weekdays = listWeekdays;
  hooks.parseZone = createInZone;
  hooks.localeData = getLocale;
  hooks.isDuration = isDuration;
  hooks.monthsShort = listMonthsShort;
  hooks.weekdaysMin = listWeekdaysMin;
  hooks.defineLocale = defineLocale;
  hooks.updateLocale = updateLocale;
  hooks.locales = listLocales;
  hooks.weekdaysShort = listWeekdaysShort;
  hooks.normalizeUnits = normalizeUnits;
  hooks.relativeTimeRounding = getSetRelativeTimeRounding;
  hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
  hooks.calendarFormat = getCalendarFormat;
  hooks.prototype = proto;
  hooks.HTML5_FMT = {
    DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
    // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
    // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
    // <input type="datetime-local" step="0.001" />
    DATE: "YYYY-MM-DD",
    // <input type="date" />
    TIME: "HH:mm",
    // <input type="time" />
    TIME_SECONDS: "HH:mm:ss",
    // <input type="time" step="1" />
    TIME_MS: "HH:mm:ss.SSS",
    // <input type="time" step="0.001" />
    WEEK: "GGGG-[W]WW",
    // <input type="week" />
    MONTH: "YYYY-MM"
    // <input type="month" />
  };
  return hooks;
}));


/***/ }),

/***/ 30738:
/***/ (function(module) {

"use strict";

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
      return test2[n];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
module.exports = shouldUseNative() ? Object.assign : function(target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};


/***/ }),

/***/ 69436:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isarray = __webpack_require__(1756);
module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  "(\\\\.)",
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
function parse(str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = "";
  var defaultDelimiter = options && options.delimiter || "/";
  var res;
  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;
    if (escaped) {
      path += escaped[1];
      continue;
    }
    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];
    if (path) {
      tokens.push(path);
      path = "";
    }
    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === "+" || modifier === "*";
    var optional = modifier === "?" || modifier === "*";
    var delimiter = prefix || defaultDelimiter;
    var pattern = capture || group;
    var prevText = prefix || (typeof tokens[tokens.length - 1] === "string" ? tokens[tokens.length - 1] : "");
    tokens.push({
      name: name || key++,
      prefix: prefix || "",
      delimiter,
      optional,
      repeat,
      partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : asterisk ? ".*" : restrictBacktrack(delimiter, prevText)
    });
  }
  if (index < str.length) {
    path += str.substr(index);
  }
  if (path) {
    tokens.push(path);
  }
  return tokens;
}
function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return "[^" + escapeString(delimiter) + "]+?";
  }
  return escapeString(prevText) + "|(?:(?!" + escapeString(prevText) + ")[^" + escapeString(delimiter) + "])+?";
}
function compile(str, options) {
  return tokensToFunction(parse(str, options), options);
}
function encodeURIComponentPretty(str) {
  return encodeURI(str).replace(/[\/?#]/g, function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
  });
}
function encodeAsterisk(str) {
  return encodeURI(str).replace(/[?#]/g, function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
  });
}
function tokensToFunction(tokens, options) {
  var matches = new Array(tokens.length);
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === "object") {
      matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", flags(options));
    }
  }
  return function(obj, opts) {
    var path = "";
    var data = obj || {};
    var options2 = opts || {};
    var encode = options2.pretty ? encodeURIComponentPretty : encodeURIComponent;
    for (var i2 = 0; i2 < tokens.length; i2++) {
      var token = tokens[i2];
      if (typeof token === "string") {
        path += token;
        continue;
      }
      var value = data[token.name];
      var segment;
      if (value == null) {
        if (token.optional) {
          if (token.partial) {
            path += token.prefix;
          }
          continue;
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined');
        }
      }
      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
        }
        if (value.length === 0) {
          if (token.optional) {
            continue;
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty');
          }
        }
        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);
          if (!matches[i2].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
          }
          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }
        continue;
      }
      segment = token.asterisk ? encodeAsterisk(value) : encode(value);
      if (!matches[i2].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
      }
      path += token.prefix + segment;
    }
    return path;
  };
}
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
function escapeGroup(group) {
  return group.replace(/([=!:$\/()])/g, "\\$1");
}
function attachKeys(re, keys) {
  re.keys = keys;
  return re;
}
function flags(options) {
  return options && options.sensitive ? "" : "i";
}
function regexpToRegexp(path, keys) {
  var groups = path.source.match(/\((?!\?)/g);
  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }
  return attachKeys(path, keys);
}
function arrayToRegexp(path, keys, options) {
  var parts = [];
  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }
  var regexp = new RegExp("(?:" + parts.join("|") + ")", flags(options));
  return attachKeys(regexp, keys);
}
function stringToRegexp(path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options);
}
function tokensToRegExp(tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */
    keys || options;
    keys = [];
  }
  options = options || {};
  var strict = options.strict;
  var end = options.end !== false;
  var route = "";
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];
    if (typeof token === "string") {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = "(?:" + token.pattern + ")";
      keys.push(token);
      if (token.repeat) {
        capture += "(?:" + prefix + capture + ")*";
      }
      if (token.optional) {
        if (!token.partial) {
          capture = "(?:" + prefix + "(" + capture + "))?";
        } else {
          capture = prefix + "(" + capture + ")?";
        }
      } else {
        capture = prefix + "(" + capture + ")";
      }
      route += capture;
    }
  }
  var delimiter = escapeString(options.delimiter || "/");
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
  }
  if (end) {
    route += "$";
  } else {
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
  }
  return attachKeys(new RegExp("^" + route, flags(options)), keys);
}
function pathToRegexp(path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */
    keys || options;
    keys = [];
  }
  options = options || {};
  if (path instanceof RegExp) {
    return regexpToRegexp(
      path,
      /** @type {!Array} */
      keys
    );
  }
  if (isarray(path)) {
    return arrayToRegexp(
      /** @type {!Array} */
      path,
      /** @type {!Array} */
      keys,
      options
    );
  }
  return stringToRegexp(
    /** @type {string} */
    path,
    /** @type {!Array} */
    keys,
    options
  );
}


/***/ }),

/***/ 1068:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ReactPropTypesSecret = __webpack_require__(28091);
function emptyFunction() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction;
module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      return;
    }
    var err = new Error(
      "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
    );
    err.name = "Invariant Violation";
    throw err;
  }
  ;
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  ;
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};


/***/ }),

/***/ 52074:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

if (false) // removed by dead control flow
{ var throwOnDirectAccess, ReactIs; } else {
  module.exports = __webpack_require__(1068)();
}


/***/ }),

/***/ 28091:
/***/ (function(module) {

"use strict";

var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 47261:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aa = __webpack_require__(12549), m = __webpack_require__(30738), r = __webpack_require__(21968);
function y(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!aa) throw Error(y(227));
var ba = /* @__PURE__ */ new Set(), ca = {};
function da(a, b) {
  ea(a, b);
  ea(a + "Capture", b);
}
function ea(a, b) {
  ca[a] = b;
  for (a = 0; a < b.length; a++) ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
  if (ia.call(ka, a)) return true;
  if (ia.call(ja, a)) return false;
  if (ha.test(a)) return ka[a] = true;
  ja[a] = true;
  return false;
}
function ma(a, b, c, d) {
  if (null !== c && 0 === c.type) return false;
  switch (typeof b) {
    case "function":
    case "symbol":
      return true;
    case "boolean":
      if (d) return false;
      if (null !== c) return !c.acceptsBooleans;
      a = a.toLowerCase().slice(0, 5);
      return "data-" !== a && "aria-" !== a;
    default:
      return false;
  }
}
function na(a, b, c, d) {
  if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return true;
  if (d) return false;
  if (null !== c) switch (c.type) {
    case 3:
      return !b;
    case 4:
      return false === b;
    case 5:
      return isNaN(b);
    case 6:
      return isNaN(b) || 1 > b;
  }
  return false;
}
function B(a, b, c, d, e, f, g) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
  this.attributeName = d;
  this.attributeNamespace = e;
  this.mustUseProperty = c;
  this.propertyName = a;
  this.type = b;
  this.sanitizeURL = f;
  this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
  D[a] = new B(a, 0, false, a, null, false, false);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
  var b = a[0];
  D[b] = new B(b, 1, false, a[1], null, false, false);
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
  D[a] = new B(a, 2, false, a.toLowerCase(), null, false, false);
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
  D[a] = new B(a, 2, false, a, null, false, false);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
  D[a] = new B(a, 3, false, a.toLowerCase(), null, false, false);
});
["checked", "multiple", "muted", "selected"].forEach(function(a) {
  D[a] = new B(a, 3, true, a, null, false, false);
});
["capture", "download"].forEach(function(a) {
  D[a] = new B(a, 4, false, a, null, false, false);
});
["cols", "rows", "size", "span"].forEach(function(a) {
  D[a] = new B(a, 6, false, a, null, false, false);
});
["rowSpan", "start"].forEach(function(a) {
  D[a] = new B(a, 5, false, a.toLowerCase(), null, false, false);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
  var b = a.replace(
    oa,
    pa
  );
  D[b] = new B(b, 1, false, a, null, false, false);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
  var b = a.replace(oa, pa);
  D[b] = new B(b, 1, false, a, "http://www.w3.org/1999/xlink", false, false);
});
["xml:base", "xml:lang", "xml:space"].forEach(function(a) {
  var b = a.replace(oa, pa);
  D[b] = new B(b, 1, false, a, "http://www.w3.org/XML/1998/namespace", false, false);
});
["tabIndex", "crossOrigin"].forEach(function(a) {
  D[a] = new B(a, 1, false, a.toLowerCase(), null, false, false);
});
D.xlinkHref = new B("xlinkHref", 1, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
["src", "href", "action", "formAction"].forEach(function(a) {
  D[a] = new B(a, 1, false, a.toLowerCase(), null, true, true);
});
function qa(a, b, c, d) {
  var e = D.hasOwnProperty(b) ? D[b] : null;
  var f = null !== e ? 0 === e.type : d ? false : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? false : true;
  f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? false : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && true === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
  var E = Symbol.for;
  sa = E("react.element");
  ta = E("react.portal");
  ua = E("react.fragment");
  wa = E("react.strict_mode");
  xa = E("react.profiler");
  ya = E("react.provider");
  za = E("react.context");
  Aa = E("react.forward_ref");
  Ba = E("react.suspense");
  Ca = E("react.suspense_list");
  Da = E("react.memo");
  Ea = E("react.lazy");
  Fa = E("react.block");
  E("react.scope");
  Ga = E("react.opaque.id");
  Ha = E("react.debug_trace_mode");
  Ia = E("react.offscreen");
  Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
  if (null === a || "object" !== typeof a) return null;
  a = Ka && a[Ka] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
  if (void 0 === Ma) try {
    throw Error();
  } catch (c) {
    var b = c.stack.trim().match(/\n( *(at )?)/);
    Ma = b && b[1] || "";
  }
  return "\n" + Ma + a;
}
var Oa = false;
function Pa(a, b) {
  if (!a || Oa) return "";
  Oa = true;
  var c = Error.prepareStackTrace;
  Error.prepareStackTrace = void 0;
  try {
    if (b) if (b = function() {
      throw Error();
    }, Object.defineProperty(b.prototype, "props", { set: function() {
      throw Error();
    } }), "object" === typeof Reflect && Reflect.construct) {
      try {
        Reflect.construct(b, []);
      } catch (k) {
        var d = k;
      }
      Reflect.construct(a, [], b);
    } else {
      try {
        b.call();
      } catch (k) {
        d = k;
      }
      a.call(b.prototype);
    }
    else {
      try {
        throw Error();
      } catch (k) {
        d = k;
      }
      a();
    }
  } catch (k) {
    if (k && d && "string" === typeof k.stack) {
      for (var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h]; ) h--;
      for (; 1 <= g && 0 <= h; g--, h--) if (e[g] !== f[h]) {
        if (1 !== g || 1 !== h) {
          do
            if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
          while (1 <= g && 0 <= h);
        }
        break;
      }
    }
  } finally {
    Oa = false, Error.prepareStackTrace = c;
  }
  return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
  switch (a.tag) {
    case 5:
      return Na(a.type);
    case 16:
      return Na("Lazy");
    case 13:
      return Na("Suspense");
    case 19:
      return Na("SuspenseList");
    case 0:
    case 2:
    case 15:
      return a = Pa(a.type, false), a;
    case 11:
      return a = Pa(a.type.render, false), a;
    case 22:
      return a = Pa(a.type._render, false), a;
    case 1:
      return a = Pa(a.type, true), a;
    default:
      return "";
  }
}
function Ra(a) {
  if (null == a) return null;
  if ("function" === typeof a) return a.displayName || a.name || null;
  if ("string" === typeof a) return a;
  switch (a) {
    case ua:
      return "Fragment";
    case ta:
      return "Portal";
    case xa:
      return "Profiler";
    case wa:
      return "StrictMode";
    case Ba:
      return "Suspense";
    case Ca:
      return "SuspenseList";
  }
  if ("object" === typeof a) switch (a.$$typeof) {
    case za:
      return (a.displayName || "Context") + ".Consumer";
    case ya:
      return (a._context.displayName || "Context") + ".Provider";
    case Aa:
      var b = a.render;
      b = b.displayName || b.name || "";
      return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
    case Da:
      return Ra(a.type);
    case Fa:
      return Ra(a._render);
    case Ea:
      b = a._payload;
      a = a._init;
      try {
        return Ra(a(b));
      } catch (c) {
      }
  }
  return null;
}
function Sa(a) {
  switch (typeof a) {
    case "boolean":
    case "number":
    case "object":
    case "string":
    case "undefined":
      return a;
    default:
      return "";
  }
}
function Ta(a) {
  var b = a.type;
  return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
  var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
  if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
    var e = c.get, f = c.set;
    Object.defineProperty(a, b, { configurable: true, get: function() {
      return e.call(this);
    }, set: function(a2) {
      d = "" + a2;
      f.call(this, a2);
    } });
    Object.defineProperty(a, b, { enumerable: c.enumerable });
    return { getValue: function() {
      return d;
    }, setValue: function(a2) {
      d = "" + a2;
    }, stopTracking: function() {
      a._valueTracker = null;
      delete a[b];
    } };
  }
}
function Va(a) {
  a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
  if (!a) return false;
  var b = a._valueTracker;
  if (!b) return true;
  var c = b.getValue();
  var d = "";
  a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
  a = d;
  return a !== c ? (b.setValue(a), true) : false;
}
function Xa(a) {
  a = a || ("undefined" !== typeof document ? document : void 0);
  if ("undefined" === typeof a) return null;
  try {
    return a.activeElement || a.body;
  } catch (b) {
    return a.body;
  }
}
function Ya(a, b) {
  var c = b.checked;
  return m({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
}
function Za(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
  c = Sa(null != b.value ? b.value : c);
  a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
}
function $a(a, b) {
  b = b.checked;
  null != b && qa(a, "checked", b, false);
}
function ab(a, b) {
  $a(a, b);
  var c = Sa(b.value), d = b.type;
  if (null != c) if ("number" === d) {
    if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
  } else a.value !== "" + c && (a.value = "" + c);
  else if ("submit" === d || "reset" === d) {
    a.removeAttribute("value");
    return;
  }
  b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
  null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
    var d = b.type;
    if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
    b = "" + a._wrapperState.initialValue;
    c || b === a.value || (a.value = b);
    a.defaultValue = b;
  }
  c = a.name;
  "" !== c && (a.name = "");
  a.defaultChecked = !!a._wrapperState.initialChecked;
  "" !== c && (a.name = c);
}
function bb(a, b, c) {
  if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
  var b = "";
  aa.Children.forEach(a, function(a2) {
    null != a2 && (b += a2);
  });
  return b;
}
function eb(a, b) {
  a = m({ children: void 0 }, b);
  if (b = db(b.children)) a.children = b;
  return a;
}
function fb(a, b, c, d) {
  a = a.options;
  if (b) {
    b = {};
    for (var e = 0; e < c.length; e++) b["$" + c[e]] = true;
    for (c = 0; c < a.length; c++) e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = true);
  } else {
    c = "" + Sa(c);
    b = null;
    for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = true;
        d && (a[e].defaultSelected = true);
        return;
      }
      null !== b || a[e].disabled || (b = a[e]);
    }
    null !== b && (b.selected = true);
  }
}
function gb(a, b) {
  if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
  return m({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
}
function hb(a, b) {
  var c = b.value;
  if (null == c) {
    c = b.children;
    b = b.defaultValue;
    if (null != c) {
      if (null != b) throw Error(y(92));
      if (Array.isArray(c)) {
        if (!(1 >= c.length)) throw Error(y(93));
        c = c[0];
      }
      b = c;
    }
    null == b && (b = "");
    c = b;
  }
  a._wrapperState = { initialValue: Sa(c) };
}
function ib(a, b) {
  var c = Sa(b.value), d = Sa(b.defaultValue);
  null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
  null != d && (a.defaultValue = "" + d);
}
function jb(a) {
  var b = a.textContent;
  b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
function lb(a) {
  switch (a) {
    case "svg":
      return "http://www.w3.org/2000/svg";
    case "math":
      return "http://www.w3.org/1998/Math/MathML";
    default:
      return "http://www.w3.org/1999/xhtml";
  }
}
function mb(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = (function(a) {
  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
    MSApp.execUnsafeLocalFunction(function() {
      return a(b, c, d, e);
    });
  } : a;
})(function(a, b) {
  if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
  else {
    nb = nb || document.createElement("div");
    nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
    for (b = nb.firstChild; a.firstChild; ) a.removeChild(a.firstChild);
    for (; b.firstChild; ) a.appendChild(b.firstChild);
  }
});
function pb(a, b) {
  if (b) {
    var c = a.firstChild;
    if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;
      return;
    }
  }
  a.textContent = b;
}
var qb = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridArea: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
}, rb = ["Webkit", "ms", "Moz", "O"];
Object.keys(qb).forEach(function(a) {
  rb.forEach(function(b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);
    qb[b] = qb[a];
  });
});
function sb(a, b, c) {
  return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
  a = a.style;
  for (var c in b) if (b.hasOwnProperty(c)) {
    var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
    "float" === c && (c = "cssFloat");
    d ? a.setProperty(c, e) : a[c] = e;
  }
}
var ub = m({ menuitem: true }, { area: true, base: true, br: true, col: true, embed: true, hr: true, img: true, input: true, keygen: true, link: true, meta: true, param: true, source: true, track: true, wbr: true });
function vb(a, b) {
  if (b) {
    if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
    if (null != b.dangerouslySetInnerHTML) {
      if (null != b.children) throw Error(y(60));
      if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
    }
    if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
  }
}
function wb(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;
  switch (a) {
    case "annotation-xml":
    case "color-profile":
    case "font-face":
    case "font-face-src":
    case "font-face-uri":
    case "font-face-format":
    case "font-face-name":
    case "missing-glyph":
      return false;
    default:
      return true;
  }
}
function xb(a) {
  a = a.target || a.srcElement || window;
  a.correspondingUseElement && (a = a.correspondingUseElement);
  return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
  if (a = Cb(a)) {
    if ("function" !== typeof yb) throw Error(y(280));
    var b = a.stateNode;
    b && (b = Db(b), yb(a.stateNode, a.type, b));
  }
}
function Eb(a) {
  zb ? Ab ? Ab.push(a) : Ab = [a] : zb = a;
}
function Fb() {
  if (zb) {
    var a = zb, b = Ab;
    Ab = zb = null;
    Bb(a);
    if (b) for (a = 0; a < b.length; a++) Bb(b[a]);
  }
}
function Gb(a, b) {
  return a(b);
}
function Hb(a, b, c, d, e) {
  return a(b, c, d, e);
}
function Ib() {
}
var Jb = Gb, Kb = false, Lb = false;
function Mb() {
  if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
  if (Lb) return a(b, c);
  Lb = true;
  try {
    return Jb(a, b, c);
  } finally {
    Lb = false, Mb();
  }
}
function Ob(a, b) {
  var c = a.stateNode;
  if (null === c) return null;
  var d = Db(c);
  if (null === d) return null;
  c = d[b];
  a: switch (b) {
    case "onClick":
    case "onClickCapture":
    case "onDoubleClick":
    case "onDoubleClickCapture":
    case "onMouseDown":
    case "onMouseDownCapture":
    case "onMouseMove":
    case "onMouseMoveCapture":
    case "onMouseUp":
    case "onMouseUpCapture":
    case "onMouseEnter":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
      a = !d;
      break a;
    default:
      a = false;
  }
  if (a) return null;
  if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
  return c;
}
var Pb = false;
if (fa) try {
  var Qb = {};
  Object.defineProperty(Qb, "passive", { get: function() {
    Pb = true;
  } });
  window.addEventListener("test", Qb, Qb);
  window.removeEventListener("test", Qb, Qb);
} catch (a) {
  Pb = false;
}
function Rb(a, b, c, d, e, f, g, h, k) {
  var l = Array.prototype.slice.call(arguments, 3);
  try {
    b.apply(c, l);
  } catch (n) {
    this.onError(n);
  }
}
var Sb = false, Tb = null, Ub = false, Vb = null, Wb = { onError: function(a) {
  Sb = true;
  Tb = a;
} };
function Xb(a, b, c, d, e, f, g, h, k) {
  Sb = false;
  Tb = null;
  Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
  Xb.apply(this, arguments);
  if (Sb) {
    if (Sb) {
      var l = Tb;
      Sb = false;
      Tb = null;
    } else throw Error(y(198));
    Ub || (Ub = true, Vb = l);
  }
}
function Zb(a) {
  var b = a, c = a;
  if (a.alternate) for (; b.return; ) b = b.return;
  else {
    a = b;
    do
      b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
    while (a);
  }
  return 3 === b.tag ? c : null;
}
function $b(a) {
  if (13 === a.tag) {
    var b = a.memoizedState;
    null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
    if (null !== b) return b.dehydrated;
  }
  return null;
}
function ac(a) {
  if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
  var b = a.alternate;
  if (!b) {
    b = Zb(a);
    if (null === b) throw Error(y(188));
    return b !== a ? null : a;
  }
  for (var c = a, d = b; ; ) {
    var e = c.return;
    if (null === e) break;
    var f = e.alternate;
    if (null === f) {
      d = e.return;
      if (null !== d) {
        c = d;
        continue;
      }
      break;
    }
    if (e.child === f.child) {
      for (f = e.child; f; ) {
        if (f === c) return ac(e), a;
        if (f === d) return ac(e), b;
        f = f.sibling;
      }
      throw Error(y(188));
    }
    if (c.return !== d.return) c = e, d = f;
    else {
      for (var g = false, h = e.child; h; ) {
        if (h === c) {
          g = true;
          c = e;
          d = f;
          break;
        }
        if (h === d) {
          g = true;
          d = e;
          c = f;
          break;
        }
        h = h.sibling;
      }
      if (!g) {
        for (h = f.child; h; ) {
          if (h === c) {
            g = true;
            c = f;
            d = e;
            break;
          }
          if (h === d) {
            g = true;
            d = f;
            c = e;
            break;
          }
          h = h.sibling;
        }
        if (!g) throw Error(y(189));
      }
    }
    if (c.alternate !== d) throw Error(y(190));
  }
  if (3 !== c.tag) throw Error(y(188));
  return c.stateNode.current === c ? a : b;
}
function cc(a) {
  a = bc(a);
  if (!a) return null;
  for (var b = a; ; ) {
    if (5 === b.tag || 6 === b.tag) return b;
    if (b.child) b.child.return = b, b = b.child;
    else {
      if (b === a) break;
      for (; !b.sibling; ) {
        if (!b.return || b.return === a) return null;
        b = b.return;
      }
      b.sibling.return = b.return;
      b = b.sibling;
    }
  }
  return null;
}
function dc(a, b) {
  for (var c = a.alternate; null !== b; ) {
    if (b === a || b === c) return true;
    b = b.return;
  }
  return false;
}
var ec, fc, gc, hc, ic = false, jc = [], kc = null, lc = null, mc = null, nc = /* @__PURE__ */ new Map(), oc = /* @__PURE__ */ new Map(), pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
  return { blockedOn: a, domEventName: b, eventSystemFlags: c | 16, nativeEvent: e, targetContainers: [d] };
}
function sc(a, b) {
  switch (a) {
    case "focusin":
    case "focusout":
      kc = null;
      break;
    case "dragenter":
    case "dragleave":
      lc = null;
      break;
    case "mouseover":
    case "mouseout":
      mc = null;
      break;
    case "pointerover":
    case "pointerout":
      nc.delete(b.pointerId);
      break;
    case "gotpointercapture":
    case "lostpointercapture":
      oc.delete(b.pointerId);
  }
}
function tc(a, b, c, d, e, f) {
  if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
  a.eventSystemFlags |= d;
  b = a.targetContainers;
  null !== e && -1 === b.indexOf(e) && b.push(e);
  return a;
}
function uc(a, b, c, d, e) {
  switch (b) {
    case "focusin":
      return kc = tc(kc, a, b, c, d, e), true;
    case "dragenter":
      return lc = tc(lc, a, b, c, d, e), true;
    case "mouseover":
      return mc = tc(mc, a, b, c, d, e), true;
    case "pointerover":
      var f = e.pointerId;
      nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
      return true;
    case "gotpointercapture":
      return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), true;
  }
  return false;
}
function vc(a) {
  var b = wc(a.target);
  if (null !== b) {
    var c = Zb(b);
    if (null !== c) {
      if (b = c.tag, 13 === b) {
        if (b = $b(c), null !== b) {
          a.blockedOn = b;
          hc(a.lanePriority, function() {
            r.unstable_runWithPriority(a.priority, function() {
              gc(c);
            });
          });
          return;
        }
      } else if (3 === b && c.stateNode.hydrate) {
        a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
        return;
      }
    }
  }
  a.blockedOn = null;
}
function xc(a) {
  if (null !== a.blockedOn) return false;
  for (var b = a.targetContainers; 0 < b.length; ) {
    var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
    if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, false;
    b.shift();
  }
  return true;
}
function zc(a, b, c) {
  xc(a) && c.delete(b);
}
function Ac() {
  for (ic = false; 0 < jc.length; ) {
    var a = jc[0];
    if (null !== a.blockedOn) {
      a = Cb(a.blockedOn);
      null !== a && ec(a);
      break;
    }
    for (var b = a.targetContainers; 0 < b.length; ) {
      var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
      if (null !== c) {
        a.blockedOn = c;
        break;
      }
      b.shift();
    }
    null === a.blockedOn && jc.shift();
  }
  null !== kc && xc(kc) && (kc = null);
  null !== lc && xc(lc) && (lc = null);
  null !== mc && xc(mc) && (mc = null);
  nc.forEach(zc);
  oc.forEach(zc);
}
function Bc(a, b) {
  a.blockedOn === b && (a.blockedOn = null, ic || (ic = true, r.unstable_scheduleCallback(r.unstable_NormalPriority, Ac)));
}
function Cc(a) {
  function b(b2) {
    return Bc(b2, a);
  }
  if (0 < jc.length) {
    Bc(jc[0], a);
    for (var c = 1; c < jc.length; c++) {
      var d = jc[c];
      d.blockedOn === a && (d.blockedOn = null);
    }
  }
  null !== kc && Bc(kc, a);
  null !== lc && Bc(lc, a);
  null !== mc && Bc(mc, a);
  nc.forEach(b);
  oc.forEach(b);
  for (c = 0; c < pc.length; c++) d = pc[c], d.blockedOn === a && (d.blockedOn = null);
  for (; 0 < pc.length && (c = pc[0], null === c.blockedOn); ) vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
  var c = {};
  c[a.toLowerCase()] = b.toLowerCase();
  c["Webkit" + a] = "webkit" + b;
  c["Moz" + a] = "moz" + b;
  return c;
}
var Ec = { animationend: Dc("Animation", "AnimationEnd"), animationiteration: Dc("Animation", "AnimationIteration"), animationstart: Dc("Animation", "AnimationStart"), transitionend: Dc("Transition", "TransitionEnd") }, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
  if (Fc[a]) return Fc[a];
  if (!Ec[a]) return a;
  var b = Ec[a], c;
  for (c in b) if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
  return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = /* @__PURE__ */ new Map(), Nc = /* @__PURE__ */ new Map(), Oc = [
  "abort",
  "abort",
  Ic,
  "animationEnd",
  Jc,
  "animationIteration",
  Kc,
  "animationStart",
  "canplay",
  "canPlay",
  "canplaythrough",
  "canPlayThrough",
  "durationchange",
  "durationChange",
  "emptied",
  "emptied",
  "encrypted",
  "encrypted",
  "ended",
  "ended",
  "error",
  "error",
  "gotpointercapture",
  "gotPointerCapture",
  "load",
  "load",
  "loadeddata",
  "loadedData",
  "loadedmetadata",
  "loadedMetadata",
  "loadstart",
  "loadStart",
  "lostpointercapture",
  "lostPointerCapture",
  "playing",
  "playing",
  "progress",
  "progress",
  "seeking",
  "seeking",
  "stalled",
  "stalled",
  "suspend",
  "suspend",
  "timeupdate",
  "timeUpdate",
  Lc,
  "transitionEnd",
  "waiting",
  "waiting"
];
function Pc(a, b) {
  for (var c = 0; c < a.length; c += 2) {
    var d = a[c], e = a[c + 1];
    e = "on" + (e[0].toUpperCase() + e.slice(1));
    Nc.set(d, b);
    Mc.set(d, e);
    da(e, [d]);
  }
}
var Qc = r.unstable_now;
Qc();
var F = 8;
function Rc(a) {
  if (0 !== (1 & a)) return F = 15, 1;
  if (0 !== (2 & a)) return F = 14, 2;
  if (0 !== (4 & a)) return F = 13, 4;
  var b = 24 & a;
  if (0 !== b) return F = 12, b;
  if (0 !== (a & 32)) return F = 11, 32;
  b = 192 & a;
  if (0 !== b) return F = 10, b;
  if (0 !== (a & 256)) return F = 9, 256;
  b = 3584 & a;
  if (0 !== b) return F = 8, b;
  if (0 !== (a & 4096)) return F = 7, 4096;
  b = 4186112 & a;
  if (0 !== b) return F = 6, b;
  b = 62914560 & a;
  if (0 !== b) return F = 5, b;
  if (a & 67108864) return F = 4, 67108864;
  if (0 !== (a & 134217728)) return F = 3, 134217728;
  b = 805306368 & a;
  if (0 !== b) return F = 2, b;
  if (0 !== (1073741824 & a)) return F = 1, 1073741824;
  F = 8;
  return a;
}
function Sc(a) {
  switch (a) {
    case 99:
      return 15;
    case 98:
      return 10;
    case 97:
    case 96:
      return 8;
    case 95:
      return 2;
    default:
      return 0;
  }
}
function Tc(a) {
  switch (a) {
    case 15:
    case 14:
      return 99;
    case 13:
    case 12:
    case 11:
    case 10:
      return 98;
    case 9:
    case 8:
    case 7:
    case 6:
    case 4:
    case 5:
      return 97;
    case 3:
    case 2:
    case 1:
      return 95;
    case 0:
      return 90;
    default:
      throw Error(y(358, a));
  }
}
function Uc(a, b) {
  var c = a.pendingLanes;
  if (0 === c) return F = 0;
  var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
  if (0 !== f) d = f, e = F = 15;
  else if (f = c & 134217727, 0 !== f) {
    var k = f & ~g;
    0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
  } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
  if (0 === d) return 0;
  d = 31 - Vc(d);
  d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
  if (0 !== b && b !== d && 0 === (b & g)) {
    Rc(b);
    if (e <= F) return b;
    F = e;
  }
  b = a.entangledLanes;
  if (0 !== b) for (a = a.entanglements, b &= d; 0 < b; ) c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
  return d;
}
function Wc(a) {
  a = a.pendingLanes & -1073741825;
  return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
  switch (a) {
    case 15:
      return 1;
    case 14:
      return 2;
    case 12:
      return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
    case 10:
      return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
    case 8:
      return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
    case 2:
      return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
  }
  throw Error(y(358, a));
}
function Yc(a) {
  return a & -a;
}
function Zc(a) {
  for (var b = [], c = 0; 31 > c; c++) b.push(a);
  return b;
}
function $c(a, b, c) {
  a.pendingLanes |= b;
  var d = b - 1;
  a.suspendedLanes &= d;
  a.pingedLanes &= d;
  a = a.eventTimes;
  b = 31 - Vc(b);
  a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
  return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = r.unstable_UserBlockingPriority, ed = r.unstable_runWithPriority, fd = true;
function gd(a, b, c, d) {
  Kb || Ib();
  var e = hd, f = Kb;
  Kb = true;
  try {
    Hb(e, a, b, c, d);
  } finally {
    (Kb = f) || Mb();
  }
}
function id(a, b, c, d) {
  ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
  if (fd) {
    var e;
    if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
    else {
      var f = yc(a, b, c, d);
      if (null === f) e && sc(a, d);
      else {
        if (e) {
          if (-1 < qc.indexOf(a)) {
            a = rc(f, a, b, c, d);
            jc.push(a);
            return;
          }
          if (uc(f, a, b, c, d)) return;
          sc(a, d);
        }
        jd(a, b, d, null, c);
      }
    }
  }
}
function yc(a, b, c, d) {
  var e = xb(d);
  e = wc(e);
  if (null !== e) {
    var f = Zb(e);
    if (null === f) e = null;
    else {
      var g = f.tag;
      if (13 === g) {
        e = $b(f);
        if (null !== e) return e;
        e = null;
      } else if (3 === g) {
        if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
        e = null;
      } else f !== e && (e = null);
    }
  }
  jd(a, b, d, e, c);
  return null;
}
var kd = null, ld = null, md = null;
function nd() {
  if (md) return md;
  var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
  for (a = 0; a < c && b[a] === e[a]; a++) ;
  var g = c - a;
  for (d = 1; d <= g && b[c - d] === e[f - d]; d++) ;
  return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
  var b = a.keyCode;
  "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
  10 === a && (a = 13);
  return 32 <= a || 13 === a ? a : 0;
}
function pd() {
  return true;
}
function qd() {
  return false;
}
function rd(a) {
  function b(b2, d, e, f, g) {
    this._reactName = b2;
    this._targetInst = e;
    this.type = d;
    this.nativeEvent = f;
    this.target = g;
    this.currentTarget = null;
    for (var c in a) a.hasOwnProperty(c) && (b2 = a[c], this[c] = b2 ? b2(f) : f[c]);
    this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : false === f.returnValue) ? pd : qd;
    this.isPropagationStopped = qd;
    return this;
  }
  m(b.prototype, { preventDefault: function() {
    this.defaultPrevented = true;
    var a2 = this.nativeEvent;
    a2 && (a2.preventDefault ? a2.preventDefault() : "unknown" !== typeof a2.returnValue && (a2.returnValue = false), this.isDefaultPrevented = pd);
  }, stopPropagation: function() {
    var a2 = this.nativeEvent;
    a2 && (a2.stopPropagation ? a2.stopPropagation() : "unknown" !== typeof a2.cancelBubble && (a2.cancelBubble = true), this.isPropagationStopped = pd);
  }, persist: function() {
  }, isPersistent: pd });
  return b;
}
var sd = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(a) {
  return a.timeStamp || Date.now();
}, defaultPrevented: 0, isTrusted: 0 }, td = rd(sd), ud = m({}, sd, { view: 0, detail: 0 }), vd = rd(ud), wd, xd, yd, Ad = m({}, ud, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: zd, button: 0, buttons: 0, relatedTarget: function(a) {
  return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
}, movementX: function(a) {
  if ("movementX" in a) return a.movementX;
  a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
  return wd;
}, movementY: function(a) {
  return "movementY" in a ? a.movementY : xd;
} }), Bd = rd(Ad), Cd = m({}, Ad, { dataTransfer: 0 }), Dd = rd(Cd), Ed = m({}, ud, { relatedTarget: 0 }), Fd = rd(Ed), Gd = m({}, sd, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Hd = rd(Gd), Id = m({}, sd, { clipboardData: function(a) {
  return "clipboardData" in a ? a.clipboardData : window.clipboardData;
} }), Jd = rd(Id), Kd = m({}, sd, { data: 0 }), Ld = rd(Kd), Md = {
  Esc: "Escape",
  Spacebar: " ",
  Left: "ArrowLeft",
  Up: "ArrowUp",
  Right: "ArrowRight",
  Down: "ArrowDown",
  Del: "Delete",
  Win: "OS",
  Menu: "ContextMenu",
  Apps: "ContextMenu",
  Scroll: "ScrollLock",
  MozPrintableKey: "Unidentified"
}, Nd = {
  8: "Backspace",
  9: "Tab",
  12: "Clear",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  19: "Pause",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  45: "Insert",
  46: "Delete",
  112: "F1",
  113: "F2",
  114: "F3",
  115: "F4",
  116: "F5",
  117: "F6",
  118: "F7",
  119: "F8",
  120: "F9",
  121: "F10",
  122: "F11",
  123: "F12",
  144: "NumLock",
  145: "ScrollLock",
  224: "Meta"
}, Od = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
function Pd(a) {
  var b = this.nativeEvent;
  return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : false;
}
function zd() {
  return Pd;
}
var Qd = m({}, ud, { key: function(a) {
  if (a.key) {
    var b = Md[a.key] || a.key;
    if ("Unidentified" !== b) return b;
  }
  return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
}, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: zd, charCode: function(a) {
  return "keypress" === a.type ? od(a) : 0;
}, keyCode: function(a) {
  return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
}, which: function(a) {
  return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
} }), Rd = rd(Qd), Sd = m({}, Ad, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), Td = rd(Sd), Ud = m({}, ud, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: zd }), Vd = rd(Ud), Wd = m({}, sd, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), Xd = rd(Wd), Yd = m({}, Ad, {
  deltaX: function(a) {
    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
  },
  deltaY: function(a) {
    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
  },
  deltaZ: 0,
  deltaMode: 0
}), Zd = rd(Yd), $d = [9, 13, 27, 32], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = false;
function ge(a, b) {
  switch (a) {
    case "keyup":
      return -1 !== $d.indexOf(b.keyCode);
    case "keydown":
      return 229 !== b.keyCode;
    case "keypress":
    case "mousedown":
    case "focusout":
      return true;
    default:
      return false;
  }
}
function he(a) {
  a = a.detail;
  return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = false;
function je(a, b) {
  switch (a) {
    case "compositionend":
      return he(b);
    case "keypress":
      if (32 !== b.which) return null;
      fe = true;
      return ee;
    case "textInput":
      return a = b.data, a === ee && fe ? null : a;
    default:
      return null;
  }
}
function ke(a, b) {
  if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = false, a) : null;
  switch (a) {
    case "paste":
      return null;
    case "keypress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b.char && 1 < b.char.length) return b.char;
        if (b.which) return String.fromCharCode(b.which);
      }
      return null;
    case "compositionend":
      return de && "ko" !== b.locale ? null : b.data;
    default:
      return null;
  }
}
var le = { color: true, date: true, datetime: true, "datetime-local": true, email: true, month: true, number: true, password: true, range: true, search: true, tel: true, text: true, time: true, url: true, week: true };
function me(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return "input" === b ? !!le[a.type] : "textarea" === b ? true : false;
}
function ne(a, b, c, d) {
  Eb(d);
  b = oe(b, "onChange");
  0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({ event: c, listeners: b }));
}
var pe = null, qe = null;
function re(a) {
  se(a, 0);
}
function te(a) {
  var b = ue(a);
  if (Wa(b)) return a;
}
function ve(a, b) {
  if ("change" === a) return b;
}
var we = false;
if (fa) {
  var xe;
  if (fa) {
    var ye = "oninput" in document;
    if (!ye) {
      var ze = document.createElement("div");
      ze.setAttribute("oninput", "return;");
      ye = "function" === typeof ze.oninput;
    }
    xe = ye;
  } else xe = false;
  we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
  pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
  if ("value" === a.propertyName && te(qe)) {
    var b = [];
    ne(b, qe, a, xb(a));
    a = re;
    if (Kb) a(b);
    else {
      Kb = true;
      try {
        Gb(a, b);
      } finally {
        Kb = false, Mb();
      }
    }
  }
}
function Ce(a, b, c) {
  "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
  if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
  if ("click" === a) return te(b);
}
function Fe(a, b) {
  if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
  return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
  if (He(a, b)) return true;
  if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return false;
  var c = Object.keys(a), d = Object.keys(b);
  if (c.length !== d.length) return false;
  for (d = 0; d < c.length; d++) if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return false;
  return true;
}
function Ke(a) {
  for (; a && a.firstChild; ) a = a.firstChild;
  return a;
}
function Le(a, b) {
  var c = Ke(a);
  a = 0;
  for (var d; c; ) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;
      if (a <= b && d >= b) return { node: c, offset: b - a };
      a = d;
    }
    a: {
      for (; c; ) {
        if (c.nextSibling) {
          c = c.nextSibling;
          break a;
        }
        c = c.parentNode;
      }
      c = void 0;
    }
    c = Ke(c);
  }
}
function Me(a, b) {
  return a && b ? a === b ? true : a && 3 === a.nodeType ? false : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : false : false;
}
function Ne() {
  for (var a = window, b = Xa(); b instanceof a.HTMLIFrameElement; ) {
    try {
      var c = "string" === typeof b.contentWindow.location.href;
    } catch (d) {
      c = false;
    }
    if (c) a = b.contentWindow;
    else break;
    b = Xa(a.document);
  }
  return b;
}
function Oe(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();
  return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = false;
function Ue(a, b, c) {
  var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
  Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = { start: d.selectionStart, end: d.selectionEnd } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = { anchorNode: d.anchorNode, anchorOffset: d.anchorOffset, focusNode: d.focusNode, focusOffset: d.focusOffset }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({ event: b, listeners: d }), b.target = Qe)));
}
Pc(
  "cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
  0
);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for (var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++) Nc.set(Ve[We], 0);
ea("onMouseEnter", ["mouseout", "mouseover"]);
ea("onMouseLeave", ["mouseout", "mouseover"]);
ea("onPointerEnter", ["pointerout", "pointerover"]);
ea("onPointerLeave", ["pointerout", "pointerover"]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
  var d = a.type || "unknown-event";
  a.currentTarget = c;
  Yb(d, b, void 0, a);
  a.currentTarget = null;
}
function se(a, b) {
  b = 0 !== (b & 4);
  for (var c = 0; c < a.length; c++) {
    var d = a[c], e = d.event;
    d = d.listeners;
    a: {
      var f = void 0;
      if (b) for (var g = d.length - 1; 0 <= g; g--) {
        var h = d[g], k = h.instance, l = h.currentTarget;
        h = h.listener;
        if (k !== f && e.isPropagationStopped()) break a;
        Ze(e, h, l);
        f = k;
      }
      else for (g = 0; g < d.length; g++) {
        h = d[g];
        k = h.instance;
        l = h.currentTarget;
        h = h.listener;
        if (k !== f && e.isPropagationStopped()) break a;
        Ze(e, h, l);
        f = k;
      }
    }
  }
  if (Ub) throw a = Vb, Ub = false, Vb = null, a;
}
function G(a, b) {
  var c = $e(b), d = a + "__bubble";
  c.has(d) || (af(b, a, 2, false), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
  a[bf] || (a[bf] = true, ba.forEach(function(b) {
    Ye.has(b) || df(b, false, a, null);
    df(b, true, a, null);
  }));
}
function df(a, b, c, d) {
  var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
  "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
  if (null !== d && !b && Ye.has(a)) {
    if ("scroll" !== a) return;
    e |= 2;
    f = d;
  }
  var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
  g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
  var e = Nc.get(b);
  switch (void 0 === e ? 2 : e) {
    case 0:
      e = gd;
      break;
    case 1:
      e = id;
      break;
    default:
      e = hd;
  }
  c = e.bind(null, b, c, a);
  e = void 0;
  !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = true);
  d ? void 0 !== e ? a.addEventListener(b, c, { capture: true, passive: e }) : a.addEventListener(b, c, true) : void 0 !== e ? a.addEventListener(b, c, { passive: e }) : a.addEventListener(b, c, false);
}
function jd(a, b, c, d, e) {
  var f = d;
  if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for (; ; ) {
    if (null === d) return;
    var g = d.tag;
    if (3 === g || 4 === g) {
      var h = d.stateNode.containerInfo;
      if (h === e || 8 === h.nodeType && h.parentNode === e) break;
      if (4 === g) for (g = d.return; null !== g; ) {
        var k = g.tag;
        if (3 === k || 4 === k) {
          if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
        }
        g = g.return;
      }
      for (; null !== h; ) {
        g = wc(h);
        if (null === g) return;
        k = g.tag;
        if (5 === k || 6 === k) {
          d = f = g;
          continue a;
        }
        h = h.parentNode;
      }
    }
    d = d.return;
  }
  Nb(function() {
    var d2 = f, e2 = xb(c), g2 = [];
    a: {
      var h2 = Mc.get(a);
      if (void 0 !== h2) {
        var k2 = td, x = a;
        switch (a) {
          case "keypress":
            if (0 === od(c)) break a;
          case "keydown":
          case "keyup":
            k2 = Rd;
            break;
          case "focusin":
            x = "focus";
            k2 = Fd;
            break;
          case "focusout":
            x = "blur";
            k2 = Fd;
            break;
          case "beforeblur":
          case "afterblur":
            k2 = Fd;
            break;
          case "click":
            if (2 === c.button) break a;
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            k2 = Bd;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            k2 = Dd;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            k2 = Vd;
            break;
          case Ic:
          case Jc:
          case Kc:
            k2 = Hd;
            break;
          case Lc:
            k2 = Xd;
            break;
          case "scroll":
            k2 = vd;
            break;
          case "wheel":
            k2 = Zd;
            break;
          case "copy":
          case "cut":
          case "paste":
            k2 = Jd;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            k2 = Td;
        }
        var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h2 ? h2 + "Capture" : null : h2;
        w = [];
        for (var t = d2, q; null !== t; ) {
          q = t;
          var v = q.stateNode;
          5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
          if (z) break;
          t = t.return;
        }
        0 < w.length && (h2 = new k2(h2, x, null, c, e2), g2.push({ event: h2, listeners: w }));
      }
    }
    if (0 === (b & 7)) {
      a: {
        h2 = "mouseover" === a || "pointerover" === a;
        k2 = "mouseout" === a || "pointerout" === a;
        if (h2 && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
        if (k2 || h2) {
          h2 = e2.window === e2 ? e2 : (h2 = e2.ownerDocument) ? h2.defaultView || h2.parentWindow : window;
          if (k2) {
            if (x = c.relatedTarget || c.toElement, k2 = d2, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
          } else k2 = null, x = d2;
          if (k2 !== x) {
            w = Bd;
            v = "onMouseLeave";
            u = "onMouseEnter";
            t = "mouse";
            if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
            z = null == k2 ? h2 : ue(k2);
            q = null == x ? h2 : ue(x);
            h2 = new w(v, t + "leave", k2, c, e2);
            h2.target = z;
            h2.relatedTarget = q;
            v = null;
            wc(e2) === d2 && (w = new w(u, t + "enter", x, c, e2), w.target = q, w.relatedTarget = z, v = w);
            z = v;
            if (k2 && x) b: {
              w = k2;
              u = x;
              t = 0;
              for (q = w; q; q = gf(q)) t++;
              q = 0;
              for (v = u; v; v = gf(v)) q++;
              for (; 0 < t - q; ) w = gf(w), t--;
              for (; 0 < q - t; ) u = gf(u), q--;
              for (; t--; ) {
                if (w === u || null !== u && w === u.alternate) break b;
                w = gf(w);
                u = gf(u);
              }
              w = null;
            }
            else w = null;
            null !== k2 && hf(g2, h2, k2, w, false);
            null !== x && null !== z && hf(g2, z, x, w, true);
          }
        }
      }
      a: {
        h2 = d2 ? ue(d2) : window;
        k2 = h2.nodeName && h2.nodeName.toLowerCase();
        if ("select" === k2 || "input" === k2 && "file" === h2.type) var J = ve;
        else if (me(h2)) if (we) J = Fe;
        else {
          J = De;
          var K = Ce;
        }
        else (k2 = h2.nodeName) && "input" === k2.toLowerCase() && ("checkbox" === h2.type || "radio" === h2.type) && (J = Ee);
        if (J && (J = J(a, d2))) {
          ne(g2, J, c, e2);
          break a;
        }
        K && K(a, h2, d2);
        "focusout" === a && (K = h2._wrapperState) && K.controlled && "number" === h2.type && bb(h2, "number", h2.value);
      }
      K = d2 ? ue(d2) : window;
      switch (a) {
        case "focusin":
          if (me(K) || "true" === K.contentEditable) Qe = K, Re = d2, Se = null;
          break;
        case "focusout":
          Se = Re = Qe = null;
          break;
        case "mousedown":
          Te = true;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          Te = false;
          Ue(g2, c, e2);
          break;
        case "selectionchange":
          if (Pe) break;
        case "keydown":
        case "keyup":
          Ue(g2, c, e2);
      }
      var Q;
      if (ae) b: {
        switch (a) {
          case "compositionstart":
            var L = "onCompositionStart";
            break b;
          case "compositionend":
            L = "onCompositionEnd";
            break b;
          case "compositionupdate":
            L = "onCompositionUpdate";
            break b;
        }
        L = void 0;
      }
      else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
      L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e2, ld = "value" in kd ? kd.value : kd.textContent, ie = true)), K = oe(d2, L), 0 < K.length && (L = new Ld(L, a, null, c, e2), g2.push({ event: L, listeners: K }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
      if (Q = ce ? je(a, c) : ke(a, c)) d2 = oe(d2, "onBeforeInput"), 0 < d2.length && (e2 = new Ld(
        "onBeforeInput",
        "beforeinput",
        null,
        c,
        e2
      ), g2.push({ event: e2, listeners: d2 }), e2.data = Q);
    }
    se(g2, b);
  });
}
function ef(a, b, c) {
  return { instance: a, listener: b, currentTarget: c };
}
function oe(a, b) {
  for (var c = b + "Capture", d = []; null !== a; ) {
    var e = a, f = e.stateNode;
    5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
    a = a.return;
  }
  return d;
}
function gf(a) {
  if (null === a) return null;
  do
    a = a.return;
  while (a && 5 !== a.tag);
  return a ? a : null;
}
function hf(a, b, c, d, e) {
  for (var f = b._reactName, g = []; null !== c && c !== d; ) {
    var h = c, k = h.alternate, l = h.stateNode;
    if (null !== k && k === d) break;
    5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
    c = c.return;
  }
  0 !== g.length && a.push({ event: b, listeners: g });
}
function jf() {
}
var kf = null, lf = null;
function mf(a, b) {
  switch (a) {
    case "button":
    case "input":
    case "select":
    case "textarea":
      return !!b.autoFocus;
  }
  return false;
}
function nf(a, b) {
  return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
  1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
  for (; null != a; a = a.nextSibling) {
    var b = a.nodeType;
    if (1 === b || 3 === b) break;
  }
  return a;
}
function sf(a) {
  a = a.previousSibling;
  for (var b = 0; a; ) {
    if (8 === a.nodeType) {
      var c = a.data;
      if ("$" === c || "$!" === c || "$?" === c) {
        if (0 === b) return a;
        b--;
      } else "/$" === c && b++;
    }
    a = a.previousSibling;
  }
  return null;
}
var tf = 0;
function uf(a) {
  return { $$typeof: Ga, toString: a, valueOf: a };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
  var b = a[wf];
  if (b) return b;
  for (var c = a.parentNode; c; ) {
    if (b = c[ff] || c[wf]) {
      c = b.alternate;
      if (null !== b.child || null !== c && null !== c.child) for (a = sf(a); null !== a; ) {
        if (c = a[wf]) return c;
        a = sf(a);
      }
      return b;
    }
    a = c;
    c = a.parentNode;
  }
  return null;
}
function Cb(a) {
  a = a[wf] || a[ff];
  return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;
  throw Error(y(33));
}
function Db(a) {
  return a[xf] || null;
}
function $e(a) {
  var b = a[yf];
  void 0 === b && (b = a[yf] = /* @__PURE__ */ new Set());
  return b;
}
var zf = [], Af = -1;
function Bf(a) {
  return { current: a };
}
function H(a) {
  0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
  Af++;
  zf[Af] = a.current;
  a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(false), Df = Cf;
function Ef(a, b) {
  var c = a.type.contextTypes;
  if (!c) return Cf;
  var d = a.stateNode;
  if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
  var e = {}, f;
  for (f in c) e[f] = b[f];
  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
  return e;
}
function Ff(a) {
  a = a.childContextTypes;
  return null !== a && void 0 !== a;
}
function Gf() {
  H(N);
  H(M);
}
function Hf(a, b, c) {
  if (M.current !== Cf) throw Error(y(168));
  I(M, b);
  I(N, c);
}
function If(a, b, c) {
  var d = a.stateNode;
  a = b.childContextTypes;
  if ("function" !== typeof d.getChildContext) return c;
  d = d.getChildContext();
  for (var e in d) if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
  return m({}, c, d);
}
function Jf(a) {
  a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
  Df = M.current;
  I(M, a);
  I(N, N.current);
  return true;
}
function Kf(a, b, c) {
  var d = a.stateNode;
  if (!d) throw Error(y(169));
  c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
  I(N, c);
}
var Lf = null, Mf = null, Nf = r.unstable_runWithPriority, Of = r.unstable_scheduleCallback, Pf = r.unstable_cancelCallback, Qf = r.unstable_shouldYield, Rf = r.unstable_requestPaint, Sf = r.unstable_now, Tf = r.unstable_getCurrentPriorityLevel, Uf = r.unstable_ImmediatePriority, Vf = r.unstable_UserBlockingPriority, Wf = r.unstable_NormalPriority, Xf = r.unstable_LowPriority, Yf = r.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {
}, ag = null, bg = null, cg = false, dg = Sf(), O = 1e4 > dg ? Sf : function() {
  return Sf() - dg;
};
function eg() {
  switch (Tf()) {
    case Uf:
      return 99;
    case Vf:
      return 98;
    case Wf:
      return 97;
    case Xf:
      return 96;
    case Yf:
      return 95;
    default:
      throw Error(y(332));
  }
}
function fg(a) {
  switch (a) {
    case 99:
      return Uf;
    case 98:
      return Vf;
    case 97:
      return Wf;
    case 96:
      return Xf;
    case 95:
      return Yf;
    default:
      throw Error(y(332));
  }
}
function gg(a, b) {
  a = fg(a);
  return Nf(a, b);
}
function hg(a, b, c) {
  a = fg(a);
  return Of(a, b, c);
}
function ig() {
  if (null !== bg) {
    var a = bg;
    bg = null;
    Pf(a);
  }
  jg();
}
function jg() {
  if (!cg && null !== ag) {
    cg = true;
    var a = 0;
    try {
      var b = ag;
      gg(99, function() {
        for (; a < b.length; a++) {
          var c = b[a];
          do
            c = c(true);
          while (null !== c);
        }
      });
      ag = null;
    } catch (c) {
      throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
    } finally {
      cg = false;
    }
  }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
  if (a && a.defaultProps) {
    b = m({}, b);
    a = a.defaultProps;
    for (var c in a) void 0 === b[c] && (b[c] = a[c]);
    return b;
  }
  return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
  pg = og = ng = null;
}
function rg(a) {
  var b = mg.current;
  H(mg);
  a.type._context._currentValue = b;
}
function sg(a, b) {
  for (; null !== a; ) {
    var c = a.alternate;
    if ((a.childLanes & b) === b) if (null === c || (c.childLanes & b) === b) break;
    else c.childLanes |= b;
    else a.childLanes |= b, null !== c && (c.childLanes |= b);
    a = a.return;
  }
}
function tg(a, b) {
  ng = a;
  pg = og = null;
  a = a.dependencies;
  null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = true), a.firstContext = null);
}
function vg(a, b) {
  if (pg !== a && false !== b && 0 !== b) {
    if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
    b = { context: a, observedBits: b, next: null };
    if (null === og) {
      if (null === ng) throw Error(y(308));
      og = b;
      ng.dependencies = { lanes: 0, firstContext: b, responders: null };
    } else og = og.next = b;
  }
  return a._currentValue;
}
var wg = false;
function xg(a) {
  a.updateQueue = { baseState: a.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null }, effects: null };
}
function yg(a, b) {
  a = a.updateQueue;
  b.updateQueue === a && (b.updateQueue = { baseState: a.baseState, firstBaseUpdate: a.firstBaseUpdate, lastBaseUpdate: a.lastBaseUpdate, shared: a.shared, effects: a.effects });
}
function zg(a, b) {
  return { eventTime: a, lane: b, tag: 0, payload: null, callback: null, next: null };
}
function Ag(a, b) {
  a = a.updateQueue;
  if (null !== a) {
    a = a.shared;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
  }
}
function Bg(a, b) {
  var c = a.updateQueue, d = a.alternate;
  if (null !== d && (d = d.updateQueue, c === d)) {
    var e = null, f = null;
    c = c.firstBaseUpdate;
    if (null !== c) {
      do {
        var g = { eventTime: c.eventTime, lane: c.lane, tag: c.tag, payload: c.payload, callback: c.callback, next: null };
        null === f ? e = f = g : f = f.next = g;
        c = c.next;
      } while (null !== c);
      null === f ? e = f = b : f = f.next = b;
    } else e = f = b;
    c = { baseState: d.baseState, firstBaseUpdate: e, lastBaseUpdate: f, shared: d.shared, effects: d.effects };
    a.updateQueue = c;
    return;
  }
  a = c.lastBaseUpdate;
  null === a ? c.firstBaseUpdate = b : a.next = b;
  c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
  var e = a.updateQueue;
  wg = false;
  var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
  if (null !== h) {
    e.shared.pending = null;
    var k = h, l = k.next;
    k.next = null;
    null === g ? f = l : g.next = l;
    g = k;
    var n = a.alternate;
    if (null !== n) {
      n = n.updateQueue;
      var A = n.lastBaseUpdate;
      A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
    }
  }
  if (null !== f) {
    A = e.baseState;
    g = 0;
    n = l = k = null;
    do {
      h = f.lane;
      var p = f.eventTime;
      if ((d & h) === h) {
        null !== n && (n = n.next = {
          eventTime: p,
          lane: 0,
          tag: f.tag,
          payload: f.payload,
          callback: f.callback,
          next: null
        });
        a: {
          var C = a, x = f;
          h = b;
          p = c;
          switch (x.tag) {
            case 1:
              C = x.payload;
              if ("function" === typeof C) {
                A = C.call(p, A, h);
                break a;
              }
              A = C;
              break a;
            case 3:
              C.flags = C.flags & -4097 | 64;
            case 0:
              C = x.payload;
              h = "function" === typeof C ? C.call(p, A, h) : C;
              if (null === h || void 0 === h) break a;
              A = m({}, A, h);
              break a;
            case 2:
              wg = true;
          }
        }
        null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [f] : h.push(f));
      } else p = { eventTime: p, lane: h, tag: f.tag, payload: f.payload, callback: f.callback, next: null }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
      f = f.next;
      if (null === f) if (h = e.shared.pending, null === h) break;
      else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
    } while (1);
    null === n && (k = A);
    e.baseState = k;
    e.firstBaseUpdate = l;
    e.lastBaseUpdate = n;
    Dg |= g;
    a.lanes = g;
    a.memoizedState = A;
  }
}
function Eg(a, b, c) {
  a = b.effects;
  b.effects = null;
  if (null !== a) for (b = 0; b < a.length; b++) {
    var d = a[b], e = d.callback;
    if (null !== e) {
      d.callback = null;
      d = c;
      if ("function" !== typeof e) throw Error(y(191, e));
      e.call(d);
    }
  }
}
var Fg = new aa.Component().refs;
function Gg(a, b, c, d) {
  b = a.memoizedState;
  c = c(d, b);
  c = null === c || void 0 === c ? b : m({}, b, c);
  a.memoizedState = c;
  0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = { isMounted: function(a) {
  return (a = a._reactInternals) ? Zb(a) === a : false;
}, enqueueSetState: function(a, b, c) {
  a = a._reactInternals;
  var d = Hg(), e = Ig(a), f = zg(d, e);
  f.payload = b;
  void 0 !== c && null !== c && (f.callback = c);
  Ag(a, f);
  Jg(a, e, d);
}, enqueueReplaceState: function(a, b, c) {
  a = a._reactInternals;
  var d = Hg(), e = Ig(a), f = zg(d, e);
  f.tag = 1;
  f.payload = b;
  void 0 !== c && null !== c && (f.callback = c);
  Ag(a, f);
  Jg(a, e, d);
}, enqueueForceUpdate: function(a, b) {
  a = a._reactInternals;
  var c = Hg(), d = Ig(a), e = zg(c, d);
  e.tag = 2;
  void 0 !== b && null !== b && (e.callback = b);
  Ag(a, e);
  Jg(a, d, c);
} };
function Lg(a, b, c, d, e, f, g) {
  a = a.stateNode;
  return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : true;
}
function Mg(a, b, c) {
  var d = false, e = Cf;
  var f = b.contextType;
  "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
  b = new b(c, f);
  a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
  b.updater = Kg;
  a.stateNode = b;
  b._reactInternals = a;
  d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
  return b;
}
function Ng(a, b, c, d) {
  a = b.state;
  "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
  "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
  b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
  var e = a.stateNode;
  e.props = c;
  e.state = a.memoizedState;
  e.refs = Fg;
  xg(a);
  var f = b.contextType;
  "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
  Cg(a, c, e, d);
  e.state = a.memoizedState;
  f = b.getDerivedStateFromProps;
  "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
  "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
  "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
  a = c.ref;
  if (null !== a && "function" !== typeof a && "object" !== typeof a) {
    if (c._owner) {
      c = c._owner;
      if (c) {
        if (1 !== c.tag) throw Error(y(309));
        var d = c.stateNode;
      }
      if (!d) throw Error(y(147, a));
      var e = "" + a;
      if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
      b = function(a2) {
        var b2 = d.refs;
        b2 === Fg && (b2 = d.refs = {});
        null === a2 ? delete b2[e] : b2[e] = a2;
      };
      b._stringRef = e;
      return b;
    }
    if ("string" !== typeof a) throw Error(y(284));
    if (!c._owner) throw Error(y(290, a));
  }
  return a;
}
function Rg(a, b) {
  if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
  function b(b2, c2) {
    if (a) {
      var d2 = b2.lastEffect;
      null !== d2 ? (d2.nextEffect = c2, b2.lastEffect = c2) : b2.firstEffect = b2.lastEffect = c2;
      c2.nextEffect = null;
      c2.flags = 8;
    }
  }
  function c(c2, d2) {
    if (!a) return null;
    for (; null !== d2; ) b(c2, d2), d2 = d2.sibling;
    return null;
  }
  function d(a2, b2) {
    for (a2 = /* @__PURE__ */ new Map(); null !== b2; ) null !== b2.key ? a2.set(b2.key, b2) : a2.set(b2.index, b2), b2 = b2.sibling;
    return a2;
  }
  function e(a2, b2) {
    a2 = Tg(a2, b2);
    a2.index = 0;
    a2.sibling = null;
    return a2;
  }
  function f(b2, c2, d2) {
    b2.index = d2;
    if (!a) return c2;
    d2 = b2.alternate;
    if (null !== d2) return d2 = d2.index, d2 < c2 ? (b2.flags = 2, c2) : d2;
    b2.flags = 2;
    return c2;
  }
  function g(b2) {
    a && null === b2.alternate && (b2.flags = 2);
    return b2;
  }
  function h(a2, b2, c2, d2) {
    if (null === b2 || 6 !== b2.tag) return b2 = Ug(c2, a2.mode, d2), b2.return = a2, b2;
    b2 = e(b2, c2);
    b2.return = a2;
    return b2;
  }
  function k(a2, b2, c2, d2) {
    if (null !== b2 && b2.elementType === c2.type) return d2 = e(b2, c2.props), d2.ref = Qg(a2, b2, c2), d2.return = a2, d2;
    d2 = Vg(c2.type, c2.key, c2.props, null, a2.mode, d2);
    d2.ref = Qg(a2, b2, c2);
    d2.return = a2;
    return d2;
  }
  function l(a2, b2, c2, d2) {
    if (null === b2 || 4 !== b2.tag || b2.stateNode.containerInfo !== c2.containerInfo || b2.stateNode.implementation !== c2.implementation) return b2 = Wg(c2, a2.mode, d2), b2.return = a2, b2;
    b2 = e(b2, c2.children || []);
    b2.return = a2;
    return b2;
  }
  function n(a2, b2, c2, d2, f2) {
    if (null === b2 || 7 !== b2.tag) return b2 = Xg(c2, a2.mode, d2, f2), b2.return = a2, b2;
    b2 = e(b2, c2);
    b2.return = a2;
    return b2;
  }
  function A(a2, b2, c2) {
    if ("string" === typeof b2 || "number" === typeof b2) return b2 = Ug("" + b2, a2.mode, c2), b2.return = a2, b2;
    if ("object" === typeof b2 && null !== b2) {
      switch (b2.$$typeof) {
        case sa:
          return c2 = Vg(b2.type, b2.key, b2.props, null, a2.mode, c2), c2.ref = Qg(a2, null, b2), c2.return = a2, c2;
        case ta:
          return b2 = Wg(b2, a2.mode, c2), b2.return = a2, b2;
      }
      if (Pg(b2) || La(b2)) return b2 = Xg(
        b2,
        a2.mode,
        c2,
        null
      ), b2.return = a2, b2;
      Rg(a2, b2);
    }
    return null;
  }
  function p(a2, b2, c2, d2) {
    var e2 = null !== b2 ? b2.key : null;
    if ("string" === typeof c2 || "number" === typeof c2) return null !== e2 ? null : h(a2, b2, "" + c2, d2);
    if ("object" === typeof c2 && null !== c2) {
      switch (c2.$$typeof) {
        case sa:
          return c2.key === e2 ? c2.type === ua ? n(a2, b2, c2.props.children, d2, e2) : k(a2, b2, c2, d2) : null;
        case ta:
          return c2.key === e2 ? l(a2, b2, c2, d2) : null;
      }
      if (Pg(c2) || La(c2)) return null !== e2 ? null : n(a2, b2, c2, d2, null);
      Rg(a2, c2);
    }
    return null;
  }
  function C(a2, b2, c2, d2, e2) {
    if ("string" === typeof d2 || "number" === typeof d2) return a2 = a2.get(c2) || null, h(b2, a2, "" + d2, e2);
    if ("object" === typeof d2 && null !== d2) {
      switch (d2.$$typeof) {
        case sa:
          return a2 = a2.get(null === d2.key ? c2 : d2.key) || null, d2.type === ua ? n(b2, a2, d2.props.children, e2, d2.key) : k(b2, a2, d2, e2);
        case ta:
          return a2 = a2.get(null === d2.key ? c2 : d2.key) || null, l(b2, a2, d2, e2);
      }
      if (Pg(d2) || La(d2)) return a2 = a2.get(c2) || null, n(b2, a2, d2, e2, null);
      Rg(b2, d2);
    }
    return null;
  }
  function x(e2, g2, h2, k2) {
    for (var l2 = null, t = null, u = g2, z = g2 = 0, q = null; null !== u && z < h2.length; z++) {
      u.index > z ? (q = u, u = null) : q = u.sibling;
      var n2 = p(e2, u, h2[z], k2);
      if (null === n2) {
        null === u && (u = q);
        break;
      }
      a && u && null === n2.alternate && b(e2, u);
      g2 = f(n2, g2, z);
      null === t ? l2 = n2 : t.sibling = n2;
      t = n2;
      u = q;
    }
    if (z === h2.length) return c(e2, u), l2;
    if (null === u) {
      for (; z < h2.length; z++) u = A(e2, h2[z], k2), null !== u && (g2 = f(u, g2, z), null === t ? l2 = u : t.sibling = u, t = u);
      return l2;
    }
    for (u = d(e2, u); z < h2.length; z++) q = C(u, e2, z, h2[z], k2), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g2 = f(q, g2, z), null === t ? l2 = q : t.sibling = q, t = q);
    a && u.forEach(function(a2) {
      return b(e2, a2);
    });
    return l2;
  }
  function w(e2, g2, h2, k2) {
    var l2 = La(h2);
    if ("function" !== typeof l2) throw Error(y(150));
    h2 = l2.call(h2);
    if (null == h2) throw Error(y(151));
    for (var t = l2 = null, u = g2, z = g2 = 0, q = null, n2 = h2.next(); null !== u && !n2.done; z++, n2 = h2.next()) {
      u.index > z ? (q = u, u = null) : q = u.sibling;
      var w2 = p(e2, u, n2.value, k2);
      if (null === w2) {
        null === u && (u = q);
        break;
      }
      a && u && null === w2.alternate && b(e2, u);
      g2 = f(w2, g2, z);
      null === t ? l2 = w2 : t.sibling = w2;
      t = w2;
      u = q;
    }
    if (n2.done) return c(e2, u), l2;
    if (null === u) {
      for (; !n2.done; z++, n2 = h2.next()) n2 = A(e2, n2.value, k2), null !== n2 && (g2 = f(n2, g2, z), null === t ? l2 = n2 : t.sibling = n2, t = n2);
      return l2;
    }
    for (u = d(e2, u); !n2.done; z++, n2 = h2.next()) n2 = C(u, e2, z, n2.value, k2), null !== n2 && (a && null !== n2.alternate && u.delete(null === n2.key ? z : n2.key), g2 = f(n2, g2, z), null === t ? l2 = n2 : t.sibling = n2, t = n2);
    a && u.forEach(function(a2) {
      return b(e2, a2);
    });
    return l2;
  }
  return function(a2, d2, f2, h2) {
    var k2 = "object" === typeof f2 && null !== f2 && f2.type === ua && null === f2.key;
    k2 && (f2 = f2.props.children);
    var l2 = "object" === typeof f2 && null !== f2;
    if (l2) switch (f2.$$typeof) {
      case sa:
        a: {
          l2 = f2.key;
          for (k2 = d2; null !== k2; ) {
            if (k2.key === l2) {
              switch (k2.tag) {
                case 7:
                  if (f2.type === ua) {
                    c(a2, k2.sibling);
                    d2 = e(k2, f2.props.children);
                    d2.return = a2;
                    a2 = d2;
                    break a;
                  }
                  break;
                default:
                  if (k2.elementType === f2.type) {
                    c(a2, k2.sibling);
                    d2 = e(k2, f2.props);
                    d2.ref = Qg(a2, k2, f2);
                    d2.return = a2;
                    a2 = d2;
                    break a;
                  }
              }
              c(a2, k2);
              break;
            } else b(a2, k2);
            k2 = k2.sibling;
          }
          f2.type === ua ? (d2 = Xg(f2.props.children, a2.mode, h2, f2.key), d2.return = a2, a2 = d2) : (h2 = Vg(f2.type, f2.key, f2.props, null, a2.mode, h2), h2.ref = Qg(a2, d2, f2), h2.return = a2, a2 = h2);
        }
        return g(a2);
      case ta:
        a: {
          for (k2 = f2.key; null !== d2; ) {
            if (d2.key === k2) if (4 === d2.tag && d2.stateNode.containerInfo === f2.containerInfo && d2.stateNode.implementation === f2.implementation) {
              c(a2, d2.sibling);
              d2 = e(d2, f2.children || []);
              d2.return = a2;
              a2 = d2;
              break a;
            } else {
              c(a2, d2);
              break;
            }
            else b(a2, d2);
            d2 = d2.sibling;
          }
          d2 = Wg(f2, a2.mode, h2);
          d2.return = a2;
          a2 = d2;
        }
        return g(a2);
    }
    if ("string" === typeof f2 || "number" === typeof f2) return f2 = "" + f2, null !== d2 && 6 === d2.tag ? (c(a2, d2.sibling), d2 = e(d2, f2), d2.return = a2, a2 = d2) : (c(a2, d2), d2 = Ug(f2, a2.mode, h2), d2.return = a2, a2 = d2), g(a2);
    if (Pg(f2)) return x(a2, d2, f2, h2);
    if (La(f2)) return w(a2, d2, f2, h2);
    l2 && Rg(a2, f2);
    if ("undefined" === typeof f2 && !k2) switch (a2.tag) {
      case 1:
      case 22:
      case 0:
      case 11:
      case 15:
        throw Error(y(152, Ra(a2.type) || "Component"));
    }
    return c(a2, d2);
  };
}
var Yg = Sg(true), Zg = Sg(false), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
  if (a === $g) throw Error(y(174));
  return a;
}
function eh(a, b) {
  I(ch, b);
  I(bh, a);
  I(ah, $g);
  a = b.nodeType;
  switch (a) {
    case 9:
    case 11:
      b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
      break;
    default:
      a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
  }
  H(ah);
  I(ah, b);
}
function fh() {
  H(ah);
  H(bh);
  H(ch);
}
function gh(a) {
  dh(ch.current);
  var b = dh(ah.current);
  var c = mb(b, a.type);
  b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
  bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
  for (var b = a; null !== b; ) {
    if (13 === b.tag) {
      var c = b.memoizedState;
      if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
    } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
      if (0 !== (b.flags & 64)) return b;
    } else if (null !== b.child) {
      b.child.return = b;
      b = b.child;
      continue;
    }
    if (b === a) break;
    for (; null === b.sibling; ) {
      if (null === b.return || b.return === a) return null;
      b = b.return;
    }
    b.sibling.return = b.return;
    b = b.sibling;
  }
  return null;
}
var jh = null, kh = null, lh = false;
function mh(a, b) {
  var c = nh(5, null, null, 0);
  c.elementType = "DELETED";
  c.type = "DELETED";
  c.stateNode = b;
  c.return = a;
  c.flags = 8;
  null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
  switch (a.tag) {
    case 5:
      var c = a.type;
      b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
      return null !== b ? (a.stateNode = b, true) : false;
    case 6:
      return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, true) : false;
    case 13:
      return false;
    default:
      return false;
  }
}
function ph(a) {
  if (lh) {
    var b = kh;
    if (b) {
      var c = b;
      if (!oh(a, b)) {
        b = rf(c.nextSibling);
        if (!b || !oh(a, b)) {
          a.flags = a.flags & -1025 | 2;
          lh = false;
          jh = a;
          return;
        }
        mh(jh, c);
      }
      jh = a;
      kh = rf(b.firstChild);
    } else a.flags = a.flags & -1025 | 2, lh = false, jh = a;
  }
}
function qh(a) {
  for (a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag; ) a = a.return;
  jh = a;
}
function rh(a) {
  if (a !== jh) return false;
  if (!lh) return qh(a), lh = true, false;
  var b = a.type;
  if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for (b = kh; b; ) mh(a, b), b = rf(b.nextSibling);
  qh(a);
  if (13 === a.tag) {
    a = a.memoizedState;
    a = null !== a ? a.dehydrated : null;
    if (!a) throw Error(y(317));
    a: {
      a = a.nextSibling;
      for (b = 0; a; ) {
        if (8 === a.nodeType) {
          var c = a.data;
          if ("/$" === c) {
            if (0 === b) {
              kh = rf(a.nextSibling);
              break a;
            }
            b--;
          } else "$" !== c && "$!" !== c && "$?" !== c || b++;
        }
        a = a.nextSibling;
      }
      kh = null;
    }
  } else kh = jh ? rf(a.stateNode.nextSibling) : null;
  return true;
}
function sh() {
  kh = jh = null;
  lh = false;
}
var th = [];
function uh() {
  for (var a = 0; a < th.length; a++) th[a]._workInProgressVersionPrimary = null;
  th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = false, zh = false;
function Ah() {
  throw Error(y(321));
}
function Bh(a, b) {
  if (null === b) return false;
  for (var c = 0; c < b.length && c < a.length; c++) if (!He(a[c], b[c])) return false;
  return true;
}
function Ch(a, b, c, d, e, f) {
  xh = f;
  R = b;
  b.memoizedState = null;
  b.updateQueue = null;
  b.lanes = 0;
  vh.current = null === a || null === a.memoizedState ? Dh : Eh;
  a = c(d, e);
  if (zh) {
    f = 0;
    do {
      zh = false;
      if (!(25 > f)) throw Error(y(301));
      f += 1;
      T = S = null;
      b.updateQueue = null;
      vh.current = Fh;
      a = c(d, e);
    } while (zh);
  }
  vh.current = Gh;
  b = null !== S && null !== S.next;
  xh = 0;
  T = S = R = null;
  yh = false;
  if (b) throw Error(y(300));
  return a;
}
function Hh() {
  var a = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
  null === T ? R.memoizedState = T = a : T = T.next = a;
  return T;
}
function Ih() {
  if (null === S) {
    var a = R.alternate;
    a = null !== a ? a.memoizedState : null;
  } else a = S.next;
  var b = null === T ? R.memoizedState : T.next;
  if (null !== b) T = b, S = a;
  else {
    if (null === a) throw Error(y(310));
    S = a;
    a = { memoizedState: S.memoizedState, baseState: S.baseState, baseQueue: S.baseQueue, queue: S.queue, next: null };
    null === T ? R.memoizedState = T = a : T = T.next = a;
  }
  return T;
}
function Jh(a, b) {
  return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
  var b = Ih(), c = b.queue;
  if (null === c) throw Error(y(311));
  c.lastRenderedReducer = a;
  var d = S, e = d.baseQueue, f = c.pending;
  if (null !== f) {
    if (null !== e) {
      var g = e.next;
      e.next = f.next;
      f.next = g;
    }
    d.baseQueue = e = f;
    c.pending = null;
  }
  if (null !== e) {
    e = e.next;
    d = d.baseState;
    var h = g = f = null, k = e;
    do {
      var l = k.lane;
      if ((xh & l) === l) null !== h && (h = h.next = { lane: 0, action: k.action, eagerReducer: k.eagerReducer, eagerState: k.eagerState, next: null }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
      else {
        var n = {
          lane: l,
          action: k.action,
          eagerReducer: k.eagerReducer,
          eagerState: k.eagerState,
          next: null
        };
        null === h ? (g = h = n, f = d) : h = h.next = n;
        R.lanes |= l;
        Dg |= l;
      }
      k = k.next;
    } while (null !== k && k !== e);
    null === h ? f = d : h.next = g;
    He(d, b.memoizedState) || (ug = true);
    b.memoizedState = d;
    b.baseState = f;
    b.baseQueue = h;
    c.lastRenderedState = d;
  }
  return [b.memoizedState, c.dispatch];
}
function Lh(a) {
  var b = Ih(), c = b.queue;
  if (null === c) throw Error(y(311));
  c.lastRenderedReducer = a;
  var d = c.dispatch, e = c.pending, f = b.memoizedState;
  if (null !== e) {
    c.pending = null;
    var g = e = e.next;
    do
      f = a(f, g.action), g = g.next;
    while (g !== e);
    He(f, b.memoizedState) || (ug = true);
    b.memoizedState = f;
    null === b.baseQueue && (b.baseState = f);
    c.lastRenderedState = f;
  }
  return [f, d];
}
function Mh(a, b, c) {
  var d = b._getVersion;
  d = d(b._source);
  var e = b._workInProgressVersionPrimary;
  if (null !== e) a = e === d;
  else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
  if (a) return c(b._source);
  th.push(b);
  throw Error(y(350));
}
function Nh(a, b, c, d) {
  var e = U;
  if (null === e) throw Error(y(349));
  var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
    return Mh(e, b, c);
  }), l = k[1], n = k[0];
  k = T;
  var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
  A = A.subscribe;
  var w = R;
  a.memoizedState = { refs: p, source: b, subscribe: d };
  h.useEffect(function() {
    p.getSnapshot = c;
    p.setSnapshot = l;
    var a2 = f(b._source);
    if (!He(g, a2)) {
      a2 = c(b._source);
      He(n, a2) || (l(a2), a2 = Ig(w), e.mutableReadLanes |= a2 & e.pendingLanes);
      a2 = e.mutableReadLanes;
      e.entangledLanes |= a2;
      for (var d2 = e.entanglements, h2 = a2; 0 < h2; ) {
        var k2 = 31 - Vc(h2), v = 1 << k2;
        d2[k2] |= a2;
        h2 &= ~v;
      }
    }
  }, [c, b, d]);
  h.useEffect(function() {
    return d(b._source, function() {
      var a2 = p.getSnapshot, c2 = p.setSnapshot;
      try {
        c2(a2(b._source));
        var d2 = Ig(w);
        e.mutableReadLanes |= d2 & e.pendingLanes;
      } catch (q) {
        c2(function() {
          throw q;
        });
      }
    });
  }, [b, d]);
  He(C, c) && He(x, b) && He(A, d) || (a = { pending: null, dispatch: null, lastRenderedReducer: Jh, lastRenderedState: n }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
  return n;
}
function Ph(a, b, c) {
  var d = Ih();
  return Nh(d, a, b, c);
}
function Qh(a) {
  var b = Hh();
  "function" === typeof a && (a = a());
  b.memoizedState = b.baseState = a;
  a = b.queue = { pending: null, dispatch: null, lastRenderedReducer: Jh, lastRenderedState: a };
  a = a.dispatch = Oh.bind(null, R, a);
  return [b.memoizedState, a];
}
function Rh(a, b, c, d) {
  a = { tag: a, create: b, destroy: c, deps: d, next: null };
  b = R.updateQueue;
  null === b ? (b = { lastEffect: null }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
  return a;
}
function Sh(a) {
  var b = Hh();
  a = { current: a };
  return b.memoizedState = a;
}
function Th() {
  return Ih().memoizedState;
}
function Uh(a, b, c, d) {
  var e = Hh();
  R.flags |= a;
  e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
  var e = Ih();
  d = void 0 === d ? null : d;
  var f = void 0;
  if (null !== S) {
    var g = S.memoizedState;
    f = g.destroy;
    if (null !== d && Bh(d, g.deps)) {
      Rh(b, c, f, d);
      return;
    }
  }
  R.flags |= a;
  e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
  return Uh(516, 4, a, b);
}
function Xh(a, b) {
  return Vh(516, 4, a, b);
}
function Yh(a, b) {
  return Vh(4, 2, a, b);
}
function Zh(a, b) {
  if ("function" === typeof b) return a = a(), b(a), function() {
    b(null);
  };
  if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
    b.current = null;
  };
}
function $h(a, b, c) {
  c = null !== c && void 0 !== c ? c.concat([a]) : null;
  return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {
}
function bi(a, b) {
  var c = Ih();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Bh(b, d[1])) return d[0];
  c.memoizedState = [a, b];
  return a;
}
function ci(a, b) {
  var c = Ih();
  b = void 0 === b ? null : b;
  var d = c.memoizedState;
  if (null !== d && null !== b && Bh(b, d[1])) return d[0];
  a = a();
  c.memoizedState = [a, b];
  return a;
}
function di(a, b) {
  var c = eg();
  gg(98 > c ? 98 : c, function() {
    a(true);
  });
  gg(97 < c ? 97 : c, function() {
    var c2 = wh.transition;
    wh.transition = 1;
    try {
      a(false), b();
    } finally {
      wh.transition = c2;
    }
  });
}
function Oh(a, b, c) {
  var d = Hg(), e = Ig(a), f = { lane: e, action: c, eagerReducer: null, eagerState: null, next: null }, g = b.pending;
  null === g ? f.next = f : (f.next = g.next, g.next = f);
  b.pending = f;
  g = a.alternate;
  if (a === R || null !== g && g === R) zh = yh = true;
  else {
    if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
      var h = b.lastRenderedState, k = g(h, c);
      f.eagerReducer = g;
      f.eagerState = k;
      if (He(k, h)) return;
    } catch (l) {
    } finally {
    }
    Jg(a, e, d);
  }
}
var Gh = { readContext: vg, useCallback: Ah, useContext: Ah, useEffect: Ah, useImperativeHandle: Ah, useLayoutEffect: Ah, useMemo: Ah, useReducer: Ah, useRef: Ah, useState: Ah, useDebugValue: Ah, useDeferredValue: Ah, useTransition: Ah, useMutableSource: Ah, useOpaqueIdentifier: Ah, unstable_isNewReconciler: false }, Dh = { readContext: vg, useCallback: function(a, b) {
  Hh().memoizedState = [a, void 0 === b ? null : b];
  return a;
}, useContext: vg, useEffect: Wh, useImperativeHandle: function(a, b, c) {
  c = null !== c && void 0 !== c ? c.concat([a]) : null;
  return Uh(4, 2, Zh.bind(
    null,
    b,
    a
  ), c);
}, useLayoutEffect: function(a, b) {
  return Uh(4, 2, a, b);
}, useMemo: function(a, b) {
  var c = Hh();
  b = void 0 === b ? null : b;
  a = a();
  c.memoizedState = [a, b];
  return a;
}, useReducer: function(a, b, c) {
  var d = Hh();
  b = void 0 !== c ? c(b) : b;
  d.memoizedState = d.baseState = b;
  a = d.queue = { pending: null, dispatch: null, lastRenderedReducer: a, lastRenderedState: b };
  a = a.dispatch = Oh.bind(null, R, a);
  return [d.memoizedState, a];
}, useRef: Sh, useState: Qh, useDebugValue: ai, useDeferredValue: function(a) {
  var b = Qh(a), c = b[0], d = b[1];
  Wh(function() {
    var b2 = wh.transition;
    wh.transition = 1;
    try {
      d(a);
    } finally {
      wh.transition = b2;
    }
  }, [a]);
  return c;
}, useTransition: function() {
  var a = Qh(false), b = a[0];
  a = di.bind(null, a[1]);
  Sh(a);
  return [a, b];
}, useMutableSource: function(a, b, c) {
  var d = Hh();
  d.memoizedState = { refs: { getSnapshot: b, setSnapshot: null }, source: a, subscribe: c };
  return Nh(d, a, b, c);
}, useOpaqueIdentifier: function() {
  if (lh) {
    var a = false, b = uf(function() {
      a || (a = true, c("r:" + (tf++).toString(36)));
      throw Error(y(355));
    }), c = Qh(b)[1];
    0 === (R.mode & 2) && (R.flags |= 516, Rh(
      5,
      function() {
        c("r:" + (tf++).toString(36));
      },
      void 0,
      null
    ));
    return b;
  }
  b = "r:" + (tf++).toString(36);
  Qh(b);
  return b;
}, unstable_isNewReconciler: false }, Eh = { readContext: vg, useCallback: bi, useContext: vg, useEffect: Xh, useImperativeHandle: $h, useLayoutEffect: Yh, useMemo: ci, useReducer: Kh, useRef: Th, useState: function() {
  return Kh(Jh);
}, useDebugValue: ai, useDeferredValue: function(a) {
  var b = Kh(Jh), c = b[0], d = b[1];
  Xh(function() {
    var b2 = wh.transition;
    wh.transition = 1;
    try {
      d(a);
    } finally {
      wh.transition = b2;
    }
  }, [a]);
  return c;
}, useTransition: function() {
  var a = Kh(Jh)[0];
  return [
    Th().current,
    a
  ];
}, useMutableSource: Ph, useOpaqueIdentifier: function() {
  return Kh(Jh)[0];
}, unstable_isNewReconciler: false }, Fh = { readContext: vg, useCallback: bi, useContext: vg, useEffect: Xh, useImperativeHandle: $h, useLayoutEffect: Yh, useMemo: ci, useReducer: Lh, useRef: Th, useState: function() {
  return Lh(Jh);
}, useDebugValue: ai, useDeferredValue: function(a) {
  var b = Lh(Jh), c = b[0], d = b[1];
  Xh(function() {
    var b2 = wh.transition;
    wh.transition = 1;
    try {
      d(a);
    } finally {
      wh.transition = b2;
    }
  }, [a]);
  return c;
}, useTransition: function() {
  var a = Lh(Jh)[0];
  return [
    Th().current,
    a
  ];
}, useMutableSource: Ph, useOpaqueIdentifier: function() {
  return Lh(Jh)[0];
}, unstable_isNewReconciler: false }, ei = ra.ReactCurrentOwner, ug = false;
function fi(a, b, c, d) {
  b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
  c = c.render;
  var f = b.ref;
  tg(b, e);
  d = Ch(a, b, c, d, f, e);
  if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
  b.flags |= 1;
  fi(a, b, d, e);
  return b.child;
}
function ii(a, b, c, d, e, f) {
  if (null === a) {
    var g = c.type;
    if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
    a = Vg(c.type, null, d, b, b.mode, f);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
  }
  g = a.child;
  if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
  b.flags |= 1;
  a = Tg(g, d);
  a.ref = b.ref;
  a.return = b;
  return b.child = a;
}
function ki(a, b, c, d, e, f) {
  if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) if (ug = false, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = true);
  else return b.lanes = a.lanes, hi(a, b, f);
  return li(a, b, c, d, f);
}
function mi(a, b, c) {
  var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
  if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) if (0 === (b.mode & 4)) b.memoizedState = { baseLanes: 0 }, ni(b, c);
  else if (0 !== (c & 1073741824)) b.memoizedState = { baseLanes: 0 }, ni(b, null !== f ? f.baseLanes : c);
  else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = { baseLanes: a }, ni(b, a), null;
  else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
  fi(a, b, e, c);
  return b.child;
}
function oi(a, b) {
  var c = b.ref;
  if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
  var f = Ff(c) ? Df : M.current;
  f = Ef(b, f);
  tg(b, e);
  c = Ch(a, b, c, d, f, e);
  if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
  b.flags |= 1;
  fi(a, b, c, e);
  return b.child;
}
function pi(a, b, c, d, e) {
  if (Ff(c)) {
    var f = true;
    Jf(b);
  } else f = false;
  tg(b, e);
  if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = true;
  else if (null === a) {
    var g = b.stateNode, h = b.memoizedProps;
    g.props = h;
    var k = g.context, l = c.contextType;
    "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
    var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
    A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
    wg = false;
    var p = b.memoizedState;
    g.state = p;
    Cg(b, d, g, e);
    k = b.memoizedState;
    h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = false);
  } else {
    g = b.stateNode;
    yg(a, b);
    h = b.memoizedProps;
    l = b.type === b.elementType ? h : lg(b.type, h);
    g.props = l;
    A = b.pendingProps;
    p = g.context;
    k = c.contextType;
    "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
    var C = c.getDerivedStateFromProps;
    (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
    wg = false;
    p = b.memoizedState;
    g.state = p;
    Cg(b, d, g, e);
    var x = b.memoizedState;
    h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(
      d,
      x,
      k
    ), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = false);
  }
  return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
  oi(a, b);
  var g = 0 !== (b.flags & 64);
  if (!d && !g) return e && Kf(b, c, false), hi(a, b, f);
  d = b.stateNode;
  ei.current = b;
  var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
  b.flags |= 1;
  null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
  b.memoizedState = d.state;
  e && Kf(b, c, true);
  return b.child;
}
function ri(a) {
  var b = a.stateNode;
  b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, false);
  eh(a, b.containerInfo);
}
var si = { dehydrated: null, retryLane: 0 };
function ti(a, b, c) {
  var d = b.pendingProps, e = P.current, f = false, g;
  (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? false : 0 !== (e & 2));
  g ? (f = true, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || true === d.unstable_avoidThisFallback || (e |= 1);
  I(P, e & 1);
  if (null === a) {
    void 0 !== d.fallback && ph(b);
    a = d.children;
    e = d.fallback;
    if (f) return a = ui(b, a, e, c), b.child.memoizedState = { baseLanes: c }, b.memoizedState = si, a;
    if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = { baseLanes: c }, b.memoizedState = si, b.lanes = 33554432, a;
    c = vi({ mode: "visible", children: a }, b.mode, c, null);
    c.return = b;
    return b.child = c;
  }
  if (null !== a.memoizedState) {
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? { baseLanes: c } : { baseLanes: e.baseLanes | c }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
  }
  if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? { baseLanes: c } : { baseLanes: e.baseLanes | c }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
  c = xi(a, b, d.children, c);
  b.memoizedState = null;
  return c;
}
function ui(a, b, c, d) {
  var e = a.mode, f = a.child;
  b = { mode: "hidden", children: b };
  0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
  c = Xg(c, e, d, null);
  f.return = a;
  c.return = a;
  f.sibling = c;
  a.child = f;
  return c;
}
function xi(a, b, c, d) {
  var e = a.child;
  a = e.sibling;
  c = Tg(e, { mode: "visible", children: c });
  0 === (b.mode & 2) && (c.lanes = d);
  c.return = b;
  c.sibling = null;
  null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
  return b.child = c;
}
function wi(a, b, c, d, e) {
  var f = b.mode, g = a.child;
  a = g.sibling;
  var h = { mode: "hidden", children: c };
  0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
  null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
  d.return = b;
  c.return = b;
  c.sibling = d;
  b.child = c;
  return d;
}
function yi(a, b) {
  a.lanes |= b;
  var c = a.alternate;
  null !== c && (c.lanes |= b);
  sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
  var g = a.memoizedState;
  null === g ? a.memoizedState = { isBackwards: b, rendering: null, renderingStartTime: 0, last: d, tail: c, tailMode: e, lastEffect: f } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
  var d = b.pendingProps, e = d.revealOrder, f = d.tail;
  fi(a, b, d.children, c);
  d = P.current;
  if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
  else {
    if (null !== a && 0 !== (a.flags & 64)) a: for (a = b.child; null !== a; ) {
      if (13 === a.tag) null !== a.memoizedState && yi(a, c);
      else if (19 === a.tag) yi(a, c);
      else if (null !== a.child) {
        a.child.return = a;
        a = a.child;
        continue;
      }
      if (a === b) break a;
      for (; null === a.sibling; ) {
        if (null === a.return || a.return === b) break a;
        a = a.return;
      }
      a.sibling.return = a.return;
      a = a.sibling;
    }
    d &= 1;
  }
  I(P, d);
  if (0 === (b.mode & 2)) b.memoizedState = null;
  else switch (e) {
    case "forwards":
      c = b.child;
      for (e = null; null !== c; ) a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
      c = e;
      null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
      zi(b, false, e, c, f, b.lastEffect);
      break;
    case "backwards":
      c = null;
      e = b.child;
      for (b.child = null; null !== e; ) {
        a = e.alternate;
        if (null !== a && null === ih(a)) {
          b.child = e;
          break;
        }
        a = e.sibling;
        e.sibling = c;
        c = e;
        e = a;
      }
      zi(b, true, c, null, f, b.lastEffect);
      break;
    case "together":
      zi(b, false, null, null, void 0, b.lastEffect);
      break;
    default:
      b.memoizedState = null;
  }
  return b.child;
}
function hi(a, b, c) {
  null !== a && (b.dependencies = a.dependencies);
  Dg |= b.lanes;
  if (0 !== (c & b.childLanes)) {
    if (null !== a && b.child !== a.child) throw Error(y(153));
    if (null !== b.child) {
      a = b.child;
      c = Tg(a, a.pendingProps);
      b.child = c;
      for (c.return = b; null !== a.sibling; ) a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
      c.sibling = null;
    }
    return b.child;
  }
  return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
  for (var c = b.child; null !== c; ) {
    if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
    else if (4 !== c.tag && null !== c.child) {
      c.child.return = c;
      c = c.child;
      continue;
    }
    if (c === b) break;
    for (; null === c.sibling; ) {
      if (null === c.return || c.return === b) return;
      c = c.return;
    }
    c.sibling.return = c.return;
    c = c.sibling;
  }
};
Ci = function() {
};
Di = function(a, b, c, d) {
  var e = a.memoizedProps;
  if (e !== d) {
    a = b.stateNode;
    dh(ah.current);
    var f = null;
    switch (c) {
      case "input":
        e = Ya(a, e);
        d = Ya(a, d);
        f = [];
        break;
      case "option":
        e = eb(a, e);
        d = eb(a, d);
        f = [];
        break;
      case "select":
        e = m({}, e, { value: void 0 });
        d = m({}, d, { value: void 0 });
        f = [];
        break;
      case "textarea":
        e = gb(a, e);
        d = gb(a, d);
        f = [];
        break;
      default:
        "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
    }
    vb(c, d);
    var g;
    c = null;
    for (l in e) if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) if ("style" === l) {
      var h = e[l];
      for (g in h) h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
    } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
    for (l in d) {
      var k = d[l];
      h = null != e ? e[l] : void 0;
      if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) if ("style" === l) if (h) {
        for (g in h) !h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
        for (g in k) k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
      } else c || (f || (f = []), f.push(l, c)), c = k;
      else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
    }
    c && (f = f || []).push(
      "style",
      c
    );
    var l = f;
    if (b.updateQueue = l) b.flags |= 4;
  }
};
Ei = function(a, b, c, d) {
  c !== d && (b.flags |= 4);
};
function Fi(a, b) {
  if (!lh) switch (a.tailMode) {
    case "hidden":
      b = a.tail;
      for (var c = null; null !== b; ) null !== b.alternate && (c = b), b = b.sibling;
      null === c ? a.tail = null : c.sibling = null;
      break;
    case "collapsed":
      c = a.tail;
      for (var d = null; null !== c; ) null !== c.alternate && (d = c), c = c.sibling;
      null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
  }
}
function Gi(a, b, c) {
  var d = b.pendingProps;
  switch (b.tag) {
    case 2:
    case 16:
    case 15:
    case 0:
    case 11:
    case 7:
    case 8:
    case 12:
    case 9:
    case 14:
      return null;
    case 1:
      return Ff(b.type) && Gf(), null;
    case 3:
      fh();
      H(N);
      H(M);
      uh();
      d = b.stateNode;
      d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
      if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
      Ci(b);
      return null;
    case 5:
      hh(b);
      var e = dh(ch.current);
      c = b.type;
      if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
      else {
        if (!d) {
          if (null === b.stateNode) throw Error(y(166));
          return null;
        }
        a = dh(ah.current);
        if (rh(b)) {
          d = b.stateNode;
          c = b.type;
          var f = b.memoizedProps;
          d[wf] = b;
          d[xf] = f;
          switch (c) {
            case "dialog":
              G("cancel", d);
              G("close", d);
              break;
            case "iframe":
            case "object":
            case "embed":
              G("load", d);
              break;
            case "video":
            case "audio":
              for (a = 0; a < Xe.length; a++) G(Xe[a], d);
              break;
            case "source":
              G("error", d);
              break;
            case "img":
            case "image":
            case "link":
              G("error", d);
              G("load", d);
              break;
            case "details":
              G("toggle", d);
              break;
            case "input":
              Za(d, f);
              G("invalid", d);
              break;
            case "select":
              d._wrapperState = { wasMultiple: !!f.multiple };
              G("invalid", d);
              break;
            case "textarea":
              hb(d, f), G("invalid", d);
          }
          vb(c, f);
          a = null;
          for (var g in f) f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = ["children", e]) : "number" === typeof e && d.textContent !== "" + e && (a = ["children", "" + e]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
          switch (c) {
            case "input":
              Va(d);
              cb(d, f, true);
              break;
            case "textarea":
              Va(d);
              jb(d);
              break;
            case "select":
            case "option":
              break;
            default:
              "function" === typeof f.onClick && (d.onclick = jf);
          }
          d = a;
          b.updateQueue = d;
          null !== d && (b.flags |= 4);
        } else {
          g = 9 === e.nodeType ? e : e.ownerDocument;
          a === kb.html && (a = lb(c));
          a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script><\/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, { is: d.is }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = true : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
          a[wf] = b;
          a[xf] = d;
          Bi(a, b, false, false);
          b.stateNode = a;
          g = wb(c, d);
          switch (c) {
            case "dialog":
              G("cancel", a);
              G("close", a);
              e = d;
              break;
            case "iframe":
            case "object":
            case "embed":
              G("load", a);
              e = d;
              break;
            case "video":
            case "audio":
              for (e = 0; e < Xe.length; e++) G(Xe[e], a);
              e = d;
              break;
            case "source":
              G("error", a);
              e = d;
              break;
            case "img":
            case "image":
            case "link":
              G("error", a);
              G("load", a);
              e = d;
              break;
            case "details":
              G("toggle", a);
              e = d;
              break;
            case "input":
              Za(a, d);
              e = Ya(a, d);
              G("invalid", a);
              break;
            case "option":
              e = eb(a, d);
              break;
            case "select":
              a._wrapperState = { wasMultiple: !!d.multiple };
              e = m({}, d, { value: void 0 });
              G("invalid", a);
              break;
            case "textarea":
              hb(a, d);
              e = gb(a, d);
              G("invalid", a);
              break;
            default:
              e = d;
          }
          vb(c, e);
          var h = e;
          for (f in h) if (h.hasOwnProperty(f)) {
            var k = h[f];
            "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
          }
          switch (c) {
            case "input":
              Va(a);
              cb(a, d, false);
              break;
            case "textarea":
              Va(a);
              jb(a);
              break;
            case "option":
              null != d.value && a.setAttribute("value", "" + Sa(d.value));
              break;
            case "select":
              a.multiple = !!d.multiple;
              f = d.value;
              null != f ? fb(a, !!d.multiple, f, false) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, true);
              break;
            default:
              "function" === typeof e.onClick && (a.onclick = jf);
          }
          mf(c, d) && (b.flags |= 4);
        }
        null !== b.ref && (b.flags |= 128);
      }
      return null;
    case 6:
      if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
      else {
        if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
        c = dh(ch.current);
        dh(ah.current);
        rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
      }
      return null;
    case 13:
      H(P);
      d = b.memoizedState;
      if (0 !== (b.flags & 64)) return b.lanes = c, b;
      d = null !== d;
      c = false;
      null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
      if (d && !c && 0 !== (b.mode & 2)) if (null === a && true !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
      else {
        if (0 === V || 3 === V) V = 4;
        null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
      }
      if (d || c) b.flags |= 4;
      return null;
    case 4:
      return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
    case 10:
      return rg(b), null;
    case 17:
      return Ff(b.type) && Gf(), null;
    case 19:
      H(P);
      d = b.memoizedState;
      if (null === d) return null;
      f = 0 !== (b.flags & 64);
      g = d.rendering;
      if (null === g) if (f) Fi(d, false);
      else {
        if (0 !== V || null !== a && 0 !== (a.flags & 64)) for (a = b.child; null !== a; ) {
          g = ih(a);
          if (null !== g) {
            b.flags |= 64;
            Fi(d, false);
            f = g.updateQueue;
            null !== f && (b.updateQueue = f, b.flags |= 4);
            null === d.lastEffect && (b.firstEffect = null);
            b.lastEffect = d.lastEffect;
            d = c;
            for (c = b.child; null !== c; ) f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : { lanes: a.lanes, firstContext: a.firstContext }), c = c.sibling;
            I(P, P.current & 1 | 2);
            return b.child;
          }
          a = a.sibling;
        }
        null !== d.tail && O() > Ji && (b.flags |= 64, f = true, Fi(d, false), b.lanes = 33554432);
      }
      else {
        if (!f) if (a = ih(g), null !== a) {
          if (b.flags |= 64, f = true, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, true), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
        } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = true, Fi(d, false), b.lanes = 33554432);
        d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
      }
      return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
    case 23:
    case 24:
      return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
  }
  throw Error(y(156, b.tag));
}
function Li(a) {
  switch (a.tag) {
    case 1:
      Ff(a.type) && Gf();
      var b = a.flags;
      return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
    case 3:
      fh();
      H(N);
      H(M);
      uh();
      b = a.flags;
      if (0 !== (b & 64)) throw Error(y(285));
      a.flags = b & -4097 | 64;
      return a;
    case 5:
      return hh(a), null;
    case 13:
      return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
    case 19:
      return H(P), null;
    case 4:
      return fh(), null;
    case 10:
      return rg(a), null;
    case 23:
    case 24:
      return Ki(), null;
    default:
      return null;
  }
}
function Mi(a, b) {
  try {
    var c = "", d = b;
    do
      c += Qa(d), d = d.return;
    while (d);
    var e = c;
  } catch (f) {
    e = "\nError generating stack: " + f.message + "\n" + f.stack;
  }
  return { value: a, source: b, stack: e };
}
function Ni(a, b) {
  try {
    console.error(b.value);
  } catch (c) {
    setTimeout(function() {
      throw c;
    });
  }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
  c = zg(-1, c);
  c.tag = 3;
  c.payload = { element: null };
  var d = b.value;
  c.callback = function() {
    Qi || (Qi = true, Ri = d);
    Ni(a, b);
  };
  return c;
}
function Si(a, b, c) {
  c = zg(-1, c);
  c.tag = 3;
  var d = a.type.getDerivedStateFromError;
  if ("function" === typeof d) {
    var e = b.value;
    c.payload = function() {
      Ni(a, b);
      return d(e);
    };
  }
  var f = a.stateNode;
  null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
    "function" !== typeof d && (null === Ti ? Ti = /* @__PURE__ */ new Set([this]) : Ti.add(this), Ni(a, b));
    var c2 = b.stack;
    this.componentDidCatch(b.value, { componentStack: null !== c2 ? c2 : "" });
  });
  return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
  var b = a.ref;
  if (null !== b) if ("function" === typeof b) try {
    b(null);
  } catch (c) {
    Wi(a, c);
  }
  else b.current = null;
}
function Xi(a, b) {
  switch (b.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      return;
    case 1:
      if (b.flags & 256 && null !== a) {
        var c = a.memoizedProps, d = a.memoizedState;
        a = b.stateNode;
        b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
        a.__reactInternalSnapshotBeforeUpdate = b;
      }
      return;
    case 3:
      b.flags & 256 && qf(b.stateNode.containerInfo);
      return;
    case 5:
    case 6:
    case 4:
    case 17:
      return;
  }
  throw Error(y(163));
}
function Yi(a, b, c) {
  switch (c.tag) {
    case 0:
    case 11:
    case 15:
    case 22:
      b = c.updateQueue;
      b = null !== b ? b.lastEffect : null;
      if (null !== b) {
        a = b = b.next;
        do {
          if (3 === (a.tag & 3)) {
            var d = a.create;
            a.destroy = d();
          }
          a = a.next;
        } while (a !== b);
      }
      b = c.updateQueue;
      b = null !== b ? b.lastEffect : null;
      if (null !== b) {
        a = b = b.next;
        do {
          var e = a;
          d = e.next;
          e = e.tag;
          0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
          a = d;
        } while (a !== b);
      }
      return;
    case 1:
      a = c.stateNode;
      c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(
        d,
        b.memoizedState,
        a.__reactInternalSnapshotBeforeUpdate
      )));
      b = c.updateQueue;
      null !== b && Eg(c, b, a);
      return;
    case 3:
      b = c.updateQueue;
      if (null !== b) {
        a = null;
        if (null !== c.child) switch (c.child.tag) {
          case 5:
            a = c.child.stateNode;
            break;
          case 1:
            a = c.child.stateNode;
        }
        Eg(c, b, a);
      }
      return;
    case 5:
      a = c.stateNode;
      null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
      return;
    case 6:
      return;
    case 4:
      return;
    case 12:
      return;
    case 13:
      null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
      return;
    case 19:
    case 17:
    case 20:
    case 21:
    case 23:
    case 24:
      return;
  }
  throw Error(y(163));
}
function aj(a, b) {
  for (var c = a; ; ) {
    if (5 === c.tag) {
      var d = c.stateNode;
      if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
      else {
        d = c.stateNode;
        var e = c.memoizedProps.style;
        e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
        d.style.display = sb("display", e);
      }
    } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
    else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
      c.child.return = c;
      c = c.child;
      continue;
    }
    if (c === a) break;
    for (; null === c.sibling; ) {
      if (null === c.return || c.return === a) return;
      c = c.return;
    }
    c.sibling.return = c.return;
    c = c.sibling;
  }
}
function bj(a, b) {
  if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
    Mf.onCommitFiberUnmount(Lf, b);
  } catch (f) {
  }
  switch (b.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      a = b.updateQueue;
      if (null !== a && (a = a.lastEffect, null !== a)) {
        var c = a = a.next;
        do {
          var d = c, e = d.destroy;
          d = d.tag;
          if (void 0 !== e) if (0 !== (d & 4)) Zi(b, c);
          else {
            d = b;
            try {
              e();
            } catch (f) {
              Wi(d, f);
            }
          }
          c = c.next;
        } while (c !== a);
      }
      break;
    case 1:
      Vi(b);
      a = b.stateNode;
      if ("function" === typeof a.componentWillUnmount) try {
        a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
      } catch (f) {
        Wi(
          b,
          f
        );
      }
      break;
    case 5:
      Vi(b);
      break;
    case 4:
      cj(a, b);
  }
}
function dj(a) {
  a.alternate = null;
  a.child = null;
  a.dependencies = null;
  a.firstEffect = null;
  a.lastEffect = null;
  a.memoizedProps = null;
  a.memoizedState = null;
  a.pendingProps = null;
  a.return = null;
  a.updateQueue = null;
}
function ej(a) {
  return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
  a: {
    for (var b = a.return; null !== b; ) {
      if (ej(b)) break a;
      b = b.return;
    }
    throw Error(y(160));
  }
  var c = b;
  b = c.stateNode;
  switch (c.tag) {
    case 5:
      var d = false;
      break;
    case 3:
      b = b.containerInfo;
      d = true;
      break;
    case 4:
      b = b.containerInfo;
      d = true;
      break;
    default:
      throw Error(y(161));
  }
  c.flags & 16 && (pb(b, ""), c.flags &= -17);
  a: b: for (c = a; ; ) {
    for (; null === c.sibling; ) {
      if (null === c.return || ej(c.return)) {
        c = null;
        break a;
      }
      c = c.return;
    }
    c.sibling.return = c.return;
    for (c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag; ) {
      if (c.flags & 2) continue b;
      if (null === c.child || 4 === c.tag) continue b;
      else c.child.return = c, c = c.child;
    }
    if (!(c.flags & 2)) {
      c = c.stateNode;
      break a;
    }
  }
  d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
  var d = a.tag, e = 5 === d || 6 === d;
  if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
  else if (4 !== d && (a = a.child, null !== a)) for (gj(a, b, c), a = a.sibling; null !== a; ) gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
  var d = a.tag, e = 5 === d || 6 === d;
  if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
  else if (4 !== d && (a = a.child, null !== a)) for (hj(a, b, c), a = a.sibling; null !== a; ) hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
  for (var c = b, d = false, e, f; ; ) {
    if (!d) {
      d = c.return;
      a: for (; ; ) {
        if (null === d) throw Error(y(160));
        e = d.stateNode;
        switch (d.tag) {
          case 5:
            f = false;
            break a;
          case 3:
            e = e.containerInfo;
            f = true;
            break a;
          case 4:
            e = e.containerInfo;
            f = true;
            break a;
        }
        d = d.return;
      }
      d = true;
    }
    if (5 === c.tag || 6 === c.tag) {
      a: for (var g = a, h = c, k = h; ; ) if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
      else {
        if (k === h) break a;
        for (; null === k.sibling; ) {
          if (null === k.return || k.return === h) break a;
          k = k.return;
        }
        k.sibling.return = k.return;
        k = k.sibling;
      }
      f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
    } else if (4 === c.tag) {
      if (null !== c.child) {
        e = c.stateNode.containerInfo;
        f = true;
        c.child.return = c;
        c = c.child;
        continue;
      }
    } else if (bj(a, c), null !== c.child) {
      c.child.return = c;
      c = c.child;
      continue;
    }
    if (c === b) break;
    for (; null === c.sibling; ) {
      if (null === c.return || c.return === b) return;
      c = c.return;
      4 === c.tag && (d = false);
    }
    c.sibling.return = c.return;
    c = c.sibling;
  }
}
function ij(a, b) {
  switch (b.tag) {
    case 0:
    case 11:
    case 14:
    case 15:
    case 22:
      var c = b.updateQueue;
      c = null !== c ? c.lastEffect : null;
      if (null !== c) {
        var d = c = c.next;
        do
          3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
        while (d !== c);
      }
      return;
    case 1:
      return;
    case 5:
      c = b.stateNode;
      if (null != c) {
        d = b.memoizedProps;
        var e = null !== a ? a.memoizedProps : d;
        a = b.type;
        var f = b.updateQueue;
        b.updateQueue = null;
        if (null !== f) {
          c[xf] = d;
          "input" === a && "radio" === d.type && null != d.name && $a(c, d);
          wb(a, e);
          b = wb(a, d);
          for (e = 0; e < f.length; e += 2) {
            var g = f[e], h = f[e + 1];
            "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
          }
          switch (a) {
            case "input":
              ab(c, d);
              break;
            case "textarea":
              ib(c, d);
              break;
            case "select":
              a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, false) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, true) : fb(c, !!d.multiple, d.multiple ? [] : "", false));
          }
        }
      }
      return;
    case 6:
      if (null === b.stateNode) throw Error(y(162));
      b.stateNode.nodeValue = b.memoizedProps;
      return;
    case 3:
      c = b.stateNode;
      c.hydrate && (c.hydrate = false, Cc(c.containerInfo));
      return;
    case 12:
      return;
    case 13:
      null !== b.memoizedState && (jj = O(), aj(b.child, true));
      kj(b);
      return;
    case 19:
      kj(b);
      return;
    case 17:
      return;
    case 23:
    case 24:
      aj(b, null !== b.memoizedState);
      return;
  }
  throw Error(y(163));
}
function kj(a) {
  var b = a.updateQueue;
  if (null !== b) {
    a.updateQueue = null;
    var c = a.stateNode;
    null === c && (c = a.stateNode = new Ui());
    b.forEach(function(b2) {
      var d = lj.bind(null, a, b2);
      c.has(b2) || (c.add(b2), b2.then(d, d));
    });
  }
}
function mj(a, b) {
  return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : false;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
  Ji = O() + 500;
}
var Z = null, Qi = false, Ri = null, Ti = null, xj = false, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = false;
function Hg() {
  return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
  a = a.mode;
  if (0 === (a & 2)) return 1;
  if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
  0 === Gj && (Gj = tj);
  if (0 !== kg.transition) {
    0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
    a = Gj;
    var b = 4186112 & ~Hj;
    b &= -b;
    0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
    return b;
  }
  a = eg();
  0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
  return a;
}
function Jg(a, b, c) {
  if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
  a = Kj(a, b);
  if (null === a) return null;
  $c(a, b, c);
  a === U && (Hi |= b, 4 === V && Ii(a, W));
  var d = eg();
  1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = /* @__PURE__ */ new Set([a]) : Cj.add(a)), Mj(a, c));
  vj = a;
}
function Kj(a, b) {
  a.lanes |= b;
  var c = a.alternate;
  null !== c && (c.lanes |= b);
  c = a;
  for (a = a.return; null !== a; ) a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
  return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
  for (var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g; ) {
    var h = 31 - Vc(g), k = 1 << h, l = f[h];
    if (-1 === l) {
      if (0 === (k & d) || 0 !== (k & e)) {
        l = b;
        Rc(k);
        var n = F;
        f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5e3 : -1;
      }
    } else l <= b && (a.expiredLanes |= k);
    g &= ~k;
  }
  d = Uc(a, a === U ? W : 0);
  b = F;
  if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
  else {
    if (null !== c) {
      if (a.callbackPriority === b) return;
      c !== Zf && Pf(c);
    }
    15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [c], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
    a.callbackPriority = b;
    a.callbackNode = c;
  }
}
function Nj(a) {
  Fj = -1;
  Hj = Gj = 0;
  if (0 !== (X & 48)) throw Error(y(327));
  var b = a.callbackNode;
  if (Oj() && a.callbackNode !== b) return null;
  var c = Uc(a, a === U ? W : 0);
  if (0 === c) return null;
  var d = c;
  var e = X;
  X |= 16;
  var f = Pj();
  if (U !== a || W !== d) wj(), Qj(a, d);
  do
    try {
      Rj();
      break;
    } catch (h) {
      Sj(a, h);
    }
  while (1);
  qg();
  oj.current = f;
  X = e;
  null !== Y ? d = 0 : (U = null, W = 0, d = V);
  if (0 !== (tj & Hi)) Qj(a, 0);
  else if (0 !== d) {
    2 === d && (X |= 64, a.hydrate && (a.hydrate = false, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
    if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = c;
    switch (d) {
      case 0:
      case 1:
        throw Error(y(345));
      case 2:
        Uj(a);
        break;
      case 3:
        Ii(a, c);
        if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
          if (0 !== Uc(a, 0)) break;
          e = a.suspendedLanes;
          if ((e & c) !== c) {
            Hg();
            a.pingedLanes |= a.suspendedLanes & e;
            break;
          }
          a.timeoutHandle = of(Uj.bind(null, a), d);
          break;
        }
        Uj(a);
        break;
      case 4:
        Ii(a, c);
        if ((c & 4186112) === c) break;
        d = a.eventTimes;
        for (e = -1; 0 < c; ) {
          var g = 31 - Vc(c);
          f = 1 << g;
          g = d[g];
          g > e && (e = g);
          c &= ~f;
        }
        c = e;
        c = O() - c;
        c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3e3 > c ? 3e3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
        if (10 < c) {
          a.timeoutHandle = of(Uj.bind(null, a), c);
          break;
        }
        Uj(a);
        break;
      case 5:
        Uj(a);
        break;
      default:
        throw Error(y(329));
    }
  }
  Mj(a, O());
  return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
  b &= ~uj;
  b &= ~Hi;
  a.suspendedLanes |= b;
  a.pingedLanes &= ~b;
  for (a = a.expirationTimes; 0 < b; ) {
    var c = 31 - Vc(b), d = 1 << c;
    a[c] = -1;
    b &= ~d;
  }
}
function Lj(a) {
  if (0 !== (X & 48)) throw Error(y(327));
  Oj();
  if (a === U && 0 !== (a.expiredLanes & W)) {
    var b = W;
    var c = Tj(a, b);
    0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
  } else b = Uc(a, 0), c = Tj(a, b);
  0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = false, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
  if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
  a.finishedWork = a.current.alternate;
  a.finishedLanes = b;
  Uj(a);
  Mj(a, O());
  return null;
}
function Vj() {
  if (null !== Cj) {
    var a = Cj;
    Cj = null;
    a.forEach(function(a2) {
      a2.expiredLanes |= 24 & a2.pendingLanes;
      Mj(a2, O());
    });
  }
  ig();
}
function Wj(a, b) {
  var c = X;
  X |= 1;
  try {
    return a(b);
  } finally {
    X = c, 0 === X && (wj(), ig());
  }
}
function Xj(a, b) {
  var c = X;
  X &= -2;
  X |= 8;
  try {
    return a(b);
  } finally {
    X = c, 0 === X && (wj(), ig());
  }
}
function ni(a, b) {
  I(rj, qj);
  qj |= b;
  tj |= b;
}
function Ki() {
  qj = rj.current;
  H(rj);
}
function Qj(a, b) {
  a.finishedWork = null;
  a.finishedLanes = 0;
  var c = a.timeoutHandle;
  -1 !== c && (a.timeoutHandle = -1, pf(c));
  if (null !== Y) for (c = Y.return; null !== c; ) {
    var d = c;
    switch (d.tag) {
      case 1:
        d = d.type.childContextTypes;
        null !== d && void 0 !== d && Gf();
        break;
      case 3:
        fh();
        H(N);
        H(M);
        uh();
        break;
      case 5:
        hh(d);
        break;
      case 4:
        fh();
        break;
      case 13:
        H(P);
        break;
      case 19:
        H(P);
        break;
      case 10:
        rg(d);
        break;
      case 23:
      case 24:
        Ki();
    }
    c = c.return;
  }
  U = a;
  Y = Tg(a.current, null);
  W = qj = tj = b;
  V = 0;
  sj = null;
  uj = Hi = Dg = 0;
}
function Sj(a, b) {
  do {
    var c = Y;
    try {
      qg();
      vh.current = Gh;
      if (yh) {
        for (var d = R.memoizedState; null !== d; ) {
          var e = d.queue;
          null !== e && (e.pending = null);
          d = d.next;
        }
        yh = false;
      }
      xh = 0;
      T = S = R = null;
      zh = false;
      pj.current = null;
      if (null === c || null === c.return) {
        V = 1;
        sj = b;
        Y = null;
        break;
      }
      a: {
        var f = a, g = c.return, h = c, k = b;
        b = W;
        h.flags |= 2048;
        h.firstEffect = h.lastEffect = null;
        if (null !== k && "object" === typeof k && "function" === typeof k.then) {
          var l = k;
          if (0 === (h.mode & 2)) {
            var n = h.alternate;
            n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
          }
          var A = 0 !== (P.current & 1), p = g;
          do {
            var C;
            if (C = 13 === p.tag) {
              var x = p.memoizedState;
              if (null !== x) C = null !== x.dehydrated ? true : false;
              else {
                var w = p.memoizedProps;
                C = void 0 === w.fallback ? false : true !== w.unstable_avoidThisFallback ? true : A ? false : true;
              }
            }
            if (C) {
              var z = p.updateQueue;
              if (null === z) {
                var u = /* @__PURE__ */ new Set();
                u.add(l);
                p.updateQueue = u;
              } else z.add(l);
              if (0 === (p.mode & 2)) {
                p.flags |= 64;
                h.flags |= 16384;
                h.flags &= -2981;
                if (1 === h.tag) if (null === h.alternate) h.tag = 17;
                else {
                  var t = zg(-1, 1);
                  t.tag = 2;
                  Ag(h, t);
                }
                h.lanes |= 1;
                break a;
              }
              k = void 0;
              h = b;
              var q = f.pingCache;
              null === q ? (q = f.pingCache = new Oi(), k = /* @__PURE__ */ new Set(), q.set(l, k)) : (k = q.get(l), void 0 === k && (k = /* @__PURE__ */ new Set(), q.set(l, k)));
              if (!k.has(h)) {
                k.add(h);
                var v = Yj.bind(null, f, l, h);
                l.then(v, v);
              }
              p.flags |= 4096;
              p.lanes = b;
              break a;
            }
            p = p.return;
          } while (null !== p);
          k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
        }
        5 !== V && (V = 2);
        k = Mi(k, h);
        p = g;
        do {
          switch (p.tag) {
            case 3:
              f = k;
              p.flags |= 4096;
              b &= -b;
              p.lanes |= b;
              var J = Pi(p, f, b);
              Bg(p, J);
              break a;
            case 1:
              f = k;
              var K = p.type, Q = p.stateNode;
              if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                p.flags |= 4096;
                b &= -b;
                p.lanes |= b;
                var L = Si(p, f, b);
                Bg(p, L);
                break a;
              }
          }
          p = p.return;
        } while (null !== p);
      }
      Zj(c);
    } catch (va) {
      b = va;
      Y === c && null !== c && (Y = c = c.return);
      continue;
    }
    break;
  } while (1);
}
function Pj() {
  var a = oj.current;
  oj.current = Gh;
  return null === a ? Gh : a;
}
function Tj(a, b) {
  var c = X;
  X |= 16;
  var d = Pj();
  U === a && W === b || Qj(a, b);
  do
    try {
      ak();
      break;
    } catch (e) {
      Sj(a, e);
    }
  while (1);
  qg();
  X = c;
  oj.current = d;
  if (null !== Y) throw Error(y(261));
  U = null;
  W = 0;
  return V;
}
function ak() {
  for (; null !== Y; ) bk(Y);
}
function Rj() {
  for (; null !== Y && !Qf(); ) bk(Y);
}
function bk(a) {
  var b = ck(a.alternate, a, qj);
  a.memoizedProps = a.pendingProps;
  null === b ? Zj(a) : Y = b;
  pj.current = null;
}
function Zj(a) {
  var b = a;
  do {
    var c = b.alternate;
    a = b.return;
    if (0 === (b.flags & 2048)) {
      c = Gi(c, b, qj);
      if (null !== c) {
        Y = c;
        return;
      }
      c = b;
      if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
        for (var d = 0, e = c.child; null !== e; ) d |= e.lanes | e.childLanes, e = e.sibling;
        c.childLanes = d;
      }
      null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
    } else {
      c = Li(b);
      if (null !== c) {
        c.flags &= 2047;
        Y = c;
        return;
      }
      null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
    }
    b = b.sibling;
    if (null !== b) {
      Y = b;
      return;
    }
    Y = b = a;
  } while (null !== b);
  0 === V && (V = 5);
}
function Uj(a) {
  var b = eg();
  gg(99, dk.bind(null, a, b));
  return null;
}
function dk(a, b) {
  do
    Oj();
  while (null !== yj);
  if (0 !== (X & 48)) throw Error(y(327));
  var c = a.finishedWork;
  if (null === c) return null;
  a.finishedWork = null;
  a.finishedLanes = 0;
  if (c === a.current) throw Error(y(177));
  a.callbackNode = null;
  var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
  a.pendingLanes = e;
  a.suspendedLanes = 0;
  a.pingedLanes = 0;
  a.expiredLanes &= e;
  a.mutableReadLanes &= e;
  a.entangledLanes &= e;
  e = a.entanglements;
  for (var g = a.eventTimes, h = a.expirationTimes; 0 < f; ) {
    var k = 31 - Vc(f), l = 1 << k;
    e[k] = 0;
    g[k] = -1;
    h[k] = -1;
    f &= ~l;
  }
  null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
  a === U && (Y = U = null, W = 0);
  1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
  if (null !== d) {
    e = X;
    X |= 32;
    pj.current = null;
    kf = fd;
    g = Ne();
    if (Oe(g)) {
      if ("selectionStart" in g) h = { start: g.selectionStart, end: g.selectionEnd };
      else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
        h = l.anchorNode;
        f = l.anchorOffset;
        k = l.focusNode;
        l = l.focusOffset;
        try {
          h.nodeType, k.nodeType;
        } catch (va) {
          h = null;
          break a;
        }
        var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
        b: for (; ; ) {
          for (var u; ; ) {
            w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
            w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
            3 === w.nodeType && (n += w.nodeValue.length);
            if (null === (u = w.firstChild)) break;
            z = w;
            w = u;
          }
          for (; ; ) {
            if (w === g) break b;
            z === h && ++C === f && (A = n);
            z === k && ++x === l && (p = n);
            if (null !== (u = w.nextSibling)) break;
            w = z;
            z = w.parentNode;
          }
          w = u;
        }
        h = -1 === A || -1 === p ? null : { start: A, end: p };
      } else h = null;
      h = h || { start: 0, end: 0 };
    } else h = null;
    lf = { focusedElem: g, selectionRange: h };
    fd = false;
    Ij = null;
    Jj = false;
    Z = d;
    do
      try {
        ek();
      } catch (va) {
        if (null === Z) throw Error(y(330));
        Wi(Z, va);
        Z = Z.nextEffect;
      }
    while (null !== Z);
    Ij = null;
    Z = d;
    do
      try {
        for (g = a; null !== Z; ) {
          var t = Z.flags;
          t & 16 && pb(Z.stateNode, "");
          if (t & 128) {
            var q = Z.alternate;
            if (null !== q) {
              var v = q.ref;
              null !== v && ("function" === typeof v ? v(null) : v.current = null);
            }
          }
          switch (t & 1038) {
            case 2:
              fj(Z);
              Z.flags &= -3;
              break;
            case 6:
              fj(Z);
              Z.flags &= -3;
              ij(Z.alternate, Z);
              break;
            case 1024:
              Z.flags &= -1025;
              break;
            case 1028:
              Z.flags &= -1025;
              ij(Z.alternate, Z);
              break;
            case 4:
              ij(Z.alternate, Z);
              break;
            case 8:
              h = Z;
              cj(g, h);
              var J = h.alternate;
              dj(h);
              null !== J && dj(J);
          }
          Z = Z.nextEffect;
        }
      } catch (va) {
        if (null === Z) throw Error(y(330));
        Wi(Z, va);
        Z = Z.nextEffect;
      }
    while (null !== Z);
    v = lf;
    q = Ne();
    t = v.focusedElem;
    g = v.selectionRange;
    if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
      null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
      q = [];
      for (v = t; v = v.parentNode; ) 1 === v.nodeType && q.push({ element: v, left: v.scrollLeft, top: v.scrollTop });
      "function" === typeof t.focus && t.focus();
      for (t = 0; t < q.length; t++) v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
    }
    fd = !!kf;
    lf = kf = null;
    a.current = c;
    Z = d;
    do
      try {
        for (t = a; null !== Z; ) {
          var K = Z.flags;
          K & 36 && Yi(t, Z.alternate, Z);
          if (K & 128) {
            q = void 0;
            var Q = Z.ref;
            if (null !== Q) {
              var L = Z.stateNode;
              switch (Z.tag) {
                case 5:
                  q = L;
                  break;
                default:
                  q = L;
              }
              "function" === typeof Q ? Q(q) : Q.current = q;
            }
          }
          Z = Z.nextEffect;
        }
      } catch (va) {
        if (null === Z) throw Error(y(330));
        Wi(Z, va);
        Z = Z.nextEffect;
      }
    while (null !== Z);
    Z = null;
    $f();
    X = e;
  } else a.current = c;
  if (xj) xj = false, yj = a, zj = b;
  else for (Z = d; null !== Z; ) b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
  d = a.pendingLanes;
  0 === d && (Ti = null);
  1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
  c = c.stateNode;
  if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
    Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
  } catch (va) {
  }
  Mj(a, O());
  if (Qi) throw Qi = false, a = Ri, Ri = null, a;
  if (0 !== (X & 8)) return null;
  ig();
  return null;
}
function ek() {
  for (; null !== Z; ) {
    var a = Z.alternate;
    Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = true) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = true));
    var b = Z.flags;
    0 !== (b & 256) && Xi(a, Z);
    0 === (b & 512) || xj || (xj = true, hg(97, function() {
      Oj();
      return null;
    }));
    Z = Z.nextEffect;
  }
}
function Oj() {
  if (90 !== zj) {
    var a = 97 < zj ? 97 : zj;
    zj = 90;
    return gg(a, fk);
  }
  return false;
}
function $i(a, b) {
  Aj.push(b, a);
  xj || (xj = true, hg(97, function() {
    Oj();
    return null;
  }));
}
function Zi(a, b) {
  Bj.push(b, a);
  xj || (xj = true, hg(97, function() {
    Oj();
    return null;
  }));
}
function fk() {
  if (null === yj) return false;
  var a = yj;
  yj = null;
  if (0 !== (X & 48)) throw Error(y(331));
  var b = X;
  X |= 32;
  var c = Bj;
  Bj = [];
  for (var d = 0; d < c.length; d += 2) {
    var e = c[d], f = c[d + 1], g = e.destroy;
    e.destroy = void 0;
    if ("function" === typeof g) try {
      g();
    } catch (k) {
      if (null === f) throw Error(y(330));
      Wi(f, k);
    }
  }
  c = Aj;
  Aj = [];
  for (d = 0; d < c.length; d += 2) {
    e = c[d];
    f = c[d + 1];
    try {
      var h = e.create;
      e.destroy = h();
    } catch (k) {
      if (null === f) throw Error(y(330));
      Wi(f, k);
    }
  }
  for (h = a.current.firstEffect; null !== h; ) a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
  X = b;
  ig();
  return true;
}
function gk(a, b, c) {
  b = Mi(c, b);
  b = Pi(a, b, 1);
  Ag(a, b);
  b = Hg();
  a = Kj(a, 1);
  null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
  if (3 === a.tag) gk(a, a, b);
  else for (var c = a.return; null !== c; ) {
    if (3 === c.tag) {
      gk(c, a, b);
      break;
    } else if (1 === c.tag) {
      var d = c.stateNode;
      if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
        a = Mi(b, a);
        var e = Si(c, a, 1);
        Ag(c, e);
        e = Hg();
        c = Kj(c, 1);
        if (null !== c) $c(c, 1, e), Mj(c, e);
        else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
          d.componentDidCatch(b, a);
        } catch (f) {
        }
        break;
      }
    }
    c = c.return;
  }
}
function Yj(a, b, c) {
  var d = a.pingCache;
  null !== d && d.delete(b);
  b = Hg();
  a.pingedLanes |= a.suspendedLanes & c;
  U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
  Mj(a, b);
}
function lj(a, b) {
  var c = a.stateNode;
  null !== c && c.delete(b);
  b = 0;
  0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
  c = Hg();
  a = Kj(a, b);
  null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
  var d = b.lanes;
  if (null !== a) if (a.memoizedProps !== b.pendingProps || N.current) ug = true;
  else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? true : false;
  else {
    ug = false;
    switch (b.tag) {
      case 3:
        ri(b);
        sh();
        break;
      case 5:
        gh(b);
        break;
      case 1:
        Ff(b.type) && Jf(b);
        break;
      case 4:
        eh(b, b.stateNode.containerInfo);
        break;
      case 10:
        d = b.memoizedProps.value;
        var e = b.type._context;
        I(mg, e._currentValue);
        e._currentValue = d;
        break;
      case 13:
        if (null !== b.memoizedState) {
          if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
          I(P, P.current & 1);
          b = hi(a, b, c);
          return null !== b ? b.sibling : null;
        }
        I(P, P.current & 1);
        break;
      case 19:
        d = 0 !== (c & b.childLanes);
        if (0 !== (a.flags & 64)) {
          if (d) return Ai(a, b, c);
          b.flags |= 64;
        }
        e = b.memoizedState;
        null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
        I(P, P.current);
        if (d) break;
        else return null;
      case 23:
      case 24:
        return b.lanes = 0, mi(a, b, c);
    }
    return hi(a, b, c);
  }
  else ug = false;
  b.lanes = 0;
  switch (b.tag) {
    case 2:
      d = b.type;
      null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
      a = b.pendingProps;
      e = Ef(b, M.current);
      tg(b, c);
      e = Ch(null, b, d, a, e, c);
      b.flags |= 1;
      if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
        b.tag = 1;
        b.memoizedState = null;
        b.updateQueue = null;
        if (Ff(d)) {
          var f = true;
          Jf(b);
        } else f = false;
        b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
        xg(b);
        var g = d.getDerivedStateFromProps;
        "function" === typeof g && Gg(b, d, g, a);
        e.updater = Kg;
        b.stateNode = e;
        e._reactInternals = b;
        Og(b, d, a, c);
        b = qi(null, b, d, true, f, c);
      } else b.tag = 0, fi(null, b, e, c), b = b.child;
      return b;
    case 16:
      e = b.elementType;
      a: {
        null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
        a = b.pendingProps;
        f = e._init;
        e = f(e._payload);
        b.type = e;
        f = b.tag = hk(e);
        a = lg(e, a);
        switch (f) {
          case 0:
            b = li(null, b, e, a, c);
            break a;
          case 1:
            b = pi(null, b, e, a, c);
            break a;
          case 11:
            b = gi(null, b, e, a, c);
            break a;
          case 14:
            b = ii(null, b, e, lg(e.type, a), d, c);
            break a;
        }
        throw Error(y(306, e, ""));
      }
      return b;
    case 0:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
    case 1:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
    case 3:
      ri(b);
      d = b.updateQueue;
      if (null === a || null === d) throw Error(y(282));
      d = b.pendingProps;
      e = b.memoizedState;
      e = null !== e ? e.element : null;
      yg(a, b);
      Cg(b, d, null, c);
      d = b.memoizedState.element;
      if (d === e) sh(), b = hi(a, b, c);
      else {
        e = b.stateNode;
        if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = true;
        if (f) {
          a = e.mutableSourceEagerHydrationData;
          if (null != a) for (e = 0; e < a.length; e += 2) f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
          c = Zg(b, null, d, c);
          for (b.child = c; c; ) c.flags = c.flags & -3 | 1024, c = c.sibling;
        } else fi(a, b, d, c), sh();
        b = b.child;
      }
      return b;
    case 5:
      return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
    case 6:
      return null === a && ph(b), null;
    case 13:
      return ti(a, b, c);
    case 4:
      return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
    case 11:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
    case 7:
      return fi(a, b, b.pendingProps, c), b.child;
    case 8:
      return fi(
        a,
        b,
        b.pendingProps.children,
        c
      ), b.child;
    case 12:
      return fi(a, b, b.pendingProps.children, c), b.child;
    case 10:
      a: {
        d = b.type._context;
        e = b.pendingProps;
        g = b.memoizedProps;
        f = e.value;
        var h = b.type._context;
        I(mg, h._currentValue);
        h._currentValue = f;
        if (null !== g) if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
          if (g.children === e.children && !N.current) {
            b = hi(a, b, c);
            break a;
          }
        } else for (h = b.child, null !== h && (h.return = b); null !== h; ) {
          var k = h.dependencies;
          if (null !== k) {
            g = h.child;
            for (var l = k.firstContext; null !== l; ) {
              if (l.context === d && 0 !== (l.observedBits & f)) {
                1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                h.lanes |= c;
                l = h.alternate;
                null !== l && (l.lanes |= c);
                sg(h.return, c);
                k.lanes |= c;
                break;
              }
              l = l.next;
            }
          } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
          if (null !== g) g.return = h;
          else for (g = h; null !== g; ) {
            if (g === b) {
              g = null;
              break;
            }
            h = g.sibling;
            if (null !== h) {
              h.return = g.return;
              g = h;
              break;
            }
            g = g.return;
          }
          h = g;
        }
        fi(a, b, e.children, c);
        b = b.child;
      }
      return b;
    case 9:
      return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(
        e,
        f.unstable_observedBits
      ), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
    case 14:
      return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
    case 15:
      return ki(a, b, b.type, b.pendingProps, d, c);
    case 17:
      return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = true, Jf(b)) : a = false, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, true, a, c);
    case 19:
      return Ai(a, b, c);
    case 23:
      return mi(a, b, c);
    case 24:
      return mi(a, b, c);
  }
  throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
  this.tag = a;
  this.key = c;
  this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
  this.index = 0;
  this.ref = null;
  this.pendingProps = b;
  this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
  this.mode = d;
  this.flags = 0;
  this.lastEffect = this.firstEffect = this.nextEffect = null;
  this.childLanes = this.lanes = 0;
  this.alternate = null;
}
function nh(a, b, c, d) {
  return new ik(a, b, c, d);
}
function ji(a) {
  a = a.prototype;
  return !(!a || !a.isReactComponent);
}
function hk(a) {
  if ("function" === typeof a) return ji(a) ? 1 : 0;
  if (void 0 !== a && null !== a) {
    a = a.$$typeof;
    if (a === Aa) return 11;
    if (a === Da) return 14;
  }
  return 2;
}
function Tg(a, b) {
  var c = a.alternate;
  null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
  c.childLanes = a.childLanes;
  c.lanes = a.lanes;
  c.child = a.child;
  c.memoizedProps = a.memoizedProps;
  c.memoizedState = a.memoizedState;
  c.updateQueue = a.updateQueue;
  b = a.dependencies;
  c.dependencies = null === b ? null : { lanes: b.lanes, firstContext: b.firstContext };
  c.sibling = a.sibling;
  c.index = a.index;
  c.ref = a.ref;
  return c;
}
function Vg(a, b, c, d, e, f) {
  var g = 2;
  d = a;
  if ("function" === typeof a) ji(a) && (g = 1);
  else if ("string" === typeof a) g = 5;
  else a: switch (a) {
    case ua:
      return Xg(c.children, e, f, b);
    case Ha:
      g = 8;
      e |= 16;
      break;
    case wa:
      g = 8;
      e |= 1;
      break;
    case xa:
      return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
    case Ba:
      return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
    case Ca:
      return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
    case Ia:
      return vi(c, e, f, b);
    case Ja:
      return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
    default:
      if ("object" === typeof a && null !== a) switch (a.$$typeof) {
        case ya:
          g = 10;
          break a;
        case za:
          g = 9;
          break a;
        case Aa:
          g = 11;
          break a;
        case Da:
          g = 14;
          break a;
        case Ea:
          g = 16;
          d = null;
          break a;
        case Fa:
          g = 22;
          break a;
      }
      throw Error(y(130, null == a ? a : typeof a, ""));
  }
  b = nh(g, c, b, e);
  b.elementType = a;
  b.type = d;
  b.lanes = f;
  return b;
}
function Xg(a, b, c, d) {
  a = nh(7, a, d, b);
  a.lanes = c;
  return a;
}
function vi(a, b, c, d) {
  a = nh(23, a, d, b);
  a.elementType = Ia;
  a.lanes = c;
  return a;
}
function Ug(a, b, c) {
  a = nh(6, a, null, b);
  a.lanes = c;
  return a;
}
function Wg(a, b, c) {
  b = nh(4, null !== a.children ? a.children : [], a.key, b);
  b.lanes = c;
  b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };
  return b;
}
function jk(a, b, c) {
  this.tag = b;
  this.containerInfo = a;
  this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
  this.timeoutHandle = -1;
  this.pendingContext = this.context = null;
  this.hydrate = c;
  this.callbackNode = null;
  this.callbackPriority = 0;
  this.eventTimes = Zc(0);
  this.expirationTimes = Zc(-1);
  this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
  this.entanglements = Zc(0);
  this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
  return { $$typeof: ta, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
}
function lk(a, b, c, d) {
  var e = b.current, f = Hg(), g = Ig(e);
  a: if (c) {
    c = c._reactInternals;
    b: {
      if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
      var h = c;
      do {
        switch (h.tag) {
          case 3:
            h = h.stateNode.context;
            break b;
          case 1:
            if (Ff(h.type)) {
              h = h.stateNode.__reactInternalMemoizedMergedChildContext;
              break b;
            }
        }
        h = h.return;
      } while (null !== h);
      throw Error(y(171));
    }
    if (1 === c.tag) {
      var k = c.type;
      if (Ff(k)) {
        c = If(c, k, h);
        break a;
      }
    }
    c = h;
  } else c = Cf;
  null === b.context ? b.context = c : b.pendingContext = c;
  b = zg(f, g);
  b.payload = { element: a };
  d = void 0 === d ? null : d;
  null !== d && (b.callback = d);
  Ag(e, b);
  Jg(e, g, f);
  return g;
}
function mk(a) {
  a = a.current;
  if (!a.child) return null;
  switch (a.child.tag) {
    case 5:
      return a.child.stateNode;
    default:
      return a.child.stateNode;
  }
}
function nk(a, b) {
  a = a.memoizedState;
  if (null !== a && null !== a.dehydrated) {
    var c = a.retryLane;
    a.retryLane = 0 !== c && c < b ? c : b;
  }
}
function ok(a, b) {
  nk(a, b);
  (a = a.alternate) && nk(a, b);
}
function pk() {
  return null;
}
function qk(a, b, c) {
  var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
  c = new jk(a, b, null != c && true === c.hydrate);
  b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
  c.current = b;
  b.stateNode = c;
  xg(b);
  a[ff] = c.current;
  cf(8 === a.nodeType ? a.parentNode : a);
  if (d) for (a = 0; a < d.length; a++) {
    b = d[a];
    var e = b._getVersion;
    e = e(b._source);
    null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [b, e] : c.mutableSourceEagerHydrationData.push(b, e);
  }
  this._internalRoot = c;
}
qk.prototype.render = function(a) {
  lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
  var a = this._internalRoot, b = a.containerInfo;
  lk(null, a, null, function() {
    b[ff] = null;
  });
};
function rk(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
  b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
  if (!b) for (var c; c = a.lastChild; ) a.removeChild(c);
  return new qk(a, 0, b ? { hydrate: true } : void 0);
}
function tk(a, b, c, d, e) {
  var f = c._reactRootContainer;
  if (f) {
    var g = f._internalRoot;
    if ("function" === typeof e) {
      var h = e;
      e = function() {
        var a2 = mk(g);
        h.call(a2);
      };
    }
    lk(b, g, a, e);
  } else {
    f = c._reactRootContainer = sk(c, d);
    g = f._internalRoot;
    if ("function" === typeof e) {
      var k = e;
      e = function() {
        var a2 = mk(g);
        k.call(a2);
      };
    }
    Xj(function() {
      lk(b, g, a, e);
    });
  }
  return mk(g);
}
ec = function(a) {
  if (13 === a.tag) {
    var b = Hg();
    Jg(a, 4, b);
    ok(a, 4);
  }
};
fc = function(a) {
  if (13 === a.tag) {
    var b = Hg();
    Jg(a, 67108864, b);
    ok(a, 67108864);
  }
};
gc = function(a) {
  if (13 === a.tag) {
    var b = Hg(), c = Ig(a);
    Jg(a, c, b);
    ok(a, c);
  }
};
hc = function(a, b) {
  return b();
};
yb = function(a, b, c) {
  switch (b) {
    case "input":
      ab(a, c);
      b = c.name;
      if ("radio" === c.type && null != b) {
        for (c = a; c.parentNode; ) c = c.parentNode;
        c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
        for (b = 0; b < c.length; b++) {
          var d = c[b];
          if (d !== a && d.form === a.form) {
            var e = Db(d);
            if (!e) throw Error(y(90));
            Wa(d);
            ab(d, e);
          }
        }
      }
      break;
    case "textarea":
      ib(a, c);
      break;
    case "select":
      b = c.value, null != b && fb(a, !!c.multiple, b, false);
  }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
  var f = X;
  X |= 4;
  try {
    return gg(98, a.bind(null, b, c, d, e));
  } finally {
    X = f, 0 === X && (wj(), ig());
  }
};
Ib = function() {
  0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
  var c = X;
  X |= 2;
  try {
    return a(b);
  } finally {
    X = c, 0 === X && (wj(), ig());
  }
};
function uk(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
  if (!rk(b)) throw Error(y(200));
  return kk(a, b, null, c);
}
var vk = { Events: [Cb, ue, Db, Eb, Fb, Oj, { current: false }] }, wk = { findFiberByHostInstance: wc, bundleType: 0, version: "17.0.2", rendererPackageName: "react-dom" };
var xk = { bundleType: wk.bundleType, version: wk.version, rendererPackageName: wk.rendererPackageName, rendererConfig: wk.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: ra.ReactCurrentDispatcher, findHostInstanceByFiber: function(a) {
  a = cc(a);
  return null === a ? null : a.stateNode;
}, findFiberByHostInstance: wk.findFiberByHostInstance || pk, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null };
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
  var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!yk.isDisabled && yk.supportsFiber) try {
    Lf = yk.inject(xk), Mf = yk;
  } catch (a) {
  }
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
  if (null == a) return null;
  if (1 === a.nodeType) return a;
  var b = a._reactInternals;
  if (void 0 === b) {
    if ("function" === typeof a.render) throw Error(y(188));
    throw Error(y(268, Object.keys(a)));
  }
  a = cc(b);
  a = null === a ? null : a.stateNode;
  return a;
};
exports.flushSync = function(a, b) {
  var c = X;
  if (0 !== (c & 48)) return a(b);
  X |= 1;
  try {
    if (a) return gg(99, a.bind(null, b));
  } finally {
    X = c, ig();
  }
};
exports.hydrate = function(a, b, c) {
  if (!rk(b)) throw Error(y(200));
  return tk(null, a, b, true, c);
};
exports.render = function(a, b, c) {
  if (!rk(b)) throw Error(y(200));
  return tk(null, a, b, false, c);
};
exports.unmountComponentAtNode = function(a) {
  if (!rk(a)) throw Error(y(40));
  return a._reactRootContainer ? (Xj(function() {
    tk(null, null, a, false, function() {
      a._reactRootContainer = null;
      a[ff] = null;
    });
  }), true) : false;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
  return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
  if (!rk(c)) throw Error(y(200));
  if (null == a || void 0 === a._reactInternals) throw Error(y(38));
  return tk(a, b, c, false, d);
};
exports.version = "17.0.2";


/***/ }),

/***/ 13499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

function checkDCE() {
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
    return;
  }
  if (false) // removed by dead control flow
{}
  try {
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    console.error(err);
  }
}
if (true) {
  checkDCE();
  module.exports = __webpack_require__(47261);
} else // removed by dead control flow
{}


/***/ }),

/***/ 13205:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = 60103, c = 60106, d = 60107, e = 60108, f = 60114, g = 60109, h = 60110, k = 60112, l = 60113, m = 60120, n = 60115, p = 60116, q = 60121, r = 60122, u = 60117, v = 60129, w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
  var x = Symbol.for;
  b = x("react.element");
  c = x("react.portal");
  d = x("react.fragment");
  e = x("react.strict_mode");
  f = x("react.profiler");
  g = x("react.provider");
  h = x("react.context");
  k = x("react.forward_ref");
  l = x("react.suspense");
  m = x("react.suspense_list");
  n = x("react.memo");
  p = x("react.lazy");
  q = x("react.block");
  r = x("react.server.block");
  u = x("react.fundamental");
  v = x("react.debug_trace_mode");
  w = x("react.legacy_hidden");
}
function y(a) {
  if ("object" === typeof a && null !== a) {
    var t = a.$$typeof;
    switch (t) {
      case b:
        switch (a = a.type, a) {
          case d:
          case f:
          case e:
          case l:
          case m:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case h:
              case k:
              case p:
              case n:
              case g:
                return a;
              default:
                return t;
            }
        }
      case c:
        return t;
    }
  }
}
var z = g, A = b, B = k, C = d, D = p, E = n, F = c, G = f, H = e, I = l;
__webpack_unused_export__ = h;
__webpack_unused_export__ = z;
__webpack_unused_export__ = A;
__webpack_unused_export__ = B;
__webpack_unused_export__ = C;
__webpack_unused_export__ = D;
__webpack_unused_export__ = E;
__webpack_unused_export__ = F;
__webpack_unused_export__ = G;
__webpack_unused_export__ = H;
__webpack_unused_export__ = I;
__webpack_unused_export__ = function() {
  return false;
};
__webpack_unused_export__ = function() {
  return false;
};
exports.isContextConsumer = function(a) {
  return y(a) === h;
};
__webpack_unused_export__ = function(a) {
  return y(a) === g;
};
__webpack_unused_export__ = function(a) {
  return "object" === typeof a && null !== a && a.$$typeof === b;
};
__webpack_unused_export__ = function(a) {
  return y(a) === k;
};
__webpack_unused_export__ = function(a) {
  return y(a) === d;
};
__webpack_unused_export__ = function(a) {
  return y(a) === p;
};
__webpack_unused_export__ = function(a) {
  return y(a) === n;
};
__webpack_unused_export__ = function(a) {
  return y(a) === c;
};
__webpack_unused_export__ = function(a) {
  return y(a) === f;
};
__webpack_unused_export__ = function(a) {
  return y(a) === e;
};
__webpack_unused_export__ = function(a) {
  return y(a) === l;
};
__webpack_unused_export__ = function(a) {
  return "string" === typeof a || "function" === typeof a || a === d || a === f || a === v || a === e || a === l || a === m || a === w || "object" === typeof a && null !== a && (a.$$typeof === p || a.$$typeof === n || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r) ? true : false;
};
__webpack_unused_export__ = y;


/***/ }),

/***/ 94249:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

if (true) {
  module.exports = __webpack_require__(13205);
} else // removed by dead control flow
{}


/***/ }),

/***/ 57847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  BrowserRouter: function() { return /* binding */ BrowserRouter; },
  HashRouter: function() { return /* binding */ HashRouter; },
  Link: function() { return /* binding */ Link; },
  MemoryRouter: function() { return /* reexport */ MemoryRouter; },
  NavLink: function() { return /* binding */ NavLink; },
  Prompt: function() { return /* reexport */ Prompt; },
  Redirect: function() { return /* reexport */ Redirect; },
  Route: function() { return /* reexport */ Route; },
  Router: function() { return /* reexport */ Router; },
  StaticRouter: function() { return /* reexport */ StaticRouter; },
  Switch: function() { return /* reexport */ Switch; },
  generatePath: function() { return /* reexport */ generatePath; },
  matchPath: function() { return /* reexport */ matchPath; },
  useHistory: function() { return /* reexport */ useHistory; },
  useLocation: function() { return /* reexport */ useLocation; },
  useParams: function() { return /* reexport */ useParams; },
  useRouteMatch: function() { return /* reexport */ useRouteMatch; },
  withRouter: function() { return /* reexport */ withRouter; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(34280);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(52074);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/history/esm/history.js + 2 modules
var esm_history = __webpack_require__(60396);
// EXTERNAL MODULE: ./node_modules/tiny-invariant/dist/esm/tiny-invariant.js
var tiny_invariant = __webpack_require__(51910);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
// EXTERNAL MODULE: ./node_modules/path-to-regexp/index.js
var path_to_regexp = __webpack_require__(69436);
var path_to_regexp_default = /*#__PURE__*/__webpack_require__.n(path_to_regexp);
// EXTERNAL MODULE: ./node_modules/react-router/node_modules/react-is/index.js
var react_is = __webpack_require__(24050);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(90018);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(78576);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// ./node_modules/react-router/esm/react-router.js











var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== "undefined" ? (
  // eslint-disable-next-line no-undef
  globalThis
) : typeof window !== "undefined" ? window : typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : {};
function getUniqueId() {
  var key2 = "__global_unique_id__";
  return commonjsGlobal[key2] = (commonjsGlobal[key2] || 0) + 1;
}
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function(h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function(handler) {
        return handler(value, changedBits);
      });
    }
  };
}
function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}
function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;
  var contextProp = "__create-react-context-" + getUniqueId() + "__";
  var Provider = /* @__PURE__ */ (function(_React$Component) {
    (0,inheritsLoose/* default */.A)(Provider2, _React$Component);
    function Provider2() {
      var _this;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }
    var _proto = Provider2.prototype;
    _proto.getChildContext = function getChildContext() {
      var _ref;
      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };
    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;
        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) // removed by dead control flow
{}
          changedBits |= 0;
          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };
    _proto.render = function render() {
      return this.props.children;
    };
    return Provider2;
  })(index_js_eager_.Component);
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (prop_types_default()).object.isRequired, _Provider$childContex);
  var Consumer = /* @__PURE__ */ (function(_React$Component2) {
    (0,inheritsLoose/* default */.A)(Consumer2, _React$Component2);
    function Consumer2() {
      var _this2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      _this2 = _React$Component2.call.apply(_React$Component2, [this].concat(args)) || this;
      _this2.observedBits = void 0;
      _this2.state = {
        value: _this2.getValue()
      };
      _this2.onUpdate = function(newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };
      return _this2;
    }
    var _proto2 = Consumer2.prototype;
    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === void 0 || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };
    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === void 0 || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };
    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };
    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };
    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };
    return Consumer2;
  })(index_js_eager_.Component);
  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (prop_types_default()).object, _Consumer$contextType);
  return {
    Provider,
    Consumer
  };
}
var createContext = index_js_eager_.createContext || createReactContext;
var createNamedContext = function createNamedContext2(name) {
  var context2 = createContext();
  context2.displayName = name;
  return context2;
};
var historyContext = /* @__PURE__ */ createNamedContext("Router-History");
var context = /* @__PURE__ */ createNamedContext("Router");
var Router = /* @__PURE__ */ (function(_React$Component) {
  (0,inheritsLoose/* default */.A)(Router2, _React$Component);
  Router2.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };
  function Router2(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    };
    _this._isMounted = false;
    _this._pendingLocation = null;
    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function(location) {
        _this._pendingLocation = location;
      });
    }
    return _this;
  }
  var _proto = Router2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    this._isMounted = true;
    if (this.unlisten) {
      this.unlisten();
    }
    if (!this.props.staticContext) {
      this.unlisten = this.props.history.listen(function(location) {
        if (_this2._isMounted) {
          _this2.setState({
            location
          });
        }
      });
    }
    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
      this._isMounted = false;
      this._pendingLocation = null;
    }
  };
  _proto.render = function render() {
    return /* @__PURE__ */ index_js_eager_.createElement(context.Provider, {
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router2.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    }, /* @__PURE__ */ index_js_eager_.createElement(historyContext.Provider, {
      children: this.props.children || null,
      value: this.props.history
    }));
  };
  return Router2;
})(index_js_eager_.Component);
if (false) // removed by dead control flow
{}
var MemoryRouter = /* @__PURE__ */ (function(_React$Component) {
  (0,inheritsLoose/* default */.A)(MemoryRouter2, _React$Component);
  function MemoryRouter2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = (0,esm_history/* createMemoryHistory */.sC)(_this.props);
    return _this;
  }
  var _proto = MemoryRouter2.prototype;
  _proto.render = function render() {
    return /* @__PURE__ */ index_js_eager_.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };
  return MemoryRouter2;
})(index_js_eager_.Component);
if (false) // removed by dead control flow
{}
var Lifecycle = /* @__PURE__ */ (function(_React$Component) {
  (0,inheritsLoose/* default */.A)(Lifecycle2, _React$Component);
  function Lifecycle2() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = Lifecycle2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };
  _proto.render = function render() {
    return null;
  };
  return Lifecycle2;
})(index_js_eager_.Component);
function Prompt(_ref) {
  var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
  return /* @__PURE__ */ index_js_eager_.createElement(context.Consumer, null, function(context2) {
    !context2 ?  false ? 0 : (0,tiny_invariant/* default */.A)(false) : void 0;
    if (!when || context2.staticContext) return null;
    var method = context2.history.block;
    return /* @__PURE__ */ index_js_eager_.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message
    });
  });
}
if (false) // removed by dead control flow
{ var messageType; }
var cache = {};
var cacheLimit = 1e4;
var cacheCount = 0;
function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = path_to_regexp_default().compile(path);
  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }
  return generator;
}
function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }
  if (params === void 0) {
    params = {};
  }
  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}
function Redirect(_ref) {
  var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
  return /* @__PURE__ */ index_js_eager_.createElement(context.Consumer, null, function(context2) {
    !context2 ?  false ? 0 : (0,tiny_invariant/* default */.A)(false) : void 0;
    var history = context2.history, staticContext = context2.staticContext;
    var method = push ? history.push : history.replace;
    var location = (0,esm_history/* createLocation */.yJ)(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : (0,esm_extends/* default */.A)({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to);
    if (staticContext) {
      method(location);
      return null;
    }
    return /* @__PURE__ */ index_js_eager_.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = (0,esm_history/* createLocation */.yJ)(prevProps.to);
        if (!(0,esm_history/* locationsAreEqual */.Fu)(prevLocation, (0,esm_extends/* default */.A)({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to
    });
  });
}
if (false) // removed by dead control flow
{}
var cache$1 = {};
var cacheLimit$1 = 1e4;
var cacheCount$1 = 0;
function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = path_to_regexp_default()(path, keys, options);
  var result = {
    regexp,
    keys
  };
  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }
  return result;
}
function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }
  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }
  var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function(matched, path2) {
    if (!path2 && path2 !== "") return null;
    if (matched) return matched;
    var _compilePath = compilePath$1(path2, {
      end: exact,
      strict,
      sensitive
    }), regexp = _compilePath.regexp, keys = _compilePath.keys;
    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0], values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path2,
      // the path used to match
      url: path2 === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact,
      // whether or not we matched exactly
      params: keys.reduce(function(memo, key2, index) {
        memo[key2.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}
function isEmptyChildren(children) {
  return index_js_eager_.Children.count(children) === 0;
}
function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? 0 : void 0;
  return value || null;
}
var Route = /* @__PURE__ */ (function(_React$Component) {
  (0,inheritsLoose/* default */.A)(Route2, _React$Component);
  function Route2() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = Route2.prototype;
  _proto.render = function render() {
    var _this = this;
    return /* @__PURE__ */ index_js_eager_.createElement(context.Consumer, null, function(context$1) {
      !context$1 ?  false ? 0 : (0,tiny_invariant/* default */.A)(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;
      var props = (0,esm_extends/* default */.A)({}, context$1, {
        location,
        match
      });
      var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render2 = _this$props.render;
      if (Array.isArray(children) && isEmptyChildren(children)) {
        children = null;
      }
      return /* @__PURE__ */ index_js_eager_.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? 0 : children(props) : children : component ? /* @__PURE__ */ index_js_eager_.createElement(component, props) : render2 ? render2(props) : null : typeof children === "function" ?  false ? 0 : children(props) : null);
    });
  };
  return Route2;
})(index_js_eager_.Component);
if (false) // removed by dead control flow
{}
function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}
function addBasename(basename, location) {
  if (!basename) return location;
  return (0,esm_extends/* default */.A)({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}
function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return (0,esm_extends/* default */.A)({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}
function createURL(location) {
  return typeof location === "string" ? location : (0,esm_history/* createPath */.AO)(location);
}
function staticHandler(methodName) {
  return function() {
     false ? 0 : (0,tiny_invariant/* default */.A)(false);
  };
}
function noop() {
}
var StaticRouter = /* @__PURE__ */ (function(_React$Component) {
  (0,inheritsLoose/* default */.A)(StaticRouter2, _React$Component);
  function StaticRouter2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.handlePush = function(location) {
      return _this.navigateTo(location, "PUSH");
    };
    _this.handleReplace = function(location) {
      return _this.navigateTo(location, "REPLACE");
    };
    _this.handleListen = function() {
      return noop;
    };
    _this.handleBlock = function() {
      return noop;
    };
    return _this;
  }
  var _proto = StaticRouter2.prototype;
  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context2 = _this$props$context === void 0 ? {} : _this$props$context;
    context2.action = action;
    context2.location = addBasename(basename, (0,esm_history/* createLocation */.yJ)(location));
    context2.url = createURL(context2.location);
  };
  _proto.render = function render() {
    var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context2 = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0,objectWithoutPropertiesLoose/* default */.A)(_this$props2, ["basename", "context", "location"]);
    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, (0,esm_history/* createLocation */.yJ)(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return /* @__PURE__ */ index_js_eager_.createElement(Router, (0,esm_extends/* default */.A)({}, rest, {
      history,
      staticContext: context2
    }));
  };
  return StaticRouter2;
})(index_js_eager_.Component);
if (false) // removed by dead control flow
{}
var Switch = /* @__PURE__ */ (function(_React$Component) {
  (0,inheritsLoose/* default */.A)(Switch2, _React$Component);
  function Switch2() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = Switch2.prototype;
  _proto.render = function render() {
    var _this = this;
    return /* @__PURE__ */ index_js_eager_.createElement(context.Consumer, null, function(context2) {
      !context2 ?  false ? 0 : (0,tiny_invariant/* default */.A)(false) : void 0;
      var location = _this.props.location || context2.location;
      var element, match;
      index_js_eager_.Children.forEach(_this.props.children, function(child) {
        if (match == null && /* @__PURE__ */ index_js_eager_.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, (0,esm_extends/* default */.A)({}, child.props, {
            path
          })) : context2.match;
        }
      });
      return match ? /* @__PURE__ */ index_js_eager_.cloneElement(element, {
        location,
        computedMatch: match
      }) : null;
    });
  };
  return Switch2;
})(index_js_eager_.Component);
if (false) // removed by dead control flow
{}
function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  var C = function C2(props) {
    var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0,objectWithoutPropertiesLoose/* default */.A)(props, ["wrappedComponentRef"]);
    return /* @__PURE__ */ index_js_eager_.createElement(context.Consumer, null, function(context2) {
      !context2 ?  false ? 0 : (0,tiny_invariant/* default */.A)(false) : void 0;
      return /* @__PURE__ */ index_js_eager_.createElement(Component, (0,esm_extends/* default */.A)({}, remainingProps, context2, {
        ref: wrappedComponentRef
      }));
    });
  };
  C.displayName = displayName;
  C.WrappedComponent = Component;
  if (false) // removed by dead control flow
{}
  return hoist_non_react_statics_cjs_default()(C, Component);
}
var useContext = index_js_eager_.useContext;
function useHistory() {
  if (false) // removed by dead control flow
{}
  return useContext(historyContext);
}
function useLocation() {
  if (false) // removed by dead control flow
{}
  return useContext(context).location;
}
function useParams() {
  if (false) // removed by dead control flow
{}
  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) // removed by dead control flow
{}
  var location = useLocation();
  var match = useContext(context).match;
  return path ? matchPath(location.pathname, path) : match;
}
if (false) // removed by dead control flow
{ var secondaryBuildName, initialBuildName, buildNames, key, global$1; }


;// ./node_modules/react-router-dom/esm/react-router-dom.js










var BrowserRouter = /* @__PURE__ */ (function(_React$Component) {
  (0,inheritsLoose/* default */.A)(BrowserRouter2, _React$Component);
  function BrowserRouter2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = (0,esm_history/* createBrowserHistory */.zR)(_this.props);
    return _this;
  }
  var _proto = BrowserRouter2.prototype;
  _proto.render = function render() {
    return /* @__PURE__ */ index_js_eager_.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };
  return BrowserRouter2;
})(index_js_eager_.Component);
if (false) // removed by dead control flow
{}
var HashRouter = /* @__PURE__ */ (function(_React$Component) {
  (0,inheritsLoose/* default */.A)(HashRouter2, _React$Component);
  function HashRouter2() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = (0,esm_history/* createHashHistory */.TM)(_this.props);
    return _this;
  }
  var _proto = HashRouter2.prototype;
  _proto.render = function render() {
    return /* @__PURE__ */ index_js_eager_.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };
  return HashRouter2;
})(index_js_eager_.Component);
if (false) // removed by dead control flow
{}
var resolveToLocation = function resolveToLocation2(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation2(to, currentLocation) {
  return typeof to === "string" ? (0,esm_history/* createLocation */.yJ)(to, null, null, currentLocation) : to;
};
var forwardRefShim = function forwardRefShim2(C) {
  return C;
};
var forwardRef = index_js_eager_.forwardRef;
if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}
function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var LinkAnchor = forwardRef(function(_ref, forwardedRef) {
  var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0,objectWithoutPropertiesLoose/* default */.A)(_ref, ["innerRef", "navigate", "onClick"]);
  var target = rest.target;
  var props = (0,esm_extends/* default */.A)({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }
      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      (!target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event)) {
        event.preventDefault();
        navigate();
      }
    }
  });
  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }
  return /* @__PURE__ */ index_js_eager_.createElement("a", props);
});
if (false) // removed by dead control flow
{}
var Link = forwardRef(function(_ref2, forwardedRef) {
  var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0,objectWithoutPropertiesLoose/* default */.A)(_ref2, ["component", "replace", "to", "innerRef"]);
  return /* @__PURE__ */ index_js_eager_.createElement(context.Consumer, null, function(context) {
    !context ?  false ? 0 : (0,tiny_invariant/* default */.A)(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";
    var props = (0,esm_extends/* default */.A)({}, rest, {
      href,
      navigate: function navigate() {
        var location2 = resolveToLocation(to, context.location);
        var isDuplicateNavigation = (0,esm_history/* createPath */.AO)(context.location) === (0,esm_history/* createPath */.AO)(normalizeToLocation(location2));
        var method = replace || isDuplicateNavigation ? history.replace : history.push;
        method(location2);
      }
    });
    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }
    return /* @__PURE__ */ index_js_eager_.createElement(component, props);
  });
});
if (false) // removed by dead control flow
{ var refType, toType; }
var forwardRefShim$1 = function forwardRefShim3(C) {
  return C;
};
var forwardRef$1 = index_js_eager_.forwardRef;
if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}
function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }
  return classnames.filter(function(i) {
    return i;
  }).join(" ");
}
var NavLink = forwardRef$1(function(_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0,objectWithoutPropertiesLoose/* default */.A)(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "sensitive", "strict", "style", "to", "innerRef"]);
  return /* @__PURE__ */ index_js_eager_.createElement(context.Consumer, null, function(context) {
    !context ?  false ? 0 : (0,tiny_invariant/* default */.A)(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname;
    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? matchPath(currentLocation.pathname, {
      path: escapedPath,
      exact,
      sensitive,
      strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
    var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
    if (isActive) {
      className = joinClassnames(className, activeClassName);
      style = (0,esm_extends/* default */.A)({}, style, activeStyle);
    }
    var props = (0,esm_extends/* default */.A)({
      "aria-current": isActive && ariaCurrent || null,
      className,
      style,
      to: toLocation
    }, rest);
    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }
    return /* @__PURE__ */ index_js_eager_.createElement(Link, props);
  });
});
if (false) // removed by dead control flow
{ var ariaCurrentType; }



/***/ }),

/***/ 89966:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = "function" === typeof Symbol && Symbol.for, c = b ? /* @__PURE__ */ Symbol.for("react.element") : 60103, d = b ? /* @__PURE__ */ Symbol.for("react.portal") : 60106, e = b ? /* @__PURE__ */ Symbol.for("react.fragment") : 60107, f = b ? /* @__PURE__ */ Symbol.for("react.strict_mode") : 60108, g = b ? /* @__PURE__ */ Symbol.for("react.profiler") : 60114, h = b ? /* @__PURE__ */ Symbol.for("react.provider") : 60109, k = b ? /* @__PURE__ */ Symbol.for("react.context") : 60110, l = b ? /* @__PURE__ */ Symbol.for("react.async_mode") : 60111, m = b ? /* @__PURE__ */ Symbol.for("react.concurrent_mode") : 60111, n = b ? /* @__PURE__ */ Symbol.for("react.forward_ref") : 60112, p = b ? /* @__PURE__ */ Symbol.for("react.suspense") : 60113, q = b ? /* @__PURE__ */ Symbol.for("react.suspense_list") : 60120, r = b ? /* @__PURE__ */ Symbol.for("react.memo") : 60115, t = b ? /* @__PURE__ */ Symbol.for("react.lazy") : 60116, v = b ? /* @__PURE__ */ Symbol.for("react.block") : 60121, w = b ? /* @__PURE__ */ Symbol.for("react.fundamental") : 60117, x = b ? /* @__PURE__ */ Symbol.for("react.responder") : 60118, y = b ? /* @__PURE__ */ Symbol.for("react.scope") : 60119;
function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;
    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;
              default:
                return u;
            }
        }
      case d:
        return u;
    }
  }
}
function A(a) {
  return z(a) === m;
}
__webpack_unused_export__ = l;
__webpack_unused_export__ = m;
__webpack_unused_export__ = k;
__webpack_unused_export__ = h;
__webpack_unused_export__ = c;
__webpack_unused_export__ = n;
__webpack_unused_export__ = e;
__webpack_unused_export__ = t;
__webpack_unused_export__ = r;
__webpack_unused_export__ = d;
__webpack_unused_export__ = g;
__webpack_unused_export__ = f;
__webpack_unused_export__ = p;
__webpack_unused_export__ = function(a) {
  return A(a) || z(a) === l;
};
__webpack_unused_export__ = A;
__webpack_unused_export__ = function(a) {
  return z(a) === k;
};
__webpack_unused_export__ = function(a) {
  return z(a) === h;
};
__webpack_unused_export__ = function(a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};
__webpack_unused_export__ = function(a) {
  return z(a) === n;
};
__webpack_unused_export__ = function(a) {
  return z(a) === e;
};
__webpack_unused_export__ = function(a) {
  return z(a) === t;
};
__webpack_unused_export__ = function(a) {
  return z(a) === r;
};
__webpack_unused_export__ = function(a) {
  return z(a) === d;
};
__webpack_unused_export__ = function(a) {
  return z(a) === g;
};
__webpack_unused_export__ = function(a) {
  return z(a) === f;
};
__webpack_unused_export__ = function(a) {
  return z(a) === p;
};
__webpack_unused_export__ = function(a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};
__webpack_unused_export__ = z;


/***/ }),

/***/ 24050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

if (true) {
  /* unused reexport */ __webpack_require__(89966);
} else // removed by dead control flow
{}


/***/ }),

/***/ 51052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Ay: function() { return /* binding */ esm_Transition; }
});

// UNUSED EXPORTS: ENTERED, ENTERING, EXITED, EXITING, UNMOUNTED

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(90018);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(34280);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: consume shared module (default) react-dom@=17.0.2 (singleton) (fallback: ./node_modules/react-dom/index.js) (eager)
var react_dom_index_js_eager_ = __webpack_require__(51971);
;// ./node_modules/react-transition-group/esm/config.js
/* harmony default export */ var config = ({
  disabled: false
});

// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(7311);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/utils/reflow.js
var reflow = __webpack_require__(17733);
;// ./node_modules/react-transition-group/esm/Transition.js









var UNMOUNTED = "unmounted";
var EXITED = "exited";
var ENTERING = "entering";
var ENTERED = "entered";
var EXITING = "exiting";
var Transition = /* @__PURE__ */ (function(_React$Component) {
  (0,inheritsLoose/* default */.A)(Transition2, _React$Component);
  function Transition2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;
    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }
    return null;
  };
  var _proto = Transition2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;
      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  _proto.getTimeouts = function getTimeouts() {
    var timeout2 = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout2;
    if (timeout2 != null && typeof timeout2 !== "number") {
      exit = timeout2.exit;
      enter = timeout2.enter;
      appear = timeout2.appear !== void 0 ? timeout2.appear : enter;
    }
    return {
      exit,
      enter,
      appear
    };
  };
  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }
    if (nextStatus !== null) {
      this.cancelNextCallback();
      if (nextStatus === ENTERING) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom_index_js_eager_.findDOMNode(this);
          if (node) (0,reflow/* forceReflow */.F)(node);
        }
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };
  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var _ref2 = this.props.nodeRef ? [appearing] : [react_dom_index_js_eager_.findDOMNode(this), appearing], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter;
    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function() {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }
    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function() {
      _this2.props.onEntering(maybeNode, maybeAppearing);
      _this2.onTransitionEnd(enterTimeout, function() {
        _this2.safeSetState({
          status: ENTERED
        }, function() {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };
  _proto.performExit = function performExit() {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? void 0 : react_dom_index_js_eager_.findDOMNode(this);
    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function() {
        _this3.props.onExited(maybeNode);
      });
      return;
    }
    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function() {
      _this3.props.onExiting(maybeNode);
      _this3.onTransitionEnd(timeouts.exit, function() {
        _this3.safeSetState({
          status: EXITED
        }, function() {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };
  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  _proto.safeSetState = function safeSetState(nextState, callback) {
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };
  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;
    var active = true;
    this.nextCallback = function(event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function() {
      active = false;
    };
    return this.nextCallback;
  };
  _proto.onTransitionEnd = function onTransitionEnd(timeout2, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : react_dom_index_js_eager_.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout2 == null && !this.props.addEndListener;
    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
      this.props.addEndListener(maybeNode, maybeNextCallback);
    }
    if (timeout2 != null) {
      setTimeout(this.nextCallback, timeout2);
    }
  };
  _proto.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0,objectWithoutPropertiesLoose/* default */.A)(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ index_js_eager_.createElement(TransitionGroupContext/* default */.A.Provider, {
        value: null
      }, typeof children === "function" ? children(status, childProps) : index_js_eager_.cloneElement(index_js_eager_.Children.only(children), childProps))
    );
  };
  return Transition2;
})(index_js_eager_.Component);
Transition.contextType = TransitionGroupContext/* default */.A;
Transition.propTypes =  false ? 0 : {};
function noop() {
}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
/* harmony default export */ var esm_Transition = (Transition);


/***/ }),

/***/ 23180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ esm_TransitionGroup; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(90018);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(89435);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(60326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js
var inheritsLoose = __webpack_require__(34280);
// EXTERNAL MODULE: consume shared module (default) react@=17.0.2 (singleton) (fallback: ./node_modules/react/index.js) (eager)
var index_js_eager_ = __webpack_require__(12549);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroupContext.js
var TransitionGroupContext = __webpack_require__(7311);
;// ./node_modules/react-transition-group/esm/utils/ChildMapping.js

function getChildMapping(children, mapFn) {
  var mapper = function mapper2(child) {
    return mapFn && (0,index_js_eager_.isValidElement)(child) ? mapFn(child) : child;
  };
  var result = /* @__PURE__ */ Object.create(null);
  if (children) index_js_eager_.Children.map(children, function(c) {
    return c;
  }).forEach(function(child) {
    result[child.key] = mapper(child);
  });
  return result;
}
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }
  var nextKeysPending = /* @__PURE__ */ Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}
function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function(child) {
    return (0,index_js_eager_.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, "appear", props),
      enter: getProp(child, "enter", props),
      exit: getProp(child, "exit", props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function(key) {
    var child = children[key];
    if (!(0,index_js_eager_.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0,index_js_eager_.isValidElement)(prevChild) && !prevChild.props.in;
    if (hasNext && (!hasPrev || isLeaving)) {
      children[key] = (0,index_js_eager_.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      children[key] = (0,index_js_eager_.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0,index_js_eager_.isValidElement)(prevChild)) {
      children[key] = (0,index_js_eager_.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, "exit", nextProps),
        enter: getProp(child, "enter", nextProps)
      });
    }
  });
  return children;
}

;// ./node_modules/react-transition-group/esm/TransitionGroup.js








var values = Object.values || function(obj) {
  return Object.keys(obj).map(function(k) {
    return obj[k];
  });
};
var defaultProps = {
  component: "div",
  childFactory: function childFactory(child) {
    return child;
  }
};
var TransitionGroup = /* @__PURE__ */ (function(_React$Component) {
  (0,inheritsLoose/* default */.A)(TransitionGroup2, _React$Component);
  function TransitionGroup2(props, context) {
    var _this;
    _this = _React$Component.call(this, props, context) || this;
    var handleExited = _this.handleExited.bind((0,assertThisInitialized/* default */.A)(_this));
    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited,
      firstRender: true
    };
    return _this;
  }
  var _proto = TransitionGroup2.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };
  TransitionGroup2.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };
  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;
    if (child.props.onExited) {
      child.props.onExited(node);
    }
    if (this.mounted) {
      this.setState(function(state) {
        var children = (0,esm_extends/* default */.A)({}, state.children);
        delete children[child.key];
        return {
          children
        };
      });
    }
  };
  _proto.render = function render() {
    var _this$props = this.props, Component = _this$props.component, childFactory2 = _this$props.childFactory, props = (0,objectWithoutPropertiesLoose/* default */.A)(_this$props, ["component", "childFactory"]);
    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory2);
    delete props.appear;
    delete props.enter;
    delete props.exit;
    if (Component === null) {
      return /* @__PURE__ */ index_js_eager_.createElement(TransitionGroupContext/* default */.A.Provider, {
        value: contextValue
      }, children);
    }
    return /* @__PURE__ */ index_js_eager_.createElement(TransitionGroupContext/* default */.A.Provider, {
      value: contextValue
    }, /* @__PURE__ */ index_js_eager_.createElement(Component, props, children));
  };
  return TransitionGroup2;
})(index_js_eager_.Component);
TransitionGroup.propTypes =  false ? 0 : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ var esm_TransitionGroup = (TransitionGroup);


/***/ }),

/***/ 7311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12549);

/* harmony default export */ __webpack_exports__.A = (react__WEBPACK_IMPORTED_MODULE_0__.createContext(null));


/***/ }),

/***/ 17733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   F: function() { return /* binding */ forceReflow; }
/* harmony export */ });
var forceReflow = function forceReflow2(node) {
  return node.scrollTop;
};


/***/ }),

/***/ 77354:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(30738);
var f = __webpack_require__(12549), g = 60103;
exports.Fragment = 60107;
if ("function" === typeof Symbol && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  exports.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, k) {
  var b, d = {}, e = null, l = null;
  void 0 !== k && (e = "" + k);
  void 0 !== a.key && (e = "" + a.key);
  void 0 !== a.ref && (l = a.ref);
  for (b in a) n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps) for (b in a = c.defaultProps, a) void 0 === d[b] && (d[b] = a[b]);
  return { $$typeof: g, type: c, key: e, ref: l, props: d, _owner: m.current };
}
exports.jsx = q;
exports.jsxs = q;


/***/ }),

/***/ 21573:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l = __webpack_require__(30738), n = 60103, p = 60106;
exports.Fragment = 60107;
exports.StrictMode = 60108;
exports.Profiler = 60114;
var q = 60109, r = 60110, t = 60112;
exports.Suspense = 60113;
var u = 60115, v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
  var w = Symbol.for;
  n = w("react.element");
  p = w("react.portal");
  exports.Fragment = w("react.fragment");
  exports.StrictMode = w("react.strict_mode");
  exports.Profiler = w("react.profiler");
  q = w("react.provider");
  r = w("react.context");
  t = w("react.forward_ref");
  exports.Suspense = w("react.suspense");
  u = w("react.memo");
  v = w("react.lazy");
}
var x = "function" === typeof Symbol && Symbol.iterator;
function y(a) {
  if (null === a || "object" !== typeof a) return null;
  a = x && a[x] || a["@@iterator"];
  return "function" === typeof a ? a : null;
}
function z(a) {
  for (var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++) b += "&args[]=" + encodeURIComponent(arguments[c]);
  return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var A = { isMounted: function() {
  return false;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, B = {};
function C(a, b, c) {
  this.props = a;
  this.context = b;
  this.refs = B;
  this.updater = c || A;
}
C.prototype.isReactComponent = {};
C.prototype.setState = function(a, b) {
  if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error(z(85));
  this.updater.enqueueSetState(this, a, b, "setState");
};
C.prototype.forceUpdate = function(a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function D() {
}
D.prototype = C.prototype;
function E(a, b, c) {
  this.props = a;
  this.context = b;
  this.refs = B;
  this.updater = c || A;
}
var F = E.prototype = new D();
F.constructor = E;
l(F, C.prototype);
F.isPureReactComponent = true;
var G = { current: null }, H = Object.prototype.hasOwnProperty, I = { key: true, ref: true, __self: true, __source: true };
function J(a, b, c) {
  var e, d = {}, k = null, h = null;
  if (null != b) for (e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b) H.call(b, e) && !I.hasOwnProperty(e) && (d[e] = b[e]);
  var g = arguments.length - 2;
  if (1 === g) d.children = c;
  else if (1 < g) {
    for (var f = Array(g), m = 0; m < g; m++) f[m] = arguments[m + 2];
    d.children = f;
  }
  if (a && a.defaultProps) for (e in g = a.defaultProps, g) void 0 === d[e] && (d[e] = g[e]);
  return { $$typeof: n, type: a, key: k, ref: h, props: d, _owner: G.current };
}
function K(a, b) {
  return { $$typeof: n, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner };
}
function L(a) {
  return "object" === typeof a && null !== a && a.$$typeof === n;
}
function escape(a) {
  var b = { "=": "=0", ":": "=2" };
  return "$" + a.replace(/[=:]/g, function(a2) {
    return b[a2];
  });
}
var M = /\/+/g;
function N(a, b) {
  return "object" === typeof a && null !== a && null != a.key ? escape("" + a.key) : b.toString(36);
}
function O(a, b, c, e, d) {
  var k = typeof a;
  if ("undefined" === k || "boolean" === k) a = null;
  var h = false;
  if (null === a) h = true;
  else switch (k) {
    case "string":
    case "number":
      h = true;
      break;
    case "object":
      switch (a.$$typeof) {
        case n:
        case p:
          h = true;
      }
  }
  if (h) return h = a, d = d(h), a = "" === e ? "." + N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace(M, "$&/") + "/"), O(d, b, c, "", function(a2) {
    return a2;
  })) : null != d && (L(d) && (d = K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace(M, "$&/") + "/") + a)), b.push(d)), 1;
  h = 0;
  e = "" === e ? "." : e + ":";
  if (Array.isArray(a)) for (var g = 0; g < a.length; g++) {
    k = a[g];
    var f = e + N(k, g);
    h += O(k, b, c, f, d);
  }
  else if (f = y(a), "function" === typeof f) for (a = f.call(a), g = 0; !(k = a.next()).done; ) k = k.value, f = e + N(k, g++), h += O(k, b, c, f, d);
  else if ("object" === k) throw b = "" + a, Error(z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
  return h;
}
function P(a, b, c) {
  if (null == a) return a;
  var e = [], d = 0;
  O(a, e, "", "", function(a2) {
    return b.call(c, a2, d++);
  });
  return e;
}
function Q(a) {
  if (-1 === a._status) {
    var b = a._result;
    b = b();
    a._status = 0;
    a._result = b;
    b.then(function(b2) {
      0 === a._status && (b2 = b2.default, a._status = 1, a._result = b2);
    }, function(b2) {
      0 === a._status && (a._status = 2, a._result = b2);
    });
  }
  if (1 === a._status) return a._result;
  throw a._result;
}
var R = { current: null };
function S() {
  var a = R.current;
  if (null === a) throw Error(z(321));
  return a;
}
var T = { ReactCurrentDispatcher: R, ReactCurrentBatchConfig: { transition: 0 }, ReactCurrentOwner: G, IsSomeRendererActing: { current: false }, assign: l };
exports.Children = { map: P, forEach: function(a, b, c) {
  P(a, function() {
    b.apply(this, arguments);
  }, c);
}, count: function(a) {
  var b = 0;
  P(a, function() {
    b++;
  });
  return b;
}, toArray: function(a) {
  return P(a, function(a2) {
    return a2;
  }) || [];
}, only: function(a) {
  if (!L(a)) throw Error(z(143));
  return a;
} };
exports.Component = C;
exports.PureComponent = E;
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = T;
exports.cloneElement = function(a, b, c) {
  if (null === a || void 0 === a) throw Error(z(267, a));
  var e = l({}, a.props), d = a.key, k = a.ref, h = a._owner;
  if (null != b) {
    void 0 !== b.ref && (k = b.ref, h = G.current);
    void 0 !== b.key && (d = "" + b.key);
    if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
    for (f in b) H.call(b, f) && !I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
  }
  var f = arguments.length - 2;
  if (1 === f) e.children = c;
  else if (1 < f) {
    g = Array(f);
    for (var m = 0; m < f; m++) g[m] = arguments[m + 2];
    e.children = g;
  }
  return {
    $$typeof: n,
    type: a.type,
    key: d,
    ref: k,
    props: e,
    _owner: h
  };
};
exports.createContext = function(a, b) {
  void 0 === b && (b = null);
  a = { $$typeof: r, _calculateChangedBits: b, _currentValue: a, _currentValue2: a, _threadCount: 0, Provider: null, Consumer: null };
  a.Provider = { $$typeof: q, _context: a };
  return a.Consumer = a;
};
exports.createElement = J;
exports.createFactory = function(a) {
  var b = J.bind(null, a);
  b.type = a;
  return b;
};
exports.createRef = function() {
  return { current: null };
};
exports.forwardRef = function(a) {
  return { $$typeof: t, render: a };
};
exports.isValidElement = L;
exports.lazy = function(a) {
  return { $$typeof: v, _payload: { _status: -1, _result: a }, _init: Q };
};
exports.memo = function(a, b) {
  return { $$typeof: u, type: a, compare: void 0 === b ? null : b };
};
exports.useCallback = function(a, b) {
  return S().useCallback(a, b);
};
exports.useContext = function(a, b) {
  return S().useContext(a, b);
};
exports.useDebugValue = function() {
};
exports.useEffect = function(a, b) {
  return S().useEffect(a, b);
};
exports.useImperativeHandle = function(a, b, c) {
  return S().useImperativeHandle(a, b, c);
};
exports.useLayoutEffect = function(a, b) {
  return S().useLayoutEffect(a, b);
};
exports.useMemo = function(a, b) {
  return S().useMemo(a, b);
};
exports.useReducer = function(a, b, c) {
  return S().useReducer(a, b, c);
};
exports.useRef = function(a) {
  return S().useRef(a);
};
exports.useState = function(a) {
  return S().useState(a);
};
exports.version = "17.0.2";


/***/ }),

/***/ 17866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

if (true) {
  module.exports = __webpack_require__(21573);
} else // removed by dead control flow
{}


/***/ }),

/***/ 54914:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

if (true) {
  module.exports = __webpack_require__(77354);
} else // removed by dead control flow
{}


/***/ }),

/***/ 92085:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f, g, h, k;
if ("object" === typeof performance && "function" === typeof performance.now) {
  var l = performance;
  exports.unstable_now = function() {
    return l.now();
  };
} else {
  var p = Date, q = p.now();
  exports.unstable_now = function() {
    return p.now() - q;
  };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
  var t = null, u = null, w = function() {
    if (null !== t) try {
      var a = exports.unstable_now();
      t(true, a);
      t = null;
    } catch (b) {
      throw setTimeout(w, 0), b;
    }
  };
  f = function(a) {
    null !== t ? setTimeout(f, 0, a) : (t = a, setTimeout(w, 0));
  };
  g = function(a, b) {
    u = setTimeout(a, b);
  };
  h = function() {
    clearTimeout(u);
  };
  exports.unstable_shouldYield = function() {
    return false;
  };
  k = exports.unstable_forceFrameRate = function() {
  };
} else {
  var x = window.setTimeout, y = window.clearTimeout;
  if ("undefined" !== typeof console) {
    var z = window.cancelAnimationFrame;
    "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    "function" !== typeof z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
  }
  var A = false, B = null, C = -1, D = 5, E = 0;
  exports.unstable_shouldYield = function() {
    return exports.unstable_now() >= E;
  };
  k = function() {
  };
  exports.unstable_forceFrameRate = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : D = 0 < a ? Math.floor(1e3 / a) : 5;
  };
  var F = new MessageChannel(), G = F.port2;
  F.port1.onmessage = function() {
    if (null !== B) {
      var a = exports.unstable_now();
      E = a + D;
      try {
        B(true, a) ? G.postMessage(null) : (A = false, B = null);
      } catch (b) {
        throw G.postMessage(null), b;
      }
    } else A = false;
  };
  f = function(a) {
    B = a;
    A || (A = true, G.postMessage(null));
  };
  g = function(a, b) {
    C = x(function() {
      a(exports.unstable_now());
    }, b);
  };
  h = function() {
    y(C);
    C = -1;
  };
}
function H(a, b) {
  var c = a.length;
  a.push(b);
  a: for (; ; ) {
    var d = c - 1 >>> 1, e = a[d];
    if (void 0 !== e && 0 < I(e, b)) a[d] = b, a[c] = e, c = d;
    else break a;
  }
}
function J(a) {
  a = a[0];
  return void 0 === a ? null : a;
}
function K(a) {
  var b = a[0];
  if (void 0 !== b) {
    var c = a.pop();
    if (c !== b) {
      a[0] = c;
      a: for (var d = 0, e = a.length; d < e; ) {
        var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
        if (void 0 !== n && 0 > I(n, c)) void 0 !== r && 0 > I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
        else if (void 0 !== r && 0 > I(r, c)) a[d] = r, a[v] = c, d = v;
        else break a;
      }
    }
    return b;
  }
  return null;
}
function I(a, b) {
  var c = a.sortIndex - b.sortIndex;
  return 0 !== c ? c : a.id - b.id;
}
var L = [], M = [], N = 1, O = null, P = 3, Q = false, R = false, S = false;
function T(a) {
  for (var b = J(M); null !== b; ) {
    if (null === b.callback) K(M);
    else if (b.startTime <= a) K(M), b.sortIndex = b.expirationTime, H(L, b);
    else break;
    b = J(M);
  }
}
function U(a) {
  S = false;
  T(a);
  if (!R) if (null !== J(L)) R = true, f(V);
  else {
    var b = J(M);
    null !== b && g(U, b.startTime - a);
  }
}
function V(a, b) {
  R = false;
  S && (S = false, h());
  Q = true;
  var c = P;
  try {
    T(b);
    for (O = J(L); null !== O && (!(O.expirationTime > b) || a && !exports.unstable_shouldYield()); ) {
      var d = O.callback;
      if ("function" === typeof d) {
        O.callback = null;
        P = O.priorityLevel;
        var e = d(O.expirationTime <= b);
        b = exports.unstable_now();
        "function" === typeof e ? O.callback = e : O === J(L) && K(L);
        T(b);
      } else K(L);
      O = J(L);
    }
    if (null !== O) var m = true;
    else {
      var n = J(M);
      null !== n && g(U, n.startTime - b);
      m = false;
    }
    return m;
  } finally {
    O = null, P = c, Q = false;
  }
}
var W = k;
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(a) {
  a.callback = null;
};
exports.unstable_continueExecution = function() {
  R || Q || (R = true, f(V));
};
exports.unstable_getCurrentPriorityLevel = function() {
  return P;
};
exports.unstable_getFirstCallbackNode = function() {
  return J(L);
};
exports.unstable_next = function(a) {
  switch (P) {
    case 1:
    case 2:
    case 3:
      var b = 3;
      break;
    default:
      b = P;
  }
  var c = P;
  P = b;
  try {
    return a();
  } finally {
    P = c;
  }
};
exports.unstable_pauseExecution = function() {
};
exports.unstable_requestPaint = W;
exports.unstable_runWithPriority = function(a, b) {
  switch (a) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 5:
      break;
    default:
      a = 3;
  }
  var c = P;
  P = a;
  try {
    return b();
  } finally {
    P = c;
  }
};
exports.unstable_scheduleCallback = function(a, b, c) {
  var d = exports.unstable_now();
  "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
  switch (a) {
    case 1:
      var e = -1;
      break;
    case 2:
      e = 250;
      break;
    case 5:
      e = 1073741823;
      break;
    case 4:
      e = 1e4;
      break;
    default:
      e = 5e3;
  }
  e = c + e;
  a = { id: N++, callback: b, priorityLevel: a, startTime: c, expirationTime: e, sortIndex: -1 };
  c > d ? (a.sortIndex = c, H(M, a), null === J(L) && a === J(M) && (S ? h() : S = true, g(U, c - d))) : (a.sortIndex = e, H(L, a), R || Q || (R = true, f(V)));
  return a;
};
exports.unstable_wrapCallback = function(a) {
  var b = P;
  return function() {
    var c = P;
    P = b;
    try {
      return a.apply(this, arguments);
    } finally {
      P = c;
    }
  };
};


/***/ }),

/***/ 21968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

if (true) {
  module.exports = __webpack_require__(92085);
} else // removed by dead control flow
{}


/***/ }),

/***/ 51910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ invariant; }
/* harmony export */ });
var isProduction = "production" === "production";
var prefix = "Invariant failed";
function invariant(condition, message) {
  if (condition) {
    return;
  }
  if (isProduction) {
    throw new Error(prefix);
  }
  var provided = typeof message === "function" ? message() : message;
  var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
  throw new Error(value);
}



/***/ }),

/***/ 85072:
/***/ (function(module) {

"use strict";


var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ 77659:
/***/ (function(module) {

"use strict";


var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ 10540:
/***/ (function(module) {

"use strict";


/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ 55056:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ 97825:
/***/ (function(module) {

"use strict";


/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ 41113:
/***/ (function(module) {

"use strict";


/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ })

}]);